import { n as __esmMin, o as __toCommonJS, r as __export, s as __toESM, t as __commonJSMin } from "./rolldown-runtime-Bg48TavK.es.js";
import { $ as splitProjectedTrackedChangeId, $a as extractTableInfo, $c as storyLocatorToKey, $i as bodySectPrShouldEmbed, $n as resolveTextTarget, $o as Selection, $r as buildDocumentFontOptions, $s as resolveColumnMode, $t as hasOddEvenHeadersFooters, A as buildTarget, Aa as hasPart, Ac as TrackDeleteMarkName, Ai as translator, An as readSectPrMargins, Ao as DecorationSet, Ar as resolveCommentIdFromAttrs, As as formatPageNumber, At as applyTrackedMutationMeta, B as updateSdtPrSubElementAttr, Ba as undoDepth, Bi as processContent, Bn as writeSectPrPageMargins, Bo as findParentNodeClosestToPos, Br as formatFootnoteCardinal, Bs as namedStoryLocator, Bt as resolveEffectiveRef, C as buildMutationFailure, Ca as getRevision, Cc as OOXML_PCT_DIVISOR, Cn as clearSectPrHeaderFooterRef, Co as tableEditing, Cr as mapBlockNodeType, Cs as isKnownTableStyleId, Ct as normalizeVariant, D as assertNotSdtLocked, Da as PlanError, Dc as calculateTabWidth, Dn as ensureSectPrElement, Do as keydownHandler, Ds as buildPageRefAnchorMap, Dt as rejectTrackedMode, E as assertNotContentLocked, Ea as trackRevisions, Ec as getTableVisualDirection, En as createSectPrElement, Eo as toggleHeaderCell, Er as toBlockAddress, Es as engines_exports, Et as ensureTrackedCapability, F as applyAttrsUpdate, Fa as closeHistory, Fc as generateRandomSigned32BitIntStrId, Fi as sequenceFieldAttrsFromParsed, Fn as writeSectPrColumns, Fo as getSchemaTypeNameByName, Fr as findInlineByAnchor, Fs as getSdtContainerMetadata, Ft as resolveRIdFromRelsData, G as isSdtNode, Ga as getActiveFormatting, Gi as createDocFromHTML, Gn as addDiagnostic, Go as getSchemaTypeByName, Gr as FlowBlockCache, Gs as getColumnAtX, Gt as registerStaticInvalidationHandlers, H as SDT_BLOCK_NAME, Ha as isInTable, Hc as derivePropertyStateFromDirect, Hn as writeSectPrPageSetup, Ho as getMarkType, Hr as resolveParagraphHeadingLevel, Hs as resolveAnchoredGraphicY, Ht as setLinkedToPreviousMutation, I as findSdtPrChild, Ia as history, Ic as createDocumentApi, Ii as helpers_exports, In as writeSectPrDirection, Io as isMarkActive, Ir as findInlineByType, Is as hasExplicitSdtContainerKey, It as SOURCE_HEADER_FOOTER_LOCAL, J as getTrackedChangeMarkAlias, Ja as getMarksFromSelection, Jc as OPERATION_IDS, Ji as htmlHandler, Jn as insertParagraphAtEnd, Jo as AllSelection, Jr as createStoryEditor, Js as getColumnWidth, Jt as getProtectionStorage, K as resolveSdtByTarget, Ka as findMark, Kc as PROPERTY_REGISTRY, Ki as InputRule, Kn as dedupeDiagnostics, Ko as createDocument, Kr as SequenceFieldEvaluator, Ks as getColumnGeometry, Kt as applyEffectiveEditability, L as removeSdtPrChild, La as redo, Lc as DEFAULT_PROTECTION_STATE, Li as getViewModeSelectionWithoutStructuredContent, Ln as writeSectPrHeaderFooterMargins, Lo as getMarkRange, Lr as isInlineQueryType, Lt as ensureHeaderFooterDescriptor, M as readChoiceListData, Ma as yCursorPluginKey, Mc as TrackInsertMarkName, Mi as isSeqInstruction, Mn as readSectPrTitlePage, Mo as __endComposition, Ms as formatSectionPageNumberText, Mt as registerExistingHeaderFooterDescriptors, N as resolveBinding, Na as ySyncPluginKey, Nc as TrackedFormatMarkNames, Ni as normalizeSeqIdentifier, Nn as setSectPrHeaderFooterRef, No as isActive, Nr as toNonEmptyString, Ns as getSdtContainerKey, Nt as resolveHeaderFooterRId, O as buildContentControlInfoFromAttrs, Oa as planError, Oc as computeTabStops$1, Oi as translator$2, On as getSectPrHeaderFooterRef, Oo as keymap, Os as formatChapterPageNumberText, Ot as requireEditorCommand, P as resolveControlType, Pa as yUndoPluginKey, Pc as generateDocxRandomId, Pi as parseSeqInstruction, Pn as writeSectPrBreakType, Po as isNodeActive, Pr as buildInlineIndex, Ps as getSdtContainerKeyForBlock, Q as resolveTrackedChangeType, Qa as calculateInlineRunPropertiesPlugin, Qc as isStoryLocator, Qi as SUPERDOC_MEDIA_MIME, Qn as resolveInlineInsertPosition, Qo as PluginKey, Qr as parseStoryKey, Qs as resolveColumnLayout, Qt as ensureSettingsRoot, R as replaceSdtPrSubElements, Ra as redoDepth, Rn as writeSectPrLineNumbering, Ro as isTextSelection, Rr as CommentMarkName, Rs as LAYOUT_BOUNDARY_SCHEMA, Rt as isHeaderFooterPartId, S as applyPagination, Sa as checkRevision, Sc as effectiveTableCellSpacing, Sl as getExtensionConfigField, Sn as sectionsListAdapter$1, So as splitCell, Sr as isTextBlockCandidate, Ss as TABLE_FALLBACK_CELL_PADDING, St as ensureExplicitHeaderFooterSlot, T as assertControlType, Ta as initRevision, Tc as getParagraphInlineDirection, Ti as getListRendering, Tn as cloneXmlElement, To as toggleHeader, Tr as resolveBlockNodeId, Ts as EMPTY_SDT_PLACEHOLDER_TEXT, Tt as sectionMutationBySectPr, U as SDT_INLINE_NAME, Ua as posToDOMRect, Uc as CAPABILITY_REASON_CODES, Ui as markdownToPmFragment, Un as writeSectPrTitlePage, Uo as getNodeType, Ur as twipsToPixels$1, Us as cloneColumnLayout, Ut as createHeaderFooterPart, V as upsertSdtPrChild, Va as CommandService, Vi as createDocFromMarkdown, Vn as writeSectPrPageNumbering, Vo as defaultBlockAt$1, Vr as getPageNumberFieldFormat, Vs as resolveAnchoredGraphicX, Vt as setHeaderFooterRefMutation, W as findAllSdtNodes, Wa as findChildren, Wc as PUBLIC_MUTATION_STEP_OP_IDS, Wi as readImageDimensionsFromDataUri, Wn as writeSectPrVerticalAlign, Wo as cleanSchemaItem, Wr as toCssFontFamily, Ws as columnRenderLayoutsEqual, Wt as getWordPartRelsPath, X as resolveTrackedChange, Xa as normalizeRunProperties, Xc as INLINE_PROPERTY_KEY_SET, Xi as annotateFragmentDomWithClipboardData, Xn as resolveBlockCreatePosition, Xo as NodeSelection, Xr as BODY_STORY_KEY, Xs as normalizeColumnLayout, Xt as SETTINGS_PART_PATH, Y as groupTrackedChanges, Ya as getSelectionFormattingState, Yc as INLINE_PROPERTY_BY_KEY, Yi as inputRulesPlugin, Yn as paginate, Yo as EditorState, Yr as DocumentApiAdapterError, Ys as getColumnX, Yt as isReadOnlyProtectionRuntimeEnforced, Z as resolveTrackedChangeInStory, Za as TRANSIENT_HYPERLINK_STYLE_IDS, Zc as INLINE_PROPERTY_REGISTRY, Zi as mergeSerializedClipboardMetadataIntoDomContainer, Zn as resolveDefaultInsertTarget, Zo as Plugin, Zr as buildStoryKey, Zs as resolveColumnCount, Zt as clearDocumentProtectionEnforcement, _ as getContiguousSequence, _a as findOrCreateRelationship, _c as normalizeZIndex, _i as translateStyleDefinitions, _l as Fragment$1, _n as readTargetSectPr, _o as goToNextCell, _r as findBlockById, _s as encodeCSSFromRPr, _t as footnotesPartDescriptor, a as resolveMainBodyEditor, aa as ListHelpers, ac as sliceRunsForLine, ai as DEFAULT_FONT_LOAD_TIMEOUT_MS, al as SNIPPET_CONTEXT_CHARS, an as readEndnotePosition, ao as resolveHypotheticalParagraphProperties, as as ReplaceStep, at as findMarkPosition, b as resolveBlock, ba as mutatePart, bc as resolveEffectiveHeaderFooterRef, bi as isDecimalWordId, bl as minMax, bn as resolveSectionProjections, bo as selectedRect, bs as resolveRunProperties, bt as removeNoteElement, c as listListItems, ca as rebuildRawNumberingFromTranslated, cc as resolveBaseFontSizeForVerticalText, ci as buildFontReport, cn as readFootnoteNumberStart, co as addColumnAfter, cs as canSplit, ct as resolveStoryRuntime, d as evaluateCanContinuePrevious, da as removeLvlOverride, dc as SPACE_CHARS, di as getFontConfigVersion, dl as DELETABLE_BLOCK_NODE_TYPES, dn as readSettingsRoot, do as columnResizing, dr as resolveTextRangeInBlock, ds as liftTarget, dt as resolveLiveStorySessionRuntime, ea as collectReferencedImageMediaForClipboard, ec as computeFragmentPmRange$1, en as parseProtectionState, eo as clampRange, er as resolveWithinScope, es as TextSelection, et as projectInternalTrackChangeType, f as evaluateCanJoin, fa as changeListLevel, fc as adjustAvailableWidthForTextIndent, fi as DEFAULT_FONT_MEASURE_CONTEXT, fl as DocumentApiValidationError, fn as removeDefaultTableStyle, fo as deleteColumn, fr as textContentInBlock, fs as replaceStep$1, ft as initStoryRevisionStore, g as getAllListItemProjections, ga as generateOrderedListIndex, gc as getFragmentZIndex, gi as resolveEvenAndOddHeadersFromSettingsPart, gl as DOMSerializer, gn as compoundMutation, go as fixTables, gr as buildBlockIndex, gs as encodeCSSFromPPr, gt as endnotesPartDescriptor, h as getAbstractNumId, ha as docxNumberingHelpers, hc as shouldApplyJustify, hi as resolvePhysicalFamily, hl as DOMParser$1, hn as setOddEvenHeadersFooters, ho as findTable, hr as getInlineIndex, hs as decodeRPrFromMarks, ht as bootstrapNotesPart, i as resolveDocumentStatFieldValue, ia as unflattenListsInHtml, ic as isEmptySdtPlaceholderRun, il as buildResolvedHandle, in as readEndnoteNumberStart, io as getResolvedParagraphProperties, is as ReplaceAroundStep$1, it as findInlineNodes, j as readCheckboxChecked, ja as registerPartDescriptor, jc as TrackFormatMarkName, ji as parseXmlToJson, jn as readSectPrPageSetup, jo as EditorView, jr as toFiniteNumber, js as formatPageNumberFieldValue, jt as exportSubEditorToPart, k as buildContentControlInfoFromNode, ka as getPart, kc as getUnderlineCssString, ki as translator$1, kn as readSectPrHeaderFooterRefs, ko as Decoration, kr as normalizeExcerpt, ks as formatIntegerWithNumericPicture, kt as applyDirectMutationMeta, l as resolveListItem, la as numberingPartDescriptor, lc as formatInsetClipPathTransform, li as installBundledSubstitutes, ln as readFootnotePosition, lo as addColumnBefore, lr as computeTextContentLength, ls as dropPoint, lt as commitLiveStorySessionRuntimes, m as findPreviousCompatibleSequence, ma as isList, mc as getFirstLineIndentOffset, mi as resolveFontFamily, mn as setDocumentProtection, mo as deleteTable, mr as getBlockIndex, ms as isLegacySchemaDefaultBorders, mt as addNoteElement, na as getSectPrMargins, nc as expandRunsForInlineNewlines, ni as fontOfferingStack, nl as buildDiscoveryItem, nn as readEndnoteNumberFormat, no as mergeRanges$1, nr as scopeByRange, ns as Mapping, nt as getTrackChanges, o as getLiveDocumentCounts, oa as markerTextToBulletStyle, oc as SUBSCRIPT_SUPERSCRIPT_SCALE, oi as getFontRegistryFor, ol as SNIPPET_MAX_LENGTH, on as readFootnoteNumberFormat, oo as CellSelection, or as buildTextWithTabs, os as Transform, ot as getTextAdapter, p as findAdjacentSequence, pa as updateNumberingProperties, pc as calculateJustifySpacing, pi as createFontResolver, pl as DEFAULT_DOCX_DEFS, pn as setDefaultTableStyle, po as deleteRow, pr as clearIndexCache, ps as convertBordersToOoxmlFormat, pt as normalizeNotePmJson, q as buildTrackedChangeCanonicalIdMap, qa as getFormattingStateAtPos, qc as COMMAND_CATALOG, qi as handleClipboardPaste, qo as parsePageNumberFieldSwitches, qr as process$1, qs as getColumnSeparatorPositions, qt as buildAllowedIdentifierSetFromEditor, r as getWordStatistics, ra as updateSectionMargins, rc as isEmptyInlineSdtPlaceholderRun, ri as getBuiltInToolbarFontOfferings, rl as buildDiscoveryResult, rn as readEndnoteNumberRestart, ro as calculateResolvedParagraphProperties, rr as validatePaginationInput, rs as RemoveMarkStep, rt as documentHelpers_exports, s as listItemProjectionToInfo, sa as numberingInfoToOrderedStyle, sc as normalizeBaselineShift, si as buildFaceReport, sn as readFootnoteNumberRestart, so as TableMap, sr as parentAllowsNodeAt, ss as canJoin, st as getStoryRuntimeCache, t as SuperConverter, ta as embedSliceInHtml, tc as computeLinePmRange$1, ti as fontOfferingRenderStack, tn as readDefaultTableStyle, to as collectChangedRangesThroughTransactions, ts as AddMarkStep, tt as enumerateStructuralRowChanges, u as computeSequenceId, ua as syncNumberingToXmlTree, uc as parseInsetClipPathForScale, ui as bumpFontConfigVersion, ul as SELECTION_EDGE_NODE_TYPES, un as readSectionNoteConfigs, uo as cellAround$1, ur as pmPositionToTextOffset, us as joinPoint, ut as registerLiveStorySessionRuntime, v as getSequenceFromTarget, va as createRelationshipsPart, vc as getCellSpacingPx, vi as TRACKED_CHANGE_SOURCE_ID_MAP_PROPERTY, vl as Schema$1, vn as getBodySectPrFromEditor, vo as inSameTable, vr as findBlockByIdStrict, vs as encodeMarksFromRPr, vt as getNoteElements, w as buildMutationSuccess, wa as incrementRevision, wc as resolveTableWidthAttr, wi as getListOrdinalFromPath, wn as clearSectPrPageBorders, wo as tableNodeTypes, ws as resolvePreferredNewTableStyleId, wt as applySectPrToProjection$1, x as resolveBlocksInRange, xa as mutateParts, xc as selectHeaderFooterVariantForPage, xl as callOrGet, xn as sectionsGetAdapter, xo as setCellAttr, xr as getHeadingLevel$1, xs as TABLE_FALLBACK_BORDERS, xt as updateNoteElement, y as isFirstInSequence, ya as getRelationshipsRoot, yc as rescaleColumnWidths, yi as createWordIdAllocator, yl as Slice, yn as getDefaultSectionAddress, yo as mergeCells, yr as findBlockByNodeIdOnly, ys as DEFAULT_TBL_LOOK, yt as getNotesConfig, z as updateSdtPrChild, za as undo, zi as updateDOMAttributes, zn as writeSectPrPageBorders, zo as findParentNode, zr as toFlowBlocks, zs as buildLayoutSourceIdentityForFragment, zt as clearHeaderFooterRefMutation } from "./SuperConverter-BBOL1zJ-.es.js";
import { a as init_dist$2, i as global$1, n as init_dist, o as Buffer$1, r as process$1$1, s as init_dist$1, t as require_jszip_min } from "./jszip-C49i9kUs.es.js";
import { t as require_lib } from "./xml-js-CqGKpaft.es.js";
import { n as v4_default } from "./uuid-B2wVPhPi.es.js";
import { $ as resolveCreateAnchor, $t as CustomSelectionPluginKey, A as replaceStructuredWrapper, At as captureRunsInRange, B as executeCompiledPlan, Bt as findAllTocNodes, C as tocListWrapper, Ct as resolveSelectionTarget, D as disposeEphemeralWriteRuntime, Dt as isInlineQuery, E as STUB_WHERE, Et as collectUnknownNodeDiagnostics, F as resolveStoryFromRef, Ft as encodeV4Ref, G as executeSpanTextRewrite, Gt as getNormalizedImageAttrs, H as executePlan, Ht as processAndInsertImageFile, I as getInlinePropertyCapabilityIssue, It as applyTcPatch, J as executeTextInsert, Jt as generateUniqueDocPrId, K as executeStyleApply, Kt as ImagePositionPlugin, L as getTrackedInlinePropertySupportIssue, Lt as areTcConfigsEqual, M as selectionMutationWrapper, Mt as isSimpleToggleOffValue, N as writeWrapper, Nt as registerStepExecutor, O as executeDomainCommand, Ot as shouldQueryBothKinds, P as resolveStoryFromInput, Pt as decodeRef, Q as resolveBlockInsertionPos, Qt as mapDisplayAlignmentToStoredJustification, R as executeStructuralInsert, Rt as parseTcInstruction, S as tocGetWrapper, St as resolveSelectionPointPosition, T as tocUpdateWrapper, Tt as executeTextSelector, U as executeSpanStyleApply, V as executeCreateStep, Vt as parseTocInstruction, W as executeSpanTextDelete, Wt as getRotationMargins, X as runMutationsOnTransaction, Xt as isContentLockedMode, Y as executeTextRewrite, Z as myersDiff, Zt as isSdtLockedMode, _ as insertTableOfContentsAtSelection, _t as paragraphsSetShadingWrapper, a as collectTrackedChangesForContext, an as releaseSelectionHandle, at as paragraphsClearShadingWrapper, b as prepareTableOfContentsInsertion, bt as paragraphsSetTabStopWrapper, c as getChangeAuthorIdentity, ct as paragraphsClearTabStopWrapper, d as matchesSameUserRefinement, dt as paragraphsSetBorderWrapper, en as captureSelectionHandle, et as paragraphsClearAlignmentWrapper, f as shouldCollapseNoEmailInsertion, ft as paragraphsSetDirectionWrapper, g as getQuickFormatList, gt as paragraphsSetOutlineLevelWrapper, h as generateLinkedStyleString, ht as paragraphsSetKeepOptionsWrapper, i as collectTrackedChanges, in as prepareSelectionForTextInputHandoff, it as paragraphsClearIndentationWrapper, j as resolveWriteStoryRuntime, jt as deriveToggleState, k as insertStructuredWrapper, kt as sortAddressesByPosition, l as getCurrentUserIdentity, lt as paragraphsResetDirectFormattingWrapper, m as LinkedStylesPluginKey, mt as paragraphsSetIndentationWrapper, nn as createSelectionTrackingBookmark, nt as paragraphsClearBorderWrapper, o as isTrackedChangeActionAllowed, on as resolveHandleToSelection, ot as paragraphsClearSpacingWrapper, p as LinkedStyles, pn as parseSizeUnit, pt as paragraphsSetFlowOptionsWrapper, q as executeTextDelete, qt as ImageRegistrationPlugin, rn as getPreservedSelection, rt as paragraphsClearDirectionWrapper, s as classifyOwnership, sn as Extension, st as paragraphsClearStyleWrapper, t as createHeadlessToolbar, tn as createSelectionHandlePlugin, tt as paragraphsClearAllTabStopsWrapper, u as isSameUserHighConfidence, ut as paragraphsSetAlignmentWrapper, v as resolveTableOfContentsCreateLocation, vt as paragraphsSetSpacingWrapper, w as tocRemoveWrapper, wt as executeBlockSelector, x as tocConfigureWrapper, xt as compilePlan, y as createTableOfContentsWrapper, yt as paragraphsSetStyleWrapper, z as executeStructuralReplace, zt as serializeTcInstruction } from "./create-headless-toolbar-EMbyHacR.es.js";
import { G as UrlValidationConstants, K as encodeTooltip, M as ptToTwips, N as resolveOpcTargetPath, R as twipsToLines, S as inchesToPixels, T as linesToTwips, X as sanitizeHref, Y as isValidImageDataUrl, b as halfPointToPixels, g as getArrayBufferFromUrl, k as pixelsToTwips, l as convertSizeToCSS, m as eighthPointsToPixels, r as DEFAULT_XML_DECLARATION, t as COMMENT_FILE_BASENAMES, z as twipsToPixels } from "./constants-D9qj59G2.es.js";
import { t as Buffer } from "./dist-B8HfvhaK.es.js";
import { t as unified } from "./unified-Dsuw2be5.es.js";
import { t as remarkGfm } from "./remark-gfm-BhnWr3yf.es.js";
import { t as remarkStringify } from "./remark-stringify-6MMJfY0k.es.js";
import { n as syncPackageMetadata, r as ensureXmlString, t as DocxZipper_default } from "./DocxZipper-FUsfThjV.es.js";
import { t as __plugin_vue_export_helper_default } from "./_plugin-vue_export-helper-5t5P5NuM.es.js";
import { t as import_eventemitter3 } from "./eventemitter3-BnGqBE-Q.es.js";
import { a as InvalidStateError, i as FileSystemNotAvailableError, o as NoSourcePathError, r as DocumentLoadError, t as DocxEncryptionError } from "./errors-CNaD6vcg.es.js";
import { t as blank_default } from "./blank-docx-1Y-uWgjm.es.js";
import * as Y from "yjs";
import { ContentType, Item, Text as Text$1, UndoManager, XmlElement, XmlText, encodeStateAsUpdate } from "yjs";
import { Fragment, Teleport, Transition, computed, createApp, createBlock, createCommentVNode, createElementBlock, createElementVNode, createTextVNode, createVNode, defineComponent, getCurrentInstance, guardReactiveProps, h, markRaw, mergeProps, nextTick, normalizeClass, normalizeProps, normalizeStyle, onActivated, onBeforeUnmount, onDeactivated, onMounted, onUnmounted, openBlock, reactive, ref, renderList, renderSlot, resolveDynamicComponent, shallowRef, toDisplayString, unref, useAttrs, useCssVars, vModelText, vShow, watch, withCtx, withDirectives, withKeys, withModifiers } from "vue";
function isNodeType(node, name) {
	return node.type.name === name;
}
function assertNodeType(node, name) {
	if (node.type.name !== name) throw new Error(`Expected node type "${name}", got "${node.type.name}"`);
}
function isMarkType(mark, name) {
	return mark.type.name === name;
}
var Node$1 = class Node$1 {
	constructor(config) {
		this.type = "node";
		this.name = "node";
		this.config = {
			...config,
			name: config.name || this.name
		};
		this.name = this.config.name;
		this.group = this.config.group;
		if (this.config.addOptions) this.options = callOrGet(getExtensionConfigField(this, "addOptions", { name: this.name })) || {};
		else this.options = {};
		this.storage = callOrGet(getExtensionConfigField(this, "addStorage", {
			name: this.name,
			options: this.options
		})) || {};
	}
	static create(config) {
		return new Node$1(config);
	}
};
function defineNode(config) {
	return Node$1.create(config);
}
var Mark = class Mark {
	constructor(config) {
		this.type = "mark";
		this.name = "mark";
		this.config = {
			...config,
			name: config.name || this.name
		};
		this.name = this.config.name;
		this.isExternal = Boolean(this.config.isExternal);
		if (this.config.addOptions) this.options = callOrGet(getExtensionConfigField(this, "addOptions", { name: this.name })) || {};
		else this.options = {};
		this.storage = callOrGet(getExtensionConfigField(this, "addStorage", {
			name: this.name,
			options: this.options
		})) || {};
	}
	static create(config) {
		return new Mark(config);
	}
};
function defineMark(config) {
	return Mark.create(config);
}
const isMacOS = () => {
	return typeof navigator !== "undefined" ? /Mac/.test(navigator.platform) : false;
};
const isIOS = () => {
	if (typeof navigator === "undefined") return false;
	return [
		"iPad Simulator",
		"iPhone Simulator",
		"iPod Simulator",
		"iPad",
		"iPhone",
		"iPod"
	].includes(navigator.platform);
};
function deleteProps(obj, propOrProps) {
	const props = typeof propOrProps === "string" ? [propOrProps] : propOrProps;
	const removeNested = (target, pathParts, index = 0) => {
		if (!target || typeof target !== "object") return false;
		const key = pathParts[index];
		const isLast = index === pathParts.length - 1;
		if (!(key in target)) return Object.keys(target).length === 0;
		if (isLast) delete target[key];
		else if (removeNested(target[key], pathParts, index + 1)) delete target[key];
		return Object.keys(target).length === 0;
	};
	const clonedObj = JSON.parse(JSON.stringify(obj));
	props.forEach((propPath) => {
		if (!propPath.includes(".")) {
			delete clonedObj[propPath];
			return;
		}
		removeNested(clonedObj, propPath.split("."));
	});
	return Object.entries(clonedObj).reduce((acc, [key, value]) => {
		if (value == null) return acc;
		if (typeof value === "object" && Object.keys(value).length === 0) return acc;
		acc[key] = value;
		return acc;
	}, {});
}
async function ensureClipboardPermission() {
	if (typeof navigator === "undefined" || !navigator.clipboard) return false;
	if (!navigator.permissions || typeof navigator.permissions.query !== "function") return true;
	try {
		const status = await navigator.permissions.query({ name: "clipboard-read" });
		if (status.state === "granted") return true;
		if (status.state === "prompt") try {
			await navigator.clipboard.readText();
			return true;
		} catch {
			return false;
		}
		return false;
	} catch {
		return false;
	}
}
async function readClipboardRaw() {
	let html = "";
	let text = "";
	const hasPermission = await ensureClipboardPermission();
	if (!navigator.clipboard) return {
		html,
		text: text || ""
	};
	if (hasPermission && navigator.clipboard.read) try {
		const items = await navigator.clipboard.read();
		for (const item of items) {
			if (item.types.includes("text/html")) html = await (await item.getType("text/html")).text();
			if (item.types.includes("text/plain")) text = await (await item.getType("text/plain")).text();
		}
	} catch {}
	if (!text && navigator.clipboard.readText) try {
		text = await navigator.clipboard.readText();
	} catch {}
	return {
		html,
		text: text || ""
	};
}
function cssColorToHex(cssColor) {
	if (!cssColor) return null;
	const trimmed = cssColor.trim();
	if (!trimmed) return null;
	if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(trimmed)) return trimmed;
	const rgbMatch = trimmed.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*([\d.]+))?\s*\)/);
	if (rgbMatch) {
		const [, r$1, g$1, b$1, a] = rgbMatch;
		if (a !== void 0 && parseFloat(a) === 0) return null;
		if (Number(r$1) > 255 || Number(g$1) > 255 || Number(b$1) > 255) return null;
		return "#" + [
			r$1,
			g$1,
			b$1
		].map((c) => Number(c).toString(16).padStart(2, "0")).join("");
	}
	return trimmed;
}
const floor = Math.floor;
const abs = Math.abs;
const min$1 = (a, b$1) => a < b$1 ? a : b$1;
const max$1 = (a, b$1) => a > b$1 ? a : b$1;
Number.isNaN;
const pow = Math.pow;
const isNegativeZero = (n) => n !== 0 ? n < 0 : 1 / n < 0;
const BIT18 = 1 << 17;
const BIT19 = 1 << 18;
const BIT20 = 1 << 19;
const BIT21 = 1 << 20;
const BIT22 = 1 << 21;
const BIT23 = 1 << 22;
const BIT24 = 1 << 23;
const BIT25 = 1 << 24;
const BIT26 = 1 << 25;
const BIT27 = 1 << 26;
const BIT28 = 1 << 27;
const BIT29 = 1 << 28;
const BIT30 = 1 << 29;
const BIT31 = 1 << 30;
BIT18 - 1;
BIT19 - 1;
BIT20 - 1;
BIT21 - 1;
BIT22 - 1;
BIT23 - 1;
BIT24 - 1;
BIT25 - 1;
BIT26 - 1;
BIT27 - 1;
BIT28 - 1;
BIT29 - 1;
BIT30 - 1;
BIT31 - 1;
const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER;
const MIN_SAFE_INTEGER = Number.MIN_SAFE_INTEGER;
/* c8 ignore next */
const isInteger = Number.isInteger || ((num) => typeof num === "number" && isFinite(num) && floor(num) === num);
Number.isNaN;
Number.parseInt;
const create$2 = () => /* @__PURE__ */ new Set();
const from = Array.from;
const every$1 = (arr, f) => {
	for (let i = 0; i < arr.length; i++) if (!f(arr[i], i, arr)) return false;
	return true;
};
const some = (arr, f) => {
	for (let i = 0; i < arr.length; i++) if (f(arr[i], i, arr)) return true;
	return false;
};
const unfold = (len, f) => {
	const array = new Array(len);
	for (let i = 0; i < len; i++) array[i] = f(i, array);
	return array;
};
const isArray$1 = Array.isArray;
const fromCharCode = String.fromCharCode;
String.fromCodePoint;
fromCharCode(65535);
var toLowerCase = (s) => s.toLowerCase();
var trimLeftRegex = /^\s*/g;
const trimLeft = (s) => s.replace(trimLeftRegex, "");
var fromCamelCaseRegex = /([A-Z])/g;
const fromCamelCase = (s, separator) => trimLeft(s.replace(fromCamelCaseRegex, (match$1) => `${separator}${toLowerCase(match$1)}`));
const _encodeUtf8Polyfill = (str) => {
	const encodedString = unescape(encodeURIComponent(str));
	const len = encodedString.length;
	const buf = new Uint8Array(len);
	for (let i = 0; i < len; i++) buf[i] = encodedString.codePointAt(i);
	return buf;
};
/* c8 ignore next */
const utf8TextEncoder = typeof TextEncoder !== "undefined" ? new TextEncoder() : null;
const _encodeUtf8Native = (str) => utf8TextEncoder.encode(str);
/* c8 ignore next */
const encodeUtf8 = utf8TextEncoder ? _encodeUtf8Native : _encodeUtf8Polyfill;
/* c8 ignore next */
let utf8TextDecoder = typeof TextDecoder === "undefined" ? null : new TextDecoder("utf-8", {
	fatal: true,
	ignoreBOM: true
});
/* c8 ignore start */
if (utf8TextDecoder && utf8TextDecoder.decode(new Uint8Array()).length === 1)
 /* c8 ignore next */
utf8TextDecoder = null;
const repeat = (source, n) => unfold(n, () => source).join("");
var Encoder = class {
	constructor() {
		this.cpos = 0;
		this.cbuf = new Uint8Array(100);
		this.bufs = [];
	}
};
const createEncoder = () => new Encoder();
const encode = (f) => {
	const encoder = createEncoder();
	f(encoder);
	return toUint8Array(encoder);
};
const length = (encoder) => {
	let len = encoder.cpos;
	for (let i = 0; i < encoder.bufs.length; i++) len += encoder.bufs[i].length;
	return len;
};
const toUint8Array = (encoder) => {
	const uint8arr = new Uint8Array(length(encoder));
	let curPos = 0;
	for (let i = 0; i < encoder.bufs.length; i++) {
		const d = encoder.bufs[i];
		uint8arr.set(d, curPos);
		curPos += d.length;
	}
	uint8arr.set(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos), curPos);
	return uint8arr;
};
const verifyLen = (encoder, len) => {
	const bufferLen = encoder.cbuf.length;
	if (bufferLen - encoder.cpos < len) {
		encoder.bufs.push(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos));
		encoder.cbuf = new Uint8Array(max$1(bufferLen, len) * 2);
		encoder.cpos = 0;
	}
};
const write$1 = (encoder, num) => {
	const bufferLen = encoder.cbuf.length;
	if (encoder.cpos === bufferLen) {
		encoder.bufs.push(encoder.cbuf);
		encoder.cbuf = new Uint8Array(bufferLen * 2);
		encoder.cpos = 0;
	}
	encoder.cbuf[encoder.cpos++] = num;
};
const writeVarUint = (encoder, num) => {
	while (num > 127) {
		write$1(encoder, 128 | 127 & num);
		num = floor(num / 128);
	}
	write$1(encoder, 127 & num);
};
const writeVarInt = (encoder, num) => {
	const isNegative = isNegativeZero(num);
	if (isNegative) num = -num;
	write$1(encoder, (num > 63 ? 128 : 0) | (isNegative ? 64 : 0) | 63 & num);
	num = floor(num / 64);
	while (num > 0) {
		write$1(encoder, (num > 127 ? 128 : 0) | 127 & num);
		num = floor(num / 128);
	}
};
var _strBuffer = new Uint8Array(3e4);
var _maxStrBSize = _strBuffer.length / 3;
const _writeVarStringNative = (encoder, str) => {
	if (str.length < _maxStrBSize) {
		/* c8 ignore next */
		const written = utf8TextEncoder.encodeInto(str, _strBuffer).written || 0;
		writeVarUint(encoder, written);
		for (let i = 0; i < written; i++) write$1(encoder, _strBuffer[i]);
	} else writeVarUint8Array(encoder, encodeUtf8(str));
};
const _writeVarStringPolyfill = (encoder, str) => {
	const encodedString = unescape(encodeURIComponent(str));
	const len = encodedString.length;
	writeVarUint(encoder, len);
	for (let i = 0; i < len; i++) write$1(encoder, encodedString.codePointAt(i));
};
/* c8 ignore next */
const writeVarString = utf8TextEncoder && utf8TextEncoder.encodeInto ? _writeVarStringNative : _writeVarStringPolyfill;
const writeUint8Array = (encoder, uint8Array) => {
	const bufferLen = encoder.cbuf.length;
	const cpos = encoder.cpos;
	const leftCopyLen = min$1(bufferLen - cpos, uint8Array.length);
	const rightCopyLen = uint8Array.length - leftCopyLen;
	encoder.cbuf.set(uint8Array.subarray(0, leftCopyLen), cpos);
	encoder.cpos += leftCopyLen;
	if (rightCopyLen > 0) {
		encoder.bufs.push(encoder.cbuf);
		encoder.cbuf = new Uint8Array(max$1(bufferLen * 2, rightCopyLen));
		encoder.cbuf.set(uint8Array.subarray(leftCopyLen));
		encoder.cpos = rightCopyLen;
	}
};
const writeVarUint8Array = (encoder, uint8Array) => {
	writeVarUint(encoder, uint8Array.byteLength);
	writeUint8Array(encoder, uint8Array);
};
const writeOnDataView = (encoder, len) => {
	verifyLen(encoder, len);
	const dview = new DataView(encoder.cbuf.buffer, encoder.cpos, len);
	encoder.cpos += len;
	return dview;
};
const writeFloat32 = (encoder, num) => writeOnDataView(encoder, 4).setFloat32(0, num, false);
const writeFloat64 = (encoder, num) => writeOnDataView(encoder, 8).setFloat64(0, num, false);
const writeBigInt64 = (encoder, num) => writeOnDataView(encoder, 8).setBigInt64(0, num, false);
var floatTestBed = /* @__PURE__ */ new DataView(/* @__PURE__ */ new ArrayBuffer(4));
var isFloat32 = (num) => {
	floatTestBed.setFloat32(0, num);
	return floatTestBed.getFloat32(0) === num;
};
const writeAny = (encoder, data) => {
	switch (typeof data) {
		case "string":
			write$1(encoder, 119);
			writeVarString(encoder, data);
			break;
		case "number":
			if (isInteger(data) && abs(data) <= 2147483647) {
				write$1(encoder, 125);
				writeVarInt(encoder, data);
			} else if (isFloat32(data)) {
				write$1(encoder, 124);
				writeFloat32(encoder, data);
			} else {
				write$1(encoder, 123);
				writeFloat64(encoder, data);
			}
			break;
		case "bigint":
			write$1(encoder, 122);
			writeBigInt64(encoder, data);
			break;
		case "object":
			if (data === null) write$1(encoder, 126);
			else if (isArray$1(data)) {
				write$1(encoder, 117);
				writeVarUint(encoder, data.length);
				for (let i = 0; i < data.length; i++) writeAny(encoder, data[i]);
			} else if (data instanceof Uint8Array) {
				write$1(encoder, 116);
				writeVarUint8Array(encoder, data);
			} else {
				write$1(encoder, 118);
				const keys$1 = Object.keys(data);
				writeVarUint(encoder, keys$1.length);
				for (let i = 0; i < keys$1.length; i++) {
					const key = keys$1[i];
					writeVarString(encoder, key);
					writeAny(encoder, data[key]);
				}
			}
			break;
		case "boolean":
			write$1(encoder, data ? 120 : 121);
			break;
		default: write$1(encoder, 127);
	}
};
/* c8 ignore next */
const create$1 = (s) => new Error(s);
/* c8 ignore next 3 */
const methodUnimplemented = () => {
	throw create$1("Method unimplemented");
};
/* c8 ignore next 3 */
const unexpectedCase = () => {
	throw create$1("Unexpected case");
};
var errorUnexpectedEndOfArray = create$1("Unexpected end of array");
var errorIntegerOutOfRange = create$1("Integer out of Range");
var Decoder = class {
	constructor(uint8Array) {
		this.arr = uint8Array;
		this.pos = 0;
	}
};
const createDecoder = (uint8Array) => new Decoder(uint8Array);
const readUint8Array = (decoder, len) => {
	const view = new Uint8Array(decoder.arr.buffer, decoder.pos + decoder.arr.byteOffset, len);
	decoder.pos += len;
	return view;
};
const readVarUint8Array = (decoder) => readUint8Array(decoder, readVarUint(decoder));
const readUint8 = (decoder) => decoder.arr[decoder.pos++];
const readVarUint = (decoder) => {
	let num = 0;
	let mult = 1;
	const len = decoder.arr.length;
	while (decoder.pos < len) {
		const r$1 = decoder.arr[decoder.pos++];
		num = num + (r$1 & 127) * mult;
		mult *= 128;
		if (r$1 < 128) return num;
		/* c8 ignore start */
		if (num > MAX_SAFE_INTEGER) throw errorIntegerOutOfRange;
	}
	throw errorUnexpectedEndOfArray;
};
/* c8 ignore start */
const _readVarStringPolyfill = (decoder) => {
	let remainingLen = readVarUint(decoder);
	if (remainingLen === 0) return "";
	else {
		let encodedString = String.fromCodePoint(readUint8(decoder));
		if (--remainingLen < 100) while (remainingLen--) encodedString += String.fromCodePoint(readUint8(decoder));
		else while (remainingLen > 0) {
			const nextLen = remainingLen < 1e4 ? remainingLen : 1e4;
			const bytes = decoder.arr.subarray(decoder.pos, decoder.pos + nextLen);
			decoder.pos += nextLen;
			encodedString += String.fromCodePoint.apply(null, bytes);
			remainingLen -= nextLen;
		}
		return decodeURIComponent(escape(encodedString));
	}
};
/* c8 ignore stop */
const _readVarStringNative = (decoder) => utf8TextDecoder.decode(readVarUint8Array(decoder));
/* c8 ignore next */
const readVarString = utf8TextDecoder ? _readVarStringNative : _readVarStringPolyfill;
const getUnixTime = Date.now;
const create = () => /* @__PURE__ */ new Map();
const setIfUndefined = (map$1, key, createT) => {
	let set = map$1.get(key);
	if (set === void 0) map$1.set(key, set = createT());
	return set;
};
var ObservableV2 = class {
	constructor() {
		this._observers = create();
	}
	on(name, f) {
		setIfUndefined(this._observers, name, create$2).add(f);
		return f;
	}
	once(name, f) {
		const _f = (...args$1) => {
			this.off(name, _f);
			f(...args$1);
		};
		this.on(name, _f);
	}
	off(name, f) {
		const observers = this._observers.get(name);
		if (observers !== void 0) {
			observers.delete(f);
			if (observers.size === 0) this._observers.delete(name);
		}
	}
	emit(name, args$1) {
		return from((this._observers.get(name) || create()).values()).forEach((f) => f(...args$1));
	}
	destroy() {
		this._observers = create();
	}
};
/* c8 ignore start */
var Observable = class {
	constructor() {
		this._observers = create();
	}
	on(name, f) {
		setIfUndefined(this._observers, name, create$2).add(f);
	}
	once(name, f) {
		const _f = (...args$1) => {
			this.off(name, _f);
			f(...args$1);
		};
		this.on(name, _f);
	}
	off(name, f) {
		const observers = this._observers.get(name);
		if (observers !== void 0) {
			observers.delete(f);
			if (observers.size === 0) this._observers.delete(name);
		}
	}
	emit(name, args$1) {
		return from((this._observers.get(name) || create()).values()).forEach((f) => f(...args$1));
	}
	destroy() {
		this._observers = create();
	}
};
/* c8 ignore end */
const EqualityTraitSymbol = Symbol("Equality");
const equals = (a, b$1) => a === b$1 || !!a?.[EqualityTraitSymbol]?.(b$1) || false;
const isObject$2 = (o) => typeof o === "object";
const keys = Object.keys;
const map = (obj, f) => {
	const results = [];
	for (const key in obj) results.push(f(obj[key], key));
	return results;
};
const size = (obj) => keys(obj).length;
const every = (obj, f) => {
	for (const key in obj) if (!f(obj[key], key)) return false;
	return true;
};
const hasProperty = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);
/* c8 ignore start */
const equalityDeep = (a, b$1) => {
	if (a === b$1) return true;
	if (a == null || b$1 == null || a.constructor !== b$1.constructor && (a.constructor || Object) !== (b$1.constructor || Object)) return false;
	if (a[EqualityTraitSymbol] != null) return a[EqualityTraitSymbol](b$1);
	switch (a.constructor) {
		case ArrayBuffer:
			a = new Uint8Array(a);
			b$1 = new Uint8Array(b$1);
		case Uint8Array:
			if (a.byteLength !== b$1.byteLength) return false;
			for (let i = 0; i < a.length; i++) if (a[i] !== b$1[i]) return false;
			break;
		case Set:
			if (a.size !== b$1.size) return false;
			for (const value of a) if (!b$1.has(value)) return false;
			break;
		case Map:
			if (a.size !== b$1.size) return false;
			for (const key of a.keys()) if (!b$1.has(key) || !equalityDeep(a.get(key), b$1.get(key))) return false;
			break;
		case void 0:
		case Object:
			if (size(a) !== size(b$1)) return false;
			for (const key in a) if (!hasProperty(a, key) || !equalityDeep(a[key], b$1[key])) return false;
			break;
		case Array:
			if (a.length !== b$1.length) return false;
			for (let i = 0; i < a.length; i++) if (!equalityDeep(a[i], b$1[i])) return false;
			break;
		default: return false;
	}
	return true;
};
const isOneOf = (value, options) => options.includes(value);
const outdatedTimeout = 3e4;
var Awareness = class extends Observable {
	constructor(doc$1) {
		super();
		this.doc = doc$1;
		this.clientID = doc$1.clientID;
		this.states = /* @__PURE__ */ new Map();
		this.meta = /* @__PURE__ */ new Map();
		this._checkInterval = setInterval(() => {
			const now = getUnixTime();
			if (this.getLocalState() !== null && 3e4 / 2 <= now - this.meta.get(this.clientID).lastUpdated) this.setLocalState(this.getLocalState());
			const remove = [];
			this.meta.forEach((meta, clientid) => {
				if (clientid !== this.clientID && 3e4 <= now - meta.lastUpdated && this.states.has(clientid)) remove.push(clientid);
			});
			if (remove.length > 0) removeAwarenessStates(this, remove, "timeout");
		}, floor(outdatedTimeout / 10));
		doc$1.on("destroy", () => {
			this.destroy();
		});
		this.setLocalState({});
	}
	destroy() {
		this.emit("destroy", [this]);
		this.setLocalState(null);
		super.destroy();
		clearInterval(this._checkInterval);
	}
	getLocalState() {
		return this.states.get(this.clientID) || null;
	}
	setLocalState(state) {
		const clientID = this.clientID;
		const currLocalMeta = this.meta.get(clientID);
		const clock = currLocalMeta === void 0 ? 0 : currLocalMeta.clock + 1;
		const prevState = this.states.get(clientID);
		if (state === null) this.states.delete(clientID);
		else this.states.set(clientID, state);
		this.meta.set(clientID, {
			clock,
			lastUpdated: getUnixTime()
		});
		const added = [];
		const updated = [];
		const filteredUpdated = [];
		const removed = [];
		if (state === null) removed.push(clientID);
		else if (prevState == null) {
			if (state != null) added.push(clientID);
		} else {
			updated.push(clientID);
			if (!equalityDeep(prevState, state)) filteredUpdated.push(clientID);
		}
		if (added.length > 0 || filteredUpdated.length > 0 || removed.length > 0) this.emit("change", [{
			added,
			updated: filteredUpdated,
			removed
		}, "local"]);
		this.emit("update", [{
			added,
			updated,
			removed
		}, "local"]);
	}
	setLocalStateField(field, value) {
		const state = this.getLocalState();
		if (state !== null) this.setLocalState({
			...state,
			[field]: value
		});
	}
	getStates() {
		return this.states;
	}
};
const removeAwarenessStates = (awareness, clients, origin) => {
	const removed = [];
	for (let i = 0; i < clients.length; i++) {
		const clientID = clients[i];
		if (awareness.states.has(clientID)) {
			awareness.states.delete(clientID);
			if (clientID === awareness.clientID) {
				const curMeta = awareness.meta.get(clientID);
				awareness.meta.set(clientID, {
					clock: curMeta.clock + 1,
					lastUpdated: getUnixTime()
				});
			}
			removed.push(clientID);
		}
	}
	if (removed.length > 0) {
		awareness.emit("change", [{
			added: [],
			updated: [],
			removed
		}, origin]);
		awareness.emit("update", [{
			added: [],
			updated: [],
			removed
		}, origin]);
	}
};
const encodeAwarenessUpdate = (awareness, clients, states = awareness.states) => {
	const len = clients.length;
	const encoder = createEncoder();
	writeVarUint(encoder, len);
	for (let i = 0; i < len; i++) {
		const clientID = clients[i];
		const state = states.get(clientID) || null;
		const clock = awareness.meta.get(clientID).clock;
		writeVarUint(encoder, clientID);
		writeVarUint(encoder, clock);
		writeVarString(encoder, JSON.stringify(state));
	}
	return toUint8Array(encoder);
};
const applyAwarenessUpdate = (awareness, update, origin) => {
	const decoder = createDecoder(update);
	const timestamp = getUnixTime();
	const added = [];
	const updated = [];
	const filteredUpdated = [];
	const removed = [];
	const len = readVarUint(decoder);
	for (let i = 0; i < len; i++) {
		const clientID = readVarUint(decoder);
		let clock = readVarUint(decoder);
		const state = JSON.parse(readVarString(decoder));
		const clientMeta = awareness.meta.get(clientID);
		const prevState = awareness.states.get(clientID);
		const currClock = clientMeta === void 0 ? 0 : clientMeta.clock;
		if (currClock < clock || currClock === clock && state === null && awareness.states.has(clientID)) {
			if (state === null) if (clientID === awareness.clientID && awareness.getLocalState() != null) clock++;
			else awareness.states.delete(clientID);
			else awareness.states.set(clientID, state);
			awareness.meta.set(clientID, {
				clock,
				lastUpdated: timestamp
			});
			if (clientMeta === void 0 && state !== null) added.push(clientID);
			else if (clientMeta !== void 0 && state === null) removed.push(clientID);
			else if (state !== null) {
				if (!equalityDeep(state, prevState)) filteredUpdated.push(clientID);
				updated.push(clientID);
			}
		}
	}
	if (added.length > 0 || filteredUpdated.length > 0 || removed.length > 0) awareness.emit("change", [{
		added,
		updated: filteredUpdated,
		removed
	}, origin]);
	if (added.length > 0 || updated.length > 0 || removed.length > 0) awareness.emit("update", [{
		added,
		updated,
		removed
	}, origin]);
};
const createMutex = () => {
	let token$1 = true;
	return (f, g$1) => {
		if (token$1) {
			token$1 = false;
			try {
				f();
			} finally {
				token$1 = true;
			}
		} else if (g$1 !== void 0) g$1();
	};
};
var highSurrogateRegex = /[\uD800-\uDBFF]/;
var lowSurrogateRegex = /[\uDC00-\uDFFF]/;
const simpleDiffString = (a, b$1) => {
	let left$1 = 0;
	let right$1 = 0;
	while (left$1 < a.length && left$1 < b$1.length && a[left$1] === b$1[left$1]) left$1++;
	if (left$1 > 0 && highSurrogateRegex.test(a[left$1 - 1])) left$1--;
	while (right$1 + left$1 < a.length && right$1 + left$1 < b$1.length && a[a.length - right$1 - 1] === b$1[b$1.length - right$1 - 1]) right$1++;
	if (right$1 > 0 && lowSurrogateRegex.test(a[a.length - right$1])) right$1--;
	return {
		index: left$1,
		remove: a.length - left$1 - right$1,
		insert: b$1.slice(left$1, b$1.length - right$1)
	};
};
const simpleDiff = simpleDiffString;
const rand = Math.random;
const oneOf$1 = (arr) => arr[floor(rand() * arr.length)];
/* c8 ignore next */
const undefinedToNull = (v) => v === void 0 ? null : v;
/* c8 ignore start */
var VarStoragePolyfill = class {
	constructor() {
		this.map = /* @__PURE__ */ new Map();
	}
	setItem(key, newValue) {
		this.map.set(key, newValue);
	}
	getItem(key) {
		return this.map.get(key);
	}
};
/* c8 ignore stop */
var _localStorage = new VarStoragePolyfill();
var usePolyfill = true;
/* c8 ignore start */
try {
	if (typeof localStorage !== "undefined" && localStorage) {
		_localStorage = localStorage;
		usePolyfill = false;
	}
} catch (e) {}
/* c8 ignore stop */
/* c8 ignore next */
const varStorage = _localStorage;
/* c8 ignore next */
const onChange = (eventHandler) => usePolyfill || addEventListener("storage", eventHandler);
/* c8 ignore next */
const offChange = (eventHandler) => usePolyfill || removeEventListener("storage", eventHandler);
init_dist(
	/* c8 ignore stop */
);
/* c8 ignore next 2 */
const isNode = typeof process$1$1 !== "undefined" && process$1$1.release && /node|io\.js/.test(process$1$1.release.name) && Object.prototype.toString.call(typeof process$1$1 !== "undefined" ? process$1$1 : 0) === "[object process]";
/* c8 ignore next */
const isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && !isNode;
typeof navigator !== "undefined" && /Mac/.test(navigator.platform);
var params;
var args = [];
/* c8 ignore start */
var computeParams = () => {
	if (params === void 0) if (isNode) {
		params = create();
		const pargs = process$1$1.argv;
		let currParamName = null;
		for (let i = 0; i < pargs.length; i++) {
			const parg = pargs[i];
			if (parg[0] === "-") {
				if (currParamName !== null) params.set(currParamName, "");
				currParamName = parg;
			} else if (currParamName !== null) {
				params.set(currParamName, parg);
				currParamName = null;
			} else args.push(parg);
		}
		if (currParamName !== null) params.set(currParamName, "");
	} else if (typeof location === "object") {
		params = create();
		(location.search || "?").slice(1).split("&").forEach((kv) => {
			if (kv.length !== 0) {
				const [key, value] = kv.split("=");
				params.set(`--${fromCamelCase(key, "-")}`, value);
				params.set(`-${fromCamelCase(key, "-")}`, value);
			}
		});
	} else params = create();
	return params;
};
/* c8 ignore stop */
/* c8 ignore next */
const hasParam = (name) => computeParams().has(name);
/* c8 ignore next 4 */
const getVariable = (name) => isNode ? undefinedToNull(process$1$1.env[name.toUpperCase().replaceAll("-", "_")]) : undefinedToNull(varStorage.getItem(name));
/* c8 ignore next 2 */
const hasConf = (name) => hasParam("--" + name) || getVariable(name) !== null;
/* c8 ignore next */
const production = hasConf("production");
isNode && isOneOf(process$1$1.env.FORCE_COLOR, [
	"true",
	"1",
	"2"
]) || !hasParam("--no-colors") && !hasConf("no-color") && (!isNode || process$1$1.stdout.isTTY) && (!isNode || hasParam("--color") || getVariable("COLORTERM") !== null || (getVariable("TERM") || "").includes("color"));
init_dist$1();
const createUint8ArrayFromLen = (len) => new Uint8Array(len);
const createUint8ArrayViewFromArrayBuffer = (buffer, byteOffset, length$1) => new Uint8Array(buffer, byteOffset, length$1);
const createUint8ArrayFromArrayBuffer = (buffer) => new Uint8Array(buffer);
/* c8 ignore start */
var toBase64Browser = (bytes) => {
	let s = "";
	for (let i = 0; i < bytes.byteLength; i++) s += fromCharCode(bytes[i]);
	return btoa(s);
};
/* c8 ignore stop */
var toBase64Node = (bytes) => Buffer$1.from(bytes.buffer, bytes.byteOffset, bytes.byteLength).toString("base64");
/* c8 ignore start */
var fromBase64Browser = (s) => {
	const a = atob(s);
	const bytes = createUint8ArrayFromLen(a.length);
	for (let i = 0; i < a.length; i++) bytes[i] = a.charCodeAt(i);
	return bytes;
};
/* c8 ignore stop */
var fromBase64Node = (s) => {
	const buf = Buffer$1.from(s, "base64");
	return createUint8ArrayViewFromArrayBuffer(buf.buffer, buf.byteOffset, buf.byteLength);
};
/* c8 ignore next */
const toBase64 = isBrowser ? toBase64Browser : toBase64Node;
/* c8 ignore next */
const fromBase64 = isBrowser ? fromBase64Browser : fromBase64Node;
const encodeAny = (data) => encode((encoder) => writeAny(encoder, data));
const bool = (gen) => gen.next() >= .5;
const int53 = (gen, min$2, max$2) => floor(gen.next() * (max$2 + 1 - min$2) + min$2);
const int32 = (gen, min$2, max$2) => floor(gen.next() * (max$2 + 1 - min$2) + min$2);
const int31 = (gen, min$2, max$2) => int32(gen, min$2, max$2);
const letter = (gen) => fromCharCode(int31(gen, 97, 122));
const word = (gen, minLen = 0, maxLen = 20) => {
	const len = int31(gen, minLen, maxLen);
	let str = "";
	for (let i = 0; i < len; i++) str += letter(gen);
	return str;
};
const oneOf = (gen, array) => array[int31(gen, 0, array.length - 1)];
/* c8 ignore stop */
var schemaSymbol = Symbol("0schema");
var ValidationError = class {
	constructor() {
		this._rerrs = [];
	}
	extend(path, expected, has, message = null) {
		this._rerrs.push({
			path,
			expected,
			has,
			message
		});
	}
	toString() {
		const s = [];
		for (let i = this._rerrs.length - 1; i > 0; i--) {
			const r$1 = this._rerrs[i];
			/* c8 ignore next */
			s.push(repeat(" ", (this._rerrs.length - i) * 2) + `${r$1.path != null ? `[${r$1.path}] ` : ""}${r$1.has} doesn't match ${r$1.expected}. ${r$1.message}`);
		}
		return s.join("\n");
	}
};
var shapeExtends = (a, b$1) => {
	if (a === b$1) return true;
	if (a == null || b$1 == null || a.constructor !== b$1.constructor) return false;
	if (a[EqualityTraitSymbol]) return equals(a, b$1);
	if (isArray$1(a)) return every$1(a, (aitem) => some(b$1, (bitem) => shapeExtends(aitem, bitem)));
	else if (isObject$2(a)) return every(a, (aitem, akey) => shapeExtends(aitem, b$1[akey]));
	/* c8 ignore next */
	return false;
};
var Schema$2 = class {
	static _dilutes = false;
	extends(other) {
		let [a, b$1] = [this.shape, other.shape];
		if (this.constructor._dilutes) [b$1, a] = [a, b$1];
		return shapeExtends(a, b$1);
	}
	equals(other) {
		return this.constructor === other.constructor && equalityDeep(this.shape, other.shape);
	}
	[schemaSymbol]() {
		return true;
	}
	[EqualityTraitSymbol](other) {
		return this.equals(other);
	}
	validate(o) {
		return this.check(o);
	}
	/* c8 ignore start */
	check(_o, _err) {
		methodUnimplemented();
	}
	/* c8 ignore stop */
	get nullable() {
		return $union(this, $null);
	}
	get optional() {
		return new $Optional(this);
	}
	cast(o) {
		assert(o, this);
		return o;
	}
	expect(o) {
		assert(o, this);
		return o;
	}
};
var $ConstructedBy = class extends Schema$2 {
	constructor(c, check) {
		super();
		this.shape = c;
		this._c = check;
	}
	check(o, err = void 0) {
		const c = o?.constructor === this.shape && (this._c == null || this._c(o));
		/* c8 ignore next */
		!c && err?.extend(null, this.shape.name, o?.constructor.name, o?.constructor !== this.shape ? "Constructor match failed" : "Check failed");
		return c;
	}
};
const $constructedBy = (c, check = null) => new $ConstructedBy(c, check);
$constructedBy($ConstructedBy);
var $Custom = class extends Schema$2 {
	constructor(check) {
		super();
		this.shape = check;
	}
	check(o, err) {
		const c = this.shape(o);
		/* c8 ignore next */
		!c && err?.extend(null, "custom prop", o?.constructor.name, "failed to check custom prop");
		return c;
	}
};
const $custom = (check) => new $Custom(check);
$constructedBy($Custom);
var $Literal = class extends Schema$2 {
	constructor(literals) {
		super();
		this.shape = literals;
	}
	check(o, err) {
		const c = this.shape.some((a) => a === o);
		/* c8 ignore next */
		!c && err?.extend(null, this.shape.join(" | "), o.toString());
		return c;
	}
};
const $literal = (...literals) => new $Literal(literals);
const $$literal = $constructedBy($Literal);
var _regexEscape = RegExp.escape || ((str) => str.replace(/[().|&,$^[\]]/g, (s) => "\\" + s));
var _schemaStringTemplateToRegex = (s) => {
	if ($string.check(s)) return [_regexEscape(s)];
	if ($$literal.check(s)) return s.shape.map((v) => v + "");
	if ($$number.check(s)) return ["[+-]?\\d+.?\\d*"];
	if ($$string.check(s)) return [".*"];
	if ($$union.check(s)) return s.shape.map(_schemaStringTemplateToRegex).flat(1);
	/* c8 ignore next 2 */
	unexpectedCase();
};
var $StringTemplate = class extends Schema$2 {
	constructor(shape) {
		super();
		this.shape = shape;
		this._r = /* @__PURE__ */ new RegExp("^" + shape.map(_schemaStringTemplateToRegex).map((opts) => `(${opts.join("|")})`).join("") + "$");
	}
	check(o, err) {
		const c = this._r.exec(o) != null;
		/* c8 ignore next */
		!c && err?.extend(null, this._r.toString(), o.toString(), "String doesn't match string template.");
		return c;
	}
};
$constructedBy($StringTemplate);
var isOptionalSymbol = Symbol("optional");
var $Optional = class extends Schema$2 {
	constructor(shape) {
		super();
		this.shape = shape;
	}
	check(o, err) {
		const c = o === void 0 || this.shape.check(o);
		/* c8 ignore next */
		!c && err?.extend(null, "undefined (optional)", "()");
		return c;
	}
	get [isOptionalSymbol]() {
		return true;
	}
};
const $$optional = $constructedBy($Optional);
var $Never = class extends Schema$2 {
	check(_o, err) {
		/* c8 ignore next */
		err?.extend(null, "never", typeof _o);
		return false;
	}
};
new $Never();
$constructedBy($Never);
var $Object = class $Object extends Schema$2 {
	constructor(shape, partial = false) {
		super();
		this.shape = shape;
		this._isPartial = partial;
	}
	static _dilutes = true;
	get partial() {
		return new $Object(this.shape, true);
	}
	check(o, err) {
		if (o == null) {
			/* c8 ignore next */
			err?.extend(null, "object", "null");
			return false;
		}
		return every(this.shape, (vv, vk) => {
			const c = this._isPartial && !hasProperty(o, vk) || vv.check(o[vk], err);
			!c && err?.extend(vk.toString(), vv.toString(), typeof o[vk], "Object property does not match");
			return c;
		});
	}
};
const $object = (def) => new $Object(def);
const $$object = $constructedBy($Object);
const $objectAny = $custom((o) => o != null && (o.constructor === Object || o.constructor == null));
var $Record = class extends Schema$2 {
	constructor(keys$1, values) {
		super();
		this.shape = {
			keys: keys$1,
			values
		};
	}
	check(o, err) {
		return o != null && every(o, (vv, vk) => {
			const ck = this.shape.keys.check(vk, err);
			/* c8 ignore next */
			!ck && err?.extend(vk + "", "Record", typeof o, ck ? "Key doesn't match schema" : "Value doesn't match value");
			return ck && this.shape.values.check(vv, err);
		});
	}
};
const $record = (keys$1, values) => new $Record(keys$1, values);
const $$record = $constructedBy($Record);
var $Tuple = class extends Schema$2 {
	constructor(shape) {
		super();
		this.shape = shape;
	}
	check(o, err) {
		return o != null && every(this.shape, (vv, vk) => {
			const c = vv.check(o[vk], err);
			/* c8 ignore next */
			!c && err?.extend(vk.toString(), "Tuple", typeof vv);
			return c;
		});
	}
};
const $tuple = (...def) => new $Tuple(def);
$constructedBy($Tuple);
var $Array = class extends Schema$2 {
	constructor(v) {
		super();
		this.shape = v.length === 1 ? v[0] : new $Union(v);
	}
	check(o, err) {
		const c = isArray$1(o) && every$1(o, (oi) => this.shape.check(oi));
		/* c8 ignore next */
		!c && err?.extend(null, "Array", "");
		return c;
	}
};
const $array = (...def) => new $Array(def);
const $$array = $constructedBy($Array);
const $arrayAny = $custom((o) => isArray$1(o));
var $InstanceOf = class extends Schema$2 {
	constructor(constructor, check) {
		super();
		this.shape = constructor;
		this._c = check;
	}
	check(o, err) {
		const c = o instanceof this.shape && (this._c == null || this._c(o));
		/* c8 ignore next */
		!c && err?.extend(null, this.shape.name, o?.constructor.name);
		return c;
	}
};
const $instanceOf = (c, check = null) => new $InstanceOf(c, check);
$constructedBy($InstanceOf);
const $$schema = $instanceOf(Schema$2);
var $Lambda = class extends Schema$2 {
	constructor(args$1) {
		super();
		this.len = args$1.length - 1;
		this.args = $tuple(...args$1.slice(-1));
		this.res = args$1[this.len];
	}
	check(f, err) {
		const c = f.constructor === Function && f.length <= this.len;
		/* c8 ignore next */
		!c && err?.extend(null, "function", typeof f);
		return c;
	}
};
const $$lambda = $constructedBy($Lambda);
const $function = $custom((o) => typeof o === "function");
var $Intersection = class extends Schema$2 {
	constructor(v) {
		super();
		this.shape = v;
	}
	check(o, err) {
		const c = every$1(this.shape, (check) => check.check(o, err));
		/* c8 ignore next */
		!c && err?.extend(null, "Intersectinon", typeof o);
		return c;
	}
};
$constructedBy($Intersection, (o) => o.shape.length > 0);
var $Union = class extends Schema$2 {
	static _dilutes = true;
	constructor(v) {
		super();
		this.shape = v;
	}
	check(o, err) {
		const c = some(this.shape, (vv) => vv.check(o, err));
		err?.extend(null, "Union", typeof o);
		return c;
	}
};
const $union = (...schemas) => schemas.findIndex(($s) => $$union.check($s)) >= 0 ? $union(...schemas.map(($s) => $($s)).map(($s) => $$union.check($s) ? $s.shape : [$s]).flat(1)) : schemas.length === 1 ? schemas[0] : new $Union(schemas);
const $$union = $constructedBy($Union);
var _t = () => true;
const $any = $custom(_t);
const $$any = $constructedBy($Custom, (o) => o.shape === _t);
const $bigint = $custom((o) => typeof o === "bigint");
const $$bigint = $custom((o) => o === $bigint);
const $symbol = $custom((o) => typeof o === "symbol");
$custom((o) => o === $symbol);
const $number = $custom((o) => typeof o === "number");
const $$number = $custom((o) => o === $number);
const $string = $custom((o) => typeof o === "string");
const $$string = $custom((o) => o === $string);
const $boolean = $custom((o) => typeof o === "boolean");
const $$boolean = $custom((o) => o === $boolean);
const $undefined = $literal(void 0);
$constructedBy($Literal, (o) => o.shape.length === 1 && o.shape[0] === void 0);
$literal(void 0);
const $null = $literal(null);
const $$null = $constructedBy($Literal, (o) => o.shape.length === 1 && o.shape[0] === null);
$constructedBy(Uint8Array);
$constructedBy($ConstructedBy, (o) => o.shape === Uint8Array);
const $primitive = $union($number, $string, $null, $undefined, $bigint, $boolean, $symbol);
(() => {
	const $jsonArr = $array($any);
	const $jsonRecord = $record($string, $any);
	const $json$1 = $union($number, $string, $null, $boolean, $jsonArr, $jsonRecord);
	$jsonArr.shape = $json$1;
	$jsonRecord.shape.values = $json$1;
	return $json$1;
})();
const $ = (o) => {
	if ($$schema.check(o)) return o;
	else if ($objectAny.check(o)) {
		const o2 = {};
		for (const k$1 in o) o2[k$1] = $(o[k$1]);
		return $object(o2);
	} else if ($arrayAny.check(o)) return $union(...o.map($));
	else if ($primitive.check(o)) return $literal(o);
	else if ($function.check(o)) return $constructedBy(o);
	/* c8 ignore next */
	unexpectedCase();
};
/* c8 ignore start */
const assert = production ? () => {} : (o, schema) => {
	const err = new ValidationError();
	if (!schema.check(o, err)) throw create$1(`Expected value to be of type ${schema.constructor.name}.\n${err.toString()}`);
};
/* c8 ignore end */
var PatternMatcher = class {
	constructor($state) {
		this.patterns = [];
		this.$state = $state;
	}
	if(pattern, handler) {
		this.patterns.push({
			if: $(pattern),
			h: handler
		});
		return this;
	}
	else(h$2) {
		return this.if($any, h$2);
	}
	done() {
		return (o, s) => {
			for (let i = 0; i < this.patterns.length; i++) {
				const p$1 = this.patterns[i];
				if (p$1.if.check(o)) return p$1.h(o, s);
			}
			throw create$1("Unhandled pattern");
		};
	}
};
const match = (state) => new PatternMatcher(state);
var _random = match($any).if($$number, (_o, gen) => int53(gen, MIN_SAFE_INTEGER, MAX_SAFE_INTEGER)).if($$string, (_o, gen) => word(gen)).if($$boolean, (_o, gen) => bool(gen)).if($$bigint, (_o, gen) => BigInt(int53(gen, MIN_SAFE_INTEGER, MAX_SAFE_INTEGER))).if($$union, (o, gen) => random(gen, oneOf(gen, o.shape))).if($$object, (o, gen) => {
	const res = {};
	for (const k$1 in o.shape) {
		let prop = o.shape[k$1];
		if ($$optional.check(prop)) {
			if (bool(gen)) continue;
			prop = prop.shape;
		}
		res[k$1] = _random(prop, gen);
	}
	return res;
}).if($$array, (o, gen) => {
	const arr = [];
	const n = int32(gen, 0, 42);
	for (let i = 0; i < n; i++) arr.push(random(gen, o.shape));
	return arr;
}).if($$literal, (o, gen) => {
	return oneOf(gen, o.shape);
}).if($$null, (o, gen) => {
	return null;
}).if($$lambda, (o, gen) => {
	const res = random(gen, o.res);
	return () => res;
}).if($$any, (o, gen) => random(gen, oneOf(gen, [
	$number,
	$string,
	$null,
	$undefined,
	$bigint,
	$boolean,
	$array($number),
	$record($union("a", "b", "c"), $number)
]))).if($$record, (o, gen) => {
	const res = {};
	const keysN = int53(gen, 0, 3);
	for (let i = 0; i < keysN; i++) {
		const key = random(gen, o.shape.keys);
		res[key] = random(gen, o.shape.values);
	}
	return res;
}).done();
const random = (gen, schema) => _random($(schema), gen);
/* c8 ignore start */
const doc = typeof document !== "undefined" ? document : {};
$custom((el) => el.nodeType === DOCUMENT_FRAGMENT_NODE);
typeof DOMParser !== "undefined" && new DOMParser();
$custom((el) => el.nodeType === ELEMENT_NODE);
$custom((el) => el.nodeType === TEXT_NODE);
const ELEMENT_NODE = doc.ELEMENT_NODE;
const TEXT_NODE = doc.TEXT_NODE;
doc.CDATA_SECTION_NODE;
doc.COMMENT_NODE;
const DOCUMENT_NODE = doc.DOCUMENT_NODE;
doc.DOCUMENT_TYPE_NODE;
const DOCUMENT_FRAGMENT_NODE = doc.DOCUMENT_FRAGMENT_NODE;
$custom((el) => el.nodeType === DOCUMENT_NODE);
/* c8 ignore stop */
var createTimeoutClass = (clearFunction) => class TT {
	constructor(timeoutId) {
		this._ = timeoutId;
	}
	destroy() {
		clearFunction(this._);
	}
};
var Timeout = createTimeoutClass(clearTimeout);
const timeout = (timeout$1, callback) => new Timeout(setTimeout(callback, timeout$1));
createTimeoutClass(clearInterval);
createTimeoutClass((arg) => typeof requestAnimationFrame !== "undefined" && cancelAnimationFrame(arg));
createTimeoutClass((arg) => typeof cancelIdleCallback !== "undefined" && cancelIdleCallback(arg));
var rotr = (w, shift) => w >>> shift | w << 32 - shift;
var sum0to256 = (x) => rotr(x, 2) ^ rotr(x, 13) ^ rotr(x, 22);
var sum1to256 = (x) => rotr(x, 6) ^ rotr(x, 11) ^ rotr(x, 25);
var sigma0to256 = (x) => rotr(x, 7) ^ rotr(x, 18) ^ x >>> 3;
var sigma1to256 = (x) => rotr(x, 17) ^ rotr(x, 19) ^ x >>> 10;
var K = new Uint32Array([
	1116352408,
	1899447441,
	3049323471,
	3921009573,
	961987163,
	1508970993,
	2453635748,
	2870763221,
	3624381080,
	310598401,
	607225278,
	1426881987,
	1925078388,
	2162078206,
	2614888103,
	3248222580,
	3835390401,
	4022224774,
	264347078,
	604807628,
	770255983,
	1249150122,
	1555081692,
	1996064986,
	2554220882,
	2821834349,
	2952996808,
	3210313671,
	3336571891,
	3584528711,
	113926993,
	338241895,
	666307205,
	773529912,
	1294757372,
	1396182291,
	1695183700,
	1986661051,
	2177026350,
	2456956037,
	2730485921,
	2820302411,
	3259730800,
	3345764771,
	3516065817,
	3600352804,
	4094571909,
	275423344,
	430227734,
	506948616,
	659060556,
	883997877,
	958139571,
	1322822218,
	1537002063,
	1747873779,
	1955562222,
	2024104815,
	2227730452,
	2361852424,
	2428436474,
	2756734187,
	3204031479,
	3329325298
]);
var HINIT = new Uint32Array([
	1779033703,
	3144134277,
	1013904242,
	2773480762,
	1359893119,
	2600822924,
	528734635,
	1541459225
]);
var Hasher = class {
	constructor() {
		const buf = /* @__PURE__ */ new ArrayBuffer(320);
		this._H = new Uint32Array(buf, 0, 8);
		this._H.set(HINIT);
		this._W = new Uint32Array(buf, 64, 64);
	}
	_updateHash() {
		const H$2 = this._H;
		const W$1 = this._W;
		for (let t = 16; t < 64; t++) W$1[t] = sigma1to256(W$1[t - 2]) + W$1[t - 7] + sigma0to256(W$1[t - 15]) + W$1[t - 16];
		let a = H$2[0];
		let b$1 = H$2[1];
		let c = H$2[2];
		let d = H$2[3];
		let e = H$2[4];
		let f = H$2[5];
		let g$1 = H$2[6];
		let h$2 = H$2[7];
		for (let tt = 0, T1, T2; tt < 64; tt++) {
			T1 = h$2 + sum1to256(e) + (e & f ^ ~e & g$1) + K[tt] + W$1[tt] >>> 0;
			T2 = sum0to256(a) + (a & b$1 ^ a & c ^ b$1 & c) >>> 0;
			h$2 = g$1;
			g$1 = f;
			f = e;
			e = d + T1 >>> 0;
			d = c;
			c = b$1;
			b$1 = a;
			a = T1 + T2 >>> 0;
		}
		H$2[0] += a;
		H$2[1] += b$1;
		H$2[2] += c;
		H$2[3] += d;
		H$2[4] += e;
		H$2[5] += f;
		H$2[6] += g$1;
		H$2[7] += h$2;
	}
	digest(data) {
		let i = 0;
		for (; i + 56 <= data.length;) {
			let j$1 = 0;
			for (; j$1 < 16 && i + 3 < data.length; j$1++) this._W[j$1] = data[i++] << 24 | data[i++] << 16 | data[i++] << 8 | data[i++];
			if (i % 64 !== 0) {
				this._W.fill(0, j$1, 16);
				while (i < data.length) {
					this._W[j$1] |= data[i] << (3 - i % 4) * 8;
					i++;
				}
				this._W[j$1] |= 128 << (3 - i % 4) * 8;
			}
			this._updateHash();
		}
		const isPaddedWith1 = i % 64 !== 0;
		this._W.fill(0, 0, 16);
		let j = 0;
		for (; i < data.length; j++) for (let ci = 3; ci >= 0 && i < data.length; ci--) this._W[j] |= data[i++] << ci * 8;
		if (!isPaddedWith1) this._W[j - (i % 4 === 0 ? 0 : 1)] |= 128 << (3 - i % 4) * 8;
		this._W[14] = data.byteLength / BIT30;
		this._W[15] = data.byteLength * 8;
		this._updateHash();
		const dv = new Uint8Array(32);
		for (let i$1 = 0; i$1 < this._H.length; i$1++) for (let ci = 0; ci < 4; ci++) dv[i$1 * 4 + ci] = this._H[i$1] >>> (3 - ci) * 8;
		return dv;
	}
};
const digest = (data) => new Hasher().digest(data);
var _convolute = (digest$1) => {
	const N = 6;
	for (let i = N; i < digest$1.length; i++) digest$1[i % N] = digest$1[i % N] ^ digest$1[i];
	return digest$1.slice(0, N);
};
const hashOfJSON = (json) => toBase64(_convolute(digest(encodeAny(json))));
const createEmptyMeta = () => ({
	mapping: /* @__PURE__ */ new Map(),
	isOMark: /* @__PURE__ */ new Map()
});
const isVisible = (item, snapshot) => snapshot === void 0 ? !item.deleted : snapshot.sv.has(item.id.client) && snapshot.sv.get(item.id.client) > item.id.clock && !Y.isDeleted(snapshot.ds, item.id);
var defaultColors = [{
	light: "#ecd44433",
	dark: "#ecd444"
}];
var getUserColor = (colorMapping, colors, user) => {
	if (!colorMapping.has(user)) {
		if (colorMapping.size < colors.length) {
			const usedColors = create$2();
			colorMapping.forEach((color) => usedColors.add(color));
			colors = colors.filter((color) => !usedColors.has(color));
		}
		colorMapping.set(user, oneOf$1(colors));
	}
	return colorMapping.get(user);
};
const ySyncPlugin = (yXmlFragment, { colors = defaultColors, colorMapping = /* @__PURE__ */ new Map(), permanentUserData = null, onFirstRender = () => {}, mapping } = {}) => {
	let initialContentChanged = false;
	const binding = new ProsemirrorBinding(yXmlFragment, mapping);
	const plugin = new Plugin({
		props: { editable: (state) => {
			const syncState = ySyncPluginKey.getState(state);
			return syncState.snapshot == null && syncState.prevSnapshot == null;
		} },
		key: ySyncPluginKey,
		state: {
			init: (_initargs, _state) => {
				return {
					type: yXmlFragment,
					doc: yXmlFragment.doc,
					binding,
					snapshot: null,
					prevSnapshot: null,
					isChangeOrigin: false,
					isUndoRedoOperation: false,
					addToHistory: true,
					colors,
					colorMapping,
					permanentUserData
				};
			},
			apply: (tr, pluginState) => {
				const change = tr.getMeta(ySyncPluginKey);
				if (change !== void 0) {
					pluginState = Object.assign({}, pluginState);
					for (const key in change) pluginState[key] = change[key];
				}
				pluginState.addToHistory = tr.getMeta("addToHistory") !== false;
				pluginState.isChangeOrigin = change !== void 0 && !!change.isChangeOrigin;
				pluginState.isUndoRedoOperation = change !== void 0 && !!change.isChangeOrigin && !!change.isUndoRedoOperation;
				if (binding.prosemirrorView !== null) {
					if (change !== void 0 && (change.snapshot != null || change.prevSnapshot != null)) timeout(0, () => {
						if (binding.prosemirrorView == null) return;
						if (change.restore == null) binding._renderSnapshot(change.snapshot, change.prevSnapshot, pluginState);
						else {
							binding._renderSnapshot(change.snapshot, change.snapshot, pluginState);
							delete pluginState.restore;
							delete pluginState.snapshot;
							delete pluginState.prevSnapshot;
							binding.mux(() => {
								binding._prosemirrorChanged(binding.prosemirrorView.state.doc);
							});
						}
					});
				}
				return pluginState;
			}
		},
		view: (view) => {
			binding.initView(view);
			if (mapping == null) binding._forceRerender();
			onFirstRender();
			return {
				update: () => {
					const pluginState = plugin.getState(view.state);
					if (pluginState.snapshot == null && pluginState.prevSnapshot == null) {
						if (initialContentChanged || view.state.doc.content.findDiffStart(view.state.doc.type.createAndFill().content) !== null) {
							initialContentChanged = true;
							if (pluginState.addToHistory === false && !pluginState.isChangeOrigin) {
								const yUndoPluginState = yUndoPluginKey.getState(view.state);
								const um = yUndoPluginState && yUndoPluginState.undoManager;
								if (um) um.stopCapturing();
							}
							binding.mux(() => {
								pluginState.doc.transact((tr) => {
									tr.meta.set("addToHistory", pluginState.addToHistory);
									binding._prosemirrorChanged(view.state.doc);
								}, ySyncPluginKey);
							});
						}
					}
				},
				destroy: () => {
					binding.destroy();
				}
			};
		}
	});
	return plugin;
};
var restoreRelativeSelection = (tr, relSel, binding) => {
	if (relSel !== null && relSel.anchor !== null && relSel.head !== null) if (relSel.type === "all") tr.setSelection(new AllSelection(tr.doc));
	else if (relSel.type === "node") {
		const anchor = relativePositionToAbsolutePosition(binding.doc, binding.type, relSel.anchor, binding.mapping);
		tr.setSelection(NodeSelection.create(tr.doc, anchor));
	} else {
		const anchor = relativePositionToAbsolutePosition(binding.doc, binding.type, relSel.anchor, binding.mapping);
		const head = relativePositionToAbsolutePosition(binding.doc, binding.type, relSel.head, binding.mapping);
		if (anchor !== null && head !== null) {
			const sel = TextSelection.between(tr.doc.resolve(anchor), tr.doc.resolve(head));
			tr.setSelection(sel);
		}
	}
};
const getRelativeSelection = (pmbinding, state) => ({
	type: state.selection.jsonID,
	anchor: absolutePositionToRelativePosition(state.selection.anchor, pmbinding.type, pmbinding.mapping),
	head: absolutePositionToRelativePosition(state.selection.head, pmbinding.type, pmbinding.mapping)
});
var ProsemirrorBinding = class {
	constructor(yXmlFragment, mapping = /* @__PURE__ */ new Map()) {
		this.type = yXmlFragment;
		this.prosemirrorView = null;
		this.mux = createMutex();
		this.mapping = mapping;
		this.isOMark = /* @__PURE__ */ new Map();
		this._observeFunction = this._typeChanged.bind(this);
		this.doc = yXmlFragment.doc;
		this.beforeTransactionSelection = null;
		this.beforeAllTransactions = () => {
			if (this.beforeTransactionSelection === null && this.prosemirrorView != null) this.beforeTransactionSelection = getRelativeSelection(this, this.prosemirrorView.state);
		};
		this.afterAllTransactions = () => {
			this.beforeTransactionSelection = null;
		};
		this._domSelectionInView = null;
	}
	get _tr() {
		return this.prosemirrorView.state.tr.setMeta("addToHistory", false);
	}
	_isLocalCursorInView() {
		if (!this.prosemirrorView.hasFocus()) return false;
		if (isBrowser && this._domSelectionInView === null) {
			timeout(0, () => {
				this._domSelectionInView = null;
			});
			this._domSelectionInView = this._isDomSelectionInView();
		}
		return this._domSelectionInView;
	}
	_isDomSelectionInView() {
		const selection = this.prosemirrorView._root.getSelection();
		if (selection == null || selection.anchorNode == null) return false;
		const range = this.prosemirrorView._root.createRange();
		range.setStart(selection.anchorNode, selection.anchorOffset);
		range.setEnd(selection.focusNode, selection.focusOffset);
		if (range.getClientRects().length === 0) {
			if (range.startContainer && range.collapsed) range.selectNodeContents(range.startContainer);
		}
		const bounding = range.getBoundingClientRect();
		const documentElement = doc.documentElement;
		return bounding.bottom >= 0 && bounding.right >= 0 && bounding.left <= (window.innerWidth || documentElement.clientWidth || 0) && bounding.top <= (window.innerHeight || documentElement.clientHeight || 0);
	}
	renderSnapshot(snapshot, prevSnapshot) {
		if (!prevSnapshot) prevSnapshot = Y.createSnapshot(Y.createDeleteSet(), /* @__PURE__ */ new Map());
		this.prosemirrorView.dispatch(this._tr.setMeta(ySyncPluginKey, {
			snapshot,
			prevSnapshot
		}));
	}
	unrenderSnapshot() {
		this.mapping.clear();
		this.mux(() => {
			const fragmentContent = this.type.toArray().map((t) => createNodeFromYElement(t, this.prosemirrorView.state.schema, this)).filter((n) => n !== null);
			const tr = this._tr.replace(0, this.prosemirrorView.state.doc.content.size, new Slice(Fragment$1.from(fragmentContent), 0, 0));
			tr.setMeta(ySyncPluginKey, {
				snapshot: null,
				prevSnapshot: null
			});
			this.prosemirrorView.dispatch(tr);
		});
	}
	_forceRerender() {
		this.mapping.clear();
		this.mux(() => {
			const sel = this.beforeTransactionSelection !== null ? null : this.prosemirrorView.state.selection;
			const fragmentContent = this.type.toArray().map((t) => createNodeFromYElement(t, this.prosemirrorView.state.schema, this)).filter((n) => n !== null);
			const tr = this._tr.replace(0, this.prosemirrorView.state.doc.content.size, new Slice(Fragment$1.from(fragmentContent), 0, 0));
			if (sel) {
				const clampedAnchor = min$1(max$1(sel.anchor, 0), tr.doc.content.size);
				const clampedHead = min$1(max$1(sel.head, 0), tr.doc.content.size);
				tr.setSelection(TextSelection.create(tr.doc, clampedAnchor, clampedHead));
			}
			this.prosemirrorView.dispatch(tr.setMeta(ySyncPluginKey, {
				isChangeOrigin: true,
				binding: this
			}));
		});
	}
	_renderSnapshot(snapshot, prevSnapshot, pluginState) {
		let historyDoc = this.doc;
		let historyType = this.type;
		if (!snapshot) snapshot = Y.snapshot(this.doc);
		if (snapshot instanceof Uint8Array || prevSnapshot instanceof Uint8Array) {
			if (!(snapshot instanceof Uint8Array) || !(prevSnapshot instanceof Uint8Array)) unexpectedCase();
			historyDoc = new Y.Doc({ gc: false });
			Y.applyUpdateV2(historyDoc, prevSnapshot);
			prevSnapshot = Y.snapshot(historyDoc);
			Y.applyUpdateV2(historyDoc, snapshot);
			snapshot = Y.snapshot(historyDoc);
			if (historyType._item === null) {
				const rootKey = Array.from(this.doc.share.keys()).find((key) => this.doc.share.get(key) === this.type);
				historyType = historyDoc.getXmlFragment(rootKey);
			} else {
				const historyStructs = historyDoc.store.clients.get(historyType._item.id.client) ?? [];
				historyType = historyStructs[Y.findIndexSS(historyStructs, historyType._item.id.clock)].content.type;
			}
		}
		this.mapping.clear();
		this.mux(() => {
			historyDoc.transact((transaction) => {
				const pud = pluginState.permanentUserData;
				if (pud) pud.dss.forEach((ds) => {
					Y.iterateDeletedStructs(transaction, ds, (_item) => {});
				});
				const computeYChange = (type, id) => {
					const user = type === "added" ? pud.getUserByClientId(id.client) : pud.getUserByDeletedId(id);
					return {
						user,
						type,
						color: getUserColor(pluginState.colorMapping, pluginState.colors, user)
					};
				};
				const fragmentContent = Y.typeListToArraySnapshot(historyType, new Y.Snapshot(prevSnapshot.ds, snapshot.sv)).map((t) => {
					if (!t._item.deleted || isVisible(t._item, snapshot) || isVisible(t._item, prevSnapshot)) return createNodeFromYElement(t, this.prosemirrorView.state.schema, {
						mapping: /* @__PURE__ */ new Map(),
						isOMark: /* @__PURE__ */ new Map()
					}, snapshot, prevSnapshot, computeYChange);
					else return null;
				}).filter((n) => n !== null);
				const tr = this._tr.replace(0, this.prosemirrorView.state.doc.content.size, new Slice(Fragment$1.from(fragmentContent), 0, 0));
				this.prosemirrorView.dispatch(tr.setMeta(ySyncPluginKey, { isChangeOrigin: true }));
			}, ySyncPluginKey);
		});
	}
	_typeChanged(events, transaction) {
		if (this.prosemirrorView == null) return;
		const syncState = ySyncPluginKey.getState(this.prosemirrorView.state);
		if (events.length === 0 || syncState.snapshot != null || syncState.prevSnapshot != null) {
			this.renderSnapshot(syncState.snapshot, syncState.prevSnapshot);
			return;
		}
		this.mux(() => {
			const delType = (_$1, type) => this.mapping.delete(type);
			Y.iterateDeletedStructs(transaction, transaction.deleteSet, (struct) => {
				if (struct.constructor === Y.Item) {
					const type = struct.content.type;
					type && this.mapping.delete(type);
				}
			});
			transaction.changed.forEach(delType);
			transaction.changedParentTypes.forEach(delType);
			const fragmentContent = this.type.toArray().map((t) => createNodeIfNotExists(t, this.prosemirrorView.state.schema, this)).filter((n) => n !== null);
			let tr = this._tr.replace(0, this.prosemirrorView.state.doc.content.size, new Slice(Fragment$1.from(fragmentContent), 0, 0));
			restoreRelativeSelection(tr, this.beforeTransactionSelection, this);
			tr = tr.setMeta(ySyncPluginKey, {
				isChangeOrigin: true,
				isUndoRedoOperation: transaction.origin instanceof Y.UndoManager
			});
			if (this.beforeTransactionSelection !== null && this._isLocalCursorInView()) tr.scrollIntoView();
			this.prosemirrorView.dispatch(tr);
		});
	}
	_prosemirrorChanged(doc$1) {
		this.doc.transact(() => {
			updateYFragment(this.doc, this.type, doc$1, this);
			this.beforeTransactionSelection = getRelativeSelection(this, this.prosemirrorView.state);
		}, ySyncPluginKey);
	}
	initView(prosemirrorView) {
		if (this.prosemirrorView != null) this.destroy();
		this.prosemirrorView = prosemirrorView;
		this.doc.on("beforeAllTransactions", this.beforeAllTransactions);
		this.doc.on("afterAllTransactions", this.afterAllTransactions);
		this.type.observeDeep(this._observeFunction);
	}
	destroy() {
		if (this.prosemirrorView == null) return;
		this.prosemirrorView = null;
		this.type.unobserveDeep(this._observeFunction);
		this.doc.off("beforeAllTransactions", this.beforeAllTransactions);
		this.doc.off("afterAllTransactions", this.afterAllTransactions);
	}
};
var createNodeIfNotExists = (el, schema, meta, snapshot, prevSnapshot, computeYChange) => {
	const node = meta.mapping.get(el);
	if (node === void 0) if (el instanceof Y.XmlElement) return createNodeFromYElement(el, schema, meta, snapshot, prevSnapshot, computeYChange);
	else throw methodUnimplemented();
	return node;
};
const createNodeFromYElement = (el, schema, meta, snapshot, prevSnapshot, computeYChange) => {
	const children = [];
	const createChildren = (type) => {
		if (type instanceof Y.XmlElement) {
			const n = createNodeIfNotExists(type, schema, meta, snapshot, prevSnapshot, computeYChange);
			if (n !== null) children.push(n);
		} else {
			const nextytext = (type._item.right?.content)?.type;
			if (nextytext instanceof Y.Text && !nextytext._item.deleted && nextytext._item.id.client === nextytext.doc.clientID) {
				type.applyDelta([{ retain: type.length }, ...nextytext.toDelta()]);
				nextytext.doc.transact((tr) => {
					nextytext._item.delete(tr);
				});
			}
			const ns = createTextNodesFromYText(type, schema, meta, snapshot, prevSnapshot, computeYChange);
			if (ns !== null) ns.forEach((textchild) => {
				if (textchild !== null) children.push(textchild);
			});
		}
	};
	if (snapshot === void 0 || prevSnapshot === void 0) el.toArray().forEach(createChildren);
	else Y.typeListToArraySnapshot(el, new Y.Snapshot(prevSnapshot.ds, snapshot.sv)).forEach(createChildren);
	try {
		const attrs = el.getAttributes(snapshot);
		if (snapshot !== void 0) {
			if (!isVisible(el._item, snapshot)) attrs.ychange = computeYChange ? computeYChange("removed", el._item.id) : { type: "removed" };
			else if (!isVisible(el._item, prevSnapshot)) attrs.ychange = computeYChange ? computeYChange("added", el._item.id) : { type: "added" };
		}
		const node = schema.node(el.nodeName, attrs, children);
		meta.mapping.set(el, node);
		return node;
	} catch (e) {
		el.doc.transact((transaction) => {
			el._item.delete(transaction);
		}, ySyncPluginKey);
		meta.mapping.delete(el);
		return null;
	}
};
var createTextNodesFromYText = (text, schema, _meta, snapshot, prevSnapshot, computeYChange) => {
	const nodes = [];
	const deltas = text.toDelta(snapshot, prevSnapshot, computeYChange);
	try {
		for (let i = 0; i < deltas.length; i++) {
			const delta = deltas[i];
			nodes.push(schema.text(delta.insert, attributesToMarks(delta.attributes, schema)));
		}
	} catch (e) {
		text.doc.transact((transaction) => {
			text._item.delete(transaction);
		}, ySyncPluginKey);
		return null;
	}
	return nodes;
};
var createTypeFromTextNodes = (nodes, meta) => {
	const type = new Y.XmlText();
	const delta = nodes.map((node) => ({
		insert: node.text,
		attributes: marksToAttributes(node.marks, meta)
	}));
	type.applyDelta(delta);
	meta.mapping.set(type, nodes);
	return type;
};
var createTypeFromElementNode = (node, meta) => {
	const type = new Y.XmlElement(node.type.name);
	for (const key in node.attrs) {
		const val = node.attrs[key];
		if (val !== null && key !== "ychange") type.setAttribute(key, val);
	}
	type.insert(0, normalizePNodeContent(node).map((n) => createTypeFromTextOrElementNode(n, meta)));
	meta.mapping.set(type, node);
	return type;
};
var createTypeFromTextOrElementNode = (node, meta) => node instanceof Array ? createTypeFromTextNodes(node, meta) : createTypeFromElementNode(node, meta);
var isObject$1 = (val) => typeof val === "object" && val !== null;
var equalAttrs = (pattrs, yattrs) => {
	const keys$1 = Object.keys(pattrs).filter((key) => pattrs[key] !== null);
	let eq = keys$1.length === (yattrs == null ? 0 : Object.keys(yattrs).filter((key) => yattrs[key] !== null).length);
	for (let i = 0; i < keys$1.length && eq; i++) {
		const key = keys$1[i];
		const l = pattrs[key];
		const r$1 = yattrs[key];
		eq = key === "ychange" || l === r$1 || isObject$1(l) && isObject$1(r$1) && equalAttrs(l, r$1);
	}
	return eq;
};
var normalizePNodeContent = (pnode) => {
	const c = pnode.content.content;
	const res = [];
	for (let i = 0; i < c.length; i++) {
		const n = c[i];
		if (n.isText) {
			const textNodes = [];
			for (let tnode = c[i]; i < c.length && tnode.isText; tnode = c[++i]) textNodes.push(tnode);
			i--;
			res.push(textNodes);
		} else res.push(n);
	}
	return res;
};
var equalYTextPText = (ytext, ptexts) => {
	const delta = ytext.toDelta();
	return delta.length === ptexts.length && delta.every((d, i) => d.insert === ptexts[i].text && keys(d.attributes || {}).length === ptexts[i].marks.length && every(d.attributes, (attr, yattrname) => {
		const markname = yattr2markname(yattrname);
		const pmarks = ptexts[i].marks;
		return equalAttrs(attr, pmarks.find((mark) => mark.type.name === markname)?.attrs);
	}));
};
var equalYTypePNode = (ytype, pnode) => {
	if (ytype instanceof Y.XmlElement && !(pnode instanceof Array) && matchNodeName(ytype, pnode)) {
		const normalizedContent = normalizePNodeContent(pnode);
		return ytype._length === normalizedContent.length && equalAttrs(ytype.getAttributes(), pnode.attrs) && ytype.toArray().every((ychild, i) => equalYTypePNode(ychild, normalizedContent[i]));
	}
	return ytype instanceof Y.XmlText && pnode instanceof Array && equalYTextPText(ytype, pnode);
};
var mappedIdentity = (mapped, pcontent) => mapped === pcontent || mapped instanceof Array && pcontent instanceof Array && mapped.length === pcontent.length && mapped.every((a, i) => pcontent[i] === a);
var computeChildEqualityFactor = (ytype, pnode, meta) => {
	const yChildren = ytype.toArray();
	const pChildren = normalizePNodeContent(pnode);
	const pChildCnt = pChildren.length;
	const yChildCnt = yChildren.length;
	const minCnt = min$1(yChildCnt, pChildCnt);
	let left$1 = 0;
	let right$1 = 0;
	let foundMappedChild = false;
	for (; left$1 < minCnt; left$1++) {
		const leftY = yChildren[left$1];
		const leftP = pChildren[left$1];
		if (mappedIdentity(meta.mapping.get(leftY), leftP)) foundMappedChild = true;
		else if (!equalYTypePNode(leftY, leftP)) break;
	}
	for (; left$1 + right$1 < minCnt; right$1++) {
		const rightY = yChildren[yChildCnt - right$1 - 1];
		const rightP = pChildren[pChildCnt - right$1 - 1];
		if (mappedIdentity(meta.mapping.get(rightY), rightP)) foundMappedChild = true;
		else if (!equalYTypePNode(rightY, rightP)) break;
	}
	return {
		equalityFactor: left$1 + right$1,
		foundMappedChild
	};
};
var ytextTrans = (ytext) => {
	let str = "";
	let n = ytext._start;
	const nAttrs = {};
	while (n !== null) {
		if (!n.deleted) {
			if (n.countable && n.content instanceof Y.ContentString) str += n.content.str;
			else if (n.content instanceof Y.ContentFormat) nAttrs[n.content.key] = null;
		}
		n = n.right;
	}
	return {
		str,
		nAttrs
	};
};
var updateYText = (ytext, ptexts, meta) => {
	meta.mapping.set(ytext, ptexts);
	const { nAttrs, str } = ytextTrans(ytext);
	const content = ptexts.map((p$1) => ({
		insert: p$1.text,
		attributes: Object.assign({}, nAttrs, marksToAttributes(p$1.marks, meta))
	}));
	const { insert, remove, index } = simpleDiff(str, content.map((c) => c.insert).join(""));
	ytext.delete(index, remove);
	ytext.insert(index, insert);
	ytext.applyDelta(content.map((c) => ({
		retain: c.insert.length,
		attributes: c.attributes
	})));
};
var hashedMarkNameRegex = /(.*)(--[a-zA-Z0-9+/=]{8})$/;
const yattr2markname = (attrName) => hashedMarkNameRegex.exec(attrName)?.[1] ?? attrName;
const attributesToMarks = (attrs, schema) => {
	const marks = [];
	for (const markName in attrs) marks.push(schema.mark(yattr2markname(markName), attrs[markName]));
	return marks;
};
var marksToAttributes = (marks, meta) => {
	const pattrs = {};
	marks.forEach((mark) => {
		if (mark.type.name !== "ychange") {
			const isOverlapping = setIfUndefined(meta.isOMark, mark.type, () => !mark.type.excludes(mark.type));
			pattrs[isOverlapping ? `${mark.type.name}--${hashOfJSON(mark.toJSON())}` : mark.type.name] = mark.attrs;
		}
	});
	return pattrs;
};
const updateYFragment = (y$1, yDomFragment, pNode, meta) => {
	if (yDomFragment instanceof Y.XmlElement && yDomFragment.nodeName !== pNode.type.name) throw new Error("node name mismatch!");
	meta.mapping.set(yDomFragment, pNode);
	if (yDomFragment instanceof Y.XmlElement) {
		const yDomAttrs = yDomFragment.getAttributes();
		const pAttrs = pNode.attrs;
		for (const key in pAttrs) if (pAttrs[key] !== null) {
			if (yDomAttrs[key] !== pAttrs[key] && key !== "ychange") yDomFragment.setAttribute(key, pAttrs[key]);
		} else yDomFragment.removeAttribute(key);
		for (const key in yDomAttrs) if (pAttrs[key] === void 0) yDomFragment.removeAttribute(key);
	}
	const pChildren = normalizePNodeContent(pNode);
	const pChildCnt = pChildren.length;
	const yChildren = yDomFragment.toArray();
	const yChildCnt = yChildren.length;
	const minCnt = min$1(pChildCnt, yChildCnt);
	let left$1 = 0;
	let right$1 = 0;
	for (; left$1 < minCnt; left$1++) {
		const leftY = yChildren[left$1];
		const leftP = pChildren[left$1];
		if (!mappedIdentity(meta.mapping.get(leftY), leftP)) if (equalYTypePNode(leftY, leftP)) meta.mapping.set(leftY, leftP);
		else break;
	}
	for (; right$1 + left$1 < minCnt; right$1++) {
		const rightY = yChildren[yChildCnt - right$1 - 1];
		const rightP = pChildren[pChildCnt - right$1 - 1];
		if (!mappedIdentity(meta.mapping.get(rightY), rightP)) if (equalYTypePNode(rightY, rightP)) meta.mapping.set(rightY, rightP);
		else break;
	}
	y$1.transact(() => {
		while (yChildCnt - left$1 - right$1 > 0 && pChildCnt - left$1 - right$1 > 0) {
			const leftY = yChildren[left$1];
			const leftP = pChildren[left$1];
			const rightY = yChildren[yChildCnt - right$1 - 1];
			const rightP = pChildren[pChildCnt - right$1 - 1];
			if (leftY instanceof Y.XmlText && leftP instanceof Array) {
				if (!equalYTextPText(leftY, leftP)) updateYText(leftY, leftP, meta);
				left$1 += 1;
			} else {
				let updateLeft = leftY instanceof Y.XmlElement && matchNodeName(leftY, leftP);
				let updateRight = rightY instanceof Y.XmlElement && matchNodeName(rightY, rightP);
				if (updateLeft && updateRight) {
					const equalityLeft = computeChildEqualityFactor(leftY, leftP, meta);
					const equalityRight = computeChildEqualityFactor(rightY, rightP, meta);
					if (equalityLeft.foundMappedChild && !equalityRight.foundMappedChild) updateRight = false;
					else if (!equalityLeft.foundMappedChild && equalityRight.foundMappedChild) updateLeft = false;
					else if (equalityLeft.equalityFactor < equalityRight.equalityFactor) updateLeft = false;
					else updateRight = false;
				}
				if (updateLeft) {
					updateYFragment(y$1, leftY, leftP, meta);
					left$1 += 1;
				} else if (updateRight) {
					updateYFragment(y$1, rightY, rightP, meta);
					right$1 += 1;
				} else {
					meta.mapping.delete(yDomFragment.get(left$1));
					yDomFragment.delete(left$1, 1);
					yDomFragment.insert(left$1, [createTypeFromTextOrElementNode(leftP, meta)]);
					left$1 += 1;
				}
			}
		}
		const yDelLen = yChildCnt - left$1 - right$1;
		if (yChildCnt === 1 && pChildCnt === 0 && yChildren[0] instanceof Y.XmlText) {
			meta.mapping.delete(yChildren[0]);
			yChildren[0].delete(0, yChildren[0].length);
		} else if (yDelLen > 0) {
			yDomFragment.slice(left$1, left$1 + yDelLen).forEach((type) => meta.mapping.delete(type));
			yDomFragment.delete(left$1, yDelLen);
		}
		if (left$1 + right$1 < pChildCnt) {
			const ins = [];
			for (let i = left$1; i < pChildCnt - right$1; i++) ins.push(createTypeFromTextOrElementNode(pChildren[i], meta));
			yDomFragment.insert(left$1, ins);
		}
	}, ySyncPluginKey);
};
var matchNodeName = (yElement, pNode) => !(pNode instanceof Array) && yElement.nodeName === pNode.type.name;
var viewsToUpdate = null;
var updateMetas = () => {
	const ups = viewsToUpdate;
	viewsToUpdate = null;
	ups.forEach((metas, view) => {
		const tr = view.state.tr;
		const syncState = ySyncPluginKey.getState(view.state);
		if (syncState && syncState.binding && !syncState.binding.isDestroyed) {
			metas.forEach((val, key) => {
				tr.setMeta(key, val);
			});
			view.dispatch(tr);
		}
	});
};
const setMeta$1 = (view, key, value) => {
	if (!viewsToUpdate) {
		viewsToUpdate = /* @__PURE__ */ new Map();
		timeout(0, updateMetas);
	}
	setIfUndefined(viewsToUpdate, view, create).set(key, value);
};
const absolutePositionToRelativePosition = (pos, type, mapping) => {
	if (pos === 0) return Y.createRelativePositionFromTypeIndex(type, 0, type.length === 0 ? -1 : 0);
	let n = type._first === null ? null : type._first.content.type;
	while (n !== null && type !== n) {
		if (n instanceof Y.XmlText) {
			if (n._length >= pos) return Y.createRelativePositionFromTypeIndex(n, pos, type.length === 0 ? -1 : 0);
			else pos -= n._length;
			if (n._item !== null && n._item.next !== null) n = n._item.next.content.type;
			else {
				do {
					n = n._item === null ? null : n._item.parent;
					pos--;
				} while (n !== type && n !== null && n._item !== null && n._item.next === null);
				if (n !== null && n !== type) n = n._item === null ? null : n._item.next.content.type;
			}
		} else {
			const pNodeSize = (mapping.get(n) || { nodeSize: 0 }).nodeSize;
			if (n._first !== null && pos < pNodeSize) {
				n = n._first.content.type;
				pos--;
			} else {
				if (pos === 1 && n._length === 0 && pNodeSize > 1) return new Y.RelativePosition(n._item === null ? null : n._item.id, n._item === null ? Y.findRootTypeKey(n) : null, null);
				pos -= pNodeSize;
				if (n._item !== null && n._item.next !== null) n = n._item.next.content.type;
				else {
					if (pos === 0) {
						n = n._item === null ? n : n._item.parent;
						return new Y.RelativePosition(n._item === null ? null : n._item.id, n._item === null ? Y.findRootTypeKey(n) : null, null);
					}
					do {
						n = n._item.parent;
						pos--;
					} while (n !== type && n._item.next === null);
					if (n !== type) n = n._item.next.content.type;
				}
			}
		}
		if (n === null) throw unexpectedCase();
		if (pos === 0 && n.constructor !== Y.XmlText && n !== type) return createRelativePosition(n._item.parent, n._item);
	}
	return Y.createRelativePositionFromTypeIndex(type, type._length, type.length === 0 ? -1 : 0);
};
var createRelativePosition = (type, item) => {
	let typeid = null;
	let tname = null;
	if (type._item === null) tname = Y.findRootTypeKey(type);
	else typeid = Y.createID(type._item.id.client, type._item.id.clock);
	return new Y.RelativePosition(typeid, tname, item.id);
};
const relativePositionToAbsolutePosition = (y$1, documentType, relPos, mapping) => {
	const decodedPos = Y.createAbsolutePositionFromRelativePosition(relPos, y$1);
	if (decodedPos === null || decodedPos.type !== documentType && !Y.isParentOf(documentType, decodedPos.type._item)) return null;
	let type = decodedPos.type;
	let pos = 0;
	if (type.constructor === Y.XmlText) pos = decodedPos.index;
	else if (type._item === null || !type._item.deleted) {
		let n = type._first;
		let i = 0;
		while (i < type._length && i < decodedPos.index && n !== null) {
			if (!n.deleted) {
				const t = n.content.type;
				i++;
				if (t instanceof Y.XmlText) pos += t._length;
				else pos += mapping.get(t).nodeSize;
			}
			n = n.right;
		}
		pos += 1;
	}
	while (type !== documentType && type._item !== null) {
		const parent = type._item.parent;
		if (parent._item === null || !parent._item.deleted) {
			pos += 1;
			let n = parent._first;
			while (n !== null) {
				const contentType = n.content.type;
				if (contentType === type) break;
				if (!n.deleted) if (contentType instanceof Y.XmlText) pos += contentType._length;
				else pos += mapping.get(contentType).nodeSize;
				n = n.right;
			}
		}
		type = parent;
	}
	return pos - 1;
};
const yXmlFragmentToProseMirrorFragment = (yXmlFragment, schema) => {
	const fragmentContent = yXmlFragment.toArray().map((t) => createNodeFromYElement(t, schema, createEmptyMeta())).filter((n) => n !== null);
	return Fragment$1.fromArray(fragmentContent);
};
const yXmlFragmentToProseMirrorRootNode = (yXmlFragment, schema) => schema.topNodeType.create(null, yXmlFragmentToProseMirrorFragment(yXmlFragment, schema));
function prosemirrorToYDoc(doc$1, xmlFragment = "prosemirror") {
	const ydoc = new Y.Doc();
	const type = ydoc.get(xmlFragment, Y.XmlFragment);
	if (!type.doc) return ydoc;
	prosemirrorToYXmlFragment(doc$1, type);
	return type.doc;
}
function prosemirrorToYXmlFragment(doc$1, xmlFragment) {
	const type = xmlFragment || new Y.XmlFragment();
	updateYFragment(type.doc ? type.doc : { transact: (transaction) => transaction(void 0) }, type, doc$1, {
		mapping: /* @__PURE__ */ new Map(),
		isOMark: /* @__PURE__ */ new Map()
	});
	return type;
}
const defaultAwarenessStateFilter = (currentClientId, userClientId, _user) => currentClientId !== userClientId;
const defaultCursorBuilder = (user) => {
	const cursor = document.createElement("span");
	cursor.classList.add("ProseMirror-yjs-cursor");
	cursor.setAttribute("style", `border-color: ${user.color}`);
	const userDiv = document.createElement("div");
	userDiv.setAttribute("style", `background-color: ${user.color}`);
	userDiv.insertBefore(document.createTextNode(user.name), null);
	const nonbreakingSpace1 = document.createTextNode("⁠");
	const nonbreakingSpace2 = document.createTextNode("⁠");
	cursor.insertBefore(nonbreakingSpace1, null);
	cursor.insertBefore(userDiv, null);
	cursor.insertBefore(nonbreakingSpace2, null);
	return cursor;
};
const defaultSelectionBuilder = (user) => {
	return {
		style: `background-color: ${user.color}70`,
		class: "ProseMirror-yjs-selection"
	};
};
var rxValidColor = /^#[0-9a-fA-F]{6}$/;
const createDecorations = (state, awareness, awarenessFilter, createCursor, createSelection) => {
	const ystate = ySyncPluginKey.getState(state);
	const y$1 = ystate.doc;
	const decorations = [];
	if (ystate.snapshot != null || ystate.prevSnapshot != null || ystate.binding.mapping.size === 0) return DecorationSet.create(state.doc, []);
	awareness.getStates().forEach((aw, clientId) => {
		if (!awarenessFilter(y$1.clientID, clientId, aw)) return;
		if (aw.cursor != null) {
			const user = aw.user || {};
			if (user.color == null) user.color = "#ffa500";
			else if (!rxValidColor.test(user.color)) console.warn("A user uses an unsupported color format", user);
			if (user.name == null) user.name = `User: ${clientId}`;
			let anchor = relativePositionToAbsolutePosition(y$1, ystate.type, Y.createRelativePositionFromJSON(aw.cursor.anchor), ystate.binding.mapping);
			let head = relativePositionToAbsolutePosition(y$1, ystate.type, Y.createRelativePositionFromJSON(aw.cursor.head), ystate.binding.mapping);
			if (anchor !== null && head !== null) {
				const maxsize = max$1(state.doc.content.size - 1, 0);
				anchor = min$1(anchor, maxsize);
				head = min$1(head, maxsize);
				decorations.push(Decoration.widget(head, () => createCursor(user, clientId), {
					key: clientId + "",
					side: 10
				}));
				const from$1 = min$1(anchor, head);
				const to = max$1(anchor, head);
				decorations.push(Decoration.inline(from$1, to, createSelection(user, clientId), {
					inclusiveEnd: true,
					inclusiveStart: false
				}));
			}
		}
	});
	return DecorationSet.create(state.doc, decorations);
};
const yCursorPlugin = (awareness, { awarenessStateFilter = defaultAwarenessStateFilter, cursorBuilder = defaultCursorBuilder, selectionBuilder = defaultSelectionBuilder, getSelection = (state) => state.selection } = {}, cursorStateField = "cursor") => new Plugin({
	key: yCursorPluginKey,
	state: {
		init(_$1, state) {
			return createDecorations(state, awareness, awarenessStateFilter, cursorBuilder, selectionBuilder);
		},
		apply(tr, prevState, _oldState, newState) {
			const ystate = ySyncPluginKey.getState(newState);
			const yCursorState = tr.getMeta(yCursorPluginKey);
			if (ystate && ystate.isChangeOrigin || yCursorState && yCursorState.awarenessUpdated) return createDecorations(newState, awareness, awarenessStateFilter, cursorBuilder, selectionBuilder);
			return prevState.map(tr.mapping, tr.doc);
		}
	},
	props: { decorations: (state) => {
		return yCursorPluginKey.getState(state);
	} },
	view: (view) => {
		const awarenessListener = () => {
			if (view.docView) setMeta$1(view, yCursorPluginKey, { awarenessUpdated: true });
		};
		const updateCursorInfo = () => {
			const ystate = ySyncPluginKey.getState(view.state);
			const current = awareness.getLocalState() || {};
			if (view.hasFocus()) {
				const selection = getSelection(view.state);
				const anchor = absolutePositionToRelativePosition(selection.anchor, ystate.type, ystate.binding.mapping);
				const head = absolutePositionToRelativePosition(selection.head, ystate.type, ystate.binding.mapping);
				if (current.cursor == null || !Y.compareRelativePositions(Y.createRelativePositionFromJSON(current.cursor.anchor), anchor) || !Y.compareRelativePositions(Y.createRelativePositionFromJSON(current.cursor.head), head)) awareness.setLocalStateField(cursorStateField, {
					anchor,
					head
				});
			} else if (current.cursor != null && relativePositionToAbsolutePosition(ystate.doc, ystate.type, Y.createRelativePositionFromJSON(current.cursor.anchor), ystate.binding.mapping) !== null) awareness.setLocalStateField(cursorStateField, null);
		};
		awareness.on("change", awarenessListener);
		view.dom.addEventListener("focusin", updateCursorInfo);
		view.dom.addEventListener("focusout", updateCursorInfo);
		return {
			update: updateCursorInfo,
			destroy: () => {
				view.dom.removeEventListener("focusin", updateCursorInfo);
				view.dom.removeEventListener("focusout", updateCursorInfo);
				awareness.off("change", awarenessListener);
				awareness.setLocalStateField(cursorStateField, null);
			}
		};
	}
});
const undo$1 = (state) => yUndoPluginKey.getState(state)?.undoManager?.undo() != null;
const redo$1 = (state) => yUndoPluginKey.getState(state)?.undoManager?.redo() != null;
const defaultProtectedNodes = new Set(["paragraph"]);
const defaultDeleteFilter = (item, protectedNodes) => !(item instanceof Item) || !(item.content instanceof ContentType) || !(item.content.type instanceof Text$1 || item.content.type instanceof XmlElement && protectedNodes.has(item.content.type.nodeName)) || item.content.type._length === 0;
const yUndoPlugin = ({ protectedNodes = defaultProtectedNodes, trackedOrigins = [], undoManager = null } = {}) => new Plugin({
	key: yUndoPluginKey,
	state: {
		init: (initargs, state) => {
			const ystate = ySyncPluginKey.getState(state);
			const _undoManager = undoManager || new UndoManager(ystate.type, {
				trackedOrigins: new Set([ySyncPluginKey].concat(trackedOrigins)),
				deleteFilter: (item) => defaultDeleteFilter(item, protectedNodes),
				captureTransaction: (tr) => tr.meta.get("addToHistory") !== false
			});
			return {
				undoManager: _undoManager,
				prevSel: null,
				hasUndoOps: _undoManager.undoStack.length > 0,
				hasRedoOps: _undoManager.redoStack.length > 0
			};
		},
		apply: (tr, val, oldState, state) => {
			const binding = ySyncPluginKey.getState(state).binding;
			const undoManager$1 = val.undoManager;
			const hasUndoOps = undoManager$1.undoStack.length > 0;
			const hasRedoOps = undoManager$1.redoStack.length > 0;
			if (binding) return {
				undoManager: undoManager$1,
				prevSel: getRelativeSelection(binding, oldState),
				hasUndoOps,
				hasRedoOps
			};
			else if (hasUndoOps !== val.hasUndoOps || hasRedoOps !== val.hasRedoOps) return Object.assign({}, val, {
				hasUndoOps: undoManager$1.undoStack.length > 0,
				hasRedoOps: undoManager$1.redoStack.length > 0
			});
			else return val;
		}
	},
	view: (view) => {
		const ystate = ySyncPluginKey.getState(view.state);
		const undoManager$1 = yUndoPluginKey.getState(view.state).undoManager;
		undoManager$1.on("stack-item-added", ({ stackItem }) => {
			const binding = ystate.binding;
			if (binding) stackItem.meta.set(binding, yUndoPluginKey.getState(view.state).prevSel);
		});
		undoManager$1.on("stack-item-popped", ({ stackItem }) => {
			const binding = ystate.binding;
			if (binding) binding.beforeTransactionSelection = stackItem.meta.get(binding) || binding.beforeTransactionSelection;
		});
		return { destroy: () => {
			undoManager$1.destroy();
		} };
	}
});
const comments_module_events = {
	RESOLVED: "resolved",
	NEW: "new",
	ADD: "add",
	UPDATE: "update",
	DELETED: "deleted",
	PENDING: "pending",
	SELECTED: "selected",
	COMMENTS_LIST: "comments-list",
	CHANGE_ACCEPTED: "change-accepted",
	CHANGE_REJECTED: "change-rejected"
};
function hasV8CaptureStackTrace(error) {
	return typeof error.captureStackTrace === "function";
}
var FileObjectError = class extends Error {
	constructor(message, cause) {
		super(message);
		this.cause = cause;
		this.name = "FileObjectError";
		if (hasV8CaptureStackTrace(Error)) Error.captureStackTrace(this, this.constructor);
	}
};
var InvalidDataUriError = class extends FileObjectError {
	constructor(uri) {
		super(`Invalid data URI format: URI must contain exactly one comma separator`);
		this.uri = uri;
		this.name = "InvalidDataUriError";
	}
};
var FetchFailedError = class extends FileObjectError {
	constructor(url, cause) {
		super(`Failed to fetch file from URL: ${url}`, cause);
		this.url = url;
		this.name = "FetchFailedError";
	}
};
const getFileObject = async (fileUrl, name, type) => {
	try {
		if (fileUrl.startsWith("data:") && fileUrl.includes(";base64,")) {
			const parts = fileUrl.split(",");
			if (parts.length !== 2) throw new InvalidDataUriError(fileUrl);
			const binary = atob(parts[1]);
			const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
			return new File([bytes], name, { type });
		}
		const response = await fetch(fileUrl);
		if (!response.ok) throw new FetchFailedError(fileUrl, /* @__PURE__ */ new Error(`HTTP ${response.status}: ${response.statusText}`));
		const blob = await response.blob();
		return new File([blob], name, { type });
	} catch (error) {
		if (error instanceof FileObjectError) throw error;
		throw new FileObjectError("Failed to create file object", error);
	}
};
var v_click_outside_default = {
	mounted(el, binding) {
		const clickOutsideHandler = (event) => {
			if (!el.contains(event.target)) binding.value?.(event);
		};
		document.addEventListener("click", clickOutsideHandler);
		el.__clickOutsideHandler = clickOutsideHandler;
	},
	unmounted(el) {
		if (el.__clickOutsideHandler) {
			document.removeEventListener("click", el.__clickOutsideHandler);
			delete el.__clickOutsideHandler;
		}
	}
};
var DEFAULT_ENDPOINT = "https://ingest.superdoc.dev/v1/collect";
function getSuperdocVersion() {
	try {
		return "1.40.0";
	} catch {
		return "unknown";
	}
}
var Telemetry = class {
	constructor(config) {
		this.enabled = config.enabled;
		this.endpoint = config.endpoint || DEFAULT_ENDPOINT;
		this.licenseKey = config.licenseKey || "";
		this.metadata = config.metadata;
		this.superdocVersion = getSuperdocVersion();
	}
	getBrowserInfo() {
		if (typeof window === "undefined") return {
			userAgent: "",
			currentUrl: "",
			hostname: "",
			screenSize: {
				width: 0,
				height: 0
			}
		};
		return {
			userAgent: window.navigator.userAgent,
			currentUrl: window.location.href,
			hostname: window.location.hostname,
			screenSize: {
				width: window.screen.width,
				height: window.screen.height
			}
		};
	}
	trackDocumentOpen(documentId, documentCreatedAt = null) {
		if (!this.enabled) return;
		const event = {
			timestamp: (/* @__PURE__ */ new Date()).toISOString(),
			documentId,
			documentCreatedAt
		};
		this.sendEvent(event);
	}
	async sendEvent(event) {
		const payload = {
			superdocVersion: this.superdocVersion,
			browserInfo: this.getBrowserInfo(),
			...this.metadata && { metadata: this.metadata },
			events: [event]
		};
		try {
			await fetch(this.endpoint, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-License-Key": this.licenseKey
				},
				body: JSON.stringify(payload),
				credentials: "omit"
			});
		} catch {}
	}
};
var isKeyboardInvocation = (event) => {
	return event.type === "contextmenu" && typeof event.detail === "number" && event.detail === 0 && (event.button === 0 || event.button === void 0) && event.clientX === 0 && event.clientY === 0;
};
var prefersNativeMenu = (event) => {
	if (!event) return false;
	if (event.ctrlKey || event.metaKey) return true;
	return isKeyboardInvocation(event);
};
var shouldAllowNativeContextMenu = (event) => {
	return prefersNativeMenu(event);
};
const shouldBypassContextMenu = shouldAllowNativeContextMenu;
const DEFAULT_SELECTION_STATE = Object.freeze({
	focused: false,
	preservedSelection: null,
	showVisualSelection: false,
	skipFocusReset: false
});
var normalizeSelectionState = (state = {}) => ({
	...DEFAULT_SELECTION_STATE,
	...state
});
var handleClickOutside = (event, editor) => {
	const editorElem = editor?.options?.element;
	if (!editorElem) return;
	if (!editorElem?.contains(event.target)) editor.setOptions({ focusTarget: event.target });
	else editor.setOptions({ focusTarget: null });
};
function getFocusMeta(tr) {
	return tr.getMeta(CustomSelectionPluginKey);
}
function setFocusMeta(tr, value) {
	return tr.setMeta(CustomSelectionPluginKey, value);
}
function getFocusState(state) {
	return CustomSelectionPluginKey.getState(state);
}
function mapPreservedSelection(selection, tr) {
	if (!selection || !tr.docChanged) return selection;
	if (typeof selection.getBookmark !== "function") return null;
	try {
		const resolved = createSelectionTrackingBookmark(selection).map(tr.mapping).resolve(tr.doc);
		if (!selection.empty && resolved.empty) return null;
		return resolved;
	} catch {
		return null;
	}
}
function shouldClearPreservedSelectionOnSelectionMove(tr, nextState) {
	if (!nextState?.preservedSelection) return false;
	if (tr.docChanged || !tr.selectionSet) return false;
	if (getFocusMeta(tr) !== void 0) return false;
	return true;
}
var isToolbarInput = (target) => {
	return !!target?.closest(".button-text-input") || target?.classList?.contains("button-text-input");
};
var isToolbarButton = (target) => {
	return !!target?.closest(".sd-toolbar-button") || !!target?.closest(".toolbar-button") || target?.classList?.contains("sd-toolbar-button") || target?.classList?.contains("toolbar-button");
};
const CustomSelection = Extension.create({
	name: "customSelection",
	addPmPlugins() {
		const editor = this.editor;
		return [new Plugin({
			key: CustomSelectionPluginKey,
			state: {
				init: () => ({ ...DEFAULT_SELECTION_STATE }),
				apply: (tr, value) => {
					const meta = getFocusMeta(tr);
					const nextState = meta !== void 0 ? normalizeSelectionState({
						...value,
						...meta
					}) : value;
					if (!nextState?.preservedSelection) return nextState;
					if (shouldClearPreservedSelectionOnSelectionMove(tr, nextState)) return {
						...nextState,
						preservedSelection: null,
						showVisualSelection: false
					};
					if (!tr.docChanged) return nextState;
					const mappedSelection = mapPreservedSelection(nextState.preservedSelection, tr);
					if (!mappedSelection) return {
						...nextState,
						preservedSelection: null,
						showVisualSelection: false
					};
					return {
						...nextState,
						preservedSelection: mappedSelection
					};
				}
			},
			view: () => {
				const clickHandler = (event) => handleClickOutside(event, editor);
				document?.addEventListener("mousedown", clickHandler);
				return { destroy: () => {
					document?.removeEventListener("mousedown", clickHandler);
				} };
			},
			props: {
				handleDOMEvents: {
					contextmenu: (view, event) => {
						if (shouldAllowNativeContextMenu(event)) return false;
						if (editor.options?.disableContextMenu) return false;
						event.preventDefault();
						const { selection } = view.state;
						if (!selection.empty) view.dispatch(setFocusMeta(view.state.tr, {
							focused: true,
							preservedSelection: selection,
							showVisualSelection: true,
							skipFocusReset: true
						}));
						setTimeout(() => {
							view.focus();
						}, 0);
						return false;
					},
					mousedown: (view, event) => {
						if (event.button === 2) {
							if (shouldAllowNativeContextMenu(event)) return false;
							const { selection: selection$1 } = view.state;
							if (!selection$1.empty) {
								view.dispatch(setFocusMeta(view.state.tr, {
									focused: true,
									preservedSelection: selection$1,
									showVisualSelection: true,
									skipFocusReset: true
								}));
								this.editor.setOptions({
									lastSelection: selection$1,
									preservedSelection: selection$1
								});
							}
							return false;
						}
						const { selection } = view.state;
						const target = event.target;
						const isElement$2 = target instanceof Element;
						const isToolbarBtn = isElement$2 && isToolbarButton(target);
						const isToolbarInp = isElement$2 && isToolbarInput(target);
						this.editor.setOptions({ focusTarget: target });
						if (isToolbarInp && !selection.empty) {
							view.dispatch(setFocusMeta(view.state.tr, {
								focused: true,
								preservedSelection: selection,
								showVisualSelection: true,
								skipFocusReset: false
							}));
							this.editor.setOptions({
								lastSelection: selection,
								preservedSelection: selection
							});
							return false;
						}
						if (isToolbarBtn && !isToolbarInp) {
							if (!selection.empty) {
								this.editor.setOptions({ lastSelection: selection });
								view.dispatch(setFocusMeta(view.state.tr, {
									focused: true,
									preservedSelection: selection,
									showVisualSelection: true,
									skipFocusReset: false
								}));
							}
							return false;
						}
						if (!isToolbarBtn && !isToolbarInp) {
							view.dispatch(setFocusMeta(view.state.tr, {
								focused: false,
								preservedSelection: null,
								showVisualSelection: false,
								skipFocusReset: false
							}));
							if (!selection.empty && !this.editor.options.element?.contains(target)) {
								this.editor.setOptions({ lastSelection: selection });
								const clearSelectionTr = view.state.tr.setSelection(TextSelection.create(view.state.doc, 0));
								view.dispatch(clearSelectionTr);
							}
						}
					},
					focus: (view) => {
						const target = this.editor.options.focusTarget;
						const isElement$2 = target instanceof Element;
						const isToolbarBtn = isElement$2 && isToolbarButton(target);
						const isToolbarInp = isElement$2 && isToolbarInput(target);
						const focusState = getFocusState(view.state);
						if (focusState?.skipFocusReset) {
							view.dispatch(setFocusMeta(view.state.tr, normalizeSelectionState({
								...focusState,
								skipFocusReset: false
							})));
							return false;
						}
						if (!isToolbarBtn && !isToolbarInp) view.dispatch(setFocusMeta(view.state.tr, {
							focused: false,
							preservedSelection: null,
							showVisualSelection: false,
							skipFocusReset: false
						}));
					},
					blur: (view) => {
						const target = this.editor.options.focusTarget;
						const isElement$2 = target instanceof Element;
						const isToolbarBtn = isElement$2 && isToolbarButton(target);
						const isToolbarInp = isElement$2 && isToolbarInput(target);
						const state = getFocusState(view.state);
						if (state?.skipFocusReset) return false;
						if (isToolbarBtn || isToolbarInp) view.dispatch(setFocusMeta(view.state.tr, {
							focused: true,
							preservedSelection: state.preservedSelection || view.state.selection,
							showVisualSelection: true,
							skipFocusReset: false
						}));
						else {
							view.dispatch(setFocusMeta(view.state.tr, {
								focused: false,
								preservedSelection: null,
								showVisualSelection: false,
								skipFocusReset: false
							}));
							this.editor.setOptions({
								preservedSelection: null,
								lastSelection: null
							});
						}
					}
				},
				decorations: (state) => {
					const { selection, doc: doc$1 } = state;
					const focusState = getFocusState(state);
					if (!(focusState.showVisualSelection && (focusState.preservedSelection || !selection.empty && focusState.focused))) return null;
					const targetSelection = focusState.preservedSelection || selection;
					if (targetSelection.empty) return null;
					return DecorationSet.create(doc$1, [Decoration.inline(targetSelection.from, targetSelection.to, { class: "sd-custom-selection" })]);
				}
			}
		})];
	},
	addCommands() {
		return { restorePreservedSelection: () => ({ tr, state }) => {
			const focusState = getFocusState(state);
			if (focusState.preservedSelection) return tr.setSelection(focusState.preservedSelection);
			const lastSelection = this.editor.options.lastSelection;
			if (lastSelection) return tr.setSelection(lastSelection);
			return tr;
		} };
	}
});
function applySelectionCleanup(editor, tr) {
	let cleaned = tr.setMeta(CustomSelectionPluginKey, DEFAULT_SELECTION_STATE);
	const sel = cleaned.selection;
	if (sel && sel instanceof TextSelection && !sel.empty) try {
		const collapsed = TextSelection.create(cleaned.doc, sel.head);
		cleaned = cleaned.setSelection(collapsed);
	} catch {}
	editor.setOptions({
		preservedSelection: null,
		lastSelection: null
	});
	return cleaned;
}
function createHistoryDispatch(editor, dispatch, inputType) {
	if (!dispatch) return dispatch;
	return (historyTr) => {
		let cleaned = applySelectionCleanup(editor, historyTr);
		if (inputType) cleaned = cleaned.setMeta("inputType", inputType);
		dispatch(cleaned);
	};
}
function runSelectionCleanupAfterCollabHistory(editor) {
	const view = editor?.view;
	const state = editor?.state;
	if (!view || !state) return;
	let tr = applySelectionCleanup(editor, state.tr);
	tr = tr.setMeta("addToHistory", false);
	view.dispatch(tr);
}
function getPresentationHistoryProxy(editor) {
	const presentationEditor = editor?.presentationEditor ?? editor?._presentationEditor ?? null;
	if (!presentationEditor || typeof presentationEditor.getActiveEditor !== "function") return null;
	return presentationEditor.getActiveEditor() === editor ? presentationEditor : null;
}
function resolveHistoryDispatch(editor, allowDispatch) {
	if (!allowDispatch) return;
	return editor?.view?.dispatch?.bind(editor.view) ?? editor?.dispatch?.bind(editor);
}
function runEditorUndo(editor, options = {}) {
	const state = editor?.state;
	const tr = state?.tr;
	const allowDispatch = options.allowDispatch !== false;
	const inputType = "historyUndo";
	if (!state || !tr) return false;
	const dispatch = resolveHistoryDispatch(editor, allowDispatch);
	if (editor.options.collaborationProvider && editor.options.ydoc) {
		const result = undo$1(state, dispatch);
		if (allowDispatch && result) runSelectionCleanupAfterCollabHistory(editor);
		return result;
	}
	return undo(state, createHistoryDispatch(editor, dispatch, allowDispatch ? inputType : void 0));
}
function runEditorRedo(editor, options = {}) {
	const state = editor?.state;
	const tr = state?.tr;
	const allowDispatch = options.allowDispatch !== false;
	const inputType = "historyRedo";
	if (!state || !tr) return false;
	const dispatch = resolveHistoryDispatch(editor, allowDispatch);
	if (editor.options.collaborationProvider && editor.options.ydoc) {
		const result = redo$1(state, dispatch);
		if (allowDispatch && result) runSelectionCleanupAfterCollabHistory(editor);
		return result;
	}
	return redo(state, createHistoryDispatch(editor, dispatch, allowDispatch ? inputType : void 0));
}
const History = Extension.create({
	name: "history",
	addOptions() {
		return {
			depth: 100,
			newGroupDelay: 500
		};
	},
	addPmPlugins() {
		if (this.editor.options.collaborationProvider && this.editor.options.ydoc) return [createUndoPlugin()];
		return [history(this.options)];
	},
	addCommands() {
		return {
			undo: () => ({ tr, dispatch }) => {
				tr?.setMeta("preventDispatch", true);
				const allowDispatch = typeof dispatch === "function";
				const presentationEditor = getPresentationHistoryProxy(this.editor);
				if (presentationEditor) {
					if (allowDispatch && typeof presentationEditor.undo === "function") return Boolean(presentationEditor.undo());
					return typeof presentationEditor.canUndo === "function" ? Boolean(presentationEditor.canUndo()) : false;
				}
				return runEditorUndo(this.editor, { allowDispatch });
			},
			redo: () => ({ tr, dispatch }) => {
				tr?.setMeta("preventDispatch", true);
				const allowDispatch = typeof dispatch === "function";
				const presentationEditor = getPresentationHistoryProxy(this.editor);
				if (presentationEditor) {
					if (allowDispatch && typeof presentationEditor.redo === "function") return Boolean(presentationEditor.redo());
					return typeof presentationEditor.canRedo === "function" ? Boolean(presentationEditor.canRedo()) : false;
				}
				return runEditorRedo(this.editor, { allowDispatch });
			}
		};
	},
	addShortcuts() {
		return {
			"Mod-z": () => this.editor.commands.undo(),
			"Mod-Shift-z": () => this.editor.commands.redo(),
			"Mod-y": () => this.editor.commands.redo()
		};
	}
});
var createUndoPlugin = () => {
	return yUndoPlugin();
};
const Color = Extension.create({
	name: "color",
	addOptions() {
		return { types: ["textStyle"] };
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: { color: {
				default: null,
				parseDOM: (el) => cssColorToHex(el.style.color),
				renderDOM: (attrs) => {
					if (!attrs.color) return {};
					return { style: `color: ${attrs.color}` };
				}
			} }
		}];
	},
	addCommands() {
		return {
			setColor: (color) => ({ chain }) => {
				return chain().setMark("textStyle", { color }).run();
			},
			unsetColor: () => ({ chain }) => {
				return chain().setMark("textStyle", { color: null }).removeEmptyTextStyle().run();
			}
		};
	}
});
const FontFamily = Extension.create({
	name: "fontFamily",
	addOptions() {
		return { types: ["textStyle"] };
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: {
				fontFamily: {
					default: null,
					parseDOM: (el) => el.style.fontFamily?.replace(/['"]+/g, ""),
					renderDOM: (attrs) => {
						if (!attrs.fontFamily) return {};
						return { style: `font-family: ${attrs.fontFamily}` };
					}
				},
				eastAsiaFontFamily: {
					default: null,
					rendered: false
				},
				csFontFamily: {
					default: null,
					rendered: false
				}
			}
		}];
	},
	addCommands() {
		return {
			setFontFamily: (fontFamily) => ({ chain }) => {
				return chain().setMark("textStyle", { fontFamily }).run();
			},
			unsetFontFamily: () => ({ chain }) => {
				return chain().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run();
			}
		};
	}
});
const FontSize = Extension.create({
	name: "fontSize",
	addOptions() {
		return {
			types: ["textStyle", "tableCell"],
			defaults: {
				value: 12,
				unit: "pt",
				min: 8,
				max: 96
			}
		};
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: { fontSize: {
				default: null,
				parseDOM: (el) => el.style.fontSize,
				renderDOM: (attrs) => {
					if (!attrs.fontSize) return {};
					let [value, unit] = parseSizeUnit(attrs.fontSize);
					if (Number.isNaN(value)) return {};
					unit = unit ? unit : this.options.defaults.unit;
					return { style: `font-size: ${value}${unit}` };
				}
			} }
		}];
	},
	addCommands() {
		return {
			setFontSize: (fontSize) => ({ chain }) => {
				let value, unit;
				if (typeof fontSize === "number") {
					value = fontSize;
					unit = null;
				} else [value, unit] = parseSizeUnit(fontSize);
				if (Number.isNaN(value)) return false;
				let { min: min$2, max: max$2, unit: defaultUnit } = this.options.defaults;
				value = minMax(Number(value), min$2, max$2);
				unit = unit ? unit : defaultUnit;
				return chain().setMark("textStyle", { fontSize: `${value}${unit}` }).run();
			},
			unsetFontSize: () => ({ chain }) => {
				return chain().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run();
			}
		};
	}
});
const LetterSpacing = Extension.create({
	name: "letterSpacing",
	addOptions() {
		return { types: ["textStyle"] };
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: { letterSpacing: {
				default: null,
				parseDOM: (el) => el.style.letterSpacing || null,
				renderDOM: (attrs) => {
					if (!attrs.letterSpacing) return {};
					const [value, unit] = parseSizeUnit(attrs.letterSpacing);
					if (Number.isNaN(value)) return {};
					return { style: `letter-spacing: ${value}${unit ?? "pt"}` };
				}
			} }
		}];
	}
});
const TextAlign = Extension.create({
	name: "textAlign",
	addOptions() {
		return { alignments: [
			"left",
			"center",
			"right",
			"justify"
		] };
	},
	addCommands() {
		return {
			setTextAlign: (alignment$1) => ({ commands: commands$1, state, tr, dispatch }) => {
				if (!this.options.alignments.includes(alignment$1)) return false;
				if (!state?.doc || !state?.selection || !tr) {
					const storedAlignment = mapDisplayAlignmentToStoredJustification(alignment$1, getSelectionParagraphProperties(this.editor, state)?.rightToLeft);
					return commands$1.updateAttributes("paragraph", { "paragraphProperties.justification": storedAlignment });
				}
				const visitedPositions = /* @__PURE__ */ new Set();
				let touched = false;
				const updateParagraph = (node, pos) => {
					if (node.type.name !== "paragraph") return true;
					if (visitedPositions.has(pos)) return false;
					visitedPositions.add(pos);
					const storedAlignment = mapDisplayAlignmentToStoredJustification(alignment$1, (this.editor ? calculateResolvedParagraphProperties(this.editor, node, state.doc.resolve(pos)) : node.attrs?.paragraphProperties ?? {})?.rightToLeft);
					const existingParagraphProperties = node.attrs?.paragraphProperties ?? {};
					if (existingParagraphProperties.justification === storedAlignment) return false;
					tr.setNodeMarkup(pos, void 0, {
						...node.attrs,
						paragraphProperties: {
							...existingParagraphProperties,
							justification: storedAlignment
						}
					});
					touched = true;
					return false;
				};
				state.selection.ranges.forEach((range) => {
					if (range.$from.pos === range.$to.pos) {
						const paragraph = getParagraphAtSelection(range.$from);
						if (paragraph) updateParagraph(paragraph.node, paragraph.pos);
						return;
					}
					state.doc.nodesBetween(range.$from.pos, range.$to.pos, updateParagraph);
				});
				if (touched && dispatch) dispatch(tr);
				return true;
			},
			unsetTextAlign: () => ({ commands: commands$1 }) => commands$1.resetAttributes("paragraph", "paragraphProperties.justification")
		};
	},
	addShortcuts() {
		return {
			"Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
			"Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
			"Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
			"Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
		};
	}
});
function getSelectionParagraphProperties(editor, state) {
	const paragraph = getParagraphAtSelection(state?.selection?.$from);
	if (!paragraph) return {};
	if (!editor || !state?.doc) return paragraph.node?.attrs?.paragraphProperties ?? {};
	return calculateResolvedParagraphProperties(editor, paragraph.node, state.doc.resolve(paragraph.pos));
}
function getParagraphAtSelection($pos) {
	if (!$pos) return null;
	for (let depth = $pos.depth; depth >= 0; depth--) {
		const node = $pos.node(depth);
		if (node?.type?.name === "paragraph") return {
			node,
			pos: depth > 0 ? $pos.before(depth) : 0
		};
	}
	return null;
}
const toggleMarkCascade = (markName, options = {}) => ({ state, chain, editor }) => {
	const { negationAttrs = { value: "0" }, isNegation = (attrs) => attrs?.value === "0" || attrs?.value === false, extendEmptyMarkRange = false } = options;
	const formattingState = getSelectionFormattingState(state, editor);
	const directMarksForType = (formattingState?.inlineMarks || []).filter((m$1) => m$1.type?.name === markName);
	const hasNegation = directMarksForType.some((m$1) => isNegation(m$1.attrs || {}));
	const hasInline = directMarksForType.some((m$1) => !isNegation(m$1.attrs || {}));
	const styleValue = formattingState?.styleRunProperties?.[markName];
	const styleOn = isRunPropertyEnabled(styleValue);
	const cmdChain = chain();
	if (hasNegation) return cmdChain.unsetMark(markName, { extendEmptyMarkRange }).run();
	if (hasInline && styleOn) return cmdChain.unsetMark(markName, { extendEmptyMarkRange }).setMark(markName, negationAttrs, { extendEmptyMarkRange }).run();
	if (hasInline) return cmdChain.unsetMark(markName, { extendEmptyMarkRange }).run();
	if (styleOn) return cmdChain.setMark(markName, negationAttrs, { extendEmptyMarkRange }).run();
	return cmdChain.setMark(markName, {}, { extendEmptyMarkRange }).run();
};
function isRunPropertyEnabled(value) {
	if (value == null) return false;
	if (typeof value === "object") {
		if ("w:val" in value) return isStyleTokenEnabled(value["w:val"]);
		if ("val" in value) return isStyleTokenEnabled(value.val);
	}
	return isStyleTokenEnabled(value);
}
function isStyleTokenEnabled(val) {
	if (val === false || val === 0) return false;
	if (typeof val === "string") {
		const normalized = val.trim().toLowerCase();
		if (!normalized) return false;
		if ([
			"0",
			"false",
			"none",
			"inherit",
			"transparent"
		].includes(normalized)) return false;
		return true;
	}
	return !!val;
}
var FORMAT_PAINTER_DOUBLE_CLICK_MS = 500;
var FORMAT_PAINTER_UI_SELECTOR = "[data-editor-ui-surface], .toolbar-dropdown-menu, .sd-toolbar-dropdown-menu, .sd-tooltip-content";
const FormatCommands = Extension.create({
	name: "formatCommands",
	addOptions() {
		return {};
	},
	addStorage() {
		return {
			storedStyle: null,
			sourceSelection: null,
			persistent: false,
			lastCopyFormatClickAt: 0,
			releaseCleanup: null,
			pointerSelecting: false,
			keyboardSelecting: false
		};
	},
	addCommands() {
		return {
			toggleMarkCascade,
			clearFormat: () => ({ chain }) => {
				return chain().clearNodes().unsetAllMarks().run();
			},
			clearMarksFormat: () => ({ chain }) => {
				return chain().unsetAllMarks().run();
			},
			clearNodesFormat: () => ({ chain }) => {
				return chain().clearNodes().run();
			},
			copyFormat: () => ({ chain }) => {
				const currentSelection = getSelectionRange(this.editor.state);
				if (!this.storage.storedStyle) {
					const marks = getMarksFromSelection(this.editor.state, this.editor);
					this.storage.storedStyle = marks;
					this.storage.sourceSelection = currentSelection;
					this.storage.persistent = false;
					this.storage.lastCopyFormatClickAt = Date.now();
					armFormatPainterRelease({
						storage: this.storage,
						editor: this.editor
					});
					return true;
				}
				if (this.storage.persistent) {
					clearFormatPainterStorage(this.storage);
					return true;
				}
				const clickedSourceAgain = isSameSelection(currentSelection, this.storage.sourceSelection);
				if (clickedSourceAgain && Date.now() - this.storage.lastCopyFormatClickAt <= FORMAT_PAINTER_DOUBLE_CLICK_MS && !this.storage.persistent) {
					this.storage.persistent = true;
					this.storage.lastCopyFormatClickAt = 0;
					return true;
				}
				if (clickedSourceAgain) {
					clearFormatPainterStorage(this.storage);
					return true;
				}
				return applyStoredFormat({
					chain,
					storage: this.storage
				});
			},
			applyStoredFormat: () => ({ chain }) => {
				return applyStoredFormat({
					chain,
					storage: this.storage
				});
			}
		};
	},
	onSelectionUpdate({ editor }) {
		const { storedStyle, sourceSelection } = this.storage;
		if (!storedStyle) return;
		const currentSelection = getSelectionRange(editor.state);
		if (editor.state.selection.empty || isSameSelection(currentSelection, sourceSelection)) return;
		if (this.storage.pointerSelecting || this.storage.keyboardSelecting) return;
		editor.commands.applyStoredFormat();
	},
	onDestroy() {
		clearFormatPainterStorage(this.storage);
	},
	addShortcuts() {
		return { "Mod-Alt-c": () => this.editor.commands.clearFormat() };
	}
});
function getSelectionRange(state) {
	const { from: from$1, to } = state.selection;
	return {
		from: from$1,
		to
	};
}
function isSameSelection(selection, otherSelection) {
	if (!selection || !otherSelection) return false;
	return selection.from === otherSelection.from && selection.to === otherSelection.to;
}
function clearFormatPainterStorage(storage) {
	storage.releaseCleanup?.();
	storage.storedStyle = null;
	storage.sourceSelection = null;
	storage.persistent = false;
	storage.lastCopyFormatClickAt = 0;
	storage.releaseCleanup = null;
	storage.pointerSelecting = false;
	storage.keyboardSelecting = false;
}
function armFormatPainterRelease({ storage, editor }) {
	if (storage.releaseCleanup) return;
	if (typeof document === "undefined" || !document?.addEventListener) return;
	const pointerDownEventName = typeof PointerEvent === "undefined" ? "mousedown" : "pointerdown";
	const pointerUpEventName = typeof PointerEvent === "undefined" ? "mouseup" : "pointerup";
	const isToolbarEvent = (event) => event?.target?.closest?.(FORMAT_PAINTER_UI_SELECTOR);
	const applyIfTargetSelected = () => {
		if (!storage.storedStyle) return;
		const selection = editor.state.selection;
		const currentSelection = getSelectionRange(editor.state);
		if (selection.empty || isSameSelection(currentSelection, storage.sourceSelection)) return;
		editor.commands.applyStoredFormat();
	};
	const handlePointerDown = (event) => {
		if (isToolbarEvent(event)) {
			storage.pointerSelecting = false;
			return;
		}
		storage.pointerSelecting = true;
	};
	const handleRelease = (event) => {
		if (isToolbarEvent(event)) {
			storage.pointerSelecting = false;
			return;
		}
		storage.pointerSelecting = false;
		applyIfTargetSelected();
	};
	const handleKeyDown$1 = (event) => {
		if (isToolbarEvent(event)) return;
		if (isFormatPainterSelectionKey(event)) storage.keyboardSelecting = true;
	};
	const handleKeyUp = () => {
		if (!storage.keyboardSelecting) return;
		storage.keyboardSelecting = false;
		applyIfTargetSelected();
	};
	document.addEventListener(pointerDownEventName, handlePointerDown, true);
	document.addEventListener(pointerUpEventName, handleRelease, true);
	document.addEventListener("keydown", handleKeyDown$1, true);
	document.addEventListener("keyup", handleKeyUp, true);
	storage.releaseCleanup = () => {
		document.removeEventListener(pointerDownEventName, handlePointerDown, true);
		document.removeEventListener(pointerUpEventName, handleRelease, true);
		document.removeEventListener("keydown", handleKeyDown$1, true);
		document.removeEventListener("keyup", handleKeyUp, true);
	};
}
function isFormatPainterSelectionKey(event) {
	if (!event?.shiftKey) return false;
	return [
		"ArrowLeft",
		"ArrowRight",
		"ArrowUp",
		"ArrowDown",
		"Home",
		"End",
		"PageUp",
		"PageDown"
	].includes(event.key);
}
function applyStoredFormat({ chain, storage }) {
	if (!storage.storedStyle) return false;
	const shouldStayActive = storage.persistent;
	try {
		if (!storage.storedStyle.length) {
			if (!shouldStayActive) clearFormatPainterStorage(storage);
			return chain().clearFormat().run();
		}
		const storedMarks = storage.storedStyle;
		const processedMarks = [];
		storedMarks.forEach((mark) => {
			const { type, attrs } = mark;
			const { name } = type;
			if (name === "textStyle") Object.keys(attrs).forEach((key) => {
				if (!attrs[key]) return;
				const attributes = {};
				attributes[key] = attrs[key];
				processedMarks.push({
					name: key,
					attrs: attributes
				});
			});
			else processedMarks.push({
				name,
				attrs
			});
		});
		const marksToCommands = {
			bold: ["setBold", "unsetBold"],
			italic: ["setItalic", "unsetItalic"],
			underline: ["setUnderline", "unsetUnderline"],
			color: [
				"setColor",
				"setColor",
				null
			],
			fontSize: ["setFontSize", "unsetFontSize"],
			fontFamily: ["setFontFamily", "unsetFontFamily"]
		};
		let result = chain();
		Object.keys(marksToCommands).forEach((key) => {
			const [setCommand, unsetCommand, defaultParam] = marksToCommands[key];
			const markToApply = processedMarks.find((mark) => mark.name === key);
			const hasEmptyAttrs = markToApply?.attrs && markToApply?.attrs[key];
			let cmd = {};
			if (!markToApply && !hasEmptyAttrs) cmd = {
				command: unsetCommand,
				argument: defaultParam
			};
			else cmd = {
				command: setCommand,
				argument: markToApply.attrs[key] || defaultParam
			};
			result = result[cmd.command](cmd.argument);
		});
		return result;
	} finally {
		if (!shouldStayActive) clearFormatPainterStorage(storage);
	}
}
function dropCursor(options = {}) {
	return new Plugin({ view(editorView) {
		return new DropCursorView(editorView, options);
	} });
}
var DropCursorView = class {
	constructor(editorView, options) {
		var _a;
		this.editorView = editorView;
		this.cursorPos = null;
		this.element = null;
		this.timeout = -1;
		this.width = (_a = options.width) !== null && _a !== void 0 ? _a : 1;
		this.color = options.color === false ? void 0 : options.color || "black";
		this.class = options.class;
		this.handlers = [
			"dragover",
			"dragend",
			"drop",
			"dragleave"
		].map((name) => {
			let handler = (e) => {
				this[name](e);
			};
			editorView.dom.addEventListener(name, handler);
			return {
				name,
				handler
			};
		});
	}
	destroy() {
		this.handlers.forEach(({ name, handler }) => this.editorView.dom.removeEventListener(name, handler));
	}
	update(editorView, prevState) {
		if (this.cursorPos != null && prevState.doc != editorView.state.doc) if (this.cursorPos > editorView.state.doc.content.size) this.setCursor(null);
		else this.updateOverlay();
	}
	setCursor(pos) {
		if (pos == this.cursorPos) return;
		this.cursorPos = pos;
		if (pos == null) {
			this.element.parentNode.removeChild(this.element);
			this.element = null;
		} else this.updateOverlay();
	}
	updateOverlay() {
		let $pos = this.editorView.state.doc.resolve(this.cursorPos);
		let isBlock = !$pos.parent.inlineContent, rect;
		let editorDOM = this.editorView.dom, editorRect = editorDOM.getBoundingClientRect();
		let scaleX = editorRect.width / editorDOM.offsetWidth, scaleY = editorRect.height / editorDOM.offsetHeight;
		if (isBlock) {
			let before = $pos.nodeBefore, after = $pos.nodeAfter;
			if (before || after) {
				let node = this.editorView.nodeDOM(this.cursorPos - (before ? before.nodeSize : 0));
				if (node) {
					let nodeRect = node.getBoundingClientRect();
					let top$1 = before ? nodeRect.bottom : nodeRect.top;
					if (before && after) top$1 = (top$1 + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2;
					let halfWidth = this.width / 2 * scaleY;
					rect = {
						left: nodeRect.left,
						right: nodeRect.right,
						top: top$1 - halfWidth,
						bottom: top$1 + halfWidth
					};
				}
			}
		}
		if (!rect) {
			let coords = this.editorView.coordsAtPos(this.cursorPos);
			let halfWidth = this.width / 2 * scaleX;
			rect = {
				left: coords.left - halfWidth,
				right: coords.left + halfWidth,
				top: coords.top,
				bottom: coords.bottom
			};
		}
		let parent = this.editorView.dom.offsetParent;
		if (!this.element) {
			this.element = parent.appendChild(document.createElement("div"));
			if (this.class) this.element.className = this.class;
			this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;";
			if (this.color) this.element.style.backgroundColor = this.color;
		}
		this.element.classList.toggle("prosemirror-dropcursor-block", isBlock);
		this.element.classList.toggle("prosemirror-dropcursor-inline", !isBlock);
		let parentLeft, parentTop;
		if (!parent || parent == document.body && getComputedStyle(parent).position == "static") {
			parentLeft = -pageXOffset;
			parentTop = -pageYOffset;
		} else {
			let rect$1 = parent.getBoundingClientRect();
			let parentScaleX = rect$1.width / parent.offsetWidth, parentScaleY = rect$1.height / parent.offsetHeight;
			parentLeft = rect$1.left - parent.scrollLeft * parentScaleX;
			parentTop = rect$1.top - parent.scrollTop * parentScaleY;
		}
		this.element.style.left = (rect.left - parentLeft) / scaleX + "px";
		this.element.style.top = (rect.top - parentTop) / scaleY + "px";
		this.element.style.width = (rect.right - rect.left) / scaleX + "px";
		this.element.style.height = (rect.bottom - rect.top) / scaleY + "px";
	}
	scheduleRemoval(timeout$1) {
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => this.setCursor(null), timeout$1);
	}
	dragover(event) {
		if (!this.editorView.editable) return;
		let pos = this.editorView.posAtCoords({
			left: event.clientX,
			top: event.clientY
		});
		let node = pos && pos.inside >= 0 && this.editorView.state.doc.nodeAt(pos.inside);
		let disableDropCursor = node && node.type.spec.disableDropCursor;
		let disabled = typeof disableDropCursor == "function" ? disableDropCursor(this.editorView, pos, event) : disableDropCursor;
		if (pos && !disabled) {
			let target = pos.pos;
			if (this.editorView.dragging && this.editorView.dragging.slice) {
				let point = dropPoint(this.editorView.state.doc, target, this.editorView.dragging.slice);
				if (point != null) target = point;
			}
			this.setCursor(target);
			this.scheduleRemoval(5e3);
		}
	}
	dragend() {
		this.scheduleRemoval(20);
	}
	drop() {
		this.scheduleRemoval(20);
	}
	dragleave(event) {
		if (!this.editorView.dom.contains(event.relatedTarget)) this.setCursor(null);
	}
};
const DropCursor = Extension.create({
	name: "dropCursor",
	addOptions() {
		return {
			color: "currentColor",
			width: 2,
			class: void 0
		};
	},
	addPmPlugins() {
		return [dropCursor(this.options)];
	}
});
var GapCursor = class GapCursor extends Selection {
	constructor($pos) {
		super($pos, $pos);
	}
	map(doc$1, mapping) {
		let $pos = doc$1.resolve(mapping.map(this.head));
		return GapCursor.valid($pos) ? new GapCursor($pos) : Selection.near($pos);
	}
	content() {
		return Slice.empty;
	}
	eq(other) {
		return other instanceof GapCursor && other.head == this.head;
	}
	toJSON() {
		return {
			type: "gapcursor",
			pos: this.head
		};
	}
	static fromJSON(doc$1, json) {
		if (typeof json.pos != "number") throw new RangeError("Invalid input for GapCursor.fromJSON");
		return new GapCursor(doc$1.resolve(json.pos));
	}
	getBookmark() {
		return new GapBookmark(this.anchor);
	}
	static valid($pos) {
		let parent = $pos.parent;
		if (parent.inlineContent || !closedBefore($pos) || !closedAfter($pos)) return false;
		let override = parent.type.spec.allowGapCursor;
		if (override != null) return override;
		let deflt = parent.contentMatchAt($pos.index()).defaultType;
		return deflt && deflt.isTextblock;
	}
	static findGapCursorFrom($pos, dir, mustMove = false) {
		search: for (;;) {
			if (!mustMove && GapCursor.valid($pos)) return $pos;
			let pos = $pos.pos, next = null;
			for (let d = $pos.depth;; d--) {
				let parent = $pos.node(d);
				if (dir > 0 ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
					next = parent.child(dir > 0 ? $pos.indexAfter(d) : $pos.index(d) - 1);
					break;
				} else if (d == 0) return null;
				pos += dir;
				let $cur = $pos.doc.resolve(pos);
				if (GapCursor.valid($cur)) return $cur;
			}
			for (;;) {
				let inside = dir > 0 ? next.firstChild : next.lastChild;
				if (!inside) {
					if (next.isAtom && !next.isText && !NodeSelection.isSelectable(next)) {
						$pos = $pos.doc.resolve(pos + next.nodeSize * dir);
						mustMove = false;
						continue search;
					}
					break;
				}
				next = inside;
				pos += dir;
				let $cur = $pos.doc.resolve(pos);
				if (GapCursor.valid($cur)) return $cur;
			}
			return null;
		}
	}
};
GapCursor.prototype.visible = false;
GapCursor.findFrom = GapCursor.findGapCursorFrom;
Selection.jsonID("gapcursor", GapCursor);
var GapBookmark = class GapBookmark {
	constructor(pos) {
		this.pos = pos;
	}
	map(mapping) {
		return new GapBookmark(mapping.map(this.pos));
	}
	resolve(doc$1) {
		let $pos = doc$1.resolve(this.pos);
		return GapCursor.valid($pos) ? new GapCursor($pos) : Selection.near($pos);
	}
};
function needsGap(type) {
	return type.isAtom || type.spec.isolating || type.spec.createGapCursor;
}
function closedBefore($pos) {
	for (let d = $pos.depth; d >= 0; d--) {
		let index = $pos.index(d), parent = $pos.node(d);
		if (index == 0) {
			if (parent.type.spec.isolating) return true;
			continue;
		}
		for (let before = parent.child(index - 1);; before = before.lastChild) {
			if (before.childCount == 0 && !before.inlineContent || needsGap(before.type)) return true;
			if (before.inlineContent) return false;
		}
	}
	return true;
}
function closedAfter($pos) {
	for (let d = $pos.depth; d >= 0; d--) {
		let index = $pos.indexAfter(d), parent = $pos.node(d);
		if (index == parent.childCount) {
			if (parent.type.spec.isolating) return true;
			continue;
		}
		for (let after = parent.child(index);; after = after.firstChild) {
			if (after.childCount == 0 && !after.inlineContent || needsGap(after.type)) return true;
			if (after.inlineContent) return false;
		}
	}
	return true;
}
function gapCursor() {
	return new Plugin({ props: {
		decorations: drawGapCursor,
		createSelectionBetween(_view, $anchor, $head) {
			return $anchor.pos == $head.pos && GapCursor.valid($head) ? new GapCursor($head) : null;
		},
		handleClick,
		handleKeyDown,
		handleDOMEvents: { beforeinput }
	} });
}
var handleKeyDown = keydownHandler({
	"ArrowLeft": arrow$1("horiz", -1),
	"ArrowRight": arrow$1("horiz", 1),
	"ArrowUp": arrow$1("vert", -1),
	"ArrowDown": arrow$1("vert", 1)
});
function arrow$1(axis, dir) {
	const dirStr = axis == "vert" ? dir > 0 ? "down" : "up" : dir > 0 ? "right" : "left";
	return function(state, dispatch, view) {
		let sel = state.selection;
		let $start = dir > 0 ? sel.$to : sel.$from, mustMove = sel.empty;
		if (sel instanceof TextSelection) {
			if (!view.endOfTextblock(dirStr) || $start.depth == 0) return false;
			mustMove = false;
			$start = state.doc.resolve(dir > 0 ? $start.after() : $start.before());
		}
		let $found = GapCursor.findGapCursorFrom($start, dir, mustMove);
		if (!$found) return false;
		if (dispatch) dispatch(state.tr.setSelection(new GapCursor($found)));
		return true;
	};
}
function handleClick(view, pos, event) {
	if (!view || !view.editable) return false;
	let $pos = view.state.doc.resolve(pos);
	if (!GapCursor.valid($pos)) return false;
	let clickPos = view.posAtCoords({
		left: event.clientX,
		top: event.clientY
	});
	if (clickPos && clickPos.inside > -1 && NodeSelection.isSelectable(view.state.doc.nodeAt(clickPos.inside))) return false;
	view.dispatch(view.state.tr.setSelection(new GapCursor($pos)));
	return true;
}
function beforeinput(view, event) {
	if (event.inputType != "insertCompositionText" || !(view.state.selection instanceof GapCursor)) return false;
	let { $from } = view.state.selection;
	let insert = $from.parent.contentMatchAt($from.index()).findWrapping(view.state.schema.nodes.text);
	if (!insert) return false;
	let frag = Fragment$1.empty;
	for (let i = insert.length - 1; i >= 0; i--) frag = Fragment$1.from(insert[i].createAndFill(null, frag));
	let tr = view.state.tr.replace($from.pos, $from.pos, new Slice(frag, 0, 0));
	tr.setSelection(TextSelection.near(tr.doc.resolve($from.pos + 1)));
	view.dispatch(tr);
	return false;
}
function drawGapCursor(state) {
	if (!(state.selection instanceof GapCursor)) return null;
	let node = document.createElement("div");
	node.className = "ProseMirror-gapcursor";
	return DecorationSet.create(state.doc, [Decoration.widget(state.selection.head, node, { key: "gapcursor" })]);
}
const Gapcursor = Extension.create({
	name: "gapCursor",
	addOptions() {
		return {};
	},
	addPmPlugins() {
		return [gapCursor()];
	},
	extendNodeSchema(extension) {
		return { allowGapCursor: callOrGet(getExtensionConfigField(extension, "allowGapCursor", {
			name: extension.name,
			options: extension.options,
			storage: extension.storage
		})) ?? null };
	}
});
function markProviderSynced(provider) {
	try {
		provider.synced = true;
	} catch {}
	try {
		provider.isSynced = true;
	} catch {}
}
function isCollaborationProviderSynced(provider) {
	return Boolean(provider && (provider.synced === true || provider.isSynced === true));
}
function onCollaborationProviderSynced(provider, onSynced) {
	if (!provider) return () => {};
	if (isCollaborationProviderSynced(provider)) {
		onSynced();
		return () => {};
	}
	const on = typeof provider.on === "function" ? provider.on.bind(provider) : null;
	const off = typeof provider.off === "function" ? provider.off.bind(provider) : null;
	if (!on) {
		onSynced();
		return () => {};
	}
	let settled = false;
	const cleanup = () => {
		if (settled) return;
		settled = true;
		off?.("synced", handleSynced);
		off?.("sync", handleSync);
	};
	const finish = () => {
		if (settled) return;
		cleanup();
		onSynced();
	};
	const handleSynced = () => {
		markProviderSynced(provider);
		finish();
	};
	const handleSync = (synced) => {
		if (synced === false) return;
		if (synced === true || isCollaborationProviderSynced(provider)) {
			markProviderSynced(provider);
			finish();
		}
	};
	on("synced", handleSynced);
	on("sync", handleSync);
	if (isCollaborationProviderSynced(provider)) finish();
	return cleanup;
}
function encodeValue(value) {
	if (value === null || value === void 0) return value;
	if (Array.isArray(value)) {
		const yArray = new Y.Array();
		const encoded = value.map(encodeValue);
		yArray.push(encoded);
		return yArray;
	}
	if (typeof value === "object") {
		const yMap = new Y.Map();
		for (const [k$1, v] of Object.entries(value)) yMap.set(k$1, encodeValue(v));
		return yMap;
	}
	return value;
}
function encodeEnvelopeToYjs(envelope) {
	const yMap = new Y.Map();
	yMap.set("v", envelope.v);
	yMap.set("clientId", envelope.clientId);
	yMap.set("data", encodeValue(envelope.data));
	return yMap;
}
function decodeValue(value) {
	if (value instanceof Y.Map) {
		const obj = {};
		for (const [k$1, v] of value.entries()) obj[k$1] = decodeValue(v);
		return obj;
	}
	if (value instanceof Y.Array) return value.toArray().map(decodeValue);
	return value;
}
function decodeYjsToEnvelope(yMap) {
	const v = yMap.get("v");
	const clientId = yMap.get("clientId");
	const rawData = yMap.get("data");
	if (typeof v !== "number" || typeof clientId !== "number") return null;
	return {
		v,
		clientId,
		data: decodeValue(rawData)
	};
}
function readEnvelopeVersion(partsMap, partId) {
	const entry = partsMap.get(partId);
	if (entry instanceof Y.Map) {
		const v = entry.get("v");
		return typeof v === "number" ? v : 0;
	}
	return 0;
}
const PARTS_MAP_KEY = "parts";
const META_MAP_KEY = "meta";
const MEDIA_MAP_KEY = "media";
const META_PARTS_SCHEMA_VERSION_KEY = "partsSchemaVersion";
const META_PARTS_MIGRATION_KEY = "partsMigration";
const META_PARTS_LAST_HYDRATED_AT_KEY = "partsLastHydratedAt";
const META_PARTS_FALLBACK_MODE_KEY = "partsFallbackMode";
const META_PARTS_CAPABILITY_KEY = "partsCapability";
const SOURCE_COLLAB_REMOTE_PARTS = "collab:remote:parts";
const SOURCE_COLLAB_REMOTE_PREFIX = "collab:remote:";
const EXCLUDED_PART_IDS = new Set(["word/document.xml"]);
const CRITICAL_PART_IDS = new Set([
	"word/styles.xml",
	"word/numbering.xml",
	"word/_rels/document.xml.rels",
	"[Content_Types].xml"
]);
function shouldSkipEvent(event) {
	return event.source.startsWith(SOURCE_COLLAB_REMOTE_PREFIX);
}
function computeNextVersion(partsMap, partId) {
	return readEnvelopeVersion(partsMap, partId) + 1;
}
function publishPart(partsMap, ydoc, partId, operation, data, state) {
	if (operation === "delete") {
		partsMap.delete(partId);
		state.lastPublishes.delete(partId);
	} else {
		const v = computeNextVersion(partsMap, partId);
		const envelope = encodeEnvelopeToYjs({
			v,
			clientId: ydoc.clientID,
			data
		});
		partsMap.set(partId, envelope);
		state.lastPublishes.set(partId, {
			v,
			time: Date.now()
		});
	}
}
function checkConcurrentOverwrite(partsMap, partId, ydoc, state, stalenessWindowMs) {
	const last = state.lastPublishes.get(partId);
	if (!last) return null;
	const gapMs = Date.now() - last.time;
	if (gapMs > stalenessWindowMs) return null;
	const currentV = readEnvelopeVersion(partsMap, partId);
	const yValue = partsMap.get(partId);
	const envelopeClientId = yValue instanceof Y.Map ? yValue.get("clientId") ?? 0 : 0;
	const versionAdvanced = currentV > last.v;
	const sameVersionDifferentWriter = currentV === last.v && envelopeClientId !== ydoc.clientID;
	if (versionAdvanced || sameVersionDifferentWriter) return {
		partId,
		localVersion: last.v,
		remoteVersion: currentV,
		remoteClientId: envelopeClientId,
		gapMs
	};
	return null;
}
function emitOverwriteTelemetry(partsMap, partId, ydoc, state, stalenessWindowMs, editor) {
	const telemetry = checkConcurrentOverwrite(partsMap, partId, ydoc, state, stalenessWindowMs);
	if (telemetry) editor.emit("parts:concurrent-overwrite", telemetry);
}
function createPartPublisher(editor, ydoc, options = {}) {
	const partsMap = ydoc.getMap(PARTS_MAP_KEY);
	const stalenessWindowMs = options.stalenessWindowMs ?? 5e3;
	const state = {
		buffer: [],
		lastPublishes: /* @__PURE__ */ new Map(),
		destroyed: false
	};
	function getCompoundDepth() {
		return editor._compoundDepth ?? 0;
	}
	function handlePartChanged(event) {
		if (state.destroyed) return;
		if (shouldSkipEvent(event)) return;
		for (const part of event.parts) {
			if (EXCLUDED_PART_IDS.has(part.partId)) continue;
			if (getCompoundDepth() > 0) {
				const data = part.operation === "delete" ? void 0 : getPart(editor, part.partId);
				state.buffer.push({
					partId: part.partId,
					operation: part.operation,
					data
				});
			} else {
				const data = part.operation === "delete" ? void 0 : getPart(editor, part.partId);
				emitOverwriteTelemetry(partsMap, part.partId, ydoc, state, stalenessWindowMs, editor);
				ydoc.transact(() => {
					publishPart(partsMap, ydoc, part.partId, part.operation, data, state);
				}, {
					event: "parts-update",
					user: editor.options.user
				});
			}
		}
	}
	function flush() {
		if (state.destroyed || state.buffer.length === 0) return;
		const buffered = state.buffer.splice(0);
		for (const entry of buffered) emitOverwriteTelemetry(partsMap, entry.partId, ydoc, state, stalenessWindowMs, editor);
		ydoc.transact(() => {
			for (const entry of buffered) {
				const data = entry.operation === "delete" ? void 0 : getPart(editor, entry.partId);
				publishPart(partsMap, ydoc, entry.partId, entry.operation, data ?? entry.data, state);
			}
		}, {
			event: "parts-update",
			user: editor.options.user
		});
	}
	function drop() {
		state.buffer.length = 0;
	}
	function destroy() {
		state.destroyed = true;
		state.buffer.length = 0;
		state.lastPublishes.clear();
	}
	return {
		handlePartChanged,
		flush,
		drop,
		destroy
	};
}
var isApplyingRemoteParts = false;
function isApplyingRemotePartChanges() {
	return isApplyingRemoteParts;
}
function createPartConsumer(editor, ydoc) {
	const partsMap = ydoc.getMap(PARTS_MAP_KEY);
	const failedParts = /* @__PURE__ */ new Map();
	const observer = (event, transaction) => {
		if (transaction.local) return;
		const operations = [];
		const relsYjsEntry = partsMap.get("word/_rels/document.xml.rels");
		const relsData = relsYjsEntry instanceof Y.Map ? decodeYjsToEnvelope(relsYjsEntry)?.data ?? null : null;
		event.changes.keys.forEach((change, key) => {
			if (EXCLUDED_PART_IDS.has(key)) return;
			const partId = key;
			const sectionId = ensureHeaderFooterSectionId(partId, relsData, editor);
			try {
				if (change.action === "delete") {
					if (hasPart(editor, partId)) operations.push({
						editor,
						partId,
						sectionId,
						operation: "delete",
						source: SOURCE_COLLAB_REMOTE_PARTS
					});
					failedParts.delete(key);
					return;
				}
				const yValue = partsMap.get(key);
				if (!(yValue instanceof Y.Map)) return;
				const envelope = decodeYjsToEnvelope(yValue);
				if (!envelope || envelope.data === void 0 || envelope.data === null) {
					console.warn(`[part-sync] Skipping invalid envelope for "${key}"`);
					return;
				}
				const prevFail = failedParts.get(key);
				if (prevFail && prevFail.v === envelope.v && prevFail.clientId === envelope.clientId) return;
				if ((hasPart(editor, partId) ? "mutate" : "create") === "mutate") operations.push({
					editor,
					partId,
					sectionId,
					operation: "mutate",
					source: SOURCE_COLLAB_REMOTE_PARTS,
					mutate: ({ part }) => {
						replacePartData(part, envelope.data);
					}
				});
				else operations.push({
					editor,
					partId,
					sectionId,
					operation: "create",
					source: SOURCE_COLLAB_REMOTE_PARTS,
					initial: envelope.data
				});
				failedParts.delete(key);
			} catch (err) {
				console.error(`[part-sync] Error processing remote part "${key}":`, err);
				trackFailure(failedParts, key, partsMap);
			}
		});
		if (operations.length === 0) return;
		isApplyingRemoteParts = true;
		try {
			mutateParts({
				editor,
				source: SOURCE_COLLAB_REMOTE_PARTS,
				operations
			});
		} catch (err) {
			console.error("[part-sync] Failed to apply remote part changes:", err);
		} finally {
			isApplyingRemoteParts = false;
		}
	};
	partsMap.observe(observer);
	return { destroy() {
		partsMap.unobserve(observer);
		failedParts.clear();
	} };
}
function replacePartData(target, source) {
	if (!target || typeof target !== "object" || !source || typeof source !== "object") return;
	const tgt = target;
	const src = source;
	for (const key of Object.keys(tgt)) if (!(key in src)) delete tgt[key];
	for (const [key, value] of Object.entries(src)) tgt[key] = value;
}
function ensureHeaderFooterSectionId(partId, relsData, editor) {
	if (!isHeaderFooterPartId(partId)) return void 0;
	const sectionId = resolveHeaderFooterRId(partId, relsData, editor) ?? partId;
	ensureHeaderFooterDescriptor(partId, sectionId);
	return sectionId;
}
function trackFailure(failedParts, key, partsMap) {
	const yValue = partsMap.get(key);
	if (yValue instanceof Y.Map) {
		const v = yValue.get("v");
		const clientId = yValue.get("clientId");
		if (typeof v === "number" && typeof clientId === "number") failedParts.set(key, {
			v,
			clientId
		});
	}
}
function isMigrationNeeded(ydoc) {
	const metaMap = ydoc.getMap(META_MAP_KEY);
	const partsMap = ydoc.getMap(PARTS_MAP_KEY);
	if (metaMap.get("partsMigration")?.status === "success") return getCandidateKeys(readDocxEntries(metaMap), partsMap).length > 0;
	return metaMap.get("docx") != null;
}
function migrateMetaDocxToParts(ydoc, options = {}) {
	const metaMap = ydoc.getMap(META_MAP_KEY);
	const partsMap = ydoc.getMap(PARTS_MAP_KEY);
	const docxEntries = readDocxEntries(metaMap);
	if (docxEntries.length === 0) return {
		migrated: false,
		partsMigrated: 0,
		error: "No meta.docx entries found"
	};
	const candidates = options.force ? docxEntries.filter((e) => !EXCLUDED_PART_IDS.has(e.name)) : getCandidateEntries(docxEntries, partsMap);
	if (candidates.length === 0) {
		updateMigrationStatus(metaMap, "success", null, ydoc);
		return {
			migrated: false,
			partsMigrated: 0,
			error: null
		};
	}
	updateMigrationStatus(metaMap, "in-progress", null, ydoc);
	const parsed = [];
	try {
		for (const entry of candidates) {
			const data = parsePartContent(entry);
			parsed.push({
				name: entry.name,
				data
			});
		}
	} catch (err) {
		const errorMsg = err instanceof Error ? err.message : String(err);
		updateMigrationStatus(metaMap, "failed", errorMsg, ydoc);
		return {
			migrated: false,
			partsMigrated: 0,
			error: errorMsg
		};
	}
	ydoc.transact(() => {
		for (const { name, data } of parsed) {
			const envelope = encodeEnvelopeToYjs({
				v: 1,
				clientId: ydoc.clientID,
				data
			});
			partsMap.set(name, envelope);
		}
		metaMap.set(META_PARTS_SCHEMA_VERSION_KEY, 1);
		const capability = {
			version: 1,
			enabledAt: (/* @__PURE__ */ new Date()).toISOString(),
			clientId: ydoc.clientID
		};
		metaMap.set(META_PARTS_CAPABILITY_KEY, capability);
	}, { event: "parts-migration" });
	updateMigrationStatus(metaMap, "success", null, ydoc);
	return {
		migrated: true,
		partsMigrated: parsed.length,
		error: null
	};
}
function readDocxEntries(metaMap) {
	const docxValue = metaMap.get("docx");
	if (!docxValue) return [];
	if (Array.isArray(docxValue)) return docxValue;
	if (typeof docxValue.toArray === "function") return docxValue.toArray();
	if (docxValue && typeof docxValue[Symbol.iterator] === "function") return Array.from(docxValue);
	return [];
}
function getCandidateKeys(docxEntries, partsMap) {
	return docxEntries.filter((e) => !EXCLUDED_PART_IDS.has(e.name) && !partsMap.has(e.name)).map((e) => e.name);
}
function getCandidateEntries(docxEntries, partsMap) {
	return docxEntries.filter((e) => !EXCLUDED_PART_IDS.has(e.name) && !partsMap.has(e.name));
}
function parsePartContent(entry) {
	if (entry.content === null || entry.content === void 0) throw new Error(`Part "${entry.name}" has no content`);
	if (typeof entry.content === "object") return entry.content;
	if (typeof entry.content === "string") return parseXmlToJson(entry.content);
	throw new Error(`Part "${entry.name}" has unsupported content type: ${typeof entry.content}`);
}
function updateMigrationStatus(metaMap, status, error, ydoc) {
	const existing = metaMap.get("partsMigration") ?? {};
	const updated = {
		status,
		attempts: (existing.attempts ?? 0) + (status === "in-progress" ? 1 : 0),
		lastAttemptAt: status === "in-progress" ? (/* @__PURE__ */ new Date()).toISOString() : existing.lastAttemptAt ?? null,
		lastSuccessAt: status === "success" ? (/* @__PURE__ */ new Date()).toISOString() : existing.lastSuccessAt ?? null,
		lastError: error,
		source: `client:${ydoc.clientID}`
	};
	metaMap.set(META_PARTS_MIGRATION_KEY, updated);
}
function seedPartsFromEditor(editor, ydoc, options) {
	const convertedXml = editor.converter?.convertedXml;
	if (!convertedXml) return;
	const partsMap = ydoc.getMap(PARTS_MAP_KEY);
	const metaMap = ydoc.getMap(META_MAP_KEY);
	const replaceExisting = options?.replaceExisting ?? false;
	const snapshotKeys = new Set(Object.keys(convertedXml).filter((key) => !EXCLUDED_PART_IDS.has(key)));
	ydoc.transact(() => {
		if (replaceExisting) {
			for (const key of [...partsMap.keys()]) if (!EXCLUDED_PART_IDS.has(key) && !snapshotKeys.has(key)) partsMap.delete(key);
		}
		for (const key of snapshotKeys) {
			if (!replaceExisting && partsMap.has(key)) continue;
			const envelope = encodeEnvelopeToYjs({
				v: 1,
				clientId: ydoc.clientID,
				data: convertedXml[key]
			});
			partsMap.set(key, envelope);
		}
		const capability = {
			version: 1,
			enabledAt: (/* @__PURE__ */ new Date()).toISOString(),
			clientId: ydoc.clientID
		};
		metaMap.set(META_PARTS_CAPABILITY_KEY, capability);
		metaMap.set(META_PARTS_SCHEMA_VERSION_KEY, 1);
	}, { event: "seed-parts" });
}
function bootstrapPartSync(editor, ydoc) {
	const metaMap = ydoc.getMap(META_MAP_KEY);
	const partsMap = ydoc.getMap(PARTS_MAP_KEY);
	const capability = metaMap.get(META_PARTS_CAPABILITY_KEY);
	let capabilityActive = capability != null && capability.version >= 1;
	if (!capabilityActive && isMigrationNeeded(ydoc)) {
		const result = migrateMetaDocxToParts(ydoc);
		if (result.migrated) capabilityActive = true;
		else if (result.error) {
			metaMap.set(META_PARTS_FALLBACK_MODE_KEY, true);
			editor.safeEmit?.("parts:degraded", {
				reason: "migration-failure",
				failures: [result.error]
			});
			editor.safeEmit?.("exception", {
				error: /* @__PURE__ */ new Error(`[part-sync] Degraded: migration from meta.docx failed. Parts sync disabled to avoid publishing non-authoritative data. Error: ${result.error}`),
				editor
			});
			console.error("[part-sync] Migration failed — entering degraded mode:", result.error);
			return createNoopHandle();
		}
	}
	if (!capabilityActive && hasNonDocumentEntries(partsMap)) {
		backfillCapability(metaMap, ydoc);
		capabilityActive = true;
		console.info("[part-sync] Backfilled partsCapability marker for existing parts data");
	}
	if (!capabilityActive) {
		const fragment = ydoc.getXmlFragment("supereditor");
		const hasRemoteState = Array.from(ydoc.store.clients.keys()).some((id) => id !== ydoc.clientID);
		if (fragment.length > 0 && hasRemoteState) {
			metaMap.set(META_PARTS_FALLBACK_MODE_KEY, true);
			editor.safeEmit?.("parts:degraded", {
				reason: "existing-room-no-parts",
				failures: ["Room has shared document content from remote clients but no parts data — cannot seed safely"]
			});
			console.warn("[part-sync] Degraded: room has Y fragment content with remote client state but no parts/meta.docx. Skipping local seed to avoid publishing non-authoritative data.");
			return createNoopHandle();
		}
		seedPartsFromEditor(editor, ydoc);
		capabilityActive = true;
		console.info("[part-sync] Seeded parts from local converter");
	}
	registerExistingHeaderFooterDescriptors(editor);
	registerHeaderFooterDescriptorsFromPartsMap(partsMap, editor);
	const hydration = hydrateFromPartsMap(editor, ydoc, partsMap);
	if (!hydration.ok) {
		metaMap.set(META_PARTS_FALLBACK_MODE_KEY, true);
		editor.safeEmit?.("parts:degraded", {
			reason: "critical-hydration-failure",
			failures: hydration.failures
		});
		editor.safeEmit?.("exception", {
			error: /* @__PURE__ */ new Error(`[part-sync] Degraded: parts sync disabled. Document sync continues but style/numbering changes will not propagate. Failed: ${hydration.failures.join(", ")}`),
			editor
		});
		console.error("[part-sync] Degraded mode — publisher/consumer NOT activated:", hydration.failures);
		return createNoopHandle();
	}
	metaMap.set(META_PARTS_LAST_HYDRATED_AT_KEY, (/* @__PURE__ */ new Date()).toISOString());
	return activateSync(editor, ydoc);
}
function activateSync(editor, ydoc) {
	const publisher = createPartPublisher(editor, ydoc);
	const partChangedHandler = (event) => {
		publisher.handlePartChanged(event);
	};
	editor.on("partChanged", partChangedHandler);
	editor._partPublisher = publisher;
	const consumer = createPartConsumer(editor, ydoc);
	return {
		publisher,
		consumer,
		destroy() {
			editor.off("partChanged", partChangedHandler);
			publisher.destroy();
			consumer.destroy();
			delete editor._partPublisher;
		}
	};
}
function hydrateFromPartsMap(editor, ydoc, partsMap) {
	const operations = [];
	const criticalFailures = [];
	const relsEntry = partsMap.get("word/_rels/document.xml.rels");
	const relsData = relsEntry instanceof Y.Map ? decodeYjsToEnvelope(relsEntry)?.data ?? null : null;
	for (const [key, value] of partsMap.entries()) {
		if (EXCLUDED_PART_IDS.has(key)) continue;
		if (!(value instanceof Y.Map)) {
			if (CRITICAL_PART_IDS.has(key)) criticalFailures.push(`${key}: entry is not a Y.Map (got ${typeof value})`);
			else console.warn(`[part-sync] Skipping non-Y.Map entry "${key}" during hydration`);
			continue;
		}
		const partId = key;
		const sectionId = isHeaderFooterPartId(key) ? resolveHeaderFooterRId(key, relsData, editor) ?? key : void 0;
		try {
			const envelope = decodeYjsToEnvelope(value);
			if (!envelope || envelope.data === void 0 || envelope.data === null) throw new Error(`Invalid envelope for "${key}"`);
			if ((hasPart(editor, partId) ? "mutate" : "create") === "mutate") operations.push({
				editor,
				partId,
				sectionId,
				operation: "mutate",
				source: SOURCE_COLLAB_REMOTE_PARTS,
				mutate: createReplacer(envelope.data)
			});
			else operations.push({
				editor,
				partId,
				sectionId,
				operation: "create",
				source: SOURCE_COLLAB_REMOTE_PARTS,
				initial: envelope.data
			});
		} catch (err) {
			const errorMsg = err instanceof Error ? err.message : String(err);
			if (CRITICAL_PART_IDS.has(key)) criticalFailures.push(`${key}: ${errorMsg}`);
			else console.warn(`[part-sync] Skipping non-critical part "${key}" during hydration:`, errorMsg);
		}
	}
	if (criticalFailures.length > 0) {
		console.error("[part-sync] Critical part hydration failures:", criticalFailures);
		return {
			ok: false,
			failures: criticalFailures
		};
	}
	if (operations.length === 0) return {
		ok: true,
		failures: []
	};
	try {
		mutateParts({
			editor,
			source: SOURCE_COLLAB_REMOTE_PARTS,
			operations
		});
		return {
			ok: true,
			failures: []
		};
	} catch (err) {
		const msg = err instanceof Error ? err.message : String(err);
		console.error("[part-sync] Hydration mutateParts failed:", err);
		return {
			ok: false,
			failures: [`mutateParts: ${msg}`]
		};
	}
}
function createNoopHandle() {
	return {
		publisher: null,
		consumer: null,
		destroy() {}
	};
}
function hasNonDocumentEntries(partsMap) {
	for (const key of partsMap.keys()) if (!EXCLUDED_PART_IDS.has(key)) return true;
	return false;
}
function registerHeaderFooterDescriptorsFromPartsMap(partsMap, editor) {
	const relsEntry = partsMap.get("word/_rels/document.xml.rels");
	const relsData = relsEntry instanceof Y.Map ? decodeYjsToEnvelope(relsEntry)?.data ?? null : null;
	for (const key of partsMap.keys()) if (isHeaderFooterPartId(key)) ensureHeaderFooterDescriptor(key, resolveHeaderFooterRId(key, relsData, editor) ?? key);
}
function backfillCapability(metaMap, ydoc) {
	const capability = {
		version: 1,
		enabledAt: (/* @__PURE__ */ new Date()).toISOString(),
		clientId: ydoc.clientID
	};
	metaMap.set(META_PARTS_CAPABILITY_KEY, capability);
}
function createReplacer(data) {
	return ({ part }) => replacePartData(part, data);
}
var SCHEMA_ATOM_NODE_NAMES = new Set(["crossReference", "citation"]);
var NORMALIZE_YJS_FRAGMENT_ORIGIN = Symbol.for("superdoc/yjs-fragment-normalize");
function normalizeYjsFragmentForSchema(fragment) {
	if (!isTraversableYjsXml(fragment)) return false;
	let changed = false;
	const normalize$1 = () => {
		changed = stripSchemaAtomChildren(fragment) || changed;
	};
	if (fragment.doc) fragment.doc.transact(normalize$1, NORMALIZE_YJS_FRAGMENT_ORIGIN);
	else normalize$1();
	return changed;
}
function normalizeYjsFragmentEventsForSchema(events, fallbackFragment) {
	if (!Array.isArray(events) || events.length === 0) return normalizeYjsFragmentForSchema(fallbackFragment);
	if (events.some((event) => event?.transaction?.origin === NORMALIZE_YJS_FRAGMENT_ORIGIN)) return false;
	let changed = false;
	const normalize$1 = () => {
		const visited = /* @__PURE__ */ new Set();
		for (const event of events) {
			const target = findNormalizableEventTarget(event?.target);
			if (!isTraversableYjsXml(target) || visited.has(target)) continue;
			visited.add(target);
			changed = stripSchemaAtomChildren(target) || changed;
		}
	};
	const doc$1 = fallbackFragment?.doc || findEventDoc(events);
	if (doc$1) doc$1.transact(normalize$1, NORMALIZE_YJS_FRAGMENT_ORIGIN);
	else normalize$1();
	return changed;
}
function stripSchemaAtomChildren(parent) {
	if (!isTraversableYjsXml(parent)) return false;
	if (parent instanceof XmlElement && SCHEMA_ATOM_NODE_NAMES.has(parent.nodeName)) return normalizeSchemaAtomElement(parent);
	let changed = false;
	for (const child of parent.toArray()) {
		if (!(child instanceof XmlElement)) continue;
		if (SCHEMA_ATOM_NODE_NAMES.has(child.nodeName)) {
			changed = normalizeSchemaAtomElement(child) || changed;
			continue;
		}
		changed = stripSchemaAtomChildren(child) || changed;
	}
	return changed;
}
function normalizeSchemaAtomElement(element) {
	let changed = false;
	if (isEmptyResolvedText(element.getAttribute("resolvedText"))) {
		const visibleText = extractVisibleXmlText(element);
		if (visibleText.length > 0) {
			element.setAttribute("resolvedText", visibleText);
			changed = true;
		}
	}
	if (element.length > 0) {
		element.delete(0, element.length);
		changed = true;
	}
	return changed;
}
function isEmptyResolvedText(value) {
	return typeof value !== "string" || value.length === 0;
}
function extractVisibleXmlText(parent) {
	let text = "";
	for (const child of parent.toArray()) if (child instanceof XmlText) text += extractVisibleTextFromXmlText(child);
	else if (child instanceof XmlElement) text += extractVisibleXmlText(child);
	return text;
}
function extractVisibleTextFromXmlText(textNode) {
	return textNode.toDelta().reduce((visibleText, op) => {
		return typeof op.insert === "string" ? visibleText + op.insert : visibleText;
	}, "");
}
function findNormalizableEventTarget(target) {
	let current = target;
	while (current) {
		if (current instanceof XmlElement && SCHEMA_ATOM_NODE_NAMES.has(current.nodeName)) return current;
		current = current.parent;
	}
	return target;
}
function findEventDoc(events) {
	for (const event of events) {
		const doc$1 = event?.target?.doc;
		if (doc$1) return doc$1;
	}
	return null;
}
function isTraversableYjsXml(value) {
	return Boolean(value && typeof value.toArray === "function");
}
new PluginKey("collaboration");
var headlessBindingStateByEditor = /* @__PURE__ */ new WeakMap();
var headlessCleanupRegisteredEditors = /* @__PURE__ */ new WeakSet();
var META_BODY_SECT_PR_KEY = "bodySectPr";
var BODY_SECT_PR_SYNC_META_KEY = "bodySectPrSync";
var collaborationCleanupByEditor = /* @__PURE__ */ new WeakMap();
var registerHeadlessBindingCleanup = (editor, cleanup) => {
	if (!cleanup || headlessCleanupRegisteredEditors.has(editor)) return;
	headlessCleanupRegisteredEditors.add(editor);
	editor.once("destroy", () => {
		cleanup();
		headlessCleanupRegisteredEditors.delete(editor);
	});
};
var cloneJsonValue$2 = (value) => {
	if (value == null) return null;
	return JSON.parse(JSON.stringify(value));
};
var serializeComparableValue = (value) => JSON.stringify(value ?? null);
var getEditorBodySectPr = (editor) => editor?.state?.doc?.attrs?.bodySectPr ?? null;
var setEditorConverterBodySectPr = (editor, bodySectPr) => {
	if (!editor?.converter) return;
	editor.converter.bodySectPr = cloneJsonValue$2(bodySectPr);
};
var syncBodySectPrToMetaMap = (ydoc, editor) => {
	const metaMap = ydoc.getMap("meta");
	const nextBodySectPr = cloneJsonValue$2(getEditorBodySectPr(editor));
	const currentMetaBodySectPr = cloneJsonValue$2(metaMap.get(META_BODY_SECT_PR_KEY) ?? null);
	setEditorConverterBodySectPr(editor, nextBodySectPr);
	if (serializeComparableValue(nextBodySectPr) === serializeComparableValue(currentMetaBodySectPr)) return false;
	metaMap.set(META_BODY_SECT_PR_KEY, nextBodySectPr);
	return true;
};
var applyBodySectPrFromMetaMap = (editor, ydoc) => {
	const nextBodySectPr = cloneJsonValue$2(ydoc.getMap("meta").get(META_BODY_SECT_PR_KEY) ?? null);
	const currentBodySectPr = cloneJsonValue$2(getEditorBodySectPr(editor));
	setEditorConverterBodySectPr(editor, nextBodySectPr);
	if (serializeComparableValue(nextBodySectPr) === serializeComparableValue(currentBodySectPr)) return false;
	if (!editor?.state?.tr) return false;
	const tr = editor.state.tr.setDocAttribute("bodySectPr", nextBodySectPr).setMeta("addToHistory", false).setMeta(BODY_SECT_PR_SYNC_META_KEY, true);
	if (typeof editor.dispatch === "function") {
		editor.dispatch(tr);
		return true;
	}
	if (typeof editor.view?.dispatch === "function") {
		editor.view.dispatch(tr);
		return true;
	}
	return false;
};
var registerBodySectPrSync = (editor, ydoc, provider, cleanupState) => {
	const metaMap = ydoc.getMap("meta");
	const metaMapObserver = (event) => {
		if (!event?.changes?.keys?.has?.(META_BODY_SECT_PR_KEY)) return;
		applyBodySectPrFromMetaMap(editor, ydoc);
	};
	metaMap.observe(metaMapObserver);
	cleanupState.metaMap = metaMap;
	cleanupState.metaMapObserver = metaMapObserver;
	const applyInitialBodySectPr = () => {
		if (editor.isDestroyed) return;
		applyBodySectPrFromMetaMap(editor, ydoc);
	};
	if (!provider) applyInitialBodySectPr();
	else cleanupState.bodySectPrPendingCleanup = onCollaborationProviderSynced(provider, applyInitialBodySectPr);
	if (typeof editor.on === "function" && !editor.options?.isHeadless) {
		const bodySectPrTransactionHandler = ({ transaction }) => {
			if (!transaction || transaction.getMeta?.(BODY_SECT_PR_SYNC_META_KEY)) return;
			if (Boolean(transaction.getMeta?.(ySyncPluginKey)?.isChangeOrigin)) {
				applyBodySectPrFromMetaMap(editor, ydoc);
				return;
			}
			const previousBodySectPr = cloneJsonValue$2(transaction.before?.attrs?.bodySectPr ?? null);
			const nextBodySectPr = cloneJsonValue$2(getEditorBodySectPr(editor));
			if (serializeComparableValue(previousBodySectPr) === serializeComparableValue(nextBodySectPr)) return;
			syncBodySectPrToMetaMap(ydoc, editor);
		};
		editor.on("transaction", bodySectPrTransactionHandler);
		cleanupState.bodySectPrTransactionHandler = bodySectPrTransactionHandler;
	}
};
const Collaboration = Extension.create({
	name: "collaboration",
	priority: 1e3,
	addOptions() {
		return {
			ydoc: null,
			field: "supereditor",
			fragment: null,
			isReady: false
		};
	},
	addPmPlugins() {
		if (!this.editor.options.ydoc) return [];
		if (collaborationCleanupByEditor.has(this.editor)) {
			const fragment$1 = this.options.fragment;
			if (fragment$1) return [ySyncPlugin(fragment$1, { onFirstRender: () => {} })];
		}
		this.options.ydoc = this.editor.options.ydoc;
		const syncListenerCleanup = initSyncListener(this.options.ydoc, this.editor, this);
		const [syncPlugin, fragment] = createSyncPlugin(this.options.ydoc, this.editor);
		this.options.fragment = fragment;
		const fragmentNormalizeCleanup = registerYjsFragmentNormalizer(fragment);
		const mediaMap = this.options.ydoc.getMap("media");
		const mediaMapObserver = (event) => {
			event.changes.keys.forEach((_$1, key) => {
				if (!(key in this.editor.storage.image.media)) {
					const fileData = mediaMap.get(key);
					this.editor.storage.image.media[key] = fileData;
				}
			});
		};
		mediaMap.observe(mediaMapObserver);
		const cleanupState = {
			syncListenerCleanup,
			mediaMap,
			mediaMapObserver,
			fragmentNormalizeCleanup,
			metaMap: null,
			metaMapObserver: null,
			partSyncHandle: null,
			partSyncPendingCleanup: null,
			bodySectPrPendingCleanup: null,
			bodySectPrTransactionHandler: null
		};
		collaborationCleanupByEditor.set(this.editor, cleanupState);
		registerBodySectPrSync(this.editor, this.options.ydoc, this.editor.options.collaborationProvider, cleanupState);
		if (typeof this.editor.on === "function") {
			const editor = this.editor;
			const ydoc = this.options.ydoc;
			const doBootstrap = () => {
				if (editor.isDestroyed) return;
				cleanupState.partSyncHandle = bootstrapPartSync(editor, ydoc);
			};
			const provider = editor.options.collaborationProvider;
			if (!provider || isCollaborationProviderSynced(provider)) doBootstrap();
			else cleanupState.partSyncPendingCleanup = onCollaborationProviderSynced(provider, doBootstrap);
		}
		if (this.editor.options.isHeadless) {
			const cleanup = initHeadlessBinding(this.editor);
			registerHeadlessBindingCleanup(this.editor, cleanup);
		}
		return [syncPlugin];
	},
	onCreate() {
		if (this.editor.options.isHeadless && this.editor.options.ydoc) {
			const cleanup = initHeadlessBinding(this.editor);
			registerHeadlessBindingCleanup(this.editor, cleanup);
		}
	},
	onDestroy() {
		cleanupCollaborationSideEffects(this.editor);
	},
	addCommands() {
		return { addImageToCollaboration: ({ mediaPath, fileData }) => () => {
			if (!this.options.ydoc || !mediaPath || !fileData) return false;
			this.options.ydoc.getMap("media").set(mediaPath, fileData);
			return true;
		} };
	}
});
const cleanupCollaborationSideEffects = (editor) => {
	const cleanup = collaborationCleanupByEditor.get(editor);
	if (!cleanup) return;
	cleanup.syncListenerCleanup?.();
	cleanup.fragmentNormalizeCleanup?.();
	cleanup.mediaMap?.unobserve?.(cleanup.mediaMapObserver);
	cleanup.metaMap?.unobserve?.(cleanup.metaMapObserver);
	cleanup.partSyncHandle?.destroy();
	cleanup.partSyncPendingCleanup?.();
	cleanup.bodySectPrPendingCleanup?.();
	if (cleanup.bodySectPrTransactionHandler && typeof editor.off === "function") editor.off("transaction", cleanup.bodySectPrTransactionHandler);
	collaborationCleanupByEditor.delete(editor);
};
const createSyncPlugin = (ydoc, editor) => {
	const fragment = ydoc.getXmlFragment("supereditor");
	normalizeYjsFragmentForSchema(fragment);
	const onFirstRender = () => {
		if (!editor.options.isNewFile) return;
		initializeMetaMap(ydoc, editor);
	};
	return [ySyncPlugin(fragment, { onFirstRender }), fragment];
};
var registerYjsFragmentNormalizer = (fragment) => {
	if (!fragment || typeof fragment.observeDeep !== "function" || typeof fragment.unobserveDeep !== "function") return () => {};
	const normalize$1 = (events) => {
		normalizeYjsFragmentEventsForSchema(events, fragment);
	};
	fragment.observeDeep(normalize$1);
	return () => {
		fragment.unobserveDeep(normalize$1);
	};
};
const initializeMetaMap = (ydoc, editor) => {
	seedPartsFromEditor(editor, ydoc);
	const mediaMap = ydoc.getMap("media");
	Object.entries(editor.options.mediaFiles).forEach(([key, value]) => {
		mediaMap.set(key, value);
	});
	syncBodySectPrToMetaMap(ydoc, editor);
	const metaMap = ydoc.getMap("meta");
	metaMap.set("fonts", editor.options.fonts);
	metaMap.set("bootstrap", {
		version: 1,
		clientId: ydoc.clientID,
		seededAt: (/* @__PURE__ */ new Date()).toISOString(),
		source: "browser"
	});
};
var initSyncListener = (ydoc, editor, extension) => {
	const provider = editor.options.collaborationProvider;
	if (!provider) return () => {};
	let cancelled = false;
	const emit = (synced) => {
		if (cancelled) return;
		if (synced === false) return;
		extension.options.isReady = true;
		editor.emit("collaborationReady", {
			editor,
			ydoc
		});
	};
	if (isCollaborationProviderSynced(provider)) {
		const timerId = setTimeout(() => {
			emit();
		}, 250);
		return () => {
			cancelled = true;
			clearTimeout(timerId);
		};
	}
	const removeProviderListeners = onCollaborationProviderSynced(provider, emit);
	return () => {
		cancelled = true;
		removeProviderListeners();
	};
};
const generateCollaborationData = async (editor) => {
	const ydoc = prosemirrorToYDoc(editor.state.doc, "supereditor");
	initializeMetaMap(ydoc, editor);
	return encodeStateAsUpdate(ydoc);
};
var initHeadlessBinding = (editor) => {
	const existing = headlessBindingStateByEditor.get(editor);
	if (existing?.cleanup) return existing.cleanup;
	const state = {
		binding: null,
		cleanup: null,
		warnedMissingBinding: false
	};
	headlessBindingStateByEditor.set(editor, state);
	const headlessViewShim = {
		get state() {
			return editor.state;
		},
		dispatch: (tr) => {
			editor.dispatch(tr);
		},
		hasFocus: () => false,
		_root: {
			getSelection: () => null,
			createRange: () => ({})
		}
	};
	const ensureInitializedBinding = () => {
		if (!editor.options.ydoc || !editor.state) return null;
		const syncState = ySyncPluginKey.getState(editor.state);
		if (!syncState?.binding) {
			if (!state.warnedMissingBinding) {
				console.warn("[Collaboration] Headless binding init: no sync state or binding found");
				state.warnedMissingBinding = true;
			}
			return null;
		}
		state.warnedMissingBinding = false;
		const binding = syncState.binding;
		if (state.binding === binding) return binding;
		binding.initView(headlessViewShim);
		if (typeof binding._forceRerender === "function") binding._forceRerender();
		if (editor.options.isNewFile) initializeMetaMap(editor.options.ydoc, editor);
		state.binding = binding;
		return binding;
	};
	const transactionHandler = ({ transaction }) => {
		if (!editor.options.ydoc) return;
		if (transaction.getMeta(ySyncPluginKey)?.isChangeOrigin) {
			applyBodySectPrFromMetaMap(editor, editor.options.ydoc);
			return;
		}
		if (transaction.getMeta?.(BODY_SECT_PR_SYNC_META_KEY)) return;
		const previousBodySectPr = cloneJsonValue$2(transaction.before?.attrs?.bodySectPr ?? null);
		const nextBodySectPr = cloneJsonValue$2(getEditorBodySectPr(editor));
		const bodySectPrChanged = serializeComparableValue(previousBodySectPr) !== serializeComparableValue(nextBodySectPr);
		const binding = ensureInitializedBinding();
		if (binding && typeof binding._prosemirrorChanged === "function") {
			const addToHistory = transaction.getMeta("addToHistory") !== false;
			if (!addToHistory) yUndoPluginKey.getState(editor.state)?.undoManager?.stopCapturing?.();
			const syncToYjs = () => {
				const ydoc = editor.options.ydoc;
				if (!ydoc) return;
				ydoc.transact((tr) => {
					tr?.meta?.set?.("addToHistory", addToHistory);
					binding._prosemirrorChanged(editor.state.doc);
				}, ySyncPluginKey);
			};
			if (typeof binding.mux === "function") binding.mux(syncToYjs);
			else syncToYjs();
		}
		if (bodySectPrChanged) syncBodySectPrToMetaMap(editor.options.ydoc, editor);
	};
	editor.on("transaction", transactionHandler);
	ensureInitializedBinding();
	state.cleanup = () => {
		editor.off("transaction", transactionHandler);
		if (headlessBindingStateByEditor.get(editor) === state) headlessBindingStateByEditor.delete(editor);
		headlessCleanupRegisteredEditors.delete(editor);
	};
	return state.cleanup;
};
var FRAGMENT_NAME = "supereditor";
function seedEditorStateToYDoc(editor, targetYdoc) {
	replaceFragment(editor, targetYdoc);
	seedPartsFromEditor(editor, targetYdoc, { replaceExisting: true });
	replaceMedia(editor, targetYdoc);
	writeDocumentMetadata(editor, targetYdoc);
	clearLegacyContent(targetYdoc);
}
function replaceFragment(editor, targetYdoc) {
	const fragment = targetYdoc.getXmlFragment(FRAGMENT_NAME);
	if (fragment.length > 0) targetYdoc.transact(() => {
		fragment.delete(0, fragment.length);
	});
	const tempYdoc = prosemirrorToYDoc(editor.state.doc, FRAGMENT_NAME);
	try {
		Y.applyUpdate(targetYdoc, Y.encodeStateAsUpdate(tempYdoc));
	} finally {
		tempYdoc.destroy();
	}
}
function replaceMedia(editor, targetYdoc) {
	const mediaFiles = editor.options.mediaFiles;
	const mediaMap = targetYdoc.getMap(MEDIA_MAP_KEY);
	targetYdoc.transact(() => {
		for (const key of [...mediaMap.keys()]) if (!mediaFiles || !(key in mediaFiles)) mediaMap.delete(key);
		if (mediaFiles) for (const [key, value] of Object.entries(mediaFiles)) mediaMap.set(key, value);
	});
}
function writeDocumentMetadata(editor, targetYdoc) {
	const metaMap = targetYdoc.getMap(META_MAP_KEY);
	targetYdoc.transact(() => {
		const bodySectPr = editor.state?.doc?.attrs?.bodySectPr ?? null;
		metaMap.set("bodySectPr", bodySectPr ? JSON.parse(JSON.stringify(bodySectPr)) : null);
		const fonts = editor.options.fonts ?? null;
		metaMap.set("fonts", fonts);
		metaMap.set("bootstrap", {
			version: 1,
			clientId: targetYdoc.clientID,
			seededAt: (/* @__PURE__ */ new Date()).toISOString(),
			source: "upgrade"
		});
	});
}
function clearLegacyContent(targetYdoc) {
	const metaMap = targetYdoc.getMap(META_MAP_KEY);
	if (metaMap.has("docx")) metaMap.delete("docx");
}
const CollaborationCursor = Extension.create({
	name: "collaborationCursor",
	priority: 999,
	addOptions() {
		return {
			provider: null,
			user: {
				name: null,
				color: null
			}
		};
	},
	addStorage() {
		return { users: [] };
	},
	addPmPlugins() {
		const { collaborationProvider: provider = null } = this.editor.options;
		if (!provider) return [];
		return [yCursorPlugin(provider.awareness, { cursorBuilder: customCursors })];
	}
});
var customCursors = (user) => {
	const cursor = document.createElement("span");
	cursor.classList.add("ProseMirror-yjs-cursor");
	cursor.setAttribute("style", `border-color: ${user.color}`);
	const userDiv = document.createElement("div");
	userDiv.setAttribute("style", `background-color: ${user.color}`);
	userDiv.insertBefore(document.createTextNode(user.name || user.email), null);
	cursor.insertBefore(userDiv, null);
	return cursor;
};
const AiMarkName = "aiMark";
const AiAnimationMarkName = "aiAnimationMark";
const AiLoaderNodeName = "aiLoaderNode";
var Attribute = class {
	static getAttributesFromExtensions(extensions) {
		const extensionAttributes = [];
		const defaultAttribute = {
			default: null,
			rendered: true,
			renderDOM: null,
			parseDOM: null,
			keepOnSplit: true
		};
		const globalAttributes = this.#getGlobalAttributes(extensions, defaultAttribute);
		const nodeAndMarksAttributes = this.#getNodeAndMarksAttributes(extensions, defaultAttribute);
		extensionAttributes.push(...globalAttributes, ...nodeAndMarksAttributes);
		return extensionAttributes;
	}
	static #getGlobalAttributes(extensions, defaultAttribute) {
		const extensionAttributes = [];
		const collectAttribute = (globalAttr) => {
			for (const type of globalAttr.types) {
				const entries = Object.entries(globalAttr.attributes);
				for (const [name, attribute] of entries) extensionAttributes.push({
					type,
					name,
					attribute: {
						...defaultAttribute,
						...attribute
					}
				});
			}
		};
		for (const extension of extensions) {
			const addGlobalAttributes = getExtensionConfigField(extension, "addGlobalAttributes", {
				name: extension.name,
				options: extension.options,
				storage: extension.storage
			});
			if (!addGlobalAttributes) continue;
			const globalAttributes = addGlobalAttributes();
			for (const globalAttr of globalAttributes) collectAttribute(globalAttr);
		}
		return extensionAttributes;
	}
	static #getNodeAndMarksAttributes(extensions, defaultAttribute) {
		const extensionAttributes = [];
		const nodeAndMarkExtensions = extensions.filter((e) => {
			return e.type === "node" || e.type === "mark";
		});
		for (const extension of nodeAndMarkExtensions) {
			const addAttributes = getExtensionConfigField(extension, "addAttributes", {
				name: extension.name,
				options: extension.options,
				storage: extension.storage
			});
			if (!addAttributes) continue;
			const attributes = addAttributes();
			for (const [name, attribute] of Object.entries(attributes)) {
				const merged = {
					...defaultAttribute,
					...attribute
				};
				if (typeof merged.default === "function") merged.default = merged.default();
				extensionAttributes.push({
					type: extension.name,
					name,
					attribute: merged
				});
			}
		}
		return extensionAttributes;
	}
	static insertExtensionAttrsToParseRule(parseRule, extensionAttrs) {
		if ("style" in parseRule) return parseRule;
		return {
			...parseRule,
			getAttrs: (node) => {
				const oldAttrs = parseRule.getAttrs ? parseRule.getAttrs(node) : parseRule.attrs;
				if (oldAttrs === false) return false;
				const parseFromString = (value) => {
					if (typeof value !== "string") return value;
					if (value.match(/^[+-]?(\d*\.)?\d+$/)) return Number(value);
					if (value === "true") return true;
					if (value === "false") return false;
					return value;
				};
				let newAttrs = {};
				for (const item of extensionAttrs) {
					const value = item.attribute.parseDOM ? item.attribute.parseDOM(node) : parseFromString(node.getAttribute(item.name));
					if (value === null || value === void 0) continue;
					newAttrs = {
						...newAttrs,
						[item.name]: value
					};
				}
				return {
					...oldAttrs,
					...newAttrs
				};
			}
		};
	}
	static getAttributesToRender(nodeOrMark, extensionAttrs) {
		const attributes = extensionAttrs.filter((item) => item.attribute.rendered).map((item) => {
			if (!item.attribute.renderDOM) return { [item.name]: nodeOrMark.attrs[item.name] };
			return item.attribute.renderDOM(nodeOrMark.attrs) || {};
		});
		let mergedAttrs = {};
		for (const attribute of attributes) mergedAttrs = this.mergeAttributes(mergedAttrs, attribute);
		return mergedAttrs;
	}
	static mergeAttributes(...objects) {
		const items = objects.filter((item) => !!item);
		let attrs = {};
		for (const item of items) {
			const mergedAttributes = { ...attrs };
			for (const [key, value] of Object.entries(item)) {
				if (!mergedAttributes[key]) {
					mergedAttributes[key] = value;
					continue;
				}
				if (key === "class") {
					const valueStr = typeof value === "string" ? value : String(value);
					const existingStr = typeof mergedAttributes[key] === "string" ? mergedAttributes[key] : String(mergedAttributes[key] || "");
					const valueClasses = valueStr ? valueStr.split(" ") : [];
					const existingClasses = existingStr ? existingStr.split(" ") : [];
					const insertClasses = valueClasses.filter((value$1) => !existingClasses.includes(value$1));
					mergedAttributes[key] = [...existingClasses, ...insertClasses].join(" ");
				} else if (key === "style") mergedAttributes[key] = [mergedAttributes[key], value].join("; ");
				else mergedAttributes[key] = value;
			}
			attrs = mergedAttributes;
		}
		return attrs;
	}
	static getSplittedAttributes(extensionAttrs, typeName, attributes) {
		const entries = Object.entries(attributes).filter(([name]) => {
			const extensionAttr = extensionAttrs.find((item) => {
				return item.type === typeName && item.name === name;
			});
			if (!extensionAttr) return false;
			return extensionAttr.attribute.keepOnSplit;
		});
		return Object.fromEntries(entries);
	}
	static getMarkAttributes(state, typeOrName) {
		const type = getMarkType(typeOrName, state.schema);
		const mark = getMarksFromSelection(state).find((markItem) => markItem.type.name === type.name);
		if (!mark) return {};
		return { ...mark.attrs };
	}
	static getNodeAttributes(state, typeOrName) {
		const type = getNodeType(typeOrName, state.schema);
		const { from: from$1, to } = state.selection;
		const nodes = [];
		state.doc.nodesBetween(from$1, to, (node$1) => {
			nodes.push(node$1);
		});
		const node = nodes.reverse().find((nodeItem) => nodeItem.type.name === type.name);
		if (!node) return {};
		return { ...node.attrs };
	}
	static getAttributes(state, typeOrName) {
		const schemaType = getSchemaTypeNameByName(typeof typeOrName === "string" ? typeOrName : typeOrName.name, state.schema);
		if (schemaType === "node") return this.getNodeAttributes(state, typeOrName);
		if (schemaType === "mark") return this.getMarkAttributes(state, typeOrName);
		return {};
	}
};
const AiMark = Mark.create({
	name: AiMarkName,
	group: "ai",
	inclusive: false,
	excludeFromSummaryJSON: true,
	addOptions() {
		return { htmlAttributes: { class: "sd-ai-highlight" } };
	},
	addAttributes() {
		return { id: {
			default: null,
			rendered: false
		} };
	},
	parseDOM() {
		return [{ tag: AiMarkName }];
	},
	renderDOM({ htmlAttributes }) {
		return [AiMarkName, Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes)];
	}
});
const AiAnimationMark = Mark.create({
	name: AiAnimationMarkName,
	group: "ai",
	inclusive: false,
	spanning: false,
	excludes: AiAnimationMarkName,
	excludeFromSummaryJSON: true,
	addOptions() {
		return { htmlAttributes: {} };
	},
	addAttributes() {
		return {
			id: {
				default: null,
				rendered: false
			},
			class: {
				default: null,
				rendered: true
			},
			dataMarkId: {
				default: null,
				rendered: true
			}
		};
	},
	parseDOM() {
		return [{ tag: AiAnimationMarkName }];
	},
	renderDOM({ htmlAttributes }) {
		return [AiAnimationMarkName, Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes)];
	}
});
var dots_loader_default = "data:image/svg+xml,%3csvg%20fill='hsla(278,%2077.40%25,%2020.80%25,%200.65)'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='4'%20cy='12'%20r='0'%3e%3canimate%20begin='0;spinner_z0Or.end'%20attributeName='r'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='0;3'%20fill='freeze'/%3e%3canimate%20begin='spinner_OLMs.end'%20attributeName='cx'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='4;12'%20fill='freeze'/%3e%3canimate%20begin='spinner_UHR2.end'%20attributeName='cx'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='12;20'%20fill='freeze'/%3e%3canimate%20id='spinner_lo66'%20begin='spinner_Aguh.end'%20attributeName='r'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='3;0'%20fill='freeze'/%3e%3canimate%20id='spinner_z0Or'%20begin='spinner_lo66.end'%20attributeName='cx'%20dur='0.001s'%20values='20;4'%20fill='freeze'/%3e%3c/circle%3e%3ccircle%20cx='4'%20cy='12'%20r='3'%3e%3canimate%20begin='0;spinner_z0Or.end'%20attributeName='cx'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='4;12'%20fill='freeze'/%3e%3canimate%20begin='spinner_OLMs.end'%20attributeName='cx'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='12;20'%20fill='freeze'/%3e%3canimate%20id='spinner_JsnR'%20begin='spinner_UHR2.end'%20attributeName='r'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='3;0'%20fill='freeze'/%3e%3canimate%20id='spinner_Aguh'%20begin='spinner_JsnR.end'%20attributeName='cx'%20dur='0.001s'%20values='20;4'%20fill='freeze'/%3e%3canimate%20begin='spinner_Aguh.end'%20attributeName='r'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='0;3'%20fill='freeze'/%3e%3c/circle%3e%3ccircle%20cx='12'%20cy='12'%20r='3'%3e%3canimate%20begin='0;spinner_z0Or.end'%20attributeName='cx'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='12;20'%20fill='freeze'/%3e%3canimate%20id='spinner_hSjk'%20begin='spinner_OLMs.end'%20attributeName='r'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='3;0'%20fill='freeze'/%3e%3canimate%20id='spinner_UHR2'%20begin='spinner_hSjk.end'%20attributeName='cx'%20dur='0.001s'%20values='20;4'%20fill='freeze'/%3e%3canimate%20begin='spinner_UHR2.end'%20attributeName='r'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='0;3'%20fill='freeze'/%3e%3canimate%20begin='spinner_Aguh.end'%20attributeName='cx'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='4;12'%20fill='freeze'/%3e%3c/circle%3e%3ccircle%20cx='20'%20cy='12'%20r='3'%3e%3canimate%20id='spinner_4v5M'%20begin='0;spinner_z0Or.end'%20attributeName='r'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='3;0'%20fill='freeze'/%3e%3canimate%20id='spinner_OLMs'%20begin='spinner_4v5M.end'%20attributeName='cx'%20dur='0.001s'%20values='20;4'%20fill='freeze'/%3e%3canimate%20begin='spinner_OLMs.end'%20attributeName='r'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='0;3'%20fill='freeze'/%3e%3canimate%20begin='spinner_UHR2.end'%20attributeName='cx'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='4;12'%20fill='freeze'/%3e%3canimate%20begin='spinner_Aguh.end'%20attributeName='cx'%20calcMode='spline'%20dur='0.5s'%20keySplines='.36,.6,.31,1'%20values='12;20'%20fill='freeze'/%3e%3c/circle%3e%3c/svg%3e";
const AiLoaderNode = Node$1.create({
	name: AiLoaderNodeName,
	excludeFromSummaryJSON: true,
	group: "inline",
	inline: true,
	atom: true,
	selectable: false,
	draggable: false,
	addOptions() {
		return { htmlAttributes: {
			class: "sd-ai-loader",
			contentEditable: "false",
			"aria-label": "AI loader node"
		} };
	},
	parseDOM() {
		return [{ tag: "span.sd-ai-loader" }];
	},
	renderDOM({ htmlAttributes }) {
		const span = document.createElement("span");
		Object.entries(Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes)).forEach(([k$1, v]) => span.setAttribute(k$1, v));
		const img = document.createElement("img");
		img.src = dots_loader_default;
		img.alt = "loading...";
		img.width = 100;
		img.height = 50;
		span.appendChild(img);
		return span;
	}
});
const AiPluginKey = new PluginKey("ai");
const AiPlugin = Extension.create({
	name: "ai",
	addCommands() {
		return {
			insertAiMark: () => ({ tr, dispatch }) => {
				const { selection } = tr;
				const { $from, $to } = selection;
				if ($from.pos === $to.pos) return false;
				tr.addMark($from.pos, $to.pos, this.editor.schema.marks[AiMarkName].create({ id: "ai-highlight" }));
				if (dispatch) dispatch(tr);
				return true;
			},
			removeSelectionAfterAiPulse: () => ({ tr, dispatch, state }) => {
				const { selection } = tr;
				const { $to } = selection;
				tr.setSelection(state.selection.constructor.create(tr.doc, $to.pos, $to.pos));
				if (dispatch) dispatch(tr);
				return true;
			},
			updateAiHighlightStyle: (className) => ({ tr, dispatch }) => {
				tr.setMeta(AiPluginKey, {
					type: "updateStyle",
					className
				});
				if (dispatch) dispatch(tr);
				return true;
			},
			clearAiHighlightStyle: () => ({ tr, dispatch }) => {
				tr.setMeta(AiPluginKey, {
					type: "updateStyle",
					className: null
				});
				if (dispatch) dispatch(tr);
				return true;
			},
			removeAiMark: (markName = AiMarkName) => ({ tr, dispatch, state }) => {
				const { doc: doc$1 } = state;
				let markFound = false;
				doc$1.descendants((node, pos) => {
					const { marks = [] } = node;
					if (marks.find((mark) => mark.type.name === markName)) {
						markFound = true;
						tr.removeMark(pos, pos + node.nodeSize, state.schema.marks[markName]);
					}
				});
				if (markFound) {
					if (dispatch) dispatch(tr);
					return true;
				}
				return false;
			},
			removeAiNode: (nodeName = AiLoaderNodeName) => ({ tr, dispatch, state }) => {
				const { doc: doc$1 } = state;
				const positions = [];
				doc$1.descendants((node, pos) => {
					if (node.type.name === nodeName) positions.push(pos);
				});
				if (positions.length === 0) return false;
				positions.sort((a, b$1) => b$1 - a);
				positions.forEach((pos) => {
					const node = doc$1.nodeAt(pos);
					if (node) tr.delete(pos, pos + node.nodeSize);
				});
				if (dispatch) dispatch(tr);
				return true;
			}
		};
	},
	addPmPlugins() {
		const editor = this.editor;
		return [new Plugin({
			key: AiPluginKey,
			state: {
				init() {
					return {
						decorations: DecorationSet.empty,
						highlightColor: "#6366f1",
						customClass: null
					};
				},
				apply(tr, oldState, _$1, newEditorState) {
					const meta = tr.getMeta(AiPluginKey);
					let customClass = oldState.customClass;
					if (meta && meta.type === "updateStyle") customClass = meta.className;
					if (tr.docChanged && customClass === "sd-ai-highlight-pulse") {
						let hasTextChanges = false;
						tr.steps.forEach((step) => {
							if (step.slice && step.slice.content.size > 0) hasTextChanges = true;
						});
						if (hasTextChanges) customClass = null;
					}
					if (!tr.docChanged && !meta) return oldState;
					const { decorations } = processAiHighlights(editor, newEditorState.doc, oldState.highlightColor, customClass) || {};
					const decorationSet = DecorationSet.create(newEditorState.doc, decorations);
					return {
						...oldState,
						decorations: decorationSet,
						customClass
					};
				}
			},
			props: { decorations(state) {
				return this.getState(state).decorations;
			} }
		})];
	}
});
var processAiHighlights = (editor, doc$1, highlightColor, customClass = null) => {
	const decorations = [];
	doc$1.descendants((node, pos) => {
		const { marks = [] } = node;
		if (marks.find((mark) => mark.type.name === "aiMark")) {
			const attrs = {
				style: `background-color: ${highlightColor}33; border-radius: 4px; transition: background-color 250ms ease;`,
				class: "sd-ai-highlight-element"
			};
			if (customClass) attrs.class += ` ${customClass}`;
			const deco = Decoration.inline(pos, pos + node.nodeSize, attrs);
			decorations.push(deco);
		}
	});
	return { decorations };
};
function getEditorSurfaceElement(editor) {
	if (!editor) return null;
	if (typeof editor.hitTest === "function" && editor.element instanceof HTMLElement) return editor.element;
	const parentEditor = editor.options?.parentEditor ?? null;
	return (editor.presentationEditor ?? parentEditor?.presentationEditor ?? parentEditor?._presentationEditor ?? null)?.element ?? editor.view?.dom ?? editor.options?.element ?? null;
}
function getSurfaceRelativePoint(editor, eventLocation = {}) {
	const surface = getEditorSurfaceElement(editor);
	if (!surface) return null;
	const rect = surface.getBoundingClientRect();
	let left$1;
	let top$1;
	if (typeof eventLocation.clientX === "number" && typeof eventLocation.clientY === "number") {
		left$1 = eventLocation.clientX - rect.left;
		top$1 = eventLocation.clientY - rect.top;
	} else if (editor?.state?.selection) {
		const selectionFrom = editor.state.selection.from;
		const coords = editor.coordsAtPos?.(selectionFrom);
		if (coords) {
			left$1 = coords.left - rect.left;
			top$1 = coords.top - rect.top;
		}
	}
	if (!Number.isFinite(left$1) || !Number.isFinite(top$1)) return null;
	return {
		left: left$1,
		top: top$1
	};
}
function findContainingBlockAncestor(element) {
	if (!element) return null;
	let current = element.parentElement;
	while (current && current !== document.body && current !== document.documentElement) {
		try {
			const style = window.getComputedStyle(current);
			const transform = style.transform;
			const filter = style.filter;
			const backdropFilter = style.backdropFilter || style.webkitBackdropFilter;
			const perspective = style.perspective;
			const willChange = style.willChange;
			const contain = style.contain;
			if (transform && transform !== "none") return current;
			if (filter && filter !== "none") return current;
			if (backdropFilter && backdropFilter !== "none") return current;
			if (perspective && perspective !== "none") return current;
			if (willChange && willChange !== "auto") {
				const values = willChange.split(",").map((v) => v.trim());
				if (values.includes("transform") || values.includes("perspective")) return current;
			}
			if (contain && /paint|layout|strict|content/.test(contain)) return current;
		} catch (error) {
			console.warn("ContextMenu: Failed to get computed style for element", current, error);
		}
		current = current.parentElement;
	}
	return null;
}
const ContextMenuPluginKey = new PluginKey("contextMenu");
var MENU_OFFSET_X = 0;
var MENU_OFFSET_Y = 28;
var CONTEXT_MENU_OFFSET_X = 10;
var CONTEXT_MENU_OFFSET_Y = 10;
const ContextMenu = Extension.create({
	name: "contextMenu",
	addOptions() {
		return {};
	},
	addPmPlugins() {
		const editor = this.editor;
		if (editor.options?.isHeadless) return [];
		const isMenuDisabled = () => Boolean(editor.options?.disableContextMenu);
		const ensureStateShape = (value = {}) => ({
			open: false,
			selected: null,
			anchorPos: null,
			menuPosition: null,
			disabled: isMenuDisabled(),
			trigger: null,
			...value
		});
		return [new Plugin({
			key: ContextMenuPluginKey,
			state: {
				init: () => ensureStateShape(),
				apply(tr, value) {
					const meta = tr.getMeta(ContextMenuPluginKey);
					const disabled = isMenuDisabled();
					if (disabled) {
						if (value.open) editor.emit("contextMenu:close");
						return ensureStateShape({ disabled: true });
					}
					if (!meta) {
						if (value.disabled !== disabled) return ensureStateShape({
							...value,
							disabled
						});
						return value;
					}
					switch (meta.type) {
						case "open": {
							if (typeof meta.pos !== "number" || meta.pos < 0 || meta.pos > tr.doc.content.size) {
								console.warn("ContextMenu: Invalid position", meta.pos);
								return ensureStateShape(value);
							}
							let left$1 = 0;
							let top$1 = 0;
							let isRightClick = false;
							if (typeof meta.clientX === "number" && typeof meta.clientY === "number") {
								left$1 = meta.clientX;
								top$1 = meta.clientY;
								isRightClick = true;
							} else {
								const relativePoint = getSurfaceRelativePoint(editor, meta);
								const surface = getEditorSurfaceElement(editor);
								if (relativePoint && surface) try {
									const rect = surface.getBoundingClientRect();
									left$1 = rect.left + relativePoint.left;
									top$1 = rect.top + relativePoint.top;
								} catch (error) {
									console.warn("ContextMenu: Failed to get surface bounds", error);
									return ensureStateShape(value);
								}
								else if (surface) try {
									const rect = surface.getBoundingClientRect();
									left$1 = rect.left;
									top$1 = rect.top;
								} catch (error) {
									console.warn("ContextMenu: Failed to get surface bounds for fallback", error);
									return ensureStateShape(value);
								}
							}
							const containingBlock = findContainingBlockAncestor(getEditorSurfaceElement(editor));
							if (containingBlock) try {
								const cbRect = containingBlock.getBoundingClientRect();
								left$1 -= cbRect.left;
								top$1 -= cbRect.top;
								left$1 += containingBlock.scrollLeft || 0;
								top$1 += containingBlock.scrollTop || 0;
							} catch (error) {
								console.warn("ContextMenu: Failed to adjust for containing block", error);
							}
							const offsetX = isRightClick ? CONTEXT_MENU_OFFSET_X : MENU_OFFSET_X;
							const offsetY = isRightClick ? CONTEXT_MENU_OFFSET_Y : MENU_OFFSET_Y;
							const menuPosition = {
								left: `${left$1 + offsetX}px`,
								top: `${top$1 + offsetY}px`
							};
							const newState = {
								...value,
								open: true,
								anchorPos: meta.pos,
								menuPosition,
								trigger: isRightClick ? "rightClick" : "slash"
							};
							editor.emit("contextMenu:open", { menuPosition });
							return ensureStateShape(newState);
						}
						case "select": return ensureStateShape({
							...value,
							selected: meta.id
						});
						case "close":
							editor.emit("contextMenu:close");
							return ensureStateShape({
								...value,
								open: false,
								anchorPos: null,
								trigger: null
							});
						default: return ensureStateShape({
							...value,
							disabled
						});
					}
				}
			},
			view(editorView) {
				const updatePosition$1 = () => {
					if (isMenuDisabled()) return;
					if (ContextMenuPluginKey.getState(editorView.state).open) editorView.dispatch(editorView.state.tr.setMeta(ContextMenuPluginKey, { type: "updatePosition" }));
				};
				window.addEventListener("scroll", updatePosition$1, true);
				window.addEventListener("resize", updatePosition$1);
				return { destroy() {
					window.removeEventListener("scroll", updatePosition$1, true);
					window.removeEventListener("resize", updatePosition$1);
				} };
			},
			props: { handleKeyDown(view, event) {
				if (isMenuDisabled()) return false;
				const pluginState = this.getState(view.state);
				if (event.key === "/" && !pluginState.open) {
					const { $cursor } = view.state.selection;
					if (!$cursor) return false;
					if (!($cursor.parent.type.name === "paragraph")) return false;
					const textBefore = $cursor.parent.textContent.slice(0, $cursor.parentOffset);
					if (!(!textBefore || textBefore.endsWith(" "))) return false;
					event.preventDefault();
					view.dispatch(view.state.tr.setMeta(ContextMenuPluginKey, {
						type: "open",
						pos: $cursor.pos
					}));
					return true;
				}
				if (!pluginState.open) return false;
				if (event.key === "Backspace" || event.key === "Delete") {
					event.preventDefault();
					view.dispatch(view.state.tr.setMeta(ContextMenuPluginKey, { type: "close" }));
					return true;
				}
				if (event.key === "Escape" || event.key === "ArrowLeft") {
					const { anchorPos, trigger } = pluginState;
					event.preventDefault();
					view.dispatch(view.state.tr.setMeta(ContextMenuPluginKey, { type: "close" }));
					if (trigger === "slash" && anchorPos !== null) {
						const insertTr = view.state.tr.insertText("/", anchorPos);
						const insertedAt = anchorPos + 1;
						insertTr.setSelection(view.state.selection.constructor.near(insertTr.doc.resolve(insertedAt)));
						view.dispatch(insertTr);
						view.focus();
					}
					return true;
				}
				return false;
			} }
		})];
	}
});
var StructuredContentViewBase = class {
	node;
	view;
	getPos;
	decorations;
	innerDecorations;
	editor;
	extension;
	htmlAttributes;
	root;
	isDragging = false;
	constructor(props) {
		this.node = props.node;
		this.view = props.editor.view;
		this.getPos = props.getPos;
		this.decorations = props.decorations;
		this.innerDecorations = props.innerDecorations;
		this.editor = props.editor;
		this.extension = props.extension;
		this.htmlAttributes = props.htmlAttributes;
		this.mount(props);
	}
	mount() {}
	get dom() {
		return this.root;
	}
	get contentDOM() {
		return null;
	}
	update(node, decorations, innerDecorations) {
		if (node.type !== this.node.type) return false;
		this.node = node;
		this.decorations = decorations;
		this.innerDecorations = innerDecorations;
		this.updateHTMLAttributes();
		return true;
	}
	stopEvent(event) {
		if (!this.dom) return false;
		const target = event.target;
		if (!(this.dom.contains(target) && !this.contentDOM?.contains(target))) return false;
		const isDragEvent = event.type.startsWith("drag");
		const isDropEvent = event.type === "drop";
		if (([
			"INPUT",
			"BUTTON",
			"SELECT",
			"TEXTAREA"
		].includes(target.tagName) || target.isContentEditable) && !isDropEvent && !isDragEvent) return true;
		const { isEditable } = this.editor;
		const { isDragging } = this;
		const isDraggable = !!this.node.type.spec.draggable;
		const isSelectable = NodeSelection.isSelectable(this.node);
		const isCopyEvent = event.type === "copy";
		const isPasteEvent = event.type === "paste";
		const isCutEvent = event.type === "cut";
		const isClickEvent = event.type === "mousedown";
		const isViewingMode = this.editor?.options?.documentMode === "viewing";
		if (!isDraggable && isSelectable && isDragEvent && event.target === this.dom) event.preventDefault();
		if (isDraggable && isDragEvent && !isDragging && event.target === this.dom) {
			event.preventDefault();
			return false;
		}
		if (isViewingMode && isClickEvent && isSelectable) return true;
		if (isDraggable && isEditable && !isDragging && isClickEvent) {
			const dragHandle = target.closest("[data-drag-handle]");
			if (dragHandle && (this.dom === dragHandle || this.dom.contains(dragHandle))) {
				this.isDragging = true;
				document.addEventListener("dragend", () => {
					this.isDragging = false;
				}, { once: true });
				document.addEventListener("drop", () => {
					this.isDragging = false;
				}, { once: true });
				document.addEventListener("mouseup", () => {
					this.isDragging = false;
				}, { once: true });
			}
		}
		if (isDragging || isDropEvent || isCopyEvent || isPasteEvent || isCutEvent || isClickEvent && isSelectable) return false;
		return true;
	}
	ignoreMutation(mutation) {
		if (!this.dom || !this.contentDOM) return true;
		if (this.node.isLeaf || this.node.isAtom) return true;
		if (mutation.type === "selection") return false;
		if (this.contentDOM === mutation.target && mutation.type === "attributes") return true;
		if (this.contentDOM.contains(mutation.target)) return false;
		return true;
	}
	destroy() {
		this.dom.remove();
		this.contentDOM?.remove();
	}
	updateAttributes(attrs) {
		const pos = this.getPos();
		if (typeof pos !== "number") return;
		return this.view.dispatch(this.view.state.tr.setNodeMarkup(pos, void 0, {
			...this.node.attrs,
			...attrs
		}));
	}
	updateHTMLAttributes() {
		const { extensionService } = this.editor;
		const { attributes } = extensionService;
		const extensionAttrs = attributes.filter((i) => i.type === this.node.type.name);
		this.htmlAttributes = Attribute.getAttributesToRender(this.node, extensionAttrs);
	}
	createDragHandle() {
		const dragHandle = document.createElement("span");
		dragHandle.classList.add("sd-structured-content-draggable");
		dragHandle.draggable = true;
		dragHandle.contentEditable = "false";
		dragHandle.dataset.dragHandle = "";
		const textElement = document.createElement("span");
		textElement.textContent = this.node.attrs.alias || "Structured content";
		dragHandle.append(textElement);
		return dragHandle;
	}
	isContentLocked() {
		return isContentLockedMode(this.node.attrs.lockMode);
	}
	isSdtLocked() {
		return isSdtLockedMode(this.node.attrs.lockMode);
	}
	updateContentEditability() {
		if (this.dom) {
			this.dom.classList.toggle("sd-structured-content--content-locked", this.isContentLocked());
			this.dom.classList.toggle("sd-structured-content--sdt-locked", this.isSdtLocked());
		}
	}
	onDragStart(event) {
		const { view } = this.editor;
		const target = event.target;
		const dragHandle = target.nodeType === 3 ? target.parentElement?.closest("[data-drag-handle]") : target.closest("[data-drag-handle]");
		if (!this.dom || this.contentDOM?.contains(target) || !dragHandle) return;
		let x = 0;
		let y$1 = 0;
		if (this.dom !== dragHandle) {
			const domBox = this.dom.getBoundingClientRect();
			const handleBox = dragHandle.getBoundingClientRect();
			const offsetX = event.offsetX ?? event.nativeEvent?.offsetX;
			const offsetY = event.offsetY ?? event.nativeEvent?.offsetY;
			x = handleBox.x - domBox.x + offsetX;
			y$1 = handleBox.y - domBox.y + offsetY;
		}
		event.dataTransfer?.setDragImage(this.dom, x, y$1);
		const pos = this.getPos();
		if (typeof pos !== "number") return;
		const selection = NodeSelection.create(view.state.doc, pos);
		const transaction = view.state.tr.setSelection(selection);
		view.dispatch(transaction);
	}
};
var StructuredContentInlineView = class extends StructuredContentViewBase {
	constructor(props) {
		super(props);
	}
	mount() {
		this.buildView();
	}
	get contentDOM() {
		return this.dom?.querySelector(`.sd-structured-content__content`) || null;
	}
	createElement() {
		const element = document.createElement("span");
		element.classList.add(structuredContentClass);
		element.setAttribute("data-structured-content", "");
		const contentElement = document.createElement("span");
		contentElement.classList.add(structuredContentInnerClass);
		element.append(contentElement);
		updateDOMAttributes(element, { ...Attribute.mergeAttributes(this.htmlAttributes) });
		return {
			element,
			contentElement
		};
	}
	buildView() {
		const { element } = this.createElement();
		const dragHandle = this.createDragHandle();
		element.prepend(dragHandle);
		element.addEventListener("dragstart", (e) => this.onDragStart(e));
		this.root = element;
		this.updateContentEditability();
	}
	updateView() {
		const domAttrs = Attribute.mergeAttributes(this.htmlAttributes);
		updateDOMAttributes(this.dom, { ...domAttrs });
		this.updateContentEditability();
	}
	update(node, decorations, innerDecorations) {
		if (!super.update(node, decorations, innerDecorations)) return false;
		this.updateView();
		return true;
	}
};
var ZERO_WIDTH_MARKER_NODE_NAMES = new Set([
	"bookmarkStart",
	"bookmarkEnd",
	"commentRangeStart",
	"commentRangeEnd",
	"commentReference",
	"permStart",
	"permEnd",
	"permStartBlock",
	"permEndBlock",
	"tableOfContentsEntry",
	"indexEntry",
	"authorityEntry",
	"passthroughInline",
	"passthroughBlock"
]);
function isZeroWidthMarker(node) {
	if (node.type.name === "fieldAnnotation" && node.attrs?.hidden === true) return true;
	return ZERO_WIDTH_MARKER_NODE_NAMES.has(node.type.name);
}
function findFirstTextPosInNode(node, nodePos) {
	if (node.isText) return nodePos;
	for (let index = 0, offset$1 = 0; index < node.childCount; index += 1) {
		const child = node.child(index);
		const found = findFirstTextPosInNode(child, nodePos + 1 + offset$1);
		if (found != null) return found;
		offset$1 += child.nodeSize;
	}
	return null;
}
function findFirstContentCursorPosInNode(node, nodePos) {
	if (isZeroWidthMarker(node)) return null;
	if (node.isText || node.isAtom) return nodePos;
	if (node.isTextblock && node.childCount === 0) return nodePos + 1;
	for (let index = 0, offset$1 = 0; index < node.childCount; index += 1) {
		const child = node.child(index);
		const found = findFirstContentCursorPosInNode(child, nodePos + 1 + offset$1);
		if (found != null) return found;
		offset$1 += child.nodeSize;
	}
	if (node.isTextblock) return nodePos + 1;
	return null;
}
function findLastTextPosInNode(node, nodePos) {
	if (node.isText) return nodePos + (node.text?.length ?? 0);
	for (let index = node.childCount - 1, offset$1 = node.content.size; index >= 0; index -= 1) {
		const child = node.child(index);
		offset$1 -= child.nodeSize;
		const found = findLastTextPosInNode(child, nodePos + 1 + offset$1);
		if (found != null) return found;
	}
	return null;
}
function findLastContentCursorPosInNode(node, nodePos) {
	if (isZeroWidthMarker(node)) return null;
	if (node.isText) return nodePos + (node.text?.length ?? 0);
	if (node.isAtom) return node.isInline ? nodePos + node.nodeSize : nodePos;
	if (node.isTextblock && node.childCount === 0) return nodePos + 1;
	for (let index = node.childCount - 1, offset$1 = node.content.size; index >= 0; index -= 1) {
		const child = node.child(index);
		offset$1 -= child.nodeSize;
		const found = findLastContentCursorPosInNode(child, nodePos + 1 + offset$1);
		if (found != null) return found;
	}
	if (node.isTextblock) return nodePos + node.nodeSize - 1;
	return null;
}
var { findChildren: findChildren$1 } = helpers_exports;
var SD_BLOCK_ID_ATTRIBUTE_NAME = "sdBlockId";
var SD_BLOCK_REV_ATTRIBUTE_NAME = "sdBlockRev";
const BLOCK_NODE_METADATA_UPDATE_META = "blockNodeMetadataUpdate";
const BlockNodePluginKey = new PluginKey("blockNodePlugin");
const BlockNode = Extension.create({
	name: "blockNode",
	addCommands() {
		return {
			replaceBlockNodeById: (id, contentNode) => ({ dispatch, tr }) => {
				const blockNode = this.editor.helpers.blockNode.getBlockNodeById(id);
				if (!blockNode || blockNode.length > 1) return false;
				if (dispatch) {
					let { pos, node } = blockNode[0];
					let newPosFrom = tr.mapping.map(pos);
					let newPosTo = tr.mapping.map(pos + node.nodeSize);
					let currentNode = tr.doc.nodeAt(newPosFrom);
					if (node.eq(currentNode)) tr.replaceWith(newPosFrom, newPosTo, contentNode);
				}
				return true;
			},
			deleteBlockNodeById: (id) => ({ dispatch, tr }) => {
				const blockNode = this.editor.helpers.blockNode.getBlockNodeById(id);
				if (!blockNode || blockNode.length > 1) return false;
				if (dispatch) {
					let { pos, node } = blockNode[0];
					let newPosFrom = tr.mapping.map(pos);
					let newPosTo = tr.mapping.map(pos + node.nodeSize);
					let currentNode = tr.doc.nodeAt(newPosFrom);
					if (node.eq(currentNode)) tr.delete(newPosFrom, newPosTo);
				}
				return true;
			},
			updateBlockNodeAttributes: (id, attrs = {}) => ({ dispatch, tr }) => {
				const blockNode = this.editor.helpers.blockNode.getBlockNodeById(id);
				if (!blockNode || blockNode.length > 1) return false;
				if (dispatch) {
					let { pos, node } = blockNode[0];
					let newPos = tr.mapping.map(pos);
					let currentNode = tr.doc.nodeAt(newPos);
					if (node.eq(currentNode)) tr.setNodeMarkup(newPos, void 0, {
						...node.attrs,
						...attrs
					});
					return true;
				}
			}
		};
	},
	addHelpers() {
		return {
			getBlockNodes: () => {
				return findChildren$1(this.editor.state.doc, (node) => nodeAllowsSdBlockIdAttr(node));
			},
			getBlockNodeById: (id) => {
				return findChildren$1(this.editor.state.doc, (node) => node.attrs.sdBlockId === id);
			},
			getBlockNodesByType: (type) => {
				return findChildren$1(this.editor.state.doc, (node) => node.type.name === type);
			},
			getBlockNodesInRange: (from$1, to) => {
				let blockNodes = [];
				this.editor.state.doc.nodesBetween(from$1, to, (node, pos) => {
					if (nodeAllowsSdBlockIdAttr(node)) blockNodes.push({
						node,
						pos
					});
				});
				return blockNodes;
			}
		};
	},
	addPmPlugins() {
		let hasInitialized = false;
		const getNextBlockRev = (node) => {
			const current = node?.attrs?.[SD_BLOCK_REV_ATTRIBUTE_NAME];
			if (typeof current === "number" && Number.isFinite(current)) return current + 1;
			const parsed = Number.parseInt(current, 10);
			if (Number.isFinite(parsed)) return parsed + 1;
			return 1;
		};
		const ensureBlockRev = (node) => {
			const current = node?.attrs?.[SD_BLOCK_REV_ATTRIBUTE_NAME];
			if (typeof current === "number" && Number.isFinite(current)) return current;
			const parsed = Number.parseInt(current, 10);
			if (Number.isFinite(parsed)) return parsed;
			return 0;
		};
		const applyNodeAttrs = (tr, node, pos, nextAttrs) => {
			tr.setNodeMarkup(pos, void 0, nextAttrs, node.marks);
		};
		const ensureUniqueSdBlockId = (node, nextAttrs, seenIds) => {
			const currentId = node.attrs?.sdBlockId;
			let changed = false;
			if (nodeAllowsSdBlockIdAttr(node) && (nodeNeedsSdBlockId(node) || seenIds.has(currentId))) {
				nextAttrs.sdBlockId = v4_default();
				changed = true;
			}
			if (currentId) seenIds.add(currentId);
			return changed;
		};
		return [new Plugin({
			key: BlockNodePluginKey,
			appendTransaction: (transactions, oldState, newState) => {
				const docChanges = transactions.some((tr$1) => tr$1.docChanged && !tr$1.getMeta("blockNodeMetadataUpdate")) && !oldState.doc.eq(newState.doc);
				if (hasInitialized && !docChanges) return;
				const { tr } = newState;
				let changed = false;
				const visitedPositions = /* @__PURE__ */ new Set();
				const isYjsOrigin = transactions.some((transaction) => {
					return transaction.getMeta(ySyncPluginKey)?.isChangeOrigin;
				});
				if (!hasInitialized) {
					const seenIds = /* @__PURE__ */ new Set();
					newState.doc.descendants((node, pos) => {
						if (!nodeAllowsSdBlockIdAttr(node) && !nodeAllowsSdBlockRevAttr(node)) return;
						const nextAttrs = { ...node.attrs };
						let nodeChanged = ensureUniqueSdBlockId(node, nextAttrs, seenIds);
						if (nodeAllowsSdBlockRevAttr(node)) {
							const rev = ensureBlockRev(node);
							if (nextAttrs.sdBlockRev !== rev) {
								nextAttrs.sdBlockRev = rev;
								nodeChanged = true;
							}
						}
						if (nodeChanged) {
							applyNodeAttrs(tr, node, pos, nextAttrs);
							changed = true;
						}
					});
				} else {
					const rangesToCheck = [];
					let shouldFallbackToFullTraversal = false;
					transactions.forEach((transaction, txIndex) => {
						if (transaction.getMeta("blockNodeMetadataUpdate")) return;
						transaction.steps.forEach((step, stepIndex) => {
							const stepRanges = [];
							if (step instanceof ReplaceStep || step instanceof ReplaceAroundStep$1) step.getMap().forEach((_oldStart, _oldEnd, newStart, newEnd) => {
								if (newEnd <= newStart) {
									stepRanges.push({
										from: newStart,
										to: newStart + 1
									});
									return;
								}
								stepRanges.push({
									from: newStart,
									to: newEnd
								});
							});
							else if (step instanceof AddMarkStep || step instanceof RemoveMarkStep) {
								if (step.to > step.from) stepRanges.push({
									from: step.from,
									to: step.to
								});
							}
							stepRanges.forEach(({ from: rangeStartRaw, to: rangeEndRaw }) => {
								let rangeStart = rangeStartRaw;
								let rangeEnd = rangeEndRaw;
								for (let i = stepIndex + 1; i < transaction.steps.length; i++) {
									const laterStepMap = transaction.steps[i].getMap();
									rangeStart = laterStepMap.map(rangeStart, -1);
									rangeEnd = laterStepMap.map(rangeEnd, 1);
								}
								for (let i = txIndex + 1; i < transactions.length; i++) {
									const laterTx = transactions[i];
									rangeStart = laterTx.mapping.map(rangeStart, -1);
									rangeEnd = laterTx.mapping.map(rangeEnd, 1);
								}
								if (rangeEnd <= rangeStart) rangeEnd = rangeStart + 1;
								rangesToCheck.push({
									from: rangeStart,
									to: rangeEnd
								});
							});
						});
					});
					const docSize = newState.doc.content.size;
					const mergedRanges = mergeRanges$1(rangesToCheck, docSize);
					const seenBlockIds = /* @__PURE__ */ new Set();
					const updateNodeAt = (node, pos) => {
						if (!nodeAllowsSdBlockIdAttr(node) && !nodeAllowsSdBlockRevAttr(node)) return;
						if (visitedPositions.has(pos)) return;
						visitedPositions.add(pos);
						const nextAttrs = { ...node.attrs };
						let nodeChanged = ensureUniqueSdBlockId(node, nextAttrs, seenBlockIds);
						if (!isYjsOrigin && nodeAllowsSdBlockRevAttr(node)) {
							nextAttrs.sdBlockRev = getNextBlockRev(node);
							nodeChanged = true;
						}
						if (nodeChanged) {
							applyNodeAttrs(tr, node, pos, nextAttrs);
							changed = true;
						}
					};
					const updateBlockAncestorsAt = (pos) => {
						const safePos = Math.max(0, Math.min(pos, docSize));
						const $pos = newState.doc.resolve(safePos);
						for (let depth = $pos.depth; depth > 0; depth--) updateNodeAt($pos.node(depth), $pos.before(depth));
					};
					for (const { from: from$1, to } of mergedRanges) {
						const clampedRange = clampRange(from$1, to, docSize);
						if (!clampedRange) continue;
						const { start: safeStart, end: safeEnd } = clampedRange;
						try {
							updateBlockAncestorsAt(safeStart);
							updateBlockAncestorsAt(Math.max(safeStart, safeEnd - 1));
							updateBlockAncestorsAt(safeEnd);
							newState.doc.nodesBetween(safeStart, safeEnd, (node, pos) => {
								updateNodeAt(node, pos);
							});
						} catch (error) {
							console.warn("Block node plugin: nodesBetween failed, falling back to full traversal", error);
							shouldFallbackToFullTraversal = true;
							break;
						}
					}
					if (shouldFallbackToFullTraversal) {
						const fallbackSeenIds = /* @__PURE__ */ new Set();
						newState.doc.descendants((node, pos) => {
							if (!nodeAllowsSdBlockIdAttr(node) && !nodeAllowsSdBlockRevAttr(node)) return;
							const nextAttrs = { ...node.attrs };
							let nodeChanged = ensureUniqueSdBlockId(node, nextAttrs, fallbackSeenIds);
							if (!isYjsOrigin && nodeAllowsSdBlockRevAttr(node)) {
								nextAttrs.sdBlockRev = getNextBlockRev(node);
								nodeChanged = true;
							}
							if (nodeChanged) {
								applyNodeAttrs(tr, node, pos, nextAttrs);
								changed = true;
							}
						});
					}
				}
				if (!hasInitialized) {
					hasInitialized = true;
					if (changed) tr.setMeta("blockNodeInitialUpdate", true);
				}
				tr.setStoredMarks(newState.tr.storedMarks);
				tr.setMeta(BLOCK_NODE_METADATA_UPDATE_META, true);
				return changed ? tr : null;
			}
		})];
	}
});
const nodeAllowsSdBlockIdAttr = (node) => {
	return !!(node?.isBlock && node?.type?.spec?.attrs?.[SD_BLOCK_ID_ATTRIBUTE_NAME]);
};
const nodeAllowsSdBlockRevAttr = (node) => {
	return !!(node?.isBlock && node?.type?.spec?.attrs?.[SD_BLOCK_REV_ATTRIBUTE_NAME]);
};
const nodeNeedsSdBlockId = (node) => {
	return !node?.attrs?.[SD_BLOCK_ID_ATTRIBUTE_NAME];
};
const STRUCTURED_CONTENT_LOCK_KEY = new PluginKey("structuredContentLock");
function collectSDTNodes(doc$1) {
	const sdtNodes = [];
	doc$1.descendants((node, pos) => {
		if (node.type.name === "structuredContent" || node.type.name === "structuredContentBlock") sdtNodes.push({
			type: node.type.name,
			node,
			lockMode: node.attrs.lockMode,
			pos,
			end: pos + node.nodeSize
		});
	});
	return sdtNodes;
}
function checkLockViolation(sdtNodes, from$1, to) {
	for (const sdt of sdtNodes) {
		if (!(from$1 < sdt.end && to > sdt.pos)) continue;
		const containsSDT = from$1 <= sdt.pos && to >= sdt.end;
		const insideSDT = from$1 >= sdt.pos && to <= sdt.end;
		const crossesStart = from$1 < sdt.pos && to > sdt.pos && to < sdt.end;
		const crossesEnd = from$1 > sdt.pos && from$1 < sdt.end && to > sdt.end;
		const wouldDamageWrapper = containsSDT || crossesStart || crossesEnd;
		const wouldModifyContent = insideSDT && !containsSDT;
		const isSdtLocked = sdt.lockMode === "sdtLocked" || sdt.lockMode === "sdtContentLocked";
		const isContentLocked = sdt.lockMode === "contentLocked" || sdt.lockMode === "sdtContentLocked";
		if (isSdtLocked && wouldDamageWrapper) return {
			blocked: true,
			reason: `Cannot delete SDT wrapper (${sdt.lockMode})`
		};
		if (isContentLocked && wouldModifyContent) return {
			blocked: true,
			reason: `Cannot modify content (${sdt.lockMode})`
		};
	}
	return { blocked: false };
}
function isAtBlockSdtWrapperDeletePosition(state, sdt, pos) {
	if (sdt.type !== "structuredContentBlock") return false;
	const $pos = state.doc.resolve(pos);
	let sdtDepth = null;
	for (let depth = $pos.depth; depth > 0; depth -= 1) if ($pos.node(depth).type.name === "structuredContentBlock" && $pos.before(depth) === sdt.pos) {
		sdtDepth = depth;
		break;
	}
	if (sdtDepth == null) return false;
	const textblockDepth = sdtDepth + 1;
	if ($pos.depth < textblockDepth) return false;
	if (!$pos.node(textblockDepth).isTextblock) return false;
	if ($pos.node(textblockDepth).type.name !== "paragraph") return false;
	if ($pos.pos !== $pos.start(textblockDepth)) return false;
	return $pos.before(textblockDepth) === $pos.start(sdtDepth);
}
function selectionCoversSdtContent(sdt, from$1, to) {
	if (from$1 === sdt.pos + 1 && to === sdt.end - 1) return true;
	if (sdt.type !== "structuredContentBlock") return false;
	const contentStart = findFirstContentCursorPosInNode(sdt.node, sdt.pos);
	const contentEnd = findLastContentCursorPosInNode(sdt.node, sdt.pos);
	return contentStart != null && contentEnd != null && from$1 === contentStart && to === contentEnd;
}
function createStructuredContentLockPlugin() {
	return new Plugin({
		key: STRUCTURED_CONTENT_LOCK_KEY,
		state: {
			init(_$1, editorState) {
				return collectSDTNodes(editorState.doc);
			},
			apply(tr, cachedSDTNodes, _oldState, newState) {
				if (!tr.docChanged) return cachedSDTNodes;
				return collectSDTNodes(newState.doc);
			}
		},
		props: {
			handleKeyDown(view, event) {
				const { state } = view;
				const { selection } = state;
				const { from: from$1, to } = selection;
				const isDelete = event.key === "Delete";
				const isBackspace = event.key === "Backspace";
				const isCut = (event.metaKey || event.ctrlKey) && event.key === "x";
				if (!isDelete && !isBackspace && !isCut) return false;
				const sdtNodes = STRUCTURED_CONTENT_LOCK_KEY.getState(state);
				if (sdtNodes.length === 0) return false;
				if (from$1 !== to && !(selection instanceof NodeSelection)) {
					const exactContentSDT = sdtNodes.find((s) => selectionCoversSdtContent(s, from$1, to));
					if (exactContentSDT) {
						const isContentLocked = exactContentSDT.lockMode === "contentLocked" || exactContentSDT.lockMode === "sdtContentLocked";
						const isWrapperDeletable = exactContentSDT.lockMode !== "sdtLocked" && exactContentSDT.lockMode !== "sdtContentLocked";
						if (exactContentSDT.lockMode === "sdtContentLocked" && exactContentSDT.type === "structuredContent" && (isBackspace || isDelete)) {
							const collapsePos = isBackspace ? exactContentSDT.pos : exactContentSDT.end;
							view.dispatch(state.tr.setSelection(TextSelection.create(state.doc, collapsePos)));
							event.preventDefault();
							return true;
						}
						if (isContentLocked && isWrapperDeletable) {
							if (isCut) {
								const tr$1 = state.tr.setSelection(NodeSelection.create(state.doc, exactContentSDT.pos));
								view.dispatch(tr$1);
								return false;
							}
							const tr = state.tr.delete(exactContentSDT.pos, exactContentSDT.end);
							view.dispatch(tr);
							event.preventDefault();
							return true;
						}
					}
				}
				let affectedFrom = from$1;
				let affectedTo = to;
				if (from$1 === to) {
					const emptyInlineSDT = sdtNodes.find((s) => s.type === "structuredContent" && s.pos + 1 === from$1 && s.end - 1 === from$1);
					if ((isBackspace || isDelete) && emptyInlineSDT) {
						const isWrapperDeletable = emptyInlineSDT.lockMode !== "sdtLocked" && emptyInlineSDT.lockMode !== "sdtContentLocked";
						event.preventDefault();
						if (isWrapperDeletable) view.dispatch(state.tr.delete(emptyInlineSDT.pos, emptyInlineSDT.end));
						return true;
					}
					const blockSdtAtWrapperDeletePosition = sdtNodes.find((s) => isAtBlockSdtWrapperDeletePosition(state, s, from$1));
					if ((isBackspace || isDelete) && blockSdtAtWrapperDeletePosition) return false;
					const inlineSdtAncestor = sdtNodes.find((s) => s.type === "structuredContent" && from$1 > s.pos && from$1 < s.end);
					const inlineSdtContentEditable = inlineSdtAncestor && inlineSdtAncestor.lockMode !== "contentLocked" && inlineSdtAncestor.lockMode !== "sdtContentLocked";
					if ((isBackspace || isDelete) && inlineSdtContentEditable && selection.$from.parent.type.name === "run") {
						const deleteFrom = isBackspace ? from$1 - 1 : from$1;
						const deleteTo = isBackspace ? from$1 : from$1 + 1;
						const staysInsideInlineSdt = deleteFrom > inlineSdtAncestor.pos && deleteTo < inlineSdtAncestor.end;
						const staysInsideRun = isBackspace ? from$1 > selection.$from.start() : from$1 < selection.$from.end();
						if (staysInsideInlineSdt && staysInsideRun) {
							view.dispatch(state.tr.delete(deleteFrom, deleteTo).scrollIntoView());
							event.preventDefault();
							return true;
						}
					}
					if (isBackspace && from$1 > 0) {
						affectedFrom = from$1 - 1;
						if (sdtNodes.find((s) => s.end === from$1)) return false;
					} else if (isDelete && to < state.doc.content.size) {
						affectedTo = to + 1;
						const adjacentSDT = sdtNodes.find((s) => s.pos === to);
						if (adjacentSDT?.type === "structuredContent") return false;
						if (adjacentSDT) {
							affectedFrom = adjacentSDT.pos;
							affectedTo = adjacentSDT.end;
						}
					}
				}
				if (checkLockViolation(sdtNodes, affectedFrom, affectedTo).blocked) {
					event.preventDefault();
					return true;
				}
				return false;
			},
			handleTextInput(view, from$1, to, _text) {
				const sdtNodes = STRUCTURED_CONTENT_LOCK_KEY.getState(view.state);
				if (sdtNodes.length === 0) return false;
				if (checkLockViolation(sdtNodes, from$1, to).blocked) return true;
				return false;
			}
		},
		filterTransaction(tr, state) {
			if (!tr.docChanged) return true;
			if (tr.getMeta?.(ySyncPluginKey)) return true;
			const inputType = tr.getMeta?.("inputType");
			if (inputType === "historyUndo" || inputType === "historyRedo") return true;
			if (tr.getMeta?.("blockNodeMetadataUpdate")) return true;
			const sdtNodes = STRUCTURED_CONTENT_LOCK_KEY.getState(state);
			if (sdtNodes.length === 0) return true;
			for (const step of tr.steps) {
				if (step.from === void 0 || step.to === void 0) continue;
				if (checkLockViolation(sdtNodes, step.from, step.to).blocked) return false;
			}
			return true;
		}
	});
}
function needsEditableSlot(node, side) {
	if (!node) return true;
	const name = node.type.name;
	if (name === "hardBreak" || name === "lineBreak" || name === "structuredContent") return true;
	if (name === "run") return !(side === "before" ? node.lastChild?.isText : node.firstChild?.isText);
	return false;
}
function applyEditableSlotAtInlineBoundary(tr, pos, direction) {
	const clampedPos = Math.max(0, Math.min(pos, tr.doc.content.size));
	if (direction === "before") {
		if (!needsEditableSlot(tr.doc.resolve(clampedPos).nodeBefore, "before")) return tr.setSelection(TextSelection.create(tr.doc, clampedPos));
		tr.insertText("​", clampedPos);
		return tr.setSelection(TextSelection.create(tr.doc, clampedPos + 1));
	}
	if (!needsEditableSlot(tr.doc.nodeAt(clampedPos), "after")) return tr.setSelection(TextSelection.create(tr.doc, clampedPos));
	tr.insertText("​", clampedPos);
	return tr.setSelection(TextSelection.create(tr.doc, clampedPos + 1));
}
const SELECT_INLINE_SDT_BEFORE_RUN_START_META = "selectInlineSdtBeforeRunStart";
function getPreviousInlineSdt(state) {
	const { $from } = state.selection;
	if ($from.parent.type.name === "run" && $from.parentOffset === 0) {
		const runStart = $from.before($from.depth);
		const node$1 = state.doc.resolve(runStart).nodeBefore;
		if (node$1?.type.name !== "structuredContent") return null;
		return {
			node: node$1,
			pos: runStart - node$1.nodeSize
		};
	}
	const node = $from.nodeBefore;
	if (node?.type.name !== "structuredContent") return null;
	return {
		node,
		pos: $from.pos - node.nodeSize
	};
}
function getNextInlineSdt(state) {
	const { $from } = state.selection;
	if ($from.parent.type.name === "run" && $from.parentOffset === $from.parent.content.size) {
		const runEnd = $from.after($from.depth);
		const node$1 = state.doc.resolve(runEnd).nodeAfter;
		if (node$1?.type.name !== "structuredContent") return null;
		return {
			node: node$1,
			pos: runEnd
		};
	}
	const node = $from.nodeAfter;
	if (node?.type.name !== "structuredContent") return null;
	return {
		node,
		pos: $from.pos
	};
}
function selectInlineSdtContent(state, dispatch, sdt) {
	if (dispatch) {
		const contentStart = sdt.pos + 1;
		const contentEnd = sdt.pos + sdt.node.nodeSize - 1;
		dispatch(state.tr.setMeta(SELECT_INLINE_SDT_BEFORE_RUN_START_META, true).setSelection(TextSelection.create(state.doc, contentStart, contentEnd)));
	}
	return true;
}
const selectInlineSdtBeforeRunStart = () => ({ state, dispatch }) => {
	const { selection } = state;
	if (!selection.empty) return false;
	const previousSdt = getPreviousInlineSdt(state);
	if (!previousSdt) return false;
	return selectInlineSdtContent(state, dispatch, previousSdt);
};
const selectInlineSdtAfterRunEnd = () => ({ state, dispatch }) => {
	const { selection } = state;
	if (!selection.empty) return false;
	const nextSdt = getNextInlineSdt(state);
	if (!nextSdt) return false;
	return selectInlineSdtContent(state, dispatch, nextSdt);
};
var INLINE_LEAF_TEXT = "￼";
function createStructuredContentSelectPlugin(editor) {
	return new Plugin({
		props: { handleKeyDown(view, event) {
			if (editor?.options?.documentMode === "viewing") return false;
			if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return false;
			if (event.shiftKey || event.altKey || event.ctrlKey || event.metaKey) return false;
			const { state } = view;
			const { selection } = state;
			const isEditableSlotText = (text) => text.replace(/\u200B/g, "").length === 0;
			const resolveAdjacentEmptyInlineSdtEntry = () => {
				if (event.key !== "ArrowLeft") return null;
				if (!selection.empty) return null;
				let targetPos = null;
				state.doc.descendants((node, pos) => {
					if (node.type.name !== "structuredContent") return true;
					if (node.content.size !== 0) return true;
					if (event.key === "ArrowLeft" && selection.from === pos + node.nodeSize) {
						targetPos = pos + 1;
						return false;
					}
					return true;
				});
				return targetPos;
			};
			const resolveBoundaryExit = ($pos) => {
				for (let depth = $pos.depth; depth > 0; depth -= 1) {
					const node = $pos.node(depth);
					if (node.type.name !== "structuredContent") continue;
					const contentFrom = $pos.start(depth);
					const contentTo = $pos.end(depth);
					const nodePos = $pos.before(depth);
					const beforePos = nodePos;
					const afterPos = nodePos + node.nodeSize;
					if (selection.empty) {
						const trailingSlice = state.doc.textBetween(selection.from, contentTo, "", INLINE_LEAF_TEXT);
						const leadingSlice = state.doc.textBetween(contentFrom, selection.from, "", INLINE_LEAF_TEXT);
						const onlyTrailingEditableSlots = trailingSlice.length > 0 && isEditableSlotText(trailingSlice);
						const onlyLeadingEditableSlots = leadingSlice.length > 0 && isEditableSlotText(leadingSlice);
						if (event.key === "ArrowRight" && (selection.from >= contentTo - 1 || onlyTrailingEditableSlots)) return afterPos;
						if (event.key === "ArrowLeft" && (selection.from <= contentFrom + 1 || onlyLeadingEditableSlots)) return beforePos;
						return null;
					}
					if (!(selection.from === contentFrom && selection.to === contentTo)) return null;
					if (event.key === "ArrowRight") return afterPos;
					if (event.key === "ArrowLeft") return beforePos;
					return null;
				}
				return null;
			};
			const adjacentEmptySdtEntry = resolveAdjacentEmptyInlineSdtEntry();
			if (adjacentEmptySdtEntry != null) try {
				view.dispatch(state.tr.setSelection(TextSelection.create(state.doc, adjacentEmptySdtEntry)));
				event.preventDefault();
				return true;
			} catch {
				return false;
			}
			const nextPos = resolveBoundaryExit(selection.$from);
			if (nextPos == null) return false;
			try {
				const direction = event.key === "ArrowLeft" ? "before" : "after";
				const tr = applyEditableSlotAtInlineBoundary(state.tr, nextPos, direction);
				view.dispatch(tr);
				event.preventDefault();
				return true;
			} catch {
				return false;
			}
		} },
		appendTransaction(transactions, oldState, newState) {
			if (editor?.options?.documentMode === "viewing") return null;
			const { selection } = newState;
			if (oldState.selection.eq(newState.selection)) return null;
			if (transactions.some((tr) => tr.docChanged)) return null;
			if (!selection.empty) {
				if (transactions.some((tr) => tr.getMeta("selectInlineSdtBeforeRunStart"))) return null;
				let selectedSdt = null;
				newState.doc.descendants((node, pos) => {
					if (node.type.name !== "structuredContent") return true;
					const contentFrom = pos + 1;
					const contentTo = pos + node.nodeSize - 1;
					if (!(selection.from === contentFrom && selection.to === contentTo)) return true;
					selectedSdt = {
						node,
						pos,
						contentFrom,
						contentTo
					};
					return false;
				});
				if (selectedSdt) {
					const oldAtTrailingBoundary = oldState.selection.empty && oldState.selection.from >= selectedSdt.pos + selectedSdt.node.nodeSize;
					const oldAtLeadingBoundary = oldState.selection.empty && oldState.selection.from <= selectedSdt.pos;
					if (oldAtTrailingBoundary) return applyEditableSlotAtInlineBoundary(newState.tr, selectedSdt.pos + selectedSdt.node.nodeSize, "after");
					if (oldAtLeadingBoundary) return applyEditableSlotAtInlineBoundary(newState.tr, selectedSdt.pos, "before");
				}
				return null;
			}
			return null;
		}
	});
}
const structuredContentClass = "sd-structured-content";
const structuredContentInnerClass = "sd-structured-content__content";
const StructuredContent = Node$1.create({
	name: "structuredContent",
	group: "inline structuredContent",
	inline: true,
	content: "inline*",
	isolating: true,
	atom: false,
	draggable: true,
	addOptions() {
		return { htmlAttributes: {
			class: structuredContentClass,
			"aria-label": "Structured content node"
		} };
	},
	addAttributes() {
		return {
			id: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-id"),
				renderDOM: (attrs) => {
					if (!attrs.id) return {};
					return { "data-id": attrs.id };
				}
			},
			tag: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-tag"),
				renderDOM: (attrs) => {
					if (!attrs.tag) return {};
					return { "data-tag": attrs.tag };
				}
			},
			alias: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-alias"),
				renderDOM: (attrs) => {
					if (!attrs.alias) return {};
					return { "data-alias": attrs.alias };
				}
			},
			lockMode: {
				default: "unlocked",
				parseDOM: (elem) => elem.getAttribute("data-lock-mode") || "unlocked",
				renderDOM: (attrs) => {
					if (!attrs.lockMode || attrs.lockMode === "unlocked") return {};
					return { "data-lock-mode": attrs.lockMode };
				}
			},
			controlType: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-control-type"),
				renderDOM: (attrs) => {
					if (!attrs.controlType) return {};
					return { "data-control-type": attrs.controlType };
				}
			},
			type: {
				default: null,
				rendered: false
			},
			appearance: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-appearance"),
				renderDOM: (attrs) => {
					if (!attrs.appearance) return {};
					return { "data-appearance": attrs.appearance };
				}
			},
			placeholder: {
				default: null,
				rendered: false
			},
			sdtPr: { rendered: false }
		};
	},
	parseDOM() {
		return [{ tag: "span[data-structured-content]" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes, { "data-structured-content": "" }),
			0
		];
	},
	addPmPlugins() {
		return [createStructuredContentLockPlugin(), createStructuredContentSelectPlugin(this.editor)];
	},
	addNodeView() {
		return (props) => {
			return new StructuredContentInlineView({ ...props });
		};
	}
});
var StructuredContentBlockView = class extends StructuredContentViewBase {
	constructor(props) {
		super(props);
	}
	mount() {
		this.buildView();
	}
	get contentDOM() {
		return this.dom?.querySelector(`.sd-structured-content-block__content`) || null;
	}
	createElement() {
		const element = document.createElement("div");
		element.classList.add(structuredContentBlockClass);
		element.setAttribute("data-structured-content-block", "");
		const contentElement = document.createElement("div");
		contentElement.classList.add(structuredContentBlockInnerClass);
		element.append(contentElement);
		updateDOMAttributes(element, { ...Attribute.mergeAttributes(this.htmlAttributes) });
		return {
			element,
			contentElement
		};
	}
	buildView() {
		const { element } = this.createElement();
		const dragHandle = this.createDragHandle();
		element.prepend(dragHandle);
		element.addEventListener("dragstart", (e) => this.onDragStart(e));
		this.root = element;
		this.updateContentEditability();
	}
	updateView() {
		const domAttrs = Attribute.mergeAttributes(this.htmlAttributes);
		updateDOMAttributes(this.dom, { ...domAttrs });
		this.updateContentEditability();
	}
	update(node, decorations, innerDecorations) {
		if (!super.update(node, decorations, innerDecorations)) return false;
		this.updateView();
		return true;
	}
};
const structuredContentBlockClass = "sd-structured-content-block";
const structuredContentBlockInnerClass = "sd-structured-content-block__content";
const StructuredContentBlock = Node$1.create({
	name: "structuredContentBlock",
	group: "block structuredContent",
	content: "block*",
	isolating: true,
	atom: false,
	draggable: true,
	addOptions() {
		return { htmlAttributes: {
			class: structuredContentBlockClass,
			"aria-label": "Structured content block node"
		} };
	},
	addAttributes() {
		return {
			id: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-id"),
				renderDOM: (attrs) => {
					if (!attrs.id) return {};
					return { "data-id": attrs.id };
				}
			},
			tag: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-tag"),
				renderDOM: (attrs) => {
					if (!attrs.tag) return {};
					return { "data-tag": attrs.tag };
				}
			},
			alias: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-alias"),
				renderDOM: (attrs) => {
					if (!attrs.alias) return {};
					return { "data-alias": attrs.alias };
				}
			},
			lockMode: {
				default: "unlocked",
				parseDOM: (elem) => elem.getAttribute("data-lock-mode") || "unlocked",
				renderDOM: (attrs) => {
					if (!attrs.lockMode || attrs.lockMode === "unlocked") return {};
					return { "data-lock-mode": attrs.lockMode };
				}
			},
			controlType: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-control-type"),
				renderDOM: (attrs) => {
					if (!attrs.controlType) return {};
					return { "data-control-type": attrs.controlType };
				}
			},
			type: {
				default: null,
				rendered: false
			},
			appearance: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-appearance"),
				renderDOM: (attrs) => {
					if (!attrs.appearance) return {};
					return { "data-appearance": attrs.appearance };
				}
			},
			placeholder: {
				default: null,
				rendered: false
			},
			sdtPr: { rendered: false }
		};
	},
	parseDOM() {
		return [{ tag: "div[data-structured-content-block]" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"div",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes, { "data-structured-content-block": "" }),
			0
		];
	},
	addNodeView() {
		return (props) => {
			return new StructuredContentBlockView({ ...props });
		};
	}
});
function getStructuredContentTagsById(idOrIds, state) {
	return findChildren(state.doc, (node) => {
		const isStructuredContent = ["structuredContent", "structuredContentBlock"].includes(node.type.name);
		if (Array.isArray(idOrIds)) return isStructuredContent && idOrIds.includes(node.attrs.id);
		else return isStructuredContent && node.attrs.id === idOrIds;
	});
}
function createTagObject(tagData) {
	if (!tagData || typeof tagData !== "object") return null;
	return JSON.stringify(tagData);
}
function parseTagObject(tag) {
	if (typeof tag !== "string" || !tag.startsWith("{")) return null;
	try {
		const parsed = JSON.parse(tag);
		return parsed && typeof parsed === "object" ? parsed : null;
	} catch {
		return null;
	}
}
function hasGroup(tag) {
	const parsed = parseTagObject(tag);
	return parsed !== null && typeof parsed.group === "string";
}
function getGroup(tag) {
	const parsed = parseTagObject(tag);
	return parsed && typeof parsed.group === "string" ? parsed.group : null;
}
function getStructuredContentByGroup(groupOrGroups, state) {
	const searchGroups = Array.isArray(groupOrGroups) ? groupOrGroups : [groupOrGroups];
	return findChildren(state.doc, (node) => {
		if (!["structuredContent", "structuredContentBlock"].includes(node.type.name)) return false;
		const nodeGroup = getGroup(node.attrs.tag);
		if (!nodeGroup) return false;
		return searchGroups.includes(nodeGroup);
	});
}
function getStructuredContentTags(state) {
	return findChildren(state.doc, (node) => {
		return node.type.name === "structuredContent" || node.type.name === "structuredContentBlock";
	});
}
function getStructuredContentInlineTags(state) {
	return findChildren(state.doc, (node) => node.type.name === "structuredContent");
}
function getStructuredContentBlockTags(state) {
	return findChildren(state.doc, (node) => node.type.name === "structuredContentBlock");
}
function getStructuredContentTablesById(id, state) {
	if (!id || !state) return [];
	const blocks = getStructuredContentTagsById(id, state).filter(({ node }) => node.type.name === "structuredContentBlock");
	if (!blocks.length) return [];
	const { pos: blockPos, node: blockNode } = blocks[0];
	const tablesInBlock = [];
	blockNode.descendants((child, relPos) => {
		if (child.type.name === "table") {
			const absPos = blockPos + 1 + relPos;
			tablesInBlock.push({
				node: child,
				pos: absPos
			});
		}
	});
	return tablesInBlock;
}
var structuredContentHelpers_exports = /* @__PURE__ */ __export({
	createTagObject: () => createTagObject,
	getGroup: () => getGroup,
	getStructuredContentBlockTags: () => getStructuredContentBlockTags,
	getStructuredContentByGroup: () => getStructuredContentByGroup,
	getStructuredContentInlineTags: () => getStructuredContentInlineTags,
	getStructuredContentTablesById: () => getStructuredContentTablesById,
	getStructuredContentTags: () => getStructuredContentTags,
	getStructuredContentTagsById: () => getStructuredContentTagsById,
	hasGroup: () => hasGroup,
	parseTagObject: () => parseTagObject
}, 1);
var STRUCTURED_CONTENT_NAMES = ["structuredContent", "structuredContentBlock"];
function isValidIntegerId(id) {
	if (id === null || id === void 0) return true;
	const str = String(id);
	return /^-?\d+$/.test(str);
}
var findFirstTextNode$1 = (node) => {
	let firstTextNode = null;
	node.descendants((child) => {
		if (child.isText) {
			firstTextNode = child;
			return false;
		}
		return true;
	});
	return firstTextNode;
};
const StructuredContentCommands = Extension.create({
	name: "structuredContentCommands",
	addCommands() {
		return {
			insertStructuredContentInline: (options = {}) => ({ editor, dispatch, state, tr }) => {
				if (options.attrs?.id !== void 0 && !isValidIntegerId(options.attrs.id)) throw new Error("Invalid structured content id - must be an integer, got: " + options.attrs.id);
				const { schema } = editor;
				let { from: from$1, to } = state.selection;
				if (dispatch) {
					const selectionText = state.doc.textBetween(from$1, to);
					let content = null;
					if (selectionText) content = schema.text(selectionText);
					if (options.text) content = schema.text(options.text);
					if (options.json) content = schema.nodeFromJSON(options.json);
					if (!content) content = schema.text(" ");
					const runType = schema.nodes.run;
					if (runType && !options.json && content.isText) {
						const formattingState = getFormattingStateAtPos(state, from$1, editor, { storedMarks: state.storedMarks || null });
						const runProperties = formattingState.inlineRunProperties || null;
						if (formattingState.resolvedMarks?.length) {
							const mergedMarks = formattingState.resolvedMarks.reduce((set, mark) => mark.addToSet(set), content.marks);
							content = content.mark(mergedMarks);
						}
						content = runType.create({ runProperties }, content);
					}
					let tag = options.attrs?.tag || "inline_text_sdt";
					if (options.attrs?.group) tag = createTagObject({ group: options.attrs.group });
					const attrs = {
						id: options.attrs?.id || generateRandomSigned32BitIntStrId(),
						tag,
						alias: options.attrs?.alias || "Structured content",
						...options.attrs
					};
					delete attrs.group;
					const node = schema.nodes.structuredContent.create(attrs, content, null);
					const parent = findParentNode((node$1) => node$1.type.name === "structuredContent")(state.selection);
					if (parent) from$1 = to = parent.pos + parent.node.nodeSize;
					const $from = state.doc.resolve(from$1);
					const $to = from$1 === to ? $from : state.doc.resolve(to);
					if (runType && $from.parent.type === runType && $from.parent === $to.parent) {
						const runDepth = $from.depth;
						const runStart = $from.before(runDepth);
						const runEnd = $from.after(runDepth);
						const parentRun = $from.parent;
						const startOffset = $from.parentOffset;
						const endOffset = $to.parentOffset;
						const leftContent = parentRun.content.cut(0, startOffset);
						const rightContent = parentRun.content.cut(endOffset);
						const fragments = [];
						if (leftContent.size > 0) fragments.push(runType.create(parentRun.attrs, leftContent, parentRun.marks));
						fragments.push(node);
						if (rightContent.size > 0) fragments.push(runType.create(parentRun.attrs, rightContent, parentRun.marks));
						tr.replaceWith(runStart, runEnd, fragments);
						const cursorPos = runStart + (leftContent.size > 0 ? leftContent.size + 2 : 0) + node.nodeSize;
						tr.setSelection(TextSelection.create(tr.doc, cursorPos));
					} else tr.replaceWith(from$1, to, node);
				}
				return true;
			},
			insertStructuredContentBlock: (options = {}) => ({ editor, dispatch, state, tr }) => {
				if (options.attrs?.id !== void 0 && !isValidIntegerId(options.attrs.id)) throw new Error("Invalid structured content id - must be an integer, got: " + options.attrs.id);
				const { schema } = editor;
				let { from: from$1, to } = state.selection;
				if (dispatch) {
					const selectionContent = state.selection.content();
					let content = null;
					if (selectionContent.size) content = selectionContent.content;
					if (options.html) {
						const html = htmlHandler(options.html, editor);
						content = DOMParser$1.fromSchema(schema).parse(html).content;
					}
					if (options.json) content = schema.nodeFromJSON(options.json);
					if (!content) content = schema.nodeFromJSON({
						type: "paragraph",
						content: []
					});
					let tag = options.attrs?.tag || "block_table_sdt";
					if (options.attrs?.group) tag = createTagObject({ group: options.attrs.group });
					const attrs = {
						id: options.attrs?.id || generateRandomSigned32BitIntStrId(),
						tag,
						alias: options.attrs?.alias || "Structured content",
						...options.attrs
					};
					delete attrs.group;
					const node = schema.nodes.structuredContentBlock.create(attrs, content, null);
					const parent = findParentNode((node$1) => node$1.type.name === "structuredContentBlock")(state.selection);
					if (parent) from$1 = to = parent.pos + parent.node.nodeSize;
					tr.replaceRangeWith(from$1, to, node);
				}
				return true;
			},
			updateStructuredContentById: (id, options = {}) => ({ editor, dispatch, state, tr }) => {
				if (options.attrs?.id !== void 0 && !isValidIntegerId(options.attrs.id)) throw new Error("Invalid structured content id - must be an integer, got: " + options.attrs.id);
				const structuredContentTags = getStructuredContentTagsById(id, state);
				if (!structuredContentTags.length) return true;
				const { schema } = editor;
				if (dispatch) {
					const { pos, node } = structuredContentTags[0];
					const posFrom = pos;
					const posTo = pos + node.nodeSize;
					let content = null;
					if (options.text) {
						const firstTextNode = options.keepTextNodeStyles === true ? findFirstTextNode$1(node) : null;
						const textMarks = firstTextNode ? firstTextNode.marks : [];
						content = schema.text(options.text, textMarks);
					}
					if (options.html) {
						const html = htmlHandler(options.html, editor);
						content = DOMParser$1.fromSchema(schema).parse(html).content;
					}
					if (options.json) content = schema.nodeFromJSON(options.json);
					if (!content) content = node.content;
					const updatedNode = node.type.create({
						...node.attrs,
						...options.attrs
					}, content, node.marks);
					try {
						editor.validateJSON(updatedNode.toJSON()).check();
					} catch (error) {
						console.error("Invalid content.", "Passed value:", content, "Error:", error);
						return false;
					}
					tr.replaceWith(posFrom, posTo, updatedNode);
				}
				return true;
			},
			deleteStructuredContent: (structuredContentTags) => ({ dispatch, tr }) => {
				if (!structuredContentTags.length) return true;
				if (dispatch) structuredContentTags.forEach((structuredContent) => {
					const { pos, node } = structuredContent;
					const posFrom = tr.mapping.map(pos);
					const posTo = tr.mapping.map(pos + node.nodeSize);
					const currentNode = tr.doc.nodeAt(posFrom);
					if (currentNode && node.eq(currentNode)) tr.delete(posFrom, posTo);
				});
				return true;
			},
			deleteStructuredContentById: (idOrIds) => ({ dispatch, state, tr }) => {
				const structuredContentTags = getStructuredContentTagsById(idOrIds, state);
				if (!structuredContentTags.length) return true;
				if (dispatch) structuredContentTags.forEach((structuredContent) => {
					const { pos, node } = structuredContent;
					const posFrom = tr.mapping.map(pos);
					const posTo = tr.mapping.map(pos + node.nodeSize);
					const currentNode = tr.doc.nodeAt(posFrom);
					if (currentNode && node.eq(currentNode)) tr.delete(posFrom, posTo);
				});
				return true;
			},
			deleteStructuredContentAtSelection: () => ({ dispatch, state, tr }) => {
				const predicate = (node) => STRUCTURED_CONTENT_NAMES.includes(node.type.name);
				const structuredContent = findParentNode(predicate)(state.selection);
				if (!structuredContent) return true;
				if (dispatch) {
					const { node, pos } = structuredContent;
					const posFrom = pos;
					const posTo = posFrom + node.nodeSize;
					const content = node.content;
					tr.replaceWith(posFrom, posTo, content);
				}
				return true;
			},
			updateStructuredContentByGroup: (group, options = {}) => ({ editor, dispatch, state, tr }) => {
				if (options.attrs?.id !== void 0 && !isValidIntegerId(options.attrs.id)) throw new Error("Invalid structured content id - must be an integer, got: " + options.attrs.id);
				const structuredContentTags = getStructuredContentByGroup(group, state);
				if (!structuredContentTags.length) return true;
				const { schema } = editor;
				if (dispatch) {
					const updates = [];
					for (const structuredContent of structuredContentTags) {
						const { pos, node } = structuredContent;
						let content = null;
						if (options.text) {
							const firstTextNode = options.keepTextNodeStyles === true ? findFirstTextNode$1(node) : null;
							const textMarks = firstTextNode ? firstTextNode.marks : [];
							content = schema.text(options.text, textMarks);
						}
						if (options.html) {
							const html = htmlHandler(options.html, editor);
							content = DOMParser$1.fromSchema(schema).parse(html).content;
						}
						if (options.json) content = schema.nodeFromJSON(options.json);
						if (!content) content = node.content;
						const updatedNode = node.type.create({
							...node.attrs,
							...options.attrs
						}, content, node.marks);
						try {
							editor.validateJSON(updatedNode.toJSON()).check();
						} catch (error) {
							console.error("Invalid content.", "Passed value:", content, "Error:", error);
							return false;
						}
						updates.push({
							pos,
							node,
							updatedNode
						});
					}
					for (const { pos, node, updatedNode } of updates) {
						const posFrom = tr.mapping.map(pos);
						const posTo = tr.mapping.map(pos + node.nodeSize);
						const currentNode = tr.doc.nodeAt(posFrom);
						if (currentNode && node.eq(currentNode)) tr.replaceWith(posFrom, posTo, updatedNode);
					}
				}
				return true;
			},
			deleteStructuredContentByGroup: (groupOrGroups) => ({ dispatch, state, tr }) => {
				const structuredContentTags = getStructuredContentByGroup(groupOrGroups, state);
				if (!structuredContentTags.length) return true;
				if (dispatch) structuredContentTags.forEach((structuredContent) => {
					const { pos, node } = structuredContent;
					const posFrom = tr.mapping.map(pos);
					const posTo = tr.mapping.map(pos + node.nodeSize);
					const currentNode = tr.doc.nodeAt(posFrom);
					if (currentNode && node.eq(currentNode)) tr.delete(posFrom, posTo);
				});
				return true;
			},
			appendRowsToStructuredContentTable: ({ id, tableIndex = 0, rows = [], copyRowStyle = false }) => ({ state, commands: commands$1, dispatch }) => {
				const normalized = normalizeRowsInput(rows);
				if (!normalized.length) return true;
				const tables = getStructuredContentTablesById(id, state);
				if (!tables.length || tableIndex < 0 || tableIndex >= tables.length) return true;
				const { node: tableNode, pos: tablePos } = tables[tableIndex];
				if (dispatch) return commands$1.appendRowsWithContent({
					tablePos,
					tableNode,
					valueRows: normalized,
					copyRowStyle
				});
				return commands$1.appendRowsWithContent({
					tablePos,
					tableNode,
					valueRows: normalized,
					copyRowStyle,
					dispatch: false
				});
			}
		};
	},
	addHelpers() {
		return { ...structuredContentHelpers_exports };
	}
});
var normalizeRowsInput = (rowsOrValues) => {
	if (!Array.isArray(rowsOrValues) || !rowsOrValues.length) return [];
	if (Array.isArray(rowsOrValues[0])) return rowsOrValues;
	return [rowsOrValues];
};
var DocumentSectionView = class {
	constructor(node, getPos, decorations, editor) {
		this.node = node;
		this.editor = editor;
		this.decorations = decorations;
		this.view = editor.view;
		this.getPos = getPos;
		this.#init();
	}
	#init() {
		const { attrs } = this.node;
		const { id, title, description } = attrs;
		this.dom = document.createElement("div");
		this.dom.className = "sd-document-section-block";
		this.dom.setAttribute("data-id", id);
		this.dom.setAttribute("data-title", title);
		this.dom.setAttribute("data-description", description);
		this.dom.setAttribute("aria-label", "Document section");
		this.#addToolTip();
		this.contentDOM = document.createElement("div");
		this.contentDOM.className = "sd-document-section-block-content";
		this.contentDOM.setAttribute("contenteditable", "true");
		this.dom.appendChild(this.contentDOM);
	}
	#addToolTip() {
		const { title } = this.node.attrs;
		this.infoDiv = document.createElement("div");
		this.infoDiv.className = "sd-document-section-block-info";
		const textSpan = document.createElement("span");
		textSpan.textContent = title || "Document section";
		this.infoDiv.appendChild(textSpan);
		this.infoDiv.setAttribute("contenteditable", "false");
		this.dom.appendChild(this.infoDiv);
	}
};
const getAllSections = (editor) => {
	if (!editor) return [];
	const type = editor.schema.nodes.documentSection;
	if (!type) return [];
	const sections = [];
	const { state } = editor;
	state.doc.descendants((node, pos) => {
		if (node.type.name === type.name) sections.push({
			node,
			pos
		});
	});
	return sections;
};
const exportSectionsToHTML = (editor) => {
	const sections = getAllSections(editor);
	const processedSections = /* @__PURE__ */ new Set();
	const result = [];
	sections.forEach(({ node }) => {
		const { attrs } = node;
		const { id, title, description } = attrs;
		if (processedSections.has(id)) return;
		processedSections.add(id);
		const html = getHTMLFromNode(node, editor);
		result.push({
			id,
			title,
			description,
			html
		});
	});
	return result;
};
const getHTMLFromNode = (node, editor) => {
	const container = document.implementation.createHTMLDocument().createElement("div");
	const fragment = DOMSerializer.fromSchema(editor.schema).serializeFragment(node.content);
	container.appendChild(fragment);
	return container.innerHTML;
};
const exportSectionsToJSON = (editor) => {
	const sections = getAllSections(editor);
	const processedSections = /* @__PURE__ */ new Set();
	const result = [];
	sections.forEach(({ node }) => {
		const { attrs } = node;
		const { id, title, description } = attrs;
		if (processedSections.has(id)) return;
		processedSections.add(id);
		result.push({
			id,
			title,
			description,
			content: node.toJSON()
		});
	});
	return result;
};
const getLinkedSectionEditor = (id, options, editor) => {
	if (!getAllSections(editor).find((s) => s.node.attrs.id === id)) return null;
	const child = editor.createChildEditor({
		...options,
		onUpdate: ({ editor: childEditor, transaction }) => {
			if (transaction.getMeta("fromLinkedParent")) return;
			const childDocJson = childEditor.state.doc.toJSON();
			const updatedContent = editor.schema.nodeFromJSON({
				type: "doc",
				content: childDocJson.content ?? []
			}).content;
			const sectionNode = getAllSections(editor)?.find((s) => s.node.attrs.id === id);
			if (!sectionNode) return;
			const { pos, node } = sectionNode;
			const newNode = node.type.create(node.attrs, updatedContent, node.marks);
			const tr = editor.state.tr.replaceWith(pos, pos + node.nodeSize, newNode);
			tr.setMeta("fromLinkedChild", true);
			(typeof editor.view?.dispatch === "function" ? editor.view.dispatch.bind(editor.view) : editor.dispatch.bind(editor))(tr);
		}
	});
	editor.on("update", ({ transaction }) => {
		if (transaction.getMeta("fromLinkedChild")) return;
		const sectionNode = getAllSections(editor)?.find((s) => s.node.attrs.id === id);
		if (!sectionNode) return;
		const json = {
			type: "doc",
			content: sectionNode.node.content.content.map((node) => node.toJSON())
		};
		const childTr = child.state.tr;
		childTr.setMeta("fromLinkedParent", true);
		childTr.replaceWith(0, child.state.doc.content.size, child.schema.nodeFromJSON(json));
		(typeof child.view?.dispatch === "function" ? child.view.dispatch.bind(child.view) : child.dispatch.bind(child))(childTr);
	});
	return child;
};
const SectionHelpers = {
	getAllSections,
	exportSectionsToHTML,
	exportSectionsToJSON,
	getLinkedSectionEditor
};
const DocumentSection = Node$1.create({
	name: "documentSection",
	group: "block",
	content: "block*",
	atom: true,
	isolating: true,
	addOptions() {
		return { htmlAttributes: {
			class: "sd-document-section-block",
			"aria-label": "Structured content block"
		} };
	},
	parseDOM() {
		return [{
			tag: "div.sd-document-section-block",
			priority: 60
		}];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"div",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	},
	addAttributes() {
		return {
			id: {},
			sdBlockId: {
				default: null,
				keepOnSplit: false,
				parseDOM: (elem) => elem.getAttribute("data-sd-block-id"),
				renderDOM: (attrs) => {
					return attrs.sdBlockId ? { "data-sd-block-id": attrs.sdBlockId } : {};
				}
			},
			title: {},
			description: {},
			sectionType: {},
			isLocked: { default: false }
		};
	},
	addNodeView() {
		return ({ node, editor, getPos, decorations }) => {
			return new DocumentSectionView(node, getPos, decorations, editor);
		};
	},
	addCommands() {
		return {
			createDocumentSection: (options = {}) => ({ tr, state, dispatch, editor }) => {
				const { selection } = state;
				let { from: from$1, to } = selection;
				let content = selection.content().content;
				const { html: optionsHTML, json: optionsJSON } = options;
				if (optionsHTML) {
					const html = htmlHandler(optionsHTML, this.editor);
					content = DOMParser$1.fromSchema(this.editor.schema).parse(html).content;
				}
				if (optionsJSON) content = this.editor.schema.nodeFromJSON(optionsJSON);
				if (!content?.content?.length) content = this.editor.schema.nodeFromJSON({
					type: "paragraph",
					content: []
				});
				if (!options.id) options.id = SectionHelpers.getAllSections(editor).length + 1;
				if (!options.title) options.title = "Document section";
				const node = this.type.createAndFill(options, content);
				if (!node) return false;
				const isAlreadyInSdtBlock = findParentNode((node$1) => node$1.type.name === "documentSection")(selection);
				if (isAlreadyInSdtBlock && isAlreadyInSdtBlock.node) {
					const insertPos$1 = isAlreadyInSdtBlock.pos + isAlreadyInSdtBlock.node.nodeSize;
					from$1 = insertPos$1;
					to = insertPos$1;
				}
				tr.replaceRangeWith(from$1, to, node);
				const nodeEnd = from$1 + node.nodeSize;
				let shouldInsertParagraph = true;
				let insertPos = nodeEnd;
				if (nodeEnd >= tr.doc.content.size) {
					insertPos = tr.doc.content.size;
					if (insertPos > 0) {
						const $endPos = tr.doc.resolve(insertPos);
						if ($endPos.nodeBefore && $endPos.nodeBefore.type.name === "paragraph") shouldInsertParagraph = false;
					}
				}
				if (shouldInsertParagraph) {
					const emptyParagraph = tr.doc.type.schema.nodes.paragraph.create();
					tr.insert(insertPos, emptyParagraph);
				}
				if (dispatch) {
					tr.setMeta("documentSection", { action: "create" });
					dispatch(tr);
					setTimeout(() => {
						try {
							const currentState = editor.state;
							const docSize = currentState.doc.content.size;
							let targetPos = from$1 + node.nodeSize;
							if (shouldInsertParagraph) targetPos += 1;
							targetPos = Math.min(targetPos, docSize);
							if (targetPos < docSize && targetPos > 0) {
								const newSelection = Selection.near(currentState.doc.resolve(targetPos));
								const newTr = currentState.tr.setSelection(newSelection);
								editor.view.dispatch(newTr);
							}
						} catch (e) {
							console.warn("Could not set delayed selection:", e);
						}
					}, 0);
				}
				return true;
			},
			removeSectionAtSelection: () => ({ tr, dispatch }) => {
				const sdtNode = findParentNode((node$1) => node$1.type.name === "documentSection")(tr.selection);
				if (!sdtNode) return false;
				const { node, pos } = sdtNode;
				const nodeStart = pos;
				const nodeEnd = nodeStart + node.nodeSize;
				const contentToPreserve = node.content;
				tr.delete(nodeStart, nodeEnd);
				if (contentToPreserve.size > 0) tr.insert(nodeStart, contentToPreserve);
				const newPos = Math.min(nodeStart, tr.doc.content.size);
				tr.setSelection(Selection.near(tr.doc.resolve(newPos)));
				if (dispatch) {
					tr.setMeta("documentSection", { action: "delete" });
					dispatch(tr);
				}
				return true;
			},
			removeSectionById: (id) => ({ tr, dispatch }) => {
				const sectionToRemove = SectionHelpers.getAllSections(this.editor).find(({ node: node$1 }) => node$1.attrs.id === id);
				if (!sectionToRemove) return false;
				const { pos, node } = sectionToRemove;
				const nodeStart = pos;
				const nodeEnd = nodeStart + node.nodeSize;
				tr.delete(nodeStart, nodeEnd);
				if (dispatch) {
					tr.setMeta("documentSection", {
						action: "delete",
						id
					});
					dispatch(tr);
				}
				return true;
			},
			lockSectionById: (id) => ({ tr, dispatch }) => {
				const sectionToLock = SectionHelpers.getAllSections(this.editor).find(({ node }) => node.attrs.id === id);
				if (!sectionToLock) return false;
				tr.setNodeMarkup(sectionToLock.pos, null, {
					...sectionToLock.node.attrs,
					isLocked: true
				});
				if (dispatch) {
					tr.setMeta("documentSection", {
						action: "lock",
						id
					});
					dispatch(tr);
				}
				return true;
			},
			updateSectionById: ({ id, html, json, attrs }) => ({ tr, dispatch, editor }) => {
				const sectionToUpdate = SectionHelpers.getAllSections(editor || this.editor).find(({ node: node$1 }) => node$1.attrs.id === id);
				if (!sectionToUpdate) return false;
				const { pos, node } = sectionToUpdate;
				let newContent = null;
				if (html) {
					const htmlDoc = htmlHandler(html, editor || this.editor);
					newContent = DOMParser$1.fromSchema((editor || this.editor).schema).parse(htmlDoc).content;
				}
				if (json) newContent = (editor || this.editor).schema.nodeFromJSON(json);
				if (!newContent) newContent = node.content;
				const updatedNode = node.type.create({
					...node.attrs,
					...attrs
				}, newContent, node.marks);
				tr.replaceWith(pos, pos + node.nodeSize, updatedNode);
				if (dispatch) {
					tr.setMeta("documentSection", {
						action: "update",
						id,
						attrs
					});
					dispatch(tr);
				}
				return true;
			}
		};
	},
	addHelpers() {
		return { ...SectionHelpers };
	}
});
const DocumentPartObject = Node$1.create({
	name: "documentPartObject",
	group: "block",
	content: "block*",
	isolating: true,
	excludeFromSummaryJSON: true,
	addOptions() {
		return { htmlAttributes: {
			class: "sd-document-part-object-block",
			"aria-label": "Structured document part block"
		} };
	},
	parseDOM() {
		return [{
			tag: "div.sd-document-part-object-block",
			priority: 60
		}];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"div",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	},
	addAttributes() {
		return {
			sdBlockId: {
				default: null,
				keepOnSplit: false,
				parseDOM: (elem) => elem.getAttribute("data-sd-block-id"),
				renderDOM: (attrs) => {
					return attrs.sdBlockId ? { "data-sd-block-id": attrs.sdBlockId } : {};
				}
			},
			id: {},
			docPartGallery: {},
			docPartUnique: { default: false },
			wrapperParagraph: { default: null }
		};
	}
});
function findGoverningSectPrParagraph(doc$1, selectionPos) {
	const candidates = [];
	doc$1.descendants((node, nodePos) => {
		if (node.type?.name === "paragraph" && node.attrs?.paragraphProperties?.sectPr) candidates.push({
			node,
			pos: nodePos
		});
	});
	if (!candidates.length) return null;
	const inside = candidates.find((c) => selectionPos >= c.pos && selectionPos < c.pos + c.node.nodeSize);
	if (inside) return inside;
	return candidates.find((c) => c.pos >= selectionPos) ?? candidates[candidates.length - 1];
}
const setSectionPageMarginsAtSelection = ({ topInches, rightInches, bottomInches, leftInches } = {}) => ({ tr, state, editor }) => {
	if (!state || !editor) {
		console.warn("[setSectionPageMarginsAtSelection] Missing state or editor");
		return false;
	}
	const hasTop = typeof topInches === "number";
	const hasRight = typeof rightInches === "number";
	const hasBottom = typeof bottomInches === "number";
	const hasLeft = typeof leftInches === "number";
	if (!hasTop && !hasRight && !hasBottom && !hasLeft) {
		console.warn("[setSectionPageMarginsAtSelection] No margin values provided");
		return false;
	}
	if (hasTop && topInches < 0 || hasRight && rightInches < 0 || hasBottom && bottomInches < 0 || hasLeft && leftInches < 0) {
		console.warn("[setSectionPageMarginsAtSelection] Margin values must be >= 0");
		return false;
	}
	const updates = {};
	if (hasTop) updates.topInches = topInches;
	if (hasRight) updates.rightInches = rightInches;
	if (hasBottom) updates.bottomInches = bottomInches;
	if (hasLeft) updates.leftInches = leftInches;
	const { from: from$1 } = state.selection;
	const governing = findGoverningSectPrParagraph(state.doc, from$1);
	if (governing) {
		const { node, pos } = governing;
		const paraProps = node.attrs?.paragraphProperties || null;
		const existingSectPr = paraProps?.sectPr || null;
		if (!existingSectPr) {
			console.warn("[setSectionPageMarginsAtSelection] Paragraph found but has no sectPr");
			return false;
		}
		const sectPr$1 = JSON.parse(JSON.stringify(existingSectPr));
		try {
			updateSectionMargins({
				type: "sectPr",
				sectPr: sectPr$1
			}, updates);
		} catch (err) {
			console.error("[setSectionPageMarginsAtSelection] Failed to update sectPr:", err);
			return false;
		}
		const resolved = getSectPrMargins(sectPr$1);
		const normalizedSectionMargins = {
			top: resolved.top ?? null,
			right: resolved.right ?? null,
			bottom: resolved.bottom ?? null,
			left: resolved.left ?? null,
			header: resolved.header ?? null,
			footer: resolved.footer ?? null
		};
		const newParagraphProperties = {
			...paraProps || {},
			sectPr: sectPr$1
		};
		const nextAttrs = {
			...node.attrs,
			paragraphProperties: newParagraphProperties,
			sectionMargins: normalizedSectionMargins
		};
		tr.setNodeMarkup(pos, void 0, nextAttrs, node.marks);
		tr.setMeta("forceUpdatePagination", true);
		return true;
	}
	const docAttrs = state.doc.attrs ?? {};
	const converter = editor.converter ?? null;
	const baseBodySectPr = docAttrs.bodySectPr || converter?.bodySectPr || null;
	const sectPr = baseBodySectPr != null ? JSON.parse(JSON.stringify(baseBodySectPr)) : {
		type: "element",
		name: "w:sectPr",
		elements: []
	};
	try {
		updateSectionMargins({
			type: "sectPr",
			sectPr
		}, updates);
	} catch (err) {
		console.error("[setSectionPageMarginsAtSelection] Failed to update sectPr:", err);
		return false;
	}
	if (converter) {
		converter.bodySectPr = sectPr;
		if (!converter.pageStyles) converter.pageStyles = {};
		if (!converter.pageStyles.pageMargins) converter.pageStyles.pageMargins = {};
		const pageMargins = converter.pageStyles.pageMargins;
		const resolved = getSectPrMargins(sectPr);
		if (resolved.top != null) pageMargins.top = resolved.top;
		if (resolved.right != null) pageMargins.right = resolved.right;
		if (resolved.bottom != null) pageMargins.bottom = resolved.bottom;
		if (resolved.left != null) pageMargins.left = resolved.left;
		if (resolved.header != null) pageMargins.header = resolved.header;
		if (resolved.footer != null) pageMargins.footer = resolved.footer;
	}
	tr.setDocAttribute("bodySectPr", sectPr);
	tr.setMeta("forceUpdatePagination", true);
	return true;
};
const Document$1 = Node$1.create({
	name: "doc",
	topNode: true,
	content: "block+",
	parseDOM() {
		return [{ tag: "doc" }];
	},
	renderDOM() {
		return ["doc", 0];
	},
	addAttributes() {
		return {
			attributes: {
				rendered: false,
				"aria-label": "Document node"
			},
			bodySectPr: {
				rendered: false,
				default: null
			},
			documentBackground: {
				rendered: false,
				default: null
			}
		};
	},
	addCommands() {
		return {
			getDocumentStats: () => ({ editor }) => {
				const text = editor.getText();
				return {
					words: text.split(/\s+/).filter((word$1) => word$1.length > 0).length,
					characters: text.length,
					paragraphs: editor.state.doc.content.childCount
				};
			},
			clearDocument: () => ({ commands: commands$1 }) => {
				return commands$1.setContent("<p></p>");
			},
			setSectionPageMarginsAtSelection
		};
	}
});
const Text$2 = Node$1.create({
	name: "text",
	group: "inline",
	inline: true,
	addOptions() {
		return {};
	}
});
var OxmlNode = class OxmlNode extends Node$1 {
	constructor(config) {
		super(config);
		this.oXmlName = config.oXmlName;
	}
	static create(config) {
		return new OxmlNode(config);
	}
};
function getRunPropertiesAtCursor($from) {
	if ($from.parent?.type.name === "run" && $from.parent.attrs?.runProperties) return { ...$from.parent.attrs.runProperties };
	const runNode = $from.nodeBefore;
	if (runNode?.type.name === "run" && runNode.attrs.runProperties) return { ...runNode.attrs.runProperties };
	if ($from.parent?.type.name === "paragraph" && $from.parent.content.size === 0) {
		const paragraphRunProperties = $from.parent.attrs?.paragraphProperties?.runProperties;
		if (paragraphRunProperties && typeof paragraphRunProperties === "object") return { ...paragraphRunProperties };
	}
	return null;
}
function getSplitRunProperties(state, $from) {
	if (state.storedMarks !== null) return normalizeRunProperties(decodeRPrFromMarks(state.storedMarks));
	return getRunPropertiesAtCursor($from);
}
function syncSplitParagraphRunProperties(attrs, runProperties) {
	const nextParagraphProperties = { ...attrs.paragraphProperties || {} };
	if (runProperties) nextParagraphProperties.runProperties = { ...runProperties };
	else delete nextParagraphProperties.runProperties;
	return {
		...attrs,
		paragraphProperties: nextParagraphProperties
	};
}
function getConverter$9(editor) {
	return editor.converter;
}
function readTranslatedLinkedStyles(editor) {
	return getConverter$9(editor)?.translatedLinkedStyles ?? null;
}
const isLinkedParagraphStyleId = (editor, styleId$1) => {
	if (!styleId$1) return false;
	const styleDefinition = (readTranslatedLinkedStyles(editor)?.styles)?.[styleId$1];
	return Boolean(styleDefinition?.type === "paragraph" && styleDefinition?.link);
};
const isLinkedCharacterStyleId = (editor, styleId$1) => {
	if (!styleId$1) return false;
	const translatedStyles = readTranslatedLinkedStyles(editor)?.styles;
	if (!translatedStyles) return false;
	return Object.values(translatedStyles).some((def) => def?.type === "paragraph" && def?.link === styleId$1);
};
const clearInheritedLinkedStyleId = (attrs, editor, { emptyParagraph = false } = {}) => {
	if (!emptyParagraph) return attrs;
	if (!attrs || typeof attrs !== "object") return attrs;
	const paragraphProperties = attrs.paragraphProperties;
	const styleId$1 = paragraphProperties?.styleId;
	if (!isLinkedParagraphStyleId(editor, styleId$1)) return attrs;
	return {
		...attrs,
		paragraphProperties: {
			...paragraphProperties,
			styleId: null
		}
	};
};
const TrackChangesBasePluginKey = new PluginKey("TrackChangesBase");
const TrackChangesBasePlugin = () => {
	return new Plugin({
		key: TrackChangesBasePluginKey,
		state: {
			init(_$1, state) {
				return {
					isTrackChangesActive: false,
					onlyOriginalShown: false,
					onlyModifiedShown: false,
					pendingDeadKeyPlaceholder: null,
					decorations: getTrackChangesDecorations(state, false, false)
				};
			},
			apply(tr, oldState, prevEditorState, newEditorState) {
				const meta = tr.getMeta(TrackChangesBasePluginKey);
				const pendingDeadKeyPlaceholder = meta && Object.prototype.hasOwnProperty.call(meta, "pendingDeadKeyPlaceholder") ? meta.pendingDeadKeyPlaceholder : oldState.pendingDeadKeyPlaceholder;
				if (meta && meta.type === "TRACK_CHANGES_ENABLE") return {
					...oldState,
					isTrackChangesActive: meta.value === true,
					pendingDeadKeyPlaceholder,
					decorations: getTrackChangesDecorations(newEditorState, oldState.onlyOriginalShown, oldState.onlyModifiedShown)
				};
				if (meta && meta.type === "SHOW_ONLY_ORIGINAL") return {
					...oldState,
					onlyOriginalShown: meta.value === true,
					onlyModifiedShown: false,
					pendingDeadKeyPlaceholder,
					decorations: getTrackChangesDecorations(newEditorState, meta.value === true, false)
				};
				if (meta && meta.type === "SHOW_ONLY_MODIFIED") return {
					...oldState,
					onlyOriginalShown: false,
					onlyModifiedShown: meta.value === true,
					pendingDeadKeyPlaceholder,
					decorations: getTrackChangesDecorations(newEditorState, false, meta.value === true)
				};
				if (!tr.docChanged) return {
					...oldState,
					pendingDeadKeyPlaceholder
				};
				if (!meta) {
					let mightAffectTrackChanges = false;
					tr.steps.forEach((step) => {
						const replaceStep$2 = step;
						if (replaceStep$2.slice || replaceStep$2.from !== replaceStep$2.to) mightAffectTrackChanges = true;
					});
					if (mightAffectTrackChanges) return {
						...oldState,
						pendingDeadKeyPlaceholder,
						decorations: getTrackChangesDecorations(newEditorState, oldState.onlyOriginalShown, oldState.onlyModifiedShown)
					};
					return {
						...oldState,
						pendingDeadKeyPlaceholder,
						decorations: oldState.decorations.map(tr.mapping, tr.doc)
					};
				}
				return {
					...oldState,
					pendingDeadKeyPlaceholder,
					decorations: getTrackChangesDecorations(newEditorState, oldState.onlyOriginalShown, oldState.onlyModifiedShown)
				};
			}
		},
		props: { decorations(state) {
			return this.getState(state)?.decorations;
		} }
	});
};
var getTrackChangesDecorations = (state, onlyOriginalShown, onlyModifiedShown) => {
	if (!state.doc || !state.doc.nodeSize || onlyModifiedShown && onlyOriginalShown) return DecorationSet.empty;
	const decorations = [];
	const trackedChanges = getTrackChanges(state);
	addStructuralRowDecorations(decorations, state, onlyOriginalShown, onlyModifiedShown);
	if (!trackedChanges.length) return decorations.length ? DecorationSet.create(state.doc, decorations) : DecorationSet.empty;
	trackedChanges.forEach(({ mark, from: from$1, to }) => {
		if (mark.type.name === "trackInsert") if (onlyOriginalShown) {
			const decoration = Decoration.inline(from$1, to, { class: "track-insert-dec hidden" });
			decorations.push(decoration);
		} else if (onlyModifiedShown) {
			const decoration = Decoration.inline(from$1, to, { class: "track-insert-dec normal" });
			decorations.push(decoration);
		} else {
			const decoration = Decoration.inline(from$1, to, { class: "track-insert-dec highlighted" });
			decorations.push(decoration);
		}
		if (mark.type.name === "trackDelete") if (onlyOriginalShown) {
			const decoration = Decoration.inline(from$1, to, { class: "track-delete-dec normal" });
			decorations.push(decoration);
		} else if (onlyModifiedShown) {
			const decoration = Decoration.inline(from$1, to, { class: "track-delete-dec hidden" });
			decorations.push(decoration);
		} else {
			const decorationInline = Decoration.inline(from$1, to, { class: "track-delete-dec highlighted" });
			decorations.push(decorationInline);
			const decorationWidget = Decoration.widget(from$1, () => {
				const span = document.createElement("span");
				span.classList.add("track-delete-widget");
				return span;
			}, {
				ignoreSelection: true,
				key: "stable-key"
			});
			decorations.push(decorationWidget);
		}
		if (mark.type.name === "trackFormat") if (onlyOriginalShown) {
			const decoration = Decoration.inline(from$1, to, { class: "track-format-dec before" });
			decorations.push(decoration);
		} else if (onlyModifiedShown) {
			const decoration = Decoration.inline(from$1, to, { class: "track-format-dec normal" });
			decorations.push(decoration);
		} else {
			const decoration = Decoration.inline(from$1, to, { class: "track-format-dec highlighted" });
			decorations.push(decoration);
		}
	});
	return DecorationSet.create(state.doc, decorations);
};
var addStructuralRowDecorations = (decorations, state, onlyOriginalShown, onlyModifiedShown) => {
	const structuralChanges = enumerateStructuralRowChanges(state);
	if (!structuralChanges.length) return;
	for (const change of structuralChanges) {
		const isInsert = change.side === "insertion";
		const baseClass = isInsert ? "track-row-insert-dec" : "track-row-delete-dec";
		let mode = "highlighted";
		if (onlyOriginalShown) mode = isInsert ? "hidden" : "normal";
		else if (onlyModifiedShown) mode = isInsert ? "normal" : "hidden";
		for (const row of change.rows) decorations.push(Decoration.node(row.from, row.to, {
			class: `${baseClass} ${mode}`,
			"data-track-change-id": change.id,
			"data-track-change-kind": change.subtype,
			"data-track-change-author": change.author || "",
			"data-track-change-date": change.date || ""
		}));
	}
};
const resolveCommentMeta = ({ converter, importedId }) => {
	const matchingImportedComment = (converter?.comments || []).find((c) => c.importedId == importedId);
	const resolvedCommentId = matchingImportedComment?.commentId ?? (importedId ? String(importedId) : v4_default());
	const internal = matchingImportedComment?.internal ?? matchingImportedComment?.isInternal ?? false;
	const parentCommentId = matchingImportedComment?.parentCommentId;
	const trackedChangeParentId = matchingImportedComment?.trackedChangeParentId;
	const trackedChangeIds = converter?.trackedChangeIdMap ? new Set(Array.from(converter.trackedChangeIdMap.values()).map((id) => String(id))) : null;
	const tcParentId = trackedChangeParentId || parentCommentId;
	const isTrackedChangeParent = tcParentId && trackedChangeIds ? trackedChangeIds.has(String(tcParentId)) : false;
	return {
		resolvedCommentId,
		importedId,
		internal,
		matchingImportedComment,
		trackedChange: matchingImportedComment?.trackedChange === true || isTrackedChangeParent
	};
};
const ensureFallbackComment = ({ converter, matchingImportedComment, commentId, importedId }) => {
	if (matchingImportedComment || !converter) return;
	converter.comments = converter.comments || [];
	if (converter.comments.some((comment) => comment.commentId === commentId)) return;
	converter.comments.push({
		commentId,
		importedId,
		elements: [],
		creatorName: null,
		creatorEmail: null,
		createdTime: null,
		isDone: false
	});
};
var TRACK_CHANGE_MARKS$1 = [
	TrackInsertMarkName,
	TrackDeleteMarkName,
	TrackFormatMarkName
];
const removeCommentsById = ({ commentId, importedId, state, tr, dispatch }) => {
	const positions = getCommentPositionsById(commentId, state.doc, importedId);
	const anchorNodePositions = [];
	state.doc.descendants((node, pos) => {
		const nodeTypeName = node.type?.name;
		if (nodeTypeName !== "commentRangeStart" && nodeTypeName !== "commentRangeEnd") return;
		const wid = node.attrs?.["w:id"];
		if (wid === commentId || importedId && wid === importedId) anchorNodePositions.push(pos);
	});
	if (!positions.length && !anchorNodePositions.length) return false;
	positions.forEach(({ from: from$1, to, mark }) => {
		tr.removeMark(from$1, to, mark);
	});
	anchorNodePositions.slice().sort((a, b$1) => b$1 - a).forEach((pos) => {
		tr.delete(pos, pos + 1);
	});
	dispatch(tr);
	return true;
};
const getCommentPositionsById = (commentId, doc$1, importedId) => {
	const positions = [];
	doc$1.descendants((node, pos) => {
		const { marks } = node;
		marks.filter((mark) => mark.type.name === CommentMarkName).forEach((commentMark) => {
			const { attrs } = commentMark;
			const currentCommentId = attrs?.commentId;
			const currentImportedId = attrs?.importedId;
			if (commentId === currentCommentId || importedId && importedId === currentImportedId) positions.push({
				from: pos,
				to: pos + node.nodeSize,
				mark: commentMark
			});
		});
	});
	return positions;
};
var getCommentMarkSegmentsById = (commentId, doc$1, importedId) => {
	const segments = [];
	doc$1.descendants((node, pos) => {
		if (!node.isInline) return;
		const commentMark = node.marks?.find((mark) => mark.type.name === "commentMark" && (mark.attrs?.commentId === commentId || importedId && mark.attrs?.importedId === importedId));
		if (!commentMark) return;
		segments.push({
			from: pos,
			to: pos + node.nodeSize,
			attrs: commentMark.attrs || {}
		});
	});
	return segments;
};
var getCommentMarkRangesById = (commentId, doc$1, importedId) => {
	const segments = getCommentMarkSegmentsById(commentId, doc$1, importedId);
	if (!segments.length) return {
		segments,
		ranges: []
	};
	const sorted = [...segments].sort((a, b$1) => a.from - b$1.from);
	const ranges = [];
	let active = {
		from: sorted[0].from,
		to: sorted[0].to,
		internal: !!sorted[0].attrs?.internal
	};
	for (let i = 1; i < sorted.length; i += 1) {
		const seg = sorted[i];
		if (seg.from <= active.to) {
			if (seg.to > active.to) active.to = seg.to;
			continue;
		}
		if (!(doc$1.textBetween(active.to, seg.from, "", "").length > 0)) {
			active.to = seg.to;
			continue;
		}
		ranges.push(active);
		active = {
			from: seg.from,
			to: seg.to,
			internal: !!seg.attrs?.internal
		};
	}
	ranges.push(active);
	return {
		segments,
		ranges
	};
};
const resolveCommentById = ({ commentId, importedId, state, tr, dispatch }) => {
	const converted = resolveCommentsInTr({
		items: [{
			commentId,
			importedId
		}],
		state,
		tr
	});
	if (converted) dispatch(tr);
	return converted;
};
const resolveCommentsInTr = ({ items = [], state, tr }) => {
	const { schema } = state;
	const markType = schema.marks?.[CommentMarkName];
	if (!markType) return false;
	const startType = schema.nodes?.commentRangeStart;
	const endType = schema.nodes?.commentRangeEnd;
	const insertions = [];
	const seen = /* @__PURE__ */ new Set();
	let converted = false;
	for (const item of items) {
		if (!item) continue;
		const { commentId, importedId } = item;
		if (commentId == null) continue;
		const key = `${commentId}:${importedId ?? ""}`;
		if (seen.has(key)) continue;
		seen.add(key);
		const { segments, ranges } = getCommentMarkRangesById(commentId, state.doc, importedId);
		if (!segments.length) continue;
		converted = true;
		segments.forEach(({ from: from$1, to, attrs }) => {
			tr.removeMark(from$1, to, markType.create(attrs));
		});
		if (startType && endType && item.preserveAnchor !== false) ranges.forEach(({ from: from$1, to, internal }) => insertions.push({
			from: from$1,
			to,
			internal,
			commentId
		}));
	}
	if (startType && endType && insertions.length) insertions.sort((a, b$1) => b$1.from - a.from || b$1.to - a.to).forEach(({ from: from$1, to, internal, commentId }) => {
		tr.insert(tr.mapping.map(to), endType.create({ "w:id": commentId }));
		tr.insert(tr.mapping.map(from$1), startType.create({
			"w:id": commentId,
			internal
		}));
	});
	return converted;
};
var getCommentRangeAnchorsById = (commentId, doc$1, importedId) => {
	const anchors = [];
	doc$1.descendants((node, pos) => {
		const typeName = node.type?.name;
		if (typeName !== "commentRangeStart" && typeName !== "commentRangeEnd") return;
		const wid = node.attrs?.["w:id"];
		if (wid !== commentId && (!importedId || wid !== importedId)) return;
		anchors.push({
			pos,
			type: typeName === "commentRangeStart" ? "start" : "end",
			internal: !!node.attrs?.internal
		});
	});
	const pairs = [];
	const stack = [];
	for (const anchor of anchors) {
		if (anchor.type === "start") {
			stack.push({
				pos: anchor.pos,
				internal: anchor.internal
			});
			continue;
		}
		const opener = stack.shift();
		if (!opener) continue;
		pairs.push({
			from: opener.pos,
			to: anchor.pos,
			internal: opener.internal
		});
	}
	return {
		pairs,
		anchorNodePositions: anchors.map((a) => a.pos)
	};
};
const reopenCommentById = ({ commentId, importedId, internal, state, tr, dispatch }) => {
	const { schema } = state;
	const markType = schema.marks?.[CommentMarkName];
	if (!markType) return false;
	const { pairs, anchorNodePositions } = getCommentRangeAnchorsById(commentId, state.doc, importedId);
	if (!pairs.length) return false;
	pairs.forEach(({ from: from$1, to, internal: anchorInternal }) => {
		const mappedFrom = tr.mapping.map(from$1);
		const mappedTo = tr.mapping.map(to);
		if (mappedTo <= mappedFrom) return;
		const attrs = {
			commentId,
			importedId,
			internal: typeof internal === "boolean" ? internal : anchorInternal
		};
		tr.addMark(mappedFrom + 1, mappedTo, markType.create(attrs));
	});
	anchorNodePositions.map((pos) => tr.mapping.map(pos)).sort((a, b$1) => b$1 - a).forEach((pos) => {
		const node = tr.doc.nodeAt(pos);
		if (!node) return;
		const typeName = node.type?.name;
		if (typeName !== "commentRangeStart" && typeName !== "commentRangeEnd") return;
		tr.delete(pos, pos + node.nodeSize);
	});
	dispatch(tr);
	return true;
};
const prepareCommentsForExport = (doc$1, tr, schema, comments = []) => {
	const commentMap = /* @__PURE__ */ new Map();
	comments.forEach((c) => {
		commentMap.set(c.commentId, c);
	});
	const trackedChangeSpanById = /* @__PURE__ */ new Map();
	const trackedChangeMarksById = /* @__PURE__ */ new Map();
	doc$1.descendants((node, pos) => {
		const trackedChangeMark = node.marks?.find((mark) => TRACK_CHANGE_MARKS$1.includes(mark.type.name));
		if (!trackedChangeMark) return;
		const trackedChangeId = trackedChangeMark.attrs?.id;
		if (!trackedChangeId) return;
		const existing = trackedChangeSpanById.get(trackedChangeId);
		const startPos = pos;
		const endPos = pos + node.nodeSize;
		if (!existing) trackedChangeSpanById.set(trackedChangeId, {
			startPos,
			endPos
		});
		else {
			existing.startPos = Math.min(existing.startPos, startPos);
			existing.endPos = Math.max(existing.endPos, endPos);
		}
		const marksEntry = trackedChangeMarksById.get(trackedChangeId) || {};
		if (trackedChangeMark.type?.name === "trackInsert" && !marksEntry.insertMark) marksEntry.insertMark = trackedChangeMark;
		if (trackedChangeMark.type?.name === "trackDelete" && !marksEntry.deleteMark) marksEntry.deleteMark = trackedChangeMark;
		trackedChangeMarksById.set(trackedChangeId, marksEntry);
	});
	const getThreadingParentId = (comment) => {
		if (!comment) return void 0;
		if ((comment.threadingStyleOverride === "range-based" || comment.threadingMethod === "range-based" || comment.originalXmlStructure?.hasCommentsExtended === false) && comment.threadingParentCommentId) return comment.threadingParentCommentId;
		return comment.parentCommentId;
	};
	const commentRanges = /* @__PURE__ */ new Map();
	const commentTrackedChangeId = /* @__PURE__ */ new Map();
	doc$1.descendants((node, pos) => {
		const commentMarks = node.marks?.filter((mark) => mark.type.name === "commentMark") || [];
		if (!commentMarks.length) return;
		const nodeEnd = pos + node.nodeSize;
		const trackedChangeId = (node.marks?.find((mark) => TRACK_CHANGE_MARKS$1.includes(mark.type.name)))?.attrs?.id;
		commentMarks.forEach((commentMark) => {
			const { attrs = {} } = commentMark;
			const { commentId } = attrs;
			if (commentId === "pending") return;
			if (!commentRanges.has(commentId)) commentRanges.set(commentId, {
				start: pos,
				end: nodeEnd,
				attrs
			});
			else {
				const existing = commentRanges.get(commentId);
				existing.start = Math.min(existing.start, pos);
				existing.end = Math.max(existing.end, nodeEnd);
			}
			if (trackedChangeId && !commentTrackedChangeId.has(commentId)) commentTrackedChangeId.set(commentId, trackedChangeId);
		});
	});
	const startNodes = [];
	const endNodes = [];
	const seen = /* @__PURE__ */ new Set();
	const trackedChangeCommentMeta = /* @__PURE__ */ new Map();
	commentRanges.forEach(({ start: start$1, end: end$1, attrs }, commentId) => {
		if (seen.has(commentId)) return;
		seen.add(commentId);
		const comment = commentMap.get(commentId);
		const parentCommentId = getThreadingParentId(comment);
		const trackedChangeId = commentTrackedChangeId.get(commentId);
		if (trackedChangeId ? trackedChangeSpanById.get(trackedChangeId) : null) {
			trackedChangeCommentMeta.set(commentId, {
				comment,
				parentCommentId,
				trackedChangeId,
				actualStart: start$1,
				actualEnd: end$1
			});
			return;
		}
		const commentStartNodeAttrs = getPreparedComment(attrs);
		const startNode = schema.nodes.commentRangeStart.create(commentStartNodeAttrs);
		startNodes.push({
			pos: start$1,
			node: startNode,
			commentId,
			parentCommentId
		});
		const endNode = schema.nodes.commentRangeEnd.create(commentStartNodeAttrs);
		endNodes.push({
			pos: end$1,
			node: endNode,
			commentId,
			parentCommentId
		});
		comments.filter((c) => getThreadingParentId(c) === commentId).sort((a, b$1) => a.createdTime - b$1.createdTime).forEach((c) => {
			if (seen.has(c.commentId)) return;
			seen.add(c.commentId);
			const childRange = commentRanges.get(c.commentId);
			const childStart = childRange?.start ?? start$1;
			const childEnd = childRange?.end ?? end$1;
			const childMark = getPreparedComment({
				commentId: c.commentId,
				internal: c.isInternal
			});
			const childStartNode = schema.nodes.commentRangeStart.create(childMark);
			startNodes.push({
				pos: childStart,
				node: childStartNode,
				commentId: c.commentId,
				parentCommentId: getThreadingParentId(c)
			});
			const childEndNode = schema.nodes.commentRangeEnd.create(childMark);
			endNodes.push({
				pos: childEnd,
				node: childEndNode,
				commentId: c.commentId,
				parentCommentId: getThreadingParentId(c)
			});
		});
	});
	if (trackedChangeSpanById.size > 0) {
		trackedChangeCommentMeta.forEach(({ comment, parentCommentId, trackedChangeId, actualStart, actualEnd }) => {
			if (!comment || !trackedChangeSpanById.has(trackedChangeId)) return;
			const span = trackedChangeSpanById.get(trackedChangeId);
			if (!span) return;
			const childMark = getPreparedComment({
				commentId: comment.commentId,
				internal: comment.isInternal
			});
			const trackedMarks = trackedChangeMarksById.get(trackedChangeId) || {};
			const startMarks = trackedMarks.insertMark ? [trackedMarks.insertMark] : trackedMarks.deleteMark ? [trackedMarks.deleteMark] : void 0;
			const endMarks = trackedMarks.deleteMark ? [trackedMarks.deleteMark] : trackedMarks.insertMark ? [trackedMarks.insertMark] : void 0;
			const startPos = actualStart ?? span.startPos;
			const endPos = actualEnd ?? span.endPos;
			const childStartNode = schema.nodes.commentRangeStart.create(childMark, null, startMarks);
			startNodes.push({
				pos: startPos,
				node: childStartNode,
				commentId: comment.commentId,
				parentCommentId
			});
			const childEndNode = schema.nodes.commentRangeEnd.create(childMark, null, endMarks);
			endNodes.push({
				pos: endPos,
				node: childEndNode,
				commentId: comment.commentId,
				parentCommentId
			});
			comments.filter((c) => getThreadingParentId(c) === comment.commentId).sort((a, b$1) => a.createdTime - b$1.createdTime).forEach((c) => {
				if (seen.has(c.commentId)) return;
				seen.add(c.commentId);
				const childRange = commentRanges.get(c.commentId);
				const childStart = childRange?.start ?? actualStart ?? span.startPos;
				const childEnd = childRange?.end ?? actualEnd ?? span.endPos;
				const childStartMarks = childRange ? void 0 : startMarks;
				const childEndMarks = childRange ? void 0 : endMarks;
				const childMarkAttrs = getPreparedComment({
					commentId: c.commentId,
					internal: c.isInternal
				});
				const childStartNode$1 = schema.nodes.commentRangeStart.create(childMarkAttrs, null, childStartMarks);
				startNodes.push({
					pos: childStart,
					node: childStartNode$1,
					commentId: c.commentId,
					parentCommentId: getThreadingParentId(c)
				});
				const childEndNode$1 = schema.nodes.commentRangeEnd.create(childMarkAttrs, null, childEndMarks);
				endNodes.push({
					pos: childEnd,
					node: childEndNode$1,
					commentId: c.commentId,
					parentCommentId: getThreadingParentId(c)
				});
			});
		});
		comments.filter((comment) => {
			const tcParentId = comment.trackedChangeParentId || comment.parentCommentId;
			return trackedChangeSpanById.has(tcParentId) && !comment.trackedChange;
		}).sort((a, b$1) => a.createdTime - b$1.createdTime).forEach((comment) => {
			if (seen.has(comment.commentId)) return;
			seen.add(comment.commentId);
			const tcParentId = comment.trackedChangeParentId || comment.parentCommentId;
			const span = trackedChangeSpanById.get(tcParentId);
			if (!span) return;
			const childMark = getPreparedComment({
				commentId: comment.commentId,
				internal: comment.isInternal
			});
			const parentCommentId = getThreadingParentId(comment);
			const trackedMarks = trackedChangeMarksById.get(tcParentId) || {};
			const startMarks = trackedMarks.insertMark ? [trackedMarks.insertMark] : trackedMarks.deleteMark ? [trackedMarks.deleteMark] : void 0;
			const endMarks = trackedMarks.deleteMark ? [trackedMarks.deleteMark] : trackedMarks.insertMark ? [trackedMarks.insertMark] : void 0;
			const childStartNode = schema.nodes.commentRangeStart.create(childMark, null, startMarks);
			startNodes.push({
				pos: span.startPos,
				node: childStartNode,
				commentId: comment.commentId,
				parentCommentId
			});
			const childEndNode = schema.nodes.commentRangeEnd.create(childMark, null, endMarks);
			endNodes.push({
				pos: span.endPos,
				node: childEndNode,
				commentId: comment.commentId,
				parentCommentId
			});
		});
	}
	const nodeAnchorsById = /* @__PURE__ */ new Map();
	doc$1.descendants((node, pos) => {
		const typeName = node.type?.name;
		if (typeName !== "commentRangeStart" && typeName !== "commentRangeEnd") return;
		const anchorId = node.attrs?.["w:id"];
		if (anchorId == null) return;
		const entry = nodeAnchorsById.get(anchorId) || {};
		if (typeName === "commentRangeStart") entry.startPos = pos;
		else entry.endPos = pos;
		nodeAnchorsById.set(anchorId, entry);
	});
	const isRepresented = (c) => seen.has(c.commentId) || c.importedId != null && seen.has(c.importedId) || nodeAnchorsById.has(c.commentId) || c.importedId != null && nodeAnchorsById.has(c.importedId);
	const findAncestorNodeAnchor = (comment) => {
		let current = comment;
		const visited = /* @__PURE__ */ new Set();
		while (current) {
			const parentId = getThreadingParentId(current);
			if (parentId == null || visited.has(parentId)) return null;
			visited.add(parentId);
			const parent = commentMap.get(parentId) || comments.find((c) => c.importedId === parentId || c.commentId === parentId);
			const anchor = nodeAnchorsById.get(parentId) ?? (parent ? nodeAnchorsById.get(parent.commentId) ?? nodeAnchorsById.get(parent.importedId) : void 0);
			if (anchor?.startPos != null && anchor?.endPos != null) return anchor;
			current = parent;
		}
		return null;
	};
	comments.filter((c) => !c.trackedChange && c.commentId != null && !isRepresented(c)).sort((a, b$1) => (a.createdTime || 0) - (b$1.createdTime || 0)).forEach((c) => {
		const anchor = findAncestorNodeAnchor(c);
		if (!anchor) return;
		seen.add(c.commentId);
		const childAttrs = getPreparedComment({
			commentId: c.commentId,
			internal: c.isInternal
		});
		startNodes.push({
			pos: anchor.startPos + 1,
			node: schema.nodes.commentRangeStart.create(childAttrs),
			commentId: c.commentId,
			parentCommentId: getThreadingParentId(c)
		});
		endNodes.push({
			pos: anchor.endPos + 1,
			node: schema.nodes.commentRangeEnd.create(childAttrs),
			commentId: c.commentId,
			parentCommentId: getThreadingParentId(c)
		});
	});
	startNodes.sort((a, b$1) => {
		if (a.pos !== b$1.pos) return a.pos - b$1.pos;
		const aIsParentOfB = a.commentId === b$1.parentCommentId;
		const bIsParentOfA = b$1.commentId === a.parentCommentId;
		if (aIsParentOfB) return -1;
		if (bIsParentOfA) return 1;
		if (a.parentCommentId && a.parentCommentId === b$1.parentCommentId) {
			const aComment = commentMap.get(a.commentId);
			const bComment = commentMap.get(b$1.commentId);
			return (aComment?.createdTime || 0) - (bComment?.createdTime || 0);
		}
		return 0;
	});
	endNodes.sort((a, b$1) => {
		if (a.pos !== b$1.pos) return a.pos - b$1.pos;
		const aIsParentOfB = a.commentId === b$1.parentCommentId;
		const bIsParentOfA = b$1.commentId === a.parentCommentId;
		if (aIsParentOfB) return -1;
		if (bIsParentOfA) return 1;
		if (a.parentCommentId && a.parentCommentId === b$1.parentCommentId) {
			const aComment = commentMap.get(a.commentId);
			const bComment = commentMap.get(b$1.commentId);
			return (aComment?.createdTime || 0) - (bComment?.createdTime || 0);
		}
		return 0;
	});
	startNodes.forEach((n) => {
		const { pos, node } = n;
		const mappedPos = tr.mapping.map(pos);
		tr.insert(mappedPos, node);
	});
	endNodes.forEach((n) => {
		const { pos, node } = n;
		const mappedPos = tr.mapping.map(pos);
		tr.insert(mappedPos, node);
	});
	return tr;
};
const getPreparedComment = (attrs) => {
	const { commentId, internal } = attrs;
	return {
		"w:id": commentId,
		internal
	};
};
const prepareCommentsForImport = (doc$1, tr, schema, converter) => {
	const toMark = [];
	const toDelete = [];
	const toUpdate = [];
	doc$1.descendants((node, pos) => {
		const { type } = node;
		if (![
			"commentRangeStart",
			"commentRangeEnd",
			"commentReference"
		].includes(type.name)) return;
		const { resolvedCommentId, importedId, internal, matchingImportedComment, trackedChange } = resolveCommentMeta({
			converter,
			importedId: node.attrs["w:id"]
		});
		const isDone = !!matchingImportedComment?.isDone;
		if (type.name === "commentRangeStart") {
			if (!matchingImportedComment || !matchingImportedComment.isDone) toMark.push({
				commentId: resolvedCommentId,
				importedId,
				internal,
				trackedChange,
				start: pos
			});
			ensureFallbackComment({
				converter,
				matchingImportedComment,
				commentId: resolvedCommentId,
				importedId
			});
			if (isDone) toUpdate.push({
				pos,
				attrs: {
					...node.attrs,
					"w:id": resolvedCommentId,
					internal
				}
			});
			else toDelete.push({
				start: pos,
				end: pos + 1
			});
		} else if (type.name === "commentRangeEnd") {
			if (isDone) {
				toUpdate.push({
					pos,
					attrs: {
						...node.attrs,
						"w:id": resolvedCommentId
					}
				});
				return;
			}
			const itemToMark = toMark.find((p$1) => p$1.importedId === importedId);
			if (!itemToMark) return;
			const { start: start$1 } = itemToMark;
			const markAttrs = {
				commentId: itemToMark.commentId,
				importedId,
				internal: itemToMark.internal,
				trackedChange: itemToMark.trackedChange
			};
			tr.addMark(start$1, pos + 1, schema.marks[CommentMarkName].create(markAttrs));
			toDelete.push({
				start: pos,
				end: pos + 1
			});
		} else if (type.name === "commentReference") toDelete.push({
			start: pos,
			end: pos + 1
		});
	});
	if (typeof tr.setNodeMarkup === "function") toUpdate.sort((a, b$1) => b$1.pos - a.pos).forEach(({ pos, attrs }) => {
		tr.setNodeMarkup(pos, void 0, attrs);
	});
	toDelete.sort((a, b$1) => b$1.start - a.start).forEach(({ start: start$1, end: end$1 }) => {
		tr.delete(start$1, end$1);
	});
};
const translateFormatChangesToEnglish = (attrs = {}) => {
	const { before = [], after = [] } = attrs;
	const beforeTypes = new Set(before.map((mark) => mark.type));
	const afterTypes = new Set(after.map((mark) => mark.type));
	const ignore = new Set(["textStyle", "commentMark"]);
	const parts = [];
	const added = [...afterTypes].filter((t) => !beforeTypes.has(t) && !ignore.has(t));
	for (const type of added) parts.push(type);
	const removed = [...beforeTypes].filter((t) => !afterTypes.has(t) && !ignore.has(t));
	for (const type of removed) parts.push(`removed ${type}`);
	const beforeTextStyle = before.find((mark) => mark.type === "textStyle")?.attrs || {};
	const afterTextStyle = after.find((mark) => mark.type === "textStyle")?.attrs || {};
	const formatAttrName = (attr) => attr.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase();
	for (const attr of Object.keys({
		...beforeTextStyle,
		...afterTextStyle
	})) {
		const beforeVal = beforeTextStyle[attr];
		const afterVal = afterTextStyle[attr];
		if (beforeVal === afterVal || afterVal === null) continue;
		const label = formatAttrName(attr);
		if (attr === "color") parts.push("color");
		else if (beforeVal === void 0 || beforeVal === null) parts.push(`${label} ${afterVal}`);
		else if (afterVal === void 0) parts.push(`removed ${label}`);
		else parts.push(`${label} ${afterVal}`);
	}
	return parts.length ? parts.join(", ") : "formatting";
};
var DEFAULT_ACTIVE_ALPHA = 68 / 255;
var DEFAULT_INACTIVE_ALPHA = 34 / 255;
const clampOpacity = (value) => {
	if (!Number.isFinite(value)) return null;
	return Math.max(0, Math.min(1, value));
};
const applyAlphaToHex = (color, opacity) => {
	if (typeof color !== "string") return color;
	const match$1 = color.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
	if (!match$1) return color;
	return `#${match$1[1].length === 3 ? match$1[1].split("").map((c) => c + c).join("") : match$1[1]}${Math.round(opacity * 255).toString(16).padStart(2, "0")}`;
};
const getHighlightColor = ({ activeThreadId, threadId, isInternal, editor }) => {
	if (!editor.options.isInternal && isInternal) return "transparent";
	const pluginState = CommentsPluginKey.getState(editor.state);
	const highlightColors = editor.options.comments?.highlightColors || {};
	const highlightOpacity = editor.options.comments?.highlightOpacity || {};
	const isActive$1 = activeThreadId === threadId;
	const baseColor = isInternal ? highlightColors.internal ?? pluginState.internalColor : highlightColors.external ?? pluginState.externalColor;
	const activeOverride = isInternal ? highlightColors.activeInternal : highlightColors.activeExternal;
	if (isActive$1 && activeOverride) return activeOverride;
	return applyAlphaToHex(baseColor, clampOpacity(isActive$1 ? highlightOpacity.active : highlightOpacity.inactive) ?? (isActive$1 ? DEFAULT_ACTIVE_ALPHA : DEFAULT_INACTIVE_ALPHA));
};
const HyperlinkAddedDisplayType = "hyperlinkAdded";
const HyperlinkModifiedDisplayType = "hyperlinkModified";
const ParagraphSplitDisplayType = "paragraphSplit";
var getMarkSnapshots = (attrs = {}) => {
	return {
		before: Array.isArray(attrs.before) ? attrs.before : [],
		after: Array.isArray(attrs.after) ? attrs.after : []
	};
};
var findSnapshotByType = (snapshots, type) => {
	return snapshots.find((snapshot) => snapshot?.type === type) ?? null;
};
var getNodeText = (nodes = []) => {
	return nodes.map((node) => node?.text || node?.textContent || "").join("").trim();
};
var getHyperlinkTarget = (linkSnapshot) => {
	const href = linkSnapshot?.attrs?.href;
	if (typeof href === "string" && href.trim().length > 0) return href.trim();
	const anchor = linkSnapshot?.attrs?.anchor;
	if (typeof anchor === "string" && anchor.trim().length > 0) return `#${anchor.trim()}`;
	return null;
};
var getLiveLinkMark = (nodes = []) => {
	for (const node of nodes) {
		const linkMark = node?.marks?.find((mark) => mark?.type?.name === "link");
		if (linkMark) return linkMark;
	}
	return null;
};
var getHyperlinkLabel = ({ linkSnapshot, nodes }) => {
	return getHyperlinkTarget(linkSnapshot) || (typeof linkSnapshot?.attrs?.text === "string" && linkSnapshot.attrs.text.trim().length > 0 ? linkSnapshot.attrs.text.trim() : null) || getNodeText(nodes);
};
var getAddedMarkTypes = ({ before, after }) => {
	const beforeTypes = new Set(before.map((snapshot) => snapshot?.type).filter(Boolean));
	return [...new Set(after.map((snapshot) => snapshot?.type).filter(Boolean))].filter((type) => !beforeTypes.has(type));
};
var getRemovedMarkTypes = ({ before, after }) => {
	const beforeTypes = new Set(before.map((snapshot) => snapshot?.type).filter(Boolean));
	const afterTypes = new Set(after.map((snapshot) => snapshot?.type).filter(Boolean));
	return [...beforeTypes].filter((type) => !afterTypes.has(type));
};
var isUnderlineOnlyFormatDelta = ({ before, after }) => {
	const addedTypes = getAddedMarkTypes({
		before,
		after
	});
	return getRemovedMarkTypes({
		before,
		after
	}).length === 0 && addedTypes.length === 1 && addedTypes[0] === "underline";
};
var snapshotAttrsEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return false;
	const keysA = Object.keys(a);
	const keysB = Object.keys(b$1);
	if (keysA.length !== keysB.length) return false;
	return keysA.every((key) => {
		const valA = a[key];
		const valB = b$1[key];
		if (valA == null && valB == null) return true;
		return valA === valB;
	});
};
const resolveTrackedFormatDisplay = ({ attrs = {}, nodes = [] }) => {
	const { before, after } = getMarkSnapshots(attrs);
	if (findSnapshotByType(before, "paragraphSplit") || findSnapshotByType(after, "paragraphSplit")) return {
		trackedChangeDisplayType: ParagraphSplitDisplayType,
		trackedChangeText: "new line"
	};
	const beforeLink = findSnapshotByType(before, "link");
	const afterLink = findSnapshotByType(after, "link");
	const inferredLiveLink = !beforeLink && !afterLink && isUnderlineOnlyFormatDelta({
		before,
		after
	}) ? getLiveLinkMark(nodes) : null;
	const addedLink = afterLink || inferredLiveLink;
	if (beforeLink && addedLink) {
		if (snapshotAttrsEqual(beforeLink.attrs, addedLink.attrs)) return {
			trackedChangeDisplayType: null,
			trackedChangeText: ""
		};
		const trackedChangeText$1 = getHyperlinkLabel({
			linkSnapshot: addedLink,
			nodes
		});
		if (!trackedChangeText$1) return null;
		return {
			trackedChangeDisplayType: HyperlinkModifiedDisplayType,
			trackedChangeText: trackedChangeText$1
		};
	}
	if (!addedLink) return null;
	const trackedChangeText = getHyperlinkLabel({
		linkSnapshot: addedLink,
		nodes
	});
	if (!trackedChangeText) return null;
	return {
		trackedChangeDisplayType: HyperlinkAddedDisplayType,
		trackedChangeText
	};
};
const normalizeCommentEventPayload = ({ conversation, editorOptions, fallbackCommentId, fallbackInternal }) => {
	const { user, documentId } = editorOptions || {};
	const normalized = {
		...conversation,
		commentId: conversation?.commentId ?? fallbackCommentId,
		isInternal: conversation?.isInternal ?? fallbackInternal
	};
	if (!normalized.commentText && normalized.text) {
		normalized.commentText = normalized.text;
		delete normalized.text;
	}
	if ("skipEmit" in normalized) delete normalized.skipEmit;
	if (!normalized.creatorName && user?.name) normalized.creatorName = user.name;
	if (!normalized.creatorId && user?.id) normalized.creatorId = user.id;
	if (!normalized.creatorEmail && user?.email) normalized.creatorEmail = user.email;
	if (!normalized.creatorImage && user?.image) normalized.creatorImage = user.image;
	if (!normalized.createdTime) normalized.createdTime = Date.now();
	if (!normalized.fileId && documentId) normalized.fileId = documentId;
	if (!normalized.documentId && documentId) normalized.documentId = documentId;
	return normalized;
};
const updatePosition = ({ allCommentPositions, threadId, pos, currentBounds, node }) => {
	let bounds = {};
	if (currentBounds instanceof DOMRect) bounds = {
		top: currentBounds.top,
		bottom: currentBounds.bottom,
		left: currentBounds.left,
		right: currentBounds.right
	};
	else bounds = { ...currentBounds };
	if (!allCommentPositions[threadId]) allCommentPositions[threadId] = {
		threadId,
		start: pos,
		end: pos + node.nodeSize,
		bounds
	};
	else {
		const existing = allCommentPositions[threadId];
		existing.start = Math.min(existing.start, pos);
		existing.end = Math.max(existing.end, pos + node.nodeSize);
		existing.bounds.top = Math.min(existing.bounds.top, currentBounds.top);
		existing.bounds.bottom = Math.max(existing.bounds.bottom, currentBounds.bottom);
	}
};
var TRACK_CHANGE_MARKS = [
	TrackInsertMarkName,
	TrackDeleteMarkName,
	TrackFormatMarkName
];
const CommentsPluginKey = new PluginKey("comments");
const CommentsPlugin = Extension.create({
	name: "comments",
	addCommands() {
		return {
			addComment: (contentOrOptions) => ({ tr, dispatch, editor }) => {
				const { selection } = tr;
				const { $from, $to } = selection;
				if ($from.pos === $to.pos) {
					console.warn("addComment requires a text selection. Please select text before adding a comment.");
					return false;
				}
				let content, explicitCommentId, author, authorId, authorEmail, authorImage, isInternal;
				if (typeof contentOrOptions === "string") content = contentOrOptions;
				else if (contentOrOptions && typeof contentOrOptions === "object") {
					content = contentOrOptions.content;
					explicitCommentId = contentOrOptions.commentId;
					author = contentOrOptions.author;
					authorId = contentOrOptions.authorId;
					authorEmail = contentOrOptions.authorEmail;
					authorImage = contentOrOptions.authorImage;
					isInternal = contentOrOptions.isInternal;
				}
				const commentId = explicitCommentId ?? v4_default();
				const resolvedInternal = isInternal ?? false;
				const configUser = editor.options?.user || {};
				tr.setMeta(CommentsPluginKey, { event: "add" });
				tr.addMark($from.pos, $to.pos, editor.schema.marks[CommentMarkName].create({
					commentId,
					internal: resolvedInternal
				}));
				if (dispatch) dispatch(tr);
				const commentPayload = normalizeCommentEventPayload({
					conversation: {
						commentId,
						isInternal: resolvedInternal,
						commentText: content,
						creatorName: author ?? configUser.name,
						creatorId: authorId ?? configUser.id,
						creatorEmail: authorEmail ?? configUser.email,
						creatorImage: authorImage ?? configUser.image,
						createdTime: Date.now()
					},
					editorOptions: editor.options,
					fallbackCommentId: commentId,
					fallbackInternal: resolvedInternal
				});
				editor.emit("commentsUpdate", {
					type: comments_module_events.ADD,
					comment: commentPayload,
					activeCommentId: commentId
				});
				return true;
			},
			addCommentReply: (options = {}) => ({ editor }) => {
				const { parentId, content, author, authorId, authorEmail, authorImage, commentId: explicitCommentId } = options;
				if (!parentId) {
					console.warn("addCommentReply requires a parentId");
					return false;
				}
				const commentId = explicitCommentId ?? v4_default();
				const configUser = editor.options?.user || {};
				const commentPayload = normalizeCommentEventPayload({
					conversation: {
						commentId,
						parentCommentId: parentId,
						commentText: content,
						creatorName: author ?? configUser.name,
						creatorId: authorId ?? configUser.id,
						creatorEmail: authorEmail ?? configUser.email,
						creatorImage: authorImage ?? configUser.image,
						createdTime: Date.now()
					},
					editorOptions: editor.options,
					fallbackCommentId: commentId,
					fallbackInternal: false
				});
				editor.emit("commentsUpdate", {
					type: comments_module_events.ADD,
					comment: commentPayload,
					activeCommentId: commentId
				});
				return true;
			},
			insertComment: (conversation = {}) => ({ tr, dispatch }) => {
				const { selection } = tr;
				const { $from, $to } = selection;
				const skipEmit = conversation?.skipEmit;
				const resolvedCommentId = conversation?.commentId ?? v4_default();
				const resolvedInternal = conversation?.isInternal ?? false;
				tr.setMeta(CommentsPluginKey, { event: "add" });
				tr.addMark($from.pos, $to.pos, this.editor.schema.marks[CommentMarkName].create({
					commentId: resolvedCommentId,
					internal: resolvedInternal
				}));
				if (dispatch) dispatch(tr);
				if (!skipEmit && resolvedCommentId !== "pending") {
					const commentPayload = normalizeCommentEventPayload({
						conversation,
						editorOptions: this.editor.options,
						fallbackCommentId: resolvedCommentId,
						fallbackInternal: resolvedInternal
					});
					const activeCommentId = commentPayload.commentId || commentPayload.importedId || null;
					const event = {
						type: comments_module_events.ADD,
						comment: commentPayload,
						...activeCommentId && { activeCommentId }
					};
					this.editor.emit("commentsUpdate", event);
				}
				return true;
			},
			removeComment: ({ commentId, importedId }) => ({ tr, dispatch, state }) => {
				tr.setMeta(CommentsPluginKey, { event: "deleted" });
				return removeCommentsById({
					commentId,
					importedId,
					state,
					tr,
					dispatch
				});
			},
			setActiveComment: ({ commentId }) => ({ tr }) => {
				tr.setMeta(CommentsPluginKey, {
					type: "setActiveComment",
					activeThreadId: commentId,
					forceUpdate: true
				});
				return true;
			},
			setCommentInternal: ({ commentId, importedId, isInternal }) => ({ tr, dispatch, state }) => {
				const { doc: doc$1 } = state;
				const commentMarkType = this.editor.schema.marks[CommentMarkName];
				if (!commentMarkType) return false;
				const matchedSegments = [];
				tr.setMeta(CommentsPluginKey, { event: "update" });
				doc$1.descendants((node, pos) => {
					if (!node.isInline) return;
					const { marks = [] } = node;
					marks.filter((mark) => mark.type.name === CommentMarkName).forEach((commentMark) => {
						const { attrs } = commentMark;
						const wid = attrs.commentId;
						const importedWid = attrs.importedId;
						if (wid === commentId || importedId && importedWid === importedId) matchedSegments.push({
							from: pos,
							to: pos + node.nodeSize,
							attrs,
							mark: commentMark
						});
					});
				});
				if (!matchedSegments.length) return false;
				matchedSegments.forEach(({ from: from$1, to, attrs, mark }) => {
					tr.removeMark(from$1, to, mark);
					tr.addMark(from$1, to, commentMarkType.create({
						...attrs,
						commentId: attrs?.commentId ?? commentId,
						importedId: attrs?.importedId ?? importedId,
						internal: isInternal
					}));
				});
				tr.setMeta(CommentsPluginKey, { type: "setCommentInternal" });
				dispatch(tr);
				return true;
			},
			resolveComment: ({ commentId, importedId }) => ({ tr, dispatch, state }) => {
				tr.setMeta(CommentsPluginKey, { event: "update" });
				return resolveCommentById({
					commentId,
					importedId,
					state,
					tr,
					dispatch
				});
			},
			resolveCommentThread: ({ comments } = {}) => ({ tr, dispatch, state }) => {
				tr.setMeta(CommentsPluginKey, { event: "update" });
				const converted = resolveCommentsInTr({
					items: comments,
					state,
					tr
				});
				if (converted) dispatch(tr);
				return converted;
			},
			reopenComment: ({ commentId, importedId, internal }) => ({ tr, dispatch, state }) => {
				tr.setMeta(CommentsPluginKey, { event: "update" });
				return reopenCommentById({
					commentId,
					importedId,
					internal,
					state,
					tr,
					dispatch
				});
			},
			editComment: ({ commentId, importedId, content, text }) => ({ editor }) => {
				const nextCommentId = commentId ?? importedId;
				if (!nextCommentId) return false;
				const payload = normalizeCommentEventPayload({
					conversation: {
						commentId: nextCommentId,
						importedId,
						commentText: content ?? text ?? "",
						updatedTime: Date.now()
					},
					editorOptions: editor.options,
					fallbackCommentId: nextCommentId,
					fallbackInternal: false
				});
				editor.emit("commentsUpdate", {
					type: comments_module_events.UPDATE,
					comment: payload,
					activeCommentId: nextCommentId
				});
				return true;
			},
			moveComment: ({ commentId, from: from$1, to }) => ({ tr, dispatch, state, editor }) => {
				if (!commentId) return false;
				if (!Number.isFinite(from$1) || !Number.isFinite(to)) return false;
				if (from$1 >= to) return false;
				const { doc: doc$1 } = state;
				if (from$1 < 0 || to > doc$1.content.size) return false;
				if (!findRangeById(doc$1, commentId)) return false;
				const markType = editor.schema?.marks?.[CommentMarkName];
				if (!markType) return false;
				tr.setMeta(CommentsPluginKey, { event: "update" });
				const segments = [];
				doc$1.descendants((node, pos) => {
					if (!node.isInline) return;
					const commentMark = node.marks?.find((mark) => mark.type.name === "commentMark" && (mark.attrs?.commentId === commentId || mark.attrs?.importedId === commentId));
					if (!commentMark) return;
					segments.push({
						from: pos,
						to: pos + node.nodeSize,
						attrs: commentMark.attrs,
						mark: commentMark
					});
				});
				if (segments.length > 0) {
					segments.forEach((segment) => {
						tr.removeMark(segment.from, segment.to, segment.mark);
					});
					const attrs = segments[0]?.attrs ?? { commentId };
					const mappedFrom$1 = tr.mapping.map(from$1);
					const mappedTo$1 = tr.mapping.map(to);
					tr.addMark(mappedFrom$1, mappedTo$1, markType.create(attrs));
					if (dispatch) dispatch(tr);
					return true;
				}
				const startType = editor.schema?.nodes?.commentRangeStart;
				const endType = editor.schema?.nodes?.commentRangeEnd;
				if (!startType || !endType) return false;
				let startPos = null;
				let endPos = null;
				let startAttrs = { "w:id": commentId };
				doc$1.descendants((node, pos) => {
					if (node.type.name === "commentRangeStart" && node.attrs?.["w:id"] === commentId) {
						startPos = pos;
						startAttrs = { ...node.attrs };
					}
					if (node.type.name === "commentRangeEnd" && node.attrs?.["w:id"] === commentId) endPos = pos;
				});
				if (startPos == null || endPos == null) return false;
				[startPos, endPos].sort((a, b$1) => b$1 - a).forEach((pos) => {
					tr.delete(pos, pos + 1);
				});
				const mappedFrom = tr.mapping.map(from$1);
				const mappedTo = tr.mapping.map(to);
				tr.insert(mappedTo, endType.create({ "w:id": commentId }));
				tr.insert(mappedFrom, startType.create({
					...startAttrs,
					"w:id": commentId
				}));
				if (dispatch) dispatch(tr);
				return true;
			},
			setCursorById: (id, options = {}) => ({ state, editor }) => {
				const { from: from$1 } = findRangeById(state.doc, id) || {};
				if (from$1 != null) {
					const tr = state.tr;
					tr.setSelection(TextSelection.create(state.doc, from$1));
					if (options.activeCommentId) tr.setMeta(CommentsPluginKey, {
						type: "setActiveComment",
						activeThreadId: options.activeCommentId,
						forceUpdate: true
					});
					else if (options.preferredActiveThreadId) tr.setMeta(CommentsPluginKey, {
						type: "setCursorById",
						preferredActiveThreadId: options.preferredActiveThreadId
					});
					if (!options.activeCommentId && editor.view && typeof editor.view.focus === "function") editor.view.focus();
					return true;
				}
				return false;
			}
		};
	},
	addPmPlugins() {
		const editor = this.editor;
		const isHeadless$1 = editor.options.isHeadless;
		let shouldUpdate = true;
		const pluginSpec = {
			key: CommentsPluginKey,
			state: {
				init() {
					const highlightColors = editor.options.comments?.highlightColors || {};
					return {
						activeThreadId: null,
						externalColor: highlightColors.external ?? "#B1124B",
						internalColor: highlightColors.internal ?? "#078383",
						decorations: DecorationSet.empty,
						allCommentPositions: {},
						allCommentIds: [],
						trackedChanges: {}
					};
				},
				apply(tr, pluginState, _$1, newEditorState) {
					const meta = tr.getMeta(CommentsPluginKey);
					const { type } = meta || {};
					if (type === "force" || type === "forceTrackChanges") shouldUpdate = true;
					if (type === "setActiveComment") {
						shouldUpdate = true;
						const previousActiveThreadId = pluginState.activeThreadId;
						const newActiveThreadId = meta.activeThreadId;
						if (previousActiveThreadId !== newActiveThreadId) {
							const update = {
								type: comments_module_events.SELECTED,
								activeCommentId: newActiveThreadId ? newActiveThreadId : null
							};
							setTimeout(() => editor.emit("commentsUpdate", update), 0);
						}
						pluginState.activeThreadId = newActiveThreadId;
						return {
							...pluginState,
							activeThreadId: newActiveThreadId
						};
					}
					if (meta && meta.decorations) return {
						...pluginState,
						decorations: meta.decorations,
						allCommentPositions: meta.allCommentPositions
					};
					const trackedChangeMeta = tr.getMeta(TrackChangesBasePluginKey);
					const currentTrackedChanges = pluginState.trackedChanges;
					if (trackedChangeMeta) pluginState.trackedChanges = handleTrackedChangeTransaction(trackedChangeMeta, currentTrackedChanges, newEditorState, editor);
					if (!tr.docChanged && tr.selectionSet) {
						const { selection } = tr;
						let currentActiveThread = getActiveCommentId(newEditorState.doc, selection);
						if (meta?.type === "setCursorById" && meta.preferredActiveThreadId && selectionContainsThread(newEditorState.doc, selection, meta.preferredActiveThreadId)) currentActiveThread = meta.preferredActiveThreadId;
						const previousSelectionId = pluginState.activeThreadId;
						const isNonCollapsedClear = currentActiveThread == null && selection && selection.$from.pos !== selection.$to.pos;
						if (previousSelectionId !== currentActiveThread && !isNonCollapsedClear) {
							pluginState.activeThreadId = currentActiveThread;
							const update = {
								type: comments_module_events.SELECTED,
								activeCommentId: currentActiveThread ? currentActiveThread : null
							};
							shouldUpdate = true;
							editor.emit("commentsUpdate", update);
						}
					}
					return { ...pluginState };
				}
			}
		};
		if (!isHeadless$1) {
			pluginSpec.props = { decorations(state) {
				return this.getState(state).decorations;
			} };
			pluginSpec.view = () => {
				let prevDoc = null;
				let prevActiveThreadId = null;
				let prevAllCommentPositions = {};
				let hasEverEmitted = false;
				return { update(view) {
					const { state } = view;
					const { doc: doc$1, tr } = state;
					const pluginState = CommentsPluginKey.getState(state);
					const currentActiveThreadId = pluginState.activeThreadId;
					const layoutEngineActive = Boolean(editor.presentationEditor);
					const meta = tr.getMeta(CommentsPluginKey);
					if (meta?.type === "setActiveComment" || meta?.forceUpdate) shouldUpdate = true;
					const docChanged = !prevDoc || !prevDoc.eq(doc$1);
					if (docChanged) shouldUpdate = true;
					const activeThreadChanged = prevActiveThreadId !== currentActiveThreadId;
					if (activeThreadChanged) {
						shouldUpdate = true;
						prevActiveThreadId = currentActiveThreadId;
					}
					const onlyActiveThreadChanged = !(prevDoc === null) && !docChanged && activeThreadChanged;
					if (!shouldUpdate) return;
					prevDoc = doc$1;
					shouldUpdate = false;
					if (layoutEngineActive) return;
					const decorations = [];
					const allCommentPositions = {};
					doc$1.descendants((node, pos) => {
						const { marks = [] } = node;
						const commentMarks = marks.filter((mark) => mark.type.name === CommentMarkName);
						let hasActive = false;
						commentMarks.forEach((commentMark) => {
							const { attrs } = commentMark;
							const threadId = attrs.commentId || attrs.importedId;
							if (!onlyActiveThreadChanged) {
								let currentBounds;
								try {
									currentBounds = view.coordsAtPos(pos);
								} catch {
									currentBounds = null;
								}
								if (currentBounds) updatePosition({
									allCommentPositions,
									threadId,
									pos,
									currentBounds,
									node
								});
							}
							const isInternal = attrs.internal;
							if (!hasActive) hasActive = currentActiveThreadId === threadId;
							let color = getHighlightColor({
								activeThreadId: currentActiveThreadId,
								threadId,
								isInternal,
								editor
							});
							const deco = Decoration.inline(pos, pos + node.nodeSize, {
								style: `background-color: ${color};`,
								"data-thread-id": threadId,
								class: "sd-editor-comment-highlight"
							});
							if (hasActive && currentActiveThreadId !== threadId) return;
							decorations.push(deco);
						});
						const trackedChangeMark = findTrackedMark({
							doc: doc$1,
							from: pos,
							to: pos + node.nodeSize
						});
						if (trackedChangeMark) {
							if (!onlyActiveThreadChanged) {
								let currentBounds;
								try {
									currentBounds = view.coordsAtPos(pos);
								} catch {
									currentBounds = null;
								}
								const { id } = trackedChangeMark.mark.attrs;
								if (currentBounds) updatePosition({
									allCommentPositions,
									threadId: id,
									pos,
									currentBounds,
									node
								});
							}
							if (currentActiveThreadId === trackedChangeMark.mark.attrs.id) {
								const trackedChangeDeco = Decoration.inline(pos, pos + node.nodeSize, {
									style: `border-width: 2px;`,
									"data-thread-id": trackedChangeMark.mark.attrs.id,
									class: "sd-editor-tracked-change-highlight"
								});
								decorations.push(trackedChangeDeco);
							}
						}
					});
					const decorationSet = DecorationSet.create(doc$1, decorations);
					if (!pluginState.decorations.eq(decorationSet)) {
						const tr$1 = state.tr.setMeta(CommentsPluginKey, {
							decorations: decorationSet,
							allCommentPositions,
							forceUpdate: true
						});
						view.dispatch(tr$1);
					}
					if (!onlyActiveThreadChanged) {
						const positionsChanged = hasPositionsChanged(prevAllCommentPositions, allCommentPositions);
						const hasComments$2 = Object.keys(allCommentPositions).length > 0;
						if (positionsChanged || !hasEverEmitted && hasComments$2) {
							prevAllCommentPositions = allCommentPositions;
							hasEverEmitted = true;
							editor.emit("comment-positions", { allCommentPositions });
						}
					}
				} };
			};
		}
		return [new Plugin(pluginSpec)];
	}
});
var hasPositionsChanged = (prevPositions, currPositions) => {
	const prevKeys = Object.keys(prevPositions);
	const currKeys = Object.keys(currPositions);
	if (prevKeys.length !== currKeys.length) return true;
	for (const key of currKeys) {
		const prev = prevPositions[key];
		const curr = currPositions[key];
		if (!prev || !prev.bounds || !curr.bounds) return true;
		if (prev.bounds.top !== curr.bounds.top || prev.bounds.left !== curr.bounds.left) return true;
	}
	return false;
};
var getActiveCommentId = (doc$1, selection) => {
	if (!selection) return;
	const { $from, $to } = selection;
	if ($from.pos !== $to.pos) return;
	if (!doc$1.nodeAt($from.pos)) return;
	const trackedChangeMark = findTrackedMark({
		doc: doc$1,
		from: $from.pos,
		to: $to.pos
	});
	const commentRanges = /* @__PURE__ */ new Map();
	doc$1.descendants((node, pos) => {
		const { marks = [] } = node;
		marks.filter((mark) => mark.type.name === CommentMarkName).forEach((mark) => {
			const commentId = mark.attrs.commentId || mark.attrs.importedId;
			if (!commentId) return;
			const existing = commentRanges.get(commentId);
			const end$1 = pos + node.nodeSize;
			if (!existing) commentRanges.set(commentId, {
				start: pos,
				end: end$1
			});
			else commentRanges.set(commentId, {
				start: Math.min(existing.start, pos),
				end: Math.max(existing.end, end$1)
			});
		});
	});
	const containingComments = [];
	commentRanges.forEach((range, commentId) => {
		if ($from.pos >= range.start && $from.pos < range.end) containingComments.push({
			commentId,
			start: range.start,
			end: range.end,
			size: range.end - range.start
		});
	});
	if (containingComments.length === 0) {
		if (trackedChangeMark) return trackedChangeMark.mark.attrs.id;
		return null;
	}
	containingComments.sort((a, b$1) => a.size - b$1.size);
	return containingComments[0].commentId;
};
var selectionContainsThread = (doc$1, selection, threadId) => {
	if (!selection || !threadId) return false;
	const { $from, $to } = selection;
	if ($from.pos !== $to.pos) return false;
	const range = findRangeById(doc$1, threadId);
	if (!range) return false;
	return $from.pos >= range.from && $from.pos < range.to;
};
var findTrackedMark = ({ doc: doc$1, from: from$1, to, offset: offset$1 = 1 }) => {
	const startPos = Math.max(from$1 - offset$1, 0);
	const endPos = Math.min(to + offset$1, doc$1.content.size);
	let markFound;
	doc$1.nodesBetween(startPos, endPos, (node, pos) => {
		if (!node || node?.nodeSize === void 0) return;
		const mark = node.marks.find((mark$1) => TRACK_CHANGE_MARKS.includes(mark$1.type.name));
		if (mark && !markFound) markFound = {
			from: pos,
			to: pos + node.nodeSize,
			mark
		};
	});
	return markFound;
};
var handleTrackedChangeTransaction = (trackedChangeMeta, trackedChanges, newEditorState, editor) => {
	const { insertedMark, deletionMark, formatMark, deletionNodes, emitCommentEvent = true } = trackedChangeMeta;
	if (!insertedMark && !deletionMark && !formatMark) return;
	const newTrackedChanges = { ...trackedChanges };
	const insertedId = insertedMark?.attrs?.id ?? null;
	const deletionId = deletionMark?.attrs?.id ?? null;
	const formatId = formatMark?.attrs?.id ?? null;
	const primaryId = insertedId || deletionId || formatId;
	if (!primaryId) return trackedChanges;
	const registerTrackedChangeId = (changeId, patch) => {
		if (!changeId) return false;
		const existing = newTrackedChanges[changeId];
		if (existing) {
			Object.assign(existing, patch);
			return false;
		}
		newTrackedChanges[changeId] = { ...patch };
		return true;
	};
	const trackedChangesForIdCache = /* @__PURE__ */ new Map();
	const getTrackedChangesForId = (changeId) => {
		if (!changeId) return [];
		if (!trackedChangesForIdCache.has(changeId)) trackedChangesForIdCache.set(changeId, getTrackChanges(newEditorState, changeId));
		return trackedChangesForIdCache.get(changeId);
	};
	const buildTrackedChangePayload = ({ event, marks, nodes: nodes$1, deletionNodes: deletionNodes$1 = [] }) => {
		if (!marks.insertedMark && !marks.deletionMark && !marks.formatMark) return null;
		const trackedMarkId = marks.insertedMark?.attrs?.id ?? marks.deletionMark?.attrs?.id ?? marks.formatMark?.attrs?.id ?? null;
		if (!trackedMarkId) return null;
		return createOrUpdateTrackedChangeComment({
			documentId: editor.options.documentId,
			event,
			marks,
			deletionNodes: deletionNodes$1,
			nodes: nodes$1,
			newEditorState,
			trackedChangesForId: getTrackedChangesForId(trackedMarkId)
		});
	};
	const { step } = trackedChangeMeta;
	let nodes = step?.slice?.content?.content || [];
	if (!nodes.length) newEditorState.doc.descendants((node) => {
		if (node.marks.find((mark) => mark.type.name === "trackFormat")) {
			nodes = [node];
			return false;
		}
	});
	const hasLiveTrackedChange = (changeId) => getTrackedChangesForId(changeId).length > 0;
	const hasCandidateNodes = nodes.length > 0 || Boolean(deletionNodes?.length) || hasLiveTrackedChange(primaryId);
	if (Boolean(insertedMark && deletionMark) && Boolean(insertedId) && Boolean(deletionId) && insertedId !== deletionId) {
		const isNewInsertion = registerTrackedChangeId(insertedId, { insertion: insertedId });
		const isNewDeletion = registerTrackedChangeId(deletionId, { deletion: deletionId });
		const hasInsertionCandidateNodes = nodes.length > 0 || hasLiveTrackedChange(insertedId);
		const hasDeletionCandidateNodes = Boolean(deletionNodes?.length) || hasLiveTrackedChange(deletionId);
		const insertionPayload = hasInsertionCandidateNodes ? buildTrackedChangePayload({
			event: isNewInsertion ? "add" : "update",
			marks: {
				insertedMark,
				deletionMark: null,
				formatMark: null
			},
			deletionNodes: [],
			nodes
		}) : null;
		const deletionPayload = deletionMark && hasDeletionCandidateNodes ? buildTrackedChangePayload({
			event: isNewDeletion ? "add" : "update",
			marks: {
				insertedMark: null,
				deletionMark,
				formatMark: null
			},
			deletionNodes,
			nodes: []
		}) : null;
		if (emitCommentEvent && insertionPayload) editor.emit("commentsUpdate", insertionPayload);
		if (emitCommentEvent && deletionPayload) editor.emit("commentsUpdate", deletionPayload);
		return newTrackedChanges;
	}
	const isNewChange = registerTrackedChangeId(primaryId, {
		...insertedMark ? { insertion: primaryId } : {},
		...deletionMark ? { deletion: deletionId } : {},
		...formatMark ? { format: formatId } : {}
	});
	const emitParams = hasCandidateNodes ? buildTrackedChangePayload({
		event: isNewChange ? "add" : "update",
		marks: {
			insertedMark,
			deletionMark,
			formatMark
		},
		deletionNodes,
		nodes
	}) : null;
	if (emitParams && emitCommentEvent) editor.emit("commentsUpdate", emitParams);
	return newTrackedChanges;
};
var normalizeFormatAttrsForCommentText = (attrs = {}, nodes) => {
	const before = Array.isArray(attrs.before) ? attrs.before : [];
	const after = Array.isArray(attrs.after) ? attrs.after : [];
	const beforeTextStyle = before.find((mark) => mark?.type === "textStyle");
	if (!beforeTextStyle) return {
		...attrs,
		before,
		after
	};
	const afterTextStyleIndex = after.findIndex((mark) => mark?.type === "textStyle");
	const wasTextStyleRemoved = nodes.some((node) => {
		return !node.marks.find((mark) => mark.type.name === "textStyle");
	});
	if (afterTextStyleIndex === -1) if (wasTextStyleRemoved) return {
		...attrs,
		before,
		after
	};
	else return {
		...attrs,
		before,
		after: [...after, {
			type: "textStyle",
			attrs: { ...beforeTextStyle.attrs }
		}]
	};
	const mergedAfter = [...after];
	mergedAfter[afterTextStyleIndex] = {
		...mergedAfter[afterTextStyleIndex],
		attrs: {
			...beforeTextStyle.attrs || {},
			...mergedAfter[afterTextStyleIndex].attrs || {}
		}
	};
	return {
		...attrs,
		before,
		after: mergedAfter
	};
};
var getTrackedChangeText = ({ nodes, mark, trackedChangeType, isReplacement }) => {
	let trackedChangeText = "";
	let deletionText = "";
	let trackedChangeDisplayType$1 = null;
	if (trackedChangeType === "trackDelete" || isReplacement) deletionText = nodes.reduce((acc, node) => {
		if (!node.marks.find((nodeMark) => nodeMark.type.name === "trackDelete")) return acc;
		const nodeText = node?.text || node?.textContent || "";
		acc += nodeText;
		return acc;
	}, "");
	if (trackedChangeType === "trackInsert" || isReplacement) trackedChangeText = nodes.reduce((acc, node) => {
		if (!node.marks.find((nodeMark) => nodeMark.type.name === "trackInsert")) return acc;
		const nodeText = node?.text || node?.textContent || "";
		acc += nodeText;
		return acc;
	}, "");
	if (trackedChangeType === "trackFormat") {
		const normalizedFormatAttrs = normalizeFormatAttrsForCommentText(mark.attrs, nodes);
		const trackedFormatDisplay = resolveTrackedFormatDisplay({
			attrs: normalizedFormatAttrs,
			nodes
		});
		if (trackedFormatDisplay) {
			trackedChangeText = trackedFormatDisplay.trackedChangeText;
			trackedChangeDisplayType$1 = trackedFormatDisplay.trackedChangeDisplayType;
		} else trackedChangeText = translateFormatChangesToEnglish(normalizedFormatAttrs);
	}
	return {
		deletionText,
		trackedChangeText,
		trackedChangeDisplayType: trackedChangeDisplayType$1
	};
};
var createOrUpdateTrackedChangeComment = ({ event, marks, deletionNodes, nodes, newEditorState, documentId, trackedChangesForId }) => {
	const node = nodes[0];
	const fallbackTrackedMark = marks.insertedMark || marks.deletionMark || marks.formatMark;
	if (!fallbackTrackedMark) return;
	const fallbackTrackedMarkId = fallbackTrackedMark.attrs?.id;
	const trackedChangesWithId = trackedChangesForId || getTrackChanges(newEditorState, fallbackTrackedMarkId);
	const liveFormatMark = trackedChangesWithId.find(({ mark }) => mark.type.name === "trackFormat")?.mark ?? null;
	const trackedMark = marks.insertedMark || marks.deletionMark || liveFormatMark || marks.formatMark;
	const { type, attrs } = trackedMark;
	const { name: trackedChangeType } = type;
	const { author, authorId, authorEmail, authorImage, date, importedAuthor } = attrs;
	const id = attrs.id;
	const insertedMarkId = marks.insertedMark?.attrs?.id ?? null;
	const deletionMarkId = marks.deletionMark?.attrs?.id ?? null;
	let isReplacement = Boolean(insertedMarkId && deletionMarkId && insertedMarkId === deletionMarkId);
	if (!isReplacement) {
		const hasInsertMark = trackedChangesWithId.some(({ mark }) => mark.type.name === TrackInsertMarkName);
		const hasDeleteMark = trackedChangesWithId.some(({ mark }) => mark.type.name === TrackDeleteMarkName);
		isReplacement = hasInsertMark && hasDeleteMark;
	}
	const nodesWithMark = [];
	trackedChangesWithId.forEach(({ from: from$1, to }) => {
		newEditorState.doc.nodesBetween(from$1, to, (node$1) => {
			if (node$1.isText) {
				if (node$1.marks?.some((m$1) => TRACK_CHANGE_MARKS.includes(m$1.type.name) && m$1.attrs.id === id)) {
					if (!nodesWithMark.some((n) => n === node$1)) nodesWithMark.push(node$1);
				}
			}
		});
	});
	let nodesToUse;
	if (isReplacement) {
		const hasInsertNode = nodesWithMark.some((node$1) => node$1.marks.find((nodeMark) => nodeMark.type.name === TrackInsertMarkName));
		const hasDeleteNode = nodesWithMark.some((node$1) => node$1.marks.find((nodeMark) => nodeMark.type.name === TrackDeleteMarkName));
		const fallbackNodes = [...!hasInsertNode && nodes?.length ? nodes : [], ...!hasDeleteNode && deletionNodes?.length ? deletionNodes : []];
		nodesToUse = Array.from(new Set([...nodesWithMark, ...fallbackNodes]));
	} else nodesToUse = nodesWithMark.length ? nodesWithMark : node ? [node] : [];
	if (!nodesToUse.length) return;
	const { deletionText, trackedChangeText, trackedChangeDisplayType: trackedChangeDisplayType$1 } = getTrackedChangeText({
		nodes: nodesToUse,
		mark: trackedMark,
		trackedChangeType,
		isReplacement,
		deletionNodes
	});
	if (!deletionText && !trackedChangeText) return;
	const params$1 = {
		event: comments_module_events.ADD,
		type: "trackedChange",
		documentId,
		changeId: id,
		trackedChangeType: isReplacement ? "both" : trackedChangeType,
		trackedChangeText,
		trackedChangeDisplayType: trackedChangeDisplayType$1,
		deletedText: isReplacement || marks.deletionMark ? deletionText : null,
		author,
		...authorId && { authorId },
		authorEmail,
		...authorImage && { authorImage },
		date,
		...importedAuthor && { importedAuthor: { name: importedAuthor } }
	};
	if (event === "add") params$1.event = comments_module_events.ADD;
	else if (event === "update") params$1.event = comments_module_events.UPDATE;
	return params$1;
};
function findRangeById(doc$1, id) {
	let from$1 = null, to = null;
	doc$1.descendants((node, pos) => {
		if (node.marks.find((m$1) => TRACK_CHANGE_MARKS.includes(m$1.type.name) && m$1.attrs.id === id)) {
			if (from$1 === null || pos < from$1) from$1 = pos;
			if (to === null || pos + node.nodeSize > to) to = pos + node.nodeSize;
		}
		if (node.marks.find((m$1) => m$1.type.name === "commentMark" && (m$1.attrs.commentId === id || m$1.attrs.importedId === id))) {
			if (from$1 === null || pos < from$1) from$1 = pos;
			if (to === null || pos + node.nodeSize > to) to = pos + node.nodeSize;
		}
		if (node.type.name === "commentRangeStart" && node.attrs["w:id"] === id) from$1 = pos;
		if (node.type.name === "commentRangeEnd" && node.attrs["w:id"] === id) to = pos;
	});
	return from$1 !== null && to !== null ? {
		from: from$1,
		to
	} : null;
}
function isHeadingStyleId$1(styleId$1) {
	return typeof styleId$1 === "string" && /^heading\s*[1-6]$/i.test(styleId$1.trim());
}
function clearHeadingStyleId$1(attrs) {
	if (!attrs || typeof attrs !== "object") return attrs;
	const paragraphProperties = attrs.paragraphProperties;
	const styleId$1 = paragraphProperties?.styleId;
	if (!isHeadingStyleId$1(styleId$1)) return attrs;
	const nextParagraphProperties = { ...paragraphProperties };
	delete nextParagraphProperties.styleId;
	return {
		...attrs,
		paragraphProperties: nextParagraphProperties
	};
}
function isTrackChangesActive(state) {
	return TrackChangesBasePluginKey.getState(state)?.isTrackChangesActive === true;
}
function findTextblockAt$1(doc$1, pos) {
	const bounded = Math.max(0, Math.min(pos, doc$1.content.size));
	const $pos = doc$1.resolve(bounded);
	for (let depth = $pos.depth; depth > 0; depth -= 1) {
		const node = $pos.node(depth);
		if (node.isTextblock) return {
			pos: $pos.before(depth),
			node
		};
	}
	return null;
}
function findPreviousTextblock(doc$1, beforePos) {
	let found = null;
	doc$1.descendants((node, pos) => {
		if (pos >= beforePos) return false;
		if (node.isTextblock) found = {
			pos,
			node
		};
		return true;
	});
	return found;
}
function findTrackableTextRange(doc$1, block) {
	let from$1 = null;
	let to = null;
	doc$1.nodesBetween(block.pos + 1, block.pos + block.node.nodeSize - 1, (node, pos) => {
		if (!node.isText || !node.text) return true;
		from$1 ??= pos;
		to = pos + node.nodeSize;
		return true;
	});
	const resolvedFrom = from$1;
	const resolvedTo = to;
	if (typeof resolvedFrom !== "number" || typeof resolvedTo !== "number") return null;
	if (resolvedFrom >= resolvedTo) return null;
	return {
		from: resolvedFrom,
		to: resolvedTo
	};
}
function textOffsetInBlock($from, blockDepth) {
	return $from.doc.textBetween($from.start(blockDepth), $from.pos, "", "￼").length;
}
function collectMarkedTextNodes(doc$1, range, changeId) {
	const nodes = [];
	doc$1.nodesBetween(range.from, range.to, (node) => {
		if (node.isText && node.marks.some((mark) => mark.type.name === "trackFormat" && mark.attrs?.id === changeId)) nodes.push(node);
		return true;
	});
	return nodes;
}
function addTrackedParagraphSplitMark({ state, tr, editor, splitSelection, sourceBlockDepth }) {
	if (!isTrackChangesActive(state)) return;
	const markType = state.schema.marks[TrackFormatMarkName];
	const user = editor?.options?.user;
	if (!markType || !user) return;
	const insertedBlock = findTextblockAt$1(tr.doc, tr.selection.from);
	if (!insertedBlock) return;
	const sourceBlock = findPreviousTextblock(tr.doc, insertedBlock.pos);
	let anchor = "source";
	let anchorBlock = sourceBlock;
	let range = anchorBlock ? findTrackableTextRange(tr.doc, anchorBlock) : null;
	if (!range) {
		anchor = "inserted";
		anchorBlock = insertedBlock;
		range = findTrackableTextRange(tr.doc, anchorBlock);
	}
	if (!range) return;
	const changeId = v4_default();
	const mark = markType.create({
		id: changeId,
		author: user.name || "",
		authorId: user.id || "",
		authorEmail: user.email || "",
		authorImage: user.image || "",
		date: (/* @__PURE__ */ new Date()).toISOString(),
		before: [{
			type: "paragraphSplit",
			attrs: {
				anchor,
				offset: textOffsetInBlock(splitSelection, sourceBlockDepth)
			}
		}],
		after: [{
			type: "paragraphSplit",
			attrs: { anchor }
		}],
		revisionGroupId: changeId,
		changeType: "formatting",
		origin: "superdoc"
	});
	tr.addMark(range.from, range.to, mark);
	tr.setMeta("skipTrackChanges", true);
	tr.setMeta(TrackChangesBasePluginKey, {
		formatMark: mark,
		step: { slice: { content: { content: collectMarkedTextNodes(tr.doc, range, changeId) } } }
	});
	tr.setMeta(CommentsPluginKey, { type: "force" });
}
const splitRunToParagraph = () => (props) => {
	const { state, view, tr, editor } = props;
	const { $from, empty: empty$1 } = state.selection;
	if (!empty$1) return false;
	if ($from.parent.type.name !== "run") return false;
	let dispatchTransaction$3 = null;
	if (view?.dispatch) dispatchTransaction$3 = view.dispatch.bind(view);
	else if (editor?.dispatch) dispatchTransaction$3 = editor.dispatch.bind(editor);
	if (!dispatchTransaction$3) return false;
	const handled = splitBlockPatch(state, (transaction) => {
		dispatchTransaction$3(transaction);
	}, editor);
	if (handled) tr.setMeta("preventDispatch", true);
	return handled;
};
function splitBlockPatch(state, dispatch, editor) {
	let { $from } = state.selection;
	if (state.selection instanceof NodeSelection && state.selection.node.isBlock) {
		if (!$from.parentOffset || !canSplit(state.doc, $from.pos)) return false;
		if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
		return true;
	}
	if (!$from.depth) return false;
	let types = [];
	let splitDepth, deflt, paragraphAttrs = null, atEnd = false, atStart = false, tableInfo = null;
	for (let d = $from.depth; d > 0; d--) {
		let node = $from.node(d);
		if (node.isBlock) {
			if (node.type.name === "paragraph") {
				atEnd = $from.end(d) == $from.pos + ($from.depth - d);
				atStart = $from.start(d) == $from.pos - ($from.depth - d);
				deflt = defaultBlockAt$1($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
				const sourceParagraphStyleId = node.attrs?.paragraphProperties?.styleId;
				const extensionAttrs = editor?.extensionService?.attributes ?? [];
				paragraphAttrs = Attribute.getSplittedAttributes(extensionAttrs, node.type.name, node.attrs);
				paragraphAttrs = clearInheritedLinkedStyleId(paragraphAttrs, editor, { emptyParagraph: atEnd });
				if (atEnd && $from.parent.type.name === "run") {
					if (!isLinkedParagraphStyleId(editor, sourceParagraphStyleId)) paragraphAttrs = syncSplitParagraphRunProperties(paragraphAttrs, getSplitRunProperties(state, $from));
					const pp = paragraphAttrs?.paragraphProperties;
					const runStyleIsLinkedCharacter = isLinkedCharacterStyleId(editor, pp?.runProperties?.styleId);
					if (pp && (isLinkedParagraphStyleId(editor, sourceParagraphStyleId) || runStyleIsLinkedCharacter)) {
						const nextPp = { ...pp };
						delete nextPp.runProperties;
						paragraphAttrs = {
							...paragraphAttrs,
							paragraphProperties: nextPp
						};
					}
				}
				types.unshift({
					type: deflt || node.type,
					attrs: paragraphAttrs
				});
				splitDepth = d;
			} else if (node.type.name === "tableCell") {
				tableInfo = extractTableInfo($from, d);
				break;
			}
		} else if (paragraphAttrs == null) {
			if (d == 1) return false;
			types.unshift(null);
		}
	}
	let tr = state.tr;
	if (state.selection instanceof TextSelection || state.selection instanceof AllSelection) tr.deleteSelection();
	let splitPos = tr.mapping.map($from.pos);
	let can = canSplit(tr.doc, splitPos, types.length, types);
	if (!can) {
		types[0] = deflt ? {
			type: deflt,
			attrs: paragraphAttrs
		} : null;
		can = canSplit(tr.doc, splitPos, types.length, types);
	}
	if (!can) return false;
	tr.split(splitPos, types.length, types);
	if (!atEnd && atStart) {
		const first$1 = tr.mapping.map($from.before(splitDepth));
		const $first = tr.doc.resolve(first$1);
		const sourceNode = $from.node(splitDepth);
		const shouldChangeType = sourceNode.type != deflt;
		const normalizedAttrs = clearHeadingStyleId$1(sourceNode.attrs);
		const shouldNormalizeAttrs = normalizedAttrs !== sourceNode.attrs;
		if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt) && (shouldChangeType || shouldNormalizeAttrs)) {
			tr.setNodeMarkup(first$1, deflt, normalizedAttrs);
			if (shouldNormalizeAttrs) paragraphAttrs = normalizedAttrs;
		}
	}
	applyStyleMarks(state, tr, editor, paragraphAttrs, tableInfo);
	if (splitDepth) addTrackedParagraphSplitMark({
		state,
		tr,
		editor,
		splitSelection: $from,
		sourceBlockDepth: splitDepth
	});
	if (dispatch) dispatch(tr.scrollIntoView());
	return true;
}
function applyStyleMarks(state, tr, editor, paragraphAttrs, tableInfo) {
	const styleId$1 = paragraphAttrs?.paragraphProperties?.styleId;
	const explicitStoredMarks = state.storedMarks;
	if (paragraphAttrs?.paragraphProperties && Object.prototype.hasOwnProperty.call(paragraphAttrs.paragraphProperties, "styleId") && paragraphAttrs.paragraphProperties.styleId == null) {
		tr.setStoredMarks([]);
		return;
	}
	if (!editor?.converter && !styleId$1) {
		if (explicitStoredMarks !== null) tr.setStoredMarks(explicitStoredMarks);
		return;
	}
	try {
		if (explicitStoredMarks !== null) {
			tr.setStoredMarks(explicitStoredMarks);
			return;
		}
		const params$1 = {
			docx: editor?.converter?.convertedXml ?? {},
			numbering: editor?.converter?.numbering ?? {},
			translatedNumbering: editor?.converter?.translatedNumbering ?? {},
			translatedLinkedStyles: editor?.converter?.translatedLinkedStyles ?? {}
		};
		const runProperties = styleId$1 ? resolveRunProperties(params$1, {}, styleId$1 ? { styleId: styleId$1 } : {}, tableInfo, false, Boolean(paragraphAttrs.paragraphProperties?.numberingProperties)) : {};
		const markDefsFromStyle = styleId$1 ? encodeMarksFromRPr(runProperties, editor?.converter?.convertedXml ?? {}) : [];
		const selectionMarks = tr.selection?.$from?.marks ? tr.selection.$from.marks() : [];
		const selectionMarkDefs = selectionMarks.map((mark) => ({
			type: mark.type.name,
			attrs: mark.attrs
		}));
		const marksToApply = (selectionMarks.length ? selectionMarkDefs : markDefsFromStyle).map((def) => {
			const markType = state.schema.marks[def.type];
			return markType ? markType.create(def.attrs) : null;
		}).filter(Boolean);
		if (marksToApply.length > 0) tr.ensureMarks(marksToApply);
	} catch {}
}
const splitRunAtCursor = () => (props) => {
	let { state, dispatch, tr } = props;
	const sel = state.selection;
	if (!sel.empty) return false;
	const $pos = sel.$from;
	const runType = state.schema.nodes.run;
	if ($pos.parent.type !== runType) return false;
	const run = $pos.parent;
	const offset$1 = $pos.parentOffset;
	const runStart = $pos.before();
	const runEnd = runStart + run.nodeSize;
	const leftFrag = run.content.cut(0, offset$1);
	const rightFrag = run.content.cut(offset$1);
	const leftRun = runType.create(run.attrs, leftFrag, run.marks);
	const rightRun = runType.create(run.attrs, rightFrag, run.marks);
	const gapPos = runStart + leftRun.nodeSize;
	tr.replaceWith(runStart, runEnd, [leftRun, rightRun]).setSelection(TextSelection.create(tr.doc, gapPos));
	if (dispatch) dispatch(tr);
	return true;
};
const cleanupEmptyRunsPlugin = new Plugin({ appendTransaction(trs, oldState, newState) {
	if (!trs.some((tr$1) => tr$1.docChanged)) return null;
	const { run, paragraph } = newState.schema.nodes;
	if (!run) return null;
	const ranges = [];
	trs.forEach((tr$1) => {
		tr$1.mapping.maps.forEach((map$1) => {
			map$1.forEach((oldStart, oldEnd, newStart, newEnd) => {
				if (newStart !== oldStart || oldEnd !== newEnd) ranges.push({
					from: newStart,
					to: newEnd
				});
			});
		});
	});
	if (!ranges.length) return null;
	ranges.sort((a, b$1) => a.from - b$1.from);
	const merged = [];
	for (const r$1 of ranges) {
		const from$1 = Math.max(0, r$1.from - 1);
		const to = Math.min(newState.doc.content.size, r$1.to + 1);
		const last = merged[merged.length - 1];
		if (last && from$1 <= last.to) last.to = Math.max(last.to, to);
		else merged.push({
			from: from$1,
			to
		});
	}
	const toDelete = [];
	merged.forEach(({ from: from$1, to }) => {
		newState.doc.nodesBetween(from$1, to, (node, pos, parent) => {
			if (node.type === run && node.content.size === 0 && parent?.type === paragraph) toDelete.push({
				from: pos,
				to: pos + node.nodeSize
			});
		});
	});
	if (!toDelete.length) return null;
	const tr = newState.tr;
	toDelete.sort((a, b$1) => b$1.from - a.from).forEach(({ from: from$1, to }) => tr.deleteRange(from$1, to));
	if (tr.selection instanceof TextSelection && tr.selection.empty && newState.storedMarks !== null) tr.setStoredMarks(newState.storedMarks);
	return tr.docChanged ? tr : null;
} });
var preserveStoredMarks = (state, tr) => {
	if (!(tr.selection instanceof TextSelection) || !tr.selection.empty) return;
	if (state.storedMarks === null) return;
	tr.setStoredMarks(state.storedMarks);
};
var normalizeSelectionIntoRun = (tr, runType) => {
	const selection = tr.selection;
	if (!(selection instanceof TextSelection)) return;
	if (selection.from !== selection.to) return;
	const $pos = tr.doc.resolve(selection.from);
	if ($pos.parent.type === runType) return;
	const nodeAfter = $pos.nodeAfter;
	if (nodeAfter?.type === runType && nodeAfter.content.size > 0) {
		const nextPos = selection.from + 1;
		if (nextPos <= tr.doc.content.size) tr.setSelection(TextSelection.create(tr.doc, nextPos));
		return;
	}
	const nodeBefore = $pos.nodeBefore;
	if (nodeBefore?.type === runType && nodeBefore.content.size > 0) {
		const prevPos = selection.from - 1;
		if (prevPos >= 0) tr.setSelection(TextSelection.create(tr.doc, prevPos));
	}
};
var copyRunPropertiesFromParagraph = (state, pos, textNode, runType, editor) => {
	let updatedTextNode = textNode;
	const formattingState = getFormattingStateAtPos(state, pos, editor, { preferParagraphRunProperties: true });
	if (formattingState.resolvedMarks?.length) {
		const mergedMarks = formattingState.resolvedMarks.reduce((set, mark) => mark.addToSet(set), updatedTextNode.marks);
		updatedTextNode = updatedTextNode.mark(mergedMarks);
	}
	return {
		runProperties: formattingState.inlineRunProperties,
		textNode: updatedTextNode
	};
};
var buildWrapTransaction = (state, ranges, runType, editor) => {
	if (!ranges.length) return null;
	const replacements = [];
	ranges.forEach(({ from: from$1, to }) => {
		state.doc.nodesBetween(from$1, to, (node, pos, parent, index) => {
			if (!node.isText || !parent || parent.type === runType) return;
			const match$1 = parent.contentMatchAt ? parent.contentMatchAt(index) : null;
			if (match$1 && !match$1.matchType(runType)) return;
			if (!match$1 && !parent.type.contentMatch.matchType(runType)) return;
			let runProperties;
			let textNode = node;
			const originalMarks = node.marks;
			if (index === 0 && parent.type.name === "paragraph") ({runProperties, textNode} = copyRunPropertiesFromParagraph(state, pos, textNode, runType, editor));
			if (!runProperties) runProperties = decodeRPrFromMarks(originalMarks);
			const runNode = runType.create({ runProperties }, textNode);
			replacements.push({
				from: pos,
				to: pos + node.nodeSize,
				runNode
			});
		});
	});
	if (!replacements.length) return null;
	const tr = state.tr;
	replacements.sort((a, b$1) => b$1.from - a.from).forEach(({ from: from$1, to, runNode }) => tr.replaceWith(from$1, to, runNode));
	normalizeSelectionIntoRun(tr, runType);
	preserveStoredMarks(state, tr);
	return tr.docChanged ? tr : null;
};
const wrapTextInRunsPlugin = (editor) => {
	let view = null;
	let pendingRanges = [];
	const flush = () => {
		if (!view) return;
		const runType = view.state.schema.nodes.run;
		if (!runType) {
			pendingRanges = [];
			return;
		}
		const tr = buildWrapTransaction(view.state, pendingRanges, runType, editor);
		pendingRanges = [];
		if (tr) view.dispatch(tr);
	};
	const onCompositionEnd = () => {
		if (typeof globalThis === "undefined") return;
		globalThis.queueMicrotask(flush);
	};
	return new Plugin({
		view(editorView) {
			view = editorView;
			editorView.dom.addEventListener("compositionend", onCompositionEnd);
			return { destroy() {
				editorView.dom.removeEventListener("compositionend", onCompositionEnd);
				view = null;
				pendingRanges = [];
			} };
		},
		appendTransaction(transactions, _oldState, newState) {
			const docSize = newState.doc.content.size;
			const runType = newState.schema.nodes.run;
			if (!runType) return null;
			pendingRanges = collectChangedRangesThroughTransactions(transactions, docSize, { extraRanges: pendingRanges });
			if (view?.composing) return null;
			const tr = buildWrapTransaction(newState, pendingRanges, runType, editor);
			pendingRanges = [];
			return tr;
		}
	});
};
const Run = OxmlNode.create({
	name: "run",
	oXmlName: "w:r",
	group: "inline",
	inline: true,
	content: "inline*",
	selectable: false,
	childToAttributes: ["runProperties"],
	addOptions() {
		return { htmlAttributes: { "data-run": "1" } };
	},
	addAttributes() {
		return {
			runProperties: {
				default: null,
				rendered: false,
				keepOnSplit: true
			},
			runPropertiesInlineKeys: {
				default: null,
				rendered: false,
				keepOnSplit: true
			},
			runPropertiesStyleKeys: {
				default: null,
				rendered: false,
				keepOnSplit: true
			},
			runPropertiesOverrideKeys: {
				default: null,
				rendered: false,
				keepOnSplit: true
			},
			rsidR: {
				default: null,
				rendered: false,
				keepOnSplit: true
			},
			rsidRPr: {
				default: null,
				rendered: false,
				keepOnSplit: true
			},
			rsidDel: {
				default: null,
				rendered: false,
				keepOnSplit: true
			}
		};
	},
	addCommands() {
		return {
			splitRunToParagraph,
			splitRunAtCursor
		};
	},
	parseDOM() {
		return [{ tag: "span[data-run]" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	},
	addPmPlugins() {
		return [
			wrapTextInRunsPlugin(this.editor),
			calculateInlineRunPropertiesPlugin(this.editor),
			cleanupEmptyRunsPlugin
		];
	}
});
var isHeadingStyleId = (styleId$1) => typeof styleId$1 === "string" && /^heading\s*[1-6]$/i.test(styleId$1.trim());
var clearHeadingStyleId = (attrs) => {
	if (!attrs || typeof attrs !== "object") return attrs;
	const paragraphProperties = attrs.paragraphProperties;
	const styleId$1 = paragraphProperties?.styleId;
	if (!isHeadingStyleId(styleId$1)) return attrs;
	const nextParagraphProperties = { ...paragraphProperties };
	delete nextParagraphProperties.styleId;
	return {
		...attrs,
		paragraphProperties: nextParagraphProperties
	};
};
var ensureMarks = (state, splittableMarks) => {
	const marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
	if (marks) {
		const filtered = marks.filter((m$1) => splittableMarks?.includes(m$1.type.name));
		state.tr.ensureMarks(filtered);
	}
};
const splitBlock = ({ keepMarks = true, attrsToRemoveOverride = [] } = {}) => (props) => {
	const { tr, state, dispatch, editor } = props;
	const { selection, doc: doc$1 } = tr;
	const { $from, $to } = selection;
	const extensionAttrs = editor.extensionService.attributes;
	let newAttrs = Attribute.getSplittedAttributes(extensionAttrs, $from.node().type.name, $from.node().attrs);
	if (attrsToRemoveOverride.length > 0) newAttrs = deleteAttributes(newAttrs, attrsToRemoveOverride);
	if (selection instanceof NodeSelection && selection.node.isBlock) {
		if (!$from.parentOffset || !canSplit(doc$1, $from.pos)) return false;
		if (dispatch) {
			if (keepMarks) ensureMarks(state, editor.extensionService.splittableMarks);
			tr.split($from.pos).scrollIntoView();
		}
		return true;
	}
	if (!$from.parent.isBlock) return false;
	if (dispatch) {
		const atEnd = $to.parentOffset === $to.parent.content.size;
		newAttrs = clearInheritedLinkedStyleId(newAttrs, editor, { emptyParagraph: atEnd });
		if (atEnd) {
			const runProperties = getSplitRunProperties(state, $from);
			newAttrs = syncSplitParagraphRunProperties(newAttrs, runProperties);
		}
		if (selection instanceof TextSelection) tr.deleteSelection();
		const deflt = $from.depth === 0 ? null : defaultBlockAt$1($from.node(-1).contentMatchAt($from.indexAfter(-1)));
		let types = atEnd && deflt ? [{
			type: deflt,
			attrs: newAttrs
		}] : void 0;
		let can = canSplit(tr.doc, tr.mapping.map($from.pos), 1, types);
		if (!types && !can && canSplit(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [{ type: deflt }] : void 0)) {
			can = true;
			types = deflt ? [{
				type: deflt,
				attrs: newAttrs
			}] : void 0;
		}
		if (can) {
			tr.split(tr.mapping.map($from.pos), 1, types);
			if (deflt && !atEnd && !$from.parentOffset) {
				const first$1 = tr.mapping.map($from.before());
				const $first = tr.doc.resolve(first$1);
				const shouldChangeType = $from.parent.type !== deflt;
				const normalizedAttrs = clearHeadingStyleId($from.parent.attrs);
				const shouldNormalizeAttrs = normalizedAttrs !== $from.parent.attrs;
				if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt) && (shouldChangeType || shouldNormalizeAttrs)) tr.setNodeMarkup(first$1, deflt, normalizedAttrs);
			}
		}
		if (keepMarks) ensureMarks(state, editor.extensionService.splittableMarks);
		tr.scrollIntoView();
	}
	return true;
};
function deleteAttributes(attrs, attrsToRemove) {
	let nextAttrs = { ...attrs };
	for (const attrName of attrsToRemove) {
		const parts = attrName.split(".");
		if (parts.length === 1) {
			delete nextAttrs[attrName];
			continue;
		}
		let source = nextAttrs;
		for (let i = 0; i < parts.length - 1; i += 1) {
			if (source == null || typeof source !== "object") {
				source = null;
				break;
			}
			source = source[parts[i]];
		}
		if (source == null || typeof source !== "object") continue;
		let target = nextAttrs;
		for (let i = 0; i < parts.length - 1; i += 1) {
			const key = parts[i];
			const value = target[key];
			target[key] = { ...value };
			target = target[key];
		}
		delete target[parts[parts.length - 1]];
	}
	return nextAttrs;
}
const decreaseListIndent = () => ({ editor, tr, dispatch }) => {
	const handled = changeListLevel(-1, editor, tr);
	if (handled && dispatch) dispatch(tr);
	return handled;
};
const removeNumberingProperties = ({ checkType = "startParagraph" } = {}) => (props) => {
	const { tr, state, editor, dispatch } = props;
	const { node: paragraph, pos } = findParentNode(isList)(state.selection) || {};
	if (!paragraph) return false;
	if (checkType === "empty" && !isVisuallyEmptyParagraph(paragraph)) return false;
	if (checkType === "startParagraph") {
		const { $from, empty: empty$1 } = state.selection;
		if ((!empty$1 || $from.parentOffset !== 0) && !isVisuallyEmptyParagraph(paragraph)) return false;
	}
	if (getResolvedParagraphProperties(paragraph).numberingProperties.ilvl > 0) {
		const outdented = decreaseListIndent()(props);
		if (outdented) tr.scrollIntoView();
		return outdented;
	} else updateNumberingProperties(null, paragraph, pos, editor, tr);
	if (dispatch) dispatch(tr);
	return true;
};
function isVisuallyEmptyParagraph(node) {
	if (!node || node.type.name !== "paragraph") return false;
	let hasHardBreak = false;
	node.descendants((n) => {
		if (n.type && n.type.name === "hardBreak") {
			hasHardBreak = true;
			return false;
		}
		return true;
	});
	if (hasHardBreak) return false;
	if ((node.textContent || "").replace(/\u200b/g, "").trim().length > 0) return false;
	let hasInlineLeaf = false;
	node.descendants((n) => {
		if (n.isInline && n.isLeaf && n.type?.name !== "hardBreak" && n.type?.name !== "run") {
			hasInlineLeaf = true;
			return false;
		}
		return true;
	});
	if (hasInlineLeaf) return false;
	return true;
}
const first = (commands$1) => (props) => {
	const items = typeof commands$1 === "function" ? commands$1(props) : commands$1;
	for (let i = 0; i < items.length; i += 1) if (items[i](props)) return true;
	return false;
};
const command = (fn) => (props) => fn(props);
const insertTabChar = () => ({ tr }) => {
	tr.insertText("	", tr.selection.from, tr.selection.to);
	return true;
};
const insertTabCharacter = ({ tr, state, dispatch }) => {
	const { from: from$1 } = tr.selection;
	const tabText = state.schema.text("	");
	tr = tr.replaceSelectionWith(tabText);
	tr = tr.setSelection(TextSelection.create(tr.doc, from$1 + 1));
	if (dispatch) dispatch(tr);
	return true;
};
const insertTabNode = () => ({ tr, state, dispatch }) => {
	let newPos = tr.selection.from;
	const tabNode = state.schema?.nodes?.tab?.create();
	if (!tabNode) return insertTabCharacter({
		tr,
		state,
		dispatch
	});
	const { from: from$1 } = tr.selection;
	const $pos = tr.doc.resolve(from$1);
	if ($pos.parent.type === state.schema.nodes.run) if (from$1 === $pos.end()) newPos = $pos.end() + 1;
	else if (from$1 === $pos.start()) newPos = $pos.start() - 1;
	else {
		splitRunAtCursor()({
			tr,
			state
		});
		newPos = tr.selection.from;
	}
	tr.insert(newPos, tabNode);
	tr = tr.setSelection(TextSelection.create(tr.doc, newPos + tabNode.nodeSize));
	if (dispatch) dispatch(tr);
	return true;
};
const setMeta = (key, value) => ({ tr }) => {
	tr.setMeta(key, value);
	return true;
};
var deleteSelection = (state, dispatch) => {
	if (state.selection.empty) return false;
	if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
	return true;
};
function atBlockStart(state, view) {
	let { $cursor } = state.selection;
	if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
	return $cursor;
}
var joinBackward = (state, dispatch, view) => {
	let $cursor = atBlockStart(state, view);
	if (!$cursor) return false;
	let $cut = findCutBefore($cursor);
	if (!$cut) {
		let range = $cursor.blockRange(), target = range && liftTarget(range);
		if (target == null) return false;
		if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
		return true;
	}
	let before = $cut.nodeBefore;
	if (deleteBarrier(state, $cut, dispatch, -1)) return true;
	if ($cursor.parent.content.size == 0 && (textblockAt(before, "end") || NodeSelection.isSelectable(before))) for (let depth = $cursor.depth;; depth--) {
		let delStep = replaceStep$1(state.doc, $cursor.before(depth), $cursor.after(depth), Slice.empty);
		if (delStep && delStep.slice.size < delStep.to - delStep.from) {
			if (dispatch) {
				let tr = state.tr.step(delStep);
				tr.setSelection(textblockAt(before, "end") ? Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : NodeSelection.create(tr.doc, $cut.pos - before.nodeSize));
				dispatch(tr.scrollIntoView());
			}
			return true;
		}
		if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
	}
	if (before.isAtom && $cut.depth == $cursor.depth - 1) {
		if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
		return true;
	}
	return false;
};
function textblockAt(node, side, only = false) {
	for (let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild) {
		if (scan.isTextblock) return true;
		if (only && scan.childCount != 1) return false;
	}
	return false;
}
var selectNodeBackward = (state, dispatch, view) => {
	let { $head, empty: empty$1 } = state.selection, $cut = $head;
	if (!empty$1) return false;
	if ($head.parent.isTextblock) {
		if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
		$cut = findCutBefore($head);
	}
	let node = $cut && $cut.nodeBefore;
	if (!node || !NodeSelection.isSelectable(node)) return false;
	if (dispatch) dispatch(state.tr.setSelection(NodeSelection.create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
	return true;
};
function findCutBefore($pos) {
	if (!$pos.parent.type.spec.isolating) for (let i = $pos.depth - 1; i >= 0; i--) {
		if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
		if ($pos.node(i).type.spec.isolating) break;
	}
	return null;
}
function atBlockEnd(state, view) {
	let { $cursor } = state.selection;
	if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
	return $cursor;
}
var joinForward = (state, dispatch, view) => {
	let $cursor = atBlockEnd(state, view);
	if (!$cursor) return false;
	let $cut = findCutAfter($cursor);
	if (!$cut) return false;
	let after = $cut.nodeAfter;
	if (deleteBarrier(state, $cut, dispatch, 1)) return true;
	if ($cursor.parent.content.size == 0 && (textblockAt(after, "start") || NodeSelection.isSelectable(after))) {
		let delStep = replaceStep$1(state.doc, $cursor.before(), $cursor.after(), Slice.empty);
		if (delStep && delStep.slice.size < delStep.to - delStep.from) {
			if (dispatch) {
				let tr = state.tr.step(delStep);
				tr.setSelection(textblockAt(after, "start") ? Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : NodeSelection.create(tr.doc, tr.mapping.map($cut.pos)));
				dispatch(tr.scrollIntoView());
			}
			return true;
		}
	}
	if (after.isAtom && $cut.depth == $cursor.depth - 1) {
		if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
		return true;
	}
	return false;
};
var selectNodeForward = (state, dispatch, view) => {
	let { $head, empty: empty$1 } = state.selection, $cut = $head;
	if (!empty$1) return false;
	if ($head.parent.isTextblock) {
		if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
		$cut = findCutAfter($head);
	}
	let node = $cut && $cut.nodeAfter;
	if (!node || !NodeSelection.isSelectable(node)) return false;
	if (dispatch) dispatch(state.tr.setSelection(NodeSelection.create(state.doc, $cut.pos)).scrollIntoView());
	return true;
};
function findCutAfter($pos) {
	if (!$pos.parent.type.spec.isolating) for (let i = $pos.depth - 1; i >= 0; i--) {
		let parent = $pos.node(i);
		if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
		if (parent.type.spec.isolating) break;
	}
	return null;
}
var joinUp = (state, dispatch) => {
	let sel = state.selection, nodeSel = sel instanceof NodeSelection, point;
	if (nodeSel) {
		if (sel.node.isTextblock || !canJoin(state.doc, sel.from)) return false;
		point = sel.from;
	} else {
		point = joinPoint(state.doc, sel.from, -1);
		if (point == null) return false;
	}
	if (dispatch) {
		let tr = state.tr.join(point);
		if (nodeSel) tr.setSelection(NodeSelection.create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
		dispatch(tr.scrollIntoView());
	}
	return true;
};
var joinDown = (state, dispatch) => {
	let sel = state.selection, point;
	if (sel instanceof NodeSelection) {
		if (sel.node.isTextblock || !canJoin(state.doc, sel.to)) return false;
		point = sel.to;
	} else {
		point = joinPoint(state.doc, sel.to, 1);
		if (point == null) return false;
	}
	if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
	return true;
};
var newlineInCode = (state, dispatch) => {
	let { $head, $anchor } = state.selection;
	if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
	if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
	return true;
};
function defaultBlockAt(match$1) {
	for (let i = 0; i < match$1.edgeCount; i++) {
		let { type } = match$1.edge(i);
		if (type.isTextblock && !type.hasRequiredAttrs()) return type;
	}
	return null;
}
var exitCode = (state, dispatch) => {
	let { $head, $anchor } = state.selection;
	if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
	let above = $head.node(-1), after = $head.indexAfter(-1), type = defaultBlockAt(above.contentMatchAt(after));
	if (!type || !above.canReplaceWith(after, after, type)) return false;
	if (dispatch) {
		let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
		tr.setSelection(Selection.near(tr.doc.resolve(pos), 1));
		dispatch(tr.scrollIntoView());
	}
	return true;
};
var createParagraphNear = (state, dispatch) => {
	let sel = state.selection, { $from, $to } = sel;
	if (sel instanceof AllSelection || $from.parent.inlineContent || $to.parent.inlineContent) return false;
	let type = defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
	if (!type || !type.isTextblock) return false;
	if (dispatch) {
		let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
		let tr = state.tr.insert(side, type.createAndFill());
		tr.setSelection(TextSelection.create(tr.doc, side + 1));
		dispatch(tr.scrollIntoView());
	}
	return true;
};
var liftEmptyBlock = (state, dispatch) => {
	let { $cursor } = state.selection;
	if (!$cursor || $cursor.parent.content.size) return false;
	if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
		let before = $cursor.before();
		if (canSplit(state.doc, before)) {
			if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
			return true;
		}
	}
	let range = $cursor.blockRange(), target = range && liftTarget(range);
	if (target == null) return false;
	if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
	return true;
};
function splitBlockAs(splitNode) {
	return (state, dispatch) => {
		let { $from, $to } = state.selection;
		if (state.selection instanceof NodeSelection && state.selection.node.isBlock) {
			if (!$from.parentOffset || !canSplit(state.doc, $from.pos)) return false;
			if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
			return true;
		}
		if (!$from.depth) return false;
		let types = [];
		let splitDepth, deflt, atEnd = false, atStart = false;
		for (let d = $from.depth;; d--) if ($from.node(d).isBlock) {
			atEnd = $from.end(d) == $from.pos + ($from.depth - d);
			atStart = $from.start(d) == $from.pos - ($from.depth - d);
			deflt = defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
			let splitType = splitNode && splitNode($to.parent, atEnd, $from);
			types.unshift(splitType || (atEnd && deflt ? { type: deflt } : null));
			splitDepth = d;
			break;
		} else {
			if (d == 1) return false;
			types.unshift(null);
		}
		let tr = state.tr;
		if (state.selection instanceof TextSelection || state.selection instanceof AllSelection) tr.deleteSelection();
		let splitPos = tr.mapping.map($from.pos);
		let can = canSplit(tr.doc, splitPos, types.length, types);
		if (!can) {
			types[0] = deflt ? { type: deflt } : null;
			can = canSplit(tr.doc, splitPos, types.length, types);
		}
		if (!can) return false;
		tr.split(splitPos, types.length, types);
		if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
			let first$1 = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first$1);
			if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
		}
		if (dispatch) dispatch(tr.scrollIntoView());
		return true;
	};
}
var splitBlock$1 = splitBlockAs();
var selectAll = (state, dispatch) => {
	if (dispatch) dispatch(state.tr.setSelection(new AllSelection(state.doc)));
	return true;
};
function joinMaybeClear(state, $pos, dispatch) {
	let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
	if (!before || !after || !before.type.compatibleContent(after.type)) return false;
	if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
		if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
		return true;
	}
	if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || canJoin(state.doc, $pos.pos))) return false;
	if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
	return true;
}
function deleteBarrier(state, $cut, dispatch, dir) {
	let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match$1;
	let isolated = before.type.spec.isolating || after.type.spec.isolating;
	if (!isolated && joinMaybeClear(state, $cut, dispatch)) return true;
	let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
	if (canDelAfter && (conn = (match$1 = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match$1.matchType(conn[0] || after.type).validEnd) {
		if (dispatch) {
			let end$1 = $cut.pos + after.nodeSize, wrap = Fragment$1.empty;
			for (let i = conn.length - 1; i >= 0; i--) wrap = Fragment$1.from(conn[i].create(null, wrap));
			wrap = Fragment$1.from(before.copy(wrap));
			let tr = state.tr.step(new ReplaceAroundStep$1($cut.pos - 1, end$1, $cut.pos, end$1, new Slice(wrap, 1, 0), conn.length, true));
			let $joinAt = tr.doc.resolve(end$1 + 2 * conn.length);
			if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && canJoin(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
			dispatch(tr.scrollIntoView());
		}
		return true;
	}
	let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : Selection.findFrom($cut, 1);
	let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && liftTarget(range);
	if (target != null && target >= $cut.depth) {
		if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
		return true;
	}
	if (canDelAfter && textblockAt(after, "start", true) && textblockAt(before, "end")) {
		let at = before, wrap = [];
		for (;;) {
			wrap.push(at);
			if (at.isTextblock) break;
			at = at.lastChild;
		}
		let afterText = after, afterDepth = 1;
		for (; !afterText.isTextblock; afterText = afterText.firstChild) afterDepth++;
		if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
			if (dispatch) {
				let end$1 = Fragment$1.empty;
				for (let i = wrap.length - 1; i >= 0; i--) end$1 = Fragment$1.from(wrap[i].copy(end$1));
				dispatch(state.tr.step(new ReplaceAroundStep$1($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new Slice(end$1, wrap.length, 0), 0, true)).scrollIntoView());
			}
			return true;
		}
	}
	return false;
}
function selectTextblockSide(side) {
	return function(state, dispatch) {
		let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
		let depth = $pos.depth;
		while ($pos.node(depth).isInline) {
			if (!depth) return false;
			depth--;
		}
		if (!$pos.node(depth).isTextblock) return false;
		if (dispatch) dispatch(state.tr.setSelection(TextSelection.create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
		return true;
	};
}
var selectTextblockStart = selectTextblockSide(-1);
var selectTextblockEnd = selectTextblockSide(1);
function setBlockType(nodeType, attrs = null) {
	return function(state, dispatch) {
		let applicable = false;
		for (let i = 0; i < state.selection.ranges.length && !applicable; i++) {
			let { $from: { pos: from$1 }, $to: { pos: to } } = state.selection.ranges[i];
			state.doc.nodesBetween(from$1, to, (node, pos) => {
				if (applicable) return false;
				if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
				if (node.type == nodeType) applicable = true;
				else {
					let $pos = state.doc.resolve(pos), index = $pos.index();
					applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
				}
			});
		}
		if (!applicable) return false;
		if (dispatch) {
			let tr = state.tr;
			for (let i = 0; i < state.selection.ranges.length; i++) {
				let { $from: { pos: from$1 }, $to: { pos: to } } = state.selection.ranges[i];
				tr.setBlockType(from$1, to, nodeType, attrs);
			}
			dispatch(tr.scrollIntoView());
		}
		return true;
	};
}
function chainCommands(...commands$1) {
	return function(state, dispatch, view) {
		for (let i = 0; i < commands$1.length; i++) if (commands$1[i](state, dispatch, view)) return true;
		return false;
	};
}
var backspace = chainCommands(deleteSelection, joinBackward, selectNodeBackward);
var del = chainCommands(deleteSelection, joinForward, selectNodeForward);
var pcBaseKeymap = {
	"Enter": chainCommands(newlineInCode, createParagraphNear, liftEmptyBlock, splitBlock$1),
	"Mod-Enter": exitCode,
	"Backspace": backspace,
	"Mod-Backspace": backspace,
	"Shift-Backspace": backspace,
	"Delete": del,
	"Mod-Delete": del,
	"Mod-a": selectAll
};
var macBaseKeymap = {
	"Ctrl-h": pcBaseKeymap["Backspace"],
	"Alt-Backspace": pcBaseKeymap["Mod-Backspace"],
	"Ctrl-d": pcBaseKeymap["Delete"],
	"Ctrl-Alt-Backspace": pcBaseKeymap["Mod-Delete"],
	"Alt-Delete": pcBaseKeymap["Mod-Delete"],
	"Alt-d": pcBaseKeymap["Mod-Delete"],
	"Ctrl-a": selectTextblockStart,
	"Ctrl-e": selectTextblockEnd
};
for (let key in pcBaseKeymap) macBaseKeymap[key] = pcBaseKeymap[key];
typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform && os.platform();
const liftEmptyBlock$1 = () => ({ state, dispatch }) => liftEmptyBlock(state, dispatch);
const createParagraphNear$1 = () => ({ state, dispatch }) => {
	return createParagraphNear(state, dispatch);
};
const newlineInCode$1 = () => ({ state, dispatch }) => newlineInCode(state, dispatch);
const exitCode$1 = () => ({ state, dispatch }) => {
	return exitCode(state, dispatch);
};
function resolveHeaderFooterSelection({ tr }) {
	return tr?.selection;
}
function findParagraph($pos) {
	for (let depth = $pos.depth; depth >= 0; depth--) {
		const node = $pos.node(depth);
		if (node.type.name === "paragraph") return {
			node,
			pos: $pos.before(depth)
		};
	}
	return null;
}
function addParagraphRunProperty(tr, mark) {
	if (!mark) return;
	updateEmptyParagraphRunProperties(tr, (currentRunProperties) => {
		const nextRunProperties = { ...currentRunProperties || {} };
		const decodedRunProperties = decodeRPrFromMarks([mark]);
		if (decodedRunProperties && typeof decodedRunProperties === "object") Object.assign(nextRunProperties, decodedRunProperties);
		return Object.keys(nextRunProperties).length > 0 ? nextRunProperties : null;
	});
}
function removeParagraphRunProperty(tr, mark) {
	if (!mark) return;
	updateEmptyParagraphRunProperties(tr, (currentRunProperties) => {
		const nextRunProperties = { ...currentRunProperties || {} };
		removeRunPropertiesForMark(nextRunProperties, mark);
		return Object.keys(nextRunProperties).length > 0 ? nextRunProperties : null;
	});
}
function updateEmptyParagraphRunProperties(tr, updater) {
	const { selection } = tr;
	if (!selection.empty) return;
	const result = findParagraph(selection.$head);
	if (!result) return;
	const { node: paragraph, pos: paragraphPos } = result;
	if (paragraph.content.size > 0) return;
	const currentParagraphProperties = paragraph.attrs.paragraphProperties;
	const newRunProperties = updater(currentParagraphProperties?.runProperties || null);
	tr.setNodeMarkup(paragraphPos, void 0, {
		...paragraph.attrs,
		paragraphProperties: {
			...currentParagraphProperties || {},
			runProperties: newRunProperties
		}
	});
}
function removeRunPropertiesForMark(runProperties, mark) {
	const type = mark?.type?.name ?? mark?.type;
	if (!type) return;
	if (type === "textStyle") {
		Object.keys(mark.attrs || {}).forEach((attr) => {
			delete runProperties[attr];
		});
		return;
	}
	switch (type) {
		case "bold":
		case "italic":
		case "strike":
		case "underline":
		case "highlight":
			delete runProperties[type];
			break;
		case "link":
			delete runProperties.styleId;
			break;
	}
}
function canSetMark(state, tr, newMarkType) {
	const selection = resolveHeaderFooterSelection({ tr });
	let cursor = null;
	if (isTextSelection(selection)) cursor = selection.$cursor;
	if (cursor) {
		const currentMarks = state.storedMarks ?? cursor.marks();
		return !!newMarkType.isInSet(currentMarks) || !currentMarks.some((mark) => mark.type.excludes(newMarkType));
	}
	return selection.ranges.some(({ $from, $to }) => {
		let someNodeSupportsMark = $from.depth === 0 ? state.doc.inlineContent && state.doc.type.allowsMarkType(newMarkType) : false;
		state.doc.nodesBetween($from.pos, $to.pos, (node, _pos, parent) => {
			if (someNodeSupportsMark) return false;
			if (node.isInline) {
				const parentAllowsMarkType = !parent || parent.type.allowsMarkType(newMarkType);
				const currentMarksAllowMarkType = !!newMarkType.isInSet(node.marks) || !node.marks.some((otherMark) => otherMark.type.excludes(newMarkType));
				someNodeSupportsMark = parentAllowsMarkType && currentMarksAllowMarkType;
			}
			return !someNodeSupportsMark;
		});
		return someNodeSupportsMark;
	});
}
const setMark = (typeOrName, attributes = {}) => ({ tr, state, dispatch }) => {
	const { empty: empty$1, ranges } = resolveHeaderFooterSelection({ tr });
	const type = getMarkType(typeOrName, state.schema);
	if (dispatch) if (empty$1) {
		const oldAttributes = Attribute.getMarkAttributes(state, type);
		const newMark = type.create({
			...oldAttributes,
			...attributes
		});
		tr.addStoredMark(newMark);
		addParagraphRunProperty(tr, newMark);
	} else ranges.forEach((range) => {
		const from$1 = range.$from.pos;
		const to = range.$to.pos;
		state.doc.nodesBetween(from$1, to, (node, pos) => {
			const trimmedFrom = Math.max(pos, from$1);
			const trimmedTo = Math.min(pos + node.nodeSize, to);
			if (node.marks.find((mark) => mark.type === type)) node.marks.forEach((mark) => {
				if (type === mark.type) tr.addMark(trimmedFrom, trimmedTo, type.create({
					...mark.attrs,
					...attributes
				}));
			});
			else tr.addMark(trimmedFrom, trimmedTo, type.create(attributes));
		});
	});
	return canSetMark(state, tr, type);
};
const unsetMark = (typeOrName, options = {}) => ({ tr, state, dispatch }) => {
	const { extendEmptyMarkRange = false } = options;
	const selection = resolveHeaderFooterSelection({ tr });
	const type = getMarkType(typeOrName, state.schema);
	const { $from, empty: empty$1, ranges } = selection;
	if (!dispatch) return true;
	const markToRemove = (tr.storedMarks ?? state.storedMarks ?? $from.marks()).find((mark) => mark.type === type) ?? {
		type,
		attrs: {}
	};
	if (empty$1 && extendEmptyMarkRange) {
		let { from: from$1, to } = selection;
		const attrs = $from.marks().find((mark) => mark.type === type)?.attrs;
		const range = getMarkRange($from, type, attrs);
		if (range) {
			from$1 = range.from;
			to = range.to;
		}
		tr.removeMark(from$1, to, type);
	} else ranges.forEach((range) => {
		tr.removeMark(range.$from.pos, range.$to.pos, type);
	});
	tr.removeStoredMark(type);
	removeParagraphRunProperty(tr, markToRemove);
	return true;
};
const unsetAllMarks = () => ({ tr, dispatch }) => {
	const { empty: empty$1, ranges } = resolveHeaderFooterSelection({ tr });
	if (dispatch) {
		if (!empty$1) ranges.forEach((range) => {
			const from$1 = range.$from.pos;
			const to = range.$to.pos;
			const seen = /* @__PURE__ */ new Set();
			const marksToRemove = [];
			tr.doc.nodesBetween(from$1, to, (node) => {
				if (!node.isInline || !node.isLeaf) return;
				for (const mark of node.marks) {
					const key = mark.type.name + "\0" + JSON.stringify(mark.attrs);
					if (!seen.has(key)) {
						seen.add(key);
						marksToRemove.push(mark);
					}
				}
			});
			for (const mark of marksToRemove) tr.removeMark(from$1, to, mark);
		});
		tr.setStoredMarks([]);
	}
	return true;
};
const toggleMark = (typeOrName, attrs = {}, options = {}) => ({ state, commands: commands$1 }) => {
	const { extendEmptyMarkRange = false } = options;
	const type = getMarkType(typeOrName, state.schema);
	if (isMarkActive(state, type, attrs)) return commands$1.unsetMark(type, { extendEmptyMarkRange });
	return commands$1.setMark(type, attrs);
};
const clearNodes = () => ({ state, tr, dispatch }) => {
	const { selection } = tr;
	const { ranges } = selection;
	if (!dispatch) return true;
	ranges.forEach(({ $from, $to }) => {
		state.doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
			if (node.type.isText) return;
			const { doc: doc$1, mapping } = tr;
			const $mappedFrom = doc$1.resolve(mapping.map(pos));
			const $mappedTo = doc$1.resolve(mapping.map(pos + node.nodeSize));
			const nodeRange = $mappedFrom.blockRange($mappedTo);
			if (!nodeRange) return;
			const targetLiftDepth = liftTarget(nodeRange);
			if (node.type.isTextblock) {
				const { defaultType } = $mappedFrom.parent.contentMatchAt($mappedFrom.index());
				tr.setNodeMarkup(nodeRange.start, defaultType);
			}
			if (targetLiftDepth || targetLiftDepth === 0) tr.lift(nodeRange, targetLiftDepth);
		});
	});
	return true;
};
const setNode = (typeOrName, attrs = {}) => ({ state, dispatch, chain }) => {
	const type = getNodeType(typeOrName, state.schema);
	if (!type.isTextblock) return false;
	return chain().command(({ commands: commands$1 }) => {
		if (setBlockType(type, attrs)(state)) return true;
		return commands$1.clearNodes();
	}).command(({ state: updatedState }) => {
		return setBlockType(type, attrs)(updatedState, dispatch);
	}).run();
};
const toggleNode = (typeOrName, toggleTypeOrName, attrs = {}) => ({ state, commands: commands$1 }) => {
	const type = getNodeType(typeOrName, state.schema);
	const toggleType = getNodeType(toggleTypeOrName, state.schema);
	if (isNodeActive(state, type, attrs)) return commands$1.setNode(toggleType);
	return commands$1.setNode(type, attrs);
};
const selectAll$1 = () => ({ state, dispatch }) => selectAll(state, dispatch);
const deleteSelection$1 = () => ({ state, tr, dispatch }) => {
	const { from: from$1, to, empty: empty$1 } = state.selection;
	if (typeof document !== "undefined" && document.getSelection) {
		const currentDomSelection = document.getSelection();
		if (empty$1 && currentDomSelection?.baseNode?.data?.length === 1) return false;
	}
	if (empty$1) return deleteSelection(state, dispatch);
	let hasListContent = false;
	state.doc.nodesBetween(from$1, to, (node) => {
		if (node.type.name === "orderedList" || node.type.name === "bulletList" || node.type.name === "listItem") {
			hasListContent = true;
			return false;
		}
	});
	if (hasListContent) {
		const transaction = tr || state.tr;
		transaction.deleteRange(from$1, to);
		if (dispatch) dispatch(transaction);
		return true;
	}
	return deleteSelection(state, dispatch);
};
const updateAttributes = (typeOrName, attrs = {}) => ({ tr, state, dispatch }) => {
	let nodeType = null;
	let markType = null;
	const schemaType = getSchemaTypeNameByName(typeof typeOrName === "string" ? typeOrName : typeOrName.name, state.schema);
	if (!schemaType) return false;
	if (schemaType === "node") nodeType = getNodeType(typeOrName, state.schema);
	if (schemaType === "mark") markType = getMarkType(typeOrName, state.schema);
	if (dispatch) {
		tr.selection.ranges.forEach((range) => {
			const from$1 = range.$from.pos;
			const to = range.$to.pos;
			state.doc.nodesBetween(from$1, to, (node, pos) => {
				if (nodeType && nodeType === node.type) {
					const resolvedAttrs = mergeAttributes(node.attrs, attrs);
					tr.setNodeMarkup(pos, void 0, resolvedAttrs);
				}
				if (markType && node.marks.length) node.marks.forEach((mark) => {
					if (markType === mark.type) {
						const trimmedFrom = Math.max(pos, from$1);
						const trimmedTo = Math.min(pos + node.nodeSize, to);
						const resolvedAttrs = mergeAttributes(mark.attrs, attrs);
						tr.addMark(trimmedFrom, trimmedTo, markType.create(resolvedAttrs));
					}
				});
			});
		});
		dispatch(tr);
	}
	return true;
};
var isPlainObject$2 = (value) => Boolean(value) && typeof value === "object" && !Array.isArray(value);
var assignNestedValue = (target, path, value) => {
	if (!path.includes(".")) {
		target[path] = value;
		return;
	}
	const parts = path.split(".");
	let current = target;
	for (let i = 0; i < parts.length; i += 1) {
		const part = parts[i];
		if (i === parts.length - 1) current[part] = value;
		else {
			if (!isPlainObject$2(current[part])) current[part] = {};
			current = current[part];
		}
	}
};
var mergeAttributes = (existingAttrs = {}, newAttrs = {}) => {
	const expandedAttrs = JSON.parse(JSON.stringify(existingAttrs));
	Object.entries(newAttrs).forEach(([key, value]) => {
		assignNestedValue(expandedAttrs, key, value);
	});
	return expandedAttrs;
};
const resetAttributes = (typeOrName, attrs) => ({ tr, state, dispatch }) => {
	let nodeType = null;
	let markType = null;
	const schemaType = getSchemaTypeNameByName(typeof typeOrName === "string" ? typeOrName : typeOrName.name, state.schema);
	if (!schemaType) return false;
	if (schemaType === "node") nodeType = getNodeType(typeOrName, state.schema);
	if (schemaType === "mark") markType = getMarkType(typeOrName, state.schema);
	if (dispatch) {
		tr.selection.ranges.forEach((range) => {
			state.doc.nodesBetween(range.$from.pos, range.$to.pos, (node, pos) => {
				if (nodeType && nodeType === node.type) tr.setNodeMarkup(pos, void 0, deleteProps(node.attrs, attrs));
				if (markType && node.marks.length) node.marks.forEach((mark) => {
					if (markType === mark.type) tr.addMark(pos, pos + node.nodeSize, markType.create(deleteProps(mark.attrs, attrs)));
				});
			});
		});
		dispatch(tr);
	}
	return true;
};
const joinUp$1 = () => ({ state, dispatch }) => joinUp(state, dispatch);
const joinDown$1 = () => ({ state, dispatch }) => joinDown(state, dispatch);
const joinBackward$1 = () => ({ state, dispatch }) => {
	const { selection, doc: doc$1 } = state;
	const { $from } = selection;
	if (!$from.parent.isTextblock || $from.parentOffset > 0) return joinBackward(state, dispatch);
	const beforePos = $from.before();
	const nodeBefore = doc$1.resolve(beforePos).nodeBefore;
	const nodeAfter = doc$1.resolve(beforePos).nodeAfter;
	const isList$1 = (node) => node?.type.name === "orderedList" || node?.type.name === "bulletList";
	if (isList$1(nodeBefore) || isList$1(nodeAfter)) return false;
	return joinBackward(state, dispatch);
};
const joinForward$1 = () => ({ state, dispatch }) => {
	const { selection, doc: doc$1 } = state;
	const { $from } = selection;
	if (!$from.parent.isTextblock || $from.parentOffset > 0) return joinForward(state, dispatch);
	const beforePos = $from.before();
	const nodeBefore = doc$1.resolve(beforePos).nodeBefore;
	const nodeAfter = doc$1.resolve(beforePos).nodeAfter;
	const isList$1 = (node) => node?.type.name === "orderedList" || node?.type.name === "bulletList";
	if (isList$1(nodeBefore) || isList$1(nodeAfter)) return false;
	return joinForward(state, dispatch);
};
const selectNodeBackward$1 = () => ({ state, dispatch }) => {
	return selectNodeBackward(state, dispatch);
};
const selectNodeForward$1 = () => ({ state, dispatch }) => selectNodeForward(state, dispatch);
const selectTextblockStart$1 = () => ({ state, dispatch }) => selectTextblockStart(state, dispatch);
const selectTextblockEnd$1 = () => ({ state, dispatch }) => selectTextblockEnd(state, dispatch);
const insertContent = (value, options = {}) => ({ tr, commands: commands$1, editor }) => {
	if (options.contentType) {
		const validTypes = [
			"html",
			"markdown",
			"text",
			"schema"
		];
		if (!validTypes.includes(options.contentType)) {
			console.error(`[insertContent] Invalid contentType: "${options.contentType}". Use: ${validTypes.join(", ")}`);
			return false;
		}
		try {
			const jsonContent = processContent({
				content: value,
				type: options.contentType,
				editor,
				onUnsupportedContent: options.onUnsupportedContent ?? editor.options?.onUnsupportedContent,
				warnOnUnsupportedContent: options.warnOnUnsupportedContent ?? editor.options?.warnOnUnsupportedContent
			}).toJSON();
			const insertionContent = jsonContent?.type === "doc" && Array.isArray(jsonContent.content) ? jsonContent.content : jsonContent;
			const ok = commands$1.insertContentAt({
				from: tr.selection.from,
				to: tr.selection.to
			}, insertionContent, options);
			if (ok && (options.contentType === "html" || options.contentType === "markdown")) Promise.resolve().then(() => editor.migrateListsToV2?.());
			return ok;
		} catch (error) {
			console.error(`[insertContent] Failed to process ${options.contentType}:`, error);
			return false;
		}
	}
	return commands$1.insertContentAt({
		from: tr.selection.from,
		to: tr.selection.to
	}, value, options);
};
var removeWhitespaces = (node) => {
	const children = node.childNodes;
	for (let i = children.length - 1; i >= 0; i -= 1) {
		const child = children[i];
		if (child.nodeType === 3 && child.nodeValue && /^(\n\s\s|\n)$/.test(child.nodeValue)) node.removeChild(child);
		else if (child.nodeType === 1) removeWhitespaces(child);
	}
	return node;
};
function elementFromString(value, editor) {
	const html = htmlHandler(`<body>${value}</body>`, editor);
	if (html === null) return null;
	return removeWhitespaces(html);
}
function createNodeFromContent(content, editor, options) {
	const schema = editor.schema;
	options = {
		slice: true,
		parseOptions: {},
		...options
	};
	const isJSONContent = typeof content === "object" && content !== null;
	const isTextContent = typeof content === "string";
	if (isJSONContent) try {
		if (Array.isArray(content) && content.length > 0) return Fragment$1.fromArray(content.map((item) => schema.nodeFromJSON(item)));
		const node = schema.nodeFromJSON(content);
		if (options.errorOnInvalidContent) node.check();
		return node;
	} catch (error) {
		if (options.errorOnInvalidContent) throw new Error("[super-editor error]: Invalid JSON content", { cause: error });
		console.warn("[super-editor warn]: Invalid content.", "Passed value:", content, "Error:", error);
		return createNodeFromContent("", editor, options);
	}
	if (isTextContent) {
		const element = elementFromString(content, editor);
		if (element === null) {
			console.warn("[super-editor] Cannot parse HTML content without a DOM. HTML insertion requires a browser environment or JSDOM. Skipping insertion.");
			return null;
		}
		if (options.errorOnInvalidContent) {
			let hasInvalidContent = false;
			let invalidContent = "";
			const contentCheckSchema = new Schema$1({
				topNode: schema.spec.topNode,
				marks: schema.spec.marks,
				nodes: schema.spec.nodes.append({ __supereditor__private__unknown__catch__all__node: {
					content: "inline*",
					group: "block",
					parseDOM: () => [{
						tag: "*",
						getAttrs: (e) => {
							hasInvalidContent = true;
							invalidContent = typeof e === "string" ? e : e.outerHTML;
							return null;
						}
					}]
				} })
			});
			if (options.slice) DOMParser$1.fromSchema(contentCheckSchema).parseSlice(element, options.parseOptions);
			else DOMParser$1.fromSchema(contentCheckSchema).parse(element, options.parseOptions);
			if (options.errorOnInvalidContent && hasInvalidContent) throw new Error("[super-editor error]: Invalid HTML content", { cause: /* @__PURE__ */ new Error(`Invalid element found: ${invalidContent}`) });
		}
		const parser = DOMParser$1.fromSchema(schema);
		if (options.slice) return parser.parseSlice(element, options.parseOptions).content;
		return parser.parse(element, options.parseOptions);
	}
	return createNodeFromContent("", editor, options);
}
function selectionToInsertionEnd(tr, startLen, bias) {
	const last = tr.steps.length - 1;
	if (last < startLen) return;
	const step = tr.steps[last];
	if (!(step instanceof ReplaceStep || step instanceof ReplaceAroundStep$1)) return;
	const map$1 = tr.mapping.maps[last];
	let end$1 = 0;
	map$1.forEach((_from, _to, _newFrom, newTo) => {
		if (end$1 === 0) end$1 = newTo;
	});
	tr.setSelection(Selection.near(tr.doc.resolve(end$1), bias));
}
var isFragment = (nodeOrFragment) => {
	return !("type" in nodeOrFragment);
};
var looksLikeHTML = (str) => /^\s*<[a-zA-Z][^>]*>.*<\/[a-zA-Z][^>]*>\s*$/s.test(str) || /^\s*<[a-zA-Z][^>]*\/>\s*$/.test(str) || /^\s*<(br|hr|img|input|meta|link|area|base|col|embed|param|source|track|wbr)\b[^>]*>\s*$/i.test(str);
const insertContentAt = (position, value, options) => ({ tr, dispatch, editor }) => {
	if (!dispatch) return true;
	options = {
		parseOptions: {},
		updateSelection: true,
		applyInputRules: false,
		applyPasteRules: false,
		asText: false,
		...options
	};
	let { from: from$1, to } = typeof position === "number" ? {
		from: position,
		to: position
	} : {
		from: position.from,
		to: position.to
	};
	const isBareString = typeof value === "string";
	const isArrayOfText = Array.isArray(value) && value.every((v) => typeof v === "string" || v && typeof v.text === "string");
	const isTextObject = !!value && typeof value === "object" && !Array.isArray(value) && typeof value.text === "string";
	if (options.asText || isArrayOfText || isTextObject || isBareString && !looksLikeHTML(value)) {
		let textContent$1;
		if (isArrayOfText) textContent$1 = value.map((v) => typeof v === "string" ? v : v && v.text || "").join("");
		else if (isTextObject) textContent$1 = value.text;
		else textContent$1 = typeof value === "string" ? value : "";
		tr.insertText(textContent$1, from$1, to);
		if (options.updateSelection) selectionToInsertionEnd(tr, tr.steps.length - 1, -1);
		if (options.applyInputRules) tr.setMeta("applyInputRules", {
			from: from$1,
			text: textContent$1
		});
		if (options.applyPasteRules) tr.setMeta("applyPasteRules", {
			from: from$1,
			text: textContent$1
		});
		return true;
	}
	let content;
	try {
		content = createNodeFromContent(value, editor, {
			parseOptions: {
				preserveWhitespace: "full",
				...options.parseOptions
			},
			errorOnInvalidContent: options.errorOnInvalidContent ?? editor.options.enableContentCheck
		});
	} catch (e) {
		editor.emit("contentError", {
			editor,
			error: e,
			disableCollaboration: () => {
				console.error("[super-editor error]: Unable to disable collaboration at this point in time");
			}
		});
		return false;
	}
	if (content === null) return false;
	let isOnlyTextContent = true;
	let isOnlyBlockContent = true;
	(isFragment(content) ? content : [content]).forEach((node) => {
		node.check();
		isOnlyTextContent = isOnlyTextContent ? node.isText && node.marks.length === 0 : false;
		isOnlyBlockContent = isOnlyBlockContent ? node.isBlock : false;
	});
	if (from$1 === to && isOnlyBlockContent) {
		const { parent } = tr.doc.resolve(from$1);
		if (parent.isTextblock && !parent.type.spec.code && !parent.childCount) {
			from$1 -= 1;
			to += 1;
		}
	}
	let newContent;
	if (isOnlyTextContent) {
		newContent = typeof value === "string" ? value : "";
		tr.insertText(newContent, from$1, to);
	} else {
		newContent = content;
		tr.replaceWith(from$1, to, newContent);
	}
	if (options.updateSelection) selectionToInsertionEnd(tr, tr.steps.length - 1, -1);
	if (options.applyInputRules) tr.setMeta("applyInputRules", {
		from: from$1,
		text: newContent
	});
	if (options.applyPasteRules) tr.setMeta("applyPasteRules", {
		from: from$1,
		text: newContent
	});
	return true;
};
const insertParagraphAt = ({ pos, text = "", sdBlockId, paraId, tracked }) => ({ state, dispatch }) => {
	const paragraphType = state.schema.nodes.paragraph;
	if (!paragraphType) return false;
	if (!Number.isInteger(pos) || pos < 0 || pos > state.doc.content.size) return false;
	const attrs = {
		...sdBlockId ? { sdBlockId } : void 0,
		...paraId ? { paraId } : void 0
	};
	const normalizedText = typeof text === "string" ? text : "";
	const content = normalizedText.length > 0 ? buildTextWithTabs(state.schema, normalizedText, void 0) : null;
	let paragraphNode;
	try {
		paragraphNode = paragraphType.createAndFill(attrs, content ?? void 0) ?? paragraphType.create(attrs, content ?? void 0);
	} catch {
		return false;
	}
	if (!paragraphNode) return false;
	try {
		const tr = state.tr.insert(pos, paragraphNode);
		if (!dispatch) return true;
		tr.setMeta("inputType", "programmatic");
		if (tracked === true) tr.setMeta("forceTrackChanges", true);
		else if (tracked === false) tr.setMeta("skipTrackChanges", true);
		dispatch(tr);
		return true;
	} catch {
		return false;
	}
};
const insertHeadingAt = ({ pos, level, text = "", sdBlockId, paraId, tracked }) => ({ state, dispatch }) => {
	const paragraphType = state.schema.nodes.paragraph;
	if (!paragraphType) return false;
	if (!Number.isInteger(pos) || pos < 0 || pos > state.doc.content.size) return false;
	if (!Number.isInteger(level) || level < 1 || level > 6) return false;
	const attrs = {
		...sdBlockId ? { sdBlockId } : void 0,
		...paraId ? { paraId } : void 0,
		paragraphProperties: {
			styleId: `Heading${level}`,
			numberingProperties: {
				numId: "0",
				ilvl: "0"
			}
		}
	};
	const normalizedText = typeof text === "string" ? text : "";
	const content = normalizedText.length > 0 ? buildTextWithTabs(state.schema, normalizedText, void 0) : null;
	let paragraphNode;
	try {
		paragraphNode = paragraphType.createAndFill(attrs, content ?? void 0) ?? paragraphType.create(attrs, content ?? void 0);
	} catch {
		return false;
	}
	if (!paragraphNode) return false;
	try {
		const tr = state.tr.insert(pos, paragraphNode);
		if (!dispatch) return true;
		tr.setMeta("inputType", "programmatic");
		if (tracked === true) tr.setMeta("forceTrackChanges", true);
		else if (tracked === false) tr.setMeta("skipTrackChanges", true);
		dispatch(tr);
		return true;
	} catch {
		return false;
	}
};
const undoInputRule = () => ({ state, dispatch }) => {
	const plugins = state.plugins;
	for (let i = 0; i < plugins.length; i += 1) {
		const plugin = plugins[i];
		let undoable;
		if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
			if (dispatch) {
				const tr = state.tr;
				const toUndo = undoable.transform;
				for (let j = toUndo.steps.length - 1; j >= 0; j -= 1) tr.step(toUndo.steps[j].invert(toUndo.docs[j]));
				if (undoable.text) {
					const marks = tr.doc.resolve(undoable.from).marks();
					tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks));
				} else tr.delete(undoable.from, undoable.to);
			}
			return true;
		}
	}
	return false;
};
const setBodyHeaderFooter = ({ headerInches, footerInches } = {}) => ({ editor }) => {
	if (!editor) {
		console.warn("[setBodyHeaderFooter] No editor instance provided");
		return false;
	}
	const hasHeader = typeof headerInches === "number";
	const hasFooter = typeof footerInches === "number";
	if (!hasHeader && !hasFooter) {
		console.warn("[setBodyHeaderFooter] No margin values provided");
		return false;
	}
	if (hasHeader && headerInches < 0) {
		console.warn("[setBodyHeaderFooter] headerInches must be >= 0, got:", headerInches);
		return false;
	}
	if (hasFooter && footerInches < 0) {
		console.warn("[setBodyHeaderFooter] footerInches must be >= 0, got:", footerInches);
		return false;
	}
	if (!editor.updatePageStyle) {
		console.warn("[setBodyHeaderFooter] editor.updatePageStyle is not available");
		return false;
	}
	const next = { ...(editor.getPageStyles?.() || {}).pageMargins || {} };
	if (hasHeader) next.header = headerInches;
	if (hasFooter) next.footer = footerInches;
	editor.updatePageStyle({ pageMargins: next });
	return true;
};
function findNearestParagraphWithSectPr(doc$1, pos) {
	let target = null;
	doc$1.descendants((node, nodePos) => {
		if (nodePos > pos) return false;
		if (node.type?.name === "paragraph" && node.attrs?.paragraphProperties?.sectPr) target = {
			node,
			pos: nodePos
		};
		return true;
	});
	return target;
}
const setSectionHeaderFooterAtSelection = ({ headerInches, footerInches } = {}) => ({ tr, state, editor }) => {
	if (!state || !editor) {
		console.warn("[setSectionHeaderFooterAtSelection] Missing state or editor");
		return false;
	}
	const hasHeader = typeof headerInches === "number";
	const hasFooter = typeof footerInches === "number";
	if (!hasHeader && !hasFooter) {
		console.warn("[setSectionHeaderFooterAtSelection] No margin values provided");
		return false;
	}
	if (hasHeader && headerInches < 0) {
		console.warn("[setSectionHeaderFooterAtSelection] headerInches must be >= 0, got:", headerInches);
		return false;
	}
	if (hasFooter && footerInches < 0) {
		console.warn("[setSectionHeaderFooterAtSelection] footerInches must be >= 0, got:", footerInches);
		return false;
	}
	const { from: from$1 } = state.selection;
	const found = findNearestParagraphWithSectPr(state.doc, from$1);
	if (!found) {
		console.warn("[setSectionHeaderFooterAtSelection] No section break found at or before selection");
		return false;
	}
	const { node, pos } = found;
	const paraProps = node.attrs?.paragraphProperties || null;
	const existingSectPr = paraProps?.sectPr || null;
	if (!existingSectPr) {
		console.warn("[setSectionHeaderFooterAtSelection] Paragraph found but has no sectPr");
		return false;
	}
	const sectPr = JSON.parse(JSON.stringify(existingSectPr));
	const updates = {};
	if (hasHeader) updates.headerInches = headerInches;
	if (hasFooter) updates.footerInches = footerInches;
	try {
		updateSectionMargins({
			type: "sectPr",
			sectPr
		}, updates);
	} catch (err) {
		console.error("[setSectionHeaderFooterAtSelection] Failed to update sectPr:", err);
		return false;
	}
	const newParagraphProperties = {
		...paraProps || {},
		sectPr
	};
	const resolvedMargins = getSectPrMargins(sectPr);
	const normalizedMargins = {
		header: resolvedMargins.header ?? null,
		footer: resolvedMargins.footer ?? null
	};
	const nextAttrs = {
		...node.attrs,
		paragraphProperties: newParagraphProperties,
		sectionMargins: normalizedMargins
	};
	tr.setNodeMarkup(pos, void 0, nextAttrs, node.marks);
	return true;
};
const insertSectionBreakAtSelection = ({ headerInches, footerInches } = {}) => ({ tr, state, editor }) => {
	if (!state || !editor) {
		console.warn("[insertSectionBreakAtSelection] Missing state or editor");
		return false;
	}
	if (typeof headerInches === "number" && headerInches < 0) {
		console.warn("[insertSectionBreakAtSelection] headerInches must be >= 0, got:", headerInches);
		return false;
	}
	if (typeof footerInches === "number" && footerInches < 0) {
		console.warn("[insertSectionBreakAtSelection] footerInches must be >= 0, got:", footerInches);
		return false;
	}
	const { $from } = state.selection;
	let paraPos = 0;
	let paragraph = null;
	for (let d = $from.depth; d >= 0; d -= 1) {
		const node = $from.node(d);
		if (node?.type?.name === "paragraph") {
			paraPos = $from.before(d);
			paragraph = node;
			break;
		}
	}
	if (!paragraph || paraPos <= 0) {
		console.warn("[insertSectionBreakAtSelection] No paragraph found at selection");
		return false;
	}
	const paraProps = paragraph.attrs?.paragraphProperties || null;
	const existingSectPr = paraProps?.sectPr || null;
	const sectPr = existingSectPr ? JSON.parse(JSON.stringify(existingSectPr)) : {
		type: "element",
		name: "w:sectPr",
		elements: []
	};
	const updates = {};
	if (headerInches != null) updates.headerInches = headerInches;
	if (footerInches != null) updates.footerInches = footerInches;
	if (Object.keys(updates).length) updateSectionMargins({
		type: "sectPr",
		sectPr
	}, updates);
	const margins = getSectPrMargins(sectPr) || {};
	const sectionMargins = {
		header: margins.header ?? null,
		footer: margins.footer ?? null
	};
	const newParagraphProperties = {
		...paraProps || {},
		sectPr
	};
	const nextAttrs = {
		...paragraph.attrs,
		paragraphProperties: newParagraphProperties,
		pageBreakSource: "sectPr",
		sectionMargins
	};
	tr.setNodeMarkup(paraPos, void 0, nextAttrs, paragraph.marks);
	return true;
};
var defaultIncrementPoints = 36;
const increaseTextIndent = () => modifyIndentation((node, resolvedProps) => calculateNewIndentation(node, 1, resolvedProps), { resolveProps: true });
const decreaseTextIndent = () => modifyIndentation((node, resolvedProps) => calculateNewIndentation(node, -1, resolvedProps), { resolveProps: true });
const setTextIndentation = (points) => modifyIndentation(() => ptToTwips(points));
const unsetTextIndentation = () => modifyIndentation(() => null);
function calculateNewIndentation(node, delta, resolvedProps) {
	let { indent } = resolvedProps ?? {};
	let { left: left$1 } = indent || {};
	const increment = ptToTwips(delta * defaultIncrementPoints);
	if (!left$1) left$1 = increment;
	else left$1 += increment;
	if (left$1 <= 0) left$1 = null;
	return left$1;
}
function modifyIndentation(calcFunc, { resolveProps = false } = {}) {
	return ({ editor, state, dispatch }) => {
		const tr = state.tr;
		const { from: from$1, to } = state.selection;
		const results = [];
		state.doc.nodesBetween(from$1, to, (node, pos) => {
			if (node.type.name === "paragraph") {
				let left$1 = calcFunc(node, resolveProps ? getResolvedParagraphProperties(node) || calculateResolvedParagraphProperties(editor ?? {}, node, state.doc.resolve(pos)) : void 0);
				if (Number.isNaN(left$1)) {
					results.push(false);
					return false;
				}
				const newAttrs = {
					...node.attrs,
					paragraphProperties: {
						...node.attrs.paragraphProperties || {},
						indent: {
							...node.attrs.paragraphProperties?.indent || {},
							left: left$1
						}
					}
				};
				if (left$1 == null) {
					delete newAttrs.paragraphProperties.indent.left;
					if (Object.keys(newAttrs.paragraphProperties.indent).length === 0) delete newAttrs.paragraphProperties.indent;
				}
				tr.setNodeMarkup(pos, void 0, newAttrs);
				results.push(true);
				return false;
			}
			return true;
		});
		const success = results.every((result) => result);
		if (dispatch && success) dispatch(tr);
		return success;
	};
}
const setLineHeight = (lineHeight) => ({ commands: commands$1 }) => {
	if (!lineHeight) return false;
	return commands$1.updateAttributes("paragraph", {
		"paragraphProperties.spacing.line": linesToTwips(lineHeight),
		"paragraphProperties.spacing.lineRule": "auto"
	});
};
const unsetLineHeight = () => ({ commands: commands$1 }) => {
	return commands$1.resetAttributes("paragraph", "paragraphProperties.spacing.line", "paragraphProperties.spacing.lineRule");
};
const setParagraphDirection = ({ direction, alignmentPolicy } = {}) => {
	if (direction !== "ltr" && direction !== "rtl") return () => false;
	return walkParagraphs$1((pPr, { editor, $pos }) => {
		const next = { ...pPr };
		if (direction === "rtl") next.rightToLeft = true;
		else {
			delete next.rightToLeft;
			if (resolveHypotheticalParagraphProperties(editor, $pos, next)?.rightToLeft === true) next.rightToLeft = false;
		}
		if (alignmentPolicy === "matchDirection") {
			const j = pPr.justification;
			if (j === "left" && direction === "rtl") next.justification = "right";
			else if (j === "right" && direction === "ltr") next.justification = "left";
		}
		return next;
	});
};
const clearParagraphDirection = () => walkParagraphs$1((pPr) => {
	const next = { ...pPr };
	delete next.rightToLeft;
	return next;
});
function walkParagraphs$1(transform) {
	return ({ editor, state, dispatch }) => {
		const { from: from$1, to } = state.selection;
		const tr = state.tr;
		let touched = false;
		state.doc.nodesBetween(from$1, to, (node, pos) => {
			if (node.type.name !== "paragraph") return true;
			const existing = node.attrs.paragraphProperties || {};
			const updated = transform(existing, {
				editor,
				node,
				$pos: state.doc.resolve(pos)
			});
			if (shallowEqual$2(existing, updated)) return false;
			tr.setNodeMarkup(pos, void 0, {
				...node.attrs,
				paragraphProperties: updated
			});
			touched = true;
			return false;
		});
		if (touched && dispatch) dispatch(tr);
		return touched;
	};
}
function shallowEqual$2(a, b$1) {
	const ka = Object.keys(a);
	const kb = Object.keys(b$1);
	if (ka.length !== kb.length) return false;
	for (const k$1 of ka) if (a[k$1] !== b$1[k$1]) return false;
	return true;
}
const backspaceEmptyRunParagraph = () => ({ state, dispatch }) => {
	const { $from } = state.selection;
	if (!state.selection.empty) return false;
	const paraType = state.schema.nodes.paragraph;
	const runType = state.schema.nodes.run;
	const para = $from.parent;
	if (para.type !== paraType || para.childCount !== 1 || para.firstChild.type !== runType || para.firstChild.content.size) return false;
	if (state.doc.childCount === 1 && $from.depth === 1) return false;
	if (dispatch) {
		const paraPos = $from.before();
		let tr = state.tr.deleteRange(paraPos, paraPos + para.nodeSize).scrollIntoView();
		const targetPos = Math.max(1, Math.min(paraPos - 1, tr.doc.content.size));
		tr = tr.setSelection(TextSelection.create(tr.doc, targetPos));
		dispatch(tr);
	}
	return true;
};
const backspaceSkipEmptyRun = () => ({ state, dispatch }) => {
	const sel = state.selection;
	if (!sel.empty) return false;
	const runType = state.schema.nodes.run;
	const $pos = sel.$from;
	const emptyRun = (n) => n && n.type === runType && n.content.size === 0;
	if ($pos.parent.type !== runType || $pos.pos !== $pos.end() || !emptyRun(state.doc.nodeAt($pos.pos + 1))) return false;
	const leftTextSel = Selection.findFrom($pos, -1, true);
	if (!leftTextSel) return false;
	const pos = leftTextSel.$from.pos;
	if (dispatch) dispatch(state.tr.delete(pos - 1, pos).scrollIntoView());
	return true;
};
const findPreviousTextDeleteRange = (doc$1, cursorPos, minPos) => {
	for (let pos = cursorPos; pos >= minPos; pos -= 1) {
		const nodeBefore = doc$1.resolve(pos).nodeBefore;
		if (!nodeBefore?.isText || !nodeBefore.text?.length) continue;
		return {
			from: pos - 1,
			to: pos
		};
	}
	return null;
};
const backspaceNextToRun = () => ({ state, tr, dispatch }) => {
	const sel = state.selection;
	if (!sel.empty) return false;
	const runType = state.schema.nodes.run;
	const $pos = sel.$from;
	if ($pos.nodeBefore?.type !== runType && $pos.pos !== $pos.start()) return false;
	if ($pos.nodeBefore) {
		if ($pos.nodeBefore.content.size === 0) return false;
	} else {
		const prevNode = state.doc.resolve($pos.start() - 1).nodeBefore;
		if (prevNode?.type !== runType || prevNode.content.size === 0) return false;
	}
	let runContentStart;
	if ($pos.nodeBefore) runContentStart = $pos.pos - $pos.nodeBefore.nodeSize + 1;
	else {
		const prevNode = state.doc.resolve($pos.start() - 1).nodeBefore;
		runContentStart = $pos.start() - 1 - prevNode.nodeSize + 1;
	}
	const deleteRange = findPreviousTextDeleteRange(state.doc, $pos.pos, runContentStart);
	if (!deleteRange) return false;
	tr.delete(deleteRange.from, deleteRange.to).setSelection(Selection.near(tr.doc.resolve(deleteRange.from)));
	if (dispatch) dispatch(tr.scrollIntoView());
	return true;
};
const backspaceAcrossRuns = () => ({ state, tr, dispatch }) => {
	const sel = state.selection;
	if (!sel.empty) return false;
	const $pos = sel.$from;
	const runType = state.schema.nodes.run;
	const insideRun = $pos.parent.type === runType;
	const betweenRuns = $pos.nodeBefore?.type === runType && !insideRun;
	if (!insideRun && !betweenRuns) return false;
	const paraDepth = insideRun ? $pos.depth - 1 : $pos.depth;
	const paraStart = $pos.start(paraDepth);
	const deleteRange = findPreviousTextDeleteRange(state.doc, $pos.pos, paraStart);
	if (!deleteRange) return false;
	if (dispatch) {
		tr.delete(deleteRange.from, deleteRange.to);
		tr.setSelection(Selection.near(tr.doc.resolve(deleteRange.from)));
		dispatch(tr.scrollIntoView());
	}
	return true;
};
var DELETABLE_INLINE_ATOMS$1 = new Set(["noBreakHyphen"]);
var onlyChildAtomIn = (runNode) => {
	if (!runNode || runNode.type.name !== "run") return null;
	if (runNode.content.childCount !== 1) return null;
	const child = runNode.content.firstChild;
	if (!child?.isAtom || !child.isInline) return null;
	if (!DELETABLE_INLINE_ATOMS$1.has(child.type.name)) return null;
	return child;
};
const backspaceAtomBefore = () => ({ state, tr, dispatch }) => {
	const sel = state.selection;
	if (!sel.empty) return false;
	const $pos = sel.$from;
	let from$1 = -1;
	let to = -1;
	const direct = $pos.nodeBefore;
	if (direct?.isInline && direct.isAtom && DELETABLE_INLINE_ATOMS$1.has(direct.type.name)) {
		const parent = $pos.parent;
		if (parent.type.name === "run" && parent.content.childCount === 1) {
			const runStart = $pos.before($pos.depth);
			from$1 = runStart;
			to = runStart + parent.nodeSize;
		} else {
			from$1 = $pos.pos - direct.nodeSize;
			to = $pos.pos;
		}
	}
	if (from$1 === -1 && onlyChildAtomIn(direct)) {
		from$1 = $pos.pos - direct.nodeSize;
		to = $pos.pos;
	}
	if (from$1 === -1 && $pos.parent.type.name === "run" && $pos.parentOffset === 0) {
		const parentBefore = state.doc.resolve($pos.before($pos.depth)).nodeBefore;
		if (onlyChildAtomIn(parentBefore)) {
			from$1 = $pos.before($pos.depth) - parentBefore.nodeSize;
			to = $pos.before($pos.depth);
		}
	}
	if (from$1 === -1) return false;
	if (dispatch) {
		tr.delete(from$1, to).setSelection(Selection.near(tr.doc.resolve(from$1)));
		dispatch(tr.scrollIntoView());
	}
	return true;
};
function findAncestorDepth$3($pos, predicate) {
	for (let depth = $pos.depth; depth > 0; depth -= 1) if (predicate($pos.node(depth))) return depth;
	return null;
}
function findSiblingAcrossHiddenMarkers$1(doc$1, pos, direction) {
	let currentPos = pos;
	let node = direction === "before" ? doc$1.resolve(currentPos).nodeBefore : doc$1.resolve(currentPos).nodeAfter;
	while (node && isZeroWidthMarker(node)) {
		currentPos += direction === "before" ? -node.nodeSize : node.nodeSize;
		node = direction === "before" ? doc$1.resolve(currentPos).nodeBefore : doc$1.resolve(currentPos).nodeAfter;
	}
	return {
		node,
		nodePos: direction === "before" && node ? currentPos - node.nodeSize : currentPos
	};
}
function isAtTextBlockBoundary($from, direction) {
	const textblockDepth = findAncestorDepth$3($from, (node) => node.isTextblock);
	if (textblockDepth == null) return null;
	const textblock = $from.node(textblockDepth);
	const textblockPos = $from.before(textblockDepth);
	const boundary = direction === "before" ? findFirstContentCursorPosInNode(textblock, textblockPos) ?? $from.start(textblockDepth) : findLastContentCursorPosInNode(textblock, textblockPos) ?? $from.end(textblockDepth);
	if ($from.pos !== boundary) return null;
	return {
		textblockDepth,
		textblockPos
	};
}
function selectAdjacentBlockSdtContent(direction) {
	return ({ state, dispatch }) => {
		const { selection } = state;
		if (!selection.empty) return false;
		const boundary = isAtTextBlockBoundary(selection.$from, direction);
		if (!boundary) return false;
		const siblingBoundaryPos = direction === "before" ? boundary.textblockPos : selection.$from.after(boundary.textblockDepth);
		const { node, nodePos } = findSiblingAcrossHiddenMarkers$1(state.doc, siblingBoundaryPos, direction);
		if (node?.type.name !== "structuredContentBlock") return false;
		if (node.content.size === 0) return false;
		const contentStart = findFirstContentCursorPosInNode(node, nodePos);
		const contentEnd = findLastContentCursorPosInNode(node, nodePos);
		if (contentStart == null || contentEnd == null) return false;
		if (contentStart >= contentEnd) return false;
		if (dispatch) dispatch(state.tr.setSelection(TextSelection.create(state.doc, contentStart, contentEnd)).scrollIntoView());
		return true;
	};
}
const selectBlockSdtBeforeTextBlockStart = () => selectAdjacentBlockSdtContent("before");
const selectBlockSdtAfterTextBlockEnd = () => selectAdjacentBlockSdtContent("after");
function isSdtContentFullyLocked(node) {
	return node.attrs.lockMode === "sdtContentLocked";
}
function findAncestorDepth$2($pos, predicate) {
	for (let depth = $pos.depth; depth > 0; depth -= 1) if (predicate($pos.node(depth))) return depth;
	return null;
}
const deleteBlockSdtAtTextBlockStart = () => ({ state, dispatch }) => {
	const { selection } = state;
	if (!selection.empty) return false;
	const { $from } = selection;
	const sdtDepth = findAncestorDepth$2($from, (node) => node.type.name === "structuredContentBlock");
	if (sdtDepth == null) return false;
	const textblockDepth = findAncestorDepth$2($from, (node) => node.isTextblock);
	if (textblockDepth !== sdtDepth + 1) return false;
	if ($from.node(textblockDepth).type.name !== "paragraph") return false;
	if ($from.pos !== $from.start(textblockDepth)) return false;
	if ($from.before(textblockDepth) !== $from.start(sdtDepth)) return false;
	const sdtNode = $from.node(sdtDepth);
	if (sdtNode.attrs.lockMode === "sdtLocked") return false;
	if (isSdtContentFullyLocked(sdtNode)) return true;
	if (dispatch) {
		const from$1 = $from.before(sdtDepth);
		const tr = state.tr.delete(from$1, from$1 + sdtNode.nodeSize);
		const selectionPos = Math.min(from$1, tr.doc.content.size);
		dispatch(tr.setSelection(Selection.near(tr.doc.resolve(selectionPos), -1)).scrollIntoView());
	}
	return true;
};
function findAncestorDepth$1($pos, predicate) {
	for (let depth = $pos.depth; depth > 0; depth -= 1) if (predicate($pos.node(depth))) return depth;
	return null;
}
function findSiblingAcrossHiddenMarkers(doc$1, pos, direction) {
	let currentPos = pos;
	let node = direction === "before" ? doc$1.resolve(currentPos).nodeBefore : doc$1.resolve(currentPos).nodeAfter;
	while (node && isZeroWidthMarker(node)) {
		currentPos += direction === "before" ? -node.nodeSize : node.nodeSize;
		node = direction === "before" ? doc$1.resolve(currentPos).nodeBefore : doc$1.resolve(currentPos).nodeAfter;
	}
	return {
		node,
		nodePos: direction === "before" && node ? currentPos - node.nodeSize : currentPos
	};
}
function createSelectionAtContentPos(doc$1, pos, bias) {
	const $pos = doc$1.resolve(pos);
	if ($pos.parent.inlineContent) return TextSelection.create(doc$1, pos);
	if ($pos.nodeAfter && NodeSelection.isSelectable($pos.nodeAfter)) return NodeSelection.create(doc$1, pos);
	return Selection.near($pos, bias);
}
function moveIntoAdjacentBlockSdt(direction) {
	return ({ state, dispatch }) => {
		const { selection } = state;
		if (!selection.empty) return false;
		const { $from } = selection;
		const textblockDepth = findAncestorDepth$1($from, (node$1) => node$1.isTextblock);
		if (textblockDepth == null) return false;
		const textblock = $from.node(textblockDepth);
		const textblockPos = $from.before(textblockDepth);
		if ((direction === "before" ? findFirstContentCursorPosInNode(textblock, textblockPos) ?? $from.start(textblockDepth) : findLastContentCursorPosInNode(textblock, textblockPos) ?? $from.end(textblockDepth)) !== $from.pos) return false;
		const siblingBoundaryPos = direction === "before" ? textblockPos : $from.after(textblockDepth);
		const { node, nodePos } = findSiblingAcrossHiddenMarkers(state.doc, siblingBoundaryPos, direction);
		if (node?.type.name !== "structuredContentBlock") return false;
		const targetPos = direction === "before" ? findLastContentCursorPosInNode(node, nodePos) : findFirstContentCursorPosInNode(node, nodePos);
		if (targetPos == null) return false;
		if (dispatch) {
			const targetSelection = createSelectionAtContentPos(state.doc, targetPos, direction === "before" ? -1 : 1);
			dispatch(state.tr.setSelection(targetSelection).scrollIntoView());
		}
		return true;
	};
}
const moveIntoBlockSdtBeforeTextBlockStart = () => moveIntoAdjacentBlockSdt("before");
const moveIntoBlockSdtAfterTextBlockEnd = () => moveIntoAdjacentBlockSdt("after");
const deleteSkipEmptyRun = () => ({ state, dispatch }) => {
	const sel = state.selection;
	if (!sel.empty) return false;
	const runType = state.schema.nodes.run;
	const $pos = sel.$from;
	const emptyRun = (n) => n && n.type === runType && n.content.size === 0;
	if ($pos.parent.type === runType && emptyRun(state.doc.nodeAt($pos.end() + 1))) {
		if ($pos.pos === $pos.end()) return deleteFromEndOfRun(state, dispatch, $pos);
		else if ($pos.pos === $pos.end() - 1) return deleteFromLastCharacter(state, dispatch, $pos);
		return false;
	}
	return false;
};
function deleteFromEndOfRun(state, dispatch, $pos) {
	const rightRun = state.doc.nodeAt($pos.pos + 1);
	const $afterRightRunPos = state.doc.resolve($pos.pos + 2 + rightRun.nodeSize);
	const rightTextSel = Selection.findFrom($afterRightRunPos, 1, true);
	if (!rightTextSel) return false;
	const pos = rightTextSel.$from.pos;
	if (dispatch) dispatch(state.tr.delete(pos, pos + 1).scrollIntoView());
	return true;
}
function deleteFromLastCharacter(state, dispatch, $pos) {
	if (dispatch) dispatch(state.tr.delete($pos.pos, $pos.pos + 1).scrollIntoView());
	return true;
}
const deleteNextToRun = () => ({ state, tr, dispatch }) => {
	const sel = state.selection;
	if (!sel.empty) return false;
	const runType = state.schema.nodes.run;
	const $pos = sel.$from;
	if ($pos.nodeAfter?.type !== runType && $pos.pos !== $pos.end()) return false;
	if ($pos.nodeAfter) {
		if ($pos.nodeAfter.content.size === 0) return false;
		tr.delete($pos.pos + 1, $pos.pos + 2).setSelection(Selection.near(tr.doc.resolve($pos.pos + 1)));
		if (dispatch) dispatch(tr.scrollIntoView());
	} else {
		const nextNode = state.doc.resolve($pos.end() + 1).nodeAfter;
		if (nextNode?.type !== runType || nextNode.content.size === 0) return false;
		tr.delete($pos.pos + 2, $pos.pos + 3).setSelection(Selection.near(tr.doc.resolve($pos.pos + 2)));
		if (dispatch) dispatch(tr.scrollIntoView());
	}
	return true;
};
var DELETABLE_INLINE_ATOMS = new Set(["noBreakHyphen"]);
const deleteAtomAfter = () => ({ state, tr, dispatch }) => {
	const sel = state.selection;
	if (!sel.empty) return false;
	const $pos = sel.$from;
	const after = $pos.nodeAfter;
	if (!after || !after.isInline || !after.isAtom) return false;
	if (!DELETABLE_INLINE_ATOMS.has(after.type.name)) return false;
	const parent = $pos.parent;
	if (parent.type.name !== "run" || parent.content.childCount !== 1) return false;
	const runStart = $pos.before($pos.depth);
	const from$1 = runStart;
	const to = runStart + parent.nodeSize;
	if (dispatch) {
		tr.delete(from$1, to).setSelection(Selection.near(tr.doc.resolve(from$1)));
		dispatch(tr.scrollIntoView());
	}
	return true;
};
function skipTab(dir) {
	return ({ state, dispatch }) => {
		const tab = state.schema.nodes.tab;
		const run = state.schema.nodes.run;
		const sel = state.selection;
		if (!tab || !sel.empty) return false;
		const $pos = sel.$from;
		if ($pos.parent.type !== run) return false;
		if (dir > 0 && $pos.pos < $pos.end()) return false;
		if (dir < 0 && $pos.pos > $pos.start()) return false;
		const step = dir > 0 ? 1 : -1;
		let $nextPos = state.doc.resolve($pos.pos + step);
		const nextNode = dir > 0 ? $nextPos.nodeAfter : $nextPos.nodeBefore;
		if (!nextNode || nextNode.type !== tab) return false;
		const nextPos = dir > 0 ? Math.min($nextPos.pos + nextNode.nodeSize + 1, state.doc.nodeSize) : Math.max(0, $nextPos.pos - nextNode.nodeSize - 1);
		if (dispatch) dispatch(state.tr.setSelection(TextSelection.create(state.doc, nextPos)));
		return true;
	};
}
function tableSeparatorNeeds$1(doc$1, pos) {
	const $pos = doc$1.resolve(pos);
	if ($pos.depth !== 0) return {
		before: false,
		after: false
	};
	const indexAfter = $pos.index(0);
	const nodeAfter = indexAfter < doc$1.childCount ? doc$1.child(indexAfter) : null;
	return {
		before: (indexAfter > 0 ? doc$1.child(indexAfter - 1) : null)?.type.name === "table",
		after: !nodeAfter || nodeAfter.type.name === "table"
	};
}
const insertTableAt = ({ pos, rows, columns, sdBlockId, tracked }) => ({ state, dispatch }) => {
	const tableType = state.schema.nodes.table;
	const tableRowType = state.schema.nodes.tableRow;
	const tableCellType = state.schema.nodes.tableCell;
	if (!tableType || !tableRowType || !tableCellType) return false;
	if (!Number.isInteger(pos) || pos < 0 || pos > state.doc.content.size) return false;
	if (!Number.isInteger(rows) || rows < 1) return false;
	if (!Number.isInteger(columns) || columns < 1) return false;
	try {
		const cellNodes = [];
		for (let c = 0; c < columns; c++) {
			const cell = tableCellType.createAndFill();
			if (!cell) return false;
			cellNodes.push(cell);
		}
		const rowNodes = [];
		for (let r$1 = 0; r$1 < rows; r$1++) {
			const row = tableRowType.createChecked(null, cellNodes);
			rowNodes.push(row);
		}
		const tableAttrs = sdBlockId ? { sdBlockId } : void 0;
		const tableNode = tableType.createChecked(tableAttrs, rowNodes);
		const sep = tableSeparatorNeeds$1(state.doc, pos);
		let tr;
		if (sep.before || sep.after) {
			const makeSep = () => state.schema.nodes.paragraph.createAndFill();
			const nodes = [];
			if (sep.before) {
				const s = makeSep();
				if (s) nodes.push(s);
			}
			nodes.push(tableNode);
			if (sep.after) {
				const s = makeSep();
				if (s) nodes.push(s);
			}
			tr = state.tr.insert(pos, Fragment$1.from(nodes));
		} else tr = state.tr.insert(pos, tableNode);
		if (!dispatch) return true;
		tr.setMeta("inputType", "programmatic");
		if (tracked === true) tr.setMeta("forceTrackChanges", true);
		else if (tracked === false) tr.setMeta("skipTrackChanges", true);
		dispatch(tr);
		return true;
	} catch {
		return false;
	}
};
function computeParagraphContentBounds(paragraphPos, paragraphNode) {
	if (!Number.isFinite(paragraphPos) || !paragraphNode || !Number.isFinite(paragraphNode.nodeSize)) return null;
	let from$1 = paragraphPos + 1;
	let to = paragraphPos + paragraphNode.nodeSize - 1;
	if (paragraphNode.firstChild?.type?.name === "run") from$1 = paragraphPos + 2;
	if (paragraphNode.lastChild?.type?.name === "run") to = paragraphPos + paragraphNode.nodeSize - 2;
	if (to < from$1) to = from$1;
	return {
		from: from$1,
		to
	};
}
function computeToggleListSelectionRange({ selectionWasCollapsed, affectedParagraphCount, firstParagraphPos, lastParagraphPos, firstNode, lastNode }) {
	if (affectedParagraphCount <= 0) return null;
	const firstBounds = computeParagraphContentBounds(firstParagraphPos, firstNode);
	const lastBounds = computeParagraphContentBounds(lastParagraphPos, lastNode);
	if (!firstBounds || !lastBounds) return null;
	if (selectionWasCollapsed && affectedParagraphCount === 1) return {
		from: lastBounds.to,
		to: lastBounds.to
	};
	return {
		from: firstBounds.from,
		to: lastBounds.to
	};
}
function numFmtIsBullet(numFmt) {
	if (numFmt == null) return false;
	const v = String(numFmt).toLowerCase();
	return v === "bullet" || v === "image" || v === "none";
}
function getParagraphListKind(node, editor) {
	const paraProps = getResolvedParagraphProperties(node);
	if (!paraProps?.numberingProperties || !node.attrs.listRendering) return null;
	const { numId, ilvl = 0 } = paraProps.numberingProperties;
	const fmt = ListHelpers.getListDefinitionDetails({
		numId,
		level: ilvl,
		editor
	})?.listNumberingType ?? node.attrs.listRendering?.numberingType;
	if (fmt == null) return null;
	return numFmtIsBullet(fmt) ? "bullet" : "ordered";
}
function paragraphMatchesToggleListType(node, editor, listType, bulletStyle, orderedStyle) {
	const kind = getParagraphListKind(node, editor);
	if (!kind) return false;
	if (listType === "bulletList") {
		if (kind !== "bullet") return false;
		if (!bulletStyle) return true;
		const markerText = node.attrs.listRendering?.markerText;
		return markerTextToBulletStyle(markerText) === bulletStyle;
	}
	if (listType === "orderedList") {
		if (kind !== "ordered") return false;
		if (!orderedStyle) return true;
		const { numberingType, markerText } = node.attrs.listRendering ?? {};
		return numberingInfoToOrderedStyle(numberingType, markerText) === orderedStyle;
	}
	return false;
}
function getPrecedingParagraphForListReuse(doc$1, from$1, paragraphsInSelection) {
	let pos = paragraphsInSelection.length > 0 ? paragraphsInSelection[0].pos : null;
	if (pos == null && from$1 > 0) {
		const $from = doc$1.resolve(from$1);
		for (let d = $from.depth; d > 0; d -= 1) if ($from.node(d).type.name === "paragraph") {
			pos = $from.before(d);
			break;
		}
	}
	if (pos == null) return null;
	const nb = doc$1.resolve(pos).nodeBefore;
	return nb?.type?.name === "paragraph" ? nb : null;
}
const toggleList = (listType, bulletStyle, orderedStyle) => ({ editor, state, tr, dispatch }) => {
	if (listType !== "orderedList" && listType !== "bulletList") return false;
	const predicate = (n) => paragraphMatchesToggleListType(n, editor, listType, bulletStyle, orderedStyle);
	const { selection } = state;
	const { from: from$1, to } = selection;
	let firstListNode = null;
	let hasNonListParagraphs = false;
	let allParagraphsInSelection = [];
	state.doc.nodesBetween(from$1, to, (node, pos) => {
		if (node.type.name === "paragraph") {
			allParagraphsInSelection.push({
				node,
				pos
			});
			return false;
		}
		return true;
	});
	const originalParagraphsInSelection = allParagraphsInSelection.length === 1 ? allParagraphsInSelection : allParagraphsInSelection.filter(({ node }) => !isVisuallyEmptyParagraph(node));
	let paragraphsInSelection = originalParagraphsInSelection;
	const seenLevels = /* @__PURE__ */ new Set();
	let allListItems = paragraphsInSelection.length > 0;
	for (const { node } of paragraphsInSelection) {
		const np = getResolvedParagraphProperties(node)?.numberingProperties;
		if (!np?.numId) {
			allListItems = false;
			break;
		}
		seenLevels.add(`${Number(np.numId)}:${Number(np.ilvl ?? 0)}`);
	}
	if (allListItems && seenLevels.size > 0 && selection.empty) {
		const expanded = new Map(paragraphsInSelection.map((p$1) => [p$1.pos, p$1]));
		state.doc.descendants((node, pos) => {
			if (node.type.name !== "paragraph") return true;
			if (expanded.has(pos)) return false;
			const np = getResolvedParagraphProperties(node)?.numberingProperties;
			if (np?.numId && seenLevels.has(`${Number(np.numId)}:${Number(np.ilvl ?? 0)}`)) expanded.set(pos, {
				node,
				pos
			});
			return false;
		});
		paragraphsInSelection = [...expanded.values()].sort((a, b$1) => a.pos - b$1.pos);
	}
	for (const { node } of paragraphsInSelection) if (!firstListNode && predicate(node)) firstListNode = node;
	else if (!predicate(node)) hasNonListParagraphs = true;
	const selectionAlreadyHasListNumbering = paragraphsInSelection.some(({ node }) => getResolvedParagraphProperties(node)?.numberingProperties != null);
	if (!firstListNode && !selectionAlreadyHasListNumbering && from$1 > 0) {
		const beforeNode = getPrecedingParagraphForListReuse(state.doc, from$1, paragraphsInSelection);
		if (beforeNode && predicate(beforeNode)) firstListNode = beforeNode;
	}
	if (firstListNode == null && allListItems && selection.empty) {
		const effectiveBulletStyle = listType === "bulletList" ? bulletStyle ?? "disc" : null;
		const effectiveOrderedStyle = listType === "orderedList" ? orderedStyle ?? "decimal" : null;
		const groups = /* @__PURE__ */ new Map();
		for (const p$1 of paragraphsInSelection) {
			const np = getResolvedParagraphProperties(p$1.node).numberingProperties;
			const sourceNumId = Number(np.numId);
			const ilvl = Number(np.ilvl ?? 0);
			const key = `${sourceNumId}:${ilvl}`;
			if (!groups.has(key)) groups.set(key, {
				sourceNumId,
				ilvl,
				paragraphs: []
			});
			groups.get(key).paragraphs.push(p$1);
		}
		if (groups.size > 0) {
			if (!dispatch) return true;
			for (const { sourceNumId, ilvl, paragraphs } of groups.values()) {
				const minted = ListHelpers.cloneListDefinitionWithLevelStyle({
					editor,
					sourceNumId,
					ilvl,
					bulletStyle: effectiveBulletStyle,
					orderedStyle: effectiveOrderedStyle
				});
				if (!minted) continue;
				for (const { node, pos } of paragraphs) updateNumberingProperties({
					numId: minted.newNumId,
					ilvl
				}, node, pos, editor, tr);
			}
			dispatch(tr);
			return true;
		}
	}
	let mode = null;
	let sharedNumberingProperties = null;
	if (firstListNode) if (!hasNonListParagraphs) mode = "remove";
	else {
		mode = "reuse";
		const baseNumbering = getResolvedParagraphProperties(firstListNode).numberingProperties || {};
		sharedNumberingProperties = {
			...baseNumbering,
			ilvl: baseNumbering.ilvl ?? 0
		};
	}
	else mode = "create";
	if (!dispatch) return true;
	if (mode === "create") {
		let styleOverrideLevel = 0;
		if (bulletStyle || orderedStyle) {
			const firstExistingListPara = paragraphsInSelection.find(({ node }) => getResolvedParagraphProperties(node)?.numberingProperties?.ilvl != null);
			const existingIlvl = firstExistingListPara ? getResolvedParagraphProperties(firstExistingListPara.node)?.numberingProperties?.ilvl : null;
			if (existingIlvl != null) styleOverrideLevel = existingIlvl;
		}
		const numId = ListHelpers.getNewListId(editor);
		ListHelpers.generateNewListDefinition({
			numId: Number(numId),
			listType,
			editor,
			bulletStyle,
			bulletStyleLevel: styleOverrideLevel,
			orderedStyle,
			orderedStyleLevel: styleOverrideLevel
		});
		sharedNumberingProperties = {
			numId: Number(numId),
			ilvl: 0
		};
	}
	for (const { node, pos } of paragraphsInSelection) {
		if (mode === "remove") {
			updateNumberingProperties(null, node, pos, editor, tr);
			continue;
		}
		if (mode === "reuse" && predicate(node)) continue;
		const existingIlvl = getResolvedParagraphProperties(node)?.numberingProperties?.ilvl;
		updateNumberingProperties(mode === "create" && existingIlvl != null && existingIlvl !== sharedNumberingProperties.ilvl ? {
			...sharedNumberingProperties,
			ilvl: existingIlvl
		} : sharedNumberingProperties, node, pos, editor, tr);
	}
	if (originalParagraphsInSelection.length > 0) {
		const firstPara = originalParagraphsInSelection[0];
		const lastPara = originalParagraphsInSelection[originalParagraphsInSelection.length - 1];
		const firstParagraphPos = firstPara.pos;
		const lastParagraphPos = lastPara.pos;
		const firstNode = tr.doc.nodeAt(firstParagraphPos);
		const lastNode = tr.doc.nodeAt(lastParagraphPos);
		const restoredSelectionRange = computeToggleListSelectionRange({
			selectionWasCollapsed: selection.empty,
			affectedParagraphCount: originalParagraphsInSelection.length,
			firstParagraphPos,
			lastParagraphPos,
			firstNode,
			lastNode
		});
		if (restoredSelectionRange && restoredSelectionRange.from >= 0 && restoredSelectionRange.to <= tr.doc.content.size && restoredSelectionRange.from <= restoredSelectionRange.to) try {
			if (selection.empty && originalParagraphsInSelection.length === 1) tr.setSelection(Selection.near(tr.doc.resolve(restoredSelectionRange.to), -1));
			else tr.setSelection(TextSelection.create(tr.doc, restoredSelectionRange.from, restoredSelectionRange.to));
		} catch {}
	}
	dispatch(tr);
	return true;
};
const increaseListIndent = () => ({ editor, tr, dispatch }) => {
	const handled = changeListLevel(1, editor, tr);
	if (handled && dispatch) dispatch(tr);
	return handled;
};
const insertListItemAt = ({ pos, position, text = "", sdBlockId, paraId, tracked }) => ({ state, dispatch }) => {
	if (!Number.isInteger(pos) || pos < 0 || pos > state.doc.content.size) return false;
	if (position !== "before" && position !== "after") return false;
	const targetNode = state.doc.nodeAt(pos);
	if (!targetNode || targetNode.type.name !== "paragraph") return false;
	const resolvedProps = getResolvedParagraphProperties(targetNode);
	const paragraphProperties = targetNode.attrs?.paragraphProperties ?? {};
	const numberingProperties = resolvedProps?.numberingProperties ?? paragraphProperties?.numberingProperties;
	if (!numberingProperties) return false;
	const paragraphType = state.schema.nodes.paragraph;
	if (!paragraphType) return false;
	const newParagraphProperties = {
		...paragraphProperties,
		numberingProperties: { ...numberingProperties }
	};
	const attrs = {
		...targetNode.attrs ?? {},
		sdBlockId: sdBlockId ?? null,
		paraId: paraId ?? null,
		textId: null,
		listRendering: null,
		paragraphProperties: newParagraphProperties,
		numberingProperties: newParagraphProperties.numberingProperties
	};
	const normalizedText = typeof text === "string" ? text : "";
	const content = normalizedText.length > 0 ? buildTextWithTabs(state.schema, normalizedText, void 0) : void 0;
	let paragraphNode;
	try {
		paragraphNode = paragraphType.createAndFill(attrs, content) ?? paragraphType.create(attrs, content ?? void 0);
	} catch {
		return false;
	}
	if (!paragraphNode) return false;
	const insertPos = position === "before" ? pos : pos + targetNode.nodeSize;
	if (!Number.isInteger(insertPos) || insertPos < 0 || insertPos > state.doc.content.size) return false;
	if (!dispatch) return true;
	try {
		const tr = state.tr.insert(insertPos, paragraphNode).setMeta("inputType", "programmatic");
		if (tracked === true) tr.setMeta("forceTrackChanges", true);
		else if (tracked === false) tr.setMeta("skipTrackChanges", true);
		dispatch(tr);
		return true;
	} catch {
		return false;
	}
};
const setListTypeAt = ({ pos, kind }) => ({ state, tr, editor, dispatch }) => {
	if (!Number.isInteger(pos) || pos < 0 || pos > state.doc.content.size) return false;
	if (kind !== "ordered" && kind !== "bullet") return false;
	const paragraph = state.doc.nodeAt(pos);
	if (!paragraph || paragraph.type.name !== "paragraph") return false;
	const numberingProperties = getResolvedParagraphProperties(paragraph)?.numberingProperties ?? paragraph.attrs?.paragraphProperties?.numberingProperties;
	if (!numberingProperties) return false;
	const level = Number(numberingProperties.ilvl ?? 0) || 0;
	const listType = kind === "bullet" ? "bulletList" : "orderedList";
	if (!dispatch) return true;
	const newNumId = Number(ListHelpers.getNewListId(editor));
	if (!Number.isFinite(newNumId)) return false;
	ListHelpers.generateNewListDefinition({
		numId: newNumId,
		listType,
		editor
	});
	updateNumberingProperties({
		...numberingProperties,
		numId: newNumId,
		ilvl: level
	}, paragraph, pos, editor, tr);
	dispatch(tr);
	return true;
};
const exitListItemAt = ({ pos }) => ({ state, tr, editor, dispatch }) => {
	if (!Number.isInteger(pos) || pos < 0 || pos > state.doc.content.size) return false;
	const paragraph = state.doc.nodeAt(pos);
	if (!paragraph || paragraph.type.name !== "paragraph") return false;
	if (!(getResolvedParagraphProperties(paragraph)?.numberingProperties ?? paragraph.attrs?.paragraphProperties?.numberingProperties)) return false;
	updateNumberingProperties(null, paragraph, pos, editor, tr);
	if (dispatch) dispatch(tr);
	return true;
};
const restoreSelection = () => ({ editor, state, tr }) => {
	if (editor.options.lastSelection) {
		tr.setSelection(TextSelection.create(state.doc, editor.options.lastSelection.from, editor.options.lastSelection.to));
		return true;
	}
	return false;
};
var clamp$1 = (value, min$2, max$2) => Math.max(min$2, Math.min(value, max$2));
const setTextSelection = ({ from: from$1, to }) => ({ state, dispatch, editor }) => {
	if (typeof from$1 !== "number" && typeof to !== "number") return false;
	const doc$1 = state.doc;
	const docSize = doc$1.content.size;
	const nextFrom = clamp$1(typeof from$1 === "number" ? from$1 : state.selection.from, 0, docSize);
	const nextTo = clamp$1(typeof to === "number" ? to : nextFrom, 0, docSize);
	const [head, anchor] = nextFrom <= nextTo ? [nextFrom, nextTo] : [nextTo, nextFrom];
	const selection = TextSelection.create(doc$1, head, anchor);
	if (dispatch) dispatch(state.tr.setSelection(selection));
	if (editor?.view?.dom && typeof editor.view.dom.focus === "function") editor.view.dom.focus({ preventScroll: true });
	else if (editor?.view && typeof editor.view.focus === "function") editor.view.focus();
	return true;
};
const getSelectionMarks = () => ({ state, tr }) => {
	tr.setMeta("preventDispatch", true);
	const marks = getMarksFromSelection(state) ?? [];
	const uniqueByType = /* @__PURE__ */ new Map();
	for (const mark of marks) {
		const typeName = typeof mark?.type === "string" ? mark.type : mark?.type?.name;
		if (!typeName) continue;
		const existing = uniqueByType.get(typeName);
		if (!existing) {
			uniqueByType.set(typeName, mark);
			continue;
		}
		const existingAttrs = existing?.attrs ?? {};
		const nextAttrs = mark?.attrs ?? {};
		const existingHasValues = Object.values(existingAttrs).some((value) => value != null);
		const nextHasValues = Object.values(nextAttrs).some((value) => value != null);
		if (!existingHasValues && nextHasValues) uniqueByType.set(typeName, mark);
	}
	return Array.from(uniqueByType.values());
};
var commands_exports = /* @__PURE__ */ __export({
	SELECT_INLINE_SDT_BEFORE_RUN_START_META: () => SELECT_INLINE_SDT_BEFORE_RUN_START_META,
	backspaceAcrossRuns: () => backspaceAcrossRuns,
	backspaceAtomBefore: () => backspaceAtomBefore,
	backspaceEmptyRunParagraph: () => backspaceEmptyRunParagraph,
	backspaceNextToRun: () => backspaceNextToRun,
	backspaceSkipEmptyRun: () => backspaceSkipEmptyRun,
	changeListLevel: () => changeListLevel,
	clearNodes: () => clearNodes,
	clearParagraphDirection: () => clearParagraphDirection,
	command: () => command,
	createParagraphNear: () => createParagraphNear$1,
	decreaseListIndent: () => decreaseListIndent,
	decreaseTextIndent: () => decreaseTextIndent,
	deleteAtomAfter: () => deleteAtomAfter,
	deleteBlockSdtAtTextBlockStart: () => deleteBlockSdtAtTextBlockStart,
	deleteNextToRun: () => deleteNextToRun,
	deleteSelection: () => deleteSelection$1,
	deleteSkipEmptyRun: () => deleteSkipEmptyRun,
	exitCode: () => exitCode$1,
	exitListItemAt: () => exitListItemAt,
	first: () => first,
	getSelectionMarks: () => getSelectionMarks,
	increaseListIndent: () => increaseListIndent,
	increaseTextIndent: () => increaseTextIndent,
	insertContent: () => insertContent,
	insertContentAt: () => insertContentAt,
	insertHeadingAt: () => insertHeadingAt,
	insertListItemAt: () => insertListItemAt,
	insertParagraphAt: () => insertParagraphAt,
	insertSectionBreakAtSelection: () => insertSectionBreakAtSelection,
	insertTabChar: () => insertTabChar,
	insertTabCharacter: () => insertTabCharacter,
	insertTabNode: () => insertTabNode,
	insertTableAt: () => insertTableAt,
	isStyleTokenEnabled: () => isStyleTokenEnabled,
	isVisuallyEmptyParagraph: () => isVisuallyEmptyParagraph,
	joinBackward: () => joinBackward$1,
	joinDown: () => joinDown$1,
	joinForward: () => joinForward$1,
	joinUp: () => joinUp$1,
	liftEmptyBlock: () => liftEmptyBlock$1,
	moveIntoBlockSdtAfterTextBlockEnd: () => moveIntoBlockSdtAfterTextBlockEnd,
	moveIntoBlockSdtBeforeTextBlockStart: () => moveIntoBlockSdtBeforeTextBlockStart,
	newlineInCode: () => newlineInCode$1,
	removeNumberingProperties: () => removeNumberingProperties,
	resetAttributes: () => resetAttributes,
	restoreSelection: () => restoreSelection,
	selectAll: () => selectAll$1,
	selectBlockSdtAfterTextBlockEnd: () => selectBlockSdtAfterTextBlockEnd,
	selectBlockSdtBeforeTextBlockStart: () => selectBlockSdtBeforeTextBlockStart,
	selectInlineSdtAfterRunEnd: () => selectInlineSdtAfterRunEnd,
	selectInlineSdtBeforeRunStart: () => selectInlineSdtBeforeRunStart,
	selectNodeBackward: () => selectNodeBackward$1,
	selectNodeForward: () => selectNodeForward$1,
	selectTextblockEnd: () => selectTextblockEnd$1,
	selectTextblockStart: () => selectTextblockStart$1,
	setBodyHeaderFooter: () => setBodyHeaderFooter,
	setLineHeight: () => setLineHeight,
	setListTypeAt: () => setListTypeAt,
	setMark: () => setMark,
	setMeta: () => setMeta,
	setNode: () => setNode,
	setParagraphDirection: () => setParagraphDirection,
	setSectionHeaderFooterAtSelection: () => setSectionHeaderFooterAtSelection,
	setSectionPageMarginsAtSelection: () => setSectionPageMarginsAtSelection,
	setTextIndentation: () => setTextIndentation,
	setTextSelection: () => setTextSelection,
	skipTab: () => skipTab,
	splitBlock: () => splitBlock,
	toggleList: () => toggleList,
	toggleMark: () => toggleMark,
	toggleMarkCascade: () => toggleMarkCascade,
	toggleNode: () => toggleNode,
	undoInputRule: () => undoInputRule,
	unsetAllMarks: () => unsetAllMarks,
	unsetLineHeight: () => unsetLineHeight,
	unsetMark: () => unsetMark,
	unsetTextIndentation: () => unsetTextIndentation,
	updateAttributes: () => updateAttributes,
	updateNumberingProperties: () => updateNumberingProperties
}, 1);
const restartNumbering = ({ editor, tr, state }) => {
	const { node: paragraph, pos: paragraphPos } = findParentNode(isList)(state.selection) || {};
	if (!paragraph) return false;
	const { numId, ilvl = 0 } = getResolvedParagraphProperties(paragraph).numberingProperties || {};
	if (numId == null) return false;
	let hasPrecedingItems = false;
	state.doc.nodesBetween(0, paragraphPos, (node) => {
		if (hasPrecedingItems) return false;
		if (node.type.name !== "paragraph") return true;
		if ((getResolvedParagraphProperties(node)?.numberingProperties)?.numId === numId) hasPrecedingItems = true;
		return false;
	});
	if (!hasPrecedingItems) {
		ListHelpers.setLvlOverride(editor, numId, ilvl, { startOverride: 1 });
		if (editor.view) tr.setMeta("preventDispatch", true);
		return true;
	}
	const abstractId = ListHelpers.getAllListDefinitions(editor)?.[numId]?.[ilvl]?.abstractId;
	if (abstractId == null) return false;
	const { numId: newNumId } = ListHelpers.createNumDefinition(editor, Number(abstractId));
	ListHelpers.setLvlOverride(editor, newNumId, ilvl, { startOverride: 1 });
	state.doc.nodesBetween(paragraphPos, state.doc.content.size, (node, pos) => {
		if (node.type.name !== "paragraph") return true;
		const props = getResolvedParagraphProperties(node)?.numberingProperties;
		if (props?.numId === numId) updateNumberingProperties({
			numId: newNumId,
			ilvl: props.ilvl ?? 0
		}, node, pos, editor, tr);
		return true;
	});
	return true;
};
const continueNumbering = ({ editor, tr, state }) => {
	const { node: paragraph } = findParentNode(isList)(state.selection) || {};
	if (!paragraph) return false;
	const { numId, ilvl = 0 } = getResolvedParagraphProperties(paragraph)?.numberingProperties || {};
	if (numId == null) return false;
	ListHelpers.removeLvlOverride(editor, numId, ilvl);
	if (editor.view) tr.setMeta("preventDispatch", true);
	return true;
};
function calculateTabStyle(nodeSize, view, pos, blockParent, paragraphContext, coordCache = null, domPosCache = null) {
	let extraStyles = "";
	try {
		const { tabStops, flattened, positionMap, startPos } = paragraphContext;
		if (paragraphContext.indentWidth === void 0) paragraphContext.indentWidth = getIndentWidth(view, startPos, paragraphContext.indent, coordCache, domPosCache);
		if (paragraphContext.tabHeight === void 0) paragraphContext.tabHeight = calcTabHeight(blockParent);
		if (paragraphContext.paragraphWidth === void 0) paragraphContext.paragraphWidth = getBlockNodeWidth(view, startPos);
		const indentWidth = paragraphContext.indentWidth;
		const hanging = twipsToPixels$1(Number(paragraphContext.indent.hanging) || 0);
		if (hanging > 0) tabStops.unshift({
			val: "start",
			pos: indentWidth + hanging
		});
		const accumulatedTabWidth = paragraphContext.accumulatedTabWidth || 0;
		const currentWidth = indentWidth + measureRangeWidth(view, startPos + 1, pos, coordCache, domPosCache) + accumulatedTabWidth;
		let tabWidth;
		if (tabStops.length) {
			const tabStop = tabStops.find((stop) => stop.pos > currentWidth && stop.val !== "clear");
			if (tabStop) {
				tabWidth = Math.min(tabStop.pos, paragraphContext.paragraphWidth) - currentWidth;
				let val = tabStop.val;
				const aliases = {
					left: "start",
					right: "end"
				};
				if (aliases[val]) val = aliases[val];
				if (val === "center" || val === "end" || val === "right") {
					const entryIndex = positionMap.get(pos);
					if (entryIndex === void 0) return;
					const nextTabIndex = findNextTabIndex(flattened, entryIndex + 1);
					const segmentWidth = measureRangeWidth(view, pos + nodeSize, nextTabIndex === -1 ? startPos + paragraphContext.paragraph.nodeSize - 1 : flattened[nextTabIndex].pos, coordCache, domPosCache);
					tabWidth -= val === "center" ? segmentWidth / 2 : segmentWidth;
				} else if (val === "decimal" || val === "num") {
					const entryIndex = positionMap.get(pos);
					if (entryIndex === void 0) return;
					const breakChar = tabStop.decimalChar || ".";
					const decimalPos = findDecimalBreakPos(flattened, entryIndex + 1, breakChar);
					const integralWidth = decimalPos ? measureRangeWidth(view, pos + nodeSize, decimalPos, coordCache, domPosCache) : measureRangeWidth(view, pos + nodeSize, startPos + paragraphContext.paragraph.nodeSize - 1, coordCache, domPosCache);
					tabWidth -= integralWidth;
				}
				if (tabStop.leader) extraStyles += {
					dot: "border-bottom: 1px dotted black;",
					heavy: "border-bottom: 2px solid black;",
					hyphen: "border-bottom: 1px solid black;",
					middleDot: "border-bottom: 1px dotted black; margin-bottom: 2px;",
					underscore: "border-bottom: 1px solid black;"
				}[tabStop.leader] || "";
			}
		}
		if (!tabWidth || tabWidth < 1) {
			tabWidth = 48 - currentWidth % 816 % 48;
			if (tabWidth === 0) tabWidth = 48;
		}
		const tabHeight = paragraphContext.tabHeight;
		paragraphContext.accumulatedTabWidth = accumulatedTabWidth + tabWidth;
		return `width: ${tabWidth}px; height: ${tabHeight}; ${extraStyles}`;
	} catch {
		return null;
	}
}
function findParagraphContext($pos, cache$2, helpers) {
	for (let depth = $pos.depth; depth >= 0; depth--) {
		const node = $pos.node(depth);
		if (node?.type?.name === "paragraph") {
			const startPos = $pos.start(depth);
			if (!cache$2.has(startPos)) {
				const paragraphContext = extractParagraphContext(node, startPos, helpers, depth);
				cache$2.set(startPos, paragraphContext);
			}
			return cache$2.get(startPos);
		}
	}
	return null;
}
function extractParagraphContext(node, startPos, helpers, depth = 0) {
	const paragraphProperties = getResolvedParagraphProperties(node) ?? node.attrs?.paragraphProperties ?? {};
	const alignmentAliases = {
		left: "start",
		right: "end"
	};
	let tabStops = [];
	if (Array.isArray(paragraphProperties.tabStops)) tabStops = paragraphProperties.tabStops.map((stop) => {
		const ref$1 = stop?.tab;
		if (!ref$1 && stop?.pos != null) return {
			...stop,
			pos: twipsToPixels$1(Number(stop.pos) || 0)
		};
		if (!ref$1) return stop || null;
		const rawType = ref$1.tabType || "start";
		return {
			val: alignmentAliases[rawType] || rawType,
			pos: twipsToPixels$1(Number(ref$1.pos) || 0),
			leader: ref$1.leader
		};
	}).filter(Boolean);
	const { entries, positionMap } = flattenParagraph(node, startPos);
	return {
		paragraph: node,
		paragraphDepth: depth,
		startPos,
		indent: paragraphProperties.indent || {},
		tabStops,
		flattened: entries,
		positionMap,
		accumulatedTabWidth: 0
	};
}
function flattenParagraph(paragraph, paragraphStartPos) {
	const entries = [];
	const positionMap = /* @__PURE__ */ new Map();
	const walk = (node, basePos) => {
		if (!node) return;
		if (node.type?.name === "run") {
			node.forEach((child, offset$1) => {
				walk(child, basePos + offset$1 + 1);
			});
			return;
		}
		const pos = basePos - 1;
		const index = entries.length;
		entries.push({
			node,
			pos
		});
		positionMap.set(pos, index);
	};
	paragraph.forEach((child, offset$1) => {
		walk(child, paragraphStartPos + offset$1 + 1);
	});
	return {
		entries,
		positionMap
	};
}
function findNextTabIndex(flattened, fromIndex) {
	for (let i = fromIndex; i < flattened.length; i++) if (flattened[i]?.node?.type?.name === "tab") return i;
	return -1;
}
function findDecimalBreakPos(flattened, startIndex, breakChar) {
	if (!breakChar) return null;
	for (let i = startIndex; i < flattened.length; i++) {
		const entry = flattened[i];
		if (!entry) break;
		if (entry.node.type?.name === "tab") break;
		if (entry.node.type?.name === "text") {
			const index = entry.node.text?.indexOf(breakChar);
			if (index !== void 0 && index !== -1) return entry.pos + index + 1;
		}
	}
	return null;
}
function measureRangeWidth(view, from$1, to, coordCache = null, domPosCache = null) {
	if (!Number.isFinite(from$1) || !Number.isFinite(to) || to <= from$1) return 0;
	try {
		const range = document.createRange();
		const fromRef = getCachedDomAtPos(view, from$1, domPosCache);
		const toRef$1 = getCachedDomAtPos(view, to, domPosCache);
		range.setStart(fromRef.node, fromRef.offset);
		range.setEnd(toRef$1.node, toRef$1.offset);
		const rect = range.getBoundingClientRect();
		range.detach?.();
		if (rect.width > 0) return rect.width;
	} catch {}
	const startLeft = getLeftCoord(view, from$1, coordCache, domPosCache);
	const endLeft = getLeftCoord(view, to, coordCache, domPosCache);
	if (startLeft == null || endLeft == null) return 0;
	return Math.max(0, endLeft - startLeft);
}
function getIndentWidth(view, paragraphStartPos, indentAttrs = {}, coordCache = null, domPosCache = null) {
	const marginLeft = getLeftCoord(view, paragraphStartPos, coordCache, domPosCache);
	const lineLeft = getLeftCoord(view, paragraphStartPos + 1, coordCache, domPosCache);
	if (marginLeft != null && lineLeft != null) {
		const diff = lineLeft - marginLeft;
		if (!Number.isNaN(diff) && Math.abs(diff) > .5) return diff;
	}
	return calculateIndentFallback(indentAttrs);
}
function getBlockNodeWidth(view, blockStartPos) {
	const blockDom = view.nodeDOM(blockStartPos - 1);
	if (blockDom instanceof HTMLElement) {
		const styles = window.getComputedStyle(blockDom);
		return blockDom.clientWidth + parseFloat(styles.marginLeft || "0") + parseFloat(styles.marginRight || "0") + parseFloat(styles.borderLeftWidth || "0") + parseFloat(styles.borderRightWidth || "0") + parseFloat(styles.paddingLeft || "0") + parseFloat(styles.paddingRight || "0");
	}
	return 816;
}
function calculateIndentFallback(indentAttrs = {}) {
	if (!indentAttrs) return 0;
	const left$1 = twipsToPixels$1(Number(indentAttrs.left) || 0);
	const firstLine = twipsToPixels$1(Number(indentAttrs.firstLine) || 0);
	const hanging = twipsToPixels$1(Number(indentAttrs.hanging) || 0);
	let textIndent = 0;
	if (firstLine && hanging) textIndent = firstLine - hanging;
	else if (firstLine) textIndent = firstLine;
	else if (hanging) textIndent = -hanging;
	if (textIndent) return left$1 + textIndent;
	if (left$1) return left$1;
	return 0;
}
function getLeftCoord(view, pos, coordCache = null, domPosCache = null) {
	if (!Number.isFinite(pos)) return null;
	if (coordCache && coordCache.has(pos)) return coordCache.get(pos);
	let result = null;
	try {
		result = view.coordsAtPos(pos).left;
	} catch {
		try {
			const ref$1 = getCachedDomAtPos(view, pos, domPosCache);
			const range = document.createRange();
			range.setStart(ref$1.node, ref$1.offset);
			range.setEnd(ref$1.node, ref$1.offset);
			const rect = range.getBoundingClientRect();
			range.detach?.();
			result = rect.left;
		} catch {
			result = null;
		}
	}
	if (coordCache) coordCache.set(pos, result);
	return result;
}
function getCachedDomAtPos(view, pos, domPosCache = null) {
	if (domPosCache && domPosCache.has(pos)) return domPosCache.get(pos);
	const result = view.domAtPos(pos);
	if (domPosCache) domPosCache.set(pos, result);
	return result;
}
function calcTabHeight(blockParent) {
	const ptToPxRatio = 1.333;
	const defaultFontSize = 16;
	const defaultLineHeight = 1.1;
	const parentTextStyleMark = blockParent.firstChild?.marks?.find((mark) => mark.type.name === "textStyle");
	return `${(parseInt(parentTextStyleMark?.attrs.fontSize) * ptToPxRatio || defaultFontSize) * defaultLineHeight}px`;
}
var nodeViewMap = /* @__PURE__ */ new WeakMap();
function inferParagraphRtlFromRuns(node) {
	const fragment = node?.content;
	if (!fragment || !fragment.childCount) return false;
	let hasExplicitRtl = false;
	for (let i = 0; i < fragment.childCount; i++) {
		const child = fragment.child(i);
		if (child.type.name !== "run") continue;
		const runProperties = child.attrs?.runProperties || {};
		const isRtl = runProperties.rightToLeft === true || runProperties.rtl === true;
		if (runProperties.rightToLeft === false || runProperties.rtl === false) return false;
		if (isRtl) hasExplicitRtl = true;
	}
	return hasExplicitRtl;
}
var ParagraphNodeView = class {
	constructor(node, editor, getPos, decorations, extensionAttrs) {
		this.node = node;
		this.editor = editor;
		this.getPos = getPos;
		this.decorations = decorations;
		this.extensionAttrs = extensionAttrs;
		this._animationFrameRequest = null;
		this.surroundingContext = {};
		nodeViewMap.set(this.node, this);
		calculateResolvedParagraphProperties(this.editor, this.node, this.editor.state.doc.resolve(this.getPos()));
		this.dom = document.createElement("p");
		const contentEl = document.createElement("span");
		contentEl.classList.add("sd-paragraph-content");
		this.contentDOM = contentEl;
		this.dom.appendChild(this.contentDOM);
		if (this.#checkIsList()) {
			this.#initList(node.attrs.listRendering);
			this.#scheduleAnimation(() => {
				if (!this.#checkIsList()) return;
				this.#updateListStyles();
			});
		}
		this.#updateHTMLAttributes();
		this.#updateDOMStyles();
	}
	update(node, decorations, innerDecorations, forceUpdate = false) {
		if (nodeViewMap.get(this.node) === this) nodeViewMap.delete(this.node);
		const oldProps = getResolvedParagraphProperties(this.node);
		const oldAttrs = this.node.attrs;
		this.node = node;
		this.decorations = decorations;
		this.innerDecorations = innerDecorations;
		nodeViewMap.set(this.node, this);
		if (!forceUpdate && !this.#checkShouldUpdate(oldProps, oldAttrs, this.surroundingContext)) return true;
		calculateResolvedParagraphProperties(this.editor, this.node, this.editor.state.doc.resolve(this.getPos()));
		this.#updateHTMLAttributes();
		this.#updateDOMStyles(oldProps);
		if (!this.#checkIsList()) {
			this.#removeList();
			return true;
		}
		this.#initList(node.attrs.listRendering);
		this.#scheduleAnimation(() => {
			this.#initList(node.attrs.listRendering);
			this.#updateListStyles();
		});
		return true;
	}
	#checkShouldUpdate(oldProps, oldAttrs, oldSurroundingContext) {
		this.#resolveNeighborParagraphProperties();
		return JSON.stringify(oldAttrs) !== JSON.stringify(this.node.attrs) || JSON.stringify(oldProps) !== JSON.stringify(getResolvedParagraphProperties(this.node)) || JSON.stringify(oldSurroundingContext) !== JSON.stringify(this.surroundingContext);
	}
	#updateHTMLAttributes() {
		const htmlAttributes = Attribute.getAttributesToRender(this.node, this.extensionAttrs);
		htmlAttributes.style = htmlAttributes.style || "";
		for (const [key, value] of Object.entries(htmlAttributes || {})) {
			if (value == null) {
				this.dom.removeAttribute(key);
				continue;
			}
			this.dom.setAttribute(key, value);
		}
		const paragraphProperties = getResolvedParagraphProperties(this.node);
		if (this.#checkIsList()) {
			this.dom.setAttribute("data-num-id", paragraphProperties.numberingProperties.numId);
			this.dom.setAttribute("data-level", paragraphProperties.numberingProperties.ilvl);
		} else {
			this.dom.removeAttribute("data-num-id");
			this.dom.removeAttribute("data-level");
		}
		if (paragraphProperties.framePr?.dropCap) this.dom.classList.add("sd-editor-dropcap");
		else this.dom.classList.remove("sd-editor-dropcap");
		if (paragraphProperties.styleId) this.dom.setAttribute("styleid", paragraphProperties.styleId);
		if (paragraphProperties.rightToLeft === true || paragraphProperties.rightToLeft !== false && inferParagraphRtlFromRuns(this.node)) this.dom.setAttribute("dir", "rtl");
		else this.dom.removeAttribute("dir");
	}
	#updateDOMStyles(oldParagraphProperties = null) {
		this.dom.style.cssText = "";
		const paragraphProperties = getResolvedParagraphProperties(this.node);
		this.#resolveNeighborParagraphProperties();
		const style = encodeCSSFromPPr(paragraphProperties, this.surroundingContext.hasPreviousParagraph, this.surroundingContext.nextParagraphProps);
		Object.entries(style).forEach(([k$1, v]) => {
			this.dom.style[k$1] = v;
		});
		if (JSON.stringify(paragraphProperties.spacing) !== JSON.stringify(oldParagraphProperties?.spacing) || paragraphProperties.styleId !== oldParagraphProperties?.styleId || paragraphProperties.contextualSpacing !== oldParagraphProperties?.contextualSpacing) {
			const previousNodeView = this.surroundingContext.previousParagraph ? nodeViewMap.get(this.surroundingContext.previousParagraph) : null;
			if (previousNodeView) {
				try {
					previousNodeView.getPos();
				} catch {
					return;
				}
				previousNodeView.update(previousNodeView.node, previousNodeView.decorations, previousNodeView.innerDecorations, true);
			}
		}
	}
	#resolveNeighborParagraphProperties() {
		const $pos = this.editor.state.doc.resolve(this.getPos());
		const parent = $pos.parent;
		const index = $pos.index();
		let hasPreviousParagraph = false;
		let previousParagraph = null;
		let nextParagraphProps = null;
		if (index > 0) {
			const previousNode = parent.child(index - 1);
			hasPreviousParagraph = previousNode.type.name === "paragraph" && !getResolvedParagraphProperties(previousNode)?.framePr?.dropCap;
			if (hasPreviousParagraph) previousParagraph = previousNode;
		}
		if (parent) {
			if (index < parent.childCount - 1) {
				const nextNode = parent.child(index + 1);
				if (nextNode.type.name === "paragraph") nextParagraphProps = getResolvedParagraphProperties(nextNode);
			}
		}
		this.surroundingContext = {
			hasPreviousParagraph,
			previousParagraph,
			nextParagraphProps
		};
	}
	#updateListStyles() {
		const listRendering = this.node.attrs.listRendering;
		if (!listRendering) return true;
		let { suffix, justification } = listRendering;
		suffix = suffix ?? "tab";
		this.#calculateMarkerStyle(justification);
		if (suffix === "tab") {
			const paragraphProperties = getResolvedParagraphProperties(this.node);
			this.#calculateTabSeparatorStyle(justification, paragraphProperties.indent);
		} else this.separator.textContent = suffix === "space" ? "\xA0" : "";
		return true;
	}
	ignoreMutation(mutation) {
		if (this.marker && (mutation.target === this.marker || this.marker.contains(mutation.target))) return true;
		if (this.separator && (mutation.target === this.separator || this.separator.contains(mutation.target))) return true;
		if (mutation.type === "attributes" && mutation.target === this.dom && mutation.attributeName === "style") return true;
		if (mutation.type === "childList") {
			if (this.marker && Array.from(mutation.removedNodes).includes(this.marker)) return true;
			if (this.marker && Array.from(mutation.addedNodes).includes(this.marker)) return true;
			if (this.separator && Array.from(mutation.removedNodes).includes(this.separator)) return true;
			if (this.separator && Array.from(mutation.addedNodes).includes(this.separator)) return true;
		}
		return false;
	}
	#initList(listRendering) {
		if (!listRendering) return;
		this.#createMarker(listRendering.markerText);
		this.#createSeparator(listRendering.suffix);
	}
	#checkIsList() {
		return isList(this.node);
	}
	#createMarker(markerText) {
		if (!this.marker) {
			this.marker = document.createElement("span");
			this.dom.insertBefore(this.marker, this.contentDOM);
		}
		this.marker.contentEditable = "false";
		this.marker.className = "list-marker";
		this.marker.textContent = markerText;
	}
	#createSeparator(suffix) {
		if (suffix === "tab" || suffix == null) {
			if (this.separator == null || this.separator.tagName?.toLowerCase() !== "span") {
				this.separator?.parentNode?.removeChild(this.separator);
				this.separator = document.createElement("span");
				this.marker.after(this.separator);
			}
			this.separator.className = "sd-editor-tab";
			this.separator.contentEditable = "false";
		} else if (suffix === "space") {
			if (this.separator == null || this.separator.nodeType !== Node.TEXT_NODE) {
				this.separator?.parentNode?.removeChild(this.separator);
				this.separator = document.createTextNode("\xA0");
				this.marker.after(this.separator);
			}
			this.separator.textContent = "\xA0";
		} else if (suffix === "nothing") {
			if (this.separator == null || this.separator.nodeType !== Node.TEXT_NODE) {
				this.separator?.parentNode?.removeChild(this.separator);
				this.separator = document.createTextNode("");
				this.marker.after(this.separator);
			}
			this.separator.textContent = "";
		}
	}
	#calculateTabSeparatorStyle(justification, indent) {
		const markerWidth = this.marker.getBoundingClientRect().width;
		let tabStyle;
		let { paragraphContext, start: start$1 } = this.#getParagraphContext();
		if (justification === "right") if (indent?.hanging || !indent?.hanging && !indent?.firstLine) tabStyle = `width: ${indent?.hanging ? twipsToPixels(indent.hanging) : 0}px;`;
		else tabStyle = calculateTabStyle(this.editor.schema.nodes.tab.create(null).nodeSize, this.editor.view, start$1, this.node, paragraphContext);
		else if (justification === "center") {
			paragraphContext.accumulatedTabWidth = markerWidth / 2;
			tabStyle = calculateTabStyle(this.editor.schema.nodes.tab.create(null).nodeSize, this.editor.view, start$1, this.node, paragraphContext);
			tabStyle += `margin-left: ${markerWidth / 2}px;`;
		} else {
			paragraphContext.accumulatedTabWidth = markerWidth;
			tabStyle = calculateTabStyle(this.editor.schema.nodes.tab.create(null).nodeSize, this.editor.view, start$1, this.node, paragraphContext);
		}
		this.separator.style.cssText = tabStyle;
	}
	#calculateMarkerStyle(justification) {
		const paragraphProperties = getResolvedParagraphProperties(this.node);
		const style = encodeCSSFromRPr(resolveRunProperties({
			translatedNumbering: this.editor.converter.translatedNumbering,
			translatedLinkedStyles: this.editor.converter.translatedLinkedStyles
		}, paragraphProperties.runProperties || {}, paragraphProperties, true, Boolean(this.node.attrs.paragraphProperties.numberingProperties)), this.editor.converter.convertedXml);
		this.marker.style.cssText = Object.entries(style).map(([k$1, v]) => `${k$1}: ${v};`).join(" ");
		let markerStyle = {
			position: "",
			left: "",
			bottom: ""
		};
		let domStyle = { position: "" };
		const calculateTop = () => {
			let top$1 = "0";
			if (globalThis) {
				const computedStyle = globalThis.getComputedStyle(this.dom);
				const markerComputedStyle = globalThis.getComputedStyle(this.marker);
				top$1 = `${parseFloat(computedStyle.lineHeight) - parseFloat(markerComputedStyle.lineHeight)}px`;
			}
			return top$1;
		};
		const markerWidth = this.marker.getBoundingClientRect().width;
		if (justification === "right") {
			markerStyle.position = "absolute";
			markerStyle.left = `${-markerWidth}px`;
			markerStyle.top = calculateTop();
			domStyle.position = "relative";
		} else if (justification === "center") {
			markerStyle.position = "absolute";
			markerStyle.left = `${-markerWidth / 2}px`;
			markerStyle.top = calculateTop();
			domStyle.position = "relative";
		}
		Object.entries(markerStyle).forEach(([k$1, v]) => {
			this.marker.style[k$1] = v;
		});
		Object.entries(domStyle).forEach(([k$1, v]) => {
			this.dom.style[k$1] = v;
		});
	}
	#removeList() {
		if (this.marker) {
			this.dom.removeChild(this.marker);
			this.marker = null;
		}
		if (this.separator) {
			this.dom.removeChild(this.separator);
			this.separator = null;
		}
		this.dom.style.position = "";
	}
	#getParagraphContext() {
		const $pos = this.editor.state.doc.resolve(this.getPos());
		const start$1 = $pos.start($pos.depth + 1);
		return {
			paragraphContext: extractParagraphContext(this.node, start$1, this.editor.helpers),
			start: start$1
		};
	}
	#scheduleAnimation(fn) {
		if (typeof globalThis === "undefined") return;
		this.#cancelScheduledAnimation();
		this._animationFrameRequest = globalThis.requestAnimationFrame(() => {
			fn();
			this._animationFrameRequest = null;
		});
	}
	#cancelScheduledAnimation() {
		if (typeof globalThis === "undefined" || !this._animationFrameRequest) return;
		globalThis.cancelAnimationFrame(this._animationFrameRequest);
		this._animationFrameRequest = null;
	}
	destroy() {
		this.#cancelScheduledAnimation();
		if (nodeViewMap.get(this.node) === this) nodeViewMap.delete(this.node);
	}
};
function createNumberingManager() {
	let countersMap = {};
	let abstractCountersMap = {};
	let abstractIdMap = {};
	const startsMap = {};
	let lastSeenByAbstractIdMap = {};
	let lastSeenByNumIdMap = {};
	let pathCache = {};
	let cacheEnabled = false;
	return {
		setStartSettings(numId, level, startValue, restartValue, startOverridden = false) {
			if (!startsMap[numId]) startsMap[numId] = {};
			if (!startsMap[numId][level]) startsMap[numId][level] = {};
			startsMap[numId][level].start = startValue;
			startsMap[numId][level].restart = restartValue;
			startsMap[numId][level].startOverridden = startOverridden;
		},
		setCounter(numId, level, pos, value, abstractId) {
			if (!countersMap[numId]) countersMap[numId] = {};
			if (!countersMap[numId][level]) countersMap[numId][level] = {};
			countersMap[numId][level][pos] = value;
			abstractIdMap[numId] = abstractId;
			if (!abstractCountersMap[abstractId]) abstractCountersMap[abstractId] = {};
			if (!abstractCountersMap[abstractId][level]) abstractCountersMap[abstractId][level] = {};
			abstractCountersMap[abstractId][level][pos] = value;
			if (!cacheEnabled) return;
			if (!lastSeenByAbstractIdMap[abstractId]) lastSeenByAbstractIdMap[abstractId] = {};
			const lastSeen = lastSeenByAbstractIdMap[abstractId][level];
			if (!lastSeen || pos > lastSeen.pos) lastSeenByAbstractIdMap[abstractId][level] = {
				pos,
				count: value
			};
			if (!lastSeenByNumIdMap[numId]) lastSeenByNumIdMap[numId] = {};
			const lastSeenNumId = lastSeenByNumIdMap[numId][level];
			if (!lastSeenNumId || pos > lastSeenNumId.pos) lastSeenByNumIdMap[numId][level] = {
				pos,
				count: value
			};
		},
		getCounter(numId, level, pos) {
			if (countersMap[numId] && countersMap[numId][level] && countersMap[numId][level][pos] != null) return countersMap[numId][level][pos];
			return null;
		},
		calculateCounter(numId, level, pos, abstractId) {
			abstractIdMap[numId] = abstractId;
			const restartSetting = startsMap?.[numId]?.[level]?.restart;
			const startValue = startsMap?.[numId]?.[level]?.start ?? 1;
			const startOverridden = startsMap?.[numId]?.[level]?.startOverridden ?? false;
			const levelData = abstractCountersMap?.[abstractId]?.[level] || {};
			let previousPos = null;
			let previousCount = startValue - 1;
			if (cacheEnabled) {
				let cachedLast;
				if (startOverridden) cachedLast = lastSeenByNumIdMap?.[numId]?.[level];
				else cachedLast = lastSeenByAbstractIdMap?.[abstractId]?.[level];
				if (cachedLast && cachedLast.pos < pos) {
					previousPos = cachedLast.pos;
					previousCount = cachedLast.count;
				}
			}
			if (previousPos == null && !cacheEnabled) {
				let maxPos = null;
				for (const key of Object.keys(levelData)) {
					const p$1 = parseInt(key, 10);
					if (!Number.isFinite(p$1) || p$1 >= pos) continue;
					if (maxPos == null || p$1 > maxPos) maxPos = p$1;
				}
				if (maxPos != null) {
					previousPos = maxPos;
					previousCount = levelData[maxPos];
				}
			}
			if (restartSetting === 0) return previousCount + 1;
			if (previousPos == null) return startValue;
			const usedLevels = [];
			for (let lvl = 0; lvl < level; lvl++) {
				const levelData$1 = abstractCountersMap?.[abstractId]?.[lvl] || {};
				if (Object.keys(levelData$1).map((p$1) => parseInt(p$1)).some((p$1) => p$1 > previousPos && p$1 < pos)) usedLevels.push(lvl);
			}
			if (usedLevels.length === 0) return previousCount + 1;
			if (restartSetting == null) return startValue;
			if (usedLevels.some((lvl) => lvl <= restartSetting)) return startValue;
			return previousCount + 1;
		},
		getAncestorsPath(numId, level, pos) {
			if (cacheEnabled && pathCache?.[numId]?.[level]?.[pos]) return pathCache[numId][level][pos];
			const path = [];
			const abstractId = abstractIdMap[numId];
			for (let lvl = 0; lvl < level; lvl++) {
				const startCount = startsMap?.[numId]?.[lvl]?.start ?? 1;
				const levelData = abstractCountersMap?.[abstractId]?.[lvl] || {};
				if (levelData == null) {
					path.push(startCount);
					continue;
				}
				const previousPos = Object.keys(levelData).map((p$1) => parseInt(p$1)).filter((p$1) => p$1 < pos).pop();
				if (previousPos == null) path.push(startCount);
				else path.push(levelData[previousPos]);
			}
			if (cacheEnabled) {
				if (!pathCache[numId]) pathCache[numId] = {};
				if (!pathCache[numId][level]) pathCache[numId][level] = {};
				pathCache[numId][level][pos] = path;
			}
			return path;
		},
		calculatePath(numId, level, pos) {
			const path = this.getAncestorsPath(numId, level, pos);
			const myCount = this.getCounter(numId, level, pos);
			path.push(myCount);
			return path;
		},
		getCountersMap() {
			return countersMap;
		},
		_clearCache() {
			lastSeenByAbstractIdMap = {};
			lastSeenByNumIdMap = {};
			pathCache = {};
			countersMap = {};
			abstractCountersMap = {};
			abstractIdMap = {};
		},
		enableCache() {
			cacheEnabled = true;
			this._clearCache();
		},
		disableCache() {
			cacheEnabled = false;
			this._clearCache();
		}
	};
}
function blockRevIsFreshForSlicePaste(rev) {
	return rev === 0 || rev === "0";
}
function shouldPreserveSlicePastedListRendering(node, transactions) {
	if (node.type.name !== "paragraph" || node.attrs.listRendering == null) return false;
	if (node.attrs.sdBlockId != null) return false;
	if (!blockRevIsFreshForSlicePaste(node.attrs.sdBlockRev)) return false;
	return transactions.some((tr) => tr.getMeta("superdocSlicePaste"));
}
function createNumberingPlugin(editor) {
	const numberingManager = createNumberingManager();
	let forceFullRecompute = false;
	const applyStartSettingsFromDefinitions = (definitionsMap) => {
		Object.entries(definitionsMap || {}).forEach(([numId, levels]) => {
			Object.entries(levels || {}).forEach(([level, def]) => {
				const start$1 = parseInt(def?.start) || 1;
				let restart = def?.restart;
				if (restart != null) restart = parseInt(restart);
				numberingManager.setStartSettings(numId, parseInt(level), start$1, restart, def.startOverridden);
			});
		});
	};
	const refreshStartSettings = () => {
		applyStartSettingsFromDefinitions(ListHelpers.getAllListDefinitions(editor));
		forceFullRecompute = true;
	};
	refreshStartSettings();
	if (typeof editor?.on === "function") {
		editor.on("list-definitions-change", refreshStartSettings);
		if (typeof editor?.off === "function") {
			const cleanupListDefinitionListener = () => {
				editor.off("list-definitions-change", refreshStartSettings);
				editor.off?.("destroy", cleanupListDefinitionListener);
			};
			editor.on("destroy", cleanupListDefinitionListener);
		}
	}
	return new Plugin({
		name: "numberingPlugin",
		key: new PluginKey("numberingPlugin"),
		appendTransaction(transactions, oldState, newState) {
			const getParagraphAnchor = ($pos) => {
				for (let depth = $pos.depth; depth >= 0; depth--) if ($pos.node(depth).type.name === "paragraph") return depth === 0 ? 0 : $pos.before(depth);
				return null;
			};
			const isInlineOnlyChange = (tr$1) => {
				if (!tr$1.docChanged) return true;
				let inlineOnly = true;
				const baseDoc = tr$1.before ?? oldState?.doc ?? newState?.doc;
				tr$1.steps.forEach((step) => {
					if (!inlineOnly) return;
					if (step instanceof AddMarkStep || step instanceof RemoveMarkStep) return;
					if (step instanceof ReplaceStep || step instanceof ReplaceAroundStep$1) {
						const { from: from$1, to } = step;
						if (from$1 == null || to == null || !baseDoc) {
							inlineOnly = false;
							return;
						}
						if (from$1 < 0 || to < 0 || from$1 > baseDoc.content.size || to > baseDoc.content.size) {
							inlineOnly = false;
							return;
						}
						let $from;
						let $to;
						try {
							$from = baseDoc.resolve(from$1);
							$to = baseDoc.resolve(to);
						} catch {
							inlineOnly = false;
							return;
						}
						const fromPara = getParagraphAnchor($from);
						const toPara = getParagraphAnchor($to);
						if (fromPara == null || toPara == null || fromPara !== toPara) {
							inlineOnly = false;
							return;
						}
						if (step.slice?.content) {
							let hasBlock = false;
							step.slice.content.descendants((node) => {
								if (node.isBlock) {
									hasBlock = true;
									return false;
								}
							});
							if (hasBlock) inlineOnly = false;
						}
						return;
					}
					inlineOnly = false;
				});
				return inlineOnly;
			};
			const isFromPlugin = transactions.some((tr$1) => tr$1.getMeta("orderedListSync"));
			const forcePluginPass = transactions.some((tr$1) => tr$1.getMeta("forcePluginPass"));
			const hasDocChanges = transactions.some((tr$1) => tr$1.docChanged);
			if (isFromPlugin || !forcePluginPass && !forceFullRecompute && !hasDocChanges) return null;
			if (!forcePluginPass && !forceFullRecompute) {
				if (transactions.every((tr$1) => isInlineOnlyChange(tr$1))) return null;
			}
			const hasNumberedParagraphInRange = (doc$1, from$1, to) => {
				if (!doc$1 || from$1 == null || to == null) return false;
				const docSize = doc$1.content.size;
				const rangeStart = Math.max(0, Math.min(from$1, to));
				const rangeEnd = Math.min(docSize, Math.max(from$1, to));
				let found = false;
				doc$1.nodesBetween(rangeStart, rangeEnd, (node, pos) => {
					if (found) return false;
					if (node.type.name !== "paragraph") return;
					if (calculateResolvedParagraphProperties(editor, node, doc$1.resolve(pos))?.numberingProperties) {
						found = true;
						return false;
					}
					return false;
				});
				return found;
			};
			if (!(() => {
				if (forcePluginPass || forceFullRecompute) return true;
				if (!hasDocChanges) return false;
				const diffStart = oldState.doc.content.findDiffStart(newState.doc.content);
				if (diffStart == null) return false;
				const diffEnd = oldState.doc.content.findDiffEnd(newState.doc.content);
				const oldDiffEnd = diffEnd?.a ?? diffStart;
				const newDiffEnd = diffEnd?.b ?? diffStart;
				if (hasNumberedParagraphInRange(oldState.doc, diffStart, oldDiffEnd)) return true;
				return hasNumberedParagraphInRange(newState.doc, diffStart, newDiffEnd);
			})()) return null;
			forceFullRecompute = false;
			const tr = newState.tr;
			tr.setMeta("orderedListSync", true);
			const bumpBlockRev = (node, pos) => {
				const current = node?.attrs?.sdBlockRev;
				let nextRev;
				if (typeof current === "number" && Number.isFinite(current)) nextRev = current + 1;
				else if (typeof current === "string" && current.trim() !== "") {
					const parsed = Number.parseInt(current, 10);
					if (Number.isFinite(parsed)) nextRev = parsed + 1;
				}
				if (nextRev != null) tr.setNodeAttribute(pos, "sdBlockRev", nextRev);
			};
			const normalizeListRendering = (listRendering) => listRendering ?? null;
			const serializeListRendering = (listRendering) => JSON.stringify(normalizeListRendering(listRendering));
			const updateListRenderingIfNeeded = (node, pos, nextListRendering) => {
				if (serializeListRendering(node?.attrs?.listRendering) === serializeListRendering(nextListRendering)) return;
				tr.setNodeAttribute(pos, "listRendering", normalizeListRendering(nextListRendering));
				bumpBlockRev(node, pos);
			};
			numberingManager.enableCache();
			try {
				newState.doc.descendants((node, pos) => {
					let resolvedProps = calculateResolvedParagraphProperties(editor, node, newState.doc.resolve(pos));
					if (node.type.name !== "paragraph" || !resolvedProps.numberingProperties) return;
					if (shouldPreserveSlicePastedListRendering(node, transactions)) return false;
					const { numId, ilvl: level = 0 } = resolvedProps.numberingProperties;
					const definitionDetails = ListHelpers.getListDefinitionDetails({
						numId,
						level,
						editor
					});
					if (!definitionDetails || Object.keys(definitionDetails).length === 0) {
						updateListRenderingIfNeeded(node, pos, null);
						return false;
					}
					let { lvlText, customFormat, listNumberingType, suffix, justification, abstractId } = definitionDetails;
					let markerText = "";
					listNumberingType = listNumberingType || "decimal";
					const count = numberingManager.calculateCounter(numId, level, pos, abstractId);
					numberingManager.setCounter(numId, level, pos, count, abstractId);
					const path = numberingManager.calculatePath(numId, level, pos);
					if (listNumberingType !== "bullet") markerText = generateOrderedListIndex({
						listLevel: path,
						lvlText,
						listNumberingType,
						customFormat
					}) ?? "";
					else markerText = docxNumberingHelpers.normalizeLvlTextChar(lvlText) ?? "";
					updateListRenderingIfNeeded(node, pos, {
						markerText,
						suffix,
						justification,
						path,
						numberingType: listNumberingType,
						...customFormat ? { customFormat } : {}
					});
					return false;
				});
			} finally {
				numberingManager.disableCache();
			}
			return tr.docChanged ? tr : null;
		}
	});
}
var shouldAddLeadingCaret = (node) => {
	if (node.type.name !== "paragraph") return false;
	if (node.childCount === 0) return false;
	const first$1 = node.child(0);
	if (first$1.type.name === "fieldAnnotation") return true;
	if (first$1.type.name !== "run") return false;
	if (first$1.childCount === 0) return false;
	return first$1.child(0).type.name === "fieldAnnotation";
};
function createLeadingCaretPlugin() {
	return new Plugin({ props: { decorations(state) {
		if (typeof document === "undefined") return null;
		const decorations = [];
		state.doc.descendants((node, pos) => {
			if (!shouldAddLeadingCaret(node)) return true;
			const widgetPos = pos + 1;
			const deco = Decoration.widget(widgetPos, () => document.createTextNode("​"), {
				key: `sd-leading-caret-${pos}`,
				side: -1
			});
			decorations.push(deco);
			return false;
		});
		return decorations.length ? DecorationSet.create(state.doc, decorations) : null;
	} } });
}
function createDropcapPlugin(editor) {
	const { view } = editor;
	const dropcapWidthCache = /* @__PURE__ */ new Map();
	const invalidateCacheForRange = (from$1, to) => {
		for (const [pos] of dropcapWidthCache) if (pos >= from$1 && pos <= to) dropcapWidthCache.delete(pos);
	};
	const getDropcapDecorations = (state, view$1, widthCache) => {
		const decorations = [];
		state.doc.descendants((node, pos) => {
			if (hasDropcapParagraph(node, pos, state)) {
				const width = getDropcapWidth(view$1, pos, widthCache);
				decorations.push(Decoration.inline(pos, pos + node.nodeSize, { style: `margin-left: -${width}px;` }));
				return false;
			}
			return node.type.name !== "paragraph";
		});
		return decorations;
	};
	function getDropcapWidth(view$1, pos, widthCache) {
		if (widthCache.has(pos)) return widthCache.get(pos);
		const domNode = view$1.nodeDOM(pos);
		if (domNode) {
			const range = document.createRange();
			range.selectNodeContents(domNode);
			const width = range.getBoundingClientRect().width;
			widthCache.set(pos, width);
			return width;
		}
		return 0;
	}
	const hasDropcapParagraph = (node, pos, state) => {
		if (node.type.name !== "paragraph") return false;
		return calculateResolvedParagraphProperties(editor, node, state.doc.resolve(pos)).framePr?.dropCap === "margin";
	};
	return new Plugin({
		name: "dropcapPlugin",
		key: new PluginKey("dropcapPlugin"),
		state: {
			init(_$1, state) {
				if (editor.presentationEditor) return DecorationSet.empty;
				const decorations = getDropcapDecorations(state, view, dropcapWidthCache);
				return DecorationSet.create(state.doc, decorations);
			},
			apply(tr, oldDecorationSet, oldState, newState) {
				if (editor.presentationEditor) return DecorationSet.empty;
				if (!tr.docChanged) return oldDecorationSet;
				let hasDropcaps = false;
				newState.doc.descendants((node, pos) => {
					if (hasDropcapParagraph(node, pos, newState)) {
						hasDropcaps = true;
						return false;
					}
				});
				if (!hasDropcaps) {
					dropcapWidthCache.clear();
					return DecorationSet.empty;
				}
				let affectsDropcaps = false;
				tr.steps.forEach((step) => {
					if (step.slice?.content) step.slice.content.descendants((node, pos) => {
						if (hasDropcapParagraph(node, pos, newState)) {
							affectsDropcaps = true;
							return false;
						}
					});
					if (step.jsonID === "replace" && step.from !== void 0 && step.to !== void 0) try {
						oldState.doc.nodesBetween(step.from, step.to, (node, pos) => {
							if (hasDropcapParagraph(node, pos, newState)) {
								affectsDropcaps = true;
								return false;
							}
						});
					} catch {
						affectsDropcaps = true;
					}
				});
				if (!affectsDropcaps) return oldDecorationSet.map(tr.mapping, tr.doc);
				tr.steps.forEach((step) => {
					if (step.from !== void 0 && step.to !== void 0) invalidateCacheForRange(step.from, step.to);
				});
				const decorations = getDropcapDecorations(newState, view, dropcapWidthCache);
				return DecorationSet.create(newState.doc, decorations);
			}
		},
		props: { decorations(state) {
			return this.getState(state);
		} }
	});
}
function isListParagraph(node) {
	return node?.type?.name === "paragraph" && node.attrs?.paragraphProperties?.numberingProperties && node.attrs?.listRendering;
}
function isRtlParagraph$1(node) {
	return getParagraphInlineDirection(node?.attrs) === "rtl";
}
function getParagraphContext$1($pos) {
	for (let depth = $pos.depth; depth >= 0; depth--) {
		const node = $pos.node(depth);
		if (node.type.name !== "paragraph") continue;
		return {
			node,
			pos: depth === 0 ? 0 : $pos.before(depth),
			start: $pos.start(depth),
			end: $pos.end(depth)
		};
	}
	return null;
}
function getParagraphTextBounds(paragraph, paragraphStart) {
	let first$1 = null;
	let last = null;
	paragraph.descendants((node, pos) => {
		if (!node.isText || !node.text?.length) return true;
		const from$1 = paragraphStart + pos;
		const to = from$1 + node.text.length;
		if (first$1 == null || from$1 < first$1) first$1 = from$1;
		if (last == null || to > last) last = to;
		return true;
	});
	return first$1 == null || last == null ? null : {
		first: first$1,
		last
	};
}
function findAdjacentTextPosition(doc$1, boundary, direction) {
	let target = null;
	if (direction < 0) {
		doc$1.nodesBetween(0, boundary, (node, pos) => {
			if (node.isText && node.text?.length) target = pos + node.text.length;
			return true;
		});
		return target;
	}
	doc$1.nodesBetween(boundary, doc$1.content.size, (node, pos) => {
		if (target != null) return false;
		if (node.isText && node.text?.length) {
			target = pos;
			return false;
		}
		return true;
	});
	return target;
}
function shouldHandlePlainHorizontalArrow(event) {
	return (event.key === "ArrowLeft" || event.key === "ArrowRight") && !event.shiftKey && !event.altKey && !event.ctrlKey && !event.metaKey;
}
function createListBoundaryNavigationPlugin() {
	return new Plugin({ props: { handleKeyDown(view, event) {
		if (!shouldHandlePlainHorizontalArrow(event)) return false;
		const { state } = view;
		const { selection } = state;
		if (!selection.empty) return false;
		const paragraph = getParagraphContext$1(selection.$from);
		if (!paragraph || !isListParagraph(paragraph.node)) return false;
		const bounds = getParagraphTextBounds(paragraph.node, paragraph.start);
		if (!bounds) return false;
		const direction = isRtlParagraph$1(paragraph.node) ? event.key === "ArrowRight" ? -1 : 1 : event.key === "ArrowLeft" ? -1 : 1;
		const atLeftBoundary = direction < 0 && selection.from <= bounds.first;
		const atRightBoundary = direction > 0 && selection.from >= bounds.last;
		if (!atLeftBoundary && !atRightBoundary) return false;
		const target = findAdjacentTextPosition(state.doc, direction < 0 ? paragraph.pos : paragraph.end, direction);
		if (target == null || target === selection.from) return false;
		event.preventDefault();
		view.dispatch(state.tr.setSelection(TextSelection.create(state.doc, target)).scrollIntoView());
		return true;
	} } });
}
const isHeadless = (editor) => {
	return editor?.options?.isHeadless ?? false;
};
const shouldSkipNodeView = (editor) => {
	return isHeadless(editor);
};
var CSS_LENGTH_TO_PT = {
	pt: 1,
	px: 72 / 96,
	in: 72,
	cm: 28.3465,
	mm: 2.83465
};
var CSS_ALIGN_TO_OOXML = {
	center: "center",
	right: "right",
	justify: "justify",
	end: "right"
};
function parseCssLength(value) {
	if (!value) return null;
	const match$1 = value.match(/^(-?[0-9]*\.?[0-9]+)\s*(%|[a-z]*)$/i);
	if (!match$1) return null;
	const num = parseFloat(match$1[1]);
	if (isNaN(num)) return null;
	const unit = match$1[2];
	if (!unit) return {
		points: num,
		unit: ""
	};
	if (unit === "%") return {
		points: num,
		unit: "%"
	};
	const factor = CSS_LENGTH_TO_PT[unit];
	return factor != null ? {
		points: num * factor,
		unit
	} : null;
}
function parseAttrs(node) {
	const numberingProperties = {};
	let indent, spacing, justification;
	let rightToLeft;
	let sectionProperties = null;
	let pageBreakSource = null;
	const { styleid: styleId$1, ...extraAttrs } = Array.from(node.attributes).reduce((acc, attr) => {
		if (attr.name === "data-num-id") numberingProperties.numId = parseInt(attr.value);
		else if (attr.name === "data-level") numberingProperties.ilvl = parseInt(attr.value);
		else if (attr.name === "data-indent") try {
			indent = JSON.parse(attr.value);
			Object.keys(indent).forEach((key) => {
				indent[key] = Number(indent[key]);
			});
		} catch {}
		else if (attr.name === "data-spacing") try {
			spacing = JSON.parse(attr.value);
			Object.keys(spacing).forEach((key) => {
				if (key !== "lineRule") spacing[key] = Number(spacing[key]);
			});
		} catch {}
		else if (attr.name === "data-justification") justification = attr.value;
		else if (attr.name === "data-sd-sect-pr") try {
			const parsedSectionProperties = JSON.parse(attr.value);
			if (parsedSectionProperties && typeof parsedSectionProperties === "object") sectionProperties = parsedSectionProperties;
		} catch {}
		else if (attr.name === "data-sd-page-break-source") pageBreakSource = attr.value || null;
		else if (attr.name === "dir") {
			if (attr.value === "rtl") rightToLeft = true;
			else if (attr.value === "ltr") rightToLeft = false;
		} else acc[attr.name] = attr.value;
		return acc;
	}, {});
	if (!spacing && node.style) {
		const cssSpacing = {};
		const lh = parseCssLength(node.style.lineHeight);
		if (lh && lh.points > 0) if (lh.unit === "" || lh.unit === "%") {
			const multiplier = lh.unit === "%" ? lh.points / 100 : lh.points;
			cssSpacing.line = Math.round(multiplier * 240 / 1.15);
			cssSpacing.lineRule = "auto";
		} else {
			cssSpacing.line = Math.round(lh.points * 20);
			cssSpacing.lineRule = "exact";
		}
		const mt = parseCssLength(node.style.marginTop);
		if (mt && mt.unit !== "%" && mt.points >= 0) cssSpacing.before = Math.round(mt.points * 20);
		const mb = parseCssLength(node.style.marginBottom);
		if (mb && mb.unit !== "%" && mb.points >= 0) cssSpacing.after = Math.round(mb.points * 20);
		if (Object.keys(cssSpacing).length > 0) spacing = cssSpacing;
	}
	if (!indent && node.style) {
		const cssIndent = {};
		const ml = parseCssLength(node.style.marginLeft);
		if (ml && ml.unit !== "%" && ml.points >= 0) cssIndent.left = Math.round(ml.points * 20);
		const mis = parseCssLength(node.style.marginInlineStart);
		if (mis && mis.unit !== "%" && mis.points >= 0) cssIndent.start = Math.round(mis.points * 20);
		const mie = parseCssLength(node.style.marginInlineEnd);
		if (mie && mie.unit !== "%" && mie.points >= 0) cssIndent.end = Math.round(mie.points * 20);
		const ti = parseCssLength(node.style.textIndent);
		if (ti && ti.unit !== "%") if (ti.points >= 0) cssIndent.firstLine = Math.round(ti.points * 20);
		else cssIndent.hanging = Math.round(Math.abs(ti.points) * 20);
		if (Object.keys(cssIndent).length > 0) indent = cssIndent;
	}
	if (!justification && node.style) {
		const textAlign = node.style.textAlign;
		if (textAlign && CSS_ALIGN_TO_OOXML[textAlign]) justification = CSS_ALIGN_TO_OOXML[textAlign];
	}
	if (rightToLeft == null && node.style) {
		if (node.style.direction === "rtl") rightToLeft = true;
		else if (node.style.direction === "ltr") rightToLeft = false;
	}
	let attrs = {
		paragraphProperties: { styleId: styleId$1 || null },
		extraAttrs
	};
	if (indent && Object.keys(indent).length > 0) attrs.paragraphProperties.indent = indent;
	if (spacing && Object.keys(spacing).length > 0) attrs.paragraphProperties.spacing = spacing;
	if (justification) attrs.paragraphProperties.justification = justification;
	if (rightToLeft != null) attrs.paragraphProperties.rightToLeft = rightToLeft;
	if (Object.keys(numberingProperties).length > 0) attrs.paragraphProperties.numberingProperties = numberingProperties;
	if (sectionProperties) attrs.paragraphProperties.sectPr = sectionProperties;
	if (pageBreakSource) attrs.pageBreakSource = pageBreakSource;
	return attrs;
}
function hasOnlyBreakContent(node) {
	if (!node || node.type.name !== "paragraph") return false;
	if ((node.textContent || "").replace(/\u200b/g, "").trim().length > 0) return false;
	let hasBreak = false;
	let hasOtherContent = false;
	node.descendants((child) => {
		if (!child.isInline || !child.isLeaf) return true;
		if (child.type.name === "lineBreak" || child.type.name === "hardBreak") hasBreak = true;
		else hasOtherContent = true;
		return !hasOtherContent;
	});
	return hasBreak && !hasOtherContent;
}
var bulletInputRegex = /^\s*([-+*])\s$/;
var orderedInputRegex = /^(\d+)\.\s$/;
const Paragraph = OxmlNode.create({
	name: "paragraph",
	oXmlName: "w:p",
	priority: 1e3,
	group: "block",
	content: "inline*",
	inline: false,
	summary: "The paragraph node mirrors MS Word w:p paragraphs, and also represents lists in the schema.",
	addOptions() {
		return {
			headingLevels: [
				1,
				2,
				3,
				4,
				5,
				6
			],
			htmlAttributes: {}
		};
	},
	addAttributes() {
		return {
			paraId: {
				rendered: false,
				keepOnSplit: false
			},
			textId: {
				rendered: false,
				keepOnSplit: false
			},
			rsidR: { rendered: false },
			rsidRDefault: { rendered: false },
			rsidP: { rendered: false },
			rsidRPr: { rendered: false },
			rsidDel: { rendered: false },
			extraAttrs: {
				default: {},
				parseDOM: (element) => {
					const extra = {};
					Array.from(element.attributes).forEach((attr) => {
						extra[attr.name] = attr.value;
					});
					return extra;
				},
				renderDOM: (attributes) => {
					return attributes.extraAttrs || {};
				}
			},
			sdBlockId: {
				default: null,
				keepOnSplit: false,
				parseDOM: (elem) => elem.getAttribute("data-sd-block-id"),
				renderDOM: (attrs) => {
					return attrs.sdBlockId ? { "data-sd-block-id": attrs.sdBlockId } : {};
				}
			},
			sdBlockRev: {
				default: 0,
				rendered: false,
				keepOnSplit: false
			},
			attributes: { rendered: false },
			filename: { rendered: false },
			paragraphProperties: { rendered: false },
			pageBreakSource: { rendered: false },
			tocSourceId: { rendered: false },
			sectionMargins: { rendered: false },
			listRendering: {
				keepOnSplit: false,
				renderDOM: ({ listRendering }) => {
					return {
						"data-marker-type": listRendering?.markerText,
						"data-list-level": listRendering?.path ? JSON.stringify(listRendering.path) : null,
						"data-list-numbering-type": listRendering?.numberingType
					};
				}
			}
		};
	},
	parseDOM() {
		return [
			{
				tag: "p",
				getAttrs: parseAttrs
			},
			{
				tag: "div",
				getAttrs: (node) => {
					const extra = {};
					Array.from(node.attributes).forEach((attr) => {
						extra[attr.name] = attr.value;
					});
					return { extraAttrs: extra };
				}
			},
			{
				tag: "blockquote",
				attrs: { paragraphProperties: { styleId: "BlockQuote" } }
			},
			...this.options.headingLevels.map((level) => ({
				tag: `h${level}`,
				getAttrs: (node) => {
					let attrs = parseAttrs(node);
					return {
						...attrs,
						paragraphProperties: {
							...attrs.paragraphProperties,
							styleId: `Heading${level}`
						}
					};
				}
			}))
		];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"p",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	},
	addNodeView() {
		if (this.editor.options?.mode !== "docx" || !this.editor.converter) return null;
		if (shouldSkipNodeView(this.editor)) return null;
		return ({ node, editor, getPos, decorations, extensionAttrs }) => {
			return new ParagraphNodeView(node, editor, getPos, decorations, extensionAttrs);
		};
	},
	addShortcuts() {
		return {
			"Mod-Shift-7": () => {
				return this.editor.commands.toggleOrderedList();
			},
			"Mod-Shift-8": () => {
				return this.editor.commands.toggleBulletList();
			},
			Enter: (params$1) => {
				return removeNumberingProperties({ checkType: "empty" })({
					...params$1,
					tr: this.editor.state.tr,
					state: this.editor.state,
					dispatch: this.editor.view.dispatch
				});
			},
			"Shift-Enter": () => {
				return this.editor.commands.first(({ commands: commands$1 }) => [() => commands$1.createParagraphNear(), splitBlock({ attrsToRemoveOverride: [
					"paragraphProperties.numberingProperties",
					"listRendering",
					"numberingProperties"
				] })]);
			},
			Tab: () => {
				return this.editor.commands.first(({ commands: commands$1 }) => [() => commands$1.increaseListIndent()]);
			},
			"Shift-Tab": () => {
				return this.editor.commands.first(({ commands: commands$1 }) => [() => commands$1.decreaseListIndent()]);
			}
		};
	},
	addInputRules() {
		return [{
			regex: orderedInputRegex,
			type: "orderedList"
		}, {
			regex: bulletInputRegex,
			type: "bulletList"
		}].map(({ regex, type }) => new InputRule({
			match: regex,
			handler: ({ state, range }) => {
				if (findParentNode(isList)(state.selection)) return null;
				const { tr } = state;
				tr.delete(range.from, range.to).setSelection(TextSelection.create(tr.doc, range.from));
				ListHelpers.createNewList({
					listType: type,
					tr,
					editor: this.editor
				});
			}
		}));
	},
	addCommands() {
		return {
			toggleOrderedList: () => (params$1) => {
				return toggleList("orderedList")(params$1);
			},
			toggleBulletList: () => (params$1) => {
				return toggleList("bulletList")(params$1);
			},
			toggleBulletListStyle: (style) => (params$1) => {
				return toggleList("bulletList", style)(params$1);
			},
			toggleOrderedListStyle: (style) => (params$1) => {
				return toggleList("orderedList", null, style)(params$1);
			},
			restartNumbering: () => restartNumbering,
			continueNumbering: () => continueNumbering
		};
	},
	addPmPlugins() {
		return [
			createDropcapPlugin(this.editor),
			createNumberingPlugin(this.editor),
			new Plugin({ props: { handleDOMEvents: { beforeinput: (view, event) => {
				if (!event || event.inputType !== "insertText" || !event.data) return false;
				if (event.isComposing) return false;
				const { state } = view;
				const { selection } = state;
				if (!selection.empty) return false;
				const { $from } = selection;
				let paragraph = null;
				let paragraphDepth = null;
				for (let d = $from.depth; d >= 0; d--) {
					const node = $from.node(d);
					if (node.type.name === "paragraph") {
						paragraph = node;
						paragraphDepth = d;
						break;
					}
				}
				if (!paragraph) return false;
				if (!(paragraph.attrs?.paragraphProperties?.numberingProperties && paragraph.attrs?.listRendering)) return false;
				if (!isVisuallyEmptyParagraph(paragraph) && !hasOnlyBreakContent(paragraph)) return false;
				let tr = state.tr;
				if (hasOnlyBreakContent(paragraph) && paragraphDepth != null) {
					const contentStart = $from.start(paragraphDepth);
					const contentEnd = $from.end(paragraphDepth);
					tr = tr.delete(contentStart, contentEnd).insertText(event.data, contentStart);
					tr = tr.setSelection(TextSelection.create(tr.doc, contentStart + event.data.length));
				} else tr = tr.insertText(event.data);
				view.dispatch(tr);
				event.preventDefault();
				return true;
			} } } }),
			createLeadingCaretPlugin(),
			createListBoundaryNavigationPlugin()
		];
	}
});
const Heading = Extension.create({
	name: "heading",
	addOptions() {
		return { levels: [
			1,
			2,
			3,
			4,
			5,
			6
		] };
	},
	addCommands() {
		return {
			setHeading: (attributes) => ({ commands: commands$1 }) => {
				if (!this.options.levels.includes(attributes.level)) return false;
				return commands$1.setLinkedStyle({ id: `Heading${attributes.level}` });
			},
			toggleHeading: (attributes) => ({ commands: commands$1 }) => {
				if (!this.options.levels.includes(attributes.level)) return false;
				return commands$1.toggleLinkedStyle({ id: `Heading${attributes.level}` }, "paragraph");
			}
		};
	},
	addShortcuts() {
		return this.options.levels.reduce((items, level) => ({
			...items,
			[`Mod-Alt-${level}`]: () => this.editor.commands.toggleHeading({ level })
		}), {});
	}
});
const CommentRangeStart = Node$1.create({
	name: "commentRangeStart",
	group: "inline",
	inline: true,
	atom: true,
	selectable: false,
	draggable: false,
	parseDOM() {
		return [{ tag: "commentRangeStart" }];
	},
	addOptions() {
		return { htmlAttributes: {
			contentEditable: "false",
			"aria-label": "Comment range start node"
		} };
	},
	renderDOM({ htmlAttributes }) {
		return ["commentRangeStart", Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes)];
	},
	addAttributes() {
		return {
			"w:id": { rendered: false },
			internal: {
				default: true,
				rendered: false
			}
		};
	}
});
const CommentRangeEnd = Node$1.create({
	name: "commentRangeEnd",
	group: "inline",
	inline: true,
	atom: true,
	selectable: false,
	draggable: false,
	addOptions() {
		return { htmlAttributes: {
			contentEditable: "false",
			"aria-label": "Comment range end node"
		} };
	},
	parseDOM() {
		return [{ tag: "commentRangeEnd" }];
	},
	renderDOM({ htmlAttributes }) {
		return ["commentRangeEnd", Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes)];
	},
	addAttributes() {
		return { "w:id": { rendered: false } };
	}
});
const CommentReference = Node$1.create({
	name: "commentReference",
	group: "inline",
	inline: true,
	atom: true,
	selectable: false,
	draggable: false,
	addOptions() {
		return { htmlAttributes: {
			contentEditable: "false",
			"aria-label": "Comment reference node"
		} };
	},
	parseDOM() {
		return [{ tag: "commentReference" }];
	},
	renderDOM({ htmlAttributes }) {
		return ["commentReference", Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes)];
	},
	addAttributes() {
		return { attributes: { rendered: false } };
	}
});
const CommentsMark = Mark.create({
	name: CommentMarkName,
	group: "comments",
	excludes: "",
	inclusive: false,
	addOptions() {
		return { htmlAttributes: { class: "sd-editor-comment" } };
	},
	addAttributes() {
		return {
			commentId: {},
			importedId: {},
			internal: {
				default: true,
				rendered: false
			},
			trackedChange: {
				default: false,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: CommentMarkName }];
	},
	renderDOM({ htmlAttributes }) {
		return [CommentMarkName, Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes)];
	}
});
var toSuperscriptDigits$1 = (value) => {
	const map$1 = {
		0: "⁰",
		1: "¹",
		2: "²",
		3: "³",
		4: "⁴",
		5: "⁵",
		6: "⁶",
		7: "⁷",
		8: "⁸",
		9: "⁹"
	};
	return String(value ?? "").split("").map((ch) => map$1[ch] ?? ch).join("");
};
var resolveFootnoteDisplayNumber = (editor, id) => {
	const key = id == null ? null : String(id);
	if (!key) return null;
	const map$1 = editor?.converter?.footnoteNumberById;
	const mapped = map$1 && typeof map$1 === "object" ? map$1[key] : void 0;
	return typeof mapped === "number" && Number.isFinite(mapped) && mapped > 0 ? mapped : null;
};
var FootnoteReferenceNodeView = class {
	constructor(node, getPos, decorations, editor, htmlAttributes = {}) {
		this.node = node;
		this.getPos = getPos;
		this.editor = editor;
		this.dom = this.#renderDom(node, htmlAttributes);
	}
	#renderDom(node, htmlAttributes) {
		const el = document.createElement("sup");
		el.className = "sd-footnote-ref";
		el.setAttribute("contenteditable", "false");
		el.setAttribute("aria-label", "Footnote reference");
		Object.entries(htmlAttributes).forEach(([key, value]) => {
			if (value != null && value !== false) el.setAttribute(key, String(value));
		});
		const id = node?.attrs?.id;
		if (id != null) {
			el.setAttribute("data-footnote-id", String(id));
			el.textContent = toSuperscriptDigits$1(resolveFootnoteDisplayNumber(this.editor, id) ?? id);
		} else el.textContent = "*";
		return el;
	}
	update(node) {
		const incomingType = node?.type?.name;
		const currentType = this.node?.type?.name;
		if (!incomingType || incomingType !== currentType) return false;
		this.node = node;
		const id = node?.attrs?.id;
		if (id != null) {
			this.dom.setAttribute("data-footnote-id", String(id));
			const display = resolveFootnoteDisplayNumber(this.editor, id) ?? id;
			this.dom.textContent = toSuperscriptDigits$1(display);
		} else {
			this.dom.removeAttribute("data-footnote-id");
			this.dom.textContent = "*";
		}
		return true;
	}
};
const FootnoteReference = Node$1.create({
	name: "footnoteReference",
	group: "inline",
	inline: true,
	atom: true,
	selectable: false,
	draggable: false,
	addOptions() {
		return { htmlAttributes: { "data-footnote-ref": "true" } };
	},
	addAttributes() {
		return {
			id: { default: null },
			customMarkFollows: { default: null }
		};
	},
	addNodeView() {
		return ({ node, editor, getPos, decorations }) => {
			const htmlAttributes = this.options.htmlAttributes;
			return new FootnoteReferenceNodeView(node, getPos, decorations, editor, htmlAttributes);
		};
	},
	parseDOM() {
		return [{ tag: "sup[data-footnote-id]" }];
	},
	renderDOM({ htmlAttributes }) {
		return ["sup", Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes)];
	}
});
var toSuperscriptDigits = (value) => {
	const map$1 = {
		0: "⁰",
		1: "¹",
		2: "²",
		3: "³",
		4: "⁴",
		5: "⁵",
		6: "⁶",
		7: "⁷",
		8: "⁸",
		9: "⁹"
	};
	return String(value ?? "").split("").map((ch) => map$1[ch] ?? ch).join("");
};
var resolveEndnoteDisplayNumber = (editor, id) => {
	const key = id == null ? null : String(id);
	if (!key) return null;
	const map$1 = editor?.converter?.endnoteNumberById;
	const mapped = map$1 && typeof map$1 === "object" ? map$1[key] : void 0;
	return typeof mapped === "number" && Number.isFinite(mapped) && mapped > 0 ? mapped : null;
};
var EndnoteReferenceNodeView = class {
	constructor(node, getPos, decorations, editor, htmlAttributes = {}) {
		this.node = node;
		this.getPos = getPos;
		this.editor = editor;
		this.dom = this.#renderDom(node, htmlAttributes);
	}
	#renderDom(node, htmlAttributes) {
		const el = document.createElement("sup");
		el.className = "sd-endnote-ref";
		el.setAttribute("contenteditable", "false");
		el.setAttribute("aria-label", "Endnote reference");
		Object.entries(htmlAttributes).forEach(([key, value]) => {
			if (value != null && value !== false) el.setAttribute(key, String(value));
		});
		const id = node?.attrs?.id;
		if (id != null) {
			el.setAttribute("data-endnote-id", String(id));
			el.textContent = toSuperscriptDigits(resolveEndnoteDisplayNumber(this.editor, id) ?? id);
		} else el.textContent = "*";
		return el;
	}
	update(node) {
		const incomingType = node?.type?.name;
		const currentType = this.node?.type?.name;
		if (!incomingType || incomingType !== currentType) return false;
		this.node = node;
		const id = node?.attrs?.id;
		if (id != null) {
			this.dom.setAttribute("data-endnote-id", String(id));
			const display = resolveEndnoteDisplayNumber(this.editor, id) ?? id;
			this.dom.textContent = toSuperscriptDigits(display);
		} else {
			this.dom.removeAttribute("data-endnote-id");
			this.dom.textContent = "*";
		}
		return true;
	}
};
const EndnoteReference = Node$1.create({
	name: "endnoteReference",
	group: "inline",
	inline: true,
	atom: true,
	selectable: false,
	draggable: false,
	addOptions() {
		return { htmlAttributes: { "data-endnote-ref": "true" } };
	},
	addAttributes() {
		return {
			id: { default: null },
			customMarkFollows: { default: null }
		};
	},
	addNodeView() {
		return ({ node, editor, getPos, decorations }) => {
			const htmlAttributes = this.options.htmlAttributes;
			return new EndnoteReferenceNodeView(node, getPos, decorations, editor, htmlAttributes);
		};
	},
	parseDOM() {
		return [{ tag: "sup[data-endnote-id]" }];
	},
	renderDOM({ htmlAttributes }) {
		return ["sup", Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes)];
	}
});
var cache$1 = /* @__PURE__ */ new WeakMap();
function getParagraphContext(paragraph, startPos, helpers, revision, compute) {
	const cached = cache$1.get(paragraph);
	if (cached && cached.revision === revision) return cached.context;
	const context = compute(paragraph, startPos, helpers);
	cache$1.set(paragraph, {
		revision,
		context
	});
	return context;
}
function clearAllParagraphContexts() {
	cache$1 = /* @__PURE__ */ new WeakMap();
}
var leaderStyles = {
	dot: "border-bottom: 1px dotted black;",
	heavy: "border-bottom: 2px solid black;",
	hyphen: "border-bottom: 1px solid black;",
	middleDot: "border-bottom: 1px dotted black; margin-bottom: 2px;",
	underscore: "border-bottom: 1px solid black;"
};
var paragraphIdFromPos = (startPos) => `para-${startPos}`;
var tabIdForIndex = (paragraphId, index) => `${paragraphId}-tab-${index}`;
function createLayoutRequest(doc$1, paragraphPos, view, helpers, revision, paragraphWidthOverride) {
	const paragraphContext = findParagraphContext(doc$1.resolve(paragraphPos), /* @__PURE__ */ new Map(), helpers);
	if (!paragraphContext) return null;
	const paragraphId = paragraphIdFromPos(paragraphContext.startPos);
	const paragraphNode = paragraphContext.paragraph;
	const effectiveContext = getParagraphContext(paragraphNode, paragraphContext.startPos, helpers, revision, () => extractParagraphContext(paragraphNode, paragraphContext.startPos, helpers, paragraphContext.paragraphDepth)) || paragraphContext;
	const { entries } = flattenParagraph(paragraphNode, paragraphContext.startPos);
	const spans = [];
	let tabIndex = 0;
	entries.forEach((entry, idx) => {
		const node = entry.node;
		const spanId = `${paragraphId}-span-${idx}`;
		const from$1 = entry.pos;
		const to = entry.pos + node.nodeSize;
		if (node.type.name === "tab") spans.push({
			type: "tab",
			spanId,
			tabId: tabIdForIndex(paragraphId, tabIndex++),
			pos: entry.pos,
			nodeSize: node.nodeSize
		});
		else if (node.type.name === "lineBreak" || node.type.name === "hardBreak") spans.push({
			type: node.type.name,
			spanId,
			pos: entry.pos,
			nodeSize: node.nodeSize
		});
		else if (node.type.name === "text") spans.push({
			type: "text",
			spanId,
			text: node.text || "",
			style: node.marks?.find((mark) => mark.type.name === "textStyle")?.attrs || {},
			from: from$1,
			to
		});
	});
	const tabStops = Array.isArray(effectiveContext.tabStops) ? [...effectiveContext.tabStops] : [];
	const hangingPx = twipsToPixels$1(Number(effectiveContext.indent?.hanging) || 0);
	if (hangingPx > 0 && effectiveContext.indentWidth != null) tabStops.unshift({
		val: "start",
		pos: effectiveContext.indentWidth + hangingPx,
		leader: "none"
	});
	const paragraphWidth = paragraphWidthOverride ?? getBlockNodeWidth(view, effectiveContext.startPos) ?? 816;
	const indentWidth = effectiveContext.indentWidth ?? getIndentWidth(view, effectiveContext.startPos, effectiveContext.indent);
	return {
		paragraphId,
		revision,
		paragraphWidth,
		defaultTabDistance: 48,
		defaultLineLength: 816,
		indents: {
			left: twipsToPixels$1(Number(effectiveContext.indent?.left) || 0),
			right: twipsToPixels$1(Number(effectiveContext.indent?.right) || 0),
			firstLine: twipsToPixels$1(Number(effectiveContext.indent?.firstLine) || 0),
			hanging: hangingPx
		},
		tabStops,
		spans,
		indentWidth,
		paragraphNode
	};
}
function calculateTabLayout(request, measurement, view) {
	const { spans, tabStops, paragraphWidth, defaultTabDistance: defaultTabDistance$1, defaultLineLength: defaultLineLength$1, paragraphId, revision, indentWidth = 0, paragraphNode } = request;
	const tabs = {};
	const leftIndentPx = request.indents?.left ?? 0;
	let currentX = indentWidth;
	const measureText$1 = (span) => {
		if (measurement?.measureText) return measurement.measureText(span.spanId, span.text || "");
		if (view && typeof span.from === "number" && typeof span.to === "number") return measureRangeWidth(view, span.from, span.to);
		return 0;
	};
	const tabHeight = paragraphNode ? calcTabHeight(paragraphNode) : void 0;
	for (let i = 0; i < spans.length; i++) {
		const span = spans[i];
		if (span.type === "text") currentX += measureText$1(span);
		else if (span.type === "lineBreak" || span.type === "hardBreak") currentX = leftIndentPx;
		else if (span.type === "tab") {
			const followingText = collectFollowingText(spans, i + 1);
			let measureTextCallback;
			if (measurement?.measureText) measureTextCallback = (text) => measurement.measureText(span.spanId, text);
			else if (view) {
				const followingRange = getFollowingTextRange(spans, i + 1);
				if (followingRange) {
					const fullWidth = measureRangeWidth(view, followingRange.from, followingRange.to);
					const fullText = followingText;
					measureTextCallback = (text) => {
						if (text === fullText) return fullWidth;
						if (fullText.length > 0) return text.length / fullText.length * fullWidth;
						return 0;
					};
				}
			}
			const result = calculateTabWidth({
				currentX,
				tabStops,
				paragraphWidth,
				defaultTabDistance: defaultTabDistance$1,
				defaultLineLength: defaultLineLength$1,
				followingText,
				measureText: measureTextCallback
			});
			tabs[span.tabId] = {
				width: result.width,
				height: tabHeight,
				leader: result.leader,
				alignment: result.alignment,
				tabStopPosUsed: result.tabStopPosUsed
			};
			currentX += result.width;
		}
	}
	return {
		paragraphId,
		revision,
		tabs
	};
}
var MAX_WALK_DEPTH = 50;
function applyLayoutResult(result, paragraph, paragraphPos) {
	const decorations = [];
	let tabIndex = 0;
	const walk = (node, pos, depth = 0) => {
		if (depth > MAX_WALK_DEPTH) {
			console.error(`applyLayoutResult: Maximum recursion depth (${MAX_WALK_DEPTH}) exceeded`);
			return;
		}
		if (!node?.type?.name) {
			console.error("applyLayoutResult: Node missing type.name", {
				node,
				pos,
				depth
			});
			return;
		}
		if (typeof node.nodeSize !== "number" || node.nodeSize < 0 || !Number.isFinite(node.nodeSize)) {
			console.error("applyLayoutResult: Invalid nodeSize", {
				nodeSize: node.nodeSize,
				nodeName: node.type.name,
				pos
			});
			return;
		}
		if (node.type.name === "tab") {
			const tabId = tabIdForIndex(result.paragraphId, tabIndex++);
			const layout = result.tabs[tabId];
			if (layout) {
				let style = `width: ${layout.width}px;`;
				if (layout.height) style += ` height: ${layout.height};`;
				if (layout.leader && leaderStyles[layout.leader]) style += ` ${leaderStyles[layout.leader]}`;
				decorations.push(Decoration.node(pos, pos + node.nodeSize, { style }));
			}
			return;
		}
		try {
			let offset$1 = 0;
			node.forEach((child) => {
				walk(child, pos + 1 + offset$1, depth + 1);
				offset$1 += child.nodeSize;
			});
		} catch (error) {
			console.error("applyLayoutResult: Error during recursion", {
				error,
				nodeName: node.type.name,
				pos,
				depth
			});
		}
	};
	walk(paragraph, paragraphPos);
	return decorations;
}
function collectFollowingText(spans, startIndex) {
	let text = "";
	for (let i = startIndex; i < spans.length; i++) {
		const span = spans[i];
		if (span.type === "tab" || span.type === "lineBreak" || span.type === "hardBreak") break;
		if (span.type === "text") text += span.text || "";
	}
	return text;
}
function getFollowingTextRange(spans, startIndex) {
	let from$1 = null;
	let to = null;
	for (let i = startIndex; i < spans.length; i++) {
		const span = spans[i];
		if (span.type === "tab" || span.type === "lineBreak" || span.type === "hardBreak") break;
		if (span.type === "text" && typeof span.from === "number" && typeof span.to === "number") {
			if (from$1 === null) from$1 = span.from;
			to = span.to;
		}
	}
	if (from$1 !== null && to !== null) return {
		from: from$1,
		to
	};
	return null;
}
const TabNode = Node$1.create({
	name: "tab",
	group: "inline",
	inline: true,
	content: "inline*",
	selectable: false,
	atom: true,
	addOptions() {
		return { htmlAttributes: {
			class: "sd-editor-tab",
			contentEditable: false
		} };
	},
	parseDOM() {
		return [{ tag: "span.sd-editor-tab" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	},
	addAttributes() {
		return { tabSize: { renderDOM: ({ tabSize }) => {
			if (!tabSize) return {};
			return { style: `width: ${tabSize}px; min-width: ${tabSize}px;` };
		} } };
	},
	addPmPlugins() {
		if (isHeadless(this.editor)) return [];
		const editor = this.editor;
		const { view, helpers } = editor;
		return [new Plugin({
			name: "tabPlugin",
			key: new PluginKey("tabPlugin"),
			state: {
				init() {
					if (editor.presentationEditor) return {
						decorations: DecorationSet.empty,
						revision: 0
					};
					return {
						decorations: buildInitialDecorations(view.state.doc, view, helpers, 0),
						revision: 0
					};
				},
				apply(tr, { decorations, revision }, _oldState, newState) {
					const currentDecorations = decorations && decorations.map ? decorations.map(tr.mapping, tr.doc) : DecorationSet.empty;
					if (editor.presentationEditor) return {
						decorations: DecorationSet.empty,
						revision
					};
					if (!tr.docChanged || tr.getMeta("blockNodeInitialUpdate")) return {
						decorations: currentDecorations,
						revision
					};
					const affectedParagraphs = getAffectedParagraphStarts(tr, newState);
					if (affectedParagraphs.size === 0) return {
						decorations: currentDecorations,
						revision
					};
					let nextDecorations = currentDecorations;
					affectedParagraphs.forEach((pos) => {
						const paragraph = newState.doc.nodeAt(pos);
						if (!paragraph || paragraph.type.name !== "paragraph") return;
						const from$1 = pos;
						const to = pos + paragraph.nodeSize;
						const existing = nextDecorations.find(from$1, to);
						if (existing?.length) nextDecorations = nextDecorations.remove(existing);
						const paragraphDecorations = buildParagraphDecorations(newState.doc, pos + 1, paragraph, view, helpers, revision + 1);
						nextDecorations = nextDecorations.add(newState.doc, paragraphDecorations);
					});
					return {
						decorations: nextDecorations,
						revision: revision + 1
					};
				}
			},
			props: { decorations(state) {
				return this.getState(state).decorations;
			} },
			view() {
				return { destroy() {
					clearAllParagraphContexts();
				} };
			}
		})];
	}
});
function buildInitialDecorations(doc$1, view, helpers, revision) {
	const decorations = [];
	doc$1.descendants((node, pos) => {
		if (node.type.name !== "paragraph") return;
		let hasTab = false;
		node.descendants((child) => {
			if (child.type.name === "tab") {
				hasTab = true;
				return false;
			}
			return true;
		});
		if (!hasTab) return;
		const request = createLayoutRequest(doc$1, pos + 1, view, helpers, revision);
		if (!request) return;
		const paragraphDecorations = applyLayoutResult(calculateTabLayout(request, void 0, view), node, pos);
		decorations.push(...paragraphDecorations);
	});
	return DecorationSet.create(doc$1, decorations);
}
function buildParagraphDecorations(doc$1, paragraphContentPos, paragraphNode, view, helpers, revision) {
	let hasTab = false;
	paragraphNode.descendants((child) => {
		if (child.type.name === "tab") {
			hasTab = true;
			return false;
		}
		return true;
	});
	if (!hasTab) return [];
	const request = createLayoutRequest(doc$1, paragraphContentPos, view, helpers, revision);
	if (!request) return [];
	return applyLayoutResult(calculateTabLayout(request, void 0, view), paragraphNode, paragraphContentPos - 1);
}
function getAffectedParagraphStarts(tr, newState) {
	const affected = /* @__PURE__ */ new Set();
	tr.steps.forEach((step, index) => {
		if (step.from == null && step.to == null) return;
		let fromPos = step.from;
		let toPos = step.to;
		if (typeof fromPos !== "number" || typeof toPos !== "number") return;
		for (let i = index; i < tr.steps.length; i++) {
			const stepMap = tr.steps[i].getMap();
			fromPos = stepMap.map(fromPos, -1);
			toPos = stepMap.map(toPos, 1);
		}
		if (fromPos < 0 || toPos < 0 || fromPos > newState.doc.content.size || toPos > newState.doc.content.size) return;
		newState.doc.nodesBetween(fromPos, toPos, (node, pos) => {
			if (node.type.name === "paragraph") {
				affected.add(pos);
				return false;
			}
			return true;
		});
	});
	return affected;
}
const LineBreak = Node$1.create({
	name: "lineBreak",
	group: "inline",
	inline: true,
	marks: "",
	defining: true,
	selectable: false,
	content: "",
	atom: true,
	leafText: () => "\n",
	addOptions() {
		return {};
	},
	parseDOM() {
		return [{ tag: "br" }];
	},
	renderDOM() {
		return ["br", {}];
	},
	addAttributes() {
		return {
			lineBreakType: { rendered: false },
			clear: { rendered: false }
		};
	},
	addCommands() {
		return { insertLineBreak: () => ({ commands: commands$1 }) => {
			return commands$1.insertContent({ type: "lineBreak" });
		} };
	}
});
const HardBreak = Node$1.create({
	name: "hardBreak",
	group: "inline",
	inline: true,
	selectable: false,
	atom: true,
	addOptions() {
		return { htmlAttributes: {
			contentEditable: "false",
			lineBreakType: "page",
			"aria-hidden": "true",
			"aria-label": "Hard break node"
		} };
	},
	addAttributes() {
		return {
			pageBreakSource: {
				rendered: false,
				default: null
			},
			pageBreakType: {
				default: null,
				rendered: false
			},
			lineBreakType: { rendered: false },
			clear: { rendered: false }
		};
	},
	parseDOM() {
		return [{
			tag: "span[linebreaktype=\"page\"]",
			getAttrs: (dom) => {
				if (!(dom instanceof HTMLElement)) return false;
				return {
					pageBreakSource: dom.getAttribute("pagebreaksource") || null,
					pageBreakType: dom.getAttribute("linebreaktype") || null
				};
			}
		}];
	},
	renderDOM({ htmlAttributes }) {
		return ["span", Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes)];
	},
	addCommands() {
		return { insertPageBreak: () => ({ commands: commands$1 }) => {
			return commands$1.insertContent({
				type: "hardBreak",
				attrs: { pageBreakType: "page" }
			});
		} };
	}
});
var NON_BREAKING_HYPHEN = "‑";
const NoBreakHyphenNode = Node$1.create({
	name: "noBreakHyphen",
	group: "inline",
	inline: true,
	selectable: false,
	atom: true,
	leafText: () => NON_BREAKING_HYPHEN,
	addOptions() {
		return { htmlAttributes: {
			class: "sd-no-break-hyphen",
			style: "white-space: nowrap;",
			contentEditable: false
		} };
	},
	parseDOM() {
		return [{ tag: "span.sd-no-break-hyphen" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			NON_BREAKING_HYPHEN
		];
	}
});
var DOCX_HEX_ID_LENGTH = 8;
function generateDocxHexId() {
	return Array.from({ length: DOCX_HEX_ID_LENGTH }, () => Math.floor(Math.random() * 16).toString(16)).join("").toUpperCase();
}
const createTableView = ({ editor }) => {
	return class TableView {
		editor;
		node;
		dom;
		table;
		colgroup;
		contentDOM;
		cellMinWidth;
		constructor(node, cellMinWidth) {
			this.editor = editor;
			this.node = node;
			this.cellMinWidth = cellMinWidth;
			this.dom = document.createElement("div");
			this.dom.className = "tableWrapper";
			this.table = this.dom.appendChild(document.createElement("table"));
			this.colgroup = this.table.appendChild(document.createElement("colgroup"));
			updateTable(this.editor, this.node, this.table);
			updateColumns(node, this.colgroup, this.table, cellMinWidth);
			this.contentDOM = this.table.appendChild(document.createElement("tbody"));
			setTimeout(() => {
				updateTableWrapper(this.dom, this.table);
			}, 0);
		}
		update(node) {
			if (node.type !== this.node.type) return false;
			this.node = node;
			updateTable(this.editor, node, this.table);
			updateColumns(node, this.colgroup, this.table, this.cellMinWidth);
			updateTableWrapper(this.dom, this.table);
			return true;
		}
		ignoreMutation(mutation) {
			const tableWrapper = this.dom;
			if (mutation.target === tableWrapper && mutation.type === "attributes" && mutation.attributeName === "style") return true;
			return mutation.type === "attributes" && (mutation.target === this.table || this.colgroup.contains(mutation.target));
		}
	};
};
function updateColumns(node, colgroup, table, _cellMinWidth) {
	const gridColumns = Array.isArray(node.attrs?.grid) && node.attrs.grid.length ? node.attrs.grid.map((col) => twipsToPixels(col.col)) : null;
	const totalColumns = gridColumns?.length ?? null;
	const resolveColumnWidth = (colIndex$1, colwidthValue) => {
		if (colwidthValue != null) return colwidthValue;
		if (gridColumns && gridColumns[colIndex$1] != null) return gridColumns[colIndex$1];
		return null;
	};
	const widths = [];
	const firstRow = node.firstChild;
	let colIndex = 0;
	if (firstRow !== null) for (let i = 0; i < firstRow.childCount; i++) {
		const { colspan, colwidth } = firstRow.child(i).attrs;
		for (let span = 0; span < colspan; span += 1, colIndex += 1) widths.push(resolveColumnWidth(colIndex, colwidth && colwidth[span]));
	}
	if (totalColumns != null && colIndex < totalColumns) for (let col = colIndex; col < totalColumns; col += 1) widths.push(resolveColumnWidth(col));
	const normalizedWidths = widths.map((widthPx) => {
		const numericWidth = Number(widthPx);
		if (!Number.isFinite(numericWidth)) return null;
		if (numericWidth < 0) return null;
		if (numericWidth === 0) return 0;
		if (numericWidth < 1) return 0;
		return numericWidth;
	});
	const tableWidthCSS = convertSizeToCSS(node.attrs.tableProperties.tableWidth?.value ?? null, node.attrs.tableProperties.tableWidth?.type ?? "auto");
	let colElement = colgroup.firstChild;
	normalizedWidths.forEach((width) => {
		if (!colElement) {
			colElement = document.createElement("col");
			colgroup.appendChild(colElement);
		}
		colElement.style.width = width !== null && width !== void 0 ? `${width}px` : null;
		colElement = colElement.nextSibling;
	});
	while (colElement) {
		const next = colElement.nextSibling;
		colElement.parentNode?.removeChild(colElement);
		colElement = next;
	}
	const tableIndent = convertSizeToCSS(node.attrs.tableProperties.tableIndent?.value ?? 0, node.attrs.tableProperties.tableIndent?.type ?? "dxa");
	const firstRowFirstCellPaddingLeftPx = firstRow?.firstChild?.attrs?.cellMargins?.left ?? 0;
	const firstRowLastCellPaddingRightPx = firstRow?.lastChild?.attrs?.cellMargins?.right ?? 0;
	table.style.marginLeft = `${-firstRowFirstCellPaddingLeftPx}px`;
	if (tableIndent !== null) table.style.marginLeft = tableIndent;
	if (node.attrs.tableProperties.tableWidth?.type === "pct") {
		const padding = firstRowFirstCellPaddingLeftPx + firstRowLastCellPaddingRightPx;
		table.style.maxWidth = table.style.width = `calc(${tableWidthCSS} + ${padding}px)`;
	} else table.style.maxWidth = table.style.width = tableWidthCSS;
}
function updateTable(editor, node, table) {
	const tableExtensionAttrs = editor.extensionService.attributes.filter((e) => e.type === "table");
	const htmlAttributes = Attribute.getAttributesToRender(node, tableExtensionAttrs);
	Object.entries(htmlAttributes).forEach(([key, value]) => {
		if (key === "style") table.style.cssText = value;
		else table.setAttribute(key, value);
	});
}
function updateTableWrapper(tableWrapper, table) {
	let defaultBorderWidth = 1;
	let borderWidth;
	if (!table) return;
	let borderLeftMax = parseFloat(table.style.borderLeftWidth || 0);
	let borderRightMax = parseFloat(table.style.borderRightWidth) || 0;
	let firstColumnCells = [...table.querySelectorAll(":scope > tbody > tr > td:first-child")];
	let lastColumnCells = [...table.querySelectorAll(":scope > tbody > tr > td:last-child")];
	for (let cell of firstColumnCells) {
		let borderLeft = parseFloat(cell.style.borderLeftWidth) || 0;
		borderLeftMax = Math.max(borderLeftMax, borderLeft);
	}
	for (let cell of lastColumnCells) {
		let borderRight = parseFloat(cell.style.borderRightWidth) || 0;
		borderRightMax = Math.max(borderRightMax, borderRight);
	}
	borderWidth = Math.ceil(Math.max(borderLeftMax, borderRightMax));
	tableWrapper.style.setProperty("--table-border-width", `${borderWidth || defaultBorderWidth}px`);
}
const createCell = (cellType, cellContent = null, attrs = null) => {
	if (cellContent) return cellType.createChecked(attrs, cellContent);
	if (attrs) return cellType.createAndFill(attrs);
	return cellType.createAndFill();
};
const createTable = (schema, rowsCount, colsCount, withHeaderRow, cellContent = null, columnWidths = null, tableAttrsOverride = null) => {
	const types = {
		table: getNodeType("table", schema),
		tableRow: getNodeType("tableRow", schema),
		tableCell: getNodeType("tableCell", schema),
		tableHeader: getNodeType("tableHeader", schema)
	};
	const headerCells = [];
	const cells = [];
	for (let index = 0; index < colsCount; index++) {
		const cellAttrs = columnWidths ? { colwidth: [columnWidths[index]] } : null;
		const cell = createCell(types.tableCell, cellContent, cellAttrs);
		if (cell) cells.push(cell);
		if (withHeaderRow) {
			const headerCell = createCell(types.tableHeader, cellContent, cellAttrs);
			if (headerCell) headerCells.push(headerCell);
		}
	}
	const rows = [];
	for (let index = 0; index < rowsCount; index++) {
		const isHeader = withHeaderRow && index === 0;
		const cellsToInsert = isHeader ? headerCells : cells;
		const rowAttrs = {
			...isHeader ? { tableRowProperties: { repeatHeader: true } } : {},
			paraId: generateDocxHexId()
		};
		rows.push(types.tableRow.createChecked(rowAttrs, cellsToInsert));
	}
	return types.table.createChecked(tableAttrsOverride, rows);
};
const getColStyleDeclaration = (minWidth, width) => {
	if (width != null) {
		const numericWidth = Number(width);
		if (Number.isFinite(numericWidth) && numericWidth >= 0) return ["width", `${numericWidth}px`];
	}
	return ["min-width", `${minWidth}px`];
};
var MIN_MEANINGFUL_WIDTH_PX = 1;
const createColGroup = (node, cellMinWidth, overrideCol, overrideValue) => {
	let totalWidth = 0;
	let fixedWidth = true;
	const cols = [];
	const colsValues = [];
	const row = node.firstChild;
	const gridColumns = Array.isArray(node.attrs?.grid) && node.attrs.grid.length ? node.attrs.grid.map((col) => twipsToPixels(col.col)) : null;
	if (!row) return {};
	const totalColumns = gridColumns?.length;
	const resolveColumnWidth = (colIndex$1, colwidthValue) => {
		if (overrideCol === colIndex$1) return overrideValue;
		if (colwidthValue != null) return colwidthValue;
		if (gridColumns && gridColumns[colIndex$1] != null) return gridColumns[colIndex$1];
		return null;
	};
	let colIndex = 0;
	for (let i = 0; i < row.childCount; i++) {
		const { colspan, colwidth } = row.child(i).attrs;
		for (let j = 0; j < colspan; j++, colIndex++) {
			const candidateWidth = resolveColumnWidth(colIndex, colwidth && colwidth[j]);
			const numericWidth = Number(candidateWidth);
			let effectiveWidth = Number.isFinite(numericWidth) && numericWidth > 0 ? numericWidth : null;
			if (effectiveWidth != null && effectiveWidth < MIN_MEANINGFUL_WIDTH_PX) effectiveWidth = 0;
			if (effectiveWidth == null) {
				totalWidth += cellMinWidth;
				fixedWidth = false;
			} else totalWidth += effectiveWidth;
			const [prop, value] = getColStyleDeclaration(cellMinWidth, effectiveWidth);
			cols.push(["col", { style: `${prop}: ${value}` }]);
			colsValues.push(parseFloat(value));
		}
	}
	if (totalColumns != null) for (let col = colIndex; col < totalColumns; col++) {
		const candidateWidth = resolveColumnWidth(col);
		const numericWidth = Number(candidateWidth);
		let effectiveWidth = Number.isFinite(numericWidth) && numericWidth > 0 ? numericWidth : null;
		if (effectiveWidth != null && effectiveWidth < MIN_MEANINGFUL_WIDTH_PX) effectiveWidth = 0;
		if (effectiveWidth == null) {
			totalWidth += cellMinWidth;
			fixedWidth = false;
		} else totalWidth += effectiveWidth;
		const [prop, value] = getColStyleDeclaration(cellMinWidth, effectiveWidth);
		cols.push(["col", { style: `${prop}: ${value}` }]);
		colsValues.push(parseFloat(value));
	}
	const tableWidth = fixedWidth ? `${totalWidth}px` : "";
	const tableMinWidth = fixedWidth ? "" : `${totalWidth}px`;
	return {
		colgroup: [
			"colgroup",
			{},
			...cols
		],
		tableWidth,
		tableMinWidth,
		colgroupValues: [...colsValues]
	};
};
const isCellSelection = (value) => value instanceof CellSelection;
const deleteTableWhenSelected = ({ editor }) => {
	const { selection } = editor.state;
	if (!isCellSelection(selection)) return false;
	let cellCount = 0;
	findParentNodeClosestToPos(selection.ranges[0].$from, (node) => {
		return node.type.name === "table";
	})?.node.descendants((node) => {
		if (node.type.name === "table") return false;
		if (["tableCell", "tableHeader"].includes(node.type.name)) cellCount += 1;
	});
	if (!(cellCount === selection.ranges.length)) return false;
	editor.commands.deleteTable();
	return true;
};
function cloneBorders(borders, sides) {
	if (!borders || typeof borders !== "object") return {};
	const source = borders;
	const keys$1 = Array.isArray(sides) ? sides : Object.keys(source);
	const clone$1 = {};
	for (const side of keys$1) {
		const borderValue = source[side];
		if (!borderValue || typeof borderValue !== "object") continue;
		clone$1[side] = { ...borderValue };
	}
	return clone$1;
}
function mapBorderSizes(borders, sizeMapper) {
	if (!borders || typeof borders !== "object") return;
	if (typeof sizeMapper !== "function") return;
	for (const border of Object.values(borders)) {
		if (!border || typeof border !== "object") continue;
		const mapped = sizeMapper(border.size);
		if (typeof mapped === "number" && Number.isFinite(mapped)) border.size = mapped;
	}
}
function resolvePreferredNewTableStyleIdFromEditor(editor) {
	const translatedLinkedStyles = readTranslatedLinkedStyles(editor);
	let settingsDefaultStyleId = null;
	const converter = editor?.converter;
	if (converter) {
		const settingsRoot = readSettingsRoot(converter);
		if (settingsRoot) settingsDefaultStyleId = readDefaultTableStyle(settingsRoot);
	}
	return resolvePreferredNewTableStyleId(settingsDefaultStyleId, translatedLinkedStyles);
}
function normalizeNewTableAttrs(editor) {
	const resolved = resolvePreferredNewTableStyleIdFromEditor(editor);
	if (resolved.source === "none") {
		const fallbackPixelBorders = cloneBorders(TABLE_FALLBACK_BORDERS, TABLE_BORDER_SIDES);
		mapBorderSizes(fallbackPixelBorders, eighthPointsToPixels);
		return {
			tableStyleId: null,
			borders: fallbackPixelBorders,
			tableProperties: {
				borders: { ...TABLE_FALLBACK_BORDERS },
				cellMargins: {
					marginTop: {
						value: TABLE_FALLBACK_CELL_PADDING.top,
						type: "dxa"
					},
					marginBottom: {
						value: TABLE_FALLBACK_CELL_PADDING.bottom,
						type: "dxa"
					},
					marginLeft: {
						value: TABLE_FALLBACK_CELL_PADDING.left,
						type: "dxa"
					},
					marginRight: {
						value: TABLE_FALLBACK_CELL_PADDING.right,
						type: "dxa"
					}
				}
			}
		};
	}
	return {
		tableStyleId: resolved.styleId,
		tableProperties: {
			tableStyleId: resolved.styleId,
			tblLook: { ...DEFAULT_TBL_LOOK }
		}
	};
}
var TABLE_BORDER_SIDES = [
	"top",
	"bottom",
	"left",
	"right",
	"insideH",
	"insideV"
];
function computeColumnWidths(editor, columnCount) {
	const { pageSize = {}, pageMargins = {} } = editor?.converter?.pageStyles ?? {};
	const { width: pageWidth } = pageSize;
	const { left: left$1 = 0, right: right$1 = 0 } = pageMargins;
	if (!pageWidth) return null;
	const availableWidth = (pageWidth - left$1 - right$1) * 96;
	const columnWidth = Math.floor(availableWidth / columnCount);
	return Array(columnCount).fill(columnWidth);
}
const createTableBorders = (borderSpec = {}) => {
	borderSpec = {
		size: .66665,
		color: "#000000",
		...borderSpec
	};
	return {
		top: borderSpec,
		left: borderSpec,
		bottom: borderSpec,
		right: borderSpec,
		insideH: borderSpec,
		insideV: borderSpec
	};
};
function cellAround($pos) {
	for (let d = $pos.depth - 1; d > 0; d--) if ($pos.node(d).type.spec.tableRole == "row") return $pos.node(0).resolve($pos.before(d + 1));
	return null;
}
function cellWrapping($pos) {
	for (let d = $pos.depth; d > 0; d--) {
		const role = $pos.node(d).type.spec.tableRole;
		if (role === "cell" || role === "header_cell") return $pos.node(d);
	}
	return null;
}
var TABLE_CELL_ROLES = new Set(["cell", "header_cell"]);
function findAncestorDepth($pos, predicate) {
	for (let depth = $pos.depth; depth > 0; depth -= 1) if (predicate($pos.node(depth))) return depth;
	return -1;
}
function findRunDepthWithinParagraph($pos, paragraphDepth) {
	for (let depth = $pos.depth; depth > paragraphDepth; depth -= 1) if ($pos.node(depth).type.name === "run") return depth;
	return -1;
}
function findParagraphDepth($pos) {
	return findAncestorDepth($pos, (node) => node.type.name === "paragraph");
}
function allInlineMarkersBetween(paragraph, fromIndex, toIndex) {
	for (let i = fromIndex; i < toIndex; i += 1) {
		const child = paragraph.child(i);
		if (child.type.name === "run") return false;
		if (!child.isInline) return false;
		if (child.textContent !== "") return false;
	}
	return true;
}
function isAtEffectiveParagraphEnd($head) {
	const paragraphDepth = findParagraphDepth($head);
	if (paragraphDepth < 0) return false;
	const paragraph = $head.node(paragraphDepth);
	if (paragraph.content.size === 0) return true;
	if ($head.pos === $head.end(paragraphDepth)) return true;
	const runDepth = findRunDepthWithinParagraph($head, paragraphDepth);
	if (runDepth < 0) return false;
	if ($head.pos !== $head.end(runDepth)) return false;
	return allInlineMarkersBetween(paragraph, $head.index(paragraphDepth) + 1, paragraph.childCount);
}
function isAtEffectiveParagraphStart($head) {
	const paragraphDepth = findParagraphDepth($head);
	if (paragraphDepth < 0) return false;
	const paragraph = $head.node(paragraphDepth);
	if (paragraph.content.size === 0) return true;
	if ($head.pos === $head.start(paragraphDepth)) return true;
	const runDepth = findRunDepthWithinParagraph($head, paragraphDepth);
	if (runDepth < 0) return false;
	if ($head.pos !== $head.start(runDepth)) return false;
	return allInlineMarkersBetween(paragraph, 0, $head.index(paragraphDepth));
}
function isInLastParagraphOfCell($head, cellDepth) {
	return $head.index(cellDepth) === $head.node(cellDepth).childCount - 1;
}
function isInFirstParagraphOfCell($head, cellDepth) {
	return $head.index(cellDepth) === 0;
}
function getTableContext($head) {
	const cellDepth = findAncestorDepth($head, (node) => TABLE_CELL_ROLES.has(node.type.spec.tableRole));
	if (cellDepth < 0) return null;
	const tableDepth = findAncestorDepth($head, (node) => node.type.spec.tableRole === "table");
	if (tableDepth < 0) return null;
	const table = $head.node(tableDepth);
	return {
		cellDepth,
		cellStart: $head.before(cellDepth),
		tableStart: $head.start(tableDepth),
		tablePos: $head.before(tableDepth),
		table
	};
}
function isRtlTable(table) {
	return getTableVisualDirection(table?.attrs) === "rtl";
}
function getCellRect(context) {
	const map$1 = TableMap.get(context.table);
	return {
		map: map$1,
		rect: map$1.findCell(context.cellStart - context.tableStart)
	};
}
function getEffectiveTableDir(table, dir) {
	return isRtlTable(table) ? -dir : dir;
}
function isLastCellInTable(context) {
	if (!context) return false;
	const { map: map$1, rect } = getCellRect(context);
	return rect.right === map$1.width && rect.bottom === map$1.height;
}
function isFirstCellInTable(context) {
	if (!context) return false;
	const { rect } = getCellRect(context);
	return rect.left === 0 && rect.top === 0;
}
function findFirstTextPosAfterBoundary(state, boundaryPos) {
	const nextNode = state.doc.resolve(boundaryPos).nodeAfter;
	if (!nextNode) return null;
	return findFirstTextPosInNode(nextNode, boundaryPos);
}
function findLastTextPosBeforeBoundary(state, boundaryPos) {
	const prevNode = state.doc.resolve(boundaryPos).nodeBefore;
	if (!prevNode) return null;
	return findLastTextPosInNode(prevNode, boundaryPos - prevNode.nodeSize);
}
function findSelectionNearBoundary(state, boundaryPos, dir) {
	return Selection.findFrom(state.doc.resolve(boundaryPos), dir, true) ?? Selection.near(state.doc.resolve(boundaryPos), dir);
}
function getDirectionHelpers(dir) {
	if (dir > 0) return {
		isAtParagraphBoundary: isAtEffectiveParagraphEnd,
		isEdgeParagraphInCell: isInLastParagraphOfCell,
		isEdgeCellInTable: isLastCellInTable,
		findTextPosAcrossBoundary: findFirstTextPosAfterBoundary,
		getTableBoundaryPos: (context) => context.tablePos + context.table.nodeSize
	};
	return {
		isAtParagraphBoundary: isAtEffectiveParagraphStart,
		isEdgeParagraphInCell: isInFirstParagraphOfCell,
		isEdgeCellInTable: isFirstCellInTable,
		findTextPosAcrossBoundary: findLastTextPosBeforeBoundary,
		getTableBoundaryPos: (context) => context.tablePos
	};
}
function isInProtectedTrailingTableParagraph(state) {
	const selection = state.selection;
	if (!selection.empty) return false;
	const $head = selection.$head;
	const paragraphDepth = findParagraphDepth($head);
	if (paragraphDepth !== 1) return false;
	const paragraph = $head.node(paragraphDepth);
	if (paragraph.type.name !== "paragraph" || paragraph.textContent !== "") return false;
	const paragraphIndex = $head.index(0);
	if (paragraphIndex !== state.doc.childCount - 1 || paragraphIndex === 0) return false;
	return state.doc.child(paragraphIndex - 1)?.type.name === "table";
}
function getTableBoundaryExitSelection(state, dir) {
	const selection = state.selection;
	if (!selection.empty) return null;
	const context = getTableContext(selection.$head);
	if (!context) return null;
	const effectiveDir = getEffectiveTableDir(context.table, dir);
	const helpers = getDirectionHelpers(effectiveDir);
	if (!helpers.isEdgeParagraphInCell(selection.$head, context.cellDepth)) return null;
	if (!helpers.isAtParagraphBoundary(selection.$head)) return null;
	if (!helpers.isEdgeCellInTable(context)) return null;
	const boundaryPos = helpers.getTableBoundaryPos(context);
	const targetPos = helpers.findTextPosAcrossBoundary(state, boundaryPos);
	if (targetPos != null) return TextSelection.create(state.doc, targetPos);
	return findSelectionNearBoundary(state, boundaryPos, effectiveDir);
}
function getIntraTableArrowSelection(state, dir, expandSelection) {
	const selection = state.selection;
	if (!selection.empty) return null;
	const context = getTableContext(selection.$head);
	if (!context) return null;
	if (!isRtlTable(context.table)) return null;
	const effectiveDir = getEffectiveTableDir(context.table, dir);
	const helpers = getDirectionHelpers(effectiveDir);
	if (!helpers.isEdgeParagraphInCell(selection.$head, context.cellDepth)) return null;
	if (!helpers.isAtParagraphBoundary(selection.$head)) return null;
	const { map: map$1 } = getCellRect(context);
	const currentCellRelativePos = context.cellStart - context.tableStart;
	const nextCellRelativePos = map$1.nextCell(currentCellRelativePos, "horiz", effectiveDir);
	if (nextCellRelativePos == null) return null;
	const nextCellAbsolutePos = context.tableStart + nextCellRelativePos;
	if (expandSelection) return CellSelection.create(state.doc, context.cellStart, nextCellAbsolutePos);
	const nextCellNode = state.doc.nodeAt(nextCellAbsolutePos);
	if (!nextCellNode) return null;
	const targetPos = effectiveDir > 0 ? findFirstTextPosInNode(nextCellNode, nextCellAbsolutePos) : findLastTextPosInNode(nextCellNode, nextCellAbsolutePos);
	if (targetPos != null) return TextSelection.create(state.doc, targetPos);
	return findSelectionNearBoundary(state, nextCellAbsolutePos, effectiveDir);
}
function getAdjacentTableEntrySelection(state, dir) {
	const selection = state.selection;
	if (!selection.empty) return null;
	const $head = selection.$head;
	const paragraphDepth = findParagraphDepth($head);
	if (paragraphDepth < 0) return null;
	if (!getDirectionHelpers(dir).isAtParagraphBoundary($head)) return null;
	const boundaryPos = dir > 0 ? $head.end(paragraphDepth) + 1 : $head.start(paragraphDepth) - 1;
	const $boundary = state.doc.resolve(boundaryPos);
	const adjacentNode = dir > 0 ? $boundary.nodeAfter : $boundary.nodeBefore;
	if (!adjacentNode || adjacentNode.type.spec.tableRole !== "table") return null;
	const effectiveDir = isRtlTable(adjacentNode) ? -dir : dir;
	const tablePos = dir > 0 ? boundaryPos : boundaryPos - adjacentNode.nodeSize;
	if (effectiveDir > 0) {
		const targetPos$1 = findFirstTextPosInNode(adjacentNode, tablePos);
		if (targetPos$1 != null) return TextSelection.create(state.doc, targetPos$1);
		return findSelectionNearBoundary(state, tablePos, 1);
	}
	const targetPos = findLastTextPosInNode(adjacentNode, tablePos);
	if (targetPos != null) return TextSelection.create(state.doc, targetPos);
	return findSelectionNearBoundary(state, tablePos + adjacentNode.nodeSize, -1);
}
const TableBoundaryNavigationPluginKey = new PluginKey("tableBoundaryNavigation");
function createTableBoundaryNavigationPlugin() {
	return new Plugin({
		key: TableBoundaryNavigationPluginKey,
		props: { handleKeyDown(view, event) {
			if (event.defaultPrevented) return false;
			if (event.altKey || event.ctrlKey || event.metaKey) return false;
			if ((event.key === "Backspace" || event.key === "Delete") && isInProtectedTrailingTableParagraph(view.state)) {
				event.preventDefault();
				return true;
			}
			const dir = event.key === "ArrowRight" ? 1 : event.key === "ArrowLeft" ? -1 : 0;
			if (!dir) return false;
			const context = getTableContext(view.state.selection.$head);
			const allowShiftInRtlTable = Boolean(event.shiftKey && context && isRtlTable(context.table));
			if (event.shiftKey && !allowShiftInRtlTable) return false;
			let nextSelection = getIntraTableArrowSelection(view.state, dir, event.shiftKey);
			if (!nextSelection && event.shiftKey) return false;
			nextSelection = nextSelection ?? getTableBoundaryExitSelection(view.state, dir) ?? getAdjacentTableEntrySelection(view.state, dir);
			if (!nextSelection) return false;
			view.dispatch(view.state.tr.setSelection(nextSelection).scrollIntoView());
			event.preventDefault();
			return true;
		} }
	});
}
function toggleHeaderRow(state, dispatch) {
	const target = resolveTarget(state);
	if (!target) return false;
	if (dispatch) {
		const { tableStart, tableNode, rowIndices } = target;
		const togglingOn = !tableNode.child(rowIndices[0]).attrs.tableRowProperties?.repeatHeader;
		const tr = state.tr;
		const headerType = state.schema.nodes.tableHeader;
		const cellType = state.schema.nodes.tableCell;
		const headerColumnIndices = togglingOn ? null : getHeaderColumnIndices(tableNode, rowIndices);
		for (const rowIndex of rowIndices) {
			const rowPos = rowPositionByIndex(tableStart, tableNode, rowIndex);
			toggleRowCellTypes(tr, rowPos, togglingOn, headerType, cellType, headerColumnIndices);
			setRepeatHeader(tr, rowPos, togglingOn);
		}
		dispatch(tr);
	}
	return true;
}
function resolveTarget(state) {
	const { selection } = state;
	if (selection instanceof CellSelection) return resolveFromCellSelection(selection);
	const $cell = cellAround(selection.$from);
	if (!$cell) return null;
	const tableNode = findTableAncestor($cell);
	if (!tableNode) return null;
	const tableStart = tableStartFromCell($cell);
	const rowIndex = findRowIndex($cell);
	if (rowIndex == null) return null;
	return {
		tableStart,
		tableNode,
		rowIndices: [rowIndex]
	};
}
function resolveFromCellSelection(cellSelection) {
	const $anchor = cellSelection.$anchorCell;
	const tableStart = $anchor.start(-1);
	const tableNode = $anchor.node(-1);
	const rect = TableMap.get(tableNode).rectBetween($anchor.pos - tableStart, cellSelection.$headCell.pos - tableStart);
	const rowIndices = [];
	for (let row = rect.top; row < rect.bottom; row++) rowIndices.push(row);
	return rowIndices.length ? {
		tableStart,
		tableNode,
		rowIndices
	} : null;
}
function getHeaderColumnIndices(tableNode, toggledRowIndices) {
	const toggledSet = new Set(toggledRowIndices);
	const headerColumns = /* @__PURE__ */ new Set();
	const map$1 = TableMap.get(tableNode);
	for (let col = 0; col < map$1.width; col++) for (let row = 0; row < map$1.height; row++) {
		if (toggledSet.has(row)) continue;
		const cellOffset = map$1.map[row * map$1.width + col];
		const cell = tableNode.nodeAt(cellOffset);
		if (cell && cell.type.spec.tableRole === "header_cell") {
			headerColumns.add(col);
			break;
		}
	}
	return headerColumns;
}
function toggleRowCellTypes(tr, rowPos, togglingOn, headerType, cellType, headerColumnIndices) {
	const mappedRowPos = tr.mapping.map(rowPos);
	const rowNode = tr.doc.nodeAt(mappedRowPos);
	let offset$1 = mappedRowPos + 1;
	let colIndex = 0;
	rowNode.forEach((cell) => {
		const targetType = resolveTargetCellType(colIndex, togglingOn, headerType, cellType, headerColumnIndices);
		if (cell.type !== targetType) tr.setNodeMarkup(offset$1, targetType, cell.attrs, cell.marks);
		colIndex += cell.attrs.colspan || 1;
		offset$1 += cell.nodeSize;
	});
}
function resolveTargetCellType(colIndex, togglingOn, headerType, cellType, headerColumnIndices) {
	if (togglingOn) return headerType;
	if (headerColumnIndices && headerColumnIndices.has(colIndex)) return headerType;
	return cellType;
}
function setRepeatHeader(tr, rowPos, value) {
	const mappedPos = tr.mapping.map(rowPos);
	const rowNode = tr.doc.nodeAt(mappedPos);
	const currentProps = rowNode.attrs.tableRowProperties ?? {};
	tr.setNodeMarkup(mappedPos, null, {
		...rowNode.attrs,
		tableRowProperties: {
			...currentProps,
			repeatHeader: value
		}
	});
}
function rowPositionByIndex(tableStart, tableNode, rowIndex) {
	let pos = tableStart;
	for (let i = 0; i < rowIndex; i++) pos += tableNode.child(i).nodeSize;
	return pos;
}
function findRowIndex($cell) {
	for (let d = $cell.depth; d > 0; d--) if ($cell.node(d).type.spec.tableRole === "row") return $cell.index(d - 1);
	return null;
}
function findTableAncestor($cell) {
	for (let d = $cell.depth; d > 0; d--) if ($cell.node(d).type.spec.tableRole === "table") return $cell.node(d);
	return null;
}
function tableStartFromCell($cell) {
	for (let d = $cell.depth; d > 0; d--) if ($cell.node(d).type.spec.tableRole === "table") return $cell.before(d) + 1;
	return null;
}
var ZERO_WIDTH_SPACE = "​";
var ROW_START_TO_TEXT_OFFSET = 3;
var CELL_TO_TEXT_OFFSET = 2;
var normalizeHeaderAttrsForBodyCell = (attrs) => {
	if (attrs?.borders !== null) return attrs;
	const nextAttrs = { ...attrs };
	delete nextAttrs.borders;
	return nextAttrs;
};
function resolveTable(tr, tablePos, tableNode) {
	if (tableNode && tableNode.type && tableNode.type.name === "table") return tableNode;
	if (typeof tablePos === "number") {
		const current = tr.doc.nodeAt(tablePos);
		if (current && current.type.name === "table") return current;
	}
	return null;
}
function pickTemplateRowForAppend(tableNode, schema) {
	const RowType = schema.nodes.tableRow;
	const rows = [];
	tableNode.descendants((child) => {
		if (child.type === RowType) rows.push(child);
	});
	if (!rows.length) return null;
	for (let i = rows.length - 1; i >= 0; i--) {
		const r$1 = rows[i];
		if (r$1.content?.content?.some((c) => c.type.name === "tableCell")) return r$1;
	}
	return rows[rows.length - 1];
}
function extractRowTemplateFormatting(cellNode, schema) {
	const ParagraphType = schema.nodes.paragraph;
	let blockType = ParagraphType;
	let blockAttrs = null;
	let textMarks = [];
	const blocks = cellNode?.content?.content || [];
	for (const block of blocks) {
		if (block.type === ParagraphType || block.type.name === "heading") {
			blockType = block.type || ParagraphType;
			blockAttrs = block.attrs || null;
		}
		let foundText = null;
		block.descendants?.((n) => {
			if (!foundText && n.isText) foundText = n;
		});
		if (foundText) {
			textMarks = foundText.marks ? Array.from(foundText.marks) : [];
			break;
		}
	}
	if (!blockType || !blockType.validContent) blockType = ParagraphType;
	return {
		blockType,
		blockAttrs,
		textMarks
	};
}
function buildFormattedCellBlock(schema, value, { blockType, blockAttrs, textMarks }, copyRowStyle = false) {
	const text = typeof value === "string" ? value : value == null ? "" : String(value);
	const type = blockType || schema.nodes.paragraph;
	const marks = copyRowStyle ? textMarks || [] : [];
	if (!text) {
		const content = marks.length > 0 ? schema.text(ZERO_WIDTH_SPACE, marks) : null;
		return type.createAndFill(blockAttrs || null, content);
	}
	const lines = text.split(/\r?\n/);
	if (lines.length > 1) {
		const paragraphs = lines.map((line) => {
			const content = line ? schema.text(line, marks) : null;
			return type.createAndFill(blockAttrs || null, content);
		}).filter(Boolean);
		return Fragment$1.from(paragraphs);
	}
	const textNode = schema.text(text, marks);
	return type.createAndFill(blockAttrs || null, textNode);
}
function buildRowFromTemplateRow({ schema, tableNode, templateRow, values, copyRowStyle = false }) {
	const RowType = schema.nodes.tableRow;
	const CellType = schema.nodes.tableCell;
	const HeaderType = schema.nodes.tableHeader;
	const totalColumns = TableMap.get(tableNode).width;
	const byColumns = Array.isArray(values) && values.length === totalColumns;
	const newCells = [];
	let columnCursor = 0;
	templateRow.content.content.forEach((cellNode, cellIndex) => {
		const isHeaderCell = cellNode.type === HeaderType;
		const targetCellType = isHeaderCell ? CellType : cellNode.type;
		const attrs = isHeaderCell ? normalizeHeaderAttrsForBodyCell({ ...cellNode.attrs }) : { ...cellNode.attrs };
		const formatting = extractRowTemplateFormatting(cellNode, schema);
		let cellValue = "";
		if (byColumns) {
			const span = Math.max(1, attrs.colspan || 1);
			cellValue = values[columnCursor] ?? "";
			columnCursor += span;
		} else cellValue = Array.isArray(values) ? values[cellIndex] ?? "" : "";
		const content = buildFormattedCellBlock(schema, cellValue, formatting, copyRowStyle);
		const newCell = targetCellType.createAndFill(attrs, content);
		if (newCell) newCells.push(newCell);
	});
	return RowType.createAndFill(null, newCells);
}
function insertRowsAtTableEnd({ tr, tablePos, tableNode, rows }) {
	if (!rows || !rows.length) return;
	const RowTypeName = "tableRow";
	let lastRowRelPos = 0;
	let lastRowNode = null;
	tableNode.descendants((child, relPos) => {
		if (child.type.name === RowTypeName) {
			lastRowRelPos = relPos;
			lastRowNode = child;
		}
	});
	if (!lastRowNode) return;
	const lastRowAbsEnd = tablePos + 1 + lastRowRelPos + lastRowNode.nodeSize;
	const frag = Fragment$1.fromArray(rows);
	tr.insert(lastRowAbsEnd, frag);
}
function insertRowAtIndex({ tr, tablePos, tableNode, sourceRowIndex, insertIndex, schema }) {
	const sourceRow = tableNode.child(sourceRowIndex);
	if (!sourceRow) return false;
	const map$1 = TableMap.get(tableNode);
	const { width, height } = map$1;
	const newCells = [];
	const cellsToExtend = [];
	const RowType = schema.nodes.tableRow;
	const CellType = schema.nodes.tableCell;
	const sourceFormatting = extractRowTemplateFormatting(sourceRow.firstChild, schema);
	for (let col = 0; col < width;) {
		if (insertIndex > 0 && insertIndex < height) {
			const indexAbove = (insertIndex - 1) * width + col;
			const indexAtInsert = insertIndex * width + col;
			if (map$1.map[indexAbove] === map$1.map[indexAtInsert]) {
				const cellPos = map$1.map[indexAbove];
				const cell = tableNode.nodeAt(cellPos);
				if (cell) {
					const attrs = cell.attrs;
					cellsToExtend.push({
						pos: tablePos + 1 + cellPos,
						attrs: {
							...attrs,
							rowspan: (attrs.rowspan || 1) + 1
						}
					});
					col += attrs.colspan || 1;
					continue;
				}
			}
		}
		const sourceMapIndex = sourceRowIndex * width + col;
		const sourceCellPos = map$1.map[sourceMapIndex];
		const sourceCell = tableNode.nodeAt(sourceCellPos);
		if (!sourceCell) {
			const fallbackCell = sourceRow.firstChild;
			const content$1 = buildFormattedCellBlock(schema, "", extractRowTemplateFormatting(fallbackCell, schema), true);
			const newCell$1 = CellType.createAndFill({
				rowspan: 1,
				colspan: 1
			}, content$1);
			if (newCell$1) newCells.push(newCell$1);
			col += 1;
			continue;
		}
		const colspan = sourceCell.attrs.colspan || 1;
		const formatting = extractRowTemplateFormatting(sourceCell, schema);
		const cellAttrs = {
			...sourceCell.attrs,
			rowspan: 1
		};
		const content = buildFormattedCellBlock(schema, "", formatting, true);
		const targetCellType = sourceCell.type.name === "tableHeader" ? CellType : sourceCell.type;
		const normalizedCellAttrs = sourceCell.type.name === "tableHeader" ? normalizeHeaderAttrsForBodyCell(cellAttrs) : cellAttrs;
		const newCell = targetCellType.createAndFill(normalizedCellAttrs, content);
		if (newCell) newCells.push(newCell);
		col += colspan;
	}
	for (const { pos, attrs } of cellsToExtend) tr.setNodeMarkup(pos, null, attrs);
	let insertPos = tablePos + 1;
	for (let i = 0; i < insertIndex; i++) insertPos += tableNode.child(i).nodeSize;
	if (newCells.length > 0) {
		const newRow = RowType.createAndFill(null, newCells);
		if (newRow) {
			tr.insert(insertPos, newRow);
			const cursorPos = insertPos + ROW_START_TO_TEXT_OFFSET;
			tr.setSelection(TextSelection.create(tr.doc, cursorPos));
			const firstTextNode = newCells[0].firstChild?.firstChild;
			if (firstTextNode?.marks?.length) tr.setStoredMarks(firstTextNode.marks);
			else if (sourceFormatting.textMarks?.length) tr.setStoredMarks(sourceFormatting.textMarks);
		}
	} else if (cellsToExtend.length > 0) {
		const cursorPos = cellsToExtend[0].pos + CELL_TO_TEXT_OFFSET;
		tr.setSelection(TextSelection.create(tr.doc, cursorPos));
	}
	return true;
}
function tableSeparatorNeeds(doc$1, pos, replaceRange = {}) {
	const boundaryBefore = replaceRange.from ?? pos;
	const boundaryAfter = replaceRange.to ?? pos;
	const $before = doc$1.resolve(boundaryBefore);
	const $after = doc$1.resolve(boundaryAfter);
	if ($before.depth !== 0 || $after.depth !== 0) return {
		before: false,
		after: false
	};
	const beforeIndex = $before.index(0);
	const afterIndex = $after.index(0);
	const nodeBefore = beforeIndex > 0 ? doc$1.child(beforeIndex - 1) : null;
	const nodeAfter = afterIndex < doc$1.childCount ? doc$1.child(afterIndex) : null;
	return {
		before: nodeBefore?.type.name === "table",
		after: !nodeAfter || nodeAfter.type.name === "table"
	};
}
function createTableSeparatorParagraph(schema) {
	const attrs = {
		sdBlockId: v4_default(),
		paraId: generateDocxHexId()
	};
	return schema.nodes.paragraph.createAndFill(attrs);
}
function insertTopLevelTableWithSeparators(tr, doc$1, pos, tableNode, replaceRange = {}) {
	const replaceFrom = replaceRange.from ?? pos;
	const replaceTo = replaceRange.to ?? pos;
	const sep = tableSeparatorNeeds(doc$1, pos, replaceRange);
	if (!sep.before && !sep.after) {
		tr.replaceWith(replaceFrom, replaceTo, tableNode);
		return { inserted: true };
	}
	const nodes = [];
	if (sep.before) {
		const before = createTableSeparatorParagraph(doc$1.type.schema);
		if (!before) return { inserted: false };
		nodes.push(before);
	}
	nodes.push(tableNode);
	if (sep.after) {
		const after = createTableSeparatorParagraph(doc$1.type.schema);
		if (!after) return { inserted: false };
		nodes.push(after);
	}
	tr.replaceWith(replaceFrom, replaceTo, Fragment$1.from(nodes));
	return { inserted: true };
}
function getFirstTableCellTextPos(tablePos, tableNode) {
	const map$1 = TableMap.get(tableNode);
	return tablePos + 1 + map$1.map[0] + 2;
}
function resolveCommandTargetTable(selection) {
	if (selection?.node?.type?.name === "structuredContentBlock") {
		let found = null;
		let count = 0;
		selection.node.descendants((node, pos) => {
			if (node.type?.name !== "table") return true;
			count += 1;
			found = {
				node,
				pos: selection.from + 1 + pos
			};
			return false;
		});
		if (count === 1 && found) return found;
	}
	return findParentNode((node) => node.type.name === "table")(selection);
}
function resolveStructuredContentBlockTableInsertion(selection) {
	if (selection instanceof NodeSelection && selection.node?.type?.name === "structuredContentBlock") {
		const contentStart = selection.from + 1;
		const firstChild = selection.node.firstChild;
		if (selection.node.childCount === 1 && firstChild?.type?.name === "paragraph" && firstChild.textContent === "") return {
			from: contentStart,
			to: contentStart + firstChild.nodeSize,
			tablePos: contentStart
		};
		const contentEnd = contentStart + selection.node.content.size;
		return {
			from: contentEnd,
			to: contentEnd,
			tablePos: contentEnd
		};
	}
	const $from = selection.$from;
	let structuredContentDepth = -1;
	for (let depth = $from.depth; depth > 0; depth--) if ($from.node(depth).type?.name === "structuredContentBlock") {
		structuredContentDepth = depth;
		break;
	}
	if (structuredContentDepth === -1) return null;
	const paragraphDepth = $from.parent?.type?.name === "run" ? $from.depth - 1 : $from.depth;
	if (paragraphDepth <= structuredContentDepth) {
		const contentEnd = $from.end(structuredContentDepth);
		return {
			from: contentEnd,
			to: contentEnd,
			tablePos: contentEnd
		};
	}
	const paragraph = $from.node(paragraphDepth);
	if (paragraph.type.name === "paragraph" && paragraph.textContent === "") {
		const from$2 = $from.before(paragraphDepth);
		return {
			from: from$2,
			to: $from.after(paragraphDepth),
			tablePos: from$2
		};
	}
	const from$1 = $from.after(paragraphDepth);
	return {
		from: from$1,
		to: from$1,
		tablePos: from$1
	};
}
var IMPORT_CONTEXT_SELECTOR = "[data-superdoc-import=\"true\"]";
var IMPORT_DEFAULT_TABLE_WIDTH_PCT = 5e3;
var isImportedTableElement = (element) => Boolean(element?.closest?.(IMPORT_CONTEXT_SELECTOR));
const Table = Node$1.create({
	name: "table",
	content: "tableRow+",
	group: "block",
	isolating: true,
	tableRole: "table",
	addOptions() {
		return {
			htmlAttributes: { "aria-label": "Table node" },
			resizable: true,
			handleWidth: 5,
			cellMinWidth: 10,
			lastColumnResizable: true,
			allowTableNodeSelection: false
		};
	},
	addAttributes() {
		return {
			sdBlockId: {
				default: null,
				keepOnSplit: false,
				parseDOM: (elem) => elem.getAttribute("data-sd-block-id"),
				renderDOM: (attrs) => {
					return attrs.sdBlockId ? { "data-sd-block-id": attrs.sdBlockId } : {};
				}
			},
			paraId: {
				default: null,
				keepOnSplit: false,
				parseDOM: () => null,
				renderDOM: () => ({})
			},
			textId: {
				default: null,
				keepOnSplit: false,
				parseDOM: () => null,
				renderDOM: () => ({})
			},
			tableIndent: { renderDOM: ({ tableIndent }) => {
				if (!tableIndent) return {};
				const { width } = tableIndent;
				let style = "";
				if (width) style += `margin-left: ${width}px`;
				return { style };
			} },
			borders: {
				default: {},
				renderDOM({ borders, borderCollapse, tableCellSpacing }) {
					if (!Object.keys(borders).length && borderCollapse !== "separate" && !tableCellSpacing) return {};
					return { style: Object.entries(borders).reduce((acc, [key, { size: size$1, color }]) => {
						return `${acc}border-${key}: ${Math.ceil(size$1)}px solid ${color || "black"};`;
					}, "") };
				}
			},
			borderCollapse: {
				default: null,
				renderDOM({ borderCollapse }) {
					return { style: `border-collapse: ${borderCollapse || "collapse"}` };
				}
			},
			justification: {
				default: null,
				renderDOM: (attrs) => {
					if (!attrs.justification) return {};
					if (attrs.justification === "center") return { style: `margin: 0 auto` };
					if (attrs.justification === "right") return { style: `margin-left: auto` };
					return {};
				}
			},
			tableLayout: { rendered: false },
			tableCellSpacing: {
				default: null,
				renderDOM({ tableCellSpacing }) {
					if (!tableCellSpacing?.value) return {};
					return { style: `border-spacing: ${tableCellSpacing.value}px` };
				}
			},
			tableProperties: {
				default: { tableWidth: {
					value: null,
					type: "auto"
				} },
				rendered: false,
				parseDOM: (element) => {
					if (!isImportedTableElement(element)) return void 0;
					return { tableWidth: {
						value: IMPORT_DEFAULT_TABLE_WIDTH_PCT,
						type: "pct"
					} };
				}
			},
			tableStyleId: {
				parseDOM: (element) => {
					if (!isImportedTableElement(element)) return void 0;
					return null;
				},
				rendered: false
			},
			needsTableStyleNormalization: {
				default: false,
				parseDOM: (element) => {
					if (!isImportedTableElement(element)) return void 0;
					return true;
				},
				rendered: false
			},
			grid: {
				default: null,
				rendered: false
			},
			userEdited: {
				default: false,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: "table" }];
	},
	renderDOM({ node, htmlAttributes }) {
		const { colgroup, tableWidth, tableMinWidth } = createColGroup(node, this.options.cellMinWidth);
		return [
			"table",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes, { style: tableWidth ? `width: ${tableWidth}` : `min-width: ${tableMinWidth}` }),
			colgroup,
			["tbody", 0]
		];
	},
	addCommands() {
		return {
			appendRowsWithContent: ({ tablePos, tableNode, valueRows = [], copyRowStyle = false }) => ({ editor, chain }) => {
				if (typeof tablePos !== "number" && !tableNode || !Array.isArray(valueRows) || !valueRows.length) return false;
				return chain().command(({ tr, dispatch }) => {
					const workingTable = resolveTable(tr, tablePos, tableNode);
					if (!workingTable) return false;
					const templateRow = pickTemplateRowForAppend(workingTable, editor.schema);
					if (!templateRow) return false;
					const newRows = valueRows.map((vals) => buildRowFromTemplateRow({
						schema: editor.schema,
						tableNode: workingTable,
						templateRow,
						values: vals,
						copyRowStyle
					})).filter(Boolean);
					if (!newRows.length) return false;
					let resolvedTablePos = tablePos;
					if (typeof resolvedTablePos !== "number" && workingTable) {
						const tables = editor.getNodesOfType("table");
						resolvedTablePos = (workingTable ? tables.find((t) => t.node.eq(workingTable)) : tables[0])?.pos ?? null;
					}
					if (typeof resolvedTablePos !== "number") return false;
					if (dispatch) insertRowsAtTableEnd({
						tr,
						tablePos,
						tableNode: workingTable,
						rows: newRows
					});
					return true;
				}).run();
			},
			insertTable: ({ rows = 3, cols = 3, withHeaderRow = false, columnWidths = null } = {}) => ({ tr, dispatch, editor, state }) => {
				const widths = columnWidths ?? computeColumnWidths(editor, cols);
				const resolved = normalizeNewTableAttrs(editor);
				const tableAttrs = {
					...resolved.tableStyleId ? { tableStyleId: resolved.tableStyleId } : {},
					...resolved.borders ? { borders: resolved.borders } : {},
					...resolved.tableProperties ? { tableProperties: resolved.tableProperties } : {}
				};
				const node = createTable(editor.schema, rows, cols, withHeaderRow, null, widths, tableAttrs);
				if (dispatch) {
					const structuredContentInsertion = resolveStructuredContentBlockTableInsertion(tr.selection);
					if (structuredContentInsertion) {
						const { from: from$1, to, tablePos } = structuredContentInsertion;
						tr.replaceWith(from$1, to, node);
						const selectionPos$1 = getFirstTableCellTextPos(tablePos, node);
						tr.scrollIntoView().setSelection(TextSelection.near(tr.doc.resolve(selectionPos$1)));
						return true;
					}
					let offset$1;
					let replaceRange = void 0;
					if (tr.selection.$from.depth === 0) {
						offset$1 = tr.selection.from;
						replaceRange = {
							from: tr.selection.from,
							to: tr.selection.to
						};
					} else {
						offset$1 = tr.selection.$from.end() + 1;
						const paragraphDepth = tr.selection.$from.parent?.type?.name === "run" ? tr.selection.$from.depth - 1 : tr.selection.$from.depth;
						const paragraph = tr.selection.$from.node(paragraphDepth);
						const isTopLevelParagraph = paragraphDepth === 1;
						const isEmptyParagraph = paragraph.type.name === "paragraph" && paragraph.textContent === "";
						if (isTopLevelParagraph && isEmptyParagraph) {
							offset$1 = tr.selection.$from.before(paragraphDepth);
							replaceRange = {
								from: tr.selection.$from.before(paragraphDepth),
								to: tr.selection.$from.after(paragraphDepth)
							};
						} else if (tr.selection.$from.parent?.type?.name === "run") offset$1 = tr.selection.$from.after(paragraphDepth);
					}
					const { inserted } = insertTopLevelTableWithSeparators(tr, state.doc, offset$1, node, replaceRange);
					if (!inserted) return false;
					const selectionPos = getFirstTableCellTextPos(offset$1, node);
					tr.scrollIntoView().setSelection(TextSelection.near(tr.doc.resolve(selectionPos)));
				}
				return true;
			},
			insertTableAt: ({ pos, rows, columns, sdBlockId, tracked } = {}) => ({ tr, state, dispatch, editor }) => {
				const tableType = state.schema.nodes.table;
				const tableRowType = state.schema.nodes.tableRow;
				const tableCellType = state.schema.nodes.tableCell;
				if (!tableType || !tableRowType || !tableCellType) return false;
				if (!Number.isInteger(pos) || pos < 0 || pos > state.doc.content.size) return false;
				if (!Number.isInteger(rows) || rows < 1) return false;
				if (!Number.isInteger(columns) || columns < 1) return false;
				try {
					const widths = computeColumnWidths(editor, columns);
					const rowNodes = [];
					for (let r$1 = 0; r$1 < rows; r$1++) {
						const cellNodes = [];
						for (let c = 0; c < columns; c++) {
							const cellAttrs = widths ? { colwidth: [widths[c]] } : {};
							const cell = tableCellType.createAndFill(cellAttrs);
							if (!cell) return false;
							cellNodes.push(cell);
						}
						const row = tableRowType.createChecked({ paraId: generateDocxHexId() }, cellNodes);
						rowNodes.push(row);
					}
					const resolved = normalizeNewTableAttrs(editor);
					const tableAttrs = {
						...resolved.tableStyleId ? { tableStyleId: resolved.tableStyleId } : {},
						...resolved.borders ? { borders: resolved.borders } : {},
						...resolved.tableProperties ? { tableProperties: resolved.tableProperties } : {},
						...sdBlockId ? { sdBlockId } : {}
					};
					const tableNode = tableType.createChecked(tableAttrs, rowNodes);
					if (dispatch) {
						const { inserted } = insertTopLevelTableWithSeparators(tr, state.doc, pos, tableNode);
						if (!inserted) return false;
						tr.setMeta("inputType", "programmatic");
						if (tracked === true) tr.setMeta("forceTrackChanges", true);
						else if (tracked === false) tr.setMeta("skipTrackChanges", true);
					}
					return true;
				} catch {
					return false;
				}
			},
			deleteTable: () => ({ state, dispatch }) => {
				return deleteTable(state, dispatch);
			},
			addColumnBefore: () => ({ state, dispatch, chain }) => {
				if (!addColumnBefore(state)) return false;
				let { rect, attrs: currentCellAttrs } = getCurrentCellAttrs(state);
				return chain().command(() => addColumnBefore(state, dispatch)).command(({ tr }) => {
					let table = tr.doc.nodeAt(rect.tableStart - 1);
					if (!table) return false;
					let updatedMap = TableMap.get(table);
					let newColumnIndex = rect.left;
					if (newColumnIndex < 0 || newColumnIndex >= updatedMap.width) return false;
					for (let row = 0; row < updatedMap.height; row++) {
						let cellIndex = row * updatedMap.width + newColumnIndex;
						let cellPos = updatedMap.map[cellIndex];
						let cellAbsolutePos = rect.tableStart + cellPos;
						let cell = tr.doc.nodeAt(cellAbsolutePos);
						if (cell) {
							let attrs = {
								...currentCellAttrs,
								colspan: cell.attrs.colspan,
								rowspan: cell.attrs.rowspan,
								colwidth: cell.attrs.colwidth
							};
							tr.setNodeMarkup(cellAbsolutePos, null, attrs);
						}
					}
					return true;
				}).run();
			},
			addColumnAfter: () => ({ state, dispatch, chain }) => {
				if (!addColumnAfter(state)) return false;
				let { rect, attrs: currentCellAttrs } = getCurrentCellAttrs(state);
				return chain().command(() => addColumnAfter(state, dispatch)).command(({ tr }) => {
					let table = tr.doc.nodeAt(rect.tableStart - 1);
					if (!table) return false;
					let updatedMap = TableMap.get(table);
					let newColumnIndex = rect.left + 1;
					if (newColumnIndex < 0 || newColumnIndex >= updatedMap.width) return false;
					for (let row = 0; row < updatedMap.height; row++) {
						let cellIndex = row * updatedMap.width + newColumnIndex;
						let cellPos = updatedMap.map[cellIndex];
						let cellAbsolutePos = rect.tableStart + cellPos;
						let cell = tr.doc.nodeAt(cellAbsolutePos);
						if (cell) {
							let attrs = {
								...currentCellAttrs,
								colspan: cell.attrs.colspan,
								rowspan: cell.attrs.rowspan,
								colwidth: cell.attrs.colwidth
							};
							tr.setNodeMarkup(cellAbsolutePos, null, attrs);
						}
					}
					return true;
				}).run();
			},
			deleteColumn: () => ({ state, dispatch }) => {
				return deleteColumn(state, dispatch);
			},
			addRowBefore: () => ({ state, dispatch, editor }) => {
				if (!isInTable(state)) return false;
				const { rect } = getCurrentCellAttrs(state);
				const tablePos = rect.tableStart - 1;
				const tableNode = state.doc.nodeAt(tablePos);
				if (!tableNode) return false;
				const tr = state.tr;
				const result = insertRowAtIndex({
					tr,
					tablePos,
					tableNode,
					sourceRowIndex: rect.top,
					insertIndex: rect.top,
					schema: editor.schema
				});
				if (result && dispatch) dispatch(tr);
				return result;
			},
			addRowAfter: () => ({ state, dispatch, editor }) => {
				if (!isInTable(state)) return false;
				const { rect } = getCurrentCellAttrs(state);
				const tablePos = rect.tableStart - 1;
				const tableNode = state.doc.nodeAt(tablePos);
				if (!tableNode) return false;
				const tr = state.tr;
				const result = insertRowAtIndex({
					tr,
					tablePos,
					tableNode,
					sourceRowIndex: rect.top,
					insertIndex: rect.top + 1,
					schema: editor.schema
				});
				if (result && dispatch) dispatch(tr);
				return result;
			},
			deleteRow: () => ({ state, dispatch }) => {
				return deleteRow(state, dispatch);
			},
			mergeCells: () => ({ state, dispatch }) => {
				return mergeCells(state, dispatch);
			},
			splitCell: () => ({ state, dispatch, commands: commands$1 }) => {
				if (splitCell(state, dispatch)) return true;
				return commands$1.splitSingleCell();
			},
			splitSingleCell: () => ({ state, dispatch, tr }) => {
				const sel = state.selection;
				let cellNode;
				let cellPos;
				if (!(sel instanceof CellSelection)) {
					cellNode = cellWrapping(sel.$from);
					if (!cellNode) return false;
					cellPos = cellAround(sel.$from)?.pos;
				} else {
					if (sel.$anchorCell.pos != sel.$headCell.pos) return false;
					cellNode = sel.$anchorCell.nodeAfter;
					cellPos = sel.$anchorCell.pos;
				}
				if (cellNode == null || cellPos == null) return false;
				if (cellNode.attrs.colspan != 1 || cellNode.attrs.rowspan != 1) return false;
				if (dispatch) {
					let rect = selectedRect(state);
					let currentRow = rect.top;
					let currentCol = rect.left;
					let baseAttrs = { ...cellNode.attrs };
					let currentColWidth = baseAttrs.colwidth;
					let newCellWidth = null;
					if (currentColWidth && currentColWidth[0]) newCellWidth = Math.ceil(currentColWidth[0] / 2);
					if (newCellWidth) tr.setNodeMarkup(tr.mapping.map(cellPos, 1), null, {
						...baseAttrs,
						colwidth: [newCellWidth]
					});
					const newCellAttrs = {
						...baseAttrs,
						colwidth: newCellWidth ? [newCellWidth] : null
					};
					const newCell = getCellType({
						node: cellNode,
						state
					}).createAndFill(newCellAttrs);
					tr.insert(tr.mapping.map(cellPos + cellNode.nodeSize, 1), newCell);
					for (let row = 0; row < rect.map.height; row++) {
						if (row === currentRow) continue;
						let rowCells = /* @__PURE__ */ new Set();
						for (let col = 0; col < rect.map.width; col++) {
							let cellIndex = rect.map.map[row * rect.map.width + col];
							if (cellIndex != null) rowCells.add(cellIndex);
						}
						[...rowCells].forEach((cellIndex) => {
							let cellRect = rect.map.findCell(cellIndex);
							if (cellRect.left <= currentCol && cellRect.right > currentCol) {
								let cellPos$1 = tr.mapping.map(rect.tableStart + cellIndex, 1);
								let cell = tr.doc.nodeAt(cellPos$1);
								if (cell) {
									let newColspan = (cell.attrs.colspan || 1) + 1;
									let updatedColwidth = cell.attrs.colwidth;
									if (updatedColwidth && newCellWidth) {
										let originalColIndex = currentCol - cellRect.left;
										updatedColwidth = [
											...updatedColwidth.slice(0, originalColIndex),
											newCellWidth,
											newCellWidth,
											...updatedColwidth.slice(originalColIndex + 1)
										];
									}
									let cellAttrs = {
										...cell.attrs,
										colspan: newColspan,
										colwidth: updatedColwidth
									};
									tr.setNodeMarkup(cellPos$1, null, cellAttrs);
								}
							}
						});
					}
				}
				return true;
			},
			mergeOrSplit: () => ({ state, dispatch, commands: commands$1 }) => {
				if (mergeCells(state, dispatch)) return true;
				return commands$1.splitCell();
			},
			toggleHeaderColumn: () => ({ state, dispatch }) => {
				return toggleHeader("column")(state, dispatch);
			},
			toggleHeaderRow: () => ({ state, dispatch }) => {
				return toggleHeaderRow(state, dispatch);
			},
			toggleHeaderCell: () => ({ state, dispatch }) => {
				return toggleHeaderCell(state, dispatch);
			},
			setCellAttr: (name, value) => ({ state, dispatch }) => {
				return setCellAttr(name, value)(state, dispatch);
			},
			goToNextCell: () => ({ state, dispatch }) => {
				return goToNextCell(1)(state, dispatch);
			},
			goToPreviousCell: () => ({ state, dispatch }) => {
				return goToNextCell(-1)(state, dispatch);
			},
			fixTables: () => ({ state, dispatch }) => {
				if (dispatch) fixTables(state);
				return true;
			},
			setCellSelection: (pos) => ({ tr, dispatch }) => {
				if (dispatch) tr.setSelection(CellSelection.create(tr.doc, pos.anchorCell, pos.headCell));
				return true;
			},
			setCellBackground: (value) => ({ editor, commands: commands$1, dispatch }) => {
				const { selection } = editor.state;
				if (!isCellSelection(selection)) return false;
				const color = value?.startsWith("#") ? value.slice(1) : value;
				if (dispatch) return commands$1.setCellAttr("background", { color });
				return true;
			},
			deleteCellAndTableBorders: () => ({ state, tr }) => {
				if (!isInTable(state)) return false;
				const table = resolveCommandTargetTable(state.selection);
				if (!table) return false;
				const nilBorder = {
					val: "nil",
					size: 0,
					space: 0,
					color: "auto"
				};
				table.node.descendants((node, pos) => {
					if (["tableCell", "tableHeader"].includes(node.type.name)) {
						const nextTableCellProperties = {
							...node.attrs.tableCellProperties ?? {},
							borders: {
								top: { ...nilBorder },
								bottom: { ...nilBorder },
								left: { ...nilBorder },
								right: { ...nilBorder }
							}
						};
						const nextInlineKeys = [...new Set([...node.attrs.tableCellPropertiesInlineKeys || [], "borders"])];
						tr.setNodeMarkup(table.pos + 1 + pos, void 0, {
							...node.attrs,
							borders: null,
							tableCellProperties: nextTableCellProperties,
							tableCellPropertiesInlineKeys: nextInlineKeys
						});
					}
					return true;
				});
				tr.setNodeMarkup(table.pos, void 0, {
					...table.node.attrs,
					borders: createTableBorders({ size: 0 }),
					tableProperties: {
						...table.node.attrs.tableProperties,
						borders: createTableBorders({
							size: 0,
							space: 0,
							val: "none",
							color: "auto"
						})
					}
				});
				return true;
			}
		};
	},
	addShortcuts() {
		return {
			Tab: () => {
				if (this.editor.commands.goToNextCell()) return true;
				if (!this.editor.can().addRowAfter()) return false;
				return this.editor.chain().addRowAfter().goToNextCell().run();
			},
			"Shift-Tab": () => this.editor.commands.goToPreviousCell(),
			Backspace: deleteTableWhenSelected,
			"Mod-Backspace": deleteTableWhenSelected,
			Delete: deleteTableWhenSelected,
			"Mod-Delete": deleteTableWhenSelected
		};
	},
	addPmPlugins() {
		const resizable = this.options.resizable && this.editor.isEditable;
		const editor = this.editor;
		return [
			...resizable ? [columnResizing({
				handleWidth: 0,
				cellMinWidth: this.options.cellMinWidth,
				defaultCellMinWidth: this.options.cellMinWidth,
				lastColumnResizable: this.options.lastColumnResizable,
				View: createTableView({ editor: this.editor })
			})] : [],
			tableEditing({ allowTableNodeSelection: this.options.allowTableNodeSelection }),
			createTableBoundaryNavigationPlugin(),
			(() => {
				let initialScanDone = false;
				return new Plugin({
					key: new PluginKey("tableStyleNormalization"),
					appendTransaction(transactions, _oldState, newState) {
						const needsInitialScan = !initialScanDone;
						initialScanDone = true;
						if (!transactions.some((t) => t.docChanged) && !needsInitialScan) return null;
						const ranges = [];
						if (needsInitialScan) ranges.push(0, newState.doc.content.size);
						else {
							const allMaps = [];
							for (const t of transactions) for (let i = 0; i < t.mapping.maps.length; i++) allMaps.push(t.mapping.maps[i]);
							for (let i = 0; i < allMaps.length; i++) allMaps[i].forEach((_oldFrom, _oldTo, newFrom, newTo) => {
								for (let j = i + 1; j < allMaps.length; j++) {
									newFrom = allMaps[j].map(newFrom, 1);
									newTo = allMaps[j].map(newTo, -1);
								}
								ranges.push(newFrom, Math.max(newFrom, newTo));
							});
						}
						if (ranges.length === 0) return null;
						let tr = null;
						for (let r$1 = 0; r$1 < ranges.length; r$1 += 2) {
							const from$1 = ranges[r$1];
							const to = Math.min(ranges[r$1 + 1], newState.doc.content.size);
							if (from$1 >= to) continue;
							newState.doc.nodesBetween(from$1, to, (node, pos) => {
								if (node.type.name === "table" && node.attrs.needsTableStyleNormalization === true) {
									const attrs = {
										...node.attrs,
										needsTableStyleNormalization: false
									};
									if (!Object.keys(node.attrs.borders ?? {}).length) {
										const resolved = normalizeNewTableAttrs(editor);
										attrs.tableStyleId = resolved.tableStyleId ?? void 0;
										if (resolved.borders) attrs.borders = resolved.borders;
										if (resolved.tableProperties) attrs.tableProperties = {
											...node.attrs.tableProperties ?? {},
											...resolved.tableProperties
										};
									}
									if (!tr) tr = newState.tr;
									tr.setNodeMarkup(pos, void 0, attrs);
								}
								if ((node.type.name === "tableCell" || node.type.name === "tableHeader") && node.attrs.borders != null) {
									const tcpBorders = node.attrs.tableCellProperties?.borders;
									const cellAttrs = { ...node.attrs };
									if (tcpBorders && typeof tcpBorders === "object" && Object.keys(tcpBorders).length > 0) cellAttrs.borders = null;
									else if (isLegacySchemaDefaultBorders(node.attrs.borders)) cellAttrs.borders = null;
									else {
										cellAttrs.tableCellProperties = {
											...node.attrs.tableCellProperties ?? {},
											borders: convertBordersToOoxmlFormat(node.attrs.borders)
										};
										cellAttrs.borders = null;
									}
									if (cellAttrs.borders !== node.attrs.borders) {
										if (!tr) tr = newState.tr;
										tr.setNodeMarkup(pos, void 0, cellAttrs);
									}
								}
							});
						}
						return tr;
					}
				});
			})()
		];
	},
	extendNodeSchema(extension) {
		return { tableRole: callOrGet(getExtensionConfigField(extension, "tableRole", {
			name: extension.name,
			options: extension.options,
			storage: extension.storage
		})) };
	}
});
function getCellType({ node, state }) {
	return tableNodeTypes(state.schema)[node.type.spec.tableRole];
}
function copyCellAttrs(node) {
	const { colspan: _colspan, rowspan: _rowspan, colwidth: _colwidth, ...attrs } = node.attrs;
	return attrs;
}
function getCurrentCellAttrs(state) {
	let rect = selectedRect(state);
	let index = rect.top * rect.map.width + rect.left;
	let pos = rect.map.map[index];
	let cell = rect.table.nodeAt(pos);
	return {
		rect,
		cell,
		attrs: copyCellAttrs(cell)
	};
}
var STYLE_TOKEN_SET = new Set([
	"none",
	"hidden",
	"dotted",
	"dashed",
	"solid",
	"double",
	"groove",
	"ridge",
	"inset",
	"outset"
]);
var STYLE_TOKEN_PATTERN = Array.from(STYLE_TOKEN_SET).join("|");
var parseBorderWidth = (value) => {
	const widthMatch = value.match(/(?:^|\s)(-?\d*\.?\d+(?:px|pt))(?=\s|$)/i);
	if (!widthMatch?.[1]) return null;
	const [widthValue, widthUnit] = parseSizeUnit(widthMatch[1]);
	const numericWidth = Number(widthValue);
	return widthUnit === "pt" ? halfPointToPixels(numericWidth) : numericWidth;
};
var parseBorderStyle = (value) => {
	const styleMatch = value.match(new RegExp(`(?:^|\\s)(${STYLE_TOKEN_PATTERN})(?=\\s|$)`, "i"));
	return styleMatch?.[1] ? styleMatch[1].toLowerCase() : null;
};
var parseBorderColor = (value) => {
	const directColorMatch = value.match(/(rgba?\([^)]+\)|hsla?\([^)]+\)|#[0-9a-fA-F]{3,8}|var\([^)]+\))/i);
	if (directColorMatch?.[1]) return directColorMatch[1];
	return value.split(/\s+/).find((part) => /^[a-z]+$/i.test(part) && !STYLE_TOKEN_SET.has(part.toLowerCase())) || null;
};
var parseBorderValue = (rawValue) => {
	if (!rawValue || typeof rawValue !== "string") return null;
	const value = rawValue.trim();
	if (!value) return null;
	if (value === "none") return {
		val: "none",
		size: 0,
		color: "auto",
		style: "none"
	};
	const size$1 = parseBorderWidth(value);
	const style = parseBorderStyle(value);
	const hexColor = cssColorToHex(parseBorderColor(value));
	if (style === "none") return {
		val: "none",
		size: 0,
		color: "auto",
		style: "none"
	};
	if (size$1 == null && !hexColor && !style) return null;
	return {
		val: style === "dashed" || style === "dotted" ? style : "single",
		size: size$1 ?? 1,
		color: hexColor || "auto",
		style: style || "solid"
	};
};
const parseCellBorders = (element) => {
	const { style } = element;
	const top$1 = parseBorderValue(style?.borderTop || style?.border);
	const right$1 = parseBorderValue(style?.borderRight || style?.border);
	const bottom$1 = parseBorderValue(style?.borderBottom || style?.border);
	const left$1 = parseBorderValue(style?.borderLeft || style?.border);
	if (!top$1 && !right$1 && !bottom$1 && !left$1) return null;
	return {
		...top$1 ? { top: top$1 } : {},
		...right$1 ? { right: right$1 } : {},
		...bottom$1 ? { bottom: bottom$1 } : {},
		...left$1 ? { left: left$1 } : {}
	};
};
var parseSide = (sideValue) => {
	if (!sideValue) return void 0;
	const [rawValue, unit] = parseSizeUnit(sideValue);
	const numericValue = Number(rawValue);
	return unit === "pt" ? halfPointToPixels(numericValue) : numericValue;
};
const parseCellMargins = (element) => {
	const { style } = element;
	const top$1 = parseSide(style?.paddingTop);
	const right$1 = parseSide(style?.paddingRight);
	const bottom$1 = parseSide(style?.paddingBottom);
	const left$1 = parseSide(style?.paddingLeft);
	if (top$1 == null && right$1 == null && bottom$1 == null && left$1 == null) return null;
	return {
		...top$1 != null ? { top: top$1 } : {},
		...right$1 != null ? { right: right$1 } : {},
		...bottom$1 != null ? { bottom: bottom$1 } : {},
		...left$1 != null ? { left: left$1 } : {}
	};
};
function parseCellVerticalAlignFromStyle(element) {
	const value = element.style?.verticalAlign;
	if (!value || typeof value !== "string") return null;
	const normalized = value.trim().toLowerCase();
	if (normalized === "middle") return "center";
	return normalized;
}
const renderCellBorderStyle = (borders) => {
	if (!borders) return {};
	return { style: [
		"top",
		"right",
		"bottom",
		"left"
	].map((side) => {
		const border = borders?.[side];
		if (border && border.val === "none") return `border-${side}: ${border.val};`;
		let color = border?.color || "black";
		if (color === "auto") color = "black";
		if (border) return `border-${side}: ${Math.ceil(border.size)}px solid ${color};`;
		return "";
	}).join(" ") };
};
const TableHeader = Node$1.create({
	name: "tableHeader",
	content: "block+",
	tableRole: "header_cell",
	isolating: true,
	addOptions() {
		return { htmlAttributes: { "aria-label": "Table head node" } };
	},
	addAttributes() {
		return {
			sdBlockId: {
				default: null,
				keepOnSplit: false,
				parseDOM: (elem) => elem.getAttribute("data-sd-block-id"),
				renderDOM: (attrs) => {
					return attrs.sdBlockId ? { "data-sd-block-id": attrs.sdBlockId } : {};
				}
			},
			colspan: { default: 1 },
			rowspan: { default: 1 },
			colwidth: {
				default: [100],
				parseDOM: (element) => {
					const colwidth = element.getAttribute("data-colwidth");
					return colwidth ? colwidth.split(",").map((width) => parseInt(width, 10)) : null;
				},
				renderDOM: (attrs) => {
					if (!attrs.colwidth) return {};
					return { "data-colwidth": attrs.colwidth.join(",") };
				}
			},
			background: {
				parseDOM: (element) => {
					const color = cssColorToHex(element.style?.backgroundColor);
					if (!color) return null;
					return { color: color.replace(/^#/, "") };
				},
				renderDOM({ background }) {
					if (!background) return {};
					const { color } = background || {};
					return { style: `background-color: ${color ? `#${color}` : "transparent"}` };
				}
			},
			verticalAlign: {
				parseDOM: parseCellVerticalAlignFromStyle,
				renderDOM({ verticalAlign }) {
					if (!verticalAlign) return {};
					return { style: `vertical-align: ${verticalAlign}` };
				}
			},
			cellMargins: {
				parseDOM: (element) => parseCellMargins(element),
				renderDOM({ cellMargins, borders }) {
					if (!cellMargins) return {};
					return { style: [
						"top",
						"right",
						"bottom",
						"left"
					].map((side) => {
						const margin = cellMargins?.[side] ?? 0;
						const border = borders?.[side];
						const borderSize = border && border.val !== "none" ? Math.ceil(border.size) : 0;
						if (margin) return `padding-${side}: ${Math.max(0, margin - borderSize)}px;`;
						return "";
					}).join(" ") };
				}
			},
			borders: {
				default: null,
				parseDOM: (element) => parseCellBorders(element),
				renderDOM: ({ borders }) => {
					if (!borders) return {};
					return renderCellBorderStyle(borders);
				}
			},
			widthType: {
				default: "auto",
				rendered: false
			},
			widthUnit: {
				default: "px",
				rendered: false
			},
			tableCellProperties: {
				default: null,
				rendered: false
			},
			tableCellPropertiesInlineKeys: {
				default: null,
				rendered: false
			},
			cellSdt: {
				default: null,
				rendered: false
			},
			__placeholder: {
				default: null,
				parseDOM: (element) => {
					return element.getAttribute("data-placeholder") || null;
				},
				renderDOM({ __placeholder }) {
					if (!__placeholder) return {};
					return { "data-placeholder": __placeholder };
				}
			}
		};
	},
	parseDOM() {
		return [{ tag: "th" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"th",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	}
});
var parseLengthPx = (length$1) => {
	if (length$1 == null) return void 0;
	if (typeof length$1 === "string") {
		const trimmed = length$1.trim().toLowerCase();
		if (!trimmed || trimmed === "auto") return void 0;
	}
	const [value, unit] = parseSizeUnit(String(length$1));
	const numericValue = Number(value);
	return unit === "pt" ? halfPointToPixels(numericValue) : numericValue;
};
var parseExplicitRowHeight = (element) => {
	const fromHeightStyle = parseLengthPx(element?.style?.height);
	if (fromHeightStyle != null) return fromHeightStyle;
	const fromMinHeightStyle = parseLengthPx(element?.style?.minHeight);
	if (fromMinHeightStyle != null) return fromMinHeightStyle;
	if (element?.hasAttribute?.("height")) {
		const fromHeightAttr = parseLengthPx(element.getAttribute("height"));
		if (fromHeightAttr != null) return fromHeightAttr;
	}
};
var parseTallestCellHeight = (element) => {
	const cells = element?.querySelectorAll?.("td,th");
	if (!cells?.length) return void 0;
	let maxCellHeight;
	for (const cellNode of Array.from(cells)) {
		const cell = cellNode;
		const fromCellHeight = parseLengthPx(cell?.style?.height);
		const fromCellMinHeight = parseLengthPx(cell?.style?.minHeight);
		const fromCellHeightAttr = cell?.hasAttribute?.("height") ? parseLengthPx(cell.getAttribute("height")) : void 0;
		const candidate = fromCellHeight ?? fromCellMinHeight ?? fromCellHeightAttr;
		if (candidate == null) continue;
		if (maxCellHeight == null || candidate > maxCellHeight) maxCellHeight = candidate;
	}
	return maxCellHeight;
};
const parseRowHeight = (element) => {
	return parseExplicitRowHeight(element) ?? parseTallestCellHeight(element);
};
const TableRow = Node$1.create({
	name: "tableRow",
	content: "(tableCell | tableHeader)*",
	tableRole: "row",
	addOptions() {
		return { htmlAttributes: { "aria-label": "Table row node" } };
	},
	addAttributes() {
		return {
			sdBlockId: {
				default: null,
				keepOnSplit: false,
				parseDOM: (elem) => elem.getAttribute("data-sd-block-id"),
				renderDOM: (attrs) => {
					return attrs.sdBlockId ? { "data-sd-block-id": attrs.sdBlockId } : {};
				}
			},
			rowHeight: { renderDOM({ rowHeight }) {
				if (!rowHeight) return {};
				return { style: `height: ${rowHeight}px` };
			} },
			cantSplit: {
				default: false,
				parseDOM() {
					return {};
				},
				renderDOM({ cantSplit }) {
					if (!cantSplit) return {};
					return { "data-cant-split": "true" };
				}
			},
			tableRowProperties: {
				rendered: false,
				parseDOM: (element) => {
					const parsedHeightPx = parseRowHeight(element);
					if (parsedHeightPx == null) return void 0;
					return { rowHeight: {
						value: pixelsToTwips(parsedHeightPx),
						rule: "atLeast"
					} };
				}
			},
			rsidDel: { rendered: false },
			rsidR: { rendered: false },
			rsidRPr: { rendered: false },
			rsidTr: { rendered: false },
			paraId: { rendered: false },
			textId: { rendered: false },
			trackChange: {
				default: null,
				keepOnSplit: true,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: "tr" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"tr",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	}
});
const TableCell = Node$1.create({
	name: "tableCell",
	content: "block+",
	tableRole: "cell",
	isolating: true,
	addOptions() {
		return { htmlAttributes: { "aria-label": "Table cell node" } };
	},
	addAttributes() {
		return {
			sdBlockId: {
				default: null,
				keepOnSplit: false,
				parseDOM: (elem) => elem.getAttribute("data-sd-block-id"),
				renderDOM: (attrs) => {
					return attrs.sdBlockId ? { "data-sd-block-id": attrs.sdBlockId } : {};
				}
			},
			paraId: {
				default: null,
				keepOnSplit: false,
				parseDOM: () => null,
				renderDOM: () => ({})
			},
			textId: {
				default: null,
				keepOnSplit: false,
				parseDOM: () => null,
				renderDOM: () => ({})
			},
			colspan: { default: 1 },
			rowspan: { default: 1 },
			colwidth: {
				default: [100],
				parseDOM: (elem) => {
					const colwidth = elem.getAttribute("data-colwidth");
					return colwidth ? colwidth.split(",").map((width) => parseInt(width, 10)) : null;
				},
				renderDOM: (attrs) => {
					if (!attrs.colwidth) return {};
					return { "data-colwidth": attrs.colwidth.join(",") };
				}
			},
			background: {
				parseDOM: (element) => {
					const color = cssColorToHex(element.style?.backgroundColor);
					if (!color) return null;
					return { color: color.replace(/^#/, "") };
				},
				renderDOM({ background }) {
					if (!background) return {};
					const { color } = background || {};
					return { style: `background-color: ${color ? `#${color}` : "transparent"}` };
				}
			},
			verticalAlign: {
				parseDOM: parseCellVerticalAlignFromStyle,
				renderDOM({ verticalAlign }) {
					if (!verticalAlign) return {};
					return { style: `vertical-align: ${verticalAlign}` };
				}
			},
			cellMargins: {
				parseDOM: (element) => parseCellMargins(element),
				renderDOM({ cellMargins, borders }) {
					if (!cellMargins) return {};
					return { style: [
						"top",
						"right",
						"bottom",
						"left"
					].map((side) => {
						const margin = cellMargins?.[side] ?? 0;
						const border = borders?.[side];
						const borderSize = border && border.val !== "none" ? Math.ceil(border.size) : 0;
						if (margin) return `padding-${side}: ${Math.max(0, margin - borderSize)}px;`;
						return "";
					}).join(" ") };
				}
			},
			borders: {
				default: null,
				parseDOM: (element) => parseCellBorders(element),
				renderDOM: ({ borders }) => {
					if (!borders) return {};
					return renderCellBorderStyle(borders);
				}
			},
			widthType: {
				default: "auto",
				rendered: false
			},
			widthUnit: {
				default: "px",
				rendered: false
			},
			__placeholder: {
				default: null,
				parseDOM: (element) => {
					return element.getAttribute("data-placeholder") || null;
				},
				renderDOM({ __placeholder }) {
					if (!__placeholder) return {};
					return { "data-placeholder": __placeholder };
				}
			},
			tableCellProperties: {
				default: null,
				rendered: false
			},
			tableCellPropertiesInlineKeys: {
				default: null,
				rendered: false
			},
			cellSdt: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: "td" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"td",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	}
});
var FieldAnnotationView = class {
	editor;
	node;
	decorations;
	getPos;
	htmlAttributes;
	dom;
	annotationClass;
	annotationContentClass;
	borderColor;
	constructor(options) {
		this.editor = options.editor;
		this.node = options.node;
		this.decorations = options.decorations;
		this.getPos = options.getPos;
		this.htmlAttributes = options.htmlAttributes;
		this.annotationClass = options.annotationClass;
		this.annotationContentClass = options.annotationContentClass;
		this.borderColor = options.borderColor;
		this.handleAnnotationClick = this.handleAnnotationClick.bind(this);
		this.handleAnnotationDoubleClick = this.handleAnnotationDoubleClick.bind(this);
		this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this);
		this.buildView();
		this.attachEventListeners();
	}
	buildView() {
		let { type } = this.node.attrs;
		let handlers = {
			text: (...args$1) => this.buildTextView(...args$1),
			image: (...args$1) => this.buildImageView(...args$1),
			signature: (...args$1) => this.buildSignatureView(...args$1),
			checkbox: (...args$1) => this.buildCheckboxView(...args$1),
			html: (...args$1) => this.buildHTMLView(...args$1),
			link: (...args$1) => this.buildLinkView(...args$1),
			default: (...args$1) => this.buildTextView(...args$1)
		};
		(handlers[type] ?? handlers.default)();
	}
	buildTextView() {
		let { displayLabel } = this.node.attrs;
		let { annotation } = this.#createAnnotation({ displayLabel });
		this.dom = annotation;
	}
	buildImageView() {
		let { displayLabel, imageSrc } = this.node.attrs;
		let { annotation, content } = this.#createAnnotation();
		if (imageSrc) {
			let img = document.createElement("img");
			img.src = imageSrc;
			img.alt = displayLabel;
			img.style.height = "auto";
			img.style.maxWidth = "100%";
			img.style.pointerEvents = "none";
			img.style.verticalAlign = "middle";
			content.append(img);
			annotation.style.display = "inline-block";
			content.style.display = "inline-block";
		} else content.textContent = displayLabel;
		this.dom = annotation;
	}
	buildSignatureView() {
		let { displayLabel, imageSrc } = this.node.attrs;
		displayLabel = displayLabel || "Signature";
		let { annotation, content } = this.#createAnnotation();
		if (imageSrc) {
			let img = document.createElement("img");
			img.src = imageSrc;
			img.alt = displayLabel;
			img.style.height = "auto";
			img.style.maxWidth = "100%";
			img.style.maxHeight = "28px";
			img.style.pointerEvents = "none";
			img.style.verticalAlign = "middle";
			content.append(img);
			annotation.style.display = "inline-block";
			content.style.display = "inline-block";
		} else content.textContent = displayLabel;
		this.dom = annotation;
	}
	buildCheckboxView() {
		let { displayLabel } = this.node.attrs;
		let { annotation } = this.#createAnnotation({ displayLabel });
		this.dom = annotation;
	}
	buildHTMLView() {
		let { displayLabel, rawHtml } = this.node.attrs;
		if (!this.editor.options.isHeadless && !!rawHtml) try {
			const tempDiv = document.createElement("div");
			rawHtml = this.editor.createChildEditor({
				element: tempDiv,
				html: rawHtml
			}).view.dom.innerHTML;
		} catch (error) {
			console.warn("Error parsing HTML in FieldAnnotationView:", error);
		}
		let { annotation, content } = this.#createAnnotation();
		if (rawHtml) {
			content.innerHTML = rawHtml.trim();
			annotation.style.display = "inline-block";
			content.style.display = "inline-block";
		} else content.textContent = displayLabel;
		this.dom = annotation;
	}
	buildLinkView() {
		let { displayLabel, linkUrl } = this.node.attrs;
		let { annotation, content } = this.#createAnnotation();
		if (linkUrl) {
			let link = document.createElement("a");
			link.href = linkUrl;
			link.target = "_blank";
			link.textContent = linkUrl;
			link.style.textDecoration = "none";
			content.append(link);
			content.style.pointerEvents = "all";
		} else content.textContent = displayLabel;
		this.dom = annotation;
	}
	#createAnnotation({ displayLabel } = {}) {
		let { highlighted } = this.node.attrs;
		let annotation = document.createElement("span");
		annotation.classList.add(this.annotationClass);
		let content = document.createElement("span");
		content.classList.add(this.annotationContentClass);
		content.style.pointerEvents = "none";
		content.contentEditable = "false";
		if (displayLabel) content.textContent = displayLabel;
		annotation.append(content);
		let omitHighlight = highlighted === false;
		let annotationStyle = [
			`border: 2px solid ${this.borderColor}`,
			`border-radius: 2px`,
			`padding: 1px 2px`,
			`box-sizing: border-box`
		].join("; ");
		let mergedAttrs = Attribute.mergeAttributes(this.htmlAttributes, { style: omitHighlight ? "" : annotationStyle });
		for (let [key, value] of Object.entries(mergedAttrs)) if (key === "style") annotation.style.cssText = value;
		else annotation.setAttribute(key, value);
		return {
			annotation,
			content
		};
	}
	attachEventListeners() {
		this.dom.addEventListener("click", this.handleAnnotationClick);
		this.dom.addEventListener("dblclick", this.handleAnnotationDoubleClick);
		this.editor.on("selectionUpdate", this.handleSelectionUpdate);
	}
	removeEventListeners() {
		this.dom.removeEventListener("click", this.handleAnnotationClick);
		this.dom.removeEventListener("dblclick", this.handleAnnotationDoubleClick);
		this.editor.off("selectionUpdate", this.handleSelectionUpdate);
	}
	handleSelectionUpdate({ editor }) {
		if (!this.editor.isEditable) return;
		let { selection } = editor.state;
		if (selection instanceof NodeSelection) {
			let currentNode = selection.node;
			if (this.node.eq(currentNode)) this.editor.emit("fieldAnnotationSelected", {
				editor: this.editor,
				node: this.node,
				nodePos: this.getPos(),
				target: this.dom
			});
		}
	}
	handleAnnotationClick(event) {
		if (!this.editor.isEditable) return;
		this.editor.emit("fieldAnnotationClicked", {
			editor: this.editor,
			node: this.node,
			nodePos: this.getPos(),
			event,
			currentTarget: event.currentTarget
		});
	}
	handleAnnotationDoubleClick(event) {
		if (!this.editor.isEditable) return;
		this.editor.emit("fieldAnnotationDoubleClicked", {
			editor: this.editor,
			node: this.node,
			nodePos: this.getPos(),
			event,
			currentTarget: event.currentTarget
		});
	}
	stopEvent(event) {
		if (!this.editor.isEditable) {
			event.preventDefault();
			return true;
		}
		return false;
	}
	update() {
		return false;
	}
	ignoreMutation() {
		return true;
	}
	destroy() {
		this.removeEventListeners();
	}
	updateAttributes(attributes) {
		this.editor.commands.command(({ tr }) => {
			tr.setNodeMarkup(this.getPos(), void 0, {
				...this.node.attrs,
				...attributes
			});
			return true;
		});
	}
};
var ALLOWED_META_KEYS$1 = [
	"inputType",
	"uiEvent",
	"paste",
	CustomSelectionPluginKey.key
];
function findRemovedFieldAnnotations(tr) {
	let removedNodes = [];
	if (!tr.steps.length || tr.meta && !Object.keys(tr.meta).every((meta) => ALLOWED_META_KEYS$1.includes(meta)) || ["historyUndo", "historyRedo"].includes(tr.getMeta("inputType")) || ["drop"].includes(tr.getMeta("uiEvent")) || tr.getMeta("fieldAnnotationUpdate") === true || tr.getMeta("tableGeneration") === true) return removedNodes;
	if (!transactionDeletedAnything(tr)) return removedNodes;
	tr.steps.forEach((step, stepIndex) => {
		if (step instanceof ReplaceStep && step.from !== step.to) {
			let mapping = tr.mapping.maps[stepIndex];
			tr.before.nodesBetween(step.from, step.to, (node, pos) => {
				if (node.type.name === "fieldAnnotation") {
					if (mapping.mapResult(pos).deleted) removedNodes.push({
						node,
						pos
					});
				}
			});
		}
	});
	if (removedNodes.length) {
		const removedNodesIds = removedNodes.map((item) => item.node.attrs.fieldId);
		const found = findChildren(tr.doc, (node) => node.type.name === "fieldAnnotation" && removedNodesIds.includes(node.attrs.fieldId));
		const foundSet = new Set(found.map((item) => item.node.attrs.fieldId));
		removedNodes = removedNodes.filter((item) => !foundSet.has(item.node.attrs.fieldId));
	}
	return removedNodes;
}
function transactionDeletedAnything(tr) {
	return tr.steps.some((step) => {
		if (step instanceof ReplaceStep || step instanceof ReplaceAroundStep) return step.from !== step.to;
		return false;
	});
}
function trackFieldAnnotationsDeletion(editor, tr) {
	let removedAnnotations = [];
	try {
		removedAnnotations = findRemovedFieldAnnotations(tr);
	} catch {}
	if (removedAnnotations.length > 0) setTimeout(() => {
		editor.emit("fieldAnnotationDeleted", {
			editor,
			removedNodes: removedAnnotations
		});
	}, 0);
}
function getAllFieldAnnotations(state) {
	return findChildren(state.doc, (node) => node.type.name === "fieldAnnotation");
}
const FieldAnnotationPlugin = (options = {}) => {
	let { editor, annotationClass: annotationClass$1 } = options;
	return new Plugin({
		key: new PluginKey("fieldAnnotation"),
		state: {
			init() {
				return null;
			},
			apply(tr, prevState) {
				trackFieldAnnotationsDeletion(editor, tr);
				return prevState;
			}
		},
		props: {
			handleDrop(view, event, slice, moved) {
				if (moved) return false;
				let fieldAnnotation = event?.dataTransfer.getData("fieldAnnotation");
				if (fieldAnnotation) {
					if (options.handleDropOutside) handleDropOutside({
						fieldAnnotation,
						editor,
						view,
						event
					});
					else {
						let annotationAttrs;
						try {
							annotationAttrs = JSON.parse(fieldAnnotation).attributes;
						} catch {
							return false;
						}
						const coordinates = view.posAtCoords({
							left: event.clientX,
							top: event.clientY
						});
						if (coordinates) editor.commands.addFieldAnnotation(coordinates.pos, { ...annotationAttrs });
					}
					return true;
				}
				return false;
			},
			handlePaste(view, event, slice) {
				const content = slice.content.content.filter((item) => item.type.name === "fieldAnnotation");
				if (content.length) editor.emit("fieldAnnotationPaste", {
					content,
					editor
				});
				return false;
			},
			handleDOMEvents: { dragstart: (view, event) => {
				if (!event.target) return false;
				let { target } = event;
				if (target.classList?.contains(annotationClass$1)) event.dataTransfer?.setDragImage(target, 0, 0);
				return false;
			} }
		},
		appendTransaction: (transactions, oldState, newState) => {
			if (!(transactions.some((tr$1) => tr$1.docChanged) && !oldState.doc.eq(newState.doc))) return;
			const affectedRanges = [];
			let hasFieldAnnotationsInSlice = false;
			let hasSteps = false;
			transactions.forEach((transaction) => {
				if (!transaction.steps) return;
				hasSteps = true;
				transaction.steps.forEach((step) => {
					if (step.slice?.content) step.slice.content.descendants((node) => {
						if (node.type.name === "fieldAnnotation") {
							hasFieldAnnotationsInSlice = true;
							return false;
						}
					});
					if (typeof step.from === "number" && typeof step.to === "number") {
						const from$1 = step.from;
						const to = step.from === step.to && step.slice?.size ? step.from + step.slice.size : step.to;
						affectedRanges.push({
							from: from$1,
							to
						});
					}
				});
			});
			if (hasSteps && !hasFieldAnnotationsInSlice && affectedRanges.length > 0) {
				const mergedRanges = mergeRanges$1(affectedRanges, newState.doc.content.size);
				let hasExistingAnnotations = false;
				for (const { from: from$1, to } of mergedRanges) {
					const clampedRange = clampRange(from$1, to, newState.doc.content.size);
					if (!clampedRange) continue;
					const { start: validStart, end: validEnd } = clampedRange;
					try {
						newState.doc.nodesBetween(validStart, validEnd, (node) => {
							if (node.type.name === "fieldAnnotation") {
								hasExistingAnnotations = true;
								return false;
							}
						});
					} catch (error) {
						console.warn("FieldAnnotationPlugin: range check failed, assuming annotations exist", error);
						hasExistingAnnotations = true;
						break;
					}
					if (hasExistingAnnotations) break;
				}
				if (!hasExistingAnnotations) return;
			}
			const { tr } = newState;
			let changed = false;
			const removeMarksFromAnnotation = (node, pos) => {
				const { marks } = node;
				const currentNode = tr.doc.nodeAt(pos);
				if (marks.length > 0 && node.eq(currentNode)) {
					tr.removeMark(pos, pos + node.nodeSize, null);
					changed = true;
				}
			};
			if (affectedRanges.length > 0) {
				const mergedRanges = mergeRanges$1(affectedRanges, newState.doc.content.size);
				let shouldFallbackToFullScan = false;
				for (const { from: from$1, to } of mergedRanges) {
					const clampedRange = clampRange(from$1, to, newState.doc.content.size);
					if (!clampedRange) continue;
					const { start: validStart, end: validEnd } = clampedRange;
					try {
						newState.doc.nodesBetween(validStart, validEnd, (node, pos) => {
							if (node.type.name === "fieldAnnotation") removeMarksFromAnnotation(node, pos);
						});
					} catch (error) {
						console.warn("FieldAnnotationPlugin: nodesBetween failed, falling back to full scan", error);
						shouldFallbackToFullScan = true;
						break;
					}
				}
				if (shouldFallbackToFullScan) {
					const annotations = getAllFieldAnnotations(newState);
					if (!annotations.length) return changed ? tr : null;
					annotations.forEach(({ node, pos }) => {
						removeMarksFromAnnotation(node, pos);
					});
				}
			} else {
				const annotations = getAllFieldAnnotations(newState);
				if (!annotations.length) return;
				annotations.forEach(({ node, pos }) => {
					removeMarksFromAnnotation(node, pos);
				});
			}
			return changed ? tr : null;
		}
	});
};
function handleDropOutside({ fieldAnnotation, editor, view, event }) {
	let sourceField;
	try {
		sourceField = JSON.parse(fieldAnnotation).sourceField;
	} catch {
		return;
	}
	let coordinates = view.posAtCoords({
		left: event.clientX,
		top: event.clientY
	});
	if (coordinates) editor.emit("fieldAnnotationDropped", {
		sourceField,
		editor,
		coordinates,
		pos: coordinates.pos
	});
}
function getAllFieldAnnotationsWithRect(view, state) {
	return getAllFieldAnnotations(state).map(({ node, pos }) => {
		return {
			node,
			pos,
			rect: posToDOMRect(view, pos, pos + node.nodeSize)
		};
	});
}
function findFieldAnnotations(predicate, state) {
	let allFieldAnnotations = getAllFieldAnnotations(state);
	let fieldAnnotations = [];
	allFieldAnnotations.forEach((annotation) => {
		if (predicate(annotation.node)) fieldAnnotations.push(annotation);
	});
	return fieldAnnotations;
}
function findFieldAnnotationsByFieldId(fieldIdOrArray, state) {
	return findChildren(state.doc, (node) => {
		let isFieldAnnotation = node.type.name === "fieldAnnotation";
		if (Array.isArray(fieldIdOrArray)) return isFieldAnnotation && fieldIdOrArray.includes(node.attrs.fieldId);
		else return isFieldAnnotation && node.attrs.fieldId === fieldIdOrArray;
	});
}
function findFirstFieldAnnotationByFieldId(fieldId, state) {
	return findNode(state.doc, (node) => {
		return node.type.name === "fieldAnnotation" && node.attrs.fieldId === fieldId;
	});
}
function findNode(node, predicate) {
	let found = null;
	node.descendants((node$1, pos) => {
		if (predicate(node$1)) found = {
			node: node$1,
			pos
		};
		if (found) return false;
	});
	return found;
}
function findFieldAnnotationsBetween(from$1, to, doc$1) {
	let fieldAnnotations = [];
	doc$1.nodesBetween(from$1, to, (node, pos) => {
		if (!node || node?.nodeSize === void 0) return;
		if (node.type.name === "fieldAnnotation") fieldAnnotations.push({
			node,
			pos
		});
	});
	return fieldAnnotations;
}
const getFieldAttrs = (field, value, input) => {
	const { type } = field.attrs;
	const handler = {
		html: annotateHtml,
		text: annotateText,
		checkbox: annotateCheckbox,
		image: annotateImage,
		link: annotateLink,
		yesno: annotateYesNo,
		date: annotateDate
	}[type];
	if (!handler) return {};
	return handler(value, input);
};
var annotateHtml = (value) => ({ rawHtml: value });
var annotateText = (value) => ({ displayLabel: value });
var annotateImage = (value) => ({ imageSrc: value });
var annotateCheckbox = (value) => ({ displayLabel: value });
var annotateDate = (value, input) => {
	return { displayLabel: getFormattedDate(value, input.input_format) };
};
var annotateLink = (value) => {
	if (!value.startsWith("http")) value = `http://${value}`;
	return { linkUrl: value };
};
var annotateYesNo = (value) => {
	return { displayLabel: {
		YES: "Yes",
		NO: "No"
	}[value[0].toUpperCase()] };
};
const processTables = ({ state, tr, annotationValues }) => {
	const { doc: doc$1 } = state;
	const tables = [];
	doc$1.descendants((node, pos) => {
		if (node.type.name === "table") tables.push({
			node,
			pos
		});
	});
	tables.reverse().forEach(({ pos }) => {
		const currentTableNode = tr.doc.nodeAt(pos);
		if (!currentTableNode || currentTableNode.type.name !== "table") return;
		try {
			generateTableIfNecessary({
				tableNode: {
					node: currentTableNode,
					pos
				},
				annotationValues,
				tr,
				state
			});
		} catch (error) {
			console.error("Error generating table at pos", pos, ":", error);
		}
	});
	return tr;
};
var generateTableIfNecessary = ({ tableNode, annotationValues, tr, state }) => {
	const { tableRow: RowType, tableCell: CellType, fieldAnnotation: FieldType, paragraph: ParaType } = state.schema.nodes;
	const rows = [];
	tableNode.node.descendants((node, pos) => {
		if (node.type === RowType) rows.push({
			node,
			pos
		});
	});
	let rowNodeToGenerate = null;
	for (const row of rows) {
		let hasArrayAnnotation = false;
		row.node.descendants((node) => {
			if (node.type === FieldType) {
				const annotationValue = getAnnotationValue(node.attrs.fieldId, annotationValues);
				if (Array.isArray(annotationValue) && node.attrs.generatorIndex === null) hasArrayAnnotation = true;
			}
		});
		if (hasArrayAnnotation) {
			rowNodeToGenerate = row;
			break;
		}
	}
	if (!rowNodeToGenerate) return;
	const { node: rowNode, pos: rowStartPos } = rowNodeToGenerate;
	const absoluteRowStart = tableNode.pos + 1 + rowStartPos;
	let rowsToGenerate = 0;
	rowNode.descendants((childNode) => {
		if (childNode.type === FieldType) {
			const annotationValue = getAnnotationValue(childNode.attrs.fieldId, annotationValues);
			if (Array.isArray(annotationValue)) rowsToGenerate = Math.max(rowsToGenerate, annotationValue.length);
		}
	});
	if (rowsToGenerate <= 1) return;
	const validateAttributes = (attrs) => {
		const cleaned = {};
		for (const [key, value] of Object.entries(attrs)) if (value !== void 0 && value !== null) {
			if (key === "displayLabel") cleaned[key] = String(value);
			else if (key === "rawHtml" || key === "linkUrl" || key === "imageSrc") cleaned[key] = String(value);
			else if (typeof value === "string" && value.length > 0) cleaned[key] = value;
			else if (typeof value !== "string") cleaned[key] = value;
		}
		return cleaned;
	};
	const rebuildCell = (cellNode, rowIndex) => {
		try {
			const updatedBlocks = cellNode.content.content.map((blockNode) => {
				if (blockNode.type !== ParaType) return blockNode;
				const updatedInlines = blockNode.content.content.map((inlineNode) => {
					if (inlineNode.type !== FieldType) return inlineNode;
					let matchedAnnotationValues = getAnnotationValue(inlineNode.attrs.fieldId, annotationValues);
					if (!Array.isArray(matchedAnnotationValues)) matchedAnnotationValues = [matchedAnnotationValues];
					const value = matchedAnnotationValues[rowIndex];
					let extraAttrs = {};
					try {
						extraAttrs = validateAttributes(getFieldAttrs(inlineNode, value, null) || {});
					} catch (error) {
						console.error("Error getting field attrs:", error);
						extraAttrs = {};
					}
					const baseAttrs = validateAttributes(inlineNode.attrs || {});
					const newAttrs = {
						...baseAttrs,
						...extraAttrs,
						generatorIndex: rowIndex
					};
					try {
						return FieldType.create(newAttrs, inlineNode.content || Fragment$1.empty, inlineNode.marks || []);
					} catch (error) {
						console.error("Error creating field node:", error);
						try {
							const fallbackAttrs = {
								...baseAttrs,
								generatorIndex: rowIndex,
								displayLabel: String(value || "")
							};
							return FieldType.create(validateAttributes(fallbackAttrs), inlineNode.content || Fragment$1.empty, inlineNode.marks || []);
						} catch (fallbackError) {
							console.error("Fallback also failed:", fallbackError);
							return inlineNode;
						}
					}
				});
				try {
					return ParaType.create(validateAttributes(blockNode.attrs || {}), Fragment$1.from(updatedInlines), blockNode.marks || []);
				} catch (error) {
					console.error("Error creating paragraph node:", error);
					return blockNode;
				}
			});
			return CellType.create(validateAttributes(cellNode.attrs || {}), Fragment$1.from(updatedBlocks), cellNode.marks || []);
		} catch (error) {
			console.error(`Failed to rebuild cell for row ${rowIndex}:`, error);
			throw error;
		}
	};
	try {
		const newRows = [];
		for (let rowIndex = 0; rowIndex < rowsToGenerate; rowIndex++) {
			const newCells = rowNode.content.content.map((cellNode) => rebuildCell(cellNode, rowIndex));
			const newRow = RowType.create(validateAttributes(rowNode.attrs || {}), Fragment$1.from(newCells), rowNode.marks || []);
			newRows.push(newRow);
		}
		const mappedRowStart = tr.mapping.map(absoluteRowStart);
		const rowEnd = mappedRowStart + rowNode.nodeSize;
		tr.replaceWith(mappedRowStart, rowEnd, Fragment$1.from(newRows));
		tr.setMeta("tableGeneration", true);
	} catch (error) {
		console.error("Error during row generation:", error);
		throw error;
	}
};
var getAnnotationValue = (id, annotationValues) => {
	return annotationValues.find((value) => value.input_id === id)?.input_value || null;
};
const getAllHeaderFooterEditors = () => [];
var annotateHeadersAndFooters = () => {};
const annotateDocument = ({ annotationValues = [], hiddenFieldIds = [], removeEmptyFields = false, schema, tr }) => {
	const annotations = [];
	const FieldType = schema.nodes.fieldAnnotation;
	tr.doc.descendants((node, pos) => {
		if (node.type === FieldType) annotations.push({
			node,
			pos,
			size: node.nodeSize
		});
	});
	const toDelete = /* @__PURE__ */ new Set();
	if (hiddenFieldIds.length) {
		for (const { node, pos } of annotations) if (hiddenFieldIds.includes(node.attrs.fieldId)) toDelete.add(pos);
	}
	for (const { node, pos } of annotations) {
		const { type, fieldType, fieldId } = node.attrs;
		if (toDelete.has(pos)) continue;
		let newValue = null;
		const input = annotationValues.find((i) => i.input_id === fieldId);
		if (!input) {
			const checkboxInputs = annotationValues.filter((i) => i.input_field_type === "CHECKBOXINPUT");
			inputsLoop: for (const cb of checkboxInputs) for (const opt of cb.input_options) if (opt.itemid === fieldId) {
				newValue = cb.input_link_value[opt.itemid] || " ";
				break inputsLoop;
			}
		}
		newValue = newValue || input?.input_value || null;
		if (Array.isArray(newValue) && node.attrs.generatorIndex != null) continue;
		if (type === "checkbox" || fieldType === "CHECKBOXINPUT") {
			if (!newValue || typeof newValue === "string" && newValue.codePointAt(0) === 9744) newValue = " ";
		}
		if (!newValue) toDelete.add(pos);
		else {
			const attrs = getFieldAttrs(node, newValue, input);
			tr = tr.setNodeMarkup(pos, void 0, {
				...node.attrs,
				...attrs
			});
		}
	}
	if (removeEmptyFields) Array.from(toDelete).sort((a, b$1) => b$1 - a).forEach((pos) => {
		const ann = annotations.find((a) => a.pos === pos);
		if (!ann) return;
		tr = tr.delete(pos, pos + ann.node.nodeSize);
	});
	return tr;
};
var getFormattedDate = (input = null, format = "") => {
	const date = input ? new Date(input) : /* @__PURE__ */ new Date();
	if (isNaN(date.getTime())) return input;
	if (format) return dateFormat(date, format);
	return date.toLocaleDateString("en-US", {
		month: "short",
		day: "2-digit",
		year: "numeric"
	});
};
const AnnotatorHelpers = {
	getFieldAttrs,
	processTables,
	annotateDocument,
	annotateHeadersAndFooters,
	getAllHeaderFooterEditors
};
const getHeaderFooterAnnotations = (editor) => {
	const editors = getAllHeaderFooterEditors(editor);
	const allAnnotations = [];
	editors.forEach(({ editor: editor$1 }) => {
		const annotations = getAllFieldAnnotations(editor$1.state);
		allAnnotations.push(...annotations);
	});
	return allAnnotations;
};
function findHeaderFooterAnnotationsByFieldId(fieldIdOrArray, editor, activeSectionEditor) {
	const sectionEditors = getAllHeaderFooterEditors(editor);
	const annotations = [];
	sectionEditors.forEach(({ editor: sectionEditor }) => {
		const fieldAnnotations = findChildren((activeSectionEditor.options.documentId === sectionEditor.options.documentId ? activeSectionEditor.state : sectionEditor.state).doc, (node) => {
			let isFieldAnnotation = node.type.name === "fieldAnnotation";
			if (Array.isArray(fieldIdOrArray)) return isFieldAnnotation && fieldIdOrArray.includes(node.attrs.fieldId);
			else return isFieldAnnotation && node.attrs.fieldId === fieldIdOrArray;
		});
		annotations.push(...fieldAnnotations);
	});
	return annotations;
}
var fieldAnnotationHelpers_exports = /* @__PURE__ */ __export({
	findFieldAnnotations: () => findFieldAnnotations,
	findFieldAnnotationsBetween: () => findFieldAnnotationsBetween,
	findFieldAnnotationsByFieldId: () => findFieldAnnotationsByFieldId,
	findFirstFieldAnnotationByFieldId: () => findFirstFieldAnnotationByFieldId,
	findHeaderFooterAnnotationsByFieldId: () => findHeaderFooterAnnotationsByFieldId,
	findRemovedFieldAnnotations: () => findRemovedFieldAnnotations,
	getAllFieldAnnotations: () => getAllFieldAnnotations,
	getAllFieldAnnotationsWithRect: () => getAllFieldAnnotationsWithRect,
	getHeaderFooterAnnotations: () => getHeaderFooterAnnotations,
	trackFieldAnnotationsDeletion: () => trackFieldAnnotationsDeletion
}, 1);
function guard(low, high, value) {
	return Math.min(Math.max(low, value), high);
}
var ColorError = class extends Error {
	constructor(color) {
		super(`Failed to parse color: "${color}"`);
	}
};
var ColorError$1 = ColorError;
function parseToRgba(color) {
	if (typeof color !== "string") throw new ColorError$1(color);
	if (color.trim().toLowerCase() === "transparent") return [
		0,
		0,
		0,
		0
	];
	let normalizedColor = color.trim();
	normalizedColor = namedColorRegex.test(color) ? nameToHex(color) : color;
	const reducedHexMatch = reducedHexRegex.exec(normalizedColor);
	if (reducedHexMatch) {
		const arr = Array.from(reducedHexMatch).slice(1);
		return [...arr.slice(0, 3).map((x) => parseInt(r(x, 2), 16)), parseInt(r(arr[3] || "f", 2), 16) / 255];
	}
	const hexMatch = hexRegex.exec(normalizedColor);
	if (hexMatch) {
		const arr = Array.from(hexMatch).slice(1);
		return [...arr.slice(0, 3).map((x) => parseInt(x, 16)), parseInt(arr[3] || "ff", 16) / 255];
	}
	const rgbaMatch = rgbaRegex.exec(normalizedColor);
	if (rgbaMatch) {
		const arr = Array.from(rgbaMatch).slice(1);
		return [...arr.slice(0, 3).map((x) => parseInt(x, 10)), parseFloat(arr[3] || "1")];
	}
	const hslaMatch = hslaRegex.exec(normalizedColor);
	if (hslaMatch) {
		const [h$2, s, l, a] = Array.from(hslaMatch).slice(1).map(parseFloat);
		if (guard(0, 100, s) !== s) throw new ColorError$1(color);
		if (guard(0, 100, l) !== l) throw new ColorError$1(color);
		return [...hslToRgb(h$2, s, l), Number.isNaN(a) ? 1 : a];
	}
	throw new ColorError$1(color);
}
function hash$2(str) {
	let hash$3 = 5381;
	let i = str.length;
	while (i) hash$3 = hash$3 * 33 ^ str.charCodeAt(--i);
	return (hash$3 >>> 0) % 2341;
}
var colorToInt = (x) => parseInt(x.replace(/_/g, ""), 36);
var compressedColorMap = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((acc, next) => {
	const key = colorToInt(next.substring(0, 3));
	const hex = colorToInt(next.substring(3)).toString(16);
	let prefix = "";
	for (let i = 0; i < 6 - hex.length; i++) prefix += "0";
	acc[key] = `${prefix}${hex}`;
	return acc;
}, {});
function nameToHex(color) {
	const result = compressedColorMap[hash$2(color.toLowerCase().trim())];
	if (!result) throw new ColorError$1(color);
	return `#${result}`;
}
var r = (str, amount) => Array.from(Array(amount)).map(() => str).join("");
var reducedHexRegex = new RegExp(`^#${r("([a-f0-9])", 3)}([a-f0-9])?$`, "i");
var hexRegex = new RegExp(`^#${r("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i");
var rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${r(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i");
var hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i;
var namedColorRegex = /^[a-z]+$/i;
var roundColor = (color) => {
	return Math.round(color * 255);
};
var hslToRgb = (hue, saturation, lightness) => {
	let l = lightness / 100;
	if (saturation === 0) return [
		l,
		l,
		l
	].map(roundColor);
	const huePrime = (hue % 360 + 360) % 360 / 60;
	const chroma = (1 - Math.abs(2 * l - 1)) * (saturation / 100);
	const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
	let red = 0;
	let green = 0;
	let blue = 0;
	if (huePrime >= 0 && huePrime < 1) {
		red = chroma;
		green = secondComponent;
	} else if (huePrime >= 1 && huePrime < 2) {
		red = secondComponent;
		green = chroma;
	} else if (huePrime >= 2 && huePrime < 3) {
		green = chroma;
		blue = secondComponent;
	} else if (huePrime >= 3 && huePrime < 4) {
		green = secondComponent;
		blue = chroma;
	} else if (huePrime >= 4 && huePrime < 5) {
		red = secondComponent;
		blue = chroma;
	} else if (huePrime >= 5 && huePrime < 6) {
		red = chroma;
		blue = secondComponent;
	}
	const lightnessModification = l - chroma / 2;
	return [
		red + lightnessModification,
		green + lightnessModification,
		blue + lightnessModification
	].map(roundColor);
};
function toHex(color) {
	const [r$1, g$1, b$1, a] = parseToRgba(color);
	let hex = (x) => {
		const h$2 = guard(0, 255, x).toString(16);
		return h$2.length === 1 ? `0${h$2}` : h$2;
	};
	return `#${hex(r$1)}${hex(g$1)}${hex(b$1)}${a < 1 ? hex(Math.round(a * 255)) : ""}`;
}
var cleanUpListsWithAnnotations_exports = /* @__PURE__ */ __export({ cleanUpListsWithAnnotations: () => cleanUpListsWithAnnotations }, 1);
var summarizeListContent = (node, fieldsToDeleteSet) => {
	const summary = {
		totalFieldAnnotations: 0,
		deletableFieldAnnotations: 0,
		hasOtherInlineContent: false
	};
	if (typeof node?.descendants !== "function") return summary;
	node.descendants((child) => {
		if (!child) return true;
		if (child.type?.name === "fieldAnnotation") {
			summary.totalFieldAnnotations += 1;
			const fieldId = child.attrs?.fieldId;
			if (fieldId && fieldsToDeleteSet.has(fieldId)) summary.deletableFieldAnnotations += 1;
			else summary.hasOtherInlineContent = true;
			return false;
		}
		if (child.isText) {
			if (child.text?.trim()) summary.hasOtherInlineContent = true;
			return false;
		}
		if (child.isInline || child.isAtom) {
			summary.hasOtherInlineContent = true;
			return false;
		}
		return true;
	});
	return summary;
};
const cleanUpListsWithAnnotations = (fieldsToDelete = []) => ({ dispatch, tr, state }) => {
	if (!dispatch) return true;
	if (!Array.isArray(fieldsToDelete)) fieldsToDelete = [fieldsToDelete];
	const fieldsToDeleteSet = new Set(fieldsToDelete);
	const { doc: doc$1 } = state;
	const docxAnnotations = getAllFieldAnnotations(state) || [];
	const nodesToDelete = [];
	fieldsToDelete.forEach((fieldId) => {
		const matched = docxAnnotations.find((a) => a.node.attrs.fieldId === fieldId);
		if (!matched) return;
		const listItem = findParentNodeClosestToPos(doc$1.resolve(matched.pos), isList);
		if (!listItem) return;
		const { totalFieldAnnotations, deletableFieldAnnotations, hasOtherInlineContent } = summarizeListContent(listItem.node, fieldsToDeleteSet);
		if (!totalFieldAnnotations) return;
		if (hasOtherInlineContent) return;
		if (totalFieldAnnotations !== deletableFieldAnnotations) return;
		let { pos, node, depth } = listItem;
		let $pos = doc$1.resolve(pos);
		while (depth > 0) {
			const parent = $pos.node(depth - 1);
			if (parent.childCount === 1) {
				depth -= 1;
				pos = $pos.before(depth);
				node = parent;
				$pos = doc$1.resolve(pos);
			} else break;
		}
		if (!nodesToDelete.some((n) => n.pos === pos)) nodesToDelete.push({
			pos,
			node
		});
	});
	if (!nodesToDelete.length) return true;
	nodesToDelete.sort((a, b$1) => b$1.pos - a.pos).forEach(({ pos, node }) => {
		tr.delete(pos, pos + node.nodeSize);
	});
	tr.setMeta("updateListSync", true);
	return true;
};
var cleanUpParagraphWithAnnotations_exports = /* @__PURE__ */ __export({ cleanUpParagraphWithAnnotations: () => cleanUpParagraphWithAnnotations }, 1);
const cleanUpParagraphWithAnnotations = (fieldsToDelete = []) => ({ dispatch, tr, state }) => {
	if (!dispatch) return true;
	const annotations = (typeof findFieldAnnotationsByFieldId === "function" ? findFieldAnnotationsByFieldId(fieldsToDelete, state) : []) || [];
	const toDelete = /* @__PURE__ */ new Map();
	const sizeOf = (doc$1) => doc$1.content.size;
	const inRange = (doc$1, pos) => Number.isInteger(pos) && pos >= 0 && pos <= sizeOf(doc$1);
	for (const annotation of annotations) {
		const origPos = annotation && annotation.pos;
		if (!Number.isInteger(origPos)) continue;
		const mappedPos = tr.mapping.map(origPos, 1);
		if (!inRange(tr.doc, mappedPos)) continue;
		let $pos;
		try {
			$pos = tr.doc.resolve(mappedPos);
		} catch {
			continue;
		}
		const parent = $pos.parent;
		if (!parent) continue;
		if (parent.childCount >= 2) continue;
		const currentNode = tr.doc.nodeAt(mappedPos);
		const annotatedNode = annotation && annotation.node;
		if (!currentNode) continue;
		if (annotatedNode && !annotatedNode.sameMarkup?.(currentNode) && annotatedNode.type !== currentNode.type) continue;
		const parentPos = $pos.before();
		if (!inRange(tr.doc, parentPos)) continue;
		toDelete.set(parentPos, true);
	}
	if (toDelete.size === 0) return true;
	const sorted = [...toDelete.keys()].sort((a, b$1) => b$1 - a);
	let changed = false;
	for (const originalParentPos of sorted) {
		const mappedParentPos = tr.mapping.map(originalParentPos, -1);
		if (!inRange(tr.doc, mappedParentPos)) continue;
		const targetNode = tr.doc.nodeAt(mappedParentPos);
		if (!targetNode) continue;
		const from$1 = mappedParentPos;
		const to = mappedParentPos + targetNode.nodeSize;
		if (!inRange(tr.doc, from$1) || !inRange(tr.doc, to) || to <= from$1) continue;
		try {
			tr.delete(from$1, to);
			changed = true;
		} catch {
			continue;
		}
	}
	if (changed) dispatch(tr);
	return true;
};
const commands = {
	...cleanUpListsWithAnnotations_exports,
	...cleanUpParagraphWithAnnotations_exports
};
const annotationClass = "annotation";
const annotationContentClass = "annotation-content";
const FieldAnnotation = Node$1.create({
	name: "fieldAnnotation",
	group: "inline",
	inline: true,
	atom: true,
	draggable: true,
	selectable: true,
	addOptions() {
		return {
			htmlAttributes: {
				class: annotationClass,
				"aria-label": "Field annotation node"
			},
			annotationClass,
			annotationContentClass,
			types: [
				"text",
				"image",
				"signature",
				"checkbox",
				"html",
				"link"
			],
			defaultType: "text",
			borderColor: "#b015b3",
			visibilityOptions: ["visible", "hidden"],
			handleDropOutside: true,
			toggleFormatNames: [
				"bold",
				"italic",
				"underline"
			]
		};
	},
	addAttributes() {
		return {
			type: {
				default: this.options.defaultType,
				parseDOM: (elem) => elem.getAttribute("data-type"),
				renderDOM: (attrs) => {
					if (!attrs.type) return {};
					return { "data-type": attrs.type };
				}
			},
			defaultDisplayLabel: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-default-display-label"),
				renderDOM: (attrs) => {
					if (!attrs.defaultDisplayLabel) return {};
					return { "data-default-display-label": attrs.defaultDisplayLabel };
				}
			},
			displayLabel: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-display-label"),
				renderDOM: (attrs) => {
					if (!attrs.displayLabel) return {};
					return { "data-display-label": attrs.displayLabel };
				}
			},
			imageSrc: {
				default: null,
				rendered: false,
				parseDOM: (elem) => {
					return elem.querySelector("img")?.getAttribute("src") || null;
				}
			},
			rawHtml: {
				default: null,
				parseDOM: (elem) => {
					try {
						if (!(elem.getAttribute("data-type") === "html")) return null;
						return JSON.parse(elem.getAttribute("data-raw-html"));
					} catch (e) {
						console.warn("Paste parse error", e);
					}
					return null;
				},
				renderDOM: (attrs) => {
					if (!attrs.rawHtml) return {};
					return { "data-raw-html": JSON.stringify(attrs.rawHtml) };
				}
			},
			linkUrl: {
				default: null,
				rendered: false,
				parseDOM: (elem) => {
					return elem.querySelector("a")?.getAttribute("href") || null;
				}
			},
			fieldId: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-field-id"),
				renderDOM: (attrs) => {
					if (!attrs.fieldId) return {};
					return { "data-field-id": attrs.fieldId };
				}
			},
			fieldType: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-field-type"),
				renderDOM: (attrs) => {
					if (!attrs.fieldType) return {};
					return { "data-field-type": attrs.fieldType };
				}
			},
			fieldColor: {
				default: "#980043",
				parseDOM: (elem) => elem.getAttribute("data-field-color") || elem.style.backgroundColor || null,
				renderDOM: (attrs) => {
					if (!attrs.fieldColor || attrs.fieldColor == "None") return {};
					let hexColor = toHex(attrs.fieldColor);
					if (hexColor.slice(1).length === 6) hexColor = `${hexColor}33`;
					if (attrs.highlighted === false) return { "data-field-color": hexColor };
					return {
						"data-field-color": hexColor,
						style: `background-color: ${hexColor}`
					};
				}
			},
			hidden: {
				default: false,
				parseDOM: (elem) => {
					let hasHiddenAttr = elem.hasAttribute("hidden");
					let hasDisplayNoneStyle = elem.style.display === "none";
					return hasHiddenAttr || hasDisplayNoneStyle;
				},
				renderDOM: (attrs) => {
					if (!attrs.hidden) return {};
					return { style: "display: none" };
				}
			},
			visibility: {
				default: "visible",
				parseDOM: (el) => {
					let visibility = el.style.visibility || "visible";
					return this.options.visibilityOptions.includes(visibility) ? visibility : "visible";
				},
				renderDOM: (attrs) => {
					if (!attrs.visibility || attrs.visibility === "visible") return {};
					return { style: `visibility: ${attrs.visibility}` };
				}
			},
			highlighted: {
				default: true,
				rendered: false
			},
			multipleImage: {
				default: false,
				parseDOM: (elem) => elem.getAttribute("data-multiple-image"),
				renderDOM: (attrs) => {
					if (!attrs.multipleImage) return {};
					return { "data-multiple-image": attrs.multipleImage };
				}
			},
			size: {
				default: null,
				renderDOM: ({ size: size$1 }) => {
					if (!size$1 || !size$1.width) return {};
					return { style: `width: ${size$1.width}px; height: ${size$1.height}px; overflow: hidden;` };
				}
			},
			extras: {
				default: {},
				rendered: false
			},
			bold: {
				default: false,
				parseDOM: (elem) => elem.getAttribute("data-bold") === "true",
				renderDOM: (attrs) => {
					if (!attrs.bold) return {};
					return {
						"data-bold": "true",
						style: "font-weight: bold"
					};
				}
			},
			italic: {
				default: false,
				parseDOM: (elem) => elem.getAttribute("data-italic") === "true",
				renderDOM: (attrs) => {
					if (!attrs.italic) return {};
					return {
						"data-italic": "true",
						style: "font-style: italic"
					};
				}
			},
			underline: {
				default: false,
				parseDOM: (elem) => elem.getAttribute("data-underline") === "true",
				renderDOM: (attrs) => {
					if (!attrs.underline) return {};
					return {
						"data-underline": "true",
						style: "text-decoration: underline"
					};
				}
			},
			fontFamily: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-font-family") || elem.style.fontFamily || null,
				renderDOM: (attrs) => {
					if (!attrs.fontFamily) return {};
					return {
						"data-font-family": attrs.fontFamily,
						style: `font-family: ${attrs.fontFamily}`
					};
				}
			},
			fontSize: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-font-size") || elem.style.fontSize || null,
				renderDOM: (attrs) => {
					if (!attrs.fontSize) return {};
					let [value, unit] = parseSizeUnit(attrs.fontSize);
					if (Number.isNaN(value)) return {};
					unit = unit ? unit : "pt";
					let fontSize = `${value}${unit}`;
					return {
						"data-font-size": fontSize,
						style: `font-size: ${fontSize}`
					};
				}
			},
			textHighlight: {
				default: null,
				parseDOM: (element) => element.getAttribute("data-text-highlight"),
				renderDOM: (attrs) => {
					if (!attrs.textHighlight) return {};
					return {
						"data-text-highlight": attrs.textHighlight,
						style: `background-color: ${attrs.textHighlight} !important`
					};
				}
			},
			textColor: {
				default: null,
				parseDOM: (element) => element.getAttribute("data-text-color"),
				renderDOM: (attrs) => {
					if (!attrs.textColor) return {};
					return {
						"data-text-color": attrs.textColor,
						style: `color: ${attrs.textColor}`
					};
				}
			},
			generatorIndex: {
				rendered: false,
				default: null
			},
			hash: {
				rendered: false,
				default: null
			},
			sdtId: {
				rendered: false,
				default: null
			}
		};
	},
	parseDOM() {
		return [{
			tag: `span.${this.options.annotationClass}`,
			priority: 60
		}];
	},
	renderDOM({ node, htmlAttributes }) {
		let { type, displayLabel, imageSrc, linkUrl } = node.attrs;
		let textRenderer = () => {
			return [
				"span",
				Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
				[
					"span",
					{ class: `${this.options.annotationContentClass}` },
					displayLabel
				]
			];
		};
		let imageRenderer = () => {
			let contentRenderer = () => {
				if (!imageSrc) return displayLabel;
				return ["img", {
					src: imageSrc,
					alt: displayLabel
				}];
			};
			return [
				"span",
				Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
				[
					"span",
					{ class: `${this.options.annotationContentClass}` },
					contentRenderer()
				]
			];
		};
		let linkRenderer = () => {
			let contentRenderer = () => {
				if (!linkUrl) return displayLabel;
				return [
					"a",
					{
						href: linkUrl,
						target: "_blank"
					},
					linkUrl
				];
			};
			return [
				"span",
				Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
				[
					"span",
					{ class: `${this.options.annotationContentClass}` },
					contentRenderer()
				]
			];
		};
		let renderers = {
			text: () => textRenderer(),
			image: () => imageRenderer(),
			signature: () => imageRenderer(),
			checkbox: () => textRenderer(),
			html: () => textRenderer(),
			link: () => linkRenderer(),
			default: () => textRenderer()
		};
		return (renderers[type] ?? renderers.default)();
	},
	addCommands() {
		const annotationTypes = this.options.types;
		return {
			addFieldAnnotation: (pos, attrs = {}, editorFocus = false) => ({ editor, dispatch, state, tr }) => {
				if (dispatch) {
					let { schema } = editor;
					let newPos = tr.mapping.map(pos);
					let currentMarks = state.doc.resolve(newPos).marks();
					currentMarks = currentMarks.length ? [...currentMarks] : null;
					let formatAttrs = getFormatAttrsFromMarks(currentMarks);
					let defaultDisplayLabel = attrs.defaultDisplayLabel ? attrs.defaultDisplayLabel : attrs.displayLabel || "";
					let node = schema.nodes[this.name].create({
						...attrs,
						...formatAttrs,
						defaultDisplayLabel,
						hash: attrs.hash || generateDocxRandomId(4)
					}, null, null);
					state.tr.insert(newPos, node).setSelection(Selection.near(tr.doc.resolve(newPos + node.nodeSize)));
					if (editorFocus) this.editor.view.focus();
				}
				return true;
			},
			addFieldAnnotationAtSelection: (attrs = {}, editorFocus = false) => ({ state, commands: commands$1 }) => {
				const { from: from$1 } = state.selection;
				return commands$1.addFieldAnnotation(from$1, attrs, editorFocus);
			},
			replaceWithFieldAnnotation: (fieldsArray) => ({ editor, dispatch, tr }) => {
				if (!dispatch) return true;
				fieldsArray.forEach((annotation) => {
					let { from: from$1, to, attrs } = annotation;
					let { schema } = editor;
					let newPosFrom = tr.mapping.map(from$1);
					let newPosTo = tr.mapping.map(to);
					let defaultDisplayLabel = attrs.defaultDisplayLabel ? attrs.defaultDisplayLabel : attrs.displayLabel || "";
					attrs.hash = generateDocxRandomId(4);
					let node = schema.nodes[this.name].create({
						...attrs,
						defaultDisplayLabel,
						hash: attrs.hash || generateDocxRandomId(4)
					}, null, null);
					tr.replaceWith(newPosFrom, newPosTo, node);
				});
				return true;
			},
			replaceFieldAnnotationsWithLabelInSelection: (options = {}) => ({ commands: commands$1 }) => {
				return commands$1.replaceFieldAnnotationsWithLabel(null, {
					...options,
					isInSelection: true
				});
			},
			replaceFieldAnnotationsWithLabel: (fieldIdOrArray, { isInSelection = false, addToHistory = false, types = annotationTypes } = {}) => ({ dispatch, state, tr }) => {
				let { from: from$1, to } = state.selection;
				let annotations = isInSelection ? findFieldAnnotationsBetween(from$1, to, state.doc) : findFieldAnnotationsByFieldId(fieldIdOrArray, state);
				annotations = types.length ? annotations.filter(({ node }) => types.includes(node.attrs.type)) : annotations;
				if (!annotations.length) return true;
				if (!addToHistory) tr.setMeta("addToHistory", false);
				if (dispatch) annotations.forEach((annotation) => {
					let { pos, node } = annotation;
					let newPosFrom = tr.mapping.map(pos);
					let newPosTo = tr.mapping.map(pos + node.nodeSize);
					let currentNode = tr.doc.nodeAt(newPosFrom);
					let nodeEqual = node.attrs.fieldId === currentNode?.attrs?.fieldId;
					let currentMarks = tr.doc.resolve(newPosFrom).marks();
					currentMarks = currentMarks.length ? [...currentMarks] : null;
					if (nodeEqual) {
						let label = node.attrs.displayLabel || " ";
						let textNode = state.schema.text(label, currentMarks);
						tr.replaceWith(newPosFrom, newPosTo, textNode);
					}
				});
				return true;
			},
			resetFieldAnnotations: () => ({ dispatch, state, tr }) => {
				let annotations = getAllFieldAnnotations(state);
				if (!annotations.length) return true;
				tr.setMeta("fieldAnnotationUpdate", true);
				if (dispatch) annotations.forEach(({ pos, node }) => {
					let newPos = tr.mapping.map(pos);
					let currentNode = tr.doc.nodeAt(newPos);
					if (node.attrs.fieldId === currentNode?.attrs?.fieldId) {
						let displayLabel = node.attrs.defaultDisplayLabel || node.attrs.displayLabel || "";
						tr.setNodeMarkup(newPos, void 0, {
							...node.attrs,
							displayLabel,
							imageSrc: null,
							rawHtml: null,
							linkUrl: null,
							hash: null
						});
					}
				});
				return true;
			},
			updateFieldAnnotations: (fieldIdOrArray, attrs = {}) => ({ dispatch, state, commands: commands$1 }) => {
				let annotations = findFieldAnnotationsByFieldId(fieldIdOrArray, state);
				if (!annotations.length) return true;
				if (dispatch) return commands$1.updateFieldAnnotationsAttributes(annotations, attrs);
				return true;
			},
			updateFieldAnnotation: (annotation, attrs = {}) => ({ dispatch, commands: commands$1 }) => {
				if (!annotation) return true;
				if (dispatch) {
					commands$1.updateFieldAnnotationsAttributes([annotation], attrs);
					if (this.editor.options.pagination && !isHeadless(this.editor)) setTimeout(() => {
						const newTr = this.editor.view.state.tr;
						newTr.setMeta("forceUpdatePagination", true);
						this.editor.view.dispatch(newTr);
					}, 50);
					return true;
				}
				return true;
			},
			updateFieldAnnotationsAttributes: (annotations, attrs = {}) => ({ dispatch, tr }) => {
				if (!dispatch) return true;
				tr.setMeta("fieldAnnotationUpdate", true);
				annotations.forEach((annotation) => {
					let { pos, node } = annotation;
					let newPos = tr.mapping.map(pos);
					let currentNode = tr.doc.nodeAt(newPos);
					if (node.attrs.fieldId === currentNode?.attrs?.fieldId) tr.setNodeMarkup(newPos, void 0, {
						...node.attrs,
						...attrs
					});
				});
				return true;
			},
			deleteFieldAnnotations: (fieldIdOrArray) => ({ dispatch, state, tr }) => {
				let annotations = findFieldAnnotationsByFieldId(fieldIdOrArray, state);
				if (!annotations.length) return true;
				if (dispatch) annotations.forEach((annotation) => {
					let { pos, node } = annotation;
					let newPosFrom = tr.mapping.map(pos);
					let newPosTo = tr.mapping.map(pos + node.nodeSize);
					let currentNode = tr.doc.nodeAt(newPosFrom);
					if (node.eq(currentNode)) tr.delete(newPosFrom, newPosTo);
				});
				return true;
			},
			deleteFieldAnnotationsByNode: (annotations) => ({ dispatch, tr }) => {
				if (!annotations.length) return true;
				if (dispatch) annotations.forEach((annotation) => {
					let { pos, node } = annotation;
					let newPosFrom = tr.mapping.map(pos);
					let newPosTo = tr.mapping.map(pos + node.nodeSize);
					let currentNode = tr.doc.nodeAt(newPosFrom);
					if (node.eq(currentNode)) tr.delete(newPosFrom, newPosTo);
				});
				return true;
			},
			deleteFieldAnnotation: (annotation) => ({ dispatch, tr }) => {
				if (!annotation) return true;
				if (dispatch) {
					let { pos, node } = annotation;
					let newPosFrom = tr.mapping.map(pos);
					let newPosTo = tr.mapping.map(pos + node.nodeSize);
					let currentNode = tr.doc.nodeAt(newPosFrom);
					if (node.eq(currentNode)) tr.delete(newPosFrom, newPosTo);
				}
				return true;
			},
			sliceFieldAnnotations: (fieldIdOrArray, end$1) => ({ dispatch, state, tr }) => {
				let annotations = findFieldAnnotationsByFieldId(fieldIdOrArray, state);
				if (!annotations.length) return true;
				if (dispatch) annotations.forEach((annotation, index) => {
					if (index >= end$1) {
						let { pos, node } = annotation;
						let newPosFrom = tr.mapping.map(pos);
						let newPosTo = tr.mapping.map(pos + node.nodeSize);
						let currentNode = tr.doc.nodeAt(newPosFrom);
						if (node.eq(currentNode)) tr.delete(newPosFrom, newPosTo);
					}
				});
				return true;
			},
			setFieldAnnotationsHiddenByCondition: (predicate = () => false, unsetFromOthers = false) => ({ dispatch, state, chain }) => {
				let annotations = getAllFieldAnnotations(state);
				if (!annotations.length) return true;
				if (dispatch) {
					let otherAnnotations = [];
					let matchedAnnotations = annotations.filter((annotation) => {
						if (predicate(annotation.node)) return annotation;
						else otherAnnotations.push(annotation);
					});
					if (unsetFromOthers) return chain().updateFieldAnnotationsAttributes(matchedAnnotations, { hidden: true }).updateFieldAnnotationsAttributes(otherAnnotations, { hidden: false }).run();
					else return chain().updateFieldAnnotationsAttributes(matchedAnnotations, { hidden: true }).run();
				}
				return true;
			},
			unsetFieldAnnotationsHidden: () => ({ dispatch, state, commands: commands$1 }) => {
				let annotations = getAllFieldAnnotations(state);
				if (!annotations.length) return true;
				if (dispatch) return commands$1.updateFieldAnnotationsAttributes(annotations, { hidden: false });
				return true;
			},
			setFieldAnnotationsVisibility: (visibility = "visible") => ({ dispatch, state, commands: commands$1 }) => {
				let annotations = getAllFieldAnnotations(state);
				if (!annotations.length) return true;
				if (!this.options.visibilityOptions.includes(visibility)) return false;
				if (dispatch) return commands$1.updateFieldAnnotationsAttributes(annotations, { visibility });
				return true;
			},
			setFieldAnnotationsHighlighted: (predicate = () => false, highlighted = true) => ({ dispatch, state, commands: commands$1 }) => {
				let annotations = getAllFieldAnnotations(state);
				if (!annotations.length) return true;
				if (dispatch) {
					let matchedAnnotations = annotations.filter((annotation) => {
						if (predicate(annotation.node)) return annotation;
					});
					return commands$1.updateFieldAnnotationsAttributes(matchedAnnotations, { highlighted });
				}
				return true;
			},
			toggleFieldAnnotationsFormat: (name, setSelection = false) => ({ dispatch, tr, state, commands: commands$1 }) => {
				if (!this.options.toggleFormatNames.includes(name)) return false;
				let { from: from$1, to, node } = state.selection;
				let annotations = findFieldAnnotationsBetween(from$1, to, state.doc);
				if (!annotations.length) return true;
				if (dispatch) {
					annotations.forEach((annotation) => {
						commands$1.updateFieldAnnotationsAttributes([annotation], { [name]: !annotation.node.attrs[name] });
					});
					if (setSelection && node?.type.name === this.name) tr.setSelection(NodeSelection.create(tr.doc, from$1));
				}
				return true;
			},
			setFieldAnnotationsFontFamily: (fontFamily, setSelection = false) => ({ dispatch, tr, state, commands: commands$1 }) => {
				let { from: from$1, to, node } = state.selection;
				let annotations = findFieldAnnotationsBetween(from$1, to, state.doc);
				if (!annotations.length) return true;
				if (dispatch) {
					annotations.forEach((annotation) => {
						commands$1.updateFieldAnnotationsAttributes([annotation], { fontFamily });
					});
					if (setSelection && node?.type.name === this.name) tr.setSelection(NodeSelection.create(tr.doc, from$1));
				}
				return true;
			},
			setFieldAnnotationsFontSize: (fontSize, setSelection = false) => ({ dispatch, tr, state, commands: commands$1 }) => {
				let { from: from$1, to, node } = state.selection;
				let annotations = findFieldAnnotationsBetween(from$1, to, state.doc);
				if (!annotations.length) return true;
				let [value, unit] = parseSizeUnit(fontSize);
				let min$2 = 8, max$2 = 96, defaultUnit = "pt";
				if (Number.isNaN(value)) return false;
				value = minMax(value, min$2, max$2);
				unit = unit ? unit : defaultUnit;
				if (dispatch) {
					annotations.forEach((annotation) => {
						commands$1.updateFieldAnnotationsAttributes([annotation], { fontSize: `${value}${unit}` });
					});
					if (setSelection && node?.type.name === this.name) tr.setSelection(NodeSelection.create(tr.doc, from$1));
				}
				return true;
			},
			setFieldAnnotationsTextHighlight: (color, setSelection = false) => ({ dispatch, tr, state, commands: commands$1 }) => {
				let { from: from$1, to, node } = state.selection;
				let annotations = findFieldAnnotationsBetween(from$1, to, state.doc);
				if (!annotations.length) return true;
				if (dispatch) {
					annotations.forEach((annotation) => {
						commands$1.updateFieldAnnotationsAttributes([annotation], { textHighlight: color });
					});
					if (setSelection && node?.type.name === this.name) tr.setSelection(NodeSelection.create(tr.doc, from$1));
				}
				return true;
			},
			setFieldAnnotationsTextColor: (color, setSelection = false) => ({ dispatch, tr, state, commands: commands$1 }) => {
				let { from: from$1, to, node } = state.selection;
				let annotations = findFieldAnnotationsBetween(from$1, to, state.doc);
				if (!annotations.length) return true;
				if (dispatch) {
					annotations.forEach((annotation) => {
						commands$1.updateFieldAnnotationsAttributes([annotation], { textColor: color });
					});
					if (setSelection && node?.type.name === this.name) tr.setSelection(NodeSelection.create(tr.doc, from$1));
				}
				return true;
			},
			...commands
		};
	},
	addNodeView() {
		return (props) => {
			return new FieldAnnotationView({
				...props,
				annotationClass: this.options.annotationClass,
				annotationContentClass: this.options.annotationContentClass,
				borderColor: this.options.borderColor
			});
		};
	},
	addPmPlugins() {
		return [FieldAnnotationPlugin({
			editor: this.editor,
			annotationClass: this.options.annotationClass,
			handleDropOutside: this.options.handleDropOutside
		})];
	}
});
function getFormatAttrsFromMarks(marks) {
	if (!marks) return {};
	let formatAttrs = {
		bold: false,
		italic: false,
		underline: false,
		fontFamily: null,
		fontSize: null
	};
	if (marks && marks.length) {
		formatAttrs.bold = marks.some((mark) => mark.type.name === "bold");
		formatAttrs.italic = marks.some((mark) => mark.type.name === "italic");
		formatAttrs.underline = marks.some((mark) => mark.type.name === "underline");
		let textStyle = marks.find((mark) => mark.type.name === "textStyle");
		if (textStyle) {
			formatAttrs.fontFamily = textStyle.attrs.fontFamily ?? null;
			formatAttrs.fontSize = textStyle.attrs.fontSize ?? null;
		}
	}
	return formatAttrs;
}
const OOXML_Z_INDEX_BASE = 251658240;
const Image = Node$1.create({
	name: "image",
	group: "inline",
	inline: true,
	draggable: true,
	addOptions() {
		return {
			allowBase64: true,
			htmlAttributes: {
				style: "display: inline-block;",
				"aria-label": "Image node"
			}
		};
	},
	addStorage() {
		return {
			media: {},
			pendingRelativeRegistrations: /* @__PURE__ */ new Set()
		};
	},
	addAttributes() {
		return {
			sdImageId: {
				default: null,
				rendered: false
			},
			relativeHeight: {
				default: null,
				rendered: false
			},
			src: {
				default: null,
				renderDOM: ({ src }) => {
					return { src: this.storage.media[src] ?? src };
				}
			},
			alt: { default: "Uploaded picture" },
			id: { rendered: false },
			isPict: { rendered: false },
			passthroughSiblings: { rendered: false },
			hidden: {
				default: false,
				rendered: false
			},
			title: { default: null },
			rId: {
				default: null,
				rendered: false
			},
			originalPadding: {
				default: null,
				rendered: false
			},
			originalAttributes: { rendered: false },
			wrap: {
				default: { type: "Inline" },
				rendered: false
			},
			anchorData: {
				default: null,
				renderDOM: ({ anchorData, originalAttributes }) => {
					const relativeHeight = originalAttributes?.relativeHeight;
					if (anchorData && relativeHeight) return { style: `position:relative; z-index: ${Math.max(0, relativeHeight - OOXML_Z_INDEX_BASE)}` };
				}
			},
			isAnchor: { rendered: false },
			vmlWatermark: { rendered: false },
			vmlTextWatermark: { rendered: false },
			textWatermarkData: { rendered: false },
			vmlStyle: { rendered: false },
			vmlAttributes: { rendered: false },
			vmlImagedata: { rendered: false },
			vmlTextpathAttributes: { rendered: false },
			vmlPathAttributes: { rendered: false },
			vmlFillAttributes: { rendered: false },
			vmlStrokeAttributes: { rendered: false },
			vmlWrapAttributes: { rendered: false },
			transformData: {
				default: {},
				renderDOM: ({ transformData }) => {
					let style = "";
					if (transformData?.rotation) style += `rotate(${Math.round(transformData.rotation)}deg) `;
					if (transformData?.verticalFlip) style += "scaleY(-1) ";
					if (transformData?.horizontalFlip) style += "scaleX(-1) ";
					style = style.trim();
					if (style.length > 0) return { style: `transform: ${style};` };
				}
			},
			grayscale: {
				default: false,
				rendered: false
			},
			lum: {
				default: null,
				rendered: false
			},
			alphaModFix: {
				default: null,
				rendered: false
			},
			gain: {
				default: null,
				rendered: false
			},
			blacklevel: {
				default: null,
				rendered: false
			},
			simplePos: { rendered: false },
			extension: { rendered: false },
			originalExtension: { rendered: false },
			originalSrc: { rendered: false },
			shouldCover: {
				default: false,
				rendered: false
			},
			clipPath: {
				default: null,
				renderDOM: (attrs) => {
					const clipPath = attrs.clipPath;
					if (typeof clipPath !== "string" || clipPath.trim().length === 0) return {};
					if (attrs.size?.width && attrs.size?.height) return {};
					let style = `clip-path: ${clipPath};`;
					const scaleStyle = formatInsetClipPathTransform(clipPath);
					if (scaleStyle) style += ` ${scaleStyle}`;
					return { style };
				}
			},
			size: {
				default: {},
				renderDOM: ({ size: size$1, shouldCover }) => {
					let style = "";
					let { width, height } = size$1 ?? {};
					if (width) style += `width: ${width}px;`;
					if (height && shouldCover) style += `height: ${height}px; object-fit: cover; object-position: left top;`;
					else if (height) style += "height: auto;";
					return { style };
				}
			},
			padding: {
				default: {},
				rendered: false
			},
			marginOffset: {
				default: {},
				rendered: false
			},
			style: {
				default: null,
				rendered: true,
				renderDOM: ({ style }) => {
					if (!style) return {};
					return { style };
				}
			},
			drawingChildOrder: {
				default: null,
				rendered: false
			},
			originalDrawingChildren: {
				default: null,
				rendered: false
			},
			rawSrcRect: {
				default: null,
				rendered: false
			},
			lockAspectRatio: {
				default: true,
				rendered: false
			},
			decorative: {
				default: false,
				rendered: false
			},
			hyperlink: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: this.options.allowBase64 ? "img[src]" : "img[src]:not([src^=\"data:\"])" }];
	},
	renderDOM({ node, htmlAttributes }) {
		const { wrap, marginOffset } = getNormalizedImageAttrs(node.attrs);
		const { anchorData, padding, transformData = {}, size: size$1 = {
			width: 0,
			height: 0
		} } = node.attrs;
		const margin = {
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		};
		let centered = false;
		let floatRight = false;
		let baseHorizontal = marginOffset?.horizontal || 0;
		let style = "";
		if (padding) {
			if (padding.left) margin.left += padding.left;
			if (padding.right) margin.right += padding.right;
			if (padding.top) margin.top += padding.top;
			if (padding.bottom) margin.bottom += padding.bottom;
		}
		const { rotation } = transformData;
		const { height, width } = size$1;
		if (rotation && height && width) {
			const { horizontal, vertical } = getRotationMargins(width, height, rotation);
			margin.left += horizontal;
			margin.right += horizontal;
			margin.top += vertical;
			margin.bottom += vertical;
		}
		if (wrap && wrap.type) {
			const { type, attrs = {} } = wrap;
			switch (type) {
				case "None":
					style += "position: absolute;";
					const relativeHeight = node.attrs.relativeHeight ?? node.attrs.originalAttributes?.relativeHeight;
					if (relativeHeight != null) {
						const zIndex = Math.max(0, relativeHeight - OOXML_Z_INDEX_BASE);
						style += `z-index: ${zIndex};`;
					} else if (attrs.behindDoc) style += "z-index: -1;";
					else style += "z-index: 1;";
					break;
				case "Square":
					style += "shape-outside: border-box; clear: both;";
					if (attrs.wrapText === "right") style += "float: left;";
					else if (attrs.wrapText === "left") {
						style += "float: right;";
						floatRight = true;
					} else if (["largest", "bothSides"].includes(attrs.wrapText)) {
						const pageStylesData = getDataFromPageStyles({
							editor: this.editor,
							marginOffset,
							size: size$1,
							attrs
						});
						style += pageStylesData.style;
						floatRight = pageStylesData.floatRight;
						baseHorizontal = pageStylesData.baseHorizontal;
					}
					if (attrs.distTop) margin.top += attrs.distTop;
					if (attrs.distBottom) margin.bottom += attrs.distBottom;
					if (attrs.distLeft) margin.left += attrs.distLeft;
					if (attrs.distRight) margin.right += attrs.distRight;
					break;
				case "Through":
				case "Tight": {
					style += "clear: both;";
					const pageStylesData = getDataFromPageStyles({
						editor: this.editor,
						marginOffset,
						size: size$1,
						attrs
					});
					style += pageStylesData.style;
					floatRight = pageStylesData.floatRight;
					baseHorizontal = pageStylesData.baseHorizontal;
					if (attrs.distTop) margin.top += attrs.distTop;
					if (attrs.distBottom) margin.bottom += attrs.distBottom;
					if (attrs.distLeft) margin.left += attrs.distLeft;
					if (attrs.distRight) margin.right += attrs.distRight;
					if (attrs.polygon) {
						let horizontalOffset = floatRight ? attrs.polygon[0][0] || 0 : marginOffset.horizontal + 15;
						let maxX = 0;
						let minX = 0;
						let minY = 0;
						let maxY = 0;
						attrs.polygon.forEach(([x, y$1]) => {
							if (floatRight && x < horizontalOffset) horizontalOffset = x;
							if (x > maxX) maxX = x;
							if (x < minX) minX = x;
							if (y$1 > maxY) maxY = y$1;
							if (y$1 < minY) minY = y$1;
						});
						const originalWidth = maxX - minX;
						const originalHeight = maxY - minY;
						const scaleWidth = Math.min(1, size$1.width / originalWidth);
						const scaleHeight = Math.min(1, size$1.height / originalHeight);
						const verticalOffset = Math.max(0, marginOffset.top);
						const points = attrs.polygon.map(([x, y$1]) => `${horizontalOffset + x * scaleWidth}px ${verticalOffset + y$1 * scaleHeight}px`).join(", ");
						style += `shape-outside: polygon(${points});`;
					}
					break;
				}
				case "TopAndBottom":
					style += "display: block; clear: both;";
					if (!anchorData) centered = true;
					if (attrs.distTop) margin.top += attrs.distTop;
					if (attrs.distBottom) margin.bottom += attrs.distBottom;
					break;
				case "Inline":
				default: break;
			}
		}
		const hasAnchorData = Boolean(anchorData);
		const hasMarginOffsets = marginOffset?.horizontal != null || marginOffset?.top != null;
		const isWrapBehindDoc = wrap?.attrs?.behindDoc;
		const isAnchorBehindDoc = anchorData?.behindDoc;
		const isBehindDocAnchor = wrap?.type === "None" && (isWrapBehindDoc || isAnchorBehindDoc);
		const isAbsolutelyPositioned = style.includes("position: absolute;");
		if (hasAnchorData) switch (anchorData.hRelativeFrom) {
			case "page":
				const pageStyles$1 = this.editor?.converter?.pageStyles || this.editor?.options.parentEditor?.converter?.pageStyles;
				margin.left -= inchesToPixels(pageStyles$1?.pageMargins?.left) || 0;
				break;
			case "margin":
				if (anchorData.alignH === "center") style += "position: absolute; left: 50%; transform: translateX(-50%);";
				if (anchorData.alignH === "left" || anchorData.alignH === "right") style += `position: absolute; ${anchorData.alignH}: 0;`;
				break;
			case "column":
				if (anchorData.alignH === "center") centered = true;
				else if (anchorData.alignH === "right") {
					floatRight = true;
					if (!style.includes("float: right;")) style += "float: right;";
				} else if (anchorData.alignH === "left") {
					if (!style.includes("float: left;")) style += "float: left;";
				} else if (!anchorData.alignH && marginOffset?.horizontal != null) {
					if (isAbsolutelyPositioned) {
						style += `left: ${baseHorizontal}px;`;
						style += "max-width: none;";
						baseHorizontal = 0;
					}
				}
				break;
			default: break;
		}
		if (hasAnchorData || hasMarginOffsets) {
			const relativeFromPageV = anchorData?.vRelativeFrom === "page";
			const relativeFromMarginV = anchorData?.vRelativeFrom === "margin";
			const maxMarginV = 500;
			const allowNegativeTopOffset = isBehindDocAnchor;
			const baseTop = allowNegativeTopOffset ? marginOffset?.top ?? 0 : Math.max(0, marginOffset?.top ?? 0);
			let rotationHorizontal = 0;
			let rotationTop = 0;
			const { rotation: rotation$1 } = transformData ?? {};
			const { height: height$1, width: width$1 } = size$1 ?? {};
			if (rotation$1 && height$1 && width$1) {
				const { horizontal: horizontal$1, vertical } = getRotationMargins(width$1, height$1, rotation$1);
				rotationHorizontal = horizontal$1;
				rotationTop = vertical;
			}
			const horizontal = baseHorizontal + rotationHorizontal;
			const top$1 = baseTop + rotationTop;
			if (horizontal) if (floatRight) margin.right += horizontal;
			else margin.left += horizontal;
			if (isAbsolutelyPositioned && allowNegativeTopOffset && !relativeFromMarginV) style += `top: ${top$1}px;`;
			else if (top$1 && !relativeFromMarginV) if (relativeFromPageV && top$1 >= maxMarginV) margin.top += maxMarginV;
			else margin.top += top$1;
		}
		if (centered) style += "margin-left: auto; margin-right: auto;";
		else {
			if (margin.left) style += `margin-left: ${margin.left}px;`;
			if (margin.right) style += `margin-right: ${margin.right}px;`;
		}
		if (margin.top) style += `margin-top: ${margin.top}px;`;
		if (margin.bottom) style += `margin-bottom: ${margin.bottom}px;`;
		if (isBehindDocAnchor) style += "max-width: none;";
		const finalAttributes = { ...htmlAttributes };
		if (style) {
			const existingStyle = finalAttributes.style || "";
			finalAttributes.style = existingStyle + (existingStyle ? " " : "") + style;
		}
		const clipPath = node.attrs.clipPath;
		const hasClipPath = typeof clipPath === "string" && clipPath.trim().length > 0;
		const { width: sizeW, height: sizeH } = size$1 ?? {};
		if (hasClipPath && sizeW > 0 && sizeH > 0) {
			const wrapperStyle = [
				finalAttributes.style || "",
				"overflow: hidden",
				`width: ${sizeW}px`,
				`height: ${sizeH}px`,
				"display: inline-block",
				"box-sizing: border-box"
			].filter(Boolean).join("; ");
			const imgInnerStyle = [
				"width: 100%",
				"height: 100%",
				"max-width: 100%",
				"max-height: 100%",
				"min-width: 0",
				"min-height: 0",
				"box-sizing: border-box",
				`clip-path: ${clipPath}`,
				formatInsetClipPathTransform(clipPath) || ""
			].filter(Boolean).join("; ");
			const imgAttrs = Attribute.mergeAttributes(this.options.htmlAttributes, {
				src: this.storage.media[node.attrs.src] ?? node.attrs.src,
				alt: node.attrs.alt ?? "Uploaded picture",
				title: node.attrs.title ?? void 0,
				style: imgInnerStyle
			});
			return [
				"span",
				{
					...finalAttributes,
					style: wrapperStyle
				},
				["img", imgAttrs]
			];
		}
		return ["img", Attribute.mergeAttributes(this.options.htmlAttributes, finalAttributes)];
	},
	addCommands() {
		return {
			setImage: (options) => ({ commands: commands$1 }) => {
				return commands$1.insertContent({
					type: this.name,
					attrs: {
						...options,
						sdImageId: options.sdImageId ?? v4_default()
					}
				});
			},
			setWrapping: (options) => ({ chain, state }) => {
				const { selection } = state;
				const { $from } = selection;
				const node = $from.nodeAfter;
				if (!node || node.type.name !== this.name) return false;
				const { type, attrs = {} } = options;
				const allowedAttrs = {};
				const allowedForType = {
					None: ["behindDoc"],
					Square: [
						"wrapText",
						"distTop",
						"distBottom",
						"distLeft",
						"distRight"
					],
					Through: [
						"distTop",
						"distBottom",
						"distLeft",
						"distRight",
						"polygon"
					],
					Tight: [
						"distTop",
						"distBottom",
						"distLeft",
						"distRight",
						"polygon"
					],
					TopAndBottom: ["distTop", "distBottom"],
					Inline: []
				}[type] || [];
				Object.keys(attrs).forEach((key) => {
					if (allowedForType.includes(key)) allowedAttrs[key] = attrs[key];
				});
				const updatedAttrs = {
					...node.attrs,
					wrap: {
						type,
						attrs: allowedAttrs
					},
					isAnchor: type !== "Inline"
				};
				return chain().updateAttributes(this.name, updatedAttrs).run();
			}
		};
	},
	addPmPlugins() {
		return [ImageRegistrationPlugin({ editor: this.editor }), ImagePositionPlugin({ editor: this.editor })];
	}
});
var getDataFromPageStyles = ({ editor, marginOffset, size: size$1, attrs }) => {
	let style = "";
	let floatRight = false;
	let baseHorizontal = marginOffset?.horizontal || 0;
	const pageStyles$1 = editor?.converter?.pageStyles || editor?.options.parentEditor?.converter?.pageStyles;
	if (pageStyles$1?.pageSize && pageStyles$1?.pageMargins && size$1.width) {
		const pageWidth = inchesToPixels(pageStyles$1.pageSize.width);
		const leftMargin = inchesToPixels(pageStyles$1.pageMargins.left);
		const rightMargin = inchesToPixels(pageStyles$1.pageMargins.right);
		const contentWidth = pageWidth - leftMargin - rightMargin;
		const imageWidth = size$1.width + (attrs.distLeft || 0) + (attrs.distRight || 0);
		const leftSpace = marginOffset.horizontal;
		const rightSpace = contentWidth - leftSpace - imageWidth;
		if (rightSpace < 0) style += "float: left;";
		else if (rightSpace > leftSpace) style += "float: left;";
		else {
			style += "float: right;";
			floatRight = true;
			baseHorizontal = rightSpace;
		}
	} else style += "float: left;";
	return {
		style,
		floatRight,
		baseHorizontal
	};
};
const BookmarkStart = Node$1.create({
	name: "bookmarkStart",
	group: "inline",
	content: "inline*",
	inline: true,
	addOptions() {
		return { htmlAttributes: {
			style: "height: 0; width: 0;",
			"aria-label": "Bookmark start node",
			role: "link"
		} };
	},
	addAttributes() {
		return {
			name: {
				default: null,
				renderDOM: ({ name }) => {
					if (name) return { name };
					return {};
				}
			},
			id: {
				default: null,
				renderDOM: ({ id }) => {
					if (id) return { id };
					return {};
				}
			},
			colFirst: { default: null },
			colLast: { default: null },
			displacedByCustomXml: { default: null }
		};
	},
	renderDOM({ htmlAttributes }) {
		return ["a", Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes)];
	},
	addCommands() {
		return {
			insertBookmark: (config) => ({ commands: commands$1 }) => {
				return commands$1.insertContent({
					type: this.name,
					attrs: config
				});
			},
			goToBookmark: (name) => ({ editor, tr }) => {
				const { doc: doc$1 } = tr;
				let targetPos = null;
				doc$1.descendants((node, pos) => {
					if (node.type.name === "bookmarkStart" && node.attrs.name === name) {
						targetPos = pos;
						return false;
					}
				});
				if (targetPos !== null) {
					editor.commands.focus(targetPos);
					return true;
				}
				return false;
			},
			renameBookmark: (name, newName) => ({ state, dispatch }) => {
				let found = false;
				state.doc.descendants((node, pos) => {
					if (node.type.name === "bookmarkStart" && node.attrs.name === name) {
						if (dispatch) dispatch(state.tr.setNodeMarkup(pos, void 0, {
							...node.attrs,
							name: newName
						}));
						found = true;
						return false;
					}
				});
				return found;
			},
			removeBookmark: (name) => ({ state, dispatch }) => {
				let startPos = null;
				let startNode = null;
				let bookmarkId = null;
				state.doc.descendants((node, pos) => {
					if (node.type.name === "bookmarkStart" && node.attrs.name === name) {
						startPos = pos;
						startNode = node;
						bookmarkId = node.attrs.id;
						return false;
					}
				});
				if (startPos === null || startNode === null) return false;
				if (dispatch) {
					const tr = state.tr;
					if (bookmarkId) {
						let endPos = null;
						let endNode = null;
						tr.doc.descendants((node, pos) => {
							if (node.type.name === "bookmarkEnd" && node.attrs.id === bookmarkId) {
								endPos = pos;
								endNode = node;
								return false;
							}
						});
						if (endPos !== null && endNode !== null && endPos > startPos) tr.delete(endPos, endPos + endNode.nodeSize);
					}
					const currentStart = tr.doc.nodeAt(startPos);
					if (currentStart) tr.delete(startPos, startPos + currentStart.nodeSize);
					dispatch(tr);
				}
				return true;
			}
		};
	}
});
const BookmarkEnd = Node$1.create({
	name: "bookmarkEnd",
	group: "inline",
	inline: true,
	atom: true,
	addOptions() {
		return { htmlAttributes: {
			style: "height: 0; width: 0; display: none;",
			"aria-label": "Bookmark end node",
			role: "none"
		} };
	},
	addAttributes() {
		return {
			id: {
				default: null,
				renderDOM: ({ id }) => {
					if (id) return { "data-bookmark-end-id": id };
					return {};
				}
			},
			displacedByCustomXml: {
				default: null,
				renderDOM: ({ displacedByCustomXml }) => {
					if (displacedByCustomXml) return { "data-displaced-by-custom-xml": displacedByCustomXml };
					return {};
				}
			},
			colFirst: { default: null },
			colLast: { default: null }
		};
	},
	renderDOM({ htmlAttributes }) {
		return ["span", Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes)];
	},
	addCommands() {
		return { insertBookmarkEnd: (id) => ({ commands: commands$1 }) => {
			return commands$1.insertContent({
				type: this.name,
				attrs: { id }
			});
		} };
	}
});
const SmartTag = Node$1.create({
	name: "smartTag",
	group: "inline",
	content: "inline*",
	inline: true,
	atom: false,
	isolating: false,
	draggable: false,
	selectable: false,
	addOptions() {
		return { htmlAttributes: {
			"data-sd-smart-tag": "",
			"aria-label": "Smart tag"
		} };
	},
	addAttributes() {
		return {
			element: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-element"),
				renderDOM: (attrs) => {
					if (!attrs.element) return {};
					return { "data-element": attrs.element };
				}
			},
			uri: {
				default: null,
				parseDOM: (elem) => elem.getAttribute("data-uri"),
				renderDOM: (attrs) => {
					if (!attrs.uri) return {};
					return { "data-uri": attrs.uri };
				}
			},
			smartTagPr: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: "span[data-sd-smart-tag]" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	}
});
const Mention = Node$1.create({
	name: "mention",
	group: "inline",
	inline: true,
	selectable: false,
	excludeFromSummaryJSON: true,
	atom: true,
	addOptions() {
		return { htmlAttributes: {
			class: "sd-editor-mention",
			"aria-label": "Mention node"
		} };
	},
	parseDOM() {
		return [{
			tag: `span[data-type="${this.name || this.email}"]`,
			getAttrs: (node) => ({
				name: node.getAttribute("name") || null,
				email: node.getAttribute("email") || null
			})
		}];
	},
	renderDOM({ node, htmlAttributes }) {
		const { name, email } = node.attrs;
		return [
			"span",
			Attribute.mergeAttributes({ "data-type": this.name || this.email }, this.options.htmlAttributes, htmlAttributes),
			`@${name ? name : email}`
		];
	},
	addAttributes() {
		return {
			name: { default: null },
			email: { default: null }
		};
	}
});
const PageNumber = Node$1.create({
	name: "page-number",
	group: "inline",
	inline: true,
	atom: true,
	draggable: false,
	selectable: false,
	defining: true,
	content: "",
	addOptions() {
		return { htmlAttributes: {
			contenteditable: false,
			"data-id": "auto-page-number",
			"aria-label": "Page number node"
		} };
	},
	addAttributes() {
		return {
			marksAsAttrs: {
				default: null,
				rendered: false
			},
			instruction: {
				default: null,
				rendered: false
			},
			pageNumberFormat: {
				default: null,
				rendered: false
			},
			pageNumberZeroPadding: {
				default: null,
				rendered: false
			}
		};
	},
	addNodeView() {
		return ({ node, editor, getPos, decorations }) => {
			const htmlAttributes = this.options.htmlAttributes;
			return new AutoPageNumberNodeView(node, getPos, decorations, editor, htmlAttributes);
		};
	},
	parseDOM() {
		return [{ tag: "span[data-id=\"auto-page-number\"]" }];
	},
	renderDOM({ htmlAttributes }) {
		return ["span", Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes)];
	},
	addCommands() {
		return { addAutoPageNumber: () => ({ tr, dispatch, state, editor }) => {
			const { options } = editor;
			if (!options.isHeaderOrFooter) return false;
			const { schema } = state;
			if (!schema?.nodes?.["page-number"]) return false;
			const pageNumberNode = schema.nodeFromJSON({ type: "page-number" });
			if (dispatch) {
				tr.replaceSelectionWith(pageNumberNode, false);
				if (!isHeadless(editor)) tr.setMeta("forceUpdatePagination", true);
			}
			return true;
		} };
	},
	addShortcuts() {
		return { "Mod-Shift-alt-p": () => this.editor.commands.addAutoPageNumber() };
	}
});
const TotalPageCount = Node$1.create({
	name: "total-page-number",
	group: "inline",
	inline: true,
	atom: true,
	draggable: false,
	selectable: false,
	content: "text*",
	addOptions() {
		return { htmlAttributes: {
			contenteditable: false,
			"data-id": "auto-total-pages",
			"aria-label": "Total page count node",
			class: "sd-editor-auto-total-pages"
		} };
	},
	addAttributes() {
		return {
			marksAsAttrs: {
				default: null,
				rendered: false
			},
			instruction: {
				default: null,
				rendered: false
			},
			pageNumberFormat: {
				default: null,
				rendered: false
			},
			pageNumberZeroPadding: {
				default: null,
				rendered: false
			},
			pageNumberNumericPicture: {
				default: null,
				rendered: false
			},
			importedCachedText: {
				default: null,
				rendered: false
			},
			resolvedText: {
				default: null,
				rendered: false
			}
		};
	},
	addNodeView() {
		return ({ node, editor, getPos, decorations }) => {
			const htmlAttributes = this.options.htmlAttributes;
			return new AutoPageNumberNodeView(node, getPos, decorations, editor, htmlAttributes);
		};
	},
	parseDOM() {
		return [{ tag: "span[data-id=\"auto-total-pages\"]" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	},
	addCommands() {
		return { addTotalPageCount: () => ({ tr, dispatch, state, editor }) => {
			const { options } = editor;
			if (!options.isHeaderOrFooter) return false;
			const { schema } = state;
			if (!schema.nodes?.["total-page-number"]) return false;
			const currentPages = editor?.options?.totalPageCount || editor?.options?.parentEditor?.currentTotalPages || 1;
			const pageNumberNode = {
				type: "total-page-number",
				content: [{
					type: "text",
					text: String(currentPages)
				}]
			};
			const pageNode = schema.nodeFromJSON(pageNumberNode);
			if (dispatch) tr.replaceSelectionWith(pageNode, false);
			return true;
		} };
	},
	addShortcuts() {
		return { "Mod-Shift-alt-c": () => this.editor.commands.addTotalPageCount() };
	}
});
const SectionPageCount = Node$1.create({
	name: "section-page-count",
	group: "inline",
	inline: true,
	atom: true,
	draggable: false,
	selectable: false,
	content: "text*",
	addOptions() {
		return { htmlAttributes: {
			contenteditable: false,
			"data-id": "auto-section-pages",
			"aria-label": "Section page count node",
			class: "sd-editor-auto-section-pages"
		} };
	},
	addAttributes() {
		return {
			marksAsAttrs: {
				default: null,
				rendered: false
			},
			importedCachedText: {
				default: null,
				rendered: false
			},
			resolvedText: {
				default: null,
				rendered: false
			},
			instruction: {
				default: null,
				rendered: false
			},
			pageNumberFormat: {
				default: null,
				rendered: false
			},
			pageNumberZeroPadding: {
				default: null,
				rendered: false
			}
		};
	},
	addNodeView() {
		return ({ node, editor, getPos, decorations }) => {
			const htmlAttributes = this.options.htmlAttributes;
			return new AutoPageNumberNodeView(node, getPos, decorations, editor, htmlAttributes);
		};
	},
	parseDOM() {
		return [{ tag: "span[data-id=\"auto-section-pages\"]" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	},
	addCommands() {
		return { addSectionPageCount: () => ({ tr, dispatch, state, editor }) => {
			const { options } = editor;
			if (!options.isHeaderOrFooter) return false;
			const { schema } = state;
			if (!schema.nodes?.["section-page-count"]) return false;
			const sectionPageCount = editor?.options?.sectionPageCount || 1;
			const sectionPageCountNode = {
				type: "section-page-count",
				content: [{
					type: "text",
					text: String(sectionPageCount)
				}]
			};
			const pageNode = schema.nodeFromJSON(sectionPageCountNode);
			if (dispatch) tr.replaceSelectionWith(pageNode, false);
			return true;
		} };
	}
});
var getNodeAttributes = (nodeName, editor, node = null) => {
	switch (nodeName) {
		case "page-number": {
			const currentPageNumber = editor.options.currentPageNumber || 1;
			const currentPageDisplayNumber = editor.options.currentPageDisplayNumber || currentPageNumber;
			const chapterNumberText = typeof editor.options.currentPageChapterNumberText === "string" ? editor.options.currentPageChapterNumberText : void 0;
			return {
				text: node?.attrs?.pageNumberFormat ? formatSectionPageNumberText({
					displayNumber: Number(currentPageDisplayNumber) || 1,
					pageFormat: node.attrs.pageNumberFormat,
					chapterNumberText,
					chapterSeparator: editor.options.currentPageChapterSeparator
				}) : editor.options.currentPageNumberText || currentPageNumber,
				className: "sd-editor-auto-page-number",
				dataId: "auto-page-number",
				ariaLabel: "Page number node"
			};
		}
		case "total-page-number": return {
			text: formatPageNumberFieldValue(Number(editor.options.totalPageCount || editor.options.parentEditor?.currentTotalPages || 1) || 1, getPageNumberFieldFormat(node?.attrs)),
			className: "sd-editor-auto-total-pages",
			dataId: "auto-total-pages",
			ariaLabel: "Total page count node"
		};
		case "section-page-count": {
			const sectionPageCount = editor.options.sectionPageCount;
			const cachedText = node?.attrs?.resolvedText ?? node?.attrs?.importedCachedText ?? node?.textContent ?? "1";
			const pageNumberFormat = typeof node?.attrs?.pageNumberFormat === "string" ? node.attrs.pageNumberFormat : void 0;
			const pageNumberZeroPadding = typeof node?.attrs?.pageNumberZeroPadding === "number" && Number.isFinite(node.attrs.pageNumberZeroPadding) ? node.attrs.pageNumberZeroPadding : void 0;
			return {
				text: sectionPageCount != null ? pageNumberFormat || pageNumberZeroPadding != null ? formatPageNumberFieldValue(Number(sectionPageCount) || 1, {
					...pageNumberFormat ? { format: pageNumberFormat } : {},
					...pageNumberZeroPadding != null ? { zeroPadding: pageNumberZeroPadding } : {}
				}) : sectionPageCount : cachedText,
				className: "sd-editor-auto-section-pages",
				dataId: "auto-section-pages",
				ariaLabel: "Section page count node"
			};
		}
		default: return {};
	}
};
var AutoPageNumberNodeView = class {
	constructor(node, getPos, decorations, editor, htmlAttributes = {}) {
		this.node = node;
		this.editor = editor;
		this.view = editor.view;
		this.getPos = getPos;
		this.editor = editor;
		this.dom = this.#renderDom(node, htmlAttributes);
	}
	#renderDom(node, htmlAttributes) {
		const attrs = getNodeAttributes(this.node.type.name, this.editor, this.node);
		const content = document.createTextNode(String(attrs.text));
		const nodeContent = document.createElement("span");
		nodeContent.className = attrs.className;
		nodeContent.setAttribute("data-id", attrs.dataId);
		nodeContent.setAttribute("aria-label", attrs.ariaLabel);
		const currentPos = this.getPos();
		const { styles, marks } = getMarksFromNeighbors(currentPos, this.view);
		this.#scheduleUpdateNodeStyle(currentPos, marks);
		Object.assign(nodeContent.style, styles);
		nodeContent.appendChild(content);
		Object.entries(htmlAttributes).forEach(([key, value]) => {
			if (value) nodeContent.setAttribute(key, value);
		});
		return nodeContent;
	}
	#scheduleUpdateNodeStyle(pos, marks) {
		setTimeout(() => {
			if (!this.editor?.state) return;
			const { state } = this.editor;
			const { dispatch } = this.view;
			const node = state.doc.nodeAt(pos);
			if (!node || node.isText) return;
			const currentMarks = node.attrs.marksAsAttrs || [];
			const newMarks = marks.map((m$1) => ({
				type: m$1.type.name,
				attrs: m$1.attrs
			}));
			if (JSON.stringify(currentMarks) === JSON.stringify(newMarks)) return;
			const newAttrs = {
				...node.attrs,
				marksAsAttrs: newMarks
			};
			dispatch(state.tr.setNodeMarkup(pos, void 0, newAttrs).setMeta("skipTrackChanges", true).setMeta("addToHistory", false));
		}, 0);
	}
	update(node) {
		const incomingType = node?.type?.name;
		const currentType = this.node?.type?.name;
		if (!incomingType || incomingType !== currentType) return false;
		this.node = node;
		const attrs = getNodeAttributes(this.node.type.name, this.editor, this.node);
		const newText = String(attrs.text);
		if (this.dom.textContent !== newText) this.dom.textContent = newText;
		return true;
	}
};
var getMarksFromNeighbors = (currentPos, view) => {
	const $pos = view.state.doc.resolve(currentPos);
	const styles = {};
	const marks = [];
	const before = $pos.nodeBefore;
	if (before) {
		Object.assign(styles, processMarks(before.marks));
		marks.push(...before.marks);
	}
	const after = $pos.nodeAfter;
	if (after) {
		Object.assign(styles, {
			...styles,
			...processMarks(after.marks)
		});
		marks.push(...after.marks);
	}
	return {
		styles,
		marks
	};
};
var processMarks = (marks) => {
	const styles = {};
	marks.forEach((mark) => {
		const { type, attrs } = mark;
		switch (type.name) {
			case "textStyle":
				if (attrs.fontFamily) styles["font-family"] = attrs.fontFamily;
				if (attrs.fontSize) styles["font-size"] = attrs.fontSize;
				if (attrs.color) styles["color"] = attrs.color;
				if (attrs.backgroundColor) styles["background-color"] = attrs.backgroundColor;
				break;
			case "bold":
				styles["font-weight"] = "bold";
				break;
			case "italic":
				styles["font-style"] = "italic";
				break;
			case "underline":
				styles["text-decoration"] = (styles["text-decoration"] || "") + " underline";
				break;
			case "strike":
				styles["text-decoration"] = (styles["text-decoration"] || "") + " line-through";
				break;
			default:
				if (attrs?.style) Object.entries(attrs.style).forEach(([key, value]) => {
					styles[key] = value;
				});
				break;
		}
	});
	return styles;
};
const PageReference = Node$1.create({
	name: "pageReference",
	group: "inline",
	inline: true,
	atom: true,
	draggable: false,
	selectable: false,
	content: "inline*",
	addOptions() {
		return { htmlAttributes: {
			contenteditable: false,
			"data-id": "auto-page-reference",
			"aria-label": "Page reference node",
			class: "sd-editor-page-reference"
		} };
	},
	addAttributes() {
		return {
			marksAsAttrs: {
				default: null,
				rendered: false
			},
			instruction: {
				default: "",
				rendered: false
			},
			instructionTokens: {
				default: null,
				rendered: false
			},
			bookmarkId: {
				default: "",
				rendered: false
			},
			hasHyperlinkSwitch: {
				default: false,
				rendered: false
			},
			hasRelativePositionSwitch: {
				default: false,
				rendered: false
			},
			pageNumberFieldFormat: {
				default: null,
				rendered: false
			},
			numericPictureFormat: {
				default: null,
				rendered: false
			},
			fieldResultFormat: {
				default: null,
				rendered: false
			},
			fieldRunProperties: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: "span[data-id=\"auto-page-reference\"]" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	}
});
const ShapeContainer = Node$1.create({
	name: "shapeContainer",
	group: "block",
	content: "block+",
	isolating: true,
	addOptions() {
		return { htmlAttributes: {
			class: "sd-editor-shape-container",
			"aria-label": "Shape container node"
		} };
	},
	addAttributes() {
		return {
			fillcolor: { renderDOM: (attrs) => {
				if (!attrs.fillcolor) return {};
				return { style: `background-color: ${attrs.fillcolor}` };
			} },
			sdBlockId: {
				default: null,
				keepOnSplit: false,
				parseDOM: (elem) => elem.getAttribute("data-sd-block-id"),
				renderDOM: (attrs) => {
					return attrs.sdBlockId ? { "data-sd-block-id": attrs.sdBlockId } : {};
				}
			},
			style: { renderDOM: (attrs) => {
				if (!attrs.style) return {};
				return { style: attrs.style };
			} },
			wrapAttributes: { rendered: false },
			anchorData: { rendered: false },
			marginOffset: { rendered: false },
			attributes: { rendered: false },
			kind: {
				default: null,
				rendered: false
			},
			width: {
				default: null,
				renderDOM: (attrs) => {
					if (attrs.width == null) return {};
					return { "data-width": attrs.width };
				}
			},
			height: {
				default: null,
				renderDOM: (attrs) => {
					if (attrs.height == null) return {};
					return { "data-height": attrs.height };
				}
			},
			fillColor: {
				default: null,
				rendered: false
			},
			strokeColor: {
				default: null,
				rendered: false
			},
			strokeWidth: {
				default: null,
				rendered: false
			},
			rotation: {
				default: 0,
				rendered: false
			},
			flipH: {
				default: false,
				rendered: false
			},
			flipV: {
				default: false,
				rendered: false
			},
			wrap: {
				default: null,
				rendered: false
			},
			isAnchor: {
				default: false,
				rendered: false
			},
			drawingContent: {
				default: null,
				rendered: false
			},
			originalAttributes: {
				default: null,
				rendered: false
			},
			effectExtent: {
				default: null,
				rendered: false
			},
			lineEnds: {
				default: null,
				rendered: false
			},
			hidden: {
				default: false,
				rendered: false
			},
			isTextBox: {
				default: false,
				rendered: false
			},
			isWordArt: {
				default: false,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: `div[data-type="${this.name}"]` }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"div",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes, { "data-type": this.name }),
			0
		];
	}
});
const ShapeTextbox = Node$1.create({
	name: "shapeTextbox",
	group: "block",
	content: "paragraph* block*",
	isolating: true,
	addOptions() {
		return { htmlAttributes: {
			class: "sd-editor-shape-textbox",
			"aria-label": "Shape textbox node"
		} };
	},
	addAttributes() {
		return {
			sdBlockId: {
				default: null,
				keepOnSplit: false,
				parseDOM: (elem) => elem.getAttribute("data-sd-block-id"),
				renderDOM: (attrs) => {
					return attrs.sdBlockId ? { "data-sd-block-id": attrs.sdBlockId } : {};
				}
			},
			attributes: { rendered: false },
			textInsets: {
				default: null,
				rendered: false
			},
			textVerticalAlign: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: `div[data-type="${this.name}"]` }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"div",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes, { "data-type": this.name }),
			0
		];
	}
});
function createDefaultHorizontalRuleAttrs() {
	return {
		horizontalRule: true,
		size: {
			width: "100%",
			height: 2
		},
		background: "#e5e7eb"
	};
}
const ContentBlock = Node$1.create({
	name: "contentBlock",
	group: "inline",
	content: "",
	isolating: true,
	atom: true,
	inline: true,
	addOptions() {
		return { htmlAttributes: { contenteditable: false } };
	},
	addAttributes() {
		return {
			horizontalRule: {
				default: false,
				renderDOM: ({ horizontalRule }) => {
					if (!horizontalRule) return {};
					return { "data-horizontal-rule": "true" };
				}
			},
			size: {
				default: null,
				renderDOM: (attrs) => {
					if (!attrs.size) return {};
					let style = "";
					if (attrs.size.top) style += `top: ${attrs.size.top}px; `;
					if (attrs.size.left) style += `left: ${attrs.size.left}px; `;
					if (attrs.size.width) style += `width: ${attrs.size.width.toString().endsWith("%") ? attrs.size.width : `${attrs.size.width}px`}; `;
					if (attrs.size.height) style += `height: ${attrs.size.height.toString().endsWith("%") ? attrs.size.height : `${attrs.size.height}px`}; `;
					if (attrs.marginOffset?.horizontal != null || attrs.marginOffset?.top != null) {
						style += "position: absolute; ";
						const relativeHeight = attrs.originalAttributes?.relativeHeight;
						if (relativeHeight != null) {
							const zIndex = Math.max(0, relativeHeight - OOXML_Z_INDEX_BASE);
							style += `z-index: ${zIndex}; `;
						} else style += "z-index: 1; ";
					}
					return { style };
				}
			},
			background: {
				default: null,
				renderDOM: (attrs) => {
					if (!attrs.background) return {};
					return { style: `background-color: ${attrs.background}` };
				}
			},
			drawingContent: { rendered: false },
			vmlAttributes: {
				default: null,
				rendered: false
			},
			style: {
				default: null,
				rendered: false
			},
			attributes: { rendered: false },
			originalAttributes: { rendered: false },
			marginOffset: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{
			tag: `div[data-type="${this.name}"]`,
			priority: 60
		}, {
			tag: "hr",
			getAttrs: () => createDefaultHorizontalRuleAttrs()
		}];
	},
	renderDOM({ htmlAttributes }) {
		return ["div", Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes, { "data-type": this.name })];
	},
	addCommands() {
		return {
			insertHorizontalRule: () => ({ commands: commands$1 }) => {
				return commands$1.insertContent({
					type: this.name,
					attrs: createDefaultHorizontalRuleAttrs()
				});
			},
			insertContentBlock: (config) => ({ commands: commands$1 }) => {
				return commands$1.insertContent({
					type: this.name,
					attrs: config
				});
			}
		};
	}
});
const TableOfContents = Node$1.create({
	name: "tableOfContents",
	group: "block",
	content: "paragraph*",
	inline: false,
	addStorage() {
		return { pageMap: null };
	},
	addOptions() {
		return { htmlAttributes: {
			"data-id": "table-of-contents",
			"aria-label": "Table of Contents"
		} };
	},
	parseDOM() {
		return [{ tag: "div[data-id=\"table-of-contents\"]" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"div",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	},
	addCommands() {
		const normalizeTocContent = (content, schema) => {
			if (!Array.isArray(content)) return null;
			return content.map((entry) => entry && typeof entry === "object" && typeof entry.type === "string" ? schema.nodeFromJSON(entry) : entry);
		};
		const insertTableOfContentsAt = (options) => ({ tr, dispatch, state }) => {
			const { pos, instruction = "", sdBlockId = null, content, rightAlignPageNumbers } = options;
			const tocType = this.editor.schema.nodes.tableOfContents;
			if (!tocType) return false;
			const defaultContent = [this.editor.schema.nodes.paragraph.create({}, this.editor.schema.text("Update table of contents to populate entries."))];
			const materializedContent = normalizeTocContent(content, state.schema) ?? defaultContent;
			const attrs = {
				instruction,
				sdBlockId
			};
			if (rightAlignPageNumbers !== void 0) attrs.rightAlignPageNumbers = rightAlignPageNumbers;
			const tocNode = tocType.create(attrs, materializedContent);
			try {
				if (dispatch) tr.insert(pos, tocNode);
				return true;
			} catch (error) {
				if (error instanceof RangeError) return false;
				throw error;
			}
		};
		return {
			insertTableOfContentsAt,
			insertTableOfContents: () => (props) => {
				const { editor } = props;
				let prepared;
				try {
					prepared = prepareTableOfContentsInsertion(editor, { at: resolveTableOfContentsCreateLocation(editor) });
				} catch {
					return false;
				}
				return insertTableOfContentsAt({
					pos: prepared.pos,
					instruction: prepared.instruction,
					sdBlockId: prepared.sdBlockId,
					content: prepared.content,
					...prepared.rightAlignPageNumbers !== void 0 ? { rightAlignPageNumbers: prepared.rightAlignPageNumbers } : {}
				})(props);
			},
			setTableOfContentsInstructionById: (options) => ({ tr, dispatch, state }) => {
				const { sdBlockId, instruction, content, rightAlignPageNumbers } = options;
				let found = false;
				state.doc.descendants((node, pos) => {
					if (found) return false;
					if (node.type.name === "tableOfContents" && node.attrs.sdBlockId === sdBlockId) {
						if (dispatch) {
							const nextAttrs = {
								...node.attrs,
								instruction
							};
							if (rightAlignPageNumbers !== void 0) nextAttrs.rightAlignPageNumbers = rightAlignPageNumbers;
							tr.setNodeMarkup(pos, void 0, nextAttrs);
							const fragment = normalizeTocContent(content, state.schema);
							if (fragment) {
								const from$1 = pos + 1;
								const to = pos + node.nodeSize - 1;
								tr.replaceWith(from$1, to, fragment);
							}
						}
						found = true;
						return false;
					}
					return true;
				});
				return found;
			},
			replaceTableOfContentsContentById: (options) => ({ tr, dispatch, state }) => {
				const { sdBlockId, content } = options;
				let found = false;
				state.doc.descendants((node, pos) => {
					if (found) return false;
					if (node.type.name === "tableOfContents" && node.attrs.sdBlockId === sdBlockId) {
						if (dispatch) {
							const from$1 = pos + 1;
							const to = pos + node.nodeSize - 1;
							const fragment = normalizeTocContent(content, state.schema) ?? [];
							tr.replaceWith(from$1, to, fragment);
						}
						found = true;
						return false;
					}
					return true;
				});
				return found;
			},
			deleteTableOfContentsById: (options) => ({ tr, dispatch, state }) => {
				const { sdBlockId } = options;
				let found = false;
				state.doc.descendants((node, pos) => {
					if (found) return false;
					if (node.type.name === "tableOfContents" && node.attrs.sdBlockId === sdBlockId) {
						if (dispatch) tr.delete(pos, pos + node.nodeSize);
						found = true;
						return false;
					}
					return true;
				});
				return found;
			}
		};
	},
	addAttributes() {
		return {
			instruction: {
				default: null,
				rendered: false
			},
			sdBlockId: {
				default: null,
				keepOnSplit: false,
				parseDOM: (elem) => elem.getAttribute("data-sd-block-id"),
				renderDOM: (attrs) => {
					return attrs.sdBlockId ? { "data-sd-block-id": attrs.sdBlockId } : {};
				}
			},
			rightAlignPageNumbers: {
				default: true,
				rendered: false
			}
		};
	}
});
const TocPageNumber = Mark.create({
	name: "tocPageNumber",
	inclusive: false,
	spanning: false,
	addOptions() {
		return { htmlAttributes: {} };
	},
	parseDOM() {
		return [{ tag: "span[data-toc-page-number]" }];
	},
	renderDOM() {
		return [
			"span",
			{ "data-toc-page-number": "" },
			0
		];
	}
});
const DocumentIndex = Node$1.create({
	name: "index",
	group: "block",
	content: "paragraph+",
	inline: false,
	addOptions() {
		return { htmlAttributes: {
			"data-id": "document-index",
			"aria-label": "Index"
		} };
	},
	parseDOM() {
		return [{ tag: "div[data-id=\"document-index\"]" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"div",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	},
	addAttributes() {
		return {
			instruction: {
				default: null,
				rendered: false
			},
			instructionTokens: {
				default: null,
				rendered: false
			},
			sdBlockId: {
				default: null,
				keepOnSplit: false,
				parseDOM: (elem) => elem.getAttribute("data-sd-block-id"),
				renderDOM: (attrs) => {
					return attrs.sdBlockId ? { "data-sd-block-id": attrs.sdBlockId } : {};
				}
			},
			wrapperParagraphProperties: {
				default: null,
				rendered: false
			}
		};
	}
});
init_dist();
var _ = {
	accentBorderCallout1: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M -8.333 0 Z L -8.333 100",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M -8.333 18.75 L -38.333 112.5",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	accentBorderCallout2: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M -8.333 0 Z L -8.333 100",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M -8.333 18.75 L -16.667 18.75 L -46.667 112.5",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	accentBorderCallout3: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M -8.333 0 Z L -8.333 100",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M -8.333 18.75 L -16.667 18.75 L -16.667 100 L -8.333 112.963",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	accentCallout1: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M -8.333 0 Z L -8.333 100",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M -8.333 18.75 L -38.333 112.5",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	accentCallout2: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M -8.333 0 Z L -8.333 100",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M -8.333 18.75 L -16.667 18.75 L -46.667 112.5",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	accentCallout3: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M -8.333 0 Z L -8.333 100",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M -8.333 18.75 L -16.667 18.75 L -16.667 100 L -8.333 112.963",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	actionButtonBackPrevious: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z M 12.5 50 L 87.5 12.5 L 87.5 87.5 Z",
				fill: "#000000",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 12.5 50 L 87.5 12.5 L 87.5 87.5 Z",
				fill: "color-mix(in srgb, currentColor 60%, black)",
				stroke: "none"
			},
			{
				d: "M 12.5 50 L 87.5 12.5 L 87.5 87.5 Z",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	actionButtonBeginning: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z M 31.25 50 L 87.5 12.5 L 87.5 87.5 Z M 21.875 12.5 L 12.5 12.5 L 12.5 87.5 L 21.875 87.5 Z",
				fill: "#000000",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 31.25 50 L 87.5 12.5 L 87.5 87.5 Z M 21.875 12.5 L 12.5 12.5 L 12.5 87.5 L 21.875 87.5 Z",
				fill: "color-mix(in srgb, currentColor 60%, black)",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 31.25 50 L 87.5 12.5 L 87.5 87.5 Z M 21.875 12.5 L 21.875 87.5 L 12.5 87.5 L 12.5 12.5 Z",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	actionButtonBlank: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	actionButtonDocument: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z M 21.875 12.5 L 59.375 12.5 L 78.125 31.25 L 78.125 87.5 L 21.875 87.5 Z",
				fill: "#000000",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 21.875 12.5 L 59.375 12.5 L 59.375 31.25 L 78.125 31.25 L 78.125 87.5 L 21.875 87.5 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none"
			},
			{
				d: "M 59.375 12.5 L 59.375 31.25 L 78.125 31.25 Z",
				fill: "color-mix(in srgb, currentColor 60%, black)",
				stroke: "none"
			},
			{
				d: "M 21.875 12.5 L 59.375 12.5 L 78.125 31.25 L 78.125 87.5 L 21.875 87.5 Z M 78.125 31.25 L 59.375 31.25 L 59.375 12.5",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	actionButtonEnd: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z M 68.75 50 L 12.5 12.5 L 12.5 87.5 Z M 78.125 12.5 L 87.5 12.5 L 87.5 87.5 L 78.125 87.5 Z",
				fill: "#000000",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 68.75 50 L 12.5 12.5 L 12.5 87.5 Z M 78.125 12.5 L 87.5 12.5 L 87.5 87.5 L 78.125 87.5 Z",
				fill: "color-mix(in srgb, currentColor 60%, black)",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 68.75 50 L 12.5 87.5 L 12.5 12.5 Z M 78.125 12.5 L 87.5 12.5 L 87.5 87.5 L 78.125 87.5 Z",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	actionButtonForwardNext: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z M 87.5 50 L 12.5 12.5 L 12.5 87.5 Z",
				fill: "#000000",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 87.5 50 L 12.5 12.5 L 12.5 87.5 Z",
				fill: "color-mix(in srgb, currentColor 60%, black)",
				stroke: "none"
			},
			{
				d: "M 87.5 50 L 12.5 87.5 L 12.5 12.5 Z",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	actionButtonHelp: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z M 28.571428571428573 33.92857142857143 A 21.428571428571427 21.428571428571427 0 0 1 71.42857142857143 33.92857142857142 A 10.714285714285714 16.071428571428573 0 0 1 60.714285714285715 50 A 5.357142857142857 8.035714285714286 0 0 0 55.35714285714286 58.035714285714285 L 55.357142857142854 68.75 L 44.642857142857146 68.75 L 44.642857142857146 58.035714285714285 A 10.714285714285714 16.071428571428573 0 0 1 55.35714285714286 41.96428571428571 A 5.357142857142857 8.035714285714286 0 0 0 60.714285714285715 33.92857142857142 A 10.714285714285714 10.714285714285714 0 0 0 39.285714285714285 33.92857142857142 Z M 50 71.42857142857143 A 8.035714285714286 8.035714285714286 0 0 1 50 87.50000000000001 A 8.035714285714286 8.035714285714286 0 0 1 50 71.42857142857143 Z",
				fill: "#000000",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 28.571428571428573 33.92857142857143 A 21.428571428571427 21.428571428571427 0 0 1 71.42857142857143 33.92857142857142 A 10.714285714285714 16.071428571428573 0 0 1 60.714285714285715 50 A 5.357142857142857 8.035714285714286 0 0 0 55.35714285714286 58.035714285714285 L 55.357142857142854 68.75 L 44.642857142857146 68.75 L 44.642857142857146 58.035714285714285 A 10.714285714285714 16.071428571428573 0 0 1 55.35714285714286 41.96428571428571 A 5.357142857142857 8.035714285714286 0 0 0 60.714285714285715 33.92857142857142 A 10.714285714285714 10.714285714285714 0 0 0 39.285714285714285 33.92857142857142 Z M 50 71.42857142857143 A 8.035714285714286 8.035714285714286 0 0 1 50 87.50000000000001 A 8.035714285714286 8.035714285714286 0 0 1 50 71.42857142857143 Z",
				fill: "color-mix(in srgb, currentColor 60%, black)",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 28.571428571428573 33.92857142857143 A 21.428571428571427 21.428571428571427 0 0 1 71.42857142857143 33.92857142857142 A 10.714285714285714 16.071428571428573 0 0 1 60.714285714285715 50 A 5.357142857142857 8.035714285714286 0 0 0 55.35714285714286 58.035714285714285 L 55.357142857142854 68.75 L 44.642857142857146 68.75 L 44.642857142857146 58.035714285714285 A 10.714285714285714 16.071428571428573 0 0 1 55.35714285714286 41.96428571428571 A 5.357142857142857 8.035714285714286 0 0 0 60.714285714285715 33.92857142857142 A 10.714285714285714 10.714285714285714 0 0 0 39.285714285714285 33.92857142857142 Z M 50 71.42857142857143 A 8.035714285714286 8.035714285714286 0 0 1 50 87.50000000000001 A 8.035714285714286 8.035714285714286 0 0 1 50 71.42857142857143 Z",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	actionButtonHome: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z M 50 12.5 L 12.5 50 L 21.875 50 L 21.875 87.5 L 78.125 87.5 L 78.125 50 L 87.5 50 L 73.4375 35.9375 L 73.4375 17.1875 L 64.0625 17.1875 L 64.0625 26.5625 Z",
				fill: "#000000",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 73.4375 35.9375 L 73.4375 17.1875 L 64.0625 17.1875 L 64.0625 26.5625 Z M 21.875 50 L 21.875 87.5 L 45.3125 87.5 L 45.3125 68.75 L 54.6875 68.75 L 54.6875 87.5 L 78.125 87.5 L 78.125 50 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 50 12.5 L 12.5 50 L 87.5 50 Z M 45.3125 68.75 L 54.6875 68.75 L 54.6875 87.5 L 45.3125 87.5 Z",
				fill: "color-mix(in srgb, currentColor 60%, black)",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 50 12.5 L 64.0625 26.5625 L 64.0625 17.1875 L 73.4375 17.1875 L 73.4375 35.9375 L 87.5 50 L 78.125 50 L 78.125 87.5 L 21.875 87.5 L 21.875 50 L 12.5 50 Z M 64.0625 26.5625 L 73.4375 35.9375 M 78.125 50 L 21.875 50 M 45.3125 87.5 L 45.3125 68.75 L 54.6875 68.75 L 54.6875 87.5",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	actionButtonInformation: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z M 50 12.5 A 37.5 37.5 0 0 1 50.00000000000002 87.5 A 37.5 37.5 0 0 1 49.99999999999999 12.5 Z",
				fill: "#000000",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 50 12.5 A 37.5 37.5 0 0 1 50.00000000000002 87.5 A 37.5 37.5 0 0 1 49.99999999999999 12.5 Z M 50 14.84375 A 7.03125 7.03125 0 0 1 50 28.90625 A 7.03125 7.03125 0 0 1 50 14.84375 M 35.9375 35.9375 L 35.9375 40.625 L 42.96875 40.625 L 42.96875 73.4375 L 35.9375 73.4375 L 35.9375 78.125 L 64.0625 78.125 L 64.0625 73.4375 L 57.03125 73.4375 L 57.03125 35.9375 Z",
				fill: "color-mix(in srgb, currentColor 60%, black)",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 50 14.84375 A 7.03125 7.03125 0 0 1 50 28.90625 A 7.03125 7.03125 0 0 1 50 14.84375 M 35.9375 35.9375 L 57.03125 35.9375 L 57.03125 73.4375 L 64.0625 73.4375 L 64.0625 78.125 L 35.9375 78.125 L 35.9375 73.4375 L 42.96875 73.4375 L 42.96875 40.625 L 35.9375 40.625 Z",
				fill: "color-mix(in srgb, currentColor 60%, white)",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 50 12.5 A 37.5 37.5 0 0 1 50.00000000000002 87.5 A 37.5 37.5 0 0 1 49.99999999999999 12.5 Z M 50 14.84375 A 7.03125 7.03125 0 0 1 50 28.90625 A 7.03125 7.03125 0 0 1 50 14.84375 M 35.9375 35.9375 L 57.03125 35.9375 L 57.03125 73.4375 L 64.0625 73.4375 L 64.0625 78.125 L 35.9375 78.125 L 35.9375 73.4375 L 42.96875 73.4375 L 42.96875 40.625 L 35.9375 40.625 Z",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	actionButtonMovie: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z M 12.5 30.833333333333332 L 12.5 45.677083333333336 L 17.552083333333332 45.677083333333336 L 19.114583333333332 43.982638888888886 L 20.572916666666664 43.982638888888886 L 20.572916666666664 66.63888888888889 L 71.5625 66.63888888888889 L 71.5625 58.826388888888886 L 79.63541666666667 58.826388888888886 L 84.01041666666667 63.125 L 87.5 63.125 L 87.5 35.52083333333333 L 84.01041666666667 35.52083333333333 L 80.98958333333333 38.513888888888886 L 71.5625 38.513888888888886 L 71.5625 35.52083333333333 L 68.59375 32.39583333333333 L 19.114583333333332 32.39583333333333 L 17.552083333333332 30.833333333333332 Z",
				fill: "#000000",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 12.5 30.833333333333332 L 12.5 45.677083333333336 L 17.552083333333332 45.677083333333336 L 19.114583333333332 43.982638888888886 L 20.572916666666664 43.982638888888886 L 20.572916666666664 66.63888888888889 L 71.5625 66.63888888888889 L 71.5625 58.826388888888886 L 79.63541666666667 58.826388888888886 L 84.01041666666667 63.125 L 87.5 63.125 L 87.5 35.52083333333333 L 84.01041666666667 35.52083333333333 L 80.98958333333333 38.513888888888886 L 71.5625 38.513888888888886 L 71.5625 35.52083333333333 L 68.59375 32.39583333333333 L 19.114583333333332 32.39583333333333 L 17.552083333333332 30.833333333333332 Z",
				fill: "color-mix(in srgb, currentColor 60%, black)",
				stroke: "none"
			},
			{
				d: "M 12.5 30.833333333333332 L 17.552083333333332 30.833333333333332 L 19.114583333333332 32.39583333333333 L 68.59375 32.39583333333333 L 71.5625 35.52083333333333 L 71.5625 38.513888888888886 L 80.98958333333333 38.513888888888886 L 84.01041666666667 35.52083333333333 L 87.5 35.52083333333333 L 87.5 63.125 L 84.01041666666667 63.125 L 79.63541666666667 58.826388888888886 L 71.5625 58.826388888888886 L 71.5625 66.63888888888889 L 20.572916666666664 66.63888888888889 L 20.572916666666664 43.982638888888886 L 19.114583333333332 43.982638888888886 L 17.552083333333332 45.677083333333336 L 12.5 45.677083333333336 Z",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	actionButtonReturn: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z M 87.5 31.25 L 68.75 12.5 L 50 31.25 L 59.375 31.25 L 59.375 59.375 A 9.375 9.375 0 0 1 50 68.75 L 40.625 68.75 A 9.375 9.375 0 0 1 31.25 59.375 L 31.25 31.25 L 12.5 31.25 L 12.5 59.375 A 28.125 28.125 0 0 0 40.625 87.5 L 50 87.5 A 28.125 28.125 0 0 0 78.125 59.375 L 78.125 31.25 Z",
				fill: "#000000",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 87.5 31.25 L 68.75 12.5 L 50 31.25 L 59.375 31.25 L 59.375 59.375 A 9.375 9.375 0 0 1 50 68.75 L 40.625 68.75 A 9.375 9.375 0 0 1 31.25 59.375 L 31.25 31.25 L 12.5 31.25 L 12.5 59.375 A 28.125 28.125 0 0 0 40.625 87.5 L 50 87.5 A 28.125 28.125 0 0 0 78.125 59.375 L 78.125 31.25 Z",
				fill: "color-mix(in srgb, currentColor 60%, black)",
				stroke: "none"
			},
			{
				d: "M 87.5 31.25 L 78.125 31.25 L 78.125 59.375 A 28.125 28.125 0 0 1 50 87.5 L 40.625 87.5 A 28.125 28.125 0 0 1 12.5 59.375 L 12.5 31.25 L 31.25 31.25 L 31.25 59.375 A 9.375 9.375 0 0 0 40.625 68.75 L 50 68.75 A 9.375 9.375 0 0 0 59.375 59.375 L 59.375 31.25 L 50 31.25 L 68.75 12.5 Z",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	actionButtonSound: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z M 12.5 35.9375 L 12.5 64.0625 L 35.9375 64.0625 L 59.375 87.5 L 59.375 12.5 L 35.9375 35.9375 Z",
				fill: "#000000",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 12.5 35.9375 L 12.5 64.0625 L 35.9375 64.0625 L 59.375 87.5 L 59.375 12.5 L 35.9375 35.9375 Z",
				fill: "color-mix(in srgb, currentColor 60%, black)",
				stroke: "none"
			},
			{
				d: "M 12.5 35.9375 L 35.9375 35.9375 L 59.375 12.5 L 59.375 87.5 L 35.9375 64.0625 L 12.5 64.0625 Z M 68.75 35.9375 L 87.5 21.875 M 68.75 50 L 87.5 50 M 68.75 64.0625 L 87.5 78.125",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	arc: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 49.99999999999999 0 A 50 50 0 0 1 100 49.999999999999986",
			fill: "none",
			stroke: "#000000"
		}]
	},
	bentArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 100 L 0 56.25 A 43.75 43.75 0 0 1 43.74999999999999 12.499999999999993 L 75 12.5 L 75 0 L 100 25 L 75 50 L 75 37.5 L 43.75 37.5 A 18.75 18.75 0 0 0 25 56.25 L 25 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	bentConnector2: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 100 100",
			fill: "none",
			stroke: "#000000"
		}]
	},
	bentConnector3: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 50 0 L 50 100 L 100 100",
			fill: "none",
			stroke: "#000000"
		}]
	},
	bentConnector4: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 50 0 L 50 50 L 100 50 L 100 100",
			fill: "none",
			stroke: "#000000"
		}]
	},
	bentConnector5: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 50 0 L 50 50 L 50 50 L 50 100 L 100 100",
			fill: "none",
			stroke: "#000000"
		}]
	},
	bentUpArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 75 L 62.5 75 L 62.5 25 L 50 25 L 75 0 L 100 25 L 87.5 25 L 87.5 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	bevel: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 12.5 12.5 L 87.5 12.5 L 87.5 87.5 L 12.5 87.5 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 0 0 L 100 0 L 87.5 12.5 L 12.5 12.5 Z",
				fill: "color-mix(in srgb, currentColor 80%, white)",
				stroke: "none"
			},
			{
				d: "M 0 100 L 12.5 87.5 L 87.5 87.5 L 100 100 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none"
			},
			{
				d: "M 0 0 L 12.5 12.5 L 12.5 87.5 L 0 100 Z",
				fill: "color-mix(in srgb, currentColor 60%, white)",
				stroke: "none"
			},
			{
				d: "M 100 0 L 100 100 L 87.5 87.5 L 87.5 12.5 Z",
				fill: "color-mix(in srgb, currentColor 60%, black)",
				stroke: "none"
			},
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z M 12.5 12.5 L 87.5 12.5 L 87.5 87.5 L 12.5 87.5 Z M 0 0 L 12.5 12.5 M 0 100 L 12.5 87.5 M 100 0 L 87.5 12.5 M 100 100 L 87.5 87.5",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	blockArc: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50.00000000000001 A 50 50 0 0 1 100 49.999999999999986 L 75 50 A 25 25 0 0 0 25 50 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	borderCallout1: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}, {
			d: "M -8.333 18.75 L -38.333 112.5",
			fill: "none",
			stroke: "#000000"
		}]
	},
	borderCallout2: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}, {
			d: "M -8.333 18.75 L -16.667 18.75 L -46.667 112.5",
			fill: "none",
			stroke: "#000000"
		}]
	},
	borderCallout3: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}, {
			d: "M -8.333 18.75 L -16.667 18.75 L -16.667 100 L -8.333 112.963",
			fill: "none",
			stroke: "#000000"
		}]
	},
	bracePair: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 16.666 100 A 8.333 8.333 0 0 1 8.333 91.667 L 8.333 58.333 A 8.333 8.333 0 0 0 5.102490888647448e-16 50 A 8.333 8.333 0 0 0 8.333 41.667 L 8.333 8.333 A 8.333 8.333 0 0 1 16.666 -1.7763568394002505e-15 L 83.334 0 A 8.333 8.333 0 0 1 91.667 8.332999999999998 L 91.667 41.667 A 8.333 8.333 0 0 0 100 50 A 8.333 8.333 0 0 0 91.667 58.333 L 91.667 91.667 A 8.333 8.333 0 0 1 83.334 100 Z",
			fill: "#000000",
			stroke: "none"
		}, {
			d: "M 16.666 100 A 8.333 8.333 0 0 1 8.333 91.667 L 8.333 58.333 A 8.333 8.333 0 0 0 5.102490888647448e-16 50 A 8.333 8.333 0 0 0 8.333 41.667 L 8.333 8.333 A 8.333 8.333 0 0 1 16.666 -1.7763568394002505e-15 M 83.334 0 A 8.333 8.333 0 0 1 91.667 8.332999999999998 L 91.667 41.667 A 8.333 8.333 0 0 0 100 50 A 8.333 8.333 0 0 0 91.667 58.333 L 91.667 91.667 A 8.333 8.333 0 0 1 83.334 100",
			fill: "none",
			stroke: "#000000"
		}]
	},
	bracketPair: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 16.667 A 16.667 16.667 0 0 1 16.666999999999998 -3.552713678800501e-15 L 83.333 0 A 16.667 16.667 0 0 1 100 16.666999999999998 L 100 83.333 A 16.667 16.667 0 0 1 83.333 100 L 16.667 100 A 16.667 16.667 0 0 1 0 83.333 Z",
			fill: "#000000",
			stroke: "none"
		}, {
			d: "M 16.667 100 A 16.667 16.667 0 0 1 0 83.333 L 0 16.667 A 16.667 16.667 0 0 1 16.666999999999998 -3.552713678800501e-15 M 83.333 0 A 16.667 16.667 0 0 1 100 16.666999999999998 L 100 83.333 A 16.667 16.667 0 0 1 83.333 100",
			fill: "none",
			stroke: "#000000"
		}]
	},
	callout1: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
			fill: "#000000",
			stroke: "none"
		}, {
			d: "M -8.333 18.75 L -38.333 112.5",
			fill: "none",
			stroke: "#000000"
		}]
	},
	callout2: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
			fill: "#000000",
			stroke: "none"
		}, {
			d: "M -8.333 18.75 L -16.667 18.75 L -46.667 112.5",
			fill: "none",
			stroke: "#000000"
		}]
	},
	callout3: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
			fill: "#000000",
			stroke: "none"
		}, {
			d: "M -8.333 18.75 L -16.667 18.75 L -16.667 100 L -8.333 112.963",
			fill: "none",
			stroke: "#000000"
		}]
	},
	can: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 12.5 A 50 12.5 0 0 0 100 12.499999999999998 L 100 87.5 A 50 12.5 0 0 1 0 87.5 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 0 12.5 A 50 12.5 0 0 1 100 12.499999999999995 A 50 12.5 0 0 1 0 12.499999999999996 Z",
				fill: "color-mix(in srgb, currentColor 60%, white)",
				stroke: "none"
			},
			{
				d: "M 100 12.5 A 50 12.5 0 0 1 0 12.500000000000002 A 50 12.5 0 0 1 100 12.499999999999996 L 100 87.5 A 50 12.5 0 0 1 0 87.5 L 0 12.5",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	chartPlus: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 50 0 L 50 100 M 0 50 L 100 50",
			fill: "none",
			stroke: "#000000"
		}, {
			d: "M 0 0 L 0 100 L 100 100 L 100 0 Z",
			fill: "#000000",
			stroke: "none"
		}]
	},
	chartStar: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 100 M 0 100 L 100 0 M 50 0 L 50 100",
			fill: "none",
			stroke: "#000000"
		}, {
			d: "M 0 0 L 0 100 L 100 100 L 100 0 Z",
			fill: "#000000",
			stroke: "none"
		}]
	},
	chartX: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 100 M 0 100 L 100 0",
			fill: "none",
			stroke: "#000000"
		}, {
			d: "M 0 0 L 0 100 L 100 100 L 100 0 Z",
			fill: "#000000",
			stroke: "none"
		}]
	},
	chevron: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 50 0 L 100 50 L 50 100 L 0 100 L 50 50 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	chord: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 85.35533905932738 85.35533905932738 A 50 50 0 0 1 3.806023374435661 69.1341716182545 A 50 50 0 0 1 49.99999999999999 7.105427357601002e-15 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	circularArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 6.25 50.00000000000001 A 43.75 43.75 0 0 1 92.00503607239835 37.76727975646819 L 97.94870282721459 37.767278803641936 L 87.5 49.99999999999999 L 72.94870282721459 37.767278803641936 L 78.75626944045719 37.767278803641936 A 31.25 31.25 0 0 0 18.74999910786014 49.999997902787435 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	cloud: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 9.027777777777777 33.263888888888886 A 15.631944444444443 21.273148148148145 0 0 1 30.57998957216487 9.85246862529543 A 12.344907407407407 16.82175925925926 0 0 1 47.80891412463702 6.079559020422696 A 10.104166666666666 13.761574074074073 0 0 1 63.17482489729218 3.8997359934452227 A 11.243055555555555 15.266203703703702 0 0 1 81.4699864255032 11.79662680033136 A 12.344907407407407 16.83564814814815 0 0 1 89.70950362413667 36.805045586854234 A 15.68287037037037 21.34259259259259 0 0 1 80.50683519493268 73.45235178627696 A 13.391203703703702 18.21064814814815 0 0 1 61.5295304537904 89.80375312777574 A 15.629629629629628 21.33101851851852 0 0 1 35.53836349121606 96.03429219674027 A 17.87037037037037 24.40509259259259 0 0 1 14.265888824303735 88.73812262075411 A 10.092592592592592 13.699074074074073 0 0 1 7.154178969814962 64.32542955825295 A 10.05787037037037 13.761574074074073 0 0 1 10.355981204179617 37.95132232917963 Z",
			fill: "#000000",
			stroke: "#000000"
		}, {
			d: "M 10.863425925925926 60.594907407407405 A 10.05787037037037 13.761574074074073 0 0 1 6.3341973784947445 59.507019673542544 M 16.037037037037035 80.78472222222221 A 10.092592592592592 13.699074074074073 0 0 1 14.058709360103522 81.29044790335425 M 38.14351851851852 90.4861111111111 A 15.629629629629628 21.33101851851852 0 0 1 35.927529327520006 86.22025847613271 M 66.72916666666666 80.44212962962962 A 15.629629629629628 21.33101851851852 0 0 1 65.64350914942649 86.19106007926317 M 79.00231481481481 53.13425925925926 A 13.391203703703702 18.21064814814815 0 0 1 87.87692721942935 70.4768770248552 M 96.75462962962962 35.541666666666664 A 12.344907407407407 16.83564814814815 0 0 1 92.62714666279902 41.3312984002895 M 88.71296296296296 12.560185185185185 A 11.243055555555555 15.266203703703702 0 0 1 89.03277422425806 16.48423239319878 M 67.31018518518518 9.148148148148147 A 11.243055555555555 15.266203703703702 0 0 1 69.59160776727714 5.445361345350392 M 51.25231481481481 10.925925925925926 A 10.104166666666666 13.761574074074073 0 0 1 52.582357388029564 7.102165159074247 M 32.407407407407405 12.018518518518517 A 15.631944444444443 21.273148148148145 0 0 1 35.32846815343311 14.263252515392796 M 9.55324074074074 36.54861111111111 A 15.631944444444443 21.273148148148145 0 0 1 8.640529037810998 32.332858776375595",
			fill: "none",
			stroke: "#000000"
		}]
	},
	cloudCallout: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 9.027777777777777 33.263888888888886 A 15.631944444444443 21.273148148148145 0 0 1 30.57998957216487 9.85246862529543 A 12.344907407407407 16.82175925925926 0 0 1 47.80891412463702 6.079559020422696 A 10.104166666666666 13.761574074074073 0 0 1 63.17482489729218 3.8997359934452227 A 11.243055555555555 15.266203703703702 0 0 1 81.4699864255032 11.79662680033136 A 12.344907407407407 16.83564814814815 0 0 1 89.70950362413667 36.805045586854234 A 15.68287037037037 21.34259259259259 0 0 1 80.50683519493268 73.45235178627696 A 13.391203703703702 18.21064814814815 0 0 1 61.5295304537904 89.80375312777574 A 15.629629629629628 21.33101851851852 0 0 1 35.53836349121606 96.03429219674027 A 17.87037037037037 24.40509259259259 0 0 1 14.265888824303735 88.73812262075411 A 10.092592592592592 13.699074074074073 0 0 1 7.154178969814962 64.32542955825295 A 10.05787037037037 13.761574074074073 0 0 1 10.355981204179617 37.95132232917963 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M 31.94477777777778 112.5 A 2.7777777777777777 2.7777777777777777 0 0 1 26.389222222222223 112.5 A 2.7777777777777777 2.7777777777777777 0 0 1 31.94477777777778 112.5 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M 35.81090347544299 109.23490399880167 A 5.555555555555555 5.555555555555555 0 0 1 24.699792364331877 109.23490399880167 A 5.555555555555555 5.555555555555555 0 0 1 35.81090347544299 109.23490399880167 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M 41.43382479714197 100.69933679796284 A 8.333333333333334 8.333333333333334 0 0 1 24.767158130475302 100.69933679796284 A 8.333333333333334 8.333333333333334 0 0 1 41.43382479714197 100.69933679796284 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M 10.863425925925926 60.594907407407405 A 10.05787037037037 13.761574074074073 0 0 1 6.3341973784947445 59.507019673542544 M 16.037037037037035 80.78472222222221 A 10.092592592592592 13.699074074074073 0 0 1 14.058709360103522 81.29044790335425 M 38.14351851851852 90.4861111111111 A 15.629629629629628 21.33101851851852 0 0 1 35.927529327520006 86.22025847613271 M 66.72916666666666 80.44212962962962 A 15.629629629629628 21.33101851851852 0 0 1 65.64350914942649 86.19106007926317 M 79.00231481481481 53.13425925925926 A 13.391203703703702 18.21064814814815 0 0 1 87.87692721942935 70.4768770248552 M 96.75462962962962 35.541666666666664 A 12.344907407407407 16.83564814814815 0 0 1 92.62714666279902 41.3312984002895 M 88.71296296296296 12.560185185185185 A 11.243055555555555 15.266203703703702 0 0 1 89.03277422425806 16.48423239319878 M 67.31018518518518 9.148148148148147 A 11.243055555555555 15.266203703703702 0 0 1 69.59160776727714 5.445361345350392 M 51.25231481481481 10.925925925925926 A 10.104166666666666 13.761574074074073 0 0 1 52.582357388029564 7.102165159074247 M 32.407407407407405 12.018518518518517 A 15.631944444444443 21.273148148148145 0 0 1 35.32846815343311 14.263252515392796 M 9.55324074074074 36.54861111111111 A 15.631944444444443 21.273148148148145 0 0 1 8.640529037810998 32.332858776375595",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	corner: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 50 0 L 50 50 L 100 50 L 100 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	cornerTabs: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 7.0710678118654755 0 L 0 7.0710678118654755 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M 0 92.92893218813452 L 7.0710678118654755 100 L 0 100 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M 92.92893218813452 0 L 100 0 L 100 7.0710678118654755 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M 100 92.92893218813452 L 100 100 L 92.92893218813452 100 Z",
				fill: "#000000",
				stroke: "#000000"
			}
		]
	},
	cube: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 25 L 75 25 L 75 100 L 0 100 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 75 25 L 100 0 L 100 75 L 75 100 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none"
			},
			{
				d: "M 0 25 L 25 0 L 100 0 L 75 25 Z",
				fill: "color-mix(in srgb, currentColor 80%, white)",
				stroke: "none"
			},
			{
				d: "M 0 25 L 25 0 L 100 0 L 100 75 L 75 100 L 0 100 Z M 0 25 L 75 25 L 100 0 M 75 25 L 75 100",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	curvedConnector2: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 C 50 0 100 50 100 100",
			fill: "none",
			stroke: "#000000"
		}]
	},
	curvedConnector3: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 C 25 0 50 25 50 50 C 50 75 75 100 100 100",
			fill: "none",
			stroke: "#000000"
		}]
	},
	curvedConnector4: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 C 25 0 50 12.5 50 25 C 50 37.5 62.5 50 75 50 C 87.5 50 100 75 100 100",
			fill: "none",
			stroke: "#000000"
		}]
	},
	curvedConnector5: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 C 25 0 50 12.5 50 25 C 50 37.5 50 50 50 50 C 50 50 50 62.5 50 75 C 50 87.5 75 100 100 100",
			fill: "none",
			stroke: "#000000"
		}]
	},
	curvedDownArrow: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 75 100 L 49.00768239224544 75 L 61.50768239224544 75 A 31.25 100 0 0 0 37.416898858120966 38.6950051637524 L 56.25 0 A 31.25 100 0 0 1 80.34078353412448 36.304994836247616 L 99.00768239224544 75 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 43.75 8.348486100883193 A 31.25 100 0 0 0 16.722972521631938 107.43120402663949 L 0 100 A 31.25 100 0 0 1 35.47297252163195 0.9172820742437011 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none"
			},
			{
				d: "M 43.75 8.348486100883193 A 31.25 100 0 0 0 16.722972521631938 107.43120402663949 L 0 100 A 31.25 100 0 0 1 31.249999999999993 -1.4210854715202004e-14 L 56.25 0 A 31.25 100 0 0 1 80.34078353412448 36.304994836247616 L 99.00768239224544 75 L 75 100 L 49.00768239224544 75 L 61.50768239224544 75 A 31.25 100 0 0 0 37.416898858120966 38.6950051637524",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	curvedLeftArrow: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 75 L 25 49.00768239224544 L 25 61.50768239224544 A 100 31.25 0 0 0 60.38771276200397 41.63987137975289 A 100 31.25 0 0 1 25.00000000000007 69.9536274355093 L 25 99.00768239224544 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 100 56.25 A 100 31.25 0 0 0 6.123233995736766e-15 25 L 0 0 A 100 31.25 0 0 1 100.00000000000001 31.249999999999993 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none"
			},
			{
				d: "M 100 56.25 A 100 31.25 0 0 0 6.123233995736766e-15 25 L 0 0 A 100 31.25 0 0 1 100.00000000000001 31.249999999999993 L 100 56.25 A 100 31.25 0 0 1 63.69500516375231 80.34078353412448 L 25 99.00768239224544 L 0 75 L 25 49.00768239224544 L 25 61.50768239224544 A 100 31.25 0 0 0 60.38771276200397 41.63987137975289",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	curvedRightArrow: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 31.25 A 100 31.25 0 0 0 36.30499483624771 55.34078353412449 L 75 49.00768239224544 L 100 75 L 75 99.00768239224544 L 75 86.50768239224544 A 100 31.25 0 0 1 38.695005163752285 62.41689885812095 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 100 25 A 100 31.25 0 0 0 0.9172820742437295 52.02702747836806 A 100 31.25 0 0 1 100 16.55405495673611 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none"
			},
			{
				d: "M 0 31.25 A 100 31.25 0 0 0 36.30499483624771 55.34078353412449 L 75 49.00768239224544 L 100 75 L 75 99.00768239224544 L 75 86.50768239224544 A 100 31.25 0 0 1 38.695005163752285 62.41689885812095 L 0 31.25 A 100 31.25 0 0 1 99.99999999999999 -3.552713678800501e-15 L 100 25 A 100 31.25 0 0 0 0.9172820742437295 52.02702747836806",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	curvedUpArrow: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 75 0 L 99.00768239224544 25 L 86.50768239224544 25 A 31.25 100 0 0 1 58.19392633648901 60.38771276200398 A 31.25 100 0 0 0 78.06173734898155 25 L 49.00768239224544 25 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 31.25 100 A 31.25 100 0 0 1 -3.552713678800501e-15 1.2246467991473532e-14 L 25 0 A 31.25 100 0 0 0 56.25 99.99999999999999 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none"
			},
			{
				d: "M 43.75 91.65151389911681 A 31.25 100 0 0 0 63.61781101249255 56.26380113711283 L 49.00768239224544 25 L 75 0 L 99.00768239224544 25 L 86.50768239224544 25 A 31.25 100 0 0 1 62.41689885812095 61.304994836247694 L 31.25 100 A 31.25 100 0 0 1 -3.552713678800501e-15 1.2246467991473532e-14 L 25 0 A 31.25 100 0 0 0 56.25 99.99999999999999",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	decagon: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 9.54915028125263 19.09836593122781 L 34.54915028125263 0.00010576881489043899 L 65.45084971874738 0.00010576881489043899 L 90.45084971874738 19.09836593122781 L 100 50 L 90.45084971874738 80.90163406877218 L 65.45084971874738 99.99989423118511 L 34.54915028125263 99.99989423118511 L 9.54915028125263 80.90163406877218 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	diagStripe: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 50 0 L 100 0 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	diamond: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 50 0 L 100 50 L 50 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	dodecagon: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 36.601851851851855 L 13.398148148148149 13.398148148148149 L 36.601851851851855 0 L 63.398148148148145 0 L 86.60185185185185 13.398148148148149 L 100 36.601851851851855 L 100 63.398148148148145 L 86.60185185185185 86.60185185185185 L 63.398148148148145 100 L 36.601851851851855 100 L 13.398148148148149 86.60185185185185 L 0 63.398148148148145 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	donut: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z M 25 50 A 25 25 0 0 0 50 75 A 25 25 0 0 0 75 50 A 25 25 0 0 0 50 25 A 25 25 0 0 0 25.000000000000007 50 Z",
			fill: "#000000",
			stroke: "#000000",
			fillRule: "evenodd",
			clipRule: "evenodd"
		}]
	},
	doubleWave: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 6.25 C 16.666666666666668 -14.583333333333332 33.333333333333336 27.083333333333332 50 6.25 C 66.66666666666667 -14.583333333333332 83.33333333333334 27.083333333333332 100 6.25 L 100 93.75 C 83.33333333333334 114.58333333333333 66.66666666666667 72.91666666666667 50 93.75 C 33.333333333333336 114.58333333333333 16.666666666666668 72.91666666666667 0 93.75 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	downArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 25 50 L 25 0 L 75 0 L 75 50 L 100 50 L 50 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	downArrowCallout: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 100 64.977 L 62.5 64.977 L 62.5 75 L 75 75 L 50 100 L 25 75 L 37.5 75 L 37.5 64.977 L 0 64.977 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	ellipse: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	ellipseRibbon: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 Q 18.75 9.375 37.5 11.71875 L 25 21.875 Q 50 28.125 75 21.875 L 62.5 11.71875 Q 81.25 9.375 100 0 L 87.5 42.96875 L 100 75 Q 87.5 81.25 75 84.375 L 75 96.875 Q 50 103.125 25 96.875 L 25 84.375 Q 12.5 81.25 0 75 L 12.5 42.96875 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 37.5 24.21875 L 37.5 11.71875 L 25 21.875 Q 50 28.125 75 21.875 L 62.5 11.71875 L 62.5 24.21875 Q 50 25.78125 37.5 24.21875 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none"
			},
			{
				d: "M 0 0 Q 18.75 9.375 37.5 11.71875 L 25 21.875 Q 50 28.125 75 21.875 L 62.5 11.71875 Q 81.25 9.375 100 0 L 87.5 42.96875 L 100 75 Q 87.5 81.25 75 84.375 L 75 96.875 Q 50 103.125 25 96.875 L 25 84.375 Q 12.5 81.25 0 75 L 12.5 42.96875 Z M 25 84.375 L 25 21.875 M 75 21.875 L 75 84.375 M 37.5 11.71875 L 37.5 24.21875 M 62.5 24.21875 L 62.5 11.71875",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	ellipseRibbon2: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 100 Q 18.75 90.625 37.5 88.28125 L 25 78.125 Q 50 71.875 75 78.125 L 62.5 88.28125 Q 81.25 90.625 100 100 L 87.5 57.03125 L 100 25 Q 87.5 18.75 75 15.625 L 75 3.125 Q 50 -3.125 25 3.125 L 25 15.625 Q 12.5 18.75 0 25 L 12.5 57.03125 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 37.5 75.78125 L 37.5 88.28125 L 25 78.125 Q 50 71.875 75 78.125 L 62.5 88.28125 L 62.5 75.78125 Q 50 74.21875 37.5 75.78125 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none"
			},
			{
				d: "M 0 100 L 12.5 57.03125 L 0 25 Q 12.5 18.75 25 15.625 L 25 3.125 Q 50 -3.125 75 3.125 L 75 15.625 Q 87.5 18.75 100 25 L 87.5 57.03125 L 100 100 Q 81.25 90.625 62.5 88.28125 L 75 78.125 Q 50 71.875 25 78.125 L 37.5 88.28125 Q 18.75 90.625 0 100 Z M 25 78.125 L 25 15.625 M 75 15.625 L 75 78.125 M 37.5 75.78125 L 37.5 88.28125 M 62.5 88.28125 L 62.5 75.78125",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	flowChartAlternateProcess: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 A 0 0 0 0 1 0 0 L 100 0 A 0 0 0 0 1 100 0 L 100 100 A 0 0 0 0 1 100 100 L 0 100 A 0 0 0 0 1 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartCollate: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 50 50 L 100 100 L 0 100 L 50 50 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartConnector: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartDecision: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 50 0 L 100 50 L 50 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartDelay: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 50 0 A 50 50 0 0 1 50.00000000000002 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartDisplay: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 16.666666666666668 0 L 83.33333333333334 0 A 16.666666666666668 50 0 0 1 83.33333333333334 100 L 16.666666666666668 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartDocument: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 100 80.19444444444444 C 50 80.19444444444444 50 110.75 0 93.38888888888889 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartExtract: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 100 L 50 0 L 100 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartInputOutput: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 100 L 20 0 L 100 0 L 80 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartInternalStorage: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 12.5 0 L 12.5 100 M 0 12.5 L 100 12.5",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	flowChartMagneticDisk: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 16.666666666666668 A 50 16.666666666666668 0 0 1 100 16.66666666666666 L 100 83.33333333333334 A 50 16.666666666666668 0 0 1 0 83.33333333333334 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 100 16.666666666666668 A 50 16.666666666666668 0 0 1 0 16.66666666666667",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 16.666666666666668 A 50 16.666666666666668 0 0 1 100 16.66666666666666 L 100 83.33333333333334 A 50 16.666666666666668 0 0 1 0 83.33333333333334 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	flowChartMagneticDrum: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 16.666666666666668 0 L 83.33333333333334 0 A 16.666666666666668 50 0 0 1 83.33333333333334 100 L 16.666666666666668 100 A 16.666666666666668 50 0 0 1 16.666666666666664 0 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 83.33333333333334 100 A 16.666666666666668 50 0 0 1 83.33333333333334 0",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 16.666666666666668 0 L 83.33333333333334 0 A 16.666666666666668 50 0 0 1 83.33333333333334 100 L 16.666666666666668 100 A 16.666666666666668 50 0 0 1 16.666666666666664 0 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	flowChartMagneticTape: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 50 100 A 50 50 0 0 1 0 50.00000000000001 A 50 50 0 0 1 49.99999999999999 0 A 50 50 0 0 1 100 49.999999999999986 A 50 50 0 0 1 85.35533905932738 85.35533905932735 L 100 85.35533905932738 L 100 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartManualInput: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 20 L 100 0 L 100 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartManualOperation: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 80 100 L 20 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartMerge: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 50 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartMultidocument: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 96.21296296296296 C 43.04629629629629 108.99074074074073 43.04629629629629 83.43518518518518 86.08796296296296 83.43518518518518 L 86.08796296296296 17.01388888888889 L 0 17.01388888888889 Z M 7.092592592592593 17.01388888888889 L 7.092592592592593 8.402777777777777 L 92.59259259259258 8.402777777777777 L 92.59259259259258 75.24074074074073 C 89.34259259259258 75.24074074074073 86.08796296296296 75.7037037037037 86.08796296296296 75.7037037037037 L 86.08796296296296 17.01388888888889 Z M 13.759259259259258 8.402777777777777 L 13.759259259259258 0 L 100 0 L 100 66.62962962962962 C 96.29629629629629 66.62962962962962 92.59259259259258 66.97685185185185 92.59259259259258 66.97685185185185 L 92.59259259259258 8.402777777777777 Z",
			fill: "#000000",
			stroke: "none",
			fillRule: "evenodd",
			clipRule: "evenodd"
		}, {
			d: "M 0 17.01388888888889 L 86.08796296296296 17.01388888888889 L 86.08796296296296 83.43518518518518 C 43.04629629629629 83.43518518518518 43.04629629629629 108.99074074074073 0 96.21296296296296 Z M 7.092592592592593 17.01388888888889 L 7.092592592592593 8.402777777777777 L 92.59259259259258 8.402777777777777 L 92.59259259259258 75.24074074074073 C 89.34259259259258 75.24074074074073 86.08796296296296 75.7037037037037 86.08796296296296 75.7037037037037 M 13.759259259259258 8.402777777777777 L 13.759259259259258 0 L 100 0 L 100 66.62962962962962 C 96.29629629629629 66.62962962962962 92.59259259259258 66.97685185185185 92.59259259259258 66.97685185185185",
			fill: "none",
			stroke: "#000000"
		}]
	},
	flowChartOfflineStorage: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 50 100 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 40 80 L 60 80",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 0 L 100 0 L 50 100 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	flowChartOffpageConnector: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 100 80 L 50 100 L 0 80 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartOnlineStorage: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 16.666666666666668 0 L 100 0 A 16.666666666666668 50 0 0 0 100 100 L 16.666666666666668 100 A 16.666666666666668 50 0 0 1 16.666666666666664 0 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartOr: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 50 0 L 50 100 M 0 50 L 100 50",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	flowChartPredefinedProcess: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 12.5 0 L 12.5 100 M 87.5 0 L 87.5 100",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	flowChartPreparation: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 20 0 L 80 0 L 100 50 L 80 100 L 20 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartProcess: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartPunchedCard: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 20 L 20 0 L 100 0 L 100 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartPunchedTape: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 10 A 25 10 0 0 0 50 9.999999999999998 A 25 10 0 0 1 100 9.999999999999995 L 100 90 A 25 10 0 0 0 50 90 A 25 10 0 0 1 0 90 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	flowChartSort: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 50 L 50 0 L 100 50 L 50 100 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 0 50 L 100 50",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 50 L 50 0 L 100 50 L 50 100 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	flowChartSummingJunction: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 14.644660940672622 14.64466094067263 L 85.35533905932738 85.35533905932738 M 85.35533905932738 14.64466094067263 L 14.644660940672622 85.35533905932738",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	flowChartTerminator: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 16.087962962962962 0 L 83.91203703703704 0 A 16.087962962962962 50 0 0 1 83.91203703703704 100 L 16.087962962962962 100 A 16.087962962962962 50 0 0 1 16.08796296296296 0 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	foldedCorner: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 100 0 L 100 83.333 L 83.333 100 L 0 100 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 83.333 100 L 86.6664 86.6664 L 100 83.333 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none"
			},
			{
				d: "M 83.333 100 L 86.6664 86.6664 L 100 83.333 L 83.333 100 L 0 100 L 0 0 L 100 0 L 100 83.333",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	frame: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 100 100 L 0 100 Z M 12.5 12.5 L 12.5 87.5 L 87.5 87.5 L 87.5 12.5 Z",
			fill: "#000000",
			stroke: "#000000",
			fillRule: "evenodd",
			clipRule: "evenodd"
		}]
	},
	funnel: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0.4865947579902823 28.47932110261916 A 50 25 0 0 1 50.363602241574895 1.7268853347203788 A 50 25 0 0 1 100.24060972515952 28.47932110261915 L 62.37835131050243 94.61983027565479 A 12.5 6.25 0 0 1 37.43984756871012 94.61983027565479 Z M 5 25 A 45 20 0 0 0 95 24.999999999999996 A 45 20 0 0 0 5 24.999999999999993 Z",
			fill: "#000000",
			stroke: "#000000",
			fillRule: "evenodd",
			clipRule: "evenodd"
		}]
	},
	gear6: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 74.82470053891974 25.327459734495154 L 89.57808159568633 20.881065308239084 L 95.0067779720481 30.283843250962747 L 83.77939691528152 40.83744882470668 A 35 35 0 0 1 83.77939691528152 59.16255117529331 L 95.0067779720481 69.71615674903725 L 89.57808159568633 79.11893469176091 L 74.82470053891974 74.67254026550485 A 35 35 0 0 1 58.954696376361774 83.83509144079817 L 55.42869637636177 98.83509144079817 L 44.57130362363823 98.83509144079817 L 41.045303623638226 83.83509144079817 A 35 35 0 0 1 25.175299461080265 74.67254026550485 L 10.421918404313672 79.11893469176091 L 4.9932220279519015 69.71615674903725 L 16.220603084718476 59.16255117529332 A 35 35 0 0 1 16.22060308471847 40.837448824706684 L 4.9932220279519015 30.283843250962747 L 10.421918404313672 20.881065308239084 L 25.175299461080257 25.327459734495154 A 35 35 0 0 1 41.04530362363821 16.16490855920184 L 44.57130362363823 1.1649085592018338 L 55.42869637636177 1.1649085592018338 L 58.954696376361774 16.164908559201834 A 35 35 0 0 1 74.82470053891973 25.327459734495143 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	gear9: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 70.98043216644243 15.943848336764354 L 78.75884461652657 9.416638461451942 L 84.97288812699333 14.630840079204173 L 79.89554838334669 23.424519066271323 A 40 40 0 0 1 87.96281579807138 37.3974361068193 L 98.11703506542025 37.397170398710514 L 99.52564437161423 45.38579074787268 L 89.98370857871895 48.85848859310251 A 40 40 0 0 1 87.18197600808145 64.74790358438975 L 94.96073004592583 71.27470637126171 L 90.90480119853021 78.2997812068352 L 81.36304716068582 74.82658399370717 A 40 40 0 0 1 69.00327641227653 85.19766307013315 L 70.76679975508767 95.19757079067537 L 63.14414693842693 97.97198952208531 L 58.06726741472468 89.17804482690939 A 40 40 0 0 1 41.93273258527532 89.17804482690939 L 36.85585306157307 97.97198952208531 L 29.233200244912325 95.19757079067537 L 30.996723587723466 85.19766307013313 A 40 40 0 0 1 18.636952839314183 74.82658399370717 L 9.095198801469792 78.2997812068352 L 5.039269954074172 71.27470637126171 L 12.818023991918551 64.74790358438975 A 40 40 0 0 1 10.016291421281053 48.85848859310253 L 0.4743556283857657 45.38579074787268 L 1.8829649345797463 37.397170398710514 L 12.037184201928625 37.39743610681929 A 40 40 0 0 1 20.104451616653293 23.42451906627133 L 15.027111873006675 14.630840079204173 L 21.241155383473426 9.416638461451942 L 29.019567833557574 15.943848336764354 A 40 40 0 0 1 44.18107115260436 10.425512421903086 L 45.944071152604366 0.42551242190308614 L 54.055928847395634 0.42551242190308614 L 55.81892884739563 10.425512421903086 A 40 40 0 0 1 70.98043216644243 15.943848336764354 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	halfFrame: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 66.667 33.333 L 33.333 33.333 L 33.333 66.667 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	heart: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 50 25 C 70.83333333333333 -33.333333333333336 152.08333333333331 25 50 100 C -52.08333333333333 25 29.166666666666668 -33.333333333333336 50 25 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	heptagon: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M -0.0002599799999956076 64.3106646 L 9.903066619999997 19.806308549999997 L 50 0 L 90.09693338 19.806308549999997 L 100.00025998 64.3106646 L 72.25196968 100.00052685 L 27.74803032 100.00052685 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	hexagon: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 25 0.00002331250544074237 L 75 0.00002331250544074237 L 100 50 L 75 99.99997668749455 L 25 99.99997668749455 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	homePlate: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 50 0 L 100 50 L 50 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	horizontalScroll: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 100 6.25 A 6.25 6.25 0 0 1 93.75 12.5 L 93.75 6.25 A 3.125 3.125 0 0 1 87.5 6.25 L 87.5 12.5 L 6.25 12.5 A 6.25 6.25 0 0 0 8.881784197001252e-16 18.75 L 0 93.75 A 6.25 6.25 0 0 0 12.5 93.75 L 12.5 87.5 L 93.75 87.5 A 6.25 6.25 0 0 0 100 81.25 Z M 6.25 25 A 6.25 6.25 0 0 0 12.5 18.75 A 3.125 3.125 0 0 0 6.25 18.75 Z",
				fill: "#000000",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 6.25 25 A 6.25 6.25 0 0 0 12.5 18.75 A 3.125 3.125 0 0 0 6.25 18.75 Z M 93.75 12.5 A 6.25 6.25 0 0 0 98.16941738241593 1.8305826175840787 A 6.25 6.25 0 0 0 87.5 6.249999999999999 A 3.125 3.125 0 0 0 93.75 6.249999999999999 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 0 18.75 A 6.25 6.25 0 0 1 6.249999999999999 12.5 L 87.5 12.5 L 87.5 6.25 A 6.25 6.25 0 0 1 100 6.249999999999997 L 100 81.25 A 6.25 6.25 0 0 1 93.75 87.5 L 12.5 87.5 L 12.5 93.75 A 6.25 6.25 0 0 1 0 93.75 Z M 87.5 12.5 L 93.75 12.5 A 6.25 6.25 0 0 0 100 6.25 M 93.75 12.5 L 93.75 6.25 A 3.125 3.125 0 0 1 87.5 6.25 M 6.25 25 L 6.25 18.75 A 3.125 3.125 0 0 1 12.5 18.75 A 6.25 6.25 0 0 1 0 18.75 M 12.5 18.75 L 12.5 87.5",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	irregularSeal1: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 50 26.85185185185185 L 67.23148148148148 0 L 65.5324074074074 24.652777777777775 L 85.09259259259258 20.63425925925926 L 77.32407407407408 33.86574074074074 L 97.67129629629629 37.6712962962963 L 81.51388888888889 48.49537037037037 L 100 61.52777777777777 L 77.94907407407408 59.916666666666664 L 84.00462962962962 83.77314814814814 L 64.9074074074074 66.93055555555556 L 61.3287037037037 91.375 L 48.75925925925926 69.14351851851852 L 39.282407407407405 100 L 35.71759259259259 72.34722222222221 L 22.046296296296294 81.56018518518518 L 26.23611111111111 64.52314814814814 L 0.625 67.5324074074074 L 17.23148148148148 54.513888888888886 L 0 39.88425925925926 L 21.421296296296294 35.263888888888886 L 1.7129629629629628 10.625 L 33.85185185185185 29.259259259259256 L 38.666666666666664 10.625 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	irregularSeal2: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 53.06481481481481 20.10185185185185 L 68.47222222222221 0 L 67.24537037037037 26.74537037037037 L 83.36574074074073 14.685185185185185 L 75.83333333333333 30.24074074074074 L 100 30.763888888888886 L 78.63425925925925 43.52777777777778 L 84.58333333333333 52.26851851851852 L 75.83333333333333 56.99074074074074 L 87.39351851851852 72.37037037037037 L 67.77777777777777 66.43518518518518 L 69.17592592592592 80.41666666666666 L 56.388888888888886 73.77314814814814 L 53.75925925925926 87.23148148148148 L 45.7037037037037 80.41666666666666 L 40.27777777777778 91.25925925925925 L 34.84722222222222 83.91203703703704 L 22.76388888888889 100 L 22.24537037037037 84.44444444444444 L 5.9490740740740735 82.52314814814814 L 15.416666666666666 71.1574074074074 L 0 59.61574074074074 L 18.21759259259259 53.666666666666664 L 5.425925925925926 38.28703703703704 L 24.87037037037037 36.18981481481481 L 20.84259259259259 16.782407407407405 L 39.58333333333333 29.546296296296294 L 45.00925925925926 8.73611111111111 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	leftArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 50 0 L 50 25 L 100 25 L 100 75 L 50 75 L 50 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	leftArrowCallout: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 25 25 L 25 37.5 L 35.022999999999996 37.5 L 35.022999999999996 0 L 100 0 L 100 100 L 35.022999999999996 100 L 35.022999999999996 62.5 L 25 62.5 L 25 75 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	leftBrace: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 100 100 A 50 8.333 0 0 1 50 91.667 L 50 58.333 A 50 8.333 0 0 0 3.061616997868383e-15 50 A 50 8.333 0 0 0 50 41.667 L 50 8.333 A 50 8.333 0 0 1 99.99999999999999 -1.7763568394002505e-15 Z",
			fill: "#000000",
			stroke: "none"
		}, {
			d: "M 100 100 A 50 8.333 0 0 1 50 91.667 L 50 58.333 A 50 8.333 0 0 0 3.061616997868383e-15 50 A 50 8.333 0 0 0 50 41.667 L 50 8.333 A 50 8.333 0 0 1 99.99999999999999 -1.7763568394002505e-15",
			fill: "none",
			stroke: "#000000"
		}]
	},
	leftBracket: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 100 100 A 100 8.333 0 0 1 0 91.667 L 0 8.333 A 100 8.333 0 0 1 99.99999999999999 -1.7763568394002505e-15 Z",
			fill: "#000000",
			stroke: "none"
		}, {
			d: "M 100 100 A 100 8.333 0 0 1 0 91.667 L 0 8.333 A 100 8.333 0 0 1 99.99999999999999 -1.7763568394002505e-15",
			fill: "none",
			stroke: "#000000"
		}]
	},
	leftCircularArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 6.25 50.00000000000001 L 18.75 50.00000000000001 A 31.25 31.25 0 0 0 78.75627033259704 62.2327190991455 L 72.94870282721459 62.232721196358064 L 87.5 50 L 97.94870282721459 62.232721196358064 L 92.00503579491598 62.232721196358064 A 43.75 43.75 0 0 1 6.249999722517629 50.00000095282626 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	leftRightArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 50 0 L 50 25 L 50 25 L 50 0 L 100 50 L 50 100 L 50 75 L 50 75 L 50 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	leftRightArrowCallout: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 25 25 L 25 37.5 L 25.9385 37.5 L 25.9385 0 L 74.0615 0 L 74.0615 37.5 L 75 37.5 L 75 25 L 100 50 L 75 75 L 75 62.5 L 74.0615 62.5 L 74.0615 100 L 25.9385 100 L 25.9385 62.5 L 25 62.5 L 25 75 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	leftRightCircularArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 12.5 50.00000000000001 L 2.0512971727853966 37.76727880364194 L 7.9949639276016455 37.767279756468184 A 43.75 43.75 0 0 1 92.00503607239835 37.76727975646819 L 97.94870282721459 37.767278803641936 L 87.5 49.99999999999999 L 72.94870282721459 37.767278803641936 L 78.75626944045719 37.767278803641936 A 31.25 31.25 0 0 0 21.243728775263097 37.76727880364193 L 27.051297172785397 37.76727880364194 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	leftRightRibbon: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 41.6665 L 46.875 0 L 46.875 16.6665 L 50 16.6665 A 3.125 4.16675 0 0 1 50 25 A 3.125 4.16675 0 0 0 50 33.3335 L 53.125 33.3335 L 53.125 16.667 L 100 58.3335 L 53.125 100 L 53.125 83.3335 L 50 83.3335 A 3.125 4.16675 0 0 1 46.875 79.16675000000001 L 46.875 66.6665 L 46.875 66.6665 L 46.875 83.333 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 53.125 20.83325 A 3.125 4.16675 0 0 1 50 25 A 3.125 4.16675 0 0 0 50 33.3335 L 53.125 33.3335 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none"
			},
			{
				d: "M 0 41.6665 L 46.875 0 L 46.875 16.6665 L 50 16.6665 A 3.125 4.16675 0 0 1 50 25 A 3.125 4.16675 0 0 0 50 33.3335 L 53.125 33.3335 L 53.125 16.667 L 100 58.3335 L 53.125 100 L 53.125 83.3335 L 50 83.3335 A 3.125 4.16675 0 0 1 46.875 79.16675000000001 L 46.875 66.6665 L 46.875 66.6665 L 46.875 83.333 Z M 53.125 20.83325 L 53.125 33.3335 M 46.875 29.16675 L 46.875 66.6665",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	leftRightUpArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 75 L 25 50 L 25 62.5 L 37.5 62.5 L 37.5 25 L 25 25 L 50 0 L 75 25 L 62.5 25 L 62.5 62.5 L 75 62.5 L 75 50 L 100 75 L 75 100 L 75 87.5 L 25 87.5 L 25 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	leftUpArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 75 L 25 50 L 25 62.5 L 62.5 62.5 L 62.5 25 L 50 25 L 75 0 L 100 25 L 87.5 25 L 87.5 87.5 L 25 87.5 L 25 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	lightningBolt: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 39.22222222222222 0 L 59.53703703703703 28.148148148148145 L 51.157407407407405 31.46759259259259 L 76.74537037037037 55.58796296296296 L 68.36574074074073 59.61574074074074 L 100 100 L 46.35185185185185 69.05092592592592 L 56.58333333333333 64.75462962962962 L 23.25 44.93055555555555 L 35.19444444444444 38.80555555555555 L 0 18.00925925925926 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	line: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 100",
			fill: "none",
			stroke: "#000000"
		}]
	},
	lineInv: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 100 L 100 0",
			fill: "none",
			stroke: "#000000"
		}]
	},
	mathDivide: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 50 11.790000000000004 A 11.76 11.76 0 0 1 50.00000000000001 35.31 A 11.76 11.76 0 0 1 49.99999999999999 11.790000000000004 Z M 50 88.21 A 11.76 11.76 0 0 1 50 64.68999999999998 A 11.76 11.76 0 0 1 50.00000000000001 88.21 Z M 13.255000000000003 38.24 L 86.745 38.24 L 86.745 61.76 L 13.255000000000003 61.76 Z",
			fill: "#000000",
			stroke: "#000000",
			fillRule: "evenodd",
			clipRule: "evenodd"
		}]
	},
	mathEqual: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 13.255000000000003 20.599999999999998 L 86.745 20.599999999999998 L 86.745 44.12 L 13.255000000000003 44.12 Z M 13.255000000000003 55.88 L 86.745 55.88 L 86.745 79.4 L 13.255000000000003 79.4 Z",
			fill: "#000000",
			stroke: "#000000",
			fillRule: "evenodd",
			clipRule: "evenodd"
		}]
	},
	mathMinus: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 13.255000000000003 38.24 L 86.745 38.24 L 86.745 61.76 L 13.255000000000003 61.76 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	mathMultiply: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 15.701924253246204 32.3330757467538 L 32.3330757467538 15.7019242532462 L 50 33.3688485064924 L 67.66692425324621 15.7019242532462 L 84.2980757467538 32.3330757467538 L 66.63115149350759 50 L 84.2980757467538 67.66692425324621 L 67.66692425324621 84.2980757467538 L 50 66.6311514935076 L 32.3330757467538 84.2980757467538 L 15.701924253246204 67.66692425324621 L 33.36884850649241 50 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	mathNotEqual: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 13.255000000000003 20.599999999999998 L 48.185994283109636 20.599999999999998 L 55.6837811089934 0 L 77.78535154987797 8.044313771019729 L 73.21545549174309 20.599999999999998 L 86.745 20.599999999999998 L 86.745 44.12 L 64.654875581802 44.12 L 60.37458562683146 55.88 L 86.745 55.88 L 86.745 79.4 L 51.81400571689038 79.4 L 44.3162188910066 100 L 22.214648450122027 91.95568622898027 L 26.78454450825693 79.4 L 13.255000000000003 79.4 L 13.255000000000003 55.88 L 35.34512441819801 55.88 L 39.62541437316855 44.12 L 13.255000000000003 44.12 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	mathPlus: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 13.255000000000003 38.24 L 38.24 38.24 L 38.24 13.255000000000003 L 61.76 13.255000000000003 L 61.76 38.24 L 86.745 38.24 L 86.745 61.76 L 61.76 61.76 L 61.76 86.745 L 38.24 86.745 L 38.24 61.76 L 13.255000000000003 61.76 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	moon: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 100 100 A 100 50 0 0 1 99.99999999999999 0 A 125 62.5 0 0 0 100 69.33752296828366 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	nonIsoscelesTrapezoid: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 100 L 25 0 L 75 0 L 100 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	noSmoking: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z M 77.5147233635495 64.81561670087828 A 31.25 31.25 0 0 0 35.18438329912174 22.4852766364505 Z M 22.4852766364505 35.18438329912172 A 31.25 31.25 0 0 0 64.81561670087828 77.51472336354949 Z",
			fill: "#000000",
			stroke: "#000000",
			fillRule: "evenodd",
			clipRule: "evenodd"
		}]
	},
	notchedRightArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 25 L 50 25 L 50 0 L 100 50 L 50 100 L 50 75 L 0 75 L 25 50 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	octagon: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 29.289 L 29.289 0 L 70.711 0 L 100 29.289 L 100 70.711 L 70.711 100 L 29.289 100 L 0 70.711 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	parallelogram: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 100 L 25 0 L 100 0 L 75 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	pentagon: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0.00010576881489043899 38.19650407644447 L 50 0 L 99.99989423118511 38.19650407644447 L 80.90163406877218 99.99974592355554 L 19.09836593122782 99.99974592355554 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	pie: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 100 50 A 50 50 0 0 1 14.64466094067263 85.35533905932738 A 50 50 0 0 1 49.99999999999999 0 L 50 50 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	pieWedge: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 100 A 100 100 0 0 1 99.99999999999999 -1.4210854715202004e-14 L 100 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	plaque: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 16.667 A 16.667 16.667 0 0 0 16.667 0 L 83.333 0 A 16.667 16.667 0 0 0 100 16.666999999999998 L 100 83.333 A 16.667 16.667 0 0 0 83.333 100 L 16.667 100 A 16.667 16.667 0 0 0 1.0205594100694468e-15 83.333 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	plaqueTabs: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 7.0710678118654755 0 A 7.0710678118654755 7.0710678118654755 0 0 1 4.3297802811774667e-16 7.0710678118654755 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M 0 92.92893218813452 A 7.0710678118654755 7.0710678118654755 0 0 1 7.071067811865476 100 L 0 100 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M 100 0 L 100 7.0710678118654755 A 7.0710678118654755 7.0710678118654755 0 0 1 92.92893218813452 8.659560562354933e-16 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M 92.92893218813452 100 A 7.0710678118654755 7.0710678118654755 0 0 1 100 92.92893218813452 L 100 100 Z",
				fill: "#000000",
				stroke: "#000000"
			}
		]
	},
	plus: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 25 L 25 25 L 25 0 L 75 0 L 75 25 L 100 25 L 100 75 L 75 75 L 75 100 L 25 100 L 25 75 L 0 75 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	quadArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 22.5 27.5 L 22.5 38.75 L 38.75 38.75 L 38.75 22.5 L 27.5 22.5 L 50 0 L 72.5 22.5 L 61.25 22.5 L 61.25 38.75 L 77.5 38.75 L 77.5 27.5 L 100 50 L 77.5 72.5 L 77.5 61.25 L 61.25 61.25 L 61.25 77.5 L 72.5 77.5 L 50 100 L 27.5 77.5 L 38.75 77.5 L 38.75 61.25 L 22.5 61.25 L 22.5 72.5 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	quadArrowCallout: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 18.515 31.485 L 18.515 40.7425 L 25.9385 40.7425 L 25.9385 25.9385 L 40.7425 25.9385 L 40.7425 18.515 L 31.485 18.515 L 50 0 L 68.515 18.515 L 59.2575 18.515 L 59.2575 25.9385 L 74.0615 25.9385 L 74.0615 40.7425 L 81.485 40.7425 L 81.485 31.485 L 100 50 L 81.485 68.515 L 81.485 59.2575 L 74.0615 59.2575 L 74.0615 74.0615 L 59.2575 74.0615 L 59.2575 81.485 L 68.515 81.485 L 50 100 L 31.485 81.485 L 40.7425 81.485 L 40.7425 74.0615 L 25.9385 74.0615 L 25.9385 59.2575 L 18.515 59.2575 L 18.515 68.515 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	rect: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 0 L 100 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	ribbon: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 34.375 0 A 3.125 4.16675 0 0 1 34.375 8.3335 L 28.125 8.3335 A 3.125 4.16675 0 0 0 28.125 16.667 L 71.875 16.667 A 3.125 4.16675 0 0 0 71.875 8.3335 L 65.625 8.3335 A 3.125 4.16675 0 0 1 65.625 0 L 100 0 L 87.5 41.6665 L 100 83.333 L 75 83.333 L 75 95.83324999999999 A 3.125 4.16675 0 0 1 71.875 100 L 28.125 100 A 3.125 4.16675 0 0 1 25 95.83324999999999 L 25 83.333 L 0 83.333 L 12.5 41.6665 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 37.5 4.16675 A 3.125 4.16675 0 0 1 34.375 8.3335 L 28.125 8.3335 A 3.125 4.16675 0 0 0 28.125 16.667 L 37.5 16.667 Z M 62.5 4.16675 A 3.125 4.16675 0 0 0 65.625 8.3335 L 71.875 8.3335 A 3.125 4.16675 0 0 1 71.875 16.667 L 62.5 16.667 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 0 0 L 34.375 0 A 3.125 4.16675 0 0 1 34.375 8.3335 L 28.125 8.3335 A 3.125 4.16675 0 0 0 28.125 16.667 L 71.875 16.667 A 3.125 4.16675 0 0 0 71.875 8.3335 L 65.625 8.3335 A 3.125 4.16675 0 0 1 65.625 0 L 100 0 L 87.5 41.6665 L 100 83.333 L 75 83.333 L 75 95.83324999999999 A 3.125 4.16675 0 0 1 71.875 100 L 28.125 100 A 3.125 4.16675 0 0 1 25 95.83324999999999 L 25 83.333 L 0 83.333 L 12.5 41.6665 Z M 37.5 4.16675 L 37.5 16.667 M 62.5 16.667 L 62.5 4.16675 M 25 83.333 L 25 12.500250000000001 M 75 12.500250000000001 L 75 83.333",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	ribbon2: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 100 L 34.375 100 A 3.125 4.16675 0 0 0 34.375 91.66649999999998 L 28.125 91.6665 A 3.125 4.16675 0 0 1 28.125 83.333 L 71.875 83.333 A 3.125 4.16675 0 0 1 71.875 91.66650000000001 L 65.625 91.6665 A 3.125 4.16675 0 0 0 65.625 100 L 100 100 L 87.5 58.3335 L 100 16.667 L 75 16.667 L 75 4.16675 A 3.125 4.16675 0 0 0 71.875 0 L 28.125 0 A 3.125 4.16675 0 0 0 25 4.166750000000001 L 25 16.667 L 0 16.667 L 12.5 58.3335 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 37.5 95.83324999999999 A 3.125 4.16675 0 0 0 34.375 91.66649999999998 L 28.125 91.6665 A 3.125 4.16675 0 0 1 28.125 83.333 L 37.5 83.333 Z M 62.5 95.83324999999999 A 3.125 4.16675 0 0 1 65.625 91.66649999999998 L 71.875 91.6665 A 3.125 4.16675 0 0 0 71.875 83.333 L 62.5 83.333 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 0 100 L 12.5 58.3335 L 0 16.667 L 25 16.667 L 25 4.16675 A 3.125 4.16675 0 0 1 28.125 -8.881784197001252e-16 L 71.875 0 A 3.125 4.16675 0 0 1 75 4.1667499999999995 L 75 16.667 L 75 16.667 L 100 16.667 L 87.5 58.3335 L 100 100 L 65.625 100 A 3.125 4.16675 0 0 1 65.625 91.66649999999998 L 71.875 91.6665 A 3.125 4.16675 0 0 0 71.875 83.333 L 28.125 83.333 A 3.125 4.16675 0 0 0 28.125 91.66650000000001 L 34.375 91.6665 A 3.125 4.16675 0 0 1 34.375 100 Z M 37.5 83.333 L 37.5 95.83324999999999 M 62.5 95.83324999999999 L 62.5 83.333 M 25 87.49975 L 25 16.667 M 75 16.667 L 75 87.49975",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	rightArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 25 L 50 25 L 50 0 L 100 50 L 50 100 L 50 75 L 0 75 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	rightArrowCallout: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 64.977 0 L 64.977 37.5 L 75 37.5 L 75 25 L 100 50 L 75 75 L 75 62.5 L 64.977 62.5 L 64.977 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	rightBrace: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 A 50 8.333 0 0 1 50.00000000000001 8.332999999999998 L 50 41.667 A 50 8.333 0 0 0 100 50 A 50 8.333 0 0 0 50.000000000000014 58.333 L 50 91.667 A 50 8.333 0 0 1 3.061616997868383e-15 100 Z",
			fill: "#000000",
			stroke: "none"
		}, {
			d: "M 0 0 A 50 8.333 0 0 1 50.00000000000001 8.332999999999998 L 50 41.667 A 50 8.333 0 0 0 100 50 A 50 8.333 0 0 0 50.000000000000014 58.333 L 50 91.667 A 50 8.333 0 0 1 3.061616997868383e-15 100",
			fill: "none",
			stroke: "#000000"
		}]
	},
	rightBracket: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 A 100 8.333 0 0 1 100.00000000000001 8.332999999999998 L 100 91.667 A 100 8.333 0 0 1 6.123233995736766e-15 100 Z",
			fill: "#000000",
			stroke: "none"
		}, {
			d: "M 0 0 A 100 8.333 0 0 1 100.00000000000001 8.332999999999998 L 100 91.667 A 100 8.333 0 0 1 6.123233995736766e-15 100",
			fill: "none",
			stroke: "#000000"
		}]
	},
	round1Rect: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 83.333 0 A 16.667 16.667 0 0 1 100 16.666999999999998 L 100 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	round2DiagRect: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 16.667 0 L 100 0 A 0 0 0 0 1 100 0 L 100 83.333 A 16.667 16.667 0 0 1 83.333 100 L 0 100 A 0 0 0 0 1 0 100 L 0 16.667 A 16.667 16.667 0 0 1 16.666999999999998 -3.552713678800501e-15 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	round2SameRect: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 16.667 0 L 83.333 0 A 16.667 16.667 0 0 1 100 16.666999999999998 L 100 100 A 0 0 0 0 1 100 100 L 0 100 A 0 0 0 0 1 0 100 L 0 16.667 A 16.667 16.667 0 0 1 16.666999999999998 -3.552713678800501e-15 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	roundRect: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 16.667 A 16.667 16.667 0 0 1 16.666999999999998 -3.552713678800501e-15 L 83.333 0 A 16.667 16.667 0 0 1 100 16.666999999999998 L 100 83.333 A 16.667 16.667 0 0 1 83.333 100 L 16.667 100 A 16.667 16.667 0 0 1 0 83.333 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	rtTriangle: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 100 L 0 0 L 100 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	smileyFace: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 50 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 0 50.000000000000014 Z",
				fill: "#000000",
				stroke: "none"
			},
			{
				d: "M 28.77314814814815 35.0462962962963 A 5.208333333333333 5.208333333333333 0 0 1 39.18981481481482 35.0462962962963 A 5.208333333333333 5.208333333333333 0 0 1 28.77314814814815 35.0462962962963 M 60.81018518518518 35.0462962962963 A 5.208333333333333 5.208333333333333 0 0 1 71.22685185185185 35.0462962962963 A 5.208333333333333 5.208333333333333 0 0 1 60.81018518518518 35.0462962962963",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "#000000",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 22.89967279598138 71.80533333333332 Q 50 90.41733333333333 77.03703703703704 71.80533333333332",
				fill: "none",
				stroke: "#000000"
			},
			{
				d: "M 0 50 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 0 50.000000000000014 Z",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	snip1Rect: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 83.333 0 L 100 16.667 L 100 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	snip2DiagRect: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 83.333 0 L 100 16.667 L 100 100 L 100 100 L 16.667 100 L 0 83.333 L 0 0 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	snip2SameRect: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 16.667 0 L 83.333 0 L 100 16.667 L 100 100 L 100 100 L 0 100 L 0 100 L 0 16.667 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	snipRoundRect: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 16.667 0 L 83.333 0 L 100 16.667 L 100 100 L 0 100 L 0 16.667 A 16.667 16.667 0 0 1 16.666999999999998 -3.552713678800501e-15 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	squareTabs: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 0 0 L 7.0710678118654755 0 L 7.0710678118654755 7.0710678118654755 L 0 7.0710678118654755 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M 0 92.92893218813452 L 7.0710678118654755 92.92893218813452 L 7.0710678118654755 100 L 0 100 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M 92.92893218813452 0 L 100 0 L 100 7.0710678118654755 L 92.92893218813452 7.0710678118654755 Z",
				fill: "#000000",
				stroke: "#000000"
			},
			{
				d: "M 92.92893218813452 92.92893218813452 L 100 92.92893218813452 L 100 100 L 92.92893218813452 100 Z",
				fill: "#000000",
				stroke: "#000000"
			}
		]
	},
	star10: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M -0.00007738000000045986 34.549 L 13.819211287416401 24.99952793 L 19.09811633 9.549 L 36.180085377416404 9.548565019999998 L 50 0 L 63.819914622583596 9.548565019999998 L 80.90188367 9.549 L 86.18078871258359 24.99952793 L 100.00007738 34.549 L 94.72174817999999 50 L 100.00007738 65.451 L 86.18078871258359 75.00047207 L 80.90188367 90.451 L 63.819914622583596 90.45143498 L 50 100 L 36.180085377416404 90.45143498 L 19.09811633 90.451 L 13.819211287416401 75.00047207 L -0.00007738000000045986 65.451 L 5.278251820000001 50 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	star12: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 13.77778151415994 40.294285808655474 L 6.698729810778062 25 L 23.483495705504467 23.48349570550447 L 25 6.698729810778069 L 40.294285808655474 13.77778151415994 L 50 0 L 59.705714191344526 13.77778151415994 L 75 6.698729810778069 L 76.51650429449553 23.48349570550447 L 93.30127018922194 25 L 86.22221848584006 40.294285808655474 L 100 50 L 86.22221848584006 59.705714191344526 L 93.30127018922194 75 L 76.51650429449553 76.51650429449553 L 75 93.30127018922192 L 59.705714191344526 86.22221848584006 L 50 100 L 40.294285808655474 86.22221848584006 L 25 93.30127018922192 L 23.483495705504467 76.51650429449553 L 6.698729810778062 75 L 13.77778151415994 59.705714191344526 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	star16: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 13.220374999999997 42.684125 L 3.8059999999999974 30.866 L 18.819875 29.166125 L 14.6445 14.6445 L 29.166125 18.819875 L 30.866 3.8059999999999974 L 42.684125 13.220374999999997 L 50 0 L 57.315875 13.220374999999997 L 69.134 3.8059999999999974 L 70.833875 18.819875 L 85.3555 14.6445 L 81.180125 29.166125 L 96.194 30.866 L 86.77962500000001 42.684125 L 100 50 L 86.77962500000001 57.315875 L 96.194 69.134 L 81.180125 70.833875 L 85.3555 85.3555 L 70.833875 81.180125 L 69.134 96.194 L 57.315875 86.77962500000001 L 50 100 L 42.684125 86.77962500000001 L 30.866 96.194 L 29.166125 81.180125 L 14.6445 85.3555 L 18.819875 70.833875 L 3.8059999999999974 69.134 L 13.220374999999997 57.315875 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	star24: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 12.820999999999998 45.105125 L 1.7037086855465873 37.059047744873965 L 15.354500000000002 35.6495 L 6.698729810778062 25 L 20.249375 27.1715 L 14.644660940672622 14.64466094067263 L 27.1715 20.249375 L 25 6.698729810778069 L 35.6495 15.354500000000002 L 37.059047744873965 1.7037086855465873 L 45.105125 12.820999999999998 L 50 0 L 54.894875 12.820999999999998 L 62.940952255126035 1.7037086855465873 L 64.3505 15.354500000000002 L 75 6.698729810778069 L 72.82849999999999 20.249375 L 85.35533905932738 14.64466094067263 L 79.750625 27.1715 L 93.30127018922194 25 L 84.6455 35.6495 L 98.29629131445341 37.059047744873965 L 87.179 45.105125 L 100 50 L 87.179 54.894875 L 98.29629131445341 62.940952255126035 L 84.6455 64.3505 L 93.30127018922194 75 L 79.750625 72.82849999999999 L 85.35533905932738 85.35533905932738 L 72.82849999999999 79.750625 L 75 93.30127018922192 L 64.3505 84.6455 L 62.940952255126035 98.29629131445341 L 54.894875 87.179 L 50 100 L 45.105125 87.179 L 37.059047744873965 98.29629131445341 L 35.6495 84.6455 L 25 93.30127018922192 L 27.1715 79.750625 L 14.644660940672622 85.35533905932738 L 20.249375 72.82849999999999 L 6.698729810778062 75 L 15.354500000000002 64.3505 L 1.7037086855465873 62.940952255126035 L 12.820999999999998 54.894875 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	star32: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 12.680750000000003 46.32425 L 0.9605000000000032 40.2455 L 14.11475 39.1145 L 3.8059999999999974 30.866 L 16.927999999999997 32.322500000000005 L 8.426499999999997 22.2215 L 21.012125 26.210375 L 14.644660940672622 14.64466094067263 L 26.210375 21.012125 L 22.2215 8.426499999999997 L 32.322500000000005 16.927999999999997 L 30.866 3.8059999999999974 L 39.1145 14.11475 L 40.2455 0.9605000000000032 L 46.32425 12.680750000000003 L 50 0 L 53.67575 12.680750000000003 L 59.7545 0.9605000000000032 L 60.8855 14.11475 L 69.134 3.8059999999999974 L 67.6775 16.927999999999997 L 77.77850000000001 8.426499999999997 L 73.789625 21.012125 L 85.35533905932738 14.64466094067263 L 78.987875 26.210375 L 91.5735 22.2215 L 83.072 32.322500000000005 L 96.194 30.866 L 85.88525 39.1145 L 99.0395 40.2455 L 87.31925 46.32425 L 100 50 L 87.31925 53.67575 L 99.0395 59.7545 L 85.88525 60.8855 L 96.194 69.134 L 83.072 67.6775 L 91.5735 77.77850000000001 L 78.987875 73.789625 L 85.35533905932738 85.35533905932738 L 73.789625 78.987875 L 77.77850000000001 91.5735 L 67.6775 83.072 L 69.134 96.194 L 60.8855 85.88525 L 59.7545 99.0395 L 53.67575 87.31925 L 50 100 L 46.32425 87.31925 L 40.2455 99.0395 L 39.1145 85.88525 L 30.866 96.194 L 32.322500000000005 83.072 L 22.2215 91.5735 L 26.210375 78.987875 L 14.644660940672622 85.35533905932738 L 21.012125 73.789625 L 8.426499999999997 77.77850000000001 L 16.927999999999997 67.6775 L 3.8059999999999974 69.134 L 14.11475 60.8855 L 0.9605000000000032 59.7545 L 12.680750000000003 53.67575 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	star4: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 41.161165235168156 41.161165235168156 L 50 0 L 58.838834764831844 41.161165235168156 L 100 50 L 58.838834764831844 58.838834764831844 L 50 100 L 41.161165235168156 58.838834764831844 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	star5: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0.00010576881489043899 38.19650407644447 L 38.19681185109177 38.196772907038735 L 50 0 L 61.80318814890823 38.196772907038735 L 99.99989423118511 38.19650407644447 L 69.09795960054346 61.80313916296127 L 80.90163406877218 99.99974592355554 L 50 76.39267586 L 19.09836593122782 99.99974592355554 L 30.90204039945654 61.80313916296127 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	star6: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0.000023312505433636943 25 L 33.3330602 24.999578643550826 L 50 0 L 66.6669398 24.999578643550826 L 99.99997668749457 25 L 83.3338796 50 L 99.99997668749457 75 L 66.6669398 75.00042135644918 L 50 100 L 33.3330602 75.00042135644918 L 0.000023312505433636943 75 L 16.666120399999997 50 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	star7: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M -0.0002599799999956076 64.3106646 L 15.398820088640399 44.504445983508 L 9.903066619999997 19.806308549999997 L 34.6011919420464 19.806347509263 L 50 0 L 65.3988080579536 19.806347509263 L 90.09693338 19.806308549999997 L 84.6011799113596 44.504445983508 L 100.00025998 64.3106646 L 77.7478798376276 75.302350457229 L 72.25196968 100.00052685 L 50 89.0087121 L 27.74803032 100.00052685 L 22.252120162372403 75.302350457229 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	star8: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 15.354500000000002 35.6495 L 14.644660940672622 14.64466094067263 L 35.6495 15.354500000000002 L 50 0 L 64.3505 15.354500000000002 L 85.35533905932738 14.64466094067263 L 84.6455 35.6495 L 100 50 L 84.6455 64.3505 L 85.35533905932738 85.35533905932738 L 64.3505 84.6455 L 50 100 L 35.6495 84.6455 L 14.644660940672622 85.35533905932738 L 15.354500000000002 64.3505 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	straightConnector1: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 100 100",
			fill: "none",
			stroke: "#000000"
		}]
	},
	stripedRightArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 25 L 0 25 L 0 75 L 0 75 Z M 0 25 L 0 25 L 0 75 L 0 75 Z M 15.625 25 L 50 25 L 50 0 L 100 50 L 50 100 L 50 75 L 15.625 75 Z",
			fill: "#000000",
			stroke: "#000000",
			fillRule: "evenodd",
			clipRule: "evenodd"
		}]
	},
	sun: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 100 50 L 79.82292175292969 57.175445556640625 L 79.82292175292969 42.824554443359375 Z M 85.35185185185185 14.643518518518519 L 76.16092175292968 33.986554443359374 L 66.01344555664062 23.83907824707031 Z M 50 0 L 57.175445556640625 20.177078247070312 L 42.824554443359375 20.177078247070312 Z M 14.643518518518519 14.643518518518519 L 33.986554443359374 23.83907824707031 L 23.83907824707031 33.986554443359374 Z M 0 50 L 20.177078247070312 42.824554443359375 L 20.177078247070312 57.175445556640625 Z M 14.643518518518519 85.35185185185185 L 23.83907824707031 66.01344555664062 L 33.986554443359374 76.16092175292968 Z M 50 100 L 42.824554443359375 79.82292175292969 L 57.175445556640625 79.82292175292969 Z M 85.35185185185185 85.35185185185185 L 66.01344555664062 76.16092175292968 L 76.16092175292968 66.01344555664062 Z M 25 50 A 25 25 0 0 1 75 49.99999999999999 A 25 25 0 0 1 25 50.00000000000001 Z",
			fill: "#000000",
			stroke: "#000000",
			fillRule: "evenodd",
			clipRule: "evenodd"
		}]
	},
	swooshArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 100 Q 16.666666666666668 33.333333333333336 83.333 0 L 83.333 0 L 100 7.5 L 86.14982349750278 25 L 86.14982349750278 25 Q 25 33.333333333333336 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	teardrop: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 Q 75 0 100 0 Q 100 25 100 50 A 50 50 0 0 1 50 100 A 50 50 0 0 1 0 50.00000000000001 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	trapezoid: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 100 L 25 0 L 75 0 L 100 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	triangle: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 100 L 50 0 L 100 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	upArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 50 0 L 100 50 L 75 50 L 75 100 L 25 100 L 25 50 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	upArrowCallout: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 35.022999999999996 L 37.5 35.022999999999996 L 37.5 25 L 25 25 L 50 0 L 75 25 L 62.5 25 L 62.5 35.022999999999996 L 100 35.022999999999996 L 100 100 L 0 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	upDownArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 50 L 50 0 L 100 50 L 75 50 L 75 50 L 100 50 L 50 100 L 0 50 L 25 50 L 25 50 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	upDownArrowCallout: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 25.9385 L 37.5 25.9385 L 37.5 25 L 25 25 L 50 0 L 75 25 L 62.5 25 L 62.5 25.9385 L 100 25.9385 L 100 74.0615 L 62.5 74.0615 L 62.5 75 L 75 75 L 50 100 L 25 75 L 37.5 75 L 37.5 74.0615 L 0 74.0615 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	uturnArrow: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 100 L 0 43.75 A 43.75 43.75 0 0 1 43.74999999999999 -7.105427357601002e-15 L 43.75 0 A 43.75 43.75 0 0 1 87.5 43.749999999999986 L 87.5 50 L 100 50 L 75 75 L 50 50 L 62.5 50 L 62.5 43.75 A 18.75 18.75 0 0 0 43.75 25 L 43.75 25 A 18.75 18.75 0 0 0 25 43.75 L 25 100 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	verticalScroll: {
		viewBox: "0 0 100 100",
		paths: [
			{
				d: "M 6.25 100 A 6.25 6.25 0 0 0 12.5 93.75 L 6.25 93.75 A 3.125 3.125 0 0 0 6.25 87.5 L 12.5 87.5 L 12.5 6.25 A 6.25 6.25 0 0 1 18.75 -8.881784197001252e-16 L 93.75 0 A 6.25 6.25 0 0 1 93.75 12.5 L 87.5 12.5 L 87.5 93.75 A 6.25 6.25 0 0 1 81.25 100 Z M 25 6.25 A 6.25 6.25 0 0 1 18.75 12.5 A 3.125 3.125 0 0 1 18.75 6.25 Z",
				fill: "#000000",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 25 6.25 A 6.25 6.25 0 0 1 18.75 12.5 A 3.125 3.125 0 0 1 18.75 6.25 Z M 12.5 93.75 A 6.25 6.25 0 0 1 1.8305826175840787 98.16941738241593 A 6.25 6.25 0 0 1 6.249999999999999 87.5 A 3.125 3.125 0 0 1 6.250000000000001 93.75 Z",
				fill: "color-mix(in srgb, currentColor 80%, black)",
				stroke: "none",
				fillRule: "evenodd",
				clipRule: "evenodd"
			},
			{
				d: "M 12.5 87.5 L 12.5 6.25 A 6.25 6.25 0 0 1 18.75 -8.881784197001252e-16 L 93.75 0 A 6.25 6.25 0 0 1 93.75 12.5 L 87.5 12.5 L 87.5 93.75 A 6.25 6.25 0 0 1 81.25 100 L 6.25 100 A 6.25 6.25 0 0 1 6.249999999999999 87.5 Z M 18.75 0 A 6.25 6.25 0 0 1 18.750000000000004 12.5 A 3.125 3.125 0 0 1 18.750000000000004 6.25 L 25 6.25 M 87.5 12.5 L 18.75 12.5 M 6.25 87.5 A 3.125 3.125 0 0 1 6.250000000000002 93.75 L 12.5 93.75 M 6.25 100 A 6.25 6.25 0 0 0 12.5 93.75 L 12.5 87.5",
				fill: "none",
				stroke: "#000000"
			}
		]
	},
	wave: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 12.5 C 33.333333333333336 -29.166666666666664 66.66666666666667 54.166666666666664 100 12.5 L 100 87.5 C 66.66666666666667 129.16666666666666 33.333333333333336 45.833333333333336 0 87.5 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	wedgeEllipseCallout: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 29.167 112.5 L 25.428460527844393 93.54583157970805 A 50 50 0 0 1 65.81115470846487 2.5657572339877106 A 50 50 0 0 1 43.53022094510429 99.57965267103867 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	wedgeRectCallout: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 0 L 16.666666666666668 0 L 16.666666666666668 0 L 41.666666666666664 0 L 100 0 L 100 58.333333333333336 L 100 58.333333333333336 L 100 83.33333333333333 L 100 100 L 41.666666666666664 100 L 29.167 112.5 L 16.666666666666668 100 L 0 100 L 0 83.33333333333333 L 0 58.333333333333336 L 0 58.333333333333336 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	},
	wedgeRoundRectCallout: {
		viewBox: "0 0 100 100",
		paths: [{
			d: "M 0 16.667 A 16.667 16.667 0 0 1 16.666999999999998 -3.552713678800501e-15 L 16.666666666666668 0 L 16.666666666666668 0 L 41.666666666666664 0 L 83.333 0 A 16.667 16.667 0 0 1 100 16.666999999999998 L 100 58.333333333333336 L 100 58.333333333333336 L 100 83.33333333333333 L 100 83.333 A 16.667 16.667 0 0 1 83.333 100 L 41.666666666666664 100 L 29.167 112.5 L 16.666666666666668 100 L 16.667 100 A 16.667 16.667 0 0 1 0 83.333 L 0 83.33333333333333 L 0 58.333333333333336 L 0 58.333333333333336 Z",
			fill: "#000000",
			stroke: "#000000"
		}]
	}
};
var F = new Set(["leftRightArrow", "upDownArrow"]), X = {
	leftRightArrow: `<leftRightArrow>
    <avLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <gd name="adj1" fmla="val 50000"/>
      <gd name="adj2" fmla="val 50000"/>
    </avLst>
    <gdLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <gd name="maxAdj2" fmla="*/ 50000 w ss"/>
      <gd name="a1" fmla="pin 0 adj1 100000"/>
      <gd name="a2" fmla="pin 0 adj2 maxAdj2"/>
      <gd name="x2" fmla="*/ ss a2 100000"/>
      <gd name="x3" fmla="+- r 0 x2"/>
      <gd name="dy" fmla="*/ h a1 200000"/>
      <gd name="y1" fmla="+- vc 0 dy"/>
      <gd name="y2" fmla="+- vc dy 0"/>
      <gd name="dx1" fmla="*/ y1 x2 hd2"/>
      <gd name="x1" fmla="+- x2 0 dx1"/>
      <gd name="x4" fmla="+- x3 dx1 0"/>
    </gdLst>
    <ahLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <ahXY gdRefY="adj1" minY="0" maxY="100000">
        <pos x="x3" y="y1"/>
      </ahXY>
      <ahXY gdRefX="adj2" minX="0" maxX="maxAdj2">
        <pos x="x2" y="t"/>
      </ahXY>
    </ahLst>
    <cxnLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <cxn ang="0">
        <pos x="r" y="vc"/>
      </cxn>
      <cxn ang="cd4">
        <pos x="x3" y="b"/>
      </cxn>
      <cxn ang="cd4">
        <pos x="x2" y="b"/>
      </cxn>
      <cxn ang="cd2">
        <pos x="l" y="vc"/>
      </cxn>
      <cxn ang="3cd4">
        <pos x="x2" y="t"/>
      </cxn>
      <cxn ang="3cd4">
        <pos x="x3" y="t"/>
      </cxn>
    </cxnLst>
    <rect l="x1" t="y1" r="x4" b="y2" xmlns="http://schemas.openxmlformats.org/drawingml/2006/main"/>
    <pathLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <path>
        <moveTo>
          <pt x="l" y="vc"/>
        </moveTo>
        <lnTo>
          <pt x="x2" y="t"/>
        </lnTo>
        <lnTo>
          <pt x="x2" y="y1"/>
        </lnTo>
        <lnTo>
          <pt x="x3" y="y1"/>
        </lnTo>
        <lnTo>
          <pt x="x3" y="t"/>
        </lnTo>
        <lnTo>
          <pt x="r" y="vc"/>
        </lnTo>
        <lnTo>
          <pt x="x3" y="b"/>
        </lnTo>
        <lnTo>
          <pt x="x3" y="y2"/>
        </lnTo>
        <lnTo>
          <pt x="x2" y="y2"/>
        </lnTo>
        <lnTo>
          <pt x="x2" y="b"/>
        </lnTo>
        <close/>
      </path>
    </pathLst>
  </leftRightArrow>`,
	upDownArrow: `<upDownArrow>
    <avLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <gd name="adj1" fmla="val 50000"/>
      <gd name="adj2" fmla="val 50000"/>
    </avLst>
    <gdLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <gd name="maxAdj2" fmla="*/ 50000 h ss"/>
      <gd name="a1" fmla="pin 0 adj1 100000"/>
      <gd name="a2" fmla="pin 0 adj2 maxAdj2"/>
      <gd name="y2" fmla="*/ ss a2 100000"/>
      <gd name="y3" fmla="+- b 0 y2"/>
      <gd name="dx1" fmla="*/ w a1 200000"/>
      <gd name="x1" fmla="+- hc 0 dx1"/>
      <gd name="x2" fmla="+- hc dx1 0"/>
      <gd name="dy1" fmla="*/ x1 y2 wd2"/>
      <gd name="y1" fmla="+- y2 0 dy1"/>
      <gd name="y4" fmla="+- y3 dy1 0"/>
    </gdLst>
    <ahLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <ahXY gdRefX="adj1" minX="0" maxX="100000">
        <pos x="x1" y="y3"/>
      </ahXY>
      <ahXY gdRefY="adj2" minY="0" maxY="maxAdj2">
        <pos x="l" y="y2"/>
      </ahXY>
    </ahLst>
    <cxnLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <cxn ang="3cd4">
        <pos x="hc" y="t"/>
      </cxn>
      <cxn ang="cd2">
        <pos x="l" y="y2"/>
      </cxn>
      <cxn ang="cd2">
        <pos x="x1" y="vc"/>
      </cxn>
      <cxn ang="cd2">
        <pos x="l" y="y3"/>
      </cxn>
      <cxn ang="cd4">
        <pos x="hc" y="b"/>
      </cxn>
      <cxn ang="0">
        <pos x="r" y="y3"/>
      </cxn>
      <cxn ang="0">
        <pos x="x2" y="vc"/>
      </cxn>
      <cxn ang="0">
        <pos x="r" y="y2"/>
      </cxn>
    </cxnLst>
    <rect l="x1" t="y1" r="x2" b="y4" xmlns="http://schemas.openxmlformats.org/drawingml/2006/main"/>
    <pathLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <path>
        <moveTo>
          <pt x="l" y="y2"/>
        </moveTo>
        <lnTo>
          <pt x="hc" y="t"/>
        </lnTo>
        <lnTo>
          <pt x="r" y="y2"/>
        </lnTo>
        <lnTo>
          <pt x="x2" y="y2"/>
        </lnTo>
        <lnTo>
          <pt x="x2" y="y3"/>
        </lnTo>
        <lnTo>
          <pt x="r" y="y3"/>
        </lnTo>
        <lnTo>
          <pt x="hc" y="b"/>
        </lnTo>
        <lnTo>
          <pt x="l" y="y3"/>
        </lnTo>
        <lnTo>
          <pt x="x1" y="y3"/>
        </lnTo>
        <lnTo>
          <pt x="x1" y="y2"/>
        </lnTo>
        <close/>
      </path>
    </pathLst>
  </upDownArrow>`
};
function U() {
	if (typeof DOMParser < "u") return new DOMParser();
	throw new Error("DOMParser is not available. In Node.js install @xmldom/xmldom and assign global.DOMParser.");
}
function Y$1(t) {
	return t ? t.charCodeAt(0) === 65279 ? t.slice(1) : t : "";
}
var p = "http://schemas.openxmlformats.org/drawingml/2006/main";
function m(t) {
	return Number.isNaN(t) || !Number.isFinite(t) ? 0 : t;
}
function B(t) {
	return typeof t == "string" && /^-?\d+(?:\.\d+)?$/.test(t.trim());
}
function g(t) {
	return t / 6e4 * (Math.PI / 180);
}
function W(t) {
	return Math.round(t * 180 * 6e4 / Math.PI);
}
function y(t, n) {
	return Math.sqrt(t * t + n * n);
}
function q(t) {
	let n = [];
	if (!t || typeof t.length != "number") return n;
	for (let o = 0; o < t.length; o += 1) {
		let L = typeof t.item == "function" ? t.item(o) : t[o];
		L && n.push(L);
	}
	return n;
}
function h$1(t, n, o) {
	if (!t) return [];
	if (typeof t.getElementsByTagNameNS == "function") return q(t.getElementsByTagNameNS(n ?? null, o));
	if (typeof t.getElementsByTagName == "function") {
		let l = q(t.getElementsByTagName(o));
		if (l.length) return l;
	}
	let L = [], e = [t];
	for (; e.length;) {
		let l = e.pop();
		if (!l) continue;
		let r$1 = l.childNodes;
		if (!(!r$1 || typeof r$1.length != "number")) for (let i = r$1.length - 1; i >= 0; i -= 1) {
			let s = typeof r$1.item == "function" ? r$1.item(i) : r$1[i];
			if (!s || s.nodeType !== 1) continue;
			let a = s, f = a.localName || a.nodeName || a.tagName || "", c = f.includes(":") ? f.split(":").pop() : f, A = !n || !a.namespaceURI || a.namespaceURI === n;
			c === o && A && L.push(a), e.push(a);
		}
	}
	return L;
}
function b(t) {
	let n = [], o = t?.childNodes;
	if (!o || typeof o.length != "number") return n;
	for (let L = 0; L < o.length; L += 1) {
		let e = typeof o.item == "function" ? o.item(L) : o[L];
		e && e.nodeType === 1 && n.push(e);
	}
	return n;
}
function H$1(t, n) {
	let o = Object.create(null), L = t, e = n;
	return o.w = L, o.h = e, o.l = 0, o.t = 0, o.r = L, o.b = e, o.hc = L / 2, o.vc = e / 2, o.ss = Math.min(L, e), [
		2,
		3,
		4,
		5,
		6,
		8,
		10,
		12,
		16,
		20,
		24,
		32,
		36,
		40,
		48,
		64,
		72,
		96
	].forEach((r$1) => {
		o[`wd${r$1}`] = L / r$1, o[`hd${r$1}`] = e / r$1;
	}), o;
}
function k(t, n) {
	if (t == null || t === "") return 0;
	if (typeof t == "number") return t;
	if (/^-?\d+(\.\d+)?$/.test(t)) return Number(t);
	if (/^-?[0-9]*cd[0-9]+$/.test(t)) {
		let L = t.split("cd"), e = L[0] === "" || L[0] === "-" ? +`${L[0]}1` : Number(L[0]), l = Number(L[1]);
		return l ? 216e5 / l * e : 0;
	}
	let o = n[t];
	return typeof o == "number" ? o : 0;
}
function V(t, n) {
	let o = t.trim().split(/\s+/), L = o[0], e = o.slice(1).map((l) => k(l, n));
	switch (L) {
		case "val": return m(e[0]);
		case "+-": return m(e[0] + e[1] - e[2]);
		case "*/": return e[2] === 0 ? 0 : m(e[0] * e[1] / e[2]);
		case "+/": return e[2] === 0 ? 0 : m((e[0] + e[1]) / e[2]);
		case "abs": return Math.abs(e[0]);
		case "max": return Math.max(e[0], e[1]);
		case "min": return Math.min(e[0], e[1]);
		case "pin": return Math.min(Math.max(e[0], e[1]), e[2]);
		case "mod": return m(Math.hypot(...e));
		case "sin": {
			let l = e[0], r$1 = g(e[1]);
			return m(l * Math.sin(r$1));
		}
		case "cos": {
			let l = e[0], r$1 = g(e[1]);
			return m(l * Math.cos(r$1));
		}
		case "atan2": return m(Math.atan2(e[1], e[0]));
		case "tan": {
			let l = e[0], r$1 = g(e[1]);
			return m(l * Math.tan(r$1));
		}
		case "at2": return W(Math.atan2(e[1], e[0]));
		case "sat2": {
			let l = e[0], r$1 = e[1], i = e[2], s = y(r$1, i);
			return s === 0 ? 0 : m(l * i / s);
		}
		case "cat2": {
			let l = e[0], r$1 = e[1], i = e[2], s = y(r$1, i);
			return s === 0 ? m(l) : m(l * r$1 / s);
		}
		case "?:": return e[0] >= 0 ? e[1] : e[2];
		case "sqrt": return e[0] < 0 ? 0 : Math.sqrt(e[0]);
		default: return typeof console < "u" && process$1$1.env.NODE_ENV !== "production" && console.warn(`Unsupported formula operator "${L}"`), 0;
	}
}
function z(t, n) {
	let o = h$1(t, p, "avLst")[0];
	if (o) {
		let e = h$1(o, p, "gd");
		for (let l of e) {
			let r$1 = l.getAttribute("name"), i = l.getAttribute("fmla");
			!r$1 || !i || (n[r$1] = V(i, n));
		}
	}
	let L = h$1(t, p, "gdLst")[0];
	if (L) {
		let e = h$1(L, p, "gd");
		for (let l of e) {
			let r$1 = l.getAttribute("name"), i = l.getAttribute("fmla");
			!r$1 || !i || (n[r$1] = V(i, n));
		}
	}
}
var G = {
	darken: "color-mix(in srgb, currentColor 60%, black)",
	darkenless: "color-mix(in srgb, currentColor 80%, black)",
	lighten: "color-mix(in srgb, currentColor 60%, white)",
	lightenless: "color-mix(in srgb, currentColor 80%, white)",
	accent: "var(--preset-accent, currentColor)",
	accentlight: "color-mix(in srgb, currentColor 85%, white)"
};
function J(t) {
	if (t == null) return "#000000";
	let n = String(t).toLowerCase();
	return n === "norm" || n === "auto" ? "#000000" : n === "none" || n === "false" || n === "transparent" ? "none" : n in G ? G[n] : /^#|^rgb|^hsl|^var\(/i.test(t) ? t : "#000000";
}
function R(t) {
	if (t == null) return "#000000";
	let n = t.toLowerCase();
	return n === "none" || n === "false" ? "none" : /^#|^rgb|^hsl|^var\(/i.test(t) ? t : "#000000";
}
function Z(t, n, o, L) {
	let e = t.getAttribute("x"), l = t.getAttribute("y"), r$1 = k(e, n), i = k(l, n);
	return o && B(e) && (r$1 *= o), L && B(l) && (i *= L), {
		x: r$1,
		y: i
	};
}
function f0(t, n, o, L, e) {
	let l = n.getAttribute("wR"), r$1 = n.getAttribute("hR"), i = Math.abs(k(l, o)), s = Math.abs(k(r$1, o));
	L && B(l) && (i *= L), e && B(r$1) && (s *= e);
	let a = k(n.getAttribute("stAng"), o), f = k(n.getAttribute("swAng"), o), c = (a % 216e5 + 216e5) % 216e5, A = f;
	A <= -216e5 && (A = -216e5), A >= 216e5 && (A = 216e5);
	let x = g(c), d = 0, u = 0, M = 0, w = 0;
	t ? (d = t.x, u = t.y, M = d - i * Math.cos(x), w = u - s * Math.sin(x)) : (M = o.hc || 0, w = o.vc || 0, d = M + i * Math.cos(x), u = w + s * Math.sin(x));
	let P = Math.max(1, Math.ceil(Math.abs(A) / 108e5)), C = A / P, N = [], T = c, E = d, D = u;
	for (let O = 0; O < P; O += 1) {
		let $$1 = T + C, I = g($$1), Q = M + i * Math.cos(I), j = w + s * Math.sin(I), s0 = Math.abs(C) > 108e5 ? 1 : 0, a0 = C >= 0 ? 1 : 0;
		N.push(`A ${i} ${s} 0 ${s0} ${a0} ${Q} ${j}`), T = $$1, E = Q, D = j;
	}
	return {
		command: N.join(" "),
		startPoint: {
			x: d,
			y: u
		},
		endPoint: {
			x: E,
			y: D
		}
	};
}
function e0(t, n) {
	if (t == null) return 1;
	let o = Number(t);
	return !Number.isFinite(o) || o === 0 ? 1 : n / o;
}
function t0(t, n, o, L) {
	let e = [], l = null, r$1 = 0, i = !1, s = !1, a = e0(t.getAttribute("w"), o), f = e0(t.getAttribute("h"), L);
	for (let c of b(t)) {
		let A = c.localName || c.nodeName || "";
		switch (A.includes(":") ? A.split(":").pop() : A) {
			case "moveTo": {
				let d = h$1(c, p, "pt")[0];
				if (!d) break;
				let u = Z(d, n, a, f);
				e.push(`M ${u.x} ${u.y}`), l = u, r$1 += 1;
				break;
			}
			case "lnTo": {
				let d = h$1(c, p, "pt")[0];
				if (!d) break;
				let u = Z(d, n, a, f);
				e.push(`L ${u.x} ${u.y}`), l = u;
				break;
			}
			case "quadBezTo": {
				let d = h$1(c, p, "pt");
				if (d.length === 2) {
					let u = Z(d[0], n, a, f), M = Z(d[1], n, a, f);
					e.push(`Q ${u.x} ${u.y} ${M.x} ${M.y}`), l = M;
				}
				break;
			}
			case "cubicBezTo": {
				let d = h$1(c, p, "pt");
				if (d.length === 3) {
					let u = Z(d[0], n, a, f), M = Z(d[1], n, a, f), w = Z(d[2], n, a, f);
					e.push(`C ${u.x} ${u.y} ${M.x} ${M.y} ${w.x} ${w.y}`), l = w;
				}
				break;
			}
			case "arcTo": {
				let { command: d, startPoint: u, endPoint: M } = f0(l, c, n, a, f);
				!l && u && (e.push(`M ${u.x} ${u.y}`), r$1 += 1), e.push(d), l = M, s = !0;
				break;
			}
			case "close":
				e.push("Z"), l = null, i = !0;
				break;
			default: break;
		}
	}
	return {
		d: e.join(" "),
		moveCount: r$1,
		isClosed: i,
		hasArc: s
	};
}
var c0 = new Set([
	"pathLst",
	"avLst",
	"gdLst",
	"ahLst",
	"cxnLst",
	"rect"
]), n0 = 100, o0 = {
	width: n0,
	height: n0
}, u0 = (t) => h$1(t, p, "path").length > 0;
function p0(t) {
	let n = b(t);
	return u0(t) && !n.some((e) => {
		let l = e.localName ?? e.tagName;
		return !c0.has(l);
	}) ? [t] : n;
}
function A0(t, n, o, L) {
	let e = t.getAttribute("fill"), l = t.getAttribute("stroke"), r$1 = l != null ? String(l).toLowerCase() : null, i = t.getAttribute("strokeWidth"), s = t.hasAttribute("fill"), a = t.hasAttribute("stroke"), f = R(l), c = s ? J(e) : void 0;
	s || (o.isClosed ? a && (f === "none" || f == null) ? c = r$1 === "false" ? L === "arc" ? "none" : "currentColor" : "none" : c = "#000000" : c = "none"), !a && (c === "#000000" || c === "none") && (f = R(null));
	let A;
	if (i && (A = k(i, n)), (c === "none" || c == null) && (f === "none" || f == null)) return null;
	let x, d = t.getAttribute("fillRule") || t.getAttribute("fill-rule");
	return d ? x = d : c !== "none" && o.moveCount > 1 && (x = "evenodd"), c === "currentColor" && (c = "#000000"), {
		fill: c,
		stroke: f,
		strokeWidth: A,
		fillRule: x,
		clipRule: x
	};
}
function h0(t, n, o) {
	let L = H$1(n, o);
	z(t, L);
	let e = h$1(t, p, "pathLst")[0];
	if (!e) return null;
	let l = [], r$1 = t.localName ?? t.tagName ?? "shape";
	for (let i of h$1(e, p, "path")) {
		let s = t0(i, L, n, o);
		if (!s || !s.d) continue;
		let a = A0(i, L, s, r$1);
		a && l.push({
			d: s.d,
			...a
		});
	}
	return l.length ? {
		name: r$1,
		viewBox: `0 0 ${n} ${o}`,
		paths: l
	} : null;
}
function L0(t, n = {}) {
	let o = n.width ?? o0.width, L = n.height ?? o0.height, e = U(), l = Y$1(t), i = e.parseFromString(l, "application/xml").documentElement, s = [];
	for (let a of p0(i)) {
		if (a.nodeType !== 1) continue;
		let f = h0(a, o, L);
		f && s.push(f);
	}
	return s;
}
var M0 = [
	"fill",
	"stroke",
	"strokeWidth",
	"fillRule",
	"clipRule"
], r0 = _;
function S(t) {
	if (!t) return null;
	let n = {};
	return M0.forEach((o) => {
		let L = t[o];
		if (L !== void 0) if (o === "strokeWidth") {
			if (typeof L == "number") n.strokeWidth = L;
			else if (typeof L == "string") {
				let e = Number(L);
				Number.isFinite(e) && (n.strokeWidth = e);
			}
		} else typeof L == "string" && (n[o] = L);
	}), Object.keys(n).length ? n : null;
}
function l0(t, n) {
	let o = t.map((e) => ({ ...e }));
	if (!n) return o;
	let L = (e, l) => typeof n == "function" ? S(n(e, l)) : Array.isArray(n) ? S(n[l]) : S(n);
	return o.map((e, l) => {
		let r$1 = L(e, l);
		return r$1 ? {
			...e,
			...r$1
		} : e;
	});
}
function x0(t, n, o) {
	let L = X[t];
	if (!L) return null;
	let [l] = L0(`<presetRoot xmlns:a="${p}">${L}</presetRoot>`, {
		width: n,
		height: o
	});
	return l ? {
		viewBox: l.viewBox,
		paths: l.paths
	} : null;
}
function i0(t) {
	let { preset: n, styleOverrides: o, width: L, height: e } = t;
	if (!n) throw new Error("createPresetShape requires a preset name.");
	if (F.has(n) && L != null && e != null && L !== e) {
		let i = x0(n, L, e);
		if (i) return {
			preset: n,
			viewBox: i.viewBox,
			paths: l0(i.paths, o)
		};
	}
	let r$1 = r0[n];
	if (!r$1) throw new Error(`Unknown preset shape: ${n}`);
	return {
		preset: n,
		viewBox: r$1.viewBox,
		paths: l0(r$1.paths, o)
	};
}
function k0(t) {
	let n = i0(t), o = n.paths.map((L) => {
		let e = [`d="${L.d}"`];
		return L.fill !== void 0 && e.push(`fill="${L.fill}"`), L.stroke !== void 0 && e.push(`stroke="${L.stroke}"`), L.strokeWidth !== void 0 && e.push(`stroke-width="${L.strokeWidth}"`), L.fillRule !== void 0 && e.push(`fill-rule="${L.fillRule}"`), L.clipRule !== void 0 && e.push(`clip-rule="${L.clipRule}"`), `  <path ${e.join(" ")} />`;
	}).join(`
`);
	return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${n.viewBox}" preserveAspectRatio="none">
${o}
</svg>`;
}
function createGradient$1(gradientData, gradientId) {
	const { gradientType, stops, angle } = gradientData;
	if (!stops || stops.length === 0) return null;
	let gradient;
	if (gradientType === "linear") {
		gradient = document.createElementNS("http://www.w3.org/2000/svg", "linearGradient");
		gradient.setAttribute("id", gradientId);
		const radians = angle * Math.PI / 180;
		const x1 = 50 - 50 * Math.cos(radians);
		const y1 = 50 + 50 * Math.sin(radians);
		const x2 = 50 + 50 * Math.cos(radians);
		const y2 = 50 - 50 * Math.sin(radians);
		gradient.setAttribute("x1", `${x1}%`);
		gradient.setAttribute("y1", `${y1}%`);
		gradient.setAttribute("x2", `${x2}%`);
		gradient.setAttribute("y2", `${y2}%`);
	} else {
		gradient = document.createElementNS("http://www.w3.org/2000/svg", "radialGradient");
		gradient.setAttribute("id", gradientId);
		gradient.setAttribute("cx", "50%");
		gradient.setAttribute("cy", "50%");
		gradient.setAttribute("r", "50%");
	}
	stops.forEach((stop) => {
		const stopElement = document.createElementNS("http://www.w3.org/2000/svg", "stop");
		stopElement.setAttribute("offset", `${stop.position * 100}%`);
		stopElement.setAttribute("stop-color", stop.color);
		if (stop.alpha != null && stop.alpha < 1) stopElement.setAttribute("stop-opacity", stop.alpha.toString());
		gradient.appendChild(stopElement);
	});
	return gradient;
}
function createTextElement(textContent$1, textAlign, width, height, options = {}) {
	const { textInsets, textVerticalAlign, pageNumber, pageNumberText, pageNumberDisplayNumber, pageNumberChapterText, pageNumberChapterSeparator, totalPages, sectionPageCount } = options;
	const foreignObject = document.createElementNS("http://www.w3.org/2000/svg", "foreignObject");
	foreignObject.setAttribute("x", "0");
	foreignObject.setAttribute("y", "0");
	foreignObject.setAttribute("width", width.toString());
	foreignObject.setAttribute("height", height.toString());
	const div$1 = document.createElement("div");
	div$1.style.width = "100%";
	div$1.style.height = "100%";
	div$1.style.display = "flex";
	div$1.style.flexDirection = "column";
	const verticalAlign = textVerticalAlign || "center";
	if (verticalAlign === "top") div$1.style.justifyContent = "flex-start";
	else if (verticalAlign === "bottom") div$1.style.justifyContent = "flex-end";
	else div$1.style.justifyContent = "center";
	if (textInsets) div$1.style.padding = `${textInsets.top}px ${textInsets.right}px ${textInsets.bottom}px ${textInsets.left}px`;
	else div$1.style.padding = "10px";
	div$1.style.boxSizing = "border-box";
	div$1.style.wordWrap = "break-word";
	div$1.style.overflowWrap = "break-word";
	div$1.style.fontSize = "12px";
	div$1.style.lineHeight = "1.2";
	if (textAlign === "center") div$1.style.textAlign = "center";
	else if (textAlign === "right" || textAlign === "r") div$1.style.textAlign = "right";
	else div$1.style.textAlign = "left";
	let currentParagraph = document.createElement("div");
	const resolveFieldText = (part) => {
		if (part.fieldType === "PAGE") {
			const count = pageNumberDisplayNumber ?? pageNumber ?? 1;
			if (!part.pageNumberFormat) return pageNumberText ?? String(count);
			return formatChapterPageNumberText({
				pageComponent: formatPageNumber(count, part.pageNumberFormat),
				chapterNumberText: pageNumberChapterText,
				chapterSeparator: pageNumberChapterSeparator
			});
		}
		if (part.fieldType === "NUMPAGES") {
			const count = totalPages ?? 1;
			return part.pageNumberFormat ? formatPageNumber(count, part.pageNumberFormat) : String(count);
		}
		if (part.fieldType === "SECTIONPAGES") {
			if (sectionPageCount == null) return part.text ?? "1";
			const count = sectionPageCount;
			return part.pageNumberFormat ? formatPageNumber(count, part.pageNumberFormat) : String(count);
		}
		return part.text;
	};
	textContent$1.parts.forEach((part) => {
		if (part.isLineBreak) {
			div$1.appendChild(currentParagraph);
			currentParagraph = document.createElement("div");
			if (part.isEmptyParagraph) currentParagraph.style.minHeight = "1em";
		} else {
			const span = document.createElement("span");
			span.textContent = resolveFieldText(part);
			if (part.formatting) {
				if (part.formatting.bold) span.style.fontWeight = "bold";
				if (part.formatting.italic) span.style.fontStyle = "italic";
				if (part.formatting.fontFamily) span.style.fontFamily = part.formatting.fontFamily;
				if (part.formatting.color) span.style.color = `#${part.formatting.color}`;
				if (part.formatting.fontSize) span.style.fontSize = `${part.formatting.fontSize}px`;
			}
			currentParagraph.appendChild(span);
		}
	});
	div$1.appendChild(currentParagraph);
	foreignObject.appendChild(div$1);
	return foreignObject;
}
function applyGradientToSVG$1(svg, gradientData) {
	const { gradientType, stops, angle } = gradientData;
	const gradientId = `gradient-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
	let defs = svg.querySelector("defs");
	if (!defs) {
		defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
		svg.insertBefore(defs, svg.firstChild);
	}
	let gradient;
	if (gradientType === "linear") {
		gradient = document.createElementNS("http://www.w3.org/2000/svg", "linearGradient");
		gradient.setAttribute("id", gradientId);
		const radians = angle * Math.PI / 180;
		const x1 = 50 - 50 * Math.cos(radians);
		const y1 = 50 + 50 * Math.sin(radians);
		const x2 = 50 + 50 * Math.cos(radians);
		const y2 = 50 - 50 * Math.sin(radians);
		gradient.setAttribute("x1", `${x1}%`);
		gradient.setAttribute("y1", `${y1}%`);
		gradient.setAttribute("x2", `${x2}%`);
		gradient.setAttribute("y2", `${y2}%`);
	} else {
		gradient = document.createElementNS("http://www.w3.org/2000/svg", "radialGradient");
		gradient.setAttribute("id", gradientId);
		gradient.setAttribute("cx", "50%");
		gradient.setAttribute("cy", "50%");
		gradient.setAttribute("r", "50%");
	}
	stops.forEach((stop) => {
		const stopElement = document.createElementNS("http://www.w3.org/2000/svg", "stop");
		stopElement.setAttribute("offset", `${stop.position * 100}%`);
		stopElement.setAttribute("stop-color", stop.color);
		if (stop.alpha != null && stop.alpha < 1) stopElement.setAttribute("stop-opacity", stop.alpha.toString());
		gradient.appendChild(stopElement);
	});
	defs.appendChild(gradient);
	svg.querySelectorAll("[fill]:not([fill=\"none\"])").forEach((el) => {
		el.setAttribute("fill", `url(#${gradientId})`);
	});
}
function applyAlphaToSVG$1(svg, alphaData) {
	const { color, alpha } = alphaData;
	svg.querySelectorAll("[fill]:not([fill=\"none\"])").forEach((el) => {
		el.setAttribute("fill", color);
		el.setAttribute("fill-opacity", alpha.toString());
	});
}
function generateTransforms(attrs) {
	const transforms = [];
	if (attrs.rotation != null) transforms.push(`rotate(${attrs.rotation}deg)`);
	if (attrs.flipH) transforms.push(`scaleX(-1)`);
	if (attrs.flipV) transforms.push(`scaleY(-1)`);
	return transforms;
}
var VectorShapeView = class {
	node;
	view;
	getPos;
	decorations;
	innerDecorations;
	editor;
	extension;
	htmlAttributes;
	root;
	constructor(props) {
		this.node = props.node;
		this.view = props.editor.view;
		this.getPos = props.getPos;
		this.decorations = props.decorations;
		this.innerDecorations = props.innerDecorations;
		this.editor = props.editor;
		this.extension = props.extension;
		this.htmlAttributes = props.htmlAttributes;
		this.mount();
	}
	mount() {
		this.buildView();
		this.#ensureParentPositioned();
	}
	#ensureParentPositioned() {
		if (this.node.attrs.wrap?.type !== "None") return;
		if (typeof globalThis !== "undefined" && globalThis.requestAnimationFrame) globalThis.requestAnimationFrame(() => {
			try {
				const parent = this.root?.parentElement;
				if (parent && parent.tagName === "P") parent.style.position = "relative";
			} catch (error) {
				console.warn("Failed to position parent element for vector shape:", error);
			}
		});
	}
	get dom() {
		return this.root;
	}
	get contentDOM() {
		return null;
	}
	createElement() {
		const attrs = this.node.attrs;
		const element = document.createElement("span");
		element.classList.add("sd-vector-shape");
		element.setAttribute("data-vector-shape", "");
		const effectExtent = attrs.effectExtent || null;
		const extentLeft = effectExtent?.left ?? 0;
		const extentTop = effectExtent?.top ?? 0;
		const extentRight = effectExtent?.right ?? 0;
		const extentBottom = effectExtent?.bottom ?? 0;
		const baseWidth = attrs.width ?? 0;
		const baseHeight = attrs.height ?? 0;
		const outerWidth = baseWidth + extentLeft + extentRight;
		const outerHeight = baseHeight + extentTop + extentBottom;
		element.style.width = `${outerWidth}px`;
		element.style.height = `${outerHeight}px`;
		const positioningStyle = this.getPositioningStyle(attrs);
		if (positioningStyle) element.style.cssText += positioningStyle;
		if (effectExtent && (!element.style.position || element.style.position === "static")) element.style.position = "relative";
		const transforms = this.generateTransform();
		const positioningTransform = element.style.transform;
		const combinedTransforms = [];
		if (positioningTransform && positioningTransform.trim() !== "") combinedTransforms.push(positioningTransform.trim());
		if (Array.isArray(transforms) && transforms.length > 0) {
			const validTransforms = transforms.filter((t) => t !== null && t !== void 0 && typeof t === "string" && t.trim() !== "");
			if (validTransforms.length > 0) combinedTransforms.push(...validTransforms);
		}
		if (combinedTransforms.length > 0) element.style.transform = combinedTransforms.join(" ");
		const svg = this.createSVGElement(attrs);
		if (svg) {
			if (effectExtent) {
				svg.style.position = "absolute";
				svg.style.left = `${extentLeft}px`;
				svg.style.top = `${extentTop}px`;
			}
			this.applyLineEnds(svg, attrs);
			element.appendChild(svg);
			if (attrs.textContent && attrs.textContent.parts) {
				const pageNumber = this.editor?.options?.currentPageNumber;
				const pageNumberText = this.editor?.options?.currentPageNumberText;
				const pageNumberDisplayNumber = this.editor?.options?.currentPageDisplayNumber;
				const pageNumberChapterText = this.editor?.options?.currentPageChapterNumberText;
				const pageNumberChapterSeparator = this.editor?.options?.currentPageChapterSeparator;
				const totalPages = this.editor?.options?.totalPageCount;
				const sectionPageCount = this.editor?.options?.sectionPageCount;
				const textElement = this.createTextElement(attrs.textContent, attrs.textAlign, attrs.width, attrs.height, {
					textVerticalAlign: attrs.textVerticalAlign,
					textInsets: attrs.textInsets,
					pageNumber,
					pageNumberText,
					pageNumberDisplayNumber,
					pageNumberChapterText,
					pageNumberChapterSeparator,
					totalPages,
					sectionPageCount
				});
				if (textElement) svg.appendChild(textElement);
			}
		}
		return { element };
	}
	getPositioningStyle(attrs) {
		const { anchorData, marginOffset, wrap, originalAttributes } = attrs;
		if (!anchorData && !marginOffset?.horizontal && !marginOffset?.top) return "";
		let style = "";
		const margin = {
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		};
		let centered = false;
		let floatRight = false;
		let baseHorizontal = marginOffset?.horizontal || 0;
		if (wrap?.type === "None") {
			style += "position: absolute;";
			const relativeHeight = originalAttributes?.relativeHeight;
			if (relativeHeight != null) {
				const zIndex = Math.max(0, relativeHeight - OOXML_Z_INDEX_BASE);
				style += `z-index: ${zIndex};`;
			} else if (wrap?.attrs?.behindDoc) style += "z-index: -1;";
			else style += "z-index: 1;";
		}
		if (anchorData) switch (anchorData.hRelativeFrom) {
			case "page":
				const pageStyles$1 = this.editor?.converter?.pageStyles || this.editor?.options?.parentEditor?.converter?.pageStyles;
				margin.left -= inchesToPixels(pageStyles$1?.pageMargins?.left) || 0;
				break;
			case "margin":
				if (anchorData.alignH === "center") style += "position: absolute; left: 50%; transform: translateX(-50%);";
				if (anchorData.alignH === "left" || anchorData.alignH === "right") style += `position: absolute; ${anchorData.alignH}: 0;`;
				break;
			case "column":
				if (anchorData.alignH === "center") centered = true;
				else if (anchorData.alignH === "right") {
					floatRight = true;
					if (!style.includes("float: right;")) style += "float: right;";
				} else if (anchorData.alignH === "left") {
					if (!style.includes("float: left;")) style += "float: left;";
				} else if (!anchorData.alignH && marginOffset?.horizontal != null) {
					if (style.includes("position: absolute;")) {
						style += `left: ${baseHorizontal}px;`;
						baseHorizontal = 0;
					}
				}
				break;
			default: break;
		}
		const isAbsolutelyPositioned = style.includes("position: absolute;");
		if (anchorData || marginOffset?.horizontal != null || marginOffset?.top != null) {
			const horizontal = baseHorizontal;
			const top$1 = marginOffset?.top ?? 0;
			if (isAbsolutelyPositioned) {
				if (horizontal && !style.includes("left:")) style += `left: ${horizontal}px;`;
				if (top$1 != null) style += `top: ${top$1}px;`;
			} else {
				if (horizontal) if (floatRight) margin.right += horizontal;
				else margin.left += horizontal;
				if (top$1 > 0) margin.top += top$1;
			}
		}
		if (centered) style += "margin-left: auto; margin-right: auto;";
		else if (!isAbsolutelyPositioned) {
			if (margin.left) style += `margin-left: ${margin.left}px;`;
			if (margin.right) style += `margin-right: ${margin.right}px;`;
		}
		if (!isAbsolutelyPositioned && margin.top) style += `margin-top: ${margin.top}px;`;
		if (margin.bottom) style += `margin-bottom: ${margin.bottom}px;`;
		return style;
	}
	generateTransform() {
		return generateTransforms(this.node.attrs);
	}
	createSVGElement(attrs) {
		const { kind, fillColor, strokeColor, strokeWidth, width, height } = attrs;
		const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
		svg.setAttribute("width", width.toString());
		svg.setAttribute("height", height.toString());
		svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
		svg.style.display = "block";
		const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
		svg.appendChild(defs);
		let fill = "none";
		let fillOpacity = 1;
		if (fillColor) if (typeof fillColor === "object") {
			if (fillColor.type === "gradient") {
				const gradientId = `gradient-${Math.random().toString(36).slice(2, 11)}-${Date.now()}`;
				const gradient = this.createGradient(fillColor, gradientId);
				if (gradient) {
					defs.appendChild(gradient);
					fill = `url(#${gradientId})`;
				}
			} else if (fillColor.type === "solidWithAlpha") {
				fill = fillColor.color;
				fillOpacity = fillColor.alpha;
			}
		} else fill = fillColor;
		const stroke = strokeColor === null ? "none" : strokeColor || "none";
		const strokeW = strokeColor === null ? 0 : strokeColor ? strokeWidth || 1 : 0;
		let shapeElement;
		switch (kind) {
			case "rect":
				shapeElement = document.createElementNS("http://www.w3.org/2000/svg", "rect");
				shapeElement.setAttribute("x", "0");
				shapeElement.setAttribute("y", "0");
				shapeElement.setAttribute("width", width.toString());
				shapeElement.setAttribute("height", height.toString());
				break;
			case "roundRect":
				shapeElement = document.createElementNS("http://www.w3.org/2000/svg", "rect");
				shapeElement.setAttribute("x", "0");
				shapeElement.setAttribute("y", "0");
				shapeElement.setAttribute("width", width.toString());
				shapeElement.setAttribute("height", height.toString());
				const radius = Math.min(width, height) * .05;
				shapeElement.setAttribute("rx", radius.toString());
				shapeElement.setAttribute("ry", radius.toString());
				break;
			case "ellipse":
				shapeElement = document.createElementNS("http://www.w3.org/2000/svg", "ellipse");
				shapeElement.setAttribute("cx", (width / 2).toString());
				shapeElement.setAttribute("cy", (height / 2).toString());
				shapeElement.setAttribute("rx", (width / 2).toString());
				shapeElement.setAttribute("ry", (height / 2).toString());
				break;
			case "circle":
				shapeElement = document.createElementNS("http://www.w3.org/2000/svg", "ellipse");
				shapeElement.setAttribute("cx", (width / 2).toString());
				shapeElement.setAttribute("cy", (height / 2).toString());
				shapeElement.setAttribute("rx", (width / 2).toString());
				shapeElement.setAttribute("ry", (height / 2).toString());
				break;
			case "line":
			case "straightConnector1":
				shapeElement = document.createElementNS("http://www.w3.org/2000/svg", "line");
				shapeElement.setAttribute("x1", "0");
				shapeElement.setAttribute("y1", "0");
				shapeElement.setAttribute("x2", width.toString());
				shapeElement.setAttribute("y2", height.toString());
				break;
			default:
				try {
					const svgTemplate = this.generateSVG({
						kind,
						fillColor,
						strokeColor,
						strokeWidth,
						width,
						height
					});
					if (svgTemplate) {
						const tempDiv = document.createElement("div");
						tempDiv.innerHTML = svgTemplate;
						const tempSvg = tempDiv.querySelector("svg");
						if (tempSvg) {
							tempSvg.setAttribute("width", width.toString());
							tempSvg.setAttribute("height", height.toString());
							tempSvg.setAttribute("preserveAspectRatio", "none");
							tempSvg.style.width = `${width}px`;
							tempSvg.style.height = `${height}px`;
							tempSvg.style.display = "block";
							return tempSvg;
						}
					}
				} catch (error) {
					console.warn("Failed to generate SVG for shape:", kind, error);
					return null;
				}
				return null;
		}
		shapeElement.setAttribute("fill", fill);
		if (fillOpacity < 1) shapeElement.setAttribute("fill-opacity", fillOpacity.toString());
		shapeElement.setAttribute("stroke", stroke);
		shapeElement.setAttribute("stroke-width", strokeW.toString());
		svg.appendChild(shapeElement);
		return svg;
	}
	applyLineEnds(svg, attrs) {
		const lineEnds = attrs.lineEnds;
		if (!lineEnds) return;
		if (attrs.strokeColor === null) return;
		const strokeColor = typeof attrs.strokeColor === "string" ? attrs.strokeColor : "#000000";
		const strokeWidth = attrs.strokeWidth ?? 1;
		if (strokeWidth <= 0) return;
		const target = svg.querySelector("line") || svg.querySelector("path") || svg.querySelector("polyline");
		if (!target) return;
		const defs = svg.querySelector("defs") || svg.insertBefore(document.createElementNS("http://www.w3.org/2000/svg", "defs"), svg.firstChild);
		const idBase = `line-end-${Math.random().toString(36).slice(2, 8)}-${Date.now()}`;
		if (lineEnds.tail) {
			const id = `${idBase}-tail`;
			this.createLineEndMarker(defs, id, lineEnds.tail, strokeColor, strokeWidth, true, attrs.effectExtent);
			target.setAttribute("marker-start", `url(#${id})`);
		}
		if (lineEnds.head) {
			const id = `${idBase}-head`;
			this.createLineEndMarker(defs, id, lineEnds.head, strokeColor, strokeWidth, false, attrs.effectExtent);
			target.setAttribute("marker-end", `url(#${id})`);
		}
	}
	createLineEndMarker(defs, id, lineEnd, strokeColor, _strokeWidth, isStart, effectExtent) {
		if (defs.querySelector(`#${id}`)) return;
		const marker = document.createElementNS("http://www.w3.org/2000/svg", "marker");
		marker.setAttribute("id", id);
		marker.setAttribute("viewBox", "0 0 10 10");
		marker.setAttribute("orient", "auto");
		const sizeScale = (value) => {
			if (value === "sm") return .75;
			if (value === "lg") return 1.25;
			return 1;
		};
		const effectMax = effectExtent ? Math.max(effectExtent.left || 0, effectExtent.right || 0, effectExtent.top || 0, effectExtent.bottom || 0) : 0;
		const useEffectExtent = Number.isFinite(effectMax) && effectMax > 0;
		const markerWidth = useEffectExtent ? effectMax * 2 : 4 * sizeScale(lineEnd.length);
		const markerHeight = useEffectExtent ? effectMax * 2 : 4 * sizeScale(lineEnd.width);
		marker.setAttribute("markerUnits", useEffectExtent ? "userSpaceOnUse" : "strokeWidth");
		marker.setAttribute("markerWidth", markerWidth.toString());
		marker.setAttribute("markerHeight", markerHeight.toString());
		marker.setAttribute("refX", isStart ? "0" : "10");
		marker.setAttribute("refY", "5");
		const shape = this.createLineEndShape(lineEnd.type || "triangle", strokeColor, isStart);
		marker.appendChild(shape);
		defs.appendChild(marker);
	}
	createLineEndShape(type, strokeColor, isStart) {
		const normalized = type.toLowerCase();
		if (normalized === "diamond") {
			const path$1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
			path$1.setAttribute("d", "M 0 5 L 5 0 L 10 5 L 5 10 Z");
			path$1.setAttribute("fill", strokeColor);
			path$1.setAttribute("stroke", "none");
			return path$1;
		}
		if (normalized === "oval") {
			const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
			circle.setAttribute("cx", "5");
			circle.setAttribute("cy", "5");
			circle.setAttribute("r", "5");
			circle.setAttribute("fill", strokeColor);
			circle.setAttribute("stroke", "none");
			return circle;
		}
		const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
		const d = isStart ? "M 10 0 L 0 5 L 10 10 Z" : "M 0 0 L 10 5 L 0 10 Z";
		path.setAttribute("d", d);
		path.setAttribute("fill", strokeColor);
		path.setAttribute("stroke", "none");
		return path;
	}
	createGradient(gradientData, gradientId) {
		return createGradient$1(gradientData, gradientId);
	}
	generateSVG({ kind, fillColor, strokeColor, strokeWidth, width, height }) {
		try {
			let fill = fillColor || "none";
			if (fillColor && typeof fillColor === "object") {
				if (fillColor.type === "gradient") fill = "#cccccc";
				else if (fillColor.type === "solidWithAlpha") fill = fillColor.color;
			}
			return k0({
				preset: kind,
				styleOverrides: {
					fill,
					stroke: strokeColor || "none",
					strokeWidth: strokeWidth || 0
				},
				width,
				height
			});
		} catch {
			return null;
		}
	}
	applyGradientToSVG(svg, gradientData) {
		applyGradientToSVG$1(svg, gradientData);
	}
	applyAlphaToSVG(svg, alphaData) {
		applyAlphaToSVG$1(svg, alphaData);
	}
	createTextElement(textContent$1, textAlign, width, height, options) {
		return createTextElement(textContent$1, textAlign, width, height, options);
	}
	buildView() {
		const { element } = this.createElement();
		this.root = element;
	}
	update() {
		return false;
	}
};
const VectorShape = Node$1.create({
	name: "vectorShape",
	group: "inline",
	inline: true,
	atom: true,
	addOptions() {
		return { htmlAttributes: {} };
	},
	addAttributes() {
		return {
			kind: {
				default: "rect",
				renderDOM: (attrs) => {
					if (!attrs.kind) return {};
					return { "data-kind": attrs.kind };
				}
			},
			width: {
				default: 100,
				renderDOM: (attrs) => {
					if (attrs.width == null) return {};
					return { "data-width": attrs.width };
				}
			},
			height: {
				default: 100,
				renderDOM: (attrs) => {
					if (attrs.height == null) return {};
					return { "data-height": attrs.height };
				}
			},
			fillColor: {
				default: null,
				renderDOM: (attrs) => {
					if (!attrs.fillColor) return {};
					return { "data-fill-color": attrs.fillColor };
				}
			},
			strokeColor: {
				default: null,
				renderDOM: (attrs) => {
					if (!attrs.strokeColor) return {};
					return { "data-stroke-color": attrs.strokeColor };
				}
			},
			strokeWidth: {
				default: 1,
				renderDOM: (attrs) => {
					if (attrs.strokeWidth == null) return {};
					return { "data-stroke-width": attrs.strokeWidth };
				}
			},
			customGeometry: {
				default: null,
				rendered: false
			},
			lineEnds: {
				default: null,
				rendered: false
			},
			hidden: {
				default: false,
				rendered: false
			},
			effectExtent: {
				default: null,
				rendered: false
			},
			rotation: {
				default: 0,
				renderDOM: (attrs) => {
					if (attrs.rotation == null) return {};
					return { "data-rotation": attrs.rotation };
				}
			},
			flipH: {
				default: false,
				renderDOM: (attrs) => {
					if (!attrs.flipH) return {};
					return { "data-flip-h": attrs.flipH };
				}
			},
			flipV: {
				default: false,
				renderDOM: (attrs) => {
					if (!attrs.flipV) return {};
					return { "data-flip-v": attrs.flipV };
				}
			},
			wrap: {
				default: { type: "Inline" },
				rendered: false
			},
			anchorData: {
				default: null,
				renderDOM: ({ anchorData, originalAttributes }) => {
					const relativeHeight = originalAttributes?.relativeHeight;
					if (anchorData && relativeHeight) return { style: `z-index: ${Math.max(0, relativeHeight - OOXML_Z_INDEX_BASE)}` };
				}
			},
			isAnchor: { rendered: false },
			marginOffset: {
				default: {},
				rendered: false
			},
			drawingContent: { rendered: false },
			originalAttributes: { rendered: false },
			textContent: {
				default: null,
				rendered: false
			},
			textAlign: {
				default: "center",
				rendered: false
			},
			textVerticalAlign: {
				default: "top",
				rendered: false
			},
			textInsets: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return false;
	},
	renderDOM({ htmlAttributes }) {
		return ["span", Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes, { "data-vector-shape": "" })];
	},
	addNodeView() {
		return (props) => {
			return new VectorShapeView({ ...props });
		};
	}
});
var ShapeGroupView = class {
	node;
	view;
	getPos;
	decorations;
	innerDecorations;
	editor;
	extension;
	htmlAttributes;
	root;
	constructor(props) {
		this.node = props.node;
		this.view = props.editor.view;
		this.getPos = props.getPos;
		this.decorations = props.decorations;
		this.innerDecorations = props.innerDecorations;
		this.editor = props.editor;
		this.extension = props.extension;
		this.htmlAttributes = props.htmlAttributes;
		this.mount();
	}
	mount() {
		this.buildView();
		this.#ensureParentPositioned();
	}
	#ensureParentPositioned() {
		if ((this.node.attrs.wrap?.type || "Inline") !== "None") return;
		if (typeof globalThis !== "undefined" && globalThis.requestAnimationFrame) globalThis.requestAnimationFrame(() => {
			try {
				const parent = this.root?.parentElement;
				if (parent && parent.tagName === "P") parent.style.position = "relative";
			} catch (error) {
				console.warn("Failed to position parent element for shape group:", error);
			}
		});
	}
	get dom() {
		return this.root;
	}
	get contentDOM() {
		return null;
	}
	createElement() {
		const { groupTransform, shapes, size: size$1, marginOffset, originalAttributes, wrap, anchorData } = this.node.attrs;
		const container = document.createElement("div");
		container.classList.add("sd-shape-group");
		container.setAttribute("data-shape-group", "");
		const width = size$1?.width || groupTransform?.width || 300;
		const height = size$1?.height || groupTransform?.height || 200;
		container.style.width = `${width}px`;
		container.style.height = `${height}px`;
		container.style.position = "relative";
		container.style.display = "inline-block";
		const wrapType = wrap?.type || "Inline";
		if (wrapType === "None") {
			container.style.position = "absolute";
			if (marginOffset?.horizontal != null) container.style.left = `${marginOffset.horizontal}px`;
			if (anchorData?.hRelativeFrom === "column" && !anchorData?.alignH && marginOffset?.horizontal != null) container.style.maxWidth = "none";
			if (marginOffset?.top != null) container.style.top = `${marginOffset.top}px`;
			const relativeHeight = originalAttributes?.relativeHeight;
			if (relativeHeight != null) {
				const zIndex = Math.max(0, relativeHeight - OOXML_Z_INDEX_BASE);
				container.style.zIndex = zIndex.toString();
			} else container.style.zIndex = "1";
		} else if (wrapType === "Square") {
			container.style.float = "left";
			container.style.clear = "both";
			if (marginOffset?.horizontal != null) container.style.marginLeft = `${marginOffset.horizontal}px`;
			if (marginOffset?.top != null) container.style.marginTop = `${marginOffset.top}px`;
			if (wrap?.attrs?.distLeft) container.style.marginLeft = `${(marginOffset?.horizontal || 0) + wrap.attrs.distLeft}px`;
			if (wrap?.attrs?.distRight) container.style.marginRight = `${wrap.attrs.distRight}px`;
			if (wrap?.attrs?.distTop) container.style.marginTop = `${(marginOffset?.top || 0) + wrap.attrs.distTop}px`;
			if (wrap?.attrs?.distBottom) container.style.marginBottom = `${wrap.attrs.distBottom}px`;
		} else {
			if (marginOffset?.horizontal != null) container.style.marginLeft = `${marginOffset.horizontal}px`;
			if (marginOffset?.top != null) container.style.marginTop = `${marginOffset.top}px`;
		}
		const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
		svg.setAttribute("version", "1.1");
		svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
		svg.setAttribute("width", width.toString());
		svg.setAttribute("height", height.toString());
		svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
		svg.style.display = "block";
		const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
		svg.appendChild(defs);
		if (shapes && Array.isArray(shapes)) shapes.forEach((shape, index) => {
			if (shape.shapeType === "vectorShape") {
				const shapeElement = this.createShapeElement(shape, groupTransform, defs, index);
				if (shapeElement) svg.appendChild(shapeElement);
			} else if (shape.shapeType === "image") {
				const imageElement = this.createImageElement(shape, groupTransform);
				if (imageElement) svg.appendChild(imageElement);
			}
		});
		container.appendChild(svg);
		return { element: container };
	}
	createShapeElement(shape, groupTransform, defs, shapeIndex) {
		const attrs = shape.attrs;
		if (!attrs) return null;
		const x = attrs.x ?? 0;
		const y$1 = attrs.y ?? 0;
		const width = attrs.width ?? 100;
		const height = attrs.height ?? 100;
		const g$1 = document.createElementNS("http://www.w3.org/2000/svg", "g");
		const transforms = [];
		transforms.push(`translate(${x}, ${y$1})`);
		if (attrs.rotation !== 0) transforms.push(`rotate(${attrs.rotation} ${width / 2} ${height / 2})`);
		if (attrs.flipH) transforms.push(`scale(-1, 1) translate(${-width}, 0)`);
		if (attrs.flipV) transforms.push(`scale(1, -1) translate(0, ${-height})`);
		if (transforms.length > 0) g$1.setAttribute("transform", transforms.join(" "));
		const shapeKind = attrs.kind;
		const customGeometry = attrs.customGeometry;
		const fillColor = attrs.fillColor === null ? null : attrs.fillColor ?? "#5b9bd5";
		const strokeColor = attrs.strokeColor === null ? null : attrs.strokeColor ?? "#000000";
		const strokeWidth = attrs.strokeWidth ?? 1;
		const lineEnds = attrs.lineEnds;
		let fillValue = fillColor;
		if (fillColor && typeof fillColor === "object" && fillColor.type === "gradient") {
			const gradientId = `gradient-${shapeIndex}-${Date.now()}-${Math.floor(Math.random() * 1e9)}`;
			const gradient = this.createGradient(fillColor, gradientId);
			defs.appendChild(gradient);
			fillValue = `url(#${gradientId})`;
		} else if (fillColor === null) fillValue = "none";
		else if (typeof fillColor === "string") fillValue = fillColor;
		if (shapeKind === "line") {
			const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
			line.setAttribute("x1", "0");
			line.setAttribute("y1", "0");
			line.setAttribute("x2", width.toString());
			line.setAttribute("y2", height.toString());
			line.setAttribute("stroke", strokeColor === null ? "none" : strokeColor);
			line.setAttribute("stroke-width", (strokeColor === null ? 0 : strokeWidth).toString());
			if (lineEnds && strokeColor !== null) {
				const markerBase = `line-end-${shapeIndex}-${Date.now()}-${Math.floor(Math.random() * 1e9)}`;
				this.applyLineEndsToTarget(line, lineEnds, strokeColor, strokeWidth, defs, markerBase);
			}
			g$1.appendChild(line);
			if (attrs.textContent && attrs.textContent.parts) {
				const pageNumber = this.editor?.options?.currentPageNumber;
				const pageNumberText = this.editor?.options?.currentPageNumberText;
				const pageNumberDisplayNumber = this.editor?.options?.currentPageDisplayNumber;
				const pageNumberChapterText = this.editor?.options?.currentPageChapterNumberText;
				const pageNumberChapterSeparator = this.editor?.options?.currentPageChapterSeparator;
				const totalPages = this.editor?.options?.totalPageCount;
				const sectionPageCount = this.editor?.options?.sectionPageCount;
				const textGroup = this.createTextElement(attrs.textContent, attrs.textAlign, width, height, {
					textVerticalAlign: attrs.textVerticalAlign,
					textInsets: attrs.textInsets,
					pageNumber,
					pageNumberText,
					pageNumberDisplayNumber,
					pageNumberChapterText,
					pageNumberChapterSeparator,
					totalPages,
					sectionPageCount
				});
				if (textGroup) g$1.appendChild(textGroup);
			}
			return g$1;
		}
		if (customGeometry?.paths?.length) {
			const fillStr = fillValue === null ? "none" : typeof fillValue === "string" ? fillValue : "none";
			const strokeStr = strokeColor === null ? "none" : strokeColor;
			const strokeW = strokeColor === null ? 0 : strokeWidth;
			const firstPath = customGeometry.paths[0];
			const viewW = firstPath.w || width;
			const viewH = firstPath.h || height;
			if (viewW > 0 && viewH > 0) {
				const needsEdgeStroke = fillStr !== "none" && strokeStr === "none";
				const innerSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
				innerSvg.setAttribute("x", "0");
				innerSvg.setAttribute("y", "0");
				innerSvg.setAttribute("width", width.toString());
				innerSvg.setAttribute("height", height.toString());
				innerSvg.setAttribute("viewBox", `0 0 ${viewW} ${viewH}`);
				innerSvg.setAttribute("preserveAspectRatio", "none");
				for (const pathData of customGeometry.paths) {
					const pathEl = document.createElementNS("http://www.w3.org/2000/svg", "path");
					pathEl.setAttribute("d", pathData.d);
					pathEl.setAttribute("fill", fillStr);
					pathEl.setAttribute("fill-rule", "evenodd");
					if (strokeStr !== "none") {
						pathEl.setAttribute("stroke", strokeStr);
						pathEl.setAttribute("stroke-width", strokeW.toString());
					} else if (needsEdgeStroke) {
						pathEl.setAttribute("stroke", fillStr);
						pathEl.setAttribute("stroke-width", "0.5");
						pathEl.setAttribute("vector-effect", "non-scaling-stroke");
					} else {
						pathEl.setAttribute("stroke", "none");
						pathEl.setAttribute("stroke-width", "0");
					}
					const pathW = pathData.w || viewW;
					const pathH = pathData.h || viewH;
					if (pathW !== viewW || pathH !== viewH) {
						const scaleX = viewW / pathW;
						const scaleY = viewH / pathH;
						pathEl.setAttribute("transform", `scale(${scaleX}, ${scaleY})`);
					}
					innerSvg.appendChild(pathEl);
				}
				g$1.appendChild(innerSvg);
			}
			if (attrs.textContent && attrs.textContent.parts) {
				const pageNumber = this.editor?.options?.currentPageNumber;
				const pageNumberText = this.editor?.options?.currentPageNumberText;
				const pageNumberDisplayNumber = this.editor?.options?.currentPageDisplayNumber;
				const pageNumberChapterText = this.editor?.options?.currentPageChapterNumberText;
				const pageNumberChapterSeparator = this.editor?.options?.currentPageChapterSeparator;
				const totalPages = this.editor?.options?.totalPageCount;
				const sectionPageCount = this.editor?.options?.sectionPageCount;
				const textGroup = this.createTextElement(attrs.textContent, attrs.textAlign, width, height, {
					textVerticalAlign: attrs.textVerticalAlign,
					textInsets: attrs.textInsets,
					pageNumber,
					pageNumberText,
					pageNumberDisplayNumber,
					pageNumberChapterText,
					pageNumberChapterSeparator,
					totalPages,
					sectionPageCount
				});
				if (textGroup) g$1.appendChild(textGroup);
			}
			return g$1;
		}
		try {
			const svgContent = k0({
				preset: shapeKind || "rect",
				styleOverrides: {
					fill: fillValue || "none",
					stroke: strokeColor === null ? "none" : strokeColor,
					strokeWidth: strokeColor === null ? 0 : strokeWidth
				},
				width,
				height
			});
			if (svgContent) {
				const tempDiv = document.createElement("div");
				tempDiv.innerHTML = svgContent;
				const svgElement = tempDiv.querySelector("svg");
				if (svgElement) {
					const markerBase = lineEnds ? `line-end-${shapeIndex}-${Date.now()}-${Math.floor(Math.random() * 1e9)}` : null;
					let lineEndsApplied = false;
					Array.from(svgElement.children).forEach((child) => {
						const clonedChild = child.cloneNode(true);
						if (clonedChild.tagName === "ellipse") {
							clonedChild.setAttribute("cx", (width / 2).toString());
							clonedChild.setAttribute("cy", (height / 2).toString());
							clonedChild.setAttribute("rx", (width / 2).toString());
							clonedChild.setAttribute("ry", (height / 2).toString());
						} else if (clonedChild.tagName === "circle") if (width !== height) {
							const ellipse = document.createElementNS("http://www.w3.org/2000/svg", "ellipse");
							ellipse.setAttribute("cx", (width / 2).toString());
							ellipse.setAttribute("cy", (height / 2).toString());
							ellipse.setAttribute("rx", (width / 2).toString());
							ellipse.setAttribute("ry", (height / 2).toString());
							Array.from(clonedChild.attributes).forEach((attr) => {
								if (![
									"cx",
									"cy",
									"r"
								].includes(attr.name)) ellipse.setAttribute(attr.name, attr.value);
							});
							g$1.appendChild(ellipse);
							return;
						} else {
							clonedChild.setAttribute("cx", (width / 2).toString());
							clonedChild.setAttribute("cy", (height / 2).toString());
							clonedChild.setAttribute("r", (width / 2).toString());
						}
						else if (clonedChild.tagName === "rect") {
							clonedChild.setAttribute("width", width.toString());
							clonedChild.setAttribute("height", height.toString());
						} else if (clonedChild.tagName === "path" && svgElement.hasAttribute("viewBox")) {
							const viewBox = svgElement.getAttribute("viewBox").split(" ").map(Number);
							if (viewBox.length === 4) {
								const [, , vbWidth, vbHeight] = viewBox;
								const scaleX = width / vbWidth;
								const scaleY = height / vbHeight;
								if (scaleX !== 1 || scaleY !== 1) {
									const pathTransform = `scale(${scaleX}, ${scaleY})`;
									const existingTransform = clonedChild.getAttribute("transform");
									clonedChild.setAttribute("transform", existingTransform ? `${existingTransform} ${pathTransform}` : pathTransform);
								}
							}
						} else if (clonedChild.hasAttribute("width")) clonedChild.setAttribute("width", width.toString());
						if (clonedChild.hasAttribute("height") && clonedChild.tagName !== "ellipse") clonedChild.setAttribute("height", height.toString());
						if (lineEnds && !lineEndsApplied && (clonedChild.tagName === "path" || clonedChild.tagName === "line" || clonedChild.tagName === "polyline")) {
							this.applyLineEndsToTarget(clonedChild, lineEnds, strokeColor, strokeWidth, defs, markerBase);
							lineEndsApplied = true;
						}
						g$1.appendChild(clonedChild);
					});
				}
			}
		} catch (error) {
			console.warn("Failed to generate shape SVG:", error);
			const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
			rect.setAttribute("width", width.toString());
			rect.setAttribute("height", height.toString());
			rect.setAttribute("fill", fillColor === null ? "none" : typeof fillColor === "string" ? fillColor : "#cccccc");
			rect.setAttribute("stroke", strokeColor === null ? "none" : strokeColor);
			rect.setAttribute("stroke-width", strokeColor === null ? "0" : strokeWidth.toString());
			g$1.appendChild(rect);
		}
		if (attrs.textContent && attrs.textContent.parts) {
			const pageNumber = this.editor?.options?.currentPageNumber;
			const pageNumberText = this.editor?.options?.currentPageNumberText;
			const pageNumberDisplayNumber = this.editor?.options?.currentPageDisplayNumber;
			const pageNumberChapterText = this.editor?.options?.currentPageChapterNumberText;
			const pageNumberChapterSeparator = this.editor?.options?.currentPageChapterSeparator;
			const totalPages = this.editor?.options?.totalPageCount;
			const sectionPageCount = this.editor?.options?.sectionPageCount;
			const textGroup = this.createTextElement(attrs.textContent, attrs.textAlign, width, height, {
				textVerticalAlign: attrs.textVerticalAlign,
				textInsets: attrs.textInsets,
				pageNumber,
				pageNumberText,
				pageNumberDisplayNumber,
				pageNumberChapterText,
				pageNumberChapterSeparator,
				totalPages,
				sectionPageCount
			});
			if (textGroup) g$1.appendChild(textGroup);
		}
		return g$1;
	}
	createTextElement(textContent$1, textAlign, width, height, options) {
		return createTextElement(textContent$1, textAlign, width, height, options);
	}
	applyLineEndsToTarget(target, lineEnds, strokeColor, strokeWidth, defs, markerBase) {
		if (!lineEnds || strokeColor === null || strokeWidth <= 0) return;
		if (lineEnds.tail) {
			const id = `${markerBase}-tail`;
			this.createLineEndMarker(defs, id, lineEnds.tail, strokeColor, strokeWidth, true, null);
			target.setAttribute("marker-start", `url(#${id})`);
		}
		if (lineEnds.head) {
			const id = `${markerBase}-head`;
			this.createLineEndMarker(defs, id, lineEnds.head, strokeColor, strokeWidth, false, null);
			target.setAttribute("marker-end", `url(#${id})`);
		}
	}
	createLineEndMarker(defs, id, lineEnd, strokeColor, _strokeWidth, isStart, effectExtent) {
		if (defs.querySelector(`#${id}`)) return;
		const marker = document.createElementNS("http://www.w3.org/2000/svg", "marker");
		marker.setAttribute("id", id);
		marker.setAttribute("viewBox", "0 0 10 10");
		marker.setAttribute("orient", "auto");
		const sizeScale = (value) => {
			if (value === "sm") return .75;
			if (value === "lg") return 1.25;
			return 1;
		};
		const effectMax = effectExtent ? Math.max(effectExtent.left || 0, effectExtent.right || 0, effectExtent.top || 0, effectExtent.bottom || 0) : 0;
		const useEffectExtent = Number.isFinite(effectMax) && effectMax > 0;
		const markerWidth = useEffectExtent ? effectMax * 2 : 4 * sizeScale(lineEnd.length);
		const markerHeight = useEffectExtent ? effectMax * 2 : 4 * sizeScale(lineEnd.width);
		marker.setAttribute("markerUnits", useEffectExtent ? "userSpaceOnUse" : "strokeWidth");
		marker.setAttribute("markerWidth", markerWidth.toString());
		marker.setAttribute("markerHeight", markerHeight.toString());
		marker.setAttribute("refX", isStart ? "0" : "10");
		marker.setAttribute("refY", "5");
		const shape = this.createLineEndShape(lineEnd.type || "triangle", strokeColor, isStart);
		marker.appendChild(shape);
		defs.appendChild(marker);
	}
	createLineEndShape(type, strokeColor, isStart) {
		const normalized = type.toLowerCase();
		if (normalized === "diamond") {
			const path$1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
			path$1.setAttribute("d", "M 0 5 L 5 0 L 10 5 L 5 10 Z");
			path$1.setAttribute("fill", strokeColor);
			path$1.setAttribute("stroke", "none");
			return path$1;
		}
		if (normalized === "oval") {
			const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
			circle.setAttribute("cx", "5");
			circle.setAttribute("cy", "5");
			circle.setAttribute("r", "5");
			circle.setAttribute("fill", strokeColor);
			circle.setAttribute("stroke", "none");
			return circle;
		}
		const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
		const d = isStart ? "M 10 0 L 0 5 L 10 10 Z" : "M 0 0 L 10 5 L 0 10 Z";
		path.setAttribute("d", d);
		path.setAttribute("fill", strokeColor);
		path.setAttribute("stroke", "none");
		return path;
	}
	createGradient(gradientData, gradientId) {
		return createGradient$1(gradientData, gradientId);
	}
	createImageElement(shape, _groupTransform) {
		const attrs = shape.attrs;
		if (!attrs) return null;
		const x = attrs.x || 0;
		const y$1 = attrs.y || 0;
		const width = attrs.width || 100;
		const height = attrs.height || 100;
		const image = document.createElementNS("http://www.w3.org/2000/svg", "image");
		image.setAttribute("x", x.toString());
		image.setAttribute("y", y$1.toString());
		image.setAttribute("width", width.toString());
		image.setAttribute("height", height.toString());
		const src = this.editor?.storage?.image?.media?.[attrs.src] ?? attrs.src;
		image.setAttribute("href", src);
		image.setAttribute("preserveAspectRatio", "none");
		return image;
	}
	buildView() {
		const { element } = this.createElement();
		this.root = element;
	}
	update() {
		return false;
	}
};
const ShapeGroup = Node$1.create({
	name: "shapeGroup",
	group: "inline",
	inline: true,
	atom: true,
	addOptions() {
		return { htmlAttributes: { contenteditable: false } };
	},
	addAttributes() {
		return {
			groupTransform: {
				default: {},
				renderDOM: () => ({})
			},
			shapes: {
				default: [],
				renderDOM: () => ({})
			},
			size: {
				default: null,
				renderDOM: (attrs) => {
					if (!attrs.size) return {};
					const sizeData = {};
					if (attrs.size.width) sizeData["data-width"] = attrs.size.width;
					if (attrs.size.height) sizeData["data-height"] = attrs.size.height;
					return sizeData;
				}
			},
			padding: {
				default: null,
				renderDOM: (attrs) => {
					if (!attrs.padding) return {};
					const paddingData = {};
					if (attrs.padding.top != null) paddingData["data-padding-top"] = attrs.padding.top;
					if (attrs.padding.right != null) paddingData["data-padding-right"] = attrs.padding.right;
					if (attrs.padding.bottom != null) paddingData["data-padding-bottom"] = attrs.padding.bottom;
					if (attrs.padding.left != null) paddingData["data-padding-left"] = attrs.padding.left;
					return paddingData;
				}
			},
			marginOffset: {
				default: null,
				renderDOM: (attrs) => {
					if (!attrs.marginOffset) return {};
					const offsetData = {};
					if (attrs.marginOffset.horizontal != null) offsetData["data-offset-x"] = attrs.marginOffset.horizontal;
					if (attrs.marginOffset.top != null) offsetData["data-offset-y"] = attrs.marginOffset.top;
					return offsetData;
				}
			},
			hidden: {
				default: false,
				rendered: false
			},
			drawingContent: { rendered: false },
			wrap: {
				default: { type: "Inline" },
				rendered: false
			},
			anchorData: {
				default: null,
				rendered: false
			},
			originalAttributes: { rendered: false }
		};
	},
	parseDOM() {
		return false;
	},
	renderDOM({ htmlAttributes }) {
		return ["div", Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes, { "data-shape-group": "" })];
	},
	addNodeView() {
		return (props) => {
			return new ShapeGroupView({ ...props });
		};
	}
});
const CHART_IMMUTABILITY_KEY = new PluginKey("chartImmutability");
var chartPositionCache = /* @__PURE__ */ new WeakMap();
function countChartNodes(doc$1) {
	let count = 0;
	doc$1.descendants((node) => {
		if (node.type.name === "chart") count++;
		return node.type.name !== "chart";
	});
	return count;
}
function collectChartNodes(doc$1) {
	let charts = chartPositionCache.get(doc$1);
	if (charts) return charts;
	charts = [];
	doc$1.descendants((node, pos) => {
		if (node.type.name === "chart") charts.push({
			pos,
			node
		});
		return node.type.name !== "chart";
	});
	chartPositionCache.set(doc$1, charts);
	return charts;
}
function transactionInsertsChart(tr) {
	for (const step of tr.steps) {
		const slice = step.slice;
		if (!slice || !slice.content.size) continue;
		let found = false;
		slice.content.descendants((node) => {
			if (node.type.name === "chart") found = true;
			return !found;
		});
		if (found) return true;
	}
	return false;
}
function isChartMutation(tr, oldDoc) {
	if (transactionInsertsChart(tr)) return true;
	const oldCharts = collectChartNodes(oldDoc);
	if (oldCharts.length === 0) return false;
	const newDoc = tr.doc;
	for (const { pos, node: oldNode } of oldCharts) {
		const mappedPos = tr.mapping.map(pos);
		const nodeAfter = newDoc.resolve(mappedPos).nodeAfter;
		if (!nodeAfter || nodeAfter.type.name !== "chart") return true;
		if (oldNode.attrs !== nodeAfter.attrs) {
			if (JSON.stringify(oldNode.attrs) !== JSON.stringify(nodeAfter.attrs)) return true;
		}
	}
	return false;
}
function createChartImmutabilityPlugin() {
	return new Plugin({
		key: CHART_IMMUTABILITY_KEY,
		state: {
			init(_$1, state) {
				return countChartNodes(state.doc);
			},
			apply(tr, oldCount, _oldState, newState) {
				if (tr.docChanged && tr.getMeta?.(ySyncPluginKey)) {
					if (oldCount === 0 && !transactionInsertsChart(tr)) return 0;
					return countChartNodes(newState.doc);
				}
				return oldCount;
			}
		},
		filterTransaction(tr, state) {
			if (!tr.docChanged) return true;
			if (tr.getMeta?.(ySyncPluginKey)) return true;
			if ((CHART_IMMUTABILITY_KEY.getState(state) ?? 0) === 0) return !transactionInsertsChart(tr);
			return !isChartMutation(tr, state.doc);
		}
	});
}
const Chart = Node$1.create({
	name: "chart",
	group: "inline",
	inline: true,
	atom: true,
	draggable: false,
	selectable: true,
	addOptions() {
		return { htmlAttributes: {} };
	},
	addAttributes() {
		return {
			width: {
				default: 400,
				renderDOM: (attrs) => {
					if (attrs.width == null) return {};
					return { "data-width": attrs.width };
				}
			},
			height: {
				default: 300,
				renderDOM: (attrs) => {
					if (attrs.height == null) return {};
					return { "data-height": attrs.height };
				}
			},
			chartData: {
				default: null,
				rendered: false
			},
			chartRelId: {
				default: null,
				rendered: false
			},
			chartPartPath: {
				default: null,
				rendered: false
			},
			isAnchor: {
				default: false,
				rendered: false
			},
			anchorData: {
				default: null,
				rendered: false
			},
			wrap: {
				default: null,
				rendered: false
			},
			padding: {
				default: null,
				rendered: false
			},
			marginOffset: {
				default: null,
				rendered: false
			},
			originalAttributes: {
				default: null,
				rendered: false
			},
			originalChildren: {
				default: null,
				rendered: false
			},
			originalChildOrder: {
				default: null,
				rendered: false
			},
			originalXml: {
				default: null,
				rendered: false
			},
			drawingContent: {
				...Attribute.json,
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: "sd-chart" }];
	},
	renderDOM({ htmlAttributes }) {
		return ["sd-chart", {
			...htmlAttributes,
			style: "display: inline-block;"
		}];
	},
	addPmPlugins() {
		return [createChartImmutabilityPlugin()];
	}
});
const MathInline = Node$1.create({
	name: "mathInline",
	group: "inline",
	inline: true,
	atom: true,
	marks: "",
	draggable: false,
	selectable: true,
	parseDOM() {
		return [{ tag: "sd-math-inline" }];
	},
	renderDOM() {
		return ["sd-math-inline", { style: "display: inline;" }];
	},
	addAttributes() {
		return {
			originalXml: {
				default: null,
				rendered: false
			},
			textContent: {
				default: "",
				rendered: false
			}
		};
	}
});
const MathBlock = Node$1.create({
	name: "mathBlock",
	group: "block",
	atom: true,
	draggable: false,
	selectable: true,
	defining: true,
	parseDOM() {
		return [{ tag: "sd-math-block" }];
	},
	renderDOM() {
		return ["sd-math-block", { style: "display: block; text-align: center;" }];
	},
	addAttributes() {
		return {
			originalXml: {
				default: null,
				rendered: false
			},
			textContent: {
				default: "",
				rendered: false
			},
			justification: {
				default: "centerGroup",
				rendered: false
			},
			paragraphProperties: {
				default: null,
				rendered: false
			}
		};
	}
});
var sharedAttributes$2 = () => ({
	originalName: { default: null },
	originalXml: { default: null }
});
var hiddenRender = (type) => ["sd-passthrough", {
	"data-sd-passthrough": type,
	style: "display: none;"
}];
const PassthroughBlock = Node$1.create({
	name: "passthroughBlock",
	group: "block",
	atom: true,
	draggable: false,
	selectable: false,
	defining: true,
	parseDOM() {
		return [{ tag: "sd-passthrough[data-sd-passthrough=\"block\"]" }];
	},
	renderDOM() {
		return hiddenRender("block");
	},
	addAttributes() {
		return sharedAttributes$2();
	}
});
const PassthroughInline = Node$1.create({
	name: "passthroughInline",
	group: "inline",
	inline: true,
	marks: "",
	atom: true,
	draggable: false,
	selectable: false,
	parseDOM() {
		return [{ tag: "sd-passthrough[data-sd-passthrough=\"inline\"]" }];
	},
	renderDOM() {
		return hiddenRender("inline");
	},
	addAttributes() {
		return sharedAttributes$2();
	}
});
const IndexEntry = Node$1.create({
	name: "indexEntry",
	group: "inline",
	inline: true,
	atom: true,
	draggable: false,
	selectable: false,
	content: "inline*",
	addOptions() {
		return { htmlAttributes: {
			contenteditable: false,
			"data-id": "document-index-entry",
			"aria-label": "Index entry",
			style: "display:none"
		} };
	},
	addAttributes() {
		return {
			instruction: {
				default: "",
				rendered: false
			},
			instructionTokens: {
				default: null,
				rendered: false
			},
			marksAsAttrs: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: "span[data-id=\"document-index-entry\"]" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	}
});
const TableOfContentsEntry = Node$1.create({
	name: "tableOfContentsEntry",
	group: "inline",
	inline: true,
	atom: true,
	draggable: false,
	selectable: false,
	content: "inline*",
	addOptions() {
		return { htmlAttributes: {
			contenteditable: false,
			"data-id": "document-toc-entry",
			"aria-label": "Table of contents entry",
			style: "display:none"
		} };
	},
	addAttributes() {
		return {
			instruction: {
				default: "",
				rendered: false
			},
			instructionTokens: {
				default: null,
				rendered: false
			},
			marksAsAttrs: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: "span[data-id=\"document-toc-entry\"]" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	},
	addCommands() {
		return {
			insertTableOfContentsEntryAt: ({ pos, instruction, instructionTokens = null }) => ({ tr, dispatch }) => {
				const nodeType = this.editor.schema.nodes.tableOfContentsEntry;
				if (!nodeType) return false;
				const node = nodeType.create({
					instruction,
					instructionTokens
				});
				try {
					if (dispatch) tr.insert(pos, node);
					return true;
				} catch (error) {
					if (error instanceof RangeError) return false;
					throw error;
				}
			},
			updateTableOfContentsEntryAt: ({ pos, instruction }) => ({ tr, dispatch, state }) => {
				const node = state.doc.nodeAt(pos);
				if (!node || node.type.name !== "tableOfContentsEntry") return false;
				if (dispatch) tr.setNodeMarkup(pos, void 0, {
					...node.attrs,
					instruction,
					instructionTokens: null
				});
				return true;
			},
			deleteTableOfContentsEntryAt: ({ pos }) => ({ tr, dispatch, state }) => {
				const node = state.doc.nodeAt(pos);
				if (!node || node.type.name !== "tableOfContentsEntry") return false;
				if (dispatch) tr.delete(pos, pos + node.nodeSize);
				return true;
			}
		};
	}
});
const CrossReference = Node$1.create({
	name: "crossReference",
	group: "inline",
	inline: true,
	atom: true,
	selectable: false,
	draggable: false,
	addOptions() {
		return { htmlAttributes: {
			contenteditable: false,
			"data-id": "cross-reference",
			"aria-label": "Cross-reference"
		} };
	},
	addAttributes() {
		return {
			instruction: {
				default: "",
				rendered: false
			},
			instructionTokens: {
				default: null,
				rendered: false
			},
			fieldType: {
				default: "REF",
				rendered: false
			},
			target: {
				default: "",
				rendered: false
			},
			display: {
				default: "content",
				rendered: false
			},
			resolvedText: {
				default: "",
				rendered: false
			},
			sdBlockId: {
				default: null,
				rendered: false
			},
			marksAsAttrs: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: "span[data-id=\"cross-reference\"]" }];
	},
	renderDOM({ node, htmlAttributes }) {
		const text = node.attrs.resolvedText || node.attrs.target || "";
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			text
		];
	}
});
const SequenceField = Node$1.create({
	name: "sequenceField",
	group: "inline",
	inline: true,
	atom: true,
	selectable: false,
	draggable: false,
	addOptions() {
		return { htmlAttributes: {
			contenteditable: false,
			"data-id": "sequence-field",
			"aria-label": "Sequence field"
		} };
	},
	addAttributes() {
		return {
			instruction: {
				default: "",
				rendered: false
			},
			instructionTokens: {
				default: null,
				rendered: false
			},
			identifier: {
				default: "",
				rendered: false
			},
			fieldArgument: {
				default: "",
				rendered: false
			},
			sequenceMode: {
				default: "next",
				rendered: false
			},
			hideResult: {
				default: false,
				rendered: false
			},
			restartNumber: {
				default: null,
				rendered: false
			},
			format: {
				default: "ARABIC",
				rendered: false
			},
			restartLevel: {
				default: null,
				rendered: false
			},
			hasGeneralFormat: {
				default: false,
				rendered: false
			},
			pageNumberFieldFormat: {
				default: null,
				rendered: false
			},
			numericPictureFormat: {
				default: null,
				rendered: false
			},
			resolvedNumber: {
				default: "",
				rendered: false
			},
			resolvedNumberIsCurrent: {
				default: false,
				rendered: false
			},
			sdBlockId: {
				default: null,
				rendered: false
			},
			marksAsAttrs: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: "span[data-id=\"sequence-field\"]" }];
	},
	renderDOM({ node, htmlAttributes }) {
		const text = node.attrs.resolvedNumber || "";
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			text
		];
	}
});
const DocumentStatField = Node$1.create({
	name: "documentStatField",
	group: "inline",
	inline: true,
	atom: true,
	selectable: false,
	draggable: false,
	addOptions() {
		return { htmlAttributes: {
			contenteditable: false,
			"data-id": "document-stat-field",
			"aria-label": "Document statistic field"
		} };
	},
	addAttributes() {
		return {
			instruction: {
				default: "",
				rendered: false
			},
			resolvedText: {
				default: "",
				rendered: false
			},
			sdBlockId: {
				default: null,
				rendered: false
			},
			marksAsAttrs: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: "span[data-id=\"document-stat-field\"]" }];
	},
	renderDOM({ node, htmlAttributes }) {
		const text = node.attrs.resolvedText || "0";
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			text
		];
	}
});
var FIELD_NODE_TYPES = new Set([
	"tableOfContents",
	"documentIndex",
	"pageReference",
	"indexEntry",
	"crossReference",
	"citation",
	"bibliography",
	"sequenceField",
	"tableOfAuthorities",
	"authorityEntry",
	"documentStatField"
]);
var SYNTHETIC_FIELD_NODE_TYPES = {
	"total-page-number": {
		fieldType: "NUMPAGES",
		instruction: "NUMPAGES",
		resolveInstruction: (node) => typeof node.attrs?.instruction === "string" && node.attrs.instruction.trim() ? node.attrs.instruction : "NUMPAGES"
	},
	"section-page-count": {
		fieldType: "SECTIONPAGES",
		instruction: "SECTIONPAGES",
		resolveInstruction: (node) => typeof node.attrs?.instruction === "string" && node.attrs.instruction.trim() ? node.attrs.instruction : "SECTIONPAGES"
	}
};
function findAllFields(doc$1) {
	const results = [];
	const blockOccurrenceCounters = /* @__PURE__ */ new Map();
	doc$1.descendants((node, pos) => {
		const typeName = node.type.name;
		const synthetic = SYNTHETIC_FIELD_NODE_TYPES[typeName];
		if (synthetic) {
			const blockId$1 = resolveParentBlockId$4(doc$1, pos);
			const counter$1 = blockOccurrenceCounters.get(blockId$1) ?? 0;
			blockOccurrenceCounters.set(blockId$1, counter$1 + 1);
			const textContent$1 = node.textContent ?? "";
			const resolvedAttr = node.attrs?.resolvedText ?? "";
			const importedCached = node.attrs?.importedCachedText ?? "";
			const resolvedText$1 = textContent$1 || resolvedAttr || importedCached;
			results.push({
				pos,
				blockId: blockId$1,
				occurrenceIndex: counter$1,
				nestingDepth: 0,
				instruction: synthetic.resolveInstruction?.(node) ?? synthetic.instruction,
				fieldType: synthetic.fieldType,
				resolvedText: resolvedText$1
			});
			return true;
		}
		if (!FIELD_NODE_TYPES.has(typeName) && !node.attrs?.instruction) return true;
		const instruction = node.attrs?.instruction ?? "";
		if (!instruction) return true;
		const blockId = resolveParentBlockId$4(doc$1, pos);
		const counter = blockOccurrenceCounters.get(blockId) ?? 0;
		blockOccurrenceCounters.set(blockId, counter + 1);
		const fieldType = extractFieldType$1(instruction);
		const resolvedText = node.type.name === "sequenceField" ? node.attrs?.resolvedNumber ?? "" : node.attrs?.resolvedText ?? "";
		results.push({
			pos,
			blockId,
			occurrenceIndex: counter,
			nestingDepth: 0,
			instruction,
			fieldType,
			resolvedText
		});
		return true;
	});
	return results;
}
function findFieldsInRange(doc$1, from$1, to) {
	const allFields = findAllFields(doc$1);
	const isCollapsed = from$1 === to;
	return allFields.filter((field) => {
		const node = doc$1.nodeAt(field.pos);
		if (!node) return false;
		const fieldEnd = field.pos + node.nodeSize;
		if (isCollapsed) return field.pos <= from$1 && fieldEnd >= from$1;
		return field.pos < to && fieldEnd > from$1;
	});
}
function resolveFieldTarget(doc$1, target) {
	const found = findAllFields(doc$1).find((f) => f.blockId === target.blockId && f.occurrenceIndex === target.occurrenceIndex && f.nestingDepth === target.nestingDepth);
	if (!found) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Field at ${target.blockId}[${target.occurrenceIndex}] not found.`);
	return found;
}
function extractFieldInfo(resolved) {
	return {
		address: {
			kind: "field",
			blockId: resolved.blockId,
			occurrenceIndex: resolved.occurrenceIndex,
			nestingDepth: resolved.nestingDepth
		},
		instruction: resolved.instruction,
		fieldType: resolved.fieldType,
		resolvedText: resolved.resolvedText,
		nested: resolved.nestingDepth > 0
	};
}
function buildFieldDiscoveryItem(resolved, evaluatedRevision) {
	const domain = {
		address: {
			kind: "field",
			blockId: resolved.blockId,
			occurrenceIndex: resolved.occurrenceIndex,
			nestingDepth: resolved.nestingDepth
		},
		instruction: resolved.instruction,
		fieldType: resolved.fieldType,
		resolvedText: resolved.resolvedText,
		nested: resolved.nestingDepth > 0
	};
	const ref$1 = `${resolved.blockId}:${resolved.occurrenceIndex}:${resolved.nestingDepth}`;
	const handle = buildResolvedHandle(ref$1, "ephemeral", "field");
	return buildDiscoveryItem(`field:${ref$1}:${evaluatedRevision}`, handle, domain);
}
function resolveParentBlockId$4(doc$1, pos) {
	const resolved = doc$1.resolve(pos);
	for (let depth = resolved.depth; depth >= 0; depth--) {
		const blockId = resolved.node(depth).attrs?.sdBlockId;
		if (blockId) return blockId;
	}
	return "";
}
function extractFieldType$1(instruction) {
	const trimmed = instruction.trim();
	const firstSpace = trimmed.indexOf(" ");
	return firstSpace > 0 ? trimmed.slice(0, firstSpace).toUpperCase() : trimmed.toUpperCase();
}
function resolveSectionPageCountFieldValue(editor, node) {
	const sectionPageCount = editor.options?.sectionPageCount;
	if (sectionPageCount == null) return null;
	const pageNumberFormat = typeof node.attrs?.pageNumberFormat === "string" && node.attrs.pageNumberFormat ? node.attrs.pageNumberFormat : void 0;
	const pageNumberZeroPadding = typeof node.attrs?.pageNumberZeroPadding === "number" && Number.isFinite(node.attrs.pageNumberZeroPadding) ? node.attrs.pageNumberZeroPadding : void 0;
	if (pageNumberFormat || pageNumberZeroPadding != null) return formatPageNumberFieldValue(Number(sectionPageCount) || 1, {
		...pageNumberFormat ? { format: pageNumberFormat } : {},
		...pageNumberZeroPadding != null ? { zeroPadding: pageNumberZeroPadding } : {}
	});
	return String(sectionPageCount);
}
function updateSequenceFieldsInTransaction(args$1) {
	const { tr, scope = { kind: "all" }, converterContext } = args$1;
	const sequenceFieldType = args$1.schema.nodes.sequenceField;
	if (!sequenceFieldType) return {
		changed: false,
		updated: 0
	};
	const evaluator = new SequenceFieldEvaluator();
	let changed = false;
	let updated = 0;
	tr.doc.descendants((node, pos) => {
		if (node.type.name === "paragraph") {
			evaluator.enterParagraph({ paragraphHeadingLevel: resolveNodeHeadingLevel(node, converterContext) });
			return true;
		}
		if (node.type !== sequenceFieldType) return true;
		const nextAttrs = buildEvaluatedSequenceAttrs(node);
		const evaluation = evaluator.evaluateField({
			identifier: nextAttrs.identifier,
			instruction: nextAttrs.instruction,
			fieldArgument: nextAttrs.fieldArgument,
			sequenceMode: nextAttrs.sequenceMode,
			hideResult: nextAttrs.hideResult,
			restartNumber: nextAttrs.restartNumber,
			restartLevel: nextAttrs.restartLevel,
			format: nextAttrs.format,
			hasGeneralFormat: nextAttrs.hasGeneralFormat,
			pageNumberFieldFormat: nextAttrs.pageNumberFieldFormat,
			numericPictureFormat: nextAttrs.numericPictureFormat,
			cachedText: typeof node.attrs.resolvedNumber === "string" ? node.attrs.resolvedNumber : ""
		});
		if (!shouldWriteSequenceField(node, pos, scope, nextAttrs.identifier)) return true;
		nextAttrs.resolvedNumber = evaluation.text;
		nextAttrs.resolvedNumberIsCurrent = true;
		if (!attrsEqual(node.attrs, nextAttrs)) {
			tr.setNodeMarkup(resolveCurrentTransactionPos(tr, pos, node), void 0, nextAttrs);
			changed = true;
		}
		updated += 1;
		return true;
	});
	return {
		changed,
		updated
	};
}
function getSequenceFieldUpdaterConverterContext(editor) {
	const converter = editor?.converter;
	if (!converter?.translatedLinkedStyles) return void 0;
	return {
		translatedLinkedStyles: converter.translatedLinkedStyles,
		translatedNumbering: converter.translatedNumbering ?? {},
		docx: converter.docx
	};
}
function resolveNodeHeadingLevel(node, converterContext) {
	const paragraphProperties = node.attrs?.paragraphProperties;
	if (converterContext) return resolveParagraphHeadingLevel(isRecord$3(paragraphProperties) ? paragraphProperties : void 0, converterContext);
}
function buildEvaluatedSequenceAttrs(node) {
	const instruction = typeof node.attrs.instruction === "string" ? node.attrs.instruction : "";
	const parsedAttrs = sequenceFieldAttrsFromParsed(parseSeqInstruction(instruction));
	return {
		...node.attrs,
		instruction,
		...parsedAttrs,
		identifier: parsedAttrs.identifier || readStringAttr(node, "identifier")
	};
}
function shouldWriteSequenceField(node, pos, scope, identifier) {
	if (scope.kind === "all") return true;
	if (scope.kind === "range") {
		const end$1 = pos + node.nodeSize;
		return pos < scope.to && end$1 > scope.from;
	}
	return normalizeSeqIdentifier(identifier) === normalizeSeqIdentifier(scope.identifier);
}
function readStringAttr(node, key) {
	const value = node.attrs?.[key];
	return typeof value === "string" ? value : "";
}
function attrsEqual(left$1, right$1) {
	const keys$1 = new Set([...Object.keys(left$1), ...Object.keys(right$1)]);
	for (const key of keys$1) if (!valuesEqual(left$1[key], right$1[key])) return false;
	return true;
}
function valuesEqual(left$1, right$1) {
	if (Object.is(left$1, right$1)) return true;
	if (!isRecord$3(left$1) || !isRecord$3(right$1)) return false;
	const keys$1 = new Set([...Object.keys(left$1), ...Object.keys(right$1)]);
	for (const key of keys$1) if (!valuesEqual(left$1[key], right$1[key])) return false;
	return true;
}
function resolveCurrentTransactionPos(tr, pos, node) {
	if (tr.doc.nodeAt(pos)?.type === node.type) return pos;
	return tr.mapping.map(pos);
}
function isRecord$3(value) {
	return value !== null && typeof value === "object" && !Array.isArray(value);
}
var UPDATABLE_FIELD_TYPES = new Set([
	"NUMWORDS",
	"NUMCHARS",
	"NUMPAGES",
	"SECTIONPAGES"
]);
function resolveTotalPageNumberFieldValue(stats, node) {
	if (stats.pages == null) return null;
	return formatPageNumberFieldValue(stats.pages, getPageNumberFieldFormat(node.attrs));
}
const FieldUpdate = Extension.create({
	name: "fieldUpdate",
	addCommands() {
		return { updateFieldsInSelection: () => ({ editor, state, tr: outerTr, dispatch }) => {
			const { from: from$1, to } = state.selection;
			const selectionHadSeq = findFieldsInRange(state.doc, from$1, to).some((field) => field.fieldType === "SEQ");
			let tocPathRan = false;
			if (editor?.doc?.toc?.update) {
				const tocTargets = findAllTocNodes(state.doc).map((toc) => toc.commandNodeId).filter((id) => typeof id === "string" && id);
				if (tocTargets.length > 0) {
					if (!dispatch) return true;
					const tocStorage = editor.storage?.tableOfContents;
					const cachedPageMap = tocStorage?.pageMap ?? null;
					for (const sdBlockId of tocTargets) {
						if (tocStorage && cachedPageMap) {
							tocStorage.pageMap = cachedPageMap;
							tocStorage.pageMapDoc = editor.state.doc;
						}
						try {
							editor.doc.toc.update({
								target: {
									kind: "block",
									nodeType: "tableOfContents",
									nodeId: sdBlockId
								},
								mode: "all"
							});
						} catch (error) {
							console.warn("[FieldUpdate] toc.update failed for", sdBlockId, error);
						}
					}
					outerTr?.setMeta?.("preventDispatch", true);
					tocPathRan = true;
				}
			}
			const activeState = tocPathRan && editor?.state?.doc ? editor.state : state;
			const activeDoc = activeState.doc ?? state.doc;
			const activeSchema = activeState.schema ?? state.schema;
			const fields = findFieldsInRange(activeDoc, Math.min(from$1, activeDoc.content.size), to >= state.doc.content.size ? activeDoc.content.size : Math.min(to, activeDoc.content.size));
			const updatable = fields.filter((f) => UPDATABLE_FIELD_TYPES.has(f.fieldType));
			const hasSeqSelection = selectionHadSeq || fields.some((field) => field.fieldType === "SEQ");
			if (updatable.length === 0 && !hasSeqSelection) return tocPathRan;
			const stats = getWordStatistics(resolveMainBodyEditor(editor));
			const tr = activeState.tr;
			let changed = false;
			const sorted = [...updatable].sort((a, b$1) => b$1.pos - a.pos);
			for (const field of sorted) {
				const node = tr.doc.nodeAt(field.pos);
				if (!node) continue;
				const freshValue = field.fieldType === "SECTIONPAGES" ? resolveSectionPageCountFieldValue(editor, node) : field.fieldType === "NUMPAGES" && node.type.name === "total-page-number" ? resolveTotalPageNumberFieldValue(stats, node) : resolveDocumentStatFieldValue(field.fieldType, stats);
				if (freshValue == null) continue;
				if (node.type.name === "total-page-number" || node.type.name === "section-page-count") {
					const textChild = freshValue ? activeSchema.text(freshValue) : null;
					const newNode = node.type.create({
						...node.attrs,
						resolvedText: freshValue
					}, textChild);
					tr.replaceWith(field.pos, field.pos + node.nodeSize, newNode);
					changed = true;
				} else {
					if ((node.attrs?.resolvedText ?? "").toString() === freshValue) continue;
					tr.setNodeMarkup(field.pos, void 0, {
						...node.attrs,
						resolvedText: freshValue
					});
					changed = true;
				}
			}
			if (hasSeqSelection) {
				const result = updateSequenceFieldsInTransaction({
					tr,
					schema: activeSchema,
					scope: { kind: "all" },
					converterContext: getSequenceFieldUpdaterConverterContext(editor)
				});
				changed = changed || result.changed;
			}
			if (!changed) return tocPathRan;
			if (dispatch) dispatch(tr);
			return true;
		} };
	},
	addShortcuts() {
		return { F9: () => this.editor.commands.updateFieldsInSelection() };
	}
});
const Citation = Node$1.create({
	name: "citation",
	group: "inline",
	inline: true,
	atom: true,
	selectable: false,
	draggable: false,
	addOptions() {
		return { htmlAttributes: {
			contenteditable: false,
			"data-id": "citation",
			"aria-label": "Citation"
		} };
	},
	addAttributes() {
		return {
			instruction: {
				default: "",
				rendered: false
			},
			instructionTokens: {
				default: null,
				rendered: false
			},
			sourceIds: {
				default: [],
				rendered: false
			},
			resolvedText: {
				default: "",
				rendered: false
			},
			sdBlockId: {
				default: null,
				rendered: false
			},
			marksAsAttrs: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: "span[data-id=\"citation\"]" }];
	},
	renderDOM({ node, htmlAttributes }) {
		const text = node.attrs.resolvedText || "[Citation]";
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			text
		];
	}
});
const Bibliography = Node$1.create({
	name: "bibliography",
	group: "block",
	content: "paragraph+",
	addOptions() {
		return { htmlAttributes: { "data-id": "bibliography" } };
	},
	addAttributes() {
		return {
			instruction: {
				default: "",
				rendered: false
			},
			instructionTokens: {
				default: null,
				rendered: false
			},
			sdBlockId: {
				default: null,
				rendered: false
			},
			wrapperParagraphProperties: {
				default: null,
				rendered: false
			},
			style: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: "div[data-id=\"bibliography\"]" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"div",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	}
});
const AuthorityEntry = Node$1.create({
	name: "authorityEntry",
	group: "inline",
	inline: true,
	atom: true,
	draggable: false,
	selectable: false,
	content: "inline*",
	addOptions() {
		return { htmlAttributes: {
			contenteditable: false,
			"data-id": "authority-entry",
			"aria-label": "Authority entry",
			style: "display:none"
		} };
	},
	addAttributes() {
		return {
			instruction: {
				default: "",
				rendered: false
			},
			instructionTokens: {
				default: null,
				rendered: false
			},
			longCitation: {
				default: "",
				rendered: false
			},
			shortCitation: {
				default: "",
				rendered: false
			},
			category: {
				default: 0,
				rendered: false
			},
			bold: {
				default: false,
				rendered: false
			},
			italic: {
				default: false,
				rendered: false
			},
			marksAsAttrs: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: "span[data-id=\"authority-entry\"]" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	}
});
const TableOfAuthorities = Node$1.create({
	name: "tableOfAuthorities",
	group: "block",
	content: "paragraph+",
	addOptions() {
		return { htmlAttributes: { "data-id": "table-of-authorities" } };
	},
	addAttributes() {
		return {
			instruction: {
				default: "",
				rendered: false
			},
			instructionTokens: {
				default: null,
				rendered: false
			},
			sdBlockId: {
				default: null,
				rendered: false
			},
			wrapperParagraphProperties: {
				default: null,
				rendered: false
			}
		};
	},
	parseDOM() {
		return [{ tag: "div[data-id=\"table-of-authorities\"]" }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"div",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	}
});
var hasExplicitPosition = (position) => {
	if (typeof position !== "string") return false;
	return normalizeBaselineShift(parseFloat(position)) != null;
};
const TextStyle = Mark.create({
	name: "textStyle",
	addOptions() {
		return { htmlAttributes: {} };
	},
	parseDOM() {
		return [{
			tag: "span",
			getAttrs: (el) => {
				const hasStyles = el.hasAttribute("style");
				const isAnnotation = el.classList.contains("annotation") || el.classList.contains("annotation-content");
				if (!hasStyles || isAnnotation) return false;
				return {};
			}
		}, { getAttrs: (node) => {
			const fontFamily = node.style.fontFamily?.replace(/['"]+/g, "");
			const fontSize = node.style.fontSize;
			const textTransform = node.style.textTransform;
			if (fontFamily || fontSize || textTransform) return {
				fontFamily: fontFamily || null,
				fontSize: fontSize || null,
				textTransform: textTransform || null
			};
			return false;
		} }];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	},
	addAttributes() {
		return {
			styleId: {},
			vertAlign: {
				default: null,
				renderDOM: (attrs) => {
					if (!attrs.vertAlign || hasExplicitPosition(attrs.position)) return {};
					if (attrs.vertAlign === "superscript") return { style: "vertical-align: super; font-size: 65%;" };
					if (attrs.vertAlign === "subscript") return { style: "vertical-align: sub; font-size: 65%;" };
					if (attrs.vertAlign === "baseline") return { style: "vertical-align: baseline;" };
					return {};
				},
				parseDOM: (el) => {
					const va = el.style?.verticalAlign;
					if (va === "super") return "superscript";
					if (va === "sub") return "subscript";
					if (va === "baseline") return "baseline";
					return null;
				}
			},
			position: {
				default: null,
				renderDOM: (attrs) => {
					if (!hasExplicitPosition(attrs.position)) return {};
					return { style: `vertical-align: ${attrs.position};` };
				},
				parseDOM: (el) => {
					const va = el.style?.verticalAlign;
					if (!va) return null;
					const numeric = parseFloat(va);
					if (!Number.isNaN(numeric)) return `${numeric}pt`;
					return null;
				}
			}
		};
	},
	addCommands() {
		return { removeEmptyTextStyle: () => ({ state, commands: commands$1 }) => {
			const attributes = Attribute.getMarkAttributes(state, this.type);
			if (Object.entries(attributes).some(([, value]) => !!value)) return true;
			return commands$1.unsetMark(this.name);
		} };
	}
});
function createCascadeToggleCommands({ markName, setCommand, unsetCommand, toggleCommand, negationAttrs, isNegation, extendEmptyMarkRange } = {}) {
	if (!markName) throw new Error("createCascadeToggleCommands requires a markName");
	const capitalized = markName.charAt(0).toUpperCase() + markName.slice(1);
	const setName = setCommand ?? `set${capitalized}`;
	const unsetName = unsetCommand ?? `unset${capitalized}`;
	const toggleName = toggleCommand ?? `toggle${capitalized}`;
	const cascadeOptions = {};
	if (negationAttrs) cascadeOptions.negationAttrs = negationAttrs;
	if (typeof isNegation === "function") cascadeOptions.isNegation = isNegation;
	if (extendEmptyMarkRange !== void 0) cascadeOptions.extendEmptyMarkRange = extendEmptyMarkRange;
	return {
		[setName]: () => ({ commands: commands$1 }) => commands$1.setMark(markName),
		[unsetName]: () => ({ commands: commands$1 }) => commands$1.unsetMark(markName),
		[toggleName]: () => ({ commands: commands$1 }) => commands$1.toggleMarkCascade(markName, cascadeOptions)
	};
}
const Bold = Mark.create({
	name: "bold",
	addOptions() {
		return { htmlAttributes: {} };
	},
	addAttributes() {
		return { value: {
			default: null,
			renderDOM: (attrs) => {
				if (attrs.value == null) return {};
				if (attrs.value === "0" || !attrs.value) return { style: "font-weight: normal" };
				return {};
			}
		} };
	},
	parseDOM() {
		return [
			{ tag: "strong" },
			{
				tag: "b",
				getAttrs: (node) => node.style.fontWeight != "normal" && null
			},
			{
				style: "font-weight=400",
				clearMark: (m$1) => m$1.type.name == "strong"
			},
			{
				style: "font-weight",
				getAttrs: (value) => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
			}
		];
	},
	renderDOM({ htmlAttributes }) {
		const { value, ...rest } = Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes) || {};
		if (value === "0") return [
			"span",
			rest,
			0
		];
		return [
			"strong",
			rest,
			0
		];
	},
	addCommands() {
		const { setBold, unsetBold, toggleBold } = createCascadeToggleCommands({
			markName: this.name,
			negationAttrs: { value: "0" }
		});
		return {
			setBold,
			unsetBold,
			toggleBold
		};
	},
	addShortcuts() {
		return {
			"Mod-b": () => this.editor.commands.toggleBold(),
			"Mod-B": () => this.editor.commands.toggleBold()
		};
	}
});
const Italic = Mark.create({
	name: "italic",
	addOptions() {
		return { htmlAttributes: {} };
	},
	addAttributes() {
		return { value: {
			default: null,
			renderDOM: (attrs) => {
				if (attrs.value == null) return {};
				if (attrs.value === "0" || !attrs.value) return { style: "font-style: normal" };
				return {};
			}
		} };
	},
	parseDOM() {
		return [
			{ tag: "i" },
			{ tag: "em" },
			{ style: "font-style=italic" },
			{
				style: "font-style=normal",
				clearMark: (m$1) => m$1.type.name == "em"
			}
		];
	},
	renderDOM({ htmlAttributes }) {
		const { value, ...rest } = Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes) || {};
		if (value === "0") return [
			"span",
			rest,
			0
		];
		return [
			"em",
			rest,
			0
		];
	},
	addCommands() {
		const { setItalic, unsetItalic, toggleItalic } = createCascadeToggleCommands({
			markName: this.name,
			negationAttrs: { value: "0" }
		});
		return {
			setItalic,
			unsetItalic,
			toggleItalic
		};
	},
	addShortcuts() {
		return {
			"Mod-i": () => this.editor.commands.toggleItalic(),
			"Mod-I": () => this.editor.commands.toggleItalic()
		};
	}
});
const Underline = Mark.create({
	name: "underline",
	addOptions() {
		return { htmlAttributes: {} };
	},
	parseDOM() {
		return [
			{ tag: "u" },
			{ style: "text-decoration=underline" },
			{
				style: "text-decoration=auto",
				clearMark: (m$1) => m$1.type.name == "u"
			}
		];
	},
	renderDOM({ htmlAttributes }) {
		const merged = Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes);
		const type = merged?.underlineType;
		const color = merged?.underlineColor;
		const css = getUnderlineCssString({
			type,
			color
		});
		const { style, ...rest } = merged || {};
		const styleString = [style, css].filter(Boolean).join("; ");
		if (type === "none") return [
			"span",
			{
				...rest,
				...styleString ? { style: styleString } : {}
			},
			0
		];
		return [
			"u",
			{
				...rest,
				...styleString ? { style: styleString } : {}
			},
			0
		];
	},
	addAttributes() {
		return {
			underlineType: { default: "single" },
			underlineColor: { default: null },
			underlineThemeColor: { default: null },
			underlineThemeTint: { default: null },
			underlineThemeShade: { default: null },
			autoAdded: {
				default: false,
				rendered: false
			}
		};
	},
	addCommands() {
		const { setUnderline, unsetUnderline, toggleUnderline } = createCascadeToggleCommands({
			markName: this.name,
			negationAttrs: { underlineType: "none" },
			isNegation: (attrs) => attrs?.underlineType === "none"
		});
		return {
			setUnderline,
			unsetUnderline,
			toggleUnderline
		};
	},
	addShortcuts() {
		return {
			"Mod-u": () => this.editor.commands.toggleUnderline(),
			"Mod-U": () => this.editor.commands.toggleUnderline()
		};
	}
});
const Highlight = Mark.create({
	name: "highlight",
	addOptions() {
		return { htmlAttributes: {} };
	},
	addAttributes() {
		return {
			color: {
				default: null,
				parseDOM: (element) => cssColorToHex(element.getAttribute("data-color") || element.style.backgroundColor),
				renderDOM: (attributes) => {
					if (!attributes.color) return {};
					return {
						"data-color": attributes.color,
						style: `background-color: ${attributes.color}; color: inherit`
					};
				}
			},
			ooxmlHighlightClear: {
				default: null,
				parseDOM: () => null,
				renderDOM: () => ({})
			}
		};
	},
	parseDOM() {
		return [{ tag: "mark" }, {
			style: "background-color",
			getAttrs: (value) => {
				if (!value || value === "transparent" || value === "inherit" || value === "initial" || value === "unset") return false;
				const color = cssColorToHex(value);
				return color ? { color } : false;
			}
		}];
	},
	renderDOM({ htmlAttributes }) {
		return [
			"mark",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	},
	addCommands() {
		return {
			setHighlight: (color) => ({ commands: commands$1 }) => commands$1.setMark(this.name, { color }),
			unsetHighlight: () => ({ commands: commands$1 }) => commands$1.unsetMark(this.name),
			toggleHighlight: () => ({ commands: commands$1 }) => commands$1.toggleMark(this.name)
		};
	},
	addShortcuts() {
		return { "Mod-Shift-h": () => this.editor.commands.toggleHighlight() };
	}
});
const Strike = Mark.create({
	name: "strike",
	addOptions() {
		return { htmlAttributes: {} };
	},
	parseDOM() {
		return [
			{ tag: "s" },
			{ style: "text-decoration=line-through" },
			{
				style: "text-decoration=auto",
				clearMark: (m$1) => m$1.type.name == "s"
			}
		];
	},
	renderDOM({ mark, htmlAttributes }) {
		const merged = Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes);
		const { value } = mark.attrs;
		const { ...rest } = merged || {};
		if (value === "0" || value === false) return [
			"span",
			rest,
			0
		];
		return [
			"s",
			rest,
			0
		];
	},
	addCommands() {
		const { setStrike, unsetStrike, toggleStrike } = createCascadeToggleCommands({
			markName: this.name,
			negationAttrs: { value: "0" }
		});
		return {
			setStrike,
			unsetStrike,
			toggleStrike
		};
	},
	addAttributes() {
		return { value: {
			default: null,
			renderDOM: (attrs) => {
				if (attrs.value == null) return {};
				if (attrs.value === "0" || !attrs.value) return { style: "text-decoration: none" };
				return {};
			}
		} };
	},
	addShortcuts() {
		return {
			"Mod-Shift-x": () => this.editor.commands.toggleStrike(),
			"Mod-Shift-X": () => this.editor.commands.toggleStrike()
		};
	}
});
const Link = Mark.create({
	name: "link",
	priority: 1e3,
	keepOnSplit: false,
	inclusive: false,
	addOptions() {
		return {
			protocols: ["http", "https"],
			htmlAttributes: {
				target: null,
				rel: "noopener noreferrer nofollow",
				class: null,
				title: null
			}
		};
	},
	parseDOM() {
		return [{ tag: "a" }];
	},
	renderDOM({ htmlAttributes }) {
		const sanitizedHref = sanitizeLinkHref(htmlAttributes.href, this.options.protocols);
		const attrs = { ...htmlAttributes };
		attrs.href = sanitizedHref ? sanitizedHref.href : "";
		return [
			"a",
			Attribute.mergeAttributes(this.options.htmlAttributes, attrs),
			0
		];
	},
	addAttributes() {
		return {
			href: {
				default: null,
				renderDOM: ({ href, name }) => {
					const sanitized = sanitizeLinkHref(href, this.options.protocols);
					if (sanitized) return { href: sanitized.href };
					if (name) return { href: `#${name}` };
					return {};
				}
			},
			target: {
				default: this.options.htmlAttributes.target,
				renderDOM: ({ target, href }) => {
					if (target) return { target };
					const sanitized = sanitizeLinkHref(href, this.options.protocols);
					if (sanitized && sanitized.isExternal) return { target: "_blank" };
					return {};
				}
			},
			rel: { default: this.options.htmlAttributes.rel },
			rId: { default: this.options.htmlAttributes.rId || null },
			text: { default: null },
			name: { default: null },
			history: {
				default: true,
				rendered: false
			},
			anchor: { rendered: false },
			docLocation: { rendered: false },
			tooltip: {
				default: null,
				renderDOM: ({ tooltip }) => {
					const result = encodeTooltip(tooltip);
					if (result) {
						const attrs = { title: result.text };
						if (result.wasTruncated) attrs["data-link-tooltip-truncated"] = "true";
						return attrs;
					}
					return {};
				}
			}
		};
	},
	addCommands() {
		return {
			setLink: ({ href, text } = {}) => ({ state, dispatch, editor }) => {
				const { selection } = state;
				const linkMarkType = editor.schema.marks.link;
				const underlineMarkType = editor.schema.marks.underline;
				const sanitizedHref = href ? sanitizeLinkHref(href, this.options.protocols) : null;
				if (href && !sanitizedHref) return false;
				let from$1 = selection.from;
				let to = selection.to;
				if (selection.empty) {
					const range = getMarkRange(selection.$from, linkMarkType);
					if (range) {
						from$1 = range.from;
						to = range.to;
					}
				} else {
					const fromLinkRange = getMarkRange(selection.$from, linkMarkType);
					const toLinkRange = getMarkRange(selection.$to, linkMarkType);
					if (fromLinkRange || toLinkRange) {
						const linkRange = fromLinkRange || toLinkRange;
						from$1 = linkRange.from;
						to = linkRange.to;
					}
				}
				({from: from$1, to} = trimRange(state.doc, from$1, to));
				const currentText = state.doc.textBetween(from$1, to);
				const computedText = text ?? currentText;
				const fallbackHref = sanitizedHref?.href ?? "";
				const finalText = computedText && computedText.length > 0 ? computedText : fallbackHref;
				let tr = state.tr;
				if (finalText && currentText !== finalText) {
					tr = tr.insertText(finalText, from$1, to);
					to = from$1 + finalText.length;
				}
				if (linkMarkType) tr = tr.removeMark(from$1, to, linkMarkType);
				if (underlineMarkType) {
					const rangesMissingUnderline = [];
					const negationMarksToRemove = [];
					tr.doc.nodesBetween(from$1, to, (node, pos) => {
						if (!node.isText || node.nodeSize <= 0) return;
						const existing = node.marks.find((mark) => mark.type === underlineMarkType);
						if (existing && existing.attrs?.underlineType !== "none") return;
						const rangeFrom = Math.max(pos, from$1);
						const rangeTo = Math.min(pos + node.nodeSize, to);
						if (rangeFrom >= rangeTo) return;
						if (existing && existing.attrs?.underlineType === "none") negationMarksToRemove.push({
							from: rangeFrom,
							to: rangeTo,
							mark: existing
						});
						rangesMissingUnderline.push({
							from: rangeFrom,
							to: rangeTo
						});
					});
					negationMarksToRemove.forEach((range) => {
						tr = tr.removeMark(range.from, range.to, range.mark);
					});
					rangesMissingUnderline.forEach((range) => {
						tr = tr.addMark(range.from, range.to, underlineMarkType.create({ autoAdded: true }));
					});
				}
				let rId = null;
				if (editor.options.mode === "docx") {
					const id = addLinkRelationship({
						editor,
						href
					});
					if (id) rId = id;
				}
				const linkAttrs = {
					text: finalText,
					rId
				};
				if (sanitizedHref?.href) linkAttrs.href = sanitizedHref.href;
				const newLinkMarkType = linkMarkType.create(linkAttrs);
				tr = tr.addMark(from$1, to, newLinkMarkType);
				dispatch(tr.scrollIntoView());
				return true;
			},
			unsetLink: () => ({ chain, state, editor }) => {
				const { selection } = state;
				const linkMarkType = editor.schema.marks.link;
				const underlineMarkType = editor.schema.marks.underline;
				let { from: from$1, to } = selection;
				if (selection.empty && linkMarkType) {
					const initialRange = getMarkRange(selection.$from, linkMarkType);
					if (initialRange) {
						from$1 = initialRange.from;
						to = initialRange.to;
					} else {
						const doc$1 = state.doc;
						const docSize = doc$1.content.size;
						const probePositions = [
							selection.from - 1,
							selection.from,
							selection.from + 1
						].filter((pos) => pos >= 0 && pos <= docSize);
						for (const pos of probePositions) {
							const range = getMarkRange(doc$1.resolve(pos), linkMarkType);
							if (range) {
								from$1 = range.from;
								to = range.to;
								break;
							}
						}
					}
				}
				const commandChain = chain();
				if (selection.empty && linkMarkType && from$1 !== to) commandChain.command(({ tr }) => {
					tr.setSelection(TextSelection.create(tr.doc, from$1, to));
					return true;
				});
				return commandChain.unsetColor().unsetMark("link", { extendEmptyMarkRange: true }).command(({ tr }) => {
					if (underlineMarkType) tr.doc.nodesBetween(from$1, to, (node, pos) => {
						if (!node.isText) return;
						node.marks.forEach((mark) => {
							if (mark.type !== underlineMarkType) return;
							if (mark.attrs?.autoAdded !== true) return;
							tr.removeMark(pos, pos + node.nodeSize, mark);
						});
					});
					const textStyleMarkType = tr.doc.type.schema.marks.textStyle;
					if (textStyleMarkType) tr.doc.nodesBetween(from$1, to, (node, pos) => {
						if (!node.isText) return;
						node.marks.forEach((mark) => {
							if (mark.type !== textStyleMarkType) return;
							if (!TRANSIENT_HYPERLINK_STYLE_IDS.has(mark.attrs?.styleId)) return;
							const clearedAttrs = {
								...mark.attrs,
								styleId: null
							};
							tr.removeMark(pos, pos + node.nodeSize, mark);
							tr.addMark(pos, pos + node.nodeSize, textStyleMarkType.create(clearedAttrs));
						});
					});
					const runNodesToUpdate = [];
					tr.doc.nodesBetween(from$1, to, (node, pos) => {
						if (node.type.name !== "run") return;
						if (!TRANSIENT_HYPERLINK_STYLE_IDS.has(node.attrs?.runProperties?.styleId)) return;
						runNodesToUpdate.push({
							node,
							pos
						});
					});
					runNodesToUpdate.sort((a, b$1) => b$1.pos - a.pos).forEach(({ node, pos }) => {
						const mappedPos = tr.mapping.map(pos);
						tr.setNodeMarkup(mappedPos, node.type, {
							...node.attrs,
							runProperties: {
								...node.attrs.runProperties,
								styleId: null
							}
						}, node.marks);
					});
					if (linkMarkType) {
						const runNodeMarkRemovals = [];
						tr.doc.nodesBetween(from$1, to, (node, pos) => {
							if (node.type.name !== "run") return;
							if (!node.marks.some((mark) => mark.type === linkMarkType)) return;
							runNodeMarkRemovals.push(pos);
						});
						runNodeMarkRemovals.reverse().forEach((pos) => {
							const mappedPos = tr.mapping.map(pos);
							const runNode = tr.doc.nodeAt(mappedPos);
							if (!runNode) return;
							tr.setNodeMarkup(mappedPos, runNode.type, runNode.attrs, runNode.marks.filter((mark) => mark.type !== linkMarkType));
						});
					}
					return true;
				}).run();
			},
			toggleLink: ({ href, text } = {}) => ({ commands: commands$1 }) => {
				if (!href) return commands$1.unsetLink();
				return commands$1.setLink({
					href,
					text
				});
			}
		};
	}
});
function normalizeProtocols(protocols = []) {
	const result = [];
	protocols.forEach((protocol) => {
		if (!protocol) return;
		if (typeof protocol === "string" && protocol.trim()) result.push(protocol.trim().toLowerCase());
		else if (typeof protocol === "object" && typeof protocol.scheme === "string" && protocol.scheme.trim()) result.push(protocol.scheme.trim().toLowerCase());
	});
	return result;
}
function sanitizeLinkHref(href, protocols) {
	if (!href) return null;
	const normalizedProtocols = Array.isArray(protocols) ? normalizeProtocols(protocols) : [];
	return sanitizeHref(href, { allowedProtocols: Array.from(new Set([...UrlValidationConstants.DEFAULT_ALLOWED_PROTOCOLS, ...normalizedProtocols])) });
}
var trimRange = (doc$1, from$1, to) => {
	while (from$1 < to && doc$1.textBetween(from$1, from$1 + 1, "") === "") from$1 += 1;
	while (to > from$1 && doc$1.textBetween(to - 1, to, "") === "") to -= 1;
	return {
		from: from$1,
		to
	};
};
function addLinkRelationship({ editor, href }) {
	return findOrCreateRelationship(editor, "link:addLinkRelationship", {
		target: href,
		type: "hyperlink"
	});
}
var trackInsertClass = "track-insert";
const TrackInsert = Mark.create({
	name: TrackInsertMarkName,
	group: "track",
	inclusive: false,
	addOptions() {
		return { htmlAttributes: { class: trackInsertClass } };
	},
	addAttributes() {
		return {
			id: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-id"),
				renderDOM: (attrs) => {
					if (!attrs.id) return {};
					return { "data-id": attrs.id };
				}
			},
			author: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-author"),
				renderDOM: (attrs) => {
					if (!attrs.author) return {};
					return { "data-author": attrs.author };
				}
			},
			authorId: {
				default: "",
				rendered: false
			},
			authorEmail: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-authoremail"),
				renderDOM: (attrs) => {
					if (!attrs.authorEmail) return {};
					return { "data-authoremail": attrs.authorEmail };
				}
			},
			authorImage: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-authorimage"),
				renderDOM: (attrs) => {
					if (!attrs.authorImage) return {};
					return { "data-authorimage": attrs.authorImage };
				}
			},
			date: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-date"),
				renderDOM: (attrs) => {
					if (!attrs.date) return {};
					return { "data-date": attrs.date };
				}
			},
			sourceId: {
				default: "",
				rendered: false
			},
			importedAuthor: {
				default: "",
				rendered: false
			},
			revisionGroupId: {
				default: "",
				rendered: false
			},
			splitFromId: {
				default: "",
				rendered: false
			},
			changeType: {
				default: "",
				rendered: false
			},
			replacementGroupId: {
				default: "",
				rendered: false
			},
			replacementSideId: {
				default: "",
				rendered: false
			},
			overlapParentId: {
				default: "",
				rendered: false
			},
			sourceIds: {
				default: null,
				rendered: false
			},
			origin: {
				default: "",
				rendered: false
			}
		};
	},
	parseDOM() {
		return false;
	},
	renderDOM({ htmlAttributes }) {
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	}
});
var trackDeleteClass = "track-delete";
const TrackDelete = Mark.create({
	name: TrackDeleteMarkName,
	group: "track",
	inclusive: false,
	addOptions() {
		return { htmlAttributes: { class: trackDeleteClass } };
	},
	addAttributes() {
		return {
			id: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-id"),
				renderDOM: (attrs) => {
					if (!attrs.id) return {};
					return { "data-id": attrs.id };
				}
			},
			author: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-author"),
				renderDOM: (attrs) => {
					if (!attrs.author) return {};
					return { "data-author": attrs.author };
				}
			},
			authorId: {
				default: "",
				rendered: false
			},
			authorEmail: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-authoremail"),
				renderDOM: (attrs) => {
					if (!attrs.authorEmail) return {};
					return { "data-authoremail": attrs.authorEmail };
				}
			},
			authorImage: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-authorimage"),
				renderDOM: (attrs) => {
					if (!attrs.authorImage) return {};
					return { "data-authorimage": attrs.authorImage };
				}
			},
			date: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-date"),
				renderDOM: (attrs) => {
					if (!attrs.date) return {};
					return { "data-date": attrs.date };
				}
			},
			sourceId: {
				default: "",
				rendered: false
			},
			importedAuthor: {
				default: "",
				rendered: false
			},
			revisionGroupId: {
				default: "",
				rendered: false
			},
			splitFromId: {
				default: "",
				rendered: false
			},
			changeType: {
				default: "",
				rendered: false
			},
			replacementGroupId: {
				default: "",
				rendered: false
			},
			replacementSideId: {
				default: "",
				rendered: false
			},
			overlapParentId: {
				default: "",
				rendered: false
			},
			sourceIds: {
				default: null,
				rendered: false
			},
			origin: {
				default: "",
				rendered: false
			}
		};
	},
	parseDOM() {
		return false;
	},
	renderDOM({ htmlAttributes }) {
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	}
});
var TRACKED_MARK_SET = new Set([
	TrackInsertMarkName,
	TrackDeleteMarkName,
	TrackFormatMarkName
]);
const enumerateTrackedMarkSpans = (state) => {
	const out = [];
	if (!state?.doc) return out;
	const inlineNodes = findInlineNodes(state.doc);
	if (!inlineNodes.length) return out;
	for (const { node, pos } of inlineNodes) {
		const marks = node?.marks ?? [];
		if (!marks.length) continue;
		for (const mark of marks) {
			if (!TRACKED_MARK_SET.has(mark.type.name)) continue;
			out.push({
				mark,
				from: pos,
				to: pos + node.nodeSize
			});
		}
	}
	return out;
};
const CanonicalChangeType = Object.freeze({
	Insertion: "insertion",
	Deletion: "deletion",
	Replacement: "replacement",
	Formatting: "formatting",
	Structural: "structural"
});
const ChangeSubtype = Object.freeze({
	TextInsertion: "text-insertion",
	TextDeletion: "text-deletion",
	TextReplacement: "text-replacement",
	RunFormatting: "run-formatting",
	TableInsert: "table-insert",
	TableDelete: "table-delete"
});
const SegmentSide = Object.freeze({
	Inserted: "inserted",
	Deleted: "deleted",
	Formatting: "formatting"
});
var CHANGE_TYPE_VALUES = new Set(Object.values(CanonicalChangeType));
const sideFromMarkName = (markName) => {
	if (markName === "trackInsert") return SegmentSide.Inserted;
	if (markName === "trackDelete") return SegmentSide.Deleted;
	if (markName === "trackFormat") return SegmentSide.Formatting;
	return null;
};
const subtypeFromChangeType = (changeType) => {
	switch (changeType) {
		case CanonicalChangeType.Insertion: return ChangeSubtype.TextInsertion;
		case CanonicalChangeType.Deletion: return ChangeSubtype.TextDeletion;
		case CanonicalChangeType.Replacement: return ChangeSubtype.TextReplacement;
		case CanonicalChangeType.Formatting: return ChangeSubtype.RunFormatting;
		default: return null;
	}
};
const deterministicJson = (value) => {
	const canonical = canonicalizeForSerialization(value);
	return JSON.stringify(canonical);
};
var canonicalizeForSerialization = (value) => {
	if (value === void 0 || typeof value === "function") return void 0;
	if (value === null) return null;
	if (Array.isArray(value)) return value.map((entry) => {
		const inner = canonicalizeForSerialization(entry);
		return inner === void 0 ? null : inner;
	});
	if (typeof value === "object") {
		const out = {};
		const keys$1 = Object.keys(value).sort();
		for (const key of keys$1) {
			const inner = canonicalizeForSerialization(value[key]);
			if (inner === void 0) continue;
			out[key] = inner;
		}
		return out;
	}
	return value;
};
const canonicalizeSourceIds = (value) => {
	if (value == null) return {};
	if (typeof value === "string") {
		const trimmed = value.trim();
		if (!trimmed) return {};
		try {
			const parsed = JSON.parse(trimmed);
			if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) return canonicalSourceIdsFromObject(parsed);
		} catch {}
		return { raw: trimmed };
	}
	if (typeof value === "object" && !Array.isArray(value)) return canonicalSourceIdsFromObject(value);
	return {};
};
var canonicalSourceIdsFromObject = (obj) => {
	const out = {};
	const keys$1 = Object.keys(obj).sort();
	for (const key of keys$1) {
		const v = obj[key];
		if (v == null) continue;
		if (typeof v === "string") {
			const trimmed = v.trim();
			if (!trimmed) continue;
			out[key] = trimmed;
			continue;
		}
		if (typeof v === "number" || typeof v === "boolean") {
			out[key] = v;
			continue;
		}
		if (typeof v === "object") {
			out[key] = canonicalizeForSerialization(v);
			continue;
		}
	}
	return out;
};
var stringAttr = (value) => typeof value === "string" ? value : "";
const readTrackedAttrs = (markOrAttrs, markName) => {
	const isMark = markOrAttrs && typeof markOrAttrs === "object" && "attrs" in markOrAttrs;
	const attrs = (isMark ? markOrAttrs.attrs : markOrAttrs) ?? {};
	const resolvedMarkName = markName ?? (isMark ? markOrAttrs.type?.name : "") ?? "";
	const id = stringAttr(attrs.id);
	const explicitRevisionGroupId = stringAttr(attrs.revisionGroupId);
	const explicitChangeType = stringAttr(attrs.changeType);
	const explicitOrigin = stringAttr(attrs.origin);
	const explicitSplitFromId = stringAttr(attrs.splitFromId);
	const explicitReplacementGroupId = stringAttr(attrs.replacementGroupId);
	const explicitReplacementSideId = stringAttr(attrs.replacementSideId);
	const explicitOverlapParentId = stringAttr(attrs.overlapParentId);
	const sideInferred = sideFromMarkName(resolvedMarkName) ?? "";
	const changeTypeInferred = inferChangeTypeFromMarkName(resolvedMarkName);
	const changeType = explicitChangeType && CHANGE_TYPE_VALUES.has(explicitChangeType) ? explicitChangeType : changeTypeInferred;
	const subtype = subtypeFromChangeType(changeType) ?? "";
	const sourceIds = canonicalizeSourceIds(attrs.sourceIds);
	const legacySourceId = stringAttr(attrs.sourceId);
	if (legacySourceId && resolvedMarkName) {
		const key = legacySourceIdKey(resolvedMarkName);
		if (key && !sourceIds[key]) sourceIds[key] = legacySourceId;
	}
	const hasReviewMetadata = Boolean(explicitChangeType || explicitRevisionGroupId || explicitSplitFromId || explicitReplacementGroupId || explicitReplacementSideId || explicitOverlapParentId || explicitOrigin || attrs.sourceIds != null && Object.keys(canonicalizeSourceIds(attrs.sourceIds)).length > 0);
	return {
		id,
		revisionGroupId: explicitRevisionGroupId || id,
		splitFromId: explicitSplitFromId,
		changeType,
		replacementGroupId: explicitReplacementGroupId,
		replacementSideId: explicitReplacementSideId,
		overlapParentId: explicitOverlapParentId,
		sourceIds,
		sourceId: legacySourceId,
		importedAuthor: stringAttr(attrs.importedAuthor),
		origin: explicitOrigin,
		author: stringAttr(attrs.author),
		authorId: stringAttr(attrs.authorId),
		authorEmail: stringAttr(attrs.authorEmail),
		authorImage: stringAttr(attrs.authorImage),
		date: stringAttr(attrs.date),
		markType: resolvedMarkName,
		side: sideInferred,
		subtype,
		explicitChangeType: explicitChangeType && CHANGE_TYPE_VALUES.has(explicitChangeType) ? explicitChangeType : "",
		hasReviewMetadata
	};
};
var inferChangeTypeFromMarkName = (markName) => {
	if (markName === "trackInsert") return CanonicalChangeType.Insertion;
	if (markName === "trackDelete") return CanonicalChangeType.Deletion;
	if (markName === "trackFormat") return CanonicalChangeType.Formatting;
	return "";
};
var legacySourceIdKey = (markName) => {
	if (markName === "trackInsert") return "wordIdInsert";
	if (markName === "trackDelete") return "wordIdDelete";
	if (markName === "trackFormat") return "wordIdFormat";
	return "";
};
const normalizedAttrsEqual = (a, b$1) => {
	if (a.markType !== b$1.markType) return false;
	if (a.id !== b$1.id) return false;
	if (a.revisionGroupId !== b$1.revisionGroupId) return false;
	if (a.splitFromId !== b$1.splitFromId) return false;
	if (a.changeType !== b$1.changeType) return false;
	if (a.replacementGroupId !== b$1.replacementGroupId) return false;
	if (a.replacementSideId !== b$1.replacementSideId) return false;
	if (a.overlapParentId !== b$1.overlapParentId) return false;
	if (a.author !== b$1.author) return false;
	if (a.authorId !== b$1.authorId) return false;
	if (a.authorEmail !== b$1.authorEmail) return false;
	if (a.authorImage !== b$1.authorImage) return false;
	if (a.date !== b$1.date) return false;
	if (a.importedAuthor !== b$1.importedAuthor) return false;
	if (a.origin !== b$1.origin) return false;
	if (deterministicJson(a.sourceIds) !== deterministicJson(b$1.sourceIds)) return false;
	return true;
};
const BODY_STORY = Object.freeze({
	kind: "story",
	storyType: "body"
});
const buildReviewGraph = ({ state, story = BODY_STORY, replacementsMode = "paired" }) => {
	return buildGraphFromSpans({
		spans: enumerateTrackedMarkSpans(state),
		structuralChanges: enumerateStructuralRowChanges(state),
		doc: state?.doc ?? null,
		story,
		replacementsMode
	});
};
var buildGraphFromSpans = ({ spans, structuralChanges = [], doc: doc$1, story, replacementsMode }) => {
	const mergedSegments = mergeAdjacentSpans(spans.map((span) => ({
		attrs: readTrackedAttrs(span.mark, span.mark.type.name),
		span
	})));
	hydrateSegmentText({
		segments: mergedSegments,
		doc: doc$1
	});
	const segmentsByChangeId = groupBy(mergedSegments, (s) => s.changeId);
	const changes = /* @__PURE__ */ new Map();
	const byRevisionGroupId = /* @__PURE__ */ new Map();
	const byReplacementGroupId = /* @__PURE__ */ new Map();
	const byParentId = /* @__PURE__ */ new Map();
	for (const [changeId, segs] of segmentsByChangeId) {
		const logical = buildLogicalChange({
			changeId,
			segments: segs,
			doc: doc$1,
			story,
			replacementsMode
		});
		changes.set(changeId, logical);
		appendToMap(byRevisionGroupId, logical.revisionGroupId, changeId);
		if (logical.replacement) appendToMap(byReplacementGroupId, logical.replacement.groupId, changeId);
		for (const seg of segs) if (seg.attrs.replacementGroupId) appendToMap(byReplacementGroupId, seg.attrs.replacementGroupId, changeId);
	}
	for (const [id, logical] of changes) {
		let resolvedParentId = "";
		for (const seg of logical.segments) {
			const parentId = seg.attrs.overlapParentId;
			if (!parentId || parentId === id) continue;
			const parentLogical = changes.get(parentId);
			seg.parentId = parentId;
			seg.parentSide = parentLogical ? parentLogical.type === CanonicalChangeType.Replacement ? "" : parentLogical.segments[0]?.side ?? "" : "";
			seg.overlapRole = "child";
			if (!resolvedParentId) resolvedParentId = parentId;
			appendToMap(byParentId, parentId, id);
		}
		if (resolvedParentId) logical.parent = resolvedParentId;
	}
	for (const [parentId, childIds] of byParentId) {
		const parent = changes.get(parentId);
		if (parent) {
			parent.children = unique$1(childIds);
			const childCoverageSegments = parent.children.flatMap((childId) => changes.get(childId)?.segments ?? []).filter((seg) => shouldContributeToParentCoverage(seg));
			parent.coverageSegments = uniqueSegments([...parent.coverageSegments, ...childCoverageSegments]);
		}
	}
	const bySegmentId = /* @__PURE__ */ new Map();
	for (const segs of segmentsByChangeId.values()) for (const seg of segs) bySegmentId.set(seg.segmentId, seg);
	for (const structural of structuralChanges) {
		const logical = buildStructuralLogicalChange({
			structural,
			doc: doc$1,
			story
		});
		if (!logical) continue;
		const internalKey = `structural:${structural.tablePos}:${structural.side}`;
		if (changes.has(internalKey)) continue;
		changes.set(internalKey, logical);
		if (logical.id && logical.id !== internalKey && !changes.has(logical.id)) changes.set(logical.id, logical);
		for (const seg of logical.segments) bySegmentId.set(seg.segmentId, seg);
		mergedSegments.push(...logical.segments);
		appendToMap(byRevisionGroupId, logical.revisionGroupId, logical.id);
	}
	const segments = mergedSegments.slice().sort((a, b$1) => a.from - b$1.from || a.to - b$1.to);
	const graph = {
		changes,
		segments,
		bySegmentId,
		byRevisionGroupId,
		byReplacementGroupId,
		byParentId,
		story,
		overlapAt: (pos) => segments.filter((seg) => pos >= seg.from && pos < seg.to),
		segmentsInRange: (from$1, to) => {
			if (from$1 > to) [from$1, to] = [to, from$1];
			return segments.filter((seg) => seg.to > from$1 && seg.from < to);
		},
		changesInRange: (from$1, to) => {
			const ids = /* @__PURE__ */ new Set();
			for (const seg of segments) {
				if (seg.to <= from$1 || seg.from >= to) continue;
				ids.add(seg.changeId);
			}
			return Array.from(ids).map((id) => changes.get(id)).filter(Boolean);
		},
		validate: () => validateGraph(graph)
	};
	Object.defineProperty(graph, "replacementsMode", {
		value: replacementsMode,
		enumerable: false
	});
	return graph;
};
var mergeAdjacentSpans = (normalized) => {
	const sorted = [...normalized].sort((a, b$1) => {
		if (a.span.from !== b$1.span.from) return a.span.from - b$1.span.from;
		return a.span.to - b$1.span.to;
	});
	const merged = [];
	const ordinalByChange = /* @__PURE__ */ new Map();
	for (const { attrs, span } of sorted) {
		const last = merged.length ? merged[merged.length - 1] : null;
		if (last && last.changeId === attrs.id && last.markType === attrs.markType && last.to === span.from && normalizedAttrsEqual(last.attrs, attrs)) {
			last.to = span.to;
			last.markRuns.push({
				from: span.from,
				to: span.to,
				mark: span.mark
			});
			continue;
		}
		const ordinal = ordinalByChange.get(attrs.id) ?? 0;
		ordinalByChange.set(attrs.id, ordinal + 1);
		const side = attrs.side || sideFromMarkNameSafe(attrs.markType);
		const seg = {
			segmentId: makeSegmentId(attrs.id, side, span.from, span.to, ordinal),
			changeId: attrs.id,
			markType: attrs.markType,
			side,
			from: span.from,
			to: span.to,
			text: "",
			mark: span.mark,
			markRuns: [{
				from: span.from,
				to: span.to,
				mark: span.mark
			}],
			attrs,
			parentId: attrs.overlapParentId || "",
			parentSide: "",
			overlapRole: attrs.overlapParentId ? "child" : "standalone"
		};
		merged.push(seg);
	}
	return merged;
};
var hydrateSegmentText = ({ segments, doc: doc$1 }) => {
	if (!doc$1) return;
	for (const seg of segments) try {
		seg.text = doc$1.textBetween(seg.from, seg.to, " ", "￼");
	} catch {
		seg.text = "";
	}
};
var shouldContributeToParentCoverage = (childSegment) => {
	return childSegment.side !== SegmentSide.Inserted;
};
var sideFromMarkNameSafe = (markName) => {
	if (markName === "trackInsert") return SegmentSide.Inserted;
	if (markName === "trackDelete") return SegmentSide.Deleted;
	if (markName === "trackFormat") return SegmentSide.Formatting;
	return "";
};
var makeSegmentId = (changeId, side, from$1, to, ordinal) => `${changeId}:${side}:${from$1}:${to}:${ordinal}`;
var buildLogicalChange = ({ changeId, segments, doc: doc$1, story, replacementsMode }) => {
	const inserted = segments.filter((s) => s.side === SegmentSide.Inserted);
	const deleted = segments.filter((s) => s.side === SegmentSide.Deleted);
	const formatting = segments.filter((s) => s.side === SegmentSide.Formatting);
	const explicitType = segments.find((s) => s.attrs.explicitChangeType)?.attrs.explicitChangeType ?? "";
	let type;
	if (explicitType) type = explicitType;
	else if (inserted.length && deleted.length) type = CanonicalChangeType.Replacement;
	else if (inserted.length) type = CanonicalChangeType.Insertion;
	else if (deleted.length) type = CanonicalChangeType.Deletion;
	else if (formatting.length) type = CanonicalChangeType.Formatting;
	else type = "";
	const subtype = subtypeFromChangeType(type) ?? "";
	const primary = segments[0]?.attrs ?? null;
	let replacement = null;
	if (type === CanonicalChangeType.Replacement) {
		const insertedSideId = inserted[0]?.attrs.replacementSideId || `${changeId}#inserted`;
		const deletedSideId = deleted[0]?.attrs.replacementSideId || `${changeId}#deleted`;
		replacement = {
			groupId: (segments.find((s) => s.attrs.replacementGroupId)?.attrs.replacementGroupId ?? "") || changeId,
			inserted,
			deleted,
			insertedSideId,
			deletedSideId
		};
	}
	const aggregatedSourceIds = aggregateSourceIds(segments);
	const sourcePlatform = derivePlatform(segments, primary);
	const before = formatting.length ? formatting[0]?.mark?.attrs?.before ?? [] : [];
	const after = formatting.length ? formatting[0]?.mark?.attrs?.after ?? [] : [];
	const coverageSegments = [...segments];
	const excerpt = doc$1 ? extractExcerpt(doc$1, segments) : "";
	const logical = {
		id: changeId,
		type,
		subtype,
		state: "open",
		segments,
		coverageSegments,
		insertedSegments: inserted,
		deletedSegments: deleted,
		formattingSegments: formatting,
		replacement,
		author: primary?.author ?? "",
		authorId: primary?.authorId ?? "",
		authorEmail: primary?.authorEmail ?? "",
		authorImage: primary?.authorImage ?? "",
		date: primary?.date ?? "",
		sourceIds: aggregatedSourceIds,
		revisionGroupId: primary?.revisionGroupId || changeId,
		splitFromId: primary?.splitFromId ?? "",
		sourcePlatform,
		story,
		parent: null,
		children: [],
		before,
		after,
		excerpt
	};
	Object.defineProperty(logical, "replacementsMode", {
		value: replacementsMode,
		enumerable: false
	});
	return logical;
};
var buildStructuralLogicalChange = ({ structural, doc: doc$1, story }) => {
	const side = structural.side === "insertion" ? SegmentSide.Inserted : SegmentSide.Deleted;
	const from$1 = structural.tableFrom;
	const to = structural.tableTo;
	if (!(from$1 < to)) return null;
	const attrs = {
		id: structural.id,
		revisionGroupId: structural.revisionGroupId,
		splitFromId: "",
		changeType: CanonicalChangeType.Structural,
		replacementGroupId: "",
		replacementSideId: "",
		overlapParentId: "",
		sourceIds: structural.sourceId ? { wordIdStructural: structural.sourceId } : {},
		sourceId: structural.sourceId,
		importedAuthor: structural.importedAuthor,
		origin: structural.sourceId ? "word" : "",
		author: structural.author,
		authorId: "",
		authorEmail: structural.authorEmail,
		authorImage: structural.authorImage,
		date: structural.date,
		markType: "",
		side,
		subtype: structural.subtype,
		explicitChangeType: CanonicalChangeType.Structural,
		hasReviewMetadata: true
	};
	const segment = {
		segmentId: `${structural.id}:structural:${from$1}:${to}:0`,
		changeId: structural.id,
		markType: "",
		side,
		from: from$1,
		to,
		text: "",
		mark: null,
		markRuns: [],
		attrs,
		parentId: "",
		parentSide: "",
		overlapRole: "standalone",
		structural: true
	};
	if (doc$1) try {
		segment.text = doc$1.textBetween(from$1, to, " ", "￼");
	} catch {
		segment.text = "";
	}
	const segments = [segment];
	const logical = {
		id: structural.id,
		type: CanonicalChangeType.Structural,
		subtype: structural.subtype,
		state: "open",
		segments,
		coverageSegments: [...segments],
		insertedSegments: side === SegmentSide.Inserted ? [...segments] : [],
		deletedSegments: side === SegmentSide.Deleted ? [...segments] : [],
		formattingSegments: [],
		replacement: null,
		author: structural.author,
		authorId: "",
		authorEmail: structural.authorEmail,
		authorImage: structural.authorImage,
		date: structural.date,
		sourceIds: attrs.sourceIds,
		revisionGroupId: structural.revisionGroupId,
		splitFromId: "",
		sourcePlatform: structural.sourceId ? "word" : "",
		story,
		parent: null,
		children: [],
		before: [],
		after: [],
		excerpt: segment.text.length > 200 ? `${segment.text.slice(0, 200)}…` : segment.text
	};
	Object.defineProperty(logical, "structural", {
		value: structural,
		enumerable: false
	});
	return logical;
};
var aggregateSourceIds = (segments) => {
	const out = {};
	const sorted = [...segments].sort((a, b$1) => {
		if (a.side !== b$1.side) return a.side < b$1.side ? -1 : 1;
		return a.from - b$1.from;
	});
	for (const seg of sorted) for (const [k$1, v] of Object.entries(seg.attrs.sourceIds || {})) {
		if (v == null || v === "") continue;
		if (out[k$1] == null) out[k$1] = v;
	}
	return out;
};
var derivePlatform = (segments, primary) => {
	if (primary?.origin) return primary.origin;
	const sourceIds = primary?.sourceIds || {};
	if (sourceIds.wordIdInsert || sourceIds.wordIdDelete || sourceIds.wordIdFormat) return "word";
	if (primary?.sourceId) return "word";
	return "";
};
var extractExcerpt = (doc$1, segments) => {
	if (!segments.length || !doc$1) return "";
	const target = segments.find((s) => s.side === SegmentSide.Inserted) ?? segments[0];
	try {
		const text = doc$1.textBetween(target.from, target.to, " ", "￼");
		return text.length > 200 ? `${text.slice(0, 200)}…` : text;
	} catch {
		return "";
	}
};
const validateGraph = (graph) => {
	const diagnostics = [];
	for (const seg of graph.segments) if (!seg.changeId) diagnostics.push({
		code: "INV_MARK_MISSING_ID",
		severity: "error",
		message: "tracked mark span lacks an id",
		details: {
			from: seg.from,
			to: seg.to,
			markType: seg.markType
		}
	});
	for (const [id, change] of graph.changes) {
		if (!change.segments.length) {
			diagnostics.push({
				code: "INV_OPEN_CHANGE_NO_SEGMENTS",
				severity: "error",
				message: "logical change has no segments",
				changeIds: [id]
			});
			continue;
		}
		for (const seg of change.segments) if (seg.from >= seg.to) diagnostics.push({
			code: "INV_EMPTY_SEGMENT_RANGE",
			severity: "error",
			message: "tracked segment has an empty range",
			changeIds: [id],
			details: {
				segmentId: seg.segmentId,
				from: seg.from,
				to: seg.to
			}
		});
		if (change.type === CanonicalChangeType.Replacement) {
			if (!change.insertedSegments.length || !change.deletedSegments.length) diagnostics.push({
				code: "INV_REPLACEMENT_MISSING_SIDE",
				severity: "warning",
				message: "replacement is missing one side",
				changeIds: [id],
				details: {
					inserted: change.insertedSegments.length,
					deleted: change.deletedSegments.length
				}
			});
			if (change.replacement && change.replacement.groupId !== id && !graph.byReplacementGroupId.has(change.replacement.groupId)) diagnostics.push({
				code: "INV_REPLACEMENT_GROUP_MISMATCH",
				severity: "warning",
				message: "replacementGroupId not indexed",
				changeIds: [id]
			});
		}
		if (change.splitFromId && change.splitFromId === id) diagnostics.push({
			code: "INV_SPLIT_FROM_SELF",
			severity: "error",
			message: "splitFromId equals own id",
			changeIds: [id]
		});
		for (const seg of change.segments) if (seg.attrs.overlapParentId && !graph.changes.has(seg.attrs.overlapParentId)) diagnostics.push({
			code: "INV_CHILD_MISSING_PARENT",
			severity: "warning",
			message: "segment references a missing overlap parent",
			changeIds: [id],
			details: {
				segmentId: seg.segmentId,
				parentId: seg.attrs.overlapParentId
			}
		});
		const revisionGroups = unique$1(change.segments.map((s) => s.attrs.revisionGroupId || id));
		if (revisionGroups.length > 1) diagnostics.push({
			code: "INV_REVISION_GROUP_INCONSISTENT",
			severity: "warning",
			message: "segments of one logical change reference multiple revisionGroupIds",
			changeIds: [id],
			details: { revisionGroups }
		});
		for (const seg of change.segments) {
			const expectedSide = sideFromMarkNameSafe(seg.markType);
			if (expectedSide && seg.side !== expectedSide) diagnostics.push({
				code: "INV_SIDE_DERIVATION_MISMATCH",
				severity: "error",
				message: "segment side does not match mark type",
				changeIds: [id],
				details: {
					segmentId: seg.segmentId,
					side: seg.side,
					markType: seg.markType
				}
			});
		}
	}
	const segmentsByPosition = /* @__PURE__ */ new Map();
	for (const seg of graph.segments) {
		const key = `${seg.markType}:${seg.from}:${seg.to}`;
		if (segmentsByPosition.has(key)) diagnostics.push({
			code: "INV_SAME_TYPE_OVERLAP",
			severity: "error",
			message: "same-type tracked marks occupy identical range",
			changeIds: [seg.changeId, segmentsByPosition.get(key).changeId],
			details: {
				range: {
					from: seg.from,
					to: seg.to
				},
				markType: seg.markType
			}
		});
		else segmentsByPosition.set(key, seg);
	}
	return diagnostics;
};
var groupBy = (arr, fn) => {
	const out = /* @__PURE__ */ new Map();
	for (const item of arr) {
		const key = fn(item);
		const list = out.get(key);
		if (list) list.push(item);
		else out.set(key, [item]);
	}
	return out;
};
var appendToMap = (map$1, key, value) => {
	const list = map$1.get(key);
	if (list) {
		if (!list.includes(value)) list.push(value);
	} else map$1.set(key, [value]);
};
var unique$1 = (arr) => Array.from(new Set(arr));
var uniqueSegments = (segments) => {
	const seen = /* @__PURE__ */ new Set();
	const out = [];
	for (const seg of segments) {
		if (seen.has(seg.segmentId)) continue;
		seen.add(seg.segmentId);
		out.push(seg);
	}
	out.sort((a, b$1) => {
		if (a.from !== b$1.from) return a.from - b$1.from;
		if (a.to !== b$1.to) return a.to - b$1.to;
		return a.segmentId.localeCompare(b$1.segmentId);
	});
	return out;
};
const graphHasErrors = (graph) => {
	for (const d of validateGraph(graph)) if (d.severity === "error") return true;
	return false;
};
const findTrackedMarkBetween = ({ tr, from: from$1, to, markName, attrs = {}, predicate = null, offset: offset$1 = 1 }) => {
	const { doc: doc$1 } = tr;
	const startPos = Math.max(from$1 - offset$1, 0);
	const endPos = Math.min(to + offset$1, doc$1.content.size);
	let markFound = null;
	const tryMatch = (node, pos) => {
		if (!node || node?.nodeSize === void 0) return;
		const mark = node.marks?.find((mark$1) => mark$1.type.name === markName && Object.keys(attrs).every((attr) => mark$1.attrs[attr] === attrs[attr]) && (typeof predicate !== "function" || predicate(mark$1)));
		if (mark && !markFound) {
			markFound = {
				from: pos,
				to: pos + node.nodeSize,
				mark
			};
			return false;
		}
	};
	doc$1.nodesBetween(startPos, endPos, (node, pos) => {
		return tryMatch(node, pos);
	});
	const inspectAroundPosition = (pos) => {
		if (pos < 0 || pos > doc$1.content.size) return;
		const resolved = doc$1.resolve(pos);
		const before = resolved.nodeBefore;
		const after = resolved.nodeAfter;
		if (before?.type?.name === "text") tryMatch(before, Math.max(pos - before.nodeSize, 0));
		else if (before?.type?.name === "run") {
			const beforeStart = Math.max(pos - before.nodeSize, 0);
			const node = before.content?.content?.[0];
			if (node?.type?.name === "text") tryMatch(node, beforeStart);
		}
		if (after?.type?.name === "text") tryMatch(after, pos);
		else if (after?.type?.name === "run") {
			const node = after.content?.content?.[0];
			if (node?.type?.name === "text") tryMatch(node, pos);
		}
	};
	if (!markFound) {
		inspectAroundPosition(startPos);
		inspectAroundPosition(endPos);
	}
	return markFound;
};
const markInsertion = ({ tr, from: from$1, to, user, date, id: providedId }) => {
	tr.removeMark(from$1, to, tr.doc.type.schema.marks[TrackDeleteMarkName]);
	tr.removeMark(from$1, to, tr.doc.type.schema.marks[TrackInsertMarkName]);
	const currentIdentity = getCurrentUserIdentity({ options: { user } });
	const trackedMark = findTrackedMarkBetween({
		tr,
		from: from$1,
		to,
		markName: TrackInsertMarkName,
		predicate: (mark) => matchesSameUserRefinement({
			currentUser: currentIdentity,
			change: getChangeAuthorIdentity(mark)
		})
	});
	let id;
	if (providedId) id = providedId;
	else if (trackedMark) id = trackedMark.mark.attrs.id;
	else id = v4_default();
	const insertionMark = tr.doc.type.schema.marks[TrackInsertMarkName].create({
		id,
		author: user.name || "",
		authorId: user.id || "",
		authorEmail: user.email || "",
		authorImage: user.image || "",
		date
	});
	tr.addMark(from$1, to, insertionMark);
	tr.doc.nodesBetween(from$1, to, (node, pos) => {
		if (pos < from$1 || ["bulletList", "orderedList"].includes(node.type.name)) return true;
		else if (node.isInline || ["tableRow", "tableCell"].includes(node.type.name)) return false;
		if (node.attrs.track) {}
		if (node.type.name === "table") return false;
	});
	return insertionMark;
};
var require_lodash = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	init_dist$2();
	(function() {
		var undefined$1;
		var VERSION = "4.17.23";
		var LARGE_ARRAY_SIZE = 200;
		var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
		var HASH_UNDEFINED = "__lodash_hash_undefined__";
		var MAX_MEMOIZE_SIZE = 500;
		var PLACEHOLDER = "__lodash_placeholder__";
		var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
		var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
		var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
		var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
		var HOT_COUNT = 800, HOT_SPAN = 16;
		var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
		var INFINITY = Infinity, MAX_SAFE_INTEGER$1 = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = NaN;
		var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
		var wrapFlags = [
			["ary", WRAP_ARY_FLAG],
			["bind", WRAP_BIND_FLAG],
			["bindKey", WRAP_BIND_KEY_FLAG],
			["curry", WRAP_CURRY_FLAG],
			["curryRight", WRAP_CURRY_RIGHT_FLAG],
			["flip", WRAP_FLIP_FLAG],
			["partial", WRAP_PARTIAL_FLAG],
			["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
			["rearg", WRAP_REARG_FLAG]
		];
		var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
		var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
		var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
		var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
		var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
		var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
		var reTrimStart = /^\s+/;
		var reWhitespace = /\s/;
		var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
		var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
		var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
		var reEscapeChar = /\\(\\)?/g;
		var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
		var reFlags = /\w*$/;
		var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
		var reIsBinary = /^0b[01]+$/i;
		var reIsHostCtor = /^\[object .+?Constructor\]$/;
		var reIsOctal = /^0o[0-7]+$/i;
		var reIsUint = /^(?:0|[1-9]\d*)$/;
		var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
		var reNoMatch = /($^)/;
		var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
		var rsAstralRange = "\\ud800-\\udfff", rsComboRange = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff", rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
		var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
		var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
			rsNonAstral,
			rsRegional,
			rsSurrPair
		].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
			rsDingbat,
			rsRegional,
			rsSurrPair
		].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
			rsNonAstral + rsCombo + "?",
			rsCombo,
			rsRegional,
			rsSurrPair,
			rsAstral
		].join("|") + ")";
		var reApos = RegExp(rsApos, "g");
		var reComboMark = RegExp(rsCombo, "g");
		var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
		var reUnicodeWord = RegExp([
			rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
				rsBreak,
				rsUpper,
				"$"
			].join("|") + ")",
			rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
				rsBreak,
				rsUpper + rsMiscLower,
				"$"
			].join("|") + ")",
			rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
			rsUpper + "+" + rsOptContrUpper,
			rsOrdUpper,
			rsOrdLower,
			rsDigits,
			rsEmoji
		].join("|"), "g");
		var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
		var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
		var contextProps = [
			"Array",
			"Buffer",
			"DataView",
			"Date",
			"Error",
			"Float32Array",
			"Float64Array",
			"Function",
			"Int8Array",
			"Int16Array",
			"Int32Array",
			"Map",
			"Math",
			"Object",
			"Promise",
			"RegExp",
			"Set",
			"String",
			"Symbol",
			"TypeError",
			"Uint8Array",
			"Uint8ClampedArray",
			"Uint16Array",
			"Uint32Array",
			"WeakMap",
			"_",
			"clearTimeout",
			"isFinite",
			"parseInt",
			"setTimeout"
		];
		var templateCounter = -1;
		var typedArrayTags = {};
		typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
		typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
		var cloneableTags = {};
		cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
		cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
		var deburredLetters = {
			"À": "A",
			"Á": "A",
			"Â": "A",
			"Ã": "A",
			"Ä": "A",
			"Å": "A",
			"à": "a",
			"á": "a",
			"â": "a",
			"ã": "a",
			"ä": "a",
			"å": "a",
			"Ç": "C",
			"ç": "c",
			"Ð": "D",
			"ð": "d",
			"È": "E",
			"É": "E",
			"Ê": "E",
			"Ë": "E",
			"è": "e",
			"é": "e",
			"ê": "e",
			"ë": "e",
			"Ì": "I",
			"Í": "I",
			"Î": "I",
			"Ï": "I",
			"ì": "i",
			"í": "i",
			"î": "i",
			"ï": "i",
			"Ñ": "N",
			"ñ": "n",
			"Ò": "O",
			"Ó": "O",
			"Ô": "O",
			"Õ": "O",
			"Ö": "O",
			"Ø": "O",
			"ò": "o",
			"ó": "o",
			"ô": "o",
			"õ": "o",
			"ö": "o",
			"ø": "o",
			"Ù": "U",
			"Ú": "U",
			"Û": "U",
			"Ü": "U",
			"ù": "u",
			"ú": "u",
			"û": "u",
			"ü": "u",
			"Ý": "Y",
			"ý": "y",
			"ÿ": "y",
			"Æ": "Ae",
			"æ": "ae",
			"Þ": "Th",
			"þ": "th",
			"ß": "ss",
			"Ā": "A",
			"Ă": "A",
			"Ą": "A",
			"ā": "a",
			"ă": "a",
			"ą": "a",
			"Ć": "C",
			"Ĉ": "C",
			"Ċ": "C",
			"Č": "C",
			"ć": "c",
			"ĉ": "c",
			"ċ": "c",
			"č": "c",
			"Ď": "D",
			"Đ": "D",
			"ď": "d",
			"đ": "d",
			"Ē": "E",
			"Ĕ": "E",
			"Ė": "E",
			"Ę": "E",
			"Ě": "E",
			"ē": "e",
			"ĕ": "e",
			"ė": "e",
			"ę": "e",
			"ě": "e",
			"Ĝ": "G",
			"Ğ": "G",
			"Ġ": "G",
			"Ģ": "G",
			"ĝ": "g",
			"ğ": "g",
			"ġ": "g",
			"ģ": "g",
			"Ĥ": "H",
			"Ħ": "H",
			"ĥ": "h",
			"ħ": "h",
			"Ĩ": "I",
			"Ī": "I",
			"Ĭ": "I",
			"Į": "I",
			"İ": "I",
			"ĩ": "i",
			"ī": "i",
			"ĭ": "i",
			"į": "i",
			"ı": "i",
			"Ĵ": "J",
			"ĵ": "j",
			"Ķ": "K",
			"ķ": "k",
			"ĸ": "k",
			"Ĺ": "L",
			"Ļ": "L",
			"Ľ": "L",
			"Ŀ": "L",
			"Ł": "L",
			"ĺ": "l",
			"ļ": "l",
			"ľ": "l",
			"ŀ": "l",
			"ł": "l",
			"Ń": "N",
			"Ņ": "N",
			"Ň": "N",
			"Ŋ": "N",
			"ń": "n",
			"ņ": "n",
			"ň": "n",
			"ŋ": "n",
			"Ō": "O",
			"Ŏ": "O",
			"Ő": "O",
			"ō": "o",
			"ŏ": "o",
			"ő": "o",
			"Ŕ": "R",
			"Ŗ": "R",
			"Ř": "R",
			"ŕ": "r",
			"ŗ": "r",
			"ř": "r",
			"Ś": "S",
			"Ŝ": "S",
			"Ş": "S",
			"Š": "S",
			"ś": "s",
			"ŝ": "s",
			"ş": "s",
			"š": "s",
			"Ţ": "T",
			"Ť": "T",
			"Ŧ": "T",
			"ţ": "t",
			"ť": "t",
			"ŧ": "t",
			"Ũ": "U",
			"Ū": "U",
			"Ŭ": "U",
			"Ů": "U",
			"Ű": "U",
			"Ų": "U",
			"ũ": "u",
			"ū": "u",
			"ŭ": "u",
			"ů": "u",
			"ű": "u",
			"ų": "u",
			"Ŵ": "W",
			"ŵ": "w",
			"Ŷ": "Y",
			"ŷ": "y",
			"Ÿ": "Y",
			"Ź": "Z",
			"Ż": "Z",
			"Ž": "Z",
			"ź": "z",
			"ż": "z",
			"ž": "z",
			"Ĳ": "IJ",
			"ĳ": "ij",
			"Œ": "Oe",
			"œ": "oe",
			"ŉ": "'n",
			"ſ": "s"
		};
		var htmlEscapes = {
			"&": "&amp;",
			"<": "&lt;",
			">": "&gt;",
			"\"": "&quot;",
			"'": "&#39;"
		};
		var htmlUnescapes = {
			"&amp;": "&",
			"&lt;": "<",
			"&gt;": ">",
			"&quot;": "\"",
			"&#39;": "'"
		};
		var stringEscapes = {
			"\\": "\\",
			"'": "'",
			"\n": "n",
			"\r": "r",
			"\u2028": "u2028",
			"\u2029": "u2029"
		};
		var freeParseFloat = parseFloat, freeParseInt = parseInt;
		var freeGlobal = typeof global$1 == "object" && global$1 && global$1.Object === Object && global$1;
		var freeSelf = typeof self == "object" && self && self.Object === Object && self;
		var root = freeGlobal || freeSelf || Function("return this")();
		var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
		var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
		var moduleExports = freeModule && freeModule.exports === freeExports;
		var freeProcess = moduleExports && freeGlobal.process;
		var nodeUtil = function() {
			try {
				var types = freeModule && freeModule.require && freeModule.require("util").types;
				if (types) return types;
				return freeProcess && freeProcess.binding && freeProcess.binding("util");
			} catch (e) {}
		}();
		var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
		function apply(func, thisArg, args$1) {
			switch (args$1.length) {
				case 0: return func.call(thisArg);
				case 1: return func.call(thisArg, args$1[0]);
				case 2: return func.call(thisArg, args$1[0], args$1[1]);
				case 3: return func.call(thisArg, args$1[0], args$1[1], args$1[2]);
			}
			return func.apply(thisArg, args$1);
		}
		function arrayAggregator(array, setter, iteratee, accumulator) {
			var index = -1, length$1 = array == null ? 0 : array.length;
			while (++index < length$1) {
				var value = array[index];
				setter(accumulator, value, iteratee(value), array);
			}
			return accumulator;
		}
		function arrayEach(array, iteratee) {
			var index = -1, length$1 = array == null ? 0 : array.length;
			while (++index < length$1) if (iteratee(array[index], index, array) === false) break;
			return array;
		}
		function arrayEachRight(array, iteratee) {
			var length$1 = array == null ? 0 : array.length;
			while (length$1--) if (iteratee(array[length$1], length$1, array) === false) break;
			return array;
		}
		function arrayEvery(array, predicate) {
			var index = -1, length$1 = array == null ? 0 : array.length;
			while (++index < length$1) if (!predicate(array[index], index, array)) return false;
			return true;
		}
		function arrayFilter(array, predicate) {
			var index = -1, length$1 = array == null ? 0 : array.length, resIndex = 0, result = [];
			while (++index < length$1) {
				var value = array[index];
				if (predicate(value, index, array)) result[resIndex++] = value;
			}
			return result;
		}
		function arrayIncludes(array, value) {
			return !!(array == null ? 0 : array.length) && baseIndexOf(array, value, 0) > -1;
		}
		function arrayIncludesWith(array, value, comparator) {
			var index = -1, length$1 = array == null ? 0 : array.length;
			while (++index < length$1) if (comparator(value, array[index])) return true;
			return false;
		}
		function arrayMap(array, iteratee) {
			var index = -1, length$1 = array == null ? 0 : array.length, result = Array(length$1);
			while (++index < length$1) result[index] = iteratee(array[index], index, array);
			return result;
		}
		function arrayPush(array, values) {
			var index = -1, length$1 = values.length, offset$1 = array.length;
			while (++index < length$1) array[offset$1 + index] = values[index];
			return array;
		}
		function arrayReduce(array, iteratee, accumulator, initAccum) {
			var index = -1, length$1 = array == null ? 0 : array.length;
			if (initAccum && length$1) accumulator = array[++index];
			while (++index < length$1) accumulator = iteratee(accumulator, array[index], index, array);
			return accumulator;
		}
		function arrayReduceRight(array, iteratee, accumulator, initAccum) {
			var length$1 = array == null ? 0 : array.length;
			if (initAccum && length$1) accumulator = array[--length$1];
			while (length$1--) accumulator = iteratee(accumulator, array[length$1], length$1, array);
			return accumulator;
		}
		function arraySome(array, predicate) {
			var index = -1, length$1 = array == null ? 0 : array.length;
			while (++index < length$1) if (predicate(array[index], index, array)) return true;
			return false;
		}
		var asciiSize = baseProperty("length");
		function asciiToArray(string) {
			return string.split("");
		}
		function asciiWords(string) {
			return string.match(reAsciiWord) || [];
		}
		function baseFindKey(collection, predicate, eachFunc) {
			var result;
			eachFunc(collection, function(value, key, collection$1) {
				if (predicate(value, key, collection$1)) {
					result = key;
					return false;
				}
			});
			return result;
		}
		function baseFindIndex(array, predicate, fromIndex, fromRight) {
			var length$1 = array.length, index = fromIndex + (fromRight ? 1 : -1);
			while (fromRight ? index-- : ++index < length$1) if (predicate(array[index], index, array)) return index;
			return -1;
		}
		function baseIndexOf(array, value, fromIndex) {
			return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
		}
		function baseIndexOfWith(array, value, fromIndex, comparator) {
			var index = fromIndex - 1, length$1 = array.length;
			while (++index < length$1) if (comparator(array[index], value)) return index;
			return -1;
		}
		function baseIsNaN(value) {
			return value !== value;
		}
		function baseMean(array, iteratee) {
			var length$1 = array == null ? 0 : array.length;
			return length$1 ? baseSum(array, iteratee) / length$1 : NAN;
		}
		function baseProperty(key) {
			return function(object) {
				return object == null ? undefined$1 : object[key];
			};
		}
		function basePropertyOf(object) {
			return function(key) {
				return object == null ? undefined$1 : object[key];
			};
		}
		function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
			eachFunc(collection, function(value, index, collection$1) {
				accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection$1);
			});
			return accumulator;
		}
		function baseSortBy(array, comparer) {
			var length$1 = array.length;
			array.sort(comparer);
			while (length$1--) array[length$1] = array[length$1].value;
			return array;
		}
		function baseSum(array, iteratee) {
			var result, index = -1, length$1 = array.length;
			while (++index < length$1) {
				var current = iteratee(array[index]);
				if (current !== undefined$1) result = result === undefined$1 ? current : result + current;
			}
			return result;
		}
		function baseTimes(n, iteratee) {
			var index = -1, result = Array(n);
			while (++index < n) result[index] = iteratee(index);
			return result;
		}
		function baseToPairs(object, props) {
			return arrayMap(props, function(key) {
				return [key, object[key]];
			});
		}
		function baseTrim(string) {
			return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
		}
		function baseUnary(func) {
			return function(value) {
				return func(value);
			};
		}
		function baseValues(object, props) {
			return arrayMap(props, function(key) {
				return object[key];
			});
		}
		function cacheHas(cache$2, key) {
			return cache$2.has(key);
		}
		function charsStartIndex(strSymbols, chrSymbols) {
			var index = -1, length$1 = strSymbols.length;
			while (++index < length$1 && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
			return index;
		}
		function charsEndIndex(strSymbols, chrSymbols) {
			var index = strSymbols.length;
			while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
			return index;
		}
		function countHolders(array, placeholder) {
			var length$1 = array.length, result = 0;
			while (length$1--) if (array[length$1] === placeholder) ++result;
			return result;
		}
		var deburrLetter = basePropertyOf(deburredLetters);
		var escapeHtmlChar = basePropertyOf(htmlEscapes);
		function escapeStringChar(chr) {
			return "\\" + stringEscapes[chr];
		}
		function getValue(object, key) {
			return object == null ? undefined$1 : object[key];
		}
		function hasUnicode(string) {
			return reHasUnicode.test(string);
		}
		function hasUnicodeWord(string) {
			return reHasUnicodeWord.test(string);
		}
		function iteratorToArray(iterator) {
			var data, result = [];
			while (!(data = iterator.next()).done) result.push(data.value);
			return result;
		}
		function mapToArray(map$1) {
			var index = -1, result = Array(map$1.size);
			map$1.forEach(function(value, key) {
				result[++index] = [key, value];
			});
			return result;
		}
		function overArg(func, transform) {
			return function(arg) {
				return func(transform(arg));
			};
		}
		function replaceHolders(array, placeholder) {
			var index = -1, length$1 = array.length, resIndex = 0, result = [];
			while (++index < length$1) {
				var value = array[index];
				if (value === placeholder || value === PLACEHOLDER) {
					array[index] = PLACEHOLDER;
					result[resIndex++] = index;
				}
			}
			return result;
		}
		function setToArray(set) {
			var index = -1, result = Array(set.size);
			set.forEach(function(value) {
				result[++index] = value;
			});
			return result;
		}
		function setToPairs(set) {
			var index = -1, result = Array(set.size);
			set.forEach(function(value) {
				result[++index] = [value, value];
			});
			return result;
		}
		function strictIndexOf(array, value, fromIndex) {
			var index = fromIndex - 1, length$1 = array.length;
			while (++index < length$1) if (array[index] === value) return index;
			return -1;
		}
		function strictLastIndexOf(array, value, fromIndex) {
			var index = fromIndex + 1;
			while (index--) if (array[index] === value) return index;
			return index;
		}
		function stringSize(string) {
			return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
		}
		function stringToArray(string) {
			return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
		}
		function trimmedEndIndex(string) {
			var index = string.length;
			while (index-- && reWhitespace.test(string.charAt(index)));
			return index;
		}
		var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
		function unicodeSize(string) {
			var result = reUnicode.lastIndex = 0;
			while (reUnicode.test(string)) ++result;
			return result;
		}
		function unicodeToArray(string) {
			return string.match(reUnicode) || [];
		}
		function unicodeWords(string) {
			return string.match(reUnicodeWord) || [];
		}
		var _$1 = (function runInContext(context) {
			context = context == null ? root : _$1.defaults(root.Object(), context, _$1.pick(root, contextProps));
			var Array$1 = context.Array, Date$1 = context.Date, Error$1 = context.Error, Function$1 = context.Function, Math$1 = context.Math, Object$1 = context.Object, RegExp$1 = context.RegExp, String$1 = context.String, TypeError$1 = context.TypeError;
			var arrayProto = Array$1.prototype, funcProto = Function$1.prototype, objectProto = Object$1.prototype;
			var coreJsData = context["__core-js_shared__"];
			var funcToString = funcProto.toString;
			var hasOwnProperty$2 = objectProto.hasOwnProperty;
			var idCounter$1 = 0;
			var maskSrcKey = function() {
				var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
				return uid ? "Symbol(src)_1." + uid : "";
			}();
			var nativeObjectToString = objectProto.toString;
			var objectCtorString = funcToString.call(Object$1);
			var oldDash = root._;
			var reIsNative = RegExp$1("^" + funcToString.call(hasOwnProperty$2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
			var Buffer$2 = moduleExports ? context.Buffer : undefined$1, Symbol$1 = context.Symbol, Uint8Array$1 = context.Uint8Array, allocUnsafe = Buffer$2 ? Buffer$2.allocUnsafe : undefined$1, getPrototype = overArg(Object$1.getPrototypeOf, Object$1), objectCreate = Object$1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : undefined$1, symIterator = Symbol$1 ? Symbol$1.iterator : undefined$1, symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined$1;
			var defineProperty = function() {
				try {
					var func = getNative(Object$1, "defineProperty");
					func({}, "", {});
					return func;
				} catch (e) {}
			}();
			var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date$1 && Date$1.now !== root.Date.now && Date$1.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
			var nativeCeil = Math$1.ceil, nativeFloor = Math$1.floor, nativeGetSymbols = Object$1.getOwnPropertySymbols, nativeIsBuffer = Buffer$2 ? Buffer$2.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object$1.keys, Object$1), nativeMax = Math$1.max, nativeMin = Math$1.min, nativeNow = Date$1.now, nativeParseInt = context.parseInt, nativeRandom = Math$1.random, nativeReverse = arrayProto.reverse;
			var DataView$1 = getNative(context, "DataView"), Map$2 = getNative(context, "Map"), Promise$1 = getNative(context, "Promise"), Set$1 = getNative(context, "Set"), WeakMap$1 = getNative(context, "WeakMap"), nativeCreate = getNative(Object$1, "create");
			var metaMap = WeakMap$1 && new WeakMap$1();
			var realNames = {};
			var dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$2), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1);
			var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined$1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1, symbolToString = symbolProto ? symbolProto.toString : undefined$1;
			function lodash(value) {
				if (isObjectLike(value) && !isArray$2(value) && !(value instanceof LazyWrapper)) {
					if (value instanceof LodashWrapper) return value;
					if (hasOwnProperty$2.call(value, "__wrapped__")) return wrapperClone(value);
				}
				return new LodashWrapper(value);
			}
			var baseCreate = function() {
				function object() {}
				return function(proto) {
					if (!isObject$3(proto)) return {};
					if (objectCreate) return objectCreate(proto);
					object.prototype = proto;
					var result$1 = new object();
					object.prototype = undefined$1;
					return result$1;
				};
			}();
			function baseLodash() {}
			function LodashWrapper(value, chainAll) {
				this.__wrapped__ = value;
				this.__actions__ = [];
				this.__chain__ = !!chainAll;
				this.__index__ = 0;
				this.__values__ = undefined$1;
			}
			lodash.templateSettings = {
				"escape": reEscape,
				"evaluate": reEvaluate,
				"interpolate": reInterpolate,
				"variable": "",
				"imports": { "_": lodash }
			};
			lodash.prototype = baseLodash.prototype;
			lodash.prototype.constructor = lodash;
			LodashWrapper.prototype = baseCreate(baseLodash.prototype);
			LodashWrapper.prototype.constructor = LodashWrapper;
			function LazyWrapper(value) {
				this.__wrapped__ = value;
				this.__actions__ = [];
				this.__dir__ = 1;
				this.__filtered__ = false;
				this.__iteratees__ = [];
				this.__takeCount__ = MAX_ARRAY_LENGTH;
				this.__views__ = [];
			}
			function lazyClone() {
				var result$1 = new LazyWrapper(this.__wrapped__);
				result$1.__actions__ = copyArray(this.__actions__);
				result$1.__dir__ = this.__dir__;
				result$1.__filtered__ = this.__filtered__;
				result$1.__iteratees__ = copyArray(this.__iteratees__);
				result$1.__takeCount__ = this.__takeCount__;
				result$1.__views__ = copyArray(this.__views__);
				return result$1;
			}
			function lazyReverse() {
				if (this.__filtered__) {
					var result$1 = new LazyWrapper(this);
					result$1.__dir__ = -1;
					result$1.__filtered__ = true;
				} else {
					result$1 = this.clone();
					result$1.__dir__ *= -1;
				}
				return result$1;
			}
			function lazyValue() {
				var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray$2(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start$1 = view.start, end$1 = view.end, length$1 = end$1 - start$1, index = isRight ? end$1 : start$1 - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length$1, this.__takeCount__);
				if (!isArr || !isRight && arrLength == length$1 && takeCount == length$1) return baseWrapperValue(array, this.__actions__);
				var result$1 = [];
				outer: while (length$1-- && resIndex < takeCount) {
					index += dir;
					var iterIndex = -1, value = array[index];
					while (++iterIndex < iterLength) {
						var data = iteratees[iterIndex], iteratee$1 = data.iteratee, type = data.type, computed$1 = iteratee$1(value);
						if (type == LAZY_MAP_FLAG) value = computed$1;
						else if (!computed$1) if (type == LAZY_FILTER_FLAG) continue outer;
						else break outer;
					}
					result$1[resIndex++] = value;
				}
				return result$1;
			}
			LazyWrapper.prototype = baseCreate(baseLodash.prototype);
			LazyWrapper.prototype.constructor = LazyWrapper;
			function Hash(entries) {
				var index = -1, length$1 = entries == null ? 0 : entries.length;
				this.clear();
				while (++index < length$1) {
					var entry = entries[index];
					this.set(entry[0], entry[1]);
				}
			}
			function hashClear() {
				this.__data__ = nativeCreate ? nativeCreate(null) : {};
				this.size = 0;
			}
			function hashDelete(key) {
				var result$1 = this.has(key) && delete this.__data__[key];
				this.size -= result$1 ? 1 : 0;
				return result$1;
			}
			function hashGet(key) {
				var data = this.__data__;
				if (nativeCreate) {
					var result$1 = data[key];
					return result$1 === HASH_UNDEFINED ? undefined$1 : result$1;
				}
				return hasOwnProperty$2.call(data, key) ? data[key] : undefined$1;
			}
			function hashHas(key) {
				var data = this.__data__;
				return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty$2.call(data, key);
			}
			function hashSet(key, value) {
				var data = this.__data__;
				this.size += this.has(key) ? 0 : 1;
				data[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
				return this;
			}
			Hash.prototype.clear = hashClear;
			Hash.prototype["delete"] = hashDelete;
			Hash.prototype.get = hashGet;
			Hash.prototype.has = hashHas;
			Hash.prototype.set = hashSet;
			function ListCache(entries) {
				var index = -1, length$1 = entries == null ? 0 : entries.length;
				this.clear();
				while (++index < length$1) {
					var entry = entries[index];
					this.set(entry[0], entry[1]);
				}
			}
			function listCacheClear() {
				this.__data__ = [];
				this.size = 0;
			}
			function listCacheDelete(key) {
				var data = this.__data__, index = assocIndexOf(data, key);
				if (index < 0) return false;
				if (index == data.length - 1) data.pop();
				else splice.call(data, index, 1);
				--this.size;
				return true;
			}
			function listCacheGet(key) {
				var data = this.__data__, index = assocIndexOf(data, key);
				return index < 0 ? undefined$1 : data[index][1];
			}
			function listCacheHas(key) {
				return assocIndexOf(this.__data__, key) > -1;
			}
			function listCacheSet(key, value) {
				var data = this.__data__, index = assocIndexOf(data, key);
				if (index < 0) {
					++this.size;
					data.push([key, value]);
				} else data[index][1] = value;
				return this;
			}
			ListCache.prototype.clear = listCacheClear;
			ListCache.prototype["delete"] = listCacheDelete;
			ListCache.prototype.get = listCacheGet;
			ListCache.prototype.has = listCacheHas;
			ListCache.prototype.set = listCacheSet;
			function MapCache(entries) {
				var index = -1, length$1 = entries == null ? 0 : entries.length;
				this.clear();
				while (++index < length$1) {
					var entry = entries[index];
					this.set(entry[0], entry[1]);
				}
			}
			function mapCacheClear() {
				this.size = 0;
				this.__data__ = {
					"hash": new Hash(),
					"map": new (Map$2 || ListCache)(),
					"string": new Hash()
				};
			}
			function mapCacheDelete(key) {
				var result$1 = getMapData(this, key)["delete"](key);
				this.size -= result$1 ? 1 : 0;
				return result$1;
			}
			function mapCacheGet(key) {
				return getMapData(this, key).get(key);
			}
			function mapCacheHas(key) {
				return getMapData(this, key).has(key);
			}
			function mapCacheSet(key, value) {
				var data = getMapData(this, key), size$2 = data.size;
				data.set(key, value);
				this.size += data.size == size$2 ? 0 : 1;
				return this;
			}
			MapCache.prototype.clear = mapCacheClear;
			MapCache.prototype["delete"] = mapCacheDelete;
			MapCache.prototype.get = mapCacheGet;
			MapCache.prototype.has = mapCacheHas;
			MapCache.prototype.set = mapCacheSet;
			function SetCache(values$1) {
				var index = -1, length$1 = values$1 == null ? 0 : values$1.length;
				this.__data__ = new MapCache();
				while (++index < length$1) this.add(values$1[index]);
			}
			function setCacheAdd(value) {
				this.__data__.set(value, HASH_UNDEFINED);
				return this;
			}
			function setCacheHas(value) {
				return this.__data__.has(value);
			}
			SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
			SetCache.prototype.has = setCacheHas;
			function Stack(entries) {
				this.size = (this.__data__ = new ListCache(entries)).size;
			}
			function stackClear() {
				this.__data__ = new ListCache();
				this.size = 0;
			}
			function stackDelete(key) {
				var data = this.__data__, result$1 = data["delete"](key);
				this.size = data.size;
				return result$1;
			}
			function stackGet(key) {
				return this.__data__.get(key);
			}
			function stackHas(key) {
				return this.__data__.has(key);
			}
			function stackSet(key, value) {
				var data = this.__data__;
				if (data instanceof ListCache) {
					var pairs = data.__data__;
					if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
						pairs.push([key, value]);
						this.size = ++data.size;
						return this;
					}
					data = this.__data__ = new MapCache(pairs);
				}
				data.set(key, value);
				this.size = data.size;
				return this;
			}
			Stack.prototype.clear = stackClear;
			Stack.prototype["delete"] = stackDelete;
			Stack.prototype.get = stackGet;
			Stack.prototype.has = stackHas;
			Stack.prototype.set = stackSet;
			function arrayLikeKeys(value, inherited) {
				var isArr = isArray$2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType$1 = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType$1, result$1 = skipIndexes ? baseTimes(value.length, String$1) : [], length$1 = result$1.length;
				for (var key in value) if ((inherited || hasOwnProperty$2.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType$1 && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length$1)))) result$1.push(key);
				return result$1;
			}
			function arraySample(array) {
				var length$1 = array.length;
				return length$1 ? array[baseRandom(0, length$1 - 1)] : undefined$1;
			}
			function arraySampleSize(array, n) {
				return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
			}
			function arrayShuffle(array) {
				return shuffleSelf(copyArray(array));
			}
			function assignMergeValue(object, key, value) {
				if (value !== undefined$1 && !eq(object[key], value) || value === undefined$1 && !(key in object)) baseAssignValue(object, key, value);
			}
			function assignValue(object, key, value) {
				var objValue = object[key];
				if (!(hasOwnProperty$2.call(object, key) && eq(objValue, value)) || value === undefined$1 && !(key in object)) baseAssignValue(object, key, value);
			}
			function assocIndexOf(array, key) {
				var length$1 = array.length;
				while (length$1--) if (eq(array[length$1][0], key)) return length$1;
				return -1;
			}
			function baseAggregator(collection, setter, iteratee$1, accumulator) {
				baseEach(collection, function(value, key, collection$1) {
					setter(accumulator, value, iteratee$1(value), collection$1);
				});
				return accumulator;
			}
			function baseAssign(object, source) {
				return object && copyObject(source, keys$1(source), object);
			}
			function baseAssignIn(object, source) {
				return object && copyObject(source, keysIn(source), object);
			}
			function baseAssignValue(object, key, value) {
				if (key == "__proto__" && defineProperty) defineProperty(object, key, {
					"configurable": true,
					"enumerable": true,
					"value": value,
					"writable": true
				});
				else object[key] = value;
			}
			function baseAt(object, paths) {
				var index = -1, length$1 = paths.length, result$1 = Array$1(length$1), skip = object == null;
				while (++index < length$1) result$1[index] = skip ? undefined$1 : get(object, paths[index]);
				return result$1;
			}
			function baseClamp(number, lower, upper) {
				if (number === number) {
					if (upper !== undefined$1) number = number <= upper ? number : upper;
					if (lower !== undefined$1) number = number >= lower ? number : lower;
				}
				return number;
			}
			function baseClone(value, bitmask, customizer, key, object, stack) {
				var result$1, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
				if (customizer) result$1 = object ? customizer(value, key, object, stack) : customizer(value);
				if (result$1 !== undefined$1) return result$1;
				if (!isObject$3(value)) return value;
				var isArr = isArray$2(value);
				if (isArr) {
					result$1 = initCloneArray(value);
					if (!isDeep) return copyArray(value, result$1);
				} else {
					var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
					if (isBuffer(value)) return cloneBuffer(value, isDeep);
					if (tag == objectTag || tag == argsTag || isFunc && !object) {
						result$1 = isFlat || isFunc ? {} : initCloneObject(value);
						if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result$1, value)) : copySymbols(value, baseAssign(result$1, value));
					} else {
						if (!cloneableTags[tag]) return object ? value : {};
						result$1 = initCloneByTag(value, tag, isDeep);
					}
				}
				stack || (stack = new Stack());
				var stacked = stack.get(value);
				if (stacked) return stacked;
				stack.set(value, result$1);
				if (isSet(value)) value.forEach(function(subValue) {
					result$1.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
				});
				else if (isMap(value)) value.forEach(function(subValue, key$1) {
					result$1.set(key$1, baseClone(subValue, bitmask, customizer, key$1, value, stack));
				});
				var props = isArr ? undefined$1 : (isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys$1)(value);
				arrayEach(props || value, function(subValue, key$1) {
					if (props) {
						key$1 = subValue;
						subValue = value[key$1];
					}
					assignValue(result$1, key$1, baseClone(subValue, bitmask, customizer, key$1, value, stack));
				});
				return result$1;
			}
			function baseConforms(source) {
				var props = keys$1(source);
				return function(object) {
					return baseConformsTo(object, source, props);
				};
			}
			function baseConformsTo(object, source, props) {
				var length$1 = props.length;
				if (object == null) return !length$1;
				object = Object$1(object);
				while (length$1--) {
					var key = props[length$1], predicate = source[key], value = object[key];
					if (value === undefined$1 && !(key in object) || !predicate(value)) return false;
				}
				return true;
			}
			function baseDelay(func, wait, args$1) {
				if (typeof func != "function") throw new TypeError$1(FUNC_ERROR_TEXT);
				return setTimeout$1(function() {
					func.apply(undefined$1, args$1);
				}, wait);
			}
			function baseDifference(array, values$1, iteratee$1, comparator) {
				var index = -1, includes$1 = arrayIncludes, isCommon = true, length$1 = array.length, result$1 = [], valuesLength = values$1.length;
				if (!length$1) return result$1;
				if (iteratee$1) values$1 = arrayMap(values$1, baseUnary(iteratee$1));
				if (comparator) {
					includes$1 = arrayIncludesWith;
					isCommon = false;
				} else if (values$1.length >= LARGE_ARRAY_SIZE) {
					includes$1 = cacheHas;
					isCommon = false;
					values$1 = new SetCache(values$1);
				}
				outer: while (++index < length$1) {
					var value = array[index], computed$1 = iteratee$1 == null ? value : iteratee$1(value);
					value = comparator || value !== 0 ? value : 0;
					if (isCommon && computed$1 === computed$1) {
						var valuesIndex = valuesLength;
						while (valuesIndex--) if (values$1[valuesIndex] === computed$1) continue outer;
						result$1.push(value);
					} else if (!includes$1(values$1, computed$1, comparator)) result$1.push(value);
				}
				return result$1;
			}
			var baseEach = createBaseEach(baseForOwn);
			var baseEachRight = createBaseEach(baseForOwnRight, true);
			function baseEvery(collection, predicate) {
				var result$1 = true;
				baseEach(collection, function(value, index, collection$1) {
					result$1 = !!predicate(value, index, collection$1);
					return result$1;
				});
				return result$1;
			}
			function baseExtremum(array, iteratee$1, comparator) {
				var index = -1, length$1 = array.length;
				while (++index < length$1) {
					var value = array[index], current = iteratee$1(value);
					if (current != null && (computed$1 === undefined$1 ? current === current && !isSymbol(current) : comparator(current, computed$1))) var computed$1 = current, result$1 = value;
				}
				return result$1;
			}
			function baseFill(array, value, start$1, end$1) {
				var length$1 = array.length;
				start$1 = toInteger(start$1);
				if (start$1 < 0) start$1 = -start$1 > length$1 ? 0 : length$1 + start$1;
				end$1 = end$1 === undefined$1 || end$1 > length$1 ? length$1 : toInteger(end$1);
				if (end$1 < 0) end$1 += length$1;
				end$1 = start$1 > end$1 ? 0 : toLength(end$1);
				while (start$1 < end$1) array[start$1++] = value;
				return array;
			}
			function baseFilter(collection, predicate) {
				var result$1 = [];
				baseEach(collection, function(value, index, collection$1) {
					if (predicate(value, index, collection$1)) result$1.push(value);
				});
				return result$1;
			}
			function baseFlatten(array, depth, predicate, isStrict, result$1) {
				var index = -1, length$1 = array.length;
				predicate || (predicate = isFlattenable);
				result$1 || (result$1 = []);
				while (++index < length$1) {
					var value = array[index];
					if (depth > 0 && predicate(value)) if (depth > 1) baseFlatten(value, depth - 1, predicate, isStrict, result$1);
					else arrayPush(result$1, value);
					else if (!isStrict) result$1[result$1.length] = value;
				}
				return result$1;
			}
			var baseFor = createBaseFor();
			var baseForRight = createBaseFor(true);
			function baseForOwn(object, iteratee$1) {
				return object && baseFor(object, iteratee$1, keys$1);
			}
			function baseForOwnRight(object, iteratee$1) {
				return object && baseForRight(object, iteratee$1, keys$1);
			}
			function baseFunctions(object, props) {
				return arrayFilter(props, function(key) {
					return isFunction(object[key]);
				});
			}
			function baseGet(object, path) {
				path = castPath(path, object);
				var index = 0, length$1 = path.length;
				while (object != null && index < length$1) object = object[toKey(path[index++])];
				return index && index == length$1 ? object : undefined$1;
			}
			function baseGetAllKeys(object, keysFunc, symbolsFunc) {
				var result$1 = keysFunc(object);
				return isArray$2(object) ? result$1 : arrayPush(result$1, symbolsFunc(object));
			}
			function baseGetTag(value) {
				if (value == null) return value === undefined$1 ? undefinedTag : nullTag;
				return symToStringTag && symToStringTag in Object$1(value) ? getRawTag(value) : objectToString(value);
			}
			function baseGt(value, other) {
				return value > other;
			}
			function baseHas(object, key) {
				return object != null && hasOwnProperty$2.call(object, key);
			}
			function baseHasIn(object, key) {
				return object != null && key in Object$1(object);
			}
			function baseInRange(number, start$1, end$1) {
				return number >= nativeMin(start$1, end$1) && number < nativeMax(start$1, end$1);
			}
			function baseIntersection(arrays, iteratee$1, comparator) {
				var includes$1 = comparator ? arrayIncludesWith : arrayIncludes, length$1 = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array$1(othLength), maxLength = Infinity, result$1 = [];
				while (othIndex--) {
					var array = arrays[othIndex];
					if (othIndex && iteratee$1) array = arrayMap(array, baseUnary(iteratee$1));
					maxLength = nativeMin(array.length, maxLength);
					caches[othIndex] = !comparator && (iteratee$1 || length$1 >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
				}
				array = arrays[0];
				var index = -1, seen = caches[0];
				outer: while (++index < length$1 && result$1.length < maxLength) {
					var value = array[index], computed$1 = iteratee$1 ? iteratee$1(value) : value;
					value = comparator || value !== 0 ? value : 0;
					if (!(seen ? cacheHas(seen, computed$1) : includes$1(result$1, computed$1, comparator))) {
						othIndex = othLength;
						while (--othIndex) {
							var cache$2 = caches[othIndex];
							if (!(cache$2 ? cacheHas(cache$2, computed$1) : includes$1(arrays[othIndex], computed$1, comparator))) continue outer;
						}
						if (seen) seen.push(computed$1);
						result$1.push(value);
					}
				}
				return result$1;
			}
			function baseInverter(object, setter, iteratee$1, accumulator) {
				baseForOwn(object, function(value, key, object$1) {
					setter(accumulator, iteratee$1(value), key, object$1);
				});
				return accumulator;
			}
			function baseInvoke(object, path, args$1) {
				path = castPath(path, object);
				object = parent(object, path);
				var func = object == null ? object : object[toKey(last(path))];
				return func == null ? undefined$1 : apply(func, object, args$1);
			}
			function baseIsArguments(value) {
				return isObjectLike(value) && baseGetTag(value) == argsTag;
			}
			function baseIsArrayBuffer(value) {
				return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
			}
			function baseIsDate(value) {
				return isObjectLike(value) && baseGetTag(value) == dateTag;
			}
			function baseIsEqual(value, other, bitmask, customizer, stack) {
				if (value === other) return true;
				if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
				return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
			}
			function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
				var objIsArr = isArray$2(object), othIsArr = isArray$2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
				objTag = objTag == argsTag ? objectTag : objTag;
				othTag = othTag == argsTag ? objectTag : othTag;
				var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
				if (isSameTag && isBuffer(object)) {
					if (!isBuffer(other)) return false;
					objIsArr = true;
					objIsObj = false;
				}
				if (isSameTag && !objIsObj) {
					stack || (stack = new Stack());
					return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
				}
				if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
					var objIsWrapped = objIsObj && hasOwnProperty$2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$2.call(other, "__wrapped__");
					if (objIsWrapped || othIsWrapped) {
						var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
						stack || (stack = new Stack());
						return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
					}
				}
				if (!isSameTag) return false;
				stack || (stack = new Stack());
				return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
			}
			function baseIsMap(value) {
				return isObjectLike(value) && getTag(value) == mapTag;
			}
			function baseIsMatch(object, source, matchData, customizer) {
				var index = matchData.length, length$1 = index, noCustomizer = !customizer;
				if (object == null) return !length$1;
				object = Object$1(object);
				while (index--) {
					var data = matchData[index];
					if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
				}
				while (++index < length$1) {
					data = matchData[index];
					var key = data[0], objValue = object[key], srcValue = data[1];
					if (noCustomizer && data[2]) {
						if (objValue === undefined$1 && !(key in object)) return false;
					} else {
						var stack = new Stack();
						if (customizer) var result$1 = customizer(objValue, srcValue, key, object, source, stack);
						if (!(result$1 === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result$1)) return false;
					}
				}
				return true;
			}
			function baseIsNative(value) {
				if (!isObject$3(value) || isMasked(value)) return false;
				return (isFunction(value) ? reIsNative : reIsHostCtor).test(toSource(value));
			}
			function baseIsRegExp(value) {
				return isObjectLike(value) && baseGetTag(value) == regexpTag;
			}
			function baseIsSet(value) {
				return isObjectLike(value) && getTag(value) == setTag;
			}
			function baseIsTypedArray(value) {
				return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
			}
			function baseIteratee(value) {
				if (typeof value == "function") return value;
				if (value == null) return identity;
				if (typeof value == "object") return isArray$2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
				return property(value);
			}
			function baseKeys(object) {
				if (!isPrototype(object)) return nativeKeys(object);
				var result$1 = [];
				for (var key in Object$1(object)) if (hasOwnProperty$2.call(object, key) && key != "constructor") result$1.push(key);
				return result$1;
			}
			function baseKeysIn(object) {
				if (!isObject$3(object)) return nativeKeysIn(object);
				var isProto = isPrototype(object), result$1 = [];
				for (var key in object) if (!(key == "constructor" && (isProto || !hasOwnProperty$2.call(object, key)))) result$1.push(key);
				return result$1;
			}
			function baseLt(value, other) {
				return value < other;
			}
			function baseMap(collection, iteratee$1) {
				var index = -1, result$1 = isArrayLike(collection) ? Array$1(collection.length) : [];
				baseEach(collection, function(value, key, collection$1) {
					result$1[++index] = iteratee$1(value, key, collection$1);
				});
				return result$1;
			}
			function baseMatches(source) {
				var matchData = getMatchData(source);
				if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
				return function(object) {
					return object === source || baseIsMatch(object, source, matchData);
				};
			}
			function baseMatchesProperty(path, srcValue) {
				if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
				return function(object) {
					var objValue = get(object, path);
					return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
				};
			}
			function baseMerge(object, source, srcIndex, customizer, stack) {
				if (object === source) return;
				baseFor(source, function(srcValue, key) {
					stack || (stack = new Stack());
					if (isObject$3(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
					else {
						var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined$1;
						if (newValue === undefined$1) newValue = srcValue;
						assignMergeValue(object, key, newValue);
					}
				}, keysIn);
			}
			function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
				var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
				if (stacked) {
					assignMergeValue(object, key, stacked);
					return;
				}
				var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined$1;
				var isCommon = newValue === undefined$1;
				if (isCommon) {
					var isArr = isArray$2(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
					newValue = srcValue;
					if (isArr || isBuff || isTyped) if (isArray$2(objValue)) newValue = objValue;
					else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
					else if (isBuff) {
						isCommon = false;
						newValue = cloneBuffer(srcValue, true);
					} else if (isTyped) {
						isCommon = false;
						newValue = cloneTypedArray(srcValue, true);
					} else newValue = [];
					else if (isPlainObject$3(srcValue) || isArguments(srcValue)) {
						newValue = objValue;
						if (isArguments(objValue)) newValue = toPlainObject(objValue);
						else if (!isObject$3(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
					} else isCommon = false;
				}
				if (isCommon) {
					stack.set(srcValue, newValue);
					mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
					stack["delete"](srcValue);
				}
				assignMergeValue(object, key, newValue);
			}
			function baseNth(array, n) {
				var length$1 = array.length;
				if (!length$1) return;
				n += n < 0 ? length$1 : 0;
				return isIndex(n, length$1) ? array[n] : undefined$1;
			}
			function baseOrderBy(collection, iteratees, orders) {
				if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee$1) {
					if (isArray$2(iteratee$1)) return function(value) {
						return baseGet(value, iteratee$1.length === 1 ? iteratee$1[0] : iteratee$1);
					};
					return iteratee$1;
				});
				else iteratees = [identity];
				var index = -1;
				iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
				return baseSortBy(baseMap(collection, function(value, key, collection$1) {
					var criteria = arrayMap(iteratees, function(iteratee$1) {
						return iteratee$1(value);
					});
					return {
						"criteria": criteria,
						"index": ++index,
						"value": value
					};
				}), function(object, other) {
					return compareMultiple(object, other, orders);
				});
			}
			function basePick(object, paths) {
				return basePickBy(object, paths, function(value, path) {
					return hasIn(object, path);
				});
			}
			function basePickBy(object, paths, predicate) {
				var index = -1, length$1 = paths.length, result$1 = {};
				while (++index < length$1) {
					var path = paths[index], value = baseGet(object, path);
					if (predicate(value, path)) baseSet(result$1, castPath(path, object), value);
				}
				return result$1;
			}
			function basePropertyDeep(path) {
				return function(object) {
					return baseGet(object, path);
				};
			}
			function basePullAll(array, values$1, iteratee$1, comparator) {
				var indexOf$1 = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length$1 = values$1.length, seen = array;
				if (array === values$1) values$1 = copyArray(values$1);
				if (iteratee$1) seen = arrayMap(array, baseUnary(iteratee$1));
				while (++index < length$1) {
					var fromIndex = 0, value = values$1[index], computed$1 = iteratee$1 ? iteratee$1(value) : value;
					while ((fromIndex = indexOf$1(seen, computed$1, fromIndex, comparator)) > -1) {
						if (seen !== array) splice.call(seen, fromIndex, 1);
						splice.call(array, fromIndex, 1);
					}
				}
				return array;
			}
			function basePullAt(array, indexes) {
				var length$1 = array ? indexes.length : 0, lastIndex = length$1 - 1;
				while (length$1--) {
					var index = indexes[length$1];
					if (length$1 == lastIndex || index !== previous) {
						var previous = index;
						if (isIndex(index)) splice.call(array, index, 1);
						else baseUnset(array, index);
					}
				}
				return array;
			}
			function baseRandom(lower, upper) {
				return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
			}
			function baseRange(start$1, end$1, step, fromRight) {
				var index = -1, length$1 = nativeMax(nativeCeil((end$1 - start$1) / (step || 1)), 0), result$1 = Array$1(length$1);
				while (length$1--) {
					result$1[fromRight ? length$1 : ++index] = start$1;
					start$1 += step;
				}
				return result$1;
			}
			function baseRepeat(string, n) {
				var result$1 = "";
				if (!string || n < 1 || n > MAX_SAFE_INTEGER$1) return result$1;
				do {
					if (n % 2) result$1 += string;
					n = nativeFloor(n / 2);
					if (n) string += string;
				} while (n);
				return result$1;
			}
			function baseRest(func, start$1) {
				return setToString(overRest(func, start$1, identity), func + "");
			}
			function baseSample(collection) {
				return arraySample(values(collection));
			}
			function baseSampleSize(collection, n) {
				var array = values(collection);
				return shuffleSelf(array, baseClamp(n, 0, array.length));
			}
			function baseSet(object, path, value, customizer) {
				if (!isObject$3(object)) return object;
				path = castPath(path, object);
				var index = -1, length$1 = path.length, lastIndex = length$1 - 1, nested = object;
				while (nested != null && ++index < length$1) {
					var key = toKey(path[index]), newValue = value;
					if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
					if (index != lastIndex) {
						var objValue = nested[key];
						newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
						if (newValue === undefined$1) newValue = isObject$3(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
					}
					assignValue(nested, key, newValue);
					nested = nested[key];
				}
				return object;
			}
			var baseSetData = !metaMap ? identity : function(func, data) {
				metaMap.set(func, data);
				return func;
			};
			var baseSetToString = !defineProperty ? identity : function(func, string) {
				return defineProperty(func, "toString", {
					"configurable": true,
					"enumerable": false,
					"value": constant(string),
					"writable": true
				});
			};
			function baseShuffle(collection) {
				return shuffleSelf(values(collection));
			}
			function baseSlice(array, start$1, end$1) {
				var index = -1, length$1 = array.length;
				if (start$1 < 0) start$1 = -start$1 > length$1 ? 0 : length$1 + start$1;
				end$1 = end$1 > length$1 ? length$1 : end$1;
				if (end$1 < 0) end$1 += length$1;
				length$1 = start$1 > end$1 ? 0 : end$1 - start$1 >>> 0;
				start$1 >>>= 0;
				var result$1 = Array$1(length$1);
				while (++index < length$1) result$1[index] = array[index + start$1];
				return result$1;
			}
			function baseSome(collection, predicate) {
				var result$1;
				baseEach(collection, function(value, index, collection$1) {
					result$1 = predicate(value, index, collection$1);
					return !result$1;
				});
				return !!result$1;
			}
			function baseSortedIndex(array, value, retHighest) {
				var low = 0, high = array == null ? low : array.length;
				if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
					while (low < high) {
						var mid = low + high >>> 1, computed$1 = array[mid];
						if (computed$1 !== null && !isSymbol(computed$1) && (retHighest ? computed$1 <= value : computed$1 < value)) low = mid + 1;
						else high = mid;
					}
					return high;
				}
				return baseSortedIndexBy(array, value, identity, retHighest);
			}
			function baseSortedIndexBy(array, value, iteratee$1, retHighest) {
				var low = 0, high = array == null ? 0 : array.length;
				if (high === 0) return 0;
				value = iteratee$1(value);
				var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined$1;
				while (low < high) {
					var mid = nativeFloor((low + high) / 2), computed$1 = iteratee$1(array[mid]), othIsDefined = computed$1 !== undefined$1, othIsNull = computed$1 === null, othIsReflexive = computed$1 === computed$1, othIsSymbol = isSymbol(computed$1);
					if (valIsNaN) var setLow = retHighest || othIsReflexive;
					else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
					else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
					else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
					else if (othIsNull || othIsSymbol) setLow = false;
					else setLow = retHighest ? computed$1 <= value : computed$1 < value;
					if (setLow) low = mid + 1;
					else high = mid;
				}
				return nativeMin(high, MAX_ARRAY_INDEX);
			}
			function baseSortedUniq(array, iteratee$1) {
				var index = -1, length$1 = array.length, resIndex = 0, result$1 = [];
				while (++index < length$1) {
					var value = array[index], computed$1 = iteratee$1 ? iteratee$1(value) : value;
					if (!index || !eq(computed$1, seen)) {
						var seen = computed$1;
						result$1[resIndex++] = value === 0 ? 0 : value;
					}
				}
				return result$1;
			}
			function baseToNumber(value) {
				if (typeof value == "number") return value;
				if (isSymbol(value)) return NAN;
				return +value;
			}
			function baseToString(value) {
				if (typeof value == "string") return value;
				if (isArray$2(value)) return arrayMap(value, baseToString) + "";
				if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
				var result$1 = value + "";
				return result$1 == "0" && 1 / value == -INFINITY ? "-0" : result$1;
			}
			function baseUniq(array, iteratee$1, comparator) {
				var index = -1, includes$1 = arrayIncludes, length$1 = array.length, isCommon = true, result$1 = [], seen = result$1;
				if (comparator) {
					isCommon = false;
					includes$1 = arrayIncludesWith;
				} else if (length$1 >= LARGE_ARRAY_SIZE) {
					var set$1 = iteratee$1 ? null : createSet(array);
					if (set$1) return setToArray(set$1);
					isCommon = false;
					includes$1 = cacheHas;
					seen = new SetCache();
				} else seen = iteratee$1 ? [] : result$1;
				outer: while (++index < length$1) {
					var value = array[index], computed$1 = iteratee$1 ? iteratee$1(value) : value;
					value = comparator || value !== 0 ? value : 0;
					if (isCommon && computed$1 === computed$1) {
						var seenIndex = seen.length;
						while (seenIndex--) if (seen[seenIndex] === computed$1) continue outer;
						if (iteratee$1) seen.push(computed$1);
						result$1.push(value);
					} else if (!includes$1(seen, computed$1, comparator)) {
						if (seen !== result$1) seen.push(computed$1);
						result$1.push(value);
					}
				}
				return result$1;
			}
			function baseUnset(object, path) {
				path = castPath(path, object);
				var index = -1, length$1 = path.length;
				if (!length$1) return true;
				var isRootPrimitive = object == null || typeof object !== "object" && typeof object !== "function";
				while (++index < length$1) {
					var key = path[index];
					if (typeof key !== "string") continue;
					if (key === "__proto__" && !hasOwnProperty$2.call(object, "__proto__")) return false;
					if (key === "constructor" && index + 1 < length$1 && typeof path[index + 1] === "string" && path[index + 1] === "prototype") {
						if (isRootPrimitive && index === 0) continue;
						return false;
					}
				}
				var obj = parent(object, path);
				return obj == null || delete obj[toKey(last(path))];
			}
			function baseUpdate(object, path, updater, customizer) {
				return baseSet(object, path, updater(baseGet(object, path)), customizer);
			}
			function baseWhile(array, predicate, isDrop, fromRight) {
				var length$1 = array.length, index = fromRight ? length$1 : -1;
				while ((fromRight ? index-- : ++index < length$1) && predicate(array[index], index, array));
				return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length$1) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length$1 : index);
			}
			function baseWrapperValue(value, actions) {
				var result$1 = value;
				if (result$1 instanceof LazyWrapper) result$1 = result$1.value();
				return arrayReduce(actions, function(result$2, action) {
					return action.func.apply(action.thisArg, arrayPush([result$2], action.args));
				}, result$1);
			}
			function baseXor(arrays, iteratee$1, comparator) {
				var length$1 = arrays.length;
				if (length$1 < 2) return length$1 ? baseUniq(arrays[0]) : [];
				var index = -1, result$1 = Array$1(length$1);
				while (++index < length$1) {
					var array = arrays[index], othIndex = -1;
					while (++othIndex < length$1) if (othIndex != index) result$1[index] = baseDifference(result$1[index] || array, arrays[othIndex], iteratee$1, comparator);
				}
				return baseUniq(baseFlatten(result$1, 1), iteratee$1, comparator);
			}
			function baseZipObject(props, values$1, assignFunc) {
				var index = -1, length$1 = props.length, valsLength = values$1.length, result$1 = {};
				while (++index < length$1) {
					var value = index < valsLength ? values$1[index] : undefined$1;
					assignFunc(result$1, props[index], value);
				}
				return result$1;
			}
			function castArrayLikeObject(value) {
				return isArrayLikeObject(value) ? value : [];
			}
			function castFunction(value) {
				return typeof value == "function" ? value : identity;
			}
			function castPath(value, object) {
				if (isArray$2(value)) return value;
				return isKey(value, object) ? [value] : stringToPath(toString(value));
			}
			var castRest = baseRest;
			function castSlice(array, start$1, end$1) {
				var length$1 = array.length;
				end$1 = end$1 === undefined$1 ? length$1 : end$1;
				return !start$1 && end$1 >= length$1 ? array : baseSlice(array, start$1, end$1);
			}
			var clearTimeout$1 = ctxClearTimeout || function(id) {
				return root.clearTimeout(id);
			};
			function cloneBuffer(buffer, isDeep) {
				if (isDeep) return buffer.slice();
				var length$1 = buffer.length, result$1 = allocUnsafe ? allocUnsafe(length$1) : new buffer.constructor(length$1);
				buffer.copy(result$1);
				return result$1;
			}
			function cloneArrayBuffer(arrayBuffer) {
				var result$1 = new arrayBuffer.constructor(arrayBuffer.byteLength);
				new Uint8Array$1(result$1).set(new Uint8Array$1(arrayBuffer));
				return result$1;
			}
			function cloneDataView(dataView, isDeep) {
				var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
				return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
			}
			function cloneRegExp(regexp) {
				var result$1 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
				result$1.lastIndex = regexp.lastIndex;
				return result$1;
			}
			function cloneSymbol(symbol) {
				return symbolValueOf ? Object$1(symbolValueOf.call(symbol)) : {};
			}
			function cloneTypedArray(typedArray, isDeep) {
				var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
				return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
			}
			function compareAscending(value, other) {
				if (value !== other) {
					var valIsDefined = value !== undefined$1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
					var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
					if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
					if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
				}
				return 0;
			}
			function compareMultiple(object, other, orders) {
				var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length$1 = objCriteria.length, ordersLength = orders.length;
				while (++index < length$1) {
					var result$1 = compareAscending(objCriteria[index], othCriteria[index]);
					if (result$1) {
						if (index >= ordersLength) return result$1;
						return result$1 * (orders[index] == "desc" ? -1 : 1);
					}
				}
				return object.index - other.index;
			}
			function composeArgs(args$1, partials, holders, isCurried) {
				var argsIndex = -1, argsLength = args$1.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result$1 = Array$1(leftLength + rangeLength), isUncurried = !isCurried;
				while (++leftIndex < leftLength) result$1[leftIndex] = partials[leftIndex];
				while (++argsIndex < holdersLength) if (isUncurried || argsIndex < argsLength) result$1[holders[argsIndex]] = args$1[argsIndex];
				while (rangeLength--) result$1[leftIndex++] = args$1[argsIndex++];
				return result$1;
			}
			function composeArgsRight(args$1, partials, holders, isCurried) {
				var argsIndex = -1, argsLength = args$1.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result$1 = Array$1(rangeLength + rightLength), isUncurried = !isCurried;
				while (++argsIndex < rangeLength) result$1[argsIndex] = args$1[argsIndex];
				var offset$1 = argsIndex;
				while (++rightIndex < rightLength) result$1[offset$1 + rightIndex] = partials[rightIndex];
				while (++holdersIndex < holdersLength) if (isUncurried || argsIndex < argsLength) result$1[offset$1 + holders[holdersIndex]] = args$1[argsIndex++];
				return result$1;
			}
			function copyArray(source, array) {
				var index = -1, length$1 = source.length;
				array || (array = Array$1(length$1));
				while (++index < length$1) array[index] = source[index];
				return array;
			}
			function copyObject(source, props, object, customizer) {
				var isNew = !object;
				object || (object = {});
				var index = -1, length$1 = props.length;
				while (++index < length$1) {
					var key = props[index];
					var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$1;
					if (newValue === undefined$1) newValue = source[key];
					if (isNew) baseAssignValue(object, key, newValue);
					else assignValue(object, key, newValue);
				}
				return object;
			}
			function copySymbols(source, object) {
				return copyObject(source, getSymbols(source), object);
			}
			function copySymbolsIn(source, object) {
				return copyObject(source, getSymbolsIn(source), object);
			}
			function createAggregator(setter, initializer) {
				return function(collection, iteratee$1) {
					var func = isArray$2(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
					return func(collection, setter, getIteratee(iteratee$1, 2), accumulator);
				};
			}
			function createAssigner(assigner) {
				return baseRest(function(object, sources) {
					var index = -1, length$1 = sources.length, customizer = length$1 > 1 ? sources[length$1 - 1] : undefined$1, guard$1 = length$1 > 2 ? sources[2] : undefined$1;
					customizer = assigner.length > 3 && typeof customizer == "function" ? (length$1--, customizer) : undefined$1;
					if (guard$1 && isIterateeCall(sources[0], sources[1], guard$1)) {
						customizer = length$1 < 3 ? undefined$1 : customizer;
						length$1 = 1;
					}
					object = Object$1(object);
					while (++index < length$1) {
						var source = sources[index];
						if (source) assigner(object, source, index, customizer);
					}
					return object;
				});
			}
			function createBaseEach(eachFunc, fromRight) {
				return function(collection, iteratee$1) {
					if (collection == null) return collection;
					if (!isArrayLike(collection)) return eachFunc(collection, iteratee$1);
					var length$1 = collection.length, index = fromRight ? length$1 : -1, iterable = Object$1(collection);
					while (fromRight ? index-- : ++index < length$1) if (iteratee$1(iterable[index], index, iterable) === false) break;
					return collection;
				};
			}
			function createBaseFor(fromRight) {
				return function(object, iteratee$1, keysFunc) {
					var index = -1, iterable = Object$1(object), props = keysFunc(object), length$1 = props.length;
					while (length$1--) {
						var key = props[fromRight ? length$1 : ++index];
						if (iteratee$1(iterable[key], key, iterable) === false) break;
					}
					return object;
				};
			}
			function createBind(func, bitmask, thisArg) {
				var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
				function wrapper() {
					return (this && this !== root && this instanceof wrapper ? Ctor : func).apply(isBind ? thisArg : this, arguments);
				}
				return wrapper;
			}
			function createCaseFirst(methodName) {
				return function(string) {
					string = toString(string);
					var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$1;
					var chr = strSymbols ? strSymbols[0] : string.charAt(0);
					var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
					return chr[methodName]() + trailing;
				};
			}
			function createCompounder(callback) {
				return function(string) {
					return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
				};
			}
			function createCtor(Ctor) {
				return function() {
					var args$1 = arguments;
					switch (args$1.length) {
						case 0: return new Ctor();
						case 1: return new Ctor(args$1[0]);
						case 2: return new Ctor(args$1[0], args$1[1]);
						case 3: return new Ctor(args$1[0], args$1[1], args$1[2]);
						case 4: return new Ctor(args$1[0], args$1[1], args$1[2], args$1[3]);
						case 5: return new Ctor(args$1[0], args$1[1], args$1[2], args$1[3], args$1[4]);
						case 6: return new Ctor(args$1[0], args$1[1], args$1[2], args$1[3], args$1[4], args$1[5]);
						case 7: return new Ctor(args$1[0], args$1[1], args$1[2], args$1[3], args$1[4], args$1[5], args$1[6]);
					}
					var thisBinding = baseCreate(Ctor.prototype), result$1 = Ctor.apply(thisBinding, args$1);
					return isObject$3(result$1) ? result$1 : thisBinding;
				};
			}
			function createCurry(func, bitmask, arity) {
				var Ctor = createCtor(func);
				function wrapper() {
					var length$1 = arguments.length, args$1 = Array$1(length$1), index = length$1, placeholder = getHolder(wrapper);
					while (index--) args$1[index] = arguments[index];
					var holders = length$1 < 3 && args$1[0] !== placeholder && args$1[length$1 - 1] !== placeholder ? [] : replaceHolders(args$1, placeholder);
					length$1 -= holders.length;
					if (length$1 < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined$1, args$1, holders, undefined$1, undefined$1, arity - length$1);
					return apply(this && this !== root && this instanceof wrapper ? Ctor : func, this, args$1);
				}
				return wrapper;
			}
			function createFind(findIndexFunc) {
				return function(collection, predicate, fromIndex) {
					var iterable = Object$1(collection);
					if (!isArrayLike(collection)) {
						var iteratee$1 = getIteratee(predicate, 3);
						collection = keys$1(collection);
						predicate = function(key) {
							return iteratee$1(iterable[key], key, iterable);
						};
					}
					var index = findIndexFunc(collection, predicate, fromIndex);
					return index > -1 ? iterable[iteratee$1 ? collection[index] : index] : undefined$1;
				};
			}
			function createFlow(fromRight) {
				return flatRest(function(funcs) {
					var length$1 = funcs.length, index = length$1, prereq = LodashWrapper.prototype.thru;
					if (fromRight) funcs.reverse();
					while (index--) {
						var func = funcs[index];
						if (typeof func != "function") throw new TypeError$1(FUNC_ERROR_TEXT);
						if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
					}
					index = wrapper ? index : length$1;
					while (++index < length$1) {
						func = funcs[index];
						var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined$1;
						if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
						else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
					}
					return function() {
						var args$1 = arguments, value = args$1[0];
						if (wrapper && args$1.length == 1 && isArray$2(value)) return wrapper.plant(value).value();
						var index$1 = 0, result$1 = length$1 ? funcs[index$1].apply(this, args$1) : value;
						while (++index$1 < length$1) result$1 = funcs[index$1].call(this, result$1);
						return result$1;
					};
				});
			}
			function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary$1, arity) {
				var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
				function wrapper() {
					var length$1 = arguments.length, args$1 = Array$1(length$1), index = length$1;
					while (index--) args$1[index] = arguments[index];
					if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args$1, placeholder);
					if (partials) args$1 = composeArgs(args$1, partials, holders, isCurried);
					if (partialsRight) args$1 = composeArgsRight(args$1, partialsRight, holdersRight, isCurried);
					length$1 -= holdersCount;
					if (isCurried && length$1 < arity) {
						var newHolders = replaceHolders(args$1, placeholder);
						return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args$1, newHolders, argPos, ary$1, arity - length$1);
					}
					var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
					length$1 = args$1.length;
					if (argPos) args$1 = reorder(args$1, argPos);
					else if (isFlip && length$1 > 1) args$1.reverse();
					if (isAry && ary$1 < length$1) args$1.length = ary$1;
					if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
					return fn.apply(thisBinding, args$1);
				}
				return wrapper;
			}
			function createInverter(setter, toIteratee) {
				return function(object, iteratee$1) {
					return baseInverter(object, setter, toIteratee(iteratee$1), {});
				};
			}
			function createMathOperation(operator, defaultValue) {
				return function(value, other) {
					var result$1;
					if (value === undefined$1 && other === undefined$1) return defaultValue;
					if (value !== undefined$1) result$1 = value;
					if (other !== undefined$1) {
						if (result$1 === undefined$1) return other;
						if (typeof value == "string" || typeof other == "string") {
							value = baseToString(value);
							other = baseToString(other);
						} else {
							value = baseToNumber(value);
							other = baseToNumber(other);
						}
						result$1 = operator(value, other);
					}
					return result$1;
				};
			}
			function createOver(arrayFunc) {
				return flatRest(function(iteratees) {
					iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
					return baseRest(function(args$1) {
						var thisArg = this;
						return arrayFunc(iteratees, function(iteratee$1) {
							return apply(iteratee$1, thisArg, args$1);
						});
					});
				});
			}
			function createPadding(length$1, chars) {
				chars = chars === undefined$1 ? " " : baseToString(chars);
				var charsLength = chars.length;
				if (charsLength < 2) return charsLength ? baseRepeat(chars, length$1) : chars;
				var result$1 = baseRepeat(chars, nativeCeil(length$1 / stringSize(chars)));
				return hasUnicode(chars) ? castSlice(stringToArray(result$1), 0, length$1).join("") : result$1.slice(0, length$1);
			}
			function createPartial(func, bitmask, thisArg, partials) {
				var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
				function wrapper() {
					var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args$1 = Array$1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
					while (++leftIndex < leftLength) args$1[leftIndex] = partials[leftIndex];
					while (argsLength--) args$1[leftIndex++] = arguments[++argsIndex];
					return apply(fn, isBind ? thisArg : this, args$1);
				}
				return wrapper;
			}
			function createRange(fromRight) {
				return function(start$1, end$1, step) {
					if (step && typeof step != "number" && isIterateeCall(start$1, end$1, step)) end$1 = step = undefined$1;
					start$1 = toFinite(start$1);
					if (end$1 === undefined$1) {
						end$1 = start$1;
						start$1 = 0;
					} else end$1 = toFinite(end$1);
					step = step === undefined$1 ? start$1 < end$1 ? 1 : -1 : toFinite(step);
					return baseRange(start$1, end$1, step, fromRight);
				};
			}
			function createRelationalOperation(operator) {
				return function(value, other) {
					if (!(typeof value == "string" && typeof other == "string")) {
						value = toNumber(value);
						other = toNumber(other);
					}
					return operator(value, other);
				};
			}
			function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary$1, arity) {
				var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
				bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
				bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
				if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
				var newData = [
					func,
					bitmask,
					thisArg,
					newPartials,
					newHolders,
					newPartialsRight,
					newHoldersRight,
					argPos,
					ary$1,
					arity
				];
				var result$1 = wrapFunc.apply(undefined$1, newData);
				if (isLaziable(func)) setData(result$1, newData);
				result$1.placeholder = placeholder;
				return setWrapToString(result$1, func, bitmask);
			}
			function createRound(methodName) {
				var func = Math$1[methodName];
				return function(number, precision) {
					number = toNumber(number);
					precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
					if (precision && nativeIsFinite(number)) {
						var pair = (toString(number) + "e").split("e");
						pair = (toString(func(pair[0] + "e" + (+pair[1] + precision))) + "e").split("e");
						return +(pair[0] + "e" + (+pair[1] - precision));
					}
					return func(number);
				};
			}
			var createSet = !(Set$1 && 1 / setToArray(new Set$1([, -0]))[1] == INFINITY) ? noop : function(values$1) {
				return new Set$1(values$1);
			};
			function createToPairs(keysFunc) {
				return function(object) {
					var tag = getTag(object);
					if (tag == mapTag) return mapToArray(object);
					if (tag == setTag) return setToPairs(object);
					return baseToPairs(object, keysFunc(object));
				};
			}
			function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary$1, arity) {
				var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
				if (!isBindKey && typeof func != "function") throw new TypeError$1(FUNC_ERROR_TEXT);
				var length$1 = partials ? partials.length : 0;
				if (!length$1) {
					bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
					partials = holders = undefined$1;
				}
				ary$1 = ary$1 === undefined$1 ? ary$1 : nativeMax(toInteger(ary$1), 0);
				arity = arity === undefined$1 ? arity : toInteger(arity);
				length$1 -= holders ? holders.length : 0;
				if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
					var partialsRight = partials, holdersRight = holders;
					partials = holders = undefined$1;
				}
				var data = isBindKey ? undefined$1 : getData(func);
				var newData = [
					func,
					bitmask,
					thisArg,
					partials,
					holders,
					partialsRight,
					holdersRight,
					argPos,
					ary$1,
					arity
				];
				if (data) mergeData(newData, data);
				func = newData[0];
				bitmask = newData[1];
				thisArg = newData[2];
				partials = newData[3];
				holders = newData[4];
				arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length$1, 0);
				if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
				if (!bitmask || bitmask == WRAP_BIND_FLAG) var result$1 = createBind(func, bitmask, thisArg);
				else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result$1 = createCurry(func, bitmask, arity);
				else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result$1 = createPartial(func, bitmask, thisArg, partials);
				else result$1 = createHybrid.apply(undefined$1, newData);
				return setWrapToString((data ? baseSetData : setData)(result$1, newData), func, bitmask);
			}
			function customDefaultsAssignIn(objValue, srcValue, key, object) {
				if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty$2.call(object, key)) return srcValue;
				return objValue;
			}
			function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
				if (isObject$3(objValue) && isObject$3(srcValue)) {
					stack.set(srcValue, objValue);
					baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
					stack["delete"](srcValue);
				}
				return objValue;
			}
			function customOmitClone(value) {
				return isPlainObject$3(value) ? undefined$1 : value;
			}
			function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
				var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
				if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
				var arrStacked = stack.get(array);
				var othStacked = stack.get(other);
				if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
				var index = -1, result$1 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
				stack.set(array, other);
				stack.set(other, array);
				while (++index < arrLength) {
					var arrValue = array[index], othValue = other[index];
					if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
					if (compared !== undefined$1) {
						if (compared) continue;
						result$1 = false;
						break;
					}
					if (seen) {
						if (!arraySome(other, function(othValue$1, othIndex) {
							if (!cacheHas(seen, othIndex) && (arrValue === othValue$1 || equalFunc(arrValue, othValue$1, bitmask, customizer, stack))) return seen.push(othIndex);
						})) {
							result$1 = false;
							break;
						}
					} else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
						result$1 = false;
						break;
					}
				}
				stack["delete"](array);
				stack["delete"](other);
				return result$1;
			}
			function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
				switch (tag) {
					case dataViewTag:
						if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
						object = object.buffer;
						other = other.buffer;
					case arrayBufferTag:
						if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) return false;
						return true;
					case boolTag:
					case dateTag:
					case numberTag: return eq(+object, +other);
					case errorTag: return object.name == other.name && object.message == other.message;
					case regexpTag:
					case stringTag: return object == other + "";
					case mapTag: var convert = mapToArray;
					case setTag:
						var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
						convert || (convert = setToArray);
						if (object.size != other.size && !isPartial) return false;
						var stacked = stack.get(object);
						if (stacked) return stacked == other;
						bitmask |= COMPARE_UNORDERED_FLAG;
						stack.set(object, other);
						var result$1 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
						stack["delete"](object);
						return result$1;
					case symbolTag: if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
				}
				return false;
			}
			function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
				var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length;
				if (objLength != getAllKeys(other).length && !isPartial) return false;
				var index = objLength;
				while (index--) {
					var key = objProps[index];
					if (!(isPartial ? key in other : hasOwnProperty$2.call(other, key))) return false;
				}
				var objStacked = stack.get(object);
				var othStacked = stack.get(other);
				if (objStacked && othStacked) return objStacked == other && othStacked == object;
				var result$1 = true;
				stack.set(object, other);
				stack.set(other, object);
				var skipCtor = isPartial;
				while (++index < objLength) {
					key = objProps[index];
					var objValue = object[key], othValue = other[key];
					if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
					if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
						result$1 = false;
						break;
					}
					skipCtor || (skipCtor = key == "constructor");
				}
				if (result$1 && !skipCtor) {
					var objCtor = object.constructor, othCtor = other.constructor;
					if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result$1 = false;
				}
				stack["delete"](object);
				stack["delete"](other);
				return result$1;
			}
			function flatRest(func) {
				return setToString(overRest(func, undefined$1, flatten), func + "");
			}
			function getAllKeys(object) {
				return baseGetAllKeys(object, keys$1, getSymbols);
			}
			function getAllKeysIn(object) {
				return baseGetAllKeys(object, keysIn, getSymbolsIn);
			}
			var getData = !metaMap ? noop : function(func) {
				return metaMap.get(func);
			};
			function getFuncName(func) {
				var result$1 = func.name + "", array = realNames[result$1], length$1 = hasOwnProperty$2.call(realNames, result$1) ? array.length : 0;
				while (length$1--) {
					var data = array[length$1], otherFunc = data.func;
					if (otherFunc == null || otherFunc == func) return data.name;
				}
				return result$1;
			}
			function getHolder(func) {
				return (hasOwnProperty$2.call(lodash, "placeholder") ? lodash : func).placeholder;
			}
			function getIteratee() {
				var result$1 = lodash.iteratee || iteratee;
				result$1 = result$1 === iteratee ? baseIteratee : result$1;
				return arguments.length ? result$1(arguments[0], arguments[1]) : result$1;
			}
			function getMapData(map$2, key) {
				var data = map$2.__data__;
				return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
			}
			function getMatchData(object) {
				var result$1 = keys$1(object), length$1 = result$1.length;
				while (length$1--) {
					var key = result$1[length$1], value = object[key];
					result$1[length$1] = [
						key,
						value,
						isStrictComparable(value)
					];
				}
				return result$1;
			}
			function getNative(object, key) {
				var value = getValue(object, key);
				return baseIsNative(value) ? value : undefined$1;
			}
			function getRawTag(value) {
				var isOwn = hasOwnProperty$2.call(value, symToStringTag), tag = value[symToStringTag];
				try {
					value[symToStringTag] = undefined$1;
					var unmasked = true;
				} catch (e) {}
				var result$1 = nativeObjectToString.call(value);
				if (unmasked) if (isOwn) value[symToStringTag] = tag;
				else delete value[symToStringTag];
				return result$1;
			}
			var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
				if (object == null) return [];
				object = Object$1(object);
				return arrayFilter(nativeGetSymbols(object), function(symbol) {
					return propertyIsEnumerable.call(object, symbol);
				});
			};
			var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
				var result$1 = [];
				while (object) {
					arrayPush(result$1, getSymbols(object));
					object = getPrototype(object);
				}
				return result$1;
			};
			var getTag = baseGetTag;
			if (DataView$1 && getTag(new DataView$1(/* @__PURE__ */ new ArrayBuffer(1))) != dataViewTag || Map$2 && getTag(new Map$2()) != mapTag || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag) getTag = function(value) {
				var result$1 = baseGetTag(value), Ctor = result$1 == objectTag ? value.constructor : undefined$1, ctorString = Ctor ? toSource(Ctor) : "";
				if (ctorString) switch (ctorString) {
					case dataViewCtorString: return dataViewTag;
					case mapCtorString: return mapTag;
					case promiseCtorString: return promiseTag;
					case setCtorString: return setTag;
					case weakMapCtorString: return weakMapTag;
				}
				return result$1;
			};
			function getView(start$1, end$1, transforms) {
				var index = -1, length$1 = transforms.length;
				while (++index < length$1) {
					var data = transforms[index], size$2 = data.size;
					switch (data.type) {
						case "drop":
							start$1 += size$2;
							break;
						case "dropRight":
							end$1 -= size$2;
							break;
						case "take":
							end$1 = nativeMin(end$1, start$1 + size$2);
							break;
						case "takeRight":
							start$1 = nativeMax(start$1, end$1 - size$2);
							break;
					}
				}
				return {
					"start": start$1,
					"end": end$1
				};
			}
			function getWrapDetails(source) {
				var match$1 = source.match(reWrapDetails);
				return match$1 ? match$1[1].split(reSplitDetails) : [];
			}
			function hasPath(object, path, hasFunc) {
				path = castPath(path, object);
				var index = -1, length$1 = path.length, result$1 = false;
				while (++index < length$1) {
					var key = toKey(path[index]);
					if (!(result$1 = object != null && hasFunc(object, key))) break;
					object = object[key];
				}
				if (result$1 || ++index != length$1) return result$1;
				length$1 = object == null ? 0 : object.length;
				return !!length$1 && isLength(length$1) && isIndex(key, length$1) && (isArray$2(object) || isArguments(object));
			}
			function initCloneArray(array) {
				var length$1 = array.length, result$1 = new array.constructor(length$1);
				if (length$1 && typeof array[0] == "string" && hasOwnProperty$2.call(array, "index")) {
					result$1.index = array.index;
					result$1.input = array.input;
				}
				return result$1;
			}
			function initCloneObject(object) {
				return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
			}
			function initCloneByTag(object, tag, isDeep) {
				var Ctor = object.constructor;
				switch (tag) {
					case arrayBufferTag: return cloneArrayBuffer(object);
					case boolTag:
					case dateTag: return new Ctor(+object);
					case dataViewTag: return cloneDataView(object, isDeep);
					case float32Tag:
					case float64Tag:
					case int8Tag:
					case int16Tag:
					case int32Tag:
					case uint8Tag:
					case uint8ClampedTag:
					case uint16Tag:
					case uint32Tag: return cloneTypedArray(object, isDeep);
					case mapTag: return new Ctor();
					case numberTag:
					case stringTag: return new Ctor(object);
					case regexpTag: return cloneRegExp(object);
					case setTag: return new Ctor();
					case symbolTag: return cloneSymbol(object);
				}
			}
			function insertWrapDetails(source, details) {
				var length$1 = details.length;
				if (!length$1) return source;
				var lastIndex = length$1 - 1;
				details[lastIndex] = (length$1 > 1 ? "& " : "") + details[lastIndex];
				details = details.join(length$1 > 2 ? ", " : " ");
				return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
			}
			function isFlattenable(value) {
				return isArray$2(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
			}
			function isIndex(value, length$1) {
				var type = typeof value;
				length$1 = length$1 == null ? MAX_SAFE_INTEGER$1 : length$1;
				return !!length$1 && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length$1;
			}
			function isIterateeCall(value, index, object) {
				if (!isObject$3(object)) return false;
				var type = typeof index;
				if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
				return false;
			}
			function isKey(value, object) {
				if (isArray$2(value)) return false;
				var type = typeof value;
				if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
				return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object$1(object);
			}
			function isKeyable(value) {
				var type = typeof value;
				return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
			}
			function isLaziable(func) {
				var funcName = getFuncName(func), other = lodash[funcName];
				if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
				if (func === other) return true;
				var data = getData(other);
				return !!data && func === data[0];
			}
			function isMasked(func) {
				return !!maskSrcKey && maskSrcKey in func;
			}
			var isMaskable = coreJsData ? isFunction : stubFalse;
			function isPrototype(value) {
				var Ctor = value && value.constructor;
				return value === (typeof Ctor == "function" && Ctor.prototype || objectProto);
			}
			function isStrictComparable(value) {
				return value === value && !isObject$3(value);
			}
			function matchesStrictComparable(key, srcValue) {
				return function(object) {
					if (object == null) return false;
					return object[key] === srcValue && (srcValue !== undefined$1 || key in Object$1(object));
				};
			}
			function memoizeCapped(func) {
				var result$1 = memoize(func, function(key) {
					if (cache$2.size === MAX_MEMOIZE_SIZE) cache$2.clear();
					return key;
				});
				var cache$2 = result$1.cache;
				return result$1;
			}
			function mergeData(data, source) {
				var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
				var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
				if (!(isCommon || isCombo)) return data;
				if (srcBitmask & WRAP_BIND_FLAG) {
					data[2] = source[2];
					newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
				}
				var value = source[3];
				if (value) {
					var partials = data[3];
					data[3] = partials ? composeArgs(partials, value, source[4]) : value;
					data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
				}
				value = source[5];
				if (value) {
					partials = data[5];
					data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
					data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
				}
				value = source[7];
				if (value) data[7] = value;
				if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
				if (data[9] == null) data[9] = source[9];
				data[0] = source[0];
				data[1] = newBitmask;
				return data;
			}
			function nativeKeysIn(object) {
				var result$1 = [];
				if (object != null) for (var key in Object$1(object)) result$1.push(key);
				return result$1;
			}
			function objectToString(value) {
				return nativeObjectToString.call(value);
			}
			function overRest(func, start$1, transform$1) {
				start$1 = nativeMax(start$1 === undefined$1 ? func.length - 1 : start$1, 0);
				return function() {
					var args$1 = arguments, index = -1, length$1 = nativeMax(args$1.length - start$1, 0), array = Array$1(length$1);
					while (++index < length$1) array[index] = args$1[start$1 + index];
					index = -1;
					var otherArgs = Array$1(start$1 + 1);
					while (++index < start$1) otherArgs[index] = args$1[index];
					otherArgs[start$1] = transform$1(array);
					return apply(func, this, otherArgs);
				};
			}
			function parent(object, path) {
				return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
			}
			function reorder(array, indexes) {
				var arrLength = array.length, length$1 = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
				while (length$1--) {
					var index = indexes[length$1];
					array[length$1] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
				}
				return array;
			}
			function safeGet(object, key) {
				if (key === "constructor" && typeof object[key] === "function") return;
				if (key == "__proto__") return;
				return object[key];
			}
			var setData = shortOut(baseSetData);
			var setTimeout$1 = ctxSetTimeout || function(func, wait) {
				return root.setTimeout(func, wait);
			};
			var setToString = shortOut(baseSetToString);
			function setWrapToString(wrapper, reference$1, bitmask) {
				var source = reference$1 + "";
				return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
			}
			function shortOut(func) {
				var count = 0, lastCalled = 0;
				return function() {
					var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
					lastCalled = stamp;
					if (remaining > 0) {
						if (++count >= HOT_COUNT) return arguments[0];
					} else count = 0;
					return func.apply(undefined$1, arguments);
				};
			}
			function shuffleSelf(array, size$2) {
				var index = -1, length$1 = array.length, lastIndex = length$1 - 1;
				size$2 = size$2 === undefined$1 ? length$1 : size$2;
				while (++index < size$2) {
					var rand$1 = baseRandom(index, lastIndex), value = array[rand$1];
					array[rand$1] = array[index];
					array[index] = value;
				}
				array.length = size$2;
				return array;
			}
			var stringToPath = memoizeCapped(function(string) {
				var result$1 = [];
				if (string.charCodeAt(0) === 46) result$1.push("");
				string.replace(rePropName, function(match$1, number, quote, subString) {
					result$1.push(quote ? subString.replace(reEscapeChar, "$1") : number || match$1);
				});
				return result$1;
			});
			function toKey(value) {
				if (typeof value == "string" || isSymbol(value)) return value;
				var result$1 = value + "";
				return result$1 == "0" && 1 / value == -INFINITY ? "-0" : result$1;
			}
			function toSource(func) {
				if (func != null) {
					try {
						return funcToString.call(func);
					} catch (e) {}
					try {
						return func + "";
					} catch (e) {}
				}
				return "";
			}
			function updateWrapDetails(details, bitmask) {
				arrayEach(wrapFlags, function(pair) {
					var value = "_." + pair[0];
					if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
				});
				return details.sort();
			}
			function wrapperClone(wrapper) {
				if (wrapper instanceof LazyWrapper) return wrapper.clone();
				var result$1 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
				result$1.__actions__ = copyArray(wrapper.__actions__);
				result$1.__index__ = wrapper.__index__;
				result$1.__values__ = wrapper.__values__;
				return result$1;
			}
			function chunk(array, size$2, guard$1) {
				if (guard$1 ? isIterateeCall(array, size$2, guard$1) : size$2 === undefined$1) size$2 = 1;
				else size$2 = nativeMax(toInteger(size$2), 0);
				var length$1 = array == null ? 0 : array.length;
				if (!length$1 || size$2 < 1) return [];
				var index = 0, resIndex = 0, result$1 = Array$1(nativeCeil(length$1 / size$2));
				while (index < length$1) result$1[resIndex++] = baseSlice(array, index, index += size$2);
				return result$1;
			}
			function compact(array) {
				var index = -1, length$1 = array == null ? 0 : array.length, resIndex = 0, result$1 = [];
				while (++index < length$1) {
					var value = array[index];
					if (value) result$1[resIndex++] = value;
				}
				return result$1;
			}
			function concat() {
				var length$1 = arguments.length;
				if (!length$1) return [];
				var args$1 = Array$1(length$1 - 1), array = arguments[0], index = length$1;
				while (index--) args$1[index - 1] = arguments[index];
				return arrayPush(isArray$2(array) ? copyArray(array) : [array], baseFlatten(args$1, 1));
			}
			var difference = baseRest(function(array, values$1) {
				return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values$1, 1, isArrayLikeObject, true)) : [];
			});
			var differenceBy = baseRest(function(array, values$1) {
				var iteratee$1 = last(values$1);
				if (isArrayLikeObject(iteratee$1)) iteratee$1 = undefined$1;
				return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values$1, 1, isArrayLikeObject, true), getIteratee(iteratee$1, 2)) : [];
			});
			var differenceWith = baseRest(function(array, values$1) {
				var comparator = last(values$1);
				if (isArrayLikeObject(comparator)) comparator = undefined$1;
				return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values$1, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
			});
			function drop(array, n, guard$1) {
				var length$1 = array == null ? 0 : array.length;
				if (!length$1) return [];
				n = guard$1 || n === undefined$1 ? 1 : toInteger(n);
				return baseSlice(array, n < 0 ? 0 : n, length$1);
			}
			function dropRight(array, n, guard$1) {
				var length$1 = array == null ? 0 : array.length;
				if (!length$1) return [];
				n = guard$1 || n === undefined$1 ? 1 : toInteger(n);
				n = length$1 - n;
				return baseSlice(array, 0, n < 0 ? 0 : n);
			}
			function dropRightWhile(array, predicate) {
				return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
			}
			function dropWhile(array, predicate) {
				return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
			}
			function fill(array, value, start$1, end$1) {
				var length$1 = array == null ? 0 : array.length;
				if (!length$1) return [];
				if (start$1 && typeof start$1 != "number" && isIterateeCall(array, value, start$1)) {
					start$1 = 0;
					end$1 = length$1;
				}
				return baseFill(array, value, start$1, end$1);
			}
			function findIndex(array, predicate, fromIndex) {
				var length$1 = array == null ? 0 : array.length;
				if (!length$1) return -1;
				var index = fromIndex == null ? 0 : toInteger(fromIndex);
				if (index < 0) index = nativeMax(length$1 + index, 0);
				return baseFindIndex(array, getIteratee(predicate, 3), index);
			}
			function findLastIndex(array, predicate, fromIndex) {
				var length$1 = array == null ? 0 : array.length;
				if (!length$1) return -1;
				var index = length$1 - 1;
				if (fromIndex !== undefined$1) {
					index = toInteger(fromIndex);
					index = fromIndex < 0 ? nativeMax(length$1 + index, 0) : nativeMin(index, length$1 - 1);
				}
				return baseFindIndex(array, getIteratee(predicate, 3), index, true);
			}
			function flatten(array) {
				return (array == null ? 0 : array.length) ? baseFlatten(array, 1) : [];
			}
			function flattenDeep(array) {
				return (array == null ? 0 : array.length) ? baseFlatten(array, INFINITY) : [];
			}
			function flattenDepth(array, depth) {
				if (!(array == null ? 0 : array.length)) return [];
				depth = depth === undefined$1 ? 1 : toInteger(depth);
				return baseFlatten(array, depth);
			}
			function fromPairs(pairs) {
				var index = -1, length$1 = pairs == null ? 0 : pairs.length, result$1 = {};
				while (++index < length$1) {
					var pair = pairs[index];
					result$1[pair[0]] = pair[1];
				}
				return result$1;
			}
			function head(array) {
				return array && array.length ? array[0] : undefined$1;
			}
			function indexOf(array, value, fromIndex) {
				var length$1 = array == null ? 0 : array.length;
				if (!length$1) return -1;
				var index = fromIndex == null ? 0 : toInteger(fromIndex);
				if (index < 0) index = nativeMax(length$1 + index, 0);
				return baseIndexOf(array, value, index);
			}
			function initial(array) {
				return (array == null ? 0 : array.length) ? baseSlice(array, 0, -1) : [];
			}
			var intersection = baseRest(function(arrays) {
				var mapped = arrayMap(arrays, castArrayLikeObject);
				return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
			});
			var intersectionBy = baseRest(function(arrays) {
				var iteratee$1 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
				if (iteratee$1 === last(mapped)) iteratee$1 = undefined$1;
				else mapped.pop();
				return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee$1, 2)) : [];
			});
			var intersectionWith = baseRest(function(arrays) {
				var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
				comparator = typeof comparator == "function" ? comparator : undefined$1;
				if (comparator) mapped.pop();
				return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
			});
			function join(array, separator) {
				return array == null ? "" : nativeJoin.call(array, separator);
			}
			function last(array) {
				var length$1 = array == null ? 0 : array.length;
				return length$1 ? array[length$1 - 1] : undefined$1;
			}
			function lastIndexOf(array, value, fromIndex) {
				var length$1 = array == null ? 0 : array.length;
				if (!length$1) return -1;
				var index = length$1;
				if (fromIndex !== undefined$1) {
					index = toInteger(fromIndex);
					index = index < 0 ? nativeMax(length$1 + index, 0) : nativeMin(index, length$1 - 1);
				}
				return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
			}
			function nth(array, n) {
				return array && array.length ? baseNth(array, toInteger(n)) : undefined$1;
			}
			var pull = baseRest(pullAll);
			function pullAll(array, values$1) {
				return array && array.length && values$1 && values$1.length ? basePullAll(array, values$1) : array;
			}
			function pullAllBy(array, values$1, iteratee$1) {
				return array && array.length && values$1 && values$1.length ? basePullAll(array, values$1, getIteratee(iteratee$1, 2)) : array;
			}
			function pullAllWith(array, values$1, comparator) {
				return array && array.length && values$1 && values$1.length ? basePullAll(array, values$1, undefined$1, comparator) : array;
			}
			var pullAt = flatRest(function(array, indexes) {
				var length$1 = array == null ? 0 : array.length, result$1 = baseAt(array, indexes);
				basePullAt(array, arrayMap(indexes, function(index) {
					return isIndex(index, length$1) ? +index : index;
				}).sort(compareAscending));
				return result$1;
			});
			function remove(array, predicate) {
				var result$1 = [];
				if (!(array && array.length)) return result$1;
				var index = -1, indexes = [], length$1 = array.length;
				predicate = getIteratee(predicate, 3);
				while (++index < length$1) {
					var value = array[index];
					if (predicate(value, index, array)) {
						result$1.push(value);
						indexes.push(index);
					}
				}
				basePullAt(array, indexes);
				return result$1;
			}
			function reverse(array) {
				return array == null ? array : nativeReverse.call(array);
			}
			function slice(array, start$1, end$1) {
				var length$1 = array == null ? 0 : array.length;
				if (!length$1) return [];
				if (end$1 && typeof end$1 != "number" && isIterateeCall(array, start$1, end$1)) {
					start$1 = 0;
					end$1 = length$1;
				} else {
					start$1 = start$1 == null ? 0 : toInteger(start$1);
					end$1 = end$1 === undefined$1 ? length$1 : toInteger(end$1);
				}
				return baseSlice(array, start$1, end$1);
			}
			function sortedIndex(array, value) {
				return baseSortedIndex(array, value);
			}
			function sortedIndexBy$1(array, value, iteratee$1) {
				return baseSortedIndexBy(array, value, getIteratee(iteratee$1, 2));
			}
			function sortedIndexOf(array, value) {
				var length$1 = array == null ? 0 : array.length;
				if (length$1) {
					var index = baseSortedIndex(array, value);
					if (index < length$1 && eq(array[index], value)) return index;
				}
				return -1;
			}
			function sortedLastIndex(array, value) {
				return baseSortedIndex(array, value, true);
			}
			function sortedLastIndexBy(array, value, iteratee$1) {
				return baseSortedIndexBy(array, value, getIteratee(iteratee$1, 2), true);
			}
			function sortedLastIndexOf(array, value) {
				if (array == null ? 0 : array.length) {
					var index = baseSortedIndex(array, value, true) - 1;
					if (eq(array[index], value)) return index;
				}
				return -1;
			}
			function sortedUniq(array) {
				return array && array.length ? baseSortedUniq(array) : [];
			}
			function sortedUniqBy(array, iteratee$1) {
				return array && array.length ? baseSortedUniq(array, getIteratee(iteratee$1, 2)) : [];
			}
			function tail(array) {
				var length$1 = array == null ? 0 : array.length;
				return length$1 ? baseSlice(array, 1, length$1) : [];
			}
			function take(array, n, guard$1) {
				if (!(array && array.length)) return [];
				n = guard$1 || n === undefined$1 ? 1 : toInteger(n);
				return baseSlice(array, 0, n < 0 ? 0 : n);
			}
			function takeRight(array, n, guard$1) {
				var length$1 = array == null ? 0 : array.length;
				if (!length$1) return [];
				n = guard$1 || n === undefined$1 ? 1 : toInteger(n);
				n = length$1 - n;
				return baseSlice(array, n < 0 ? 0 : n, length$1);
			}
			function takeRightWhile(array, predicate) {
				return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
			}
			function takeWhile(array, predicate) {
				return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
			}
			var union = baseRest(function(arrays) {
				return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
			});
			var unionBy = baseRest(function(arrays) {
				var iteratee$1 = last(arrays);
				if (isArrayLikeObject(iteratee$1)) iteratee$1 = undefined$1;
				return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee$1, 2));
			});
			var unionWith = baseRest(function(arrays) {
				var comparator = last(arrays);
				comparator = typeof comparator == "function" ? comparator : undefined$1;
				return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
			});
			function uniq(array) {
				return array && array.length ? baseUniq(array) : [];
			}
			function uniqBy(array, iteratee$1) {
				return array && array.length ? baseUniq(array, getIteratee(iteratee$1, 2)) : [];
			}
			function uniqWith(array, comparator) {
				comparator = typeof comparator == "function" ? comparator : undefined$1;
				return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
			}
			function unzip(array) {
				if (!(array && array.length)) return [];
				var length$1 = 0;
				array = arrayFilter(array, function(group) {
					if (isArrayLikeObject(group)) {
						length$1 = nativeMax(group.length, length$1);
						return true;
					}
				});
				return baseTimes(length$1, function(index) {
					return arrayMap(array, baseProperty(index));
				});
			}
			function unzipWith(array, iteratee$1) {
				if (!(array && array.length)) return [];
				var result$1 = unzip(array);
				if (iteratee$1 == null) return result$1;
				return arrayMap(result$1, function(group) {
					return apply(iteratee$1, undefined$1, group);
				});
			}
			var without = baseRest(function(array, values$1) {
				return isArrayLikeObject(array) ? baseDifference(array, values$1) : [];
			});
			var xor = baseRest(function(arrays) {
				return baseXor(arrayFilter(arrays, isArrayLikeObject));
			});
			var xorBy = baseRest(function(arrays) {
				var iteratee$1 = last(arrays);
				if (isArrayLikeObject(iteratee$1)) iteratee$1 = undefined$1;
				return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee$1, 2));
			});
			var xorWith = baseRest(function(arrays) {
				var comparator = last(arrays);
				comparator = typeof comparator == "function" ? comparator : undefined$1;
				return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
			});
			var zip = baseRest(unzip);
			function zipObject(props, values$1) {
				return baseZipObject(props || [], values$1 || [], assignValue);
			}
			function zipObjectDeep(props, values$1) {
				return baseZipObject(props || [], values$1 || [], baseSet);
			}
			var zipWith = baseRest(function(arrays) {
				var length$1 = arrays.length, iteratee$1 = length$1 > 1 ? arrays[length$1 - 1] : undefined$1;
				iteratee$1 = typeof iteratee$1 == "function" ? (arrays.pop(), iteratee$1) : undefined$1;
				return unzipWith(arrays, iteratee$1);
			});
			function chain(value) {
				var result$1 = lodash(value);
				result$1.__chain__ = true;
				return result$1;
			}
			function tap(value, interceptor) {
				interceptor(value);
				return value;
			}
			function thru(value, interceptor) {
				return interceptor(value);
			}
			var wrapperAt = flatRest(function(paths) {
				var length$1 = paths.length, start$1 = length$1 ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
					return baseAt(object, paths);
				};
				if (length$1 > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start$1)) return this.thru(interceptor);
				value = value.slice(start$1, +start$1 + (length$1 ? 1 : 0));
				value.__actions__.push({
					"func": thru,
					"args": [interceptor],
					"thisArg": undefined$1
				});
				return new LodashWrapper(value, this.__chain__).thru(function(array) {
					if (length$1 && !array.length) array.push(undefined$1);
					return array;
				});
			});
			function wrapperChain() {
				return chain(this);
			}
			function wrapperCommit() {
				return new LodashWrapper(this.value(), this.__chain__);
			}
			function wrapperNext() {
				if (this.__values__ === undefined$1) this.__values__ = toArray(this.value());
				var done = this.__index__ >= this.__values__.length, value = done ? undefined$1 : this.__values__[this.__index__++];
				return {
					"done": done,
					"value": value
				};
			}
			function wrapperToIterator() {
				return this;
			}
			function wrapperPlant(value) {
				var result$1, parent$1 = this;
				while (parent$1 instanceof baseLodash) {
					var clone$2 = wrapperClone(parent$1);
					clone$2.__index__ = 0;
					clone$2.__values__ = undefined$1;
					if (result$1) previous.__wrapped__ = clone$2;
					else result$1 = clone$2;
					var previous = clone$2;
					parent$1 = parent$1.__wrapped__;
				}
				previous.__wrapped__ = value;
				return result$1;
			}
			function wrapperReverse() {
				var value = this.__wrapped__;
				if (value instanceof LazyWrapper) {
					var wrapped = value;
					if (this.__actions__.length) wrapped = new LazyWrapper(this);
					wrapped = wrapped.reverse();
					wrapped.__actions__.push({
						"func": thru,
						"args": [reverse],
						"thisArg": undefined$1
					});
					return new LodashWrapper(wrapped, this.__chain__);
				}
				return this.thru(reverse);
			}
			function wrapperValue() {
				return baseWrapperValue(this.__wrapped__, this.__actions__);
			}
			var countBy = createAggregator(function(result$1, value, key) {
				if (hasOwnProperty$2.call(result$1, key)) ++result$1[key];
				else baseAssignValue(result$1, key, 1);
			});
			function every$2(collection, predicate, guard$1) {
				var func = isArray$2(collection) ? arrayEvery : baseEvery;
				if (guard$1 && isIterateeCall(collection, predicate, guard$1)) predicate = undefined$1;
				return func(collection, getIteratee(predicate, 3));
			}
			function filter(collection, predicate) {
				return (isArray$2(collection) ? arrayFilter : baseFilter)(collection, getIteratee(predicate, 3));
			}
			var find = createFind(findIndex);
			var findLast = createFind(findLastIndex);
			function flatMap(collection, iteratee$1) {
				return baseFlatten(map$1(collection, iteratee$1), 1);
			}
			function flatMapDeep(collection, iteratee$1) {
				return baseFlatten(map$1(collection, iteratee$1), INFINITY);
			}
			function flatMapDepth(collection, iteratee$1, depth) {
				depth = depth === undefined$1 ? 1 : toInteger(depth);
				return baseFlatten(map$1(collection, iteratee$1), depth);
			}
			function forEach(collection, iteratee$1) {
				return (isArray$2(collection) ? arrayEach : baseEach)(collection, getIteratee(iteratee$1, 3));
			}
			function forEachRight(collection, iteratee$1) {
				return (isArray$2(collection) ? arrayEachRight : baseEachRight)(collection, getIteratee(iteratee$1, 3));
			}
			var groupBy$1 = createAggregator(function(result$1, value, key) {
				if (hasOwnProperty$2.call(result$1, key)) result$1[key].push(value);
				else baseAssignValue(result$1, key, [value]);
			});
			function includes(collection, value, fromIndex, guard$1) {
				collection = isArrayLike(collection) ? collection : values(collection);
				fromIndex = fromIndex && !guard$1 ? toInteger(fromIndex) : 0;
				var length$1 = collection.length;
				if (fromIndex < 0) fromIndex = nativeMax(length$1 + fromIndex, 0);
				return isString(collection) ? fromIndex <= length$1 && collection.indexOf(value, fromIndex) > -1 : !!length$1 && baseIndexOf(collection, value, fromIndex) > -1;
			}
			var invokeMap = baseRest(function(collection, path, args$1) {
				var index = -1, isFunc = typeof path == "function", result$1 = isArrayLike(collection) ? Array$1(collection.length) : [];
				baseEach(collection, function(value) {
					result$1[++index] = isFunc ? apply(path, value, args$1) : baseInvoke(value, path, args$1);
				});
				return result$1;
			});
			var keyBy = createAggregator(function(result$1, value, key) {
				baseAssignValue(result$1, key, value);
			});
			function map$1(collection, iteratee$1) {
				return (isArray$2(collection) ? arrayMap : baseMap)(collection, getIteratee(iteratee$1, 3));
			}
			function orderBy(collection, iteratees, orders, guard$1) {
				if (collection == null) return [];
				if (!isArray$2(iteratees)) iteratees = iteratees == null ? [] : [iteratees];
				orders = guard$1 ? undefined$1 : orders;
				if (!isArray$2(orders)) orders = orders == null ? [] : [orders];
				return baseOrderBy(collection, iteratees, orders);
			}
			var partition = createAggregator(function(result$1, value, key) {
				result$1[key ? 0 : 1].push(value);
			}, function() {
				return [[], []];
			});
			function reduce(collection, iteratee$1, accumulator) {
				var func = isArray$2(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
				return func(collection, getIteratee(iteratee$1, 4), accumulator, initAccum, baseEach);
			}
			function reduceRight(collection, iteratee$1, accumulator) {
				var func = isArray$2(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
				return func(collection, getIteratee(iteratee$1, 4), accumulator, initAccum, baseEachRight);
			}
			function reject(collection, predicate) {
				return (isArray$2(collection) ? arrayFilter : baseFilter)(collection, negate(getIteratee(predicate, 3)));
			}
			function sample(collection) {
				return (isArray$2(collection) ? arraySample : baseSample)(collection);
			}
			function sampleSize(collection, n, guard$1) {
				if (guard$1 ? isIterateeCall(collection, n, guard$1) : n === undefined$1) n = 1;
				else n = toInteger(n);
				return (isArray$2(collection) ? arraySampleSize : baseSampleSize)(collection, n);
			}
			function shuffle(collection) {
				return (isArray$2(collection) ? arrayShuffle : baseShuffle)(collection);
			}
			function size$1(collection) {
				if (collection == null) return 0;
				if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
				var tag = getTag(collection);
				if (tag == mapTag || tag == setTag) return collection.size;
				return baseKeys(collection).length;
			}
			function some$1(collection, predicate, guard$1) {
				var func = isArray$2(collection) ? arraySome : baseSome;
				if (guard$1 && isIterateeCall(collection, predicate, guard$1)) predicate = undefined$1;
				return func(collection, getIteratee(predicate, 3));
			}
			var sortBy = baseRest(function(collection, iteratees) {
				if (collection == null) return [];
				var length$1 = iteratees.length;
				if (length$1 > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
				else if (length$1 > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [iteratees[0]];
				return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
			});
			var now = ctxNow || function() {
				return root.Date.now();
			};
			function after(n, func) {
				if (typeof func != "function") throw new TypeError$1(FUNC_ERROR_TEXT);
				n = toInteger(n);
				return function() {
					if (--n < 1) return func.apply(this, arguments);
				};
			}
			function ary(func, n, guard$1) {
				n = guard$1 ? undefined$1 : n;
				n = func && n == null ? func.length : n;
				return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
			}
			function before(n, func) {
				var result$1;
				if (typeof func != "function") throw new TypeError$1(FUNC_ERROR_TEXT);
				n = toInteger(n);
				return function() {
					if (--n > 0) result$1 = func.apply(this, arguments);
					if (n <= 1) func = undefined$1;
					return result$1;
				};
			}
			var bind = baseRest(function(func, thisArg, partials) {
				var bitmask = WRAP_BIND_FLAG;
				if (partials.length) {
					var holders = replaceHolders(partials, getHolder(bind));
					bitmask |= WRAP_PARTIAL_FLAG;
				}
				return createWrap(func, bitmask, thisArg, partials, holders);
			});
			var bindKey = baseRest(function(object, key, partials) {
				var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
				if (partials.length) {
					var holders = replaceHolders(partials, getHolder(bindKey));
					bitmask |= WRAP_PARTIAL_FLAG;
				}
				return createWrap(key, bitmask, object, partials, holders);
			});
			function curry(func, arity, guard$1) {
				arity = guard$1 ? undefined$1 : arity;
				var result$1 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
				result$1.placeholder = curry.placeholder;
				return result$1;
			}
			function curryRight(func, arity, guard$1) {
				arity = guard$1 ? undefined$1 : arity;
				var result$1 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
				result$1.placeholder = curryRight.placeholder;
				return result$1;
			}
			function debounce$2(func, wait, options) {
				var lastArgs, lastThis, maxWait, result$1, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
				if (typeof func != "function") throw new TypeError$1(FUNC_ERROR_TEXT);
				wait = toNumber(wait) || 0;
				if (isObject$3(options)) {
					leading = !!options.leading;
					maxing = "maxWait" in options;
					maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
					trailing = "trailing" in options ? !!options.trailing : trailing;
				}
				function invokeFunc(time) {
					var args$1 = lastArgs, thisArg = lastThis;
					lastArgs = lastThis = undefined$1;
					lastInvokeTime = time;
					result$1 = func.apply(thisArg, args$1);
					return result$1;
				}
				function leadingEdge(time) {
					lastInvokeTime = time;
					timerId = setTimeout$1(timerExpired, wait);
					return leading ? invokeFunc(time) : result$1;
				}
				function remainingWait(time) {
					var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
					return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
				}
				function shouldInvoke(time) {
					var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
					return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
				}
				function timerExpired() {
					var time = now();
					if (shouldInvoke(time)) return trailingEdge(time);
					timerId = setTimeout$1(timerExpired, remainingWait(time));
				}
				function trailingEdge(time) {
					timerId = undefined$1;
					if (trailing && lastArgs) return invokeFunc(time);
					lastArgs = lastThis = undefined$1;
					return result$1;
				}
				function cancel() {
					if (timerId !== undefined$1) clearTimeout$1(timerId);
					lastInvokeTime = 0;
					lastArgs = lastCallTime = lastThis = timerId = undefined$1;
				}
				function flush() {
					return timerId === undefined$1 ? result$1 : trailingEdge(now());
				}
				function debounced() {
					var time = now(), isInvoking = shouldInvoke(time);
					lastArgs = arguments;
					lastThis = this;
					lastCallTime = time;
					if (isInvoking) {
						if (timerId === undefined$1) return leadingEdge(lastCallTime);
						if (maxing) {
							clearTimeout$1(timerId);
							timerId = setTimeout$1(timerExpired, wait);
							return invokeFunc(lastCallTime);
						}
					}
					if (timerId === undefined$1) timerId = setTimeout$1(timerExpired, wait);
					return result$1;
				}
				debounced.cancel = cancel;
				debounced.flush = flush;
				return debounced;
			}
			var defer = baseRest(function(func, args$1) {
				return baseDelay(func, 1, args$1);
			});
			var delay = baseRest(function(func, wait, args$1) {
				return baseDelay(func, toNumber(wait) || 0, args$1);
			});
			function flip$1(func) {
				return createWrap(func, WRAP_FLIP_FLAG);
			}
			function memoize(func, resolver) {
				if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError$1(FUNC_ERROR_TEXT);
				var memoized = function() {
					var args$1 = arguments, key = resolver ? resolver.apply(this, args$1) : args$1[0], cache$2 = memoized.cache;
					if (cache$2.has(key)) return cache$2.get(key);
					var result$1 = func.apply(this, args$1);
					memoized.cache = cache$2.set(key, result$1) || cache$2;
					return result$1;
				};
				memoized.cache = new (memoize.Cache || MapCache)();
				return memoized;
			}
			memoize.Cache = MapCache;
			function negate(predicate) {
				if (typeof predicate != "function") throw new TypeError$1(FUNC_ERROR_TEXT);
				return function() {
					var args$1 = arguments;
					switch (args$1.length) {
						case 0: return !predicate.call(this);
						case 1: return !predicate.call(this, args$1[0]);
						case 2: return !predicate.call(this, args$1[0], args$1[1]);
						case 3: return !predicate.call(this, args$1[0], args$1[1], args$1[2]);
					}
					return !predicate.apply(this, args$1);
				};
			}
			function once(func) {
				return before(2, func);
			}
			var overArgs = castRest(function(func, transforms) {
				transforms = transforms.length == 1 && isArray$2(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
				var funcsLength = transforms.length;
				return baseRest(function(args$1) {
					var index = -1, length$1 = nativeMin(args$1.length, funcsLength);
					while (++index < length$1) args$1[index] = transforms[index].call(this, args$1[index]);
					return apply(func, this, args$1);
				});
			});
			var partial = baseRest(function(func, partials) {
				return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, replaceHolders(partials, getHolder(partial)));
			});
			var partialRight = baseRest(function(func, partials) {
				return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, replaceHolders(partials, getHolder(partialRight)));
			});
			var rearg = flatRest(function(func, indexes) {
				return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
			});
			function rest(func, start$1) {
				if (typeof func != "function") throw new TypeError$1(FUNC_ERROR_TEXT);
				start$1 = start$1 === undefined$1 ? start$1 : toInteger(start$1);
				return baseRest(func, start$1);
			}
			function spread(func, start$1) {
				if (typeof func != "function") throw new TypeError$1(FUNC_ERROR_TEXT);
				start$1 = start$1 == null ? 0 : nativeMax(toInteger(start$1), 0);
				return baseRest(function(args$1) {
					var array = args$1[start$1], otherArgs = castSlice(args$1, 0, start$1);
					if (array) arrayPush(otherArgs, array);
					return apply(func, this, otherArgs);
				});
			}
			function throttle$1(func, wait, options) {
				var leading = true, trailing = true;
				if (typeof func != "function") throw new TypeError$1(FUNC_ERROR_TEXT);
				if (isObject$3(options)) {
					leading = "leading" in options ? !!options.leading : leading;
					trailing = "trailing" in options ? !!options.trailing : trailing;
				}
				return debounce$2(func, wait, {
					"leading": leading,
					"maxWait": wait,
					"trailing": trailing
				});
			}
			function unary(func) {
				return ary(func, 1);
			}
			function wrap(value, wrapper) {
				return partial(castFunction(wrapper), value);
			}
			function castArray() {
				if (!arguments.length) return [];
				var value = arguments[0];
				return isArray$2(value) ? value : [value];
			}
			function clone$1(value) {
				return baseClone(value, CLONE_SYMBOLS_FLAG);
			}
			function cloneWith(value, customizer) {
				customizer = typeof customizer == "function" ? customizer : undefined$1;
				return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
			}
			function cloneDeep$1(value) {
				return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
			}
			function cloneDeepWith(value, customizer) {
				customizer = typeof customizer == "function" ? customizer : undefined$1;
				return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
			}
			function conformsTo(object, source) {
				return source == null || baseConformsTo(object, source, keys$1(source));
			}
			function eq(value, other) {
				return value === other || value !== value && other !== other;
			}
			var gt = createRelationalOperation(baseGt);
			var gte = createRelationalOperation(function(value, other) {
				return value >= other;
			});
			var isArguments = baseIsArguments(function() {
				return arguments;
			}()) ? baseIsArguments : function(value) {
				return isObjectLike(value) && hasOwnProperty$2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
			};
			var isArray$2 = Array$1.isArray;
			var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
			function isArrayLike(value) {
				return value != null && isLength(value.length) && !isFunction(value);
			}
			function isArrayLikeObject(value) {
				return isObjectLike(value) && isArrayLike(value);
			}
			function isBoolean(value) {
				return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
			}
			var isBuffer = nativeIsBuffer || stubFalse;
			var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
			function isElement$2(value) {
				return isObjectLike(value) && value.nodeType === 1 && !isPlainObject$3(value);
			}
			function isEmpty(value) {
				if (value == null) return true;
				if (isArrayLike(value) && (isArray$2(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
				var tag = getTag(value);
				if (tag == mapTag || tag == setTag) return !value.size;
				if (isPrototype(value)) return !baseKeys(value).length;
				for (var key in value) if (hasOwnProperty$2.call(value, key)) return false;
				return true;
			}
			function isEqual$1(value, other) {
				return baseIsEqual(value, other);
			}
			function isEqualWith(value, other, customizer) {
				customizer = typeof customizer == "function" ? customizer : undefined$1;
				var result$1 = customizer ? customizer(value, other) : undefined$1;
				return result$1 === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result$1;
			}
			function isError(value) {
				if (!isObjectLike(value)) return false;
				var tag = baseGetTag(value);
				return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject$3(value);
			}
			function isFinite$1(value) {
				return typeof value == "number" && nativeIsFinite(value);
			}
			function isFunction(value) {
				if (!isObject$3(value)) return false;
				var tag = baseGetTag(value);
				return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
			}
			function isInteger$1(value) {
				return typeof value == "number" && value == toInteger(value);
			}
			function isLength(value) {
				return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
			}
			function isObject$3(value) {
				var type = typeof value;
				return value != null && (type == "object" || type == "function");
			}
			function isObjectLike(value) {
				return value != null && typeof value == "object";
			}
			var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
			function isMatch$1(object, source) {
				return object === source || baseIsMatch(object, source, getMatchData(source));
			}
			function isMatchWith(object, source, customizer) {
				customizer = typeof customizer == "function" ? customizer : undefined$1;
				return baseIsMatch(object, source, getMatchData(source), customizer);
			}
			function isNaN$3(value) {
				return isNumber(value) && value != +value;
			}
			function isNative(value) {
				if (isMaskable(value)) throw new Error$1(CORE_ERROR_TEXT);
				return baseIsNative(value);
			}
			function isNull(value) {
				return value === null;
			}
			function isNil(value) {
				return value == null;
			}
			function isNumber(value) {
				return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
			}
			function isPlainObject$3(value) {
				if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
				var proto = getPrototype(value);
				if (proto === null) return true;
				var Ctor = hasOwnProperty$2.call(proto, "constructor") && proto.constructor;
				return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
			}
			var isRegExp$1 = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
			function isSafeInteger(value) {
				return isInteger$1(value) && value >= -MAX_SAFE_INTEGER$1 && value <= MAX_SAFE_INTEGER$1;
			}
			var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
			function isString(value) {
				return typeof value == "string" || !isArray$2(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
			}
			function isSymbol(value) {
				return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
			}
			var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
			function isUndefined(value) {
				return value === undefined$1;
			}
			function isWeakMap(value) {
				return isObjectLike(value) && getTag(value) == weakMapTag;
			}
			function isWeakSet(value) {
				return isObjectLike(value) && baseGetTag(value) == weakSetTag;
			}
			var lt = createRelationalOperation(baseLt);
			var lte = createRelationalOperation(function(value, other) {
				return value <= other;
			});
			function toArray(value) {
				if (!value) return [];
				if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
				if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
				var tag = getTag(value);
				return (tag == mapTag ? mapToArray : tag == setTag ? setToArray : values)(value);
			}
			function toFinite(value) {
				if (!value) return value === 0 ? value : 0;
				value = toNumber(value);
				if (value === INFINITY || value === -INFINITY) return (value < 0 ? -1 : 1) * MAX_INTEGER;
				return value === value ? value : 0;
			}
			function toInteger(value) {
				var result$1 = toFinite(value), remainder = result$1 % 1;
				return result$1 === result$1 ? remainder ? result$1 - remainder : result$1 : 0;
			}
			function toLength(value) {
				return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
			}
			function toNumber(value) {
				if (typeof value == "number") return value;
				if (isSymbol(value)) return NAN;
				if (isObject$3(value)) {
					var other = typeof value.valueOf == "function" ? value.valueOf() : value;
					value = isObject$3(other) ? other + "" : other;
				}
				if (typeof value != "string") return value === 0 ? value : +value;
				value = baseTrim(value);
				var isBinary = reIsBinary.test(value);
				return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
			}
			function toPlainObject(value) {
				return copyObject(value, keysIn(value));
			}
			function toSafeInteger(value) {
				return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER$1, MAX_SAFE_INTEGER$1) : value === 0 ? value : 0;
			}
			function toString(value) {
				return value == null ? "" : baseToString(value);
			}
			var assign = createAssigner(function(object, source) {
				if (isPrototype(source) || isArrayLike(source)) {
					copyObject(source, keys$1(source), object);
					return;
				}
				for (var key in source) if (hasOwnProperty$2.call(source, key)) assignValue(object, key, source[key]);
			});
			var assignIn = createAssigner(function(object, source) {
				copyObject(source, keysIn(source), object);
			});
			var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
				copyObject(source, keysIn(source), object, customizer);
			});
			var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
				copyObject(source, keys$1(source), object, customizer);
			});
			var at = flatRest(baseAt);
			function create$3(prototype, properties) {
				var result$1 = baseCreate(prototype);
				return properties == null ? result$1 : baseAssign(result$1, properties);
			}
			var defaults = baseRest(function(object, sources) {
				object = Object$1(object);
				var index = -1;
				var length$1 = sources.length;
				var guard$1 = length$1 > 2 ? sources[2] : undefined$1;
				if (guard$1 && isIterateeCall(sources[0], sources[1], guard$1)) length$1 = 1;
				while (++index < length$1) {
					var source = sources[index];
					var props = keysIn(source);
					var propsIndex = -1;
					var propsLength = props.length;
					while (++propsIndex < propsLength) {
						var key = props[propsIndex];
						var value = object[key];
						if (value === undefined$1 || eq(value, objectProto[key]) && !hasOwnProperty$2.call(object, key)) object[key] = source[key];
					}
				}
				return object;
			});
			var defaultsDeep = baseRest(function(args$1) {
				args$1.push(undefined$1, customDefaultsMerge);
				return apply(mergeWith, undefined$1, args$1);
			});
			function findKey(object, predicate) {
				return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
			}
			function findLastKey(object, predicate) {
				return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
			}
			function forIn(object, iteratee$1) {
				return object == null ? object : baseFor(object, getIteratee(iteratee$1, 3), keysIn);
			}
			function forInRight(object, iteratee$1) {
				return object == null ? object : baseForRight(object, getIteratee(iteratee$1, 3), keysIn);
			}
			function forOwn(object, iteratee$1) {
				return object && baseForOwn(object, getIteratee(iteratee$1, 3));
			}
			function forOwnRight(object, iteratee$1) {
				return object && baseForOwnRight(object, getIteratee(iteratee$1, 3));
			}
			function functions(object) {
				return object == null ? [] : baseFunctions(object, keys$1(object));
			}
			function functionsIn(object) {
				return object == null ? [] : baseFunctions(object, keysIn(object));
			}
			function get(object, path, defaultValue) {
				var result$1 = object == null ? undefined$1 : baseGet(object, path);
				return result$1 === undefined$1 ? defaultValue : result$1;
			}
			function has(object, path) {
				return object != null && hasPath(object, path, baseHas);
			}
			function hasIn(object, path) {
				return object != null && hasPath(object, path, baseHasIn);
			}
			var invert = createInverter(function(result$1, value, key) {
				if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
				result$1[value] = key;
			}, constant(identity));
			var invertBy = createInverter(function(result$1, value, key) {
				if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
				if (hasOwnProperty$2.call(result$1, value)) result$1[value].push(key);
				else result$1[value] = [key];
			}, getIteratee);
			var invoke = baseRest(baseInvoke);
			function keys$1(object) {
				return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
			}
			function keysIn(object) {
				return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
			}
			function mapKeys(object, iteratee$1) {
				var result$1 = {};
				iteratee$1 = getIteratee(iteratee$1, 3);
				baseForOwn(object, function(value, key, object$1) {
					baseAssignValue(result$1, iteratee$1(value, key, object$1), value);
				});
				return result$1;
			}
			function mapValues(object, iteratee$1) {
				var result$1 = {};
				iteratee$1 = getIteratee(iteratee$1, 3);
				baseForOwn(object, function(value, key, object$1) {
					baseAssignValue(result$1, key, iteratee$1(value, key, object$1));
				});
				return result$1;
			}
			var merge = createAssigner(function(object, source, srcIndex) {
				baseMerge(object, source, srcIndex);
			});
			var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
				baseMerge(object, source, srcIndex, customizer);
			});
			var omit = flatRest(function(object, paths) {
				var result$1 = {};
				if (object == null) return result$1;
				var isDeep = false;
				paths = arrayMap(paths, function(path) {
					path = castPath(path, object);
					isDeep || (isDeep = path.length > 1);
					return path;
				});
				copyObject(object, getAllKeysIn(object), result$1);
				if (isDeep) result$1 = baseClone(result$1, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
				var length$1 = paths.length;
				while (length$1--) baseUnset(result$1, paths[length$1]);
				return result$1;
			});
			function omitBy(object, predicate) {
				return pickBy(object, negate(getIteratee(predicate)));
			}
			var pick = flatRest(function(object, paths) {
				return object == null ? {} : basePick(object, paths);
			});
			function pickBy(object, predicate) {
				if (object == null) return {};
				var props = arrayMap(getAllKeysIn(object), function(prop) {
					return [prop];
				});
				predicate = getIteratee(predicate);
				return basePickBy(object, props, function(value, path) {
					return predicate(value, path[0]);
				});
			}
			function result(object, path, defaultValue) {
				path = castPath(path, object);
				var index = -1, length$1 = path.length;
				if (!length$1) {
					length$1 = 1;
					object = undefined$1;
				}
				while (++index < length$1) {
					var value = object == null ? undefined$1 : object[toKey(path[index])];
					if (value === undefined$1) {
						index = length$1;
						value = defaultValue;
					}
					object = isFunction(value) ? value.call(object) : value;
				}
				return object;
			}
			function set(object, path, value) {
				return object == null ? object : baseSet(object, path, value);
			}
			function setWith(object, path, value, customizer) {
				customizer = typeof customizer == "function" ? customizer : undefined$1;
				return object == null ? object : baseSet(object, path, value, customizer);
			}
			var toPairs = createToPairs(keys$1);
			var toPairsIn = createToPairs(keysIn);
			function transform(object, iteratee$1, accumulator) {
				var isArr = isArray$2(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
				iteratee$1 = getIteratee(iteratee$1, 4);
				if (accumulator == null) {
					var Ctor = object && object.constructor;
					if (isArrLike) accumulator = isArr ? new Ctor() : [];
					else if (isObject$3(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
					else accumulator = {};
				}
				(isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object$1) {
					return iteratee$1(accumulator, value, index, object$1);
				});
				return accumulator;
			}
			function unset(object, path) {
				return object == null ? true : baseUnset(object, path);
			}
			function update(object, path, updater) {
				return object == null ? object : baseUpdate(object, path, castFunction(updater));
			}
			function updateWith(object, path, updater, customizer) {
				customizer = typeof customizer == "function" ? customizer : undefined$1;
				return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
			}
			function values(object) {
				return object == null ? [] : baseValues(object, keys$1(object));
			}
			function valuesIn(object) {
				return object == null ? [] : baseValues(object, keysIn(object));
			}
			function clamp$2(number, lower, upper) {
				if (upper === undefined$1) {
					upper = lower;
					lower = undefined$1;
				}
				if (upper !== undefined$1) {
					upper = toNumber(upper);
					upper = upper === upper ? upper : 0;
				}
				if (lower !== undefined$1) {
					lower = toNumber(lower);
					lower = lower === lower ? lower : 0;
				}
				return baseClamp(toNumber(number), lower, upper);
			}
			function inRange(number, start$1, end$1) {
				start$1 = toFinite(start$1);
				if (end$1 === undefined$1) {
					end$1 = start$1;
					start$1 = 0;
				} else end$1 = toFinite(end$1);
				number = toNumber(number);
				return baseInRange(number, start$1, end$1);
			}
			function random$1(lower, upper, floating) {
				if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined$1;
				if (floating === undefined$1) {
					if (typeof upper == "boolean") {
						floating = upper;
						upper = undefined$1;
					} else if (typeof lower == "boolean") {
						floating = lower;
						lower = undefined$1;
					}
				}
				if (lower === undefined$1 && upper === undefined$1) {
					lower = 0;
					upper = 1;
				} else {
					lower = toFinite(lower);
					if (upper === undefined$1) {
						upper = lower;
						lower = 0;
					} else upper = toFinite(upper);
				}
				if (lower > upper) {
					var temp = lower;
					lower = upper;
					upper = temp;
				}
				if (floating || lower % 1 || upper % 1) {
					var rand$1 = nativeRandom();
					return nativeMin(lower + rand$1 * (upper - lower + freeParseFloat("1e-" + ((rand$1 + "").length - 1))), upper);
				}
				return baseRandom(lower, upper);
			}
			var camelCase = createCompounder(function(result$1, word$1, index) {
				word$1 = word$1.toLowerCase();
				return result$1 + (index ? capitalize$1(word$1) : word$1);
			});
			function capitalize$1(string) {
				return upperFirst(toString(string).toLowerCase());
			}
			function deburr(string) {
				string = toString(string);
				return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
			}
			function endsWith(string, target, position) {
				string = toString(string);
				target = baseToString(target);
				var length$1 = string.length;
				position = position === undefined$1 ? length$1 : baseClamp(toInteger(position), 0, length$1);
				var end$1 = position;
				position -= target.length;
				return position >= 0 && string.slice(position, end$1) == target;
			}
			function escape$1(string) {
				string = toString(string);
				return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
			}
			function escapeRegExp(string) {
				string = toString(string);
				return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
			}
			var kebabCase = createCompounder(function(result$1, word$1, index) {
				return result$1 + (index ? "-" : "") + word$1.toLowerCase();
			});
			var lowerCase = createCompounder(function(result$1, word$1, index) {
				return result$1 + (index ? " " : "") + word$1.toLowerCase();
			});
			var lowerFirst = createCaseFirst("toLowerCase");
			function pad(string, length$1, chars) {
				string = toString(string);
				length$1 = toInteger(length$1);
				var strLength = length$1 ? stringSize(string) : 0;
				if (!length$1 || strLength >= length$1) return string;
				var mid = (length$1 - strLength) / 2;
				return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
			}
			function padEnd(string, length$1, chars) {
				string = toString(string);
				length$1 = toInteger(length$1);
				var strLength = length$1 ? stringSize(string) : 0;
				return length$1 && strLength < length$1 ? string + createPadding(length$1 - strLength, chars) : string;
			}
			function padStart(string, length$1, chars) {
				string = toString(string);
				length$1 = toInteger(length$1);
				var strLength = length$1 ? stringSize(string) : 0;
				return length$1 && strLength < length$1 ? createPadding(length$1 - strLength, chars) + string : string;
			}
			function parseInt$2(string, radix, guard$1) {
				if (guard$1 || radix == null) radix = 0;
				else if (radix) radix = +radix;
				return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
			}
			function repeat$1(string, n, guard$1) {
				if (guard$1 ? isIterateeCall(string, n, guard$1) : n === undefined$1) n = 1;
				else n = toInteger(n);
				return baseRepeat(toString(string), n);
			}
			function replace() {
				var args$1 = arguments, string = toString(args$1[0]);
				return args$1.length < 3 ? string : string.replace(args$1[1], args$1[2]);
			}
			var snakeCase = createCompounder(function(result$1, word$1, index) {
				return result$1 + (index ? "_" : "") + word$1.toLowerCase();
			});
			function split(string, separator, limit) {
				if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined$1;
				limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
				if (!limit) return [];
				string = toString(string);
				if (string && (typeof separator == "string" || separator != null && !isRegExp$1(separator))) {
					separator = baseToString(separator);
					if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
				}
				return string.split(separator, limit);
			}
			var startCase = createCompounder(function(result$1, word$1, index) {
				return result$1 + (index ? " " : "") + upperFirst(word$1);
			});
			function startsWith(string, target, position) {
				string = toString(string);
				position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
				target = baseToString(target);
				return string.slice(position, position + target.length) == target;
			}
			function template(string, options, guard$1) {
				var settings = lodash.templateSettings;
				if (guard$1 && isIterateeCall(string, options, guard$1)) options = undefined$1;
				string = toString(string);
				options = assignInWith({}, options, settings, customDefaultsAssignIn);
				var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys$1(imports), importsValues = baseValues(imports, importsKeys);
				var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
				var reDelimiters = RegExp$1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
				var sourceURL = "//# sourceURL=" + (hasOwnProperty$2.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
				string.replace(reDelimiters, function(match$1, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset$1) {
					interpolateValue || (interpolateValue = esTemplateValue);
					source += string.slice(index, offset$1).replace(reUnescapedString, escapeStringChar);
					if (escapeValue) {
						isEscaping = true;
						source += "' +\n__e(" + escapeValue + ") +\n'";
					}
					if (evaluateValue) {
						isEvaluating = true;
						source += "';\n" + evaluateValue + ";\n__p += '";
					}
					if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
					index = offset$1 + match$1.length;
					return match$1;
				});
				source += "';\n";
				var variable = hasOwnProperty$2.call(options, "variable") && options.variable;
				if (!variable) source = "with (obj) {\n" + source + "\n}\n";
				else if (reForbiddenIdentifierChars.test(variable)) throw new Error$1(INVALID_TEMPL_VAR_ERROR_TEXT);
				source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
				source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
				var result$1 = attempt(function() {
					return Function$1(importsKeys, sourceURL + "return " + source).apply(undefined$1, importsValues);
				});
				result$1.source = source;
				if (isError(result$1)) throw result$1;
				return result$1;
			}
			function toLower(value) {
				return toString(value).toLowerCase();
			}
			function toUpper(value) {
				return toString(value).toUpperCase();
			}
			function trim(string, chars, guard$1) {
				string = toString(string);
				if (string && (guard$1 || chars === undefined$1)) return baseTrim(string);
				if (!string || !(chars = baseToString(chars))) return string;
				var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars);
				return castSlice(strSymbols, charsStartIndex(strSymbols, chrSymbols), charsEndIndex(strSymbols, chrSymbols) + 1).join("");
			}
			function trimEnd(string, chars, guard$1) {
				string = toString(string);
				if (string && (guard$1 || chars === undefined$1)) return string.slice(0, trimmedEndIndex(string) + 1);
				if (!string || !(chars = baseToString(chars))) return string;
				var strSymbols = stringToArray(string);
				return castSlice(strSymbols, 0, charsEndIndex(strSymbols, stringToArray(chars)) + 1).join("");
			}
			function trimStart(string, chars, guard$1) {
				string = toString(string);
				if (string && (guard$1 || chars === undefined$1)) return string.replace(reTrimStart, "");
				if (!string || !(chars = baseToString(chars))) return string;
				var strSymbols = stringToArray(string);
				return castSlice(strSymbols, charsStartIndex(strSymbols, stringToArray(chars))).join("");
			}
			function truncate(string, options) {
				var length$1 = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
				if (isObject$3(options)) {
					var separator = "separator" in options ? options.separator : separator;
					length$1 = "length" in options ? toInteger(options.length) : length$1;
					omission = "omission" in options ? baseToString(options.omission) : omission;
				}
				string = toString(string);
				var strLength = string.length;
				if (hasUnicode(string)) {
					var strSymbols = stringToArray(string);
					strLength = strSymbols.length;
				}
				if (length$1 >= strLength) return string;
				var end$1 = length$1 - stringSize(omission);
				if (end$1 < 1) return omission;
				var result$1 = strSymbols ? castSlice(strSymbols, 0, end$1).join("") : string.slice(0, end$1);
				if (separator === undefined$1) return result$1 + omission;
				if (strSymbols) end$1 += result$1.length - end$1;
				if (isRegExp$1(separator)) {
					if (string.slice(end$1).search(separator)) {
						var match$1, substring = result$1;
						if (!separator.global) separator = RegExp$1(separator.source, toString(reFlags.exec(separator)) + "g");
						separator.lastIndex = 0;
						while (match$1 = separator.exec(substring)) var newEnd = match$1.index;
						result$1 = result$1.slice(0, newEnd === undefined$1 ? end$1 : newEnd);
					}
				} else if (string.indexOf(baseToString(separator), end$1) != end$1) {
					var index = result$1.lastIndexOf(separator);
					if (index > -1) result$1 = result$1.slice(0, index);
				}
				return result$1 + omission;
			}
			function unescape$1(string) {
				string = toString(string);
				return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
			}
			var upperCase = createCompounder(function(result$1, word$1, index) {
				return result$1 + (index ? " " : "") + word$1.toUpperCase();
			});
			var upperFirst = createCaseFirst("toUpperCase");
			function words(string, pattern, guard$1) {
				string = toString(string);
				pattern = guard$1 ? undefined$1 : pattern;
				if (pattern === undefined$1) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
				return string.match(pattern) || [];
			}
			var attempt = baseRest(function(func, args$1) {
				try {
					return apply(func, undefined$1, args$1);
				} catch (e) {
					return isError(e) ? e : new Error$1(e);
				}
			});
			var bindAll = flatRest(function(object, methodNames) {
				arrayEach(methodNames, function(key) {
					key = toKey(key);
					baseAssignValue(object, key, bind(object[key], object));
				});
				return object;
			});
			function cond(pairs) {
				var length$1 = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
				pairs = !length$1 ? [] : arrayMap(pairs, function(pair) {
					if (typeof pair[1] != "function") throw new TypeError$1(FUNC_ERROR_TEXT);
					return [toIteratee(pair[0]), pair[1]];
				});
				return baseRest(function(args$1) {
					var index = -1;
					while (++index < length$1) {
						var pair = pairs[index];
						if (apply(pair[0], this, args$1)) return apply(pair[1], this, args$1);
					}
				});
			}
			function conforms(source) {
				return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
			}
			function constant(value) {
				return function() {
					return value;
				};
			}
			function defaultTo(value, defaultValue) {
				return value == null || value !== value ? defaultValue : value;
			}
			var flow = createFlow();
			var flowRight = createFlow(true);
			function identity(value) {
				return value;
			}
			function iteratee(func) {
				return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
			}
			function matches(source) {
				return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
			}
			function matchesProperty(path, srcValue) {
				return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
			}
			var method = baseRest(function(path, args$1) {
				return function(object) {
					return baseInvoke(object, path, args$1);
				};
			});
			var methodOf = baseRest(function(object, args$1) {
				return function(path) {
					return baseInvoke(object, path, args$1);
				};
			});
			function mixin(object, source, options) {
				var props = keys$1(source), methodNames = baseFunctions(source, props);
				if (options == null && !(isObject$3(source) && (methodNames.length || !props.length))) {
					options = source;
					source = object;
					object = this;
					methodNames = baseFunctions(source, keys$1(source));
				}
				var chain$1 = !(isObject$3(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
				arrayEach(methodNames, function(methodName) {
					var func = source[methodName];
					object[methodName] = func;
					if (isFunc) object.prototype[methodName] = function() {
						var chainAll = this.__chain__;
						if (chain$1 || chainAll) {
							var result$1 = object(this.__wrapped__);
							(result$1.__actions__ = copyArray(this.__actions__)).push({
								"func": func,
								"args": arguments,
								"thisArg": object
							});
							result$1.__chain__ = chainAll;
							return result$1;
						}
						return func.apply(object, arrayPush([this.value()], arguments));
					};
				});
				return object;
			}
			function noConflict() {
				if (root._ === this) root._ = oldDash;
				return this;
			}
			function noop() {}
			function nthArg(n) {
				n = toInteger(n);
				return baseRest(function(args$1) {
					return baseNth(args$1, n);
				});
			}
			var over = createOver(arrayMap);
			var overEvery = createOver(arrayEvery);
			var overSome = createOver(arraySome);
			function property(path) {
				return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
			}
			function propertyOf(object) {
				return function(path) {
					return object == null ? undefined$1 : baseGet(object, path);
				};
			}
			var range = createRange();
			var rangeRight = createRange(true);
			function stubArray() {
				return [];
			}
			function stubFalse() {
				return false;
			}
			function stubObject() {
				return {};
			}
			function stubString() {
				return "";
			}
			function stubTrue() {
				return true;
			}
			function times(n, iteratee$1) {
				n = toInteger(n);
				if (n < 1 || n > MAX_SAFE_INTEGER$1) return [];
				var index = MAX_ARRAY_LENGTH, length$1 = nativeMin(n, MAX_ARRAY_LENGTH);
				iteratee$1 = getIteratee(iteratee$1);
				n -= MAX_ARRAY_LENGTH;
				var result$1 = baseTimes(length$1, iteratee$1);
				while (++index < n) iteratee$1(index);
				return result$1;
			}
			function toPath(value) {
				if (isArray$2(value)) return arrayMap(value, toKey);
				return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
			}
			function uniqueId(prefix) {
				var id = ++idCounter$1;
				return toString(prefix) + id;
			}
			var add = createMathOperation(function(augend, addend) {
				return augend + addend;
			}, 0);
			var ceil = createRound("ceil");
			var divide = createMathOperation(function(dividend, divisor) {
				return dividend / divisor;
			}, 1);
			var floor$1 = createRound("floor");
			function max$2(array) {
				return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
			}
			function maxBy(array, iteratee$1) {
				return array && array.length ? baseExtremum(array, getIteratee(iteratee$1, 2), baseGt) : undefined$1;
			}
			function mean(array) {
				return baseMean(array, identity);
			}
			function meanBy(array, iteratee$1) {
				return baseMean(array, getIteratee(iteratee$1, 2));
			}
			function min$2(array) {
				return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
			}
			function minBy(array, iteratee$1) {
				return array && array.length ? baseExtremum(array, getIteratee(iteratee$1, 2), baseLt) : undefined$1;
			}
			var multiply = createMathOperation(function(multiplier, multiplicand) {
				return multiplier * multiplicand;
			}, 1);
			var round$1 = createRound("round");
			var subtract = createMathOperation(function(minuend, subtrahend) {
				return minuend - subtrahend;
			}, 0);
			function sum(array) {
				return array && array.length ? baseSum(array, identity) : 0;
			}
			function sumBy(array, iteratee$1) {
				return array && array.length ? baseSum(array, getIteratee(iteratee$1, 2)) : 0;
			}
			lodash.after = after;
			lodash.ary = ary;
			lodash.assign = assign;
			lodash.assignIn = assignIn;
			lodash.assignInWith = assignInWith;
			lodash.assignWith = assignWith;
			lodash.at = at;
			lodash.before = before;
			lodash.bind = bind;
			lodash.bindAll = bindAll;
			lodash.bindKey = bindKey;
			lodash.castArray = castArray;
			lodash.chain = chain;
			lodash.chunk = chunk;
			lodash.compact = compact;
			lodash.concat = concat;
			lodash.cond = cond;
			lodash.conforms = conforms;
			lodash.constant = constant;
			lodash.countBy = countBy;
			lodash.create = create$3;
			lodash.curry = curry;
			lodash.curryRight = curryRight;
			lodash.debounce = debounce$2;
			lodash.defaults = defaults;
			lodash.defaultsDeep = defaultsDeep;
			lodash.defer = defer;
			lodash.delay = delay;
			lodash.difference = difference;
			lodash.differenceBy = differenceBy;
			lodash.differenceWith = differenceWith;
			lodash.drop = drop;
			lodash.dropRight = dropRight;
			lodash.dropRightWhile = dropRightWhile;
			lodash.dropWhile = dropWhile;
			lodash.fill = fill;
			lodash.filter = filter;
			lodash.flatMap = flatMap;
			lodash.flatMapDeep = flatMapDeep;
			lodash.flatMapDepth = flatMapDepth;
			lodash.flatten = flatten;
			lodash.flattenDeep = flattenDeep;
			lodash.flattenDepth = flattenDepth;
			lodash.flip = flip$1;
			lodash.flow = flow;
			lodash.flowRight = flowRight;
			lodash.fromPairs = fromPairs;
			lodash.functions = functions;
			lodash.functionsIn = functionsIn;
			lodash.groupBy = groupBy$1;
			lodash.initial = initial;
			lodash.intersection = intersection;
			lodash.intersectionBy = intersectionBy;
			lodash.intersectionWith = intersectionWith;
			lodash.invert = invert;
			lodash.invertBy = invertBy;
			lodash.invokeMap = invokeMap;
			lodash.iteratee = iteratee;
			lodash.keyBy = keyBy;
			lodash.keys = keys$1;
			lodash.keysIn = keysIn;
			lodash.map = map$1;
			lodash.mapKeys = mapKeys;
			lodash.mapValues = mapValues;
			lodash.matches = matches;
			lodash.matchesProperty = matchesProperty;
			lodash.memoize = memoize;
			lodash.merge = merge;
			lodash.mergeWith = mergeWith;
			lodash.method = method;
			lodash.methodOf = methodOf;
			lodash.mixin = mixin;
			lodash.negate = negate;
			lodash.nthArg = nthArg;
			lodash.omit = omit;
			lodash.omitBy = omitBy;
			lodash.once = once;
			lodash.orderBy = orderBy;
			lodash.over = over;
			lodash.overArgs = overArgs;
			lodash.overEvery = overEvery;
			lodash.overSome = overSome;
			lodash.partial = partial;
			lodash.partialRight = partialRight;
			lodash.partition = partition;
			lodash.pick = pick;
			lodash.pickBy = pickBy;
			lodash.property = property;
			lodash.propertyOf = propertyOf;
			lodash.pull = pull;
			lodash.pullAll = pullAll;
			lodash.pullAllBy = pullAllBy;
			lodash.pullAllWith = pullAllWith;
			lodash.pullAt = pullAt;
			lodash.range = range;
			lodash.rangeRight = rangeRight;
			lodash.rearg = rearg;
			lodash.reject = reject;
			lodash.remove = remove;
			lodash.rest = rest;
			lodash.reverse = reverse;
			lodash.sampleSize = sampleSize;
			lodash.set = set;
			lodash.setWith = setWith;
			lodash.shuffle = shuffle;
			lodash.slice = slice;
			lodash.sortBy = sortBy;
			lodash.sortedUniq = sortedUniq;
			lodash.sortedUniqBy = sortedUniqBy;
			lodash.split = split;
			lodash.spread = spread;
			lodash.tail = tail;
			lodash.take = take;
			lodash.takeRight = takeRight;
			lodash.takeRightWhile = takeRightWhile;
			lodash.takeWhile = takeWhile;
			lodash.tap = tap;
			lodash.throttle = throttle$1;
			lodash.thru = thru;
			lodash.toArray = toArray;
			lodash.toPairs = toPairs;
			lodash.toPairsIn = toPairsIn;
			lodash.toPath = toPath;
			lodash.toPlainObject = toPlainObject;
			lodash.transform = transform;
			lodash.unary = unary;
			lodash.union = union;
			lodash.unionBy = unionBy;
			lodash.unionWith = unionWith;
			lodash.uniq = uniq;
			lodash.uniqBy = uniqBy;
			lodash.uniqWith = uniqWith;
			lodash.unset = unset;
			lodash.unzip = unzip;
			lodash.unzipWith = unzipWith;
			lodash.update = update;
			lodash.updateWith = updateWith;
			lodash.values = values;
			lodash.valuesIn = valuesIn;
			lodash.without = without;
			lodash.words = words;
			lodash.wrap = wrap;
			lodash.xor = xor;
			lodash.xorBy = xorBy;
			lodash.xorWith = xorWith;
			lodash.zip = zip;
			lodash.zipObject = zipObject;
			lodash.zipObjectDeep = zipObjectDeep;
			lodash.zipWith = zipWith;
			lodash.entries = toPairs;
			lodash.entriesIn = toPairsIn;
			lodash.extend = assignIn;
			lodash.extendWith = assignInWith;
			mixin(lodash, lodash);
			lodash.add = add;
			lodash.attempt = attempt;
			lodash.camelCase = camelCase;
			lodash.capitalize = capitalize$1;
			lodash.ceil = ceil;
			lodash.clamp = clamp$2;
			lodash.clone = clone$1;
			lodash.cloneDeep = cloneDeep$1;
			lodash.cloneDeepWith = cloneDeepWith;
			lodash.cloneWith = cloneWith;
			lodash.conformsTo = conformsTo;
			lodash.deburr = deburr;
			lodash.defaultTo = defaultTo;
			lodash.divide = divide;
			lodash.endsWith = endsWith;
			lodash.eq = eq;
			lodash.escape = escape$1;
			lodash.escapeRegExp = escapeRegExp;
			lodash.every = every$2;
			lodash.find = find;
			lodash.findIndex = findIndex;
			lodash.findKey = findKey;
			lodash.findLast = findLast;
			lodash.findLastIndex = findLastIndex;
			lodash.findLastKey = findLastKey;
			lodash.floor = floor$1;
			lodash.forEach = forEach;
			lodash.forEachRight = forEachRight;
			lodash.forIn = forIn;
			lodash.forInRight = forInRight;
			lodash.forOwn = forOwn;
			lodash.forOwnRight = forOwnRight;
			lodash.get = get;
			lodash.gt = gt;
			lodash.gte = gte;
			lodash.has = has;
			lodash.hasIn = hasIn;
			lodash.head = head;
			lodash.identity = identity;
			lodash.includes = includes;
			lodash.indexOf = indexOf;
			lodash.inRange = inRange;
			lodash.invoke = invoke;
			lodash.isArguments = isArguments;
			lodash.isArray = isArray$2;
			lodash.isArrayBuffer = isArrayBuffer;
			lodash.isArrayLike = isArrayLike;
			lodash.isArrayLikeObject = isArrayLikeObject;
			lodash.isBoolean = isBoolean;
			lodash.isBuffer = isBuffer;
			lodash.isDate = isDate;
			lodash.isElement = isElement$2;
			lodash.isEmpty = isEmpty;
			lodash.isEqual = isEqual$1;
			lodash.isEqualWith = isEqualWith;
			lodash.isError = isError;
			lodash.isFinite = isFinite$1;
			lodash.isFunction = isFunction;
			lodash.isInteger = isInteger$1;
			lodash.isLength = isLength;
			lodash.isMap = isMap;
			lodash.isMatch = isMatch$1;
			lodash.isMatchWith = isMatchWith;
			lodash.isNaN = isNaN$3;
			lodash.isNative = isNative;
			lodash.isNil = isNil;
			lodash.isNull = isNull;
			lodash.isNumber = isNumber;
			lodash.isObject = isObject$3;
			lodash.isObjectLike = isObjectLike;
			lodash.isPlainObject = isPlainObject$3;
			lodash.isRegExp = isRegExp$1;
			lodash.isSafeInteger = isSafeInteger;
			lodash.isSet = isSet;
			lodash.isString = isString;
			lodash.isSymbol = isSymbol;
			lodash.isTypedArray = isTypedArray;
			lodash.isUndefined = isUndefined;
			lodash.isWeakMap = isWeakMap;
			lodash.isWeakSet = isWeakSet;
			lodash.join = join;
			lodash.kebabCase = kebabCase;
			lodash.last = last;
			lodash.lastIndexOf = lastIndexOf;
			lodash.lowerCase = lowerCase;
			lodash.lowerFirst = lowerFirst;
			lodash.lt = lt;
			lodash.lte = lte;
			lodash.max = max$2;
			lodash.maxBy = maxBy;
			lodash.mean = mean;
			lodash.meanBy = meanBy;
			lodash.min = min$2;
			lodash.minBy = minBy;
			lodash.stubArray = stubArray;
			lodash.stubFalse = stubFalse;
			lodash.stubObject = stubObject;
			lodash.stubString = stubString;
			lodash.stubTrue = stubTrue;
			lodash.multiply = multiply;
			lodash.nth = nth;
			lodash.noConflict = noConflict;
			lodash.noop = noop;
			lodash.now = now;
			lodash.pad = pad;
			lodash.padEnd = padEnd;
			lodash.padStart = padStart;
			lodash.parseInt = parseInt$2;
			lodash.random = random$1;
			lodash.reduce = reduce;
			lodash.reduceRight = reduceRight;
			lodash.repeat = repeat$1;
			lodash.replace = replace;
			lodash.result = result;
			lodash.round = round$1;
			lodash.runInContext = runInContext;
			lodash.sample = sample;
			lodash.size = size$1;
			lodash.snakeCase = snakeCase;
			lodash.some = some$1;
			lodash.sortedIndex = sortedIndex;
			lodash.sortedIndexBy = sortedIndexBy$1;
			lodash.sortedIndexOf = sortedIndexOf;
			lodash.sortedLastIndex = sortedLastIndex;
			lodash.sortedLastIndexBy = sortedLastIndexBy;
			lodash.sortedLastIndexOf = sortedLastIndexOf;
			lodash.startCase = startCase;
			lodash.startsWith = startsWith;
			lodash.subtract = subtract;
			lodash.sum = sum;
			lodash.sumBy = sumBy;
			lodash.template = template;
			lodash.times = times;
			lodash.toFinite = toFinite;
			lodash.toInteger = toInteger;
			lodash.toLength = toLength;
			lodash.toLower = toLower;
			lodash.toNumber = toNumber;
			lodash.toSafeInteger = toSafeInteger;
			lodash.toString = toString;
			lodash.toUpper = toUpper;
			lodash.trim = trim;
			lodash.trimEnd = trimEnd;
			lodash.trimStart = trimStart;
			lodash.truncate = truncate;
			lodash.unescape = unescape$1;
			lodash.uniqueId = uniqueId;
			lodash.upperCase = upperCase;
			lodash.upperFirst = upperFirst;
			lodash.each = forEach;
			lodash.eachRight = forEachRight;
			lodash.first = head;
			mixin(lodash, function() {
				var source = {};
				baseForOwn(lodash, function(func, methodName) {
					if (!hasOwnProperty$2.call(lodash.prototype, methodName)) source[methodName] = func;
				});
				return source;
			}(), { "chain": false });
			lodash.VERSION = VERSION;
			arrayEach([
				"bind",
				"bindKey",
				"curry",
				"curryRight",
				"partial",
				"partialRight"
			], function(methodName) {
				lodash[methodName].placeholder = lodash;
			});
			arrayEach(["drop", "take"], function(methodName, index) {
				LazyWrapper.prototype[methodName] = function(n) {
					n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);
					var result$1 = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
					if (result$1.__filtered__) result$1.__takeCount__ = nativeMin(n, result$1.__takeCount__);
					else result$1.__views__.push({
						"size": nativeMin(n, MAX_ARRAY_LENGTH),
						"type": methodName + (result$1.__dir__ < 0 ? "Right" : "")
					});
					return result$1;
				};
				LazyWrapper.prototype[methodName + "Right"] = function(n) {
					return this.reverse()[methodName](n).reverse();
				};
			});
			arrayEach([
				"filter",
				"map",
				"takeWhile"
			], function(methodName, index) {
				var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
				LazyWrapper.prototype[methodName] = function(iteratee$1) {
					var result$1 = this.clone();
					result$1.__iteratees__.push({
						"iteratee": getIteratee(iteratee$1, 3),
						"type": type
					});
					result$1.__filtered__ = result$1.__filtered__ || isFilter;
					return result$1;
				};
			});
			arrayEach(["head", "last"], function(methodName, index) {
				var takeName = "take" + (index ? "Right" : "");
				LazyWrapper.prototype[methodName] = function() {
					return this[takeName](1).value()[0];
				};
			});
			arrayEach(["initial", "tail"], function(methodName, index) {
				var dropName = "drop" + (index ? "" : "Right");
				LazyWrapper.prototype[methodName] = function() {
					return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
				};
			});
			LazyWrapper.prototype.compact = function() {
				return this.filter(identity);
			};
			LazyWrapper.prototype.find = function(predicate) {
				return this.filter(predicate).head();
			};
			LazyWrapper.prototype.findLast = function(predicate) {
				return this.reverse().find(predicate);
			};
			LazyWrapper.prototype.invokeMap = baseRest(function(path, args$1) {
				if (typeof path == "function") return new LazyWrapper(this);
				return this.map(function(value) {
					return baseInvoke(value, path, args$1);
				});
			});
			LazyWrapper.prototype.reject = function(predicate) {
				return this.filter(negate(getIteratee(predicate)));
			};
			LazyWrapper.prototype.slice = function(start$1, end$1) {
				start$1 = toInteger(start$1);
				var result$1 = this;
				if (result$1.__filtered__ && (start$1 > 0 || end$1 < 0)) return new LazyWrapper(result$1);
				if (start$1 < 0) result$1 = result$1.takeRight(-start$1);
				else if (start$1) result$1 = result$1.drop(start$1);
				if (end$1 !== undefined$1) {
					end$1 = toInteger(end$1);
					result$1 = end$1 < 0 ? result$1.dropRight(-end$1) : result$1.take(end$1 - start$1);
				}
				return result$1;
			};
			LazyWrapper.prototype.takeRightWhile = function(predicate) {
				return this.reverse().takeWhile(predicate).reverse();
			};
			LazyWrapper.prototype.toArray = function() {
				return this.take(MAX_ARRAY_LENGTH);
			};
			baseForOwn(LazyWrapper.prototype, function(func, methodName) {
				var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
				if (!lodashFunc) return;
				lodash.prototype[methodName] = function() {
					var value = this.__wrapped__, args$1 = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee$1 = args$1[0], useLazy = isLazy || isArray$2(value);
					var interceptor = function(value$1) {
						var result$2 = lodashFunc.apply(lodash, arrayPush([value$1], args$1));
						return isTaker && chainAll ? result$2[0] : result$2;
					};
					if (useLazy && checkIteratee && typeof iteratee$1 == "function" && iteratee$1.length != 1) isLazy = useLazy = false;
					var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
					if (!retUnwrapped && useLazy) {
						value = onlyLazy ? value : new LazyWrapper(this);
						var result$1 = func.apply(value, args$1);
						result$1.__actions__.push({
							"func": thru,
							"args": [interceptor],
							"thisArg": undefined$1
						});
						return new LodashWrapper(result$1, chainAll);
					}
					if (isUnwrapped && onlyLazy) return func.apply(this, args$1);
					result$1 = this.thru(interceptor);
					return isUnwrapped ? isTaker ? result$1.value()[0] : result$1.value() : result$1;
				};
			});
			arrayEach([
				"pop",
				"push",
				"shift",
				"sort",
				"splice",
				"unshift"
			], function(methodName) {
				var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
				lodash.prototype[methodName] = function() {
					var args$1 = arguments;
					if (retUnwrapped && !this.__chain__) {
						var value = this.value();
						return func.apply(isArray$2(value) ? value : [], args$1);
					}
					return this[chainName](function(value$1) {
						return func.apply(isArray$2(value$1) ? value$1 : [], args$1);
					});
				};
			});
			baseForOwn(LazyWrapper.prototype, function(func, methodName) {
				var lodashFunc = lodash[methodName];
				if (lodashFunc) {
					var key = lodashFunc.name + "";
					if (!hasOwnProperty$2.call(realNames, key)) realNames[key] = [];
					realNames[key].push({
						"name": methodName,
						"func": lodashFunc
					});
				}
			});
			realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
				"name": "wrapper",
				"func": undefined$1
			}];
			LazyWrapper.prototype.clone = lazyClone;
			LazyWrapper.prototype.reverse = lazyReverse;
			LazyWrapper.prototype.value = lazyValue;
			lodash.prototype.at = wrapperAt;
			lodash.prototype.chain = wrapperChain;
			lodash.prototype.commit = wrapperCommit;
			lodash.prototype.next = wrapperNext;
			lodash.prototype.plant = wrapperPlant;
			lodash.prototype.reverse = wrapperReverse;
			lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
			lodash.prototype.first = lodash.prototype.head;
			if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
			return lodash;
		})();
		if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
			root._ = _$1;
			define(function() {
				return _$1;
			});
		} else if (freeModule) {
			(freeModule.exports = _$1)._ = _$1;
			freeExports._ = _$1;
		} else root._ = _$1;
	}).call(exports);
}));
var import_lodash$1 = require_lodash();
var normalizeAttrs = (attrs = {}) => {
	return Object.fromEntries(Object.entries(attrs).filter(([, value]) => value !== null && value !== void 0));
};
var stripUnsetInternalSnapshotAttrs = (attrs = {}) => {
	const nextAttrs = { ...attrs };
	if (nextAttrs.ooxmlHighlightClear === null || nextAttrs.ooxmlHighlightClear === void 0) delete nextAttrs.ooxmlHighlightClear;
	return nextAttrs;
};
const createMarkSnapshot = (type, attrs = {}) => {
	return {
		type,
		attrs: stripUnsetInternalSnapshotAttrs(attrs)
	};
};
var IDENTITY_ATTR_VALUES = {
	vertAlign: "baseline",
	position: "0pt"
};
var ATTRIBUTE_ONLY_MARKS = ["textStyle"];
var normalizeSnapshotAttrs = (attrs = {}) => {
	const base = normalizeAttrs(attrs);
	return Object.fromEntries(Object.entries(base).filter(([key, value]) => IDENTITY_ATTR_VALUES[key] !== value));
};
const getTypeName = (markLike) => {
	return markLike?.type?.name ?? markLike?.type;
};
const isTrackFormatNoOp = (before, after) => {
	const normalize$1 = (entries) => entries.map((s) => ({
		type: getTypeName(s),
		attrs: normalizeSnapshotAttrs(s.attrs || {})
	})).filter((s) => {
		if (ATTRIBUTE_ONLY_MARKS.includes(s.type) && Object.keys(s.attrs).length === 0) return false;
		return true;
	});
	const normBefore = normalize$1(before);
	const normAfter = normalize$1(after);
	if (normBefore.length === 0 && normAfter.length === 0) return true;
	if (normBefore.length !== normAfter.length) return false;
	return normBefore.every((b$1) => normAfter.some((a) => a.type === b$1.type && (0, import_lodash$1.isEqual)(a.attrs, b$1.attrs))) && normAfter.every((a) => normBefore.some((b$1) => b$1.type === a.type && (0, import_lodash$1.isEqual)(b$1.attrs, a.attrs)));
};
const attrsExactlyMatch = (left$1 = {}, right$1 = {}) => {
	return (0, import_lodash$1.isEqual)(normalizeAttrs(left$1), normalizeAttrs(right$1));
};
var marksMatch = (left$1, right$1, exact = true) => {
	if (!left$1 || !right$1 || getTypeName(left$1) !== getTypeName(right$1)) return false;
	if (!exact) return true;
	return attrsExactlyMatch(left$1.attrs || {}, right$1.attrs || {});
};
const markSnapshotMatchesStepMark = (snapshot, stepMark, exact = true) => {
	return marksMatch(snapshot, stepMark, exact);
};
const hasMatchingMark = (marks, stepMark) => {
	return marks.some((mark) => {
		return marksMatch(mark, stepMark, true);
	});
};
const upsertMarkSnapshotByType = (snapshots, incoming) => {
	const existing = snapshots.find((mark) => mark.type === incoming.type);
	if (existing) {
		const merged = {
			...existing,
			attrs: stripUnsetInternalSnapshotAttrs({
				...existing.attrs,
				...incoming.attrs
			})
		};
		return snapshots.map((mark) => mark === existing ? merged : mark);
	}
	return [...snapshots, createMarkSnapshot(incoming.type, incoming.attrs)];
};
var markMatchesSnapshot = (mark, snapshot, exact = true) => {
	return marksMatch(mark, snapshot, exact);
};
var markAttrsIncludeSnapshotAttrs = (mark, snapshot) => {
	if (!mark || !snapshot || mark.type.name !== snapshot.type) return false;
	const normalizedMarkAttrs = normalizeAttrs(mark.attrs || {});
	const normalizedSnapshotAttrs = normalizeAttrs(snapshot.attrs || {});
	if (Object.keys(normalizedSnapshotAttrs).length === 0) return false;
	return (0, import_lodash$1.isMatch)(normalizedMarkAttrs, normalizedSnapshotAttrs);
};
var markAttrsMatchOnOverlap = (mark, snapshot) => {
	if (!mark || !snapshot || mark.type.name !== snapshot.type) return false;
	if (!ATTRIBUTE_ONLY_MARKS.includes(snapshot.type)) return false;
	const normalizedMarkAttrs = normalizeAttrs(mark.attrs || {});
	const normalizedSnapshotAttrs = normalizeAttrs(snapshot.attrs || {});
	const markKeys$1 = Object.keys(normalizedMarkAttrs);
	const snapshotKeys = Object.keys(normalizedSnapshotAttrs);
	if (markKeys$1.length === 0 || snapshotKeys.length === 0) return false;
	const overlapKeys = markKeys$1.filter((key) => Object.prototype.hasOwnProperty.call(normalizedSnapshotAttrs, key));
	if (overlapKeys.length === 0) return false;
	return overlapKeys.every((key) => (0, import_lodash$1.isEqual)(normalizedMarkAttrs[key], normalizedSnapshotAttrs[key]));
};
const findMarkInRangeBySnapshot = ({ doc: doc$1, from: from$1, to, snapshot }) => {
	let exactMatch = null;
	let subsetMatch = null;
	let overlapMatch = null;
	let typeOnlyMatch = null;
	const normalizedSnapshotAttrs = normalizeAttrs(snapshot?.attrs || {});
	const shouldFallbackToTypeOnly = !(Object.keys(normalizedSnapshotAttrs).length > 0);
	doc$1.nodesBetween(from$1, to, (node) => {
		if (exactMatch) return false;
		if (!node.isInline) return;
		const exact = node.marks.find((mark) => markMatchesSnapshot(mark, snapshot, true));
		if (exact && !exactMatch) {
			exactMatch = exact;
			return false;
		}
		if (!subsetMatch) {
			const subset = node.marks.find((mark) => markAttrsIncludeSnapshotAttrs(mark, snapshot));
			if (subset) subsetMatch = subset;
		}
		if (!overlapMatch) {
			const overlap = node.marks.find((mark) => markAttrsMatchOnOverlap(mark, snapshot));
			if (overlap) overlapMatch = overlap;
		}
		if (!typeOnlyMatch) {
			const fallback = node.marks.find((mark) => markMatchesSnapshot(mark, snapshot, false));
			if (fallback) typeOnlyMatch = fallback;
		}
	});
	const liveMark = exactMatch || subsetMatch || overlapMatch || (shouldFallbackToTypeOnly ? typeOnlyMatch : null);
	if (!liveMark) console.debug("[track-changes] could not find live mark for snapshot", snapshot);
	return liveMark;
};
const getLiveInlineMarksInRange = ({ doc: doc$1, from: from$1, to }) => {
	const marks = [];
	const seen = /* @__PURE__ */ new Set();
	doc$1.nodesBetween(from$1, to, (node) => {
		if (!node.isInline) return;
		node.marks.forEach((mark) => {
			const key = `${mark.type.name}:${JSON.stringify(mark.attrs || {})}`;
			if (seen.has(key)) return;
			seen.add(key);
			marks.push(mark);
		});
	});
	return marks;
};
var SUPPORTED_KINDS = new Set([
	"text-insert",
	"text-delete",
	"text-replace",
	"format-apply",
	"format-remove"
]);
var EMPTY_STRUCTURAL_GAP_REFINEMENT_MAX_DISTANCE = 4;
const compileTrackedEdit = ({ state, tr, intent, replacements = "paired" }) => {
	if (!intent || !SUPPORTED_KINDS.has(intent.kind)) return failure$4("CAPABILITY_UNAVAILABLE", `Unsupported tracked edit kind ${intent?.kind ?? "unknown"}.`);
	const ctx$1 = makeContext({
		state,
		tr,
		intent,
		replacements
	});
	if (graphHasErrors(ctx$1.graph)) return failure$4("PRECONDITION_FAILED", "Tracked review graph has invariant errors before edit.", { diagnostics: ctx$1.graph.validate() });
	try {
		switch (intent.kind) {
			case "text-insert": return compileTextInsert(ctx$1, intent);
			case "text-delete": return compileTextDelete(ctx$1, intent);
			case "text-replace": return compileTextReplace(ctx$1, intent);
			case "format-apply":
			case "format-remove": return compileFormat(ctx$1, intent);
			default: return failure$4("CAPABILITY_UNAVAILABLE", "Unsupported tracked edit kind.");
		}
	} catch (error) {
		return failure$4("PRECONDITION_FAILED", error.message ?? "compile failed.", { error });
	}
};
var makeContext = ({ state, tr, intent, replacements }) => {
	return {
		state,
		tr,
		schema: state.schema,
		graph: buildReviewGraph({
			state: { doc: tr.doc },
			replacementsMode: replacements
		}),
		intent,
		replacements,
		currentIdentity: getCurrentUserIdentity({ options: { user: intent.user } }),
		createdChangeIds: [],
		updatedChangeIds: [],
		removedChangeIds: [],
		remappedChangeIds: [],
		diagnostics: []
	};
};
var failure$4 = (code, message, details) => ({
	ok: false,
	code,
	message,
	...details !== void 0 ? { details } : {}
});
var classifySegment = (ctx$1, segment) => {
	return isSameUserHighConfidence(classifyOwnership({
		currentUser: ctx$1.currentIdentity,
		change: getChangeAuthorIdentity(segment?.attrs ?? {})
	})) ? "same-user" : "different-user";
};
var isSameUserForRefinement = (ctx$1, segment) => {
	return matchesSameUserRefinement({
		currentUser: ctx$1.currentIdentity,
		change: getChangeAuthorIdentity(segment?.attrs ?? {})
	});
};
var findSegmentAt = (ctx$1, pos) => {
	const hits = ctx$1.graph.overlapAt(pos);
	if (hits.length) return hits[0];
	const left$1 = ctx$1.graph.segments.find((s) => s.to === pos);
	if (left$1) return left$1;
	return null;
};
var findSegmentAcrossEmptyStructuralGap = (ctx$1, pos) => {
	let nearest = null;
	for (const segment of ctx$1.graph.segments) {
		if (segment.to >= pos) continue;
		if (pos - segment.to > EMPTY_STRUCTURAL_GAP_REFINEMENT_MAX_DISTANCE) continue;
		if (!isEmptyStructuralGap(ctx$1, segment.to, pos)) continue;
		if (!nearest || segment.to > nearest.to) nearest = segment;
	}
	return nearest;
};
var findAdjacentInsertedSegment = (ctx$1, pos) => {
	const left$1 = ctx$1.graph.segments.find((segment) => segment.side === SegmentSide.Inserted && segment.to === pos && isSameUserForRefinement(ctx$1, segment));
	if (left$1) return left$1;
	return ctx$1.graph.segments.find((segment) => segment.side === SegmentSide.Inserted && segment.from === pos && isSameUserForRefinement(ctx$1, segment)) ?? null;
};
var findAdjacentDeletedSegment = (ctx$1, from$1, to) => {
	const sameUserDeleted = (segment) => segment.side === SegmentSide.Deleted && !segment.attrs?.replacementGroupId && !segment.attrs?.overlapParentId && isSameUserForRefinement(ctx$1, segment);
	const exactLeft = ctx$1.graph.segments.find((segment) => sameUserDeleted(segment) && segment.to === from$1);
	if (exactLeft) return exactLeft;
	const exactRight = ctx$1.graph.segments.find((segment) => sameUserDeleted(segment) && segment.from === to);
	if (exactRight) return exactRight;
	let nearest = null;
	let nearestDistance = Infinity;
	for (const segment of ctx$1.graph.segments) {
		if (!sameUserDeleted(segment)) continue;
		if (segment.from > to) {
			const distance = segment.from - to;
			if (distance < nearestDistance && isCoalescibleDeletionGap(ctx$1, to, segment.from)) {
				nearest = segment;
				nearestDistance = distance;
			}
		} else if (segment.to < from$1) {
			const distance = from$1 - segment.to;
			if (distance < nearestDistance && isCoalescibleDeletionGap(ctx$1, segment.to, from$1)) {
				nearest = segment;
				nearestDistance = distance;
			}
		}
	}
	return nearest;
};
var isEmptyStructuralGap = (ctx$1, from$1, to) => {
	if (to <= from$1) return false;
	if (!sharesTextblock(ctx$1.tr.doc, from$1, to)) return false;
	if (ctx$1.graph.segmentsInRange(from$1, to).length) return false;
	if (ctx$1.tr.doc.textBetween(from$1, to, "", "")) return false;
	let hasInlineLeaf = false;
	ctx$1.tr.doc.nodesBetween(from$1, to, (node, pos) => {
		if (pos < from$1 || pos >= to) return;
		if (node.isInline && node.isLeaf) {
			hasInlineLeaf = true;
			return false;
		}
	});
	return !hasInlineLeaf;
};
var ZERO_WIDTH_ANCHOR_NODE_NAMES = new Set([
	"commentRangeStart",
	"commentRangeEnd",
	"commentReference",
	"bookmarkEnd",
	"permStart",
	"permEnd"
]);
var isCoalescibleDeletionGap = (ctx$1, from$1, to) => {
	if (to <= from$1) return false;
	if (!sharesTextblock(ctx$1.tr.doc, from$1, to)) return false;
	if (ctx$1.graph.segmentsInRange(from$1, to).length) return false;
	if (ctx$1.tr.doc.textBetween(from$1, to, "", "")) return false;
	let blocked = false;
	ctx$1.tr.doc.nodesBetween(from$1, to, (node, pos) => {
		if (pos < from$1 || pos >= to) return;
		if (node.isInline && node.isLeaf && !ZERO_WIDTH_ANCHOR_NODE_NAMES.has(node.type.name)) {
			blocked = true;
			return false;
		}
	});
	return !blocked;
};
var sharesTextblock = (doc$1, from$1, to) => {
	const left$1 = textblockStart(doc$1, from$1);
	const right$1 = textblockStart(doc$1, to);
	return left$1 !== null && left$1 === right$1;
};
var textblockStart = (doc$1, pos) => {
	const resolved = doc$1.resolve(Math.max(0, Math.min(doc$1.content.size, pos)));
	for (let depth = resolved.depth; depth > 0; depth -= 1) if (resolved.node(depth).isTextblock) return resolved.start(depth);
	return null;
};
var segmentsInRange = (ctx$1, from$1, to) => ctx$1.graph.segmentsInRange(from$1, to);
var insertSchema = (ctx$1) => ctx$1.schema.marks[TrackInsertMarkName];
var deleteSchema = (ctx$1) => ctx$1.schema.marks[TrackDeleteMarkName];
var makeInsertMark = (ctx$1, { id, overlapParentId = "", replacementGroupId = "", replacementSideId = "" }) => {
	const attrs = {
		id,
		author: ctx$1.intent.user.name || "",
		authorId: ctx$1.intent.user.id || "",
		authorEmail: ctx$1.intent.user.email || "",
		authorImage: ctx$1.intent.user.image || "",
		date: ctx$1.intent.date,
		sourceId: "",
		importedAuthor: "",
		revisionGroupId: id,
		splitFromId: "",
		changeType: replacementGroupId ? CanonicalChangeType.Replacement : CanonicalChangeType.Insertion,
		replacementGroupId,
		replacementSideId,
		overlapParentId,
		sourceIds: null,
		origin: ""
	};
	return insertSchema(ctx$1).create(attrs);
};
var makeDeleteMark = (ctx$1, { id, overlapParentId = "", replacementGroupId = "", replacementSideId = "" }) => {
	const attrs = {
		id,
		author: ctx$1.intent.user.name || "",
		authorId: ctx$1.intent.user.id || "",
		authorEmail: ctx$1.intent.user.email || "",
		authorImage: ctx$1.intent.user.image || "",
		date: ctx$1.intent.date,
		sourceId: "",
		importedAuthor: "",
		revisionGroupId: id,
		splitFromId: "",
		changeType: replacementGroupId ? CanonicalChangeType.Replacement : CanonicalChangeType.Deletion,
		replacementGroupId,
		replacementSideId,
		overlapParentId,
		sourceIds: null,
		origin: ""
	};
	return deleteSchema(ctx$1).create(attrs);
};
var stripTrackedMarksFromSlice = (slice, schema) => {
	if (!slice || slice === Slice.empty) return slice;
	const trackedMarkNames = new Set([
		TrackInsertMarkName,
		TrackDeleteMarkName,
		TrackFormatMarkName
	]);
	const stripFragment = (fragment) => {
		const children = [];
		for (let i = 0; i < fragment.childCount; i += 1) {
			const child = fragment.child(i);
			if (child.isText) {
				const filtered = child.marks.filter((mark) => !trackedMarkNames.has(mark.type.name));
				children.push(filtered.length === child.marks.length ? child : child.mark(filtered));
			} else if (child.content?.childCount) children.push(child.copy(stripFragment(child.content)));
			else children.push(child);
		}
		return Fragment$1.from(children);
	};
	return new Slice(stripFragment(slice.content), slice.openStart, slice.openEnd);
};
var compileTextInsert = (ctx$1, intent) => {
	const { at, content } = intent;
	const docSize = ctx$1.tr.doc.content.size;
	if (at < 0 || at > docSize) return failure$4("INVALID_TARGET", `text-insert position ${at} out of range [0, ${docSize}].`);
	const sanitizedSlice = stripTrackedMarksFromSlice(content ?? Slice.empty, ctx$1.schema);
	if (!sanitizedSlice.content.size) return failure$4("INVALID_TARGET", "text-insert requires non-empty content.");
	const containing = findContainingSegment(ctx$1, at);
	const overlapParent = containing && containing.from < at && containing.to > at ? containing : null;
	const boundaryAdjacent = !overlapParent && containing && (containing.to === at || containing.from === at) ? containing : null;
	const emptyGapAdjacent = !overlapParent && !boundaryAdjacent ? findSegmentAcrossEmptyStructuralGap(ctx$1, at) : null;
	const exactAdjacentInserted = findAdjacentInsertedSegment(ctx$1, at);
	const refinementTarget = exactAdjacentInserted ? exactAdjacentInserted : overlapParent && overlapParent.side === SegmentSide.Inserted && isSameUserForRefinement(ctx$1, overlapParent) ? overlapParent : boundaryAdjacent && boundaryAdjacent.side === SegmentSide.Inserted && isSameUserForRefinement(ctx$1, boundaryAdjacent) ? boundaryAdjacent : emptyGapAdjacent && emptyGapAdjacent.side === SegmentSide.Inserted && isSameUserForRefinement(ctx$1, emptyGapAdjacent) ? emptyGapAdjacent : null;
	if (refinementTarget) {
		const refinedId = refinementTarget.changeId;
		return applyInsert(ctx$1, at, sanitizedSlice, makeInsertMark(ctx$1, {
			id: refinedId,
			overlapParentId: refinementTarget.attrs.overlapParentId || "",
			replacementGroupId: refinementTarget.attrs.replacementGroupId || "",
			replacementSideId: refinementTarget.attrs.replacementSideId || ""
		}), refinedId, { update: true });
	}
	if (overlapParent) {
		const childId = intent.replacementGroupHint || v4_default();
		const overlapParentId = overlapParent.changeId;
		return applyInsert(ctx$1, at, sanitizedSlice, makeInsertMark(ctx$1, {
			id: childId,
			overlapParentId
		}), childId, { create: true });
	}
	const newId = intent.replacementGroupHint || v4_default();
	return applyInsert(ctx$1, at, sanitizedSlice, makeInsertMark(ctx$1, { id: newId }), newId, { create: true });
};
var applyInsert = (ctx$1, at, slice, insertMark, changeId, { update, create: create$3 }) => {
	const beforeSize = ctx$1.tr.doc.content.size;
	try {
		ctx$1.tr.replaceRange(at, at, slice);
	} catch (error) {
		return failure$4("INVALID_TARGET", error.message ?? "replaceRange failed.");
	}
	const afterSize = ctx$1.tr.doc.content.size;
	if (afterSize === beforeSize) return failure$4("INVALID_TARGET", "text-insert did not change the document.");
	const insertedFrom = at;
	const insertedTo = at + (afterSize - beforeSize);
	ctx$1.tr.addMark(insertedFrom, insertedTo, insertMark);
	if (create$3) ctx$1.createdChangeIds.push(changeId);
	else if (update) ctx$1.updatedChangeIds.push(changeId);
	const insertedNodes = [];
	ctx$1.tr.doc.nodesBetween(insertedFrom, insertedTo, (node) => {
		if (node.isInline) insertedNodes.push(node);
	});
	return {
		ok: true,
		tr: ctx$1.tr,
		createdChangeIds: ctx$1.createdChangeIds,
		updatedChangeIds: ctx$1.updatedChangeIds,
		removedChangeIds: ctx$1.removedChangeIds,
		remappedChangeIds: ctx$1.remappedChangeIds,
		selection: {
			kind: "near",
			pos: insertedTo,
			bias: 1
		},
		insertedMark: insertMark,
		insertedFrom,
		insertedTo,
		insertedNodes
	};
};
var compileTextDelete = (ctx$1, intent) => {
	const docSize = ctx$1.tr.doc.content.size;
	if (intent.from < 0 || intent.to > docSize) return failure$4("INVALID_TARGET", `text-delete range [${intent.from}, ${intent.to}] out of bounds.`);
	if (intent.from === intent.to) return failure$4("INVALID_TARGET", "text-delete requires a non-empty range.");
	const coalesceTarget = intent.replacementGroupHint || intent.preserveExistingReviewState ? null : findAdjacentDeletedSegment(ctx$1, intent.from, intent.to);
	const sharedDeletionId = intent.replacementGroupHint || coalesceTarget?.changeId || null;
	const result = applyTrackedDelete(ctx$1, intent.from, intent.to, {
		replacementGroupId: "",
		replacementSideId: "",
		sharedDeletionId,
		recordSharedDeletionId: Boolean(intent.replacementGroupHint),
		reassignExistingDeletions: intent.source !== "native" && !intent.preserveExistingReviewState ? "different-user" : false
	});
	if (result.ok === false) return result;
	if (coalesceTarget && !ctx$1.updatedChangeIds.includes(coalesceTarget.changeId)) ctx$1.updatedChangeIds.push(coalesceTarget.changeId);
	return {
		ok: true,
		tr: ctx$1.tr,
		createdChangeIds: ctx$1.createdChangeIds,
		updatedChangeIds: ctx$1.updatedChangeIds,
		removedChangeIds: ctx$1.removedChangeIds,
		remappedChangeIds: ctx$1.remappedChangeIds,
		selection: {
			kind: "near",
			pos: intent.from,
			bias: -1
		},
		deletionMark: result.deletionMarks[0] || null,
		deletionMarks: result.deletionMarks,
		deletionNodes: result.deletionNodes
	};
};
var applyTrackedDelete = (ctx$1, from$1, to, { replacementGroupId, replacementSideId, sharedDeletionId, recordSharedDeletionId = false, recordCollapsedIds = true, reassignExistingDeletions = false }) => {
	const deletionMarks = [];
	const deletionNodes = [];
	const ops = [];
	const isImportedOwnInsertion = (mark) => {
		if (!mark) return false;
		return shouldCollapseNoEmailInsertion({
			currentUser: ctx$1.intent.user,
			insertionAttrs: mark.attrs
		});
	};
	ctx$1.tr.doc.nodesBetween(from$1, to, (node, pos) => {
		if (!node.isInline || !node.isLeaf) return;
		if (node.type.name.includes("table")) return;
		const segFrom = Math.max(from$1, pos);
		const segTo = Math.min(to, pos + node.nodeSize);
		if (segFrom >= segTo) return;
		const insertMark = node.marks.find((m$1) => m$1.type.name === TrackInsertMarkName);
		const existingDelete = node.marks.find((m$1) => m$1.type.name === TrackDeleteMarkName);
		if (insertMark) {
			const segmentAtPos = ctx$1.graph.overlapAt(pos)[0] ?? null;
			const ownership = isSameUserHighConfidence(classifyOwnership({
				currentUser: ctx$1.currentIdentity,
				change: getChangeAuthorIdentity(segmentAtPos?.attrs ?? insertMark.attrs)
			})) ? "same-user" : "different-user";
			if (!ctx$1.intent.preserveExistingReviewState && (ownership === "same-user" || isImportedOwnInsertion(insertMark))) {
				ops.push({
					kind: "collapse",
					from: segFrom,
					to: segTo,
					changeId: insertMark.attrs.id
				});
				return;
			}
			const parentId = insertMark.attrs.id;
			ops.push({
				kind: "mark-delete",
				from: segFrom,
				to: segTo,
				node,
				parentId,
				parentSide: SegmentSide.Inserted
			});
			return;
		}
		if (existingDelete) {
			const allExistingDeletes = node.marks.filter((m$1) => m$1.type.name === TrackDeleteMarkName);
			const isDifferentUserDeletion = !isSameUserHighConfidence(classifyOwnership({
				currentUser: ctx$1.currentIdentity,
				change: getChangeAuthorIdentity(existingDelete.attrs)
			}));
			if (reassignExistingDeletions === "all" || reassignExistingDeletions === "different-user" && isDifferentUserDeletion) {
				ops.push({
					kind: "reassign",
					from: segFrom,
					to: segTo,
					node,
					parentId: existingDelete.attrs.id || existingDelete.attrs.overlapParentId || "",
					existingDeleteMarks: allExistingDeletes
				});
				return;
			}
			ops.push({
				kind: "noop",
				from: segFrom,
				to: segTo
			});
			return;
		}
		ops.push({
			kind: "mark-delete",
			from: segFrom,
			to: segTo,
			node
		});
	});
	if (!ops.length) return failure$4("CAPABILITY_UNAVAILABLE", `text-delete range [${from$1}, ${to}] has no inline text content to track.`);
	const sortedOps = [...ops].sort((a, b$1) => b$1.from - a.from);
	const deletionId = sharedDeletionId ?? v4_default();
	let mintedThisCall = false;
	const collapsedIds = /* @__PURE__ */ new Set();
	for (const op of sortedOps) {
		if (op.kind === "collapse") {
			try {
				ctx$1.tr.replaceRange(op.from, op.to, Slice.empty);
			} catch {
				return failure$4("INVALID_TARGET", `Cannot collapse own-insertion range [${op.from}, ${op.to}].`);
			}
			if (op.changeId) collapsedIds.add(op.changeId);
			continue;
		}
		if (op.kind === "noop") continue;
		if (op.kind === "reassign") {
			const mark = makeDeleteMark(ctx$1, {
				id: deletionId,
				overlapParentId: op.parentId || "",
				replacementGroupId,
				replacementSideId
			});
			try {
				for (const m$1 of op.existingDeleteMarks ?? []) ctx$1.tr.removeMark(op.from, op.to, m$1);
				ctx$1.tr.addMark(op.from, op.to, mark);
				deletionMarks.push(mark);
				if (op.node) deletionNodes.push(op.node);
				if (!mintedThisCall) {
					if (!sharedDeletionId || recordSharedDeletionId) ctx$1.createdChangeIds.push(deletionId);
					mintedThisCall = true;
				}
			} catch (error) {
				return failure$4("INVALID_TARGET", error.message ?? "addMark failed.");
			}
			continue;
		}
		if (op.kind === "mark-delete") {
			const mark = makeDeleteMark(ctx$1, {
				id: deletionId,
				overlapParentId: op.parentId || "",
				replacementGroupId,
				replacementSideId
			});
			try {
				ctx$1.tr.addMark(op.from, op.to, mark);
				deletionMarks.push(mark);
				if (op.node) deletionNodes.push(op.node);
				if (!mintedThisCall) {
					if (!sharedDeletionId || recordSharedDeletionId) ctx$1.createdChangeIds.push(deletionId);
					mintedThisCall = true;
				}
			} catch (error) {
				return failure$4("INVALID_TARGET", error.message ?? "addMark failed.");
			}
		}
	}
	if (recordCollapsedIds && collapsedIds.size) {
		const finalGraph = buildReviewGraph({
			state: { doc: ctx$1.tr.doc },
			replacementsMode: ctx$1.replacements
		});
		for (const id of collapsedIds) if (finalGraph.changes.has(id)) ctx$1.updatedChangeIds.push(id);
		else ctx$1.removedChangeIds.push(id);
	}
	return {
		ok: true,
		deletionMarks,
		deletionNodes,
		deletionId,
		mintedThisCall
	};
};
var compileTextReplace = (ctx$1, intent) => {
	const docSize = ctx$1.tr.doc.content.size;
	if (intent.from < 0 || intent.to > docSize) return failure$4("INVALID_TARGET", `text-replace range [${intent.from}, ${intent.to}] out of bounds.`);
	if (intent.from > intent.to) return failure$4("INVALID_TARGET", "text-replace `from` must be <= `to`.");
	const sanitizedSlice = stripTrackedMarksFromSlice(intent.content ?? Slice.empty, ctx$1.schema);
	if (!sanitizedSlice.content.size && intent.from === intent.to) return failure$4("INVALID_TARGET", "text-replace requires a non-empty replacement or non-empty range.");
	const segments = segmentsInRange(ctx$1, intent.from, intent.to);
	const ownInsertedTarget = getSingleFullyCoveringOwnInsertedSegment(ctx$1, segments, intent.from, intent.to);
	if (ownInsertedTarget && !intent.preserveExistingReviewState) {
		const deleteResult = applyTrackedDelete(ctx$1, intent.from, intent.to, {
			replacementGroupId: "",
			replacementSideId: "",
			sharedDeletionId: null,
			recordCollapsedIds: false
		});
		if (deleteResult.ok === false) return deleteResult;
		if (!sanitizedSlice.content.size) {
			ctx$1.updatedChangeIds.push(ownInsertedTarget.changeId);
			return {
				ok: true,
				tr: ctx$1.tr,
				createdChangeIds: ctx$1.createdChangeIds,
				updatedChangeIds: ctx$1.updatedChangeIds,
				removedChangeIds: ctx$1.removedChangeIds,
				remappedChangeIds: ctx$1.remappedChangeIds,
				selection: {
					kind: "near",
					pos: intent.from,
					bias: -1
				}
			};
		}
		const insertMark = makeInsertMark(ctx$1, {
			id: ownInsertedTarget.changeId,
			overlapParentId: ownInsertedTarget.attrs.overlapParentId || "",
			replacementGroupId: ownInsertedTarget.attrs.replacementGroupId || "",
			replacementSideId: ownInsertedTarget.attrs.replacementSideId || ""
		});
		return applyInsert(ctx$1, clampToDocSize(ctx$1.tr.doc.content.size, intent.from), sanitizedSlice, insertMark, ownInsertedTarget.changeId, { update: true });
	}
	if (segments.length > 0 && segments.every((s) => s.side === SegmentSide.Deleted && classifySegment(ctx$1, s) === "same-user" && s.from <= intent.from && s.to >= intent.to) && sanitizedSlice.content.size) {
		const insertId = v4_default();
		const insertMark = makeInsertMark(ctx$1, { id: insertId });
		return applyInsert(ctx$1, intent.from, sanitizedSlice, insertMark, insertId, { create: true });
	}
	return compileOrdinaryTextReplace(ctx$1, intent, sanitizedSlice, getReplacementParentId(ctx$1, segments));
};
var compileOrdinaryTextReplace = (ctx$1, intent, sanitizedSlice, replacementParentId) => {
	const sharedId = intent.replacements === "paired" && !replacementParentId ? intent.replacementGroupHint || v4_default() : null;
	const replacementGroupId = sharedId ?? "";
	let positionTo = replacementParentId ? intent.from : intent.to;
	if (intent.from !== intent.to && intent.probeForDeletionSpan) {
		const probePos = Math.max(intent.from, intent.to - 1);
		const deletionSpan = findMarkPosition(ctx$1.tr.doc, probePos, TrackDeleteMarkName);
		if (!replacementParentId && deletionSpan && deletionSpan.to > positionTo) positionTo = deletionSpan.to;
	}
	const baseParentIsTextblock = ctx$1.tr.doc.resolve(positionTo).parent?.isTextblock;
	const shouldPreferInlineInsertion = intent.from === intent.to && baseParentIsTextblock;
	const tryTempInsert = (slice) => {
		const tempTr = ctx$1.state.apply(ctx$1.tr).tr;
		const isEmptySlice = !slice || slice.content.size === 0;
		try {
			tempTr.replaceRange(positionTo, positionTo, slice ?? Slice.empty);
		} catch {
			return null;
		}
		if (!tempTr.docChanged && !isEmptySlice) return null;
		const insertedFrom = tempTr.mapping.map(positionTo, -1);
		const insertedTo = tempTr.mapping.map(positionTo, 1);
		if (insertedFrom === insertedTo) return {
			tempTr,
			insertedFrom,
			insertedTo
		};
		if (shouldPreferInlineInsertion && !tempTr.doc.resolve(insertedFrom).parent?.isTextblock) return null;
		return {
			tempTr,
			insertedFrom,
			insertedTo
		};
	};
	let insertion = null;
	if (sanitizedSlice.content.size) {
		const openSlice = Slice.maxOpen(sanitizedSlice.content, true);
		insertion = tryTempInsert(sanitizedSlice) || tryTempInsert(openSlice);
		if (!insertion) return failure$4("CAPABILITY_UNAVAILABLE", "replacement slice could not be inserted into the document.");
	}
	let insertedMark = null;
	let trackedInsertedSlice = Slice.empty;
	const insertedNodes = [];
	if (insertion && insertion.insertedFrom !== insertion.insertedTo) {
		const { tempTr, insertedFrom, insertedTo } = insertion;
		const forcedInsertId = sharedId || (replacementParentId ? v4_default() : void 0);
		insertedMark = markInsertion({
			tr: tempTr,
			from: insertedFrom,
			to: insertedTo,
			user: ctx$1.intent.user,
			date: ctx$1.intent.date,
			id: forcedInsertId
		});
		if (!insertedMark) return failure$4("PRECONDITION_FAILED", "Failed to create tracked insertion mark for replacement.");
		if (replacementParentId || replacementGroupId) {
			const overlayMark = makeInsertMark(ctx$1, {
				id: insertedMark.attrs.id,
				overlapParentId: replacementParentId,
				replacementGroupId,
				replacementSideId: sharedId ? `${sharedId}#inserted` : ""
			});
			tempTr.removeMark(insertedFrom, insertedTo, insertedMark);
			tempTr.addMark(insertedFrom, insertedTo, overlayMark);
			insertedMark = overlayMark;
		}
		const insertId = insertedMark.attrs.id;
		if (!ctx$1.createdChangeIds.includes(insertId) && !ctx$1.updatedChangeIds.includes(insertId)) ctx$1.createdChangeIds.push(insertId);
		trackedInsertedSlice = tempTr.doc.slice(insertedFrom, insertedTo);
		tempTr.doc.nodesBetween(insertedFrom, insertedTo, (node) => {
			if (node.isInline) insertedNodes.push(node);
		});
	}
	let insertedFromAbs = positionTo;
	let insertedToAbs = positionTo;
	let insertedLength = 0;
	let condensedStep = null;
	if (trackedInsertedSlice && trackedInsertedSlice.content.size) {
		const stepIndexBeforeCondensed = ctx$1.tr.steps.length;
		condensedStep = new ReplaceStep(positionTo, positionTo, trackedInsertedSlice, false);
		if (ctx$1.tr.maybeStep(condensedStep).failed) return failure$4("INVALID_TARGET", "condensed insertion step failed to apply.");
		const condensedMap = ctx$1.tr.steps[stepIndexBeforeCondensed].getMap();
		insertedFromAbs = condensedMap.map(positionTo, -1);
		insertedToAbs = condensedMap.map(positionTo, 1);
		insertedLength = insertedToAbs - insertedFromAbs;
	}
	let deletionMarks = [];
	let deletionNodes = [];
	let deletionMark = null;
	if (intent.from !== intent.to) {
		const stepsBefore = ctx$1.tr.steps.length;
		const delResult = applyTrackedDelete(ctx$1, insertedLength > 0 && positionTo <= intent.from ? intent.from + insertedLength : intent.from, insertedLength > 0 && positionTo <= intent.from ? intent.to + insertedLength : intent.to, {
			replacementGroupId,
			replacementSideId: sharedId ? `${sharedId}#deleted` : "",
			sharedDeletionId: sharedId,
			reassignExistingDeletions: sharedId || replacementParentId ? "all" : false
		});
		if (delResult.ok === false) return delResult;
		deletionMarks = delResult.deletionMarks;
		deletionMark = delResult.deletionMarks[0] || null;
		deletionNodes = delResult.deletionNodes;
		if (insertedLength > 0) {
			const delMapping = new Mapping();
			for (let i = stepsBefore; i < ctx$1.tr.steps.length; i += 1) delMapping.appendMap(ctx$1.tr.steps[i].getMap());
			insertedFromAbs = delMapping.map(insertedFromAbs, 1);
			insertedToAbs = delMapping.map(insertedToAbs, 1);
		}
	}
	const selection = insertedLength > 0 ? {
		kind: "near",
		pos: insertedToAbs,
		bias: 1
	} : {
		kind: "near",
		pos: intent.from,
		bias: -1
	};
	return {
		ok: true,
		tr: ctx$1.tr,
		createdChangeIds: ctx$1.createdChangeIds,
		updatedChangeIds: ctx$1.updatedChangeIds,
		removedChangeIds: ctx$1.removedChangeIds,
		remappedChangeIds: ctx$1.remappedChangeIds,
		selection,
		insertedMark,
		insertedFrom: insertedFromAbs,
		insertedTo: insertedToAbs,
		insertedNodes,
		insertedStep: condensedStep,
		deletionMark,
		deletionMarks,
		deletionNodes
	};
};
var clampToDocSize = (size$1, pos) => Math.max(0, Math.min(size$1, pos));
var getSingleFullyCoveringOwnInsertedSegment = (ctx$1, segments, from$1, to) => {
	if (!segments.length) return null;
	const inserted = segments.filter((s) => s.side === SegmentSide.Inserted && classifySegment(ctx$1, s) === "same-user" && s.from <= from$1 && s.to >= to);
	if (inserted.length !== segments.length) return null;
	const [first$1] = inserted;
	if (!first$1) return null;
	return inserted.every((s) => s.changeId === first$1.changeId) ? first$1 : null;
};
var getReplacementParentId = (ctx$1, segments) => {
	for (const segment of segments) {
		if (classifySegment(ctx$1, segment) !== "different-user") continue;
		if (segment.attrs?.overlapParentId) return segment.attrs.overlapParentId;
		return segment.changeId || "";
	}
	return "";
};
var compileFormat = (ctx$1, intent) => {
	if (!TrackedFormatMarkNames.includes(intent.mark.type.name)) return failure$4("CAPABILITY_UNAVAILABLE", `Mark ${intent.mark.type.name} is not a tracked formatting mark.`);
	const subranges = computeFormatLeafRanges(ctx$1, intent.from, intent.to);
	if (!subranges) return failure$4("CAPABILITY_UNAVAILABLE", "format range crosses tracked-deleted content.");
	const trackFormatType = ctx$1.schema.marks[TrackFormatMarkName];
	const needsTrackFormat = subranges.some((range) => !range.fold);
	if (!trackFormatType && needsTrackFormat) return failure$4("CAPABILITY_UNAVAILABLE", "schema is missing trackFormat mark.");
	const formatMarks = [];
	let sharedWid = null;
	for (const range of subranges) {
		if (range.fold) {
			if (intent.kind === "format-apply") ctx$1.tr.addMark(range.from, range.to, intent.mark);
			else ctx$1.tr.removeMark(range.from, range.to, intent.mark);
			continue;
		}
		const result = applyTrackedFormatRange({
			ctx: ctx$1,
			intent,
			range,
			trackFormatType,
			sharedWid
		});
		sharedWid = result.sharedWid;
		if (result.formatMark) {
			formatMarks.push(result.formatMark);
			if (!ctx$1.createdChangeIds.includes(result.formatMark.attrs.id)) ctx$1.createdChangeIds.push(result.formatMark.attrs.id);
		}
	}
	return {
		ok: true,
		tr: ctx$1.tr,
		createdChangeIds: ctx$1.createdChangeIds,
		updatedChangeIds: ctx$1.updatedChangeIds,
		removedChangeIds: ctx$1.removedChangeIds,
		remappedChangeIds: ctx$1.remappedChangeIds,
		formatMarks
	};
};
var computeFormatLeafRanges = (ctx$1, from$1, to) => {
	const ranges = [];
	let touchesDeletion = false;
	ctx$1.tr.doc.nodesBetween(from$1, to, (node, pos) => {
		if (touchesDeletion) return false;
		if (!node.isInline || node.type.name === "run") return;
		const segFrom = Math.max(from$1, pos);
		const segTo = Math.min(to, pos + node.nodeSize);
		if (segFrom >= segTo) return;
		if (node.marks.find((m$1) => m$1.type.name === "trackDelete")) {
			touchesDeletion = true;
			return false;
		}
		const insertMark = node.marks.find((m$1) => m$1.type.name === TrackInsertMarkName);
		if (insertMark) {
			const ownership = classifySegment(ctx$1, { attrs: insertMark.attrs });
			ranges.push({
				from: segFrom,
				to: segTo,
				fold: ownership === "same-user",
				...ownership === "same-user" ? {} : { parentId: insertMark.attrs.id },
				node
			});
			return;
		}
		ranges.push({
			from: segFrom,
			to: segTo,
			fold: false,
			node
		});
	});
	if (touchesDeletion) return null;
	return ranges;
};
var applyTrackedFormatRange = ({ ctx: ctx$1, intent, range, trackFormatType, sharedWid }) => {
	if (intent.kind === "format-apply") return applyTrackedFormatAdd({
		ctx: ctx$1,
		intent,
		range,
		trackFormatType,
		sharedWid
	});
	return applyTrackedFormatRemove({
		ctx: ctx$1,
		intent,
		range,
		trackFormatType,
		sharedWid
	});
};
var applyTrackedFormatAdd = ({ ctx: ctx$1, intent, range, trackFormatType, sharedWid }) => {
	const liveMarks = getLiveInlineMarksInRange({
		doc: ctx$1.tr.doc,
		from: range.from,
		to: range.to
	});
	const existingChangeMark = liveMarks.find((mark) => [TrackDeleteMarkName, TrackFormatMarkName].includes(mark.type.name));
	const wid = existingChangeMark ? existingChangeMark.attrs.id : sharedWid ?? v4_default();
	ctx$1.tr.addMark(range.from, range.to, intent.mark);
	if (!hasMatchingMark(liveMarks, intent.mark)) {
		const formatChangeMark = liveMarks.find((mark) => mark.type.name === TrackFormatMarkName);
		let after = [];
		let before = [];
		if (formatChangeMark) {
			const beforeSnapshots = Array.isArray(formatChangeMark.attrs.before) ? formatChangeMark.attrs.before : [];
			const afterSnapshots = Array.isArray(formatChangeMark.attrs.after) ? formatChangeMark.attrs.after : [];
			if (beforeSnapshots.find((mark) => markSnapshotMatchesStepMark(mark, intent.mark, true))) {
				before = beforeSnapshots.filter((mark) => !markSnapshotMatchesStepMark(mark, intent.mark, true));
				after = afterSnapshots.filter((mark) => getTypeName(mark) !== intent.mark.type.name);
			} else {
				before = [...beforeSnapshots];
				after = upsertMarkSnapshotByType(afterSnapshots, {
					type: intent.mark.type.name,
					attrs: intent.mark.attrs
				});
			}
		} else {
			const existingMarkOfSameType = liveMarks.find((mark) => mark.type.name === intent.mark.type.name && !["trackDelete", "trackFormat"].includes(mark.type.name));
			before = existingMarkOfSameType ? [createMarkSnapshot(existingMarkOfSameType.type.name, existingMarkOfSameType.attrs)] : [];
			after = [createMarkSnapshot(intent.mark.type.name, intent.mark.attrs)];
		}
		if (isTrackFormatNoOp(before, after)) {
			if (formatChangeMark) ctx$1.tr.removeMark(range.from, range.to, formatChangeMark);
			return {
				sharedWid: wid,
				formatMark: null
			};
		}
		if (after.length || before.length) {
			const formatMark = createTrackFormatMark({
				ctx: ctx$1,
				trackFormatType,
				id: wid,
				before,
				after,
				parentId: range.parentId || "",
				existingFormatMark: formatChangeMark
			});
			ctx$1.tr.addMark(range.from, range.to, formatMark);
			return {
				sharedWid: wid,
				formatMark
			};
		}
		if (formatChangeMark) ctx$1.tr.removeMark(range.from, range.to, formatChangeMark);
	}
	return {
		sharedWid: wid,
		formatMark: null
	};
};
var applyTrackedFormatRemove = ({ ctx: ctx$1, intent, range, trackFormatType, sharedWid }) => {
	const liveMarksBeforeRemove = getLiveInlineMarksInRange({
		doc: ctx$1.tr.doc,
		from: range.from,
		to: range.to
	});
	ctx$1.tr.removeMark(range.from, range.to, intent.mark);
	if (!hasMatchingMark(liveMarksBeforeRemove, intent.mark)) return {
		sharedWid,
		formatMark: null
	};
	const formatChangeMark = liveMarksBeforeRemove.find((mark) => mark.type.name === TrackFormatMarkName);
	let after = [];
	let before = [];
	if (formatChangeMark) {
		const afterSnapshots = Array.isArray(formatChangeMark.attrs.after) ? formatChangeMark.attrs.after : [];
		const beforeSnapshots = Array.isArray(formatChangeMark.attrs.before) ? formatChangeMark.attrs.before : [];
		if (afterSnapshots.find((mark) => markSnapshotMatchesStepMark(mark, intent.mark, true))) {
			after = afterSnapshots.filter((mark) => !markSnapshotMatchesStepMark(mark, intent.mark, true));
			if (after.length === 0) {
				const remainingFormatMarks = liveMarksBeforeRemove.filter((m$1) => !["trackDelete", "trackFormat"].includes(m$1.type.name) && m$1.type.name !== intent.mark.type.name);
				if (beforeSnapshots.every((snapshot) => remainingFormatMarks.some((m$1) => markSnapshotMatchesStepMark(snapshot, m$1, true)))) {
					ctx$1.tr.removeMark(range.from, range.to, formatChangeMark);
					return {
						sharedWid: formatChangeMark.attrs.id || sharedWid,
						formatMark: null
					};
				}
			}
			before = [...beforeSnapshots];
		} else {
			after = [...afterSnapshots];
			before = upsertMarkSnapshotByType(beforeSnapshots, {
				type: intent.mark.type.name,
				attrs: intent.mark.attrs
			});
		}
	} else {
		after = [];
		const existingMark = range.node.marks.find((mark) => mark.type === intent.mark.type);
		before = existingMark ? [createMarkSnapshot(intent.mark.type.name, existingMark.attrs)] : [];
	}
	if (after.length || before.length) {
		const wid = formatChangeMark ? formatChangeMark.attrs.id : sharedWid ?? v4_default();
		const formatMark = createTrackFormatMark({
			ctx: ctx$1,
			trackFormatType,
			id: wid,
			before,
			after,
			parentId: range.parentId || "",
			existingFormatMark: formatChangeMark
		});
		ctx$1.tr.addMark(range.from, range.to, formatMark);
		return {
			sharedWid: wid,
			formatMark
		};
	}
	if (formatChangeMark) ctx$1.tr.removeMark(range.from, range.to, formatChangeMark);
	return {
		sharedWid: formatChangeMark?.attrs?.id || sharedWid,
		formatMark: null
	};
};
var createTrackFormatMark = ({ ctx: ctx$1, trackFormatType, id, before, after, parentId, existingFormatMark }) => trackFormatType.create({
	id,
	sourceId: existingFormatMark?.attrs?.sourceId || "",
	author: ctx$1.intent.user.name || "",
	authorId: ctx$1.intent.user.id || "",
	authorEmail: ctx$1.intent.user.email || "",
	authorImage: ctx$1.intent.user.image || "",
	date: ctx$1.intent.date,
	before,
	after,
	importedAuthor: existingFormatMark?.attrs?.importedAuthor || "",
	revisionGroupId: existingFormatMark?.attrs?.revisionGroupId || id,
	splitFromId: existingFormatMark?.attrs?.splitFromId || "",
	changeType: CanonicalChangeType.Formatting,
	replacementGroupId: "",
	replacementSideId: "",
	overlapParentId: parentId || existingFormatMark?.attrs?.overlapParentId || "",
	sourceIds: existingFormatMark?.attrs?.sourceIds ?? null,
	origin: existingFormatMark?.attrs?.origin || ""
});
var findContainingSegment = (ctx$1, pos) => findSegmentAt(ctx$1, pos);
var isFiniteNonNeg = (value) => typeof value === "number" && Number.isFinite(value) && value >= 0;
const sliceFromText = (schema, text, marks) => {
	if (!text) return Slice.empty;
	return new Slice(Fragment$1.from(schema.text(text, marks ?? null)), 0, 0);
};
const makeTextInsertIntent = ({ at, content, schema, user, date, source, replacementGroupHint, preserveExistingReviewState }) => {
	if (!isFiniteNonNeg(at)) throw new Error("makeTextInsertIntent: `at` must be a non-negative finite number");
	return {
		kind: "text-insert",
		at,
		content: content instanceof Slice ? content : schema ? sliceFromText(schema, content) : Slice.empty,
		user,
		date,
		source,
		...replacementGroupHint ? { replacementGroupHint } : {},
		...preserveExistingReviewState ? { preserveExistingReviewState: true } : {}
	};
};
const makeTextDeleteIntent = ({ from: from$1, to, user, date, source, replacementGroupHint, preserveExistingReviewState }) => {
	if (!isFiniteNonNeg(from$1) || !isFiniteNonNeg(to)) throw new Error("makeTextDeleteIntent: `from`/`to` must be non-negative finite numbers");
	if (from$1 > to) throw new Error("makeTextDeleteIntent: `from` must be <= `to`");
	return {
		kind: "text-delete",
		from: from$1,
		to,
		user,
		date,
		source,
		...replacementGroupHint ? { replacementGroupHint } : {},
		...preserveExistingReviewState ? { preserveExistingReviewState: true } : {}
	};
};
const makeTextReplaceIntent = ({ from: from$1, to, content, schema, replacements, user, date, source, replacementGroupHint, preserveExistingReviewState }) => {
	if (!isFiniteNonNeg(from$1) || !isFiniteNonNeg(to)) throw new Error("makeTextReplaceIntent: `from`/`to` must be non-negative finite numbers");
	if (from$1 > to) throw new Error("makeTextReplaceIntent: `from` must be <= `to`");
	return {
		kind: "text-replace",
		from: from$1,
		to,
		content: content instanceof Slice ? content : schema ? sliceFromText(schema, content) : Slice.empty,
		replacements,
		user,
		date,
		source,
		...replacementGroupHint ? { replacementGroupHint } : {},
		...preserveExistingReviewState ? { preserveExistingReviewState: true } : {}
	};
};
const makeFormatIntent = ({ kind, from: from$1, to, mark, user, date, source }) => {
	if (kind !== "format-apply" && kind !== "format-remove") throw new Error(`makeFormatIntent: unsupported kind ${kind}`);
	if (!isFiniteNonNeg(from$1) || !isFiniteNonNeg(to)) throw new Error("makeFormatIntent: `from`/`to` must be non-negative finite numbers");
	if (from$1 > to) throw new Error("makeFormatIntent: `from` must be <= `to`");
	return {
		kind,
		from: from$1,
		to,
		mark,
		user,
		date,
		source
	};
};
const collectWholeTablesInRange = ({ doc: doc$1, from: from$1, to }) => {
	if (!doc$1 || typeof from$1 !== "number" || typeof to !== "number" || to <= from$1) return [];
	const boundedFrom = Math.max(0, from$1);
	const boundedTo = Math.min(doc$1.content.size, to);
	if (boundedTo <= boundedFrom) return [];
	const tables = [];
	doc$1.nodesBetween(boundedFrom, boundedTo, (node, pos) => {
		if (node.type?.name !== "table") return true;
		if (pos >= boundedFrom && pos + node.nodeSize <= boundedTo) {
			tables.push({
				pos,
				node,
				from: pos,
				to: pos + node.nodeSize
			});
			return false;
		}
		return true;
	});
	return tables;
};
const stampTableRows = ({ type, tr, from: from$1, to, user, date }) => {
	if (type !== "rowInsert" && type !== "rowDelete") return false;
	const tables = collectWholeTablesInRange({
		doc: tr.doc,
		from: from$1,
		to
	});
	if (!tables.length) return false;
	let stamped = false;
	for (const { pos: tablePos, node: tableNode } of tables) {
		const revisionGroupId = v4_default();
		let offset$1 = 1;
		const rowPositions = [];
		tableNode.forEach((child) => {
			const childPos = tablePos + offset$1;
			offset$1 += child.nodeSize;
			if (child.type?.name === "tableRow") rowPositions.push(childPos);
		});
		for (const rowPos of rowPositions) {
			const rowNode = tr.doc.nodeAt(rowPos);
			if (!rowNode || rowNode.type?.name !== "tableRow") continue;
			if (rowNode.attrs?.trackChange) continue;
			const trackChange = {
				type,
				id: v4_default(),
				author: user?.name || "",
				authorId: user?.id || "",
				authorEmail: user?.email || "",
				authorImage: user?.image || "",
				date,
				revisionGroupId
			};
			tr.setNodeMarkup(rowPos, void 0, {
				...rowNode.attrs,
				trackChange
			});
			stamped = true;
		}
	}
	return stamped;
};
const markDeletion = ({ tr, from: from$1, to, user, date, id: providedId }) => {
	const currentIdentity = getCurrentUserIdentity({ options: { user } });
	const isOwnInsertion = (mark) => {
		const changeIdentity = getChangeAuthorIdentity(mark);
		if (matchesSameUserRefinement({
			currentUser: currentIdentity,
			change: changeIdentity
		})) return true;
		if (!changeIdentity.hasId && !changeIdentity.hasEmail) return shouldCollapseNoEmailInsertion({
			currentUser: user,
			insertionAttrs: mark?.attrs
		});
		return false;
	};
	const trackedMark = findTrackedMarkBetween({
		tr,
		from: from$1,
		to,
		markName: TrackDeleteMarkName,
		predicate: (mark) => matchesSameUserRefinement({
			currentUser: currentIdentity,
			change: getChangeAuthorIdentity(mark)
		})
	});
	let id;
	if (providedId) id = providedId;
	else if (trackedMark) id = trackedMark.mark.attrs.id;
	else id = v4_default();
	const deletionMark = tr.doc.type.schema.marks[TrackDeleteMarkName].create({
		id,
		author: user.name || "",
		authorId: user.id || "",
		authorEmail: user.email || "",
		authorImage: user.image || "",
		date
	});
	const deletionMap = new Mapping();
	const shouldReassignExistingDeletions = Boolean(providedId);
	let nodes = [];
	tr.doc.nodesBetween(from$1, to, (node, pos) => {
		if (node.type.name.includes("table")) return;
		if (!node.isInline || !node.isLeaf) return;
		const mappedFrom = deletionMap.map(Math.max(from$1, pos));
		const mappedTo = deletionMap.map(Math.min(to, pos + node.nodeSize));
		if (mappedFrom >= mappedTo) return;
		const insertMark = node.marks.find((mark) => mark.type.name === TrackInsertMarkName);
		const existingDeleteMarks = node.marks.filter((mark) => mark.type.name === TrackDeleteMarkName);
		if (insertMark && isOwnInsertion(insertMark)) {
			const removeStep = new ReplaceStep(mappedFrom, mappedTo, Slice.empty);
			if (!tr.maybeStep(removeStep).failed) deletionMap.appendMap(removeStep.getMap());
			return;
		}
		if (existingDeleteMarks.length > 0) {
			if (shouldReassignExistingDeletions) {
				nodes.push(node);
				existingDeleteMarks.forEach((existingDeleteMark) => {
					tr.removeMark(mappedFrom, mappedTo, existingDeleteMark);
				});
				tr.addMark(mappedFrom, mappedTo, deletionMark);
			}
			return;
		}
		nodes.push(node);
		tr.addMark(mappedFrom, mappedTo, deletionMark);
	});
	return {
		deletionMark,
		deletionMap,
		nodes
	};
};
var sliceContainsTable = (slice) => {
	const content = slice?.content;
	if (!content) return false;
	let found = false;
	content.forEach((node) => {
		if (found) return;
		if (node?.type?.name === "table") found = true;
	});
	return found;
};
var rangeContainsWholeTable = ({ doc: doc$1, from: from$1, to }) => collectWholeTablesInRange({
	doc: doc$1,
	from: from$1,
	to
}).length > 0;
var findDocPosByTextOffset = ({ doc: doc$1, from: from$1, to, textOffset }) => {
	let remaining = textOffset;
	let foundPos = null;
	doc$1.nodesBetween(from$1, to, (node, pos) => {
		if (foundPos !== null) return false;
		if (!node.isText || !node.text) return;
		const nodeStart = Math.max(from$1, pos);
		const nodeEnd = Math.min(to, pos + node.text.length);
		if (nodeStart >= nodeEnd) return;
		const nodeLen = nodeEnd - nodeStart;
		if (remaining < nodeLen) {
			foundPos = nodeStart + remaining;
			return false;
		}
		remaining -= nodeLen;
	});
	return foundPos;
};
var normalizeReplaceStepSingleCharDelete = ({ step, doc: doc$1 }) => {
	if (!(step instanceof ReplaceStep) || step.from === step.to || step.to - step.from <= 1 || step.slice.content.size === 0) return step;
	const findSingleDeletedCharPos = ({ oldText, newText, from: from$1, to }) => {
		if (oldText.length - newText.length !== 1) return null;
		let prefix = 0;
		while (prefix < newText.length && oldText.charCodeAt(prefix) === newText.charCodeAt(prefix)) prefix += 1;
		let suffix = 0;
		while (suffix < newText.length - prefix && oldText.charCodeAt(oldText.length - 1 - suffix) === newText.charCodeAt(newText.length - 1 - suffix)) suffix += 1;
		if (prefix + suffix !== newText.length) return null;
		return findDocPosByTextOffset({
			doc: doc$1,
			from: from$1,
			to,
			textOffset: prefix
		});
	};
	let deleteFrom = findSingleDeletedCharPos({
		oldText: doc$1.textBetween(step.from, step.to),
		newText: step.slice.content.textBetween(0, step.slice.content.size),
		from: step.from,
		to: step.to
	});
	if (deleteFrom === null) {
		const applied = step.apply(doc$1);
		if (applied.failed || !applied.doc) return step;
		deleteFrom = findSingleDeletedCharPos({
			oldText: doc$1.textBetween(0, doc$1.content.size),
			newText: applied.doc.textBetween(0, applied.doc.content.size),
			from: 0,
			to: doc$1.content.size
		});
		if (deleteFrom === null || deleteFrom < step.from || deleteFrom >= step.to) return step;
	}
	try {
		const deleteTo = deleteFrom + 1;
		const candidate = new ReplaceStep(deleteFrom, deleteTo, Slice.empty, step.structure);
		return candidate.apply(doc$1).failed ? step : candidate;
	} catch {
		return step;
	}
};
const replaceStep = ({ state, tr, step, newTr, map: map$1, user, date, originalStep, originalStepIndex, replacements = "paired" }) => {
	const originalRange = {
		from: step.from,
		to: step.to,
		sliceSize: step.slice.content.size
	};
	step = normalizeReplaceStepSingleCharDelete({
		step,
		doc: newTr.doc
	});
	const stepWasNormalized = step.from !== originalRange.from || step.to !== originalRange.to || step.slice.content.size !== originalRange.sliceSize;
	const compiled = tryCompileStep({
		state,
		tr,
		newTr,
		step,
		stepWasNormalized,
		originalStep,
		originalStepIndex,
		map: map$1,
		user,
		date,
		replacements
	});
	if (compiled.handled) return;
	if (compiled.failed) return;
	if (step.from !== step.to && step.slice.content.size === 0) {
		let hasInlineContent = false;
		newTr.doc.nodesBetween(step.from, step.to, (node) => {
			if (node.isInline) {
				hasInlineContent = true;
				return false;
			}
		});
		if (!hasInlineContent) {
			if (!newTr.maybeStep(step).failed) map$1.appendMap(step.getMap());
			return;
		}
	}
};
var tryStructuralTableInsert = ({ newTr, step, map: map$1, user, date }) => {
	const beforeSteps = newTr.steps.length;
	const beforeSize = newTr.doc.content.size;
	const insertAt = step.from;
	const replacedLength = step.to - step.from;
	if (step.from !== step.to) {
		let hasRealContent = false;
		newTr.doc.nodesBetween(step.from, step.to, (node) => {
			if (hasRealContent) return false;
			if (node.isText && node.text || node.isLeaf && !node.isText) hasRealContent = true;
			return !hasRealContent;
		});
		if (hasRealContent) return { handled: false };
	}
	if (newTr.maybeStep(step).failed) return { handled: false };
	const stepMap = newTr.steps[beforeSteps].getMap();
	map$1.appendMap(stepMap);
	const insertedFrom = insertAt;
	const insertedTo = insertAt + (newTr.doc.content.size - beforeSize) + replacedLength;
	if (insertedTo > insertedFrom) {
		let hasInlineText = false;
		newTr.doc.nodesBetween(insertedFrom, insertedTo, (node) => {
			if (node.isText && node.text) {
				hasInlineText = true;
				return false;
			}
		});
		if (hasInlineText) markInsertion({
			tr: newTr,
			from: insertedFrom,
			to: insertedTo,
			user,
			date
		});
	}
	stampTableRows({
		type: "rowInsert",
		tr: newTr,
		from: insertedFrom,
		to: insertedTo,
		user,
		date
	});
	newTr.setMeta(TrackChangesBasePluginKey, { insertedTo });
	newTr.setMeta(CommentsPluginKey, { type: "force" });
	return { handled: true };
};
var tryStructuralTableDelete = ({ newTr, step, map: map$1, originalStep, originalStepIndex, tr, user, date }) => {
	const from$1 = step.from;
	const to = step.to;
	const tableRanges = collectWholeTablesInRange({
		doc: newTr.doc,
		from: from$1,
		to
	});
	let hasOutsideText = false;
	newTr.doc.nodesBetween(from$1, to, (node, pos) => {
		if (hasOutsideText) return false;
		if (node.isText && node.text && !tableRanges.some((r$1) => pos >= r$1.from && pos < r$1.to)) {
			hasOutsideText = true;
			return false;
		}
	});
	if (hasOutsideText) return { handled: false };
	let hasInlineText = false;
	newTr.doc.nodesBetween(from$1, to, (node) => {
		if (node.isText && node.text) {
			hasInlineText = true;
			return false;
		}
	});
	if (hasInlineText) markDeletion({
		tr: newTr,
		from: from$1,
		to,
		user,
		date
	});
	if (!stampTableRows({
		type: "rowDelete",
		tr: newTr,
		from: from$1,
		to,
		user,
		date
	}) && !hasInlineText) return { handled: false };
	if (map$1 && originalStep && tr) try {
		const invertStep = originalStep.invert(tr.docs[originalStepIndex]).map(map$1);
		if (invertStep) map$1.appendMap(invertStep.getMap());
	} catch {}
	newTr.setMeta(TrackChangesBasePluginKey, {});
	newTr.setMeta(CommentsPluginKey, { type: "force" });
	return { handled: true };
};
var tryCompileStep = ({ state, tr, newTr, step, stepWasNormalized, originalStep, originalStepIndex, map: map$1, user, date, replacements }) => {
	if (step.slice.content.size > 0 && sliceContainsTable(step.slice)) {
		const structural = tryStructuralTableInsert({
			newTr,
			step,
			map: map$1,
			user,
			date
		});
		if (structural.handled) return structural;
	}
	if (step.from !== step.to && step.slice.content.size === 0 && rangeContainsWholeTable({
		doc: newTr.doc,
		from: step.from,
		to: step.to
	})) {
		const structural = tryStructuralTableDelete({
			newTr,
			step,
			map: map$1,
			originalStep,
			originalStepIndex,
			tr,
			user,
			date
		});
		if (structural.handled) return structural;
	}
	if (step.from !== step.to && step.slice.content.size === 0) {
		let hasInlineContent = false;
		newTr.doc.nodesBetween(step.from, step.to, (node) => {
			if (node.isInline) {
				hasInlineContent = true;
				return false;
			}
		});
		if (!hasInlineContent) return { handled: false };
	}
	let intent;
	try {
		const preserveExistingReviewState = tr.getMeta("protectTrackedReviewState") === true;
		const source = tr.getMeta("inputType") === "programmatic" ? "document-api" : "native";
		if (step.from === step.to && step.slice.content.size > 0) intent = makeTextInsertIntent({
			at: step.from,
			content: step.slice,
			user,
			date,
			source,
			preserveExistingReviewState
		});
		else if (step.from !== step.to && step.slice.content.size === 0) intent = makeTextDeleteIntent({
			from: step.from,
			to: step.to,
			user,
			date,
			source,
			preserveExistingReviewState
		});
		else if (step.from !== step.to && step.slice.content.size > 0) {
			intent = makeTextReplaceIntent({
				from: step.from,
				to: step.to,
				content: step.slice,
				replacements,
				user,
				date,
				source,
				preserveExistingReviewState
			});
			if (tr.steps.length === 1) intent.probeForDeletionSpan = true;
		} else return { handled: false };
	} catch (error) {
		return {
			failed: true,
			error
		};
	}
	const beforeSize = newTr.doc.content.size;
	const beforeSteps = newTr.steps.length;
	const newTrDocBeforeCompile = newTr.doc;
	const result = compileTrackedEdit({
		state,
		tr: newTr,
		intent,
		replacements
	});
	if (!result.ok) return {
		failed: true,
		error: new Error(result.message)
	};
	const invertSourceStep = stepWasNormalized ? step : originalStep;
	const invertSourceDoc = stepWasNormalized ? newTrDocBeforeCompile : tr.docs[originalStepIndex];
	let invertStep;
	try {
		invertStep = stepWasNormalized ? invertSourceStep.invert(invertSourceDoc) : invertSourceStep.invert(invertSourceDoc).map(map$1);
	} catch {
		invertStep = null;
	}
	if (invertStep) {
		map$1.appendMap(invertStep.getMap());
		const mirrorIndex = map$1.maps.length - 1;
		for (let i = beforeSteps; i < newTr.steps.length; i += 1) map$1.appendMap(newTr.steps[i].getMap(), mirrorIndex);
	} else for (let i = beforeSteps; i < newTr.steps.length; i += 1) map$1.appendMap(newTr.steps[i].getMap());
	const meta = {};
	if (typeof result.insertedTo === "number") meta.insertedTo = result.insertedTo;
	if (result.insertedMark) meta.insertedMark = result.insertedMark;
	if (result.deletionMark) meta.deletionMark = result.deletionMark;
	else if (result.deletionMarks?.length) meta.deletionMark = result.deletionMarks[0];
	if (result.deletionNodes?.length) meta.deletionNodes = result.deletionNodes;
	if (result.insertedMark && result.insertedStep) meta.step = result.insertedStep;
	else if (result.insertedMark && result.insertedNodes?.length) meta.step = { slice: { content: { content: result.insertedNodes } } };
	if (result.selection?.kind === "near" && stepWasNormalized && !result.insertedMark) meta.selectionPos = result.selection.pos;
	newTr.setMeta(TrackChangesBasePluginKey, meta);
	newTr.setMeta(CommentsPluginKey, { type: "force" });
	if (typeof result.insertedTo === "number" && result.insertedTo > step.from) stampTableRows({
		type: "rowInsert",
		tr: newTr,
		from: step.from,
		to: result.insertedTo,
		user,
		date
	});
	return {
		handled: true,
		sizeDelta: newTr.doc.content.size - beforeSize
	};
};
const addMarkStep = ({ state, step, newTr, doc: doc$1, user, date }) => {
	if (TrackedFormatMarkNames.includes(step.mark.type.name)) {
		const intentUser = {
			name: user?.name || "",
			email: user?.email || "",
			image: user?.image || ""
		};
		const result = compileTrackedEdit({
			state,
			tr: newTr,
			intent: makeFormatIntent({
				kind: "format-apply",
				from: step.from,
				to: step.to,
				mark: step.mark,
				user: intentUser,
				date,
				source: "native"
			})
		});
		if (result.ok === true) {
			if (result.formatMarks?.length) newTr.setMeta(TrackChangesBasePluginKey, {
				formatMark: result.formatMarks[0],
				step
			});
			newTr.setMeta(CommentsPluginKey, { type: "force" });
			return;
		}
		return;
	}
	doc$1.nodesBetween(step.from, step.to, (node, pos) => {
		if (!node.isInline || node.type.name === "run") return;
		if (node.marks.find((mark) => mark.type.name === "trackDelete")) return false;
		newTr.addMark(Math.max(step.from, pos), Math.min(step.to, pos + node.nodeSize), step.mark);
	});
};
const removeMarkStep = ({ state, step, newTr, doc: doc$1, user, date }) => {
	if (TrackedFormatMarkNames.includes(step.mark.type.name)) {
		const intentUser = {
			name: user?.name || "",
			email: user?.email || "",
			image: user?.image || ""
		};
		const result = compileTrackedEdit({
			state,
			tr: newTr,
			intent: makeFormatIntent({
				kind: "format-remove",
				from: step.from,
				to: step.to,
				mark: step.mark,
				user: intentUser,
				date,
				source: "native"
			})
		});
		if (result.ok) {
			if (result.formatMarks?.length) newTr.setMeta(TrackChangesBasePluginKey, {
				formatMark: result.formatMarks[0],
				step
			});
			newTr.setMeta(CommentsPluginKey, { type: "force" });
			return;
		}
		return;
	}
	doc$1.nodesBetween(step.from, step.to, (node, pos) => {
		if (!node.isInline || node.type.name === "run") return true;
		if (node.marks.find((mark) => mark.type.name === "trackDelete")) return false;
		newTr.removeMark(Math.max(step.from, pos), Math.min(step.to, pos + node.nodeSize), step.mark);
	});
};
var scopeHasLiveContent = (doc$1, cursorPos, trackDeleteMarkType) => {
	const $cursor = doc$1.resolve(cursorPos);
	let scopeDepth = 0;
	let paraDepth = 0;
	for (let d = $cursor.depth; d > 0; d--) {
		const name = $cursor.node(d).type.name;
		if (name === "listItem" || name === "list_item") {
			scopeDepth = d;
			break;
		}
		if (!paraDepth && name === "paragraph") paraDepth = d;
	}
	scopeDepth = scopeDepth || paraDepth;
	if (scopeDepth <= 0) return false;
	const scopeNode = $cursor.node(scopeDepth);
	const scopeStart = $cursor.before(scopeDepth) + 1;
	const scopeEnd = scopeStart + scopeNode.content.size;
	let hasLive = false;
	doc$1.nodesBetween(scopeStart, scopeEnd, (node) => {
		if (hasLive) return false;
		if (!node.isInline || !node.isLeaf) return;
		if (!node.marks.some((m$1) => m$1.type === trackDeleteMarkType)) hasLive = true;
	});
	return hasLive;
};
var findPreviousLiveCharPos = (doc$1, cursorPos, trackDeleteMarkType) => {
	const $cursor = doc$1.resolve(cursorPos);
	let paraDepth = $cursor.depth;
	while (paraDepth > 0 && $cursor.node(paraDepth).type.name !== "paragraph") paraDepth--;
	if (paraDepth <= 0) return null;
	const paraStart = $cursor.before(paraDepth) + 1;
	let lastLiveCharPos = null;
	doc$1.nodesBetween(paraStart, cursorPos, (node, pos) => {
		if (!node.isText) return;
		if (node.marks.some((m$1) => m$1.type === trackDeleteMarkType)) return;
		const nodeEnd = pos + node.nodeSize;
		const relevantEnd = Math.min(nodeEnd, cursorPos);
		if (relevantEnd > pos) lastLiveCharPos = relevantEnd - 1;
	});
	return lastLiveCharPos;
};
const replaceAroundStep = ({ state, tr, step, newTr, map: map$1, doc: doc$1, user, date, originalStep, originalStepIndex, replacements = "paired" }) => {
	if (tr.getMeta("forceTrackChanges")) {
		if (!newTr.maybeStep(step).failed) map$1.appendMap(step.getMap());
		return;
	}
	if (step.structure && step.insert === 1 && step.gapFrom === step.from + 1 && step.gapTo === step.to - 1) {
		newTr.step(step);
		map$1.appendMap(step.getMap());
		return;
	}
	if (!(tr.getMeta("inputType") === "deleteContentBackward")) return;
	const trackDeleteMarkType = state.schema.marks[TrackDeleteMarkName];
	const deleteFrom = findPreviousLiveCharPos(doc$1, state.selection.from, trackDeleteMarkType);
	if (deleteFrom === null) {
		if (scopeHasLiveContent(doc$1, state.selection.from, trackDeleteMarkType)) return;
		if (!newTr.maybeStep(step).failed) map$1.appendMap(step.getMap());
		return;
	}
	const charStep = new ReplaceStep(deleteFrom, deleteFrom + 1, Slice.empty);
	replaceStep({
		state,
		tr,
		step: charStep,
		newTr,
		map: map$1,
		doc: doc$1,
		user,
		date,
		originalStep: charStep,
		originalStepIndex,
		replacements
	});
	const trackMeta = newTr.getMeta(TrackChangesBasePluginKey) || {};
	trackMeta.selectionPos = deleteFrom;
	newTr.setMeta(TrackChangesBasePluginKey, trackMeta);
	if (trackMeta.deletionMark) {
		const ourId = trackMeta.deletionMark.attrs.id;
		const ourDate = trackMeta.deletionMark.attrs.date;
		const ourIdentity = getChangeAuthorIdentity(trackMeta.deletionMark);
		const searchTo = Math.min(newTr.doc.content.size, deleteFrom + 20);
		let contiguous = true;
		newTr.doc.nodesBetween(deleteFrom, searchTo, (node, pos) => {
			if (!contiguous) return false;
			if (!node.isText) return;
			const delMark = node.marks.find((m$1) => m$1.type.name === TrackDeleteMarkName);
			if (!delMark) {
				contiguous = false;
				return;
			}
			const isSameActor = matchesSameUserRefinement({
				currentUser: ourIdentity,
				change: getChangeAuthorIdentity(delMark)
			});
			if (delMark.attrs.id !== ourId && isSameActor && delMark.attrs.date === ourDate) {
				const merged = state.schema.marks[TrackDeleteMarkName].create({
					...delMark.attrs,
					id: ourId
				});
				newTr.removeMark(pos, pos + node.nodeSize, delMark);
				newTr.addMark(pos, pos + node.nodeSize, merged);
			}
		});
	}
};
var COMPOSITION_INPUT_TYPES = new Set(["insertCompositionText", "deleteCompositionText"]);
var COMBINING_MARK_REGEX = /^\p{Mark}$/u;
var graphemeSegmenter = typeof Intl !== "undefined" && typeof Intl.Segmenter === "function" ? new Intl.Segmenter(void 0, { granularity: "grapheme" }) : null;
var DEAD_KEY_PLACEHOLDER_MARKS = new Map([
	["`", "̀"],
	["'", "́"],
	["´", "́"],
	["^", "̂"],
	["~", "̃"],
	["¨", "̈"]
]);
var TRACKABLE_META_KEYS = [
	"inputType",
	"uiEvent",
	"paste",
	"pointer",
	"composition",
	"superdocSlicePaste",
	"forceTrackChanges",
	"protectTrackedReviewState",
	CustomSelectionPluginKey.key
];
var PASSTHROUGH_META_KEYS = [
	"inputType",
	"uiEvent",
	"paste",
	"pointer",
	"composition",
	"addToHistory",
	"superdocSlicePaste",
	CustomSelectionPluginKey.key
];
var ALLOWED_META_KEYS = new Set([...TRACKABLE_META_KEYS, ySyncPluginKey.key]);
var getTextNodeAtPos = ({ doc: doc$1, pos }) => {
	let found = null;
	doc$1.nodesBetween(Math.max(0, pos - 1), Math.min(doc$1.content.size, pos + 1), (node, nodePos) => {
		if (found || !node.isText || !node.text) return;
		const from$1 = nodePos;
		const to = nodePos + node.text.length;
		if (pos >= from$1 && pos < to) {
			found = {
				node,
				from: from$1
			};
			return false;
		}
	});
	return found;
};
var getFirstGrapheme = (text) => {
	if (!text) return "";
	if (graphemeSegmenter) return graphemeSegmenter.segment(text)[Symbol.iterator]().next().value?.segment ?? "";
	const chars = Array.from(text);
	if (!chars.length) return "";
	const grapheme = [chars[0]];
	for (let index = 1; index < chars.length; index += 1) {
		if (!COMBINING_MARK_REGEX.test(chars[index])) break;
		grapheme.push(chars[index]);
	}
	return grapheme.join("");
};
var startsWithCompatibleGrapheme = ({ text, combiningMark }) => {
	const firstGrapheme = getFirstGrapheme(text);
	return Boolean(firstGrapheme) && firstGrapheme.normalize("NFD").includes(combiningMark);
};
var getOwnedDeadKeyPlaceholderInfoAt = ({ doc: doc$1, pos, user }) => {
	const placeholderChar = doc$1.textBetween(pos, pos + 1);
	const combiningMark = DEAD_KEY_PLACEHOLDER_MARKS.get(placeholderChar);
	if (!combiningMark) return null;
	const textNodeAtPos = getTextNodeAtPos({
		doc: doc$1,
		pos
	});
	const currentIdentity = getCurrentUserIdentity({ options: { user } });
	return textNodeAtPos?.node?.marks?.some((mark) => mark.type.name === "trackInsert" && matchesSameUserRefinement({
		currentUser: currentIdentity,
		change: getChangeAuthorIdentity(mark)
	})) ? {
		placeholderChar,
		combiningMark,
		textNodeAtPos
	} : null;
};
var getOwnedDeadKeyPlaceholderAt = ({ doc: doc$1, pos, user, insertedText }) => {
	const placeholder = getOwnedDeadKeyPlaceholderInfoAt({
		doc: doc$1,
		pos,
		user
	});
	if (!placeholder || !startsWithCompatibleGrapheme({
		text: insertedText,
		combiningMark: placeholder.combiningMark
	})) return null;
	return placeholder;
};
var getLeadingDeadKeyPlaceholderNormalization = (text) => {
	const [placeholderChar] = Array.from(text);
	if (!placeholderChar) return null;
	const combiningMark = DEAD_KEY_PLACEHOLDER_MARKS.get(placeholderChar);
	if (!combiningMark) return null;
	const normalizedText = text.slice(placeholderChar.length);
	if (!normalizedText || !startsWithCompatibleGrapheme({
		text: normalizedText,
		combiningMark
	})) return null;
	return {
		placeholderChar,
		combiningMark,
		normalizedText
	};
};
var createNormalizedSlice = ({ step, normalizedText, doc: doc$1 }) => {
	const { schema } = doc$1.type;
	const firstChild = step.slice.content.firstChild;
	if (!firstChild) return null;
	if (firstChild.isText) return new Slice(Fragment$1.from(schema.text(normalizedText, firstChild.marks)), step.slice.openStart, step.slice.openEnd);
	if (firstChild.childCount === 1 && firstChild.firstChild?.isText) {
		const textChild = firstChild.firstChild;
		const normalizedFirstChild = firstChild.copy(Fragment$1.from(schema.text(normalizedText, textChild.marks)));
		return new Slice(Fragment$1.from(normalizedFirstChild), step.slice.openStart, step.slice.openEnd);
	}
	return null;
};
var isCompositionTransaction = (tr) => tr.getMeta("composition") !== void 0 || COMPOSITION_INPUT_TYPES.has(tr.getMeta("inputType"));
var getCandidatePlaceholderPositions = ({ step, pendingDeadKeyPlaceholder, isReplacement }) => {
	if (pendingDeadKeyPlaceholder?.pos !== void 0) return [
		pendingDeadKeyPlaceholder.pos,
		pendingDeadKeyPlaceholder.pos - 1,
		pendingDeadKeyPlaceholder.pos + 1
	];
	return isReplacement ? [step.from] : [step.from, step.from - 1];
};
var findCompatibleOwnedDeadKeyPlaceholder = ({ doc: doc$1, positions, user, insertedText }) => {
	for (const pos of positions) {
		if (pos < 1 || pos >= doc$1.content.size) continue;
		const placeholder = getOwnedDeadKeyPlaceholderAt({
			doc: doc$1,
			pos,
			user,
			insertedText
		});
		if (placeholder) return {
			...placeholder,
			pos
		};
	}
	return null;
};
var foldCollapsedPlaceholderInsertion = ({ step, doc: doc$1, user, insertedText, pendingDeadKeyPlaceholder }) => {
	const placeholder = findCompatibleOwnedDeadKeyPlaceholder({
		doc: doc$1,
		positions: getCandidatePlaceholderPositions({
			step,
			pendingDeadKeyPlaceholder,
			isReplacement: false
		}),
		user,
		insertedText
	});
	if (!placeholder) return null;
	try {
		const candidate = new ReplaceStep(placeholder.pos, placeholder.pos + 1, step.slice, step.structure);
		if (!candidate.apply(doc$1).failed) return candidate;
	} catch {}
	return null;
};
var getInsertedText = (step) => step.slice.content.textBetween(0, step.slice.content.size);
var normalizeCompositionInsertStep = ({ step, doc: doc$1, tr, user, pendingDeadKeyPlaceholder }) => {
	if (!(step instanceof ReplaceStep)) return step;
	const insertedText = getInsertedText(step);
	if (!insertedText) return step;
	const hasCompositionContext = isCompositionTransaction(tr) || Boolean(pendingDeadKeyPlaceholder);
	const leadingPlaceholderNormalization = hasCompositionContext ? getLeadingDeadKeyPlaceholderNormalization(insertedText) : null;
	if (leadingPlaceholderNormalization) {
		const { normalizedText } = leadingPlaceholderNormalization;
		const normalizedSlice = createNormalizedSlice({
			step,
			normalizedText,
			doc: doc$1
		});
		if (normalizedSlice) {
			const placeholder = findCompatibleOwnedDeadKeyPlaceholder({
				doc: doc$1,
				positions: getCandidatePlaceholderPositions({
					step,
					pendingDeadKeyPlaceholder,
					isReplacement: step.from !== step.to
				}),
				user,
				insertedText: normalizedText
			});
			if (placeholder) try {
				const candidate = step.from !== step.to ? new ReplaceStep(step.from, step.to, normalizedSlice, step.structure) : new ReplaceStep(placeholder.pos, placeholder.pos + 1, normalizedSlice, step.structure);
				if (!candidate.apply(doc$1).failed) return candidate;
			} catch {}
		}
	}
	if (step.from === step.to && hasCompositionContext) {
		const folded = foldCollapsedPlaceholderInsertion({
			step,
			doc: doc$1,
			user,
			insertedText,
			pendingDeadKeyPlaceholder
		});
		if (folded) return folded;
	}
	return step;
};
var mergeTrackChangesMeta = (tr, extraMeta) => {
	const existingMeta = tr.getMeta(TrackChangesBasePluginKey) || {};
	tr.setMeta(TrackChangesBasePluginKey, {
		...existingMeta,
		...extraMeta
	});
};
var copyPassthroughMeta = (sourceTr, targetTr) => {
	PASSTHROUGH_META_KEYS.forEach((key) => {
		const value = sourceTr.getMeta(key);
		if (value !== void 0) targetTr.setMeta(key, value);
	});
};
var getPendingDeadKeyPlaceholder = ({ tr, newTr, user }) => {
	if (!isCompositionTransaction(tr) || tr.steps.length !== 1) return null;
	const [originalStep] = tr.steps;
	if (!(originalStep instanceof ReplaceStep) || originalStep.from !== originalStep.to) return null;
	const insertedText = getInsertedText(originalStep);
	if (!DEAD_KEY_PLACEHOLDER_MARKS.has(insertedText)) return null;
	const trackMeta = newTr.getMeta(TrackChangesBasePluginKey);
	const anchorPos = typeof trackMeta?.insertedTo === "number" ? trackMeta.insertedTo : newTr.selection.from;
	const matches = [];
	newTr.doc.descendants((node, pos$1) => {
		if (!node.isText || !node.text?.includes(insertedText)) return;
		for (let index = 0; index < node.text.length; index += 1) if (node.text[index] === insertedText) matches.push(pos$1 + index);
	});
	const pos = matches.sort((left$1, right$1) => Math.abs(left$1 - anchorPos) - Math.abs(right$1 - anchorPos))[0];
	if (pos === void 0) return null;
	return {
		pos,
		placeholderChar: insertedText,
		authorId: user.id,
		authorEmail: user.email
	};
};
const trackedTransaction = ({ tr, state, user, replacements = "paired" }) => {
	const notAllowedMeta = [
		"historyUndo",
		"historyRedo",
		"acceptReject"
	];
	const isProgrammaticInput = tr.getMeta("inputType") === "programmatic";
	const ySyncMeta = tr.getMeta(ySyncPluginKey);
	const pendingDeadKeyPlaceholder = TrackChangesBasePluginKey.getState(state)?.pendingDeadKeyPlaceholder ?? null;
	const hasDisallowedMeta = tr.meta && Object.keys(tr.meta).some((meta) => !ALLOWED_META_KEYS.has(meta));
	const isBlockIdentityRepair = Boolean(tr.getMeta("superdoc/block-identity-repair"));
	if (ySyncMeta?.isChangeOrigin || !tr.steps.length || isBlockIdentityRepair || hasDisallowedMeta && !isProgrammaticInput || notAllowedMeta.includes(tr.getMeta("inputType")) || tr.getMeta(CommentsPluginKey)) {
		if (pendingDeadKeyPlaceholder && !isCompositionTransaction(tr)) mergeTrackChangesMeta(tr, { pendingDeadKeyPlaceholder: null });
		return tr;
	}
	const newTr = state.tr;
	const map$1 = new Mapping();
	const fixedTimeTo10Mins = Math.floor(Date.now() / 6e5) * 6e5;
	const date = new Date(fixedTimeTo10Mins).toISOString();
	tr.steps.forEach((originalStep, originalStepIndex) => {
		const { doc: doc$1 } = newTr;
		let step = originalStep.map(map$1);
		if (!step) return;
		step = normalizeCompositionInsertStep({
			step,
			doc: doc$1,
			tr,
			user,
			pendingDeadKeyPlaceholder
		});
		if (step instanceof ReplaceStep) replaceStep({
			state,
			tr,
			step,
			newTr,
			map: map$1,
			doc: doc$1,
			user,
			date,
			originalStep,
			originalStepIndex,
			replacements
		});
		else if (step instanceof AddMarkStep) addMarkStep({
			state,
			tr,
			step,
			newTr,
			map: map$1,
			doc: doc$1,
			user,
			date
		});
		else if (step instanceof RemoveMarkStep) removeMarkStep({
			state,
			tr,
			step,
			newTr,
			map: map$1,
			doc: doc$1,
			user,
			date
		});
		else if (step instanceof ReplaceAroundStep$1) replaceAroundStep({
			state,
			tr,
			step,
			newTr,
			map: map$1,
			doc: doc$1,
			user,
			date,
			originalStep,
			originalStepIndex,
			replacements
		});
		else newTr.step(step);
	});
	copyPassthroughMeta(tr, newTr);
	mergeTrackChangesMeta(newTr, { pendingDeadKeyPlaceholder: getPendingDeadKeyPlaceholder({
		tr,
		newTr,
		user
	}) });
	const trackMeta = newTr.getMeta(TrackChangesBasePluginKey);
	if (trackMeta?.selectionPos !== void 0 && trackMeta?.selectionPos !== null) {
		const boundedPos = Math.max(0, Math.min(trackMeta.selectionPos, newTr.doc.content.size));
		const $pos = newTr.doc.resolve(boundedPos);
		if ($pos.parent.inlineContent) newTr.setSelection(TextSelection.create(newTr.doc, boundedPos));
		else newTr.setSelection(TextSelection.near($pos, -1));
	} else if (tr.selectionSet) if (tr.selection instanceof TextSelection && (tr.selection.from < state.selection.from || tr.getMeta("inputType") === "deleteContentBackward")) {
		const caretPos = map$1.map(tr.selection.from, -1);
		newTr.setSelection(new TextSelection(newTr.doc.resolve(caretPos)));
	} else if (trackMeta?.insertedTo !== void 0) {
		const boundedInsertedTo = Math.max(0, Math.min(trackMeta.insertedTo, newTr.doc.content.size));
		const $insertPos = newTr.doc.resolve(boundedInsertedTo);
		newTr.setSelection(TextSelection.near($insertPos, 1));
	} else {
		const deletionMarkSchema = state.schema.marks[TrackDeleteMarkName];
		const deletionMark = findMark(state, deletionMarkSchema, false);
		if (tr.selection.from > state.selection.from && deletionMark) {
			const caretPos = map$1.map(deletionMark.to + 1, 1);
			newTr.setSelection(new TextSelection(newTr.doc.resolve(caretPos)));
		} else newTr.setSelection(tr.selection.map(newTr.doc, map$1));
	}
	else if (state.selection.from - tr.selection.from > 1 && tr.selection.$head.depth > 1) {
		const caretPos = map$1.map(tr.selection.from - 2, -1);
		newTr.setSelection(new TextSelection(newTr.doc.resolve(caretPos)));
	}
	if (tr.storedMarksSet) newTr.setStoredMarks(tr.storedMarks);
	if (tr.scrolledIntoView) newTr.scrollIntoView();
	return newTr;
};
const markWrapping = () => {};
const parseFormatList = (str) => {
	if (!str) return [];
	let formatList;
	try {
		formatList = JSON.parse(str);
	} catch {
		return [];
	}
	if (!Array.isArray(formatList)) return [];
	return formatList.filter((format) => Object.hasOwn(format, "type") && Object.hasOwn(format, "attrs"));
};
var trackChangesHelpers_exports = /* @__PURE__ */ __export({
	addMarkStep: () => addMarkStep,
	attrsExactlyMatch: () => attrsExactlyMatch,
	createMarkSnapshot: () => createMarkSnapshot,
	documentHelpers: () => documentHelpers_exports,
	enumerateStructuralRowChanges: () => enumerateStructuralRowChanges,
	findMarkInRangeBySnapshot: () => findMarkInRangeBySnapshot,
	findTrackedMarkBetween: () => findTrackedMarkBetween,
	getLiveInlineMarksInRange: () => getLiveInlineMarksInRange,
	getTrackChanges: () => getTrackChanges,
	getTypeName: () => getTypeName,
	hasMatchingMark: () => hasMatchingMark,
	isTrackFormatNoOp: () => isTrackFormatNoOp,
	markDeletion: () => markDeletion,
	markInsertion: () => markInsertion,
	markSnapshotMatchesStepMark: () => markSnapshotMatchesStepMark,
	markWrapping: () => markWrapping,
	parseFormatList: () => parseFormatList,
	removeMarkStep: () => removeMarkStep,
	replaceAroundStep: () => replaceAroundStep,
	replaceStep: () => replaceStep,
	trackedTransaction: () => trackedTransaction,
	upsertMarkSnapshotByType: () => upsertMarkSnapshotByType
}, 1);
var trackFormatClass = "track-format";
const TrackFormat = Mark.create({
	name: TrackFormatMarkName,
	group: "track",
	inclusive: false,
	addOptions() {
		return { htmlAttributes: { class: trackFormatClass } };
	},
	addAttributes() {
		return {
			id: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-id"),
				renderDOM: (attrs) => {
					if (!attrs.id) return {};
					return { "data-id": attrs.id };
				}
			},
			author: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-author"),
				renderDOM: (attrs) => {
					if (!attrs.author) return {};
					return { "data-author": attrs.author };
				}
			},
			authorId: {
				default: "",
				rendered: false
			},
			authorEmail: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-authoremail"),
				renderDOM: (attrs) => {
					if (!attrs.authorEmail) return {};
					return { "data-authoremail": attrs.authorEmail };
				}
			},
			authorImage: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-authorimage"),
				renderDOM: (attrs) => {
					if (!attrs.authorImage) return {};
					return { "data-authorimage": attrs.authorImage };
				}
			},
			date: {
				default: "",
				parseDOM: (elem) => elem.getAttribute("data-date"),
				renderDOM: (attrs) => {
					if (!attrs.date) return {};
					return { "data-date": attrs.date };
				}
			},
			before: {
				default: [],
				parseDOM: (elem) => {
					return parseFormatList(elem.getAttribute("data-before"));
				},
				renderDOM: (attrs) => {
					if (!attrs.before) return {};
					return { "data-before": JSON.stringify(attrs.before) };
				}
			},
			after: {
				default: [],
				parseDOM: (elem) => {
					return parseFormatList(elem.getAttribute("data-after"));
				},
				renderDOM: (attrs) => {
					if (!attrs.after) return {};
					return { "data-after": JSON.stringify(attrs.after) };
				}
			},
			sourceId: {
				default: "",
				rendered: false
			},
			importedAuthor: {
				default: "",
				rendered: false
			},
			revisionGroupId: {
				default: "",
				rendered: false
			},
			splitFromId: {
				default: "",
				rendered: false
			},
			changeType: {
				default: "",
				rendered: false
			},
			replacementGroupId: {
				default: "",
				rendered: false
			},
			replacementSideId: {
				default: "",
				rendered: false
			},
			overlapParentId: {
				default: "",
				rendered: false
			},
			sourceIds: {
				default: null,
				rendered: false
			},
			origin: {
				default: "",
				rendered: false
			}
		};
	},
	parseDOM() {
		return false;
	},
	renderDOM({ htmlAttributes }) {
		return [
			"span",
			Attribute.mergeAttributes(this.options.htmlAttributes, htmlAttributes),
			0
		];
	}
});
const hasExpandedSelection = (selection) => {
	return Number.isFinite(selection?.from) && Number.isFinite(selection?.to) && selection.from !== selection.to;
};
var COMMENT_NODE_NAMES = new Set([
	"commentRangeStart",
	"commentRangeEnd",
	"commentReference"
]);
const enumerateCommentAnchors = (doc$1) => {
	const byId = /* @__PURE__ */ new Map();
	if (!doc$1) return [];
	doc$1.descendants((node, pos) => {
		if (!COMMENT_NODE_NAMES.has(node.type.name)) return;
		const id = node.attrs?.["w:id"] ?? node.attrs?.commentId ?? node.attrs?.attributes?.["w:id"];
		if (id == null) return;
		const key = String(id);
		const existing = byId.get(key);
		if (node.type.name === "commentRangeStart") if (existing) existing.startPos = pos;
		else byId.set(key, {
			commentId: key,
			startPos: pos,
			endPos: -1,
			referencePos: -1
		});
		else if (node.type.name === "commentRangeEnd") if (existing) existing.endPos = pos;
		else byId.set(key, {
			commentId: key,
			startPos: -1,
			endPos: pos,
			referencePos: -1
		});
		else if (node.type.name === "commentReference") if (existing) existing.referencePos = pos;
		else byId.set(key, {
			commentId: key,
			startPos: -1,
			endPos: -1,
			referencePos: pos
		});
	});
	return Array.from(byId.values());
};
const planCommentEffects = ({ doc: doc$1, removedRanges, resolvedRanges = [] }) => {
	const plan = {
		nodeDeletes: [],
		entityDeletes: [],
		entityShrinks: [],
		entityDetaches: [],
		diagnostics: []
	};
	if (!doc$1) return plan;
	const anchors = enumerateCommentAnchors(doc$1);
	if (!anchors.length) return plan;
	const sortedRemoved = [...removedRanges].filter((r$1) => r$1.from < r$1.to).sort((a, b$1) => a.from - b$1.from);
	const sortedResolved = [...resolvedRanges].filter((r$1) => r$1.from < r$1.to).sort((a, b$1) => a.from - b$1.from);
	if (!sortedRemoved.length && !sortedResolved.length) return plan;
	for (const anchor of anchors) {
		const start$1 = anchor.startPos;
		const end$1 = anchor.endPos;
		const ref$1 = anchor.referencePos;
		if (start$1 < 0 && end$1 < 0 && ref$1 < 0) continue;
		const anchorStart = start$1 >= 0 ? start$1 : ref$1 >= 0 ? ref$1 : end$1;
		const anchorEnd = end$1 >= 0 ? end$1 + 1 : ref$1 >= 0 ? ref$1 + 1 : start$1 + 1;
		const removedCause = sortedRemoved[0]?.cause ?? "trackedChange";
		const resolvedMatch = sortedResolved.find((r$1) => r$1.from < anchorEnd && r$1.to > anchorStart);
		const resolvedCause = resolvedMatch?.cause ?? removedCause;
		const removesEnd = sortedRemoved.some((r$1) => end$1 >= 0 && r$1.from <= end$1 && r$1.to > end$1);
		const removesRef = sortedRemoved.some((r$1) => ref$1 >= 0 && r$1.from <= ref$1 && r$1.to > ref$1);
		if (sortedRemoved.some((r$1) => r$1.from <= anchorStart && r$1.to >= anchorEnd) || removesEnd || removesRef) {
			plan.entityDeletes.push({
				id: anchor.commentId,
				cause: removedCause
			});
			if (start$1 >= 0) plan.nodeDeletes.push({
				kind: "commentRangeStart",
				from: start$1,
				to: start$1 + 1,
				commentId: anchor.commentId
			});
			if (end$1 >= 0) plan.nodeDeletes.push({
				kind: "commentRangeEnd",
				from: end$1,
				to: end$1 + 1,
				commentId: anchor.commentId
			});
			if (ref$1 >= 0) plan.nodeDeletes.push({
				kind: "commentReference",
				from: ref$1,
				to: ref$1 + 1,
				commentId: anchor.commentId
			});
			continue;
		}
		if (sortedRemoved.some((r$1) => r$1.from < anchorEnd && r$1.to > anchorStart)) {
			plan.entityShrinks.push({
				id: anchor.commentId,
				cause: removedCause,
				anchor: {
					from: anchorStart,
					to: anchorEnd
				}
			});
			if (resolvedMatch) plan.entityDetaches.push({
				id: anchor.commentId,
				cause: resolvedCause
			});
			continue;
		}
		if (resolvedMatch) plan.entityDetaches.push({
			id: anchor.commentId,
			cause: resolvedCause
		});
	}
	return plan;
};
var failure$3 = (code, message, extra) => ({
	ok: false,
	code,
	message,
	...extra || {}
});
const decideTrackedChanges = ({ state, editor, decision, target, replacements = "paired" }) => {
	if (decision !== "accept" && decision !== "reject") return failure$3("INVALID_TARGET", `decision must be "accept" or "reject" (got "${String(decision)}").`);
	const normalized = normalizeDecisionTarget(target);
	if (!normalized.ok) return normalized.failure;
	const graph = buildReviewGraph({
		state,
		replacementsMode: replacements
	});
	if (graphHasErrors(graph)) return failure$3("PRECONDITION_FAILED", "tracked review graph has invariant errors before decision.", { diagnostics: graph.validate() });
	const selectionResult = resolveTargetToSelections({
		graph,
		normalized: normalized.value
	});
	if (!selectionResult.ok) return selectionResult.failure;
	const { selections } = selectionResult;
	if (!selections.length) return failure$3("TARGET_NOT_FOUND", "no tracked changes match the requested decision target.");
	const permissionResult = runPermissionPreflight({
		editor,
		decision,
		selections
	});
	if (!permissionResult.ok) return permissionResult.failure;
	const planResult = buildMutationPlan({
		state,
		graph,
		selections,
		decision
	});
	if (!planResult.ok) return planResult.failure;
	const { plan } = planResult;
	const applyResult = applyPlan({
		state,
		plan
	});
	if (!applyResult.ok) return applyResult.failure;
	return {
		ok: true,
		tr: applyResult.tr,
		receipt: applyResult.receipt,
		touchedChangeIds: applyResult.touchedChangeIds,
		diagnostics: plan.diagnostics
	};
};
var normalizeDecisionTarget = (target) => {
	if (!target || typeof target !== "object") return {
		ok: false,
		failure: failure$3("INVALID_TARGET", "decision target must be an object.")
	};
	const t = target;
	if (t.kind === "id") {
		if (typeof t.id !== "string" || !t.id) return {
			ok: false,
			failure: failure$3("INVALID_TARGET", "target.kind = \"id\" requires a non-empty id.")
		};
		return {
			ok: true,
			value: {
				kind: "id",
				id: t.id
			}
		};
	}
	if (t.kind === "range") {
		const from$1 = Number(t.from);
		const to = Number(t.to);
		if (!Number.isFinite(from$1) || !Number.isFinite(to) || from$1 < 0 || to < 0 || from$1 > to) return {
			ok: false,
			failure: failure$3("INVALID_TARGET", "target.kind = \"range\" requires from <= to.")
		};
		return {
			ok: true,
			value: {
				kind: "range",
				from: from$1,
				to
			}
		};
	}
	if (t.kind === "all") return {
		ok: true,
		value: { kind: "all" }
	};
	if (typeof t.id === "string" && t.id) return {
		ok: true,
		value: {
			kind: "id",
			id: t.id
		}
	};
	if (t.scope === "all") return {
		ok: true,
		value: { kind: "all" }
	};
	if (Number.isFinite(t.from) && Number.isFinite(t.to)) {
		const from$1 = Number(t.from);
		const to = Number(t.to);
		if (from$1 > to) return {
			ok: false,
			failure: failure$3("INVALID_TARGET", "range target requires from <= to.")
		};
		return {
			ok: true,
			value: {
				kind: "range",
				from: from$1,
				to
			}
		};
	}
	return {
		ok: false,
		failure: failure$3("INVALID_TARGET", "decision target shape was not recognised.")
	};
};
var resolveLogicalChangeById = (graph, id) => {
	const key = String(id);
	for (const candidate of graph.changes.values()) if (candidate?.type === CanonicalChangeType.Structural && String(candidate.id) === key) return candidate;
	return graph.changes.get(id);
};
var resolveTargetToSelections = ({ graph, normalized }) => {
	if (normalized.kind === "all") {
		const sel = [];
		const seen = /* @__PURE__ */ new Set();
		for (const change of graph.changes.values()) {
			if (seen.has(change)) continue;
			seen.add(change);
			sel.push({
				change,
				coverage: "full",
				ranges: change.segments.map((s) => ({
					from: s.from,
					to: s.to
				}))
			});
		}
		sel.sort((a, b$1) => firstFrom(a) - firstFrom(b$1));
		return {
			ok: true,
			selections: sel
		};
	}
	if (normalized.kind === "id") {
		const change = resolveLogicalChangeById(graph, normalized.id);
		if (!change) return {
			ok: false,
			failure: failure$3("TARGET_NOT_FOUND", `no tracked change with id "${normalized.id}".`)
		};
		return {
			ok: true,
			selections: [{
				change,
				coverage: "full",
				ranges: change.segments.map((s) => ({
					from: s.from,
					to: s.to
				}))
			}]
		};
	}
	const { from: from$1, to } = normalized;
	const byId = /* @__PURE__ */ new Map();
	for (const segment of graph.segments) {
		const overlapFrom = Math.max(segment.from, from$1);
		const overlapTo = Math.min(segment.to, to);
		if (overlapFrom >= overlapTo) {
			if (from$1 === to && segment.from <= from$1 && segment.to > from$1) {
				const change$1 = resolveLogicalChangeById(graph, segment.changeId);
				if (!change$1) continue;
				const existing$1 = byId.get(change$1.id);
				if (existing$1) {
					existing$1.coverage = "full";
					existing$1.ranges = change$1.segments.map((s) => ({
						from: s.from,
						to: s.to
					}));
				} else byId.set(change$1.id, {
					change: change$1,
					coverage: "full",
					ranges: change$1.segments.map((s) => ({
						from: s.from,
						to: s.to
					}))
				});
			}
			continue;
		}
		const change = resolveLogicalChangeById(graph, segment.changeId);
		if (!change) continue;
		const existing = byId.get(change.id);
		if (existing) {
			existing.ranges.push({
				from: overlapFrom,
				to: overlapTo
			});
			if (rangesCoverChange(existing.ranges, change)) {
				existing.coverage = "full";
				existing.ranges = change.segments.map((s) => ({
					from: s.from,
					to: s.to
				}));
			} else existing.coverage = "partial";
			continue;
		}
		const isFull = segment.from >= from$1 && segment.to <= to && change.segments.every((s) => s.from >= from$1 && s.to <= to);
		byId.set(change.id, {
			change,
			coverage: isFull ? "full" : "partial",
			ranges: [{
				from: overlapFrom,
				to: overlapTo
			}]
		});
	}
	return {
		ok: true,
		selections: Array.from(byId.values()).sort((a, b$1) => firstFrom(a) - firstFrom(b$1))
	};
};
var firstFrom = (selection) => selection.ranges[0]?.from ?? 0;
var rangesCoverChange = (ranges, change) => {
	const sorted = [...ranges].sort((a, b$1) => a.from - b$1.from);
	const merged = [];
	for (const r$1 of sorted) {
		const last = merged[merged.length - 1];
		if (last && r$1.from <= last.to) last.to = Math.max(last.to, r$1.to);
		else merged.push({
			from: r$1.from,
			to: r$1.to
		});
	}
	return change.segments.every((seg) => merged.some((r$1) => r$1.from <= seg.from && r$1.to >= seg.to));
};
var runPermissionPreflight = ({ editor, decision, selections }) => {
	const resolver = editor?.options?.permissionResolver;
	if (typeof resolver !== "function") return { ok: true };
	const role = editor.options?.role ?? "editor";
	const isInternal = Boolean(editor.options?.isInternal);
	const currentIdentity = getCurrentUserIdentity(editor);
	for (const selection of selections) {
		const change = selection.change;
		const isOwn = isSameUserHighConfidence(classifyOwnership({
			currentUser: currentIdentity,
			change: getChangeAuthorIdentity({
				author: change.author,
				authorId: change.authorId,
				authorEmail: change.authorEmail,
				importedAuthor: change.importedAuthor
			})
		}));
		const permission = decision === "accept" ? isOwn ? "RESOLVE_OWN" : "RESOLVE_OTHER" : isOwn ? "REJECT_OWN" : "REJECT_OTHER";
		if (resolver({
			permission,
			role,
			isInternal,
			trackedChange: {
				id: change.id,
				type: change.type,
				attrs: {
					author: change.author,
					authorId: change.authorId,
					authorEmail: change.authorEmail,
					date: change.date
				},
				from: selection.ranges[0]?.from ?? 0,
				to: selection.ranges[selection.ranges.length - 1]?.to ?? 0,
				segments: change.segments.map((s) => ({
					from: s.from,
					to: s.to
				})),
				commentId: change.id
			},
			comment: null
		}) === false) return {
			ok: false,
			failure: failure$3("PERMISSION_DENIED", `permission denied for ${decision} of change "${change.id}".`, { details: {
				changeId: change.id,
				permission
			} })
		};
	}
	return { ok: true };
};
var buildMutationPlan = ({ state, graph, selections, decision }) => {
	const ops = [];
	const removedRanges = [];
	const resolvedRanges = [];
	const touched = /* @__PURE__ */ new Set();
	const retired = /* @__PURE__ */ new Set();
	const diagnostics = [];
	const structuralTableRemovals = [];
	for (const selection of selections) {
		const change = selection.change;
		if (change.type !== CanonicalChangeType.Structural) continue;
		const structural = change.structural;
		if (!structural || structural.wholeTable !== true || structural.decidable === false) continue;
		if (!(structural.side === "insertion" && decision === "reject" || structural.side === "deletion" && decision === "accept")) continue;
		structuralTableRemovals.push({
			from: structural.tableFrom,
			to: structural.tableTo,
			structuralId: change.id
		});
	}
	const suppressedInsideTable = /* @__PURE__ */ new Set();
	const isInsideRemovedTable = (change) => structuralTableRemovals.length > 0 && change.type !== CanonicalChangeType.Structural && change.segments.length > 0 && change.segments.every((seg) => structuralTableRemovals.some((range) => range.from <= seg.from && range.to >= seg.to));
	const structuralTableStays = [];
	for (const selection of selections) {
		const change = selection.change;
		if (change.type !== CanonicalChangeType.Structural) continue;
		const structural = change.structural;
		if (!structural || structural.wholeTable !== true || structural.decidable === false) continue;
		if (!(structural.side === "insertion" && decision === "accept" || structural.side === "deletion" && decision === "reject")) continue;
		structuralTableStays.push({
			from: structural.tableFrom,
			to: structural.tableTo,
			structuralId: change.id
		});
	}
	const isInsideStayingTable = (change) => structuralTableStays.length > 0 && change.type !== CanonicalChangeType.Structural && change.segments.length > 0 && change.segments.every((seg) => structuralTableStays.some((range) => range.from <= seg.from && range.to >= seg.to));
	const cascadedInsideStayingTable = /* @__PURE__ */ new Set();
	const planContainedInlineChild = (change) => {
		if (cascadedInsideStayingTable.has(change.id)) return null;
		cascadedInsideStayingTable.add(change.id);
		touched.add(change.id);
		const fullSelection = {
			change,
			coverage: "full",
			ranges: change.segments.map((s) => ({
				from: s.from,
				to: s.to
			}))
		};
		if (change.type === CanonicalChangeType.Insertion) {
			planInsertionDecision({
				ops,
				change,
				selection: fullSelection,
				decision,
				removedRanges,
				retired
			});
			return null;
		}
		if (change.type === CanonicalChangeType.Deletion) {
			planDeletionDecision({
				ops,
				change,
				selection: fullSelection,
				decision,
				removedRanges,
				retired
			});
			return null;
		}
		if (change.type === CanonicalChangeType.Replacement) {
			const repResult = planReplacementDecision({
				ops,
				graph,
				change,
				decision,
				removedRanges,
				retired
			});
			if (!repResult.ok) return repResult.failure;
			return null;
		}
		if (change.type === CanonicalChangeType.Formatting) {
			planFormattingDecision({
				ops,
				change,
				decision,
				retired
			});
			return null;
		}
		cascadedInsideStayingTable.delete(change.id);
		touched.delete(change.id);
		return null;
	};
	for (const selection of selections) {
		const { change } = selection;
		if (isInsideRemovedTable(change)) {
			retired.add(change.id);
			touched.add(change.id);
			suppressedInsideTable.add(change.id);
			continue;
		}
		if (isInsideStayingTable(change)) {
			const failureResult = planContainedInlineChild(change);
			if (failureResult) return {
				ok: false,
				failure: failureResult
			};
			continue;
		}
		const isFull = selection.coverage === "full";
		if (!isFull) {
			if (change.type === CanonicalChangeType.Structural) return {
				ok: false,
				failure: failure$3("INVALID_INPUT", "partial-range decisions are not valid on an indivisible structural revision.", { details: {
					changeId: change.id,
					subtype: change.subtype
				} })
			};
			if (change.type === CanonicalChangeType.Replacement) return {
				ok: false,
				failure: failure$3("CAPABILITY_UNAVAILABLE", "partial-range replacement decisions are not yet fixture-backed.", { details: { changeId: change.id } })
			};
			if (change.type === CanonicalChangeType.Formatting) return {
				ok: false,
				failure: failure$3("CAPABILITY_UNAVAILABLE", "partial-range formatting decisions are not yet fixture-backed.", { details: { changeId: change.id } })
			};
		}
		touched.add(change.id);
		if (isFull) for (const segment of change.segments) resolvedRanges.push({
			from: segment.from,
			to: segment.to,
			cause: `${decision}:${change.id}`
		});
		if (change.type === CanonicalChangeType.Structural) {
			const structuralResult = planStructuralDecision({
				ops,
				change,
				decision,
				removedRanges,
				retired
			});
			if (!structuralResult.ok) return {
				ok: false,
				failure: structuralResult.failure
			};
		} else if (!isFull && (change.type === CanonicalChangeType.Insertion || change.type === CanonicalChangeType.Deletion)) {
			const partialResult = planPartialTextDecision({
				ops,
				change,
				selection,
				decision,
				removedRanges,
				retired
			});
			if (!partialResult.ok) return {
				ok: false,
				failure: partialResult.failure
			};
			for (const id of partialResult.createdChangeIds) touched.add(id);
		} else if (change.type === CanonicalChangeType.Insertion) planInsertionDecision({
			ops,
			change,
			selection,
			decision,
			removedRanges,
			retired
		});
		else if (change.type === CanonicalChangeType.Deletion) planDeletionDecision({
			ops,
			change,
			selection,
			decision,
			removedRanges,
			retired
		});
		else if (change.type === CanonicalChangeType.Replacement) {
			const repResult = planReplacementDecision({
				ops,
				graph,
				change,
				decision,
				removedRanges,
				retired
			});
			if (!repResult.ok) return {
				ok: false,
				failure: repResult.failure
			};
		} else if (change.type === CanonicalChangeType.Formatting) planFormattingDecision({
			ops,
			change,
			decision,
			retired
		});
		else return {
			ok: false,
			failure: failure$3("CAPABILITY_UNAVAILABLE", `unsupported change type "${change.type}" for change "${change.id}".`)
		};
	}
	if (structuralTableStays.length > 0) {
		const decidedObjects = new Set(selections.map((selection) => selection.change));
		const seenStaying = /* @__PURE__ */ new Set();
		for (const change of graph.changes.values()) {
			if (seenStaying.has(change)) continue;
			seenStaying.add(change);
			if (decidedObjects.has(change) || cascadedInsideStayingTable.has(change.id)) continue;
			if (!isInsideStayingTable(change)) continue;
			const failureResult = planContainedInlineChild(change);
			if (failureResult) return {
				ok: false,
				failure: failureResult
			};
		}
	}
	if (!ops.length) return {
		ok: false,
		failure: failure$3("NO_OP", "decision target produced no operations.", { details: { selections: selections.map((s) => s.change.id) } })
	};
	const affectedChildren = [];
	for (const id of suppressedInsideTable) affectedChildren.push({ changeId: id });
	for (const id of cascadedInsideStayingTable) affectedChildren.push({ changeId: id });
	const seenChange = /* @__PURE__ */ new Set();
	for (const change of graph.changes.values()) {
		if (seenChange.has(change)) continue;
		seenChange.add(change);
		if (touched.has(change.id)) continue;
		const insideRemoved = change.segments.length ? change.segments.every((seg) => removedRanges.some((r$1) => r$1.from <= seg.from && r$1.to >= seg.to)) : false;
		if (insideRemoved && isInsideRemovedTable(change)) {
			retired.add(change.id);
			touched.add(change.id);
			affectedChildren.push({ changeId: change.id });
			continue;
		}
		if (!change.parent) continue;
		if (!retired.has(change.parent) && !touched.has(change.parent)) continue;
		if (insideRemoved) {
			retired.add(change.id);
			touched.add(change.id);
			affectedChildren.push({ changeId: change.id });
		}
	}
	const commentEffects = planCommentEffects({
		doc: state.doc,
		removedRanges,
		resolvedRanges
	});
	for (const del$1 of commentEffects.nodeDeletes) ops.push({
		kind: "removeContent",
		from: del$1.from,
		to: del$1.to
	});
	return {
		ok: true,
		plan: {
			ops,
			commentEffects: {
				...commentEffects,
				_affectedChildren: affectedChildren
			},
			touchedChangeIds: touched,
			retiredChangeIds: retired,
			diagnostics
		}
	};
};
var planInsertionDecision = ({ ops, change, selection, decision, removedRanges, retired }) => {
	const isFull = selection.coverage === "full";
	if (decision === "accept") {
		const ranges$1 = isFull ? change.insertedSegments.map((s) => ({
			from: s.from,
			to: s.to
		})) : selection.ranges;
		for (const range of ranges$1) pushRemoveMarkOpsForRange({
			ops,
			segments: change.insertedSegments,
			range,
			changeId: change.id,
			side: SegmentSide.Inserted
		});
		if (isFull) retired.add(change.id);
		return;
	}
	const ranges = isFull ? change.insertedSegments.map((s) => ({
		from: s.from,
		to: s.to
	})) : selection.ranges;
	for (const range of ranges) {
		ops.push({
			kind: "removeContent",
			from: range.from,
			to: range.to,
			changeId: change.id,
			side: SegmentSide.Inserted
		});
		removedRanges.push({
			from: range.from,
			to: range.to,
			cause: `reject-insertion:${change.id}`
		});
	}
	if (isFull) retired.add(change.id);
};
var planDeletionDecision = ({ ops, change, selection, decision, removedRanges, retired }) => {
	const isFull = selection.coverage === "full";
	if (decision === "accept") {
		const ranges$1 = isFull ? change.deletedSegments.map((s) => ({
			from: s.from,
			to: s.to
		})) : selection.ranges;
		for (const range of ranges$1) {
			ops.push({
				kind: "removeContent",
				from: range.from,
				to: range.to,
				changeId: change.id,
				side: SegmentSide.Deleted
			});
			removedRanges.push({
				from: range.from,
				to: range.to,
				cause: `accept-deletion:${change.id}`
			});
		}
		if (isFull) retired.add(change.id);
		return;
	}
	const ranges = isFull ? change.deletedSegments.map((s) => ({
		from: s.from,
		to: s.to
	})) : selection.ranges;
	for (const range of ranges) pushRemoveMarkOpsForRange({
		ops,
		segments: change.deletedSegments,
		range,
		changeId: change.id,
		side: SegmentSide.Deleted
	});
	if (isFull) retired.add(change.id);
};
var planStructuralDecision = ({ ops, change, decision, removedRanges, retired }) => {
	const structural = change.structural;
	if (!structural) return {
		ok: false,
		failure: failure$3("PRECONDITION_FAILED", `structural change "${change.id}" is missing its structural payload.`)
	};
	if (structural.decidable === false || !structural.wholeTable) return {
		ok: false,
		failure: failure$3("CAPABILITY_UNAVAILABLE", "structural row-level revisions (partial rows or mixed sides) are not decidable; only whole-table insert/delete is supported.", { details: {
			changeId: change.id,
			reason: structural.undecidableReason ?? "not-whole-table"
		} })
	};
	if (structural.side === "insertion" && decision === "reject" || structural.side === "deletion" && decision === "accept") {
		ops.push({
			kind: "removeContent",
			from: structural.tableFrom,
			to: structural.tableTo,
			changeId: change.id,
			side: structural.side === "insertion" ? SegmentSide.Inserted : SegmentSide.Deleted
		});
		removedRanges.push({
			from: structural.tableFrom,
			to: structural.tableTo,
			cause: `${decision}-structural:${change.id}`
		});
		retired.add(change.id);
		return { ok: true };
	}
	for (const row of structural.rows) ops.push({
		kind: "clearRowTrackChange",
		from: row.from,
		to: row.to,
		changeId: change.id
	});
	retired.add(change.id);
	return { ok: true };
};
var planReplacementDecision = ({ ops, graph, change, decision, removedRanges, retired }) => {
	const inserted = change.insertedSegments;
	const deleted = change.deletedSegments;
	if (!inserted.length || !deleted.length) return {
		ok: false,
		failure: failure$3("PRECONDITION_FAILED", `replacement "${change.id}" missing inserted or deleted side.`)
	};
	if (decision === "accept") {
		for (const seg of deleted) {
			ops.push({
				kind: "removeContent",
				from: seg.from,
				to: seg.to,
				changeId: change.id,
				side: SegmentSide.Deleted
			});
			removedRanges.push({
				from: seg.from,
				to: seg.to,
				cause: `accept-replacement-deleted:${change.id}`
			});
		}
		for (const seg of inserted) pushRemoveMarkOpsForSegment({
			ops,
			segment: seg,
			changeId: change.id,
			side: SegmentSide.Inserted
		});
	} else {
		for (const seg of inserted) {
			ops.push({
				kind: "removeContent",
				from: seg.from,
				to: seg.to,
				changeId: change.id,
				side: SegmentSide.Inserted
			});
			removedRanges.push({
				from: seg.from,
				to: seg.to,
				cause: `reject-replacement-inserted:${change.id}`
			});
		}
		const parentRestore = getParentRestoreContext({
			graph,
			change
		});
		for (const seg of deleted) {
			pushRemoveMarkOpsForSegment({
				ops,
				segment: seg,
				changeId: change.id,
				side: SegmentSide.Deleted
			});
			if (parentRestore?.mark) pushAddMarkOpsForSegment({
				ops,
				segment: seg,
				changeId: parentRestore.mark.attrs?.id || change.parent || change.id,
				side: parentRestore.mark.type.name === "trackInsert" ? SegmentSide.Inserted : SegmentSide.Deleted,
				mark: parentRestore.mark
			});
		}
		for (const sibling of parentRestore?.siblingSegments ?? []) {
			pushRemoveMarkOpsForSegment({
				ops,
				segment: sibling,
				changeId: sibling.changeId,
				side: sibling.side
			});
			pushAddMarkOpsForSegment({
				ops,
				segment: sibling,
				changeId: parentRestore.mark.attrs?.id || sibling.changeId,
				side: parentRestore.mark.type.name === "trackInsert" ? SegmentSide.Inserted : SegmentSide.Deleted,
				mark: parentRestore.mark
			});
			retired.add(sibling.changeId);
		}
	}
	retired.add(change.id);
	return { ok: true };
};
var getParentRestoreContext = ({ graph, change }) => {
	const explicit = getExplicitParentRestoreContext({
		graph,
		change
	});
	if (explicit) return explicit;
	return inferAdjacentParentRestoreContext({
		graph,
		change
	});
};
var getExplicitParentRestoreContext = ({ graph, change }) => {
	if (!change.parent) return null;
	const parent = graph.changes.get(change.parent);
	if (!parent) return null;
	if (parent.type === CanonicalChangeType.Insertion) {
		const mark = parent.insertedSegments[0]?.mark ?? null;
		return mark ? {
			mark,
			siblingSegments: []
		} : null;
	}
	if (parent.type === CanonicalChangeType.Deletion) {
		const mark = parent.deletedSegments[0]?.mark ?? null;
		return mark ? {
			mark,
			siblingSegments: []
		} : null;
	}
	return null;
};
var inferAdjacentParentRestoreContext = ({ graph, change }) => {
	if (!change.deletedSegments.length || !change.segments.length) return null;
	const from$1 = Math.min(...change.segments.map((segment) => segment.from));
	const to = Math.max(...change.segments.map((segment) => segment.to));
	const before = nearestSegmentBefore({
		graph,
		change,
		from: from$1
	});
	const after = nearestSegmentAfter({
		graph,
		change,
		to
	});
	if (!before || !after) return null;
	if (!areParentRestorePeers(before, after)) return null;
	return {
		mark: before.mark,
		siblingSegments: after.changeId === before.changeId ? [] : [after]
	};
};
var nearestSegmentBefore = ({ graph, change, from: from$1 }) => {
	return graph.segments.filter((segment) => segment.changeId !== change.id && segment.to <= from$1).sort((a, b$1) => b$1.to - a.to || b$1.from - a.from)[0];
};
var nearestSegmentAfter = ({ graph, change, to }) => {
	return graph.segments.filter((segment) => segment.changeId !== change.id && segment.from >= to).sort((a, b$1) => a.from - b$1.from || a.to - b$1.to)[0];
};
var areParentRestorePeers = (left$1, right$1) => {
	if (!left$1 || !right$1) return false;
	if (left$1.side !== right$1.side) return false;
	if (left$1.side !== SegmentSide.Inserted && left$1.side !== SegmentSide.Deleted) return false;
	if (left$1.markType !== right$1.markType) return false;
	return left$1.attrs.author === right$1.attrs.author && left$1.attrs.authorEmail === right$1.attrs.authorEmail && left$1.attrs.date === right$1.attrs.date;
};
var planFormattingDecision = ({ ops, change, decision, retired }) => {
	for (const seg of change.formattingSegments) {
		if (decision === "accept") {
			pushRemoveMarkOpsForSegment({
				ops,
				segment: seg,
				changeId: change.id,
				side: SegmentSide.Formatting
			});
			continue;
		}
		for (const run of getSegmentMarkRuns(seg)) {
			const paragraphSplit = snapshotAttrsForType(run.mark.attrs?.before, "paragraphSplit");
			if (paragraphSplit) ops.push({
				kind: "rejectParagraphSplit",
				from: run.from,
				to: run.to,
				changeId: change.id,
				side: SegmentSide.Formatting,
				mark: run.mark,
				anchor: paragraphSplit.anchor === "source" ? "source" : "inserted"
			});
			else ops.push({
				kind: "restoreFormat",
				from: run.from,
				to: run.to,
				changeId: change.id,
				side: SegmentSide.Formatting,
				mark: run.mark,
				beforeMarks: run.mark.attrs?.before ?? [],
				afterMarks: run.mark.attrs?.after ?? []
			});
		}
	}
	retired.add(change.id);
};
var snapshotAttrsForType = (snapshots, type) => {
	if (!Array.isArray(snapshots)) return null;
	const snapshot = snapshots.find((entry) => entry?.type === type);
	return snapshot?.attrs && typeof snapshot.attrs === "object" ? snapshot.attrs : null;
};
var planPartialTextDecision = ({ ops, change, selection, decision, removedRanges, retired }) => {
	const side = change.type === CanonicalChangeType.Insertion ? SegmentSide.Inserted : SegmentSide.Deleted;
	const segments = side === SegmentSide.Inserted ? change.insertedSegments : change.deletedSegments;
	if (!segments.length) return {
		ok: false,
		failure: failure$3("PRECONDITION_FAILED", `change "${change.id}" has no ${side} segments.`)
	};
	const selectedRanges = mergeRanges(selection.ranges);
	const successorRanges = [];
	let logicalOffset = 0;
	let successorOrdinal = 0;
	for (const segment of segments) {
		pushRemoveMarkOpsForSegment({
			ops,
			segment,
			changeId: change.id,
			side
		});
		const pieces = subtractRanges({
			from: segment.from,
			to: segment.to
		}, selectedRanges);
		for (const piece of pieces) {
			const offsetStart = logicalOffset + (piece.from - segment.from);
			const offsetEnd = logicalOffset + (piece.to - segment.from);
			const successorId = deterministicSuccessorId({
				sourceId: change.id,
				revisionGroupId: segment.attrs?.revisionGroupId || change.revisionGroupId || change.id,
				side,
				offsetStart,
				offsetEnd,
				decision,
				ordinal: successorOrdinal
			});
			successorOrdinal += 1;
			const successorMark = segment.mark.type.create({
				...segment.mark.attrs,
				id: successorId,
				splitFromId: change.id,
				revisionGroupId: segment.attrs?.revisionGroupId || change.revisionGroupId || change.id
			});
			ops.push({
				kind: "addMark",
				from: piece.from,
				to: piece.to,
				changeId: successorId,
				side,
				mark: successorMark
			});
			successorRanges.push({
				id: successorId,
				from: piece.from,
				to: piece.to
			});
		}
		logicalOffset += segment.to - segment.from;
	}
	for (const range of selectedRanges) if (change.type === CanonicalChangeType.Insertion && decision === "reject") {
		ops.push({
			kind: "removeContent",
			from: range.from,
			to: range.to,
			changeId: change.id,
			side
		});
		removedRanges.push({
			from: range.from,
			to: range.to,
			cause: `partial-reject-insertion:${change.id}`
		});
	} else if (change.type === CanonicalChangeType.Deletion && decision === "accept") {
		ops.push({
			kind: "removeContent",
			from: range.from,
			to: range.to,
			changeId: change.id,
			side
		});
		removedRanges.push({
			from: range.from,
			to: range.to,
			cause: `partial-accept-deletion:${change.id}`
		});
	}
	retired.add(change.id);
	return {
		ok: true,
		createdChangeIds: successorRanges.map((entry) => entry.id)
	};
};
var pushRemoveMarkOpsForRange = ({ ops, segments, range, changeId, side }) => {
	for (const segment of segments) {
		if (segment.to <= range.from || segment.from >= range.to) continue;
		pushRemoveMarkOpsForSegment({
			ops,
			segment,
			changeId,
			side,
			from: Math.max(segment.from, range.from),
			to: Math.min(segment.to, range.to)
		});
	}
};
var pushRemoveMarkOpsForSegment = ({ ops, segment, changeId, side, from: from$1 = segment.from, to = segment.to }) => {
	for (const run of getSegmentMarkRuns(segment)) {
		const clippedFrom = Math.max(from$1, run.from);
		const clippedTo = Math.min(to, run.to);
		if (clippedFrom >= clippedTo) continue;
		ops.push({
			kind: "removeMark",
			from: clippedFrom,
			to: clippedTo,
			changeId,
			side,
			mark: run.mark
		});
	}
};
var pushAddMarkOpsForSegment = ({ ops, segment, changeId, side, mark, from: from$1 = segment.from, to = segment.to }) => {
	for (const run of getSegmentMarkRuns(segment)) {
		const clippedFrom = Math.max(from$1, run.from);
		const clippedTo = Math.min(to, run.to);
		if (clippedFrom >= clippedTo) continue;
		ops.push({
			kind: "addMark",
			from: clippedFrom,
			to: clippedTo,
			changeId,
			side,
			mark
		});
	}
};
var getSegmentMarkRuns = (segment) => {
	return segment.markRuns?.length ? segment.markRuns : [{
		from: segment.from,
		to: segment.to,
		mark: segment.mark
	}];
};
var mergeRanges = (ranges) => {
	const sorted = ranges.filter((range) => range.from < range.to).map((range) => ({
		from: range.from,
		to: range.to
	})).sort((a, b$1) => a.from - b$1.from || a.to - b$1.to);
	const merged = [];
	for (const range of sorted) {
		const last = merged[merged.length - 1];
		if (last && range.from <= last.to) last.to = Math.max(last.to, range.to);
		else merged.push(range);
	}
	return merged;
};
var subtractRanges = (range, removals) => {
	let pieces = [range];
	for (const removal of removals) {
		const next = [];
		for (const piece of pieces) {
			if (removal.to <= piece.from || removal.from >= piece.to) {
				next.push(piece);
				continue;
			}
			if (removal.from > piece.from) next.push({
				from: piece.from,
				to: Math.min(removal.from, piece.to)
			});
			if (removal.to < piece.to) next.push({
				from: Math.max(removal.to, piece.from),
				to: piece.to
			});
		}
		pieces = next;
	}
	return pieces.filter((piece) => piece.from < piece.to);
};
var deterministicSuccessorId = ({ sourceId, revisionGroupId, side, offsetStart, offsetEnd, decision, ordinal }) => {
	const input = `${sourceId}|${revisionGroupId}|${side}|${offsetStart}|${offsetEnd}|${decision}|${ordinal}`;
	let hash$3 = 2166136261;
	for (let i = 0; i < input.length; i += 1) {
		hash$3 ^= input.charCodeAt(i);
		hash$3 = Math.imul(hash$3, 16777619);
	}
	return `${sourceId}~${side}~${(hash$3 >>> 0).toString(36)}`;
};
var findTextblockAt = (doc$1, pos) => {
	const bounded = Math.max(0, Math.min(pos, doc$1.content.size));
	const $pos = doc$1.resolve(bounded);
	for (let depth = $pos.depth; depth > 0; depth -= 1) {
		const node = $pos.node(depth);
		if (node.isTextblock) return {
			pos: $pos.before(depth),
			node
		};
	}
	return null;
};
var rejectParagraphSplitAt = (tr, from$1, anchor = "inserted") => {
	const block = findTextblockAt(tr.doc, from$1);
	if (!block) return false;
	const joinPos = anchor === "source" ? block.pos + block.node.nodeSize : block.pos;
	if (joinPos <= 0 || joinPos >= tr.doc.content.size || !canJoin(tr.doc, joinPos)) return false;
	tr.join(joinPos);
	return true;
};
var applyPlan = ({ state, plan }) => {
	const tr = state.tr;
	tr.setMeta("inputType", "acceptReject");
	const sortedOps = [...plan.ops].sort((a, b$1) => a.from - b$1.from || a.to - b$1.to);
	const markOps = sortedOps.filter((op) => op.kind !== "removeContent");
	const contentOps = sortedOps.filter((op) => op.kind === "removeContent").reverse();
	const splitJoinOps = sortedOps.filter((op) => op.kind === "rejectParagraphSplit").reverse();
	try {
		for (const op of markOps) {
			if (op.kind === "removeMark" && op.mark) {
				tr.step(new RemoveMarkStep(op.from, op.to, op.mark));
				continue;
			}
			if (op.kind === "addMark" && op.mark) {
				tr.step(new AddMarkStep(op.from, op.to, op.mark));
				continue;
			}
			if (op.kind === "restoreFormat" && op.mark) {
				for (const afterSnapshot of op.afterMarks ?? []) {
					const liveMark = findMarkInRangeBySnapshot({
						doc: tr.doc,
						from: op.from,
						to: op.to,
						snapshot: afterSnapshot
					});
					if (liveMark) tr.step(new RemoveMarkStep(op.from, op.to, liveMark));
				}
				for (const beforeSnapshot of op.beforeMarks ?? []) {
					const markType = state.schema.marks[beforeSnapshot.type];
					if (!markType) continue;
					tr.step(new AddMarkStep(op.from, op.to, markType.create(beforeSnapshot.attrs)));
				}
				tr.step(new RemoveMarkStep(op.from, op.to, op.mark));
				continue;
			}
			if (op.kind === "rejectParagraphSplit" && op.mark) {
				tr.step(new RemoveMarkStep(op.from, op.to, op.mark));
				continue;
			}
			if (op.kind === "clearRowTrackChange") {
				const mappedFrom = tr.mapping.map(op.from, 1);
				const rowNode = tr.doc.nodeAt(mappedFrom);
				if (rowNode && rowNode.type.name === "tableRow") tr.setNodeMarkup(mappedFrom, void 0, {
					...rowNode.attrs,
					trackChange: null
				});
				continue;
			}
		}
		for (const op of contentOps) tr.step(new ReplaceStep(op.from, op.to, Slice.empty));
		for (const op of splitJoinOps) if (!rejectParagraphSplitAt(tr, tr.mapping.map(op.from, 1), op.anchor)) throw new Error(`could not join paragraph split for tracked change "${op.changeId ?? ""}".`);
	} catch (error) {
		return {
			ok: false,
			failure: failure$3("PRECONDITION_FAILED", error.message ?? "failed to apply mutation plan.", { details: { error: String(error) } })
		};
	}
	tr.setMeta(TrackChangesBasePluginKey, {
		insertedMark: null,
		deletionMark: null,
		deletionNodes: [],
		step: null,
		emitCommentEvent: true,
		decisionTouchedChangeIds: Array.from(plan.touchedChangeIds),
		decisionRetiredChangeIds: Array.from(plan.retiredChangeIds)
	});
	tr.setMeta(CommentsPluginKey, { type: "force" });
	tr.setMeta("skipTrackChanges", true);
	return {
		ok: true,
		tr,
		touchedChangeIds: plan.touchedChangeIds,
		receipt: buildReceipt({ plan })
	};
};
var buildReceipt = ({ plan }) => {
	return {
		createdChangeIds: collectCreatedChangeIds(plan),
		updatedChangeIds: [],
		removedChangeIds: Array.from(plan.retiredChangeIds).map((id) => ({
			id,
			cause: "decision"
		})),
		deletedComments: plan.commentEffects.entityDeletes,
		detachedComments: plan.commentEffects.entityDetaches,
		shrunkenComments: plan.commentEffects.entityShrinks.map(({ id, cause }) => ({
			id,
			cause
		})),
		affectedChildren: plan.commentEffects._affectedChildren ?? []
	};
};
var collectCreatedChangeIds = (plan) => {
	const ids = /* @__PURE__ */ new Set();
	for (const op of plan.ops) if (op.kind === "addMark" && op.changeId) ids.add(op.changeId);
	return Array.from(ids);
};
const buildDecisionBubbleEvents = ({ result, editor }) => {
	const resolvedById = editor?.options?.user?.id;
	const resolvedByEmail = editor?.options?.user?.email;
	const resolvedByName = editor?.options?.user?.name;
	const events = [];
	for (const entry of result.receipt.removedChangeIds) events.push({
		type: "trackedChange",
		event: "resolve",
		changeId: entry.id,
		resolvedById,
		resolvedByEmail,
		resolvedByName
	});
	for (const child of result.receipt.affectedChildren) events.push({
		type: "trackedChange",
		event: "resolve",
		changeId: child.changeId,
		resolvedById,
		resolvedByEmail,
		resolvedByName
	});
	return events;
};
var getTrackChangesStorage = (editor) => {
	const storage = editor?.storage?.trackChanges;
	if (!storage || typeof storage !== "object") return null;
	return storage;
};
var readReplacementsMode$1 = (editor) => editor?.options?.trackedChanges?.replacements === "independent" ? "independent" : "paired";
var dispatchReviewDecision = ({ editor, state, dispatch, decision, target }) => {
	const trackChangesStorage = getTrackChangesStorage(editor);
	if (trackChangesStorage) {
		trackChangesStorage.lastDecisionFailure = null;
		trackChangesStorage.lastDecisionReceipt = null;
	}
	const result = decideTrackedChanges({
		state,
		editor,
		decision,
		target,
		replacements: readReplacementsMode$1(editor)
	});
	if (result.ok === false) {
		if (trackChangesStorage) trackChangesStorage.lastDecisionFailure = {
			code: result.code,
			message: result.message,
			details: result.details
		};
		return {
			applied: false,
			failure: result
		};
	}
	if (trackChangesStorage) trackChangesStorage.lastDecisionReceipt = result.receipt ?? null;
	if (dispatch) {
		const nextState = state.apply(result.tr);
		dispatch(result.tr);
		if (editor?.emit) {
			const documentId = editor.options?.documentId;
			const resolveEvents = buildDecisionBubbleEvents({
				result,
				editor
			});
			for (const event of resolveEvents) {
				if (collectRemainingForLogicalId({
					state: nextState,
					originalId: event.changeId
				}).some(({ mark }) => mark.attrs?.splitFromId === event.changeId)) continue;
				editor.emit("commentsUpdate", event);
			}
			const touched = result.touchedChangeIds instanceof Set ? result.touchedChangeIds : new Set(result.touchedChangeIds || []);
			const emittedFor = /* @__PURE__ */ new Set();
			for (const changeId of touched) {
				if (emittedFor.has(changeId)) continue;
				if (Array.from(touched).some((other) => other !== changeId && isSuccessorOf({
					state: nextState,
					id: changeId,
					originalId: other
				}))) continue;
				const remaining = collectRemainingForLogicalId({
					state: nextState,
					originalId: changeId
				});
				if (!remaining.length) continue;
				const payload = buildPartialUpdatePayload({
					state: nextState,
					documentId,
					originalId: changeId,
					remaining
				});
				if (payload) {
					editor.emit("commentsUpdate", payload);
					emittedFor.add(changeId);
				}
			}
			const deletedCommentIds = new Set((result.receipt?.deletedComments ?? []).map(({ id }) => id).filter(Boolean));
			const detachedCommentIds = new Set((result.receipt?.detachedComments ?? []).map(({ id }) => id).filter((id) => id && !deletedCommentIds.has(id)));
			for (const commentId of deletedCommentIds) editor.emit("commentsUpdate", buildDeletedCommentPayload({
				commentId,
				documentId
			}));
			for (const commentId of detachedCommentIds) editor.emit("commentsUpdate", buildDetachedCommentUpdatePayload({
				commentId,
				documentId
			}));
		}
	}
	return {
		applied: true,
		result
	};
};
var collectRemainingForLogicalId = ({ state, originalId }) => {
	return getTrackChanges(state).filter(({ mark }) => mark.attrs?.id === originalId || mark.attrs?.splitFromId === originalId);
};
var isSuccessorOf = ({ state, id, originalId }) => {
	return getTrackChanges(state).some(({ mark }) => mark.attrs?.id === id && mark.attrs?.splitFromId === originalId);
};
var buildPartialUpdatePayload = ({ state, documentId, originalId, remaining }) => {
	let insertedMark = null;
	let deletionMark = null;
	let formatMark = null;
	for (const entry of remaining) {
		if (!insertedMark && entry.mark.type.name === "trackInsert") insertedMark = entry.mark;
		if (!deletionMark && entry.mark.type.name === "trackDelete") deletionMark = entry.mark;
		if (!formatMark && entry.mark.type.name === "trackFormat") formatMark = entry.mark;
	}
	const anchorMark = insertedMark || deletionMark || formatMark;
	if (!anchorMark) return null;
	const insertedText = remaining.filter(({ mark }) => mark.type.name === TrackInsertMarkName).map(({ node }) => node?.text || node?.textContent || "").join("");
	const deletedText = remaining.filter(({ mark }) => mark.type.name === TrackDeleteMarkName).map(({ node }) => node?.text || node?.textContent || "").join("");
	const trackedChangeType = insertedMark ? TrackInsertMarkName : deletionMark ? TrackDeleteMarkName : TrackFormatMarkName;
	const isReplacement = Boolean(insertedMark && deletionMark);
	const { author, authorId, authorEmail, authorImage, date, importedAuthor } = anchorMark.attrs;
	return {
		event: "update",
		type: "trackedChange",
		documentId,
		changeId: originalId,
		trackedChangeType: isReplacement ? "both" : trackedChangeType,
		trackedChangeText: trackedChangeType === "trackDelete" ? deletedText : insertedText,
		trackedChangeDisplayType: null,
		deletedText: isReplacement || deletionMark ? deletedText : null,
		author,
		...authorId && { authorId },
		authorEmail,
		...authorImage && { authorImage },
		date,
		...importedAuthor && { importedAuthor: { name: importedAuthor } }
	};
};
var buildDetachedCommentUpdatePayload = ({ commentId, documentId }) => ({
	type: "update",
	comment: {
		commentId,
		documentId,
		fileId: documentId ?? null,
		trackedChange: false,
		trackedChangeParentId: null,
		trackedChangeType: null,
		trackedChangeDisplayType: null,
		trackedChangeText: null,
		trackedChangeStory: null,
		trackedChangeStoryKind: null,
		trackedChangeStoryLabel: null,
		trackedChangeAnchorKey: null,
		deletedText: null
	}
});
var buildDeletedCommentPayload = ({ commentId, documentId }) => ({
	type: "deleted",
	comment: {
		commentId,
		documentId,
		fileId: documentId ?? null
	}
});
const TrackChanges = Extension.create({
	name: "trackChanges",
	addStorage() {
		return {
			lastCompilerFailure: null,
			lastDecisionFailure: null,
			lastDecisionReceipt: null
		};
	},
	addCommands() {
		return {
			acceptTrackedChangesBetween: (from$1, to) => ({ state, dispatch, editor }) => {
				return dispatchReviewDecision({
					editor,
					state,
					dispatch,
					decision: "accept",
					target: {
						kind: "range",
						from: from$1,
						to
					}
				}).applied;
			},
			rejectTrackedChangesBetween: (from$1, to) => ({ state, dispatch, editor }) => {
				return dispatchReviewDecision({
					editor,
					state,
					dispatch,
					decision: "reject",
					target: {
						kind: "range",
						from: from$1,
						to
					}
				}).applied;
			},
			acceptTrackedChange: ({ trackedChange }) => ({ commands: commands$1 }) => {
				const { start: from$1, end: to } = trackedChange;
				return commands$1.acceptTrackedChangesBetween(from$1, to);
			},
			acceptTrackedChangeBySelection: () => ({ state, commands: commands$1 }) => {
				const { from: from$1, to } = state.selection;
				return commands$1.acceptTrackedChangesBetween(from$1, to);
			},
			acceptTrackedChangeFromToolbar: () => ({ state, commands: commands$1, editor }) => {
				return resolveTrackedChangeAction({
					action: "accept",
					state,
					commands: commands$1,
					editor,
					...getTrackedChangeResolutionContext({
						state,
						trackedChangeId: CommentsPluginKey.getState(state)?.activeThreadId
					})
				});
			},
			acceptTrackedChangeFromContextMenu: ({ from: from$1 = null, to = null, trackedChangeId = null } = {}) => ({ state, commands: commands$1, editor }) => {
				return resolveTrackedChangeAction({
					action: "accept",
					state,
					commands: commands$1,
					editor,
					selection: Number.isFinite(from$1) && Number.isFinite(to) ? {
						from: from$1,
						to
					} : null,
					...getTrackedChangeResolutionContext({
						state,
						trackedChangeId
					})
				});
			},
			acceptTrackedChangeById: (id) => ({ state, dispatch, editor }) => {
				return dispatchReviewDecision({
					editor,
					state,
					dispatch,
					decision: "accept",
					target: {
						kind: "id",
						id
					}
				}).applied;
			},
			acceptAllTrackedChanges: () => ({ state, dispatch, editor }) => {
				return dispatchReviewDecision({
					editor,
					state,
					dispatch,
					decision: "accept",
					target: { kind: "all" }
				}).applied;
			},
			rejectTrackedChangeById: (id) => ({ state, dispatch, editor }) => {
				return dispatchReviewDecision({
					editor,
					state,
					dispatch,
					decision: "reject",
					target: {
						kind: "id",
						id
					}
				}).applied;
			},
			rejectTrackedChange: ({ trackedChange }) => ({ commands: commands$1 }) => {
				const { start: from$1, end: to } = trackedChange;
				return commands$1.rejectTrackedChangesBetween(from$1, to);
			},
			rejectTrackedChangeOnSelection: () => ({ state, commands: commands$1 }) => {
				const { from: from$1, to } = state.selection;
				return commands$1.rejectTrackedChangesBetween(from$1, to);
			},
			rejectTrackedChangeFromToolbar: () => ({ state, commands: commands$1, editor }) => {
				return resolveTrackedChangeAction({
					action: "reject",
					state,
					commands: commands$1,
					editor,
					...getTrackedChangeResolutionContext({
						state,
						trackedChangeId: CommentsPluginKey.getState(state)?.activeThreadId
					})
				});
			},
			rejectTrackedChangeFromContextMenu: ({ from: from$1 = null, to = null, trackedChangeId = null } = {}) => ({ state, commands: commands$1, editor }) => {
				return resolveTrackedChangeAction({
					action: "reject",
					state,
					commands: commands$1,
					editor,
					selection: Number.isFinite(from$1) && Number.isFinite(to) ? {
						from: from$1,
						to
					} : null,
					...getTrackedChangeResolutionContext({
						state,
						trackedChangeId
					})
				});
			},
			rejectAllTrackedChanges: () => ({ state, dispatch, editor }) => {
				return dispatchReviewDecision({
					editor,
					state,
					dispatch,
					decision: "reject",
					target: { kind: "all" }
				}).applied;
			},
			insertTrackedChange: (options = {}) => ({ state, dispatch, editor }) => {
				const { from: from$1 = state.selection.from, to = state.selection.to, text = "", id, user, comment, addToHistory = true, emitCommentEvent = true } = options;
				const docSize = state.doc.content.size;
				if (from$1 < 0 || to > docSize || from$1 > to) {
					console.warn("insertTrackedChange: invalid range", {
						from: from$1,
						to,
						docSize
					});
					return false;
				}
				if (state.doc.textBetween(from$1, to, "", "") === text) return false;
				if (!dispatch) return true;
				const resolvedUser = user ?? editor?.options?.user ?? {};
				if (!resolvedUser.name && !resolvedUser.email) console.warn("insertTrackedChange: no user name/email provided, track change will have undefined author");
				return dispatchCompiledInsertTrackedChange({
					editor,
					state,
					dispatch,
					from: from$1,
					to,
					text,
					resolvedUser,
					date: (/* @__PURE__ */ new Date()).toISOString(),
					providedId: id,
					comment,
					addToHistory,
					emitCommentEvent
				});
			},
			toggleTrackChanges: () => ({ state }) => {
				const trackChangeState = TrackChangesBasePluginKey.getState(state);
				if (trackChangeState === void 0) return false;
				state.tr.setMeta(TrackChangesBasePluginKey, {
					type: "TRACK_CHANGES_ENABLE",
					value: !trackChangeState.isTrackChangesActive
				});
				return true;
			},
			enableTrackChanges: () => ({ state }) => {
				state.tr.setMeta(TrackChangesBasePluginKey, {
					type: "TRACK_CHANGES_ENABLE",
					value: true
				});
				return true;
			},
			disableTrackChanges: () => ({ state }) => {
				state.tr.setMeta(TrackChangesBasePluginKey, {
					type: "TRACK_CHANGES_ENABLE",
					value: false
				});
				return true;
			},
			toggleTrackChangesShowOriginal: () => ({ state }) => {
				const trackChangeState = TrackChangesBasePluginKey.getState(state);
				if (trackChangeState === void 0) return false;
				state.tr.setMeta(TrackChangesBasePluginKey, {
					type: "SHOW_ONLY_ORIGINAL",
					value: !trackChangeState.onlyOriginalShown
				});
				return true;
			},
			enableTrackChangesShowOriginal: () => ({ state }) => {
				state.tr.setMeta(TrackChangesBasePluginKey, {
					type: "SHOW_ONLY_ORIGINAL",
					value: true
				});
				return true;
			},
			disableTrackChangesShowOriginal: () => ({ state }) => {
				state.tr.setMeta(TrackChangesBasePluginKey, {
					type: "SHOW_ONLY_ORIGINAL",
					value: false
				});
				return true;
			},
			toggleTrackChangesShowFinal: () => ({ state }) => {
				const trackChangeState = TrackChangesBasePluginKey.getState(state);
				if (trackChangeState === void 0) return false;
				state.tr.setMeta(TrackChangesBasePluginKey, {
					type: "SHOW_ONLY_MODIFIED",
					value: !trackChangeState.onlyModifiedShown
				});
				return true;
			},
			enableTrackChangesShowFinal: () => ({ state }) => {
				state.tr.setMeta(TrackChangesBasePluginKey, {
					type: "SHOW_ONLY_MODIFIED",
					value: true
				});
				return true;
			}
		};
	},
	addPmPlugins() {
		return [TrackChangesBasePlugin()];
	}
});
var getTrackedChangeActionSelection = ({ state, editor }) => {
	const currentSelection = state?.selection;
	if (hasExpandedSelection(currentSelection)) return currentSelection;
	const preservedSelection = editor?.options?.preservedSelection ?? editor?.options?.lastSelection;
	if (hasExpandedSelection(preservedSelection)) return preservedSelection;
	return currentSelection;
};
var getTrackedChangeResolutionContext = ({ state, trackedChangeId = null }) => {
	const commentsPluginState = CommentsPluginKey.getState(state);
	const resolvedTrackedChangeId = trackedChangeId ?? commentsPluginState?.activeThreadId ?? null;
	const hasTrackedChangeInCache = Boolean(resolvedTrackedChangeId && commentsPluginState?.trackedChanges?.[resolvedTrackedChangeId]);
	const hasTrackedChangeInDocument = Boolean(resolvedTrackedChangeId && getChangesByIdToResolve(state, resolvedTrackedChangeId)?.length);
	return {
		trackedChangeId: resolvedTrackedChangeId,
		hasKnownTrackedChangeId: hasTrackedChangeInCache || hasTrackedChangeInDocument
	};
};
var selectionTouchesTrackedChange = ({ state, trackedChangeId, selection = state?.selection }) => {
	if (!selection) return false;
	if (!trackedChangeId) return collectTrackedChanges({
		state,
		from: selection.from,
		to: selection.to
	}).length > 0;
	return collectTrackedChanges({
		state,
		from: selection.from,
		to: selection.to
	}).some((change) => change.id === trackedChangeId);
};
var resolveTrackedChangeAction = ({ action, state, commands: commands$1, editor, trackedChangeId = null, hasKnownTrackedChangeId = false, selection = null }) => {
	const targetSelection = selection ?? getTrackedChangeActionSelection({
		state,
		editor
	});
	const betweenCommand = action === "accept" ? commands$1.acceptTrackedChangesBetween : commands$1.rejectTrackedChangesBetween;
	const byIdCommand = action === "accept" ? commands$1.acceptTrackedChangeById : commands$1.rejectTrackedChangeById;
	const selectionCommand = action === "accept" ? commands$1.acceptTrackedChangeBySelection : commands$1.rejectTrackedChangeOnSelection;
	if (hasExpandedSelection(targetSelection) && selectionTouchesTrackedChange({
		state,
		trackedChangeId,
		selection: targetSelection
	})) return betweenCommand(targetSelection.from, targetSelection.to);
	if (trackedChangeId && hasKnownTrackedChangeId) return byIdCommand(trackedChangeId);
	return hasExpandedSelection(targetSelection) ? betweenCommand(targetSelection.from, targetSelection.to) : selectionCommand();
};
var getChangesByIdToResolve = (state, id) => {
	const trackedChanges = getTrackChanges(state);
	const changeIndex = trackedChanges.findIndex(({ mark }) => mark.attrs.id === id);
	if (changeIndex === -1) return;
	const matchingChange = trackedChanges[changeIndex];
	const matchingId = matchingChange.mark.attrs.id;
	const linkedBefore = [];
	const linkedAfter = [];
	const collectDirection = (direction, collection) => {
		let currentIndex = changeIndex;
		while (true) {
			const neighborIndex = currentIndex + direction;
			const neighbor = trackedChanges[neighborIndex];
			if (!neighbor) break;
			if (!(neighbor.mark.attrs.id === matchingId)) break;
			collection.push(neighbor);
			currentIndex = neighborIndex;
		}
	};
	collectDirection(-1, linkedBefore);
	collectDirection(1, linkedAfter);
	return [
		matchingChange,
		...linkedAfter,
		...linkedBefore
	];
};
var dispatchCompiledInsertTrackedChange = ({ editor, state, dispatch, from: from$1, to, text, resolvedUser, date, providedId, comment, addToHistory, emitCommentEvent }) => {
	const replacements = readReplacementsMode$1(editor);
	const tr = state.tr;
	const schema = state.schema;
	const trackChangesStorage = getTrackChangesStorage(editor);
	if (trackChangesStorage) trackChangesStorage.lastCompilerFailure = null;
	const activeMarks = state.storedMarks ?? state.doc.resolve(from$1).marks();
	let intent;
	try {
		if (from$1 === to && text) intent = makeTextInsertIntent({
			at: from$1,
			content: sliceFromText(schema, text, activeMarks),
			user: resolvedUser,
			date,
			source: "document-api",
			replacementGroupHint: providedId
		});
		else if (from$1 !== to && !text) intent = makeTextDeleteIntent({
			from: from$1,
			to,
			user: resolvedUser,
			date,
			source: "document-api",
			replacementGroupHint: providedId
		});
		else if (from$1 !== to && text) intent = makeTextReplaceIntent({
			from: from$1,
			to,
			content: sliceFromText(schema, text, activeMarks),
			replacements,
			user: resolvedUser,
			date,
			source: "document-api",
			replacementGroupHint: providedId
		});
		else return false;
	} catch (error) {
		console.warn("insertTrackedChange: could not build intent", error);
		return false;
	}
	const result = compileTrackedEdit({
		state,
		tr,
		intent,
		replacements
	});
	if (result.ok === false) {
		if (trackChangesStorage) trackChangesStorage.lastCompilerFailure = {
			code: result.code,
			message: result.message,
			details: result.details
		};
		return false;
	}
	if (!dispatch) return true;
	const insertedNodes = result.insertedNodes ?? [];
	const deletionNodes = result.deletionNodes ?? [];
	const meta = {
		insertedMark: result.insertedMark || null,
		deletionMark: result.deletionMark || result.deletionMarks?.[0] || null,
		deletionNodes,
		step: result.insertedStep ? result.insertedStep : result.insertedMark ? { slice: { content: { content: insertedNodes } } } : null,
		emitCommentEvent
	};
	tr.setMeta(TrackChangesBasePluginKey, meta);
	tr.setMeta(CommentsPluginKey, { type: "force" });
	tr.setMeta("skipTrackChanges", true);
	if (!addToHistory) tr.setMeta("addToHistory", false);
	dispatch(tr);
	const changeId = providedId || result.createdChangeIds?.[0] || result.updatedChangeIds?.[0] || null;
	if (comment?.trim() && changeId && editor.commands?.addCommentReply) editor.commands.addCommentReply({
		parentId: changeId,
		content: comment,
		author: resolvedUser.name,
		authorId: resolvedUser.id,
		authorEmail: resolvedUser.email,
		authorImage: resolvedUser.image
	});
	return true;
};
const TextTransform = Extension.create({
	name: "textTransform",
	addOptions() {
		return { types: ["textStyle"] };
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: { textTransform: {
				default: null,
				renderDOM: (attrs) => {
					if (!attrs.textTransform) return {};
					return { style: `text-transform: ${attrs.textTransform}` };
				}
			} }
		}];
	}
});
const Placeholder = Extension.create({
	name: "placeholder",
	addOptions() {
		return { placeholder: "Type something..." };
	},
	addPmPlugins() {
		const applyDecoration = (state) => {
			if (state.doc.textBetween(0, state.doc.content.size, " ", " ") !== "") return DecorationSet.empty;
			const { $from } = state.selection;
			if ($from.depth === 0) return DecorationSet.empty;
			const decoration = Decoration.node($from.before(), $from.after(), {
				"data-placeholder": this.options.placeholder,
				class: "sd-editor-placeholder"
			});
			return DecorationSet.create(state.doc, [decoration]);
		};
		return [new Plugin({
			key: new PluginKey("placeholder"),
			state: {
				init: (_$1, state) => {
					return applyDecoration(state);
				},
				apply: (tr, oldValue, oldState, newState) => {
					return applyDecoration(newState);
				}
			},
			props: { decorations(state) {
				return this.getState(state);
			} }
		})];
	}
});
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [
	"top",
	bottom,
	right,
	left
];
var start = "start";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
	return acc.concat([placement + "-" + start, placement + "-end"]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
	return acc.concat([
		placement,
		placement + "-" + start,
		placement + "-end"
	]);
}, []);
var modifierPhases = [
	"beforeRead",
	"read",
	"afterRead",
	"beforeMain",
	"main",
	"afterMain",
	"beforeWrite",
	"write",
	"afterWrite"
];
function getNodeName(element) {
	return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow(node) {
	if (node == null) return window;
	if (node.toString() !== "[object Window]") {
		var ownerDocument = node.ownerDocument;
		return ownerDocument ? ownerDocument.defaultView || window : window;
	}
	return node;
}
function isElement$1(node) {
	return node instanceof getWindow(node).Element || node instanceof Element;
}
function isHTMLElement(node) {
	return node instanceof getWindow(node).HTMLElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
	if (typeof ShadowRoot === "undefined") return false;
	return node instanceof getWindow(node).ShadowRoot || node instanceof ShadowRoot;
}
function applyStyles$2(_ref) {
	var state = _ref.state;
	Object.keys(state.elements).forEach(function(name) {
		var style = state.styles[name] || {};
		var attributes = state.attributes[name] || {};
		var element = state.elements[name];
		if (!isHTMLElement(element) || !getNodeName(element)) return;
		Object.assign(element.style, style);
		Object.keys(attributes).forEach(function(name$1) {
			var value = attributes[name$1];
			if (value === false) element.removeAttribute(name$1);
			else element.setAttribute(name$1, value === true ? "" : value);
		});
	});
}
function effect$2(_ref2) {
	var state = _ref2.state;
	var initialStyles = {
		popper: {
			position: state.options.strategy,
			left: "0",
			top: "0",
			margin: "0"
		},
		arrow: { position: "absolute" },
		reference: {}
	};
	Object.assign(state.elements.popper.style, initialStyles.popper);
	state.styles = initialStyles;
	if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
	return function() {
		Object.keys(state.elements).forEach(function(name) {
			var element = state.elements[name];
			var attributes = state.attributes[name] || {};
			var style = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]).reduce(function(style$1, property) {
				style$1[property] = "";
				return style$1;
			}, {});
			if (!isHTMLElement(element) || !getNodeName(element)) return;
			Object.assign(element.style, style);
			Object.keys(attributes).forEach(function(attribute) {
				element.removeAttribute(attribute);
			});
		});
	};
}
var applyStyles_default = {
	name: "applyStyles",
	enabled: true,
	phase: "write",
	fn: applyStyles$2,
	effect: effect$2,
	requires: ["computeStyles"]
};
function getBasePlacement$1(placement) {
	return placement.split("-")[0];
}
var max = Math.max;
var min = Math.min;
var round = Math.round;
function getUAString() {
	var uaData = navigator.userAgentData;
	if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
		return item.brand + "/" + item.version;
	}).join(" ");
	return navigator.userAgent;
}
function isLayoutViewport() {
	return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
	if (includeScale === void 0) includeScale = false;
	if (isFixedStrategy === void 0) isFixedStrategy = false;
	var clientRect = element.getBoundingClientRect();
	var scaleX = 1;
	var scaleY = 1;
	if (includeScale && isHTMLElement(element)) {
		scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
		scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
	}
	var visualViewport = (isElement$1(element) ? getWindow(element) : window).visualViewport;
	var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
	var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
	var y$1 = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
	var width = clientRect.width / scaleX;
	var height = clientRect.height / scaleY;
	return {
		width,
		height,
		top: y$1,
		right: x + width,
		bottom: y$1 + height,
		left: x,
		x,
		y: y$1
	};
}
function getLayoutRect(element) {
	var clientRect = getBoundingClientRect(element);
	var width = element.offsetWidth;
	var height = element.offsetHeight;
	if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
	if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
	return {
		x: element.offsetLeft,
		y: element.offsetTop,
		width,
		height
	};
}
function contains(parent, child) {
	var rootNode = child.getRootNode && child.getRootNode();
	if (parent.contains(child)) return true;
	else if (rootNode && isShadowRoot(rootNode)) {
		var next = child;
		do {
			if (next && parent.isSameNode(next)) return true;
			next = next.parentNode || next.host;
		} while (next);
	}
	return false;
}
function getComputedStyle$1(element) {
	return getWindow(element).getComputedStyle(element);
}
function isTableElement(element) {
	return [
		"table",
		"td",
		"th"
	].indexOf(getNodeName(element)) >= 0;
}
function getDocumentElement(element) {
	return ((isElement$1(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
function getParentNode(element) {
	if (getNodeName(element) === "html") return element;
	return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}
function getTrueOffsetParent(element) {
	if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") return null;
	return element.offsetParent;
}
function getContainingBlock(element) {
	var isFirefox = /firefox/i.test(getUAString());
	if (/Trident/i.test(getUAString()) && isHTMLElement(element)) {
		if (getComputedStyle$1(element).position === "fixed") return null;
	}
	var currentNode = getParentNode(element);
	if (isShadowRoot(currentNode)) currentNode = currentNode.host;
	while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
		var css = getComputedStyle$1(currentNode);
		if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || ["transform", "perspective"].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
		else currentNode = currentNode.parentNode;
	}
	return null;
}
function getOffsetParent(element) {
	var window$1 = getWindow(element);
	var offsetParent = getTrueOffsetParent(element);
	while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === "static") offsetParent = getTrueOffsetParent(offsetParent);
	if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle$1(offsetParent).position === "static")) return window$1;
	return offsetParent || getContainingBlock(element) || window$1;
}
function getMainAxisFromPlacement(placement) {
	return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min$2, value, max$2) {
	return max(min$2, min(value, max$2));
}
function withinMaxClamp(min$2, value, max$2) {
	var v = within(min$2, value, max$2);
	return v > max$2 ? max$2 : v;
}
function getFreshSideObject() {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0
	};
}
function mergePaddingObject(paddingObject) {
	return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys$1) {
	return keys$1.reduce(function(hashMap, key) {
		hashMap[key] = value;
		return hashMap;
	}, {});
}
var toPaddingObject = function toPaddingObject$1(padding, state) {
	padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, { placement: state.placement })) : padding;
	return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
	var _state$modifiersData$;
	var state = _ref.state, name = _ref.name, options = _ref.options;
	var arrowElement = state.elements.arrow;
	var popperOffsets$1 = state.modifiersData.popperOffsets;
	var basePlacement = getBasePlacement$1(state.placement);
	var axis = getMainAxisFromPlacement(basePlacement);
	var len = ["left", "right"].indexOf(basePlacement) >= 0 ? "height" : "width";
	if (!arrowElement || !popperOffsets$1) return;
	var paddingObject = toPaddingObject(options.padding, state);
	var arrowRect = getLayoutRect(arrowElement);
	var minProp = axis === "y" ? "top" : left;
	var maxProp = axis === "y" ? bottom : right;
	var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets$1[axis] - state.rects.popper[len];
	var startDiff = popperOffsets$1[axis] - state.rects.reference[axis];
	var arrowOffsetParent = getOffsetParent(arrowElement);
	var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
	var centerToReference = endDiff / 2 - startDiff / 2;
	var min$2 = paddingObject[minProp];
	var max$2 = clientSize - arrowRect[len] - paddingObject[maxProp];
	var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
	var offset$1 = within(min$2, center, max$2);
	var axisProp = axis;
	state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset$1, _state$modifiersData$.centerOffset = offset$1 - center, _state$modifiersData$);
}
function effect$1(_ref2) {
	var state = _ref2.state;
	var _options$element = _ref2.options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
	if (arrowElement == null) return;
	if (typeof arrowElement === "string") {
		arrowElement = state.elements.popper.querySelector(arrowElement);
		if (!arrowElement) return;
	}
	if (!contains(state.elements.popper, arrowElement)) return;
	state.elements.arrow = arrowElement;
}
var arrow_default = {
	name: "arrow",
	enabled: true,
	phase: "main",
	fn: arrow,
	effect: effect$1,
	requires: ["popperOffsets"],
	requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
	return placement.split("-")[1];
}
var unsetSides = {
	top: "auto",
	right: "auto",
	bottom: "auto",
	left: "auto"
};
function roundOffsetsByDPR(_ref, win) {
	var x = _ref.x, y$1 = _ref.y;
	var dpr = win.devicePixelRatio || 1;
	return {
		x: round(x * dpr) / dpr || 0,
		y: round(y$1 * dpr) / dpr || 0
	};
}
function mapToStyles(_ref2) {
	var _Object$assign2;
	var popper$1 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
	var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y$1 = _offsets$y === void 0 ? 0 : _offsets$y;
	var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
		x,
		y: y$1
	}) : {
		x,
		y: y$1
	};
	x = _ref3.x;
	y$1 = _ref3.y;
	var hasX = offsets.hasOwnProperty("x");
	var hasY = offsets.hasOwnProperty("y");
	var sideX = left;
	var sideY = "top";
	var win = window;
	if (adaptive) {
		var offsetParent = getOffsetParent(popper$1);
		var heightProp = "clientHeight";
		var widthProp = "clientWidth";
		if (offsetParent === getWindow(popper$1)) {
			offsetParent = getDocumentElement(popper$1);
			if (getComputedStyle$1(offsetParent).position !== "static" && position === "absolute") {
				heightProp = "scrollHeight";
				widthProp = "scrollWidth";
			}
		}
		offsetParent = offsetParent;
		if (placement === "top" || (placement === "left" || placement === "right") && variation === "end") {
			sideY = bottom;
			var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
			y$1 -= offsetY - popperRect.height;
			y$1 *= gpuAcceleration ? 1 : -1;
		}
		if (placement === "left" || (placement === "top" || placement === "bottom") && variation === "end") {
			sideX = right;
			var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
			x -= offsetX - popperRect.width;
			x *= gpuAcceleration ? 1 : -1;
		}
	}
	var commonStyles = Object.assign({ position }, adaptive && unsetSides);
	var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
		x,
		y: y$1
	}, getWindow(popper$1)) : {
		x,
		y: y$1
	};
	x = _ref4.x;
	y$1 = _ref4.y;
	if (gpuAcceleration) {
		var _Object$assign;
		return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y$1 + "px)" : "translate3d(" + x + "px, " + y$1 + "px, 0)", _Object$assign));
	}
	return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y$1 + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
	var state = _ref5.state, options = _ref5.options;
	var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
	var commonStyles = {
		placement: getBasePlacement$1(state.placement),
		variation: getVariation(state.placement),
		popper: state.elements.popper,
		popperRect: state.rects.popper,
		gpuAcceleration,
		isFixed: state.options.strategy === "fixed"
	};
	if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
		offsets: state.modifiersData.popperOffsets,
		position: state.options.strategy,
		adaptive,
		roundOffsets
	})));
	if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
		offsets: state.modifiersData.arrow,
		position: "absolute",
		adaptive: false,
		roundOffsets
	})));
	state.attributes.popper = Object.assign({}, state.attributes.popper, { "data-popper-placement": state.placement });
}
var computeStyles_default = {
	name: "computeStyles",
	enabled: true,
	phase: "beforeWrite",
	fn: computeStyles,
	data: {}
};
var passive = { passive: true };
function effect(_ref) {
	var state = _ref.state, instance = _ref.instance, options = _ref.options;
	var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
	var window$1 = getWindow(state.elements.popper);
	var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
	if (scroll) scrollParents.forEach(function(scrollParent) {
		scrollParent.addEventListener("scroll", instance.update, passive);
	});
	if (resize) window$1.addEventListener("resize", instance.update, passive);
	return function() {
		if (scroll) scrollParents.forEach(function(scrollParent) {
			scrollParent.removeEventListener("scroll", instance.update, passive);
		});
		if (resize) window$1.removeEventListener("resize", instance.update, passive);
	};
}
var eventListeners_default = {
	name: "eventListeners",
	enabled: true,
	phase: "write",
	fn: function fn() {},
	effect,
	data: {}
};
var hash$1 = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
function getOppositePlacement(placement) {
	return placement.replace(/left|right|bottom|top/g, function(matched) {
		return hash$1[matched];
	});
}
var hash = {
	start: "end",
	end: "start"
};
function getOppositeVariationPlacement(placement) {
	return placement.replace(/start|end/g, function(matched) {
		return hash[matched];
	});
}
function getWindowScroll(node) {
	var win = getWindow(node);
	return {
		scrollLeft: win.pageXOffset,
		scrollTop: win.pageYOffset
	};
}
function getWindowScrollBarX(element) {
	return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element, strategy) {
	var win = getWindow(element);
	var html = getDocumentElement(element);
	var visualViewport = win.visualViewport;
	var width = html.clientWidth;
	var height = html.clientHeight;
	var x = 0;
	var y$1 = 0;
	if (visualViewport) {
		width = visualViewport.width;
		height = visualViewport.height;
		var layoutViewport = isLayoutViewport();
		if (layoutViewport || !layoutViewport && strategy === "fixed") {
			x = visualViewport.offsetLeft;
			y$1 = visualViewport.offsetTop;
		}
	}
	return {
		width,
		height,
		x: x + getWindowScrollBarX(element),
		y: y$1
	};
}
function getDocumentRect(element) {
	var _element$ownerDocumen;
	var html = getDocumentElement(element);
	var winScroll = getWindowScroll(element);
	var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
	var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
	var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
	var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
	var y$1 = -winScroll.scrollTop;
	if (getComputedStyle$1(body || html).direction === "rtl") x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
	return {
		width,
		height,
		x,
		y: y$1
	};
}
function isScrollParent(element) {
	var _getComputedStyle = getComputedStyle$1(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
	return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node) {
	if ([
		"html",
		"body",
		"#document"
	].indexOf(getNodeName(node)) >= 0) return node.ownerDocument.body;
	if (isHTMLElement(node) && isScrollParent(node)) return node;
	return getScrollParent(getParentNode(node));
}
function listScrollParents(element, list) {
	var _element$ownerDocumen;
	if (list === void 0) list = [];
	var scrollParent = getScrollParent(element);
	var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
	var win = getWindow(scrollParent);
	var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
	var updatedList = list.concat(target);
	return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}
function rectToClientRect(rect) {
	return Object.assign({}, rect, {
		left: rect.x,
		top: rect.y,
		right: rect.x + rect.width,
		bottom: rect.y + rect.height
	});
}
function getInnerBoundingClientRect(element, strategy) {
	var rect = getBoundingClientRect(element, false, strategy === "fixed");
	rect.top = rect.top + element.clientTop;
	rect.left = rect.left + element.clientLeft;
	rect.bottom = rect.top + element.clientHeight;
	rect.right = rect.left + element.clientWidth;
	rect.width = element.clientWidth;
	rect.height = element.clientHeight;
	rect.x = rect.left;
	rect.y = rect.top;
	return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
	return clippingParent === "viewport" ? rectToClientRect(getViewportRect(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
	var clippingParents$1 = listScrollParents(getParentNode(element));
	var clipperElement = ["absolute", "fixed"].indexOf(getComputedStyle$1(element).position) >= 0 && isHTMLElement(element) ? getOffsetParent(element) : element;
	if (!isElement$1(clipperElement)) return [];
	return clippingParents$1.filter(function(clippingParent) {
		return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
	});
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
	var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
	var clippingParents$1 = [].concat(mainClippingParents, [rootBoundary]);
	var firstClippingParent = clippingParents$1[0];
	var clippingRect = clippingParents$1.reduce(function(accRect, clippingParent) {
		var rect = getClientRectFromMixedType(element, clippingParent, strategy);
		accRect.top = max(rect.top, accRect.top);
		accRect.right = min(rect.right, accRect.right);
		accRect.bottom = min(rect.bottom, accRect.bottom);
		accRect.left = max(rect.left, accRect.left);
		return accRect;
	}, getClientRectFromMixedType(element, firstClippingParent, strategy));
	clippingRect.width = clippingRect.right - clippingRect.left;
	clippingRect.height = clippingRect.bottom - clippingRect.top;
	clippingRect.x = clippingRect.left;
	clippingRect.y = clippingRect.top;
	return clippingRect;
}
function computeOffsets(_ref) {
	var reference$1 = _ref.reference, element = _ref.element, placement = _ref.placement;
	var basePlacement = placement ? getBasePlacement$1(placement) : null;
	var variation = placement ? getVariation(placement) : null;
	var commonX = reference$1.x + reference$1.width / 2 - element.width / 2;
	var commonY = reference$1.y + reference$1.height / 2 - element.height / 2;
	var offsets;
	switch (basePlacement) {
		case "top":
			offsets = {
				x: commonX,
				y: reference$1.y - element.height
			};
			break;
		case bottom:
			offsets = {
				x: commonX,
				y: reference$1.y + reference$1.height
			};
			break;
		case right:
			offsets = {
				x: reference$1.x + reference$1.width,
				y: commonY
			};
			break;
		case left:
			offsets = {
				x: reference$1.x - element.width,
				y: commonY
			};
			break;
		default: offsets = {
			x: reference$1.x,
			y: reference$1.y
		};
	}
	var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
	if (mainAxis != null) {
		var len = mainAxis === "y" ? "height" : "width";
		switch (variation) {
			case start:
				offsets[mainAxis] = offsets[mainAxis] - (reference$1[len] / 2 - element[len] / 2);
				break;
			case "end":
				offsets[mainAxis] = offsets[mainAxis] + (reference$1[len] / 2 - element[len] / 2);
				break;
			default:
		}
	}
	return offsets;
}
function detectOverflow(state, options) {
	if (options === void 0) options = {};
	var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
	var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
	var altContext = elementContext === "popper" ? reference : popper;
	var popperRect = state.rects.popper;
	var element = state.elements[altBoundary ? altContext : elementContext];
	var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
	var referenceClientRect = getBoundingClientRect(state.elements.reference);
	var popperOffsets$1 = computeOffsets({
		reference: referenceClientRect,
		element: popperRect,
		strategy: "absolute",
		placement
	});
	var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets$1));
	var elementClientRect = elementContext === "popper" ? popperClientRect : referenceClientRect;
	var overflowOffsets = {
		top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
		bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
		left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
		right: elementClientRect.right - clippingClientRect.right + paddingObject.right
	};
	var offsetData = state.modifiersData.offset;
	if (elementContext === "popper" && offsetData) {
		var offset$1 = offsetData[placement];
		Object.keys(overflowOffsets).forEach(function(key) {
			var multiply = ["right", "bottom"].indexOf(key) >= 0 ? 1 : -1;
			var axis = ["top", "bottom"].indexOf(key) >= 0 ? "y" : "x";
			overflowOffsets[key] += offset$1[axis] * multiply;
		});
	}
	return overflowOffsets;
}
function computeAutoPlacement(state, options) {
	if (options === void 0) options = {};
	var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
	var variation = getVariation(placement);
	var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement$1) {
		return getVariation(placement$1) === variation;
	}) : basePlacements;
	var allowedPlacements = placements$1.filter(function(placement$1) {
		return allowedAutoPlacements.indexOf(placement$1) >= 0;
	});
	if (allowedPlacements.length === 0) allowedPlacements = placements$1;
	var overflows = allowedPlacements.reduce(function(acc, placement$1) {
		acc[placement$1] = detectOverflow(state, {
			placement: placement$1,
			boundary,
			rootBoundary,
			padding
		})[getBasePlacement$1(placement$1)];
		return acc;
	}, {});
	return Object.keys(overflows).sort(function(a, b$1) {
		return overflows[a] - overflows[b$1];
	});
}
function getExpandedFallbackPlacements(placement) {
	if (getBasePlacement$1(placement) === "auto") return [];
	var oppositePlacement = getOppositePlacement(placement);
	return [
		getOppositeVariationPlacement(placement),
		oppositePlacement,
		getOppositeVariationPlacement(oppositePlacement)
	];
}
function flip(_ref) {
	var state = _ref.state, options = _ref.options, name = _ref.name;
	if (state.modifiersData[name]._skip) return;
	var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
	var preferredPlacement = state.options.placement;
	var isBasePlacement = getBasePlacement$1(preferredPlacement) === preferredPlacement;
	var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
	var placements$1 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement$1) {
		return acc.concat(getBasePlacement$1(placement$1) === "auto" ? computeAutoPlacement(state, {
			placement: placement$1,
			boundary,
			rootBoundary,
			padding,
			flipVariations,
			allowedAutoPlacements
		}) : placement$1);
	}, []);
	var referenceRect = state.rects.reference;
	var popperRect = state.rects.popper;
	var checksMap = /* @__PURE__ */ new Map();
	var makeFallbackChecks = true;
	var firstFittingPlacement = placements$1[0];
	for (var i = 0; i < placements$1.length; i++) {
		var placement = placements$1[i];
		var _basePlacement = getBasePlacement$1(placement);
		var isStartVariation = getVariation(placement) === start;
		var isVertical = ["top", bottom].indexOf(_basePlacement) >= 0;
		var len = isVertical ? "width" : "height";
		var overflow = detectOverflow(state, {
			placement,
			boundary,
			rootBoundary,
			altBoundary,
			padding
		});
		var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : "top";
		if (referenceRect[len] > popperRect[len]) mainVariationSide = getOppositePlacement(mainVariationSide);
		var altVariationSide = getOppositePlacement(mainVariationSide);
		var checks = [];
		if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
		if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
		if (checks.every(function(check) {
			return check;
		})) {
			firstFittingPlacement = placement;
			makeFallbackChecks = false;
			break;
		}
		checksMap.set(placement, checks);
	}
	if (makeFallbackChecks) {
		var numberOfChecks = flipVariations ? 3 : 1;
		var _loop = function _loop$1(_i$1) {
			var fittingPlacement = placements$1.find(function(placement$1) {
				var checks$1 = checksMap.get(placement$1);
				if (checks$1) return checks$1.slice(0, _i$1).every(function(check) {
					return check;
				});
			});
			if (fittingPlacement) {
				firstFittingPlacement = fittingPlacement;
				return "break";
			}
		};
		for (var _i = numberOfChecks; _i > 0; _i--) if (_loop(_i) === "break") break;
	}
	if (state.placement !== firstFittingPlacement) {
		state.modifiersData[name]._skip = true;
		state.placement = firstFittingPlacement;
		state.reset = true;
	}
}
var flip_default = {
	name: "flip",
	enabled: true,
	phase: "main",
	fn: flip,
	requiresIfExists: ["offset"],
	data: { _skip: false }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
	if (preventedOffsets === void 0) preventedOffsets = {
		x: 0,
		y: 0
	};
	return {
		top: overflow.top - rect.height - preventedOffsets.y,
		right: overflow.right - rect.width + preventedOffsets.x,
		bottom: overflow.bottom - rect.height + preventedOffsets.y,
		left: overflow.left - rect.width - preventedOffsets.x
	};
}
function isAnySideFullyClipped(overflow) {
	return [
		"top",
		right,
		bottom,
		left
	].some(function(side) {
		return overflow[side] >= 0;
	});
}
function hide(_ref) {
	var state = _ref.state, name = _ref.name;
	var referenceRect = state.rects.reference;
	var popperRect = state.rects.popper;
	var preventedOffsets = state.modifiersData.preventOverflow;
	var referenceOverflow = detectOverflow(state, { elementContext: "reference" });
	var popperAltOverflow = detectOverflow(state, { altBoundary: true });
	var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
	var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
	var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
	var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
	state.modifiersData[name] = {
		referenceClippingOffsets,
		popperEscapeOffsets,
		isReferenceHidden,
		hasPopperEscaped
	};
	state.attributes.popper = Object.assign({}, state.attributes.popper, {
		"data-popper-reference-hidden": isReferenceHidden,
		"data-popper-escaped": hasPopperEscaped
	});
}
var hide_default = {
	name: "hide",
	enabled: true,
	phase: "main",
	requiresIfExists: ["preventOverflow"],
	fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset$1) {
	var basePlacement = getBasePlacement$1(placement);
	var invertDistance = ["left", "top"].indexOf(basePlacement) >= 0 ? -1 : 1;
	var _ref = typeof offset$1 === "function" ? offset$1(Object.assign({}, rects, { placement })) : offset$1, skidding = _ref[0], distance = _ref[1];
	skidding = skidding || 0;
	distance = (distance || 0) * invertDistance;
	return ["left", "right"].indexOf(basePlacement) >= 0 ? {
		x: distance,
		y: skidding
	} : {
		x: skidding,
		y: distance
	};
}
function offset(_ref2) {
	var state = _ref2.state, options = _ref2.options, name = _ref2.name;
	var _options$offset = options.offset, offset$1 = _options$offset === void 0 ? [0, 0] : _options$offset;
	var data = placements.reduce(function(acc, placement) {
		acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset$1);
		return acc;
	}, {});
	var _data$state$placement = data[state.placement], x = _data$state$placement.x, y$1 = _data$state$placement.y;
	if (state.modifiersData.popperOffsets != null) {
		state.modifiersData.popperOffsets.x += x;
		state.modifiersData.popperOffsets.y += y$1;
	}
	state.modifiersData[name] = data;
}
var offset_default = {
	name: "offset",
	enabled: true,
	phase: "main",
	requires: ["popperOffsets"],
	fn: offset
};
function popperOffsets(_ref) {
	var state = _ref.state, name = _ref.name;
	state.modifiersData[name] = computeOffsets({
		reference: state.rects.reference,
		element: state.rects.popper,
		strategy: "absolute",
		placement: state.placement
	});
}
var popperOffsets_default = {
	name: "popperOffsets",
	enabled: true,
	phase: "read",
	fn: popperOffsets,
	data: {}
};
function getAltAxis(axis) {
	return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref) {
	var state = _ref.state, options = _ref.options, name = _ref.name;
	var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
	var overflow = detectOverflow(state, {
		boundary,
		rootBoundary,
		padding,
		altBoundary
	});
	var basePlacement = getBasePlacement$1(state.placement);
	var variation = getVariation(state.placement);
	var isBasePlacement = !variation;
	var mainAxis = getMainAxisFromPlacement(basePlacement);
	var altAxis = getAltAxis(mainAxis);
	var popperOffsets$1 = state.modifiersData.popperOffsets;
	var referenceRect = state.rects.reference;
	var popperRect = state.rects.popper;
	var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, { placement: state.placement })) : tetherOffset;
	var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
		mainAxis: tetherOffsetValue,
		altAxis: tetherOffsetValue
	} : Object.assign({
		mainAxis: 0,
		altAxis: 0
	}, tetherOffsetValue);
	var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
	var data = {
		x: 0,
		y: 0
	};
	if (!popperOffsets$1) return;
	if (checkMainAxis) {
		var _offsetModifierState$;
		var mainSide = mainAxis === "y" ? "top" : left;
		var altSide = mainAxis === "y" ? bottom : right;
		var len = mainAxis === "y" ? "height" : "width";
		var offset$1 = popperOffsets$1[mainAxis];
		var min$2 = offset$1 + overflow[mainSide];
		var max$2 = offset$1 - overflow[altSide];
		var additive = tether ? -popperRect[len] / 2 : 0;
		var minLen = variation === "start" ? referenceRect[len] : popperRect[len];
		var maxLen = variation === "start" ? -popperRect[len] : -referenceRect[len];
		var arrowElement = state.elements.arrow;
		var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
			width: 0,
			height: 0
		};
		var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
		var arrowPaddingMin = arrowPaddingObject[mainSide];
		var arrowPaddingMax = arrowPaddingObject[altSide];
		var arrowLen = within(0, referenceRect[len], arrowRect[len]);
		var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
		var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
		var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
		var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
		var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
		var tetherMin = offset$1 + minOffset - offsetModifierValue - clientOffset;
		var tetherMax = offset$1 + maxOffset - offsetModifierValue;
		var preventedOffset = within(tether ? min(min$2, tetherMin) : min$2, offset$1, tether ? max(max$2, tetherMax) : max$2);
		popperOffsets$1[mainAxis] = preventedOffset;
		data[mainAxis] = preventedOffset - offset$1;
	}
	if (checkAltAxis) {
		var _offsetModifierState$2;
		var _mainSide = mainAxis === "x" ? "top" : left;
		var _altSide = mainAxis === "x" ? bottom : right;
		var _offset = popperOffsets$1[altAxis];
		var _len = altAxis === "y" ? "height" : "width";
		var _min = _offset + overflow[_mainSide];
		var _max = _offset - overflow[_altSide];
		var isOriginSide = ["top", left].indexOf(basePlacement) !== -1;
		var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
		var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
		var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
		var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
		popperOffsets$1[altAxis] = _preventedOffset;
		data[altAxis] = _preventedOffset - _offset;
	}
	state.modifiersData[name] = data;
}
var preventOverflow_default = {
	name: "preventOverflow",
	enabled: true,
	phase: "main",
	fn: preventOverflow,
	requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
	return {
		scrollLeft: element.scrollLeft,
		scrollTop: element.scrollTop
	};
}
function getNodeScroll(node) {
	if (node === getWindow(node) || !isHTMLElement(node)) return getWindowScroll(node);
	else return getHTMLElementScroll(node);
}
function isElementScaled(element) {
	var rect = element.getBoundingClientRect();
	var scaleX = round(rect.width) / element.offsetWidth || 1;
	var scaleY = round(rect.height) / element.offsetHeight || 1;
	return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
	if (isFixed === void 0) isFixed = false;
	var isOffsetParentAnElement = isHTMLElement(offsetParent);
	var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
	var documentElement = getDocumentElement(offsetParent);
	var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
	var scroll = {
		scrollLeft: 0,
		scrollTop: 0
	};
	var offsets = {
		x: 0,
		y: 0
	};
	if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
		if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) scroll = getNodeScroll(offsetParent);
		if (isHTMLElement(offsetParent)) {
			offsets = getBoundingClientRect(offsetParent, true);
			offsets.x += offsetParent.clientLeft;
			offsets.y += offsetParent.clientTop;
		} else if (documentElement) offsets.x = getWindowScrollBarX(documentElement);
	}
	return {
		x: rect.left + scroll.scrollLeft - offsets.x,
		y: rect.top + scroll.scrollTop - offsets.y,
		width: rect.width,
		height: rect.height
	};
}
function order(modifiers) {
	var map$1 = /* @__PURE__ */ new Map();
	var visited = /* @__PURE__ */ new Set();
	var result = [];
	modifiers.forEach(function(modifier) {
		map$1.set(modifier.name, modifier);
	});
	function sort(modifier) {
		visited.add(modifier.name);
		[].concat(modifier.requires || [], modifier.requiresIfExists || []).forEach(function(dep) {
			if (!visited.has(dep)) {
				var depModifier = map$1.get(dep);
				if (depModifier) sort(depModifier);
			}
		});
		result.push(modifier);
	}
	modifiers.forEach(function(modifier) {
		if (!visited.has(modifier.name)) sort(modifier);
	});
	return result;
}
function orderModifiers(modifiers) {
	var orderedModifiers = order(modifiers);
	return modifierPhases.reduce(function(acc, phase) {
		return acc.concat(orderedModifiers.filter(function(modifier) {
			return modifier.phase === phase;
		}));
	}, []);
}
function debounce$1(fn) {
	var pending;
	return function() {
		if (!pending) pending = new Promise(function(resolve) {
			Promise.resolve().then(function() {
				pending = void 0;
				resolve(fn());
			});
		});
		return pending;
	};
}
function mergeByName(modifiers) {
	var merged = modifiers.reduce(function(merged$1, current) {
		var existing = merged$1[current.name];
		merged$1[current.name] = existing ? Object.assign({}, existing, current, {
			options: Object.assign({}, existing.options, current.options),
			data: Object.assign({}, existing.data, current.data)
		}) : current;
		return merged$1;
	}, {});
	return Object.keys(merged).map(function(key) {
		return merged[key];
	});
}
var DEFAULT_OPTIONS = {
	placement: "bottom",
	modifiers: [],
	strategy: "absolute"
};
function areValidElements() {
	for (var _len = arguments.length, args$1 = new Array(_len), _key = 0; _key < _len; _key++) args$1[_key] = arguments[_key];
	return !args$1.some(function(element) {
		return !(element && typeof element.getBoundingClientRect === "function");
	});
}
function popperGenerator(generatorOptions) {
	if (generatorOptions === void 0) generatorOptions = {};
	var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers$1 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
	return function createPopper$1(reference$1, popper$1, options) {
		if (options === void 0) options = defaultOptions;
		var state = {
			placement: "bottom",
			orderedModifiers: [],
			options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
			modifiersData: {},
			elements: {
				reference: reference$1,
				popper: popper$1
			},
			attributes: {},
			styles: {}
		};
		var effectCleanupFns = [];
		var isDestroyed = false;
		var instance = {
			state,
			setOptions: function setOptions(setOptionsAction) {
				var options$1 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
				cleanupModifierEffects();
				state.options = Object.assign({}, defaultOptions, state.options, options$1);
				state.scrollParents = {
					reference: isElement$1(reference$1) ? listScrollParents(reference$1) : reference$1.contextElement ? listScrollParents(reference$1.contextElement) : [],
					popper: listScrollParents(popper$1)
				};
				var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers$1, state.options.modifiers)));
				state.orderedModifiers = orderedModifiers.filter(function(m$1) {
					return m$1.enabled;
				});
				runModifierEffects();
				return instance.update();
			},
			forceUpdate: function forceUpdate() {
				if (isDestroyed) return;
				var _state$elements = state.elements, reference$2 = _state$elements.reference, popper$2 = _state$elements.popper;
				if (!areValidElements(reference$2, popper$2)) return;
				state.rects = {
					reference: getCompositeRect(reference$2, getOffsetParent(popper$2), state.options.strategy === "fixed"),
					popper: getLayoutRect(popper$2)
				};
				state.reset = false;
				state.placement = state.options.placement;
				state.orderedModifiers.forEach(function(modifier) {
					return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
				});
				for (var index = 0; index < state.orderedModifiers.length; index++) {
					if (state.reset === true) {
						state.reset = false;
						index = -1;
						continue;
					}
					var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
					if (typeof fn === "function") state = fn({
						state,
						options: _options,
						name,
						instance
					}) || state;
				}
			},
			update: debounce$1(function() {
				return new Promise(function(resolve) {
					instance.forceUpdate();
					resolve(state);
				});
			}),
			destroy: function destroy() {
				cleanupModifierEffects();
				isDestroyed = true;
			}
		};
		if (!areValidElements(reference$1, popper$1)) return instance;
		instance.setOptions(options).then(function(state$1) {
			if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state$1);
		});
		function runModifierEffects() {
			state.orderedModifiers.forEach(function(_ref) {
				var name = _ref.name, _ref$options = _ref.options, options$1 = _ref$options === void 0 ? {} : _ref$options, effect$3 = _ref.effect;
				if (typeof effect$3 === "function") {
					var cleanupFn = effect$3({
						state,
						name,
						instance,
						options: options$1
					});
					effectCleanupFns.push(cleanupFn || function noopFn() {});
				}
			});
		}
		function cleanupModifierEffects() {
			effectCleanupFns.forEach(function(fn) {
				return fn();
			});
			effectCleanupFns = [];
		}
		return instance;
	};
}
var createPopper = /* @__PURE__ */ popperGenerator({ defaultModifiers: [
	eventListeners_default,
	popperOffsets_default,
	computeStyles_default,
	applyStyles_default,
	offset_default,
	flip_default,
	preventOverflow_default,
	arrow_default,
	hide_default
] });
init_dist();
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
	passive: true,
	capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO$1() {
	return document.body;
};
function hasOwnProperty$1(obj, key) {
	return {}.hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
	if (Array.isArray(value)) {
		var v = value[index];
		return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
	}
	return value;
}
function isType(value, type) {
	var str = {}.toString.call(value);
	return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args$1) {
	return typeof value === "function" ? value.apply(void 0, args$1) : value;
}
function debounce(fn, ms) {
	if (ms === 0) return fn;
	var timeout$1;
	return function(arg) {
		clearTimeout(timeout$1);
		timeout$1 = setTimeout(function() {
			fn(arg);
		}, ms);
	};
}
function removeProperties(obj, keys$1) {
	var clone$1 = Object.assign({}, obj);
	keys$1.forEach(function(key) {
		delete clone$1[key];
	});
	return clone$1;
}
function splitBySpaces(value) {
	return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
	return [].concat(value);
}
function pushIfUnique(arr, value) {
	if (arr.indexOf(value) === -1) arr.push(value);
}
function unique(arr) {
	return arr.filter(function(item, index) {
		return arr.indexOf(item) === index;
	});
}
function getBasePlacement(placement) {
	return placement.split("-")[0];
}
function arrayFrom(value) {
	return [].slice.call(value);
}
function removeUndefinedProps(obj) {
	return Object.keys(obj).reduce(function(acc, key) {
		if (obj[key] !== void 0) acc[key] = obj[key];
		return acc;
	}, {});
}
function div() {
	return document.createElement("div");
}
function isElement(value) {
	return ["Element", "Fragment"].some(function(type) {
		return isType(value, type);
	});
}
function isNodeList(value) {
	return isType(value, "NodeList");
}
function isMouseEvent(value) {
	return isType(value, "MouseEvent");
}
function isReferenceElement(value) {
	return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
	if (isElement(value)) return [value];
	if (isNodeList(value)) return arrayFrom(value);
	if (Array.isArray(value)) return value;
	return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
	els.forEach(function(el) {
		if (el) el.style.transitionDuration = value + "ms";
	});
}
function setVisibilityState(els, state) {
	els.forEach(function(el) {
		if (el) el.setAttribute("data-state", state);
	});
}
function getOwnerDocument(elementOrElements) {
	var _element$ownerDocumen;
	var element = normalizeToArray(elementOrElements)[0];
	return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
	var clientX = event.clientX, clientY = event.clientY;
	return popperTreeData.every(function(_ref) {
		var popperRect = _ref.popperRect, popperState = _ref.popperState;
		var interactiveBorder = _ref.props.interactiveBorder;
		var basePlacement = getBasePlacement(popperState.placement);
		var offsetData = popperState.modifiersData.offset;
		if (!offsetData) return true;
		var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
		var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
		var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
		var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
		var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
		var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
		var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
		var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
		return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
	});
}
function updateTransitionEndListener(box, action, listener) {
	var method = action + "EventListener";
	["transitionend", "webkitTransitionEnd"].forEach(function(event) {
		box[method](event, listener);
	});
}
function actualContains(parent, child) {
	var target = child;
	while (target) {
		var _target$getRootNode;
		if (parent.contains(target)) return true;
		target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
	}
	return false;
}
var currentInput = { isTouch: false };
var lastMouseMoveTime = 0;
function onDocumentTouchStart() {
	if (currentInput.isTouch) return;
	currentInput.isTouch = true;
	if (window.performance) document.addEventListener("mousemove", onDocumentMouseMove);
}
function onDocumentMouseMove() {
	var now = performance.now();
	if (now - lastMouseMoveTime < 20) {
		currentInput.isTouch = false;
		document.removeEventListener("mousemove", onDocumentMouseMove);
	}
	lastMouseMoveTime = now;
}
function onWindowBlur() {
	var activeElement = document.activeElement;
	if (isReferenceElement(activeElement)) {
		var instance = activeElement._tippy;
		if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
	}
}
function bindGlobalEventListeners() {
	document.addEventListener("touchstart", onDocumentTouchStart, TOUCH_OPTIONS);
	window.addEventListener("blur", onWindowBlur);
}
var isIE11 = typeof window !== "undefined" && typeof document !== "undefined" ? !!window.msCrypto : false;
function createMemoryLeakWarning(method) {
	var txt = method === "destroy" ? "n already-" : " ";
	return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function clean(value) {
	return value.replace(/[ \t]{2,}/g, " ").replace(/^[ \t]*/gm, "").trim();
}
function getDevMessage(message) {
	return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c👷‍ This is a development-only message. It will be removed in production.\n  ");
}
function getFormattedMessage(message) {
	return [
		getDevMessage(message),
		"color: #00C584; font-size: 1.3em; font-weight: bold;",
		"line-height: 1.5",
		"color: #a6a095;"
	];
}
var visitedMessages;
if (process$1$1.env.NODE_ENV !== "production") resetVisitedMessages();
function resetVisitedMessages() {
	visitedMessages = /* @__PURE__ */ new Set();
}
function warnWhen(condition, message) {
	if (condition && !visitedMessages.has(message)) {
		var _console;
		visitedMessages.add(message);
		(_console = console).warn.apply(_console, getFormattedMessage(message));
	}
}
function errorWhen(condition, message) {
	if (condition && !visitedMessages.has(message)) {
		var _console2;
		visitedMessages.add(message);
		(_console2 = console).error.apply(_console2, getFormattedMessage(message));
	}
}
function validateTargets(targets) {
	var didPassFalsyValue = !targets;
	var didPassPlainObject = Object.prototype.toString.call(targets) === "[object Object]" && !targets.addEventListener;
	errorWhen(didPassFalsyValue, [
		"tippy() was passed",
		"`" + String(targets) + "`",
		"as its targets (first) argument. Valid types are: String, Element,",
		"Element[], or NodeList."
	].join(" "));
	errorWhen(didPassPlainObject, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var pluginProps = {
	animateFill: false,
	followCursor: false,
	inlinePositioning: false,
	sticky: false
};
var defaultProps = Object.assign({
	appendTo: TIPPY_DEFAULT_APPEND_TO,
	aria: {
		content: "auto",
		expanded: "auto"
	},
	delay: 0,
	duration: [300, 250],
	getReferenceClientRect: null,
	hideOnClick: true,
	ignoreAttributes: false,
	interactive: false,
	interactiveBorder: 2,
	interactiveDebounce: 0,
	moveTransition: "",
	offset: [0, 10],
	onAfterUpdate: function onAfterUpdate() {},
	onBeforeUpdate: function onBeforeUpdate() {},
	onCreate: function onCreate() {},
	onDestroy: function onDestroy() {},
	onHidden: function onHidden() {},
	onHide: function onHide() {},
	onMount: function onMount() {},
	onShow: function onShow() {},
	onShown: function onShown() {},
	onTrigger: function onTrigger() {},
	onUntrigger: function onUntrigger() {},
	onClickOutside: function onClickOutside() {},
	placement: "top",
	plugins: [],
	popperOptions: {},
	render: null,
	showOnCreate: false,
	touch: true,
	trigger: "mouseenter focus",
	triggerTarget: null
}, pluginProps, {
	allowHTML: false,
	animation: "fade",
	arrow: true,
	content: "",
	inertia: false,
	maxWidth: 350,
	role: "tooltip",
	theme: "",
	zIndex: 9999
});
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps$1(partialProps) {
	/* istanbul ignore else */
	if (process$1$1.env.NODE_ENV !== "production") validateProps(partialProps, []);
	Object.keys(partialProps).forEach(function(key) {
		defaultProps[key] = partialProps[key];
	});
};
function getExtendedPassedProps(passedProps) {
	var pluginProps$1 = (passedProps.plugins || []).reduce(function(acc, plugin) {
		var name = plugin.name, defaultValue = plugin.defaultValue;
		if (name) {
			var _name;
			acc[name] = passedProps[name] !== void 0 ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
		}
		return acc;
	}, {});
	return Object.assign({}, passedProps, pluginProps$1);
}
function getDataAttributeProps(reference$1, plugins) {
	return (plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, { plugins }))) : defaultKeys).reduce(function(acc, key) {
		var valueAsString = (reference$1.getAttribute("data-tippy-" + key) || "").trim();
		if (!valueAsString) return acc;
		if (key === "content") acc[key] = valueAsString;
		else try {
			acc[key] = JSON.parse(valueAsString);
		} catch (e) {
			acc[key] = valueAsString;
		}
		return acc;
	}, {});
}
function evaluateProps(reference$1, props) {
	var out = Object.assign({}, props, { content: invokeWithArgsOrReturn(props.content, [reference$1]) }, props.ignoreAttributes ? {} : getDataAttributeProps(reference$1, props.plugins));
	out.aria = Object.assign({}, defaultProps.aria, out.aria);
	out.aria = {
		expanded: out.aria.expanded === "auto" ? props.interactive : out.aria.expanded,
		content: out.aria.content === "auto" ? props.interactive ? null : "describedby" : out.aria.content
	};
	return out;
}
function validateProps(partialProps, plugins) {
	if (partialProps === void 0) partialProps = {};
	if (plugins === void 0) plugins = [];
	Object.keys(partialProps).forEach(function(prop) {
		var didPassUnknownProp = !hasOwnProperty$1(removeProperties(defaultProps, Object.keys(pluginProps)), prop);
		if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
			return plugin.name === prop;
		}).length === 0;
		warnWhen(didPassUnknownProp, [
			"`" + prop + "`",
			"is not a valid prop. You may have spelled it incorrectly, or if it's",
			"a plugin, forgot to pass it in an array as props.plugins.",
			"\n\n",
			"All props: https://atomiks.github.io/tippyjs/v6/all-props/\n",
			"Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"
		].join(" "));
	});
}
var innerHTML = function innerHTML$1() {
	return "innerHTML";
};
function dangerouslySetInnerHTML(element, html) {
	element[innerHTML()] = html;
}
function createArrowElement(value) {
	var arrow$2 = div();
	if (value === true) arrow$2.className = ARROW_CLASS;
	else {
		arrow$2.className = SVG_ARROW_CLASS;
		if (isElement(value)) arrow$2.appendChild(value);
		else dangerouslySetInnerHTML(arrow$2, value);
	}
	return arrow$2;
}
function setContent(content, props) {
	if (isElement(props.content)) {
		dangerouslySetInnerHTML(content, "");
		content.appendChild(props.content);
	} else if (typeof props.content !== "function") if (props.allowHTML) dangerouslySetInnerHTML(content, props.content);
	else content.textContent = props.content;
}
function getChildren(popper$1) {
	var box = popper$1.firstElementChild;
	var boxChildren = arrayFrom(box.children);
	return {
		box,
		content: boxChildren.find(function(node) {
			return node.classList.contains(CONTENT_CLASS);
		}),
		arrow: boxChildren.find(function(node) {
			return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
		}),
		backdrop: boxChildren.find(function(node) {
			return node.classList.contains(BACKDROP_CLASS);
		})
	};
}
function render(instance) {
	var popper$1 = div();
	var box = div();
	box.className = BOX_CLASS;
	box.setAttribute("data-state", "hidden");
	box.setAttribute("tabindex", "-1");
	var content = div();
	content.className = CONTENT_CLASS;
	content.setAttribute("data-state", "hidden");
	setContent(content, instance.props);
	popper$1.appendChild(box);
	box.appendChild(content);
	onUpdate(instance.props, instance.props);
	function onUpdate(prevProps, nextProps) {
		var _getChildren = getChildren(popper$1), box$1 = _getChildren.box, content$1 = _getChildren.content, arrow$2 = _getChildren.arrow;
		if (nextProps.theme) box$1.setAttribute("data-theme", nextProps.theme);
		else box$1.removeAttribute("data-theme");
		if (typeof nextProps.animation === "string") box$1.setAttribute("data-animation", nextProps.animation);
		else box$1.removeAttribute("data-animation");
		if (nextProps.inertia) box$1.setAttribute("data-inertia", "");
		else box$1.removeAttribute("data-inertia");
		box$1.style.maxWidth = typeof nextProps.maxWidth === "number" ? nextProps.maxWidth + "px" : nextProps.maxWidth;
		if (nextProps.role) box$1.setAttribute("role", nextProps.role);
		else box$1.removeAttribute("role");
		if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) setContent(content$1, instance.props);
		if (nextProps.arrow) {
			if (!arrow$2) box$1.appendChild(createArrowElement(nextProps.arrow));
			else if (prevProps.arrow !== nextProps.arrow) {
				box$1.removeChild(arrow$2);
				box$1.appendChild(createArrowElement(nextProps.arrow));
			}
		} else if (arrow$2) box$1.removeChild(arrow$2);
	}
	return {
		popper: popper$1,
		onUpdate
	};
}
render.$$tippy = true;
var idCounter = 1;
var mouseMoveListeners = [];
var mountedInstances = [];
function createTippy(reference$1, passedProps) {
	var props = evaluateProps(reference$1, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps))));
	var showTimeout;
	var hideTimeout;
	var scheduleHideAnimationFrame;
	var isVisibleFromClick = false;
	var didHideDueToDocumentMouseDown = false;
	var didTouchMove = false;
	var ignoreOnFirstUpdate = false;
	var lastTriggerEvent;
	var currentTransitionEndListener;
	var onFirstUpdate;
	var listeners = [];
	var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
	var currentTarget;
	var id = idCounter++;
	var popperInstance = null;
	var plugins = unique(props.plugins);
	var instance = {
		id,
		reference: reference$1,
		popper: div(),
		popperInstance,
		props,
		state: {
			isEnabled: true,
			isVisible: false,
			isDestroyed: false,
			isMounted: false,
			isShown: false
		},
		plugins,
		clearDelayTimeouts,
		setProps,
		setContent: setContent$1,
		show,
		hide: hide$1,
		hideWithInteractivity,
		enable,
		disable,
		unmount,
		destroy
	};
	/* istanbul ignore if */
	if (!props.render) {
		if (process$1$1.env.NODE_ENV !== "production") errorWhen(true, "render() function has not been supplied.");
		return instance;
	}
	var _props$render = props.render(instance), popper$1 = _props$render.popper, onUpdate = _props$render.onUpdate;
	popper$1.setAttribute("data-tippy-root", "");
	popper$1.id = "tippy-" + instance.id;
	instance.popper = popper$1;
	reference$1._tippy = instance;
	popper$1._tippy = instance;
	var pluginsHooks = plugins.map(function(plugin) {
		return plugin.fn(instance);
	});
	var hasAriaExpanded = reference$1.hasAttribute("aria-expanded");
	addListeners();
	handleAriaExpandedAttribute();
	handleStyles();
	invokeHook("onCreate", [instance]);
	if (props.showOnCreate) scheduleShow();
	popper$1.addEventListener("mouseenter", function() {
		if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
	});
	popper$1.addEventListener("mouseleave", function() {
		if (instance.props.interactive && instance.props.trigger.indexOf("mouseenter") >= 0) getDocument().addEventListener("mousemove", debouncedOnMouseMove);
	});
	return instance;
	function getNormalizedTouchSettings() {
		var touch = instance.props.touch;
		return Array.isArray(touch) ? touch : [touch, 0];
	}
	function getIsCustomTouchBehavior() {
		return getNormalizedTouchSettings()[0] === "hold";
	}
	function getIsDefaultRenderFn() {
		var _instance$props$rende;
		return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
	}
	function getCurrentTarget() {
		return currentTarget || reference$1;
	}
	function getDocument() {
		var parent = getCurrentTarget().parentNode;
		return parent ? getOwnerDocument(parent) : document;
	}
	function getDefaultTemplateChildren() {
		return getChildren(popper$1);
	}
	function getDelay(isShow) {
		if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") return 0;
		return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
	}
	function handleStyles(fromHide) {
		if (fromHide === void 0) fromHide = false;
		popper$1.style.pointerEvents = instance.props.interactive && !fromHide ? "" : "none";
		popper$1.style.zIndex = "" + instance.props.zIndex;
	}
	function invokeHook(hook, args$1, shouldInvokePropsHook) {
		if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
		pluginsHooks.forEach(function(pluginHooks) {
			if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args$1);
		});
		if (shouldInvokePropsHook) {
			var _instance$props;
			(_instance$props = instance.props)[hook].apply(_instance$props, args$1);
		}
	}
	function handleAriaContentAttribute() {
		var aria = instance.props.aria;
		if (!aria.content) return;
		var attr = "aria-" + aria.content;
		var id$1 = popper$1.id;
		normalizeToArray(instance.props.triggerTarget || reference$1).forEach(function(node) {
			var currentValue = node.getAttribute(attr);
			if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id$1 : id$1);
			else {
				var nextValue = currentValue && currentValue.replace(id$1, "").trim();
				if (nextValue) node.setAttribute(attr, nextValue);
				else node.removeAttribute(attr);
			}
		});
	}
	function handleAriaExpandedAttribute() {
		if (hasAriaExpanded || !instance.props.aria.expanded) return;
		normalizeToArray(instance.props.triggerTarget || reference$1).forEach(function(node) {
			if (instance.props.interactive) node.setAttribute("aria-expanded", instance.state.isVisible && node === getCurrentTarget() ? "true" : "false");
			else node.removeAttribute("aria-expanded");
		});
	}
	function cleanupInteractiveMouseListeners() {
		getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
		mouseMoveListeners = mouseMoveListeners.filter(function(listener) {
			return listener !== debouncedOnMouseMove;
		});
	}
	function onDocumentPress(event) {
		if (currentInput.isTouch) {
			if (didTouchMove || event.type === "mousedown") return;
		}
		var actualTarget = event.composedPath && event.composedPath()[0] || event.target;
		if (instance.props.interactive && actualContains(popper$1, actualTarget)) return;
		if (normalizeToArray(instance.props.triggerTarget || reference$1).some(function(el) {
			return actualContains(el, actualTarget);
		})) {
			if (currentInput.isTouch) return;
			if (instance.state.isVisible && instance.props.trigger.indexOf("click") >= 0) return;
		} else invokeHook("onClickOutside", [instance, event]);
		if (instance.props.hideOnClick === true) {
			instance.clearDelayTimeouts();
			instance.hide();
			didHideDueToDocumentMouseDown = true;
			setTimeout(function() {
				didHideDueToDocumentMouseDown = false;
			});
			if (!instance.state.isMounted) removeDocumentPress();
		}
	}
	function onTouchMove() {
		didTouchMove = true;
	}
	function onTouchStart() {
		didTouchMove = false;
	}
	function addDocumentPress() {
		var doc$1 = getDocument();
		doc$1.addEventListener("mousedown", onDocumentPress, true);
		doc$1.addEventListener("touchend", onDocumentPress, TOUCH_OPTIONS);
		doc$1.addEventListener("touchstart", onTouchStart, TOUCH_OPTIONS);
		doc$1.addEventListener("touchmove", onTouchMove, TOUCH_OPTIONS);
	}
	function removeDocumentPress() {
		var doc$1 = getDocument();
		doc$1.removeEventListener("mousedown", onDocumentPress, true);
		doc$1.removeEventListener("touchend", onDocumentPress, TOUCH_OPTIONS);
		doc$1.removeEventListener("touchstart", onTouchStart, TOUCH_OPTIONS);
		doc$1.removeEventListener("touchmove", onTouchMove, TOUCH_OPTIONS);
	}
	function onTransitionedOut(duration, callback) {
		onTransitionEnd(duration, function() {
			if (!instance.state.isVisible && popper$1.parentNode && popper$1.parentNode.contains(popper$1)) callback();
		});
	}
	function onTransitionedIn(duration, callback) {
		onTransitionEnd(duration, callback);
	}
	function onTransitionEnd(duration, callback) {
		var box = getDefaultTemplateChildren().box;
		function listener(event) {
			if (event.target === box) {
				updateTransitionEndListener(box, "remove", listener);
				callback();
			}
		}
		if (duration === 0) return callback();
		updateTransitionEndListener(box, "remove", currentTransitionEndListener);
		updateTransitionEndListener(box, "add", listener);
		currentTransitionEndListener = listener;
	}
	function on(eventType, handler, options) {
		if (options === void 0) options = false;
		normalizeToArray(instance.props.triggerTarget || reference$1).forEach(function(node) {
			node.addEventListener(eventType, handler, options);
			listeners.push({
				node,
				eventType,
				handler,
				options
			});
		});
	}
	function addListeners() {
		if (getIsCustomTouchBehavior()) {
			on("touchstart", onTrigger, { passive: true });
			on("touchend", onMouseLeave, { passive: true });
		}
		splitBySpaces(instance.props.trigger).forEach(function(eventType) {
			if (eventType === "manual") return;
			on(eventType, onTrigger);
			switch (eventType) {
				case "mouseenter":
					on("mouseleave", onMouseLeave);
					break;
				case "focus":
					on(isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
					break;
				case "focusin":
					on("focusout", onBlurOrFocusOut);
					break;
			}
		});
	}
	function removeListeners() {
		listeners.forEach(function(_ref) {
			var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
			node.removeEventListener(eventType, handler, options);
		});
		listeners = [];
	}
	function onTrigger(event) {
		var _lastTriggerEvent;
		var shouldScheduleClickHide = false;
		if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
		var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === "focus";
		lastTriggerEvent = event;
		currentTarget = event.currentTarget;
		handleAriaExpandedAttribute();
		if (!instance.state.isVisible && isMouseEvent(event)) mouseMoveListeners.forEach(function(listener) {
			return listener(event);
		});
		if (event.type === "click" && (instance.props.trigger.indexOf("mouseenter") < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
		else scheduleShow(event);
		if (event.type === "click") isVisibleFromClick = !shouldScheduleClickHide;
		if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
	}
	function onMouseMove(event) {
		var target = event.target;
		var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper$1.contains(target);
		if (event.type === "mousemove" && isCursorOverReferenceOrPopper) return;
		if (isCursorOutsideInteractiveBorder(getNestedPopperTree().concat(popper$1).map(function(popper$2) {
			var _instance$popperInsta;
			var state = (_instance$popperInsta = popper$2._tippy.popperInstance) == null ? void 0 : _instance$popperInsta.state;
			if (state) return {
				popperRect: popper$2.getBoundingClientRect(),
				popperState: state,
				props
			};
			return null;
		}).filter(Boolean), event)) {
			cleanupInteractiveMouseListeners();
			scheduleHide(event);
		}
	}
	function onMouseLeave(event) {
		if (isEventListenerStopped(event) || instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick) return;
		if (instance.props.interactive) {
			instance.hideWithInteractivity(event);
			return;
		}
		scheduleHide(event);
	}
	function onBlurOrFocusOut(event) {
		if (instance.props.trigger.indexOf("focusin") < 0 && event.target !== getCurrentTarget()) return;
		if (instance.props.interactive && event.relatedTarget && popper$1.contains(event.relatedTarget)) return;
		scheduleHide(event);
	}
	function isEventListenerStopped(event) {
		return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0 : false;
	}
	function createPopperInstance() {
		destroyPopperInstance();
		var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset$1 = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
		var arrow$2 = getIsDefaultRenderFn() ? getChildren(popper$1).arrow : null;
		var computedReference = getReferenceClientRect ? {
			getBoundingClientRect: getReferenceClientRect,
			contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
		} : reference$1;
		var modifiers = [
			{
				name: "offset",
				options: { offset: offset$1 }
			},
			{
				name: "preventOverflow",
				options: { padding: {
					top: 2,
					bottom: 2,
					left: 5,
					right: 5
				} }
			},
			{
				name: "flip",
				options: { padding: 5 }
			},
			{
				name: "computeStyles",
				options: { adaptive: !moveTransition }
			},
			{
				name: "$$tippy",
				enabled: true,
				phase: "beforeWrite",
				requires: ["computeStyles"],
				fn: function fn(_ref2) {
					var state = _ref2.state;
					if (getIsDefaultRenderFn()) {
						var box = getDefaultTemplateChildren().box;
						[
							"placement",
							"reference-hidden",
							"escaped"
						].forEach(function(attr) {
							if (attr === "placement") box.setAttribute("data-placement", state.placement);
							else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, "");
							else box.removeAttribute("data-" + attr);
						});
						state.attributes.popper = {};
					}
				}
			}
		];
		if (getIsDefaultRenderFn() && arrow$2) modifiers.push({
			name: "arrow",
			options: {
				element: arrow$2,
				padding: 3
			}
		});
		modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
		instance.popperInstance = createPopper(computedReference, popper$1, Object.assign({}, popperOptions, {
			placement,
			onFirstUpdate,
			modifiers
		}));
	}
	function destroyPopperInstance() {
		if (instance.popperInstance) {
			instance.popperInstance.destroy();
			instance.popperInstance = null;
		}
	}
	function mount() {
		var appendTo = instance.props.appendTo;
		var parentNode;
		var node = getCurrentTarget();
		if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === "parent") parentNode = node.parentNode;
		else parentNode = invokeWithArgsOrReturn(appendTo, [node]);
		if (!parentNode.contains(popper$1)) parentNode.appendChild(popper$1);
		instance.state.isMounted = true;
		createPopperInstance();
		/* istanbul ignore else */
		if (process$1$1.env.NODE_ENV !== "production") warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper$1, [
			"Interactive tippy element may not be accessible via keyboard",
			"navigation because it is not directly after the reference element",
			"in the DOM source order.",
			"\n\n",
			"Using a wrapper <div> or <span> tag around the reference element",
			"solves this by creating a new parentNode context.",
			"\n\n",
			"Specifying `appendTo: document.body` silences this warning, but it",
			"assumes you are using a focus management solution to handle",
			"keyboard navigation.",
			"\n\n",
			"See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"
		].join(" "));
	}
	function getNestedPopperTree() {
		return arrayFrom(popper$1.querySelectorAll("[data-tippy-root]"));
	}
	function scheduleShow(event) {
		instance.clearDelayTimeouts();
		if (event) invokeHook("onTrigger", [instance, event]);
		addDocumentPress();
		var delay = getDelay(true);
		var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
		if (currentInput.isTouch && touchValue === "hold" && touchDelay) delay = touchDelay;
		if (delay) showTimeout = setTimeout(function() {
			instance.show();
		}, delay);
		else instance.show();
	}
	function scheduleHide(event) {
		instance.clearDelayTimeouts();
		invokeHook("onUntrigger", [instance, event]);
		if (!instance.state.isVisible) {
			removeDocumentPress();
			return;
		}
		if (instance.props.trigger.indexOf("mouseenter") >= 0 && instance.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(event.type) >= 0 && isVisibleFromClick) return;
		var delay = getDelay(false);
		if (delay) hideTimeout = setTimeout(function() {
			if (instance.state.isVisible) instance.hide();
		}, delay);
		else scheduleHideAnimationFrame = requestAnimationFrame(function() {
			instance.hide();
		});
	}
	function enable() {
		instance.state.isEnabled = true;
	}
	function disable() {
		instance.hide();
		instance.state.isEnabled = false;
	}
	function clearDelayTimeouts() {
		clearTimeout(showTimeout);
		clearTimeout(hideTimeout);
		cancelAnimationFrame(scheduleHideAnimationFrame);
	}
	function setProps(partialProps) {
		/* istanbul ignore else */
		if (process$1$1.env.NODE_ENV !== "production") warnWhen(instance.state.isDestroyed, createMemoryLeakWarning("setProps"));
		if (instance.state.isDestroyed) return;
		invokeHook("onBeforeUpdate", [instance, partialProps]);
		removeListeners();
		var prevProps = instance.props;
		var nextProps = evaluateProps(reference$1, Object.assign({}, prevProps, removeUndefinedProps(partialProps), { ignoreAttributes: true }));
		instance.props = nextProps;
		addListeners();
		if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
			cleanupInteractiveMouseListeners();
			debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
		}
		if (prevProps.triggerTarget && !nextProps.triggerTarget) normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
			node.removeAttribute("aria-expanded");
		});
		else if (nextProps.triggerTarget) reference$1.removeAttribute("aria-expanded");
		handleAriaExpandedAttribute();
		handleStyles();
		if (onUpdate) onUpdate(prevProps, nextProps);
		if (instance.popperInstance) {
			createPopperInstance();
			getNestedPopperTree().forEach(function(nestedPopper) {
				requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
			});
		}
		invokeHook("onAfterUpdate", [instance, partialProps]);
	}
	function setContent$1(content) {
		instance.setProps({ content });
	}
	function show() {
		/* istanbul ignore else */
		if (process$1$1.env.NODE_ENV !== "production") warnWhen(instance.state.isDestroyed, createMemoryLeakWarning("show"));
		var isAlreadyVisible = instance.state.isVisible;
		var isDestroyed = instance.state.isDestroyed;
		var isDisabled = !instance.state.isEnabled;
		var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
		var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);
		if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
		if (getCurrentTarget().hasAttribute("disabled")) return;
		invokeHook("onShow", [instance], false);
		if (instance.props.onShow(instance) === false) return;
		instance.state.isVisible = true;
		if (getIsDefaultRenderFn()) popper$1.style.visibility = "visible";
		handleStyles();
		addDocumentPress();
		if (!instance.state.isMounted) popper$1.style.transition = "none";
		if (getIsDefaultRenderFn()) {
			var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
			setTransitionDuration([box, content], 0);
		}
		onFirstUpdate = function onFirstUpdate$1() {
			var _instance$popperInsta2;
			if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
			ignoreOnFirstUpdate = true;
			popper$1.offsetHeight;
			popper$1.style.transition = instance.props.moveTransition;
			if (getIsDefaultRenderFn() && instance.props.animation) {
				var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
				setTransitionDuration([_box, _content], duration);
				setVisibilityState([_box, _content], "visible");
			}
			handleAriaContentAttribute();
			handleAriaExpandedAttribute();
			pushIfUnique(mountedInstances, instance);
			(_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
			invokeHook("onMount", [instance]);
			if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
				instance.state.isShown = true;
				invokeHook("onShown", [instance]);
			});
		};
		mount();
	}
	function hide$1() {
		/* istanbul ignore else */
		if (process$1$1.env.NODE_ENV !== "production") warnWhen(instance.state.isDestroyed, createMemoryLeakWarning("hide"));
		var isAlreadyHidden = !instance.state.isVisible;
		var isDestroyed = instance.state.isDestroyed;
		var isDisabled = !instance.state.isEnabled;
		var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);
		if (isAlreadyHidden || isDestroyed || isDisabled) return;
		invokeHook("onHide", [instance], false);
		if (instance.props.onHide(instance) === false) return;
		instance.state.isVisible = false;
		instance.state.isShown = false;
		ignoreOnFirstUpdate = false;
		isVisibleFromClick = false;
		if (getIsDefaultRenderFn()) popper$1.style.visibility = "hidden";
		cleanupInteractiveMouseListeners();
		removeDocumentPress();
		handleStyles(true);
		if (getIsDefaultRenderFn()) {
			var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
			if (instance.props.animation) {
				setTransitionDuration([box, content], duration);
				setVisibilityState([box, content], "hidden");
			}
		}
		handleAriaContentAttribute();
		handleAriaExpandedAttribute();
		if (instance.props.animation) {
			if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
		} else instance.unmount();
	}
	function hideWithInteractivity(event) {
		/* istanbul ignore else */
		if (process$1$1.env.NODE_ENV !== "production") warnWhen(instance.state.isDestroyed, createMemoryLeakWarning("hideWithInteractivity"));
		getDocument().addEventListener("mousemove", debouncedOnMouseMove);
		pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
		debouncedOnMouseMove(event);
	}
	function unmount() {
		/* istanbul ignore else */
		if (process$1$1.env.NODE_ENV !== "production") warnWhen(instance.state.isDestroyed, createMemoryLeakWarning("unmount"));
		if (instance.state.isVisible) instance.hide();
		if (!instance.state.isMounted) return;
		destroyPopperInstance();
		getNestedPopperTree().forEach(function(nestedPopper) {
			nestedPopper._tippy.unmount();
		});
		if (popper$1.parentNode) popper$1.parentNode.removeChild(popper$1);
		mountedInstances = mountedInstances.filter(function(i) {
			return i !== instance;
		});
		instance.state.isMounted = false;
		invokeHook("onHidden", [instance]);
	}
	function destroy() {
		/* istanbul ignore else */
		if (process$1$1.env.NODE_ENV !== "production") warnWhen(instance.state.isDestroyed, createMemoryLeakWarning("destroy"));
		if (instance.state.isDestroyed) return;
		instance.clearDelayTimeouts();
		instance.unmount();
		removeListeners();
		delete reference$1._tippy;
		instance.state.isDestroyed = true;
		invokeHook("onDestroy", [instance]);
	}
}
function tippy(targets, optionalProps) {
	if (optionalProps === void 0) optionalProps = {};
	var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
	/* istanbul ignore else */
	if (process$1$1.env.NODE_ENV !== "production") {
		validateTargets(targets);
		validateProps(optionalProps, plugins);
	}
	bindGlobalEventListeners();
	var passedProps = Object.assign({}, optionalProps, { plugins });
	var elements = getArrayOfElements(targets);
	/* istanbul ignore else */
	if (process$1$1.env.NODE_ENV !== "production") {
		var isSingleContentElement = isElement(passedProps.content);
		var isMoreThanOneReferenceElement = elements.length > 1;
		warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, [
			"tippy() was passed an Element as the `content` prop, but more than",
			"one tippy instance was created by this invocation. This means the",
			"content element will only be appended to the last tippy instance.",
			"\n\n",
			"Instead, pass the .innerHTML of the element, or use a function that",
			"returns a cloned version of the element instead.",
			"\n\n",
			"1) content: element.innerHTML\n",
			"2) content: () => element.cloneNode(true)"
		].join(" "));
	}
	var instances = elements.reduce(function(acc, reference$1) {
		var instance = reference$1 && createTippy(reference$1, passedProps);
		if (instance) acc.push(instance);
		return acc;
	}, []);
	return isElement(targets) ? instances[0] : instances;
}
tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
Object.assign({}, applyStyles_default, { effect: function effect$3(_ref) {
	var state = _ref.state;
	var initialStyles = {
		popper: {
			position: state.options.strategy,
			left: "0",
			top: "0",
			margin: "0"
		},
		arrow: { position: "absolute" },
		reference: {}
	};
	Object.assign(state.elements.popper.style, initialStyles.popper);
	state.styles = initialStyles;
	if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
} });
tippy.setDefaultProps({ render });
var tippy_esm_default = tippy;
const STYLE_ISOLATION_CLASS = "sd-editor-scoped";
const applyStyleIsolationClass = (target) => {
	if (!target || !target.classList) return;
	target.classList.add(STYLE_ISOLATION_CLASS);
};
var _hoisted_1$23 = ["onClick", "onMouseenter"];
var _hoisted_2$18 = { key: 0 };
var _hoisted_3$14 = { key: 0 };
var _hoisted_4$10 = { key: 1 };
var _hoisted_5$9 = { key: 1 };
var Mentions_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "Mentions",
	props: {
		users: {
			type: Array,
			required: true
		},
		mention: {
			type: String,
			default: ""
		},
		inserMention: {
			type: Function,
			required: true
		}
	},
	setup(__props) {
		const props = __props;
		const container = ref(null);
		const activeUserIndex = ref(null);
		const getFilteredUsers = computed(() => {
			const mention = props.mention.slice(1)?.toLowerCase();
			return props.users.filter((user) => {
				const isViewer = user.role === "viewer";
				const userMatch = user.name?.toLowerCase().startsWith(mention);
				const emailMatch = user.email?.toLowerCase().startsWith(mention);
				return !isViewer && (userMatch || emailMatch);
			}) || [];
		});
		const handleClick$1 = (user) => {
			props.inserMention(user);
		};
		const handleKeydown = (event) => {
			if (event.key === "ArrowDown") {
				activeUserIndex.value += 1;
				if (activeUserIndex.value === getFilteredUsers.value.length) activeUserIndex.value = 0;
			} else if (event.key === "ArrowUp") {
				activeUserIndex.value -= 1;
				if (activeUserIndex.value < 0) activeUserIndex.value = getFilteredUsers.value.length - 1;
			} else if (event.key === "Enter") {
				const user = getFilteredUsers.value[activeUserIndex.value];
				if (user) props.inserMention(user);
			}
		};
		const handleFocus = () => {
			activeUserIndex.value = 0;
		};
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "mentions-container",
				ref_key: "container",
				ref: container,
				onKeydown: withModifiers(handleKeydown, ["prevent"]),
				onFocus: withModifiers(handleFocus, ["stop", "prevent"]),
				tabindex: "0"
			}, [(openBlock(true), createElementBlock(Fragment, null, renderList(getFilteredUsers.value, (user, index) => {
				return openBlock(), createElementBlock("div", {
					onClick: withModifiers(($event) => handleClick$1(user), ["stop", "prevent"]),
					onMouseenter: ($event) => activeUserIndex.value = index,
					onMouseleave: _cache[0] || (_cache[0] = ($event) => activeUserIndex.value = null),
					key: user.email,
					class: normalizeClass(["user-row", { "sd-selected": activeUserIndex.value === index }])
				}, [user.name ? (openBlock(), createElementBlock("div", _hoisted_2$18, [user.name ? (openBlock(), createElementBlock("span", _hoisted_3$14, toDisplayString(user.name), 1)) : createCommentVNode("", true), user.name && user.email ? (openBlock(), createElementBlock("span", _hoisted_4$10, " (" + toDisplayString(user.email) + ")", 1)) : createCommentVNode("", true)])) : (openBlock(), createElementBlock("div", _hoisted_5$9, [createElementVNode("span", null, toDisplayString(user.email), 1)]))], 42, _hoisted_1$23);
			}), 128))], 544);
		};
	}
}, [["__scopeId", "data-v-b9684aad"]]);
var popoverPluginKey = new PluginKey("popoverPlugin");
const PopoverPlugin = Extension.create({
	name: "popoverPlugin",
	addOptions() {
		return {};
	},
	addPmPlugins() {
		return [new Plugin({
			key: popoverPluginKey,
			state: {
				init: () => {
					return {};
				},
				apply: (tr, value) => {
					const newValue = { ...value };
					if (tr.docChanged || tr.selectionSet) newValue.shouldUpdate = true;
					else newValue.shouldUpdate = false;
					return newValue;
				}
			},
			view: (view) => {
				const popover = new Popover(view, this.editor);
				return {
					update: (view$1, lastState) => {
						if (!popoverPluginKey.getState(view$1.state).shouldUpdate) return;
						popover.update(view$1, lastState);
					},
					destroy: () => {
						popover.destroy();
					}
				};
			}
		})];
	}
});
var Popover = class {
	constructor(view, editor) {
		this.editor = editor;
		this.view = view;
		this.popover = document.createElement("div");
		this.popover.className = "sd-editor-popover";
		applyStyleIsolationClass(this.popover);
		document.body.appendChild(this.popover);
		this.tippyInstance = tippy_esm_default(this.popover, {
			trigger: "manual",
			placement: "bottom-start",
			interactive: true,
			appendTo: document.body,
			arrow: false,
			onShow: (instance) => {
				instance.setProps({ getReferenceClientRect: () => this.popoverRect });
				this.bindKeyDownEvents();
			},
			onHide: () => {
				this.unbindKeyDownEvents();
			},
			theme: "sd-editor-popover"
		});
	}
	bindKeyDownEvents() {
		this.view.dom.addEventListener("keydown", this.handleKeyDown);
	}
	unbindKeyDownEvents() {
		this.view.dom.removeEventListener("keydown", this.handleKeyDown);
	}
	handleKeyDown = (event) => {
		const isArrow = event.key === "ArrowDown" || event.key === "ArrowUp";
		if (this.tippyInstance.state.isVisible && isArrow) {
			event.preventDefault();
			this.popover.firstChild.focus();
		}
	};
	mountVueComponent(component, props = {}) {
		if (this.app) this.app.unmount();
		this.app = createApp(component, props);
		this.app.mount(this.popover);
		this.tippyInstance.setContent(this.popover);
	}
	update(view) {
		this.state = view.state;
		const showPopover = this.isShowMentions;
		let popoverContent = {
			component: null,
			props: null
		};
		if (this.isShowMentions) {
			const { from: from$1 } = this.state.selection;
			const atMention = this.getMentionText(from$1);
			popoverContent = {
				component: Mentions_default,
				props: {
					users: this.editor.users,
					mention: atMention,
					inserMention: (user) => {
						const { $from } = this.state.selection;
						const length$1 = atMention.length;
						const attributes = { ...user };
						const mentionNode = this.editor.schema.nodes.mention.create(attributes);
						const tr = this.state.tr.replaceWith($from.pos - length$1, $from.pos, mentionNode);
						this.editor.view.dispatch(tr);
						this.editor.view.focus();
					}
				}
			};
		}
		if (showPopover && popoverContent.component) {
			const { to } = this.state.selection;
			const { component, props } = popoverContent;
			this.mountVueComponent(component, props);
			this.showPopoverAtPosition(to);
		} else this.tippyInstance.hide();
	}
	showPopoverAtPosition(pos) {
		const end$1 = this.view.coordsAtPos(pos);
		this.popoverRect = {
			width: 0,
			height: 0,
			top: end$1.bottom,
			left: end$1.left,
			bottom: end$1.bottom,
			right: end$1.left
		};
		this.tippyInstance.show();
	}
	getMentionText(from$1) {
		const startPos = Math.max(0, from$1 - 20);
		const textBefore = this.state.doc.textBetween(startPos, from$1, "\n", "\0");
		const atIndex = textBefore.lastIndexOf("@");
		if (atIndex !== -1) return textBefore.substring(atIndex);
		return "";
	}
	get isShowMentions() {
		const { from: from$1 } = this.state.selection;
		if (from$1 < 1) return false;
		return this.getMentionText(from$1).match(/(?:^|\s)@[\w]*$/) && this.state.selection.empty;
	}
	destroy() {
		this.tippyInstance.destroy();
		this.popover.remove();
	}
};
var DEFAULT_TRACKED_NODE_TYPE = "tracked-node";
const positionTrackerKey = new PluginKey("positionTracker");
function getNodeIdCandidates(node) {
	const attrs = node.attrs ?? {};
	const candidateFields = [
		"paraId",
		"sdBlockId",
		"blockId",
		"id",
		"uuid"
	];
	const ids = [];
	for (const field of candidateFields) {
		const value = attrs[field];
		if (typeof value === "string" && value.length > 0) ids.push(value);
	}
	return ids;
}
function findBlockCandidateById(doc$1, blockId) {
	let match$1 = null;
	let isAmbiguous = false;
	doc$1.descendants((node, pos) => {
		if (!node.isBlock) return;
		if (!getNodeIdCandidates(node).includes(blockId)) return;
		if (match$1) {
			isAmbiguous = true;
			return false;
		}
		match$1 = {
			node,
			pos
		};
	});
	if (isAmbiguous) return null;
	return match$1;
}
function resolveSegmentPosition(targetOffset, segmentStart, segmentLength, docFrom, docTo) {
	if (segmentLength <= 1) return targetOffset <= segmentStart ? docFrom : docTo;
	return docFrom + (targetOffset - segmentStart);
}
function resolveOffsetsInBlock(blockNode, blockPos, range) {
	if (range.start < 0 || range.end < range.start) return null;
	let flattenedOffset = 0;
	let fromPos;
	let toPos;
	const advanceSegment = (segmentLength, docFrom, docTo) => {
		const segmentStart = flattenedOffset;
		const segmentEnd = flattenedOffset + segmentLength;
		if (fromPos == null && range.start <= segmentEnd) fromPos = resolveSegmentPosition(range.start, segmentStart, segmentLength, docFrom, docTo);
		if (toPos == null && range.end <= segmentEnd) toPos = resolveSegmentPosition(range.end, segmentStart, segmentLength, docFrom, docTo);
		flattenedOffset = segmentEnd;
	};
	const walkNodeContent = (node, contentStart) => {
		let isFirstChild = true;
		let childOffset = 0;
		for (let i = 0; i < node.childCount; i += 1) {
			const child = node.child(i);
			const childPos = contentStart + childOffset;
			if (child.isBlock && !isFirstChild) advanceSegment(1, childPos, childPos + 1);
			walkNode(child, childPos);
			childOffset += child.nodeSize;
			isFirstChild = false;
		}
	};
	const walkNode = (node, docPos) => {
		if (node.isText) {
			const text = node.text ?? "";
			if (text.length > 0) advanceSegment(text.length, docPos, docPos + text.length);
			return;
		}
		if (node.isLeaf) {
			advanceSegment(1, docPos, docPos + node.nodeSize);
			return;
		}
		walkNodeContent(node, docPos + 1);
	};
	walkNodeContent(blockNode, blockPos + 1);
	if (flattenedOffset === 0 && range.start === 0 && range.end === 0) {
		const anchor = blockPos + 1;
		return {
			from: anchor,
			to: anchor
		};
	}
	if (range.end > flattenedOffset) return null;
	if (fromPos == null || toPos == null) return null;
	return {
		from: fromPos,
		to: toPos
	};
}
function getTrackableAddress(input) {
	if (!input || typeof input !== "object") return null;
	if ("kind" in input && (input.kind === "inline" || input.kind === "block")) return input;
	if ("address" in input && input.address && typeof input.address === "object") {
		const address = input.address;
		if (address.kind === "inline" || address.kind === "block") return address;
	}
	return null;
}
function createPositionTrackerPlugin() {
	return new Plugin({
		key: positionTrackerKey,
		state: {
			init() {
				return {
					decorations: DecorationSet.empty,
					generation: 0
				};
			},
			apply(tr, state) {
				let { decorations, generation } = state;
				const meta = tr.getMeta(positionTrackerKey);
				if (meta?.action === "add") decorations = decorations.add(tr.doc, meta.decorations);
				else if (meta?.action === "remove") {
					const toRemove = decorations.find().filter((decoration) => meta.ids.includes(decoration.spec.id));
					decorations = decorations.remove(toRemove);
				} else if (meta?.action === "removeByType") {
					const toRemove = decorations.find().filter((decoration) => decoration.spec.type === meta.type);
					decorations = decorations.remove(toRemove);
				}
				if (tr.docChanged) {
					decorations = decorations.map(tr.mapping, tr.doc);
					generation += 1;
				}
				return {
					decorations,
					generation
				};
			}
		},
		props: { decorations() {
			return null;
		} }
	});
}
var PositionTracker = class {
	#editor;
	constructor(editor) {
		this.#editor = editor;
	}
	#getState() {
		if (!this.#editor?.state) return null;
		return positionTrackerKey.getState(this.#editor.state) ?? null;
	}
	#resolveTrackNodeAddress(address) {
		const doc$1 = this.#editor?.state?.doc;
		if (!doc$1) return null;
		if (address.kind === "inline") {
			const { start: start$1, end: end$1 } = address.anchor;
			if (!start$1 || !end$1 || start$1.blockId !== end$1.blockId) return null;
			const block$1 = findBlockCandidateById(doc$1, start$1.blockId);
			if (!block$1) return null;
			return resolveOffsetsInBlock(block$1.node, block$1.pos, {
				start: start$1.offset,
				end: end$1.offset
			});
		}
		const block = findBlockCandidateById(doc$1, address.nodeId);
		if (!block) return null;
		const anchor = block.pos + 1;
		return {
			from: anchor,
			to: anchor
		};
	}
	track(from$1, to, spec) {
		const id = v4_default();
		if (!this.#editor?.state) return id;
		const fullSpec = {
			kind: "range",
			...spec,
			id
		};
		const deco = Decoration.inline(from$1, to, {}, fullSpec);
		const tr = this.#editor.state.tr.setMeta(positionTrackerKey, {
			action: "add",
			decorations: [deco]
		}).setMeta("addToHistory", false);
		this.#editor.dispatch(tr);
		return id;
	}
	trackMany(ranges) {
		if (!this.#editor?.state) return ranges.map(() => v4_default());
		const ids = [];
		const decorations = [];
		for (const { from: from$1, to, spec } of ranges) {
			const id = v4_default();
			ids.push(id);
			const fullSpec = {
				kind: "range",
				...spec,
				id
			};
			decorations.push(Decoration.inline(from$1, to, {}, fullSpec));
		}
		const tr = this.#editor.state.tr.setMeta(positionTrackerKey, {
			action: "add",
			decorations
		}).setMeta("addToHistory", false);
		this.#editor.dispatch(tr);
		return ids;
	}
	trackNode(input, spec) {
		const [trackedId] = this.trackNodes([input], spec);
		return trackedId ?? null;
	}
	trackNodes(inputs, spec) {
		if (!Array.isArray(inputs) || inputs.length === 0) return [];
		const trackSpec = {
			type: DEFAULT_TRACKED_NODE_TYPE,
			...spec ?? {}
		};
		const pendingRanges = [];
		const pendingInputIndexes = [];
		const results = Array.from({ length: inputs.length }, () => null);
		for (let index = 0; index < inputs.length; index += 1) {
			const address = getTrackableAddress(inputs[index]);
			if (!address) continue;
			const resolved = this.#resolveTrackNodeAddress(address);
			if (!resolved) continue;
			pendingRanges.push({
				from: resolved.from,
				to: resolved.to,
				spec: trackSpec
			});
			pendingInputIndexes.push(index);
		}
		if (pendingRanges.length === 0) return results;
		const trackedIds = this.trackMany(pendingRanges);
		for (let i = 0; i < pendingInputIndexes.length; i += 1) {
			const inputIndex = pendingInputIndexes[i];
			results[inputIndex] = trackedIds[i] ?? null;
		}
		return results;
	}
	untrack(id) {
		if (!this.#editor?.state) return;
		const tr = this.#editor.state.tr.setMeta(positionTrackerKey, {
			action: "remove",
			ids: [id]
		}).setMeta("addToHistory", false);
		this.#editor.dispatch(tr);
	}
	untrackMany(ids) {
		if (!this.#editor?.state || ids.length === 0) return;
		const tr = this.#editor.state.tr.setMeta(positionTrackerKey, {
			action: "remove",
			ids
		}).setMeta("addToHistory", false);
		this.#editor.dispatch(tr);
	}
	untrackByType(type) {
		if (!this.#editor?.state) return;
		const tr = this.#editor.state.tr.setMeta(positionTrackerKey, {
			action: "removeByType",
			type
		}).setMeta("addToHistory", false);
		this.#editor.dispatch(tr);
	}
	resolve(id) {
		const state = this.#getState();
		if (!state) return null;
		const found = state.decorations.find().find((decoration) => decoration.spec.id === id);
		if (!found) return null;
		const spec = found.spec;
		return {
			id: spec.id,
			from: found.from,
			to: found.to,
			spec
		};
	}
	resolveMany(ids) {
		const result = /* @__PURE__ */ new Map();
		for (const id of ids) result.set(id, null);
		const state = this.#getState();
		if (!state || ids.length === 0) return result;
		const idSet = new Set(ids);
		for (const decoration of state.decorations.find()) {
			const spec = decoration.spec;
			if (idSet.has(spec.id)) result.set(spec.id, {
				id: spec.id,
				from: decoration.from,
				to: decoration.to,
				spec
			});
		}
		return result;
	}
	findByType(type) {
		const state = this.#getState();
		if (!state) return [];
		return state.decorations.find().filter((decoration) => decoration.spec.type === type).map((decoration) => {
			const spec = decoration.spec;
			return {
				id: spec.id,
				from: decoration.from,
				to: decoration.to,
				spec
			};
		});
	}
	goToTracked(id, options) {
		const resolved = this.resolve(id);
		if (!resolved) return false;
		const from$1 = Math.max(0, Math.min(resolved.from, this.#editor.state.doc.content.size));
		const to = Math.max(from$1, Math.min(resolved.to, this.#editor.state.doc.content.size));
		const block = options?.block ?? "center";
		if (this.#editor.commands?.setTextSelection) this.#editor.commands.setTextSelection({
			from: from$1,
			to
		});
		else if (this.#editor.state) {
			const tr = this.#editor.state.tr.setSelection(TextSelection.create(this.#editor.state.doc, from$1, to)).scrollIntoView();
			this.#editor.dispatch(tr);
		}
		const presentationEditor = this.#editor.presentationEditor;
		if (!(presentationEditor?.scrollToPosition?.(from$1, { block }) ?? false)) {
			Promise.resolve(presentationEditor?.scrollToPositionAsync?.(from$1, { block })).catch(() => {});
			try {
				const { node } = this.#editor.view?.domAtPos(from$1) ?? { node: null };
				if (typeof Element !== "undefined" && node instanceof Element) node.scrollIntoView({
					block,
					inline: "nearest"
				});
				else if (node?.parentElement) node.parentElement?.scrollIntoView({
					block,
					inline: "nearest"
				});
			} catch {}
		}
		return true;
	}
	get generation() {
		return this.#getState()?.generation ?? 0;
	}
};
var SearchQuery = class {
	constructor(config) {
		this.search = config.search;
		this.caseSensitive = !!config.caseSensitive;
		this.literal = !!config.literal;
		this.regexp = !!config.regexp;
		this.replace = config.replace || "";
		this.valid = !!this.search && !(this.regexp && !validRegExp(this.search));
		this.wholeWord = !!config.wholeWord;
		this.filter = config.filter || null;
		this.impl = !this.valid ? nullQuery : this.regexp ? new RegExpQuery(this) : new StringQuery(this);
	}
	eq(other) {
		return this.search == other.search && this.replace == other.replace && this.caseSensitive == other.caseSensitive && this.regexp == other.regexp && this.wholeWord == other.wholeWord;
	}
	findNext(state, from$1 = 0, to = state.doc.content.size) {
		for (;;) {
			if (from$1 >= to) return null;
			let result = this.impl.findNext(state, from$1, to);
			if (!result || this.checkResult(state, result)) return result;
			from$1 = result.from + 1;
		}
	}
	findPrev(state, from$1 = state.doc.content.size, to = 0) {
		for (;;) {
			if (from$1 <= to) return null;
			let result = this.impl.findPrev(state, from$1, to);
			if (!result || this.checkResult(state, result)) return result;
			from$1 = result.to - 1;
		}
	}
	checkResult(state, result) {
		return (!this.wholeWord || checkWordBoundary(state, result.from) && checkWordBoundary(state, result.to)) && (!this.filter || this.filter(state, result));
	}
	unquote(string) {
		return this.literal ? string : string.replace(/\\([nrt\\])/g, (_$1, ch) => ch == "n" ? "\n" : ch == "r" ? "\r" : ch == "t" ? "	" : "\\");
	}
	getReplacements(state, result) {
		let marks = state.doc.resolve(result.from).marksAcross(state.doc.resolve(result.to));
		let ranges = [];
		let frag = Fragment$1.empty, pos = result.from, { match: match$1 } = result;
		let groups = match$1 ? getGroupIndices(match$1) : [[0, result.to - result.from]];
		let replParts = parseReplacement(this.unquote(this.replace));
		for (let part of replParts) if (typeof part == "string") frag = frag.addToEnd(state.schema.text(part, marks));
		else {
			const groupSpan = groups[part.group];
			if (!groupSpan) continue;
			let from$1 = result.matchStart + groupSpan[0], to = result.matchStart + groupSpan[1];
			if (part.copy) frag = frag.append(state.doc.slice(from$1, to).content);
			else {
				if (frag != Fragment$1.empty || from$1 > pos) {
					ranges.push({
						from: pos,
						to: from$1,
						insert: new Slice(frag, 0, 0)
					});
					frag = Fragment$1.empty;
				}
				pos = to;
			}
		}
		if (frag != Fragment$1.empty || pos < result.to) ranges.push({
			from: pos,
			to: result.to,
			insert: new Slice(frag, 0, 0)
		});
		return ranges;
	}
};
var nullQuery = new class {
	findNext() {
		return null;
	}
	findPrev() {
		return null;
	}
}();
var StringQuery = class {
	constructor(query) {
		this.query = query;
		let string = query.unquote(query.search);
		if (!query.caseSensitive) string = string.toLowerCase();
		this.string = string;
	}
	findNext(state, from$1, to) {
		return scanTextblocks(state.doc, from$1, to, (node, start$1) => {
			let off = Math.max(from$1, start$1);
			let content = textContent(node).slice(off - start$1, Math.min(node.content.size, to - start$1));
			let index = (this.query.caseSensitive ? content : content.toLowerCase()).indexOf(this.string);
			if (index < 0) return null;
			const absoluteIndex = off - start$1 + index;
			return {
				from: mapIndexToDocPos(node, start$1, absoluteIndex),
				to: mapIndexToDocPos(node, start$1, absoluteIndex + this.string.length),
				match: null,
				matchStart: start$1
			};
		});
	}
	findPrev(state, from$1, to) {
		return scanTextblocks(state.doc, from$1, to, (node, start$1) => {
			let off = Math.max(start$1, to);
			let content = textContent(node).slice(off - start$1, Math.min(node.content.size, from$1 - start$1));
			if (!this.query.caseSensitive) content = content.toLowerCase();
			let index = content.lastIndexOf(this.string);
			if (index < 0) return null;
			const absoluteIndex = off - start$1 + index;
			return {
				from: mapIndexToDocPos(node, start$1, absoluteIndex),
				to: mapIndexToDocPos(node, start$1, absoluteIndex + this.string.length),
				match: null,
				matchStart: start$1
			};
		});
	}
};
var baseFlags = "g" + (/x/.unicode == null ? "" : "u") + (/x/.hasIndices == null ? "" : "d");
var RegExpQuery = class {
	constructor(query) {
		this.query = query;
		this.regexp = new RegExp(query.search, baseFlags + (query.caseSensitive ? "" : "i"));
	}
	findNext(state, from$1, to) {
		return scanTextblocks(state.doc, from$1, to, (node, start$1) => {
			let content = textContent(node).slice(0, Math.min(node.content.size, to - start$1));
			this.regexp.lastIndex = from$1 - start$1;
			let match$1 = this.regexp.exec(content);
			if (!match$1) return null;
			const absoluteIndex = match$1.index;
			return {
				from: mapIndexToDocPos(node, start$1, absoluteIndex),
				to: mapIndexToDocPos(node, start$1, absoluteIndex + match$1[0].length),
				match: match$1,
				matchStart: start$1
			};
		});
	}
	findPrev(state, from$1, to) {
		return scanTextblocks(state.doc, from$1, to, (node, start$1) => {
			let content = textContent(node).slice(0, Math.min(node.content.size, from$1 - start$1));
			let match$1;
			for (let off = 0;;) {
				this.regexp.lastIndex = off;
				let next = this.regexp.exec(content);
				if (!next) break;
				match$1 = next;
				off = next.index + 1;
			}
			if (!match$1) return null;
			const absoluteIndex = match$1.index;
			return {
				from: mapIndexToDocPos(node, start$1, absoluteIndex),
				to: mapIndexToDocPos(node, start$1, absoluteIndex + match$1[0].length),
				match: match$1,
				matchStart: start$1
			};
		});
	}
};
function getGroupIndices(match$1) {
	if (match$1.indices) return match$1.indices;
	let result = [[0, match$1[0].length]];
	for (let i = 1, pos = 0; i < match$1.length; i++) {
		let found = match$1[i] ? match$1[0].indexOf(match$1[i], pos) : -1;
		result.push(found < 0 ? void 0 : [found, pos = found + match$1[i].length]);
	}
	return result;
}
function parseReplacement(text) {
	let result = [], highestSeen = -1;
	function add(text$1) {
		let last = result.length - 1;
		if (last > -1 && typeof result[last] == "string") result[last] += text$1;
		else result.push(text$1);
	}
	while (text.length) {
		let m$1 = /\$([$&\d+])/.exec(text);
		if (!m$1) {
			add(text);
			return result;
		}
		if (m$1.index > 0) add(text.slice(0, m$1.index + (m$1[1] == "$" ? 1 : 0)));
		if (m$1[1] != "$") {
			let n = m$1[1] == "&" ? 0 : +m$1[1];
			if (highestSeen >= n) result.push({
				group: n,
				copy: true
			});
			else {
				highestSeen = n || 1e3;
				result.push({
					group: n,
					copy: false
				});
			}
		}
		text = text.slice(m$1.index + m$1[0].length);
	}
	return result;
}
function validRegExp(source) {
	try {
		new RegExp(source, baseFlags);
		return true;
	} catch {
		return false;
	}
}
var TextContentCache = /* @__PURE__ */ new WeakMap();
var transparentInlineNodes = new Set(["run", "bookmarkStart"]);
function textContent(node) {
	let cached = TextContentCache.get(node);
	if (cached) return cached;
	let content = "";
	for (let i = 0; i < node.childCount; i++) {
		let child = node.child(i);
		if (child.isText) content += child.text;
		else if (child.isLeaf) content += "￼";
		else if (child.type && transparentInlineNodes.has(child.type.name)) content += textContent(child);
		else content += " " + textContent(child) + " ";
	}
	TextContentCache.set(node, content);
	return content;
}
function mapIndexToDocPos(node, start$1, index) {
	if (index <= 0) return start$1;
	if (index >= textContent(node).length) return start$1 + node.content.size;
	return mapIndexWithinNode(node, start$1, index);
}
function mapIndexWithinNode(node, start$1, index) {
	if (index <= 0) return start$1;
	let offset$1 = start$1;
	for (let i = 0; i < node.childCount; i++) {
		const child = node.child(i);
		const childStart = offset$1;
		if (child.isText) {
			const len = child.text.length;
			if (index <= len) return childStart + index;
			index -= len;
			offset$1 += child.nodeSize;
			continue;
		}
		if (child.isLeaf) {
			if (index <= 1) return childStart + Math.min(index, 1);
			index -= 1;
			offset$1 += child.nodeSize;
			continue;
		}
		const isTransparentInline = child.inlineContent && child.type && transparentInlineNodes.has(child.type.name);
		const innerTextLength = textContent(child).length;
		if (isTransparentInline) {
			if (index <= innerTextLength) return mapIndexWithinNode(child, childStart + 1, index);
			index -= innerTextLength;
			offset$1 += child.nodeSize;
			continue;
		}
		const contribution = innerTextLength + 2;
		const relativeIndex = index - 1;
		if (relativeIndex < 0) return childStart;
		if (relativeIndex <= innerTextLength) return mapIndexWithinNode(child, childStart + 1, relativeIndex);
		if (relativeIndex === innerTextLength + 1) return childStart + child.nodeSize;
		index -= contribution;
		offset$1 += child.nodeSize;
	}
	return start$1 + node.content.size;
}
function scanTextblocks(node, from$1, to, f, nodeStart = 0) {
	const isTransparentInline = node.inlineContent && node.type && transparentInlineNodes.has(node.type.name);
	if (node.inlineContent && !isTransparentInline) return f(node, nodeStart);
	else if (!node.isLeaf) if (from$1 > to) for (let i = node.childCount - 1, pos = nodeStart + node.content.size; i >= 0 && pos > to; i--) {
		let child = node.child(i);
		pos -= child.nodeSize;
		if (pos < from$1) {
			let result = scanTextblocks(child, from$1, to, f, pos + 1);
			if (result != null) return result;
		}
	}
	else for (let i = 0, pos = nodeStart; i < node.childCount && pos < to; i++) {
		let child = node.child(i), start$1 = pos;
		pos += child.nodeSize;
		if (pos > from$1) {
			let result = scanTextblocks(child, from$1, to, f, start$1 + 1);
			if (result != null) return result;
		}
	}
	return null;
}
function checkWordBoundary(state, pos) {
	let $pos = state.doc.resolve(pos);
	let before = $pos.nodeBefore, after = $pos.nodeAfter;
	if (!before || !after || !before.isText || !after.isText) return true;
	return !/\p{L}$/u.test(before.text) || !/^\p{L}/u.test(after.text);
}
var SearchState = class {
	constructor(query, range, highlight, deco) {
		this.query = query;
		this.range = range;
		this.highlight = highlight;
		this.deco = deco;
	}
};
function buildMatchDeco(state, query, range, highlight = true) {
	if (!query.valid) return DecorationSet.empty;
	let deco = [];
	let sel = state.selection;
	for (let pos = range ? range.from : 0, end$1 = range ? range.to : state.doc.content.size;;) {
		let next = query.findNext(state, pos, end$1);
		if (!next) break;
		let cls = next.from == sel.from && next.to == sel.to ? "ProseMirror-active-search-match" : "ProseMirror-search-match";
		const attrs = highlight ? { class: cls } : {};
		deco.push(Decoration.inline(next.from, next.to, attrs));
		pos = next.to;
	}
	return DecorationSet.create(state.doc, deco);
}
var searchKey = new PluginKey("search");
function search(options = {}) {
	return new Plugin({
		key: searchKey,
		state: {
			init(_config, state) {
				let query = options.initialQuery || new SearchQuery({ search: "" });
				let range = options.initialRange || null;
				const highlight = options.initialHighlight ?? true;
				return new SearchState(query, range, highlight, buildMatchDeco(state, query, range, highlight));
			},
			apply(tr, search$1, _oldState, state) {
				let set = tr.getMeta(searchKey);
				if (set) {
					const highlight = typeof set.highlight === "boolean" ? set.highlight : true;
					return new SearchState(set.query, set.range, highlight, buildMatchDeco(state, set.query, set.range, highlight));
				}
				if (tr.docChanged || tr.selectionSet) {
					let range = search$1.range;
					if (range) {
						let from$1 = tr.mapping.map(range.from, 1);
						let to = tr.mapping.map(range.to, -1);
						range = from$1 < to ? {
							from: from$1,
							to
						} : null;
					}
					const highlight = typeof search$1.highlight === "boolean" ? search$1.highlight : true;
					search$1 = new SearchState(search$1.query, range, highlight, buildMatchDeco(state, search$1.query, range, highlight));
				}
				return search$1;
			}
		},
		props: { decorations: (state) => searchKey.getState(state).deco }
	});
}
function getMatchHighlights(state) {
	let search$1 = searchKey.getState(state);
	return search$1 ? search$1.deco : DecorationSet.empty;
}
function nextMatch(search$1, state, wrap, curFrom, curTo) {
	let range = search$1.range || {
		from: 0,
		to: state.doc.content.size
	};
	let next = search$1.query.findNext(state, Math.max(curTo, range.from), range.to);
	if (!next && wrap) next = search$1.query.findNext(state, range.from, Math.min(curFrom, range.to));
	return next;
}
function prevMatch(search$1, state, wrap, curFrom, curTo) {
	let range = search$1.range || {
		from: 0,
		to: state.doc.content.size
	};
	let prev = search$1.query.findPrev(state, Math.min(curFrom, range.to), range.from);
	if (!prev && wrap) prev = search$1.query.findPrev(state, range.to, Math.max(curTo, range.from));
	return prev;
}
function findCommand(wrap, dir) {
	return (state, dispatch) => {
		let search$1 = searchKey.getState(state);
		if (!search$1 || !search$1.query.valid) return false;
		let { from: from$1, to } = state.selection;
		let next = dir > 0 ? nextMatch(search$1, state, wrap, from$1, to) : prevMatch(search$1, state, wrap, from$1, to);
		if (!next) return false;
		let selection = TextSelection.create(state.doc, next.from, next.to);
		if (dispatch) dispatch(state.tr.setSelection(selection).scrollIntoView());
		return true;
	};
}
findCommand(true, 1);
findCommand(false, 1);
findCommand(true, -1);
findCommand(false, -1);
function replaceCommand(wrap, moveForward) {
	return (state, dispatch) => {
		let search$1 = searchKey.getState(state);
		if (!search$1 || !search$1.query.valid) return false;
		let { from: from$1 } = state.selection;
		let next = nextMatch(search$1, state, wrap, from$1, from$1);
		if (!next) return false;
		if (!dispatch) return true;
		if (state.selection.from == next.from && state.selection.to == next.to) {
			let tr = state.tr, replacements = search$1.query.getReplacements(state, next);
			for (let i = replacements.length - 1; i >= 0; i--) {
				let { from: from$2, to, insert } = replacements[i];
				tr.replace(from$2, to, insert);
			}
			let after = moveForward && nextMatch(search$1, state, wrap, next.from, next.to);
			if (after) tr.setSelection(TextSelection.create(tr.doc, tr.mapping.map(after.from, 1), tr.mapping.map(after.to, -1)));
			else tr.setSelection(TextSelection.create(tr.doc, next.from, tr.mapping.map(next.to, 1)));
			dispatch(tr.scrollIntoView());
		} else if (!moveForward) return false;
		else dispatch(state.tr.setSelection(TextSelection.create(state.doc, next.from, next.to)).scrollIntoView());
		return true;
	};
}
replaceCommand(true, true);
replaceCommand(false, true);
replaceCommand(false, false);
var BLOCK_SEPARATOR = "\n";
var ATOM_PLACEHOLDER = "￼";
var DELETION_BARRIER = "\0";
var DEFAULT_SEARCH_MODEL$1 = "raw";
var hasTrackDeleteMark$2 = (node) => node?.marks?.some((mark) => mark?.type?.name === "trackDelete") ?? false;
var readLeafText = (node) => {
	const leafText = node?.type?.spec?.leafText;
	if (typeof leafText === "function") return leafText(node);
	if (typeof leafText === "string") return leafText;
	return ATOM_PLACEHOLDER;
};
var SearchIndex = class SearchIndex {
	text = "";
	segments = [];
	valid = false;
	docSize = 0;
	doc = null;
	searchModel = DEFAULT_SEARCH_MODEL$1;
	build(doc$1, options = {}) {
		const searchModel = options?.searchModel === "visible" ? "visible" : DEFAULT_SEARCH_MODEL$1;
		if (searchModel === "visible") this.#buildVisible(doc$1);
		else this.text = doc$1.textBetween(0, doc$1.content.size, BLOCK_SEPARATOR, readLeafText);
		this.segments = [];
		this.docSize = doc$1.content.size;
		this.doc = doc$1;
		this.searchModel = searchModel;
		let offset$1 = 0;
		const visibleContext = searchModel === "visible" ? { deletionBarrierActive: false } : null;
		this.#walkNodeContent(doc$1, 0, offset$1, (segment) => {
			this.segments.push(segment);
			offset$1 = segment.offsetEnd;
		}, searchModel, visibleContext);
		this.valid = true;
	}
	#buildVisible(doc$1) {
		const parts = [];
		let emittedDeletionBarrier = false;
		const appendDeletionBarrier = () => {
			if (emittedDeletionBarrier) return;
			parts.push(DELETION_BARRIER);
			emittedDeletionBarrier = true;
		};
		const walkNodeContent = (node) => {
			let isFirstChild = true;
			node.forEach((child) => {
				if (child.isBlock && !isFirstChild) {
					parts.push(BLOCK_SEPARATOR);
					emittedDeletionBarrier = false;
				}
				walkNode(child);
				isFirstChild = false;
			});
		};
		const walkNode = (node) => {
			if (node.isText) {
				const text = node.text || "";
				if (!text.length) return;
				if (hasTrackDeleteMark$2(node)) {
					appendDeletionBarrier();
					return;
				}
				parts.push(text);
				emittedDeletionBarrier = false;
				return;
			}
			if (node.isLeaf) {
				if (hasTrackDeleteMark$2(node)) {
					appendDeletionBarrier();
					return;
				}
				parts.push(readLeafText(node));
				emittedDeletionBarrier = false;
				return;
			}
			walkNodeContent(node);
		};
		walkNodeContent(doc$1);
		this.text = parts.join("");
	}
	#walkNodeContent(node, contentStart, offset$1, addSegment, searchModel = DEFAULT_SEARCH_MODEL$1, context = null) {
		let currentOffset = offset$1;
		let isFirstChild = true;
		node.forEach((child, childContentOffset) => {
			const childDocPos = contentStart + childContentOffset;
			if (child.isBlock && !isFirstChild) {
				addSegment({
					offsetStart: currentOffset,
					offsetEnd: currentOffset + 1,
					docFrom: childDocPos,
					docTo: childDocPos,
					kind: "blockSep"
				});
				currentOffset += 1;
				if (context && searchModel === "visible") context.deletionBarrierActive = false;
			}
			currentOffset = this.#walkNode(child, childDocPos, currentOffset, addSegment, searchModel, context);
			isFirstChild = false;
		});
		return currentOffset;
	}
	#walkNode(node, docPos, offset$1, addSegment, searchModel = DEFAULT_SEARCH_MODEL$1, context = null) {
		if (node.isText) {
			if (searchModel === "visible" && hasTrackDeleteMark$2(node)) {
				if (context?.deletionBarrierActive) return offset$1;
				addSegment({
					offsetStart: offset$1,
					offsetEnd: offset$1 + 1,
					docFrom: docPos,
					docTo: docPos,
					kind: "atom"
				});
				if (context) context.deletionBarrierActive = true;
				return offset$1 + 1;
			}
			const text = node.text || "";
			if (text.length > 0) {
				if (context && searchModel === "visible") context.deletionBarrierActive = false;
				addSegment({
					offsetStart: offset$1,
					offsetEnd: offset$1 + text.length,
					docFrom: docPos,
					docTo: docPos + text.length,
					kind: "text"
				});
				return offset$1 + text.length;
			}
			return offset$1;
		}
		if (node.isLeaf) {
			if (searchModel === "visible" && hasTrackDeleteMark$2(node)) {
				if (context?.deletionBarrierActive) return offset$1;
				addSegment({
					offsetStart: offset$1,
					offsetEnd: offset$1 + 1,
					docFrom: docPos,
					docTo: docPos + node.nodeSize,
					kind: "atom"
				});
				if (context) context.deletionBarrierActive = true;
				return offset$1 + 1;
			}
			if (context && searchModel === "visible") context.deletionBarrierActive = false;
			const leafText = readLeafText(node);
			if (leafText.length === 0) return offset$1;
			if (node.type.name === "hard_break") {
				addSegment({
					offsetStart: offset$1,
					offsetEnd: offset$1 + leafText.length,
					docFrom: docPos,
					docTo: docPos + node.nodeSize,
					kind: "hardBreak"
				});
				return offset$1 + leafText.length;
			}
			addSegment({
				offsetStart: offset$1,
				offsetEnd: offset$1 + leafText.length,
				docFrom: docPos,
				docTo: docPos + node.nodeSize,
				kind: "atom"
			});
			return offset$1 + leafText.length;
		}
		return this.#walkNodeContent(node, docPos + 1, offset$1, addSegment, searchModel, context);
	}
	invalidate() {
		this.valid = false;
	}
	isStale(doc$1, options = {}) {
		const searchModel = options?.searchModel === "visible" ? "visible" : DEFAULT_SEARCH_MODEL$1;
		return !this.valid || this.doc !== doc$1 || this.searchModel !== searchModel;
	}
	ensureValid(doc$1, options = {}) {
		if (this.isStale(doc$1, options)) this.build(doc$1, options);
	}
	offsetRangeToDocRanges(start$1, end$1) {
		const ranges = [];
		let current = null;
		for (const segment of this.segments) {
			if (segment.offsetEnd <= start$1) continue;
			if (segment.offsetStart >= end$1) break;
			if (segment.kind === "blockSep") {
				if (current) {
					ranges.push({
						from: current.from,
						to: current.to
					});
					current = null;
				}
				continue;
			}
			const overlapStart = Math.max(start$1, segment.offsetStart);
			const overlapEnd = Math.min(end$1, segment.offsetEnd);
			if (overlapStart >= overlapEnd) continue;
			let from$1;
			let to;
			if (segment.kind === "text") {
				from$1 = segment.docFrom + (overlapStart - segment.offsetStart);
				to = segment.docFrom + (overlapEnd - segment.offsetStart);
			} else {
				from$1 = segment.docFrom;
				to = segment.docTo;
			}
			if (current && segment.offsetStart === current.offsetEnd && from$1 === current.to) {
				current.to = to;
				current.offsetEnd = overlapEnd;
			} else {
				if (current) ranges.push({
					from: current.from,
					to: current.to
				});
				current = {
					from: from$1,
					to,
					offsetEnd: overlapEnd
				};
			}
		}
		if (current) ranges.push({
			from: current.from,
			to: current.to
		});
		return ranges;
	}
	offsetToDocPos(offset$1) {
		for (const segment of this.segments) if (offset$1 >= segment.offsetStart && offset$1 < segment.offsetEnd) {
			if (segment.kind === "text") return segment.docFrom + (offset$1 - segment.offsetStart);
			return segment.docFrom;
		}
		if (this.segments.length > 0 && offset$1 === this.segments[this.segments.length - 1].offsetEnd) return this.segments[this.segments.length - 1].docTo;
		return null;
	}
	static escapeRegex(str) {
		return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	}
	static toFlexiblePattern(searchString) {
		const hasLeadingWhitespace = /^[\s\u00a0]+/.test(searchString);
		const hasTrailingWhitespace = /[\s\u00a0]+$/.test(searchString);
		const parts = searchString.replace(/^[\s\u00a0]+|[\s\u00a0]+$/g, "").split(/[\s\u00a0]+/).filter((part) => part.length > 0);
		if (parts.length === 0) return hasLeadingWhitespace || hasTrailingWhitespace ? "[\\s\\u00a0]+" : "";
		const blockSeparatorPattern = "(?:\\n)*";
		let pattern = parts.map((part) => {
			return Array.from(part).map((ch) => SearchIndex.escapeRegex(ch)).join(blockSeparatorPattern);
		}).join("[\\s\\u00a0]+");
		if (hasLeadingWhitespace) pattern = "[\\s\\u00a0]+" + pattern;
		if (hasTrailingWhitespace) pattern = pattern + "[\\s\\u00a0]+";
		return pattern;
	}
	search(pattern, options = {}) {
		const { caseSensitive = false, maxMatches = 1e3 } = options;
		const matches = [];
		let regex;
		if (pattern instanceof RegExp) {
			const flags = pattern.flags.includes("g") ? pattern.flags : pattern.flags + "g";
			regex = new RegExp(pattern.source, flags);
		} else if (typeof pattern === "string") {
			if (pattern.length === 0) return matches;
			const flexiblePattern = SearchIndex.toFlexiblePattern(pattern);
			if (flexiblePattern.length === 0) return matches;
			const flags = caseSensitive ? "g" : "gi";
			regex = new RegExp(flexiblePattern, flags);
		} else return matches;
		let match$1;
		while ((match$1 = regex.exec(this.text)) !== null && matches.length < maxMatches) {
			matches.push({
				start: match$1.index,
				end: match$1.index + match$1[0].length,
				text: match$1[0]
			});
			if (match$1[0].length === 0) regex.lastIndex++;
		}
		return matches;
	}
	static DIACRITICS_PATTERN = /[\u0300-\u036f\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7]/g;
	static stripDiacritics(str) {
		return str.normalize("NFD").replace(SearchIndex.DIACRITICS_PATTERN, "");
	}
	static buildDiacriticOffsetMap(original) {
		const nfd = original.normalize("NFD");
		const toOriginal = [];
		let foldedChars = [];
		const nfdToOriginal = [];
		let origIdx = 0;
		for (let nfdIdx = 0; nfdIdx < nfd.length;) {
			const origNfd = original[origIdx].normalize("NFD");
			for (let k$1 = 0; k$1 < origNfd.length; k$1++) nfdToOriginal[nfdIdx + k$1] = origIdx;
			nfdIdx += origNfd.length;
			origIdx++;
		}
		for (let nfdIdx = 0; nfdIdx < nfd.length; nfdIdx++) {
			const cp = nfd.charCodeAt(nfdIdx);
			if (cp >= 768 && cp <= 879 || cp >= 1425 && cp <= 1469 || cp === 1471 || cp === 1473 || cp === 1474 || cp === 1476 || cp === 1477 || cp === 1479) continue;
			foldedChars.push(nfd[nfdIdx]);
			toOriginal.push(nfdToOriginal[nfdIdx]);
		}
		toOriginal.push(original.length);
		return {
			folded: foldedChars.join(""),
			toOriginal
		};
	}
	searchIgnoringDiacritics(pattern, options = {}) {
		const { caseSensitive = false, maxMatches = 1e3 } = options;
		if (!pattern || typeof pattern !== "string" || pattern.length === 0) return [];
		const { folded: foldedText, toOriginal } = SearchIndex.buildDiacriticOffsetMap(this.text);
		const foldedQuery = SearchIndex.stripDiacritics(pattern);
		const flexiblePattern = SearchIndex.toFlexiblePattern(foldedQuery);
		if (flexiblePattern.length === 0) return [];
		const flags = caseSensitive ? "g" : "gi";
		const regex = new RegExp(flexiblePattern, flags);
		const matches = [];
		let match$1;
		while ((match$1 = regex.exec(foldedText)) !== null && matches.length < maxMatches) {
			const originalStart = toOriginal[match$1.index];
			const originalEnd = toOriginal[match$1.index + match$1[0].length];
			matches.push({
				start: originalStart,
				end: originalEnd,
				text: this.text.slice(originalStart, originalEnd)
			});
			if (match$1[0].length === 0) regex.lastIndex++;
		}
		return matches;
	}
};
const customSearchHighlightsKey = new PluginKey("customSearchHighlights");
var isRegExp = (value) => Object.prototype.toString.call(value) === "[object RegExp]";
var SEARCH_POSITION_TRACKER_TYPE = "search-match";
var DEFAULT_SEARCH_MODEL = "raw";
var normalizeSearchModel = (value) => value === "visible" ? "visible" : DEFAULT_SEARCH_MODEL;
var mapIndexMatchesToDocMatches = ({ searchIndex, indexMatches, doc: doc$1, positionTracker }) => {
	const matches = [];
	for (const indexMatch of indexMatches) {
		const ranges = searchIndex.offsetRangeToDocRanges(indexMatch.start, indexMatch.end);
		if (ranges.length === 0) continue;
		const matchTexts = ranges.map((r$1) => doc$1.textBetween(r$1.from, r$1.to));
		const matchText = typeof indexMatch.text === "string" ? indexMatch.text : matchTexts.join("");
		const match$1 = {
			from: ranges[0].from,
			to: ranges[ranges.length - 1].to,
			text: matchText,
			id: v4_default(),
			ranges,
			trackerIds: []
		};
		if (positionTracker?.trackMany) {
			const trackedRanges = ranges.map((range, rangeIndex) => ({
				from: range.from,
				to: range.to,
				spec: {
					type: SEARCH_POSITION_TRACKER_TYPE,
					metadata: { rangeIndex }
				}
			}));
			const trackerIds = positionTracker.trackMany(trackedRanges);
			if (trackerIds.length > 0) {
				match$1.trackerIds = trackerIds;
				match$1.id = trackerIds[0];
			}
		}
		matches.push(match$1);
	}
	return matches;
};
var resolveMatchSelectionRange = (match$1, positionTracker) => {
	if (!match$1) return {
		from: void 0,
		to: void 0
	};
	if (positionTracker?.resolve && Array.isArray(match$1.trackerIds) && match$1.trackerIds.length > 0) {
		const resolved = positionTracker.resolve(match$1.trackerIds[0]);
		if (resolved) return {
			from: resolved.from,
			to: resolved.to
		};
	}
	if (match$1?.ranges && match$1.ranges.length > 0) return {
		from: match$1.ranges[0].from,
		to: match$1.ranges[0].to
	};
	if (positionTracker?.resolve && match$1?.id) {
		const resolved = positionTracker.resolve(match$1.id);
		if (resolved) return {
			from: resolved.from,
			to: resolved.to
		};
	}
	return {
		from: match$1.from,
		to: match$1.to
	};
};
var resolveInlineTextPosition = (doc$1, position, direction) => {
	const docSize = doc$1.content.size;
	if (!Number.isFinite(position) || position < 0 || position > docSize) return position;
	const step = direction === "forward" ? 1 : -1;
	let current = position;
	let iterations = 0;
	while (iterations < 8) {
		iterations += 1;
		const resolved = doc$1.resolve(current);
		const boundaryNode = direction === "forward" ? resolved.nodeAfter : resolved.nodeBefore;
		if (!boundaryNode) break;
		if (boundaryNode.isText) break;
		if (!boundaryNode.isInline || boundaryNode.isAtom || boundaryNode.content.size === 0) break;
		const next = current + step;
		if (next < 0 || next > docSize) break;
		current = next;
		const adjacent = doc$1.resolve(current);
		const checkNode = direction === "forward" ? adjacent.nodeAfter : adjacent.nodeBefore;
		if (checkNode && checkNode.isText) break;
	}
	return current;
};
var resolveSearchRange = ({ doc: doc$1, from: from$1, to, expectedText, highlights }) => {
	const docSize = doc$1.content.size;
	let resolvedFrom = Math.max(0, Math.min(from$1, docSize));
	let resolvedTo = Math.max(0, Math.min(to, docSize));
	if (highlights) {
		const windowStart = Math.max(0, resolvedFrom - 4);
		const windowEnd = Math.min(docSize, resolvedTo + 4);
		const candidates = highlights.find(windowStart, windowEnd);
		if (candidates.length > 0) {
			let chosen = candidates[0];
			if (expectedText) {
				const matching = candidates.filter((decoration) => doc$1.textBetween(decoration.from, decoration.to) === expectedText);
				if (matching.length > 0) chosen = matching[0];
			}
			resolvedFrom = chosen.from;
			resolvedTo = chosen.to;
		}
	}
	const normalizedFrom = resolveInlineTextPosition(doc$1, resolvedFrom, "forward");
	const normalizedTo = resolveInlineTextPosition(doc$1, resolvedTo, "backward");
	if (Number.isFinite(normalizedFrom) && Number.isFinite(normalizedTo) && normalizedFrom <= normalizedTo) {
		resolvedFrom = normalizedFrom;
		resolvedTo = normalizedTo;
	}
	return {
		from: resolvedFrom,
		to: resolvedTo
	};
};
var getPositionTracker = (editor) => {
	if (!editor) return null;
	if (editor.positionTracker) return editor.positionTracker;
	const storageTracker = editor.storage?.positionTracker?.tracker;
	if (storageTracker) {
		editor.positionTracker = storageTracker;
		return storageTracker;
	}
	const tracker = new PositionTracker(editor);
	if (editor.storage?.positionTracker) editor.storage.positionTracker.tracker = tracker;
	editor.positionTracker = tracker;
	return tracker;
};
const Search = Extension.create({
	addStorage() {
		return {
			searchResults: [],
			highlightEnabled: true,
			searchIndex: new SearchIndex(),
			activeMatchIndex: -1,
			query: "",
			caseSensitive: false,
			ignoreDiacritics: false,
			searchModel: DEFAULT_SEARCH_MODEL
		};
	},
	addPmPlugins() {
		const editor = this.editor;
		const storage = this.storage;
		const searchIndexInvalidatorPlugin = new Plugin({
			key: new PluginKey("searchIndexInvalidator"),
			appendTransaction(transactions, oldState, newState) {
				if (!transactions.some((tr) => tr.docChanged)) return null;
				if (storage?.searchIndex) storage.searchIndex.invalidate();
				if (storage?.query) {
					storage.searchIndex.ensureValid(newState.doc, { searchModel: storage.searchModel ?? DEFAULT_SEARCH_MODEL });
					const indexMatches = (storage.ignoreDiacritics ? (q$1, opts) => storage.searchIndex.searchIgnoringDiacritics(q$1, opts) : (q$1, opts) => storage.searchIndex.search(q$1, opts))(storage.query, {
						caseSensitive: storage.caseSensitive,
						searchModel: storage.searchModel ?? DEFAULT_SEARCH_MODEL
					});
					const refreshed = mapIndexMatchesToDocMatches({
						searchIndex: storage.searchIndex,
						indexMatches,
						doc: newState.doc
					});
					storage.searchResults = refreshed;
					if (refreshed.length === 0) storage.activeMatchIndex = -1;
					else if (storage.activeMatchIndex < 0) storage.activeMatchIndex = 0;
					else if (storage.activeMatchIndex >= refreshed.length) storage.activeMatchIndex = refreshed.length - 1;
				}
				return null;
			}
		});
		const searchHighlightWithIdPlugin = new Plugin({
			key: customSearchHighlightsKey,
			props: { decorations(state) {
				if (!editor) return null;
				const matches = storage?.searchResults;
				if (!matches?.length) return null;
				const highlightEnabled = storage?.highlightEnabled !== false;
				const decorations = [];
				const activeIdx = storage?.activeMatchIndex ?? -1;
				for (let i = 0; i < matches.length; i++) {
					const match$1 = matches[i];
					const cls = i === activeIdx ? "ProseMirror-active-search-match" : "ProseMirror-search-match";
					const attrs = highlightEnabled ? {
						id: `search-match-${match$1.id}`,
						class: cls
					} : { id: `search-match-${match$1.id}` };
					if (match$1.ranges && match$1.ranges.length > 0) for (const range of match$1.ranges) decorations.push(Decoration.inline(range.from, range.to, attrs));
					else decorations.push(Decoration.inline(match$1.from, match$1.to, attrs));
				}
				return DecorationSet.create(state.doc, decorations);
			} }
		});
		return [
			search(),
			searchIndexInvalidatorPlugin,
			searchHighlightWithIdPlugin
		];
	},
	addCommands() {
		return {
			goToFirstMatch: () => ({ state, editor, dispatch }) => {
				const searchResults = this.storage?.searchResults;
				if (Array.isArray(searchResults) && searchResults.length > 0) {
					const firstMatch = searchResults[0];
					const { from: from$1, to } = resolveMatchSelectionRange(firstMatch, getPositionTracker(editor));
					if (typeof from$1 !== "number" || typeof to !== "number") return false;
					editor.view.focus();
					const tr$1 = state.tr.setSelection(TextSelection.create(state.doc, from$1, to)).scrollIntoView();
					if (dispatch) dispatch(tr$1);
					const presentationEditor$1 = editor.presentationEditor;
					if (presentationEditor$1 && typeof presentationEditor$1.scrollToPosition === "function") {
						if (presentationEditor$1.scrollToPosition(from$1, { block: "center" })) return true;
					}
					try {
						const domPos = editor.view.domAtPos(from$1);
						if (domPos?.node?.scrollIntoView) domPos.node.scrollIntoView(true);
					} catch {}
					return true;
				}
				const highlights = getMatchHighlights(state);
				if (!highlights) return false;
				const decorations = highlights.find();
				if (!decorations?.length) return false;
				const firstDeco = decorations[0];
				editor.view.focus();
				const tr = state.tr.setSelection(TextSelection.create(state.doc, firstDeco.from, firstDeco.to)).scrollIntoView();
				if (dispatch) dispatch(tr);
				const presentationEditor = editor.presentationEditor;
				if (presentationEditor && typeof presentationEditor.scrollToPosition === "function") {
					if (presentationEditor.scrollToPosition(firstDeco.from, { block: "center" })) return true;
				}
				try {
					const domPos = editor.view.domAtPos(firstDeco.from);
					if (domPos?.node?.scrollIntoView) domPos.node.scrollIntoView(true);
				} catch {}
				return true;
			},
			search: (patternInput, options = {}) => ({ state, editor }) => {
				if (options != null && (typeof options !== "object" || Array.isArray(options))) throw new TypeError("Search options must be an object");
				const highlight = typeof options?.highlight === "boolean" ? options.highlight : true;
				const maxMatches = typeof options?.maxMatches === "number" ? options.maxMatches : 1e3;
				const searchModel = normalizeSearchModel(options?.searchModel);
				let caseSensitive = false;
				let searchPattern = patternInput;
				if (isRegExp(patternInput)) {
					caseSensitive = !patternInput.flags.includes("i");
					searchPattern = patternInput;
				} else if (typeof patternInput === "string" && /^\/(.+)\/([gimsuy]*)$/.test(patternInput)) {
					const [, body, flags] = patternInput.match(/^\/(.+)\/([gimsuy]*)$/);
					caseSensitive = !flags.includes("i");
					searchPattern = new RegExp(body, flags.includes("g") ? flags : flags + "g");
				} else {
					searchPattern = String(patternInput);
					caseSensitive = typeof options?.caseSensitive === "boolean" ? options.caseSensitive : false;
				}
				const positionTracker = getPositionTracker(editor);
				positionTracker?.untrackByType?.(SEARCH_POSITION_TRACKER_TYPE);
				const searchIndex = this.storage.searchIndex;
				searchIndex.ensureValid(state.doc, { searchModel });
				this.storage.searchModel = searchModel;
				const resultMatches = mapIndexMatchesToDocMatches({
					searchIndex,
					indexMatches: searchIndex.search(searchPattern, {
						caseSensitive,
						maxMatches,
						searchModel
					}),
					doc: state.doc,
					positionTracker
				});
				this.storage.searchResults = resultMatches;
				this.storage.highlightEnabled = highlight;
				return resultMatches;
			},
			goToSearchResult: (match$1) => ({ state, dispatch, editor }) => {
				const positionTracker = getPositionTracker(editor);
				const doc$1 = state.doc;
				const highlights = getMatchHighlights(state);
				let { from: from$1, to } = resolveMatchSelectionRange(match$1, positionTracker);
				if (typeof from$1 !== "number" || typeof to !== "number") return false;
				const normalized = resolveSearchRange({
					doc: doc$1,
					from: from$1,
					to,
					expectedText: match$1?.text ?? null,
					highlights
				});
				from$1 = normalized.from;
				to = normalized.to;
				editor.view.focus();
				const tr = state.tr.setSelection(TextSelection.create(state.doc, from$1, to)).scrollIntoView();
				if (dispatch) dispatch(tr);
				const presentationEditor = editor.presentationEditor;
				const scrollOpts = {
					block: "center",
					ifNeeded: true,
					suppressSelectionSyncScroll: true
				};
				if (!(presentationEditor?.scrollToPosition?.(from$1, scrollOpts) ?? false)) {
					Promise.resolve(presentationEditor?.scrollToPositionAsync?.(from$1, scrollOpts)).catch(() => {});
					const { node } = editor.view.domAtPos(from$1);
					if (node?.scrollIntoView) node.scrollIntoView({
						block: "center",
						inline: "nearest"
					});
				}
				return true;
			},
			setSearchSession: (query, options = {}) => ({ state, editor }) => {
				const caseSensitive = options.caseSensitive ?? false;
				const ignoreDiacritics = options.ignoreDiacritics ?? false;
				const highlight = options.highlight ?? true;
				const searchModel = normalizeSearchModel(options.searchModel);
				this.storage.query = query;
				this.storage.caseSensitive = caseSensitive;
				this.storage.ignoreDiacritics = ignoreDiacritics;
				this.storage.searchModel = searchModel;
				const positionTracker = getPositionTracker(editor);
				positionTracker?.untrackByType?.(SEARCH_POSITION_TRACKER_TYPE);
				if (!query) {
					this.storage.searchResults = [];
					this.storage.activeMatchIndex = -1;
					this.storage.highlightEnabled = highlight;
					return {
						matches: [],
						activeMatchIndex: -1
					};
				}
				const searchIndex = this.storage.searchIndex;
				searchIndex.ensureValid(state.doc, { searchModel });
				const resultMatches = mapIndexMatchesToDocMatches({
					searchIndex,
					indexMatches: ignoreDiacritics ? searchIndex.searchIgnoringDiacritics(query, {
						caseSensitive,
						searchModel
					}) : searchIndex.search(query, {
						caseSensitive,
						searchModel
					}),
					doc: state.doc,
					positionTracker
				});
				this.storage.searchResults = resultMatches;
				this.storage.highlightEnabled = highlight;
				this.storage.activeMatchIndex = resultMatches.length > 0 ? 0 : -1;
				return {
					matches: resultMatches,
					activeMatchIndex: this.storage.activeMatchIndex
				};
			},
			clearSearchSession: () => ({ editor }) => {
				getPositionTracker(editor)?.untrackByType?.(SEARCH_POSITION_TRACKER_TYPE);
				this.storage.searchResults = [];
				this.storage.highlightEnabled = true;
				this.storage.activeMatchIndex = -1;
				this.storage.query = "";
				this.storage.caseSensitive = false;
				this.storage.ignoreDiacritics = false;
				this.storage.searchModel = DEFAULT_SEARCH_MODEL;
				return true;
			},
			nextSearchMatch: () => ({ editor }) => {
				const matches = this.storage.searchResults;
				if (!matches || matches.length === 0) return {
					activeMatchIndex: -1,
					match: null
				};
				const nextIdx = (this.storage.activeMatchIndex + 1) % matches.length;
				this.storage.activeMatchIndex = nextIdx;
				const match$1 = matches[nextIdx];
				editor.commands.goToSearchResult(match$1);
				return {
					activeMatchIndex: nextIdx,
					match: match$1
				};
			},
			previousSearchMatch: () => ({ editor }) => {
				const matches = this.storage.searchResults;
				if (!matches || matches.length === 0) return {
					activeMatchIndex: -1,
					match: null
				};
				const prevIdx = (this.storage.activeMatchIndex - 1 + matches.length) % matches.length;
				this.storage.activeMatchIndex = prevIdx;
				const match$1 = matches[prevIdx];
				editor.commands.goToSearchResult(match$1);
				return {
					activeMatchIndex: prevIdx,
					match: match$1
				};
			},
			replaceSearchMatch: (replacement) => ({ state, dispatch, commands: commands$1 }) => {
				const matches = this.storage.searchResults;
				const activeIdx = this.storage.activeMatchIndex;
				if (!matches || activeIdx < 0 || activeIdx >= matches.length) return {
					matches: matches || [],
					activeMatchIndex: activeIdx
				};
				const match$1 = matches[activeIdx];
				const from$1 = match$1.ranges[0].from;
				const to = match$1.ranges[match$1.ranges.length - 1].to;
				const tr = state.tr;
				if (replacement) tr.replace(from$1, to, new Slice(Fragment$1.from(state.schema.text(replacement)), 0, 0));
				else tr.replace(from$1, to, Slice.empty);
				if (dispatch) dispatch(tr);
				state.tr;
				const result = commands$1.setSearchSession(this.storage.query, {
					caseSensitive: this.storage.caseSensitive,
					ignoreDiacritics: this.storage.ignoreDiacritics,
					highlight: this.storage.highlightEnabled,
					searchModel: this.storage.searchModel
				});
				if (result.matches.length > 0) {
					const newIdx = Math.min(activeIdx, result.matches.length - 1);
					this.storage.activeMatchIndex = newIdx;
					result.activeMatchIndex = newIdx;
					const nextMatch$1 = result.matches[newIdx];
					if (nextMatch$1) commands$1.goToSearchResult(nextMatch$1);
				}
				return result;
			},
			replaceAllSearchMatches: (replacement) => ({ state, dispatch, commands: commands$1 }) => {
				const matches = this.storage.searchResults;
				if (!matches || matches.length === 0) return { replacedCount: 0 };
				const { schema } = state;
				const tr = state.tr;
				const count = matches.length;
				for (let i = matches.length - 1; i >= 0; i--) {
					const match$1 = matches[i];
					const from$1 = match$1.ranges[0].from;
					const to = match$1.ranges[match$1.ranges.length - 1].to;
					if (replacement) tr.replace(from$1, to, new Slice(Fragment$1.from(schema.text(replacement)), 0, 0));
					else tr.replace(from$1, to, Slice.empty);
				}
				if (dispatch) dispatch(tr);
				commands$1.clearSearchSession();
				return { replacedCount: count };
			}
		};
	}
});
const NodeResizerKey = new PluginKey("node-resizer");
var nodeResizer = (nodeNames = ["image"], editor) => {
	let resizeState = {
		dragging: false,
		startX: 0,
		startY: 0,
		startWidth: 0,
		startHeight: 0,
		handle: null,
		pos: null,
		resizableElement: null,
		aspectRatio: 1
	};
	let resizeContainer = null;
	let editorView = null;
	let globalClickHandler = null;
	let globalMousedownHandler = null;
	let scrollHandler = null;
	let currentWrapper = null;
	return new Plugin({
		key: NodeResizerKey,
		state: {
			init() {
				return DecorationSet.empty;
			},
			apply(tr, oldState, _$1, newState) {
				if (tr.getMeta(NodeResizerKey)) return oldState;
				if (typeof document === "undefined" || editor.options.isHeadless) return oldState;
				if (!editor.options.isHeaderOrFooter && (editor.options.documentMode === "viewing" || !editor.isEditable)) return DecorationSet.empty;
				const { selection } = newState;
				const node = selection.node;
				if (!node || !nodeNames.includes(node.type.name)) return DecorationSet.empty;
				if (node.attrs?.vmlWatermark === true) return DecorationSet.empty;
				const decorations = [];
				if (nodeNames.includes(selection.node?.type.name)) decorations.push(Decoration.node(selection.from, selection.to, {
					nodeName: "span",
					class: "sd-editor-resizable-wrapper",
					"data-pos": selection.from
				}));
				return DecorationSet.create(newState.doc, decorations);
			}
		},
		props: { decorations(state) {
			return this.getState(state);
		} },
		view(view) {
			editorView = view;
			globalClickHandler = (event) => {
				if (!event.target.closest(".sd-editor-resizable-wrapper") && !event.target.closest(".sd-editor-resize-container")) hideResizeHandles();
			};
			document.addEventListener("click", globalClickHandler);
			globalMousedownHandler = (event) => {
				if (event.target.closest(".sd-editor-resize-handle")) {
					event.preventDefault();
					event.stopPropagation();
					startResize(editorView, event, event.target);
					return true;
				}
			};
			document.addEventListener("mousedown", globalMousedownHandler);
			scrollHandler = () => {
				if (currentWrapper && resizeContainer) updateHandlePositions(currentWrapper);
			};
			window.addEventListener("scroll", scrollHandler, true);
			return {
				update(view$1, prevState) {
					const { selection } = view$1.state;
					const prevSelection = prevState.selection;
					if (selection.from !== prevSelection.from || selection.to !== prevSelection.to) setTimeout(() => {
						const selectedResizableWrapper = (editorView?.dom)?.querySelector(".sd-editor-resizable-wrapper");
						if (selectedResizableWrapper) showResizeHandles(view$1, selectedResizableWrapper);
						else hideResizeHandles();
					}, 10);
				},
				destroy() {
					hideResizeHandles();
					cleanupEventListeners();
					if (globalClickHandler) {
						document.removeEventListener("click", globalClickHandler);
						globalClickHandler = null;
					}
					if (globalMousedownHandler) {
						document.removeEventListener("mousedown", globalMousedownHandler);
						globalMousedownHandler = null;
					}
					if (scrollHandler) {
						window.removeEventListener("scroll", scrollHandler, true);
						scrollHandler = null;
					}
					editorView = null;
				}
			};
		}
	});
	function showResizeHandles(view, wrapper) {
		hideResizeHandles();
		const pos = Number.parseInt(wrapper.getAttribute("data-pos"), 10);
		const node = view.state.doc.nodeAt(pos);
		if (!nodeNames.includes(node?.type.name)) return;
		if (node?.attrs?.vmlWatermark === true) return;
		currentWrapper = wrapper;
		resizeContainer = document.createElement("div");
		resizeContainer.className = "sd-editor-resize-container";
		resizeContainer.style.position = "absolute";
		resizeContainer.style.pointerEvents = "none";
		resizeContainer.style.zIndex = "1000";
		for (const handle of [
			"nw",
			"ne",
			"sw",
			"se"
		]) {
			const handleEl = document.createElement("div");
			handleEl.className = `sd-editor-resize-handle sd-editor-resize-handle-${handle}`;
			handleEl.setAttribute("data-handle", handle);
			handleEl.setAttribute("data-pos", pos);
			handleEl.style.pointerEvents = "auto";
			resizeContainer.appendChild(handleEl);
		}
		applyStyleIsolationClass(resizeContainer);
		document.body.appendChild(resizeContainer);
		updateHandlePositions(wrapper);
	}
	function hideResizeHandles() {
		if (resizeContainer?.parentNode) {
			resizeContainer.parentNode.removeChild(resizeContainer);
			resizeContainer = null;
		}
		currentWrapper = null;
	}
	function updateHandlePositions(resizableElement) {
		if (!resizeContainer || !resizableElement) return;
		const rect = resizableElement.getBoundingClientRect();
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
		resizeContainer.style.left = `${rect.left + scrollLeft}px`;
		resizeContainer.style.top = `${rect.top + scrollTop}px`;
		resizeContainer.style.width = `${rect.width}px`;
		resizeContainer.style.height = `${rect.height}px`;
	}
	function startResize(view, event, handleElement) {
		if (!view.hasFocus()) return;
		const handle = handleElement.getAttribute("data-handle");
		const pos = Number.parseInt(handleElement.getAttribute("data-pos"), 10);
		if (view.state.selection.from !== pos || !nodeNames.includes(view.state.selection.node?.type.name)) return;
		const resizableElement = view.nodeDOM(pos);
		if (!resizableElement) return;
		const rect = resizableElement.getBoundingClientRect();
		resizeState = {
			dragging: true,
			startX: event.clientX,
			startY: event.clientY,
			startWidth: rect.width,
			startHeight: rect.height,
			handle,
			pos,
			resizableElement,
			aspectRatio: rect.width / rect.height
		};
		document.addEventListener("mousemove", handleMouseMove);
		document.addEventListener("mouseup", handleMouseUp);
		document.body.style.cursor = getResizeCursor(handle);
		document.body.style.userSelect = "none";
	}
	function handleMouseMove(event) {
		if (!resizeState.dragging) return;
		event.preventDefault();
		event.stopPropagation();
		let deltaX = event.clientX - resizeState.startX;
		if (resizeState.handle.includes("w")) deltaX = -deltaX;
		const newWidth = Math.max(20, resizeState.startWidth + deltaX);
		if (resizeState.resizableElement) {
			resizeState.resizableElement.style.width = `${newWidth}px`;
			resizeState.resizableElement.style.height = "auto";
			updateHandlePositions(resizeState.resizableElement);
		}
	}
	function handleMouseUp(event) {
		if (!resizeState.dragging) return;
		cleanupEventListeners();
		let deltaX = event.clientX - resizeState.startX;
		if (resizeState.handle.includes("w")) deltaX = -deltaX;
		const newWidth = Math.max(20, resizeState.startWidth + deltaX);
		const newHeight = newWidth / resizeState.aspectRatio;
		if (editorView && resizeState.pos < editorView.state.doc.content.size) {
			const tr = editorView.state.tr;
			const node = tr.doc.nodeAt(resizeState.pos);
			if (nodeNames.includes(node?.type.name)) {
				const attrs = {
					...node.attrs,
					size: {
						...node.attrs.size,
						width: Math.round(newWidth),
						height: Math.round(newHeight)
					}
				};
				tr.setNodeMarkup(resizeState.pos, null, attrs);
				tr.setMeta(NodeResizerKey, { action: "resize" });
				editorView.dispatch(tr);
			}
		}
		resizeState = {
			dragging: false,
			startX: 0,
			startY: 0,
			startWidth: 0,
			startHeight: 0,
			handle: null,
			pos: null,
			resizableElement: null,
			aspectRatio: 1
		};
	}
	function cleanupEventListeners() {
		document.removeEventListener("mousemove", handleMouseMove);
		document.removeEventListener("mouseup", handleMouseUp);
		document.body.style.cursor = "";
		document.body.style.userSelect = "";
	}
	function getResizeCursor(handle) {
		switch (handle) {
			case "nw":
			case "se": return "nwse-resize";
			case "ne":
			case "sw": return "nesw-resize";
			default: return "default";
		}
	}
};
const NodeResizer = Extension.create({
	name: "nodeResizer",
	addOptions() {
		return {};
	},
	addPmPlugins() {
		if (this.editor.options.isHeadless || !(typeof document !== "undefined")) return [];
		return [nodeResizer(["image"], this.editor)];
	}
});
const PERMISSION_MUTATION_META = "permissionRangeMutation";
var PERMISSION_PLUGIN_KEY = new PluginKey("permissionRanges");
var EVERYONE_GROUP = "everyone";
var EMPTY_IDENTIFIER_SET = Object.freeze(/* @__PURE__ */ new Set());
var normalizeIdentifier = (value) => typeof value === "string" ? value.trim().toLowerCase() : "";
var isEveryoneGroup = (value) => normalizeIdentifier(value) === EVERYONE_GROUP;
var isRangeAllowedForUser = (attrs, allowedIdentifiers) => {
	if (!attrs) return false;
	if (isEveryoneGroup(attrs.edGrp)) return true;
	if (!allowedIdentifiers?.size) return false;
	const normalizedEd = normalizeIdentifier(attrs.ed);
	return normalizedEd && allowedIdentifiers.has(normalizedEd);
};
var getPermissionTypeInfo = (schema) => {
	const startTypes = [];
	const endTypes = [];
	const permStartType = schema?.nodes?.["permStart"];
	const permStartBlockType = schema?.nodes?.["permStartBlock"];
	const permEndType = schema?.nodes?.["permEnd"];
	const permEndBlockType = schema?.nodes?.["permEndBlock"];
	if (permStartType) startTypes.push(permStartType);
	if (permStartBlockType) startTypes.push(permStartBlockType);
	if (permEndType) endTypes.push(permEndType);
	if (permEndBlockType) endTypes.push(permEndBlockType);
	return {
		startTypes,
		endTypes,
		startTypeSet: new Set(startTypes),
		endTypeSet: new Set(endTypes),
		allTypeSet: new Set([...startTypes, ...endTypes])
	};
};
var getPermissionNodeId = (node, pos, fallbackPrefix) => String(node.attrs?.id ?? `${fallbackPrefix}-${pos}`);
var derivePrincipal = (attrs) => {
	if (isEveryoneGroup(attrs?.edGrp)) return { kind: "everyone" };
	if (attrs?.ed) return {
		kind: "editor",
		id: String(attrs.ed)
	};
	return { kind: "everyone" };
};
var buildPermissionState = (doc$1, allowedIdentifiers = EMPTY_IDENTIFIER_SET, permTypes, protectionEnforced = false) => {
	const allRanges = [];
	const allowedRanges = [];
	const openRanges = /* @__PURE__ */ new Map();
	const startTypeSet = permTypes?.startTypeSet ?? /* @__PURE__ */ new Set();
	const endTypeSet = permTypes?.endTypeSet ?? /* @__PURE__ */ new Set();
	const blockStartType = doc$1.type.schema?.nodes?.["permStartBlock"];
	const blockEndType = doc$1.type.schema?.nodes?.["permEndBlock"];
	doc$1.descendants((node, pos) => {
		if (startTypeSet.has(node.type)) {
			const id = getPermissionNodeId(node, pos, "permStart");
			openRanges.set(id, {
				from: pos + node.nodeSize,
				startPos: pos,
				attrs: node.attrs ?? {},
				isBlock: node.type === blockStartType
			});
			return false;
		}
		if (endTypeSet.has(node.type)) {
			const id = getPermissionNodeId(node, pos, "permEnd");
			const start$1 = openRanges.get(id);
			if (start$1) {
				const to = Math.max(pos, start$1.from);
				if (to > start$1.from) {
					const isBlock = start$1.isBlock || node.type === blockEndType;
					const entry = {
						id,
						from: start$1.from,
						to,
						startPos: start$1.startPos,
						endPos: pos,
						principal: derivePrincipal(start$1.attrs),
						kind: isBlock ? "block" : "inline",
						edGrp: start$1.attrs.edGrp,
						ed: start$1.attrs.ed
					};
					allRanges.push(entry);
					if (protectionEnforced && isRangeAllowedForUser(start$1.attrs, allowedIdentifiers)) allowedRanges.push(entry);
				}
				openRanges.delete(id);
			}
			return false;
		}
	});
	return {
		allRanges,
		allowedRanges,
		hasAllowedRanges: allowedRanges.length > 0,
		ranges: allowedRanges
	};
};
var collectPermissionTags = (doc$1, permStartTypes, permEndTypes) => {
	const tags = /* @__PURE__ */ new Map();
	const permStartTypeSet = new Set(permStartTypes);
	const permEndTypeSet = new Set(permEndTypes);
	doc$1.descendants((node, pos) => {
		if (!permStartTypeSet.has(node.type) && !permEndTypeSet.has(node.type)) return;
		const id = node.attrs?.id;
		if (!id) return;
		const entry = tags.get(id) ?? {};
		if (permStartTypeSet.has(node.type)) entry.start = {
			pos,
			attrs: node.attrs ?? {},
			nodeType: node.type
		};
		else if (permEndTypeSet.has(node.type)) entry.end = {
			pos,
			attrs: node.attrs ?? {},
			nodeType: node.type
		};
		tags.set(id, entry);
	});
	return tags;
};
var clampPosition = (pos, size$1) => {
	if (Number.isNaN(pos) || !Number.isFinite(pos)) return 0;
	return Math.max(0, Math.min(pos, size$1));
};
var trimPermissionTagsFromRange = (doc$1, range, permTagTypes) => {
	let from$1 = range.from;
	let to = range.to;
	while (from$1 < to) {
		const node = doc$1.nodeAt(from$1);
		if (!node || !permTagTypes.has(node.type)) break;
		from$1 += node.nodeSize;
	}
	while (to > from$1) {
		const nodeBefore = doc$1.resolve(to).nodeBefore;
		if (!nodeBefore || !permTagTypes.has(nodeBefore.type)) break;
		to -= nodeBefore.nodeSize;
	}
	return {
		from: from$1,
		to
	};
};
var collectChangedRanges = (tr) => {
	const ranges = [];
	tr.mapping.maps.forEach((map$1) => {
		map$1.forEach((oldStart, oldEnd) => {
			const from$1 = Math.min(oldStart, oldEnd);
			const to = Math.max(oldStart, oldEnd);
			ranges.push({
				from: from$1,
				to
			});
		});
	});
	return ranges;
};
var isRangeAllowed = (range, allowedRanges) => {
	if (!allowedRanges?.length) return false;
	return allowedRanges.some((allowed) => range.from >= allowed.from && range.to <= allowed.to);
};
const PermissionRanges = Extension.create({
	name: "permissionRanges",
	addStorage() {
		return {
			allRanges: [],
			allowedRanges: [],
			hasAllowedRanges: false,
			ranges: []
		};
	},
	addPmPlugins() {
		const editor = this.editor;
		const storage = this.storage;
		const getAllowedIdentifiers = () => buildAllowedIdentifierSetFromEditor(editor);
		return [new Plugin({
			key: PERMISSION_PLUGIN_KEY,
			state: {
				init(_$1, state) {
					const permissionTypeInfo = getPermissionTypeInfo(state.schema);
					const protectionEnforced = isReadOnlyProtectionRuntimeEnforced(editor);
					const permissionState = buildPermissionState(state.doc, getAllowedIdentifiers(), permissionTypeInfo, protectionEnforced);
					storage.allRanges = permissionState.allRanges;
					storage.allowedRanges = permissionState.allowedRanges;
					storage.hasAllowedRanges = permissionState.hasAllowedRanges;
					storage.ranges = permissionState.ranges;
					applyEffectiveEditability(editor, { refilterRanges: false });
					return permissionState;
				},
				apply(tr, value, _oldState, newState) {
					if (!tr.docChanged) return value;
					const permissionTypeInfo = getPermissionTypeInfo(newState.schema);
					const protectionEnforced = isReadOnlyProtectionRuntimeEnforced(editor);
					const permissionState = buildPermissionState(newState.doc, getAllowedIdentifiers(), permissionTypeInfo, protectionEnforced);
					storage.allRanges = permissionState.allRanges;
					storage.allowedRanges = permissionState.allowedRanges;
					storage.hasAllowedRanges = permissionState.hasAllowedRanges;
					storage.ranges = permissionState.ranges;
					applyEffectiveEditability(editor, { refilterRanges: false });
					return permissionState;
				}
			},
			appendTransaction(transactions, oldState, newState) {
				if (!transactions.some((tr$1) => tr$1.docChanged)) return null;
				if (transactions.some((tr$1) => tr$1.getMeta?.("permissionRangeMutation"))) return null;
				if (transactions.some((tr$1) => tr$1.getMeta?.(ySyncPluginKey))) return null;
				const permTypes = getPermissionTypeInfo(newState.schema);
				if (!permTypes.startTypes.length || !permTypes.endTypes.length) return null;
				const oldTags = collectPermissionTags(oldState.doc, permTypes.startTypes, permTypes.endTypes);
				if (!oldTags.size) return null;
				const newTags = collectPermissionTags(newState.doc, permTypes.startTypes, permTypes.endTypes);
				const mappingToNew = new Mapping();
				transactions.forEach((tr$1) => {
					mappingToNew.appendMapping(tr$1.mapping);
				});
				const pendingInsertions = [];
				oldTags.forEach((tag, id) => {
					const current = newTags.get(id);
					if (tag.start && !current?.start) {
						const mapped = mappingToNew.mapResult(tag.start.pos, -1);
						pendingInsertions.push({
							pos: mapped.pos,
							nodeType: tag.start.nodeType,
							attrs: tag.start.attrs,
							priority: 0
						});
					}
					if (tag.end && !current?.end) {
						const mapped = mappingToNew.mapResult(tag.end.pos, 1);
						pendingInsertions.push({
							pos: mapped.pos,
							nodeType: tag.end.nodeType,
							attrs: tag.end.attrs,
							priority: 1
						});
					}
				});
				if (!pendingInsertions.length) return null;
				pendingInsertions.sort((a, b$1) => {
					if (a.pos === b$1.pos) return a.priority - b$1.priority;
					return a.pos - b$1.pos;
				});
				const tr = newState.tr;
				let offset$1 = 0;
				pendingInsertions.forEach((item) => {
					if (!item.nodeType) return;
					const node = item.nodeType.create(item.attrs);
					const insertPos = clampPosition(item.pos + offset$1, tr.doc.content.size);
					tr.insert(insertPos, node);
					offset$1 += node.nodeSize;
				});
				return tr.docChanged ? tr : null;
			},
			filterTransaction(tr, state) {
				if (!tr.docChanged) return true;
				if (tr.getMeta?.(ySyncPluginKey)) return true;
				if (tr.getMeta?.("permissionRangeMutation")) return true;
				if (!editor) return true;
				if (!isReadOnlyProtectionRuntimeEnforced(editor)) return true;
				const activeRanges = storage.allowedRanges ?? storage.ranges;
				if (!activeRanges?.length) return false;
				const changedRanges = collectChangedRanges(tr);
				if (!changedRanges.length) return true;
				const permTypes = getPermissionTypeInfo(state.schema);
				if (!permTypes.startTypes.length || !permTypes.endTypes.length) return true;
				return changedRanges.every((range) => {
					return isRangeAllowed(trimPermissionTagsFromRange(state.doc, range, permTypes.allTypeSet), activeRanges);
				});
			}
		})];
	}
});
const Protection = Extension.create({
	name: "protection",
	addStorage() {
		return {
			state: {
				editingRestriction: {
					mode: "none",
					enforced: false,
					runtimeEnforced: false,
					passwordProtected: false,
					formattingRestricted: false
				},
				writeProtection: {
					enabled: false,
					passwordProtected: false
				},
				readOnlyRecommended: false
			},
			initialized: false,
			editableBaseline: null
		};
	}
});
const DOM_CLASS_NAMES = {
	PAGE: "superdoc-page",
	FRAGMENT: "superdoc-fragment",
	LINE: "superdoc-line",
	INLINE_SDT_WRAPPER: "superdoc-structured-content-inline",
	INLINE_SDT_LABEL: "superdoc-structured-content-inline__label",
	BLOCK_SDT: "superdoc-structured-content-block",
	BLOCK_SDT_LABEL: "superdoc-structured-content__label",
	TABLE_FRAGMENT: "superdoc-table-fragment",
	DOCUMENT_SECTION: "superdoc-document-section",
	SDT_GROUP_HOVER: "sdt-group-hover",
	TOC_ENTRY: "superdoc-toc-entry",
	TOC_GROUP_HOVER: "toc-group-hover",
	IMAGE_FRAGMENT: "superdoc-image-fragment",
	INLINE_IMAGE: "superdoc-inline-image",
	LIST_MARKER: "superdoc-list-marker",
	INLINE_IMAGE_CLIP_WRAPPER: "superdoc-inline-image-clip-wrapper",
	ANNOTATION: "annotation",
	ANNOTATION_CONTENT: "annotation-content",
	ANNOTATION_CARET_ANCHOR: "annotation-caret-anchor"
};
const STRUCTURED_CONTENT_CHROME_LABEL_CLASS_NAMES = [DOM_CLASS_NAMES.INLINE_SDT_LABEL, DOM_CLASS_NAMES.BLOCK_SDT_LABEL];
const DATA_ATTRS = {
	PM_START: "data-pm-start",
	PM_END: "data-pm-end",
	LAYOUT_EPOCH: "data-layout-epoch",
	TABLE_BOUNDARIES: "data-table-boundaries",
	SDT_ID: "data-sdt-id",
	SDT_TYPE: "data-sdt-type",
	FIELD_ID: "data-field-id",
	FIELD_TYPE: "data-field-type",
	DRAGGABLE: "data-draggable",
	DISPLAY_LABEL: "data-display-label",
	VARIANT: "data-variant",
	TYPE: "data-type",
	LAYOUT_BOUNDARY_SCHEMA: "data-layout-boundary-schema",
	LAYOUT_FRAGMENT_ID: "data-layout-fragment-id",
	LAYOUT_STORY: "data-layout-story",
	LAYOUT_BLOCK_REF: "data-layout-block-ref"
};
const DATASET_KEYS = {
	PM_START: "pmStart",
	PM_END: "pmEnd",
	LAYOUT_EPOCH: "layoutEpoch",
	TABLE_BOUNDARIES: "tableBoundaries",
	SDT_ID: "sdtId",
	SDT_TYPE: "sdtType",
	FIELD_ID: "fieldId",
	FIELD_TYPE: "fieldType",
	DRAGGABLE: "draggable",
	DISPLAY_LABEL: "displayLabel",
	VARIANT: "variant",
	TYPE: "type",
	LAYOUT_BOUNDARY_SCHEMA: "layoutBoundarySchema",
	LAYOUT_FRAGMENT_ID: "layoutFragmentId",
	LAYOUT_STORY: "layoutStory",
	LAYOUT_BLOCK_REF: "layoutBlockRef"
};
const encodeLayoutStoryDataset = (story) => story.kind === "body" ? "body" : story.id ? `${story.kind}:${story.id}` : story.kind;
const decodeLayoutStoryDataset = (raw) => {
	if (!raw) return { kind: "unknown" };
	if (raw === "body") return { kind: "body" };
	const idx = raw.indexOf(":");
	const kind = idx === -1 ? raw : raw.slice(0, idx);
	const id = idx === -1 ? void 0 : raw.slice(idx + 1);
	switch (kind) {
		case "body":
		case "header":
		case "footer":
		case "footnote":
		case "endnote": return id ? {
			kind,
			id
		} : { kind };
		default: return { kind: "unknown" };
	}
};
`${DOM_CLASS_NAMES.BLOCK_SDT}${DATA_ATTRS.SDT_ID}`;
const DRAGGABLE_SELECTOR = `[${DATA_ATTRS.DRAGGABLE}="true"]`;
function buildImagePmSelector(pmStart) {
	const v = String(pmStart);
	const attr = DATA_ATTRS.PM_START;
	return [
		`.${DOM_CLASS_NAMES.IMAGE_FRAGMENT}[${attr}="${v}"]`,
		`.${DOM_CLASS_NAMES.INLINE_IMAGE_CLIP_WRAPPER}[${attr}="${v}"]`,
		`.${DOM_CLASS_NAMES.INLINE_IMAGE}[${attr}="${v}"]`
	].join(", ");
}
function buildInlineImagePmSelector(pmStart) {
	const v = String(pmStart);
	const attr = DATA_ATTRS.PM_START;
	return [`.${DOM_CLASS_NAMES.INLINE_IMAGE_CLIP_WRAPPER}[${attr}="${v}"]`, `.${DOM_CLASS_NAMES.INLINE_IMAGE}[${attr}="${v}"]`].join(", ");
}
function buildAnnotationSelector() {
	return `.${DOM_CLASS_NAMES.ANNOTATION}[${DATA_ATTRS.PM_START}]`;
}
const VerticalNavigationPluginKey = new PluginKey("verticalNavigation");
var createDefaultState = () => ({ goalX: null });
const VerticalNavigation = Extension.create({
	name: "verticalNavigation",
	addPmPlugins() {
		if (this.editor.options?.isHeaderOrFooter) return [];
		if (this.editor.options?.isHeadless) return [];
		const editor = this.editor;
		return [new Plugin({
			key: VerticalNavigationPluginKey,
			state: {
				init: () => createDefaultState(),
				apply(tr, value) {
					const meta = tr.getMeta(VerticalNavigationPluginKey);
					if (meta?.type === "vertical-move") return { goalX: meta.goalX ?? value.goalX ?? null };
					if (meta?.type === "set-goal-x") return {
						...value,
						goalX: meta.goalX ?? null
					};
					if (meta?.type === "reset-goal-x") return {
						...value,
						goalX: null
					};
					if (tr.selectionSet) return {
						...value,
						goalX: null
					};
					return value;
				}
			},
			props: {
				handleKeyDown(view, event) {
					if (view.composing || !editor.isEditable) return false;
					if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
						view.dispatch(view.state.tr.setMeta(VerticalNavigationPluginKey, { type: "reset-goal-x" }));
						return false;
					}
					if (event.key === "Home" || event.key === "End") {
						view.dispatch(view.state.tr.setMeta(VerticalNavigationPluginKey, { type: "reset-goal-x" }));
						if (!isPresenting(editor)) return false;
						if (event.ctrlKey || event.metaKey || event.altKey) return false;
						const targetPos = resolveLineBoundaryPosition(editor, view.state.selection, event.key);
						if (!Number.isFinite(targetPos)) return false;
						const selection$1 = buildSelection(view.state, targetPos, event.shiftKey);
						if (!selection$1) return false;
						view.dispatch(view.state.tr.setSelection(selection$1));
						return true;
					}
					if (event.key === "PageUp" || event.key === "PageDown") {
						view.dispatch(view.state.tr.setMeta(VerticalNavigationPluginKey, { type: "reset-goal-x" }));
						return false;
					}
					if (event.key !== "ArrowUp" && event.key !== "ArrowDown") return false;
					if (!isPresenting(editor)) return false;
					let goalX = VerticalNavigationPluginKey.getState(view.state)?.goalX;
					const coords = getCurrentCoords(editor, view.state.selection);
					if (!coords) return false;
					if (goalX == null) {
						goalX = coords?.x;
						if (!Number.isFinite(goalX)) return false;
						view.dispatch(view.state.tr.setMeta(VerticalNavigationPluginKey, {
							type: "set-goal-x",
							goalX
						}));
					}
					const adjacent = getAdjacentLineClientTarget(editor, coords, event.key === "ArrowUp" ? -1 : 1);
					if (!adjacent) return false;
					let hit = getHitFromLayoutCoords(editor, goalX, adjacent.clientY, coords, adjacent.pageIndex);
					if (adjacent.pmStart != null && adjacent.pmEnd != null) {
						const TOLERANCE = 5;
						const hitPos = hit?.pos;
						if (!hit || !Number.isFinite(hitPos) || hitPos < adjacent.pmStart - TOLERANCE || hitPos > adjacent.pmEnd + TOLERANCE) hit = resolvePositionAtGoalX(editor, adjacent.pmStart, adjacent.pmEnd, goalX, adjacent.isRtl);
					}
					if (!hit || !Number.isFinite(hit.pos)) return false;
					const selection = buildSelection(view.state, hit.pos, event.shiftKey);
					if (!selection) return false;
					view.dispatch(view.state.tr.setMeta(VerticalNavigationPluginKey, {
						type: "vertical-move",
						goalX
					}).setSelection(selection));
					return true;
				},
				handleDOMEvents: {
					mousedown: (view) => {
						view.dispatch(view.state.tr.setMeta(VerticalNavigationPluginKey, { type: "reset-goal-x" }));
						return false;
					},
					touchstart: (view) => {
						view.dispatch(view.state.tr.setMeta(VerticalNavigationPluginKey, { type: "reset-goal-x" }));
						return false;
					},
					compositionstart: (view) => {
						view.dispatch(view.state.tr.setMeta(VerticalNavigationPluginKey, { type: "reset-goal-x" }));
						return false;
					}
				}
			}
		})];
	}
});
function isPresenting(editor) {
	const presentationCtx = editor?.presentationEditor;
	if (!presentationCtx) return false;
	return presentationCtx.getActiveEditor?.() === editor;
}
function getCurrentCoords(editor, selection) {
	const presentationEditor = editor.presentationEditor;
	const layoutSpaceCoords = presentationEditor.computeCaretLayoutRect(selection.head);
	if (!layoutSpaceCoords) return null;
	const clientCoords = presentationEditor.denormalizeClientPoint(layoutSpaceCoords.x, layoutSpaceCoords.y, layoutSpaceCoords.pageIndex, layoutSpaceCoords.height);
	return {
		clientX: clientCoords.x,
		clientY: clientCoords.y,
		height: clientCoords.height,
		x: layoutSpaceCoords.x,
		y: layoutSpaceCoords.y
	};
}
function resolveLineBoundaryPosition(editor, selection, key) {
	const coords = getCurrentCoords(editor, selection);
	if (!coords) return null;
	const doc$1 = editor.presentationEditor?.visibleHost?.ownerDocument ?? document;
	const caretX = coords.clientX;
	const lineEl = findLineElementAtPoint(doc$1, caretX, coords.clientY + coords.height / 2);
	if (!lineEl) return null;
	const pmStart = Number(lineEl.dataset?.pmStart);
	const pmEnd = Number(lineEl.dataset?.pmEnd);
	if (!Number.isFinite(pmStart) || !Number.isFinite(pmEnd)) return null;
	return key === "Home" ? pmStart : pmEnd;
}
function getAdjacentLineClientTarget(editor, coords, direction) {
	const doc$1 = editor.presentationEditor.visibleHost?.ownerDocument ?? document;
	const caretX = coords.clientX;
	const currentLine = findLineElementAtPoint(doc$1, caretX, coords.clientY + coords.height / 2);
	if (!currentLine) return null;
	const adjacentLine = findAdjacentLineElement(currentLine, direction, caretX);
	if (!adjacentLine) return null;
	const pageEl = adjacentLine.closest?.(`.${DOM_CLASS_NAMES.PAGE}`);
	const pageIndex = pageEl ? Number(pageEl.dataset.pageIndex ?? "NaN") : null;
	const rect = adjacentLine.getBoundingClientRect();
	const clientY = rect.top + rect.height / 2;
	if (!Number.isFinite(clientY)) return null;
	const pmStart = Number(adjacentLine.dataset?.pmStart);
	const pmEnd = Number(adjacentLine.dataset?.pmEnd);
	const isRtl = adjacentLine.closest?.("[dir=\"rtl\"]") != null;
	return {
		clientY,
		pageIndex: Number.isFinite(pageIndex) ? pageIndex : void 0,
		pmStart: Number.isFinite(pmStart) ? pmStart : void 0,
		pmEnd: Number.isFinite(pmEnd) ? pmEnd : void 0,
		isRtl
	};
}
function getHitFromLayoutCoords(editor, goalX, clientY, coords, pageIndex) {
	const presentationEditor = editor.presentationEditor;
	const clientX = presentationEditor.denormalizeClientPoint(goalX, coords.y, pageIndex)?.x;
	if (!Number.isFinite(clientX)) return null;
	return presentationEditor.hitTest(clientX, clientY);
}
function buildSelection(state, pos, extend) {
	const { doc: doc$1, selection } = state;
	if (selection instanceof NodeSelection || selection instanceof CellSelection) return null;
	const clamped = Math.max(0, Math.min(pos, doc$1.content.size));
	if (extend) {
		const anchor = selection.anchor ?? selection.from;
		return TextSelection.create(doc$1, anchor, clamped);
	}
	return TextSelection.create(doc$1, clamped);
}
function findLineElementAtPoint(doc$1, x, y$1) {
	if (typeof doc$1?.elementsFromPoint !== "function") return null;
	const chain = doc$1.elementsFromPoint(x, y$1) ?? [];
	for (const el of chain) if (el?.classList?.contains?.(DOM_CLASS_NAMES.LINE)) return el;
	return null;
}
function findAdjacentLineElement(currentLine, direction, caretX) {
	const pageClass = DOM_CLASS_NAMES.PAGE;
	const page = currentLine.closest?.(`.${pageClass}`);
	if (!page) return null;
	const currentLineMetrics = getLineMetrics(currentLine);
	if (!currentLineMetrics) return null;
	const adjacentOnCurrentPage = findClosestLineInDirection(getPageLineElements(page), currentLine, currentLineMetrics, direction, caretX);
	if (adjacentOnCurrentPage) return adjacentOnCurrentPage;
	const pages = Array.from(page.parentElement?.querySelectorAll?.(`.${pageClass}`) ?? []);
	const pageIndex = pages.indexOf(page);
	if (pageIndex === -1) return null;
	const nextPage = pages[pageIndex + direction];
	if (!nextPage) return null;
	return findEdgeLineForPage(getPageLineElements(nextPage), direction, caretX);
}
function resolvePositionAtGoalX(editor, pmStart, pmEnd, goalX, isRtl = false) {
	const presentationEditor = editor.presentationEditor;
	let bestPos = pmStart;
	let bestDist = Infinity;
	let lo = pmStart;
	let hi = pmEnd;
	while (lo <= hi) {
		const mid = Math.floor((lo + hi) / 2);
		const rect = presentationEditor.computeCaretLayoutRect(mid);
		if (!rect || !Number.isFinite(rect.x)) {
			lo = mid + 1;
			continue;
		}
		const dist = Math.abs(rect.x - goalX);
		if (dist < bestDist) {
			bestDist = dist;
			bestPos = mid;
		}
		if (rect.x < goalX) if (isRtl) hi = mid - 1;
		else lo = mid + 1;
		else if (rect.x > goalX) if (isRtl) lo = mid + 1;
		else hi = mid - 1;
		else break;
	}
	return { pos: bestPos };
}
function getPageLineElements(page) {
	const fragmentClass = DOM_CLASS_NAMES.FRAGMENT;
	const lineClass = DOM_CLASS_NAMES.LINE;
	const headerClass = "superdoc-page-header";
	const footerClass = "superdoc-page-footer";
	return Array.from(page.querySelectorAll(`.${fragmentClass}`)).filter((fragment) => !fragment.closest?.(`.${headerClass}, .${footerClass}`)).flatMap((fragment) => Array.from(fragment.querySelectorAll(`.${lineClass}`)));
}
function findClosestLineInDirection(lineEls, currentLine, currentMetrics, direction, caretX) {
	const directionalCandidates = lineEls.filter((line) => line !== currentLine).map((line) => ({
		line,
		metrics: getLineMetrics(line)
	})).filter(({ metrics }) => metrics && isLineInDirection(metrics.centerY, currentMetrics.centerY, direction));
	if (directionalCandidates.length === 0) return null;
	const nearestVerticalDistance = directionalCandidates.reduce((minDistance, { metrics }) => {
		const distance = Math.abs(metrics.centerY - currentMetrics.centerY);
		return Math.min(minDistance, distance);
	}, Infinity);
	const targetRowCenterY = directionalCandidates.filter(({ metrics }) => isWithinTolerance(Math.abs(metrics.centerY - currentMetrics.centerY), nearestVerticalDistance, 1)).reduce((bestCenterY, { metrics }) => {
		if (bestCenterY == null) return metrics.centerY;
		return direction > 0 ? Math.min(bestCenterY, metrics.centerY) : Math.max(bestCenterY, metrics.centerY);
	}, null);
	if (!Number.isFinite(targetRowCenterY)) return null;
	return chooseLineClosestToX(directionalCandidates.filter(({ metrics }) => isWithinTolerance(metrics.centerY, targetRowCenterY, getRowTolerance(currentMetrics, metrics))), caretX);
}
function findEdgeLineForPage(lineEls, direction, caretX) {
	const candidates = lineEls.map((line) => ({
		line,
		metrics: getLineMetrics(line)
	})).filter(({ metrics }) => metrics);
	if (candidates.length === 0) return null;
	const targetRowCenterY = candidates.reduce((edgeCenterY, { metrics }) => {
		if (edgeCenterY == null) return metrics.centerY;
		return direction > 0 ? Math.min(edgeCenterY, metrics.centerY) : Math.max(edgeCenterY, metrics.centerY);
	}, null);
	if (!Number.isFinite(targetRowCenterY)) return null;
	return chooseLineClosestToX(candidates.filter(({ metrics }) => isWithinTolerance(metrics.centerY, targetRowCenterY, Math.max(metrics.height / 2, 1))), caretX);
}
function chooseLineClosestToX(candidates, caretX) {
	if (candidates.length === 0) return null;
	let best = null;
	for (const candidate of candidates) {
		const horizontalDistance = getHorizontalDistanceToLine(candidate.metrics, caretX);
		const centerDistance = Math.abs(candidate.metrics.centerX - caretX);
		if (!best || horizontalDistance < best.horizontalDistance || horizontalDistance === best.horizontalDistance && centerDistance < best.centerDistance) best = {
			line: candidate.line,
			horizontalDistance,
			centerDistance
		};
	}
	return best?.line ?? null;
}
function getLineMetrics(line) {
	const rect = line?.getBoundingClientRect?.();
	if (!rect) return null;
	const { top: top$1, bottom: bottom$1, left: left$1, right: right$1, height, width } = rect;
	if (![
		top$1,
		bottom$1,
		left$1,
		right$1,
		height,
		width
	].every(Number.isFinite)) return null;
	return {
		top: top$1,
		bottom: bottom$1,
		left: left$1,
		right: right$1,
		height,
		centerX: left$1 + width / 2,
		centerY: top$1 + height / 2
	};
}
function isLineInDirection(lineCenterY, currentCenterY, direction) {
	const epsilon = 1;
	return direction > 0 ? lineCenterY > currentCenterY + epsilon : lineCenterY < currentCenterY - epsilon;
}
function isWithinTolerance(value, expected, tolerance) {
	return Math.abs(value - expected) <= tolerance;
}
function getRowTolerance(currentMetrics, candidateMetrics) {
	return Math.max(Math.min(currentMetrics.height, candidateMetrics.height) / 2, 1);
}
function getHorizontalDistanceToLine(metrics, caretX) {
	if (caretX < metrics.left) return metrics.left - caretX;
	if (caretX > metrics.right) return caretX - metrics.right;
	return 0;
}
var STRONG_RTL_CHAR_RE$1 = /[\u0590-\u08FF\p{Script=Hebrew}\p{Script=Arabic}]/u;
var STRONG_LTR_CHAR_RE = /[A-Za-z\u00C0-\u024F]/;
var isStrongRtl = (char) => STRONG_RTL_CHAR_RE$1.test(char);
var isStrongLtr = (char) => STRONG_LTR_CHAR_RE.test(char);
var hasMixedDirectionBoundary = (leftChar, rightChar) => isStrongRtl(leftChar) && isStrongLtr(rightChar) || isStrongLtr(leftChar) && isStrongRtl(rightChar);
var resolveCaretPoint = (doc$1, range) => {
	const rect = range.getBoundingClientRect();
	if (rect && Number.isFinite(rect.left) && Number.isFinite(rect.top)) {
		if (rect.width === 0 && rect.height === 0) return null;
		const midY = rect.height > 0 ? rect.top + rect.height / 2 : rect.top;
		return {
			x: rect.left,
			y: midY
		};
	}
	const node = range.startContainer?.nodeType === Node.TEXT_NODE ? range.startContainer.parentElement : range.startContainer;
	if (!node || !(node instanceof HTMLElement)) return null;
	const fallbackRect = node.getBoundingClientRect();
	if (!fallbackRect) return null;
	return {
		x: fallbackRect.left,
		y: fallbackRect.top + fallbackRect.height / 2
	};
};
var resolveLineElement = (doc$1, point) => {
	return doc$1.elementsFromPoint(point.x, point.y).find((el) => el instanceof HTMLElement ? el.classList.contains("superdoc-line") : false);
};
var collectVisualChars = (lineEl, view, targetX = null) => {
	const doc$1 = lineEl.ownerDocument;
	const nodeFilter = doc$1.defaultView?.NodeFilter;
	if (!nodeFilter) return [];
	const chars = [];
	const walker = doc$1.createTreeWalker(lineEl, nodeFilter.SHOW_TEXT);
	const RANGE_WINDOW_PX = 96;
	const hasTargetX = Number.isFinite(targetX);
	let node = walker.nextNode();
	while (node) {
		const textNode = node;
		const text = textNode.textContent ?? "";
		for (let i = 0; i < text.length; i += 1) {
			const char = text[i];
			if (!char || /\s/.test(char)) continue;
			let pmStart;
			let pmEnd;
			try {
				pmStart = view.posAtDOM(textNode, i);
				pmEnd = view.posAtDOM(textNode, i + 1);
			} catch {
				continue;
			}
			if (!Number.isFinite(pmStart) || !Number.isFinite(pmEnd) || pmEnd <= pmStart) continue;
			const range = doc$1.createRange();
			range.setStart(textNode, i);
			range.setEnd(textNode, i + 1);
			const rect = range.getBoundingClientRect();
			if (rect.width <= 0 || rect.height <= 0) continue;
			if (hasTargetX && rect.right < targetX - RANGE_WINDOW_PX) continue;
			if (hasTargetX && rect.left > targetX + RANGE_WINDOW_PX) continue;
			chars.push({
				char,
				pmStart,
				pmEnd,
				centerX: rect.left + rect.width / 2,
				centerY: rect.top + rect.height / 2
			});
		}
		node = walker.nextNode();
	}
	return chars;
};
var resolveBoundaryChars = (chars, caretPoint) => {
	if (chars.length === 0) return null;
	const sameBand = chars.filter((c) => Math.abs(c.centerY - caretPoint.y) <= 8);
	const band = sameBand.length > 0 ? sameBand : chars;
	band.sort((a, b$1) => a.centerX - b$1.centerX);
	let left$1 = null;
	let right$1 = null;
	for (const c of band) {
		if (c.centerX < caretPoint.x) {
			left$1 = c;
			continue;
		}
		right$1 = c;
		break;
	}
	if (!left$1 || !right$1) return null;
	return {
		left: left$1,
		right: right$1
	};
};
var resolveMixedBidiBackspaceRange = ({ state, view }) => {
	const { selection } = state;
	if (!selection?.empty) return null;
	const doc$1 = view?.dom?.ownerDocument;
	const nativeSelection = doc$1?.getSelection?.();
	if (!nativeSelection || nativeSelection.rangeCount === 0) return null;
	const range = nativeSelection.getRangeAt(0);
	if (!range.collapsed) return null;
	const caretPoint = resolveCaretPoint(doc$1, range);
	if (!caretPoint) return null;
	const lineEl = resolveLineElement(doc$1, caretPoint);
	if (!lineEl) return null;
	const lineText = lineEl.textContent ?? "";
	const hasRtl = STRONG_RTL_CHAR_RE$1.test(lineText);
	const hasLtr = STRONG_LTR_CHAR_RE.test(lineText);
	if (!hasRtl || !hasLtr) return null;
	let chars = collectVisualChars(lineEl, view, caretPoint.x);
	if (chars.length < 2) chars = collectVisualChars(lineEl, view, null);
	const boundary = resolveBoundaryChars(chars, caretPoint);
	if (!boundary) return null;
	if (!hasMixedDirectionBoundary(boundary.left.char, boundary.right.char)) return null;
	if (selection.from !== boundary.right.pmStart && selection.from !== boundary.left.pmEnd) return null;
	return {
		from: boundary.left.pmStart,
		to: boundary.left.pmEnd
	};
};
const mixedBidiBackspace = () => ({ state, view, tr, dispatch }) => {
	const range = resolveMixedBidiBackspaceRange({
		state,
		view
	});
	if (!range) return false;
	if (dispatch) {
		tr.delete(range.from, range.to);
		tr.scrollIntoView();
	}
	return true;
};
const MixedBidiBackspace = Extension.create({
	name: "mixedBidiBackspace",
	addCommands() {
		return { mixedBidiBackspace };
	}
});
const createPermissionBlockMarkerNode = ({ name, attributes }) => Node$1.create({
	name,
	group: "block",
	inline: false,
	atom: true,
	draggable: false,
	selectable: false,
	defining: true,
	renderDOM() {
		return ["div", { style: "display: none;" }];
	},
	addAttributes() {
		return attributes();
	}
});
var sharedAttributes$1 = () => ({
	id: { default: null },
	edGrp: { default: null },
	ed: { default: null },
	colFirst: { default: null },
	colLast: { default: null }
});
const PermStart = Node$1.create({
	name: "permStart",
	group: "inline",
	inline: true,
	atom: true,
	renderDOM() {
		return ["span", { style: "display: none;" }];
	},
	addAttributes() {
		return sharedAttributes$1();
	}
});
const PermStartBlock = createPermissionBlockMarkerNode({
	name: "permStartBlock",
	attributes: sharedAttributes$1
});
var sharedAttributes = () => ({
	id: { default: null },
	edGrp: { default: null },
	displacedByCustomXml: { default: null }
});
const PermEnd = Node$1.create({
	name: "permEnd",
	group: "inline",
	inline: true,
	atom: true,
	renderDOM() {
		return ["span", { style: "display: none;" }];
	},
	addAttributes() {
		return sharedAttributes();
	}
});
const PermEndBlock = createPermissionBlockMarkerNode({
	name: "permEndBlock",
	attributes: sharedAttributes
});
var IGNORED_ATTRIBUTE_KEYS = new Set(["sdBlockId"]);
var TRACK_CHANGE_MARK_NAMES$1 = new Set([
	"trackInsert",
	"trackDelete",
	"trackFormat"
]);
var TRACK_CHANGE_IGNORED_ATTRIBUTE_KEYS = new Set(["id", "sourceId"]);
function getAttributesDiff(objectA = {}, objectB = {}, ignoreKeys = []) {
	const diff = {
		added: {},
		deleted: {},
		modified: {}
	};
	const ignored = new Set([...IGNORED_ATTRIBUTE_KEYS, ...ignoreKeys]);
	diffObjects(objectA ?? {}, objectB ?? {}, "", diff, ignored);
	return Object.keys(diff.added).length > 0 || Object.keys(diff.deleted).length > 0 || Object.keys(diff.modified).length > 0 ? diff : null;
}
function getMarksDiff(marksA = [], marksB = []) {
	marksA = marksA || [];
	marksB = marksB || [];
	const normalizeMarkAttrs = (markName, attrs) => {
		if (!attrs) return {};
		const ignoredMarkKeys = /* @__PURE__ */ new Set();
		if (TRACK_CHANGE_MARK_NAMES$1.has(markName)) for (const key of TRACK_CHANGE_IGNORED_ATTRIBUTE_KEYS) ignoredMarkKeys.add(key);
		const normalized = {};
		for (const [key, value] of Object.entries(attrs)) {
			if (IGNORED_ATTRIBUTE_KEYS.has(key) || ignoredMarkKeys.has(key)) continue;
			normalized[key] = value;
		}
		return normalized;
	};
	const marksDiff = {
		added: [],
		deleted: [],
		modified: []
	};
	const entriesA = marksA.map((mark) => ({
		name: mark.type,
		raw: mark.attrs || {},
		normalized: normalizeMarkAttrs(mark.type, mark.attrs)
	}));
	const entriesB = marksB.map((mark) => ({
		name: mark.type,
		raw: mark.attrs || {},
		normalized: normalizeMarkAttrs(mark.type, mark.attrs)
	}));
	const matchedBIndices = /* @__PURE__ */ new Set();
	const exactMatchedA = /* @__PURE__ */ new Set();
	entriesA.forEach((entryA, indexA) => {
		const indexB = entriesB.findIndex((entryB, candidateIndexB) => !matchedBIndices.has(candidateIndexB) && entryA.name === entryB.name && deepEquals(entryA.normalized, entryB.normalized));
		if (indexB >= 0) {
			exactMatchedA.add(indexA);
			matchedBIndices.add(indexB);
		}
	});
	entriesA.forEach((entryA, indexA) => {
		if (exactMatchedA.has(indexA)) return;
		const indexB = entriesB.findIndex((entryB, candidateIndexB) => !matchedBIndices.has(candidateIndexB) && entryA.name === entryB.name);
		if (indexB >= 0) {
			matchedBIndices.add(indexB);
			const entryB = entriesB[indexB];
			if (!deepEquals(entryA.normalized, entryB.normalized)) marksDiff.modified.push({
				name: entryA.name,
				oldAttrs: entryA.raw,
				newAttrs: entryB.raw
			});
			return;
		}
		marksDiff.deleted.push({
			name: entryA.name,
			attrs: entryA.raw
		});
	});
	entriesB.forEach((entryB, indexB) => {
		if (!matchedBIndices.has(indexB)) marksDiff.added.push({
			name: entryB.name,
			attrs: entryB.raw
		});
	});
	return marksDiff.added.length > 0 || marksDiff.deleted.length > 0 || marksDiff.modified.length > 0 ? marksDiff : null;
}
function diffObjects(objectA, objectB, basePath, diff, ignoreKeys) {
	const keys$1 = new Set([...Object.keys(objectA || {}), ...Object.keys(objectB || {})]);
	for (const key of keys$1) {
		if (ignoreKeys.has(key)) continue;
		const path = joinPath(basePath, key);
		const hasA = Object.prototype.hasOwnProperty.call(objectA, key);
		const hasB = Object.prototype.hasOwnProperty.call(objectB, key);
		if (hasA && !hasB) {
			recordDeletedValue(objectA[key], path, diff, ignoreKeys);
			continue;
		}
		if (!hasA && hasB) {
			recordAddedValue(objectB[key], path, diff, ignoreKeys);
			continue;
		}
		const valueA = objectA[key];
		const valueB = objectB[key];
		if (isPlainObject$1(valueA) && isPlainObject$1(valueB)) {
			diffObjects(valueA, valueB, path, diff, ignoreKeys);
			continue;
		}
		if (Array.isArray(valueA) && Array.isArray(valueB)) {
			if (valueA.length === valueB.length && valueA.every((item, index) => deepEquals(item, valueB[index]))) continue;
		}
		if (!deepEquals(valueA, valueB)) diff.modified[path] = {
			from: valueA,
			to: valueB
		};
	}
}
function recordAddedValue(value, path, diff, ignoreKeys) {
	if (isPlainObject$1(value)) {
		for (const [childKey, childValue] of Object.entries(value)) {
			if (ignoreKeys.has(childKey)) continue;
			recordAddedValue(childValue, joinPath(path, childKey), diff, ignoreKeys);
		}
		return;
	}
	diff.added[path] = value;
}
function recordDeletedValue(value, path, diff, ignoreKeys) {
	if (isPlainObject$1(value)) {
		for (const [childKey, childValue] of Object.entries(value)) {
			if (ignoreKeys.has(childKey)) continue;
			recordDeletedValue(childValue, joinPath(path, childKey), diff, ignoreKeys);
		}
		return;
	}
	diff.deleted[path] = value;
}
function joinPath(base, key) {
	return base ? `${base}.${key}` : key;
}
function applyAttrsDiff(baseAttrs, attrsDiff) {
	const result = cloneAttrs(baseAttrs ?? {});
	if (!attrsDiff) return result;
	for (const [path, value] of Object.entries(attrsDiff.added ?? {})) setAtPath(result, path, value);
	for (const [path, change] of Object.entries(attrsDiff.modified ?? {})) setAtPath(result, path, change.to);
	for (const path of Object.keys(attrsDiff.deleted ?? {})) deleteAtPath(result, path);
	return result;
}
function cloneAttrs(value) {
	if (!isPlainObject$1(value)) return {};
	const clone$1 = {};
	for (const [key, child] of Object.entries(value)) clone$1[key] = cloneDeep(child);
	return clone$1;
}
function cloneDeep(value) {
	if (Array.isArray(value)) return value.map(cloneDeep);
	if (isPlainObject$1(value)) {
		const clone$1 = {};
		for (const [key, child] of Object.entries(value)) clone$1[key] = cloneDeep(child);
		return clone$1;
	}
	return value;
}
function splitPath(path) {
	return path.split(".");
}
function setAtPath(target, path, value) {
	const segments = splitPath(path);
	let cursor = target;
	for (let i = 0; i < segments.length - 1; i++) {
		const key = segments[i];
		const next = cursor[key];
		if (!isPlainObject$1(next)) cursor[key] = {};
		cursor = cursor[key];
	}
	cursor[segments[segments.length - 1]] = cloneDeep(value);
}
function deleteAtPath(target, path) {
	const segments = splitPath(path);
	let cursor = target;
	for (let i = 0; i < segments.length - 1; i++) {
		const key = segments[i];
		const next = cursor[key];
		if (!isPlainObject$1(next)) return;
		cursor = next;
	}
	delete cursor[segments[segments.length - 1]];
}
function isPlainObject$1(value) {
	return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}
function deepEquals(a, b$1) {
	if (a === b$1) return true;
	if (Array.isArray(a) && Array.isArray(b$1)) {
		if (a.length !== b$1.length) return false;
		for (let i = 0; i < a.length; i++) if (!deepEquals(a[i], b$1[i])) return false;
		return true;
	}
	if (isPlainObject$1(a) && isPlainObject$1(b$1)) {
		const keysA = Object.keys(a);
		const keysB = Object.keys(b$1);
		if (keysA.length !== keysB.length) return false;
		for (const key of keysA) if (!deepEquals(a[key], b$1[key])) return false;
		return true;
	}
	return false;
}
const NON_SEMANTIC_BLOCK_ATTRS = new Set([
	"sdBlockId",
	"sdBlockRev",
	"paraId",
	"textId",
	"rsidR",
	"rsidRDefault",
	"rsidP",
	"rsidRPr",
	"rsidDel"
]);
var VOLATILE_IMAGE_ORIGINAL_ATTR_KEYS = new Set(["wp14:anchorId", "wp14:editId"]);
function omitKeys(attrs, keysToOmit) {
	const result = {};
	for (const [key, value] of Object.entries(attrs)) if (!keysToOmit.has(key)) result[key] = value;
	return result;
}
function normalizeParagraphAttrs(attrs) {
	return omitKeys(attrs, NON_SEMANTIC_BLOCK_ATTRS);
}
function normalizeBlockAttrs(attrs) {
	return omitKeys(attrs, NON_SEMANTIC_BLOCK_ATTRS);
}
function normalizeImageNodeJSON(nodeJSON) {
	const attrs = nodeJSON.attrs;
	if (!attrs?.originalAttributes) return nodeJSON;
	const originalAttributes = attrs.originalAttributes;
	const cleanedOriginalAttributes = omitKeys(originalAttributes, VOLATILE_IMAGE_ORIGINAL_ATTR_KEYS);
	return {
		...nodeJSON,
		attrs: {
			...attrs,
			originalAttributes: cleanedOriginalAttributes
		}
	};
}
function normalizeInlineNodeJSON(nodeJSON) {
	if (nodeJSON.type === "image") return normalizeImageNodeJSON(nodeJSON);
	return nodeJSON;
}
function normalizeInlineNodeAttrs(typeName, attrs) {
	if (typeName !== "image") return attrs;
	const originalAttributes = attrs.originalAttributes;
	if (!originalAttributes) return attrs;
	return {
		...attrs,
		originalAttributes: omitKeys(originalAttributes, VOLATILE_IMAGE_ORIGINAL_ATTR_KEYS)
	};
}
function semanticInlineNodeKey(node) {
	return JSON.stringify(normalizeInlineNodeJSON(node.toJSON()));
}
function normalizeParagraphNodeJSON(nodeJSON) {
	const attrs = nodeJSON.attrs ?? {};
	const content = nodeJSON.content;
	return {
		...nodeJSON,
		attrs: normalizeParagraphAttrs(attrs),
		...content ? { content: content.map(normalizeContentNodeJSON) } : {}
	};
}
function normalizeContentNodeJSON(nodeJSON) {
	const content = nodeJSON.content;
	if (!content) return normalizeInlineNodeJSON(nodeJSON);
	return {
		...nodeJSON,
		content: content.map(normalizeContentNodeJSON)
	};
}
function normalizeDocJSON(docJSON) {
	const content = docJSON.content;
	if (!content) return docJSON;
	return {
		...docJSON,
		content: content.map(normalizeDocNodeJSON)
	};
}
function normalizeDocNodeJSON(nodeJSON) {
	if (nodeJSON.type === "paragraph") return normalizeParagraphNodeJSON(nodeJSON);
	const attrs = nodeJSON.attrs;
	const content = nodeJSON.content;
	const normalizedAttrs = attrs ? normalizeBlockAttrs(attrs) : void 0;
	if (content) return {
		...nodeJSON,
		...normalizedAttrs ? { attrs: normalizedAttrs } : {},
		content: content.map(normalizeDocNodeJSON)
	};
	if (normalizedAttrs) return {
		...nodeJSON,
		attrs: normalizedAttrs
	};
	return nodeJSON;
}
var LEGACY_VOLATILE_PARAGRAPH_ATTRS = new Set([
	"paraId",
	"textId",
	"rsidR",
	"rsidRDefault",
	"rsidP",
	"rsidRPr",
	"rsidDel"
]);
function normalizeParagraphAttrsLegacy(attrs) {
	return omitKeys(attrs, LEGACY_VOLATILE_PARAGRAPH_ATTRS);
}
function normalizeParagraphNodeJSONLegacy(nodeJSON) {
	const attrs = nodeJSON.attrs ?? {};
	const content = nodeJSON.content;
	return {
		...nodeJSON,
		attrs: normalizeParagraphAttrsLegacy(attrs),
		...content ? { content: content.map(normalizeContentNodeJSON) } : {}
	};
}
function normalizeDocNodeJSONLegacy(nodeJSON) {
	if (nodeJSON.type === "paragraph") return normalizeParagraphNodeJSONLegacy(nodeJSON);
	const content = nodeJSON.content;
	if (content) return {
		...nodeJSON,
		content: content.map(normalizeDocNodeJSONLegacy)
	};
	return nodeJSON;
}
function normalizeDocJSONLegacy(docJSON) {
	const content = docJSON.content;
	if (!content) return docJSON;
	return {
		...docJSON,
		content: content.map(normalizeDocNodeJSONLegacy)
	};
}
function diffSequences(oldSeq, newSeq, options) {
	if (!options) throw new Error("diffSequences requires an options object.");
	const comparator = options.comparator ?? ((a, b$1) => a === b$1);
	const reorder = options.reorderOperations ?? ((ops) => ops);
	const canTreatAsModification$2 = options.canTreatAsModification;
	const shouldProcessEqualAsModification$4 = options.shouldProcessEqualAsModification;
	if (typeof options.buildAdded !== "function") throw new Error("diffSequences requires a buildAdded option.");
	if (typeof options.buildDeleted !== "function") throw new Error("diffSequences requires a buildDeleted option.");
	if (typeof options.buildModified !== "function") throw new Error("diffSequences requires a buildModified option.");
	const steps = buildOperationSteps(reorder(myersDiff(oldSeq, newSeq, comparator)));
	const diffs = [];
	for (let i = 0; i < steps.length; i += 1) {
		const step = steps[i];
		if (step.type === "equal") {
			if (!shouldProcessEqualAsModification$4) continue;
			const oldItem = oldSeq[step.oldIdx];
			const newItem = newSeq[step.newIdx];
			if (!shouldProcessEqualAsModification$4(oldItem, newItem, step.oldIdx, step.newIdx)) continue;
			const diff = options.buildModified(oldItem, newItem, step.oldIdx, step.newIdx);
			if (diff != null) diffs.push(diff);
			continue;
		}
		if (step.type === "delete") {
			const nextStep = steps[i + 1];
			if (nextStep?.type === "insert" && typeof canTreatAsModification$2 === "function" && canTreatAsModification$2(oldSeq[step.oldIdx], newSeq[nextStep.newIdx], step.oldIdx, nextStep.newIdx)) {
				const diff = options.buildModified(oldSeq[step.oldIdx], newSeq[nextStep.newIdx], step.oldIdx, nextStep.newIdx);
				if (diff != null) diffs.push(diff);
				i += 1;
			} else {
				const diff = options.buildDeleted(oldSeq[step.oldIdx], step.oldIdx, step.newIdx);
				if (diff != null) diffs.push(diff);
			}
			continue;
		}
		if (step.type === "insert") {
			const diff = options.buildAdded(newSeq[step.newIdx], step.oldIdx, oldSeq[step.oldIdx - 1], step.newIdx);
			if (diff != null) diffs.push(diff);
		}
	}
	return diffs;
}
function buildOperationSteps(operations) {
	let oldIdx = 0;
	let newIdx = 0;
	const steps = [];
	for (const op of operations) if (op === "equal") {
		steps.push({
			type: "equal",
			oldIdx,
			newIdx
		});
		oldIdx += 1;
		newIdx += 1;
	} else if (op === "delete") {
		steps.push({
			type: "delete",
			oldIdx,
			newIdx
		});
		oldIdx += 1;
	} else if (op === "insert") {
		steps.push({
			type: "insert",
			oldIdx,
			newIdx
		});
		newIdx += 1;
	}
	return steps;
}
function reorderDiffOperations(operations) {
	const normalized = [];
	for (let i = 0; i < operations.length; i += 1) {
		const op = operations[i];
		if (op !== "delete") {
			normalized.push(op);
			continue;
		}
		let deleteCount = 0;
		while (i < operations.length && operations[i] === "delete") {
			deleteCount += 1;
			i += 1;
		}
		let insertCount = 0;
		let insertCursor = i;
		while (insertCursor < operations.length && operations[insertCursor] === "insert") {
			insertCount += 1;
			insertCursor += 1;
		}
		const pairCount = Math.min(deleteCount, insertCount);
		for (let k$1 = 0; k$1 < pairCount; k$1 += 1) normalized.push("delete", "insert");
		for (let k$1 = pairCount; k$1 < deleteCount; k$1 += 1) normalized.push("delete");
		for (let k$1 = pairCount; k$1 < insertCount; k$1 += 1) normalized.push("insert");
		i = insertCursor - 1;
	}
	return normalized;
}
function isInlineNodeToken(token$1) {
	return token$1.kind === "inlineNode";
}
function tokenizeInlineContent(pmNode, baseOffset = 0) {
	const content = [];
	pmNode.nodesBetween(0, pmNode.content.size, (node, pos) => {
		let nodeText = "";
		if (node.isText) nodeText = node.text ?? "";
		else if (node.isLeaf) {
			const leafTextFn = node.type.spec?.leafText;
			if (leafTextFn) nodeText = leafTextFn(node);
		}
		if (nodeText) {
			const runAttrs = (pos > 0 ? pmNode.nodeAt(pos - 1) : null)?.attrs ?? {};
			const tokenOffset = baseOffset + pos;
			for (let i = 0; i < nodeText.length; i += 1) content.push({
				kind: "text",
				char: nodeText[i] ?? "",
				runAttrs,
				offset: tokenOffset + i,
				marks: node.marks?.map((mark) => mark.toJSON()) ?? []
			});
			return;
		}
		if (node.type.name !== "run" && node.isInline) content.push({
			kind: "inlineNode",
			node,
			nodeType: node.type.name,
			nodeJSON: node.toJSON(),
			pos: baseOffset + pos
		});
	}, 0);
	return content;
}
function getInlineDiff(oldContent, newContent, oldParagraphEndPos) {
	const buildInlineDiff = (action, token$1, oldIdx) => {
		if (token$1.kind !== "text") return {
			action,
			idx: oldIdx,
			kind: "inlineNode",
			nodeJSON: token$1.nodeJSON ?? token$1.node.toJSON(),
			nodeType: token$1.nodeType
		};
		return {
			action,
			idx: oldIdx,
			kind: "text",
			text: token$1.char,
			runAttrs: token$1.runAttrs,
			marks: token$1.marks
		};
	};
	return groupDiffs(diffSequences(oldContent, newContent, {
		comparator: inlineComparator,
		shouldProcessEqualAsModification: shouldProcessEqualAsModification$3,
		canTreatAsModification: (oldToken, newToken) => isInlineNodeToken(oldToken) && isInlineNodeToken(newToken) && oldToken.node.type.name === newToken.node.type.name,
		buildAdded: (token$1, oldIdx) => buildInlineDiff("added", token$1, oldIdx),
		buildDeleted: (token$1, oldIdx) => buildInlineDiff("deleted", token$1, oldIdx),
		buildModified: (oldToken, newToken, oldIdx) => {
			if (oldToken.kind !== "text" && newToken.kind !== "text") {
				const attrsDiff = getAttributesDiff(normalizeInlineNodeAttrs(oldToken.node.type.name, oldToken.node.attrs), normalizeInlineNodeAttrs(newToken.node.type.name, newToken.node.attrs));
				return {
					action: "modified",
					idx: oldIdx,
					kind: "inlineNode",
					oldNodeJSON: oldToken.node.toJSON(),
					newNodeJSON: newToken.node.toJSON(),
					nodeType: oldToken.nodeType,
					attrsDiff
				};
			}
			if (oldToken.kind === "text" && newToken.kind === "text") return {
				action: "modified",
				idx: oldIdx,
				kind: "text",
				newText: newToken.char,
				oldText: oldToken.char,
				oldAttrs: oldToken.runAttrs,
				newAttrs: newToken.runAttrs,
				oldMarks: oldToken.marks,
				newMarks: newToken.marks
			};
			return null;
		}
	}), oldContent, oldParagraphEndPos);
}
function inlineComparator(a, b$1) {
	if (a.kind !== b$1.kind) return false;
	if (a.kind === "text" && b$1.kind === "text") return a.char === b$1.char;
	if (a.kind === "inlineNode" && b$1.kind === "inlineNode") return semanticInlineNodeKey(a.node) === semanticInlineNodeKey(b$1.node);
	return false;
}
function shouldProcessEqualAsModification$3(oldToken, newToken) {
	if (oldToken.kind === "text" && newToken.kind === "text") return Boolean(getAttributesDiff(oldToken.runAttrs, newToken.runAttrs)) || oldToken.marks?.length !== newToken.marks?.length || Boolean(getMarksDiff(oldToken.marks, newToken.marks));
	if (oldToken.kind === "inlineNode" && newToken.kind === "inlineNode") {
		const oldJSON = normalizeInlineNodeJSON(oldToken.node.toJSON());
		const newJSON = normalizeInlineNodeJSON(newToken.node.toJSON());
		return JSON.stringify(oldJSON) !== JSON.stringify(newJSON);
	}
	return false;
}
function groupDiffs(diffs, oldTokens, oldParagraphEndPos) {
	const grouped = [];
	let currentGroup = null;
	const pushCurrentGroup = () => {
		if (!currentGroup) return;
		const result = {
			action: currentGroup.action,
			kind: "text",
			startPos: currentGroup.startPos,
			endPos: currentGroup.endPos
		};
		if (currentGroup.action === "modified") {
			result.oldText = currentGroup.oldText;
			result.newText = currentGroup.newText;
			result.runAttrsDiff = getAttributesDiff(currentGroup.oldAttrs, currentGroup.newAttrs);
			result.marksDiff = getMarksDiff(currentGroup.oldMarks, currentGroup.newMarks);
		} else {
			result.text = currentGroup.text;
			result.runAttrs = currentGroup.runAttrs;
			result.marks = currentGroup.marks;
		}
		grouped.push(result);
		currentGroup = null;
	};
	for (const diff of diffs) {
		if (diff.kind !== "text") {
			pushCurrentGroup();
			grouped.push({
				action: diff.action,
				kind: "inlineNode",
				startPos: resolveTokenPosition(oldTokens, diff.idx, oldParagraphEndPos),
				endPos: resolveTokenPosition(oldTokens, diff.idx, oldParagraphEndPos),
				nodeType: diff.nodeType,
				...diff.action === "modified" ? {
					oldNodeJSON: diff.oldNodeJSON,
					newNodeJSON: diff.newNodeJSON,
					attrsDiff: diff.attrsDiff ?? null
				} : { nodeJSON: diff.nodeJSON }
			});
			continue;
		}
		if (!currentGroup || !canExtendGroup(currentGroup, diff, oldTokens, oldParagraphEndPos)) {
			pushCurrentGroup();
			currentGroup = createTextGroup(diff, oldTokens, oldParagraphEndPos);
		} else extendTextGroup(currentGroup, diff, oldTokens, oldParagraphEndPos);
	}
	pushCurrentGroup();
	return grouped;
}
function createTextGroup(diff, oldTokens, oldParagraphEndPos) {
	return diff.action === "modified" ? {
		action: diff.action,
		kind: "text",
		startPos: resolveTokenPosition(oldTokens, diff.idx, oldParagraphEndPos),
		endPos: resolveTokenPosition(oldTokens, diff.idx, oldParagraphEndPos),
		newText: diff.newText,
		oldText: diff.oldText,
		oldAttrs: diff.oldAttrs,
		newAttrs: diff.newAttrs,
		oldMarks: diff.oldMarks,
		newMarks: diff.newMarks
	} : {
		action: diff.action,
		kind: "text",
		startPos: resolveTokenPosition(oldTokens, diff.idx, oldParagraphEndPos),
		endPos: resolveTokenPosition(oldTokens, diff.idx, oldParagraphEndPos),
		text: diff.text,
		runAttrs: diff.runAttrs,
		marks: diff.marks
	};
}
function extendTextGroup(group, diff, oldTokens, oldParagraphEndPos) {
	group.endPos = resolveTokenPosition(oldTokens, diff.idx, oldParagraphEndPos);
	if (group.action === "modified" && diff.action === "modified") {
		group.newText += diff.newText;
		group.oldText += diff.oldText;
	} else if (group.action !== "modified" && diff.action !== "modified") group.text += diff.text;
}
function canExtendGroup(group, diff, oldTokens, oldParagraphEndPos) {
	if (group.action !== diff.action) return false;
	if (group.action === "modified" && diff.action === "modified") {
		if (!areInlineAttrsEqual(group.oldAttrs, diff.oldAttrs) || !areInlineAttrsEqual(group.newAttrs, diff.newAttrs)) return false;
		if (!areInlineMarksEqual(group.oldMarks, diff.oldMarks) || !areInlineMarksEqual(group.newMarks, diff.newMarks)) return false;
	} else if (group.action !== "modified" && diff.action !== "modified") {
		if (!areInlineAttrsEqual(group.runAttrs, diff.runAttrs)) return false;
		if (!areInlineMarksEqual(group.marks, diff.marks)) return false;
	} else return false;
	const diffPos = resolveTokenPosition(oldTokens, diff.idx, oldParagraphEndPos);
	if (group.action === "added") return group.startPos === diffPos;
	if (diffPos == null || group.endPos == null) return false;
	return group.endPos + 1 === diffPos;
}
function resolveTokenPosition(tokens, idx, paragraphEndPos) {
	if (idx < 0) return null;
	const token$1 = tokens[idx];
	if (token$1) {
		if (token$1.kind === "text") return token$1.offset ?? null;
		return token$1.pos ?? null;
	}
	if (idx === tokens.length) return paragraphEndPos;
	return null;
}
function areInlineAttrsEqual(a, b$1) {
	return !getAttributesDiff(a ?? {}, b$1 ?? {});
}
function areInlineMarksEqual(a, b$1) {
	return !getMarksDiff(a ?? [], b$1 ?? []);
}
function getInsertionPos(currentDepth, oldNodes = [], oldIdx = 0) {
	const previousNode = oldIdx > 0 ? oldNodes[oldIdx - 1] : void 0;
	if (!previousNode) return 0;
	if (currentDepth > previousNode.depth) return previousNode.pos + 1;
	if (currentDepth === previousNode.depth) return previousNode.pos + (previousNode.node.nodeSize ?? 0);
	for (let cursor = oldIdx - 1; cursor >= 0; cursor -= 1) {
		const candidateNode = oldNodes[cursor];
		if (!candidateNode) continue;
		if (candidateNode.depth > currentDepth) continue;
		if (candidateNode.depth === currentDepth) return candidateNode.pos + (candidateNode.node.nodeSize ?? 0);
		return candidateNode.pos + 1;
	}
	return 0;
}
function levenshteinDistance(a, b$1) {
	const lenA = a.length;
	const lenB = b$1.length;
	if (lenA === 0) return lenB;
	if (lenB === 0) return lenA;
	let previous = new Array(lenB + 1);
	let current = new Array(lenB + 1);
	for (let j = 0; j <= lenB; j += 1) previous[j] = j;
	for (let i = 1; i <= lenA; i += 1) {
		current[0] = i;
		const charA = a[i - 1];
		for (let j = 1; j <= lenB; j += 1) {
			const cost = charA === b$1[j - 1] ? 0 : 1;
			const deletion = previous[j] + 1;
			const insertion = current[j - 1] + 1;
			const substitution = previous[j - 1] + cost;
			current[j] = Math.min(deletion, insertion, substitution);
		}
		[previous, current] = [current, previous];
	}
	return previous[lenB];
}
var SIMILARITY_THRESHOLD = .65;
var MIN_LENGTH_FOR_SIMILARITY = 4;
function createParagraphSnapshot(paragraph, paragraphPos, depth) {
	const text = tokenizeInlineContent(paragraph, paragraphPos + 1);
	return {
		node: paragraph,
		pos: paragraphPos,
		depth,
		text,
		endPos: paragraphPos + 1 + paragraph.content.size,
		fullText: text.map((token$1) => token$1.kind === "text" ? token$1.char : "").join(""),
		contentSignature: buildContentSignature(text)
	};
}
function buildContentSignature(tokens) {
	return tokens.map((token$1) => {
		if (token$1.kind === "text") return token$1.char;
		return `\0${semanticInlineNodeKey(token$1.node)}\0`;
	}).join("");
}
function shouldProcessEqualAsModification$1(oldParagraph, newParagraph) {
	const oldNormalized = normalizeParagraphNodeJSON(oldParagraph.node.toJSON());
	const newNormalized = normalizeParagraphNodeJSON(newParagraph.node.toJSON());
	return JSON.stringify(oldNormalized) !== JSON.stringify(newNormalized);
}
function paragraphComparator(oldParagraph, newParagraph) {
	if (oldParagraph?.depth !== newParagraph?.depth) return false;
	const oldId = oldParagraph?.node?.attrs?.paraId;
	const newId = newParagraph?.node?.attrs?.paraId;
	if (oldId && newId && oldId === newId) return true;
	return (oldParagraph?.contentSignature ?? oldParagraph?.fullText) === (newParagraph?.contentSignature ?? newParagraph?.fullText);
}
function buildAddedParagraphDiff(paragraph, oldNodes, oldIdx) {
	return {
		action: "added",
		nodeType: "paragraph",
		nodeJSON: paragraph.node.toJSON(),
		text: paragraph.fullText,
		pos: getInsertionPos(paragraph.depth, oldNodes, oldIdx)
	};
}
function buildDeletedParagraphDiff(paragraph) {
	return {
		action: "deleted",
		nodeType: "paragraph",
		nodeJSON: paragraph.node.toJSON(),
		oldText: paragraph.fullText,
		pos: paragraph.pos
	};
}
function buildModifiedParagraphDiff(oldParagraph, newParagraph) {
	const contentDiff = getInlineDiff(oldParagraph.text, newParagraph.text, oldParagraph.endPos);
	const attrsDiff = getAttributesDiff(normalizeParagraphAttrs(oldParagraph.node.attrs), normalizeParagraphAttrs(newParagraph.node.attrs));
	if (contentDiff.length === 0 && !attrsDiff) return null;
	return {
		action: "modified",
		nodeType: "paragraph",
		oldNodeJSON: oldParagraph.node.toJSON(),
		newNodeJSON: newParagraph.node.toJSON(),
		oldText: oldParagraph.fullText,
		newText: newParagraph.fullText,
		pos: oldParagraph.pos,
		contentDiff,
		attrsDiff
	};
}
function canTreatAsModification(oldParagraph, newParagraph) {
	if (oldParagraph?.depth !== newParagraph?.depth) return false;
	if (paragraphComparator(oldParagraph, newParagraph)) return true;
	const oldText = oldParagraph.fullText;
	const newText = newParagraph.fullText;
	if (Math.max(oldText.length, newText.length) < MIN_LENGTH_FOR_SIMILARITY) return false;
	return getTextSimilarityScore(oldText, newText) >= SIMILARITY_THRESHOLD;
}
function getTextSimilarityScore(oldText, newText) {
	if (!oldText && !newText) return 1;
	return 1 - levenshteinDistance(oldText, newText) / (Math.max(oldText.length, newText.length) || 1);
}
var NON_PARAGRAPH_BLOCK_IGNORED_ATTRS = Array.from(NON_SEMANTIC_BLOCK_ATTRS);
function diffNodes(oldNodes, newNodes) {
	const addedNodesSet = /* @__PURE__ */ new Set();
	const deletedNodesSet = /* @__PURE__ */ new Set();
	return diffSequences(oldNodes, newNodes, {
		comparator: nodeComparator,
		reorderOperations: reorderDiffOperations,
		shouldProcessEqualAsModification: shouldProcessEqualAsModification$2,
		canTreatAsModification: canTreatAsModification$1,
		buildAdded: (nodeInfo, _oldIdx) => buildAddedDiff(nodeInfo, oldNodes, _oldIdx, addedNodesSet),
		buildDeleted: (nodeInfo) => buildDeletedDiff(nodeInfo, deletedNodesSet),
		buildModified: buildModifiedDiff
	});
}
function normalizeNodes(pmDoc) {
	const nodes = [];
	const depthMap = /* @__PURE__ */ new WeakMap();
	depthMap.set(pmDoc, -1);
	pmDoc.descendants((node, pos, parent) => {
		const depth = (parent ? depthMap.get(parent) ?? -1 : -1) + 1;
		depthMap.set(node, depth);
		if (node.type.name === "paragraph") {
			nodes.push(createParagraphSnapshot(node, pos, depth));
			return false;
		}
		nodes.push({
			node,
			pos,
			depth
		});
	});
	return nodes;
}
function nodeComparator(oldNodeInfo, newNodeInfo) {
	if (oldNodeInfo.node.type.name !== newNodeInfo.node.type.name) return false;
	if (isParagraphNodeInfo(oldNodeInfo) && isParagraphNodeInfo(newNodeInfo)) return paragraphComparator(oldNodeInfo, newNodeInfo);
	else if (oldNodeInfo.node.type.name === "tableRow" && newNodeInfo.node.type.name === "tableRow" && oldNodeInfo.node.attrs.paraId && newNodeInfo.node.attrs.paraId) return oldNodeInfo.node.attrs.paraId === newNodeInfo.node.attrs.paraId;
	return true;
}
function shouldProcessEqualAsModification$2(oldNodeInfo, newNodeInfo) {
	if (isParagraphNodeInfo(oldNodeInfo) && isParagraphNodeInfo(newNodeInfo)) return shouldProcessEqualAsModification$1(oldNodeInfo, newNodeInfo);
	return JSON.stringify(oldNodeInfo.node.attrs) !== JSON.stringify(newNodeInfo.node.attrs);
}
function canTreatAsModification$1(deletedNodeInfo, insertedNodeInfo) {
	if (isParagraphNodeInfo(deletedNodeInfo) && isParagraphNodeInfo(insertedNodeInfo)) return canTreatAsModification(deletedNodeInfo, insertedNodeInfo);
	return false;
}
function buildAddedDiff(nodeInfo, oldNodes, oldIdx, addedNodesSet) {
	if (addedNodesSet.has(nodeInfo.node)) return null;
	addedNodesSet.add(nodeInfo.node);
	if (isParagraphNodeInfo(nodeInfo)) return buildAddedParagraphDiff(nodeInfo, oldNodes, oldIdx);
	nodeInfo.node.descendants((childNode) => {
		addedNodesSet.add(childNode);
	});
	return {
		action: "added",
		nodeType: nodeInfo.node.type.name,
		nodeJSON: nodeInfo.node.toJSON(),
		pos: getInsertionPos(nodeInfo.depth, oldNodes, oldIdx)
	};
}
function buildDeletedDiff(nodeInfo, deletedNodesSet) {
	if (deletedNodesSet.has(nodeInfo.node)) return null;
	deletedNodesSet.add(nodeInfo.node);
	if (isParagraphNodeInfo(nodeInfo)) return buildDeletedParagraphDiff(nodeInfo);
	nodeInfo.node.descendants((childNode) => {
		deletedNodesSet.add(childNode);
	});
	return {
		action: "deleted",
		nodeType: nodeInfo.node.type.name,
		nodeJSON: nodeInfo.node.toJSON(),
		pos: nodeInfo.pos
	};
}
function buildModifiedDiff(oldNodeInfo, newNodeInfo) {
	if (isParagraphNodeInfo(oldNodeInfo) && isParagraphNodeInfo(newNodeInfo)) return buildModifiedParagraphDiff(oldNodeInfo, newNodeInfo);
	const attrsDiff = getAttributesDiff(oldNodeInfo.node.attrs, newNodeInfo.node.attrs, NON_PARAGRAPH_BLOCK_IGNORED_ATTRS);
	if (!attrsDiff) return null;
	return {
		action: "modified",
		nodeType: oldNodeInfo.node.type.name,
		oldNodeJSON: oldNodeInfo.node.toJSON(),
		newNodeJSON: newNodeInfo.node.toJSON(),
		pos: oldNodeInfo.pos,
		attrsDiff
	};
}
function isParagraphNodeInfo(nodeInfo) {
	return nodeInfo.node.type.name === "paragraph";
}
const COMMENT_ATTRS_DIFF_IGNORED_KEYS = [
	"textJson",
	"elements",
	"commentId",
	"trackedChangeParentId",
	"documentId",
	"fileId",
	"selection"
];
function buildCommentTokens(comments, schema) {
	return comments.map((comment) => {
		const commentId = resolveCommentId$1(comment);
		if (!commentId) return null;
		return {
			commentId,
			commentJSON: comment,
			content: tokenizeCommentText(comment, schema)
		};
	}).filter((token$1) => token$1 !== null);
}
function diffComments(oldComments, newComments, schema) {
	return diffSequences(buildCommentTokens(oldComments, schema), buildCommentTokens(newComments, schema), {
		comparator: commentComparator,
		shouldProcessEqualAsModification,
		canTreatAsModification: () => false,
		buildAdded: (token$1) => buildAddedCommentDiff(token$1),
		buildDeleted: (token$1) => buildDeletedCommentDiff(token$1),
		buildModified: (oldToken, newToken) => buildModifiedCommentDiff(oldToken, newToken)
	});
}
function commentComparator(oldToken, newToken) {
	return oldToken.commentId === newToken.commentId;
}
function shouldProcessEqualAsModification(oldToken, newToken) {
	if (getAttributesDiff(oldToken.commentJSON, newToken.commentJSON, COMMENT_ATTRS_DIFF_IGNORED_KEYS)) return true;
	return (oldToken.content ? JSON.stringify(oldToken.content.node.toJSON()) : "") !== (newToken.content ? JSON.stringify(newToken.content.node.toJSON()) : "");
}
function buildAddedCommentDiff(comment) {
	return {
		action: "added",
		nodeType: "comment",
		commentId: comment.commentId,
		commentJSON: comment.commentJSON,
		text: getCommentText(comment.content)
	};
}
function buildDeletedCommentDiff(comment) {
	return {
		action: "deleted",
		nodeType: "comment",
		commentId: comment.commentId,
		commentJSON: comment.commentJSON,
		oldText: getCommentText(comment.content)
	};
}
function buildModifiedCommentDiff(oldComment, newComment) {
	const contentDiff = buildCommentContentDiff(oldComment.content, newComment.content);
	const attrsDiff = getAttributesDiff(oldComment.commentJSON, newComment.commentJSON, COMMENT_ATTRS_DIFF_IGNORED_KEYS);
	if (contentDiff.length === 0 && !attrsDiff) return null;
	return {
		action: "modified",
		nodeType: "comment",
		commentId: oldComment.commentId,
		oldCommentJSON: oldComment.commentJSON,
		newCommentJSON: newComment.commentJSON,
		oldText: getCommentText(oldComment.content),
		newText: getCommentText(newComment.content),
		contentDiff,
		attrsDiff
	};
}
function buildCommentContentDiff(oldContent, newContent) {
	if (!oldContent || !newContent) return [];
	if (oldContent.node.type.name === "doc" && newContent.node.type.name === "doc") return diffNodes(normalizeNodes(oldContent.node), normalizeNodes(newContent.node));
	return diffNodes([oldContent], [newContent]);
}
function resolveCommentId$1(comment) {
	return comment.importedId ?? comment.id ?? comment.commentId ?? null;
}
function getCommentText(content) {
	if (!content) return "";
	if (content.node.type.name === "paragraph") return content.fullText;
	return content.node.textContent ?? "";
}
function tokenizeCommentText(comment, schema) {
	const nodeJson = resolveCommentBodyNodeJSON(comment);
	if (!nodeJson) return null;
	const node = schema.nodeFromJSON(nodeJson);
	if (node.type.name !== "paragraph") return {
		node,
		pos: 0,
		depth: 0
	};
	return createParagraphSnapshot(node, 0, 0);
}
function resolveCommentBodyNodeJSON(comment) {
	if (isRecord$2(comment.textJson)) return comment.textJson;
	if (Array.isArray(comment.elements) && comment.elements.length > 0) {
		if (comment.elements.length === 1 && isRecord$2(comment.elements[0])) return comment.elements[0];
		return {
			type: "doc",
			content: comment.elements
		};
	}
	return null;
}
function isRecord$2(value) {
	return value !== null && typeof value === "object" && !Array.isArray(value);
}
const SLOT_VARIANTS = [
	"default",
	"first",
	"even"
];
var PART_KINDS = ["header", "footer"];
function captureHeaderFooterState(editor) {
	return {
		parts: collectHeaderFooterParts(editor),
		slots: collectHeaderFooterSlots(editor)
	};
}
function diffHeaderFooters(oldState, newState, schema) {
	const previous = oldState ?? {
		parts: [],
		slots: []
	};
	const next = newState ?? {
		parts: [],
		slots: []
	};
	const previousParts = new Map(previous.parts.map((part) => [part.refId, part]));
	const nextParts = new Map(next.parts.map((part) => [part.refId, part]));
	const addedParts = [];
	const removedParts = [];
	const modifiedParts = [];
	for (const nextPart of next.parts) {
		const previousPart = previousParts.get(nextPart.refId);
		if (!previousPart) {
			addedParts.push(structuredClone(nextPart));
			continue;
		}
		if (previousPart.kind !== nextPart.kind) {
			removedParts.push(structuredClone(previousPart));
			addedParts.push(structuredClone(nextPart));
			continue;
		}
		const oldDoc = schema.nodeFromJSON(previousPart.content);
		const newDoc = schema.nodeFromJSON(nextPart.content);
		const docDiffs = diffNodes(normalizeNodes(oldDoc), normalizeNodes(newDoc));
		if (docDiffs.length > 0 || previousPart.partPath !== nextPart.partPath) modifiedParts.push({
			refId: nextPart.refId,
			kind: nextPart.kind,
			oldPartPath: previousPart.partPath,
			partPath: nextPart.partPath,
			docDiffs
		});
	}
	for (const previousPart of previous.parts) if (!nextParts.has(previousPart.refId)) removedParts.push(structuredClone(previousPart));
	const previousSlots = new Map(previous.slots.map((slot) => [slot.sectionId, slot]));
	const nextSlots = new Map(next.slots.map((slot) => [slot.sectionId, slot]));
	const slotChanges = [];
	const sectionIds = new Set([...previousSlots.keys(), ...nextSlots.keys()]);
	for (const sectionId of sectionIds) {
		const previousSlot = previousSlots.get(sectionId);
		const nextSlot = nextSlots.get(sectionId) ?? createClearedSlotState(sectionId);
		if (!slotsEqual(previousSlot, nextSlot)) slotChanges.push(structuredClone(nextSlot));
	}
	if (addedParts.length === 0 && removedParts.length === 0 && modifiedParts.length === 0 && slotChanges.length === 0) return null;
	return {
		addedParts,
		removedParts,
		modifiedParts,
		slotChanges
	};
}
function collectHeaderFooterParts(editor) {
	const parts = [];
	const partPaths = readHeaderFooterPartPaths(editor);
	for (const kind of PART_KINDS) {
		const source = kind === "header" ? editor.converter?.headers : editor.converter?.footers;
		if (!source) continue;
		for (const [refId, content] of Object.entries(source)) {
			const partPath = partPaths.get(refId);
			if (!partPath || !content || typeof content !== "object") continue;
			parts.push({
				refId,
				kind,
				partPath,
				content: structuredClone(content)
			});
		}
	}
	return parts.sort(compareParts);
}
function readHeaderFooterPartPaths(editor) {
	const result = /* @__PURE__ */ new Map();
	const relsRoot = (editor.converter?.convertedXml?.["word/_rels/document.xml.rels"])?.elements?.find((entry) => entry.name === "Relationships");
	if (!relsRoot?.elements) return result;
	for (const entry of relsRoot.elements) {
		const type = entry.attributes?.Type;
		if (entry.name !== "Relationship" || type !== "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header" && type !== "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer") continue;
		const refId = entry.attributes?.Id;
		const target = entry.attributes?.Target;
		if (!refId || !target) continue;
		result.set(refId, normalizePartPath(target));
	}
	return result;
}
function normalizePartPath(target) {
	let normalized = target.replace(/^\.\//, "");
	if (normalized.startsWith("../")) normalized = normalized.slice(3);
	if (normalized.startsWith("/")) normalized = normalized.slice(1);
	if (!normalized.startsWith("word/")) normalized = `word/${normalized}`;
	return normalized;
}
function collectHeaderFooterSlots(editor) {
	const slots = [];
	for (const projection of resolveSectionProjections(editor)) {
		const sectPr = readTargetSectPr(editor, projection);
		const headerRefs = sectPr ? readSectPrHeaderFooterRefs(sectPr, "header") : void 0;
		const footerRefs = sectPr ? readSectPrHeaderFooterRefs(sectPr, "footer") : void 0;
		slots.push({
			sectionId: projection.sectionId,
			titlePg: projection.range.titlePg === true,
			header: {
				default: headerRefs?.default ?? null,
				first: headerRefs?.first ?? null,
				even: headerRefs?.even ?? null
			},
			footer: {
				default: footerRefs?.default ?? null,
				first: footerRefs?.first ?? null,
				even: footerRefs?.even ?? null
			}
		});
	}
	return slots.sort((a, b$1) => a.sectionId.localeCompare(b$1.sectionId));
}
function compareParts(a, b$1) {
	if (a.kind !== b$1.kind) return a.kind.localeCompare(b$1.kind);
	return a.refId.localeCompare(b$1.refId);
}
function createClearedSlotState(sectionId) {
	return {
		sectionId,
		titlePg: false,
		header: {
			default: null,
			first: null,
			even: null
		},
		footer: {
			default: null,
			first: null,
			even: null
		}
	};
}
function slotsEqual(previous, next) {
	if (!previous) return false;
	if (previous.titlePg !== next.titlePg) return false;
	for (const variant of SLOT_VARIANTS) {
		if (previous.header[variant] !== next.header[variant]) return false;
		if (previous.footer[variant] !== next.footer[variant]) return false;
	}
	return true;
}
var DOCUMENT_RELS_PATH$2 = "word/_rels/document.xml.rels";
function toRelsPathForPart(partPath) {
	if (partPath === DOCUMENT_RELS_PATH$2 || partPath.endsWith(".rels")) return null;
	if (!partPath.includes("/") || partPath.endsWith("/")) return null;
	return getWordPartRelsPath(partPath);
}
var DOCUMENT_RELS_PATH$1 = "word/_rels/document.xml.rels";
function capturePartsState(editor, headerFooters) {
	const convertedXml = editor.converter?.convertedXml ?? {};
	const mediaStore = getMediaStore(editor);
	const headerFooterClosures = {};
	for (const part of headerFooters?.parts ?? []) headerFooterClosures[part.refId] = {
		refId: part.refId,
		kind: part.kind,
		partPath: part.partPath,
		parts: collectPartClosure(part.partPath, convertedXml, mediaStore)
	};
	return {
		bodyClosure: collectBodyClosure(convertedXml, mediaStore),
		headerFooterClosures
	};
}
function diffParts(previousPartsState, nextPartsState) {
	if (!previousPartsState || !nextPartsState) return null;
	const upserts = {};
	const deletes = /* @__PURE__ */ new Set();
	const nextReachablePartPaths = collectReachablePartPaths(nextPartsState);
	const previousOwnedParts = collectOwnedParts(previousPartsState);
	const nextOwnedParts = collectOwnedParts(nextPartsState);
	for (const [partPath, snapshot] of Object.entries(nextOwnedParts)) {
		const previous = previousOwnedParts[partPath];
		if (!previous || !partSnapshotsEqual(previous, snapshot)) upserts[partPath] = structuredClone(snapshot);
	}
	for (const partPath of Object.keys(previousOwnedParts)) if (!(partPath in nextOwnedParts) && !(partPath in upserts) && !nextReachablePartPaths.has(partPath)) deletes.add(partPath);
	if (Object.keys(upserts).length === 0 && deletes.size === 0) return null;
	return {
		upserts,
		deletes: [...deletes].sort()
	};
}
function collectOwnedParts(partsState) {
	const owned = {};
	addOwnedPartsFromClosure(owned, partsState.bodyClosure);
	for (const closure of Object.values(partsState.headerFooterClosures)) addOwnedPartsFromClosure(owned, closure.parts, closure.partPath);
	return owned;
}
function addOwnedPartsFromClosure(target, closure, semanticRootPath) {
	for (const [partPath, snapshot] of Object.entries(closure)) {
		if (isSemanticOwnedPart(partPath, semanticRootPath)) continue;
		target[partPath] = snapshot;
	}
}
function isSemanticOwnedPart(partPath, headerFooterRootPath) {
	if (partPath === "word/document.xml" || partPath === "word/styles.xml" || partPath === "word/numbering.xml") return true;
	if (headerFooterRootPath && partPath === headerFooterRootPath) return true;
	return false;
}
function collectReachablePartPaths(partsState) {
	const reachable = /* @__PURE__ */ new Set();
	for (const partPath of Object.keys(partsState?.bodyClosure ?? {})) reachable.add(partPath);
	for (const closure of Object.values(partsState?.headerFooterClosures ?? {})) for (const partPath of Object.keys(closure.parts)) reachable.add(partPath);
	return reachable;
}
function getMediaStore(editor) {
	return {
		...editor.options?.mediaFiles ?? {},
		...editor.storage?.image?.media ?? {}
	};
}
function collectPartClosure(partPath, convertedXml, mediaStore) {
	const snapshots = {};
	collectPartAndDependencies(partPath, convertedXml, mediaStore, snapshots, /* @__PURE__ */ new Set());
	return snapshots;
}
function collectBodyClosure(convertedXml, mediaStore) {
	const relsPart = convertedXml[DOCUMENT_RELS_PATH$1];
	if (!relsPart || typeof relsPart !== "object") return {};
	const snapshots = { [DOCUMENT_RELS_PATH$1]: {
		kind: "xml",
		content: structuredClone(relsPart)
	} };
	const visited = new Set([DOCUMENT_RELS_PATH$1]);
	for (const relationship of readRelationships(relsPart)) {
		if (!shouldCaptureBodyRelationship(String(relationship.attributes?.Type ?? ""))) continue;
		if (String(relationship.attributes?.TargetMode ?? "") === "External") continue;
		const targetPath = resolveOpcTargetPath(String(relationship.attributes?.Target ?? ""), "word");
		if (!targetPath) continue;
		collectPartAndDependencies(targetPath, convertedXml, mediaStore, snapshots, visited);
	}
	return snapshots;
}
function collectPartAndDependencies(partPath, convertedXml, mediaStore, snapshots, visited) {
	if (visited.has(partPath)) return;
	visited.add(partPath);
	const xmlPart = convertedXml[partPath];
	if (xmlPart && typeof xmlPart === "object") snapshots[partPath] = {
		kind: "xml",
		content: structuredClone(xmlPart)
	};
	else if (partPath in mediaStore) {
		snapshots[partPath] = {
			kind: "binary",
			content: structuredClone(mediaStore[partPath])
		};
		return;
	} else return;
	const relsPath = toRelsPathForPart(partPath);
	const relsPart = relsPath ? convertedXml[relsPath] : void 0;
	if (!relsPath || !relsPart || typeof relsPart !== "object") return;
	snapshots[relsPath] = {
		kind: "xml",
		content: structuredClone(relsPart)
	};
	const relationships = readRelationships(relsPart);
	const baseDir = getPartBaseDir(partPath);
	for (const relationship of relationships) {
		if (String(relationship.attributes?.TargetMode ?? "") === "External") continue;
		const targetPath = resolveOpcTargetPath(String(relationship.attributes?.Target ?? ""), baseDir);
		if (!targetPath) continue;
		collectPartAndDependencies(targetPath, convertedXml, mediaStore, snapshots, visited);
	}
}
function readRelationships(relsPart) {
	const root = relsPart?.elements?.find((entry) => entry.name === "Relationships");
	return Array.isArray(root?.elements) ? root.elements : [];
}
function getPartBaseDir(partPath) {
	const lastSlash = partPath.lastIndexOf("/");
	return lastSlash >= 0 ? partPath.slice(0, lastSlash) : "";
}
function shouldCaptureBodyRelationship(type) {
	return !BODY_RELATIONSHIP_EXCLUSIONS.has(type);
}
function partSnapshotsEqual(a, b$1) {
	return a.kind === b$1.kind && JSON.stringify(a.content) === JSON.stringify(b$1.content);
}
var BODY_RELATIONSHIP_EXCLUSIONS = new Set([
	"http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
	"http://schemas.openxmlformats.org/officeDocument/2006/relationships/numbering",
	"http://schemas.openxmlformats.org/officeDocument/2006/relationships/settings",
	"http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
	"http://schemas.openxmlformats.org/officeDocument/2006/relationships/webSettings",
	"http://schemas.openxmlformats.org/officeDocument/2006/relationships/fontTable",
	"http://schemas.openxmlformats.org/officeDocument/2006/relationships/header",
	"http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer",
	"http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
	"http://schemas.openxmlformats.org/officeDocument/2006/relationships/footnotes",
	"http://schemas.openxmlformats.org/officeDocument/2006/relationships/endnotes",
	"http://schemas.microsoft.com/office/2011/relationships/commentsExtended",
	"http://schemas.microsoft.com/office/2016/09/relationships/commentsIds",
	"http://schemas.microsoft.com/office/2018/08/relationships/commentsExtensible"
]);
function hasOwnStyle(styleMap, styleId$1) {
	return Object.prototype.hasOwnProperty.call(styleMap, styleId$1);
}
function diffStyles(oldStyles, newStyles) {
	const oldStyleMap = oldStyles?.styles ?? {};
	const newStyleMap = newStyles?.styles ?? {};
	const addedStyles = {};
	const removedStyles = {};
	const modifiedStyles = {};
	for (const [styleId$1, styleDef] of Object.entries(newStyleMap)) if (!hasOwnStyle(oldStyleMap, styleId$1)) addedStyles[styleId$1] = styleDef;
	for (const [styleId$1, styleDef] of Object.entries(oldStyleMap)) {
		if (!hasOwnStyle(newStyleMap, styleId$1)) {
			removedStyles[styleId$1] = styleDef;
			continue;
		}
		const attrsDiff = getAttributesDiff(styleDef, newStyleMap[styleId$1]);
		if (attrsDiff) modifiedStyles[styleId$1] = attrsDiff;
	}
	const docDefaultsDiff = getAttributesDiff(oldStyles?.docDefaults ?? {}, newStyles?.docDefaults ?? {});
	const latentStylesDiff = getAttributesDiff(oldStyles?.latentStyles ?? {}, newStyles?.latentStyles ?? {});
	if (!(Boolean(docDefaultsDiff) || Boolean(latentStylesDiff) || Object.keys(addedStyles).length > 0 || Object.keys(removedStyles).length > 0 || Object.keys(modifiedStyles).length > 0)) return null;
	return {
		docDefaultsDiff,
		latentStylesDiff,
		addedStyles,
		removedStyles,
		modifiedStyles
	};
}
function diffNumbering(oldNumbering, newNumbering) {
	return getAttributesDiff(oldNumbering ?? {}, newNumbering ?? {});
}
function computeDiff(oldPmDoc, newPmDoc, schema, oldComments = [], newComments = [], oldStyles = null, newStyles = null, oldNumbering = null, newNumbering = null, oldHeaderFooters = null, newHeaderFooters = null, oldPartsState = null, newPartsState = null) {
	const docDiffs = diffNodes(normalizeNodes(oldPmDoc), normalizeNodes(newPmDoc));
	const headerFootersDiff = diffHeaderFooters(oldHeaderFooters, newHeaderFooters, schema);
	const partsDiff = oldPartsState && newPartsState ? diffParts(oldPartsState, newPartsState) : null;
	return {
		docDiffs,
		commentDiffs: diffComments(oldComments, newComments, schema),
		stylesDiff: diffStyles(oldStyles, newStyles),
		numberingDiff: diffNumbering(oldNumbering, newNumbering),
		headerFootersDiff,
		partsDiff
	};
}
function replayNonParagraphDiff({ tr, diff, schema }) {
	const result = {
		applied: 0,
		skipped: 0,
		warnings: []
	};
	const skipWithWarning = (message) => {
		result.skipped += 1;
		result.warnings.push(message);
	};
	if (diff.nodeType === "paragraph") {
		skipWithWarning("Non-paragraph handler received a paragraph diff.");
		return result;
	}
	const { pos } = diff;
	if (pos < 0 || pos > tr.doc.content.size) {
		skipWithWarning(`Position ${pos} outside of document.`);
		return result;
	}
	if (diff.action === "added") {
		if (!diff.nodeJSON) {
			skipWithWarning("Missing nodeJSON for added non-paragraph diff.");
			return result;
		}
		try {
			const node = schema.nodeFromJSON(diff.nodeJSON);
			const step = new ReplaceStep(pos, pos, new Slice(Fragment$1.from(node), 0, 0));
			if (tr.maybeStep(step).failed) {
				skipWithWarning(`Failed to insert node at pos ${pos}.`);
				return result;
			}
			result.applied += 1;
			return result;
		} catch (error) {
			skipWithWarning(`Invalid nodeJSON for added diff at pos ${pos}.`);
			return result;
		}
	}
	if (diff.action === "deleted") {
		const node = tr.doc.nodeAt(pos);
		if (!node) {
			skipWithWarning(`No node found at pos ${pos} for deletion.`);
			return result;
		}
		if (node.type.name !== diff.nodeType) {
			skipWithWarning(`Node type mismatch at pos ${pos} for deletion.`);
			return result;
		}
		const step = new ReplaceStep(pos, pos + node.nodeSize, Slice.empty);
		if (tr.maybeStep(step).failed) {
			skipWithWarning(`Failed to delete node at pos ${pos}.`);
			return result;
		}
		result.applied += 1;
		return result;
	}
	if (diff.action === "modified") {
		if (!diff.attrsDiff) {
			result.skipped += 1;
			return result;
		}
		const node = tr.doc.nodeAt(pos);
		if (!node) {
			skipWithWarning(`No node found at pos ${pos} for modification.`);
			return result;
		}
		if (node.type.name !== diff.nodeType) {
			skipWithWarning(`Node type mismatch at pos ${pos} for modification.`);
			return result;
		}
		try {
			const mergedAttrs = applyAttrsDiff(node.attrs, diff.attrsDiff);
			tr.setNodeMarkup(pos, void 0, mergedAttrs, node.marks);
			result.applied += 1;
			return result;
		} catch (error) {
			skipWithWarning(`Failed to update node attrs at pos ${pos}.`);
			return result;
		}
	}
	skipWithWarning(`Unsupported diff action for non-paragraph node at pos ${pos}.`);
	return result;
}
function applyAttrsDiff$1({ attrs, diff }) {
	const updated = JSON.parse(JSON.stringify(attrs ?? {}));
	Object.entries(diff.added || {}).forEach(([path, value]) => {
		setNestedValue(updated, path, value);
	});
	Object.entries(diff.modified || {}).forEach(([path, change]) => {
		setNestedValue(updated, path, change.to);
	});
	Object.keys(diff.deleted || {}).forEach((path) => {
		deleteNestedValue(updated, path);
	});
	return updated;
}
var setNestedValue = (target, path, value) => {
	if (!path.includes(".")) {
		target[path] = value;
		return;
	}
	const parts = path.split(".");
	let current = target;
	for (let i = 0; i < parts.length; i += 1) {
		const key = parts[i];
		if (i === parts.length - 1) current[key] = value;
		else {
			if (!isPlainObject(current[key])) current[key] = {};
			current = current[key];
		}
	}
};
var deleteNestedValue = (target, path) => {
	if (!path.includes(".")) {
		delete target[path];
		return;
	}
	const parts = path.split(".");
	let current = target;
	for (let i = 0; i < parts.length; i += 1) {
		const key = parts[i];
		if (i === parts.length - 1) {
			delete current[key];
			return;
		}
		if (!isPlainObject(current[key])) return;
		current = current[key];
	}
};
var isPlainObject = (value) => {
	return Boolean(value) && typeof value === "object" && !Array.isArray(value);
};
function marksFromDiff({ schema, action, marks = [], marksDiff = null, oldMarks = [] }) {
	if (action === "deleted") return [];
	if (action === "modified") {
		if (marksDiff) return buildMarksFromJSON(schema, applyMarksDiff(oldMarks, marksDiff));
		if (marks.length > 0) return buildMarksFromJSON(schema, marks);
		return [];
	}
	if (marks.length === 0) return [];
	return buildMarksFromJSON(schema, marks);
}
var applyMarksDiff = (existingMarks, marksDiff) => {
	const updatedMarks = existingMarks.map((mark) => ({
		type: mark.type,
		attrs: mark.attrs ?? {}
	}));
	marksDiff.deleted.forEach((mark) => {
		const index = updatedMarks.findIndex((existing) => existing.type === mark.name && deepEquals(existing.attrs, mark.attrs));
		if (index >= 0) updatedMarks.splice(index, 1);
	});
	marksDiff.modified.forEach((mark) => {
		const index = updatedMarks.findIndex((existing) => existing.type === mark.name && deepEquals(existing.attrs, mark.oldAttrs));
		if (index >= 0) {
			updatedMarks.splice(index, 1, {
				type: mark.name,
				attrs: mark.newAttrs ?? {}
			});
			return;
		}
		updatedMarks.push({
			type: mark.name,
			attrs: mark.newAttrs ?? {}
		});
	});
	marksDiff.added.forEach((mark) => {
		updatedMarks.push({
			type: mark.name,
			attrs: mark.attrs ?? {}
		});
	});
	return updatedMarks;
};
var buildMarksFromJSON = (schema, marks) => {
	const resolvedMarks = [];
	marks.forEach((mark) => {
		const markType = schema.marks[mark.type];
		if (!markType) return;
		resolvedMarks.push(markType.create(mark.attrs ?? {}));
	});
	return resolvedMarks;
};
function replayInlineDiff({ tr, diff, schema, paragraphEndPos }) {
	const result = {
		applied: 0,
		skipped: 0,
		warnings: []
	};
	const skipWithWarning = (message) => {
		result.skipped += 1;
		result.warnings.push(message);
	};
	const isAddition = diff.action === "added";
	const isDeletion = diff.action === "deleted";
	const isModification = diff.action === "modified";
	let from$1 = diff.startPos ?? null;
	let to = diff.endPos ?? null;
	if (isAddition && from$1 === null) {
		from$1 = paragraphEndPos;
		to = paragraphEndPos;
	}
	if (!isAddition && (from$1 === null || to === null)) {
		skipWithWarning("Missing inline diff anchor positions.");
		return result;
	}
	if (from$1 === null) {
		skipWithWarning("Missing inline diff start position.");
		return result;
	}
	if (to === null) to = from$1;
	if (diff.kind === "text") {
		const textForRange = diff.action === "modified" ? diff.oldText : diff.text;
		const rangeLength = typeof textForRange === "string" ? textForRange.length : null;
		if (!isAddition && rangeLength !== null && from$1 !== null) to = from$1 + rangeLength;
		else if (!isAddition && to !== null && from$1 !== null) to = to + 1;
		if (isAddition) {
			if (!diff.text) {
				skipWithWarning("Missing text content for inline addition.");
				return result;
			}
			const marks = marksFromDiff({
				schema,
				action: diff.action,
				marks: diff.marks
			});
			const textNode = schema.text(diff.text, marks);
			const slice = new Slice(Fragment$1.from(textNode), 0, 0);
			const step = new ReplaceStep(from$1, from$1, slice);
			if (tr.maybeStep(step).failed) {
				skipWithWarning(`Failed to insert text at ${from$1}.`);
				return result;
			}
			result.applied += 1;
			return result;
		}
		if (isDeletion) {
			const step = new ReplaceStep(from$1, to, Slice.empty);
			if (tr.maybeStep(step).failed) {
				skipWithWarning(`Failed to delete text at ${from$1}-${to}.`);
				return result;
			}
			result.applied += 1;
			return result;
		}
		if (isModification) {
			if (diff.newText == null) {
				skipWithWarning("Missing newText for inline modification.");
				return result;
			}
			marksFromDiff({
				schema,
				action: diff.action,
				marks: diff.marks,
				marksDiff: diff.marksDiff,
				oldMarks: getMarksAtPosition(tr.doc, from$1)
			}).forEach((mark) => {
				const step = new AddMarkStep(from$1, to, mark);
				if (tr.maybeStep(step).failed) skipWithWarning(`Failed to add mark ${mark.type.name} at ${from$1}-${to}.`);
			});
			(diff.marksDiff?.deleted ?? []).forEach((markEntry) => {
				const markType = schema.marks[markEntry.name];
				if (!markType) {
					skipWithWarning(`Unknown mark type ${markEntry.name} for deletion.`);
					return;
				}
				const mark = markType.create(markEntry.attrs || {});
				const step = new RemoveMarkStep(from$1, to, mark);
				if (tr.maybeStep(step).failed) skipWithWarning(`Failed to remove mark ${mark.type.name} at ${from$1}-${to}.`);
			});
			(diff.marksDiff?.modified ?? []).forEach((markEntry) => {
				const markType = schema.marks[markEntry.name];
				if (!markType) {
					skipWithWarning(`Unknown mark type ${markEntry.name} for modification.`);
					return;
				}
				const oldMark = markType.create(markEntry.oldAttrs || {});
				const step = new RemoveMarkStep(from$1, to, oldMark);
				if (tr.maybeStep(step).failed) skipWithWarning(`Failed to remove old mark ${oldMark.type.name} at ${from$1}-${to}.`);
			});
			if (diff.runAttrsDiff) {
				const metadataDiff = filterAttributesDiffByPath(diff.runAttrsDiff, (path) => !path.startsWith("runProperties"));
				if (metadataDiff) {
					const metadataReplayResult = applyRunAttrsDiffInRange(tr, from$1, to, metadataDiff);
					if (metadataReplayResult.warning) skipWithWarning(metadataReplayResult.warning);
				}
				if (!diff.marksDiff) {
					const runPropertiesDiff = filterAttributesDiffByPath(diff.runAttrsDiff, (path) => path.startsWith("runProperties"));
					if (runPropertiesDiff) {
						const runPropertiesReplayResult = applyRunAttrsDiffInRange(tr, from$1, to, runPropertiesDiff);
						if (runPropertiesReplayResult.warning) skipWithWarning(runPropertiesReplayResult.warning);
					}
				}
			}
			result.applied += 1;
			return result;
		}
	}
	if (diff.kind === "inlineNode") {
		if (isAddition) {
			if (!diff.nodeJSON) {
				skipWithWarning("Missing nodeJSON for inline node addition.");
				return result;
			}
			try {
				const node = schema.nodeFromJSON(diff.nodeJSON);
				const slice = new Slice(Fragment$1.from(node), 0, 0);
				const step = new ReplaceStep(from$1, from$1, slice);
				if (tr.maybeStep(step).failed) {
					skipWithWarning(`Failed to insert inline node at ${from$1}.`);
					return result;
				}
				result.applied += 1;
				return result;
			} catch (error) {
				skipWithWarning("Invalid nodeJSON for inline node addition.");
				return result;
			}
		}
		if (isDeletion) {
			const node = tr.doc.nodeAt(from$1);
			if (!node) {
				skipWithWarning(`No inline node found at ${from$1} for deletion.`);
				return result;
			}
			to = from$1 + node.nodeSize;
			const step = new ReplaceStep(from$1, to, Slice.empty);
			if (tr.maybeStep(step).failed) {
				skipWithWarning(`Failed to delete inline node at ${from$1}-${to}.`);
				return result;
			}
			result.applied += 1;
			return result;
		}
		if (isModification) {
			if (!diff.newNodeJSON) {
				skipWithWarning("Missing newNodeJSON for inline node modification.");
				return result;
			}
			try {
				const existingNode = tr.doc.nodeAt(from$1);
				if (!existingNode) {
					skipWithWarning(`No inline node found at ${from$1} for modification.`);
					return result;
				}
				to = from$1 + existingNode.nodeSize;
				const node = schema.nodeFromJSON(diff.newNodeJSON);
				const slice = new Slice(Fragment$1.from(node), 0, 0);
				const step = new ReplaceStep(from$1, to, slice);
				if (tr.maybeStep(step).failed) {
					skipWithWarning(`Failed to replace inline node at ${from$1}-${to}.`);
					return result;
				}
				result.applied += 1;
				return result;
			} catch (error) {
				skipWithWarning("Invalid newNodeJSON for inline node modification.");
				return result;
			}
		}
	}
	skipWithWarning("Unsupported inline diff operation.");
	return result;
}
var applyRunAttrsDiffInRange = (tr, from$1, to, diff) => {
	const runEntries = [];
	tr.doc.nodesBetween(from$1, to, (node, pos) => {
		if (node.type.name === "run") {
			runEntries.push({
				pos,
				node
			});
			return false;
		}
	});
	if (runEntries.length === 0) return { warning: `No run nodes found in ${from$1}-${to} for run-attr update.` };
	const failures = [];
	runEntries.forEach(({ pos, node }) => {
		const updatedAttrs = applyAttrsDiff$1({
			attrs: node.attrs,
			diff
		});
		if (deepEquals(updatedAttrs, node.attrs)) return;
		try {
			tr.setNodeMarkup(pos, void 0, updatedAttrs, node.marks);
		} catch (error) {
			failures.push(`Failed to update run attrs at ${pos}.`);
		}
	});
	if (failures.length > 0) return { warning: failures.join(" ") };
	return {};
};
var filterAttributesDiffByPath = (diff, predicate) => {
	const filtered = {
		added: {},
		deleted: {},
		modified: {}
	};
	Object.entries(diff.added || {}).forEach(([path, value]) => {
		if (predicate(path)) filtered.added[path] = value;
	});
	Object.entries(diff.deleted || {}).forEach(([path, value]) => {
		if (predicate(path)) filtered.deleted[path] = value;
	});
	Object.entries(diff.modified || {}).forEach(([path, value]) => {
		if (predicate(path)) filtered.modified[path] = value;
	});
	return Object.keys(filtered.added).length > 0 || Object.keys(filtered.deleted).length > 0 || Object.keys(filtered.modified).length > 0 ? filtered : null;
};
var getMarksAtPosition = (doc$1, pos) => {
	const resolved = doc$1.resolve(pos);
	const candidate = resolved.nodeAfter || resolved.nodeBefore;
	if (!candidate || !candidate.isInline) return [];
	return candidate.marks.map((mark) => ({
		type: mark.type.name,
		attrs: mark.attrs ?? {}
	}));
};
function replayParagraphDiff({ tr, diff, schema }) {
	const result = {
		applied: 0,
		skipped: 0,
		warnings: []
	};
	const skipWithWarning = (message) => {
		result.skipped += 1;
		result.warnings.push(message);
	};
	const { pos } = diff;
	if (pos < 0 || pos > tr.doc.content.size) {
		skipWithWarning(`Position ${pos} outside of document.`);
		return result;
	}
	if (diff.action === "added") {
		if (!diff.nodeJSON) {
			skipWithWarning("Missing nodeJSON for added paragraph diff.");
			return result;
		}
		try {
			const node = schema.nodeFromJSON(diff.nodeJSON);
			const step = new ReplaceStep(pos, pos, new Slice(Fragment$1.from(node), 0, 0));
			if (tr.maybeStep(step).failed) {
				skipWithWarning(`Failed to insert paragraph at pos ${pos}.`);
				return result;
			}
			result.applied += 1;
			return result;
		} catch (error) {
			skipWithWarning(`Invalid nodeJSON for added paragraph at pos ${pos}.`);
			return result;
		}
	}
	if (diff.action === "deleted") {
		const node = tr.doc.nodeAt(pos);
		if (!node) {
			skipWithWarning(`No paragraph found at pos ${pos} for deletion.`);
			return result;
		}
		if (node.type.name !== "paragraph") {
			skipWithWarning(`Node type mismatch at pos ${pos} for paragraph deletion.`);
			return result;
		}
		const step = new ReplaceStep(pos, pos + node.nodeSize, Slice.empty);
		if (tr.maybeStep(step).failed) {
			skipWithWarning(`Failed to delete paragraph at pos ${pos}.`);
			return result;
		}
		result.applied += 1;
		return result;
	}
	if (diff.action === "modified") {
		const node = tr.doc.nodeAt(pos);
		if (!node) {
			skipWithWarning(`No paragraph found at pos ${pos} for modification.`);
			return result;
		}
		if (node.type.name !== "paragraph") {
			skipWithWarning(`Node type mismatch at pos ${pos} for paragraph modification.`);
			return result;
		}
		if (diff.attrsDiff) try {
			const mergedAttrs = applyAttrsDiff(node.attrs, diff.attrsDiff);
			tr.setNodeMarkup(pos, void 0, mergedAttrs, node.marks);
			result.applied += 1;
		} catch (error) {
			skipWithWarning(`Failed to update paragraph attrs at pos ${pos}.`);
			return result;
		}
		const paragraphEndPos = pos + 1 + node.content.size;
		const contentDiffs = [...diff.contentDiff ?? []].sort((a, b$1) => {
			const aPos = a.startPos ?? paragraphEndPos;
			const bPos = b$1.startPos ?? paragraphEndPos;
			if (aPos === bPos) return 0;
			return aPos - bPos;
		});
		for (let idx = contentDiffs.length - 1; idx >= 0; idx -= 1) {
			const inlineDiff = contentDiffs[idx];
			const inlineResult = replayInlineDiff({
				tr,
				diff: inlineDiff,
				schema,
				paragraphEndPos
			});
			result.applied += inlineResult.applied;
			result.skipped += inlineResult.skipped;
			result.warnings.push(...inlineResult.warnings);
		}
		return result;
	}
	skipWithWarning(`Unsupported paragraph diff action at pos ${pos}.`);
	return result;
}
function replayDocDiffs({ tr, docDiffs, schema }) {
	const result = {
		applied: 0,
		skipped: 0,
		warnings: []
	};
	for (let idx = docDiffs.length - 1; idx >= 0; idx -= 1) {
		const diff = docDiffs[idx];
		const handlerResult = diff.nodeType === "paragraph" ? replayParagraphDiff({
			tr,
			diff,
			schema
		}) : replayNonParagraphDiff({
			tr,
			diff,
			schema
		});
		result.applied += handlerResult.applied;
		result.skipped += handlerResult.skipped;
		result.warnings.push(...handlerResult.warnings);
	}
	return result;
}
function findCommentIndexById(comments, commentId) {
	return comments.findIndex((comment) => resolveCommentId$1(comment) === commentId);
}
function cloneCommentPayload(comment) {
	return structuredClone(comment);
}
function buildReplayCommentEventPayload({ comment, commentId, editor }) {
	const payload = cloneCommentPayload(comment);
	if (!payload.commentId) payload.commentId = commentId;
	const editorDocumentId = editor?.options?.documentId != null ? String(editor.options.documentId) : null;
	if (editorDocumentId) {
		payload.documentId = editorDocumentId;
		payload.fileId = editorDocumentId;
	}
	return payload;
}
function replayCommentDiff({ comments, diff, editor }) {
	const result = {
		applied: 0,
		skipped: 0,
		warnings: []
	};
	const skipWithWarning = (message) => {
		result.skipped += 1;
		result.warnings.push(message);
	};
	if (diff.nodeType !== "comment") {
		skipWithWarning(`Non-comment diff received: ${diff.nodeType}.`);
		return result;
	}
	if (diff.action === "added") {
		if (findCommentIndexById(comments, diff.commentId) !== -1) {
			skipWithWarning(`Comment ${diff.commentId} already exists; skipping add.`);
			return result;
		}
		const storedComment = cloneCommentPayload(diff.commentJSON);
		comments.push(storedComment);
		result.applied += 1;
		const payload = buildReplayCommentEventPayload({
			comment: storedComment,
			commentId: diff.commentId,
			editor
		});
		const resolvedText = resolveCommentTextPayload({
			comment: storedComment,
			fallbackText: diff.text
		});
		if (!payload.commentText && resolvedText) payload.commentText = resolvedText;
		editor?.emit?.("commentsUpdate", {
			type: comments_module_events.ADD,
			comment: payload
		});
		return result;
	}
	if (diff.action === "deleted") {
		const existingIndex = findCommentIndexById(comments, diff.commentId);
		if (existingIndex === -1) {
			skipWithWarning(`Comment ${diff.commentId} not found; skipping delete.`);
			return result;
		}
		comments.splice(existingIndex, 1);
		result.applied += 1;
		const payload = buildReplayCommentEventPayload({
			comment: diff.commentJSON,
			commentId: diff.commentId,
			editor
		});
		editor?.emit?.("commentsUpdate", {
			type: comments_module_events.DELETED,
			comment: payload
		});
		return result;
	}
	if (diff.action === "modified") {
		const existingIndex = findCommentIndexById(comments, diff.commentId);
		if (existingIndex === -1) {
			skipWithWarning(`Comment ${diff.commentId} not found; skipping modify.`);
			return result;
		}
		const storedComment = cloneCommentPayload(diff.newCommentJSON);
		comments.splice(existingIndex, 1, storedComment);
		result.applied += 1;
		const payload = buildReplayCommentEventPayload({
			comment: storedComment,
			commentId: diff.commentId,
			editor
		});
		const resolvedText = resolveCommentTextPayload({
			comment: storedComment,
			fallbackText: diff.newText
		});
		if (!payload.commentText && resolvedText) payload.commentText = resolvedText;
		editor?.emit?.("commentsUpdate", {
			type: comments_module_events.UPDATE,
			comment: payload
		});
		return result;
	}
	skipWithWarning("Unsupported comment diff action.");
	return result;
}
function resolveCommentTextPayload({ comment, fallbackText }) {
	if (typeof comment.commentText === "string" && comment.commentText.length > 0) return comment.commentText;
	if (typeof fallbackText === "string" && fallbackText.length > 0) return fallbackText;
	const fromElements = extractStructuredCommentText(comment.elements);
	if (fromElements) return fromElements;
	const fromTextJson = extractStructuredCommentText(comment.textJson);
	if (fromTextJson) return fromTextJson;
}
function extractStructuredCommentText(value) {
	if (!value) return "";
	if (typeof value === "string") return value;
	if (Array.isArray(value)) return value.map((item) => extractStructuredCommentText(item)).join("");
	if (typeof value !== "object") return "";
	const node = value;
	return `${typeof node.text === "string" ? node.text : ""}${extractStructuredCommentText(node.content)}${extractStructuredCommentText(node.elements)}`;
}
function replayComments({ comments, commentDiffs, editor }) {
	const result = {
		applied: 0,
		skipped: 0,
		warnings: []
	};
	for (const diff of commentDiffs) {
		const diffResult = replayCommentDiff({
			comments,
			diff,
			editor
		});
		result.applied += diffResult.applied;
		result.skipped += diffResult.skipped;
		result.warnings.push(...diffResult.warnings);
	}
	return result;
}
function findStylesRoot(converter) {
	const stylesPart = converter?.convertedXml?.["word/styles.xml"];
	if (!stylesPart?.elements) return null;
	const root = stylesPart.elements.find((element) => element.name === "w:styles");
	if (!root) return null;
	if (!root.elements) root.elements = [];
	return root;
}
function replaceSingletonElement(root, name, nextNode) {
	if (!root.elements) root.elements = [];
	const existingIndex = root.elements.findIndex((element) => element.name === name);
	if (!nextNode) {
		if (existingIndex >= 0) root.elements.splice(existingIndex, 1);
		return;
	}
	if (existingIndex >= 0) {
		root.elements[existingIndex] = nextNode;
		return;
	}
	const docDefaultsIndex = root.elements.findIndex((element) => element.name === "w:docDefaults");
	const latentStylesIndex = root.elements.findIndex((element) => element.name === "w:latentStyles");
	if (name === "w:docDefaults") {
		root.elements.unshift(nextNode);
		return;
	}
	if (name === "w:latentStyles") {
		const insertIndex$1 = docDefaultsIndex >= 0 ? docDefaultsIndex + 1 : 0;
		root.elements.splice(insertIndex$1, 0, nextNode);
		return;
	}
	const insertIndex = latentStylesIndex >= 0 ? latentStylesIndex + 1 : root.elements.length;
	root.elements.splice(insertIndex, 0, nextNode);
}
function getStyleId(node) {
	const value = node?.attributes?.["w:styleId"];
	return value == null ? null : String(value);
}
function decodeStyleNode(styleDef) {
	return translator$2.decode({ node: { attrs: { style: styleDef } } });
}
function syncStylesDiffToConvertedXml(converter, stylesDiff) {
	if (!stylesDiff) return false;
	const root = findStylesRoot(converter);
	if (!root) return false;
	const translated = converter.translatedLinkedStyles ?? {};
	const translatedStyles = translated.styles ?? {};
	if (stylesDiff.docDefaultsDiff) replaceSingletonElement(root, "w:docDefaults", translator.decode({ node: { attrs: { docDefaults: translated.docDefaults } } }));
	if (stylesDiff.latentStylesDiff) replaceSingletonElement(root, "w:latentStyles", translator$1.decode({ node: { attrs: { latentStyles: translated.latentStyles ?? {} } } }));
	const removedStyleIds = new Set(Object.keys(stylesDiff.removedStyles ?? {}));
	if (removedStyleIds.size > 0 && root.elements) root.elements = root.elements.filter((element) => {
		if (element.name !== "w:style") return true;
		const styleId$1 = getStyleId(element);
		return !styleId$1 || !removedStyleIds.has(styleId$1);
	});
	const upsertStyleIds = [...Object.keys(stylesDiff.modifiedStyles ?? {}), ...Object.keys(stylesDiff.addedStyles ?? {})];
	const uniqueUpsertStyleIds = [...new Set(upsertStyleIds)];
	if (uniqueUpsertStyleIds.length === 0) return true;
	if (!root.elements) root.elements = [];
	for (const styleId$1 of uniqueUpsertStyleIds) {
		const styleDef = translatedStyles[styleId$1];
		if (!styleDef) continue;
		const nextStyleNode = decodeStyleNode(styleDef);
		if (!nextStyleNode) continue;
		const existingIndex = root.elements.findIndex((element) => element.name === "w:style" && getStyleId(element) === String(styleId$1));
		if (existingIndex >= 0) {
			root.elements[existingIndex] = nextStyleNode;
			continue;
		}
		root.elements.push(nextStyleNode);
	}
	return true;
}
function cloneValue(value) {
	if (value === null || typeof value !== "object") return value;
	return structuredClone(value);
}
function isRecord$1(value) {
	return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}
function ensureParentObject(target, pathSegments) {
	let current = target;
	for (const segment of pathSegments) {
		const next = current[segment];
		if (!isRecord$1(next)) current[segment] = {};
		current = current[segment];
	}
	return current;
}
function setByPath(target, path, value) {
	const segments = path.split(".").filter(Boolean);
	if (segments.length === 0) return;
	const leaf = segments.pop();
	const parent = ensureParentObject(target, segments);
	parent[leaf] = cloneValue(value);
}
function pruneEmptyParents(root, segments) {
	for (let idx = segments.length - 1; idx >= 0; idx -= 1) {
		const parentPath = segments.slice(0, idx);
		const currentKey = segments[idx];
		const parent = parentPath.length === 0 ? root : parentPath.reduce((acc, key) => {
			if (!acc || !isRecord$1(acc[key])) return;
			return acc[key];
		}, root) ?? void 0;
		if (!parent || !isRecord$1(parent[currentKey])) return;
		if (Object.keys(parent[currentKey]).length === 0) {
			delete parent[currentKey];
			continue;
		}
		return;
	}
}
function deleteByPath(target, path) {
	const segments = path.split(".").filter(Boolean);
	if (segments.length === 0) return;
	const leaf = segments.pop();
	const parent = segments.length === 0 ? target : segments.reduce((acc, key) => {
		if (!acc || !isRecord$1(acc[key])) return;
		return acc[key];
	}, target) ?? void 0;
	if (!parent) return;
	delete parent[leaf];
	pruneEmptyParents(target, segments);
}
function applyAttributesDiff(target, diff) {
	if (!diff) return false;
	let changed = false;
	for (const [path, value] of Object.entries(diff.added ?? {})) {
		setByPath(target, path, value);
		changed = true;
	}
	for (const [path, value] of Object.entries(diff.modified ?? {})) {
		setByPath(target, path, value.to);
		changed = true;
	}
	for (const path of Object.keys(diff.deleted ?? {})) {
		deleteByPath(target, path);
		changed = true;
	}
	return changed;
}
function ensureTranslatedStyles(editor) {
	const converter = editor.converter;
	if (!converter) return null;
	if (!converter.translatedLinkedStyles) converter.translatedLinkedStyles = {};
	if (!converter.translatedLinkedStyles.docDefaults) converter.translatedLinkedStyles.docDefaults = {};
	if (!converter.translatedLinkedStyles.latentStyles) converter.translatedLinkedStyles.latentStyles = {};
	if (!converter.translatedLinkedStyles.styles) converter.translatedLinkedStyles.styles = {};
	return converter.translatedLinkedStyles;
}
function replayStyles({ stylesDiff, editor }) {
	const result = {
		applied: 0,
		skipped: 0,
		warnings: []
	};
	if (!stylesDiff) return result;
	if (!editor?.converter) {
		result.skipped += 1;
		result.warnings.push("Style replay skipped: editor converter is unavailable.");
		return result;
	}
	const translated = ensureTranslatedStyles(editor);
	if (!translated) {
		result.skipped += 1;
		result.warnings.push("Style replay skipped: translated style state is unavailable.");
		return result;
	}
	let changed = false;
	changed = applyAttributesDiff(translated.docDefaults, stylesDiff.docDefaultsDiff) || changed;
	changed = applyAttributesDiff(translated.latentStyles, stylesDiff.latentStylesDiff) || changed;
	for (const styleId$1 of Object.keys(stylesDiff.removedStyles ?? {})) if (Object.prototype.hasOwnProperty.call(translated.styles, styleId$1)) {
		delete translated.styles[styleId$1];
		changed = true;
	}
	for (const [styleId$1, styleDef] of Object.entries(stylesDiff.addedStyles ?? {})) {
		translated.styles[styleId$1] = structuredClone(styleDef);
		changed = true;
	}
	for (const [styleId$1, diff] of Object.entries(stylesDiff.modifiedStyles ?? {})) {
		const styleTarget = translated.styles?.[styleId$1];
		if (!styleTarget) {
			result.skipped += 1;
			result.warnings.push(`Style replay skipped for "${styleId$1}": style was not found in translated styles.`);
			continue;
		}
		changed = applyAttributesDiff(styleTarget, diff) || changed;
	}
	if (!changed) return result;
	syncStylesDiffToConvertedXml(editor.converter, stylesDiff);
	editor.converter.documentModified = true;
	if (typeof editor.converter.promoteToGuid === "function") editor.converter.promoteToGuid();
	editor.emit?.("stylesDefaultsChanged");
	result.applied += 1;
	return result;
}
function ensureTranslatedNumbering(editor) {
	const converter = editor.converter;
	if (!converter) return null;
	if (!converter.translatedNumbering) converter.translatedNumbering = {};
	if (!converter.translatedNumbering.abstracts) converter.translatedNumbering.abstracts = {};
	if (!converter.translatedNumbering.definitions) converter.translatedNumbering.definitions = {};
	return converter.translatedNumbering;
}
function replayNumbering({ numberingDiff, editor }) {
	const result = {
		applied: 0,
		skipped: 0,
		warnings: []
	};
	if (!numberingDiff) return result;
	if (!editor?.converter) {
		result.skipped += 1;
		result.warnings.push("Numbering replay skipped: editor converter is unavailable.");
		return result;
	}
	const translated = ensureTranslatedNumbering(editor);
	if (!translated) {
		result.skipped += 1;
		result.warnings.push("Numbering replay skipped: translated numbering state is unavailable.");
		return result;
	}
	if (!applyAttributesDiff(translated, numberingDiff)) return result;
	const { skipped } = rebuildRawNumberingFromTranslated(editor);
	if (skipped > 0) result.warnings.push(`Numbering replay rebuilt with ${skipped} skipped translated numbering entries.`);
	editor.converter.documentModified = true;
	if (typeof editor.converter.promoteToGuid === "function") editor.converter.promoteToGuid();
	editor.emit?.("list-definitions-change", {
		change: { type: "replay-numbering" },
		numbering: editor.converter.numbering,
		editor
	});
	result.applied += 1;
	return result;
}
var HEADER_RELATIONSHIP_TYPE$2 = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header";
var FOOTER_RELATIONSHIP_TYPE$2 = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer";
function replayHeaderFooters({ tr, headerFootersDiff, schema, editor, trackedChangesRequested = false }) {
	const result = {
		applied: 0,
		skipped: 0,
		warnings: []
	};
	if (!headerFootersDiff) return result;
	if (!editor?.converter) {
		result.skipped += 1;
		result.warnings.push("Header/footer replay skipped: editor converter is unavailable.");
		return result;
	}
	if (trackedChangesRequested) result.warnings.push("Header/footer replay applied directly because tracked header/footer replay is not supported.");
	ensureHeaderFooterCollections(editor.converter);
	for (const part of headerFootersDiff.addedParts) {
		createHeaderFooterPart$1(editor.converter, schema, part);
		result.applied += 1;
	}
	for (const part of headerFootersDiff.modifiedParts) {
		if (applyHeaderFooterPartContent(editor.converter, schema, part.refId, part.kind, part.oldPartPath, part.partPath, part.docDiffs)) {
			result.applied += 1;
			continue;
		}
		result.skipped += 1;
		result.warnings.push(`Header/footer replay skipped for "${part.refId}": stored part content was not found.`);
	}
	let slotChangesApplied = 0;
	for (const slot of headerFootersDiff.slotChanges) {
		if (applyHeaderFooterSlotChange(tr, editor, slot)) {
			result.applied += 1;
			slotChangesApplied += 1;
			continue;
		}
		result.skipped += 1;
		result.warnings.push(`Header/footer replay skipped for section "${slot.sectionId}": section projection was not found.`);
	}
	if (slotChangesApplied > 0) syncTitlePageCache(tr, editor);
	for (const part of headerFootersDiff.removedParts) {
		deleteHeaderFooterPart(editor.converter, part);
		result.applied += 1;
	}
	if (result.applied > 0) {
		tr.setMeta("forceUpdatePagination", true);
		editor.converter.headerFooterModified = true;
		editor.converter.documentModified = true;
		const changedParts = [];
		if (headerFootersDiff.addedParts.length > 0 || headerFootersDiff.removedParts.length > 0 || headerFootersDiff.slotChanges.length > 0) changedParts.push({
			partId: "word/_rels/document.xml.rels",
			operation: "mutate",
			changedPaths: []
		});
		for (const part of headerFootersDiff.addedParts) changedParts.push({
			partId: part.partPath,
			sectionId: part.refId,
			operation: "create",
			changedPaths: []
		});
		for (const part of headerFootersDiff.modifiedParts) {
			if (part.oldPartPath !== part.partPath) {
				changedParts.push({
					partId: part.oldPartPath,
					sectionId: part.refId,
					operation: "delete",
					changedPaths: []
				});
				changedParts.push({
					partId: part.partPath,
					sectionId: part.refId,
					operation: "create",
					changedPaths: []
				});
				continue;
			}
			changedParts.push({
				partId: part.partPath,
				sectionId: part.refId,
				operation: "mutate",
				changedPaths: []
			});
		}
		for (const part of headerFootersDiff.removedParts) changedParts.push({
			partId: part.partPath,
			sectionId: part.refId,
			operation: "delete",
			changedPaths: []
		});
		editor.emit?.("partChanged", {
			parts: changedParts,
			source: "diff-replay"
		});
	}
	return result;
}
function ensureHeaderFooterCollections(converter) {
	if (!converter.headers) converter.headers = {};
	if (!converter.footers) converter.footers = {};
	if (!converter.headerIds) converter.headerIds = {};
	if (!converter.footerIds) converter.footerIds = {};
	if (!converter.convertedXml) converter.convertedXml = {};
}
function createHeaderFooterPart$1(converter, schema, part) {
	const partCollection = part.kind === "header" ? converter.headers : converter.footers;
	partCollection[part.refId] = structuredClone(part.content);
	const variantIds = part.kind === "header" ? converter.headerIds : converter.footerIds;
	if (!Array.isArray(variantIds.ids)) variantIds.ids = [];
	if (!variantIds.ids.includes(part.refId)) variantIds.ids.push(part.refId);
	upsertRelationshipEntry(converter.convertedXml, part);
	ensureXmlPartExists(converter.convertedXml, part);
	syncHeaderFooterPartXml(converter, schema, part.kind, part.refId, part.content);
}
function applyHeaderFooterPartContent(converter, schema, refId, kind, oldPartPath, partPath, docDiffs) {
	const collection = kind === "header" ? converter.headers : converter.footers;
	const currentJson = collection[refId];
	if (!currentJson || typeof currentJson !== "object") return false;
	let nextJson = currentJson;
	if (docDiffs.length > 0) {
		const partTr = EditorState.create({
			schema,
			doc: schema.nodeFromJSON(currentJson)
		}).tr;
		if (replayDocDiffs({
			tr: partTr,
			docDiffs,
			schema
		}).skipped > 0) return false;
		nextJson = partTr.doc.toJSON();
		collection[refId] = nextJson;
	}
	updateHeaderFooterPartPath(converter, {
		refId,
		kind,
		oldPartPath,
		partPath
	});
	syncHeaderFooterPartXml(converter, schema, kind, refId, nextJson);
	return true;
}
function applyHeaderFooterSlotChange(tr, editor, slot) {
	const projectionEditor = {
		...editor,
		state: {
			...editor.state,
			doc: tr.doc
		}
	};
	const projection = resolveSectionProjections(projectionEditor).find((entry) => entry.sectionId === slot.sectionId);
	if (!projection) return false;
	const nextSectPr = ensureSectPrElement(readTargetSectPr(projectionEditor, projection));
	writeSectPrTitlePage(nextSectPr, slot.titlePg);
	applySlotRefs(nextSectPr, "header", slot.header);
	applySlotRefs(nextSectPr, "footer", slot.footer);
	syncVariantIdCaches(editor.converter, slot);
	if (projection.target.kind === "paragraph") {
		const paragraph = tr.doc.nodeAt(projection.target.pos);
		if (!paragraph) return false;
		const attrs = paragraph.attrs ?? {};
		const nextAttrs = {
			...attrs,
			paragraphProperties: {
				...attrs.paragraphProperties ?? {},
				sectPr: nextSectPr
			},
			pageBreakSource: "sectPr",
			sectionMargins: readSectPrMargins(nextSectPr)
		};
		tr.setNodeMarkup(projection.target.pos, void 0, nextAttrs, paragraph.marks);
		return true;
	}
	tr.setDocAttribute("bodySectPr", nextSectPr);
	syncBodySectPrConverterCache(editor.converter, nextSectPr);
	return true;
}
function applySlotRefs(sectPr, kind, refs) {
	for (const variant of SLOT_VARIANTS) {
		clearSectPrHeaderFooterRef(sectPr, kind, variant);
		if (refs[variant]) setSectPrHeaderFooterRef(sectPr, kind, variant, refs[variant]);
	}
}
function syncVariantIdCaches(converter, slot) {
	const headerIds = converter.headerIds ??= {};
	const footerIds = converter.footerIds ??= {};
	for (const variant of SLOT_VARIANTS) {
		headerIds[variant] = slot.header[variant] ?? null;
		footerIds[variant] = slot.footer[variant] ?? null;
	}
}
function syncBodySectPrConverterCache(converter, sectPr) {
	converter.bodySectPr = cloneXmlElement(sectPr);
	const savedBodyNode = converter.savedTagsToRestore?.find((entry) => entry?.name === "w:body");
	if (!savedBodyNode || !Array.isArray(savedBodyNode.elements)) return;
	const preservedChildren = savedBodyNode.elements.filter((entry) => entry?.name !== "w:sectPr");
	preservedChildren.push(cloneXmlElement(sectPr));
	savedBodyNode.elements = preservedChildren;
}
function syncTitlePageCache(tr, editor) {
	if (!editor.converter) return;
	if (!editor.converter.headerIds) editor.converter.headerIds = {};
	if (!editor.converter.footerIds) editor.converter.footerIds = {};
	const hasTitlePage = resolveSectionProjections({
		...editor,
		state: {
			...editor.state,
			doc: tr.doc
		}
	}).some((entry) => entry.range.titlePg === true);
	editor.converter.headerIds.titlePg = hasTitlePage;
	editor.converter.footerIds.titlePg = hasTitlePage;
}
function deleteHeaderFooterPart(converter, part) {
	const collection = part.kind === "header" ? converter.headers : converter.footers;
	delete collection[part.refId];
	const variantIds = part.kind === "header" ? converter.headerIds : converter.footerIds;
	if (Array.isArray(variantIds.ids)) variantIds.ids = variantIds.ids.filter((value) => value !== part.refId);
	for (const key of [
		"default",
		"first",
		"even",
		"odd"
	]) if (variantIds[key] === part.refId) variantIds[key] = null;
	removeRelationshipEntry(converter.convertedXml, part.refId);
	delete converter.convertedXml[part.partPath];
	const relsPath = toRelsPathForPart(part.partPath);
	if (relsPath) delete converter.convertedXml[relsPath];
}
function updateHeaderFooterPartPath(converter, part) {
	upsertRelationshipEntry(converter.convertedXml, {
		refId: part.refId,
		kind: part.kind,
		partPath: part.partPath,
		content: {
			type: "doc",
			content: []
		}
	});
	if (part.oldPartPath === part.partPath) {
		ensureXmlPartExists(converter.convertedXml, {
			refId: part.refId,
			kind: part.kind,
			partPath: part.partPath,
			content: {
				type: "doc",
				content: []
			}
		});
		return;
	}
	const previousXml = converter.convertedXml[part.oldPartPath];
	if (previousXml) {
		converter.convertedXml[part.partPath] = previousXml;
		delete converter.convertedXml[part.oldPartPath];
	} else ensureXmlPartExists(converter.convertedXml, {
		refId: part.refId,
		kind: part.kind,
		partPath: part.partPath,
		content: {
			type: "doc",
			content: []
		}
	});
	const oldRelsPath = toRelsPathForPart(part.oldPartPath);
	const nextRelsPath = toRelsPathForPart(part.partPath);
	if (oldRelsPath && nextRelsPath && oldRelsPath !== nextRelsPath) {
		const previousRels = converter.convertedXml[oldRelsPath];
		if (previousRels) {
			converter.convertedXml[nextRelsPath] = previousRels;
			delete converter.convertedXml[oldRelsPath];
		}
	}
}
function upsertRelationshipEntry(convertedXml, part) {
	const relsRoot = ensureRelationshipsRoot(convertedXml);
	const target = part.partPath.replace(/^word\//, "");
	const type = part.kind === "header" ? HEADER_RELATIONSHIP_TYPE$2 : FOOTER_RELATIONSHIP_TYPE$2;
	const existing = relsRoot.elements.find((entry) => entry.name === "Relationship" && entry.attributes?.Id === part.refId);
	if (existing) {
		existing.attributes = {
			...existing.attributes ?? {},
			Id: part.refId,
			Type: type,
			Target: target
		};
		return;
	}
	relsRoot.elements.push({
		name: "Relationship",
		attributes: {
			Id: part.refId,
			Type: type,
			Target: target
		},
		elements: []
	});
}
function removeRelationshipEntry(convertedXml, refId) {
	const relsRoot = convertedXml["word/_rels/document.xml.rels"]?.elements?.find((entry) => entry.name === "Relationships");
	if (!relsRoot?.elements) return;
	relsRoot.elements = relsRoot.elements.filter((entry) => !(entry.name === "Relationship" && entry.attributes?.Id === refId));
}
function ensureXmlPartExists(convertedXml, part) {
	if (convertedXml[part.partPath]) return;
	convertedXml[part.partPath] = {
		type: "element",
		name: "document",
		elements: [{
			type: "element",
			name: part.kind === "header" ? "w:hdr" : "w:ftr",
			attributes: getHeaderFooterRootAttributes(convertedXml, part.kind),
			elements: []
		}]
	};
}
function syncHeaderFooterPartXml(converter, schema, kind, refId, content) {
	const partPath = findPartPathByRefId(converter.convertedXml, refId);
	if (!partPath) return;
	ensureXmlPartExists(converter.convertedXml, {
		refId,
		kind,
		partPath,
		content: {
			type: "doc",
			content: []
		}
	});
	const exported = converter.exportToXmlJson?.({
		data: content,
		editor: {
			schema,
			getUpdatedJson: () => content
		},
		editorSchema: schema,
		isHeaderFooter: true,
		comments: [],
		commentDefinitions: []
	});
	const root = converter.convertedXml[partPath];
	if (!root?.elements?.[0]) return;
	root.elements[0].attributes = {
		...getHeaderFooterRootAttributes(converter.convertedXml, kind),
		...root.elements[0].attributes ?? {}
	};
	if (exported?.result?.elements?.[0]?.elements) root.elements[0].elements = exported.result.elements[0].elements;
}
function getHeaderFooterRootAttributes(convertedXml, kind) {
	const existingAttributes = findExistingHeaderFooterRootAttributes(convertedXml, kind);
	return {
		...DEFAULT_DOCX_DEFS,
		...existingAttributes ?? {}
	};
}
function findExistingHeaderFooterRootAttributes(convertedXml, kind) {
	const rootName = kind === "header" ? "w:hdr" : "w:ftr";
	for (const value of Object.values(convertedXml)) {
		const root = value?.elements?.[0];
		if (root?.name !== rootName || !root.attributes) continue;
		return root.attributes;
	}
	return null;
}
function findPartPathByRefId(convertedXml, refId) {
	const target = ((convertedXml["word/_rels/document.xml.rels"]?.elements?.find((entry) => entry.name === "Relationships"))?.elements?.find((entry) => entry.name === "Relationship" && entry.attributes?.Id === refId))?.attributes?.Target;
	if (!target) return null;
	return normalizePartPath(target);
}
function ensureRelationshipsRoot(convertedXml) {
	if (!convertedXml["word/_rels/document.xml.rels"]) convertedXml["word/_rels/document.xml.rels"] = {
		type: "element",
		name: "document",
		elements: []
	};
	const relsPart = convertedXml["word/_rels/document.xml.rels"];
	if (!relsPart.elements) relsPart.elements = [];
	let relsRoot = relsPart.elements.find((entry) => entry.name === "Relationships");
	if (!relsRoot) {
		relsRoot = {
			name: "Relationships",
			attributes: { xmlns: "http://schemas.openxmlformats.org/package/2006/relationships" },
			elements: []
		};
		relsPart.elements.push(relsRoot);
	}
	if (!relsRoot.elements) relsRoot.elements = [];
	return relsRoot;
}
function replayPartsDiff({ partsDiff, editor }) {
	const result = {
		applied: 0,
		skipped: 0,
		warnings: []
	};
	if (!partsDiff) return result;
	if (!editor?.converter?.convertedXml) {
		result.skipped += 1;
		result.warnings.push("Parts replay skipped: editor converter is unavailable.");
		return result;
	}
	editor.options ??= {};
	editor.options.mediaFiles ??= {};
	const optionMediaStore = editor.options.mediaFiles;
	editor.storage ??= {};
	editor.storage.image ??= {};
	editor.storage.image.media ??= {};
	const storageMediaStore = editor.storage.image.media;
	const changedParts = [];
	for (const [partPath, snapshot] of Object.entries(partsDiff.upserts)) {
		if (snapshot.kind === "xml") {
			const operation = partPath in editor.converter.convertedXml ? "mutate" : "create";
			editor.converter.convertedXml[partPath] = structuredClone(snapshot.content);
			changedParts.push({
				partId: partPath,
				operation,
				changedPaths: []
			});
		} else {
			const operation = partPath in optionMediaStore || partPath in storageMediaStore || partPath in editor.converter.convertedXml ? "mutate" : "create";
			const value = structuredClone(snapshot.content);
			optionMediaStore[partPath] = value;
			storageMediaStore[partPath] = structuredClone(value);
			if (partPath.startsWith("word/media/") && typeof value === "string") editor.commands?.addImageToCollaboration?.({
				mediaPath: partPath,
				fileData: value
			});
			changedParts.push({
				partId: partPath,
				operation,
				changedPaths: []
			});
		}
		result.applied += 1;
	}
	for (const partPath of partsDiff.deletes) {
		if (partPath in editor.converter.convertedXml) {
			delete editor.converter.convertedXml[partPath];
			changedParts.push({
				partId: partPath,
				operation: "delete",
				changedPaths: []
			});
			result.applied += 1;
			continue;
		}
		const hadOptionMedia = partPath in optionMediaStore;
		const hadStorageMedia = partPath in storageMediaStore;
		if (hadOptionMedia) delete optionMediaStore[partPath];
		if (hadStorageMedia) delete storageMediaStore[partPath];
		if (hadOptionMedia || hadStorageMedia) {
			changedParts.push({
				partId: partPath,
				operation: "delete",
				changedPaths: []
			});
			result.applied += 1;
		}
	}
	if (changedParts.length > 0) {
		editor.converter.documentModified = true;
		editor.emit?.("partChanged", {
			parts: changedParts,
			source: "diff-replay"
		});
	}
	return {
		applied: result.applied,
		skipped: result.skipped,
		warnings: result.warnings
	};
}
function replayDiffs({ tr, diff, schema, comments = [], editor, trackedChangesRequested = false }) {
	const docReplay = replayDocDiffs({
		tr,
		docDiffs: diff.docDiffs,
		schema
	});
	const commentsReplay = replayComments({
		comments,
		commentDiffs: diff.commentDiffs,
		editor
	});
	const stylesReplay = replayStyles({
		stylesDiff: diff.stylesDiff,
		editor
	});
	const numberingReplay = replayNumbering({
		numberingDiff: diff.numberingDiff,
		editor
	});
	const headerFootersReplay = replayHeaderFooters({
		tr,
		headerFootersDiff: diff.headerFootersDiff,
		schema,
		editor,
		trackedChangesRequested
	});
	const partsReplay = replayPartsDiff({
		partsDiff: diff.partsDiff,
		editor
	});
	return {
		tr,
		appliedDiffs: docReplay.applied + commentsReplay.applied + stylesReplay.applied + numberingReplay.applied + headerFootersReplay.applied + partsReplay.applied,
		skippedDiffs: docReplay.skipped + commentsReplay.skipped + stylesReplay.skipped + numberingReplay.skipped + headerFootersReplay.skipped + partsReplay.skipped,
		warnings: [
			...docReplay.warnings,
			...commentsReplay.warnings,
			...stylesReplay.warnings,
			...numberingReplay.warnings,
			...headerFootersReplay.warnings,
			...partsReplay.warnings
		]
	};
}
const Diffing = Extension.create({
	name: "documentDiffing",
	addCommands() {
		return {
			compareDocuments: (targetEditor) => ({ state, tr }) => {
				tr.setMeta("preventDispatch", true);
				const updatedDocument = targetEditor.state.doc;
				const currentComments = this.editor.converter?.comments ?? [];
				const nextComments = targetEditor.converter?.comments ?? currentComments;
				const currentStyles = this.editor.converter?.translatedLinkedStyles ?? null;
				const nextStyles = targetEditor.converter?.translatedLinkedStyles ?? currentStyles;
				const currentNumbering = this.editor.converter?.translatedNumbering ?? null;
				const nextNumbering = targetEditor.converter?.translatedNumbering ?? currentNumbering;
				const currentHeaderFooters = captureHeaderFooterState(this.editor);
				const currentPartsState = capturePartsState(this.editor, currentHeaderFooters);
				const nextHeaderFooters = captureHeaderFooterState(targetEditor);
				const nextPartsState = capturePartsState(targetEditor, nextHeaderFooters);
				return computeDiff(state.doc, updatedDocument, state.schema, currentComments, nextComments, currentStyles, nextStyles, currentNumbering, nextNumbering, currentHeaderFooters, nextHeaderFooters, currentPartsState, nextPartsState);
			},
			replayDifferences: (diff, { applyTrackedChanges = true } = {}) => ({ state, dispatch }) => {
				if (!dispatch) return true;
				const comments = this.editor.converter ? Array.isArray(this.editor.converter.comments) ? this.editor.converter.comments : this.editor.converter.comments = [] : [];
				const tr = state.tr;
				const canApplyTrackedChanges = applyTrackedChanges && Boolean(this.editor.options.user);
				if (canApplyTrackedChanges) tr.setMeta("inputType", "programmatic");
				const replayResult = replayDiffs({
					tr,
					diff,
					schema: state.schema,
					comments,
					editor: this.editor,
					trackedChangesRequested: canApplyTrackedChanges
				});
				if (canApplyTrackedChanges) tr.setMeta("forceTrackChanges", true);
				else tr.setMeta("skipTrackChanges", true);
				if (dispatch && (tr.docChanged || replayResult.appliedDiffs > 0)) dispatch(tr);
				this.editor.emit("commentsUpdate", { type: "replayCompleted" });
				return true;
			}
		};
	}
});
var getRichTextExtensions = () => {
	return [
		Bold,
		Color,
		Document$1,
		FontFamily,
		FontSize,
		LetterSpacing,
		History,
		Heading,
		Italic,
		Link,
		Paragraph,
		TableOfContents,
		DocumentIndex,
		Strike,
		Text$2,
		TextAlign,
		TextStyle,
		Underline,
		Placeholder,
		PopoverPlugin,
		Mention,
		Highlight,
		FormatCommands,
		Table,
		TableRow,
		TableCell,
		TableHeader,
		FieldAnnotation,
		DropCursor,
		TrackInsert,
		TrackDelete,
		TrackFormat,
		AiPlugin,
		Image,
		NodeResizer,
		CustomSelection,
		MixedBidiBackspace,
		MathInline,
		MathBlock,
		PassthroughInline,
		PassthroughBlock
	];
};
var getStarterExtensions = () => {
	return [
		Bold,
		BlockNode,
		Color,
		CommentRangeStart,
		CommentRangeEnd,
		CommentReference,
		FootnoteReference,
		EndnoteReference,
		Document$1,
		FontFamily,
		FontSize,
		LetterSpacing,
		History,
		Heading,
		Italic,
		Link,
		Paragraph,
		LineBreak,
		HardBreak,
		Run,
		ContextMenu,
		Strike,
		TabNode,
		NoBreakHyphenNode,
		TableOfContents,
		TocPageNumber,
		DocumentIndex,
		Text$2,
		TextAlign,
		TextStyle,
		Underline,
		FormatCommands,
		CommentsPlugin,
		Gapcursor,
		Table,
		TableRow,
		TableCell,
		TableHeader,
		FieldAnnotation,
		DropCursor,
		Image,
		BookmarkStart,
		BookmarkEnd,
		SmartTag,
		Mention,
		Collaboration,
		CollaborationCursor,
		TrackChanges,
		TrackInsert,
		TrackDelete,
		TrackFormat,
		CommentsMark,
		Highlight,
		LinkedStyles,
		AiPlugin,
		AiMark,
		AiAnimationMark,
		AiLoaderNode,
		PageNumber,
		TotalPageCount,
		SectionPageCount,
		PageReference,
		IndexEntry,
		TableOfContentsEntry,
		CrossReference,
		SequenceField,
		DocumentStatField,
		FieldUpdate,
		Citation,
		Bibliography,
		AuthorityEntry,
		TableOfAuthorities,
		ShapeContainer,
		ShapeTextbox,
		ContentBlock,
		Search,
		StructuredContent,
		StructuredContentBlock,
		StructuredContentCommands,
		DocumentSection,
		DocumentPartObject,
		NodeResizer,
		CustomSelection,
		TextTransform,
		VectorShape,
		ShapeGroup,
		Chart,
		PermStart,
		PermEnd,
		PermStartBlock,
		PermEndBlock,
		PermissionRanges,
		Protection,
		VerticalNavigation,
		MixedBidiBackspace,
		MathInline,
		MathBlock,
		PassthroughInline,
		PassthroughBlock,
		Diffing
	];
};
var sanitizeNumber = (value, defaultNumber) => {
	let sanitized = value.replace(/[^0-9.]/g, "");
	sanitized = parseFloat(sanitized);
	if (isNaN(sanitized)) sanitized = defaultNumber;
	sanitized = parseFloat(sanitized);
	return sanitized;
};
var throttle = (func, wait, options) => {
	let timeout$1, args$1, result;
	let previous = 0;
	if (!options) options = {};
	const later = () => {
		previous = options.leading === false ? 0 : Date.now();
		timeout$1 = null;
		result = func(...args$1);
		if (!timeout$1) args$1 = null;
	};
	const throttled = (...callArgs) => {
		const _now = Date.now();
		if (!previous && options.leading === false) previous = _now;
		const remaining = wait - (_now - previous);
		args$1 = callArgs;
		if (remaining <= 0 || remaining > wait) {
			if (timeout$1) {
				clearTimeout(timeout$1);
				timeout$1 = null;
			}
			previous = _now;
			result = func(...callArgs);
			if (!timeout$1) args$1 = null;
		} else if (!timeout$1 && options.trailing !== false) timeout$1 = setTimeout(later, remaining);
		return result;
	};
	throttled.cancel = function() {
		clearTimeout(timeout$1);
		previous = 0;
		timeout$1 = args$1 = null;
	};
	return throttled;
};
const normalizeFontOption = (option) => {
	if (!option) return option;
	const fontFamily = option.props?.style?.fontFamily ?? option.key ?? option.label;
	return {
		...option,
		props: {
			...option.props,
			style: {
				...option.props?.style,
				fontFamily
			},
			"data-item": option.props?.["data-item"] ?? "btn-fontFamily-option"
		}
	};
};
const useToolbarItem = (options) => {
	if (![
		"button",
		"options",
		"separator",
		"dropdown",
		"overflow"
	].includes(options.type)) throw new Error("Invalid toolbar item type - " + options.type);
	if (options.type === "button" && !options.defaultLabel && !options.icon) throw new Error("Toolbar button item needs either icon or label - " + options.name);
	if (!options.name) throw new Error("Invalid toolbar item name - " + options.name);
	const id = ref(v4_default());
	const type = options.type;
	const name = ref(options.name);
	const command$1 = options.command;
	const noArgumentCommand = options.noArgumentCommand;
	const icon = ref(options.icon);
	const group = ref(options.group || "center");
	const allowWithoutEditor = ref(options.allowWithoutEditor);
	const attributes = ref(options.attributes || {});
	const initiallyDisabled = options.disabled || false;
	const disabled = ref(options.disabled);
	const active = ref(false);
	const expand = ref(false);
	const style = ref(options.style);
	const isNarrow = ref(options.isNarrow);
	const isWide = ref(options.isWide);
	const minWidth = ref(options.minWidth);
	const suppressActiveHighlight = ref(options.suppressActiveHighlight || false);
	const argument = ref(options.argument);
	const childItem = ref(null);
	const parentItem = ref(null);
	const iconColor = ref(options.iconColor);
	const hasCaret = ref(options.hasCaret);
	const splitButton = ref(Boolean(options.splitButton));
	const splitButtonCommand = options.splitButtonCommand;
	const restoreEditorFocus = Boolean(options.restoreEditorFocus);
	const dropdownStyles = ref(options.dropdownStyles);
	const tooltip = ref(options.tooltip);
	const tooltipVisible = ref(options.tooltipVisible);
	const tooltipTimeout = ref(options.tooltipTimeout);
	const defaultLabel = ref(options.defaultLabel);
	const label = ref(options.label);
	const hideLabel = ref(options.hideLabel);
	const inlineTextInputVisible = ref(options.inlineTextInputVisible);
	const hasInlineTextInput = ref(options.hasInlineTextInput);
	const markName = ref(options.markName);
	const labelAttr = ref(options.labelAttr);
	const selectedValue = ref(options.selectedValue);
	const dropdownValueKey = ref(options.dropdownValueKey);
	const inputRef = ref(options.inputRef || null);
	const nestedOptions = ref([]);
	if (options.options) {
		if (!Array.isArray(options.options)) throw new Error("Invalid toolbar item options - " + options.options);
		nestedOptions.value?.push(...options.options);
	}
	const activate = (attrs = {}, ...args$1) => {
		onActivate(attrs, ...args$1);
		if (suppressActiveHighlight.value) return;
		active.value = true;
	};
	const deactivate = () => {
		onDeactivate();
		active.value = false;
	};
	const setDisabled = (state) => {
		disabled.value = state;
	};
	const resetDisabled = () => {
		disabled.value = initiallyDisabled;
	};
	const onActivate = options.onActivate || (() => null);
	const onDeactivate = options.onDeactivate || (() => null);
	const unref$1 = () => {
		const flattened = {};
		Object.keys(refs).forEach((key) => {
			if (refs[key].value !== void 0) flattened[key] = refs[key].value;
		});
		return flattened;
	};
	const refs = {
		id,
		name,
		type,
		command: command$1,
		noArgumentCommand,
		icon,
		tooltip,
		group,
		attributes,
		disabled,
		active,
		expand,
		nestedOptions,
		style,
		isNarrow,
		isWide,
		minWidth,
		argument,
		parentItem,
		iconColor,
		hasCaret,
		splitButton,
		splitButtonCommand,
		dropdownStyles,
		tooltipVisible,
		tooltipTimeout,
		defaultLabel,
		label,
		hideLabel,
		inlineTextInputVisible,
		hasInlineTextInput,
		restoreEditorFocus,
		markName,
		labelAttr,
		childItem,
		allowWithoutEditor,
		dropdownValueKey,
		selectedValue,
		inputRef
	};
	return {
		...refs,
		unref: unref$1,
		activate,
		deactivate,
		setDisabled,
		resetDisabled,
		onActivate,
		onDeactivate
	};
};
var DEFAULT_API_ENDPOINT = "https://sd-dev-express-gateway-i6xtm.ondigitalocean.app/insights";
var SYSTEM_PROMPT = "You are an expert copywriter and you are immersed in a document editor. You are to provide document related text responses based on the user prompts. Only write what is asked for. Do not provide explanations. Try to keep placeholders as short as possible. Do not output your prompt. Your instructions are: ";
async function baseInsightsFetch(payload, options = {}) {
	const apiKey = options.apiKey;
	const apiEndpoint = options.endpoint || DEFAULT_API_ENDPOINT;
	try {
		const headers = { "Content-Type": "application/json" };
		if (apiKey) headers["x-api-key"] = apiKey;
		const response = await fetch(apiEndpoint, {
			method: "POST",
			headers,
			body: JSON.stringify(payload)
		});
		if (!response.ok) {
			const errorText = await response.text();
			throw new Error(`Harbour API error: ${response.status} - ${errorText}`);
		}
		return response;
	} catch (error) {
		console.error("Error calling Harbour API:", error);
		throw error;
	}
}
async function processStream(stream, onChunk, onDone) {
	const reader = stream.getReader();
	const decoder = new TextDecoder();
	let result = "";
	let buffer = "";
	try {
		while (true) {
			const { done, value } = await reader.read();
			if (done) {
				if (typeof onDone === "function") onDone();
				break;
			}
			const chunk = decoder.decode(value, { stream: true });
			if (typeof onChunk === "function") onChunk(chunk);
		}
		let extractedValue = getJsonBetweenFencesFromResponse(buffer);
		if (extractedValue !== null) result = extractedValue;
		return result || "";
	} catch (error) {
		console.error("Error reading stream:", error);
		throw error;
	} finally {
		reader.releaseLock();
	}
}
function getJsonBetweenFencesFromResponse(buffer) {
	try {
		const match$1 = buffer.match(/```json\s*\n([\s\S]*?)\n\s*```/);
		if (match$1 && match$1[1]) {
			const jsonObj = JSON.parse(match$1[1]);
			if (jsonObj.custom_prompt && jsonObj.custom_prompt.value !== void 0) return jsonObj.custom_prompt.value || "";
		}
		return null;
	} catch {
		return null;
	}
}
async function writeStreaming(prompt, options = {}, onChunk, onDone) {
	if (!prompt) throw new Error("Prompt is required for text generation");
	const payload = {
		stream: true,
		context: SYSTEM_PROMPT,
		doc_text: "",
		insights: [{
			type: "custom_prompt",
			name: "text_generation",
			message: `Generate text based on the following prompt: ${prompt}`
		}]
	};
	if (options.documentXml) payload.document_content = options.documentXml;
	const response = await baseInsightsFetch(payload, options.config || {});
	if (!response.body) return "";
	return await processStream(response.body, onChunk, onDone);
}
async function rewriteStreaming(text, prompt = "", options = {}, onChunk, onDone) {
	if (!text) throw new Error("Text is required for rewriting");
	const response = await baseInsightsFetch({
		stream: true,
		context: SYSTEM_PROMPT,
		insights: [{
			type: "custom_prompt",
			name: "text_rewrite",
			message: prompt ? `Rewrite the following text: "${text}" using these instructions: ${prompt}` : `Rewrite the following text: "${text}"`
		}]
	}, options.config || {});
	if (!response.body) return "";
	return await processStream(response.body, onChunk, onDone);
}
var formatRegistry = { rules: [
	{
		name: "bold",
		pattern: /\*\*(.*?)\*\*/g,
		transform: (_match, content) => ({
			type: "text",
			marks: [{ type: "bold" }],
			text: content
		})
	},
	{
		name: "italic",
		pattern: /\*(.*?)\*/g,
		transform: (_match, content) => ({
			type: "text",
			marks: [{ type: "italic" }],
			text: content
		})
	},
	{
		name: "underline",
		pattern: /<(?:u|ins)>(.*?)<\/(?:u|ins)>/g,
		transform: (_match, content) => ({
			type: "text",
			marks: [{ type: "underline" }],
			text: content
		})
	}
] };
function formatDocument(editor) {
	try {
		let doc$1 = editor.state.doc;
		const docText = doc$1.textContent || "";
		if (!docText) return;
		formatRegistry.rules.forEach((rule) => {
			rule.pattern.lastIndex = 0;
			const matches = [];
			let match$1;
			while ((match$1 = rule.pattern.exec(docText)) !== null) matches.push({
				rule,
				startPos: match$1.index,
				endPos: match$1.index + match$1[0].length,
				originalText: match$1[0],
				contentText: match$1[1]
			});
			matches.sort((a, b$1) => b$1.startPos - a.startPos);
			for (const match$2 of matches) {
				const { startPos, endPos, originalText, contentText } = match$2;
				try {
					let tr = editor.state.tr;
					const replacement = rule.transform(originalText, contentText, editor);
					const nodesInRange = [];
					doc$1.nodesBetween(startPos, Math.min(endPos, doc$1.content.size), (node, pos) => {
						if (node.isText) nodesInRange.push({
							node,
							pos
						});
						return true;
					});
					if (nodesInRange.length > 0) {
						let foundExactMatch = false;
						let actualStartPos = -1;
						let actualEndPos = -1;
						for (let i = 0; i < nodesInRange.length; i++) {
							const nodeInfo = nodesInRange[i];
							const nodeText = nodeInfo.node.text || "";
							const nodePos = nodeInfo.pos;
							if (nodeText.includes(originalText)) {
								actualStartPos = nodePos + nodeText.indexOf(originalText);
								actualEndPos = actualStartPos + originalText.length;
								foundExactMatch = true;
								break;
							}
						}
						if (!foundExactMatch) {
							let combinedText = "";
							let offsets = [];
							let basePos = nodesInRange[0].pos;
							for (const nodeInfo of nodesInRange) {
								const nodeText = nodeInfo.node.text || "";
								const relativePos = nodeInfo.pos - basePos;
								for (let i = 0; i < nodeText.length; i++) offsets.push(relativePos + i);
								combinedText += nodeText;
							}
							const matchIndex = combinedText.indexOf(originalText);
							if (matchIndex >= 0) {
								actualStartPos = basePos + offsets[matchIndex];
								actualEndPos = basePos + (offsets[matchIndex + originalText.length - 1] || 0) + 1;
								foundExactMatch = true;
							}
						}
						if (foundExactMatch) {
							const marks = replacement.marks ? replacement.marks.map((mark) => editor.schema.marks[mark.type].create(mark.attrs)) : [];
							tr = tr.delete(actualStartPos, actualEndPos);
							tr = tr.insert(actualStartPos, editor.schema.text(replacement.text, marks));
							if (tr.docChanged) {
								editor.view.dispatch(tr);
								doc$1 = editor.state.doc;
							}
						}
					}
				} catch (error) {
					console.error("Error processing match:", error);
				}
			}
		});
	} catch (error) {
		console.error("Error formatting document:", error);
	}
}
var edit_regular_default = "<!-- @note: includes color gradient for inline svg AI Writer -->\n<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->\n    <linearGradient id=\"gradient\" x1=\"125%\" y1=\"50%\" x2=\"-25%\" y2=\"50%\">\n        <stop offset=\"-20%\" stop-color=\"rgba(218, 215, 118, 0.5)\" />\n        <stop offset=\"30%\" stop-color=\"rgb(191, 100, 100)\" />\n        <stop offset=\"60%\" stop-color=\"rgb(77, 82, 217)\" />\n        <stop offset=\"150%\" stop-color=\"rgb(255, 219, 102)\" />\n    </linearGradient>\n    <path fill=\"url(#gradient)\" d=\"M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1 .8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z\"/>\n</svg>";
var paper_plane_regular_default = "<!-- @note: includes color gradient for inline svg AI Writer -->\n<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->\n  <defs>\n    <linearGradient id=\"gradient\" x1=\"125%\" y1=\"50%\" x2=\"-25%\" y2=\"50%\">\n      <stop offset=\"-20%\" stop-color=\"rgba(218, 215, 118, 0.5)\" />\n      <stop offset=\"30%\" stop-color=\"rgb(191, 100, 100)\" />\n      <stop offset=\"60%\" stop-color=\"rgb(77, 82, 217)\" />\n      <stop offset=\"150%\" stop-color=\"rgb(255, 219, 102)\" />\n    </linearGradient>\n  </defs>\n  <path fill=\"url(#gradient)\" d=\"M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z\"/>\n</svg>";
var _hoisted_1$22 = { class: "ai-user-input-field" };
var _hoisted_2$17 = ["innerHTML"];
var _hoisted_3$13 = ["placeholder"];
var _hoisted_4$9 = { class: "ai-loader" };
var _hoisted_5$8 = ["innerHTML"];
var AIWriter_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "AIWriter",
	props: {
		selectedText: {
			type: String,
			required: true
		},
		handleClose: {
			type: Function,
			required: true
		},
		editor: {
			type: Object,
			required: true
		},
		apiKey: { type: String },
		endpoint: {
			type: String,
			required: false
		}
	},
	setup(__props) {
		const props = __props;
		const selectionState = ref(null);
		const aiWriterRef = ref(null);
		const handleClickOutside$1 = (event) => {
			if (aiWriterRef.value && !aiWriterRef.value.contains(event.target)) {
				if (!isLoading.value) props.editor.commands.removeAiMark();
				props.handleClose();
			}
		};
		const editableRef = ref(null);
		const saveSelection = () => {
			if (props.selectedText) {
				selectionState.value = {
					...props.editor.state.selection,
					from: props.editor.state.selection.from,
					to: props.editor.state.selection.to
				};
				props.editor.commands.setMeta("storedSelection", selectionState.value);
				props.editor.commands.insertAiMark();
			}
		};
		const focusTextarea = () => {
			setTimeout(() => {
				nextTick(() => {
					if (editableRef.value) editableRef.value.focus();
				});
			}, 0);
		};
		const addEventListeners = () => {
			document.addEventListener("mousedown", handleClickOutside$1);
			document.addEventListener("keydown", handleCaptureKeyDown, true);
		};
		const removeEventListeners = () => {
			document.removeEventListener("mousedown", handleClickOutside$1);
			document.removeEventListener("keydown", handleCaptureKeyDown, true);
		};
		onMounted(() => {
			saveSelection();
			focusTextarea();
			addEventListeners();
		});
		onUnmounted(() => {
			if (!isLoading.value) props.editor.commands.removeAiMark();
			removeEventListeners();
		});
		const handleCaptureKeyDown = (event) => {
			if (editableRef.value && event.target === editableRef.value && [
				"ArrowUp",
				"ArrowDown",
				"ArrowLeft",
				"ArrowRight"
			].includes(event.key)) event.stopPropagation();
		};
		const placeholderText = computed(() => props.selectedText ? "Insert prompt to update text" : "Insert prompt to generate text");
		const isLoading = ref(false);
		const isError = ref("");
		const promptText = ref("");
		const textProcessingStarted = ref(false);
		const previousText = ref("");
		const isFormatting = ref(false);
		const pendingFormatting = ref(false);
		const isInSuggestingMode = computed(() => {
			return props.editor.isInSuggestingMode?.() || false;
		});
		const getDocumentXml = () => {
			try {
				return props.editor.state.doc.textContent || "";
			} catch (error) {
				console.error("Error getting document XML:", error);
				return "";
			}
		};
		const handleTextChunk = async (text) => {
			try {
				props.editor.commands.removeAiNode("aiLoaderNode");
				if (props.selectedText && !textProcessingStarted.value) {
					props.editor.commands.removeAiMark();
					props.editor.commands.clearAiHighlightStyle();
					if (selectionState.value) {
						const { state } = props.editor;
						const { from: from$1, to } = selectionState.value;
						const tr = state.tr.setSelection(TextSelection.create(state.doc, from$1, to));
						props.editor.view.dispatch(tr);
					} else console.warn("[AIWriter] No stored selection to restore");
					props.editor.commands.deleteSelection();
					textProcessingStarted.value = true;
				}
				if (text === null || text === void 0 || text === "") return;
				const textStr = String(text);
				const wrappedContent = {
					type: "text",
					marks: [{
						type: "aiAnimationMark",
						attrs: {
							class: "sd-ai-text-appear",
							dataMarkId: `ai-animation-${Date.now()}`
						}
					}],
					text: textStr
				};
				props.editor.commands.insertContent(wrappedContent);
				pendingFormatting.value = true;
				if (!isFormatting.value) await runSafeFormat();
				props.handleClose();
			} catch (error) {
				console.error("Error handling text chunk:", error);
			}
		};
		const runSafeFormat = async () => {
			if (isFormatting.value) return;
			try {
				isFormatting.value = true;
				pendingFormatting.value = false;
				await nextTick();
				formatDocument(props.editor);
				if (pendingFormatting.value) {
					pendingFormatting.value = false;
					await runSafeFormat();
				}
			} finally {
				isFormatting.value = false;
			}
		};
		const handleDone = async () => {
			if (pendingFormatting.value || isFormatting.value) {
				pendingFormatting.value = true;
				await new Promise((resolve) => {
					const checkFormatting = () => {
						if (!isFormatting.value && !pendingFormatting.value) resolve();
						else setTimeout(checkFormatting, 100);
					};
					checkFormatting();
				});
			}
			await runSafeFormat();
			setTimeout(() => {
				props.editor.commands.removeAiMark("aiAnimationMark");
				props.editor.commands.removeAiMark();
			}, 1e3);
		};
		const handleSubmit = async () => {
			isError.value = "";
			textProcessingStarted.value = false;
			previousText.value = "";
			isLoading.value = true;
			try {
				props.handleClose();
				if (props.selectedText) {
					props.editor.commands.updateAiHighlightStyle("sd-ai-highlight-pulse");
					props.editor.commands.removeSelectionAfterAiPulse();
				} else props.editor.commands.insertContent({ type: "aiLoaderNode" });
				if (isInSuggestingMode.value) props.editor.commands.enableTrackChanges();
				const options = {
					docText: "",
					documentXml: getDocumentXml(),
					config: {
						apiKey: props.apiKey,
						endpoint: props.endpoint
					}
				};
				if (props.selectedText) await rewriteStreaming(props.selectedText, promptText.value, options, handleTextChunk, handleDone);
				else await writeStreaming(promptText.value, options, handleTextChunk, handleDone);
			} catch (error) {
				console.error("AI generation error:", error);
				isError.value = error.message || "An error occurred";
			} finally {
				promptText.value = "";
				if (isInSuggestingMode.value) props.editor.commands.disableTrackChanges();
				isLoading.value = false;
				textProcessingStarted.value = false;
			}
		};
		const handleKeyDown$1 = (event) => {
			if (event.key === "Enter" && !event.shiftKey) {
				event.preventDefault();
				handleSubmit();
			}
		};
		const handleInput = (event) => {
			if (isError.value) isError.value = "";
			promptText.value = event.target.value;
		};
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "ai-writer prosemirror-isolated",
				ref_key: "aiWriterRef",
				ref: aiWriterRef,
				onMousedown: _cache[1] || (_cache[1] = withModifiers(() => {}, ["stop"]))
			}, [createElementVNode("div", _hoisted_1$22, [createElementVNode("span", {
				class: "ai-textarea-icon",
				innerHTML: unref(edit_regular_default)
			}, null, 8, _hoisted_2$17), withDirectives(createElementVNode("textarea", {
				ref_key: "editableRef",
				ref: editableRef,
				class: "ai-textarea",
				placeholder: placeholderText.value,
				onKeydown: handleKeyDown$1,
				onInput: handleInput,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => promptText.value = $event),
				rows: "4"
			}, null, 40, _hoisted_3$13), [[vModelText, promptText.value]])]), createElementVNode("div", _hoisted_4$9, [promptText.value ? (openBlock(), createElementBlock("span", {
				key: 0,
				class: "ai-textarea-icon ai-submit-button",
				onClick: withModifiers(handleSubmit, ["stop"]),
				innerHTML: unref(paper_plane_regular_default)
			}, null, 8, _hoisted_5$8)) : createCommentVNode("", true)])], 544);
		};
	}
}, [["__scopeId", "data-v-5444b0c8"]]);
var isHighContrastMode = ref(false);
function useHighContrastMode() {
	const setHighContrastMode = (value) => {
		isHighContrastMode.value = value;
	};
	return {
		isHighContrastMode,
		setHighContrastMode
	};
}
var bold_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M0 64C0 46.3 14.3 32 32 32l48 0 16 0 128 0c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128L96 480l-16 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-160L48 96 32 96C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64L112 96l0 128 112 0zM112 288l0 128 144 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0-112 0z\"/></svg>";
var italic_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M128 64c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-58.7 0L160 416l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l58.7 0L224 96l-64 0c-17.7 0-32-14.3-32-32z\"/></svg>";
var underline_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M16 64c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 128c0 53 43 96 96 96s96-43 96-96l0-128-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 128c0 88.4-71.6 160-160 160s-160-71.6-160-160L64 96 48 96C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32z\"/></svg>";
var list_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M40 48C26.7 48 16 58.7 16 72l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L40 48zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM16 232l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z\"/></svg>";
var list_circle_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. (bullet shapes modified)--><path fill-rule=\"evenodd\" d=\"M192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM64 48 A48 48 0 1 0 64 144 A48 48 0 1 0 64 48 Z M64 68 A28 28 0 1 1 64 124 A28 28 0 1 1 64 68 Z M64 208 A48 48 0 1 0 64 304 A48 48 0 1 0 64 208 Z M64 228 A28 28 0 1 1 64 284 A28 28 0 1 1 64 228 Z M64 368 A48 48 0 1 0 64 464 A48 48 0 1 0 64 368 Z M64 388 A28 28 0 1 1 64 444 A28 28 0 1 1 64 388 Z\"/></svg>\n";
var list_square_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. (bullet shapes modified)--><path d=\"M192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM16 48 L112 48 L112 144 L16 144 Z M16 208 L112 208 L112 304 L16 304 Z M16 368 L112 368 L112 464 L16 464 Z\"/></svg>\n";
var list_ol_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M24 56c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24l0 120 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-96-8 0C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432l33.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z\"/></svg>";
var list_decimal_solid_default = "<svg width=\"512\" height=\"512\" viewBox=\"0 0 512 512\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_0_1)\">\n<path d=\"M260 54C242.3 54 228 68.3 228 86C228 103.7 242.3 118 260 118H480C497.7 118 512 103.7 512 86C512 68.3 497.7 54 480 54H260ZM260 224C242.3 224 228 238.3 228 256C228 273.7 242.3 288 260 288H480C497.7 288 512 273.7 512 256C512 238.3 497.7 224 480 224H260ZM260 394C242.3 394 228 408.3 228 426C228 443.7 242.3 458 260 458H480C497.7 458 512 443.7 512 426C512 408.3 497.7 394 480 394H260Z\" fill=\"currentColor\"/>\n<path d=\"M131.823 9.18182V111H110.296V29.6151H109.7L86.3828 44.2315V25.1406L111.589 9.18182H131.823ZM163.132 112.293C159.85 112.293 157.033 111.133 154.68 108.812C152.36 106.459 151.2 103.642 151.2 100.361C151.2 97.1127 152.36 94.3286 154.68 92.0085C157.033 89.6884 159.85 88.5284 163.132 88.5284C166.314 88.5284 169.098 89.6884 171.484 92.0085C173.87 94.3286 175.064 97.1127 175.064 100.361C175.064 102.548 174.5 104.554 173.373 106.376C172.279 108.166 170.838 109.608 169.048 110.702C167.258 111.762 165.286 112.293 163.132 112.293Z\" fill=\"currentColor\"/>\n<path d=\"M62.37 284V268.489L98.6129 234.93C101.695 231.947 104.281 229.263 106.369 226.876C108.49 224.49 110.097 222.153 111.191 219.866C112.285 217.546 112.832 215.044 112.832 212.359C112.832 209.376 112.152 206.808 110.793 204.653C109.434 202.466 107.578 200.792 105.225 199.632C102.872 198.439 100.204 197.842 97.2209 197.842C94.1054 197.842 91.3875 198.472 89.0675 199.732C86.7474 200.991 84.9576 202.797 83.6982 205.151C82.4387 207.504 81.8089 210.304 81.8089 213.553H61.3757C61.3757 206.891 62.8838 201.107 65.8999 196.202C68.916 191.296 73.1418 187.501 78.5774 184.817C84.013 182.132 90.2772 180.79 97.37 180.79C104.662 180.79 111.009 182.082 116.411 184.668C121.847 187.22 126.073 190.766 129.089 195.307C132.105 199.848 133.613 205.051 133.613 210.918C133.613 214.762 132.851 218.557 131.326 222.303C129.835 226.048 127.166 230.207 123.322 234.781C119.477 239.322 114.058 244.774 107.065 251.138L92.1996 265.705V266.401H134.955V284H62.37ZM163.132 285.293C159.85 285.293 157.033 284.133 154.68 281.812C152.36 279.459 151.2 276.642 151.2 273.361C151.2 270.113 152.36 267.329 154.68 265.009C157.033 262.688 159.85 261.528 163.132 261.528C166.314 261.528 169.098 262.688 171.484 265.009C173.87 267.329 175.064 270.113 175.064 273.361C175.064 275.548 174.5 277.554 173.373 279.376C172.279 281.166 170.838 282.608 169.048 283.702C167.258 284.762 165.286 285.293 163.132 285.293Z\" fill=\"currentColor\"/>\n<path d=\"M98.7745 451.392C91.3503 451.392 84.738 450.116 78.9379 447.564C73.1708 444.979 68.6135 441.432 65.266 436.925C61.9516 432.384 60.2447 427.147 60.1452 421.214H81.8214C81.954 423.7 82.766 425.888 84.2575 427.777C85.7821 429.633 87.8039 431.075 90.3228 432.102C92.8417 433.13 95.6755 433.643 98.8242 433.643C102.105 433.643 105.006 433.063 107.525 431.903C110.043 430.743 112.016 429.136 113.441 427.081C114.866 425.026 115.578 422.656 115.578 419.972C115.578 417.254 114.816 414.851 113.292 412.763C111.8 410.642 109.646 408.984 106.828 407.791C104.044 406.598 100.73 406.001 96.8853 406.001H87.3896V390.192H96.8853C100.133 390.192 103 389.628 105.486 388.501C108.005 387.375 109.961 385.817 111.353 383.828C112.745 381.806 113.441 379.453 113.441 376.768C113.441 374.216 112.828 371.979 111.601 370.057C110.408 368.101 108.718 366.577 106.53 365.483C104.376 364.389 101.857 363.842 98.9734 363.842C96.0567 363.842 93.3886 364.373 90.9691 365.433C88.5496 366.461 86.6107 367.936 85.1523 369.858C83.694 371.78 82.9151 374.034 82.8157 376.619H62.1836C62.283 370.753 63.9568 365.582 67.2049 361.108C70.453 356.634 74.828 353.137 80.3299 350.618C85.8649 348.066 92.1126 346.79 99.0728 346.79C106.099 346.79 112.248 348.066 117.517 350.618C122.787 353.17 126.881 356.617 129.797 360.959C132.747 365.268 134.205 370.107 134.172 375.476C134.205 381.177 132.432 385.933 128.853 389.744C125.306 393.556 120.683 395.975 114.982 397.003V397.798C122.472 398.759 128.173 401.361 132.084 405.604C136.028 409.813 137.984 415.083 137.951 421.413C137.984 427.214 136.31 432.367 132.929 436.875C129.582 441.383 124.958 444.929 119.059 447.514C113.159 450.099 106.398 451.392 98.7745 451.392ZM163.132 451.293C159.85 451.293 157.033 450.133 154.68 447.812C152.36 445.459 151.2 442.642 151.2 439.361C151.2 436.113 152.36 433.329 154.68 431.009C157.033 428.688 159.85 427.528 163.132 427.528C166.314 427.528 169.098 428.688 171.484 431.009C173.87 433.329 175.064 436.113 175.064 439.361C175.064 441.548 174.5 443.554 173.373 445.376C172.279 447.166 170.838 448.608 169.048 449.702C167.258 450.762 165.286 451.293 163.132 451.293Z\" fill=\"currentColor\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_0_1\">\n<rect width=\"512\" height=\"512\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>\n";
var list_decimal_paren_solid_default = "<svg width=\"512\" height=\"512\" viewBox=\"0 0 512 512\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<g clip-path=\"url(#clip0_1_12)\">\n<path d=\"M260 54C242.3 54 228 68.3 228 86C228 103.7 242.3 118 260 118H480C497.7 118 512 103.7 512 86C512 68.3 497.7 54 480 54H260ZM260 224C242.3 224 228 238.3 228 256C228 273.7 242.3 288 260 288H480C497.7 288 512 273.7 512 256C512 238.3 497.7 224 480 224H260ZM260 394C242.3 394 228 408.3 228 426C228 443.7 242.3 458 260 458H480C497.7 458 512 443.7 512 426C512 408.3 497.7 394 480 394H260Z\" fill=\"currentColor\"/>\n<path d=\"M119.768 25.1818V127H98.2415V45.6151H97.6449L74.3281 60.2315V41.1406L99.5341 25.1818H119.768ZM179.863 76.0909C179.863 88.4536 178.205 99.822 174.891 110.196C171.61 120.57 166.572 130.182 159.777 139.031H139.543C142.128 135.75 144.531 131.74 146.752 127C148.972 122.26 150.911 117.09 152.569 111.489C154.226 105.854 155.518 100.021 156.446 93.9886C157.374 87.9564 157.838 81.9905 157.838 76.0909C157.838 68.2358 157.026 60.3144 155.402 52.3267C153.811 44.3059 151.624 36.8816 148.84 30.054C146.089 23.1932 142.99 17.5753 139.543 13.2003H159.777C166.572 22.0497 171.61 31.6615 174.891 42.0355C178.205 52.4096 179.863 63.7614 179.863 76.0909Z\" fill=\"currentColor\"/>\n<path d=\"M55.7841 300V284.489L92.027 250.93C95.1094 247.947 97.6946 245.263 99.7827 242.876C101.904 240.49 103.511 238.153 104.605 235.866C105.699 233.546 106.246 231.044 106.246 228.359C106.246 225.376 105.566 222.808 104.207 220.653C102.848 218.466 100.992 216.792 98.6392 215.632C96.286 214.439 93.6179 213.842 90.6349 213.842C87.5194 213.842 84.8016 214.472 82.4815 215.732C80.1615 216.991 78.3717 218.797 77.1122 221.151C75.8527 223.504 75.223 226.304 75.223 229.553H54.7898C54.7898 222.891 56.2978 217.107 59.3139 212.202C62.33 207.296 66.5559 203.501 71.9915 200.817C77.4271 198.132 83.6913 196.79 90.7841 196.79C98.0758 196.79 104.423 198.082 109.825 200.668C115.261 203.22 119.487 206.766 122.503 211.307C125.519 215.848 127.027 221.051 127.027 226.918C127.027 230.762 126.265 234.557 124.74 238.303C123.249 242.048 120.58 246.207 116.736 250.781C112.891 255.322 107.472 260.774 100.479 267.138L85.6136 281.705V282.401H128.369V300H55.7841ZM179.863 249.091C179.863 261.454 178.205 272.822 174.891 283.196C171.61 293.57 166.572 303.182 159.777 312.031H139.543C142.128 308.75 144.531 304.74 146.752 300C148.972 295.26 150.911 290.09 152.569 284.489C154.226 278.854 155.518 273.021 156.446 266.989C157.374 260.956 157.838 254.991 157.838 249.091C157.838 241.236 157.026 233.314 155.402 225.327C153.811 217.306 151.624 209.882 148.84 203.054C146.089 196.193 142.99 190.575 139.543 186.2H159.777C166.572 195.05 171.61 204.661 174.891 215.036C178.205 225.41 179.863 236.761 179.863 249.091Z\" fill=\"currentColor\"/>\n<path d=\"M89.3175 473.392C81.8932 473.392 75.281 472.116 69.4808 469.564C63.7138 466.979 59.1565 463.432 55.8089 458.925C52.4946 454.384 50.7876 449.147 50.6882 443.214H72.3643C72.4969 445.7 73.3089 447.888 74.8004 449.777C76.325 451.633 78.3468 453.075 80.8658 454.102C83.3847 455.13 86.2185 455.643 89.3672 455.643C92.6484 455.643 95.5485 455.063 98.0675 453.903C100.586 452.743 102.558 451.136 103.984 449.081C105.409 447.026 106.121 444.656 106.121 441.972C106.121 439.254 105.359 436.851 103.835 434.763C102.343 432.642 100.189 430.984 97.3715 429.791C94.5874 428.598 91.273 428.001 87.4283 428.001H77.9325V412.192H87.4283C90.6764 412.192 93.5433 411.628 96.0291 410.501C98.5481 409.375 100.504 407.817 101.896 405.828C103.288 403.806 103.984 401.453 103.984 398.768C103.984 396.216 103.371 393.979 102.144 392.057C100.951 390.101 99.2607 388.577 97.0732 387.483C94.9188 386.389 92.3999 385.842 89.5163 385.842C86.5997 385.842 83.9316 386.373 81.5121 387.433C79.0926 388.461 77.1536 389.936 75.6953 391.858C74.237 393.78 73.4581 396.034 73.3587 398.619H52.7266C52.826 392.753 54.4998 387.582 57.7479 383.108C60.996 378.634 65.371 375.137 70.8729 372.618C76.4079 370.066 82.6555 368.79 89.6158 368.79C96.6423 368.79 102.79 370.066 108.06 372.618C113.33 375.17 117.424 378.617 120.34 382.959C123.29 387.268 124.748 392.107 124.715 397.476C124.748 403.177 122.975 407.933 119.396 411.744C115.849 415.556 111.226 417.975 105.525 419.003V419.798C113.015 420.759 118.716 423.361 122.627 427.604C126.571 431.813 128.527 437.083 128.494 443.413C128.527 449.214 126.853 454.367 123.472 458.875C120.125 463.383 115.501 466.929 109.602 469.514C103.702 472.099 96.9406 473.392 89.3175 473.392ZM179.863 421.091C179.863 433.454 178.205 444.822 174.891 455.196C171.61 465.57 166.572 475.182 159.777 484.031H139.543C142.128 480.75 144.531 476.74 146.752 472C148.972 467.26 150.911 462.09 152.569 456.489C154.226 450.854 155.518 445.021 156.446 438.989C157.374 432.956 157.838 426.991 157.838 421.091C157.838 413.236 157.026 405.314 155.402 397.327C153.811 389.306 151.624 381.882 148.84 375.054C146.089 368.193 142.99 362.575 139.543 358.2H159.777C166.572 367.05 171.61 376.661 174.891 387.036C178.205 397.41 179.863 408.761 179.863 421.091Z\" fill=\"currentColor\"/>\n</g>\n<defs>\n<clipPath id=\"clip0_1_12\">\n<rect width=\"512\" height=\"512\" fill=\"white\"/>\n</clipPath>\n</defs>\n</svg>\n";
var list_upper_roman_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\">\n  <path fill=\"currentColor\" d=\"M260 54c-17.7 0-32 14.3-32 32s14.3 32 32 32l220 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L260 54zm0 170c-17.7 0-32 14.3-32 32s14.3 32 32 32l220 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-220 0zm0 170c-17.7 0-32 14.3-32 32s14.3 32 32 32l220 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-220 0z\"/>\n  <text fill=\"currentColor\" font-family=\"Georgia, serif\" font-weight=\"bold\" font-size=\"120\" text-anchor=\"end\" x=\"210\" y=\"86\" dominant-baseline=\"central\">I.</text>\n  <text fill=\"currentColor\" font-family=\"Georgia, serif\" font-weight=\"bold\" font-size=\"120\" text-anchor=\"end\" x=\"210\" y=\"256\" dominant-baseline=\"central\">II.</text>\n  <text fill=\"currentColor\" font-family=\"Georgia, serif\" font-weight=\"bold\" font-size=\"120\" text-anchor=\"end\" x=\"210\" y=\"426\" dominant-baseline=\"central\">III.</text>\n</svg>\n";
var list_lower_roman_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\">\n  <path fill=\"currentColor\" d=\"M260 54C242.3 54 228 68.3 228 86C228 103.7 242.3 118 260 118H480C497.7 118 512 103.7 512 86C512 68.3 497.7 54 480 54H260ZM260 224C242.3 224 228 238.3 228 256C228 273.7 242.3 288 260 288H480C497.7 288 512 273.7 512 256C512 238.3 497.7 224 480 224H260ZM260 394C242.3 394 228 408.3 228 426C228 443.7 242.3 458 260 458H480C497.7 458 512 443.7 512 426C512 408.3 497.7 394 480 394H260Z\"/>\n  <text fill=\"currentColor\" font-family=\"Georgia, serif\" font-weight=\"bold\" font-size=\"120\" text-anchor=\"end\" x=\"210\" y=\"86\" dominant-baseline=\"central\">i.</text>\n  <text fill=\"currentColor\" font-family=\"Georgia, serif\" font-weight=\"bold\" font-size=\"120\" text-anchor=\"end\" x=\"210\" y=\"256\" dominant-baseline=\"central\">ii.</text>\n  <text fill=\"currentColor\" font-family=\"Georgia, serif\" font-weight=\"bold\" font-size=\"120\" text-anchor=\"end\" x=\"210\" y=\"426\" dominant-baseline=\"central\">iii.</text>\n</svg>\n";
var list_upper_alpha_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\">\n  <path fill=\"currentColor\" d=\"M260 54c-17.7 0-32 14.3-32 32s14.3 32 32 32l220 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L260 54zm0 170c-17.7 0-32 14.3-32 32s14.3 32 32 32l220 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-220 0zm0 170c-17.7 0-32 14.3-32 32s14.3 32 32 32l220 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-220 0z\"/>\n  <text fill=\"currentColor\" font-family=\"sans-serif\" font-weight=\"bold\" font-size=\"140\" text-anchor=\"end\" x=\"210\" y=\"86\" dominant-baseline=\"central\">A.</text>\n  <text fill=\"currentColor\" font-family=\"sans-serif\" font-weight=\"bold\" font-size=\"140\" text-anchor=\"end\" x=\"210\" y=\"256\" dominant-baseline=\"central\">B.</text>\n  <text fill=\"currentColor\" font-family=\"sans-serif\" font-weight=\"bold\" font-size=\"140\" text-anchor=\"end\" x=\"210\" y=\"426\" dominant-baseline=\"central\">C.</text>\n</svg>\n";
var list_upper_alpha_paren_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\">\n  <path fill=\"currentColor\" d=\"M260 54c-17.7 0-32 14.3-32 32s14.3 32 32 32l220 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L260 54zm0 170c-17.7 0-32 14.3-32 32s14.3 32 32 32l220 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-220 0zm0 170c-17.7 0-32 14.3-32 32s14.3 32 32 32l220 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-220 0z\"/>\n  <text fill=\"currentColor\" font-family=\"sans-serif\" font-weight=\"bold\" font-size=\"140\" text-anchor=\"end\" x=\"210\" y=\"86\" dominant-baseline=\"central\">A)</text>\n  <text fill=\"currentColor\" font-family=\"sans-serif\" font-weight=\"bold\" font-size=\"140\" text-anchor=\"end\" x=\"210\" y=\"256\" dominant-baseline=\"central\">B)</text>\n  <text fill=\"currentColor\" font-family=\"sans-serif\" font-weight=\"bold\" font-size=\"140\" text-anchor=\"end\" x=\"210\" y=\"426\" dominant-baseline=\"central\">C)</text>\n</svg>\n";
var list_lower_alpha_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\">\n  <path fill=\"currentColor\" d=\"M260 54C242.3 54 228 68.3 228 86C228 103.7 242.3 118 260 118H480C497.7 118 512 103.7 512 86C512 68.3 497.7 54 480 54H260ZM260 224C242.3 224 228 238.3 228 256C228 273.7 242.3 288 260 288H480C497.7 288 512 273.7 512 256C512 238.3 497.7 224 480 224H260ZM260 394C242.3 394 228 408.3 228 426C228 443.7 242.3 458 260 458H480C497.7 458 512 443.7 512 426C512 408.3 497.7 394 480 394H260Z\"/>\n  <text fill=\"currentColor\" font-family=\"sans-serif\" font-weight=\"bold\" font-size=\"140\" text-anchor=\"end\" x=\"210\" y=\"74\" dominant-baseline=\"central\">a.</text>\n  <text fill=\"currentColor\" font-family=\"sans-serif\" font-weight=\"bold\" font-size=\"140\" text-anchor=\"end\" x=\"210\" y=\"244\" dominant-baseline=\"central\">b.</text>\n  <text fill=\"currentColor\" font-family=\"sans-serif\" font-weight=\"bold\" font-size=\"140\" text-anchor=\"end\" x=\"210\" y=\"414\" dominant-baseline=\"central\">c.</text>\n</svg>\n";
var list_lower_alpha_paren_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\">\n  <path fill=\"currentColor\" d=\"M260 54C242.3 54 228 68.3 228 86C228 103.7 242.3 118 260 118H480C497.7 118 512 103.7 512 86C512 68.3 497.7 54 480 54H260ZM260 224C242.3 224 228 238.3 228 256C228 273.7 242.3 288 260 288H480C497.7 288 512 273.7 512 256C512 238.3 497.7 224 480 224H260ZM260 394C242.3 394 228 408.3 228 426C228 443.7 242.3 458 260 458H480C497.7 458 512 443.7 512 426C512 408.3 497.7 394 480 394H260Z\"/>\n  <text fill=\"currentColor\" font-family=\"sans-serif\" font-weight=\"bold\" font-size=\"140\" text-anchor=\"end\" x=\"210\" y=\"74\" dominant-baseline=\"central\">a)</text>\n  <text fill=\"currentColor\" font-family=\"sans-serif\" font-weight=\"bold\" font-size=\"140\" text-anchor=\"end\" x=\"210\" y=\"244\" dominant-baseline=\"central\">b)</text>\n  <text fill=\"currentColor\" font-family=\"sans-serif\" font-weight=\"bold\" font-size=\"140\" text-anchor=\"end\" x=\"210\" y=\"414\" dominant-baseline=\"central\">c)</text>\n</svg>\n";
var image_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l96 0 32 0 208 0c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z\"/></svg>";
var link_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z\"/></svg>";
var align_left_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M288 64c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l224 0c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32L32 352c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z\"/></svg>";
var align_center_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M352 64c0-17.7-14.3-32-32-32L128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32L32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32z\"/></svg>";
var align_right_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M448 64c0 17.7-14.3 32-32 32L192 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z\"/></svg>";
var align_justify_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M448 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32L32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32z\"/></svg>";
var indent_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M0 64C0 46.3 14.3 32 32 32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 96l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3L0 176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z\"/></svg>";
var outdent_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M0 64C0 46.3 14.3 32 32 32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 96l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32zM.2 268.6c-8.2-6.4-8.2-18.9 0-25.3l101.9-79.3c10.5-8.2 25.8-.7 25.8 12.6l0 158.6c0 13.3-15.3 20.8-25.8 12.6L.2 268.6z\"/></svg>";
var paint_roller_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 192c-35.3 0-64-28.7-64-64L0 64zM160 352c0-17.7 14.3-32 32-32l0-16c0-44.2 35.8-80 80-80l144 0c17.7 0 32-14.3 32-32l0-32 0-90.5c37.3 13.2 64 48.7 64 90.5l0 32c0 53-43 96-96 96l-144 0c-8.8 0-16 7.2-16 16l0 16c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128z\"/></svg>";
var text_slash_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96 503 96 497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32L376.1 32l-.3 0L204.5 32c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96l116.7 0L301.3 210.8l-94.5-74.1zM243.3 416L192 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-42.2 0 17.6-62.1L272.9 311 243.3 416z\"/></svg>";
var rotate_left_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M48.5 224L40 224c-13.3 0-24-10.7-24-24L16 72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8L48.5 224z\"/></svg>";
var rotate_right_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M463.5 224l8.5 0c13.3 0 24-10.7 24-24l0-128c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l119.5 0z\"/></svg>";
var calendar_check_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z\"/></svg>";
var calendar_xmark_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM305 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z\"/></svg>";
var list_check_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z\"/></svg>";
var user_edit_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l293.1 0c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1l-91.4 0zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z\"/></svg>";
var eye_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z\"/></svg>";
var file_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128z\"/></svg>";
var font_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416 32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-1.8 0 18-48 159.6 0 18 48-1.8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-25.8 0L254 52.8zM279.8 304l-111.6 0L224 155.1 279.8 304z\"/></svg>";
var file_half_dashed_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M64 0C28.7 0 0 28.7 0 64L0 320l384 0 0-160-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM0 416l64 0 0-64L0 352l0 64zm288 32l-80 0 0 64 80 0 0-64zm-112 0l-80 0 0 64 80 0 0-64zM64 448L0 448c0 35.3 28.7 64 64 64l0-64zm256 0l0 64c35.3 0 64-28.7 64-64l-64 0zm64-32l0-64-64 0 0 64 64 0z\"/></svg>";
var comment_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z\"/></svg>";
var circle_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z\"/></svg>";
var check_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z\"/></svg>";
var xmark_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z\"/></svg>";
var up_right_from_square_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-128c0-17.7-14.3-32-32-32L352 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z\"/></svg>";
var ellipsis_vertical_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z\"/></svg>";
var caret_up_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z\"/></svg>";
var caret_down_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z\"/></svg>";
var ruler_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0L17.9 401.9c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 50.7-50.7c18.7-18.7 49.1-18.7 67.9 0l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9L177.9 494.1z\"/></svg>";
var paintbrush_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z\"/></svg>";
var highlighter_icon_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M315 315l158.4-215L444.1 70.6 229 229 315 315zm-187 5s0 0 0 0l0-71.7c0-15.3 7.2-29.6 19.5-38.6L420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L334.4 396.5c-9 12.3-23.4 19.5-38.6 19.5L224 416l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L128 320zM7 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7L24 512c-13.3 0-24-10.7-24-24l0-4.7c0-6.4 2.5-12.5 7-17z\"/></svg>\n";
var magic_wand_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.7-53.3L160 80l-53.3-26.7L80 0 53.3 53.3 0 80l53.3 26.7L80 160zm352 128l-26.7 53.3L352 368l53.3 26.7L432 448l26.7-53.3L512 368l-53.3-26.7L432 288zm70.6-193.8L417.8 9.4C411.5 3.1 403.3 0 395.2 0c-8.2 0-16.4 3.1-22.6 9.4L9.4 372.5c-12.5 12.5-12.5 32.8 0 45.3l84.9 84.9c6.3 6.3 14.4 9.4 22.6 9.4 8.2 0 16.4-3.1 22.6-9.4l363.1-363.2c12.5-12.5 12.5-32.8 0-45.2zM359.5 203.5l-50.9-50.9 86.6-86.6 50.9 50.9-86.6 86.6z\"/></svg>";
var table_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M64 256l0-96 160 0 0 96L64 256zm0 64l160 0 0 96L64 416l0-96zm224 96l0-96 160 0 0 96-160 0zM448 256l-160 0 0-96 160 0 0 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z\"/></svg>";
var table_columns_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 64l0 256 160 0 0-256L64 160zm384 0l-160 0 0 256 160 0 0-256z\"/></svg>";
var arrows_left_right_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z\"/></svg>";
var arrows_to_dot_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M256 0c17.7 0 32 14.3 32 32l0 32 32 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l32 0 0-32c0-17.7 14.3-32 32-32zM169.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224l32 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 32 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z\"/></svg>";
var plus_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z\"/></svg>";
var trash_can_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z\"/></svg>";
var wrench_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7L336 192c-8.8 0-16-7.2-16-16l0-57.4c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z\"/></svg>";
var border_none_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z\"/></svg>";
var up_down_default = "<svg xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"3 4 18 16\"><path stroke=\"#000000\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M6 10V5m0 0L4 7m2-2 2 2m-2 7v5m0 0 2-2m-2 2-2-2m8-10h8m0 5h-8m0 5h8\"></path></svg>\n";
var magnifying_glass_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z\"/></svg>\n";
var scissors_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M278.1 256L444.5 89.6c4.7-4.7 4.7-12.3 0-17-32.8-32.8-86-32.8-118.8 0L210.2 188.1l-24.9-24.9c4.3-10.9 6.7-22.8 6.7-35.3 0-53-43-96-96-96S0 75 0 128s43 96 96 96c4.5 0 9-.3 13.4-.9L142.3 256l-32.9 32.9c-4.4-.6-8.8-.9-13.4-.9-53 0-96 43-96 96s43 96 96 96 96-43 96-96c0-12.5-2.4-24.3-6.7-35.3l24.9-24.9L325.7 439.4c32.8 32.8 86 32.8 118.8 0 4.7-4.7 4.7-12.3 0-17L278.1 256zM96 160c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm0 256c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z\"/></svg>";
var copy_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M320 448v40c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24h72v296c0 30.9 25.1 56 56 56h168zm0-344V0H152c-13.3 0-24 10.7-24 24v368c0 13.3 10.7 24 24 24h272c13.3 0 24-10.7 24-24V128H344c-13.2 0-24-10.8-24-24zm121-31L375 7A24 24 0 0 0 358.1 0H352v96h96v-6.1a24 24 0 0 0 -7-17z\"/></svg>";
var paste_solid_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M128 184c0-30.9 25.1-56 56-56h136V56c0-13.3-10.7-24-24-24h-80.6C204.3 12.9 183.6 0 160 0s-44.3 12.9-55.4 32H24C10.7 32 0 42.7 0 56v336c0 13.3 10.7 24 24 24h104V184zm32-144c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm184 248h104v200c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.1V256h-96v-96h6.1a24 24 0 0 1 17 7l65.9 65.9a24 24 0 0 1 7 17z\"/></svg>";
const toolbarIcons = {
	undo: rotate_left_solid_default,
	redo: rotate_right_solid_default,
	bold: bold_solid_default,
	italic: italic_solid_default,
	underline: underline_solid_default,
	color: font_solid_default,
	link: link_solid_default,
	image: image_solid_default,
	tableOfContents: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"96 96 448 448\"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d=\"M96 160C96 124.7 124.7 96 160 96L480 96C515.3 96 544 124.7 544 160L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 160zM160 160L160 224L224 224L224 160L160 160zM480 160L288 160L288 224L480 224L480 160zM160 288L160 352L224 352L224 288L160 288zM480 288L288 288L288 352L480 352L480 288zM160 416L160 480L224 480L224 416L160 416zM480 416L288 416L288 480L480 480L480 416z\"></path></svg>\n",
	alignLeft: align_left_solid_default,
	alignRight: align_right_solid_default,
	alignCenter: align_center_solid_default,
	alignJustify: align_justify_solid_default,
	bulletList: list_solid_default,
	bulletListDisc: list_solid_default,
	bulletListCircle: list_circle_solid_default,
	bulletListSquare: list_square_solid_default,
	numberedList: list_ol_solid_default,
	numberedListDecimal: list_decimal_solid_default,
	numberedListDecimalParen: list_decimal_paren_solid_default,
	numberedListUpperRoman: list_upper_roman_solid_default,
	numberedListLowerRoman: list_lower_roman_solid_default,
	numberedListUpperAlpha: list_upper_alpha_solid_default,
	numberedListUpperAlphaParen: list_upper_alpha_paren_solid_default,
	numberedListLowerAlpha: list_lower_alpha_solid_default,
	numberedListLowerAlphaParen: list_lower_alpha_paren_solid_default,
	indentLeft: outdent_solid_default,
	indentRight: indent_solid_default,
	directionLtr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" aria-hidden=\"true\"><path d=\"M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z\"/></svg>\n",
	directionRtl: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" aria-hidden=\"true\"><path d=\"M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z\"/></svg>\n",
	pageBreak: file_half_dashed_solid_default,
	copyFormat: paint_roller_solid_default,
	clearFormatting: text_slash_solid_default,
	trackChanges: list_check_solid_default,
	trackChangesFinal: file_solid_default,
	trackChangesOriginal: eye_solid_default,
	trackChangesAccept: calendar_check_solid_default,
	trackChangesReject: calendar_xmark_solid_default,
	documentMode: user_edit_solid_default,
	documentEditingMode: user_edit_solid_default,
	documentSuggestingMode: comment_solid_default,
	documentViewingMode: eye_solid_default,
	colorOption: circle_solid_default,
	colorOptionCheck: check_solid_default,
	linkInput: link_solid_default,
	removeLink: xmark_solid_default,
	openLink: up_right_from_square_solid_default,
	overflow: ellipsis_vertical_solid_default,
	dropdownCaretUp: caret_up_solid_default,
	dropdownCaretDown: caret_down_solid_default,
	ruler: ruler_solid_default,
	paintbrush: paintbrush_solid_default,
	highlight: highlighter_icon_default,
	ai: magic_wand_solid_default,
	table: table_solid_default,
	tableActions: table_columns_solid_default,
	splitCell: arrows_left_right_solid_default,
	mergeCells: arrows_to_dot_solid_default,
	addRowBefore: plus_solid_default,
	addRowAfter: plus_solid_default,
	addColumnBefore: plus_solid_default,
	addColumnAfter: plus_solid_default,
	deleteRow: trash_can_solid_default,
	deleteColumn: trash_can_solid_default,
	deleteTable: trash_can_solid_default,
	deleteBorders: border_none_solid_default,
	fixTables: wrench_solid_default,
	lineHeight: up_down_default,
	search: magnifying_glass_default,
	cut: scissors_solid_default,
	copy: copy_solid_default,
	paste: paste_solid_default,
	strikethrough: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-209.9 0-.4-.1-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3c0 0 0 0 0 0s0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6c0 0 0 0 0 0l.2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1l-75.7 0c7 5.6 11.4 11.2 13.9 17.2z\"/></svg>\n",
	formattingMarks: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><text x=\"12\" y=\"18\" text-anchor=\"middle\" font-family=\"Arial, Helvetica, sans-serif\" font-size=\"20\" font-weight=\"700\" fill=\"currentColor\">¶</text></svg>\n"
};
var _hoisted_1$21 = [
	"onClick",
	"innerHTML",
	"aria-label",
	"onKeydown"
];
var AlignmentButtons_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "AlignmentButtons",
	emits: ["select"],
	setup(__props, { emit: __emit }) {
		const { isHighContrastMode: isHighContrastMode$1 } = useHighContrastMode();
		const emit = __emit;
		const alignmentButtonsRefs = ref([]);
		const alignmentButtons = [
			{
				key: "left",
				ariaLabel: "Align left",
				icon: toolbarIcons.alignLeft
			},
			{
				key: "center",
				ariaLabel: "Align center",
				icon: toolbarIcons.alignCenter
			},
			{
				key: "right",
				ariaLabel: "Align right",
				icon: toolbarIcons.alignRight
			},
			{
				key: "justify",
				ariaLabel: "Justify",
				icon: toolbarIcons.alignJustify
			}
		];
		const select = (alignment$1) => {
			emit("select", alignment$1);
		};
		const moveToNextButton = (index) => {
			if (index === alignmentButtonsRefs.value.length - 1) return;
			const nextButton = alignmentButtonsRefs.value[index + 1];
			if (nextButton) {
				nextButton.setAttribute("tabindex", "0");
				nextButton.focus();
			}
		};
		const moveToPreviousButton = (index) => {
			if (index === 0) return;
			const previousButton = alignmentButtonsRefs.value[index - 1];
			if (previousButton) {
				previousButton.setAttribute("tabindex", "0");
				previousButton.focus();
			}
		};
		const handleKeyDown$1 = (e, index) => {
			switch (e.key) {
				case "ArrowLeft":
					moveToPreviousButton(index);
					break;
				case "ArrowRight":
					moveToNextButton(index);
					break;
				case "Enter":
					select(alignmentButtons[index].key);
					break;
				default: break;
			}
		};
		onMounted(() => {
			const firstButton = alignmentButtonsRefs.value[0];
			if (firstButton) {
				firstButton.setAttribute("tabindex", "0");
				firstButton.focus();
			}
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["alignment-buttons", { "high-contrast": unref(isHighContrastMode$1) }]) }, [(openBlock(), createElementBlock(Fragment, null, renderList(alignmentButtons, (button, index) => {
				return createElementVNode("div", {
					key: button.key,
					class: "sd-button-icon",
					onClick: ($event) => select(button.key),
					innerHTML: button.icon,
					"data-item": "btn-textAlign-option",
					role: "menuitem",
					"aria-label": button.ariaLabel,
					ref_for: true,
					ref_key: "alignmentButtonsRefs",
					ref: alignmentButtonsRefs,
					onKeydown: withModifiers((event) => handleKeyDown$1(event, index), ["prevent"])
				}, null, 40, _hoisted_1$21);
			}), 64))], 2);
		};
	}
}, [["__scopeId", "data-v-ceb338e0"]]);
var _hoisted_1$20 = [
	"onClick",
	"innerHTML",
	"aria-label",
	"onKeydown"
];
var StyleButtonsList_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "StyleButtonsList",
	props: {
		buttons: {
			type: Array,
			required: true
		},
		selectedStyle: {
			type: String,
			default: null
		},
		iconSize: {
			type: Number,
			default: 25
		}
	},
	emits: ["select"],
	setup(__props, { emit: __emit }) {
		const { isHighContrastMode: isHighContrastMode$1 } = useHighContrastMode();
		const emit = __emit;
		const props = __props;
		const buttonRefs = ref([]);
		const iconStyle = computed(() => ({
			width: `${props.iconSize}px`,
			height: `${props.iconSize}px`
		}));
		const select = (key) => {
			emit("select", key);
		};
		const moveToNextButton = (index) => {
			if (index === buttonRefs.value.length - 1) return;
			const next = buttonRefs.value[index + 1];
			if (next) {
				next.setAttribute("tabindex", "0");
				next.focus();
			}
		};
		const moveToPreviousButton = (index) => {
			if (index === 0) return;
			const prev = buttonRefs.value[index - 1];
			if (prev) {
				prev.setAttribute("tabindex", "0");
				prev.focus();
			}
		};
		const handleKeyDown$1 = (e, index) => {
			switch (e.key) {
				case "ArrowLeft":
					moveToPreviousButton(index);
					break;
				case "ArrowRight":
					moveToNextButton(index);
					break;
				case "Enter":
					select(props.buttons[index].key);
					break;
				default: break;
			}
		};
		onMounted(() => {
			const first$1 = buttonRefs.value[0];
			if (first$1) {
				first$1.setAttribute("tabindex", "0");
				first$1.focus();
			}
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["style-buttons-list", { "high-contrast": unref(isHighContrastMode$1) }]) }, [(openBlock(true), createElementBlock(Fragment, null, renderList(props.buttons, (button, index) => {
				return openBlock(), createElementBlock("div", {
					key: button.key,
					class: normalizeClass(["sd-button-icon", { "sd-selected": props.selectedStyle === button.key }]),
					style: normalizeStyle(iconStyle.value),
					onClick: ($event) => select(button.key),
					innerHTML: button.icon,
					role: "menuitem",
					"aria-label": button.ariaLabel,
					ref_for: true,
					ref_key: "buttonRefs",
					ref: buttonRefs,
					onKeydown: withModifiers((event) => handleKeyDown$1(event, index), ["prevent"])
				}, null, 46, _hoisted_1$20);
			}), 128))], 2);
		};
	}
}, [["__scopeId", "data-v-701c1d54"]]);
const bulletStyleButtons = [
	{
		key: "disc",
		icon: toolbarIcons.bulletListDisc,
		ariaLabel: "Opaque circle"
	},
	{
		key: "circle",
		icon: toolbarIcons.bulletListCircle,
		ariaLabel: "Outline circle"
	},
	{
		key: "square",
		icon: toolbarIcons.bulletListSquare,
		ariaLabel: "Opaque square"
	}
];
const numberedStyleButtons = [
	{
		key: "decimal",
		icon: toolbarIcons.numberedListDecimal,
		ariaLabel: "1. 2. 3."
	},
	{
		key: "decimal-paren",
		icon: toolbarIcons.numberedListDecimalParen,
		ariaLabel: "1) 2) 3)"
	},
	{
		key: "upper-roman",
		icon: toolbarIcons.numberedListUpperRoman,
		ariaLabel: "I. II. III."
	},
	{
		key: "lower-roman",
		icon: toolbarIcons.numberedListLowerRoman,
		ariaLabel: "i. ii. iii."
	},
	{
		key: "upper-alpha",
		icon: toolbarIcons.numberedListUpperAlpha,
		ariaLabel: "A. B. C."
	},
	{
		key: "upper-alpha-paren",
		icon: toolbarIcons.numberedListUpperAlphaParen,
		ariaLabel: "A) B) C)"
	},
	{
		key: "lower-alpha",
		icon: toolbarIcons.numberedListLowerAlpha,
		ariaLabel: "a. b. c."
	},
	{
		key: "lower-alpha-paren",
		icon: toolbarIcons.numberedListLowerAlphaParen,
		ariaLabel: "a) b) c)"
	}
];
var _hoisted_1$19 = ["onClick", "onKeydown"];
var _hoisted_2$16 = { class: "document-mode-column icon-column" };
var _hoisted_3$12 = ["innerHTML"];
var _hoisted_4$8 = { class: "document-mode-column text-column" };
var _hoisted_5$7 = { class: "document-mode-type" };
var _hoisted_6$5 = { class: "document-mode-description" };
var DocumentMode_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "DocumentMode",
	props: { options: { type: Array } },
	emits: ["select"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const documentModeRefs = ref([]);
		const { isHighContrastMode: isHighContrastMode$1 } = useHighContrastMode();
		const props = __props;
		const handleClick$1 = (item) => {
			emit("select", item);
		};
		const moveToNextOption = (index) => {
			if (index === documentModeRefs.value.length - 1) return;
			const nextOption = documentModeRefs.value[index + 1];
			if (nextOption) {
				nextOption.setAttribute("tabindex", "0");
				nextOption.focus();
			}
		};
		const moveToPreviousOption = (index) => {
			if (index === 0) return;
			const previousOption = documentModeRefs.value[index - 1];
			if (previousOption) {
				previousOption.setAttribute("tabindex", "0");
				previousOption.focus();
			}
		};
		const handleKeyDown$1 = (e, index) => {
			switch (e.key) {
				case "ArrowDown":
					moveToNextOption(index);
					break;
				case "ArrowUp":
					moveToPreviousOption(index);
					break;
				case "Enter":
					handleClick$1(props.options[index]);
					break;
				default: break;
			}
		};
		onMounted(() => {
			documentModeRefs.value[0].setAttribute("tabindex", "0");
			documentModeRefs.value[0].focus();
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["document-mode", { "high-contrast": unref(isHighContrastMode$1) }]) }, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.options, (option, index) => {
				return openBlock(), createElementBlock("div", {
					class: normalizeClass(["sd-option-item", { "sd-disabled": option.disabled }]),
					onClick: ($event) => handleClick$1(option),
					"data-item": "btn-documentMode-option",
					role: "menuitem",
					ref_for: true,
					ref_key: "documentModeRefs",
					ref: documentModeRefs,
					onKeydown: withModifiers((event) => handleKeyDown$1(event, index), ["prevent"])
				}, [createElementVNode("div", _hoisted_2$16, [createElementVNode("div", {
					class: "icon-column__icon",
					innerHTML: option.icon
				}, null, 8, _hoisted_3$12)]), createElementVNode("div", _hoisted_4$8, [createElementVNode("div", _hoisted_5$7, toDisplayString(option.label), 1), createElementVNode("div", _hoisted_6$5, toDisplayString(option.description), 1)])], 42, _hoisted_1$19);
			}), 256))], 2);
		};
	}
}, [["__scopeId", "data-v-abd514d9"]]);
var _hoisted_1$18 = {
	key: 0,
	class: "linked-style-buttons",
	"data-editor-ui-surface": ""
};
var _hoisted_2$15 = [
	"onClick",
	"onKeydown",
	"aria-label"
];
var LinkedStyle_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "LinkedStyle",
	props: {
		editor: {
			type: Object,
			required: true
		},
		selectedOption: { type: String }
	},
	emits: ["select"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const styleRefs = ref([]);
		const props = __props;
		const select = (style) => {
			emit("select", style);
		};
		const moveToNextStyle = (index) => {
			if (index === styleRefs.value.length - 1) return;
			const nextItem = styleRefs.value[index + 1];
			nextItem.setAttribute("tabindex", "0");
			nextItem.focus();
		};
		const moveToPreviousStyle = (index) => {
			if (index === 0) return;
			const previousItem = styleRefs.value[index - 1];
			previousItem.setAttribute("tabindex", "0");
			previousItem.focus();
		};
		const handleKeyDown$1 = (event, index, style) => {
			switch (event.key) {
				case "ArrowDown":
					moveToNextStyle(index);
					break;
				case "ArrowUp":
					moveToPreviousStyle(index);
					break;
				case "Enter":
					event.preventDefault();
					select(style);
					break;
				default: break;
			}
		};
		onMounted(() => {
			styleRefs.value[0].setAttribute("tabindex", "0");
			styleRefs.value[0].focus();
		});
		return (_ctx, _cache) => {
			return props.editor ? (openBlock(), createElementBlock("div", _hoisted_1$18, [(openBlock(true), createElementBlock(Fragment, null, renderList(unref(getQuickFormatList)(__props.editor), (style, index) => {
				return openBlock(), createElementBlock("div", {
					class: normalizeClass(["style-item", { selected: __props.selectedOption === style.id }]),
					onClick: ($event) => select(style),
					onKeydown: (event) => handleKeyDown$1(event, index, style),
					"aria-label": `Linked style - ${style.id}`,
					ref_for: true,
					ref_key: "styleRefs",
					ref: styleRefs
				}, [createElementVNode("div", {
					class: "style-name",
					style: normalizeStyle(unref(generateLinkedStyleString)(style, null, null, false)),
					"data-item": "btn-linkedStyles-option"
				}, toDisplayString(style.definition.attrs.name), 5)], 42, _hoisted_2$15);
			}), 256))])) : createCommentVNode("", true);
		};
	}
}, [["__scopeId", "data-v-80e74746"]]);
var _hoisted_1$17 = {
	key: 0,
	class: "link-title"
};
var _hoisted_2$14 = {
	key: 1,
	class: "link-title"
};
var _hoisted_3$11 = {
	key: 2,
	class: "link-title"
};
var _hoisted_4$7 = {
	key: 3,
	class: "link-title"
};
var _hoisted_5$6 = {
	key: 4,
	class: "link-input-wrapper"
};
var _hoisted_6$4 = { class: "input-row text-input-row" };
var _hoisted_7$3 = ["readonly"];
var _hoisted_8$1 = { class: "input-row url-input-row" };
var _hoisted_9$1 = ["innerHTML"];
var _hoisted_10$1 = ["readonly", "onKeydown"];
var _hoisted_11$1 = ["innerHTML"];
var _hoisted_12$1 = {
	key: 0,
	class: "input-row link-buttons"
};
var _hoisted_13$1 = ["innerHTML"];
var _hoisted_14$1 = {
	key: 5,
	class: "input-row go-to-anchor clickable"
};
var LinkInput_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "LinkInput",
	props: {
		showInput: {
			type: Boolean,
			default: true
		},
		showLink: {
			type: Boolean,
			default: true
		},
		goToAnchor: {
			type: Function,
			default: () => {}
		},
		editor: {
			type: Object,
			required: true
		},
		closePopover: {
			type: Function,
			default: () => {}
		}
	},
	setup(__props) {
		const props = __props;
		const { isHighContrastMode: isHighContrastMode$1 } = useHighContrastMode();
		const urlError = ref(false);
		const getSelectedText = () => {
			if (!props.editor || !props.editor.state) return "";
			const { state } = props.editor;
			const { selection } = state;
			const linkMark = state.schema.marks.link;
			if (selection.empty) {
				const range = getMarkRange(selection.$from, linkMark);
				return range ? state.doc.textBetween(range.from, range.to, " ") : "";
			}
			const rangeFrom = getMarkRange(selection.$from, linkMark);
			const rangeTo = getMarkRange(selection.$to, linkMark);
			if (rangeFrom || rangeTo) {
				const linkRange = rangeFrom || rangeTo;
				return state.doc.textBetween(linkRange.from, linkRange.to, " ");
			}
			return state.doc.textBetween(selection.from, selection.to, " ");
		};
		const getLinkHrefAtSelection = () => {
			if (!props.editor || !props.editor.state) return "";
			const { state } = props.editor;
			const { schema, selection } = state;
			const linkMark = schema.marks.link;
			if (!linkMark) return "";
			let href = "";
			const { $from, empty: empty$1 } = selection;
			if (empty$1) {
				let link = (state.storedMarks || $from.marks()).find((mark) => mark.type === linkMark);
				if (!link) {
					const nodeAfter = $from.nodeAfter;
					const nodeBefore = $from.nodeBefore;
					const marksOnNodeAfter = nodeAfter && Array.isArray(nodeAfter.marks) ? nodeAfter.marks : [];
					const marksOnNodeBefore = nodeBefore && Array.isArray(nodeBefore.marks) ? nodeBefore.marks : [];
					link = marksOnNodeAfter.find((mark) => mark.type === linkMark) || marksOnNodeBefore.find((mark) => mark.type === linkMark);
				}
				if (link && link.attrs && link.attrs.href) href = link.attrs.href;
			} else state.doc.nodesBetween(selection.from, selection.to, (node) => {
				if (node.marks) {
					const link = node.marks.find((mark) => mark.type === linkMark);
					if (link && link.attrs && link.attrs.href) href = link.attrs.href;
				}
			});
			return href || "";
		};
		const text = ref("");
		const rawUrl = ref("");
		const isAnchor = ref(false);
		const HAS_PROTOCOL = /^[a-z][a-z0-9+.-]*:/i;
		const url = computed(() => {
			if (!rawUrl.value) return "";
			if (rawUrl.value.startsWith("#") || HAS_PROTOCOL.test(rawUrl.value)) return rawUrl.value;
			return "https://" + rawUrl.value;
		});
		const sanitizedUrl = computed(() => {
			if (!url.value) return null;
			return sanitizeHref(url.value);
		});
		const validUrl = computed(() => sanitizedUrl.value !== null);
		const isEditing = computed(() => !isAnchor.value && !!getLinkHrefAtSelection());
		const isDisabled = computed(() => !validUrl.value);
		const isViewingMode = computed(() => props.editor?.options?.documentMode === "viewing");
		const openLink = () => {
			const href = sanitizedUrl.value?.href;
			if (!href) return;
			window.open(href, "_blank");
		};
		const updateFromEditor = () => {
			text.value = getSelectedText();
			rawUrl.value = getLinkHrefAtSelection();
		};
		watch(() => props.editor?.state?.selection, () => {
			updateFromEditor();
		}, { immediate: true });
		const focusInput = () => {
			const input = document.querySelector(".link-input-ctn input");
			if (!input) return;
			input.focus();
		};
		onMounted(() => {
			updateFromEditor();
			isAnchor.value = rawUrl.value.startsWith("#");
			if (props.showInput) focusInput();
		});
		const handleSubmit = () => {
			if (isViewingMode.value) return;
			const editor = props.editor;
			if (!editor) return;
			if (!rawUrl.value) {
				if (editor.commands?.unsetLink) editor.commands.unsetLink();
				props.closePopover();
				return;
			}
			if (!validUrl.value) {
				urlError.value = true;
				return;
			}
			const href = sanitizedUrl.value?.href;
			if (!href) {
				urlError.value = true;
				return;
			}
			const finalText = text.value || href;
			if (editor.commands?.toggleLink) editor.commands.toggleLink({
				href,
				text: finalText
			});
			const endPos = editor.view.state.selection.$to.pos;
			editor.view.dispatch(editor.view.state.tr.setSelection(new TextSelection(editor.view.state.doc.resolve(endPos))));
			setTimeout(() => editor.view.focus(), 100);
			props.closePopover();
		};
		const handleRemove = () => {
			if (props.editor && props.editor.commands && props.editor.commands.unsetLink) {
				props.editor.commands.unsetLink();
				props.closePopover();
			}
		};
		const navigateToAnchor = (url$1) => {
			const presentationEditor = props.editor?.presentationEditor ?? null;
			if (presentationEditor) presentationEditor.goToAnchor(url$1);
			else if (props.goToAnchor) props.goToAnchor(url$1);
		};
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["link-input-ctn", { "high-contrast": unref(isHighContrastMode$1) }]) }, [isAnchor.value ? (openBlock(), createElementBlock("div", _hoisted_1$17, "Page anchor")) : isViewingMode.value ? (openBlock(), createElementBlock("div", _hoisted_2$14, "Link details")) : isEditing.value ? (openBlock(), createElementBlock("div", _hoisted_3$11, "Edit link")) : (openBlock(), createElementBlock("div", _hoisted_4$7, "Add link")), __props.showInput && !isAnchor.value ? (openBlock(), createElementBlock("div", _hoisted_5$6, [
				createElementVNode("div", _hoisted_6$4, [_cache[5] || (_cache[5] = createElementVNode("div", { class: "input-icon text-input-icon" }, "T", -1)), withDirectives(createElementVNode("input", {
					type: "text",
					name: "text",
					placeholder: "Text",
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => text.value = $event),
					readonly: isViewingMode.value,
					onKeydown: _cache[1] || (_cache[1] = withKeys(withModifiers(($event) => !isViewingMode.value && handleSubmit, ["stop", "prevent"]), ["enter"]))
				}, null, 40, _hoisted_7$3), [[vModelText, text.value]])]),
				createElementVNode("div", _hoisted_8$1, [
					createElementVNode("div", {
						class: "input-icon",
						innerHTML: unref(toolbarIcons).linkInput
					}, null, 8, _hoisted_9$1),
					withDirectives(createElementVNode("input", {
						type: "text",
						name: "link",
						placeholder: "Type or paste a link",
						class: normalizeClass({ "sd-error": urlError.value }),
						"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => rawUrl.value = $event),
						readonly: isViewingMode.value,
						onKeydown: [withKeys(withModifiers(handleSubmit, ["stop", "prevent"]), ["enter"]), _cache[3] || (_cache[3] = ($event) => urlError.value = false)]
					}, null, 42, _hoisted_10$1), [[vModelText, rawUrl.value]]),
					createElementVNode("div", {
						class: normalizeClass(["open-link-icon", { "sd-disabled": !validUrl.value }]),
						innerHTML: unref(toolbarIcons).openLink,
						onClick: openLink,
						"data-item": "btn-link-open"
					}, null, 10, _hoisted_11$1)
				]),
				!isViewingMode.value ? (openBlock(), createElementBlock("div", _hoisted_12$1, [isEditing.value ? (openBlock(), createElementBlock("button", {
					key: 0,
					class: "remove-btn",
					onClick: handleRemove,
					"data-item": "btn-link-remove"
				}, [createElementVNode("div", {
					class: "remove-btn__icon",
					innerHTML: unref(toolbarIcons).removeLink
				}, null, 8, _hoisted_13$1), _cache[6] || (_cache[6] = createTextVNode(" Remove ", -1))])) : createCommentVNode("", true), createElementVNode("button", {
					class: normalizeClass(["sd-submit-btn", { "disable-btn": isDisabled.value }]),
					onClick: handleSubmit,
					"data-item": "btn-link-apply"
				}, " Apply ", 2)])) : createCommentVNode("", true)
			])) : isAnchor.value ? (openBlock(), createElementBlock("div", _hoisted_14$1, [createElementVNode("a", { onClick: _cache[4] || (_cache[4] = withModifiers(($event) => navigateToAnchor(rawUrl.value), ["stop", "prevent"])) }, "Go to " + toDisplayString(rawUrl.value.startsWith("#_") ? rawUrl.value.substring(2) : rawUrl.value), 1)])) : createCommentVNode("", true)], 2);
		};
	}
}, [["__scopeId", "data-v-c490d677"]]);
var _hoisted_1$16 = [
	"aria-label",
	"onClick",
	"onKeydown"
];
var _hoisted_2$13 = ["innerHTML"];
var _hoisted_3$10 = ["innerHTML"];
var ROW_SIZE$1 = 7;
var IconGridRow_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "IconGridRow",
	props: {
		icons: {
			type: Array,
			required: true
		},
		activeColor: {
			type: Object,
			required: false
		}
	},
	emits: ["select", "clickoutside"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const props = __props;
		const isActive$1 = computed(() => (option) => {
			if (!props.activeColor.value) return false;
			return props.activeColor.value.toUpperCase() === option.value;
		});
		const getCheckStyle = (color, optionIndex) => {
			if (optionIndex === 5 || ["#FFFFFF", "#FAFF09"].includes(color)) return { color: "#000" };
			return { color: "#FFF" };
		};
		const handleClick$1 = (option) => {
			emit("select", option.value);
		};
		const rowRefs = ref([]);
		const iconRefs = ref([]);
		onMounted(() => {
			if (!props.icons.every((row) => Array.isArray(row))) throw new Error("icon props must be 2d array");
			const firstIcon = iconRefs.value[0];
			if (firstIcon) {
				firstIcon.setAttribute("tabindex", "0");
				firstIcon.focus();
			}
		});
		const moveToNextIcon = (rowIndex, optionIndex) => {
			const iconIndex = ROW_SIZE$1 * rowIndex + optionIndex + 1;
			const nextIcon = iconRefs.value[iconIndex];
			if (nextIcon) {
				nextIcon.setAttribute("tabindex", "0");
				nextIcon.focus();
			}
		};
		const moveToPreviousIcon = (rowIndex, optionIndex) => {
			const iconIndex = ROW_SIZE$1 * rowIndex + optionIndex - 1;
			const previousIcon = iconRefs.value[iconIndex];
			if (previousIcon) {
				previousIcon.setAttribute("tabindex", "0");
				previousIcon.focus();
			}
		};
		const moveToNextRow = (rowIndex, optionIndex) => {
			const iconIndex = optionIndex + ROW_SIZE$1 * (rowIndex + 1);
			const nextIcon = iconRefs.value[iconIndex];
			if (nextIcon) {
				nextIcon.setAttribute("tabindex", "0");
				nextIcon.focus();
			}
		};
		const moveToPreviousRow = (rowIndex, optionIndex) => {
			const iconIndex = optionIndex + ROW_SIZE$1 * (rowIndex - 1);
			const previousIcon = iconRefs.value[iconIndex];
			if (previousIcon) {
				previousIcon.setAttribute("tabindex", "0");
				previousIcon.focus();
			}
		};
		const handleKeyDown$1 = (event, rowIndex, optionIndex, option) => {
			switch (event.key) {
				case "ArrowRight":
					moveToNextIcon(rowIndex, optionIndex);
					break;
				case "ArrowLeft":
					moveToPreviousIcon(rowIndex, optionIndex);
					break;
				case "ArrowDown":
					moveToNextRow(rowIndex, optionIndex);
					break;
				case "ArrowUp":
					moveToPreviousRow(rowIndex, optionIndex);
					break;
				case "Enter":
					handleClick$1(option);
					break;
				case "Escape":
					emit("clickoutside");
					break;
				default: break;
			}
		};
		return (_ctx, _cache) => {
			return openBlock(true), createElementBlock(Fragment, null, renderList(__props.icons, (row, rowIndex) => {
				return openBlock(), createElementBlock("div", {
					class: "sd-option-row",
					key: rowIndex,
					role: "group",
					ref_for: true,
					ref_key: "rowRefs",
					ref: rowRefs
				}, [(openBlock(true), createElementBlock(Fragment, null, renderList(row, (option, optionIndex) => {
					return openBlock(), createElementBlock("div", {
						class: "sd-option",
						key: optionIndex,
						"aria-label": option.label,
						role: "menuitem",
						ref_for: true,
						ref_key: "iconRefs",
						ref: iconRefs,
						onClick: withModifiers(($event) => handleClick$1(option), ["stop", "prevent"]),
						onKeydown: withModifiers((event) => handleKeyDown$1(event, rowIndex, optionIndex, option), ["prevent"])
					}, [createElementVNode("div", {
						class: "sd-option__icon",
						innerHTML: option.icon,
						style: normalizeStyle(option.style)
					}, null, 12, _hoisted_2$13), isActive$1.value(option) ? (openBlock(), createElementBlock("div", {
						key: 0,
						class: "sd-option__check",
						innerHTML: unref(toolbarIcons).colorOptionCheck,
						style: normalizeStyle(getCheckStyle(option.value, optionIndex))
					}, null, 12, _hoisted_3$10)) : createCommentVNode("", true)], 40, _hoisted_1$16);
				}), 128))]);
			}), 128);
		};
	}
}, [["__scopeId", "data-v-30cad300"]]);
var droplet_slash_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M320 512c53.2 0 101.4-21.6 136.1-56.6l-298.3-235C140 257.1 128 292.3 128 320c0 106 86 192 192 192zM505.2 370.7c4.4-16.2 6.8-33.1 6.8-50.7c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0l-1.8 0c-9.6 0-18.5 4.2-24.5 11.7C277.8 33 240.7 81.3 205.8 136L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L505.2 370.7zM224 336c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16s16 7.2 16 16z\"/></svg>\n";
var _hoisted_1$15 = { class: "options-grid-wrap" };
var _hoisted_2$12 = ["innerHTML"];
var _hoisted_3$9 = { class: "option-grid-ctn" };
var IconGrid_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "IconGrid",
	props: {
		icons: {
			type: Array,
			required: true
		},
		customIcons: {
			type: Array,
			required: false
		},
		activeColor: {
			type: Object,
			required: false
		},
		hasNoneIcon: {
			type: Boolean,
			required: false
		}
	},
	emits: ["select", "clickoutside"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const handleSelect = (option) => {
			emit("select", option);
		};
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$15, [__props.hasNoneIcon ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: "none-option",
				role: "menuitem",
				"aria-label": "Clear color selection",
				onClick: _cache[0] || (_cache[0] = ($event) => handleSelect("none"))
			}, [createElementVNode("span", {
				innerHTML: unref(droplet_slash_default),
				class: "none-icon"
			}, null, 8, _hoisted_2$12), _cache[1] || (_cache[1] = createTextVNode(" None ", -1))])) : createCommentVNode("", true), createElementVNode("div", _hoisted_3$9, [createVNode(IconGridRow_default, {
				icons: __props.icons,
				"active-color": __props.activeColor,
				onSelect: handleSelect
			}, null, 8, ["icons", "active-color"]), __props.customIcons.flat().length ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [_cache[2] || (_cache[2] = createElementVNode("span", { class: "option-grid-ctn__subtitle" }, "Custom colors", -1)), createVNode(IconGridRow_default, {
				icons: __props.customIcons,
				"active-color": __props.activeColor,
				onSelect: handleSelect
			}, null, 8, ["icons", "active-color"])], 64)) : createCommentVNode("", true)])]);
		};
	}
}, [["__scopeId", "data-v-b243fab8"]]);
var closeDropdown$1 = (dropdown) => {
	dropdown.expand.value = false;
};
const makeColorOption = (color, label = null) => {
	return {
		label,
		icon: toolbarIcons.colorOption,
		value: color,
		style: {
			color,
			boxShadow: "0 0 5px 1px rgba(0, 0, 0, 0.1)",
			borderRadius: "50%"
		}
	};
};
const renderColorOptions = (superToolbar, button, customIcons = [], hasNoneIcon = false) => {
	const handleSelect = (e) => {
		button.iconColor.value = e;
		superToolbar.emitCommand({
			item: button,
			argument: e
		});
		closeDropdown$1(button);
	};
	return h("div", {}, [h(IconGrid_default, {
		icons,
		customIcons,
		activeColor: button.iconColor,
		hasNoneIcon,
		onSelect: handleSelect
	})]);
};
const icons = [
	[
		makeColorOption("#111111", "black"),
		makeColorOption("#333333", "dark gray"),
		makeColorOption("#5C5C5C", "medium gray"),
		makeColorOption("#858585", "light gray"),
		makeColorOption("#ADADAD", "very light gray"),
		makeColorOption("#D6D6D6", "transparent gray"),
		makeColorOption("#FFFFFF", "white")
	],
	[
		makeColorOption("#860028", "dark red"),
		makeColorOption("#D2003F", "red"),
		makeColorOption("#DB3365", "coral red"),
		makeColorOption("#E4668C", "light red"),
		makeColorOption("#ED99B2", "pale pink"),
		makeColorOption("#F6CCD9", "transparent pink"),
		makeColorOption("#FF004D", "bright pink")
	],
	[
		makeColorOption("#83015E", "dark purple"),
		makeColorOption("#CD0194", "purple"),
		makeColorOption("#D734A9", "orchid"),
		makeColorOption("#E167BF", "light purple"),
		makeColorOption("#EB99D4", "lavender"),
		makeColorOption("#F5CCEA", "transparent pink"),
		makeColorOption("#FF00A8", "neon pink")
	],
	[
		makeColorOption("#8E220A", "maroon"),
		makeColorOption("#DD340F", "red-orange"),
		makeColorOption("#E45C3F", "burnt orange"),
		makeColorOption("#EB856F", "peach"),
		makeColorOption("#F1AE9F", "pale peach"),
		makeColorOption("#F8D6CF", "transparent peach"),
		makeColorOption("#FF7A00", "orange")
	],
	[
		makeColorOption("#947D02", "olive"),
		makeColorOption("#E7C302", "mustard yellow"),
		makeColorOption("#ECCF35", "yellow"),
		makeColorOption("#F1DB67", "light yellow"),
		makeColorOption("#F5E79A", "very pale yellow"),
		makeColorOption("#FAF3CC", "transparent yellow"),
		makeColorOption("#FAFF09", "neon yellow")
	],
	[
		makeColorOption("#055432", "forest green"),
		makeColorOption("#07834F", "green"),
		makeColorOption("#399C72", "medium green"),
		makeColorOption("#6AB595", "light green"),
		makeColorOption("#9CCDB9", "mint"),
		makeColorOption("#CDE6DC", "transparent mint"),
		makeColorOption("#05F38F", "bright teal")
	],
	[
		makeColorOption("#063E7E", "navy blue"),
		makeColorOption("#0A60C5", "blue"),
		makeColorOption("#3B80D1", "sky blue"),
		makeColorOption("#6CA0DC", "cornflower blue"),
		makeColorOption("#9DBFE8", "light blue"),
		makeColorOption("#CEDFF3", "very light blue"),
		makeColorOption("#21c8ce", "cyan")
	],
	[
		makeColorOption("#3E027A", "deep purple"),
		makeColorOption("#6103BF", "indigo"),
		makeColorOption("#8136CC", "violet"),
		makeColorOption("#A068D9", "lavender pink"),
		makeColorOption("#C09AE6", "light lilac"),
		makeColorOption("#DFCDF2", "transparent lilac"),
		makeColorOption("#A91DFF", "neon purple")
	]
];
const getAvailableColorOptions = () => {
	return icons.flat().map((item) => item.value);
};
var _hoisted_1$14 = [
	"data-cols",
	"data-rows",
	"onKeydown",
	"onClick"
];
var _hoisted_2$11 = ["aria-valuetext"];
var ROW_SIZE = 5;
var TableGrid_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "TableGrid",
	emits: ["select", "clickoutside"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const selectedRows = ref(0);
		const selectedCols = ref(0);
		const { isHighContrastMode: isHighContrastMode$1 } = useHighContrastMode();
		const tableGridItems = ref([]);
		const onTableGridMouseOver = (event) => {
			let target = event.target;
			if (!!target.dataset.grid) return;
			selectGridItems([...target.parentElement.querySelectorAll("[data-item]")], parseInt(target.dataset.cols, 10), parseInt(target.dataset.rows, 10));
		};
		const selectGridItems = (allItems, cols, rows) => {
			selectedCols.value = cols;
			selectedRows.value = rows;
			for (let i = 0; i < allItems.length; i++) {
				let item = allItems[i];
				let itemsCols = parseInt(item.dataset.cols, 10);
				let itemsRows = parseInt(item.dataset.rows, 10);
				if (itemsCols <= cols && itemsRows <= rows) item.classList.add("sd-selected");
				else item.classList.remove("sd-selected");
			}
		};
		const handleClick$1 = ({ cols, rows }) => {
			emit("select", {
				cols,
				rows
			});
		};
		const handleKeyDown$1 = (event, cols, rows) => {
			let normalizedCols = cols - 1;
			let normalizedRows = rows - 1;
			switch (event.key) {
				case "ArrowRight": {
					if (normalizedCols >= 4) return;
					const currentRow = normalizedRows * ROW_SIZE;
					tableGridItems.value[currentRow + normalizedCols + 1].setAttribute("tabindex", "0");
					tableGridItems.value[currentRow + normalizedCols + 1].focus();
					selectGridItems(tableGridItems.value, cols + 1, rows);
					break;
				}
				case "ArrowLeft": {
					if (normalizedCols <= 0) return;
					const currentRow = normalizedRows * ROW_SIZE;
					tableGridItems.value[currentRow + normalizedCols - 1].setAttribute("tabindex", "0");
					tableGridItems.value[currentRow + normalizedCols - 1].focus();
					selectGridItems(tableGridItems.value, cols - 1, rows);
					break;
				}
				case "ArrowDown": {
					if (normalizedRows >= 4) return;
					const nextRow = (normalizedRows + 1) * ROW_SIZE;
					tableGridItems.value[nextRow + normalizedCols].setAttribute("tabindex", "0");
					tableGridItems.value[nextRow + normalizedCols].focus();
					selectGridItems(tableGridItems.value, cols, rows + 1);
					break;
				}
				case "ArrowUp": {
					if (normalizedRows <= 0) return;
					const previousRow = (normalizedRows - 1) * ROW_SIZE;
					tableGridItems.value[previousRow + normalizedCols].setAttribute("tabindex", "0");
					tableGridItems.value[previousRow + normalizedCols].focus();
					selectGridItems(tableGridItems.value, cols, rows - 1);
					break;
				}
				case "Enter":
					handleClick$1({
						cols,
						rows
					});
					break;
				default: break;
			}
		};
		onMounted(() => {
			tableGridItems.value[0].setAttribute("tabindex", "0");
			tableGridItems.value[0].focus();
			selectGridItems(tableGridItems.value, 1, 1);
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["toolbar-table-grid-wrapper", { "high-contrast": unref(isHighContrastMode$1) }]) }, [createElementVNode("div", {
				class: "toolbar-table-grid",
				onMouseover: onTableGridMouseOver,
				"data-grid": "true"
			}, [(openBlock(), createElementBlock(Fragment, null, renderList(5, (i) => {
				return openBlock(), createElementBlock(Fragment, { key: i }, [(openBlock(), createElementBlock(Fragment, null, renderList(5, (n) => {
					return createElementVNode("div", {
						class: "toolbar-table-grid__item",
						key: `${i}_${n}`,
						"data-cols": n,
						"data-rows": i,
						"data-item": "true",
						ref_for: true,
						ref_key: "tableGridItems",
						ref: tableGridItems,
						onKeydown: withModifiers((event) => handleKeyDown$1(event, n, i), ["prevent"]),
						onClick: withModifiers(($event) => handleClick$1({
							cols: n,
							rows: i
						}), ["stop", "prevent"])
					}, null, 40, _hoisted_1$14);
				}), 64))], 64);
			}), 64))], 32), createElementVNode("div", {
				class: "toolbar-table-grid-value",
				"aria-valuetext": `${selectedRows.value} x ${selectedCols.value}`
			}, toDisplayString(selectedRows.value) + " x " + toDisplayString(selectedCols.value), 9, _hoisted_2$11)], 2);
		};
	}
}, [["__scopeId", "data-v-168b91ce"]]);
var _hoisted_1$13 = { class: "toolbar-table-actions" };
var _hoisted_2$10 = [
	"onClick",
	"data-item",
	"ariaLabel"
];
var _hoisted_3$8 = { class: "toolbar-table-actions__icon" };
var _hoisted_4$6 = ["innerHTML"];
var _hoisted_5$5 = { class: "toolbar-table-actions__label" };
var TableActions_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "TableActions",
	props: { options: { type: Array } },
	emits: ["select"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const handleClick$1 = (item) => {
			emit("select", { command: item.command });
		};
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$13, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.options, (option) => {
				return openBlock(), createElementBlock("div", {
					class: normalizeClass(["toolbar-table-actions__item", { "toolbar-table-actions__item--border": option.bottomBorder }]),
					onClick: ($event) => handleClick$1(option),
					"data-item": option.props?.["data-item"] || "",
					ariaLabel: option.props?.ariaLabel,
					role: "menuitem"
				}, [createElementVNode("div", _hoisted_3$8, [createElementVNode("div", {
					class: "toolbar-table-actions__icon-wrapper",
					innerHTML: option.icon
				}, null, 8, _hoisted_4$6)]), createElementVNode("div", _hoisted_5$5, toDisplayString(option.label), 1)], 10, _hoisted_2$10);
			}), 256))]);
		};
	}
}, [["__scopeId", "data-v-652015c8"]]);
function getScrollableParent(element) {
	let currentElement = element;
	while (currentElement) {
		const overflowY = window.getComputedStyle(currentElement).overflowY;
		if (/(auto|scroll)/.test(overflowY) && currentElement.scrollHeight > currentElement.clientHeight) return currentElement;
		currentElement = currentElement.parentElement;
	}
	return document.scrollingElement || document.documentElement;
}
function scrollToElement(targetElement, options = {
	behavior: "smooth",
	block: "start"
}) {
	if (!targetElement) return;
	const container = getScrollableParent(targetElement);
	const containerRect = container.getBoundingClientRect();
	const offsetTop = targetElement.getBoundingClientRect().top - containerRect.top + container.scrollTop;
	container.scrollTo({
		top: options.block === "start" ? offsetTop : offsetTop - container.clientHeight + targetElement.offsetHeight,
		behavior: options.behavior
	});
}
var check_default = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z\"/></svg>\n";
var _hoisted_1$12 = { class: "search-input-ctn" };
var _hoisted_2$9 = { class: "sd-row" };
var _hoisted_3$7 = ["onKeydown"];
var SearchInput_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "SearchInput",
	props: { searchRef: { type: Object } },
	emits: ["submit"],
	setup(__props, { emit: __emit }) {
		const searchValue = ref("");
		const emit = __emit;
		const handleSubmit = () => {
			emit("submit", { value: searchValue.value });
		};
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$12, [createElementVNode("div", _hoisted_2$9, [withDirectives(createElementVNode("input", {
				ref: __props.searchRef,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => searchValue.value = $event),
				class: "search-input",
				type: "text",
				name: "search",
				placeholder: "Type search string",
				onKeydown: withKeys(withModifiers(handleSubmit, ["stop", "prevent"]), ["enter"])
			}, null, 40, _hoisted_3$7), [[vModelText, searchValue.value]])]), createElementVNode("div", { class: "sd-row sd-submit" }, [createElementVNode("button", {
				class: "sd-submit-btn",
				onClick: handleSubmit
			}, "Apply")])]);
		};
	}
}, [["__scopeId", "data-v-d25821a5"]]);
const TOOLBAR_FONTS = getBuiltInToolbarFontOfferings().map((offering) => ({
	label: offering.logicalFamily,
	key: fontOfferingStack(offering),
	fontWeight: 400,
	props: {
		style: { fontFamily: fontOfferingRenderStack(offering) },
		"data-item": "btn-fontFamily-option"
	}
}));
function normalizeToolbarFamily(value) {
	return String(value ?? "").trim().toLowerCase();
}
function compareToolbarFontOptions(a, b$1) {
	return String(a.label ?? "").trim().localeCompare(String(b$1.label ?? "").trim(), "en", { sensitivity: "base" });
}
function composeToolbarFontOptions(documentOptions, configFonts) {
	if (configFonts) return configFonts;
	if (!documentOptions?.length) return void 0;
	const seen = new Set(TOOLBAR_FONTS.map((option) => normalizeToolbarFamily(option.label)));
	const merged = [...TOOLBAR_FONTS];
	for (const option of documentOptions) {
		const dedupeKey = normalizeToolbarFamily(option.logicalFamily);
		if (seen.has(dedupeKey)) continue;
		seen.add(dedupeKey);
		merged.push({
			label: option.logicalFamily,
			key: option.logicalFamily,
			fontWeight: 400,
			props: {
				style: { fontFamily: option.previewFamily || option.logicalFamily },
				"data-item": "btn-fontFamily-option"
			}
		});
	}
	return merged.length > TOOLBAR_FONTS.length ? merged.sort(compareToolbarFontOptions) : void 0;
}
const TOOLBAR_FONT_SIZES = [
	{
		label: "8",
		key: "8pt",
		props: { "data-item": "btn-fontSize-option" }
	},
	{
		label: "9",
		key: "9pt",
		props: { "data-item": "btn-fontSize-option" }
	},
	{
		label: "10",
		key: "10pt",
		props: { "data-item": "btn-fontSize-option" }
	},
	{
		label: "11",
		key: "11pt",
		props: { "data-item": "btn-fontSize-option" }
	},
	{
		label: "12",
		key: "12pt",
		props: { "data-item": "btn-fontSize-option" }
	},
	{
		label: "14",
		key: "14pt",
		props: { "data-item": "btn-fontSize-option" }
	},
	{
		label: "18",
		key: "18pt",
		props: { "data-item": "btn-fontSize-option" }
	},
	{
		label: "24",
		key: "24pt",
		props: { "data-item": "btn-fontSize-option" }
	},
	{
		label: "30",
		key: "30pt",
		props: { "data-item": "btn-fontSize-option" }
	},
	{
		label: "36",
		key: "36pt",
		props: { "data-item": "btn-fontSize-option" }
	},
	{
		label: "48",
		key: "48pt",
		props: { "data-item": "btn-fontSize-option" }
	},
	{
		label: "60",
		key: "60pt",
		props: { "data-item": "btn-fontSize-option" }
	},
	{
		label: "72",
		key: "72pt",
		props: { "data-item": "btn-fontSize-option" }
	},
	{
		label: "96",
		key: "96pt",
		props: { "data-item": "btn-fontSize-option" }
	}
];
const RESPONSIVE_BREAKPOINTS = {
	sm: 768,
	md: 1024,
	lg: 1280,
	xl: 1410
};
const HEADLESS_ITEM_MAP = {
	undo: "undo",
	redo: "redo",
	bold: "bold",
	italic: "italic",
	underline: "underline",
	strike: "strikethrough",
	acceptTrackedChangeBySelection: "track-changes-accept-selection",
	rejectTrackedChangeOnSelection: "track-changes-reject-selection",
	ruler: "ruler",
	formattingMarks: "formatting-marks",
	zoom: "zoom",
	documentMode: "document-mode",
	link: "link",
	fontFamily: "font-family",
	fontSize: "font-size",
	list: "bullet-list",
	numberedlist: "numbered-list",
	table: "table-insert",
	image: "image",
	tableOfContents: "table-of-contents-insert",
	color: "text-color",
	highlight: "highlight-color",
	textAlign: "text-align",
	lineHeight: "line-height",
	linkedStyles: "linked-style",
	indentleft: "indent-decrease",
	indentright: "indent-increase",
	directionLtr: "direction-ltr",
	directionRtl: "direction-rtl",
	clearFormatting: "clear-formatting",
	copyFormat: "copy-format"
};
const TABLE_ACTION_COMMAND_MAP = {
	addRowBefore: "table-add-row-before",
	addRowAfter: "table-add-row-after",
	deleteRow: "table-delete-row",
	addColumnBefore: "table-add-column-before",
	addColumnAfter: "table-add-column-after",
	deleteColumn: "table-delete-column",
	deleteTable: "table-delete",
	deleteCellAndTableBorders: "table-remove-borders",
	mergeCells: "table-merge-cells",
	splitCell: "table-split-cell",
	fixTables: "table-fix"
};
const TABLE_ACTION_COMMAND_IDS = Object.values(TABLE_ACTION_COMMAND_MAP);
const HEADLESS_TOOLBAR_COMMANDS = [...new Set([...Object.values(HEADLESS_ITEM_MAP), ...TABLE_ACTION_COMMAND_IDS])];
var NON_HEADLESS_EXECUTE_ITEM_NAMES = new Set(["link"]);
const HEADLESS_EXECUTE_ITEMS = new Set(Object.keys(HEADLESS_ITEM_MAP).filter((itemName) => !NON_HEADLESS_EXECUTE_ITEM_NAMES.has(itemName)));
var closeDropdown = (dropdown) => {
	dropdown.expand.value = false;
};
const makeDefaultItems = ({ superToolbar, toolbarIcons: toolbarIcons$1, toolbarTexts: toolbarTexts$1, toolbarFonts, hideButtons, availableWidth, role, isDev = false } = {}) => {
	const bold = useToolbarItem({
		type: "button",
		name: "bold",
		command: "toggleBold",
		icon: toolbarIcons$1.bold,
		tooltip: toolbarTexts$1.bold,
		attributes: { ariaLabel: "Bold" }
	});
	const fontOptions = (toolbarFonts ?? TOOLBAR_FONTS).map(normalizeFontOption);
	const fontButton = useToolbarItem({
		type: "dropdown",
		name: "fontFamily",
		tooltip: toolbarTexts$1.fontFamily,
		command: "setFontFamily",
		defaultLabel: "Arial",
		label: "Arial",
		markName: "textStyle",
		labelAttr: "fontFamily",
		hasCaret: true,
		isWide: true,
		style: { width: "116px" },
		suppressActiveHighlight: true,
		attributes: { ariaLabel: "Font family" },
		options: fontOptions,
		onActivate: ({ fontFamily }) => {
			if (!fontFamily) return;
			fontFamily = fontFamily.split(",")[0];
			fontButton.label.value = fontFamily;
			const defaultFont = fontOptions.find((i) => i.label === fontButton.defaultLabel.value);
			const foundFont = fontOptions.find((i) => i.label === fontFamily);
			if (foundFont) fontButton.selectedValue.value = foundFont.key;
			else if (defaultFont) fontButton.selectedValue.value = defaultFont.key;
			else fontButton.selectedValue.value = "";
		},
		onDeactivate: () => {
			fontButton.label.value = fontButton.defaultLabel.value;
			const defaultFont = fontOptions.find((i) => i.label === fontButton.defaultLabel.value);
			if (defaultFont) fontButton.selectedValue.value = defaultFont.key;
			else fontButton.selectedValue.value = "";
		}
	});
	const aiButton = useToolbarItem({
		type: "dropdown",
		dropdownStyles: {
			padding: 0,
			outline: "none"
		},
		name: "ai",
		tooltip: toolbarTexts$1.ai,
		icon: toolbarIcons$1.ai,
		hideLabel: true,
		hasCaret: false,
		isWide: true,
		suppressActiveHighlight: true,
		attributes: { ariaLabel: "AI" },
		options: [{
			type: "render",
			key: "ai",
			render: () => {
				let selectedText = "";
				if (superToolbar.activeEditor) {
					const { state } = superToolbar.activeEditor;
					const { from: from$1, to, empty: empty$1 } = state.selection;
					selectedText = !empty$1 ? state.doc.textBetween(from$1, to) : "";
				}
				const handleClose = () => {
					closeDropdown(aiButton);
				};
				return h("div", {}, [h(AIWriter_default, {
					handleClose,
					selectedText,
					editor: superToolbar.activeEditor,
					apiKey: superToolbar.config.aiApiKey,
					endpoint: superToolbar.config.aiEndpoint,
					superToolbar
				})]);
			}
		}]
	});
	const fontSizeOptions = TOOLBAR_FONT_SIZES;
	const fontSize = useToolbarItem({
		type: "dropdown",
		name: "fontSize",
		defaultLabel: "12",
		label: "12",
		minWidth: "50px",
		markName: "textStyle",
		labelAttr: "fontSize",
		tooltip: toolbarTexts$1.fontSize,
		hasCaret: true,
		hasInlineTextInput: true,
		inlineTextInputVisible: true,
		suppressActiveHighlight: true,
		isWide: true,
		command: "setFontSize",
		attributes: { ariaLabel: "Font size" },
		options: fontSizeOptions,
		onActivate: ({ fontSize: size$1 }, isMultiple = false) => {
			if (isMultiple) {
				fontSize.label.value = "";
				fontSize.selectedValue.value = "";
				return;
			}
			const defaultSize = fontSizeOptions.find((i) => i.label === String(fontSize.defaultLabel.value));
			if (!size$1) {
				fontSize.label.value = fontSize.defaultLabel.value;
				if (defaultSize) fontSize.selectedValue.value = defaultSize.key;
				else fontSize.selectedValue.value = "";
				return;
			}
			let sanitizedValue = sanitizeNumber(size$1, 12);
			if (sanitizedValue < 8) sanitizedValue = 8;
			if (sanitizedValue > 96) sanitizedValue = 96;
			let sanitizedValueStr = String(sanitizedValue);
			const foundSize = fontSizeOptions.find((i) => {
				return i.label === sanitizedValueStr || i.key === sanitizedValueStr;
			});
			if (foundSize) fontSize.selectedValue.value = foundSize.key;
			else fontSize.selectedValue.value = "";
			fontSize.label.value = sanitizedValueStr;
		},
		onDeactivate: () => {
			fontSize.label.value = fontSize.defaultLabel.value;
			const defaultSize = fontSizeOptions.find((i) => i.label === String(fontSize.defaultLabel.value));
			if (defaultSize) fontSize.selectedValue.value = defaultSize.key;
			else fontSize.selectedValue.value = "";
		}
	});
	const separator = useToolbarItem({
		type: "separator",
		name: "separator",
		isNarrow: true
	});
	const italic = useToolbarItem({
		type: "button",
		name: "italic",
		command: "toggleItalic",
		icon: toolbarIcons$1.italic,
		active: false,
		tooltip: toolbarTexts$1.italic,
		attributes: { ariaLabel: "Italic" }
	});
	const underline = useToolbarItem({
		type: "button",
		name: "underline",
		command: "toggleUnderline",
		icon: toolbarIcons$1.underline,
		active: false,
		tooltip: toolbarTexts$1.underline,
		attributes: { ariaLabel: "Underline" }
	});
	const strikethrough = useToolbarItem({
		type: "button",
		name: "strike",
		command: "toggleStrike",
		icon: toolbarIcons$1.strikethrough,
		active: false,
		tooltip: toolbarTexts$1.strikethrough,
		attributes: { ariaLabel: "Strikethrough" }
	});
	const highlight = useToolbarItem({
		type: "dropdown",
		name: "highlight",
		icon: toolbarIcons$1.highlight,
		hideLabel: true,
		markName: "highlight",
		labelAttr: "color",
		active: false,
		tooltip: toolbarTexts$1.highlight,
		command: "setHighlight",
		noArgumentCommand: "unsetHighlight",
		suppressActiveHighlight: true,
		attributes: { ariaLabel: "Highlight" },
		options: [{
			key: "color",
			type: "render",
			render: () => renderColorOptions(superToolbar, highlight, [], true)
		}],
		onActivate: ({ color }) => {
			highlight.iconColor.value = color || "";
		},
		onDeactivate: () => highlight.iconColor.value = ""
	});
	const colorButton = useToolbarItem({
		type: "dropdown",
		name: "color",
		icon: toolbarIcons$1.color,
		hideLabel: true,
		markName: "textStyle",
		labelAttr: "color",
		active: false,
		tooltip: toolbarTexts$1.color,
		command: "setColor",
		suppressActiveHighlight: true,
		attributes: { ariaLabel: "Color" },
		options: [{
			key: "color",
			type: "render",
			render: () => renderColorOptions(superToolbar, colorButton)
		}],
		onActivate: ({ color }) => {
			colorButton.iconColor.value = color;
		},
		onDeactivate: () => colorButton.iconColor.value = "#000"
	});
	const searchRef = ref(null);
	const search$1 = useToolbarItem({
		type: "dropdown",
		name: "search",
		active: false,
		icon: toolbarIcons$1.search,
		tooltip: toolbarTexts$1.search,
		group: "right",
		inputRef: searchRef,
		attributes: { ariaLabel: "Search" },
		options: [{
			type: "render",
			key: "searchDropdown",
			render: () => renderSearchDropdown()
		}]
	});
	const renderSearchDropdown = () => {
		const handleSubmit = ({ value }) => {
			superToolbar.activeEditor.commands.search(value, { searchModel: "visible" });
		};
		return h("div", {}, [h(SearchInput_default, {
			onSubmit: handleSubmit,
			searchRef
		})]);
	};
	const link = useToolbarItem({
		type: "dropdown",
		name: "link",
		markName: "link",
		icon: toolbarIcons$1.link,
		active: false,
		tooltip: toolbarTexts$1.link,
		attributes: { ariaLabel: "Link dropdown" },
		options: [{
			type: "render",
			key: "linkDropdown",
			render: () => renderLinkDropdown(link)
		}],
		onActivate: ({ href }) => {
			if (href) link.attributes.value = { href };
			else link.attributes.value = {};
		},
		onDeactivate: () => {
			link.attributes.value = {};
			link.expand.value = false;
		}
	});
	function renderLinkDropdown(link$1) {
		return h("div", {}, [h(LinkInput_default, {
			editor: superToolbar.activeEditor,
			closePopover: () => closeDropdown(link$1),
			goToAnchor: () => {
				closeDropdown(link$1);
				if (!superToolbar.activeEditor || !link$1.attributes.value?.href) return;
				const anchorName = link$1.attributes.value?.href?.slice(1);
				const anchor = superToolbar.activeEditor.element.querySelector(`a[name='${anchorName}']`);
				if (anchor) scrollToElement(anchor);
			}
		})]);
	}
	const linkInput = useToolbarItem({
		type: "options",
		name: "linkInput",
		command: "toggleLink",
		active: false
	});
	link.childItem = linkInput;
	linkInput.parentItem = link;
	const image = useToolbarItem({
		type: "button",
		name: "image",
		command: "startImageUpload",
		icon: toolbarIcons$1.image,
		active: false,
		tooltip: toolbarTexts$1.image,
		disabled: false,
		attributes: { ariaLabel: "Image" }
	});
	const tableOfContents = useToolbarItem({
		type: "button",
		name: "tableOfContents",
		command: "insertTableOfContents",
		icon: toolbarIcons$1.tableOfContents,
		active: false,
		tooltip: toolbarTexts$1.tableOfContents,
		disabled: false,
		attributes: { ariaLabel: "Table of contents" }
	});
	const tableItem = useToolbarItem({
		type: "dropdown",
		name: "table",
		icon: toolbarIcons$1.table,
		hideLabel: true,
		labelAttr: "table",
		active: false,
		tooltip: toolbarTexts$1.table,
		command: "insertTable",
		suppressActiveHighlight: true,
		attributes: { ariaLabel: "Table" },
		options: [{
			key: "table",
			type: "render",
			render: () => renderTableGrid(tableItem)
		}]
	});
	function renderTableGrid(tableItem$1) {
		const handleSelect = (e) => {
			superToolbar.emitCommand({
				item: tableItem$1,
				argument: e
			});
			closeDropdown(tableItem$1);
		};
		return h("div", {}, [h(TableGrid_default, { onSelect: handleSelect })]);
	}
	const tableActionsItem = useToolbarItem({
		type: "dropdown",
		name: "tableActions",
		command: "executeTableCommand",
		tooltip: toolbarTexts$1.tableActions,
		icon: toolbarIcons$1.tableActions,
		hideLabel: true,
		disabled: true,
		attributes: { ariaLabel: "Table actions" },
		options: [{
			type: "render",
			render: () => renderTableActions(tableActionsItem)
		}]
	});
	const tableActionsOptions$1 = [
		{
			label: toolbarTexts$1.addRowBefore,
			command: "addRowBefore",
			icon: toolbarIcons$1.addRowBefore,
			props: {
				"data-item": "btn-tableActions-option",
				ariaLabel: "Add row before"
			}
		},
		{
			label: toolbarTexts$1.addRowAfter,
			command: "addRowAfter",
			icon: toolbarIcons$1.addRowAfter,
			props: {
				"data-item": "btn-tableActions-option",
				ariaLabel: "Add row after"
			}
		},
		{
			label: toolbarTexts$1.addColumnBefore,
			command: "addColumnBefore",
			icon: toolbarIcons$1.addColumnBefore,
			props: {
				"data-item": "btn-tableActions-option",
				ariaLabel: "Add column before"
			}
		},
		{
			label: toolbarTexts$1.addColumnAfter,
			command: "addColumnAfter",
			icon: toolbarIcons$1.addColumnAfter,
			bottomBorder: true,
			props: {
				"data-item": "btn-tableActions-option",
				ariaLabel: "Add column after"
			}
		},
		{
			label: toolbarTexts$1.deleteRow,
			command: "deleteRow",
			icon: toolbarIcons$1.deleteRow,
			props: {
				"data-item": "btn-tableActions-option",
				ariaLabel: "Delete row"
			}
		},
		{
			label: toolbarTexts$1.deleteColumn,
			command: "deleteColumn",
			icon: toolbarIcons$1.deleteColumn,
			props: {
				"data-item": "btn-tableActions-option",
				ariaLabel: "Delete column"
			}
		},
		{
			label: toolbarTexts$1.deleteTable,
			command: "deleteTable",
			icon: toolbarIcons$1.deleteTable,
			props: {
				"data-item": "btn-tableActions-option",
				ariaLabel: "Delete table"
			}
		},
		{
			label: toolbarTexts$1.removeBorders,
			command: "deleteCellAndTableBorders",
			icon: toolbarIcons$1.deleteBorders,
			bottomBorder: true,
			props: {
				"data-item": "btn-tableActions-option",
				ariaLabel: "Delete cell and table borders"
			}
		},
		{
			label: toolbarTexts$1.mergeCells,
			command: "mergeCells",
			icon: toolbarIcons$1.mergeCells,
			props: {
				"data-item": "btn-tableActions-option",
				ariaLabel: "Merge cells"
			}
		},
		{
			label: toolbarTexts$1.splitCell,
			command: "splitCell",
			icon: toolbarIcons$1.splitCell,
			props: {
				"data-item": "btn-tableActions-option",
				ariaLabel: "Split cells"
			}
		},
		{
			label: toolbarTexts$1.fixTables,
			command: "fixTables",
			icon: toolbarIcons$1.fixTables,
			props: {
				"data-item": "btn-tableActions-option",
				ariaLabel: "Fix tables"
			}
		}
	];
	function renderTableActions(tableActionsItem$1) {
		return h(TableActions_default, {
			options: tableActionsOptions$1,
			onSelect: (event) => {
				closeDropdown(tableActionsItem$1);
				const { command: command$1 } = event;
				superToolbar.emitCommand({
					item: tableActionsItem$1,
					argument: { command: command$1 }
				});
			}
		});
	}
	const alignment$1 = useToolbarItem({
		type: "dropdown",
		name: "textAlign",
		tooltip: toolbarTexts$1.textAlign,
		icon: toolbarIcons$1.alignLeft,
		command: "setTextAlign",
		hasCaret: true,
		markName: "textAlign",
		labelAttr: "textAlign",
		suppressActiveHighlight: true,
		attributes: { ariaLabel: "Text align" },
		options: [{
			type: "render",
			render: () => {
				const handleSelect = (e) => {
					closeDropdown(alignment$1);
					const buttonWithCommand = {
						...alignment$1,
						command: "setTextAlign"
					};
					buttonWithCommand.command = "setTextAlign";
					superToolbar.emitCommand({
						item: buttonWithCommand,
						argument: e
					});
					setAlignmentIcon(alignment$1, e);
				};
				return h("div", {}, [h(AlignmentButtons_default, { onSelect: handleSelect })]);
			},
			key: "alignment"
		}],
		onActivate: ({ textAlign }) => {
			setAlignmentIcon(alignment$1, textAlign);
		},
		onDeactivate: () => {
			setAlignmentIcon(alignment$1, "left");
		}
	});
	const setAlignmentIcon = (alignment$2, e) => {
		let alignValue = e === "both" ? "justify" : e;
		let icons$1 = {
			left: toolbarIcons$1.alignLeft,
			right: toolbarIcons$1.alignRight,
			center: toolbarIcons$1.alignCenter,
			justify: toolbarIcons$1.alignJustify
		};
		let icon = icons$1[alignValue] ?? icons$1.left;
		alignment$2.icon.value = icon;
	};
	const bulletedList = useToolbarItem({
		type: "dropdown",
		name: "list",
		command: "toggleBulletListStyle",
		splitButton: true,
		splitButtonCommand: "toggleBulletList",
		icon: toolbarIcons$1.bulletList,
		hasCaret: true,
		tooltip: toolbarTexts$1.bulletList,
		restoreEditorFocus: true,
		attributes: { ariaLabel: "Bullet list" },
		options: [{
			type: "render",
			key: "bullet-style-buttons",
			render: () => {
				const handleSelect = (style) => {
					closeDropdown(bulletedList);
					const item = {
						...bulletedList,
						command: "toggleBulletListStyle"
					};
					superToolbar.emitCommand({
						item,
						argument: style
					});
				};
				return h(StyleButtonsList_default, {
					buttons: bulletStyleButtons,
					iconSize: 25,
					selectedStyle: bulletedList.selectedValue.value,
					onSelect: handleSelect
				});
			}
		}]
	});
	const numberedList = useToolbarItem({
		type: "dropdown",
		name: "numberedlist",
		command: "toggleOrderedListStyle",
		splitButton: true,
		splitButtonCommand: "toggleOrderedList",
		icon: toolbarIcons$1.numberedList,
		hasCaret: true,
		tooltip: toolbarTexts$1.numberedList,
		restoreEditorFocus: true,
		attributes: { ariaLabel: "Numbered list" },
		options: [{
			type: "render",
			key: "numbered-style-buttons",
			render: () => {
				const handleSelect = (style) => {
					closeDropdown(numberedList);
					const item = {
						...numberedList,
						command: "toggleOrderedListStyle"
					};
					superToolbar.emitCommand({
						item,
						argument: style
					});
				};
				return h(StyleButtonsList_default, {
					buttons: numberedStyleButtons,
					iconSize: 30,
					selectedStyle: numberedList.selectedValue.value,
					onSelect: handleSelect
				});
			}
		}]
	});
	const indentLeft = useToolbarItem({
		type: "button",
		name: "indentleft",
		command: "decreaseTextIndent",
		icon: toolbarIcons$1.indentLeft,
		active: false,
		tooltip: toolbarTexts$1.indentLeft,
		disabled: false,
		attributes: { ariaLabel: "Left indent" }
	});
	const indentRight = useToolbarItem({
		type: "button",
		name: "indentright",
		command: "increaseTextIndent",
		icon: toolbarIcons$1.indentRight,
		active: false,
		tooltip: toolbarTexts$1.indentRight,
		disabled: false,
		attributes: { ariaLabel: "Right indent" }
	});
	const overflow = useToolbarItem({
		type: "overflow",
		name: "overflow",
		command: null,
		icon: toolbarIcons$1.overflow,
		active: false,
		disabled: false,
		attributes: { ariaLabel: "Overflow items" }
	});
	const zoom = useToolbarItem({
		type: "dropdown",
		name: "zoom",
		allowWithoutEditor: true,
		tooltip: toolbarTexts$1.zoom,
		defaultLabel: "100%",
		label: "100%",
		hasCaret: true,
		command: "setZoom",
		isWide: true,
		style: {
			width: "71px",
			minWidth: "71px"
		},
		inlineTextInputVisible: false,
		hasInlineTextInput: true,
		attributes: { ariaLabel: "Zoom" },
		options: [
			{
				label: "50%",
				key: .5,
				props: { "data-item": "btn-zoom-option" }
			},
			{
				label: "75%",
				key: .75,
				props: { "data-item": "btn-zoom-option" }
			},
			{
				label: "90%",
				key: .9,
				props: { "data-item": "btn-zoom-option" }
			},
			{
				label: "100%",
				key: 1,
				props: { "data-item": "btn-zoom-option" }
			},
			{
				label: "125%",
				key: 1.25,
				props: { "data-item": "btn-zoom-option" }
			},
			{
				label: "150%",
				key: 1.5,
				props: { "data-item": "btn-zoom-option" }
			},
			{
				label: "200%",
				key: 2,
				props: { "data-item": "btn-zoom-option" }
			}
		],
		onActivate: ({ zoom: value }) => {
			if (!value) return;
			zoom.label.value = value;
		}
	});
	const undo$2 = useToolbarItem({
		type: "button",
		name: "undo",
		disabled: true,
		tooltip: toolbarTexts$1.undo,
		command: "undo",
		icon: toolbarIcons$1.undo,
		group: "left",
		attributes: { ariaLabel: "Undo" }
	});
	const redo$2 = useToolbarItem({
		type: "button",
		disabled: true,
		name: "redo",
		tooltip: toolbarTexts$1.redo,
		command: "redo",
		icon: toolbarIcons$1.redo,
		group: "left",
		attributes: { ariaLabel: "Redo" }
	});
	const acceptTrackedChangeBySelection = useToolbarItem({
		type: "button",
		disabled: false,
		name: "acceptTrackedChangeBySelection",
		tooltip: toolbarTexts$1.trackChangesAccept,
		command: "acceptTrackedChangeFromToolbar",
		icon: toolbarIcons$1.trackChangesAccept,
		group: "left",
		attributes: { ariaLabel: "Accept tracked changes" }
	});
	const rejectTrackedChangeOnSelection = useToolbarItem({
		type: "button",
		disabled: false,
		name: "rejectTrackedChangeOnSelection",
		tooltip: toolbarTexts$1.trackChangesReject,
		command: "rejectTrackedChangeFromToolbar",
		icon: toolbarIcons$1.trackChangesReject,
		group: "left",
		attributes: { ariaLabel: "Reject tracked changes" }
	});
	const clearFormatting = useToolbarItem({
		type: "button",
		name: "clearFormatting",
		command: "clearFormat",
		tooltip: toolbarTexts$1.clearFormatting,
		icon: toolbarIcons$1.clearFormatting,
		attributes: { ariaLabel: "Clear formatting" }
	});
	const copyFormat = useToolbarItem({
		type: "button",
		name: "copyFormat",
		tooltip: toolbarTexts$1.copyFormat,
		icon: toolbarIcons$1.copyFormat,
		command: "copyFormat",
		active: false,
		attributes: { ariaLabel: "Copy formatting" }
	});
	const getDocumentOptionsAfterRole = (role$1, documentOptions$1) => {
		if (role$1 === "editor") return documentOptions$1;
		else if (role$1 === "suggester") return documentOptions$1.filter((option) => option.value === "suggesting");
		else return documentOptions$1.filter((option) => option.value === "viewing");
	};
	const getDefaultLabel = (role$1) => {
		if (role$1 === "editor") return "Editing";
		else if (role$1 === "suggester") return "Suggesting";
		else return "Viewing";
	};
	const documentMode = useToolbarItem({
		type: "dropdown",
		name: "documentMode",
		command: "setDocumentMode",
		allowWithoutEditor: true,
		icon: toolbarIcons$1.documentMode,
		defaultLabel: getDefaultLabel(role),
		label: getDefaultLabel(role),
		hasCaret: role === "editor",
		isWide: true,
		style: {
			display: "flex",
			justifyContent: "flex-end"
		},
		inlineTextInputVisible: false,
		hasInlineTextInput: false,
		group: "right",
		disabled: role !== "editor",
		attributes: {
			dropdownPosition: "right",
			className: "sd-toolbar-item--doc-mode",
			ariaLabel: "Document mode"
		},
		options: [{
			type: "render",
			render: () => renderDocumentMode(documentMode)
		}]
	});
	const documentOptions = [
		{
			label: toolbarTexts$1.documentEditingMode,
			value: "editing",
			icon: toolbarIcons$1.documentEditingMode,
			description: toolbarTexts$1.documentEditingModeDescription
		},
		{
			label: toolbarTexts$1.documentSuggestingMode,
			value: "suggesting",
			icon: toolbarIcons$1.documentSuggestingMode,
			description: toolbarTexts$1.documentSuggestingModeDescription
		},
		{
			label: toolbarTexts$1.documentViewingMode,
			value: "viewing",
			icon: toolbarIcons$1.documentViewingMode,
			description: toolbarTexts$1.documentViewingModeDescription
		}
	];
	function renderDocumentMode(renderDocumentButton) {
		return h(DocumentMode_default, {
			options: getDocumentOptionsAfterRole(role, documentOptions),
			onSelect: (item) => {
				closeDropdown(renderDocumentButton);
				const { label, icon } = item;
				documentMode.label.value = label;
				documentMode.icon.value = icon;
				superToolbar.emitCommand({
					item: documentMode,
					argument: label
				});
			}
		});
	}
	const controlSizes = new Map([
		["separator", 20],
		["zoom", 71],
		["fontFamily", 118],
		["fontSize", 57],
		["textAlign", 40],
		["linkedStyles", 142],
		["documentMode", 47],
		["ai", 32],
		["default", 32]
	]);
	const ruler = useToolbarItem({
		type: "button",
		name: "ruler",
		command: "toggleRuler",
		icon: toolbarIcons$1.ruler,
		active: false,
		tooltip: toolbarTexts$1.ruler,
		attributes: { ariaLabel: "Ruler" }
	});
	const formattingMarks = useToolbarItem({
		type: "button",
		name: "formattingMarks",
		command: "toggleFormattingMarks",
		allowWithoutEditor: true,
		icon: toolbarIcons$1.formattingMarks,
		active: false,
		tooltip: toolbarTexts$1.formattingMarks,
		attributes: { ariaLabel: "Formatting marks" }
	});
	const selectedLinkedStyle = ref(null);
	const linkedStyles = useToolbarItem({
		type: "dropdown",
		name: "linkedStyles",
		command: "setLinkedStyle",
		tooltip: toolbarTexts$1.linkedStyles,
		icon: toolbarIcons$1.paintbrush,
		defaultLabel: toolbarTexts$1.formatText,
		label: toolbarTexts$1.formatText,
		hasCaret: true,
		isWide: true,
		style: { width: "140px" },
		suppressActiveHighlight: true,
		disabled: false,
		attributes: {
			className: "sd-toolbar-item--linked-styles",
			ariaLabel: "Linked styles"
		},
		options: [{
			type: "render",
			key: "linkedStyle",
			render: () => {
				const handleSelect = (style) => {
					closeDropdown(linkedStyles);
					const itemWithCommand = {
						...linkedStyles,
						command: "setLinkedStyle"
					};
					superToolbar.emitCommand({
						item: itemWithCommand,
						argument: style
					});
					selectedLinkedStyle.value = style.id;
				};
				return h("div", {}, [h(LinkedStyle_default, {
					editor: superToolbar.activeEditor,
					onSelect: handleSelect,
					selectedOption: selectedLinkedStyle.value
				})]);
			}
		}],
		onActivate: ({ styleId: styleId$1 }) => {
			const selectedStyle = getQuickFormatList(superToolbar.activeEditor)?.find((style) => style.id === styleId$1);
			linkedStyles.label.value = selectedStyle && selectedStyle.id !== "Normal" ? selectedStyle.definition.attrs.name : toolbarTexts$1.formatText;
			linkedStyles.disabled.value = false;
		},
		onDeactivate: () => {
			linkedStyles.disabled.value = true;
			linkedStyles.label.value = toolbarTexts$1.formatText;
		}
	});
	const renderIcon = (value, selectedValue) => {
		if (selectedValue.value != value) return;
		return h("div", {
			innerHTML: check_default,
			class: "dropdown-select-icon"
		});
	};
	const lineHeight = useToolbarItem({
		type: "dropdown",
		name: "lineHeight",
		tooltip: toolbarTexts$1.lineHeight,
		icon: toolbarIcons$1.lineHeight,
		hasCaret: false,
		hasInlineTextInput: false,
		hideLabel: true,
		inlineTextInputVisible: false,
		suppressActiveHighlight: true,
		isWide: false,
		command: "setLineHeight",
		dropdownValueKey: "key",
		selectedValue: "1",
		attributes: { ariaLabel: "Line height" },
		options: [
			1,
			1.15,
			1.5,
			2,
			2.5,
			3
		].map((lineHeightValue) => {
			return {
				label: lineHeightValue.toFixed(2),
				key: lineHeightValue,
				icon: () => renderIcon(lineHeightValue, lineHeight.selectedValue),
				props: { "data-item": "btn-lineHeight-option" }
			};
		})
	});
	const XL_OVERFLOW_SAFETY_BUFFER = 20;
	const stickyItemsWidth = 120;
	const toolbarPadding = 32;
	const itemsToHideXL = [
		"linkedStyles",
		"clearFormatting",
		"copyFormat",
		"ruler",
		"formattingMarks"
	];
	const itemsToHideSM = [
		"zoom",
		"fontFamily",
		"fontSize",
		"redo"
	];
	const shouldUseLgCompactStyles = availableWidth <= RESPONSIVE_BREAKPOINTS.lg;
	const shouldIncludeFormattingMarks = superToolbar.config?.showFormattingMarksButton === true;
	const shouldIncludeTableOfContents = superToolbar.config?.showTableOfContentsButton === true;
	if (shouldUseLgCompactStyles) documentMode.attributes.value = {
		...documentMode.attributes.value,
		className: `${documentMode.attributes.value.className} sd-toolbar-item--doc-mode-compact`
	};
	if (shouldUseLgCompactStyles) linkedStyles.attributes.value = {
		...linkedStyles.attributes.value,
		className: `${linkedStyles.attributes.value.className} sd-toolbar-item--linked-styles-compact`
	};
	let toolbarItems = [
		undo$2,
		redo$2,
		acceptTrackedChangeBySelection,
		rejectTrackedChangeOnSelection,
		zoom,
		fontButton,
		separator,
		fontSize,
		separator,
		bold,
		italic,
		underline,
		strikethrough,
		colorButton,
		highlight,
		separator,
		link,
		image,
		...shouldIncludeTableOfContents ? [tableOfContents] : [],
		tableItem,
		tableActionsItem,
		separator,
		alignment$1,
		bulletedList,
		numberedList,
		indentLeft,
		indentRight,
		lineHeight,
		separator,
		linkedStyles,
		separator,
		ruler,
		...shouldIncludeFormattingMarks ? [formattingMarks] : [],
		copyFormat,
		clearFormatting,
		aiButton,
		overflow,
		documentMode
	];
	if (!superToolbar.config?.superdoc?.config?.modules?.ai) toolbarItems = toolbarItems.filter((item) => item.name.value !== "ai");
	if (availableWidth <= RESPONSIVE_BREAKPOINTS.md && hideButtons) toolbarItems = toolbarItems.filter((item) => item.type !== "separator");
	if (superToolbar.config.mode !== "docx") {
		const getLinkedStylesIndex = toolbarItems.findIndex((item) => item.name.value === "linkedStyles");
		toolbarItems.splice(getLinkedStylesIndex - 1, 2);
		const filterItems = [
			"ruler",
			"zoom",
			"undo",
			"redo"
		];
		toolbarItems = toolbarItems.filter((item) => !filterItems.includes(item.name.value));
	}
	const devItems = [];
	if (!isDev) {
		if (role === "viewer") devItems.push(...[acceptTrackedChangeBySelection, rejectTrackedChangeOnSelection]);
		toolbarItems = toolbarItems.filter((item) => !devItems.includes(item));
	}
	const toolbarItemsSticky = [
		search$1,
		undo$2,
		overflow,
		documentMode
	].map((item) => item.name);
	const isStickyItem = (item) => toolbarItemsSticky.includes(item.name);
	const overflowItems = [];
	const visibleItems = [];
	let totalWidth = toolbarPadding + stickyItemsWidth;
	toolbarItems.forEach((item) => {
		const itemWidth = controlSizes.get(item.name.value) || controlSizes.get("default");
		if (availableWidth < RESPONSIVE_BREAKPOINTS.xl + XL_OVERFLOW_SAFETY_BUFFER && itemsToHideXL.includes(item.name.value) && hideButtons) {
			overflowItems.push(item);
			if (item.name.value === "linkedStyles") {
				const linkedStylesIdx = toolbarItems.findIndex((item$1) => item$1.name.value === "linkedStyles");
				toolbarItems.splice(linkedStylesIdx + 1, 1);
			}
			return;
		}
		if (availableWidth < RESPONSIVE_BREAKPOINTS.sm && itemsToHideSM.includes(item.name.value) && hideButtons) {
			overflowItems.push(item);
			return;
		}
		if (isStickyItem(item)) {
			visibleItems.push(item);
			totalWidth += itemWidth;
			return;
		}
		if (totalWidth < availableWidth || !hideButtons) {
			visibleItems.push(item);
			totalWidth += itemWidth;
		} else overflowItems.push(item);
	});
	return {
		defaultItems: visibleItems,
		overflowItems: overflowItems.filter((item) => item.type !== "separator")
	};
};
var _hoisted_1$11 = { class: "sd-toolbar-icon" };
var _hoisted_2$8 = ["innerHTML"];
var ToolbarButtonIcon_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "ToolbarButtonIcon",
	props: {
		name: {
			type: String,
			required: true
		},
		color: {
			type: String,
			default: null
		},
		icon: {
			type: String,
			default: null
		}
	},
	setup(__props) {
		const props = __props;
		const getBarColor = computed(() => {
			if (props.name === "color") return { backgroundColor: props.color || "#111111" };
			if (props.name === "highlight") return { backgroundColor: props.color || "#D6D6D6" };
		});
		const hasColorBar = computed(() => {
			return ["color", "highlight"].includes(props.name);
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$11, [createElementVNode("div", {
				class: normalizeClass(["sd-toolbar-icon__icon", [`sd-toolbar-icon__icon--${props.name}`]]),
				innerHTML: __props.icon
			}, null, 10, _hoisted_2$8), hasColorBar.value ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: "color-bar",
				style: normalizeStyle(getBarColor.value)
			}, null, 4)) : createCommentVNode("", true)]);
		};
	}
}, [["__scopeId", "data-v-521c3d93"]]);
var _hoisted_1$10 = ["role", "aria-label"];
var _hoisted_2$7 = ["data-item"];
var _hoisted_3$6 = ["data-item"];
var _hoisted_4$5 = {
	key: 1,
	class: "sd-button-label"
};
var _hoisted_5$4 = ["data-item", "aria-label"];
var _hoisted_6$3 = ["innerHTML"];
var _hoisted_7$2 = {
	key: 1,
	class: "sd-button-label"
};
var _hoisted_8 = {
	key: 2,
	class: "sd-toolbar-button__field sd-toolbar-split-field__main"
};
var _hoisted_9 = ["onKeydown", "id"];
var _hoisted_10 = [
	"placeholder",
	"onKeydown",
	"id"
];
var _hoisted_11 = [
	"data-item",
	"aria-label",
	"disabled"
];
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = {
	"aria-live": "polite",
	class: "sd-visually-hidden"
};
var ToolbarButton_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "ToolbarButton",
	props: {
		iconColor: {
			type: String,
			default: null
		},
		active: {
			type: Boolean,
			default: false
		},
		isNarrow: {
			type: Boolean,
			default: false
		},
		isWide: {
			type: Boolean,
			default: false
		},
		toolbarItem: {
			type: Object,
			required: true
		},
		defaultLabel: {
			type: String,
			default: null
		},
		isOverflowItem: {
			type: Boolean,
			default: false
		},
		allowEnterPropagation: {
			type: Boolean,
			default: false
		}
	},
	emits: [
		"buttonClick",
		"textSubmit",
		"mainClick",
		"tabOut"
	],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const props = __props;
		const { name, active, icon, label, hideLabel, iconColor, hasCaret, splitButton, disabled, expand, inlineTextInputVisible, hasInlineTextInput, minWidth, style, attributes } = props.toolbarItem;
		const isSplit = computed(() => Boolean(splitButton?.value) && Boolean(hasCaret?.value));
		const isInlineSplitField = computed(() => name?.value === "fontSize" && Boolean(hasInlineTextInput?.value) && Boolean(hasCaret?.value));
		const inlineTextInput = ref(label);
		const inlineInput = ref(null);
		const { isHighContrastMode: isHighContrastMode$1 } = useHighContrastMode();
		const selectInlineInput = () => {
			nextTick(() => {
				inlineInput.value?.select();
			});
		};
		const handleClick$1 = () => {
			if (hasInlineTextInput) nextTick(() => {
				inlineInput.value?.focus();
				selectInlineInput();
			});
			emit("buttonClick");
		};
		const handleSplitMainClick = (event) => {
			if (disabled?.value) return;
			event?.stopPropagation();
			emit("mainClick");
		};
		const handleOuterClick = () => {
			if (isSplit.value) return;
			handleClick$1();
		};
		const handleOuterEnter = (event) => {
			if (isSplit.value) {
				handleSplitMainClick(event);
				return;
			}
			handleClick$1();
		};
		const onEnterKeydown = (event) => {
			if (!props.allowEnterPropagation) event.stopPropagation();
			handleOuterEnter(event);
		};
		const handleInputSubmit = () => {
			const value = inlineTextInput.value;
			const cleanValue = value.match(/^\d+(\.5)?$/) ? value : Math.floor(parseFloat(value)).toString();
			emit("textSubmit", cleanValue);
			inlineTextInput.value = cleanValue;
		};
		const handleInputTab = (event) => {
			if (name?.value !== "fontSize") return;
			event.preventDefault();
			handleInputSubmit();
			inlineInput.value?.blur();
			emit("tabOut", event);
		};
		const getStyle = computed(() => {
			if (style.value) return style.value;
			return { minWidth: props.minWidth };
		});
		const caretIcon = computed(() => {
			return expand?.value ? toolbarIcons.dropdownCaretUp : toolbarIcons.dropdownCaretDown;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: normalizeClass(["sd-toolbar-item", unref(attributes).className]),
				style: normalizeStyle(getStyle.value),
				role: __props.isOverflowItem ? "menuitem" : "button",
				"aria-label": unref(attributes).ariaLabel,
				"data-sd-part": "toolbar-item",
				onClick: handleOuterClick,
				onKeydown: _cache[5] || (_cache[5] = withKeys(($event) => onEnterKeydown($event), ["enter"])),
				tabindex: "0"
			}, [createElementVNode("div", {
				class: normalizeClass(["sd-toolbar-button", {
					"sd-active": unref(active),
					"sd-disabled": unref(disabled),
					narrow: __props.isNarrow,
					wide: __props.isWide,
					split: isSplit.value,
					"split-field": isInlineSplitField.value,
					"sd-toolbar-split-field": isInlineSplitField.value,
					"has-inline-text-input": unref(hasInlineTextInput),
					"high-contrast": unref(isHighContrastMode$1)
				}]),
				"data-item": `btn-${unref(name) || ""}`
			}, [
				isSplit.value ? (openBlock(), createElementBlock("div", {
					key: 0,
					class: "sd-toolbar-button__main",
					"data-item": `btn-${unref(name) || ""}-main`,
					onClick: _cache[0] || (_cache[0] = ($event) => handleSplitMainClick($event))
				}, [unref(icon) ? (openBlock(), createBlock(ToolbarButtonIcon_default, {
					key: 0,
					color: unref(iconColor),
					class: "sd-toolbar-icon",
					icon: unref(icon),
					name: unref(name)
				}, null, 8, [
					"color",
					"icon",
					"name"
				])) : createCommentVNode("", true), unref(label) && !unref(hideLabel) && !unref(inlineTextInputVisible) ? (openBlock(), createElementBlock("div", _hoisted_4$5, toDisplayString(unref(label)), 1)) : createCommentVNode("", true)], 8, _hoisted_3$6)) : createCommentVNode("", true),
				isSplit.value ? (openBlock(), createElementBlock("div", {
					key: 1,
					class: "sd-toolbar-button__caret",
					"data-item": `btn-${unref(name) || ""}-caret`,
					"aria-label": `${unref(attributes).ariaLabel} options`,
					role: "button"
				}, [createElementVNode("div", {
					class: "sd-dropdown-caret",
					innerHTML: caretIcon.value,
					style: normalizeStyle({ opacity: unref(disabled) ? .6 : 1 })
				}, null, 12, _hoisted_6$3)], 8, _hoisted_5$4)) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
					unref(icon) ? (openBlock(), createBlock(ToolbarButtonIcon_default, {
						key: 0,
						color: unref(iconColor),
						class: "sd-toolbar-icon",
						icon: unref(icon),
						name: unref(name)
					}, null, 8, [
						"color",
						"icon",
						"name"
					])) : createCommentVNode("", true),
					unref(label) && !unref(hideLabel) && !unref(inlineTextInputVisible) ? (openBlock(), createElementBlock("div", _hoisted_7$2, toDisplayString(unref(label)), 1)) : createCommentVNode("", true),
					unref(inlineTextInputVisible) ? (openBlock(), createElementBlock("span", _hoisted_8, [unref(name) === "fontSize" ? withDirectives((openBlock(), createElementBlock("input", {
						key: 0,
						"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => inlineTextInput.value = $event),
						onKeydown: [withKeys(withModifiers(handleInputSubmit, ["prevent"]), ["enter"]), withKeys(handleInputTab, ["tab"])],
						onFocus: selectInlineInput,
						onClick: _cache[2] || (_cache[2] = withModifiers(() => {}, ["stop"])),
						type: "text",
						class: normalizeClass(["button-text-input button-text-input--font-size", { "high-contrast": unref(isHighContrastMode$1) }]),
						id: "inlineTextInput-" + unref(name),
						autocomplete: "off",
						ref_key: "inlineInput",
						ref: inlineInput
					}, null, 42, _hoisted_9)), [[vModelText, inlineTextInput.value]]) : withDirectives((openBlock(), createElementBlock("input", {
						key: 1,
						"onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => inlineTextInput.value = $event),
						placeholder: unref(label),
						onKeydown: withKeys(withModifiers(handleInputSubmit, ["prevent"]), ["enter"]),
						type: "text",
						class: "button-text-input",
						id: "inlineTextInput-" + unref(name),
						autocomplete: "off",
						ref_key: "inlineInput",
						ref: inlineInput
					}, null, 40, _hoisted_10)), [[vModelText, inlineTextInput.value]])])) : createCommentVNode("", true),
					isInlineSplitField.value ? (openBlock(), createElementBlock("button", {
						key: 3,
						type: "button",
						class: "sd-toolbar-button__field-caret sd-toolbar-split-field__caret",
						"data-item": `btn-${unref(name) || ""}-caret`,
						"aria-label": `${unref(attributes).ariaLabel} options`,
						disabled: unref(disabled),
						tabindex: "-1",
						onMousedown: _cache[4] || (_cache[4] = withModifiers(() => {}, ["prevent"]))
					}, [createElementVNode("span", {
						class: "sd-dropdown-caret",
						innerHTML: caretIcon.value,
						style: normalizeStyle({ opacity: unref(disabled) ? .6 : 1 })
					}, null, 12, _hoisted_12)], 40, _hoisted_11)) : unref(hasCaret) ? (openBlock(), createElementBlock("div", {
						key: 4,
						class: "sd-dropdown-caret",
						innerHTML: caretIcon.value,
						style: normalizeStyle({ opacity: unref(disabled) ? .6 : 1 })
					}, null, 12, _hoisted_13)) : createCommentVNode("", true)
				], 64)),
				createElementVNode("div", _hoisted_14, toDisplayString(`${unref(attributes).ariaLabel} ${unref(active) ? "selected" : "unset"}`), 1)
			], 10, _hoisted_2$7)], 46, _hoisted_1$10);
		};
	}
}, [["__scopeId", "data-v-2caa0057"]]);
var _hoisted_1$9 = {
	class: "toolbar-separator",
	role: "separator",
	"aria-label": "Toolbar separator"
};
var ToolbarSeparator_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "ToolbarSeparator",
	props: { active: {
		type: Boolean,
		default: false
	} },
	emits: ["command"],
	setup(__props, { emit: __emit }) {
		const { isHighContrastMode: isHighContrastMode$1 } = useHighContrastMode();
		const getSeparatorColor = () => {
			if (isHighContrastMode$1.value) return "#000";
			return "var(--sd-ui-border, #dbdbdb)";
		};
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$9, [createElementVNode("div", {
				class: "separator-inner",
				style: normalizeStyle({ backgroundColor: getSeparatorColor() })
			}, null, 4)]);
		};
	}
}, [["__scopeId", "data-v-d027f7fc"]]);
var _hoisted_1$8 = { class: "overflow-menu" };
var _hoisted_2$6 = { class: "overflow-menu-trigger" };
var _hoisted_3$5 = {
	key: 0,
	class: "overflow-menu_items",
	role: "group"
};
var OverflowMenu_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "OverflowMenu",
	props: {
		toolbarItem: {
			type: Object,
			required: true
		},
		overflowItems: {
			type: Array,
			required: true
		}
	},
	emits: ["buttonClick", "close"],
	setup(__props, { emit: __emit }) {
		const { proxy } = getCurrentInstance();
		const emit = __emit;
		const props = __props;
		const isOverflowMenuOpened = computed(() => props.toolbarItem.expand.value);
		const hasOpenDropdown = ref(false);
		const overflowToolbarItem = computed(() => ({
			...props.toolbarItem,
			active: isOverflowMenuOpened.value
		}));
		const toggleOverflowMenu = () => {
			emit("buttonClick", props.toolbarItem);
		};
		const handleCommand = ({ item, argument }) => {
			proxy.$toolbar.emitCommand({
				item,
				argument
			});
		};
		const handleKeyDown$1 = (e) => {
			if (e.key === "Escape") {
				if (isOverflowMenuOpened.value && !hasOpenDropdown.value) {
					e.preventDefault();
					emit("close");
				}
			}
		};
		onMounted(() => {
			document.addEventListener("keydown", handleKeyDown$1, true);
		});
		onBeforeUnmount(() => {
			document.removeEventListener("keydown", handleKeyDown$1, true);
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$8, [createElementVNode("div", _hoisted_2$6, [createVNode(ToolbarButton_default, {
				"toolbar-item": overflowToolbarItem.value,
				onButtonClick: toggleOverflowMenu
			}, null, 8, ["toolbar-item"])]), isOverflowMenuOpened.value ? (openBlock(), createElementBlock("div", _hoisted_3$5, [createVNode(ButtonGroup_default, {
				class: "superdoc-toolbar-overflow",
				"toolbar-items": __props.overflowItems,
				"from-overflow": "",
				onCommand: handleCommand,
				onDropdownUpdateShow: _cache[0] || (_cache[0] = ($event) => hasOpenDropdown.value = $event)
			}, null, 8, ["toolbar-items"])])) : createCommentVNode("", true)]);
		};
	}
}, [["__scopeId", "data-v-35b48dff"]]);
var _hoisted_1$7 = { class: "toolbar-dropdown" };
var _hoisted_2$5 = ["onClick"];
var _hoisted_3$4 = {
	key: 0,
	class: "toolbar-dropdown-option__icon"
};
var _hoisted_4$4 = { class: "toolbar-dropdown-option__label" };
var TRIGGER_FOCUS_SELECTOR = "button, [href], input, select, textarea, [role=\"button\"], [tabindex]:not([tabindex=\"-1\"])";
var ToolbarDropdown_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "ToolbarDropdown",
	props: {
		options: {
			type: Array,
			default: () => []
		},
		show: {
			type: Boolean,
			required: true
		},
		placement: {
			type: String,
			default: "bottom-start"
		},
		disabled: {
			type: Boolean,
			default: false
		},
		contentStyle: {
			type: Object,
			default: () => ({})
		},
		menuProps: {
			type: Function,
			default: null
		},
		nodeProps: {
			type: Function,
			default: null
		}
	},
	emits: ["update:show", "select"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const triggerRef = ref(null);
		const menuRef = ref(null);
		const menuPosition = ref({
			top: "0px",
			left: "0px",
			maxHeight: "none"
		});
		const optionRefs = ref([]);
		const keyboardIndex = ref(-1);
		const isOpen = computed(() => Boolean(props.show));
		const hasRenderOptions = computed(() => props.options.some((option) => option?.type === "render"));
		const computedMenuProps = computed(() => {
			if (typeof props.menuProps !== "function") return {};
			return props.menuProps() || {};
		});
		const computedMenuAttrs = computed(() => {
			const { class: _class, style: _style, ...rest } = computedMenuProps.value;
			return rest;
		});
		const mergedMenuClass = computed(() => {
			const fromProps = computedMenuProps.value.class;
			const onlyRenderOptions = props.options.length > 0 && props.options.every((option) => option && option.type === "render");
			return [
				"toolbar-dropdown-menu",
				fromProps,
				{ "toolbar-dropdown-menu--render-only": onlyRenderOptions }
			];
		});
		const mergedMenuStyle = computed(() => {
			const fromProps = computedMenuProps.value.style || {};
			return {
				...props.contentStyle,
				...fromProps
			};
		});
		const menuStyle = computed(() => {
			return {
				...mergedMenuStyle.value,
				position: "fixed",
				top: menuPosition.value.top,
				left: menuPosition.value.left,
				maxHeight: menuPosition.value.maxHeight,
				zIndex: 2e3
			};
		});
		const setOpen = (value) => {
			emit("update:show", value);
		};
		const close = () => {
			if (!isOpen.value) return;
			setOpen(false);
		};
		const updateMenuPosition = () => {
			if (!triggerRef.value) return;
			const rect = triggerRef.value.getBoundingClientRect();
			const menuEl = menuRef.value;
			const menuWidth = menuEl?.offsetWidth ?? 0;
			const menuHeight = menuEl?.scrollHeight ?? menuEl?.offsetHeight ?? 0;
			const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
			const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
			const gutter = 8;
			const gap = 4;
			const belowTop = rect.bottom + gap;
			const aboveBottom = rect.top - gap;
			const availableBelow = Math.max(0, viewportHeight - belowTop - gutter);
			const availableAbove = Math.max(0, aboveBottom - gutter);
			const openAbove = availableBelow < menuHeight && availableAbove > availableBelow;
			const maxHeight = openAbove ? availableAbove : availableBelow;
			const menuRenderHeight = menuHeight ? Math.min(menuHeight, maxHeight) : maxHeight;
			const top$1 = openAbove ? Math.max(gutter, aboveBottom - menuRenderHeight) : belowTop;
			let left$1 = rect.left;
			if (props.placement === "bottom-end") left$1 = rect.right - menuWidth;
			const maxLeft = Math.max(gutter, viewportWidth - menuWidth - gutter);
			left$1 = Math.min(Math.max(gutter, left$1), maxLeft);
			menuPosition.value = {
				top: `${top$1}px`,
				left: `${left$1}px`,
				maxHeight: `${maxHeight}px`
			};
		};
		const onTriggerClick = () => {
			if (props.disabled) return;
			setOpen(!isOpen.value);
		};
		const getNodeProps = (option) => {
			if (typeof props.nodeProps !== "function") return {};
			return props.nodeProps(option) || {};
		};
		const onOptionClick = (option) => {
			if (option?.disabled) return;
			if (option?.type === "render") return;
			emit("select", option?.key, option);
			close();
		};
		const isRenderOption = (option) => option?.type === "render";
		const isOptionNavigable = (option) => !option?.disabled && option?.type !== "render";
		const hasIcon = (option) => typeof option?.icon === "function" || Boolean(option?.icon);
		const renderIcon = (option) => {
			if (typeof option?.icon === "function") return option.icon(option);
			return option?.icon || null;
		};
		const classHasSelected = (value) => {
			if (!value) return false;
			if (typeof value === "string") return value.split(/\s+/).includes("sd-selected");
			if (Array.isArray(value)) return value.some(classHasSelected);
			if (typeof value === "object") return Boolean(value["sd-selected"]);
			return false;
		};
		const isOptionSelected = (option) => {
			return classHasSelected(option?.props?.class) || classHasSelected(option?.class);
		};
		const getNavigableIndexes = () => {
			return props.options.map((option, index) => isOptionNavigable(option) ? index : -1).filter((index) => index >= 0);
		};
		const getInitialKeyboardIndex = () => {
			const selectedIndex = props.options.findIndex((option) => isOptionNavigable(option) && isOptionSelected(option));
			if (selectedIndex >= 0) return selectedIndex;
			return getNavigableIndexes()[0] ?? -1;
		};
		const setOptionRef = (el, index) => {
			if (!el) {
				delete optionRefs.value[index];
				return;
			}
			optionRefs.value[index] = el;
		};
		const focusKeyboardIndex = () => {
			optionRefs.value.forEach((el, index) => {
				if (!el) return;
				el.setAttribute("tabindex", index === keyboardIndex.value ? "0" : "-1");
			});
			const target = optionRefs.value[keyboardIndex.value];
			if (target && typeof target.focus === "function") {
				target.focus();
				target.scrollIntoView?.({
					block: "nearest",
					inline: "nearest"
				});
			}
		};
		const moveKeyboardIndex = (direction) => {
			const navigableIndexes = getNavigableIndexes();
			if (!navigableIndexes.length) {
				keyboardIndex.value = -1;
				return;
			}
			const currentPosition = navigableIndexes.indexOf(keyboardIndex.value);
			if (currentPosition < 0) {
				keyboardIndex.value = direction > 0 ? navigableIndexes[0] : navigableIndexes[navigableIndexes.length - 1];
				return;
			}
			keyboardIndex.value = navigableIndexes[(currentPosition + direction + navigableIndexes.length) % navigableIndexes.length];
		};
		const selectKeyboardOption = () => {
			let option = props.options[keyboardIndex.value];
			if (!isOptionNavigable(option)) {
				const firstIndex = getNavigableIndexes()[0];
				option = firstIndex === void 0 ? null : props.options[firstIndex];
			}
			if (!option) return;
			onOptionClick(option);
		};
		const RenderOption = defineComponent({
			name: "ToolbarDropdownRenderOption",
			props: { option: {
				type: Object,
				required: true
			} },
			setup(componentProps) {
				return () => {
					if (typeof componentProps.option.render !== "function") return null;
					return componentProps.option.render();
				};
			}
		});
		const OptionIcon = defineComponent({
			name: "ToolbarDropdownOptionIcon",
			props: { option: {
				type: Object,
				required: true
			} },
			setup(componentProps) {
				return () => renderIcon(componentProps.option);
			}
		});
		const handlePointerDown = (event) => {
			if (!isOpen.value) return;
			const target = event.target;
			if (!(target instanceof Element)) return;
			const insideTrigger = triggerRef.value?.contains(target);
			const insideMenu = menuRef.value?.contains(target);
			if (insideTrigger || insideMenu) return;
			close();
		};
		const triggerFocusTargetRef = ref(null);
		const rememberTriggerFocusTarget = () => {
			const trigger = triggerRef.value;
			const active = document.activeElement;
			if (trigger && active instanceof HTMLElement && trigger.contains(active)) {
				triggerFocusTargetRef.value = active;
				return;
			}
			triggerFocusTargetRef.value = trigger?.matches?.(TRIGGER_FOCUS_SELECTOR) ? trigger : trigger?.querySelector(TRIGGER_FOCUS_SELECTOR);
		};
		const focusTrigger = () => {
			const remembered = triggerFocusTargetRef.value;
			if (remembered instanceof HTMLElement && document.contains(remembered)) {
				remembered.focus();
				return;
			}
			const trigger = triggerRef.value;
			if (!trigger) return;
			const fallback = trigger.matches?.(TRIGGER_FOCUS_SELECTOR) ? trigger : trigger.querySelector(TRIGGER_FOCUS_SELECTOR);
			if (fallback instanceof HTMLElement) {
				fallback.focus();
				return;
			}
			trigger.setAttribute("tabindex", "-1");
			trigger.focus();
		};
		const handleKeyDown$1 = (event) => {
			if (!isOpen.value) return;
			const { key } = event;
			if (![
				"Escape",
				"ArrowDown",
				"ArrowUp",
				"Enter"
			].includes(key)) return;
			if (key === "Escape") {
				event.preventDefault();
				close();
				nextTick(() => {
					requestAnimationFrame(focusTrigger);
				});
				return;
			}
			if (hasRenderOptions.value) return;
			event.preventDefault();
			if (key === "ArrowDown") {
				moveKeyboardIndex(1);
				focusKeyboardIndex();
				return;
			}
			if (key === "ArrowUp") {
				moveKeyboardIndex(-1);
				focusKeyboardIndex();
				return;
			}
			if (key === "Enter") selectKeyboardOption();
		};
		watch(isOpen, async (open) => {
			if (!open) {
				keyboardIndex.value = -1;
				optionRefs.value = [];
				return;
			}
			rememberTriggerFocusTarget();
			await nextTick();
			updateMenuPosition();
			if (hasRenderOptions.value) return;
			keyboardIndex.value = getInitialKeyboardIndex();
			await nextTick();
			focusKeyboardIndex();
		}, { immediate: true });
		watch(isOpen, (open) => {
			if (open) {
				document.addEventListener("pointerdown", handlePointerDown, true);
				document.addEventListener("keydown", handleKeyDown$1, true);
				window.addEventListener("resize", updateMenuPosition);
				window.addEventListener("scroll", updateMenuPosition, true);
			} else {
				document.removeEventListener("pointerdown", handlePointerDown, true);
				document.removeEventListener("keydown", handleKeyDown$1, true);
				window.removeEventListener("resize", updateMenuPosition);
				window.removeEventListener("scroll", updateMenuPosition, true);
			}
		}, { immediate: true });
		onBeforeUnmount(() => {
			document.removeEventListener("pointerdown", handlePointerDown, true);
			document.removeEventListener("keydown", handleKeyDown$1, true);
			window.removeEventListener("resize", updateMenuPosition);
			window.removeEventListener("scroll", updateMenuPosition, true);
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$7, [createElementVNode("div", {
				ref_key: "triggerRef",
				ref: triggerRef,
				class: "toolbar-dropdown-trigger",
				"data-sd-part": "dropdown-trigger",
				onClick: onTriggerClick
			}, [renderSlot(_ctx.$slots, "trigger", {}, void 0, true)], 512), (openBlock(), createBlock(Teleport, { to: "body" }, [createVNode(Transition, { name: "fade-in-scale-up-transition" }, {
				default: withCtx(() => [isOpen.value ? (openBlock(), createElementBlock("div", mergeProps({
					key: 0,
					ref_key: "menuRef",
					ref: menuRef,
					"data-sd-part": "dropdown-menu",
					class: mergedMenuClass.value,
					style: menuStyle.value
				}, computedMenuAttrs.value), [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.options, (option, index) => {
					return openBlock(), createElementBlock("div", mergeProps({
						key: option.key,
						ref_for: true,
						ref: (el) => setOptionRef(el, index),
						class: ["toolbar-dropdown-option", [
							option.class,
							option.props?.class,
							{
								"sd-disabled": option.disabled,
								"sd-render": isRenderOption(option)
							}
						]],
						tabindex: "-1",
						onClick: ($event) => onOptionClick(option)
					}, { ref_for: true }, {
						...option.props,
						...getNodeProps(option)
					}), [isRenderOption(option) ? (openBlock(), createBlock(unref(RenderOption), {
						key: 0,
						option
					}, null, 8, ["option"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [hasIcon(option) ? (openBlock(), createElementBlock("span", _hoisted_3$4, [createVNode(unref(OptionIcon), { option }, null, 8, ["option"])])) : createCommentVNode("", true), createElementVNode("span", _hoisted_4$4, toDisplayString(option.label), 1)], 64))], 16, _hoisted_2$5);
				}), 128))], 16)) : createCommentVNode("", true)]),
				_: 1
			})]))]);
		};
	}
}, [["__scopeId", "data-v-69732782"]]);
var normalize = (value) => String(value ?? "").trim().toLowerCase();
const findPrefixMatchIndex = (query, labels) => {
	const q$1 = normalize(query);
	if (!q$1) return -1;
	for (let i = 0; i < labels.length; i += 1) if (normalize(labels[i]).startsWith(q$1)) return i;
	return -1;
};
const computeTypeahead = (query, labels, { autocomplete = true } = {}) => {
	const typed = String(query ?? "");
	const matchIndex = findPrefixMatchIndex(typed, labels);
	const completion = matchIndex >= 0 ? String(labels[matchIndex] ?? "") : "";
	if (autocomplete && matchIndex >= 0 && completion.length > typed.length) return {
		matchIndex,
		display: completion,
		selectionStart: typed.length,
		selectionEnd: completion.length
	};
	return {
		matchIndex,
		display: typed,
		selectionStart: typed.length,
		selectionEnd: typed.length
	};
};
var stripWrappingQuotes = (value) => {
	let result = String(value ?? "").trim();
	while (result.length >= 2 && (result.startsWith("\"") && result.endsWith("\"") || result.startsWith("'") && result.endsWith("'"))) result = result.slice(1, -1).trim();
	return result;
};
const normalizeCustomFontFamily = (value) => {
	return stripWrappingQuotes((String(value ?? "").split(",")[0] ?? "").replace(/[\u0000-\u001f\u007f]/g, "")).replace(/\s+/g, " ").trim();
};
var _hoisted_1$6 = [
	"value",
	"disabled",
	"aria-label",
	"aria-expanded",
	"aria-controls",
	"aria-activedescendant"
];
var _hoisted_2$4 = ["aria-label", "disabled"];
var _hoisted_3$3 = ["innerHTML"];
var _hoisted_4$3 = ["id", "aria-label"];
var _hoisted_5$3 = [
	"id",
	"aria-selected",
	"aria-label",
	"onMousedown",
	"onMouseenter"
];
var _hoisted_6$2 = { class: "toolbar-dropdown-option__label" };
var _hoisted_7$1 = {
	class: "sd-button-label sd-font-combobox__legacy-label",
	"aria-hidden": "true"
};
var FontFamilyCombobox_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "FontFamilyCombobox",
	props: {
		item: {
			type: Object,
			required: true
		},
		uiFontFamily: {
			type: String,
			default: "Arial, Helvetica, sans-serif"
		}
	},
	emits: [
		"command",
		"item-clicked",
		"tab-out",
		"editor-handoff"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { isHighContrastMode: isHighContrastMode$1 } = useHighContrastMode();
		const inputRef = ref(null);
		const rootRef = ref(null);
		const popupRef = ref(null);
		const optionRefs = ref([]);
		const isEditing = ref(false);
		const isOpen = ref(false);
		const activeIndex = ref(-1);
		const query = ref("");
		const inputDisplay = ref("");
		const isComposing = ref(false);
		const menuPosition = ref({
			top: "0px",
			left: "0px",
			minWidth: "0px",
			maxHeight: "none"
		});
		const options = computed(() => props.item.nestedOptions?.value ?? []);
		const optionLabels = computed(() => options.value.map((option) => String(option?.label ?? "")));
		const appliedLabel = computed(() => String(props.item.label?.value ?? ""));
		const disabled = computed(() => Boolean(props.item.disabled?.value));
		const ariaLabel = computed(() => props.item.attributes?.value?.ariaLabel ?? "Font family");
		const boundValue = computed(() => isEditing.value ? inputDisplay.value : appliedLabel.value);
		const listboxId = computed(() => `sd-fontfamily-listbox-${props.item.id?.value ?? "default"}`);
		const optionId = (index) => `${listboxId.value}-option-${index}`;
		const activeDescendant = computed(() => isOpen.value && activeIndex.value >= 0 ? optionId(activeIndex.value) : void 0);
		const caretIcon = computed(() => isOpen.value ? toolbarIcons.dropdownCaretUp : toolbarIcons.dropdownCaretDown);
		const previewFamilyForLabel = (label) => {
			const normalized = String(label ?? "").trim().toLowerCase();
			return options.value.find((candidate) => String(candidate?.label ?? "").trim().toLowerCase() === normalized)?.props?.style?.fontFamily || label || props.uiFontFamily;
		};
		const inputStyle = computed(() => ({ fontFamily: previewFamilyForLabel(isEditing.value ? inputDisplay.value : appliedLabel.value) }));
		const appliedIndex = () => {
			const selectedKey = props.item.selectedValue?.value;
			if (selectedKey) {
				const byKey = options.value.findIndex((option) => option?.key === selectedKey);
				if (byKey >= 0) return byKey;
			}
			return optionLabels.value.findIndex((label) => label.toLowerCase() === appliedLabel.value.toLowerCase());
		};
		const setSelectionRange = (start$1, end$1) => {
			const el = inputRef.value;
			if (!el || typeof el.setSelectionRange !== "function") return;
			try {
				el.setSelectionRange(start$1, end$1);
			} catch {}
		};
		const scrollActiveIntoView = () => {
			optionRefs.value[activeIndex.value]?.scrollIntoView?.({
				block: "nearest",
				inline: "nearest"
			});
		};
		const updatePosition$1 = () => {
			const trigger = rootRef.value;
			if (!trigger) return;
			const rect = trigger.getBoundingClientRect();
			const menuEl = popupRef.value;
			const menuHeight = menuEl?.scrollHeight ?? menuEl?.offsetHeight ?? 0;
			const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
			const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
			const gutter = 8;
			const gap = 4;
			const belowTop = rect.bottom + gap;
			const aboveBottom = rect.top - gap;
			const availableBelow = Math.max(0, viewportHeight - belowTop - gutter);
			const availableAbove = Math.max(0, aboveBottom - gutter);
			const openAbove = availableBelow < menuHeight && availableAbove > availableBelow;
			const maxHeight = openAbove ? availableAbove : availableBelow;
			const renderHeight = menuHeight ? Math.min(menuHeight, maxHeight) : maxHeight;
			const top$1 = openAbove ? Math.max(gutter, aboveBottom - renderHeight) : belowTop;
			const left$1 = Math.min(Math.max(gutter, rect.left), Math.max(gutter, viewportWidth - rect.width - gutter));
			menuPosition.value = {
				top: `${top$1}px`,
				left: `${left$1}px`,
				minWidth: `${rect.width}px`,
				maxHeight: `${maxHeight}px`
			};
		};
		const menuStyle = computed(() => ({
			position: "fixed",
			top: menuPosition.value.top,
			left: menuPosition.value.left,
			minWidth: menuPosition.value.minWidth,
			maxHeight: menuPosition.value.maxHeight,
			fontFamily: props.uiFontFamily,
			zIndex: 2e3
		}));
		const setItemExpanded = (open) => {
			if (props.item.expand && typeof props.item.expand === "object" && "value" in props.item.expand) props.item.expand.value = open;
		};
		const openList = (index, { focusInput = false } = {}) => {
			if (disabled.value || !options.value.length) {
				setItemExpanded(false);
				return;
			}
			isOpen.value = true;
			setItemExpanded(true);
			activeIndex.value = index ?? -1;
			if (focusInput) {
				isEditing.value = true;
				inputDisplay.value = appliedLabel.value;
				inputRef.value?.focus();
			}
			nextTick(() => {
				updatePosition$1();
				scrollActiveIntoView();
			});
		};
		const closeList = ({ syncItem = true } = {}) => {
			isOpen.value = false;
			activeIndex.value = -1;
			if (syncItem) setItemExpanded(false);
		};
		const resetToApplied = () => {
			closeList();
			isEditing.value = false;
			query.value = "";
			inputDisplay.value = appliedLabel.value;
		};
		const onFocus = () => {
			if (disabled.value) return;
			emit("item-clicked");
			isEditing.value = true;
			query.value = "";
			inputDisplay.value = appliedLabel.value;
			nextTick(() => setSelectionRange(0, inputDisplay.value.length));
		};
		const onInputMousedown = (event) => {
			if (disabled.value || document.activeElement === inputRef.value) return;
			event.preventDefault();
			inputRef.value?.focus();
			isEditing.value = true;
			query.value = "";
			inputDisplay.value = appliedLabel.value;
			setSelectionRange(0, appliedLabel.value.length);
		};
		const onBlur = (event) => {
			const next = event.relatedTarget;
			if (next instanceof Node && rootRef.value?.contains(next)) return;
			if (next instanceof Node && popupRef.value?.contains(next)) return;
			resetToApplied();
		};
		const onInput = (event) => {
			if (isComposing.value) return;
			const el = event.target;
			const typed = el.value;
			const selectionStart = typeof el.selectionStart === "number" ? el.selectionStart : typed.length;
			const selectionEnd = typeof el.selectionEnd === "number" ? el.selectionEnd : selectionStart;
			const isDelete = typeof event.inputType === "string" && event.inputType.startsWith("delete");
			const editAtEnd = selectionStart === typed.length && selectionEnd === typed.length;
			query.value = typed;
			const result = computeTypeahead(typed, optionLabels.value, { autocomplete: !isDelete && editAtEnd });
			inputDisplay.value = result.display;
			el.value = result.display;
			if (result.display === typed && !editAtEnd) setSelectionRange(selectionStart, selectionEnd);
			else setSelectionRange(result.selectionStart, result.selectionEnd);
			if (isOpen.value) {
				activeIndex.value = result.matchIndex;
				nextTick(scrollActiveIntoView);
			}
		};
		const onCompositionEnd = (event) => {
			isComposing.value = false;
			onInput(event);
		};
		const moveActive = (direction) => {
			if (!options.value.length) return;
			const count = options.value.length;
			activeIndex.value = ((activeIndex.value < 0 ? direction > 0 ? -1 : 0 : activeIndex.value) + direction + count) % count;
			nextTick(scrollActiveIntoView);
		};
		const emitFontCommand = (label, option) => {
			emit("item-clicked");
			emit("command", {
				item: props.item,
				argument: label,
				option
			});
			if (option) props.item.selectedValue.value = option.key;
		};
		const applyOption = (option) => {
			if (!option) return;
			emitFontCommand(option.label, option);
			isEditing.value = false;
			query.value = "";
			inputDisplay.value = option.label;
			closeList();
		};
		const applySelection = () => {
			if (isOpen.value && activeIndex.value >= 0) {
				applyOption(options.value[activeIndex.value]);
				return true;
			}
			const matchIndex = findPrefixMatchIndex(query.value, optionLabels.value);
			if (matchIndex >= 0) {
				applyOption(options.value[matchIndex]);
				return true;
			}
			const custom = normalizeCustomFontFamily(query.value);
			if (custom) {
				emitFontCommand(custom, null);
				isEditing.value = false;
				query.value = "";
				inputDisplay.value = custom;
				closeList();
				return true;
			}
			return false;
		};
		const onKeydown = (event) => {
			if (event.isComposing || isComposing.value || event.keyCode === 229) return;
			if (event.ctrlKey || event.metaKey || event.altKey) return;
			switch (event.key) {
				case "ArrowDown":
					event.preventDefault();
					if (!isOpen.value) {
						const typedMatch = findPrefixMatchIndex(query.value, optionLabels.value);
						const index = typedMatch >= 0 ? typedMatch : appliedIndex();
						openList(index >= 0 ? index : 0);
					} else moveActive(1);
					break;
				case "ArrowUp":
					event.preventDefault();
					if (!isOpen.value) {
						const typedMatch = findPrefixMatchIndex(query.value, optionLabels.value);
						const index = typedMatch >= 0 ? typedMatch : appliedIndex();
						openList(index >= 0 ? index : options.value.length - 1);
					} else moveActive(-1);
					break;
				case "Enter":
					event.preventDefault();
					if (applySelection()) emit("editor-handoff");
					inputRef.value?.blur();
					break;
				case "Tab":
					event.preventDefault();
					applySelection();
					closeList();
					inputRef.value?.blur();
					emit("tab-out", event);
					break;
				case "Escape":
					event.preventDefault();
					resetToApplied();
					nextTick(() => inputRef.value?.focus());
					break;
				default: break;
			}
		};
		const onCaretMousedown = (event) => {
			event.preventDefault();
			if (disabled.value) return;
			emit("item-clicked");
			if (!isEditing.value) {
				isEditing.value = true;
				inputDisplay.value = appliedLabel.value;
				inputRef.value?.focus();
			}
			if (isOpen.value) closeList();
			else {
				const index = appliedIndex();
				openList(index >= 0 ? index : 0);
			}
		};
		const onOptionMousedown = (event, option) => {
			event.preventDefault();
			applyOption(option);
			emit("editor-handoff");
			inputRef.value?.blur();
		};
		const onOptionMouseenter = (index) => {
			activeIndex.value = index;
		};
		const handleDocumentPointerDown = (event) => {
			if (!isOpen.value) return;
			const target = event.target;
			if (!(target instanceof Element)) return;
			if (rootRef.value?.contains(target) || popupRef.value?.contains(target)) return;
			closeList();
		};
		watch(isOpen, (open) => {
			if (open) {
				document.addEventListener("pointerdown", handleDocumentPointerDown, true);
				window.addEventListener("resize", updatePosition$1);
				window.addEventListener("scroll", updatePosition$1, true);
			} else {
				document.removeEventListener("pointerdown", handleDocumentPointerDown, true);
				window.removeEventListener("resize", updatePosition$1);
				window.removeEventListener("scroll", updatePosition$1, true);
				optionRefs.value = [];
			}
		}, { immediate: true });
		onBeforeUnmount(() => {
			document.removeEventListener("pointerdown", handleDocumentPointerDown, true);
			window.removeEventListener("resize", updatePosition$1);
			window.removeEventListener("scroll", updatePosition$1, true);
		});
		const setOptionRef = (el, index) => {
			if (!el) {
				delete optionRefs.value[index];
				return;
			}
			optionRefs.value[index] = el;
		};
		const isOptionActive = (index) => index === activeIndex.value;
		const isOptionSelected = (option) => option?.key && option.key === props.item.selectedValue?.value;
		watch(appliedLabel, (label) => {
			if (isEditing.value) return;
			inputDisplay.value = label;
		});
		watch(() => Boolean(props.item.expand?.value), (expanded) => {
			if (expanded && !isOpen.value) {
				const index = appliedIndex();
				openList(index >= 0 ? index : 0, { focusInput: true });
				return;
			}
			if (!expanded && isOpen.value) closeList({ syncItem: false });
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "rootRef",
				ref: rootRef,
				class: normalizeClass(["sd-font-combobox sd-toolbar-split-field", {
					"sd-disabled": disabled.value,
					"high-contrast": unref(isHighContrastMode$1)
				}]),
				style: normalizeStyle(props.item.style?.value),
				"data-item": "btn-fontFamily"
			}, [
				createElementVNode("span", {
					class: "sd-font-combobox__field sd-toolbar-split-field__main",
					onMousedown: onInputMousedown
				}, [createElementVNode("input", {
					ref_key: "inputRef",
					ref: inputRef,
					class: "button-text-input sd-font-combobox__input",
					type: "text",
					role: "combobox",
					autocomplete: "off",
					spellcheck: "false",
					value: boundValue.value,
					style: normalizeStyle(inputStyle.value),
					disabled: disabled.value,
					"aria-label": ariaLabel.value,
					"aria-expanded": isOpen.value ? "true" : "false",
					"aria-controls": listboxId.value,
					"aria-activedescendant": activeDescendant.value,
					"aria-haspopup": "listbox",
					"aria-autocomplete": "both",
					onFocus,
					onBlur,
					onInput,
					onKeydown,
					onCompositionstart: _cache[0] || (_cache[0] = ($event) => isComposing.value = true),
					onCompositionend: onCompositionEnd
				}, null, 44, _hoisted_1$6)], 32),
				createElementVNode("button", {
					type: "button",
					class: "sd-font-combobox__caret sd-toolbar-split-field__caret",
					"data-item": "btn-fontFamily-toggle",
					tabindex: "-1",
					"aria-label": `${ariaLabel.value} options`,
					disabled: disabled.value,
					onMousedown: onCaretMousedown
				}, [createElementVNode("span", {
					class: "sd-dropdown-caret",
					innerHTML: caretIcon.value
				}, null, 8, _hoisted_3$3)], 40, _hoisted_2$4),
				(openBlock(), createBlock(Teleport, { to: "body" }, [isOpen.value ? (openBlock(), createElementBlock("div", {
					key: 0,
					ref_key: "popupRef",
					ref: popupRef,
					role: "listbox",
					id: listboxId.value,
					"aria-label": ariaLabel.value,
					class: normalizeClass(["sd-font-combobox__listbox", { "high-contrast": unref(isHighContrastMode$1) }]),
					style: normalizeStyle(menuStyle.value)
				}, [(openBlock(true), createElementBlock(Fragment, null, renderList(options.value, (option, index) => {
					return openBlock(), createElementBlock("div", mergeProps({
						key: option.key,
						ref_for: true,
						ref: (el) => setOptionRef(el, index),
						id: optionId(index),
						role: "option",
						class: ["toolbar-dropdown-option sd-font-combobox__option", {
							"sd-active": isOptionActive(index),
							"sd-selected": isOptionSelected(option)
						}],
						"aria-selected": isOptionSelected(option) ? "true" : "false",
						"aria-label": `${ariaLabel.value} - ${option.label}`
					}, { ref_for: true }, option.props, {
						onMousedown: (e) => onOptionMousedown(e, option),
						onMouseenter: ($event) => onOptionMouseenter(index)
					}), [createElementVNode("span", _hoisted_6$2, toDisplayString(option.label), 1)], 16, _hoisted_5$3);
				}), 128))], 14, _hoisted_4$3)) : createCommentVNode("", true)])),
				createElementVNode("span", _hoisted_7$1, toDisplayString(appliedLabel.value), 1)
			], 6);
		};
	}
}, [["__scopeId", "data-v-1e39033e"]]);
var SdTooltip_default = /* @__PURE__ */ __plugin_vue_export_helper_default(/* @__PURE__ */ Object.assign({ inheritAttrs: false }, {
	__name: "SdTooltip",
	props: {
		trigger: {
			type: String,
			default: "hover"
		},
		delay: {
			type: Number,
			default: 100
		},
		duration: {
			type: Number,
			default: 100
		},
		autoHideDuration: {
			type: Number,
			default: 0
		},
		disabled: {
			type: Boolean,
			default: false
		},
		contentStyle: {
			type: Object,
			default: () => ({})
		}
	},
	setup(__props) {
		const props = __props;
		const attrs = useAttrs();
		const isOpen = ref(false);
		const triggerRef = ref(null);
		const contentRef = ref(null);
		const position = ref({
			top: "0px",
			left: "0px"
		});
		let closeTimeout = null;
		let openTimeout = null;
		let autoHideTimeout = null;
		const mergedContentClass = computed(() => ["sd-tooltip-content", attrs.class]);
		const contentStyle = computed(() => ({
			...props.contentStyle,
			...attrs.style || {},
			position: "fixed",
			top: position.value.top,
			left: position.value.left,
			zIndex: 2100
		}));
		const clearCloseTimeout = () => {
			if (closeTimeout) {
				window.clearTimeout(closeTimeout);
				closeTimeout = null;
			}
		};
		const clearOpenTimeout = () => {
			if (openTimeout) {
				window.clearTimeout(openTimeout);
				openTimeout = null;
			}
		};
		const clearAutoHideTimeout = () => {
			if (autoHideTimeout) {
				window.clearTimeout(autoHideTimeout);
				autoHideTimeout = null;
			}
		};
		const scheduleAutoHide = () => {
			clearAutoHideTimeout();
			if (props.autoHideDuration <= 0) return;
			autoHideTimeout = window.setTimeout(() => {
				autoHideTimeout = null;
				close();
			}, props.autoHideDuration);
		};
		const updatePosition$1 = () => {
			if (!triggerRef.value || !contentRef.value) return;
			const triggerRect = triggerRef.value.getBoundingClientRect();
			const contentWidth = contentRef.value.offsetWidth;
			const contentHeight = contentRef.value.offsetHeight;
			const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
			const gutter = 8;
			let left$1 = triggerRect.left + triggerRect.width / 2 - contentWidth / 2;
			left$1 = Math.max(gutter, Math.min(left$1, viewportWidth - contentWidth - gutter));
			position.value = {
				top: `${triggerRect.top - contentHeight - 10}px`,
				left: `${left$1}px`
			};
		};
		const open = async () => {
			if (props.disabled) return;
			clearCloseTimeout();
			clearOpenTimeout();
			if (isOpen.value) return;
			isOpen.value = true;
			await nextTick();
			updatePosition$1();
			scheduleAutoHide();
		};
		const close = () => {
			clearOpenTimeout();
			clearCloseTimeout();
			clearAutoHideTimeout();
			if (!isOpen.value) return;
			isOpen.value = false;
		};
		const openWithDelay = () => {
			clearCloseTimeout();
			clearOpenTimeout();
			if (isOpen.value) return;
			if (props.delay === 0) {
				open();
				return;
			}
			openTimeout = window.setTimeout(() => {
				openTimeout = null;
				open();
			}, props.delay);
		};
		const closeWithDelay = () => {
			clearOpenTimeout();
			clearCloseTimeout();
			if (!isOpen.value) return;
			if (props.duration === 0) {
				close();
				return;
			}
			closeTimeout = window.setTimeout(() => {
				closeTimeout = null;
				close();
			}, props.duration);
		};
		const handleTriggerMouseEnter = () => {
			if (props.trigger !== "hover") return;
			openWithDelay();
		};
		const handleTriggerMouseLeave = () => {
			if (props.trigger !== "hover") return;
			closeWithDelay();
		};
		const handleContentMouseEnter = () => {
			clearOpenTimeout();
			clearCloseTimeout();
		};
		const handleContentMouseLeave = () => {
			closeWithDelay();
		};
		const handleEscape = (event) => {
			if (event.key === "Escape") close();
		};
		watch(() => props.disabled, (disabled) => {
			if (disabled) close();
		});
		watch(isOpen, (openState) => {
			if (openState) {
				window.addEventListener("resize", updatePosition$1);
				window.addEventListener("scroll", updatePosition$1, true);
				document.addEventListener("keydown", handleEscape, true);
			} else {
				window.removeEventListener("resize", updatePosition$1);
				window.removeEventListener("scroll", updatePosition$1, true);
				document.removeEventListener("keydown", handleEscape, true);
			}
		});
		onBeforeUnmount(() => {
			clearOpenTimeout();
			clearCloseTimeout();
			clearAutoHideTimeout();
			window.removeEventListener("resize", updatePosition$1);
			window.removeEventListener("scroll", updatePosition$1, true);
			document.removeEventListener("keydown", handleEscape, true);
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [createElementVNode("span", {
				ref_key: "triggerRef",
				ref: triggerRef,
				class: "sd-tooltip-trigger",
				onMouseenter: handleTriggerMouseEnter,
				onMouseleave: handleTriggerMouseLeave,
				onFocusin: handleTriggerMouseEnter,
				onFocusout: handleTriggerMouseLeave
			}, [renderSlot(_ctx.$slots, "trigger", {}, void 0, true)], 544), (openBlock(), createBlock(Teleport, { to: "body" }, [createVNode(Transition, { name: "fade-in-scale-up-transition" }, {
				default: withCtx(() => [isOpen.value && !__props.disabled ? (openBlock(), createElementBlock("div", {
					key: 0,
					ref_key: "contentRef",
					ref: contentRef,
					class: normalizeClass(mergedContentClass.value),
					style: normalizeStyle(contentStyle.value),
					onMouseenter: handleContentMouseEnter,
					onMouseleave: handleContentMouseLeave
				}, [_cache[0] || (_cache[0] = createElementVNode("span", {
					class: "sd-tooltip-arrow",
					"aria-hidden": "true"
				}, null, -1)), renderSlot(_ctx.$slots, "default", {}, void 0, true)], 38)) : createCommentVNode("", true)]),
				_: 3
			})]))], 64);
		};
	}
}), [["__scopeId", "data-v-f0925f67"]]);
var _hoisted_1$5 = ["data-toolbar-position"];
var _hoisted_2$3 = [
	"onKeydown",
	"tabindex",
	"data-item-id"
];
var _hoisted_3$2 = { key: 0 };
var _hoisted_4$2 = { key: 0 };
var _hoisted_5$2 = { key: 0 };
var _hoisted_6$1 = { key: 0 };
var TOOLBAR_TOOLTIP_AUTO_HIDE_MS = 3e3;
var ButtonGroup_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "ButtonGroup",
	props: {
		toolbarItems: {
			type: Array,
			required: true
		},
		overflowItems: {
			type: Array,
			default: () => []
		},
		uiFontFamily: {
			type: String,
			default: "Arial, Helvetica, sans-serif"
		},
		position: {
			type: String,
			default: "left"
		},
		fromOverflow: {
			type: Boolean,
			default: false
		},
		compactSideGroups: {
			type: Boolean,
			default: false
		}
	},
	emits: [
		"command",
		"item-clicked",
		"dropdown-update-show"
	],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const { proxy } = getCurrentInstance();
		const toolbarItemRefs = ref([]);
		const buttonGroupRef = ref(null);
		const props = __props;
		const currentItem = ref(null);
		const { isHighContrastMode: isHighContrastMode$1 } = useHighContrastMode();
		const isMobile = window.matchMedia("(max-width: 768px)").matches;
		const getPositionStyle = computed(() => {
			if (props.position === "left") return {
				minWidth: props.compactSideGroups ? "auto" : "120px",
				justifyContent: "flex-start"
			};
			if (props.position === "right") return {
				minWidth: props.compactSideGroups ? "auto" : "120px",
				justifyContent: "flex-end"
			};
			return {
				flexGrow: isMobile ? 0 : 1,
				justifyContent: "center"
			};
		});
		const isButton = (item) => item.type === "button";
		const isDropdown = (item) => item.type === "dropdown";
		const isFontFamily = (item) => item.type === "dropdown" && item.name?.value === "fontFamily";
		const isSeparator = (item) => item.type === "separator";
		const isOverflow = (item) => item.type === "overflow";
		const hasNestedOptions = (item) => Boolean(item.nestedOptions?.value?.length);
		const getExpanded = (item) => {
			if (!item) return false;
			const expand = item.expand;
			if (typeof expand === "object" && expand !== null && "value" in expand) return Boolean(expand.value);
			return Boolean(expand);
		};
		const setExpanded = (item, open) => {
			if (!item?.expand) return;
			item.expand.value = open;
		};
		const handleToolbarButtonClick = (item, argument = null) => {
			if (item.disabled.value) return;
			if (isOverflow(item)) {
				const willOpen = !getExpanded(item);
				if (willOpen) closeDropdowns();
				setExpanded(item, willOpen);
				currentItem.value = willOpen ? item : null;
				emit("item-clicked");
				return;
			}
			if (isDropdown(item)) return;
			if (currentItem.value && isDropdown(currentItem.value) && getExpanded(currentItem.value)) closeDropdowns();
			emit("item-clicked");
			emit("command", {
				item,
				argument: argument ?? item.argument?.value ?? null
			});
		};
		const handleToolbarButtonTextSubmit = (item, argument) => {
			if (item.disabled.value) return;
			currentItem.value = null;
			emit("command", {
				item,
				argument
			});
		};
		const handleSplitButtonMainClick = (item) => {
			if (item.disabled.value) return;
			closeDropdowns();
			const splitCommand = item.splitButtonCommand;
			const dropdownCommand = item.command;
			const targetCommand = splitCommand || dropdownCommand;
			if (!targetCommand) return;
			const commandItem = {
				...item,
				command: targetCommand
			};
			emit("item-clicked");
			emit("command", {
				item: commandItem,
				argument: null
			});
		};
		const closeDropdowns = (exceptItem = null) => {
			const toolbarItems = proxy?.$toolbar?.toolbarItems || [];
			const overflowItems = proxy?.$toolbar?.overflowItems || [];
			const allItems = [...toolbarItems, ...overflowItems];
			(allItems.length ? allItems : props.toolbarItems).forEach((toolbarItem) => {
				if (toolbarItem === exceptItem) return;
				const shouldCloseOverflow = isOverflow(toolbarItem) && !props.fromOverflow;
				if (isDropdown(toolbarItem) || shouldCloseOverflow) setExpanded(toolbarItem, false);
			});
			if (!exceptItem || currentItem.value !== exceptItem) currentItem.value = null;
		};
		const handleSelect = (item, option) => {
			closeDropdowns();
			emit("command", {
				item,
				argument: item.dropdownValueKey.value ? option[item.dropdownValueKey.value] : option.label,
				option
			});
			item.selectedValue.value = option.key;
		};
		const handleComboboxItemClicked = (item) => {
			closeDropdowns(item);
			emit("item-clicked");
		};
		const handleComboboxCommand = (payload) => {
			emit("command", payload);
		};
		const waitForFrame = () => new Promise((resolve) => requestAnimationFrame(resolve));
		const flushPendingToolbarMarks = () => Boolean(proxy?.$toolbar?.flushPendingMarkCommands?.());
		const handleEditorTextInputHandoff = () => {
			flushPendingToolbarMarks();
			prepareSelectionForTextInputHandoff(proxy?.$toolbar?.activeEditor);
			focusEditor();
		};
		const handleComboboxTabOut = (startIndex, event) => {
			closeDropdowns();
			flushPendingToolbarMarks();
			if (event.shiftKey) focusAdjacentToolbarControlAfterUpdate(startIndex, -1, () => focusPreviousButtonGroup() || focusEditor());
			else focusAdjacentToolbarControlAfterUpdate(startIndex, 1, true);
		};
		const handleToolbarButtonTabOut = (item, event) => {
			closeDropdowns();
			if (item.name.value === "fontSize" && !event.shiftKey) {
				handleEditorTextInputHandoff();
				return;
			}
			if (event.shiftKey) moveToAdjacentToolbarControl(event, -1);
			else moveToAdjacentToolbarControl(event, 1) || focusEditor();
		};
		const dropdownOptions = (item) => {
			if (!item.nestedOptions?.value?.length) return [];
			return item.nestedOptions.value.map((option) => {
				const isSelected = option?.type !== "render" && item.selectedValue.value === option.key;
				return {
					...option,
					props: {
						...option.props,
						class: isSelected ? "sd-selected" : ""
					}
				};
			});
		};
		const getDropdownAttributes = (option, item) => {
			return {
				role: "menuitem",
				ariaLabel: `${item.attributes.value.ariaLabel} - ${option.label}`
			};
		};
		const moveToNextButton = (e) => {
			const currentButton = e.target;
			const nextButton = e.target.closest(".sd-toolbar-item-ctn").nextElementSibling;
			if (nextButton) {
				currentButton.setAttribute("tabindex", "-1");
				nextButton.setAttribute("tabindex", "0");
				nextButton.focus();
			}
		};
		const moveToPreviousButton = (e) => {
			const currentButton = e.target;
			const previousButton = e.target.closest(".sd-toolbar-item-ctn").previousElementSibling;
			if (previousButton) {
				currentButton.setAttribute("tabindex", "-1");
				previousButton.setAttribute("tabindex", "0");
				previousButton.focus();
			}
		};
		const focusEditor = () => {
			const editor = proxy?.$toolbar?.activeEditor;
			if (editor && typeof editor.focus === "function") {
				editor.focus();
				return true;
			}
			const editorDom = editor?.view?.dom;
			if (editorDom instanceof HTMLElement) {
				editorDom.focus();
				return true;
			}
			return false;
		};
		const getToolbarItemFocusTarget = (container) => {
			if (!(container instanceof HTMLElement)) return null;
			if (container.classList.contains("sd-disabled")) return null;
			return container.querySelector("input:not([disabled]), textarea:not([disabled]), select:not([disabled])") || container.querySelector("button:not([disabled]), [role=\"button\"]:not(.sd-disabled), [tabindex]:not([tabindex=\"-1\"])");
		};
		const getCurrentToolbarItemContainers = () => {
			if (toolbarItemRefs.value.length) return toolbarItemRefs.value;
			const group = document.querySelector(`.button-group[data-toolbar-position="${props.position}"]`);
			if (!group) return [];
			return Array.from(group.querySelectorAll(":scope > .sd-toolbar-item-ctn"));
		};
		const focusToolbarControlFromIndex = (startIndex, direction) => {
			if (startIndex < 0) return false;
			const containers = getCurrentToolbarItemContainers();
			let index = startIndex + direction;
			while (index >= 0 && index < containers.length) {
				const container = containers[index];
				const target = getToolbarItemFocusTarget(container);
				if (target instanceof HTMLElement) {
					containers[startIndex]?.setAttribute("tabindex", "-1");
					container.setAttribute("tabindex", "0");
					target.focus();
					return true;
				}
				index += direction;
			}
			return false;
		};
		const focusPreviousButtonGroup = () => {
			const previousButtonGroup = buttonGroupRef.value?.previousElementSibling;
			if (previousButtonGroup instanceof HTMLElement) {
				previousButtonGroup.setAttribute("tabindex", "0");
				previousButtonGroup.focus();
				return true;
			}
			return false;
		};
		const focusAdjacentToolbarControlAfterUpdate = async (startIndex, direction, fallback = false) => {
			await nextTick();
			await waitForFrame();
			if (focusToolbarControlFromIndex(startIndex, direction)) return;
			if (typeof fallback === "function") {
				fallback();
				return;
			}
			if (fallback) focusEditor();
		};
		const moveToAdjacentToolbarControl = (event, direction) => {
			const current = event.target.closest(".sd-toolbar-item-ctn");
			if (!(current instanceof HTMLElement)) return false;
			let candidate = direction > 0 ? current.nextElementSibling : current.previousElementSibling;
			while (candidate) {
				const target = getToolbarItemFocusTarget(candidate);
				if (target instanceof HTMLElement) {
					current.setAttribute("tabindex", "-1");
					candidate.setAttribute("tabindex", "0");
					target.focus();
					return true;
				}
				candidate = direction > 0 ? candidate.nextElementSibling : candidate.previousElementSibling;
			}
			return false;
		};
		const moveToNextButtonGroup = (e) => {
			const nextButtonGroup = e.target.closest(".button-group").nextElementSibling;
			if (nextButtonGroup) {
				nextButtonGroup.setAttribute("tabindex", "0");
				nextButtonGroup.focus();
			} else focusEditor();
		};
		const moveToPreviousButtonGroup = (e) => {
			const previousButtonGroup = e.target.closest(".button-group").previousElementSibling;
			if (previousButtonGroup) {
				previousButtonGroup.setAttribute("tabindex", "0");
				previousButtonGroup.focus();
			}
		};
		const activateToolbarItem = (item) => {
			if (item.disabled.value) return;
			if (isDropdown(item)) {
				handleDropdownUpdateShowForItem(!getExpanded(item), item);
				return;
			}
			handleToolbarButtonClick(item, null, false);
		};
		const handleKeyDown$1 = (e, item) => {
			const isTypingField = e.target.nodeName === "INPUT" || e.target.nodeName === "TEXTAREA";
			const isTypingToolbarItem = item.name.value === "fontSize" || item.name.value === "fontFamily";
			if (isTypingField && isTypingToolbarItem) return;
			if (![
				"Enter",
				" ",
				"Spacebar",
				"Escape",
				"ArrowRight",
				"ArrowLeft",
				"Tab"
			].includes(e.key)) return;
			e.preventDefault();
			switch (e.key) {
				case "Enter":
				case " ":
				case "Spacebar":
					activateToolbarItem(item);
					break;
				case "Escape":
					closeDropdowns();
					break;
				case "ArrowRight":
					closeDropdowns();
					moveToNextButton(e);
					break;
				case "ArrowLeft":
					closeDropdowns();
					moveToPreviousButton(e);
					break;
				case "Tab":
					if (e.shiftKey) moveToPreviousButtonGroup(e);
					else moveToNextButtonGroup(e);
					break;
				default: break;
			}
		};
		const handleFocus = (e) => {
			const firstButton = toolbarItemRefs.value.find((item) => !item.classList.contains("sd-disabled"));
			if (firstButton) {
				firstButton.setAttribute("tabindex", "0");
				firstButton.focus();
			}
		};
		const handleDropdownUpdateShowForItem = (open, item) => {
			emit("item-clicked");
			if (!open) {
				closeDropdowns();
				emit("dropdown-update-show", false);
				return;
			}
			closeDropdowns();
			currentItem.value = item;
			setExpanded(item, true);
			emit("dropdown-update-show", true);
		};
		const handleDocumentPointerDown = (event) => {
			if (!currentItem.value) return;
			const target = event.target;
			if (!(target instanceof Element)) return;
			if (target.closest(".sd-toolbar-dropdown-menu, .sd-font-combobox__listbox")) return;
			if (buttonGroupRef.value?.contains(target)) return;
			closeDropdowns();
		};
		const isCurrentItemExpanded = () => {
			return getExpanded(currentItem.value);
		};
		watch(isCurrentItemExpanded, (isOpen) => {
			if (isOpen) document.addEventListener("pointerdown", handleDocumentPointerDown, true);
			else document.removeEventListener("pointerdown", handleDocumentPointerDown, true);
		}, { immediate: true });
		onBeforeUnmount(() => {
			document.removeEventListener("pointerdown", handleDocumentPointerDown, true);
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				style: normalizeStyle(getPositionStyle.value),
				class: "button-group",
				role: "group",
				onFocus: handleFocus,
				ref_key: "buttonGroupRef",
				ref: buttonGroupRef,
				"data-toolbar-position": props.position
			}, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.toolbarItems, (item, index) => {
				return openBlock(), createElementBlock("div", {
					key: item.id.value,
					class: normalizeClass([{
						narrow: item.isNarrow.value,
						wide: item.isWide.value,
						"sd-disabled": item.disabled.value
					}, "sd-toolbar-item-ctn"]),
					onKeydown: (e) => handleKeyDown$1(e, item),
					ref_for: true,
					ref_key: "toolbarItemRefs",
					ref: toolbarItemRefs,
					tabindex: index === 0 ? 0 : -1,
					"data-item-id": item.id.value
				}, [
					isSeparator(item) ? (openBlock(), createBlock(ToolbarSeparator_default, {
						key: 0,
						style: { "width": "20px" }
					})) : createCommentVNode("", true),
					isFontFamily(item) && hasNestedOptions(item) ? (openBlock(), createBlock(SdTooltip_default, {
						key: 1,
						trigger: "hover",
						disabled: !item.tooltip?.value,
						"auto-hide-duration": TOOLBAR_TOOLTIP_AUTO_HIDE_MS,
						"content-style": { fontFamily: props.uiFontFamily }
					}, {
						trigger: withCtx(() => [createVNode(FontFamilyCombobox_default, {
							item,
							"ui-font-family": props.uiFontFamily,
							class: "sd-toolbar-button sd-editor-toolbar-dropdown",
							onCommand: handleComboboxCommand,
							onItemClicked: ($event) => handleComboboxItemClicked(item),
							onTabOut: ($event) => handleComboboxTabOut(index, $event),
							onEditorHandoff: handleEditorTextInputHandoff
						}, null, 8, [
							"item",
							"ui-font-family",
							"onItemClicked",
							"onTabOut"
						])]),
						default: withCtx(() => [createElementVNode("div", null, [createTextVNode(toDisplayString(item.tooltip) + " ", 1), item.disabled.value ? (openBlock(), createElementBlock("span", _hoisted_3$2, "(disabled)")) : createCommentVNode("", true)])]),
						_: 2
					}, 1032, ["disabled", "content-style"])) : isDropdown(item) && hasNestedOptions(item) ? (openBlock(), createBlock(ToolbarDropdown_default, {
						key: 2,
						options: dropdownOptions(item),
						disabled: item.disabled.value,
						show: getExpanded(item),
						"content-style": { fontFamily: props.uiFontFamily },
						placement: "bottom-start",
						class: "sd-toolbar-button sd-editor-toolbar-dropdown",
						onSelect: (key, option) => handleSelect(item, option),
						"onUpdate:show": (open) => handleDropdownUpdateShowForItem(open, item),
						style: normalizeStyle(item.dropdownStyles.value),
						"menu-props": () => ({
							role: "menu",
							style: { fontFamily: props.uiFontFamily },
							class: ["sd-toolbar-dropdown-menu", { "high-contrast": unref(isHighContrastMode$1) }]
						}),
						"node-props": (option) => getDropdownAttributes(option, item)
					}, {
						trigger: withCtx(() => [createVNode(SdTooltip_default, {
							trigger: "hover",
							disabled: !item.tooltip?.value,
							"auto-hide-duration": TOOLBAR_TOOLTIP_AUTO_HIDE_MS,
							"content-style": { fontFamily: props.uiFontFamily }
						}, {
							trigger: withCtx(() => [createVNode(ToolbarButton_default, {
								"toolbar-item": item,
								disabled: item.disabled.value,
								"allow-enter-propagation": true,
								onTextSubmit: ($event) => handleToolbarButtonTextSubmit(item, $event),
								onMainClick: ($event) => handleSplitButtonMainClick(item),
								onTabOut: ($event) => handleToolbarButtonTabOut(item, $event)
							}, null, 8, [
								"toolbar-item",
								"disabled",
								"onTextSubmit",
								"onMainClick",
								"onTabOut"
							])]),
							default: withCtx(() => [createElementVNode("div", null, [createTextVNode(toDisplayString(item.tooltip) + " ", 1), item.disabled.value ? (openBlock(), createElementBlock("span", _hoisted_4$2, "(disabled)")) : createCommentVNode("", true)])]),
							_: 2
						}, 1032, ["disabled", "content-style"])]),
						_: 2
					}, 1032, [
						"options",
						"disabled",
						"show",
						"content-style",
						"onSelect",
						"onUpdate:show",
						"style",
						"menu-props",
						"node-props"
					])) : isButton(item) ? (openBlock(), createBlock(SdTooltip_default, {
						key: 3,
						trigger: "hover",
						class: "sd-editor-toolbar-tooltip",
						"auto-hide-duration": TOOLBAR_TOOLTIP_AUTO_HIDE_MS,
						"content-style": { fontFamily: props.uiFontFamily }
					}, {
						trigger: withCtx(() => [createVNode(ToolbarButton_default, {
							"toolbar-item": item,
							"is-overflow-item": __props.fromOverflow,
							onTextSubmit: ($event) => handleToolbarButtonTextSubmit(item, $event),
							onButtonClick: ($event) => handleToolbarButtonClick(item)
						}, null, 8, [
							"toolbar-item",
							"is-overflow-item",
							"onTextSubmit",
							"onButtonClick"
						])]),
						default: withCtx(() => [item.tooltip ? (openBlock(), createElementBlock("div", _hoisted_5$2, [createTextVNode(toDisplayString(item.tooltip) + " ", 1), item.disabled.value ? (openBlock(), createElementBlock("span", _hoisted_6$1, "(disabled)")) : createCommentVNode("", true)])) : createCommentVNode("", true)]),
						_: 2
					}, 1032, ["content-style"])) : createCommentVNode("", true),
					isOverflow(item) && __props.overflowItems.length ? (openBlock(), createBlock(OverflowMenu_default, {
						key: 4,
						"toolbar-item": item,
						onButtonClick: ($event) => handleToolbarButtonClick(item),
						"overflow-items": __props.overflowItems,
						onClose: closeDropdowns
					}, null, 8, [
						"toolbar-item",
						"onButtonClick",
						"overflow-items"
					])) : createCommentVNode("", true)
				], 42, _hoisted_2$3);
			}), 128))], 44, _hoisted_1$5);
		};
	}
}, [["__scopeId", "data-v-181bd035"]]);
var DEFAULT_UI_FONT_FAMILY = "Arial, Helvetica, sans-serif";
var Toolbar_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "Toolbar",
	emits: [
		"command",
		"toggle",
		"select"
	],
	setup(__props, { emit: __emit }) {
		const { proxy } = getCurrentInstance();
		let toolbarKey = ref(1);
		const compactSideGroups = ref(false);
		let containerResizeObserver = null;
		const uiFontFamily = computed(() => {
			const configured = proxy?.$toolbar?.config?.uiDisplayFallbackFont;
			if (typeof configured === "string" && configured.trim()) return configured.trim();
			return DEFAULT_UI_FONT_FAMILY;
		});
		const showLeftSide = proxy.$toolbar.config?.toolbarGroups?.includes("left");
		const showRightSide = proxy.$toolbar.config?.toolbarGroups?.includes("right");
		const excludeButtonsList = proxy.$toolbar.config?.toolbarButtonsExclude || [];
		const getFilteredItems = (position) => {
			return proxy.$toolbar.getToolbarItemByGroup(position).filter((item) => !excludeButtonsList.includes(item.name.value));
		};
		const updateCompactSideGroups = () => {
			compactSideGroups.value = proxy.$toolbar.getAvailableWidth() <= RESPONSIVE_BREAKPOINTS.lg;
		};
		const onKeyDown = async (e) => {
			if (e.metaKey && e.key === "f") {
				const searchItem = proxy.$toolbar.getToolbarItemByName("search");
				if (searchItem) {
					e.preventDefault();
					searchItem.expand.value = true;
					await nextTick();
					if (searchItem.inputRef.value) searchItem.inputRef.value.focus();
				}
			}
		};
		const onWindowResized = async () => {
			await proxy.$toolbar.onToolbarResize();
			updateCompactSideGroups();
			toolbarKey.value += 1;
		};
		const onResizeThrottled = throttle(onWindowResized, 300);
		const onToolbarItemsChanged = () => {
			toolbarKey.value += 1;
		};
		function teardownListeners() {
			window.removeEventListener("resize", onResizeThrottled);
			window.removeEventListener("keydown", onKeyDown);
			proxy.$toolbar.off?.("toolbar-items-changed", onToolbarItemsChanged);
			containerResizeObserver?.disconnect();
			containerResizeObserver = null;
		}
		function setupListeners() {
			teardownListeners();
			window.addEventListener("resize", onResizeThrottled);
			window.addEventListener("keydown", onKeyDown);
			proxy.$toolbar.on?.("toolbar-items-changed", onToolbarItemsChanged);
			if (typeof ResizeObserver !== "undefined" && proxy.$toolbar.config?.responsiveToContainer && proxy.$toolbar.toolbarContainer) {
				containerResizeObserver = new ResizeObserver(() => {
					onResizeThrottled();
				});
				containerResizeObserver.observe(proxy.$toolbar.toolbarContainer);
			}
			updateCompactSideGroups();
		}
		onMounted(setupListeners);
		onActivated(setupListeners);
		onDeactivated(teardownListeners);
		onBeforeUnmount(teardownListeners);
		const handleCommand = ({ item, argument, option }) => {
			proxy.$toolbar.emitCommand({
				item,
				argument,
				option
			});
		};
		const restoreSelection$1 = () => {
			const editor = proxy.$toolbar.activeEditor;
			if (!editor) return;
			if (editor.options?.isHeaderOrFooter) return;
			editor.commands?.restoreSelection();
		};
		const handleToolbarMousedown = (e) => {
			if (e.target.closest("input, textarea, [contenteditable=\"true\"]")) return;
			e.preventDefault();
		};
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "superdoc-toolbar",
				key: unref(toolbarKey),
				role: "toolbar",
				"aria-label": "Toolbar",
				"data-sd-part": "toolbar",
				"data-editor-ui-surface": "",
				onMousedown: handleToolbarMousedown
			}, [
				unref(showLeftSide) ? (openBlock(), createBlock(ButtonGroup_default, {
					key: 0,
					tabindex: "0",
					"toolbar-items": getFilteredItems("left"),
					"compact-side-groups": compactSideGroups.value,
					"ui-font-family": uiFontFamily.value,
					position: "left",
					onCommand: handleCommand,
					onItemClicked: restoreSelection$1,
					class: "superdoc-toolbar-group-side"
				}, null, 8, [
					"toolbar-items",
					"compact-side-groups",
					"ui-font-family"
				])) : createCommentVNode("", true),
				createVNode(ButtonGroup_default, {
					tabindex: "0",
					"toolbar-items": getFilteredItems("center"),
					"overflow-items": unref(proxy).$toolbar.overflowItems,
					"compact-side-groups": compactSideGroups.value,
					"ui-font-family": uiFontFamily.value,
					position: "center",
					onCommand: handleCommand,
					onItemClicked: restoreSelection$1
				}, null, 8, [
					"toolbar-items",
					"overflow-items",
					"compact-side-groups",
					"ui-font-family"
				]),
				unref(showRightSide) ? (openBlock(), createBlock(ButtonGroup_default, {
					key: 1,
					tabindex: "0",
					"toolbar-items": getFilteredItems("right"),
					"compact-side-groups": compactSideGroups.value,
					"ui-font-family": uiFontFamily.value,
					position: "right",
					onCommand: handleCommand,
					onItemClicked: restoreSelection$1,
					class: "superdoc-toolbar-group-side"
				}, null, 8, [
					"toolbar-items",
					"compact-side-groups",
					"ui-font-family"
				])) : createCommentVNode("", true)
			], 32);
		};
	}
}, [["__scopeId", "data-v-938eaa1b"]]);
const toolbarTexts = {
	bold: "Bold",
	fontFamily: "Font family",
	ai: "AI text generation",
	fontSize: "Font size",
	italic: "Italic",
	underline: "Underline",
	highlight: "Highlight color",
	strikethrough: "Strikethrough",
	color: "Text color",
	search: "Search",
	link: "Link",
	image: "Image",
	tableOfContents: "Table of contents",
	table: "Insert table",
	tableActions: "Table options",
	addRowBefore: "Insert row above",
	addRowAfter: "Insert row below",
	addColumnBefore: "Insert column left",
	addColumnAfter: "Insert column right",
	deleteRow: "Delete row",
	deleteColumn: "Delete column",
	deleteTable: "Delete table",
	removeBorders: "Remove borders",
	mergeCells: "Merge cells",
	splitCell: "Split cell",
	fixTables: "Fix tables",
	textAlign: "Alignment",
	bulletList: "Bullet list",
	numberedList: "Numbered list",
	indentLeft: "Left indent",
	indentRight: "Right indent",
	directionLtr: "Left-to-right",
	directionRtl: "Right-to-left",
	zoom: "Zoom",
	undo: "Undo",
	redo: "Redo",
	trackChanges: "Track Changes",
	trackChangesAccept: "Accept changes under selection",
	trackChangesReject: "Reject changes under selection",
	trackChangesOriginal: "Toggle Show Original",
	trackChangesFinal: "Toggle Show Final",
	clearFormatting: "Clear formatting",
	copyFormat: "Format painter",
	lineHeight: "Line height",
	formatText: "Format text",
	ruler: "Show or hide ruler",
	formattingMarks: "Show or hide formatting marks",
	pageBreak: "Insert page break",
	documentEditingMode: "Editing",
	documentSuggestingMode: "Suggesting",
	documentViewingMode: "Viewing",
	documentEditingModeDescription: "Edit document directly",
	documentSuggestingModeDescription: "Edits become suggestions",
	documentViewingModeDescription: "View clean version of document only",
	linkedStyles: "Linked styles"
};
const getParagraphFontFamilyFromProperties = (paragraphProps, convertedXml = {}) => {
	const fontFamilyProps = paragraphProps?.runProperties?.fontFamily;
	if (!fontFamilyProps) return null;
	const [markDef] = encodeMarksFromRPr({ fontFamily: fontFamilyProps }, convertedXml);
	return markDef?.attrs?.fontFamily ?? null;
};
const findElementBySelector = (selector) => {
	let el = null;
	if (selector) {
		if (selector.startsWith("#") || selector.startsWith(".")) el = document.querySelector(selector);
		else el = document.getElementById(selector);
		if (!el) return null;
	}
	return el;
};
var SuperToolbar = class SuperToolbar extends import_eventemitter3.default {
	static #MARK_TOGGLE_NAMES = new Set([
		"bold",
		"italic",
		"underline",
		"strike",
		"highlight",
		"color",
		"fontSize",
		"fontFamily"
	]);
	config = {
		selector: null,
		toolbarGroups: [
			"left",
			"center",
			"right"
		],
		role: "editor",
		icons: { ...toolbarIcons },
		texts: { ...toolbarTexts },
		fonts: null,
		hideButtons: true,
		responsiveToContainer: false,
		mode: "docx",
		excludeItems: [],
		groups: null,
		editor: null,
		aiApiKey: null,
		aiEndpoint: null,
		customButtons: [],
		showFormattingMarksButton: false,
		showTableOfContentsButton: false
	};
	toolbarItems = [];
	overflowItems = [];
	isDev = false;
	role = "editor";
	superdoc;
	toolbarContainer = null;
	toolbar = null;
	constructor(config) {
		super();
		this.config = {
			...this.config,
			...config
		};
		this.toolbarItems = [];
		this.overflowItems = [];
		this.isDev = config.isDev || false;
		this.superdoc = config.superdoc;
		this.role = config.role || "editor";
		this.toolbarContainer = null;
		this.controller = null;
		this.snapshot = null;
		this._unsubscribeController = null;
		if (this.config.editor) this.config.mode = this.config.editor.options.mode;
		this.config.icons = {
			...toolbarIcons,
			...config.icons
		};
		this.config.texts = {
			...toolbarTexts,
			...config.texts
		};
		this.config.hideButtons = config.hideButtons ?? true;
		this.config.responsiveToContainer = config.responsiveToContainer ?? false;
		this.pendingMarkCommands = [];
		this.stickyStoredMarks = null;
		this._boundEditorHandlers = {
			transaction: null,
			selectionUpdate: null,
			focus: null,
			fontsChanged: null
		};
		this._lastFontOptionsSignature = "";
		this._restoreFocusTimeoutId = null;
		if (!this.config.selector && this.config.element) this.config.selector = this.config.element;
		this.toolbarContainer = findElementBySelector(this.config.selector);
		if (this.toolbarContainer) {
			const uiFontFamily = (this.config?.uiDisplayFallbackFont || "").toString().trim() || "Arial, Helvetica, sans-serif";
			this.toolbarContainer.style.setProperty("--sd-ui-font-family", uiFontFamily);
		}
		this.#initToolbarGroups();
		this.#makeToolbarItems({
			superToolbar: this,
			icons: this.config.icons,
			texts: this.config.texts,
			fonts: this.config.fonts,
			hideButtons: this.config.hideButtons,
			isDev: config.isDev
		});
		if (this.config.selector && !this.toolbarContainer) return;
		this.app = createApp(Toolbar_default);
		this.app.directive("click-outside", v_click_outside_default);
		this.app.config.globalProperties.$toolbar = this;
		if (this.toolbarContainer) this.toolbar = this.app.mount(this.toolbarContainer);
		this.activeEditor = config.editor || null;
		this.initHeadlessToolbar();
		this.updateToolbarState();
	}
	createHeadlessToolbar() {
		if (!this.superdoc) return null;
		return createHeadlessToolbar({
			superdoc: this.superdoc,
			commands: HEADLESS_TOOLBAR_COMMANDS
		});
	}
	initHeadlessToolbar() {
		if (!this.superdoc) return;
		this.destroyHeadlessToolbar();
		this.controller = this.createHeadlessToolbar();
		this.snapshot = this.controller.getSnapshot();
		this._unsubscribeController = this.controller.subscribe(({ snapshot }) => {
			this.snapshot = snapshot;
			this.updateToolbarState();
		});
	}
	destroyHeadlessToolbar() {
		this._unsubscribeController?.();
		this.controller?.destroy();
		this.controller = null;
		this.snapshot = null;
		this._unsubscribeController = null;
	}
	#initToolbarGroups() {
		if (this.config.groups && !Array.isArray(this.config.groups) && Object.keys(this.config.groups).length) this.config.toolbarGroups = Object.keys(this.config.groups);
	}
	#detachActiveEditorListeners() {
		if (!this.activeEditor || !this._boundEditorHandlers.transaction) return;
		this.activeEditor.off("transaction", this._boundEditorHandlers.transaction);
		this.activeEditor.off("selectionUpdate", this._boundEditorHandlers.selectionUpdate);
		this.activeEditor.off("focus", this._boundEditorHandlers.focus);
		this.activeEditor.off("fonts-changed", this._boundEditorHandlers.fontsChanged);
		this._boundEditorHandlers.transaction = null;
		this._boundEditorHandlers.selectionUpdate = null;
		this._boundEditorHandlers.focus = null;
		this._boundEditorHandlers.fontsChanged = null;
	}
	setActiveEditor(editor) {
		const sameEditor = editor === this.activeEditor;
		const alreadyListening = Boolean(this._boundEditorHandlers.transaction);
		if (sameEditor && (!editor || alreadyListening)) {
			this.updateToolbarState();
			return;
		}
		this.#detachActiveEditorListeners();
		this.activeEditor = editor;
		if (editor) {
			this._boundEditorHandlers.transaction = this.onEditorTransaction.bind(this);
			this._boundEditorHandlers.selectionUpdate = this.onEditorSelectionUpdate.bind(this);
			this._boundEditorHandlers.focus = this.onEditorFocus.bind(this);
			this._boundEditorHandlers.fontsChanged = this.onEditorFontsChanged.bind(this);
			this.activeEditor.on("transaction", this._boundEditorHandlers.transaction);
			this.activeEditor.on("selectionUpdate", this._boundEditorHandlers.selectionUpdate);
			this.activeEditor.on("focus", this._boundEditorHandlers.focus);
			this.activeEditor.on("fonts-changed", this._boundEditorHandlers.fontsChanged);
		}
		this.#rebuildToolbarItems();
		this._lastFontOptionsSignature = this.#fontOptionsSignature();
		this.updateToolbarState();
	}
	getToolbarItemByGroup(groupName) {
		return this.toolbarItems.filter((item) => (item.group?.value || "center") === groupName);
	}
	getToolbarItemByName(name) {
		return this.#getAllToolbarItems().find((item) => item.name.value === name);
	}
	#getAllToolbarItems() {
		return [...this.toolbarItems, ...this.overflowItems];
	}
	getAvailableWidth() {
		const documentWidth = document.documentElement.clientWidth;
		const containerWidth = this.toolbarContainer?.offsetWidth ?? 0;
		return this.config.responsiveToContainer ? containerWidth : documentWidth;
	}
	#makeToolbarItems({ superToolbar, icons: icons$1, texts, fonts, hideButtons, isDev = false } = {}) {
		const availableWidth = this.getAvailableWidth();
		const { defaultItems, overflowItems } = makeDefaultItems({
			superToolbar,
			toolbarIcons: icons$1,
			toolbarTexts: texts,
			toolbarFonts: this.#resolveToolbarFonts(fonts),
			hideButtons,
			availableWidth,
			role: this.role,
			isDev
		});
		const customItems = this.config.customButtons || [];
		if (customItems.length) defaultItems.push(...customItems.map((item) => useToolbarItem({ ...item })));
		let allConfigItems = [...defaultItems.map((item) => item.name.value), ...overflowItems.map((item) => item.name.value)];
		if (this.config.groups) allConfigItems = Object.values(this.config.groups).flatMap((item) => item);
		this.toolbarItems = defaultItems.filter((item) => allConfigItems.includes(item.name.value)).filter((item) => !this.config.excludeItems.includes(item.name.value));
		this.overflowItems = overflowItems.filter((item) => allConfigItems.includes(item.name.value));
	}
	#resolveToolbarFonts(configFonts) {
		return composeToolbarFontOptions(this.superdoc?.fonts?.getDocumentFontOptions?.() ?? [], configFonts);
	}
	#rebuildToolbarItems() {
		this.#makeToolbarItems({
			superToolbar: this,
			icons: this.config.icons,
			texts: this.config.texts,
			fonts: this.config.fonts,
			hideButtons: this.config.hideButtons,
			isDev: this.isDev
		});
		this.emit("toolbar-items-changed");
	}
	#fontOptionsSignature() {
		if (this.config.fonts) return "custom-fonts";
		const options = this.superdoc?.fonts?.getDocumentFontOptions?.() ?? [];
		return JSON.stringify(options.map((option) => [option.logicalFamily, option.previewFamily]));
	}
	#initDefaultFonts() {
		if (!this.activeEditor || !this.activeEditor.converter) return;
		const { typeface = "Arial", fontSizePt = 12 } = this.activeEditor.converter.getDocumentDefaultStyles() ?? {};
		const fontSizeItem = this.toolbarItems.find((item) => item.name.value === "fontSize");
		if (fontSizeItem) fontSizeItem.defaultLabel.value = fontSizePt;
		const fontFamilyItem = this.toolbarItems.find((item) => item.name.value === "fontFamily");
		if (fontFamilyItem) fontFamilyItem.defaultLabel.value = typeface;
	}
	#updateHighlightColors() {
		if (!this.activeEditor || !this.activeEditor.converter) return;
		if (!this.activeEditor.converter.docHiglightColors.size) return;
		const highlightItem = this.toolbarItems.find((item) => item.name.value === "highlight");
		if (!highlightItem) return;
		const pickerColorOptions = getAvailableColorOptions();
		const perChunk = 7;
		const result = Array.from(this.activeEditor.converter.docHiglightColors).reduce((resultArray, item, index) => {
			const chunkIndex = Math.floor(index / perChunk);
			if (!resultArray[chunkIndex]) resultArray[chunkIndex] = [];
			if (!pickerColorOptions.includes(item)) resultArray[chunkIndex].push(makeColorOption(item));
			return resultArray;
		}, []);
		const option = {
			key: "color",
			type: "render",
			render: () => renderColorOptions(this, highlightItem, result, true)
		};
		highlightItem.nestedOptions.value = [option];
	}
	#syncDocumentModeUi() {
		const documentModeItem = this.getToolbarItemByName("documentMode");
		if (!documentModeItem) return;
		const mode = (this.snapshot?.commands?.["document-mode"]?.value || "editing").toLowerCase();
		const texts = this.config.texts || {};
		const icons$1 = this.config.icons || {};
		const map$1 = {
			editing: {
				label: texts.documentEditingMode || "Editing",
				icon: icons$1.documentEditingMode || icons$1.documentMode
			},
			suggesting: {
				label: texts.documentSuggestingMode || "Suggesting",
				icon: icons$1.documentSuggestingMode || icons$1.documentMode
			},
			viewing: {
				label: texts.documentViewingMode || "Viewing",
				icon: icons$1.documentViewingMode || icons$1.documentMode
			}
		};
		const next = map$1[mode] || map$1.editing;
		if (documentModeItem.label?.value !== void 0) documentModeItem.label.value = next.label;
		if (documentModeItem.defaultLabel?.value !== void 0) documentModeItem.defaultLabel.value = next.label;
		if (documentModeItem.icon?.value !== void 0 && next.icon) documentModeItem.icon.value = next.icon;
	}
	#getFontFamilyFallbackValue() {
		if (!this.activeEditor?.state) return null;
		const { state } = this.activeEditor;
		const selection = state.selection;
		if (!selection?.empty) return null;
		const paragraphParent = findParentNode((n) => n.type.name === "paragraph")(selection);
		if (!paragraphParent || paragraphParent.node?.content?.size !== 0) return null;
		return getParagraphFontFamilyFromProperties(calculateResolvedParagraphProperties(this.activeEditor, paragraphParent.node, state.doc.resolve(paragraphParent.pos)), this.activeEditor?.converter?.convertedXml ?? {}) || null;
	}
	#isFontSizeMixedState(commandState) {
		return Boolean(commandState?.active) && commandState?.value == null;
	}
	#applyHeadlessState(item) {
		if (item.name.value === "tableActions") {
			const hasAnyEnabled = TABLE_ACTION_COMMAND_IDS.map((commandId$1) => this.snapshot?.commands?.[commandId$1]).some((state) => state && !state.disabled);
			item.setDisabled(!hasAnyEnabled);
			return true;
		}
		const commandId = HEADLESS_ITEM_MAP[item.name.value];
		if (!commandId) return false;
		const commandState = this.snapshot?.commands?.[commandId];
		const setDisabled = () => {
			item.setDisabled(Boolean(commandState?.disabled));
		};
		const handlers = {
			textAlign: () => {
				if (commandState?.value) item.activate({ textAlign: commandState.value });
				else item.deactivate();
			},
			lineHeight: () => {
				item.selectedValue.value = commandState?.value != null ? commandState.value : "";
			},
			zoom: () => {
				if (commandState?.value != null) {
					const value = typeof commandState.value === "number" ? `${commandState.value}%` : String(commandState.value);
					item.onActivate({ zoom: value });
				}
			},
			documentMode: () => {
				this.#syncDocumentModeUi();
			},
			link: () => {
				item.active.value = Boolean(commandState?.active);
				item.attributes.value = commandState?.value ? { href: commandState.value } : {};
			},
			fontFamily: () => {
				if (commandState?.value != null) {
					item.activate({ fontFamily: commandState.value });
					return;
				}
				const fallbackFontFamily = this.#getFontFamilyFallbackValue();
				if (fallbackFontFamily) {
					item.activate({ fontFamily: fallbackFontFamily });
					return;
				}
				item.deactivate();
			},
			fontSize: () => {
				if (commandState?.value != null) {
					item.activate({ fontSize: commandState.value });
					return;
				}
				if (this.#isFontSizeMixedState(commandState)) {
					item.activate({}, true);
					return;
				}
				item.deactivate();
			},
			color: () => {
				if (commandState?.value != null) item.activate({ color: commandState.value });
				else item.deactivate();
			},
			highlight: () => {
				if (commandState?.value != null) item.activate({ color: commandState.value });
				else item.deactivate();
			},
			linkedStyles: () => {
				if (commandState?.value != null) item.activate({ styleId: commandState.value });
				else item.label.value = this.config.texts?.formatText || "Format text";
			},
			list: () => {
				if (commandState?.active) {
					item.activate();
					item.selectedValue.value = markerTextToBulletStyle(commandState.value);
				} else {
					item.deactivate();
					item.selectedValue.value = null;
				}
			},
			numberedlist: () => {
				if (commandState?.active) {
					item.activate();
					item.selectedValue.value = commandState.value;
				} else {
					item.deactivate();
					item.selectedValue.value = null;
				}
			},
			default: () => {
				if (commandState?.active) item.activate();
				else item.deactivate();
			}
		};
		const handler = handlers[item.name.value] ?? handlers.default;
		setDisabled();
		handler();
		return true;
	}
	#executeHeadlessCommand(item, argument) {
		const isTableActions = item?.name?.value === "tableActions";
		const commandId = isTableActions ? TABLE_ACTION_COMMAND_MAP[argument?.command] : HEADLESS_ITEM_MAP[item?.name?.value];
		if (!commandId || !this.controller?.execute) return false;
		if (isTableActions) this.controller.execute(commandId);
		else this.controller.execute(commandId, argument);
		return true;
	}
	updateToolbarState() {
		this.#syncDocumentModeUi();
		this.#initDefaultFonts();
		this.#updateHighlightColors();
		const currentMode = this.snapshot?.commands?.["document-mode"]?.value || "editing";
		if (!this.activeEditor || currentMode === "viewing") {
			this.#deactivateAll();
			this.#getAllToolbarItems().forEach((item) => {
				if (item.allowWithoutEditor?.value) this.#applyHeadlessState(item);
			});
			return;
		}
		const { state } = this.activeEditor;
		if (!state) {
			this.#deactivateAll();
			return;
		}
		this.#getAllToolbarItems().forEach((item) => {
			item.resetDisabled();
			this.#applyHeadlessState(item);
		});
	}
	onToolbarResize = () => {
		this.#makeToolbarItems({
			superToolbar: this,
			icons: this.config.icons,
			texts: this.config.texts,
			fonts: this.config.fonts,
			hideButtons: this.config.hideButtons,
			isDev: this.isDev
		});
		if (this.role === "viewer") this.#deactivateAll();
		this.updateToolbarState();
	};
	#deactivateAll() {
		this.activeEditor = null;
		this.#getAllToolbarItems().forEach((item) => {
			const { allowWithoutEditor } = item;
			if (allowWithoutEditor.value) return;
			item.setDisabled(true);
		});
	}
	onEditorTransaction({ transaction }) {
		if (!transaction.docChanged && !transaction.selectionSet) return;
		this.updateToolbarState();
	}
	#scheduleRestoreEditorFocus() {
		if (!this.activeEditor || this.activeEditor.options.isHeaderOrFooter) return;
		clearTimeout(this._restoreFocusTimeoutId);
		this._restoreFocusTimeoutId = setTimeout(() => {
			this._restoreFocusTimeoutId = null;
			if (!this.activeEditor || this.activeEditor.options.isHeaderOrFooter) return;
			this.activeEditor.focus();
		}, 0);
	}
	emitCommand({ item, argument, option }) {
		const hasFocusFn = this.activeEditor?.view?.hasFocus;
		const wasFocused = Boolean(typeof hasFocusFn === "function" && hasFocusFn.call(this.activeEditor.view));
		const { command: command$1 } = item;
		const isMarkToggle = this.isMarkToggle(item);
		const shouldRestoreFocus = Boolean(item?.restoreEditorFocus);
		const hasArgument = argument !== null && argument !== void 0;
		const isDropdownOpen = item?.type === "dropdown" && !hasArgument;
		const isFontCommand = item?.command === "setFontFamily" || item?.command === "setFontSize";
		if (isDropdownOpen && isFontCommand) return;
		if (!wasFocused && isMarkToggle && !this.activeEditor?.options?.isHeaderOrFooter) {
			this.pendingMarkCommands.push({
				command: command$1,
				argument,
				item
			});
			const labelAttr = item?.labelAttr?.value;
			if (labelAttr && argument) item?.activate?.({ [labelAttr]: argument });
			else item?.activate?.();
			if (this.activeEditor && !this.activeEditor.options.isHeaderOrFooter) this.activeEditor.focus();
			return;
		}
		if (this.activeEditor && !this.activeEditor.options.isHeaderOrFooter) this.activeEditor.focus();
		if (!command$1) return;
		if (item?.name?.value === "tableActions") {
			if (this.#executeHeadlessCommand(item, argument)) {
				this.updateToolbarState();
				return;
			}
		}
		if (HEADLESS_EXECUTE_ITEMS.has(item?.name?.value)) {
			if (this.#executeHeadlessCommand(item, argument)) {
				if (isMarkToggle) this.#syncStickyMarksFromState();
				this.updateToolbarState();
				if (shouldRestoreFocus) this.#scheduleRestoreEditorFocus();
				return;
			}
		}
		if (command$1 === "insertTableOfContents" && this.activeEditor) insertTableOfContentsAtSelection(this.activeEditor);
		else if (this.activeEditor && this.activeEditor.commands && command$1 in this.activeEditor.commands) this.activeEditor.commands[command$1](argument);
		else if (typeof command$1 === "function") command$1({
			item,
			argument,
			option
		});
		else {
			const error = /* @__PURE__ */ new Error(`[super-toolbar 🎨] Command not found: ${command$1}`);
			this.emit("exception", {
				error,
				editor: this.activeEditor
			});
			throw error;
		}
		if (isMarkToggle) this.#syncStickyMarksFromState();
		this.updateToolbarState();
		if (shouldRestoreFocus) this.#scheduleRestoreEditorFocus();
	}
	flushPendingMarkCommands() {
		if (!this.activeEditor) return false;
		if (!this.pendingMarkCommands.length) return false;
		const pending = this.pendingMarkCommands;
		this.pendingMarkCommands = [];
		pending.forEach(({ command: command$1, argument, item }) => {
			if (!command$1) return;
			try {
				if (HEADLESS_EXECUTE_ITEMS.has(item?.name?.value)) {
					if (this.#executeHeadlessCommand(item, argument)) {
						this.#ensureStoredMarksForMarkToggle({
							command: command$1,
							argument
						});
						return;
					}
				}
				if (this.activeEditor.commands && command$1 in this.activeEditor.commands) this.activeEditor.commands[command$1](argument);
				this.#ensureStoredMarksForMarkToggle({
					command: command$1,
					argument
				});
			} catch (error) {
				const err = /* @__PURE__ */ new Error(`[super-toolbar 🎨] Failed to execute pending command: ${command$1}`);
				this.emit("exception", {
					error: err,
					editor: this.activeEditor,
					originalError: error
				});
				console.error(err, error);
			}
		});
		this.#syncStickyMarksFromState();
		this.updateToolbarState();
		return true;
	}
	onEditorSelectionUpdate() {
		if (!this.activeEditor) return;
		if (this.flushPendingMarkCommands()) return;
		if (this.#restoreStickyMarksIfNeeded()) this.updateToolbarState();
	}
	onEditorFontsChanged() {
		const signature = this.#fontOptionsSignature();
		if (signature !== this._lastFontOptionsSignature) {
			this._lastFontOptionsSignature = signature;
			this.#rebuildToolbarItems();
		}
		this.updateToolbarState();
	}
	onEditorFocus() {
		if (this.pendingMarkCommands.length) {
			this.onEditorSelectionUpdate();
			return;
		}
		if (this.#restoreStickyMarksIfNeeded()) this.updateToolbarState();
	}
	isMarkToggle(item) {
		const name = item?.name?.value;
		return SuperToolbar.#MARK_TOGGLE_NAMES.has(name);
	}
	#syncStickyMarksFromState() {
		if (!this.activeEditor) return;
		const { selection, storedMarks } = this.activeEditor.state || {};
		if (!selection?.empty) return;
		this.stickyStoredMarks = storedMarks?.length ? [...storedMarks] : null;
	}
	#restoreStickyMarksIfNeeded() {
		if (!this.activeEditor) return false;
		if (!this.stickyStoredMarks?.length) return false;
		const { state, view } = this.activeEditor;
		const { selection, storedMarks } = state || {};
		if (!selection?.empty) return false;
		if (storedMarks?.length) return false;
		if (!view?.dispatch || !state?.tr) return false;
		if (getActiveFormatting(this.activeEditor).some((mark) => SuperToolbar.#MARK_TOGGLE_NAMES.has(mark.name))) return false;
		const tr = state.tr.setStoredMarks(this.stickyStoredMarks);
		view.dispatch(tr);
		return true;
	}
	#ensureStoredMarksForMarkToggle({ command: command$1, argument }) {
		if (!this.activeEditor) return;
		if (!this.activeEditor.state?.selection?.empty) return;
		if (this.activeEditor.state?.storedMarks?.length) return;
		if (command$1 !== "setFontSize") return;
		const { state, view } = this.activeEditor;
		const textStyleMark = state.schema?.marks?.textStyle;
		if (!textStyleMark || !view?.dispatch || !state?.tr) return;
		const [value, unit] = parseSizeUnit(argument ?? "");
		if (Number.isNaN(value)) return;
		const clamped = Math.min(96, Math.max(8, Number(value)));
		const resolvedUnit = unit || "pt";
		const mark = textStyleMark.create({ fontSize: `${clamped}${resolvedUnit}` });
		const tr = state.tr.setStoredMarks([mark]);
		view.dispatch(tr);
	}
	destroy() {
		if (this._restoreFocusTimeoutId !== null) {
			clearTimeout(this._restoreFocusTimeoutId);
			this._restoreFocusTimeoutId = null;
		}
		this.#detachActiveEditorListeners();
		this.destroyHeadlessToolbar();
		this.app?.unmount();
	}
};
var Schema = class Schema {
	static createSchemaByExtensions(extensions, editor) {
		const nodeExtensions = extensions.filter((e) => e.type === "node");
		const markExtensions = extensions.filter((e) => e.type === "mark");
		const topNode = nodeExtensions.find((e) => getExtensionConfigField(e, "topNode"))?.name;
		const attributes = Attribute.getAttributesFromExtensions(extensions);
		return new Schema$1({
			topNode,
			nodes: Schema.#createNodesSchema(nodeExtensions, attributes, editor),
			marks: Schema.#createMarksSchema(markExtensions, attributes, editor)
		});
	}
	static #createNodesSchema(nodeExtensions, attributes, editor) {
		const nodeEntries = nodeExtensions.map((extension) => {
			const extensionAttributes = attributes.filter((a) => a.type === extension.name);
			const context = {
				name: extension.name,
				options: extension.options,
				storage: extension.storage,
				editor
			};
			const attrs = Object.fromEntries(extensionAttributes.map((attr) => {
				return [attr.name, { default: attr?.attribute?.default }];
			}));
			const additionalNodeFields = nodeExtensions.reduce((fields, e) => {
				const extendNodeSchema = getExtensionConfigField(e, "extendNodeSchema", context);
				return {
					...fields,
					...extendNodeSchema ? extendNodeSchema(extension) : {}
				};
			}, {});
			const schema = cleanSchemaItem({
				content: callOrGet(getExtensionConfigField(extension, "content", context)),
				group: callOrGet(getExtensionConfigField(extension, "group", context)),
				marks: callOrGet(getExtensionConfigField(extension, "marks", context)),
				inline: callOrGet(getExtensionConfigField(extension, "inline", context)),
				atom: callOrGet(getExtensionConfigField(extension, "atom", context)),
				selectable: callOrGet(getExtensionConfigField(extension, "selectable", context)),
				draggable: callOrGet(getExtensionConfigField(extension, "draggable", context)),
				code: callOrGet(getExtensionConfigField(extension, "code", context)),
				defining: callOrGet(getExtensionConfigField(extension, "defining", context)),
				isolating: callOrGet(getExtensionConfigField(extension, "isolating", context)),
				leafText: getExtensionConfigField(extension, "leafText", context),
				summary: getExtensionConfigField(extension, "summary", context),
				attrs,
				...additionalNodeFields
			});
			if (typeof extension.validChildren === "function" || Array.isArray(extension.validChildren)) Object.defineProperty(schema, "validChildren", {
				enumerable: false,
				configurable: false,
				get: () => extension.validChildren
			});
			const parseDOM = callOrGet(getExtensionConfigField(extension, "parseDOM", context));
			if (parseDOM) schema.parseDOM = parseDOM.map((parseRule) => {
				return Attribute.insertExtensionAttrsToParseRule(parseRule, extensionAttributes);
			});
			const renderDOM = getExtensionConfigField(extension, "renderDOM", context);
			if (renderDOM) schema.toDOM = (node) => renderDOM({
				node,
				htmlAttributes: Attribute.getAttributesToRender(node, extensionAttributes)
			});
			const renderText = getExtensionConfigField(extension, "renderText", context);
			if (renderText) schema.toText = renderText;
			return [extension.name, schema];
		});
		return Object.fromEntries(nodeEntries);
	}
	static #createMarksSchema(markExtensions, attributes, editor) {
		const markEntries = markExtensions.map((extension) => {
			const extensionAttributes = attributes.filter((a) => a.type === extension.name);
			const context = {
				name: extension.name,
				options: extension.options,
				storage: extension.storage,
				editor
			};
			const attrs = Object.fromEntries(extensionAttributes.map((attr) => {
				return [attr.name, { default: attr?.attribute?.default }];
			}));
			const schema = cleanSchemaItem({
				group: callOrGet(getExtensionConfigField(extension, "group", context)),
				inclusive: callOrGet(getExtensionConfigField(extension, "inclusive", context)),
				excludes: callOrGet(getExtensionConfigField(extension, "excludes", context)),
				spanning: callOrGet(getExtensionConfigField(extension, "spanning", context)),
				code: callOrGet(getExtensionConfigField(extension, "code", context)),
				attrs
			});
			const parseDOM = callOrGet(getExtensionConfigField(extension, "parseDOM", context));
			if (parseDOM) schema.parseDOM = parseDOM.map((parseRule) => {
				return Attribute.insertExtensionAttrsToParseRule(parseRule, extensionAttributes);
			});
			const renderDOM = getExtensionConfigField(extension, "renderDOM", context);
			if (renderDOM) schema.toDOM = (mark) => renderDOM({
				mark,
				htmlAttributes: Attribute.getAttributesToRender(mark, extensionAttributes)
			});
			return [extension.name, schema];
		});
		return Object.fromEntries(markEntries);
	}
};
const Commands = Extension.create({
	name: "commands",
	addCommands() {
		return { ...commands_exports };
	}
});
var dispatchHistoryBoundary = (view) => {
	const tr = view?.state?.tr;
	if (!tr) return;
	view.dispatch?.(closeHistory(tr));
};
const handleEnter = (editor) => {
	const { view } = editor;
	dispatchHistoryBoundary(view);
	return editor.commands.first(({ commands: commands$1 }) => [
		() => commands$1.splitRunToParagraph?.() ?? false,
		() => commands$1.newlineInCode(),
		() => commands$1.createParagraphNear(),
		() => commands$1.liftEmptyBlock(),
		() => commands$1.splitBlock()
	]);
};
const handleBackspace = (editor) => {
	const { view } = editor;
	dispatchHistoryBoundary(view);
	return editor.commands.first(({ commands: commands$1, tr }) => [
		() => commands$1.undoInputRule(),
		() => {
			tr.setMeta("inputType", "deleteContentBackward");
			return false;
		},
		() => commands$1.deleteBlockSdtAtTextBlockStart(),
		() => commands$1.selectInlineSdtBeforeRunStart(),
		() => commands$1.selectBlockSdtBeforeTextBlockStart(),
		() => commands$1.moveIntoBlockSdtBeforeTextBlockStart(),
		() => commands$1.backspaceEmptyRunParagraph(),
		() => commands$1.backspaceSkipEmptyRun(),
		() => commands$1.backspaceAtomBefore(),
		() => commands$1.backspaceNextToRun(),
		() => commands$1.backspaceAcrossRuns(),
		() => commands$1.mixedBidiBackspace?.() ?? false,
		() => commands$1.deleteSelection(),
		() => commands$1.removeNumberingProperties(),
		() => commands$1.joinBackward(),
		() => commands$1.selectNodeBackward()
	]);
};
const handleDelete = (editor) => {
	const { view } = editor;
	dispatchHistoryBoundary(view);
	return editor.commands.first(({ commands: commands$1 }) => [
		() => commands$1.deleteBlockSdtAtTextBlockStart(),
		() => commands$1.selectInlineSdtAfterRunEnd(),
		() => commands$1.selectBlockSdtAfterTextBlockEnd(),
		() => commands$1.moveIntoBlockSdtAfterTextBlockEnd(),
		() => commands$1.deleteSkipEmptyRun(),
		() => commands$1.deleteAtomAfter(),
		() => commands$1.deleteNextToRun(),
		() => commands$1.deleteSelection(),
		() => commands$1.joinForward(),
		() => commands$1.selectNodeForward()
	]);
};
const Keymap = Extension.create({
	name: "keymap",
	addShortcuts() {
		const baseKeymap$1 = {
			Enter: () => handleEnter(this.editor),
			"Shift-Enter": () => this.editor.commands.insertLineBreak(),
			"Mod-Enter": () => this.editor.commands.insertPageBreak(),
			Backspace: () => handleBackspace(this.editor),
			"Mod-Backspace": () => handleBackspace(this.editor),
			"Shift-Backspace": () => handleBackspace(this.editor),
			Delete: () => handleDelete(this.editor),
			"Mod-Delete": () => handleDelete(this.editor),
			"Mod-a": () => this.editor.commands.selectAll(),
			Tab: () => this.editor.commands.insertTabNode(),
			ArrowLeft: () => this.editor.commands.skipTab(-1),
			ArrowRight: () => this.editor.commands.skipTab(1)
		};
		const pcBaseKeymap$1 = { ...baseKeymap$1 };
		const macBaseKeymap$1 = {
			...baseKeymap$1,
			"Ctrl-h": () => handleBackspace(this.editor),
			"Alt-Backspace": () => handleBackspace(this.editor),
			"Ctrl-d": () => handleDelete(this.editor),
			"Ctrl-Alt-Backspace": () => handleDelete(this.editor),
			"Alt-Delete": () => handleDelete(this.editor),
			"Alt-d": () => handleDelete(this.editor),
			"Ctrl-a": () => this.editor.commands.selectAll(),
			"Ctrl-e": () => this.editor.commands.selectTextblockEnd(),
			"Ctrl-t": () => this.editor.commands.insertTabChar()
		};
		if (isMacOS() || isIOS()) return macBaseKeymap$1;
		return pcBaseKeymap$1;
	}
});
var appendStoryInputDebugLog = (entry) => {
	const debugGlobal = globalThis;
	if (debugGlobal.__SD_DEBUG_STORY_INPUT__ !== true) return;
	const existingLog = Array.isArray(debugGlobal.__SD_DEBUG_STORY_INPUT_LOG__) ? debugGlobal.__SD_DEBUG_STORY_INPUT_LOG__ : [];
	existingLog.push(entry);
	if (existingLog.length > 200) existingLog.splice(0, existingLog.length - 200);
	debugGlobal.__SD_DEBUG_STORY_INPUT_LOG__ = existingLog;
};
var isStorySurfaceEditor = (editor) => {
	const documentId = editor?.options?.documentId ?? "";
	return documentId.startsWith("hf:") || documentId.startsWith("fn:") || documentId.startsWith("en:") || editor?.options?.isHeaderOrFooter === true || editor?.options?.headerFooterType === "header" || editor?.options?.headerFooterType === "footer";
};
var recordStoryInputDebug = (view, event, editor, phase, extra = {}) => {
	if (!isStorySurfaceEditor(editor)) return;
	let domAnchorPos = null;
	const domSelection = view?.dom?.ownerDocument?.getSelection?.() ?? null;
	try {
		if (view?.dom && domSelection?.anchorNode && view.dom.contains(domSelection.anchorNode)) domAnchorPos = view.posAtDOM(domSelection.anchorNode, domSelection.anchorOffset, -1);
	} catch {
		domAnchorPos = null;
	}
	appendStoryInputDebugLog({
		phase,
		documentId: editor?.options?.documentId ?? null,
		inputType: event?.inputType ?? null,
		data: event?.data ?? null,
		cancelable: event?.cancelable ?? null,
		defaultPrevented: event?.defaultPrevented ?? null,
		selectionFrom: view?.state?.selection?.from ?? null,
		selectionTo: view?.state?.selection?.to ?? null,
		domAnchorPos,
		...extra
	});
};
var isInlineStructuredContentNode = (node) => node?.type?.name === "structuredContent" && node.isInline;
var isInlineStructuredContentBoundary = (doc$1, pos) => {
	if (typeof pos !== "number" || pos < 0 || pos > doc$1.content.size) return false;
	const $pos = doc$1.resolve(pos);
	const before = $pos.parent.childBefore($pos.parentOffset).node;
	const after = $pos.parent.childAfter($pos.parentOffset).node;
	return isInlineStructuredContentNode(before) || isInlineStructuredContentNode(after);
};
var getInputSelection = (state) => {
	const { selection } = state;
	if (!selection.empty) return selection;
	const preserved = getPreservedSelection(state);
	if (preserved && !preserved.empty) return preserved;
	return selection;
};
var handleInsertTextBeforeInput = (view, event, editor) => {
	const isInsertTextInput = event?.inputType === "insertText";
	const hasTextData = typeof event?.data === "string" && event.data.length > 0;
	const isComposing = event?.isComposing === true;
	recordStoryInputDebug(view, event, editor, "beforeinput:start", {
		isInsertTextInput,
		hasTextData,
		isComposing
	});
	if (!isInsertTextInput || !hasTextData || isComposing) {
		recordStoryInputDebug(view, event, editor, "beforeinput:skip");
		return false;
	}
	const selection = getInputSelection(view.state);
	const shouldHandleCollapsedSelection = isStorySurfaceEditor(editor) || isInlineStructuredContentBoundary(view.state.doc, view.state.selection.from);
	if (selection.empty && !shouldHandleCollapsedSelection) {
		recordStoryInputDebug(view, event, editor, "beforeinput:skip-empty-selection");
		return false;
	}
	const tr = view.state.tr.insertText(event.data, selection.from, selection.to);
	const insertedTo = Math.max(0, Math.min(selection.from + event.data.length, tr.doc.content.size));
	try {
		tr.setSelection(TextSelection.create(tr.doc, insertedTo));
	} catch {
		tr.setSelection(Selection.near(tr.doc.resolve(insertedTo), 1));
	}
	if (!selection.empty) tr.setMeta(CustomSelectionPluginKey, {
		focused: false,
		preservedSelection: null,
		showVisualSelection: false,
		skipFocusReset: false
	});
	tr.setMeta("inputType", "insertText");
	view.dispatch(tr);
	event.preventDefault();
	recordStoryInputDebug(view, event, editor, "beforeinput:handled");
	return true;
};
var shouldForceEndStaleComposition = (view, event) => {
	if (!view.composing || event?.isComposing) return false;
	const inputType = event?.inputType ?? null;
	if (!inputType) return false;
	return !["insertCompositionText", "deleteCompositionText"].includes(inputType);
};
var NAVIGATION_KEYS = new Set([
	"ArrowLeft",
	"ArrowRight",
	"ArrowUp",
	"ArrowDown",
	"Home",
	"End",
	"PageUp",
	"PageDown"
]);
const Editable = Extension.create({
	name: "editable",
	addPmPlugins() {
		const editor = this.editor;
		const isFullyBlocked = () => !editor.options.editable && !editor.options.allowSelectionInViewMode;
		const blockWhenNotEditable = (_view, event) => {
			if (!editor.options.editable) {
				event.preventDefault();
				return true;
			}
			return false;
		};
		return [new Plugin({
			key: new PluginKey("editable"),
			props: {
				editable: () => editor.options.editable,
				handleDOMEvents: {
					beforeinput: (view, event) => {
						recordStoryInputDebug(view, event, editor, "dom:beforeinput");
						if (!editor.options.editable) {
							event.preventDefault();
							return true;
						}
						if (shouldForceEndStaleComposition(view, event)) __endComposition(view);
						if (handleInsertTextBeforeInput(view, event, editor)) return true;
						return false;
					},
					input: (view, event) => {
						recordStoryInputDebug(view, event, editor, "dom:input");
						return false;
					},
					compositionstart: (view, event) => blockWhenNotEditable(view, event),
					compositionupdate: (view, event) => blockWhenNotEditable(view, event),
					compositionend: (view, event) => blockWhenNotEditable(view, event),
					mousedown: (_view, event) => {
						if (isFullyBlocked()) {
							event.preventDefault();
							return true;
						}
						return false;
					},
					focus: (view, event) => {
						if (isFullyBlocked()) {
							event.preventDefault();
							view.dom.blur();
							return true;
						}
						return false;
					}
				},
				handleClick: () => isFullyBlocked(),
				handleDoubleClick: () => isFullyBlocked(),
				handleTripleClick: () => isFullyBlocked(),
				handleKeyDown: (_view, event) => {
					if (!editor.options.editable) {
						if (editor.options.allowSelectionInViewMode) {
							if (NAVIGATION_KEYS.has(event.key)) return false;
							if ((event.ctrlKey || event.metaKey) && ["c", "a"].includes(event.key.toLowerCase())) return false;
						}
						return true;
					}
					return false;
				},
				handlePaste: () => !editor.options.editable,
				handleDrop: () => !editor.options.editable
			}
		})];
	}
});
const EditorFocus = Extension.create({
	name: "editorFocus",
	addPmPlugins() {
		const editor = this.editor;
		return [new Plugin({
			key: new PluginKey("editorFocus"),
			props: { handleDOMEvents: {
				focus: (view, event) => {
					editor.isFocused = true;
					const tr = editor.state.tr.setMeta("focus", { event }).setMeta("addToHistory", false);
					view.dispatch(tr);
					return false;
				},
				blur: (view, event) => {
					editor.isFocused = false;
					const tr = editor.state.tr.setMeta("blur", { event }).setMeta("addToHistory", false);
					view.dispatch(tr);
					return false;
				}
			} }
		})];
	}
});
const PositionTrackerExtension = Extension.create({
	name: "positionTracker",
	addStorage() {
		return { tracker: null };
	},
	addPmPlugins() {
		return [createPositionTrackerPlugin()];
	},
	onCreate() {
		const existing = this.editor?.positionTracker ?? this.storage.tracker;
		if (existing) {
			this.storage.tracker = existing;
			this.editor.positionTracker = existing;
			return;
		}
		const tracker = new PositionTracker(this.editor);
		this.storage.tracker = tracker;
		this.editor.positionTracker = tracker;
	},
	onDestroy() {
		if (this.editor?.positionTracker === this.storage.tracker) this.editor.positionTracker = null;
		this.storage.tracker = null;
	}
});
const SelectionHandleExtension = Extension.create({
	name: "selectionHandle",
	addPmPlugins() {
		return [createSelectionHandlePlugin()];
	}
});
var global = globalThis || self;
var EventEmitter = class {
	#events = /* @__PURE__ */ new Map();
	on(name, fn) {
		const callbacks = this.#events.get(name);
		if (callbacks) callbacks.push(fn);
		else this.#events.set(name, [fn]);
	}
	emit(name, ...args$1) {
		const callbacks = this.#events.get(name);
		if (!callbacks) return;
		for (const fn of callbacks) fn.apply(this, args$1);
	}
	safeEmit(name, ...args$1) {
		const callbacks = this.#events.get(name);
		if (!callbacks) return [];
		const errors = [];
		for (const fn of callbacks) try {
			fn.apply(this, args$1);
		} catch (err) {
			errors.push(err instanceof Error ? err : new Error(String(err)));
		}
		return errors;
	}
	off(name, fn) {
		const callbacks = this.#events.get(name);
		if (!callbacks) return;
		if (fn) this.#events.set(name, callbacks.filter((cb) => cb !== fn));
		else this.#events.delete(name);
	}
	once(name, fn) {
		const wrapper = (...args$1) => {
			this.off(name, wrapper);
			fn.apply(this, args$1);
		};
		this.on(name, wrapper);
	}
	removeAllListeners() {
		this.#events = /* @__PURE__ */ new Map();
	}
};
function isExtensionRulesEnabled(extension, enabled) {
	if (Array.isArray(enabled)) return enabled.some((enabledExtension) => {
		return (typeof enabledExtension === "string" ? enabledExtension : enabledExtension.name) === extension.name;
	});
	return enabled;
}
var ExtensionService = class ExtensionService {
	editor;
	schema;
	extensions;
	externalExtensions = [];
	splittableMarks = [];
	constructor(extensions, userExtensions, editor) {
		this.editor = editor;
		this.externalExtensions = userExtensions || [];
		this.externalExtensions = this.externalExtensions.map((extension) => {
			return {
				...extension,
				isExternal: true
			};
		});
		this.extensions = ExtensionService.getResolvedExtensions([...extensions, ...this.externalExtensions]);
		this.schema = Schema.createSchemaByExtensions(this.extensions, editor);
		this.#setupExtensions();
	}
	static create(...args$1) {
		return new ExtensionService(...args$1);
	}
	static getResolvedExtensions(extensions) {
		return ExtensionService.sortByPriority(extensions);
	}
	static sortByPriority(extensions) {
		const defaultValue = 100;
		return extensions.sort((a, b$1) => {
			const priorityA = getExtensionConfigField(a, "priority") || defaultValue;
			const priorityB = getExtensionConfigField(b$1, "priority") || defaultValue;
			if (priorityA > priorityB) return -1;
			if (priorityA < priorityB) return 1;
			return 0;
		});
	}
	get attributes() {
		return Attribute.getAttributesFromExtensions(this.extensions);
	}
	get commands() {
		let commandsObject = {};
		for (const extension of this.extensions) {
			const addCommands = getExtensionConfigField(extension, "addCommands", {
				name: extension.name,
				options: extension.options,
				storage: extension.storage,
				editor: this.editor,
				type: getSchemaTypeByName(extension.name, this.schema)
			});
			if (addCommands) commandsObject = {
				...commandsObject,
				...addCommands()
			};
		}
		return commandsObject;
	}
	get helpers() {
		const helpersObject = {};
		for (const extension of this.extensions) {
			const name = extension.name;
			if (!name) continue;
			const addHelpers = getExtensionConfigField(extension, "addHelpers", {
				name: extension.name,
				options: extension.options,
				storage: extension.storage,
				editor: this.editor,
				type: getSchemaTypeByName(extension.name, this.schema)
			});
			if (addHelpers) helpersObject[name] = addHelpers();
		}
		return helpersObject;
	}
	get plugins() {
		const editor = this.editor;
		const extensions = ExtensionService.sortByPriority([...this.extensions].reverse());
		const inputRules = [];
		const allPlugins = extensions.map((extension) => {
			const context = {
				name: extension.name,
				options: extension.options,
				storage: extension.storage,
				editor,
				type: getSchemaTypeByName(extension.name, this.schema)
			};
			const plugins = [];
			const addShortcuts = getExtensionConfigField(extension, "addShortcuts", context);
			let bindingsObject = {};
			if (addShortcuts) {
				const entries = Object.entries(addShortcuts()).map(([shortcut, method]) => {
					return [shortcut, (...args$1) => method({
						editor,
						keymapArgs: args$1
					})];
				});
				bindingsObject = { ...Object.fromEntries(entries) };
			}
			plugins.push(keymap(bindingsObject));
			const addInputRules = getExtensionConfigField(extension, "addInputRules", context);
			if (isExtensionRulesEnabled(extension, editor.options.enableInputRules) && addInputRules) inputRules.push(...addInputRules());
			const addPmPlugins = getExtensionConfigField(extension, "addPmPlugins", context);
			if (addPmPlugins) plugins.push(...addPmPlugins());
			return plugins;
		}).flat();
		return [inputRulesPlugin({
			editor,
			rules: inputRules
		}), ...allPlugins];
	}
	get nodeViews() {
		const { editor } = this;
		const entries = this.extensions.filter((e) => e.type === "node").filter((extension) => !!getExtensionConfigField(extension, "addNodeView")).map((extension) => {
			const extensionAttrs = this.attributes.filter((a) => a.type === extension.name);
			const addNodeView = getExtensionConfigField(extension, "addNodeView", {
				name: extension.name,
				options: extension.options,
				storage: extension.storage,
				editor,
				type: getNodeType(extension.name, this.schema)
			});
			if (!addNodeView) return null;
			const nodeViewFunction = addNodeView();
			if (!nodeViewFunction) return null;
			const nodeview = (node, _view, getPos, decorations) => {
				return nodeViewFunction({
					editor,
					node,
					getPos,
					decorations,
					htmlAttributes: Attribute.getAttributesToRender(node, extensionAttrs),
					extension,
					extensionAttrs
				});
			};
			return [extension.name, nodeview];
		}).filter(Boolean);
		return Object.fromEntries(entries);
	}
	#setupExtensions() {
		for (const extension of this.extensions) {
			this.editor.extensionStorage[extension.name] = extension.storage;
			const context = {
				name: extension.name,
				options: extension.options,
				storage: extension.storage,
				editor: this.editor,
				type: getSchemaTypeByName(extension.name, this.schema)
			};
			if (extension.type === "mark") {
				if (callOrGet(getExtensionConfigField(extension, "keepOnSplit", context)) ?? true) this.splittableMarks.push(extension.name);
			}
			this.#attachEditorEvents(extension);
		}
	}
	#attachEditorEvents(extension) {
		const context = {
			name: extension.name,
			options: extension.options,
			storage: extension.storage,
			editor: this.editor,
			type: getSchemaTypeByName(extension.name, this.schema)
		};
		const onBeforeCreate = getExtensionConfigField(extension, "onBeforeCreate", context);
		const onCreate = getExtensionConfigField(extension, "onCreate", context);
		const onUpdate = getExtensionConfigField(extension, "onUpdate", context);
		const onSelectionUpdate = getExtensionConfigField(extension, "onSelectionUpdate", context);
		const onTransaction = getExtensionConfigField(extension, "onTransaction", context);
		const onFocus = getExtensionConfigField(extension, "onFocus", context);
		const onBlur = getExtensionConfigField(extension, "onBlur", context);
		const onDestroy = getExtensionConfigField(extension, "onDestroy", context);
		if (onBeforeCreate) this.editor.on("beforeCreate", onBeforeCreate);
		if (onCreate) this.editor.on("create", onCreate);
		if (onUpdate) this.editor.on("update", onUpdate);
		if (onSelectionUpdate) this.editor.on("selectionUpdate", onSelectionUpdate);
		if (onTransaction) this.editor.on("transaction", onTransaction);
		if (onFocus) this.editor.on("focus", onFocus);
		if (onBlur) this.editor.on("blur", onBlur);
		if (onDestroy) this.editor.on("destroy", onDestroy);
	}
};
const migration_after_0_4_14 = (editor) => {
	const { state } = editor;
	const dispatch = typeof editor.view?.dispatch === "function" ? editor.view.dispatch.bind(editor.view) : editor.dispatch.bind(editor);
	const { tr } = state;
	if (!dispatch) return;
	state.doc.descendants((node, pos) => {
		if (node.type.name === "paragraph") {
			const { attrs } = node;
			const { spacing } = attrs;
			if (!spacing) return;
			const newSpacing = {
				line: twipsToLines(pixelsToTwips(spacing.line)),
				lineSpaceBefore: twipsToLines(pixelsToTwips(spacing.lineSpaceBefore)),
				lineSpaceAfter: twipsToLines(pixelsToTwips(spacing.lineSpaceAfter))
			};
			tr.setNodeMarkup(pos, void 0, {
				...attrs,
				spacing: {
					...spacing,
					...newSpacing
				}
			});
		}
	});
	dispatch(tr);
	return true;
};
var DOCUMENT_MIGRATIONS = { initial: migration_after_0_4_14 };
const getNecessaryMigrations = (version$1) => {
	if (version$1 === "initial" || version$1 === "0.4.14") return Object.values(DOCUMENT_MIGRATIONS);
};
const setImageNodeSelection = (view, pos) => {
	const { doc: doc$1 } = view.state;
	const node = doc$1.nodeAt(pos);
	if (node && node.type.name === "image") {
		const tr = view.state.tr.setSelection(NodeSelection.create(doc$1, pos));
		view.dispatch(tr);
		return true;
	}
	return false;
};
function canRenderFont(fontName, uiDisplayFallbackFont = "sans-serif") {
	const _canRenderFont = (fontName$1, uiDisplayFallbackFont$1) => {
		const ctx$1 = document.createElement("canvas").getContext("2d");
		ctx$1.textBaseline = "top";
		const text = "abcdefghijklmnopqrstuvwxyz0123456789";
		ctx$1.font = `72px ${uiDisplayFallbackFont$1}`;
		const initialTextMeasurement = ctx$1.measureText(text);
		const fallbackWidth = initialTextMeasurement.width;
		const fallbackHeight = initialTextMeasurement.actualBoundingBoxDescent;
		ctx$1.font = `72px "${fontName$1}", ${uiDisplayFallbackFont$1}`;
		const customTextMeasurement = ctx$1.measureText(text);
		const customFontWidth = customTextMeasurement.width;
		const customFontHeight = customTextMeasurement.actualBoundingBoxDescent;
		return customFontWidth !== fallbackWidth || customFontHeight !== fallbackHeight;
	};
	if (_canRenderFont(fontName, uiDisplayFallbackFont)) return true;
	return _canRenderFont(fontName, uiDisplayFallbackFont === "sans-serif" ? "serif" : "sans-serif");
}
var log$1 = (...args$1) => {};
const migrateListsToV2IfNecessary = (editor) => {
	const replacements = [];
	log$1("ATTEMPTING MIGRATIONS");
	if (!editor.converter.numbering) return replacements;
	const { state } = editor;
	const { doc: doc$1 } = state;
	const dispatch = typeof editor.view?.dispatch === "function" ? editor.view.dispatch.bind(editor.view) : editor.dispatch.bind(editor);
	const LIST_TYPES = ["orderedList", "bulletList"];
	let lastListEndPos = 0;
	doc$1.descendants((node, pos) => {
		if (!LIST_TYPES.includes(node.type.name)) return;
		if (pos < lastListEndPos) return;
		const extracted = flattenListCompletely(node, editor, 0);
		if (extracted.length > 0) replacements.push({
			from: pos,
			to: pos + node.nodeSize,
			listNode: node,
			replacement: extracted
		});
		lastListEndPos = pos + node.nodeSize;
	});
	let tr = state.tr;
	if (replacements.length > 0) for (let i = replacements.length - 1; i >= 0; i--) {
		const { from: from$1, to, replacement, listNode } = replacements[i];
		const nodesToInsert = [];
		for (const item of replacement) if (item.node.type.name === "listItem") {
			const singleItemList = listNode.type.create(listNode.attrs, [item.node]);
			nodesToInsert.push(singleItemList);
		} else nodesToInsert.push(item.node);
		log$1("NODES TO INSERT", nodesToInsert);
		tr = tr.replaceWith(from$1, to, nodesToInsert);
	}
	tr.setMeta("listsv2migration", replacements);
	editor.options.migrated = true;
	dispatch(tr);
	return replacements;
};
function flattenListCompletely(listNode, editor, baseLevel = 0, sharedNumId = null) {
	const result = [];
	const listTypes = ["orderedList", "bulletList"];
	const currentListType = listNode.type.name;
	const needsMigration = shouldMigrateList(listNode);
	const hasValidDefinition = checkValidDefinition(listNode, editor);
	log$1("Needs migration?", needsMigration);
	if (!needsMigration) if (!hasValidDefinition) return generateMissingListDefinition(listNode, editor);
	else return result;
	let numId = parseInt(listNode.attrs?.listId);
	log$1("LIST ID", numId, "SHARED NUM ID", sharedNumId);
	if (!numId || Number.isNaN(numId)) numId = ListHelpers.getNewListId(editor);
	if (!ListHelpers.getListDefinitionDetails({
		numId,
		level: baseLevel,
		editor
	}) || !sharedNumId && !numId) {
		numId = ListHelpers.getNewListId(editor);
		log$1("Genearted new list ID", numId, "for list type", currentListType);
		ListHelpers.generateNewListDefinition({
			numId,
			listType: currentListType,
			editor
		});
	}
	if (!sharedNumId) sharedNumId = numId;
	for (const listItem of listNode.content.content) if (!listItem.content.content?.length) result.push({
		node: listItem,
		baseLevel
	});
	else if (listItem.content.content.length === 1) {
		const contentNode = listItem.content.content[0];
		if (listTypes.includes(contentNode.type.name)) {
			const flattened = flattenListCompletely(contentNode, editor, baseLevel + 1, sharedNumId);
			result.push(...flattened);
		} else {
			const newList = ListHelpers.createSchemaOrderedListNode({
				level: baseLevel,
				numId: sharedNumId,
				listType: listNode.type.name,
				editor,
				contentNode: contentNode.toJSON(),
				listLevel: listItem.attrs.listLevel || [1]
			});
			result.push({
				node: newList,
				baseLevel
			});
		}
	} else {
		const firstItem = listItem.content.content[0];
		if (listTypes.includes(firstItem.type.name)) {
			const flattened = flattenListCompletely(firstItem, editor, baseLevel + 1, sharedNumId);
			result.push(...flattened);
		} else if (firstItem.type.name === "paragraph" || firstItem.isTextblock) {
			const newList = ListHelpers.createSchemaOrderedListNode({
				level: baseLevel,
				numId: sharedNumId,
				listType: listNode.type.name,
				editor,
				contentNode: firstItem.toJSON(),
				listLevel: listItem.attrs.listLevel || [1]
			});
			result.push({
				node: newList,
				baseLevel
			});
		} else result.push({ node: firstItem });
		for (let contentItem of listItem.content.content.slice(1)) if (listTypes.includes(contentItem.type.name)) {
			const flattened = flattenListCompletely(contentItem, editor, baseLevel + 1, sharedNumId);
			result.push(...flattened);
		} else result.push({ node: contentItem });
	}
	return result;
}
var shouldMigrateList = (listItem) => {
	const content = listItem.content;
	if (content?.content?.length > 1) return true;
	const firstChild = content.firstChild;
	if (firstChild && firstChild.type.name === "listItem") {
		const { attrs } = firstChild;
		const { level, listNumberingType } = attrs || {};
		if (typeof level === "undefined" || !listNumberingType) return true;
		return (firstChild?.content?.content).filter((child) => ["bulletList", "orderedList"].includes(child.type.name)).length > 0;
	}
	return false;
};
var checkValidDefinition = (listNode, editor) => {
	const listType = listNode.type.name;
	const { attrs } = listNode.content.firstChild;
	const { numId, level } = attrs || {};
	const { abstract } = ListHelpers.getListDefinitionDetails({
		numId,
		level,
		listType,
		editor
	}) || {};
	if (abstract) return true;
	return false;
};
var generateMissingListDefinition = (listNode, editor) => {
	const listType = listNode.type.name;
	const { attrs } = listNode.content.firstChild;
	const { numId } = attrs || {};
	return ListHelpers.generateNewListDefinition({
		numId,
		listType,
		editor
	});
};
const migrateParagraphFieldsListsV2 = async (annotationValues = [], editor) => {
	const annotations = getAllFieldAnnotations(editor.state);
	const newValues = [];
	if (!annotations.length) return annotationValues;
	for (const annotation of annotations) {
		const type = annotation.node?.attrs?.type;
		const matchedAnnotation = annotationValues.find((v) => v.input_id === annotation.node.attrs.fieldId);
		if (!!matchedAnnotation && (!type || type !== "html")) {
			newValues.push(matchedAnnotation);
			continue;
		}
		const value = matchedAnnotation?.input_value;
		if (!value) continue;
		await new Promise((resolve, reject) => {
			const element = document.createElement("div");
			editor.createChildEditor({
				element,
				html: value,
				onCreate: ({ editor: localEditor }) => {
					const { migrated } = localEditor.options;
					if (migrated) {
						matchedAnnotation.input_value = localEditor.getHTML();
						newValues.push(matchedAnnotation);
					}
					resolve();
				},
				onError: (error) => {
					reject(error);
				}
			});
		});
	}
	return newValues;
};
const createLinkedChildEditor = (currentEditor, options = {}) => {
	if (currentEditor.options.isChildEditor) return null;
	return new Editor({
		...currentEditor.options,
		pagination: false,
		suppressDefaultDocxStyles: true,
		ydoc: null,
		collaborationProvider: null,
		fileSource: null,
		initialState: null,
		documentId: null,
		isCommentsEnabled: false,
		isNewFile: false,
		fragment: false,
		onCreate: () => null,
		onListDefinitionsChange: linkListDefinitionsChange,
		...options,
		isChildEditor: true,
		parentEditor: currentEditor
	});
};
var linkListDefinitionsChange = (options) => {
	const { editor, numbering } = options;
	const { parentEditor = {} } = editor.options;
	const { converter: parentConverter } = parentEditor;
	if (!parentConverter) return;
	parentConverter.numbering = numbering;
	const { tr } = parentEditor.state;
	tr.setMeta("updatedListItemNodeViews", true);
	parentEditor.dispatch(tr);
};
function createLogger(debug, additionalPrefixes = []) {
	const basePrefix = "[SuperValidator]";
	const style = "color: teal; font-weight: bold;";
	const allPrefixes = [basePrefix, ...additionalPrefixes.map((p$1) => `[${p$1}]`)];
	const format = allPrefixes.map(() => "%c%s").join(" ");
	const styledPrefixes = allPrefixes.map((p$1) => [style, p$1]).flat();
	return {
		debug: (...args$1) => {
			if (!debug) return;
			console.debug(format, ...styledPrefixes, ...args$1);
		},
		withPrefix: (prefix) => createLogger(debug, [...additionalPrefixes, prefix])
	};
}
function ensureValidImageRID(images, editor, tr, logger) {
	let modified = false;
	const results = [];
	images.forEach(({ node, pos }) => {
		const { rId, src } = node.attrs;
		if (!rId && src) {
			const newId = findOrCreateRelationship(editor, "image-rid:ensureValidImageRID", {
				target: src,
				type: "image"
			});
			if (newId) {
				logger.debug("Assigned rId for image:", newId, "at pos:", pos);
				tr.setNodeMarkup(pos, void 0, {
					...node.attrs,
					rId: newId
				});
				results.push(`Added missing rId to image at pos ${pos}`);
				modified = true;
			}
		}
	});
	return {
		modified,
		results
	};
}
function createImageNodeValidator({ editor, logger }) {
	const validator = (tr, analysis) => {
		const ruleResults = [ensureValidImageRID(analysis.image || [], editor, tr, logger)];
		return {
			modified: ruleResults.some((r$1) => r$1.modified),
			results: ruleResults.flatMap((r$1) => r$1.results)
		};
	};
	validator.requiredElements = { nodes: ["image"] };
	return validator;
}
function ensureValidLinkRID(links, editor, tr, logger) {
	let modified = false;
	const results = [];
	links.forEach(({ mark, from: from$1, to }) => {
		const { rId, href, anchor } = mark.attrs;
		if (!rId && href && !anchor) {
			const newId = findOrCreateRelationship(editor, "link-rid:ensureValidLinkRID", {
				target: href,
				type: "hyperlink"
			});
			if (newId) {
				logger.debug("Assigned rId for link:", newId, "from pos:", from$1, "to pos:", to);
				const linkMarkType = editor.schema.marks.link;
				const newMark = linkMarkType.create({
					...mark.attrs,
					rId: newId
				});
				tr.removeMark(from$1, to, linkMarkType);
				tr.addMark(from$1, to, newMark);
				results.push(`Added missing rId to link from pos ${from$1} to ${to}`);
				modified = true;
			}
		}
	});
	return {
		modified,
		results
	};
}
function createLinkMarkValidator({ editor, logger }) {
	const validator = (tr, analysis) => {
		const ruleResults = [ensureValidLinkRID(analysis.link || [], editor, tr, logger)];
		return {
			modified: ruleResults.some((r$1) => r$1.modified),
			results: ruleResults.flatMap((r$1) => r$1.results)
		};
	};
	validator.requiredElements = { marks: ["link"] };
	return validator;
}
const StateValidators = {
	imageNodeValidator: createImageNodeValidator,
	linkMarkValidator: createLinkMarkValidator
};
function createNumberingValidator({ editor, logger }) {
	return () => {
		const results = [];
		let modified = false;
		const convertedXml = editor?.converter?.convertedXml;
		const path = "word/numbering.xml";
		const numbering = convertedXml?.[path];
		if (!numbering || !numbering.elements?.length || !numbering.elements[0].elements?.length) {
			results.push(`${path} is not a valid xml`);
			return {
				results,
				modified
			};
		}
		const removed = [];
		let elements = numbering.elements[0];
		pruneInvalidNumNodes(elements, removed);
		if (removed.length) {
			modified = true;
			results.push(`Removed invalid <w:num> by numId:` + removed.join(", "));
			logger?.debug?.(`Removed invalid <w:num> by numId: ${removed.join(", ")}`);
		} else results.push("No <w:num> entries with null/invalid numId found.");
		return {
			results,
			modified
		};
	};
}
function pruneInvalidNumNodes(node, removed) {
	if (!node || !Array.isArray(node.elements)) return;
	const next = [];
	for (const el of node.elements) {
		if (el?.type === "element") {
			if (el.name === "w:num") {
				const raw = (el.attributes || {})["w:numId"];
				const v = raw == null ? null : String(raw).trim();
				if (v == null || v === "" || /^null$/i.test(v) || !/^\d+$/.test(v)) {
					removed.push(v ?? "missing node");
					continue;
				}
			}
			if (Array.isArray(el.elements) && el.elements.length) pruneInvalidNumNodes(el, removed);
		}
		next.push(el);
	}
	node.elements = next;
}
function createRelationshipsValidator({ editor, logger }) {
	return () => {
		const results = [];
		let modified = false;
		const convertedXml = editor?.converter?.convertedXml;
		if (!convertedXml || typeof convertedXml !== "object") return {
			results,
			modified
		};
		const { relsKey, wasNormalized } = findAndNormalizeRelationshipsFile(convertedXml, results);
		if (!relsKey) return {
			results,
			modified
		};
		if (wasNormalized) modified = true;
		const { root, wasFixed } = validateRelationshipsRoot(convertedXml[relsKey], relsKey, results);
		if (!root) return {
			results,
			modified
		};
		if (wasFixed) modified = true;
		if (cleanupRootChildren(root)) modified = true;
		const { filteredIds, binMediaTargets, wasProcessed } = processRelationships(root, convertedXml, results);
		if (wasProcessed) modified = true;
		if (fixMissingDocumentRefs(convertedXml, filteredIds, results, logger)) modified = true;
		const contentTypesXml = convertedXml["[Content_Types].xml"];
		if (binMediaTargets.size > 0 || contentTypesXml) {
			if (updateContentTypes(convertedXml, binMediaTargets, results)) modified = true;
		} else results.push("[Content_Types].xml not found or not parseable. Skipped content types patch.");
		return {
			results,
			modified
		};
	};
}
function findAndNormalizeRelationshipsFile(convertedXml, results) {
	const relsKey = [
		"word/_rels/document.xml.rels",
		"word/document.xml.rels",
		"_rels/document.xml.rels",
		"document.xml.rels"
	].find((k$1) => convertedXml?.[k$1]?.elements);
	if (!relsKey) return {
		relsKey: null,
		wasNormalized: false
	};
	const canonicalKey = "word/_rels/document.xml.rels";
	if (relsKey !== canonicalKey) {
		convertedXml[canonicalKey] = convertedXml[relsKey];
		delete convertedXml[relsKey];
		results.push(`Normalized relationships location to ${canonicalKey} (was ${relsKey})`);
		return {
			relsKey: canonicalKey,
			wasNormalized: true
		};
	}
	return {
		relsKey,
		wasNormalized: false
	};
}
function validateRelationshipsRoot(relsTree, relsKey, results) {
	const root = relsTree?.elements?.[0];
	if (!root || root.type !== "element") {
		results.push(`${relsKey} is not a valid xml`);
		return {
			root: null,
			wasFixed: false
		};
	}
	const RELS_NS = "http://schemas.openxmlformats.org/package/2006/relationships";
	let wasFixed = false;
	if (root.name !== "Relationships") {
		root.name = "Relationships";
		results.push(`Fixed relationships root element name to "Relationships"`);
		wasFixed = true;
	}
	root.attributes = root.attributes || {};
	if (root.attributes.xmlns !== RELS_NS) {
		root.attributes.xmlns = RELS_NS;
		results.push(`Set relationships xmlns to ${RELS_NS}`);
		wasFixed = true;
	}
	return {
		root,
		wasFixed
	};
}
function cleanupRootChildren(root) {
	const validChildren = root.elements?.filter((child) => child?.type === "element" && child.name === "Relationship") || [];
	if (root.elements?.length !== validChildren.length) {
		root.elements = validChildren;
		return true;
	}
	return false;
}
function processRelationships(root, convertedXml, results) {
	const binMediaTargets = /* @__PURE__ */ new Set();
	const filteredIds = /* @__PURE__ */ new Set();
	let wasProcessed = false;
	const ridNum = (id) => {
		const m$1 = /^rId(\d+)$/.exec(String(id || ""));
		return m$1 ? parseInt(m$1[1], 10) : null;
	};
	const isType$1 = (type, tail) => typeof type === "string" && new RegExp(`/relationships/${tail}$`, "i").test(type);
	const isHyperlinkType = (type) => isType$1(type, "hyperlink");
	const isImageType = (type) => isType$1(type, "image");
	const looksExternal = (target) => /^https?:\/\//i.test(target || "") || /^mailto:/i.test(target || "");
	const usedIds = /* @__PURE__ */ new Set();
	let maxRid = 0;
	for (const el of root.elements) {
		el.attributes = el.attributes || {};
		const id = el.attributes.Id;
		const n = ridNum(id);
		if (Number.isInteger(n)) maxRid = Math.max(maxRid, n);
		if (typeof id === "string" && id) usedIds.add(id);
	}
	let ridCounter = maxRid;
	const allocateId = (preferred) => {
		if (preferred && !usedIds.has(preferred)) {
			usedIds.add(preferred);
			return preferred;
		}
		let newId;
		do {
			ridCounter += 1;
			newId = `rId${ridCounter}`;
		} while (usedIds.has(newId));
		usedIds.add(newId);
		return newId;
	};
	const seenIds = /* @__PURE__ */ new Set();
	const filtered = [];
	function extractStringAttr(attrs, key) {
		return typeof attrs[key] === "string" ? attrs[key].trim() : "";
	}
	for (const rel of root.elements) {
		rel.attributes = rel.attributes || {};
		const attrs = rel.attributes;
		let id = extractStringAttr(attrs, "Id");
		const type = extractStringAttr(attrs, "Type");
		let target = extractStringAttr(attrs, "Target");
		let targetMode = extractStringAttr(attrs, "TargetMode");
		if (!target) {
			results.push(`Removed relationship "${id}" without Target`);
			wasProcessed = true;
			continue;
		}
		if (isHyperlinkType(type) && looksExternal(target) && targetMode.toLowerCase() !== "external") {
			attrs.TargetMode = "External";
			targetMode = "External";
			results.push(`Set TargetMode="External" for hyperlink ${id}`);
			wasProcessed = true;
		}
		if (isImageType(type)) {
			const relPath = resolveOpcTargetPath(target, "word");
			if (relPath && /^media\/.+\.bin$/i.test(target) && relPath in convertedXml) binMediaTargets.add(`/${relPath}`);
		}
		if (targetMode.toLowerCase() !== "external" && !looksExternal(target)) {
			if (!(resolveOpcTargetPath(target, "word") in convertedXml)) if (!isImageType(type)) {
				results.push(`Removed relationship ${id} with missing target: ${target}`);
				wasProcessed = true;
				continue;
			} else results.push(`Warning: image relationship ${id} target not found: ${target}.`);
		}
		if (!id) {
			const newId = allocateId(null);
			attrs.Id = newId;
			results.push(`Assigned missing Id "${newId}"`);
			wasProcessed = true;
			id = newId;
		}
		if (seenIds.has(id)) {
			results.push(`Removed duplicate relationship with ID "${id}"`);
			wasProcessed = true;
			continue;
		}
		seenIds.add(id);
		filtered.push(rel);
	}
	if (root.elements.length !== filtered.length) {
		root.elements = filtered;
		wasProcessed = true;
	} else if (root.elements.some((el, i) => el !== filtered[i])) {
		root.elements = filtered;
		wasProcessed = true;
	}
	for (const rel of root.elements) {
		const id = rel.attributes?.Id;
		if (typeof id === "string" && id) filteredIds.add(id);
	}
	return {
		filteredIds,
		binMediaTargets,
		wasProcessed
	};
}
function fixMissingDocumentRefs(convertedXml, filteredIds, results, logger) {
	const document$1 = convertedXml["word/document.xml"];
	if (document$1?.elements?.length) {
		const documentRoot = document$1.elements[0];
		if (documentRoot?.type === "element") {
			const missingRefs = [];
			processDocumentForMissingRefs(documentRoot, filteredIds, missingRefs);
			if (missingRefs.length) {
				results.push(`Fixed ${missingRefs.length} missing relationship references`);
				logger?.debug?.(`Fixed ${missingRefs.length} missing relationship references in document`);
				return true;
			}
		}
	}
	return false;
}
function updateContentTypes(convertedXml, binMediaTargets, results) {
	const contentTypesKey = "[Content_Types].xml";
	const contentTypesXml = convertedXml[contentTypesKey];
	if (typeof contentTypesXml === "string") return updateContentTypesString(contentTypesXml, binMediaTargets, results, convertedXml, contentTypesKey);
	else if (contentTypesXml?.elements?.length) return updateContentTypesElements(contentTypesXml, binMediaTargets, results);
	else return false;
}
function updateContentTypesString(contentTypesXml, binMediaTargets, results, convertedXml, contentTypesKey) {
	const CONTENT_TYPES_NS$1 = "<Types xmlns=\"http://schemas.openxmlformats.org/package/2006/content-types\">";
	const ensureDefault = (xmlString, ext, contentType) => {
		if (new RegExp(`<Default\\s+Extension="${ext}"\\b`, "i").test(xmlString)) return xmlString;
		return xmlString.replace(CONTENT_TYPES_NS$1, `${CONTENT_TYPES_NS$1}<Default Extension="${ext}" ContentType="${contentType}"/>`);
	};
	const ensureOverride = (xmlString, partName, contentType) => {
		const esc = partName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
		if (new RegExp(`<Override\\s+PartName="${esc}"\\b`, "i").test(xmlString)) return xmlString;
		return xmlString.replace(CONTENT_TYPES_NS$1, `${CONTENT_TYPES_NS$1}<Override PartName="${partName}" ContentType="${contentType}" />`);
	};
	let updated = contentTypesXml;
	updated = ensureDefault(updated, "rels", "application/vnd.openxmlformats-package.relationships+xml");
	updated = ensureDefault(updated, "xml", "application/xml");
	for (const partName of binMediaTargets) {
		updated = ensureOverride(updated, partName, "image/png");
		results.push(`Added Content Types Override for "${partName}" as image/png`);
	}
	if (updated !== contentTypesXml) {
		convertedXml[contentTypesKey] = updated;
		return true;
	}
	return false;
}
function updateContentTypesElements(contentTypesXml, binMediaTargets, results) {
	const typesRoot = contentTypesXml.elements.find((el) => el.name === "Types") || contentTypesXml.elements[0];
	typesRoot.elements = typesRoot.elements || [];
	const hasDefault = (ext) => typesRoot.elements.some((el) => el.name === "Default" && el.attributes?.Extension === ext);
	const addDefault = (ext, ct) => {
		typesRoot.elements.unshift({
			type: "element",
			name: "Default",
			attributes: {
				Extension: ext,
				ContentType: ct
			}
		});
	};
	const hasOverride = (part) => typesRoot.elements.some((el) => el.name === "Override" && el.attributes?.PartName === part);
	const addOverride = (part, ct) => {
		typesRoot.elements.unshift({
			type: "element",
			name: "Override",
			attributes: {
				PartName: part,
				ContentType: ct
			}
		});
	};
	let wasUpdated = false;
	if (!hasDefault("rels")) {
		addDefault("rels", "application/vnd.openxmlformats-package.relationships+xml");
		wasUpdated = true;
	}
	if (!hasDefault("xml")) {
		addDefault("xml", "application/xml");
		wasUpdated = true;
	}
	for (const partName of binMediaTargets) if (!hasOverride(partName)) {
		addOverride(partName, "image/png");
		results.push(`Added Content Types Override for "${partName}" as image/png`);
		wasUpdated = true;
	}
	return wasUpdated;
}
function processDocumentForMissingRefs(node, usedIds, fixed) {
	if (!node?.elements?.length) return;
	for (const element of node.elements) {
		if (element?.type !== "element") continue;
		const rIdValue = element.attributes?.["r:id"];
		if (typeof rIdValue === "string" && !usedIds.has(rIdValue)) {
			delete element.attributes["r:id"];
			fixed.push(`Removed invalid r:id="${rIdValue}"`);
		}
		processDocumentForMissingRefs(element, usedIds, fixed);
	}
}
const XmlValidators = {
	numberingValidator: createNumberingValidator,
	relationshipsValidator: createRelationshipsValidator
};
var SuperValidator = class {
	#editor;
	#stateValidators;
	#xmlValidators;
	#requiredNodeTypes;
	#requiredMarkTypes;
	constructor(options) {
		this.#editor = options.editor;
		this.dryRun = options.dryRun || false;
		this.debug = options.debug || false;
		this.logger = createLogger(this.debug);
		const { stateValidators, xmlValidators, nodeTypes, markTypes } = this.#initializeValidators();
		this.#stateValidators = stateValidators;
		this.#xmlValidators = xmlValidators;
		this.#requiredNodeTypes = nodeTypes;
		this.#requiredMarkTypes = markTypes;
	}
	#initializeValidators() {
		const requiredNodes = /* @__PURE__ */ new Set();
		const requiredMarks = /* @__PURE__ */ new Set();
		const initializeValidatorSet = (validatorFactories) => {
			return Object.fromEntries(Object.entries(validatorFactories).map(([key, factory]) => {
				const validatorLogger = this.logger.withPrefix(key);
				const validator = factory({
					editor: this.#editor,
					logger: validatorLogger
				});
				this.#collectValidatorRequirements(validator, requiredNodes, requiredMarks);
				return [key, validator];
			}));
		};
		return {
			stateValidators: initializeValidatorSet(StateValidators),
			xmlValidators: initializeValidatorSet(XmlValidators),
			nodeTypes: requiredNodes,
			markTypes: requiredMarks
		};
	}
	#collectValidatorRequirements(validator, requiredNodes, requiredMarks) {
		if (!validator.requiredElements) return;
		if (typeof validator.requiredElements === "object") {
			if (validator.requiredElements.nodes) validator.requiredElements.nodes.forEach((nodeType) => {
				requiredNodes.add(nodeType);
			});
			if (validator.requiredElements.marks) validator.requiredElements.marks.forEach((markType) => {
				requiredMarks.add(markType);
			});
		}
	}
	#analyzeDocument() {
		const { doc: doc$1 } = this.#editor.state;
		const analysis = {};
		this.#requiredNodeTypes.forEach((type) => analysis[type] = []);
		this.#requiredMarkTypes.forEach((type) => analysis[type] = []);
		const collectElements = (node, pos) => {
			if (this.#requiredNodeTypes.has(node.type.name)) analysis[node.type.name].push({
				node,
				pos
			});
			if (node.isText && node.marks) node.marks.forEach((mark) => {
				if (this.#requiredMarkTypes.has(mark.type.name)) analysis[mark.type.name].push({
					mark,
					node,
					pos,
					from: pos,
					to: pos + node.nodeSize
				});
			});
		};
		doc$1.descendants(collectElements);
		return analysis;
	}
	validateActiveDocument() {
		const state = this.#editor.state;
		if (!state) return {
			modified: false,
			results: []
		};
		const { tr } = state;
		const documentAnalysis = this.#analyzeDocument();
		this.logger.debug("Document analysis:", documentAnalysis);
		let hasModifiedDocument = false;
		const validationResults = [];
		Object.entries(this.#stateValidators).forEach(([key, validator]) => {
			this.logger.debug(`🕵 Validating with ${key}...`);
			const { results, modified } = validator(tr, documentAnalysis);
			validationResults.push({
				key,
				results
			});
			hasModifiedDocument = hasModifiedDocument || modified;
		});
		if (!this.dryRun) this.#dispatchWithFallback(tr);
		else this.logger.debug("DRY RUN: No changes applied to the document.");
		this.logger.debug("Results:", validationResults);
		return {
			modified: hasModifiedDocument,
			results: validationResults
		};
	}
	validateDocumentExport() {
		const state = this.#editor.state;
		if (!state) return {
			modified: false,
			results: []
		};
		const { tr } = state;
		let hasModifiedDocument = false;
		const validationResults = [];
		Object.entries(this.#xmlValidators).forEach(([key, validator]) => {
			this.logger.debug(`🕵 Validating export with ${key}...`);
			const { results, modified } = validator();
			validationResults.push({
				key,
				results
			});
			hasModifiedDocument = hasModifiedDocument || modified;
		});
		if (!this.dryRun && hasModifiedDocument) this.#dispatchWithFallback(tr);
		else this.logger.debug("DRY RUN: No export changes applied to the document.");
		this.logger.debug("Export validation results:", validationResults);
		return {
			modified: hasModifiedDocument,
			results: validationResults
		};
	}
	#dispatchWithFallback(tr) {
		if (typeof this.#editor?.dispatch === "function") {
			this.#editor.dispatch(tr);
			return;
		}
		this.#editor?.view?.dispatch?.(tr);
	}
};
var domAvailabilityCache = null;
const canUseDOM = () => {
	if (domAvailabilityCache !== null) return domAvailabilityCache;
	try {
		const hasDOM = typeof globalThis !== "undefined" && typeof globalThis.window !== "undefined" && typeof globalThis.document !== "undefined" && typeof globalThis.document.createElement === "function";
		domAvailabilityCache = hasDOM;
		return hasDOM;
	} catch {
		domAvailabilityCache = false;
		return false;
	}
};
function buildCommentJsonFromText(text) {
	return text.replace(/\r\n?/g, "\n").split("\n").map((paragraphText$1) => ({
		type: "paragraph",
		content: [{
			type: "run",
			content: [{
				type: "text",
				text: paragraphText$1
			}]
		}]
	}));
}
var summaryVersion = "1.40.0";
var nodeKeys = [
	"group",
	"content",
	"marks",
	"inline",
	"atom",
	"defining",
	"code",
	"tableRole",
	"summary"
];
var markKeys = [
	"group",
	"inclusive",
	"excludes",
	"spanning",
	"code"
];
function mapAttributes(attrs) {
	if (!attrs) return {};
	return Object.fromEntries(Object.entries(attrs).map(([name, attrSpec]) => {
		const defaultValue = attrSpec?.default;
		return [name, {
			default: defaultValue ?? null,
			required: defaultValue === void 0
		}];
	}));
}
function pickSpecFields(spec, keys$1) {
	return Object.fromEntries(keys$1.map((key) => [key, spec[key]]).filter(([, value]) => value !== void 0));
}
function buildSchemaSummary(schema, schemaVersion) {
	if (!schema || typeof schema !== "object") throw new Error("Invalid schema: schema must be a valid ProseMirror Schema object.");
	const resolvedSchemaVersion = schemaVersion || "current";
	const nodes = [];
	schema.spec.nodes.forEach((name, spec) => {
		nodes.push({
			name,
			attrs: mapAttributes(spec.attrs),
			...pickSpecFields(spec, nodeKeys)
		});
	});
	const marks = [];
	schema.spec.marks.forEach((name, spec) => {
		marks.push({
			name,
			attrs: mapAttributes(spec.attrs),
			...pickSpecFields(spec, markKeys)
		});
	});
	return {
		version: summaryVersion,
		schemaVersion: resolvedSchemaVersion,
		topNode: schema.topNodeType?.name,
		nodes,
		marks
	};
}
const transformListsInCopiedContent = (html) => {
	const container = document.createElement("div");
	container.innerHTML = html;
	const result = [];
	const stack = [];
	const flushStackUntil = (level) => {
		while (stack.length && stack[stack.length - 1].level >= level) {
			const top$1 = stack.pop();
			if (stack.length) stack[stack.length - 1].el.appendChild(top$1.el);
			else result.push(top$1.el.outerHTML);
		}
	};
	Array.from(container.childNodes).forEach((node) => {
		if (node.nodeType !== Node.ELEMENT_NODE) {
			result.push(node.outerHTML || node.textContent);
			return;
		}
		if (node.tagName.toLowerCase() === "ol" || node.tagName.toLowerCase() === "ul") {
			const child = getFirstElementChild(node);
			const level = getLevel(child);
			const numFmt = child.getAttribute("data-num-fmt");
			const lvlText = child.getAttribute("data-lvl-text");
			const tag = node.tagName.toLowerCase();
			const li = child.cloneNode(true);
			li.setAttribute("aria-level", level + 1);
			li.style.setProperty("list-style-type", getListStyleType(numFmt, lvlText));
			if (!stack.length || stack[stack.length - 1].level < level) {
				const newList = document.createElement(tag);
				stack.push({
					tag,
					level,
					el: newList
				});
			} else if (stack[stack.length - 1].level > level) flushStackUntil(level + 1);
			else if (stack[stack.length - 1].tag !== tag) {
				flushStackUntil(level);
				const newList = document.createElement(tag);
				stack.push({
					tag,
					level,
					el: newList
				});
			}
			stack[stack.length - 1].el.appendChild(li);
		} else {
			flushStackUntil(0);
			result.push(node.outerHTML);
		}
	});
	flushStackUntil(0);
	return result.join("");
};
const getListStyleType = (numFmt, lvlText) => {
	const bulletFmtMap = new Map([
		["●", "disc"],
		["◦", "circle"],
		["▪", "square"]
	]);
	if (numFmt === "bullet") return bulletFmtMap.get(lvlText) || "disc";
	const fmtMap = new Map([
		["decimal", "decimal"],
		["lowerLetter", "lower-alpha"],
		["upperLetter", "upper-alpha"],
		["lowerRoman", "lower-roman"],
		["upperRoman", "upper-roman"]
	]);
	return lvlText.startsWith("0") ? "decimal-leading-zero" : fmtMap.get(numFmt);
};
function getFirstElementChild(node) {
	return Array.from(node.childNodes).find((n) => n.nodeType === Node.ELEMENT_NODE) || null;
}
const getLevel = (node) => {
	const lvl = node.getAttribute("data-level");
	return lvl ? parseInt(lvl, 10) : 0;
};
var HEADING_STYLE_RE = /^Heading[1-9]$/i;
function wrapHeadingSelectionAsParagraph(slice, state) {
	const firstChild = slice.content.firstChild;
	if (!firstChild || firstChild.type.name === "paragraph") return slice;
	const $from = state.selection.$from;
	const $to = state.selection.$to;
	if (!$from || !$to) return slice;
	let parentParagraph = null;
	let parentDepth = -1;
	for (let depth = $from.depth; depth >= 0; depth--) {
		const node = $from.node(depth);
		if (node?.type?.name === "paragraph") {
			if ($to.depth >= depth && $to.node(depth) === node) {
				parentParagraph = node;
				parentDepth = depth;
			}
			break;
		}
	}
	if (!parentParagraph) return slice;
	const startOffset = $from.parentOffset;
	const endOffset = $to.parentOffset;
	if (startOffset !== 0 || endOffset !== parentParagraph.content.size) return slice;
	if ($from.depth !== parentDepth || $to.depth !== parentDepth) return slice;
	const styleId$1 = parentParagraph.attrs?.paragraphProperties?.styleId;
	if (typeof styleId$1 !== "string" || !HEADING_STYLE_RE.test(styleId$1)) return slice;
	const wrapped = parentParagraph.type.create(parentParagraph.attrs, slice.content, parentParagraph.marks);
	return new Slice(Fragment$1.from(wrapped), 0, 0);
}
var DEFAULT_FALLBACK_MARGIN_INCHES = 1;
var MIN_MOBILE_SIDE_MARGIN_PX = 10;
var RESIZE_DEBOUNCE_MS = 150;
var DEFAULT_LINE_HEIGHT = 1.2;
var HEADER_FOOTER_LINE_HEIGHT = 1;
var RUNTIME_COPY_STRIP_SELECTOR = [
	".list-marker",
	".sd-editor-tab",
	".ProseMirror-trailingBreak"
].join(", ");
var PARAGRAPH_CONTENT_SELECTOR = "span.sd-paragraph-content";
var BLOCK_COPY_CONTEXT_SELECTOR = "p, div, h1, h2, h3, h4, h5, h6, blockquote, table";
var WORD_HTML_META = "<meta name=\"Generator\" content=\"Microsoft Word\">";
var WORD_NUM_FMT_BY_LIST_FMT = new Map([
	["decimal", "decimal"],
	["lowerLetter", "alpha-lower"],
	["upperLetter", "alpha-upper"],
	["lowerRoman", "roman-lower"],
	["upperRoman", "roman-upper"],
	["bullet", "bullet"]
]);
function closestCopyBlock(node, root) {
	let current = node;
	while (current && current !== root) {
		if (current.nodeType === Node.ELEMENT_NODE) {
			const element = current;
			if (element.matches(BLOCK_COPY_CONTEXT_SELECTOR)) return element;
		}
		current = current.parentNode;
	}
	return null;
}
function fragmentHasBlockElements(fragment) {
	const container = document.createElement("div");
	container.appendChild(fragment.cloneNode(true));
	return Boolean(container.querySelector(BLOCK_COPY_CONTEXT_SELECTOR));
}
function getInlineTextStyle(element) {
	const styles = [];
	const computedStyle = globalThis.getComputedStyle?.(element);
	const color = element.style.color || (computedStyle?.color && computedStyle.color !== "rgb(0, 0, 0)" ? computedStyle.color : "");
	const fontFamily = element.style.fontFamily || "";
	const fontSize = element.style.fontSize || (computedStyle?.fontSize && computedStyle.fontSize !== "16px" ? computedStyle.fontSize : "");
	const textTransform = element.style.textTransform || (computedStyle?.textTransform && computedStyle.textTransform !== "none" ? computedStyle.textTransform : "");
	const fontWeight = element.style.fontWeight || (computedStyle?.fontWeight && computedStyle.fontWeight !== "400" ? computedStyle.fontWeight : "");
	if (color) styles.push(`color: ${color}`);
	if (fontFamily) styles.push(`font-family: ${fontFamily}`);
	if (fontSize) styles.push(`font-size: ${fontSize}`);
	if (textTransform) styles.push(`text-transform: ${textTransform}`);
	if (fontWeight) styles.push(`font-weight: ${fontWeight}`);
	return styles.join("; ");
}
function wrapInlineOnlyRange(range, view) {
	const fragment = range.cloneContents();
	if (fragmentHasBlockElements(fragment)) return fragment;
	const startBlock = closestCopyBlock(range.startContainer, view.dom);
	const endBlock = closestCopyBlock(range.endContainer, view.dom);
	if (!startBlock || startBlock !== endBlock) return fragment;
	const wrapper = startBlock.cloneNode(false);
	const inheritedTextStyle = getInlineTextStyle(startBlock);
	if (inheritedTextStyle) {
		const span = document.createElement("span");
		span.setAttribute("style", inheritedTextStyle);
		span.appendChild(fragment);
		wrapper.appendChild(span);
	} else wrapper.appendChild(fragment);
	const contextualFragment = document.createDocumentFragment();
	contextualFragment.appendChild(wrapper);
	return contextualFragment;
}
function getParagraphNodeFromBlockDom(view, blockDom) {
	let pos;
	try {
		pos = view.posAtDOM(blockDom, 0);
	} catch {
		return null;
	}
	const { doc: doc$1 } = view.state;
	if (pos < 0 || pos > doc$1.content.size) return null;
	const $pos = doc$1.resolve(pos);
	for (let d = $pos.depth; d > 0; d -= 1) {
		const n = $pos.node(d);
		if (n.type.name === "paragraph") return n;
	}
	return null;
}
function normalizeCopiedListMetadata(container) {
	container.querySelectorAll("p[data-num-id], p[data-list-numbering-type]").forEach((node) => {
		const numberingType = node.getAttribute("data-list-numbering-type");
		const markerText = node.getAttribute("data-marker-type");
		if (numberingType && !node.hasAttribute("data-num-fmt")) node.setAttribute("data-num-fmt", numberingType);
		if (markerText && !node.hasAttribute("data-lvl-text")) node.setAttribute("data-lvl-text", markerText);
	});
}
function annotateCopiedSectionMetadata(container, view) {
	const copiedBlocks = Array.from(container.querySelectorAll("[data-sd-block-id]"));
	if (copiedBlocks.length === 0) return;
	copiedBlocks.forEach((node) => {
		const blockId = node.getAttribute("data-sd-block-id");
		if (!blockId) return;
		const sourceNode = view.dom.querySelector(`[data-sd-block-id="${globalThis.CSS?.escape?.(blockId) ?? blockId}"]`);
		if (!sourceNode) return;
		const pmNode = getParagraphNodeFromBlockDom(view, sourceNode);
		const sectPr = (pmNode?.attrs?.paragraphProperties)?.sectPr;
		if (!sectPr || typeof sectPr !== "object") return;
		node.setAttribute("data-sd-sect-pr", JSON.stringify(sectPr));
		const pageBreakSource = pmNode?.attrs?.pageBreakSource;
		if (typeof pageBreakSource === "string" && pageBreakSource.length > 0) node.setAttribute("data-sd-page-break-source", pageBreakSource);
	});
}
function parseCopiedListPath(pathAttr) {
	if (!pathAttr) return [];
	try {
		const parsed = JSON.parse(pathAttr);
		return Array.isArray(parsed) ? parsed.map((item) => Number(item)).filter((item) => Number.isFinite(item)) : [];
	} catch {
		return [];
	}
}
function getWordLevelText(level, fmt, markerText, storedLevelText) {
	if (fmt === "bullet") return markerText || storedLevelText || "•";
	if (storedLevelText?.includes("%")) return storedLevelText;
	const punctuation = markerText.match(/[.)]$/)?.[0] || ".";
	return `%${level + 1}${punctuation}`;
}
function buildWordListPrefix(markerText) {
	const fragment = document.createDocumentFragment();
	fragment.appendChild(document.createComment("[if !supportLists]"));
	const span = document.createElement("span");
	span.textContent = markerText;
	fragment.appendChild(span);
	fragment.appendChild(document.createComment("[endif]"));
	return fragment;
}
function serializeSelectionAsWordHtml(container) {
	if (Array.from(container.querySelectorAll("p[data-num-id], p[data-list-numbering-type]")).length === 0) return null;
	const wordContainer = container.cloneNode(true);
	const cssRules = [".MsoNormal {}", ".MsoListParagraph {}"];
	const seenLevels = /* @__PURE__ */ new Set();
	wordContainer.querySelectorAll("p[data-num-id], p[data-list-numbering-type]").forEach((node) => {
		const level = Number.parseInt(node.getAttribute("data-level") || "0", 10) || 0;
		const wordLevel = level + 1;
		const importedNumId = node.getAttribute("data-num-id") || "1";
		const abstractId = importedNumId;
		const fmt = node.getAttribute("data-num-fmt") || node.getAttribute("data-list-numbering-type") || "decimal";
		const wordNumFmt = WORD_NUM_FMT_BY_LIST_FMT.get(fmt) || "decimal";
		const markerText = node.getAttribute("data-marker-type") || node.getAttribute("data-lvl-text") || "1.";
		const levelText = getWordLevelText(level, fmt, markerText, node.getAttribute("data-lvl-text"));
		const levelKey = `${abstractId}:${wordLevel}:${importedNumId}`;
		const styleAttr = node.getAttribute("style");
		const msoListStyle = `mso-list:l${abstractId} level${wordLevel} lfo${importedNumId}`;
		node.setAttribute("class", "MsoListParagraph");
		node.setAttribute("style", styleAttr ? `${msoListStyle};${styleAttr}` : msoListStyle);
		if (!seenLevels.has(levelKey)) {
			cssRules.push(`@list l${abstractId}:level${wordLevel} lfo${importedNumId} { mso-level-number-format: ${wordNumFmt}; mso-level-text: "${levelText}"; }`);
			seenLevels.add(levelKey);
		}
		const path = parseCopiedListPath(node.getAttribute("data-list-level"));
		const startValue = path[level] ?? path[path.length - 1] ?? 1;
		const markerPrefix = fmt === "bullet" ? markerText : `${markerText}`.trim() || `${startValue}.`;
		node.prepend(buildWordListPrefix(markerPrefix));
	});
	return `${WORD_HTML_META}<style>${cssRules.join("\n")}</style>${wordContainer.innerHTML}`;
}
function getSelectionFromViewRoot(root) {
	if (root instanceof Document) return root.getSelection();
	if (typeof ShadowRoot !== "undefined" && root instanceof ShadowRoot) {
		const extended = root;
		if (typeof extended.getSelection === "function") return extended.getSelection() ?? null;
		return extended.ownerDocument.getSelection();
	}
	return typeof document !== "undefined" ? document.getSelection() : null;
}
function buildSelectionClipboardHtml(view, editor) {
	const rootSelection = getSelectionFromViewRoot(view.root);
	if (!rootSelection || rootSelection.isCollapsed || rootSelection.rangeCount === 0) return null;
	const container = document.createElement("div");
	let appendedContent = false;
	for (let index = 0; index < rootSelection.rangeCount; index += 1) {
		const range = rootSelection.getRangeAt(index);
		const commonAncestor = range.commonAncestorContainer.nodeType === Node.ELEMENT_NODE ? range.commonAncestorContainer : range.commonAncestorContainer.parentElement;
		if (commonAncestor && !view.dom.contains(commonAncestor)) continue;
		container.appendChild(wrapInlineOnlyRange(range, view));
		appendedContent = true;
	}
	if (!appendedContent) return null;
	container.querySelectorAll(RUNTIME_COPY_STRIP_SELECTOR).forEach((node) => {
		node.parentNode?.removeChild(node);
	});
	container.querySelectorAll(PARAGRAPH_CONTENT_SELECTOR).forEach((node) => {
		const parent = node.parentNode;
		if (!parent) return;
		while (node.firstChild) parent.insertBefore(node.firstChild, node);
		parent.removeChild(node);
	});
	container.querySelectorAll("[contenteditable], [draggable], [spellcheck], [data-pm-slice]").forEach((node) => {
		node.removeAttribute("contenteditable");
		node.removeAttribute("draggable");
		node.removeAttribute("spellcheck");
		node.removeAttribute("data-pm-slice");
	});
	container.querySelectorAll("[class]").forEach((node) => {
		const retainedClasses = (node.getAttribute("class") || "").split(/\s+/).filter(Boolean).filter((className) => !className.startsWith("ProseMirror"));
		if (retainedClasses.length > 0) node.setAttribute("class", retainedClasses.join(" "));
		else node.removeAttribute("class");
	});
	mergeSerializedClipboardMetadataIntoDomContainer(container, view, editor);
	normalizeCopiedListMetadata(container);
	annotateCopiedSectionMetadata(container, view);
	return serializeSelectionAsWordHtml(container) || container.innerHTML || null;
}
var ProseMirrorRenderer = class {
	constructor() {
		this.view = null;
		this.eventListenerCleanups = [];
		this.resizeTimeoutId = null;
	}
	attach({ element, state, editorProps = {}, dispatchTransaction: dispatchTransaction$3, handleClick: handleClick$1 }) {
		this.view?.destroy();
		this.view = new EditorView(element, {
			...editorProps && typeof editorProps === "object" ? editorProps : {},
			dispatchTransaction: dispatchTransaction$3,
			state,
			handleClick: handleClick$1
		});
		return this.view;
	}
	destroy() {
		if (this.resizeTimeoutId !== null) {
			clearTimeout(this.resizeTimeoutId);
			this.resizeTimeoutId = null;
		}
		for (const cleanup of this.eventListenerCleanups) cleanup();
		this.eventListenerCleanups = [];
		this.view?.destroy();
		this.view = null;
	}
	initContainerElement(options) {
		if (!canUseDOM()) {
			options.isHeadless = true;
			options.element = null;
			return;
		}
		if (!options.element && options.selector) {
			const { selector } = options;
			let foundElement = null;
			if (selector.startsWith("#") || selector.startsWith(".")) {
				const queriedElement = document.querySelector(selector);
				foundElement = queriedElement instanceof HTMLElement ? queriedElement : null;
			} else foundElement = document.getElementById(selector);
			options.element = foundElement;
			if (["text", "html"].includes(options.mode) && options.element) options.element.classList.add("sd-super-editor-html");
		}
		if (options.isHeadless) {
			options.element = null;
			return;
		}
		options.element = options.element || document.createElement("div");
		applyStyleIsolationClass(options.element);
	}
	initFonts(editor) {
		const results = editor.converter.getFontFaceImportString();
		if (results?.styleString?.length) try {
			const style = document.createElement("style");
			style.textContent = results.styleString;
			document.head.appendChild(style);
			editor.fontsImported = results.fontsImported;
		} catch (error) {
			console.warn("Failed to inject fonts into DOM:", error);
		}
	}
	updateEditorStyles(editor, element, proseMirror) {
		if (!proseMirror || !element) return;
		this.#applyBaseStyles(editor, element, proseMirror);
		if (editor.isWebLayout()) this.#applyWebLayoutStyles(element, proseMirror);
		else this.#applyPrintLayoutStyles(editor, element, proseMirror);
	}
	#applyBaseStyles(editor, element, proseMirror) {
		proseMirror.setAttribute("role", "document");
		proseMirror.setAttribute("aria-multiline", "true");
		proseMirror.setAttribute("aria-label", "Main content area, start typing to enter text.");
		proseMirror.setAttribute("aria-description", "");
		proseMirror.classList.remove("view-mode");
		element.style.boxSizing = "border-box";
		element.style.isolation = "isolate";
		proseMirror.style.outline = "none";
		proseMirror.style.border = "none";
		element.style.backgroundColor = "#fff";
		proseMirror.style.backgroundColor = "#fff";
		const { typeface, fontSizePt, fontFamilyCss } = editor.converter.getDocumentDefaultStyles() ?? {};
		const resolvedFontFamily = fontFamilyCss || typeface;
		if (resolvedFontFamily) element.style.fontFamily = resolvedFontFamily;
		if (fontSizePt) element.style.fontSize = `${fontSizePt}pt`;
		proseMirror.style.lineHeight = editor.options.isHeaderOrFooter ? String(HEADER_FOOTER_LINE_HEIGHT) : String(DEFAULT_LINE_HEIGHT);
		element.style.transformOrigin = "top left";
		element.style.touchAction = "auto";
		const elementStyleWithVendor = element.style;
		if ("webkitOverflowScrolling" in element.style || typeof elementStyleWithVendor === "object") elementStyleWithVendor.webkitOverflowScrolling = "touch";
	}
	#applyWebLayoutStyles(element, proseMirror) {
		element.style.width = "";
		element.style.minWidth = "";
		element.style.minHeight = "";
		element.style.paddingLeft = "";
		element.style.paddingRight = "";
		proseMirror.style.paddingTop = "0";
		proseMirror.style.paddingBottom = "0";
	}
	#applyPrintLayoutStyles(editor, element, proseMirror) {
		const { pageSize, pageMargins } = editor.converter.pageStyles ?? {};
		if (pageSize?.width != null) {
			element.style.width = `${pageSize.width}in`;
			element.style.minWidth = `${pageSize.width}in`;
			if (pageSize?.height != null) element.style.minHeight = `${pageSize.height}in`;
		}
		if (pageMargins) {
			element.style.paddingLeft = `${pageMargins.left}in`;
			element.style.paddingRight = `${pageMargins.right}in`;
		}
		if (editor.presentationEditor && pageMargins?.top != null) proseMirror.style.paddingTop = `${pageMargins.top}in`;
		else if (editor.presentationEditor) proseMirror.style.paddingTop = `${DEFAULT_FALLBACK_MARGIN_INCHES}in`;
		else proseMirror.style.paddingTop = "0";
		proseMirror.style.paddingBottom = "0";
	}
	initDefaultStyles(editor, element = editor.element) {
		if (editor.options.isHeadless || editor.options.suppressDefaultDocxStyles) return;
		if (!element) return;
		const proseMirrorElement = element.querySelector(".ProseMirror");
		const proseMirror = proseMirrorElement instanceof HTMLElement ? proseMirrorElement : null;
		if (!proseMirror) return;
		this.updateEditorStyles(editor, element, proseMirror);
		this.initMobileStyles(editor, element);
	}
	initMobileStyles(editor, element) {
		if (!element) return;
		if (editor.isWebLayout()) return;
		const initialWidth = element.offsetWidth;
		const updateScale = () => {
			const elementWidth = initialWidth;
			const availableWidth = document.documentElement.clientWidth - MIN_MOBILE_SIDE_MARGIN_PX;
			editor.options.scale = Math.min(1, availableWidth / elementWidth);
			const superEditorElement = element.closest(".super-editor");
			const superEditorContainer = element.closest(".super-editor-container");
			if (!(superEditorElement instanceof HTMLElement) || !(superEditorContainer instanceof HTMLElement)) return;
			if (editor.options.scale < 1) {
				superEditorElement.style.maxWidth = `${elementWidth * editor.options.scale}px`;
				superEditorContainer.style.minWidth = "0px";
				element.style.transform = `scale(${editor.options.scale})`;
			} else {
				superEditorElement.style.maxWidth = "";
				superEditorContainer.style.minWidth = "";
				element.style.transform = "none";
			}
		};
		updateScale();
		const handleResize = () => {
			if (this.resizeTimeoutId !== null) clearTimeout(this.resizeTimeoutId);
			this.resizeTimeoutId = setTimeout(() => {
				updateScale();
				this.resizeTimeoutId = null;
			}, RESIZE_DEBOUNCE_MS);
		};
		if ("orientation" in screen && "addEventListener" in screen.orientation) {
			screen.orientation.addEventListener("change", handleResize);
			this.eventListenerCleanups.push(() => {
				screen.orientation.removeEventListener("change", handleResize);
			});
		} else {
			const mediaQueryList = typeof window.matchMedia === "function" ? window.matchMedia("(orientation: portrait)") : null;
			if (mediaQueryList?.addEventListener) {
				mediaQueryList.addEventListener("change", handleResize);
				this.eventListenerCleanups.push(() => {
					mediaQueryList.removeEventListener("change", handleResize);
				});
			}
		}
		window.addEventListener("resize", handleResize);
		this.eventListenerCleanups.push(() => {
			window.removeEventListener("resize", handleResize);
		});
	}
	registerCopyHandler(editor) {
		const dom = this.view?.dom;
		if (!dom || !canUseDOM()) return;
		const copyHandler = (event) => {
			try {
				const clipboardData = event.clipboardData;
				if (!clipboardData) return;
				event.preventDefault();
				if (!this.view) return;
				const { from: from$1, to } = this.view.state.selection;
				let sliceJson = "";
				let mediaJson = "";
				if (from$1 !== to) {
					const slice = wrapHeadingSelectionAsParagraph(this.view.state.doc.slice(from$1, to), this.view.state);
					sliceJson = JSON.stringify(slice.toJSON());
					clipboardData.setData("application/x-superdoc-slice", sliceJson);
					mediaJson = collectReferencedImageMediaForClipboard(sliceJson, editor);
					if (mediaJson) clipboardData.setData(SUPERDOC_MEDIA_MIME, mediaJson);
				}
				const richHtml = buildSelectionClipboardHtml(this.view, editor);
				const bodySectPr = this.view.state.doc.attrs?.bodySectPr;
				const bodySectPrJson = bodySectPr && bodySectPrShouldEmbed(bodySectPr) ? JSON.stringify(bodySectPr) : "";
				if (richHtml) {
					clipboardData.setData("text/html", embedSliceInHtml(richHtml, sliceJson, bodySectPrJson, mediaJson));
					clipboardData.setData("text/plain", getSelectionFromViewRoot(this.view.root)?.toString() ?? "");
					return;
				}
				const fragment = this.view.state.doc.slice(from$1, to).content;
				const div$1 = document.createElement("div");
				const serializer = DOMSerializer.fromSchema(this.view.state.schema);
				div$1.appendChild(serializer.serializeFragment(fragment));
				annotateFragmentDomWithClipboardData(div$1, fragment, editor);
				const html = transformListsInCopiedContent(div$1.innerHTML);
				clipboardData.setData("text/html", embedSliceInHtml(html, sliceJson, bodySectPrJson, mediaJson));
				clipboardData.setData("text/plain", this.view.state.doc.textBetween(from$1, to, "\n"));
			} catch (error) {
				console.warn("Failed to transform copied content:", error);
			}
		};
		dom.addEventListener("copy", copyHandler);
		this.eventListenerCleanups.push(() => {
			dom.removeEventListener("copy", copyHandler);
		});
	}
	initDevTools(editor) {
		if (editor.options.isHeaderOrFooter) return;
		if (process$1.env.NODE_ENV === "development" || editor.options.isDebug) try {
			window.superdocdev = {
				converter: editor.converter,
				editor
			};
		} catch (error) {
			console.warn("Failed to initialize developer tools:", error);
		}
	}
};
const BLANK_DOCX_BASE64 = `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`;
const BLANK_DOCX_DATA_URI = `data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${BLANK_DOCX_BASE64}`;
function isVisibleProjection(options) {
	return options?.textModel === "visible";
}
function hasTrackDeleteMark$1(pmNode) {
	return pmNode.marks?.some((mark) => mark.type.name === "trackDelete") ?? false;
}
function projectContentNode(pmNode, options) {
	return projectBlock(pmNode, options);
}
function projectInlineNode(pmNode, options) {
	return projectInline(pmNode, options) ?? {
		kind: "run",
		run: { text: "" }
	};
}
function projectMarkBasedInline(editor, candidate) {
	const { nodeType, anchor, attrs } = candidate;
	const text = resolveTextByBlockId(editor, anchor);
	if (nodeType === "hyperlink") return {
		kind: "hyperlink",
		hyperlink: {
			...typeof attrs?.href === "string" ? { href: attrs.href } : {},
			...typeof attrs?.anchor === "string" ? { anchor: attrs.anchor } : {},
			...typeof attrs?.tooltip === "string" ? { tooltip: attrs.tooltip } : {},
			inlines: [{
				kind: "run",
				run: { text }
			}]
		}
	};
	return {
		kind: "run",
		run: { text }
	};
}
function blockMatchesId(node, blockId) {
	const attrs = node.attrs;
	if (!attrs) return false;
	return attrs.sdBlockId === blockId || attrs.paraId === blockId || attrs.blockId === blockId || attrs.id === blockId || attrs.uuid === blockId;
}
function resolveTextByBlockId(editor, anchor) {
	try {
		const doc$1 = editor.state.doc;
		let text = "";
		doc$1.descendants((node, pos) => {
			if (blockMatchesId(node, anchor.start.blockId) && node.isBlock) {
				const from$1 = pos + 1 + anchor.start.offset;
				const to = pos + 1 + anchor.end.offset;
				text = doc$1.textBetween(from$1, Math.min(to, pos + node.nodeSize - 1), "");
				return false;
			}
			return true;
		});
		return text;
	} catch {
		return "";
	}
}
function projectDocument(editor, options) {
	const doc$1 = editor.state.doc;
	const body = [];
	const projectionOptions = { textModel: "visible" };
	doc$1.forEach((child) => {
		body.push(projectBlock(child, projectionOptions));
	});
	const sections = projectSections(editor);
	const numbering = projectNumberingCatalog(editor);
	return {
		modelVersion: "sdm/1",
		body,
		...sections.length > 0 && { sections },
		...numbering && { numbering }
	};
}
function projectSections(editor) {
	let projections;
	try {
		projections = resolveSectionProjections(editor);
	} catch {
		return [];
	}
	return projections.map((projection) => domainToSDSection(projection.domain));
}
function domainToSDSection(domain) {
	const section = { id: domain.address.sectionId };
	if (domain.breakType) section.breakType = domain.breakType;
	if (domain.pageSetup) section.pageSetup = domain.pageSetup;
	if (domain.margins) section.margins = {
		top: domain.margins.top,
		right: domain.margins.right,
		bottom: domain.margins.bottom,
		left: domain.margins.left,
		gutter: domain.margins.gutter
	};
	if (domain.headerFooterMargins) section.headerFooterMargins = domain.headerFooterMargins;
	if (domain.columns) section.columns = domain.columns;
	if (domain.lineNumbering) section.lineNumbering = domain.lineNumbering;
	if (domain.pageNumbering) section.pageNumbering = domain.pageNumbering;
	if (domain.titlePage != null) section.titlePage = domain.titlePage;
	if (domain.oddEvenHeadersFooters != null) section.oddEvenHeadersFooters = domain.oddEvenHeadersFooters;
	if (domain.verticalAlign) section.verticalAlign = domain.verticalAlign;
	if (domain.sectionDirection) section.sectionDirection = domain.sectionDirection;
	return section;
}
var BULLET_FORMATS$1 = new Set(["bullet"]);
function projectNumberingCatalog(editor) {
	const translated = editor.converter?.translatedNumbering;
	if (!translated) return void 0;
	const { definitions = {}, abstracts = {} } = translated;
	const entries = Object.entries(definitions);
	if (entries.length === 0) return void 0;
	const catalog = { definitions: {} };
	for (const [numId, definition] of entries) {
		if (!definition) continue;
		const abstractId = definition.abstractNumId;
		const levelDefs = (abstractId != null ? abstracts[abstractId] : void 0)?.levels;
		if (!levelDefs) continue;
		const levels = [];
		for (const levelDef of Object.values(levelDefs)) {
			const format = levelDef.numFmt?.val;
			const start$1 = definition.lvlOverrides?.[levelDef.ilvl]?.startOverride ?? levelDef.start;
			levels.push({
				level: levelDef.ilvl,
				kind: format && BULLET_FORMATS$1.has(format) ? "bullet" : "ordered",
				...format != null && { format },
				...levelDef.lvlText != null && { text: levelDef.lvlText },
				...start$1 != null && { start: start$1 },
				...levelDef.lvlRestart != null && { restartAfterLevel: levelDef.lvlRestart }
			});
		}
		if (levels.length > 0) catalog.definitions[numId] = { levels };
	}
	return Object.keys(catalog.definitions).length > 0 ? catalog : void 0;
}
function projectBlock(pmNode, options) {
	const typeName = pmNode.type.name;
	switch (typeName) {
		case "paragraph": return projectParagraphOrHeading(pmNode, options);
		case "heading": return projectHeadingNode(pmNode, options);
		case "table": return projectTable(pmNode, options);
		case "bulletList":
		case "orderedList": return projectList(pmNode, typeName === "orderedList", options);
		case "listItem": return projectListItemAsContent(pmNode, options);
		case "image": return projectBlockImage(pmNode);
		case "tableOfContents": return projectToc(pmNode);
		case "sdt":
		case "structuredContentBlock": return projectBlockSdt(pmNode, options);
		case "sectionBreak": return projectSectionBreak(pmNode);
		case "pageBreak":
		case "horizontalRule": return projectBreak(pmNode);
		case "drawing": return projectBlockDrawing(pmNode);
		default: return projectFallbackBlock(pmNode, options);
	}
}
function projectParagraphOrHeading(pmNode, options) {
	const attrs = pmNode.attrs;
	const headingLevel = getHeadingLevel$1(attrs?.paragraphProperties?.styleId);
	if (headingLevel && headingLevel >= 1 && headingLevel <= 6) return buildHeading(pmNode, attrs, headingLevel, options);
	return buildParagraph(pmNode, attrs, options);
}
function projectHeadingNode(pmNode, options) {
	const attrs = pmNode.attrs;
	return buildHeading(pmNode, attrs, pmNode.attrs?.level ?? getHeadingLevel$1(attrs?.paragraphProperties?.styleId) ?? 1, options);
}
function buildParagraph(pmNode, attrs, options) {
	const inlines = projectInlineChildren(pmNode, options);
	const result = {
		kind: "paragraph",
		id: resolveNodeId(pmNode),
		paragraph: { inlines }
	};
	const styleRef = attrs?.paragraphProperties?.styleId ?? pmNode.attrs?.paragraphStyle;
	if (styleRef) result.paragraph.styleRef = styleRef;
	const props = extractParagraphProps(attrs);
	if (props) result.paragraph.props = props;
	return result;
}
function buildHeading(pmNode, attrs, level, options) {
	const inlines = projectInlineChildren(pmNode, options);
	const result = {
		kind: "heading",
		id: resolveNodeId(pmNode),
		heading: {
			level,
			inlines
		}
	};
	const styleRef = attrs?.paragraphProperties?.styleId ?? pmNode.attrs?.paragraphStyle;
	if (styleRef) result.heading.styleRef = styleRef;
	const props = extractParagraphProps(attrs);
	if (props) result.heading.props = props;
	return result;
}
function projectTable(pmNode, options) {
	const attrs = pmNode.attrs;
	const pmAttrs = pmNode.attrs;
	const rows = [];
	pmNode.forEach((child) => {
		if (child.type.name === "tableRow") rows.push(projectTableRow(child, options));
	});
	const result = {
		kind: "table",
		id: resolveNodeId(pmNode),
		table: { rows }
	};
	const styleRef = attrs?.tableProperties?.tableStyleId ?? pmAttrs?.tableStyleId;
	if (styleRef) result.table.styleRef = styleRef;
	const props = extractTableProps(attrs, pmAttrs);
	if (props) result.table.props = props;
	const gridModel = pmAttrs?.grid ?? pmAttrs?.tableGridModel ?? attrs?.tableGrid?.colWidths;
	if (gridModel && Array.isArray(gridModel)) {
		const columns = gridModel.map((item) => typeof item === "number" ? item : item?.col ?? item?.width).filter((width) => typeof width === "number" && Number.isFinite(width)).map((width) => ({ width }));
		if (columns.length > 0) result.table.columns = columns;
	}
	if (pmAttrs?.needsTableStyleNormalization === true) {
		const ext = isRecord(result.ext) ? { ...result.ext } : {};
		const superdocExt = isRecord(ext.superdoc) ? { ...ext.superdoc } : {};
		superdocExt.needsTableStyleNormalization = true;
		result.ext = {
			...ext,
			superdoc: superdocExt
		};
	}
	return result;
}
function projectTableRow(pmNode, options) {
	const cells = [];
	pmNode.forEach((child) => {
		if (child.type.name === "tableCell" || child.type.name === "tableHeader") cells.push(projectTableCell(child, options));
	});
	const row = { cells };
	const attrs = pmNode.attrs;
	if (attrs?.minHeight !== void 0 || attrs?.cantSplit !== void 0) {
		row.props = {};
		if (attrs.minHeight !== void 0) row.props.minHeight = attrs.minHeight;
		if (attrs.cantSplit !== void 0) row.props.cantSplit = attrs.cantSplit;
	}
	return row;
}
function projectTableCell(pmNode, options) {
	const attrs = pmNode.attrs;
	const content = [];
	pmNode.forEach((child) => {
		content.push(projectBlock(child, options));
	});
	const cell = { content };
	if (attrs?.colspan && attrs.colspan > 1) cell.colSpan = attrs.colspan;
	if (attrs?.rowspan && attrs.rowspan > 1) cell.rowSpan = attrs.rowspan;
	const vAlign = (attrs?.tableCellProperties)?.vAlign ?? attrs?.verticalAlign;
	if (vAlign) cell.props = { verticalAlign: vAlign };
	return cell;
}
function projectList(pmNode, ordered, options) {
	const items = [];
	pmNode.forEach((child) => {
		if (child.type.name === "listItem") items.push(projectListItem(child, options));
	});
	const result = {
		kind: "list",
		id: resolveNodeId(pmNode),
		list: {
			items,
			levels: [{
				level: 0,
				kind: ordered ? "ordered" : "bullet"
			}]
		}
	};
	const attrs = pmNode.attrs;
	if (attrs?.listStyleId) result.list.styleRef = attrs.listStyleId;
	return result;
}
function projectListItem(pmNode, options) {
	const content = [];
	pmNode.forEach((child) => {
		content.push(projectBlock(child, options));
	});
	return {
		level: pmNode.attrs?.level ?? 0,
		content
	};
}
function projectListItemAsContent(pmNode, options) {
	const inlines = projectInlineChildren(pmNode, options);
	return {
		kind: "paragraph",
		id: resolveNodeId(pmNode),
		paragraph: { inlines }
	};
}
function projectBlockImage(pmNode) {
	const attrs = pmNode.attrs;
	return {
		kind: "image",
		id: resolveNodeId(pmNode),
		image: {
			src: attrs?.src ?? "",
			...attrs?.alt ? { alt: attrs.alt } : {},
			...attrs?.size ? { geometry: {
				width: attrs.size.width,
				height: attrs.size.height
			} } : {}
		}
	};
}
function projectToc(pmNode) {
	const instruction = pmNode.attrs?.instruction ?? "";
	const config = parseTocInstruction(instruction);
	return {
		kind: "toc",
		id: resolveNodeId(pmNode),
		toc: {
			...instruction ? { instruction } : {},
			...config.source ? { sourceConfig: config.source } : {},
			...config.display ? { displayConfig: config.display } : {},
			...config.preserved ? { preservedSwitches: config.preserved } : {},
			entryCount: pmNode.childCount
		}
	};
}
var LOCK_MODE_TO_SDT_LOCK = {
	unlocked: "none",
	sdtLocked: "sdt",
	contentLocked: "content",
	sdtContentLocked: "both"
};
function extractSdtMetadata(attrs) {
	const lock = LOCK_MODE_TO_SDT_LOCK[attrs.lockMode];
	const controlType = attrs.controlType ?? attrs.type;
	return {
		...attrs.tag ? { tag: attrs.tag } : {},
		...attrs.alias ? { alias: attrs.alias } : {},
		...typeof controlType === "string" ? { type: controlType } : {},
		...attrs.appearance ? { appearance: attrs.appearance } : {},
		...attrs.placeholder ? { placeholder: attrs.placeholder } : {},
		...lock && lock !== "none" ? { lock } : {}
	};
}
function projectBlockSdt(pmNode, options) {
	const children = [];
	pmNode.forEach((child) => {
		children.push(projectBlock(child, options));
	});
	return {
		kind: "sdt",
		id: resolveSdtNodeId(pmNode),
		sdt: {
			...extractSdtMetadata(pmNode.attrs ?? {}),
			scope: "block",
			...children.length > 0 ? { content: children } : {}
		}
	};
}
function projectInlineSdt(pmNode, options) {
	const inlines = projectInlineChildren(pmNode, options);
	return {
		kind: "sdt",
		id: resolveSdtNodeId(pmNode),
		sdt: {
			...extractSdtMetadata(pmNode.attrs ?? {}),
			scope: "inline",
			...inlines.length > 0 ? { inlines } : {}
		}
	};
}
function projectSectionBreak(pmNode) {
	return {
		kind: "sectionBreak",
		id: resolveNodeId(pmNode),
		sectionBreak: { targetSectionId: pmNode.attrs?.targetSectionId ?? "" }
	};
}
function projectBreak(pmNode) {
	const breakType = pmNode.attrs?.breakType ?? "page";
	return {
		kind: "break",
		id: resolveNodeId(pmNode),
		break: { type: breakType === "column" ? "column" : "page" }
	};
}
function projectBlockDrawing(pmNode) {
	return {
		kind: "drawing",
		id: resolveNodeId(pmNode),
		drawing: {
			source: pmNode.attrs?.source ?? { type: "unknown" },
			...pmNode.attrs?.geometry ? { geometry: pmNode.attrs.geometry } : {},
			...pmNode.attrs?.layout ? { layout: pmNode.attrs.layout } : {}
		}
	};
}
function projectFallbackBlock(pmNode, options) {
	const inlines = projectInlineChildren(pmNode, options);
	return {
		kind: "paragraph",
		id: resolveNodeId(pmNode),
		paragraph: { inlines }
	};
}
function projectInlineChildren(pmNode, options) {
	const inlines = [];
	pmNode.forEach((child) => {
		const projected = projectInline(child, options);
		if (projected) inlines.push(projected);
	});
	return inlines;
}
function projectInline(pmNode, options) {
	if (pmNode.isText) return projectTextRun(pmNode, options);
	switch (pmNode.type.name) {
		case "run": return projectRunNode(pmNode, options);
		case "image": return projectInlineImage(pmNode);
		case "tab": return projectTab();
		case "hardBreak":
		case "lineBreak": return projectLineBreak();
		case "footnoteRef":
		case "footnoteReference": return projectFootnoteRef(pmNode);
		case "endnoteRef":
		case "endnoteReference": return projectEndnoteRef(pmNode);
		case "field": return projectInlineField(pmNode);
		case "structuredContent": return projectInlineSdt(pmNode, options);
		default: return projectInlineFallback(pmNode, options);
	}
}
function projectRunNode(pmNode, options) {
	const runProperties = (pmNode.attrs ?? {}).runProperties;
	const text = isVisibleProjection(options) ? textContentInBlock(pmNode, options) : pmNode.textContent;
	if (isVisibleProjection(options) && text.length === 0) return null;
	let linkMark;
	pmNode.forEach((child) => {
		if (!linkMark) linkMark = child.marks?.find((m$1) => m$1.type.name === "link");
	});
	if (linkMark) return buildHyperlinkFromRunNode(pmNode, linkMark, options);
	const run = {
		kind: "run",
		run: { text }
	};
	const styleRef = typeof runProperties?.rStyle === "string" ? runProperties.rStyle : typeof runProperties?.styleId === "string" ? runProperties.styleId : void 0;
	if (styleRef) run.run.styleRef = styleRef;
	const props = extractRunPropsFromRunProperties(runProperties);
	if (props) run.run.props = props;
	return run;
}
function buildHyperlinkFromRunNode(pmNode, linkMark, options) {
	const attrs = linkMark.attrs;
	const text = isVisibleProjection(options) ? textContentInBlock(pmNode, options) : pmNode.textContent;
	if (isVisibleProjection(options) && text.length === 0) return null;
	const childRun = {
		kind: "run",
		run: { text }
	};
	const runProperties = pmNode.attrs?.runProperties;
	const props = extractRunPropsFromRunProperties(runProperties);
	if (props) childRun.run.props = props;
	return {
		kind: "hyperlink",
		hyperlink: {
			...typeof attrs.href === "string" ? { href: attrs.href } : {},
			...typeof attrs.anchor === "string" ? { anchor: attrs.anchor } : {},
			...typeof attrs.tooltip === "string" ? { tooltip: attrs.tooltip } : {},
			inlines: [childRun]
		}
	};
}
function extractRunPropsFromRunProperties(runProperties) {
	if (!runProperties) return void 0;
	const props = {};
	let hasProps = false;
	const resolveBool = (v) => {
		if (typeof v === "boolean") return v;
		if (v && typeof v === "object") {
			const obj = v;
			const val = obj.val ?? obj.value;
			if (typeof val === "boolean") return val;
			if (typeof val === "string") return val !== "0" && val !== "false" && val !== "none";
			return true;
		}
		if (typeof v === "string") return v !== "0" && v !== "false";
	};
	if (resolveBool(runProperties.bold ?? runProperties.b)) {
		props.bold = true;
		hasProps = true;
	}
	if (resolveBool(runProperties.italic ?? runProperties.i)) {
		props.italic = true;
		hasProps = true;
	}
	const underline = runProperties.underline ?? runProperties.u;
	if (underline !== void 0 && underline !== "none" && underline !== false) {
		props.underline = typeof underline === "object" ? underline : { style: "single" };
		hasProps = true;
	}
	if (resolveBool(runProperties.strike ?? runProperties.dstrike)) {
		props.strikethrough = true;
		hasProps = true;
	}
	if (runProperties.highlight) {
		const h$2 = runProperties.highlight;
		const color = typeof h$2 === "string" ? h$2 : h$2?.val ?? h$2?.color;
		if (typeof color === "string") {
			props.highlight = color;
			hasProps = true;
		}
	}
	if (runProperties.color) {
		const c = runProperties.color;
		props.color = typeof c === "string" ? {
			model: "rgb",
			value: c
		} : c;
		hasProps = true;
	}
	const sz = runProperties.sz ?? runProperties.size ?? runProperties.fontSize;
	if (typeof sz === "number") {
		props.fontSize = sz;
		hasProps = true;
	} else if (typeof sz === "string") {
		const parsed = Number.parseFloat(sz);
		if (Number.isFinite(parsed)) {
			props.fontSize = parsed;
			hasProps = true;
		}
	}
	const rFonts = runProperties.rFonts ?? runProperties.fontFamily;
	if (rFonts) {
		if (typeof rFonts === "string") {
			props.fontFamily = rFonts;
			hasProps = true;
		} else if (typeof rFonts === "object") {
			const selected = rFonts.ascii ?? rFonts.hAnsi ?? rFonts.eastAsia ?? rFonts.cs;
			if (typeof selected === "string") {
				props.fontFamily = selected;
				hasProps = true;
			}
			props.fonts = rFonts;
			hasProps = true;
		}
	}
	const lang = runProperties.lang;
	if (lang) {
		props.lang = typeof lang === "string" ? { val: lang } : lang;
		hasProps = true;
	}
	if (resolveBool(runProperties.caps)) {
		props.caps = true;
		hasProps = true;
	}
	if (resolveBool(runProperties.smallCaps)) {
		props.smallCaps = true;
		hasProps = true;
	}
	if (resolveBool(runProperties.vanish)) {
		props.vanish = true;
		hasProps = true;
	}
	return hasProps ? props : void 0;
}
function projectTextRun(pmNode, options) {
	if (isVisibleProjection(options) && hasTrackDeleteMark$1(pmNode)) return null;
	const marks = pmNode.marks;
	const linkMark = marks.find((m$1) => m$1.type.name === "link");
	if (linkMark) return projectHyperlinkFromMark(pmNode, linkMark);
	const run = {
		kind: "run",
		run: { text: pmNode.text ?? "" }
	};
	const styleRef = extractRunStyleRef(marks);
	if (styleRef) run.run.styleRef = styleRef;
	const props = extractRunProps(marks);
	if (props) run.run.props = props;
	return run;
}
function projectHyperlinkFromMark(pmNode, linkMark) {
	const attrs = linkMark.attrs;
	const childRun = {
		kind: "run",
		run: { text: pmNode.text ?? "" }
	};
	const otherMarks = pmNode.marks.filter((m$1) => m$1 !== linkMark);
	const props = extractRunPropsFromMarks(otherMarks);
	if (props) childRun.run.props = props;
	const styleRef = extractRunStyleRefFromMarks(otherMarks);
	if (styleRef) childRun.run.styleRef = styleRef;
	return {
		kind: "hyperlink",
		hyperlink: {
			...typeof attrs.href === "string" ? { href: attrs.href } : {},
			...typeof attrs.anchor === "string" ? { anchor: attrs.anchor } : {},
			...typeof attrs.tooltip === "string" ? { tooltip: attrs.tooltip } : {},
			inlines: [childRun]
		}
	};
}
function projectInlineImage(pmNode) {
	const attrs = pmNode.attrs;
	return {
		kind: "image",
		image: {
			src: attrs?.src ?? "",
			...attrs?.alt ? { alt: attrs.alt } : {},
			...attrs?.size ? { geometry: {
				width: attrs.size.width,
				height: attrs.size.height
			} } : {}
		}
	};
}
function projectTab() {
	return {
		kind: "tab",
		tab: {}
	};
}
function projectLineBreak() {
	return {
		kind: "lineBreak",
		lineBreak: {}
	};
}
function projectFootnoteRef(pmNode) {
	return {
		kind: "footnoteRef",
		footnoteRef: {
			...pmNode.attrs?.id ? { noteId: pmNode.attrs.id } : {},
			...pmNode.attrs?.noteId ? { noteId: pmNode.attrs.noteId } : {}
		}
	};
}
function projectEndnoteRef(pmNode) {
	return {
		kind: "endnoteRef",
		endnoteRef: {
			...pmNode.attrs?.id ? { noteId: pmNode.attrs.id } : {},
			...pmNode.attrs?.noteId ? { noteId: pmNode.attrs.noteId } : {}
		}
	};
}
function projectInlineField(pmNode) {
	return {
		kind: "field",
		field: {
			...pmNode.attrs?.fieldType ? { fieldType: pmNode.attrs.fieldType } : {},
			...pmNode.attrs?.instruction ? { instruction: pmNode.attrs.instruction } : {},
			...pmNode.attrs?.resultText ? { resultText: pmNode.attrs.resultText } : {},
			placement: "inline"
		}
	};
}
function projectInlineFallback(pmNode, options) {
	const text = isVisibleProjection(options) ? textContentInBlock(pmNode, options) : pmNode.textContent ?? "￼";
	if (isVisibleProjection(options) && text.length === 0) return null;
	return {
		kind: "run",
		run: { text }
	};
}
function resolveNodeId(pmNode) {
	const id = pmNode.attrs?.sdBlockId;
	return typeof id === "string" && id.length > 0 ? id : void 0;
}
function resolveSdtNodeId(pmNode) {
	const attrs = pmNode.attrs ?? {};
	const id = attrs.id ?? attrs.sdBlockId;
	if (typeof id === "number") return String(id);
	return typeof id === "string" && id.length > 0 ? id : void 0;
}
function isRecord(value) {
	return value !== null && typeof value === "object" && !Array.isArray(value);
}
function extractTableProps(attrs, pmAttrs) {
	const tableProps = attrs?.tableProperties;
	const props = {};
	let hasProps = false;
	const width = extractTableWidth(tableProps?.tableWidth ?? pmAttrs?.tableWidth);
	if (width) {
		props.width = width;
		hasProps = true;
	}
	const layout = tableProps?.tableLayout ?? pmAttrs?.tableLayout;
	if (layout === "fixed" || layout === "autofit") {
		props.layout = layout;
		hasProps = true;
	}
	const alignment$1 = mapTableAlignmentToSD(tableProps?.justification ?? pmAttrs?.justification);
	if (alignment$1) {
		props.alignment = alignment$1;
		hasProps = true;
	}
	return hasProps ? props : void 0;
}
function mapTableAlignmentToSD(value) {
	if (typeof value !== "string") return void 0;
	switch (value) {
		case "start":
		case "left": return "left";
		case "end":
		case "right": return "right";
		case "center":
		case "inside":
		case "outside": return value;
		default: return;
	}
}
function extractTableWidth(width) {
	if (!isRecord(width)) return void 0;
	const type = typeof width.type === "string" ? width.type.toLowerCase() : void 0;
	const value = typeof width.value === "number" ? width.value : typeof width.width === "number" ? width.width : void 0;
	if (type === "auto") return { kind: "auto" };
	if (type === "nil" || type === "none") return { kind: "none" };
	if (type === "pct" && typeof value === "number" && Number.isFinite(value)) return {
		kind: "percent",
		value
	};
	if (type === "dxa" && typeof value === "number" && Number.isFinite(value)) return {
		kind: "points",
		value: value / 20
	};
	if (typeof value === "number" && Number.isFinite(value)) return {
		kind: "points",
		value
	};
}
function extractParagraphProps(attrs) {
	const pp = attrs?.paragraphProperties;
	if (!pp) return void 0;
	const ppAny = pp;
	const props = {};
	let hasProps = false;
	if (pp.justification) {
		props.alignment = pp.justification === "both" ? "justify" : pp.justification;
		hasProps = true;
	}
	if (pp.indent) {
		props.indent = pp.indent;
		hasProps = true;
	}
	if (pp.spacing) {
		props.spacing = pp.spacing;
		hasProps = true;
	}
	if (pp.keepNext !== void 0) {
		props.keepWithNext = pp.keepNext;
		hasProps = true;
	}
	if (pp.keepLines !== void 0) {
		props.keepLines = pp.keepLines;
		hasProps = true;
	}
	if (pp.pageBreakBefore !== void 0) {
		props.pageBreakBefore = pp.pageBreakBefore;
		hasProps = true;
	}
	if (pp.widowControl !== void 0) {
		props.widowControl = pp.widowControl;
		hasProps = true;
	}
	if (pp.outlineLvl !== void 0) {
		props.outlineLevel = pp.outlineLvl;
		hasProps = true;
	}
	if (pp.numberingProperties) {
		props.numbering = {
			numId: String(pp.numberingProperties.numId ?? ""),
			level: pp.numberingProperties.ilvl
		};
		hasProps = true;
	}
	if (ppAny.tabs) {
		props.tabs = ppAny.tabs;
		hasProps = true;
	}
	if (ppAny.borders) {
		props.borders = ppAny.borders;
		hasProps = true;
	}
	if (ppAny.shading) {
		props.shading = ppAny.shading;
		hasProps = true;
	}
	if (ppAny.rightToLeft !== void 0) {
		props.bidi = ppAny.rightToLeft;
		hasProps = true;
	}
	if (ppAny.markRunProps) {
		props.markRunProps = ppAny.markRunProps;
		hasProps = true;
	}
	return hasProps ? props : void 0;
}
function extractRunStyleRef(marks) {
	return extractRunStyleRefFromMarks(marks);
}
function extractRunStyleRefFromMarks(marks) {
	const textStyle = marks.find((m$1) => m$1.type.name === "textStyle");
	if (!textStyle) return void 0;
	return typeof textStyle.attrs?.rStyle === "string" ? textStyle.attrs.rStyle : void 0;
}
function extractRunProps(marks) {
	return extractRunPropsFromMarks(marks);
}
function extractRunPropsFromMarks(marks) {
	const props = {};
	let hasProps = false;
	for (const mark of marks) switch (mark.type.name) {
		case "bold":
			props.bold = true;
			hasProps = true;
			break;
		case "italic":
			props.italic = true;
			hasProps = true;
			break;
		case "underline":
			props.underline = mark.attrs && typeof mark.attrs === "object" && Object.keys(mark.attrs).length > 0 ? mark.attrs : { style: "single" };
			hasProps = true;
			break;
		case "strikethrough":
			props.strikethrough = true;
			hasProps = true;
			break;
		case "highlight": {
			const color = mark.attrs?.color;
			if (typeof color === "string") {
				props.highlight = color;
				hasProps = true;
			}
			break;
		}
		case "textStyle": {
			const a = mark.attrs;
			if (!a) break;
			if (a.color) {
				props.color = a.color;
				hasProps = true;
			}
			if (a.fontSize !== void 0) {
				props.fontSize = a.fontSize;
				hasProps = true;
			}
			if (a.fontSizeCs !== void 0) {
				props.fontSizeCs = a.fontSizeCs;
				hasProps = true;
			}
			if (a.fontFamily) {
				props.fontFamily = a.fontFamily;
				hasProps = true;
			}
			if (a.fonts) {
				props.fonts = a.fonts;
				hasProps = true;
			}
			if (a.caps) {
				props.caps = true;
				hasProps = true;
			}
			if (a.smallCaps) {
				props.smallCaps = true;
				hasProps = true;
			}
			if (a.vanish) {
				props.vanish = true;
				hasProps = true;
			}
			if (a.characterSpacing !== void 0) {
				props.characterSpacing = a.characterSpacing;
				hasProps = true;
			}
			break;
		}
	}
	return hasProps ? props : void 0;
}
function getAdapter(editor, input) {
	return projectDocument(editor, input.options);
}
function resolveMeasurement(value) {
	if (typeof value === "number") return value;
	if (value && typeof value === "object" && typeof value.value === "number") return value.value;
}
function mapTableAlignment(justification) {
	switch (justification) {
		case "start": return "left";
		case "end": return "right";
		case "left":
		case "center":
		case "right": return justification;
		default: return;
	}
}
function mapParagraphProperties(attrs) {
	const props = attrs?.paragraphProperties ?? void 0;
	const indentation = props?.indent ? {
		left: props.indent.left,
		right: props.indent.right,
		firstLine: props.indent.firstLine,
		hanging: props.indent.hanging
	} : void 0;
	const spacing = props?.spacing ? {
		before: props.spacing.before,
		after: props.spacing.after,
		line: props.spacing.line
	} : void 0;
	const justification = props?.justification;
	const alignment$1 = justification === "both" ? "justify" : justification;
	const paragraphNumbering = props?.numberingProperties ? {
		numId: toFiniteNumber(props.numberingProperties.numId),
		level: toFiniteNumber(props.numberingProperties.ilvl)
	} : void 0;
	return {
		styleId: props?.styleId ?? void 0,
		alignment: alignment$1 ?? void 0,
		indentation,
		spacing,
		keepWithNext: props?.keepNext ?? void 0,
		outlineLevel: props?.outlineLvl ?? void 0,
		paragraphNumbering
	};
}
function mapListNumbering(attrs) {
	const listRendering = getListRendering(attrs?.listRendering);
	if (!listRendering) return void 0;
	const listNumbering = {};
	if (listRendering.markerText) listNumbering.marker = listRendering.markerText;
	if (Array.isArray(listRendering.path)) listNumbering.path = listRendering.path;
	listNumbering.ordinal = getListOrdinalFromPath(listRendering.path);
	return Object.keys(listNumbering).length ? listNumbering : void 0;
}
function mapParagraphNode(candidate) {
	const attrs = candidate.node.attrs;
	return {
		nodeType: "paragraph",
		kind: "block",
		properties: mapParagraphProperties(attrs)
	};
}
function mapHeadingNode(candidate) {
	const attrs = candidate.node.attrs;
	const baseProps = mapParagraphProperties(attrs);
	const headingLevelCandidate = getHeadingLevel$1(attrs?.paragraphProperties?.styleId) ?? (baseProps.outlineLevel != null ? baseProps.outlineLevel + 1 : void 0);
	if (!headingLevelCandidate || headingLevelCandidate < 1 || headingLevelCandidate > 6) throw new DocumentApiAdapterError("INVALID_TARGET", `Node "${candidate.nodeId}" does not have a valid heading level.`);
	return {
		nodeType: "heading",
		kind: "block",
		properties: {
			...baseProps,
			headingLevel: headingLevelCandidate
		}
	};
}
function mapListItemNode(candidate) {
	const attrs = candidate.node.attrs;
	return {
		nodeType: "listItem",
		kind: "block",
		properties: {
			...mapParagraphProperties(attrs),
			numbering: mapListNumbering(attrs)
		}
	};
}
function mapTableNode(candidate) {
	const tableProps = candidate.node.attrs?.tableProperties ?? void 0;
	return {
		nodeType: "table",
		kind: "block",
		properties: {
			layout: tableProps?.tableLayout ?? void 0,
			width: resolveMeasurement(tableProps?.tableWidth ?? null) ?? void 0,
			alignment: mapTableAlignment(tableProps?.justification)
		}
	};
}
function mapTableRowNode() {
	return {
		nodeType: "tableRow",
		kind: "block",
		properties: {}
	};
}
function mapTableCellNode(candidate) {
	const attrs = candidate.node.attrs;
	const cellProps = attrs?.tableCellProperties ?? void 0;
	return {
		nodeType: "tableCell",
		kind: "block",
		properties: {
			width: resolveMeasurement(cellProps?.cellWidth ?? null) ?? (Array.isArray(attrs?.colwidth) && attrs.colwidth.length > 0 ? attrs.colwidth[0] : void 0),
			shading: cellProps?.shading?.fill ?? attrs?.background?.color ?? void 0,
			vMerge: cellProps?.vMerge === "continue" || cellProps?.vMerge === "restart" ? true : attrs?.rowspan && attrs.rowspan > 1 ? true : void 0,
			gridSpan: cellProps?.gridSpan ?? attrs?.colspan ?? void 0,
			padding: resolveMeasurement(cellProps?.cellMargins?.top ?? null) ?? resolveMeasurement(attrs?.cellMargins?.top ?? null)
		}
	};
}
function mapTableOfContentsNode(candidate) {
	const node = candidate.node;
	const instruction = node.attrs?.instruction ?? "";
	const config = parseTocInstruction(instruction);
	const entryCount = node.childCount;
	return {
		nodeType: "tableOfContents",
		kind: "block",
		properties: {
			instruction,
			sourceConfig: config.source,
			displayConfig: config.display,
			preservedSwitches: config.preserved,
			entryCount
		}
	};
}
function parseCropFromClipPath$1(clipPath) {
	if (!clipPath) return null;
	const match$1 = clipPath.match(/^inset\(\s*([\d.]+)%\s+([\d.]+)%\s+([\d.]+)%\s+([\d.]+)%\s*\)$/);
	if (!match$1) return null;
	return {
		top: parseFloat(match$1[1]),
		right: parseFloat(match$1[2]),
		bottom: parseFloat(match$1[3]),
		left: parseFloat(match$1[4])
	};
}
function detectCaptionSibling(doc$1, imagePos) {
	if (!doc$1) return false;
	try {
		const $pos = doc$1.resolve(imagePos);
		const parentDepth = $pos.depth - 1;
		if (parentDepth < 0) return false;
		const afterParentPos = $pos.before(parentDepth + 1) + $pos.node(parentDepth + 1).nodeSize;
		if (afterParentPos >= doc$1.content.size) return false;
		const nextNode = doc$1.nodeAt(afterParentPos);
		if (!nextNode || nextNode.type.name !== "paragraph") return false;
		return nextNode.attrs?.paragraphProperties?.styleId === "Caption";
	} catch {
		return false;
	}
}
function buildImageInfo(attrs, kind, doc$1, pos) {
	const isFloating = Boolean(attrs?.isAnchor);
	const wrapObj = attrs?.wrap;
	const td = attrs?.transformData;
	const transform = td && (td.rotation || td.verticalFlip || td.horizontalFlip) ? {
		rotation: td.rotation ?? void 0,
		verticalFlip: td.verticalFlip ?? void 0,
		horizontalFlip: td.horizontalFlip ?? void 0
	} : null;
	return {
		nodeType: "image",
		kind,
		properties: {
			src: attrs?.src ?? void 0,
			alt: attrs?.alt ?? void 0,
			size: attrs?.size ? {
				width: attrs.size.width,
				height: attrs.size.height,
				unit: void 0
			} : void 0,
			placement: isFloating ? "floating" : "inline",
			wrap: {
				type: wrapObj?.type ?? "Inline",
				attrs: wrapObj?.attrs ?? void 0
			},
			anchorData: attrs?.anchorData ?? null,
			marginOffset: attrs?.marginOffset ?? null,
			relativeHeight: attrs?.relativeHeight ?? null,
			name: attrs?.alt ?? void 0,
			description: attrs?.title ?? void 0,
			transform,
			crop: parseCropFromClipPath$1(attrs?.clipPath),
			lockAspectRatio: attrs?.lockAspectRatio ?? true,
			decorative: attrs?.decorative ?? false,
			hyperlink: attrs?.hyperlink ?? null,
			hasCaption: pos != null ? detectCaptionSibling(doc$1, pos) : false
		}
	};
}
function mapHyperlinkNode(candidate) {
	const attrs = candidate.mark?.attrs ?? candidate.attrs ?? {};
	return {
		nodeType: "hyperlink",
		kind: "inline",
		properties: {
			href: typeof attrs.href === "string" ? attrs.href : void 0,
			anchor: typeof attrs.anchor === "string" ? attrs.anchor : typeof attrs.docLocation === "string" ? attrs.docLocation : void 0,
			tooltip: typeof attrs.tooltip === "string" ? attrs.tooltip : void 0
		}
	};
}
function mapCommentNode(candidate) {
	const commentId = resolveCommentIdFromAttrs(candidate.mark?.attrs ?? candidate.attrs ?? {});
	if (!commentId) throw new DocumentApiAdapterError("INVALID_TARGET", "Comment node is missing a commentId attribute.");
	return {
		nodeType: "comment",
		kind: "inline",
		properties: { commentId }
	};
}
function mapBookmarkNode(candidate) {
	const attrs = candidate.attrs ?? candidate.node?.attrs ?? {};
	return {
		nodeType: "bookmark",
		kind: "inline",
		properties: {
			name: typeof attrs.name === "string" ? attrs.name : void 0,
			bookmarkId: typeof attrs.id === "string" ? attrs.id : void 0
		}
	};
}
function mapFootnoteRefNode(candidate) {
	const attrs = candidate.node?.attrs ?? candidate.attrs ?? {};
	return {
		nodeType: "footnoteRef",
		kind: "inline",
		properties: { noteId: typeof attrs.id === "string" ? attrs.id : void 0 }
	};
}
function parseBooleanToken(value) {
	const normalized = value.trim().toLowerCase();
	if (!normalized) return void 0;
	if (normalized === "0" || normalized === "false" || normalized === "off" || normalized === "none") return false;
	if (normalized === "1" || normalized === "true" || normalized === "on" || normalized === "single") return true;
}
function resolveBooleanLike(value) {
	if (typeof value === "boolean") return value;
	if (typeof value === "number") return value !== 0;
	if (typeof value === "string") return parseBooleanToken(value);
	if (value && typeof value === "object") {
		const record = value;
		const explicit = resolveBooleanLike(record.val ?? record.value ?? record.type ?? record["w:val"] ?? record["w:value"]);
		if (explicit != null) return explicit;
		return true;
	}
}
function resolveUnderlineLike(values) {
	for (const value of values) {
		if (value == null) continue;
		if (typeof value === "string") {
			const normalized = value.trim().toLowerCase();
			if (!normalized) continue;
			return normalized !== "none" && normalized !== "false" && normalized !== "0";
		}
		const resolved = resolveBooleanLike(value);
		if (resolved != null) return resolved;
	}
}
function resolveColorValue(value) {
	if (typeof value === "string") return value;
	if (value && typeof value === "object") {
		const record = value;
		if (typeof record.val === "string") return record.val;
		if (typeof record.value === "string") return record.value;
		if (typeof record["w:val"] === "string") return record["w:val"];
	}
}
function resolveHighlightValue(value) {
	if (typeof value === "string") return value;
	if (value && typeof value === "object") {
		const record = value;
		const highlightValue = record.val ?? record.value ?? record["w:val"];
		if (typeof highlightValue === "string") {
			const normalized = highlightValue.trim();
			if (!normalized) return void 0;
			if (normalized.toLowerCase() === "none") return "transparent";
			return normalized;
		}
		const fill = record.fill ?? record["w:fill"];
		if (typeof fill === "string") {
			const normalized = fill.trim();
			if (!normalized || normalized.toLowerCase() === "auto") return void 0;
			return normalized.startsWith("#") ? normalized : `#${normalized}`;
		}
	}
}
function resolveFontValue(runProperties) {
	const fromRFonts = runProperties.rFonts;
	if (fromRFonts && typeof fromRFonts === "object") {
		const fonts = fromRFonts;
		const selected = fonts.ascii ?? fonts.hAnsi ?? fonts.eastAsia ?? fonts.cs;
		if (typeof selected === "string") return selected;
	}
	const fromFontFamily = runProperties.fontFamily;
	if (typeof fromFontFamily === "string") return fromFontFamily;
	if (fromFontFamily && typeof fromFontFamily === "object") {
		const fonts = fromFontFamily;
		const selected = fonts.ascii ?? fonts.hAnsi ?? fonts.eastAsia ?? fonts.cs;
		if (typeof selected === "string") return selected;
	}
}
function resolveFontSizeValue(runProperties) {
	const candidate = runProperties.sz ?? runProperties.size ?? runProperties.fontSize;
	if (typeof candidate === "number") return candidate;
	if (typeof candidate === "string") {
		const parsed = Number.parseFloat(candidate);
		return Number.isFinite(parsed) ? parsed : void 0;
	}
}
function mapRunNode(candidate) {
	const attrs = candidate.node?.attrs ?? candidate.attrs ?? {};
	const runProperties = attrs.runProperties && typeof attrs.runProperties === "object" ? attrs.runProperties : void 0;
	const underline = resolveUnderlineLike([runProperties?.underline, runProperties?.u]);
	const strike = resolveBooleanLike(runProperties?.strike) ?? resolveBooleanLike(runProperties?.dstrike) ?? void 0;
	const languageRaw = runProperties?.lang;
	const language = typeof languageRaw === "string" ? languageRaw : languageRaw && typeof languageRaw === "object" && typeof languageRaw.val === "string" ? languageRaw.val : void 0;
	return {
		nodeType: "run",
		kind: "inline",
		properties: {
			bold: resolveBooleanLike(runProperties?.bold) ?? void 0,
			italic: resolveBooleanLike(runProperties?.italic) ?? void 0,
			underline: underline ?? void 0,
			strike,
			font: runProperties ? resolveFontValue(runProperties) : void 0,
			size: runProperties ? resolveFontSizeValue(runProperties) : void 0,
			color: resolveColorValue(runProperties?.color),
			highlight: resolveHighlightValue(runProperties?.highlight),
			styleId: typeof runProperties?.rStyle === "string" ? runProperties.rStyle : typeof runProperties?.styleId === "string" ? runProperties.styleId : void 0,
			language
		}
	};
}
function mapTabNode() {
	return {
		nodeType: "tab",
		kind: "inline",
		properties: {}
	};
}
function mapLineBreakNode() {
	return {
		nodeType: "lineBreak",
		kind: "inline",
		properties: {}
	};
}
function isInlineCandidate(candidate) {
	return "anchor" in candidate;
}
function mapNodeInfo(candidate, overrideType, doc$1) {
	const nodeType = overrideType ?? candidate.nodeType;
	const kind = isInlineCandidate(candidate) ? "inline" : "block";
	switch (nodeType) {
		case "paragraph":
			if (kind !== "block") throw new DocumentApiAdapterError("INVALID_TARGET", "Paragraph nodes can only be resolved as blocks.");
			return mapParagraphNode(candidate);
		case "heading":
			if (kind !== "block") throw new DocumentApiAdapterError("INVALID_TARGET", "Heading nodes can only be resolved as blocks.");
			return mapHeadingNode(candidate);
		case "listItem":
			if (kind !== "block") throw new DocumentApiAdapterError("INVALID_TARGET", "ListItem nodes can only be resolved as blocks.");
			return mapListItemNode(candidate);
		case "table":
			if (kind !== "block") throw new DocumentApiAdapterError("INVALID_TARGET", "Table nodes can only be resolved as blocks.");
			return mapTableNode(candidate);
		case "tableRow":
			if (kind !== "block") throw new DocumentApiAdapterError("INVALID_TARGET", "TableRow nodes can only be resolved as blocks.");
			return mapTableRowNode();
		case "tableCell":
			if (kind !== "block") throw new DocumentApiAdapterError("INVALID_TARGET", "TableCell nodes can only be resolved as blocks.");
			return mapTableCellNode(candidate);
		case "image": {
			const attrs = candidate.node?.attrs;
			return buildImageInfo(attrs, kind, doc$1, candidate.pos);
		}
		case "sdt": {
			const attrs = candidate.node?.attrs;
			return buildContentControlInfoFromAttrs(attrs, kind);
		}
		case "tableOfContents":
			if (kind !== "block") throw new DocumentApiAdapterError("INVALID_TARGET", "TableOfContents nodes can only be resolved as blocks.");
			return mapTableOfContentsNode(candidate);
		case "hyperlink":
			if (!isInlineCandidate(candidate)) throw new DocumentApiAdapterError("INVALID_TARGET", "Hyperlink nodes can only be resolved inline.");
			return mapHyperlinkNode(candidate);
		case "comment":
			if (!isInlineCandidate(candidate)) throw new DocumentApiAdapterError("INVALID_TARGET", "Comment nodes can only be resolved inline.");
			return mapCommentNode(candidate);
		case "run":
			if (!isInlineCandidate(candidate)) throw new DocumentApiAdapterError("INVALID_TARGET", "Run nodes can only be resolved inline.");
			return mapRunNode(candidate);
		case "bookmark":
			if (!isInlineCandidate(candidate)) throw new DocumentApiAdapterError("INVALID_TARGET", "Bookmark nodes can only be resolved inline.");
			return mapBookmarkNode(candidate);
		case "footnoteRef":
			if (!isInlineCandidate(candidate)) throw new DocumentApiAdapterError("INVALID_TARGET", "Footnote references can only be resolved inline.");
			return mapFootnoteRefNode(candidate);
		case "tab": return mapTabNode();
		case "lineBreak": return mapLineBreakNode();
		default: throw new DocumentApiAdapterError("INVALID_TARGET", `Node type "${nodeType}" is not implemented yet.`);
	}
}
function resolveNodeInfoForAddress(editor, index, address, inlineIndex) {
	if (address.kind === "block") {
		const candidate$1 = findBlockById(index, address);
		if (!candidate$1) return void 0;
		return mapNodeInfo(candidate$1, address.nodeType, editor.state.doc);
	}
	const candidate = findInlineByAnchor(inlineIndex ?? getInlineIndex(editor), address);
	if (!candidate) return void 0;
	return mapNodeInfo(candidate, address.nodeType);
}
function resolveIncludedNodes(editor, index, addresses) {
	const included = [];
	let inlineIndex;
	for (const address of addresses) {
		if (address.kind === "inline") {
			inlineIndex ??= getInlineIndex(editor);
			const info$1 = resolveNodeInfoForAddress(editor, index, address, inlineIndex);
			if (info$1) included.push(info$1);
			continue;
		}
		const info = resolveNodeInfoForAddress(editor, index, address);
		if (info) included.push(info);
	}
	return included;
}
function toInlineAddress(candidate, nodeTypeOverride) {
	return {
		kind: "inline",
		nodeType: nodeTypeOverride ?? candidate.nodeType,
		anchor: candidate.anchor
	};
}
function executeInlineSelector(editor, index, query, diagnostics) {
	const scope = resolveWithinScope(index, query, diagnostics);
	if (!scope.ok) return {
		matches: [],
		total: 0
	};
	const inlineIndex = getInlineIndex(editor);
	const select = query.select;
	let requestedType;
	let addressType;
	if (select.type === "node") {
		if (select.kind && select.kind !== "inline") {
			addDiagnostic(diagnostics, "Only inline nodes are supported by the current inline adapter.");
			return {
				matches: [],
				total: 0
			};
		}
		if (select.nodeType) {
			if (!isInlineQueryType(select.nodeType)) {
				addDiagnostic(diagnostics, `Node type "${select.nodeType}" is not an inline type.`);
				return {
					matches: [],
					total: 0
				};
			}
			requestedType = select.nodeType;
			addressType = select.nodeType;
		}
	} else return {
		matches: [],
		total: 0
	};
	let candidates = requestedType ? findInlineByType(inlineIndex, requestedType) : inlineIndex.candidates;
	candidates = scopeByRange(candidates, scope.range);
	const paged = paginate(candidates.map((candidate) => toInlineAddress(candidate, addressType)), query.offset, query.limit);
	return {
		matches: paged.items,
		total: paged.total
	};
}
function executeDualKindSelector(editor, index, query, diagnostics) {
	const queryWithoutPagination = {
		...query,
		offset: void 0,
		limit: void 0
	};
	const blockResult = executeBlockSelector(index, queryWithoutPagination, diagnostics);
	const inlineResult = executeInlineSelector(editor, index, queryWithoutPagination, diagnostics);
	const paged = paginate(sortAddressesByPosition(editor, index, [...blockResult.matches, ...inlineResult.matches]), query.offset, query.limit);
	return {
		matches: paged.items,
		total: paged.total
	};
}
function buildInlineRpr(marks) {
	const rpr = {};
	for (const mark of marks) switch (mark.type.name) {
		case "bold":
			rpr.bold = !isSimpleToggleOffValue(mark.attrs.value);
			break;
		case "italic":
			rpr.italic = !isSimpleToggleOffValue(mark.attrs.value);
			break;
		case "strike":
			rpr.strike = !isSimpleToggleOffValue(mark.attrs.value);
			break;
		case "underline": {
			const ut = mark.attrs.underlineType;
			if (ut === "none") rpr.underline = { "w:val": "none" };
			else if (ut) rpr.underline = { "w:val": ut };
			else rpr.underline = { "w:val": "single" };
			break;
		}
		case "runProperties":
			if (typeof mark.attrs.styleId === "string" && mark.attrs.styleId) rpr.styleId = mark.attrs.styleId;
			break;
	}
	return rpr;
}
function marksEqual(a, b$1) {
	if (a.length !== b$1.length) return false;
	for (let i = 0; i < a.length; i++) if (!a[i].eq(b$1[i])) return false;
	return true;
}
function coalesceRuns(runs) {
	if (runs.length === 0) return [];
	const sorted = [...runs].sort((a, b$1) => a.from - b$1.from);
	const result = [];
	let startIndex = 0;
	while (startIndex < sorted.length && sorted[startIndex].from >= sorted[startIndex].to) startIndex++;
	if (startIndex >= sorted.length) return [];
	let current = { ...sorted[startIndex] };
	for (let i = startIndex + 1; i < sorted.length; i++) {
		const next = sorted[i];
		if (next.from >= next.to) continue;
		if (next.from === current.to && marksEqual(current.marks, next.marks)) current = {
			from: current.from,
			to: next.to,
			charCount: current.charCount + next.charCount,
			marks: current.marks
		};
		else {
			if (current.charCount > 0) result.push(current);
			current = { ...next };
		}
	}
	if (current.charCount > 0) result.push(current);
	return result;
}
function toMatchStyle(marks, cascadeContext) {
	const boldDirect = deriveToggleState(marks, "bold");
	const italicDirect = deriveToggleState(marks, "italic");
	const underlineDirect = deriveToggleState(marks, "underline");
	const strikeDirect = deriveToggleState(marks, "strike");
	const direct = {
		bold: boldDirect,
		italic: italicDirect,
		underline: underlineDirect,
		strike: strikeDirect
	};
	const boldState = derivePropertyStateFromDirect(boldDirect);
	const italicState = derivePropertyStateFromDirect(italicDirect);
	const underlineState = derivePropertyStateFromDirect(underlineDirect);
	const strikeState = derivePropertyStateFromDirect(strikeDirect);
	const effective = {
		bold: boldState.effective,
		italic: italicState.effective,
		underline: underlineState.effective,
		strike: strikeState.effective
	};
	if (cascadeContext && (boldDirect === "clear" || italicDirect === "clear" || underlineDirect === "clear" || strikeDirect === "clear")) {
		const inlineRpr = buildInlineRpr(marks);
		const resolved = resolveRunProperties(cascadeContext.resolverParams, inlineRpr, cascadeContext.paragraphProperties);
		if (boldDirect === "clear") effective.bold = resolved.bold ?? false;
		if (italicDirect === "clear") effective.italic = resolved.italic ?? false;
		if (strikeDirect === "clear") effective.strike = resolved.strike ?? false;
		if (underlineDirect === "clear") {
			const uVal = resolved.underline?.["w:val"];
			effective.underline = uVal != null && uVal !== "none";
		}
	}
	const style = {
		direct,
		effective
	};
	const runProps = marks.find((m$1) => m$1.type.name === "runProperties");
	const textStyle = marks.find((m$1) => m$1.type.name === "textStyle");
	const color = extractAttr(runProps, "color") ?? extractAttr(textStyle, "color");
	const normalizedColor = color != null ? normalizeHexColor$1(String(color)) : void 0;
	if (normalizedColor) style.color = normalizedColor;
	const highlight = extractAttr(runProps, "highlight") ?? extractAttr(textStyle, "highlight");
	const normalizedHighlight = highlight != null ? normalizeHexColor$1(String(highlight)) : void 0;
	if (normalizedHighlight) style.highlight = normalizedHighlight;
	const fontFamily = extractAttr(runProps, "fontFamily") ?? extractAttr(textStyle, "fontFamily");
	if (typeof fontFamily === "string" && fontFamily.trim().length > 0) style.fontFamily = fontFamily;
	const rpFontSize = extractAttr(runProps, "fontSize");
	const rawFontSize = rpFontSize ?? extractAttr(textStyle, "fontSize");
	const parsedSize = parseFontSizePt((rpFontSize != null ? "runProperties" : "textStyle") === "runProperties" && typeof rawFontSize === "number" ? rawFontSize / 2 : rawFontSize);
	if (parsedSize !== void 0) style.fontSizePt = parsedSize;
	return style;
}
function extractAttr(mark, key) {
	if (!mark) return void 0;
	const val = mark.attrs[key];
	return val === void 0 || val === null ? void 0 : val;
}
function extractRunStyleId(marks) {
	const runProps = marks.find((m$1) => m$1.type.name === "runProperties");
	if (!runProps) return void 0;
	const id = runProps.attrs.styleId;
	return typeof id === "string" && id.length > 0 ? id : void 0;
}
function normalizeHexColor$1(raw) {
	if (!raw || typeof raw !== "string") return void 0;
	const trimmed = raw.trim().toLowerCase();
	if (!trimmed) return void 0;
	if (/^#[0-9a-f]{6}$/.test(trimmed)) return trimmed;
	if (/^#[0-9a-f]{3}$/.test(trimmed)) {
		const [, r$1, g$1, b$1] = trimmed;
		return `#${r$1}${r$1}${g$1}${g$1}${b$1}${b$1}`;
	}
	if (/^[0-9a-f]{6}$/.test(trimmed)) return `#${trimmed}`;
	const rgbMatch = trimmed.match(/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/);
	if (rgbMatch) {
		const [, rs, gs, bs] = rgbMatch;
		const r$1 = parseInt(rs, 10);
		const g$1 = parseInt(gs, 10);
		const b$1 = parseInt(bs, 10);
		if (r$1 <= 255 && g$1 <= 255 && b$1 <= 255) return `#${r$1.toString(16).padStart(2, "0")}${g$1.toString(16).padStart(2, "0")}${b$1.toString(16).padStart(2, "0")}`;
	}
	const named = CSS_NAMED_COLORS[trimmed];
	if (named) return named;
}
function parseFontSizePt(raw) {
	if (raw === void 0 || raw === null) return void 0;
	let value;
	if (typeof raw === "number") value = raw;
	else if (typeof raw === "string") {
		const cleaned = raw.replace(/\s*(pt|px|hp)$/i, "").trim();
		value = parseFloat(cleaned);
	} else return;
	if (!Number.isFinite(value) || value < 0) return void 0;
	return Math.round(value * 10) / 10;
}
function assertRunTilingInvariant(runs, blockRange, blockId) {
	if (runs.length === 0) {
		if (blockRange.start !== blockRange.end) throw planError("INTERNAL_ERROR", `run-tiling: no runs for non-empty block range in block ${blockId}`);
		return;
	}
	if (runs[0].range.start !== blockRange.start) throw planError("INTERNAL_ERROR", `run-tiling: first run starts at ${runs[0].range.start} but block range starts at ${blockRange.start} in block ${blockId}`);
	if (runs[runs.length - 1].range.end !== blockRange.end) throw planError("INTERNAL_ERROR", `run-tiling: last run ends at ${runs[runs.length - 1].range.end} but block range ends at ${blockRange.end} in block ${blockId}`);
	for (let i = 0; i < runs.length - 1; i++) if (runs[i].range.end !== runs[i + 1].range.start) throw planError("INTERNAL_ERROR", `run-tiling: gap or overlap between runs[${i}] and runs[${i + 1}] in block ${blockId}`);
}
var CSS_NAMED_COLORS = {
	aliceblue: "#f0f8ff",
	antiquewhite: "#faebd7",
	aqua: "#00ffff",
	aquamarine: "#7fffd4",
	azure: "#f0ffff",
	beige: "#f5f5dc",
	bisque: "#ffe4c4",
	black: "#000000",
	blanchedalmond: "#ffebcd",
	blue: "#0000ff",
	blueviolet: "#8a2be2",
	brown: "#a52a2a",
	burlywood: "#deb887",
	cadetblue: "#5f9ea0",
	chartreuse: "#7fff00",
	chocolate: "#d2691e",
	coral: "#ff7f50",
	cornflowerblue: "#6495ed",
	cornsilk: "#fff8dc",
	crimson: "#dc143c",
	cyan: "#00ffff",
	darkblue: "#00008b",
	darkcyan: "#008b8b",
	darkgoldenrod: "#b8860b",
	darkgray: "#a9a9a9",
	darkgreen: "#006400",
	darkgrey: "#a9a9a9",
	darkkhaki: "#bdb76b",
	darkmagenta: "#8b008b",
	darkolivegreen: "#556b2f",
	darkorange: "#ff8c00",
	darkorchid: "#9932cc",
	darkred: "#8b0000",
	darksalmon: "#e9967a",
	darkseagreen: "#8fbc8f",
	darkslateblue: "#483d8b",
	darkslategray: "#2f4f4f",
	darkslategrey: "#2f4f4f",
	darkturquoise: "#00ced1",
	darkviolet: "#9400d3",
	deeppink: "#ff1493",
	deepskyblue: "#00bfff",
	dimgray: "#696969",
	dimgrey: "#696969",
	dodgerblue: "#1e90ff",
	firebrick: "#b22222",
	floralwhite: "#fffaf0",
	forestgreen: "#228b22",
	fuchsia: "#ff00ff",
	gainsboro: "#dcdcdc",
	ghostwhite: "#f8f8ff",
	gold: "#ffd700",
	goldenrod: "#daa520",
	gray: "#808080",
	green: "#008000",
	greenyellow: "#adff2f",
	grey: "#808080",
	honeydew: "#f0fff0",
	hotpink: "#ff69b4",
	indianred: "#cd5c5c",
	indigo: "#4b0082",
	ivory: "#fffff0",
	khaki: "#f0e68c",
	lavender: "#e6e6fa",
	lavenderblush: "#fff0f5",
	lawngreen: "#7cfc00",
	lemonchiffon: "#fffacd",
	lightblue: "#add8e6",
	lightcoral: "#f08080",
	lightcyan: "#e0ffff",
	lightgoldenrodyellow: "#fafad2",
	lightgray: "#d3d3d3",
	lightgreen: "#90ee90",
	lightgrey: "#d3d3d3",
	lightpink: "#ffb6c1",
	lightsalmon: "#ffa07a",
	lightseagreen: "#20b2aa",
	lightskyblue: "#87cefa",
	lightslategray: "#778899",
	lightslategrey: "#778899",
	lightsteelblue: "#b0c4de",
	lightyellow: "#ffffe0",
	lime: "#00ff00",
	limegreen: "#32cd32",
	linen: "#faf0e6",
	magenta: "#ff00ff",
	maroon: "#800000",
	mediumaquamarine: "#66cdaa",
	mediumblue: "#0000cd",
	mediumorchid: "#ba55d3",
	mediumpurple: "#9370db",
	mediumseagreen: "#3cb371",
	mediumslateblue: "#7b68ee",
	mediumspringgreen: "#00fa9a",
	mediumturquoise: "#48d1cc",
	mediumvioletred: "#c71585",
	midnightblue: "#191970",
	mintcream: "#f5fffa",
	mistyrose: "#ffe4e1",
	moccasin: "#ffe4b5",
	navajowhite: "#ffdead",
	navy: "#000080",
	oldlace: "#fdf5e6",
	olive: "#808000",
	olivedrab: "#6b8e23",
	orange: "#ffa500",
	orangered: "#ff4500",
	orchid: "#da70d6",
	palegoldenrod: "#eee8aa",
	palegreen: "#98fb98",
	paleturquoise: "#afeeee",
	palevioletred: "#db7093",
	papayawhip: "#ffefd5",
	peachpuff: "#ffdab9",
	peru: "#cd853f",
	pink: "#ffc0cb",
	plum: "#dda0dd",
	powderblue: "#b0e0e6",
	purple: "#800080",
	rebeccapurple: "#663399",
	red: "#ff0000",
	rosybrown: "#bc8f8f",
	royalblue: "#4169e1",
	saddlebrown: "#8b4513",
	salmon: "#fa8072",
	sandybrown: "#f4a460",
	seagreen: "#2e8b57",
	seashell: "#fff5ee",
	sienna: "#a0522d",
	silver: "#c0c0c0",
	skyblue: "#87ceeb",
	slateblue: "#6a5acd",
	slategray: "#708090",
	slategrey: "#708090",
	snow: "#fffafa",
	springgreen: "#00ff7f",
	steelblue: "#4682b4",
	tan: "#d2b48c",
	teal: "#008080",
	thistle: "#d8bfd8",
	tomato: "#ff6347",
	turquoise: "#40e0d0",
	violet: "#ee82ee",
	wheat: "#f5deb3",
	white: "#ffffff",
	whitesmoke: "#f5f5f5",
	yellow: "#ffff00",
	yellowgreen: "#9acd32"
};
function encodeV3Ref(payload) {
	return `text:${btoa(JSON.stringify(payload))}`;
}
function encodeStoryAwareRef(storyKey, rev, matchId, scope, segments, blockIndex, runIndex) {
	return encodeV4Ref({
		v: 4,
		rev,
		storyKey,
		scope,
		matchId,
		segments,
		blockIndex,
		runIndex
	});
}
function buildSelectionTargetFromBlocks(blocks, story) {
	const first$1 = blocks[0];
	const last = blocks[blocks.length - 1];
	const target = {
		kind: "selection",
		start: {
			kind: "text",
			blockId: first$1.blockId,
			offset: first$1.range.start
		},
		end: {
			kind: "text",
			blockId: last.blockId,
			offset: last.range.end
		}
	};
	if (story) target.story = story;
	return target;
}
function buildSelectionTargetFromTextRanges(textRanges, story) {
	const first$1 = textRanges[0];
	const last = textRanges[textRanges.length - 1];
	const target = {
		kind: "selection",
		start: {
			kind: "text",
			blockId: first$1.blockId,
			offset: first$1.range.start
		},
		end: {
			kind: "text",
			blockId: last.blockId,
			offset: last.range.end
		}
	};
	if (story) target.story = story;
	return target;
}
function readCandidateVisibleText(editor, candidate) {
	const maybeNode = candidate.node;
	if (maybeNode && typeof maybeNode.childCount === "number" && maybeNode.childCount > 0) return textContentInBlock(maybeNode, { textModel: "visible" });
	return editor.state.doc.textBetween(candidate.pos + 1, candidate.end - 1, "\n", "￼");
}
function buildMatchBlocks(editor, textRanges, evaluatedRevision, matchId, storyKey, resolverParams) {
	const index = getBlockIndex(editor);
	const doc$1 = editor.state.doc;
	const blockGroupMap = /* @__PURE__ */ new Map();
	const blockOrder = [];
	for (const range of textRanges) {
		const existing = blockGroupMap.get(range.blockId);
		if (existing) existing.push(range);
		else {
			blockGroupMap.set(range.blockId, [range]);
			blockOrder.push(range.blockId);
		}
	}
	const blocks = [];
	for (let blockIdx = 0; blockIdx < blockOrder.length; blockIdx++) {
		const blockId = blockOrder[blockIdx];
		const ranges = blockGroupMap.get(blockId);
		const candidate = index.candidates.find((c) => c.nodeId === blockId);
		if (!candidate) continue;
		const from$1 = Math.min(...ranges.map((r$1) => r$1.range.start));
		const to = Math.max(...ranges.map((r$1) => r$1.range.end));
		const sorted = [...ranges].sort((a, b$1) => a.range.start - b$1.range.start);
		for (let i = 0; i < sorted.length - 1; i++) if (sorted[i].range.end < sorted[i + 1].range.start) {
			const gapStart = sorted[i].range.end;
			const gapEnd = sorted[i + 1].range.start;
			const coveringStart = Math.min(...sorted.map((r$1) => r$1.range.start));
			const coveringEnd = Math.max(...sorted.map((r$1) => r$1.range.end));
			throw planError("INVALID_INPUT", `discontiguous text ranges in block ${blockId}: gap between ${gapStart} and ${gapEnd}. Two or more edits target the same block with untouched text between them and cannot be coalesced safely. Fix by: (a) splitting the edits across separate superdoc_mutations batches — preferred, works in both direct and tracked change modes; or (b) combining the edits into a single text.rewrite covering offsets ${coveringStart}..${coveringEnd} — direct mode only, since in tracked mode the untouched middle would be recorded as deleted+reinserted.`, void 0, {
				blockId,
				gap: {
					start: gapStart,
					end: gapEnd
				},
				coveringRange: {
					start: coveringStart,
					end: coveringEnd
				},
				rangeCount: sorted.length,
				ranges: sorted.map((r$1) => ({
					start: r$1.range.start,
					end: r$1.range.end
				})),
				remediation: {
					preferred: "split-batches",
					optionA: "Split into separate superdoc_mutations batches (works in direct and tracked modes).",
					optionB: `Combine into one text.rewrite covering offsets ${coveringStart}..${coveringEnd} (direct mode only — pollutes tracked history).`
				}
			});
		}
		const blockText = readCandidateVisibleText(editor, candidate);
		const matchedText = blockText.slice(from$1, to);
		const node = doc$1.nodeAt(candidate.pos);
		const nodeType = node?.type.name ?? "paragraph";
		const paragraphStyle = buildParagraphStyle(node);
		const cascadeContext = resolverParams ? {
			resolverParams,
			paragraphProperties: node?.attrs?.paragraphProperties ?? null
		} : void 0;
		const coalesced = coalesceRuns(captureRunsInRange(editor, candidate.pos, from$1, to, { textModel: "visible" }).runs);
		const blockRange = {
			start: from$1,
			end: to
		};
		const runs = coalesced.map((run, runIdx) => ({
			range: {
				start: run.from,
				end: run.to
			},
			text: blockText.slice(run.from, run.to),
			styleId: extractRunStyleId(run.marks),
			styles: toMatchStyle(run.marks, cascadeContext),
			ref: encodeStoryAwareRef(storyKey, evaluatedRevision, matchId, "run", [{
				blockId,
				start: run.from,
				end: run.to
			}], blockIdx, runIdx)
		}));
		for (const run of runs) if (run.styleId === void 0) delete run.styleId;
		assertRunTilingInvariant(runs, blockRange, blockId);
		const block = {
			blockId,
			nodeType,
			range: blockRange,
			text: matchedText,
			ref: encodeStoryAwareRef(storyKey, evaluatedRevision, matchId, "block", [{
				blockId,
				start: from$1,
				end: to
			}], blockIdx),
			runs
		};
		if (paragraphStyle) block.paragraphStyle = paragraphStyle;
		blocks.push(block);
	}
	return blocks;
}
function buildParagraphStyle(node) {
	if (!node) return void 0;
	const attrs = node.attrs;
	const styleId$1 = attrs?.paragraphProperties?.styleId;
	const listRendering = attrs?.listRendering;
	const isListItem$1 = listRendering != null;
	const listLevel = isListItem$1 ? listRendering?.level : void 0;
	if (!(styleId$1 || isListItem$1)) return void 0;
	const result = {};
	if (typeof styleId$1 === "string" && styleId$1.length > 0) result.styleId = styleId$1;
	if (isListItem$1) result.isListItem = true;
	if (typeof listLevel === "number" && listLevel >= 0) result.listLevel = listLevel;
	return result;
}
function buildBlocksSnippet(editor, blocks) {
	if (!editor.state?.doc || blocks.length === 0) return void 0;
	const index = getBlockIndex(editor);
	const matchText = blocks.map((b$1) => b$1.text).join("\n");
	if (matchText.length >= 500) return {
		snippet: matchText.slice(0, 500),
		highlightRange: {
			start: 0,
			end: 500
		}
	};
	const remainingBudget = 500 - matchText.length;
	const contextEachSide = Math.min(100, Math.floor(remainingBudget / 2));
	let leftContext = "";
	const firstBlock = blocks[0];
	const firstCandidate = index.candidates.find((c) => c.nodeId === firstBlock.blockId);
	if (firstCandidate) {
		const fullBlockText = readCandidateVisibleText(editor, firstCandidate);
		const contextStart = Math.max(0, firstBlock.range.start - contextEachSide);
		leftContext = fullBlockText.slice(contextStart, firstBlock.range.start);
	}
	let rightContext = "";
	const lastBlock = blocks[blocks.length - 1];
	const lastCandidate = index.candidates.find((c) => c.nodeId === lastBlock.blockId);
	if (lastCandidate) {
		const fullBlockText = readCandidateVisibleText(editor, lastCandidate);
		const contextEnd = Math.min(fullBlockText.length, lastBlock.range.end + contextEachSide);
		rightContext = fullBlockText.slice(lastBlock.range.end, contextEnd);
	}
	let snippet = leftContext + matchText + rightContext;
	let highlightRange = {
		start: leftContext.length,
		end: leftContext.length + matchText.length
	};
	if (snippet.length > 500) {
		snippet = snippet.slice(0, 500);
		highlightRange = {
			start: highlightRange.start,
			end: Math.min(highlightRange.end, 500)
		};
	}
	return {
		snippet,
		highlightRange
	};
}
function applyPagination$1(items, offset$1, limit) {
	validatePaginationInput(offset$1, limit);
	if (limit === void 0) return items.slice(offset$1);
	return items.slice(offset$1, offset$1 + limit);
}
function buildInlineAnchorSegments(editor, anchor) {
	const index = getBlockIndex(editor);
	const doc$1 = editor.state.doc;
	const startCandidate = index.candidates.find((c) => c.nodeId === anchor.start.blockId);
	const endCandidate = index.candidates.find((c) => c.nodeId === anchor.end.blockId);
	if (!startCandidate || !endCandidate) return [{
		blockId: anchor.start.blockId,
		start: anchor.start.offset,
		end: anchor.start.offset
	}];
	const startBlockText = doc$1.textBetween(startCandidate.pos + 1, startCandidate.end - 1, "\n", "￼");
	return [{
		blockId: anchor.start.blockId,
		start: anchor.start.offset,
		end: startBlockText.length
	}, {
		blockId: anchor.end.blockId,
		start: 0,
		end: anchor.end.offset
	}];
}
function isZeroWidthMatch(textRanges) {
	return textRanges.every((r$1) => r$1.range.start === r$1.range.end);
}
function queryMatchAdapter(editor, input) {
	const runtime = resolveStoryRuntime(editor, input.in);
	const storyEditor = runtime.editor;
	const storyKey = runtime.storyKey;
	const nonBodyStory = runtime.kind !== "body" ? runtime.locator : void 0;
	const evaluatedRevision = getRevision(storyEditor);
	const require$1 = input.require ?? "any";
	const translatedLinkedStyles = readTranslatedLinkedStyles(storyEditor);
	const converter = storyEditor.converter;
	const hasStyleCascade = translatedLinkedStyles?.styles != null;
	const resolverParams = hasStyleCascade ? {
		translatedLinkedStyles,
		translatedNumbering: converter?.translatedNumbering
	} : null;
	if ((require$1 === "first" || require$1 === "exactlyOne") && (input.limit !== void 0 || input.offset !== void 0)) throw planError("INVALID_INPUT", `limit/offset are not valid when require is "${require$1}"`);
	const isTextSelector = input.select.type === "text";
	const effectiveResolved = hasStyleCascade && isTextSelector;
	const result = findLegacyAdapter(storyEditor, {
		select: input.select,
		within: input.within,
		includeNodes: input.includeNodes,
		limit: isTextSelector ? void 0 : input.limit,
		offset: isTextSelector ? void 0 : input.offset
	});
	const rawMatches = [];
	for (const item of result.items) {
		const address = item.address;
		const textRanges = item.context?.textRanges?.length ? item.context.textRanges : void 0;
		if (isTextSelector && textRanges && isZeroWidthMatch(textRanges)) continue;
		rawMatches.push({
			address,
			textRanges
		});
	}
	const totalMatches = isTextSelector ? rawMatches.length : result.total;
	const userOffset = input.offset ?? 0;
	const paginatedMatches = isTextSelector ? applyPagination$1(rawMatches, userOffset, input.limit) : rawMatches;
	if (require$1 === "first" || require$1 === "exactlyOne" || require$1 === "all") {
		if (totalMatches === 0) {
			const doc$1 = storyEditor.state?.doc;
			const docSize = typeof doc$1?.content?.size === "number" ? doc$1.content.size : 0;
			const previewLength = Math.min(docSize, 300);
			const textPreview = previewLength > 0 && typeof doc$1?.textBetween === "function" ? doc$1.textBetween(0, previewLength, "\n", "\n") : "";
			throw planError("MATCH_NOT_FOUND", `selector matched zero ranges. Document starts with: "${textPreview.slice(0, 200)}..."`, void 0, {
				selectorType: input.select?.type ?? "unknown",
				selectorPattern: input.select?.pattern ?? "",
				selectorMode: input.select?.mode ?? "contains",
				searchScope: (input.within?.kind === "block" ? input.within.nodeId : void 0) ?? "document",
				candidateCount: 0,
				textPreview
			});
		}
	}
	if (require$1 === "exactlyOne" && totalMatches > 1) throw planError("AMBIGUOUS_MATCH", `selector matched ${totalMatches} ranges, expected exactly one`, void 0, { matchCount: totalMatches });
	const matchItems = paginatedMatches.map((raw, pageIdx) => {
		const id = `m:${userOffset + pageIdx}`;
		if (isTextSelector && raw.textRanges?.length) {
			const blocks = buildMatchBlocks(storyEditor, raw.textRanges, evaluatedRevision, id, storyKey, resolverParams);
			if (blocks.length === 0) throw planError("INTERNAL_ERROR", `text match produced no blocks for ${id}`, void 0, {
				source: "query-match-adapter:buildMatchEntries",
				invariant: "text match must have at least one block after zero-width filtering",
				context: { matchId: id }
			});
			const snippetResult = buildBlocksSnippet(storyEditor, blocks);
			const ref$1 = encodeStoryAwareRef(storyKey, evaluatedRevision, id, "match", blocks.map((b$1) => ({
				blockId: b$1.blockId,
				start: b$1.range.start,
				end: b$1.range.end
			})));
			const address = raw.address;
			if (nonBodyStory && !address.story) address.story = nonBodyStory;
			return {
				id,
				handle: buildResolvedHandle(ref$1, "ephemeral", "text"),
				matchKind: "text",
				address,
				target: buildSelectionTargetFromBlocks(blocks, nonBodyStory),
				snippet: snippetResult?.snippet ?? "",
				highlightRange: snippetResult?.highlightRange ?? {
					start: 0,
					end: 0
				},
				blocks
			};
		} else {
			if (nonBodyStory && !raw.address.story) raw.address.story = nonBodyStory;
			if (raw.address.kind === "block") return {
				id,
				handle: buildResolvedHandle(nonBodyStory ? encodeV4Ref({
					v: 4,
					rev: evaluatedRevision,
					storyKey,
					scope: "node",
					node: {
						kind: "block",
						nodeType: raw.address.nodeType,
						nodeId: raw.address.nodeId
					}
				}) : raw.address.nodeId, "stable", "node"),
				matchKind: "node",
				address: raw.address,
				blocks: []
			};
			const anchor = raw.address.anchor;
			return {
				id,
				handle: buildResolvedHandle(encodeStoryAwareRef(storyKey, evaluatedRevision, id, "match", anchor.start.blockId === anchor.end.blockId ? [{
					blockId: anchor.start.blockId,
					start: anchor.start.offset,
					end: anchor.end.offset
				}] : buildInlineAnchorSegments(storyEditor, anchor)), "ephemeral", "node"),
				matchKind: "node",
				address: raw.address,
				blocks: []
			};
		}
	});
	const truncated = require$1 === "first" ? matchItems.slice(0, 1) : matchItems;
	return buildDiscoveryResult({
		evaluatedRevision,
		total: totalMatches,
		items: truncated,
		page: {
			limit: input.limit ?? totalMatches,
			offset: userOffset,
			returned: truncated.length
		},
		meta: { effectiveResolved }
	});
}
function findLegacyAdapter(editor, query) {
	const runtime = resolveStoryRuntime(editor, query.in);
	const diagnostics = [];
	const index = getBlockIndex(runtime.editor);
	if (query.includeUnknown) collectUnknownNodeDiagnostics(runtime.editor, index, diagnostics);
	const isInlineSelector = query.select.type !== "text" && isInlineQuery(query.select);
	const isDualKindSelector = query.select.type !== "text" && shouldQueryBothKinds(query.select);
	const result = query.select.type === "text" ? executeTextSelector(runtime.editor, index, query, diagnostics) : isDualKindSelector ? executeDualKindSelector(runtime.editor, index, query, diagnostics) : isInlineSelector ? executeInlineSelector(runtime.editor, index, query, diagnostics) : executeBlockSelector(index, query, diagnostics);
	const uniqueDiagnostics = dedupeDiagnostics(diagnostics);
	const includedNodes = query.includeNodes ? resolveIncludedNodes(runtime.editor, index, result.matches) : void 0;
	const evaluatedRevision = getRevision(runtime.editor);
	const nonBodyStory = runtime.kind !== "body" ? runtime.locator : void 0;
	const items = result.matches.map((address, idx) => {
		const nodeId = "nodeId" in address ? address.nodeId : void 0;
		const contextEntry = result.context?.[idx];
		const textRanges = contextEntry?.textRanges;
		const isTextContext = textRanges?.length;
		let ref$1;
		let targetKind;
		if (isTextContext && textRanges) {
			const segments = textRanges.map((tr) => ({
				blockId: tr.blockId,
				start: tr.range.start,
				end: tr.range.end
			}));
			ref$1 = encodeV4Ref({
				v: 4,
				rev: evaluatedRevision,
				storyKey: runtime.storyKey,
				scope: "match",
				matchId: `f:${idx}`,
				segments
			});
			targetKind = "text";
		} else {
			ref$1 = nodeId ?? `find:${idx}`;
			targetKind = "node";
		}
		const handle = buildResolvedHandle(ref$1, "ephemeral", targetKind);
		if (nonBodyStory && !address.story) address.story = nonBodyStory;
		const domain = { address };
		if (includedNodes?.[idx]) domain.node = includedNodes[idx];
		if (contextEntry) {
			if (textRanges?.length) contextEntry.target = buildSelectionTargetFromTextRanges(textRanges, nonBodyStory);
			domain.context = contextEntry;
		}
		return buildDiscoveryItem(ref$1, handle, domain);
	});
	return {
		...buildDiscoveryResult({
			evaluatedRevision,
			total: result.total,
			items,
			page: {
				limit: query.limit ?? result.total,
				offset: query.offset ?? 0,
				returned: items.length
			}
		}),
		diagnostics: uniqueDiagnostics.length ? uniqueDiagnostics : void 0
	};
}
function translateToInternalQuery(input) {
	if (!input || typeof input !== "object" || !input.select || typeof input.select !== "object" || !input.select.type) throw new DocumentApiAdapterError("INVALID_INPUT", "SDFindInput requires a \"select\" object with a \"type\" field (\"text\" or \"node\").", {
		field: "select",
		value: input?.select
	});
	const { select, within: within$1, limit, offset: offset$1 } = input;
	if (within$1) validateWithinAddress(within$1);
	if (select.type === "node") {
		const raw = select;
		if ("nodeKind" in raw && raw.nodeKind != null) throw new DocumentApiAdapterError("INVALID_INPUT", `"nodeKind" is no longer supported on node selectors. Use "nodeType" instead: { type: 'node', nodeType: '${String(raw.nodeKind)}' }.`, {
			field: "select.nodeKind",
			value: raw.nodeKind
		});
		if (raw.kind === "content") throw new DocumentApiAdapterError("INVALID_INPUT", `kind: 'content' is no longer supported on node selectors. Use kind: 'block' instead.`, {
			field: "select.kind",
			value: raw.kind
		});
	}
	return {
		select,
		limit,
		offset: offset$1,
		includeNodes: true
	};
}
function validateWithinAddress(address) {
	if (address.kind === "block" && "nodeId" in address && typeof address.nodeId === "string") return {
		nodeId: address.nodeId,
		nodeType: address.nodeType
	};
	throw new DocumentApiAdapterError("INVALID_TARGET", "\"within\" scope requires a BlockNodeAddress with a nodeId.", {
		field: "within",
		value: address
	});
}
function resolveWithinAddress(index, nodeId, expectedNodeType) {
	if (expectedNodeType) {
		const match$2 = findBlockByIdStrict(index, {
			kind: "block",
			nodeType: expectedNodeType,
			nodeId
		});
		return {
			kind: "block",
			nodeType: match$2.nodeType,
			nodeId: match$2.nodeId
		};
	}
	const match$1 = findBlockByNodeIdOnly(index, nodeId);
	return {
		kind: "block",
		nodeType: match$1.nodeType,
		nodeId: match$1.nodeId
	};
}
function projectMatchToSDNodeResult(editor, address, blockIndex) {
	if (address.kind === "block") {
		const candidate = blockIndex.byId.get(`${address.nodeType}:${address.nodeId}`);
		if (!candidate) {
			const found = blockIndex.candidates.find((c) => c.nodeType === address.nodeType && c.nodeId === address.nodeId);
			if (!found) return null;
			return {
				node: projectContentNode(found.node, { textModel: "visible" }),
				address
			};
		}
		return {
			node: projectContentNode(candidate.node, { textModel: "visible" }),
			address
		};
	}
	const inlineCandidate = findInlineByAnchor(getInlineIndex(editor), address);
	if (inlineCandidate) {
		if (inlineCandidate.node) return {
			node: projectInlineNode(inlineCandidate.node),
			address
		};
		const markProjected = projectMarkBasedInline(editor, inlineCandidate);
		if (markProjected) return {
			node: markProjected,
			address
		};
	}
	return {
		node: {
			kind: "run",
			run: { text: resolveTextByBlockId(editor, address.anchor) }
		},
		address
	};
}
function sdFindAdapter(editor, input) {
	const runtime = resolveStoryRuntime(editor, input.in);
	const query = translateToInternalQuery(input);
	const index = getBlockIndex(runtime.editor);
	if (input.within) {
		const { nodeId, nodeType } = validateWithinAddress(input.within);
		query.within = resolveWithinAddress(index, nodeId, nodeType);
	}
	const diagnostics = [];
	const isInlineSelector = query.select.type !== "text" && isInlineQuery(query.select);
	const isDualKindSelector = query.select.type !== "text" && shouldQueryBothKinds(query.select);
	const result = query.select.type === "text" ? executeTextSelector(runtime.editor, index, query, diagnostics) : isDualKindSelector ? executeDualKindSelector(runtime.editor, index, query, diagnostics) : isInlineSelector ? executeInlineSelector(runtime.editor, index, query, diagnostics) : executeBlockSelector(index, query, diagnostics);
	const sdNonBodyStory = runtime.kind !== "body" ? runtime.locator : void 0;
	const items = [];
	for (const address of result.matches) {
		if (sdNonBodyStory && !address.story) address.story = sdNonBodyStory;
		const projected = projectMatchToSDNodeResult(runtime.editor, address, index);
		if (projected) items.push(projected);
	}
	return {
		total: result.total,
		limit: input.limit ?? result.total,
		offset: input.offset ?? 0,
		items
	};
}
function findBlocksByTypeAndId(blockIndex, nodeType, nodeId) {
	const byIdMatch = blockIndex.byId.get(`${nodeType}:${nodeId}`);
	if (byIdMatch) return [byIdMatch];
	return blockIndex.candidates.filter((candidate) => candidate.nodeType === nodeType && candidate.nodeId === nodeId);
}
function buildInlineAddress(address) {
	return address;
}
function getNodeAdapter(editor, address) {
	const storyEditor = resolveStoryRuntime(editor, address.story).editor;
	const blockIndex = getBlockIndex(storyEditor);
	if (address.kind === "block") {
		const matches = findBlocksByTypeAndId(blockIndex, address.nodeType, address.nodeId);
		if (matches.length > 1) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Multiple nodes share ${address.nodeType} id "${address.nodeId}".`);
		let candidate$1 = matches[0];
		if (!candidate$1) try {
			candidate$1 = findBlockByNodeIdOnly(blockIndex, address.nodeId);
		} catch {}
		if (!candidate$1) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Node "${address.nodeType}" not found for id "${address.nodeId}".`);
		return {
			node: projectContentNode(candidate$1.node),
			address: {
				kind: "block",
				nodeType: candidate$1.nodeType,
				nodeId: candidate$1.nodeId,
				...address.story && { story: address.story }
			}
		};
	}
	const candidate = findInlineByAnchor(getInlineIndex(storyEditor), address);
	if (!candidate) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Inline node "${address.nodeType}" not found for the provided anchor.`);
	if (candidate.node) return {
		node: projectInlineNode(candidate.node),
		address: buildInlineAddress(address)
	};
	const projected = projectMarkBasedInline(storyEditor, candidate);
	if (projected) return {
		node: projected,
		address: buildInlineAddress(address)
	};
	throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Inline node "${address.nodeType}" could not be projected from the provided anchor.`);
}
function resolveBlockById(editor, nodeId, nodeType) {
	const blockIndex = getBlockIndex(editor);
	if (nodeType) {
		const matches$1 = findBlocksByTypeAndId(blockIndex, nodeType, nodeId);
		if (matches$1.length === 0) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Node "${nodeType}" not found for id "${nodeId}".`);
		if (matches$1.length > 1) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Multiple nodes share ${nodeType} id "${nodeId}".`);
		return {
			candidate: matches$1[0],
			resolvedType: nodeType
		};
	}
	const matches = blockIndex.candidates.filter((candidate) => candidate.nodeId === nodeId);
	if (matches.length === 1) return {
		candidate: matches[0],
		resolvedType: matches[0].nodeType
	};
	if (matches.length > 1) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Multiple nodes share id "${nodeId}". Provide nodeType to disambiguate.`);
	for (const [key, candidate] of blockIndex.byId) if (key.endsWith(`:${nodeId}`)) return {
		candidate,
		resolvedType: candidate.nodeType
	};
	throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Node not found for id "${nodeId}".`);
}
function getNodeByIdAdapter(editor, input) {
	const { nodeId, nodeType } = input;
	const { candidate, resolvedType } = resolveBlockById(editor, nodeId, nodeType);
	return {
		node: projectContentNode(candidate.node),
		address: {
			kind: "block",
			nodeType: resolvedType,
			nodeId: candidate.nodeId
		}
	};
}
function proseMirrorDocToMdast(doc$1, editor) {
	return {
		type: "root",
		children: groupConsecutiveListItems(convertDocChildren(doc$1, editor))
	};
}
var HEADING_STYLE_DEPTH = {
	Heading1: 1,
	Heading2: 2,
	Heading3: 3,
	Heading4: 4,
	Heading5: 5,
	Heading6: 6
};
var BULLET_FORMATS = new Set(["bullet", "none"]);
function convertDocChildren(doc$1, editor) {
	const blocks = [];
	doc$1.forEach((child) => {
		blocks.push(...convertBlockNode(child, editor));
	});
	return blocks;
}
function convertBlockNode(node, editor) {
	switch (node.type.name) {
		case "paragraph": return convertParagraph(node, editor);
		case "table": return [convertTable(node, editor)];
		case "contentBlock": return convertContentBlock(node);
		default: return [{
			type: "paragraph",
			children: convertInlineContent(node, editor)
		}];
	}
}
function convertParagraph(node, editor) {
	const pProps = node.attrs.paragraphProperties;
	const styleId$1 = pProps?.styleId;
	const numberingProps = pProps?.numberingProperties ?? node.attrs.numberingProperties;
	const inlineContent = convertInlineContent(node, editor);
	if (styleId$1 && styleId$1 in HEADING_STYLE_DEPTH) return [{
		type: "heading",
		depth: HEADING_STYLE_DEPTH[styleId$1],
		children: inlineContent
	}];
	if (numberingProps && numberingProps.numId != null) {
		const numId = numberingProps.numId;
		const ilvl = numberingProps.ilvl ?? 0;
		return [{
			type: "pendingListItem",
			numId,
			ilvl,
			ordered: isOrderedList(numId, ilvl, editor),
			children: [{
				type: "paragraph",
				children: inlineContent
			}]
		}];
	}
	if (styleId$1 === "Quote") return [{
		type: "blockquote",
		children: [{
			type: "paragraph",
			children: inlineContent
		}]
	}];
	return [{
		type: "paragraph",
		children: inlineContent
	}];
}
function isOrderedList(numId, ilvl, editor) {
	try {
		const details = ListHelpers.getListDefinitionDetails({
			numId,
			level: ilvl,
			listType: void 0,
			editor
		});
		if (!details?.numFmt) return false;
		return !BULLET_FORMATS.has(details.numFmt);
	} catch {
		return false;
	}
}
function groupConsecutiveListItems(blocks) {
	const result = [];
	let i = 0;
	while (i < blocks.length) {
		const block = blocks[i];
		if (isPendingListItem(block)) {
			const run = [block];
			i += 1;
			while (i < blocks.length && isPendingListItem(blocks[i]) && blocks[i].numId === block.numId) {
				run.push(blocks[i]);
				i += 1;
			}
			result.push(buildListTree(run));
		} else {
			result.push(block);
			i += 1;
		}
	}
	return result;
}
function isPendingListItem(block) {
	return block.type === "pendingListItem";
}
function buildListTree(items) {
	const rootList = {
		type: "list",
		ordered: items[0].ordered,
		spread: false,
		children: []
	};
	for (const item of items) insertItemAtDepth(rootList, item.ilvl, item.children, item.ordered);
	return rootList;
}
function insertItemAtDepth(list, depth, content, ordered) {
	if (depth === 0) {
		const listItem = {
			type: "listItem",
			spread: false,
			children: content
		};
		list.children.push(listItem);
		return;
	}
	if (list.children.length === 0) list.children.push({
		type: "listItem",
		spread: false,
		children: []
	});
	const lastItem = list.children[list.children.length - 1];
	let nestedList = lastItem.children.find((child) => child.type === "list");
	if (!nestedList) {
		nestedList = {
			type: "list",
			ordered,
			spread: false,
			children: []
		};
		lastItem.children.push(nestedList);
	}
	insertItemAtDepth(nestedList, depth - 1, content, ordered);
}
function convertContentBlock(node) {
	if (node.attrs.horizontalRule) return [{ type: "thematicBreak" }];
	return [];
}
function convertTable(node, editor) {
	const rows = [];
	node.forEach((rowNode) => {
		rows.push(convertTableRow(rowNode, editor));
	});
	return {
		type: "table",
		children: rows
	};
}
function convertTableRow(node, editor) {
	const cells = [];
	node.forEach((cellNode) => {
		cells.push(convertTableCell(cellNode, editor));
	});
	return {
		type: "tableRow",
		children: cells
	};
}
function convertTableCell(node, editor) {
	const inlineContent = [];
	node.forEach((child) => {
		if (child.type.name === "paragraph") {
			if (inlineContent.length > 0) inlineContent.push({
				type: "text",
				value: " "
			});
			inlineContent.push(...convertInlineContent(child, editor));
		}
	});
	return {
		type: "tableCell",
		children: inlineContent
	};
}
function convertInlineContent(node, editor) {
	const result = [];
	node.forEach((child) => {
		result.push(...convertInlineNode(child, editor));
	});
	return result;
}
function convertInlineNode(node, editor) {
	switch (node.type.name) {
		case "run": return convertRunNode(node, editor);
		case "text": return [wrapWithMarks(node.text ?? "", node.marks)];
		case "lineBreak": return [{ type: "break" }];
		case "image": return [convertImageNode(node)];
		case "contentBlock": return [];
		default: return convertInlineContent(node, editor);
	}
}
function convertRunNode(node, editor) {
	const result = [];
	node.forEach((child) => {
		if (child.type.name === "text") {
			const text = child.text ?? "";
			const runProps = node.attrs.runProperties;
			if (isMonospaceRun(runProps)) {
				const code = {
					type: "inlineCode",
					value: text
				};
				result.push(wrapWithMarks(code, child.marks));
			} else result.push(wrapWithMarks(text, child.marks));
		} else result.push(...convertInlineNode(child, editor));
	});
	return result;
}
function isMonospaceRun(runProps) {
	if (!runProps) return false;
	const rFonts = runProps.rFonts;
	if (!rFonts) return false;
	return rFonts.ascii === "Courier New" || rFonts.hAnsi === "Courier New";
}
function convertImageNode(node) {
	return {
		type: "image",
		url: node.attrs.src ?? "",
		alt: node.attrs.alt ?? void 0,
		title: node.attrs.title ?? void 0
	};
}
var MARK_PRIORITY = {
	link: 0,
	strong: 1,
	bold: 1,
	emphasis: 2,
	italic: 2,
	delete: 3,
	strike: 3
};
function wrapWithMarks(content, marks) {
	let node = typeof content === "string" ? {
		type: "text",
		value: content
	} : content;
	if (!marks || marks.length === 0) return node;
	const sorted = [...marks].sort((a, b$1) => (MARK_PRIORITY[a.type.name] ?? 99) - (MARK_PRIORITY[b$1.type.name] ?? 99));
	for (let i = sorted.length - 1; i >= 0; i--) node = applyMark(sorted[i], node);
	return node;
}
function applyMark(mark, child) {
	switch (mark.type.name) {
		case "bold": return {
			type: "strong",
			children: [child]
		};
		case "italic": return {
			type: "emphasis",
			children: [child]
		};
		case "strike": return {
			type: "delete",
			children: [child]
		};
		case "link": return {
			type: "link",
			url: mark.attrs.href ?? "",
			title: mark.attrs.tooltip ?? void 0,
			children: [child]
		};
		case "textStyle":
			if (mark.attrs.fontFamily === "Courier New" && child.type === "text") return {
				type: "inlineCode",
				value: child.value
			};
			return child;
		default: return child;
	}
}
var remarkProcessor = unified().use(remarkGfm).use(remarkStringify, {
	bullet: "-",
	fences: true
});
function getMarkdownAdapter(editor, input) {
	const runtime = resolveStoryRuntime(editor, input.in);
	const mdastRoot = proseMirrorDocToMdast(runtime.editor.state.doc, runtime.editor);
	return remarkProcessor.stringify(mdastRoot);
}
var DEFAULT_UNFLATTEN_LISTS = true;
function getHtmlAdapter(editor, input) {
	const runtime = resolveStoryRuntime(editor, input.in);
	const unflattenLists = input.unflattenLists ?? DEFAULT_UNFLATTEN_LISTS;
	return runtime.editor.getHTML({ unflattenLists });
}
function markdownToFragmentAdapter(editor, input) {
	const { fragment, diagnostics: mdDiagnostics } = markdownToPmFragment(input.markdown, editor);
	const sdNodes = [];
	for (let i = 0; i < fragment.childCount; i++) sdNodes.push(projectContentNode(fragment.child(i)));
	const diagnostics = mdDiagnostics.map(bridgeDiagnostic);
	const lossy = diagnostics.some((d) => d.severity === "warning" || d.severity === "error");
	return {
		fragment: sdNodes.length === 1 ? sdNodes[0] : sdNodes,
		lossy,
		diagnostics
	};
}
function bridgeDiagnostic(md) {
	return {
		code: `MD_${md.nodeType.toUpperCase()}`,
		severity: md.severity === "error" ? "error" : "warning",
		message: md.message,
		...md.position ? { path: [`line:${md.position.line}`, `col:${md.position.column}`] } : {}
	};
}
const HEADING_STYLE_PATTERN = /^Heading\d$/;
function clampHeadingLevel(value) {
	if (typeof value !== "number" || !Number.isFinite(value)) return 1;
	const rounded = Math.floor(value);
	if (rounded < 1) return 1;
	if (rounded > 6) return 6;
	return rounded;
}
function isHeadingNodeInfo(node) {
	return node?.kind === "block" && node.nodeType === "heading";
}
function getHeadingText(node) {
	if (!node) return "";
	if (typeof node.text === "string" && node.text.length > 0) return node.text;
	if (typeof node.summary?.text === "string" && node.summary.text.length > 0) return node.summary.text;
	return "";
}
function buildOutline(result) {
	const outline = [];
	for (const item of result.items) {
		if (item.address.kind !== "block") continue;
		const maybeHeading = isHeadingNodeInfo(item.node) ? item.node : void 0;
		outline.push({
			level: clampHeadingLevel(maybeHeading?.properties.headingLevel),
			text: getHeadingText(maybeHeading),
			nodeId: item.address.nodeId
		});
	}
	return outline;
}
function extractTextFormatting(node) {
	let fontFamily;
	let fontSize;
	node.descendants((child) => {
		if (fontFamily !== void 0 || fontSize !== void 0) return false;
		const marks = child.marks ?? [];
		if (!child.isText || marks.length === 0) return;
		for (const mark of marks) {
			const attrs = mark.attrs;
			if (typeof attrs.fontFamily === "string" && attrs.fontFamily) fontFamily = attrs.fontFamily;
			if (attrs.fontSize != null) {
				const raw = typeof attrs.fontSize === "string" ? parseFloat(attrs.fontSize) : attrs.fontSize;
				if (typeof raw === "number" && Number.isFinite(raw)) fontSize = raw;
			}
		}
		return false;
	});
	return {
		fontFamily,
		fontSize
	};
}
function collectDocumentStyles(editor) {
	const headingPattern = HEADING_STYLE_PATTERN;
	const doc$1 = editor.state?.doc;
	if (!doc$1?.descendants) return {
		styles: { paragraphStyles: [] },
		defaults: { styleId: "Normal" }
	};
	const styleData = /* @__PURE__ */ new Map();
	const fontCounts = /* @__PURE__ */ new Map();
	const sizeCounts = /* @__PURE__ */ new Map();
	doc$1.descendants((node) => {
		if (node.type.name !== "paragraph") return;
		const sid = node.attrs.paragraphProperties?.styleId;
		const isHeading = sid ? headingPattern.test(sid) : false;
		const fmt = extractTextFormatting(node);
		if (sid) {
			const existing = styleData.get(sid);
			if (existing) {
				existing.count++;
				if (!existing.fontFamily && fmt.fontFamily) existing.fontFamily = fmt.fontFamily;
				if (existing.fontSize === void 0 && fmt.fontSize !== void 0) existing.fontSize = fmt.fontSize;
			} else styleData.set(sid, {
				count: 1,
				fontFamily: fmt.fontFamily,
				fontSize: fmt.fontSize
			});
		}
		if (!isHeading) {
			if (fmt.fontFamily) fontCounts.set(fmt.fontFamily, (fontCounts.get(fmt.fontFamily) ?? 0) + 1);
			if (fmt.fontSize !== void 0) sizeCounts.set(fmt.fontSize, (sizeCounts.get(fmt.fontSize) ?? 0) + 1);
		}
	});
	const paragraphStyles = Array.from(styleData.entries()).map(([styleId$1, data]) => ({
		styleId: styleId$1,
		count: data.count,
		...data.fontFamily ? { fontFamily: data.fontFamily } : {},
		...data.fontSize !== void 0 ? { fontSize: data.fontSize } : {}
	})).sort((a, b$1) => b$1.count - a.count);
	let defaultFont;
	let defaultSize;
	let maxFontCount = 0;
	for (const [font, count] of fontCounts) if (count > maxFontCount) {
		defaultFont = font;
		maxFontCount = count;
	}
	let maxSizeCount = 0;
	for (const [size$1, count] of sizeCounts) if (count > maxSizeCount) {
		defaultSize = size$1;
		maxSizeCount = count;
	}
	const bodyStyles = paragraphStyles.filter((s) => !headingPattern.test(s.styleId));
	const defaultStyle = bodyStyles.length > 0 ? bodyStyles[0].styleId : "Normal";
	const defaults = {
		...defaultFont ? { fontFamily: defaultFont } : {},
		...defaultSize !== void 0 ? { fontSize: defaultSize } : {},
		styleId: defaultStyle
	};
	return {
		styles: { paragraphStyles },
		defaults
	};
}
function infoAdapter(editor, _input) {
	const counts = getLiveDocumentCounts(editor);
	const headingResult = findLegacyAdapter(editor, {
		select: {
			type: "node",
			nodeType: "heading"
		},
		includeNodes: true
	});
	const { styles, defaults } = collectDocumentStyles(editor);
	return {
		counts,
		outline: buildOutline(headingResult),
		capabilities: {
			canFind: true,
			canGetNode: true,
			canComment: true,
			canReplace: true
		},
		revision: getRevision(editor),
		styles,
		defaults
	};
}
var FALLBACK_STORE_KEY = "__documentApiComments";
var DELETED_COMMENT_SNAPSHOT_KEY = "__documentApiDeletedCommentSnapshots";
function ensureFallbackStore(editor) {
	const storage = ensureEditorStorage(editor);
	if (!Array.isArray(storage[FALLBACK_STORE_KEY])) storage[FALLBACK_STORE_KEY] = [];
	return storage[FALLBACK_STORE_KEY];
}
function ensureEditorStorage(editor) {
	if (!editor.storage) editor.storage = {};
	return editor.storage;
}
function getDeletedCommentSnapshotStore(editor) {
	const storage = ensureEditorStorage(editor);
	const existing = storage[DELETED_COMMENT_SNAPSHOT_KEY];
	if (existing instanceof Map) return existing;
	const created = /* @__PURE__ */ new Map();
	storage[DELETED_COMMENT_SNAPSHOT_KEY] = created;
	return created;
}
function getCommentEntityStore(editor) {
	const mutableEditor = editor;
	const converter = mutableEditor.converter;
	if (converter) {
		if (!Array.isArray(converter.comments)) converter.comments = [];
		return converter.comments;
	}
	return ensureFallbackStore(mutableEditor);
}
function findCommentEntity(store, commentId) {
	return store.find((entry) => entry.commentId === commentId || entry.importedId === commentId);
}
function upsertCommentEntity(store, commentId, patch) {
	const existing = findCommentEntity(store, commentId);
	if (existing) {
		const resolvedId = typeof existing.commentId === "string" && existing.commentId.length > 0 ? existing.commentId : commentId;
		Object.assign(existing, patch, { commentId: resolvedId });
		return existing;
	}
	const created = {
		...patch,
		commentId
	};
	store.push(created);
	return created;
}
function removeCommentEntityTree(store, commentId) {
	const root = findCommentEntity(store, commentId);
	if (!root || typeof root.commentId !== "string" || root.commentId.length === 0) return [];
	const removeIds = new Set([root.commentId]);
	let changed = true;
	while (changed) {
		changed = false;
		for (const entry of store) {
			if (typeof entry.commentId !== "string" || entry.commentId.length === 0) continue;
			if (typeof entry.parentCommentId !== "string" || entry.parentCommentId.length === 0) continue;
			if (removeIds.has(entry.parentCommentId) && !removeIds.has(entry.commentId)) {
				removeIds.add(entry.commentId);
				changed = true;
			}
		}
	}
	const removed = store.filter((entry) => typeof entry.commentId === "string" && removeIds.has(entry.commentId));
	const kept = store.filter((entry) => !(typeof entry.commentId === "string" && removeIds.has(entry.commentId)));
	store.splice(0, store.length, ...kept);
	return removed;
}
function commentEntityIdentity(entry) {
	return toNonEmptyString$1(entry?.commentId) ?? toNonEmptyString$1(entry?.importedId);
}
function stashRemovedCommentEntities(editor, removed) {
	if (removed.length === 0) return;
	const snapshots = getDeletedCommentSnapshotStore(editor);
	for (const entry of removed) {
		const identity = commentEntityIdentity(entry);
		if (!identity) continue;
		snapshots.set(identity, { ...entry });
	}
}
function restoreStashedCommentEntityTree(editor, rootCommentId) {
	const snapshots = getDeletedCommentSnapshotStore(editor);
	const store = getCommentEntityStore(editor);
	const root = Array.from(snapshots.values()).find((entry) => toNonEmptyString$1(entry.commentId) === rootCommentId || toNonEmptyString$1(entry.importedId) === rootCommentId);
	if (!root) return [];
	const restoreIds = /* @__PURE__ */ new Set();
	const rootIdentity = commentEntityIdentity(root);
	if (!rootIdentity) return [];
	restoreIds.add(rootIdentity);
	let changed = true;
	while (changed) {
		changed = false;
		for (const entry of snapshots.values()) {
			const identity = commentEntityIdentity(entry);
			if (!identity || restoreIds.has(identity)) continue;
			const parentId = toNonEmptyString$1(entry.parentCommentId);
			if (!parentId || !restoreIds.has(parentId)) continue;
			restoreIds.add(identity);
			changed = true;
		}
	}
	const restored = [];
	for (const identity of restoreIds) {
		const snapshot = snapshots.get(identity);
		if (!snapshot) continue;
		upsertCommentEntity(store, identity, { ...snapshot });
		snapshots.delete(identity);
		restored.push(snapshot);
	}
	return restored;
}
function isDanglingOpenRootComment(entry, anchoredIds) {
	const commentId = toNonEmptyString$1(entry.commentId);
	const importedId = toNonEmptyString$1(entry.importedId);
	if (!commentId) return false;
	if (toNonEmptyString$1(entry.parentCommentId)) return false;
	if (isCommentResolved(entry)) return false;
	if (entry.trackedChange === true || toNonEmptyString$1(entry.trackedChangeParentId)) return false;
	if (anchoredIds.has(commentId)) return false;
	if (importedId && anchoredIds.has(importedId)) return false;
	return true;
}
function reconcileCommentEntityStoreWithAnchors(editor, anchoredCommentIds) {
	const anchoredIds = new Set(Array.from(anchoredCommentIds, (value) => toNonEmptyString$1(value)).filter((value) => !!value));
	const restored = [];
	for (const anchoredId of anchoredIds) restored.push(...restoreStashedCommentEntityTree(editor, anchoredId));
	const store = getCommentEntityStore(editor);
	const removed = [];
	const prunedRootIds = /* @__PURE__ */ new Set();
	for (const entry of [...store]) {
		const commentId = toNonEmptyString$1(entry.commentId);
		if (!commentId || prunedRootIds.has(commentId)) continue;
		if (!isDanglingOpenRootComment(entry, anchoredIds)) continue;
		const removedTree = removeCommentEntityTree(store, commentId);
		if (!removedTree.length) continue;
		stashRemovedCommentEntities(editor, removedTree);
		removed.push(...removedTree);
		prunedRootIds.add(commentId);
	}
	return {
		restored,
		removed
	};
}
function collectTextFragments(value, sink) {
	if (!value) return;
	if (typeof value === "string") {
		if (value.length > 0) sink.push(value);
		return;
	}
	if (Array.isArray(value)) {
		for (const item of value) collectTextFragments(item, sink);
		return;
	}
	if (typeof value !== "object") return;
	const record = value;
	if (typeof record.text === "string" && record.text.length > 0) sink.push(record.text);
	if (record.content) collectTextFragments(record.content, sink);
	if (record.elements) collectTextFragments(record.elements, sink);
	if (record.nodes) collectTextFragments(record.nodes, sink);
}
function hasOwnProperty(record, key) {
	return Object.prototype.hasOwnProperty.call(record, key);
}
function hasCommentBodyPayload(raw) {
	return hasOwnProperty(raw, "commentText") || hasOwnProperty(raw, "text") || hasOwnProperty(raw, "commentJSON") || hasOwnProperty(raw, "elements");
}
function isSyntheticTrackedChangeProjection(raw) {
	if (raw.trackedChange !== true) return false;
	return !hasCommentBodyPayload(raw) && !hasOwnProperty(raw, "parentCommentId");
}
function extractCommentText(entry) {
	if (typeof entry.commentText === "string") return entry.commentText;
	const fragments = [];
	if (entry.commentJSON) collectTextFragments(entry.commentJSON, fragments);
	if (entry.elements) collectTextFragments(entry.elements, fragments);
	if (!fragments.length) return void 0;
	return fragments.join("").trim();
}
function isCommentResolved(entry) {
	return Boolean(entry.isDone || entry.resolvedTime);
}
function syncCommentEntitiesFromCollaboration(editor, entries, options = {}) {
	const store = getCommentEntityStore(editor);
	const seen = /* @__PURE__ */ new Set();
	const upstreamIds = /* @__PURE__ */ new Set();
	const validEntries = [];
	for (const raw of entries) {
		if (!raw || typeof raw !== "object") continue;
		if (isSyntheticTrackedChangeProjection(raw)) continue;
		const cid = toNonEmptyString$1(raw.commentId);
		const iid = toNonEmptyString$1(raw.importedId);
		if (cid) upstreamIds.add(cid);
		if (iid) upstreamIds.add(iid);
		validEntries.push(raw);
	}
	let changed = true;
	while (changed) {
		changed = false;
		for (const raw of validEntries) {
			const parentRef = toNonEmptyString$1(raw.parentCommentId);
			if (!parentRef) continue;
			if (upstreamIds.has(parentRef)) continue;
			const cid = toNonEmptyString$1(raw.commentId);
			const iid = toNonEmptyString$1(raw.importedId);
			if (cid && upstreamIds.delete(cid)) changed = true;
			if (iid && upstreamIds.delete(iid)) changed = true;
		}
	}
	for (const raw of validEntries) {
		const commentId = toNonEmptyString$1(raw.commentId) ?? toNonEmptyString$1(raw.importedId);
		if (!commentId) continue;
		if (!upstreamIds.has(commentId)) continue;
		seen.add(commentId);
		const patch = {};
		if (typeof raw.importedId === "string") patch.importedId = raw.importedId;
		if (typeof raw.parentCommentId === "string") patch.parentCommentId = raw.parentCommentId;
		if (raw.trackedChangeParentId === null) patch.trackedChangeParentId = null;
		if (typeof raw.trackedChangeParentId === "string") patch.trackedChangeParentId = raw.trackedChangeParentId;
		const commentText = typeof raw.commentText === "string" ? raw.commentText : typeof raw.text === "string" ? raw.text : void 0;
		if (commentText !== void 0) patch.commentText = commentText;
		if (raw.commentJSON !== void 0) patch.commentJSON = raw.commentJSON;
		if (raw.elements !== void 0) patch.elements = raw.elements;
		if (typeof raw.creatorName === "string") patch.creatorName = raw.creatorName;
		if (typeof raw.creatorEmail === "string") patch.creatorEmail = raw.creatorEmail;
		if (typeof raw.creatorImage === "string") patch.creatorImage = raw.creatorImage;
		if (typeof raw.createdTime === "number") patch.createdTime = raw.createdTime;
		if (typeof raw.trackedChange === "boolean") patch.trackedChange = raw.trackedChange;
		const normalizedTrackedChangeType = normalizeTrackedChangeType(raw.trackedChangeType);
		if (normalizedTrackedChangeType !== void 0) patch.trackedChangeType = normalizedTrackedChangeType;
		if (raw.trackedChangeType === null) patch.trackedChangeType = null;
		if (typeof raw.trackedChangeDisplayType === "string") patch.trackedChangeDisplayType = raw.trackedChangeDisplayType;
		if (raw.trackedChangeDisplayType === null) patch.trackedChangeDisplayType = null;
		if (raw.trackedChangeStory === null) patch.trackedChangeStory = null;
		if (raw.trackedChangeStory && typeof raw.trackedChangeStory === "object") patch.trackedChangeStory = raw.trackedChangeStory;
		if (typeof raw.trackedChangeStoryKind === "string") patch.trackedChangeStoryKind = raw.trackedChangeStoryKind;
		if (raw.trackedChangeStoryKind === null) patch.trackedChangeStoryKind = null;
		if (typeof raw.trackedChangeStoryLabel === "string") patch.trackedChangeStoryLabel = raw.trackedChangeStoryLabel;
		if (raw.trackedChangeStoryLabel === null) patch.trackedChangeStoryLabel = null;
		if (typeof raw.trackedChangeAnchorKey === "string") patch.trackedChangeAnchorKey = raw.trackedChangeAnchorKey;
		if (raw.trackedChangeAnchorKey === null) patch.trackedChangeAnchorKey = null;
		if (typeof raw.trackedChangeText === "string") patch.trackedChangeText = raw.trackedChangeText;
		if (raw.trackedChangeText === null) patch.trackedChangeText = null;
		if (typeof raw.deletedText === "string") patch.deletedText = raw.deletedText;
		if (raw.deletedText === null) patch.deletedText = null;
		if (typeof raw.isInternal === "boolean") patch.isInternal = raw.isInternal;
		if (typeof raw.isDone === "boolean") patch.isDone = raw.isDone;
		if (typeof raw.resolvedTime === "number") patch.resolvedTime = raw.resolvedTime;
		if (raw.resolvedTime === null) patch.resolvedTime = null;
		if (typeof raw.resolvedByEmail === "string") patch.resolvedByEmail = raw.resolvedByEmail;
		if (typeof raw.resolvedByName === "string") patch.resolvedByName = raw.resolvedByName;
		upsertCommentEntity(store, commentId, patch);
	}
	if (options.previouslySynced) {
		for (const priorId of options.previouslySynced) if (!seen.has(priorId)) removeCommentEntityTree(store, priorId);
	}
	return seen;
}
function toNonEmptyString$1(value) {
	if (typeof value !== "string") return void 0;
	const trimmed = value.trim();
	return trimmed.length > 0 ? trimmed : void 0;
}
function normalizeTrackedChangeType(value) {
	switch (toNonEmptyString$1(value)) {
		case "insert":
		case "trackInsert": return "insert";
		case "delete":
		case "trackDelete": return "delete";
		case "replacement":
		case "both": return "replacement";
		case "format":
		case "trackFormat": return "format";
		default: return;
	}
}
function normalizeTrackedChangeLink(link) {
	if (!link) return link;
	return {
		...link,
		trackedChangeType: normalizeTrackedChangeType(link.trackedChangeType)
	};
}
function toCommentInfo(entry, options = {}) {
	const resolvedId = typeof entry.commentId === "string" ? entry.commentId : String(entry.importedId ?? "");
	const status = options.status ?? (isCommentResolved(entry) ? "resolved" : "open");
	const trackedChangeLink = options.trackedChangeLink !== void 0 ? normalizeTrackedChangeLink(options.trackedChangeLink) : entry.trackedChange === true || entry.trackedChangeType != null || entry.trackedChangeAnchorKey != null || entry.trackedChangeText != null || entry.deletedText != null ? {
		trackedChange: true,
		trackedChangeType: normalizeTrackedChangeType(entry.trackedChangeType),
		trackedChangeDisplayType: entry.trackedChangeDisplayType ?? null,
		trackedChangeStory: entry.trackedChangeStory ?? null,
		trackedChangeAnchorKey: entry.trackedChangeAnchorKey ?? null,
		trackedChangeText: entry.trackedChangeText ?? null,
		deletedText: entry.deletedText ?? null
	} : null;
	return {
		address: {
			kind: "entity",
			entityType: "comment",
			entityId: resolvedId
		},
		commentId: resolvedId,
		importedId: typeof entry.importedId === "string" ? entry.importedId : void 0,
		parentCommentId: typeof entry.parentCommentId === "string" ? entry.parentCommentId : void 0,
		text: extractCommentText(entry),
		isInternal: typeof entry.isInternal === "boolean" ? entry.isInternal : void 0,
		status,
		target: options.target,
		anchoredText: options.anchoredText,
		createdTime: typeof entry.createdTime === "number" ? entry.createdTime : void 0,
		creatorName: typeof entry.creatorName === "string" ? entry.creatorName : void 0,
		creatorEmail: typeof entry.creatorEmail === "string" ? entry.creatorEmail : void 0,
		trackedChange: trackedChangeLink?.trackedChange === true ? true : void 0,
		trackedChangeType: trackedChangeLink?.trackedChangeType,
		trackedChangeDisplayType: trackedChangeLink?.trackedChangeDisplayType ?? void 0,
		trackedChangeStory: trackedChangeLink?.trackedChangeStory ?? void 0,
		trackedChangeAnchorKey: trackedChangeLink?.trackedChangeAnchorKey ?? void 0,
		trackedChangeText: trackedChangeLink?.trackedChangeText ?? void 0,
		deletedText: trackedChangeLink?.deletedText ?? void 0,
		trackedChangeLink
	};
}
function resolveCommentId(candidate) {
	return resolveCommentIdFromAttrs(candidate.attrs ?? {});
}
function resolveImportedId(candidate) {
	return toNonEmptyString((candidate.attrs ?? {}).importedId);
}
function toTextAddress(candidate) {
	const { start: start$1, end: end$1 } = candidate.anchor;
	if (start$1.blockId !== end$1.blockId) return null;
	return {
		kind: "text",
		blockId: start$1.blockId,
		range: {
			start: start$1.offset,
			end: end$1.offset
		}
	};
}
function listCommentAnchors(editor) {
	const candidates = getInlineIndex(editor).byType.get("comment") ?? [];
	const anchors = [];
	const seen = /* @__PURE__ */ new Set();
	for (const candidate of candidates) {
		const commentId = resolveCommentId(candidate);
		if (!commentId) continue;
		const target = toTextAddress(candidate);
		if (!target) continue;
		const dedupeKey = `${commentId}|${target.blockId}:${target.range.start}:${target.range.end}`;
		if (seen.has(dedupeKey)) continue;
		seen.add(dedupeKey);
		const attrs = candidate.attrs ?? {};
		const isInternal = typeof attrs.internal === "boolean" ? attrs.internal : void 0;
		const status = candidate.mark ? "open" : "resolved";
		anchors.push({
			commentId,
			importedId: resolveImportedId(candidate),
			status,
			target,
			isInternal,
			pos: candidate.pos,
			end: candidate.end,
			attrs
		});
	}
	return anchors;
}
function resolveCommentAnchorsById(editor, commentId) {
	return listCommentAnchors(editor).filter((anchor) => anchor.commentId === commentId || anchor.importedId === commentId);
}
const TRACKED_CHANGE_ANCHOR_KEY_PREFIX = "tc::";
const COMMENT_ANCHOR_KEY_PREFIX = "comment::";
function makeTrackedChangeAnchorKey(ref$1) {
	return `${TRACKED_CHANGE_ANCHOR_KEY_PREFIX}${ref$1.storyKey}::${ref$1.rawId}`;
}
function makeCommentAnchorKey(commentId) {
	return `${COMMENT_ANCHOR_KEY_PREFIX}${commentId}`;
}
function isTrackedChangeAnchorKey(key) {
	return typeof key === "string" && key.startsWith("tc::");
}
function isCommentAnchorKey(key) {
	return typeof key === "string" && key.startsWith("comment::");
}
function parseTrackedChangeAnchorKey(key) {
	if (!isTrackedChangeAnchorKey(key)) return null;
	const body = key.slice(4);
	const separatorIndex = body.lastIndexOf("::");
	if (separatorIndex <= 0 || separatorIndex >= body.length - 2) return null;
	const storyKey = body.slice(0, separatorIndex);
	const rawId = body.slice(separatorIndex + 2);
	if (!storyKey || !rawId) return null;
	return {
		storyKey,
		rawId
	};
}
function getConverter$8(editor) {
	return editor.converter;
}
function toRevisionCapableNoteId(note) {
	if (!note || note.id === void 0 || note.id === null) return null;
	const numeric = Number(note.id);
	if (Number.isFinite(numeric) && numeric < 0) return null;
	const noteId = String(note.id);
	return noteId.length > 0 ? noteId : null;
}
function enumerateRevisionCapableStories(editor) {
	const stories = [{
		kind: "story",
		storyType: "body"
	}];
	const converter = getConverter$8(editor);
	if (!converter) return stories;
	if (converter.headers) for (const refId of Object.keys(converter.headers)) stories.push({
		kind: "story",
		storyType: "headerFooterPart",
		refId
	});
	if (converter.footers) for (const refId of Object.keys(converter.footers)) stories.push({
		kind: "story",
		storyType: "headerFooterPart",
		refId
	});
	if (Array.isArray(converter.footnotes)) for (const note of converter.footnotes) {
		const noteId = toRevisionCapableNoteId(note);
		if (!noteId) continue;
		stories.push({
			kind: "story",
			storyType: "footnote",
			noteId
		});
	}
	if (Array.isArray(converter.endnotes)) for (const note of converter.endnotes) {
		const noteId = toRevisionCapableNoteId(note);
		if (!noteId) continue;
		stories.push({
			kind: "story",
			storyType: "endnote",
			noteId
		});
	}
	return stories;
}
function classifyStoryKind(locator) {
	switch (locator.storyType) {
		case "body": return "body";
		case "headerFooterSlot":
		case "headerFooterPart": return "headerFooter";
		case "footnote": return "footnote";
		case "endnote": return "endnote";
	}
}
function capitalize(word$1) {
	if (!word$1) return word$1;
	return word$1.charAt(0).toUpperCase() + word$1.slice(1);
}
function variantLabel(variant) {
	switch (variant) {
		case "first": return "First page";
		case "even": return "Even pages";
		case "default": return "Default";
	}
}
function describeStoryLocation(locator) {
	switch (locator.storyType) {
		case "body": return "";
		case "headerFooterSlot": {
			const kind = capitalize(locator.headerFooterKind);
			const variant = variantLabel(locator.variant);
			const section = locator.section.sectionId;
			if (variant === "Default") return `${kind} · Section ${section}`;
			return `${kind} · Section ${section} · ${variant}`;
		}
		case "headerFooterPart": return `Header/Footer · ${locator.refId}`;
		case "footnote": return `Footnote ${locator.noteId}`;
		case "endnote": return `Endnote ${locator.noteId}`;
	}
}
var indexByHost = /* @__PURE__ */ new WeakMap();
function getTrackedChangeIndex(hostEditor) {
	let index = indexByHost.get(hostEditor);
	if (!index) {
		index = new TrackedChangeIndexImpl(hostEditor);
		indexByHost.set(hostEditor, index);
	}
	return index;
}
function buildTrackedChangeAddress(locator, storyKey, canonicalId) {
	return {
		kind: "entity",
		entityType: "trackedChange",
		entityId: canonicalId,
		...storyKey === "body" ? {} : { story: locator }
	};
}
function addCanonicalAlias(map$1, alias, canonicalId) {
	const normalized = toNonEmptyString(alias);
	if (!normalized || map$1.has(normalized)) return;
	map$1.set(normalized, canonicalId);
}
function buildCanonicalIdByAlias(grouped) {
	const map$1 = /* @__PURE__ */ new Map();
	for (const change of grouped) {
		addCanonicalAlias(map$1, change.id, change.id);
		addCanonicalAlias(map$1, change.rawId, change.id);
		addCanonicalAlias(map$1, change.commandRawId, change.id);
		addCanonicalAlias(map$1, change.attrs.id, change.id);
		addCanonicalAlias(map$1, change.attrs.sourceId, change.id);
	}
	return map$1;
}
function resolveCanonicalId(alias, canonicalIdByAlias) {
	const normalized = toNonEmptyString(alias);
	if (!normalized) return void 0;
	return canonicalIdByAlias.get(normalized) ?? normalized;
}
function copyOverlapLayer(layer, canonicalIdByAlias) {
	const layerWithAliases = layer;
	return {
		id: resolveCanonicalId(layerWithAliases.rawId, canonicalIdByAlias) ?? resolveCanonicalId(layerWithAliases.commandRawId, canonicalIdByAlias) ?? resolveCanonicalId(layerWithAliases.id, canonicalIdByAlias) ?? layer.id,
		type: layer.type,
		relationship: layer.relationship
	};
}
function copyOverlapInfo(overlap, canonicalIdByAlias) {
	if (!overlap) return void 0;
	const visualLayers = overlap.visualLayers?.map((layer) => copyOverlapLayer(layer, canonicalIdByAlias));
	const preferredContextTarget = overlap.preferredContextTarget ? copyOverlapLayer(overlap.preferredContextTarget, canonicalIdByAlias) : void 0;
	const preferredContextTargetId = preferredContextTarget?.id ?? resolveCanonicalId(overlap.preferredContextTargetId, canonicalIdByAlias);
	return {
		...visualLayers && visualLayers.length > 0 ? { visualLayers } : {},
		...preferredContextTargetId ? { preferredContextTargetId } : {},
		...preferredContextTarget ? { preferredContextTarget } : {}
	};
}
var TrackedChangeIndexImpl = class {
	#hostEditor;
	#snapshots = /* @__PURE__ */ new Map();
	#aggregated = null;
	#dirtyStoryKeys = /* @__PURE__ */ new Set();
	#listeners = /* @__PURE__ */ new Set();
	#teardowns = [];
	#broadcastScheduled = false;
	#pendingBroadcastStories = null;
	#pendingBroadcastSource = null;
	#bodyDirty = true;
	constructor(hostEditor) {
		this.#hostEditor = hostEditor;
		this.#attachHostListeners();
	}
	get(locator) {
		const storyKey = buildStoryKey(locator);
		return this.#getByKey(storyKey, locator);
	}
	getAll() {
		if (this.#aggregated && this.#dirtyStoryKeys.size === 0) return this.#aggregated;
		const stories = enumerateRevisionCapableStories(this.#hostEditor);
		const flat = [];
		for (const story of stories) {
			const storyKey = buildStoryKey(story);
			const snapshots = this.#getByKey(storyKey, story);
			flat.push(...snapshots);
		}
		this.#aggregated = flat;
		return flat;
	}
	invalidate(locator) {
		const storyKey = buildStoryKey(locator);
		this.#invalidateKey(storyKey);
		this.#scheduleBroadcast([locator], "invalidate");
	}
	invalidateAll() {
		this.#snapshots.clear();
		this.#dirtyStoryKeys.clear();
		this.#aggregated = null;
		this.#bodyDirty = true;
		this.#scheduleBroadcast(void 0, "invalidateAll");
	}
	subscribe(listener) {
		this.#listeners.add(listener);
		return () => {
			this.#listeners.delete(listener);
		};
	}
	dispose() {
		for (const teardown of this.#teardowns) try {
			teardown();
		} catch {}
		this.#teardowns.length = 0;
		this.#listeners.clear();
		this.#snapshots.clear();
		this.#dirtyStoryKeys.clear();
		this.#aggregated = null;
		indexByHost.delete(this.#hostEditor);
	}
	#getByKey(storyKey, locator) {
		if (storyKey === "body") {
			if (this.#bodyDirty || !this.#snapshots.has(storyKey)) {
				const bodySnapshots = this.#buildSnapshotsFromEditor(this.#hostEditor, storyKey, locator);
				this.#snapshots.set(storyKey, bodySnapshots);
				this.#bodyDirty = false;
				this.#dirtyStoryKeys.delete(storyKey);
				this.#aggregated = null;
			}
			return this.#snapshots.get(storyKey) ?? [];
		}
		if (this.#dirtyStoryKeys.has(storyKey) || !this.#snapshots.has(storyKey)) {
			const snapshots = this.#computeStorySnapshots(locator, storyKey);
			this.#snapshots.set(storyKey, snapshots);
			this.#dirtyStoryKeys.delete(storyKey);
			this.#aggregated = null;
		}
		return this.#snapshots.get(storyKey) ?? [];
	}
	#computeStorySnapshots(locator, storyKey) {
		let runtime;
		try {
			runtime = resolveStoryRuntime(this.#hostEditor, locator);
		} catch {
			return [];
		}
		return this.#buildSnapshotsFromEditor(runtime.editor, storyKey, locator);
	}
	#buildSnapshotsFromEditor(editor, storyKey, locator) {
		const grouped = groupTrackedChanges(editor);
		if (grouped.length === 0) return [];
		const storyKind = classifyStoryKind(locator);
		const storyLabel = describeStoryLocation(locator);
		const canonicalIdByAlias = buildCanonicalIdByAlias(grouped);
		return grouped.map((change) => this.#buildSnapshot(editor, change, storyKey, locator, storyKind, storyLabel, canonicalIdByAlias));
	}
	#buildSnapshot(editor, change, storyKey, locator, storyKind, storyLabel, canonicalIdByAlias) {
		const runtimeRef = {
			storyKey,
			rawId: change.rawId
		};
		const address = buildTrackedChangeAddress(locator, storyKey, change.id);
		const type = resolveTrackedChangeType(change);
		const excerpt = (change.excerpt !== void 0 ? change.excerpt : void 0) ?? normalizeExcerpt(editor.state.doc.textBetween(change.from, change.to, " ", "￼"));
		return {
			address,
			runtimeRef,
			story: locator,
			type,
			subtype: type === "structural" && change.structural ? change.structural.subtype : void 0,
			author: toNonEmptyString(change.attrs.author),
			authorEmail: toNonEmptyString(change.attrs.authorEmail),
			authorImage: toNonEmptyString(change.attrs.authorImage),
			date: toNonEmptyString(change.attrs.date),
			excerpt,
			wordRevisionIds: change.wordRevisionIds ? { ...change.wordRevisionIds } : void 0,
			origin: toNonEmptyString(change.attrs.origin),
			imported: Boolean(toNonEmptyString(change.attrs.sourceId)),
			overlap: copyOverlapInfo(change.overlap, canonicalIdByAlias),
			storyLabel,
			storyKind,
			anchorKey: makeTrackedChangeAnchorKey(runtimeRef),
			commandRawId: change.commandRawId,
			replacementGroupId: toNonEmptyString(change.attrs.replacementGroupId),
			replacementSideId: toNonEmptyString(change.attrs.replacementSideId),
			hasInsert: change.hasInsert,
			hasDelete: change.hasDelete,
			hasFormat: change.hasFormat,
			range: {
				from: change.from,
				to: change.to
			}
		};
	}
	#attachHostListeners() {
		const editor = this.#hostEditor;
		if (typeof editor.on !== "function") return;
		const onTransaction = ({ transaction }) => {
			if (!transaction.docChanged) return;
			this.#bodyDirty = true;
			this.#aggregated = null;
			this.#scheduleBroadcast([{
				kind: "story",
				storyType: "body"
			}], "body-edit");
		};
		editor.on("transaction", onTransaction);
		this.#teardowns.push(() => editor.off?.("transaction", onTransaction));
		const onPartChanged = (event) => {
			const invalidatedStories = this.#storiesFromPartChange(event);
			if (invalidatedStories.length === 0) return;
			for (const story of invalidatedStories) this.#invalidateKey(buildStoryKey(story));
			this.#scheduleBroadcast(invalidatedStories, "partChanged");
		};
		editor.on("partChanged", onPartChanged);
		this.#teardowns.push(() => editor.off?.("partChanged", onPartChanged));
		const onNotesChanged = () => {
			const wiped = [];
			for (const key of Array.from(this.#snapshots.keys())) {
				if (!key.startsWith("fn:") && !key.startsWith("en:")) continue;
				this.#invalidateKey(key);
				const storyType = key.startsWith("fn:") ? "footnote" : "endnote";
				const noteId = key.slice(storyType === "footnote" ? 3 : 3);
				wiped.push({
					kind: "story",
					storyType,
					noteId
				});
			}
			if (wiped.length > 0) {
				this.#scheduleBroadcast(wiped, "notes-part-changed");
				return;
			}
			this.#aggregated = null;
			this.#scheduleBroadcast(void 0, "notes-part-changed");
		};
		editor.on("notes-part-changed", onNotesChanged);
		this.#teardowns.push(() => editor.off?.("notes-part-changed", onNotesChanged));
		const onDestroy = () => {
			this.dispose();
		};
		editor.on("destroy", onDestroy);
		this.#teardowns.push(() => editor.off?.("destroy", onDestroy));
	}
	#storiesFromPartChange(event) {
		const stories = [];
		const relsData = this.#hostEditor.converter?.convertedXml?.["word/_rels/document.xml.rels"];
		for (const part of event.parts) {
			if (!isHeaderFooterPartId(part.partId)) continue;
			const refId = resolveRIdFromRelsData(relsData, part.partId);
			if (!refId) continue;
			stories.push({
				kind: "story",
				storyType: "headerFooterPart",
				refId
			});
		}
		return stories;
	}
	#invalidateKey(storyKey) {
		if (storyKey === "body") this.#bodyDirty = true;
		else {
			this.#dirtyStoryKeys.add(storyKey);
			this.#snapshots.delete(storyKey);
		}
		this.#aggregated = null;
	}
	#scheduleBroadcast(stories, source) {
		this.#pendingBroadcastStories = this.#mergePendingStories(this.#pendingBroadcastStories, stories);
		this.#pendingBroadcastSource = this.#mergePendingSource(this.#pendingBroadcastSource, source);
		if (this.#broadcastScheduled) return;
		this.#broadcastScheduled = true;
		Promise.resolve().then(() => {
			this.#broadcastScheduled = false;
			const pendingStories = this.#pendingBroadcastStories;
			const pendingSource = this.#pendingBroadcastSource;
			this.#pendingBroadcastStories = null;
			this.#pendingBroadcastSource = null;
			this.#emitHostEvent(pendingStories ?? void 0, pendingSource ?? void 0);
			this.#notifySubscribers();
		});
	}
	#mergePendingStories(current, next) {
		if (current === void 0 || next === void 0) return void 0;
		const merged = /* @__PURE__ */ new Map();
		for (const story of current ?? []) merged.set(buildStoryKey(story), story);
		for (const story of next ?? []) merged.set(buildStoryKey(story), story);
		return Array.from(merged.values());
	}
	#mergePendingSource(current, next) {
		if (current === null) return next;
		if (current === void 0 || current === next) return current;
	}
	#emitHostEvent(stories, source) {
		const editor = this.#hostEditor;
		if (typeof editor.emit !== "function") return;
		editor.emit("tracked-changes-changed", {
			editor,
			stories,
			source
		});
	}
	#notifySubscribers() {
		if (this.#listeners.size === 0) return;
		const snapshot = this.getAll();
		for (const listener of Array.from(this.#listeners)) try {
			listener(snapshot);
		} catch {}
	}
};
function normalizeWordRevisionIds(wordRevisionIds) {
	if (!wordRevisionIds) return void 0;
	const normalized = {};
	if (wordRevisionIds.insert) normalized.insert = wordRevisionIds.insert;
	if (wordRevisionIds.delete) normalized.delete = wordRevisionIds.delete;
	if (wordRevisionIds.format) normalized.format = wordRevisionIds.format;
	return Object.keys(normalized).length > 0 ? normalized : void 0;
}
var projectedTrackedChangeCache = /* @__PURE__ */ new WeakMap();
function readReplacementsMode(editor) {
	return editor?.options?.trackedChanges?.replacements === "independent" ? "independent" : "paired";
}
function buildChangedTextFields(type, excerpt) {
	if (!excerpt) return {};
	if (type === "insert") return { insertedText: excerpt };
	if (type === "delete") return { deletedText: excerpt };
	return {};
}
function buildProjectedInfo(snapshot, options = {}) {
	const id = options.id ?? snapshot.address.entityId;
	const type = options.type ?? projectInternalTrackChangeType(snapshot.type, { subtype: snapshot.subtype });
	return {
		info: {
			address: {
				...snapshot.address,
				entityId: id
			},
			id,
			type,
			grouping: options.grouping,
			pairedWithChangeId: options.pairedWithChangeId ?? void 0,
			wordRevisionIds: normalizeWordRevisionIds(snapshot.wordRevisionIds),
			overlap: snapshot.overlap,
			author: snapshot.author,
			authorEmail: snapshot.authorEmail,
			authorImage: snapshot.authorImage,
			date: snapshot.date,
			excerpt: snapshot.excerpt,
			...buildChangedTextFields(type, snapshot.excerpt),
			origin: snapshot.origin,
			imported: snapshot.imported
		},
		handleKey: `${snapshot.anchorKey}${options.handleSuffix ?? ""}`,
		snapshot
	};
}
function isCombinedReplacementSnapshot(snapshot) {
	return snapshot.hasInsert && snapshot.hasDelete;
}
function replacementPairKey(snapshot) {
	if (snapshot.type !== "insert" && snapshot.type !== "delete") return null;
	if (snapshot.replacementGroupId) return `group:${snapshot.runtimeRef.storyKey}:${snapshot.replacementGroupId}`;
	if (snapshot.commandRawId) return `command:${snapshot.runtimeRef.storyKey}:${snapshot.commandRawId}`;
	return null;
}
function projectedSnapshotType(snapshot) {
	return isCombinedReplacementSnapshot(snapshot) ? "replacement" : projectInternalTrackChangeType(snapshot.type, { subtype: snapshot.subtype });
}
function snapshotGrouping(snapshot) {
	return isCombinedReplacementSnapshot(snapshot) ? "replacement-pair" : "standalone";
}
function snapshotToProjected(snapshot) {
	return buildProjectedInfo(snapshot, {
		type: projectedSnapshotType(snapshot),
		grouping: snapshotGrouping(snapshot),
		pairedWithChangeId: null
	});
}
function snapshotToInfo(snapshot) {
	return snapshotToProjected(snapshot).info;
}
function mergeWordRevisionIdsFromPair(inserted, deleted) {
	return normalizeWordRevisionIds({
		insert: inserted.wordRevisionIds?.insert,
		delete: deleted.wordRevisionIds?.delete,
		format: inserted.wordRevisionIds?.format ?? deleted.wordRevisionIds?.format
	});
}
function projectSplitReplacementPair(group) {
	const inserted = group.find((snapshot) => snapshot.type === "insert");
	const deleted = group.find((snapshot) => snapshot.type === "delete");
	if (!inserted || !deleted) return null;
	const projected = buildProjectedInfo(inserted, {
		type: "replacement",
		grouping: "replacement-pair",
		pairedWithChangeId: null
	});
	projected.info.wordRevisionIds = mergeWordRevisionIdsFromPair(inserted, deleted);
	projected.info.insertedText = inserted.excerpt;
	projected.info.deletedText = deleted.excerpt;
	return projected;
}
function projectSnapshots(snapshots, replacements = "paired") {
	const byPairKey = /* @__PURE__ */ new Map();
	for (const snapshot of snapshots) {
		if (isCombinedReplacementSnapshot(snapshot)) continue;
		const key = replacementPairKey(snapshot);
		if (!key) continue;
		const group = byPairKey.get(key) ?? [];
		group.push(snapshot);
		byPairKey.set(key, group);
	}
	const collapsedByPairKey = /* @__PURE__ */ new Map();
	if (replacements === "paired") for (const [key, group] of byPairKey.entries()) {
		const collapsed = projectSplitReplacementPair(group);
		if (collapsed) collapsedByPairKey.set(key, collapsed);
	}
	const projected = [];
	const emittedPairKeys = /* @__PURE__ */ new Set();
	for (const snapshot of snapshots) {
		if (isCombinedReplacementSnapshot(snapshot)) {
			projected.push(snapshotToProjected(snapshot));
			continue;
		}
		const pairKey = replacementPairKey(snapshot);
		if (pairKey && replacements === "paired") {
			const collapsed = collapsedByPairKey.get(pairKey);
			if (collapsed) {
				if (!emittedPairKeys.has(pairKey)) {
					emittedPairKeys.add(pairKey);
					projected.push(collapsed);
				}
				continue;
			}
		}
		projected.push(buildProjectedInfo(snapshot, {
			grouping: "standalone",
			pairedWithChangeId: null
		}));
	}
	return projected;
}
function cacheProjectedTrackedChanges(editor, projected, revision = getRevision(editor)) {
	projectedTrackedChangeCache.set(editor, {
		revision,
		byProjectedId: new Map(projected.map((row) => [row.info.id, row.snapshot]))
	});
}
function getCachedProjectedTrackedChangeSnapshot(editor, projectedId) {
	const cache$2 = projectedTrackedChangeCache.get(editor);
	if (!cache$2) return null;
	if (cache$2.revision !== getRevision(editor)) return null;
	return cache$2.byProjectedId.get(projectedId) ?? null;
}
function filterProjectedByType(rows, requestedType) {
	if (!requestedType) return [...rows];
	return rows.filter((row) => row.info.type === requestedType);
}
function toNoOpReceipt(message, details) {
	return {
		success: false,
		failure: {
			code: "NO_OP",
			message,
			details
		}
	};
}
function decisionFailureReceipt(editor, fallbackMessage, fallbackDetails) {
	const failureInfo = editor.storage?.trackChanges?.lastDecisionFailure ?? null;
	if (!failureInfo?.code) return toNoOpReceipt(fallbackMessage, fallbackDetails);
	return {
		success: false,
		failure: {
			code: failureInfo.code,
			message: failureInfo.message ?? fallbackMessage,
			details: failureInfo.details ?? fallbackDetails
		}
	};
}
function commentEntityId(record) {
	return toNonEmptyString(record.commentId) ?? toNonEmptyString(record.importedId);
}
function isTrackedChangeLinkedRootComment(record) {
	return !toNonEmptyString(record.parentCommentId) && (record.trackedChange === true || toNonEmptyString(record.trackedChangeParentId) != null || record.trackedChangeType != null || record.trackedChangeAnchorKey != null);
}
function trackedCommentRootHasLiveAnchors(editor, commentId, record) {
	const aliases = new Set([commentId, toNonEmptyString(record.importedId)].filter((value) => !!value));
	for (const alias of aliases) if (resolveCommentAnchorsById(editor, alias).length > 0) return true;
	return false;
}
function emitDeletedCommentUpdate(editor, commentId) {
	const emitter = editor.emit;
	if (typeof emitter !== "function") return;
	const documentId = toNonEmptyString(editor.options?.documentId) ?? null;
	emitter.call(editor, "commentsUpdate", {
		type: "deleted",
		comment: {
			commentId,
			documentId,
			fileId: documentId
		}
	});
}
function pruneMissingTrackedCommentRoots(editor) {
	const store = getCommentEntityStore(editor);
	const rootIds = Array.from(new Set(store.filter(isTrackedChangeLinkedRootComment).map((record) => commentEntityId(record)).filter((commentId) => commentId != null)));
	const removedIds = /* @__PURE__ */ new Set();
	for (const commentId of rootIds) {
		const record = findCommentEntity(store, commentId);
		if (!record) continue;
		if (trackedCommentRootHasLiveAnchors(editor, commentId, record)) continue;
		const removed = removeCommentEntityTree(store, commentId);
		stashRemovedCommentEntities(editor, removed);
		for (const removedRecord of removed) {
			const removedId = commentEntityId(removedRecord);
			if (removedId) removedIds.add(removedId);
		}
	}
	return Array.from(removedIds);
}
function applyDecisionCommentEffects(hostEditor, decisionEditor) {
	const storage = decisionEditor.storage;
	const store = getCommentEntityStore(hostEditor);
	const receipt = storage?.trackChanges?.lastDecisionReceipt ?? null;
	const deletedCommentIds = new Set((receipt?.deletedComments ?? []).map((entry) => toNonEmptyString(entry?.id)).filter(Boolean));
	const detachedCommentIds = new Set((receipt?.detachedComments ?? []).map((entry) => toNonEmptyString(entry?.id)).filter((id) => Boolean(id) && !deletedCommentIds.has(id)));
	for (const commentId of deletedCommentIds) stashRemovedCommentEntities(hostEditor, removeCommentEntityTree(store, commentId));
	for (const commentId of detachedCommentIds) {
		const record = findCommentEntity(store, commentId);
		if (!record) continue;
		record.trackedChange = false;
		record.trackedChangeParentId = null;
		record.trackedChangeType = null;
		record.trackedChangeDisplayType = null;
		record.trackedChangeStory = null;
		record.trackedChangeStoryKind = null;
		record.trackedChangeStoryLabel = null;
		record.trackedChangeAnchorKey = null;
		record.trackedChangeText = null;
		record.deletedText = null;
	}
	const prunedCommentIds = pruneMissingTrackedCommentRoots(hostEditor);
	for (const commentId of prunedCommentIds) emitDeletedCommentUpdate(hostEditor, commentId);
}
function resolveListScope(input) {
	if (!input || input.in === void 0) return "body";
	if (input.in === "all") return "all";
	return { story: input.in };
}
function trackChangesListWrapper(editor, input) {
	validatePaginationInput(input?.offset, input?.limit);
	const index = getTrackedChangeIndex(editor);
	const scope = resolveListScope(input);
	let rawSnapshots;
	if (scope === "all") rawSnapshots = index.getAll();
	else if (scope === "body") rawSnapshots = index.get({
		kind: "story",
		storyType: "body"
	});
	else rawSnapshots = index.get(scope.story);
	const projected = projectSnapshots(rawSnapshots, readReplacementsMode(editor));
	const evaluatedRevision = getRevision(editor);
	cacheProjectedTrackedChanges(editor, projected, evaluatedRevision);
	const paged = paginate(filterProjectedByType(projected, input?.type), input?.offset, input?.limit);
	const items = paged.items.map((row) => {
		const info = row.info;
		const handle = buildResolvedHandle(row.handleKey, "stable", "trackedChange");
		const { address, type, grouping, pairedWithChangeId, wordRevisionIds, overlap, author, authorEmail, authorImage, date, excerpt, insertedText, deletedText, origin, imported } = info;
		return buildDiscoveryItem(info.id, handle, {
			address,
			type,
			grouping,
			pairedWithChangeId,
			wordRevisionIds,
			overlap,
			author,
			authorEmail,
			authorImage,
			date,
			excerpt,
			insertedText,
			deletedText,
			origin,
			imported
		});
	});
	return buildDiscoveryResult({
		evaluatedRevision,
		total: paged.total,
		items,
		page: {
			limit: input?.limit ?? paged.total,
			offset: input?.offset ?? 0,
			returned: items.length
		}
	});
}
function trackChangesGetWrapper(editor, input) {
	const { id, story } = input;
	const resolved = resolveTrackedChangeInStory(editor, {
		kind: "entity",
		entityType: "trackedChange",
		entityId: id,
		...story ? { story } : {}
	});
	if (!resolved) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Tracked change "${id}" was not found.`, { id });
	const index = getTrackedChangeIndex(editor);
	const storyKey = buildStoryKey(resolved.story);
	const anchorKey = makeTrackedChangeAnchorKey(resolved.runtimeRef);
	const snapshots = storyKey === "body" ? index.get({
		kind: "story",
		storyType: "body"
	}) : index.get(resolved.story);
	const projectedMatch = projectSnapshots(snapshots, readReplacementsMode(editor)).find((row) => row.info.id === id);
	if (projectedMatch) return projectedMatch.info;
	const { baseId } = splitProjectedTrackedChangeId(id);
	const snapshot = snapshots.find((item) => item.anchorKey === anchorKey || item.address.entityId === baseId);
	if (snapshot) return snapshotToInfo(snapshot);
	const type = projectInternalTrackChangeType(resolveTrackedChangeType(resolved.change), resolved.change.structural);
	const excerpt = (resolved.change.excerpt !== void 0 ? resolved.change.excerpt : void 0) ?? normalizeExcerpt(resolved.editor.state.doc.textBetween(resolved.change.from, resolved.change.to, " ", "￼"));
	const grouping = resolved.change.hasInsert && resolved.change.hasDelete && !resolved.change.hasFormat ? "replacement-pair" : void 0;
	return {
		address: {
			kind: "entity",
			entityType: "trackedChange",
			entityId: resolved.change.id,
			...storyKey === "body" ? {} : { story: resolved.story }
		},
		id: resolved.change.id,
		type,
		grouping,
		wordRevisionIds: normalizeWordRevisionIds(resolved.change.wordRevisionIds),
		overlap: resolved.change.overlap,
		author: toNonEmptyString(resolved.change.attrs.author),
		authorEmail: toNonEmptyString(resolved.change.attrs.authorEmail),
		authorImage: toNonEmptyString(resolved.change.attrs.authorImage),
		date: toNonEmptyString(resolved.change.attrs.date),
		excerpt,
		...buildChangedTextFields(type, excerpt),
		origin: toNonEmptyString(resolved.change.attrs.origin),
		imported: Boolean(toNonEmptyString(resolved.change.attrs.sourceId))
	};
}
function decideSingle(hostEditor, decision, id, story, options) {
	const resolved = resolveTrackedChangeInStory(hostEditor, {
		kind: "entity",
		entityType: "trackedChange",
		entityId: id,
		...story ? { story } : {}
	});
	if (!resolved) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Tracked change "${id}" was not found.`, {
		id,
		story
	});
	const commandName = decision === "accept" ? "acceptTrackedChangeById" : "rejectTrackedChangeById";
	const command$1 = resolved.editor.commands[commandName];
	if (typeof command$1 !== "function") throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", `${decision === "accept" ? "Accept" : "Reject"} tracked change command is not available on the story editor.`, { reason: "missing_command" });
	checkRevision(hostEditor, options?.expectedRevision);
	const commandRawId = resolved.change.commandRawId ?? resolved.change.rawId;
	if (executeDomainCommand(resolved.editor, () => Boolean(command$1(commandRawId))).steps[0]?.effect !== "changed") return decisionFailureReceipt(resolved.editor, `${decision === "accept" ? "Accept" : "Reject"} tracked change "${id}" produced no change.`, {
		id,
		story
	});
	if (resolved.commit) resolved.commit(hostEditor);
	getTrackedChangeIndex(hostEditor).invalidate(resolved.story);
	applyDecisionCommentEffects(hostEditor, resolved.editor);
	return { success: true };
}
function trackChangesAcceptWrapper(editor, input, options) {
	return decideSingle(editor, "accept", input.id, input.story, options);
}
function trackChangesRejectWrapper(editor, input, options) {
	return decideSingle(editor, "reject", input.id, input.story, options);
}
function decideAll(editor, decision, input, options) {
	const index = getTrackedChangeIndex(editor);
	const requestedStoryKey = input.story && input.story !== "all" ? buildStoryKey(input.story) : null;
	const allSnapshots = index.getAll();
	const matchingSnapshots = requestedStoryKey ? allSnapshots.filter((snapshot) => snapshot.runtimeRef.storyKey === requestedStoryKey) : allSnapshots;
	if (matchingSnapshots.length === 0) return toNoOpReceipt(`${decision === "accept" ? "Accept" : "Reject"} all tracked changes produced no change.`);
	checkRevision(editor, options?.expectedRevision);
	const byStoryKey = /* @__PURE__ */ new Map();
	for (const snapshot of matchingSnapshots) {
		const key = snapshot.runtimeRef.storyKey;
		const entry = byStoryKey.get(key);
		if (entry) {
			entry.snapshots.push(snapshot);
			continue;
		}
		byStoryKey.set(key, {
			story: snapshot.story,
			snapshots: [snapshot]
		});
	}
	let anyApplied = false;
	for (const { story, snapshots } of byStoryKey.values()) {
		const runtime = resolveStoryRuntime(editor, story);
		const commandName = decision === "accept" ? "acceptAllTrackedChanges" : "rejectAllTrackedChanges";
		const bulkCommand = runtime.editor.commands[commandName];
		if (!(executeDomainCommand(runtime.editor, () => {
			if (typeof bulkCommand === "function") return Boolean(bulkCommand());
			const perChangeCommand = runtime.editor.commands[decision === "accept" ? "acceptTrackedChangeById" : "rejectTrackedChangeById"];
			if (typeof perChangeCommand !== "function") return false;
			let applied = false;
			for (const snapshot of snapshots) if (perChangeCommand(resolveTrackedChangeInStory(editor, snapshot.address)?.change.commandRawId ?? snapshot.runtimeRef.rawId)) applied = true;
			return applied;
		}).steps[0]?.effect === "changed")) continue;
		anyApplied = true;
		if (runtime.commit) runtime.commit(editor);
		index.invalidate(story);
		applyDecisionCommentEffects(editor, runtime.editor);
	}
	if (!anyApplied) return decisionFailureReceipt(editor, `${decision === "accept" ? "Accept" : "Reject"} all tracked changes produced no change.`);
	return { success: true };
}
function trackChangesAcceptAllWrapper(editor, input, options) {
	return decideAll(editor, "accept", input, options);
}
function trackChangesRejectAllWrapper(editor, input, options) {
	return decideAll(editor, "reject", input, options);
}
function resolveRangeToPmCoords(editor, range) {
	if (!range.segments?.length) return null;
	if (range.segments.length > 1) return null;
	const seg = range.segments[0];
	const doc$1 = editor.state.doc;
	const block = findBlockStart(doc$1, seg.blockId);
	if (!block) return null;
	return resolveTextRangeInBlock(block.node, block.pos, seg.range);
}
function findBlockStart(doc$1, blockId) {
	let found = null;
	doc$1.descendants((node, pos) => {
		if (found !== null) return false;
		const attrs = node.attrs;
		if ((attrs?.blockId ?? attrs?.sdBlockId ?? attrs?.id) === blockId) {
			found = {
				node,
				pos
			};
			return false;
		}
		return true;
	});
	return found;
}
function trackChangesDecideRangeWrapper(editor, input, options) {
	const story = input.story;
	if (story && (story.kind !== "story" || story.storyType !== "body")) return {
		success: false,
		failure: {
			code: "CAPABILITY_UNAVAILABLE",
			message: "trackChanges.decide range targets currently support the body story only.",
			details: { story: input.story }
		}
	};
	const resolved = resolveRangeToPmCoords(editor, input.range);
	if (!resolved) return {
		success: false,
		failure: {
			code: "INVALID_TARGET",
			message: "trackChanges.decide range could not be resolved to a contiguous PM coordinate.",
			details: { range: input.range }
		}
	};
	checkRevision(editor, options?.expectedRevision);
	const commandName = input.decision === "accept" ? "acceptTrackedChangesBetween" : "rejectTrackedChangesBetween";
	const command$1 = editor.commands[commandName];
	if (typeof command$1 !== "function") return {
		success: false,
		failure: {
			code: "CAPABILITY_UNAVAILABLE",
			message: `${commandName} command is not available on the editor.`
		}
	};
	if (!Boolean(command$1(resolved.from, resolved.to))) return decisionFailureReceipt(editor, "No tracked changes matched the requested decision target.", {
		range: input.range,
		story: input.story
	});
	getTrackedChangeIndex(editor).invalidate({
		kind: "story",
		storyType: "body"
	});
	applyDecisionCommentEffects(editor, editor);
	return { success: true };
}
function toCommentAddress(commentId) {
	return {
		kind: "entity",
		entityType: "comment",
		entityId: commentId
	};
}
function toNotFoundError(input) {
	return new DocumentApiAdapterError("TARGET_NOT_FOUND", "Comment target could not be resolved.", { target: input });
}
function isTextAddressShape(target) {
	if (!target || typeof target !== "object") return false;
	const t = target;
	if (t.kind !== "text") return false;
	if (typeof t.blockId !== "string") return false;
	return isTextRangeShape(t.range);
}
function isTextRangeShape(range) {
	if (!range || typeof range !== "object") return false;
	const r$1 = range;
	return Number.isInteger(r$1.start) && Number.isInteger(r$1.end) && r$1.start <= r$1.end;
}
function isTextSegmentShape(segment) {
	if (!segment || typeof segment !== "object") return false;
	const seg = segment;
	return typeof seg.blockId === "string" && isTextRangeShape(seg.range);
}
function isTextTargetShape(target) {
	if (!target || typeof target !== "object") return false;
	const t = target;
	if (t.kind !== "text") return false;
	if (!Array.isArray(t.segments) || t.segments.length === 0) return false;
	if (!t.segments.every(isTextSegmentShape)) return false;
	return true;
}
function targetToSegments(target) {
	if (isTextAddressShape(target)) return [{
		blockId: target.blockId,
		range: target.range
	}];
	if (isTextTargetShape(target)) return [...target.segments];
	return null;
}
function isTrackedChangeCommentTargetShape(target) {
	if (!target || typeof target !== "object") return false;
	const value = target;
	if (value.kind !== void 0 && value.kind !== "trackedChange") return false;
	return typeof value.trackedChangeId === "string" && value.trackedChangeId.length > 0;
}
function trackedChangeDisplayType(snapshot) {
	if (snapshot.type !== "structural") return null;
	return snapshot.subtype === "table-delete" ? "tableDelete" : "tableInsert";
}
function publicTrackedChangeType(snapshot) {
	return projectInternalTrackChangeType(snapshot.type, { subtype: snapshot.subtype });
}
function buildTrackedChangeLink(snapshot) {
	const { trackedChangeText, deletedText } = trackedChangeTextFields(snapshot);
	return {
		trackedChange: true,
		trackedChangeType: publicTrackedChangeType(snapshot),
		trackedChangeDisplayType: trackedChangeDisplayType(snapshot),
		trackedChangeStory: snapshot.story,
		trackedChangeAnchorKey: snapshot.anchorKey,
		trackedChangeText,
		deletedText
	};
}
function getTrackedChangeThreadingId(snapshot) {
	return snapshot.commandRawId ?? snapshot.runtimeRef.rawId ?? snapshot.address.entityId ?? null;
}
function trackedChangeSnapshotAliases(snapshot) {
	return Array.from(new Set([
		snapshot.address.entityId,
		snapshot.runtimeRef.rawId,
		snapshot.commandRawId,
		snapshot.replacementGroupId,
		snapshot.replacementSideId,
		snapshot.anchorKey
	].filter((value) => typeof value === "string" && value.length > 0)));
}
function overlapsTrackedChangeRange(snapshot, from$1, to) {
	if (from$1 === to) return snapshot.range.from <= from$1 && snapshot.range.to >= to;
	return snapshot.range.from < to && snapshot.range.to > from$1;
}
function trackedChangeTypePriority(type) {
	if (type === "delete") return 0;
	if (type === "format") return 1;
	return 2;
}
function choosePreferredTrackedChangeSnapshot(snapshots, preferredId) {
	if (snapshots.length === 0) return null;
	const preferred = preferredId ? String(preferredId) : null;
	return [...snapshots].sort((left$1, right$1) => {
		const leftMatchesPreferred = preferred ? trackedChangeSnapshotAliases(left$1).some((alias) => alias === preferred) : false;
		if (leftMatchesPreferred !== (preferred ? trackedChangeSnapshotAliases(right$1).some((alias) => alias === preferred) : false)) return leftMatchesPreferred ? -1 : 1;
		const leftLength = Math.max(0, left$1.range.to - left$1.range.from);
		const rightLength = Math.max(0, right$1.range.to - right$1.range.from);
		if (leftLength !== rightLength) return leftLength - rightLength;
		const typeDelta = trackedChangeTypePriority(publicTrackedChangeType(left$1)) - trackedChangeTypePriority(publicTrackedChangeType(right$1));
		if (typeDelta !== 0) return typeDelta;
		if (left$1.range.from !== right$1.range.from) return left$1.range.from - right$1.range.from;
		return left$1.address.entityId.localeCompare(right$1.address.entityId);
	})[0] ?? null;
}
function inferTrackedChangeSnapshotForRange(editor, from$1, to, preferredId) {
	let snapshots;
	try {
		snapshots = getTrackedChangeIndex(editor).getAll();
	} catch {
		return null;
	}
	return choosePreferredTrackedChangeSnapshot(snapshots.filter((snapshot) => overlapsTrackedChangeRange(snapshot, from$1, to)), preferredId);
}
function assignTrackedChangeLink(info, link) {
	if (!link) {
		delete info.trackedChange;
		delete info.trackedChangeType;
		delete info.trackedChangeDisplayType;
		delete info.trackedChangeStory;
		delete info.trackedChangeAnchorKey;
		delete info.trackedChangeText;
		delete info.deletedText;
		info.trackedChangeLink = null;
		return;
	}
	info.trackedChange = true;
	info.trackedChangeType = link.trackedChangeType;
	info.trackedChangeDisplayType = link.trackedChangeDisplayType ?? void 0;
	info.trackedChangeStory = link.trackedChangeStory ?? void 0;
	info.trackedChangeAnchorKey = link.trackedChangeAnchorKey ?? void 0;
	info.trackedChangeText = link.trackedChangeText ?? void 0;
	info.deletedText = link.deletedText ?? void 0;
	info.trackedChangeLink = link;
}
function listCommentAnchorsSafe(editor) {
	try {
		return listCommentAnchors(editor);
	} catch {
		return [];
	}
}
function emitCommentLifecycleUpdate(editor, type, comment) {
	const emitter = editor.emit;
	if (typeof emitter !== "function") return;
	emitter.call(editor, "commentsUpdate", {
		type,
		comment
	});
}
function applyTextSelection(editor, from$1, to) {
	const setTextSelection$1 = editor.commands?.setTextSelection;
	if (typeof setTextSelection$1 === "function") {
		if (setTextSelection$1({
			from: from$1,
			to
		}) === true) return true;
	}
	if (editor.state?.tr && typeof editor.dispatch === "function") try {
		const tr = editor.state.tr.setSelection(TextSelection.create(editor.state.doc, from$1, to)).setMeta("inputType", "programmatic");
		editor.dispatch(tr);
		return true;
	} catch {
		return false;
	}
	return false;
}
function resolveCommentIdentity(editor, commentId) {
	const record = findCommentEntity(getCommentEntityStore(editor), commentId);
	const canonicalCommentIdFromRecord = toNonEmptyString(record?.commentId);
	const importedIdFromRecord = toNonEmptyString(record?.importedId);
	const anchorCandidates = [
		...resolveCommentAnchorsById(editor, commentId),
		...canonicalCommentIdFromRecord && canonicalCommentIdFromRecord !== commentId ? resolveCommentAnchorsById(editor, canonicalCommentIdFromRecord) : [],
		...importedIdFromRecord && importedIdFromRecord !== commentId && importedIdFromRecord !== canonicalCommentIdFromRecord ? resolveCommentAnchorsById(editor, importedIdFromRecord) : []
	];
	const seen = /* @__PURE__ */ new Set();
	const anchors = anchorCandidates.filter((anchor) => {
		const key = `${anchor.commentId}|${anchor.importedId ?? ""}|${anchor.pos}|${anchor.end}`;
		if (seen.has(key)) return false;
		seen.add(key);
		return true;
	});
	const canonicalCommentId = canonicalCommentIdFromRecord ?? anchors[0]?.commentId;
	if (!canonicalCommentId) throw toNotFoundError({ commentId });
	return {
		commentId: canonicalCommentId,
		importedId: importedIdFromRecord ?? anchors[0]?.importedId,
		anchors
	};
}
function canonicalizeAnchors(sorted) {
	if (sorted.length === 0) return [];
	const result = [];
	let current = {
		blockId: sorted[0].target.blockId,
		range: {
			start: sorted[0].target.range.start,
			end: sorted[0].target.range.end
		},
		pos: sorted[0].pos,
		end: sorted[0].end
	};
	for (let i = 1; i < sorted.length; i++) {
		const anchor = sorted[i];
		const sameBlock = anchor.target.blockId === current.blockId;
		const overlapsOrAdjacent = anchor.target.range.start <= current.range.end;
		if (sameBlock && overlapsOrAdjacent) {
			current.range.end = Math.max(current.range.end, anchor.target.range.end);
			current.end = Math.max(current.end, anchor.end);
		} else {
			result.push(current);
			current = {
				blockId: anchor.target.blockId,
				range: {
					start: anchor.target.range.start,
					end: anchor.target.range.end
				},
				pos: anchor.pos,
				end: anchor.end
			};
		}
	}
	result.push(current);
	return result;
}
function extractSegmentText(editor, pos, end$1) {
	try {
		const cleaned = editor.state.doc.textBetween(pos, end$1, " ", "￼").replace(/\ufffc/g, "").trim();
		return cleaned.length > 0 ? cleaned : void 0;
	} catch {
		return;
	}
}
function buildAnchoredText(editor, canonical) {
	const parts = [];
	for (const anchor of canonical) {
		const text = extractSegmentText(editor, anchor.pos, anchor.end);
		if (text) parts.push(text);
	}
	return parts.length > 0 ? normalizeExcerpt(parts.join(" ")) : void 0;
}
function buildTextTarget$1(canonical) {
	if (canonical.length === 0) return void 0;
	return {
		kind: "text",
		segments: canonical.map((a) => ({
			blockId: a.blockId,
			range: {
				start: a.range.start,
				end: a.range.end
			}
		}))
	};
}
function mergeAnchorData(editor, infosById, anchors) {
	const grouped = /* @__PURE__ */ new Map();
	const canonicalByCommentId = /* @__PURE__ */ new Map();
	for (const anchor of anchors) {
		const group = grouped.get(anchor.commentId) ?? [];
		group.push(anchor);
		grouped.set(anchor.commentId, group);
	}
	for (const [commentId, commentAnchors] of grouped.entries()) {
		const sorted = [...commentAnchors].sort((a, b$1) => a.pos === b$1.pos ? a.end - b$1.end : a.pos - b$1.pos);
		const firstAnchor = sorted[0];
		const status = sorted.every((anchor) => anchor.status === "resolved") ? "resolved" : "open";
		const canonical = canonicalizeAnchors(sorted);
		canonicalByCommentId.set(commentId, canonical);
		const target = buildTextTarget$1(canonical);
		const anchoredText = buildAnchoredText(editor, canonical);
		const existing = infosById.get(commentId);
		if (existing) {
			if (!existing.target && target) existing.target = target;
			if (!existing.importedId && firstAnchor.importedId) existing.importedId = firstAnchor.importedId;
			if (existing.isInternal == null && firstAnchor.isInternal != null) existing.isInternal = firstAnchor.isInternal;
			if (status === "open") existing.status = "open";
			if (existing.anchoredText == null && anchoredText != null) existing.anchoredText = anchoredText;
			continue;
		}
		infosById.set(commentId, toCommentInfo({
			commentId,
			importedId: firstAnchor.importedId,
			isInternal: firstAnchor.isInternal,
			isDone: status === "resolved"
		}, {
			target,
			status,
			anchoredText
		}));
	}
	return canonicalByCommentId;
}
function parseCreatedTime(value) {
	if (!value) return void 0;
	const parsed = Date.parse(value);
	return Number.isFinite(parsed) ? parsed : void 0;
}
function trackedChangeTextFields(snapshot) {
	const excerpt = snapshot.excerpt ?? "";
	if (publicTrackedChangeType(snapshot) === "delete") return {
		trackedChangeText: "",
		deletedText: excerpt
	};
	return {
		trackedChangeText: excerpt,
		deletedText: null
	};
}
function toTrackedChangeCommentInfo(snapshot) {
	const commentId = toNonEmptyString(snapshot.address.entityId);
	if (!commentId) return null;
	const { trackedChangeText, deletedText } = trackedChangeTextFields(snapshot);
	const trackedChangeLink = buildTrackedChangeLink(snapshot);
	return {
		address: toCommentAddress(commentId),
		commentId,
		text: trackedChangeText || deletedText || void 0,
		status: "open",
		creatorName: snapshot.author,
		creatorEmail: snapshot.authorEmail,
		createdTime: parseCreatedTime(snapshot.date),
		anchoredText: snapshot.excerpt,
		story: snapshot.story,
		trackedChange: true,
		trackedChangeType: publicTrackedChangeType(snapshot),
		trackedChangeDisplayType: trackedChangeDisplayType(snapshot),
		trackedChangeStory: snapshot.story,
		trackedChangeAnchorKey: snapshot.anchorKey,
		trackedChangeText,
		deletedText,
		trackedChangeLink
	};
}
function mergeTrackedChangeCommentInfos(editor, infosById) {
	let trackedChanges;
	try {
		trackedChanges = getTrackedChangeIndex(editor).getAll();
	} catch {
		return;
	}
	for (const snapshot of trackedChanges) {
		const trackedChangeComment = toTrackedChangeCommentInfo(snapshot);
		if (!trackedChangeComment) continue;
		const existing = infosById.get(trackedChangeComment.commentId);
		if (!existing) {
			if (snapshot.wordRevisionIds) continue;
			infosById.set(trackedChangeComment.commentId, trackedChangeComment);
			continue;
		}
		Object.assign(existing, {
			story: trackedChangeComment.story,
			trackedChange: true,
			trackedChangeType: trackedChangeComment.trackedChangeType,
			trackedChangeStory: trackedChangeComment.trackedChangeStory,
			trackedChangeAnchorKey: trackedChangeComment.trackedChangeAnchorKey,
			trackedChangeText: trackedChangeComment.trackedChangeText,
			deletedText: trackedChangeComment.deletedText,
			anchoredText: existing.anchoredText ?? trackedChangeComment.anchoredText,
			creatorName: existing.creatorName ?? trackedChangeComment.creatorName,
			creatorEmail: existing.creatorEmail ?? trackedChangeComment.creatorEmail,
			createdTime: existing.createdTime ?? trackedChangeComment.createdTime,
			trackedChangeLink: trackedChangeComment.trackedChangeLink
		});
	}
}
function buildCommentInfos(editor) {
	const anchors = listCommentAnchorsSafe(editor);
	const anchoredCommentIds = Array.from(new Set(anchors.map((anchor) => anchor.commentId)));
	for (const commentId of anchoredCommentIds) restoreStashedCommentEntityTree(editor, commentId);
	const store = getCommentEntityStore(editor);
	const infosById = /* @__PURE__ */ new Map();
	for (const entry of store) {
		const commentId = toNonEmptyString(entry.commentId) ?? toNonEmptyString(entry.importedId) ?? null;
		if (!commentId) continue;
		infosById.set(commentId, toCommentInfo({
			...entry,
			commentId
		}));
	}
	const canonicalByCommentId = mergeAnchorData(editor, infosById, anchors);
	mergeTrackedChangeCommentInfos(editor, infosById);
	for (const [commentId, canonical] of canonicalByCommentId.entries()) {
		const info = infosById.get(commentId);
		if (!info || canonical.length === 0) continue;
		const from$1 = canonical[0]?.pos ?? 0;
		const snapshot = inferTrackedChangeSnapshotForRange(editor, from$1, canonical[canonical.length - 1]?.end ?? from$1, toNonEmptyString(findCommentEntity(store, commentId)?.trackedChangeParentId));
		assignTrackedChangeLink(info, snapshot ? buildTrackedChangeLink(snapshot) : null);
	}
	for (const info of infosById.values()) {
		if (info.target != null && info.anchoredText != null && info.trackedChangeLink != null || !info.parentCommentId) continue;
		const visited = /* @__PURE__ */ new Set();
		let cursor = info;
		while (cursor?.parentCommentId && !visited.has(cursor.parentCommentId)) {
			visited.add(cursor.parentCommentId);
			const ancestor = infosById.get(cursor.parentCommentId);
			if (ancestor?.target != null) {
				if (info.target == null) info.target = ancestor.target;
				if (info.anchoredText == null && ancestor.anchoredText != null) info.anchoredText = ancestor.anchoredText;
				if (info.trackedChangeLink == null && ancestor.trackedChangeLink != null) assignTrackedChangeLink(info, ancestor.trackedChangeLink);
				break;
			}
			cursor = ancestor;
		}
	}
	const infos = Array.from(infosById.values());
	infos.sort((left$1, right$1) => {
		const leftCreated = left$1.createdTime ?? 0;
		const rightCreated = right$1.createdTime ?? 0;
		if (leftCreated !== rightCreated) return leftCreated - rightCreated;
		const leftStart = left$1.target?.segments[0]?.range.start ?? Number.MAX_SAFE_INTEGER;
		const rightStart = right$1.target?.segments[0]?.range.start ?? Number.MAX_SAFE_INTEGER;
		if (leftStart !== rightStart) return leftStart - rightStart;
		return left$1.commentId.localeCompare(right$1.commentId);
	});
	return infos;
}
function validateCommentTargetSegmentOrder(editor, segments) {
	const orderedCandidates = [...getBlockIndex(editor).candidates].sort((left$1, right$1) => left$1.pos - right$1.pos);
	const orderByBlockId = /* @__PURE__ */ new Map();
	for (let i = 0; i < orderedCandidates.length; i += 1) {
		const candidate = orderedCandidates[i];
		if (!orderByBlockId.has(candidate.nodeId)) orderByBlockId.set(candidate.nodeId, i);
	}
	let lastOrder = -1;
	for (const segment of segments) {
		const currentOrder = orderByBlockId.get(segment.blockId);
		if (currentOrder === void 0 || currentOrder <= lastOrder) return {
			ok: false,
			reason: "document-order"
		};
		if (lastOrder >= 0 && currentOrder !== lastOrder + 1) return {
			ok: false,
			reason: "contiguous-blocks"
		};
		lastOrder = currentOrder;
	}
	return { ok: true };
}
function buildTrackedChangeEntityFields(snapshot) {
	if (!snapshot) return {
		trackedChange: false,
		trackedChangeParentId: null,
		trackedChangeType: null,
		trackedChangeDisplayType: null,
		trackedChangeStory: null,
		trackedChangeStoryKind: null,
		trackedChangeStoryLabel: null,
		trackedChangeAnchorKey: null,
		trackedChangeText: null,
		deletedText: null
	};
	const link = buildTrackedChangeLink(snapshot);
	return {
		trackedChange: true,
		trackedChangeParentId: getTrackedChangeThreadingId(snapshot),
		trackedChangeType: link.trackedChangeType ?? null,
		trackedChangeDisplayType: link.trackedChangeDisplayType ?? null,
		trackedChangeStory: link.trackedChangeStory ?? null,
		trackedChangeStoryKind: snapshot.storyKind,
		trackedChangeStoryLabel: snapshot.storyLabel,
		trackedChangeAnchorKey: link.trackedChangeAnchorKey ?? null,
		trackedChangeText: link.trackedChangeText ?? null,
		deletedText: link.deletedText ?? null
	};
}
function hasTrackedChangeEntityFields(record) {
	return Boolean(record && (record.trackedChange === true || record.trackedChangeParentId != null || record.trackedChangeType != null || record.trackedChangeAnchorKey != null || record.trackedChangeText != null || record.deletedText != null));
}
function buildTrackedChangeEntityFieldsFromRecord(record) {
	if (!hasTrackedChangeEntityFields(record)) return null;
	return {
		trackedChange: record?.trackedChange === true,
		trackedChangeParentId: record?.trackedChangeParentId ?? null,
		trackedChangeType: record?.trackedChangeType ?? null,
		trackedChangeDisplayType: record?.trackedChangeDisplayType ?? null,
		trackedChangeStory: record?.trackedChangeStory ?? null,
		trackedChangeStoryKind: record?.trackedChangeStoryKind ?? null,
		trackedChangeStoryLabel: record?.trackedChangeStoryLabel ?? null,
		trackedChangeAnchorKey: record?.trackedChangeAnchorKey ?? null,
		trackedChangeText: record?.trackedChangeText ?? null,
		deletedText: record?.deletedText ?? null
	};
}
function buildCommentLifecyclePayload$1(record) {
	const payload = { commentId: record.commentId };
	if (record.importedId !== void 0) payload.importedId = record.importedId;
	if (record.parentCommentId !== void 0) payload.parentCommentId = record.parentCommentId;
	if (record.commentText !== void 0) {
		payload.commentText = record.commentText;
		payload.text = record.commentText;
	}
	if (record.commentJSON !== void 0) payload.commentJSON = record.commentJSON;
	if (record.creatorName !== void 0) payload.creatorName = record.creatorName;
	if (record.creatorEmail !== void 0) payload.creatorEmail = record.creatorEmail;
	if (record.creatorImage !== void 0) payload.creatorImage = record.creatorImage;
	if (record.createdTime !== void 0) payload.createdTime = record.createdTime;
	if (record.isInternal !== void 0) payload.isInternal = record.isInternal;
	if (record.isDone !== void 0) payload.isDone = record.isDone;
	if (record.resolvedTime !== void 0) payload.resolvedTime = record.resolvedTime;
	if (record.fileId !== void 0) payload.fileId = record.fileId;
	if (record.documentId !== void 0) payload.documentId = record.documentId;
	if (record.trackedChange !== void 0) payload.trackedChange = record.trackedChange;
	if (record.trackedChangeParentId !== void 0) payload.trackedChangeParentId = record.trackedChangeParentId;
	if (record.trackedChangeType !== void 0) payload.trackedChangeType = record.trackedChangeType;
	if (record.trackedChangeDisplayType !== void 0) payload.trackedChangeDisplayType = record.trackedChangeDisplayType;
	if (record.trackedChangeStory !== void 0) payload.trackedChangeStory = record.trackedChangeStory;
	if (record.trackedChangeStoryKind !== void 0) payload.trackedChangeStoryKind = record.trackedChangeStoryKind;
	if (record.trackedChangeStoryLabel !== void 0) payload.trackedChangeStoryLabel = record.trackedChangeStoryLabel;
	if (record.trackedChangeAnchorKey !== void 0) payload.trackedChangeAnchorKey = record.trackedChangeAnchorKey;
	if (record.trackedChangeText !== void 0) payload.trackedChangeText = record.trackedChangeText;
	if (record.deletedText !== void 0) payload.deletedText = record.deletedText;
	return payload;
}
function findTrackedChangeSnapshotByAlias(editor, alias) {
	try {
		const index = getTrackedChangeIndex(editor);
		const bodySnapshots = typeof index.get === "function" ? Array.from(index.get({
			kind: "story",
			storyType: "body"
		})) : [];
		const candidateSets = bodySnapshots.length > 0 ? [bodySnapshots, Array.from(index.getAll())] : [Array.from(index.getAll())];
		for (const snapshots of candidateSets) {
			const directMatch = choosePreferredTrackedChangeSnapshot(snapshots.filter((snapshot) => trackedChangeSnapshotAliases(snapshot).some((value) => value === alias)), alias);
			if (directMatch) return directMatch;
			const projectedMatch = projectSnapshots(snapshots).find((row) => row.info.id === alias);
			if (projectedMatch) return projectedMatch.snapshot;
		}
		return getCachedProjectedTrackedChangeSnapshot(editor, alias);
	} catch {
		return null;
	}
}
function resolveCommentTrackedChangeSnapshot(editor, commentId) {
	const preferredId = toNonEmptyString(findCommentEntity(getCommentEntityStore(editor), commentId)?.trackedChangeParentId);
	if (preferredId) {
		const direct = findTrackedChangeSnapshotByAlias(editor, preferredId);
		if (direct) return direct;
	}
	const info = buildCommentInfos(editor).find((candidate) => candidate.commentId === commentId || candidate.importedId === commentId);
	if (!info?.target) return null;
	const resolved = resolveCommentTarget(editor, info.target);
	if (!resolved.ok) return null;
	return resolved.value.trackedChangeSnapshot;
}
function resolveCommentTarget(editor, target) {
	if (isTrackedChangeCommentTargetShape(target)) {
		const resolved = resolveTrackedChangeInStory(editor, {
			kind: "entity",
			entityType: "trackedChange",
			entityId: target.trackedChangeId,
			...target.story ? { story: target.story } : {}
		});
		const indexedSnapshot = resolved ? null : findTrackedChangeSnapshotByAlias(editor, target.trackedChangeId);
		if (!resolved && !indexedSnapshot) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Comment target could not be resolved.", { target });
		if (resolved && resolved.editor !== editor) return {
			ok: false,
			failure: {
				code: "INVALID_TARGET",
				message: "Comment tracked-change targets outside the active story are not supported on this editor handle.",
				details: { target }
			}
		};
		if (indexedSnapshot && buildStoryKey(indexedSnapshot.story) !== "body") return {
			ok: false,
			failure: {
				code: "INVALID_TARGET",
				message: "Comment tracked-change targets outside the active story are not supported on this editor handle.",
				details: { target }
			}
		};
		const from$1 = resolved?.change.from ?? indexedSnapshot.range.from;
		const to = resolved?.change.to ?? indexedSnapshot.range.to;
		if (from$1 === to) return {
			ok: false,
			failure: {
				code: "INVALID_TARGET",
				message: "Comment target range must be non-collapsed.",
				details: { target }
			}
		};
		return {
			ok: true,
			value: {
				from: from$1,
				to,
				trackedChangeSnapshot: indexedSnapshot ?? inferTrackedChangeSnapshotForRange(editor, from$1, to, target.trackedChangeId)
			}
		};
	}
	if (target?.kind === "selection") {
		const resolved = resolveSelectionTarget(editor, target);
		if (resolved.absFrom === resolved.absTo) return {
			ok: false,
			failure: {
				code: "INVALID_TARGET",
				message: "Comment target range must be non-collapsed.",
				details: { target }
			}
		};
		return {
			ok: true,
			value: {
				from: resolved.absFrom,
				to: resolved.absTo,
				trackedChangeSnapshot: inferTrackedChangeSnapshotForRange(editor, resolved.absFrom, resolved.absTo)
			}
		};
	}
	const segments = targetToSegments(target);
	if (!segments) return {
		ok: false,
		failure: {
			code: "INVALID_TARGET",
			message: "Comment target must be a TextAddress, TextTarget, SelectionTarget, or tracked-change target.",
			details: { target }
		}
	};
	for (const seg of segments) if (seg.range.start === seg.range.end) return {
		ok: false,
		failure: {
			code: "INVALID_TARGET",
			message: "Comment target range must be non-collapsed.",
			details: { target }
		}
	};
	const resolvedSegments = segments.map((seg) => resolveTextTarget(editor, {
		kind: "text",
		blockId: seg.blockId,
		range: seg.range
	}));
	if (resolvedSegments.some((r$1) => r$1 === null)) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Comment target could not be resolved.", { target });
	if (segments.length > 1) {
		const segmentOrder = validateCommentTargetSegmentOrder(editor, segments);
		if (segmentOrder.ok === false) return {
			ok: false,
			failure: {
				code: "INVALID_TARGET",
				message: segmentOrder.reason === "document-order" ? "Comment target segments must be in document order." : "Comment target segments must cover contiguous blocks in document order.",
				details: { target }
			}
		};
	}
	for (let i = 1; i < resolvedSegments.length; i += 1) {
		const prev = resolvedSegments[i - 1];
		const curr = resolvedSegments[i];
		if (prev.to > curr.from) return {
			ok: false,
			failure: {
				code: "INVALID_TARGET",
				message: "Comment target segments must be in document order.",
				details: { target }
			}
		};
	}
	const firstResolved = resolvedSegments[0];
	const lastResolved = resolvedSegments[resolvedSegments.length - 1];
	if (firstResolved.from === lastResolved.to) return {
		ok: false,
		failure: {
			code: "INVALID_TARGET",
			message: "Comment target range must be non-collapsed.",
			details: { target }
		}
	};
	return {
		ok: true,
		value: {
			from: firstResolved.from,
			to: lastResolved.to,
			trackedChangeSnapshot: inferTrackedChangeSnapshotForRange(editor, firstResolved.from, lastResolved.to)
		}
	};
}
function addCommentHandler(editor, input, options) {
	const target = input.target;
	if (!target) return {
		success: false,
		failure: {
			code: "INVALID_TARGET",
			message: "Comment target is required."
		}
	};
	const resolvedTarget = resolveCommentTarget(editor, target);
	if (resolvedTarget.ok === false) return {
		success: false,
		failure: resolvedTarget.failure
	};
	requireEditorCommand(editor.commands?.addComment, "comments.create (addComment)");
	if (!applyTextSelection(editor, resolvedTarget.value.from, resolvedTarget.value.to)) return {
		success: false,
		failure: {
			code: "INVALID_TARGET",
			message: "Comment target selection could not be applied.",
			details: { target: input.target }
		}
	};
	const commentId = v4_default();
	let trackedPayload = null;
	if (executeDomainCommand(editor, () => {
		const didInsert = requireEditorCommand(editor.commands?.addComment, "comments.create (addComment)")({
			content: input.text,
			isInternal: false,
			commentId
		}) === true;
		if (didInsert) {
			clearIndexCache(editor);
			const store = getCommentEntityStore(editor);
			const now = Date.now();
			const user = editor.options?.user ?? {};
			upsertCommentEntity(store, commentId, {
				commentId,
				commentText: input.text,
				commentJSON: buildCommentJsonFromText(input.text),
				parentCommentId: void 0,
				createdTime: now,
				creatorName: user.name,
				creatorEmail: user.email,
				creatorImage: user.image,
				isDone: false,
				isInternal: false,
				fileId: editor.options?.documentId,
				documentId: editor.options?.documentId,
				...buildTrackedChangeEntityFields(resolvedTarget.value.trackedChangeSnapshot)
			});
			const stored = findCommentEntity(store, commentId);
			if (stored) trackedPayload = buildCommentLifecyclePayload$1(stored);
		}
		return didInsert;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return {
		success: false,
		failure: {
			code: "NO_OP",
			message: "Comment insertion produced no change."
		}
	};
	if (trackedPayload && resolvedTarget.value.trackedChangeSnapshot) emitCommentLifecycleUpdate(editor, "update", trackedPayload);
	return {
		success: true,
		id: commentId,
		inserted: [toCommentAddress(commentId)]
	};
}
function editCommentHandler(editor, input, options) {
	const editComment = requireEditorCommand(editor.commands?.editComment, "comments.patch (editComment)");
	const store = getCommentEntityStore(editor);
	const identity = resolveCommentIdentity(editor, input.commentId);
	const existing = findCommentEntity(store, identity.commentId);
	if ((existing ? extractCommentText(existing) : void 0) === input.text) return {
		success: false,
		failure: {
			code: "NO_OP",
			message: "Comment edit produced no change."
		}
	};
	if (executeDomainCommand(editor, () => {
		const didEdit = editComment({
			commentId: identity.commentId,
			importedId: identity.importedId,
			content: input.text
		});
		if (didEdit) upsertCommentEntity(store, identity.commentId, {
			commentText: input.text,
			commentJSON: buildCommentJsonFromText(input.text),
			importedId: identity.importedId
		});
		return Boolean(didEdit);
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return {
		success: false,
		failure: {
			code: "NO_OP",
			message: "Comment edit produced no change."
		}
	};
	return {
		success: true,
		updated: [toCommentAddress(identity.commentId)]
	};
}
function replyToCommentHandler(editor, input, options) {
	const addCommentReply = requireEditorCommand(editor.commands?.addCommentReply, "comments.create (addCommentReply)");
	if (!input.parentCommentId) return {
		success: false,
		failure: {
			code: "INVALID_TARGET",
			message: "Reply target requires a non-empty parent comment id."
		}
	};
	const parentIdentity = resolveCommentIdentity(editor, input.parentCommentId);
	const store = getCommentEntityStore(editor);
	const inheritedTrackedFields = buildTrackedChangeEntityFieldsFromRecord(findCommentEntity(store, parentIdentity.commentId)) ?? buildTrackedChangeEntityFields(resolveCommentTrackedChangeSnapshot(editor, parentIdentity.commentId));
	const replyId = v4_default();
	let trackedPayload = null;
	if (executeDomainCommand(editor, () => {
		const didReply = addCommentReply({
			parentId: parentIdentity.commentId,
			content: input.text,
			commentId: replyId
		});
		if (didReply) {
			const now = Date.now();
			const user = editor.options?.user ?? {};
			upsertCommentEntity(store, replyId, {
				commentId: replyId,
				parentCommentId: parentIdentity.commentId,
				commentText: input.text,
				commentJSON: buildCommentJsonFromText(input.text),
				createdTime: now,
				creatorName: user.name,
				creatorEmail: user.email,
				creatorImage: user.image,
				isDone: false,
				isInternal: false,
				fileId: editor.options?.documentId,
				documentId: editor.options?.documentId,
				...inheritedTrackedFields ?? {}
			});
			const stored = findCommentEntity(store, replyId);
			if (stored) trackedPayload = buildCommentLifecyclePayload$1(stored);
		}
		return Boolean(didReply);
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return {
		success: false,
		failure: {
			code: "INVALID_TARGET",
			message: "Comment reply could not be applied."
		}
	};
	if (trackedPayload && inheritedTrackedFields) emitCommentLifecycleUpdate(editor, "update", trackedPayload);
	return {
		success: true,
		id: replyId,
		inserted: [toCommentAddress(replyId)]
	};
}
function moveCommentHandler(editor, input, options) {
	const moveComment = requireEditorCommand(editor.commands?.moveComment, "comments.patch (moveComment)");
	const resolvedTarget = resolveCommentTarget(editor, input.target);
	if (resolvedTarget.ok === false) return {
		success: false,
		failure: resolvedTarget.failure
	};
	const store = getCommentEntityStore(editor);
	const identity = resolveCommentIdentity(editor, input.commentId);
	if (!identity.anchors.length) return {
		success: false,
		failure: {
			code: "INVALID_TARGET",
			message: "Comment cannot be moved because it has no resolvable anchor."
		}
	};
	if (identity.anchors.length > 1) return {
		success: false,
		failure: {
			code: "INVALID_TARGET",
			message: "Comment move target is ambiguous for comments with multiple anchors."
		}
	};
	const currentAnchor = identity.anchors[0];
	if (currentAnchor && currentAnchor.pos === resolvedTarget.value.from && currentAnchor.end === resolvedTarget.value.to) return {
		success: false,
		failure: {
			code: "NO_OP",
			message: "Comment move produced no change."
		}
	};
	let trackedPayload = null;
	if (executeDomainCommand(editor, () => {
		const didMove = Boolean(moveComment({
			commentId: identity.commentId,
			from: resolvedTarget.value.from,
			to: resolvedTarget.value.to
		}));
		if (didMove) {
			upsertCommentEntity(store, identity.commentId, {
				importedId: identity.importedId,
				...buildTrackedChangeEntityFields(resolvedTarget.value.trackedChangeSnapshot)
			});
			const stored = findCommentEntity(store, identity.commentId);
			if (stored) trackedPayload = buildCommentLifecyclePayload$1(stored);
		}
		return didMove;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return {
		success: false,
		failure: {
			code: "NO_OP",
			message: "Comment move produced no change."
		}
	};
	if (trackedPayload) emitCommentLifecycleUpdate(editor, "update", trackedPayload);
	return {
		success: true,
		updated: [toCommentAddress(identity.commentId)]
	};
}
function resolveCommentHandler(editor, input, options) {
	const resolveComment = requireEditorCommand(editor.commands?.resolveComment, "comments.patch (resolveComment)");
	const store = getCommentEntityStore(editor);
	const identity = resolveCommentIdentity(editor, input.commentId);
	const existing = findCommentEntity(store, identity.commentId);
	if ((existing ? isCommentResolved(existing) : false) || identity.anchors.length > 0 && identity.anchors.every((a) => a.status === "resolved")) return {
		success: false,
		failure: {
			code: "NO_OP",
			message: "Comment is already resolved."
		}
	};
	let resolvedTimestamp = null;
	if (executeDomainCommand(editor, () => {
		const didResolve = resolveComment({
			commentId: identity.commentId,
			importedId: identity.importedId
		});
		if (didResolve) {
			resolvedTimestamp = Date.now();
			upsertCommentEntity(store, identity.commentId, {
				importedId: identity.importedId,
				isDone: true,
				resolvedTime: resolvedTimestamp
			});
		}
		return Boolean(didResolve);
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return {
		success: false,
		failure: {
			code: "NO_OP",
			message: "Comment resolve produced no change."
		}
	};
	emitCommentLifecycleUpdate(editor, "resolved", {
		commentId: identity.commentId,
		importedId: identity.importedId,
		isDone: true,
		resolvedTime: resolvedTimestamp
	});
	return {
		success: true,
		updated: [toCommentAddress(identity.commentId)]
	};
}
function reopenCommentHandler(editor, input, options) {
	const reopenComment = requireEditorCommand(editor.commands?.reopenComment, "comments.patch (reopenComment)");
	const store = getCommentEntityStore(editor);
	const identity = resolveCommentIdentity(editor, input.commentId);
	const existing = findCommentEntity(store, identity.commentId);
	const isAnchored = identity.anchors.length > 0;
	const isResolvedInStore = existing ? isCommentResolved(existing) : false;
	const isResolvedInDoc = isAnchored && identity.anchors.every((a) => a.status === "resolved");
	if (!isResolvedInStore && !isResolvedInDoc) return {
		success: false,
		failure: {
			code: "NO_OP",
			message: "Comment is already active."
		}
	};
	const storedInternal = existing?.isInternal;
	const internalOverride = typeof storedInternal === "boolean" ? storedInternal : void 0;
	if (executeDomainCommand(editor, () => {
		const didReopen = reopenComment({
			commentId: identity.commentId,
			importedId: identity.importedId,
			internal: internalOverride
		});
		if (didReopen) upsertCommentEntity(store, identity.commentId, {
			importedId: identity.importedId,
			isDone: false,
			resolvedTime: null
		});
		return Boolean(didReopen);
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return {
		success: false,
		failure: {
			code: "NO_OP",
			message: "Comment reopen produced no change."
		}
	};
	emitCommentLifecycleUpdate(editor, "update", {
		commentId: identity.commentId,
		importedId: identity.importedId,
		isDone: false,
		resolvedTime: null
	});
	return {
		success: true,
		updated: [toCommentAddress(identity.commentId)]
	};
}
function removeCommentHandler(editor, input, options) {
	const removeComment = requireEditorCommand(editor.commands?.removeComment, "comments.remove (removeComment)");
	const store = getCommentEntityStore(editor);
	const identity = resolveCommentIdentity(editor, input.commentId);
	let didRemove = false;
	let removedRecords = [];
	if (executeDomainCommand(editor, () => {
		didRemove = removeComment({
			commentId: identity.commentId,
			importedId: identity.importedId
		}) === true;
		removedRecords = removeCommentEntityTree(store, identity.commentId);
		return didRemove || removedRecords.length > 0;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return {
		success: false,
		failure: {
			code: "NO_OP",
			message: "Comment remove produced no change."
		}
	};
	const removedIds = /* @__PURE__ */ new Set();
	for (const record of removedRecords) {
		const removedId = toNonEmptyString(record.commentId);
		if (removedId) removedIds.add(removedId);
	}
	if (!removedIds.size && didRemove) removedIds.add(identity.commentId);
	for (const removedId of removedIds) emitCommentLifecycleUpdate(editor, "deleted", {
		commentId: removedId,
		importedId: removedId === identity.commentId ? identity.importedId : void 0
	});
	return {
		success: true,
		removed: Array.from(removedIds).map((id) => toCommentAddress(id))
	};
}
function setCommentInternalHandler(editor, input, options) {
	const setCommentInternal = requireEditorCommand(editor.commands?.setCommentInternal, "comments.setInternal (setCommentInternal)");
	const store = getCommentEntityStore(editor);
	const identity = resolveCommentIdentity(editor, input.commentId);
	const existing = findCommentEntity(store, identity.commentId);
	const currentInternal = (typeof existing?.isInternal === "boolean" ? existing.isInternal : void 0) ?? identity.anchors[0]?.isInternal;
	if (typeof currentInternal === "boolean" && currentInternal === input.isInternal) return {
		success: false,
		failure: {
			code: "NO_OP",
			message: "Comment internal state is already set to the requested value."
		}
	};
	const hasOpenAnchor = identity.anchors.some((anchor) => anchor.status === "open");
	if (executeDomainCommand(editor, () => {
		if (hasOpenAnchor) {
			if (!setCommentInternal({
				commentId: identity.commentId,
				importedId: identity.importedId,
				isInternal: input.isInternal
			})) return false;
		}
		upsertCommentEntity(store, identity.commentId, {
			importedId: identity.importedId,
			isInternal: input.isInternal
		});
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return {
		success: false,
		failure: {
			code: "INVALID_TARGET",
			message: "Comment internal state could not be updated on the current anchor."
		}
	};
	return {
		success: true,
		updated: [toCommentAddress(identity.commentId)]
	};
}
function setCommentActiveHandler(editor, input, options) {
	const setActiveComment = requireEditorCommand(editor.commands?.setActiveComment, "comments.setActive (setActiveComment)");
	let resolvedCommentId = null;
	if (input.commentId != null) resolvedCommentId = resolveCommentIdentity(editor, input.commentId).commentId;
	if (executeDomainCommand(editor, () => Boolean(setActiveComment({ commentId: resolvedCommentId })), { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return {
		success: false,
		failure: {
			code: "INVALID_TARGET",
			message: "Active comment could not be updated."
		}
	};
	return {
		success: true,
		updated: resolvedCommentId ? [toCommentAddress(resolvedCommentId)] : void 0
	};
}
function goToCommentHandler(editor, input) {
	const setCursorById = requireEditorCommand(editor.commands?.setCursorById, "comments.goTo (setCursorById)");
	const identity = resolveCommentIdentity(editor, input.commentId);
	let didSetCursor = setCursorById(identity.commentId);
	if (!didSetCursor && identity.importedId && identity.importedId !== identity.commentId) didSetCursor = setCursorById(identity.importedId);
	if (!didSetCursor) throw toNotFoundError({ commentId: identity.commentId });
	return {
		success: true,
		updated: [toCommentAddress(identity.commentId)]
	};
}
function getCommentHandler(editor, input) {
	const found = buildCommentInfos(editor).find((comment) => comment.commentId === input.commentId || comment.importedId === input.commentId);
	if (!found) throw toNotFoundError({ commentId: input.commentId });
	return found;
}
function listCommentsHandler(editor, query) {
	validatePaginationInput(query?.offset, query?.limit);
	const comments = buildCommentInfos(editor);
	const filtered = query?.includeResolved ?? true ? comments : comments.filter((comment) => comment.status !== "resolved");
	const evaluatedRevision = getRevision(editor);
	const paged = paginate(filtered, query?.offset, query?.limit);
	const items = paged.items.map((comment) => {
		const handle = buildResolvedHandle(`comment:${comment.commentId}`, "stable", "comment");
		const { importedId, parentCommentId, text, isInternal, status, target, anchoredText, createdTime, creatorName, creatorEmail, address, story, trackedChange, trackedChangeType, trackedChangeDisplayType: trackedChangeDisplayType$1, trackedChangeStory, trackedChangeAnchorKey, trackedChangeText, deletedText, trackedChangeLink } = comment;
		return buildDiscoveryItem(comment.commentId, handle, {
			address,
			importedId,
			parentCommentId,
			text,
			isInternal,
			status,
			target,
			anchoredText,
			createdTime,
			creatorName,
			creatorEmail,
			story,
			trackedChange,
			trackedChangeType,
			trackedChangeDisplayType: trackedChangeDisplayType$1,
			trackedChangeStory,
			trackedChangeAnchorKey,
			trackedChangeText,
			deletedText,
			trackedChangeLink
		});
	});
	return buildDiscoveryResult({
		evaluatedRevision,
		total: paged.total,
		items,
		page: {
			limit: query?.limit ?? paged.total,
			offset: query?.offset ?? 0,
			returned: items.length
		}
	});
}
function createCommentsWrapper(editor) {
	return {
		add: (input, options) => addCommentHandler(editor, input, options),
		edit: (input, options) => editCommentHandler(editor, input, options),
		reply: (input, options) => replyToCommentHandler(editor, input, options),
		move: (input, options) => moveCommentHandler(editor, input, options),
		resolve: (input, options) => resolveCommentHandler(editor, input, options),
		reopen: (input, options) => reopenCommentHandler(editor, input, options),
		remove: (input, options) => removeCommentHandler(editor, input, options),
		setInternal: (input, options) => setCommentInternalHandler(editor, input, options),
		setActive: (input, options) => setCommentActiveHandler(editor, input, options),
		goTo: (input) => goToCommentHandler(editor, input),
		get: (input) => getCommentHandler(editor, input),
		list: (query) => listCommentsHandler(editor, query)
	};
}
var TRACK_MARK_TYPE_BY_NAME = {
	[TrackInsertMarkName]: "insert",
	[TrackDeleteMarkName]: "delete",
	[TrackFormatMarkName]: "format"
};
var EMITTABLE_BLOCK_TYPES = new Set([
	"paragraph",
	"heading",
	"listItem",
	"image",
	"tableOfContents"
]);
var SDT_BLOCK_NODE_NAMES = new Set(["structuredContentBlock", "sdt"]);
function indexCellsForTable(tableNode) {
	const map$1 = TableMap.get(tableNode);
	const anchors = [];
	let rowOffset = 0;
	for (let rowChildIndex = 0; rowChildIndex < tableNode.childCount; rowChildIndex++) {
		const row = tableNode.child(rowChildIndex);
		let cellOffsetInRow = 0;
		for (let cellChildIndexInRow = 0; cellChildIndexInRow < row.childCount; cellChildIndexInRow++) {
			const cellNode = row.child(cellChildIndexInRow);
			const cellOffset = rowOffset + 1 + cellOffsetInRow;
			cellOffsetInRow += cellNode.nodeSize;
			const cellAttrs = cellNode.attrs;
			if (cellAttrs.__placeholder != null) continue;
			const mapIndex = map$1.map.indexOf(cellOffset);
			if (mapIndex < 0) continue;
			anchors.push({
				cellNode,
				cellOffset,
				rowChildIndex,
				cellChildIndexInRow,
				gridRowIndex: Math.floor(mapIndex / map$1.width),
				gridColumnIndex: mapIndex % map$1.width,
				rowspan: cellAttrs.rowspan ?? 1,
				colspan: cellAttrs.colspan ?? 1
			});
		}
		rowOffset += row.nodeSize;
	}
	return anchors;
}
function readSpanTrackedChanges(node, canonicalIdByAlias) {
	const out = [];
	for (const mark of node.marks) {
		const type = TRACK_MARK_TYPE_BY_NAME[mark.type.name];
		if (!type) continue;
		const alias = getTrackedChangeMarkAlias(mark);
		if (!alias) continue;
		const entityId = canonicalIdByAlias.get(alias);
		if (!entityId) continue;
		out.push({
			entityId,
			type
		});
	}
	out.sort((a, b$1) => {
		if (a.entityId !== b$1.entityId) return a.entityId < b$1.entityId ? -1 : 1;
		return a.type < b$1.type ? -1 : a.type > b$1.type ? 1 : 0;
	});
	return out;
}
function spanTrackedChangesEqual(a, b$1) {
	if (a.length !== b$1.length) return false;
	for (let i = 0; i < a.length; i++) if (a[i].entityId !== b$1[i].entityId || a[i].type !== b$1[i].type) return false;
	return true;
}
function recordEntityHit(index, entityId, type, blockId) {
	let entry = index.get(entityId);
	if (!entry) {
		entry = {
			blockIds: /* @__PURE__ */ new Set(),
			types: /* @__PURE__ */ new Set()
		};
		index.set(entityId, entry);
	}
	entry.blockIds.add(blockId);
	entry.types.add(type);
}
function buildTextSpans(node, blockId, canonicalIdByAlias, entityIndex) {
	if (canonicalIdByAlias.size === 0) return void 0;
	const spans = [];
	let hasAnyTrackedChange = false;
	node.descendants((child) => {
		if (!child.isText || typeof child.text !== "string" || child.text.length === 0) return true;
		const tracked = readSpanTrackedChanges(child, canonicalIdByAlias);
		if (tracked.length > 0) {
			hasAnyTrackedChange = true;
			for (const tc of tracked) recordEntityHit(entityIndex, tc.entityId, tc.type, blockId);
		}
		const last = spans.length > 0 ? spans[spans.length - 1] : void 0;
		const lastTracked = last?.trackedChanges ?? [];
		if (last && spanTrackedChangesEqual(lastTracked, tracked)) {
			last.text += child.text;
			return true;
		}
		const span = { text: child.text };
		if (tracked.length > 0) span.trackedChanges = tracked;
		spans.push(span);
		return true;
	});
	return hasAnyTrackedChange ? spans : void 0;
}
function buildBlock(node, pos, nodeType, path, canonicalIdByAlias, entityIndex, tableContext) {
	const nodeId = resolveBlockNodeId(node, pos, nodeType, path);
	if (!nodeId) return void 0;
	const pProps = node.attrs.paragraphProperties;
	const headingLevel = getHeadingLevel$1(pProps?.styleId);
	const block = {
		nodeId,
		type: nodeType,
		text: node.textContent
	};
	const spans = buildTextSpans(node, nodeId, canonicalIdByAlias, entityIndex);
	if (spans) block.textSpans = spans;
	if (headingLevel !== void 0) block.headingLevel = headingLevel;
	if (tableContext) block.tableContext = tableContext;
	return block;
}
function collectContainerBlocks(container, contentStart, containerPath, ctx$1, tableContext, nestedParent) {
	const blocks = [];
	let childOffset = 0;
	for (let i = 0; i < container.childCount; i++) {
		const child = container.child(i);
		const childPos = contentStart + childOffset;
		childOffset += child.nodeSize;
		const childPath = [...containerPath, i];
		if (child.type.name === "table") {
			blocks.push(...collectTableExtractBlocks(child, childPos, childPath, ctx$1, nestedParent));
			continue;
		}
		if (SDT_BLOCK_NODE_NAMES.has(child.type.name)) {
			blocks.push(...collectContainerBlocks(child, childPos + 1, childPath, ctx$1, tableContext, nestedParent));
			continue;
		}
		const childType = mapBlockNodeType(child);
		if (childType && EMITTABLE_BLOCK_TYPES.has(childType)) {
			const block = buildBlock(child, childPos, childType, childPath, ctx$1.canonicalIdByAlias, ctx$1.entityIndex, tableContext);
			if (block) blocks.push(block);
			continue;
		}
		if (!child.isLeaf && child.firstChild?.isBlock === true) blocks.push(...collectContainerBlocks(child, childPos + 1, childPath, ctx$1, tableContext, nestedParent));
	}
	return blocks;
}
function collectTableExtractBlocks(tableNode, tablePos, tablePath, ctx$1, parent) {
	const tableOrdinal = ctx$1.ordinals.next++;
	const anchors = indexCellsForTable(tableNode);
	const blocks = [];
	for (const anchor of anchors) {
		const cellContentStart = tablePos + 1 + anchor.cellOffset + 1;
		const cellPath = [
			...tablePath,
			anchor.rowChildIndex,
			anchor.cellChildIndexInRow
		];
		const tableContext = {
			tableOrdinal,
			rowIndex: anchor.gridRowIndex,
			columnIndex: anchor.gridColumnIndex,
			rowspan: anchor.rowspan,
			colspan: anchor.colspan
		};
		if (parent) {
			tableContext.parentTableOrdinal = parent.tableOrdinal;
			tableContext.parentRowIndex = parent.rowIndex;
			tableContext.parentColumnIndex = parent.columnIndex;
		}
		blocks.push(...collectContainerBlocks(anchor.cellNode, cellContentStart, cellPath, ctx$1, tableContext, {
			tableOrdinal,
			rowIndex: anchor.gridRowIndex,
			columnIndex: anchor.gridColumnIndex
		}));
	}
	return blocks;
}
function collectBlocks(editor) {
	const ctx$1 = {
		ordinals: { next: 0 },
		canonicalIdByAlias: buildTrackedChangeCanonicalIdMap(editor),
		entityIndex: /* @__PURE__ */ new Map()
	};
	return {
		blocks: collectContainerBlocks(editor.state.doc, 0, [], ctx$1),
		entityIndex: ctx$1.entityIndex
	};
}
function collectComments(editor) {
	return createCommentsWrapper(editor).list({ includeResolved: true }).items.map((item) => {
		const comment = {
			entityId: item.address.entityId,
			status: item.status
		};
		if (item.text) comment.text = item.text;
		if (item.anchoredText) comment.anchoredText = item.anchoredText;
		if (item.target?.segments?.[0]?.blockId) comment.blockId = item.target.segments[0].blockId;
		if (item.creatorName) comment.author = item.creatorName;
		return comment;
	});
}
function collectTrackedChanges$1(editor, entityIndex) {
	return trackChangesListWrapper(editor).items.map((item) => {
		const tc = {
			entityId: item.address.entityId,
			type: item.type
		};
		const indexEntry = entityIndex.get(item.address.entityId);
		if (indexEntry && indexEntry.blockIds.size > 0) tc.blockIds = Array.from(indexEntry.blockIds);
		if (item.wordRevisionIds) tc.wordRevisionIds = item.wordRevisionIds;
		const isMultiTypeEntity = !!(indexEntry && indexEntry.types.size > 1);
		if (item.excerpt && !isMultiTypeEntity) tc.excerpt = item.excerpt;
		if (item.author) tc.author = item.author;
		if (item.date) tc.date = item.date;
		return tc;
	});
}
function extractAdapter(editor, _input) {
	const { blocks, entityIndex } = collectBlocks(editor);
	return {
		blocks,
		comments: collectComments(editor),
		trackedChanges: collectTrackedChanges$1(editor, entityIndex),
		revision: getRevision(editor)
	};
}
var REQUIRED_COMMANDS = {
	"create.paragraph": ["insertParagraphAt"],
	"create.heading": ["insertHeadingAt"],
	"lists.insert": ["insertListItemAt"],
	"lists.indent": [],
	"lists.outdent": [],
	"lists.create": [],
	"lists.attach": [],
	"lists.detach": [],
	"lists.delete": [],
	"lists.join": [],
	"lists.separate": [],
	"lists.setLevel": [],
	"lists.setValue": [],
	"lists.continuePrevious": [],
	"lists.setLevelRestart": [],
	"lists.convertToText": [],
	"lists.applyTemplate": [],
	"lists.applyPreset": [],
	"lists.captureTemplate": [],
	"lists.setLevelNumbering": [],
	"lists.setLevelBullet": [],
	"lists.setLevelPictureBullet": [],
	"lists.setLevelAlignment": [],
	"lists.setLevelIndents": [],
	"lists.setLevelTrailingCharacter": [],
	"lists.setLevelMarkerFont": [],
	"lists.clearLevelOverrides": [],
	"blocks.delete": ["deleteBlockNodeById"],
	"comments.create": [
		"addComment",
		"setTextSelection",
		"addCommentReply"
	],
	"comments.patch": [
		"editComment",
		"moveComment",
		"resolveComment",
		"reopenComment",
		"setCommentInternal"
	],
	"comments.delete": ["removeComment"],
	"trackChanges.decide": [
		"acceptTrackedChangeById",
		"rejectTrackedChangeById",
		"acceptAllTrackedChanges",
		"rejectAllTrackedChanges"
	],
	"history.undo": ["undo"],
	"history.redo": ["redo"],
	"create.table": ["insertTableAt"],
	"tables.delete": ["insertTableAt"],
	"tables.clearContents": ["insertTableAt"],
	"tables.move": ["insertTableAt"],
	"tables.setLayout": ["insertTableAt"],
	"tables.setAltText": ["insertTableAt"],
	"tables.insertRow": ["insertTableAt"],
	"tables.deleteRow": ["insertTableAt"],
	"tables.setRowHeight": ["insertTableAt"],
	"tables.distributeRows": ["insertTableAt"],
	"tables.setRowOptions": ["insertTableAt"],
	"tables.insertColumn": ["insertTableAt"],
	"tables.deleteColumn": ["insertTableAt"],
	"tables.setColumnWidth": ["insertTableAt"],
	"tables.distributeColumns": ["insertTableAt"],
	"tables.insertCell": ["insertTableAt"],
	"tables.deleteCell": ["insertTableAt"],
	"tables.mergeCells": ["insertTableAt"],
	"tables.unmergeCells": ["insertTableAt"],
	"tables.splitCell": ["insertTableAt"],
	"tables.setCellProperties": ["insertTableAt"],
	"tables.convertFromText": ["insertTableAt"],
	"tables.split": ["insertTableAt"],
	"tables.convertToText": ["insertTableAt"],
	"tables.sort": ["insertTableAt"],
	"tables.setStyle": ["insertTableAt"],
	"tables.clearStyle": ["insertTableAt"],
	"tables.setStyleOption": ["insertTableAt"],
	"tables.setBorder": ["insertTableAt"],
	"tables.clearBorder": ["insertTableAt"],
	"tables.applyBorderPreset": ["insertTableAt"],
	"tables.setShading": ["insertTableAt"],
	"tables.clearShading": ["insertTableAt"],
	"tables.setTablePadding": ["insertTableAt"],
	"tables.setCellPadding": ["insertTableAt"],
	"tables.setCellSpacing": ["insertTableAt"],
	"tables.clearCellSpacing": ["insertTableAt"],
	"create.tableOfContents": ["insertTableOfContentsAt"],
	"toc.configure": ["setTableOfContentsInstructionById"],
	"toc.update": ["replaceTableOfContentsContentById"],
	"toc.remove": ["deleteTableOfContentsById"],
	"toc.markEntry": ["insertTableOfContentsEntryAt"],
	"toc.unmarkEntry": ["deleteTableOfContentsEntryAt"],
	"toc.editEntry": ["updateTableOfContentsEntryAt"],
	"bookmarks.list": ["insertBookmark"],
	"bookmarks.get": ["insertBookmark"],
	"bookmarks.insert": ["insertBookmark"],
	"bookmarks.rename": ["insertBookmark"],
	"bookmarks.remove": ["insertBookmark"],
	"footnotes.list": ["insertContent"],
	"footnotes.get": ["insertContent"],
	"footnotes.insert": ["insertContent"],
	"footnotes.update": ["insertContent"],
	"footnotes.remove": ["insertContent"],
	"footnotes.configure": ["insertContent"],
	"crossRefs.list": ["insertContent"],
	"crossRefs.get": ["insertContent"],
	"crossRefs.insert": ["insertContent"],
	"crossRefs.rebuild": ["insertContent"],
	"crossRefs.remove": ["insertContent"],
	"index.list": ["insertContent"],
	"index.get": ["insertContent"],
	"index.insert": ["insertContent"],
	"index.configure": ["insertContent"],
	"index.rebuild": ["insertContent"],
	"index.remove": ["insertContent"],
	"index.entries.list": ["insertContent"],
	"index.entries.get": ["insertContent"],
	"index.entries.insert": ["insertContent"],
	"index.entries.update": ["insertContent"],
	"index.entries.remove": ["insertContent"],
	"captions.list": ["insertContent"],
	"captions.get": ["insertContent"],
	"captions.insert": ["insertContent"],
	"captions.update": ["insertContent"],
	"captions.remove": ["insertContent"],
	"captions.configure": ["insertContent"],
	"fields.list": ["insertContent"],
	"fields.get": ["insertContent"],
	"fields.insert": ["insertContent"],
	"fields.rebuild": ["insertContent"],
	"fields.remove": ["insertContent"],
	"citations.list": ["insertContent"],
	"citations.get": ["insertContent"],
	"citations.insert": ["insertContent"],
	"citations.update": ["insertContent"],
	"citations.remove": ["insertContent"],
	"citations.sources.list": ["insertContent"],
	"citations.sources.get": ["insertContent"],
	"citations.sources.insert": ["insertContent"],
	"citations.sources.update": ["insertContent"],
	"citations.sources.remove": ["insertContent"],
	"citations.bibliography.get": ["insertContent"],
	"citations.bibliography.insert": ["insertContent"],
	"citations.bibliography.configure": ["insertContent"],
	"citations.bibliography.rebuild": ["insertContent"],
	"citations.bibliography.remove": ["insertContent"],
	"authorities.list": ["insertContent"],
	"authorities.get": ["insertContent"],
	"authorities.insert": ["insertContent"],
	"authorities.configure": ["insertContent"],
	"authorities.rebuild": ["insertContent"],
	"authorities.remove": ["insertContent"],
	"authorities.entries.list": ["insertContent"],
	"authorities.entries.get": ["insertContent"],
	"authorities.entries.insert": ["insertContent"],
	"authorities.entries.update": ["insertContent"],
	"authorities.entries.remove": ["insertContent"],
	"create.image": ["setImage"],
	"images.delete": ["setImage"],
	"images.move": ["setImage"],
	"images.convertToInline": ["setImage"],
	"images.convertToFloating": ["setImage"],
	"images.setSize": ["setImage"],
	"images.setWrapType": ["setImage"],
	"images.setWrapSide": ["setImage"],
	"images.setWrapDistances": ["setImage"],
	"images.setPosition": ["setImage"],
	"images.setAnchorOptions": ["setImage"],
	"images.setZOrder": ["setImage"],
	"images.scale": ["setImage"],
	"images.setLockAspectRatio": ["setImage"],
	"images.rotate": ["setImage"],
	"images.flip": ["setImage"],
	"images.crop": ["setImage"],
	"images.resetCrop": ["setImage"],
	"images.replaceSource": ["setImage"],
	"images.setAltText": ["setImage"],
	"images.setDecorative": ["setImage"],
	"images.setName": ["setImage"],
	"images.setHyperlink": ["setImage"],
	"images.insertCaption": ["setImage"],
	"images.updateCaption": ["setImage"],
	"images.removeCaption": ["setImage"]
};
var VALID_CAPABILITY_REASON_CODES = new Set(CAPABILITY_REASON_CODES);
function hasCommand(editor, command$1) {
	return typeof editor.commands?.[command$1] === "function";
}
function hasAllCommands(editor, operationId) {
	const required = REQUIRED_COMMANDS[operationId];
	if (!required || required.length === 0) return true;
	return required.every((command$1) => hasCommand(editor, command$1));
}
var REQUIRED_HELPERS = {
	"blocks.delete": (editor) => typeof editor.helpers?.blockNode?.getBlockNodeById === "function",
	"sections.setOddEvenHeadersFooters": (editor) => Boolean(editor.converter),
	"sections.setHeaderFooterRef": (editor) => Boolean(editor.converter),
	"tables.setDefaultStyle": (editor) => Boolean(editor.converter),
	"tables.clearDefaultStyle": (editor) => Boolean(editor.converter),
	"headerFooters.refs.set": (editor) => Boolean(editor.converter),
	"headerFooters.refs.setLinkedToPrevious": (editor) => Boolean(editor.converter),
	"headerFooters.parts.list": (editor) => Boolean(editor.converter),
	"headerFooters.parts.create": (editor) => Boolean(editor.converter),
	"headerFooters.parts.delete": (editor) => Boolean(editor.converter),
	"lists.setLevelPictureBullet": (editor) => {
		const converter = editor.converter;
		return Boolean(converter?.convertedXml?.["word/numbering.xml"]);
	}
};
function hasSchemaNode(editor, ...names) {
	const nodes = editor.schema?.nodes;
	if (!nodes) return false;
	return names.some((n) => Boolean(nodes[n]));
}
var SCHEMA_NODE_GATES = [
	{
		prefix: "crossRefs.",
		nodes: ["crossReference"]
	},
	{
		prefix: "citations.bibliography.",
		nodes: ["bibliography"]
	},
	{
		prefix: "citations.sources.",
		nodes: ["citation"]
	},
	{
		prefix: "citations.",
		nodes: ["citation"]
	},
	{
		prefix: "authorities.entries.",
		nodes: ["authorityEntry"]
	},
	{
		prefix: "authorities.",
		nodes: ["tableOfAuthorities"]
	},
	{
		prefix: "index.entries.",
		nodes: ["indexEntry"]
	},
	{
		prefix: "index.",
		nodes: ["documentIndex", "index"]
	},
	{
		prefix: "fields.",
		nodes: ["sequenceField"]
	},
	{
		prefix: "footnotes.",
		nodes: ["footnoteReference", "endnoteReference"]
	}
];
var schemaGatedIds = /* @__PURE__ */ new Set();
for (const gate of SCHEMA_NODE_GATES) {
	const matchingIds = Object.keys(REQUIRED_COMMANDS).filter((id) => id.startsWith(gate.prefix) && !schemaGatedIds.has(id));
	for (const id of matchingIds) {
		schemaGatedIds.add(id);
		const existingCheck = REQUIRED_HELPERS[id];
		if (existingCheck) REQUIRED_HELPERS[id] = (editor) => existingCheck(editor) && hasSchemaNode(editor, ...gate.nodes);
		else REQUIRED_HELPERS[id] = (editor) => hasSchemaNode(editor, ...gate.nodes);
	}
}
function hasRequiredHelpers(editor, operationId) {
	const check = REQUIRED_HELPERS[operationId];
	if (!check) return true;
	return check(editor);
}
function hasMarkCapability(editor, markName) {
	return Boolean(editor.schema?.marks?.[markName]);
}
function isMarkBackedOperation(operationId) {
	return operationId === "format.apply" || getInlineAliasKey(operationId) !== void 0;
}
function getInlineAliasKey(operationId) {
	if (!operationId.startsWith("format.")) return void 0;
	const key = operationId.slice(7);
	if (INLINE_PROPERTY_KEY_SET.has(key)) return key;
}
function isInlinePropertyAvailable(editor, property) {
	if (property.storage === "mark") {
		if (property.carrier.storage !== "mark") return false;
		const markName = property.carrier.markName;
		if (!hasMarkCapability(editor, markName)) return false;
		if (markName === "textStyle" && property.carrier.textStyleAttr) {
			const textStyleMark = editor.schema.marks.textStyle;
			const markAttrs = textStyleMark?.spec?.attrs ?? textStyleMark?.attrs;
			if (!markAttrs || !Object.prototype.hasOwnProperty.call(markAttrs, property.carrier.textStyleAttr)) return false;
		}
		return true;
	}
	return Boolean(editor.schema?.nodes?.run);
}
function hasTrackedModeCapability(editor, operationId) {
	if (!hasCommand(editor, "insertTrackedChange")) return false;
	if (!editor.options?.user) return false;
	const inlineKey = getInlineAliasKey(operationId);
	if (inlineKey !== void 0) {
		if (!INLINE_PROPERTY_BY_KEY[inlineKey].tracked) return false;
		return Boolean(editor.schema?.marks?.[TrackFormatMarkName]);
	}
	if (operationId === "format.apply") {
		if (!editor.schema?.marks?.["trackFormat"]) return false;
		return INLINE_PROPERTY_REGISTRY.some((property) => property.tracked && isInlinePropertyAvailable(editor, property));
	}
	if (isMarkBackedOperation(operationId)) return Boolean(editor.schema?.marks?.[TrackFormatMarkName]);
	return true;
}
function getNamespaceOperationIds(prefix) {
	return Object.keys(REQUIRED_COMMANDS).filter((id) => id.startsWith(`${prefix}.`));
}
function isCommentsNamespaceEnabled(editor) {
	return getNamespaceOperationIds("comments").every((id) => hasAllCommands(editor, id));
}
function isListsNamespaceEnabled(editor) {
	return getNamespaceOperationIds("lists").every((id) => hasAllCommands(editor, id));
}
function isHistoryNamespaceEnabled(editor) {
	return hasCommand(editor, "undo") && hasCommand(editor, "redo");
}
function isTrackChangesEnabled(editor) {
	return hasCommand(editor, "insertTrackedChange") && hasCommand(editor, "acceptTrackedChangeById") && hasCommand(editor, "rejectTrackedChangeById") && hasCommand(editor, "acceptAllTrackedChanges") && hasCommand(editor, "rejectAllTrackedChanges");
}
function getNamespaceReason(enabled) {
	return enabled ? void 0 : ["NAMESPACE_UNAVAILABLE"];
}
function pushReason(reasons, reason) {
	if (!VALID_CAPABILITY_REASON_CODES.has(reason)) return;
	if (!reasons.includes(reason)) reasons.push(reason);
}
function isNonCommandBackedOperation(operationId) {
	return operationId === "format.apply" || operationId === "styles.apply" || operationId === "templates.apply" || getInlineAliasKey(operationId) !== void 0;
}
function hasStylesRoot(stylesPart) {
	return stylesPart?.elements?.some((el) => el.name === "w:styles") === true;
}
function isStylesApplyAvailable(editor) {
	const converter = editor.converter;
	if (!converter?.convertedXml?.["word/styles.xml"]) return false;
	if (!hasStylesRoot(converter.convertedXml["word/styles.xml"])) return false;
	return true;
}
function getStylesApplyUnavailableReason(editor) {
	const converter = editor.converter;
	if (!converter) return "OPERATION_UNAVAILABLE";
	if (!converter.convertedXml?.["word/styles.xml"]) return "STYLES_PART_MISSING";
	if (!hasStylesRoot(converter.convertedXml["word/styles.xml"])) return "STYLES_PART_MISSING";
}
function isTemplatesApplyAvailable(editor) {
	const converter = editor.converter;
	return Boolean(converter?.convertedXml && typeof converter.parseXmlToJson === "function");
}
function isOperationAvailable(editor, operationId) {
	if (operationId === "format.apply") return INLINE_PROPERTY_REGISTRY.some((property) => isInlinePropertyAvailable(editor, property));
	const inlineKey = getInlineAliasKey(operationId);
	if (inlineKey !== void 0) return isInlinePropertyAvailable(editor, INLINE_PROPERTY_BY_KEY[inlineKey]);
	if (operationId === "styles.apply") return isStylesApplyAvailable(editor);
	if (operationId === "templates.apply") return isTemplatesApplyAvailable(editor);
	return hasAllCommands(editor, operationId) && hasRequiredHelpers(editor, operationId);
}
function isCommandBackedAvailability(operationId) {
	return !isNonCommandBackedOperation(operationId);
}
function buildOperationCapabilities(editor) {
	const operations = {};
	for (const operationId of OPERATION_IDS) {
		const metadata = COMMAND_CATALOG[operationId];
		const available = isOperationAvailable(editor, operationId);
		const tracked = available && metadata.supportsTrackedMode && hasTrackedModeCapability(editor, operationId);
		const dryRun = metadata.supportsDryRun && available;
		const reasons = [];
		if (!available) {
			if (operationId === "styles.apply") {
				const stylesReason = getStylesApplyUnavailableReason(editor);
				if (stylesReason) pushReason(reasons, stylesReason);
			} else if (operationId === "templates.apply") pushReason(reasons, "OPERATION_UNAVAILABLE");
			else if (isCommandBackedAvailability(operationId)) {
				if (!hasAllCommands(editor, operationId)) pushReason(reasons, "COMMAND_UNAVAILABLE");
				if (!hasRequiredHelpers(editor, operationId)) pushReason(reasons, "HELPER_UNAVAILABLE");
			}
			pushReason(reasons, "OPERATION_UNAVAILABLE");
		}
		if (metadata.supportsTrackedMode && !tracked) pushReason(reasons, "TRACKED_MODE_UNAVAILABLE");
		if (metadata.supportsDryRun && !dryRun) pushReason(reasons, "DRY_RUN_UNAVAILABLE");
		operations[operationId] = {
			available,
			tracked,
			dryRun,
			reasons: reasons.length > 0 ? reasons : void 0
		};
	}
	return operations;
}
var SUPPORTED_NON_UNIFORM_STRATEGIES = [
	"error",
	"useLeadingRun",
	"majority",
	"union"
];
var SUPPORTED_SET_MARKS = [
	"bold",
	"italic",
	"underline",
	"strike"
];
var REGEX_MAX_PATTERN_LENGTH = 1024;
function buildFormatCapabilities(editor) {
	const trackedInlinePropertiesSupported = hasTrackedModeCapability(editor, "format.apply");
	const supportedInlineProperties = {};
	for (const property of INLINE_PROPERTY_REGISTRY) {
		const available = isInlinePropertyAvailable(editor, property);
		supportedInlineProperties[property.key] = {
			available,
			tracked: available && property.tracked && trackedInlinePropertiesSupported,
			type: property.type,
			storage: property.storage
		};
	}
	return { supportedInlineProperties };
}
function buildPlanEngineCapabilities() {
	return {
		supportedStepOps: PUBLIC_MUTATION_STEP_OP_IDS,
		supportedNonUniformStrategies: SUPPORTED_NON_UNIFORM_STRATEGIES,
		supportedSetMarks: SUPPORTED_SET_MARKS,
		regex: { maxPatternLength: REGEX_MAX_PATTERN_LENGTH }
	};
}
function getDocumentApiCapabilities(editor) {
	const operations = buildOperationCapabilities(editor);
	const commentsEnabled = isCommentsNamespaceEnabled(editor);
	const listsEnabled = isListsNamespaceEnabled(editor);
	const trackChangesEnabled = isTrackChangesEnabled(editor);
	const historyEnabled = isHistoryNamespaceEnabled(editor);
	const dryRunEnabled = OPERATION_IDS.some((operationId) => operations[operationId].dryRun);
	return {
		global: {
			trackChanges: {
				enabled: trackChangesEnabled,
				reasons: getNamespaceReason(trackChangesEnabled)
			},
			comments: {
				enabled: commentsEnabled,
				reasons: getNamespaceReason(commentsEnabled)
			},
			lists: {
				enabled: listsEnabled,
				reasons: getNamespaceReason(listsEnabled)
			},
			dryRun: {
				enabled: dryRunEnabled,
				reasons: dryRunEnabled ? void 0 : ["DRY_RUN_UNAVAILABLE"]
			},
			history: {
				enabled: historyEnabled,
				reasons: getNamespaceReason(historyEnabled)
			}
		},
		format: buildFormatCapabilities(editor),
		operations,
		planEngine: buildPlanEngineCapabilities()
	};
}
function isDocumentEmpty(editor) {
	const { doc: doc$1 } = editor.state;
	if (doc$1.childCount !== 1) return false;
	const firstChild = doc$1.firstChild;
	return firstChild?.type.name === "paragraph" && firstChild.childCount === 0;
}
function clearContentWrapper(editor, _input, options) {
	const paragraphType = editor.state.schema.nodes.paragraph;
	if (!paragraphType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "clearContent requires the paragraph node type in the schema.", { reason: "missing_schema_node" });
	if (isDocumentEmpty(editor)) return {
		success: false,
		failure: {
			code: "NO_OP",
			message: "Document is already empty."
		}
	};
	if (!(executeDomainCommand(editor, () => {
		const { state } = editor;
		const emptyParagraph = paragraphType.create();
		const tr = state.tr.replaceWith(0, state.doc.content.size, emptyParagraph);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect === "changed")) return {
		success: false,
		failure: {
			code: "NO_OP",
			message: "Clear command produced no change."
		}
	};
	return { success: true };
}
function syncDocDefaultsToConvertedXml(converter, docDefaultsTranslator) {
	const docDefaults = converter.translatedLinkedStyles.docDefaults;
	const newDocDefaultsNode = docDefaultsTranslator.decode({ node: { attrs: { docDefaults } } });
	const stylesPart = converter.convertedXml["word/styles.xml"];
	if (!stylesPart) return;
	const stylesRoot = stylesPart.elements?.find((el) => el.name === "w:styles");
	if (!stylesRoot) return;
	if (!stylesRoot.elements) stylesRoot.elements = [];
	const existingIndex = stylesRoot.elements.findIndex((el) => el.name === "w:docDefaults");
	if (newDocDefaultsNode) if (existingIndex >= 0) stylesRoot.elements[existingIndex] = newDocDefaultsNode;
	else stylesRoot.elements.unshift(newDocDefaultsNode);
	else if (existingIndex >= 0) stylesRoot.elements.splice(existingIndex, 1);
}
var STYLES_PART = "word/styles.xml";
var PROPERTIES_KEY_BY_CHANNEL = {
	run: "runProperties",
	paragraph: "paragraphProperties"
};
var XML_PATH_BY_CHANNEL = {
	run: "w:styles/w:docDefaults/w:rPrDefault/w:rPr",
	paragraph: "w:styles/w:docDefaults/w:pPrDefault/w:pPr"
};
var UNDERLINE_API_TO_STORAGE = {
	val: "w:val",
	color: "w:color",
	themeColor: "w:themeColor",
	themeTint: "w:themeTint",
	themeShade: "w:themeShade"
};
var UNDERLINE_STORAGE_TO_API = Object.fromEntries(Object.entries(UNDERLINE_API_TO_STORAGE).map(([k$1, v]) => [v, k$1]));
function mapUnderlineToStorage(apiObj) {
	const result = {};
	for (const [k$1, v] of Object.entries(apiObj)) result[UNDERLINE_API_TO_STORAGE[k$1] ?? k$1] = v;
	return result;
}
function mapUnderlineToApi(storageObj) {
	const result = {};
	for (const [k$1, v] of Object.entries(storageObj)) result[UNDERLINE_STORAGE_TO_API[k$1] ?? k$1] = v;
	return result;
}
function normalizeHexColor(val) {
	return val.replace(/^#/, "").toUpperCase();
}
var HEX_SUBKEYS_BY_PROPERTY = {
	color: new Set(["val"]),
	shading: new Set(["color", "fill"]),
	underline: new Set(["color", "w:color"]),
	borders: new Set(["color"])
};
function normalizeObjectSubKeys(obj, key) {
	const hexKeys = HEX_SUBKEYS_BY_PROPERTY[key];
	if (!hexKeys) return obj;
	const result = {};
	for (const [k$1, v] of Object.entries(obj)) if (typeof v === "string" && hexKeys.has(k$1)) result[k$1] = normalizeHexColor(v);
	else result[k$1] = v;
	return result;
}
function jsonDeepEqual(a, b$1) {
	if (a === b$1) return true;
	if (a === null || b$1 === null) return false;
	if (typeof a !== typeof b$1) return false;
	if (Array.isArray(a)) {
		if (!Array.isArray(b$1) || a.length !== b$1.length) return false;
		for (let i = 0; i < a.length; i++) if (!jsonDeepEqual(a[i], b$1[i])) return false;
		return true;
	}
	if (typeof a === "object") {
		const aObj = a;
		const bObj = b$1;
		const aKeys = Object.keys(aObj);
		const bKeys = Object.keys(bObj);
		if (aKeys.length !== bKeys.length) return false;
		for (const key of aKeys) {
			if (!Object.prototype.hasOwnProperty.call(bObj, key)) return false;
			if (!jsonDeepEqual(aObj[key], bObj[key])) return false;
		}
		return true;
	}
	return false;
}
function formatState(value, schema, key) {
	if (value === void 0) return "inherit";
	switch (schema.kind) {
		case "boolean": return value ? "on" : "off";
		case "object":
			if (typeof value === "object" && value !== null) {
				const obj = { ...value };
				return key === "underline" ? mapUnderlineToApi(obj) : obj;
			}
			return value;
		case "array": return Array.isArray(value) ? [...value.map((item) => structuredClone(item))] : value;
		default: return value;
	}
}
function asRecord$1(value) {
	return typeof value === "object" && value !== null ? value : {};
}
function cloneForStorage(value) {
	if (value === null || typeof value !== "object") return value;
	return structuredClone(value);
}
function applyReplace(targetProps, key, value) {
	targetProps[key] = cloneForStorage(value);
}
function applyShallowMerge(targetProps, key, value) {
	const current = asRecord$1(targetProps[key]);
	const patch = value;
	if (key === "underline") {
		const storagePatch = cloneForStorage(mapUnderlineToStorage(normalizeObjectSubKeys(patch, key)));
		targetProps[key] = {
			...current,
			...storagePatch
		};
		return;
	}
	targetProps[key] = {
		...current,
		...cloneForStorage(normalizeObjectSubKeys(patch, key))
	};
}
function applyEdgeMerge(targetProps, key, value) {
	const current = asRecord$1(targetProps[key]);
	const patch = value;
	const result = { ...current };
	for (const [edge, edgeValue] of Object.entries(patch)) result[edge] = {
		...asRecord$1(result[edge]),
		...cloneForStorage(normalizeObjectSubKeys(edgeValue, key))
	};
	targetProps[key] = result;
}
function applyPatch(targetProps, patch, channel) {
	const before = {};
	const after = {};
	const patchKeys = new Set(Object.keys(patch));
	for (const def of PROPERTY_REGISTRY) {
		if (def.channel !== channel || !patchKeys.has(def.key)) continue;
		const key = def.key;
		const value = patch[key];
		before[key] = formatState(targetProps[key], def.schema, key);
		switch (def.mergeStrategy) {
			case "replace":
				applyReplace(targetProps, key, value);
				break;
			case "shallowMerge":
				applyShallowMerge(targetProps, key, value);
				break;
			case "edgeMerge":
				applyEdgeMerge(targetProps, key, value);
				break;
		}
		after[key] = formatState(targetProps[key], def.schema, key);
	}
	return {
		before,
		after,
		changed: !jsonDeepEqual(before, after)
	};
}
function stylesApplyAdapter(editor, input, options) {
	const channel = input.target.channel;
	const converter = editor.converter;
	if (!converter) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "styles.apply requires a document converter.", { reason: "converter_missing" });
	const stylesPart = converter.convertedXml[STYLES_PART];
	if (!stylesPart) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "styles.apply requires word/styles.xml to be present in the document package.", { reason: "styles_part_missing" });
	if (!stylesPart.elements?.find((el) => el.name === "w:styles")) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "word/styles.xml does not contain a w:styles root element.", { reason: "styles_root_missing" });
	const resolution = {
		scope: "docDefaults",
		channel,
		xmlPart: STYLES_PART,
		xmlPath: XML_PATH_BY_CHANNEL[channel]
	};
	const dryRun = options.dryRun;
	return mutatePart({
		editor,
		partId: STYLES_PART,
		operation: "mutate",
		source: "styles.apply",
		dryRun,
		expectedRevision: options.expectedRevision,
		mutate({ dryRun: isDryRun }) {
			const propsKey = PROPERTIES_KEY_BY_CHANNEL[channel];
			const existingProps = converter.translatedLinkedStyles?.docDefaults?.[propsKey];
			let targetProps;
			if (isDryRun) targetProps = existingProps ? structuredClone(existingProps) : {};
			else {
				if (!converter.translatedLinkedStyles) converter.translatedLinkedStyles = {};
				if (!converter.translatedLinkedStyles.docDefaults) converter.translatedLinkedStyles.docDefaults = {};
				if (!converter.translatedLinkedStyles.docDefaults[propsKey]) converter.translatedLinkedStyles.docDefaults[propsKey] = {};
				targetProps = converter.translatedLinkedStyles.docDefaults[propsKey];
			}
			const { before, after, changed } = applyPatch(targetProps, input.patch, channel);
			if (changed && !isDryRun) syncDocDefaultsToConvertedXml(converter, translator);
			return {
				success: true,
				changed,
				resolution,
				dryRun: isDryRun,
				before,
				after
			};
		}
	}).result;
}
var import_jszip_min = /* @__PURE__ */ __toESM(require_jszip_min(), 1);
async function readOpcPackage(bytes) {
	const zip = await import_jszip_min.default.loadAsync(bytes);
	const entries = [];
	zip.forEach((relativePath, file) => {
		if (file.dir) return;
		entries.push({
			name: relativePath,
			file
		});
	});
	const byName = /* @__PURE__ */ new Map();
	await Promise.all(entries.map(async ({ name, file }) => {
		byName.set(name, await file.async("uint8array"));
	}));
	return { byName };
}
function decodeText(bytes) {
	return ensureXmlString(bytes);
}
function localName$1(el) {
	if (!el.name) return void 0;
	return el.name.includes(":") ? el.name.split(":").pop() : el.name;
}
function rootElement(parsed, name) {
	return parsed.elements?.find((el) => localName$1(el) === name);
}
function childrenByLocalName(el, name) {
	return (el.elements ?? []).filter((c) => localName$1(c) === name);
}
function firstChildByLocalName(el, name) {
	return (el.elements ?? []).find((c) => localName$1(c) === name);
}
function clone(value) {
	return structuredClone(value);
}
function mergeIgnorableValues(currentValue, sourceValue) {
	const merged = [...new Set([...(currentValue ?? "").split(/\s+/).filter(Boolean), ...(sourceValue ?? "").split(/\s+/).filter(Boolean)])];
	return merged.length ? merged.join(" ") : void 0;
}
function mergeNamespaceAttributes(currentEl, sourceEl) {
	const sourceAttrs = sourceEl.attributes ?? {};
	if (Object.keys(sourceAttrs).length === 0) return;
	const nextAttrs = { ...currentEl.attributes ?? {} };
	for (const [key, value] of Object.entries(sourceAttrs)) {
		if (key === "mc:Ignorable") {
			const merged = mergeIgnorableValues(nextAttrs[key], value);
			if (merged) nextAttrs[key] = merged;
			continue;
		}
		if (key === "xmlns" || key.startsWith("xmlns:")) nextAttrs[key] = value;
	}
	currentEl.attributes = nextAttrs;
}
function deepEqualValue(a, b$1) {
	if (a === b$1) return true;
	if (a == null || b$1 == null) return a === b$1;
	if (typeof a !== typeof b$1) return false;
	if (Array.isArray(a) || Array.isArray(b$1)) {
		if (!Array.isArray(a) || !Array.isArray(b$1) || a.length !== b$1.length) return false;
		for (let i = 0; i < a.length; i++) if (!deepEqualValue(a[i], b$1[i])) return false;
		return true;
	}
	if (typeof a !== "object") return false;
	const aRecord = a;
	const bRecord = b$1;
	const aKeys = Object.keys(aRecord);
	const bKeys = Object.keys(bRecord);
	if (aKeys.length !== bKeys.length) return false;
	for (const key of aKeys) {
		if (!(key in bRecord)) return false;
		if (!deepEqualValue(aRecord[key], bRecord[key])) return false;
	}
	return true;
}
function xmlDeepEqual(a, b$1) {
	return deepEqualValue(a, b$1);
}
function styleId(el) {
	return el.attributes?.["w:styleId"];
}
function replaceSingleton(stylesEl, name, sourceNode) {
	if (!sourceNode) return false;
	if (!stylesEl.elements) stylesEl.elements = [];
	const existingSingletons = stylesEl.elements.filter((c) => localName$1(c) === name);
	const existingIndex = stylesEl.elements.findIndex((c) => localName$1(c) === name);
	const desiredIndex = name === "docDefaults" ? 0 : stylesEl.elements.some((c) => localName$1(c) === "docDefaults") ? 1 : 0;
	if (existingSingletons.length === 1 && existingIndex === desiredIndex && xmlDeepEqual(existingSingletons[0], sourceNode)) return false;
	stylesEl.elements = stylesEl.elements.filter((c) => localName$1(c) !== name);
	const next = clone(sourceNode);
	if (name === "docDefaults") {
		stylesEl.elements.unshift(next);
		return true;
	}
	const insertAt = stylesEl.elements.some((c) => localName$1(c) === "docDefaults") ? 1 : 0;
	stylesEl.elements.splice(insertAt, 0, next);
	return true;
}
function mergeStylesAuthoritative(currentRoot, sourceRoot) {
	const result = {
		replacedIds: [],
		addedIds: [],
		docDefaultsAdopted: false,
		latentStylesAdopted: false,
		importedStyleEls: []
	};
	const curStyles = rootElement(currentRoot, "styles");
	const srcStyles = rootElement(sourceRoot, "styles");
	if (!curStyles || !srcStyles) return result;
	mergeNamespaceAttributes(curStyles, srcStyles);
	if (!curStyles.elements) curStyles.elements = [];
	result.docDefaultsAdopted = replaceSingleton(curStyles, "docDefaults", firstChildByLocalName(srcStyles, "docDefaults"));
	result.latentStylesAdopted = replaceSingleton(curStyles, "latentStyles", firstChildByLocalName(srcStyles, "latentStyles"));
	const indexById = /* @__PURE__ */ new Map();
	curStyles.elements.forEach((el, idx) => {
		if (localName$1(el) === "style") {
			const id = styleId(el);
			if (id) indexById.set(id, idx);
		}
	});
	const srcStyleEls = childrenByLocalName(srcStyles, "style");
	for (const srcEl of srcStyleEls) {
		const id = styleId(srcEl);
		if (!id) continue;
		const next = clone(srcEl);
		if (indexById.has(id)) {
			const idx = indexById.get(id);
			curStyles.elements[idx] = next;
			result.replacedIds.push(id);
		} else {
			curStyles.elements.push(next);
			indexById.set(id, curStyles.elements.length - 1);
			result.addedIds.push(id);
		}
		result.importedStyleEls.push(next);
	}
	return result;
}
function rewriteImportedStyleNumbering(importedStyleEls, numRemap) {
	if (numRemap.size === 0) return;
	const walk = (el) => {
		if (localName$1(el) === "numId") {
			const v = el.attributes?.["w:val"];
			if (v !== void 0 && numRemap.has(v)) el.attributes["w:val"] = numRemap.get(v);
		}
		if (el.elements) for (const c of el.elements) walk(c);
	};
	for (const styleEl of importedStyleEls) walk(styleEl);
}
function numAttr(el, attr) {
	return el.attributes?.[attr];
}
function reorderNumberingChildren(numberingEl) {
	if (!numberingEl.elements) return;
	const other = [];
	const abstracts = [];
	const nums = [];
	for (const el of numberingEl.elements) {
		const ln = localName$1(el);
		if (ln === "abstractNum") abstracts.push(el);
		else if (ln === "num") nums.push(el);
		else other.push(el);
	}
	numberingEl.elements = [
		...other,
		...abstracts,
		...nums
	];
}
function mergeNumberingGraph(currentRoot, sourceRoot) {
	const result = {
		numRemap: /* @__PURE__ */ new Map(),
		abstractRemap: /* @__PURE__ */ new Map(),
		mappings: []
	};
	const cur = rootElement(currentRoot, "numbering");
	const src = rootElement(sourceRoot, "numbering");
	if (!cur || !src) return result;
	mergeNamespaceAttributes(cur, src);
	if (!cur.elements) cur.elements = [];
	const usedAbstract = /* @__PURE__ */ new Set();
	const usedNum = /* @__PURE__ */ new Set();
	for (const el of cur.elements) {
		const ln = localName$1(el);
		if (ln === "abstractNum") {
			const id = numAttr(el, "w:abstractNumId");
			if (id !== void 0) usedAbstract.add(id);
		} else if (ln === "num") {
			const id = numAttr(el, "w:numId");
			if (id !== void 0) usedNum.add(id);
		}
	}
	const nextFree = (used) => {
		let i = 1;
		while (used.has(String(i))) i++;
		const v = String(i);
		used.add(v);
		return v;
	};
	const srcAbstract = childrenByLocalName(src, "abstractNum");
	const srcNums = childrenByLocalName(src, "num");
	for (const el of srcAbstract) {
		const id = numAttr(el, "w:abstractNumId");
		if (id === void 0) continue;
		const next = clone(el);
		let finalId = id;
		if (usedAbstract.has(id)) {
			finalId = nextFree(usedAbstract);
			next.attributes = next.attributes ?? {};
			next.attributes["w:abstractNumId"] = finalId;
			result.mappings.push({
				kind: "numbering",
				from: `abstractNumId:${id}`,
				to: `abstractNumId:${finalId}`
			});
		} else usedAbstract.add(id);
		result.abstractRemap.set(id, finalId);
		cur.elements.push(next);
	}
	for (const el of srcNums) {
		const id = numAttr(el, "w:numId");
		if (id === void 0) continue;
		const next = clone(el);
		const absRef = firstChildByLocalName(next, "abstractNumId");
		const absVal = absRef?.attributes?.["w:val"];
		if (absRef && absVal !== void 0 && result.abstractRemap.has(absVal)) {
			absRef.attributes = absRef.attributes ?? {};
			absRef.attributes["w:val"] = result.abstractRemap.get(absVal);
		}
		let finalId = id;
		if (usedNum.has(id)) {
			finalId = nextFree(usedNum);
			next.attributes = next.attributes ?? {};
			next.attributes["w:numId"] = finalId;
			result.numRemap.set(id, finalId);
			result.mappings.push({
				kind: "numbering",
				from: `numId:${id}`,
				to: `numId:${finalId}`
			});
		} else usedNum.add(id);
		cur.elements.push(next);
	}
	reorderNumberingChildren(cur);
	return result;
}
var LAYOUT_AFFECTING_SETTING_NAMES = new Set([
	"defaultTabStop",
	"autoHyphenation",
	"consecutiveHyphenLimit",
	"hyphenationZone",
	"doNotHyphenateCaps",
	"characterSpacingControl",
	"decimalSymbol",
	"listSeparator",
	"mirrorMargins",
	"gutterAtTop",
	"bookFoldPrinting",
	"bookFoldRevPrinting",
	"bookFoldPrintingSheets",
	"evenAndOddHeaders",
	"compat",
	"themeFontLang",
	"displayBackgroundShape",
	"noPunctuationKerning",
	"kerning"
]);
function reconcileSettings(currentRoot, sourceRoot) {
	const result = {
		adopted: [],
		changed: false
	};
	const cur = rootElement(currentRoot, "settings");
	const src = rootElement(sourceRoot, "settings");
	if (!cur || !src) return result;
	mergeNamespaceAttributes(cur, src);
	if (!cur.elements) cur.elements = [];
	for (const srcEl of src.elements ?? []) {
		const ln = localName$1(srcEl);
		if (!ln || !LAYOUT_AFFECTING_SETTING_NAMES.has(ln)) continue;
		const idx = cur.elements.findIndex((c) => localName$1(c) === ln);
		const next = clone(srcEl);
		if (idx >= 0) {
			if (xmlDeepEqual(cur.elements[idx], next)) continue;
			cur.elements[idx] = next;
		} else cur.elements.push(next);
		result.adopted.push(ln);
		result.changed = true;
	}
	return result;
}
function findFinalBodySectPr(documentRoot) {
	const doc$1 = rootElement(documentRoot, "document");
	if (!doc$1) return void 0;
	const body = firstChildByLocalName(doc$1, "body");
	if (!body) return void 0;
	const sectPrs = childrenByLocalName(body, "sectPr");
	return sectPrs.length ? sectPrs[sectPrs.length - 1] : void 0;
}
function findParagraphSectPr(paragraph) {
	if (localName$1(paragraph) !== "p") return void 0;
	const pPr = firstChildByLocalName(paragraph, "pPr");
	return pPr ? firstChildByLocalName(pPr, "sectPr") : void 0;
}
function findFirstSectionBreakSectPr(node) {
	const directSectPr = findParagraphSectPr(node);
	if (directSectPr) return directSectPr;
	if (localName$1(node) === "pPrChange") return void 0;
	for (const child of node.elements ?? []) {
		const sectPr = findFirstSectionBreakSectPr(child);
		if (sectPr) return sectPr;
	}
}
function findPageOneSectPr(documentRoot) {
	const doc$1 = rootElement(documentRoot, "document");
	if (!doc$1) return void 0;
	const body = firstChildByLocalName(doc$1, "body");
	if (!body) return void 0;
	for (const child of body.elements ?? []) {
		if (localName$1(child) === "sectPr") continue;
		const sectPr = findFirstSectionBreakSectPr(child);
		if (sectPr) return sectPr;
	}
	return findFinalBodySectPr(documentRoot);
}
function rewriteSectPrRefs(sectPr, relIdRemap) {
	for (const el of sectPr.elements ?? []) {
		const ln = localName$1(el);
		if (ln === "headerReference" || ln === "footerReference") {
			const rid = el.attributes?.["r:id"];
			if (rid !== void 0 && relIdRemap.has(rid)) el.attributes["r:id"] = relIdRemap.get(rid);
		}
	}
}
var HEADER_REL_TYPE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header";
var FOOTER_REL_TYPE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer";
var IMAGE_REL_TYPE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";
var HEADER_CONTENT_TYPE = "application/vnd.openxmlformats-officedocument.wordprocessingml.header+xml";
var FOOTER_CONTENT_TYPE = "application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml";
var CONTENT_TYPES_PART$1 = "[Content_Types].xml";
var DOCUMENT_RELS_PART$1 = "word/_rels/document.xml.rels";
function getRelationshipsRoot$1(part) {
	if (!part) return void 0;
	return rootElement(part, "Relationships");
}
function relTargetToWordPath(target) {
	const cleaned = target.replace(/^\.\//, "").replace(/^\.\.\//, "");
	if (cleaned.startsWith("word/")) return cleaned;
	if (cleaned.startsWith("/")) return cleaned.slice(1);
	return `word/${cleaned}`;
}
function baseName(p$1) {
	return p$1.split("/").pop() ?? p$1;
}
function extOf(name) {
	const m$1 = name.match(/\.([^.]+)$/);
	return m$1 ? m$1[1] : "";
}
function importHeaderFooterAssets(editor, converter, byName, dryRun) {
	const result = {
		relIdRemap: /* @__PURE__ */ new Map(),
		changedParts: [],
		mappings: [],
		warnings: [],
		detected: false,
		applied: false
	};
	const srcRelsRaw = byName.get(DOCUMENT_RELS_PART$1);
	const srcRelEls = getRelationshipsRoot$1(srcRelsRaw ? converter.parseXmlToJson(decodeText(srcRelsRaw)) : void 0)?.elements ?? [];
	const hfPartNames = [...byName.keys()].filter((n) => /^word\/(header|footer)\d+\.xml$/.test(n)).sort();
	if (hfPartNames.length === 0) return result;
	result.detected = true;
	if (dryRun) {
		for (const srcPart of hfPartNames) result.changedParts.push({
			part: srcPart,
			scope: "headersFooters",
			change: "imported"
		});
		return result;
	}
	const usedPartNames = new Set(Object.keys(converter.convertedXml));
	const allocatePartName = (sourceTarget, kind) => {
		const desired = `word/${sourceTarget}`;
		if (!usedPartNames.has(desired)) {
			usedPartNames.add(desired);
			return desired;
		}
		let i = 1;
		while (usedPartNames.has(`word/${kind}${i}.xml`)) i++;
		const allocated = `word/${kind}${i}.xml`;
		usedPartNames.add(allocated);
		return allocated;
	};
	let docRelsPart = converter.convertedXml[DOCUMENT_RELS_PART$1];
	if (!docRelsPart) {
		docRelsPart = { elements: [{
			type: "element",
			name: "Relationships",
			attributes: { xmlns: "http://schemas.openxmlformats.org/package/2006/relationships" },
			elements: []
		}] };
		converter.convertedXml[DOCUMENT_RELS_PART$1] = docRelsPart;
	}
	const docRelsRoot = getRelationshipsRoot$1(docRelsPart);
	if (!docRelsRoot.elements) docRelsRoot.elements = [];
	const usedRelIds = new Set(docRelsRoot.elements.map((el) => el.attributes?.Id).filter((x) => !!x));
	const allocateRelId = () => {
		let max$2 = 0;
		for (const id of usedRelIds) {
			const m$1 = id.match(/^rId(\d+)$/);
			if (m$1) max$2 = Math.max(max$2, Number(m$1[1]));
		}
		const next = `rId${max$2 + 1}`;
		usedRelIds.add(next);
		return next;
	};
	const mediaStore = converter.convertedXml.media ?? converter.media ?? {};
	converter.convertedXml.media = mediaStore;
	converter.media = mediaStore;
	if (!converter.addedMedia) converter.addedMedia = {};
	const usedMedia = new Set([...Object.keys(mediaStore), ...Object.keys(converter.convertedXml).filter((p$1) => p$1.startsWith("word/media/"))]);
	const allocateMediaPath = (sourceMediaPath) => {
		const base = baseName(sourceMediaPath);
		const desired = `word/media/${base}`;
		if (!usedMedia.has(desired)) {
			usedMedia.add(desired);
			return desired;
		}
		const ext = extOf(base);
		let i = 1;
		while (usedMedia.has(`word/media/tmpl-image${i}.${ext}`)) i++;
		const allocated = `word/media/tmpl-image${i}.${ext}`;
		usedMedia.add(allocated);
		return allocated;
	};
	const sourceRelIdsByTarget = /* @__PURE__ */ new Map();
	for (const rel of srcRelEls) {
		const type = rel.attributes?.Type;
		const target = rel.attributes?.Target;
		const id = rel.attributes?.Id;
		if (!type || !target || !id) continue;
		if (type === HEADER_REL_TYPE || type === FOOTER_REL_TYPE) {
			const sourceTarget = relTargetToWordPath(target).replace(/^word\//, "");
			const existing = sourceRelIdsByTarget.get(sourceTarget);
			if (existing) existing.push(id);
			else sourceRelIdsByTarget.set(sourceTarget, [id]);
		}
	}
	const setHeaderIdsArray = (idsHolder, relId) => {
		if (!Array.isArray(idsHolder.ids)) idsHolder.ids = [];
		idsHolder.ids.push(relId);
	};
	let docRelsChanged = false;
	let contentTypesChanged = false;
	for (const srcPart of hfPartNames) {
		const kind = /header/.test(baseName(srcPart)) ? "header" : "footer";
		const sourceTarget = baseName(srcPart);
		const targetPartName = allocatePartName(sourceTarget, kind);
		const targetBase = baseName(targetPartName);
		let parsedPart;
		try {
			parsedPart = converter.parseXmlToJson(decodeText(byName.get(srcPart)));
		} catch {
			result.warnings.push({
				code: "HEADER_FOOTER_PARSE_FAILED",
				message: `Could not parse source ${srcPart}; skipped.`
			});
			continue;
		}
		const srcPartRelsPath = `word/_rels/${sourceTarget}.rels`;
		const srcPartRelsRaw = byName.get(srcPartRelsPath);
		if (srcPartRelsRaw) {
			let parsedRels;
			try {
				parsedRels = converter.parseXmlToJson(decodeText(srcPartRelsRaw));
			} catch {
				parsedRels = { elements: [] };
			}
			const relsRoot = getRelationshipsRoot$1(parsedRels);
			for (const rel of relsRoot?.elements ?? []) {
				const type = rel.attributes?.Type;
				const target = rel.attributes?.Target;
				const mode = rel.attributes?.TargetMode;
				if (!type || !target) continue;
				if (mode === "External") continue;
				if (type === IMAGE_REL_TYPE || /\/media\//.test(relTargetToWordPath(target))) {
					const srcMediaPath = relTargetToWordPath(target);
					const bytes = byName.get(srcMediaPath);
					if (!bytes) {
						result.warnings.push({
							code: "MEDIA_MISSING",
							message: `Header/footer ${srcPart} references missing media ${srcMediaPath}.`
						});
						continue;
					}
					const targetMediaPath = allocateMediaPath(srcMediaPath);
					mediaStore[targetMediaPath] = bytes;
					converter.addedMedia[targetMediaPath] = bytes;
					const imgStorage = editor.storage?.image?.media;
					if (imgStorage) imgStorage[targetMediaPath] = bytes;
					rel.attributes.Target = `media/${baseName(targetMediaPath)}`;
					result.changedParts.push({
						part: targetMediaPath,
						scope: "headersFooters",
						change: "imported"
					});
					if (baseName(targetMediaPath) !== baseName(srcMediaPath)) result.mappings.push({
						kind: "relationship",
						from: baseName(srcMediaPath),
						to: baseName(targetMediaPath)
					});
				}
			}
			converter.convertedXml[`word/_rels/${targetBase}.rels`] = parsedRels;
		}
		converter.convertedXml[targetPartName] = parsedPart;
		result.changedParts.push({
			part: targetPartName,
			scope: "headersFooters",
			change: "imported"
		});
		const relId = allocateRelId();
		docRelsRoot.elements.push({
			type: "element",
			name: "Relationship",
			attributes: {
				Id: relId,
				Type: kind === "header" ? HEADER_REL_TYPE : FOOTER_REL_TYPE,
				Target: targetBase
			}
		});
		docRelsChanged = true;
		const sourceRelIds = sourceRelIdsByTarget.get(sourceTarget) ?? [];
		for (const sourceRelId of sourceRelIds) {
			result.relIdRemap.set(sourceRelId, relId);
			result.mappings.push({
				kind: "relationship",
				from: sourceRelId,
				to: relId
			});
		}
		if (ensureContentTypeOverride$1(converter, targetPartName, kind === "header" ? HEADER_CONTENT_TYPE : FOOTER_CONTENT_TYPE)) contentTypesChanged = true;
		try {
			const pmJson = converter.reimportHeaderFooterPart?.(targetPartName);
			if (pmJson) {
				const collection = kind === "header" ? converter.headers ??= {} : converter.footers ??= {};
				collection[relId] = pmJson;
				setHeaderIdsArray(kind === "header" ? converter.headerIds ??= {} : converter.footerIds ??= {}, relId);
			}
		} catch {}
	}
	if (docRelsChanged) result.changedParts.push({
		part: DOCUMENT_RELS_PART$1,
		scope: "package",
		change: "merged"
	});
	if (contentTypesChanged) result.changedParts.push({
		part: CONTENT_TYPES_PART$1,
		scope: "package",
		change: "merged"
	});
	result.applied = result.changedParts.length > 0;
	return result;
}
function ensureContentTypeOverride$1(converter, partPath, contentType) {
	const ct = converter.convertedXml[CONTENT_TYPES_PART$1];
	const types = ct ? rootElement(ct, "Types") : void 0;
	if (!types) return false;
	if (!types.elements) types.elements = [];
	const partName = `/${partPath}`;
	if (types.elements.some((el) => el.name === "Override" && el.attributes?.PartName === partName)) return false;
	types.elements.push({
		type: "element",
		name: "Override",
		attributes: {
			PartName: partName,
			ContentType: contentType
		}
	});
	return true;
}
var HEADER_FOOTER_KINDS = ["header", "footer"];
var HEADER_FOOTER_VARIANTS$2 = [
	"default",
	"first",
	"even"
];
function toSectionXmlElement(node) {
	if (!node.name) throw new Error("Expected named XML element.");
	return {
		type: node.type,
		name: node.name,
		attributes: node.attributes ? { ...node.attributes } : void 0,
		elements: node.elements?.filter((child) => typeof child.name === "string").map((child) => toSectionXmlElement(child))
	};
}
function mergePageOneHeaderFooterModel(targetSectPr, sourceSectPr) {
	const mergedSectPr = ensureSectPrElement(targetSectPr);
	for (const kind of HEADER_FOOTER_KINDS) for (const variant of HEADER_FOOTER_VARIANTS$2) {
		const sourceRef = getSectPrHeaderFooterRef(sourceSectPr, kind, variant);
		if (sourceRef) setSectPrHeaderFooterRef(mergedSectPr, kind, variant, sourceRef);
		else clearSectPrHeaderFooterRef(mergedSectPr, kind, variant);
	}
	writeSectPrTitlePage(mergedSectPr, readSectPrTitlePage(sourceSectPr));
	return mergedSectPr;
}
function applyPageOneSectionDefaults(editor, sourceDocumentXml, relIdRemap, parseXml, dryRun) {
	const result = {
		detected: false,
		applied: false,
		changed: false,
		changedParts: [],
		warnings: []
	};
	let parsedDoc;
	try {
		parsedDoc = parseXml(sourceDocumentXml);
	} catch {
		return result;
	}
	const sourceSectPr = findPageOneSectPr(parsedDoc);
	if (!sourceSectPr) return result;
	result.detected = true;
	let sectPr;
	try {
		const rewrittenSectPr = clone(sourceSectPr);
		rewriteSectPrRefs(rewrittenSectPr, relIdRemap);
		sectPr = toSectionXmlElement(rewrittenSectPr);
	} catch {
		result.warnings.push({
			code: "SECTION_DEFAULTS_UNAVAILABLE",
			message: "Could not normalize the source page-1 sectPr."
		});
		return result;
	}
	let projections;
	try {
		projections = resolveSectionProjections(editor);
	} catch {
		result.warnings.push({
			code: "SECTION_DEFAULTS_UNAVAILABLE",
			message: "Could not resolve sections to apply the source page-1 sectPr."
		});
		return result;
	}
	if (projections.length === 0) {
		result.warnings.push({
			code: "SECTION_DEFAULTS_UNAVAILABLE",
			message: "No section projections found for page-1 sectPr adoption."
		});
		return result;
	}
	const bodyProjection = [...projections].reverse().find((projection) => projection.target.kind === "body") ?? projections[projections.length - 1];
	const sectionUpdates = projections.map((projection) => {
		const currentSectPr = readTargetSectPr(editor, projection);
		const nextSectPr = projection.sectionId === bodyProjection.sectionId ? clone(sectPr) : mergePageOneHeaderFooterModel(currentSectPr, sectPr);
		if (xmlDeepEqual(currentSectPr, nextSectPr)) return null;
		return {
			sectionId: projection.sectionId,
			nextSectPr
		};
	}).filter((update) => Boolean(update));
	if (sectionUpdates.length === 0) return result;
	result.changed = true;
	result.changedParts.push({
		part: "word/document.xml",
		scope: "sectionDefaults",
		change: sectionUpdates.some((update) => update.sectionId !== bodyProjection.sectionId) ? "merged" : "replaced"
	});
	if (dryRun) return result;
	try {
		for (let index = 0; index < sectionUpdates.length; index += 1) {
			const update = sectionUpdates[index];
			const liveProjection = resolveSectionProjections(editor).find((projection) => projection.sectionId === update.sectionId);
			if (!liveProjection) throw new Error(`Section ${update.sectionId} disappeared during page-1 sectPr adoption.`);
			applySectPrToProjection$1(editor, liveProjection, clone(update.nextSectPr), { addToHistory: index === sectionUpdates.length - 1 });
		}
		clearIndexCache(editor);
		result.applied = true;
	} catch (err) {
		result.changed = false;
		result.changedParts = [];
		result.warnings.push({
			code: "SECTION_DEFAULTS_FAILED",
			message: `Failed to apply source page-1 sectPr: ${err.message ?? "unknown error"}.`
		});
	}
	return result;
}
var SUBSTRATE_SCOPE_ORDER = [
	"styles",
	"numbering",
	"settings",
	"theme",
	"fontTable",
	"webSettings"
];
var CONTENT_TYPE_BY_SCOPE = {
	theme: "application/vnd.openxmlformats-officedocument.theme+xml",
	fontTable: "application/vnd.openxmlformats-officedocument.wordprocessingml.fontTable+xml",
	webSettings: "application/vnd.openxmlformats-officedocument.wordprocessingml.webSettings+xml"
};
var REL_TYPE_BY_PART = {
	theme: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
	fontTable: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/fontTable"
};
var CONTENT_TYPES_PART = "[Content_Types].xml";
var DOCUMENT_RELS_PART = "word/_rels/document.xml.rels";
function categorizeOutOfScope(name) {
	if (name.startsWith("customXml/")) return { category: "customXml" };
	if (name.startsWith("docProps/")) return { category: "docProps" };
	if (name.startsWith("word/glossary/")) return { category: "glossary" };
	if (name.startsWith("_xmlsignatures/") || name.includes("/_xmlsignatures/") || /signatures/i.test(name)) return { category: "signatures" };
	if (name.startsWith("word/embeddings/")) return { category: "embeddings" };
}
function detectScopes(byName) {
	const substrate = [];
	const unsupported = [];
	const has = (p$1) => byName.has(p$1);
	const text = (p$1) => decodeText(byName.get(p$1));
	if (has("word/styles.xml")) substrate.push({
		scope: "styles",
		part: "word/styles.xml",
		xml: text("word/styles.xml")
	});
	if (has("word/numbering.xml")) substrate.push({
		scope: "numbering",
		part: "word/numbering.xml",
		xml: text("word/numbering.xml")
	});
	if (has("word/settings.xml")) substrate.push({
		scope: "settings",
		part: "word/settings.xml",
		xml: text("word/settings.xml")
	});
	const themeParts = [...byName.keys()].filter((n) => /^word\/theme\/[^/]+\.xml$/.test(n)).sort();
	if (themeParts.length > 0) substrate.push({
		scope: "theme",
		part: "word/theme/theme1.xml",
		xml: text(themeParts[0])
	});
	if (has("word/fontTable.xml")) substrate.push({
		scope: "fontTable",
		part: "word/fontTable.xml",
		xml: text("word/fontTable.xml")
	});
	if (has("word/webSettings.xml")) substrate.push({
		scope: "webSettings",
		part: "word/webSettings.xml",
		xml: text("word/webSettings.xml")
	});
	const hfParts = [...byName.keys()].filter((n) => /^word\/(header|footer)\d+\.xml$/.test(n)).sort();
	const headersFooters = {
		detected: hfParts.length > 0,
		part: hfParts[0] ?? "word/header1.xml"
	};
	const sectionDefaults = has("word/document.xml") ? {
		detected: true,
		documentXml: text("word/document.xml")
	} : { detected: false };
	for (const name of [...byName.keys()].sort()) {
		const cat = categorizeOutOfScope(name);
		if (cat) unsupported.push({
			part: name,
			category: cat.category,
			reason: "out of initial apply scope"
		});
	}
	substrate.sort((a, b$1) => {
		const sa = SUBSTRATE_SCOPE_ORDER.indexOf(a.scope);
		const sb = SUBSTRATE_SCOPE_ORDER.indexOf(b$1.scope);
		return sa !== sb ? sa - sb : a.part.localeCompare(b$1.part);
	});
	return {
		substrate,
		headersFooters,
		sectionDefaults,
		unsupported
	};
}
function fnv1aHex(bytes) {
	let h$2 = 2166136261;
	for (let i = 0; i < bytes.length; i++) {
		h$2 ^= bytes[i];
		h$2 = Math.imul(h$2, 16777619);
	}
	return (h$2 >>> 0).toString(16).padStart(8, "0");
}
function getBuiltinModule(id) {
	const proc = globalThis.process;
	if (typeof proc?.getBuiltinModule !== "function") return;
	const direct = proc.getBuiltinModule(id);
	if (direct != null) return direct;
	if (id.startsWith("node:")) {
		const bare = proc.getBuiltinModule(id.slice(5));
		if (bare != null) return bare;
	}
}
function getNodeRequire() {
	const req = globalThis.require;
	if (typeof req === "function") return req;
	try {
		return Function("try { return require; } catch { return undefined; }")();
	} catch {
		return;
	}
}
function getNodeFs() {
	const builtin = getBuiltinModule("node:fs");
	if (builtin && typeof builtin.readFileSync === "function") return builtin;
	const req = getNodeRequire();
	try {
		const fs = req?.("node:fs");
		if (fs && typeof fs.readFileSync === "function") return fs;
	} catch {}
}
function resolveSourceBytes(input) {
	const source = input.source;
	if (source.kind === "path") {
		const fs = getNodeFs();
		if (!fs) return { failure: {
			code: "CAPABILITY_UNAVAILABLE",
			message: "templates.apply path source requires Node fs."
		} };
		try {
			const buf = fs.readFileSync(source.path);
			return { bytes: new Uint8Array(buf) };
		} catch {
			return { failure: {
				code: "UNSUPPORTED_SOURCE",
				message: "templates.apply could not read source path."
			} };
		}
	}
	try {
		let bytes;
		const g$1 = globalThis;
		if (g$1.Buffer && typeof g$1.Buffer.from === "function") bytes = new Uint8Array(g$1.Buffer.from(source.data, "base64"));
		else if (typeof g$1.atob === "function") {
			const bin = g$1.atob(source.data);
			bytes = new Uint8Array(bin.length);
			for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
		} else return { failure: {
			code: "CAPABILITY_UNAVAILABLE",
			message: "templates.apply base64 source requires Buffer or atob."
		} };
		return { bytes };
	} catch {
		return { failure: {
			code: "INVALID_PACKAGE",
			message: "templates.apply could not decode base64 source."
		} };
	}
}
function failure$2(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function pushNoChangeSkip(skippedScopes, scope, part, message) {
	skippedScopes.push({
		scope,
		part,
		reason: "NO_CHANGE",
		message
	});
}
function templatesApplyAdapter(editor, input, options) {
	const converter = editor.converter;
	if (!converter || !converter.convertedXml || typeof converter.parseXmlToJson !== "function") throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "templates.apply requires a document converter.", { reason: "converter_missing" });
	checkRevision(editor, options.expectedRevision);
	return applyTemplateAsync(editor, converter, input, options);
}
async function applyTemplateAsync(editor, converter, input, options) {
	const resolved = resolveSourceBytes(input);
	if (resolved.failure) return failure$2(resolved.failure.code, resolved.failure.message);
	const bytes = resolved.bytes;
	let byName;
	try {
		({byName} = await readOpcPackage(bytes));
	} catch (err) {
		return failure$2("INVALID_PACKAGE", `templates.apply source is not a valid DOCX package: ${err.message ?? "invalid package"}`);
	}
	const partCount = byName.size;
	if (!byName.has(CONTENT_TYPES_PART)) return failure$2("INVALID_PACKAGE", "templates.apply source is missing [Content_Types].xml.");
	const fingerprint = fnv1aHex(bytes);
	const sourceInfo = {
		kind: input.source.kind,
		fingerprint,
		partCount
	};
	const detection = detectScopes(byName);
	const dryRun = options.dryRun;
	const detectedScopes = [];
	const appliedScopes = [];
	const skippedScopes = [];
	const changedParts = [];
	const warnings = [];
	const idMappings = {};
	const styleMappings = [];
	const numberingMappings = [];
	const relationshipMappings = [];
	for (const d of detection.substrate) detectedScopes.push({
		scope: d.scope,
		part: d.part
	});
	if (detection.headersFooters.detected) detectedScopes.push({
		scope: "headersFooters",
		part: detection.headersFooters.part
	});
	if (detection.sectionDefaults.detected) detectedScopes.push({
		scope: "sectionDefaults",
		part: "word/document.xml"
	});
	const presentSubstrate = new Set(detection.substrate.map((d) => d.scope));
	for (const scope of SUBSTRATE_SCOPE_ORDER) if (!presentSubstrate.has(scope)) skippedScopes.push({
		scope,
		reason: "NOT_PRESENT_IN_SOURCE",
		message: `Source package does not contain a ${scope} part.`
	});
	for (const item of detection.unsupported) if (item.category === "customXml") {
		if (!skippedScopes.some((s) => s.scope === "customXml")) skippedScopes.push({
			scope: "customXml",
			part: item.part,
			reason: "OUT_OF_SCOPE",
			message: "customXml is not part of the supported template surface and was not applied."
		});
	}
	const parsedByPart = /* @__PURE__ */ new Map();
	for (const d of detection.substrate) try {
		parsedByPart.set(d.part, converter.parseXmlToJson(d.xml));
	} catch {
		return failure$2("UNSUPPORTED_TEMPLATE_CONTENT", `templates.apply could not parse source part ${d.part}.`);
	}
	const substrateByScope = /* @__PURE__ */ new Map();
	for (const d of detection.substrate) substrateByScope.set(d.scope, d);
	const applyDescriptorPart = (partId, mutateFn) => {
		return mutatePart({
			editor,
			partId,
			operation: "mutate",
			source: "templates.apply",
			dryRun,
			mutate() {
				mutateFn();
			}
		}).changed;
	};
	let numRemap = /* @__PURE__ */ new Map();
	const numbering = substrateByScope.get("numbering");
	if (numbering) {
		const parsed = parsedByPart.get(numbering.part);
		const hadCurrent = !!converter.convertedXml["word/numbering.xml"];
		if (applyDescriptorPart("word/numbering.xml", () => {
			const res = mergeNumberingGraph(converter.convertedXml["word/numbering.xml"], parsed);
			numRemap = res.numRemap;
			numberingMappings.push(...res.mappings);
		})) {
			appliedScopes.push({
				scope: "numbering",
				part: "word/numbering.xml"
			});
			changedParts.push({
				part: "word/numbering.xml",
				scope: "numbering",
				change: hadCurrent ? "merged" : "created"
			});
		} else pushNoChangeSkip(skippedScopes, "numbering", "word/numbering.xml", "Source numbering graph does not change the current numbering definitions.");
	}
	const styles = substrateByScope.get("styles");
	if (styles) {
		const parsed = parsedByPart.get(styles.part);
		const hadCurrent = !!converter.convertedXml["word/styles.xml"];
		let docDefaultsAdopted = false;
		let latentStylesAdopted = false;
		const runMerge = (target) => {
			const res = mergeStylesAuthoritative(target, parsed);
			rewriteImportedStyleNumbering(res.importedStyleEls, numRemap);
			docDefaultsAdopted = res.docDefaultsAdopted;
			latentStylesAdopted = res.latentStylesAdopted;
		};
		if (applyDescriptorPart("word/styles.xml", () => {
			runMerge(converter.convertedXml["word/styles.xml"]);
		})) {
			if (docDefaultsAdopted) warnings.push({
				code: "DOC_DEFAULTS_ADOPTED",
				message: "Adopted source w:docDefaults (style baseline)."
			});
			if (latentStylesAdopted) warnings.push({
				code: "LATENT_STYLES_ADOPTED",
				message: "Adopted source w:latentStyles."
			});
			appliedScopes.push({
				scope: "styles",
				part: "word/styles.xml"
			});
			changedParts.push({
				part: "word/styles.xml",
				scope: "styles",
				change: hadCurrent ? "merged" : "created"
			});
		} else pushNoChangeSkip(skippedScopes, "styles", "word/styles.xml", "Source styles already match the current style system.");
	}
	const settings = substrateByScope.get("settings");
	if (settings) {
		const parsed = parsedByPart.get(settings.part);
		const hadCurrent = !!converter.convertedXml["word/settings.xml"];
		if (applyDescriptorPart("word/settings.xml", () => {
			reconcileSettings(converter.convertedXml["word/settings.xml"], parsed);
		})) {
			appliedScopes.push({
				scope: "settings",
				part: "word/settings.xml"
			});
			changedParts.push({
				part: "word/settings.xml",
				scope: "settings",
				change: hadCurrent ? "merged" : "created"
			});
		} else pushNoChangeSkip(skippedScopes, "settings", "word/settings.xml", "Source settings do not change the current layout-affecting settings.");
	}
	for (const scope of [
		"theme",
		"fontTable",
		"webSettings"
	]) {
		const d = substrateByScope.get(scope);
		if (!d) continue;
		const parsed = parsedByPart.get(d.part);
		const currentPart = converter.convertedXml[d.part];
		const hadCurrent = !!currentPart;
		const partChanged = !currentPart || !xmlDeepEqual(currentPart, parsed);
		const contentType = CONTENT_TYPE_BY_SCOPE[scope];
		const relType = REL_TYPE_BY_PART[scope];
		const target = d.part.replace(/^word\//, "");
		const willRegisterContentType = Boolean(contentType && canRegisterContentTypeOverride(converter, d.part));
		const willRegisterDocumentRelationship = Boolean(relType && canRegisterDocumentRelationship(converter, relType));
		if (!(partChanged || willRegisterContentType || willRegisterDocumentRelationship)) {
			pushNoChangeSkip(skippedScopes, scope, d.part, `Source ${scope} part already matches the current package state.`);
			continue;
		}
		if (!dryRun && partChanged) converter.convertedXml[d.part] = parsed;
		appliedScopes.push({
			scope,
			part: d.part
		});
		if (partChanged) changedParts.push({
			part: d.part,
			scope,
			change: hadCurrent ? "replaced" : "created"
		});
		if (contentType) {
			if (dryRun) {
				if (willRegisterContentType) changedParts.push({
					part: CONTENT_TYPES_PART,
					scope: "package",
					change: "merged"
				});
			} else if (ensureContentTypeOverride(converter, d.part, contentType)) changedParts.push({
				part: CONTENT_TYPES_PART,
				scope: "package",
				change: "merged"
			});
			else if (!converter.convertedXml[CONTENT_TYPES_PART]) warnings.push({
				code: "CONTENT_TYPE_NOT_REGISTERED",
				message: `Could not register content-type override for ${d.part}; [Content_Types].xml not present.`
			});
		}
		if (relType) {
			if (dryRun) {
				if (willRegisterDocumentRelationship) changedParts.push({
					part: DOCUMENT_RELS_PART,
					scope: "package",
					change: "merged"
				});
			} else if (ensureDocumentRelationship(converter, relType, target)) changedParts.push({
				part: DOCUMENT_RELS_PART,
				scope: "package",
				change: "merged"
			});
			else if (!converter.convertedXml[DOCUMENT_RELS_PART]) warnings.push({
				code: "RELATIONSHIP_NOT_REGISTERED",
				message: `Could not register document relationship for ${d.part}; ${DOCUMENT_RELS_PART} not present.`
			});
		}
	}
	let relIdRemap = /* @__PURE__ */ new Map();
	if (detection.headersFooters.detected) {
		const hf = importHeaderFooterAssets(editor, converter, byName, dryRun);
		relIdRemap = hf.relIdRemap;
		changedParts.push(...hf.changedParts);
		relationshipMappings.push(...hf.mappings);
		warnings.push(...hf.warnings);
		if (hf.changedParts.length > 0) appliedScopes.push({
			scope: "headersFooters",
			part: detection.headersFooters.part
		});
		else pushNoChangeSkip(skippedScopes, "headersFooters", detection.headersFooters.part, "Source headers and footers do not produce any importable changes.");
	}
	if (detection.sectionDefaults.detected && detection.sectionDefaults.documentXml) {
		const sec = applyPageOneSectionDefaults(editor, detection.sectionDefaults.documentXml, relIdRemap, (xml) => converter.parseXmlToJson(xml), dryRun);
		if (sec.changed) {
			changedParts.push(...sec.changedParts);
			warnings.push(...sec.warnings);
			appliedScopes.push({
				scope: "sectionDefaults",
				part: "word/document.xml"
			});
		} else if (sec.detected) {
			warnings.push(...sec.warnings);
			pushNoChangeSkip(skippedScopes, "sectionDefaults", "word/document.xml", sec.warnings.length > 0 ? "Source page-1 section defaults could not be applied." : "Source page-1 section defaults already match the current document's active section defaults and section header/footer visibility model.");
		}
	}
	if (styleMappings.length > 0) idMappings.styles = styleMappings;
	if (numberingMappings.length > 0) idMappings.numbering = numberingMappings;
	if (relationshipMappings.length > 0) idMappings.relationships = relationshipMappings;
	const changed = appliedScopes.length > 0;
	if (!dryRun && changed) converter.documentModified = true;
	return {
		success: true,
		changed,
		dryRun,
		bodyPolicy: "preserve",
		source: sourceInfo,
		detectedScopes,
		appliedScopes,
		skippedScopes,
		unsupportedItems: detection.unsupported,
		changedParts,
		idMappings,
		warnings
	};
}
function ensureContentTypeOverride(converter, partPath, contentType) {
	const ct = converter.convertedXml[CONTENT_TYPES_PART];
	const types = ct ? rootElement(ct, "Types") : void 0;
	if (!types) return false;
	if (!types.elements) types.elements = [];
	const partName = `/${partPath}`;
	if (types.elements.some((el) => el.name === "Override" && el.attributes?.PartName === partName)) return false;
	types.elements.push({
		type: "element",
		name: "Override",
		attributes: {
			PartName: partName,
			ContentType: contentType
		}
	});
	return true;
}
function canRegisterContentTypeOverride(converter, partPath) {
	const ct = converter.convertedXml[CONTENT_TYPES_PART];
	const types = ct ? rootElement(ct, "Types") : void 0;
	if (!types) return false;
	const partName = `/${partPath}`;
	return !types.elements?.some((el) => el.name === "Override" && el.attributes?.PartName === partName);
}
function ensureDocumentRelationship(converter, relType, target) {
	const rels = converter.convertedXml[DOCUMENT_RELS_PART];
	const relsRoot = rels ? rootElement(rels, "Relationships") : void 0;
	if (!relsRoot) return false;
	if (!relsRoot.elements) relsRoot.elements = [];
	if (relsRoot.elements.some((el) => el.name === "Relationship" && el.attributes?.Type === relType)) return false;
	let max$2 = 0;
	for (const el of relsRoot.elements) {
		const m$1 = el.attributes?.Id?.match(/^rId(\d+)$/);
		if (m$1) max$2 = Math.max(max$2, Number(m$1[1]));
	}
	relsRoot.elements.push({
		type: "element",
		name: "Relationship",
		attributes: {
			Id: `rId${max$2 + 1}`,
			Type: relType,
			Target: target
		}
	});
	return true;
}
function canRegisterDocumentRelationship(converter, relType) {
	const rels = converter.convertedXml[DOCUMENT_RELS_PART];
	const relsRoot = rels ? rootElement(rels, "Relationships") : void 0;
	if (!relsRoot) return false;
	return !relsRoot.elements?.some((el) => el.name === "Relationship" && el.attributes?.Type === relType);
}
function collectTrackInsertRefsInRange(editor, from$1, to) {
	if (to <= from$1) return void 0;
	const doc$1 = editor.state.doc;
	if (typeof doc$1.nodesBetween !== "function") return void 0;
	const canonicalIdByAlias = buildTrackedChangeCanonicalIdMap(editor);
	const ids = /* @__PURE__ */ new Set();
	doc$1.nodesBetween(from$1, to, (node) => {
		const marks = node.marks ?? [];
		for (const mark of marks) {
			if (mark.type.name !== "trackInsert") continue;
			const alias = getTrackedChangeMarkAlias(mark);
			if (!alias) continue;
			ids.add(canonicalIdByAlias.get(alias) ?? alias);
		}
	});
	if (ids.size === 0) return void 0;
	return Array.from(ids).map((id) => ({
		kind: "entity",
		entityType: "trackedChange",
		entityId: id
	}));
}
function mintBlockRef(editor, storyKey, nodeId, textLength) {
	return encodeV4Ref({
		v: 4,
		rev: getRevision(editor),
		storyKey,
		scope: "block",
		matchId: `create:${nodeId}`,
		segments: [{
			blockId: nodeId,
			start: 0,
			end: textLength
		}],
		blockIndex: 0
	});
}
function resolveCreateInsertPosition(editor, at) {
	const location$1 = at ?? { kind: "documentEnd" };
	if (location$1.kind === "documentStart") return 0;
	if (location$1.kind === "documentEnd") return editor.state.doc.content.size;
	const { pos } = resolveCreateAnchor(editor, location$1.target, location$1.kind);
	return pos;
}
function resolveCreatedBlock(editor, nodeType, blockId) {
	const index = getBlockIndex(editor);
	const resolved = index.byId.get(`${nodeType}:${blockId}`);
	if (resolved) return resolved;
	const bySdBlockId = index.candidates.find((candidate) => {
		if (candidate.nodeType !== nodeType) return false;
		const attrs = candidate.node.attrs;
		return typeof attrs?.sdBlockId === "string" && attrs.sdBlockId === blockId;
	});
	if (bySdBlockId) return bySdBlockId;
	const fallback = index.candidates.find((candidate) => candidate.nodeType === nodeType && candidate.nodeId === blockId);
	if (fallback) return fallback;
	throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Created ${nodeType} could not be resolved after insertion.`, { [`${nodeType}Id`]: blockId });
}
function buildParagraphCreateSuccess(paragraphNodeId, trackedChangeRefs, story, ref$1) {
	return {
		success: true,
		paragraph: {
			kind: "block",
			nodeType: "paragraph",
			nodeId: paragraphNodeId,
			...story && { story }
		},
		insertionPoint: {
			kind: "text",
			blockId: paragraphNodeId,
			range: {
				start: 0,
				end: 0
			},
			...story && { story }
		},
		trackedChangeRefs,
		...ref$1 ? { ref: ref$1 } : {}
	};
}
function buildHeadingCreateSuccess(headingNodeId, trackedChangeRefs, story, ref$1) {
	return {
		success: true,
		heading: {
			kind: "block",
			nodeType: "heading",
			nodeId: headingNodeId,
			...story && { story }
		},
		insertionPoint: {
			kind: "text",
			blockId: headingNodeId,
			range: {
				start: 0,
				end: 0
			},
			...story && { story }
		},
		trackedChangeRefs,
		...ref$1 ? { ref: ref$1 } : {}
	};
}
function createParagraphWrapper(editor, input, options) {
	const runtime = resolveWriteStoryRuntime(editor, input.in);
	const storyEditor = runtime.editor;
	try {
		const insertParagraphAt$1 = requireEditorCommand(storyEditor.commands?.insertParagraphAt, "create.paragraph");
		const mode = options?.changeMode ?? "direct";
		if (mode === "tracked") ensureTrackedCapability(storyEditor, { operation: "create.paragraph" });
		const insertAt = resolveCreateInsertPosition(storyEditor, input.at);
		if (options?.dryRun) {
			if (!storyEditor.can().insertParagraphAt?.({
				pos: insertAt,
				text: input.text,
				tracked: mode === "tracked"
			})) return {
				success: false,
				failure: {
					code: "INVALID_TARGET",
					message: "Paragraph creation could not be applied at the requested location."
				}
			};
			return {
				success: true,
				paragraph: {
					kind: "block",
					nodeType: "paragraph",
					nodeId: "(dry-run)"
				},
				insertionPoint: {
					kind: "text",
					blockId: "(dry-run)",
					range: {
						start: 0,
						end: 0
					}
				}
			};
		}
		const paragraphId = v4_default();
		let canonicalId = paragraphId;
		let trackedChangeRefs;
		if (executeDomainCommand(storyEditor, () => {
			const didApply = insertParagraphAt$1({
				pos: insertAt,
				text: input.text,
				sdBlockId: paragraphId,
				tracked: mode === "tracked"
			});
			if (didApply) {
				clearIndexCache(storyEditor);
				try {
					const paragraph = resolveCreatedBlock(storyEditor, "paragraph", paragraphId);
					canonicalId = paragraph.nodeId;
					if (mode === "tracked") trackedChangeRefs = collectTrackInsertRefsInRange(storyEditor, paragraph.pos, paragraph.end);
				} catch (e) {
					if (!(e instanceof DocumentApiAdapterError)) throw e;
				}
			}
			return didApply;
		}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return {
			success: false,
			failure: {
				code: "INVALID_TARGET",
				message: "Paragraph creation could not be applied at the requested location."
			}
		};
		if (runtime.commit) runtime.commit(editor);
		const nonBodyStory = runtime.kind !== "body" ? runtime.locator : void 0;
		const textLen = input.text?.length ?? 0;
		const ref$1 = textLen > 0 ? mintBlockRef(storyEditor, runtime.storyKey, canonicalId, textLen) : void 0;
		return buildParagraphCreateSuccess(canonicalId, trackedChangeRefs, nonBodyStory, ref$1);
	} finally {
		disposeEphemeralWriteRuntime(runtime);
	}
}
function createHeadingWrapper(editor, input, options) {
	const runtime = resolveWriteStoryRuntime(editor, input.in);
	const storyEditor = runtime.editor;
	try {
		const insertHeadingAt$1 = requireEditorCommand(storyEditor.commands?.insertHeadingAt, "create.heading");
		const mode = options?.changeMode ?? "direct";
		if (mode === "tracked") ensureTrackedCapability(storyEditor, { operation: "create.heading" });
		const insertAt = resolveCreateInsertPosition(storyEditor, input.at);
		if (options?.dryRun) {
			if (!storyEditor.can().insertHeadingAt?.({
				pos: insertAt,
				level: input.level,
				text: input.text,
				tracked: mode === "tracked"
			})) return {
				success: false,
				failure: {
					code: "INVALID_TARGET",
					message: "Heading creation could not be applied at the requested location."
				}
			};
			return {
				success: true,
				heading: {
					kind: "block",
					nodeType: "heading",
					nodeId: "(dry-run)"
				},
				insertionPoint: {
					kind: "text",
					blockId: "(dry-run)",
					range: {
						start: 0,
						end: 0
					}
				}
			};
		}
		const headingId = v4_default();
		let canonicalId = headingId;
		let trackedChangeRefs;
		if (executeDomainCommand(storyEditor, () => {
			const didApply = insertHeadingAt$1({
				pos: insertAt,
				level: input.level,
				text: input.text,
				sdBlockId: headingId,
				tracked: mode === "tracked"
			});
			if (didApply) {
				clearIndexCache(storyEditor);
				try {
					const heading = resolveCreatedBlock(storyEditor, "heading", headingId);
					canonicalId = heading.nodeId;
					if (mode === "tracked") trackedChangeRefs = collectTrackInsertRefsInRange(storyEditor, heading.pos, heading.end);
				} catch (e) {
					if (!(e instanceof DocumentApiAdapterError)) throw e;
				}
			}
			return didApply;
		}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return {
			success: false,
			failure: {
				code: "INVALID_TARGET",
				message: "Heading creation could not be applied at the requested location."
			}
		};
		if (runtime.commit) runtime.commit(editor);
		const nonBodyStory = runtime.kind !== "body" ? runtime.locator : void 0;
		const textLen = input.text?.length ?? 0;
		const ref$1 = textLen > 0 ? mintBlockRef(storyEditor, runtime.storyKey, canonicalId, textLen) : void 0;
		return buildHeadingCreateSuccess(canonicalId, trackedChangeRefs, nonBodyStory, ref$1);
	} finally {
		disposeEphemeralWriteRuntime(runtime);
	}
}
var SUPPORTED_DELETE_NODE_TYPES = new Set(DELETABLE_BLOCK_NODE_TYPES);
var REJECTED_DELETE_NODE_TYPES = new Set(["tableRow", "tableCell"]);
var TEXT_PREVIEW_MAX_LENGTH = 80;
var RANGE_DELETE_SAFE_NODE_TYPES = new Set(["passthroughBlock", "passthroughInline"]);
function extractTextPreview(node) {
	if (!node.isTextblock) return null;
	const text = node.textContent;
	if (text.length <= TEXT_PREVIEW_MAX_LENGTH) return text;
	return text.slice(0, TEXT_PREVIEW_MAX_LENGTH);
}
function extractBlockText$1(node) {
	if (!node.isTextblock) return null;
	return node.textContent;
}
var HEADING_PATTERN = /^Heading(\d)$/;
var OOXML_DEFAULT_FONT_SIZE_PT = 10;
function buildStyleContext(editor) {
	const styleProps = readTranslatedLinkedStyles(editor);
	if (!styleProps) return null;
	return {
		styles: styleProps.styles ?? {},
		docDefaultsFontSizeHp: typeof styleProps.docDefaults?.runProperties?.fontSize === "number" ? styleProps.docDefaults.runProperties.fontSize : void 0
	};
}
function resolveBlockFontSizePt(styleCtx, styleId$1) {
	if (!styleCtx) return OOXML_DEFAULT_FONT_SIZE_PT;
	let currentId = styleId$1 ?? "Normal";
	const visited = /* @__PURE__ */ new Set();
	while (currentId && !visited.has(currentId)) {
		visited.add(currentId);
		const style = styleCtx.styles[currentId];
		if (!style) break;
		const fs = style.runProperties?.fontSize;
		if (typeof fs === "number") return fs / 2;
		currentId = style.basedOn ?? "";
	}
	if (!visited.has("Normal")) {
		const fs = styleCtx.styles["Normal"]?.runProperties?.fontSize;
		if (typeof fs === "number") return fs / 2;
	}
	if (typeof styleCtx.docDefaultsFontSizeHp === "number") return styleCtx.docDefaultsFontSizeHp / 2;
	return OOXML_DEFAULT_FONT_SIZE_PT;
}
function extractBlockFormatting(node, styleCtx) {
	const pProps = node.attrs.paragraphProperties;
	const styleId$1 = pProps?.styleId ?? null;
	let fontFamily;
	let fontSize;
	let bold;
	let underline;
	let color;
	node.descendants((child) => {
		if (fontFamily !== void 0) return false;
		const marks = child.marks ?? [];
		if (!child.isText || marks.length === 0) return;
		for (const mark of marks) {
			const markName = mark.type.name;
			const attrs = mark.attrs;
			if (markName === "textStyle") {
				if (typeof attrs.fontFamily === "string" && attrs.fontFamily) fontFamily = attrs.fontFamily;
				if (attrs.fontSize != null) {
					const raw = typeof attrs.fontSize === "string" ? parseFloat(attrs.fontSize) : attrs.fontSize;
					if (typeof raw === "number" && Number.isFinite(raw)) fontSize = raw;
				}
				if (typeof attrs.color === "string" && attrs.color) color = attrs.color;
			}
			if (markName === "bold" && attrs.value === true) bold = true;
			if (markName === "underline") underline = true;
		}
		return false;
	});
	if (color === "auto") color = void 0;
	let headingLevel;
	if (typeof styleId$1 === "string") {
		const m$1 = HEADING_PATTERN.exec(styleId$1);
		if (m$1) headingLevel = parseInt(m$1[1], 10);
	}
	return {
		...styleId$1 ? { styleId: styleId$1 } : {},
		...fontFamily ? { fontFamily } : {},
		...fontSize !== void 0 ? { fontSize } : styleCtx ? { fontSize: resolveBlockFontSizePt(styleCtx, styleId$1) } : {},
		...bold ? { bold } : {},
		...underline ? { underline } : {},
		...color ? { color } : {},
		...pProps?.justification ? { alignment: pProps.justification } : {},
		...headingLevel ? { headingLevel } : {}
	};
}
function toBlockSummary(candidate, ordinal) {
	return {
		ordinal,
		nodeId: candidate.nodeId,
		nodeType: candidate.nodeType,
		textPreview: extractTextPreview(candidate.node)
	};
}
function resolveSdBlockId(candidate) {
	const sdBlockId = candidate.node.attrs?.sdBlockId;
	if (typeof sdBlockId === "string" && sdBlockId.length > 0) return sdBlockId;
	throw new DocumentApiAdapterError("INTERNAL_ERROR", "Resolved block candidate is missing sdBlockId attribute. This indicates a schema/extension invariant violation.", { attrs: candidate.node.attrs });
}
function validateDeleteTargetNodeType(nodeType) {
	if (REJECTED_DELETE_NODE_TYPES.has(nodeType)) throw new DocumentApiAdapterError("INVALID_TARGET", `blocks.delete does not support "${nodeType}" targets. Table row/column operations are out of scope.`, { nodeType });
	if (!SUPPORTED_DELETE_NODE_TYPES.has(nodeType)) throw new DocumentApiAdapterError("INVALID_TARGET", `blocks.delete does not support "${nodeType}" targets.`, { nodeType });
}
function validateCommandLayerUniqueness(editor, sdBlockId) {
	const getBlockNodeById = editor.helpers?.blockNode?.getBlockNodeById;
	if (typeof getBlockNodeById !== "function") throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "blocks.delete requires the blockNode helper to be registered.", { reason: "missing_helper" });
	const matches = getBlockNodeById(sdBlockId);
	if (!matches || Array.isArray(matches) && matches.length === 0) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Block with sdBlockId "${sdBlockId}" was not found at the command layer.`, { sdBlockId });
	if (Array.isArray(matches) && matches.length > 1) throw new DocumentApiAdapterError("AMBIGUOUS_TARGET", `Multiple blocks share sdBlockId "${sdBlockId}" at the command layer.`, {
		sdBlockId,
		count: matches.length
	});
}
function collectTopLevelBlocks(editor) {
	const doc$1 = editor.state.doc;
	const results = [];
	let offset$1 = 0;
	for (let i = 0; i < doc$1.childCount; i++) {
		const child = doc$1.child(i);
		const nodeType = mapBlockNodeType(child);
		const pos = offset$1;
		if (nodeType) {
			const nodeId = resolveBlockNodeId(child, pos, nodeType, [i]);
			if (nodeId) results.push({
				node: child,
				pos,
				end: pos + child.nodeSize,
				nodeType,
				nodeId
			});
		}
		offset$1 += child.nodeSize;
	}
	return results;
}
function blocksListWrapper(editor, input) {
	const topLevel = collectTopLevelBlocks(editor);
	const filtered = input?.nodeTypes ? topLevel.filter((b$1) => input.nodeTypes.includes(b$1.nodeType)) : topLevel;
	const total = filtered.length;
	const offset$1 = input?.offset ?? 0;
	const limit = input?.limit ?? total;
	const paged = filtered.slice(offset$1, offset$1 + limit);
	const rev = getRevision(editor);
	const styleCtx = buildStyleContext(editor);
	return {
		total,
		blocks: paged.map((candidate, i) => {
			const textLength = computeTextContentLength(candidate.node);
			const fullText = input?.includeText ? extractBlockText$1(candidate.node) : void 0;
			const ref$1 = textLength > 0 ? encodeV4Ref({
				v: 4,
				rev,
				storyKey: "body",
				scope: "block",
				matchId: candidate.nodeId,
				segments: [{
					blockId: candidate.nodeId,
					start: 0,
					end: textLength
				}],
				blockIndex: offset$1 + i
			}) : void 0;
			return {
				ordinal: offset$1 + i,
				nodeId: candidate.nodeId,
				nodeType: candidate.nodeType,
				textPreview: extractTextPreview(candidate.node),
				...fullText !== void 0 ? { text: fullText } : {},
				isEmpty: textLength === 0,
				...extractBlockFormatting(candidate.node, styleCtx),
				...ref$1 ? { ref: ref$1 } : {}
			};
		}),
		revision: rev
	};
}
function blocksDeleteWrapper(editor, input, options) {
	rejectTrackedMode("blocks.delete", options);
	const candidate = findBlockByIdStrict(getBlockIndex(editor), input.target);
	validateDeleteTargetNodeType(candidate.nodeType);
	const deletedBlock = toBlockSummary(candidate, collectTopLevelBlocks(editor).findIndex((b$1) => b$1.nodeId === candidate.nodeId && b$1.nodeType === candidate.nodeType));
	const sdBlockId = resolveSdBlockId(candidate);
	const deleteBlockNodeById = requireEditorCommand(editor.commands?.deleteBlockNodeById, "blocks.delete");
	validateCommandLayerUniqueness(editor, sdBlockId);
	if (options?.dryRun) return {
		success: true,
		deleted: input.target,
		deletedBlock
	};
	if (executeDomainCommand(editor, () => {
		const didApply = deleteBlockNodeById(sdBlockId);
		if (didApply) clearIndexCache(editor);
		return didApply;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") throw new DocumentApiAdapterError("INTERNAL_ERROR", "blocks.delete command returned false despite passing all pre-apply checks. This is an internal invariant violation.", {
		sdBlockId,
		target: input.target
	});
	return {
		success: true,
		deleted: input.target,
		deletedBlock
	};
}
function hasSectionBreak(candidate) {
	const pPr = candidate.node.attrs?.paragraphProperties;
	return pPr?.sectPr != null && typeof pPr.sectPr === "object";
}
function resolveTopLevelOrdinal(topLevel, candidate, label) {
	const idx = topLevel.findIndex((b$1) => b$1.nodeId === candidate.nodeId && b$1.nodeType === candidate.nodeType);
	if (idx !== -1) return idx;
	throw new DocumentApiAdapterError("INVALID_TARGET", `blocks.deleteRange ${label} resolved to a nested block (not a direct document child). Only top-level blocks are supported.`, {
		nodeId: candidate.nodeId,
		nodeType: candidate.nodeType
	});
}
function resolveRangeEndpoint(index, address, label) {
	const key = `${address.nodeType}:${address.nodeId}`;
	if (index.ambiguous.has(key)) throw new DocumentApiAdapterError("AMBIGUOUS_TARGET", `Multiple blocks share key "${key}".`, { target: address });
	const candidate = index.byId.get(key);
	if (candidate) return candidate;
	const mismatch = index.candidates.find((c) => c.nodeId === address.nodeId);
	if (mismatch) throw new DocumentApiAdapterError("INVALID_TARGET", `blocks.deleteRange ${label} expected ${address.nodeType}:${address.nodeId} but resolved to ${mismatch.nodeType}.`, {
		expected: address.nodeType,
		actual: mismatch.nodeType,
		nodeId: address.nodeId
	});
	throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Block "${key}" was not found.`, { target: address });
}
function rejectUnmappedNodesInRange(doc$1, rangeBlocks) {
	if (rangeBlocks.length === 0) return;
	const rangeFrom = rangeBlocks[0].pos;
	const rangeTo = rangeBlocks[rangeBlocks.length - 1].end;
	const recognizedPositions = new Set(rangeBlocks.map((b$1) => b$1.pos));
	let offset$1 = 0;
	for (let i = 0; i < doc$1.childCount; i++) {
		const child = doc$1.child(i);
		const childEnd = offset$1 + child.nodeSize;
		if (childEnd > rangeFrom && offset$1 < rangeTo && !recognizedPositions.has(offset$1)) {
			if (!RANGE_DELETE_SAFE_NODE_TYPES.has(child.type.name)) throw new DocumentApiAdapterError("INVALID_TARGET", `blocks.deleteRange cannot delete range: unrecognized node "${child.type.name}" at position ${offset$1} would be silently removed.`, {
				pmNodeType: child.type.name,
				pos: offset$1
			});
		}
		offset$1 = childEnd;
	}
}
function blocksDeleteRangeWrapper(editor, input, options) {
	rejectTrackedMode("blocks.deleteRange", options);
	const topLevel = collectTopLevelBlocks(editor);
	const index = getBlockIndex(editor);
	const startCandidate = resolveRangeEndpoint(index, input.start, "start");
	const endCandidate = resolveRangeEndpoint(index, input.end, "end");
	const startOrdinal = resolveTopLevelOrdinal(topLevel, startCandidate, "start");
	const endOrdinal = resolveTopLevelOrdinal(topLevel, endCandidate, "end");
	if (startOrdinal > endOrdinal) throw new DocumentApiAdapterError("INVALID_INPUT", `blocks.deleteRange start ordinal (${startOrdinal}) is after end ordinal (${endOrdinal}). The start must precede or equal the end.`, {
		startOrdinal,
		endOrdinal
	});
	const rangeBlocks = topLevel.slice(startOrdinal, endOrdinal + 1);
	rejectUnmappedNodesInRange(editor.state.doc, rangeBlocks);
	for (const block of rangeBlocks) if (hasSectionBreak(block)) throw new DocumentApiAdapterError("INVALID_TARGET", `blocks.deleteRange cannot delete a range that includes a section break (block "${block.nodeId}" at ordinal ${topLevel.indexOf(block)}).`, {
		nodeId: block.nodeId,
		nodeType: block.nodeType
	});
	const deletedBlocks = rangeBlocks.map((c, i) => toBlockSummary(c, startOrdinal + i));
	const revisionBefore = getRevision(editor);
	if (options?.dryRun) return {
		success: true,
		deletedCount: rangeBlocks.length,
		deletedBlocks,
		revision: {
			before: revisionBefore,
			after: revisionBefore
		},
		dryRun: true
	};
	const rangeFrom = rangeBlocks[0].pos;
	const rangeTo = rangeBlocks[rangeBlocks.length - 1].end;
	if (executeDomainCommand(editor, () => {
		const tr = editor.state.tr;
		tr.delete(rangeFrom, rangeTo);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") throw new DocumentApiAdapterError("INTERNAL_ERROR", "blocks.deleteRange command returned false despite passing all pre-apply checks.", {
		start: input.start,
		end: input.end
	});
	const revisionAfter = getRevision(editor);
	return {
		success: true,
		deletedCount: rangeBlocks.length,
		deletedBlocks,
		revision: {
			before: revisionBefore,
			after: revisionAfter
		},
		dryRun: false
	};
}
var INDENT_PER_LEVEL_TWIPS = 720;
var HANGING_INDENT_TWIPS = 360;
function findLevelElement(abstract, ilvl) {
	const ilvlStr = String(ilvl);
	return abstract.elements?.find((el) => el.name === "w:lvl" && el.attributes?.["w:ilvl"] === ilvlStr);
}
function readChildAttr(parent, elementName) {
	return parent.elements?.find((el) => el.name === elementName)?.attributes?.["w:val"];
}
function setChildAttr(parent, elementName, value) {
	if (!parent.elements) parent.elements = [];
	const existing = parent.elements.find((el) => el.name === elementName);
	if (existing) {
		if (existing.attributes?.["w:val"] === value) return false;
		if (!existing.attributes) existing.attributes = {};
		existing.attributes["w:val"] = value;
		return true;
	}
	parent.elements.push({
		type: "element",
		name: elementName,
		attributes: { "w:val": value }
	});
	return true;
}
function findOrCreateChild(parent, elementName) {
	if (!parent.elements) parent.elements = [];
	let child = parent.elements.find((el) => el.name === elementName);
	if (!child) {
		child = {
			type: "element",
			name: elementName,
			elements: []
		};
		parent.elements.push(child);
	}
	if (!child.elements) child.elements = [];
	return child;
}
function resolveAbstractLevel(editor, abstractNumId, ilvl) {
	const abstract = editor.converter.numbering?.abstracts?.[abstractNumId];
	if (!abstract) return null;
	const lvlEl = findLevelElement(abstract, ilvl);
	if (!lvlEl) return null;
	return {
		abstract,
		lvlEl
	};
}
function hasLevel(editor, abstractNumId, ilvl) {
	return resolveAbstractLevel(editor, abstractNumId, ilvl) != null;
}
function readLevelProperties(lvlEl, ilvl) {
	const props = { level: ilvl };
	const numFmt = readChildAttr(lvlEl, "w:numFmt");
	if (numFmt != null) props.numFmt = numFmt;
	const lvlText = readChildAttr(lvlEl, "w:lvlText");
	if (lvlText != null) props.lvlText = lvlText;
	const startVal = readChildAttr(lvlEl, "w:start");
	if (startVal != null) props.start = Number(startVal);
	const alignment$1 = readChildAttr(lvlEl, "w:lvlJc");
	if (alignment$1 != null) props.alignment = alignment$1;
	const suff = readChildAttr(lvlEl, "w:suff");
	if (suff != null) props.trailingCharacter = suff;
	const picBulletId = readChildAttr(lvlEl, "w:lvlPicBulletId");
	if (picBulletId != null) props.pictureBulletId = Number(picBulletId);
	const pPr = lvlEl.elements?.find((el) => el.name === "w:pPr");
	const ind = pPr?.elements?.find((el) => el.name === "w:ind");
	if (ind?.attributes) {
		const indents = {};
		if (ind.attributes["w:left"] != null) indents.left = Number(ind.attributes["w:left"]);
		if (ind.attributes["w:hanging"] != null) indents.hanging = Number(ind.attributes["w:hanging"]);
		if (ind.attributes["w:firstLine"] != null) indents.firstLine = Number(ind.attributes["w:firstLine"]);
		if (Object.keys(indents).length > 0) props.indents = indents;
	}
	const tabStopVal = readLevelTabStop(pPr);
	if (tabStopVal != null) props.tabStopAt = tabStopVal;
	const rFonts = (lvlEl.elements?.find((el) => el.name === "w:rPr"))?.elements?.find((el) => el.name === "w:rFonts");
	if (rFonts?.attributes?.["w:ascii"]) props.markerFont = rFonts.attributes["w:ascii"];
	return props;
}
function readLevelTabStop(pPr) {
	if (!pPr?.elements) return void 0;
	const tabs = pPr.elements.find((el) => el.name === "w:tabs");
	if (!tabs?.elements) return void 0;
	const tab = tabs.elements.find((el) => el.name === "w:tab");
	if (!tab?.attributes?.["w:pos"]) return void 0;
	return Number(tab.attributes["w:pos"]);
}
function mutateLevelTabStop(lvlEl, value) {
	const pPr = findOrCreateChild(lvlEl, "w:pPr");
	if (value === null) {
		const tabsIdx = pPr.elements.findIndex((el) => el.name === "w:tabs");
		if (tabsIdx === -1) return false;
		pPr.elements.splice(tabsIdx, 1);
		return true;
	}
	const tabs = findOrCreateChild(pPr, "w:tabs");
	const existing = tabs.elements.find((el) => el.name === "w:tab");
	const posStr = String(value);
	if (existing) {
		if (existing.attributes?.["w:pos"] === posStr && existing.attributes?.["w:val"] === "num") return false;
		existing.attributes = {
			...existing.attributes,
			"w:val": "num",
			"w:pos": posStr
		};
		return true;
	}
	tabs.elements.push({
		type: "element",
		name: "w:tab",
		attributes: {
			"w:val": "num",
			"w:pos": posStr
		}
	});
	return true;
}
function setLevelTabStop(editor, abstractNumId, ilvl, value) {
	const resolved = resolveAbstractLevel(editor, abstractNumId, ilvl);
	if (!resolved) return false;
	return mutateLevelTabStop(resolved.lvlEl, value);
}
var SYMBOL_FONT_NAMES = new Set([
	"wingdings",
	"wingdings 2",
	"wingdings 3",
	"symbol",
	"webdings",
	"zapfdingbats",
	"zapf dingbats"
]);
function isSymbolFont(fontName) {
	return typeof fontName === "string" && SYMBOL_FONT_NAMES.has(fontName.toLowerCase());
}
var RFONTS_FAMILY_ATTRS = [
	"w:ascii",
	"w:hAnsi",
	"w:eastAsia",
	"w:cs"
];
function rFontsHasSymbolFont(rFontsEl) {
	const attrs = rFontsEl.attributes;
	if (!attrs) return false;
	for (const attr of RFONTS_FAMILY_ATTRS) if (isSymbolFont(attrs[attr])) return true;
	return false;
}
function readRFontsFamily(rFontsEl) {
	const attrs = rFontsEl.attributes;
	if (!attrs) return void 0;
	for (const attr of RFONTS_FAMILY_ATTRS) {
		const val = attrs[attr];
		if (val) return val;
	}
}
function clearPictureBulletId(lvlEl) {
	if (!lvlEl.elements) return false;
	const idx = lvlEl.elements.findIndex((el) => el.name === "w:lvlPicBulletId");
	if (idx === -1) return false;
	lvlEl.elements.splice(idx, 1);
	return true;
}
function levelHasRFonts(lvlEl) {
	return !!(lvlEl.elements?.find((el) => el.name === "w:rPr"))?.elements?.find((el) => el.name === "w:rFonts");
}
function findDonorMarkerFont(abstract) {
	if (!abstract?.elements) return void 0;
	const lvls = abstract.elements.filter((el) => el.name === "w:lvl");
	lvls.sort((a, b$1) => Number(a.attributes?.["w:ilvl"] ?? 0) - Number(b$1.attributes?.["w:ilvl"] ?? 0));
	for (const lvl of lvls) {
		const rFonts = (lvl.elements?.find((el) => el.name === "w:rPr"))?.elements?.find((el) => el.name === "w:rFonts");
		if (!rFonts) continue;
		if (rFontsHasSymbolFont(rFonts)) continue;
		const family = readRFontsFamily(rFonts);
		if (family) return family;
	}
}
function normalizeLevelFontForNumFmt(lvlEl, newNumFmt) {
	if (newNumFmt === "bullet" || !lvlEl.elements) return false;
	const rPrIdx = lvlEl.elements.findIndex((el) => el.name === "w:rPr");
	if (rPrIdx === -1) return false;
	const rPr = lvlEl.elements[rPrIdx];
	if (!rPr.elements) return false;
	const rFontsIdx = rPr.elements.findIndex((el) => el.name === "w:rFonts");
	if (rFontsIdx === -1) return false;
	if (!rFontsHasSymbolFont(rPr.elements[rFontsIdx])) return false;
	rPr.elements.splice(rFontsIdx, 1);
	if (rPr.elements.length === 0) lvlEl.elements.splice(rPrIdx, 1);
	return true;
}
function mutateLevelNumberStyle(lvlEl, numFmt) {
	let changed = normalizeLevelFontForNumFmt(lvlEl, numFmt);
	changed = setChildAttr(lvlEl, "w:numFmt", numFmt) || changed;
	changed = clearPictureBulletId(lvlEl) || changed;
	return changed;
}
function setLevelNumberStyle(editor, abstractNumId, ilvl, numFmt) {
	const resolved = resolveAbstractLevel(editor, abstractNumId, ilvl);
	if (!resolved) return false;
	return mutateLevelNumberStyle(resolved.lvlEl, numFmt);
}
function setLevelText(editor, abstractNumId, ilvl, text) {
	const resolved = resolveAbstractLevel(editor, abstractNumId, ilvl);
	if (!resolved) return false;
	return setChildAttr(resolved.lvlEl, "w:lvlText", text);
}
function setLevelStart(editor, abstractNumId, ilvl, start$1) {
	const resolved = resolveAbstractLevel(editor, abstractNumId, ilvl);
	if (!resolved) return false;
	return setChildAttr(resolved.lvlEl, "w:start", String(start$1));
}
function applyLevelPropertiesToElement(lvlEl, entry) {
	let changed = false;
	if (entry.numFmt != null || entry.lvlText != null) {
		const fmtParams = {};
		if (entry.numFmt != null) fmtParams.numFmt = entry.numFmt;
		if (entry.lvlText != null) fmtParams.lvlText = entry.lvlText;
		if (entry.start != null) fmtParams.start = entry.start;
		if (fmtParams.numFmt != null && fmtParams.lvlText != null) changed = mutateLevelNumberingFormat(lvlEl, fmtParams) || changed;
		else {
			if (fmtParams.numFmt != null) {
				changed = normalizeLevelFontForNumFmt(lvlEl, fmtParams.numFmt) || changed;
				changed = setChildAttr(lvlEl, "w:numFmt", fmtParams.numFmt) || changed;
			}
			if (fmtParams.lvlText != null) changed = setChildAttr(lvlEl, "w:lvlText", fmtParams.lvlText) || changed;
			if (fmtParams.start != null) changed = setChildAttr(lvlEl, "w:start", String(fmtParams.start)) || changed;
		}
	} else if (entry.start != null) changed = setChildAttr(lvlEl, "w:start", String(entry.start)) || changed;
	if (entry.alignment != null) changed = mutateLevelAlignment(lvlEl, entry.alignment) || changed;
	if (entry.indents != null) changed = mutateLevelIndents(lvlEl, entry.indents) || changed;
	if (entry.trailingCharacter != null) changed = mutateLevelTrailingCharacter(lvlEl, entry.trailingCharacter) || changed;
	if (entry.markerFont != null) changed = mutateLevelMarkerFont(lvlEl, entry.markerFont) || changed;
	if (entry.pictureBulletId != null) changed = mutateLevelPictureBulletId(lvlEl, entry.pictureBulletId) || changed;
	if (entry.tabStopAt !== void 0) changed = mutateLevelTabStop(lvlEl, entry.tabStopAt) || changed;
	return changed;
}
function mutateLevelNumberingFormat(lvlEl, { numFmt, lvlText, start: start$1 }) {
	let changed = normalizeLevelFontForNumFmt(lvlEl, numFmt);
	changed = setChildAttr(lvlEl, "w:numFmt", numFmt) || changed;
	changed = setChildAttr(lvlEl, "w:lvlText", lvlText) || changed;
	if (start$1 != null) changed = setChildAttr(lvlEl, "w:start", String(start$1)) || changed;
	return changed;
}
function mutateLevelBulletMarker(lvlEl, markerText) {
	let changed = false;
	changed = setChildAttr(lvlEl, "w:numFmt", "bullet") || changed;
	changed = setChildAttr(lvlEl, "w:lvlText", markerText) || changed;
	return changed;
}
function mutateLevelPictureBulletId(lvlEl, pictureBulletId) {
	return setChildAttr(lvlEl, "w:lvlPicBulletId", String(pictureBulletId));
}
function mutateLevelAlignment(lvlEl, alignment$1) {
	return setChildAttr(lvlEl, "w:lvlJc", alignment$1);
}
function mutateLevelIndents(lvlEl, indents) {
	const ind = findOrCreateChild(findOrCreateChild(lvlEl, "w:pPr"), "w:ind");
	if (!ind.attributes) ind.attributes = {};
	let changed = false;
	if (indents.left != null) {
		const newVal = String(indents.left);
		if (ind.attributes["w:left"] !== newVal) {
			ind.attributes["w:left"] = newVal;
			changed = true;
		}
	}
	if (indents.hanging != null) {
		const newVal = String(indents.hanging);
		if (ind.attributes["w:hanging"] !== newVal) {
			ind.attributes["w:hanging"] = newVal;
			changed = true;
		}
		if (ind.attributes["w:firstLine"] != null) {
			delete ind.attributes["w:firstLine"];
			changed = true;
		}
	}
	if (indents.firstLine != null) {
		const newVal = String(indents.firstLine);
		if (ind.attributes["w:firstLine"] !== newVal) {
			ind.attributes["w:firstLine"] = newVal;
			changed = true;
		}
		if (ind.attributes["w:hanging"] != null) {
			delete ind.attributes["w:hanging"];
			changed = true;
		}
	}
	return changed;
}
function mutateLevelTrailingCharacter(lvlEl, trailingCharacter) {
	return setChildAttr(lvlEl, "w:suff", trailingCharacter);
}
function mutateLevelMarkerFont(lvlEl, fontFamily) {
	const rPr = findOrCreateChild(lvlEl, "w:rPr");
	const rFonts = rPr.elements.find((el) => el.name === "w:rFonts");
	if (rFonts) {
		const attrs = rFonts.attributes || {};
		if (attrs["w:ascii"] === fontFamily && attrs["w:hAnsi"] === fontFamily && attrs["w:eastAsia"] === fontFamily && attrs["w:cs"] === fontFamily) return false;
		rFonts.attributes = {
			...rFonts.attributes,
			"w:ascii": fontFamily,
			"w:hAnsi": fontFamily,
			"w:eastAsia": fontFamily,
			"w:cs": fontFamily
		};
		return true;
	}
	rPr.elements.push({
		type: "element",
		name: "w:rFonts",
		attributes: {
			"w:ascii": fontFamily,
			"w:hAnsi": fontFamily,
			"w:eastAsia": fontFamily,
			"w:cs": fontFamily
		}
	});
	return true;
}
function setLevelNumberingFormat(editor, abstractNumId, ilvl, params$1) {
	const resolved = resolveAbstractLevel(editor, abstractNumId, ilvl);
	if (!resolved) return false;
	return mutateLevelNumberingFormat(resolved.lvlEl, params$1);
}
function setLevelBulletMarker(editor, abstractNumId, ilvl, markerText) {
	const resolved = resolveAbstractLevel(editor, abstractNumId, ilvl);
	if (!resolved) return false;
	return mutateLevelBulletMarker(resolved.lvlEl, markerText);
}
function setLevelPictureBulletId(editor, abstractNumId, ilvl, pictureBulletId) {
	const resolved = resolveAbstractLevel(editor, abstractNumId, ilvl);
	if (!resolved) return false;
	return mutateLevelPictureBulletId(resolved.lvlEl, pictureBulletId);
}
function setLevelAlignment(editor, abstractNumId, ilvl, alignment$1) {
	const resolved = resolveAbstractLevel(editor, abstractNumId, ilvl);
	if (!resolved) return false;
	return mutateLevelAlignment(resolved.lvlEl, alignment$1);
}
function setLevelIndents(editor, abstractNumId, ilvl, indents) {
	const resolved = resolveAbstractLevel(editor, abstractNumId, ilvl);
	if (!resolved) return false;
	return mutateLevelIndents(resolved.lvlEl, indents);
}
function setLevelTrailingCharacter(editor, abstractNumId, ilvl, trailingCharacter) {
	const resolved = resolveAbstractLevel(editor, abstractNumId, ilvl);
	if (!resolved) return false;
	return mutateLevelTrailingCharacter(resolved.lvlEl, trailingCharacter);
}
function setLevelMarkerFont(editor, abstractNumId, ilvl, fontFamily) {
	const resolved = resolveAbstractLevel(editor, abstractNumId, ilvl);
	if (!resolved) return false;
	return mutateLevelMarkerFont(resolved.lvlEl, fontFamily);
}
function hasLevelOverride$1(editor, numId, ilvl) {
	const numDef = editor.converter.numbering?.definitions?.[numId];
	if (!numDef?.elements) return false;
	const ilvlStr = String(ilvl);
	return numDef.elements.some((el) => el.name === "w:lvlOverride" && el.attributes?.["w:ilvl"] === ilvlStr);
}
function clearLevelOverride(editor, numId, ilvl) {
	if (!hasLevelOverride$1(editor, numId, ilvl)) return false;
	removeLvlOverride(editor.converter.numbering, numId, ilvl);
	return true;
}
function materializeLevelFormattingOverride(editor, abstractNumId, numId, ilvl) {
	const resolved = resolveAbstractLevel(editor, abstractNumId, ilvl);
	const numDef = editor.converter.numbering?.definitions?.[numId];
	if (!resolved || !numDef?.elements) return false;
	const ilvlStr = String(ilvl);
	const overrideIndex = numDef.elements.findIndex((el) => el.name === "w:lvlOverride" && el.attributes?.["w:ilvl"] === ilvlStr);
	if (overrideIndex === -1) return false;
	const overrideEl = numDef.elements[overrideIndex];
	if (!overrideEl?.elements) return false;
	const lvlIndex = overrideEl.elements.findIndex((el) => el.name === "w:lvl");
	if (lvlIndex === -1) return false;
	const lvlEl = overrideEl.elements[lvlIndex];
	const props = readLevelProperties(lvlEl, ilvl);
	const abstractChanged = applyLevelPropertiesToElement(resolved.lvlEl, props);
	const lvlRestartElements = lvlEl.elements?.filter((el) => el.name === "w:lvlRestart").map((el) => deepCloneElement(el)) ?? [];
	overrideEl.elements.splice(lvlIndex, 1);
	if (lvlRestartElements.length > 0) overrideEl.elements.push({
		type: "element",
		name: "w:lvl",
		attributes: { "w:ilvl": ilvlStr },
		elements: lvlRestartElements
	});
	let overrideChanged = true;
	if (overrideEl.elements.length === 0) numDef.elements.splice(overrideIndex, 1);
	return abstractChanged || overrideChanged;
}
function captureTemplate(editor, abstractNumId, levels) {
	const abstract = editor.converter.numbering?.abstracts?.[abstractNumId];
	if (!abstract?.elements) return null;
	const lvlElements = abstract.elements.filter((el) => el.name === "w:lvl");
	const captured = [];
	for (const lvlEl of lvlElements) {
		const ilvl = Number(lvlEl.attributes?.["w:ilvl"]);
		if (levels && !levels.includes(ilvl)) continue;
		captured.push(readLevelProperties(lvlEl, ilvl));
	}
	captured.sort((a, b$1) => a.level - b$1.level);
	return {
		version: 1,
		levels: captured
	};
}
function applyTemplateToAbstract(editor, abstractNumId, template, levels) {
	const abstract = editor.converter.numbering?.abstracts?.[abstractNumId];
	if (!abstract?.elements) return {
		changed: false,
		error: "ABSTRACT_NOT_FOUND"
	};
	const templateByLevel = /* @__PURE__ */ new Map();
	for (const entry of template.levels) templateByLevel.set(entry.level, entry);
	const targetLevels = levels ?? template.levels.map((l) => l.level);
	for (const ilvl of targetLevels) if (!templateByLevel.has(ilvl)) return {
		changed: false,
		error: "LEVEL_NOT_IN_TEMPLATE"
	};
	for (const ilvl of targetLevels) if (!findLevelElement(abstract, ilvl)) return {
		changed: false,
		error: "LEVEL_NOT_IN_ABSTRACT"
	};
	let anyChanged = false;
	const strippedLevels = [];
	for (const ilvl of targetLevels) {
		const entry = templateByLevel.get(ilvl);
		const lvlEl = findLevelElement(abstract, ilvl);
		const hadRFontsBefore = levelHasRFonts(lvlEl);
		anyChanged = applyLevelPropertiesToElement(lvlEl, entry) || anyChanged;
		if (hadRFontsBefore && !levelHasRFonts(lvlEl)) strippedLevels.push({
			ilvl,
			lvlEl
		});
	}
	if (strippedLevels.length > 0) {
		const donorFont = findDonorMarkerFont(abstract);
		if (donorFont) for (const { lvlEl } of strippedLevels) anyChanged = mutateLevelMarkerFont(lvlEl, donorFont) || anyChanged;
	}
	return { changed: anyChanged };
}
var ORDERED_PRESET_CONFIG = {
	decimal: {
		numFmt: "decimal",
		lvlTextSuffix: "."
	},
	decimalParenthesis: {
		numFmt: "decimal",
		lvlTextSuffix: ")"
	},
	lowerLetter: {
		numFmt: "lowerLetter",
		lvlTextSuffix: "."
	},
	upperLetter: {
		numFmt: "upperLetter",
		lvlTextSuffix: "."
	},
	lowerRoman: {
		numFmt: "lowerRoman",
		lvlTextSuffix: "."
	},
	upperRoman: {
		numFmt: "upperRoman",
		lvlTextSuffix: "."
	}
};
var BULLET_PRESET_CONFIG = {
	disc: {
		markerText: "•",
		fontFamily: "Symbol"
	},
	circle: {
		markerText: "o",
		fontFamily: "Courier New"
	},
	square: {
		markerText: "",
		fontFamily: "Wingdings"
	},
	dash: {
		markerText: "–",
		fontFamily: "Calibri"
	}
};
function buildOrderedPresetTemplate(config) {
	const levels = [];
	for (let ilvl = 0; ilvl <= 8; ilvl++) levels.push({
		level: ilvl,
		numFmt: config.numFmt,
		lvlText: `%${ilvl + 1}${config.lvlTextSuffix}`,
		start: 1,
		alignment: "left",
		indents: {
			left: INDENT_PER_LEVEL_TWIPS * (ilvl + 1),
			hanging: HANGING_INDENT_TWIPS
		}
	});
	return {
		version: 1,
		levels
	};
}
function buildBulletPresetTemplate(config) {
	const levels = [];
	for (let ilvl = 0; ilvl <= 8; ilvl++) levels.push({
		level: ilvl,
		numFmt: "bullet",
		lvlText: config.markerText,
		start: 1,
		alignment: "left",
		markerFont: config.fontFamily,
		indents: {
			left: INDENT_PER_LEVEL_TWIPS * (ilvl + 1),
			hanging: HANGING_INDENT_TWIPS
		}
	});
	return {
		version: 1,
		levels
	};
}
var PRESET_TEMPLATES = {};
for (const [id, config] of Object.entries(ORDERED_PRESET_CONFIG)) PRESET_TEMPLATES[id] = buildOrderedPresetTemplate(config);
for (const [id, config] of Object.entries(BULLET_PRESET_CONFIG)) PRESET_TEMPLATES[id] = buildBulletPresetTemplate(config);
function getPresetTemplate(presetId) {
	return PRESET_TEMPLATES[presetId];
}
function mutateLevelLayout(lvlEl, layout) {
	let changed = false;
	if (layout.alignment != null) changed = mutateLevelAlignment(lvlEl, layout.alignment) || changed;
	if (layout.followCharacter != null) changed = mutateLevelTrailingCharacter(lvlEl, layout.followCharacter) || changed;
	if (layout.tabStopAt !== void 0) changed = mutateLevelTabStop(lvlEl, layout.tabStopAt) || changed;
	const hasAlignedAt = layout.alignedAt != null;
	const hasTextIndentAt = layout.textIndentAt != null;
	if (hasAlignedAt || hasTextIndentAt) {
		const ind = (lvlEl.elements?.find((el) => el.name === "w:pPr"))?.elements?.find((el) => el.name === "w:ind");
		const existingLeft = ind?.attributes?.["w:left"] != null ? Number(ind.attributes["w:left"]) : void 0;
		const existingHanging = ind?.attributes?.["w:hanging"] != null ? Number(ind.attributes["w:hanging"]) : void 0;
		const existingFirstLine = ind?.attributes?.["w:firstLine"] != null ? Number(ind.attributes["w:firstLine"]) : void 0;
		let existingAlignedAt;
		if (existingLeft != null) if (existingHanging != null) existingAlignedAt = existingLeft - existingHanging;
		else if (existingFirstLine != null) existingAlignedAt = existingLeft + existingFirstLine;
		else existingAlignedAt = existingLeft;
		let newLeft, newHanging;
		if (hasAlignedAt && hasTextIndentAt) {
			newLeft = layout.textIndentAt;
			newHanging = layout.textIndentAt - layout.alignedAt;
		} else if (hasTextIndentAt) {
			newLeft = layout.textIndentAt;
			newHanging = existingAlignedAt != null ? layout.textIndentAt - existingAlignedAt : 0;
		} else if (hasAlignedAt) {
			if (existingLeft == null) return {
				changed,
				error: "INVALID_INPUT"
			};
			newLeft = existingLeft;
			newHanging = existingLeft - layout.alignedAt;
		}
		if (newLeft != null) changed = mutateLevelIndents(lvlEl, {
			left: newLeft,
			hanging: newHanging ?? 0
		}) || changed;
	}
	return { changed };
}
function setLevelLayout(editor, abstractNumId, ilvl, layout) {
	const resolved = resolveAbstractLevel(editor, abstractNumId, ilvl);
	if (!resolved) return { changed: false };
	return mutateLevelLayout(resolved.lvlEl, layout);
}
function captureEffectiveStyle(editor, abstractNumId, numId, levels) {
	const abstract = editor.converter.numbering?.abstracts?.[abstractNumId];
	if (!abstract?.elements) return null;
	const numDef = editor.converter.numbering?.definitions?.[numId];
	const overridesByLevel = buildOverrideMap(numDef);
	const lvlElements = abstract.elements.filter((el) => el.name === "w:lvl");
	const captured = [];
	for (const lvlEl of lvlElements) {
		const ilvl = Number(lvlEl.attributes?.["w:ilvl"]);
		if (levels && !levels.includes(ilvl)) continue;
		const baseProps = readLevelProperties(lvlEl, ilvl);
		const overrideLvl = overridesByLevel.get(ilvl);
		if (overrideLvl) mergeOverrideProps(baseProps, readLevelProperties(overrideLvl, ilvl));
		captured.push(baseProps);
	}
	captured.sort((a, b$1) => a.level - b$1.level);
	return {
		version: 1,
		levels: captured
	};
}
function buildOverrideMap(numDef) {
	const map$1 = /* @__PURE__ */ new Map();
	if (!numDef?.elements) return map$1;
	for (const el of numDef.elements) {
		if (el.name !== "w:lvlOverride") continue;
		const ilvl = Number(el.attributes?.["w:ilvl"]);
		const lvlChild = el.elements?.find((c) => c.name === "w:lvl");
		if (lvlChild) map$1.set(ilvl, lvlChild);
	}
	return map$1;
}
function mergeOverrideProps(base, override) {
	if (override.numFmt != null) base.numFmt = override.numFmt;
	if (override.lvlText != null) base.lvlText = override.lvlText;
	if (override.start != null) base.start = override.start;
	if (override.alignment != null) base.alignment = override.alignment;
	if (override.indents != null) base.indents = {
		...base.indents,
		...override.indents
	};
	if (override.trailingCharacter != null) base.trailingCharacter = override.trailingCharacter;
	if (override.markerFont != null) base.markerFont = override.markerFont;
	if (override.pictureBulletId != null) base.pictureBulletId = override.pictureBulletId;
	if (override.tabStopAt != null) base.tabStopAt = override.tabStopAt;
}
function isAbstractShared(editor, abstractNumId, numId) {
	const definitions = editor.converter.numbering?.definitions;
	if (!definitions) return false;
	for (const [defNumId, numDef] of Object.entries(definitions)) {
		if (Number(defNumId) === numId) continue;
		if (!numDef?.elements) continue;
		const absEl = numDef.elements.find((el) => el.name === "w:abstractNumId");
		if (absEl && Number(absEl.attributes?.["w:val"]) === abstractNumId) return true;
	}
	return false;
}
function deepCloneElement(element) {
	const clone$1 = { ...element };
	if (element.attributes) clone$1.attributes = { ...element.attributes };
	if (element.elements) clone$1.elements = element.elements.map((child) => deepCloneElement(child));
	return clone$1;
}
function cloneAbstractDefinition(editor, originalAbstractNumId) {
	const numbering = editor.converter.numbering;
	const existingAbstractIds = Object.keys(numbering.abstracts).map(Number);
	const newAbstractNumId = existingAbstractIds.length > 0 ? Math.max(...existingAbstractIds) + 1 : 0;
	const original = numbering.abstracts[originalAbstractNumId];
	if (!original) throw new Error(`cloneAbstractDefinition: abstract ${originalAbstractNumId} not found.`);
	const cloned = deepCloneElement(original);
	cloned.attributes = {
		...cloned.attributes,
		"w:abstractNumId": String(newAbstractNumId)
	};
	numbering.abstracts[newAbstractNumId] = cloned;
	return { newAbstractNumId };
}
function cloneAbstractIntoNum(editor, originalAbstractNumId, numId) {
	const numbering = editor.converter.numbering;
	const { newAbstractNumId } = cloneAbstractDefinition(editor, originalAbstractNumId);
	const numDef = numbering.definitions[numId];
	if (!numDef) throw new Error(`cloneAbstractIntoNum: num ${numId} not found.`);
	if (!numDef.elements) numDef.elements = [];
	const abstractNumIdEl = numDef.elements.find((el) => el.name === "w:abstractNumId");
	if (abstractNumIdEl) abstractNumIdEl.attributes = {
		...abstractNumIdEl.attributes || {},
		"w:val": String(newAbstractNumId)
	};
	else numDef.elements.unshift({
		type: "element",
		name: "w:abstractNumId",
		attributes: { "w:val": String(newAbstractNumId) }
	});
	return { newAbstractNumId };
}
function copySequenceStateOverrides(editor, fromNumId, toNumId, levels) {
	if (fromNumId === toNumId) return false;
	const sourceNumDef = editor.converter.numbering?.definitions?.[fromNumId];
	const targetNumDef = editor.converter.numbering?.definitions?.[toNumId];
	if (!sourceNumDef?.elements || !targetNumDef) return false;
	if (!targetNumDef.elements) targetNumDef.elements = [];
	const levelSet = levels ? new Set(levels.map((level) => String(level))) : null;
	let changed = false;
	for (const sourceEl of sourceNumDef.elements) {
		if (sourceEl.name !== "w:lvlOverride") continue;
		const ilvl = sourceEl.attributes?.["w:ilvl"];
		if (ilvl == null) continue;
		if (levelSet && !levelSet.has(ilvl)) continue;
		const nextElements = [];
		for (const child of sourceEl.elements ?? []) {
			if (child.name === "w:startOverride") {
				nextElements.push(deepCloneElement(child));
				continue;
			}
			if (child.name === "w:lvl") {
				const lvlRestartElements = child.elements?.filter((lvlChild) => lvlChild.name === "w:lvlRestart").map((lvlChild) => deepCloneElement(lvlChild)) ?? [];
				if (lvlRestartElements.length > 0) nextElements.push({
					type: "element",
					name: "w:lvl",
					attributes: {
						...child.attributes || {},
						"w:ilvl": child.attributes?.["w:ilvl"] ?? ilvl
					},
					elements: lvlRestartElements
				});
			}
		}
		if (nextElements.length === 0) continue;
		const targetIndex = targetNumDef.elements.findIndex((el) => el.name === "w:lvlOverride" && el.attributes?.["w:ilvl"] === ilvl);
		const nextOverride = {
			type: "element",
			name: "w:lvlOverride",
			attributes: {
				...sourceEl.attributes || {},
				"w:ilvl": ilvl
			},
			elements: nextElements
		};
		if (targetIndex === -1) targetNumDef.elements.push(nextOverride);
		else targetNumDef.elements[targetIndex] = nextOverride;
		changed = true;
	}
	return changed;
}
function cloneAbstractAndNum(editor, originalAbstractNumId, originalNumId) {
	const numbering = editor.converter.numbering;
	const { newAbstractNumId } = cloneAbstractDefinition(editor, originalAbstractNumId);
	const existingNumIds = Object.keys(numbering.definitions).map(Number);
	const newNumId = existingNumIds.length > 0 ? Math.max(...existingNumIds) + 1 : 1;
	const originalNumDef = numbering.definitions[originalNumId];
	const newElements = [{
		type: "element",
		name: "w:abstractNumId",
		attributes: { "w:val": String(newAbstractNumId) }
	}];
	if (originalNumDef?.elements) {
		for (const el of originalNumDef.elements) if (el.name === "w:lvlOverride") newElements.push(deepCloneElement(el));
	}
	numbering.definitions[newNumId] = {
		type: "element",
		name: "w:num",
		attributes: { "w:numId": String(newNumId) },
		elements: newElements
	};
	return {
		newAbstractNumId,
		newNumId
	};
}
const LevelFormattingHelpers = {
	readLevelProperties,
	findLevelElement,
	hasLevel,
	setLevelNumberingFormat,
	setLevelBulletMarker,
	setLevelPictureBulletId,
	setLevelAlignment,
	setLevelIndents,
	setLevelTrailingCharacter,
	setLevelMarkerFont,
	setLevelTabStop,
	setLevelNumberStyle,
	setLevelText,
	setLevelStart,
	setLevelLayout,
	hasLevelOverride: hasLevelOverride$1,
	clearLevelOverride,
	materializeLevelFormattingOverride,
	captureTemplate,
	applyTemplateToAbstract,
	captureEffectiveStyle,
	isAbstractShared,
	cloneAbstractIntoNum,
	cloneAbstractAndNum,
	copySequenceStateOverrides,
	getPresetTemplate,
	PRESET_TEMPLATES
};
function toListsFailure$1(code, message, details) {
	return {
		success: false,
		failure: {
			code,
			message,
			details
		}
	};
}
function dispatchEditorTransaction$1(editor, tr) {
	if (typeof editor.dispatch === "function") {
		editor.dispatch(tr);
		return;
	}
	if (typeof editor.view?.dispatch === "function") {
		editor.view.dispatch(tr);
		return;
	}
	throw new DocumentApiAdapterError("INTERNAL_ERROR", "Cannot apply list mutation because no transaction dispatcher is available.", { reason: "missing_dispatch" });
}
function getConverterNumbering$1(editor) {
	return editor.converter.numbering;
}
function executeDomainCommandWithRollback(editor, handler, options) {
	let receipt;
	compoundMutation({
		editor,
		source: "lists",
		affectedParts: ["word/numbering.xml"],
		execute() {
			receipt = executeDomainCommand(editor, handler, options);
			return receipt.steps[0]?.effect === "changed";
		}
	});
	return receipt;
}
function resolveInsertedListItem(editor, sdBlockId) {
	const index = getBlockIndex(editor);
	const byNodeId = index.candidates.find((candidate) => candidate.nodeType === "listItem" && candidate.nodeId === sdBlockId);
	if (byNodeId) return resolveListItem(editor, {
		kind: "block",
		nodeType: "listItem",
		nodeId: byNodeId.nodeId
	});
	const bySdBlockId = index.candidates.find((candidate) => {
		if (candidate.nodeType !== "listItem") return false;
		const attrs = candidate.node.attrs;
		return typeof attrs?.sdBlockId === "string" && attrs.sdBlockId === sdBlockId;
	});
	if (bySdBlockId) return resolveListItem(editor, {
		kind: "block",
		nodeType: "listItem",
		nodeId: bySdBlockId.nodeId
	});
	throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Inserted list item with sdBlockId "${sdBlockId}" could not be resolved after insertion.`);
}
function generateRuntimeParaId() {
	return v4_default().replace(/-/g, "").slice(0, 8).toUpperCase();
}
function withListTarget(editor, input) {
	return resolveListItem(editor, input.target);
}
function hasLevelOverride(editor, numId, level) {
	const definition = editor.converter?.numbering?.definitions?.[numId];
	const ilvl = String(level);
	return definition?.elements?.some((element) => element.name === "w:lvlOverride" && element.attributes?.["w:ilvl"] === ilvl) ?? false;
}
function executeSetLevel(editor, target, newLevel, options) {
	if (target.numId == null) return toListsFailure$1("INVALID_TARGET", "Target must have numbering metadata.", { target: target.address });
	if (newLevel < 0 || newLevel > 8) return toListsFailure$1("LEVEL_OUT_OF_RANGE", "Level must be between 0 and 8.", { level: newLevel });
	if (target.level === newLevel) return toListsFailure$1("NO_OP", "Item is already at the requested level.", {
		target: target.address,
		level: newLevel
	});
	if (!ListHelpers.hasListDefinition(editor, target.numId, newLevel)) return toListsFailure$1("LEVEL_OUT_OF_RANGE", "Target level is not defined in the active numbering definition.", {
		target: target.address,
		level: newLevel
	});
	if (options?.dryRun) return {
		success: true,
		item: target.address
	};
	if (executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		updateNumberingProperties({
			numId: target.numId,
			ilvl: newLevel
		}, target.candidate.node, target.candidate.pos, editor, tr);
		dispatchEditorTransaction$1(editor, tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return toListsFailure$1("INVALID_TARGET", "Level change could not be applied.", {
		target: target.address,
		level: newLevel
	});
	return {
		success: true,
		item: target.address
	};
}
function isBlockRange(target) {
	return typeof target === "object" && target !== null && "from" in target;
}
function listsListWrapper(editor, query) {
	return listListItems(editor, query);
}
function listsGetWrapper(editor, input) {
	const item = resolveListItem(editor, input.address);
	return listItemProjectionToInfo(item, computeSequenceId(editor, item));
}
function listsCanJoinWrapper(editor, input) {
	return evaluateCanJoin(editor, resolveListItem(editor, input.target), input.direction);
}
function listsCanContinuePreviousWrapper(editor, input) {
	return evaluateCanContinuePrevious(editor, resolveListItem(editor, input.target));
}
function listsInsertWrapper(editor, input, options) {
	const target = withListTarget(editor, input);
	const mode = (options?.changeMode ?? "direct") === "tracked" ? "tracked" : "direct";
	if (mode === "tracked") ensureTrackedCapability(editor, { operation: "lists.insert" });
	const insertListItemAt$1 = requireEditorCommand(editor.commands?.insertListItemAt, "lists.insert (insertListItemAt)");
	if (options?.dryRun) return {
		success: true,
		item: {
			kind: "block",
			nodeType: "listItem",
			nodeId: "(dry-run)"
		},
		insertionPoint: {
			kind: "text",
			blockId: "(dry-run)",
			range: {
				start: 0,
				end: 0
			}
		}
	};
	const createdId = v4_default();
	const createdParaId = generateRuntimeParaId();
	let created = null;
	if (executeDomainCommand(editor, () => {
		const didApply = insertListItemAt$1({
			pos: target.candidate.pos,
			position: input.position,
			text: input.text ?? "",
			sdBlockId: createdId,
			paraId: createdParaId,
			tracked: mode === "tracked"
		});
		if (didApply) {
			clearIndexCache(editor);
			try {
				created = resolveInsertedListItem(editor, createdId);
			} catch {}
		}
		return didApply;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return toListsFailure$1("INVALID_TARGET", "List item insertion could not be applied at the requested target.", {
		target: input.target,
		position: input.position
	});
	const resolved = created;
	if (!resolved) return {
		success: true,
		item: {
			kind: "block",
			nodeType: "listItem",
			nodeId: createdParaId
		},
		insertionPoint: {
			kind: "text",
			blockId: createdParaId,
			range: {
				start: 0,
				end: 0
			}
		}
	};
	return {
		success: true,
		item: resolved.address,
		insertionPoint: {
			kind: "text",
			blockId: resolved.address.nodeId,
			range: {
				start: 0,
				end: 0
			}
		},
		trackedChangeRefs: mode === "tracked" ? collectTrackInsertRefsInRange(editor, resolved.candidate.pos, resolved.candidate.end) : void 0
	};
}
function listsIndentWrapper(editor, input, options) {
	rejectTrackedMode("lists.indent", options);
	const target = withListTarget(editor, input);
	return executeSetLevel(editor, target, (target.level ?? 0) + 1, options);
}
function listsOutdentWrapper(editor, input, options) {
	rejectTrackedMode("lists.outdent", options);
	const target = withListTarget(editor, input);
	const currentLevel = target.level ?? 0;
	if (currentLevel <= 0) return toListsFailure$1("NO_OP", "List item is already at level 0.", { target: input.target });
	return executeSetLevel(editor, target, currentLevel - 1, options);
}
var PRESET_KIND_MAP = {
	decimal: "ordered",
	decimalParenthesis: "ordered",
	lowerLetter: "ordered",
	upperLetter: "ordered",
	lowerRoman: "ordered",
	upperRoman: "ordered",
	disc: "bullet",
	circle: "bullet",
	square: "bullet",
	dash: "bullet"
};
function resolveCreateKind(input) {
	const raw = input;
	if (raw.style != null && raw.preset != null) return { failure: toListsFailure$1("INVALID_INPUT", "Cannot provide both style and preset.", {}) };
	if (raw.preset != null) {
		const presetKind = PRESET_KIND_MAP[raw.preset];
		if (!presetKind) return { failure: toListsFailure$1("INVALID_INPUT", `Unknown preset: ${raw.preset}.`, { preset: raw.preset }) };
		if (raw.kind != null && raw.kind !== presetKind) return { failure: toListsFailure$1("INVALID_INPUT", `Preset kind (${presetKind}) conflicts with provided kind (${raw.kind}).`, {
			preset: raw.preset,
			kind: raw.kind
		}) };
		return { kind: presetKind };
	}
	if (raw.style != null) {
		if (raw.kind == null) return { failure: toListsFailure$1("INVALID_INPUT", "kind is required when style is provided.", {}) };
		return { kind: raw.kind };
	}
	if (raw.kind == null) return { failure: toListsFailure$1("INVALID_INPUT", "kind is required when neither preset nor style is provided.", {}) };
	return { kind: raw.kind };
}
function isListKind(value) {
	return value === "ordered" || value === "bullet";
}
function listsCreateWrapper(editor, input, options) {
	rejectTrackedMode("lists.create", options);
	const raw = input;
	if (input.mode === "empty" && raw.at == null) return toListsFailure$1("INVALID_TARGET", "Mode \"empty\" requires an \"at\" field.", { mode: "empty" });
	if (input.mode === "fromParagraphs" && raw.target == null) return toListsFailure$1("INVALID_TARGET", "Mode \"fromParagraphs\" requires a \"target\" field.", { mode: "fromParagraphs" });
	const level = input.level ?? 0;
	if (level < 0 || level > 8) return toListsFailure$1("LEVEL_OUT_OF_RANGE", "Level must be between 0 and 8.", { level });
	let styleTemplate;
	if (raw.style != null) {
		styleTemplate = raw.style;
		if (styleTemplate.version !== 1) return toListsFailure$1("INVALID_INPUT", "Unsupported style version.", { version: styleTemplate.version });
	} else if (raw.preset != null) {
		styleTemplate = LevelFormattingHelpers.getPresetTemplate(raw.preset);
		if (!styleTemplate) return toListsFailure$1("INVALID_INPUT", `Unknown preset: ${raw.preset}.`, { preset: raw.preset });
	}
	let blocks;
	if (input.mode === "empty") blocks = [resolveBlock(editor, input.at.nodeId)];
	else blocks = isBlockRange(input.target) ? resolveBlocksInRange(editor, input.target.from.nodeId, input.target.to.nodeId) : [resolveBlock(editor, input.target.nodeId)];
	if (blocks.length === 0) return toListsFailure$1("INVALID_TARGET", "No paragraphs found in the specified range.", {});
	const alreadyListItem = blocks.find((t) => t.nodeType === "listItem");
	if (alreadyListItem) return toListsFailure$1("INVALID_TARGET", "One or more target paragraphs are already list items.", { nodeId: alreadyListItem.nodeId });
	if (options?.dryRun) return {
		success: true,
		listId: "(dry-run)",
		item: {
			kind: "block",
			nodeType: "listItem",
			nodeId: blocks[0].nodeId
		}
	};
	const sequenceInput = raw.sequence ?? { mode: "new" };
	const requestedKind = raw.kind;
	if (requestedKind != null && !isListKind(requestedKind)) return toListsFailure$1("INVALID_INPUT", `Unknown list kind: ${String(requestedKind)}.`, { kind: requestedKind });
	let kind;
	let listType;
	if (sequenceInput.mode !== "continuePrevious") {
		const kindResult = resolveCreateKind(input);
		if ("failure" in kindResult) return kindResult.failure;
		kind = kindResult.kind;
		listType = kind === "ordered" ? "orderedList" : "bulletList";
	} else kind = requestedKind;
	let continuePreviousNumId;
	if (sequenceInput.mode === "continuePrevious") {
		if (styleTemplate) return toListsFailure$1("INVALID_INPUT", "preset/style cannot be combined with sequence.mode \"continuePrevious\". The new items inherit formatting from the previous sequence.", {});
		const allItems = getAllListItemProjections(editor);
		const firstBlockPos = blocks[0].pos;
		for (let i = allItems.length - 1; i >= 0; i--) {
			const item = allItems[i];
			if (item.candidate.pos >= firstBlockPos) continue;
			if (item.numId == null) continue;
			if (kind != null && item.kind !== kind) continue;
			continuePreviousNumId = item.numId;
			break;
		}
		if (continuePreviousNumId == null) return toListsFailure$1("NO_COMPATIBLE_PREVIOUS", "No compatible previous list sequence found.", {});
	}
	let numId;
	if (executeDomainCommandWithRollback(editor, () => {
		if (sequenceInput.mode === "continuePrevious") {
			numId = continuePreviousNumId;
			const { tr } = editor.state;
			for (const block of blocks) updateNumberingProperties({
				numId,
				ilvl: level
			}, block.node, block.pos, editor, tr);
			dispatchEditorTransaction$1(editor, tr);
			clearIndexCache(editor);
		} else {
			numId = ListHelpers.getNewListId(editor);
			ListHelpers.generateNewListDefinition({
				numId,
				listType,
				editor
			});
			if (styleTemplate) {
				const abstractNumId = getAbstractNumId(editor, numId);
				if (abstractNumId != null) {
					LevelFormattingHelpers.applyTemplateToAbstract(editor, abstractNumId, styleTemplate, void 0);
					const numberingPart = getPart(editor, "word/numbering.xml");
					if (numberingPart) syncNumberingToXmlTree(numberingPart, getConverterNumbering$1(editor));
				}
			}
			const { tr } = editor.state;
			for (const block of blocks) updateNumberingProperties({
				numId,
				ilvl: level
			}, block.node, block.pos, editor, tr);
			dispatchEditorTransaction$1(editor, tr);
			clearIndexCache(editor);
			if (sequenceInput.startAt != null) ListHelpers.setLvlOverride(editor, numId, level, { startOverride: sequenceInput.startAt });
		}
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return toListsFailure$1("INVALID_TARGET", "List creation could not be applied.", { mode: input.mode });
	return {
		success: true,
		listId: `${numId}:${blocks[0].nodeId}`,
		item: {
			kind: "block",
			nodeType: "listItem",
			nodeId: blocks[0].nodeId
		}
	};
}
function listsAttachWrapper(editor, input, options) {
	rejectTrackedMode("lists.attach", options);
	const attachTo = resolveListItem(editor, input.attachTo);
	if (attachTo.numId == null) return toListsFailure$1("INVALID_TARGET", "attachTo target must be a list item with numbering metadata.", { attachTo: input.attachTo });
	const numId = attachTo.numId;
	const level = input.level ?? attachTo.level ?? 0;
	const targets = isBlockRange(input.target) ? resolveBlocksInRange(editor, input.target.from.nodeId, input.target.to.nodeId) : [resolveBlock(editor, input.target.nodeId)];
	if (targets.length === 0) return toListsFailure$1("INVALID_TARGET", "No paragraphs found in the specified target.", { target: input.target });
	const alreadyListItem = targets.find((t) => t.nodeType === "listItem");
	if (alreadyListItem) return toListsFailure$1("INVALID_TARGET", "Target paragraphs are already list items.", { nodeId: alreadyListItem.nodeId });
	if (options?.dryRun) return {
		success: true,
		item: {
			kind: "block",
			nodeType: "listItem",
			nodeId: targets[0].nodeId
		}
	};
	if (executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		for (const block of targets) updateNumberingProperties({
			numId,
			ilvl: level
		}, block.node, block.pos, editor, tr);
		dispatchEditorTransaction$1(editor, tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return toListsFailure$1("INVALID_TARGET", "List attachment could not be applied.", { target: input.target });
	return {
		success: true,
		item: {
			kind: "block",
			nodeType: "listItem",
			nodeId: targets[0].nodeId
		}
	};
}
function listsDetachWrapper(editor, input, options) {
	rejectTrackedMode("lists.detach", options);
	const target = resolveListItem(editor, input.target);
	if (options?.dryRun) return {
		success: true,
		paragraph: {
			kind: "block",
			nodeType: "paragraph",
			nodeId: target.address.nodeId
		}
	};
	if (executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		updateNumberingProperties(null, target.candidate.node, target.candidate.pos, editor, tr);
		dispatchEditorTransaction$1(editor, tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return toListsFailure$1("INVALID_TARGET", "List detach could not be applied.", { target: input.target });
	return {
		success: true,
		paragraph: {
			kind: "block",
			nodeType: "paragraph",
			nodeId: target.address.nodeId
		}
	};
}
function listsDeleteWrapper(editor, input, options) {
	rejectTrackedMode("lists.delete", options);
	const sequence = getContiguousSequence(editor, resolveListItem(editor, input.target));
	if (sequence.length === 0) return toListsFailure$1("INVALID_TARGET", "List sequence could not be resolved.", { target: input.target });
	if (options?.dryRun) return {
		success: true,
		deletedCount: sequence.length
	};
	if (executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		const sortedDesc = [...sequence].sort((a, b$1) => b$1.candidate.pos - a.candidate.pos);
		for (const item of sortedDesc) {
			const start$1 = item.candidate.pos;
			const end$1 = start$1 + item.candidate.node.nodeSize;
			const mappedStart = tr.mapping.map(start$1, -1);
			const mappedEnd = tr.mapping.map(end$1, 1);
			if (mappedEnd > mappedStart) tr.delete(mappedStart, mappedEnd);
		}
		dispatchEditorTransaction$1(editor, tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return toListsFailure$1("INVALID_TARGET", "List deletion could not be applied.", { target: input.target });
	return {
		success: true,
		deletedCount: sequence.length
	};
}
function listsJoinWrapper(editor, input, options) {
	rejectTrackedMode("lists.join", options);
	const target = resolveListItem(editor, input.target);
	if (target.numId == null) return toListsFailure$1("INVALID_TARGET", "Target must have numbering metadata.", { target: input.target });
	const canJoinResult = evaluateCanJoin(editor, target, input.direction);
	if (!canJoinResult.canJoin) return toListsFailure$1(canJoinResult.reason, `Cannot join: ${canJoinResult.reason}`, {
		target: input.target,
		direction: input.direction
	});
	const adjacent = findAdjacentSequence(editor, target, input.direction);
	let absorbingNumId;
	let absorbedItems;
	let anchorNodeId;
	if (input.direction === "withPrevious") {
		absorbingNumId = adjacent.numId;
		absorbedItems = getContiguousSequence(editor, target);
		anchorNodeId = adjacent.sequence[0]?.address.nodeId ?? target.address.nodeId;
	} else {
		absorbingNumId = target.numId;
		absorbedItems = adjacent.sequence;
		anchorNodeId = getContiguousSequence(editor, target)[0]?.address.nodeId ?? target.address.nodeId;
	}
	const mergedListId = `${absorbingNumId}:${anchorNodeId}`;
	if (options?.dryRun) return {
		success: true,
		listId: mergedListId
	};
	if (executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		for (const item of absorbedItems) {
			const currentLevel = item.level ?? 0;
			updateNumberingProperties({
				numId: absorbingNumId,
				ilvl: currentLevel
			}, item.candidate.node, item.candidate.pos, editor, tr);
		}
		dispatchEditorTransaction$1(editor, tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return toListsFailure$1("INVALID_TARGET", "List join could not be applied.", {
		target: input.target,
		direction: input.direction
	});
	return {
		success: true,
		listId: mergedListId
	};
}
function listsSeparateWrapper(editor, input, options) {
	rejectTrackedMode("lists.separate", options);
	const target = resolveListItem(editor, input.target);
	if (target.numId == null) return toListsFailure$1("INVALID_TARGET", "Target must have numbering metadata.", { target: input.target });
	if (isFirstInSequence(editor, target)) return toListsFailure$1("NO_OP", "Target is already the first item in its sequence.", { target: input.target });
	const copyOverrides = input.copyOverrides !== false;
	const abstractNumId = getAbstractNumId(editor, target.numId);
	if (abstractNumId == null) return toListsFailure$1("INVALID_TARGET", "Could not resolve abstract definition for target.", { target: input.target });
	const itemsToReassign = getSequenceFromTarget(editor, target);
	if (options?.dryRun) return {
		success: true,
		listId: "(dry-run)",
		numId: 0
	};
	let newNumId;
	if (executeDomainCommandWithRollback(editor, () => {
		newNumId = ListHelpers.createNumDefinition(editor, abstractNumId, { copyOverridesFrom: copyOverrides ? target.numId : void 0 }).numId;
		const { tr } = editor.state;
		for (const item of itemsToReassign) {
			const currentLevel = item.level ?? 0;
			updateNumberingProperties({
				numId: newNumId,
				ilvl: currentLevel
			}, item.candidate.node, item.candidate.pos, editor, tr);
		}
		dispatchEditorTransaction$1(editor, tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return toListsFailure$1("INVALID_TARGET", "List separation could not be applied.", { target: input.target });
	return {
		success: true,
		listId: `${newNumId}:${target.address.nodeId}`,
		numId: newNumId
	};
}
function listsMergeWrapper(editor, input, options) {
	rejectTrackedMode("lists.merge", options);
	const target = resolveListItem(editor, input.target);
	if (target.numId == null) return toListsFailure$1("INVALID_TARGET", "Target must have numbering metadata.", { target: input.target });
	const adjacent = findAdjacentSequence(editor, target, input.direction);
	if (!adjacent) return toListsFailure$1("NO_ADJACENT_SEQUENCE", "No adjacent list sequence found in the given direction.", {
		target: input.target,
		direction: input.direction
	});
	const targetSequence = getContiguousSequence(editor, target);
	if (adjacent.numId === target.numId) return toListsFailure$1("NO_OP", "Target and adjacent items already belong to the same sequence.", { target: input.target });
	let absorbingNumId;
	let absorbedItems;
	let anchorNodeId;
	let gapFromPos;
	let gapToPos;
	if (input.direction === "withPrevious") {
		absorbingNumId = adjacent.numId;
		absorbedItems = targetSequence;
		anchorNodeId = adjacent.sequence[0]?.address.nodeId ?? target.address.nodeId;
		const lastOfAdjacent = adjacent.sequence[adjacent.sequence.length - 1];
		const firstOfTarget = targetSequence[0];
		gapFromPos = lastOfAdjacent.candidate.pos + lastOfAdjacent.candidate.node.nodeSize;
		gapToPos = firstOfTarget.candidate.pos;
	} else {
		absorbingNumId = target.numId;
		absorbedItems = adjacent.sequence;
		anchorNodeId = targetSequence[0]?.address.nodeId ?? target.address.nodeId;
		const lastOfTarget = targetSequence[targetSequence.length - 1];
		const firstOfAdjacent = adjacent.sequence[0];
		gapFromPos = lastOfTarget.candidate.pos + lastOfTarget.candidate.node.nodeSize;
		gapToPos = firstOfAdjacent.candidate.pos;
	}
	const gapEmptyParagraphs = [];
	if (gapFromPos < gapToPos) editor.state.doc.forEach((child, offset$1) => {
		if (child.type.name !== "paragraph") return;
		if (offset$1 < gapFromPos) return;
		if (offset$1 + child.nodeSize > gapToPos) return;
		if (child.childCount > 0) return;
		gapEmptyParagraphs.push({
			pos: offset$1,
			node: child
		});
	});
	const mergedListId = `${absorbingNumId}:${anchorNodeId}`;
	if (options?.dryRun) return {
		success: true,
		listId: mergedListId,
		absorbedCount: absorbedItems.length,
		removedEmptyBlocks: gapEmptyParagraphs.length
	};
	if (executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		for (const item of absorbedItems) {
			const currentLevel = item.level ?? 0;
			updateNumberingProperties({
				numId: absorbingNumId,
				ilvl: currentLevel
			}, item.candidate.node, item.candidate.pos, editor, tr);
		}
		const sorted = [...gapEmptyParagraphs].sort((a, b$1) => b$1.pos - a.pos);
		for (const gap of sorted) tr.delete(gap.pos, gap.pos + gap.node.nodeSize);
		dispatchEditorTransaction$1(editor, tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return toListsFailure$1("INVALID_TARGET", "List merge could not be applied.", {
		target: input.target,
		direction: input.direction
	});
	return {
		success: true,
		listId: mergedListId,
		absorbedCount: absorbedItems.length,
		removedEmptyBlocks: gapEmptyParagraphs.length
	};
}
function listsSplitWrapper(editor, input, options) {
	rejectTrackedMode("lists.split", options);
	const separateResult = listsSeparateWrapper(editor, { target: input.target }, options);
	if (!separateResult.success) return separateResult;
	if (!(input.restartNumbering !== false)) return {
		success: true,
		listId: separateResult.listId,
		numId: separateResult.numId,
		restartedAt: null
	};
	if (options?.dryRun) return {
		success: true,
		listId: separateResult.listId,
		numId: separateResult.numId,
		restartedAt: 1
	};
	const setValueOptions = options ? {
		...options,
		expectedRevision: void 0
	} : options;
	const setValueResult = listsSetValueWrapper(editor, {
		target: input.target,
		value: 1
	}, setValueOptions);
	if (!setValueResult.success) return setValueResult;
	return {
		success: true,
		listId: separateResult.listId,
		numId: separateResult.numId,
		restartedAt: 1
	};
}
function listsSetLevelWrapper(editor, input, options) {
	rejectTrackedMode("lists.setLevel", options);
	return executeSetLevel(editor, resolveListItem(editor, input.target), input.level, options);
}
function listsSetValueWrapper(editor, input, options) {
	rejectTrackedMode("lists.setValue", options);
	const target = resolveListItem(editor, input.target);
	if (target.numId == null) return toListsFailure$1("INVALID_TARGET", "Target must have numbering metadata.", { target: input.target });
	const level = target.level ?? 0;
	if (options?.dryRun) return {
		success: true,
		item: target.address
	};
	if (input.value === null) {
		if (!hasLevelOverride(editor, target.numId, level)) return toListsFailure$1("NO_OP", "No startOverride to remove.", { target: input.target });
		if (executeDomainCommandWithRollback(editor, () => {
			ListHelpers.removeLvlOverride(editor, target.numId, level);
			dispatchEditorTransaction$1(editor, editor.state.tr);
			return true;
		}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return toListsFailure$1("NO_OP", "No startOverride to remove.", { target: input.target });
		return {
			success: true,
			item: target.address
		};
	}
	if (isFirstInSequence(editor, target)) {
		if (executeDomainCommandWithRollback(editor, () => {
			ListHelpers.setLvlOverride(editor, target.numId, level, { startOverride: input.value });
			dispatchEditorTransaction$1(editor, editor.state.tr);
			return true;
		}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return toListsFailure$1("INVALID_TARGET", "setValue could not be applied.", { target: input.target });
		return {
			success: true,
			item: target.address
		};
	}
	const abstractNumId = getAbstractNumId(editor, target.numId);
	if (abstractNumId == null) return toListsFailure$1("INVALID_TARGET", "Could not resolve abstract definition for target.", { target: input.target });
	const itemsToReassign = getSequenceFromTarget(editor, target);
	if (executeDomainCommandWithRollback(editor, () => {
		const { numId: newNumId } = ListHelpers.createNumDefinition(editor, abstractNumId, { copyOverridesFrom: target.numId });
		ListHelpers.setLvlOverride(editor, newNumId, level, { startOverride: input.value });
		const { tr } = editor.state;
		for (const item of itemsToReassign) updateNumberingProperties({
			numId: newNumId,
			ilvl: item.level ?? 0
		}, item.candidate.node, item.candidate.pos, editor, tr);
		dispatchEditorTransaction$1(editor, tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return toListsFailure$1("INVALID_TARGET", "setValue could not be applied.", { target: input.target });
	return {
		success: true,
		item: target.address
	};
}
function listsContinuePreviousWrapper(editor, input, options) {
	rejectTrackedMode("lists.continuePrevious", options);
	const target = resolveListItem(editor, input.target);
	if (target.numId == null) return toListsFailure$1("INVALID_TARGET", "Target must have numbering metadata.", { target: input.target });
	const canContinue = evaluateCanContinuePrevious(editor, target);
	if (!canContinue.canContinue) return toListsFailure$1({
		NO_PREVIOUS_LIST: "NO_COMPATIBLE_PREVIOUS",
		INCOMPATIBLE_DEFINITIONS: "NO_COMPATIBLE_PREVIOUS",
		ALREADY_CONTINUOUS: "ALREADY_CONTINUOUS"
	}[canContinue.reason] ?? "INVALID_TARGET", `Cannot continue previous: ${canContinue.reason}`, { target: input.target });
	const previous = findPreviousCompatibleSequence(editor, target);
	if (options?.dryRun) return {
		success: true,
		item: target.address
	};
	const sequence = getContiguousSequence(editor, target);
	const level = target.level ?? 0;
	if (executeDomainCommandWithRollback(editor, () => {
		ListHelpers.removeLvlOverride(editor, target.numId, level);
		const { tr } = editor.state;
		for (const item of sequence) {
			const currentLevel = item.level ?? 0;
			updateNumberingProperties({
				numId: previous.numId,
				ilvl: currentLevel
			}, item.candidate.node, item.candidate.pos, editor, tr);
		}
		dispatchEditorTransaction$1(editor, tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return toListsFailure$1("INVALID_TARGET", "continuePrevious could not be applied.", { target: input.target });
	return {
		success: true,
		item: target.address
	};
}
function listsSetLevelRestartWrapper(editor, input, options) {
	rejectTrackedMode("lists.setLevelRestart", options);
	const target = resolveListItem(editor, input.target);
	if (target.numId == null) return toListsFailure$1("INVALID_TARGET", "Target must have numbering metadata.", { target: input.target });
	if (input.level < 0 || input.level > 8) return toListsFailure$1("LEVEL_OUT_OF_RANGE", "Level must be between 0 and 8.", { level: input.level });
	if (options?.dryRun) return {
		success: true,
		item: target.address
	};
	const scope = input.scope ?? "definition";
	if (executeDomainCommandWithRollback(editor, () => {
		if (scope === "instance") ListHelpers.setLvlOverride(editor, target.numId, input.level, { lvlRestart: input.restartAfterLevel });
		else {
			const abstractNumId = getAbstractNumId(editor, target.numId);
			if (abstractNumId == null) return false;
			ListHelpers.setLvlRestartOnAbstract(editor, abstractNumId, input.level, input.restartAfterLevel);
		}
		dispatchEditorTransaction$1(editor, editor.state.tr);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return toListsFailure$1("INVALID_TARGET", "setLevelRestart could not be applied.", { target: input.target });
	return {
		success: true,
		item: target.address
	};
}
function listsConvertToTextWrapper(editor, input, options) {
	rejectTrackedMode("lists.convertToText", options);
	const target = resolveListItem(editor, input.target);
	const includeMarker = input.includeMarker ?? false;
	if (options?.dryRun) return {
		success: true,
		paragraph: {
			kind: "block",
			nodeType: "paragraph",
			nodeId: target.address.nodeId
		}
	};
	if (executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		if (includeMarker && target.marker) {
			const startPos = target.candidate.pos + 1;
			tr.insertText(target.marker, startPos);
		}
		updateNumberingProperties(null, target.candidate.node, target.candidate.pos, editor, tr);
		dispatchEditorTransaction$1(editor, tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return toListsFailure$1("INVALID_TARGET", "convertToText could not be applied.", { target: input.target });
	return {
		success: true,
		paragraph: {
			kind: "block",
			nodeType: "paragraph",
			nodeId: target.address.nodeId
		}
	};
}
function toListsFailure(code, message, details) {
	return {
		success: false,
		failure: {
			code,
			message,
			details
		}
	};
}
function dispatchEditorTransaction(editor, tr) {
	if (typeof editor.dispatch === "function") {
		editor.dispatch(tr);
		return;
	}
	if (typeof editor.view?.dispatch === "function") editor.view.dispatch(tr);
}
function validateLevel(level) {
	if (level < 0 || level > 8) return toListsFailure("LEVEL_OUT_OF_RANGE", "Level must be between 0 and 8.", { level });
	return null;
}
function validateLevelsArray(levels) {
	if (!levels) return null;
	for (const lvl of levels) if (lvl < 0 || lvl > 8) return toListsFailure("LEVEL_OUT_OF_RANGE", "Each level must be between 0 and 8.", { level: lvl });
	return null;
}
function normalizeLevels(levels) {
	if (!levels) return void 0;
	return [...new Set(levels)].sort((a, b$1) => a - b$1);
}
function preflightTemplateLevels(template, levels, target) {
	const templateLevelSet = new Set(template.levels.map((l) => l.level));
	const targetLevels = levels ?? template.levels.map((l) => l.level);
	for (const ilvl of targetLevels) if (!templateLevelSet.has(ilvl)) return toListsFailure("INVALID_INPUT", "Requested level does not exist in the template.", { target });
	return null;
}
function toApplyTemplateError(error, target) {
	switch (error) {
		case "ABSTRACT_NOT_FOUND": return toListsFailure("INVALID_TARGET", "Abstract numbering definition not found.", { target });
		case "LEVEL_NOT_IN_TEMPLATE": return toListsFailure("INVALID_INPUT", "Requested level does not exist in the template.", { target });
		case "LEVEL_NOT_IN_ABSTRACT": return toListsFailure("INVALID_TARGET", "Requested level does not exist in the abstract definition.", { target });
		default: return toListsFailure("INVALID_INPUT", `Template application failed: ${error}.`, { target });
	}
}
function resolveTargetAbstract(editor, target) {
	const resolved = resolveListItem(editor, target);
	if (resolved.numId == null) return {
		ok: false,
		failure: toListsFailure("INVALID_TARGET", "Target must have numbering metadata.", { target })
	};
	const abstractNumId = getAbstractNumId(editor, resolved.numId);
	if (abstractNumId == null) return {
		ok: false,
		failure: toListsFailure("INVALID_TARGET", "Could not resolve abstract definition for target.", { target })
	};
	return {
		ok: true,
		resolved,
		abstractNumId,
		numId: resolved.numId
	};
}
var NUMBERING_PART = "word/numbering.xml";
function getConverterNumbering(editor) {
	return editor.converter.numbering;
}
function executeSingleLevelMutation(editor, operationId, target, level, options, mutate) {
	rejectTrackedMode(operationId, options);
	const levelError = validateLevel(level);
	if (levelError) return levelError;
	const targetResult = resolveTargetAbstract(editor, target);
	if (!targetResult.ok) return targetResult.failure;
	if (!LevelFormattingHelpers.hasLevel(editor, targetResult.abstractNumId, level)) return toListsFailure("LEVEL_NOT_FOUND", `Level ${level} does not exist in the abstract definition.`, {
		target,
		level
	});
	if (options?.dryRun) return {
		success: true,
		item: targetResult.resolved.address
	};
	let noOp = false;
	const compound = compoundMutation({
		editor,
		source: operationId,
		affectedParts: [NUMBERING_PART],
		execute() {
			if (!mutatePart({
				editor,
				partId: NUMBERING_PART,
				operation: "mutate",
				source: operationId,
				expectedRevision: options?.expectedRevision,
				mutate({ part }) {
					if (!mutate(targetResult.abstractNumId, level)) return false;
					syncNumberingToXmlTree(part, getConverterNumbering(editor));
					return true;
				}
			}).changed) {
				noOp = true;
				return false;
			}
			dispatchEditorTransaction(editor, editor.state.tr);
			return true;
		}
	});
	if (noOp) return toListsFailure("NO_OP", `${operationId}: values already match.`, { target });
	if (!compound.success) return toListsFailure("NO_OP", `${operationId}: mutation failed.`, { target });
	return {
		success: true,
		item: targetResult.resolved.address
	};
}
function applyTemplateCompound(editor, source, target, template, levels, options, noOpMessage, failMessage) {
	const levelsError = validateLevelsArray(levels);
	if (levelsError) return levelsError;
	const targetResult = resolveTargetAbstract(editor, target);
	if (!targetResult.ok) return targetResult.failure;
	const preflightError = preflightTemplateLevels(template, levels, target);
	if (preflightError) return preflightError;
	if (options?.dryRun) return {
		success: true,
		item: targetResult.resolved.address
	};
	let applyError;
	let noOp = false;
	const compound = compoundMutation({
		editor,
		source,
		affectedParts: [NUMBERING_PART],
		execute() {
			const result = mutatePart({
				editor,
				partId: NUMBERING_PART,
				operation: "mutate",
				source,
				expectedRevision: options?.expectedRevision,
				mutate({ part }) {
					const applyResult = LevelFormattingHelpers.applyTemplateToAbstract(editor, targetResult.abstractNumId, template, levels);
					if (applyResult.error) {
						applyError = applyResult.error;
						return false;
					}
					if (!applyResult.changed) return false;
					syncNumberingToXmlTree(part, getConverterNumbering(editor));
					return true;
				}
			});
			if (applyError || !result.changed) {
				noOp = !applyError;
				return false;
			}
			dispatchEditorTransaction(editor, editor.state.tr);
			return true;
		}
	});
	if (applyError) return toApplyTemplateError(applyError, target);
	if (noOp) return toListsFailure("NO_OP", noOpMessage, { target });
	if (!compound.success) return toListsFailure("NO_OP", failMessage, { target });
	return {
		success: true,
		item: targetResult.resolved.address
	};
}
function listsApplyTemplateWrapper(editor, input, options) {
	rejectTrackedMode("lists.applyTemplate", options);
	if (input.template.version !== 1) return toListsFailure("INVALID_INPUT", "Unsupported template version.", { version: input.template.version });
	return applyTemplateCompound(editor, "lists.applyTemplate", input.target, input.template, input.levels, options, "All template levels already match.", "Template application failed.");
}
function listsApplyPresetWrapper(editor, input, options) {
	rejectTrackedMode("lists.applyPreset", options);
	const template = LevelFormattingHelpers.getPresetTemplate(input.preset);
	if (!template) return toListsFailure("INVALID_INPUT", `Unknown preset: ${input.preset}.`, { preset: input.preset });
	return applyTemplateCompound(editor, "lists.applyPreset", input.target, template, input.levels, options, "All preset levels already match.", "Preset application failed.");
}
var DEFAULT_PRESET_FOR_KIND = {
	ordered: "decimal",
	bullet: "disc"
};
function areAbstractsCompatibleForMerge(targetAbstractNumId, adjacentAbstractNumId) {
	return adjacentAbstractNumId != null && targetAbstractNumId === adjacentAbstractNumId;
}
function resolveSequenceKind(sequence) {
	const first$1 = sequence[0];
	if (!first$1 || first$1.numId == null) return void 0;
	return first$1.kind;
}
function mergeAdjacentSequence(editor, tr, absorbingNumId, absorbedItems) {
	const firstAbsorbed = absorbedItems[0];
	if (firstAbsorbed?.numId != null) ListHelpers.removeLvlOverride(editor, firstAbsorbed.numId, firstAbsorbed.level ?? 0);
	for (const item of absorbedItems) updateNumberingProperties({
		numId: absorbingNumId,
		ilvl: item.level ?? 0
	}, item.candidate.node, item.candidate.pos, editor, tr);
}
function listsSetTypeWrapper(editor, input, options) {
	rejectTrackedMode("lists.setType", options);
	const preset = DEFAULT_PRESET_FOR_KIND[input.kind];
	if (!preset) return toListsFailure("INVALID_INPUT", `Unknown list kind: ${input.kind}.`, { kind: input.kind });
	const template = LevelFormattingHelpers.getPresetTemplate(preset);
	if (!template) return toListsFailure("INVALID_INPUT", `No template found for preset: ${preset}.`, { preset });
	const targetResult = resolveTargetAbstract(editor, input.target);
	if (!targetResult.ok) return targetResult.failure;
	if (options?.dryRun) return {
		success: true,
		item: targetResult.resolved.address
	};
	const continuity = input.continuity ?? "preserve";
	let applyError;
	let noOp = false;
	const compound = compoundMutation({
		editor,
		source: "lists.setType",
		affectedParts: [NUMBERING_PART],
		execute() {
			let didAnything = false;
			const formatResult = mutatePart({
				editor,
				partId: NUMBERING_PART,
				operation: "mutate",
				source: "lists.setType",
				expectedRevision: options?.expectedRevision,
				mutate({ part }) {
					const result = LevelFormattingHelpers.applyTemplateToAbstract(editor, targetResult.abstractNumId, template, void 0);
					if (result.error) {
						applyError = result.error;
						return false;
					}
					if (result.changed) syncNumberingToXmlTree(part, getConverterNumbering(editor));
					return result.changed;
				}
			});
			if (applyError) return false;
			if (formatResult.changed) didAnything = true;
			let mergeDispatched = false;
			if (continuity === "preserve") {
				clearIndexCache(editor);
				const freshTarget = resolveListItem(editor, input.target);
				if (freshTarget.numId != null) {
					const { tr } = editor.state;
					if (mergeAdjacentCompatibleSequences(editor, tr, freshTarget, targetResult.abstractNumId)) {
						didAnything = true;
						mergeDispatched = true;
						dispatchEditorTransaction(editor, tr);
						clearIndexCache(editor);
					}
				}
			}
			if (!didAnything) {
				noOp = true;
				return false;
			}
			if (formatResult.changed && !mergeDispatched) dispatchEditorTransaction(editor, editor.state.tr);
			return true;
		}
	});
	if (applyError) return toApplyTemplateError(applyError, input.target);
	if (noOp) return toListsFailure("NO_OP", "List type is already the requested kind.", { target: input.target });
	if (!compound.success) return toListsFailure("NO_OP", "setType mutation failed.", { target: input.target });
	return {
		success: true,
		item: targetResult.resolved.address
	};
}
function mergeAdjacentCompatibleSequences(editor, tr, target, targetAbstractNumId) {
	const targetNumId = target.numId;
	let merged = false;
	const prev = findAdjacentSequence(editor, target, "withPrevious");
	if (prev && canMergeSequences(prev.abstractNumId, targetAbstractNumId, prev.sequence, target.kind)) {
		const targetSequence = getContiguousSequence(editor, target);
		mergeAdjacentSequence(editor, tr, prev.numId, targetSequence);
		clearIndexCache(editor);
		merged = true;
		const freshTarget = resolveListItem(editor, target.address);
		const next$1 = findAdjacentSequence(editor, freshTarget, "withNext");
		if (next$1 && prev.abstractNumId != null && canMergeSequences(next$1.abstractNumId, prev.abstractNumId, next$1.sequence, freshTarget.kind)) {
			mergeAdjacentSequence(editor, tr, prev.numId, next$1.sequence);
			clearIndexCache(editor);
		}
		return merged;
	}
	const next = findAdjacentSequence(editor, target, "withNext");
	if (next && canMergeSequences(next.abstractNumId, targetAbstractNumId, next.sequence, target.kind)) {
		mergeAdjacentSequence(editor, tr, targetNumId, next.sequence);
		clearIndexCache(editor);
		merged = true;
	}
	return merged;
}
function canMergeSequences(adjacentAbstractNumId, targetAbstractNumId, adjacentSequence, targetKind) {
	const adjacentKind = resolveSequenceKind(adjacentSequence);
	if (adjacentKind == null || adjacentKind !== targetKind) return false;
	return areAbstractsCompatibleForMerge(targetAbstractNumId, adjacentAbstractNumId);
}
function listsCaptureTemplateWrapper(editor, input) {
	const levelsError = validateLevelsArray(input.levels);
	if (levelsError) return levelsError;
	const targetResult = resolveTargetAbstract(editor, input.target);
	if (!targetResult.ok) return targetResult.failure;
	const template = LevelFormattingHelpers.captureTemplate(editor, targetResult.abstractNumId, input.levels);
	if (!template) return toListsFailure("INVALID_TARGET", "Could not capture template from target.", { target: input.target });
	return {
		success: true,
		template
	};
}
function listsSetLevelNumberingWrapper(editor, input, options) {
	return executeSingleLevelMutation(editor, "lists.setLevelNumbering", input.target, input.level, options, (abstractNumId, ilvl) => LevelFormattingHelpers.setLevelNumberingFormat(editor, abstractNumId, ilvl, {
		numFmt: input.numFmt,
		lvlText: input.lvlText,
		start: input.start
	}));
}
function listsSetLevelBulletWrapper(editor, input, options) {
	return executeSingleLevelMutation(editor, "lists.setLevelBullet", input.target, input.level, options, (abstractNumId, ilvl) => LevelFormattingHelpers.setLevelBulletMarker(editor, abstractNumId, ilvl, input.markerText));
}
function listsSetLevelPictureBulletWrapper(editor, input, options) {
	rejectTrackedMode("lists.setLevelPictureBullet", options);
	const converter = editor.converter;
	if (converter?.convertedXml && !converter.convertedXml["word/numbering.xml"]) return toListsFailure("CAPABILITY_UNAVAILABLE", "Picture bullets require a numbering definition (word/numbering.xml).", { target: input.target });
	return executeSingleLevelMutation(editor, "lists.setLevelPictureBullet", input.target, input.level, options, (abstractNumId, ilvl) => LevelFormattingHelpers.setLevelPictureBulletId(editor, abstractNumId, ilvl, input.pictureBulletId));
}
function listsSetLevelAlignmentWrapper(editor, input, options) {
	return executeSingleLevelMutation(editor, "lists.setLevelAlignment", input.target, input.level, options, (abstractNumId, ilvl) => LevelFormattingHelpers.setLevelAlignment(editor, abstractNumId, ilvl, input.alignment));
}
function listsSetLevelIndentsWrapper(editor, input, options) {
	const hasLeft = input.left != null;
	const hasHanging = input.hanging != null;
	const hasFirstLine = input.firstLine != null;
	if (!hasLeft && !hasHanging && !hasFirstLine) return toListsFailure("INVALID_INPUT", "At least one indent property is required.", {});
	if (hasHanging && hasFirstLine) return toListsFailure("INVALID_INPUT", "hanging and firstLine are mutually exclusive.", {});
	return executeSingleLevelMutation(editor, "lists.setLevelIndents", input.target, input.level, options, (abstractNumId, ilvl) => {
		const indents = {};
		if (hasLeft) indents.left = input.left;
		if (hasHanging) indents.hanging = input.hanging;
		if (hasFirstLine) indents.firstLine = input.firstLine;
		return LevelFormattingHelpers.setLevelIndents(editor, abstractNumId, ilvl, indents);
	});
}
function listsSetLevelTrailingCharacterWrapper(editor, input, options) {
	return executeSingleLevelMutation(editor, "lists.setLevelTrailingCharacter", input.target, input.level, options, (abstractNumId, ilvl) => LevelFormattingHelpers.setLevelTrailingCharacter(editor, abstractNumId, ilvl, input.trailingCharacter));
}
function listsSetLevelMarkerFontWrapper(editor, input, options) {
	return executeSingleLevelMutation(editor, "lists.setLevelMarkerFont", input.target, input.level, options, (abstractNumId, ilvl) => LevelFormattingHelpers.setLevelMarkerFont(editor, abstractNumId, ilvl, input.fontFamily));
}
function ensureSequenceLocalAbstract(editor, target, targetAbstractNumId, targetNumId) {
	if (!LevelFormattingHelpers.isAbstractShared(editor, targetAbstractNumId, targetNumId)) return {
		abstractNumId: targetAbstractNumId,
		numId: targetNumId,
		sourceNumId: targetNumId,
		pendingRebind: null
	};
	const sequence = getContiguousSequence(editor, target);
	const sequenceNodeIds = new Set(sequence.map((item) => item.address.nodeId));
	const allItemsWithNumId = getAllListItemProjections(editor).filter((item) => item.numId === targetNumId);
	if (allItemsWithNumId.length === sequence.length && allItemsWithNumId.every((item) => sequenceNodeIds.has(item.address.nodeId))) {
		const { newAbstractNumId: newAbstractNumId$1 } = LevelFormattingHelpers.cloneAbstractIntoNum(editor, targetAbstractNumId, targetNumId);
		return {
			abstractNumId: newAbstractNumId$1,
			numId: targetNumId,
			sourceNumId: targetNumId,
			pendingRebind: null
		};
	}
	const { newAbstractNumId, newNumId } = LevelFormattingHelpers.cloneAbstractAndNum(editor, targetAbstractNumId, targetNumId);
	return {
		abstractNumId: newAbstractNumId,
		numId: newNumId,
		sourceNumId: targetNumId,
		pendingRebind: sequence
	};
}
function applyPendingRebind(editor, tr, local) {
	if (!local.pendingRebind) return;
	for (const item of local.pendingRebind) updateNumberingProperties({
		numId: local.numId,
		ilvl: item.level ?? 0
	}, item.candidate.node, item.candidate.pos, editor, tr);
}
function executeSequenceLocalLevelMutation(editor, operationId, target, level, options, mutate) {
	rejectTrackedMode(operationId, options);
	const levelError = validateLevel(level);
	if (levelError) return levelError;
	const targetResult = resolveTargetAbstract(editor, target);
	if (!targetResult.ok) return targetResult.failure;
	if (!LevelFormattingHelpers.hasLevel(editor, targetResult.abstractNumId, level)) return toListsFailure("LEVEL_NOT_FOUND", `Level ${level} does not exist in the abstract definition.`, {
		target,
		level
	});
	if (options?.dryRun) return {
		success: true,
		item: targetResult.resolved.address
	};
	let noOp = false;
	const compound = compoundMutation({
		editor,
		source: operationId,
		affectedParts: [NUMBERING_PART],
		execute() {
			const local = ensureSequenceLocalAbstract(editor, resolveListItem(editor, target), targetResult.abstractNumId, targetResult.numId);
			if (!mutatePart({
				editor,
				partId: NUMBERING_PART,
				operation: "mutate",
				source: operationId,
				expectedRevision: options?.expectedRevision,
				mutate({ part }) {
					LevelFormattingHelpers.materializeLevelFormattingOverride(editor, local.abstractNumId, local.numId, level);
					if (!mutate(local.abstractNumId, level)) return false;
					LevelFormattingHelpers.copySequenceStateOverrides(editor, local.sourceNumId, local.numId, [level]);
					syncNumberingToXmlTree(part, getConverterNumbering(editor));
					return true;
				}
			}).changed) {
				noOp = true;
				return false;
			}
			const { tr } = editor.state;
			applyPendingRebind(editor, tr, local);
			dispatchEditorTransaction(editor, tr);
			if (local.pendingRebind) clearIndexCache(editor);
			return true;
		}
	});
	if (noOp) return toListsFailure("NO_OP", `${operationId}: values already match.`, { target });
	if (!compound.success) return toListsFailure("NO_OP", `${operationId}: mutation failed.`, { target });
	return {
		success: true,
		item: targetResult.resolved.address
	};
}
function listsGetStyleWrapper(editor, input) {
	const levelsError = validateLevelsArray(input.levels);
	if (levelsError) return levelsError;
	const normalized = normalizeLevels(input.levels);
	const targetResult = resolveTargetAbstract(editor, input.target);
	if (!targetResult.ok) return targetResult.failure;
	const style = LevelFormattingHelpers.captureEffectiveStyle(editor, targetResult.abstractNumId, targetResult.numId, normalized);
	if (!style) return toListsFailure("INVALID_TARGET", "Could not capture style from target.", { target: input.target });
	return {
		success: true,
		style
	};
}
function listsApplyStyleWrapper(editor, input, options) {
	rejectTrackedMode("lists.applyStyle", options);
	if (input.style.version !== 1) return toListsFailure("INVALID_INPUT", "Unsupported style version.", { version: input.style.version });
	const levelsError = validateLevelsArray(input.levels);
	if (levelsError) return levelsError;
	const normalized = normalizeLevels(input.levels);
	const targetResult = resolveTargetAbstract(editor, input.target);
	if (!targetResult.ok) return targetResult.failure;
	const preflightError = preflightTemplateLevels(input.style, normalized, input.target);
	if (preflightError) return preflightError;
	if (options?.dryRun) return {
		success: true,
		item: targetResult.resolved.address
	};
	let applyError;
	let noOp = false;
	const compound = compoundMutation({
		editor,
		source: "lists.applyStyle",
		affectedParts: [NUMBERING_PART],
		execute() {
			const local = ensureSequenceLocalAbstract(editor, resolveListItem(editor, input.target), targetResult.abstractNumId, targetResult.numId);
			const result = mutatePart({
				editor,
				partId: NUMBERING_PART,
				operation: "mutate",
				source: "lists.applyStyle",
				expectedRevision: options?.expectedRevision,
				mutate({ part }) {
					const affectedLevels = normalized ?? input.style.levels.map((l) => l.level);
					for (const ilvl of affectedLevels) LevelFormattingHelpers.materializeLevelFormattingOverride(editor, local.abstractNumId, local.numId, ilvl);
					const applyResult = LevelFormattingHelpers.applyTemplateToAbstract(editor, local.abstractNumId, input.style, normalized);
					if (applyResult.error) {
						applyError = applyResult.error;
						return false;
					}
					if (!applyResult.changed) return false;
					LevelFormattingHelpers.copySequenceStateOverrides(editor, local.sourceNumId, local.numId, affectedLevels);
					syncNumberingToXmlTree(part, getConverterNumbering(editor));
					return true;
				}
			});
			if (applyError || !result.changed) {
				noOp = !applyError;
				return false;
			}
			const { tr } = editor.state;
			applyPendingRebind(editor, tr, local);
			dispatchEditorTransaction(editor, tr);
			if (local.pendingRebind) clearIndexCache(editor);
			return true;
		}
	});
	if (applyError) return toApplyTemplateError(applyError, input.target);
	if (noOp) return toListsFailure("NO_OP", "All style levels already match.", { target: input.target });
	if (!compound.success) return toListsFailure("NO_OP", "Style application failed.", { target: input.target });
	return {
		success: true,
		item: targetResult.resolved.address
	};
}
var _setValueDelegate;
function registerSetValueDelegate(fn) {
	_setValueDelegate = fn;
}
function listsRestartAtWrapper(editor, input, options) {
	rejectTrackedMode("lists.restartAt", options);
	if (input.startAt < 1 || !Number.isInteger(input.startAt)) return toListsFailure("INVALID_INPUT", "startAt must be a positive integer (>= 1).", { startAt: input.startAt });
	const resolved = resolveListItem(editor, input.target);
	if (resolved.numId == null) return toListsFailure("INVALID_TARGET", "Target must have numbering metadata.", { target: input.target });
	if (resolved.kind === "bullet") return toListsFailure("INVALID_INPUT", "Cannot restart numbering on a bullet list.", { target: input.target });
	if (!_setValueDelegate) return toListsFailure("INVALID_INPUT", "restartAt: internal delegate not registered.", { target: input.target });
	return _setValueDelegate(editor, {
		target: input.target,
		value: input.startAt
	}, options);
}
function listsSetLevelNumberStyleWrapper(editor, input, options) {
	if (input.numberStyle === "bullet") return toListsFailure("INVALID_INPUT", "Use setLevelBullet or setLevelPictureBullet to set bullet format.", { numberStyle: input.numberStyle });
	return executeSequenceLocalLevelMutation(editor, "lists.setLevelNumberStyle", input.target, input.level, options, (abstractNumId, ilvl) => LevelFormattingHelpers.setLevelNumberStyle(editor, abstractNumId, ilvl, input.numberStyle));
}
function listsSetLevelTextWrapper(editor, input, options) {
	return executeSequenceLocalLevelMutation(editor, "lists.setLevelText", input.target, input.level, options, (abstractNumId, ilvl) => LevelFormattingHelpers.setLevelText(editor, abstractNumId, ilvl, input.text));
}
function listsSetLevelStartWrapper(editor, input, options) {
	if (input.startAt < 1 || !Number.isInteger(input.startAt)) return toListsFailure("INVALID_INPUT", "startAt must be a positive integer (>= 1).", { startAt: input.startAt });
	if (!validateLevel(input.level)) {
		const targetResult = resolveTargetAbstract(editor, input.target);
		if (targetResult.ok && LevelFormattingHelpers.hasLevel(editor, targetResult.abstractNumId, input.level)) {
			const abstracts = getConverterNumbering(editor).abstracts;
			const lvlEl = LevelFormattingHelpers.findLevelElement(abstracts[targetResult.abstractNumId], input.level);
			if (LevelFormattingHelpers.readLevelProperties(lvlEl, input.level).numFmt === "bullet") return toListsFailure("INVALID_INPUT", "Cannot set start value on a bullet level.", {
				target: input.target,
				level: input.level
			});
		}
	}
	return executeSequenceLocalLevelMutation(editor, "lists.setLevelStart", input.target, input.level, options, (abstractNumId, ilvl) => LevelFormattingHelpers.setLevelStart(editor, abstractNumId, ilvl, input.startAt));
}
function listsSetLevelLayoutWrapper(editor, input, options) {
	rejectTrackedMode("lists.setLevelLayout", options);
	const levelError = validateLevel(input.level);
	if (levelError) return levelError;
	const targetResult = resolveTargetAbstract(editor, input.target);
	if (!targetResult.ok) return targetResult.failure;
	if (!LevelFormattingHelpers.hasLevel(editor, targetResult.abstractNumId, input.level)) return toListsFailure("LEVEL_NOT_FOUND", `Level ${input.level} does not exist in the abstract definition.`, {
		target: input.target,
		level: input.level
	});
	if (options?.dryRun) return {
		success: true,
		item: targetResult.resolved.address
	};
	let noOp = false;
	let layoutError;
	const compound = compoundMutation({
		editor,
		source: "lists.setLevelLayout",
		affectedParts: [NUMBERING_PART],
		execute() {
			const local = ensureSequenceLocalAbstract(editor, resolveListItem(editor, input.target), targetResult.abstractNumId, targetResult.numId);
			const result = mutatePart({
				editor,
				partId: NUMBERING_PART,
				operation: "mutate",
				source: "lists.setLevelLayout",
				expectedRevision: options?.expectedRevision,
				mutate({ part }) {
					LevelFormattingHelpers.materializeLevelFormattingOverride(editor, local.abstractNumId, local.numId, input.level);
					const layoutResult = LevelFormattingHelpers.setLevelLayout(editor, local.abstractNumId, input.level, input.layout);
					if (layoutResult.error) {
						layoutError = layoutResult.error;
						return false;
					}
					if (!layoutResult.changed) return false;
					syncNumberingToXmlTree(part, getConverterNumbering(editor));
					return true;
				}
			});
			if (layoutError || !result.changed) {
				noOp = !layoutError;
				return false;
			}
			const { tr } = editor.state;
			applyPendingRebind(editor, tr, local);
			dispatchEditorTransaction(editor, tr);
			if (local.pendingRebind) clearIndexCache(editor);
			return true;
		}
	});
	if (layoutError) return toListsFailure("INVALID_INPUT", `Layout mutation failed: ${layoutError}.`, { target: input.target });
	if (noOp) return toListsFailure("NO_OP", "lists.setLevelLayout: values already match.", { target: input.target });
	if (!compound.success) return toListsFailure("NO_OP", "lists.setLevelLayout: mutation failed.", { target: input.target });
	return {
		success: true,
		item: targetResult.resolved.address
	};
}
function listsClearLevelOverridesWrapper(editor, input, options) {
	rejectTrackedMode("lists.clearLevelOverrides", options);
	const levelError = validateLevel(input.level);
	if (levelError) return levelError;
	const resolved = resolveListItem(editor, input.target);
	if (resolved.numId == null) return toListsFailure("INVALID_TARGET", "Target must have numbering metadata.", { target: input.target });
	if (options?.dryRun) return {
		success: true,
		item: resolved.address
	};
	if (!LevelFormattingHelpers.hasLevelOverride(editor, resolved.numId, input.level)) return toListsFailure("NO_OP", "No override exists for this level.", {
		target: input.target,
		level: input.level
	});
	let noOp = false;
	const compound = compoundMutation({
		editor,
		source: "lists.clearLevelOverrides",
		affectedParts: [NUMBERING_PART],
		execute() {
			if (!mutatePart({
				editor,
				partId: NUMBERING_PART,
				operation: "mutate",
				source: "lists.clearLevelOverrides",
				expectedRevision: options?.expectedRevision,
				mutate({ part }) {
					LevelFormattingHelpers.clearLevelOverride(editor, resolved.numId, input.level);
					syncNumberingToXmlTree(part, getConverterNumbering(editor));
					return true;
				}
			}).changed) {
				noOp = true;
				return false;
			}
			dispatchEditorTransaction(editor, editor.state.tr);
			return true;
		}
	});
	if (noOp) return toListsFailure("NO_OP", "clearLevelOverrides could not be applied.", { target: input.target });
	if (!compound.success) return toListsFailure("NO_OP", "clearLevelOverrides mutation failed.", { target: input.target });
	return {
		success: true,
		item: resolved.address
	};
}
function previewPlan(editor, input) {
	checkRevision(editor, input.expectedRevision);
	if (!input.steps?.length) throw planError("INVALID_INPUT", "plan must contain at least one step");
	const failures = [];
	const stepPreviews = [];
	let currentPhase = "compile";
	let evaluatedRevision = getRevision(editor);
	try {
		const compiled = compilePlan(editor, input.steps, { skipIdentityRepair: true });
		evaluatedRevision = compiled.compiledRevision;
		currentPhase = "execute";
		const tr = editor.state.tr;
		const { stepOutcomes, assertFailures } = runMutationsOnTransaction(editor, tr, compiled, {
			throwOnAssertFailure: false,
			changeMode: input.changeMode ?? "direct",
			isPreview: true
		});
		for (const outcome of stepOutcomes) {
			const preview = {
				stepId: outcome.stepId,
				op: outcome.op
			};
			if (outcome.data && "resolutions" in outcome.data && outcome.data.domain === "text") {
				preview.resolutions = outcome.data.resolutions;
				if ("spanResolutions" in outcome.data && outcome.data.spanResolutions?.length) preview.spanResolutions = outcome.data.spanResolutions;
				if ("selectionResolutions" in outcome.data && outcome.data.selectionResolutions?.length) preview.selectionResolutions = outcome.data.selectionResolutions;
			}
			stepPreviews.push(preview);
		}
		for (const failure$5 of assertFailures) failures.push({
			code: "PRECONDITION_FAILED",
			stepId: failure$5.stepId,
			phase: "assert",
			message: `assert "${failure$5.stepId}" expected ${failure$5.expectedCount} matches but found ${failure$5.actualCount}`,
			details: {
				expectedCount: failure$5.expectedCount,
				actualCount: failure$5.actualCount
			}
		});
	} catch (error) {
		if (error instanceof PlanError) failures.push({
			code: error.code,
			stepId: error.stepId ?? "",
			phase: currentPhase,
			message: error.message,
			details: error.details
		});
		else throw error;
	}
	return {
		evaluatedRevision,
		steps: stepPreviews,
		valid: failures.length === 0,
		failures: failures.length > 0 ? failures : void 0
	};
}
var PREVIEW_TEXT_MAX_LENGTH = 2e3;
var BLOCK_PREVIEW_MAX_LENGTH = 200;
var EDGE_NODE_TYPES$1 = new Set(SELECTION_EDGE_NODE_TYPES);
function resolveDocumentStart(index) {
	const first$1 = index.candidates[0];
	return first$1 ? first$1.pos : 1;
}
function resolveDocumentEnd(editor, index) {
	let maxEnd = 0;
	for (const c of index.candidates) if (c.end > maxEnd) maxEnd = c.end;
	return maxEnd > 0 ? maxEnd : editor.state.doc.content.size - 1;
}
function resolveRefAnchor(editor, ref$1, boundary, revision) {
	const decoded = decodeRef(ref$1);
	if (!decoded) throw new DocumentApiAdapterError("INVALID_TARGET", `Only text refs (from query.match or ranges.resolve) are valid range anchors. Got: "${ref$1}".`, {
		ref: ref$1,
		boundary
	});
	const segments = decoded.segments;
	if (!segments?.length) throw new DocumentApiAdapterError("INVALID_TARGET", "Ref contains no segments.", {
		ref: ref$1,
		boundary
	});
	if (decoded.rev !== revision) throw new PlanError("REVISION_MISMATCH", `REVISION_MISMATCH — ref was created at revision ${decoded.rev} but document is at revision ${revision}. Re-run the discovery operation to obtain a fresh ref.`, void 0, {
		ref: ref$1,
		boundary,
		refRevision: decoded.rev,
		currentRevision: revision,
		refStability: "ephemeral",
		remediation: "Re-run ranges.resolve or query.match to obtain a fresh ref valid for the current revision."
	});
	const seg = boundary === "start" ? segments[0] : segments[segments.length - 1];
	const offset$1 = boundary === "start" ? seg.start : seg.end;
	return resolveSelectionPointPosition(editor, {
		kind: "text",
		blockId: seg.blockId,
		offset: offset$1
	});
}
function resolveAnchor(editor, anchor, revision, index) {
	switch (anchor.kind) {
		case "document": return anchor.edge === "start" ? resolveDocumentStart(index) : resolveDocumentEnd(editor, index);
		case "point": return resolveSelectionPointPosition(editor, anchor.point);
		case "ref": return resolveRefAnchor(editor, anchor.ref, anchor.boundary, revision);
	}
}
function isEdgeNodeType(nodeType) {
	return EDGE_NODE_TYPES$1.has(nodeType);
}
function computeTextOffset(editor, blockContentStart, absPos) {
	if (absPos <= blockContentStart) return 0;
	return editor.state.doc.textBetween(blockContentStart, absPos, "", "￼").length;
}
function absPositionToSelectionPoint(editor, index, absPos) {
	for (const candidate of index.candidates) {
		const blockContentStart = candidate.pos + 1;
		const blockContentEnd = candidate.end - 1;
		if (absPos === candidate.pos && isEdgeNodeType(candidate.nodeType)) return {
			kind: "nodeEdge",
			node: {
				kind: "block",
				nodeType: candidate.nodeType,
				nodeId: candidate.nodeId
			},
			edge: "before"
		};
		if (absPos === candidate.end && isEdgeNodeType(candidate.nodeType)) return {
			kind: "nodeEdge",
			node: {
				kind: "block",
				nodeType: candidate.nodeType,
				nodeId: candidate.nodeId
			},
			edge: "after"
		};
		if (absPos >= blockContentStart && absPos <= blockContentEnd && isTextBlockCandidate(candidate)) return {
			kind: "text",
			blockId: candidate.nodeId,
			offset: computeTextOffset(editor, blockContentStart, absPos)
		};
	}
	return resolveGapPosition(index, absPos);
}
function resolveGapPosition(index, absPos) {
	const first$1 = index.candidates[0];
	const last = index.candidates[index.candidates.length - 1];
	if (first$1 && absPos <= first$1.pos && isEdgeNodeType(first$1.nodeType)) return {
		kind: "nodeEdge",
		node: {
			kind: "block",
			nodeType: first$1.nodeType,
			nodeId: first$1.nodeId
		},
		edge: "before"
	};
	if (last && absPos >= last.end && isEdgeNodeType(last.nodeType)) return {
		kind: "nodeEdge",
		node: {
			kind: "block",
			nodeType: last.nodeType,
			nodeId: last.nodeId
		},
		edge: "after"
	};
	const fallback = first$1 ?? last;
	if (fallback) return {
		kind: "text",
		blockId: fallback.nodeId,
		offset: 0
	};
	throw new DocumentApiAdapterError("INVALID_TARGET", `Could not map position ${absPos} to a SelectionPoint — document appears empty.`, { absPos });
}
function buildSelectionTarget(editor, index, absFrom, absTo, story) {
	return {
		kind: "selection",
		start: absPositionToSelectionPoint(editor, index, absFrom),
		end: absPositionToSelectionPoint(editor, index, absTo),
		...story && { story }
	};
}
function buildPreview(editor, index, absFrom, absTo) {
	const blocks = [];
	let fullText = "";
	for (const candidate of index.candidates) {
		if (candidate.end <= absFrom || candidate.pos >= absTo) continue;
		const blockContentStart = candidate.pos + 1;
		const blockContentEnd = candidate.end - 1;
		const rangeStart = Math.max(blockContentStart, absFrom);
		const rangeEnd = Math.min(blockContentEnd, absTo);
		if (rangeStart > rangeEnd) continue;
		const blockText = editor.state.doc.textBetween(rangeStart, rangeEnd, "", "￼");
		blocks.push({
			nodeId: candidate.nodeId,
			nodeType: candidate.nodeType,
			textPreview: blockText.length > BLOCK_PREVIEW_MAX_LENGTH ? blockText.slice(0, BLOCK_PREVIEW_MAX_LENGTH) : blockText
		});
		if (fullText.length > 0) fullText += "\n";
		fullText += blockText;
	}
	const truncated = fullText.length > PREVIEW_TEXT_MAX_LENGTH;
	return {
		text: truncated ? fullText.slice(0, PREVIEW_TEXT_MAX_LENGTH) : fullText,
		truncated,
		blocks
	};
}
function findNearestTextCandidate(index, pos) {
	let best;
	let bestDist = Infinity;
	for (const c of index.candidates) {
		if (!isTextBlockCandidate(c)) continue;
		const dist = pos < c.pos ? c.pos - pos : pos > c.end ? pos - c.end : 0;
		if (dist < bestDist) {
			bestDist = dist;
			best = c;
		}
	}
	return best;
}
function encodeRangeRef(editor, index, absFrom, absTo, revision, storyKey) {
	const segments = [];
	for (const candidate of index.candidates) {
		if (candidate.end <= absFrom || candidate.pos >= absTo) continue;
		if (!isTextBlockCandidate(candidate)) continue;
		const blockContentStart = candidate.pos + 1;
		const blockContentEnd = candidate.end - 1;
		const segStart = Math.max(blockContentStart, absFrom);
		const segEnd = Math.min(blockContentEnd, absTo);
		if (segStart > segEnd) continue;
		segments.push({
			blockId: candidate.nodeId,
			start: computeTextOffset(editor, blockContentStart, segStart),
			end: computeTextOffset(editor, blockContentStart, segEnd)
		});
	}
	if (segments.length === 0) {
		const fallback = findNearestTextCandidate(index, absFrom);
		if (fallback) {
			const blockContentStart = fallback.pos + 1;
			const offset$1 = computeTextOffset(editor, blockContentStart, Math.max(blockContentStart, Math.min(fallback.end - 1, absFrom)));
			segments.push({
				blockId: fallback.nodeId,
				start: offset$1,
				end: offset$1
			});
		}
	}
	if (segments.length === 0) return null;
	if (storyKey && storyKey !== "body") return encodeV4Ref({
		v: 4,
		rev: revision,
		storyKey,
		scope: "match",
		matchId: `range:${absFrom}-${absTo}`,
		segments
	});
	return encodeV3Ref({
		v: 3,
		rev: revision,
		matchId: `range:${absFrom}-${absTo}`,
		scope: "match",
		segments
	});
}
function rangeContainsOnlyTextBlocks(index, absFrom, absTo) {
	for (const candidate of index.candidates) {
		if (candidate.end <= absFrom || candidate.pos >= absTo) continue;
		if (isTextBlockCandidate(candidate)) continue;
		if (candidate.pos <= absFrom && candidate.end >= absTo) continue;
		return false;
	}
	return true;
}
function resolveAbsoluteRange(editor, input) {
	const revision = getRevision(editor);
	if (input.expectedRevision !== void 0) checkRevision(editor, input.expectedRevision);
	const index = getBlockIndex(editor);
	const absFrom = Math.min(input.absFrom, input.absTo);
	const absTo = Math.max(input.absFrom, input.absTo);
	const isNonBody = input.storyLocator !== void 0 && input.storyLocator.storyType !== "body";
	const storyForTarget = isNonBody ? input.storyLocator : void 0;
	const storyKey = isNonBody ? buildStoryKey(input.storyLocator) : void 0;
	const target = buildSelectionTarget(editor, index, absFrom, absTo, storyForTarget);
	const coversFullTarget = target.start.kind === "text" && target.end.kind === "text" && rangeContainsOnlyTextBlocks(index, absFrom, absTo);
	return {
		evaluatedRevision: revision,
		handle: {
			ref: encodeRangeRef(editor, index, absFrom, absTo, revision, storyKey),
			refStability: "ephemeral",
			coversFullTarget
		},
		target,
		preview: buildPreview(editor, index, absFrom, absTo)
	};
}
function extractStoryFromAnchor(anchor) {
	if (anchor.kind !== "ref") return void 0;
	return resolveStoryFromRef(anchor.ref);
}
function reconcileAnchorStories(startStory, endStory) {
	if (!startStory) return endStory;
	if (!endStory) return startStory;
	if (storyLocatorToKey(startStory) !== storyLocatorToKey(endStory)) throw new DocumentApiAdapterError("INVALID_INPUT", `Range anchor story mismatch: start ref targets "${storyLocatorToKey(startStory)}" but end ref targets "${storyLocatorToKey(endStory)}". A range cannot span multiple stories.`, {
		startStory: storyLocatorToKey(startStory),
		endStory: storyLocatorToKey(endStory)
	});
	return startStory;
}
function resolveRangeStory(input) {
	const anchorStory = reconcileAnchorStories(extractStoryFromAnchor(input.start), extractStoryFromAnchor(input.end));
	return resolveStoryFromInput({ in: input.in }, anchorStory ? { story: anchorStory } : void 0);
}
function resolveRange(hostEditor, input) {
	const storyLocator = resolveRangeStory(input);
	const storyEditor = resolveStoryRuntime(hostEditor, storyLocator).editor;
	const revision = getRevision(storyEditor);
	if (input.expectedRevision !== void 0) checkRevision(storyEditor, input.expectedRevision);
	const index = getBlockIndex(storyEditor);
	return resolveAbsoluteRange(storyEditor, {
		absFrom: resolveAnchor(storyEditor, input.start, revision, index),
		absTo: resolveAnchor(storyEditor, input.end, revision, index),
		storyLocator
	});
}
var COMMENT_MARK_NAME = "commentMark";
var TRACK_CHANGE_MARK_NAMES = new Set([
	"trackInsert",
	"trackDelete",
	"trackFormat"
]);
function resolveCurrentSelectionInfo(editor, input) {
	const state = editor.state;
	if (!state) return {
		empty: true,
		target: null,
		activeMarks: [],
		activeCommentIds: [],
		activeChangeIds: []
	};
	const sel = state.selection;
	const { from: from$1, to, empty: empty$1 } = sel;
	const segments = shouldProjectTextTarget(sel) ? collectTextSegments(state.doc, from$1, to) : null;
	const target = segments && segments.length > 0 ? buildTextTarget(segments) : null;
	const activeMarks = collectActiveMarks(state, from$1, to);
	const { commentIds: activeCommentIds, changeIds: activeChangeRawIds } = collectActiveEntityIds(state, from$1, to);
	const info = {
		empty: empty$1,
		target,
		activeMarks,
		activeCommentIds,
		activeChangeIds: mapRawChangeIdsToCanonical(editor, activeChangeRawIds)
	};
	if (input.includeText && !empty$1) info.text = state.doc.textBetween(from$1, to, " ");
	return info;
}
function buildTextTarget(segments) {
	return {
		kind: "text",
		segments
	};
}
function shouldProjectTextTarget(selection) {
	if (!selection || typeof selection !== "object") return false;
	if (selection instanceof NodeSelection) return false;
	if ("$anchorCell" in selection) return false;
	return true;
}
function collectTextSegments(doc$1, from$1, to) {
	const segments = [];
	let abort = false;
	doc$1.nodesBetween(from$1, to, (node, pos) => {
		if (abort) return false;
		if (!node.isTextblock) return true;
		const blockId = readBlockId(node);
		if (!blockId) {
			abort = true;
			return false;
		}
		const blockStart = pos + 1;
		const blockEnd = pos + node.nodeSize - 1;
		const selStart = Math.max(from$1, blockStart);
		const selEnd = Math.min(to, blockEnd);
		const start$1 = pmPositionToTextOffset(node, pos, selStart);
		const end$1 = Math.max(start$1, pmPositionToTextOffset(node, pos, selEnd));
		segments.push({
			blockId,
			range: {
				start: start$1,
				end: end$1
			}
		});
		return false;
	});
	if (abort) return null;
	return segments;
}
function readBlockId(node) {
	const attrs = node.attrs ?? {};
	const id = attrs.sdBlockId ?? attrs.id ?? attrs.blockId;
	return typeof id === "string" && id.length > 0 ? id : null;
}
function mapRawChangeIdsToCanonical(editor, rawIds) {
	if (rawIds.length === 0) return rawIds;
	let grouped;
	try {
		grouped = groupTrackedChanges(editor);
	} catch {
		return [];
	}
	const rawToCanonical = /* @__PURE__ */ new Map();
	for (const change of grouped) rawToCanonical.set(change.rawId, change.id);
	const seen = /* @__PURE__ */ new Set();
	const out = [];
	for (const raw of rawIds) {
		const canonical = rawToCanonical.get(raw);
		if (!canonical) continue;
		if (seen.has(canonical)) continue;
		seen.add(canonical);
		out.push(canonical);
	}
	return out;
}
function collectActiveEntityIds(state, from$1, to) {
	const commentIds = /* @__PURE__ */ new Set();
	const changeIds = /* @__PURE__ */ new Set();
	const collectFromMark = (markType, attrs) => {
		if (markType === COMMENT_MARK_NAME) {
			const id = resolveCommentIdFromAttrs(attrs ?? {});
			if (typeof id === "string" && id.length > 0) commentIds.add(id);
		} else if (TRACK_CHANGE_MARK_NAMES.has(markType)) {
			const id = attrs?.id;
			if (typeof id === "string" && id.length > 0) changeIds.add(id);
		}
	};
	if (from$1 === to) {
		if (state.storedMarks) for (const mark of state.storedMarks) collectFromMark(mark.type.name, mark.attrs);
		const $pos = state.doc.resolve(from$1);
		for (const mark of $pos.marks()) collectFromMark(mark.type.name, mark.attrs);
	} else state.doc.nodesBetween(from$1, to, (node, pos) => {
		if (!node.isText) return true;
		const start$1 = Math.max(pos, from$1);
		if (Math.min(pos + node.nodeSize, to) <= start$1) return false;
		for (const mark of node.marks) collectFromMark(mark.type.name, mark.attrs);
		return false;
	});
	return {
		commentIds: Array.from(commentIds),
		changeIds: Array.from(changeIds)
	};
}
function collectActiveMarks(state, from$1, to) {
	const names = /* @__PURE__ */ new Set();
	const stored = state.storedMarks;
	if (stored) for (const mark of stored) names.add(mark.type.name);
	if (from$1 === to) {
		const marks = state.doc.resolve(from$1).marks();
		for (const mark of marks) names.add(mark.type.name);
	} else {
		const common = markTypesPresentEverywhere(state.doc, from$1, to);
		for (const name of common) names.add(name);
	}
	return Array.from(names);
}
function markTypesPresentEverywhere(doc$1, from$1, to) {
	let common = null;
	let aborted = false;
	doc$1.nodesBetween(from$1, to, (node, pos) => {
		if (aborted) return false;
		if (!node.isText) return true;
		const start$1 = Math.max(pos, from$1);
		if (Math.min(pos + node.nodeSize, to) <= start$1) return false;
		const names = /* @__PURE__ */ new Set();
		for (const m$1 of node.marks) names.add(m$1.type.name);
		if (common === null) common = names;
		else {
			for (const name of common) if (!names.has(name)) common.delete(name);
			if (common.size === 0) aborted = true;
		}
		return false;
	});
	return common ?? /* @__PURE__ */ new Set();
}
function resolveLocatorToCandidate(editor, locator, operationName) {
	const hasTarget = locator.target != null;
	const hasNodeId = locator.nodeId != null;
	if (hasTarget && hasNodeId) throw new DocumentApiAdapterError("INVALID_TARGET", `${operationName}: cannot combine target and nodeId. Use exactly one locator mode.`, { fields: ["target", "nodeId"] });
	if (!hasTarget && !hasNodeId) throw new DocumentApiAdapterError("INVALID_TARGET", `${operationName}: requires either target or nodeId.`, { fields: ["target", "nodeId"] });
	const index = getBlockIndex(editor);
	const candidate = hasTarget ? findBlockById(index, locator.target) : findBlockByNodeIdOnly(index, locator.nodeId);
	if (!candidate) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `${operationName}: target was not found.`, { target: hasTarget ? locator.target : locator.nodeId });
	return candidate;
}
function resolveTableLocator(editor, locator, operationName) {
	const candidate = resolveLocatorToCandidate(editor, locator, operationName);
	if (candidate.nodeType !== "table") throw new DocumentApiAdapterError("INVALID_TARGET", `${operationName}: target resolved to "${candidate.nodeType}", expected "table".`, {
		actualNodeType: candidate.nodeType,
		nodeId: candidate.nodeId
	});
	return {
		candidate,
		address: toBlockAddress(candidate)
	};
}
function resolveTableCreateLocation(editor, location$1, operationName) {
	if (location$1.kind === "documentStart") return 0;
	if (location$1.kind === "documentEnd") return editor.state.doc.content.size;
	const index = getBlockIndex(editor);
	const loc = location$1;
	const target = loc.target != null ? findBlockById(index, loc.target) : findBlockByNodeIdOnly(index, loc.nodeId);
	if (!target) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `${operationName}: reference block for "${location$1.kind}" placement was not found.`, { location: location$1 });
	return location$1.kind === "before" ? target.pos : target.end;
}
function findLastCandidate(candidates, predicate) {
	for (let i = candidates.length - 1; i >= 0; i--) {
		const candidate = candidates[i];
		if (predicate(candidate)) return candidate;
	}
}
function resolveRowLocator(editor, input, operationName) {
	const candidate = resolveLocatorToCandidate(editor, input, operationName);
	if (candidate.nodeType === "tableRow") {
		if (input.rowIndex != null) throw new DocumentApiAdapterError("INVALID_TARGET", `${operationName}: rowIndex must not be provided when target is a row node. Either pass a table nodeId with rowIndex, or pass a row nodeId without rowIndex.`);
		const tableCandidate = findParentTable(getBlockIndex(editor), candidate);
		if (!tableCandidate) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `${operationName}: parent table for row was not found.`);
		const rowIdx = getRowIndex(tableCandidate, candidate.pos);
		return {
			table: {
				candidate: tableCandidate,
				address: toBlockAddress(tableCandidate)
			},
			rowNode: candidate.node,
			rowPos: candidate.pos,
			rowIndex: rowIdx
		};
	}
	if (candidate.nodeType !== "table") throw new DocumentApiAdapterError("INVALID_TARGET", `${operationName}: target resolved to "${candidate.nodeType}", expected "table" or "tableRow".`, {
		actualNodeType: candidate.nodeType,
		nodeId: candidate.nodeId
	});
	const table = {
		candidate,
		address: toBlockAddress(candidate)
	};
	if (input.rowIndex == null) throw new DocumentApiAdapterError("INVALID_TARGET", `${operationName}: rowIndex is required when target is a table.`);
	const rowCount = table.candidate.node.childCount;
	if (input.rowIndex < 0 || input.rowIndex >= rowCount) throw new DocumentApiAdapterError("INVALID_TARGET", `${operationName}: rowIndex ${input.rowIndex} is out of range (table has ${rowCount} rows).`);
	let rowPos = table.candidate.pos + 1;
	for (let i = 0; i < input.rowIndex; i++) rowPos += table.candidate.node.child(i).nodeSize;
	return {
		table,
		rowNode: table.candidate.node.child(input.rowIndex),
		rowPos,
		rowIndex: input.rowIndex
	};
}
function findParentTable(index, rowCandidate) {
	return findLastCandidate(index.candidates, (c) => c.nodeType === "table" && c.pos < rowCandidate.pos && c.end >= rowCandidate.end);
}
function getRowIndex(tableCandidate, rowPos) {
	let pos = tableCandidate.pos + 1;
	const tableNode = tableCandidate.node;
	for (let i = 0; i < tableNode.childCount; i++) {
		if (pos === rowPos) return i;
		pos += tableNode.child(i).nodeSize;
	}
	return 0;
}
function resolveCellLocator(editor, locator, operationName) {
	const candidate = resolveLocatorToCandidate(editor, locator, operationName);
	if (candidate.nodeType !== "tableCell") throw new DocumentApiAdapterError("INVALID_TARGET", `${operationName}: target resolved to "${candidate.nodeType}", expected "tableCell".`, {
		actualNodeType: candidate.nodeType,
		nodeId: candidate.nodeId
	});
	const tableCandidate = findLastCandidate(getBlockIndex(editor).candidates, (c) => c.nodeType === "table" && c.pos < candidate.pos && c.end >= candidate.end);
	if (!tableCandidate) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `${operationName}: parent table for cell was not found.`);
	const map$1 = TableMap.get(tableCandidate.node);
	const cellOffset = candidate.pos - tableCandidate.pos - 1;
	const mapIndex = map$1.map.indexOf(cellOffset);
	const rowIndex = Math.floor(mapIndex / map$1.width);
	const columnIndex = mapIndex % map$1.width;
	return {
		table: {
			candidate: tableCandidate,
			address: toBlockAddress(tableCandidate)
		},
		cellNode: candidate.node,
		cellPos: candidate.pos,
		rowIndex: rowIndex >= 0 ? rowIndex : 0,
		columnIndex: columnIndex >= 0 ? columnIndex : 0
	};
}
function resolveMergeRangeLocator(editor, input, operationName) {
	const table = resolveTableLocator(editor, input, operationName);
	const map$1 = TableMap.get(table.candidate.node);
	const startRow = Math.min(input.start.rowIndex, input.end.rowIndex);
	const endRow = Math.max(input.start.rowIndex, input.end.rowIndex);
	const startCol = Math.min(input.start.columnIndex, input.end.columnIndex);
	const endCol = Math.max(input.start.columnIndex, input.end.columnIndex);
	if (startRow < 0 || endRow >= map$1.height || startCol < 0 || endCol >= map$1.width) throw new DocumentApiAdapterError("INVALID_TARGET", `${operationName}: cell range is out of bounds (table is ${map$1.height}×${map$1.width}).`);
	return {
		table,
		startRow,
		startCol,
		endRow,
		endCol
	};
}
function resolveTableScopedCellLocator(editor, input, operationName) {
	const table = resolveTableLocator(editor, input, operationName);
	const map$1 = TableMap.get(table.candidate.node);
	if (input.rowIndex < 0 || input.rowIndex >= map$1.height || input.columnIndex < 0 || input.columnIndex >= map$1.width) throw new DocumentApiAdapterError("INVALID_TARGET", `${operationName}: cell (${input.rowIndex}, ${input.columnIndex}) is out of bounds (table is ${map$1.height}×${map$1.width}).`);
	const requestedIndex = input.rowIndex * map$1.width + input.columnIndex;
	const cellOffset = map$1.map[requestedIndex];
	const anchorIndex = map$1.map.indexOf(cellOffset);
	const anchorRow = Math.floor(anchorIndex / map$1.width);
	const anchorCol = anchorIndex % map$1.width;
	const cellPos = table.candidate.pos + 1 + cellOffset;
	const cellNode = table.candidate.node.nodeAt(cellOffset);
	if (!cellNode) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `${operationName}: cell at (${input.rowIndex}, ${input.columnIndex}) could not be resolved.`);
	return {
		table,
		cellNode,
		cellPos,
		rowIndex: anchorRow,
		columnIndex: anchorCol
	};
}
function resolveColumnLocator(editor, input, operationName) {
	const table = resolveTableLocator(editor, input, operationName);
	const columnCount = getTableColumnCount(table.candidate.node);
	if (input.columnIndex < 0 || input.columnIndex >= columnCount) throw new DocumentApiAdapterError("INVALID_TARGET", `${operationName}: columnIndex ${input.columnIndex} is out of range (table has ${columnCount} columns).`);
	return {
		table,
		columnIndex: input.columnIndex,
		columnCount
	};
}
function getTableColumnCount(tableNode) {
	if (tableNode.childCount === 0) return 0;
	const firstRow = tableNode.child(0);
	let count = 0;
	for (let i = 0; i < firstRow.childCount; i++) {
		const cell = firstRow.child(i);
		count += cell.attrs.colspan ?? 1;
	}
	return count;
}
function resolvePostMutationTableAddress(editor, preMutationPos, preMutationNodeId, tr) {
	const index = getBlockIndex(editor);
	const mappedPos = tr.mapping.map(preMutationPos);
	const candidate = index.candidates.find((c) => c.pos === mappedPos && c.nodeType === "table");
	if (candidate) return toBlockAddress(candidate);
	try {
		const found = findBlockByNodeIdOnly(index, preMutationNodeId);
		if (found.nodeType === "table") return toBlockAddress(found);
	} catch {}
}
function toTableFailure(code, message, details) {
	return {
		success: false,
		failure: {
			code,
			message,
			details
		}
	};
}
function syncExtractedTableAttrs(tp) {
	const extracted = {};
	extracted.tableStyleId = tp.tableStyleId ?? null;
	extracted.justification = tp.justification ?? null;
	extracted.tableLayout = tp.tableLayout ?? null;
	extracted.borders = convertTableBordersToPixelUnits(tp.borders) ?? {};
	const indent = tp.tableIndent;
	if (indent?.value != null) extracted.tableIndent = {
		width: twipsToPixels(indent.value),
		type: indent.type
	};
	else extracted.tableIndent = null;
	const spacing = tp.tableCellSpacing;
	if (spacing?.value != null) {
		extracted.tableCellSpacing = {
			value: twipsToPixels(spacing.value),
			type: spacing.type ?? "dxa"
		};
		extracted.borderCollapse = "separate";
	} else {
		extracted.tableCellSpacing = null;
		extracted.borderCollapse = null;
	}
	const width = tp.tableWidth;
	if (width) if (width.type === "pct" && typeof width.value === "number") extracted.tableWidth = {
		value: width.value,
		type: "pct"
	};
	else if (width.type === "auto") extracted.tableWidth = {
		width: 0,
		type: "auto"
	};
	else if (width.value != null) {
		const widthPx = twipsToPixels(width.value);
		extracted.tableWidth = widthPx != null ? {
			width: widthPx,
			type: width.type
		} : null;
	} else extracted.tableWidth = null;
	else extracted.tableWidth = null;
	return extracted;
}
function convertTableBordersToPixelUnits(value) {
	const clone$1 = cloneBorders(value);
	if (!clone$1 || Object.keys(clone$1).length === 0) return void 0;
	mapBorderSizes(clone$1, eighthPointsToPixels);
	return Object.keys(clone$1).length > 0 ? clone$1 : void 0;
}
function buildWidthAuthoringTableAttrs(currentAttrs, attrOverrides = {}, tablePropertyOverrides = {}) {
	const currentTableProps = currentAttrs.tableProperties ?? {};
	const nextTableWidth = resolveWidthAuthoringTableWidth(currentAttrs, attrOverrides, tablePropertyOverrides);
	const updatedTableProps = {
		...currentTableProps,
		...tablePropertyOverrides,
		tableLayout: "fixed"
	};
	if (nextTableWidth) updatedTableProps.tableWidth = nextTableWidth;
	else delete updatedTableProps.tableWidth;
	return {
		...currentAttrs,
		tableProperties: updatedTableProps,
		...attrOverrides,
		...syncExtractedTableAttrs(updatedTableProps),
		userEdited: true
	};
}
function resolveWidthAuthoringTableWidth(currentAttrs, attrOverrides, tablePropertyOverrides) {
	const explicitOverride = normalizeTableWidthMeasurement(tablePropertyOverrides.tableWidth);
	if (explicitOverride) return explicitOverride;
	const gridWidth = sumGridColumnTwips(attrOverrides.grid ?? currentAttrs.grid);
	if (gridWidth != null) return {
		value: gridWidth,
		type: "dxa"
	};
	return null;
}
function sumGridColumnTwips(grid) {
	const columns = normalizeGridColumns$1(grid);
	if (!columns || columns.length === 0) return null;
	const total = columns.reduce((sum, column) => sum + column.col, 0);
	return total > 0 ? total : null;
}
function normalizeGridColumns$1(grid) {
	if (Array.isArray(grid)) {
		const columns = grid.map((width) => normalizeGridWidth$1(width)).filter((width) => width != null);
		return columns.length > 0 ? columns : null;
	}
	if (grid && typeof grid === "object") {
		const rawColWidths = grid.colWidths;
		if (Array.isArray(rawColWidths)) {
			const columns = rawColWidths.map((width) => normalizeGridWidth$1(width)).filter((width) => width != null);
			return columns.length > 0 ? columns : null;
		}
	}
	return null;
}
function normalizeGridWidth$1(width) {
	if (typeof width === "number" && Number.isFinite(width) && width > 0) return { col: Math.round(width) };
	const value = width?.col;
	if (typeof value === "number" && Number.isFinite(value) && value > 0) return { col: Math.round(value) };
	return null;
}
function normalizeTableWidthMeasurement(width) {
	if (!width || typeof width !== "object") return null;
	const value = width.value;
	if (width.type !== "dxa" || typeof value !== "number" || !Number.isFinite(value) || value <= 0) return null;
	return {
		value: Math.round(value),
		type: "dxa"
	};
}
var POINTS_TO_PIXELS = 96 / 72;
var POINTS_TO_TWIPS = 20;
var PIXELS_TO_TWIPS = 1440 / 96;
var DEFAULT_TABLE_GRID_WIDTH_TWIPS = 1500;
var SETTINGS_PART$1 = "word/settings.xml";
function createSeparatorParagraph(schema) {
	const paragraphType = schema.nodes.paragraph;
	if (!paragraphType) return null;
	const separatorAttrs = {
		sdBlockId: v4_default(),
		paraId: generateDocxHexId()
	};
	return paragraphType.createAndFill(separatorAttrs) ?? paragraphType.createAndFill();
}
function buildTableSuccess(tableAddress, trackedChangeRefs) {
	return {
		success: true,
		table: tableAddress,
		trackedChangeRefs
	};
}
function normalizeGridWidth(width) {
	if (typeof width === "number" && Number.isFinite(width)) return { col: Math.round(width) };
	if (width && typeof width === "object") {
		const col = width.col;
		if (typeof col === "number" && Number.isFinite(col)) return { col: Math.round(col) };
	}
	return { col: DEFAULT_TABLE_GRID_WIDTH_TWIPS };
}
function normalizeGridColumns(grid) {
	if (Array.isArray(grid)) {
		if (grid.length === 0) return null;
		return {
			columns: grid.map((width) => normalizeGridWidth(width)),
			format: "array"
		};
	}
	if (grid && typeof grid === "object") {
		const rawColWidths = grid.colWidths;
		if (Array.isArray(rawColWidths) && rawColWidths.length > 0) return {
			columns: rawColWidths.map((width) => normalizeGridWidth(width)),
			format: "object"
		};
	}
	return null;
}
function serializeGridColumns(originalGrid, normalized) {
	if (normalized.format === "array") return normalized.columns;
	return {
		...originalGrid,
		colWidths: normalized.columns
	};
}
function insertGridColumnWidth(grid, insertIndex) {
	const normalized = normalizeGridColumns(grid);
	if (!normalized) return null;
	const colWidths = normalized.columns.slice();
	const boundedIndex = Math.max(0, Math.min(insertIndex, colWidths.length));
	const template = colWidths[Math.min(boundedIndex, colWidths.length - 1)] ?? colWidths[colWidths.length - 1] ?? normalizeGridWidth(null);
	colWidths.splice(boundedIndex, 0, { ...template });
	return serializeGridColumns(grid, {
		...normalized,
		columns: colWidths
	});
}
function removeGridColumnWidth(grid, deleteIndex) {
	const normalized = normalizeGridColumns(grid);
	if (!normalized || normalized.columns.length <= 1) return null;
	const colWidths = normalized.columns.slice();
	const boundedIndex = Math.max(0, Math.min(deleteIndex, colWidths.length - 1));
	colWidths.splice(boundedIndex, 1);
	return serializeGridColumns(grid, {
		...normalized,
		columns: colWidths
	});
}
function buildFirstRowCellWidthProps(attrs, cellStartCol, colspan, colwidth, gridColumns) {
	const currentCellProps = attrs.tableCellProperties && typeof attrs.tableCellProperties === "object" ? attrs.tableCellProperties : {};
	const spanTwips = resolveSpanWidthTwips(cellStartCol, colspan, colwidth, gridColumns);
	if (spanTwips == null) return Object.keys(currentCellProps).length > 0 ? currentCellProps : void 0;
	return {
		...currentCellProps,
		cellWidth: {
			value: spanTwips,
			type: "dxa"
		}
	};
}
function resolveSpanWidthTwips(cellStartCol, colspan, colwidth, gridColumns) {
	const boundedSpan = Math.max(1, colspan);
	if (Array.isArray(gridColumns) && cellStartCol >= 0 && cellStartCol + boundedSpan <= gridColumns.length) {
		const gridSpanTwips = gridColumns.slice(cellStartCol, cellStartCol + boundedSpan).reduce((sum, column) => sum + normalizeGridWidth(column).col, 0);
		if (gridSpanTwips > 0) return gridSpanTwips;
	}
	const spanWidthPx = colwidth.slice(0, boundedSpan).reduce((sum, width) => sum + (Number.isFinite(width) ? width : 0), 0);
	if (spanWidthPx > 0) return Math.round(spanWidthPx * PIXELS_TO_TWIPS);
}
function normalizeCellAttrsForSingleCell(attrs) {
	const currentColwidth = Array.isArray(attrs.colwidth) ? attrs.colwidth : null;
	const tableCellProperties = { ...attrs.tableCellProperties ?? {} };
	delete tableCellProperties.gridSpan;
	delete tableCellProperties.vMerge;
	return {
		...attrs,
		colspan: 1,
		rowspan: 1,
		colwidth: currentColwidth && currentColwidth.length > 0 ? [currentColwidth[0] ?? 0] : currentColwidth,
		tableCellProperties
	};
}
function stripMergeMetadataFromTableCellProperties(attrs) {
	const { gridSpan: _g, vMerge: _v, ...cleanedTcp } = attrs.tableCellProperties ?? {};
	return {
		...attrs,
		tableCellProperties: cleanedTcp
	};
}
function normalizeClonedRowInsertCellAttrs(sourceAttrs, fromHeaderToBody) {
	const normalizedAttrs = {
		...sourceAttrs,
		rowspan: 1
	};
	if (fromHeaderToBody && normalizedAttrs.borders == null) delete normalizedAttrs.borders;
	return normalizedAttrs;
}
function normalizeClonedColumnInsertCellAttrs(sourceAttrs) {
	const normalizedAttrs = {
		...stripMergeMetadataFromTableCellProperties(sourceAttrs),
		colspan: 1,
		rowspan: 1
	};
	if (Array.isArray(normalizedAttrs.colwidth)) delete normalizedAttrs.colwidth;
	return normalizedAttrs;
}
function expandMergedCellIntoSingles({ tr, tablePos, tableNode, cellPos, cellNode, rowIndex, columnIndex, rowspan, colspan, schema }) {
	const tableStart = tablePos + 1;
	const map$1 = TableMap.get(tableNode);
	const resetCell = cellNode.type.create(normalizeCellAttrsForSingleCell(cellNode.attrs), cellNode.content);
	tr.replaceWith(cellPos, cellPos + cellNode.nodeSize, resetCell);
	const mapFrom = tr.mapping.maps.length;
	for (let row = rowIndex + rowspan - 1; row >= rowIndex; row--) for (let col = columnIndex + colspan - 1; col >= columnIndex; col--) {
		if (row === rowIndex && col === columnIndex) continue;
		const newCell = schema.nodes.tableCell.createAndFill();
		let insertRelPos;
		if (row === rowIndex) insertRelPos = map$1.positionAt(rowIndex, columnIndex, tableNode) + resetCell.nodeSize;
		else insertRelPos = map$1.positionAt(row, col, tableNode);
		tr.insert(tr.mapping.slice(mapFrom).map(tableStart + insertRelPos), newCell);
	}
}
function isBoundaryEdge(edge) {
	return edge === "top" || edge === "bottom" || edge === "left" || edge === "right" || edge === "insideH" || edge === "insideV";
}
function cellSidesForEdge(edge, row, col, lastRow, lastCol) {
	switch (edge) {
		case "top": return row === 0 ? ["top"] : [];
		case "bottom": return row === lastRow ? ["bottom"] : [];
		case "left": return col === 0 ? ["left"] : [];
		case "right": return col === lastCol ? ["right"] : [];
		case "insideH": return [row < lastRow ? "bottom" : null, row > 0 ? "top" : null].filter((side) => side != null);
		case "insideV": return [col < lastCol ? "right" : null, col > 0 ? "left" : null].filter((side) => side != null);
		default: return [];
	}
}
function tableBorderToCellBorder(border) {
	const val = typeof border.val === "string" ? border.val : "single";
	const color = typeof border.color === "string" ? border.color : "auto";
	const size$1 = typeof border.size === "number" ? border.size : 0;
	return {
		val,
		color,
		size: val === "none" || val === "nil" ? 0 : size$1,
		space: 0
	};
}
function applyTableEdgeToCellBorders(tr, tablePos, tableNode, edge, borderSpec) {
	const map$1 = TableMap.get(tableNode);
	const tableStart = tablePos + 1;
	const seen = /* @__PURE__ */ new Set();
	const mapFrom = tr.mapping.maps.length;
	const lastRow = map$1.height - 1;
	const lastCol = map$1.width - 1;
	const cellBorder = tableBorderToCellBorder(borderSpec);
	for (let row = 0; row < map$1.height; row++) for (let col = 0; col < map$1.width; col++) {
		const relPos = map$1.map[row * map$1.width + col];
		if (seen.has(relPos)) continue;
		seen.add(relPos);
		const targetSides = cellSidesForEdge(edge, row, col, lastRow, lastCol);
		if (targetSides.length === 0) continue;
		const cellNode = tableNode.nodeAt(relPos);
		if (!cellNode) continue;
		const cellAttrs = cellNode.attrs;
		const tcp = { ...cellAttrs.tableCellProperties ?? {} };
		const borders = { ...tcp.borders ?? {} };
		for (const side of targetSides) borders[side] = { ...cellBorder };
		tcp.borders = borders;
		tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(tableStart + relPos), null, {
			...cellAttrs,
			borders: null,
			tableCellProperties: tcp
		});
	}
}
function applyTableBorderPresetToCellBorders(tr, tablePos, tableNode, preset) {
	if (preset === "custom") return;
	const map$1 = TableMap.get(tableNode);
	const tableStart = tablePos + 1;
	const seen = /* @__PURE__ */ new Set();
	const mapFrom = tr.mapping.maps.length;
	const lastRow = map$1.height - 1;
	const lastCol = map$1.width - 1;
	const noneBorder = tableBorderToCellBorder({
		val: "none",
		color: "auto",
		size: 0
	});
	const singleBorder = tableBorderToCellBorder({
		val: "single",
		color: "000000",
		size: 4
	});
	for (let row = 0; row < map$1.height; row++) for (let col = 0; col < map$1.width; col++) {
		const relPos = map$1.map[row * map$1.width + col];
		if (seen.has(relPos)) continue;
		seen.add(relPos);
		const cellNode = tableNode.nodeAt(relPos);
		if (!cellNode) continue;
		const cellAttrs = cellNode.attrs;
		const tcp = { ...cellAttrs.tableCellProperties ?? {} };
		const borders = { ...tcp.borders ?? {} };
		if (preset === "none") {
			borders.top = { ...noneBorder };
			borders.bottom = { ...noneBorder };
			borders.left = { ...noneBorder };
			borders.right = { ...noneBorder };
		} else if (preset === "box") {
			borders.top = row === 0 ? { ...singleBorder } : { ...noneBorder };
			borders.bottom = row === lastRow ? { ...singleBorder } : { ...noneBorder };
			borders.left = col === 0 ? { ...singleBorder } : { ...noneBorder };
			borders.right = col === lastCol ? { ...singleBorder } : { ...noneBorder };
		} else {
			borders.top = { ...singleBorder };
			borders.bottom = { ...singleBorder };
			borders.left = { ...singleBorder };
			borders.right = { ...singleBorder };
		}
		tcp.borders = borders;
		tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(tableStart + relPos), null, {
			...cellAttrs,
			borders: null,
			tableCellProperties: tcp
		});
	}
}
var PRESET_GREY = "999999";
var PRESET_BLACK = "000000";
var STATIC_PRESETS = {
	grid: {
		borders: {
			top: {
				lineStyle: "single",
				lineWeightPt: 1,
				color: PRESET_BLACK
			},
			bottom: {
				lineStyle: "single",
				lineWeightPt: 1,
				color: PRESET_BLACK
			},
			left: {
				lineStyle: "single",
				lineWeightPt: 1,
				color: PRESET_BLACK
			},
			right: {
				lineStyle: "single",
				lineWeightPt: 1,
				color: PRESET_BLACK
			},
			insideH: {
				lineStyle: "single",
				lineWeightPt: 1,
				color: PRESET_BLACK
			},
			insideV: {
				lineStyle: "single",
				lineWeightPt: 1,
				color: PRESET_BLACK
			}
		},
		styleOptions: {},
		headerRowFill: null
	},
	minimal: {
		borders: {
			top: null,
			left: null,
			right: null,
			insideV: null,
			insideH: {
				lineStyle: "single",
				lineWeightPt: .25,
				color: PRESET_GREY
			},
			bottom: {
				lineStyle: "single",
				lineWeightPt: 1,
				color: PRESET_BLACK
			}
		},
		styleOptions: {},
		headerRowFill: null
	},
	striped: {
		borders: {
			top: {
				lineStyle: "single",
				lineWeightPt: .5,
				color: PRESET_GREY
			},
			bottom: {
				lineStyle: "single",
				lineWeightPt: .5,
				color: PRESET_GREY
			},
			left: {
				lineStyle: "single",
				lineWeightPt: .5,
				color: PRESET_GREY
			},
			right: {
				lineStyle: "single",
				lineWeightPt: .5,
				color: PRESET_GREY
			},
			insideH: {
				lineStyle: "single",
				lineWeightPt: .5,
				color: PRESET_GREY
			},
			insideV: {
				lineStyle: "single",
				lineWeightPt: .5,
				color: PRESET_GREY
			}
		},
		styleOptions: { bandedRows: true },
		headerRowFill: null
	}
};
function buildPresetSpec(preset, accentColorInput) {
	if (preset === "accent") {
		const accentColor = normalizeColorInput(accentColorInput ?? "1F3864");
		return {
			borders: {
				top: {
					lineStyle: "single",
					lineWeightPt: 2,
					color: accentColor
				},
				bottom: {
					lineStyle: "single",
					lineWeightPt: 2,
					color: accentColor
				},
				left: null,
				right: null,
				insideV: null,
				insideH: {
					lineStyle: "single",
					lineWeightPt: .5,
					color: PRESET_GREY
				}
			},
			styleOptions: { headerRow: true },
			headerRowFill: accentColor
		};
	}
	return STATIC_PRESETS[preset] ?? null;
}
function applyShadingToCells(tr, tableNode, tableStart, fill, cellPositions) {
	const map$1 = TableMap.get(tableNode);
	const positions = cellPositions ?? map$1.map;
	const seen = /* @__PURE__ */ new Set();
	const mapFrom = tr.mapping.maps.length;
	for (const relPos of positions) {
		if (seen.has(relPos)) continue;
		seen.add(relPos);
		const cellNode = tableNode.nodeAt(relPos);
		if (!cellNode) continue;
		const cellAttrs = cellNode.attrs;
		const cellProps = { ...cellAttrs.tableCellProperties ?? {} };
		cellProps.shading = {
			fill,
			val: "clear",
			color: "auto"
		};
		const nextCellAttrs = {
			...cellAttrs,
			tableCellProperties: cellProps
		};
		if (fill === "auto") delete nextCellAttrs.background;
		else nextCellAttrs.background = { color: fill };
		tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(tableStart + relPos), null, nextCellAttrs);
	}
}
function removeColSpan(attrs, pos, n = 1) {
	const result = {
		...attrs,
		colspan: (attrs.colspan || 1) - n
	};
	if (result.colwidth) {
		result.colwidth = result.colwidth.slice();
		result.colwidth.splice(pos, n);
		if (!result.colwidth.some((w) => w > 0)) result.colwidth = null;
	}
	return result;
}
function addColSpan(attrs, pos, n = 1) {
	const result = {
		...attrs,
		colspan: (attrs.colspan || 1) + n
	};
	if (result.colwidth) {
		result.colwidth = result.colwidth.slice();
		for (let i = 0; i < n; i++) result.colwidth.splice(pos, 0, 0);
	}
	return result;
}
function isHeaderColumn(tableNode, map$1, col) {
	for (let row = 0; row < map$1.height; row++) {
		const cell = tableNode.nodeAt(map$1.map[col + row * map$1.width]);
		if (!cell || cell.type.name !== "tableHeader") return false;
	}
	return true;
}
function resolveInsertedColumnCellType(tableNode, map$1, index, col) {
	let refColumn = col > 0 ? -1 : 0;
	if (isHeaderColumn(tableNode, map$1, col + refColumn)) refColumn = col === 0 || col === map$1.width ? null : 0;
	if (refColumn == null) return tableNode.type.schema.nodes.tableCell ?? null;
	const refPos = map$1.map[index + refColumn];
	return refPos != null ? tableNode.nodeAt(refPos)?.type ?? null : null;
}
function addColumnToTable(tr, tablePos, col) {
	const tableNode = tr.doc.nodeAt(tablePos);
	if (!tableNode || tableNode.type.name !== "table") return;
	const map$1 = TableMap.get(tableNode);
	const tableStart = tablePos + 1;
	const mapStart = tr.mapping.maps.length;
	const sourceCol = col > 0 ? col - 1 : map$1.width > 0 ? 0 : -1;
	for (let row = 0; row < map$1.height; row++) {
		const index = row * map$1.width + col;
		if (col > 0 && col < map$1.width && map$1.map[index - 1] === map$1.map[index]) {
			const pos = map$1.map[index];
			const cell = tableNode.nodeAt(pos);
			if (!cell) continue;
			tr.setNodeMarkup(tr.mapping.slice(mapStart).map(tableStart + pos), null, addColSpan(cell.attrs, col - map$1.colCount(pos)));
			row += (cell.attrs.rowspan || 1) - 1;
		} else {
			const refType = resolveInsertedColumnCellType(tableNode, map$1, index, col);
			if (!refType) continue;
			let clonedAttrs = null;
			if (sourceCol >= 0) {
				const sourceIdx = row * map$1.width + sourceCol;
				const sourcePos = map$1.map[sourceIdx];
				if (sourcePos != null) {
					const sourceCell = tableNode.nodeAt(sourcePos);
					if (sourceCell) clonedAttrs = normalizeClonedColumnInsertCellAttrs(sourceCell.attrs);
				}
			}
			const cellPos = map$1.positionAt(row, col, tableNode);
			const newCell = refType.createAndFill(clonedAttrs ?? void 0);
			if (!newCell) continue;
			tr.insert(tr.mapping.slice(mapStart).map(tableStart + cellPos), newCell);
		}
	}
}
function removeColumnFromTable(tr, tablePos, col) {
	const tableNode = tr.doc.nodeAt(tablePos);
	if (!tableNode || tableNode.type.name !== "table") return;
	const map$1 = TableMap.get(tableNode);
	const tableStart = tablePos + 1;
	const mapStart = tr.mapping.maps.length;
	for (let row = 0; row < map$1.height;) {
		const index = row * map$1.width + col;
		const pos = map$1.map[index];
		const cell = tableNode.nodeAt(pos);
		if (!cell) {
			row++;
			continue;
		}
		const attrs = cell.attrs;
		const rowspan = attrs.rowspan || 1;
		if (col > 0 && map$1.map[index - 1] === pos || col < map$1.width - 1 && map$1.map[index + 1] === pos) tr.setNodeMarkup(tr.mapping.slice(mapStart).map(tableStart + pos), null, removeColSpan(attrs, col - map$1.colCount(pos)));
		else {
			const start$1 = tr.mapping.slice(mapStart).map(tableStart + pos);
			tr.delete(start$1, start$1 + cell.nodeSize);
		}
		row += rowspan;
	}
}
function insertRowInTable(tr, tablePos, sourceRowIndex, insertIndex, schema) {
	const tableNode = tr.doc.nodeAt(tablePos);
	if (!tableNode || tableNode.type.name !== "table") return false;
	const rowCount = tableNode.childCount;
	if (rowCount === 0) return false;
	const map$1 = TableMap.get(tableNode);
	const boundedInsertIndex = Math.max(0, Math.min(insertIndex, rowCount));
	const boundedSourceRowIndex = Math.max(0, Math.min(sourceRowIndex, rowCount - 1));
	const sourceRow = tableNode.child(boundedSourceRowIndex);
	if (!sourceRow) return false;
	const rowType = schema.nodes.tableRow;
	const defaultCellType = schema.nodes.tableCell;
	if (!rowType || !defaultCellType) return false;
	const newCells = [];
	const cellsToExtend = [];
	for (let col = 0; col < map$1.width;) {
		if (boundedInsertIndex > 0 && boundedInsertIndex < map$1.height) {
			const indexAbove = (boundedInsertIndex - 1) * map$1.width + col;
			const indexAtInsert = boundedInsertIndex * map$1.width + col;
			if (map$1.map[indexAbove] === map$1.map[indexAtInsert]) {
				const spanningPos = map$1.map[indexAbove];
				const spanningCell = tableNode.nodeAt(spanningPos);
				if (spanningCell) {
					const spanningAttrs = spanningCell.attrs;
					const rowspan = spanningAttrs.rowspan || 1;
					const colspan$1 = spanningAttrs.colspan || 1;
					cellsToExtend.push({
						pos: tablePos + 1 + spanningPos,
						attrs: {
							...spanningAttrs,
							rowspan: rowspan + 1
						}
					});
					col += colspan$1;
					continue;
				}
			}
		}
		const sourceMapIndex = boundedSourceRowIndex * map$1.width + col;
		const sourceCellPos = map$1.map[sourceMapIndex];
		const sourceCell = tableNode.nodeAt(sourceCellPos) ?? sourceRow.firstChild;
		if (!sourceCell) {
			col += 1;
			continue;
		}
		const colspan = sourceCell.attrs.colspan || 1;
		const fromHeaderToBody = sourceCell.type.name === "tableHeader";
		const newCell = (fromHeaderToBody ? defaultCellType : sourceCell.type).createAndFill(normalizeClonedRowInsertCellAttrs(sourceCell.attrs, fromHeaderToBody));
		if (newCell) newCells.push(newCell);
		col += colspan;
	}
	for (const { pos, attrs } of cellsToExtend) tr.setNodeMarkup(pos, null, attrs);
	if (newCells.length === 0) return true;
	const newRow = rowType.createAndFill(null, newCells);
	if (!newRow) return false;
	let insertPos = tablePos + 1;
	for (let row = 0; row < boundedInsertIndex; row++) insertPos += tableNode.child(row).nodeSize;
	tr.insert(insertPos, newRow);
	return true;
}
function addColumnToTableForSplit(tr, tablePos, col, splitRowStart, splitRowEnd) {
	const tableNode = tr.doc.nodeAt(tablePos);
	if (!tableNode || tableNode.type.name !== "table") return;
	const map$1 = TableMap.get(tableNode);
	const tableStart = tablePos + 1;
	const mapStart = tr.mapping.maps.length;
	const widenedOutsideSplit = /* @__PURE__ */ new Set();
	for (let row = 0; row < map$1.height; row++) {
		const index = row * map$1.width + col;
		const pos = map$1.map[index];
		const cell = tableNode.nodeAt(pos);
		if (!cell) continue;
		if (!(row >= splitRowStart && row < splitRowEnd) && col > 0) {
			const leftPos = map$1.map[index - 1];
			const leftCell = tableNode.nodeAt(leftPos);
			if (leftCell && !widenedOutsideSplit.has(leftPos)) {
				tr.setNodeMarkup(tr.mapping.slice(mapStart).map(tableStart + leftPos), null, addColSpan(leftCell.attrs, col - map$1.colCount(leftPos)));
				widenedOutsideSplit.add(leftPos);
			}
			row += (cell.attrs?.rowspan || 1) - 1;
			continue;
		}
		if (col > 0 && map$1.map[index - 1] === pos) {
			tr.setNodeMarkup(tr.mapping.slice(mapStart).map(tableStart + pos), null, addColSpan(cell.attrs, col - map$1.colCount(pos)));
			row += (cell.attrs.rowspan || 1) - 1;
		} else {
			const refType = col > 0 ? tableNode.nodeAt(map$1.map[index - 1])?.type ?? cell.type : cell.type;
			const cellPos = map$1.positionAt(row, col, tableNode);
			tr.insert(tr.mapping.slice(mapStart).map(tableStart + cellPos), refType.createAndFill());
			row += (cell.attrs?.rowspan || 1) - 1;
		}
	}
}
function insertRowInTableForSplit(tr, tablePos, sourceRowIndex, insertIndex, splitColStart, splitColEnd, schema) {
	const tableNode = tr.doc.nodeAt(tablePos);
	if (!tableNode || tableNode.type.name !== "table") return false;
	const rowCount = tableNode.childCount;
	if (rowCount === 0) return false;
	const map$1 = TableMap.get(tableNode);
	const boundedInsertIndex = Math.max(0, Math.min(insertIndex, rowCount));
	const boundedSourceRowIndex = Math.max(0, Math.min(sourceRowIndex, rowCount - 1));
	const sourceRow = tableNode.child(boundedSourceRowIndex);
	if (!sourceRow) return false;
	const rowType = schema.nodes.tableRow;
	const defaultCellType = schema.nodes.tableCell;
	if (!rowType || !defaultCellType) return false;
	const newCells = [];
	const cellsToExtend = /* @__PURE__ */ new Map();
	for (let col = 0; col < map$1.width;) {
		if (boundedInsertIndex > 0 && boundedInsertIndex < map$1.height) {
			const indexAbove = (boundedInsertIndex - 1) * map$1.width + col;
			const indexAtInsert = boundedInsertIndex * map$1.width + col;
			if (map$1.map[indexAbove] === map$1.map[indexAtInsert]) {
				const spanningPos = map$1.map[indexAbove];
				const spanningCell = tableNode.nodeAt(spanningPos);
				if (spanningCell) {
					const spanningAttrs = spanningCell.attrs;
					const rowspan = spanningAttrs.rowspan || 1;
					const colspan$1 = spanningAttrs.colspan || 1;
					cellsToExtend.set(tablePos + 1 + spanningPos, {
						...spanningAttrs,
						rowspan: rowspan + 1
					});
					col += colspan$1;
					continue;
				}
			}
		}
		const sourceMapIndex = boundedSourceRowIndex * map$1.width + col;
		const sourceCellPos = map$1.map[sourceMapIndex];
		const sourceCell = tableNode.nodeAt(sourceCellPos) ?? sourceRow.firstChild;
		if (!sourceCell) {
			col += 1;
			continue;
		}
		const sourceAttrs = sourceCell.attrs;
		const colspan = sourceAttrs.colspan || 1;
		if (!(col < splitColEnd && col + colspan > splitColStart)) {
			const sourceRowspan = sourceAttrs.rowspan || 1;
			cellsToExtend.set(tablePos + 1 + sourceCellPos, {
				...sourceAttrs,
				rowspan: sourceRowspan + 1
			});
			col += colspan;
			continue;
		}
		const fromHeaderToBody = sourceCell.type.name === "tableHeader";
		const newCell = (fromHeaderToBody ? defaultCellType : sourceCell.type).createAndFill(normalizeClonedRowInsertCellAttrs(sourceAttrs, fromHeaderToBody));
		if (newCell) newCells.push(newCell);
		col += colspan;
	}
	for (const [pos, attrs] of cellsToExtend.entries()) tr.setNodeMarkup(pos, null, attrs);
	if (newCells.length === 0) return true;
	const newRow = rowType.createAndFill(null, newCells);
	if (!newRow) return false;
	let insertPos = tablePos + 1;
	for (let row = 0; row < boundedInsertIndex; row++) insertPos += tableNode.child(row).nodeSize;
	tr.insert(insertPos, newRow);
	return true;
}
function tablesDeleteAdapter(editor, input, options) {
	const mode = options?.changeMode ?? "direct";
	if (mode === "tracked") ensureTrackedCapability(editor, { operation: "tables.delete" });
	const { candidate } = resolveTableLocator(editor, input, "tables.delete");
	if (options?.dryRun) return buildTableSuccess();
	try {
		const tr = editor.state.tr;
		tr.delete(candidate.pos, candidate.end);
		if (mode === "tracked") applyTrackedMutationMeta(tr);
		else applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess();
	} catch {
		return toTableFailure("INVALID_TARGET", "Table deletion could not be applied.");
	}
}
function tablesClearContentsAdapter(editor, input, options) {
	rejectTrackedMode("tables.clearContents", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.clearContents");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const tr = editor.state.tr;
		const tableNode = candidate.node;
		const tableStart = candidate.pos;
		const emptyParagraph = editor.state.schema.nodes.paragraph?.createAndFill();
		if (!emptyParagraph) return toTableFailure("INVALID_TARGET", "Cannot create empty paragraph for cell replacement.");
		const replacements = [];
		tableNode.forEach((row, rowOffset) => {
			row.forEach((cell, cellOffset) => {
				const cellStart = tableStart + 1 + rowOffset + 1 + cellOffset + 1;
				const cellEnd = cellStart + cell.content.size;
				replacements.push({
					from: cellStart,
					to: cellEnd
				});
			});
		});
		for (let i = replacements.length - 1; i >= 0; i--) {
			const { from: from$1, to } = replacements[i];
			tr.replaceWith(from$1, to, emptyParagraph);
		}
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Table content clearing could not be applied.");
	}
}
function tablesMoveAdapter(editor, input, options) {
	rejectTrackedMode("tables.move", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.move");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const tr = editor.state.tr;
		const tableSlice = candidate.node;
		const tablePos = candidate.pos;
		const tableEnd = candidate.end;
		const destPos = resolveTableCreateLocation(editor, input.destination, "tables.move");
		tr.delete(tablePos, tableEnd);
		const mappedDest = tr.mapping.map(destPos);
		tr.insert(mappedDest, tableSlice);
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		let freshAddress = resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr);
		if (!freshAddress) {
			const sdBlockId = tableSlice.attrs.sdBlockId;
			if (typeof sdBlockId === "string") {
				const found = getBlockIndex(editor).candidates.find((c) => c.nodeType === "table" && c.node.attrs.sdBlockId === sdBlockId);
				if (found) freshAddress = toBlockAddress(found);
			}
		}
		return buildTableSuccess(freshAddress);
	} catch {
		return toTableFailure("INVALID_TARGET", "Table move could not be applied.");
	}
}
function tablesSetLayoutAdapter(editor, input, options) {
	rejectTrackedMode("tables.setLayout", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.setLayout");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const tr = editor.state.tr;
		const currentAttrs = candidate.node.attrs;
		const updatedTableProps = { ...currentAttrs.tableProperties ?? {} };
		if (input.preferredWidth !== void 0) updatedTableProps.tableWidth = {
			value: input.preferredWidth,
			type: "dxa"
		};
		if (input.alignment !== void 0) updatedTableProps.justification = input.alignment;
		if (input.leftIndentPt !== void 0) updatedTableProps.tableIndent = {
			value: Math.round(input.leftIndentPt * 20),
			type: "dxa"
		};
		if (input.autoFitMode !== void 0) if (input.autoFitMode === "fixedWidth") updatedTableProps.tableLayout = "fixed";
		else if (input.autoFitMode === "fitWindow") {
			updatedTableProps.tableLayout = "autofit";
			updatedTableProps.tableWidth = {
				value: 5e3,
				type: "pct"
			};
		} else updatedTableProps.tableLayout = "autofit";
		if (input.tableDirection !== void 0) updatedTableProps.rightToLeft = input.tableDirection === "rtl";
		tr.setNodeMarkup(candidate.pos, null, {
			...currentAttrs,
			tableProperties: updatedTableProps,
			...syncExtractedTableAttrs(updatedTableProps)
		});
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Table layout update could not be applied.");
	}
}
function tablesSetAltTextAdapter(editor, input, options) {
	rejectTrackedMode("tables.setAltText", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.setAltText");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const tr = editor.state.tr;
		const currentAttrs = candidate.node.attrs;
		const updatedTableProps = { ...currentAttrs.tableProperties ?? {} };
		if (input.title !== void 0) updatedTableProps.caption = input.title;
		if (input.description !== void 0) updatedTableProps.description = input.description;
		tr.setNodeMarkup(candidate.pos, null, {
			...currentAttrs,
			tableProperties: updatedTableProps,
			...syncExtractedTableAttrs(updatedTableProps)
		});
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Table alt text update could not be applied.");
	}
}
function tablesInsertRowAdapter(editor, input, options) {
	const mode = options?.changeMode ?? "direct";
	if (mode === "tracked") ensureTrackedCapability(editor, { operation: "tables.insertRow" });
	let normalizedInput = input;
	const inputAny = input;
	if (inputAny.rowIndex == null && inputAny.position == null) {
		const lastIndex = resolveTableLocator(editor, input, "tables.insertRow").candidate.node.childCount - 1;
		normalizedInput = {
			...input,
			rowIndex: lastIndex,
			position: "below"
		};
	}
	const { table, rowIndex } = resolveRowLocator(editor, normalizedInput, "tables.insertRow");
	if (options?.dryRun) return buildTableSuccess(table.address);
	try {
		const tr = editor.state.tr;
		const tablePos = table.candidate.pos;
		const normalizedAny = normalizedInput;
		const count = normalizedAny.count ?? 1;
		const position = normalizedAny.position ?? "below";
		const schema = editor.state.schema;
		for (let i = 0; i < count; i++) {
			const currentTableNode = tr.doc.nodeAt(tablePos);
			if (!currentTableNode || currentTableNode.type.name !== "table") break;
			const insertIdx = position === "above" ? rowIndex + i : rowIndex + 1 + i;
			const sourceIdx = position === "above" ? rowIndex + i : rowIndex;
			if (!insertRowInTable(tr, tablePos, Math.min(sourceIdx, currentTableNode.childCount - 1), Math.min(insertIdx, currentTableNode.childCount), schema)) return toTableFailure("INVALID_TARGET", "Row insertion could not be applied.");
		}
		if (mode === "tracked") applyTrackedMutationMeta(tr);
		else applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, table.candidate.pos, table.address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Row insertion could not be applied.");
	}
}
function tablesDeleteRowAdapter(editor, input, options) {
	const mode = options?.changeMode ?? "direct";
	if (mode === "tracked") ensureTrackedCapability(editor, { operation: "tables.deleteRow" });
	const { table, rowIndex, rowNode, rowPos } = resolveRowLocator(editor, input, "tables.deleteRow");
	const tableNode = table.candidate.node;
	const tableStart = table.candidate.pos + 1;
	if (tableNode.childCount <= 1) return toTableFailure("NO_OP", "Cannot delete the last row of a table.");
	if (options?.dryRun) return buildTableSuccess(table.address);
	try {
		const tr = editor.state.tr;
		const map$1 = TableMap.get(tableNode);
		const nextRowPos = rowPos + rowNode.nodeSize;
		const mapFrom = tr.mapping.maps.length;
		tr.delete(rowPos, nextRowPos);
		const seen = /* @__PURE__ */ new Set();
		for (let col = 0, index = rowIndex * map$1.width; col < map$1.width; col++, index++) {
			const pos = map$1.map[index];
			if (seen.has(pos)) continue;
			seen.add(pos);
			const cell = tableNode.nodeAt(pos);
			if (!cell) continue;
			const attrs = cell.attrs;
			const rowspan = attrs.rowspan || 1;
			const colspan = attrs.colspan || 1;
			if (rowIndex > 0 && pos === map$1.map[index - map$1.width]) {
				tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(tableStart + pos), null, {
					...attrs,
					rowspan: rowspan - 1
				});
				col += colspan - 1;
			} else if (rowIndex < map$1.height - 1 && pos === map$1.map[index + map$1.width]) {
				const copy = cell.type.create({
					...attrs,
					rowspan: rowspan - 1
				}, cell.content);
				const newPos = map$1.positionAt(rowIndex + 1, col, tableNode);
				tr.insert(tr.mapping.slice(mapFrom).map(tableStart + newPos), copy);
				col += colspan - 1;
			}
		}
		if (mode === "tracked") applyTrackedMutationMeta(tr);
		else applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, table.candidate.pos, table.address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Row deletion could not be applied.");
	}
}
function tablesSetRowHeightAdapter(editor, input, options) {
	rejectTrackedMode("tables.setRowHeight", options);
	const { table, rowPos, rowNode } = resolveRowLocator(editor, input, "tables.setRowHeight");
	if (options?.dryRun) return buildTableSuccess(table.address);
	try {
		const tr = editor.state.tr;
		const currentAttrs = rowNode.attrs;
		const currentRowProps = currentAttrs.tableRowProperties ?? {};
		const heightTwips = Math.round(input.heightPt * POINTS_TO_TWIPS);
		const heightPx = Math.round(input.heightPt * POINTS_TO_PIXELS);
		const updatedRowProps = {
			...currentRowProps,
			rowHeight: {
				value: heightTwips,
				rule: input.rule
			}
		};
		const newAttrs = {
			...currentAttrs,
			rowHeight: heightPx,
			tableRowProperties: updatedRowProps
		};
		tr.setNodeMarkup(rowPos, null, newAttrs);
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, table.candidate.pos, table.address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Row height update could not be applied.");
	}
}
function tablesDistributeRowsAdapter(editor, input, options) {
	rejectTrackedMode("tables.distributeRows", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.distributeRows");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const tr = editor.state.tr;
		const tableNode = candidate.node;
		const tablePos = candidate.pos;
		let totalHeight = 0;
		let explicitCount = 0;
		for (let i = 0; i < tableNode.childCount; i++) {
			const height = tableNode.child(i).attrs.rowHeight;
			if (height != null && height > 0) {
				totalHeight += height;
				explicitCount++;
			}
		}
		if (explicitCount === 0) return buildTableSuccess(address);
		const avgHeight = Math.round(totalHeight / tableNode.childCount);
		let rowPos = tablePos + 1;
		for (let i = 0; i < tableNode.childCount; i++) {
			const row = tableNode.child(i);
			const currentAttrs = row.attrs;
			const currentRowProps = currentAttrs.tableRowProperties ?? {};
			const heightTwips = Math.round(avgHeight * PIXELS_TO_TWIPS);
			tr.setNodeMarkup(rowPos, null, {
				...currentAttrs,
				rowHeight: avgHeight,
				tableRowProperties: {
					...currentRowProps,
					rowHeight: {
						value: heightTwips,
						rule: currentRowProps.rowHeight?.rule ?? "atLeast"
					}
				}
			});
			rowPos += row.nodeSize;
		}
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Row distribution could not be applied.");
	}
}
function tablesSetRowOptionsAdapter(editor, input, options) {
	rejectTrackedMode("tables.setRowOptions", options);
	const { table, rowPos, rowNode } = resolveRowLocator(editor, input, "tables.setRowOptions");
	if (options?.dryRun) return buildTableSuccess(table.address);
	try {
		const tr = editor.state.tr;
		const currentAttrs = rowNode.attrs;
		const currentRowProps = currentAttrs.tableRowProperties ?? {};
		const rowPropUpdates = {};
		const attrUpdates = {};
		if (input.allowBreakAcrossPages !== void 0) {
			rowPropUpdates.cantSplit = !input.allowBreakAcrossPages;
			attrUpdates.cantSplit = !input.allowBreakAcrossPages;
		}
		if (input.repeatHeader !== void 0) rowPropUpdates.repeatHeader = input.repeatHeader;
		const newAttrs = {
			...currentAttrs,
			...attrUpdates,
			tableRowProperties: {
				...currentRowProps,
				...rowPropUpdates
			}
		};
		tr.setNodeMarkup(rowPos, null, newAttrs);
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, table.candidate.pos, table.address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Row options update could not be applied.");
	}
}
function tablesInsertColumnAdapter(editor, input, options) {
	const mode = options?.changeMode ?? "direct";
	if (mode === "tracked") ensureTrackedCapability(editor, { operation: "tables.insertColumn" });
	let normalizedInput = input;
	const inputAny = input;
	if (inputAny.position === "first" || inputAny.position === "last" || (inputAny.position === "left" || inputAny.position === "right") && inputAny.columnIndex == null) {
		const tableResolved = resolveTableLocator(editor, input, "tables.insertColumn");
		const lastColumnIndex = Math.max(0, getTableColumnCount(tableResolved.candidate.node) - 1);
		const insertAtStart = inputAny.position === "first" || inputAny.position === "left";
		normalizedInput = {
			...input,
			columnIndex: insertAtStart ? 0 : lastColumnIndex,
			position: insertAtStart ? "left" : "right"
		};
	}
	const { table, columnIndex } = resolveColumnLocator(editor, normalizedInput, "tables.insertColumn");
	if (options?.dryRun) return buildTableSuccess(table.address);
	try {
		const tr = editor.state.tr;
		const tablePos = table.candidate.pos;
		const normalizedAny = normalizedInput;
		const count = normalizedAny.count ?? 1;
		const position = normalizedAny.position ?? "right";
		let updatedGrid = table.candidate.node.attrs.grid;
		for (let c = 0; c < count; c++) {
			const insertCol = position === "left" ? columnIndex + c : columnIndex + 1 + c;
			addColumnToTable(tr, tablePos, insertCol);
			updatedGrid = insertGridColumnWidth(updatedGrid, insertCol) ?? updatedGrid;
		}
		if (updatedGrid) {
			const currentTableNode = tr.doc.nodeAt(tablePos);
			if (currentTableNode && currentTableNode.type.name === "table") tr.setNodeMarkup(tablePos, null, {
				...currentTableNode.attrs,
				grid: updatedGrid,
				userEdited: true
			});
		}
		if (mode === "tracked") applyTrackedMutationMeta(tr);
		else applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, table.candidate.pos, table.address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Column insertion could not be applied.");
	}
}
function tablesDeleteColumnAdapter(editor, input, options) {
	const mode = options?.changeMode ?? "direct";
	if (mode === "tracked") ensureTrackedCapability(editor, { operation: "tables.deleteColumn" });
	const { table, columnIndex, columnCount } = resolveColumnLocator(editor, input, "tables.deleteColumn");
	if (columnCount <= 1) return toTableFailure("NO_OP", "Cannot delete the last column of a table.");
	if (options?.dryRun) return buildTableSuccess(table.address);
	try {
		const tr = editor.state.tr;
		let updatedGrid = table.candidate.node.attrs.grid;
		removeColumnFromTable(tr, table.candidate.pos, columnIndex);
		updatedGrid = removeGridColumnWidth(updatedGrid, columnIndex) ?? updatedGrid;
		if (updatedGrid) {
			const currentTableNode = tr.doc.nodeAt(table.candidate.pos);
			if (currentTableNode && currentTableNode.type.name === "table") tr.setNodeMarkup(table.candidate.pos, null, {
				...currentTableNode.attrs,
				grid: updatedGrid,
				userEdited: true
			});
		}
		if (mode === "tracked") applyTrackedMutationMeta(tr);
		else applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, table.candidate.pos, table.address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Column deletion could not be applied.");
	}
}
function tablesSetColumnWidthAdapter(editor, input, options) {
	rejectTrackedMode("tables.setColumnWidth", options);
	const { table, columnIndex } = resolveColumnLocator(editor, input, "tables.setColumnWidth");
	if (options?.dryRun) return buildTableSuccess(table.address);
	try {
		const tr = editor.state.tr;
		const tablePos = table.candidate.pos;
		const tableStart = tablePos + 1;
		const tableNode = table.candidate.node;
		const tableAttrs = tableNode.attrs;
		const map$1 = TableMap.get(tableNode);
		const widthPx = Math.round(input.widthPt * (96 / 72));
		const normalizedGrid = normalizeGridColumns(tableAttrs.grid);
		const nextGridColumns = normalizedGrid?.columns.slice();
		if (nextGridColumns && columnIndex < nextGridColumns.length) nextGridColumns[columnIndex] = { col: Math.round(input.widthPt * POINTS_TO_TWIPS) };
		const processed = /* @__PURE__ */ new Set();
		for (let row = 0; row < map$1.height; row++) {
			const index = row * map$1.width + columnIndex;
			const pos = map$1.map[index];
			if (processed.has(pos)) continue;
			processed.add(pos);
			const cell = tableNode.nodeAt(pos);
			if (!cell) continue;
			const attrs = cell.attrs;
			const colspan = attrs.colspan || 1;
			const colwidth = attrs.colwidth?.slice() ?? [];
			const cellStartCol = map$1.colCount(pos);
			const withinCol = columnIndex - cellStartCol;
			while (colwidth.length < colspan) colwidth.push(0);
			colwidth[withinCol] = widthPx;
			const nextAttrs = {
				...attrs,
				colwidth
			};
			if (row === 0) {
				const nextCellProps = buildFirstRowCellWidthProps(attrs, cellStartCol, colspan, colwidth, nextGridColumns);
				if (nextCellProps) nextAttrs.tableCellProperties = nextCellProps;
				else delete nextAttrs.tableCellProperties;
			}
			tr.setNodeMarkup(tableStart + pos, null, nextAttrs);
		}
		const tableAttrUpdates = {};
		if (normalizedGrid && nextGridColumns) tableAttrUpdates.grid = serializeGridColumns(tableAttrs.grid, {
			...normalizedGrid,
			columns: nextGridColumns
		});
		tr.setNodeMarkup(tablePos, null, buildWidthAuthoringTableAttrs(tableAttrs, tableAttrUpdates));
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, table.candidate.pos, table.address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Column width update could not be applied.");
	}
}
function tablesDistributeColumnsAdapter(editor, input, options) {
	rejectTrackedMode("tables.distributeColumns", options);
	const tableLocator = {};
	if (input.target != null) tableLocator.target = input.target;
	if (input.nodeId != null) tableLocator.nodeId = input.nodeId;
	const { candidate, address } = resolveTableLocator(editor, tableLocator, "tables.distributeColumns");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const tr = editor.state.tr;
		const tablePos = candidate.pos;
		const tableStart = tablePos + 1;
		const tableNode = candidate.node;
		const tableAttrs = tableNode.attrs;
		const map$1 = TableMap.get(tableNode);
		const normalizedGrid = normalizeGridColumns(tableAttrs.grid);
		const nextGridColumns = normalizedGrid?.columns.slice();
		const rangeStart = input.columnRange?.start ?? 0;
		const rangeEnd = input.columnRange?.end ?? map$1.width - 1;
		const rangeWidth = rangeEnd - rangeStart + 1;
		let totalWidth = 0;
		for (let col = rangeStart; col <= rangeEnd; col++) {
			const pos = map$1.map[col];
			const cell = tableNode.nodeAt(pos);
			if (!cell) continue;
			const colwidth = cell.attrs.colwidth;
			const cellStartCol = map$1.colCount(pos);
			const withinCol = col - cellStartCol;
			totalWidth += colwidth?.[withinCol] ?? 100;
		}
		const evenWidth = Math.round(totalWidth / rangeWidth);
		if (nextGridColumns) {
			const evenWidthTwips = Math.max(1, Math.round(evenWidth * PIXELS_TO_TWIPS));
			const maxColumn = Math.min(rangeEnd, nextGridColumns.length - 1);
			for (let col = Math.max(rangeStart, 0); col <= maxColumn; col++) nextGridColumns[col] = { col: evenWidthTwips };
		}
		const processed = /* @__PURE__ */ new Set();
		for (let row = 0; row < map$1.height; row++) for (let col = rangeStart; col <= rangeEnd; col++) {
			const index = row * map$1.width + col;
			const pos = map$1.map[index];
			if (processed.has(pos)) continue;
			processed.add(pos);
			const cell = tableNode.nodeAt(pos);
			if (!cell) continue;
			const attrs = cell.attrs;
			const colspan = attrs.colspan || 1;
			const cellStartCol = map$1.colCount(pos);
			const newColwidth = attrs.colwidth?.slice() ?? Array(colspan).fill(0);
			while (newColwidth.length < colspan) newColwidth.push(0);
			for (let c = 0; c < colspan; c++) {
				const absCol = cellStartCol + c;
				if (absCol >= rangeStart && absCol <= rangeEnd) newColwidth[c] = evenWidth;
			}
			const nextAttrs = {
				...attrs,
				colwidth: newColwidth
			};
			if (row === 0) {
				const nextCellProps = buildFirstRowCellWidthProps(attrs, cellStartCol, colspan, newColwidth, nextGridColumns);
				if (nextCellProps) nextAttrs.tableCellProperties = nextCellProps;
				else delete nextAttrs.tableCellProperties;
			}
			tr.setNodeMarkup(tableStart + pos, null, nextAttrs);
		}
		const tableAttrUpdates = {};
		if (normalizedGrid && nextGridColumns) tableAttrUpdates.grid = serializeGridColumns(tableAttrs.grid, {
			...normalizedGrid,
			columns: nextGridColumns
		});
		tr.setNodeMarkup(tablePos, null, buildWidthAuthoringTableAttrs(tableAttrs, tableAttrUpdates));
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Column distribution could not be applied.");
	}
}
function tablesConvertFromTextAdapter(editor, input, options) {
	rejectTrackedMode("tables.convertFromText", options);
	const index = getBlockIndex(editor);
	let candidate;
	if (input.target != null) candidate = findBlockById(index, input.target);
	else if (input.nodeId != null) candidate = findBlockByNodeIdOnly(index, input.nodeId);
	else throw new DocumentApiAdapterError("INVALID_TARGET", "tables.convertFromText: requires either target or nodeId.");
	if (!candidate) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "tables.convertFromText: target was not found.");
	if (options?.dryRun) return buildTableSuccess();
	try {
		const tr = editor.state.tr;
		const schema = editor.state.schema;
		const doc$1 = editor.state.doc;
		const paragraphs = [];
		let pos = candidate.pos;
		while (pos < doc$1.content.size) {
			const node = doc$1.nodeAt(pos);
			if (!node || node.type.name !== "paragraph") break;
			paragraphs.push({
				node,
				pos
			});
			pos += node.nodeSize;
		}
		if (paragraphs.length === 0) return toTableFailure("INVALID_TARGET", "No paragraph content found at target.");
		const rawDelimiter = input.delimiter ?? "tab";
		const sep = typeof rawDelimiter === "object" ? rawDelimiter.custom : rawDelimiter === "tab" ? "	" : rawDelimiter === "comma" ? "," : null;
		const rows = [];
		let maxCols = 1;
		for (const p$1 of paragraphs) {
			const text = p$1.node.textContent;
			const cells = sep != null ? text.split(sep) : [text];
			rows.push(cells);
			if (cells.length > maxCols) maxCols = cells.length;
		}
		const numCols = input.columns ?? (input.inferColumns !== false ? maxCols : maxCols);
		const tableRows = [];
		for (const cells of rows) {
			const tableCells = [];
			for (let c = 0; c < numCols; c++) {
				const text = cells[c] ?? "";
				const content = text ? schema.text(text) : void 0;
				const para = schema.nodes.paragraph.createAndFill(null, content);
				tableCells.push(schema.nodes.tableCell.createAndFill({ sdBlockId: v4_default() }, para));
			}
			tableRows.push(schema.nodes.tableRow.createAndFill({
				sdBlockId: v4_default(),
				paraId: generateDocxHexId()
			}, tableCells));
		}
		const tableId = v4_default();
		const tableNode = schema.nodes.table.create({ sdBlockId: tableId }, tableRows);
		const startPos = paragraphs[0].pos;
		const lastP = paragraphs[paragraphs.length - 1];
		const endPos = lastP.pos + lastP.node.nodeSize;
		tr.replaceWith(startPos, endPos, tableNode);
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		const insertedTable = getBlockIndex(editor).candidates.find((block) => block.nodeType === "table" && block.pos === startPos);
		return buildTableSuccess(insertedTable ? toBlockAddress(insertedTable) : void 0);
	} catch {
		return toTableFailure("INVALID_TARGET", "Text-to-table conversion could not be applied.");
	}
}
function tablesSplitAdapter(editor, input, options) {
	rejectTrackedMode("tables.split", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.split");
	const tableNode = candidate.node;
	if (input.rowIndex <= 0 || input.rowIndex >= tableNode.childCount) return toTableFailure("INVALID_TARGET", "Split row index must be between 1 and rowCount-1.");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const tr = editor.state.tr;
		const tablePos = candidate.pos;
		const schema = editor.state.schema;
		const secondTableRows = [];
		for (let i = input.rowIndex; i < tableNode.childCount; i++) secondTableRows.push(tableNode.child(i));
		let rowPos = tablePos + 1;
		const rowPositions = [];
		for (let i = 0; i < tableNode.childCount; i++) {
			rowPositions.push(rowPos);
			rowPos += tableNode.child(i).nodeSize;
		}
		const mapFrom = tr.mapping.maps.length;
		for (let i = tableNode.childCount - 1; i >= input.rowIndex; i--) {
			const rp = tr.mapping.slice(mapFrom).map(rowPositions[i]);
			const rEnd = tr.mapping.slice(mapFrom).map(rowPositions[i] + tableNode.child(i).nodeSize);
			tr.delete(rp, rEnd);
		}
		const newTableAttrs = Attribute.getSplittedAttributes(editor.extensionService?.attributes ?? [], tableNode.type.name, tableNode.attrs);
		const newTable = schema.nodes.table.create(newTableAttrs, secondTableRows);
		const separatorParagraph = createSeparatorParagraph(schema);
		if (!separatorParagraph) return toTableFailure("INVALID_TARGET", "Table split could not create a separator paragraph.");
		const insertPos = tr.mapping.slice(mapFrom).map(tablePos + tableNode.nodeSize);
		tr.insert(insertPos, separatorParagraph);
		tr.insert(insertPos + separatorParagraph.nodeSize, newTable);
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(address);
	} catch {
		return toTableFailure("INVALID_TARGET", "Table split could not be applied.");
	}
}
function tablesConvertToTextAdapter(editor, input, options) {
	rejectTrackedMode("tables.convertToText", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.convertToText");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const tr = editor.state.tr;
		const tableNode = candidate.node;
		const tablePos = candidate.pos;
		const schema = editor.state.schema;
		const map$1 = TableMap.get(tableNode);
		const delimiter = input.delimiter ?? "tab";
		const sep = delimiter === "tab" ? "	" : delimiter === "comma" ? "," : null;
		const paragraphs = [];
		for (let row = 0; row < map$1.height; row++) if (sep !== null) {
			const cellTexts = [];
			const seen = /* @__PURE__ */ new Set();
			for (let col = 0; col < map$1.width; col++) {
				const pos = map$1.map[row * map$1.width + col];
				if (seen.has(pos)) continue;
				seen.add(pos);
				const cell = tableNode.nodeAt(pos);
				cellTexts.push(cell?.textContent ?? "");
			}
			const text = cellTexts.join(sep);
			const content = text ? schema.text(text) : void 0;
			paragraphs.push(schema.nodes.paragraph.createAndFill(null, content));
		} else {
			const seen = /* @__PURE__ */ new Set();
			for (let col = 0; col < map$1.width; col++) {
				const pos = map$1.map[row * map$1.width + col];
				if (seen.has(pos)) continue;
				seen.add(pos);
				const text = tableNode.nodeAt(pos)?.textContent ?? "";
				const content = text ? schema.text(text) : void 0;
				paragraphs.push(schema.nodes.paragraph.createAndFill(null, content));
			}
		}
		tr.replaceWith(tablePos, tablePos + tableNode.nodeSize, paragraphs);
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess();
	} catch {
		return toTableFailure("INVALID_TARGET", "Table-to-text conversion could not be applied.");
	}
}
function tablesInsertCellAdapter(editor, input, options) {
	rejectTrackedMode("tables.insertCell", options);
	const { table, cellPos, rowIndex, columnIndex } = resolveCellLocator(editor, input, "tables.insertCell");
	if (options?.dryRun) return buildTableSuccess(table.address);
	try {
		const tr = editor.state.tr;
		const tablePos = table.candidate.pos;
		const tableStart = tablePos + 1;
		const tableNode = table.candidate.node;
		const map$1 = TableMap.get(tableNode);
		const schema = editor.state.schema;
		if (input.mode === "shiftRight") {
			const slotCount = map$1.width * map$1.height;
			if (new Set(map$1.map).size !== slotCount) return toTableFailure("INVALID_TARGET", "Cell insertion with shiftRight is not supported for merged cells in this version.");
			const makeEmptyCell = (preferHeader = false) => {
				const candidateType = preferHeader ? schema.nodes.tableHeader ?? schema.nodes.tableCell : schema.nodes.tableCell;
				return candidateType.createAndFill({ sdBlockId: v4_default() }) ?? candidateType.createAndFill();
			};
			const overflowRowCells = [];
			for (let col = 0; col < map$1.width; col++) {
				const templateOffset = map$1.map[(map$1.height - 1) * map$1.width + col];
				const templateCell = tableNode.nodeAt(templateOffset);
				overflowRowCells.push(makeEmptyCell(templateCell?.type.name === "tableHeader"));
			}
			const overflowRowAttrs = {
				...tableNode.child(Math.max(0, map$1.height - 1)).attrs ?? {},
				sdBlockId: v4_default(),
				paraId: generateDocxHexId()
			};
			const overflowRow = schema.nodes.tableRow.createAndFill(overflowRowAttrs, overflowRowCells) ?? schema.nodes.tableRow.create(overflowRowAttrs, overflowRowCells);
			if (!overflowRow) return toTableFailure("INVALID_TARGET", "Cell insertion could not construct an overflow row.");
			tr.insert(tablePos + tableNode.nodeSize - 1, overflowRow);
			const expandedTableNode = tr.doc.nodeAt(tablePos);
			if (!expandedTableNode || expandedTableNode.type.name !== "table") return toTableFailure("INVALID_TARGET", "Cell insertion could not locate expanded table state.");
			const expandedMap = TableMap.get(expandedTableNode);
			const expandedSlotCount = expandedMap.width * expandedMap.height;
			if (new Set(expandedMap.map).size !== expandedSlotCount) return toTableFailure("INVALID_TARGET", "Cell insertion with shiftRight produced an unsupported merged-table shape.");
			const rowMajorCells = [];
			for (let i = 0; i < expandedSlotCount; i++) {
				const offset$1 = expandedMap.map[i];
				const cell = expandedTableNode.nodeAt(offset$1);
				if (!cell) return toTableFailure("INVALID_TARGET", "Cell insertion could not resolve expanded table cells.");
				rowMajorCells.push(cell);
			}
			const targetLinearIndex = rowIndex * expandedMap.width + columnIndex;
			const targetOffset = expandedMap.map[targetLinearIndex];
			const targetCell = expandedTableNode.nodeAt(targetOffset);
			rowMajorCells.splice(targetLinearIndex, 0, makeEmptyCell(targetCell?.type.name === "tableHeader"));
			rowMajorCells.pop();
			const rebuiltRows = [];
			const rebuiltRowCount = rowMajorCells.length / expandedMap.width;
			for (let rebuiltRowIndex = 0; rebuiltRowIndex < rebuiltRowCount; rebuiltRowIndex++) {
				const rowAttrs = expandedTableNode.child(rebuiltRowIndex).attrs ?? {};
				const rowCells = rowMajorCells.slice(rebuiltRowIndex * expandedMap.width, (rebuiltRowIndex + 1) * expandedMap.width);
				const rebuiltRow = schema.nodes.tableRow.createAndFill(rowAttrs, rowCells) ?? schema.nodes.tableRow.create(rowAttrs, rowCells);
				if (!rebuiltRow) return toTableFailure("INVALID_TARGET", "Cell insertion could not construct a replacement row.");
				rebuiltRows.push(rebuiltRow);
			}
			const rebuiltTable = schema.nodes.table.create(expandedTableNode.attrs, rebuiltRows);
			tr.replaceWith(tablePos, tablePos + expandedTableNode.nodeSize, rebuiltTable);
		} else {
			const lastRowIdx = (map$1.height - 1) * map$1.width + columnIndex;
			const lastCellPos = map$1.map[lastRowIdx];
			const lastCell = tableNode.nodeAt(lastCellPos);
			if (lastCell) tr.delete(tableStart + lastCellPos, tableStart + lastCellPos + lastCell.nodeSize);
			const insertRow = Math.min(rowIndex + 1, map$1.height - 1);
			const insertOffset = map$1.map[insertRow * map$1.width + columnIndex];
			const newCell = schema.nodes.tableCell.createAndFill();
			const mappedInsertPos = tr.mapping.map(tableStart + insertOffset);
			tr.insert(mappedInsertPos, newCell);
		}
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, table.candidate.pos, table.address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Cell insertion could not be applied.");
	}
}
function tablesDeleteCellAdapter(editor, input, options) {
	rejectTrackedMode("tables.deleteCell", options);
	const { table, cellPos, cellNode, rowIndex, columnIndex } = resolveCellLocator(editor, input, "tables.deleteCell");
	const row = table.candidate.node.child(rowIndex);
	const deletedColspan = Math.max(1, cellNode.attrs.colspan || 1);
	const deletedColwidth = Array.isArray(cellNode.attrs.colwidth) ? [...cellNode.attrs.colwidth] : null;
	if (input.mode === "shiftLeft" && row.childCount <= 1) return toTableFailure("NO_OP", "Cannot shift-left delete the last remaining cell in a row.");
	if (options?.dryRun) return buildTableSuccess(table.address);
	try {
		const tr = editor.state.tr;
		const tablePos = table.candidate.pos;
		const tableStart = tablePos + 1;
		const tableNode = table.candidate.node;
		const map$1 = TableMap.get(tableNode);
		const schema = editor.state.schema;
		tr.delete(cellPos, cellPos + cellNode.nodeSize);
		if (input.mode === "shiftLeft") {
			const currentTableNode = tr.doc.nodeAt(tablePos);
			if (!currentTableNode || currentTableNode.type.name !== "table") return toTableFailure("INVALID_TARGET", "Cell deletion could not locate the updated table.");
			const currentRow = currentTableNode.child(rowIndex);
			const lastCellIndex = currentRow.childCount - 1;
			const lastAttrs = currentRow.child(lastCellIndex).attrs;
			const tableCellProperties = lastAttrs.tableCellProperties ?? {};
			const lastRowspan = Math.max(1, lastAttrs.rowspan || 1);
			const hasVerticalMerge = tableCellProperties.vMerge != null;
			if (lastRowspan > 1 || hasVerticalMerge) {
				let rowEndPos = tablePos + 1;
				for (let i = 0; i <= rowIndex; i++) rowEndPos += currentTableNode.child(i).nodeSize;
				const mappedRowEnd = rowEndPos - 1;
				const newCell = schema.nodes.tableCell.createAndFill();
				tr.insert(mappedRowEnd, newCell);
			} else {
				const nextColspan = Math.max(1, lastAttrs.colspan || 1) + deletedColspan;
				const nextTableCellProps = { ...tableCellProperties };
				if (nextColspan > 1) nextTableCellProps.gridSpan = nextColspan;
				else delete nextTableCellProps.gridSpan;
				const nextColwidth = Array.isArray(lastAttrs.colwidth) ? [...lastAttrs.colwidth] : null;
				if (nextColwidth) {
					if (deletedColwidth) for (const width of deletedColwidth) {
						if (nextColwidth.length >= nextColspan) break;
						nextColwidth.push(typeof width === "number" ? width : 0);
					}
					while (nextColwidth.length < nextColspan) nextColwidth.push(0);
				}
				let rowOffset = 0;
				for (let i = 0; i < rowIndex; i++) rowOffset += currentTableNode.child(i).nodeSize;
				let lastCellOffset = rowOffset + 1;
				for (let i = 0; i < lastCellIndex; i++) lastCellOffset += currentRow.child(i).nodeSize;
				tr.setNodeMarkup(tableStart + lastCellOffset, null, {
					...lastAttrs,
					colspan: nextColspan,
					colwidth: nextColwidth,
					tableCellProperties: nextTableCellProps
				});
			}
		} else {
			const lastRowIndex = map$1.height - 1;
			const colOffset = map$1.map[lastRowIndex * map$1.width + columnIndex];
			const mappedColPos = tr.mapping.map(tableStart + colOffset);
			const newCell = schema.nodes.tableCell.createAndFill();
			tr.insert(mappedColPos, newCell);
		}
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, table.candidate.pos, table.address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Cell deletion could not be applied.");
	}
}
function tablesMergeCellsAdapter(editor, input, options) {
	rejectTrackedMode("tables.mergeCells", options);
	const { table, startRow, startCol, endRow, endCol } = resolveMergeRangeLocator(editor, input, "tables.mergeCells");
	if (options?.dryRun) return buildTableSuccess(table.address);
	try {
		const tr = editor.state.tr;
		const tableStart = table.candidate.pos + 1;
		const tableNode = table.candidate.node;
		const map$1 = TableMap.get(tableNode);
		const content = [];
		const cellPositions = [];
		let topLeftPos = null;
		let topLeftCell = null;
		for (let row = startRow; row <= endRow; row++) for (let col = startCol; col <= endCol; col++) {
			const idx = row * map$1.width + col;
			const pos = map$1.map[idx];
			if (cellPositions.includes(pos)) continue;
			cellPositions.push(pos);
			const cell = tableNode.nodeAt(pos);
			if (!cell) continue;
			if (topLeftPos === null) {
				topLeftPos = pos;
				topLeftCell = cell;
			}
			cell.forEach((child) => content.push(child));
		}
		if (topLeftPos === null || !topLeftCell) return toTableFailure("INVALID_TARGET", "No cells found in merge range.");
		const rowSpan = endRow - startRow + 1;
		const colSpan = endCol - startCol + 1;
		const mergedAttrs = {
			...topLeftCell.attrs,
			colspan: colSpan,
			rowspan: rowSpan
		};
		const mapFrom = tr.mapping.maps.length;
		const sortedPositions = [...cellPositions].sort((a, b$1) => b$1 - a);
		for (const pos of sortedPositions) {
			const cell = tableNode.nodeAt(pos);
			if (!cell) continue;
			const absPos = tr.mapping.slice(mapFrom).map(tableStart + pos);
			tr.delete(absPos, absPos + cell.nodeSize);
		}
		const mergedCell = topLeftCell.type.create(mergedAttrs, content);
		const insertPos = tr.mapping.slice(mapFrom).map(tableStart + topLeftPos);
		tr.insert(insertPos, mergedCell);
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, table.candidate.pos, table.address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Cell merge could not be applied.");
	}
}
function resolveCellOrTableScopedInput(editor, input, operationName) {
	if (!(input.rowIndex != null && input.columnIndex != null)) return resolveCellLocator(editor, input, operationName);
	const target = input.target;
	if (target && typeof target === "object" && !Array.isArray(target)) {
		const blockTarget = target;
		if (blockTarget.kind === "block" && blockTarget.nodeType === "table") return resolveTableScopedCellLocator(editor, input, operationName);
		return resolveCellLocator(editor, { target }, operationName);
	}
	const nodeId = input.nodeId;
	if (typeof nodeId === "string") {
		const candidate = findBlockByNodeIdOnly(getBlockIndex(editor), nodeId);
		if (!candidate) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `${operationName}: target was not found.`, { target: nodeId });
		return candidate.nodeType === "table" ? resolveTableScopedCellLocator(editor, input, operationName) : resolveCellLocator(editor, { nodeId }, operationName);
	}
	return resolveCellLocator(editor, {}, operationName);
}
function tablesUnmergeCellsAdapter(editor, input, options) {
	rejectTrackedMode("tables.unmergeCells", options);
	const { table, cellPos, cellNode, rowIndex, columnIndex } = resolveCellOrTableScopedInput(editor, input, "tables.unmergeCells");
	const attrs = cellNode.attrs;
	const colspan = attrs.colspan || 1;
	const rowspan = attrs.rowspan || 1;
	if (colspan === 1 && rowspan === 1) return buildTableSuccess(table.address);
	if (options?.dryRun) return buildTableSuccess(table.address);
	try {
		const tr = editor.state.tr;
		const tablePos = table.candidate.pos;
		const tableNode = table.candidate.node;
		const schema = editor.state.schema;
		expandMergedCellIntoSingles({
			tr,
			tablePos,
			tableNode,
			cellPos,
			cellNode,
			rowIndex,
			columnIndex,
			rowspan,
			colspan,
			schema
		});
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, table.candidate.pos, table.address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Cell unmerge could not be applied.");
	}
}
function tablesSplitCellAdapter(editor, input, options) {
	rejectTrackedMode("tables.splitCell", options);
	const { table, cellPos, cellNode, rowIndex, columnIndex } = resolveCellLocator(editor, input, "tables.splitCell");
	if (input.rows < 1 || input.columns < 1) return toTableFailure("INVALID_TARGET", "Split rows and columns must be at least 1.");
	const attrs = cellNode.attrs;
	const currentColspan = attrs.colspan || 1;
	const currentRowspan = attrs.rowspan || 1;
	if (input.rows === 1 && input.columns === 1 && currentColspan === 1 && currentRowspan === 1) return toTableFailure("NO_OP", "Cell is already a single cell and split target is 1×1.");
	if (options?.dryRun) return buildTableSuccess(table.address);
	try {
		const tr = editor.state.tr;
		const tablePos = table.candidate.pos;
		const schema = editor.state.schema;
		const targetColumns = Math.max(input.columns, currentColspan);
		const targetRows = Math.max(input.rows, currentRowspan);
		const additionalColumns = Math.max(0, targetColumns - currentColspan);
		const additionalRows = Math.max(0, targetRows - currentRowspan);
		let updatedGrid = table.candidate.node.attrs.grid;
		if (currentColspan > 1 || currentRowspan > 1) {
			const currentTableNode = tr.doc.nodeAt(tablePos);
			if (!currentTableNode || currentTableNode.type.name !== "table") return toTableFailure("INVALID_TARGET", "Cell split target table is unavailable.");
			const currentCellPos = tr.mapping.map(cellPos, 1);
			const currentCellNode = tr.doc.nodeAt(currentCellPos);
			if (!currentCellNode || currentCellNode.type.name !== "tableCell" && currentCellNode.type.name !== "tableHeader") return toTableFailure("INVALID_TARGET", "Split target cell is unavailable.");
			expandMergedCellIntoSingles({
				tr,
				tablePos,
				tableNode: currentTableNode,
				cellPos: currentCellPos,
				cellNode: currentCellNode,
				rowIndex,
				columnIndex,
				rowspan: currentRowspan,
				colspan: currentColspan,
				schema
			});
		}
		for (let columnOffset = 0; columnOffset < additionalColumns; columnOffset++) {
			const insertColumnIndex = columnIndex + currentColspan + columnOffset;
			addColumnToTableForSplit(tr, tablePos, insertColumnIndex, rowIndex, rowIndex + targetRows);
			updatedGrid = insertGridColumnWidth(updatedGrid, insertColumnIndex) ?? updatedGrid;
		}
		for (let rowOffset = 0; rowOffset < additionalRows; rowOffset++) {
			const currentTableNode = tr.doc.nodeAt(tablePos);
			if (!currentTableNode || currentTableNode.type.name !== "table") return toTableFailure("INVALID_TARGET", "Cell split target table is unavailable.");
			const insertIndex = rowIndex + currentRowspan + rowOffset;
			const boundedInsertIndex = Math.max(0, Math.min(insertIndex, currentTableNode.childCount));
			if (!insertRowInTableForSplit(tr, tablePos, Math.max(0, Math.min(boundedInsertIndex - 1, currentTableNode.childCount - 1)), boundedInsertIndex, columnIndex, columnIndex + targetColumns, schema)) return toTableFailure("INVALID_TARGET", "Cell split could not insert required rows.");
		}
		const finalTableNode = tr.doc.nodeAt(tablePos);
		if (!finalTableNode || finalTableNode.type.name !== "table") return toTableFailure("INVALID_TARGET", "Cell split target table is unavailable.");
		let finalTargetCellPos = tr.mapping.map(cellPos, 1);
		let finalTargetCell = tr.doc.nodeAt(finalTargetCellPos);
		if (!finalTargetCell || finalTargetCell.type.name !== "tableCell" && finalTargetCell.type.name !== "tableHeader") {
			finalTargetCellPos = tablePos + 1 + TableMap.get(finalTableNode).positionAt(rowIndex, columnIndex, finalTableNode);
			finalTargetCell = tr.doc.nodeAt(finalTargetCellPos);
		}
		if (!finalTargetCell || finalTargetCell.type.name !== "tableCell" && finalTargetCell.type.name !== "tableHeader") return toTableFailure("INVALID_TARGET", "Split target cell is unavailable.");
		tr.setNodeMarkup(finalTargetCellPos, null, normalizeCellAttrsForSingleCell(finalTargetCell.attrs));
		if (updatedGrid) {
			const currentTableAttrs = finalTableNode.attrs;
			tr.setNodeMarkup(tablePos, null, {
				...currentTableAttrs,
				grid: updatedGrid,
				userEdited: true
			});
		}
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, table.candidate.pos, table.address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Cell split could not be applied.");
	}
}
function tablesSetCellPropertiesAdapter(editor, input, options) {
	rejectTrackedMode("tables.setCellProperties", options);
	const { table, cellPos, cellNode } = resolveCellLocator(editor, input, "tables.setCellProperties");
	if (options?.dryRun) return buildTableSuccess(table.address);
	try {
		const tr = editor.state.tr;
		const currentAttrs = cellNode.attrs;
		const currentCellProps = currentAttrs.tableCellProperties ?? {};
		const attrUpdates = {};
		const cellPropUpdates = {};
		if (input.preferredWidthPt !== void 0) {
			const widthPx = Math.round(input.preferredWidthPt * (96 / 72));
			const colspan = currentAttrs.colspan || 1;
			attrUpdates.colwidth = Array(colspan).fill(widthPx);
			cellPropUpdates.cellWidth = {
				w: Math.round(input.preferredWidthPt * 20),
				type: "dxa"
			};
		}
		if (input.verticalAlign !== void 0) {
			attrUpdates.verticalAlign = input.verticalAlign;
			cellPropUpdates.vAlign = input.verticalAlign;
		}
		if (input.wrapText !== void 0) cellPropUpdates.noWrap = !input.wrapText;
		if (input.fitText !== void 0) cellPropUpdates.tcFitText = input.fitText;
		const newAttrs = {
			...currentAttrs,
			...attrUpdates,
			tableCellProperties: {
				...currentCellProps,
				...cellPropUpdates
			}
		};
		tr.setNodeMarkup(cellPos, null, newAttrs);
		if (input.preferredWidthPt !== void 0) {
			const tableAttrs = table.candidate.node.attrs;
			tr.setNodeMarkup(table.candidate.pos, null, buildWidthAuthoringTableAttrs(tableAttrs));
		}
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, table.candidate.pos, table.address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Cell properties update could not be applied.");
	}
}
function buildSetCellTextParagraph(schema, text) {
	const paragraphType = schema.nodes.paragraph;
	if (!paragraphType) return null;
	return text.length === 0 ? paragraphType.createAndFill() : paragraphType.createAndFill(null, schema.text(text));
}
var IDENTITY_BLOCK_ATTRS = NON_SEMANTIC_BLOCK_ATTRS;
function cellContentEqualsIgnoringIdentity(a, b$1) {
	if (a.type !== b$1.type) return false;
	if (a.text !== b$1.text) return false;
	if (a.marks.length !== b$1.marks.length) return false;
	for (let i = 0; i < a.marks.length; i++) if (!a.marks[i].eq(b$1.marks[i])) return false;
	const aAttrs = a.attrs;
	const bAttrs = b$1.attrs;
	const keys$1 = new Set([...Object.keys(aAttrs), ...Object.keys(bAttrs)]);
	for (const key of keys$1) {
		if (IDENTITY_BLOCK_ATTRS.has(key)) continue;
		if (JSON.stringify(aAttrs[key]) !== JSON.stringify(bAttrs[key])) return false;
	}
	if (a.childCount !== b$1.childCount) return false;
	for (let i = 0; i < a.childCount; i++) if (!cellContentEqualsIgnoringIdentity(a.child(i), b$1.child(i))) return false;
	return true;
}
function tablesSetCellTextAdapter(editor, input, options) {
	rejectTrackedMode("tables.setCellText", options);
	const { table, cellPos, cellNode } = resolveCellOrTableScopedInput(editor, input, "tables.setCellText");
	const candidateParagraph = buildSetCellTextParagraph(editor.state.schema, input.text);
	if (!candidateParagraph) return toTableFailure("INVALID_TARGET", "tables.setCellText: paragraph node type is unavailable.");
	try {
		const tr = editor.state.tr;
		const cellStart = cellPos + 1;
		const cellEnd = cellStart + cellNode.content.size;
		tr.replaceWith(cellStart, cellEnd, candidateParagraph);
		const stateApply = editor.state.apply;
		if (typeof stateApply === "function") {
			const projectedCell = stateApply.call(editor.state, tr).doc.nodeAt(cellPos);
			if (projectedCell && cellContentEqualsIgnoringIdentity(cellNode, projectedCell)) return toTableFailure("NO_OP", "tables.setCellText: cell already contains this text.");
		}
		if (options?.dryRun) return buildTableSuccess(table.address);
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, table.candidate.pos, table.address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Cell text update could not be applied.");
	}
}
function tablesSortAdapter(editor, input, options) {
	rejectTrackedMode("tables.sort", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.sort");
	const tableNode = candidate.node;
	if (!input.keys || input.keys.length === 0) return toTableFailure("INVALID_TARGET", "No sort keys provided.");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const tr = editor.state.tr;
		const tablePos = candidate.pos;
		tablePos + 1;
		const map$1 = TableMap.get(tableNode);
		for (const key of input.keys) if (key.columnIndex < 0 || key.columnIndex >= map$1.width) return toTableFailure("INVALID_TARGET", `Sort column index ${key.columnIndex} is out of bounds.`);
		const rows = [];
		for (let r$1 = 0; r$1 < tableNode.childCount; r$1++) rows.push({
			index: r$1,
			node: tableNode.child(r$1)
		});
		const getCellText = (rowIdx, colIdx) => {
			const cellPos = map$1.map[rowIdx * map$1.width + colIdx];
			return tableNode.nodeAt(cellPos)?.textContent ?? "";
		};
		const rowValues = rows.map((row) => ({
			row,
			values: input.keys.map((key) => getCellText(row.index, key.columnIndex))
		}));
		rowValues.sort((a, b$1) => {
			for (let k$1 = 0; k$1 < input.keys.length; k$1++) {
				const key = input.keys[k$1];
				const va = a.values[k$1];
				const vb = b$1.values[k$1];
				let cmp;
				if (key.type === "number") cmp = (parseFloat(va) || 0) - (parseFloat(vb) || 0);
				else if (key.type === "date") cmp = (new Date(va).getTime() || 0) - (new Date(vb).getTime() || 0);
				else cmp = va.localeCompare(vb);
				if (key.direction === "descending") cmp = -cmp;
				if (cmp !== 0) return cmp;
			}
			return 0;
		});
		if (rowValues.every((rv, i) => rv.row.index === i)) return buildTableSuccess(address);
		const sortedNodes = rowValues.map((rv) => rv.row.node);
		const tableEnd = tablePos + tableNode.nodeSize;
		const newTable = tableNode.type.create(tableNode.attrs, sortedNodes);
		tr.replaceWith(tablePos, tableEnd, newTable);
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Table sort could not be applied.");
	}
}
function tablesSetStyleAdapter(editor, input, options) {
	rejectTrackedMode("tables.setStyle", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.setStyle");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const tr = editor.state.tr;
		const currentAttrs = candidate.node.attrs;
		const updatedTableProps = {
			...currentAttrs.tableProperties ?? {},
			tableStyleId: input.styleId
		};
		tr.setNodeMarkup(candidate.pos, null, {
			...currentAttrs,
			tableProperties: updatedTableProps,
			...syncExtractedTableAttrs(updatedTableProps)
		});
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Table style assignment could not be applied.");
	}
}
function tablesClearStyleAdapter(editor, input, options) {
	rejectTrackedMode("tables.clearStyle", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.clearStyle");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const tr = editor.state.tr;
		const currentAttrs = candidate.node.attrs;
		const currentTableProps = { ...currentAttrs.tableProperties ?? {} };
		delete currentTableProps.tableStyleId;
		tr.setNodeMarkup(candidate.pos, null, {
			...currentAttrs,
			tableProperties: currentTableProps,
			...syncExtractedTableAttrs(currentTableProps)
		});
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Table style removal could not be applied.");
	}
}
var WORD_DEFAULT_TBL_LOOK = {
	firstRow: true,
	lastRow: false,
	firstColumn: true,
	lastColumn: false,
	noHBand: false,
	noVBand: true
};
var FLAG_TO_OOXML_KEY = {
	headerRow: "firstRow",
	lastRow: "lastRow",
	firstColumn: "firstColumn",
	lastColumn: "lastColumn",
	bandedRows: "noHBand",
	bandedColumns: "noVBand"
};
var INVERTED_FLAGS = new Set(["bandedRows", "bandedColumns"]);
function resolveStyleOptionFlag(flag) {
	return FLAG_TO_OOXML_KEY[flag === "totalRow" ? "lastRow" : flag];
}
function tablesSetStyleOptionAdapter(editor, input, options) {
	rejectTrackedMode("tables.setStyleOption", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.setStyleOption");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const xmlKey = resolveStyleOptionFlag(input.flag);
		const ooxmlValue = INVERTED_FLAGS.has(input.flag) ? !input.enabled : input.enabled;
		const currentAttrs = candidate.node.attrs;
		const currentTableProps = currentAttrs.tableProperties ?? {};
		const existingLook = currentTableProps.tblLook;
		if (existingLook != null && existingLook[xmlKey] === ooxmlValue) return toTableFailure("NO_OP", `Style option '${input.flag}' already has the requested value.`);
		const updatedLook = existingLook != null ? { ...existingLook } : { ...WORD_DEFAULT_TBL_LOOK };
		updatedLook[xmlKey] = ooxmlValue;
		delete updatedLook.val;
		const updatedTableProps = {
			...currentTableProps,
			tblLook: updatedLook
		};
		const tr = editor.state.tr;
		tr.setNodeMarkup(candidate.pos, null, {
			...currentAttrs,
			tableProperties: updatedTableProps,
			...syncExtractedTableAttrs(updatedTableProps)
		});
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Table style option could not be applied.");
	}
}
function resolveTableOrCellTarget(editor, locator, operationName) {
	const index = getBlockIndex(editor);
	let candidate;
	if (locator.target != null) candidate = findBlockById(index, locator.target);
	else if (locator.nodeId != null) candidate = findBlockByNodeIdOnly(index, locator.nodeId);
	else throw new DocumentApiAdapterError("INVALID_TARGET", `${operationName}: requires either target or nodeId.`);
	if (!candidate) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `${operationName}: target was not found.`);
	if (candidate.nodeType === "tableCell") {
		const resolvedCell = resolveCellLocator(editor, locator, operationName);
		return {
			node: candidate.node,
			pos: candidate.pos,
			address: resolvedCell.table.address,
			scope: "cell"
		};
	}
	const scope = candidate.nodeType === "table" ? "table" : "invalid";
	return {
		node: candidate.node,
		pos: candidate.pos,
		address: toBlockAddress(candidate),
		scope
	};
}
function tablesSetBorderAdapter(editor, input, options) {
	rejectTrackedMode("tables.setBorder", options);
	const resolved = resolveTableOrCellTarget(editor, input, "tables.setBorder");
	if (resolved.scope === "invalid") return toTableFailure("INVALID_TARGET", "tables.setBorder: target must be a table or tableCell.");
	if (options?.dryRun) return buildTableSuccess(resolved.address);
	try {
		const tr = editor.state.tr;
		const currentAttrs = resolved.node.attrs;
		const propsKey = resolved.scope === "table" ? "tableProperties" : "tableCellProperties";
		const currentProps = { ...currentAttrs[propsKey] ?? {} };
		const currentBorders = { ...currentProps.borders ?? {} };
		currentBorders[input.edge] = {
			val: input.lineStyle,
			size: Math.round(input.lineWeightPt * 8),
			color: normalizeColorInput(input.color)
		};
		currentProps.borders = currentBorders;
		const syncAttrs = resolved.scope === "table" ? syncExtractedTableAttrs(currentProps) : {};
		const cellClear = resolved.scope === "cell" ? { borders: null } : {};
		tr.setNodeMarkup(resolved.pos, null, {
			...currentAttrs,
			[propsKey]: currentProps,
			...syncAttrs,
			...cellClear
		});
		if (resolved.scope === "table" && isBoundaryEdge(input.edge)) applyTableEdgeToCellBorders(tr, resolved.pos, resolved.node, input.edge, currentBorders[input.edge]);
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		if (resolved.scope === "table") return buildTableSuccess(resolvePostMutationTableAddress(editor, resolved.pos, resolved.address.nodeId, tr));
		return buildTableSuccess(resolved.address);
	} catch {
		return toTableFailure("INVALID_TARGET", "Border update could not be applied.");
	}
}
function tablesClearBorderAdapter(editor, input, options) {
	rejectTrackedMode("tables.clearBorder", options);
	const resolved = resolveTableOrCellTarget(editor, input, "tables.clearBorder");
	if (resolved.scope === "invalid") return toTableFailure("INVALID_TARGET", "tables.clearBorder: target must be a table or tableCell.");
	if (options?.dryRun) return buildTableSuccess(resolved.address);
	try {
		const tr = editor.state.tr;
		const currentAttrs = resolved.node.attrs;
		const propsKey = resolved.scope === "table" ? "tableProperties" : "tableCellProperties";
		const currentProps = { ...currentAttrs[propsKey] ?? {} };
		const currentBorders = { ...currentProps.borders ?? {} };
		currentBorders[input.edge] = {
			val: "nil",
			size: 0,
			color: "auto"
		};
		currentProps.borders = currentBorders;
		const syncAttrs = resolved.scope === "table" ? syncExtractedTableAttrs(currentProps) : {};
		const cellClear = resolved.scope === "cell" ? { borders: null } : {};
		tr.setNodeMarkup(resolved.pos, null, {
			...currentAttrs,
			[propsKey]: currentProps,
			...syncAttrs,
			...cellClear
		});
		if (resolved.scope === "table" && isBoundaryEdge(input.edge)) applyTableEdgeToCellBorders(tr, resolved.pos, resolved.node, input.edge, currentBorders[input.edge]);
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		if (resolved.scope === "table") return buildTableSuccess(resolvePostMutationTableAddress(editor, resolved.pos, resolved.address.nodeId, tr));
		return buildTableSuccess(resolved.address);
	} catch {
		return toTableFailure("INVALID_TARGET", "Border clear could not be applied.");
	}
}
function tablesApplyBorderPresetAdapter(editor, input, options) {
	rejectTrackedMode("tables.applyBorderPreset", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.applyBorderPreset");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const tr = editor.state.tr;
		const currentAttrs = candidate.node.attrs;
		const currentTableProps = { ...currentAttrs.tableProperties ?? {} };
		const none = {
			val: "none",
			size: 0,
			color: "auto"
		};
		const single = {
			val: "single",
			size: 4,
			color: "000000"
		};
		let borders;
		switch (input.preset) {
			case "none":
				borders = {
					top: none,
					bottom: none,
					left: none,
					right: none,
					insideH: none,
					insideV: none
				};
				break;
			case "box":
				borders = {
					top: single,
					bottom: single,
					left: single,
					right: single,
					insideH: none,
					insideV: none
				};
				break;
			case "all":
			case "grid":
				borders = {
					top: single,
					bottom: single,
					left: single,
					right: single,
					insideH: single,
					insideV: single
				};
				break;
			default: return buildTableSuccess(address);
		}
		currentTableProps.borders = borders;
		tr.setNodeMarkup(candidate.pos, null, {
			...currentAttrs,
			tableProperties: currentTableProps,
			...syncExtractedTableAttrs(currentTableProps)
		});
		applyTableBorderPresetToCellBorders(tr, candidate.pos, candidate.node, input.preset);
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Border preset could not be applied.");
	}
}
function tablesSetShadingAdapter(editor, input, options) {
	if (input.color === null) return tablesClearShadingAdapter(editor, {
		target: input.target,
		nodeId: input.nodeId
	}, options);
	if (typeof input.color !== "string") return toTableFailure("INVALID_INPUT", "tables.setShading: color is required (hex string, \"auto\", or null to clear).");
	rejectTrackedMode("tables.setShading", options);
	const resolved = resolveTableOrCellTarget(editor, input, "tables.setShading");
	if (resolved.scope === "invalid") return toTableFailure("INVALID_TARGET", "tables.setShading: target must be a table or tableCell.");
	if (options?.dryRun) return buildTableSuccess(resolved.address);
	const normalizedColor = normalizeColorInput(input.color);
	try {
		const tr = editor.state.tr;
		const currentAttrs = resolved.node.attrs;
		const propsKey = resolved.scope === "table" ? "tableProperties" : "tableCellProperties";
		const currentProps = { ...currentAttrs[propsKey] ?? {} };
		currentProps.shading = {
			fill: normalizedColor,
			val: "clear",
			color: "auto"
		};
		const syncAttrs = resolved.scope === "table" ? syncExtractedTableAttrs(currentProps) : {};
		tr.setNodeMarkup(resolved.pos, null, {
			...currentAttrs,
			[propsKey]: currentProps,
			...syncAttrs
		});
		if (resolved.scope === "table") applyShadingToCells(tr, resolved.node, resolved.pos + 1, normalizedColor);
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		if (resolved.scope === "table") return buildTableSuccess(resolvePostMutationTableAddress(editor, resolved.pos, resolved.address.nodeId, tr));
		return buildTableSuccess(resolved.address);
	} catch {
		return toTableFailure("INVALID_TARGET", "Shading update could not be applied.");
	}
}
function tablesClearShadingAdapter(editor, input, options) {
	rejectTrackedMode("tables.clearShading", options);
	const resolved = resolveTableOrCellTarget(editor, input, "tables.clearShading");
	if (resolved.scope === "invalid") return toTableFailure("INVALID_TARGET", "tables.clearShading: target must be a table or tableCell.");
	if (options?.dryRun) return buildTableSuccess(resolved.address);
	try {
		const tr = editor.state.tr;
		const currentAttrs = resolved.node.attrs;
		const propsKey = resolved.scope === "table" ? "tableProperties" : "tableCellProperties";
		const currentProps = { ...currentAttrs[propsKey] ?? {} };
		delete currentProps.shading;
		const syncAttrs = resolved.scope === "table" ? syncExtractedTableAttrs(currentProps) : {};
		tr.setNodeMarkup(resolved.pos, null, {
			...currentAttrs,
			[propsKey]: currentProps,
			...syncAttrs
		});
		if (resolved.scope === "table") {
			const tableNode = resolved.node;
			const tableStart = resolved.pos + 1;
			const map$1 = TableMap.get(tableNode);
			const seen = /* @__PURE__ */ new Set();
			const mapFrom = tr.mapping.maps.length;
			for (let i = 0; i < map$1.map.length; i++) {
				const relPos = map$1.map[i];
				if (seen.has(relPos)) continue;
				seen.add(relPos);
				const cellNode = tableNode.nodeAt(relPos);
				if (!cellNode) continue;
				const cellAttrs = cellNode.attrs;
				const cellProps = { ...cellAttrs.tableCellProperties ?? {} };
				delete cellProps.shading;
				const nextCellAttrs = {
					...cellAttrs,
					tableCellProperties: cellProps
				};
				delete nextCellAttrs.background;
				tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(tableStart + relPos), null, nextCellAttrs);
			}
		}
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		if (resolved.scope === "table") return buildTableSuccess(resolvePostMutationTableAddress(editor, resolved.pos, resolved.address.nodeId, tr));
		return buildTableSuccess(resolved.address);
	} catch {
		return toTableFailure("INVALID_TARGET", "Shading clear could not be applied.");
	}
}
function tablesSetTablePaddingAdapter(editor, input, options) {
	rejectTrackedMode("tables.setTablePadding", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.setTablePadding");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const tr = editor.state.tr;
		const currentAttrs = candidate.node.attrs;
		const currentTableProps = { ...currentAttrs.tableProperties ?? {} };
		currentTableProps.cellMargins = {
			marginTop: {
				value: Math.round(input.topPt * POINTS_TO_TWIPS),
				type: "dxa"
			},
			marginRight: {
				value: Math.round(input.rightPt * POINTS_TO_TWIPS),
				type: "dxa"
			},
			marginBottom: {
				value: Math.round(input.bottomPt * POINTS_TO_TWIPS),
				type: "dxa"
			},
			marginLeft: {
				value: Math.round(input.leftPt * POINTS_TO_TWIPS),
				type: "dxa"
			}
		};
		tr.setNodeMarkup(candidate.pos, null, {
			...currentAttrs,
			tableProperties: currentTableProps,
			...syncExtractedTableAttrs(currentTableProps)
		});
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Table padding could not be applied.");
	}
}
function tablesSetCellPaddingAdapter(editor, input, options) {
	rejectTrackedMode("tables.setCellPadding", options);
	const { table, cellPos, cellNode } = resolveCellLocator(editor, input, "tables.setCellPadding");
	if (options?.dryRun) return buildTableSuccess(table.address);
	try {
		const tr = editor.state.tr;
		const currentAttrs = cellNode.attrs;
		const currentCellProps = { ...currentAttrs.tableCellProperties ?? {} };
		const cellMargins = {
			top: Math.round(input.topPt * (96 / 72)),
			right: Math.round(input.rightPt * (96 / 72)),
			bottom: Math.round(input.bottomPt * (96 / 72)),
			left: Math.round(input.leftPt * (96 / 72))
		};
		currentCellProps.cellMargins = {
			top: {
				w: Math.round(input.topPt * 20),
				type: "dxa"
			},
			right: {
				w: Math.round(input.rightPt * 20),
				type: "dxa"
			},
			bottom: {
				w: Math.round(input.bottomPt * 20),
				type: "dxa"
			},
			left: {
				w: Math.round(input.leftPt * 20),
				type: "dxa"
			}
		};
		tr.setNodeMarkup(cellPos, null, {
			...currentAttrs,
			cellMargins,
			tableCellProperties: currentCellProps
		});
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, table.candidate.pos, table.address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Cell padding could not be applied.");
	}
}
function tablesSetCellSpacingAdapter(editor, input, options) {
	rejectTrackedMode("tables.setCellSpacing", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.setCellSpacing");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const tr = editor.state.tr;
		const currentAttrs = candidate.node.attrs;
		const currentTableProps = { ...currentAttrs.tableProperties ?? {} };
		currentTableProps.tableCellSpacing = {
			value: Math.round(input.spacingPt * 20),
			type: "dxa"
		};
		tr.setNodeMarkup(candidate.pos, null, {
			...currentAttrs,
			tableProperties: currentTableProps,
			...syncExtractedTableAttrs(currentTableProps)
		});
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Cell spacing could not be applied.");
	}
}
function tablesClearCellSpacingAdapter(editor, input, options) {
	rejectTrackedMode("tables.clearCellSpacing", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.clearCellSpacing");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const tr = editor.state.tr;
		const currentAttrs = candidate.node.attrs;
		const currentTableProps = { ...currentAttrs.tableProperties ?? {} };
		delete currentTableProps.tableCellSpacing;
		delete currentTableProps.tblCellSpacing;
		tr.setNodeMarkup(candidate.pos, null, {
			...currentAttrs,
			tableProperties: currentTableProps,
			...syncExtractedTableAttrs(currentTableProps)
		});
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Cell spacing removal could not be applied.");
	}
}
var XML_KEY_TO_STYLE_OPTION = {
	firstRow: "headerRow",
	lastRow: "lastRow",
	firstColumn: "firstColumn",
	lastColumn: "lastColumn",
	noHBand: "bandedRows",
	noVBand: "bandedColumns"
};
function readTableLookAsState(tblLook) {
	if (!tblLook) return void 0;
	const result = {};
	let hasAny = false;
	for (const [xmlKey, apiFlag] of Object.entries(XML_KEY_TO_STYLE_OPTION)) if (xmlKey in tblLook && typeof tblLook[xmlKey] === "boolean") {
		const rawValue = tblLook[xmlKey];
		result[apiFlag] = INVERTED_FLAGS.has(apiFlag) ? !rawValue : rawValue;
		hasAny = true;
	}
	return hasAny ? result : void 0;
}
function writeTableLook(currentLook, patch) {
	const result = currentLook ? { ...currentLook } : { ...WORD_DEFAULT_TBL_LOOK };
	for (const [apiFlag, value] of Object.entries(patch)) {
		if (value === void 0) continue;
		const normalizedFlag = apiFlag;
		const xmlKey = resolveStyleOptionFlag(normalizedFlag);
		result[xmlKey] = INVERTED_FLAGS.has(normalizedFlag) ? !value : value;
	}
	delete result.val;
	return result;
}
function normalizeColorInput(color) {
	if (color === "auto") return "auto";
	const stripped = color.startsWith("#") ? color.slice(1) : color;
	return (stripped.length === 3 ? stripped[0] + stripped[0] + stripped[1] + stripped[1] + stripped[2] + stripped[2] : stripped).toUpperCase();
}
function normalizeBorderSpecFromApi(spec) {
	return {
		val: spec.lineStyle,
		size: Math.round(spec.lineWeightPt * 8),
		color: normalizeColorInput(spec.color)
	};
}
function normalizeBorderSpecToApi(border) {
	const rawColor = typeof border.color === "string" ? border.color : "auto";
	const color = rawColor === "auto" ? "auto" : rawColor.toUpperCase();
	return {
		lineStyle: String(border.val ?? "single"),
		lineWeightPt: typeof border.size === "number" ? border.size / 8 : 0,
		color
	};
}
var CLEARED_BORDER_OOXML = {
	val: "none",
	size: 0,
	color: "auto"
};
function isClearedBorder(border) {
	return border.val === "none" || border.val === "nil";
}
function readBorderEdge(border) {
	if (!border || typeof border !== "object") return void 0;
	const b$1 = border;
	if (isClearedBorder(b$1)) return null;
	return normalizeBorderSpecToApi(b$1);
}
function readBordersAsState(borders) {
	if (!borders || typeof borders !== "object") return void 0;
	const b$1 = borders;
	const result = {};
	let hasAny = false;
	for (const edge of [
		"top",
		"bottom",
		"left",
		"right",
		"insideH",
		"insideV"
	]) if (edge in b$1) {
		const value = readBorderEdge(b$1[edge]);
		if (value !== void 0) {
			result[edge] = value;
			hasAny = true;
		}
	}
	return hasAny ? result : void 0;
}
var TABLE_MARGIN_KEY_GROUPS = [
	{
		keys: ["marginTop"],
		apiKey: "topPt"
	},
	{
		keys: ["marginRight", "marginEnd"],
		apiKey: "rightPt"
	},
	{
		keys: ["marginBottom"],
		apiKey: "bottomPt"
	},
	{
		keys: ["marginLeft", "marginStart"],
		apiKey: "leftPt"
	}
];
function readCellMarginEntry(cellMargins, keys$1) {
	for (const key of keys$1) {
		const entry = cellMargins[key];
		if (entry && typeof entry.value === "number") return entry;
	}
}
function readCellMarginsAsState(cellMargins) {
	if (!cellMargins || typeof cellMargins !== "object") return void 0;
	const cm = cellMargins;
	const result = {};
	let hasAny = false;
	for (const { keys: keys$1, apiKey } of TABLE_MARGIN_KEY_GROUPS) {
		const entry = readCellMarginEntry(cm, keys$1);
		if (entry && typeof entry.value === "number") {
			result[apiKey] = entry.value / POINTS_TO_TWIPS;
			hasAny = true;
		}
	}
	return hasAny ? result : void 0;
}
function readCellSpacingPt(spacing) {
	if (!spacing || typeof spacing !== "object") return void 0;
	const s = spacing;
	if (typeof s.value !== "number") return void 0;
	return s.value / POINTS_TO_TWIPS;
}
function expandApplyToEdges(applyTo) {
	switch (applyTo) {
		case "all": return [
			"top",
			"bottom",
			"left",
			"right",
			"insideH",
			"insideV"
		];
		case "outside": return [
			"top",
			"bottom",
			"left",
			"right"
		];
		case "inside": return ["insideH", "insideV"];
		default: return [applyTo];
	}
}
function buildOoxmlBorderPatch(currentBorders, edgePatch) {
	const result = { ...currentBorders };
	const edges = Object.entries(edgePatch);
	for (const [edge, value] of edges) {
		if (value === void 0) continue;
		result[edge] = value === null ? { ...CLEARED_BORDER_OOXML } : normalizeBorderSpecFromApi(value);
	}
	return result;
}
function isStylePatchSatisfied(currentTableProps, input) {
	if (input.styleId !== void 0) {
		if (currentTableProps.tableStyleId !== input.styleId) return false;
	}
	if (input.styleOptions) {
		const currentLook = currentTableProps.tblLook ?? {};
		for (const [apiFlag, value] of Object.entries(input.styleOptions)) {
			if (value === void 0) continue;
			const normalizedFlag = apiFlag;
			const xmlKey = resolveStyleOptionFlag(normalizedFlag);
			const expectedXmlValue = INVERTED_FLAGS.has(normalizedFlag) ? !value : value;
			if (!(xmlKey in currentLook) || currentLook[xmlKey] !== expectedXmlValue) return false;
		}
	}
	return true;
}
function isTableOptionsSatisfied(currentTableProps, input) {
	if (input.defaultCellMargins !== void 0) {
		const cm = currentTableProps.cellMargins;
		if (!cm) return false;
		const m$1 = input.defaultCellMargins;
		const pairs = [
			[["marginTop"], m$1.topPt],
			[["marginRight", "marginEnd"], m$1.rightPt],
			[["marginBottom"], m$1.bottomPt],
			[["marginLeft", "marginStart"], m$1.leftPt]
		];
		for (const [ooxmlKeys, ptValue] of pairs) {
			const entry = readCellMarginEntry(cm, ooxmlKeys);
			if (!entry || entry.value !== Math.round(ptValue * POINTS_TO_TWIPS)) return false;
		}
	}
	if (input.cellSpacingPt !== void 0) {
		const spacing = currentTableProps.tableCellSpacing;
		if (input.cellSpacingPt === null) {
			if (spacing !== void 0 && spacing !== null) return false;
		} else if (!spacing || spacing.value !== Math.round(input.cellSpacingPt * POINTS_TO_TWIPS)) return false;
	}
	return true;
}
function tablesApplyStyleAdapter(editor, input, options) {
	rejectTrackedMode("tables.applyStyle", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.applyStyle");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const currentAttrs = candidate.node.attrs;
		const currentTableProps = currentAttrs.tableProperties ?? {};
		if (isStylePatchSatisfied(currentTableProps, input)) return toTableFailure("NO_OP", "tables.applyStyle did not produce a change.");
		const updatedTableProps = { ...currentTableProps };
		if (input.styleId !== void 0) updatedTableProps.tableStyleId = input.styleId;
		if (input.styleOptions) updatedTableProps.tblLook = writeTableLook(asRecord(updatedTableProps.tblLook), input.styleOptions);
		const tr = editor.state.tr;
		tr.setNodeMarkup(candidate.pos, null, {
			...currentAttrs,
			tableProperties: updatedTableProps,
			...syncExtractedTableAttrs(updatedTableProps)
		});
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Table style application could not be applied.");
	}
}
function tablesSetBordersAdapter(editor, input, options) {
	rejectTrackedMode("tables.setBorders", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.setBorders");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		let edgePatch;
		if (input.mode === "applyTo") {
			const edges = expandApplyToEdges(input.applyTo);
			edgePatch = {};
			for (const edge of edges) edgePatch[edge] = input.border;
		} else edgePatch = input.edges;
		const tr = editor.state.tr;
		const currentAttrs = candidate.node.attrs;
		const currentTableProps = { ...currentAttrs.tableProperties ?? {} };
		currentTableProps.borders = buildOoxmlBorderPatch(currentTableProps.borders ?? {}, edgePatch);
		tr.setNodeMarkup(candidate.pos, null, {
			...currentAttrs,
			tableProperties: currentTableProps,
			...syncExtractedTableAttrs(currentTableProps)
		});
		const patchEntries = Object.entries(edgePatch);
		for (const [edge, value] of patchEntries) {
			if (value === void 0) continue;
			if (!isBoundaryEdge(edge)) continue;
			const ooxmlSpec = value === null ? { ...CLEARED_BORDER_OOXML } : normalizeBorderSpecFromApi(value);
			applyTableEdgeToCellBorders(tr, candidate.pos, candidate.node, edge, ooxmlSpec);
		}
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Table border update could not be applied.");
	}
}
function tablesSetTableOptionsAdapter(editor, input, options) {
	rejectTrackedMode("tables.setTableOptions", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.setTableOptions");
	if (options?.dryRun) return buildTableSuccess(address);
	try {
		const currentAttrs = candidate.node.attrs;
		const currentTableProps = currentAttrs.tableProperties ?? {};
		if (isTableOptionsSatisfied(currentTableProps, input)) return toTableFailure("NO_OP", "tables.setTableOptions did not produce a change.");
		const updatedTableProps = { ...currentTableProps };
		if (input.defaultCellMargins !== void 0) {
			const m$1 = input.defaultCellMargins;
			updatedTableProps.cellMargins = {
				marginTop: {
					value: Math.round(m$1.topPt * POINTS_TO_TWIPS),
					type: "dxa"
				},
				marginRight: {
					value: Math.round(m$1.rightPt * POINTS_TO_TWIPS),
					type: "dxa"
				},
				marginBottom: {
					value: Math.round(m$1.bottomPt * POINTS_TO_TWIPS),
					type: "dxa"
				},
				marginLeft: {
					value: Math.round(m$1.leftPt * POINTS_TO_TWIPS),
					type: "dxa"
				}
			};
		}
		if (input.cellSpacingPt !== void 0) if (input.cellSpacingPt === null) {
			delete updatedTableProps.tableCellSpacing;
			delete updatedTableProps.tblCellSpacing;
		} else updatedTableProps.tableCellSpacing = {
			value: Math.round(input.cellSpacingPt * POINTS_TO_TWIPS),
			type: "dxa"
		};
		const tr = editor.state.tr;
		tr.setNodeMarkup(candidate.pos, null, {
			...currentAttrs,
			tableProperties: updatedTableProps,
			...syncExtractedTableAttrs(updatedTableProps)
		});
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, candidate.pos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Table options could not be applied.");
	}
}
function tablesApplyPresetAdapter(editor, input, options) {
	rejectTrackedMode("tables.applyPreset", options);
	const { candidate, address } = resolveTableLocator(editor, input, "tables.applyPreset");
	if (options?.dryRun) return buildTableSuccess(address);
	const spec = buildPresetSpec(input.preset, input.accentColor);
	if (!spec) return toTableFailure("INVALID_TARGET", `tables.applyPreset: unknown preset "${input.preset}".`);
	try {
		const tr = editor.state.tr;
		const tableNode = candidate.node;
		const tablePos = candidate.pos;
		const currentAttrs = tableNode.attrs;
		const currentTableProps = { ...currentAttrs.tableProperties ?? {} };
		currentTableProps.borders = buildOoxmlBorderPatch(currentTableProps.borders ?? {}, spec.borders);
		if (Object.keys(spec.styleOptions).length > 0) {
			const updatedLook = { ...currentTableProps.tblLook ?? { ...WORD_DEFAULT_TBL_LOOK } };
			for (const [flag, value] of Object.entries(spec.styleOptions)) {
				if (value === void 0) continue;
				const ooxmlKey = resolveStyleOptionFlag(flag);
				updatedLook[ooxmlKey] = INVERTED_FLAGS.has(flag) ? !value : value;
			}
			currentTableProps.tblLook = updatedLook;
		}
		tr.setNodeMarkup(tablePos, null, {
			...currentAttrs,
			tableProperties: currentTableProps,
			...syncExtractedTableAttrs(currentTableProps)
		});
		const patchEntries = Object.entries(spec.borders);
		for (const [edge, value] of patchEntries) {
			if (value === void 0) continue;
			if (!isBoundaryEdge(edge)) continue;
			applyTableEdgeToCellBorders(tr, tablePos, tableNode, edge, value === null ? { ...CLEARED_BORDER_OOXML } : normalizeBorderSpecFromApi(value));
		}
		if (spec.headerRowFill && tableNode.childCount > 0) {
			const map$1 = TableMap.get(tableNode);
			const headerCellPositions = map$1.map.slice(0, map$1.width);
			applyShadingToCells(tr, tableNode, tablePos + 1, spec.headerRowFill, headerCellPositions);
		}
		applyDirectMutationMeta(tr);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return buildTableSuccess(resolvePostMutationTableAddress(editor, tablePos, address.nodeId, tr));
	} catch {
		return toTableFailure("INVALID_TARGET", "Table preset could not be applied.");
	}
}
function resolveCreatedTable(editor, tableId) {
	const index = getBlockIndex(editor);
	const resolved = index.byId.get(`table:${tableId}`);
	if (resolved) return resolved;
	const bySdBlockId = index.candidates.find((candidate) => {
		if (candidate.nodeType !== "table") return false;
		const attrs = candidate.node.attrs;
		return typeof attrs?.sdBlockId === "string" && attrs.sdBlockId === tableId;
	});
	if (bySdBlockId) return bySdBlockId;
	throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Created table could not be resolved after insertion.", { tableId });
}
function createTableAdapter(editor, input, options) {
	const insertTableAt$1 = requireEditorCommand(editor.commands?.insertTableAt, "create.table");
	const mode = options?.changeMode ?? "direct";
	if (mode === "tracked") ensureTrackedCapability(editor, { operation: "create.table" });
	const insertAt = resolveTableCreateLocation(editor, input.at ?? { kind: "documentEnd" }, "create.table");
	if (options?.dryRun) {
		if (!editor.can().insertTableAt?.({
			pos: insertAt,
			rows: input.rows,
			columns: input.columns,
			tracked: mode === "tracked"
		})) return {
			success: false,
			failure: {
				code: "INVALID_TARGET",
				message: "Table creation could not be applied at the requested location."
			}
		};
		return {
			success: true,
			table: {
				kind: "block",
				nodeType: "table",
				nodeId: "(dry-run)"
			}
		};
	}
	const tableId = v4_default();
	if (!insertTableAt$1({
		pos: insertAt,
		rows: input.rows,
		columns: input.columns,
		sdBlockId: tableId,
		tracked: mode === "tracked"
	})) return {
		success: false,
		failure: {
			code: "INVALID_TARGET",
			message: "Table creation could not be applied at the requested location."
		}
	};
	clearIndexCache(editor);
	try {
		const table = resolveCreatedTable(editor, tableId);
		const trackedChangeRefs = mode === "tracked" ? collectTrackInsertRefsInRange(editor, table.pos, table.end) : void 0;
		return {
			success: true,
			table: {
				kind: "block",
				nodeType: "table",
				nodeId: table.nodeId
			},
			trackedChangeRefs
		};
	} catch {
		return {
			success: true,
			table: {
				kind: "block",
				nodeType: "table",
				nodeId: tableId
			}
		};
	}
}
function asRecord(value) {
	return value && typeof value === "object" ? value : void 0;
}
function resolveTableLook(tableProps) {
	return asRecord(tableProps.tblLook);
}
function mapJustificationToTableAlignment(value) {
	switch (value) {
		case "left":
		case "start": return "left";
		case "center": return "center";
		case "right":
		case "end": return "right";
		default: return;
	}
}
function mapTableLayoutToAutoFitMode(layout, tableWidth) {
	if (layout === "fixed") return "fixedWidth";
	if (layout === "autofit") return tableWidth?.type === "pct" ? "fitWindow" : "fitContents";
}
function resolveMeasurementValue(value) {
	if (typeof value === "number" && Number.isFinite(value)) return value;
	if (typeof value === "string") {
		const parsed = Number(value);
		if (Number.isFinite(parsed)) return parsed;
	}
}
function resolvePreferredWidth(value) {
	const numeric = resolveMeasurementValue(value);
	if (numeric != null) return numeric;
	const record = asRecord(value);
	if (!record) return void 0;
	return resolveMeasurementValue(record.value) ?? resolveMeasurementValue(record.width);
}
function resolveCellNodeId(attrs) {
	for (const field of [
		"paraId",
		"sdBlockId",
		"blockId",
		"id",
		"uuid",
		"nodeId"
	]) {
		const value = attrs[field];
		if (typeof value === "string" && value.length > 0) return value;
	}
	return "";
}
function tablesGetAdapter(editor, input) {
	const resolved = resolveTableLocator(editor, input, "tables.get");
	const tableNode = resolved.candidate.node;
	return {
		nodeId: resolved.candidate.nodeId,
		address: resolved.address,
		rows: tableNode.childCount,
		columns: getTableColumnCount(tableNode)
	};
}
function tablesGetCellsAdapter(editor, input) {
	const resolved = resolveTableLocator(editor, input, "tables.getCells");
	const tableNode = resolved.candidate.node;
	const tablePos = resolved.candidate.pos;
	const tableEnd = resolved.candidate.end;
	const tableStart = resolved.candidate.pos + 1;
	const map$1 = TableMap.get(tableNode);
	const index = getBlockIndex(editor);
	const cells = [];
	for (const candidate of index.candidates) {
		if (candidate.nodeType !== "tableCell") continue;
		if (candidate.pos <= tablePos || candidate.end > tableEnd) continue;
		const offsets = [candidate.pos - tableStart, candidate.pos - tablePos];
		let mapIndex = -1;
		for (const offset$1 of offsets) {
			mapIndex = map$1.map.indexOf(offset$1);
			if (mapIndex !== -1) break;
		}
		if (mapIndex === -1) continue;
		const row = Math.floor(mapIndex / map$1.width);
		const col = mapIndex % map$1.width;
		if (input.rowIndex != null && row !== input.rowIndex) continue;
		if (input.columnIndex != null && col !== input.columnIndex) continue;
		const attrs = candidate.node.attrs;
		const cellNodeId = candidate.nodeId || resolveCellNodeId(attrs);
		cells.push({
			nodeId: cellNodeId,
			address: {
				kind: "block",
				nodeType: "tableCell",
				nodeId: cellNodeId
			},
			rowIndex: row,
			columnIndex: col,
			colspan: typeof attrs.colspan === "number" ? attrs.colspan : 1,
			rowspan: typeof attrs.rowspan === "number" ? attrs.rowspan : 1
		});
	}
	cells.sort((a, b$1) => a.rowIndex - b$1.rowIndex || a.columnIndex - b$1.columnIndex);
	return {
		nodeId: resolved.candidate.nodeId,
		address: resolved.address,
		cells
	};
}
function tablesGetPropertiesAdapter(editor, input) {
	const resolved = resolveTableLocator(editor, input, "tables.getProperties");
	const tp = asRecord(resolved.candidate.node.attrs?.tableProperties) ?? {};
	const result = {
		nodeId: resolved.candidate.nodeId,
		address: resolved.address
	};
	if (tp.tableStyleId != null) result.styleId = String(tp.tableStyleId);
	const alignment$1 = mapJustificationToTableAlignment(tp.justification);
	if (alignment$1) result.alignment = alignment$1;
	if (tp.rightToLeft === true) result.direction = "rtl";
	else if (tp.rightToLeft === false) result.direction = "ltr";
	const tableWidth = asRecord(tp.tableWidth);
	const autoFitMode = mapTableLayoutToAutoFitMode(tp.tableLayout, tableWidth);
	if (autoFitMode) result.autoFitMode = autoFitMode;
	if (autoFitMode !== "fitWindow") {
		const preferredWidth = resolvePreferredWidth(tp.tableWidth);
		if (preferredWidth != null) result.preferredWidth = preferredWidth;
	}
	const styleOptions = readTableLookAsState(resolveTableLook(tp));
	if (styleOptions) result.styleOptions = styleOptions;
	const borders = readBordersAsState(tp.borders);
	if (borders) result.borders = borders;
	const defaultCellMargins = readCellMarginsAsState(tp.cellMargins);
	if (defaultCellMargins) result.defaultCellMargins = defaultCellMargins;
	const cellSpacingPt = readCellSpacingPt(tp.tableCellSpacing);
	if (cellSpacingPt !== void 0) result.cellSpacingPt = cellSpacingPt;
	return result;
}
function getConverterForStyles(editor) {
	return editor.converter;
}
function toDocumentMutationFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function toDocumentMutationSuccess() {
	return { success: true };
}
function tablesGetStylesAdapter(editor, _input) {
	const converter = getConverterForStyles(editor);
	if (!converter) return {
		explicitDefaultStyleId: null,
		effectiveDefaultStyleId: null,
		effectiveDefaultSource: "none",
		styles: []
	};
	const translatedLinkedStyles = readTranslatedLinkedStyles(editor);
	const allStyles = translatedLinkedStyles?.styles ?? {};
	const styles = [];
	for (const [id, def] of Object.entries(allStyles)) {
		if (def.type !== "table") continue;
		styles.push({
			id,
			name: def.name ?? null,
			basedOn: def.basedOn ?? null,
			isDefault: def.default === true,
			isCustom: def.customStyle === true,
			uiPriority: def.uiPriority ?? null,
			hidden: def.hidden === true || def.semiHidden === true,
			quickFormat: def.qFormat === true,
			conditionalRegions: def.tableStyleProperties ? Object.keys(def.tableStyleProperties) : []
		});
	}
	let explicitDefaultStyleId = null;
	const settingsRoot = readSettingsRoot(converter);
	if (settingsRoot) explicitDefaultStyleId = readDefaultTableStyle(settingsRoot);
	const resolved = resolvePreferredNewTableStyleId(explicitDefaultStyleId, translatedLinkedStyles);
	return {
		explicitDefaultStyleId,
		effectiveDefaultStyleId: resolved.styleId,
		effectiveDefaultSource: resolved.source,
		styles
	};
}
function tablesSetDefaultStyleAdapter(editor, input, options) {
	rejectTrackedMode("tables.setDefaultStyle", options);
	const converter = getConverterForStyles(editor);
	if (!converter) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "tables.setDefaultStyle requires an active document converter.");
	if (!isKnownTableStyleId(input.styleId, readTranslatedLinkedStyles(editor))) throw new DocumentApiAdapterError("INVALID_INPUT", `tables.setDefaultStyle: "${input.styleId}" is not a known table style.`);
	return mutatePart({
		editor,
		partId: SETTINGS_PART$1,
		operation: "mutate",
		source: "tables.setDefaultStyle",
		dryRun: options?.dryRun === true,
		expectedRevision: options?.expectedRevision,
		mutate({ part, dryRun: isDryRun }) {
			const existingRoot = readSettingsRoot(converter);
			if ((existingRoot ? readDefaultTableStyle(existingRoot) : null) === input.styleId) return toDocumentMutationFailure("NO_OP", "tables.setDefaultStyle did not produce a document settings change.");
			if (!isDryRun) setDefaultTableStyle(ensureSettingsRoot(part), input.styleId);
			return toDocumentMutationSuccess();
		}
	}).result;
}
function tablesClearDefaultStyleAdapter(editor, _input, options) {
	rejectTrackedMode("tables.clearDefaultStyle", options);
	const converter = getConverterForStyles(editor);
	if (!converter) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "tables.clearDefaultStyle requires an active document converter.");
	return mutatePart({
		editor,
		partId: SETTINGS_PART$1,
		operation: "mutate",
		source: "tables.clearDefaultStyle",
		dryRun: options?.dryRun === true,
		expectedRevision: options?.expectedRevision,
		mutate({ part, dryRun: isDryRun }) {
			const existingRoot = readSettingsRoot(converter);
			if ((existingRoot ? readDefaultTableStyle(existingRoot) : null) === null) return toDocumentMutationFailure("NO_OP", "tables.clearDefaultStyle did not produce a document settings change.");
			if (!isDryRun) removeDefaultTableStyle(ensureSettingsRoot(part));
			return toDocumentMutationSuccess();
		}
	}).result;
}
function targetBlockId(t) {
	return t?.kind === "range" ? t.blockId : "";
}
function selectionTargetToRange(t) {
	const startPoint = t.normalizedTarget.start;
	const endPoint = t.normalizedTarget.end;
	const blockId = startPoint.kind === "text" ? startPoint.blockId : endPoint.kind === "text" ? endPoint.blockId : "__selection__";
	return {
		kind: "range",
		stepId: t.stepId,
		op: t.op,
		blockId,
		from: 0,
		to: t.absTo - t.absFrom,
		absFrom: t.absFrom,
		absTo: t.absTo,
		text: t.text,
		marks: [],
		capturedStyle: t.capturedStyle
	};
}
function partitionTargets(targets) {
	const range = [];
	const span = [];
	const selection = [];
	for (const t of targets) if (t.kind === "range") range.push(t);
	else if (t.kind === "selection") selection.push(t);
	else span.push(t);
	return {
		range,
		span,
		selection
	};
}
function sortRangeTargets(targets) {
	return [...targets].sort((a, b$1) => {
		if (a.blockId === b$1.blockId) return a.from - b$1.from;
		return a.absFrom - b$1.absFrom;
	});
}
function buildRangeResolution(target) {
	return {
		target: {
			kind: "text",
			blockId: target.blockId,
			range: {
				start: target.from,
				end: target.to
			}
		},
		range: {
			from: target.from,
			to: target.to
		},
		text: target.text
	};
}
function buildSpanResolution(target) {
	return {
		targets: target.segments.map((seg) => ({
			kind: "text",
			blockId: seg.blockId,
			range: {
				start: seg.from,
				end: seg.to
			}
		})),
		matchId: target.matchId,
		text: target.text
	};
}
function buildSelectionResolution(target) {
	return {
		selectionTarget: target.normalizedTarget,
		range: {
			from: target.absFrom,
			to: target.absTo
		},
		text: target.text
	};
}
function resolveDomainHandler(step) {
	const maybeHandler = step._handler;
	return typeof maybeHandler === "function" ? maybeHandler : void 0;
}
function executeTextStep(ctx$1, targets, step, rangeExecutor, spanExecutor) {
	const { range, span, selection } = partitionTargets(targets);
	let overallChanged = false;
	const resolutions = [];
	const spanResolutions = [];
	const selectionResolutions = [];
	for (const target of sortRangeTargets(range)) {
		resolutions.push(buildRangeResolution(target));
		const { changed } = rangeExecutor(ctx$1.editor, ctx$1.tr, target, step, ctx$1.mapping);
		if (changed) overallChanged = true;
	}
	for (const selTarget of selection) {
		selectionResolutions.push(buildSelectionResolution(selTarget));
		const rangeTarget = selectionTargetToRange(selTarget);
		const { changed } = rangeExecutor(ctx$1.editor, ctx$1.tr, rangeTarget, step, ctx$1.mapping);
		if (changed) overallChanged = true;
	}
	for (const target of span) {
		spanResolutions.push(buildSpanResolution(target));
		if (!spanExecutor) throw planError("INVALID_INPUT", `step op "${step.op}" does not support cross-block targets`, step.id);
		const { changed } = spanExecutor(ctx$1.editor, ctx$1.tr, target, step, ctx$1.mapping);
		if (changed) overallChanged = true;
	}
	const effect$3 = overallChanged ? "changed" : "noop";
	const data = {
		domain: "text",
		resolutions,
		...spanResolutions.length > 0 ? { spanResolutions } : {},
		...selectionResolutions.length > 0 ? { selectionResolutions } : {}
	};
	return {
		stepId: step.id,
		op: step.op,
		effect: effect$3,
		matchCount: targets.length,
		data
	};
}
function ensureFormatStepCapabilities(ctx$1, step) {
	const inlineKeys = step.args.inline ? Object.keys(step.args.inline) : [];
	const capabilityIssue = getInlinePropertyCapabilityIssue(ctx$1.editor, inlineKeys, step.op);
	if (capabilityIssue) throw planError(capabilityIssue.code, capabilityIssue.message, step.id, capabilityIssue.details);
	if (ctx$1.changeMode !== "tracked") return;
	const trackedIssue = getTrackedInlinePropertySupportIssue(inlineKeys, step.op);
	if (trackedIssue) throw planError(trackedIssue.code, trackedIssue.message, step.id, trackedIssue.details);
}
var TABLE_ADAPTER_DISPATCH = {
	"tables.delete": (e, i, o) => tablesDeleteAdapter(e, i, o),
	"tables.clearContents": (e, i, o) => tablesClearContentsAdapter(e, i, o),
	"tables.move": (e, i, o) => tablesMoveAdapter(e, i, o),
	"tables.split": (e, i, o) => tablesSplitAdapter(e, i, o),
	"tables.convertFromText": (e, i, o) => tablesConvertFromTextAdapter(e, i, o),
	"tables.convertToText": (e, i, o) => tablesConvertToTextAdapter(e, i, o),
	"tables.setLayout": (e, i, o) => tablesSetLayoutAdapter(e, i, o),
	"tables.insertRow": (e, i, o) => tablesInsertRowAdapter(e, i, o),
	"tables.deleteRow": (e, i, o) => tablesDeleteRowAdapter(e, i, o),
	"tables.setRowHeight": (e, i, o) => tablesSetRowHeightAdapter(e, i, o),
	"tables.distributeRows": (e, i, o) => tablesDistributeRowsAdapter(e, i, o),
	"tables.setRowOptions": (e, i, o) => tablesSetRowOptionsAdapter(e, i, o),
	"tables.insertColumn": (e, i, o) => tablesInsertColumnAdapter(e, i, o),
	"tables.deleteColumn": (e, i, o) => tablesDeleteColumnAdapter(e, i, o),
	"tables.setColumnWidth": (e, i, o) => tablesSetColumnWidthAdapter(e, i, o),
	"tables.distributeColumns": (e, i, o) => tablesDistributeColumnsAdapter(e, i, o),
	"tables.insertCell": (e, i, o) => tablesInsertCellAdapter(e, i, o),
	"tables.deleteCell": (e, i, o) => tablesDeleteCellAdapter(e, i, o),
	"tables.mergeCells": (e, i, o) => tablesMergeCellsAdapter(e, i, o),
	"tables.unmergeCells": (e, i, o) => tablesUnmergeCellsAdapter(e, i, o),
	"tables.splitCell": (e, i, o) => tablesSplitCellAdapter(e, i, o),
	"tables.setCellProperties": (e, i, o) => tablesSetCellPropertiesAdapter(e, i, o),
	"tables.sort": (e, i, o) => tablesSortAdapter(e, i, o),
	"tables.setAltText": (e, i, o) => tablesSetAltTextAdapter(e, i, o),
	"tables.setStyle": (e, i, o) => tablesSetStyleAdapter(e, i, o),
	"tables.clearStyle": (e, i, o) => tablesClearStyleAdapter(e, i, o),
	"tables.setStyleOption": (e, i, o) => tablesSetStyleOptionAdapter(e, i, o),
	"tables.setBorder": (e, i, o) => tablesSetBorderAdapter(e, i, o),
	"tables.clearBorder": (e, i, o) => tablesClearBorderAdapter(e, i, o),
	"tables.applyBorderPreset": (e, i, o) => tablesApplyBorderPresetAdapter(e, i, o),
	"tables.setShading": (e, i, o) => tablesSetShadingAdapter(e, i, o),
	"tables.clearShading": (e, i, o) => tablesClearShadingAdapter(e, i, o),
	"tables.setTablePadding": (e, i, o) => tablesSetTablePaddingAdapter(e, i, o),
	"tables.setCellPadding": (e, i, o) => tablesSetCellPaddingAdapter(e, i, o),
	"tables.setCellSpacing": (e, i, o) => tablesSetCellSpacingAdapter(e, i, o),
	"tables.clearCellSpacing": (e, i, o) => tablesClearCellSpacingAdapter(e, i, o)
};
var ROW_TARGETED_TABLE_OPS = new Set([
	"tables.insertRow",
	"tables.deleteRow",
	"tables.setRowHeight",
	"tables.setRowOptions"
]);
function buildTableInput(op, blockId, args$1) {
	const { target: _target, nodeId: _n, ...safeArgs } = args$1;
	if (ROW_TARGETED_TABLE_OPS.has(op) && safeArgs.rowIndex == null) return {
		...safeArgs,
		target: {
			kind: "block",
			nodeType: "tableRow",
			nodeId: blockId
		}
	};
	return {
		...safeArgs,
		nodeId: blockId
	};
}
var registered = false;
function registerBuiltInExecutors() {
	if (registered) return;
	registered = true;
	registerStepExecutor("text.rewrite", { execute: (ctx$1, targets, step) => executeTextStep(ctx$1, targets, step, (e, tr, t, s, m$1) => executeTextRewrite(e, tr, t, s, m$1), (e, tr, t, s, m$1) => executeSpanTextRewrite(e, tr, t, s, m$1)) });
	registerStepExecutor("text.insert", { execute: (ctx$1, targets, step) => executeTextStep(ctx$1, targets, step, (e, tr, t, s, m$1) => executeTextInsert(e, tr, t, s, m$1)) });
	registerStepExecutor("text.delete", { execute: (ctx$1, targets, step) => executeTextStep(ctx$1, targets, step, (e, tr, t, s, m$1) => executeTextDelete(e, tr, t, s, m$1), (e, tr, t, s, m$1) => executeSpanTextDelete(e, tr, t, s, m$1)) });
	registerStepExecutor("format.apply", { execute: (ctx$1, targets, step) => {
		ensureFormatStepCapabilities(ctx$1, step);
		return executeTextStep(ctx$1, targets, step, (e, tr, t, s, m$1) => executeStyleApply(e, tr, t, s, m$1), (e, tr, t, s, m$1) => executeSpanStyleApply(e, tr, t, s, m$1));
	} });
	registerStepExecutor("create.paragraph", { execute: (ctx$1, targets, step) => executeCreateStep(ctx$1.editor, ctx$1.tr, step, targets, ctx$1.mapping) });
	registerStepExecutor("create.heading", { execute: (ctx$1, targets, step) => executeCreateStep(ctx$1.editor, ctx$1.tr, step, targets, ctx$1.mapping) });
	registerStepExecutor("domain.command", { execute(ctx$1, _targets, step) {
		const handler = resolveDomainHandler(step);
		if (!handler) return {
			stepId: step.id,
			op: step.op,
			effect: "noop",
			matchCount: 0,
			data: {
				domain: "command",
				commandDispatched: false
			}
		};
		const success = handler();
		if (success) ctx$1.commandDispatched = true;
		const effect$3 = success ? "changed" : "noop";
		const data = {
			domain: "command",
			commandDispatched: success
		};
		return {
			stepId: step.id,
			op: step.op,
			effect: effect$3,
			matchCount: success ? 1 : 0,
			data
		};
	} });
	registerStepExecutor("tables", { execute(ctx$1, targets, step) {
		if (targets.length > 1) throw planError("INVALID_INPUT", `table operation "${step.op}" requires exactly one target, got ${targets.length}`, step.id);
		if (ctx$1.isPreview) return {
			stepId: step.id,
			op: step.op,
			effect: "noop",
			matchCount: targets.length,
			data: {
				domain: "table",
				tableId: targetBlockId(targets[0])
			}
		};
		const handler = step._handler;
		if (handler) {
			const result$1 = handler();
			if (result$1.success) ctx$1.commandDispatched = true;
			return {
				stepId: step.id,
				op: step.op,
				effect: result$1.success ? "changed" : "noop",
				matchCount: result$1.success ? 1 : 0,
				data: {
					domain: "table",
					tableId: result$1.tableId ?? ""
				}
			};
		}
		const adapterFn = TABLE_ADAPTER_DISPATCH[step.op];
		if (!adapterFn || !targets[0]) return {
			stepId: step.id,
			op: step.op,
			effect: "noop",
			matchCount: 0,
			data: {
				domain: "table",
				tableId: ""
			}
		};
		const input = buildTableInput(step.op, targetBlockId(targets[0]), step.args);
		const result = adapterFn(ctx$1.editor, input, { changeMode: ctx$1.changeMode });
		if (result.success) ctx$1.commandDispatched = true;
		return {
			stepId: step.id,
			op: step.op,
			effect: result.success ? "changed" : "noop",
			matchCount: result.success ? 1 : 0,
			data: {
				domain: "table",
				tableId: targetBlockId(targets[0])
			}
		};
	} });
	registerStepExecutor("structural.insert", { execute(ctx$1, targets, step) {
		if (ctx$1.isPreview) return {
			stepId: step.id,
			op: step.op,
			effect: "noop",
			matchCount: targets.length,
			data: { domain: "structural" }
		};
		const structuralStep = step;
		if (targets.length > 1) throw planError("INVALID_INPUT", `structural.insert requires at most one target, got ${targets.length}`, step.id);
		if (targets.length === 0) return {
			stepId: step.id,
			op: step.op,
			effect: "noop",
			matchCount: 0,
			data: { domain: "structural" }
		};
		const target = targets[0];
		const targetAddress = target?.kind === "range" ? {
			kind: "text",
			blockId: target.blockId,
			range: {
				start: target.from,
				end: target.to
			}
		} : void 0;
		const result = executeStructuralInsert(ctx$1.editor, {
			target: targetAddress,
			content: structuralStep.args.content,
			placement: structuralStep.args.placement,
			nestingPolicy: structuralStep.args.nestingPolicy,
			changeMode: ctx$1.changeMode
		});
		if (result.success) ctx$1.commandDispatched = true;
		return {
			stepId: step.id,
			op: step.op,
			effect: result.success ? "changed" : "noop",
			matchCount: result.success ? 1 : 0,
			data: {
				domain: "structural",
				insertedBlockIds: result.insertedBlockIds
			}
		};
	} });
	registerStepExecutor("structural.replace", { execute(ctx$1, targets, step) {
		if (ctx$1.isPreview) return {
			stepId: step.id,
			op: step.op,
			effect: "noop",
			matchCount: targets.length,
			data: { domain: "structural" }
		};
		const structuralStep = step;
		if (targets.length > 1) throw planError("INVALID_INPUT", `structural.replace requires exactly one target, got ${targets.length}`, step.id);
		const target = targets[0];
		if (!target || target.kind !== "range") return {
			stepId: step.id,
			op: step.op,
			effect: "noop",
			matchCount: 0,
			data: { domain: "structural" }
		};
		const result = executeStructuralReplace(ctx$1.editor, {
			target: {
				kind: "text",
				blockId: target.blockId,
				range: {
					start: target.from,
					end: target.to
				}
			},
			content: structuralStep.args.content,
			nestingPolicy: structuralStep.args.nestingPolicy,
			changeMode: ctx$1.changeMode
		});
		if (result.success) ctx$1.commandDispatched = true;
		return {
			stepId: step.id,
			op: step.op,
			effect: result.success ? "changed" : "noop",
			matchCount: result.success ? 1 : 0,
			data: {
				domain: "structural",
				insertedBlockIds: result.insertedBlockIds
			}
		};
	} });
	registerStepExecutor("create.table", { execute(ctx$1, _targets, step) {
		if (_targets.length > 1) throw planError("INVALID_INPUT", `create.table requires exactly one target, got ${_targets.length}`, step.id);
		if (ctx$1.isPreview) return {
			stepId: step.id,
			op: step.op,
			effect: "noop",
			matchCount: _targets.length,
			data: {
				domain: "table",
				tableId: targetBlockId(_targets[0])
			}
		};
		const handler = step._handler;
		if (handler) {
			const result$1 = handler();
			if (result$1.success) ctx$1.commandDispatched = true;
			return {
				stepId: step.id,
				op: step.op,
				effect: result$1.success ? "changed" : "noop",
				matchCount: result$1.success ? 1 : 0,
				data: {
					domain: "table",
					tableId: result$1.nodeId ?? ""
				}
			};
		}
		const args$1 = step.args;
		const input = {
			rows: args$1.rows,
			columns: args$1.columns,
			at: args$1.at
		};
		const result = createTableAdapter(ctx$1.editor, input, { changeMode: ctx$1.changeMode });
		if (result.success) ctx$1.commandDispatched = true;
		return {
			stepId: step.id,
			op: step.op,
			effect: result.success ? "changed" : "noop",
			matchCount: result.success ? 1 : 0,
			data: {
				domain: "table",
				tableId: result.success ? result.table?.nodeId ?? "" : ""
			}
		};
	} });
}
var STYLES_PART_ID = "word/styles.xml";
function getConverter$7(editor) {
	return editor.converter;
}
const stylesPartDescriptor = {
	id: STYLES_PART_ID,
	ensurePart(editor) {
		const converter = getConverter$7(editor);
		if (converter?.convertedXml[STYLES_PART_ID]) return converter.convertedXml[STYLES_PART_ID];
		return {
			type: "element",
			name: "document",
			elements: [{
				type: "element",
				name: "w:styles",
				elements: []
			}]
		};
	},
	afterCommit(ctx$1) {
		if (ctx$1.source.startsWith("collab:remote:") || ctx$1.source === "templates.apply") {
			const converter = getConverter$7(ctx$1.editor);
			if (converter) try {
				converter.translatedLinkedStyles = translateStyleDefinitions(converter.convertedXml);
			} catch (err) {
				console.warn("[parts] Failed to rebuild translatedLinkedStyles:", err);
			}
		}
		ctx$1.editor.emit("stylesDefaultsChanged");
	}
};
const settingsPartDescriptor = {
	id: "word/settings.xml",
	ensurePart() {
		return {
			type: "element",
			name: "document",
			elements: [{
				type: "element",
				name: "w:settings",
				elements: []
			}]
		};
	}
};
var RELS_PART_ID = "word/_rels/document.xml.rels";
var HEADER_RELATIONSHIP_TYPE$1 = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header";
var FOOTER_RELATIONSHIP_TYPE$1 = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer";
function getConverter$6(editor) {
	return editor.converter;
}
function createEmptyHeaderFooterJson() {
	return {
		type: "doc",
		content: [{
			type: "paragraph",
			content: []
		}]
	};
}
function syncHeaderFooterCaches(editor, part) {
	const converter = getConverter$6(editor);
	if (!converter) return;
	const relsRoot = getRelationshipsRoot(part);
	if (!relsRoot?.elements) return;
	let changed = false;
	for (const el of relsRoot.elements) {
		if (el.name !== "Relationship") continue;
		const type = el.attributes?.Type;
		const id = el.attributes?.Id;
		if (!id) continue;
		const isHeader = type === HEADER_RELATIONSHIP_TYPE$1;
		if (!isHeader && !(type === FOOTER_RELATIONSHIP_TYPE$1)) continue;
		const variantIds = isHeader ? converter.headerIds ??= {} : converter.footerIds ??= {};
		if (!Array.isArray(variantIds.ids)) variantIds.ids = [];
		if (variantIds.ids.includes(id)) continue;
		variantIds.ids.push(id);
		const collection = isHeader ? converter.headers ??= {} : converter.footers ??= {};
		if (!(id in collection)) collection[id] = createEmptyHeaderFooterJson();
		changed = true;
	}
	if (changed) converter.headerFooterModified = true;
}
const relsPartDescriptor = {
	id: RELS_PART_ID,
	ensurePart() {
		return createRelationshipsPart();
	},
	afterCommit({ editor, part }) {
		syncHeaderFooterCaches(editor, part);
	}
};
function createTableWrapper(editor, input, options) {
	if (options?.dryRun) {
		checkRevision(editor, options?.expectedRevision);
		return createTableAdapter(editor, input, options);
	}
	let adapterResult;
	executeCompiledPlan(editor, {
		mutationSteps: [{
			step: {
				id: v4_default(),
				op: "create.table",
				where: STUB_WHERE,
				args: {},
				_handler: () => {
					adapterResult = createTableAdapter(editor, input, options);
					return {
						success: adapterResult.success,
						nodeId: adapterResult.success ? adapterResult.table.nodeId : void 0
					};
				}
			},
			targets: []
		}],
		assertSteps: [],
		compiledRevision: getRevision(editor)
	}, {
		expectedRevision: options?.expectedRevision,
		changeMode: options?.changeMode
	});
	return adapterResult;
}
function getConverter$5(editor) {
	return editor.converter;
}
function toSectionFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function toSectionSuccess(section) {
	return {
		success: true,
		section
	};
}
function toDocumentSuccess() {
	return { success: true };
}
function toCreateFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function toCreateSuccess(section, breakParagraphId) {
	return {
		success: true,
		section,
		breakParagraph: {
			kind: "block",
			nodeType: "paragraph",
			nodeId: breakParagraphId
		}
	};
}
function createSectionBreakId() {
	const randomUuid = globalThis.crypto?.randomUUID?.();
	if (randomUuid) return randomUuid;
	return `section-break-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
function readParagraphSectPr(node) {
	const sectPr = (node.attrs ?? {}).paragraphProperties?.sectPr;
	return sectPr && typeof sectPr === "object" ? sectPr : null;
}
function readTargetSectPr$1(editor, projection) {
	if (projection.target.kind === "paragraph") return readParagraphSectPr(projection.target.node);
	return getBodySectPrFromEditor(editor);
}
function buildSectionMarginsForAttrs(sectPr) {
	const margins = readSectPrMargins(sectPr);
	return {
		top: margins.top ?? null,
		right: margins.right ?? null,
		bottom: margins.bottom ?? null,
		left: margins.left ?? null,
		header: margins.header ?? null,
		footer: margins.footer ?? null
	};
}
function syncConverterBodySection(editor, sectPr) {
	const converter = getConverter$5(editor);
	if (!converter) return;
	converter.bodySectPr = cloneXmlElement(sectPr);
	const savedBodyNode = converter.savedTagsToRestore?.find((entry) => entry?.name === "w:body");
	if (savedBodyNode && Array.isArray(savedBodyNode.elements)) {
		const preservedChildren = savedBodyNode.elements.filter((entry) => entry?.name !== "w:sectPr");
		preservedChildren.push(cloneXmlElement(sectPr));
		savedBodyNode.elements = preservedChildren;
	}
	const margins = readSectPrMargins(sectPr);
	const pageSetup = readSectPrPageSetup(sectPr);
	if (!converter.pageStyles) converter.pageStyles = {};
	if (!converter.pageStyles.pageSize) converter.pageStyles.pageSize = {};
	if (pageSetup?.width !== void 0) converter.pageStyles.pageSize.width = pageSetup.width;
	if (pageSetup?.height !== void 0) converter.pageStyles.pageSize.height = pageSetup.height;
	if (!converter.pageStyles.pageMargins) converter.pageStyles.pageMargins = {};
	const pageMargins = converter.pageStyles.pageMargins;
	if (margins.top !== void 0) pageMargins.top = margins.top;
	if (margins.right !== void 0) pageMargins.right = margins.right;
	if (margins.bottom !== void 0) pageMargins.bottom = margins.bottom;
	if (margins.left !== void 0) pageMargins.left = margins.left;
	if (margins.header !== void 0) pageMargins.header = margins.header;
	if (margins.footer !== void 0) pageMargins.footer = margins.footer;
	if (margins.gutter !== void 0) pageMargins.gutter = margins.gutter;
}
function applySectPrToProjection(editor, projection, sectPr) {
	if (projection.target.kind === "paragraph") {
		const paragraph = projection.target.node;
		const attrs = paragraph.attrs ?? {};
		const paragraphProperties = {
			...attrs.paragraphProperties ?? {},
			sectPr
		};
		const nextAttrs = {
			...attrs,
			paragraphProperties,
			pageBreakSource: "sectPr",
			sectionMargins: buildSectionMarginsForAttrs(sectPr)
		};
		const tr$1 = applyDirectMutationMeta(editor.state.tr);
		tr$1.setNodeMarkup(projection.target.pos, void 0, nextAttrs, paragraph.marks);
		tr$1.setMeta("forceUpdatePagination", true);
		editor.dispatch(tr$1);
		return;
	}
	const tr = applyDirectMutationMeta(editor.state.tr);
	tr.setDocAttribute("bodySectPr", sectPr);
	tr.setMeta("forceUpdatePagination", true);
	editor.dispatch(tr);
	syncConverterBodySection(editor, sectPr);
}
function sectionMutationBySectPr$1(editor, input, options, operationName, mutate) {
	rejectTrackedMode(operationName, options);
	checkRevision(editor, options?.expectedRevision);
	const sections = resolveSectionProjections(editor);
	const projection = sections.find((entry) => entry.sectionId === input.target.sectionId);
	if (!projection) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Section target was not found.", { target: input.target });
	const dryRun = options?.dryRun === true;
	const nextSectPr = ensureSectPrElement(readTargetSectPr$1(editor, projection));
	const before = JSON.stringify(nextSectPr);
	const earlyResult = mutate(nextSectPr, projection, sections, dryRun);
	if (earlyResult) return earlyResult;
	if (!(before !== JSON.stringify(nextSectPr))) return toSectionFailure("NO_OP", `${operationName} did not produce a section change.`);
	if (options?.dryRun) return toSectionSuccess(projection.address);
	applySectPrToProjection(editor, projection, nextSectPr);
	clearIndexCache(editor);
	return toSectionSuccess(projection.address);
}
function resolveInsertPosition(editor, location$1) {
	const target = location$1 ?? { kind: "documentEnd" };
	if (target.kind === "documentStart") return 0;
	if (target.kind === "documentEnd") return editor.state.doc.content.size;
	return resolveBlockInsertionPos(editor, target.target.nodeId, target.kind);
}
function buildSectPrFromCreateInput(input) {
	const sectPr = createSectPrElement();
	if (input.breakType) writeSectPrBreakType(sectPr, input.breakType);
	if (input.pageMargins) writeSectPrPageMargins(sectPr, input.pageMargins);
	if (input.headerFooterMargins) writeSectPrHeaderFooterMargins(sectPr, input.headerFooterMargins);
	return sectPr;
}
function createSectionBreakNode(editor, breakParagraphId, input) {
	const paragraphType = editor.state.schema.nodes.paragraph;
	if (!paragraphType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "create.sectionBreak requires a paragraph node type.");
	const sectPr = buildSectPrFromCreateInput(input);
	const attrs = {
		sdBlockId: breakParagraphId,
		paragraphProperties: { sectPr },
		pageBreakSource: "sectPr",
		sectionMargins: buildSectionMarginsForAttrs(sectPr)
	};
	const paragraphNode = paragraphType.createAndFill(attrs, void 0) ?? paragraphType.create(attrs, void 0);
	if (!paragraphNode) throw new DocumentApiAdapterError("INVALID_TARGET", "Unable to construct a section-break paragraph node.");
	return paragraphNode;
}
function updateGlobalTitlePageFlag(editor) {
	const converter = getConverter$5(editor);
	if (!converter) return;
	const anyTitlePage = resolveSectionProjections(editor).some((entry) => entry.domain.titlePage === true);
	if (!converter.headerIds) converter.headerIds = {};
	if (!converter.footerIds) converter.footerIds = {};
	converter.headerIds.titlePg = anyTitlePage;
	converter.footerIds.titlePg = anyTitlePage;
}
function createSectionBreakAdapter(editor, input, options) {
	rejectTrackedMode("create.sectionBreak", options);
	checkRevision(editor, options?.expectedRevision);
	const breakParagraphId = options?.dryRun ? "(dry-run)" : createSectionBreakId();
	const insertPos = resolveInsertPosition(editor, input.at);
	const paragraphNode = createSectionBreakNode(editor, breakParagraphId, input);
	try {
		editor.state.tr.insert(insertPos, paragraphNode);
		if (options?.dryRun) return toCreateSuccess({
			kind: "section",
			sectionId: "section-(dry-run)"
		}, breakParagraphId);
	} catch {
		return toCreateFailure("INVALID_TARGET", "create.sectionBreak could not insert at the requested location.");
	}
	const tr = applyDirectMutationMeta(editor.state.tr.insert(insertPos, paragraphNode));
	tr.setMeta("forceUpdatePagination", true);
	editor.dispatch(tr);
	clearIndexCache(editor);
	return toCreateSuccess(resolveSectionProjections(editor).find((projection) => projection.target.kind === "paragraph" && projection.target.nodeId === breakParagraphId)?.address ?? getDefaultSectionAddress(editor), breakParagraphId);
}
function sectionsListAdapter(editor, query) {
	return sectionsListAdapter$1(editor, query);
}
function sectionsGetAdapterByInput(editor, input) {
	return sectionsGetAdapter(editor, input.address);
}
function sectionsSetBreakTypeAdapter(editor, input, options) {
	return sectionMutationBySectPr$1(editor, input, options, "sections.setBreakType", (sectPr) => {
		writeSectPrBreakType(sectPr, input.breakType);
	});
}
function sectionsSetPageMarginsAdapter(editor, input, options) {
	return sectionMutationBySectPr$1(editor, input, options, "sections.setPageMargins", (sectPr) => {
		writeSectPrPageMargins(sectPr, input);
	});
}
function sectionsSetHeaderFooterMarginsAdapter(editor, input, options) {
	return sectionMutationBySectPr$1(editor, input, options, "sections.setHeaderFooterMargins", (sectPr) => {
		writeSectPrHeaderFooterMargins(sectPr, input);
	});
}
function sectionsSetPageSetupAdapter(editor, input, options) {
	return sectionMutationBySectPr$1(editor, input, options, "sections.setPageSetup", (sectPr) => {
		writeSectPrPageSetup(sectPr, input);
	});
}
function sectionsSetColumnsAdapter(editor, input, options) {
	return sectionMutationBySectPr$1(editor, input, options, "sections.setColumns", (sectPr) => {
		writeSectPrColumns(sectPr, input);
	});
}
function sectionsSetLineNumberingAdapter(editor, input, options) {
	return sectionMutationBySectPr$1(editor, input, options, "sections.setLineNumbering", (sectPr) => {
		writeSectPrLineNumbering(sectPr, input);
	});
}
function sectionsSetPageNumberingAdapter(editor, input, options) {
	return sectionMutationBySectPr$1(editor, input, options, "sections.setPageNumbering", (sectPr) => {
		writeSectPrPageNumbering(sectPr, input);
	});
}
function sectionsSetTitlePageAdapter(editor, input, options) {
	const result = sectionMutationBySectPr$1(editor, input, options, "sections.setTitlePage", (sectPr) => {
		writeSectPrTitlePage(sectPr, input.enabled);
	});
	if (result.success && !options?.dryRun) updateGlobalTitlePageFlag(editor);
	return result;
}
function sectionsSetOddEvenHeadersFootersAdapter(editor, input, options) {
	rejectTrackedMode("sections.setOddEvenHeadersFooters", options);
	const converter = getConverter$5(editor);
	if (!converter) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "sections.setOddEvenHeadersFooters requires an active document converter.");
	return mutatePart({
		editor,
		partId: "word/settings.xml",
		operation: "mutate",
		source: "sections.setOddEvenHeadersFooters",
		dryRun: options?.dryRun === true,
		expectedRevision: options?.expectedRevision,
		mutate({ part, dryRun: isDryRun }) {
			const existingRoot = readSettingsRoot(converter);
			if (!((existingRoot ? hasOddEvenHeadersFooters(existingRoot) : false) !== input.enabled)) return toSectionFailure("NO_OP", "sections.setOddEvenHeadersFooters did not produce a document settings change.");
			if (!isDryRun) {
				setOddEvenHeadersFooters(ensureSettingsRoot(part), input.enabled);
				if (!converter.pageStyles) converter.pageStyles = {};
				converter.pageStyles.alternateHeaders = input.enabled;
			}
			return toDocumentSuccess();
		}
	}).result;
}
function sectionsSetVerticalAlignAdapter(editor, input, options) {
	return sectionMutationBySectPr$1(editor, input, options, "sections.setVerticalAlign", (sectPr) => {
		writeSectPrVerticalAlign(sectPr, input.value);
	});
}
function sectionsSetSectionDirectionAdapter(editor, input, options) {
	return sectionMutationBySectPr$1(editor, input, options, "sections.setSectionDirection", (sectPr) => {
		writeSectPrDirection(sectPr, input.direction);
	});
}
function sectionsSetHeaderFooterRefAdapter(editor, input, options) {
	return sectionMutationBySectPr$1(editor, input, options, "sections.setHeaderFooterRef", (sectPr, _projection, _sections, dryRun) => {
		const converter = getConverter$5(editor) ?? null;
		return setHeaderFooterRefMutation(sectPr, input.kind, input.variant, input.refId, converter, "sections.setHeaderFooterRef", dryRun);
	});
}
function sectionsClearHeaderFooterRefAdapter(editor, input, options) {
	return sectionMutationBySectPr$1(editor, input, options, "sections.clearHeaderFooterRef", (sectPr, _projection, _sections, dryRun) => {
		const converter = getConverter$5(editor) ?? null;
		clearHeaderFooterRefMutation(sectPr, input.kind, input.variant, converter, dryRun);
	});
}
function sectionsSetLinkToPreviousAdapter(editor, input, options) {
	return sectionMutationBySectPr$1(editor, input, options, "sections.setLinkToPrevious", (sectPr, projection, sections, dryRun) => {
		return setLinkedToPreviousMutation(sectPr, projection, sections, input.kind, input.variant, input.linked, editor, dryRun, "sections.setLinkToPrevious");
	});
}
function sectionsSetPageBordersAdapter(editor, input, options) {
	return sectionMutationBySectPr$1(editor, input, options, "sections.setPageBorders", (sectPr) => {
		writeSectPrPageBorders(sectPr, input.borders);
	});
}
function sectionsClearPageBordersAdapter(editor, input, options) {
	return sectionMutationBySectPr$1(editor, input, options, "sections.clearPageBorders", (sectPr) => {
		clearSectPrPageBorders(sectPr);
	});
}
function executeTableCommand(editor, op, adapterFn, input, options) {
	if (options?.dryRun) {
		checkRevision(editor, options?.expectedRevision);
		return adapterFn(editor, input, options);
	}
	let adapterResult;
	executeCompiledPlan(editor, {
		mutationSteps: [{
			step: {
				id: v4_default(),
				op,
				where: STUB_WHERE,
				args: {},
				_handler: () => {
					adapterResult = adapterFn(editor, input, options);
					return { success: adapterResult.success };
				}
			},
			targets: []
		}],
		assertSteps: [],
		compiledRevision: getRevision(editor)
	}, {
		expectedRevision: options?.expectedRevision,
		changeMode: options?.changeMode
	});
	return adapterResult;
}
function tablesDeleteWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.delete", tablesDeleteAdapter, input, options);
}
function tablesClearContentsWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.clearContents", tablesClearContentsAdapter, input, options);
}
function tablesMoveWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.move", tablesMoveAdapter, input, options);
}
function tablesConvertFromTextWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.convertFromText", tablesConvertFromTextAdapter, input, options);
}
function tablesSplitWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.split", tablesSplitAdapter, input, options);
}
function tablesConvertToTextWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.convertToText", tablesConvertToTextAdapter, input, options);
}
function tablesSetLayoutWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setLayout", tablesSetLayoutAdapter, input, options);
}
function tablesInsertRowWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.insertRow", tablesInsertRowAdapter, input, options);
}
function tablesDeleteRowWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.deleteRow", tablesDeleteRowAdapter, input, options);
}
function tablesSetRowHeightWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setRowHeight", tablesSetRowHeightAdapter, input, options);
}
function tablesDistributeRowsWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.distributeRows", tablesDistributeRowsAdapter, input, options);
}
function tablesSetRowOptionsWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setRowOptions", tablesSetRowOptionsAdapter, input, options);
}
function tablesInsertColumnWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.insertColumn", tablesInsertColumnAdapter, input, options);
}
function tablesDeleteColumnWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.deleteColumn", tablesDeleteColumnAdapter, input, options);
}
function tablesSetColumnWidthWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setColumnWidth", tablesSetColumnWidthAdapter, input, options);
}
function tablesDistributeColumnsWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.distributeColumns", tablesDistributeColumnsAdapter, input, options);
}
function tablesInsertCellWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.insertCell", tablesInsertCellAdapter, input, options);
}
function tablesDeleteCellWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.deleteCell", tablesDeleteCellAdapter, input, options);
}
function tablesMergeCellsWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.mergeCells", tablesMergeCellsAdapter, input, options);
}
function tablesUnmergeCellsWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.unmergeCells", tablesUnmergeCellsAdapter, input, options);
}
function tablesSplitCellWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.splitCell", tablesSplitCellAdapter, input, options);
}
function tablesSetCellPropertiesWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setCellProperties", tablesSetCellPropertiesAdapter, input, options);
}
function tablesSetCellTextWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setCellText", tablesSetCellTextAdapter, input, options);
}
function tablesSortWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.sort", tablesSortAdapter, input, options);
}
function tablesSetAltTextWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setAltText", tablesSetAltTextAdapter, input, options);
}
function tablesSetStyleWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setStyle", tablesSetStyleAdapter, input, options);
}
function tablesClearStyleWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.clearStyle", tablesClearStyleAdapter, input, options);
}
function tablesSetStyleOptionWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setStyleOption", tablesSetStyleOptionAdapter, input, options);
}
function tablesSetBorderWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setBorder", tablesSetBorderAdapter, input, options);
}
function tablesClearBorderWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.clearBorder", tablesClearBorderAdapter, input, options);
}
function tablesApplyBorderPresetWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.applyBorderPreset", tablesApplyBorderPresetAdapter, input, options);
}
function tablesSetShadingWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setShading", tablesSetShadingAdapter, input, options);
}
function tablesClearShadingWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.clearShading", tablesClearShadingAdapter, input, options);
}
function tablesSetTablePaddingWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setTablePadding", tablesSetTablePaddingAdapter, input, options);
}
function tablesSetCellPaddingWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setCellPadding", tablesSetCellPaddingAdapter, input, options);
}
function tablesSetCellSpacingWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setCellSpacing", tablesSetCellSpacingAdapter, input, options);
}
function tablesClearCellSpacingWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.clearCellSpacing", tablesClearCellSpacingAdapter, input, options);
}
function tablesApplyStyleWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.applyStyle", tablesApplyStyleAdapter, input, options);
}
function tablesSetBordersWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setBorders", tablesSetBordersAdapter, input, options);
}
function tablesSetTableOptionsWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.setTableOptions", tablesSetTableOptionsAdapter, input, options);
}
function tablesApplyPresetWrapper(editor, input, options) {
	return executeTableCommand(editor, "tables.applyPreset", tablesApplyPresetAdapter, input, options);
}
var BatchHistoryAdapter = class {
	#done = [];
	#redone = [];
	#listeners = /* @__PURE__ */ new Set();
	record(batch) {
		this.#done.push(batch);
		this.#redone.length = 0;
		this.#notify();
	}
	getSnapshot() {
		return {
			undoDepth: this.#done.length,
			redoDepth: this.#redone.length
		};
	}
	undo() {
		const batch = this.#done.pop();
		if (!batch) return false;
		try {
			if (batch.undo() === false) {
				this.#done.push(batch);
				return false;
			}
		} catch {
			this.#done.push(batch);
			return false;
		}
		this.#redone.push(batch);
		this.#notify();
		return true;
	}
	redo() {
		const batch = this.#redone.pop();
		if (!batch) return false;
		try {
			if (batch.redo() === false) {
				this.#redone.push(batch);
				return false;
			}
		} catch {
			this.#redone.push(batch);
			return false;
		}
		this.#done.push(batch);
		this.#notify();
		return true;
	}
	subscribe(onChange$1) {
		this.#listeners.add(onChange$1);
		return () => this.#listeners.delete(onChange$1);
	}
	#notify() {
		this.#listeners.forEach((listener) => listener());
	}
};
var BATCH_PARTICIPANT_KEY = "internal:batch";
var DEFAULT_GLOBAL_HISTORY_CAP = 500;
var stateEquals = (a, b$1) => a.canUndo === b$1.canUndo && a.canRedo === b$1.canRedo && a.undoDepth === b$1.undoDepth && a.redoDepth === b$1.redoDepth;
var DocumentHistoryCoordinator = class {
	#participants = /* @__PURE__ */ new Map();
	#doneStack = [];
	#redoStack = [];
	#changeListeners = /* @__PURE__ */ new Set();
	#cueListeners = /* @__PURE__ */ new Set();
	#purgeListeners = /* @__PURE__ */ new Set();
	#capacity;
	#onDiagnostic;
	#batchAdapter = new BatchHistoryAdapter();
	#suppressionCount = 0;
	#seq = 0;
	#lastEmittedState = {
		canUndo: false,
		canRedo: false,
		undoDepth: 0,
		redoDepth: 0
	};
	#activeReplay = null;
	#activeSurface = "body";
	constructor(options = {}) {
		this.#capacity = Math.max(1, options.capacity ?? DEFAULT_GLOBAL_HISTORY_CAP);
		this.#onDiagnostic = options.onDiagnostic;
		this.register({
			key: BATCH_PARTICIPANT_KEY,
			surface: "body",
			adapter: this.#batchAdapter
		});
		this.setPinned(BATCH_PARTICIPANT_KEY, true);
	}
	withHistoryBatch(batch) {
		this.#batchAdapter.record(batch);
	}
	register(participant, options = {}) {
		const existing = this.#participants.get(participant.key);
		if (existing) existing.unsubscribe();
		const lastSnapshot = participant.adapter.getSnapshot();
		const unsubscribe = participant.adapter.subscribe(() => this.#onParticipantTransaction(participant.key));
		this.#participants.set(participant.key, {
			participant,
			lastSnapshot,
			pinned: existing?.pinned ?? options.pinned ?? false,
			unsubscribe
		});
		this.#onDiagnostic?.("unified-history: participant registered", {
			key: participant.key,
			surface: participant.surface,
			snapshot: lastSnapshot,
			replacedExisting: Boolean(existing)
		});
	}
	unregister(key) {
		const record = this.#participants.get(key);
		if (!record) return;
		record.unsubscribe();
		this.#participants.delete(key);
	}
	purge(key, reason = "unregister") {
		const record = this.#participants.get(key);
		if (record) {
			this.#invokeOnInvalidated(record);
			record.unsubscribe();
			this.#participants.delete(key);
		}
		this.#removeEntriesForKey(key);
		this.#notifyPurge(key, reason);
		this.#emitStateIfChanged();
	}
	#invokeOnInvalidated(record) {
		const hook = record.participant.onInvalidated;
		if (!hook) return;
		try {
			hook();
		} catch (error) {
			this.#onDiagnostic?.("unified-history: onInvalidated threw", {
				key: record.participant.key,
				error
			});
		}
	}
	hasParticipant(key) {
		return this.#participants.has(key);
	}
	setPinned(key, pinned) {
		const record = this.#participants.get(key);
		if (!record) return;
		record.pinned = pinned;
	}
	isPinned(key) {
		const record = this.#participants.get(key);
		return Boolean(record?.pinned);
	}
	getReachableKeys() {
		const keys$1 = /* @__PURE__ */ new Set();
		for (const entry of this.#doneStack) keys$1.add(entry.participantKey);
		for (const entry of this.#redoStack) keys$1.add(entry.participantKey);
		return keys$1;
	}
	setActiveSurface(surface) {
		this.#activeSurface = surface;
	}
	getActiveSurface() {
		return this.#activeSurface;
	}
	canUndo() {
		return this.#findExecutableEntry(this.#doneStack, "undo") !== null;
	}
	canRedo() {
		return this.#findExecutableEntry(this.#redoStack, "redo") !== null;
	}
	getState() {
		return {
			canUndo: this.canUndo(),
			canRedo: this.canRedo(),
			undoDepth: this.#doneStack.length,
			redoDepth: this.#redoStack.length
		};
	}
	undo() {
		return this.#replay("undo");
	}
	redo() {
		return this.#replay("redo");
	}
	syncParticipant(key) {
		this.#onParticipantTransaction(key);
	}
	onChange(listener) {
		this.#changeListeners.add(listener);
		return () => this.#changeListeners.delete(listener);
	}
	onCue(listener) {
		this.#cueListeners.add(listener);
		return () => this.#cueListeners.delete(listener);
	}
	onPurge(listener) {
		this.#purgeListeners.add(listener);
		return () => this.#purgeListeners.delete(listener);
	}
	destroy() {
		for (const record of this.#participants.values()) record.unsubscribe();
		this.#participants.clear();
		this.#doneStack.length = 0;
		this.#redoStack.length = 0;
		this.#changeListeners.clear();
		this.#cueListeners.clear();
		this.#purgeListeners.clear();
	}
	#onParticipantTransaction(key) {
		const record = this.#participants.get(key);
		if (!record) return;
		const previous = record.lastSnapshot;
		const current = record.participant.adapter.getSnapshot();
		record.lastSnapshot = current;
		this.#onDiagnostic?.("unified-history: participant transaction observed", {
			key,
			surface: record.participant.surface,
			previous,
			current,
			suppressionCount: this.#suppressionCount
		});
		if (this.#suppressionCount > 0) return;
		const changeKind = record.participant.adapter.consumePendingChangeKind?.() ?? "unknown";
		const undoIncreased = current.undoDepth > previous.undoDepth;
		const undoDecreased = current.undoDepth < previous.undoDepth;
		const redoIncreased = current.redoDepth > previous.redoDepth;
		const redoDecreased = current.redoDepth < previous.redoDepth;
		if (changeKind === "undo") {
			this.#mirrorExternalUndo(record.participant, previous, current);
			return;
		}
		if (changeKind === "redo") {
			this.#mirrorExternalRedo(record.participant, previous, current);
			return;
		}
		if (undoIncreased) {
			this.#recordLocalEdit(record.participant, current.undoDepth - previous.undoDepth);
			return;
		}
		if (undoDecreased) this.#discardTopEntriesForKey(this.#doneStack, record.participant.key, previous.undoDepth - current.undoDepth);
		if (redoIncreased) {
			this.#appendReplayEntries(this.#redoStack, record.participant, current.redoDepth - previous.redoDepth);
			this.#emitStateIfChanged();
			return;
		}
		if (redoDecreased) this.#discardTopEntriesForKey(this.#redoStack, record.participant.key, previous.redoDepth - current.redoDepth);
		this.#emitStateIfChanged();
	}
	#recordLocalEdit(participant, stepCount) {
		this.#appendReplayEntries(this.#doneStack, participant, stepCount);
		if (this.#redoStack.length > 0) this.#redoStack.length = 0;
		this.#onDiagnostic?.("unified-history: recorded local edit", {
			key: participant.key,
			surface: participant.surface,
			stepCount,
			state: this.getState()
		});
		this.#emitStateIfChanged();
	}
	#mirrorExternalUndo(participant, previous, current) {
		const stepCount = previous.undoDepth - current.undoDepth;
		if (stepCount <= 0) return;
		const unmatchedSteps = stepCount - this.#moveEntriesBetweenStacks(this.#doneStack, this.#redoStack, participant, stepCount);
		if (unmatchedSteps > 0) this.#discardTopEntriesForKey(this.#doneStack, participant.key, unmatchedSteps);
		this.#emitStateIfChanged();
	}
	#mirrorExternalRedo(participant, previous, current) {
		const stepCount = current.undoDepth - previous.undoDepth;
		if (stepCount <= 0) return;
		const unmatchedSteps = stepCount - this.#moveEntriesBetweenStacks(this.#redoStack, this.#doneStack, participant, stepCount);
		if (unmatchedSteps > 0) this.#appendReplayEntries(this.#doneStack, participant, unmatchedSteps);
		this.#emitStateIfChanged();
	}
	#findExecutableEntry(stack, action) {
		for (let i = stack.length - 1; i >= 0; i -= 1) {
			const entry = stack[i];
			const record = this.#participants.get(entry.participantKey);
			if (!record) continue;
			const snapshot = record.participant.adapter.getSnapshot();
			if (action === "undo" ? snapshot.undoDepth > 0 : snapshot.redoDepth > 0) return {
				entry,
				record
			};
		}
		return null;
	}
	#replay(action) {
		const source = action === "undo" ? this.#doneStack : this.#redoStack;
		const target = action === "undo" ? this.#redoStack : this.#doneStack;
		const hit = this.#findExecutableEntry(source, action);
		if (!hit) return false;
		const { entry, record } = hit;
		this.#removeEntryExact(source, entry);
		this.#activeReplay = {
			action,
			surface: entry.surface,
			key: entry.participantKey
		};
		this.#suppressionCount += 1;
		let didRun = false;
		try {
			didRun = action === "undo" ? record.participant.adapter.undo() : record.participant.adapter.redo();
		} catch (error) {
			this.#onDiagnostic?.("unified-history: adapter threw during replay", {
				action,
				key: entry.participantKey,
				error
			});
		} finally {
			this.#suppressionCount = Math.max(0, this.#suppressionCount - 1);
			record.lastSnapshot = record.participant.adapter.getSnapshot();
		}
		if (!didRun) {
			this.#onDiagnostic?.("unified-history: replay produced no local step", {
				action,
				key: entry.participantKey
			});
			source.push(entry);
			this.#activeReplay = null;
			this.#emitStateIfChanged();
			return false;
		}
		target.push({
			...entry,
			seq: ++this.#seq
		});
		this.#enforceCapacity();
		this.#onDiagnostic?.("unified-history: replay applied", {
			action,
			key: entry.participantKey,
			surface: entry.surface,
			activeSurface: this.#activeSurface,
			state: this.getState()
		});
		this.#emitCueIfCrossSurface(entry);
		this.#runFlushAfterReplay(record, action);
		this.#activeReplay = null;
		this.#emitStateIfChanged();
		return true;
	}
	#runFlushAfterReplay(record, action) {
		const hook = record.participant.flushAfterReplay;
		if (!hook) return;
		try {
			hook(action);
		} catch (error) {
			this.#onDiagnostic?.("unified-history: flushAfterReplay threw", {
				key: record.participant.key,
				action,
				error
			});
		}
	}
	#emitCueIfCrossSurface(entry) {
		const replay = this.#activeReplay;
		if (!replay) return;
		if (entry.surface === this.#activeSurface) return;
		const cue = {
			action: replay.action,
			surface: entry.surface,
			participantKey: entry.participantKey
		};
		this.#cueListeners.forEach((listener) => {
			try {
				listener(cue);
			} catch (error) {
				this.#onDiagnostic?.("unified-history: cue listener threw", { error });
			}
		});
	}
	#removeEntriesForKey(key) {
		this.#filterInPlace(this.#doneStack, (entry) => entry.participantKey !== key);
		this.#filterInPlace(this.#redoStack, (entry) => entry.participantKey !== key);
	}
	#discardTopEntriesForKey(stack, key, count) {
		return this.#takeTopEntriesForKey(stack, key, count).length;
	}
	#moveEntriesBetweenStacks(source, target, participant, count) {
		const movedEntries = this.#takeTopEntriesForKey(source, participant.key, count);
		movedEntries.forEach((entry) => {
			target.push({
				...entry,
				seq: ++this.#seq
			});
		});
		this.#enforceCapacity();
		return movedEntries.length;
	}
	#takeTopEntriesForKey(stack, key, count) {
		const removed = [];
		if (count <= 0) return removed;
		for (let i = stack.length - 1; i >= 0 && removed.length < count; i -= 1) {
			if (stack[i].participantKey !== key) continue;
			removed.push(stack[i]);
			stack.splice(i, 1);
		}
		return removed;
	}
	#appendReplayEntries(stack, participant, count) {
		for (let i = 0; i < count; i += 1) stack.push({
			seq: ++this.#seq,
			participantKey: participant.key,
			surface: participant.surface
		});
		this.#enforceCapacity();
	}
	#removeEntryExact(stack, entry) {
		for (let i = stack.length - 1; i >= 0; i -= 1) if (stack[i].seq === entry.seq) {
			stack.splice(i, 1);
			return;
		}
	}
	#enforceCapacity() {
		while (this.#doneStack.length + this.#redoStack.length > this.#capacity) {
			const victim = this.#doneStack.length > 0 ? this.#doneStack.shift() : this.#redoStack.shift();
			if (!victim) break;
			if (!this.#isKeyReferenced(victim.participantKey)) this.#notifyPurge(victim.participantKey, "capacity-eviction");
			this.#onDiagnostic?.("unified-history: capacity eviction", {
				key: victim.participantKey,
				surface: victim.surface
			});
		}
	}
	#isKeyReferenced(key) {
		for (const entry of this.#doneStack) if (entry.participantKey === key) return true;
		for (const entry of this.#redoStack) if (entry.participantKey === key) return true;
		return false;
	}
	#filterInPlace(array, predicate) {
		let writeIndex = 0;
		for (let readIndex = 0; readIndex < array.length; readIndex += 1) {
			const value = array[readIndex];
			if (predicate(value)) {
				array[writeIndex] = value;
				writeIndex += 1;
			}
		}
		array.length = writeIndex;
	}
	#emitStateIfChanged() {
		const next = this.getState();
		if (stateEquals(next, this.#lastEmittedState)) return;
		this.#lastEmittedState = next;
		this.#changeListeners.forEach((listener) => {
			try {
				listener();
			} catch (error) {
				this.#onDiagnostic?.("unified-history: change listener threw", { error });
			}
		});
	}
	#notifyPurge(key, reason) {
		this.#purgeListeners.forEach((listener) => {
			try {
				listener({
					key,
					reason
				});
			} catch (error) {
				this.#onDiagnostic?.("unified-history: purge listener threw", { error });
			}
		});
	}
};
var isYjsBacked = (editor) => {
	const opts = editor.options;
	return Boolean(opts?.collaborationProvider && opts?.ydoc);
};
var readYjsDepths = (editor) => {
	if (!editor.state) return {
		undoDepth: 0,
		redoDepth: 0
	};
	const manager = yUndoPluginKey.getState(editor.state)?.undoManager;
	return {
		undoDepth: manager?.undoStack?.length ?? 0,
		redoDepth: manager?.redoStack?.length ?? 0
	};
};
var readPmDepths = (editor) => {
	if (!editor.state) return {
		undoDepth: 0,
		redoDepth: 0
	};
	try {
		return {
			undoDepth: undoDepth(editor.state),
			redoDepth: redoDepth(editor.state)
		};
	} catch {
		return {
			undoDepth: 0,
			redoDepth: 0
		};
	}
};
const readEditorHistorySnapshot = (editor) => {
	return isYjsBacked(editor) ? readYjsDepths(editor) : readPmDepths(editor);
};
var EditorHistorySnapshotAdapter = class {
	#editor;
	#collaborative;
	#pendingChangeKind = "unknown";
	constructor(editor) {
		this.#editor = editor;
		this.#collaborative = isYjsBacked(editor);
	}
	getSnapshot() {
		if (this.#collaborative) return readYjsDepths(this.#editor);
		return readPmDepths(this.#editor);
	}
	undo() {
		return Boolean(runEditorUndo(this.#editor));
	}
	redo() {
		return Boolean(runEditorRedo(this.#editor));
	}
	consumePendingChangeKind() {
		const changeKind = this.#pendingChangeKind;
		this.#pendingChangeKind = "unknown";
		return changeKind;
	}
	subscribe(onChange$1) {
		const editor = this.#editor;
		if (!editor.on || !editor.off) return () => {};
		const handleTransaction = (payload) => {
			this.#pendingChangeKind = classifyTransaction(payload?.transaction);
			onChange$1();
		};
		editor.on("transaction", handleTransaction);
		return () => editor.off?.("transaction", handleTransaction);
	}
};
var classifyTransaction = (transaction) => {
	const inputType = transaction?.getMeta?.("inputType");
	if (inputType === "historyUndo") return "undo";
	if (inputType === "historyRedo") return "redo";
	if (transaction?.docChanged && transaction.getMeta?.("addToHistory") !== false) return "edit";
	return "unknown";
};
var HEADER_FOOTER_KEY_PREFIX = "hf:part:";
const BODY_PARTICIPANT_KEY = BODY_STORY_KEY;
const buildHeaderFooterParticipantKey = (refId) => `${HEADER_FOOTER_KEY_PREFIX}${refId}`;
const createBodyParticipant = (editor) => ({
	key: BODY_PARTICIPANT_KEY,
	surface: "body",
	adapter: new EditorHistorySnapshotAdapter(editor)
});
const createHeaderFooterParticipant = (editor, descriptor) => ({
	key: buildHeaderFooterParticipantKey(descriptor.id),
	surface: descriptor.kind,
	adapter: new EditorHistorySnapshotAdapter(editor)
});
const createNoteParticipant = (input) => {
	const surface = input.storyType === "footnote" ? "note" : "endnote";
	return {
		key: input.storyKey,
		surface,
		adapter: new EditorHistorySnapshotAdapter(input.editor),
		flushAfterReplay: input.flushAfterReplay,
		onInvalidated: input.onInvalidated
	};
};
var DEFAULT_CAPACITY = 20;
var DEFAULT_IDLE_TTL_MS = 600 * 1e3;
var SWEEP_INTERVAL_MS = 30 * 1e3;
var NoteEditorRegistry = class extends EventEmitter {
	#entries = /* @__PURE__ */ new Map();
	#capacity;
	#idleTtlMs;
	#now;
	#onBeforeAutoDispose;
	#scheduleSweep;
	#cancelSweep = null;
	constructor(options = {}) {
		super();
		this.#capacity = Math.max(1, options.capacity ?? DEFAULT_CAPACITY);
		this.#idleTtlMs = Math.max(0, options.idleTtlMs ?? DEFAULT_IDLE_TTL_MS);
		this.#now = options.now ?? (() => Date.now());
		this.#onBeforeAutoDispose = options.onBeforeAutoDispose;
		this.#scheduleSweep = options.scheduleSweep ?? defaultScheduleSweep;
	}
	get(storyKey) {
		const entry = this.#entries.get(storyKey);
		if (!entry) return null;
		entry.lastAccessMs = this.#now();
		return entry.editor;
	}
	register(input) {
		const existing = this.#entries.get(input.storyKey);
		if (existing) {
			existing.editor = input.editor;
			existing.locator = input.locator;
			existing.commit = input.commit ?? null;
			existing.lastAccessMs = this.#now();
			return;
		}
		const entry = {
			storyKey: input.storyKey,
			locator: input.locator,
			editor: input.editor,
			commit: input.commit ?? null,
			lastAccessMs: this.#now(),
			pinned: false,
			disposers: /* @__PURE__ */ new Set()
		};
		this.#entries.set(input.storyKey, entry);
		this.emit("editorCreated", {
			storyKey: input.storyKey,
			editor: input.editor,
			locator: input.locator
		});
		this.#syncSweepSchedule();
		this.#enforceCapacity();
	}
	attachDisposer(storyKey, disposer) {
		const entry = this.#entries.get(storyKey);
		if (!entry) {
			disposer();
			return;
		}
		entry.disposers.add(disposer);
	}
	setCommitHook(storyKey, commit) {
		const entry = this.#entries.get(storyKey);
		if (!entry) return;
		entry.commit = commit;
	}
	getCommitHook(storyKey) {
		return this.#entries.get(storyKey)?.commit ?? null;
	}
	pin(storyKey) {
		const entry = this.#entries.get(storyKey);
		if (!entry) return;
		entry.pinned = true;
		entry.lastAccessMs = this.#now();
		this.#syncSweepSchedule();
	}
	unpin(storyKey) {
		const entry = this.#entries.get(storyKey);
		if (!entry) return;
		entry.pinned = false;
		this.#syncSweepSchedule();
		this.#enforceCapacity();
	}
	isPinned(storyKey) {
		return this.#entries.get(storyKey)?.pinned ?? false;
	}
	touch(storyKey) {
		const entry = this.#entries.get(storyKey);
		if (!entry) return;
		entry.lastAccessMs = this.#now();
	}
	purge(storyKey, reason = "purge") {
		const entry = this.#entries.get(storyKey);
		if (!entry) return;
		this.#entries.delete(storyKey);
		this.#syncSweepSchedule();
		this.#disposeEntry(entry, reason);
	}
	get size() {
		return this.#entries.size;
	}
	keys() {
		return Array.from(this.#entries.keys());
	}
	runIdleSweep() {
		if (this.#idleTtlMs <= 0) return;
		const cutoff = this.#now() - this.#idleTtlMs;
		for (const [storyKey, entry] of this.#entries) {
			if (entry.pinned) continue;
			if (entry.lastAccessMs > cutoff) continue;
			this.#entries.delete(storyKey);
			this.#disposeEntry(entry, "idle");
		}
		this.#syncSweepSchedule();
	}
	destroy() {
		this.#cancelSweep?.();
		this.#cancelSweep = null;
		for (const entry of this.#entries.values()) this.#disposeEntry(entry, "destroy");
		this.#entries.clear();
		this.removeAllListeners();
	}
	#enforceCapacity() {
		const unpinned = [];
		for (const entry of this.#entries.values()) if (!entry.pinned) unpinned.push(entry);
		if (unpinned.length <= this.#capacity) return;
		unpinned.sort((a, b$1) => a.lastAccessMs - b$1.lastAccessMs);
		const excess = unpinned.length - this.#capacity;
		for (let i = 0; i < excess; i += 1) {
			const victim = unpinned[i];
			this.#entries.delete(victim.storyKey);
			this.#disposeEntry(victim, "cap");
		}
		this.#syncSweepSchedule();
	}
	#syncSweepSchedule() {
		if (this.#idleTtlMs <= 0) {
			this.#cancelSweep?.();
			this.#cancelSweep = null;
			return;
		}
		if (!Array.from(this.#entries.values()).some((entry) => !entry.pinned)) {
			this.#cancelSweep?.();
			this.#cancelSweep = null;
			return;
		}
		if (this.#cancelSweep) return;
		this.#cancelSweep = this.#scheduleSweep(() => this.runIdleSweep(), SWEEP_INTERVAL_MS);
	}
	#disposeEntry(entry, reason) {
		if (reason !== "purge" && reason !== "destroy") this.#onBeforeAutoDispose?.(entry.storyKey);
		entry.disposers.forEach((disposer) => {
			try {
				disposer();
			} catch (error) {
				console.warn("[NoteEditorRegistry] disposer threw:", error);
			}
		});
		try {
			entry.editor.destroy?.();
		} catch (error) {
			console.warn("[NoteEditorRegistry] editor.destroy threw:", error);
		}
		this.emit("editorDisposed", {
			storyKey: entry.storyKey,
			reason
		});
	}
};
var defaultScheduleSweep = (callback, intervalMs) => {
	if (typeof setInterval !== "function") return () => {};
	const handle = setInterval(callback, intervalMs);
	return () => clearInterval(handle);
};
function getRootPresentationHistoryOwner(editor) {
	const withPresentation = editor;
	const presentationEditor = withPresentation.presentationEditor ?? withPresentation._presentationEditor ?? null;
	if (!presentationEditor) return null;
	if (presentationEditor.editor !== editor) return null;
	return presentationEditor;
}
var HISTORY_UNSAFE_OPS = OPERATION_IDS.filter((id) => COMMAND_CATALOG[id].historyUnsafe === true);
function readHistoryDepths(editor) {
	const presentationOwner = getRootPresentationHistoryOwner(editor);
	if (presentationOwner) {
		const state = presentationOwner.getHistoryState();
		return {
			undoDepth: state.undoDepth,
			redoDepth: state.redoDepth
		};
	}
	return readEditorHistorySnapshot(editor);
}
function runHistoryCommand(editor, action) {
	const presentationOwner = getRootPresentationHistoryOwner(editor);
	if (presentationOwner) return action === "undo" ? presentationOwner.undo() : presentationOwner.redo();
	const command$1 = editor.commands?.[action];
	if (typeof command$1 !== "function") throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", `history.${action} command is not available.`, { reason: "missing_command" });
	return Boolean(command$1());
}
function buildAnchoredCommentIdSet(editor) {
	const ids = /* @__PURE__ */ new Set();
	try {
		for (const anchor of listCommentAnchors(editor)) {
			if (typeof anchor.commentId === "string" && anchor.commentId.length > 0) ids.add(anchor.commentId);
			if (typeof anchor.importedId === "string" && anchor.importedId.length > 0) ids.add(anchor.importedId);
		}
	} catch {
		return ids;
	}
	return ids;
}
function buildCommentLifecyclePayload(record) {
	const payload = { commentId: record.commentId };
	if (record.importedId !== void 0) payload.importedId = record.importedId;
	if (record.parentCommentId !== void 0) payload.parentCommentId = record.parentCommentId;
	if (record.commentText !== void 0) {
		payload.commentText = record.commentText;
		payload.text = record.commentText;
	}
	if (record.commentJSON !== void 0) payload.commentJSON = record.commentJSON;
	if (record.creatorName !== void 0) payload.creatorName = record.creatorName;
	if (record.creatorEmail !== void 0) payload.creatorEmail = record.creatorEmail;
	if (record.creatorImage !== void 0) payload.creatorImage = record.creatorImage;
	if (record.createdTime !== void 0) payload.createdTime = record.createdTime;
	if (record.isInternal !== void 0) payload.isInternal = record.isInternal;
	if (record.isDone !== void 0) payload.isDone = record.isDone;
	if (record.resolvedTime !== void 0) payload.resolvedTime = record.resolvedTime;
	if (record.fileId !== void 0) payload.fileId = record.fileId;
	if (record.documentId !== void 0) payload.documentId = record.documentId;
	return payload;
}
function emitCommentLifecycleEvents(editor, type, records) {
	const emitter = editor.emit;
	if (typeof emitter !== "function") return;
	for (const record of records) emitter.call(editor, "commentsUpdate", {
		type,
		comment: buildCommentLifecyclePayload(record)
	});
}
function reconcileCommentHistorySideEffects(editor) {
	const { restored, removed } = reconcileCommentEntityStoreWithAnchors(editor, buildAnchoredCommentIdSet(editor));
	if (removed.length > 0) emitCommentLifecycleEvents(editor, "deleted", removed);
	if (restored.length > 0) emitCommentLifecycleEvents(editor, "add", restored);
}
function createHistoryAdapter(editor) {
	return {
		get() {
			const { undoDepth: ud, redoDepth: rd } = readHistoryDepths(editor);
			return {
				undoDepth: ud,
				redoDepth: rd,
				canUndo: ud > 0,
				canRedo: rd > 0,
				historyUnsafeOperations: HISTORY_UNSAFE_OPS
			};
		},
		undo() {
			const revBefore = getRevision(editor);
			if (readHistoryDepths(editor).undoDepth === 0) return {
				noop: true,
				reason: "EMPTY_UNDO_STACK",
				revision: {
					before: revBefore,
					after: revBefore
				}
			};
			const success = runHistoryCommand(editor, "undo");
			if (success) reconcileCommentHistorySideEffects(editor);
			const revAfter = getRevision(editor);
			return {
				noop: !success,
				reason: success ? void 0 : "NO_EFFECT",
				revision: {
					before: revBefore,
					after: revAfter
				}
			};
		},
		redo() {
			const revBefore = getRevision(editor);
			if (readHistoryDepths(editor).redoDepth === 0) return {
				noop: true,
				reason: "EMPTY_REDO_STACK",
				revision: {
					before: revBefore,
					after: revBefore
				}
			};
			const success = runHistoryCommand(editor, "redo");
			if (success) reconcileCommentHistorySideEffects(editor);
			const revAfter = getRevision(editor);
			return {
				noop: !success,
				reason: success ? void 0 : "NO_EFFECT",
				revision: {
					before: revBefore,
					after: revAfter
				}
			};
		}
	};
}
var CANONICAL_COMMENT_IGNORED_KEYS = COMMENT_ATTRS_DIFF_IGNORED_KEYS.filter((key) => key !== "textJson" && key !== "elements" && key !== "commentId");
function canonicalizeComment(comment) {
	const result = {};
	for (const [key, value] of Object.entries(comment)) if (!CANONICAL_COMMENT_IGNORED_KEYS.includes(key)) result[key] = value;
	return result;
}
function buildCanonicalDiffableState(doc$1, comments, styles, numbering, headerFooters, partsState) {
	return {
		body: normalizeDocJSON(doc$1.toJSON()),
		comments: comments.map(canonicalizeComment),
		styles: styles ? styles : null,
		numbering: numbering ? numbering : null,
		headerFooters: headerFooters ? structuredClone(headerFooters) : null,
		partsState: partsState ? structuredClone(partsState) : null
	};
}
function buildLegacyCanonicalDiffableState(doc$1, comments, styles, numbering, headerFooters, partsState) {
	return {
		body: normalizeDocJSONLegacy(doc$1.toJSON()),
		comments: comments.map(canonicalizeComment),
		styles: styles ? styles : null,
		numbering: numbering ? numbering : null,
		headerFooters: headerFooters ? structuredClone(headerFooters) : null,
		partsState: partsState ? structuredClone(partsState) : null
	};
}
function sortKeysDeep(value) {
	if (value === null || value === void 0) return value;
	if (Array.isArray(value)) return value.map(sortKeysDeep);
	if (typeof value === "object") {
		const sorted = {};
		for (const key of Object.keys(value).sort()) sorted[key] = sortKeysDeep(value[key]);
		return sorted;
	}
	return value;
}
function stableStringify(state) {
	return JSON.stringify(sortKeysDeep(state));
}
var INITIAL_HASH = [
	1779033703,
	3144134277,
	1013904242,
	2773480762,
	1359893119,
	2600822924,
	528734635,
	1541459225
];
var ROUND_CONSTANTS = [
	1116352408,
	1899447441,
	3049323471,
	3921009573,
	961987163,
	1508970993,
	2453635748,
	2870763221,
	3624381080,
	310598401,
	607225278,
	1426881987,
	1925078388,
	2162078206,
	2614888103,
	3248222580,
	3835390401,
	4022224774,
	264347078,
	604807628,
	770255983,
	1249150122,
	1555081692,
	1996064986,
	2554220882,
	2821834349,
	2952996808,
	3210313671,
	3336571891,
	3584528711,
	113926993,
	338241895,
	666307205,
	773529912,
	1294757372,
	1396182291,
	1695183700,
	1986661051,
	2177026350,
	2456956037,
	2730485921,
	2820302411,
	3259730800,
	3345764771,
	3516065817,
	3600352804,
	4094571909,
	275423344,
	430227734,
	506948616,
	659060556,
	883997877,
	958139571,
	1322822218,
	1537002063,
	1747873779,
	1955562222,
	2024104815,
	2227730452,
	2361852424,
	2428436474,
	2756734187,
	3204031479,
	3329325298
];
function rightRotate(value, amount) {
	return value >>> amount | value << 32 - amount;
}
function sha256Hex(input) {
	const bytes = new TextEncoder().encode(input);
	const bitLength = BigInt(bytes.length) * 8n;
	const paddedLength = Math.ceil((bytes.length + 1 + 8) / 64) * 64;
	const padded = new Uint8Array(paddedLength);
	padded.set(bytes);
	padded[bytes.length] = 128;
	const paddedView = new DataView(padded.buffer);
	paddedView.setUint32(paddedLength - 8, Number(bitLength >> 32n & 4294967295n));
	paddedView.setUint32(paddedLength - 4, Number(bitLength & 4294967295n));
	const hash$3 = [...INITIAL_HASH];
	const words = new Uint32Array(64);
	for (let offset$1 = 0; offset$1 < paddedLength; offset$1 += 64) {
		for (let index = 0; index < 16; index += 1) words[index] = paddedView.getUint32(offset$1 + index * 4);
		for (let index = 16; index < 64; index += 1) {
			const s0 = rightRotate(words[index - 15], 7) ^ rightRotate(words[index - 15], 18) ^ words[index - 15] >>> 3;
			const s1 = rightRotate(words[index - 2], 17) ^ rightRotate(words[index - 2], 19) ^ words[index - 2] >>> 10;
			words[index] = words[index - 16] + s0 + words[index - 7] + s1 >>> 0;
		}
		let [a, b$1, c, d, e, f, g$1, h$2] = hash$3;
		for (let index = 0; index < 64; index += 1) {
			const s1 = rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25);
			const ch = e & f ^ ~e & g$1;
			const temp1 = h$2 + s1 + ch + ROUND_CONSTANTS[index] + words[index] >>> 0;
			const temp2 = (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) + (a & b$1 ^ a & c ^ b$1 & c) >>> 0;
			h$2 = g$1;
			g$1 = f;
			f = e;
			e = d + temp1 >>> 0;
			d = c;
			c = b$1;
			b$1 = a;
			a = temp1 + temp2 >>> 0;
		}
		hash$3[0] = hash$3[0] + a >>> 0;
		hash$3[1] = hash$3[1] + b$1 >>> 0;
		hash$3[2] = hash$3[2] + c >>> 0;
		hash$3[3] = hash$3[3] + d >>> 0;
		hash$3[4] = hash$3[4] + e >>> 0;
		hash$3[5] = hash$3[5] + f >>> 0;
		hash$3[6] = hash$3[6] + g$1 >>> 0;
		hash$3[7] = hash$3[7] + h$2 >>> 0;
	}
	return hash$3.map((value) => value.toString(16).padStart(8, "0")).join("");
}
function computeFingerprint(state) {
	return sha256Hex(stableStringify(state));
}
function buildDiffSummary(diff) {
	const bodyHasChanges = diff.docDiffs.length > 0;
	const commentsHasChanges = diff.commentDiffs.length > 0;
	const stylesHasChanges = diff.stylesDiff !== null;
	const numberingHasChanges = diff.numberingDiff !== null;
	const headerFootersHasChanges = diff.headerFootersDiff !== null;
	const partsHasChanges = diff.partsDiff !== null;
	const changedComponents = [];
	if (bodyHasChanges) changedComponents.push("body");
	if (commentsHasChanges) changedComponents.push("comments");
	if (stylesHasChanges) changedComponents.push("styles");
	if (numberingHasChanges) changedComponents.push("numbering");
	if (headerFootersHasChanges) changedComponents.push("headerFooters");
	if (partsHasChanges) changedComponents.push("parts");
	return {
		hasChanges: changedComponents.length > 0,
		changedComponents,
		body: { hasChanges: bodyHasChanges },
		comments: { hasChanges: commentsHasChanges },
		styles: { hasChanges: stylesHasChanges },
		numbering: { hasChanges: numberingHasChanges },
		headerFooters: { hasChanges: headerFootersHasChanges },
		parts: { hasChanges: partsHasChanges }
	};
}
const V1_COVERAGE = Object.freeze({
	body: true,
	comments: true,
	styles: true,
	numbering: true,
	headerFooters: false
});
const V2_COVERAGE = Object.freeze({
	body: true,
	comments: true,
	styles: true,
	numbering: true,
	headerFooters: true
});
function coverageEquals(a, b$1) {
	return a.body === b$1.body && a.comments === b$1.comments && a.styles === b$1.styles && a.numbering === b$1.numbering && a.headerFooters === b$1.headerFooters;
}
var SNAPSHOT_VERSION_V2 = "sd-diff-snapshot/v2";
var PAYLOAD_VERSION_V1 = "sd-diff-payload/v1";
var PAYLOAD_VERSION_V2 = "sd-diff-payload/v2";
var ENGINE_ID = "super-editor";
function getEditorComments(editor) {
	return Array.isArray(editor.converter?.comments) ? editor.converter.comments : [];
}
function getEditorStyles(editor) {
	return editor.converter?.translatedLinkedStyles ?? null;
}
function getEditorNumbering(editor) {
	return editor.converter?.translatedNumbering ?? null;
}
function getEditorHeaderFooters(editor) {
	return captureHeaderFooterState(editor);
}
function getEditorPartsState(editor, headerFooters) {
	return capturePartsState(editor, headerFooters);
}
function buildCanonicalStateForCoverage(doc$1, comments, styles, numbering, headerFooters, partsState, coverage) {
	return buildCanonicalDiffableState(doc$1, comments, styles, numbering, coverage.headerFooters ? headerFooters : null, coverage.headerFooters ? partsState : null);
}
function buildLegacyCanonicalStateForCoverage(doc$1, comments, styles, numbering, headerFooters, partsState, coverage) {
	return buildLegacyCanonicalDiffableState(doc$1, comments, styles, numbering, coverage.headerFooters ? headerFooters : null, coverage.headerFooters ? partsState : null);
}
function captureSnapshot(editor) {
	const doc$1 = editor.state.doc;
	const comments = getEditorComments(editor);
	const styles = getEditorStyles(editor);
	const numbering = getEditorNumbering(editor);
	const headerFooters = getEditorHeaderFooters(editor);
	const partsState = getEditorPartsState(editor, headerFooters);
	return {
		version: SNAPSHOT_VERSION_V2,
		engine: ENGINE_ID,
		fingerprint: computeFingerprint(buildCanonicalStateForCoverage(doc$1, comments, styles, numbering, headerFooters, partsState, V2_COVERAGE)),
		coverage: { ...V2_COVERAGE },
		payload: structuredClone({
			doc: doc$1.toJSON(),
			comments,
			styles,
			numbering,
			headerFooters,
			partsState
		})
	};
}
function compareToSnapshot(editor, targetSnapshot) {
	validateEngine(targetSnapshot.engine);
	validateSnapshotVersion(targetSnapshot.version);
	validateSnapshotFingerprints(targetSnapshot);
	const expectedCoverage = getCoverageForSnapshotVersion(targetSnapshot.version);
	const targetCoverage = targetSnapshot.coverage;
	validateCoverageMatch(expectedCoverage, targetCoverage);
	validateSnapshotPayload(targetSnapshot.payload);
	const targetComments = targetSnapshot.payload.comments ?? [];
	const targetStyles = targetSnapshot.payload.styles;
	const targetNumbering = targetSnapshot.payload.numbering;
	const targetHeaderFooters = targetSnapshot.payload.headerFooters ?? null;
	const targetPartsState = targetSnapshot.payload.partsState ?? null;
	const targetDoc = parseDocPayload(editor.state.schema, targetSnapshot.payload.doc);
	let reDerivedFingerprint;
	try {
		reDerivedFingerprint = computeFingerprint(buildCanonicalStateForCoverage(targetDoc, targetComments, targetStyles, targetNumbering, targetHeaderFooters, targetSnapshot.version === SNAPSHOT_VERSION_V2 ? targetPartsState : null, targetCoverage));
	} catch (err) {
		if (err instanceof DiffServiceError) throw err;
		throw new DiffServiceError("INVALID_INPUT", `Snapshot payload contains malformed data that failed during canonicalization: ${err instanceof Error ? err.message : String(err)}`);
	}
	if (reDerivedFingerprint !== targetSnapshot.fingerprint) {
		if (computeFingerprint(buildLegacyCanonicalStateForCoverage(targetDoc, targetComments, targetStyles, targetNumbering, targetHeaderFooters, targetSnapshot.version === SNAPSHOT_VERSION_V2 ? targetPartsState : null, targetCoverage)) !== targetSnapshot.fingerprint) throw new DiffServiceError("INVALID_INPUT", `Target snapshot fingerprint does not match re-derived value. The snapshot may have been tampered with.`);
	}
	const baseDoc = editor.state.doc;
	const baseComments = getEditorComments(editor);
	const baseStyles = getEditorStyles(editor);
	const baseNumbering = getEditorNumbering(editor);
	const baseHeaderFooters = targetCoverage.headerFooters ? getEditorHeaderFooters(editor) : null;
	const basePartsState = targetCoverage.headerFooters ? getEditorPartsState(editor, baseHeaderFooters) : null;
	const baseFingerprint = computeFingerprint(buildCanonicalStateForCoverage(baseDoc, baseComments, baseStyles, baseNumbering, baseHeaderFooters, targetSnapshot.version === SNAPSHOT_VERSION_V2 ? basePartsState : null, targetCoverage));
	let rawDiff;
	try {
		rawDiff = computeDiff(baseDoc, targetDoc, editor.state.schema, baseComments, targetComments, baseStyles, targetStyles, baseNumbering, targetNumbering, baseHeaderFooters, targetHeaderFooters, basePartsState, targetPartsState);
	} catch (err) {
		if (err instanceof DiffServiceError) throw err;
		throw new DiffServiceError("INVALID_INPUT", `Snapshot payload contains data that failed during diff computation: ${err instanceof Error ? err.message : String(err)}`);
	}
	const summary = buildDiffSummary(rawDiff);
	const payload = structuredClone({
		docDiffs: rawDiff.docDiffs,
		commentDiffs: rawDiff.commentDiffs,
		stylesDiff: rawDiff.stylesDiff,
		numberingDiff: rawDiff.numberingDiff,
		headerFootersDiff: rawDiff.headerFootersDiff,
		partsDiff: rawDiff.partsDiff
	});
	return {
		version: getPayloadVersionForCoverage(targetCoverage),
		engine: ENGINE_ID,
		baseFingerprint,
		targetFingerprint: targetSnapshot.fingerprint,
		coverage: { ...targetCoverage },
		summary,
		payload
	};
}
function applyDiffPayload(editor, diffPayload, options) {
	validateEngine(diffPayload.engine);
	validatePayloadVersion(diffPayload.version);
	validateCoverageForPayloadVersion(diffPayload);
	validatePayloadFingerprints(diffPayload);
	const baseDoc = editor.state.doc;
	const baseComments = getEditorComments(editor);
	const baseStyles = getEditorStyles(editor);
	const baseNumbering = getEditorNumbering(editor);
	const baseHeaderFooters = getEditorHeaderFooters(editor);
	const basePartsState = getEditorPartsState(editor, baseHeaderFooters);
	const currentFingerprint = computeFingerprint(buildCanonicalStateForCoverage(baseDoc, baseComments, baseStyles, baseNumbering, baseHeaderFooters, diffPayload.version === PAYLOAD_VERSION_V2 ? basePartsState : null, diffPayload.coverage));
	if (currentFingerprint !== diffPayload.baseFingerprint) {
		if (computeFingerprint(buildLegacyCanonicalStateForCoverage(baseDoc, baseComments, baseStyles, baseNumbering, baseHeaderFooters, diffPayload.version === PAYLOAD_VERSION_V2 ? basePartsState : null, diffPayload.coverage)) !== diffPayload.baseFingerprint) throw new DiffServiceError("PRECONDITION_FAILED", `Document fingerprint mismatch. Expected "${diffPayload.baseFingerprint}", got "${currentFingerprint}". The document may have changed since the diff was computed. Re-run diff.compare against the current state.`);
	}
	const rawDiff = parseDiffPayloadContents(diffPayload.payload);
	const comments = editor.converter ? Array.isArray(editor.converter.comments) ? editor.converter.comments : [] : [];
	const trackedRequested = options?.changeMode === "tracked";
	const trackedAvailable = Boolean(editor.options?.user);
	if (trackedRequested && !trackedAvailable) throw new DiffServiceError("CAPABILITY_UNAVAILABLE", "Tracked change mode was requested but is not available. A user identity must be configured on the editor to enable tracked changes.");
	const tr = editor.state.tr;
	const { staging, stagedComments, commit } = createStagingEditor(editor, comments);
	const replayResult = replayDiffs({
		tr,
		diff: rawDiff,
		schema: editor.state.schema,
		comments: stagedComments,
		editor: staging,
		trackedChangesRequested: trackedRequested
	});
	tr.setMeta("inputType", "programmatic");
	if (trackedRequested) tr.setMeta("forceTrackChanges", true);
	else tr.setMeta("skipTrackChanges", true);
	if (replayResult.skippedDiffs > 0) throw new DiffServiceError("INTERNAL_ERROR", `Diff apply failed: ${replayResult.skippedDiffs} operations skipped. Warnings: ${replayResult.warnings.join("; ")}`);
	commit();
	const verifiedSummary = buildDiffSummary(rawDiff);
	return {
		result: {
			appliedOperations: replayResult.appliedDiffs,
			baseFingerprint: diffPayload.baseFingerprint,
			targetFingerprint: diffPayload.targetFingerprint,
			coverage: { ...diffPayload.coverage },
			summary: verifiedSummary,
			diagnostics: replayResult.warnings
		},
		tr
	};
}
var STAGED_CONVERTER_KEYS = [
	"translatedLinkedStyles",
	"translatedNumbering",
	"convertedXml",
	"numbering",
	"headers",
	"footers",
	"headerIds",
	"footerIds",
	"bodySectPr",
	"savedTagsToRestore",
	"documentGuid",
	"documentUniqueIdentifier"
];
function createStagingEditor(editor, comments) {
	const pendingEvents = [];
	const stagedComments = comments.map((c) => ({ ...c }));
	const stagedOptions = editor.options ? {
		...editor.options,
		mediaFiles: editor.options.mediaFiles ? structuredClone(editor.options.mediaFiles) : editor.options.mediaFiles
	} : editor.options;
	const stagedStorage = editor.storage ? {
		...editor.storage,
		image: editor.storage.image ? {
			...editor.storage.image,
			media: editor.storage.image.media ? structuredClone(editor.storage.image.media) : editor.storage.image.media
		} : editor.storage.image
	} : editor.storage;
	let stagedConverter = null;
	if (editor.converter) {
		const raw = editor.converter;
		const cloned = Object.create(raw);
		for (const key of STAGED_CONVERTER_KEYS) {
			const val = raw[key];
			if (val !== null && val !== void 0 && typeof val === "object") cloned[key] = structuredClone(val);
		}
		cloned.headerFooterModified = raw.headerFooterModified;
		cloned.documentModified = raw.documentModified;
		cloned.comments = stagedComments;
		stagedConverter = cloned;
	}
	const staging = {
		state: editor.state,
		emit: (event, payload) => {
			pendingEvents.push([event, payload]);
		},
		options: stagedOptions,
		storage: stagedStorage,
		converter: stagedConverter
	};
	function commit() {
		if (editor.converter && stagedConverter) {
			const realRaw = editor.converter;
			const stagedRaw = stagedConverter;
			for (const key of STAGED_CONVERTER_KEYS) realRaw[key] = stagedRaw[key];
			realRaw.headerFooterModified = stagedRaw.headerFooterModified;
			realRaw.documentModified = stagedRaw.documentModified;
		}
		if (editor.options && stagedOptions && "mediaFiles" in stagedOptions) editor.options.mediaFiles = stagedOptions.mediaFiles;
		if (editor.storage?.image && stagedStorage?.image) editor.storage.image.media = stagedStorage.image.media;
		const ownedComments = stagedComments.map((c) => structuredClone(c));
		if (editor.converter) if (Array.isArray(editor.converter.comments)) {
			editor.converter.comments.length = 0;
			editor.converter.comments.push(...ownedComments);
		} else editor.converter.comments = ownedComments;
		for (const [event, payload] of pendingEvents) editor.emit?.(event, payload);
	}
	return {
		staging,
		stagedComments,
		commit
	};
}
function parseDocPayload(schema, doc$1) {
	if (doc$1 === null || doc$1 === void 0 || typeof doc$1 !== "object" || Array.isArray(doc$1)) throw new DiffServiceError("INVALID_INPUT", "Snapshot payload.doc must be a valid document object.");
	try {
		return schema.nodeFromJSON(doc$1);
	} catch (err) {
		throw new DiffServiceError("INVALID_INPUT", `Snapshot payload.doc is not a valid ProseMirror document: ${err instanceof Error ? err.message : String(err)}`);
	}
}
function parseDiffPayloadContents(payload) {
	const docDiffs = payload.docDiffs;
	const commentDiffs = payload.commentDiffs;
	const stylesDiff = payload.stylesDiff;
	const numberingDiff = payload.numberingDiff;
	const headerFootersDiff = payload.headerFootersDiff;
	const partsDiff = payload.partsDiff;
	if (!Array.isArray(docDiffs)) throw new DiffServiceError("INVALID_INPUT", "Diff payload.docDiffs must be an array.");
	if (!Array.isArray(commentDiffs)) throw new DiffServiceError("INVALID_INPUT", "Diff payload.commentDiffs must be an array.");
	for (let i = 0; i < commentDiffs.length; i++) validateCommentDiffEntry(commentDiffs[i], i);
	if (stylesDiff !== null && stylesDiff !== void 0 && (typeof stylesDiff !== "object" || Array.isArray(stylesDiff))) throw new DiffServiceError("INVALID_INPUT", "Diff payload.stylesDiff must be a plain object or null.");
	if (numberingDiff !== null && numberingDiff !== void 0 && (typeof numberingDiff !== "object" || Array.isArray(numberingDiff))) throw new DiffServiceError("INVALID_INPUT", "Diff payload.numberingDiff must be a plain object or null.");
	if (headerFootersDiff !== null && headerFootersDiff !== void 0 && (typeof headerFootersDiff !== "object" || Array.isArray(headerFootersDiff))) throw new DiffServiceError("INVALID_INPUT", "Diff payload.headerFootersDiff must be a plain object or null.");
	if (partsDiff !== null && partsDiff !== void 0 && (typeof partsDiff !== "object" || Array.isArray(partsDiff))) throw new DiffServiceError("INVALID_INPUT", "Diff payload.partsDiff must be a plain object or null.");
	return {
		docDiffs,
		commentDiffs: structuredClone(commentDiffs),
		stylesDiff: stylesDiff ?? null,
		numberingDiff: numberingDiff ?? null,
		headerFootersDiff: headerFootersDiff ?? null,
		partsDiff: partsDiff ?? null
	};
}
function isNonNullObject(v) {
	return v !== null && v !== void 0 && typeof v === "object" && !Array.isArray(v);
}
function validateCommentDiffEntry(entry, index) {
	if (!isNonNullObject(entry)) throw new DiffServiceError("INVALID_INPUT", `Diff payload.commentDiffs[${index}] must be a non-null object.`);
	const { action, commentId, nodeType } = entry;
	if (nodeType !== "comment") throw new DiffServiceError("INVALID_INPUT", `Diff payload.commentDiffs[${index}].nodeType must be 'comment'.`);
	if (typeof commentId !== "string") throw new DiffServiceError("INVALID_INPUT", `Diff payload.commentDiffs[${index}].commentId must be a string.`);
	if (action === "added") {
		if (!isNonNullObject(entry.commentJSON)) throw new DiffServiceError("INVALID_INPUT", `Diff payload.commentDiffs[${index}].commentJSON must be a non-null object for 'added' entries.`);
	} else if (action === "deleted") {
		if (!isNonNullObject(entry.commentJSON)) throw new DiffServiceError("INVALID_INPUT", `Diff payload.commentDiffs[${index}].commentJSON must be a non-null object for 'deleted' entries.`);
	} else if (action === "modified") {
		if (!isNonNullObject(entry.newCommentJSON)) throw new DiffServiceError("INVALID_INPUT", `Diff payload.commentDiffs[${index}].newCommentJSON must be a non-null object for 'modified' entries.`);
	} else throw new DiffServiceError("INVALID_INPUT", `Diff payload.commentDiffs[${index}].action must be 'added', 'deleted', or 'modified'.`);
}
function validateEngine(engine) {
	if (engine !== ENGINE_ID) throw new DiffServiceError("INVALID_INPUT", `Unsupported engine "${engine}". This adapter only supports "${ENGINE_ID}".`);
}
function validateSnapshotVersion(version$1) {
	if (version$1 !== "sd-diff-snapshot/v1" && version$1 !== SNAPSHOT_VERSION_V2) throw new DiffServiceError("CAPABILITY_UNSUPPORTED", `Unsupported snapshot version "${version$1}". Expected "sd-diff-snapshot/v1" or "${SNAPSHOT_VERSION_V2}".`);
}
function validatePayloadVersion(version$1) {
	if (version$1 !== PAYLOAD_VERSION_V1 && version$1 !== PAYLOAD_VERSION_V2) throw new DiffServiceError("CAPABILITY_UNSUPPORTED", `Unsupported diff version "${version$1}". Expected "${PAYLOAD_VERSION_V1}" or "${PAYLOAD_VERSION_V2}".`);
}
function validateSnapshotFingerprints(snapshot) {
	if (typeof snapshot.fingerprint !== "string") throw new DiffServiceError("INVALID_INPUT", "Snapshot fingerprint must be a string.");
}
function validatePayloadFingerprints(payload) {
	if (typeof payload.baseFingerprint !== "string" || typeof payload.targetFingerprint !== "string") throw new DiffServiceError("INVALID_INPUT", "Diff payload fingerprints must be strings.");
}
function validateSnapshotPayload(payload) {
	if (payload.comments !== null && payload.comments !== void 0) {
		if (!Array.isArray(payload.comments)) throw new DiffServiceError("INVALID_INPUT", "Snapshot payload.comments must be an array or null.");
		for (let i = 0; i < payload.comments.length; i++) {
			const entry = payload.comments[i];
			if (entry === null || entry === void 0 || typeof entry !== "object" || Array.isArray(entry)) throw new DiffServiceError("INVALID_INPUT", `Snapshot payload.comments[${i}] must be a non-null object.`);
		}
	}
	if (payload.styles !== null && payload.styles !== void 0 && (typeof payload.styles !== "object" || Array.isArray(payload.styles))) throw new DiffServiceError("INVALID_INPUT", "Snapshot payload.styles must be a plain object or null.");
	if (payload.numbering !== null && payload.numbering !== void 0 && (typeof payload.numbering !== "object" || Array.isArray(payload.numbering))) throw new DiffServiceError("INVALID_INPUT", "Snapshot payload.numbering must be a plain object or null.");
	if (payload.headerFooters !== null && payload.headerFooters !== void 0 && (typeof payload.headerFooters !== "object" || Array.isArray(payload.headerFooters))) throw new DiffServiceError("INVALID_INPUT", "Snapshot payload.headerFooters must be a plain object or null.");
	if (payload.partsState !== null && payload.partsState !== void 0 && (typeof payload.partsState !== "object" || Array.isArray(payload.partsState))) throw new DiffServiceError("INVALID_INPUT", "Snapshot payload.partsState must be a plain object or null.");
}
function validateCoverageMatch(base, target) {
	if (!coverageEquals(base, target)) throw new DiffServiceError("INVALID_INPUT", `Coverage mismatch between base and target. Both must use the same coverage configuration.`);
}
function validateCoverageForPayloadVersion(diffPayload) {
	const expectedCoverage = diffPayload.version === PAYLOAD_VERSION_V1 ? V1_COVERAGE : V2_COVERAGE;
	if (!coverageEquals(diffPayload.coverage, expectedCoverage)) throw new DiffServiceError("INVALID_INPUT", `Coverage mismatch for payload version "${diffPayload.version}". Expected ${JSON.stringify(expectedCoverage)}, got ${JSON.stringify(diffPayload.coverage)}.`);
}
function getCoverageForSnapshotVersion(version$1) {
	return version$1 === "sd-diff-snapshot/v1" ? V1_COVERAGE : V2_COVERAGE;
}
function getPayloadVersionForCoverage(coverage) {
	return coverage.headerFooters ? PAYLOAD_VERSION_V2 : PAYLOAD_VERSION_V1;
}
var DiffServiceError = class extends Error {
	constructor(code, message) {
		super(message);
		this.name = "DiffServiceError";
		this.code = code;
	}
};
function createDiffAdapter(editor) {
	const diffEditor = editor;
	return {
		capture() {
			return wrapServiceCall(() => captureSnapshot(diffEditor));
		},
		compare(input) {
			return wrapServiceCall(() => compareToSnapshot(diffEditor, input.targetSnapshot));
		},
		apply(input, options) {
			const { result, tr } = wrapServiceCall(() => applyDiffPayload(diffEditor, input.diff, options));
			if (tr.docChanged || result.appliedOperations > 0) editor.dispatch(tr);
			editor.emit("commentsUpdate", { type: "replayCompleted" });
			return result;
		}
	};
}
function wrapServiceCall(fn) {
	try {
		return fn();
	} catch (error) {
		if (error instanceof DiffServiceError) throw new DocumentApiAdapterError(error.code, error.message);
		throw error;
	}
}
function stableHash$1(input) {
	let hash$3 = 2166136261;
	for (let index = 0; index < input.length; index += 1) {
		hash$3 ^= input.charCodeAt(index);
		hash$3 = Math.imul(hash$3, 16777619);
	}
	return (hash$3 >>> 0).toString(16).padStart(8, "0");
}
function resolvePublicTcEntryNodeId(node, pos) {
	return `tc-entry-${stableHash$1(`${pos}:${typeof node.attrs?.instruction === "string" ? node.attrs.instruction : ""}`)}`;
}
function findAllTcEntryNodes(doc$1) {
	const results = [];
	let currentParagraphSdBlockId;
	doc$1.descendants((node, pos) => {
		if (node.type.name === "tableOfContents") return false;
		if (node.type.name === "paragraph") {
			const attrs = node.attrs;
			currentParagraphSdBlockId = attrs?.sdBlockId ?? attrs?.paraId;
			return true;
		}
		if (node.type.name === "tableOfContentsEntry") {
			const nodeId = resolvePublicTcEntryNodeId(node, pos);
			results.push({
				node,
				pos,
				nodeId,
				containingParagraphSdBlockId: currentParagraphSdBlockId
			});
			return false;
		}
		return true;
	});
	return results;
}
function resolveTcEntryTarget(doc$1, target) {
	const found = findAllTcEntryNodes(doc$1).find((entry) => entry.nodeId === target.nodeId);
	if (!found) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Table of contents entry with nodeId "${target.nodeId}" not found.`);
	return found;
}
function findParagraphBySdBlockId(doc$1, sdBlockId, editor) {
	let found;
	doc$1.descendants((node, pos) => {
		if (found) return false;
		if (node.type.name === "tableOfContents") return false;
		if (node.type.name === "paragraph") {
			const attrs = node.attrs;
			if ((attrs?.sdBlockId ?? attrs?.paraId) === sdBlockId) {
				found = {
					node,
					pos,
					sdBlockId
				};
				return false;
			}
		}
		return true;
	});
	if (!found) {
		if (editor) try {
			const block = findBlockByNodeIdOnly(buildBlockIndex(editor), sdBlockId);
			if (block.node.type.name === "paragraph") return {
				node: block.node,
				pos: block.pos,
				sdBlockId
			};
		} catch {}
		throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Paragraph with sdBlockId "${sdBlockId}" not found.`);
	}
	return found;
}
function extractTcEntryInfo(resolved) {
	const instruction = resolved.node.attrs?.instruction ?? "";
	const config = parseTcInstruction(instruction);
	return {
		nodeType: "tableOfContentsEntry",
		kind: "inline",
		properties: {
			instruction,
			text: config.text,
			level: config.level,
			tableIdentifier: config.tableIdentifier,
			omitPageNumber: config.omitPageNumber
		}
	};
}
function buildTcEntryDiscoveryItem(resolved, evaluatedRevision) {
	const instruction = resolved.node.attrs?.instruction ?? "";
	const config = parseTcInstruction(instruction);
	const address = {
		kind: "inline",
		nodeType: "tableOfContentsEntry",
		nodeId: resolved.nodeId
	};
	const handle = buildResolvedHandle(resolved.nodeId, "ephemeral", "field");
	const domain = {
		address,
		instruction,
		text: config.text,
		level: config.level,
		tableIdentifier: config.tableIdentifier,
		omitPageNumber: config.omitPageNumber
	};
	return buildDiscoveryItem(`tc-entry:${resolved.nodeId}:${evaluatedRevision}`, handle, domain);
}
var TC_LEVEL_MIN = 1;
var TC_LEVEL_MAX = 9;
function validateTcLevel(level) {
	if (level === void 0) return;
	if (!Number.isInteger(level) || level < TC_LEVEL_MIN || level > TC_LEVEL_MAX) throw new DocumentApiValidationError("INVALID_INPUT", `TC entry level must be an integer between ${TC_LEVEL_MIN} and ${TC_LEVEL_MAX}, got ${level}`, { level });
}
function buildEntryAddress$2(nodeId) {
	return {
		kind: "inline",
		nodeType: "tableOfContentsEntry",
		nodeId
	};
}
function entrySuccess$2(nodeId) {
	return {
		success: true,
		entry: buildEntryAddress$2(nodeId)
	};
}
function entryFailure$2(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function toEntryEditorCommand(command$1) {
	return command$1;
}
function runEntryAction(editor, action, expectedRevision) {
	return executeDomainCommand(editor, () => {
		const result = action();
		if (result) clearIndexCache(editor);
		return result;
	}, { expectedRevision });
}
function runEntryCommand(editor, command$1, args$1, expectedRevision) {
	const executeCommand = toEntryEditorCommand(command$1);
	return runEntryAction(editor, () => executeCommand(args$1), expectedRevision);
}
function receiptApplied$8(receipt) {
	return receipt.steps[0]?.effect === "changed";
}
function tocListEntriesWrapper(editor, query) {
	const doc$1 = editor.state.doc;
	const revision = getRevision(editor);
	let filtered = findAllTcEntryNodes(doc$1);
	if (query?.tableIdentifier !== void 0) filtered = filtered.filter((entry) => {
		return parseTcInstruction(entry.node.attrs?.instruction ?? "").tableIdentifier === query.tableIdentifier;
	});
	if (query?.levelRange) {
		const { from: from$1, to } = query.levelRange;
		filtered = filtered.filter((entry) => {
			const config = parseTcInstruction(entry.node.attrs?.instruction ?? "");
			return config.level >= from$1 && config.level <= to;
		});
	}
	const { total, items: paged } = paginate(filtered.map((entry) => buildTcEntryDiscoveryItem(entry, revision)), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function tocGetEntryWrapper(editor, input) {
	return extractTcEntryInfo(resolveTcEntryTarget(editor.state.doc, input.target));
}
function tocMarkEntryWrapper(editor, input, options) {
	rejectTrackedMode("toc.markEntry", options);
	validateTcLevel(input.level);
	const command$1 = requireEditorCommand(editor.commands?.insertTableOfContentsEntryAt, "toc.markEntry");
	const paragraph = findParagraphBySdBlockId(editor.state.doc, input.target.anchor.nodeId, editor);
	const instruction = serializeTcInstruction({
		text: input.text,
		level: input.level ?? 1,
		omitPageNumber: input.omitPageNumber ?? false,
		tableIdentifier: input.tableIdentifier
	});
	const pos = (input.target.position ?? "end") === "start" ? paragraph.pos + 1 : paragraph.pos + paragraph.node.nodeSize - 1;
	if (options?.dryRun) return entrySuccess$2("(dry-run)");
	if (!receiptApplied$8(runEntryCommand(editor, command$1, {
		pos,
		instruction
	}, options?.expectedRevision))) return entryFailure$2("INVALID_INSERTION_CONTEXT", "TC entry could not be inserted at the requested location.");
	return entrySuccess$2(resolveInsertedEntryId(editor.state.doc, pos, instruction));
}
function resolveInsertedEntryId(doc$1, insertPos, instruction) {
	const allEntries = findAllTcEntryNodes(doc$1);
	const matching = allEntries.filter((e) => e.node.attrs?.instruction === instruction);
	if (matching.length > 0) {
		matching.sort((a, b$1) => Math.abs(a.pos - insertPos) - Math.abs(b$1.pos - insertPos));
		return matching[0].nodeId;
	}
	return allEntries.reduce((best, entry) => Math.abs(entry.pos - insertPos) < Math.abs(best.pos - insertPos) ? entry : best, allEntries[0])?.nodeId ?? `tc-entry-unknown`;
}
function tocUnmarkEntryWrapper(editor, input, options) {
	rejectTrackedMode("toc.unmarkEntry", options);
	const command$1 = requireEditorCommand(editor.commands?.deleteTableOfContentsEntryAt, "toc.unmarkEntry");
	const resolved = resolveTcEntryTarget(editor.state.doc, input.target);
	if (options?.dryRun) return entrySuccess$2(resolved.nodeId);
	return receiptApplied$8(runEntryCommand(editor, command$1, { pos: resolved.pos }, options?.expectedRevision)) ? entrySuccess$2(resolved.nodeId) : entryFailure$2("NO_OP", "TC entry removal produced no change.");
}
function tocEditEntryWrapper(editor, input, options) {
	rejectTrackedMode("toc.editEntry", options);
	validateTcLevel(input.patch.level);
	const command$1 = requireEditorCommand(editor.commands?.updateTableOfContentsEntryAt, "toc.editEntry");
	const resolved = resolveTcEntryTarget(editor.state.doc, input.target);
	const currentConfig = parseTcInstruction(resolved.node.attrs?.instruction ?? "");
	const patched = applyTcPatch(currentConfig, input.patch);
	if (areTcConfigsEqual(currentConfig, patched)) return entryFailure$2("NO_OP", "Edit patch produced no change.");
	if (options?.dryRun) return entrySuccess$2(resolved.nodeId);
	if (!receiptApplied$8(runEntryCommand(editor, command$1, {
		pos: resolved.pos,
		instruction: serializeTcInstruction(patched)
	}, options?.expectedRevision))) return entryFailure$2("NO_OP", "TC entry edit could not be applied.");
	return entrySuccess$2(resolvePostEditEntryId(editor.state.doc, resolved.pos));
}
function resolvePostEditEntryId(doc$1, originalPos) {
	const allEntries = findAllTcEntryNodes(doc$1);
	if (allEntries.length === 0) return `tc-entry-unknown`;
	return allEntries.reduce((best, entry) => Math.abs(entry.pos - originalPos) < Math.abs(best.pos - originalPos) ? entry : best, allEntries[0]).nodeId;
}
function collectImages(doc$1) {
	const results = [];
	doc$1.descendants((node, pos) => {
		if (node.type.name !== "image") return;
		const sdImageId = node.attrs.sdImageId;
		if (typeof sdImageId !== "string" || sdImageId.length === 0) return;
		results.push({
			pos,
			node,
			sdImageId,
			placement: node.attrs.isAnchor ? "floating" : "inline"
		});
	});
	return results;
}
function findImageById(editor, sdImageId) {
	const matches = collectImages(editor.state.doc).filter((c) => c.sdImageId === sdImageId);
	if (matches.length === 0) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Image with sdImageId "${sdImageId}" was not found.`, { sdImageId });
	if (matches.length > 1) throw new DocumentApiAdapterError("AMBIGUOUS_TARGET", `Multiple images share sdImageId "${sdImageId}" (${matches.length} found).`, {
		sdImageId,
		count: matches.length
	});
	return matches[0];
}
function requireFloatingPlacement(image, operation) {
	if (image.placement === "floating") return;
	throw new DocumentApiAdapterError("INVALID_TARGET", `${operation} requires a floating image, but image "${image.sdImageId}" has inline placement.`, {
		sdImageId: image.sdImageId,
		placement: image.placement
	});
}
var ALLOWED_WRAP_ATTRS = {
	None: ["behindDoc"],
	Square: [
		"wrapText",
		"distTop",
		"distBottom",
		"distLeft",
		"distRight"
	],
	Through: [
		"wrapText",
		"distTop",
		"distBottom",
		"distLeft",
		"distRight",
		"polygon"
	],
	Tight: [
		"wrapText",
		"distTop",
		"distBottom",
		"distLeft",
		"distRight",
		"polygon"
	],
	TopAndBottom: ["distTop", "distBottom"],
	Inline: []
};
var WRAP_TYPES_SUPPORTING_SIDE = new Set([
	"Square",
	"Tight",
	"Through"
]);
var WRAP_TYPES_SUPPORTING_DISTANCES = new Set([
	"Square",
	"Tight",
	"Through",
	"TopAndBottom"
]);
var RELATIVE_HEIGHT_MIN = 0;
var RELATIVE_HEIGHT_MAX = 4294967295;
function buildImageAddress(candidate) {
	return {
		kind: "inline",
		nodeType: "image",
		nodeId: candidate.sdImageId,
		placement: candidate.placement
	};
}
function buildSuccessResult(candidate) {
	return {
		success: true,
		image: buildImageAddress(candidate)
	};
}
function buildNoOpResult(message) {
	return {
		success: false,
		failure: {
			code: "NO_OP",
			message
		}
	};
}
function parseCropFromClipPath(clipPath) {
	if (!clipPath) return null;
	const match$1 = clipPath.match(/^inset\(\s*([\d.]+)%\s+([\d.]+)%\s+([\d.]+)%\s+([\d.]+)%\s*\)$/);
	if (!match$1) return null;
	return {
		top: parseFloat(match$1[1]),
		right: parseFloat(match$1[2]),
		bottom: parseFloat(match$1[3]),
		left: parseFloat(match$1[4])
	};
}
function buildTransformInfo(td) {
	if (!td) return null;
	if (!td.rotation && !td.verticalFlip && !td.horizontalFlip) return null;
	return {
		rotation: td.rotation ?? void 0,
		verticalFlip: td.verticalFlip ?? void 0,
		horizontalFlip: td.horizontalFlip ?? void 0
	};
}
function hasCaptionSibling(editor, imagePos) {
	try {
		return findCaptionParagraph(editor, imagePos) !== null;
	} catch {
		return false;
	}
}
function resolveImageAnchorBlockId(editor, imagePos) {
	try {
		const attrs = findContainingParagraph(editor, imagePos).node.attrs ?? {};
		const blockId = attrs.sdBlockId ?? attrs.paraId ?? attrs.id ?? attrs.blockId;
		return typeof blockId === "string" && blockId.length > 0 ? blockId : void 0;
	} catch {
		return;
	}
}
function buildImageSummary(editor, candidate) {
	const attrs = candidate.node.attrs;
	const anchorBlockId = resolveImageAnchorBlockId(editor, candidate.pos);
	return {
		sdImageId: candidate.sdImageId,
		address: buildImageAddress(candidate),
		...anchorBlockId ? { anchor: { blockId: anchorBlockId } } : {},
		properties: {
			src: attrs.src ?? void 0,
			alt: attrs.alt ?? void 0,
			size: attrs.size ?? void 0,
			placement: candidate.placement,
			wrap: {
				type: attrs.wrap?.type ?? "Inline",
				attrs: attrs.wrap?.attrs ?? void 0
			},
			anchorData: attrs.anchorData ?? null,
			marginOffset: attrs.marginOffset ?? null,
			relativeHeight: attrs.relativeHeight ?? null,
			name: attrs.alt ?? void 0,
			description: attrs.title ?? void 0,
			transform: buildTransformInfo(attrs.transformData),
			crop: parseCropFromClipPath(attrs.clipPath),
			lockAspectRatio: attrs.lockAspectRatio ?? true,
			decorative: attrs.decorative ?? false,
			hyperlink: attrs.hyperlink ?? null,
			hasCaption: hasCaptionSibling(editor, candidate.pos)
		}
	};
}
function isUnsignedInt32(value) {
	return typeof value === "number" && Number.isInteger(value) && value >= RELATIVE_HEIGHT_MIN && value <= RELATIVE_HEIGHT_MAX;
}
function resolveImageInsertPosition(editor, location$1) {
	switch (location$1.kind) {
		case "documentStart": return 0;
		case "documentEnd": return editor.state.doc.content.size;
		case "before":
		case "after": return resolveCreateAnchor(editor, location$1.target, location$1.kind).pos;
		case "inParagraph": {
			const { pos } = resolveCreateAnchor(editor, location$1.target, "before");
			return pos + 1 + (location$1.offset ?? 0);
		}
		default: throw new DocumentApiAdapterError("INVALID_TARGET", `Unknown image location kind: "${location$1.kind}".`);
	}
}
function filterWrapAttrs(type, attrs) {
	const allowed = ALLOWED_WRAP_ATTRS[type] ?? [];
	const result = {};
	for (const key of allowed) if (key in attrs) result[key] = attrs[key];
	return result;
}
function resolveImageMoveSourceParagraphCleanup(editor, imagePos, targetPos) {
	const paragraph = findContainingParagraph(editor, imagePos);
	if (paragraph.depth !== 1) return null;
	if (paragraph.node.childCount !== 1) return null;
	if (paragraph.node.child(0)?.type.name !== "image") return null;
	const paragraphContentStart = paragraph.pos + 1;
	const paragraphContentEnd = paragraph.pos + paragraph.node.nodeSize - 1;
	if (targetPos >= paragraphContentStart && targetPos <= paragraphContentEnd) return null;
	return {
		pos: paragraph.pos,
		end: paragraph.pos + paragraph.node.nodeSize
	};
}
function imagesListWrapper(editor, input) {
	const allImages = collectImages(editor.state.doc);
	const offset$1 = input.offset ?? 0;
	const limit = input.limit ?? allImages.length;
	const items = allImages.slice(offset$1, offset$1 + limit).map((c) => buildImageSummary(editor, c));
	return {
		total: allImages.length,
		items
	};
}
function imagesGetWrapper(editor, input) {
	return buildImageSummary(editor, findImageById(editor, input.imageId));
}
function createImageWrapper(editor, input, options) {
	rejectTrackedMode("create.image", options);
	const runtime = resolveWriteStoryRuntime(editor, input.in);
	const storyEditor = runtime.editor;
	try {
		if (typeof storyEditor.commands.setImage !== "function") throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "create.image requires the image extension (setImage command).");
		let resolvedSize = input.size;
		if (isFinitePositive(resolvedSize?.width) && isFinitePositive(resolvedSize?.height)) {} else if (input.src?.startsWith("data:")) {
			const dims = readImageDimensionsFromDataUri(input.src);
			if (dims) resolvedSize = dims;
			else return {
				success: false,
				failure: {
					code: "INVALID_INPUT",
					message: "Image dimensions could not be determined. Provide explicit size.width and size.height, or use a data URI with a supported format (PNG, JPEG, GIF, BMP, WEBP)."
				}
			};
		} else return {
			success: false,
			failure: {
				code: "INVALID_INPUT",
				message: "Image dimensions are required. Provide size.width and size.height (finite positive numbers), or use a data URI src so dimensions can be inferred."
			}
		};
		const drawingId = generateUniqueDocPrId(storyEditor);
		const sdImageId = v4_default();
		const insertPos = input.at ? resolveImageInsertPosition(storyEditor, input.at) : null;
		if (options?.dryRun) return {
			success: true,
			image: {
				kind: "inline",
				nodeType: "image",
				nodeId: sdImageId,
				placement: "inline"
			}
		};
		if (!(executeDomainCommand(storyEditor, () => {
			const attrs = {
				src: input.src,
				alt: input.alt,
				title: input.title,
				size: resolvedSize,
				sdImageId,
				id: drawingId
			};
			if (insertPos !== null) return Boolean(storyEditor.commands.insertContentAt(insertPos, {
				type: "image",
				attrs
			}));
			return Boolean(storyEditor.commands.setImage(attrs));
		}).steps[0]?.effect === "changed")) return {
			success: false,
			failure: {
				code: "INVALID_TARGET",
				message: "Image could not be created."
			}
		};
		if (runtime.commit) runtime.commit(editor);
		return {
			success: true,
			image: {
				kind: "inline",
				nodeType: "image",
				nodeId: sdImageId,
				placement: "inline"
			}
		};
	} finally {
		disposeEphemeralWriteRuntime(runtime);
	}
}
function isFinitePositive(value) {
	return typeof value === "number" && Number.isFinite(value) && value > 0;
}
function imagesDeleteWrapper(editor, input, options) {
	rejectTrackedMode("images.delete", options);
	const image = findImageById(editor, input.imageId);
	if (options?.dryRun) return buildSuccessResult(image);
	if (!(executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.delete(pos, pos + node.nodeSize);
		if (!tr.docChanged) return false;
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect === "changed")) return buildNoOpResult("Image deletion produced no change.");
	return buildSuccessResult(image);
}
function imagesMoveWrapper(editor, input, options) {
	rejectTrackedMode("images.move", options);
	const image = findImageById(editor, input.imageId);
	const targetPos = resolveImageInsertPosition(editor, input.to);
	if (options?.dryRun) return buildSuccessResult(image);
	if (!(executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const attrs = { ...node.attrs };
		const tr = editor.state.tr;
		const sourceParagraphCleanup = resolveImageMoveSourceParagraphCleanup(editor, pos, targetPos);
		tr.delete(pos, pos + node.nodeSize);
		if (sourceParagraphCleanup) {
			const cleanupFrom = tr.mapping.map(sourceParagraphCleanup.pos);
			const cleanupTo = tr.mapping.map(sourceParagraphCleanup.end);
			if (cleanupTo > cleanupFrom) tr.delete(cleanupFrom, cleanupTo);
		}
		const mappedPos = tr.mapping.map(targetPos);
		const imageNode = editor.state.schema.nodes.image.create(attrs);
		tr.insert(mappedPos, imageNode);
		if (!tr.docChanged) return false;
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect === "changed")) return {
		success: false,
		failure: {
			code: "INVALID_TARGET",
			message: "Image move produced no change."
		}
	};
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesConvertToInlineWrapper(editor, input, options) {
	rejectTrackedMode("images.convertToInline", options);
	const image = findImageById(editor, input.imageId);
	if (image.placement === "inline") return buildNoOpResult("Image is already inline.");
	if (options?.dryRun) return buildSuccessResult(image);
	if (!(executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			isAnchor: false,
			wrap: { type: "Inline" },
			anchorData: null,
			marginOffset: null,
			relativeHeight: null
		});
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect === "changed")) return buildNoOpResult("Convert to inline produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesConvertToFloatingWrapper(editor, input, options) {
	rejectTrackedMode("images.convertToFloating", options);
	const image = findImageById(editor, input.imageId);
	if (image.placement === "floating") return buildNoOpResult("Image is already floating.");
	if (options?.dryRun) return buildSuccessResult(image);
	if (!(executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			isAnchor: true,
			wrap: {
				type: "Square",
				attrs: {}
			},
			anchorData: {
				hRelativeFrom: "column",
				vRelativeFrom: "paragraph"
			}
		});
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect === "changed")) return buildNoOpResult("Convert to floating produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesSetSizeWrapper(editor, input, options) {
	rejectTrackedMode("images.setSize", options);
	if (!isFinitePositive(input.size?.width) || !isFinitePositive(input.size?.height)) throw new DocumentApiAdapterError("INVALID_INPUT", "images.setSize requires size.width and size.height as finite positive numbers.");
	const image = findImageById(editor, input.imageId);
	const currentSize = image.node.attrs.size ?? {};
	const nextSize = {
		width: input.size.width,
		height: input.size.height,
		...input.size.unit !== void 0 ? { unit: input.size.unit } : {}
	};
	if (currentSize.width === nextSize.width && currentSize.height === nextSize.height && currentSize.unit === nextSize.unit) return buildNoOpResult(`Image size is already ${nextSize.width}x${nextSize.height}.`);
	if (options?.dryRun) return buildSuccessResult(image);
	if (!(executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			size: nextSize
		});
		if (!tr.docChanged) return false;
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect === "changed")) return buildNoOpResult("Set image size produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesSetWrapTypeWrapper(editor, input, options) {
	rejectTrackedMode("images.setWrapType", options);
	const image = findImageById(editor, input.imageId);
	requireFloatingPlacement(image, "images.setWrapType");
	if (image.node.attrs.wrap?.type === input.type) return buildNoOpResult(`Wrap type is already "${input.type}".`);
	if (options?.dryRun) return buildSuccessResult(image);
	if (!(executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		const existingAttrs = node.attrs.wrap?.attrs ?? {};
		const filteredAttrs = filterWrapAttrs(input.type, existingAttrs);
		const becomingInline = input.type === "Inline";
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			wrap: {
				type: input.type,
				attrs: filteredAttrs
			},
			isAnchor: !becomingInline,
			...becomingInline ? {
				anchorData: null,
				marginOffset: null,
				relativeHeight: null
			} : {}
		});
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect === "changed")) return buildNoOpResult("Set wrap type produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesSetWrapSideWrapper(editor, input, options) {
	rejectTrackedMode("images.setWrapSide", options);
	const image = findImageById(editor, input.imageId);
	requireFloatingPlacement(image, "images.setWrapSide");
	const currentWrapType = image.node.attrs.wrap?.type;
	if (!WRAP_TYPES_SUPPORTING_SIDE.has(currentWrapType)) throw new DocumentApiAdapterError("INVALID_TARGET", `images.setWrapSide is not valid for wrap type "${currentWrapType}".`, { wrapType: currentWrapType });
	if (image.node.attrs.wrap?.attrs?.wrapText === input.side) return buildNoOpResult(`Wrap side is already "${input.side}".`);
	if (options?.dryRun) return buildSuccessResult(image);
	if (!(executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			wrap: {
				...node.attrs.wrap,
				attrs: {
					...node.attrs.wrap?.attrs ?? {},
					wrapText: input.side
				}
			}
		});
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect === "changed")) return buildNoOpResult("Set wrap side produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesSetWrapDistancesWrapper(editor, input, options) {
	rejectTrackedMode("images.setWrapDistances", options);
	const image = findImageById(editor, input.imageId);
	requireFloatingPlacement(image, "images.setWrapDistances");
	const currentWrapType = image.node.attrs.wrap?.type;
	if (!WRAP_TYPES_SUPPORTING_DISTANCES.has(currentWrapType)) throw new DocumentApiAdapterError("INVALID_TARGET", `images.setWrapDistances is not valid for wrap type "${currentWrapType}".`, { wrapType: currentWrapType });
	if (options?.dryRun) return buildSuccessResult(image);
	if (!(executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		const currentAttrs = node.attrs.wrap?.attrs ?? {};
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			wrap: {
				...node.attrs.wrap,
				attrs: {
					...currentAttrs,
					...input.distances
				}
			}
		});
		if (!tr.docChanged) return false;
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect === "changed")) return buildNoOpResult("Set wrap distances produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesSetPositionWrapper(editor, input, options) {
	rejectTrackedMode("images.setPosition", options);
	const image = findImageById(editor, input.imageId);
	requireFloatingPlacement(image, "images.setPosition");
	if (options?.dryRun) return buildSuccessResult(image);
	if (!(executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		const { position } = input;
		const newAnchorData = {
			...node.attrs.anchorData ?? {},
			...position.hRelativeFrom !== void 0 ? { hRelativeFrom: position.hRelativeFrom } : {},
			...position.vRelativeFrom !== void 0 ? { vRelativeFrom: position.vRelativeFrom } : {},
			...position.alignH !== void 0 ? { alignH: position.alignH } : {},
			...position.alignV !== void 0 ? { alignV: position.alignV } : {}
		};
		const newMarginOffset = position.marginOffset ? {
			...node.attrs.marginOffset ?? {},
			...position.marginOffset
		} : node.attrs.marginOffset;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			anchorData: newAnchorData,
			marginOffset: newMarginOffset
		});
		if (!tr.docChanged) return false;
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect === "changed")) return buildNoOpResult("Set position produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesSetAnchorOptionsWrapper(editor, input, options) {
	rejectTrackedMode("images.setAnchorOptions", options);
	const image = findImageById(editor, input.imageId);
	requireFloatingPlacement(image, "images.setAnchorOptions");
	if (options?.dryRun) return buildSuccessResult(image);
	if (!(executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		const { options: anchorOpts } = input;
		const updatedOrigAttrs = {
			...node.attrs.originalAttributes ?? {},
			...anchorOpts.behindDoc !== void 0 ? { behindDoc: anchorOpts.behindDoc ? "1" : "0" } : {},
			...anchorOpts.allowOverlap !== void 0 ? { allowOverlap: anchorOpts.allowOverlap ? "1" : "0" } : {},
			...anchorOpts.layoutInCell !== void 0 ? { layoutInCell: anchorOpts.layoutInCell ? "1" : "0" } : {},
			...anchorOpts.lockAnchor !== void 0 ? { locked: anchorOpts.lockAnchor ? "1" : "0" } : {}
		};
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			originalAttributes: updatedOrigAttrs,
			...anchorOpts.simplePos !== void 0 ? { simplePos: anchorOpts.simplePos } : {}
		});
		if (!tr.docChanged) return false;
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect === "changed")) return buildNoOpResult("Set anchor options produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesSetZOrderWrapper(editor, input, options) {
	rejectTrackedMode("images.setZOrder", options);
	if (!isUnsignedInt32(input.zOrder?.relativeHeight)) throw new DocumentApiAdapterError("INVALID_INPUT", `images.setZOrder requires zOrder.relativeHeight as an unsigned 32-bit integer (${RELATIVE_HEIGHT_MIN}..${RELATIVE_HEIGHT_MAX}).`);
	const image = findImageById(editor, input.imageId);
	requireFloatingPlacement(image, "images.setZOrder");
	if (image.node.attrs.relativeHeight === input.zOrder.relativeHeight) return buildNoOpResult(`relativeHeight is already ${input.zOrder.relativeHeight}.`);
	if (options?.dryRun) return buildSuccessResult(image);
	if (!(executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			relativeHeight: input.zOrder.relativeHeight
		});
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect === "changed")) return buildNoOpResult("Set z-order produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesScaleWrapper(editor, input, options) {
	rejectTrackedMode("images.scale", options);
	const image = findImageById(editor, input.imageId);
	const currentSize = image.node.attrs.size;
	if (!isFinitePositive(currentSize?.width) || !isFinitePositive(currentSize?.height)) throw new DocumentApiAdapterError("INVALID_TARGET", "Image has no explicit size; use setSize first.");
	const newSize = {
		width: Math.max(1, Math.round(currentSize.width * input.factor)),
		height: Math.max(1, Math.round(currentSize.height * input.factor))
	};
	if (newSize.width === currentSize.width && newSize.height === currentSize.height) return buildNoOpResult("Scale produced no size change.");
	if (options?.dryRun) return buildSuccessResult(image);
	if (executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			size: newSize
		});
		if (!tr.docChanged) return false;
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect !== "changed") return buildNoOpResult("Scale produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesSetLockAspectRatioWrapper(editor, input, options) {
	rejectTrackedMode("images.setLockAspectRatio", options);
	const image = findImageById(editor, input.imageId);
	if ((image.node.attrs.lockAspectRatio ?? true) === input.locked) return buildNoOpResult(`lockAspectRatio is already ${input.locked}.`);
	if (options?.dryRun) return buildSuccessResult(image);
	if (executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			lockAspectRatio: input.locked
		});
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect !== "changed") return buildNoOpResult("Set lock aspect ratio produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesRotateWrapper(editor, input, options) {
	rejectTrackedMode("images.rotate", options);
	const image = findImageById(editor, input.imageId);
	if ((image.node.attrs.transformData?.rotation ?? 0) === input.angle) return buildNoOpResult(`Rotation is already ${input.angle} degrees.`);
	if (options?.dryRun) return buildSuccessResult(image);
	if (executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			transformData: {
				...node.attrs.transformData ?? {},
				rotation: input.angle
			}
		});
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect !== "changed") return buildNoOpResult("Rotate produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesFlipWrapper(editor, input, options) {
	rejectTrackedMode("images.flip", options);
	const image = findImageById(editor, input.imageId);
	const current = image.node.attrs.transformData ?? {};
	const targetH = input.horizontal ?? current.horizontalFlip ?? false;
	const targetV = input.vertical ?? current.verticalFlip ?? false;
	if (targetH === (current.horizontalFlip ?? false) && targetV === (current.verticalFlip ?? false)) return buildNoOpResult("Flip state is already as requested.");
	if (options?.dryRun) return buildSuccessResult(image);
	if (executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			transformData: {
				...node.attrs.transformData ?? {},
				horizontalFlip: targetH,
				verticalFlip: targetV
			}
		});
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect !== "changed") return buildNoOpResult("Flip produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function cropToClipPath(crop) {
	const { top: top$1 = 0, right: right$1 = 0, bottom: bottom$1 = 0, left: left$1 = 0 } = crop;
	return `inset(${top$1}% ${right$1}% ${bottom$1}% ${left$1}%)`;
}
function cropToRawSrcRect(crop) {
	const { top: top$1 = 0, right: right$1 = 0, bottom: bottom$1 = 0, left: left$1 = 0 } = crop;
	return {
		name: "a:srcRect",
		attributes: {
			l: String(Math.round(left$1 * 1e3)),
			t: String(Math.round(top$1 * 1e3)),
			r: String(Math.round(right$1 * 1e3)),
			b: String(Math.round(bottom$1 * 1e3))
		}
	};
}
function imagesCropWrapper(editor, input, options) {
	rejectTrackedMode("images.crop", options);
	const image = findImageById(editor, input.imageId);
	const newClipPath = cropToClipPath(input.crop);
	if (image.node.attrs.clipPath === newClipPath) return buildNoOpResult("Crop values are already as requested.");
	if (options?.dryRun) return buildSuccessResult(image);
	if (executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			clipPath: newClipPath,
			rawSrcRect: cropToRawSrcRect(input.crop)
		});
		if (!tr.docChanged) return false;
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect !== "changed") return buildNoOpResult("Crop produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesResetCropWrapper(editor, input, options) {
	rejectTrackedMode("images.resetCrop", options);
	const image = findImageById(editor, input.imageId);
	if (!image.node.attrs.clipPath) return buildNoOpResult("Image has no crop to reset.");
	if (options?.dryRun) return buildSuccessResult(image);
	if (executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			clipPath: null,
			rawSrcRect: null,
			shouldCover: false
		});
		if (!tr.docChanged) return false;
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect !== "changed") return buildNoOpResult("Reset crop produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesReplaceSourceWrapper(editor, input, options) {
	rejectTrackedMode("images.replaceSource", options);
	const isDataUri = input.src.startsWith("data:");
	const isInternalPath = input.src.startsWith("word/media/");
	if (!isDataUri && !isInternalPath) throw new DocumentApiAdapterError("INVALID_INPUT", "External URLs are not supported in V1; provide a data URI or internal media path.");
	const image = findImageById(editor, input.imageId);
	const newAttrs = {
		...image.node.attrs,
		src: input.src,
		rId: null,
		originalSrc: null,
		originalExtension: null,
		clipPath: null,
		rawSrcRect: null,
		shouldCover: false
	};
	if (input.resetSize) {
		if (!isDataUri) throw new DocumentApiAdapterError("INVALID_INPUT", "Cannot determine intrinsic dimensions from internal path; set size explicitly via setSize after replacement.");
		const dims = readImageDimensionsFromDataUri(input.src);
		if (!dims) throw new DocumentApiAdapterError("INVALID_INPUT", "Could not determine intrinsic dimensions from data URI.");
		newAttrs.size = {
			width: dims.width,
			height: dims.height
		};
	}
	if (options?.dryRun) return buildSuccessResult(image);
	if (executeDomainCommand(editor, () => {
		const { pos } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, newAttrs);
		if (!tr.docChanged) return false;
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect !== "changed") return buildNoOpResult("Replace source produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesSetAltTextWrapper(editor, input, options) {
	rejectTrackedMode("images.setAltText", options);
	const image = findImageById(editor, input.imageId);
	if (image.node.attrs.title === input.description && !image.node.attrs.decorative) return buildNoOpResult("Alt text is already as requested.");
	if (options?.dryRun) return buildSuccessResult(image);
	if (executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			title: input.description,
			decorative: false
		});
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect !== "changed") return buildNoOpResult("Set alt text produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesSetDecorativeWrapper(editor, input, options) {
	rejectTrackedMode("images.setDecorative", options);
	const image = findImageById(editor, input.imageId);
	if ((image.node.attrs.decorative ?? false) === input.decorative) return buildNoOpResult(`Decorative is already ${input.decorative}.`);
	if (options?.dryRun) return buildSuccessResult(image);
	if (executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			decorative: input.decorative,
			title: input.decorative ? "" : node.attrs.title
		});
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect !== "changed") return buildNoOpResult("Set decorative produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesSetNameWrapper(editor, input, options) {
	rejectTrackedMode("images.setName", options);
	const image = findImageById(editor, input.imageId);
	if (image.node.attrs.alt === input.name) return buildNoOpResult("Name is already as requested.");
	if (options?.dryRun) return buildSuccessResult(image);
	if (executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			alt: input.name
		});
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect !== "changed") return buildNoOpResult("Set name produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesSetHyperlinkWrapper(editor, input, options) {
	rejectTrackedMode("images.setHyperlink", options);
	const image = findImageById(editor, input.imageId);
	const newValue = input.url === null ? null : {
		url: input.url,
		...input.tooltip ? { tooltip: input.tooltip } : {}
	};
	const current = image.node.attrs.hyperlink ?? null;
	if (current === null && newValue === null || current !== null && newValue !== null && current.url === newValue.url && current.tooltip === newValue.tooltip) return buildNoOpResult("Hyperlink is already as requested.");
	if (options?.dryRun) return buildSuccessResult(image);
	if (executeDomainCommand(editor, () => {
		const { pos, node } = image;
		const tr = editor.state.tr;
		tr.setNodeMarkup(pos, void 0, {
			...node.attrs,
			hyperlink: newValue
		});
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect !== "changed") return buildNoOpResult("Set hyperlink produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function findContainingParagraph(editor, imagePos) {
	const $pos = editor.state.doc.resolve(imagePos);
	for (let depth = $pos.depth; depth >= 1; depth -= 1) {
		const node = $pos.node(depth);
		if (node.type.name !== "paragraph") continue;
		return {
			depth,
			pos: $pos.before(depth),
			node
		};
	}
	throw new DocumentApiAdapterError("INVALID_TARGET", "Caption operations require the image to be inside a paragraph.");
}
function findCaptionParagraph(editor, imagePos) {
	const paragraph = findContainingParagraph(editor, imagePos);
	const afterParagraphPos = paragraph.pos + paragraph.node.nodeSize;
	if (afterParagraphPos >= editor.state.doc.content.size) return null;
	const nextNode = editor.state.doc.nodeAt(afterParagraphPos);
	if (!nextNode || nextNode.type.name !== "paragraph") return null;
	if ((nextNode.attrs?.paragraphProperties?.styleId ?? nextNode.attrs?.styleId) !== "Caption") return null;
	return {
		pos: afterParagraphPos,
		node: nextNode
	};
}
function requireSoleImageInParagraph(editor, imagePos) {
	const $pos = editor.state.doc.resolve(imagePos);
	const parentDepth = $pos.depth - 1;
	if (parentDepth < 0) throw new DocumentApiAdapterError("INVALID_TARGET", "Caption operations require the image to be inside a paragraph.");
	const parentNode = $pos.node(parentDepth + 1);
	let inlineContentCount = 0;
	parentNode.forEach((child) => {
		if (child.isInline) inlineContentCount++;
	});
	if (inlineContentCount !== 1) throw new DocumentApiAdapterError("INVALID_TARGET", "Caption operations require the image to be the sole content of its paragraph.");
}
function imagesInsertCaptionWrapper(editor, input, options) {
	rejectTrackedMode("images.insertCaption", options);
	const image = findImageById(editor, input.imageId);
	requireSoleImageInParagraph(editor, image.pos);
	if (findCaptionParagraph(editor, image.pos)) throw new DocumentApiAdapterError("INVALID_TARGET", "Image already has a caption; use updateCaption.");
	if (options?.dryRun) return buildSuccessResult(image);
	if (executeDomainCommand(editor, () => {
		const paragraph = findContainingParagraph(editor, findImageById(editor, input.imageId).pos);
		const afterParagraphPos = paragraph.pos + paragraph.node.nodeSize;
		const tr = editor.state.tr;
		const captionPara = editor.state.schema.nodes.paragraph.create({ paragraphProperties: { styleId: "Caption" } }, editor.state.schema.text(input.text));
		tr.insert(afterParagraphPos, captionPara);
		if (!tr.docChanged) return false;
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect !== "changed") return buildNoOpResult("Insert caption produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesUpdateCaptionWrapper(editor, input, options) {
	rejectTrackedMode("images.updateCaption", options);
	const image = findImageById(editor, input.imageId);
	requireSoleImageInParagraph(editor, image.pos);
	const caption = findCaptionParagraph(editor, image.pos);
	if (!caption) throw new DocumentApiAdapterError("INVALID_TARGET", "No caption paragraph found; use insertCaption first.");
	if (options?.dryRun) return buildSuccessResult(image);
	if (executeDomainCommand(editor, () => {
		const tr = editor.state.tr;
		const textStart = caption.pos + 1;
		const textEnd = caption.pos + caption.node.nodeSize - 1;
		tr.replaceWith(textStart, textEnd, editor.state.schema.text(input.text));
		if (!tr.docChanged) return false;
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect !== "changed") return buildNoOpResult("Update caption produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function imagesRemoveCaptionWrapper(editor, input, options) {
	rejectTrackedMode("images.removeCaption", options);
	const image = findImageById(editor, input.imageId);
	requireSoleImageInParagraph(editor, image.pos);
	const caption = findCaptionParagraph(editor, image.pos);
	if (!caption) return buildNoOpResult("No caption to remove.");
	if (options?.dryRun) return buildSuccessResult(image);
	if (executeDomainCommand(editor, () => {
		const tr = editor.state.tr;
		tr.delete(caption.pos, caption.pos + caption.node.nodeSize);
		if (!tr.docChanged) return false;
		editor.dispatch(tr);
		return true;
	}).steps[0]?.effect !== "changed") return buildNoOpResult("Remove caption produced no change.");
	return buildSuccessResult(findImageById(editor, input.imageId));
}
function getLinkMarkType(editor) {
	const markType = editor.schema.marks.link;
	if (!markType) throw new Error("Link mark type is not defined in the editor schema.");
	return markType;
}
function dispatchTransaction$2(editor, tr) {
	editor.dispatch(tr);
}
function dispatchIfChanged(editor, tr) {
	if (!tr.docChanged) return false;
	dispatchTransaction$2(editor, tr);
	return true;
}
function createRelationshipId(editor, href) {
	if (editor.options.mode !== "docx") return null;
	return findOrCreateRelationship(editor, "hyperlink-mutation-helper:createRelationshipId", {
		target: href,
		type: "hyperlink"
	});
}
function sanitizeHrefOrThrow(href) {
	const result = sanitizeHref(href);
	if (!result) throw Object.assign(/* @__PURE__ */ new Error(`Blocked or invalid href: "${href}"`), { code: "INVALID_INPUT" });
	return result.href;
}
function buildMarkAttrs(editor, spec) {
	const attrs = {};
	if (spec.href) {
		attrs.href = sanitizeHrefOrThrow(spec.href);
		attrs.rId = createRelationshipId(editor, attrs.href);
	}
	if (spec.anchor) {
		attrs.anchor = spec.anchor;
		if (!spec.href) attrs.href = `#${spec.anchor}`;
	}
	if (spec.docLocation) attrs.docLocation = spec.docLocation;
	if (spec.tooltip) attrs.tooltip = spec.tooltip;
	if (spec.target) attrs.target = spec.target;
	if (spec.rel) attrs.rel = spec.rel;
	return attrs;
}
function wrapWithLink(editor, from$1, to, spec) {
	const linkMarkType = getLinkMarkType(editor);
	const attrs = buildMarkAttrs(editor, spec);
	const tr = editor.state.tr;
	tr.addMark(from$1, to, linkMarkType.create(attrs));
	applyDirectMutationMeta(tr);
	dispatchTransaction$2(editor, tr);
	return true;
}
function insertLinkedText(editor, pos, text, spec) {
	const linkMarkType = getLinkMarkType(editor);
	const attrs = buildMarkAttrs(editor, spec);
	const tr = editor.state.tr;
	const mark = linkMarkType.create(attrs);
	tr.insertText(text, pos);
	tr.addMark(pos, pos + text.length, mark);
	applyDirectMutationMeta(tr);
	dispatchTransaction$2(editor, tr);
	return true;
}
function patchLinkMark(editor, from$1, to, existingMark, patch) {
	const linkMarkType = getLinkMarkType(editor);
	const merged = { ...existingMark.attrs };
	for (const [key, value] of Object.entries(patch)) {
		if (value === void 0) continue;
		if (value === null) merged[key] = null;
		else merged[key] = value;
	}
	if (typeof patch.href === "string") {
		merged.href = sanitizeHrefOrThrow(patch.href);
		merged.rId = createRelationshipId(editor, merged.href);
	}
	if (patch.href === null && typeof merged.anchor === "string") {
		merged.href = `#${merged.anchor}`;
		merged.rId = null;
	}
	if (typeof patch.anchor === "string" && patch.href === void 0) {
		const currentHref = merged.href;
		if (typeof currentHref === "string" && currentHref.startsWith("#")) merged.href = `#${patch.anchor}`;
	}
	if (patch.anchor === null && typeof merged.href === "string" && !merged.href.startsWith("#")) merged.anchor = null;
	const tr = editor.state.tr;
	tr.removeMark(from$1, to, existingMark);
	tr.addMark(from$1, to, linkMarkType.create(merged));
	applyDirectMutationMeta(tr);
	return dispatchIfChanged(editor, tr);
}
function unwrapLink(editor, from$1, to) {
	const linkMarkType = getLinkMarkType(editor);
	const tr = editor.state.tr;
	tr.removeMark(from$1, to, linkMarkType);
	applyDirectMutationMeta(tr);
	return dispatchIfChanged(editor, tr);
}
function deleteLinkedText(editor, from$1, to) {
	const tr = editor.state.tr;
	tr.delete(from$1, to);
	applyDirectMutationMeta(tr);
	dispatchTransaction$2(editor, tr);
	return true;
}
function normalizeReadProperties(attrs) {
	const rawHref = typeof attrs.href === "string" ? attrs.href : void 0;
	const rawAnchor = typeof attrs.anchor === "string" ? attrs.anchor : void 0;
	const rawDocLocation = typeof attrs.docLocation === "string" ? attrs.docLocation : void 0;
	const rawTooltip = typeof attrs.tooltip === "string" ? attrs.tooltip : void 0;
	const rawTarget = typeof attrs.target === "string" ? attrs.target : void 0;
	const rawRel = typeof attrs.rel === "string" ? attrs.rel : void 0;
	const props = {};
	let effectiveAnchor = rawAnchor;
	let effectiveHref = rawHref;
	if (rawHref && rawHref.startsWith("#")) {
		const fragment = rawHref.slice(1);
		if (!rawAnchor) {
			effectiveAnchor = fragment;
			effectiveHref = void 0;
		} else if (rawAnchor === fragment) effectiveHref = void 0;
	}
	if (effectiveHref) props.href = effectiveHref;
	if (effectiveAnchor) props.anchor = effectiveAnchor;
	if (rawDocLocation) props.docLocation = rawDocLocation;
	if (rawTooltip) props.tooltip = rawTooltip;
	if (rawTarget) props.target = rawTarget;
	if (rawRel) props.rel = rawRel;
	return props;
}
function candidateToTarget(candidate) {
	return {
		kind: "inline",
		nodeType: "hyperlink",
		anchor: candidate.anchor
	};
}
function candidateToReadProperties(candidate) {
	return normalizeReadProperties(candidate.mark?.attrs ?? candidate.attrs ?? {});
}
function extractDisplayText(editor, candidate) {
	const doc$1 = editor.state.doc;
	try {
		return doc$1.textBetween(candidate.pos, candidate.end, "");
	} catch {
		return;
	}
}
function candidateToDomain(editor, candidate) {
	return {
		address: candidateToTarget(candidate),
		properties: candidateToReadProperties(candidate),
		text: extractDisplayText(editor, candidate)
	};
}
function encodeInlineRef(anchor) {
	return `${anchor.start.blockId}:${anchor.start.offset}:${anchor.end.offset}`;
}
function isInsideTocBlock(editor, pos) {
	const resolved = editor.state.doc.resolve(pos);
	for (let depth = resolved.depth; depth > 0; depth--) if (resolved.node(depth).type.name === "tableOfContents") return true;
	return false;
}
function rejectIfInsideToc(editor, pos, operationName) {
	if (isInsideTocBlock(editor, pos)) throw new DocumentApiAdapterError("INVALID_TARGET", `${operationName}: target is inside a TOC block. TOC content is managed by toc.* operations.`);
}
function findHyperlinkCandidates(editor) {
	return findInlineByType(buildInlineIndex(editor, getBlockIndex(editor)), "hyperlink");
}
function resolveHyperlinkCandidate(editor, target) {
	const candidate = findInlineByAnchor(buildInlineIndex(editor, getBlockIndex(editor)), target);
	if (!candidate) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Hyperlink target not found in document.", { target });
	return candidate;
}
function resolveCandidateTextRange(editor, candidate, operationName) {
	const start$1 = candidate.anchor.start;
	const end$1 = candidate.anchor.end;
	if (start$1.blockId !== end$1.blockId) throw new DocumentApiAdapterError("INVALID_TARGET", `${operationName}: hyperlink anchor spans multiple blocks.`, { anchor: candidate.anchor });
	const resolved = resolveTextTarget(editor, {
		kind: "text",
		blockId: start$1.blockId,
		range: {
			start: start$1.offset,
			end: end$1.offset
		}
	});
	if (!resolved) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `${operationName}: hyperlink text range could not be resolved.`, { anchor: candidate.anchor });
	return resolved;
}
function hyperlinkSuccess(target) {
	return {
		success: true,
		hyperlink: target
	};
}
function hyperlinkFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function receiptApplied$7(receipt) {
	return receipt.steps[0]?.effect === "changed";
}
function matchesListQuery(candidate, query, editor) {
	if (!query) return true;
	const props = candidateToReadProperties(candidate);
	if (query.hrefPattern && (!props.href || !props.href.includes(query.hrefPattern))) return false;
	if (query.anchor && props.anchor !== query.anchor) return false;
	if (query.textPattern) {
		const text = extractDisplayText(editor, candidate);
		if (!text || !text.includes(query.textPattern)) return false;
	}
	return true;
}
function hyperlinksListWrapper(editor, query) {
	const revision = getRevision(editor);
	let candidates = findHyperlinkCandidates(editor);
	if (query?.within) {
		const withinResult = resolveWithinScope(getBlockIndex(editor), { within: query.within }, []);
		if (!withinResult.ok) candidates = [];
		else candidates = scopeByRange(candidates, withinResult.range);
	}
	const { total, items: paged } = paginate(candidates.filter((c) => matchesListQuery(c, query, editor)).map((candidate) => {
		const domain = candidateToDomain(editor, candidate);
		const ref$1 = encodeInlineRef(candidate.anchor);
		return buildDiscoveryItem(ref$1, buildResolvedHandle(ref$1, "ephemeral", "node"), domain);
	}), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function hyperlinksGetWrapper(editor, input) {
	const candidate = resolveHyperlinkCandidate(editor, input.target);
	return {
		address: candidateToTarget(candidate),
		properties: candidateToReadProperties(candidate),
		text: extractDisplayText(editor, candidate)
	};
}
function specFromInput(link) {
	return {
		href: link.destination.href,
		anchor: link.destination.anchor,
		docLocation: link.destination.docLocation,
		tooltip: link.tooltip,
		target: link.target,
		rel: link.rel
	};
}
function hyperlinksWrapWrapper(editor, input, options) {
	rejectTrackedMode("hyperlinks.wrap", options);
	const resolved = resolveTextTarget(editor, input.target);
	if (!resolved) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "hyperlinks.wrap: text target block not found.", { target: input.target });
	rejectIfInsideToc(editor, resolved.from, "hyperlinks.wrap");
	const overlapping = findInlineByType(buildInlineIndex(editor, getBlockIndex(editor)), "hyperlink").filter((c) => c.pos < resolved.to && c.end > resolved.from);
	if (overlapping.length > 1) throw new DocumentApiAdapterError("INVALID_TARGET", "hyperlinks.wrap: target range spans multiple existing links.");
	if (overlapping.length === 1) {
		const existing = overlapping[0];
		if (existing.pos === resolved.from && existing.end === resolved.to) {
			const existingProps = candidateToReadProperties(existing);
			const spec$1 = specFromInput(input.link);
			if (existingProps.href === spec$1.href && existingProps.anchor === spec$1.anchor) return hyperlinkFailure("NO_OP", "Text range is already linked with the same destination.");
		} else throw new DocumentApiAdapterError("INVALID_TARGET", "hyperlinks.wrap: target range partially overlaps an existing link. Remove the existing link first.");
	}
	if (input.link.destination.href) sanitizeHrefOrThrow(input.link.destination.href);
	if (options?.dryRun) return hyperlinkSuccess({
		kind: "inline",
		nodeType: "hyperlink",
		anchor: {
			start: {
				blockId: input.target.blockId,
				offset: input.target.range.start
			},
			end: {
				blockId: input.target.blockId,
				offset: input.target.range.end
			}
		}
	});
	const spec = specFromInput(input.link);
	if (!receiptApplied$7(executeDomainCommand(editor, () => {
		const result = wrapWithLink(editor, resolved.from, resolved.to, spec);
		if (result) clearIndexCache(editor);
		return result;
	}, { expectedRevision: options?.expectedRevision }))) return hyperlinkFailure("NO_OP", "Wrap operation produced no change.");
	const postCandidate = findHyperlinkAtRange(editor, resolved.from, resolved.to);
	return hyperlinkSuccess(postCandidate ? candidateToTarget(postCandidate) : {
		kind: "inline",
		nodeType: "hyperlink",
		anchor: {
			start: {
				blockId: input.target.blockId,
				offset: input.target.range.start
			},
			end: {
				blockId: input.target.blockId,
				offset: input.target.range.end
			}
		}
	});
}
function hyperlinksInsertWrapper(editor, input, options) {
	rejectTrackedMode("hyperlinks.insert", options);
	let insertPos;
	let blockId;
	let offset$1;
	let structuralEnd = false;
	if (input.target) {
		const resolved = resolveTextTarget(editor, input.target);
		if (!resolved) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "hyperlinks.insert: text target block not found.", { target: input.target });
		rejectIfInsideToc(editor, resolved.from, "hyperlinks.insert");
		insertPos = resolved.from;
		blockId = input.target.blockId;
		offset$1 = input.target.range.start;
	} else {
		const fallback = resolveDefaultInsertTarget(editor);
		if (!fallback) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "hyperlinks.insert: document has no content to insert into.");
		if (fallback.kind === "text-block") {
			insertPos = fallback.range.from;
			blockId = fallback.target.blockId;
			offset$1 = fallback.target.range.start;
		} else {
			insertPos = fallback.insertPos;
			blockId = "";
			offset$1 = 0;
			structuralEnd = true;
		}
	}
	if (input.link.destination.href) sanitizeHrefOrThrow(input.link.destination.href);
	if (options?.dryRun) return hyperlinkSuccess({
		kind: "inline",
		nodeType: "hyperlink",
		anchor: {
			start: {
				blockId,
				offset: offset$1
			},
			end: {
				blockId,
				offset: offset$1 + input.text.length
			}
		}
	});
	const spec = specFromInput(input.link);
	if (!receiptApplied$7(executeDomainCommand(editor, () => {
		if (structuralEnd) {
			insertParagraphAtEnd(editor, insertPos, input.text);
			clearIndexCache(editor);
			const textStart = insertPos + 1;
			const result$1 = wrapWithLink(editor, textStart, textStart + input.text.length, spec);
			if (result$1) clearIndexCache(editor);
			return result$1;
		}
		const result = insertLinkedText(editor, insertPos, input.text, spec);
		if (result) clearIndexCache(editor);
		return result;
	}, { expectedRevision: options?.expectedRevision }))) return hyperlinkFailure("NO_OP", "Insert operation produced no change.");
	const searchFrom = structuralEnd ? insertPos + 1 : insertPos;
	const postCandidate = findHyperlinkAtRange(editor, searchFrom, searchFrom + input.text.length);
	return hyperlinkSuccess(postCandidate ? candidateToTarget(postCandidate) : {
		kind: "inline",
		nodeType: "hyperlink",
		anchor: {
			start: {
				blockId,
				offset: offset$1
			},
			end: {
				blockId,
				offset: offset$1 + input.text.length
			}
		}
	});
}
function hyperlinksPatchWrapper(editor, input, options) {
	rejectTrackedMode("hyperlinks.patch", options);
	const candidate = resolveHyperlinkCandidate(editor, input.target);
	const resolvedRange = resolveCandidateTextRange(editor, candidate, "hyperlinks.patch");
	rejectIfInsideToc(editor, resolvedRange.from, "hyperlinks.patch");
	const existingMark = candidate.mark;
	if (!existingMark) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "hyperlinks.patch: resolved candidate has no mark.");
	const oldAttrs = existingMark.attrs;
	const mergedHref = input.patch.href === void 0 ? oldAttrs.href : input.patch.href;
	const mergedAnchor = input.patch.anchor === void 0 ? oldAttrs.anchor : input.patch.anchor;
	const hasHref = typeof mergedHref === "string" && mergedHref.length > 0;
	const hasAnchor$1 = typeof mergedAnchor === "string" && mergedAnchor.length > 0;
	if (!hasHref && !hasAnchor$1) throw new DocumentApiAdapterError("INVALID_INPUT", "hyperlinks.patch: resulting destination must have at least one of href or anchor.");
	if (typeof input.patch.href === "string") sanitizeHrefOrThrow(input.patch.href);
	const currentProps = candidateToReadProperties(candidate);
	if (Object.entries(input.patch).every(([key, value]) => {
		if (value === void 0) return true;
		if (value === null) return currentProps[key] === void 0;
		return currentProps[key] === value;
	})) return hyperlinkFailure("NO_OP", "Patch produces no change — all values already match.");
	if (options?.dryRun) return hyperlinkSuccess(candidateToTarget(candidate));
	if (!receiptApplied$7(executeDomainCommand(editor, () => {
		const result = patchLinkMark(editor, resolvedRange.from, resolvedRange.to, existingMark, input.patch);
		if (result) clearIndexCache(editor);
		return result;
	}, { expectedRevision: options?.expectedRevision }))) return hyperlinkFailure("NO_OP", "Patch operation produced no change.");
	const postCandidate = findHyperlinkAtRange(editor, resolvedRange.from, resolvedRange.to);
	return hyperlinkSuccess(postCandidate ? candidateToTarget(postCandidate) : candidateToTarget(candidate));
}
function hyperlinksRemoveWrapper(editor, input, options) {
	rejectTrackedMode("hyperlinks.remove", options);
	const candidate = resolveHyperlinkCandidate(editor, input.target);
	const resolvedRange = resolveCandidateTextRange(editor, candidate, "hyperlinks.remove");
	rejectIfInsideToc(editor, resolvedRange.from, "hyperlinks.remove");
	const mode = input.mode ?? "unwrap";
	const targetAddress = candidateToTarget(candidate);
	if (options?.dryRun) return hyperlinkSuccess(targetAddress);
	if (!receiptApplied$7(executeDomainCommand(editor, () => {
		const result = mode === "unwrap" ? unwrapLink(editor, resolvedRange.from, resolvedRange.to) : deleteLinkedText(editor, resolvedRange.from, resolvedRange.to);
		if (result) clearIndexCache(editor);
		return result;
	}, { expectedRevision: options?.expectedRevision }))) return hyperlinkFailure("NO_OP", `Remove (${mode}) operation produced no change.`);
	return hyperlinkSuccess(targetAddress);
}
function findHyperlinkAtRange(editor, from$1, to) {
	const hyperlinks = findInlineByType(buildInlineIndex(editor, getBlockIndex(editor)), "hyperlink");
	return hyperlinks.find((c) => c.pos >= from$1 - 1 && c.pos <= from$1 + 1 && c.end >= to - 1 && c.end <= to + 1) ?? hyperlinks.find((c) => c.pos <= from$1 && c.end >= to);
}
function generateSdtId() {
	return String(Math.floor(Math.random() * 2147483647));
}
function isValidWordSdtId(id) {
	if (!/^-?\d+$/.test(id)) return false;
	const n = Number(id);
	return n >= -2147483648 && n <= 2147483647;
}
var FORBIDDEN_RAW_PATCH_NAMES = new Set([
	"w:sdtContent",
	"w:id",
	"w:sdtPr"
]);
function reIdDescendantSdts(node, schema) {
	if (node.childCount === 0) return node;
	const children = [];
	let changed = false;
	node.forEach((child) => {
		let result = child;
		if (isSdtNode(child)) {
			result = child.type.create({
				...child.attrs,
				id: generateSdtId()
			}, child.content, child.marks);
			changed = true;
		}
		const recursed = reIdDescendantSdts(result, schema);
		if (recursed !== result) changed = true;
		children.push(recursed);
	});
	if (!changed) return node;
	return node.copy(Fragment$1.from(children));
}
function executeSdtMutation(editor, target, options, handler) {
	const mode = options?.changeMode ?? "direct";
	if (mode !== "direct") throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", `Content control mutations only support changeMode "direct", got "${mode}".`, { changeMode: mode });
	if (options?.dryRun) return buildMutationSuccess(target);
	let updatedRef;
	const receipt = executeDomainCommand(editor, () => {
		const result = handler();
		if (typeof result === "boolean") return result;
		updatedRef = result;
		return true;
	}, { expectedRevision: options?.expectedRevision });
	clearIndexCache(editor);
	if (receipt.steps[0]?.effect !== "changed") return buildMutationFailure("NO_OP", "The mutation had no effect.");
	return buildMutationSuccess(target, updatedRef);
}
function dispatchTransaction$1(editor, tr) {
	if (editor.view?.dispatch) {
		editor.view.dispatch(tr);
		return;
	}
	if (typeof editor.dispatch === "function") {
		editor.dispatch(tr);
		return;
	}
	throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "Content-control mutation requires an editor dispatch function.");
}
function buildEmptyBlockContent(editor, sdtNode) {
	const firstChild = sdtNode.childCount > 0 ? sdtNode.child(0) : null;
	if (firstChild?.type?.name === "paragraph") return firstChild.type.create(firstChild.attrs ?? null, null, firstChild.marks);
	const paragraphType = editor.schema.nodes.paragraph;
	if (!paragraphType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "Content-control text mutation requires the paragraph node type in the schema.");
	return paragraphType.createAndFill?.() ?? paragraphType.create();
}
function getOnlyChild(node) {
	return node.childCount === 1 ? node.child(0) : null;
}
function hasMeaningfulAttributeValue(value) {
	if (value == null) return false;
	if (Array.isArray(value)) return value.some(hasMeaningfulAttributeValue);
	if (typeof value === "object") return Object.values(value).some(hasMeaningfulAttributeValue);
	return value !== "";
}
function hasSubstantiveNodeAttrs(node) {
	return hasMeaningfulAttributeValue(node.attrs ?? null);
}
function isPlainTextNode(node, expectedText) {
	return node?.type.name === "text" && node.text === expectedText && (node.marks?.length ?? 0) === 0;
}
function isPlainRunNode(node, expectedText) {
	if (node?.type.name !== "run") return false;
	if (hasSubstantiveNodeAttrs(node)) return false;
	return isPlainTextNode(getOnlyChild(node), expectedText);
}
function isCanonicalPlainTextInlineContent(node, expectedText) {
	const onlyChild = getOnlyChild(node);
	if (expectedText.length === 0) return node.childCount === 0 || isPlainTextNode(onlyChild, "") || isPlainRunNode(onlyChild, "");
	return isPlainTextNode(onlyChild, expectedText) || isPlainRunNode(onlyChild, expectedText);
}
function isCanonicalPlainTextParagraph(node, expectedText) {
	if (node?.type.name !== "paragraph") return false;
	const onlyChild = getOnlyChild(node);
	if (expectedText.length === 0) return node.childCount === 0 || isPlainTextNode(onlyChild, "") || isPlainRunNode(onlyChild, "");
	return isPlainTextNode(onlyChild, expectedText) || isPlainRunNode(onlyChild, expectedText);
}
function alreadyMatchesPlainTextReplacement(sdt, expectedText) {
	if (sdt.kind === "inline") return isCanonicalPlainTextInlineContent(sdt.node, expectedText);
	return isCanonicalPlainTextParagraph(getOnlyChild(sdt.node), expectedText);
}
function replaceSdtTextContent(editor, target, text) {
	const resolved = resolveSdtByTarget(editor.state.doc, target);
	const { tr } = editor.state;
	const innerFrom = resolved.pos + 1;
	const innerTo = resolved.pos + resolved.node.nodeSize - 1;
	if (resolved.kind === "inline") {
		if (text.length > 0) {
			const textNode = editor.schema.text(text);
			tr.replaceWith(innerFrom, innerTo, textNode);
		} else tr.delete(innerFrom, innerTo);
		dispatchTransaction$1(editor, tr);
		return true;
	}
	const paragraph = buildEmptyBlockContent(editor, resolved.node);
	if (!paragraph) return false;
	const paragraphText$1 = text.length > 0 ? buildTextWithTabs(editor.schema, text, void 0) : null;
	const updatedParagraph = paragraph.type.create(paragraph.attrs ?? null, paragraphText$1, paragraph.marks);
	tr.replaceWith(innerFrom, innerTo, updatedParagraph);
	dispatchTransaction$1(editor, tr);
	return true;
}
function listWrapper(editor, query) {
	let infos = findAllSdtNodes(editor.state.doc).map(buildContentControlInfoFromNode);
	if (query?.controlType) infos = infos.filter((info) => info.controlType === query.controlType);
	if (query?.tag) infos = infos.filter((info) => info.properties.tag === query.tag);
	return applyPagination(infos, query);
}
function getWrapper(editor, input) {
	return buildContentControlInfoFromNode(resolveSdtByTarget(editor.state.doc, input.target));
}
function listInRangeWrapper(editor, input) {
	const doc$1 = editor.state.doc;
	const allSdts = findAllSdtNodes(doc$1);
	let rangeStart = 0;
	let rangeEnd = doc$1.content.size;
	if (input.startBlockId || input.endBlockId) {
		const blockIndex = buildBlockIndex(editor);
		if (input.startBlockId) rangeStart = findBlockByNodeIdOnly(blockIndex, input.startBlockId).pos;
		if (input.endBlockId) rangeEnd = findBlockByNodeIdOnly(blockIndex, input.endBlockId).end;
	}
	return applyPagination(allSdts.filter((sdt) => {
		const sdtEnd = sdt.pos + sdt.node.nodeSize;
		return sdt.pos >= rangeStart && sdtEnd <= rangeEnd;
	}).map(buildContentControlInfoFromNode), input);
}
function selectByTagWrapper(editor, input) {
	return applyPagination(findAllSdtNodes(editor.state.doc).map(buildContentControlInfoFromNode).filter((info) => info.properties.tag === input.tag), input);
}
function selectByTitleWrapper(editor, input) {
	return applyPagination(findAllSdtNodes(editor.state.doc).map(buildContentControlInfoFromNode).filter((info) => info.properties.alias === input.title), input);
}
function listChildrenWrapper(editor, input) {
	const parent = resolveSdtByTarget(editor.state.doc, input.target);
	const children = [];
	parent.node.forEach((child, offset$1) => {
		if (isSdtNode(child)) children.push({
			node: child,
			pos: parent.pos + 1 + offset$1,
			kind: child.type.name === "structuredContentBlock" ? "block" : "inline"
		});
	});
	return applyPagination(children.map(buildContentControlInfoFromNode), input);
}
function getParentWrapper(editor, input) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	const $pos = editor.state.doc.resolve(sdt.pos);
	for (let depth = $pos.depth - 1; depth >= 0; depth--) {
		const ancestor = $pos.node(depth);
		if (isSdtNode(ancestor)) return buildContentControlInfoFromNode({
			node: ancestor,
			pos: $pos.before(depth),
			kind: ancestor.type.name === "structuredContentBlock" ? "block" : "inline"
		});
	}
	return null;
}
function wrapWrapper(editor, input, options) {
	resolveSdtByTarget(editor.state.doc, input.target);
	const id = generateSdtId();
	const wrapperTarget = {
		kind: input.kind,
		nodeType: "sdt",
		nodeId: id
	};
	return executeSdtMutation(editor, input.target, options, () => {
		const resolved = resolveSdtByTarget(editor.state.doc, input.target);
		const nodeTypeName = input.kind === "block" ? SDT_BLOCK_NAME : "structuredContent";
		const nodeType = editor.schema.nodes[nodeTypeName];
		if (!nodeType) return false;
		const wrapperNode = nodeType.create({
			id,
			tag: input.tag,
			alias: input.alias,
			lockMode: input.lockMode ?? "unlocked",
			controlType: "richText",
			type: "richText",
			sdtPr: buildDefaultSdtPr("richText")
		}, resolved.node);
		const { tr } = editor.state;
		tr.replaceWith(resolved.pos, resolved.pos + resolved.node.nodeSize, wrapperNode);
		dispatchTransaction$1(editor, tr);
		return wrapperTarget;
	});
}
function unwrapWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertNotSdtLocked(sdt, "unwrap");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		const resolved = resolveSdtByTarget(editor.state.doc, input.target);
		const { tr } = editor.state;
		tr.replaceWith(resolved.pos, resolved.pos + resolved.node.nodeSize, resolved.node.content);
		dispatchTransaction$1(editor, tr);
		return true;
	});
}
function deleteWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertNotSdtLocked(sdt, "delete");
	const target = buildTarget(sdt);
	const deleteCmd = editor.commands?.deleteStructuredContentById;
	if (typeof deleteCmd !== "function") throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "deleteStructuredContentById command not available.");
	return executeSdtMutation(editor, target, options, () => {
		return Boolean(deleteCmd(input.target.nodeId));
	});
}
function copyWrapper(editor, input, options) {
	resolveSdtByTarget(editor.state.doc, input.target);
	const target = input.target;
	return executeSdtMutation(editor, target, options, () => {
		const source = resolveSdtByTarget(editor.state.doc, input.target);
		const dest = resolveSdtByTarget(editor.state.doc, input.destination);
		const newId = generateSdtId();
		const cloned = reIdDescendantSdts(source.node.type.create({
			...source.node.attrs,
			id: newId
		}, source.node.content, source.node.marks), editor.schema);
		const { tr } = editor.state;
		const insertPos = dest.pos + dest.node.nodeSize;
		tr.insert(insertPos, cloned);
		dispatchTransaction$1(editor, tr);
		return {
			kind: source.kind,
			nodeType: "sdt",
			nodeId: newId
		};
	});
}
function moveWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertNotSdtLocked(sdt, "move");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		const source = resolveSdtByTarget(editor.state.doc, input.target);
		const { tr } = editor.state;
		tr.delete(source.pos, source.pos + source.node.nodeSize);
		const destAfterDelete = resolveSdtByTarget(tr.doc, input.destination);
		const insertPos = destAfterDelete.pos + destAfterDelete.node.nodeSize;
		tr.insert(insertPos, source.node);
		dispatchTransaction$1(editor, tr);
		return true;
	});
}
function patchWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertNotSdtLocked(sdt, "patch");
	const target = buildTarget(sdt);
	const patchFields = {};
	if (input.alias !== void 0) patchFields.alias = input.alias;
	if (input.tag !== void 0) patchFields.tag = input.tag;
	if (input.appearance !== void 0) patchFields.appearance = input.appearance;
	if (input.color !== void 0) patchFields.color = input.color;
	if (input.placeholder !== void 0) patchFields.placeholder = input.placeholder;
	if (input.showingPlaceholder !== void 0) patchFields.showingPlaceholder = input.showingPlaceholder;
	if (input.temporary !== void 0) patchFields.temporary = input.temporary;
	if (input.tabIndex !== void 0) patchFields.tabIndex = input.tabIndex;
	return executeSdtMutation(editor, target, options, () => {
		return applyAttrsUpdate(editor, input.target.nodeId, patchFields);
	});
}
function setLockModeWrapper(editor, input, options) {
	return executeSdtMutation(editor, buildTarget(resolveSdtByTarget(editor.state.doc, input.target)), options, () => {
		return applyAttrsUpdate(editor, input.target.nodeId, { lockMode: input.lockMode });
	});
}
var CONTROL_TYPE_SDT_PR_ELEMENTS = {
	text: "w:text",
	richText: "w:richText",
	date: "w:date",
	checkbox: "w14:checkbox",
	comboBox: "w:comboBox",
	dropDownList: "w:dropDownList",
	repeatingSection: "w15:repeatingSection",
	repeatingSectionItem: "w15:repeatingSectionItem",
	group: "w:group"
};
var DEFAULT_CHECKBOX_SYMBOL_FONT = "MS Gothic";
var DEFAULT_CHECKBOX_CHECKED_HEX = "2612";
var DEFAULT_CHECKBOX_UNCHECKED_HEX = "2610";
function pad2(value) {
	return String(value).padStart(2, "0");
}
function buildDateControlDefaults(now = /* @__PURE__ */ new Date()) {
	const year = now.getFullYear();
	const month = now.getMonth() + 1;
	const day = now.getDate();
	return {
		displayText: `${month}/${day}/${year}`,
		fullDate: `${year}-${pad2(month)}-${pad2(day)}T00:00:00Z`,
		dateFormat: "M/d/yyyy",
		locale: "en-US",
		storageFormat: "dateTime",
		calendar: "gregorian"
	};
}
function upsertChildElement(elements, childName, attrs) {
	const idx = elements.findIndex((el) => el.name === childName);
	const next = [...elements];
	const value = {
		name: childName,
		type: "element",
		attributes: attrs
	};
	if (idx >= 0) next[idx] = value;
	else next.push(value);
	return next;
}
function applyDateDefaultsToSdtPr(sdtPr, defaults) {
	if (!sdtPr) return sdtPr;
	const dateEl = findSdtPrChild(sdtPr, "w:date");
	if (!dateEl) return sdtPr;
	let dateChildren = [...dateEl.elements ?? []];
	dateChildren = upsertChildElement(dateChildren, "w:dateFormat", { "w:val": defaults.dateFormat });
	dateChildren = upsertChildElement(dateChildren, "w:lid", { "w:val": defaults.locale });
	dateChildren = upsertChildElement(dateChildren, "w:storeMappedDataAs", { "w:val": defaults.storageFormat });
	dateChildren = upsertChildElement(dateChildren, "w:calendar", { "w:val": defaults.calendar });
	const dateNext = {
		...dateEl,
		name: "w:date",
		type: "element",
		attributes: {
			...dateEl.attributes ?? {},
			"w:fullDate": defaults.fullDate
		},
		elements: dateChildren
	};
	const elements = [...sdtPr.elements ?? []];
	const idx = elements.findIndex((el) => el.name === "w:date");
	if (idx >= 0) elements[idx] = dateNext;
	else elements.push(dateNext);
	return {
		...sdtPr,
		elements
	};
}
function parseCheckboxSymbolCodePoint(raw, fallbackHex) {
	const fallback = Number.parseInt(fallbackHex, 16);
	const normalized = String(raw ?? "").trim().replace(/^0x/i, "");
	if (!normalized) return fallback;
	if (/^[0-9A-Fa-f]+$/.test(normalized)) {
		const parsedHex = Number.parseInt(normalized, 16);
		if (Number.isInteger(parsedHex) && parsedHex >= 0 && parsedHex <= 1114111) return parsedHex;
	}
	if (/^\d+$/.test(normalized)) {
		const parsedDec = Number.parseInt(normalized, 10);
		if (Number.isInteger(parsedDec) && parsedDec >= 0 && parsedDec <= 1114111) return parsedDec;
	}
	return fallback;
}
function resolveCheckboxVisualSymbol(sdtPr, checked) {
	const checkboxEl = findSdtPrChild(sdtPr, "w14:checkbox") ?? findSdtPrChild(sdtPr, "w:checkbox");
	const stateName = checked ? "w14:checkedState" : "w14:uncheckedState";
	const legacyStateName = checked ? "w:checkedState" : "w:uncheckedState";
	const stateEl = checkboxEl?.elements?.find((e) => e.name === stateName || e.name === legacyStateName);
	const fallbackHex = checked ? DEFAULT_CHECKBOX_CHECKED_HEX : DEFAULT_CHECKBOX_UNCHECKED_HEX;
	const codePoint = parseCheckboxSymbolCodePoint(stateEl?.attributes?.["w14:val"] ?? stateEl?.attributes?.["w:val"], fallbackHex);
	const font = String(stateEl?.attributes?.["w14:font"] ?? stateEl?.attributes?.["w:font"] ?? DEFAULT_CHECKBOX_SYMBOL_FONT);
	return {
		char: String.fromCodePoint(codePoint),
		font
	};
}
function buildCheckboxTextJson(symbol) {
	return {
		type: "text",
		text: symbol.char,
		marks: [{
			type: "textStyle",
			attrs: { fontFamily: symbol.font }
		}]
	};
}
function createTextWithOptionalFont(editor, text, fontFamily) {
	if (fontFamily) {
		const textStyleMark = editor.schema.marks?.textStyle;
		if (textStyleMark) return editor.schema.text(text, [textStyleMark.create({ fontFamily })]);
	}
	return editor.schema.text(text);
}
function buildDefaultTypeSdtPrElement(controlType) {
	switch (controlType) {
		case "text": return {
			name: "w:text",
			type: "element"
		};
		case "richText": return {
			name: "w:richText",
			type: "element"
		};
		case "date": return {
			name: "w:date",
			type: "element",
			elements: [
				{
					name: "w:dateFormat",
					type: "element",
					attributes: { "w:val": "M/d/yyyy" }
				},
				{
					name: "w:lid",
					type: "element",
					attributes: { "w:val": "en-US" }
				},
				{
					name: "w:storeMappedDataAs",
					type: "element",
					attributes: { "w:val": "dateTime" }
				},
				{
					name: "w:calendar",
					type: "element",
					attributes: { "w:val": "gregorian" }
				}
			]
		};
		case "checkbox": return {
			name: "w14:checkbox",
			type: "element",
			elements: [
				{
					name: "w14:checked",
					type: "element",
					attributes: { "w14:val": "0" }
				},
				{
					name: "w14:checkedState",
					type: "element",
					attributes: {
						"w14:font": DEFAULT_CHECKBOX_SYMBOL_FONT,
						"w14:val": DEFAULT_CHECKBOX_CHECKED_HEX
					}
				},
				{
					name: "w14:uncheckedState",
					type: "element",
					attributes: {
						"w14:font": DEFAULT_CHECKBOX_SYMBOL_FONT,
						"w14:val": DEFAULT_CHECKBOX_UNCHECKED_HEX
					}
				}
			]
		};
		case "comboBox": return {
			name: "w:comboBox",
			type: "element",
			elements: []
		};
		case "dropDownList": return {
			name: "w:dropDownList",
			type: "element",
			elements: []
		};
		case "repeatingSection": return {
			name: "w15:repeatingSection",
			type: "element",
			elements: [{
				name: "w15:allowInsertDeleteSection",
				type: "element",
				attributes: { "w15:val": "1" }
			}]
		};
		case "repeatingSectionItem": return {
			name: "w15:repeatingSectionItem",
			type: "element"
		};
		case "group": return {
			name: "w:group",
			type: "element"
		};
		default: return;
	}
}
function buildDefaultSdtPr(controlType) {
	const typeElement = buildDefaultTypeSdtPrElement(controlType);
	if (!typeElement) return void 0;
	return {
		name: "w:sdtPr",
		type: "element",
		elements: [typeElement]
	};
}
function setTypeWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertNotSdtLocked(sdt, "setType");
	const currentType = resolveControlType(sdt.node.attrs);
	if (currentType === input.controlType) return buildMutationFailure("NO_OP", `Control type is already "${currentType}".`);
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		const oldElementName = CONTROL_TYPE_SDT_PR_ELEMENTS[currentType];
		if (oldElementName) updateSdtPrChild(editor, input.target, oldElementName, () => null);
		const newElementName = CONTROL_TYPE_SDT_PR_ELEMENTS[input.controlType];
		if (newElementName) {
			const defaultTypeElement = buildDefaultTypeSdtPrElement(input.controlType);
			updateSdtPrChild(editor, input.target, newElementName, (existing) => existing ?? defaultTypeElement ?? {
				name: newElementName,
				type: "element"
			});
		}
		return applyAttrsUpdate(editor, input.target.nodeId, {
			controlType: input.controlType,
			type: input.controlType
		});
	});
}
function getContentWrapper(editor, input) {
	return {
		content: resolveSdtByTarget(editor.state.doc, input.target).node.textContent,
		format: "text"
	};
}
function replaceContentWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertNotContentLocked(sdt, "replaceContent");
	if ((input.format ?? "text") === "text" && alreadyMatchesPlainTextReplacement(sdt, input.content)) return buildMutationFailure("NO_OP", "Content control already contains the requested text.");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		return replaceSdtTextContent(editor, input.target, input.content);
	});
}
function clearContentWrapper$1(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertNotContentLocked(sdt, "clearContent");
	if (alreadyMatchesPlainTextReplacement(sdt, "")) return buildMutationFailure("NO_OP", "Content control is already empty.");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		return replaceSdtTextContent(editor, input.target, "");
	});
}
function appendContentWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertNotContentLocked(sdt, "appendContent");
	if (input.content.length === 0) return buildMutationFailure("NO_OP", "Appended content is empty.");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		const currentText = resolveSdtByTarget(editor.state.doc, input.target).node.textContent;
		return replaceSdtTextContent(editor, input.target, currentText + input.content);
	});
}
function prependContentWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertNotContentLocked(sdt, "prependContent");
	if (input.content.length === 0) return buildMutationFailure("NO_OP", "Prepended content is empty.");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		const currentText = resolveSdtByTarget(editor.state.doc, input.target).node.textContent;
		return replaceSdtTextContent(editor, input.target, input.content + currentText);
	});
}
function insertTextAroundSdt(editor, target, content, resolvePos) {
	const pos = resolvePos(resolveSdtByTarget(editor.state.doc, target));
	const { tr } = editor.state;
	const tabType = editor.schema.nodes?.tab;
	const parentAllowsTab = tabType && content.includes("	") ? parentAllowsNodeAt(tr, pos, tabType) : false;
	const lineBreakType = editor.schema.nodes?.lineBreak;
	const parentAllowsLineBreak = lineBreakType && /[\r\n]/.test(content) ? parentAllowsNodeAt(tr, pos, lineBreakType) : false;
	tr.insert(pos, buildTextWithTabs(editor.schema, content, void 0, {
		parentAllowsTab,
		parentAllowsLineBreak
	}));
	dispatchTransaction$1(editor, tr);
	return true;
}
function insertBeforeWrapper(editor, input, options) {
	return executeSdtMutation(editor, buildTarget(resolveSdtByTarget(editor.state.doc, input.target)), options, () => insertTextAroundSdt(editor, input.target, input.content, (resolved) => resolved.pos));
}
function insertAfterWrapper(editor, input, options) {
	return executeSdtMutation(editor, buildTarget(resolveSdtByTarget(editor.state.doc, input.target)), options, () => insertTextAroundSdt(editor, input.target, input.content, (resolved) => resolved.pos + resolved.node.nodeSize));
}
function getBindingWrapper(editor, input) {
	return resolveBinding(resolveSdtByTarget(editor.state.doc, input.target).node.attrs) ?? null;
}
function setBindingWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertNotSdtLocked(sdt, "setBinding");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		const bindingAttrs = {
			"w:storeItemID": input.storeItemId,
			"w:xpath": input.xpath
		};
		if (input.prefixMappings) bindingAttrs["w:prefixMappings"] = input.prefixMappings;
		return updateSdtPrChild(editor, input.target, "w:dataBinding", () => ({
			name: "w:dataBinding",
			type: "element",
			attributes: bindingAttrs
		}));
	});
}
function clearBindingWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertNotSdtLocked(sdt, "clearBinding");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		return updateSdtPrChild(editor, input.target, "w:dataBinding", () => null);
	});
}
function getRawPropertiesWrapper(editor, input) {
	const sdtPr = resolveSdtByTarget(editor.state.doc, input.target).node.attrs.sdtPr;
	return { properties: typeof sdtPr === "object" && sdtPr !== null ? { ...sdtPr } : {} };
}
function patchRawPropertiesWrapper(editor, input, options) {
	const target = buildTarget(resolveSdtByTarget(editor.state.doc, input.target));
	const seenNames = /* @__PURE__ */ new Set();
	for (const patch of input.patches) {
		if (seenNames.has(patch.name)) throw new DocumentApiAdapterError("INVALID_INPUT", `Duplicate patch name "${patch.name}" in the same patch array.`);
		seenNames.add(patch.name);
		if (FORBIDDEN_RAW_PATCH_NAMES.has(patch.name)) throw new DocumentApiAdapterError("INVALID_INPUT", `Patching "${patch.name}" is not allowed via patchRawProperties.`, { name: patch.name });
		if (patch.name.startsWith("r:")) throw new DocumentApiAdapterError("INVALID_INPUT", `Injecting relationship references ("${patch.name}") is not allowed.`, { name: patch.name });
		if (patch.name.startsWith("cp:") || patch.name === "Types" || patch.name === "[Content_Types]") throw new DocumentApiAdapterError("INVALID_INPUT", `Injecting package-level elements ("${patch.name}") is not allowed.`, { name: patch.name });
	}
	return executeSdtMutation(editor, target, options, () => {
		let currentSdtPr = resolveSdtByTarget(editor.state.doc, input.target).node.attrs.sdtPr ?? {
			name: "w:sdtPr",
			elements: []
		};
		for (const patch of input.patches) switch (patch.op) {
			case "set": {
				const el = patch.element;
				const normalized = {
					...el,
					name: patch.name,
					type: el.type ?? "element"
				};
				currentSdtPr = upsertSdtPrChild(currentSdtPr, patch.name, normalized);
				break;
			}
			case "remove":
				currentSdtPr = removeSdtPrChild(currentSdtPr, patch.name);
				break;
			case "setAttr": {
				const existing = findSdtPrChild(currentSdtPr, patch.name);
				if (!existing) throw new DocumentApiAdapterError("INVALID_TARGET", `Element "${patch.name}" does not exist in sdtPr.`);
				currentSdtPr = upsertSdtPrChild(currentSdtPr, patch.name, {
					...existing,
					attributes: {
						...existing.attributes ?? {},
						[patch.attr]: patch.value
					}
				});
				break;
			}
			case "removeAttr": {
				const existingEl = findSdtPrChild(currentSdtPr, patch.name);
				if (!existingEl) throw new DocumentApiAdapterError("INVALID_TARGET", `Element "${patch.name}" does not exist in sdtPr.`);
				const attrs = { ...existingEl.attributes ?? {} };
				delete attrs[patch.attr];
				currentSdtPr = upsertSdtPrChild(currentSdtPr, patch.name, {
					...existingEl,
					attributes: attrs
				});
				break;
			}
		}
		return applyAttrsUpdate(editor, input.target.nodeId, { sdtPr: currentSdtPr });
	});
}
function validateWordCompatibilityWrapper(editor, input) {
	const attrs = resolveSdtByTarget(editor.state.doc, input.target).node.attrs;
	const diagnostics = [];
	const id = String(attrs.id ?? "");
	if (!isValidWordSdtId(id)) diagnostics.push({
		code: "INVALID_ID_FORMAT",
		severity: "error",
		message: `Content control id "${id}" is not a valid signed 32-bit integer.`
	});
	return {
		compatible: diagnostics.length === 0,
		diagnostics
	};
}
function normalizeWordCompatibilityWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	const target = buildTarget(sdt);
	if (isValidWordSdtId(String(sdt.node.attrs.id ?? ""))) return buildMutationFailure("NO_OP", "Content control ID is already Word-compatible.");
	return executeSdtMutation(editor, target, options, () => {
		const newId = generateSdtId();
		return applyAttrsUpdate(editor, input.target.nodeId, { id: newId });
	});
}
function normalizeTagPayloadWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	const target = buildTarget(sdt);
	const tag = sdt.node.attrs.tag;
	if (tag) try {
		JSON.parse(tag);
		return buildMutationFailure("NO_OP", "Tag payload is already valid JSON.");
	} catch {}
	return executeSdtMutation(editor, target, options, () => {
		const currentTag = resolveSdtByTarget(editor.state.doc, input.target).node.attrs.tag ?? "";
		return applyAttrsUpdate(editor, input.target.nodeId, { tag: JSON.stringify({ value: currentTag }) });
	});
}
function textSetMultilineWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, "text", "text.setMultiline");
	assertNotSdtLocked(sdt, "text.setMultiline");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		return updateSdtPrChild(editor, input.target, "w:text", (existing) => ({
			name: "w:text",
			type: "element",
			...existing,
			attributes: {
				...existing?.attributes ?? {},
				"w:multiLine": input.multiline ? "1" : "0"
			}
		}));
	});
}
function textSetValueWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, "text", "text.setValue");
	assertNotContentLocked(sdt, "text.setValue");
	if (alreadyMatchesPlainTextReplacement(sdt, input.value)) return buildMutationFailure("NO_OP", "Content control text already matches the requested value.");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		return replaceSdtTextContent(editor, input.target, input.value);
	});
}
function textClearValueWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, "text", "text.clearValue");
	assertNotContentLocked(sdt, "text.clearValue");
	if (alreadyMatchesPlainTextReplacement(sdt, "")) return buildMutationFailure("NO_OP", "Content control text is already empty.");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		return replaceSdtTextContent(editor, input.target, "");
	});
}
function updateDateSubElement(editor, target, subName, value, operation, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, target);
	assertControlType(sdt, "date", operation);
	assertNotSdtLocked(sdt, operation);
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		return updateSdtPrSubElementAttr(editor, target, "w:date", subName, "w:val", value);
	});
}
function dateSetValueWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, "date", "date.setValue");
	assertNotSdtLocked(sdt, "date.setValue");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		return updateSdtPrChild(editor, input.target, "w:date", (existing) => ({
			name: "w:date",
			type: "element",
			...existing,
			attributes: {
				...existing?.attributes ?? {},
				"w:fullDate": input.value
			}
		}));
	});
}
function dateClearValueWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, "date", "date.clearValue");
	assertNotSdtLocked(sdt, "date.clearValue");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		return updateSdtPrChild(editor, input.target, "w:date", (existing) => {
			if (!existing) return null;
			const attrs = { ...existing.attributes ?? {} };
			delete attrs["w:fullDate"];
			return {
				...existing,
				attributes: attrs
			};
		});
	});
}
function dateSetDisplayFormatWrapper(editor, input, options) {
	return updateDateSubElement(editor, input.target, "w:dateFormat", input.format, "date.setDisplayFormat", options);
}
function dateSetDisplayLocaleWrapper(editor, input, options) {
	return updateDateSubElement(editor, input.target, "w:lid", input.locale, "date.setDisplayLocale", options);
}
function dateSetStorageFormatWrapper(editor, input, options) {
	return updateDateSubElement(editor, input.target, "w:storeMappedDataAs", input.format, "date.setStorageFormat", options);
}
function dateSetCalendarWrapper(editor, input, options) {
	return updateDateSubElement(editor, input.target, "w:calendar", input.calendar, "date.setCalendar", options);
}
function checkboxGetStateWrapper(editor, input) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, "checkbox", "checkbox.getState");
	const sdtPr = sdt.node.attrs.sdtPr;
	return { checked: readCheckboxChecked(sdtPr) };
}
function checkboxSetStateWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, "checkbox", "checkbox.setState");
	assertNotSdtLocked(sdt, "checkbox.setState");
	const target = buildTarget(sdt);
	const symbol = resolveCheckboxVisualSymbol(sdt.node.attrs.sdtPr, input.checked);
	return executeSdtMutation(editor, target, options, () => {
		const checkboxUpdated = updateSdtPrSubElementAttr(editor, input.target, "w14:checkbox", "w14:checked", "w14:val", input.checked ? "1" : "0");
		if (!checkboxUpdated) return false;
		if (sdt.kind === "inline") {
			const updateCmd = editor.commands?.updateStructuredContentById;
			if (typeof updateCmd === "function") return Boolean(updateCmd(input.target.nodeId, { json: buildCheckboxTextJson(symbol) })) || Boolean(updateCmd(input.target.nodeId, {
				text: symbol.char,
				keepTextNodeStyles: true
			})) || checkboxUpdated;
		}
		return checkboxUpdated;
	});
}
function checkboxToggleWrapper(editor, input, options) {
	const currentState = checkboxGetStateWrapper(editor, input);
	return checkboxSetStateWrapper(editor, {
		target: input.target,
		checked: !currentState.checked
	}, options);
}
function checkboxSetSymbolPairWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, "checkbox", "checkbox.setSymbolPair");
	assertNotSdtLocked(sdt, "checkbox.setSymbolPair");
	const target = buildTarget(sdt);
	const checked = readCheckboxChecked(sdt.node.attrs.sdtPr);
	const symbolFromInput = checked ? input.checkedSymbol : input.uncheckedSymbol;
	const symbol = {
		char: String.fromCodePoint(parseCheckboxSymbolCodePoint(symbolFromInput.char, checked ? DEFAULT_CHECKBOX_CHECKED_HEX : DEFAULT_CHECKBOX_UNCHECKED_HEX)),
		font: symbolFromInput.font || DEFAULT_CHECKBOX_SYMBOL_FONT
	};
	return executeSdtMutation(editor, target, options, () => {
		const pairUpdated = updateSdtPrChild(editor, input.target, "w14:checkbox", (existing) => {
			const el = existing ?? {
				name: "w14:checkbox",
				type: "element",
				elements: []
			};
			const elements = (el.elements ?? []).filter((e) => e.name !== "w14:checkedState" && e.name !== "w14:uncheckedState");
			elements.push({
				name: "w14:checkedState",
				type: "element",
				attributes: {
					"w14:font": input.checkedSymbol.font,
					"w14:val": input.checkedSymbol.char
				}
			});
			elements.push({
				name: "w14:uncheckedState",
				type: "element",
				attributes: {
					"w14:font": input.uncheckedSymbol.font,
					"w14:val": input.uncheckedSymbol.char
				}
			});
			return {
				...el,
				elements
			};
		});
		if (!pairUpdated) return false;
		if (sdt.kind === "inline") {
			const updateCmd = editor.commands?.updateStructuredContentById;
			if (typeof updateCmd === "function") return Boolean(updateCmd(input.target.nodeId, { json: buildCheckboxTextJson(symbol) })) || Boolean(updateCmd(input.target.nodeId, {
				text: symbol.char,
				keepTextNodeStyles: true
			})) || pairUpdated;
		}
		return pairUpdated;
	});
}
function choiceListGetItemsWrapper(editor, input) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, ["comboBox", "dropDownList"], "choiceList.getItems");
	const sdtPr = sdt.node.attrs.sdtPr;
	return readChoiceListData(sdtPr, resolveControlType(sdt.node.attrs));
}
function choiceListSetItemsWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, ["comboBox", "dropDownList"], "choiceList.setItems");
	assertNotSdtLocked(sdt, "choiceList.setItems");
	const target = buildTarget(sdt);
	const ct = resolveControlType(sdt.node.attrs);
	return executeSdtMutation(editor, target, options, () => {
		const childName = `w:${ct}`;
		const itemElements = input.items.map((item) => ({
			name: "w:listItem",
			type: "element",
			attributes: {
				"w:displayText": item.displayText,
				"w:value": item.value
			}
		}));
		return replaceSdtPrSubElements(editor, input.target, childName, itemElements);
	});
}
function choiceListSetSelectedWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, ["comboBox", "dropDownList"], "choiceList.setSelected");
	assertNotSdtLocked(sdt, "choiceList.setSelected");
	const target = buildTarget(sdt);
	const ct = resolveControlType(sdt.node.attrs);
	const currentSdtPr = sdt.node.attrs.sdtPr;
	const { items } = readChoiceListData(currentSdtPr, ct);
	const selectedDisplayText = items.find((item) => item.value === input.value)?.displayText ?? input.value;
	return executeSdtMutation(editor, target, options, () => {
		const selectedUpdated = updateSdtPrChild(editor, input.target, `w:${ct}`, (existing) => ({
			name: `w:${ct}`,
			type: "element",
			...existing,
			attributes: {
				...existing?.attributes ?? {},
				"w:lastValue": input.value
			}
		}));
		if (!selectedUpdated) return false;
		const updateCmd = editor.commands?.updateStructuredContentById;
		if (typeof updateCmd === "function") return Boolean(updateCmd(input.target.nodeId, {
			text: selectedDisplayText,
			keepTextNodeStyles: true
		})) || selectedUpdated;
		return selectedUpdated;
	});
}
function getRepeatingSectionItems(sdt) {
	const items = [];
	sdt.node.forEach((child, offset$1) => {
		if (isSdtNode(child)) {
			if (resolveControlType(child.attrs) === "repeatingSectionItem") items.push({
				node: child,
				pos: sdt.pos + 1 + offset$1,
				kind: child.type.name === "structuredContentBlock" ? "block" : "inline"
			});
		}
	});
	return items;
}
function repeatingSectionListItemsWrapper(editor, input) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, "repeatingSection", "repeatingSection.listItems");
	const infos = getRepeatingSectionItems(sdt).map(buildContentControlInfoFromNode);
	return {
		items: infos,
		total: infos.length
	};
}
function repeatingSectionInsertItemBeforeWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, "repeatingSection", "repeatingSection.insertItemBefore");
	assertNotContentLocked(sdt, "repeatingSection.insertItemBefore");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		const resolved = resolveSdtByTarget(editor.state.doc, input.target);
		const items = getRepeatingSectionItems(resolved);
		if (input.index < 0 || input.index > items.length) throw new DocumentApiAdapterError("INVALID_INPUT", `Index ${input.index} out of range [0, ${items.length}].`);
		const insertPos = input.index < items.length ? items[input.index].pos : resolved.pos + resolved.node.nodeSize - 1;
		const nodeType = editor.schema.nodes[SDT_BLOCK_NAME];
		const paragraph = editor.schema.nodes.paragraph.create();
		const newItem = nodeType.create({
			id: generateSdtId(),
			controlType: "repeatingSectionItem",
			type: "repeatingSectionItem"
		}, paragraph);
		const { tr } = editor.state;
		tr.insert(insertPos, newItem);
		dispatchTransaction$1(editor, tr);
		return true;
	});
}
function repeatingSectionInsertItemAfterWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, "repeatingSection", "repeatingSection.insertItemAfter");
	assertNotContentLocked(sdt, "repeatingSection.insertItemAfter");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		const items = getRepeatingSectionItems(resolveSdtByTarget(editor.state.doc, input.target));
		if (input.index < 0 || input.index >= items.length) throw new DocumentApiAdapterError("INVALID_INPUT", `Index ${input.index} out of range [0, ${items.length - 1}].`);
		const afterItem = items[input.index];
		const insertPos = afterItem.pos + afterItem.node.nodeSize;
		const nodeType = editor.schema.nodes[SDT_BLOCK_NAME];
		const paragraph = editor.schema.nodes.paragraph.create();
		const newItem = nodeType.create({
			id: generateSdtId(),
			controlType: "repeatingSectionItem",
			type: "repeatingSectionItem"
		}, paragraph);
		const { tr } = editor.state;
		tr.insert(insertPos, newItem);
		dispatchTransaction$1(editor, tr);
		return true;
	});
}
function repeatingSectionCloneItemWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, "repeatingSection", "repeatingSection.cloneItem");
	assertNotContentLocked(sdt, "repeatingSection.cloneItem");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		const items = getRepeatingSectionItems(resolveSdtByTarget(editor.state.doc, input.target));
		if (input.index < 0 || input.index >= items.length) throw new DocumentApiAdapterError("INVALID_INPUT", `Index ${input.index} out of range [0, ${items.length - 1}].`);
		const sourceItem = items[input.index];
		const cloned = reIdDescendantSdts(sourceItem.node.type.create({
			...sourceItem.node.attrs,
			id: generateSdtId()
		}, sourceItem.node.content, sourceItem.node.marks), editor.schema);
		const insertPos = sourceItem.pos + sourceItem.node.nodeSize;
		const { tr } = editor.state;
		tr.insert(insertPos, cloned);
		dispatchTransaction$1(editor, tr);
		return true;
	});
}
function repeatingSectionDeleteItemWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, "repeatingSection", "repeatingSection.deleteItem");
	assertNotContentLocked(sdt, "repeatingSection.deleteItem");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		const items = getRepeatingSectionItems(resolveSdtByTarget(editor.state.doc, input.target));
		if (input.index < 0 || input.index >= items.length) throw new DocumentApiAdapterError("INVALID_INPUT", `Index ${input.index} out of range [0, ${items.length - 1}].`);
		const item = items[input.index];
		const { tr } = editor.state;
		tr.delete(item.pos, item.pos + item.node.nodeSize);
		dispatchTransaction$1(editor, tr);
		return true;
	});
}
function repeatingSectionSetAllowInsertDeleteWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, "repeatingSection", "repeatingSection.setAllowInsertDelete");
	assertNotSdtLocked(sdt, "repeatingSection.setAllowInsertDelete");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		return updateSdtPrSubElementAttr(editor, input.target, "w15:repeatingSection", "w15:allowInsertDeleteSection", "w15:val", input.allow ? "1" : "0");
	});
}
function groupWrapWrapper(editor, input, options) {
	resolveSdtByTarget(editor.state.doc, input.target);
	const target = input.target;
	return executeSdtMutation(editor, target, options, () => {
		const resolved = resolveSdtByTarget(editor.state.doc, input.target);
		const groupNodeType = editor.schema.nodes[SDT_BLOCK_NAME];
		if (!groupNodeType) return false;
		const groupId = generateSdtId();
		const groupNode = groupNodeType.create({
			id: groupId,
			controlType: "group",
			type: "group"
		}, resolved.node);
		const { tr } = editor.state;
		tr.replaceWith(resolved.pos, resolved.pos + resolved.node.nodeSize, groupNode);
		dispatchTransaction$1(editor, tr);
		return {
			kind: "block",
			nodeType: "sdt",
			nodeId: groupId
		};
	});
}
function groupUngroupWrapper(editor, input, options) {
	const sdt = resolveSdtByTarget(editor.state.doc, input.target);
	assertControlType(sdt, "group", "group.ungroup");
	assertNotSdtLocked(sdt, "group.ungroup");
	return executeSdtMutation(editor, buildTarget(sdt), options, () => {
		const resolved = resolveSdtByTarget(editor.state.doc, input.target);
		const { tr } = editor.state;
		tr.replaceWith(resolved.pos, resolved.pos + resolved.node.nodeSize, resolved.node.content);
		dispatchTransaction$1(editor, tr);
		return true;
	});
}
function createWrapper(editor, input, options) {
	const commandName = input.kind === "block" ? "insertStructuredContentBlock" : "insertStructuredContentInline";
	if (typeof editor.commands?.[commandName] !== "function") throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", `${commandName} command not available.`);
	const id = generateSdtId();
	const target = {
		kind: input.kind,
		nodeType: "sdt",
		nodeId: id
	};
	if (input.target) resolveSdtByTarget(editor.state.doc, input.target);
	return executeSdtMutation(editor, target, options, () => {
		const controlType = input.controlType ?? "richText";
		const attrs = {
			id,
			tag: input.tag,
			alias: input.alias,
			lockMode: input.lockMode ?? "unlocked",
			controlType,
			type: controlType
		};
		const defaultSdtPr = buildDefaultSdtPr(controlType);
		const isDateCreate = input.controlType === "date" && input.content == null;
		const dateDefaults = isDateCreate ? buildDateControlDefaults() : null;
		const sdtPrWithDateDefaults = dateDefaults ? applyDateDefaultsToSdtPr(defaultSdtPr, dateDefaults) : defaultSdtPr;
		if (sdtPrWithDateDefaults) attrs.sdtPr = sdtPrWithDateDefaults;
		const isCheckboxCreate = input.controlType === "checkbox" && input.content == null;
		const checkboxSymbol = isCheckboxCreate ? resolveCheckboxVisualSymbol(defaultSdtPr, false) : {
			char: "",
			font: DEFAULT_CHECKBOX_SYMBOL_FONT
		};
		const contentText = input.content ?? (isCheckboxCreate ? checkboxSymbol.char : isDateCreate ? dateDefaults?.displayText : void 0);
		if (input.target) {
			const ref$1 = resolveSdtByTarget(editor.state.doc, input.target);
			const nodeTypeName = input.kind === "block" ? SDT_BLOCK_NAME : "structuredContent";
			const nodeType = editor.schema.nodes[nodeTypeName];
			if (!nodeType) return false;
			let content;
			if (contentText !== void 0) {
				const textNode = createTextWithOptionalFont(editor, contentText, isCheckboxCreate ? checkboxSymbol.font : void 0);
				if (input.kind === "block") content = editor.schema.nodes.paragraph.create(null, textNode);
				else content = textNode;
			} else if (input.kind === "block") content = editor.schema.nodes.paragraph.create();
			const newNode = content ? nodeType.create(attrs, content) : nodeType.create(attrs);
			const insertPos = ref$1.pos + ref$1.node.nodeSize;
			const { tr } = editor.state;
			tr.insert(insertPos, newNode);
			dispatchTransaction$1(editor, tr);
			return true;
		}
		if (input.at) {
			const { absFrom, absTo } = resolveSelectionTarget(editor, input.at);
			const { tr } = editor.state;
			tr.setSelection(TextSelection.create(tr.doc, absFrom, absTo));
			dispatchTransaction$1(editor, tr);
		}
		const cmd = editor.commands?.[commandName];
		if (typeof cmd !== "function") return false;
		if (contentText !== void 0) {
			if (input.kind === "block") {
				if (isCheckboxCreate) return Boolean(cmd({
					attrs,
					json: {
						type: "paragraph",
						content: [buildCheckboxTextJson(checkboxSymbol)]
					}
				}));
				return Boolean(cmd({
					attrs,
					json: {
						type: "paragraph",
						content: [{
							type: "text",
							text: contentText
						}]
					}
				}));
			}
			if (isCheckboxCreate) return Boolean(cmd({
				attrs,
				json: buildCheckboxTextJson(checkboxSymbol)
			}));
			return Boolean(cmd({
				attrs,
				text: contentText
			}));
		}
		return Boolean(cmd({ attrs }));
	});
}
function createContentControlsAdapter(editor) {
	return {
		list: (query) => listWrapper(editor, query),
		get: (input) => getWrapper(editor, input),
		listInRange: (input) => listInRangeWrapper(editor, input),
		selectByTag: (input) => selectByTagWrapper(editor, input),
		selectByTitle: (input) => selectByTitleWrapper(editor, input),
		listChildren: (input) => listChildrenWrapper(editor, input),
		getParent: (input) => getParentWrapper(editor, input),
		wrap: (input, options) => wrapWrapper(editor, input, options),
		unwrap: (input, options) => unwrapWrapper(editor, input, options),
		delete: (input, options) => deleteWrapper(editor, input, options),
		copy: (input, options) => copyWrapper(editor, input, options),
		move: (input, options) => moveWrapper(editor, input, options),
		patch: (input, options) => patchWrapper(editor, input, options),
		setLockMode: (input, options) => setLockModeWrapper(editor, input, options),
		setType: (input, options) => setTypeWrapper(editor, input, options),
		getContent: (input) => getContentWrapper(editor, input),
		replaceContent: (input, options) => replaceContentWrapper(editor, input, options),
		clearContent: (input, options) => clearContentWrapper$1(editor, input, options),
		appendContent: (input, options) => appendContentWrapper(editor, input, options),
		prependContent: (input, options) => prependContentWrapper(editor, input, options),
		insertBefore: (input, options) => insertBeforeWrapper(editor, input, options),
		insertAfter: (input, options) => insertAfterWrapper(editor, input, options),
		getBinding: (input) => getBindingWrapper(editor, input),
		setBinding: (input, options) => setBindingWrapper(editor, input, options),
		clearBinding: (input, options) => clearBindingWrapper(editor, input, options),
		getRawProperties: (input) => getRawPropertiesWrapper(editor, input),
		patchRawProperties: (input, options) => patchRawPropertiesWrapper(editor, input, options),
		validateWordCompatibility: (input) => validateWordCompatibilityWrapper(editor, input),
		normalizeWordCompatibility: (input, options) => normalizeWordCompatibilityWrapper(editor, input, options),
		normalizeTagPayload: (input, options) => normalizeTagPayloadWrapper(editor, input, options),
		text: {
			setMultiline: (input, options) => textSetMultilineWrapper(editor, input, options),
			setValue: (input, options) => textSetValueWrapper(editor, input, options),
			clearValue: (input, options) => textClearValueWrapper(editor, input, options)
		},
		date: {
			setValue: (input, options) => dateSetValueWrapper(editor, input, options),
			clearValue: (input, options) => dateClearValueWrapper(editor, input, options),
			setDisplayFormat: (input, options) => dateSetDisplayFormatWrapper(editor, input, options),
			setDisplayLocale: (input, options) => dateSetDisplayLocaleWrapper(editor, input, options),
			setStorageFormat: (input, options) => dateSetStorageFormatWrapper(editor, input, options),
			setCalendar: (input, options) => dateSetCalendarWrapper(editor, input, options)
		},
		checkbox: {
			getState: (input) => checkboxGetStateWrapper(editor, input),
			setState: (input, options) => checkboxSetStateWrapper(editor, input, options),
			toggle: (input, options) => checkboxToggleWrapper(editor, input, options),
			setSymbolPair: (input, options) => checkboxSetSymbolPairWrapper(editor, input, options)
		},
		choiceList: {
			getItems: (input) => choiceListGetItemsWrapper(editor, input),
			setItems: (input, options) => choiceListSetItemsWrapper(editor, input, options),
			setSelected: (input, options) => choiceListSetSelectedWrapper(editor, input, options)
		},
		repeatingSection: {
			listItems: (input) => repeatingSectionListItemsWrapper(editor, input),
			insertItemBefore: (input, options) => repeatingSectionInsertItemBeforeWrapper(editor, input, options),
			insertItemAfter: (input, options) => repeatingSectionInsertItemAfterWrapper(editor, input, options),
			cloneItem: (input, options) => repeatingSectionCloneItemWrapper(editor, input, options),
			deleteItem: (input, options) => repeatingSectionDeleteItemWrapper(editor, input, options),
			setAllowInsertDelete: (input, options) => repeatingSectionSetAllowInsertDeleteWrapper(editor, input, options)
		},
		group: {
			wrap: (input, options) => groupWrapWrapper(editor, input, options),
			ungroup: (input, options) => groupUngroupWrapper(editor, input, options)
		},
		create: (input, options) => createWrapper(editor, input, options)
	};
}
var VARIANT_ORDER = [
	"default",
	"first",
	"even"
];
var KIND_ORDER = ["header", "footer"];
function getConverter$4(editor) {
	return editor.converter;
}
function requireConverter$1(editor, operationName) {
	const converter = getConverter$4(editor);
	if (!converter) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", `${operationName} requires an active document converter.`);
	return converter;
}
function invalidateSlotRuntimesAfterRefChange(editor, result, options) {
	if (!result.success || options?.dryRun) return;
	const cache$2 = getStoryRuntimeCache(editor);
	if (cache$2) cache$2.invalidateByPrefix("hf:slot:");
}
function effectiveLimitOf(limit, total) {
	return limit ?? total;
}
function buildSlotEntries(editor, sections, kindFilter, sectionFilter) {
	const entries = [];
	for (const projection of sections) {
		if (sectionFilter && projection.sectionId !== sectionFilter.sectionId) continue;
		const sectPr = readTargetSectPr(editor, projection);
		const kinds = kindFilter ? [kindFilter] : KIND_ORDER;
		for (const kind of kinds) {
			const refs = sectPr ? readSectPrHeaderFooterRefs(sectPr, kind) : void 0;
			for (const variant of VARIANT_ORDER) {
				const refId = refs?.[variant] ?? null;
				entries.push({
					section: projection.address,
					sectionIndex: projection.range.sectionIndex,
					kind,
					variant,
					refId,
					isExplicit: refId !== null
				});
			}
		}
	}
	return entries;
}
function headerFootersListAdapter(editor, query) {
	validatePaginationInput(query?.offset, query?.limit);
	const allEntries = buildSlotEntries(editor, resolveSectionProjections(editor), query?.kind, query?.section);
	const offset$1 = query?.offset ?? 0;
	const effectiveLimit = effectiveLimitOf(query?.limit, allEntries.length);
	const { total, items: paged } = paginate(allEntries, offset$1, effectiveLimit);
	const evaluatedRevision = getRevision(editor);
	const items = paged.map((entry) => {
		const id = `slot:${entry.section.sectionId}:${entry.kind}:${entry.variant}`;
		return buildDiscoveryItem(id, buildResolvedHandle(id, "ephemeral", "ext:headerFooterSlot"), entry);
	});
	return buildDiscoveryResult({
		evaluatedRevision,
		total,
		items,
		page: {
			limit: effectiveLimit,
			offset: offset$1,
			returned: items.length
		}
	});
}
function headerFootersGetAdapter(editor, input) {
	const { section, headerFooterKind, variant } = input.target;
	const projection = resolveSectionProjections(editor).find((s) => s.sectionId === section.sectionId);
	if (!projection) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Section target was not found.", { target: section });
	const sectPr = readTargetSectPr(editor, projection);
	const refId = (sectPr ? readSectPrHeaderFooterRefs(sectPr, headerFooterKind) : void 0)?.[variant] ?? null;
	return {
		section: projection.address,
		sectionIndex: projection.range.sectionIndex,
		kind: headerFooterKind,
		variant,
		refId,
		isExplicit: refId !== null
	};
}
function headerFootersResolveAdapter(editor, input) {
	const { section, headerFooterKind, variant } = input.target;
	const sections = resolveSectionProjections(editor);
	const projection = sections.find((s) => s.sectionId === section.sectionId);
	if (!projection) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Section target was not found.", { target: section });
	const sectPr = readTargetSectPr(editor, projection);
	if (sectPr) {
		const refs = readSectPrHeaderFooterRefs(sectPr, headerFooterKind);
		if (refs?.[variant]) return {
			status: "explicit",
			refId: refs[variant],
			section: projection.address
		};
	}
	const resolved = resolveEffectiveRef(sections, projection.range.sectionIndex, headerFooterKind, variant);
	if (resolved) return {
		status: "inherited",
		refId: resolved.refId,
		resolvedFromSection: resolved.resolvedFromSection,
		resolvedVariant: resolved.resolvedVariant
	};
	return { status: "none" };
}
function headerFootersRefsSetAdapter(editor, input, options) {
	const { section, headerFooterKind, variant } = input.target;
	const result = sectionMutationBySectPr(editor, { target: section }, options, "headerFooters.refs.set", (sectPr, _projection, _sections, dryRun) => {
		const converter = getConverter$4(editor) ?? null;
		return setHeaderFooterRefMutation(sectPr, headerFooterKind, variant, input.refId, converter, "headerFooters.refs.set", dryRun);
	});
	invalidateSlotRuntimesAfterRefChange(editor, result, options);
	return result;
}
function headerFootersRefsClearAdapter(editor, input, options) {
	const { section, headerFooterKind, variant } = input.target;
	const result = sectionMutationBySectPr(editor, { target: section }, options, "headerFooters.refs.clear", (sectPr, _projection, _sections, dryRun) => {
		clearHeaderFooterRefMutation(sectPr, headerFooterKind, variant, getConverter$4(editor) ?? null, dryRun);
	});
	invalidateSlotRuntimesAfterRefChange(editor, result, options);
	return result;
}
function headerFootersRefsSetLinkedToPreviousAdapter(editor, input, options) {
	const { section, headerFooterKind, variant } = input.target;
	const result = sectionMutationBySectPr(editor, { target: section }, options, "headerFooters.refs.setLinkedToPrevious", (sectPr, projection, sections, dryRun) => {
		return setLinkedToPreviousMutation(sectPr, projection, sections, headerFooterKind, variant, input.linked, editor, dryRun, "headerFooters.refs.setLinkedToPrevious");
	});
	invalidateSlotRuntimesAfterRefChange(editor, result, options);
	return result;
}
var HEADER_RELATIONSHIP_TYPE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header";
var FOOTER_RELATIONSHIP_TYPE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer";
var DOCUMENT_RELS_PATH = "word/_rels/document.xml.rels";
var HEADER_FILE_PATTERN = /header(\d+)\.xml$/;
var FOOTER_FILE_PATTERN = /footer(\d+)\.xml$/;
function kindFromRelationshipType(type) {
	if (type === HEADER_RELATIONSHIP_TYPE) return "header";
	if (type === FOOTER_RELATIONSHIP_TYPE) return "footer";
	return null;
}
function normalizeTarget(target) {
	let normalized = target.replace(/^\.\//, "");
	if (normalized.startsWith("../")) normalized = normalized.slice(3);
	if (normalized.startsWith("/")) normalized = normalized.slice(1);
	if (!normalized.startsWith("word/")) normalized = `word/${normalized}`;
	return normalized;
}
function readRelationshipElements(converter) {
	const relsPart = converter.convertedXml?.[DOCUMENT_RELS_PATH];
	if (!relsPart?.elements) return [];
	const root = relsPart.elements.find((e) => e.name === "Relationships");
	if (!root?.elements) return [];
	return root.elements.filter((e) => e.name === "Relationship");
}
function extractPartIndex(kind, partPath) {
	const pattern = kind === "header" ? HEADER_FILE_PATTERN : FOOTER_FILE_PATTERN;
	const match$1 = partPath.match(pattern);
	if (!match$1) return null;
	const num = Number(match$1[1]);
	return Number.isFinite(num) ? num : null;
}
function headerFootersPartsListAdapter(editor, query) {
	const converter = requireConverter$1(editor, "headerFooters.parts.list");
	validatePaginationInput(query?.offset, query?.limit);
	const relationships = readRelationshipElements(converter);
	const sections = resolveSectionProjections(editor);
	const refToSections = /* @__PURE__ */ new Map();
	for (const projection of sections) {
		const sectPr = readTargetSectPr(editor, projection);
		if (!sectPr) continue;
		for (const kind of KIND_ORDER) {
			const refs = readSectPrHeaderFooterRefs(sectPr, kind);
			if (!refs) continue;
			for (const variant of VARIANT_ORDER) {
				const refId = refs[variant];
				if (!refId) continue;
				if (!refToSections.has(refId)) refToSections.set(refId, []);
				if (!refToSections.get(refId).some((a) => a.sectionId === projection.sectionId)) refToSections.get(refId).push(projection.address);
			}
		}
	}
	const allEntries = [];
	for (const rel of relationships) {
		const kind = kindFromRelationshipType(String(rel.attributes?.Type ?? ""));
		if (!kind) continue;
		if (query?.kind && kind !== query.kind) continue;
		const refId = String(rel.attributes?.Id ?? "");
		const partPath = normalizeTarget(String(rel.attributes?.Target ?? ""));
		allEntries.push({
			refId,
			kind,
			partPath,
			referencedBySections: refToSections.get(refId) ?? []
		});
	}
	allEntries.sort((a, b$1) => {
		const kindDiff = KIND_ORDER.indexOf(a.kind) - KIND_ORDER.indexOf(b$1.kind);
		if (kindDiff !== 0) return kindDiff;
		const indexA = extractPartIndex(a.kind, a.partPath);
		const indexB = extractPartIndex(b$1.kind, b$1.partPath);
		if (indexA !== null && indexB !== null) return indexA - indexB;
		if (indexA !== null) return -1;
		if (indexB !== null) return 1;
		const pathCmp = a.partPath.localeCompare(b$1.partPath);
		if (pathCmp !== 0) return pathCmp;
		return a.refId.localeCompare(b$1.refId);
	});
	const offset$1 = query?.offset ?? 0;
	const effectiveLimit = effectiveLimitOf(query?.limit, allEntries.length);
	const { total, items: paged } = paginate(allEntries, offset$1, effectiveLimit);
	const evaluatedRevision = getRevision(editor);
	const items = paged.map((entry) => {
		const id = `part:${entry.refId}`;
		return buildDiscoveryItem(id, buildResolvedHandle(id, "stable", "ext:headerFooterPart"), entry);
	});
	return buildDiscoveryResult({
		evaluatedRevision,
		total,
		items,
		page: {
			limit: effectiveLimit,
			offset: offset$1,
			returned: items.length
		}
	});
}
function toPartsMutationFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function headerFootersPartsCreateAdapter(editor, input, options) {
	rejectTrackedMode("headerFooters.parts.create", options);
	checkRevision(editor, options?.expectedRevision);
	const converter = requireConverter$1(editor, "headerFooters.parts.create");
	if (input.sourceRefId) {
		const sourceRel = readRelationshipElements(converter).find((rel) => String(rel.attributes?.Id ?? "") === input.sourceRefId);
		if (!sourceRel) return toPartsMutationFailure("INVALID_TARGET", `sourceRefId '${input.sourceRefId}' does not reference an existing header/footer relationship`);
		const sourceKind = kindFromRelationshipType(String(sourceRel.attributes?.Type ?? ""));
		if (sourceKind !== input.kind) return toPartsMutationFailure("INVALID_TARGET", `sourceRefId '${input.sourceRefId}' is a ${sourceKind ?? "unknown"}, not a ${input.kind}`);
	}
	if (options?.dryRun) return {
		success: true,
		refId: "(dry-run)",
		partPath: `word/${input.kind}(dry-run).xml`
	};
	try {
		const result = createHeaderFooterPart(editor, {
			kind: input.kind,
			variant: "default",
			sourceRefId: input.sourceRefId
		});
		return {
			success: true,
			refId: result.refId,
			partPath: result.relationshipTarget
		};
	} catch (err) {
		throw new DocumentApiAdapterError("INTERNAL_ERROR", `headerFooters.parts.create failed: ${err instanceof Error ? err.message : String(err)}`);
	}
}
function headerFootersPartsDeleteAdapter(editor, input, options) {
	rejectTrackedMode("headerFooters.parts.delete", options);
	checkRevision(editor, options?.expectedRevision);
	const converter = requireConverter$1(editor, "headerFooters.parts.delete");
	const refId = input.target.refId;
	const targetRel = readRelationshipElements(converter).find((rel) => String(rel.attributes?.Id ?? "") === refId);
	if (!targetRel) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `refId '${refId}' not found in document relationships.`);
	const kind = kindFromRelationshipType(String(targetRel.attributes?.Type ?? ""));
	if (!kind) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `refId '${refId}' is not a header/footer relationship.`);
	const sections = resolveSectionProjections(editor);
	const referencingSections = [];
	for (const projection of sections) {
		const sectPr = readTargetSectPr(editor, projection);
		if (!sectPr) continue;
		const refs = readSectPrHeaderFooterRefs(sectPr, kind);
		if (!refs) continue;
		for (const variant of VARIANT_ORDER) if (refs[variant] === refId) {
			referencingSections.push(projection.address);
			break;
		}
	}
	if (referencingSections.length > 0) return toPartsMutationFailure("INVALID_TARGET", `Cannot delete part '${refId}': still referenced by sections [${referencingSections.map((s) => s.sectionId).join(", ")}].`);
	const partPath = normalizeTarget(String(targetRel.attributes?.Target ?? ""));
	if (options?.dryRun) return {
		success: true,
		refId,
		partPath
	};
	const convertedXml = converter.convertedXml ?? {};
	const relsPart = convertedXml[DOCUMENT_RELS_PATH];
	if (relsPart?.elements) {
		const root = relsPart.elements.find((e) => e.name === "Relationships");
		if (root?.elements) root.elements = root.elements.filter((e) => !(e.name === "Relationship" && String(e.attributes?.Id ?? "") === refId));
	}
	delete convertedXml[partPath];
	delete convertedXml[getWordPartRelsPath(partPath)];
	const collection = kind === "header" ? converter.headers : converter.footers;
	if (collection && typeof collection === "object") delete collection[refId];
	const variantIds = kind === "header" ? converter.headerIds : converter.footerIds;
	if (variantIds && Array.isArray(variantIds.ids)) {
		const idx = variantIds.ids.indexOf(refId);
		if (idx !== -1) variantIds.ids.splice(idx, 1);
	}
	if (variantIds) {
		for (const key of [
			"default",
			"first",
			"even",
			"odd"
		]) if (variantIds[key] === refId) variantIds[key] = null;
	}
	converter.headerFooterModified = true;
	converter.documentModified = true;
	return {
		success: true,
		refId,
		partPath
	};
}
var SPECIAL_NOTE_TYPES = new Set(["separator", "continuationSeparator"]);
function isSpecialEntry(entry) {
	return SPECIAL_NOTE_TYPES.has(entry.type ?? "");
}
function normalizeNoteId(entry) {
	return String(entry.id ?? "");
}
function findNoteEntryById(entries, noteId) {
	if (!Array.isArray(entries)) return void 0;
	let fallback;
	for (const entry of entries) {
		if (String(entry.id ?? "") !== noteId) continue;
		if (!isSpecialEntry(entry)) return entry;
		fallback ??= entry;
	}
	return fallback;
}
function enumerateEffectiveNoteEntries(entries) {
	if (!Array.isArray(entries)) return [];
	const orderedIds = [];
	const effectiveById = /* @__PURE__ */ new Map();
	for (const entry of entries) {
		const noteId = normalizeNoteId(entry);
		if (!effectiveById.has(noteId)) {
			orderedIds.push(noteId);
			effectiveById.set(noteId, entry);
			continue;
		}
		if (isSpecialEntry(effectiveById.get(noteId)) && !isSpecialEntry(entry)) effectiveById.set(noteId, entry);
	}
	return orderedIds.map((noteId) => effectiveById.get(noteId));
}
function normalizeStory(locator) {
	if (!locator || locator.storyType === "body") return void 0;
	return locator;
}
function buildBookmarkAddress(name, story) {
	const normalizedStory = normalizeStory(story);
	return normalizedStory ? {
		kind: "entity",
		entityType: "bookmark",
		name,
		story: normalizedStory
	} : {
		kind: "entity",
		entityType: "bookmark",
		name
	};
}
function findAllBookmarksInDocument(editor) {
	return collectFromDocumentStories(editor, {
		collectFromDoc: collectBookmarksFromDoc,
		collectFromPmJson: collectBookmarksFromPmJson
	});
}
function findAllBookmarkMarkersInDocument(editor) {
	return collectFromDocumentStories(editor, {
		collectFromDoc: collectBookmarkMarkersFromDoc,
		collectFromPmJson: collectBookmarkMarkersFromPmJson
	});
}
function collectFromDocumentStories(editor, collector) {
	const results = [];
	const seenStoryKeys = /* @__PURE__ */ new Set();
	const converter = editor.converter;
	seenStoryKeys.add(BODY_STORY_KEY);
	collector.collectFromDoc(editor.state.doc, BODY_STORY_KEY, results);
	collectFromHeaderFooterEditors(editor, converter?.headerEditors, results, seenStoryKeys, collector);
	collectFromHeaderFooterEditors(editor, converter?.footerEditors, results, seenStoryKeys, collector);
	collectFromHeaderFooterCache(editor, converter?.headers, results, seenStoryKeys, collector);
	collectFromHeaderFooterCache(editor, converter?.footers, results, seenStoryKeys, collector);
	collectFromNotes(editor, converter?.footnotes, "footnote", results, seenStoryKeys, collector);
	collectFromNotes(editor, converter?.endnotes, "endnote", results, seenStoryKeys, collector);
	return results;
}
function findAllBookmarks(doc$1) {
	const results = [];
	const endPositions = collectBookmarkEndPositions(doc$1);
	doc$1.descendants((node, pos) => {
		if (node.type.name === "bookmarkStart") {
			const name = node.attrs?.name ?? "";
			const bookmarkId = node.attrs?.id ?? "";
			const endPos = endPositions.get(bookmarkId) ?? null;
			results.push({
				node,
				pos,
				name,
				bookmarkId,
				endPos
			});
		}
		return true;
	});
	return results;
}
function collectBookmarkEndPositions(doc$1) {
	const map$1 = /* @__PURE__ */ new Map();
	doc$1.descendants((node, pos) => {
		if (node.type.name === "bookmarkEnd") {
			const id = node.attrs?.id ?? "";
			if (id) map$1.set(id, pos);
		}
		return true;
	});
	return map$1;
}
function collectBookmarksFromDoc(doc$1, storyKey, results) {
	doc$1.descendants((node) => {
		if (node.type.name === "bookmarkStart") results.push({
			name: readBookmarkName(node.attrs),
			bookmarkId: readBookmarkId(node.attrs),
			storyKey
		});
		return true;
	});
}
function collectBookmarkMarkersFromDoc(doc$1, storyKey, results) {
	doc$1.descendants((node) => {
		if (!isBookmarkMarkerType(node.type.name)) return true;
		const bookmarkId = readBookmarkId(node.attrs);
		if (bookmarkId) results.push({
			bookmarkId,
			storyKey,
			markerType: node.type.name
		});
		return true;
	});
}
function collectFromHeaderFooterEditors(hostEditor, editors, results, seenStoryKeys, collector) {
	if (!Array.isArray(editors)) return;
	for (const entry of editors) {
		const refId = typeof entry?.id === "string" && entry.id.length > 0 ? entry.id : null;
		const storyEditor = entry?.editor;
		if (!refId || !storyEditor?.state?.doc) continue;
		const storyKey = buildStoryKey({
			kind: "story",
			storyType: "headerFooterPart",
			refId
		});
		if (seenStoryKeys.has(storyKey)) continue;
		seenStoryKeys.add(storyKey);
		collectFromLiveOrDoc(hostEditor, storyKey, storyEditor.state.doc, results, collector);
	}
}
function collectFromHeaderFooterCache(hostEditor, collection, results, seenStoryKeys, collector) {
	if (!collection || typeof collection !== "object") return;
	for (const [refId, pmJson] of Object.entries(collection)) {
		if (typeof refId !== "string" || refId.length === 0) continue;
		const storyKey = buildStoryKey({
			kind: "story",
			storyType: "headerFooterPart",
			refId
		});
		if (seenStoryKeys.has(storyKey)) continue;
		seenStoryKeys.add(storyKey);
		collectFromLiveOrPmJson(hostEditor, storyKey, pmJson, results, collector);
	}
}
function collectFromNotes(hostEditor, notes, storyType, results, seenStoryKeys, collector) {
	for (const note of enumerateEffectiveNoteEntries(notes)) {
		const noteId = note?.id != null ? String(note.id) : "";
		if (!noteId) continue;
		const pmJson = getNotePmJson(note);
		if (!pmJson) continue;
		const storyKey = buildStoryKey({
			kind: "story",
			storyType,
			noteId
		});
		if (seenStoryKeys.has(storyKey)) continue;
		seenStoryKeys.add(storyKey);
		collectFromLiveOrPmJson(hostEditor, storyKey, pmJson, results, collector);
	}
}
function collectFromLiveOrDoc(hostEditor, storyKey, fallbackDoc, results, collector) {
	const liveDoc = resolveLiveStorySessionRuntime(hostEditor, storyKey)?.editor?.state?.doc;
	collector.collectFromDoc(liveDoc ?? fallbackDoc, storyKey, results);
}
function collectFromLiveOrPmJson(hostEditor, storyKey, fallbackPmJson, results, collector) {
	const liveDoc = resolveLiveStorySessionRuntime(hostEditor, storyKey)?.editor?.state?.doc;
	if (liveDoc) {
		collector.collectFromDoc(liveDoc, storyKey, results);
		return;
	}
	collector.collectFromPmJson(fallbackPmJson, storyKey, results);
}
function getNotePmJson(note) {
	if (Array.isArray(note.content)) return {
		type: "doc",
		content: note.content.length > 0 ? note.content : [{ type: "paragraph" }]
	};
	if (note.doc && typeof note.doc === "object") return note.doc;
	return null;
}
function collectBookmarksFromPmJson(pmJson, storyKey, results) {
	if (!isObjectRecord(pmJson)) return;
	visitPmJson(pmJson, (node) => {
		if (node.type !== "bookmarkStart") return;
		const name = readBookmarkName(node.attrs);
		const bookmarkId = readBookmarkId(node.attrs);
		results.push({
			name,
			bookmarkId,
			storyKey
		});
	});
}
function collectBookmarkMarkersFromPmJson(pmJson, storyKey, results) {
	if (!isObjectRecord(pmJson)) return;
	visitPmJson(pmJson, (node) => {
		if (!isBookmarkMarkerType(node.type)) return;
		const bookmarkId = readBookmarkId(node.attrs);
		if (bookmarkId) results.push({
			bookmarkId,
			storyKey,
			markerType: node.type
		});
	});
}
function visitPmJson(node, visitor) {
	visitor(node);
	const content = node.content;
	if (!Array.isArray(content)) return;
	for (const child of content) if (isObjectRecord(child)) visitPmJson(child, visitor);
}
function isObjectRecord(value) {
	return typeof value === "object" && value !== null;
}
function isBookmarkMarkerType(type) {
	return type === "bookmarkStart" || type === "bookmarkEnd";
}
function readBookmarkId(attrs) {
	if (!isObjectRecord(attrs) || attrs.id == null) return "";
	return String(attrs.id);
}
function readBookmarkName(attrs) {
	if (!isObjectRecord(attrs) || typeof attrs.name !== "string") return "";
	return attrs.name;
}
function resolveBookmarkTarget(doc$1, target) {
	const found = findAllBookmarks(doc$1).find((b$1) => b$1.name === target.name);
	if (!found) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Bookmark with name "${target.name}" not found.`);
	return found;
}
function nodePositionToPosition(doc$1, pos) {
	const resolved = doc$1.resolve(pos);
	for (let depth = resolved.depth; depth >= 0; depth--) {
		const node = resolved.node(depth);
		const blockId = node.attrs?.sdBlockId;
		if (blockId) return {
			blockId,
			offset: pmPositionToTextOffset(node, resolved.start(depth) - 1, pos)
		};
	}
	return {
		blockId: "",
		offset: pos
	};
}
function extractBookmarkInfo(doc$1, resolved, story) {
	const from$1 = nodePositionToPosition(doc$1, resolved.pos);
	const to = resolved.endPos !== null ? nodePositionToPosition(doc$1, resolved.endPos) : from$1;
	const colFirst = resolved.node.attrs?.colFirst;
	const colLast = resolved.node.attrs?.colLast;
	const info = {
		address: buildBookmarkAddress(resolved.name, story),
		name: resolved.name,
		bookmarkId: resolved.bookmarkId,
		range: {
			from: from$1,
			to
		}
	};
	if (colFirst !== void 0 && colFirst !== null && colLast !== void 0 && colLast !== null) info.tableColumn = {
		colFirst,
		colLast
	};
	return info;
}
function buildBookmarkDiscoveryItem(doc$1, resolved, evaluatedRevision, story, idScope) {
	const from$1 = nodePositionToPosition(doc$1, resolved.pos);
	const to = resolved.endPos !== null ? nodePositionToPosition(doc$1, resolved.endPos) : from$1;
	const colFirst = resolved.node.attrs?.colFirst;
	const colLast = resolved.node.attrs?.colLast;
	const domain = {
		address: buildBookmarkAddress(resolved.name, story),
		name: resolved.name,
		bookmarkId: resolved.bookmarkId,
		range: {
			from: from$1,
			to
		}
	};
	if (colFirst !== void 0 && colFirst !== null && colLast !== void 0 && colLast !== null) domain.tableColumn = {
		colFirst,
		colLast
	};
	const handle = buildResolvedHandle(resolved.name, "stable", "node");
	return buildDiscoveryItem(`${idScope ? `bookmark:${encodeURIComponent(idScope)}:` : "bookmark:"}${encodeURIComponent(resolved.name)}:${encodeURIComponent(evaluatedRevision)}`, handle, domain);
}
const BOOKMARK_SCAN_REVISION_PREFIX = "bookmark-scan:";
function bookmarkSuccess(address) {
	return {
		success: true,
		bookmark: address
	};
}
function bookmarkFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function receiptApplied$6(receipt) {
	return receipt.steps[0]?.effect === "changed";
}
function parseBookmarkId(raw) {
	if (typeof raw === "number" && Number.isInteger(raw) && raw >= 0) return raw;
	if (typeof raw !== "string" || raw.trim().length === 0) return null;
	if (!/^\d+$/.test(raw)) return null;
	const parsed = Number.parseInt(raw, 10);
	return Number.isInteger(parsed) && parsed >= 0 ? parsed : null;
}
function allocateBookmarkId(editor) {
	const entries = findAllBookmarkMarkersInDocument(editor);
	let maxId = -1;
	for (const entry of entries) {
		const id = parseBookmarkId(entry.bookmarkId);
		if (id !== null && id > maxId) maxId = id;
	}
	return String(maxId + 1);
}
function bookmarkExistsAnywhere(editor, name, exclude, preCollected) {
	return (preCollected ?? findAllBookmarksInDocument(editor)).some((bookmark) => {
		if (bookmark.name !== name) return false;
		if (!exclude) return true;
		return !(bookmark.storyKey === exclude.storyKey && bookmark.bookmarkId === exclude.bookmarkId);
	});
}
function collectBookmarkStorySnapshots(editor, entries) {
	return [...new Set(entries.map((entry) => entry.storyKey))].flatMap((storyKey) => {
		const locator = storyKey === "body" ? void 0 : parseStoryKey(storyKey);
		try {
			const runtime = resolveStoryRuntime(editor, locator);
			return [{
				storyKey,
				runtime,
				revision: getRevision(runtime.editor)
			}];
		} catch (error) {
			if (error instanceof DocumentApiAdapterError && error.code === "STORY_NOT_FOUND") return [];
			throw error;
		}
	});
}
function buildDocumentBookmarkRevision(hostRevision, snapshots) {
	if (snapshots.length === 0) return hostRevision;
	if (snapshots.length === 1 && snapshots[0]?.storyKey === "body") return hostRevision;
	return `${BOOKMARK_SCAN_REVISION_PREFIX}${[...snapshots].sort((left$1, right$1) => left$1.storyKey.localeCompare(right$1.storyKey)).map((snapshot) => `${snapshot.storyKey}@${snapshot.revision}`).join("|")}`;
}
function getDocumentBookmarkRevision(editor, preCollected) {
	return buildDocumentBookmarkRevision(getRevision(editor), collectBookmarkStorySnapshots(editor, preCollected ?? findAllBookmarksInDocument(editor)));
}
function expectedRevisionMatchesStory(storyEditor, expectedRevision) {
	return expectedRevision === getRevision(storyEditor);
}
function expectedRevisionMatchesDocumentScan(hostEditor, expectedRevision) {
	return expectedRevision.startsWith("bookmark-scan:") && expectedRevision === getDocumentBookmarkRevision(hostEditor);
}
function checkBookmarkRevision(hostEditor, storyEditor, expectedRevision) {
	if (expectedRevision === void 0) return;
	if (expectedRevisionMatchesStory(storyEditor, expectedRevision)) return;
	if (expectedRevisionMatchesDocumentScan(hostEditor, expectedRevision)) return;
	checkRevision(storyEditor, expectedRevision);
}
function resolveBookmarkMutationStory(editor, target) {
	if (target.story) return target.story;
	const matches = findAllBookmarksInDocument(editor).filter((bookmark) => bookmark.name === target.name);
	if (matches.length > 1) throw new DocumentApiAdapterError("INVALID_INPUT", `Bookmark name "${target.name}" exists in multiple stories. Pass target.story to disambiguate the mutation.`);
	const entry = matches[0];
	if (!entry) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Bookmark with name "${target.name}" not found.`);
	return entry.storyKey === "body" ? void 0 : parseStoryKey(entry.storyKey);
}
function bookmarksListWrapper(editor, query) {
	if (query?.in) return listBookmarksFromStory(editor, query.in, query);
	const entries = findAllBookmarksInDocument(editor);
	const hostRevision = getRevision(editor);
	const snapshots = collectBookmarkStorySnapshots(editor, entries);
	const { total, items: paged } = paginate(snapshots.flatMap(({ storyKey, runtime, revision }) => {
		const doc$1 = runtime.editor.state.doc;
		return findAllBookmarks(doc$1).map((bookmark) => buildBookmarkDiscoveryItem(doc$1, bookmark, revision, runtime.locator, storyKey));
	}), query?.offset, query?.limit);
	const effectiveLimit = query?.limit ?? total;
	return buildDiscoveryResult({
		evaluatedRevision: buildDocumentBookmarkRevision(hostRevision, snapshots),
		total,
		items: paged,
		page: {
			limit: effectiveLimit,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function listBookmarksFromStory(editor, storyLocator, query) {
	const runtime = resolveStoryRuntime(editor, storyLocator);
	const storyEditor = runtime.editor;
	const doc$1 = storyEditor.state.doc;
	const revision = getRevision(storyEditor);
	const { total, items: paged } = paginate(findAllBookmarks(doc$1).map((bookmark) => buildBookmarkDiscoveryItem(doc$1, bookmark, revision, runtime.locator)), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function bookmarksGetWrapper(editor, input) {
	if (input.target.story) {
		const runtime$1 = resolveStoryRuntime(editor, input.target.story);
		const resolved$1 = resolveBookmarkTarget(runtime$1.editor.state.doc, input.target);
		return extractBookmarkInfo(runtime$1.editor.state.doc, resolved$1, runtime$1.locator);
	}
	const entry = findAllBookmarksInDocument(editor).find((bookmark) => bookmark.name === input.target.name);
	if (!entry) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Bookmark with name "${input.target.name}" not found.`);
	const runtime = resolveStoryRuntime(editor, entry.storyKey === "body" ? void 0 : parseStoryKey(entry.storyKey));
	const resolved = resolveBookmarkTarget(runtime.editor.state.doc, input.target);
	return extractBookmarkInfo(runtime.editor.state.doc, resolved, runtime.locator);
}
function bookmarksInsertWrapper(editor, input, options) {
	rejectTrackedMode("bookmarks.insert", options);
	const runtime = resolveWriteStoryRuntime(editor, input.at.story);
	const storyEditor = runtime.editor;
	const address = buildBookmarkAddress(input.name, runtime.locator);
	try {
		checkBookmarkRevision(editor, storyEditor, options?.expectedRevision);
		const allBookmarks = findAllBookmarksInDocument(editor);
		if (bookmarkExistsAnywhere(editor, input.name, void 0, allBookmarks)) return bookmarkFailure("NO_OP", `Bookmark with name "${input.name}" already exists.`);
		if (options?.dryRun) return bookmarkSuccess(address);
		const bookmarkStartType = storyEditor.schema.nodes.bookmarkStart;
		const bookmarkEndType = storyEditor.schema.nodes.bookmarkEnd;
		if (!bookmarkStartType || !bookmarkEndType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "bookmarks.insert requires bookmarkStart and bookmarkEnd node types in the schema.");
		const resolved = resolveInlineInsertPosition(storyEditor, input.at, "bookmarks.insert");
		if (!receiptApplied$6(executeDomainCommand(storyEditor, () => {
			const bookmarkId = allocateBookmarkId(editor);
			const startAttrs = {
				name: input.name,
				id: bookmarkId
			};
			if (input.tableColumn) {
				startAttrs.colFirst = input.tableColumn.colFirst;
				startAttrs.colLast = input.tableColumn.colLast;
			}
			const startNode = bookmarkStartType.create(startAttrs);
			const endNode = bookmarkEndType.create({ id: bookmarkId });
			const { tr } = storyEditor.state;
			tr.insert(resolved.to, endNode);
			tr.insert(resolved.from, startNode);
			storyEditor.dispatch(tr);
			clearIndexCache(storyEditor);
			return true;
		}))) return bookmarkFailure("NO_OP", "Insert operation produced no change.");
		if (runtime.commit) runtime.commit(editor);
		return bookmarkSuccess(address);
	} finally {
		disposeEphemeralWriteRuntime(runtime);
	}
}
function bookmarksRenameWrapper(editor, input, options) {
	rejectTrackedMode("bookmarks.rename", options);
	const runtime = resolveWriteStoryRuntime(editor, resolveBookmarkMutationStory(editor, input.target));
	const storyEditor = runtime.editor;
	try {
		checkBookmarkRevision(editor, storyEditor, options?.expectedRevision);
		const resolved = resolveBookmarkTarget(storyEditor.state.doc, input.target);
		if (resolved.name === input.newName) return bookmarkFailure("NO_OP", "New name is identical to current name.");
		if (bookmarkExistsAnywhere(editor, input.newName, {
			storyKey: runtime.storyKey,
			bookmarkId: resolved.bookmarkId
		})) throw new DocumentApiAdapterError("INVALID_INPUT", `bookmarks.rename: a bookmark with name "${input.newName}" already exists.`);
		const newAddress = buildBookmarkAddress(input.newName, runtime.locator);
		if (options?.dryRun) return bookmarkSuccess(newAddress);
		if (!receiptApplied$6(executeDomainCommand(storyEditor, () => {
			const { tr } = storyEditor.state;
			tr.setNodeMarkup(resolved.pos, void 0, {
				...resolved.node.attrs,
				name: input.newName
			});
			storyEditor.dispatch(tr);
			clearIndexCache(storyEditor);
			return true;
		}))) return bookmarkFailure("NO_OP", "Rename operation produced no change.");
		if (runtime.commit) runtime.commit(editor);
		return bookmarkSuccess(newAddress);
	} finally {
		disposeEphemeralWriteRuntime(runtime);
	}
}
function bookmarksRemoveWrapper(editor, input, options) {
	rejectTrackedMode("bookmarks.remove", options);
	const runtime = resolveWriteStoryRuntime(editor, resolveBookmarkMutationStory(editor, input.target));
	const storyEditor = runtime.editor;
	try {
		checkBookmarkRevision(editor, storyEditor, options?.expectedRevision);
		const resolved = resolveBookmarkTarget(storyEditor.state.doc, input.target);
		const address = buildBookmarkAddress(resolved.name, runtime.locator);
		if (options?.dryRun) return bookmarkSuccess(address);
		if (!receiptApplied$6(executeDomainCommand(storyEditor, () => {
			const { tr } = storyEditor.state;
			if (resolved.endPos !== null && resolved.endPos > resolved.pos) {
				const endNode = tr.doc.nodeAt(resolved.endPos);
				if (endNode) tr.delete(resolved.endPos, resolved.endPos + endNode.nodeSize);
			}
			const startNode = tr.doc.nodeAt(resolved.pos);
			if (startNode) tr.delete(resolved.pos, resolved.pos + startNode.nodeSize);
			storyEditor.dispatch(tr);
			clearIndexCache(storyEditor);
			return true;
		}))) return bookmarkFailure("NO_OP", "Remove operation produced no change.");
		if (runtime.commit) runtime.commit(editor);
		return bookmarkSuccess(address);
	} finally {
		disposeEphemeralWriteRuntime(runtime);
	}
}
function executeOutOfBandMutation(editor, mutateFn, options) {
	if (!options.dryRun) if (editor.options?.collaborationProvider && editor.options?.ydoc) try {
		yUndoPluginKey.getState(editor.state)?.undoManager?.stopCapturing();
	} catch {}
	else try {
		editor.view?.dispatch?.(closeHistory(editor.state.tr));
	} catch {}
	checkRevision(editor, options.expectedRevision);
	const result = mutateFn(options.dryRun);
	if (result.changed && !options.dryRun) {
		const converter = editor.converter;
		if (converter) {
			converter.documentModified = true;
			if (!converter.documentGuid && typeof converter.promoteToGuid === "function") converter.promoteToGuid();
		}
		incrementRevision(editor);
	}
	return result.payload;
}
var import_lib = /* @__PURE__ */ __toESM(require_lib(), 1);
const CUSTOM_XML_DATA_RELATIONSHIP_TYPE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml";
const CUSTOM_XML_PROPS_RELATIONSHIP_TYPE = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps";
const CUSTOM_XML_DATASTORE_NAMESPACE = "http://schemas.openxmlformats.org/officeDocument/2006/customXml";
function getLocalName(name) {
	if (!name || typeof name !== "string") return "";
	const i = name.indexOf(":");
	return i >= 0 ? name.slice(i + 1) : name;
}
function findFirstElement(parent, localName$2) {
	if (!parent?.elements?.length) return null;
	return parent.elements.find((el) => el?.type === "element" && getLocalName(el.name) === localName$2) ?? null;
}
function findAllElements(parent, localName$2) {
	if (!parent?.elements?.length) return [];
	return parent.elements.filter((el) => el?.type === "element" && getLocalName(el.name) === localName$2);
}
function partNameFromIndex(index) {
	return `customXml/item${index}.xml`;
}
function propsPartNameFromIndex(index) {
	return `customXml/itemProps${index}.xml`;
}
function indexFromPartName(partName) {
	const m$1 = /^customXml\/item(\d+)\.xml$/i.exec(partName ?? "");
	return m$1 ? Number.parseInt(m$1[1], 10) : null;
}
function indexFromPropsPartName(propsPartName) {
	const m$1 = /^customXml\/itemProps(\d+)\.xml$/i.exec(propsPartName ?? "");
	return m$1 ? Number.parseInt(m$1[1], 10) : null;
}
function isCustomXmlStoragePartName(partName) {
	return indexFromPartName(partName) != null;
}
function listCustomXmlStoragePartNames(convertedXml) {
	if (!convertedXml || typeof convertedXml !== "object") return [];
	const indexes = [];
	for (const path of Object.keys(convertedXml)) {
		const idx = indexFromPartName(path);
		if (idx != null) indexes.push(idx);
	}
	indexes.sort((a, b$1) => a - b$1);
	return indexes.map(partNameFromIndex);
}
function findPropsPartFor(convertedXml, partName) {
	if (!convertedXml) return null;
	const idx = indexFromPartName(partName);
	if (idx == null) return null;
	const relsRoot = convertedXml[`customXml/_rels/item${idx}.xml.rels`]?.elements?.find((el) => getLocalName(el?.name) === "Relationships");
	if (relsRoot?.elements?.length) for (const rel of relsRoot.elements) {
		if (rel?.attributes?.Type !== "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps") continue;
		const target = rel?.attributes?.Target;
		if (typeof target !== "string" || target.length === 0) continue;
		const candidate = resolveOpcTargetPath(target, "customXml");
		if (candidate && convertedXml[candidate]) return candidate;
	}
	const indexCandidate = propsPartNameFromIndex(idx);
	return convertedXml[indexCandidate] ? indexCandidate : null;
}
function parsePropsPart(propsDoc) {
	const root = propsDoc?.elements?.find((el) => el?.type === "element" && getLocalName(el.name) === "datastoreItem");
	if (!root) return null;
	const itemId = root.attributes?.["ds:itemID"] ?? root.attributes?.itemID ?? null;
	const schemaRefs = findAllElements(findFirstElement(root, "schemaRefs"), "schemaRef").map((el) => el.attributes?.["ds:uri"] ?? el.attributes?.uri ?? null).filter((uri) => typeof uri === "string" && uri.length > 0);
	return {
		itemId: typeof itemId === "string" && itemId.length > 0 ? itemId : null,
		schemaRefs
	};
}
function parseStoragePartRootNamespace(storageDoc) {
	const root = storageDoc?.elements?.find((el) => el?.type === "element");
	if (!root) return null;
	const xmlns = root.attributes?.xmlns;
	if (typeof xmlns === "string" && xmlns.length > 0) return xmlns;
	const elementName = root.name ?? "";
	const colonIdx = elementName.indexOf(":");
	if (colonIdx > 0) {
		const prefixedAttr = `xmlns:${elementName.slice(0, colonIdx)}`;
		const prefixedValue = root.attributes?.[prefixedAttr];
		if (typeof prefixedValue === "string" && prefixedValue.length > 0) return prefixedValue;
	}
	return null;
}
function serializeXmlDoc(xmlDoc) {
	if (!xmlDoc) return "";
	return import_lib.js2xml(xmlDoc, {
		compact: false,
		spaces: 0
	});
}
function readCustomXmlPart(convertedXml, target) {
	if (!target || !convertedXml) return null;
	let partName = null;
	let itemId = null;
	if (typeof target.partName === "string" && target.partName.length > 0) {
		if (!isCustomXmlStoragePartName(target.partName)) return null;
		partName = target.partName;
	} else if (typeof target.id === "string" && target.id.length > 0) {
		itemId = target.id;
		for (const candidatePartName of listCustomXmlStoragePartNames(convertedXml)) {
			const propsName = findPropsPartFor(convertedXml, candidatePartName);
			if (!propsName) continue;
			if (parsePropsPart(convertedXml[propsName])?.itemId === itemId) {
				partName = candidatePartName;
				break;
			}
		}
		if (!partName) return null;
	} else return null;
	const storageDoc = convertedXml[partName];
	if (!storageDoc) return null;
	const propsPartName = findPropsPartFor(convertedXml, partName);
	const props = propsPartName ? parsePropsPart(convertedXml[propsPartName]) : null;
	return {
		id: props?.itemId ?? null,
		partName,
		propsPartName: propsPartName ?? null,
		rootNamespace: parseStoragePartRootNamespace(storageDoc),
		schemaRefs: props?.schemaRefs ?? [],
		content: serializeXmlDoc(storageDoc)
	};
}
function listCustomXmlParts(convertedXml) {
	return listCustomXmlStoragePartNames(convertedXml).map((partName) => {
		const propsPartName = findPropsPartFor(convertedXml, partName);
		const props = propsPartName ? parsePropsPart(convertedXml[propsPartName]) : null;
		return {
			id: props?.itemId ?? null,
			partName,
			propsPartName: propsPartName ?? null,
			rootNamespace: parseStoragePartRootNamespace(convertedXml[partName]),
			schemaRefs: props?.schemaRefs ?? []
		};
	});
}
function nextCustomXmlItemIndex(convertedXml, converter) {
	const used = /* @__PURE__ */ new Set();
	for (const path of Object.keys(convertedXml ?? {})) {
		const idx = indexFromPartName(path) ?? indexFromPropsPartName(path);
		if (idx != null) used.add(idx);
	}
	let candidate = 1;
	while (used.has(candidate)) candidate += 1;
	return candidate;
}
function createXmlDocument(rootElement$1, declaration) {
	const nextDeclaration = declaration ?? DEFAULT_XML_DECLARATION;
	return {
		declaration: {
			...nextDeclaration,
			attributes: { ...nextDeclaration.attributes }
		},
		elements: [rootElement$1]
	};
}
function parseContentToRootElement(content) {
	const parsed = import_lib.xml2js(content, { compact: false });
	const root = (parsed.elements ?? []).find((el) => el?.type === "element");
	if (!root) throw new Error("Custom XML content is missing a root element.");
	return {
		root,
		declaration: parsed.declaration ?? null
	};
}
function ensureDocumentRelationshipsRoot(convertedXml) {
	if (!convertedXml["word/_rels/document.xml.rels"]) convertedXml["word/_rels/document.xml.rels"] = createXmlDocument({
		type: "element",
		name: "Relationships",
		attributes: { xmlns: "http://schemas.openxmlformats.org/package/2006/relationships" },
		elements: []
	});
	const relsData = convertedXml["word/_rels/document.xml.rels"];
	relsData.elements ??= [];
	let relsRoot = relsData.elements.find((el) => getLocalName(el?.name) === "Relationships");
	if (!relsRoot) {
		relsRoot = {
			type: "element",
			name: "Relationships",
			attributes: { xmlns: "http://schemas.openxmlformats.org/package/2006/relationships" },
			elements: []
		};
		relsData.elements.push(relsRoot);
	}
	relsRoot.elements ??= [];
	return relsRoot;
}
function getNextRelationshipId(relsRoot) {
	const used = (relsRoot?.elements ?? []).map((rel) => {
		const id = rel?.attributes?.Id;
		const m$1 = typeof id === "string" ? /^rId(\d+)$/.exec(id) : null;
		return m$1 ? Number.parseInt(m$1[1], 10) : NaN;
	}).filter((n) => Number.isFinite(n));
	return `rId${(used.length > 0 ? Math.max(...used) : 0) + 1}`;
}
function buildDocumentRelTarget(partName) {
	return partName.startsWith("customXml/") ? `../${partName}` : partName;
}
function buildItemPropsRoot(itemId, schemaRefs) {
	return [{
		type: "element",
		name: "ds:datastoreItem",
		attributes: {
			"ds:itemID": itemId,
			"xmlns:ds": CUSTOM_XML_DATASTORE_NAMESPACE
		},
		elements: schemaRefs === void 0 ? [] : [{
			type: "element",
			name: "ds:schemaRefs",
			elements: schemaRefs.map((uri) => ({
				type: "element",
				name: "ds:schemaRef",
				attributes: { "ds:uri": uri }
			}))
		}]
	}][0];
}
function buildItemRelsRoot(propsPartFileName) {
	return {
		type: "element",
		name: "Relationships",
		attributes: { xmlns: "http://schemas.openxmlformats.org/package/2006/relationships" },
		elements: [{
			type: "element",
			name: "Relationship",
			attributes: {
				Id: "rId1",
				Type: CUSTOM_XML_PROPS_RELATIONSHIP_TYPE,
				Target: propsPartFileName
			}
		}]
	};
}
function resolveTargetPartName(convertedXml, target) {
	if (!target) return null;
	if (typeof target.partName === "string" && target.partName.length > 0) {
		if (!isCustomXmlStoragePartName(target.partName)) return null;
		return convertedXml[target.partName] ? target.partName : null;
	}
	if (typeof target.id === "string" && target.id.length > 0) for (const partName of listCustomXmlStoragePartNames(convertedXml)) {
		const propsName = findPropsPartFor(convertedXml, partName);
		if (!propsName) continue;
		if (parsePropsPart(convertedXml[propsName])?.itemId === target.id) return partName;
	}
	return null;
}
function createCustomXmlPart(convertedXml, { content, schemaRefs }, converter) {
	const { root, declaration } = parseContentToRootElement(content);
	const index = nextCustomXmlItemIndex(convertedXml, converter);
	const partName = partNameFromIndex(index);
	const propsPartName = propsPartNameFromIndex(index);
	const itemRelsPath = `customXml/_rels/item${index}.xml.rels`;
	const itemId = `{${v4_default().toUpperCase()}}`;
	convertedXml[partName] = createXmlDocument(root, declaration);
	convertedXml[propsPartName] = createXmlDocument(buildItemPropsRoot(itemId, schemaRefs));
	convertedXml[itemRelsPath] = createXmlDocument(buildItemRelsRoot(`itemProps${index}.xml`));
	const relsRoot = ensureDocumentRelationshipsRoot(convertedXml);
	relsRoot.elements.push({
		type: "element",
		name: "Relationship",
		attributes: {
			Id: getNextRelationshipId(relsRoot),
			Type: CUSTOM_XML_DATA_RELATIONSHIP_TYPE,
			Target: buildDocumentRelTarget(partName)
		}
	});
	if (converter?.removedCustomXmlPaths instanceof Set) {
		converter.removedCustomXmlPaths.delete(partName);
		converter.removedCustomXmlPaths.delete(propsPartName);
		converter.removedCustomXmlPaths.delete(itemRelsPath);
	}
	return {
		id: itemId,
		partName,
		propsPartName
	};
}
function patchCustomXmlPart(convertedXml, target, { content, schemaRefs }, converter) {
	const partName = resolveTargetPartName(convertedXml, target);
	if (!partName) return null;
	if (content !== void 0) {
		const { root, declaration } = parseContentToRootElement(content);
		convertedXml[partName] = createXmlDocument(root, convertedXml[partName]?.declaration ?? declaration);
	}
	let resolvedId = null;
	if (schemaRefs !== void 0) {
		let propsPartName = findPropsPartFor(convertedXml, partName);
		if (propsPartName) resolvedId = parsePropsPart(convertedXml[propsPartName])?.itemId ?? null;
		if (!propsPartName) {
			const idx = indexFromPartName(partName);
			if (idx == null) return null;
			propsPartName = propsPartNameFromIndex(idx);
			const itemRelsPath = `customXml/_rels/item${idx}.xml.rels`;
			resolvedId = `{${v4_default().toUpperCase()}}`;
			convertedXml[itemRelsPath] = createXmlDocument(buildItemRelsRoot(`itemProps${idx}.xml`));
		}
		if (!resolvedId) resolvedId = `{${v4_default().toUpperCase()}}`;
		const existingDecl = convertedXml[propsPartName]?.declaration;
		convertedXml[propsPartName] = createXmlDocument(buildItemPropsRoot(resolvedId, schemaRefs), existingDecl);
	} else {
		const propsPartName = findPropsPartFor(convertedXml, partName);
		if (propsPartName) resolvedId = parsePropsPart(convertedXml[propsPartName])?.itemId ?? null;
	}
	if (converter) invalidateConverterCachesForPath(converter, partName);
	return resolvedId ? {
		partName,
		id: resolvedId
	} : { partName };
}
function removeCustomXmlPart(convertedXml, target, converter) {
	const partName = resolveTargetPartName(convertedXml, target);
	if (!partName) return false;
	const index = indexFromPartName(partName);
	const removedPaths = [
		partName,
		findPropsPartFor(convertedXml, partName),
		index == null ? null : `customXml/_rels/item${index}.xml.rels`
	].filter((path) => typeof path === "string" && path.length > 0);
	for (const path of removedPaths) delete convertedXml[path];
	const relsRoot = convertedXml["word/_rels/document.xml.rels"]?.elements?.find((el) => getLocalName(el?.name) === "Relationships");
	if (relsRoot?.elements?.length) relsRoot.elements = relsRoot.elements.filter((rel) => {
		if (rel?.attributes?.Type !== "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml") return true;
		return resolveOpcTargetPath(rel?.attributes?.Target, "word") !== partName;
	});
	if (converter) {
		if (!(converter.removedCustomXmlPaths instanceof Set)) converter.removedCustomXmlPaths = /* @__PURE__ */ new Set();
		for (const path of removedPaths) converter.removedCustomXmlPaths.add(path);
		invalidateConverterCachesForPath(converter, partName);
	}
	return true;
}
function invalidateConverterCachesForPath(converter, partName) {
	if (!converter || typeof partName !== "string") return;
	const biblio = converter.bibliographyPart;
	if (biblio && biblio.partPath === partName) converter.bibliographyPart = {
		sources: [],
		partPath: null,
		itemPropsPath: null,
		itemRelsPath: null,
		selectedStyle: null,
		styleName: null,
		version: null
	};
}
function getConverter$3(editor) {
	return editor.converter ?? null;
}
function getConvertedXml$1(editor) {
	return getConverter$3(editor)?.convertedXml ?? {};
}
function toSummary$1(record) {
	const summary = {
		partName: record.partName,
		schemaRefs: record.schemaRefs
	};
	if (record.id) summary.id = record.id;
	if (record.propsPartName) summary.propsPartName = record.propsPartName;
	if (record.rootNamespace) summary.rootNamespace = record.rootNamespace;
	return summary;
}
function customXmlPartsListWrapper(editor, query) {
	const revision = getRevision(editor);
	let filtered = listCustomXmlParts(getConvertedXml$1(editor));
	if (query?.rootNamespace !== void 0) filtered = filtered.filter((p$1) => p$1.rootNamespace === query.rootNamespace);
	if (query?.schemaRef !== void 0) filtered = filtered.filter((p$1) => p$1.schemaRefs.includes(query.schemaRef));
	const { total, items: paged } = paginate(filtered.map((record) => {
		const summary = toSummary$1(record);
		const stableId = summary.id ?? summary.partName;
		return buildDiscoveryItem(stableId, buildResolvedHandle(`customXml:${stableId}`, "ephemeral", "ext:customXmlPart"), summary);
	}), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function customXmlPartsGetWrapper(editor, input) {
	const record = readCustomXmlPart(getConvertedXml$1(editor), input.target);
	if (!record) return null;
	const info = {
		partName: record.partName,
		rootNamespace: record.rootNamespace ?? void 0,
		schemaRefs: record.schemaRefs,
		content: record.content
	};
	if (record.id) info.id = record.id;
	if (record.propsPartName) info.propsPartName = record.propsPartName;
	return info;
}
function failure$1(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function isWriteFailure(outcome) {
	return outcome.ok === false;
}
function targetNotFound() {
	return {
		ok: false,
		code: "TARGET_NOT_FOUND",
		message: "No custom XML part matched the supplied target."
	};
}
function safeValidate(fn) {
	try {
		return {
			ok: true,
			payload: fn()
		};
	} catch (e) {
		return {
			ok: false,
			code: "INVALID_INPUT",
			message: e instanceof Error ? e.message : String(e)
		};
	}
}
function customXmlPartsCreateWrapper(editor, input, options) {
	rejectTrackedMode("customXml.parts.create", options);
	const outcome = executeOutOfBandMutation(editor, (dryRun) => {
		if (dryRun) {
			const probe$1 = safeValidate(() => createCustomXmlPart({}, {
				content: input.content,
				schemaRefs: input.schemaRefs
			}));
			if (isWriteFailure(probe$1)) return {
				changed: false,
				payload: probe$1
			};
			return {
				changed: false,
				payload: {
					ok: true,
					payload: {
						id: "{DRY-RUN}",
						partName: "",
						propsPartName: ""
					}
				}
			};
		}
		const probe = safeValidate(() => createCustomXmlPart(getConvertedXml$1(editor), {
			content: input.content,
			schemaRefs: input.schemaRefs
		}, getConverter$3(editor)));
		if (isWriteFailure(probe)) return {
			changed: false,
			payload: probe
		};
		return {
			changed: true,
			payload: {
				ok: true,
				payload: probe.payload
			}
		};
	}, {
		dryRun: options?.dryRun === true,
		expectedRevision: options?.expectedRevision
	});
	if (isWriteFailure(outcome)) return failure$1(outcome.code, outcome.message);
	return {
		success: true,
		id: outcome.payload.id,
		partName: outcome.payload.partName,
		propsPartName: outcome.payload.propsPartName
	};
}
function customXmlPartsPatchWrapper(editor, input, options) {
	rejectTrackedMode("customXml.parts.patch", options);
	const outcome = executeOutOfBandMutation(editor, (dryRun) => {
		if (dryRun) {
			if (!resolveTargetPartName(getConvertedXml$1(editor), input.target)) return {
				changed: false,
				payload: targetNotFound()
			};
			if (input.content !== void 0) {
				const probe$1 = safeValidate(() => createCustomXmlPart({}, {
					content: input.content,
					schemaRefs: void 0
				}));
				if (isWriteFailure(probe$1)) return {
					changed: false,
					payload: probe$1
				};
			}
			return {
				changed: false,
				payload: {
					ok: true,
					payload: { id: null }
				}
			};
		}
		if (!resolveTargetPartName(getConvertedXml$1(editor), input.target)) return {
			changed: false,
			payload: targetNotFound()
		};
		const probe = safeValidate(() => patchCustomXmlPart(getConvertedXml$1(editor), input.target, {
			content: input.content,
			schemaRefs: input.schemaRefs
		}, getConverter$3(editor)));
		if (isWriteFailure(probe)) return {
			changed: false,
			payload: probe
		};
		if (!probe.payload) return {
			changed: false,
			payload: targetNotFound()
		};
		return {
			changed: true,
			payload: {
				ok: true,
				payload: { id: probe.payload.id ?? null }
			}
		};
	}, {
		dryRun: options?.dryRun === true,
		expectedRevision: options?.expectedRevision
	});
	if (isWriteFailure(outcome)) return failure$1(outcome.code, outcome.message);
	const result = {
		success: true,
		target: input.target
	};
	if (outcome.payload.id) result.id = outcome.payload.id;
	return result;
}
function customXmlPartsRemoveWrapper(editor, input, options) {
	rejectTrackedMode("customXml.parts.remove", options);
	const outcome = executeOutOfBandMutation(editor, (dryRun) => {
		if (dryRun) return resolveTargetPartName(getConvertedXml$1(editor), input.target) ? {
			changed: false,
			payload: {
				ok: true,
				payload: true
			}
		} : {
			changed: false,
			payload: targetNotFound()
		};
		if (!removeCustomXmlPart(getConvertedXml$1(editor), input.target, getConverter$3(editor))) return {
			changed: false,
			payload: targetNotFound()
		};
		return {
			changed: true,
			payload: {
				ok: true,
				payload: true
			}
		};
	}, {
		dryRun: options?.dryRun === true,
		expectedRevision: options?.expectedRevision
	});
	if (isWriteFailure(outcome)) return failure$1(outcome.code, outcome.message);
	return {
		success: true,
		target: input.target
	};
}
function createCustomXmlPartsAdapter(editor) {
	return {
		list: (query) => customXmlPartsListWrapper(editor, query),
		get: (input) => customXmlPartsGetWrapper(editor, input),
		create: (input, options) => customXmlPartsCreateWrapper(editor, input, options),
		patch: (input, options) => customXmlPartsPatchWrapper(editor, input, options),
		remove: (input, options) => customXmlPartsRemoveWrapper(editor, input, options)
	};
}
function failure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function getConverter$2(editor) {
	return editor.converter ?? null;
}
function getConvertedXml(editor) {
	return getConverter$2(editor)?.convertedXml ?? {};
}
function markConverterDirty(editor) {
	const converter = getConverter$2(editor);
	if (!converter) return;
	converter.documentModified = true;
	if (!converter.documentGuid && typeof converter.promoteToGuid === "function") converter.promoteToGuid();
}
function getRootElement(doc$1) {
	return doc$1?.elements?.find((el) => el?.type === "element") ?? null;
}
function localName(name) {
	if (!name) return "";
	const idx = name.indexOf(":");
	return idx >= 0 ? name.slice(idx + 1) : name;
}
function getTextContent(node) {
	if (!node) return "";
	if (node.type === "text") return node.text ?? "";
	if (node.type === "cdata") return node.cdata ?? "";
	return (node.elements ?? []).map((child) => getTextContent(child)).join("");
}
function escapeXmlText(value) {
	return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function escapeXmlAttribute(value) {
	return escapeXmlText(value).replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
function buildEnvelopeXml(namespace, entries) {
	const children = entries.map((entry) => {
		const json = JSON.stringify(entry.payload);
		return `<ref id="${escapeXmlAttribute(entry.id)}" encoding="json">${escapeXmlText(json)}</ref>`;
	}).join("");
	return `<refs xmlns="${escapeXmlAttribute(namespace)}">${children}</refs>`;
}
function parseMetadataPart(convertedXml, partName) {
	const root = getRootElement(convertedXml[partName]);
	if (!root || localName(root.name) !== "refs") return null;
	const namespace = parseStoragePartRootNamespace(convertedXml[partName]);
	if (typeof namespace !== "string" || namespace.length === 0) return null;
	const entries = [];
	for (const child of root.elements ?? []) {
		if (child?.type !== "element" || localName(child.name) !== "ref") continue;
		if (child.attributes?.encoding !== "json") continue;
		const id = child.attributes?.id;
		if (typeof id !== "string" || id.length === 0) continue;
		try {
			entries.push({
				id,
				namespace,
				partName,
				payload: JSON.parse(getTextContent(child))
			});
		} catch {
			continue;
		}
	}
	return {
		namespace,
		partName,
		entries
	};
}
function listMetadataParts(convertedXml) {
	return listCustomXmlParts(convertedXml).map((part) => parseMetadataPart(convertedXml, part.partName)).filter((part) => part !== null);
}
function buildFilteredMetadataXml(editor, convertedXml, options) {
	const filtered = {};
	const finalDoc = options?.finalDoc === true;
	for (const part of listMetadataParts(convertedXml)) {
		const resolvedEntries = finalDoc ? [] : part.entries.filter((entry) => hasAnchor(editor, entry.id));
		filtered[part.partName] = buildEnvelopeXml(part.namespace, resolvedEntries);
	}
	return filtered;
}
function findPartByNamespace(convertedXml, namespace) {
	return listMetadataParts(convertedXml).find((part) => part.namespace === namespace) ?? null;
}
function findEntry(convertedXml, id) {
	for (const part of listMetadataParts(convertedXml)) {
		const entry = part.entries.find((candidate) => candidate.id === id);
		if (entry) return entry;
	}
	return null;
}
function hasPayloadEntry(convertedXml, id) {
	return findEntry(convertedXml, id) !== null;
}
function predictPartName(convertedXml, converter) {
	return `customXml/item${nextCustomXmlItemIndex(convertedXml, converter)}.xml`;
}
function buildAnchorAttrs(id) {
	return {
		id: generateRandomSigned32BitIntStrId(),
		tag: id,
		alias: "Anchored metadata",
		appearance: "hidden",
		controlType: "richText",
		type: "richText",
		sdtPr: {
			name: "w:sdtPr",
			type: "element",
			elements: [{
				name: "w:richText",
				type: "element"
			}, {
				name: "w15:appearance",
				type: "element",
				attributes: { "w15:val": "hidden" }
			}]
		}
	};
}
function dispatchTransaction(editor, tr) {
	if (editor.view?.dispatch) {
		editor.view.dispatch(tr);
		return;
	}
	if (typeof editor.dispatch === "function") {
		editor.dispatch(tr);
		return;
	}
	throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "metadata.* requires an editor dispatch function.");
}
function findAnchorsById(editor, id) {
	return findAllSdtNodes(editor.state.doc).filter((sdt) => sdt.kind === "inline" && sdt.node.attrs?.tag === id);
}
function hasAnchor(editor, id) {
	return findAnchorsById(editor, id).length > 0;
}
function wrapRangeInAnchor(editor, target, id) {
	const { absFrom, absTo } = resolveSelectionTarget(editor, target);
	if (absFrom >= absTo) throw new DocumentApiAdapterError("INVALID_TARGET", "metadata.attach requires a non-empty text range.");
	const nodeType = editor.schema.nodes[SDT_INLINE_NAME];
	if (!nodeType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "Inline content-control node is not available.");
	const { tr } = editor.state;
	const attrs = buildAnchorAttrs(id);
	const runType = editor.schema.nodes.run;
	const $from = tr.doc.resolve(absFrom);
	const $to = tr.doc.resolve(absTo);
	if (runType && $from.parent.type === runType && $from.parent === $to.parent) {
		const runDepth = $from.depth;
		const runStart = $from.before(runDepth);
		const runEnd = $from.after(runDepth);
		const parentRun = $from.parent;
		const selectedContent = parentRun.content.cut($from.parentOffset, $to.parentOffset);
		const leftContent = parentRun.content.cut(0, $from.parentOffset);
		const rightContent = parentRun.content.cut($to.parentOffset);
		const sdtNode = nodeType.create(attrs, selectedContent);
		const replacement = [];
		if (leftContent.size > 0) replacement.push(runType.create(parentRun.attrs, leftContent, parentRun.marks));
		replacement.push(sdtNode);
		if (rightContent.size > 0) replacement.push(runType.create(parentRun.attrs, rightContent, parentRun.marks));
		tr.replaceWith(runStart, runEnd, replacement);
	} else {
		const selected = tr.doc.slice(absFrom, absTo);
		const sdtNode = nodeType.create(attrs, selected.content);
		tr.replaceWith(absFrom, absTo, sdtNode);
	}
	dispatchTransaction(editor, tr);
	clearIndexCache(editor);
	return true;
}
function unwrapAnchor(editor, id) {
	const anchor = findAnchorsById(editor, id)[0];
	if (!anchor) return false;
	const { tr } = editor.state;
	tr.replaceWith(anchor.pos, anchor.pos + anchor.node.nodeSize, anchor.node.content);
	dispatchTransaction(editor, tr);
	clearIndexCache(editor);
	return true;
}
function pointFromPmPosition(editor, pos) {
	const index = getBlockIndex(editor);
	for (const candidate of index.candidates) {
		if (!isTextBlockCandidate(candidate)) continue;
		const contentStart = candidate.pos + 1;
		const contentEnd = candidate.end - 1;
		if (pos >= contentStart && pos <= contentEnd) return {
			kind: "text",
			blockId: candidate.nodeId,
			offset: pmPositionToTextOffset(candidate.node, candidate.pos, pos)
		};
	}
	throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Could not resolve metadata anchor to a text range.");
}
function resolveAnchorTarget(editor, id) {
	const anchor = findAnchorsById(editor, id)[0];
	if (!anchor) return null;
	return {
		kind: "selection",
		start: pointFromPmPosition(editor, anchor.pos + 1),
		end: pointFromPmPosition(editor, anchor.pos + anchor.node.nodeSize - 1)
	};
}
function rangesOverlap$1(aFrom, aTo, bFrom, bTo) {
	if (aFrom === aTo || bFrom === bTo) return aFrom <= bTo && bFrom <= aTo;
	return aFrom < bTo && bFrom < aTo;
}
function anchorOverlaps(editor, id, within$1) {
	const anchor = findAnchorsById(editor, id)[0];
	if (!anchor) return false;
	const query = resolveSelectionTarget(editor, within$1);
	return rangesOverlap$1(anchor.pos + 1, anchor.pos + anchor.node.nodeSize - 1, query.absFrom, query.absTo);
}
function writeEntry(editor, namespace, id, payload, dryRun) {
	const convertedXml = getConvertedXml(editor);
	const converter = getConverter$2(editor);
	const existing = findPartByNamespace(convertedXml, namespace);
	const entries = existing?.entries.filter((entry) => entry.id !== id) ?? [];
	const next = {
		id,
		namespace,
		partName: existing?.partName ?? predictPartName(convertedXml, converter),
		payload
	};
	const xml = buildEnvelopeXml(namespace, [...entries, next]);
	if (dryRun) return { partName: next.partName };
	if (existing) {
		patchCustomXmlPart(convertedXml, { partName: existing.partName }, {
			content: xml,
			schemaRefs: void 0
		}, converter ?? void 0);
		markConverterDirty(editor);
		return { partName: existing.partName };
	}
	const created = createCustomXmlPart(convertedXml, {
		content: xml,
		schemaRefs: void 0
	}, converter ?? void 0);
	markConverterDirty(editor);
	return { partName: created.partName };
}
function removeEntry(editor, id, dryRun) {
	const convertedXml = getConvertedXml(editor);
	const converter = getConverter$2(editor);
	const part = listMetadataParts(convertedXml).find((candidate) => candidate.entries.some((entry) => entry.id === id));
	if (!part) return false;
	if (dryRun) return true;
	const remaining = part.entries.filter((entry) => entry.id !== id);
	if (remaining.length === 0) removeCustomXmlPart(convertedXml, { partName: part.partName }, converter ?? void 0);
	else patchCustomXmlPart(convertedXml, { partName: part.partName }, {
		content: buildEnvelopeXml(part.namespace, remaining),
		schemaRefs: void 0
	}, converter ?? void 0);
	markConverterDirty(editor);
	return true;
}
function toSummary(entry, editor) {
	return {
		id: entry.id,
		namespace: entry.namespace,
		partName: entry.partName,
		anchorStatus: hasAnchor(editor, entry.id) ? "resolved" : "orphan"
	};
}
function listEntries(editor, query) {
	let entries = listMetadataParts(getConvertedXml(editor)).flatMap((part) => part.entries);
	if (query?.namespace !== void 0) entries = entries.filter((entry) => entry.namespace === query.namespace);
	if (query?.within !== void 0) entries = entries.filter((entry) => anchorOverlaps(editor, entry.id, query.within));
	if (query?.resolvedOnly) entries = entries.filter((entry) => hasAnchor(editor, entry.id));
	return entries;
}
function metadataListWrapper(editor, query) {
	const { total, items } = paginate(listEntries(editor, query).map((entry) => {
		const summary = toSummary(entry, editor);
		return buildDiscoveryItem(summary.id, buildResolvedHandle(`metadata:${summary.id}`, "ephemeral", "ext:anchoredMetadata"), summary);
	}), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: getRevision(editor),
		total,
		items,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: items.length
		}
	});
}
function metadataGetWrapper(editor, input) {
	const entry = findEntry(getConvertedXml(editor), input.id);
	if (!entry) return null;
	return {
		...entry,
		anchorStatus: hasAnchor(editor, entry.id) ? "resolved" : "orphan"
	};
}
function metadataResolveWrapper(editor, input) {
	if (!hasPayloadEntry(getConvertedXml(editor), input.id)) return null;
	const target = resolveAnchorTarget(editor, input.id);
	return target ? {
		id: input.id,
		target
	} : null;
}
function metadataAttachWrapper(editor, input, options) {
	rejectTrackedMode("metadata.attach", options);
	const id = input.id ?? v4_default();
	const convertedXml = getConvertedXml(editor);
	try {
		resolveSelectionTarget(editor, input.target);
	} catch (error) {
		const message = error instanceof Error ? error.message : String(error);
		if (error instanceof DocumentApiAdapterError) {
			if (error.code === "TARGET_NOT_FOUND" || error.code === "INVALID_TARGET") return failure(error.code, message);
		}
		return failure("INVALID_TARGET", message);
	}
	if (hasPayloadEntry(convertedXml, id) || hasAnchor(editor, id)) return failure("INVALID_INPUT", `Anchored metadata id "${id}" already exists.`);
	const preview = writeEntry(editor, input.namespace, id, input.payload, true);
	if (options?.dryRun) {
		checkRevision(editor, options.expectedRevision);
		return {
			success: true,
			id,
			namespace: input.namespace,
			partName: preview.partName
		};
	}
	if (executeDomainCommand(editor, () => {
		wrapRangeInAnchor(editor, input.target, id);
		writeEntry(editor, input.namespace, id, input.payload, false);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return failure("INVALID_TARGET", "metadata.attach did not change the document.");
	const entry = findEntry(getConvertedXml(editor), id);
	return {
		success: true,
		id,
		namespace: input.namespace,
		partName: entry?.partName ?? preview.partName
	};
}
function metadataUpdateWrapper(editor, input, options) {
	rejectTrackedMode("metadata.update", options);
	const existing = findEntry(getConvertedXml(editor), input.id);
	if (!existing) return failure("TARGET_NOT_FOUND", `Anchored metadata entry "${input.id}" not found.`);
	return executeOutOfBandMutation(editor, (dryRun) => {
		if (!dryRun) writeEntry(editor, existing.namespace, input.id, input.payload, false);
		return {
			changed: true,
			payload: {
				success: true,
				id: input.id
			}
		};
	}, {
		dryRun: options?.dryRun ?? false,
		expectedRevision: options?.expectedRevision
	});
}
function metadataRemoveWrapper(editor, input, options) {
	rejectTrackedMode("metadata.remove", options);
	const payloadExists = hasPayloadEntry(getConvertedXml(editor), input.id);
	const anchorExists = hasAnchor(editor, input.id);
	if (!payloadExists && !anchorExists) return failure("TARGET_NOT_FOUND", `Anchored metadata entry "${input.id}" not found.`);
	if (options?.dryRun) {
		checkRevision(editor, options.expectedRevision);
		return {
			success: true,
			id: input.id
		};
	}
	if (!anchorExists) return executeOutOfBandMutation(editor, (dryRun) => {
		return {
			changed: removeEntry(editor, input.id, dryRun),
			payload: {
				success: true,
				id: input.id
			}
		};
	}, {
		dryRun: false,
		expectedRevision: options?.expectedRevision
	});
	if (executeDomainCommand(editor, () => {
		unwrapAnchor(editor, input.id);
		removeEntry(editor, input.id, false);
		markConverterDirty(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }).steps[0]?.effect !== "changed") return failure("TARGET_NOT_FOUND", `Anchored metadata entry "${input.id}" not found.`);
	return {
		success: true,
		id: input.id
	};
}
function createAnchoredMetadataAdapter(editor) {
	return {
		attach: (input, options) => metadataAttachWrapper(editor, input, options),
		list: (query) => metadataListWrapper(editor, query),
		get: (input) => metadataGetWrapper(editor, input),
		update: (input, options) => metadataUpdateWrapper(editor, input, options),
		remove: (input, options) => metadataRemoveWrapper(editor, input, options),
		resolve: (input) => metadataResolveWrapper(editor, input)
	};
}
var SETTINGS_PART = SETTINGS_PART_PATH;
function getConverter$1(editor) {
	return editor.converter ?? void 0;
}
function requireConverter(editor, operationName) {
	const converter = getConverter$1(editor);
	if (!converter) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", `${operationName} requires an active document converter.`);
	return converter;
}
function buildPreviewState(current, editingRestriction) {
	const { mode, enforced } = editingRestriction;
	return {
		editingRestriction: {
			mode,
			enforced,
			runtimeEnforced: mode === "readOnly" && enforced,
			passwordProtected: current.editingRestriction.passwordProtected,
			formattingRestricted: editingRestriction.formattingRestricted
		},
		writeProtection: current.writeProtection,
		readOnlyRecommended: current.readOnlyRecommended
	};
}
function protectionGetAdapter(editor) {
	const stored = getProtectionStorage(editor);
	if (stored?.initialized) return stored.state;
	const converter = getConverter$1(editor);
	return parseProtectionState(converter ? readSettingsRoot(converter) : null);
}
function protectionSetEditingRestrictionAdapter(editor, input, options) {
	rejectTrackedMode("protection.setEditingRestriction", options);
	const converter = requireConverter(editor, "protection.setEditingRestriction");
	const result = mutatePart({
		editor,
		partId: SETTINGS_PART,
		operation: "mutate",
		source: "protection.setEditingRestriction",
		dryRun: options?.dryRun === true,
		expectedRevision: options?.expectedRevision,
		mutate({ part, dryRun: isDryRun }) {
			const currentState = parseProtectionState(readSettingsRoot(converter));
			const { editingRestriction } = currentState;
			if (editingRestriction.mode === input.mode && editingRestriction.enforced === true && (input.formattingRestricted === void 0 || editingRestriction.formattingRestricted === input.formattingRestricted)) return {
				success: false,
				failure: {
					code: "NO_OP",
					message: "Editing restriction already matches the requested state."
				}
			};
			if (isDryRun) return {
				success: true,
				state: buildPreviewState(currentState, {
					mode: input.mode,
					enforced: true,
					formattingRestricted: input.formattingRestricted ?? currentState.editingRestriction.formattingRestricted
				})
			};
			const settingsRoot = ensureSettingsRoot(part);
			setDocumentProtection(settingsRoot, {
				mode: input.mode,
				enforced: true,
				formattingRestricted: input.formattingRestricted
			});
			const newState = parseProtectionState(settingsRoot);
			const protStorage = getProtectionStorage(editor);
			if (protStorage) protStorage.state = newState;
			editor.emit("protectionChanged", {
				editor,
				state: newState,
				source: "local-mutation"
			});
			return {
				success: true,
				state: newState
			};
		}
	});
	if (options?.dryRun !== true) applyEffectiveEditability(editor);
	return result.result;
}
function protectionClearEditingRestrictionAdapter(editor, _input, options) {
	rejectTrackedMode("protection.clearEditingRestriction", options);
	const converter = requireConverter(editor, "protection.clearEditingRestriction");
	const result = mutatePart({
		editor,
		partId: SETTINGS_PART,
		operation: "mutate",
		source: "protection.clearEditingRestriction",
		dryRun: options?.dryRun === true,
		expectedRevision: options?.expectedRevision,
		mutate({ part, dryRun: isDryRun }) {
			const currentState = parseProtectionState(readSettingsRoot(converter));
			if (!currentState.editingRestriction.enforced) return {
				success: false,
				failure: {
					code: "NO_OP",
					message: "Editing restriction is already not enforced."
				}
			};
			if (isDryRun) return {
				success: true,
				state: buildPreviewState(currentState, {
					mode: currentState.editingRestriction.mode,
					enforced: false,
					formattingRestricted: currentState.editingRestriction.formattingRestricted
				})
			};
			const settingsRoot = ensureSettingsRoot(part);
			clearDocumentProtectionEnforcement(settingsRoot);
			const newState = parseProtectionState(settingsRoot);
			const protStorage = getProtectionStorage(editor);
			if (protStorage) protStorage.state = newState;
			editor.emit("protectionChanged", {
				editor,
				state: newState,
				source: "local-mutation"
			});
			return {
				success: true,
				state: newState
			};
		}
	});
	if (options?.dryRun !== true) applyEffectiveEditability(editor);
	return result.result;
}
function pmPosToPosition(doc$1, pos) {
	const resolved = doc$1.resolve(pos);
	for (let depth = resolved.depth; depth >= 0; depth--) {
		const node = resolved.node(depth);
		const blockId = node.attrs?.sdBlockId;
		if (blockId) return {
			blockId,
			offset: pmPositionToTextOffset(node, resolved.start(depth) - 1, pos)
		};
	}
	return {
		blockId: "",
		offset: pos
	};
}
function getPermRangesStorage(editor) {
	return editor.storage.permissionRanges;
}
function getAllRanges(editor) {
	return getPermRangesStorage(editor)?.allRanges ?? [];
}
function toRangeInfo(entry, doc$1) {
	return {
		id: entry.id,
		principal: entry.principal,
		kind: entry.kind,
		start: pmPosToPosition(doc$1, entry.from),
		end: pmPosToPosition(doc$1, entry.to)
	};
}
function principalToAttrs(principal) {
	if (principal.kind === "everyone") return { edGrp: "everyone" };
	return { ed: principal.id };
}
function generatePermissionId() {
	return String(Math.floor(Math.random() * 2e9));
}
function permissionRangesListAdapter(editor, input) {
	const revision = getRevision(editor);
	const doc$1 = editor.state.doc;
	const { total, items: paged } = paginate(getAllRanges(editor).map((entry) => buildDiscoveryItem(entry.id, buildResolvedHandle(`perm:${entry.id}`, "ephemeral", "ext:permissionRange"), toRangeInfo(entry, doc$1))), input?.offset, input?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: input?.limit ?? total,
			offset: input?.offset ?? 0,
			returned: paged.length
		}
	});
}
function permissionRangesGetAdapter(editor, input) {
	const entry = getAllRanges(editor).find((r$1) => r$1.id === input.id);
	if (!entry) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Permission range '${input.id}' not found.`);
	return toRangeInfo(entry, editor.state.doc);
}
function permissionRangesCreateAdapter(editor, input, options) {
	rejectTrackedMode("permissionRanges.create", options);
	const { target, principal, id: callerSuppliedId } = input;
	const id = callerSuppliedId ?? generatePermissionId();
	if (getAllRanges(editor).some((r$1) => r$1.id === id)) throw new DocumentApiAdapterError("INVALID_INPUT", `Permission range ID '${id}' already exists.`);
	const resolved = resolveSelectionTarget(editor, target);
	const from$1 = resolved.absFrom;
	const to = resolved.absTo;
	const doc$1 = editor.state.doc;
	if (from$1 >= to || from$1 < 0 || to > doc$1.content.size) throw new DocumentApiAdapterError("INVALID_TARGET", "Target range is invalid or empty.");
	const attrs = {
		id,
		...principalToAttrs(principal)
	};
	const $from = doc$1.resolve(from$1);
	const $to = doc$1.resolve(to);
	const spansMultipleBlocks = $from.parent !== $to.parent || $from.depth === 0;
	if (options?.dryRun) return {
		success: true,
		range: toRangeInfo({
			id,
			principal,
			kind: spansMultipleBlocks ? "block" : "inline",
			from: from$1,
			to,
			startPos: from$1,
			endPos: to
		}, doc$1)
	};
	const { tr } = editor.state;
	tr.setMeta(PERMISSION_MUTATION_META, true);
	tr.setMeta("addToHistory", false);
	setTrackChangesSkip(editor, tr);
	const schema = editor.state.schema;
	if (spansMultipleBlocks) {
		const startNode = schema.nodes.permStartBlock?.create(attrs);
		const endNode = schema.nodes.permEndBlock?.create({ id });
		if (!startNode || !endNode) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "Block-level permission range nodes are not available in the schema.");
		tr.insert(to, endNode);
		tr.insert(from$1, startNode);
	} else {
		const startNode = schema.nodes.permStart?.create(attrs);
		const endNode = schema.nodes.permEnd?.create({ id });
		if (!startNode || !endNode) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "Inline permission range nodes are not available in the schema.");
		tr.insert(to, endNode);
		tr.insert(from$1, startNode);
	}
	if (editor.view) editor.view.dispatch(tr);
	else editor.dispatch(tr);
	const created = getAllRanges(editor).find((r$1) => r$1.id === id);
	if (created) return {
		success: true,
		range: toRangeInfo(created, editor.state.doc)
	};
	return {
		success: true,
		range: {
			id,
			principal,
			kind: spansMultipleBlocks ? "block" : "inline",
			start: pmPosToPosition(editor.state.doc, from$1),
			end: pmPosToPosition(editor.state.doc, to)
		}
	};
}
function permissionRangesRemoveAdapter(editor, input, options) {
	rejectTrackedMode("permissionRanges.remove", options);
	const { id } = input;
	if (options?.dryRun) {
		if (!getAllRanges(editor).some((r$1) => r$1.id === id)) {
			const hasMarker = findMarkerPositions(editor, id);
			if (!hasMarker.start && !hasMarker.end) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Permission range '${id}' not found.`);
		}
		return {
			success: true,
			id
		};
	}
	const positions = findMarkerPositions(editor, id);
	if (!positions.start && !positions.end) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Permission range '${id}' not found.`);
	const { tr } = editor.state;
	tr.setMeta(PERMISSION_MUTATION_META, true);
	tr.setMeta("addToHistory", false);
	setTrackChangesSkip(editor, tr);
	const toDelete = [...positions.end ? [positions.end] : [], ...positions.start ? [positions.start] : []].sort((a, b$1) => b$1.pos - a.pos);
	for (const marker of toDelete) tr.delete(marker.pos, marker.pos + marker.nodeSize);
	if (editor.view) editor.view.dispatch(tr);
	else editor.dispatch(tr);
	return {
		success: true,
		id
	};
}
function permissionRangesUpdatePrincipalAdapter(editor, input, options) {
	rejectTrackedMode("permissionRanges.updatePrincipal", options);
	const { id, principal } = input;
	const positions = findMarkerPositions(editor, id);
	if (!positions.start) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Permission range start marker '${id}' not found.`);
	if (options?.dryRun) {
		const existing = getAllRanges(editor).find((r$1) => r$1.id === id);
		if (existing) return {
			success: true,
			range: toRangeInfo({
				...existing,
				principal
			}, editor.state.doc)
		};
		return {
			success: true,
			range: {
				id,
				principal,
				kind: "inline",
				start: pmPosToPosition(editor.state.doc, positions.start.pos),
				end: pmPosToPosition(editor.state.doc, positions.start.pos)
			}
		};
	}
	const { tr } = editor.state;
	tr.setMeta(PERMISSION_MUTATION_META, true);
	tr.setMeta("addToHistory", false);
	setTrackChangesSkip(editor, tr);
	const { pos, node } = positions.start;
	const newAttrs = {
		...node.attrs,
		...principalToAttrs(principal),
		...principal.kind === "everyone" ? { ed: void 0 } : { edGrp: void 0 }
	};
	tr.setNodeMarkup(pos, void 0, newAttrs);
	if (editor.view) editor.view.dispatch(tr);
	else editor.dispatch(tr);
	const updated = getAllRanges(editor).find((r$1) => r$1.id === id);
	if (updated) return {
		success: true,
		range: toRangeInfo(updated, editor.state.doc)
	};
	return {
		success: true,
		range: {
			id,
			principal,
			kind: "inline",
			start: pmPosToPosition(editor.state.doc, pos),
			end: pmPosToPosition(editor.state.doc, pos)
		}
	};
}
function setTrackChangesSkip(editor, tr) {
	try {
		const trackPlugin = editor.state.plugins.find((p$1) => p$1.key?.includes("trackChangesBase$"));
		if (trackPlugin) tr.setMeta(trackPlugin, { skip: true });
	} catch {}
}
function findMarkerPositions(editor, id) {
	let start$1 = null;
	let end$1 = null;
	const permStartTypes = new Set(["permStart", "permStartBlock"]);
	const permEndTypes = new Set(["permEnd", "permEndBlock"]);
	editor.state.doc.descendants((node, pos) => {
		if (start$1 && end$1) return false;
		const typeName = node.type.name;
		if (node.attrs?.id === id) {
			if (permStartTypes.has(typeName)) start$1 = {
				pos,
				nodeSize: node.nodeSize,
				node: { attrs: { ...node.attrs } }
			};
			else if (permEndTypes.has(typeName)) end$1 = {
				pos,
				nodeSize: node.nodeSize,
				node: { attrs: { ...node.attrs } }
			};
		}
		return true;
	});
	return {
		start: start$1,
		end: end$1
	};
}
function getConverterStore(editor) {
	return editor.converter ?? {};
}
function isLegacyFootnoteMap(value) {
	return value != null && typeof value === "object" && !Array.isArray(value);
}
function extractTextFromNode(node) {
	if (node == null) return "";
	if (typeof node === "string") return node;
	if (typeof node !== "object") return "";
	const candidate = node;
	if (typeof candidate.text === "string") return candidate.text;
	if (!Array.isArray(candidate.content)) return "";
	return candidate.content.map((child) => extractTextFromNode(child)).join("");
}
function extractTextFromContent(content) {
	if (typeof content === "string") return content;
	if (!Array.isArray(content)) return "";
	return content.map((node) => extractTextFromNode(node)).filter((text) => text.length > 0).join("\n");
}
function resolveCollectionContent(collection, noteId) {
	if (!collection) return "";
	if (Array.isArray(collection)) return extractTextFromContent(findNoteEntryById(collection, noteId)?.content);
	if (isLegacyFootnoteMap(collection)) return collection[noteId]?.content ?? "";
	return "";
}
function findAllFootnotes(doc$1, typeFilter) {
	const results = [];
	doc$1.descendants((node, pos) => {
		if (node.type.name === "footnoteReference") {
			if (!typeFilter || typeFilter === "footnote") {
				const noteId = String(node.attrs?.id ?? "");
				results.push({
					node,
					pos,
					noteId,
					type: "footnote"
				});
			}
		} else if (node.type.name === "endnoteReference") {
			if (!typeFilter || typeFilter === "endnote") {
				const noteId = String(node.attrs?.id ?? "");
				results.push({
					node,
					pos,
					noteId,
					type: "endnote"
				});
			}
		}
		return true;
	});
	return results;
}
function resolveFootnoteTarget(doc$1, target) {
	const found = findAllFootnotes(doc$1).find((f) => f.noteId === target.noteId);
	if (!found) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Footnote/endnote with noteId "${target.noteId}" not found.`);
	return found;
}
function resolveDisplayNumber$2(editor, resolved) {
	const store = getConverterStore(editor);
	const numberMap = resolved.type === "footnote" ? store.footnoteNumberById : store.endnoteNumberById;
	if (numberMap && numberMap[resolved.noteId] !== void 0) return String(numberMap[resolved.noteId]);
	return resolved.noteId;
}
function resolveContent(editor, resolved) {
	const store = getConverterStore(editor);
	return resolveCollectionContent(resolved.type === "footnote" ? store.footnotes : store.endnotes, resolved.noteId);
}
function extractFootnoteInfo(editor, resolved) {
	return {
		address: {
			kind: "entity",
			entityType: "footnote",
			noteId: resolved.noteId
		},
		type: resolved.type,
		noteId: resolved.noteId,
		displayNumber: resolveDisplayNumber$2(editor, resolved),
		content: resolveContent(editor, resolved)
	};
}
function buildFootnoteDiscoveryItem(editor, resolved, evaluatedRevision) {
	const domain = {
		address: {
			kind: "entity",
			entityType: "footnote",
			noteId: resolved.noteId
		},
		type: resolved.type,
		noteId: resolved.noteId,
		displayNumber: resolveDisplayNumber$2(editor, resolved),
		content: resolveContent(editor, resolved)
	};
	const handle = buildResolvedHandle(resolved.noteId, "stable", "node");
	return buildDiscoveryItem(`footnote:${resolved.noteId}:${evaluatedRevision}`, handle, domain);
}
function footnoteSuccess(address) {
	return {
		success: true,
		footnote: address
	};
}
function footnoteFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function configSuccess$1() {
	return { success: true };
}
function getConverter(editor) {
	const converter = editor.converter;
	if (!converter) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "converter not available.");
	return converter;
}
function toNonNegativeInteger(value) {
	const num = Number(value);
	if (!Number.isInteger(num) || !Number.isFinite(num) || num < 0) return null;
	return num;
}
function collectUsedNoteIds(editor, converter, type) {
	const used = /* @__PURE__ */ new Set();
	const config = getNotesConfig(type);
	for (const ref$1 of findAllFootnotes(editor.state.doc, type)) {
		const parsed = toNonNegativeInteger(ref$1.noteId);
		if (parsed != null) used.add(parsed);
	}
	const ooxmlPart = converter.convertedXml?.[config.partId];
	if (ooxmlPart) for (const el of getNoteElements(ooxmlPart, config.childElementName)) {
		const parsed = toNonNegativeInteger(el.attributes?.["w:id"]);
		if (parsed != null) used.add(parsed);
	}
	const cache$2 = converter[config.converterKey];
	if (Array.isArray(cache$2)) for (const entry of cache$2) {
		const parsed = toNonNegativeInteger(entry.id);
		if (parsed != null) used.add(parsed);
	}
	return used;
}
function allocateNextNoteId(editor, converter, type) {
	const used = collectUsedNoteIds(editor, converter, type);
	let candidate = 1;
	while (used.has(candidate)) candidate += 1;
	return String(candidate);
}
function footnotesListWrapper(editor, query) {
	const doc$1 = editor.state.doc;
	const revision = getRevision(editor);
	const { total, items: paged } = paginate(findAllFootnotes(doc$1, query?.type).map((f) => buildFootnoteDiscoveryItem(editor, f, revision)), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function footnotesGetWrapper(editor, input) {
	return extractFootnoteInfo(editor, resolveFootnoteTarget(editor.state.doc, input.target));
}
function footnotesInsertWrapper(editor, input, options) {
	rejectTrackedMode("footnotes.insert", options);
	checkRevision(editor, options?.expectedRevision);
	const converter = getConverter(editor);
	const notesConfig = getNotesConfig(input.type);
	const noteId = allocateNextNoteId(editor, converter, input.type);
	const address = {
		kind: "entity",
		entityType: "footnote",
		noteId
	};
	if (options?.dryRun) return footnoteSuccess(address);
	const nodeTypeName = input.type === "endnote" ? "endnoteReference" : "footnoteReference";
	const nodeType = editor.schema.nodes[nodeTypeName];
	if (!nodeType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", `footnotes.insert: node type "${nodeTypeName}" is not registered in the schema.`);
	const resolved = resolveInlineInsertPosition(editor, input.at, "footnotes.insert");
	const { success } = compoundMutation({
		editor,
		source: `footnotes.insert:${input.type}`,
		affectedParts: [notesConfig.partId],
		execute: () => {
			bootstrapNotesPart(editor, input.type);
			mutatePart({
				editor,
				partId: notesConfig.partId,
				operation: "mutate",
				source: `footnotes.insert:${input.type}`,
				mutate({ part }) {
					addNoteElement(part, notesConfig, noteId, input.content);
				}
			});
			const node = nodeType.create({ id: noteId });
			const { tr } = editor.state;
			tr.insert(resolved.from, node);
			editor.dispatch(tr);
			clearIndexCache(editor);
			return true;
		}
	});
	if (!success) return footnoteFailure("NO_OP", "Insert operation produced no change.");
	return footnoteSuccess(address);
}
function footnotesUpdateWrapper(editor, input, options) {
	rejectTrackedMode("footnotes.update", options);
	const resolved = resolveFootnoteTarget(editor.state.doc, input.target);
	const address = {
		kind: "entity",
		entityType: "footnote",
		noteId: resolved.noteId
	};
	if (options?.dryRun || input.patch.content === void 0) return footnoteSuccess(address);
	const notesConfig = getNotesConfig(resolved.type);
	mutatePart({
		editor,
		partId: notesConfig.partId,
		operation: "mutate",
		source: `footnotes.update:${resolved.type}`,
		expectedRevision: options?.expectedRevision,
		mutate({ part }) {
			updateNoteElement(part, notesConfig, resolved.noteId, input.patch.content);
		}
	});
	return footnoteSuccess(address);
}
function footnotesRemoveWrapper(editor, input, options) {
	rejectTrackedMode("footnotes.remove", options);
	checkRevision(editor, options?.expectedRevision);
	const resolved = resolveFootnoteTarget(editor.state.doc, input.target);
	const address = {
		kind: "entity",
		entityType: "footnote",
		noteId: resolved.noteId
	};
	if (options?.dryRun) return footnoteSuccess(address);
	const notesConfig = getNotesConfig(resolved.type);
	const { success } = compoundMutation({
		editor,
		source: `footnotes.remove:${resolved.type}`,
		affectedParts: [notesConfig.partId],
		execute: () => {
			const { tr } = editor.state;
			const node = tr.doc.nodeAt(resolved.pos);
			if (!node) return false;
			tr.delete(resolved.pos, resolved.pos + node.nodeSize);
			editor.dispatch(tr);
			if (!findAllFootnotes(editor.state.doc, resolved.type).some((f) => f.noteId === resolved.noteId)) mutatePart({
				editor,
				partId: notesConfig.partId,
				operation: "mutate",
				source: `footnotes.remove:${resolved.type}`,
				mutate({ part }) {
					removeNoteElement(part, notesConfig, resolved.noteId);
				}
			});
			clearIndexCache(editor);
			return true;
		}
	});
	if (!success) return footnoteFailure("NO_OP", "Remove operation produced no change.");
	return footnoteSuccess(address);
}
function footnotesConfigureWrapper(editor, input, options) {
	rejectTrackedMode("footnotes.configure", options);
	const prElementName = input.type === "endnote" ? "w:endnotePr" : "w:footnotePr";
	mutatePart({
		editor,
		partId: "word/settings.xml",
		operation: "mutate",
		source: `footnotes.configure:${input.type}`,
		dryRun: options?.dryRun,
		expectedRevision: options?.expectedRevision,
		mutate({ part }) {
			const root = part?.elements?.[0];
			if (!root) return;
			if (!root.elements) root.elements = [];
			const elements = root.elements;
			let prElement = elements.find((el) => el.name === prElementName);
			if (!prElement) {
				prElement = {
					type: "element",
					name: prElementName,
					elements: []
				};
				elements.push(prElement);
			}
			if (!prElement.elements) prElement.elements = [];
			if (!input.numbering) return;
			const setOrRemoveChild = (name, value) => {
				if (value === void 0) return;
				const children = prElement.elements;
				const existing = children.findIndex((el) => el.name === name);
				const newEl = {
					type: "element",
					name,
					attributes: { "w:val": value }
				};
				if (existing >= 0) children[existing] = newEl;
				else children.push(newEl);
			};
			setOrRemoveChild("w:numFmt", input.numbering.format);
			setOrRemoveChild("w:numStart", input.numbering.start !== void 0 ? String(input.numbering.start) : void 0);
			if (input.numbering.restartPolicy !== void 0) setOrRemoveChild("w:numRestart", RESTART_POLICY_TO_OOXML[input.numbering.restartPolicy] ?? input.numbering.restartPolicy);
			setOrRemoveChild("w:pos", input.numbering.position);
		}
	});
	if (!options?.dryRun && prElementName === "w:footnotePr") syncFootnotePropertiesCache(editor);
	return configSuccess$1();
}
function syncFootnotePropertiesCache(editor) {
	const converter = getConverter(editor);
	if (!converter?.footnoteProperties || converter.footnoteProperties.source !== "settings") return;
	const prElement = (((converter.convertedXml?.["word/settings.xml"])?.elements?.[0])?.elements ?? []).find((el) => el.name === "w:footnotePr");
	if (prElement) converter.footnoteProperties.originalXml = structuredClone(prElement);
	else converter.footnoteProperties = null;
}
var RESTART_POLICY_TO_OOXML = {
	continuous: "continuous",
	eachSection: "eachSect",
	eachPage: "eachPage"
};
function findAllCrossRefs(doc$1) {
	const results = [];
	doc$1.descendants((node, pos) => {
		if (node.type.name === "crossReference") results.push({
			node,
			pos,
			instruction: node.attrs?.instruction ?? "",
			target: node.attrs?.target ?? "",
			fieldType: node.attrs?.fieldType ?? "REF",
			display: node.attrs?.display ?? "content",
			resolvedText: node.attrs?.resolvedText ?? "",
			blockId: resolveParentBlockId$3(doc$1, pos)
		});
		return true;
	});
	return results;
}
function resolveCrossRefTarget(doc$1, target) {
	const found = findAllCrossRefs(doc$1).find((c) => {
		if (target.anchor?.start?.blockId && c.blockId !== target.anchor.start.blockId) return false;
		if (target.anchor?.start?.offset !== void 0) {
			const resolved = doc$1.resolve(c.pos);
			if (c.pos - resolved.start(resolved.depth) !== target.anchor.start.offset) return false;
		}
		return true;
	});
	if (!found) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Cross-reference not found at the specified anchor.");
	return found;
}
function extractCrossRefInfo(doc$1, resolved) {
	return {
		address: buildCrossRefAddress(doc$1, resolved),
		instruction: resolved.instruction,
		target: parseTarget(resolved),
		display: parseDisplay(resolved.display),
		resolvedText: resolved.resolvedText
	};
}
function buildCrossRefDiscoveryItem(doc$1, resolved, evaluatedRevision) {
	const domain = {
		address: buildCrossRefAddress(doc$1, resolved),
		instruction: resolved.instruction,
		target: parseTarget(resolved),
		display: parseDisplay(resolved.display),
		resolvedText: resolved.resolvedText
	};
	const ref$1 = `${resolved.blockId}:${resolved.pos}`;
	const handle = buildResolvedHandle(ref$1, "ephemeral", "node");
	return buildDiscoveryItem(`crossRef:${ref$1}:${evaluatedRevision}`, handle, domain);
}
var VALID_DISPLAYS = new Set([
	"content",
	"pageNumber",
	"noteNumber",
	"labelAndNumber",
	"aboveBelow",
	"numberOnly",
	"numberFullContext",
	"styledContent",
	"styledPageNumber"
]);
function parseTarget(resolved) {
	if (resolved.fieldType === "NOTEREF") return {
		kind: "note",
		noteId: resolved.target
	};
	if (resolved.fieldType === "STYLEREF") return {
		kind: "styledParagraph",
		styleName: resolved.target
	};
	return {
		kind: "bookmark",
		name: resolved.target
	};
}
function parseDisplay(raw) {
	if (VALID_DISPLAYS.has(raw)) return raw;
	return "content";
}
function resolveParentBlockId$3(doc$1, pos) {
	const resolved = doc$1.resolve(pos);
	for (let depth = resolved.depth; depth >= 0; depth--) {
		const blockId = resolved.node(depth).attrs?.sdBlockId;
		if (blockId) return blockId;
	}
	return "";
}
function buildCrossRefAddress(doc$1, resolved) {
	const r$1 = doc$1.resolve(resolved.pos);
	const offset$1 = resolved.pos - r$1.start(r$1.depth);
	return {
		kind: "inline",
		nodeType: "crossRef",
		anchor: {
			start: {
				blockId: resolved.blockId,
				offset: offset$1
			},
			end: {
				blockId: resolved.blockId,
				offset: offset$1 + resolved.node.nodeSize
			}
		}
	};
}
function crossRefSuccess(address) {
	return {
		success: true,
		crossRef: address
	};
}
function crossRefFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function receiptApplied$5(receipt) {
	return receipt.steps[0]?.effect === "changed";
}
function crossRefsListWrapper(editor, query) {
	const doc$1 = editor.state.doc;
	const revision = getRevision(editor);
	const { total, items: paged } = paginate(findAllCrossRefs(doc$1).map((c) => buildCrossRefDiscoveryItem(doc$1, c, revision)), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function crossRefsGetWrapper(editor, input) {
	const resolved = resolveCrossRefTarget(editor.state.doc, input.target);
	return extractCrossRefInfo(editor.state.doc, resolved);
}
function crossRefsInsertWrapper(editor, input, options) {
	rejectTrackedMode("crossRefs.insert", options);
	const dummyAddress = {
		kind: "inline",
		nodeType: "crossRef",
		anchor: {
			start: {
				blockId: "",
				offset: 0
			},
			end: {
				blockId: "",
				offset: 0
			}
		}
	};
	if (options?.dryRun) return crossRefSuccess(dummyAddress);
	const crossRefType = editor.schema.nodes.crossReference;
	if (!crossRefType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "crossRefs.insert: crossReference node type not in schema.");
	const resolved = resolveInlineInsertPosition(editor, input.at, "crossRefs.insert");
	if (!receiptApplied$5(executeDomainCommand(editor, () => {
		const instruction = buildRefInstruction(input);
		const targetName = extractTargetName(input.target);
		const node = crossRefType.create({
			instruction,
			target: targetName,
			fieldType: input.target.kind === "note" ? "NOTEREF" : input.target.kind === "styledParagraph" ? "STYLEREF" : "REF",
			display: input.display ?? "content",
			resolvedText: ""
		});
		const { tr } = editor.state;
		tr.insert(resolved.from, node);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return crossRefFailure("NO_OP", "Insert produced no change.");
	return crossRefSuccess(computeInlineAddress$1(editor.state.doc, resolved.from));
}
function crossRefsRebuildWrapper(editor, input, options) {
	rejectTrackedMode("crossRefs.rebuild", options);
	const resolved = resolveCrossRefTarget(editor.state.doc, input.target);
	const address = extractCrossRefInfo(editor.state.doc, resolved).address;
	if (options?.dryRun) return crossRefSuccess(address);
	return crossRefSuccess(address);
}
function crossRefsRemoveWrapper(editor, input, options) {
	rejectTrackedMode("crossRefs.remove", options);
	const resolved = resolveCrossRefTarget(editor.state.doc, input.target);
	const address = extractCrossRefInfo(editor.state.doc, resolved).address;
	if (options?.dryRun) return crossRefSuccess(address);
	if (!receiptApplied$5(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		tr.delete(resolved.pos, resolved.pos + resolved.node.nodeSize);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return crossRefFailure("NO_OP", "Remove produced no change.");
	return crossRefSuccess(address);
}
function computeInlineAddress$1(doc$1, pos) {
	const node = doc$1.nodeAt?.(pos);
	if (!node || typeof doc$1.resolve !== "function") return {
		kind: "inline",
		nodeType: "crossRef",
		anchor: {
			start: {
				blockId: "",
				offset: pos
			},
			end: {
				blockId: "",
				offset: pos + (node?.nodeSize ?? 1)
			}
		}
	};
	const r$1 = doc$1.resolve(pos);
	let blockId = "";
	for (let depth = r$1.depth; depth >= 0; depth--) {
		const bid = r$1.node(depth).attrs?.sdBlockId;
		if (bid) {
			blockId = bid;
			break;
		}
	}
	const offset$1 = pos - r$1.start(r$1.depth);
	return {
		kind: "inline",
		nodeType: "crossRef",
		anchor: {
			start: {
				blockId,
				offset: offset$1
			},
			end: {
				blockId,
				offset: offset$1 + node.nodeSize
			}
		}
	};
}
function extractTargetName(target) {
	switch (target.kind) {
		case "bookmark": return target.name;
		case "heading": return target.nodeId;
		case "note": return target.noteId;
		case "caption": return target.nodeId;
		case "numberedItem": return target.nodeId;
		case "styledParagraph": return target.styleName;
	}
}
function buildRefInstruction(input) {
	const targetName = extractTargetName(input.target);
	const parts = [input.target.kind === "note" ? "NOTEREF" : input.target.kind === "styledParagraph" ? "STYLEREF" : "REF", targetName];
	if (input.display === "pageNumber") parts.push("\\p");
	if (input.display === "aboveBelow") parts.push("\\p");
	if (input.display === "numberOnly") parts.push("\\n");
	if (input.display === "numberFullContext") parts.push("\\w");
	parts.push("\\h");
	return parts.join(" ");
}
var REFERENCE_BLOCK_PREFIX = {
	index: "index-auto",
	bibliography: "bibliography-auto",
	tableOfAuthorities: "toa-auto"
};
function stableHash(input) {
	let hash$3 = 2166136261;
	for (let index = 0; index < input.length; index += 1) {
		hash$3 ^= input.charCodeAt(index);
		hash$3 = Math.imul(hash$3, 16777619);
	}
	return (hash$3 >>> 0).toString(16).padStart(8, "0");
}
function toReferenceBlockType(node) {
	switch (node.type.name) {
		case "documentIndex":
		case "index": return "index";
		case "bibliography": return "bibliography";
		case "tableOfAuthorities": return "tableOfAuthorities";
		default: return;
	}
}
function resolvePublicReferenceBlockNodeId(node, occurrenceIndex) {
	const blockType = toReferenceBlockType(node);
	if (!blockType) throw new Error(`Unsupported reference block node type: ${node.type.name}`);
	return `${REFERENCE_BLOCK_PREFIX[blockType]}-${stableHash(`${blockType}:${occurrenceIndex}`)}`;
}
function findAllIndexNodes(doc$1) {
	const results = [];
	let occurrenceIndex = 0;
	doc$1.descendants((node, pos) => {
		if (node.type.name === "documentIndex" || node.type.name === "index") {
			const commandNodeId = node.attrs?.sdBlockId;
			const nodeId = resolvePublicReferenceBlockNodeId(node, occurrenceIndex);
			occurrenceIndex += 1;
			results.push({
				node,
				pos,
				nodeId,
				commandNodeId
			});
			return false;
		}
		return true;
	});
	return results;
}
function resolveIndexTarget(doc$1, target) {
	const found = findAllIndexNodes(doc$1).find((i) => i.nodeId === target.nodeId || i.commandNodeId === target.nodeId);
	if (!found) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Index with nodeId "${target.nodeId}" not found.`);
	return found;
}
function resolvePostMutationIndexId(doc$1, sdBlockId) {
	return findAllIndexNodes(doc$1).find((node) => node.commandNodeId === sdBlockId)?.nodeId ?? sdBlockId;
}
function extractIndexInfo(resolved) {
	const instruction = resolved.node.attrs?.instruction ?? "";
	return {
		address: {
			kind: "block",
			nodeType: "index",
			nodeId: resolved.nodeId
		},
		instruction,
		config: parseIndexInstruction(instruction),
		entryCount: resolved.node.childCount
	};
}
function buildIndexDiscoveryItem(resolved, evaluatedRevision) {
	const instruction = resolved.node.attrs?.instruction ?? "";
	const domain = {
		address: {
			kind: "block",
			nodeType: "index",
			nodeId: resolved.nodeId
		},
		instruction,
		config: parseIndexInstruction(instruction),
		entryCount: resolved.node.childCount
	};
	const handle = buildResolvedHandle(resolved.nodeId, "stable", "node");
	return buildDiscoveryItem(`index:${resolved.nodeId}:${evaluatedRevision}`, handle, domain);
}
function findAllIndexEntries(doc$1) {
	const results = [];
	doc$1.descendants((node, pos) => {
		if (node.type.name === "indexEntry") {
			const instruction = node.attrs?.instruction ?? "";
			const blockId = resolveParentBlockId$2(doc$1, pos);
			results.push({
				node,
				pos,
				instruction,
				blockId
			});
		}
		return true;
	});
	return results;
}
function resolveIndexEntryTarget(doc$1, target) {
	const found = findAllIndexEntries(doc$1).find((e) => {
		if (target.anchor?.start?.blockId && e.blockId !== target.anchor.start.blockId) return false;
		if (target.anchor?.start?.offset !== void 0) {
			const resolved = doc$1.resolve(e.pos);
			if (e.pos - resolved.start(resolved.depth) !== target.anchor.start.offset) return false;
		}
		return true;
	});
	if (!found) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Index entry not found at the specified anchor.");
	return found;
}
function extractIndexEntryInfo(doc$1, resolved) {
	const subEntry = resolved.node.attrs?.subEntry || void 0;
	return {
		address: buildEntryAddress$1(doc$1, resolved),
		instruction: resolved.instruction,
		text: extractPrimaryEntryText$1(resolved.node.attrs?.instructionTokens, resolved.instruction, subEntry),
		subEntry,
		bold: resolved.node.attrs?.bold ?? false,
		italic: resolved.node.attrs?.italic ?? false,
		crossReference: resolved.node.attrs?.crossReference || void 0,
		pageRangeBookmark: resolved.node.attrs?.pageRangeBookmark || void 0,
		entryType: resolved.node.attrs?.entryType || void 0
	};
}
function buildIndexEntryDiscoveryItem(doc$1, resolved, evaluatedRevision) {
	const subEntry = resolved.node.attrs?.subEntry || void 0;
	const domain = {
		address: buildEntryAddress$1(doc$1, resolved),
		instruction: resolved.instruction,
		text: extractPrimaryEntryText$1(resolved.node.attrs?.instructionTokens, resolved.instruction, subEntry),
		subEntry,
		bold: resolved.node.attrs?.bold ?? false,
		italic: resolved.node.attrs?.italic ?? false
	};
	const ref$1 = `${resolved.blockId}:${resolved.pos}`;
	const handle = buildResolvedHandle(ref$1, "ephemeral", "node");
	return buildDiscoveryItem(`indexEntry:${ref$1}:${evaluatedRevision}`, handle, domain);
}
function resolveParentBlockId$2(doc$1, pos) {
	const resolved = doc$1.resolve(pos);
	for (let depth = resolved.depth; depth >= 0; depth--) {
		const blockId = resolved.node(depth).attrs?.sdBlockId;
		if (blockId) return blockId;
	}
	return "";
}
function buildEntryAddress$1(doc$1, resolved) {
	const r$1 = doc$1.resolve(resolved.pos);
	const offset$1 = resolved.pos - r$1.start(r$1.depth);
	return {
		kind: "inline",
		nodeType: "indexEntry",
		anchor: {
			start: {
				blockId: resolved.blockId,
				offset: offset$1
			},
			end: {
				blockId: resolved.blockId,
				offset: offset$1 + resolved.node.nodeSize
			}
		}
	};
}
function extractPrimaryEntryText$1(instructionTokens, instruction, subEntry) {
	if (Array.isArray(instructionTokens) && instructionTokens.length > 0) {
		const rawTokenText = instructionTokens.map((token$1) => readInstructionTokenText$1(token$1)).filter((text) => text.length > 0).join("");
		if (rawTokenText) return removeTrailingSubEntry(parseXeInstructionEntryText$1(rawTokenText) || rawTokenText, subEntry);
	}
	return removeTrailingSubEntry(parseXeInstructionEntryText$1(instruction), subEntry);
}
function readInstructionTokenText$1(token$1) {
	if (typeof token$1 === "string") return token$1;
	if (!token$1 || typeof token$1 !== "object") return "";
	const tokenObject = token$1;
	if (tokenObject.type === "tab") return "	";
	return typeof tokenObject.text === "string" ? tokenObject.text : "";
}
function parseXeInstructionEntryText$1(instruction) {
	const xeMatch = instruction.match(/^\s*XE\s+"([^"]*)"/);
	if (!xeMatch) return "";
	return xeMatch[1] ?? "";
}
function removeTrailingSubEntry(text, subEntry) {
	if (!subEntry) return text;
	const suffix = `:${subEntry}`;
	if (!text.endsWith(suffix)) return text;
	return text.slice(0, -suffix.length);
}
function parseIndexInstruction(instruction) {
	const config = {};
	const h$2 = instruction.match(/\\h\s+"([^"]*)"/);
	if (h$2) config.headingSeparator = h$2[1];
	const e = instruction.match(/\\e\s+"([^"]*)"/);
	if (e) config.entryPageSeparator = e[1];
	const g$1 = instruction.match(/\\g\s+"([^"]*)"/);
	if (g$1) config.pageRangeSeparator = g$1[1];
	const s = instruction.match(/\\s\s+(\S+)/);
	if (s) config.sequenceId = s[1];
	const c = instruction.match(/\\c\s+(\d+)/);
	if (c) config.columns = parseInt(c[1], 10);
	const f = instruction.match(/\\f\s+"([^"]*)"/);
	if (f) config.entryTypeFilter = f[1];
	const b$1 = instruction.match(/\\b\s+"([^"]*)"/);
	if (b$1) config.pageRangeBookmark = b$1[1];
	const p$1 = instruction.match(/\\p\s+"([^"]*)-([^"]*)"/);
	if (p$1) config.letterRange = {
		from: p$1[1],
		to: p$1[2]
	};
	if (/\\r(?:\s|$)/.test(instruction)) config.runIn = true;
	if (/\\a(?:\s|$)/.test(instruction)) config.accentedSorting = true;
	return config;
}
function indexSuccess(address) {
	return {
		success: true,
		index: address
	};
}
function indexFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function entrySuccess$1(address) {
	return {
		success: true,
		entry: address
	};
}
function entryFailure$1(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function receiptApplied$4(receipt) {
	return receipt.steps[0]?.effect === "changed";
}
function indexListWrapper(editor, query) {
	const doc$1 = editor.state.doc;
	const revision = getRevision(editor);
	const { total, items: paged } = paginate(findAllIndexNodes(doc$1).map((n) => buildIndexDiscoveryItem(n, revision)), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function indexGetWrapper(editor, input) {
	return extractIndexInfo(resolveIndexTarget(editor.state.doc, input.target));
}
function indexInsertWrapper(editor, input, options) {
	rejectTrackedMode("index.insert", options);
	const requestedNodeId = `index-${Date.now()}`;
	const dryRunAddress = {
		kind: "block",
		nodeType: "index",
		nodeId: requestedNodeId
	};
	if (options?.dryRun) return indexSuccess(dryRunAddress);
	const indexType = editor.schema.nodes.documentIndex ?? editor.schema.nodes.index;
	if (!indexType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "index.insert: documentIndex node type not in schema.");
	const pos = resolveBlockCreatePosition(editor, input.at);
	if (!receiptApplied$4(executeDomainCommand(editor, () => {
		const instruction = buildIndexInstruction(input.config);
		const node = indexType.create({
			instruction,
			sdBlockId: requestedNodeId
		}, editor.schema.nodes.paragraph.create());
		const { tr } = editor.state;
		tr.insert(pos, node);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return indexFailure("NO_OP", "Insert produced no change.");
	return indexSuccess({
		kind: "block",
		nodeType: "index",
		nodeId: resolvePostMutationIndexId(editor.state.doc, requestedNodeId)
	});
}
function indexConfigureWrapper(editor, input, options) {
	rejectTrackedMode("index.configure", options);
	const resolved = resolveIndexTarget(editor.state.doc, input.target);
	const address = {
		kind: "block",
		nodeType: "index",
		nodeId: resolved.nodeId
	};
	if (options?.dryRun) return indexSuccess(address);
	const currentInstruction = resolved.node.attrs.instruction ?? "";
	const mergedConfig = { ...parseIndexInstruction(currentInstruction) };
	for (const [key, value] of Object.entries(input.patch)) if (value !== void 0) mergedConfig[key] = value;
	const newInstruction = buildIndexInstruction(mergedConfig);
	if (newInstruction === currentInstruction) return indexFailure("NO_OP", "Configuration patch produced no change.");
	if (!receiptApplied$4(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		const newAttrs = {
			...resolved.node.attrs,
			instruction: newInstruction
		};
		tr.setNodeMarkup(resolved.pos, void 0, newAttrs);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return indexFailure("NO_OP", "Configure produced no change.");
	return indexSuccess(address);
}
function indexRebuildWrapper(editor, input, options) {
	rejectTrackedMode("index.rebuild", options);
	const address = {
		kind: "block",
		nodeType: "index",
		nodeId: resolveIndexTarget(editor.state.doc, input.target).nodeId
	};
	if (options?.dryRun) return indexSuccess(address);
	return indexSuccess(address);
}
function indexRemoveWrapper(editor, input, options) {
	rejectTrackedMode("index.remove", options);
	const resolved = resolveIndexTarget(editor.state.doc, input.target);
	const address = {
		kind: "block",
		nodeType: "index",
		nodeId: resolved.nodeId
	};
	if (options?.dryRun) return indexSuccess(address);
	if (!receiptApplied$4(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		tr.delete(resolved.pos, resolved.pos + resolved.node.nodeSize);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return indexFailure("NO_OP", "Remove produced no change.");
	return indexSuccess(address);
}
function indexEntriesListWrapper(editor, query) {
	const doc$1 = editor.state.doc;
	const revision = getRevision(editor);
	const { total, items: paged } = paginate(findAllIndexEntries(doc$1).map((e) => buildIndexEntryDiscoveryItem(doc$1, e, revision)), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function indexEntriesGetWrapper(editor, input) {
	const resolved = resolveIndexEntryTarget(editor.state.doc, input.target);
	return extractIndexEntryInfo(editor.state.doc, resolved);
}
function indexEntriesInsertWrapper(editor, input, options) {
	rejectTrackedMode("index.entries.insert", options);
	const dummyAddress = {
		kind: "inline",
		nodeType: "indexEntry",
		anchor: {
			start: {
				blockId: "",
				offset: 0
			},
			end: {
				blockId: "",
				offset: 0
			}
		}
	};
	if (options?.dryRun) return entrySuccess$1(dummyAddress);
	const entryType = editor.schema.nodes.indexEntry;
	if (!entryType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "index.entries.insert: indexEntry node type not in schema.");
	const resolved = resolveInlineInsertPosition(editor, input.at, "index.entries.insert");
	const instruction = buildXeInstruction(input.entry);
	if (!receiptApplied$4(executeDomainCommand(editor, () => {
		const node = entryType.create({
			instruction,
			instructionTokens: null,
			bold: input.entry.bold ?? false,
			italic: input.entry.italic ?? false,
			subEntry: input.entry.subEntry ?? "",
			crossReference: input.entry.crossReference ?? "",
			pageRangeBookmark: input.entry.pageRangeBookmark ?? "",
			entryType: input.entry.entryType ?? "",
			yomi: input.entry.yomi ?? ""
		});
		const { tr } = editor.state;
		tr.insert(resolved.from, node);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return entryFailure$1("NO_OP", "Insert produced no change.");
	return entrySuccess$1(resolveInsertedIndexEntryAddress(editor.state.doc, resolved.from, instruction));
}
function indexEntriesUpdateWrapper(editor, input, options) {
	rejectTrackedMode("index.entries.update", options);
	const resolved = resolveIndexEntryTarget(editor.state.doc, input.target);
	const address = extractIndexEntryInfo(editor.state.doc, resolved).address;
	if (options?.dryRun) return entrySuccess$1(address);
	if (!receiptApplied$4(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		const newAttrs = { ...resolved.node.attrs };
		if (input.patch?.text !== void 0) {
			newAttrs.text = input.patch.text;
			newAttrs.instructionTokens = null;
		}
		if (input.patch?.subEntry !== void 0) newAttrs.subEntry = input.patch.subEntry;
		if (input.patch?.bold !== void 0) newAttrs.bold = input.patch.bold;
		if (input.patch?.italic !== void 0) newAttrs.italic = input.patch.italic;
		if (input.patch?.crossReference !== void 0) newAttrs.crossReference = input.patch.crossReference;
		if (input.patch?.pageRangeBookmark !== void 0) newAttrs.pageRangeBookmark = input.patch.pageRangeBookmark;
		if (input.patch?.entryType !== void 0) newAttrs.entryType = input.patch.entryType;
		if (input.patch?.yomi !== void 0) newAttrs.yomi = input.patch.yomi;
		newAttrs.instruction = buildXeInstructionFromAttrs(newAttrs);
		newAttrs.instructionTokens = null;
		tr.setNodeMarkup(resolved.pos, void 0, newAttrs);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return entryFailure$1("NO_OP", "Update produced no change.");
	return entrySuccess$1(address);
}
function indexEntriesRemoveWrapper(editor, input, options) {
	rejectTrackedMode("index.entries.remove", options);
	const resolved = resolveIndexEntryTarget(editor.state.doc, input.target);
	const address = extractIndexEntryInfo(editor.state.doc, resolved).address;
	if (options?.dryRun) return entrySuccess$1(address);
	if (!receiptApplied$4(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		tr.delete(resolved.pos, resolved.pos + resolved.node.nodeSize);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return entryFailure$1("NO_OP", "Remove produced no change.");
	return entrySuccess$1(address);
}
function computeInlineEntryAddress$1(doc$1, pos) {
	const node = doc$1.nodeAt?.(pos);
	if (!node || typeof doc$1.resolve !== "function") return {
		kind: "inline",
		nodeType: "indexEntry",
		anchor: {
			start: {
				blockId: "",
				offset: pos
			},
			end: {
				blockId: "",
				offset: pos + (node?.nodeSize ?? 1)
			}
		}
	};
	const r$1 = doc$1.resolve(pos);
	let blockId = "";
	for (let depth = r$1.depth; depth >= 0; depth--) {
		const bid = r$1.node(depth).attrs?.sdBlockId;
		if (bid) {
			blockId = bid;
			break;
		}
	}
	const offset$1 = pos - r$1.start(r$1.depth);
	return {
		kind: "inline",
		nodeType: "indexEntry",
		anchor: {
			start: {
				blockId,
				offset: offset$1
			},
			end: {
				blockId,
				offset: offset$1 + node.nodeSize
			}
		}
	};
}
function resolveInsertedIndexEntryAddress(doc$1, preferredPos, instruction) {
	if ((doc$1.nodeAt?.(preferredPos))?.type?.name === "indexEntry") return computeInlineEntryAddress$1(doc$1, preferredPos);
	const instructionMatchedPositions = [];
	const allEntryPositions = [];
	doc$1.descendants?.((node, pos) => {
		if (node.type?.name !== "indexEntry") return true;
		allEntryPositions.push(pos);
		if ((node.attrs?.instruction ?? "") === instruction) instructionMatchedPositions.push(pos);
		return true;
	});
	const candidates = instructionMatchedPositions.length > 0 ? instructionMatchedPositions : allEntryPositions;
	if (candidates.length === 0) return computeInlineEntryAddress$1(doc$1, preferredPos);
	return computeInlineEntryAddress$1(doc$1, candidates.reduce((bestPos, candidatePos) => {
		const bestDistance = Math.abs(bestPos - preferredPos);
		return Math.abs(candidatePos - preferredPos) < bestDistance ? candidatePos : bestPos;
	}));
}
function buildXeInstruction(entry) {
	let text = entry.text ?? "";
	if (entry.subEntry) text += `:${entry.subEntry}`;
	const parts = [`XE "${text}"`];
	if (entry.bold) parts.push("\\b");
	if (entry.italic) parts.push("\\i");
	if (entry.crossReference) parts.push(`\\t "${entry.crossReference}"`);
	if (entry.pageRangeBookmark) parts.push(`\\r "${entry.pageRangeBookmark}"`);
	if (entry.entryType) parts.push(`\\f "${entry.entryType}"`);
	if (entry.yomi) parts.push(`\\y "${entry.yomi}"`);
	return parts.join(" ");
}
function buildXeInstructionFromAttrs(attrs) {
	let text = typeof attrs.text === "string" ? attrs.text : extractPrimaryEntryText(attrs);
	const subEntry = attrs.subEntry ?? "";
	if (subEntry && text.endsWith(`:${subEntry}`)) text = text.slice(0, -(subEntry.length + 1));
	if (subEntry) text += `:${subEntry}`;
	const parts = [`XE "${text}"`];
	if (attrs.bold) parts.push("\\b");
	if (attrs.italic) parts.push("\\i");
	const crossRef = attrs.crossReference ?? "";
	if (crossRef) parts.push(`\\t "${crossRef}"`);
	const prb = attrs.pageRangeBookmark ?? "";
	if (prb) parts.push(`\\r "${prb}"`);
	const et = attrs.entryType ?? "";
	if (et) parts.push(`\\f "${et}"`);
	const yomi = attrs.yomi ?? "";
	if (yomi) parts.push(`\\y "${yomi}"`);
	return parts.join(" ");
}
function extractPrimaryEntryText(attrs) {
	const instructionTokens = attrs.instructionTokens;
	if (Array.isArray(instructionTokens) && instructionTokens.length > 0) {
		const rawTokenText = instructionTokens.map((token$1) => readInstructionTokenText(token$1)).filter((text) => text.length > 0).join("");
		if (rawTokenText) {
			const parsedFromTokens = parseXeInstructionEntryText(rawTokenText);
			if (parsedFromTokens) return parsedFromTokens;
			return rawTokenText;
		}
	}
	return parseXeInstructionEntryText(attrs.instruction ?? "");
}
function readInstructionTokenText(token$1) {
	if (typeof token$1 === "string") return token$1;
	if (!token$1 || typeof token$1 !== "object") return "";
	const tokenObject = token$1;
	if (tokenObject.type === "tab") return "	";
	return typeof tokenObject.text === "string" ? tokenObject.text : "";
}
function parseXeInstructionEntryText(instruction) {
	const xeMatch = instruction.match(/^\s*XE\s+"([^"]*)"/);
	if (!xeMatch) return "";
	return xeMatch[1] ?? "";
}
function buildIndexInstruction(config) {
	const parts = ["INDEX"];
	if (!config) return parts[0] + " \\h \"A\"";
	if (config.headingSeparator !== void 0) parts.push(`\\h "${config.headingSeparator}"`);
	if (config.entryPageSeparator !== void 0) parts.push(`\\e "${config.entryPageSeparator}"`);
	if (config.pageRangeSeparator !== void 0) parts.push(`\\g "${config.pageRangeSeparator}"`);
	if (config.sequenceId !== void 0) parts.push(`\\s ${config.sequenceId}`);
	if (config.columns !== void 0) parts.push(`\\c ${config.columns}`);
	if (config.entryTypeFilter !== void 0) parts.push(`\\f "${config.entryTypeFilter}"`);
	if (config.pageRangeBookmark !== void 0) parts.push(`\\b "${config.pageRangeBookmark}"`);
	if (config.letterRange) parts.push(`\\p "${config.letterRange.from}-${config.letterRange.to}"`);
	if (config.runIn) parts.push("\\r");
	if (config.accentedSorting) parts.push("\\a");
	return parts.length > 1 ? parts.join(" ") : "INDEX \\h \"A\"";
}
var CAPTION_STYLE_NAMES = new Set(["Caption", "caption"]);
function hasCaptionStyle(node) {
	const paragraphProperties = node.attrs?.paragraphProperties ?? {};
	return [
		node.attrs?.styleName,
		node.attrs?.styleId,
		paragraphProperties.styleName,
		paragraphProperties.styleId
	].some((candidate) => typeof candidate === "string" && CAPTION_STYLE_NAMES.has(candidate));
}
function isCaptionParagraph(node) {
	if (node.type.name !== "paragraph") return false;
	if (hasCaptionStyle(node)) return true;
	const seqField = findSeqField(node);
	if (!seqField) return false;
	return isSeqInstruction(seqField.attrs?.instruction ?? "");
}
function findSeqField(node) {
	let seqNode = null;
	node.descendants((child) => {
		if (child.type.name === "sequenceField" && !seqNode) {
			seqNode = child;
			return false;
		}
		return true;
	});
	return seqNode;
}
function findAllCaptions(doc$1) {
	const results = [];
	doc$1.descendants((node, pos) => {
		if (!isCaptionParagraph(node)) return true;
		const seqField = findSeqField(node);
		const nodeId = node.attrs?.sdBlockId ?? `caption-${pos}`;
		const label = seqField ? seqField.attrs?.identifier ?? "" : "";
		const number = seqField ? seqField.attrs?.resolvedNumber ?? "" : "";
		const instruction = seqField ? seqField.attrs?.instruction ?? "" : "";
		let text = "";
		try {
			text = node.textContent ?? "";
		} catch {
			text = "";
		}
		results.push({
			node,
			pos,
			nodeId,
			label,
			number,
			text,
			instruction
		});
		return false;
	});
	return results;
}
function resolveCaptionTarget(doc$1, target) {
	const found = findAllCaptions(doc$1).find((c) => c.nodeId === target.nodeId);
	if (!found) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Caption with nodeId "${target.nodeId}" not found.`);
	return found;
}
function extractCaptionInfo(resolved) {
	return {
		address: {
			kind: "block",
			nodeType: "paragraph",
			nodeId: resolved.nodeId
		},
		label: resolved.label,
		number: parseInt(resolved.number, 10) || 0,
		text: resolved.text,
		instruction: resolved.instruction
	};
}
function buildCaptionDiscoveryItem(resolved, evaluatedRevision) {
	const domain = {
		address: {
			kind: "block",
			nodeType: "paragraph",
			nodeId: resolved.nodeId
		},
		label: resolved.label,
		number: parseInt(resolved.number, 10) || 0,
		text: resolved.text,
		instruction: resolved.instruction
	};
	const handle = buildResolvedHandle(resolved.nodeId, "stable", "node");
	return buildDiscoveryItem(`caption:${resolved.nodeId}:${evaluatedRevision}`, handle, domain);
}
function captionSuccess(address) {
	return {
		success: true,
		caption: address
	};
}
function captionFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function configSuccess() {
	return { success: true };
}
function configFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function receiptApplied$3(receipt) {
	return receipt.steps[0]?.effect === "changed";
}
var CAPTION_PARAGRAPH_STYLE_ID = "Caption";
function buildCaptionParagraphAttrs(nodeId) {
	return {
		sdBlockId: nodeId,
		paragraphProperties: { styleId: CAPTION_PARAGRAPH_STYLE_ID }
	};
}
function captionsListWrapper(editor, query) {
	const doc$1 = editor.state.doc;
	const revision = getRevision(editor);
	const { total, items: paged } = paginate(findAllCaptions(doc$1).map((c) => buildCaptionDiscoveryItem(c, revision)), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function captionsGetWrapper(editor, input) {
	return extractCaptionInfo(resolveCaptionTarget(editor.state.doc, input.target));
}
function captionsInsertWrapper(editor, input, options) {
	rejectTrackedMode("captions.insert", options);
	const nodeId = `caption-${Date.now()}`;
	const address = {
		kind: "block",
		nodeType: "paragraph",
		nodeId
	};
	if (options?.dryRun) return captionSuccess(address);
	const pos = resolveBlockCreatePosition(editor, input.position === "above" ? {
		kind: "before",
		target: input.adjacentTo
	} : {
		kind: "after",
		target: input.adjacentTo
	});
	if (!receiptApplied$3(executeDomainCommand(editor, () => {
		const label = input.label;
		const children = [];
		const schema = editor.schema;
		children.push(schema.text(`${label} `));
		if (schema.nodes.sequenceField) {
			const instruction = `SEQ ${label} \\* ARABIC`;
			const parsed = parseSeqInstruction(instruction);
			children.push(schema.nodes.sequenceField.create({
				instruction,
				...sequenceFieldAttrsFromParsed(parsed),
				resolvedNumber: "",
				resolvedNumberIsCurrent: false,
				sdBlockId: `seq-${Date.now()}`
			}));
		}
		if (input.text) {
			const captionContent = buildTextWithTabs(schema, `: ${input.text}`, void 0);
			if (captionContent instanceof Fragment$1) captionContent.forEach((child) => children.push(child));
			else children.push(captionContent);
		}
		const captionParagraph = schema.nodes.paragraph.create(buildCaptionParagraphAttrs(nodeId), children);
		const { tr } = editor.state;
		tr.insert(pos, captionParagraph);
		updateSequenceFieldsInTransaction({
			tr,
			schema,
			scope: {
				kind: "identifier",
				identifier: label
			},
			converterContext: getSequenceFieldUpdaterConverterContext(editor)
		});
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return captionFailure("NO_OP", "Insert produced no change.");
	return captionSuccess(address);
}
function captionsUpdateWrapper(editor, input, options) {
	rejectTrackedMode("captions.update", options);
	const resolved = resolveCaptionTarget(editor.state.doc, input.target);
	const address = {
		kind: "block",
		nodeType: "paragraph",
		nodeId: resolved.nodeId
	};
	if (options?.dryRun) return captionSuccess(address);
	if (input.patch.text === void 0) return captionFailure("NO_OP", "No patch fields provided.");
	if (!receiptApplied$3(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		const captionNode = tr.doc.nodeAt(resolved.pos);
		if (!captionNode) return false;
		let trailingTextStart = resolved.pos + 1;
		captionNode.forEach((child, offset$1) => {
			if (child.type.name !== "text") trailingTextStart = resolved.pos + 1 + offset$1 + child.nodeSize;
		});
		const contentEnd = resolved.pos + captionNode.nodeSize - 1;
		const newText = input.patch.text ? `: ${input.patch.text}` : "";
		if (newText) tr.replaceWith(trailingTextStart, contentEnd, buildTextWithTabs(editor.schema, newText, void 0));
		else tr.delete(trailingTextStart, contentEnd);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return captionFailure("NO_OP", "Update produced no change.");
	return captionSuccess(address);
}
function captionsRemoveWrapper(editor, input, options) {
	rejectTrackedMode("captions.remove", options);
	const resolved = resolveCaptionTarget(editor.state.doc, input.target);
	const address = {
		kind: "block",
		nodeType: "paragraph",
		nodeId: resolved.nodeId
	};
	if (options?.dryRun) return captionSuccess(address);
	if (!receiptApplied$3(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		tr.delete(resolved.pos, resolved.pos + resolved.node.nodeSize);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return captionFailure("NO_OP", "Remove produced no change.");
	return captionSuccess(address);
}
function captionsConfigureWrapper(editor, input, options) {
	rejectTrackedMode("captions.configure", options);
	if (options?.dryRun) return configSuccess();
	if (!receiptApplied$3(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		let changed = false;
		tr.doc.descendants((node, pos) => {
			if (node.type.name !== "sequenceField") return true;
			if (node.attrs.identifier !== input.label) return true;
			const format = CAPTION_FORMAT_TO_OOXML[input.format ?? "decimal"] ?? "ARABIC";
			const newInstruction = `SEQ ${input.label} \\* ${format}`;
			const parsedAttrs = sequenceFieldAttrsFromParsed(parseSeqInstruction(newInstruction));
			if (node.attrs.instruction === newInstruction && node.attrs.format === format && JSON.stringify(node.attrs.pageNumberFieldFormat) === JSON.stringify(parsedAttrs.pageNumberFieldFormat)) return true;
			tr.setNodeMarkup(tr.mapping.map(pos), void 0, {
				...node.attrs,
				instruction: newInstruction,
				...parsedAttrs,
				resolvedNumberIsCurrent: false
			});
			changed = true;
			return true;
		});
		if (!changed) return false;
		updateSequenceFieldsInTransaction({
			tr,
			schema: editor.schema,
			scope: {
				kind: "identifier",
				identifier: input.label
			},
			converterContext: getSequenceFieldUpdaterConverterContext(editor)
		});
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return configFailure("NO_OP", "Configure produced no change.");
	return configSuccess();
}
var CAPTION_FORMAT_TO_OOXML = {
	decimal: "ARABIC",
	lowerRoman: "roman",
	upperRoman: "ROMAN",
	lowerLetter: "alphabetic",
	upperLetter: "ALPHABETIC"
};
function fieldSuccess(address) {
	return {
		success: true,
		field: address
	};
}
function fieldFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function receiptApplied$2(receipt) {
	return receipt.steps[0]?.effect === "changed";
}
function fieldsListWrapper(editor, query) {
	const doc$1 = editor.state.doc;
	const revision = getRevision(editor);
	const { total, items: paged } = paginate(findAllFields(doc$1).map((f) => buildFieldDiscoveryItem(f, revision)), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function fieldsGetWrapper(editor, input) {
	return extractFieldInfo(resolveFieldTarget(editor.state.doc, input.target));
}
var DOCUMENT_STAT_FIELD_TYPES = new Set(["NUMWORDS", "NUMCHARS"]);
function fieldsInsertWrapper(editor, input, options) {
	rejectTrackedMode("fields.insert", options);
	if (input.mode !== "raw") throw new DocumentApiAdapterError("INVALID_INPUT", "fields.insert requires mode: \"raw\".");
	const address = {
		kind: "field",
		blockId: "",
		occurrenceIndex: 0,
		nestingDepth: 0
	};
	if (options?.dryRun) return fieldSuccess(address);
	const fieldType = extractFieldType(input.instruction);
	const resolved = resolveInlineInsertPosition(editor, input.at, "fields.insert");
	if (DOCUMENT_STAT_FIELD_TYPES.has(fieldType)) return insertDocumentStatField(editor, input, resolved, options);
	if (fieldType === "NUMPAGES") return insertNumPagesField(editor, input, resolved, options);
	if (fieldType === "SECTIONPAGES") return insertSectionPagesField(editor, input, resolved, options);
	return insertRawField(editor, input, resolved, options);
}
function insertDocumentStatField(editor, input, resolved, options) {
	const nodeType = editor.schema.nodes.documentStatField;
	if (!nodeType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "fields.insert: documentStatField node type not in schema.");
	const stats = getWordStatistics(resolveMainBodyEditor(editor));
	const initialValue = resolveDocumentStatFieldValue(extractFieldType(input.instruction), stats) ?? "";
	if (!receiptApplied$2(executeDomainCommand(editor, () => {
		const node = nodeType.create({
			instruction: input.instruction,
			resolvedText: initialValue,
			sdBlockId: `field-${Date.now()}`
		});
		const { tr } = editor.state;
		tr.insert(resolved.from, node);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return fieldFailure("NO_OP", "Insert produced no change.");
	return fieldSuccess(computeFieldAddress(editor.state.doc, resolved.from));
}
function insertNumPagesField(editor, input, resolved, options) {
	if (!Boolean(editor.options?.isHeaderOrFooter)) return fieldFailure("INVALID_INPUT", "fields.insert: NUMPAGES insertion is only supported in headers/footers.");
	const nodeType = editor.schema.nodes["total-page-number"];
	if (!nodeType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "fields.insert: total-page-number node type not in schema.");
	const parsedInstruction = parsePageNumberFieldSwitches(input.instruction, "NUMPAGES");
	if (!receiptApplied$2(executeDomainCommand(editor, () => {
		const node = nodeType.create(parsedInstruction);
		const { tr } = editor.state;
		tr.insert(resolved.from, node);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return fieldFailure("NO_OP", "Insert produced no change.");
	return fieldSuccess(computeFieldAddress(editor.state.doc, resolved.from));
}
function insertSectionPagesField(editor, input, resolved, options) {
	const nodeType = editor.schema.nodes["section-page-count"];
	if (!nodeType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "fields.insert: section-page-count node type not in schema.");
	const normalizedInstruction = input.instruction.trim().replace(/\s+/g, " ");
	const parsedInstruction = parsePageNumberFieldSwitches(normalizedInstruction, "SECTIONPAGES");
	const initialAttrs = {
		instruction: normalizedInstruction,
		...parsedInstruction.pageNumberFormat ? { pageNumberFormat: parsedInstruction.pageNumberFormat } : {},
		...parsedInstruction.pageNumberZeroPadding != null ? { pageNumberZeroPadding: parsedInstruction.pageNumberZeroPadding } : {}
	};
	const initialValue = resolveSectionPageCountFieldValue(editor, { attrs: initialAttrs }) ?? "";
	if (!receiptApplied$2(executeDomainCommand(editor, () => {
		const textChild = initialValue ? editor.schema.text(initialValue) : null;
		const node = nodeType.create({
			...initialAttrs,
			...initialValue ? { resolvedText: initialValue } : {}
		}, textChild);
		const { tr } = editor.state;
		tr.insert(resolved.from, node);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return fieldFailure("NO_OP", "Insert produced no change.");
	return fieldSuccess(computeFieldAddress(editor.state.doc, resolved.from));
}
function insertRawField(editor, input, resolved, options) {
	const fieldNodeType = editor.schema.nodes.sequenceField;
	if (!fieldNodeType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "fields.insert: sequenceField node type not in schema.");
	if (!receiptApplied$2(executeDomainCommand(editor, () => {
		const fieldType = extractFieldType(input.instruction);
		const parsed = isSeqInstruction(input.instruction) ? parseSeqInstruction(input.instruction) : null;
		const node = fieldNodeType.create(parsed ? {
			instruction: input.instruction,
			...sequenceFieldAttrsFromParsed(parsed),
			resolvedNumber: "",
			resolvedNumberIsCurrent: false,
			sdBlockId: `field-${Date.now()}`
		} : {
			instruction: input.instruction,
			identifier: fieldType,
			format: "ARABIC",
			resolvedNumber: "",
			sdBlockId: `field-${Date.now()}`
		});
		const { tr } = editor.state;
		tr.insert(resolved.from, node);
		if (parsed) updateSequenceFieldsInTransaction({
			tr,
			schema: editor.schema,
			scope: {
				kind: "identifier",
				identifier: parsed.identifier
			},
			converterContext: getSequenceFieldUpdaterConverterContext(editor)
		});
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return fieldFailure("NO_OP", "Insert produced no change.");
	return fieldSuccess(computeFieldAddress(editor.state.doc, resolved.from));
}
function fieldsRebuildWrapper(editor, input, options) {
	rejectTrackedMode("fields.rebuild", options);
	const resolved = resolveFieldTarget(editor.state.doc, input.target);
	const address = {
		kind: "field",
		blockId: resolved.blockId,
		occurrenceIndex: resolved.occurrenceIndex,
		nestingDepth: resolved.nestingDepth
	};
	if (options?.dryRun) return fieldSuccess(address);
	const node = editor.state.doc.nodeAt(resolved.pos);
	if (!node) return fieldFailure("TARGET_NOT_FOUND", "Node not found at resolved position.");
	if (node.type.name === "documentStatField") return rebuildDocumentStatField(editor, resolved, address, options);
	if (node.type.name === "total-page-number") return rebuildTotalPageNumber(editor, resolved, address, options);
	if (node.type.name === "section-page-count") return rebuildSectionPageCount(editor, resolved, address, options);
	if (node.type.name === "sequenceField" && isSeqInstruction(node.attrs?.instruction ?? "")) return rebuildSequenceFields(editor, address, options);
	if (!receiptApplied$2(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		const currentNode = tr.doc.nodeAt(resolved.pos);
		if (!currentNode) return false;
		tr.setNodeMarkup(resolved.pos, void 0, {
			...currentNode.attrs,
			resolvedNumber: ""
		});
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return fieldFailure("NO_OP", "Rebuild produced no change.");
	return fieldSuccess(address);
}
function rebuildSequenceFields(editor, address, options) {
	executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		if (updateSequenceFieldsInTransaction({
			tr,
			schema: editor.schema,
			scope: { kind: "all" },
			converterContext: getSequenceFieldUpdaterConverterContext(editor)
		}).changed) {
			editor.dispatch(tr);
			clearIndexCache(editor);
		}
		return true;
	}, { expectedRevision: options?.expectedRevision });
	return fieldSuccess(address);
}
function rebuildDocumentStatField(editor, resolved, address, options) {
	const stats = getWordStatistics(resolveMainBodyEditor(editor));
	const node = editor.state.doc.nodeAt(resolved.pos);
	if (!node) return fieldFailure("TARGET_NOT_FOUND", "Node not found.");
	const freshValue = resolveDocumentStatFieldValue(extractFieldType(node.attrs?.instruction ?? ""), stats) ?? "";
	if (!receiptApplied$2(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		const currentNode = tr.doc.nodeAt(resolved.pos);
		if (!currentNode) return false;
		tr.setNodeMarkup(resolved.pos, void 0, {
			...currentNode.attrs,
			resolvedText: freshValue
		});
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return fieldFailure("NO_OP", "Rebuild produced no change.");
	return fieldSuccess(address);
}
function rebuildTotalPageNumber(editor, resolved, address, options) {
	const stats = getWordStatistics(resolveMainBodyEditor(editor));
	if (stats.pages == null) return fieldSuccess(address);
	const node = editor.state.doc.nodeAt(resolved.pos);
	if (!node) return fieldFailure("TARGET_NOT_FOUND", "Node not found.");
	const freshValue = formatPageNumberFieldValue(stats.pages, getPageNumberFieldFormat(node.attrs));
	if (!receiptApplied$2(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		const currentNode = tr.doc.nodeAt(resolved.pos);
		if (!currentNode) return false;
		const textChild = freshValue ? editor.schema.text(freshValue) : null;
		const newNode = currentNode.type.create({
			...currentNode.attrs,
			resolvedText: freshValue
		}, textChild);
		tr.replaceWith(resolved.pos, resolved.pos + currentNode.nodeSize, newNode);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return fieldFailure("NO_OP", "Rebuild produced no change.");
	return fieldSuccess(address);
}
function rebuildSectionPageCount(editor, resolved, address, options) {
	const node = editor.state.doc.nodeAt(resolved.pos);
	if (!node) return fieldFailure("TARGET_NOT_FOUND", "Node not found.");
	const freshValue = resolveSectionPageCountFieldValue(editor, node);
	if (freshValue == null) return fieldSuccess(address);
	if (!receiptApplied$2(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		const currentNode = tr.doc.nodeAt(resolved.pos);
		if (!currentNode) return false;
		const textChild = freshValue ? editor.schema.text(freshValue) : null;
		const newNode = currentNode.type.create({
			...currentNode.attrs,
			resolvedText: freshValue
		}, textChild);
		tr.replaceWith(resolved.pos, resolved.pos + currentNode.nodeSize, newNode);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return fieldFailure("NO_OP", "Rebuild produced no change.");
	return fieldSuccess(address);
}
function fieldsRemoveWrapper(editor, input, options) {
	rejectTrackedMode("fields.remove", options);
	if (input.mode !== "raw") throw new DocumentApiAdapterError("INVALID_INPUT", "fields.remove requires mode: \"raw\".");
	const resolved = resolveFieldTarget(editor.state.doc, input.target);
	const address = {
		kind: "field",
		blockId: resolved.blockId,
		occurrenceIndex: resolved.occurrenceIndex,
		nestingDepth: resolved.nestingDepth
	};
	if (options?.dryRun) return fieldSuccess(address);
	if (!receiptApplied$2(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		const node = tr.doc.nodeAt(resolved.pos);
		if (!node) return false;
		tr.delete(resolved.pos, resolved.pos + node.nodeSize);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return fieldFailure("NO_OP", "Remove produced no change.");
	return fieldSuccess(address);
}
function computeFieldAddress(doc$1, pos) {
	if (!doc$1.nodeAt?.(pos) || typeof doc$1.resolve !== "function") return {
		kind: "field",
		blockId: "",
		occurrenceIndex: 0,
		nestingDepth: 0
	};
	const r$1 = doc$1.resolve(pos);
	let blockId = "";
	for (let depth = r$1.depth; depth >= 0; depth--) {
		const bid = r$1.node(depth).attrs?.sdBlockId;
		if (bid) {
			blockId = bid;
			break;
		}
	}
	const blockStart = r$1.start(r$1.depth);
	let occurrenceIndex = 0;
	doc$1.nodesBetween(blockStart, pos, (n) => {
		if (n.attrs?.instruction && n !== doc$1) occurrenceIndex++;
		return true;
	});
	return {
		kind: "field",
		blockId,
		occurrenceIndex,
		nestingDepth: 0
	};
}
function extractFieldType(instruction) {
	const trimmed = instruction.trim();
	const firstSpace = trimmed.indexOf(" ");
	return firstSpace > 0 ? trimmed.slice(0, firstSpace).toUpperCase() : trimmed.toUpperCase();
}
function findAllCitations(doc$1) {
	const results = [];
	doc$1.descendants((node, pos) => {
		if (node.type.name === "citation") results.push({
			node,
			pos,
			sourceIds: node.attrs?.sourceIds ?? [],
			locale: node.attrs?.locale ?? null,
			resolvedText: node.attrs?.resolvedText ?? "",
			blockId: resolveParentBlockId$1(doc$1, pos)
		});
		return true;
	});
	return results;
}
function resolveCitationTarget(doc$1, target) {
	const found = findAllCitations(doc$1).find((c) => {
		if (target.anchor?.start?.blockId && c.blockId !== target.anchor.start.blockId) return false;
		if (target.anchor?.start?.offset !== void 0) {
			const resolved = doc$1.resolve(c.pos);
			if (c.pos - resolved.start(resolved.depth) !== target.anchor.start.offset) return false;
		}
		return true;
	});
	if (!found) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Citation not found at the specified anchor.");
	return found;
}
function extractCitationInfo(doc$1, resolved) {
	const instruction = resolved.node.attrs?.instruction ?? "";
	return {
		address: buildCitationAddress(doc$1, resolved),
		sourceIds: resolved.sourceIds,
		displayText: resolved.resolvedText,
		instruction
	};
}
function buildCitationDiscoveryItem(doc$1, resolved, evaluatedRevision) {
	const address = buildCitationAddress(doc$1, resolved);
	const instruction = resolved.node.attrs?.instruction ?? "";
	const domain = {
		address,
		sourceIds: resolved.sourceIds,
		displayText: resolved.resolvedText,
		instruction
	};
	const ref$1 = `${resolved.blockId}:${resolved.pos}`;
	const handle = buildResolvedHandle(ref$1, "ephemeral", "node");
	return buildDiscoveryItem(`citation:${ref$1}:${evaluatedRevision}`, handle, domain);
}
function findAllBibliographies(doc$1) {
	const results = [];
	let occurrenceIndex = 0;
	doc$1.descendants((node, pos) => {
		if (node.type.name === "bibliography") {
			const rawBlockId = node.attrs?.sdBlockId;
			const commandNodeId = rawBlockId != null ? String(rawBlockId) : void 0;
			const nodeId = resolvePublicReferenceBlockNodeId(node, occurrenceIndex);
			occurrenceIndex += 1;
			results.push({
				node,
				pos,
				nodeId,
				commandNodeId
			});
			return false;
		}
		return true;
	});
	return results;
}
function resolveBibliographyTarget(doc$1, target) {
	const found = findAllBibliographies(doc$1).find((b$1) => b$1.nodeId === target.nodeId || b$1.commandNodeId === target.nodeId);
	if (!found) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Bibliography with nodeId "${target.nodeId}" not found.`);
	return found;
}
function resolvePostMutationBibliographyId(doc$1, sdBlockId) {
	return findAllBibliographies(doc$1).find((b$1) => b$1.commandNodeId === sdBlockId)?.nodeId ?? sdBlockId;
}
function extractBibliographyInfo(resolved) {
	const instruction = resolved.node.attrs?.instruction ?? "";
	const style = resolved.node.attrs?.style ?? "";
	return {
		address: {
			kind: "block",
			nodeType: "bibliography",
			nodeId: resolved.nodeId
		},
		style,
		sourceCount: resolved.node.childCount,
		instruction
	};
}
function getBibliographyPart(editor) {
	const converter = editor.converter;
	if (!converter) return void 0;
	converter.bibliographyPart ??= {};
	return converter.bibliographyPart;
}
function getSourcesFromConverter(editor) {
	const part = getBibliographyPart(editor);
	if (!part) return [];
	part.sources ??= [];
	return part.sources;
}
function toSelectedStylePath(styleName) {
	if (styleName.startsWith("/") || styleName.toUpperCase().includes(".XSL")) return styleName;
	return `/${styleName}.XSL`;
}
function syncBibliographyStyleToConverter(editor, style) {
	const part = getBibliographyPart(editor);
	if (!part) return;
	part.selectedStyle = toSelectedStylePath(style);
	part.styleName = style;
}
function resolveSourceTarget(editor, target) {
	const found = getSourcesFromConverter(editor).find((s) => s.tag === target.sourceId);
	if (!found) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Citation source with tag "${target.sourceId}" not found.`);
	return found;
}
function resolveParentBlockId$1(doc$1, pos) {
	const resolved = doc$1.resolve(pos);
	for (let depth = resolved.depth; depth >= 0; depth--) {
		const rawBlockId = resolved.node(depth).attrs?.sdBlockId;
		if (rawBlockId != null) return String(rawBlockId);
	}
	return "";
}
function buildCitationAddress(doc$1, resolved) {
	const r$1 = doc$1.resolve(resolved.pos);
	const offset$1 = resolved.pos - r$1.start(r$1.depth);
	return {
		kind: "inline",
		nodeType: "citation",
		anchor: {
			start: {
				blockId: resolved.blockId,
				offset: offset$1
			},
			end: {
				blockId: resolved.blockId,
				offset: offset$1 + resolved.node.nodeSize
			}
		}
	};
}
function citationSuccess(address) {
	return {
		success: true,
		citation: address
	};
}
function citationFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function sourceSuccess(address) {
	return {
		success: true,
		source: address
	};
}
function sourceFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function bibSuccess(address) {
	return {
		success: true,
		bibliography: address
	};
}
function bibFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function receiptApplied$1(receipt) {
	return receipt.steps[0]?.effect === "changed";
}
function citationsListWrapper(editor, query) {
	const doc$1 = editor.state.doc;
	const revision = getRevision(editor);
	const { total, items: paged } = paginate(findAllCitations(doc$1).map((c) => buildCitationDiscoveryItem(doc$1, c, revision)), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function citationsGetWrapper(editor, input) {
	const resolved = resolveCitationTarget(editor.state.doc, input.target);
	return extractCitationInfo(editor.state.doc, resolved);
}
function citationsInsertWrapper(editor, input, options) {
	rejectTrackedMode("citations.insert", options);
	const dummyAddress = {
		kind: "inline",
		nodeType: "citation",
		anchor: {
			start: {
				blockId: "",
				offset: 0
			},
			end: {
				blockId: "",
				offset: 0
			}
		}
	};
	if (options?.dryRun) return citationSuccess(dummyAddress);
	const citationType = editor.schema.nodes.citation;
	if (!citationType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "citations.insert: citation node type not in schema.");
	const resolved = resolveInlineInsertPosition(editor, input.at, "citations.insert");
	if (!receiptApplied$1(executeDomainCommand(editor, () => {
		const instruction = buildCitationInstruction(input.sourceIds);
		const node = citationType.create({
			instruction,
			sourceIds: input.sourceIds,
			resolvedText: ""
		});
		const { tr } = editor.state;
		tr.insert(resolved.from, node);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return citationFailure("NO_OP", "Insert produced no change.");
	return citationSuccess(resolveInsertedCitationAddress(editor.state.doc, resolved.from, input.sourceIds));
}
function citationsUpdateWrapper(editor, input, options) {
	rejectTrackedMode("citations.update", options);
	const resolved = resolveCitationTarget(editor.state.doc, input.target);
	const address = extractCitationInfo(editor.state.doc, resolved).address;
	if (options?.dryRun) return citationSuccess(address);
	if (!receiptApplied$1(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		const newAttrs = { ...resolved.node.attrs };
		if (input.patch?.sourceIds) newAttrs.sourceIds = input.patch.sourceIds;
		if (input.patch?.sourceIds) newAttrs.instruction = buildCitationInstruction(newAttrs.sourceIds ?? []);
		tr.setNodeMarkup(resolved.pos, void 0, newAttrs);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return citationFailure("NO_OP", "Update produced no change.");
	return citationSuccess(address);
}
function citationsRemoveWrapper(editor, input, options) {
	rejectTrackedMode("citations.remove", options);
	const resolved = resolveCitationTarget(editor.state.doc, input.target);
	const address = extractCitationInfo(editor.state.doc, resolved).address;
	if (options?.dryRun) return citationSuccess(address);
	if (!receiptApplied$1(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		tr.delete(resolved.pos, resolved.pos + resolved.node.nodeSize);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return citationFailure("NO_OP", "Remove produced no change.");
	return citationSuccess(address);
}
function citationSourcesListWrapper(editor, query) {
	const revision = getRevision(editor);
	const { total, items: paged } = paginate(getSourcesFromConverter(editor).map((s) => {
		const domain = {
			address: {
				kind: "entity",
				entityType: "citationSource",
				sourceId: s.tag
			},
			sourceId: s.tag,
			tag: s.tag,
			type: s.type,
			fields: s.fields
		};
		const handle = buildResolvedHandle(s.tag, "stable", "node");
		return buildDiscoveryItem(`source:${s.tag}:${revision}`, handle, domain);
	}), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function citationSourcesGetWrapper(editor, input) {
	const source = resolveSourceTarget(editor, input.target);
	return {
		address: {
			kind: "entity",
			entityType: "citationSource",
			sourceId: source.tag
		},
		sourceId: source.tag,
		tag: source.tag,
		type: source.type,
		fields: source.fields
	};
}
function citationSourcesInsertWrapper(editor, input, options) {
	rejectTrackedMode("citations.sources.insert", options);
	const sourceId = `source-${Date.now()}`;
	const address = {
		kind: "entity",
		entityType: "citationSource",
		sourceId
	};
	if (executeOutOfBandMutation(editor, (dryRun) => {
		const sources = getSourcesFromConverter(editor);
		if (sources.some((s) => s.tag === sourceId)) return {
			changed: false,
			payload: "duplicate"
		};
		if (!dryRun) sources.push({
			tag: sourceId,
			type: input.type,
			fields: input.fields ?? {}
		});
		return {
			changed: true,
			payload: "inserted"
		};
	}, {
		dryRun: options?.dryRun ?? false,
		expectedRevision: options?.expectedRevision
	}) === "duplicate") return sourceFailure("NO_OP", `Source with id "${sourceId}" already exists.`);
	return sourceSuccess(address);
}
function citationSourcesUpdateWrapper(editor, input, options) {
	rejectTrackedMode("citations.sources.update", options);
	const source = resolveSourceTarget(editor, input.target);
	const address = {
		kind: "entity",
		entityType: "citationSource",
		sourceId: source.tag
	};
	executeOutOfBandMutation(editor, (dryRun) => {
		if (!dryRun && input.patch) Object.assign(source.fields, input.patch);
		return {
			changed: true,
			payload: void 0
		};
	}, {
		dryRun: options?.dryRun ?? false,
		expectedRevision: options?.expectedRevision
	});
	return sourceSuccess(address);
}
function citationSourcesRemoveWrapper(editor, input, options) {
	rejectTrackedMode("citations.sources.remove", options);
	const source = resolveSourceTarget(editor, input.target);
	const address = {
		kind: "entity",
		entityType: "citationSource",
		sourceId: source.tag
	};
	executeOutOfBandMutation(editor, (dryRun) => {
		if (!dryRun) {
			const sources = getSourcesFromConverter(editor);
			const idx = sources.findIndex((s) => s.tag === source.tag);
			if (idx >= 0) sources.splice(idx, 1);
		}
		return {
			changed: true,
			payload: void 0
		};
	}, {
		dryRun: options?.dryRun ?? false,
		expectedRevision: options?.expectedRevision
	});
	return sourceSuccess(address);
}
function bibliographyGetWrapper(editor, input) {
	return extractBibliographyInfo(resolveBibliographyTarget(editor.state.doc, input.target));
}
function bibliographyInsertWrapper(editor, input, options) {
	rejectTrackedMode("citations.bibliography.insert", options);
	const nodeId = v4_default();
	const address = {
		kind: "block",
		nodeType: "bibliography",
		nodeId
	};
	if (options?.dryRun) return bibSuccess(address);
	const bibType = editor.schema.nodes.bibliography;
	if (!bibType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "citations.bibliography.insert: bibliography node type not in schema.");
	const pos = resolveBlockCreatePosition(editor, input.at);
	if (!receiptApplied$1(executeDomainCommand(editor, () => {
		const node = bibType.create({
			instruction: "BIBLIOGRAPHY",
			sdBlockId: nodeId,
			...input.style !== void 0 ? { style: input.style } : {}
		}, editor.schema.nodes.paragraph.create());
		const { tr } = editor.state;
		tr.insert(pos, node);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return bibFailure("NO_OP", "Insert produced no change.");
	if (input.style !== void 0) syncBibliographyStyleToConverter(editor, input.style);
	return bibSuccess({
		kind: "block",
		nodeType: "bibliography",
		nodeId: resolvePostMutationBibliographyId(editor.state.doc, nodeId)
	});
}
function bibliographyConfigureWrapper(editor, input, options) {
	rejectTrackedMode("citations.bibliography.configure", options);
	const resolved = resolveBibliographyTarget(editor.state.doc, input.target);
	const stableNodeId = resolved.commandNodeId ?? resolved.nodeId;
	const address = {
		kind: "block",
		nodeType: "bibliography",
		nodeId: stableNodeId
	};
	if (options?.dryRun) return bibSuccess(address);
	if (!receiptApplied$1(executeDomainCommand(editor, () => {
		if (resolved.node.attrs.style === input.style) return false;
		const { tr } = editor.state;
		tr.setNodeMarkup(resolved.pos, void 0, {
			...resolved.node.attrs,
			style: input.style
		});
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return bibFailure("NO_OP", "Configure produced no change.");
	syncBibliographyStyleToConverter(editor, input.style);
	const bibliographies = findAllBibliographies(editor.state.doc);
	return bibSuccess({
		kind: "block",
		nodeType: "bibliography",
		nodeId: (bibliographies.find((bibliography) => bibliography.pos === resolved.pos) ?? bibliographies.find((bibliography) => bibliography.commandNodeId === stableNodeId))?.nodeId ?? resolvePostMutationBibliographyId(editor.state.doc, stableNodeId)
	});
}
function bibliographyRebuildWrapper(editor, input, options) {
	rejectTrackedMode("citations.bibliography.rebuild", options);
	const address = {
		kind: "block",
		nodeType: "bibliography",
		nodeId: resolveBibliographyTarget(editor.state.doc, input.target).nodeId
	};
	if (options?.dryRun) return bibSuccess(address);
	return bibSuccess(address);
}
function bibliographyRemoveWrapper(editor, input, options) {
	rejectTrackedMode("citations.bibliography.remove", options);
	const resolved = resolveBibliographyTarget(editor.state.doc, input.target);
	const address = {
		kind: "block",
		nodeType: "bibliography",
		nodeId: resolved.nodeId
	};
	if (options?.dryRun) return bibSuccess(address);
	if (!receiptApplied$1(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		tr.delete(resolved.pos, resolved.pos + resolved.node.nodeSize);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return bibFailure("NO_OP", "Remove produced no change.");
	return bibSuccess(address);
}
function computeInlineAddress(doc$1, pos) {
	const node = doc$1.nodeAt?.(pos);
	if (!node || typeof doc$1.resolve !== "function") return {
		kind: "inline",
		nodeType: "citation",
		anchor: {
			start: {
				blockId: "",
				offset: pos
			},
			end: {
				blockId: "",
				offset: pos + (node?.nodeSize ?? 1)
			}
		}
	};
	const r$1 = doc$1.resolve(pos);
	let blockId = "";
	for (let depth = r$1.depth; depth >= 0; depth--) {
		const bid = r$1.node(depth).attrs?.sdBlockId;
		if (bid) {
			blockId = bid;
			break;
		}
	}
	const offset$1 = pos - r$1.start(r$1.depth);
	return {
		kind: "inline",
		nodeType: "citation",
		anchor: {
			start: {
				blockId,
				offset: offset$1
			},
			end: {
				blockId,
				offset: offset$1 + node.nodeSize
			}
		}
	};
}
function resolveInsertedCitationAddress(doc$1, preferredPos, sourceIds) {
	if ((doc$1.nodeAt?.(preferredPos))?.type?.name === "citation") return computeInlineAddress(doc$1, preferredPos);
	const exactSourceIdMatches = [];
	const allCitationPositions = [];
	doc$1.descendants?.((node, pos) => {
		if (node.type?.name !== "citation") return true;
		allCitationPositions.push(pos);
		if (sameSourceIds(Array.isArray(node.attrs?.sourceIds) ? node.attrs.sourceIds : [], sourceIds)) exactSourceIdMatches.push(pos);
		return true;
	});
	const candidates = exactSourceIdMatches.length > 0 ? exactSourceIdMatches : allCitationPositions;
	if (candidates.length === 0) return computeInlineAddress(doc$1, preferredPos);
	return computeInlineAddress(doc$1, candidates.reduce((bestPos, candidatePos) => {
		const bestDistance = Math.abs(bestPos - preferredPos);
		return Math.abs(candidatePos - preferredPos) < bestDistance ? candidatePos : bestPos;
	}));
}
function sameSourceIds(left$1, right$1) {
	if (left$1.length !== right$1.length) return false;
	for (let i = 0; i < left$1.length; i++) if (left$1[i] !== right$1[i]) return false;
	return true;
}
function buildCitationInstruction(sourceIds) {
	if (sourceIds.length === 0) return "CITATION";
	const parts = [`CITATION ${sourceIds[0]}`];
	for (let i = 1; i < sourceIds.length; i++) parts.push(`\\m ${sourceIds[i]}`);
	return parts.join(" ");
}
function findAllAuthorities(doc$1) {
	const results = [];
	let occurrenceIndex = 0;
	doc$1.descendants((node, pos) => {
		if (node.type.name === "tableOfAuthorities") {
			const commandNodeId = node.attrs?.sdBlockId;
			const nodeId = resolvePublicReferenceBlockNodeId(node, occurrenceIndex);
			occurrenceIndex += 1;
			results.push({
				node,
				pos,
				nodeId,
				commandNodeId
			});
			return false;
		}
		return true;
	});
	return results;
}
function resolveAuthorityTarget(doc$1, target) {
	const found = findAllAuthorities(doc$1).find((a) => a.nodeId === target.nodeId || a.commandNodeId === target.nodeId);
	if (!found) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", `Table of authorities with nodeId "${target.nodeId}" not found.`);
	return found;
}
function resolvePostMutationAuthorityId(doc$1, sdBlockId) {
	return findAllAuthorities(doc$1).find((node) => node.commandNodeId === sdBlockId)?.nodeId ?? sdBlockId;
}
function extractAuthorityInfo(resolved) {
	const instruction = resolved.node.attrs?.instruction ?? "";
	return {
		address: {
			kind: "block",
			nodeType: "tableOfAuthorities",
			nodeId: resolved.nodeId
		},
		instruction,
		config: parseToaInstruction(instruction),
		entryCount: resolved.node.childCount
	};
}
function buildAuthorityDiscoveryItem(resolved, evaluatedRevision) {
	const instruction = resolved.node.attrs?.instruction ?? "";
	const domain = {
		address: {
			kind: "block",
			nodeType: "tableOfAuthorities",
			nodeId: resolved.nodeId
		},
		instruction,
		config: parseToaInstruction(instruction),
		entryCount: resolved.node.childCount
	};
	const handle = buildResolvedHandle(resolved.nodeId, "stable", "node");
	return buildDiscoveryItem(`toa:${resolved.nodeId}:${evaluatedRevision}`, handle, domain);
}
function findAllAuthorityEntries(doc$1) {
	const results = [];
	doc$1.descendants((node, pos) => {
		if (node.type.name === "authorityEntry") results.push({
			node,
			pos,
			instruction: node.attrs?.instruction ?? "",
			longCitation: node.attrs?.longCitation ?? "",
			shortCitation: node.attrs?.shortCitation ?? "",
			category: node.attrs?.category ?? 0,
			blockId: resolveParentBlockId(doc$1, pos)
		});
		return true;
	});
	return results;
}
function resolveAuthorityEntryTarget(doc$1, target) {
	const found = findAllAuthorityEntries(doc$1).find((e) => {
		if (target.anchor?.start?.blockId && e.blockId !== target.anchor.start.blockId) return false;
		if (target.anchor?.start?.offset !== void 0) {
			const resolved = doc$1.resolve(e.pos);
			if (e.pos - resolved.start(resolved.depth) !== target.anchor.start.offset) return false;
		}
		return true;
	});
	if (!found) throw new DocumentApiAdapterError("TARGET_NOT_FOUND", "Authority entry not found at the specified anchor.");
	return found;
}
function extractAuthorityEntryInfo(doc$1, resolved) {
	return {
		address: buildEntryAddress(doc$1, resolved),
		longCitation: resolved.longCitation,
		shortCitation: resolved.shortCitation,
		category: resolved.category,
		bold: resolved.node.attrs?.bold ?? false,
		italic: resolved.node.attrs?.italic ?? false,
		instruction: resolved.instruction
	};
}
function buildAuthorityEntryDiscoveryItem(doc$1, resolved, evaluatedRevision) {
	const domain = {
		address: buildEntryAddress(doc$1, resolved),
		longCitation: resolved.longCitation,
		shortCitation: resolved.shortCitation,
		category: resolved.category,
		bold: resolved.node.attrs?.bold ?? false,
		italic: resolved.node.attrs?.italic ?? false,
		instruction: resolved.instruction
	};
	const ref$1 = `${resolved.blockId}:${resolved.pos}`;
	const handle = buildResolvedHandle(ref$1, "ephemeral", "node");
	return buildDiscoveryItem(`authorityEntry:${ref$1}:${evaluatedRevision}`, handle, domain);
}
function resolveParentBlockId(doc$1, pos) {
	const resolved = doc$1.resolve(pos);
	for (let depth = resolved.depth; depth >= 0; depth--) {
		const blockId = resolved.node(depth).attrs?.sdBlockId;
		if (blockId) return blockId;
	}
	return "";
}
function buildEntryAddress(doc$1, resolved) {
	const r$1 = doc$1.resolve(resolved.pos);
	const offset$1 = resolved.pos - r$1.start(r$1.depth);
	return {
		kind: "inline",
		nodeType: "authorityEntry",
		anchor: {
			start: {
				blockId: resolved.blockId,
				offset: offset$1
			},
			end: {
				blockId: resolved.blockId,
				offset: offset$1 + resolved.node.nodeSize
			}
		}
	};
}
var TOA_LEADER_REVERSE_MAP = {
	".": "dot",
	"-": "hyphen",
	_: "underscore"
};
function parseToaInstruction(instruction) {
	const config = {};
	const c = instruction.match(/\\c\s+(\d+)/);
	if (c) config.category = parseInt(c[1], 10);
	const e = instruction.match(/\\e\s+"([^"]*)"/);
	if (e) config.entryPageSeparator = e[1];
	if (/\\p(?:\s|$)/.test(instruction)) config.usePassim = true;
	if (/\\h(?:\s|$)/.test(instruction)) config.includeHeadings = true;
	const l = instruction.match(/\\l\s+"([^"]*)"/);
	if (l) config.tabLeader = TOA_LEADER_REVERSE_MAP[l[1]] ?? l[1];
	const g$1 = instruction.match(/\\g\s+"([^"]*)"/);
	if (g$1) config.pageRangeSeparator = g$1[1];
	return config;
}
function toaSuccess(address) {
	return {
		success: true,
		authorities: address
	};
}
function toaFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function entrySuccess(address) {
	return {
		success: true,
		entry: address
	};
}
function entryFailure(code, message) {
	return {
		success: false,
		failure: {
			code,
			message
		}
	};
}
function receiptApplied(receipt) {
	return receipt.steps[0]?.effect === "changed";
}
function authoritiesListWrapper(editor, query) {
	const doc$1 = editor.state.doc;
	const revision = getRevision(editor);
	const { total, items: paged } = paginate(findAllAuthorities(doc$1).map((n) => buildAuthorityDiscoveryItem(n, revision)), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function authoritiesGetWrapper(editor, input) {
	return extractAuthorityInfo(resolveAuthorityTarget(editor.state.doc, input.target));
}
function authoritiesInsertWrapper(editor, input, options) {
	rejectTrackedMode("authorities.insert", options);
	const requestedNodeId = `toa-${Date.now()}`;
	const dryRunAddress = {
		kind: "block",
		nodeType: "tableOfAuthorities",
		nodeId: requestedNodeId
	};
	if (options?.dryRun) return toaSuccess(dryRunAddress);
	const toaType = editor.schema.nodes.tableOfAuthorities;
	if (!toaType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "authorities.insert: tableOfAuthorities node type not in schema.");
	const pos = resolveBlockCreatePosition(editor, input.at);
	if (!receiptApplied(executeDomainCommand(editor, () => {
		const attrs = {
			instruction: buildToaInstruction(input.config),
			sdBlockId: requestedNodeId
		};
		if (input.config?.category !== void 0) attrs.category = input.config.category;
		const node = toaType.create(attrs, editor.schema.nodes.paragraph.create());
		const { tr } = editor.state;
		tr.insert(pos, node);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return toaFailure("NO_OP", "Insert produced no change.");
	return toaSuccess({
		kind: "block",
		nodeType: "tableOfAuthorities",
		nodeId: resolvePostMutationAuthorityId(editor.state.doc, requestedNodeId)
	});
}
function authoritiesConfigureWrapper(editor, input, options) {
	rejectTrackedMode("authorities.configure", options);
	const resolved = resolveAuthorityTarget(editor.state.doc, input.target);
	const address = {
		kind: "block",
		nodeType: "tableOfAuthorities",
		nodeId: resolved.nodeId
	};
	if (options?.dryRun) return toaSuccess(address);
	const currentInstruction = resolved.node.attrs.instruction ?? "";
	const mergedConfig = { ...parseToaInstruction(currentInstruction) };
	for (const [key, value] of Object.entries(input.patch)) if (value !== void 0) mergedConfig[key] = value;
	const newInstruction = buildToaInstruction(mergedConfig);
	const currentCategory = resolved.node.attrs.category;
	const categoryUnchanged = input.patch.category === void 0 || input.patch.category === currentCategory;
	if (newInstruction === currentInstruction && categoryUnchanged) return toaFailure("NO_OP", "Configuration patch produced no change.");
	if (!receiptApplied(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		const newAttrs = {
			...resolved.node.attrs,
			instruction: newInstruction
		};
		if (input.patch.category !== void 0) newAttrs.category = input.patch.category;
		tr.setNodeMarkup(resolved.pos, void 0, newAttrs);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return toaFailure("NO_OP", "Configure produced no change.");
	return toaSuccess(address);
}
function authoritiesRebuildWrapper(editor, input, options) {
	rejectTrackedMode("authorities.rebuild", options);
	const address = {
		kind: "block",
		nodeType: "tableOfAuthorities",
		nodeId: resolveAuthorityTarget(editor.state.doc, input.target).nodeId
	};
	if (options?.dryRun) return toaSuccess(address);
	return toaSuccess(address);
}
function authoritiesRemoveWrapper(editor, input, options) {
	rejectTrackedMode("authorities.remove", options);
	const resolved = resolveAuthorityTarget(editor.state.doc, input.target);
	const address = {
		kind: "block",
		nodeType: "tableOfAuthorities",
		nodeId: resolved.nodeId
	};
	if (options?.dryRun) return toaSuccess(address);
	if (!receiptApplied(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		tr.delete(resolved.pos, resolved.pos + resolved.node.nodeSize);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return toaFailure("NO_OP", "Remove produced no change.");
	return toaSuccess(address);
}
function authorityEntriesListWrapper(editor, query) {
	const doc$1 = editor.state.doc;
	const revision = getRevision(editor);
	const { total, items: paged } = paginate(findAllAuthorityEntries(doc$1).map((e) => buildAuthorityEntryDiscoveryItem(doc$1, e, revision)), query?.offset, query?.limit);
	return buildDiscoveryResult({
		evaluatedRevision: revision,
		total,
		items: paged,
		page: {
			limit: query?.limit ?? total,
			offset: query?.offset ?? 0,
			returned: paged.length
		}
	});
}
function authorityEntriesGetWrapper(editor, input) {
	const resolved = resolveAuthorityEntryTarget(editor.state.doc, input.target);
	return extractAuthorityEntryInfo(editor.state.doc, resolved);
}
function authorityEntriesInsertWrapper(editor, input, options) {
	rejectTrackedMode("authorities.entries.insert", options);
	const dummyAddress = {
		kind: "inline",
		nodeType: "authorityEntry",
		anchor: {
			start: {
				blockId: "",
				offset: 0
			},
			end: {
				blockId: "",
				offset: 0
			}
		}
	};
	if (options?.dryRun) return entrySuccess(dummyAddress);
	const entryType = editor.schema.nodes.authorityEntry;
	if (!entryType) throw new DocumentApiAdapterError("CAPABILITY_UNAVAILABLE", "authorities.entries.insert: authorityEntry node type not in schema.");
	const resolved = resolveInlineInsertPosition(editor, input.at, "authorities.entries.insert");
	if (!receiptApplied(executeDomainCommand(editor, () => {
		const instruction = buildTaInstruction(input);
		const node = entryType.create({
			instruction,
			longCitation: input.entry.longCitation ?? "",
			shortCitation: input.entry.shortCitation ?? "",
			category: input.entry.category ?? 0,
			bold: input.entry.bold ?? false,
			italic: input.entry.italic ?? false
		});
		const { tr } = editor.state;
		tr.insert(resolved.from, node);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return entryFailure("NO_OP", "Insert produced no change.");
	return entrySuccess(computeInlineEntryAddress(editor.state.doc, resolved.from));
}
function authorityEntriesUpdateWrapper(editor, input, options) {
	rejectTrackedMode("authorities.entries.update", options);
	const resolved = resolveAuthorityEntryTarget(editor.state.doc, input.target);
	const address = extractAuthorityEntryInfo(editor.state.doc, resolved).address;
	if (options?.dryRun) return entrySuccess(address);
	if (!receiptApplied(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		const newAttrs = { ...resolved.node.attrs };
		if (input.patch.longCitation !== void 0) newAttrs.longCitation = input.patch.longCitation;
		if (input.patch.shortCitation !== void 0) newAttrs.shortCitation = input.patch.shortCitation;
		if (input.patch.category !== void 0) newAttrs.category = input.patch.category;
		if (input.patch.bold !== void 0) newAttrs.bold = input.patch.bold;
		if (input.patch.italic !== void 0) newAttrs.italic = input.patch.italic;
		newAttrs.instruction = buildTaInstructionFromAttrs(newAttrs);
		tr.setNodeMarkup(resolved.pos, void 0, newAttrs);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return entryFailure("NO_OP", "Update produced no change.");
	return entrySuccess(address);
}
function authorityEntriesRemoveWrapper(editor, input, options) {
	rejectTrackedMode("authorities.entries.remove", options);
	const resolved = resolveAuthorityEntryTarget(editor.state.doc, input.target);
	const address = extractAuthorityEntryInfo(editor.state.doc, resolved).address;
	if (options?.dryRun) return entrySuccess(address);
	if (!receiptApplied(executeDomainCommand(editor, () => {
		const { tr } = editor.state;
		tr.delete(resolved.pos, resolved.pos + resolved.node.nodeSize);
		editor.dispatch(tr);
		clearIndexCache(editor);
		return true;
	}, { expectedRevision: options?.expectedRevision }))) return entryFailure("NO_OP", "Remove produced no change.");
	return entrySuccess(address);
}
function computeInlineEntryAddress(doc$1, pos) {
	const node = doc$1.nodeAt?.(pos);
	if (!node || typeof doc$1.resolve !== "function") return {
		kind: "inline",
		nodeType: "authorityEntry",
		anchor: {
			start: {
				blockId: "",
				offset: pos
			},
			end: {
				blockId: "",
				offset: pos + (node?.nodeSize ?? 1)
			}
		}
	};
	const r$1 = doc$1.resolve(pos);
	let blockId = "";
	for (let depth = r$1.depth; depth >= 0; depth--) {
		const bid = r$1.node(depth).attrs?.sdBlockId;
		if (bid) {
			blockId = bid;
			break;
		}
	}
	const offset$1 = pos - r$1.start(r$1.depth);
	return {
		kind: "inline",
		nodeType: "authorityEntry",
		anchor: {
			start: {
				blockId,
				offset: offset$1
			},
			end: {
				blockId,
				offset: offset$1 + node.nodeSize
			}
		}
	};
}
function buildTaInstruction(input) {
	const parts = ["TA"];
	if (input.entry.longCitation) parts.push(`\\l "${input.entry.longCitation}"`);
	if (input.entry.shortCitation) parts.push(`\\s "${input.entry.shortCitation}"`);
	if (input.entry.category !== void 0) parts.push(`\\c ${input.entry.category}`);
	if (input.entry.bold) parts.push("\\b");
	if (input.entry.italic) parts.push("\\i");
	return parts.join(" ");
}
function buildTaInstructionFromAttrs(attrs) {
	const parts = ["TA"];
	const longCitation = attrs.longCitation;
	const shortCitation = attrs.shortCitation;
	const category = attrs.category;
	if (longCitation) parts.push(`\\l "${longCitation}"`);
	if (shortCitation) parts.push(`\\s "${shortCitation}"`);
	if (category !== void 0) parts.push(`\\c ${category}`);
	if (attrs.bold) parts.push("\\b");
	if (attrs.italic) parts.push("\\i");
	return parts.join(" ");
}
function buildToaInstruction(config) {
	const parts = ["TOA"];
	if (!config) return parts[0];
	if (config.category !== void 0) parts.push(`\\c ${config.category}`);
	if (config.entryPageSeparator !== void 0) parts.push(`\\e "${config.entryPageSeparator}"`);
	if (config.usePassim) parts.push("\\p");
	if (config.includeHeadings) parts.push("\\h");
	if (config.tabLeader !== void 0 && config.tabLeader !== "none") parts.push(`\\l "${{
		dot: ".",
		hyphen: "-",
		underscore: "_"
	}[config.tabLeader] ?? config.tabLeader}"`);
	if (config.pageRangeSeparator !== void 0) parts.push(`\\g "${config.pageRangeSeparator}"`);
	return parts.length > 1 ? parts.join(" ") : "TOA";
}
function assembleDocumentApiAdapters(editor) {
	registerBuiltInExecutors();
	initRevision(editor);
	trackRevisions(editor);
	initStoryRevisionStore(editor);
	registerPartDescriptor(stylesPartDescriptor);
	registerPartDescriptor(settingsPartDescriptor);
	registerPartDescriptor(relsPartDescriptor);
	registerPartDescriptor(numberingPartDescriptor);
	const ccAdapter = createContentControlsAdapter(editor);
	registerSetValueDelegate((ed, input, options) => listsSetValueWrapper(ed, input, options));
	return {
		get: { get: (input) => getAdapter(editor, input) },
		find: { find: (input) => sdFindAdapter(editor, input) },
		getNode: {
			getNode: (address) => getNodeAdapter(editor, address),
			getNodeById: (input) => getNodeByIdAdapter(editor, input)
		},
		getText: { getText: (input) => getTextAdapter(editor, input) },
		getMarkdown: { getMarkdown: (input) => getMarkdownAdapter(editor, input) },
		getHtml: { getHtml: (input) => getHtmlAdapter(editor, input) },
		markdownToFragment: { markdownToFragment: (input) => markdownToFragmentAdapter(editor, input) },
		info: { info: (input) => infoAdapter(editor, input) },
		extract: { extract: (input) => extractAdapter(editor, input) },
		clearContent: { clearContent: (input, options) => clearContentWrapper(editor, input, options) },
		capabilities: { get: () => getDocumentApiCapabilities(editor) },
		comments: createCommentsWrapper(editor),
		write: {
			write: (request, options) => writeWrapper(editor, request, options),
			insertStructured: (input, options) => insertStructuredWrapper(editor, input, options),
			replaceStructured: (input, options) => replaceStructuredWrapper(editor, input, options)
		},
		selectionMutation: { execute: (request, options) => selectionMutationWrapper(editor, request, options) },
		styles: { apply: (input, options) => stylesApplyAdapter(editor, input, options) },
		templates: { apply: (input, options) => templatesApplyAdapter(editor, input, options) },
		paragraphs: {
			setStyle: (input, options) => paragraphsSetStyleWrapper(editor, input, options),
			clearStyle: (input, options) => paragraphsClearStyleWrapper(editor, input, options),
			resetDirectFormatting: (input, options) => paragraphsResetDirectFormattingWrapper(editor, input, options),
			setAlignment: (input, options) => paragraphsSetAlignmentWrapper(editor, input, options),
			clearAlignment: (input, options) => paragraphsClearAlignmentWrapper(editor, input, options),
			setIndentation: (input, options) => paragraphsSetIndentationWrapper(editor, input, options),
			clearIndentation: (input, options) => paragraphsClearIndentationWrapper(editor, input, options),
			setSpacing: (input, options) => paragraphsSetSpacingWrapper(editor, input, options),
			clearSpacing: (input, options) => paragraphsClearSpacingWrapper(editor, input, options),
			setKeepOptions: (input, options) => paragraphsSetKeepOptionsWrapper(editor, input, options),
			setOutlineLevel: (input, options) => paragraphsSetOutlineLevelWrapper(editor, input, options),
			setFlowOptions: (input, options) => paragraphsSetFlowOptionsWrapper(editor, input, options),
			setTabStop: (input, options) => paragraphsSetTabStopWrapper(editor, input, options),
			clearTabStop: (input, options) => paragraphsClearTabStopWrapper(editor, input, options),
			clearAllTabStops: (input, options) => paragraphsClearAllTabStopsWrapper(editor, input, options),
			setBorder: (input, options) => paragraphsSetBorderWrapper(editor, input, options),
			clearBorder: (input, options) => paragraphsClearBorderWrapper(editor, input, options),
			setShading: (input, options) => paragraphsSetShadingWrapper(editor, input, options),
			clearShading: (input, options) => paragraphsClearShadingWrapper(editor, input, options),
			setDirection: (input, options) => paragraphsSetDirectionWrapper(editor, input, options),
			clearDirection: (input, options) => paragraphsClearDirectionWrapper(editor, input, options)
		},
		trackChanges: {
			list: (input) => trackChangesListWrapper(editor, input),
			get: (input) => trackChangesGetWrapper(editor, input),
			accept: (input, options) => trackChangesAcceptWrapper(editor, input, options),
			reject: (input, options) => trackChangesRejectWrapper(editor, input, options),
			acceptAll: (input, options) => trackChangesAcceptAllWrapper(editor, input, options),
			rejectAll: (input, options) => trackChangesRejectAllWrapper(editor, input, options),
			decideRange: (input, options) => trackChangesDecideRangeWrapper(editor, input, options)
		},
		blocks: {
			list: (input) => blocksListWrapper(editor, input),
			delete: (input, options) => blocksDeleteWrapper(editor, input, options),
			deleteRange: (input, options) => blocksDeleteRangeWrapper(editor, input, options)
		},
		create: {
			paragraph: (input, options) => createParagraphWrapper(editor, input, options),
			heading: (input, options) => createHeadingWrapper(editor, input, options),
			table: (input, options) => createTableWrapper(editor, input, options),
			sectionBreak: (input, options) => createSectionBreakAdapter(editor, input, options),
			tableOfContents: (input, options) => createTableOfContentsWrapper(editor, input, options),
			image: (input, options) => createImageWrapper(editor, input, options),
			contentControl: (input, options) => ccAdapter.create(input, options)
		},
		lists: {
			list: (query) => listsListWrapper(editor, query),
			get: (input) => listsGetWrapper(editor, input),
			insert: (input, options) => listsInsertWrapper(editor, input, options),
			create: (input, options) => listsCreateWrapper(editor, input, options),
			attach: (input, options) => listsAttachWrapper(editor, input, options),
			detach: (input, options) => listsDetachWrapper(editor, input, options),
			delete: (input, options) => listsDeleteWrapper(editor, input, options),
			indent: (input, options) => listsIndentWrapper(editor, input, options),
			outdent: (input, options) => listsOutdentWrapper(editor, input, options),
			join: (input, options) => listsJoinWrapper(editor, input, options),
			canJoin: (input) => listsCanJoinWrapper(editor, input),
			separate: (input, options) => listsSeparateWrapper(editor, input, options),
			merge: (input, options) => listsMergeWrapper(editor, input, options),
			split: (input, options) => listsSplitWrapper(editor, input, options),
			setLevel: (input, options) => listsSetLevelWrapper(editor, input, options),
			setValue: (input, options) => listsSetValueWrapper(editor, input, options),
			continuePrevious: (input, options) => listsContinuePreviousWrapper(editor, input, options),
			canContinuePrevious: (input) => listsCanContinuePreviousWrapper(editor, input),
			setLevelRestart: (input, options) => listsSetLevelRestartWrapper(editor, input, options),
			convertToText: (input, options) => listsConvertToTextWrapper(editor, input, options),
			applyTemplate: (input, options) => listsApplyTemplateWrapper(editor, input, options),
			applyPreset: (input, options) => listsApplyPresetWrapper(editor, input, options),
			captureTemplate: (input) => listsCaptureTemplateWrapper(editor, input),
			setLevelNumbering: (input, options) => listsSetLevelNumberingWrapper(editor, input, options),
			setLevelBullet: (input, options) => listsSetLevelBulletWrapper(editor, input, options),
			setLevelPictureBullet: (input, options) => listsSetLevelPictureBulletWrapper(editor, input, options),
			setLevelAlignment: (input, options) => listsSetLevelAlignmentWrapper(editor, input, options),
			setLevelIndents: (input, options) => listsSetLevelIndentsWrapper(editor, input, options),
			setLevelTrailingCharacter: (input, options) => listsSetLevelTrailingCharacterWrapper(editor, input, options),
			setLevelMarkerFont: (input, options) => listsSetLevelMarkerFontWrapper(editor, input, options),
			clearLevelOverrides: (input, options) => listsClearLevelOverridesWrapper(editor, input, options),
			setType: (input, options) => listsSetTypeWrapper(editor, input, options),
			getStyle: (input) => listsGetStyleWrapper(editor, input),
			applyStyle: (input, options) => listsApplyStyleWrapper(editor, input, options),
			restartAt: (input, options) => listsRestartAtWrapper(editor, input, options),
			setLevelNumberStyle: (input, options) => listsSetLevelNumberStyleWrapper(editor, input, options),
			setLevelText: (input, options) => listsSetLevelTextWrapper(editor, input, options),
			setLevelStart: (input, options) => listsSetLevelStartWrapper(editor, input, options),
			setLevelLayout: (input, options) => listsSetLevelLayoutWrapper(editor, input, options)
		},
		sections: {
			list: (query) => sectionsListAdapter(editor, query),
			get: (input) => sectionsGetAdapterByInput(editor, input),
			setBreakType: (input, options) => sectionsSetBreakTypeAdapter(editor, input, options),
			setPageMargins: (input, options) => sectionsSetPageMarginsAdapter(editor, input, options),
			setHeaderFooterMargins: (input, options) => sectionsSetHeaderFooterMarginsAdapter(editor, input, options),
			setPageSetup: (input, options) => sectionsSetPageSetupAdapter(editor, input, options),
			setColumns: (input, options) => sectionsSetColumnsAdapter(editor, input, options),
			setLineNumbering: (input, options) => sectionsSetLineNumberingAdapter(editor, input, options),
			setPageNumbering: (input, options) => sectionsSetPageNumberingAdapter(editor, input, options),
			setTitlePage: (input, options) => sectionsSetTitlePageAdapter(editor, input, options),
			setOddEvenHeadersFooters: (input, options) => sectionsSetOddEvenHeadersFootersAdapter(editor, input, options),
			setVerticalAlign: (input, options) => sectionsSetVerticalAlignAdapter(editor, input, options),
			setSectionDirection: (input, options) => sectionsSetSectionDirectionAdapter(editor, input, options),
			setHeaderFooterRef: (input, options) => sectionsSetHeaderFooterRefAdapter(editor, input, options),
			clearHeaderFooterRef: (input, options) => sectionsClearHeaderFooterRefAdapter(editor, input, options),
			setLinkToPrevious: (input, options) => sectionsSetLinkToPreviousAdapter(editor, input, options),
			setPageBorders: (input, options) => sectionsSetPageBordersAdapter(editor, input, options),
			clearPageBorders: (input, options) => sectionsClearPageBordersAdapter(editor, input, options)
		},
		tables: {
			convertFromText: (input, options) => tablesConvertFromTextWrapper(editor, input, options),
			delete: (input, options) => tablesDeleteWrapper(editor, input, options),
			clearContents: (input, options) => tablesClearContentsWrapper(editor, input, options),
			move: (input, options) => tablesMoveWrapper(editor, input, options),
			split: (input, options) => tablesSplitWrapper(editor, input, options),
			convertToText: (input, options) => tablesConvertToTextWrapper(editor, input, options),
			setLayout: (input, options) => tablesSetLayoutWrapper(editor, input, options),
			insertRow: (input, options) => tablesInsertRowWrapper(editor, input, options),
			deleteRow: (input, options) => tablesDeleteRowWrapper(editor, input, options),
			setRowHeight: (input, options) => tablesSetRowHeightWrapper(editor, input, options),
			distributeRows: (input, options) => tablesDistributeRowsWrapper(editor, input, options),
			setRowOptions: (input, options) => tablesSetRowOptionsWrapper(editor, input, options),
			insertColumn: (input, options) => tablesInsertColumnWrapper(editor, input, options),
			deleteColumn: (input, options) => tablesDeleteColumnWrapper(editor, input, options),
			setColumnWidth: (input, options) => tablesSetColumnWidthWrapper(editor, input, options),
			distributeColumns: (input, options) => tablesDistributeColumnsWrapper(editor, input, options),
			insertCell: (input, options) => tablesInsertCellWrapper(editor, input, options),
			deleteCell: (input, options) => tablesDeleteCellWrapper(editor, input, options),
			mergeCells: (input, options) => tablesMergeCellsWrapper(editor, input, options),
			unmergeCells: (input, options) => tablesUnmergeCellsWrapper(editor, input, options),
			splitCell: (input, options) => tablesSplitCellWrapper(editor, input, options),
			setCellProperties: (input, options) => tablesSetCellPropertiesWrapper(editor, input, options),
			setCellText: (input, options) => tablesSetCellTextWrapper(editor, input, options),
			sort: (input, options) => tablesSortWrapper(editor, input, options),
			setAltText: (input, options) => tablesSetAltTextWrapper(editor, input, options),
			setStyle: (input, options) => tablesSetStyleWrapper(editor, input, options),
			clearStyle: (input, options) => tablesClearStyleWrapper(editor, input, options),
			setStyleOption: (input, options) => tablesSetStyleOptionWrapper(editor, input, options),
			setBorder: (input, options) => tablesSetBorderWrapper(editor, input, options),
			clearBorder: (input, options) => tablesClearBorderWrapper(editor, input, options),
			applyBorderPreset: (input, options) => tablesApplyBorderPresetWrapper(editor, input, options),
			setShading: (input, options) => tablesSetShadingWrapper(editor, input, options),
			clearShading: (input, options) => tablesClearShadingWrapper(editor, input, options),
			setTablePadding: (input, options) => tablesSetTablePaddingWrapper(editor, input, options),
			setCellPadding: (input, options) => tablesSetCellPaddingWrapper(editor, input, options),
			setCellSpacing: (input, options) => tablesSetCellSpacingWrapper(editor, input, options),
			clearCellSpacing: (input, options) => tablesClearCellSpacingWrapper(editor, input, options),
			applyStyle: (input, options) => tablesApplyStyleWrapper(editor, input, options),
			setBorders: (input, options) => tablesSetBordersWrapper(editor, input, options),
			setTableOptions: (input, options) => tablesSetTableOptionsWrapper(editor, input, options),
			applyPreset: (input, options) => tablesApplyPresetWrapper(editor, input, options),
			get: (input) => tablesGetAdapter(editor, input),
			getCells: (input) => tablesGetCellsAdapter(editor, input),
			getProperties: (input) => tablesGetPropertiesAdapter(editor, input),
			getStyles: (input) => tablesGetStylesAdapter(editor, input),
			setDefaultStyle: (input, options) => tablesSetDefaultStyleAdapter(editor, input, options),
			clearDefaultStyle: (input, options) => tablesClearDefaultStyleAdapter(editor, input, options)
		},
		toc: {
			list: (query) => tocListWrapper(editor, query),
			get: (input) => tocGetWrapper(editor, input),
			configure: (input, options) => tocConfigureWrapper(editor, input, options),
			update: (input, options) => tocUpdateWrapper(editor, input, options),
			remove: (input, options) => tocRemoveWrapper(editor, input, options),
			markEntry: (input, options) => tocMarkEntryWrapper(editor, input, options),
			unmarkEntry: (input, options) => tocUnmarkEntryWrapper(editor, input, options),
			listEntries: (query) => tocListEntriesWrapper(editor, query),
			getEntry: (input) => tocGetEntryWrapper(editor, input),
			editEntry: (input, options) => tocEditEntryWrapper(editor, input, options)
		},
		images: {
			image: (input, options) => createImageWrapper(editor, input, options),
			list: (input) => imagesListWrapper(editor, input),
			get: (input) => imagesGetWrapper(editor, input),
			delete: (input, options) => imagesDeleteWrapper(editor, input, options),
			move: (input, options) => imagesMoveWrapper(editor, input, options),
			convertToInline: (input, options) => imagesConvertToInlineWrapper(editor, input, options),
			convertToFloating: (input, options) => imagesConvertToFloatingWrapper(editor, input, options),
			setSize: (input, options) => imagesSetSizeWrapper(editor, input, options),
			setWrapType: (input, options) => imagesSetWrapTypeWrapper(editor, input, options),
			setWrapSide: (input, options) => imagesSetWrapSideWrapper(editor, input, options),
			setWrapDistances: (input, options) => imagesSetWrapDistancesWrapper(editor, input, options),
			setPosition: (input, options) => imagesSetPositionWrapper(editor, input, options),
			setAnchorOptions: (input, options) => imagesSetAnchorOptionsWrapper(editor, input, options),
			setZOrder: (input, options) => imagesSetZOrderWrapper(editor, input, options),
			scale: (input, options) => imagesScaleWrapper(editor, input, options),
			setLockAspectRatio: (input, options) => imagesSetLockAspectRatioWrapper(editor, input, options),
			rotate: (input, options) => imagesRotateWrapper(editor, input, options),
			flip: (input, options) => imagesFlipWrapper(editor, input, options),
			crop: (input, options) => imagesCropWrapper(editor, input, options),
			resetCrop: (input, options) => imagesResetCropWrapper(editor, input, options),
			replaceSource: (input, options) => imagesReplaceSourceWrapper(editor, input, options),
			setAltText: (input, options) => imagesSetAltTextWrapper(editor, input, options),
			setDecorative: (input, options) => imagesSetDecorativeWrapper(editor, input, options),
			setName: (input, options) => imagesSetNameWrapper(editor, input, options),
			setHyperlink: (input, options) => imagesSetHyperlinkWrapper(editor, input, options),
			insertCaption: (input, options) => imagesInsertCaptionWrapper(editor, input, options),
			updateCaption: (input, options) => imagesUpdateCaptionWrapper(editor, input, options),
			removeCaption: (input, options) => imagesRemoveCaptionWrapper(editor, input, options)
		},
		hyperlinks: {
			list: (query) => hyperlinksListWrapper(editor, query),
			get: (input) => hyperlinksGetWrapper(editor, input),
			wrap: (input, options) => hyperlinksWrapWrapper(editor, input, options),
			insert: (input, options) => hyperlinksInsertWrapper(editor, input, options),
			patch: (input, options) => hyperlinksPatchWrapper(editor, input, options),
			remove: (input, options) => hyperlinksRemoveWrapper(editor, input, options)
		},
		headerFooters: {
			list: (query) => headerFootersListAdapter(editor, query),
			get: (input) => headerFootersGetAdapter(editor, input),
			resolve: (input) => headerFootersResolveAdapter(editor, input),
			refs: {
				set: (input, options) => headerFootersRefsSetAdapter(editor, input, options),
				clear: (input, options) => headerFootersRefsClearAdapter(editor, input, options),
				setLinkedToPrevious: (input, options) => headerFootersRefsSetLinkedToPreviousAdapter(editor, input, options)
			},
			parts: {
				list: (query) => headerFootersPartsListAdapter(editor, query),
				create: (input, options) => headerFootersPartsCreateAdapter(editor, input, options),
				delete: (input, options) => headerFootersPartsDeleteAdapter(editor, input, options)
			}
		},
		contentControls: ccAdapter,
		bookmarks: {
			list: (query) => bookmarksListWrapper(editor, query),
			get: (input) => bookmarksGetWrapper(editor, input),
			insert: (input, options) => bookmarksInsertWrapper(editor, input, options),
			rename: (input, options) => bookmarksRenameWrapper(editor, input, options),
			remove: (input, options) => bookmarksRemoveWrapper(editor, input, options)
		},
		customXml: { parts: createCustomXmlPartsAdapter(editor) },
		metadata: createAnchoredMetadataAdapter(editor),
		footnotes: {
			list: (query) => footnotesListWrapper(editor, query),
			get: (input) => footnotesGetWrapper(editor, input),
			insert: (input, options) => footnotesInsertWrapper(editor, input, options),
			update: (input, options) => footnotesUpdateWrapper(editor, input, options),
			remove: (input, options) => footnotesRemoveWrapper(editor, input, options),
			configure: (input, options) => footnotesConfigureWrapper(editor, input, options)
		},
		crossRefs: {
			list: (query) => crossRefsListWrapper(editor, query),
			get: (input) => crossRefsGetWrapper(editor, input),
			insert: (input, options) => crossRefsInsertWrapper(editor, input, options),
			rebuild: (input, options) => crossRefsRebuildWrapper(editor, input, options),
			remove: (input, options) => crossRefsRemoveWrapper(editor, input, options)
		},
		index: {
			list: (query) => indexListWrapper(editor, query),
			get: (input) => indexGetWrapper(editor, input),
			insert: (input, options) => indexInsertWrapper(editor, input, options),
			configure: (input, options) => indexConfigureWrapper(editor, input, options),
			rebuild: (input, options) => indexRebuildWrapper(editor, input, options),
			remove: (input, options) => indexRemoveWrapper(editor, input, options),
			entries: {
				list: (query) => indexEntriesListWrapper(editor, query),
				get: (input) => indexEntriesGetWrapper(editor, input),
				insert: (input, options) => indexEntriesInsertWrapper(editor, input, options),
				update: (input, options) => indexEntriesUpdateWrapper(editor, input, options),
				remove: (input, options) => indexEntriesRemoveWrapper(editor, input, options)
			}
		},
		captions: {
			list: (query) => captionsListWrapper(editor, query),
			get: (input) => captionsGetWrapper(editor, input),
			insert: (input, options) => captionsInsertWrapper(editor, input, options),
			update: (input, options) => captionsUpdateWrapper(editor, input, options),
			remove: (input, options) => captionsRemoveWrapper(editor, input, options),
			configure: (input, options) => captionsConfigureWrapper(editor, input, options)
		},
		fields: {
			list: (query) => fieldsListWrapper(editor, query),
			get: (input) => fieldsGetWrapper(editor, input),
			insert: (input, options) => fieldsInsertWrapper(editor, input, options),
			rebuild: (input, options) => fieldsRebuildWrapper(editor, input, options),
			remove: (input, options) => fieldsRemoveWrapper(editor, input, options)
		},
		citations: {
			list: (query) => citationsListWrapper(editor, query),
			get: (input) => citationsGetWrapper(editor, input),
			insert: (input, options) => citationsInsertWrapper(editor, input, options),
			update: (input, options) => citationsUpdateWrapper(editor, input, options),
			remove: (input, options) => citationsRemoveWrapper(editor, input, options),
			sources: {
				list: (query) => citationSourcesListWrapper(editor, query),
				get: (input) => citationSourcesGetWrapper(editor, input),
				insert: (input, options) => citationSourcesInsertWrapper(editor, input, options),
				update: (input, options) => citationSourcesUpdateWrapper(editor, input, options),
				remove: (input, options) => citationSourcesRemoveWrapper(editor, input, options)
			},
			bibliography: {
				get: (input) => bibliographyGetWrapper(editor, input),
				insert: (input, options) => bibliographyInsertWrapper(editor, input, options),
				configure: (input, options) => bibliographyConfigureWrapper(editor, input, options),
				rebuild: (input, options) => bibliographyRebuildWrapper(editor, input, options),
				remove: (input, options) => bibliographyRemoveWrapper(editor, input, options)
			}
		},
		authorities: {
			list: (query) => authoritiesListWrapper(editor, query),
			get: (input) => authoritiesGetWrapper(editor, input),
			insert: (input, options) => authoritiesInsertWrapper(editor, input, options),
			configure: (input, options) => authoritiesConfigureWrapper(editor, input, options),
			rebuild: (input, options) => authoritiesRebuildWrapper(editor, input, options),
			remove: (input, options) => authoritiesRemoveWrapper(editor, input, options),
			entries: {
				list: (query) => authorityEntriesListWrapper(editor, query),
				get: (input) => authorityEntriesGetWrapper(editor, input),
				insert: (input, options) => authorityEntriesInsertWrapper(editor, input, options),
				update: (input, options) => authorityEntriesUpdateWrapper(editor, input, options),
				remove: (input, options) => authorityEntriesRemoveWrapper(editor, input, options)
			}
		},
		ranges: { resolve: (input) => resolveRange(editor, input) },
		selection: { current: (input) => resolveCurrentSelectionInfo(editor, input) },
		query: { match: (input) => queryMatchAdapter(editor, input) },
		mutations: {
			preview: (input) => previewPlan(editor, input),
			apply: (input) => executePlan(editor, input)
		},
		diff: createDiffAdapter(editor),
		history: createHistoryAdapter(editor),
		protection: {
			get: () => protectionGetAdapter(editor),
			setEditingRestriction: (input, options) => protectionSetEditingRestrictionAdapter(editor, input, options),
			clearEditingRestriction: (_input, options) => protectionClearEditingRestrictionAdapter(editor, void 0, options)
		},
		permissionRanges: {
			list: (input) => permissionRangesListAdapter(editor, input),
			get: (input) => permissionRangesGetAdapter(editor, input),
			create: (input, options) => permissionRangesCreateAdapter(editor, input, options),
			remove: (input, options) => permissionRangesRemoveAdapter(editor, input, options),
			updatePrincipal: (input, options) => permissionRangesUpdatePrincipalAdapter(editor, input, options)
		}
	};
}
function getDocumentApiAdapters(editor) {
	return assembleDocumentApiAdapters(editor);
}
var EDGE_NODE_TYPES = new Set(SELECTION_EDGE_NODE_TYPES);
function selectCurrentPmSelection(editor) {
	return editor.state.selection;
}
function selectEffectivePmSelection(editor) {
	const liveSelection = editor.state.selection;
	if (!liveSelection.empty) return liveSelection;
	const preserved = getPreservedSelection(editor.state);
	if (preserved && !preserved.empty) return preserved;
	return liveSelection;
}
function classifyNodeSelection(editor, selection) {
	const node = selection.node;
	const mappedType = mapBlockNodeType(node);
	if (mappedType && EDGE_NODE_TYPES.has(mappedType)) return "block-edge";
	if (node.isLeaf && node.isInline) {
		if (editor.state.doc.resolve(selection.from).parent.inlineContent) return "inline-leaf";
	}
	return "reject";
}
function extractAbsoluteRange(editor, selection) {
	if ("$anchorCell" in selection) throw new DocumentApiAdapterError("INVALID_CONTEXT", "CellSelection cannot be converted to SelectionTarget. Use table-specific APIs for rectangular table selections.", { selectionType: selection.constructor.name });
	if (selection instanceof NodeSelection) {
		if (classifyNodeSelection(editor, selection) === "reject") {
			const displayType = mapBlockNodeType(selection.node) ?? selection.node.type.name;
			throw new DocumentApiAdapterError("INVALID_CONTEXT", `NodeSelection for node type "${displayType}" cannot be converted to SelectionTarget.`, {
				nodeType: displayType,
				pmNodeType: selection.node.type.name
			});
		}
	}
	return {
		absFrom: selection.from,
		absTo: selection.to
	};
}
function resolvePmSelectionToRange(editor, selection) {
	const { absFrom, absTo } = extractAbsoluteRange(editor, selection);
	return resolveAbsoluteRange(editor, {
		absFrom,
		absTo
	});
}
function resolveCurrentEditorSelectionRange(editor) {
	return resolvePmSelectionToRange(editor, selectCurrentPmSelection(editor));
}
function resolveEffectiveEditorSelectionRange(editor) {
	return resolvePmSelectionToRange(editor, selectEffectivePmSelection(editor));
}
var CONTENT_TYPES_PART_ID = "[Content_Types].xml";
var CONTENT_TYPES_NS = "http://schemas.openxmlformats.org/package/2006/content-types";
const contentTypesPartDescriptor = {
	id: CONTENT_TYPES_PART_ID,
	ensurePart() {
		return {
			type: "element",
			name: "document",
			elements: [{
				type: "element",
				name: "Types",
				attributes: { xmlns: CONTENT_TYPES_NS },
				elements: []
			}]
		};
	}
};
function initPartsRuntime(editor) {
	registerPartDescriptor(stylesPartDescriptor);
	registerPartDescriptor(settingsPartDescriptor);
	registerPartDescriptor(relsPartDescriptor);
	registerPartDescriptor(numberingPartDescriptor);
	registerPartDescriptor(contentTypesPartDescriptor);
	registerPartDescriptor(footnotesPartDescriptor);
	registerPartDescriptor(endnotesPartDescriptor);
	registerStaticInvalidationHandlers();
	initRevision(editor);
	trackRevisions(editor);
}
var empty_exports = /* @__PURE__ */ __export({ default: () => null }, 1);
var init_empty = __esmMin((() => {}));
function normalizeEditorTrackChangesOptions(options) {
	const canonical = options.modules?.trackChanges;
	const legacy = options.trackedChanges;
	if (!canonical && !legacy) return options;
	const normalized = {
		...legacy ?? {},
		...canonical ?? {}
	};
	return {
		...options,
		trackedChanges: normalized
	};
}
var CURRENT_APP_VERSION = "1.40.0";
var PIXELS_PER_INCH = 96;
var MAX_HEIGHT_BUFFER_PX = 50;
var MAX_WIDTH_BUFFER_PX = 20;
var TRACKED_REVIEW_MARK_NAMES = new Set([
	TrackInsertMarkName,
	TrackDeleteMarkName,
	TrackFormatMarkName
]);
var isTrackedReviewMark = (mark) => Boolean(mark?.type?.name && TRACKED_REVIEW_MARK_NAMES.has(mark.type.name));
var trackedReviewMarkKey = (mark) => {
	if (!isTrackedReviewMark(mark)) return null;
	const id = typeof mark.attrs?.id === "string" ? mark.attrs.id : "";
	return `${mark.type?.name ?? ""}:${id}`;
};
var trackedReviewMarkKeysForNode = (node) => {
	const keys$1 = /* @__PURE__ */ new Set();
	if (!node) return keys$1;
	for (const mark of node.marks ?? []) {
		const key = trackedReviewMarkKey(mark);
		if (key) keys$1.add(key);
	}
	return keys$1;
};
var inlineNodeHasTrackedReviewMark = (node) => Boolean(node.isInline && node.marks?.some(isTrackedReviewMark));
var rangeHasTrackedReviewMark = (doc$1, from$1, to) => {
	if (from$1 >= to) return false;
	const docStart = 0;
	const docEnd = doc$1.content.size;
	const clampedFrom = Math.max(docStart, Math.min(docEnd, from$1));
	const clampedTo = Math.max(docStart, Math.min(docEnd, to));
	if (clampedFrom >= clampedTo) return false;
	let found = false;
	doc$1.nodesBetween(clampedFrom, clampedTo, (node) => {
		if (inlineNodeHasTrackedReviewMark(node)) {
			found = true;
			return false;
		}
	});
	return found;
};
var rangeIsTrackedInsertionOnly = (doc$1, from$1, to) => {
	if (from$1 >= to) return false;
	const docStart = 0;
	const docEnd = doc$1.content.size;
	const clampedFrom = Math.max(docStart, Math.min(docEnd, from$1));
	const clampedTo = Math.max(docStart, Math.min(docEnd, to));
	if (clampedFrom >= clampedTo) return false;
	let sawTrackedInsertion = false;
	let sawUntrackedInline = false;
	let sawNonInsertionTrackedMark = false;
	doc$1.nodesBetween(clampedFrom, clampedTo, (node, pos) => {
		if (!node.isInline || !node.isLeaf) return;
		if (pos + node.nodeSize <= clampedFrom || pos >= clampedTo) return;
		const trackedMarks = (node.marks ?? []).filter(isTrackedReviewMark);
		if (!trackedMarks.length) {
			sawUntrackedInline = true;
			return;
		}
		sawTrackedInsertion = true;
		if (!trackedMarks.every((mark) => mark.type?.name === "trackInsert")) sawNonInsertionTrackedMark = true;
	});
	return sawTrackedInsertion && !sawUntrackedInline && !sawNonInsertionTrackedMark;
};
var getSingleTrackedInsertionMarkInRange = (doc$1, from$1, to) => {
	if (!rangeIsTrackedInsertionOnly(doc$1, from$1, to)) return null;
	const insertionMarks = [];
	const seenIds = /* @__PURE__ */ new Set();
	doc$1.nodesBetween(from$1, to, (node, pos) => {
		if (!node.isInline || !node.isLeaf) return;
		if (pos + node.nodeSize <= from$1 || pos >= to) return;
		const insertionMark = (node.marks ?? []).find((mark) => mark.type?.name === TrackInsertMarkName);
		const id = typeof insertionMark?.attrs?.id === "string" ? insertionMark.attrs.id : null;
		if (!insertionMark || !id || seenIds.has(id)) return;
		seenIds.add(id);
		insertionMarks.push(insertionMark);
	});
	return insertionMarks.length === 1 ? insertionMarks[0] : null;
};
var getSingleTrackedInsertionMarkAtCollapsedPosition = (doc$1, pos) => {
	const boundedPos = Math.max(0, Math.min(doc$1.content.size, pos));
	const $pos = doc$1.resolve(boundedPos);
	const beforeInsert = $pos.nodeBefore?.marks?.find((mark) => mark.type?.name === "trackInsert") ?? null;
	const afterInsert = $pos.nodeAfter?.marks?.find((mark) => mark.type?.name === "trackInsert") ?? null;
	const beforeId = typeof beforeInsert?.attrs?.id === "string" ? beforeInsert.attrs.id : null;
	const afterId = typeof afterInsert?.attrs?.id === "string" ? afterInsert.attrs.id : null;
	if (!beforeInsert || !afterInsert || !beforeId || beforeId !== afterId) return null;
	return beforeInsert;
};
var resolveDirectInsertionMutationCommentMeta = (state, tr) => {
	if (!tr.docChanged || tr.steps.length !== 1) return null;
	const [step] = tr.steps;
	if (!(step instanceof ReplaceStep)) return null;
	const docBeforeStep = (tr.docs ?? [])[0] ?? state.doc;
	const insertedMark = step.from !== step.to && step.slice.content.size === 0 ? getSingleTrackedInsertionMarkInRange(docBeforeStep, step.from, step.to) : step.from === step.to && step.slice.content.size > 0 ? getSingleTrackedInsertionMarkAtCollapsedPosition(docBeforeStep, step.from) : null;
	if (!insertedMark) return null;
	return {
		insertedMark,
		deletionMark: null,
		formatMark: null,
		deletionNodes: [],
		step,
		emitCommentEvent: true
	};
};
var collapsedPositionIsInsideTrackedReviewMark = (doc$1, pos) => {
	const boundedPos = Math.max(0, Math.min(doc$1.content.size, pos));
	const $pos = doc$1.resolve(boundedPos);
	const beforeKeys = trackedReviewMarkKeysForNode($pos.nodeBefore);
	if (!beforeKeys.size) return false;
	const afterKeys = trackedReviewMarkKeysForNode($pos.nodeAfter);
	for (const key of beforeKeys) if (afterKeys.has(key)) return true;
	return false;
};
var fragmentHasTrackedReviewMark = (fragment) => {
	let found = false;
	fragment.descendants?.((node) => {
		if (inlineNodeHasTrackedReviewMark(node)) {
			found = true;
			return false;
		}
	});
	return found;
};
var collapsedInsertionExtendsTrackedInsertion = (doc$1, pos, slice) => {
	const enclosingInsert = getSingleTrackedInsertionMarkAtCollapsedPosition(doc$1, pos);
	if (!enclosingInsert) return false;
	if (!slice.content) return true;
	const enclosingInsertId = typeof enclosingInsert.attrs?.id === "string" ? enclosingInsert.attrs.id : null;
	if (!enclosingInsertId) return false;
	let compatible = true;
	slice.content.descendants?.((node) => {
		if (!compatible || !node.isInline) return compatible ? void 0 : false;
		const trackedMarks = (node.marks ?? []).filter(isTrackedReviewMark);
		if (!trackedMarks.length) return;
		if (!trackedMarks.every((mark) => mark.type?.name === "trackInsert" && mark.attrs?.id === enclosingInsertId)) {
			compatible = false;
			return false;
		}
	});
	return compatible;
};
var collapsedInsertionExtendsTrackedReviewMark = (doc$1, pos, slice) => {
	if (!slice.content || !fragmentHasTrackedReviewMark(slice.content)) return false;
	const boundedPos = Math.max(0, Math.min(doc$1.content.size, pos));
	const $pos = doc$1.resolve(boundedPos);
	return trackedReviewMarkKeysForNode($pos.nodeBefore).size > 0 || trackedReviewMarkKeysForNode($pos.nodeAfter).size > 0;
};
var stepTouchesTrackedReviewState = (step, doc$1) => {
	if (step instanceof ReplaceStep) {
		if (step.from !== step.to && step.slice.content.size === 0 && rangeIsTrackedInsertionOnly(doc$1, step.from, step.to)) return false;
		if (step.from === step.to && step.slice.content.size > 0 && collapsedInsertionExtendsTrackedInsertion(doc$1, step.from, step.slice)) return false;
		if (rangeHasTrackedReviewMark(doc$1, step.from, step.to)) return true;
		if (step.from === step.to && step.slice.content.size > 0) return collapsedPositionIsInsideTrackedReviewMark(doc$1, step.from) || collapsedInsertionExtendsTrackedReviewMark(doc$1, step.from, step.slice);
		return false;
	}
	if (step instanceof AddMarkStep || step instanceof RemoveMarkStep) return rangeHasTrackedReviewMark(doc$1, step.from, step.to);
	if (step instanceof ReplaceAroundStep$1) return rangeHasTrackedReviewMark(doc$1, step.from, step.to) || rangeHasTrackedReviewMark(doc$1, step.gapFrom, step.gapTo);
	return false;
};
var transactionTouchesTrackedReviewState = (state, tr) => {
	if (!tr.docChanged || !tr.steps.length) return false;
	const docs = tr.docs ?? [];
	return tr.steps.some((step, index) => stepTouchesTrackedReviewState(step, docs[index] ?? state.doc));
};
var CONTENT_CONTROL_POINTER_WINDOW_MS = 800;
var cloneExtensionInstance = (extension) => {
	const extensionLike = extension;
	const config = extensionLike?.config;
	const ExtensionCtor = extensionLike?.constructor;
	if (!config || typeof config !== "object" || typeof ExtensionCtor !== "function") return extension;
	try {
		return new ExtensionCtor(config);
	} catch {
		return extension;
	}
};
function getCellContentWidthPx(cellNode) {
	const totalWidth = (cellNode.attrs?.colwidth ?? []).reduce((sum, w) => sum + (w || 0), 0);
	const margins = cellNode.attrs?.cellMargins;
	const leftMargin = margins?.left ?? 0;
	const rightMargin = margins?.right ?? 0;
	return Math.max(totalWidth - leftMargin - rightMargin, 0);
}
var Editor = class Editor extends EventEmitter {
	#commandService;
	#renderer = null;
	#isDestroyed = false;
	#editorLifecycleState = "initialized";
	#documentApi = null;
	#sourcePath = null;
	get currentTotalPages() {
		if (this.presentationEditor) {
			const pages = this.presentationEditor.getPages();
			return pages.length > 0 ? pages.length : void 0;
		}
	}
	#telemetry = null;
	#documentOpenTracked = false;
	#lastActiveContentControlRef = null;
	#lastPointerDownAt = 0;
	#constructorFragment = null;
	constructor(options) {
		super();
		this.extensionStorage = {};
		this.presentationEditor = null;
		this.isFocused = false;
		this.fontsImported = [];
		this.options = {
			element: null,
			selector: null,
			isHeadless: false,
			document: null,
			mockDocument: null,
			mockWindow: null,
			content: "",
			user: null,
			users: [],
			media: {},
			mediaFiles: {},
			fonts: {},
			documentMode: "editing",
			mode: "docx",
			role: "editor",
			colors: [],
			converter: null,
			fileSource: null,
			initialState: null,
			documentId: null,
			extensions: [],
			editable: true,
			editorProps: {},
			parseOptions: {},
			coreExtensionOptions: {},
			enableInputRules: true,
			isCommentsEnabled: false,
			isNewFile: false,
			scale: 1,
			viewOptions: { layout: "print" },
			annotations: false,
			isInternal: false,
			externalExtensions: [],
			isChildEditor: false,
			numbering: {},
			isHeaderOrFooter: false,
			lastSelection: null,
			suppressDefaultDocxStyles: false,
			jsonOverride: null,
			loadFromSchema: false,
			fragment: null,
			skipViewCreation: false,
			onBeforeCreate: () => null,
			onCreate: () => null,
			onUpdate: () => null,
			onSelectionUpdate: () => null,
			onTransaction: () => null,
			onFocus: () => null,
			onBlur: () => null,
			onDestroy: () => null,
			onContentError: ({ error }) => {
				throw error;
			},
			onTrackedChangesUpdate: () => null,
			onCommentsUpdate: () => null,
			onCommentsLoaded: () => null,
			onCommentClicked: () => null,
			onCommentLocationsUpdate: () => null,
			onPointerDown: () => null,
			onPointerUp: () => null,
			onRightClick: () => null,
			onDocumentLocked: () => null,
			onFirstRender: () => null,
			onCollaborationReady: () => null,
			onException: () => null,
			onListDefinitionsChange: () => null,
			onFontsResolved: null,
			handleImageUpload: null,
			customUpdatedFiles: {},
			isHeaderFooterChanged: false,
			isCustomXmlChanged: false,
			ydoc: null,
			collaborationProvider: null,
			collaborationIsReady: false,
			shouldLoadComments: false,
			replacedFile: false,
			focusTarget: null,
			permissionResolver: null,
			parentEditor: null,
			licenseKey: void 0,
			telemetry: { enabled: true }
		};
		const resolvedOptions = normalizeEditorTrackChangesOptions(options);
		const domAvailable = canUseDOM();
		const isHeadlessRequested = Boolean(resolvedOptions.isHeadless);
		const mountRequested = Boolean(resolvedOptions.element || resolvedOptions.selector);
		const domDocumentForImport = resolvedOptions.document ?? resolvedOptions.mockDocument ?? (domAvailable ? document : null);
		const requiresDomForImport = Boolean(resolvedOptions.html || resolvedOptions.markdown) || (resolvedOptions.mode === "text" || resolvedOptions.mode === "html") && typeof resolvedOptions.content === "string";
		if (!domDocumentForImport && requiresDomForImport) throw new Error("[super-editor] HTML/Markdown import requires a DOM. Provide { document } (e.g. from JSDOM), set DOM globals, or run in a browser environment.");
		if (!domAvailable && mountRequested && !isHeadlessRequested) throw new Error("[super-editor] Cannot mount an editor without a DOM. Provide DOM globals (e.g. via JSDOM) or pass { isHeadless: true }.");
		if (!domAvailable && !isHeadlessRequested) resolvedOptions.isHeadless = true;
		if (resolvedOptions.isHeadless) {
			resolvedOptions.element = null;
			resolvedOptions.selector = null;
		}
		this.#constructorFragment = resolvedOptions.fragment ?? null;
		this.#checkHeadless(resolvedOptions);
		this.setOptions(resolvedOptions);
		this.#renderer = resolvedOptions.renderer ?? (domAvailable ? new ProseMirrorRenderer() : null);
		this.#initTelemetry();
		const { setHighContrastMode } = useHighContrastMode();
		this.setHighContrastMode = setHighContrastMode;
		if (resolvedOptions.deferDocumentLoad === true) {
			this.#initCore();
			this.#editorLifecycleState = "initialized";
		} else {
			const modes = {
				docx: () => this.#init(),
				text: () => this.#initRichText(),
				html: () => this.#initRichText(),
				default: () => {
					console.log("Not implemented.");
				}
			};
			(modes[this.options.mode] ?? modes.default)();
			this.#editorLifecycleState = "ready";
		}
	}
	get docChanged() {
		return this.options.isHeaderFooterChanged || this.options.isCustomXmlChanged || !this.options.initialState.doc.eq(this.state.doc);
	}
	#initContainerElement(options) {
		this.#renderer?.initContainerElement?.(options);
	}
	#shouldMountRenderer() {
		return canUseDOM() && !this.options.isHeadless;
	}
	#getDomDocument() {
		return this.options.document ?? this.options.mockDocument ?? (canUseDOM() ? document : null);
	}
	#emitCreateAsync() {
		setTimeout(() => {
			if (this.isDestroyed) return;
			this.emit("create", { editor: this });
		}, 0);
		this.#trackDocumentOpen();
	}
	#initTelemetry() {
		const { telemetry: telemetryConfig, licenseKey } = this.options;
		if (typeof process$1 !== "undefined" && (process$1.env?.VITEST || process$1.env.NODE_ENV === "test")) return;
		if (this.options.mode === "text" || this.options.isHeaderOrFooter || this.options.isChildEditor) return;
		if (!telemetryConfig?.enabled) return;
		const resolvedLicenseKey = licenseKey !== void 0 ? licenseKey : telemetryConfig.licenseKey ?? "community-and-eval-agplv3";
		try {
			this.#telemetry = new Telemetry({
				enabled: true,
				endpoint: telemetryConfig.endpoint,
				licenseKey: resolvedLicenseKey,
				metadata: telemetryConfig.metadata
			});
			console.debug("[super-editor] Telemetry: enabled");
		} catch {}
	}
	#trackDocumentOpen() {
		this.getDocumentIdentifier().then((documentId) => {
			if (!this.#telemetry || this.#documentOpenTracked) return;
			try {
				const documentCreatedAt = this.converter?.getDocumentCreatedTimestamp?.() ?? null;
				this.#telemetry.trackDocumentOpen(documentId, documentCreatedAt);
				this.#documentOpenTracked = true;
			} catch {}
		});
	}
	#assertState(...allowed) {
		if (!allowed.includes(this.#editorLifecycleState)) throw new InvalidStateError(`Invalid operation: editor is in '${this.#editorLifecycleState}' state, expected one of: ${allowed.join(", ")}`);
	}
	async #withState(during, success, failure$5, operation) {
		this.#editorLifecycleState = during;
		try {
			const result = await operation();
			this.#editorLifecycleState = success;
			return result;
		} catch (error) {
			this.#editorLifecycleState = failure$5;
			throw error;
		}
	}
	#initCore() {
		if (!this.options.extensions?.length) this.options.extensions = this.options.mode === "docx" ? getStarterExtensions() : getRichTextExtensions();
		this.#createExtensionService();
		this.#createCommandService();
		this.#createSchema();
		this.#registerEventListeners();
	}
	#registerEventListeners() {
		this.on("create", this.options.onCreate);
		this.on("update", this.options.onUpdate);
		this.on("selectionUpdate", this.options.onSelectionUpdate);
		this.on("transaction", this.options.onTransaction);
		this.on("focus", this.#onFocus.bind(this));
		this.on("blur", this.options.onBlur);
		this.on("destroy", this.options.onDestroy);
		this.on("trackedChangesUpdate", this.options.onTrackedChangesUpdate);
		this.on("commentsLoaded", this.options.onCommentsLoaded);
		this.on("commentClick", this.options.onCommentClicked);
		this.on("commentsUpdate", this.options.onCommentsUpdate);
		this.on("locked", this.options.onDocumentLocked);
		this.on("collaborationReady", this.#onCollaborationReady.bind(this));
		this.on("comment-positions", this.options.onCommentLocationsUpdate);
		this.on("list-definitions-change", this.options.onListDefinitionsChange);
		this.on("fonts-resolved", this.options.onFontsResolved);
		if (this.options.onFontsChanged) this.on("fonts-changed", this.options.onFontsChanged);
		this.on("exception", this.options.onException);
		this.on("pointerDown", this.options.onPointerDown);
		this.#trackContentControlPointer();
		this.on("pointerUp", this.options.onPointerUp);
		this.on("rightClick", this.options.onRightClick);
	}
	#trackContentControlPointer() {
		this.on("pointerDown", () => {
			this.#lastPointerDownAt = Date.now();
		});
	}
	async #loadDocument(source, options) {
		try {
			const resolvedMode = options?.mode ?? this.options.mode ?? "docx";
			const explicitIsNewFile = options?.isNewFile;
			const hasOpenFragment = Object.prototype.hasOwnProperty.call(options ?? {}, "fragment");
			const resolvedOptions = {
				...this.options,
				mode: resolvedMode,
				isCommentsEnabled: options?.isCommentsEnabled ?? this.options.isCommentsEnabled,
				suppressDefaultDocxStyles: options?.suppressDefaultDocxStyles ?? this.options.suppressDefaultDocxStyles,
				documentMode: options?.documentMode ?? this.options.documentMode ?? "editing",
				html: options?.html,
				markdown: options?.markdown,
				jsonOverride: options?.json ?? null,
				fragment: hasOpenFragment ? options?.fragment ?? null : this.options.fragment ?? this.#constructorFragment
			};
			const loadOptions = options?.password ? { password: options.password } : void 0;
			if (typeof source === "string") if (typeof process$1 !== "undefined" && process$1.versions?.node) {
				const buffer = (init_empty(), __toCommonJS(empty_exports)).readFileSync(source);
				const [docx, _media, mediaFiles, fonts, decryptedData] = await Editor.loadXmlData(buffer, true, loadOptions);
				resolvedOptions.content = docx;
				resolvedOptions.mediaFiles = mediaFiles;
				resolvedOptions.fonts = fonts;
				resolvedOptions.fileSource = decryptedData ?? buffer;
				resolvedOptions.isNewFile = explicitIsNewFile ?? false;
				this.#sourcePath = decryptedData ? null : source;
			} else {
				const response = await fetch(source);
				if (!response.ok) {
					console.debug("[SuperDoc] Fetch failed:", response.status, response.statusText);
					throw new Error(`Fetch failed: ${response.status} ${response.statusText}`);
				}
				const blob = await response.blob();
				const [docx, _media, mediaFiles, fonts, decryptedData] = await Editor.loadXmlData(blob, false, loadOptions);
				resolvedOptions.content = docx;
				resolvedOptions.mediaFiles = mediaFiles;
				resolvedOptions.fonts = fonts;
				resolvedOptions.fileSource = decryptedData ?? blob;
				resolvedOptions.isNewFile = explicitIsNewFile ?? false;
				this.#sourcePath = source.split("/").pop() || null;
			}
			else if (source != null && typeof source === "object") {
				const isNodeBuffer = typeof Buffer !== "undefined" && (Buffer.isBuffer(source) || source instanceof Buffer);
				const isBlob = typeof Blob !== "undefined" && source instanceof Blob;
				const isArrayBuffer = source instanceof ArrayBuffer;
				const hasArrayBuffer = typeof source === "object" && "buffer" in source && source.buffer instanceof ArrayBuffer;
				if (isNodeBuffer || isBlob || isArrayBuffer || hasArrayBuffer) {
					const [docx, _media, mediaFiles, fonts, decryptedData] = await Editor.loadXmlData(source, isNodeBuffer, loadOptions);
					resolvedOptions.content = docx;
					resolvedOptions.mediaFiles = mediaFiles;
					resolvedOptions.fonts = fonts;
					resolvedOptions.fileSource = decryptedData ?? source;
					resolvedOptions.isNewFile = explicitIsNewFile ?? false;
					this.#sourcePath = null;
				} else {
					const [docx, _media, mediaFiles, fonts, decryptedData] = await Editor.loadXmlData(source, false, loadOptions);
					resolvedOptions.content = docx;
					resolvedOptions.mediaFiles = mediaFiles;
					resolvedOptions.fonts = fonts;
					resolvedOptions.fileSource = decryptedData ?? source;
					resolvedOptions.isNewFile = explicitIsNewFile ?? false;
					this.#sourcePath = null;
				}
			} else if (resolvedMode === "docx" && !options?.content && !options?.html && !options?.markdown) {
				const { content, mediaFiles, fonts, fileSource } = await this.#loadBlankDocxTemplate();
				resolvedOptions.content = content;
				resolvedOptions.mediaFiles = {
					...mediaFiles,
					...options?.mediaFiles ?? {}
				};
				resolvedOptions.fonts = {
					...fonts,
					...options?.fonts ?? {}
				};
				resolvedOptions.fileSource = fileSource;
				resolvedOptions.isNewFile = explicitIsNewFile ?? true;
				this.#sourcePath = null;
			} else {
				resolvedOptions.content = options?.content ?? [];
				resolvedOptions.mediaFiles = options?.mediaFiles ?? {};
				resolvedOptions.fonts = options?.fonts ?? {};
				resolvedOptions.fileSource = null;
				resolvedOptions.isNewFile = explicitIsNewFile ?? !options?.content;
				this.#sourcePath = null;
			}
			this.setOptions(resolvedOptions);
			this.#createConverter();
			initPartsRuntime(this);
			this.#initProtectionState();
			this.#initMedia();
			const shouldMountRenderer = this.#shouldMountRenderer();
			if (shouldMountRenderer) {
				this.#initContainerElement(this.options);
				this.#initFonts();
			}
			this.#createInitialState({ includePlugins: !shouldMountRenderer });
			if (!shouldMountRenderer) {
				const tr = this.state.tr.setMeta("forcePluginPass", true).setMeta("addToHistory", false);
				this.#dispatchTransaction(tr);
			}
			if (shouldMountRenderer) {
				this.mount(this.options.element);
				this.#configureStateWithExtensionPlugins();
			}
			if (!shouldMountRenderer) this.#emitCreateAsync();
			if (shouldMountRenderer) {
				this.initDefaultStyles();
				this.#checkFonts();
			}
			if (Boolean(this.options.markdown || this.options.html || this.options.loadFromSchema || this.options.jsonOverride || this.options.mode === "html" || this.options.mode === "text")) this.migrateListsToV2();
			this.setDocumentMode(this.options.documentMode, "init");
			this.#emitProtectionInit();
			this.initializeCollaborationData();
			if (!this.options.ydoc && !this.options.isChildEditor) this.#initComments();
			if (shouldMountRenderer) {
				this.#initDevTools();
				this.#registerCopyHandler();
			}
		} catch (error) {
			if (error instanceof DocxEncryptionError) {
				console.debug("[SuperDoc] Document load error:", error.message);
				throw error;
			}
			const err = error instanceof Error ? error : new Error(String(error));
			console.debug("[SuperDoc] Document load error:", err.message);
			throw new DocumentLoadError(`Failed to load document: ${err.message}`, err);
		}
	}
	#unloadDocument() {
		this.unmount();
		this.destroyHeaderFooterEditors();
		this.converter = void 0;
		if (this.storage.image) this.storage.image.media = {};
		const protStorageToReset = getProtectionStorage(this);
		if (protStorageToReset) {
			protStorageToReset.state = { ...DEFAULT_PROTECTION_STATE };
			protStorageToReset.initialized = false;
			protStorageToReset.editableBaseline = null;
		}
		this.#sourcePath = null;
		this.options.initialState = null;
		this.options.content = "";
		this.options.fileSource = null;
		this.options.fragment = null;
		this._state = void 0;
		this.#lastActiveContentControlRef = null;
		this.#lastPointerDownAt = 0;
	}
	#initProtectionState() {
		const protStorage = getProtectionStorage(this);
		if (!protStorage) return;
		protStorage.state = parseProtectionState(this.converter ? readSettingsRoot(this.converter) : null);
		protStorage.initialized = true;
	}
	#emitProtectionInit() {
		const protStorage = getProtectionStorage(this);
		if (!protStorage?.initialized) return;
		this.emit("protectionChanged", {
			editor: this,
			state: protStorage.state,
			source: "init"
		});
	}
	#init() {
		this.#createExtensionService();
		this.#createCommandService();
		this.#createSchema();
		this.#createConverter();
		initPartsRuntime(this);
		this.#initProtectionState();
		this.#initMedia();
		this.on("beforeCreate", this.options.onBeforeCreate);
		this.emit("beforeCreate", { editor: this });
		this.on("contentError", this.options.onContentError);
		const shouldMountRenderer = this.#shouldMountRenderer();
		this.#createInitialState({ includePlugins: !shouldMountRenderer });
		if (!shouldMountRenderer) {
			const tr = this.state.tr.setMeta("forcePluginPass", true).setMeta("addToHistory", false);
			this.#dispatchTransaction(tr);
		}
		if (shouldMountRenderer) {
			this.#initContainerElement(this.options);
			this.#initFonts();
			this.mount(this.options.element);
			this.#configureStateWithExtensionPlugins();
		}
		this.on("create", this.options.onCreate);
		this.on("update", this.options.onUpdate);
		this.on("selectionUpdate", this.options.onSelectionUpdate);
		this.on("transaction", this.options.onTransaction);
		this.on("focus", this.#onFocus.bind(this));
		this.on("blur", this.options.onBlur);
		this.on("destroy", this.options.onDestroy);
		this.on("trackedChangesUpdate", this.options.onTrackedChangesUpdate);
		this.on("commentsLoaded", this.options.onCommentsLoaded);
		this.on("commentClick", this.options.onCommentClicked);
		this.on("commentsUpdate", this.options.onCommentsUpdate);
		this.on("locked", this.options.onDocumentLocked);
		this.on("collaborationReady", this.#onCollaborationReady.bind(this));
		this.on("comment-positions", this.options.onCommentLocationsUpdate);
		this.on("list-definitions-change", this.options.onListDefinitionsChange);
		this.on("fonts-resolved", this.options.onFontsResolved);
		if (this.options.onFontsChanged) this.on("fonts-changed", this.options.onFontsChanged);
		this.on("exception", this.options.onException);
		this.on("pointerDown", this.options.onPointerDown);
		this.#trackContentControlPointer();
		this.on("pointerUp", this.options.onPointerUp);
		this.on("rightClick", this.options.onRightClick);
		if (!shouldMountRenderer) this.#emitCreateAsync();
		this.initializeCollaborationData();
		if (shouldMountRenderer) {
			this.initDefaultStyles();
			this.#checkFonts();
		}
		if (Boolean(this.options.markdown || this.options.html || this.options.loadFromSchema || this.options.jsonOverride || this.options.mode === "html" || this.options.mode === "text")) this.migrateListsToV2();
		this.setDocumentMode(this.options.documentMode, "init");
		this.#emitProtectionInit();
		if (!this.options.ydoc && !this.options.isChildEditor) this.#initComments();
		if (shouldMountRenderer) {
			this.#initDevTools();
			this.#registerCopyHandler();
		}
	}
	#initRichText() {
		if (!this.options.extensions || !this.options.extensions.length) this.options.extensions = getRichTextExtensions();
		this.#createExtensionService();
		this.#createCommandService();
		this.#createSchema();
		this.on("beforeCreate", this.options.onBeforeCreate);
		this.emit("beforeCreate", { editor: this });
		this.on("contentError", this.options.onContentError);
		const shouldMountRenderer = this.#shouldMountRenderer();
		this.#createInitialState({ includePlugins: !shouldMountRenderer });
		if (shouldMountRenderer) {
			this.#initContainerElement(this.options);
			this.mount(this.options.element);
			this.#configureStateWithExtensionPlugins();
		}
		this.on("create", this.options.onCreate);
		this.on("update", this.options.onUpdate);
		this.on("selectionUpdate", this.options.onSelectionUpdate);
		this.on("transaction", this.options.onTransaction);
		this.on("focus", this.#onFocus.bind(this));
		this.on("blur", this.options.onBlur);
		this.on("destroy", this.options.onDestroy);
		this.on("commentsLoaded", this.options.onCommentsLoaded);
		this.on("commentClick", this.options.onCommentClicked);
		this.on("locked", this.options.onDocumentLocked);
		this.on("list-definitions-change", this.options.onListDefinitionsChange);
		this.on("pointerDown", this.options.onPointerDown);
		this.#trackContentControlPointer();
		this.on("pointerUp", this.options.onPointerUp);
		this.on("rightClick", this.options.onRightClick);
		if (!shouldMountRenderer) this.#emitCreateAsync();
	}
	mount(el) {
		this.#createView(el);
		setTimeout(() => {
			if (this.isDestroyed) return;
			this.emit("create", { editor: this });
		}, 0);
		this.#trackDocumentOpen();
	}
	unmount() {
		if (this.#renderer) this.#renderer.destroy();
		else if (this.view) this.view.destroy();
		this.view = void 0;
	}
	#onFocus({ editor, event }) {
		this.toolbar?.setActiveEditor?.(editor);
		this.options.onFocus?.({
			editor,
			event
		});
	}
	setToolbar(toolbar) {
		this.toolbar = toolbar;
	}
	#checkHeadless(options) {
		if (!options.isHeadless) return;
		if (typeof navigator === "undefined") global.navigator = {
			platform: "node",
			userAgent: "Node.js"
		};
		if (options.mockDocument) {
			console.warn("[super-editor] `mockDocument` is deprecated and will be removed in a future version. Use `document` instead (e.g., `new Editor({ document: jsdomDocument })`). See https://docs.superdoc.dev/guide/headless for migration guidance.");
			global.document = options.mockDocument;
		}
		if (options.mockWindow) {
			console.warn("[super-editor] `mockWindow` is deprecated and will be removed in a future version. Prefer passing `document` only. Global window assignment is no longer required for headless mode.");
			global.window = options.mockWindow;
		}
	}
	isWebLayout() {
		return this.options.viewOptions?.layout === "web";
	}
	focus() {
		this.view?.focus();
	}
	get state() {
		return this._state;
	}
	get lifecycleState() {
		return this.#editorLifecycleState;
	}
	get sourcePath() {
		return this.#sourcePath;
	}
	setState(newState) {
		this._state = newState;
		if (this.view && !this.view.isDestroyed) this.view.updateState(newState);
	}
	get storage() {
		return this.extensionStorage;
	}
	get commands() {
		return this.#commandService?.commands;
	}
	get doc() {
		this.#assertState("ready", "saving");
		if (!this.#documentApi) this.#documentApi = createDocumentApi(getDocumentApiAdapters(this));
		return this.#documentApi;
	}
	#getDefaultSelectionHandleSurface() {
		const explicitType = this.options.headerFooterType;
		return explicitType === "header" || explicitType === "footer" ? explicitType : "body";
	}
	captureCurrentSelectionHandle(surface) {
		this.#assertState("ready", "saving");
		const selection = selectCurrentPmSelection(this);
		return captureSelectionHandle(this, selection, surface ?? this.#getDefaultSelectionHandleSurface());
	}
	captureEffectiveSelectionHandle(surface) {
		this.#assertState("ready", "saving");
		const selection = selectEffectivePmSelection(this);
		return captureSelectionHandle(this, selection, surface ?? this.#getDefaultSelectionHandleSurface());
	}
	resolveSelectionHandle(handle) {
		this.#assertState("ready", "saving");
		const selection = resolveHandleToSelection(handle);
		if (!selection) return null;
		return resolvePmSelectionToRange(handle._owner, selection);
	}
	releaseSelectionHandle(handle) {
		this.#assertState("ready", "saving");
		releaseSelectionHandle(handle);
	}
	getCurrentSelectionRange() {
		this.#assertState("ready", "saving");
		return resolveCurrentEditorSelectionRange(this);
	}
	getEffectiveSelectionRange() {
		this.#assertState("ready", "saving");
		return resolveEffectiveEditorSelectionRange(this);
	}
	get helpers() {
		return this.extensionService.helpers;
	}
	get isEditable() {
		return Boolean(this.options.editable && this.view && this.view.editable);
	}
	get isDestroyed() {
		return Boolean(this.#isDestroyed || this.view?.isDestroyed);
	}
	get element() {
		return this.options.element;
	}
	get users() {
		return this.options.users;
	}
	chain() {
		return this.#commandService.chain();
	}
	can() {
		return this.#commandService.can();
	}
	setDocumentMode(documentMode, _caller) {
		if (this.options.isHeaderOrFooter || this.options.isChildEditor) return;
		let cleanedMode = documentMode?.toLowerCase() || "editing";
		if (!this.extensionService || !this.state) return;
		const pm = this.view?.dom || this.options.element?.querySelector?.(".ProseMirror");
		if (this.options.role === "viewer") cleanedMode = "viewing";
		if (this.options.role === "suggester" && cleanedMode === "editing") cleanedMode = "suggesting";
		if (cleanedMode === "viewing") {
			this.commands.toggleTrackChangesShowOriginal?.();
			const normalizedSelection = getViewModeSelectionWithoutStructuredContent(this.state);
			if (normalizedSelection) this.view?.dispatch(this.state.tr.setSelection(normalizedSelection));
			this.setEditable(false, false);
			this.setOptions({ documentMode: "viewing" });
			if (pm) pm.classList.add("view-mode");
		} else if (cleanedMode === "suggesting") {
			this.commands.disableTrackChangesShowOriginal?.();
			this.commands.enableTrackChanges?.();
			this.setOptions({ documentMode: "suggesting" });
			this.setEditable(true, false);
			if (pm) pm.classList.remove("view-mode");
		} else if (cleanedMode === "editing") {
			this.commands.disableTrackChangesShowOriginal?.();
			this.commands.disableTrackChanges?.();
			this.setEditable(true, false);
			this.setOptions({ documentMode: "editing" });
			if (pm) pm.classList.remove("view-mode");
		}
		applyEffectiveEditability(this);
		this.emit("documentModeChange", {
			editor: this,
			documentMode: cleanedMode
		});
	}
	blur() {
		this.view?.dom?.blur();
	}
	hasFocus() {
		if (this.view) return this.view.hasFocus();
		return false;
	}
	coordsAtPos(pos) {
		if (this.presentationEditor) return this.presentationEditor.coordsAtPos(pos);
		if (this.view) return this.view.coordsAtPos(pos);
		return null;
	}
	getElementAtPos(pos, options = {}) {
		if (this.presentationEditor) return this.presentationEditor.getElementAtPos(pos, options);
		if (!this.view) return null;
		if (!Number.isFinite(pos)) return null;
		const maxPos = this.view.state.doc.content.size;
		const clampedPos = Math.max(0, Math.min(pos, maxPos));
		try {
			const { node } = this.view.domAtPos(clampedPos);
			if (node && node.nodeType === 1) return node;
			if (node && node.nodeType === 3) return node.parentElement;
			return node?.parentElement ?? null;
		} catch {
			return null;
		}
	}
	posAtCoords(coords) {
		if (typeof this.presentationEditor?.hitTest === "function") {
			const coordsObj = coords;
			const clientX = coordsObj?.clientX ?? coordsObj?.left ?? coordsObj?.x ?? null;
			const clientY = coordsObj?.clientY ?? coordsObj?.top ?? coordsObj?.y ?? null;
			if (Number.isFinite(clientX) && Number.isFinite(clientY)) {
				const hit = this.presentationEditor.hitTest(clientX, clientY);
				if (hit) return {
					pos: hit.pos,
					inside: hit.pos
				};
			}
		}
		if (this.view) return this.view.posAtCoords(coords);
		return null;
	}
	#registerCopyHandler() {
		this.#renderer?.registerCopyHandler?.(this);
	}
	async generateCollaborationUpdate() {
		return await generateCollaborationData(this);
	}
	initializeCollaborationData() {
		if (!this.options.isNewFile || !this.options.collaborationProvider) return;
		onCollaborationProviderSynced(this.options.collaborationProvider, () => {
			this.#insertNewFileData();
		});
	}
	replaceContent(content) {
		this.setOptions({ content });
		this.#createConverter();
		this.initDefaultStyles();
		this.#createConverter();
		initPartsRuntime(this);
		this.#initMedia();
		const doc$1 = this.#generatePmData();
		const tr = this.state.tr.replaceWith(0, this.state.doc.content.size, doc$1);
		tr.setMeta("replaceContent", true);
		this.#dispatchTransaction(tr);
	}
	#syncDocumentAttrs(nextAttrs = {}) {
		const currentAttrs = this.state.doc?.attrs ?? {};
		const docAttrSpecs = this.schema?.topNodeType?.spec?.attrs ?? {};
		const attrKeys = new Set([
			...Object.keys(docAttrSpecs),
			...Object.keys(currentAttrs),
			...Object.keys(nextAttrs)
		]);
		if (attrKeys.size === 0) return;
		const valuesMatch = (a, b$1) => a === b$1 || JSON.stringify(a) === JSON.stringify(b$1);
		const tr = this.state.tr.setMeta("addToHistory", false);
		let changed = false;
		for (const key of attrKeys) {
			const nextValue = Object.prototype.hasOwnProperty.call(nextAttrs, key) ? nextAttrs[key] : docAttrSpecs[key]?.default;
			if (valuesMatch(currentAttrs[key], nextValue)) continue;
			tr.setDocAttribute(key, nextValue);
			changed = true;
		}
		if (changed) this.#dispatchTransaction(tr);
	}
	#insertNewFileData() {
		if (!this.options.isNewFile) return;
		this.options.isNewFile = false;
		const doc$1 = this.#generatePmData();
		const nextBodySectPr = JSON.parse(JSON.stringify(doc$1.attrs?.bodySectPr ?? null));
		const tr = this.state.tr.replaceWith(0, this.state.doc.content.size, doc$1).setMeta("addToHistory", false);
		this.#dispatchTransaction(tr);
		const ydoc = this.options.ydoc;
		if (ydoc) ydoc.getMap("meta").set("bodySectPr", nextBodySectPr);
		this.#syncDocumentAttrs(doc$1.attrs ?? {});
		setTimeout(() => {
			this.#initComments();
		}, 50);
	}
	setOptions(options = {}) {
		const previousOptions = this.options ?? {};
		const nextOptions = {
			...previousOptions,
			...options
		};
		const previousDescriptors = Object.getOwnPropertyDescriptors(previousOptions);
		for (const [key, descriptor] of Object.entries(previousDescriptors)) {
			if (descriptor.enumerable) continue;
			if (Object.prototype.hasOwnProperty.call(options, key)) continue;
			Object.defineProperty(nextOptions, key, descriptor);
		}
		this.options = nextOptions;
		if ((this.options.isNewFile || !this.options.ydoc) && this.options.isCommentsEnabled) this.options.shouldLoadComments = true;
		if (!this.view || !this.state || this.isDestroyed) return;
		if (this.options.editorProps) this.view.setProps(this.options.editorProps);
		this.view.updateState(this.state);
	}
	setEditable(editable = true, emitUpdate = true) {
		this.setOptions({ editable });
		if (this.view) {
			this.view.setProps({});
			if (!editable && this.view.dom) this.view.dom.blur();
		}
		if (emitUpdate && this.state) this.emit("update", {
			editor: this,
			transaction: this.state.tr
		});
	}
	registerPlugin(plugin, handlePlugins) {
		if (this.isDestroyed) return;
		if (!this.state?.plugins) return;
		const plugins = typeof handlePlugins === "function" ? handlePlugins(plugin, [...this.state.plugins]) : [...this.state.plugins, plugin];
		this._state = this.state.reconfigure({ plugins });
		this.view?.updateState(this._state);
	}
	#getPluginKeyName(plugin) {
		const pluginKey = plugin.key;
		return typeof pluginKey?.key === "string" ? pluginKey.key : "";
	}
	unregisterPlugin(nameOrPluginKey) {
		if (this.isDestroyed) return;
		const name = typeof nameOrPluginKey === "string" ? `${nameOrPluginKey}$` : nameOrPluginKey?.key ?? "";
		this._state = this.state.reconfigure({ plugins: this.state.plugins.filter((plugin) => !this.#getPluginKeyName(plugin).startsWith(name)) });
		this.view?.updateState(this._state);
	}
	attachCollaboration({ ydoc, collaborationProvider }) {
		if (this.isDestroyed) throw new Error("[super-editor] Cannot attach collaboration to a destroyed editor");
		if (this.options.ydoc) throw new Error("[super-editor] Editor already has collaboration attached");
		if (this.options.isHeadless) throw new Error("[super-editor] attachCollaboration is not supported in headless mode");
		const prevProvider = this.options.collaborationProvider;
		const prevShouldLoadComments = this.options.shouldLoadComments;
		const prevCollaborationIsReady = this.options.collaborationIsReady;
		const prevState = this._state;
		const rollback = () => {
			cleanupCollaborationSideEffects(this);
			this.options.ydoc = void 0;
			this.options.collaborationProvider = prevProvider;
			this.options.shouldLoadComments = prevShouldLoadComments;
			this.options.collaborationIsReady = prevCollaborationIsReady;
			this._state = prevState;
			this.view?.updateState(prevState);
		};
		this.options.ydoc = ydoc;
		this.options.collaborationProvider = collaborationProvider;
		this.options.shouldLoadComments = false;
		let plugins;
		try {
			plugins = [...this.extensionService.plugins];
		} catch (err) {
			rollback();
			throw err;
		}
		try {
			this._state = this.state.reconfigure({ plugins });
			this.view?.updateState(this._state);
		} catch (err) {
			rollback();
			throw err;
		}
	}
	#createExtensionService() {
		const allowedExtensions = [
			"extension",
			"node",
			"mark"
		];
		const coreExtensions = [
			Editable,
			Commands,
			EditorFocus,
			Keymap,
			PositionTrackerExtension,
			SelectionHandleExtension
		];
		const externalExtensions = this.options.externalExtensions || [];
		const allExtensions = [...coreExtensions, ...this.options.extensions].filter((extension) => {
			const extensionType = typeof extension?.type === "string" ? extension.type : void 0;
			return extensionType ? allowedExtensions.includes(extensionType) : false;
		}).map((extension) => cloneExtensionInstance(extension));
		const isolatedExternalExtensions = externalExtensions.map((extension) => cloneExtensionInstance(extension));
		this.extensionService = ExtensionService.create(allExtensions, isolatedExternalExtensions, this);
	}
	#createCommandService() {
		this.#commandService = CommandService.create({ editor: this });
	}
	#createConverter() {
		if (this.options.converter) this.converter = this.options.converter;
		else this.converter = new SuperConverter({
			docx: this.options.content,
			media: this.options.mediaFiles,
			fonts: this.options.fonts,
			debug: true,
			fileSource: this.options.fileSource,
			documentId: this.options.documentId,
			mockWindow: this.options.mockWindow ?? null,
			mockDocument: this.options.mockDocument ?? null,
			isNewFile: this.options.isNewFile ?? false,
			trackedChangesOptions: this.options.trackedChanges ?? null
		});
	}
	async #loadBlankDocxTemplate() {
		const arrayBuffer = await getArrayBufferFromUrl(BLANK_DOCX_DATA_URI);
		const canUseBuffer = typeof process$1 !== "undefined" && !!process$1.versions?.node && typeof Buffer !== "undefined";
		const uint8Array = new Uint8Array(arrayBuffer);
		let fileSource;
		if (canUseBuffer) fileSource = Buffer.from(uint8Array);
		else if (typeof Blob !== "undefined") fileSource = new Blob([uint8Array]);
		else throw new Error("Blob is not available to create blank DOCX");
		const [content, _media, mediaFiles, fonts] = await Editor.loadXmlData(fileSource, canUseBuffer);
		return {
			content,
			mediaFiles,
			fonts,
			fileSource
		};
	}
	async #getBaseDocxEntriesForExport() {
		if (Array.isArray(this.options.content)) return this.options.content;
		const blankDocx = await this.#loadBlankDocxTemplate();
		this.options.content = blankDocx.content;
		this.options.mediaFiles = {
			...blankDocx.mediaFiles,
			...this.options.mediaFiles ?? {}
		};
		this.options.fonts = {
			...blankDocx.fonts,
			...this.options.fonts ?? {}
		};
		return blankDocx.content;
	}
	#initMedia() {
		if (this.options.isChildEditor) return;
		if (!this.options.ydoc) {
			this.storage.image.media = this.options.mediaFiles;
			return;
		}
		const mediaMap = this.options.ydoc.getMap("media");
		if (this.options.isNewFile) {
			Object.entries(this.options.mediaFiles).forEach(([key, value]) => {
				mediaMap.set(key, value);
			});
			this.storage.image.media = this.options.mediaFiles;
		} else this.storage.image.media = Object.fromEntries(mediaMap.entries());
	}
	#initFonts() {
		this.#renderer?.initFonts?.(this);
	}
	async #checkFonts() {
		if (!this.options.onFontsResolved || typeof this.options.onFontsResolved !== "function") return;
		if (this.options.isHeadless) return;
		try {
			const fontsUsedInDocument = this.converter.getDocumentFonts();
			const payload = {
				documentFonts: fontsUsedInDocument,
				unsupportedFonts: this.#determineUnsupportedFonts(fontsUsedInDocument)
			};
			this.emit("fonts-resolved", payload);
		} catch {
			console.warn("[SuperDoc] Could not determine document fonts and unsupported fonts");
		}
	}
	#determineUnsupportedFonts(fonts) {
		return fonts.filter((font) => {
			const canRender = canRenderFont(font);
			const isFontImported = this.fontsImported.includes(font);
			return !canRender && !isFontImported;
		});
	}
	static async loadXmlData(fileSource, isNode$1 = false, options) {
		if (!fileSource) return;
		const zipper = new DocxZipper_default();
		return [
			await zipper.getDocxData(fileSource, isNode$1, { password: options?.password }),
			zipper.media,
			zipper.mediaFiles,
			zipper.fonts,
			zipper.decryptedFileData
		];
	}
	static getDocumentVersion(doc$1) {
		return SuperConverter.getStoredSuperdocVersion(doc$1);
	}
	static setDocumentVersion(doc$1, version$1) {
		const result = SuperConverter.setStoredSuperdocVersion(doc$1, version$1);
		if (typeof result === "string") return result;
		return version$1;
	}
	static getDocumentGuid(doc$1) {
		return SuperConverter.extractDocumentGuid(doc$1);
	}
	static updateDocumentVersion(doc$1, version$1) {
		console.warn("updateDocumentVersion is deprecated, use setDocumentVersion instead");
		return Editor.setDocumentVersion(doc$1, version$1);
	}
	async getSchemaSummaryJSON() {
		if (!this.schema) throw new Error("Schema is not initialized.");
		const schemaVersion = this.converter?.getSuperdocVersion?.() || "current";
		const suppressedNames = new Set((this.extensionService?.extensions || []).filter((ext) => {
			const suppressFlag = (ext?.config)?.excludeFromSummaryJSON;
			return Boolean(suppressFlag);
		}).map((ext) => ext.name));
		const summary = buildSchemaSummary(this.schema, schemaVersion);
		if (!suppressedNames.size) return summary;
		return {
			...summary,
			nodes: summary.nodes.filter((node) => !suppressedNames.has(node.name)),
			marks: summary.marks.filter((mark) => !suppressedNames.has(mark.name))
		};
	}
	validateJSON(doc$1) {
		if (!this.schema) throw new Error("Schema is not initialized.");
		try {
			if (Array.isArray(doc$1)) return doc$1.map((d) => this.schema.nodeFromJSON(d));
			return this.schema.nodeFromJSON(doc$1);
		} catch (error) {
			const detail = error instanceof Error ? error.message : String(error);
			const validationError = /* @__PURE__ */ new Error(`Invalid document for current schema: ${detail}`);
			if (error instanceof Error) validationError.cause = error;
			throw validationError;
		}
	}
	#createSchema() {
		this.schema = this.extensionService.schema;
	}
	#generatePmData() {
		let doc$1;
		try {
			const { mode, content, fragment, loadFromSchema } = this.options;
			const domDocument = this.#getDomDocument();
			const hasJsonContent = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
			if (mode === "docx") if (loadFromSchema && hasJsonContent(content)) {
				doc$1 = this.schema.nodeFromJSON(content);
				doc$1 = this.#prepareDocumentForImport(doc$1);
			} else {
				doc$1 = createDocument(this.converter, this.schema, this);
				doc$1 = this.#prepareDocumentForImport(doc$1);
				if (this.options.markdown) doc$1 = createDocFromMarkdown(this.options.markdown, this, {
					isImport: true,
					document: domDocument,
					onUnsupportedContent: this.options.onUnsupportedContent,
					warnOnUnsupportedContent: this.options.warnOnUnsupportedContent
				});
				else if (this.options.html) doc$1 = createDocFromHTML(this.options.html, this, {
					isImport: true,
					document: domDocument,
					onUnsupportedContent: this.options.onUnsupportedContent,
					warnOnUnsupportedContent: this.options.warnOnUnsupportedContent
				});
				else if (this.options.jsonOverride) doc$1 = this.schema.nodeFromJSON(this.options.jsonOverride);
				if (fragment) {
					normalizeYjsFragmentForSchema(fragment);
					doc$1 = yXmlFragmentToProseMirrorRootNode(fragment, this.schema);
				}
			}
			else if (mode === "text" || mode === "html") if (loadFromSchema && hasJsonContent(content)) doc$1 = this.schema.nodeFromJSON(content);
			else if (typeof content === "string") doc$1 = createDocFromHTML(content, this, {
				document: domDocument,
				onUnsupportedContent: this.options.onUnsupportedContent,
				warnOnUnsupportedContent: this.options.warnOnUnsupportedContent
			});
			else doc$1 = this.schema.topNodeType.createAndFill();
		} catch (err) {
			console.error(err);
			const error = err instanceof Error ? err : new Error(String(err));
			this.emit("contentError", {
				editor: this,
				error
			});
		}
		return doc$1;
	}
	#createInitialState({ includePlugins = false } = {}) {
		if (this._state) return;
		const doc$1 = this.#generatePmData();
		const config = { schema: this.schema };
		if (!this.options.ydoc) config.doc = doc$1;
		let initialState = EditorState.create(config);
		if (includePlugins) initialState = initialState.reconfigure({ plugins: [...this.extensionService.plugins] });
		this.options.initialState = initialState;
		this._state = initialState;
	}
	#configureStateWithExtensionPlugins() {
		const configuredState = this.state.reconfigure({ plugins: [...this.extensionService.plugins] });
		this._state = configuredState;
		this.view?.updateState(configuredState);
	}
	#createView(element) {
		if (!this._state) this.#createInitialState();
		if (!this.#renderer) {
			if (!canUseDOM()) throw new Error("[super-editor] Cannot create an editor view without a renderer.");
			this.#renderer = new ProseMirrorRenderer();
		}
		this.view = this.#renderer.attach({
			element,
			editorProps: this.options.editorProps,
			dispatchTransaction: this.#dispatchTransaction.bind(this),
			state: this.state,
			handleClick: this.#handleNodeSelection.bind(this)
		});
		this.createNodeViews();
	}
	createNodeViews() {
		if (this.options.skipViewCreation || typeof this.view?.setProps !== "function") return;
		this.view.setProps({ nodeViews: this.extensionService.nodeViews });
	}
	getMaxContentSize() {
		const localPageStyles = this.converter?.pageStyles;
		const parentPageStyles = this.options.parentEditor?.converter?.pageStyles;
		const localPageSize = localPageStyles?.pageSize;
		const pageStyles$1 = localPageSize?.width && localPageSize?.height ? localPageStyles : parentPageStyles ?? localPageStyles;
		if (!pageStyles$1) return {};
		let cellConstraintWidth = 0;
		const { $head } = this.state.selection;
		for (let d = $head.depth; d > 0; d--) {
			const node = $head.node(d);
			if (node.type.name === "tableCell" || node.type.name === "tableHeader") {
				cellConstraintWidth = getCellContentWidthPx(node);
				break;
			}
		}
		if (this.isWebLayout()) {
			if (cellConstraintWidth > 0) return {
				width: cellConstraintWidth,
				height: Infinity
			};
			return {};
		}
		const { pageSize = {}, pageMargins = {} } = pageStyles$1;
		const { width, height } = pageSize;
		if (!width || !height) return {};
		const getMarginPx = (side) => {
			return (pageMargins?.[side] ?? 0) * PIXELS_PER_INCH;
		};
		const topPx = getMarginPx("top");
		const bottomPx = getMarginPx("bottom");
		const leftPx = getMarginPx("left");
		const rightPx = getMarginPx("right");
		const maxHeight = height * PIXELS_PER_INCH - topPx - bottomPx - MAX_HEIGHT_BUFFER_PX;
		const maxWidth = width * PIXELS_PER_INCH - leftPx - rightPx - MAX_WIDTH_BUFFER_PX;
		if (cellConstraintWidth > 0) return {
			width: cellConstraintWidth,
			height: maxHeight
		};
		return {
			width: maxWidth,
			height: maxHeight
		};
	}
	updateEditorStyles(element, proseMirror) {
		this.#renderer?.updateEditorStyles?.(this, element, proseMirror);
	}
	initDefaultStyles(element = this.element) {
		if (this.options.isHeadless || this.options.suppressDefaultDocxStyles) return;
		this.#renderer?.initDefaultStyles?.(this, element);
	}
	initMobileStyles(element) {
		this.#renderer?.initMobileStyles?.(this, element);
	}
	#onCollaborationReady({ editor, ydoc }) {
		if (this.options.collaborationIsReady) return;
		if (this.isDestroyed || !this.converter || !this.state) return;
		console.debug("🔗 [super-editor] Collaboration ready");
		this.#validateDocumentInit();
		if (this.options.ydoc) this.migrateListsToV2();
		this.options.onCollaborationReady({
			editor,
			ydoc
		});
		this.options.collaborationIsReady = true;
		this.options.initialState = this.state;
		const { tr } = this.state;
		tr.setMeta("collaborationReady", true);
		this.#dispatchTransaction(tr);
		if (!this.options.isNewFile) this.#initComments();
	}
	#initComments() {
		if (!this.options.isCommentsEnabled) return;
		if (!this.options.shouldLoadComments) return;
		if (!this.converter) return;
		const replacedFile = this.options.replacedFile;
		this.emit("commentsLoaded", {
			editor: this,
			replacedFile,
			comments: this.converter.comments || []
		});
		this.options.replacedFile = false;
		if (this.options.isHeadless) return;
		setTimeout(() => {
			const st = this.state;
			if (!st) return;
			const tr = st.tr.setMeta(CommentsPluginKey, { type: "force" });
			this.#dispatchTransaction(tr);
		}, 50);
	}
	#dispatchTransaction(transaction) {
		if (this.isDestroyed) return;
		const perf = this.view?.dom?.ownerDocument?.defaultView?.performance ?? globalThis.performance;
		const perfNow = () => perf?.now ? perf.now() : Date.now();
		const perfStart = perfNow();
		const prevState = this.state;
		let nextState;
		let transactionToApply = transaction;
		let effectiveTransaction = transaction;
		const forceTrackChanges = transactionToApply.getMeta("forceTrackChanges") === true;
		try {
			const isTrackChangesActive$1 = TrackChangesBasePluginKey.getState(prevState)?.isTrackChangesActive ?? false;
			const skipTrackChanges = transactionToApply.getMeta("skipTrackChanges") === true;
			const directInsertionMutationCommentMeta = resolveDirectInsertionMutationCommentMeta(prevState, transactionToApply);
			const protectsExistingTrackedReviewState = transactionTouchesTrackedReviewState(prevState, transactionToApply);
			if (protectsExistingTrackedReviewState && skipTrackChanges) transactionToApply.setMeta("protectTrackedReviewState", true);
			const shouldTrack = (isTrackChangesActive$1 || forceTrackChanges) && !skipTrackChanges || protectsExistingTrackedReviewState;
			if (!shouldTrack && directInsertionMutationCommentMeta && !transactionToApply.getMeta(TrackChangesBasePluginKey)) transactionToApply.setMeta(TrackChangesBasePluginKey, directInsertionMutationCommentMeta);
			if (shouldTrack && forceTrackChanges && !this.options.user) throw new Error("forceTrackChanges requires a user to be configured on the editor instance.");
			const trackedUser = this.options.user ?? {};
			transactionToApply = shouldTrack ? trackedTransaction({
				tr: transactionToApply,
				state: prevState,
				user: trackedUser,
				replacements: this.options.trackedChanges?.replacements === "independent" ? "independent" : "paired"
			}) : transactionToApply;
			const { state: appliedState, transactions: appliedTransactions } = prevState.applyTransaction(transactionToApply);
			nextState = appliedState;
			effectiveTransaction = appliedTransactions.find((t) => t.docChanged) ?? transactionToApply;
		} catch (error) {
			if (forceTrackChanges) throw error;
			nextState = prevState.apply(transactionToApply);
			console.log(error);
		}
		const selectionHasChanged = !prevState.selection.eq(nextState.selection);
		this._state = nextState;
		if (this.view) this.view.updateState(nextState);
		const end$1 = perfNow();
		this.emit("transaction", {
			editor: this,
			transaction: transactionToApply,
			duration: end$1 - perfStart
		});
		if (selectionHasChanged) this.emit("selectionUpdate", {
			editor: this,
			transaction: transactionToApply
		});
		this.#emitContentControlEvents({
			transaction: transactionToApply,
			nextState,
			selectionHasChanged
		});
		const focus = transactionToApply.getMeta("focus");
		if (focus) this.emit("focus", {
			editor: this,
			event: focus.event,
			transaction: transactionToApply
		});
		const blur = transactionToApply.getMeta("blur");
		if (blur) this.emit("blur", {
			editor: this,
			event: blur.event,
			transaction: transactionToApply
		});
		if (effectiveTransaction.docChanged) {
			if (transaction.docChanged && this.converter) {
				if (!this.converter.documentGuid) {
					this.converter.promoteToGuid();
					console.debug("Document modified - assigned GUID:", this.converter.documentGuid);
				}
				this.converter.documentModified = true;
			}
			this.emit("update", {
				editor: this,
				transaction: effectiveTransaction
			});
		}
	}
	#emitContentControlEvents({ transaction, nextState, selectionHasChanged }) {
		const uiEvent = transaction.getMeta("uiEvent");
		const recentPointerDown = Date.now() - this.#lastPointerDownAt <= CONTENT_CONTROL_POINTER_WINDOW_MS;
		const source = uiEvent === "click" || recentPointerDown ? "pointer" : "keyboard";
		const activePath = nextState.selection ? this.#collectActiveSdtRefs(nextState.selection) : [];
		const activeContentControl = activePath[0] ?? null;
		if (selectionHasChanged) {
			const previous = this.#lastActiveContentControlRef;
			if (previous?.id !== activeContentControl?.id) {
				if (activeContentControl) this.emit("contentControlFocus", {
					active: activeContentControl,
					previous,
					activePath,
					source
				});
				else if (previous) this.emit("contentControlBlur", {
					active: null,
					previous,
					activePath: [],
					source
				});
				this.#lastActiveContentControlRef = activeContentControl;
			}
		}
		if (uiEvent === "click" && activeContentControl) this.emit("contentControlClick", {
			target: activeContentControl,
			source: "pointer"
		});
	}
	#collectActiveSdtRefs(selection) {
		const refs = [];
		const seenIds = /* @__PURE__ */ new Set();
		const selectedNode = selection instanceof NodeSelection ? selection.node : null;
		if (selectedNode && (selectedNode.type?.name === "structuredContent" || selectedNode.type?.name === "structuredContentBlock")) {
			const ref$1 = this.#toSdtRef(selectedNode);
			if (ref$1) {
				refs.push(ref$1);
				seenIds.add(ref$1.id);
			}
		}
		const anchor = selection.$anchor;
		if (anchor && typeof anchor.depth === "number" && typeof anchor.node === "function") for (let depth = anchor.depth; depth >= 0; depth -= 1) {
			const node = anchor.node(depth);
			if (!node) continue;
			const typeName = node?.type?.name;
			if (typeName !== "structuredContent" && typeName !== "structuredContentBlock") continue;
			const ref$1 = this.#toSdtRef(node);
			if (!ref$1) continue;
			if (seenIds.has(ref$1.id)) continue;
			refs.push(ref$1);
			seenIds.add(ref$1.id);
		}
		return refs;
	}
	#toSdtRef(node) {
		const attrs = node.attrs;
		const id = attrs?.id;
		if (typeof id !== "string" || id.length === 0) return null;
		const scope = node.type.name === "structuredContent" ? "inline" : "block";
		return {
			id,
			tag: typeof attrs.tag === "string" ? attrs.tag : void 0,
			alias: typeof attrs.alias === "string" ? attrs.alias : void 0,
			controlType: typeof attrs.controlType === "string" ? attrs.controlType : "unknown",
			scope
		};
	}
	dispatch(tr) {
		this.#dispatchTransaction(tr);
	}
	async getDocumentIdentifier() {
		return await this.converter?.getDocumentIdentifier() || null;
	}
	getDocumentGuid() {
		return this.converter?.documentGuid || null;
	}
	isDocumentModified() {
		return this.converter?.documentModified || false;
	}
	getDocumentId() {
		console.warn("getDocumentId is deprecated, use getDocumentGuid instead");
		return this.getDocumentGuid();
	}
	getAttributes(nameOrType) {
		return Attribute.getAttributes(this.state, nameOrType);
	}
	isActive(nameOrAttributes, attributesOrUndefined) {
		const name = typeof nameOrAttributes === "string" ? nameOrAttributes : null;
		const attributes = typeof nameOrAttributes === "string" ? attributesOrUndefined : nameOrAttributes;
		return isActive(this.state, name, attributes);
	}
	getJSON() {
		const json = this.state.doc.toJSON();
		try {
			const jsonObj = json;
			const attrs = jsonObj.attrs;
			const converter = this.converter;
			if (converter && converter.bodySectPr) {
				jsonObj.attrs = attrs || {};
				jsonObj.attrs.bodySectPr = converter.bodySectPr;
			}
		} catch {}
		return json;
	}
	getMetadata() {
		return {
			documentGuid: this.converter?.documentGuid || null,
			isModified: this.isDocumentModified(),
			version: this.converter?.getSuperdocVersion() || null
		};
	}
	getHTML({ unflattenLists = false } = {}) {
		const domDocument = this.#getDomDocument();
		if (!domDocument) throw new Error("[super-editor] getHTML() requires a DOM. Provide { document } (e.g. from JSDOM), set DOM globals, or run in a browser environment.");
		const container = domDocument.createElement("div");
		const fragment = DOMSerializer.fromSchema(this.schema).serializeFragment(this.state.doc.content, { document: domDocument });
		container.appendChild(fragment);
		let html = container.innerHTML;
		if (unflattenLists) html = unflattenListsInHtml(html, domDocument);
		return html;
	}
	async getMarkdown() {
		const domDocument = this.#getDomDocument();
		if (!domDocument) throw new Error("[super-editor] getMarkdown() requires a DOM. Provide { document } (e.g. from JSDOM), set DOM globals, or run in a browser environment.");
		const globals = globalThis;
		const shouldInjectGlobals = globals.document === void 0;
		const savedGlobals = shouldInjectGlobals ? {
			document: globals.document,
			window: globals.window,
			navigatorDescriptor: Object.getOwnPropertyDescriptor(globalThis, "navigator")
		} : null;
		if (shouldInjectGlobals) {
			globals.document = domDocument;
			if (!globals.window && domDocument.defaultView) globals.window = domDocument.defaultView;
			if (!globals.navigator && domDocument.defaultView?.navigator) globals.navigator = domDocument.defaultView.navigator;
		}
		try {
			const [{ unified: unified$1 }, { default: rehypeParse }, { default: rehypeRemark }, { default: remarkStringify$1 }, { default: remarkGfm$1 }] = await Promise.all([
				import("./unified-vFnLRfAM.es.js"),
				import("./rehype-parse-DTSDs3kr.es.js"),
				import("./rehype-remark-Bt5njn02.es.js"),
				import("./remark-stringify-B-orWEvD.es.js"),
				import("./remark-gfm-eZN6yzWQ.es.js")
			]);
			const html = this.getHTML();
			const file = unified$1().use(rehypeParse, { fragment: true }).use(rehypeRemark).use(remarkGfm$1).use(remarkStringify$1, {
				bullet: "-",
				fences: true
			}).processSync(html);
			return String(file);
		} finally {
			if (savedGlobals) {
				if (savedGlobals.document === void 0) delete globals.document;
				else globals.document = savedGlobals.document;
				if (savedGlobals.window === void 0) delete globals.window;
				else globals.window = savedGlobals.window;
				if (savedGlobals.navigatorDescriptor) Object.defineProperty(globalThis, "navigator", savedGlobals.navigatorDescriptor);
				else delete globals.navigator;
			}
		}
	}
	getDocumentVersion() {
		return this.converter?.getSuperdocVersion() || null;
	}
	createChildEditor(options) {
		return createLinkedChildEditor(this, options);
	}
	getPageStyles() {
		return this.converter?.pageStyles || {};
	}
	updatePageStyle({ pageMargins }) {
		if (!this.converter) return;
		let hasMadeUpdate = false;
		if (pageMargins) {
			this.converter.pageStyles.pageMargins = pageMargins;
			this.initDefaultStyles();
			hasMadeUpdate = true;
		}
		if (hasMadeUpdate && this.view && !isHeadless()) {
			const newTr = this.view.state.tr;
			newTr.setMeta("forceUpdatePagination", true);
			this.#dispatchTransaction(newTr);
			this.emit("pageStyleUpdate", {
				pageMargins,
				pageStyles: this.converter.pageStyles
			});
		}
	}
	#handleNodeSelection(view, pos) {
		this.setOptions({ lastSelection: null });
		if (this.options.isHeaderOrFooter) return setImageNodeSelection(view, pos);
	}
	#prepareDocumentForImport(doc$1) {
		const newState = EditorState.create({
			schema: this.schema,
			doc: doc$1
		});
		const { tr, doc: newDoc } = newState;
		prepareCommentsForImport(newDoc, tr, this.schema, this.converter);
		return newState.apply(tr).doc;
	}
	migrateListsToV2() {
		if (this.options.isHeaderOrFooter) return [];
		return migrateListsToV2IfNecessary(this);
	}
	#prepareDocumentForExport(comments = []) {
		const doc$1 = this.state.doc;
		const tr = new Transform(doc$1);
		prepareCommentsForExport(doc$1, tr, this.schema, comments);
		return tr.doc.toJSON();
	}
	getUpdatedJson() {
		return this.#prepareDocumentForExport();
	}
	#installWordIdAllocatorIfNeeded() {
		if (!this.converter) return;
		const allocator = createWordIdAllocator();
		const reserveAttrs = (attrs, path) => {
			const sourceId = attrs?.sourceId;
			if (isDecimalWordId(sourceId)) allocator.reserve(path, sourceId);
		};
		const reserveFromDoc = (doc$1, path) => {
			if (!doc$1) return;
			doc$1.descendants((node) => {
				if (!Array.isArray(node.marks)) return;
				for (const mark of node.marks) {
					const name = mark.type.name;
					if (name !== "trackInsert" && name !== "trackDelete" && name !== "trackFormat") continue;
					reserveAttrs(mark.attrs, path);
				}
			});
		};
		const reserveFromJson = (node, path) => {
			if (!node || typeof node !== "object") return;
			const current = node;
			if (Array.isArray(current.marks)) for (const mark of current.marks) {
				if (mark.type !== "trackInsert" && mark.type !== "trackDelete" && mark.type !== "trackFormat") continue;
				reserveAttrs(mark.attrs, path);
			}
			if (Array.isArray(current.content)) for (const child of current.content) reserveFromJson(child, path);
		};
		const wordPartPath = (target, fallback) => {
			if (typeof target !== "string" || !target) return fallback;
			const stripped = target.replace(/^\/+/, "");
			return stripped.startsWith("word/") ? stripped : `word/${stripped}`;
		};
		const relsRoot = this.converter.convertedXml?.["word/_rels/document.xml.rels"]?.elements?.find((node) => node.name === "Relationships");
		const resolveRelationshipTarget = (relationshipId, fallback) => {
			const target = relsRoot?.elements?.find((node) => node.attributes?.Id === relationshipId)?.attributes?.Target;
			return wordPartPath(target, fallback);
		};
		reserveFromDoc(this.state?.doc, "word/document.xml");
		for (const [id, header] of Object.entries(this.converter.headers || {})) {
			const partPath = resolveRelationshipTarget(id, "word/header1.xml");
			const headerEditor = this.converter.headerEditors?.find((item) => item.id === id);
			reserveFromDoc(headerEditor?.editor?.state?.doc, partPath);
			reserveFromJson(header, partPath);
		}
		for (const [id, footer] of Object.entries(this.converter.footers || {})) {
			const partPath = resolveRelationshipTarget(id, "word/footer1.xml");
			const footerEditor = this.converter.footerEditors?.find((item) => item.id === id);
			reserveFromDoc(footerEditor?.editor?.state?.doc, partPath);
			reserveFromJson(footer, partPath);
		}
		reserveFromJson(this.converter.footnotes, "word/footnotes.xml");
		reserveFromJson(this.converter.endnotes, "word/endnotes.xml");
		this.converter.wordIdAllocator = allocator;
	}
	#persistTrackedChangeSourceIdMap() {
		if (!this.converter) return;
		const sourceIdMap = this.converter.wordIdAllocator?.getSourceIdMap?.() ?? {};
		if (Object.keys(sourceIdMap).length === 0 && !this.#hasTrackedChangeSourceIdMapProperty()) return;
		const payload = JSON.stringify({
			version: 1,
			parts: sourceIdMap
		});
		SuperConverter.setStoredCustomProperty(this.converter.convertedXml, TRACKED_CHANGE_SOURCE_ID_MAP_PROPERTY, payload, false);
	}
	#hasTrackedChangeSourceIdMapProperty() {
		const properties = (this.converter?.convertedXml?.["docProps/custom.xml"])?.elements?.find((node) => {
			const name = node?.name;
			return name === "Properties" || name?.endsWith(":Properties");
		});
		return Boolean(properties?.elements?.some((node) => {
			const name = node?.name;
			return (name === "property" || name?.endsWith(":property")) && node.attributes?.name === "SuperdocTrackedChangeSourceIds";
		}));
	}
	async exportDocx({ isFinalDoc = false, commentsType = "external", exportJsonOnly = false, exportXmlOnly = false, comments, getUpdatedDocs = false, fieldsHighlightColor = null, compression } = {}) {
		try {
			commitLiveStorySessionRuntimes(resolveMainBodyEditor(this));
			const preparedComments = (comments ?? this.converter.comments ?? []).map((comment) => {
				const elements = Array.isArray(comment.elements) && comment.elements.length ? comment.elements : void 0;
				const commentJson = comment.commentJSON ?? elements ?? (typeof comment.commentText === "string" ? buildCommentJsonFromText(comment.commentText) : void 0);
				return {
					...comment,
					commentJSON: commentJson
				};
			});
			const json = this.#prepareDocumentForExport(preparedComments);
			this.#installWordIdAllocatorIfNeeded();
			const documentXml = await this.converter.exportToDocx(json, this.schema, this.storage.image.media, isFinalDoc, commentsType, preparedComments, this, exportJsonOnly, fieldsHighlightColor);
			this.#validateDocumentExport();
			if (exportXmlOnly || exportJsonOnly) return documentXml;
			this.#persistTrackedChangeSourceIdMap();
			const customXml = this.converter.schemaToXml(this.converter.convertedXml["docProps/custom.xml"].elements[0]);
			const styles = this.converter.schemaToXml(this.converter.convertedXml["word/styles.xml"].elements[0]);
			const hasCustomSettings = !!this.converter.convertedXml["word/settings.xml"]?.elements?.length;
			const customSettings = hasCustomSettings ? this.converter.schemaToXml(this.converter.convertedXml["word/settings.xml"]?.elements?.[0]) : null;
			const rels = this.converter.schemaToXml(this.converter.convertedXml["word/_rels/document.xml.rels"].elements[0]);
			const footnotesData = this.converter.convertedXml["word/footnotes.xml"];
			const footnotesXml = footnotesData?.elements?.[0] ? this.converter.schemaToXml(footnotesData.elements[0]) : null;
			const footnotesRelsData = this.converter.convertedXml["word/_rels/footnotes.xml.rels"];
			const footnotesRelsXml = footnotesRelsData?.elements?.[0] ? this.converter.schemaToXml(footnotesRelsData.elements[0]) : null;
			const endnotesData = this.converter.convertedXml["word/endnotes.xml"];
			const endnotesXml = endnotesData?.elements?.[0] ? this.converter.schemaToXml(endnotesData.elements[0]) : null;
			const endnotesRelsData = this.converter.convertedXml["word/_rels/endnotes.xml.rels"];
			const endnotesRelsXml = endnotesRelsData?.elements?.[0] ? this.converter.schemaToXml(endnotesRelsData.elements[0]) : null;
			const settingsRelsData = this.converter.convertedXml["word/_rels/settings.xml.rels"];
			const settingsRelsXml = settingsRelsData?.elements?.[0] ? this.converter.schemaToXml(settingsRelsData.elements[0]) : null;
			const media = this.converter.addedMedia;
			const updatedHeadersFooters = {};
			Object.entries(this.converter.convertedXml).forEach(([name, json$1]) => {
				if (name.includes("header") || name.includes("footer")) {
					const jsonObj = json$1;
					const resultXml = this.converter.schemaToXml(jsonObj.elements?.[0]);
					updatedHeadersFooters[name] = String(resultXml.replace(/\[\[sdspace\]\]/g, ""));
				}
			});
			const numberingData = this.converter.convertedXml["word/numbering.xml"];
			const numbering = numberingData?.elements?.[0] ? this.converter.schemaToXml(numberingData.elements[0]) : null;
			const appXmlData = this.converter.convertedXml["docProps/app.xml"];
			const appXml = appXmlData?.elements?.[0] ? this.converter.schemaToXml(appXmlData.elements[0]) : null;
			const coreXmlData = this.converter.convertedXml["docProps/core.xml"];
			const coreXml = coreXmlData?.elements?.[0] ? this.converter.schemaToXml(coreXmlData.elements[0]) : null;
			const updatedDocs = {
				...this.options.customUpdatedFiles,
				"word/document.xml": String(documentXml),
				"docProps/custom.xml": String(customXml),
				"word/_rels/document.xml.rels": String(rels),
				...numbering ? { "word/numbering.xml": String(numbering) } : {},
				"word/styles.xml": String(styles),
				...updatedHeadersFooters,
				...appXml ? { "docProps/app.xml": String(appXml) } : {},
				...coreXml ? { "docProps/core.xml": String(coreXml) } : {}
			};
			if (hasCustomSettings) {
				let settingsXml = String(customSettings);
				if (settingsRelsXml) updatedDocs["word/_rels/settings.xml.rels"] = String(settingsRelsXml);
				else if (/<\w+:attachedTemplate\b/i.test(settingsXml)) settingsXml = settingsXml.replace(/<\w+:attachedTemplate\b[^>]*\/?>/gi, "");
				updatedDocs["word/settings.xml"] = settingsXml;
			}
			if (footnotesXml) updatedDocs["word/footnotes.xml"] = String(footnotesXml);
			if (footnotesRelsXml) updatedDocs["word/_rels/footnotes.xml.rels"] = String(footnotesRelsXml);
			if (endnotesXml) updatedDocs["word/endnotes.xml"] = String(endnotesXml);
			if (endnotesRelsXml) updatedDocs["word/_rels/endnotes.xml.rels"] = String(endnotesRelsXml);
			const commentFiles = COMMENT_FILE_BASENAMES.map((name) => `word/${name}`);
			for (const path of commentFiles) {
				const data = this.converter.convertedXml[path];
				if (data?.elements?.[0]) updatedDocs[path] = String(this.converter.schemaToXml(data.elements[0]));
				else updatedDocs[path] = null;
			}
			const bibliographyPartPaths = typeof this.converter.getBibliographyPartExportPaths === "function" ? this.converter.getBibliographyPartExportPaths() : [];
			for (const path of bibliographyPartPaths) {
				const partData = this.converter.convertedXml[path];
				if (partData?.elements?.[0]) updatedDocs[path] = String(this.converter.schemaToXml(partData.elements[0]));
			}
			if (isFinalDoc) {
				const filteredMetadataParts = buildFilteredMetadataXml(this, this.converter.convertedXml, { finalDoc: true });
				for (const [path, xml] of Object.entries(filteredMetadataParts)) updatedDocs[path] = xml;
			}
			for (const path of Object.keys(this.converter.convertedXml)) {
				if (!path.startsWith("customXml/")) continue;
				if (!path.endsWith(".xml") && !path.endsWith(".rels")) continue;
				if (Object.prototype.hasOwnProperty.call(updatedDocs, path)) continue;
				const partData = this.converter.convertedXml[path];
				if (partData?.elements?.[0]) updatedDocs[path] = String(this.converter.schemaToXml(partData.elements[0]));
			}
			const templateSubstratePaths = Object.keys(this.converter.convertedXml).filter((path) => /^word\/theme\/[^/]+\.xml$/.test(path) || path === "word/fontTable.xml" || path === "word/webSettings.xml");
			for (const path of templateSubstratePaths) {
				if (Object.prototype.hasOwnProperty.call(updatedDocs, path)) continue;
				const partData = this.converter.convertedXml[path];
				if (partData?.elements?.[0]) updatedDocs[path] = String(this.converter.schemaToXml(partData.elements[0]));
			}
			for (const path of ["[Content_Types].xml", "word/_rels/document.xml.rels"]) {
				if (Object.prototype.hasOwnProperty.call(updatedDocs, path)) continue;
				const partData = this.converter.convertedXml[path];
				if (partData?.elements?.[0]) updatedDocs[path] = String(this.converter.schemaToXml(partData.elements[0]));
			}
			const removedCustomXmlPaths = this.converter.removedCustomXmlPaths;
			if (removedCustomXmlPaths instanceof Set) for (const path of removedCustomXmlPaths) updatedDocs[path] = null;
			const zipper = new DocxZipper_default();
			if (getUpdatedDocs) {
				updatedDocs["[Content_Types].xml"] = await zipper.updateContentTypes({ files: this.options.content }, media, true, updatedDocs, this.options.fonts);
				const content = this.options.content;
				const { contentTypesXml, relsXml } = syncPackageMetadata({
					baseFiles: Array.isArray(content) || content && typeof content === "object" ? content : null,
					updatedDocs
				});
				updatedDocs["[Content_Types].xml"] = contentTypesXml;
				updatedDocs["_rels/.rels"] = relsXml;
				return updatedDocs;
			}
			const baseDocxEntries = !this.options.fileSource && !Array.isArray(this.options.content) ? await this.#getBaseDocxEntriesForExport() : this.options.content;
			return await zipper.updateZip({
				docx: baseDocxEntries,
				updatedDocs,
				originalDocxFile: this.options.fileSource,
				media,
				fonts: this.options.fonts,
				isHeadless: this.options.isHeadless,
				compression
			});
		} catch (error) {
			const err = error instanceof Error ? error : new Error(String(error));
			this.emit("exception", {
				error: err,
				editor: this
			});
			console.error(err);
			throw err;
		}
	}
	#endCollaboration() {
		if (!this.options.ydoc) return;
		try {
			console.debug("🔗 [super-editor] Ending collaboration");
			this.options.collaborationProvider?.disconnect?.();
			this.options.ydoc.destroy();
		} catch (error) {
			const err = error instanceof Error ? error : new Error(String(error));
			this.emit("exception", {
				error: err,
				editor: this
			});
			console.error(err);
		}
	}
	async open(source, options) {
		this.#assertState("initialized", "closed");
		await this.#withState("documentLoading", "ready", "closed", async () => {
			await this.#loadDocument(source, options);
		});
		this.emit("documentOpen", {
			editor: this,
			sourcePath: this.#sourcePath
		});
	}
	static async open(source, config) {
		const resolvedConfig = {
			mode: "docx",
			isHeadless: !(config?.element != null || config?.selector != null),
			...config
		};
		const { html, markdown, json, fragment, isCommentsEnabled, suppressDefaultDocxStyles, documentMode, content, mediaFiles, fonts, isNewFile, password, ...editorConfig } = resolvedConfig;
		const openOptions = {
			mode: resolvedConfig.mode,
			html,
			markdown,
			json,
			fragment,
			isCommentsEnabled,
			suppressDefaultDocxStyles,
			documentMode,
			content,
			mediaFiles,
			fonts,
			isNewFile,
			password
		};
		const editor = new Editor({
			...editorConfig,
			deferDocumentLoad: true
		});
		await editor.open(source, openOptions);
		return editor;
	}
	close() {
		if (this.#editorLifecycleState === "closed" || this.#editorLifecycleState === "initialized") return;
		if (this.#editorLifecycleState === "destroyed") return;
		this.#assertState("ready");
		this.emit("documentClose", { editor: this });
		this.#unloadDocument();
		this.#documentApi = null;
		this.#editorLifecycleState = "closed";
	}
	async save(options) {
		this.#assertState("ready");
		if (!this.#sourcePath) throw new NoSourcePathError("No source path. Use saveTo(path) or exportDocument() instead.");
		await this.#withState("saving", "ready", "ready", async () => {
			const data = await this.exportDocument(options);
			await this.#writeToPath(this.#sourcePath, data);
		});
	}
	async saveTo(path, options) {
		this.#assertState("ready");
		await this.#withState("saving", "ready", "ready", async () => {
			const data = await this.exportDocument(options);
			await this.#writeToPath(path, data);
			this.#sourcePath = path;
		});
	}
	async exportDocument(options) {
		this.#assertState("ready", "saving");
		return await this.exportDocx({
			isFinalDoc: options?.isFinalDoc,
			commentsType: options?.commentsType,
			comments: options?.comments,
			fieldsHighlightColor: options?.fieldsHighlightColor,
			compression: options?.compression
		});
	}
	async #writeToPath(path, data) {
		const isNode$1 = typeof globalThis !== "undefined" && typeof globalThis.process !== "undefined" && globalThis.process.versions?.node != null;
		const hasNodeBuffer = typeof Buffer !== "undefined" && typeof Buffer.isBuffer === "function";
		if (isNode$1 || hasNodeBuffer) try {
			const fs = (init_empty(), __toCommonJS(empty_exports));
			const buffer = Buffer.isBuffer(data) ? data : Buffer.from(await data.arrayBuffer());
			fs.writeFileSync(path, buffer);
			return;
		} catch {}
		if (typeof window !== "undefined" && "showSaveFilePicker" in window) {
			const writable = await (await window.showSaveFilePicker({
				suggestedName: path.split("/").pop() || "document.docx",
				types: [{
					description: "Word Document",
					accept: { "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"] }
				}]
			})).createWritable();
			await writable.write(data);
			await writable.close();
			return;
		}
		throw new FileSystemNotAvailableError("File System Access API not available. Use exportDocument() to get the document data and handle the download manually.");
	}
	destroy() {
		if (this.#editorLifecycleState === "ready") this.close();
		if (this.#editorLifecycleState === "destroyed") return;
		this.#isDestroyed = true;
		this.emit("destroy");
		this.unmount();
		this.destroyHeaderFooterEditors();
		this.#endCollaboration();
		this.removeAllListeners();
		this.extensionService = void 0;
		this.schema = void 0;
		this.#commandService = void 0;
		this.#documentApi = null;
		this.#editorLifecycleState = "destroyed";
	}
	destroyHeaderFooterEditors() {
		try {
			const headerEditors = this.converter?.headerEditors ?? [];
			const footerEditors = this.converter?.footerEditors ?? [];
			if (!headerEditors.length && !footerEditors.length) return;
			const editors = [...headerEditors, ...footerEditors].filter(Boolean);
			for (const editorData of editors) editorData?.editor?.destroy?.();
			if (headerEditors.length) headerEditors.length = 0;
			if (footerEditors.length) footerEditors.length = 0;
		} catch (error) {
			const err = error instanceof Error ? error : new Error(String(error));
			this.emit("exception", {
				error: err,
				editor: this
			});
			console.error(err);
		}
	}
	static checkIfMigrationsNeeded() {
		const dataVersion = version ?? "initial";
		const migrations = getNecessaryMigrations(dataVersion) || [];
		console.debug("[checkVersionMigrations] Migrations needed:", dataVersion, migrations.length);
		return migrations.length > 0;
	}
	processCollaborationMigrations() {
		console.debug("[checkVersionMigrations] Current editor version", CURRENT_APP_VERSION);
		if (!this.options.ydoc) return;
		let docVersion = this.options.ydoc.getMap("meta").get("version");
		if (!docVersion) docVersion = "initial";
		console.debug("[checkVersionMigrations] Document version", docVersion);
		const migrations = getNecessaryMigrations(docVersion) || [];
		const syncPlugin = this.state.plugins.find((plugin) => this.#getPluginKeyName(plugin).startsWith("y-sync"));
		if (!syncPlugin) return this.options.ydoc;
		let hasRunMigrations = false;
		for (const migration of migrations) {
			console.debug("🏃‍♂️ Running migration", migration.name);
			if (!migration(this)) throw new Error("Migration failed at " + migration.name);
			else hasRunMigrations = true;
		}
		if (!hasRunMigrations) return;
		return (syncPlugin?.getState(this.state)).doc;
	}
	async replaceFile(newFile, options) {
		this.setOptions({ annotations: true });
		const [docx, media, mediaFiles, fonts, decryptedData] = await Editor.loadXmlData(newFile, false, options);
		this.setOptions({
			fileSource: decryptedData ?? (newFile instanceof ArrayBuffer ? new Blob([newFile]) : newFile),
			content: docx,
			media,
			mediaFiles,
			fonts,
			isNewFile: true
		});
		this.options.shouldLoadComments = true;
		this.options.replacedFile = true;
		this.#createConverter();
		initPartsRuntime(this);
		this.#initMedia();
		this.initDefaultStyles();
		if (this.options.ydoc && this.options.collaborationProvider) {
			const ydoc = this.options.ydoc;
			const provider = this.options.collaborationProvider;
			const doReplaceFileSync = () => {
				this.options.fragment = null;
				this.#insertNewFileData();
				seedPartsFromEditor(this, ydoc, { replaceExisting: true });
				const mediaFiles$1 = this.options.mediaFiles ?? {};
				const mediaMap = ydoc.getMap("media");
				for (const key of mediaMap.keys()) if (!(key in mediaFiles$1)) mediaMap.delete(key);
				Object.entries(mediaFiles$1).forEach(([key, value]) => {
					mediaMap.set(key, value);
				});
			};
			const SYNC_TIMEOUT_MS = 1e4;
			await new Promise((resolve, reject) => {
				let timer;
				let settled = false;
				const cleanup = onCollaborationProviderSynced(provider, () => {
					if (settled) return;
					settled = true;
					clearTimeout(timer);
					try {
						doReplaceFileSync();
						resolve();
					} catch (error) {
						reject(error);
					}
				});
				if (!settled) timer = setTimeout(() => {
					settled = true;
					cleanup();
					reject(/* @__PURE__ */ new Error(`replaceFile(): collaboration provider did not sync within ${SYNC_TIMEOUT_MS}ms. The provider exposes on/off but never emitted sync(true) or synced.`));
				}, SYNC_TIMEOUT_MS);
			});
		} else this.#insertNewFileData();
		if (!this.options.ydoc) this.#initComments();
		this.emit("documentReplaced", { editor: this });
	}
	getInternalXmlFile(name, type = "json") {
		if (!this.converter.convertedXml[name]) {
			console.warn("Cannot find file in docx");
			return null;
		}
		if (type === "json") return this.converter.convertedXml[name].elements[0] || null;
		return this.converter.schemaToXml(this.converter.convertedXml[name].elements[0]);
	}
	updateInternalXmlFile(name, updatedContent) {
		if (typeof updatedContent === "string") this.options.customUpdatedFiles[name] = String(updatedContent);
		else {
			const internalFileXml = this.converter.schemaToXml(updatedContent);
			this.options.customUpdatedFiles[name] = String(internalFileXml);
		}
		this.options.isCustomXmlChanged = true;
	}
	getNodesOfType(type) {
		const { findChildren: findChildren$2 } = helpers_exports;
		return findChildren$2(this.state.doc, (node) => node.type.name === type);
	}
	replaceNodeWithHTML(targetNode, html) {
		const { tr } = this.state;
		if (!targetNode || !html) return;
		const start$1 = targetNode.pos;
		const end$1 = start$1 + targetNode.node.nodeSize;
		const htmlNode = createDocFromHTML(html, this);
		tr.replaceWith(start$1, end$1, htmlNode);
		this.dispatch(tr);
	}
	prepareForAnnotations(annotationValues = []) {
		const { tr } = this.state;
		const newTr = AnnotatorHelpers.processTables({
			state: this.state,
			tr,
			annotationValues
		});
		this.dispatch(newTr);
	}
	async migrateParagraphFields(annotationValues = []) {
		if (!Array.isArray(annotationValues) || !annotationValues.length) return annotationValues;
		return await migrateParagraphFieldsListsV2(annotationValues, this);
	}
	annotate(annotationValues = [], hiddenIds = [], removeEmptyFields = false) {
		const { state, schema } = this;
		let tr = state.tr;
		tr = AnnotatorHelpers.processTables({
			state: this.state,
			tr,
			annotationValues
		});
		tr = AnnotatorHelpers.annotateDocument({
			tr,
			schema,
			annotationValues,
			hiddenFieldIds: hiddenIds,
			removeEmptyFields,
			editor: this
		});
		if (tr.docChanged) {
			const finalTr = tr.scrollIntoView();
			this.dispatch(finalTr);
		}
	}
	previewAnnotations(annotationValues = [], hiddenIds = []) {
		this.originalState = this.state;
		this.annotate(annotationValues, hiddenIds);
	}
	closePreview() {
		if (!this.originalState) return;
		if (this.view) this.view.updateState(this.originalState);
		else this._state = this.originalState;
	}
	#validateDocumentInit() {
		if (this.options.isHeaderOrFooter || this.options.isChildEditor) return;
		new SuperValidator({
			editor: this,
			dryRun: false,
			debug: false
		}).validateActiveDocument();
	}
	#validateDocumentExport() {
		if (this.options.isHeaderOrFooter || this.options.isChildEditor) return;
		new SuperValidator({
			editor: this,
			dryRun: false,
			debug: false
		}).validateDocumentExport();
	}
	#initDevTools() {
		this.#renderer?.initDevTools?.(this);
	}
};
var token = (varName, fallback) => ({
	css: `var(${varName}, ${fallback})`,
	fallback
});
var H = {
	EXT: token("--sd-comments-highlight-external", "#B1124B40"),
	EXT_ACTIVE: token("--sd-comments-highlight-external-active", "#B1124B66"),
	EXT_FADED: token("--sd-comments-highlight-external-faded", "#B1124B20"),
	INT: token("--sd-comments-highlight-internal", "#07838340"),
	INT_ACTIVE: token("--sd-comments-highlight-internal-active", "#07838366"),
	INT_FADED: token("--sd-comments-highlight-internal-faded", "#07838320"),
	EXT_NESTED_BDR: token("--sd-comments-highlight-external-nested-border", "#B1124B99"),
	INT_NESTED_BDR: token("--sd-comments-highlight-internal-nested-border", "#07838399")
};
var TRACK_CHANGE_FOCUSED_CLASS = "track-change-focused";
var COMMENT_HIGHLIGHT_SELECTOR$1 = ".superdoc-comment-highlight";
var TRACK_CHANGE_SELECTOR$1 = "[data-track-change-id]";
function parseCommaSeparated(value) {
	if (!value) return [];
	return value.split(",").filter(Boolean);
}
function parseImportedIdMap(value) {
	const map$1 = /* @__PURE__ */ new Map();
	if (!value) return map$1;
	for (const entry of value.split(",")) {
		const eq = entry.indexOf("=");
		if (eq > 0) map$1.set(entry.slice(0, eq), entry.slice(eq + 1));
	}
	return map$1;
}
function applyInlineStyleValue(el, property, preferredValue, fallbackValue) {
	el.style[property] = "";
	el.style[property] = preferredValue;
	if (!el.style[property]) el.style[property] = fallbackValue;
}
function applyBgColor(el, color) {
	applyInlineStyleValue(el, "backgroundColor", color.css, color.fallback);
}
function applyBoxShadow(el, border) {
	applyInlineStyleValue(el, "boxShadow", `inset 1px 0 0 ${border.css}, inset -1px 0 0 ${border.css}`, `inset 1px 0 0 ${border.fallback}, inset -1px 0 0 ${border.fallback}`);
}
var CommentHighlightDecorator = class {
	#activeCommentId = null;
	#container = null;
	setContainer(container) {
		this.#container = container;
	}
	getActiveCommentId() {
		return this.#activeCommentId;
	}
	setActiveComment(commentId) {
		if (this.#activeCommentId === commentId) return false;
		this.#activeCommentId = commentId;
		return true;
	}
	apply() {
		const root = this.#container;
		if (!root) return;
		this.#applyCommentHighlights(root);
		this.#applyTrackChangeFocus(root);
	}
	destroy() {
		const root = this.#container;
		if (!root) return;
		const commentEls = root.querySelectorAll(COMMENT_HIGHLIGHT_SELECTOR$1);
		for (let i = 0; i < commentEls.length; i++) {
			const el = commentEls[i];
			el.style.backgroundColor = "";
			el.style.boxShadow = "";
		}
		const focusedEls = root.querySelectorAll(`.${TRACK_CHANGE_FOCUSED_CLASS}`);
		for (let i = 0; i < focusedEls.length; i++) focusedEls[i].classList.remove(TRACK_CHANGE_FOCUSED_CLASS);
	}
	#applyCommentHighlights(root) {
		const activeId = this.#activeCommentId;
		const elements = root.querySelectorAll(COMMENT_HIGHLIGHT_SELECTOR$1);
		for (let i = 0; i < elements.length; i++) {
			const el = elements[i];
			const ids = parseCommaSeparated(el.dataset.commentIds);
			if (ids.length === 0) continue;
			const internalIds = new Set(parseCommaSeparated(el.dataset.commentInternalIds));
			const primaryIsInternal = internalIds.has(ids[0]);
			const isTrackedChangeAnchored = el.classList.contains("highlighted") && (el.classList.contains("track-insert-dec") || el.classList.contains("track-delete-dec"));
			if (activeId == null) {
				if (!isTrackedChangeAnchored) applyBgColor(el, primaryIsInternal ? H.INT : H.EXT);
				else el.style.backgroundColor = "";
				el.style.boxShadow = "";
				continue;
			}
			const matchedId = this.#resolveMatch(activeId, ids, el.dataset.commentImportedIds);
			if (matchedId != null) {
				const matchIsInternal = internalIds.has(matchedId);
				if (!isTrackedChangeAnchored) applyBgColor(el, matchIsInternal ? H.INT_ACTIVE : H.EXT_ACTIVE);
				else el.style.backgroundColor = "";
				if (ids.length > 1) applyBoxShadow(el, matchIsInternal ? H.INT_NESTED_BDR : H.EXT_NESTED_BDR);
				else el.style.boxShadow = "";
			} else {
				if (!isTrackedChangeAnchored) applyBgColor(el, primaryIsInternal ? H.INT_FADED : H.EXT_FADED);
				else el.style.backgroundColor = "";
				el.style.boxShadow = "";
			}
		}
	}
	#resolveMatch(activeId, commentIds, importedIdsAttr) {
		if (commentIds.includes(activeId)) return activeId;
		if (importedIdsAttr) {
			const canonicalId = parseImportedIdMap(importedIdsAttr).get(activeId);
			if (canonicalId && commentIds.includes(canonicalId)) return canonicalId;
		}
		return null;
	}
	#applyTrackChangeFocus(root) {
		const activeId = this.#activeCommentId;
		const elements = root.querySelectorAll(TRACK_CHANGE_SELECTOR$1);
		for (let i = 0; i < elements.length; i++) {
			const el = elements[i];
			if (activeId && el.dataset.trackChangeId === activeId) el.classList.add(TRACK_CHANGE_FOCUSED_CLASS);
			else el.classList.remove(TRACK_CHANGE_FOCUSED_CLASS);
		}
	}
};
var EXCLUDED_PLUGIN_KEY_REF_LIST = [
	TrackChangesBasePluginKey,
	CommentsPluginKey,
	AiPluginKey,
	CustomSelectionPluginKey,
	LinkedStylesPluginKey,
	NodeResizerKey
];
var EXCLUDED_PLUGIN_KEY_REFS = new Set([...EXCLUDED_PLUGIN_KEY_REF_LIST]);
var EXCLUDED_PLUGIN_KEY_PREFIXES = [
	"placeholder",
	"tabPlugin",
	"dropcapPlugin",
	"ImagePosition",
	"ImageRegistration",
	"search",
	"yjs-cursor"
];
var TEXT_RANGE_BLOCK_SEP = "\n";
var TEXT_RANGE_LEAF_SEP = "\n";
function charOffsetToPosition(doc$1, charOffset, blockSep, leafSep) {
	const docSize = doc$1.content.size;
	if (charOffset <= 0) return 0;
	if (charOffset >= doc$1.textBetween(0, docSize, blockSep, leafSep).length) return docSize;
	let low = 0;
	let high = docSize;
	while (low < high) {
		const mid = Math.floor((low + high) / 2);
		if (doc$1.textBetween(0, mid, blockSep, leafSep).length < charOffset) low = mid + 1;
		else high = mid;
	}
	return low;
}
function findRangeByText(doc$1, text, hintFrom) {
	if (!text) return null;
	const docSize = doc$1.content.size;
	const full = doc$1.textBetween(0, docSize, TEXT_RANGE_BLOCK_SEP, TEXT_RANGE_LEAF_SEP);
	const matches = [];
	let i = 0;
	for (;;) {
		const idx = full.indexOf(text, i);
		if (idx === -1) break;
		matches.push(idx);
		i = idx + 1;
	}
	if (matches.length === 0) return null;
	const toPos = (charOffset) => charOffsetToPosition(doc$1, charOffset, TEXT_RANGE_BLOCK_SEP, TEXT_RANGE_LEAF_SEP);
	const initial = matches[0];
	let charOffsetFrom;
	if (hintFrom == null) charOffsetFrom = initial;
	else charOffsetFrom = matches.reduce((acc, idx) => {
		const pos = toPos(idx);
		return Math.abs(pos - hintFrom) < Math.abs(acc.bestPos - hintFrom) ? {
			best: idx,
			bestPos: pos
		} : acc;
	}, {
		best: initial,
		bestPos: toPos(initial)
	}).best;
	const from$1 = toPos(charOffsetFrom);
	const to = toPos(charOffsetFrom + text.length);
	return from$1 < to ? {
		from: from$1,
		to
	} : null;
}
function resolveMovedRangeFromPrevious(doc$1, docSize, prev) {
	if (!prev.text) return null;
	const resolved = findRangeByText(doc$1, prev.text, prev.from);
	if (!resolved) return null;
	if (resolved.from < 0 || resolved.to <= resolved.from || resolved.to > docSize) return null;
	return resolved;
}
function restoreRangesFromPrevious(doc$1, docSize, previousRanges) {
	const out = [];
	for (const prev of previousRanges) {
		const resolved = resolveMovedRangeFromPrevious(doc$1, docSize, prev);
		if (!resolved) continue;
		out.push({
			...prev,
			from: resolved.from,
			to: resolved.to
		});
	}
	return out;
}
function rangeUnion(ranges) {
	if (ranges.length === 0) return null;
	let from$1 = ranges[0].from;
	let to = ranges[0].to;
	for (let i = 1; i < ranges.length; i++) {
		if (ranges[i].from < from$1) from$1 = ranges[i].from;
		if (ranges[i].to > to) to = ranges[i].to;
	}
	return {
		from: from$1,
		to
	};
}
function preferFullRestoredWhenPartial(current, previousRanges, doc$1, docSize) {
	if (current.length === 0 || !previousRanges?.length) return current;
	const restored = restoreRangesFromPrevious(doc$1, docSize, previousRanges);
	if (restored.length === 0) return current;
	const currentSpan = rangeUnion(current);
	const restoredSpan = rangeUnion(restored);
	if (!currentSpan || !restoredSpan) return current;
	return currentSpan.from >= restoredSpan.from && currentSpan.to <= restoredSpan.to && restoredSpan.to - restoredSpan.from > currentSpan.to - currentSpan.from ? restored : current;
}
var DecorationBridge = class DecorationBridge {
	#applied = /* @__PURE__ */ new WeakMap();
	#eligiblePlugins = [];
	#pluginListSnapshot = [];
	#prevDecorationSets = /* @__PURE__ */ new Map();
	#hadEligiblePlugins = false;
	#previousRanges = /* @__PURE__ */ new Map();
	#skipRestoreEmptyOnNextCollect = false;
	#lastTransactionWasDocChange = false;
	#lastDocChangeToken = 0;
	#docChangeMappingsByToken = /* @__PURE__ */ new Map();
	#previousRangesTokenByPlugin = /* @__PURE__ */ new Map();
	sync(state, domIndex, options) {
		this.#refreshEligiblePlugins(state);
		const docSize = state.doc.content.size;
		const restoreEmpty = options?.restoreEmptyDecorations !== false;
		if (!restoreEmpty) this.#skipRestoreEmptyOnNextCollect = true;
		const desired = this.#eligiblePlugins.length > 0 ? this.#collectDesiredState(state, domIndex, docSize, restoreEmpty) : /* @__PURE__ */ new Map();
		this.#hadEligiblePlugins = this.#eligiblePlugins.length > 0;
		return this.#reconcile(desired, domIndex, docSize);
	}
	recordTransaction(transaction) {
		this.#lastTransactionWasDocChange = Boolean(transaction?.docChanged);
		if (!transaction?.docChanged) return;
		this.#lastDocChangeToken += 1;
		this.#docChangeMappingsByToken.set(this.#lastDocChangeToken, transaction.mapping);
	}
	hasChanges(state) {
		this.#refreshEligiblePlugins(state);
		if (this.#eligiblePlugins.length === 0) return this.#hadEligiblePlugins;
		for (const plugin of this.#eligiblePlugins) if (this.#getDecorationSet(plugin, state) !== this.#prevDecorationSets.get(plugin)) return true;
		return false;
	}
	hasCurrentRanges(state) {
		this.#refreshEligiblePlugins(state);
		if (this.#eligiblePlugins.length === 0) return false;
		const docSize = state.doc.content.size;
		for (const plugin of this.#eligiblePlugins) {
			const decorationSet = this.#getDecorationSet(plugin, state);
			if (decorationSet === DecorationSet.empty) continue;
			for (const decoration of decorationSet.find(0, docSize)) {
				if (!this.#isInlineDecoration(decoration)) continue;
				const attrs = this.#extractSafeAttrs(decoration);
				if (!(attrs.classes.length > 0 || attrs.dataEntries.length > 0 || attrs.styleEntries.length > 0)) continue;
				if (decoration.from >= decoration.to) continue;
				return true;
			}
		}
		return false;
	}
	collectDecorationRanges(state) {
		this.#refreshEligiblePlugins(state);
		const ranges = [];
		const docSize = state.doc.content.size;
		for (const plugin of this.#eligiblePlugins) {
			const { ranges: pluginRanges, decorationSet } = this.#collectPluginRanges(plugin, state, docSize);
			const previousPluginRanges = this.#previousRanges.get(plugin);
			const mayRestoreEmpty = !this.#skipRestoreEmptyOnNextCollect && previousPluginRanges && previousPluginRanges.length > 0;
			const { effectiveRanges, rangesToStore } = this.#resolveEffectiveRanges(pluginRanges, previousPluginRanges, state.doc, docSize, mayRestoreEmpty, this.#lastTransactionWasDocChange);
			this.#setPreviousRanges(plugin, rangesToStore.length > 0 ? [...rangesToStore] : []);
			this.#prevDecorationSets.set(plugin, decorationSet);
			ranges.push(...effectiveRanges);
		}
		this.#clearSkipRestoreFlagIfSet();
		return ranges;
	}
	#clearSkipRestoreFlagIfSet() {
		if (this.#skipRestoreEmptyOnNextCollect) this.#skipRestoreEmptyOnNextCollect = false;
	}
	destroy() {
		this.#eligiblePlugins = [];
		this.#pluginListSnapshot = [];
		this.#prevDecorationSets.clear();
		this.#previousRanges.clear();
		this.#previousRangesTokenByPlugin.clear();
		this.#hadEligiblePlugins = false;
		this.#skipRestoreEmptyOnNextCollect = false;
		this.#lastTransactionWasDocChange = false;
		this.#lastDocChangeToken = 0;
		this.#docChangeMappingsByToken.clear();
	}
	#refreshEligiblePlugins(state) {
		if (state.plugins === this.#pluginListSnapshot) return;
		this.#pluginListSnapshot = state.plugins;
		this.#eligiblePlugins = state.plugins.filter((plugin) => {
			if (!plugin.props.decorations) return false;
			if (this.#isExcludedByKeyRef(plugin)) return false;
			if (this.#isExcludedByKeyPrefix(plugin)) return false;
			return true;
		});
		const eligibleSet = new Set(this.#eligiblePlugins);
		for (const key of this.#prevDecorationSets.keys()) if (!eligibleSet.has(key)) this.#prevDecorationSets.delete(key);
		for (const key of this.#previousRanges.keys()) if (!eligibleSet.has(key)) this.#previousRanges.delete(key);
		for (const key of this.#previousRangesTokenByPlugin.keys()) if (!eligibleSet.has(key)) this.#previousRangesTokenByPlugin.delete(key);
		this.#pruneDocChangeMappings();
	}
	#isExcludedByKeyRef(plugin) {
		const specKey = plugin.spec?.key;
		return specKey != null && EXCLUDED_PLUGIN_KEY_REFS.has(specKey);
	}
	#isExcludedByKeyPrefix(plugin) {
		const keyString = plugin.key ?? "";
		return EXCLUDED_PLUGIN_KEY_PREFIXES.some((prefix) => keyString === prefix || keyString.startsWith(`${prefix}$`));
	}
	#collectDesiredState(state, domIndex, docSize, restoreEmptyDecorations) {
		const desired = /* @__PURE__ */ new Map();
		for (const plugin of this.#eligiblePlugins) {
			const { ranges: pluginRanges, decorationSet } = this.#collectPluginRanges(plugin, state, docSize);
			const previousPluginRanges = this.#previousRanges.get(plugin);
			const { effectiveRanges, rangesToStore } = this.#resolveEffectiveRanges(pluginRanges, previousPluginRanges, state.doc, docSize, restoreEmptyDecorations, this.#lastTransactionWasDocChange);
			if (pluginRanges.length > 0 || effectiveRanges.length > 0) {
				this.#applyRangesToDesired(desired, domIndex, effectiveRanges);
				this.#setPreviousRanges(plugin, rangesToStore.length > 0 ? [...rangesToStore] : []);
				this.#prevDecorationSets.set(plugin, decorationSet);
				continue;
			}
			if (!restoreEmptyDecorations) {
				this.#setPreviousRanges(plugin, []);
				this.#prevDecorationSets.set(plugin, decorationSet);
				continue;
			}
			this.#setPreviousRanges(plugin, []);
			this.#prevDecorationSets.set(plugin, decorationSet);
		}
		return desired;
	}
	#applyRangesToDesired(desired, domIndex, ranges) {
		for (const range of ranges) {
			const entries = domIndex.findEntriesInRange(range.from, range.to);
			for (const entry of entries) {
				const d = this.#getOrCreateDesired(desired, entry.el);
				for (const cls of range.classes) d.classes.add(cls);
				for (const [key, value] of Object.entries(range.dataAttrs)) d.dataAttrs.set(key, value);
				if (range.style) for (const [prop, value] of DecorationBridge.#parseStyleString(range.style)) d.styleProps.set(prop, value);
			}
		}
	}
	#collectPluginRanges(plugin, state, docSize) {
		const decorationSet = this.#getDecorationSet(plugin, state);
		const prevDecorationSet = this.#prevDecorationSets.get(plugin);
		const remapped = this.#remapUnchangedPluginRangesIfNeeded(plugin, decorationSet, prevDecorationSet, state.doc, docSize);
		if (remapped) return {
			ranges: remapped,
			decorationSet
		};
		const ranges = [];
		if (decorationSet !== DecorationSet.empty) {
			const decorations = decorationSet.find(0, docSize);
			for (const decoration of decorations) {
				if (!this.#isInlineDecoration(decoration)) continue;
				const attrs = this.#extractSafeAttrs(decoration);
				if (attrs.classes.length === 0 && attrs.dataEntries.length === 0 && attrs.styleEntries.length === 0) continue;
				if (decoration.from >= decoration.to) continue;
				const dataAttrs = {};
				for (const [key, value] of attrs.dataEntries) dataAttrs[key] = value;
				const style = attrs.styleEntries.length > 0 ? attrs.styleEntries.map(([prop, val]) => `${prop}: ${val}`).join("; ") : null;
				const rangeText = typeof state.doc.textBetween === "function" ? state.doc.textBetween(decoration.from, decoration.to, TEXT_RANGE_BLOCK_SEP, TEXT_RANGE_LEAF_SEP) : void 0;
				ranges.push({
					from: decoration.from,
					to: decoration.to,
					classes: attrs.classes,
					style,
					dataAttrs,
					...rangeText ? { text: rangeText } : {}
				});
			}
		}
		return {
			ranges,
			decorationSet
		};
	}
	#resolveEffectiveRanges(pluginRanges, previousPluginRanges, doc$1, docSize, restoreEmpty, lastTransactionWasDocChange) {
		let current = pluginRanges;
		if (current.length === 0 && restoreEmpty && previousPluginRanges?.length) current = restoreRangesFromPrevious(doc$1, docSize, previousPluginRanges);
		const effectiveRanges = lastTransactionWasDocChange && restoreEmpty && previousPluginRanges?.length ? preferFullRestoredWhenPartial(current, previousPluginRanges, doc$1, docSize) : current;
		const storeExpandedOnDocChange = lastTransactionWasDocChange && effectiveRanges !== current;
		return {
			effectiveRanges,
			rangesToStore: pluginRanges.length > 0 ? storeExpandedOnDocChange ? effectiveRanges : pluginRanges : effectiveRanges
		};
	}
	#setPreviousRanges(plugin, ranges) {
		this.#previousRanges.set(plugin, ranges);
		this.#previousRangesTokenByPlugin.set(plugin, this.#lastDocChangeToken);
		this.#pruneDocChangeMappings();
	}
	#getMappingsSinceToken(fromToken) {
		if (fromToken >= this.#lastDocChangeToken) return [];
		const mappings = [];
		for (let token$1 = fromToken + 1; token$1 <= this.#lastDocChangeToken; token$1 += 1) {
			const mapping = this.#docChangeMappingsByToken.get(token$1);
			if (!mapping) return [];
			mappings.push(mapping);
		}
		return mappings;
	}
	#mapThroughMappings(pos, assoc, mappings) {
		let mapped = pos;
		for (const mapping of mappings) mapped = mapping.map(mapped, assoc);
		return mapped;
	}
	#pruneDocChangeMappings() {
		if (this.#docChangeMappingsByToken.size === 0) return;
		let minTrackedToken = this.#lastDocChangeToken;
		for (const token$1 of this.#previousRangesTokenByPlugin.values()) if (token$1 < minTrackedToken) minTrackedToken = token$1;
		for (const token$1 of this.#docChangeMappingsByToken.keys()) if (token$1 <= minTrackedToken) this.#docChangeMappingsByToken.delete(token$1);
	}
	#remapUnchangedPluginRangesIfNeeded(plugin, currentSet, previousSet, doc$1, docSize) {
		if (!previousSet || previousSet !== currentSet) return null;
		const previousRanges = this.#previousRanges.get(plugin);
		if (!previousRanges?.length) return null;
		const rangesToken = this.#previousRangesTokenByPlugin.get(plugin) ?? -1;
		if (rangesToken === this.#lastDocChangeToken) return previousRanges;
		const mappings = this.#getMappingsSinceToken(rangesToken);
		if (mappings.length === 0) return null;
		const remapped = [];
		for (const prev of previousRanges) {
			if (prev.text) {
				const resolved = findRangeByText(doc$1, prev.text, prev.from);
				if (resolved && resolved.from >= 0 && resolved.to > resolved.from && resolved.to <= docSize) {
					remapped.push({
						from: resolved.from,
						to: resolved.to,
						classes: prev.classes,
						style: prev.style,
						dataAttrs: prev.dataAttrs,
						text: prev.text
					});
					continue;
				}
			}
			const from$1 = this.#mapThroughMappings(prev.from, -1, mappings);
			const to = this.#mapThroughMappings(prev.to, 1, mappings);
			if (from$1 < 0 || to <= from$1 || to > docSize) continue;
			remapped.push({
				from: from$1,
				to,
				classes: prev.classes,
				style: prev.style,
				dataAttrs: prev.dataAttrs,
				text: prev.text
			});
		}
		if (remapped.length === 0) return null;
		return remapped;
	}
	#getDecorationSet(plugin, state) {
		try {
			const result = plugin.props.decorations?.call(plugin, state);
			return result instanceof DecorationSet ? result : DecorationSet.empty;
		} catch {
			return DecorationSet.empty;
		}
	}
	#isInlineDecoration(decoration) {
		return decoration.inline === true;
	}
	#extractSafeAttrs(decoration) {
		const raw = decoration.type?.attrs ?? {};
		const classes = typeof raw.class === "string" ? raw.class.split(/\s+/).filter((c) => c.length > 0) : [];
		const dataEntries = [];
		for (const [key, value] of Object.entries(raw)) {
			if (key === "class" || key === "style") continue;
			if (!key.startsWith("data-")) continue;
			if (typeof value !== "string") continue;
			dataEntries.push([key, value]);
		}
		return {
			classes,
			dataEntries,
			styleEntries: typeof raw.style === "string" ? DecorationBridge.#parseStyleString(raw.style) : []
		};
	}
	static #parseStyleString(cssText) {
		if (!cssText.trim()) return [];
		const temp = document.createElement("span");
		temp.style.cssText = cssText;
		const entries = [];
		for (let i = 0; i < temp.style.length; i++) {
			const prop = temp.style.item(i);
			const value = temp.style.getPropertyValue(prop);
			if (prop && value) entries.push([prop, value]);
		}
		return entries;
	}
	#getOrCreateDesired(map$1, el) {
		let state = map$1.get(el);
		if (!state) {
			state = {
				classes: /* @__PURE__ */ new Set(),
				dataAttrs: /* @__PURE__ */ new Map(),
				styleProps: /* @__PURE__ */ new Map()
			};
			map$1.set(el, state);
		}
		return state;
	}
	#reconcile(desired, domIndex, docSize) {
		let mutated = false;
		for (const [el, desiredState] of desired) {
			const applied = this.#applied.get(el);
			if (!applied) {
				this.#applyFresh(el, desiredState);
				mutated = true;
			} else if (this.#applyDiff(el, applied, desiredState)) mutated = true;
		}
		const allEntries = docSize > 0 ? domIndex.findEntriesInRange(0, docSize) : [];
		for (const entry of allEntries) {
			if (desired.has(entry.el)) continue;
			const applied = this.#applied.get(entry.el);
			if (!applied) continue;
			this.#removeAll(entry.el, applied);
			mutated = true;
		}
		return mutated;
	}
	#applyFresh(el, desired) {
		const tracked = {
			classes: /* @__PURE__ */ new Set(),
			dataAttrs: /* @__PURE__ */ new Map(),
			styleProps: /* @__PURE__ */ new Map(),
			priorClasses: /* @__PURE__ */ new Set(),
			priorDataAttrs: /* @__PURE__ */ new Map(),
			priorStyleProps: /* @__PURE__ */ new Map()
		};
		for (const cls of desired.classes) {
			if (el.classList.contains(cls)) tracked.priorClasses.add(cls);
			el.classList.add(cls);
			tracked.classes.add(cls);
		}
		for (const [key, value] of desired.dataAttrs) {
			const prior = el.getAttribute(key);
			if (prior !== null) tracked.priorDataAttrs.set(key, prior);
			el.setAttribute(key, value);
			tracked.dataAttrs.set(key, value);
		}
		for (const [prop, value] of desired.styleProps) {
			const prior = el.style.getPropertyValue(prop);
			if (prior) tracked.priorStyleProps.set(prop, prior);
			el.style.setProperty(prop, value);
			tracked.styleProps.set(prop, value);
		}
		this.#applied.set(el, tracked);
	}
	#ensureDesiredClass(el, applied, className) {
		const hasCachedClass = applied.classes.has(className);
		const hasDomClass = el.classList.contains(className);
		if (hasCachedClass && hasDomClass) return false;
		if (!hasCachedClass && hasDomClass) applied.priorClasses.add(className);
		el.classList.add(className);
		applied.classes.add(className);
		return true;
	}
	#ensureDesiredDataAttr(el, applied, key, value) {
		const cachedValue = applied.dataAttrs.get(key);
		const domValue = el.getAttribute(key);
		if (cachedValue === value && domValue === value) return false;
		if (!applied.dataAttrs.has(key) && domValue !== null) applied.priorDataAttrs.set(key, domValue);
		el.setAttribute(key, value);
		applied.dataAttrs.set(key, value);
		return true;
	}
	#ensureDesiredStyleProp(el, applied, prop, value) {
		const cachedValue = applied.styleProps.get(prop);
		const domValue = el.style.getPropertyValue(prop);
		if (cachedValue === value && domValue === value) return false;
		if (!applied.styleProps.has(prop) && domValue) applied.priorStyleProps.set(prop, domValue);
		el.style.setProperty(prop, value);
		applied.styleProps.set(prop, value);
		return true;
	}
	#applyDiff(el, applied, desired) {
		let mutated = false;
		for (const cls of desired.classes) if (this.#ensureDesiredClass(el, applied, cls)) mutated = true;
		for (const cls of applied.classes) if (!desired.classes.has(cls)) {
			if (!applied.priorClasses.has(cls)) el.classList.remove(cls);
			applied.priorClasses.delete(cls);
			applied.classes.delete(cls);
			mutated = true;
		}
		for (const [key, value] of desired.dataAttrs) if (this.#ensureDesiredDataAttr(el, applied, key, value)) mutated = true;
		for (const key of applied.dataAttrs.keys()) if (!desired.dataAttrs.has(key)) {
			const prior = applied.priorDataAttrs.get(key);
			if (prior != null) el.setAttribute(key, prior);
			else el.removeAttribute(key);
			applied.priorDataAttrs.delete(key);
			applied.dataAttrs.delete(key);
			mutated = true;
		}
		for (const [prop, value] of desired.styleProps) if (this.#ensureDesiredStyleProp(el, applied, prop, value)) mutated = true;
		for (const prop of applied.styleProps.keys()) if (!desired.styleProps.has(prop)) {
			const prior = applied.priorStyleProps.get(prop);
			if (prior) el.style.setProperty(prop, prior);
			else el.style.removeProperty(prop);
			applied.priorStyleProps.delete(prop);
			applied.styleProps.delete(prop);
			mutated = true;
		}
		if (applied.classes.size === 0 && applied.dataAttrs.size === 0 && applied.styleProps.size === 0) this.#applied.delete(el);
		return mutated;
	}
	#removeAll(el, applied) {
		for (const cls of applied.classes) if (!applied.priorClasses.has(cls)) el.classList.remove(cls);
		for (const key of applied.dataAttrs.keys()) {
			const prior = applied.priorDataAttrs.get(key);
			if (prior != null) el.setAttribute(key, prior);
			else el.removeAttribute(key);
		}
		for (const prop of applied.styleProps.keys()) {
			const prior = applied.priorStyleProps.get(prop);
			if (prior) el.style.setProperty(prop, prior);
			else el.style.removeProperty(prop);
		}
		this.#applied.delete(el);
	}
};
var INTERACTION_EPOCH_KEY$2 = "interactionEpoch";
var DISPLAY_LABEL_SOURCE_KEY = "displayLabelSource";
var DISPLAY_LABEL_SOURCE = {
	CANONICAL: "canonical",
	DERIVED: "derived"
};
function resolveAnnotationDisplayLabel(annotation, contentEl) {
	const existingLabel = annotation.dataset[DATASET_KEYS.DISPLAY_LABEL];
	const existingLabelSource = annotation.dataset[DISPLAY_LABEL_SOURCE_KEY];
	if (existingLabel !== void 0 && existingLabelSource !== DISPLAY_LABEL_SOURCE.DERIVED) return {
		source: DISPLAY_LABEL_SOURCE.CANONICAL,
		value: existingLabel
	};
	const derivedLabel = contentEl?.textContent?.trim() ?? "";
	if (derivedLabel.length === 0) return null;
	return {
		source: DISPLAY_LABEL_SOURCE.DERIVED,
		value: derivedLabel
	};
}
var FieldAnnotationInteractionLayer = class {
	#container = null;
	setContainer(container) {
		this.#container = container;
	}
	apply(layoutEpoch) {
		if (!this.#container) return;
		const epochStr = String(layoutEpoch);
		const annotations = this.#container.querySelectorAll(buildAnnotationSelector());
		for (let index = 0; index < annotations.length; index += 1) {
			const annotation = annotations[index];
			if (annotation.dataset[INTERACTION_EPOCH_KEY$2] === epochStr) continue;
			annotation.dataset[INTERACTION_EPOCH_KEY$2] = epochStr;
			annotation.draggable = true;
			annotation.dataset[DATASET_KEYS.DRAGGABLE] = "true";
			const displayLabel = resolveAnnotationDisplayLabel(annotation, annotation.querySelector(`.${DOM_CLASS_NAMES.ANNOTATION_CONTENT}`));
			if (displayLabel !== null) {
				annotation.dataset[DATASET_KEYS.DISPLAY_LABEL] = displayLabel.value;
				annotation.dataset[DISPLAY_LABEL_SOURCE_KEY] = displayLabel.source;
			}
			const variantType = annotation.dataset[DATASET_KEYS.TYPE];
			if (variantType) annotation.dataset[DATASET_KEYS.VARIANT] = variantType;
			this.#ensureCaretAnchor(annotation);
		}
	}
	clear() {
		if (!this.#container) return;
		const annotations = this.#container.querySelectorAll(buildAnnotationSelector());
		for (let index = 0; index < annotations.length; index += 1) {
			const annotation = annotations[index];
			annotation.removeAttribute("draggable");
			delete annotation.dataset[DATASET_KEYS.DRAGGABLE];
			delete annotation.dataset[DATASET_KEYS.DISPLAY_LABEL];
			delete annotation.dataset[DATASET_KEYS.VARIANT];
			delete annotation.dataset[INTERACTION_EPOCH_KEY$2];
			delete annotation.dataset[DISPLAY_LABEL_SOURCE_KEY];
			annotation.querySelector(`.${DOM_CLASS_NAMES.ANNOTATION_CARET_ANCHOR}`)?.remove();
		}
	}
	#ensureCaretAnchor(annotation) {
		if (annotation.querySelector(`.${DOM_CLASS_NAMES.ANNOTATION_CARET_ANCHOR}`)) return;
		const pmEnd = annotation.dataset[DATASET_KEYS.PM_END];
		const layoutEpoch = annotation.dataset[DATASET_KEYS.LAYOUT_EPOCH];
		if (pmEnd == null) return;
		const doc$1 = this.#container?.ownerDocument;
		if (!doc$1) return;
		const caretAnchor = doc$1.createElement("span");
		caretAnchor.dataset[DATASET_KEYS.PM_START] = pmEnd;
		caretAnchor.dataset[DATASET_KEYS.PM_END] = pmEnd;
		caretAnchor.dataset[DATASET_KEYS.LAYOUT_EPOCH] = layoutEpoch ?? "";
		caretAnchor.classList.add(DOM_CLASS_NAMES.ANNOTATION_CARET_ANCHOR);
		caretAnchor.style.position = "absolute";
		caretAnchor.style.left = "100%";
		caretAnchor.style.top = "0";
		caretAnchor.style.width = "0";
		caretAnchor.style.height = "1em";
		caretAnchor.style.overflow = "hidden";
		caretAnchor.style.pointerEvents = "none";
		caretAnchor.style.userSelect = "none";
		caretAnchor.style.opacity = "0";
		caretAnchor.textContent = "​";
		if (!annotation.style.position) annotation.style.position = "relative";
		annotation.appendChild(caretAnchor);
	}
};
var INTERACTION_EPOCH_KEY$1 = "imageInteractionEpoch";
function parsePmNumber(value) {
	return value && value.trim().length > 0 ? value : null;
}
function collectImageRoots(container) {
	const roots = [];
	const seen = /* @__PURE__ */ new Set();
	const add = (element) => {
		if (!element || seen.has(element)) return;
		seen.add(element);
		roots.push(element);
	};
	for (const fragment of Array.from(container.querySelectorAll(`.${DOM_CLASS_NAMES.IMAGE_FRAGMENT}`))) {
		if (!fragment.hasAttribute("data-image-metadata") && fragment.querySelector?.(`[data-image-metadata]`) == null) continue;
		add(fragment);
	}
	for (const wrapper of Array.from(container.querySelectorAll(`.${DOM_CLASS_NAMES.INLINE_IMAGE_CLIP_WRAPPER}`))) {
		if (wrapper.querySelector?.(`[data-image-metadata]`) == null) continue;
		add(wrapper);
	}
	for (const inlineImage of Array.from(container.querySelectorAll(`.${DOM_CLASS_NAMES.INLINE_IMAGE}`))) if (inlineImage.hasAttribute("data-image-metadata") && inlineImage.closest(`.${DOM_CLASS_NAMES.INLINE_IMAGE_CLIP_WRAPPER}`) == null) add(inlineImage);
	return roots;
}
function resolveImageLabel(root) {
	const directLabel = root.dataset[DATASET_KEYS.DISPLAY_LABEL];
	if (directLabel) return directLabel;
	const img = root.tagName === "IMG" ? root : root.querySelector("img");
	const alt = img?.getAttribute("alt")?.trim();
	if (alt) return alt;
	const title = img?.getAttribute("title")?.trim();
	if (title) return title;
	return root.getAttribute("data-block-id") ?? root.getAttribute("data-sd-block-id") ?? "Image";
}
function resolveImageKind(root) {
	return root.classList.contains(DOM_CLASS_NAMES.IMAGE_FRAGMENT) ? "block" : "inline";
}
function getBehindDocSection(root) {
	return root.closest("[data-behind-doc-section]")?.dataset.behindDocSection ?? null;
}
function canInteractWithRoot(root, activeHeaderFooterMode) {
	const section = getBehindDocSection(root);
	if (!section) return true;
	return section === activeHeaderFooterMode;
}
function clearImageRoot(root) {
	root.removeAttribute("draggable");
	delete root.dataset.dragSourceKind;
	delete root.dataset.imageKind;
	delete root.dataset.nodeType;
	delete root.dataset.displayLabel;
	delete root.dataset[INTERACTION_EPOCH_KEY$1];
}
var ImageInteractionLayer = class {
	#container = null;
	setContainer(container) {
		this.#container = container;
	}
	apply(layoutEpoch, options = {}) {
		if (!this.#container) return;
		const epochStr = String(layoutEpoch);
		for (const root of collectImageRoots(this.#container)) {
			if (!canInteractWithRoot(root, options.activeHeaderFooterMode ?? "body")) {
				clearImageRoot(root);
				continue;
			}
			if (root.dataset[INTERACTION_EPOCH_KEY$1] === epochStr) continue;
			const pmStart = parsePmNumber(root.dataset.pmStart);
			const pmEnd = parsePmNumber(root.dataset.pmEnd);
			if (!pmStart || !pmEnd) continue;
			root.dataset[INTERACTION_EPOCH_KEY$1] = epochStr;
			root.draggable = true;
			root.dataset.dragSourceKind = "existingImage";
			root.dataset.imageKind = resolveImageKind(root);
			root.dataset.nodeType = "image";
			root.dataset.displayLabel = resolveImageLabel(root);
			root.dataset.pmStart = pmStart;
			root.dataset.pmEnd = pmEnd;
		}
	}
	clear() {
		if (!this.#container) return;
		for (const root of collectImageRoots(this.#container)) clearImageRoot(root);
	}
};
var BLOCK_LABEL_SELECTOR = ".superdoc-structured-content__label";
var INLINE_LABEL_SELECTOR = `.${DOM_CLASS_NAMES.INLINE_SDT_WRAPPER}__label`;
var INTERACTION_EPOCH_KEY = "structuredContentInteractionEpoch";
var StructuredContentInteractionLayer = class {
	#container = null;
	setContainer(container) {
		this.#container = container;
	}
	apply(layoutEpoch) {
		if (!this.#container) return;
		const labels = Array.from(this.#container.querySelectorAll(`${BLOCK_LABEL_SELECTOR}, ${INLINE_LABEL_SELECTOR}`));
		for (const label of labels) {
			if (label.dataset[INTERACTION_EPOCH_KEY] === String(layoutEpoch)) continue;
			const sdtElement = label.closest(`.${DOM_CLASS_NAMES.BLOCK_SDT}, .${DOM_CLASS_NAMES.INLINE_SDT_WRAPPER}`);
			if (!sdtElement?.dataset.sdtId || !sdtElement.dataset.pmStart || !sdtElement.dataset.pmEnd) continue;
			const lockMode = sdtElement.dataset.lockMode ?? "unlocked";
			if (lockMode !== "unlocked") {
				label.draggable = false;
				continue;
			}
			const scope = sdtElement.dataset.sdtScope ?? (sdtElement.classList.contains(DOM_CLASS_NAMES.BLOCK_SDT) ? "block" : "inline");
			const labelText = label.textContent?.trim() || "Structured content";
			label.dataset[INTERACTION_EPOCH_KEY] = String(layoutEpoch);
			label.draggable = true;
			label.dataset.dragSourceKind = "structuredContent";
			label.dataset.sdtId = sdtElement.dataset.sdtId;
			label.dataset.pmStart = sdtElement.dataset.pmStart;
			label.dataset.pmEnd = sdtElement.dataset.pmEnd;
			label.dataset.sdtScope = scope;
			label.dataset.lockMode = lockMode;
			label.dataset[DATASET_KEYS.DISPLAY_LABEL] = labelText;
			label.dataset.nodeType = scope === "block" ? "structuredContentBlock" : "structuredContent";
		}
	}
	clear() {
		if (!this.#container) return;
		const labels = Array.from(this.#container.querySelectorAll(`${BLOCK_LABEL_SELECTOR}, ${INLINE_LABEL_SELECTOR}`));
		for (const label of labels) {
			label.removeAttribute("draggable");
			delete label.dataset.dragSourceKind;
			delete label.dataset.sdtId;
			delete label.dataset.pmStart;
			delete label.dataset.pmEnd;
			delete label.dataset.sdtScope;
			delete label.dataset.lockMode;
			delete label.dataset.nodeType;
			delete label.dataset[DATASET_KEYS.DISPLAY_LABEL];
			delete label.dataset[INTERACTION_EPOCH_KEY];
		}
	}
};
const PROOFING_CSS = {
	SPELLING: "sd-proofing-spelling",
	GRAMMAR: "sd-proofing-grammar",
	STYLE: "sd-proofing-style",
	DATA_ATTR: "data-sd-proofing",
	SPLIT_ATTR: "data-sd-proofing-split"
};
function cssClassForKind(kind) {
	switch (kind) {
		case "spelling": return PROOFING_CSS.SPELLING;
		case "grammar": return PROOFING_CSS.GRAMMAR;
		case "style": return PROOFING_CSS.STYLE;
	}
}
var splitOriginMap = /* @__PURE__ */ new WeakMap();
function computeSplitSegments(spanPmStart, spanPmEnd, spanText, annotations) {
	const boundaries = /* @__PURE__ */ new Set();
	boundaries.add(spanPmStart);
	boundaries.add(spanPmEnd);
	for (const annotation of annotations) {
		const clampedFrom = Math.max(annotation.pmFrom, spanPmStart);
		const clampedTo = Math.min(annotation.pmTo, spanPmEnd);
		if (clampedFrom > spanPmStart) boundaries.add(clampedFrom);
		if (clampedTo < spanPmEnd) boundaries.add(clampedTo);
	}
	const sortedBoundaries = Array.from(boundaries).sort((a, b$1) => a - b$1);
	const segments = [];
	for (let index = 0; index < sortedBoundaries.length - 1; index += 1) {
		const segmentPmStart = sortedBoundaries[index];
		const segmentPmEnd = sortedBoundaries[index + 1];
		const textStart = segmentPmStart - spanPmStart;
		const textEnd = segmentPmEnd - spanPmStart;
		if (textEnd <= textStart || textStart >= spanText.length) continue;
		const clampedTextEnd = Math.min(textEnd, spanText.length);
		let proofingClass = null;
		for (const annotation of annotations) if (annotation.pmFrom <= segmentPmStart && annotation.pmTo >= segmentPmEnd) {
			proofingClass = cssClassForKind(annotation.kind);
			break;
		}
		segments.push({
			textStart,
			textEnd: clampedTextEnd,
			pmStart: segmentPmStart,
			pmEnd: segmentPmEnd,
			proofingClass
		});
	}
	return segments;
}
function replaceSpanWithSiblings(originalSpan, segments, spanText) {
	const parent = originalSpan.parentNode;
	if (!parent) return [];
	const doc$1 = originalSpan.ownerDocument;
	const siblings = [];
	for (const segment of segments) {
		const text = spanText.slice(segment.textStart, segment.textEnd);
		if (text.length === 0) continue;
		const span = doc$1.createElement("span");
		for (let index = 0; index < originalSpan.attributes.length; index += 1) {
			const attr = originalSpan.attributes[index];
			span.setAttribute(attr.name, attr.value);
		}
		span.setAttribute("data-pm-start", String(segment.pmStart));
		span.setAttribute("data-pm-end", String(segment.pmEnd));
		if (segment.proofingClass) {
			span.classList.add(segment.proofingClass);
			span.setAttribute("aria-invalid", "spelling");
		}
		span.setAttribute(PROOFING_CSS.SPLIT_ATTR, "");
		span.setAttribute(PROOFING_CSS.DATA_ATTR, "");
		span.textContent = "";
		span.appendChild(doc$1.createTextNode(text));
		splitOriginMap.set(span, originalSpan);
		siblings.push(span);
	}
	originalSpan.style.display = "none";
	originalSpan.setAttribute(PROOFING_CSS.DATA_ATTR, "original");
	const originalPmStart = originalSpan.getAttribute("data-pm-start");
	const originalPmEnd = originalSpan.getAttribute("data-pm-end");
	if (originalPmStart) originalSpan.setAttribute("data-sd-orig-pm-start", originalPmStart);
	if (originalPmEnd) originalSpan.setAttribute("data-sd-orig-pm-end", originalPmEnd);
	originalSpan.removeAttribute("data-pm-start");
	originalSpan.removeAttribute("data-pm-end");
	for (const sibling of siblings) parent.insertBefore(sibling, originalSpan);
	return siblings;
}
function restoreSplitSpans(container) {
	const splitSpans = Array.from(container.querySelectorAll(`[${PROOFING_CSS.SPLIT_ATTR}]`));
	if (splitSpans.length === 0) return false;
	const groupsByOriginal = /* @__PURE__ */ new Map();
	for (const span of splitSpans) {
		const original = splitOriginMap.get(span);
		if (!original) continue;
		const group = groupsByOriginal.get(original);
		if (group) group.push(span);
		else groupsByOriginal.set(original, [span]);
	}
	for (const [original, siblings] of groupsByOriginal) {
		const parent = original.parentNode;
		if (!parent) continue;
		unhideOriginalSpan(original);
		for (const sibling of siblings) parent.removeChild(sibling);
	}
	const remainingSplitSpans = Array.from(container.querySelectorAll(`[${PROOFING_CSS.SPLIT_ATTR}]`));
	for (const span of remainingSplitSpans) span.parentNode?.removeChild(span);
	const hiddenOriginals = Array.from(container.querySelectorAll(`[${PROOFING_CSS.DATA_ATTR}="original"]`));
	for (const element of hiddenOriginals) unhideOriginalSpan(element);
	return true;
}
function unhideOriginalSpan(element) {
	element.style.display = "";
	if (!element.style.cssText) element.removeAttribute("style");
	element.removeAttribute(PROOFING_CSS.DATA_ATTR);
	const savedStart = element.getAttribute("data-sd-orig-pm-start");
	const savedEnd = element.getAttribute("data-sd-orig-pm-end");
	if (savedStart) {
		element.setAttribute("data-pm-start", savedStart);
		element.removeAttribute("data-sd-orig-pm-start");
	}
	if (savedEnd) {
		element.setAttribute("data-pm-end", savedEnd);
		element.removeAttribute("data-sd-orig-pm-end");
	}
}
function applyProofingDecorations(container, annotations) {
	const hadPrevious = clearProofingDecorations(container);
	if (annotations.length === 0) return hadPrevious;
	const sortedAnnotations = [...annotations].sort((left$1, right$1) => left$1.pmFrom - right$1.pmFrom);
	const spans = Array.from(container.querySelectorAll("[data-pm-start][data-pm-end]"));
	let mutated = false;
	for (const span of spans) {
		const pmStart = Number.parseInt(span.getAttribute("data-pm-start") ?? "", 10);
		const pmEnd = Number.parseInt(span.getAttribute("data-pm-end") ?? "", 10);
		if (Number.isNaN(pmStart) || Number.isNaN(pmEnd) || pmEnd <= pmStart) continue;
		if (!isLeafTextSpan(span)) continue;
		const overlappingAnnotations = findOverlappingAnnotations(sortedAnnotations, pmStart, pmEnd);
		if (overlappingAnnotations.length === 0) continue;
		const text = span.textContent ?? "";
		if (text.length === 0) continue;
		if (isCoveredBySingleAnnotation(pmStart, pmEnd, overlappingAnnotations)) {
			span.classList.add(cssClassForKind(overlappingAnnotations[0].kind));
			span.setAttribute(PROOFING_CSS.DATA_ATTR, "");
			span.setAttribute("aria-invalid", "spelling");
			mutated = true;
			continue;
		}
		const segments = computeSplitSegments(pmStart, pmEnd, text, overlappingAnnotations);
		if (segments.length > 1) {
			replaceSpanWithSiblings(span, segments, text);
			mutated = true;
			continue;
		}
		if (segments.length === 1 && segments[0].proofingClass) {
			span.classList.add(segments[0].proofingClass);
			span.setAttribute(PROOFING_CSS.DATA_ATTR, "");
			span.setAttribute("aria-invalid", "spelling");
			mutated = true;
		}
	}
	return mutated || hadPrevious;
}
function clearProofingDecorations(container) {
	let cleared = false;
	const restoredSplits = restoreSplitSpans(container);
	const decoratedElements = Array.from(container.querySelectorAll(`[${PROOFING_CSS.DATA_ATTR}]`));
	for (const element of decoratedElements) {
		element.classList.remove(PROOFING_CSS.SPELLING, PROOFING_CSS.GRAMMAR, PROOFING_CSS.STYLE);
		element.removeAttribute(PROOFING_CSS.DATA_ATTR);
		element.removeAttribute("aria-invalid");
		cleared = true;
	}
	return cleared || restoredSplits;
}
function isLeafTextSpan(element) {
	const children = element.childNodes;
	if (children.length === 0) return false;
	for (let index = 0; index < children.length; index += 1) if (children[index].nodeType === Node.ELEMENT_NODE) return false;
	return true;
}
function findOverlappingAnnotations(sortedAnnotations, pmStart, pmEnd) {
	const overlapping = [];
	for (const annotation of sortedAnnotations) {
		if (annotation.pmFrom >= pmEnd) break;
		if (annotation.pmTo > pmStart) overlapping.push(annotation);
	}
	return overlapping;
}
function isCoveredBySingleAnnotation(pmStart, pmEnd, annotations) {
	return annotations.some((annotation) => annotation.pmFrom <= pmStart && annotation.pmTo >= pmEnd);
}
var PresentationProofingDecorator = class {
	#container = null;
	setContainer(container) {
		this.#container = container;
	}
	applyAnnotations(annotations) {
		const container = this.#container;
		if (!container) return false;
		if (!annotations || annotations.length === 0) return clearProofingDecorations(container);
		return applyProofingDecorations(container, annotations);
	}
	clear() {
		const container = this.#container;
		if (!container) return false;
		return clearProofingDecorations(container);
	}
};
var PresentationPostPaintPipeline = class {
	#fieldAnnotationLayer;
	#imageLayer;
	#structuredContentLayer;
	#commentHighlightDecorator;
	#decorationBridge;
	#proofingDecorator;
	constructor(deps = {}) {
		this.#fieldAnnotationLayer = deps.fieldAnnotationLayer ?? new FieldAnnotationInteractionLayer();
		this.#imageLayer = deps.imageLayer ?? new ImageInteractionLayer();
		this.#structuredContentLayer = deps.structuredContentLayer ?? new StructuredContentInteractionLayer();
		this.#commentHighlightDecorator = deps.commentHighlightDecorator ?? new CommentHighlightDecorator();
		this.#decorationBridge = deps.decorationBridge ?? new DecorationBridge();
		this.#proofingDecorator = deps.proofingDecorator ?? new PresentationProofingDecorator();
	}
	setContainer(container) {
		this.#fieldAnnotationLayer.setContainer(container);
		this.#imageLayer.setContainer(container);
		this.#structuredContentLayer.setContainer(container);
		this.#commentHighlightDecorator.setContainer(container);
		this.#proofingDecorator.setContainer(container);
	}
	setActiveComment(commentId) {
		return this.#commentHighlightDecorator.setActiveComment(commentId);
	}
	recordDecorationTransaction(transaction) {
		this.#decorationBridge.recordTransaction(transaction);
	}
	hasDecorationChanges(editorState) {
		return this.#decorationBridge.hasChanges(editorState);
	}
	hasCurrentDecorationRanges(editorState) {
		return this.#decorationBridge.hasCurrentRanges(editorState);
	}
	collectDecorationRanges(editorState) {
		return this.#decorationBridge.collectDecorationRanges(editorState);
	}
	syncDecorations(editorState, domPositionIndex, options) {
		if (!editorState) return false;
		return this.#decorationBridge.sync(editorState, domPositionIndex, options);
	}
	applyCommentHighlights() {
		this.#commentHighlightDecorator.apply();
	}
	syncInlineStyleLayers(editorState, domPositionIndex) {
		this.applyCommentHighlights();
		return this.syncDecorations(editorState, domPositionIndex);
	}
	applyProofingAnnotations(annotations, rebuildDomPositionIndex) {
		const mutated = this.#proofingDecorator.applyAnnotations(annotations);
		if (mutated) rebuildDomPositionIndex();
		return mutated;
	}
	refreshAfterPaint(options) {
		this.#fieldAnnotationLayer.apply(options.layoutEpoch);
		options.rebuildDomPositionIndex();
		this.#imageLayer.apply(options.layoutEpoch, { activeHeaderFooterMode: options.activeHeaderFooterMode });
		this.#structuredContentLayer.apply(options.layoutEpoch);
		this.syncInlineStyleLayers(options.editorState, options.domPositionIndex);
		this.applyProofingAnnotations(options.proofingAnnotations, options.rebuildDomPositionIndex);
		options.reapplyStructuredContentHover?.();
		options.reapplyTocGroupHover?.();
	}
	destroy() {
		this.#proofingDecorator.clear();
		this.#fieldAnnotationLayer.clear();
		this.#imageLayer.clear();
		this.#structuredContentLayer.clear();
		this.#commentHighlightDecorator.destroy();
		this.#decorationBridge.destroy();
	}
};
var HoverGroupCoordinator = class {
	#spec;
	#current = null;
	constructor(spec) {
		this.handleMouseEnter = (event) => {
			const entry = event.target?.closest?.(this.#spec.entrySelector);
			if (!entry) return;
			const id = this.#spec.getId(entry);
			if (!id) return;
			this.#set(id);
		};
		this.handleMouseLeave = (event) => {
			const entry = event.target?.closest?.(this.#spec.entrySelector);
			if (!entry) return;
			const id = this.#spec.getId(entry);
			if (!id) return;
			const relatedTarget = event.relatedTarget;
			if (relatedTarget) {
				const nextEntry = relatedTarget.closest?.(this.#spec.entrySelector);
				if (nextEntry && this.#spec.getId(nextEntry) === id) return;
			}
			this.clear();
		};
		this.#spec = spec;
	}
	reapply() {
		if (!this.#current) return;
		const { id } = this.#current;
		const elements = this.#spec.queryGroup(id);
		if (elements.length === 0) {
			this.#current = null;
			return;
		}
		this.#applyClass(elements);
		this.#spec.onApply?.(elements);
		this.#current = {
			id,
			elements
		};
	}
	clear() {
		if (!this.#current) return;
		for (const element of this.#current.elements) {
			element.classList.remove(this.#spec.hoverClass);
			this.#spec.onClear?.(element);
		}
		this.#current = null;
	}
	#set(id) {
		if (this.#current?.id === id) return;
		this.clear();
		const elements = this.#spec.queryGroup(id);
		if (elements.length === 0) return;
		this.#applyClass(elements);
		this.#spec.onApply?.(elements);
		this.#current = {
			id,
			elements
		};
	}
	#applyClass(elements) {
		const filter = this.#spec.shouldApplyTo;
		for (const element of elements) {
			if (filter && !filter(element)) continue;
			element.classList.add(this.#spec.hoverClass);
		}
	}
};
var ProofingStore = class {
	#issuesBySegment = /* @__PURE__ */ new Map();
	addIssue(issue) {
		const list = this.#issuesBySegment.get(issue.segmentId);
		if (list) list.push(issue);
		else this.#issuesBySegment.set(issue.segmentId, [issue]);
	}
	remapIssues(segmentIds, mapping, recheckId) {
		for (const id of segmentIds) {
			const list = this.#issuesBySegment.get(id);
			if (!list) continue;
			const surviving = [];
			for (const issue of list) {
				const fromResult = mapping.mapResult(issue.pmFrom, -1);
				const toResult = mapping.mapResult(issue.pmTo, 1);
				if (fromResult.deleted || toResult.deleted) continue;
				if (fromResult.pos >= toResult.pos) continue;
				issue.pmFrom = fromResult.pos;
				issue.pmTo = toResult.pos;
				issue.state = "mapped";
				issue.recheckId = recheckId;
				surviving.push(issue);
			}
			if (surviving.length > 0) this.#issuesBySegment.set(id, surviving);
			else this.#issuesBySegment.delete(id);
		}
	}
	replaceBatchResults(recheckIds, coveredSegmentIds, freshIssues) {
		for (const segId of coveredSegmentIds) {
			const list = this.#issuesBySegment.get(segId);
			if (!list) continue;
			const filtered = list.filter((issue) => issue.recheckId === null || !recheckIds.has(issue.recheckId));
			if (filtered.length > 0) this.#issuesBySegment.set(segId, filtered);
			else this.#issuesBySegment.delete(segId);
		}
		for (const issue of freshIssues) this.addIssue(issue);
	}
	removeBySegmentIds(ids) {
		for (const id of ids) this.#issuesBySegment.delete(id);
	}
	removeOrphanedSegments(currentSegmentIds) {
		for (const segId of this.#issuesBySegment.keys()) if (!currentSegmentIds.has(segId)) this.#issuesBySegment.delete(segId);
	}
	clear() {
		this.#issuesBySegment.clear();
	}
	getAllIssues() {
		const result = [];
		for (const list of this.#issuesBySegment.values()) result.push(...list);
		return result;
	}
	getDisplayIssues(ignoredWords) {
		const normalizedIgnored = new Set(ignoredWords.map((w) => w.normalize("NFC").toLowerCase()));
		const result = [];
		for (const list of this.#issuesBySegment.values()) for (const issue of list) {
			if (issue.kind !== "spelling") continue;
			if (isSuppressed(issue, normalizedIgnored)) continue;
			result.push(issue);
		}
		return result;
	}
	getActiveRecheckIds() {
		const ids = /* @__PURE__ */ new Set();
		for (const list of this.#issuesBySegment.values()) for (const issue of list) if (issue.state === "mapped" && issue.recheckId !== null) ids.add(issue.recheckId);
		return ids;
	}
	get isEmpty() {
		return this.#issuesBySegment.size === 0;
	}
	get size() {
		let count = 0;
		for (const list of this.#issuesBySegment.values()) count += list.length;
		return count;
	}
};
function isSuppressed(issue, normalizedIgnored) {
	if (normalizedIgnored.size === 0) return false;
	const raw = issue.word ?? issue.message;
	if (!raw) return false;
	const normalized = raw.normalize("NFC").toLowerCase();
	return normalizedIgnored.has(normalized);
}
function resolveSegmentLanguage(paraNode, defaultLanguage) {
	const runLanguage = findFirstRunLanguage(paraNode);
	if (runLanguage) return runLanguage;
	const paraLang = extractParagraphLanguage(paraNode);
	if (paraLang) return paraLang;
	return defaultLanguage;
}
function findFirstRunLanguage(paraNode) {
	let lang = null;
	paraNode.descendants((node) => {
		if (lang) return false;
		if (node.type.name === "run") {
			const runProps = node.attrs.runProperties;
			if (runProps?.lang?.val) {
				lang = runProps.lang.val;
				return false;
			}
		}
		return true;
	});
	return lang;
}
function extractParagraphLanguage(paraNode) {
	return paraNode.attrs.paragraphProperties?.lang?.val ?? null;
}
function extractSegmentsWithMaps(doc$1, defaultLanguage, pageResolver) {
	const segments = [];
	const offsetMaps = /* @__PURE__ */ new Map();
	const segmentPositions = /* @__PURE__ */ new Map();
	walkParagraphs(doc$1, (paraNode, paraPos, surface) => {
		const { text, slices } = extractParagraphText(paraNode, paraPos);
		if (text.length === 0) return;
		const segmentId = buildSegmentId(paraNode, paraPos);
		const language = resolveSegmentLanguage(paraNode, defaultLanguage ?? null);
		const pageIndex = pageResolver?.(paraPos);
		segments.push({
			id: segmentId,
			text,
			language,
			metadata: {
				blockId: paraNode.attrs.sdBlockId,
				pageIndex,
				surface
			}
		});
		offsetMaps.set(segmentId, {
			segmentId,
			slices
		});
		segmentPositions.set(segmentId, paraPos);
	});
	return {
		segments,
		offsetMaps,
		segmentPositions
	};
}
function walkParagraphs(doc$1, visitor) {
	doc$1.descendants((node, pos) => {
		const typeName = node.type.name;
		if (typeName === "header" || typeName === "footer") return false;
		if (typeName === "paragraph") {
			visitor(node, pos, isInsideTableCell(doc$1, pos) ? "table-cell" : "body");
			return false;
		}
		return true;
	});
}
function isInsideTableCell(doc$1, pos) {
	const resolved = doc$1.resolve(pos);
	for (let depth = resolved.depth; depth > 0; depth--) {
		const ancestor = resolved.node(depth);
		if (ancestor.type.name === "tableCell" || ancestor.type.name === "tableHeader") return true;
	}
	return false;
}
function extractParagraphText(paraNode, paraPos) {
	const parts = [];
	const slices = [];
	let textOffset = 0;
	const contentStart = paraPos + 1;
	paraNode.forEach((child, offset$1) => {
		processNode(child, contentStart + offset$1);
	});
	return {
		text: parts.join(""),
		slices
	};
	function processNode(node, pos) {
		const typeName = node.type.name;
		if (typeName === "run") {
			const runProps = node.attrs.runProperties;
			if (runProps?.vanish === true) {
				emitBoundary();
				return;
			}
			if (runProps?.noProof === true) {
				emitBoundary();
				return;
			}
			const runContentStart = pos + 1;
			node.forEach((child, childOff) => {
				processNode(child, runContentStart + childOff);
			});
			return;
		}
		if (node.isText && node.text) {
			if (hasTrackDeleteMark(node)) return;
			const text = node.text;
			const pmFrom = pos;
			const pmTo = pos + text.length;
			slices.push({
				textStart: textOffset,
				textEnd: textOffset + text.length,
				pmFrom,
				pmTo
			});
			parts.push(text);
			textOffset += text.length;
			return;
		}
		if (isNonTextInlineNode(typeName)) {
			emitBoundary();
			return;
		}
		if (node.childCount > 0) {
			const contentStart$1 = pos + 1;
			node.forEach((child, childOff) => {
				processNode(child, contentStart$1 + childOff);
			});
		}
	}
	function emitBoundary() {
		if (parts.length > 0 && !parts[parts.length - 1].endsWith(" ")) {
			parts.push(" ");
			textOffset += 1;
		}
	}
}
function hasTrackDeleteMark(node) {
	return node.marks?.some((m$1) => m$1.type.name === "trackDelete") ?? false;
}
var NON_TEXT_INLINE_NODES = new Set([
	"fieldAnnotation",
	"image",
	"equation",
	"hardBreak",
	"lineBreak",
	"tab",
	"footnoteReference",
	"symbol"
]);
function isNonTextInlineNode(typeName) {
	return NON_TEXT_INLINE_NODES.has(typeName);
}
function buildSegmentId(paraNode, paraPos) {
	const blockId = paraNode.attrs.sdBlockId;
	return blockId ? `blk-${blockId}` : `pos-${paraPos}`;
}
function resolveIssuePmRangeFromSlices(issue, slices) {
	const pmFrom = textOffsetToPmPos(issue.start, slices);
	const pmTo = textOffsetToPmPos(issue.end, slices);
	if (pmFrom === null || pmTo === null || pmFrom >= pmTo) return null;
	return {
		...issue,
		pmFrom,
		pmTo
	};
}
function textOffsetToPmPos(textOffset, slices) {
	for (const slice of slices) if (textOffset >= slice.textStart && textOffset <= slice.textEnd) {
		const delta = textOffset - slice.textStart;
		return slice.pmFrom + delta;
	}
	for (const slice of slices) if (slice.textStart >= textOffset) return slice.pmFrom;
	if (slices.length > 0) {
		const last = slices[slices.length - 1];
		if (textOffset >= last.textEnd) return last.pmTo;
	}
	return null;
}
function computeDirtySegmentIds(segments, segmentPositions, changedRanges) {
	if (changedRanges.length === 0) return /* @__PURE__ */ new Set();
	const dirty = /* @__PURE__ */ new Set();
	const sorted = segments.map((seg) => ({
		id: seg.id,
		pos: segmentPositions.get(seg.id) ?? -1
	})).filter((s) => s.pos >= 0).sort((a, b$1) => a.pos - b$1.pos);
	for (const range of changedRanges) for (let i = 0; i < sorted.length; i++) {
		const seg = sorted[i];
		const segEnd = sorted[i + 1]?.pos ?? Infinity;
		if (seg.pos < range.to && segEnd > range.from) dirty.add(seg.id);
		if (seg.pos <= range.from && segEnd >= range.from && i > 0) dirty.add(sorted[i - 1].id);
	}
	return dirty;
}
function hashSegmentText(text) {
	let hash$3 = 2166136261;
	for (let i = 0; i < text.length; i++) {
		hash$3 ^= text.charCodeAt(i);
		hash$3 = Math.imul(hash$3, 16777619);
	}
	return (hash$3 >>> 0).toString(16);
}
function prioritizeByVisibility(segments, visibilitySource) {
	const visiblePages = visibilitySource.getVisiblePageIndices();
	if (!visiblePages || visiblePages.length === 0) return segments;
	const visibleSet = new Set(visiblePages);
	const visible = [];
	const rest = [];
	for (const seg of segments) {
		const pageIndex = seg.metadata.pageIndex;
		if (pageIndex !== void 0 && visibleSet.has(pageIndex)) visible.push(seg);
		else rest.push(seg);
	}
	return [...visible, ...rest];
}
function buildPaintSlices(issues) {
	const spellingIssues = issues.filter((i) => i.kind === "spelling");
	if (spellingIssues.length === 0) return [];
	const sorted = [...spellingIssues].sort((a, b$1) => a.pmFrom - b$1.pmFrom || a.pmTo - b$1.pmTo);
	const slices = [];
	let current = null;
	for (const issue of sorted) {
		if (!current) {
			current = {
				pmFrom: issue.pmFrom,
				pmTo: issue.pmTo,
				kind: "spelling",
				issue
			};
			continue;
		}
		if (issue.pmFrom <= current.pmTo) current.pmTo = Math.max(current.pmTo, issue.pmTo);
		else {
			slices.push(current);
			current = {
				pmFrom: issue.pmFrom,
				pmTo: issue.pmTo,
				kind: "spelling",
				issue
			};
		}
	}
	if (current) slices.push(current);
	return slices;
}
function findSliceAtPosition(slices, pmPos) {
	let lo = 0;
	let hi = slices.length - 1;
	while (lo <= hi) {
		const mid = lo + hi >>> 1;
		const slice = slices[mid];
		if (pmPos < slice.pmFrom) hi = mid - 1;
		else if (pmPos >= slice.pmTo) lo = mid + 1;
		else return slice;
	}
	return null;
}
var DEFAULT_DEBOUNCE_MS = 500;
var DEFAULT_MAX_WAIT_MS = 2e3;
var DEFAULT_TIMEOUT_MS = 1e4;
var DEFAULT_MAX_CONCURRENT = 2;
var DEFAULT_MAX_SEGMENTS_PER_BATCH = 20;
var DEFAULT_MAX_SUGGESTIONS = 5;
var ProofingSessionManager = class {
	#config;
	#provider = null;
	#capabilities = null;
	#status = "disabled";
	#store = new ProofingStore();
	#offsetMaps = /* @__PURE__ */ new Map();
	#segmentHashes = /* @__PURE__ */ new Map();
	#debounceTimer = null;
	#pendingAbortControllers = /* @__PURE__ */ new Set();
	#inFlightCount = 0;
	#documentEpoch = 0;
	#disposed = false;
	#pendingSegments = [];
	#nextRecheckId = 0;
	#isComposing = false;
	#lastCheckFiredAt = 0;
	#visibilitySource = null;
	#documentId = null;
	#pageResolver = null;
	#lastDoc = null;
	#lastSegments = [];
	constructor(config = {}) {
		this.onResultsChanged = null;
		this.#config = {
			enabled: config.enabled ?? false,
			debounceMs: config.debounceMs ?? DEFAULT_DEBOUNCE_MS,
			maxSuggestions: config.maxSuggestions ?? DEFAULT_MAX_SUGGESTIONS,
			visibleFirst: config.visibleFirst ?? true,
			allowIgnoreWord: config.allowIgnoreWord ?? true,
			defaultLanguage: config.defaultLanguage ?? null,
			ignoredWords: config.ignoredWords ?? [],
			timeoutMs: config.timeoutMs ?? DEFAULT_TIMEOUT_MS,
			maxConcurrentRequests: config.maxConcurrentRequests ?? DEFAULT_MAX_CONCURRENT,
			maxSegmentsPerBatch: config.maxSegmentsPerBatch ?? DEFAULT_MAX_SEGMENTS_PER_BATCH,
			onProofingError: config.onProofingError ?? null,
			onStatusChange: config.onStatusChange ?? null
		};
		if (config.provider) this.#provider = config.provider;
		if (this.#config.enabled && this.#provider) this.#setStatus("idle");
	}
	get status() {
		return this.#status;
	}
	get isEnabled() {
		return this.#config.enabled && this.#provider !== null;
	}
	get config() {
		return this.#config;
	}
	setVisibilitySource(source) {
		this.#visibilitySource = source;
	}
	setDocumentId(id) {
		this.#documentId = id;
	}
	setPageResolver(resolver) {
		this.#pageResolver = resolver;
	}
	setComposing(composing) {
		this.#isComposing = composing;
		if (!composing && this.#lastSegments.length > 0 && this.isEnabled) this.#scheduleDebouncedCheck(this.#lastSegments);
	}
	getPaintSlices(activeWordRange) {
		if (!this.isEnabled) return [];
		const slices = buildPaintSlices(this.#store.getDisplayIssues(this.#config.ignoredWords));
		if (!activeWordRange) return slices;
		return slices.filter((s) => s.pmTo <= activeWordRange.from || s.pmFrom >= activeWordRange.to);
	}
	getIssueAtPosition(pmPos, activeWordRange) {
		return findSliceAtPosition(this.getPaintSlices(activeWordRange), pmPos)?.issue ?? null;
	}
	updateConfig(patch, doc$1) {
		const prevEnabled = this.#config.enabled;
		const prevProvider = this.#provider;
		const needsRecheck = patch.provider !== void 0 || patch.defaultLanguage !== void 0;
		if (patch.debounceMs !== void 0) this.#config.debounceMs = patch.debounceMs;
		if (patch.maxSuggestions !== void 0) this.#config.maxSuggestions = patch.maxSuggestions;
		if (patch.visibleFirst !== void 0) this.#config.visibleFirst = patch.visibleFirst;
		if (patch.allowIgnoreWord !== void 0) this.#config.allowIgnoreWord = patch.allowIgnoreWord;
		if (patch.timeoutMs !== void 0) this.#config.timeoutMs = patch.timeoutMs;
		if (patch.maxConcurrentRequests !== void 0) this.#config.maxConcurrentRequests = patch.maxConcurrentRequests;
		if (patch.maxSegmentsPerBatch !== void 0) this.#config.maxSegmentsPerBatch = patch.maxSegmentsPerBatch;
		if (patch.onProofingError !== void 0) this.#config.onProofingError = patch.onProofingError ?? null;
		if (patch.onStatusChange !== void 0) this.#config.onStatusChange = patch.onStatusChange ?? null;
		if (patch.defaultLanguage !== void 0) this.#config.defaultLanguage = patch.defaultLanguage ?? null;
		if (patch.ignoredWords !== void 0) {
			this.#config.ignoredWords = patch.ignoredWords ?? [];
			this.onResultsChanged?.();
		}
		if (patch.provider !== void 0) {
			if (prevProvider && prevProvider !== patch.provider) prevProvider.dispose?.();
			this.#provider = patch.provider ?? null;
			this.#capabilities = null;
		}
		if (patch.enabled !== void 0) {
			this.#config.enabled = patch.enabled;
			if (!patch.enabled) {
				this.#cancelAll();
				this.#store.clear();
				this.#segmentHashes.clear();
				this.#offsetMaps.clear();
				this.#setStatus("disabled");
				this.onResultsChanged?.();
				return;
			}
			if (patch.enabled && !prevEnabled && doc$1) {
				this.#setStatus("idle");
				this.#scheduleFullCheck(doc$1);
				return;
			}
		}
		if (needsRecheck && this.isEnabled && doc$1) {
			this.#cancelAll();
			this.#documentEpoch++;
			this.#store.clear();
			this.#segmentHashes.clear();
			this.onResultsChanged?.();
			this.#scheduleFullCheck(doc$1);
		}
	}
	onDocumentChanged(doc$1, changedRanges, mapping) {
		if (!this.isEnabled) return;
		this.#documentEpoch++;
		this.#lastDoc = doc$1;
		const { segments, offsetMaps, segmentPositions } = extractSegmentsWithMaps(doc$1, this.#config.defaultLanguage, this.#pageResolver ?? void 0);
		this.#lastSegments = segments;
		this.#offsetMaps = offsetMaps;
		const dirtyIds = computeDirtySegmentIds(segments, segmentPositions, changedRanges);
		for (const id of dirtyIds) this.#segmentHashes.delete(id);
		if (dirtyIds.size > 0) {
			const recheckId = this.#nextRecheckId++;
			this.#store.remapIssues(dirtyIds, mapping, recheckId);
			this.#store.removeOrphanedSegments(new Set(segments.map((s) => s.id)));
		}
		this.#scheduleDebouncedCheck(segments);
	}
	runInitialCheck(doc$1) {
		if (!this.isEnabled) return;
		this.#scheduleFullCheck(doc$1);
	}
	ignoreWord(word$1) {
		const normalized = word$1.normalize("NFC").toLowerCase();
		if (!this.#config.ignoredWords.includes(normalized)) {
			this.#config.ignoredWords = [...this.#config.ignoredWords, normalized];
			this.onResultsChanged?.();
		}
	}
	removeIgnoredWord(word$1) {
		const normalized = word$1.normalize("NFC").toLowerCase();
		this.#config.ignoredWords = this.#config.ignoredWords.filter((w) => w !== normalized);
		this.onResultsChanged?.();
	}
	dispose() {
		this.#disposed = true;
		this.#cancelAll();
		this.#store.clear();
		this.#offsetMaps.clear();
		this.#segmentHashes.clear();
		this.#lastDoc = null;
		this.#lastSegments = [];
		this.#pendingSegments = [];
		this.#provider?.dispose?.();
		this.#provider = null;
		this.#setStatus("disabled");
	}
	#scheduleFullCheck(doc$1) {
		this.#lastDoc = doc$1;
		const { segments, offsetMaps } = extractSegmentsWithMaps(doc$1, this.#config.defaultLanguage, this.#pageResolver ?? void 0);
		this.#lastSegments = segments;
		this.#offsetMaps = offsetMaps;
		this.#segmentHashes.clear();
		this.#store.clear();
		this.#scheduleDebouncedCheck(segments);
	}
	#scheduleDebouncedCheck(segments) {
		if (this.#isComposing) return;
		if (this.#debounceTimer !== null) clearTimeout(this.#debounceTimer);
		const msSinceLastCheck = Date.now() - this.#lastCheckFiredAt;
		if (this.#lastCheckFiredAt > 0 && msSinceLastCheck >= DEFAULT_MAX_WAIT_MS) this.#fireCheck(segments);
		else this.#debounceTimer = setTimeout(() => {
			this.#debounceTimer = null;
			this.#fireCheck(segments);
		}, this.#config.debounceMs);
	}
	#fireCheck(segments) {
		this.#lastCheckFiredAt = Date.now();
		this.#runCheck(segments);
	}
	async #runCheck(segments) {
		if (this.#disposed || !this.#provider) return;
		if (!this.#capabilities && this.#provider.getCapabilities) try {
			this.#capabilities = await this.#provider.getCapabilities();
		} catch {}
		const unchecked = segments.filter((seg) => {
			const hash$3 = hashSegmentText(seg.text);
			return this.#segmentHashes.get(seg.id) !== hash$3;
		});
		if (unchecked.length === 0) {
			this.#setStatus("idle");
			return;
		}
		const activeRecheckIds = this.#store.getActiveRecheckIds();
		const ordered = this.#config.visibleFirst && this.#visibilitySource ? prioritizeByVisibility(unchecked, this.#visibilitySource) : unchecked;
		const batches = this.#batchSegments(ordered);
		const epoch = this.#documentEpoch;
		this.#pendingSegments = [];
		for (let i = 0; i < batches.length; i++) {
			if (this.#disposed || epoch !== this.#documentEpoch) return;
			if (this.#inFlightCount >= this.#config.maxConcurrentRequests) {
				for (let j = i; j < batches.length; j++) this.#pendingSegments.push(...batches[j]);
				break;
			}
			this.#sendBatch(batches[i], epoch, activeRecheckIds);
		}
	}
	async #sendBatch(segments, epoch, recheckIds) {
		if (!this.#provider || this.#disposed) return;
		const controller = new AbortController();
		this.#pendingAbortControllers.add(controller);
		this.#inFlightCount++;
		this.#setStatus("checking");
		const timeoutId = setTimeout(() => controller.abort(), this.#config.timeoutMs);
		const request = {
			documentId: this.#documentId,
			defaultLanguage: this.#config.defaultLanguage,
			maxSuggestions: this.#config.maxSuggestions,
			segments,
			signal: controller.signal
		};
		try {
			const result = await this.#provider.check(request);
			clearTimeout(timeoutId);
			if (!this.#pendingAbortControllers.delete(controller)) return;
			this.#inFlightCount--;
			if (epoch !== this.#documentEpoch || this.#disposed) {
				this.#drainPendingSegments();
				return;
			}
			const validSegmentIds = new Set(segments.map((s) => s.id));
			const segmentTextMap = new Map(segments.map((s) => [s.id, s]));
			const freshIssues = [];
			for (const issue of result.issues) {
				if (!this.#validateIssue(issue, validSegmentIds, segmentTextMap)) continue;
				const offsetMap = this.#offsetMaps.get(issue.segmentId);
				if (!offsetMap) continue;
				const resolved = resolveIssuePmRangeFromSlices(issue, offsetMap.slices);
				if (!resolved) continue;
				const segment = segmentTextMap.get(issue.segmentId);
				const storedIssue = {
					...resolved,
					state: "confirmed",
					recheckId: null
				};
				if (segment) storedIssue.word = segment.text.slice(issue.start, issue.end);
				freshIssues.push(storedIssue);
			}
			this.#store.replaceBatchResults(recheckIds, validSegmentIds, freshIssues);
			for (const seg of segments) this.#segmentHashes.set(seg.id, hashSegmentText(seg.text));
			this.#setStatus(this.#inFlightCount > 0 ? "checking" : "idle");
			this.onResultsChanged?.();
			this.#schedulePendingSegments(epoch, recheckIds);
		} catch (err) {
			clearTimeout(timeoutId);
			if (!this.#pendingAbortControllers.delete(controller)) return;
			this.#inFlightCount--;
			if (this.#disposed) return;
			if (epoch !== this.#documentEpoch) {
				this.#drainPendingSegments();
				return;
			}
			const isTimeout = controller.signal.aborted;
			const proofingError = {
				kind: isTimeout ? "timeout" : "provider-error",
				message: isTimeout ? "Provider request timed out" : String(err),
				segmentIds: segments.map((s) => s.id),
				cause: err
			};
			this.#config.onProofingError?.(proofingError);
			this.#setStatus(this.#inFlightCount > 0 ? "checking" : "degraded");
			this.#schedulePendingSegments(epoch, recheckIds);
		}
	}
	#schedulePendingSegments(epoch, recheckIds) {
		if (this.#disposed || epoch !== this.#documentEpoch) return;
		if (this.#pendingSegments.length === 0) return;
		if (this.#inFlightCount >= this.#config.maxConcurrentRequests) return;
		const nextBatch = this.#pendingSegments.splice(0, this.#config.maxSegmentsPerBatch);
		if (nextBatch.length > 0) this.#sendBatch(nextBatch, epoch, recheckIds);
	}
	#drainPendingSegments() {
		if (this.#disposed || this.#pendingSegments.length === 0) return;
		this.#schedulePendingSegments(this.#documentEpoch, this.#store.getActiveRecheckIds());
	}
	#validateIssue(issue, validSegmentIds, segmentTextMap) {
		if (!validSegmentIds.has(issue.segmentId)) {
			this.#reportValidationError(`Unknown segmentId: ${issue.segmentId}`, [issue.segmentId]);
			return false;
		}
		const segment = segmentTextMap.get(issue.segmentId);
		if (!segment) return false;
		if (issue.start < 0 || issue.end <= issue.start || issue.end > segment.text.length) {
			this.#reportValidationError(`Invalid offsets [${issue.start}, ${issue.end}) for segment "${issue.segmentId}" (length ${segment.text.length})`, [issue.segmentId]);
			return false;
		}
		return true;
	}
	#reportValidationError(message, segmentIds) {
		this.#config.onProofingError?.({
			kind: "validation-error",
			message,
			segmentIds
		});
	}
	#batchSegments(segments) {
		const batches = [];
		for (let i = 0; i < segments.length; i += this.#config.maxSegmentsPerBatch) batches.push(segments.slice(i, i + this.#config.maxSegmentsPerBatch));
		return batches;
	}
	#cancelAll() {
		if (this.#debounceTimer !== null) {
			clearTimeout(this.#debounceTimer);
			this.#debounceTimer = null;
		}
		for (const controller of this.#pendingAbortControllers) controller.abort();
		this.#pendingAbortControllers.clear();
		this.#inFlightCount = 0;
		this.#pendingSegments = [];
	}
	#setStatus(status) {
		if (this.#status !== status) {
			this.#status = status;
			this.#config.onStatusChange?.(status);
		}
	}
};
var MAX_RENDERED_SERIES = 20;
var MAX_POINTS_PER_SERIES = 500;
var SVG_ELEMENT_BUDGET = 5e3;
var SERIES_COLORS = [
	"#4472C4",
	"#ED7D31",
	"#A5A5A5",
	"#FFC000",
	"#5B9BD5",
	"#70AD47"
];
var AXIS_COLOR = "#595959";
var GRID_COLOR = "#E0E0E0";
var LABEL_COLOR = "#333";
var TICK_LABEL_COLOR = "#666";
var FONT_FAMILY = "Calibri, Arial, sans-serif";
var PLACEHOLDER_BG = "#f8f9fa";
var PLACEHOLDER_BORDER = "#dee2e6";
var PLACEHOLDER_TEXT_COLOR = "#6c757d";
var SVG_NS$1 = "http://www.w3.org/2000/svg";
var CHART_PADDING = {
	top: 30,
	right: 20,
	bottom: 50,
	left: 60
};
var VALUE_TICK_COUNT = 5;
function createChartElement(doc$1, chartData, geometry) {
	const container = doc$1.createElement("div");
	container.classList.add("superdoc-chart");
	container.style.width = "100%";
	container.style.height = "100%";
	container.style.position = "relative";
	if (!chartData || !chartData.series?.length) return createChartPlaceholder(doc$1, container, "No chart data");
	if (chartData.chartType === "barChart") return renderBarChart(doc$1, container, chartData, geometry);
	if (chartData.chartType === "lineChart") return renderLineChart(doc$1, container, chartData, geometry);
	if (chartData.chartType === "stockChart") return renderLineChart(doc$1, container, chartData, geometry);
	if (chartData.chartType === "areaChart") return renderAreaChart(doc$1, container, chartData, geometry);
	if (chartData.chartType === "scatterChart") return renderScatterChart(doc$1, container, chartData, geometry);
	if (chartData.chartType === "bubbleChart") return renderBubbleChart(doc$1, container, chartData, geometry);
	if (chartData.chartType === "radarChart") return renderRadarChart(doc$1, container, chartData, geometry);
	if (chartData.chartType === "pieChart") return renderPieChart(doc$1, container, chartData, geometry);
	if (chartData.chartType === "doughnutChart") return renderDoughnutChart(doc$1, container, chartData, geometry);
	if (chartData.chartType === "ofPieChart") return renderPieChart(doc$1, container, chartData, geometry);
	return createChartPlaceholder(doc$1, container, `Chart: ${chartData.chartType}`);
}
function createChartPlaceholder(doc$1, container, label) {
	container.style.display = "flex";
	container.style.alignItems = "center";
	container.style.justifyContent = "center";
	container.style.background = PLACEHOLDER_BG;
	container.style.border = `1px solid ${PLACEHOLDER_BORDER}`;
	container.style.borderRadius = "4px";
	container.style.color = PLACEHOLDER_TEXT_COLOR;
	container.style.fontSize = "13px";
	container.style.fontFamily = FONT_FAMILY;
	const icon = doc$1.createElement("span");
	icon.textContent = "📊 ";
	container.appendChild(icon);
	const text = doc$1.createElement("span");
	text.textContent = label;
	container.appendChild(text);
	return container;
}
function formatTickValue(value) {
	if (Math.abs(value) >= 1e6) return `${(value / 1e6).toFixed(1)}M`;
	if (Math.abs(value) >= 1e3) return `${(value / 1e3).toFixed(1)}K`;
	return Number.isInteger(value) ? String(value) : value.toFixed(1);
}
function applyGuardrails(chart) {
	let truncated = false;
	let series = chart.series;
	if (series.length > MAX_RENDERED_SERIES) {
		series = series.slice(0, MAX_RENDERED_SERIES);
		truncated = true;
	}
	series = series.map((s) => {
		if (s.values.length <= MAX_POINTS_PER_SERIES && s.categories.length <= MAX_POINTS_PER_SERIES) return s;
		truncated = true;
		return {
			name: s.name,
			categories: s.categories.slice(0, MAX_POINTS_PER_SERIES),
			values: s.values.slice(0, MAX_POINTS_PER_SERIES),
			...s.xValues && { xValues: s.xValues.slice(0, MAX_POINTS_PER_SERIES) },
			...s.bubbleSizes && { bubbleSizes: s.bubbleSizes.slice(0, MAX_POINTS_PER_SERIES) }
		};
	});
	return {
		series,
		truncated
	};
}
function computeBarLayout(width, height, series) {
	const plotWidth = Math.max(1, width - CHART_PADDING.left - CHART_PADDING.right);
	const plotHeight = Math.max(1, height - CHART_PADDING.top - CHART_PADDING.bottom);
	const allValues = series.flatMap((s) => s.values);
	const maxValue = Math.max(0, ...allValues);
	const minValue = Math.min(0, ...allValues);
	const valueRange = Math.max(1, maxValue - minValue);
	const categories = series[0]?.categories ?? [];
	const categoryCount = Math.max(1, categories.length);
	const seriesCount = series.length;
	const groupWidth = plotWidth / categoryCount;
	const barGap = Math.max(1, groupWidth * .1);
	const totalBarWidth = groupWidth - barGap * 2;
	return {
		plotWidth,
		plotHeight,
		groupWidth,
		barWidth: Math.max(1, totalBarWidth / seriesCount),
		barGap,
		baselineY: CHART_PADDING.top + plotHeight * (maxValue / valueRange),
		valueRange,
		minValue,
		maxValue
	};
}
function renderBars(doc$1, svg, series, layout) {
	const { groupWidth, barGap, barWidth, baselineY, valueRange, plotHeight } = layout;
	for (let si = 0; si < series.length; si++) {
		const s = series[si];
		const color = SERIES_COLORS[si % SERIES_COLORS.length];
		for (let ci = 0; ci < s.values.length; ci++) {
			const value = s.values[ci];
			const barHeight = Math.abs(value / valueRange) * plotHeight;
			const x = CHART_PADDING.left + ci * groupWidth + barGap + si * barWidth;
			const y$1 = value >= 0 ? baselineY - barHeight : baselineY;
			const rect = doc$1.createElementNS(SVG_NS$1, "rect");
			rect.setAttribute("x", String(x));
			rect.setAttribute("y", String(y$1));
			rect.setAttribute("width", String(barWidth));
			rect.setAttribute("height", String(Math.max(.5, barHeight)));
			rect.setAttribute("fill", color);
			svg.appendChild(rect);
		}
	}
}
function renderAxes(doc$1, svg, layout) {
	const { plotWidth, plotHeight, baselineY } = layout;
	const vAxis = doc$1.createElementNS(SVG_NS$1, "line");
	vAxis.setAttribute("x1", String(CHART_PADDING.left));
	vAxis.setAttribute("y1", String(CHART_PADDING.top));
	vAxis.setAttribute("x2", String(CHART_PADDING.left));
	vAxis.setAttribute("y2", String(CHART_PADDING.top + plotHeight));
	vAxis.setAttribute("stroke", AXIS_COLOR);
	vAxis.setAttribute("stroke-width", "1");
	svg.appendChild(vAxis);
	const hAxis = doc$1.createElementNS(SVG_NS$1, "line");
	hAxis.setAttribute("x1", String(CHART_PADDING.left));
	hAxis.setAttribute("y1", String(baselineY));
	hAxis.setAttribute("x2", String(CHART_PADDING.left + plotWidth));
	hAxis.setAttribute("y2", String(baselineY));
	hAxis.setAttribute("stroke", AXIS_COLOR);
	hAxis.setAttribute("stroke-width", "1");
	svg.appendChild(hAxis);
}
function renderCategoryLabels(doc$1, svg, categories, layout, width) {
	const { groupWidth, plotHeight } = layout;
	const categoryCount = Math.max(1, categories.length);
	const fontSize = Math.max(8, Math.min(12, width / categoryCount / 5));
	for (let ci = 0; ci < categories.length; ci++) {
		const labelX = CHART_PADDING.left + ci * groupWidth + groupWidth / 2;
		const label = doc$1.createElementNS(SVG_NS$1, "text");
		label.setAttribute("x", String(labelX));
		label.setAttribute("y", String(CHART_PADDING.top + plotHeight + 16));
		label.setAttribute("text-anchor", "middle");
		label.setAttribute("font-size", String(fontSize));
		label.setAttribute("fill", LABEL_COLOR);
		label.setAttribute("font-family", FONT_FAMILY);
		label.textContent = categories[ci] ?? "";
		svg.appendChild(label);
	}
}
function renderValueTicks(doc$1, svg, layout, height) {
	const { plotWidth, plotHeight, valueRange, minValue } = layout;
	const tickStep = valueRange / VALUE_TICK_COUNT;
	const fontSize = Math.max(8, Math.min(11, height / 30));
	for (let i = 0; i <= VALUE_TICK_COUNT; i++) {
		const tickValue = minValue + tickStep * i;
		const tickY = CHART_PADDING.top + plotHeight - plotHeight * (tickValue - minValue) / valueRange;
		const label = doc$1.createElementNS(SVG_NS$1, "text");
		label.setAttribute("x", String(CHART_PADDING.left - 6));
		label.setAttribute("y", String(tickY + 3));
		label.setAttribute("text-anchor", "end");
		label.setAttribute("font-size", String(fontSize));
		label.setAttribute("fill", TICK_LABEL_COLOR);
		label.setAttribute("font-family", FONT_FAMILY);
		label.textContent = formatTickValue(tickValue);
		svg.appendChild(label);
		if (i > 0 && i < VALUE_TICK_COUNT) {
			const gridLine = doc$1.createElementNS(SVG_NS$1, "line");
			gridLine.setAttribute("x1", String(CHART_PADDING.left));
			gridLine.setAttribute("y1", String(tickY));
			gridLine.setAttribute("x2", String(CHART_PADDING.left + plotWidth));
			gridLine.setAttribute("y2", String(tickY));
			gridLine.setAttribute("stroke", GRID_COLOR);
			gridLine.setAttribute("stroke-width", "0.5");
			svg.appendChild(gridLine);
		}
	}
}
function renderLegend(doc$1, svg, series, height) {
	const legendY = height - 12;
	let legendX = CHART_PADDING.left;
	for (let si = 0; si < series.length; si++) {
		const s = series[si];
		const color = SERIES_COLORS[si % SERIES_COLORS.length];
		const swatch = doc$1.createElementNS(SVG_NS$1, "rect");
		swatch.setAttribute("x", String(legendX));
		swatch.setAttribute("y", String(legendY - 8));
		swatch.setAttribute("width", "10");
		swatch.setAttribute("height", "10");
		swatch.setAttribute("fill", color);
		svg.appendChild(swatch);
		const label = doc$1.createElementNS(SVG_NS$1, "text");
		label.setAttribute("x", String(legendX + 14));
		label.setAttribute("y", String(legendY));
		label.setAttribute("font-size", "10");
		label.setAttribute("fill", LABEL_COLOR);
		label.setAttribute("font-family", FONT_FAMILY);
		label.textContent = s.name;
		svg.appendChild(label);
		legendX += 14 + s.name.length * 6 + 16;
	}
}
function renderTruncationIndicator(doc$1, svg, width) {
	const indicator = doc$1.createElementNS(SVG_NS$1, "text");
	indicator.setAttribute("x", String(width - 8));
	indicator.setAttribute("y", "14");
	indicator.setAttribute("text-anchor", "end");
	indicator.setAttribute("font-size", "10");
	indicator.setAttribute("fill", PLACEHOLDER_TEXT_COLOR);
	indicator.setAttribute("font-family", FONT_FAMILY);
	indicator.textContent = "Data truncated for display";
	svg.appendChild(indicator);
}
function toCartesianLayout(width, height, series, forceZeroMin = false) {
	const plotWidth = Math.max(1, width - CHART_PADDING.left - CHART_PADDING.right);
	const plotHeight = Math.max(1, height - CHART_PADDING.top - CHART_PADDING.bottom);
	const values = series.flatMap((s) => s.values).filter((v) => Number.isFinite(v));
	let minValue = values.length ? Math.min(...values) : 0;
	let maxValue = values.length ? Math.max(...values) : 1;
	if (forceZeroMin) {
		minValue = Math.min(0, minValue);
		maxValue = Math.max(0, maxValue);
	}
	if (maxValue === minValue) {
		minValue -= 1;
		maxValue += 1;
	}
	const valueRange = Math.max(1, maxValue - minValue);
	const zeroRatio = (0 - minValue) / valueRange;
	const baselineRatio = Math.max(0, Math.min(1, zeroRatio));
	const baselineY = CHART_PADDING.top + plotHeight - plotHeight * baselineRatio;
	const categoryCount = Math.max(1, series[0]?.categories?.length ?? series[0]?.values?.length ?? 1);
	return {
		plotWidth,
		plotHeight,
		minValue,
		maxValue,
		valueRange,
		baselineY,
		categoryCount
	};
}
function pointX(layout, index) {
	if (layout.categoryCount <= 1) return CHART_PADDING.left + layout.plotWidth / 2;
	return CHART_PADDING.left + layout.plotWidth * index / (layout.categoryCount - 1);
}
function pointY(layout, value) {
	return CHART_PADDING.top + layout.plotHeight - (value - layout.minValue) / layout.valueRange * layout.plotHeight;
}
function renderCartesianAxes(doc$1, svg, layout) {
	const vAxis = doc$1.createElementNS(SVG_NS$1, "line");
	vAxis.setAttribute("x1", String(CHART_PADDING.left));
	vAxis.setAttribute("y1", String(CHART_PADDING.top));
	vAxis.setAttribute("x2", String(CHART_PADDING.left));
	vAxis.setAttribute("y2", String(CHART_PADDING.top + layout.plotHeight));
	vAxis.setAttribute("stroke", AXIS_COLOR);
	vAxis.setAttribute("stroke-width", "1");
	svg.appendChild(vAxis);
	const hAxis = doc$1.createElementNS(SVG_NS$1, "line");
	hAxis.setAttribute("x1", String(CHART_PADDING.left));
	hAxis.setAttribute("y1", String(layout.baselineY));
	hAxis.setAttribute("x2", String(CHART_PADDING.left + layout.plotWidth));
	hAxis.setAttribute("y2", String(layout.baselineY));
	hAxis.setAttribute("stroke", AXIS_COLOR);
	hAxis.setAttribute("stroke-width", "1");
	svg.appendChild(hAxis);
}
function renderPointCategoryLabels(doc$1, svg, categories, layout, width) {
	const labels = categories.length ? categories : Array.from({ length: layout.categoryCount }, (_$1, i) => String(i + 1));
	const categoryCount = Math.max(1, labels.length);
	const fontSize = Math.max(8, Math.min(12, width / categoryCount / 4));
	for (let i = 0; i < labels.length; i++) {
		const label = doc$1.createElementNS(SVG_NS$1, "text");
		label.setAttribute("x", String(pointX(layout, i)));
		label.setAttribute("y", String(CHART_PADDING.top + layout.plotHeight + 16));
		label.setAttribute("text-anchor", "middle");
		label.setAttribute("font-size", String(fontSize));
		label.setAttribute("fill", LABEL_COLOR);
		label.setAttribute("font-family", FONT_FAMILY);
		label.textContent = labels[i] ?? "";
		svg.appendChild(label);
	}
}
function renderCartesianValueTicks(doc$1, svg, layout, height) {
	const tickStep = layout.valueRange / VALUE_TICK_COUNT;
	const fontSize = Math.max(8, Math.min(11, height / 30));
	for (let i = 0; i <= VALUE_TICK_COUNT; i++) {
		const tickValue = layout.minValue + tickStep * i;
		const tickY = CHART_PADDING.top + layout.plotHeight - layout.plotHeight * (tickValue - layout.minValue) / layout.valueRange;
		const label = doc$1.createElementNS(SVG_NS$1, "text");
		label.setAttribute("x", String(CHART_PADDING.left - 6));
		label.setAttribute("y", String(tickY + 3));
		label.setAttribute("text-anchor", "end");
		label.setAttribute("font-size", String(fontSize));
		label.setAttribute("fill", TICK_LABEL_COLOR);
		label.setAttribute("font-family", FONT_FAMILY);
		label.textContent = formatTickValue(tickValue);
		svg.appendChild(label);
		if (i > 0 && i < VALUE_TICK_COUNT) {
			const grid = doc$1.createElementNS(SVG_NS$1, "line");
			grid.setAttribute("x1", String(CHART_PADDING.left));
			grid.setAttribute("y1", String(tickY));
			grid.setAttribute("x2", String(CHART_PADDING.left + layout.plotWidth));
			grid.setAttribute("y2", String(tickY));
			grid.setAttribute("stroke", GRID_COLOR);
			grid.setAttribute("stroke-width", "0.5");
			svg.appendChild(grid);
		}
	}
}
function toXYPoints(series) {
	const yValues = series.values;
	const xValues = series.xValues?.length ? series.xValues : yValues.map((_$1, index) => index + 1);
	const sizes = series.bubbleSizes ?? [];
	const count = Math.min(xValues.length, yValues.length);
	const points = [];
	for (let i = 0; i < count; i++) {
		const x = xValues[i];
		const y$1 = yValues[i];
		if (!Number.isFinite(x) || !Number.isFinite(y$1)) continue;
		const size$1 = sizes[i];
		points.push({
			x,
			y: y$1,
			...Number.isFinite(size$1) ? { size: size$1 } : {}
		});
	}
	return points;
}
function toXYLayout(width, height, points, forceZeroMin = false) {
	const plotWidth = Math.max(1, width - CHART_PADDING.left - CHART_PADDING.right);
	const plotHeight = Math.max(1, height - CHART_PADDING.top - CHART_PADDING.bottom);
	let minX = points.length ? Math.min(...points.map((point) => point.x)) : 0;
	let maxX = points.length ? Math.max(...points.map((point) => point.x)) : 1;
	let minY = points.length ? Math.min(...points.map((point) => point.y)) : 0;
	let maxY = points.length ? Math.max(...points.map((point) => point.y)) : 1;
	if (forceZeroMin) {
		minX = Math.min(0, minX);
		maxX = Math.max(0, maxX);
		minY = Math.min(0, minY);
		maxY = Math.max(0, maxY);
	}
	if (maxX === minX) {
		minX -= 1;
		maxX += 1;
	}
	if (maxY === minY) {
		minY -= 1;
		maxY += 1;
	}
	const xRange = Math.max(1, maxX - minX);
	const yRange = Math.max(1, maxY - minY);
	const axisXRatio = Math.max(0, Math.min(1, (0 - minX) / xRange));
	const axisYRatio = Math.max(0, Math.min(1, (0 - minY) / yRange));
	const axisX = CHART_PADDING.left + plotWidth * axisXRatio;
	const axisY = CHART_PADDING.top + plotHeight - plotHeight * axisYRatio;
	return {
		plotWidth,
		plotHeight,
		minX,
		maxX,
		xRange,
		minY,
		maxY,
		yRange,
		axisX,
		axisY
	};
}
function xyToSvgX(layout, xValue) {
	return CHART_PADDING.left + (xValue - layout.minX) / layout.xRange * layout.plotWidth;
}
function xyToSvgY(layout, yValue) {
	return CHART_PADDING.top + layout.plotHeight - (yValue - layout.minY) / layout.yRange * layout.plotHeight;
}
function renderXYAxes(doc$1, svg, layout) {
	const yAxis = doc$1.createElementNS(SVG_NS$1, "line");
	yAxis.setAttribute("x1", String(layout.axisX));
	yAxis.setAttribute("y1", String(CHART_PADDING.top));
	yAxis.setAttribute("x2", String(layout.axisX));
	yAxis.setAttribute("y2", String(CHART_PADDING.top + layout.plotHeight));
	yAxis.setAttribute("stroke", AXIS_COLOR);
	yAxis.setAttribute("stroke-width", "1");
	svg.appendChild(yAxis);
	const xAxis = doc$1.createElementNS(SVG_NS$1, "line");
	xAxis.setAttribute("x1", String(CHART_PADDING.left));
	xAxis.setAttribute("y1", String(layout.axisY));
	xAxis.setAttribute("x2", String(CHART_PADDING.left + layout.plotWidth));
	xAxis.setAttribute("y2", String(layout.axisY));
	xAxis.setAttribute("stroke", AXIS_COLOR);
	xAxis.setAttribute("stroke-width", "1");
	svg.appendChild(xAxis);
}
function renderXYTicks(doc$1, svg, layout, height) {
	const fontSize = Math.max(8, Math.min(11, height / 30));
	for (let i = 0; i <= VALUE_TICK_COUNT; i++) {
		const tickRatio = i / VALUE_TICK_COUNT;
		const yValue = layout.minY + layout.yRange * tickRatio;
		const y$1 = CHART_PADDING.top + layout.plotHeight - layout.plotHeight * tickRatio;
		const yLabel = doc$1.createElementNS(SVG_NS$1, "text");
		yLabel.setAttribute("x", String(CHART_PADDING.left - 6));
		yLabel.setAttribute("y", String(y$1 + 3));
		yLabel.setAttribute("text-anchor", "end");
		yLabel.setAttribute("font-size", String(fontSize));
		yLabel.setAttribute("fill", TICK_LABEL_COLOR);
		yLabel.setAttribute("font-family", FONT_FAMILY);
		yLabel.textContent = formatTickValue(yValue);
		svg.appendChild(yLabel);
		if (i > 0 && i < VALUE_TICK_COUNT) {
			const grid = doc$1.createElementNS(SVG_NS$1, "line");
			grid.setAttribute("x1", String(CHART_PADDING.left));
			grid.setAttribute("y1", String(y$1));
			grid.setAttribute("x2", String(CHART_PADDING.left + layout.plotWidth));
			grid.setAttribute("y2", String(y$1));
			grid.setAttribute("stroke", GRID_COLOR);
			grid.setAttribute("stroke-width", "0.5");
			svg.appendChild(grid);
		}
		const xValue = layout.minX + layout.xRange * tickRatio;
		const x = CHART_PADDING.left + layout.plotWidth * tickRatio;
		const xLabel = doc$1.createElementNS(SVG_NS$1, "text");
		xLabel.setAttribute("x", String(x));
		xLabel.setAttribute("y", String(CHART_PADDING.top + layout.plotHeight + 16));
		xLabel.setAttribute("text-anchor", "middle");
		xLabel.setAttribute("font-size", String(fontSize));
		xLabel.setAttribute("fill", TICK_LABEL_COLOR);
		xLabel.setAttribute("font-family", FONT_FAMILY);
		xLabel.textContent = formatTickValue(xValue);
		svg.appendChild(xLabel);
	}
}
function estimateScatterBubbleElements(pointsBySeries, hasLegend) {
	const points = pointsBySeries.reduce((sum, seriesPoints) => sum + seriesPoints.length, 0);
	const axes = 2;
	const ticks = (VALUE_TICK_COUNT + 1) * 2;
	const gridLines = Math.max(0, VALUE_TICK_COUNT - 1);
	const legend = hasLegend ? pointsBySeries.length * 2 : 0;
	return points + axes + ticks + gridLines + legend;
}
function renderScatterChart(doc$1, container, chart, geometry) {
	const { width, height } = geometry;
	const { series, truncated } = applyGuardrails(chart);
	const pointsBySeries = series.map(toXYPoints);
	const allPoints = pointsBySeries.flat();
	if (allPoints.length === 0) return createChartPlaceholder(doc$1, container, "No chart data");
	const hasLegend = chart.legendPosition !== void 0;
	const estimated = estimateScatterBubbleElements(pointsBySeries, hasLegend);
	if (estimated > SVG_ELEMENT_BUDGET) return createChartPlaceholder(doc$1, container, `Chart too complex for inline rendering (${estimated} elements)`);
	const layout = toXYLayout(width, height, allPoints, false);
	const svg = doc$1.createElementNS(SVG_NS$1, "svg");
	svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
	svg.setAttribute("width", "100%");
	svg.setAttribute("height", "100%");
	svg.style.display = "block";
	renderXYAxes(doc$1, svg, layout);
	renderXYTicks(doc$1, svg, layout, height);
	for (let si = 0; si < pointsBySeries.length; si++) {
		const points = pointsBySeries[si];
		const color = SERIES_COLORS[si % SERIES_COLORS.length];
		for (const point of points) {
			const marker = doc$1.createElementNS(SVG_NS$1, "circle");
			marker.setAttribute("cx", String(xyToSvgX(layout, point.x)));
			marker.setAttribute("cy", String(xyToSvgY(layout, point.y)));
			marker.setAttribute("r", "3");
			marker.setAttribute("fill", color);
			marker.setAttribute("fill-opacity", "0.85");
			svg.appendChild(marker);
		}
	}
	if (hasLegend) renderLegend(doc$1, svg, series, height);
	if (truncated) renderTruncationIndicator(doc$1, svg, width);
	container.appendChild(svg);
	return container;
}
function renderBubbleChart(doc$1, container, chart, geometry) {
	const { width, height } = geometry;
	const { series, truncated } = applyGuardrails(chart);
	const pointsBySeries = series.map(toXYPoints);
	const allPoints = pointsBySeries.flat();
	if (allPoints.length === 0) return createChartPlaceholder(doc$1, container, "No chart data");
	const hasLegend = chart.legendPosition !== void 0;
	const estimated = estimateScatterBubbleElements(pointsBySeries, hasLegend);
	if (estimated > SVG_ELEMENT_BUDGET) return createChartPlaceholder(doc$1, container, `Chart too complex for inline rendering (${estimated} elements)`);
	const layout = toXYLayout(width, height, allPoints, false);
	const allSizes = allPoints.map((point) => point.size).filter((size$1) => size$1 != null && size$1 > 0);
	const maxBubbleSize = allSizes.length ? Math.max(...allSizes) : 1;
	const svg = doc$1.createElementNS(SVG_NS$1, "svg");
	svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
	svg.setAttribute("width", "100%");
	svg.setAttribute("height", "100%");
	svg.style.display = "block";
	renderXYAxes(doc$1, svg, layout);
	renderXYTicks(doc$1, svg, layout, height);
	for (let si = 0; si < pointsBySeries.length; si++) {
		const points = pointsBySeries[si];
		const color = SERIES_COLORS[si % SERIES_COLORS.length];
		for (const point of points) {
			const size$1 = point.size && point.size > 0 ? point.size : maxBubbleSize * .5;
			const radius = maxBubbleSize > 0 ? 4 + size$1 / maxBubbleSize * 10 : 6;
			const bubble = doc$1.createElementNS(SVG_NS$1, "circle");
			bubble.setAttribute("cx", String(xyToSvgX(layout, point.x)));
			bubble.setAttribute("cy", String(xyToSvgY(layout, point.y)));
			bubble.setAttribute("r", String(Math.max(2, radius)));
			bubble.setAttribute("fill", color);
			bubble.setAttribute("fill-opacity", "0.45");
			bubble.setAttribute("stroke", color);
			bubble.setAttribute("stroke-width", "1");
			svg.appendChild(bubble);
		}
	}
	if (hasLegend) renderLegend(doc$1, svg, series, height);
	if (truncated) renderTruncationIndicator(doc$1, svg, width);
	container.appendChild(svg);
	return container;
}
function estimateRadarElements(series, categoryCount, hasLegend) {
	const grid = 4 + categoryCount;
	const labels = categoryCount;
	const seriesElements = series.reduce((sum, s) => sum + 1 + Math.min(categoryCount, s.values.length), 0);
	const legend = hasLegend ? series.length * 2 : 0;
	return grid + labels + seriesElements + legend;
}
function renderRadarChart(doc$1, container, chart, geometry) {
	const { width, height } = geometry;
	const { series, truncated } = applyGuardrails(chart);
	const categories = series[0]?.categories ?? [];
	const categoryCount = Math.max(3, categories.length, ...series.map((oneSeries) => oneSeries.values.length));
	const hasLegend = chart.legendPosition !== void 0;
	const estimated = estimateRadarElements(series, categoryCount, hasLegend);
	if (estimated > SVG_ELEMENT_BUDGET) return createChartPlaceholder(doc$1, container, `Chart too complex for inline rendering (${estimated} elements)`);
	const allValues = series.flatMap((oneSeries) => oneSeries.values).filter((value) => Number.isFinite(value));
	const maxValue = allValues.length ? Math.max(...allValues) : 1;
	const minValue = allValues.length ? Math.min(...allValues) : 0;
	const valueRange = Math.max(1, maxValue - Math.min(0, minValue));
	const svg = doc$1.createElementNS(SVG_NS$1, "svg");
	svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
	svg.setAttribute("width", "100%");
	svg.setAttribute("height", "100%");
	svg.style.display = "block";
	const legendSpace = hasLegend ? 34 : 10;
	const radius = Math.max(10, Math.min(width - 60, height - legendSpace - 60) / 2);
	const centerX = width / 2;
	const centerY = CHART_PADDING.top + (height - CHART_PADDING.top - legendSpace) / 2;
	const ringCount = 4;
	for (let ring = 1; ring <= ringCount; ring++) {
		const ringRadius = radius * ring / ringCount;
		const ringPoints = [];
		for (let i = 0; i < categoryCount; i++) {
			const angle = -Math.PI / 2 + i * Math.PI * 2 / categoryCount;
			ringPoints.push(`${centerX + ringRadius * Math.cos(angle)},${centerY + ringRadius * Math.sin(angle)}`);
		}
		const polygon = doc$1.createElementNS(SVG_NS$1, "polygon");
		polygon.setAttribute("points", ringPoints.join(" "));
		polygon.setAttribute("fill", "none");
		polygon.setAttribute("stroke", GRID_COLOR);
		polygon.setAttribute("stroke-width", "0.8");
		svg.appendChild(polygon);
	}
	for (let i = 0; i < categoryCount; i++) {
		const angle = -Math.PI / 2 + i * Math.PI * 2 / categoryCount;
		const x = centerX + radius * Math.cos(angle);
		const y$1 = centerY + radius * Math.sin(angle);
		const spoke = doc$1.createElementNS(SVG_NS$1, "line");
		spoke.setAttribute("x1", String(centerX));
		spoke.setAttribute("y1", String(centerY));
		spoke.setAttribute("x2", String(x));
		spoke.setAttribute("y2", String(y$1));
		spoke.setAttribute("stroke", GRID_COLOR);
		spoke.setAttribute("stroke-width", "0.8");
		svg.appendChild(spoke);
		const labelRadius = radius + 14;
		const labelX = centerX + labelRadius * Math.cos(angle);
		const labelY = centerY + labelRadius * Math.sin(angle);
		const label = doc$1.createElementNS(SVG_NS$1, "text");
		label.setAttribute("x", String(labelX));
		label.setAttribute("y", String(labelY));
		label.setAttribute("font-size", "10");
		label.setAttribute("fill", LABEL_COLOR);
		label.setAttribute("font-family", FONT_FAMILY);
		label.setAttribute("text-anchor", Math.abs(Math.cos(angle)) < .2 ? "middle" : Math.cos(angle) > 0 ? "start" : "end");
		label.textContent = categories[i] ?? `Category ${i + 1}`;
		svg.appendChild(label);
	}
	for (let si = 0; si < series.length; si++) {
		const oneSeries = series[si];
		const color = SERIES_COLORS[si % SERIES_COLORS.length];
		const points = [];
		const pointPositions = [];
		const pointCount = Math.min(categoryCount, oneSeries.values.length);
		for (let i = 0; i < pointCount; i++) {
			const value = oneSeries.values[i] ?? 0;
			const pointRadius = Math.max(0, (value - Math.min(0, minValue)) / valueRange) * radius;
			const angle = -Math.PI / 2 + i * Math.PI * 2 / categoryCount;
			const x = centerX + pointRadius * Math.cos(angle);
			const y$1 = centerY + pointRadius * Math.sin(angle);
			points.push(`${x},${y$1}`);
			pointPositions.push({
				x,
				y: y$1
			});
		}
		if (points.length > 0) {
			const polygon = doc$1.createElementNS(SVG_NS$1, "polygon");
			polygon.setAttribute("points", points.join(" "));
			polygon.setAttribute("fill", color);
			polygon.setAttribute("fill-opacity", "0.18");
			polygon.setAttribute("stroke", color);
			polygon.setAttribute("stroke-width", "1.8");
			svg.appendChild(polygon);
		}
		for (const point of pointPositions) {
			const marker = doc$1.createElementNS(SVG_NS$1, "circle");
			marker.setAttribute("cx", String(point.x));
			marker.setAttribute("cy", String(point.y));
			marker.setAttribute("r", "2.5");
			marker.setAttribute("fill", color);
			svg.appendChild(marker);
		}
	}
	if (hasLegend) renderLegend(doc$1, svg, series, height);
	if (truncated) renderTruncationIndicator(doc$1, svg, width);
	container.appendChild(svg);
	return container;
}
function estimateLineAreaElements(series, categories, hasLegend, withMarkers) {
	const points = series.reduce((sum, s) => sum + s.values.length, 0);
	const pathPerSeries = series.length;
	const markerCount = withMarkers ? points : 0;
	const axes = 2;
	const valueTicks = (VALUE_TICK_COUNT + 1) * 2;
	const categoryLabels = categories.length;
	const legend = hasLegend ? series.length * 2 : 0;
	return pathPerSeries + markerCount + axes + valueTicks + categoryLabels + legend;
}
function normalizePieSlices(series) {
	let truncated = false;
	const maxCount = Math.min(series.values.length, MAX_POINTS_PER_SERIES);
	if (series.values.length > maxCount) truncated = true;
	const slices = [];
	for (let i = 0; i < maxCount; i++) {
		const raw = Number(series.values[i]);
		const value = Number.isFinite(raw) && raw > 0 ? raw : 0;
		slices.push({
			label: series.categories[i] ?? `Category ${i + 1}`,
			value,
			color: SERIES_COLORS[i % SERIES_COLORS.length]
		});
	}
	return {
		slices,
		truncated
	};
}
function renderPieSlices(doc$1, svg, slices, centerX, centerY, radius) {
	const total = slices.reduce((sum, slice) => sum + slice.value, 0);
	if (total <= 0) return;
	let start$1 = -Math.PI / 2;
	for (const slice of slices) {
		if (slice.value <= 0) continue;
		const sweep = slice.value / total * Math.PI * 2;
		if (sweep >= Math.PI * 2 - 1e-4) {
			const full = doc$1.createElementNS(SVG_NS$1, "circle");
			full.setAttribute("cx", String(centerX));
			full.setAttribute("cy", String(centerY));
			full.setAttribute("r", String(radius));
			full.setAttribute("fill", slice.color);
			full.setAttribute("stroke", "#fff");
			full.setAttribute("stroke-width", String(Math.max(1, radius * .01)));
			svg.appendChild(full);
			break;
		}
		const end$1 = start$1 + sweep;
		const x1 = centerX + radius * Math.cos(start$1);
		const y1 = centerY + radius * Math.sin(start$1);
		const x2 = centerX + radius * Math.cos(end$1);
		const y2 = centerY + radius * Math.sin(end$1);
		const largeArc = sweep > Math.PI ? 1 : 0;
		const path = doc$1.createElementNS(SVG_NS$1, "path");
		path.setAttribute("d", `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} Z`);
		path.setAttribute("fill", slice.color);
		path.setAttribute("stroke", "#fff");
		path.setAttribute("stroke-width", String(Math.max(1, radius * .01)));
		svg.appendChild(path);
		start$1 = end$1;
	}
}
function renderPieLegend(doc$1, svg, slices, width, height) {
	const totalWidth = slices.reduce((acc, slice) => acc + 14 + slice.label.length * 6 + 16, 0);
	let legendX = Math.max(10, (width - totalWidth) / 2);
	const legendY = height - 14;
	for (const slice of slices) {
		const swatch = doc$1.createElementNS(SVG_NS$1, "rect");
		swatch.setAttribute("x", String(legendX));
		swatch.setAttribute("y", String(legendY - 8));
		swatch.setAttribute("width", "10");
		swatch.setAttribute("height", "10");
		swatch.setAttribute("fill", slice.color);
		svg.appendChild(swatch);
		const label = doc$1.createElementNS(SVG_NS$1, "text");
		label.setAttribute("x", String(legendX + 14));
		label.setAttribute("y", String(legendY));
		label.setAttribute("font-size", "10");
		label.setAttribute("fill", LABEL_COLOR);
		label.setAttribute("font-family", FONT_FAMILY);
		label.textContent = slice.label;
		svg.appendChild(label);
		legendX += 14 + slice.label.length * 6 + 16;
	}
}
function renderPieChart(doc$1, container, chart, geometry) {
	const series = chart.series[0];
	if (!series) return createChartPlaceholder(doc$1, container, "No chart data");
	const { slices, truncated } = normalizePieSlices(series);
	if (slices.reduce((sum, slice) => sum + slice.value, 0) <= 0) return createChartPlaceholder(doc$1, container, "No chart data");
	if (slices.length * 3 > SVG_ELEMENT_BUDGET) return createChartPlaceholder(doc$1, container, "Chart too large");
	const { width, height } = geometry;
	const hasLegend = chart.legendPosition !== void 0;
	const title = series.name?.trim() || "";
	const hasTitle = title.length > 0;
	const titleSpace = hasTitle ? 34 : 10;
	const legendSpace = hasLegend ? 40 : 10;
	const plotWidth = Math.max(1, width - 20);
	const plotHeight = Math.max(1, height - titleSpace - legendSpace);
	const centerX = width / 2;
	const centerY = titleSpace + plotHeight / 2;
	const radius = Math.max(8, Math.min(plotWidth, plotHeight) * .45);
	const svg = doc$1.createElementNS(SVG_NS$1, "svg");
	svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
	svg.setAttribute("width", "100%");
	svg.setAttribute("height", "100%");
	svg.style.display = "block";
	if (hasTitle) {
		const titleEl = doc$1.createElementNS(SVG_NS$1, "text");
		titleEl.setAttribute("x", String(centerX));
		titleEl.setAttribute("y", "24");
		titleEl.setAttribute("text-anchor", "middle");
		titleEl.setAttribute("font-size", String(Math.max(12, Math.min(22, width / 18))));
		titleEl.setAttribute("fill", AXIS_COLOR);
		titleEl.setAttribute("font-family", FONT_FAMILY);
		titleEl.textContent = title;
		svg.appendChild(titleEl);
	}
	renderPieSlices(doc$1, svg, slices, centerX, centerY, radius);
	if (hasLegend) renderPieLegend(doc$1, svg, slices, width, height);
	if (truncated) renderTruncationIndicator(doc$1, svg, width);
	container.appendChild(svg);
	return container;
}
function renderLineChart(doc$1, container, chart, geometry) {
	const { width, height } = geometry;
	const { series, truncated } = applyGuardrails(chart);
	const categories = series[0]?.categories ?? [];
	const hasLegend = chart.legendPosition !== void 0;
	const estimated = estimateLineAreaElements(series, categories, hasLegend, true);
	if (estimated > SVG_ELEMENT_BUDGET) return createChartPlaceholder(doc$1, container, `Chart too complex for inline rendering (${estimated} elements)`);
	const layout = toCartesianLayout(width, height, series, false);
	const svg = doc$1.createElementNS(SVG_NS$1, "svg");
	svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
	svg.setAttribute("width", "100%");
	svg.setAttribute("height", "100%");
	svg.style.display = "block";
	renderCartesianAxes(doc$1, svg, layout);
	renderCartesianValueTicks(doc$1, svg, layout, height);
	renderPointCategoryLabels(doc$1, svg, categories, layout, width);
	for (let si = 0; si < series.length; si++) {
		const s = series[si];
		const color = SERIES_COLORS[si % SERIES_COLORS.length];
		const points = [];
		for (let i = 0; i < s.values.length; i++) {
			const x = pointX(layout, i);
			const y$1 = pointY(layout, s.values[i] ?? 0);
			points.push(`${x},${y$1}`);
		}
		if (points.length === 0) continue;
		const line = doc$1.createElementNS(SVG_NS$1, "polyline");
		line.setAttribute("points", points.join(" "));
		line.setAttribute("fill", "none");
		line.setAttribute("stroke", color);
		line.setAttribute("stroke-width", "2");
		svg.appendChild(line);
		for (let i = 0; i < s.values.length; i++) {
			const marker = doc$1.createElementNS(SVG_NS$1, "circle");
			marker.setAttribute("cx", String(pointX(layout, i)));
			marker.setAttribute("cy", String(pointY(layout, s.values[i] ?? 0)));
			marker.setAttribute("r", "2.5");
			marker.setAttribute("fill", color);
			svg.appendChild(marker);
		}
	}
	if (hasLegend) renderLegend(doc$1, svg, series, height);
	if (truncated) renderTruncationIndicator(doc$1, svg, width);
	container.appendChild(svg);
	return container;
}
function renderAreaChart(doc$1, container, chart, geometry) {
	const { width, height } = geometry;
	const { series, truncated } = applyGuardrails(chart);
	const categories = series[0]?.categories ?? [];
	const hasLegend = chart.legendPosition !== void 0;
	const estimated = estimateLineAreaElements(series, categories, hasLegend, false) + series.length;
	if (estimated > SVG_ELEMENT_BUDGET) return createChartPlaceholder(doc$1, container, `Chart too complex for inline rendering (${estimated} elements)`);
	const layout = toCartesianLayout(width, height, series, true);
	const svg = doc$1.createElementNS(SVG_NS$1, "svg");
	svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
	svg.setAttribute("width", "100%");
	svg.setAttribute("height", "100%");
	svg.style.display = "block";
	renderCartesianAxes(doc$1, svg, layout);
	renderCartesianValueTicks(doc$1, svg, layout, height);
	renderPointCategoryLabels(doc$1, svg, categories, layout, width);
	for (let si = 0; si < series.length; si++) {
		const s = series[si];
		if (s.values.length === 0) continue;
		const color = SERIES_COLORS[si % SERIES_COLORS.length];
		const pathParts = [`M ${pointX(layout, 0)} ${layout.baselineY}`];
		for (let i = 0; i < s.values.length; i++) pathParts.push(`L ${pointX(layout, i)} ${pointY(layout, s.values[i] ?? 0)}`);
		const lastX = pointX(layout, Math.max(0, s.values.length - 1));
		pathParts.push(`L ${lastX} ${layout.baselineY} Z`);
		const area = doc$1.createElementNS(SVG_NS$1, "path");
		area.setAttribute("d", pathParts.join(" "));
		area.setAttribute("fill", color);
		area.setAttribute("fill-opacity", "0.35");
		area.setAttribute("stroke", color);
		area.setAttribute("stroke-width", "1.5");
		svg.appendChild(area);
	}
	if (hasLegend) renderLegend(doc$1, svg, series, height);
	if (truncated) renderTruncationIndicator(doc$1, svg, width);
	container.appendChild(svg);
	return container;
}
function renderDoughnutSlices(doc$1, svg, slices, centerX, centerY, outerRadius, innerRadius) {
	const total = slices.reduce((sum, slice) => sum + slice.value, 0);
	if (total <= 0) return;
	let start$1 = -Math.PI / 2;
	for (const slice of slices) {
		if (slice.value <= 0) continue;
		const sweep = slice.value / total * Math.PI * 2;
		if (sweep >= Math.PI * 2 - 1e-4) {
			const ring = doc$1.createElementNS(SVG_NS$1, "circle");
			ring.setAttribute("cx", String(centerX));
			ring.setAttribute("cy", String(centerY));
			ring.setAttribute("r", String((outerRadius + innerRadius) / 2));
			ring.setAttribute("fill", "none");
			ring.setAttribute("stroke", slice.color);
			ring.setAttribute("stroke-width", String(Math.max(1, outerRadius - innerRadius)));
			svg.appendChild(ring);
			break;
		}
		const end$1 = start$1 + sweep;
		const x1 = centerX + outerRadius * Math.cos(start$1);
		const y1 = centerY + outerRadius * Math.sin(start$1);
		const x2 = centerX + outerRadius * Math.cos(end$1);
		const y2 = centerY + outerRadius * Math.sin(end$1);
		const ix1 = centerX + innerRadius * Math.cos(start$1);
		const iy1 = centerY + innerRadius * Math.sin(start$1);
		const ix2 = centerX + innerRadius * Math.cos(end$1);
		const iy2 = centerY + innerRadius * Math.sin(end$1);
		const largeArc = sweep > Math.PI ? 1 : 0;
		const path = doc$1.createElementNS(SVG_NS$1, "path");
		path.setAttribute("d", `M ${x1} ${y1} A ${outerRadius} ${outerRadius} 0 ${largeArc} 1 ${x2} ${y2} L ${ix2} ${iy2} A ${innerRadius} ${innerRadius} 0 ${largeArc} 0 ${ix1} ${iy1} Z`);
		path.setAttribute("fill", slice.color);
		path.setAttribute("stroke", "#fff");
		path.setAttribute("stroke-width", "1");
		svg.appendChild(path);
		start$1 = end$1;
	}
}
function renderDoughnutChart(doc$1, container, chart, geometry) {
	const series = chart.series[0];
	if (!series) return createChartPlaceholder(doc$1, container, "No chart data");
	const { slices, truncated } = normalizePieSlices(series);
	if (slices.reduce((sum, slice) => sum + slice.value, 0) <= 0) return createChartPlaceholder(doc$1, container, "No chart data");
	if (slices.length * 3 > SVG_ELEMENT_BUDGET) return createChartPlaceholder(doc$1, container, "Chart too large");
	const { width, height } = geometry;
	const hasLegend = chart.legendPosition !== void 0;
	const title = series.name?.trim() || "";
	const hasTitle = title.length > 0;
	const titleSpace = hasTitle ? 34 : 10;
	const legendSpace = hasLegend ? 40 : 10;
	const plotWidth = Math.max(1, width - 20);
	const plotHeight = Math.max(1, height - titleSpace - legendSpace);
	const centerX = width / 2;
	const centerY = titleSpace + plotHeight / 2;
	const outerRadius = Math.max(8, Math.min(plotWidth, plotHeight) * .45);
	const innerRadius = Math.max(2, outerRadius * .58);
	const svg = doc$1.createElementNS(SVG_NS$1, "svg");
	svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
	svg.setAttribute("width", "100%");
	svg.setAttribute("height", "100%");
	svg.style.display = "block";
	if (hasTitle) {
		const titleEl = doc$1.createElementNS(SVG_NS$1, "text");
		titleEl.setAttribute("x", String(centerX));
		titleEl.setAttribute("y", "24");
		titleEl.setAttribute("text-anchor", "middle");
		titleEl.setAttribute("font-size", String(Math.max(12, Math.min(22, width / 18))));
		titleEl.setAttribute("fill", AXIS_COLOR);
		titleEl.setAttribute("font-family", FONT_FAMILY);
		titleEl.textContent = title;
		svg.appendChild(titleEl);
	}
	renderDoughnutSlices(doc$1, svg, slices, centerX, centerY, outerRadius, innerRadius);
	if (hasLegend) renderPieLegend(doc$1, svg, slices, width, height);
	if (truncated) renderTruncationIndicator(doc$1, svg, width);
	container.appendChild(svg);
	return container;
}
function estimateSvgElements(series, categories, hasLegend) {
	const bars = series.reduce((sum, s) => sum + s.values.length, 0);
	const axes = 2;
	const categoryLabels = categories.length;
	const valueTicks = (VALUE_TICK_COUNT + 1) * 2;
	const legend = hasLegend ? series.length * 2 : 0;
	return bars + axes + categoryLabels + valueTicks + legend;
}
function renderBarChart(doc$1, container, chart, geometry) {
	const { width, height } = geometry;
	const { series, truncated } = applyGuardrails(chart);
	const categories = series[0]?.categories ?? [];
	const hasLegend = chart.legendPosition !== void 0;
	const estimated = estimateSvgElements(series, categories, hasLegend);
	if (estimated > SVG_ELEMENT_BUDGET) return createChartPlaceholder(doc$1, container, `Chart too complex for inline rendering (${estimated} elements)`);
	const svg = doc$1.createElementNS(SVG_NS$1, "svg");
	svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
	svg.setAttribute("width", "100%");
	svg.setAttribute("height", "100%");
	svg.style.display = "block";
	const layout = computeBarLayout(width, height, series);
	renderBars(doc$1, svg, series, layout);
	renderAxes(doc$1, svg, layout);
	renderCategoryLabels(doc$1, svg, categories, layout, width);
	renderValueTicks(doc$1, svg, layout, height);
	if (hasLegend) renderLegend(doc$1, svg, series, height);
	if (truncated) renderTruncationIndicator(doc$1, svg, width);
	container.appendChild(svg);
	return container;
}
var DEFAULT_PPI = 96;
var DEFAULT_RULER_HEIGHT = 25;
var TICK_SPACING_PX = DEFAULT_PPI / 8;
function generateRulerDefinition(config) {
	const ppi = config.ppi ?? DEFAULT_PPI;
	const heightPx = config.heightPx ?? DEFAULT_RULER_HEIGHT;
	const { pageSize, pageMargins } = config;
	if (!Number.isFinite(ppi) || ppi <= 0) throw new Error(`Invalid PPI: ${ppi}. Must be a positive finite number.`);
	if (!Number.isFinite(pageSize.width) || pageSize.width <= 0) throw new Error(`Invalid page width: ${pageSize.width}. Must be a positive finite number.`);
	if (!Number.isFinite(pageSize.height) || pageSize.height <= 0) throw new Error(`Invalid page height: ${pageSize.height}. Must be a positive finite number.`);
	if (!Number.isFinite(pageMargins.left) || pageMargins.left < 0) throw new Error(`Invalid left margin: ${pageMargins.left}. Must be a non-negative finite number.`);
	if (!Number.isFinite(pageMargins.right) || pageMargins.right < 0) throw new Error(`Invalid right margin: ${pageMargins.right}. Must be a non-negative finite number.`);
	if (pageMargins.left + pageMargins.right >= pageSize.width) throw new Error(`Invalid margins: left (${pageMargins.left}) + right (${pageMargins.right}) must be less than page width (${pageSize.width}).`);
	const widthPx = pageSize.width * ppi;
	const ticks = [];
	let currentX = 0;
	for (let inch = 0; inch < pageSize.width; inch++) {
		const remaining = pageSize.width - inch;
		ticks.push({
			size: "main",
			height: "20%",
			label: inch,
			x: currentX
		});
		currentX += TICK_SPACING_PX;
		for (let i = 0; i < 3; i++) {
			ticks.push({
				size: "eighth",
				height: "10%",
				x: currentX
			});
			currentX += TICK_SPACING_PX;
		}
		ticks.push({
			size: "half",
			height: "40%",
			x: currentX
		});
		currentX += TICK_SPACING_PX;
		if (remaining <= .5) break;
		for (let i = 0; i < 3; i++) {
			ticks.push({
				size: "eighth",
				height: "10%",
				x: currentX
			});
			currentX += TICK_SPACING_PX;
		}
	}
	return {
		widthPx,
		heightPx,
		ticks,
		leftMarginPx: pageMargins.left * ppi,
		rightMarginPx: widthPx - pageMargins.right * ppi,
		pageWidthInches: pageSize.width
	};
}
function calculateMarginFromHandle(handleX, side, pageWidthPx, ppi = DEFAULT_PPI) {
	if (side === "left") return handleX / ppi;
	else return (pageWidthPx - handleX) / ppi;
}
function clampHandlePosition(handleX, side, otherHandleX, pageWidthPx, minContentWidthPx = 200) {
	if (!Number.isFinite(handleX)) throw new Error(`Invalid handleX: ${handleX}. Must be a finite number.`);
	if (!Number.isFinite(otherHandleX)) throw new Error(`Invalid otherHandleX: ${otherHandleX}. Must be a finite number.`);
	if (!Number.isFinite(pageWidthPx)) throw new Error(`Invalid pageWidthPx: ${pageWidthPx}. Must be a finite number.`);
	if (!Number.isFinite(minContentWidthPx)) throw new Error(`Invalid minContentWidthPx: ${minContentWidthPx}. Must be a finite number.`);
	if (side === "left") {
		const min$2 = 0;
		const max$2 = otherHandleX - minContentWidthPx;
		return Math.max(min$2, Math.min(max$2, handleX));
	} else {
		const min$2 = otherHandleX + minContentWidthPx;
		const max$2 = pageWidthPx;
		return Math.max(min$2, Math.min(max$2, handleX));
	}
}
function generateRulerDefinitionFromPx(config) {
	const ppi = config.ppi ?? DEFAULT_PPI;
	const heightPx = config.heightPx ?? DEFAULT_RULER_HEIGHT;
	const { pageWidthPx, leftMarginPx, rightMarginPx } = config;
	if (!Number.isFinite(ppi) || ppi <= 0) throw new Error(`Invalid PPI: ${ppi}. Must be a positive finite number.`);
	if (!Number.isFinite(pageWidthPx) || pageWidthPx <= 0) throw new Error(`Invalid page width: ${pageWidthPx}px. Must be a positive finite number.`);
	if (!Number.isFinite(config.pageHeightPx) || config.pageHeightPx <= 0) throw new Error(`Invalid page height: ${config.pageHeightPx}px. Must be a positive finite number.`);
	if (!Number.isFinite(leftMarginPx) || leftMarginPx < 0) throw new Error(`Invalid left margin: ${leftMarginPx}px. Must be a non-negative finite number.`);
	if (!Number.isFinite(rightMarginPx) || rightMarginPx < 0) throw new Error(`Invalid right margin: ${rightMarginPx}px. Must be a non-negative finite number.`);
	if (leftMarginPx + rightMarginPx >= pageWidthPx) throw new Error(`Invalid margins: left (${leftMarginPx}px) + right (${rightMarginPx}px) must be less than page width (${pageWidthPx}px).`);
	const pageWidthInches = pageWidthPx / ppi;
	const ticks = [];
	let currentX = 0;
	for (let inch = 0; inch < pageWidthInches; inch++) {
		const remaining = pageWidthInches - inch;
		ticks.push({
			size: "main",
			height: "20%",
			label: inch,
			x: currentX
		});
		currentX += TICK_SPACING_PX;
		for (let i = 0; i < 3; i++) {
			ticks.push({
				size: "eighth",
				height: "10%",
				x: currentX
			});
			currentX += TICK_SPACING_PX;
		}
		ticks.push({
			size: "half",
			height: "40%",
			x: currentX
		});
		currentX += TICK_SPACING_PX;
		if (remaining <= .5) break;
		for (let i = 0; i < 3; i++) {
			ticks.push({
				size: "eighth",
				height: "10%",
				x: currentX
			});
			currentX += TICK_SPACING_PX;
		}
	}
	return {
		widthPx: pageWidthPx,
		heightPx,
		ticks,
		leftMarginPx,
		rightMarginPx: pageWidthPx - rightMarginPx,
		pageWidthInches
	};
}
const RULER_CLASS_NAMES = {
	ruler: "superdoc-ruler",
	tick: "superdoc-ruler-tick",
	tickMain: "superdoc-ruler-tick--main",
	tickHalf: "superdoc-ruler-tick--half",
	tickEighth: "superdoc-ruler-tick--eighth",
	label: "superdoc-ruler-label",
	handle: "superdoc-ruler-handle",
	handleLeft: "superdoc-ruler-handle--left",
	handleRight: "superdoc-ruler-handle--right",
	indicator: "superdoc-ruler-indicator"
};
function createRulerElement(options) {
	const { definition, doc: doc$1, interactive = false } = options;
	if (!Number.isFinite(definition.widthPx) || definition.widthPx <= 0) {
		console.warn(`[createRulerElement] Invalid ruler width: ${definition.widthPx}px. Using minimum width of 1px.`);
		definition.widthPx = Math.max(1, definition.widthPx || 1);
	}
	if (!definition.ticks || definition.ticks.length === 0) console.warn("[createRulerElement] Ruler definition has no ticks. Ruler will be empty.");
	const ruler = doc$1.createElement("div");
	ruler.className = RULER_CLASS_NAMES.ruler;
	ruler.style.cssText = `
    position: relative;
    width: ${definition.widthPx}px;
    height: ${definition.heightPx}px;
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    user-select: none;
    pointer-events: ${interactive ? "auto" : "none"};
  `;
	for (const tick of definition.ticks) {
		const tickEl = createTickElement(tick, doc$1);
		ruler.appendChild(tickEl);
	}
	if (interactive) {
		const leftHandle = createHandleElement("left", definition.leftMarginPx, doc$1, options);
		const rightHandle = createHandleElement("right", definition.rightMarginPx, doc$1, options);
		ruler.appendChild(leftHandle);
		ruler.appendChild(rightHandle);
	}
	return ruler;
}
function createTickElement(tick, doc$1) {
	const el = doc$1.createElement("div");
	const sizeClass = tick.size === "main" ? RULER_CLASS_NAMES.tickMain : tick.size === "half" ? RULER_CLASS_NAMES.tickHalf : RULER_CLASS_NAMES.tickEighth;
	el.className = `${RULER_CLASS_NAMES.tick} ${sizeClass}`;
	el.style.cssText = `
    position: absolute;
    left: ${tick.x}px;
    bottom: 0;
    width: 1px;
    height: ${tick.height};
    background-color: #666;
    pointer-events: none;
  `;
	if (tick.label !== void 0 && tick.label !== 0) {
		const label = doc$1.createElement("span");
		label.className = RULER_CLASS_NAMES.label;
		label.textContent = String(tick.label);
		label.style.cssText = `
      position: absolute;
      top: -16px;
      left: -2px;
      font-size: 10px;
      color: #666;
      pointer-events: none;
      user-select: none;
    `;
		el.appendChild(label);
	}
	return el;
}
function createHandleElement(side, x, doc$1, options) {
	const handle = doc$1.createElement("div");
	const sideClass = side === "left" ? RULER_CLASS_NAMES.handleLeft : RULER_CLASS_NAMES.handleRight;
	handle.className = `${RULER_CLASS_NAMES.handle} ${sideClass}`;
	handle.dataset.side = side;
	handle.style.cssText = `
    position: absolute;
    left: ${x}px;
    top: 0;
    width: 5px;
    height: 20px;
    margin-left: -2px;
    background-color: #ccc;
    border-radius: 4px 4px 0 0;
    cursor: grab;
    transition: background-color 150ms ease;
    z-index: 10;
  `;
	handle.addEventListener("mouseenter", () => {
		if (!handle.dataset.dragging) handle.style.backgroundColor = "rgba(37, 99, 235, 0.4)";
	});
	handle.addEventListener("mouseleave", () => {
		if (!handle.dataset.dragging) handle.style.backgroundColor = "#ccc";
	});
	if (options.onDragStart || options.onDrag || options.onDragEnd) setupHandleDrag(handle, side, options);
	return handle;
}
function setupHandleDrag(handle, side, options) {
	let offsetX = 0;
	const onPointerDown = (event) => {
		event.preventDefault();
		handle.dataset.dragging = "true";
		handle.style.backgroundColor = "rgba(37, 99, 235, 0.4)";
		handle.style.cursor = "grabbing";
		const rect = handle.getBoundingClientRect();
		offsetX = event.clientX - rect.left - rect.width / 2;
		handle.setPointerCapture(event.pointerId);
		options.onDragStart?.(side, event);
	};
	const onPointerMove = (event) => {
		if (handle.dataset.dragging !== "true") return;
		const ruler = handle.parentElement;
		if (!ruler) return;
		const rulerRect = ruler.getBoundingClientRect();
		const newX = event.clientX - rulerRect.left - offsetX;
		options.onDrag?.(side, newX, event);
	};
	const onPointerUp = (event) => {
		if (handle.dataset.dragging !== "true") return;
		handle.dataset.dragging = "";
		handle.style.backgroundColor = "#ccc";
		handle.style.cursor = "grab";
		handle.releasePointerCapture(event.pointerId);
		const ruler = handle.parentElement;
		if (!ruler) return;
		const rulerRect = ruler.getBoundingClientRect();
		const finalX = event.clientX - rulerRect.left - offsetX;
		options.onDragEnd?.(side, finalX, event);
	};
	handle.addEventListener("pointerdown", onPointerDown);
	handle.addEventListener("pointermove", onPointerMove);
	handle.addEventListener("pointerup", onPointerUp);
	handle.addEventListener("pointercancel", onPointerUp);
}
var RULER_STYLES = `
/* Ruler container */
.${RULER_CLASS_NAMES.ruler} {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background-color: transparent;
}

/* Tick marks base styling */
.${RULER_CLASS_NAMES.tick} {
  flex-shrink: 0;
}

/* Handle hover and active states */
.${RULER_CLASS_NAMES.handle}:hover {
  background-color: rgba(37, 99, 235, 0.4) !important;
}

.${RULER_CLASS_NAMES.handle}:active,
.${RULER_CLASS_NAMES.handle}[data-dragging="true"] {
  background-color: rgba(37, 99, 235, 0.6) !important;
  cursor: grabbing !important;
}

/* Vertical indicator animation */
.${RULER_CLASS_NAMES.indicator} {
  transition: left 16ms linear;
}

/* Print mode: hide rulers */
@media print {
  .${RULER_CLASS_NAMES.ruler} {
    display: none !important;
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .${RULER_CLASS_NAMES.tick} {
    background-color: #000 !important;
  }

  .${RULER_CLASS_NAMES.label} {
    color: #000 !important;
  }

  .${RULER_CLASS_NAMES.handle} {
    background-color: #666 !important;
    border: 1px solid #000;
  }

  .${RULER_CLASS_NAMES.handle}:hover,
  .${RULER_CLASS_NAMES.handle}:active {
    background-color: #0066cc !important;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .${RULER_CLASS_NAMES.handle} {
    transition: none !important;
  }

  .${RULER_CLASS_NAMES.indicator} {
    transition: none !important;
  }
}
`;
var rulerStylesInjected = false;
function ensureRulerStyles(doc$1) {
	if (rulerStylesInjected || !doc$1) return;
	const styleEl = doc$1.createElement("style");
	styleEl.setAttribute("data-superdoc-ruler-styles", "true");
	styleEl.textContent = RULER_STYLES;
	doc$1.head?.appendChild(styleEl);
	rulerStylesInjected = true;
}
const BROWSER_DEFAULT_FONT_SIZE = "16px";
const CLASS_NAMES$1 = {
	container: "superdoc-layout",
	page: "superdoc-page",
	fragment: "superdoc-fragment",
	line: "superdoc-line",
	spread: "superdoc-spread",
	pageHeader: "superdoc-page-header",
	pageFooter: "superdoc-page-footer"
};
const DEFAULT_PAGE_STYLES = {
	background: "var(--sd-layout-page-bg, #fff)",
	boxShadow: "var(--sd-layout-page-shadow, 0 4px 20px rgba(15, 23, 42, 0.08))",
	border: "1px solid rgba(15, 23, 42, 0.08)",
	margin: "0 auto"
};
const containerStyles = {
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	background: "transparent",
	padding: "0",
	overflowY: "auto",
	isolation: "isolate"
};
const containerStylesHorizontal = {
	display: "flex",
	flexDirection: "row",
	alignItems: "flex-start",
	justifyContent: "safe center",
	background: "transparent",
	padding: "0",
	overflowX: "auto",
	minHeight: "100%",
	isolation: "isolate"
};
const spreadStyles = {
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	gap: "0px"
};
const pageStyles = (width, height, overrides) => {
	const merged = {
		...DEFAULT_PAGE_STYLES,
		...overrides || {}
	};
	return {
		position: "relative",
		width: `${width}px`,
		height: `${height}px`,
		minWidth: `${width}px`,
		minHeight: `${height}px`,
		flexShrink: "0",
		background: merged.background,
		boxShadow: merged.boxShadow,
		border: merged.border,
		margin: merged.margin,
		overflow: "hidden"
	};
};
const fragmentStyles = {
	position: "absolute",
	whiteSpace: "pre",
	overflow: "visible",
	boxSizing: "border-box"
};
const lineStyles = (lineHeight) => ({
	lineHeight: `${lineHeight}px`,
	height: `${lineHeight}px`,
	fontSize: "0",
	position: "relative",
	display: "block",
	whiteSpace: "pre",
	overflow: "visible"
});
var PRINT_STYLES = `
@media print {
  .${CLASS_NAMES$1.container} {
    background: transparent;
    padding: 0;
  }

  .${CLASS_NAMES$1.page} {
    margin: 0;
    border: none;
    box-shadow: none;
    page-break-after: always;
  }
}
`;
var LINK_AND_TOC_STYLES = `
/* Reset browser default link styling - allow run colors to show through from inline styles
 *
 * Note: !important was removed from these rules to allow inline styles to take precedence.
 * This is necessary because OOXML hyperlink character styles apply colors via inline style
 * attributes on the run elements. The CSS cascade ensures that inline styles (applied via
 * element.style.color in applyRunStyles) override these class-based rules naturally.
 *
 * Implications:
 * - OOXML hyperlink character styles will correctly display their assigned colors
 * - Browser default link colors are still reset by these inherit rules
 * - Inline color styles from run objects override the inherit value as expected
 */
.superdoc-link {
  color: inherit;
  text-decoration: none;
}

.superdoc-link:visited {
  color: inherit;
}

.superdoc-link:hover {
  text-decoration: underline;
}

/* Focus visible for keyboard navigation (WCAG 2.1 SC 2.4.7) */
.superdoc-link:focus-visible {
  outline: 2px solid #0066cc;
  outline-offset: 2px;
  border-radius: 2px;
}

/* Remove outline for mouse users */
.superdoc-link:focus:not(:focus-visible) {
  outline: none;
}

/* Active state */
.superdoc-link:active {
  opacity: 0.8;
}

/* Print mode: show URLs after links */
@media print {
  .superdoc-link::after {
    content: " (" attr(href) ")";
    font-size: 0.9em;
    color: #666;
  }

  /* Don't show URL for anchor-only links */
  .superdoc-link[href^="#"]::after {
    content: "";
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .superdoc-link:focus-visible {
    outline-width: 3px;
    outline-offset: 3px;
  }
}

/* SD-2454: bookmark bracket indicators.
 * When the showBookmarks layout option is enabled, the pm-adapter emits
 * [ and ] marker TextRuns at bookmark start/end positions. Mirror Word's
 * visual treatment: subtle gray, non-selectable so users can't accidentally
 * include the brackets in copied text. The bookmark name is surfaced via
 * the native title tooltip on the opening bracket. */
[data-bookmark-marker="start"],
[data-bookmark-marker="end"] {
  color: #8b8b8b;
  user-select: none;
  cursor: default;
  font-weight: normal;
}


/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .superdoc-link {
    transition: none;
  }
}

/* Screen reader only content (WCAG SC 1.3.1) */
.superdoc-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* TOC entry specific styles - prevent wrapping */
.superdoc-toc-entry {
  white-space: nowrap !important;
}

.superdoc-toc-entry .superdoc-link {
  color: inherit !important;
  text-decoration: none !important;
  cursor: default;
  /* Disable native link drag so our pointer loop can run text-selection. */
  -webkit-user-drag: none;
  user-drag: none;
}

.superdoc-toc-entry .superdoc-link:hover {
  text-decoration: none;
}

/* Override focus styles for TOC links (they're not interactive) */
.superdoc-toc-entry .superdoc-link:focus-visible {
  outline: none;
}

/* TOC hover. .toc-group-hover is set by PresentationEditor on every entry
   sharing a data-toc-id so the whole TOC greys out together. The ::after
   stripe (height set via --toc-gap-below) fills the paragraph-spacing gap
   between adjacent entries so the hover reads as one continuous block. */
.superdoc-toc-entry:hover,
.superdoc-toc-entry.toc-group-hover {
  background-color: var(--sd-content-controls-block-hover-bg, #f2f2f2);
}

/* Pointer-events stay on (default) so the stripe extends the parent entry's
   hit-test area through the paragraph-spacing gap. Without this, moving the
   cursor between two adjacent entries fires mouseout on the upper entry with
   relatedTarget = the page (not a TOC entry), the coordinator drops the
   group-hover class, and the grey disappears for a frame before the next
   entry's mouseover restores it — visible as a flicker. */
.superdoc-toc-entry.toc-group-hover::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  height: var(--toc-gap-below, 0px);
  background-color: var(--sd-content-controls-block-hover-bg, #f2f2f2);
}

/* Remove focus outlines from layout engine elements */
.superdoc-layout,
.superdoc-page,
.superdoc-layout:focus,
.superdoc-page:focus {
  outline: none !important;
}
`;
var TRACK_CHANGE_STYLES = `
.superdoc-layout .track-insert-dec.hidden,
.superdoc-layout .track-delete-dec.hidden {
  display: none;
}

.superdoc-layout .track-insert-dec.highlighted {
  border-top: var(--sd-tracked-changes-insert-border-width, 1px) dashed var(--sd-tracked-changes-insert-border, #00853d);
  border-bottom: var(--sd-tracked-changes-insert-border-width, 1px) dashed var(--sd-tracked-changes-insert-border, #00853d);
  background-color: var(--sd-tracked-changes-insert-background, #399c7222);
  color: var(--sd-tracked-changes-insert-text, currentColor);
  text-decoration-line: var(--sd-tracked-changes-insert-decoration-line, none);
  text-decoration-color: var(--sd-tracked-changes-insert-text, currentColor);
  text-decoration-thickness: var(--sd-tracked-changes-insert-decoration-thickness, 1px);
  text-underline-offset: var(--sd-tracked-changes-insert-underline-offset, 0px);
}

.superdoc-layout .track-delete-dec.highlighted {
  border-top: var(--sd-tracked-changes-delete-border-width, 1px) dashed var(--sd-tracked-changes-delete-border, #cb0e47);
  border-bottom: var(--sd-tracked-changes-delete-border-width, 1px) dashed var(--sd-tracked-changes-delete-border, #cb0e47);
  background-color: var(--sd-tracked-changes-delete-background, #cb0e4722);
  color: var(--sd-tracked-changes-delete-text, currentColor);
  text-decoration:
    line-through
    solid
    var(--sd-tracked-changes-delete-text, currentColor)
    var(--sd-tracked-changes-delete-decoration-thickness, 2px) !important;
}

.superdoc-layout .track-format-dec.highlighted {
  border-bottom: 2px solid var(--sd-tracked-changes-format-border, gold);
}

.superdoc-layout .track-insert-dec.highlighted.track-change-focused {
  border-left: none;
  border-right: none;
  border-top-style: solid;
  border-bottom-style: solid;
  background-color: var(--sd-tracked-changes-insert-background-focused, #399c7244);
}

.superdoc-layout .track-delete-dec.highlighted.track-change-focused {
  border-left: none;
  border-right: none;
  border-top-style: solid;
  border-bottom-style: solid;
  background-color: var(--sd-tracked-changes-delete-background-focused, #cb0e4744);
}

.superdoc-layout .track-overlap-insert-delete-dec.track-insert-dec.track-delete-dec.highlighted {
  border-top: var(--sd-tracked-changes-insert-border-width, 1px) dashed var(--sd-tracked-changes-insert-border, #00853d);
  border-bottom: var(--sd-tracked-changes-insert-border-width, 1px) dashed var(--sd-tracked-changes-insert-border, #00853d);
  background-color: var(--sd-tracked-changes-insert-background, #399c7222);
  color: var(--sd-tracked-changes-insert-text, currentColor);
  text-decoration:
    line-through
    solid
    var(--sd-tracked-changes-delete-text, #cb0e47)
    var(--sd-tracked-changes-delete-decoration-thickness, 2px) !important;
}

.superdoc-layout .track-overlap-insert-delete-dec.track-insert-dec.track-delete-dec.highlighted.track-change-focused {
  border-left: none;
  border-right: none;
  border-top-style: solid;
  border-bottom-style: solid;
  background-color: var(--sd-tracked-changes-insert-background-focused, #399c7244);
  color: var(--sd-tracked-changes-insert-text, currentColor);
  text-decoration:
    line-through
    solid
    var(--sd-tracked-changes-delete-text, #cb0e47)
    var(--sd-tracked-changes-delete-decoration-thickness, 2px) !important;
}

.superdoc-layout .track-format-dec.highlighted.track-change-focused {
  background-color: var(--sd-tracked-changes-format-background-focused, #ffd70033);
}

/*
 * Structural row-level tracked changes (inserted/deleted whole rows).
 *
 * The painter renders a row as absolutely-positioned cell <div>s (no <tr>), so
 * each cell of a tracked row carries the same base class (track-insert-dec /
 * track-delete-dec) + modifier (highlighted / hidden) as inline runs, plus the
 * block-context marker class track-row-cell-dec. These rules reuse the same
 * --sd-tracked-changes-insert-* / --sd-tracked-changes-delete-* CSS variables so
 * the per-author color flows through identically to the inline path.
 *
 * 'hidden' mode collapses the cell (and therefore the row) via the existing
 * .track-insert-dec.hidden / .track-delete-dec.hidden { display: none } rule
 * above: an inserted row in 'original' mode and a deleted row in 'final' mode
 * disappear, matching inline behavior.
 */
.superdoc-layout .track-row-cell-dec.track-insert-dec.highlighted {
  background-color: var(--sd-tracked-changes-insert-background, #399c7222);
  border-top: var(--sd-tracked-changes-insert-border-width, 2px) solid
    var(--sd-tracked-changes-insert-border, #00853d);
  border-bottom: var(--sd-tracked-changes-insert-border-width, 2px) solid
    var(--sd-tracked-changes-insert-border, #00853d);
}

.superdoc-layout .track-row-cell-dec.track-delete-dec.highlighted {
  background-color: var(--sd-tracked-changes-delete-background, #cb0e4722);
  border-top: var(--sd-tracked-changes-delete-border-width, 2px) solid
    var(--sd-tracked-changes-delete-border, #cb0e47);
  border-bottom: var(--sd-tracked-changes-delete-border-width, 2px) solid
    var(--sd-tracked-changes-delete-border, #cb0e47);
}

.superdoc-layout .track-row-cell-dec.track-delete-dec.highlighted .superdoc-line {
  text-decoration:
    line-through
    solid
    var(--sd-tracked-changes-delete-text, #cb0e47)
    var(--sd-tracked-changes-delete-decoration-thickness, 2px);
}
`;
var FORMATTING_MARKS_STYLES = `
.superdoc-formatting-space-mark,
.superdoc-marker-suffix-space {
  position: relative;
}

.superdoc-formatting-space-mark {
  white-space: pre;
}

.superdoc-layout.superdoc-show-formatting-marks .superdoc-tab {
  position: relative;
  visibility: visible !important;
}

.superdoc-layout.superdoc-show-formatting-marks .superdoc-tab::after {
  content: "→";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: var(--sd-formatting-mark-color, var(--sd-ui-action, currentColor));
  font-size: 0.75em;
  line-height: 1;
  pointer-events: none;
}

.superdoc-layout.superdoc-show-formatting-marks [dir="rtl"] .superdoc-tab::after {
  content: "←";
}

.superdoc-layout.superdoc-show-formatting-marks .superdoc-formatting-space-mark::after,
.superdoc-layout.superdoc-show-formatting-marks .superdoc-marker-suffix-space::after {
  content: "·";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: var(--sd-formatting-mark-color, var(--sd-ui-action, currentColor));
  font-size: 0.75em;
  line-height: 1;
  pointer-events: none;
}

.superdoc-formatting-paragraph-mark {
  display: none;
  position: absolute;
  top: 0;
  transform: translateX(var(--sd-formatting-paragraph-mark-gap, 0.2em));
  color: var(--sd-formatting-mark-color, var(--sd-ui-action, currentColor));
  pointer-events: none;
  user-select: none;
  white-space: pre;
  z-index: 2;
}

.superdoc-layout.superdoc-show-formatting-marks .superdoc-formatting-paragraph-mark {
  display: inline;
}

.superdoc-layout.superdoc-show-formatting-marks [dir="rtl"] .superdoc-formatting-paragraph-mark {
  transform: translateX(calc(-100% - var(--sd-formatting-paragraph-mark-gap, 0.2em)));
}

@media print {
  .superdoc-layout.superdoc-show-formatting-marks .superdoc-tab::after,
  .superdoc-layout.superdoc-show-formatting-marks .superdoc-formatting-space-mark::after,
  .superdoc-layout.superdoc-show-formatting-marks .superdoc-marker-suffix-space::after {
    content: "";
    display: none;
  }

  .superdoc-layout.superdoc-show-formatting-marks .superdoc-formatting-paragraph-mark {
    display: none;
  }
}
`;
var SDT_CONTAINER_STYLES = `
/* Document Section - Block-level container with gray border and hover tooltip */
.superdoc-document-section {
  background-color: #fafafa;
  border: 1px solid #ababab;
  border-radius: 4px;
  position: relative;
  box-sizing: border-box;
}

/* Document section tooltip - positioned above the fragment */
.superdoc-document-section__tooltip {
  position: absolute;
  top: -19px;
  left: -1px;
  max-width: 100px;
  min-width: 0;
  height: 18px;
  border: 1px solid #ababab;
  border-bottom: none;
  border-radius: 6px 6px 0 0;
  padding: 0 8px;
  align-items: center;
  font-size: 10px;
  display: none;
  z-index: 100;
  background-color: #fafafa;
  pointer-events: none;
}

.superdoc-document-section__tooltip span {
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* Show tooltip on hover - adjust border radius to connect with tooltip tab */
.superdoc-document-section:hover {
  border-radius: 0 4px 4px 4px;
}

.superdoc-document-section:hover .superdoc-document-section__tooltip {
  display: flex;
  align-items: center;
}

/* Continuation styling: SDT container boundary handling for multi-fragment document sections */
/* Single fragment (both start and end): full border radius */
.superdoc-document-section[data-sdt-container-start="true"][data-sdt-container-end="true"] {
  border-radius: 4px;
}

/* First fragment of a multi-fragment SDT: top corners, no bottom border */
.superdoc-document-section[data-sdt-container-start="true"]:not([data-sdt-container-end="true"]) {
  border-radius: 4px 4px 0 0;
  border-bottom: none;
}

/* Last fragment of a multi-fragment SDT: bottom corners, no top border */
.superdoc-document-section[data-sdt-container-end="true"]:not([data-sdt-container-start="true"]) {
  border-radius: 0 0 4px 4px;
  border-top: none;
}

.superdoc-document-section[data-sdt-container-start="true"]:hover {
  border-radius: 0 4px 0 0;
}

/* Middle fragments (neither start nor end): no corners, no top/bottom borders */
.superdoc-document-section:not([data-sdt-container-start="true"]):not([data-sdt-container-end="true"]) {
  border-radius: 0;
  border-top: none;
  border-bottom: none;
}

/* Structured Content Block - Blue border container */
.superdoc-structured-content-block {
  box-sizing: border-box;
  border-radius: 4px;
  background-color: transparent;
  position: relative;
  z-index: 0;
  --sd-sdt-chrome-left: 0px;
  --sd-sdt-chrome-width: 100%;
  --sd-sdt-chrome-bottom-extension: 0px;
}

.superdoc-structured-content-block::before {
  content: '';
  position: absolute;
  left: var(--sd-sdt-chrome-left, 0px);
  top: 0;
  bottom: calc(0px - var(--sd-sdt-chrome-bottom-extension, 0px));
  width: var(--sd-sdt-chrome-width, 100%);
  border-radius: inherit;
  background-color: var(--sd-content-controls-block-bg, transparent);
  box-sizing: border-box;
  z-index: -1;
  pointer-events: none;
}

.superdoc-structured-content-block::after {
  content: '';
  position: absolute;
  left: var(--sd-sdt-chrome-left, 0px);
  top: 0;
  bottom: calc(0px - var(--sd-sdt-chrome-bottom-extension, 0px));
  width: var(--sd-sdt-chrome-width, 100%);
  border: 1px solid transparent;
  border-radius: inherit;
  box-sizing: border-box;
  z-index: 1;
  pointer-events: none;
}

.superdoc-structured-content-block:not(.ProseMirror-selectednode):hover::before {
  background-color: var(--sd-content-controls-block-hover-bg, #f2f2f2);
}

.superdoc-structured-content-block:not(.ProseMirror-selectednode):hover::after {
  border-color: var(--sd-content-controls-block-hover-border, transparent);
}

/* Group hover (JavaScript-coordinated via PresentationEditor) */
.superdoc-structured-content-block.sdt-group-hover:not(.ProseMirror-selectednode)::before {
  background-color: var(--sd-content-controls-block-hover-bg, #f2f2f2);
}

.superdoc-structured-content-block.sdt-group-hover:not(.ProseMirror-selectednode)::after {
  border-color: var(--sd-content-controls-block-hover-border, transparent);
}

.superdoc-structured-content-block.ProseMirror-selectednode {
  outline: none;
}

.superdoc-structured-content-block.ProseMirror-selectednode::after {
  border-color: var(--sd-content-controls-block-border, #629be7);
}

/* Structured content labels - shared box model; positioning differs by scope. */
.superdoc-structured-content__label,
.superdoc-structured-content-inline__label {
  font-size: 11px;
  align-items: center;
  justify-content: center;
  height: 18px;
  padding: 0 4px;
  border: 1px solid var(--sd-content-controls-label-border, #629be7);
  background-color: var(--sd-content-controls-label-bg, #629be7ee);
  color: var(--sd-content-controls-label-text, #ffffff);
  box-sizing: border-box;
  display: none;
  pointer-events: auto;
  cursor: pointer;
  user-select: none;
}

.superdoc-structured-content__label::before,
.superdoc-structured-content-inline__label::before {
  content: '';
  width: 2px;
  height: 8px;
  margin-right: 4px;
  background:
    radial-gradient(circle, currentColor 1px, transparent 1px) center 0 / 2px 2px no-repeat,
    radial-gradient(circle, currentColor 1px, transparent 1px) center 3px / 2px 2px no-repeat,
    radial-gradient(circle, currentColor 1px, transparent 1px) center 6px / 2px 2px no-repeat;
  flex: 0 0 auto;
}

/* Structured content drag handle/label - positioned above */
.superdoc-structured-content__label {
  position: absolute;
  left: calc(var(--sd-sdt-chrome-left, 0px) + 2px);
  top: -18px;
  width: max-content;
  max-width: 130px;
  min-width: 0;
  border-bottom: none;
  border-radius: 6px 6px 0 0;
  white-space: nowrap;
  z-index: 10;
}

.superdoc-structured-content__label span {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.superdoc-structured-content-block.ProseMirror-selectednode .superdoc-structured-content__label {
  display: inline-flex;
}

/* Continuation styling for structured content blocks */
/* Single fragment (both start and end): full border radius */
.superdoc-structured-content-block[data-sdt-container-start="true"][data-sdt-container-end="true"] {
  border-radius: 4px;
}

/* First fragment of a multi-fragment SDT: top corners, no bottom border */
.superdoc-structured-content-block[data-sdt-container-start="true"]:not([data-sdt-container-end="true"]) {
  border-radius: 4px 4px 0 0;
}

.superdoc-structured-content-block[data-sdt-container-start="true"]:not([data-sdt-container-end="true"])::after {
  border-bottom: none;
}

/* Last fragment of a multi-fragment SDT: bottom corners, no top border */
.superdoc-structured-content-block[data-sdt-container-end="true"]:not([data-sdt-container-start="true"]) {
  border-radius: 0 0 4px 4px;
}

.superdoc-structured-content-block[data-sdt-container-end="true"]:not([data-sdt-container-start="true"])::after {
  border-top: none;
}

/* Middle fragment (neither start nor end): no corners, no top/bottom borders */
.superdoc-structured-content-block:not([data-sdt-container-start="true"]):not([data-sdt-container-end="true"]) {
  border-radius: 0;
}

.superdoc-structured-content-block:not([data-sdt-container-start="true"]):not([data-sdt-container-end="true"])::after {
  border-top: none;
  border-bottom: none;
}

/* Structured Content Inline - Inline wrapper with blue border */
.superdoc-structured-content-inline {
  padding: 1px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid transparent;
  background-color: var(--sd-content-controls-inline-bg, transparent);
  position: relative;
  display: inline;
  font-size: initial;
  line-height: normal;
  z-index: 10;
}

.superdoc-structured-content-inline[data-contains-inline-image='true']:not([data-appearance='hidden']) {
  display: inline-block;
  vertical-align: top;
}

/* Hover effect for inline structured content */
.superdoc-structured-content-inline:not(.ProseMirror-selectednode):hover {
  background-color: var(--sd-content-controls-inline-hover-bg, #f2f2f2);
  border-color: var(--sd-content-controls-inline-hover-border, transparent);
}

.superdoc-structured-content-inline.ProseMirror-selectednode {
  border-color: var(--sd-content-controls-inline-border, #629be7);
  outline: none;
  background-color: transparent;
}

.superdoc-structured-content-inline[data-empty='true']:not([data-appearance='hidden']) {
  border-color: var(--sd-content-controls-inline-border, #629be7);
}

.superdoc-empty-sdt-placeholder {
  display: inline-block;
  line-height: normal;
  vertical-align: baseline;
  white-space: nowrap;
}

.superdoc-empty-sdt-placeholder::before {
  content: attr(data-placeholder-text);
  color: var(--sd-content-controls-placeholder-text, #a6a6a6);
}

.superdoc-structured-content-inline.ProseMirror-selectednode .superdoc-empty-sdt-placeholder::before,
.superdoc-structured-content-block.ProseMirror-selectednode .superdoc-empty-sdt-placeholder::before {
  background-color: var(--sd-content-controls-placeholder-selected-bg, Highlight);
}

.superdoc-structured-content-inline[data-appearance='hidden'] .superdoc-empty-inline-sdt-placeholder,
.superdoc-structured-content-block[data-appearance='hidden'] .superdoc-empty-block-sdt-placeholder,
.superdoc-empty-sdt-placeholder[data-appearance='hidden'] {
  width: 0;
  min-width: 0;
  overflow: hidden;
}

.superdoc-structured-content-inline[data-appearance='hidden'] .superdoc-empty-inline-sdt-placeholder::before,
.superdoc-structured-content-block[data-appearance='hidden'] .superdoc-empty-block-sdt-placeholder::before,
.superdoc-empty-sdt-placeholder[data-appearance='hidden']::before {
  content: '';
}

/* Inline structured content label - shown when active */
.superdoc-structured-content-inline__label {
  position: absolute;
  bottom: calc(100% + 1px);
  inset-inline-start: 2px;
  transform: none;
  border-radius: 4px 4px 0 0;
  white-space: nowrap;
  z-index: 100;
}

.superdoc-structured-content-inline.ProseMirror-selectednode .superdoc-structured-content-inline__label {
  display: inline-flex;
}

.superdoc-structured-content-inline:not(.ProseMirror-selectednode):hover .superdoc-structured-content-inline__label {
  display: none;
}

/* Hidden appearance per ECMA-376 (w15:appearance val="hidden"). SDT
 * exists in the document for anchoring but is visually transparent: no
 * padding, no border, no hover background, no selected outline. The
 * alias label is not emitted into the DOM at all (see renderer.ts), so
 * there is nothing to hide from copy-paste or screen readers. */
.superdoc-structured-content-inline[data-appearance='hidden'] {
  padding: 0;
  border: none;
  border-radius: 0;
  background-color: transparent;
}
.superdoc-structured-content-inline[data-appearance='hidden']:hover {
  background-color: transparent;
  border: none;
}
.superdoc-structured-content-inline[data-appearance='hidden'].ProseMirror-selectednode {
  border-color: transparent;
  background-color: transparent;
}

/* Global content-control chrome opt-out: preserve SDT wrappers/datasets while
 * suppressing built-in visual chrome on structured-content controls. Their
 * label elements are not emitted by renderer/helpers when this class is
 * present (DOM non-emission). documentSection chrome (e.g. the locked-section
 * tooltip) is intentionally preserved and not in scope.
 *
 * Custom styling surface (SD-3322): instead of fully erasing the look, these
 * rules read --sd-content-controls-custom-* variables whose defaults reproduce
 * the empty look (0-width transparent border, no background, no radius/padding).
 * So chrome:'none' stays visually empty by default, but a consumer can paint
 * their own field/clause look by setting those variables on the painted wrapper
 * (target it via data-sdt-* attributes) - no !important, and no need to fight
 * the .ProseMirror-selectednode / .sdt-group-hover state classes, because the
 * painter reads the variables across rest, hover, and selected. The border is a
 * full shorthand (e.g. "1px solid #1355ff"); its default "0 solid transparent"
 * is identical in layout to no border. It's re-asserted in every state so the
 * box never shifts (no jitter); only the background changes on hover/selected.
 * Block controls add a -border-left override for an accent rail. */
.superdoc-cc-chrome-none .superdoc-structured-content-inline {
  padding: var(--sd-content-controls-custom-inline-padding, 0);
  border: var(--sd-content-controls-custom-inline-border, 0 solid transparent);
  border-radius: var(--sd-content-controls-custom-inline-radius, 0);
  background: var(--sd-content-controls-custom-inline-bg, none);
}
.superdoc-cc-chrome-none .superdoc-structured-content-block {
  padding: var(--sd-content-controls-custom-block-padding, 0);
  border: var(--sd-content-controls-custom-block-border, 0 solid transparent);
  border-left: var(--sd-content-controls-custom-block-border-left, var(--sd-content-controls-custom-block-border, 0 solid transparent));
  border-radius: var(--sd-content-controls-custom-block-radius, 0);
  background: var(--sd-content-controls-custom-block-bg, none);
}

.superdoc-cc-chrome-none .superdoc-structured-content-inline:hover,
.superdoc-cc-chrome-none .superdoc-structured-content-inline[data-lock-mode]:hover {
  border: var(--sd-content-controls-custom-inline-border, 0 solid transparent);
  background: var(--sd-content-controls-custom-inline-hover-bg, var(--sd-content-controls-custom-inline-bg, none));
}
.superdoc-cc-chrome-none .superdoc-structured-content-block:hover,
.superdoc-cc-chrome-none .superdoc-structured-content-block.sdt-group-hover,
.superdoc-cc-chrome-none .superdoc-structured-content-block[data-lock-mode].sdt-group-hover {
  border: var(--sd-content-controls-custom-block-border, 0 solid transparent);
  border-left: var(--sd-content-controls-custom-block-border-left, var(--sd-content-controls-custom-block-border, 0 solid transparent));
  background: var(--sd-content-controls-custom-block-hover-bg, var(--sd-content-controls-custom-block-bg, none));
}

.superdoc-cc-chrome-none .superdoc-structured-content-inline.ProseMirror-selectednode {
  border: var(--sd-content-controls-custom-inline-border, 0 solid transparent);
  background: var(--sd-content-controls-custom-inline-selected-bg, var(--sd-content-controls-custom-inline-hover-bg, var(--sd-content-controls-custom-inline-bg, none)));
}
.superdoc-cc-chrome-none .superdoc-structured-content-block.ProseMirror-selectednode {
  border: var(--sd-content-controls-custom-block-border, 0 solid transparent);
  border-left: var(--sd-content-controls-custom-block-border-left, var(--sd-content-controls-custom-block-border, 0 solid transparent));
  background: var(--sd-content-controls-custom-block-selected-bg, var(--sd-content-controls-custom-block-hover-bg, var(--sd-content-controls-custom-block-bg, none)));
}

/* Hover highlight for SDT containers.
 * Hover adds background highlight and z-index boost.
 * Block SDTs use .sdt-group-hover class (event delegation for multi-fragment coordination).
 * Inline SDTs use :hover (single element, no coordination needed).
 * Hover is suppressed when the node is selected (SD-1584).
 *
 * Inline SDTs with appearance=hidden are excluded via the same :not()
 * that handles selection. Both predicates live in one :not(a, b) so the
 * selector keeps (0,4,0) specificity. A second chained :not() would push
 * it to (0,5,0) and beat the viewing-mode suppression rule below, which
 * also sits at (0,4,0). */
.superdoc-structured-content-block[data-lock-mode].sdt-group-hover:not(.ProseMirror-selectednode),
.superdoc-structured-content-inline[data-lock-mode]:hover:not(.ProseMirror-selectednode, [data-appearance='hidden']) {
  background-color: var(--sd-content-controls-lock-hover-bg, rgba(98, 155, 231, 0.08));
  z-index: 9999999;
}

.superdoc-structured-content-block[data-lock-mode].sdt-group-hover:not(.ProseMirror-selectednode) {
  background-color: transparent;
}

.superdoc-structured-content-block[data-lock-mode].sdt-group-hover:not(.ProseMirror-selectednode)::before {
  background-color: var(--sd-content-controls-lock-hover-bg, rgba(98, 155, 231, 0.08));
}

/* Chrome opt-out for block SDTs. Main paints block chrome through ::before
 * (background) and ::after (border) pseudo-elements, which the element-level
 * .superdoc-cc-chrome-none rules above cannot reach. Suppress the pseudo
 * chrome directly, including the selected-node border and the lock-hover
 * ::before background. Declared after every chrome-showing pseudo rule so
 * source order resolves equal-specificity ties, the same way the
 * viewing-mode rules below do. */
.superdoc-cc-chrome-none .superdoc-structured-content-block::before,
.superdoc-cc-chrome-none .superdoc-structured-content-block:hover::before,
.superdoc-cc-chrome-none .superdoc-structured-content-block.sdt-group-hover::before,
.superdoc-cc-chrome-none .superdoc-structured-content-block[data-lock-mode].sdt-group-hover::before {
  background: none;
}

.superdoc-cc-chrome-none .superdoc-structured-content-block::after,
.superdoc-cc-chrome-none .superdoc-structured-content-block:hover::after,
.superdoc-cc-chrome-none .superdoc-structured-content-block.sdt-group-hover::after,
.superdoc-cc-chrome-none .superdoc-structured-content-block.ProseMirror-selectednode::after {
  border: none;
}

/* Chrome opt-out for the lock-hover affordance. The base lock-hover rules above
 * paint a built-in tint and boost z-index on hovered locked controls; under
 * chrome:'none' that would override the custom hover background and stack above
 * host-attached UI. Re-assert the custom hover background (so a locked control
 * follows --sd-content-controls-custom-*-hover-bg, defaulting to empty - no tint
 * leaks) and reset the z-index. Mirrors the base lock-hover selectors with the
 * chrome-none prefix, so the extra class wins over the base rules. Split inline
 * vs block because each reads its own hover variable. */
.superdoc-cc-chrome-none .superdoc-structured-content-inline[data-lock-mode]:hover:not(.ProseMirror-selectednode, [data-appearance='hidden']) {
  background: var(--sd-content-controls-custom-inline-hover-bg, var(--sd-content-controls-custom-inline-bg, none));
  z-index: auto;
}
.superdoc-cc-chrome-none .superdoc-structured-content-block[data-lock-mode].sdt-group-hover:not(.ProseMirror-selectednode) {
  background: var(--sd-content-controls-custom-block-hover-bg, var(--sd-content-controls-custom-block-bg, none));
  z-index: auto;
}

/* Viewing mode: remove structured content affordances */
.presentation-editor--viewing .superdoc-structured-content-block,
.presentation-editor--viewing .superdoc-structured-content-inline {
  background: none;
  border: none;
  padding: 0;
}

.presentation-editor--viewing .superdoc-structured-content-block:hover {
  background: none;
  border: none;
}

.presentation-editor--viewing .superdoc-structured-content-block::after,
.presentation-editor--viewing .superdoc-structured-content-block:hover::after,
.presentation-editor--viewing .superdoc-structured-content-block.sdt-group-hover::after,
.presentation-editor--viewing .superdoc-structured-content-block[data-lock-mode].sdt-group-hover::after {
  border: none;
}

.presentation-editor--viewing .superdoc-structured-content-block::before,
.presentation-editor--viewing .superdoc-structured-content-block:hover::before,
.presentation-editor--viewing .superdoc-structured-content-block.sdt-group-hover::before,
.presentation-editor--viewing .superdoc-structured-content-block[data-lock-mode].sdt-group-hover::before {
  background: none;
}

.presentation-editor--viewing .superdoc-structured-content-block.sdt-group-hover,
.presentation-editor--viewing .superdoc-structured-content-block[data-lock-mode].sdt-group-hover {
  background: none;
  border: none;
}

.presentation-editor--viewing .superdoc-structured-content-inline:hover {
  background: none;
  border: none;
}

.presentation-editor--viewing .superdoc-structured-content-inline[data-lock-mode]:hover {
  background: none;
  border: none;
}

.presentation-editor--viewing .superdoc-structured-content__label,
.presentation-editor--viewing .superdoc-structured-content-inline__label {
  display: none !important;
}

/* Print mode: hide visual styling for SDT containers */
@media print {
  .superdoc-document-section,
  .superdoc-structured-content-block,
  .superdoc-structured-content-inline {
    background: none;
    border: none;
    padding: 0;
  }

  .superdoc-structured-content-block::after {
    border: none;
  }

  .superdoc-structured-content-block::before {
    background: none;
  }

  .superdoc-document-section__tooltip,
  .superdoc-structured-content__label,
  .superdoc-structured-content-inline__label {
    display: none !important;
  }
}
`;
var FIELD_ANNOTATION_STYLES = `
/* Field annotation visual styles — suppress native selection artifacts.
 * Annotations are atomic inline nodes; native selection and caret look broken. */
.superdoc-layout .annotation::selection,
.superdoc-layout .annotation *::selection {
  background: transparent;
}

.superdoc-layout .annotation::-moz-selection,
.superdoc-layout .annotation *::-moz-selection  {
  background: transparent;
}

.superdoc-layout .annotation,
.superdoc-layout .annotation * {
  caret-color: transparent;
}
`;
var IMAGE_SELECTION_STYLES = `
/* Highlight for selected images (block or inline) */
.superdoc-image-selected {
  outline: 2px solid #4a90e2;
  outline-offset: 2px;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(74, 144, 226, 0.35);
}

/* Ensure inline images can be targeted */
.${DOM_CLASS_NAMES.INLINE_IMAGE}.superdoc-image-selected {
  outline-offset: 2px;
}

/* Selection on clip wrapper so outline matches the visible cropped portion, not the scaled image */
.${DOM_CLASS_NAMES.INLINE_IMAGE_CLIP_WRAPPER}.superdoc-image-selected {
  outline-offset: 2px;
}
`;
var MATH_MENCLOSE_STYLES = `
/* MathML <menclose> polyfill.
 *
 * MathML 3 defined <menclose notation="..."> with borders, strikes, and other
 * enclosure notations. MathML Core (the subset shipped in Chrome 109+, 2023)
 * dropped <menclose> — the WG moved its rendering to CSS/SVG. Firefox and
 * WebKit also do not paint it. Without this polyfill, m:borderBox content
 * imports correctly (the notation attribute is right) but renders invisibly.
 *
 * Each notation token is composable: "box horizontalstrike" draws the box
 * border and a horizontal strike together. Diagonal strikes layer through
 * CSS custom properties so X patterns (both diagonals) stack correctly.
 *
 * @spec MathML 3 §3.3.8 menclose
 */
menclose {
  display: inline-block;
  position: relative;
  padding: 0.15em 0.25em;

  --sd-menclose-stroke: currentColor;
  --sd-menclose-h: none;
  --sd-menclose-v: none;
  --sd-menclose-up: none;
  --sd-menclose-down: none;
}

menclose[notation~="box"] { border: 1px solid var(--sd-menclose-stroke); }
menclose[notation~="roundedbox"] { border: 1px solid var(--sd-menclose-stroke); border-radius: 0.3em; }
menclose[notation~="top"] { border-top: 1px solid var(--sd-menclose-stroke); }
menclose[notation~="bottom"] { border-bottom: 1px solid var(--sd-menclose-stroke); }
menclose[notation~="left"] { border-left: 1px solid var(--sd-menclose-stroke); }
menclose[notation~="right"] { border-right: 1px solid var(--sd-menclose-stroke); }

menclose[notation~="horizontalstrike"] {
  --sd-menclose-h: linear-gradient(var(--sd-menclose-stroke), var(--sd-menclose-stroke)) no-repeat center / 100% 1px;
}
menclose[notation~="verticalstrike"] {
  --sd-menclose-v: linear-gradient(var(--sd-menclose-stroke), var(--sd-menclose-stroke)) no-repeat center / 1px 100%;
}
/* Gradient direction is perpendicular to the stripe it produces.
 * "to bottom right" → stripe runs bottom-left → top-right (visually "/") = updiagonalstrike.
 * "to top right"    → stripe runs top-left → bottom-right (visually "\") = downdiagonalstrike.
 */
menclose[notation~="updiagonalstrike"] {
  --sd-menclose-up: linear-gradient(
    to bottom right,
    transparent calc(50% - 0.5px),
    var(--sd-menclose-stroke) calc(50% - 0.5px),
    var(--sd-menclose-stroke) calc(50% + 0.5px),
    transparent calc(50% + 0.5px)
  );
}
menclose[notation~="downdiagonalstrike"] {
  --sd-menclose-down: linear-gradient(
    to top right,
    transparent calc(50% - 0.5px),
    var(--sd-menclose-stroke) calc(50% - 0.5px),
    var(--sd-menclose-stroke) calc(50% + 0.5px),
    transparent calc(50% + 0.5px)
  );
}

menclose::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: var(--sd-menclose-h), var(--sd-menclose-v), var(--sd-menclose-up), var(--sd-menclose-down);
}
`;
var printStylesInjected = false;
var linkStylesInjected = false;
var trackChangeStylesInjected = false;
var formattingMarksStylesInjected = false;
var sdtContainerStylesInjected = false;
var fieldAnnotationStylesInjected = false;
var imageSelectionStylesInjected = false;
var mathMencloseStylesInjected = false;
const ensurePrintStyles = (doc$1) => {
	if (printStylesInjected || !doc$1) return;
	const styleEl = doc$1.createElement("style");
	styleEl.setAttribute("data-superdoc-print-styles", "true");
	styleEl.textContent = PRINT_STYLES;
	doc$1.head?.appendChild(styleEl);
	printStylesInjected = true;
};
const ensureLinkStyles = (doc$1) => {
	if (linkStylesInjected || !doc$1) return;
	const styleEl = doc$1.createElement("style");
	styleEl.setAttribute("data-superdoc-link-styles", "true");
	styleEl.textContent = LINK_AND_TOC_STYLES;
	doc$1.head?.appendChild(styleEl);
	linkStylesInjected = true;
};
const ensureTrackChangeStyles = (doc$1) => {
	if (trackChangeStylesInjected || !doc$1) return;
	const styleEl = doc$1.createElement("style");
	styleEl.setAttribute("data-superdoc-track-change-styles", "true");
	styleEl.textContent = TRACK_CHANGE_STYLES;
	doc$1.head?.appendChild(styleEl);
	trackChangeStylesInjected = true;
};
const ensureFormattingMarksStyles = (doc$1) => {
	if (formattingMarksStylesInjected || !doc$1) return;
	const styleEl = doc$1.createElement("style");
	styleEl.setAttribute("data-superdoc-formatting-marks-styles", "true");
	styleEl.textContent = FORMATTING_MARKS_STYLES;
	doc$1.head?.appendChild(styleEl);
	formattingMarksStylesInjected = true;
};
const ensureSdtContainerStyles = (doc$1) => {
	if (sdtContainerStylesInjected || !doc$1) return;
	const styleEl = doc$1.createElement("style");
	styleEl.setAttribute("data-superdoc-sdt-container-styles", "true");
	styleEl.textContent = SDT_CONTAINER_STYLES;
	doc$1.head?.appendChild(styleEl);
	sdtContainerStylesInjected = true;
};
const ensureFieldAnnotationStyles = (doc$1) => {
	if (fieldAnnotationStylesInjected || !doc$1) return;
	const styleEl = doc$1.createElement("style");
	styleEl.setAttribute("data-superdoc-field-annotation-styles", "true");
	styleEl.textContent = FIELD_ANNOTATION_STYLES;
	doc$1.head?.appendChild(styleEl);
	fieldAnnotationStylesInjected = true;
};
const ensureImageSelectionStyles = (doc$1) => {
	if (imageSelectionStylesInjected || !doc$1) return;
	const styleEl = doc$1.createElement("style");
	styleEl.setAttribute("data-superdoc-image-selection-styles", "true");
	styleEl.textContent = IMAGE_SELECTION_STYLES;
	doc$1.head?.appendChild(styleEl);
	imageSelectionStylesInjected = true;
};
const ensureMathMencloseStyles = (doc$1) => {
	if (mathMencloseStylesInjected || !doc$1) return;
	const styleEl = doc$1.createElement("style");
	styleEl.setAttribute("data-superdoc-math-menclose-styles", "true");
	styleEl.textContent = MATH_MENCLOSE_STYLES;
	doc$1.head?.appendChild(styleEl);
	mathMencloseStylesInjected = true;
};
function validateHexColor(color) {
	if (typeof color !== "string") return void 0;
	const trimmed = color.trim();
	if (!trimmed) return void 0;
	const withoutHash = trimmed.startsWith("#") ? trimmed.slice(1) : trimmed;
	if (!/^[0-9A-Fa-f]{3}$|^[0-9A-Fa-f]{6}$/.test(withoutHash)) return;
	return `#${withoutHash}`;
}
function addValidatedGradientStops(gradient, stops) {
	stops.forEach((stop) => {
		const position = typeof stop.position === "number" && Number.isFinite(stop.position) ? Math.max(0, Math.min(1, stop.position)) : 0;
		const validatedColor = validateHexColor(stop.color);
		if (!validatedColor) return;
		const alpha = typeof stop.alpha === "number" && Number.isFinite(stop.alpha) ? Math.max(0, Math.min(1, stop.alpha)) : 1;
		const stopElement = document.createElementNS("http://www.w3.org/2000/svg", "stop");
		stopElement.setAttribute("offset", `${position * 100}%`);
		stopElement.setAttribute("stop-color", validatedColor);
		if (alpha < 1) stopElement.setAttribute("stop-opacity", alpha.toString());
		gradient.appendChild(stopElement);
	});
}
function createGradient(gradientData, gradientId) {
	const { gradientType, stops, angle } = gradientData;
	if (!stops || stops.length === 0) return null;
	let gradient;
	if (gradientType === "linear") {
		gradient = document.createElementNS("http://www.w3.org/2000/svg", "linearGradient");
		gradient.setAttribute("id", gradientId);
		const radians = angle * Math.PI / 180;
		const x1 = 50 - 50 * Math.cos(radians);
		const y1 = 50 + 50 * Math.sin(radians);
		const x2 = 50 + 50 * Math.cos(radians);
		const y2 = 50 - 50 * Math.sin(radians);
		gradient.setAttribute("x1", `${x1}%`);
		gradient.setAttribute("y1", `${y1}%`);
		gradient.setAttribute("x2", `${x2}%`);
		gradient.setAttribute("y2", `${y2}%`);
	} else {
		gradient = document.createElementNS("http://www.w3.org/2000/svg", "radialGradient");
		gradient.setAttribute("id", gradientId);
		gradient.setAttribute("cx", "50%");
		gradient.setAttribute("cy", "50%");
		gradient.setAttribute("r", "50%");
	}
	addValidatedGradientStops(gradient, stops);
	return gradient;
}
function applyGradientToSVG(svg, gradientData) {
	try {
		const gradientId = generateGradientId("gradient");
		const gradient = createGradient(gradientData, gradientId);
		if (!gradient) return;
		let defs = svg.querySelector("defs");
		if (!defs) {
			defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
			svg.insertBefore(defs, svg.firstChild);
		}
		defs.appendChild(gradient);
		svg.querySelectorAll("[fill]:not([fill=\"none\"])").forEach((el) => {
			el.setAttribute("fill", `url(#${gradientId})`);
		});
	} catch (error) {
		console.error("Failed to apply gradient to SVG:", error);
	}
}
function applyAlphaToSVG(svg, alphaData) {
	try {
		const { color, alpha } = alphaData;
		const validatedColor = validateHexColor(color);
		if (!validatedColor) return;
		const clampedAlpha = typeof alpha === "number" && Number.isFinite(alpha) ? Math.max(0, Math.min(1, alpha)) : 1;
		svg.querySelectorAll("[fill]:not([fill=\"none\"])").forEach((el) => {
			el.setAttribute("fill", validatedColor);
			el.setAttribute("fill-opacity", clampedAlpha.toString());
		});
	} catch (error) {
		console.error("Failed to apply alpha to SVG:", error);
	}
}
var gradientIdCounter = 0;
function generateGradientId(prefix = "gradient") {
	return `${prefix}-${Date.now()}-${gradientIdCounter++}-${Math.random().toString(36).substring(2, 11)}`;
}
var clampNumber = (value, min$2, max$2) => Math.min(max$2, Math.max(min$2, value));
var mergeSortedSegments = (segments) => {
	if (segments.length <= 1) return segments;
	const merged = [];
	let current = segments[0];
	for (let i = 1; i < segments.length; i += 1) {
		const next = segments[i];
		if (next.start <= current.end) {
			current = {
				start: current.start,
				end: Math.max(current.end, next.end)
			};
			continue;
		}
		merged.push(current);
		current = next;
	}
	merged.push(current);
	return merged;
};
const applySquareWrapExclusionsToLines = (renderedLines, exclusions, contentWidthPx, alignmentOffsetY) => {
	if (renderedLines.length === 0 || exclusions.length === 0 || contentWidthPx <= 0) return;
	renderedLines.forEach((line) => {
		const paddingLeft = line.el.style.paddingLeft;
		const paddingRight = line.el.style.paddingRight;
		if (paddingLeft && paddingLeft !== "0px" || paddingRight && paddingRight !== "0px") return;
		const lineTop = line.top + alignmentOffsetY;
		const lineBottom = lineTop + line.height;
		const excludedSegments = [];
		for (const ex of exclusions) {
			if (lineBottom <= ex.top || lineTop >= ex.bottom) continue;
			if (ex.wrapText !== "bothSides") continue;
			const start$1 = clampNumber(ex.left, 0, contentWidthPx);
			const end$1 = clampNumber(ex.right, 0, contentWidthPx);
			if (end$1 <= start$1) continue;
			excludedSegments.push({
				start: start$1,
				end: end$1
			});
		}
		if (excludedSegments.length === 0) return;
		excludedSegments.sort((a, b$1) => a.start - b$1.start);
		const merged = mergeSortedSegments(excludedSegments);
		let bestStart = 0;
		let bestWidth = 0;
		let cursor = 0;
		for (const seg of merged) {
			const gapWidth = seg.start - cursor;
			if (gapWidth > bestWidth) {
				bestStart = cursor;
				bestWidth = gapWidth;
			}
			cursor = Math.max(cursor, seg.end);
		}
		const tailWidth = contentWidthPx - cursor;
		if (tailWidth > bestWidth) {
			bestStart = cursor;
			bestWidth = tailWidth;
		}
		if (bestWidth <= 0 || bestStart === 0 && bestWidth >= contentWidthPx) return;
		const marginLeft = bestStart;
		const marginRight = Math.max(0, contentWidthPx - (bestStart + bestWidth));
		line.el.style.boxSizing = "border-box";
		line.el.style.marginLeft = `${marginLeft}px`;
		line.el.style.marginRight = `${marginRight}px`;
	});
};
init_dist();
var isDevelopment = () => {
	if (typeof process$1$1 !== "undefined" && typeof process$1$1.env !== "undefined") return process$1$1.env.NODE_ENV === "development";
	return false;
};
var ValidationStatsCollector = class {
	constructor() {
		this.stats = {
			totalSpans: 0,
			validSpans: 0,
			missingPmStart: 0,
			missingPmEnd: 0,
			missingBoth: 0
		};
	}
	record(hasPmStart, hasPmEnd) {
		this.stats.totalSpans++;
		if (hasPmStart && hasPmEnd) this.stats.validSpans++;
		else if (!hasPmStart && !hasPmEnd) this.stats.missingBoth++;
		else if (!hasPmStart) this.stats.missingPmStart++;
		else this.stats.missingPmEnd++;
	}
	getStats() {
		return { ...this.stats };
	}
	reset() {
		this.stats = {
			totalSpans: 0,
			validSpans: 0,
			missingPmStart: 0,
			missingPmEnd: 0,
			missingBoth: 0
		};
	}
	getCoveragePercent() {
		if (this.stats.totalSpans === 0) return 100;
		return this.stats.validSpans / this.stats.totalSpans * 100;
	}
	logSummary() {
		if (!isDevelopment()) return;
		const coverage = this.getCoveragePercent();
		const s = this.stats;
		if (coverage < 100) console.warn("[PmPositionValidation] PM position coverage:", {
			coverage: `${coverage.toFixed(1)}%`,
			totalSpans: s.totalSpans,
			validSpans: s.validSpans,
			missingPmStart: s.missingPmStart,
			missingPmEnd: s.missingPmEnd,
			missingBoth: s.missingBoth
		});
	}
};
const globalValidationStats = new ValidationStatsCollector();
function assertPmPositions(run, context) {
	const hasPmStart = run.pmStart != null;
	const hasPmEnd = run.pmEnd != null;
	globalValidationStats.record(hasPmStart, hasPmEnd);
	if (!isDevelopment()) return;
	if (!hasPmStart || !hasPmEnd) {
		const textPreview = run.text ? run.text.substring(0, 20) + (run.text.length > 20 ? "..." : "") : "(no text)";
		console.warn(`[PmPositionValidation] Missing PM positions in ${context}:`, {
			hasPmStart,
			hasPmEnd,
			textPreview,
			fallback: "Will use PM DOM coordinates for cursor positioning"
		});
	}
}
function assertFragmentPmPositions(fragment, _context) {
	const hasPmStart = fragment.pmStart != null;
	const hasPmEnd = fragment.pmEnd != null;
	globalValidationStats.record(hasPmStart, hasPmEnd);
}
var SUPPORTED_IMAGE_CLIP_PATH_PREFIXES = [
	"inset(",
	"polygon(",
	"circle(",
	"ellipse(",
	"path(",
	"rect("
];
const readImageClipPathValue = (value) => {
	if (typeof value !== "string") return "";
	const normalized = value.trim();
	if (normalized.length === 0) return "";
	const lower = normalized.toLowerCase();
	if (!SUPPORTED_IMAGE_CLIP_PATH_PREFIXES.some((prefix) => lower.startsWith(prefix))) return "";
	return normalized;
};
function resolveClipPath(value) {
	if (typeof value !== "string") return void 0;
	const trimmed = value.trim();
	return trimmed.length > 0 ? trimmed : void 0;
}
function applyImageClipPath(el, clipPath, options) {
	const resolved = resolveClipPath(clipPath);
	if (resolved) {
		if (options?.clipContainer) options.clipContainer.style.overflow = "hidden";
		el.style.clipPath = resolved;
		const scale = parseInsetClipPathForScale(resolved);
		if (scale) {
			el.style.transformOrigin = "0 0";
			el.style.transform = `translate(${scale.translateX}%, ${scale.translateY}%) scale(${scale.scaleX}, ${scale.scaleY})`;
		}
	}
}
init_dist();
const applyRunDataAttributes = (element, dataAttrs) => {
	if (!dataAttrs) return;
	Object.entries(dataAttrs).forEach(([key, value]) => {
		if (typeof key !== "string" || !key.toLowerCase().startsWith("data-")) return;
		if (typeof value !== "string") return;
		try {
			element.setAttribute(key, value);
		} catch (error) {
			if (process$1$1.env.NODE_ENV === "development") console.warn(`[DomPainter] Failed to set data attribute "${key}":`, error);
		}
	});
};
var stableDataAttrs = (attrs) => {
	if (!attrs) return void 0;
	const keys$1 = Object.keys(attrs).sort();
	const out = {};
	keys$1.forEach((key) => {
		out[key] = attrs[key];
	});
	return out;
};
const textRunMergeSignature = (run) => JSON.stringify({
	kind: run.kind ?? "text",
	fontFamily: run.fontFamily,
	fontSize: run.fontSize,
	bold: run.bold ?? false,
	italic: run.italic ?? false,
	letterSpacing: run.letterSpacing ?? null,
	color: run.color ?? null,
	underline: run.underline ?? null,
	strike: run.strike ?? false,
	highlight: run.highlight ?? null,
	textTransform: run.textTransform ?? null,
	token: run.token ?? null,
	pageNumberFieldFormat: run.pageNumberFieldFormat ?? null,
	pageRefMetadata: run.pageRefMetadata ?? null,
	trackedChange: run.trackedChange ?? null,
	trackedChanges: run.trackedChanges ?? null,
	sdt: run.sdt ?? null,
	link: run.link ?? null,
	comments: run.comments ?? null,
	dataAttrs: stableDataAttrs(run.dataAttrs) ?? null,
	bidi: run.bidi ?? null
});
var LINK_DATASET_KEYS = {
	blocked: "linkBlocked",
	docLocation: "linkDocLocation",
	history: "linkHistory",
	rId: "linkRid",
	truncated: "linkTooltipTruncated"
};
var MAX_HREF_LENGTH = 2048;
var SAFE_ANCHOR_PATTERN = /^[A-Za-z0-9._-]+$/;
var LINK_TARGET_SET = new Set([
	"_blank",
	"_self",
	"_parent",
	"_top"
]);
var AMBIGUOUS_LINK_PATTERNS = /^(click here|read more|more|link|here|this|download|view)$/i;
const linkMetrics = {
	sanitized: 0,
	blocked: 0,
	invalidProtocol: 0,
	homographWarnings: 0,
	reset() {
		this.sanitized = 0;
		this.blocked = 0;
		this.invalidProtocol = 0;
		this.homographWarnings = 0;
	},
	getMetrics() {
		return {
			"hyperlink.sanitized.count": this.sanitized,
			"hyperlink.blocked.count": this.blocked,
			"hyperlink.invalid_protocol.count": this.invalidProtocol,
			"hyperlink.homograph_warnings.count": this.homographWarnings
		};
	}
};
function sanitizeUrl(href) {
	if (typeof href !== "string") return null;
	return sanitizeHref(href)?.href ?? null;
}
var normalizeAnchor = (value) => {
	if (typeof value !== "string") return null;
	const trimmed = value.trim();
	if (!trimmed) return null;
	const anchor = trimmed.startsWith("#") ? trimmed.slice(1) : trimmed;
	if (!SAFE_ANCHOR_PATTERN.test(anchor)) return null;
	return `#${anchor}`;
};
var isValidSafeFragment = (fragment) => {
	return SAFE_ANCHOR_PATTERN.test(fragment);
};
var encodeFragment = (fragment) => {
	try {
		return encodeURIComponent(fragment);
	} catch {
		return null;
	}
};
var appendDocLocation = (href, docLocation) => {
	if (!docLocation?.trim()) return href;
	const fragment = docLocation.trim();
	if (href?.includes("#")) return href;
	const encoded = isValidSafeFragment(fragment) ? fragment : encodeFragment(fragment);
	if (!encoded) return href;
	return href ? `${href}#${encoded}` : `#${encoded}`;
};
var buildLinkDataset = (link) => {
	const dataset = {};
	if (link.version === 2) {
		if (link.rId) dataset[LINK_DATASET_KEYS.rId] = link.rId;
		if (link.docLocation) dataset[LINK_DATASET_KEYS.docLocation] = link.docLocation;
		if (typeof link.history === "boolean") dataset[LINK_DATASET_KEYS.history] = String(link.history);
	}
	return dataset;
};
var resolveLinkTarget = (link, sanitized) => {
	if (link.target && LINK_TARGET_SET.has(link.target)) return link.target;
	if (sanitized && (sanitized.protocol === "http" || sanitized.protocol === "https")) return "_blank";
};
var resolveLinkRel = (link, target) => {
	const relValues = /* @__PURE__ */ new Set();
	if (typeof link.rel === "string" && link.rel.trim()) link.rel.trim().split(/\s+/).forEach((value) => {
		if (value) relValues.add(value);
	});
	if (target === "_blank") {
		relValues.add("noopener");
		relValues.add("noreferrer");
	}
	if (relValues.size === 0) return;
	return Array.from(relValues).join(" ");
};
const applyLinkDataset = (element, dataset) => {
	if (!dataset) return;
	Object.entries(dataset).forEach(([key, value]) => {
		if (value != null) element.dataset[key] = value;
	});
};
const buildLinkRenderData = (link) => {
	const dataset = buildLinkDataset(link);
	const sanitized = typeof link.href === "string" ? sanitizeHref(link.href) : null;
	const anchorHref = normalizeAnchor(link.anchor ?? link.name ?? "");
	let href = sanitized?.href ?? anchorHref;
	if (link.version === 2) href = appendDocLocation(href, link.docLocation ?? null);
	if (sanitized) {
		linkMetrics.sanitized++;
		if (sanitized.href && typeof link.href === "string") {
			const hostStartIndex = link.href.indexOf("://") + 3;
			let hostEndIndex = link.href.indexOf("/", hostStartIndex);
			if (hostEndIndex === -1) hostEndIndex = link.href.indexOf("?", hostStartIndex);
			if (hostEndIndex === -1) hostEndIndex = link.href.indexOf("#", hostStartIndex);
			if (hostEndIndex === -1) hostEndIndex = link.href.length;
			const rawHostname = link.href.slice(hostStartIndex, hostEndIndex);
			if (rawHostname && /[^\x00-\x7F]/.test(rawHostname)) linkMetrics.homographWarnings++;
		}
	}
	if (sanitized && sanitized.href.length > MAX_HREF_LENGTH) {
		console.warn(`[DomPainter] Rejecting URL exceeding ${MAX_HREF_LENGTH} characters`);
		linkMetrics.blocked++;
		return {
			blocked: true,
			dataset: { [LINK_DATASET_KEYS.blocked]: "true" }
		};
	}
	if (!href) {
		if (typeof link.href === "string" && link.href.trim()) {
			dataset[LINK_DATASET_KEYS.blocked] = "true";
			console.warn(`[DomPainter] Blocked potentially unsafe URL: ${link.href.slice(0, 50)}`);
			linkMetrics.blocked++;
			if (!sanitized) linkMetrics.invalidProtocol++;
			return {
				blocked: true,
				dataset
			};
		}
		const hadAnchor = (link.anchor ?? link.name ?? null) != null;
		if (Object.keys(dataset).length > 0 || hadAnchor) {
			dataset[LINK_DATASET_KEYS.blocked] = "true";
			linkMetrics.blocked++;
			return {
				blocked: true,
				dataset
			};
		}
		return null;
	}
	const target = resolveLinkTarget(link, sanitized);
	const rel = resolveLinkRel(link, target);
	const tooltipSource = link.version === 2 ? link.tooltip ?? link.title : link.title;
	const tooltipResult = tooltipSource ? encodeTooltip(tooltipSource) : null;
	const tooltip = tooltipResult?.text ?? null;
	if (tooltipResult?.wasTruncated) dataset[LINK_DATASET_KEYS.truncated] = "true";
	return {
		href,
		target,
		rel,
		tooltip,
		dataset: Object.keys(dataset).length > 0 ? dataset : void 0,
		blocked: false
	};
};
const applyTooltipAccessibility = (elem, tooltip, context) => {
	const linkId = context.getNextLinkId();
	elem.id = linkId;
	if (!tooltip) return linkId;
	elem.setAttribute("title", tooltip);
	const descId = `link-desc-${linkId}`;
	const descElem = context.doc.createElement("span");
	descElem.id = descId;
	descElem.className = "superdoc-sr-only";
	descElem.textContent = tooltip;
	if (elem.parentElement) {
		elem.parentElement.appendChild(descElem);
		elem.setAttribute("aria-describedby", descId);
	} else console.warn("[DomPainter] Unable to add aria-describedby for tooltip (element not in DOM)");
	return linkId;
};
const enhanceAccessibility = (elem, linkData, textContent$1) => {
	if (!linkData.href) return;
	const trimmedText = textContent$1.trim().toLowerCase();
	if (AMBIGUOUS_LINK_PATTERNS.test(trimmedText)) try {
		const hostname = new URL(linkData.href).hostname.replace(/^www\./, "");
		const ariaLabel = `${textContent$1.trim()} - ${hostname}`;
		elem.setAttribute("aria-label", ariaLabel);
		return;
	} catch {
		elem.setAttribute("aria-label", `${textContent$1.trim()} - external link`);
		return;
	}
	if (linkData.target === "_blank" && !elem.getAttribute("aria-label")) elem.setAttribute("aria-label", `${textContent$1.trim()} (opens in new tab)`);
};
const applyLinkAttributes = (elem, linkData) => {
	if (!linkData.href) return;
	elem.href = linkData.href;
	elem.classList.add("superdoc-link");
	if (linkData.target) elem.target = linkData.target;
	else elem.removeAttribute("target");
	if (linkData.rel) elem.rel = linkData.rel;
	else elem.removeAttribute("rel");
	if (linkData.tooltip) elem.title = linkData.tooltip;
	else elem.removeAttribute("title");
	elem.setAttribute("role", "link");
	elem.setAttribute("tabindex", "0");
};
var MAX_RESIZE_MULTIPLIER = 3;
var FALLBACK_MAX_DIMENSION = 1e3;
var MIN_IMAGE_DIMENSION = 20;
var clampLumUnit = (value) => {
	return Math.max(-1e5, Math.min(1e5, value));
};
var parseVmlFixedFraction = (value) => {
	if (typeof value === "number" && Number.isFinite(value)) return value;
	if (typeof value !== "string" || value.length === 0) return null;
	if (value.endsWith("f")) {
		const raw = Number.parseInt(value.slice(0, -1), 10);
		return Number.isFinite(raw) ? raw / 65536 : null;
	}
	const parsed = Number.parseFloat(value);
	return Number.isFinite(parsed) ? parsed : null;
};
const buildImageFilters = (source) => {
	const filters = [];
	if (source.grayscale) filters.push("grayscale(100%)");
	if (source.gain != null || source.blacklevel != null) {
		const gain = parseVmlFixedFraction(source.gain);
		const blacklevel = parseVmlFixedFraction(source.blacklevel);
		if (gain != null) {
			const contrast = Math.max(0, gain);
			if (contrast > 0) filters.push(`contrast(${contrast})`);
		}
		if (blacklevel != null) {
			const brightness = Math.max(0, 1 + blacklevel * (65536 / 32767));
			if (brightness > 0) filters.push(`brightness(${brightness})`);
		}
	}
	if (source.lum) {
		const contrastValue = typeof source.lum.contrast === "number" ? clampLumUnit(source.lum.contrast) : null;
		const brightValue = typeof source.lum.bright === "number" ? clampLumUnit(source.lum.bright) : null;
		if (contrastValue != null) {
			const contrast = Math.max(0, 1 + contrastValue / 1e5);
			if (contrast >= 0) filters.push(`contrast(${contrast})`);
		}
		if (brightValue != null) {
			const brightness = Math.max(0, 1 + brightValue / 1e5);
			if (brightness >= 0) filters.push(`brightness(${brightness})`);
		}
	}
	return filters;
};
const resolveImageOpacity = (source) => {
	const amt = source.alphaModFix?.amt;
	if (typeof amt !== "number" || !Number.isFinite(amt)) return null;
	const opacity = Math.max(0, Math.min(1e5, amt)) / 1e5;
	return opacity === 1 ? null : String(opacity);
};
const renderImageRun = (run, context) => {
	if (!run.src) return null;
	const hasClipPath = typeof run.clipPath === "string" && run.clipPath.trim().length > 0;
	const img = context.doc.createElement("img");
	img.classList.add(DOM_CLASS_NAMES.INLINE_IMAGE);
	if (typeof run.src === "string" && run.src.startsWith("data:")) {
		if (!isValidImageDataUrl(run.src)) return null;
		img.src = run.src;
	} else {
		const sanitized = sanitizeUrl(run.src);
		if (sanitized) img.src = sanitized;
		else return null;
	}
	if (!hasClipPath) {
		img.width = run.width;
		img.height = run.height;
	} else Object.assign(img.style, {
		width: "100%",
		height: "100%",
		maxWidth: "100%",
		maxHeight: "100%",
		boxSizing: "border-box",
		minWidth: "0",
		minHeight: "0"
	});
	applyImageClipPath(img, run.clipPath);
	if (run.width > 0 && run.height > 0) {
		const aspectRatio = run.width / run.height;
		const inlineImageMetadata = {
			originalWidth: run.width,
			originalHeight: run.height,
			maxWidth: Math.max(run.width * MAX_RESIZE_MULTIPLIER, FALLBACK_MAX_DIMENSION),
			maxHeight: Math.max(run.height * MAX_RESIZE_MULTIPLIER, FALLBACK_MAX_DIMENSION),
			aspectRatio,
			minWidth: MIN_IMAGE_DIMENSION,
			minHeight: MIN_IMAGE_DIMENSION
		};
		img.setAttribute("data-image-metadata", JSON.stringify(inlineImageMetadata));
	}
	img.alt = run.alt ?? "";
	if (run.title) img.title = run.title;
	img.style.display = "inline-block";
	const useWrapper = hasClipPath && run.width > 0 && run.height > 0;
	if (!useWrapper) {
		img.style.verticalAlign = run.verticalAlign ?? "top";
		if (run.distTop) img.style.marginTop = `${run.distTop}px`;
		if (run.distBottom) img.style.marginBottom = `${run.distBottom}px`;
		if (run.distLeft) img.style.marginLeft = `${run.distLeft}px`;
		if (run.distRight) img.style.marginRight = `${run.distRight}px`;
		img.style.position = "relative";
		img.style.zIndex = "1";
		img.style.maxWidth = "100%";
	}
	const transforms = [];
	if (run.rotation != null && run.rotation !== 0) {
		const angleRad = run.rotation * Math.PI / 180;
		const w = run.width;
		const h$2 = run.height;
		const cosA = Math.cos(angleRad);
		const sinA = Math.sin(angleRad);
		const newTopLeftX = w / 2 * (1 - cosA) + h$2 / 2 * sinA;
		const newTopLeftY = w / 2 * sinA + h$2 / 2 * (1 - cosA);
		transforms.push(`translate(${-newTopLeftX}px, ${-newTopLeftY}px)`);
		transforms.push(`rotate(${run.rotation}deg)`);
	}
	if (run.flipH) transforms.push("scaleX(-1)");
	if (run.flipV) transforms.push("scaleY(-1)");
	if (transforms.length > 0) {
		img.style.transform = transforms.join(" ");
		img.style.transformOrigin = "center";
	}
	const filters = buildImageFilters(run);
	if (filters.length > 0) img.style.filter = filters.join(" ");
	const opacity = resolveImageOpacity(run);
	if (opacity != null) img.style.opacity = opacity;
	assertPmPositions(run, "inline image run");
	if (useWrapper) {
		const wrapper = context.doc.createElement("span");
		wrapper.classList.add(DOM_CLASS_NAMES.INLINE_IMAGE_CLIP_WRAPPER);
		wrapper.style.display = "inline-block";
		wrapper.style.width = `${run.width}px`;
		wrapper.style.height = `${run.height}px`;
		wrapper.style.boxSizing = "border-box";
		wrapper.style.overflow = "hidden";
		wrapper.style.verticalAlign = run.verticalAlign ?? "top";
		if (run.distTop) wrapper.style.marginTop = `${run.distTop}px`;
		if (run.distBottom) wrapper.style.marginBottom = `${run.distBottom}px`;
		if (run.distLeft) wrapper.style.marginLeft = `${run.distLeft}px`;
		if (run.distRight) wrapper.style.marginRight = `${run.distRight}px`;
		wrapper.style.position = "relative";
		wrapper.style.zIndex = "1";
		if (run.pmStart != null) wrapper.dataset.pmStart = String(run.pmStart);
		if (run.pmEnd != null) wrapper.dataset.pmEnd = String(run.pmEnd);
		wrapper.dataset.layoutEpoch = String(context.layoutEpoch);
		context.applySdtDataset(wrapper, run.sdt);
		if (run.dataAttrs) applyRunDataAttributes(wrapper, run.dataAttrs);
		wrapper.appendChild(img);
		return context.buildImageHyperlinkAnchor(wrapper, run.hyperlink, "inline-block");
	}
	if (run.pmStart != null) img.dataset.pmStart = String(run.pmStart);
	if (run.pmEnd != null) img.dataset.pmEnd = String(run.pmEnd);
	img.dataset.layoutEpoch = String(context.layoutEpoch);
	context.applySdtDataset(img, run.sdt);
	if (run.dataAttrs) applyRunDataAttributes(img, run.dataAttrs);
	const runClipPath = readImageClipPathValue(run.clipPath);
	if (runClipPath) {
		img.style.clipPath = runClipPath;
		img.style.display = "block";
		img.style.marginTop = "";
		img.style.marginBottom = "";
		img.style.marginLeft = "";
		img.style.marginRight = "";
		img.style.verticalAlign = "";
		img.style.position = "static";
		img.style.zIndex = "";
		const wrapper = context.doc.createElement("span");
		wrapper.classList.add("superdoc-inline-image-clip-wrapper");
		wrapper.style.display = "inline-block";
		wrapper.style.width = `${run.width}px`;
		wrapper.style.height = `${run.height}px`;
		wrapper.style.verticalAlign = run.verticalAlign ?? "top";
		wrapper.style.position = "relative";
		wrapper.style.zIndex = "1";
		if (run.distTop) wrapper.style.marginTop = `${run.distTop}px`;
		if (run.distBottom) wrapper.style.marginBottom = `${run.distBottom}px`;
		if (run.distLeft) wrapper.style.marginLeft = `${run.distLeft}px`;
		if (run.distRight) wrapper.style.marginRight = `${run.distRight}px`;
		if (run.pmStart != null) wrapper.dataset.pmStart = String(run.pmStart);
		if (run.pmEnd != null) wrapper.dataset.pmEnd = String(run.pmEnd);
		wrapper.dataset.layoutEpoch = String(context.layoutEpoch);
		context.applySdtDataset(wrapper, run.sdt);
		wrapper.appendChild(img);
		return context.buildImageHyperlinkAnchor(wrapper, run.hyperlink, "inline-block");
	}
	return context.buildImageHyperlinkAnchor(img, run.hyperlink, "inline-block");
};
var resolveClipPathFromAttrs$1 = (attrs) => {
	if (!attrs || typeof attrs !== "object") return "";
	return readImageClipPathValue(attrs.clipPath);
};
const resolveBlockImageClipPath = (block) => {
	if (!block || typeof block !== "object") return "";
	const record = block;
	return readImageClipPathValue(record.clipPath) || resolveClipPathFromAttrs$1(record.attrs);
};
const createBlockImageContent = ({ doc: doc$1, block, className, clipContainer, imageDisplay, hyperlinkDisplay = "block", buildImageHyperlinkAnchor: buildImageHyperlinkAnchor$1 }) => {
	const img = doc$1.createElement("img");
	if (className) img.classList.add(className);
	if (block.src) img.src = block.src;
	img.alt = block.alt ?? "";
	img.style.width = "100%";
	img.style.height = "100%";
	img.style.objectFit = block.objectFit ?? "contain";
	if (block.objectFit === "cover") img.style.objectPosition = "left top";
	applyImageClipPath(img, resolveBlockImageClipPath(block), clipContainer ? { clipContainer } : void 0);
	img.style.display = imageDisplay ?? (block.display === "inline" ? "inline-block" : "block");
	const filters = buildImageFilters(block);
	if (filters.length > 0) img.style.filter = filters.join(" ");
	const opacity = resolveImageOpacity(block);
	if (opacity != null) img.style.opacity = opacity;
	return buildImageHyperlinkAnchor$1?.(img, block.hyperlink, hyperlinkDisplay) ?? img;
};
const buildImageHyperlinkAnchor = (doc$1, imageEl, hyperlink, display) => {
	if (!hyperlink?.url) return imageEl;
	const sanitized = sanitizeHref(hyperlink.url);
	if (!sanitized?.href) return imageEl;
	const anchor = doc$1.createElement("a");
	anchor.href = sanitized.href;
	anchor.classList.add("superdoc-link");
	if (sanitized.protocol === "http" || sanitized.protocol === "https") {
		anchor.target = "_blank";
		anchor.rel = "noopener noreferrer";
	}
	const tooltipResult = encodeTooltip(typeof hyperlink.tooltip === "string" && hyperlink.tooltip.trim().length > 0 ? hyperlink.tooltip : hyperlink.url);
	if (tooltipResult?.text) anchor.title = tooltipResult.text;
	for (const titledElement of [imageEl, ...Array.from(imageEl.querySelectorAll("[title]"))]) titledElement.removeAttribute("title");
	anchor.setAttribute("role", "link");
	anchor.setAttribute("tabindex", "0");
	if (display === "block") anchor.style.cssText = "display: block; width: 100%; height: 100%; cursor: pointer;";
	else {
		anchor.style.display = "inline-block";
		anchor.style.lineHeight = "0";
		anchor.style.cursor = "pointer";
		anchor.style.verticalAlign = imageEl.style.verticalAlign || "bottom";
	}
	anchor.appendChild(imageEl);
	return anchor;
};
function isStructuredContentMetadata(sdt) {
	return sdt !== null && sdt !== void 0 && typeof sdt === "object" && "type" in sdt && sdt.type === "structuredContent";
}
function isDocumentSectionMetadata(sdt) {
	return sdt !== null && sdt !== void 0 && typeof sdt === "object" && "type" in sdt && sdt.type === "documentSection";
}
function getSdtContainerConfig(sdt) {
	if (isDocumentSectionMetadata(sdt)) return {
		className: "superdoc-document-section",
		labelText: sdt.title ?? "Document section",
		labelClassName: "superdoc-document-section__tooltip",
		isStart: true,
		isEnd: true
	};
	if (isStructuredContentMetadata(sdt) && sdt.scope === "block") return {
		className: "superdoc-structured-content-block",
		labelText: sdt.alias ?? "Structured content",
		labelClassName: `${DOM_CLASS_NAMES.BLOCK_SDT_LABEL} superdoc-structured-content-block__label`,
		isStart: true,
		isEnd: true
	};
	return null;
}
function shouldRenderSdtContainerChrome(sdt, containerSdt, options) {
	const metadata = getSdtContainerMetadata(sdt, containerSdt);
	if (!metadata) return false;
	if (isStructuredContentMetadata(metadata) && metadata.appearance === "hidden") return false;
	const containerKey = getSdtContainerKey(sdt, containerSdt);
	const ancestorKeys = [options?.ancestorContainerKey, ...options?.ancestorContainerKeys ?? []];
	if (containerKey && ancestorKeys.includes(containerKey)) return false;
	if ([options?.ancestorContainerSdt, ...options?.ancestorContainerSdts ?? []].includes(metadata)) return false;
	return true;
}
function getSdtSiblingBoundaries(containerKeys) {
	return containerKeys.map((key, index) => {
		if (!key) return void 0;
		const prev = index > 0 ? containerKeys[index - 1] : null;
		const next = index < containerKeys.length - 1 ? containerKeys[index + 1] : null;
		return {
			isStart: key !== prev,
			isEnd: key !== next
		};
	});
}
function applySdtContainerChrome(doc$1, container, sdt, containerSdt, boundaryOptions, options, chrome) {
	if (!shouldRenderSdtContainerChrome(sdt, containerSdt, options)) return false;
	const metadata = getSdtContainerMetadata(sdt, containerSdt);
	const config = getSdtContainerConfig(metadata);
	if (!config) return false;
	const isStart = boundaryOptions?.isStart ?? config.isStart;
	const isEnd = boundaryOptions?.isEnd ?? config.isEnd;
	container.classList.add(config.className);
	container.dataset.sdtContainerStart = String(isStart);
	container.dataset.sdtContainerEnd = String(isEnd);
	container.style.overflow = "visible";
	if (isStructuredContentMetadata(metadata)) container.dataset.lockMode = metadata.lockMode || "unlocked";
	if (boundaryOptions?.widthOverride != null) container.style.width = `${boundaryOptions.widthOverride}px`;
	if (boundaryOptions?.paddingBottomOverride != null && boundaryOptions.paddingBottomOverride > 0) {
		container.style.paddingBottom = `${boundaryOptions.paddingBottomOverride}px`;
		container.style.setProperty("--sd-sdt-chrome-bottom-extension", `${boundaryOptions.paddingBottomOverride}px`);
	}
	if (boundaryOptions?.showLabel ?? isStart) {
		if (chrome === "none" && isStructuredContentMetadata(metadata)) return true;
		const labelEl = doc$1.createElement("div");
		labelEl.className = config.labelClassName;
		const labelText = doc$1.createElement("span");
		labelText.textContent = config.labelText;
		labelEl.appendChild(labelText);
		container.appendChild(labelEl);
	}
	return true;
}
function shouldRebuildForSdtBoundary(element, boundary) {
	if (!boundary) return element.dataset.sdtContainerStart !== void 0;
	const startAttr = element.dataset.sdtContainerStart;
	const endAttr = element.dataset.sdtContainerEnd;
	const expectedStart = String(boundary.isStart ?? true);
	const expectedEnd = String(boundary.isEnd ?? true);
	if (startAttr === void 0 || endAttr === void 0) return true;
	return startAttr !== expectedStart || endAttr !== expectedEnd;
}
var normalizeSpan = (span) => {
	if (typeof span !== "number" || !Number.isFinite(span) || span < 1) return 1;
	return Math.floor(span);
};
var clampStartIndex = (index, totalCount) => {
	if (totalCount <= 0) return 0;
	return Math.min(Math.max(0, index), totalCount - 1);
};
var getExclusiveEndIndex = (startIndex, span, totalCount) => {
	if (totalCount <= 0) return 0;
	return Math.min(startIndex + span, totalCount);
};
const getTableCellGridBounds = (position) => {
	const normalizedRowSpan = normalizeSpan(position.rowSpan);
	const normalizedColSpan = normalizeSpan(position.colSpan);
	const startRow = clampStartIndex(position.rowIndex, position.totalRows);
	const startCol = clampStartIndex(position.gridColumnStart, position.totalCols);
	const endRowExclusive = getExclusiveEndIndex(startRow, normalizedRowSpan, position.totalRows);
	const endColExclusive = getExclusiveEndIndex(startCol, normalizedColSpan, position.totalCols);
	const hasRows = position.totalRows > 0;
	const hasCols = position.totalCols > 0;
	return {
		startRow,
		endRowExclusive,
		startCol,
		endColExclusive,
		touchesTopEdge: hasRows && startRow === 0,
		touchesBottomEdge: hasRows && endRowExclusive === position.totalRows,
		touchesLeftEdge: hasCols && startCol === 0,
		touchesRightEdge: hasCols && endColExclusive === position.totalCols
	};
};
var ALLOWED_BORDER_STYLES = new Set([
	"none",
	"single",
	"double",
	"dashed",
	"dotted",
	"thick",
	"triple",
	"dotDash",
	"dotDotDash",
	"wave",
	"doubleWave"
]);
var borderStyleToCSS = (style) => {
	if (!style || style === "none") return "none";
	if (!ALLOWED_BORDER_STYLES.has(style)) {
		console.warn(`Invalid border style: ${style}, using 'solid' fallback`);
		return "solid";
	}
	return {
		none: "none",
		single: "solid",
		double: "double",
		dashed: "dashed",
		dotted: "dotted",
		thick: "solid",
		triple: "solid",
		dotDash: "dashed",
		dotDotDash: "dashed",
		wave: "solid",
		doubleWave: "solid"
	}[style];
};
var isValidHexColor = (color) => /^#[0-9A-Fa-f]{6}$/.test(color);
const applyBorder = (element, side, border) => {
	if (!border) return;
	if (border.style === "none" || border.width === 0) {
		element.style[`border${side}`] = "none";
		return;
	}
	const style = borderStyleToCSS(border.style);
	const width = border.width ?? 1;
	const color = border.color ?? "#000000";
	const safeColor = isValidHexColor(color) ? color : "#000000";
	const actualWidth = border.style === "thick" ? Math.max(width * 2, 3) : width;
	element.style[`border${side}`] = `${actualWidth}px ${style} ${safeColor}`;
};
const applyCellBorders = (element, borders) => {
	if (!borders) return;
	applyBorder(element, "Top", borders.top);
	applyBorder(element, "Right", borders.right);
	applyBorder(element, "Bottom", borders.bottom);
	applyBorder(element, "Left", borders.left);
};
const borderValueToSpec = (value) => {
	if (!value) return void 0;
	if (typeof value === "object" && "none" in value && value.none) return {
		style: "none",
		width: 0
	};
	if (typeof value === "object") {
		const raw = value;
		const width = typeof raw.width === "number" ? raw.width : typeof raw.size === "number" ? raw.size : void 0;
		const color = typeof raw.color === "string" ? raw.color : void 0;
		const space = typeof raw.space === "number" ? raw.space : void 0;
		const spec = { style: raw.style ?? "single" };
		if (width != null) spec.width = width;
		if (color) spec.color = color;
		if (space != null) spec.space = space;
		return spec;
	}
};
const resolveTableBorderValue = (explicit, fallback) => {
	const explicitSpec = borderValueToSpec(explicit);
	if (explicitSpec) return explicitSpec;
	return borderValueToSpec(fallback);
};
var BORDER_STYLE_NUMBER = {
	single: 1,
	thick: 2,
	double: 3,
	dotted: 4,
	dashed: 5,
	dotDash: 6,
	dotDotDash: 7,
	triple: 8,
	wave: 18,
	doubleWave: 19
};
var BORDER_STYLE_LINES = {
	single: 1,
	thick: 1,
	double: 2,
	dotted: 1,
	dashed: 1,
	dotDash: 1,
	dotDotDash: 1,
	triple: 3,
	wave: 1,
	doubleWave: 2
};
const isPresentBorder = (b$1) => !!b$1 && b$1.style !== void 0 && b$1.style !== "none" && (b$1.width === void 0 || b$1.width > 0);
const isExplicitNoneBorder = (b$1) => {
	if (!b$1 || typeof b$1 !== "object") return false;
	const r$1 = b$1;
	return r$1.style === "none" || r$1.none === true;
};
var borderWeight = (b$1) => (BORDER_STYLE_LINES[b$1.style] ?? 1) * (BORDER_STYLE_NUMBER[b$1.style] ?? 1);
var colorBrightness = (color, formula) => {
	const hex = (color ?? "#000000").replace("#", "");
	if (hex.length < 6) return 0;
	return formula(parseInt(hex.slice(0, 2), 16), parseInt(hex.slice(2, 4), 16), parseInt(hex.slice(4, 6), 16));
};
const resolveBorderConflict = (a, b$1) => {
	const pa = isPresentBorder(a);
	const pb = isPresentBorder(b$1);
	if (!pa && !pb) return void 0;
	if (!pa) return b$1;
	if (!pb) return a;
	const wa = borderWeight(a);
	const wb = borderWeight(b$1);
	if (wa !== wb) return wa > wb ? a : b$1;
	const na = BORDER_STYLE_NUMBER[a.style] ?? 99;
	const nb = BORDER_STYLE_NUMBER[b$1.style] ?? 99;
	if (na !== nb) return na < nb ? a : b$1;
	const formulas = [
		(r$1, g$1, bl) => r$1 + bl + 2 * g$1,
		(_r, g$1, bl) => bl + 2 * g$1,
		(_r, g$1) => g$1
	];
	for (const f of formulas) {
		const ba = colorBrightness(a.color, f);
		const bb = colorBrightness(b$1.color, f);
		if (ba !== bb) return ba < bb ? a : b$1;
	}
	return a;
};
const hasExplicitCellBorders = (cellBorders) => Boolean(cellBorders && (cellBorders.top !== void 0 || cellBorders.right !== void 0 || cellBorders.bottom !== void 0 || cellBorders.left !== void 0));
const resolveTableCellBorders = (tableBorders, cellPosition) => {
	const cellBounds = getTableCellGridBounds(cellPosition);
	return {
		top: borderValueToSpec(cellBounds.touchesTopEdge ? tableBorders?.top : tableBorders?.insideH),
		bottom: borderValueToSpec(cellBounds.touchesBottomEdge ? tableBorders?.bottom : null),
		left: borderValueToSpec(cellBounds.touchesLeftEdge ? tableBorders?.left : tableBorders?.insideV),
		right: borderValueToSpec(cellBounds.touchesRightEdge ? tableBorders?.right : null)
	};
};
const swapCellBordersLR = (borders) => {
	if (!borders) return void 0;
	return {
		...borders,
		left: borders.right,
		right: borders.left
	};
};
var getFiniteNumber = (value) => {
	if (typeof value !== "number" || !Number.isFinite(value)) return;
	return value;
};
var getNonNegativeFiniteNumber = (value) => {
	const numericValue = getFiniteNumber(value);
	if (numericValue == null || numericValue < 0) return;
	return numericValue;
};
var getMarkerTextWidthPx = (marker, measureMarkerText) => {
	const glyphWidthPx = getNonNegativeFiniteNumber(marker.glyphWidthPx);
	if (glyphWidthPx != null) return glyphWidthPx;
	if (marker.markerText) {
		const safeMeasuredWidthPx = getNonNegativeFiniteNumber(measureMarkerText(marker.markerText, marker));
		if (safeMeasuredWidthPx != null) return safeMeasuredWidthPx;
	}
	return getNonNegativeFiniteNumber(marker.markerBoxWidthPx) ?? 0;
};
var getMarkerBoxWidthPx = (marker, markerTextWidthPx) => Math.max(getNonNegativeFiniteNumber(marker.markerBoxWidthPx) ?? 0, markerTextWidthPx);
var getExplicitFirstLineMarkerStartPx = (wordLayout, marker) => {
	if (wordLayout?.firstLineIndentMode !== true) return;
	return getFiniteNumber(marker.markerX);
};
var getMarkerAnchorPx = (indentLeft, firstLine, hanging) => indentLeft - hanging + firstLine;
var getMarkerStartPx = (anchorPx, justification, markerTextWidthPx) => {
	if (justification === "right") return anchorPx - markerTextWidthPx;
	if (justification === "center") return anchorPx - markerTextWidthPx / 2;
	return anchorPx;
};
var getNextExplicitTabStopPx = (tabsPx, currentPosPx) => {
	if (!Array.isArray(tabsPx)) return;
	for (const tabPx of tabsPx) if (typeof tabPx === "number" && Number.isFinite(tabPx) && tabPx > currentPosPx) return tabPx;
};
var getFirstLineTextStartTargetPx = (wordLayout, marker) => {
	return getFiniteNumber(marker.textStartX) ?? getFiniteNumber(wordLayout?.textStartPx);
};
var getNextDefaultTabStopPx = (currentPosPx) => {
	const remainderPx = currentPosPx % 48;
	if (remainderPx === 0) return currentPosPx + 48;
	return currentPosPx + 48 - remainderPx;
};
var getMinimumReadableTextStartPx = (markerContentEndPx, gutterWidthPx) => markerContentEndPx + gutterWidthPx;
var resolveExplicitStandardTextStartPx = (explicitTextStartPx, markerContentEndPx, gutterWidthPx) => {
	if (explicitTextStartPx == null) return;
	if (explicitTextStartPx > markerContentEndPx) return explicitTextStartPx;
	if (explicitTextStartPx > 0) {
		const nextTabStopPx = getNextDefaultTabStopPx(markerContentEndPx);
		const minReadablePx = getMinimumReadableTextStartPx(markerContentEndPx, gutterWidthPx);
		return Math.max(nextTabStopPx, minReadablePx);
	}
};
function resolveListMarkerGeometry(wordLayout, indentLeft, firstLine, hanging, measureMarkerText) {
	const marker = wordLayout?.marker;
	if (!marker) return;
	const markerTextWidthPx = getMarkerTextWidthPx(marker, measureMarkerText);
	const markerBoxWidthPx = getMarkerBoxWidthPx(marker, markerTextWidthPx);
	const justification = marker.justification ?? "left";
	const explicitFirstLineMarkerStartPx = getExplicitFirstLineMarkerStartPx(wordLayout, marker);
	const anchorPx = getMarkerAnchorPx(indentLeft, firstLine, hanging);
	const markerStartPx = explicitFirstLineMarkerStartPx ?? getMarkerStartPx(anchorPx, justification, markerTextWidthPx);
	const markerContentEndPx = markerStartPx + markerTextWidthPx;
	const suffix = marker.suffix ?? "tab";
	if (suffix === "nothing") return {
		markerStartPx,
		markerTextWidthPx,
		textStartPx: markerContentEndPx,
		suffixWidthPx: 0
	};
	if (suffix === "space") return {
		markerStartPx,
		markerTextWidthPx,
		textStartPx: markerContentEndPx + 4,
		suffixWidthPx: 4
	};
	if (justification !== "left") {
		const gutterWidthPx$1 = Math.max(getNonNegativeFiniteNumber(marker.gutterWidthPx) ?? 0, 8);
		return {
			markerStartPx,
			markerTextWidthPx,
			textStartPx: markerContentEndPx + gutterWidthPx$1,
			suffixWidthPx: gutterWidthPx$1
		};
	}
	if (wordLayout?.firstLineIndentMode === true) {
		const explicitTabStopPx = getNextExplicitTabStopPx(wordLayout.tabsPx, markerContentEndPx);
		const textStartTargetPx = getFirstLineTextStartTargetPx(wordLayout, marker);
		let textStartPx$1;
		if (explicitTabStopPx != null) textStartPx$1 = explicitTabStopPx;
		else if (textStartTargetPx != null && textStartTargetPx > markerContentEndPx) textStartPx$1 = textStartTargetPx;
		else textStartPx$1 = markerContentEndPx + 8;
		if (textStartPx$1 - markerContentEndPx < 8) textStartPx$1 = markerContentEndPx + 8;
		return {
			markerStartPx,
			markerTextWidthPx,
			textStartPx: textStartPx$1,
			suffixWidthPx: textStartPx$1 - markerContentEndPx
		};
	}
	const gutterWidthPx = Math.max(getNonNegativeFiniteNumber(marker.gutterWidthPx) ?? 0, 8);
	const explicitTextStartPx = resolveExplicitStandardTextStartPx(getFiniteNumber(wordLayout?.textStartPx), markerContentEndPx, gutterWidthPx);
	if (explicitTextStartPx != null) return {
		markerStartPx,
		markerTextWidthPx,
		textStartPx: explicitTextStartPx,
		suffixWidthPx: explicitTextStartPx - markerContentEndPx
	};
	const markerBoxEndPx = markerStartPx + markerBoxWidthPx;
	let textStartPx = indentLeft + firstLine;
	if (textStartPx <= markerBoxEndPx) textStartPx = getNextDefaultTabStopPx(markerBoxEndPx);
	return {
		markerStartPx,
		markerTextWidthPx,
		textStartPx,
		suffixWidthPx: textStartPx - markerContentEndPx
	};
}
function resolveListTextStartPx(wordLayout, indentLeft, firstLine, hanging, measureMarkerText) {
	const geometry = resolveListMarkerGeometry(wordLayout, indentLeft, firstLine, hanging, measureMarkerText);
	if (geometry) return geometry.textStartPx;
	if (wordLayout?.firstLineIndentMode === true) return getFiniteNumber(wordLayout.textStartPx);
}
function isMinimalWordLayout(value) {
	if (typeof value !== "object" || value === null) return false;
	const obj = value;
	if (obj.marker !== void 0) {
		if (typeof obj.marker !== "object" || obj.marker === null) return false;
		const marker = obj.marker;
		if (marker.markerText !== void 0 && typeof marker.markerText !== "string") return false;
		if (marker.markerX !== void 0 && typeof marker.markerX !== "number") return false;
		if (marker.textStartX !== void 0 && typeof marker.textStartX !== "number") return false;
	}
	if (obj.indentLeftPx !== void 0) {
		if (typeof obj.indentLeftPx !== "number") return false;
	}
	if (obj.firstLineIndentMode !== void 0) {
		if (typeof obj.firstLineIndentMode !== "boolean") return false;
	}
	if (obj.textStartPx !== void 0) {
		if (typeof obj.textStartPx !== "number") return false;
	}
	if (obj.tabsPx !== void 0) {
		if (!Array.isArray(obj.tabsPx)) return false;
		for (const tab of obj.tabsPx) if (typeof tab !== "number") return false;
	}
	return true;
}
function resolveMarkerIndent(indent, isRtl) {
	const left$1 = indent?.left ?? 0;
	const right$1 = indent?.right ?? 0;
	return {
		anchorIndentPx: isRtl ? right$1 : left$1,
		firstLinePx: isRtl ? -(indent?.firstLine ?? 0) : indent?.firstLine ?? 0,
		hangingPx: isRtl ? -(indent?.hanging ?? 0) : indent?.hanging ?? 0
	};
}
function computeTabWidth(currentPos, justification, tabs, hangingIndent, firstLineIndent, leftIndent) {
	const nextDefaultTabStop = currentPos + 48 - currentPos % 48;
	let tabWidth;
	if (justification === "left") {
		const explicitTabs = [...tabs ?? []];
		if (hangingIndent && hangingIndent > 0) {
			explicitTabs.push(leftIndent);
			explicitTabs.sort((a, b$1) => a - b$1);
		}
		let targetTabStop;
		for (const tab of explicitTabs) if (tab > currentPos) {
			targetTabStop = tab;
			break;
		}
		if (targetTabStop === void 0) targetTabStop = nextDefaultTabStop;
		tabWidth = targetTabStop - currentPos;
	} else if (justification === "right") if (firstLineIndent != null && firstLineIndent > 0) tabWidth = nextDefaultTabStop - currentPos;
	else tabWidth = hangingIndent ?? 0;
	else tabWidth = nextDefaultTabStop - currentPos;
	return tabWidth;
}
const hashParagraphBorder$2 = (border) => {
	const parts = [];
	if (border.style !== void 0) parts.push(`s:${border.style}`);
	if (border.width !== void 0) parts.push(`w:${border.width}`);
	if (border.color !== void 0) parts.push(`c:${border.color}`);
	if (border.space !== void 0) parts.push(`sp:${border.space}`);
	return parts.join(",");
};
const hashParagraphBorders$2 = (borders) => {
	const parts = [];
	if (borders.top) parts.push(`t:[${hashParagraphBorder$2(borders.top)}]`);
	if (borders.right) parts.push(`r:[${hashParagraphBorder$2(borders.right)}]`);
	if (borders.bottom) parts.push(`b:[${hashParagraphBorder$2(borders.bottom)}]`);
	if (borders.left) parts.push(`l:[${hashParagraphBorder$2(borders.left)}]`);
	if (borders.between) parts.push(`bw:[${hashParagraphBorder$2(borders.between)}]`);
	return parts.join(";");
};
var isBetweenBorderNone = (borders) => {
	if (!borders?.between) return true;
	return borders.between.style === "none";
};
function isResolvedFragmentWithBorders(item) {
	return item !== void 0 && item.kind === "fragment" && "paragraphBorders" in item && item.paragraphBorders !== void 0;
}
const computeBetweenBorderFlags = (resolvedItems) => {
	const pairFlags = /* @__PURE__ */ new Set();
	const noBetweenPairs = /* @__PURE__ */ new Set();
	for (let i = 0; i < resolvedItems.length - 1; i += 1) {
		const resolvedCur = resolvedItems[i];
		if (resolvedCur.kind !== "fragment") continue;
		const frag = resolvedCur.fragment;
		if (frag.kind !== "para") continue;
		if (frag.continuesOnNext) continue;
		if (!isResolvedFragmentWithBorders(resolvedCur)) continue;
		const borders = resolvedCur.paragraphBorders;
		const resolvedNext = resolvedItems[i + 1];
		if (resolvedNext.kind !== "fragment") continue;
		const next = resolvedNext.fragment;
		if (next.kind !== "para") continue;
		if (next.continuesFromPrev) continue;
		if (next.blockId === frag.blockId) continue;
		if (!isResolvedFragmentWithBorders(resolvedNext)) continue;
		const nextBorders = resolvedNext.paragraphBorders;
		if (("paragraphBorderHash" in resolvedCur && resolvedCur.paragraphBorderHash ? resolvedCur.paragraphBorderHash : hashParagraphBorders$2(borders)) !== ("paragraphBorderHash" in resolvedNext && resolvedNext.paragraphBorderHash ? resolvedNext.paragraphBorderHash : hashParagraphBorders$2(nextBorders))) continue;
		if (frag.x !== next.x) continue;
		pairFlags.add(i);
		if (isBetweenBorderNone(borders) && isBetweenBorderNone(nextBorders)) noBetweenPairs.add(i);
	}
	const result = /* @__PURE__ */ new Map();
	for (const i of pairFlags) {
		const resolvedCur = resolvedItems[i];
		const resolvedNext = resolvedItems[i + 1];
		if (resolvedCur.kind !== "fragment" || resolvedNext.kind !== "fragment") continue;
		const frag = resolvedCur.fragment;
		const next = resolvedNext.fragment;
		const fragHeight = "height" in resolvedCur && resolvedCur.height != null ? resolvedCur.height : 0;
		const gapBelow = Math.max(0, next.y - (frag.y + fragHeight));
		const isNoBetween = noBetweenPairs.has(i);
		if (!result.has(i)) result.set(i, {
			showBetweenBorder: !isNoBetween,
			suppressTopBorder: false,
			suppressBottomBorder: isNoBetween,
			gapBelow
		});
		else {
			const existing = result.get(i);
			existing.showBetweenBorder = !isNoBetween;
			existing.suppressBottomBorder = isNoBetween;
			existing.gapBelow = gapBelow;
		}
		if (!result.has(i + 1)) result.set(i + 1, {
			showBetweenBorder: false,
			suppressTopBorder: true,
			suppressBottomBorder: false,
			gapBelow: 0
		});
		else result.get(i + 1).suppressTopBorder = true;
	}
	return result;
};
var PX_PER_PT$1 = 96 / 72;
const getParagraphBorderBox = (fragmentWidth, indent) => {
	const indentLeft = Number.isFinite(indent?.left) ? indent.left : 0;
	const indentRight = Number.isFinite(indent?.right) ? indent.right : 0;
	const firstLineOffset = (Number.isFinite(indent?.firstLine) ? indent.firstLine : 0) - (Number.isFinite(indent?.hanging) ? indent.hanging : 0);
	const minLeftInset = Math.min(indentLeft, indentLeft + firstLineOffset);
	const leftInset = Math.max(0, minLeftInset);
	const rightInset = Math.max(0, indentRight);
	return {
		leftInset,
		width: Math.max(0, fragmentWidth - leftInset - rightInset)
	};
};
const computeBorderSpaceExpansion = (borders, betweenInfo) => {
	if (!borders) return {
		top: 0,
		bottom: 0,
		left: 0,
		right: 0
	};
	const suppressTop = betweenInfo?.suppressTopBorder ?? false;
	const suppressBottom = betweenInfo?.suppressBottomBorder ?? false;
	const showBetween = betweenInfo?.showBetweenBorder ?? false;
	return {
		top: suppressTop ? borders.between?.space ? borders.between.space * PX_PER_PT$1 : 0 : borders.top?.space ? borders.top.space * PX_PER_PT$1 : 0,
		bottom: !suppressBottom && !showBetween && borders.bottom?.space ? borders.bottom.space * PX_PER_PT$1 : 0,
		left: borders.left?.space ? borders.left.space * PX_PER_PT$1 : 0,
		right: borders.right?.space ? borders.right.space * PX_PER_PT$1 : 0
	};
};
const createParagraphDecorationLayers = (doc$1, fragmentWidth, attrs, betweenInfo) => {
	if (!attrs?.borders && !attrs?.shading) return {};
	const borderBox = getParagraphBorderBox(fragmentWidth, attrs.indent);
	const space = computeBorderSpaceExpansion(attrs.borders, betweenInfo);
	const betweenSpaceBelow = betweenInfo?.showBetweenBorder && attrs.borders?.between?.space ? attrs.borders.between.space * PX_PER_PT$1 : 0;
	const rawGap = betweenInfo?.showBetweenBorder || betweenInfo?.suppressBottomBorder ? betweenInfo.gapBelow : 0;
	const gapExtension = Math.max(0, rawGap - betweenSpaceBelow);
	const bw = computeRenderedBorderWidths(attrs.borders, betweenInfo);
	const shadingBottom = gapExtension + space.bottom;
	const borderBottom = gapExtension + space.bottom + bw.bottom;
	const commonStyles = {
		position: "absolute",
		pointerEvents: "none",
		boxSizing: "border-box"
	};
	let shadingLayer;
	if (attrs.shading) {
		shadingLayer = doc$1.createElement("div");
		shadingLayer.classList.add("superdoc-paragraph-shading");
		Object.assign(shadingLayer.style, commonStyles);
		shadingLayer.style.top = space.top > 0 ? `-${space.top}px` : "0px";
		shadingLayer.style.bottom = shadingBottom > 0 ? `-${shadingBottom}px` : "0px";
		shadingLayer.style.left = `${borderBox.leftInset - space.left}px`;
		shadingLayer.style.width = `${borderBox.width + space.left + space.right}px`;
		applyParagraphShadingStyles(shadingLayer, attrs.shading);
	}
	let borderLayer;
	if (attrs.borders) {
		borderLayer = doc$1.createElement("div");
		borderLayer.classList.add("superdoc-paragraph-border");
		Object.assign(borderLayer.style, commonStyles);
		borderLayer.style.top = space.top + bw.top > 0 ? `-${space.top + bw.top}px` : "0px";
		borderLayer.style.bottom = borderBottom > 0 ? `-${borderBottom}px` : "0px";
		borderLayer.style.left = `${borderBox.leftInset - space.left - bw.left}px`;
		borderLayer.style.width = `${borderBox.width + space.left + bw.left + space.right + bw.right}px`;
		borderLayer.style.zIndex = "1";
		applyParagraphBorderStyles(borderLayer, attrs.borders, betweenInfo);
	}
	return {
		shadingLayer,
		borderLayer
	};
};
var computeRenderedBorderWidths = (borders, betweenInfo) => {
	if (!borders) return {
		top: 0,
		bottom: 0,
		left: 0,
		right: 0
	};
	const suppressTop = betweenInfo?.suppressTopBorder ?? false;
	const suppressBottom = betweenInfo?.suppressBottomBorder ?? false;
	const showBetween = betweenInfo?.showBetweenBorder ?? false;
	return {
		top: !suppressTop ? borders.top?.width ?? 0 : 0,
		bottom: showBetween ? borders.between?.width ?? 0 : !suppressBottom ? borders.bottom?.width ?? 0 : 0,
		left: borders.left?.width ?? 0,
		right: borders.right?.width ?? 0
	};
};
var BORDER_SIDES = [
	"top",
	"right",
	"bottom",
	"left"
];
const applyParagraphBorderStyles = (element, borders, betweenInfo) => {
	if (!borders) return;
	const showBetweenBorder = betweenInfo?.showBetweenBorder ?? false;
	const suppressTopBorder = betweenInfo?.suppressTopBorder ?? false;
	const suppressBottomBorder = betweenInfo?.suppressBottomBorder ?? false;
	element.style.boxSizing = "border-box";
	BORDER_SIDES.forEach((side) => {
		if (side === "top" && suppressTopBorder) return;
		if (side === "bottom" && suppressBottomBorder) return;
		const border = borders[side];
		if (!border) return;
		setBorderSideStyle(element, side, border);
	});
	if (showBetweenBorder && borders.between) setBorderSideStyle(element, "bottom", borders.between);
};
var setBorderSideStyle = (element, side, border) => {
	const resolvedStyle = border.style && border.style !== "none" ? border.style : border.style === "none" ? "none" : "solid";
	if (resolvedStyle === "none") {
		element.style.setProperty(`border-${side}-style`, "none");
		element.style.setProperty(`border-${side}-width`, "0px");
		if (border.color) element.style.setProperty(`border-${side}-color`, border.color);
		return;
	}
	const width = border.width != null ? Math.max(0, border.width) : void 0;
	element.style.setProperty(`border-${side}-style`, resolvedStyle);
	element.style.setProperty(`border-${side}-width`, `${width ?? 1}px`);
	element.style.setProperty(`border-${side}-color`, border.color ?? "#000");
};
const stampBetweenBorderDataset = (element, betweenInfo) => {
	if (!betweenInfo) return;
	if (betweenInfo.showBetweenBorder) element.dataset.betweenBorder = "true";
	if (betweenInfo.suppressTopBorder) element.dataset.suppressTopBorder = "true";
	if (betweenInfo.suppressBottomBorder) element.dataset.suppressBottomBorder = "true";
	if (betweenInfo.gapBelow) element.dataset.gapBelow = String(betweenInfo.gapBelow);
};
const applyParagraphShadingStyles = (element, shading) => {
	if (!shading?.fill) return;
	element.style.backgroundColor = shading.fill;
};
const isRtlParagraph = (attrs) => getParagraphInlineDirection(attrs) === "rtl";
const resolveTextAlign = (alignment$1, isRtl) => {
	switch (alignment$1) {
		case "center":
		case "right":
		case "left": return alignment$1;
		case "justify":
		default: return isRtl ? "right" : "left";
	}
};
const applyRtlStyles = (element, attrs) => {
	const rtl = isRtlParagraph(attrs);
	if (rtl) {
		element.setAttribute("dir", "rtl");
		element.style.direction = "rtl";
	} else {
		element.removeAttribute("dir");
		element.style.direction = "";
	}
	element.style.textAlign = resolveTextAlign(attrs?.alignment, rtl);
	return rtl;
};
const shouldUseSegmentPositioning = (hasExplicitPositioning, hasSegments, isRtl) => hasExplicitPositioning && hasSegments && !isRtl;
const RTL_DATE_LIKE_TOKEN_RE = /^-?\d+(?:[./-]\d+)+$/;
const STRONG_RTL_CHAR_RE = /[\u0590-\u08FF\p{Script=Hebrew}\p{Script=Arabic}]/u;
const LATIN_DIGIT_NEUTRAL_ONLY_RE = /^[\s0-9A-Za-z./\-_:,+()]+$/;
var RLM = "‏";
const normalizeRtlDateTokenForWordParity = (text) => {
	if (!RTL_DATE_LIKE_TOKEN_RE.test(text)) return text;
	return text.replace(/[./-]/g, (separator) => `${RLM}${separator}${RLM}`);
};
const resolveRunDirectionAttribute = (opts) => {
	if (opts.isRtlTagged) {
		const sample = (opts.runText ?? opts.effectiveText).trim();
		if (!sample) return "rtl";
		if (RTL_DATE_LIKE_TOKEN_RE.test(sample)) return "rtl";
		if (STRONG_RTL_CHAR_RE.test(sample)) return "rtl";
		if (LATIN_DIGIT_NEUTRAL_ONLY_RE.test(sample)) return null;
		return "rtl";
	}
	if (typeof opts.runText === "string" && RTL_DATE_LIKE_TOKEN_RE.test(opts.runText)) return "ltr";
	return null;
};
const hasExplicitSegmentPositioning = (line) => line.segments?.some((segment) => segment.x !== void 0) === true;
const applyParagraphLineIndentation = (params$1) => {
	const { lineEl, line, indent, indentLeftPx, hasListMarkerLayout, lineIndex, localStartLine, continuesFromPrev, suppressFirstLineIndent, resetContinuationTextIndent } = params$1;
	const paraIndentLeft = indent?.left ?? 0;
	const paraIndentRight = indent?.right ?? 0;
	const firstLineOffset = suppressFirstLineIndent ? 0 : (indent?.firstLine ?? 0) - (indent?.hanging ?? 0);
	const isFirstLine = lineIndex === 0 && localStartLine === 0 && !continuesFromPrev;
	const explicitSegmentPositioning = hasExplicitSegmentPositioning(line);
	if (hasListMarkerLayout && indentLeftPx) {
		if (!explicitSegmentPositioning) lineEl.style.paddingLeft = `${indentLeftPx}px`;
	} else if (explicitSegmentPositioning) {
		if (isFirstLine && firstLineOffset !== 0) {
			const adjustedPadding = (paraIndentLeft < 0 ? 0 : paraIndentLeft) + firstLineOffset;
			if (adjustedPadding > 0) lineEl.style.paddingLeft = `${adjustedPadding}px`;
		}
	} else if (paraIndentLeft && paraIndentLeft > 0) lineEl.style.paddingLeft = `${paraIndentLeft}px`;
	else if (!isFirstLine && indent?.hanging && indent.hanging > 0 && (paraIndentLeft == null || paraIndentLeft >= 0)) lineEl.style.paddingLeft = `${indent.hanging}px`;
	if (paraIndentRight && paraIndentRight > 0) lineEl.style.paddingRight = `${paraIndentRight}px`;
	if (isFirstLine && firstLineOffset && !explicitSegmentPositioning) lineEl.style.textIndent = `${firstLineOffset}px`;
	else if (firstLineOffset && explicitSegmentPositioning) lineEl.style.textIndent = "0px";
	else if (firstLineOffset && !hasListMarkerLayout && resetContinuationTextIndent) lineEl.style.textIndent = "0px";
};
const resolveAvailableWidthForLine = (params$1) => {
	const { containerWidth, line, indentLeftPx, indentRightPx, firstLineOffset, isFirstLine, isListFirstLine, resolvedListTextStartPx } = params$1;
	const positiveIndentReduction = Math.max(0, indentLeftPx) + Math.max(0, indentRightPx);
	const fallbackAvailableWidth = Math.max(0, containerWidth - positiveIndentReduction);
	let availableWidth = line.maxWidth != null ? Math.min(line.maxWidth, fallbackAvailableWidth) : fallbackAvailableWidth;
	if (resolvedListTextStartPx != null) availableWidth = containerWidth - resolvedListTextStartPx - Math.max(0, indentRightPx);
	if (isFirstLine && !isListFirstLine && line.hasExplicitTabStops !== true) availableWidth = adjustAvailableWidthForTextIndent(availableWidth, firstLineOffset, line.maxWidth);
	return availableWidth;
};
function applySourceAnchorDataset(element, sourceAnchor) {
	if (!sourceAnchor) {
		delete element.dataset.sourceAnchor;
		delete element.dataset.sourceNodeId;
		delete element.dataset.sourceOccurrenceId;
		return;
	}
	try {
		element.dataset.sourceAnchor = JSON.stringify(sourceAnchor);
	} catch {
		delete element.dataset.sourceAnchor;
	}
	if (sourceAnchor.sourceNodeId) element.dataset.sourceNodeId = sourceAnchor.sourceNodeId;
	else delete element.dataset.sourceNodeId;
	if (sourceAnchor.occurrenceId) element.dataset.sourceOccurrenceId = sourceAnchor.occurrenceId;
	else delete element.dataset.sourceOccurrenceId;
}
function allowFontSynthesis(element) {
	element.style.setProperty("font-synthesis", "weight style");
}
var getFiniteNonNegativeNumber = (value) => {
	if (typeof value !== "number" || !Number.isFinite(value) || value < 0) return;
	return value;
};
var resolvePainterMarkerTextWidth = (markerTextWidthPx, marker) => getFiniteNonNegativeNumber(markerTextWidthPx) ?? getFiniteNonNegativeNumber(marker.glyphWidthPx) ?? getFiniteNonNegativeNumber(marker.markerBoxWidthPx) ?? 0;
const resolvePainterListMarkerGeometry = ({ wordLayout, indentLeftPx, hangingIndentPx, firstLineIndentPx, markerTextWidthPx }) => resolveListMarkerGeometry(wordLayout, indentLeftPx, firstLineIndentPx, hangingIndentPx, (_markerText, marker) => resolvePainterMarkerTextWidth(markerTextWidthPx, marker));
const resolvePainterListTextStartPx = ({ wordLayout, indentLeftPx, hangingIndentPx, firstLineIndentPx, markerTextWidthPx }) => resolveListTextStartPx(wordLayout, indentLeftPx, firstLineIndentPx, hangingIndentPx, (_markerText, marker) => resolvePainterMarkerTextWidth(markerTextWidthPx, marker));
var isMarkerSuffix = (suffix) => suffix === "tab" || suffix === "space" || suffix === "nothing";
const createListMarkerElement = (doc$1, markerText, run, sourceAnchor, resolvePhysical = (css) => resolvePhysicalFamily(css)) => {
	const markerContainer = doc$1.createElement("span");
	markerContainer.classList.add(DOM_CLASS_NAMES.LIST_MARKER);
	markerContainer.style.display = "inline-block";
	markerContainer.style.wordSpacing = "0px";
	const markerEl = doc$1.createElement("span");
	markerEl.classList.add("superdoc-paragraph-marker");
	markerEl.textContent = markerText;
	markerEl.style.pointerEvents = "none";
	const cssFontFamily = toCssFontFamily(run.fontFamily) ?? run.fontFamily ?? "";
	markerEl.style.fontFamily = resolvePhysical(cssFontFamily, {
		weight: run.bold ? "700" : "400",
		style: run.italic ? "italic" : "normal"
	});
	if (run.fontSize != null) markerEl.style.fontSize = `${run.fontSize}px`;
	allowFontSynthesis(markerEl);
	markerEl.style.fontWeight = run.bold ? "bold" : "";
	markerEl.style.fontStyle = run.italic ? "italic" : "";
	if (run.color) markerEl.style.color = run.color;
	if (run.letterSpacing != null) markerEl.style.letterSpacing = `${run.letterSpacing}px`;
	if (run.allCaps) markerEl.style.textTransform = "uppercase";
	else if (run.smallCaps) markerEl.style.fontVariant = "small-caps";
	markerContainer.appendChild(markerEl);
	if (sourceAnchor) applySourceAnchorDataset(markerEl, sourceAnchor);
	return markerContainer;
};
const renderLegacyListMarker = (params$1) => {
	const { doc: doc$1, lineEl, wordLayout, markerLayout, markerMeasure, markerTextWidthPx, indentLeftPx, hangingIndentPx, firstLineIndentPx, isRtl, sourceAnchor, resolvePhysical = (css) => resolvePhysicalFamily(css) } = params$1;
	const markerTextWidth = markerTextWidthPx ?? markerMeasure?.markerTextWidth ?? 0;
	const markerGeometry = markerLayout?.justification === "left" && wordLayout?.firstLineIndentMode !== true && typeof markerTextWidth === "number" && Number.isFinite(markerTextWidth) && markerTextWidth >= 0 ? resolvePainterListMarkerGeometry({
		wordLayout,
		indentLeftPx,
		hangingIndentPx,
		firstLineIndentPx,
		markerTextWidthPx: markerTextWidth
	}) : void 0;
	const anchorPoint = indentLeftPx - hangingIndentPx + firstLineIndentPx;
	const markerJustification = markerLayout?.justification ?? "left";
	let markerStartPos;
	let currentPos;
	if (markerJustification === "left") {
		markerStartPos = anchorPoint;
		currentPos = markerStartPos + markerTextWidth;
	} else if (markerJustification === "right") {
		markerStartPos = anchorPoint - markerTextWidth;
		currentPos = anchorPoint;
	} else {
		markerStartPos = anchorPoint - markerTextWidth / 2;
		currentPos = markerStartPos + markerTextWidth;
	}
	const suffix = markerLayout?.suffix ?? "tab";
	let suffixWidthPx = 0;
	if (markerGeometry && (suffix === "tab" || suffix === "space")) suffixWidthPx = markerGeometry.suffixWidthPx;
	else if (suffix === "tab") suffixWidthPx = computeTabWidth(currentPos, markerJustification, wordLayout?.tabsPx, hangingIndentPx, firstLineIndentPx, indentLeftPx);
	else if (suffix === "space") suffixWidthPx = 4;
	if (isRtl) lineEl.style.paddingRight = `${anchorPoint}px`;
	else lineEl.style.paddingLeft = `${anchorPoint}px`;
	if ((markerLayout?.run)?.vanish) return;
	const markerContainer = createListMarkerElement(doc$1, markerLayout?.markerText ?? "", markerLayout?.run ?? {}, sourceAnchor, resolvePhysical);
	markerContainer.style.position = "relative";
	if (markerJustification === "right") {
		markerContainer.style.position = "absolute";
		if (isRtl) markerContainer.style.right = `${markerStartPos}px`;
		else markerContainer.style.left = `${markerStartPos}px`;
	} else if (markerJustification === "center") {
		markerContainer.style.position = "absolute";
		if (isRtl) {
			markerContainer.style.right = `${markerStartPos - markerTextWidth / 2}px`;
			lineEl.style.paddingRight = `${parseFloat(lineEl.style.paddingRight || "0") + markerTextWidth / 2}px`;
		} else {
			markerContainer.style.left = `${markerStartPos - markerTextWidth / 2}px`;
			lineEl.style.paddingLeft = `${parseFloat(lineEl.style.paddingLeft || "0") + markerTextWidth / 2}px`;
		}
	}
	prependMarkerSuffix(doc$1, lineEl, isMarkerSuffix(suffix) ? suffix : void 0, suffixWidthPx, markerLayout?.run?.fontSize);
	lineEl.prepend(markerContainer);
};
const renderResolvedListMarker = (params$1) => {
	const { doc: doc$1, lineEl, marker, isRtl, sourceAnchor, resolvePhysical } = params$1;
	if (isRtl) lineEl.style.paddingRight = `${marker.firstLinePaddingLeftPx}px`;
	else lineEl.style.paddingLeft = `${marker.firstLinePaddingLeftPx}px`;
	if (marker.vanish) return;
	const markerContainer = createListMarkerElement(doc$1, marker.text, marker.run, marker.sourceAnchor ?? sourceAnchor, resolvePhysical);
	markerContainer.style.position = "relative";
	if (marker.justification === "right") {
		markerContainer.style.position = "absolute";
		if (isRtl) markerContainer.style.right = `${marker.markerStartPx}px`;
		else markerContainer.style.left = `${marker.markerStartPx}px`;
	} else if (marker.justification === "center") {
		markerContainer.style.position = "absolute";
		const paddingAdjust = marker.centerPaddingAdjustPx ?? 0;
		if (isRtl) {
			markerContainer.style.right = `${marker.markerStartPx - paddingAdjust}px`;
			lineEl.style.paddingRight = `${parseFloat(lineEl.style.paddingRight || "0") + paddingAdjust}px`;
		} else {
			markerContainer.style.left = `${marker.markerStartPx - paddingAdjust}px`;
			lineEl.style.paddingLeft = `${parseFloat(lineEl.style.paddingLeft || "0") + paddingAdjust}px`;
		}
	}
	prependMarkerSuffix(doc$1, lineEl, marker.suffix, marker.suffixWidthPx, marker.run.fontSize);
	lineEl.prepend(markerContainer);
};
var prependMarkerSuffix = (doc$1, lineEl, suffix, suffixWidthPx, fontSize) => {
	if (suffix === "tab") {
		const tabEl = doc$1.createElement("span");
		tabEl.classList.add("superdoc-tab", "superdoc-marker-suffix-tab");
		tabEl.innerHTML = "&nbsp;";
		tabEl.style.display = "inline-block";
		if (fontSize != null) tabEl.style.fontSize = `${fontSize}px`;
		tabEl.style.wordSpacing = "0px";
		tabEl.style.width = `${suffixWidthPx}px`;
		lineEl.prepend(tabEl);
	} else if (suffix === "space") {
		const spaceEl = doc$1.createElement("span");
		spaceEl.classList.add("superdoc-marker-suffix-space");
		if (fontSize != null) spaceEl.style.fontSize = `${fontSize}px`;
		spaceEl.style.wordSpacing = "0px";
		spaceEl.textContent = "\xA0";
		lineEl.prepend(spaceEl);
	}
};
const applyParagraphBlockStyles = (element, attrs) => {
	if (!attrs) return;
	if (attrs.styleId) element.setAttribute("styleid", attrs.styleId);
	applyRtlStyles(element, attrs);
	if (attrs.dropCap) element.classList.add("sd-editor-dropcap");
	const indent = attrs.indent;
	if (indent) {
		if (indent.left && indent.left > 0) element.style.paddingLeft = `${indent.left}px`;
		if (indent.right && indent.right > 0) element.style.paddingRight = `${indent.right}px`;
		if (!(indent.left != null && indent.left < 0)) {
			const textIndent = (indent.firstLine ?? 0) - (indent.hanging ?? 0);
			if (textIndent) element.style.textIndent = `${textIndent}px`;
		}
	}
};
const clearParagraphFrameIndentStyles = (element) => {
	if (element.style.paddingLeft) element.style.removeProperty("padding-left");
	if (element.style.paddingRight) element.style.removeProperty("padding-right");
	if (element.style.marginLeft) element.style.removeProperty("margin-left");
	if (element.style.marginRight) element.style.removeProperty("margin-right");
	if (element.style.textIndent) element.style.removeProperty("text-indent");
};
var INLINE_SDT_CHROME_EXTRA_WIDTH_PX = 4;
const renderParagraphContent = (params$1) => {
	const { doc: doc$1, frameEl, block, measure, linesOverride, width, localStartLine, localEndLine, lineIndexOffset = 0, continuesFromPrev, continuesOnNext, resolvedContent, betweenInfo, sdtBoundary, spacingPolicy, ancestorContainerKey, ancestorContainerSdt, ancestorContainerKeys, ancestorContainerSdts, onSdtContainerChrome, applySdtDataset: applySdtDataset$1, applyContainerSdtDataset: applyContainerSdtDataset$1, contentControlsChrome, renderDropCap: renderDropCap$1, lineTopOffset = 0 } = params$1;
	applyParagraphBlockStyles(frameEl, block.attrs);
	const { shadingLayer, borderLayer } = createParagraphDecorationLayers(doc$1, width, block.attrs, betweenInfo);
	if (shadingLayer) frameEl.appendChild(shadingLayer);
	if (borderLayer) frameEl.appendChild(borderLayer);
	stampBetweenBorderDataset(frameEl, betweenInfo);
	if (block.attrs?.styleId) {
		frameEl.dataset.styleId = block.attrs.styleId;
		frameEl.setAttribute("styleid", block.attrs.styleId);
	}
	applySdtDataset$1(frameEl, block.attrs?.sdt);
	applyContainerSdtDataset$1?.(frameEl, block.attrs?.containerSdt);
	const applySdtChrome = shouldRenderSdtContainerChrome(block.attrs?.sdt, block.attrs?.containerSdt, {
		ancestorContainerKey,
		ancestorContainerSdt,
		ancestorContainerKeys,
		ancestorContainerSdts
	});
	if (applySdtChrome) {
		if (applySdtContainerChrome(doc$1, frameEl, block.attrs?.sdt, block.attrs?.containerSdt, sdtBoundary, void 0, contentControlsChrome)) onSdtContainerChrome?.();
	}
	renderParagraphDropCap({
		frameEl,
		block,
		measure,
		resolvedContent,
		continuesFromPrev,
		renderDropCap: renderDropCap$1
	});
	clearParagraphFrameIndentStyles(frameEl);
	const spacingBefore = block.attrs?.spacing?.before;
	let beforeHeight = 0;
	if (spacingPolicy && localStartLine === 0) {
		beforeHeight = effectiveTableCellSpacing(spacingBefore, spacingPolicy.isFirstBlock, spacingPolicy.paddingTop);
		if (beforeHeight > 0) frameEl.style.marginTop = `${beforeHeight}px`;
	}
	const renderResult = resolvedContent != null ? renderResolvedLines({
		...params$1,
		resolvedContent,
		lineTopOffset: lineTopOffset + beforeHeight
	}) : renderMeasuredLines({
		...params$1,
		lineTopOffset: lineTopOffset + beforeHeight
	});
	if (applySdtChrome) applyBlockSdtChromeBounds(frameEl, block, measure, getRenderedContentLines(params$1), width, lineIndexOffset + localStartLine, continuesFromPrev, continuesOnNext, sdtBoundary, resolvedContent);
	let renderedHeight = renderResult.renderedHeight;
	const originalLineCount = measure.lines?.length ?? linesOverride?.length ?? 0;
	const renderedStartLine = lineIndexOffset + localStartLine;
	const renderedEndLine = lineIndexOffset + localEndLine;
	const renderedEntireBlock = !continuesFromPrev && !continuesOnNext && renderedStartLine === 0 && renderedEndLine >= originalLineCount;
	if (renderedEntireBlock && measure.totalHeight && measure.totalHeight > renderedHeight) renderedHeight = measure.totalHeight;
	let afterHeight = 0;
	if (spacingPolicy && renderedEntireBlock && !spacingPolicy.isLastBlock) {
		const spacingAfter = block.attrs?.spacing?.after;
		if (typeof spacingAfter === "number" && spacingAfter > 0) {
			frameEl.style.marginBottom = `${spacingAfter}px`;
			afterHeight = spacingAfter;
		}
	}
	if (renderedHeight > 0) frameEl.style.height = `${renderedHeight}px`;
	return {
		renderedHeight,
		totalHeight: beforeHeight + renderedHeight + afterHeight,
		renderedLines: renderResult.renderedLines
	};
};
var getRenderedContentLines = (params$1) => {
	if (params$1.resolvedContent) return params$1.resolvedContent.lines.map((line) => line.line);
	const lines = params$1.linesOverride ?? params$1.measure.lines ?? [];
	return lines.slice(params$1.localStartLine, Math.min(params$1.localEndLine, lines.length));
};
var applyBlockSdtChromeBounds = (element, block, measure, lines, fragmentWidth, lineIndexBase, fragmentContinuesFromPrev, fragmentContinuesOnNext, sdtBoundary, content) => {
	const sdt = getSdtContainerMetadata(block.attrs?.sdt, block.attrs?.containerSdt);
	if (!isStructuredContentMetadata(sdt) || sdt.scope !== "block") return;
	if (fragmentContinuesFromPrev || fragmentContinuesOnNext) return;
	if (sdtBoundary && ((sdtBoundary.isStart ?? true) === false || (sdtBoundary.isEnd ?? true) === false)) return;
	if (Math.max(measure.lines?.length ?? 0, content?.lines.length ?? 0, lines.length) > 1) return;
	const expandedBlock = {
		...block,
		runs: expandRunsForInlineNewlines(block.runs)
	};
	let contentLeft = Number.POSITIVE_INFINITY;
	let contentRight = Number.NEGATIVE_INFINITY;
	for (const [index, line] of lines.entries()) {
		const runsForLine = sliceRunsForLine(expandedBlock, line);
		if (runsForLine.length === 0) continue;
		let hasVisibleContent = false;
		for (const run of runsForLine) {
			if (run.kind === "lineBreak" || run.kind === "break") continue;
			if (isEmptySdtPlaceholderRun(run)) {
				hasVisibleContent = true;
				break;
			}
			if ((run.kind === "text" || run.kind === void 0) && "text" in run) {
				if ((run.text ?? "").trim().length === 0) continue;
			}
			hasVisibleContent = true;
			break;
		}
		if (!hasVisibleContent) continue;
		const lineWidth = Math.max(0, line.naturalWidth ?? line.width ?? 0);
		if (lineWidth <= 0) continue;
		const inlineSdtChromeWidth = hasExplicitSegmentPositioning(line) ? 0 : getInlineSdtChromeExtraWidth(runsForLine);
		const resolvedLine = content?.lines[index];
		const lineOffset = resolveBlockSdtChromeLineOffset(block, line, resolvedLine, resolvedLine?.lineIndex ?? lineIndexBase + index);
		const availableWidth = resolveBlockSdtChromeAvailableWidth(block, line, fragmentWidth, lineOffset, resolvedLine);
		const paintedLineWidthWithChrome = resolveBlockSdtChromePaintedLineWidth(block, line, lineWidth, availableWidth, index, lines.length, fragmentContinuesOnNext, resolvedLine, content) + inlineSdtChromeWidth;
		const alignmentSlack = Math.max(0, availableWidth - paintedLineWidthWithChrome);
		const alignment$1 = resolveTextAlign(block.attrs?.alignment, getParagraphInlineDirection(block.attrs) === "rtl");
		const lineLeft = lineOffset + (alignment$1 === "center" ? alignmentSlack / 2 : alignment$1 === "right" ? alignmentSlack : 0);
		contentLeft = Math.min(contentLeft, lineLeft);
		contentRight = Math.max(contentRight, lineLeft + paintedLineWidthWithChrome);
	}
	if (!Number.isFinite(contentLeft) || !Number.isFinite(contentRight)) return;
	const chromeLeft = Math.max(0, contentLeft);
	const chromeWidth = Math.max(0, Math.min(fragmentWidth, contentRight) - chromeLeft);
	if (chromeWidth <= 0 || chromeWidth >= fragmentWidth) return;
	element.style.setProperty("--sd-sdt-chrome-left", `${chromeLeft}px`);
	element.style.setProperty("--sd-sdt-chrome-width", `${chromeWidth}px`);
};
var getInlineSdtChromeExtraWidth = (runs) => {
	let wrapperCount = 0;
	let currentSdtId = null;
	for (const run of runs) {
		const sdt = "sdt" in run ? run.sdt : void 0;
		const sdtId = sdt?.type === "structuredContent" && sdt.scope === "inline" && sdt.id && sdt.appearance !== "hidden" ? String(sdt.id) : null;
		if (sdtId !== currentSdtId) {
			if (sdtId) wrapperCount += 1;
			currentSdtId = sdtId;
		}
	}
	return wrapperCount * INLINE_SDT_CHROME_EXTRA_WIDTH_PX;
};
var resolveBlockSdtChromeLineOffset = (block, line, resolvedLine, lineIndex) => {
	if (resolvedLine) {
		if (resolvedLine.isListFirstLine) return resolvedLine.resolvedListTextStartPx ?? resolvedLine.indentOffset;
		if (resolvedLine.hasExplicitSegmentPositioning) return resolvedLine.indentOffset;
		return Math.max(0, resolvedLine.paddingLeftPx + resolvedLine.textIndentPx);
	}
	const paraIndent = block.attrs?.indent;
	const indentLeft = paraIndent?.left ?? 0;
	const firstLine = paraIndent?.firstLine ?? 0;
	const hanging = paraIndent?.hanging ?? 0;
	const firstLineOffset = block.attrs?.suppressFirstLineIndent === true ? 0 : firstLine - hanging;
	const isFirstLine = lineIndex === 0;
	if (line.segments?.some((segment) => segment.x !== void 0) === true) {
		const effectiveLeftIndent = indentLeft < 0 ? 0 : indentLeft;
		return Math.max(0, effectiveLeftIndent + (isFirstLine ? firstLineOffset : 0));
	}
	if (isFirstLine) return Math.max(0, indentLeft + firstLineOffset);
	if (indentLeft > 0) return indentLeft;
	if (hanging > 0 && indentLeft >= 0) return hanging;
	return 0;
};
var resolveBlockSdtChromeAvailableWidth = (block, line, fragmentWidth, lineOffset, resolvedLine) => {
	if (resolvedLine) return Math.max(0, resolvedLine.availableWidth);
	const rightIndent = Math.max(0, block.attrs?.indent?.right ?? 0);
	const fallbackAvailableWidth = Math.max(0, fragmentWidth - lineOffset - rightIndent);
	if (line.maxWidth != null) return Math.min(line.maxWidth, fallbackAvailableWidth);
	return fallbackAvailableWidth;
};
var resolveBlockSdtChromePaintedLineWidth = (block, line, lineWidth, availableWidth, fragmentLineIndex, fragmentLineCount, fragmentContinuesOnNext, resolvedLine, content) => {
	const hasMultipleExplicitPositionedSegments = (line.segments?.filter((segment) => segment.x !== void 0).length ?? 0) > 1;
	const paragraphEndsWithLineBreak = content?.paragraphEndsWithLineBreak === true || block.runs[block.runs.length - 1]?.kind === "lineBreak";
	const isLastLineOfParagraph = resolvedLine != null ? resolvedLine.skipJustify : fragmentLineIndex === fragmentLineCount - 1 && !fragmentContinuesOnNext;
	return shouldApplyJustify({
		alignment: block.attrs?.alignment,
		hasExplicitPositioning: line.segments?.some((segment) => segment.x !== void 0) === true,
		hasExplicitTabStops: line.hasExplicitTabStops === true,
		isLastLineOfParagraph,
		paragraphEndsWithLineBreak,
		skipJustifyOverride: (resolvedLine?.skipJustify ?? false) || hasMultipleExplicitPositionedSegments
	}) ? Math.max(lineWidth, availableWidth) : lineWidth;
};
var renderResolvedLines = (params$1) => {
	const { frameEl, block, resolvedContent: content, markerTextWidth, renderLine: renderLine$1, captureLineSnapshot, convertFinalParagraphMark, lineTopOffset = 0, sourceAnchor, resolvePhysical = (css) => resolvePhysicalFamily(css) } = params$1;
	const renderedLines = [];
	const resolvedMarker = content.marker;
	const expandedRunsForBlock = expandRunsForInlineNewlines(block.runs);
	const isRtl = getParagraphInlineDirection(block.attrs) === "rtl";
	let renderedHeight = 0;
	content.lines.forEach((resolvedLine, index) => {
		const paragraphMarkLeftOffset = resolveResolvedListParagraphMarkOffset(resolvedLine.isListFirstLine ? resolvedMarker : void 0, markerTextWidth, resolvedLine.indentOffset);
		const lineEl = renderLine$1({
			block,
			line: resolvedLine.line,
			lineIndex: resolvedLine.lineIndex,
			isLastLine: index === content.lines.length - 1 && !content.continuesOnNext,
			availableWidth: resolvedLine.availableWidth,
			skipJustify: resolvedLine.skipJustify,
			preExpandedRuns: expandedRunsForBlock,
			resolvedListTextStartPx: resolvedLine.resolvedListTextStartPx,
			indentOffsetOverride: resolvedLine.indentOffset,
			paragraphMarkLeftOffsetOverride: paragraphMarkLeftOffset
		});
		if (!resolvedLine.isListFirstLine) applyResolvedLineIndentation(lineEl, block, content, resolvedLine);
		if (resolvedLine.paddingRightPx > 0) lineEl.style.paddingRight = `${resolvedLine.paddingRightPx}px`;
		if (resolvedLine.isListFirstLine && resolvedMarker) renderResolvedListMarker({
			doc: params$1.doc,
			lineEl,
			marker: resolvedMarker,
			isRtl,
			sourceAnchor,
			resolvePhysical
		});
		if (convertFinalParagraphMark && index === content.lines.length - 1 && !content.continuesOnNext) convertParagraphMarkToCellMark(lineEl);
		captureLineSnapshot?.(lineEl, {
			inTableParagraph: params$1.containerKind === "table-cell",
			wrapperEl: frameEl,
			sourceAnchor
		});
		frameEl.appendChild(lineEl);
		const height = resolvedLine.line.lineHeight;
		renderedLines.push({
			el: lineEl,
			top: lineTopOffset + renderedHeight,
			height
		});
		renderedHeight += height;
	});
	return {
		renderedHeight,
		renderedLines
	};
};
var renderMeasuredLines = (params$1) => {
	const { doc: doc$1, frameEl, block, measure, containerKind, width, localStartLine, localEndLine, linesOverride, lineIndexOffset = 0, continuesFromPrev, continuesOnNext, markerWidth, markerTextWidth, wordLayout, renderLine: renderLine$1, captureLineSnapshot, convertFinalParagraphMark, lineTopOffset = 0, sourceAnchor, resolvePhysical = (css) => resolvePhysicalFamily(css) } = params$1;
	const lines = linesOverride ?? measure.lines ?? [];
	const paraIndent = block.attrs?.indent;
	const paraIndentLeft = paraIndent?.left ?? 0;
	const paraIndentRight = paraIndent?.right ?? 0;
	const isRtl = getParagraphInlineDirection(block.attrs) === "rtl";
	const { anchorIndentPx: paraMarkerAnchorIndent, firstLinePx: markerFirstLine, hangingPx: markerHanging } = resolveMarkerIndent(paraIndent, isRtl);
	const wordLayoutIndentLeft = wordLayout?.indentLeftPx;
	const tableMarkerIndentLeft = measure.marker?.indentLeft ?? wordLayoutIndentLeft ?? (typeof paraIndent?.left === "number" ? paraIndent.left : 0);
	const suppressFirstLineIndent = block.attrs?.suppressFirstLineIndent === true;
	const firstLineOffset = suppressFirstLineIndent ? 0 : (paraIndent?.firstLine ?? 0) - (paraIndent?.hanging ?? 0);
	const expandedRunsForBlock = containerKind === "body-fragment" ? expandRunsForInlineNewlines(block.runs) : void 0;
	const paragraphEndsWithLineBreak = (block.runs.length > 0 ? block.runs[block.runs.length - 1] : null)?.kind === "lineBreak";
	const markerLayout = wordLayout?.marker;
	const markerMeasure = measure.marker;
	const legacyMarkerWidth = markerWidth ?? markerMeasure?.markerWidth;
	const legacyMarkerTextWidth = markerTextWidth ?? markerMeasure?.markerTextWidth;
	const listFirstLineTextStartPx = !continuesFromPrev && legacyMarkerWidth && markerLayout && markerMeasure ? resolvePainterListTextStartPx({
		wordLayout,
		indentLeftPx: containerKind === "table-cell" ? tableMarkerIndentLeft : paraMarkerAnchorIndent,
		hangingIndentPx: markerHanging,
		firstLineIndentPx: markerFirstLine,
		markerTextWidthPx: legacyMarkerTextWidth
	}) : void 0;
	let renderedHeight = 0;
	const renderedLines = [];
	const renderedLocalEndLine = Math.min(localEndLine, lines.length);
	for (let lineIdx = localStartLine; lineIdx < localEndLine && lineIdx < lines.length; lineIdx++) {
		const line = lines[lineIdx];
		const explicitSegmentPositioning = hasExplicitSegmentPositioning(line);
		const isFirstLine = lineIdx === 0 && !continuesFromPrev;
		const isListFirstLine = Boolean(lineIdx === 0 && !continuesFromPrev && legacyMarkerWidth && markerLayout);
		const shouldUseResolvedListTextStart = isListFirstLine && explicitSegmentPositioning && listFirstLineTextStartPx != null;
		const globalLineIndex = lineIndexOffset + lineIdx;
		const isLastLineOfParagraph = (linesOverride ? lineIdx === renderedLocalEndLine - 1 : globalLineIndex === (measure.lines?.length ?? lines.length) - 1) && !continuesOnNext;
		const shouldSkipJustifyForLastLine = isLastLineOfParagraph && !paragraphEndsWithLineBreak;
		const lineEl = renderLine$1({
			block,
			line,
			lineIndex: globalLineIndex,
			isLastLine: isLastLineOfParagraph,
			availableWidth: containerKind === "body-fragment" ? resolveAvailableWidthForLine({
				containerWidth: width,
				line,
				indentLeftPx: paraIndentLeft,
				indentRightPx: paraIndentRight,
				firstLineOffset,
				isFirstLine,
				isListFirstLine,
				resolvedListTextStartPx: shouldUseResolvedListTextStart ? listFirstLineTextStartPx : void 0
			}) : void 0,
			skipJustify: shouldSkipJustifyForLastLine,
			preExpandedRuns: expandedRunsForBlock,
			resolvedListTextStartPx: shouldUseResolvedListTextStart ? listFirstLineTextStartPx : void 0
		});
		lineEl.style.paddingLeft = "";
		lineEl.style.paddingRight = "";
		lineEl.style.textIndent = "";
		if (convertFinalParagraphMark && isLastLineOfParagraph) convertParagraphMarkToCellMark(lineEl);
		if (isListFirstLine && markerLayout && markerMeasure) {
			if (paraIndentRight > 0) lineEl.style.paddingRight = `${paraIndentRight}px`;
			renderLegacyListMarker({
				doc: doc$1,
				lineEl,
				wordLayout,
				markerLayout,
				markerMeasure,
				markerTextWidthPx: legacyMarkerTextWidth,
				indentLeftPx: containerKind === "table-cell" ? tableMarkerIndentLeft : paraMarkerAnchorIndent,
				hangingIndentPx: markerHanging,
				firstLineIndentPx: markerFirstLine,
				isRtl,
				sourceAnchor,
				resolvePhysical
			});
		} else applyParagraphLineIndentation({
			lineEl,
			line,
			indent: paraIndent,
			indentLeftPx: containerKind === "table-cell" ? tableMarkerIndentLeft : paraMarkerAnchorIndent,
			hasListMarkerLayout: Boolean(markerLayout),
			lineIndex: lineIdx,
			localStartLine,
			continuesFromPrev,
			suppressFirstLineIndent,
			resetContinuationTextIndent: containerKind === "body-fragment"
		});
		captureLineSnapshot?.(lineEl, {
			inTableParagraph: containerKind === "table-cell",
			wrapperEl: frameEl,
			sourceAnchor
		});
		frameEl.appendChild(lineEl);
		const height = line.lineHeight;
		renderedLines.push({
			el: lineEl,
			top: lineTopOffset + renderedHeight,
			height
		});
		renderedHeight += height;
	}
	return {
		renderedHeight,
		renderedLines
	};
};
var renderParagraphDropCap = (params$1) => {
	const { frameEl, block, measure, resolvedContent, continuesFromPrev, renderDropCap: renderDropCap$1 } = params$1;
	if (!renderDropCap$1) return;
	if (resolvedContent?.dropCap) {
		const dc = resolvedContent.dropCap;
		const dropCapEl = renderDropCap$1({
			mode: dc.mode,
			run: {
				text: dc.text,
				fontFamily: dc.fontFamily,
				fontSize: dc.fontSize,
				bold: dc.bold,
				italic: dc.italic,
				color: dc.color,
				position: dc.position
			},
			lines: 0
		}, dc.width != null && dc.height != null ? {
			width: dc.width,
			height: dc.height,
			lines: 0,
			mode: dc.mode
		} : void 0);
		frameEl.appendChild(dropCapEl);
		return;
	}
	const dropCapDescriptor = block.attrs?.dropCapDescriptor;
	const dropCapMeasure = measure.dropCap;
	if (dropCapDescriptor && dropCapMeasure && !continuesFromPrev) frameEl.appendChild(renderDropCap$1(dropCapDescriptor, dropCapMeasure));
};
var applyResolvedLineIndentation = (lineEl, block, content, resolvedLine) => {
	if (resolvedLine.paddingLeftPx > 0) lineEl.style.paddingLeft = `${resolvedLine.paddingLeftPx}px`;
	if (resolvedLine.textIndentPx !== 0) lineEl.style.textIndent = `${resolvedLine.textIndentPx}px`;
	else if (resolvedLine.lineIndex > 0 || content.continuesFromPrev) {
		const paraIndent = block.attrs?.indent;
		if ((block.attrs?.suppressFirstLineIndent === true ? 0 : (paraIndent?.firstLine ?? 0) - (paraIndent?.hanging ?? 0)) && !resolvedLine.isListFirstLine) lineEl.style.textIndent = "0px";
	}
};
var resolveResolvedListParagraphMarkOffset = (marker, markerTextWidth, indentOffset) => {
	if (!marker) return void 0;
	if (typeof indentOffset === "number" && Number.isFinite(indentOffset) && indentOffset > 0) return indentOffset;
	if (marker.vanish) return indentOffset;
	const paddingLeft = Number.isFinite(marker.firstLinePaddingLeftPx) ? marker.firstLinePaddingLeftPx : 0;
	const suffixWidth = marker.suffix !== "nothing" && Number.isFinite(marker.suffixWidthPx) ? marker.suffixWidthPx : 0;
	if (marker.justification === "left") return paddingLeft + (typeof markerTextWidth === "number" && Number.isFinite(markerTextWidth) && markerTextWidth > 0 ? markerTextWidth : 0) + suffixWidth;
	return paddingLeft + (marker.justification === "center" && Number.isFinite(marker.centerPaddingAdjustPx) ? marker.centerPaddingAdjustPx ?? 0 : 0) + suffixWidth;
};
var convertParagraphMarkToCellMark = (lineEl) => {
	const mark = lineEl.querySelector(".superdoc-formatting-paragraph-mark");
	if (!mark) return;
	mark.classList.add("superdoc-formatting-cell-mark");
	mark.textContent = "¤";
};
function getCellSegmentCount(cell) {
	if (cell.blocks && cell.blocks.length > 0) {
		let total = 0;
		for (const block of cell.blocks) if (block.kind === "paragraph") total += block.lines?.length || 0;
		else if (block.kind === "table") {
			const tableMeasure = block;
			for (const row of tableMeasure.rows) total += getEmbeddedRowSegmentCount(row);
		} else if (("height" in block ? block.height : 0) > 0) total += 1;
		return total;
	}
	if (cell.paragraph) return cell.paragraph.lines?.length || 0;
	return 0;
}
function getEmbeddedRowSegmentCount(row) {
	if (!row.cells.some((cell) => cell.blocks?.some((b$1) => b$1.kind === "table"))) return 1;
	let maxSegments = 0;
	for (const cell of row.cells) maxSegments = Math.max(maxSegments, getCellSegmentCount(cell));
	return maxSegments > 0 ? maxSegments : 1;
}
function getEmbeddedTableSegmentCount(tableMeasure) {
	let total = 0;
	for (const row of tableMeasure.rows) total += getEmbeddedRowSegmentCount(row);
	return total;
}
function computeVisibleHeight(rows, fromRow, toRow, partialRow) {
	let height = 0;
	for (let r$1 = fromRow; r$1 < toRow; r$1++) if (partialRow && partialRow.rowIndex === r$1) height += partialRow.partialHeight;
	else height += rows[r$1]?.height || 0;
	return height;
}
function computeCellVisibleHeight(cell, cellFrom, cellTo) {
	let cellVisHeight = 0;
	if (cell.blocks && cell.blocks.length > 0) {
		let segIdx = 0;
		for (const blk of cell.blocks) if (blk.kind === "paragraph") {
			const lines = blk.lines || [];
			for (const line of lines) {
				if (segIdx >= cellFrom && segIdx < cellTo) cellVisHeight += line.lineHeight || 0;
				segIdx++;
			}
		} else if (blk.kind === "table") {
			const nestedTable = blk;
			for (const nestedRow of nestedTable.rows) {
				const nestedRowSegs = getEmbeddedRowSegmentCount(nestedRow);
				for (let s = 0; s < nestedRowSegs; s++) {
					if (segIdx >= cellFrom && segIdx < cellTo) cellVisHeight += (nestedRow.height || 0) / nestedRowSegs;
					segIdx++;
				}
			}
		} else {
			const blkHeight = "height" in blk ? blk.height : 0;
			if (blkHeight > 0) {
				if (segIdx >= cellFrom && segIdx < cellTo) cellVisHeight += blkHeight;
				segIdx++;
			}
		}
	} else if (cell.paragraph) {
		const lines = cell.paragraph.lines || [];
		for (let i = 0; i < lines.length; i++) if (i >= cellFrom && i < cellTo) cellVisHeight += lines[i].lineHeight || 0;
	}
	return cellVisHeight;
}
var applyInlineStyles = (el, styles) => {
	Object.entries(styles).forEach(([key, value]) => {
		if (value != null && value !== "" && key in el.style) el.style[key] = String(value);
	});
};
var renderEmbeddedTable = (params$1) => {
	const { doc: doc$1, table, measure, availableWidth, context, renderLine: renderLine$1, captureLineSnapshot, renderDrawingContent, applySdtDataset: applySdtDataset$1, chrome, fromRow: paramFromRow, toRow: paramToRow, partialRow: paramPartialRow, sdtBoundary, ancestorContainerKey, ancestorContainerSdt, ancestorContainerKeys, ancestorContainerSdts, onSdtContainerChrome } = params$1;
	const effectiveFromRow = paramFromRow ?? 0;
	const effectiveToRow = paramToRow ?? table.rows.length;
	const visibleHeight = computeVisibleHeight(measure.rows, effectiveFromRow, effectiveToRow, paramPartialRow);
	const columnWidths = rescaleColumnWidths(measure.columnWidths, measure.totalWidth, availableWidth);
	const fragmentWidth = columnWidths ? availableWidth : measure.totalWidth;
	const fragment = {
		kind: "table",
		blockId: table.id,
		fromRow: effectiveFromRow,
		toRow: effectiveToRow,
		x: 0,
		y: 0,
		width: fragmentWidth,
		height: visibleHeight,
		columnWidths,
		partialRow: paramPartialRow
	};
	const effectiveColumnWidths = columnWidths ?? measure.columnWidths;
	const embeddedCellSpacingPx = measure.cellSpacingPx ?? getCellSpacingPx(table.attrs?.cellSpacing);
	const applyFragmentFrame = (el, frag) => {
		el.style.left = `${frag.x}px`;
		el.style.top = `${frag.y}px`;
		el.style.width = `${frag.width}px`;
		el.dataset.blockId = frag.blockId;
	};
	let hasSdtContainerChrome = false;
	return {
		element: renderTableFragment({
			doc: doc$1,
			fragment,
			context,
			block: table,
			measure,
			cellSpacingPx: embeddedCellSpacingPx,
			effectiveColumnWidths,
			renderLine: renderLine$1,
			captureLineSnapshot,
			renderDrawingContent,
			applyFragmentFrame,
			applySdtDataset: applySdtDataset$1,
			chrome,
			applyStyles: applyInlineStyles,
			sdtBoundary,
			ancestorContainerKey,
			ancestorContainerSdt,
			ancestorContainerKeys,
			ancestorContainerSdts,
			onSdtContainerChrome: () => {
				hasSdtContainerChrome = true;
				onSdtContainerChrome?.();
			}
		}),
		hasSdtContainerChrome
	};
};
function renderPartialEmbeddedTable(params$1) {
	const { doc: doc$1, block, blockMeasure: tableMeasure, cumulativeLineCount, globalFromLine, globalToLine, contentWidthPx, context, renderLine: renderLine$1, captureLineSnapshot, renderDrawingContent, applySdtDataset: applySdtDataset$1, chrome, sdtBoundary, ancestorContainerKey, ancestorContainerSdt, ancestorContainerKeys, ancestorContainerSdts, onSdtContainerChrome } = params$1;
	const rowSegmentCounts = tableMeasure.rows.map((row) => getEmbeddedRowSegmentCount(row));
	const totalTableSegments = rowSegmentCounts.reduce((s, c) => s + c, 0);
	const tableStartSegment = cumulativeLineCount;
	const nextCumulativeLineCount = cumulativeLineCount + totalTableSegments;
	if (nextCumulativeLineCount <= globalFromLine || tableStartSegment >= globalToLine) return {
		element: null,
		height: 0,
		nextCumulativeLineCount,
		hasSdtContainerChrome: false
	};
	const localFrom = Math.max(0, globalFromLine - tableStartSegment);
	const localTo = Math.min(totalTableSegments, globalToLine - tableStartSegment);
	let segmentOffset = 0;
	let embeddedFromRow = -1;
	let embeddedToRow = -1;
	let partialRowInfo;
	for (let r$1 = 0; r$1 < tableMeasure.rows.length; r$1++) {
		const rowSegs = rowSegmentCounts[r$1];
		const rowStart = segmentOffset;
		const rowEnd = segmentOffset + rowSegs;
		segmentOffset = rowEnd;
		if (rowEnd <= localFrom || rowStart >= localTo) continue;
		if (embeddedFromRow === -1) embeddedFromRow = r$1;
		embeddedToRow = r$1 + 1;
		if (rowSegs > 1 && (rowStart < localFrom || rowEnd > localTo)) {
			const rowLocalFrom = Math.max(0, localFrom - rowStart);
			const rowLocalTo = Math.min(rowSegs, localTo - rowStart);
			const row = tableMeasure.rows[r$1];
			const fromLineByCell = [];
			const toLineByCell = [];
			let partialHeight = 0;
			for (const cell of row.cells) {
				const cellTotal = getCellSegmentCount(cell);
				const cellFrom = Math.min(rowLocalFrom, cellTotal);
				const cellTo = Math.min(rowLocalTo, cellTotal);
				fromLineByCell.push(cellFrom);
				toLineByCell.push(cellTo);
				partialHeight = Math.max(partialHeight, computeCellVisibleHeight(cell, cellFrom, cellTo));
			}
			partialRowInfo = {
				rowIndex: r$1,
				fromLineByCell,
				toLineByCell,
				isFirstPart: rowLocalFrom === 0,
				isLastPart: rowLocalTo >= rowSegs,
				partialHeight
			};
		}
	}
	if (embeddedFromRow === -1) return {
		element: null,
		height: 0,
		nextCumulativeLineCount,
		hasSdtContainerChrome: false
	};
	const visibleHeight = computeVisibleHeight(tableMeasure.rows, embeddedFromRow, embeddedToRow, partialRowInfo);
	const effectiveSdtBoundary = sdtBoundary ? {
		...sdtBoundary,
		isStart: (sdtBoundary.isStart ?? true) && localFrom === 0,
		isEnd: (sdtBoundary.isEnd ?? true) && localTo >= totalTableSegments,
		showLabel: sdtBoundary.showLabel === void 0 ? void 0 : sdtBoundary.showLabel && localFrom === 0
	} : void 0;
	const tableWrapper = doc$1.createElement("div");
	tableWrapper.style.position = "relative";
	tableWrapper.style.width = "100%";
	tableWrapper.style.height = `${visibleHeight}px`;
	tableWrapper.style.flexShrink = "0";
	tableWrapper.style.boxSizing = "border-box";
	const tableResult = renderEmbeddedTable({
		doc: doc$1,
		table: block,
		measure: tableMeasure,
		availableWidth: contentWidthPx,
		context: {
			...context,
			section: "body"
		},
		renderLine: renderLine$1,
		captureLineSnapshot,
		renderDrawingContent,
		applySdtDataset: applySdtDataset$1,
		chrome,
		fromRow: embeddedFromRow,
		toRow: embeddedToRow,
		partialRow: partialRowInfo,
		sdtBoundary: effectiveSdtBoundary,
		ancestorContainerKey,
		ancestorContainerSdt,
		ancestorContainerKeys,
		ancestorContainerSdts,
		onSdtContainerChrome
	});
	tableWrapper.appendChild(tableResult.element);
	return {
		element: tableWrapper,
		height: visibleHeight,
		nextCumulativeLineCount,
		hasSdtContainerChrome: tableResult.hasSdtContainerChrome
	};
}
const renderTableCell = (deps) => {
	const { doc: doc$1, x, y: y$1, rowHeight, cellMeasure, cell, borders, useDefaultBorder, renderLine: renderLine$1, captureLineSnapshot, renderDrawingContent, context, applySdtDataset: applySdtDataset$1, chrome, ancestorContainerKey, ancestorContainerSdt, ancestorContainerKeys, ancestorContainerSdts, onSdtContainerChrome, tableIndent, isRtl, cellWidth, fromLine, toLine, resolvePhysical } = deps;
	const padding = (cell?.attrs)?.padding || {
		top: 0,
		left: 4,
		right: 4,
		bottom: 0
	};
	const buildTableImageHyperlinkAnchor = (imageEl, hyperlink, display) => buildImageHyperlinkAnchor(doc$1, imageEl, hyperlink, display);
	const paddingLeft = isRtl ? padding.right ?? 4 : padding.left ?? 4;
	const paddingTop = padding.top ?? 0;
	const paddingRight = isRtl ? padding.left ?? 4 : padding.right ?? 4;
	const paddingBottom = padding.bottom ?? 0;
	const cellEl = doc$1.createElement("div");
	cellEl.style.position = "absolute";
	cellEl.style.left = `${x}px`;
	cellEl.style.top = `${y$1}px`;
	cellEl.style.width = `${cellWidth ?? cellMeasure.width}px`;
	cellEl.style.height = `${rowHeight}px`;
	cellEl.style.boxSizing = "border-box";
	cellEl.style.overflow = "hidden";
	cellEl.style.paddingLeft = `${paddingLeft}px`;
	cellEl.style.paddingTop = `${paddingTop}px`;
	cellEl.style.paddingRight = `${paddingRight}px`;
	cellEl.style.paddingBottom = `${paddingBottom}px`;
	if (borders) applyCellBorders(cellEl, borders);
	else if (useDefaultBorder) cellEl.style.border = "1px solid rgba(0,0,0,0.6)";
	if (cell?.attrs?.background) cellEl.style.backgroundColor = cell.attrs.background;
	const cellBlocks = cell?.blocks ?? (cell?.paragraph ? [cell.paragraph] : []);
	const blockMeasures = cellMeasure?.blocks ?? (cellMeasure?.paragraph ? [cellMeasure.paragraph] : []);
	const sdtBoundaries = getSdtSiblingBoundaries(cellBlocks.map((block) => block.kind === "paragraph" || block.kind === "table" ? getSdtContainerKeyForBlock(block) : null));
	if (cellBlocks.length > 0 && blockMeasures.length > 0) {
		const content = doc$1.createElement("div");
		content.style.position = "relative";
		content.style.width = "100%";
		content.style.height = "100%";
		content.style.display = "flex";
		content.style.flexDirection = "column";
		if (cell?.attrs?.verticalAlign === "center") content.style.justifyContent = "center";
		else if (cell?.attrs?.verticalAlign === "bottom") content.style.justifyContent = "flex-end";
		else content.style.justifyContent = "flex-start";
		cellEl.appendChild(content);
		content.style.zIndex = "0";
		const blockLineCounts = [];
		for (let i = 0; i < Math.min(blockMeasures.length, cellBlocks.length); i++) {
			const bm = blockMeasures[i];
			if (bm.kind === "paragraph") blockLineCounts.push(bm.lines?.length || 0);
			else if (bm.kind === "table") blockLineCounts.push(getEmbeddedTableSegmentCount(bm));
			else {
				const blockHeight = "height" in bm ? bm.height : 0;
				blockLineCounts.push(blockHeight > 0 ? 1 : 0);
			}
		}
		const totalLines = blockLineCounts.reduce((a, b$1) => a + b$1, 0);
		const globalFromLine = fromLine ?? 0;
		const globalToLine = toLine === -1 || toLine === void 0 ? totalLines : toLine;
		const effectiveCellWidth = cellWidth ?? cellMeasure.width;
		const contentWidthPx = Math.max(0, effectiveCellWidth - paddingLeft - paddingRight);
		const contentHeightPx = Math.max(0, rowHeight - paddingTop - paddingBottom);
		let flowCursorY = 0;
		const anchoredBlocks = [];
		const renderedLines = [];
		let cumulativeLineCount = 0;
		for (let i = 0; i < Math.min(blockMeasures.length, cellBlocks.length); i++) {
			const blockMeasure = blockMeasures[i];
			const block = cellBlocks[i];
			if (blockMeasure.kind === "table" && block?.kind === "table") {
				const result = renderPartialEmbeddedTable({
					doc: doc$1,
					block,
					blockMeasure,
					cumulativeLineCount,
					globalFromLine,
					globalToLine,
					contentWidthPx,
					context,
					renderLine: renderLine$1,
					captureLineSnapshot,
					renderDrawingContent,
					applySdtDataset: applySdtDataset$1,
					chrome,
					sdtBoundary: sdtBoundaries[i],
					ancestorContainerKey,
					ancestorContainerSdt,
					ancestorContainerKeys,
					ancestorContainerSdts,
					onSdtContainerChrome
				});
				cumulativeLineCount = result.nextCumulativeLineCount;
				if (result.element) {
					content.appendChild(result.element);
					flowCursorY += result.height;
				}
				if (result.hasSdtContainerChrome) cellEl.style.overflow = "visible";
				continue;
			}
			if (blockMeasure.kind === "image" && block?.kind === "image") {
				if (block.anchor?.isAnchored) {
					anchoredBlocks.push({
						block,
						measure: blockMeasure
					});
					if (blockMeasure.height > 0) cumulativeLineCount += 1;
					continue;
				}
				const imgSegmentIndex = cumulativeLineCount;
				cumulativeLineCount += 1;
				if (imgSegmentIndex < globalFromLine || imgSegmentIndex >= globalToLine) continue;
				const imageWrapper = doc$1.createElement("div");
				imageWrapper.style.position = "relative";
				imageWrapper.style.width = `${blockMeasure.width}px`;
				imageWrapper.style.height = `${blockMeasure.height}px`;
				imageWrapper.style.flexShrink = "0";
				imageWrapper.style.maxWidth = "100%";
				imageWrapper.style.boxSizing = "border-box";
				applySdtDataset$1(imageWrapper, block.attrs?.sdt);
				imageWrapper.appendChild(createBlockImageContent({
					doc: doc$1,
					block,
					className: "superdoc-table-image",
					clipContainer: imageWrapper,
					imageDisplay: "block",
					buildImageHyperlinkAnchor: buildTableImageHyperlinkAnchor
				}));
				content.appendChild(imageWrapper);
				flowCursorY += blockMeasure.height;
				continue;
			}
			if (blockMeasure.kind === "drawing" && block?.kind === "drawing") {
				if (block.anchor?.isAnchored) {
					anchoredBlocks.push({
						block,
						measure: blockMeasure
					});
					if (blockMeasure.height > 0) cumulativeLineCount += 1;
					continue;
				}
				const drawSegmentIndex = cumulativeLineCount;
				cumulativeLineCount += 1;
				if (drawSegmentIndex < globalFromLine || drawSegmentIndex >= globalToLine) continue;
				const drawingWrapper = doc$1.createElement("div");
				drawingWrapper.style.position = "relative";
				drawingWrapper.style.width = `${blockMeasure.width}px`;
				drawingWrapper.style.height = `${blockMeasure.height}px`;
				drawingWrapper.style.flexShrink = "0";
				drawingWrapper.style.maxWidth = "100%";
				drawingWrapper.style.boxSizing = "border-box";
				drawingWrapper.dataset.blockId = block.id;
				applySdtDataset$1(drawingWrapper, block.attrs);
				const drawingInner = doc$1.createElement("div");
				drawingInner.classList.add("superdoc-table-drawing");
				drawingInner.style.width = "100%";
				drawingInner.style.height = "100%";
				drawingInner.style.display = "flex";
				drawingInner.style.alignItems = "center";
				drawingInner.style.justifyContent = "center";
				drawingInner.style.overflow = "hidden";
				if (block.drawingKind === "image" && "src" in block && block.src) drawingInner.appendChild(createBlockImageContent({
					doc: doc$1,
					block,
					className: "superdoc-drawing-image",
					clipContainer: drawingInner,
					imageDisplay: "block",
					buildImageHyperlinkAnchor: buildTableImageHyperlinkAnchor
				}));
				else if (renderDrawingContent) {
					const drawingContent = renderDrawingContent(block);
					drawingContent.style.width = "100%";
					drawingContent.style.height = "100%";
					drawingInner.appendChild(drawingContent);
				} else {
					const placeholder = doc$1.createElement("div");
					placeholder.classList.add("superdoc-drawing-placeholder");
					placeholder.style.width = "100%";
					placeholder.style.height = "100%";
					const stripePattern = "repeating-linear-gradient(45deg, rgba(15,23,42,0.1), rgba(15,23,42,0.1) 6px, rgba(15,23,42,0.2) 6px, rgba(15,23,42,0.2) 12px)";
					placeholder.style.background = stripePattern;
					placeholder.style.backgroundImage = stripePattern;
					placeholder.style.border = "1px dashed rgba(15, 23, 42, 0.3)";
					drawingInner.appendChild(placeholder);
				}
				drawingWrapper.appendChild(drawingInner);
				content.appendChild(drawingWrapper);
				flowCursorY += blockMeasure.height;
				continue;
			}
			if (blockMeasure.kind === "paragraph" && block?.kind === "paragraph") {
				const paragraphMeasure = blockMeasure;
				const blockLineCount = paragraphMeasure.lines?.length || 0;
				const isLastBlockInCell = i === Math.min(blockMeasures.length, cellBlocks.length) - 1;
				const wordLayout = block.attrs?.wordLayout ?? null;
				const blockStartGlobal = cumulativeLineCount;
				if (cumulativeLineCount + blockLineCount <= globalFromLine) {
					cumulativeLineCount += blockLineCount;
					continue;
				}
				if (blockStartGlobal >= globalToLine) {
					cumulativeLineCount += blockLineCount;
					continue;
				}
				const localStartLine = Math.max(0, globalFromLine - blockStartGlobal);
				const localEndLine = Math.min(blockLineCount, globalToLine - blockStartGlobal);
				const paraWrapper = doc$1.createElement("div");
				paraWrapper.style.position = "relative";
				paraWrapper.style.left = "0";
				paraWrapper.style.width = "100%";
				const baseSdtBoundary = sdtBoundaries[i];
				const sdtBoundary = baseSdtBoundary ? {
					...baseSdtBoundary,
					isStart: (baseSdtBoundary.isStart ?? true) && localStartLine === 0,
					isEnd: (baseSdtBoundary.isEnd ?? true) && localEndLine >= blockLineCount,
					showLabel: baseSdtBoundary.showLabel === void 0 ? void 0 : baseSdtBoundary.showLabel && localStartLine === 0
				} : void 0;
				content.appendChild(paraWrapper);
				const result = renderParagraphContent({
					doc: doc$1,
					frameEl: paraWrapper,
					block,
					measure: paragraphMeasure,
					containerKind: "table-cell",
					width: contentWidthPx,
					localStartLine,
					localEndLine,
					wordLayout: wordLayout ?? void 0,
					spacingPolicy: {
						isFirstBlock: i === 0,
						isLastBlock: isLastBlockInCell,
						paddingTop
					},
					sdtBoundary,
					ancestorContainerKey,
					ancestorContainerSdt,
					ancestorContainerKeys,
					ancestorContainerSdts,
					onSdtContainerChrome: () => {
						cellEl.style.overflow = "visible";
						onSdtContainerChrome?.();
					},
					contentControlsChrome: chrome,
					applySdtDataset: applySdtDataset$1,
					resolvePhysical,
					renderLine: ({ block: block$1, line, lineIndex, isLastLine, resolvedListTextStartPx }) => renderLine$1(block$1, line, {
						...context,
						section: "body"
					}, lineIndex, isLastLine, resolvedListTextStartPx),
					convertFinalParagraphMark: isLastBlockInCell,
					lineTopOffset: flowCursorY
				});
				renderedLines.push(...result.renderedLines);
				flowCursorY += result.totalHeight;
				cumulativeLineCount += blockLineCount;
			}
		}
		const verticalAlign = cell?.attrs?.verticalAlign;
		const remainingSpace = contentHeightPx - flowCursorY;
		const alignmentOffsetY = verticalAlign === "center" ? Math.max(0, remainingSpace / 2) : verticalAlign === "bottom" ? Math.max(0, remainingSpace) : 0;
		const wrapExclusions = [];
		for (const entry of anchoredBlocks) {
			const anchoredBlock = entry.block;
			const anchoredMeasure = entry.measure;
			const anchor = anchoredBlock.anchor;
			if (!anchor || !anchor.isAnchored) continue;
			const objectWidth = anchoredMeasure.width;
			const objectHeight = anchoredMeasure.height;
			const baseLeft = anchor.offsetH ?? 0;
			const indentOffset = typeof tableIndent === "number" && Number.isFinite(tableIndent) ? tableIndent : 0;
			const left$1 = anchor.hRelativeFrom === "column" ? baseLeft - x - indentOffset : baseLeft;
			const top$1 = anchor.offsetV ?? 0;
			const behindDoc = anchor.behindDoc === true || anchoredBlock.wrap?.type === "None" && anchoredBlock.wrap?.behindDoc;
			const zIndex = typeof anchoredBlock.zIndex === "number" ? anchoredBlock.zIndex : normalizeZIndex(anchoredBlock.attrs?.originalAttributes) ?? (behindDoc ? -1 : 1);
			const wrap = anchoredBlock.wrap;
			if (!behindDoc && wrap?.type === "Square") {
				const wrapText = wrap.wrapText ?? "bothSides";
				const distLeft = anchoredBlock.padding?.left ?? 0;
				const distRight = anchoredBlock.padding?.right ?? 0;
				const distTop = anchoredBlock.padding?.top ?? 0;
				const distBottom = anchoredBlock.padding?.bottom ?? 0;
				wrapExclusions.push({
					left: left$1 - distLeft,
					right: left$1 + objectWidth + distRight,
					top: top$1 - distTop,
					bottom: top$1 + objectHeight + distBottom,
					wrapText
				});
			}
			if (anchoredBlock.kind === "image") {
				const imageWrapper = doc$1.createElement("div");
				imageWrapper.style.position = "absolute";
				imageWrapper.style.left = `${left$1}px`;
				imageWrapper.style.top = `${top$1}px`;
				imageWrapper.style.width = `${objectWidth}px`;
				imageWrapper.style.height = `${objectHeight}px`;
				imageWrapper.style.maxWidth = "100%";
				imageWrapper.style.boxSizing = "border-box";
				imageWrapper.style.zIndex = String(zIndex);
				applySdtDataset$1(imageWrapper, anchoredBlock.attrs?.sdt);
				imageWrapper.appendChild(createBlockImageContent({
					doc: doc$1,
					block: anchoredBlock,
					className: "superdoc-table-image",
					clipContainer: imageWrapper,
					imageDisplay: "block",
					buildImageHyperlinkAnchor: buildTableImageHyperlinkAnchor
				}));
				content.appendChild(imageWrapper);
			} else {
				const drawingWrapper = doc$1.createElement("div");
				drawingWrapper.style.position = "absolute";
				drawingWrapper.style.left = `${left$1}px`;
				drawingWrapper.style.top = `${top$1}px`;
				drawingWrapper.style.width = `${objectWidth}px`;
				drawingWrapper.style.height = `${objectHeight}px`;
				drawingWrapper.style.maxWidth = "100%";
				drawingWrapper.style.boxSizing = "border-box";
				drawingWrapper.style.zIndex = String(zIndex);
				drawingWrapper.dataset.blockId = anchoredBlock.id;
				applySdtDataset$1(drawingWrapper, anchoredBlock.attrs);
				const drawingInner = doc$1.createElement("div");
				drawingInner.classList.add("superdoc-table-drawing");
				drawingInner.style.width = "100%";
				drawingInner.style.height = "100%";
				drawingInner.style.display = "flex";
				drawingInner.style.alignItems = "center";
				drawingInner.style.justifyContent = "center";
				drawingInner.style.overflow = "hidden";
				if (anchoredBlock.drawingKind === "image" && "src" in anchoredBlock && anchoredBlock.src) drawingInner.appendChild(createBlockImageContent({
					doc: doc$1,
					block: anchoredBlock,
					className: "superdoc-drawing-image",
					clipContainer: drawingInner,
					imageDisplay: "block",
					buildImageHyperlinkAnchor: buildTableImageHyperlinkAnchor
				}));
				else if (renderDrawingContent) {
					const drawingContent = renderDrawingContent(anchoredBlock);
					drawingContent.style.width = "100%";
					drawingContent.style.height = "100%";
					drawingInner.appendChild(drawingContent);
				} else {
					const placeholder = doc$1.createElement("div");
					placeholder.classList.add("superdoc-drawing-placeholder");
					placeholder.style.width = "100%";
					placeholder.style.height = "100%";
					const stripePattern = "repeating-linear-gradient(45deg, rgba(15,23,42,0.1), rgba(15,23,42,0.1) 6px, rgba(15,23,42,0.2) 6px, rgba(15,23,42,0.2) 12px)";
					placeholder.style.background = stripePattern;
					placeholder.style.backgroundImage = stripePattern;
					placeholder.style.border = "1px dashed rgba(15, 23, 42, 0.3)";
					drawingInner.appendChild(placeholder);
				}
				drawingWrapper.appendChild(drawingInner);
				content.appendChild(drawingWrapper);
			}
		}
		applySquareWrapExclusionsToLines(renderedLines, wrapExclusions, contentWidthPx, alignmentOffsetY);
		if (captureLineSnapshot) for (const rendered of renderedLines) {
			const candidateLine = rendered.el.classList.contains("superdoc-line") ? rendered.el : rendered.el.querySelector(".superdoc-line");
			if (!(candidateLine instanceof HTMLElement)) continue;
			const wrapperEl = rendered.el.classList.contains("superdoc-line") ? void 0 : rendered.el;
			captureLineSnapshot(candidateLine, {
				...context,
				section: "body"
			}, {
				inTableParagraph: false,
				wrapperEl
			});
		}
	}
	return { cellElement: cellEl };
};
var TRACK_CHANGE_BASE_CLASS = {
	insert: "track-insert-dec",
	delete: "track-delete-dec",
	format: "track-format-dec"
};
var TRACK_CHANGE_OVERLAP_INSERT_DELETE_CLASS = "track-overlap-insert-delete-dec";
var TRACK_CHANGE_BACKGROUND_ALPHA = 34;
var TRACK_CHANGE_BACKGROUND_FOCUSED_ALPHA = 68;
var expandHexColor = (hex) => {
	const normalized = hex.replace("#", "");
	if (normalized.length === 3) return normalized.split("").map((char) => char + char).join("");
	if (normalized.length === 6 || normalized.length === 8) return normalized.slice(0, 6);
	return null;
};
var colorWithAlpha = (color, alpha) => {
	const expanded = color.trim().startsWith("#") ? expandHexColor(color.trim()) : null;
	if (!expanded) return color;
	return `#${expanded}${Math.max(0, Math.min(255, alpha)).toString(16).padStart(2, "0")}`;
};
var setColorVar = (elem, name, value) => {
	elem.style.setProperty(name, value);
};
var applyAuthorColorVariables = (elem, layer) => {
	const color = layer.color;
	if (!color) return;
	const background = colorWithAlpha(color, TRACK_CHANGE_BACKGROUND_ALPHA);
	const backgroundFocused = colorWithAlpha(color, TRACK_CHANGE_BACKGROUND_FOCUSED_ALPHA);
	switch (layer.kind) {
		case "insert":
			setColorVar(elem, "--sd-tracked-changes-insert-border", color);
			setColorVar(elem, "--sd-tracked-changes-insert-background", background);
			setColorVar(elem, "--sd-tracked-changes-insert-background-focused", backgroundFocused);
			break;
		case "delete":
			setColorVar(elem, "--sd-tracked-changes-delete-border", color);
			setColorVar(elem, "--sd-tracked-changes-delete-background", background);
			setColorVar(elem, "--sd-tracked-changes-delete-background-focused", backgroundFocused);
			setColorVar(elem, "--sd-tracked-changes-delete-text", color);
			break;
		case "format":
			setColorVar(elem, "--sd-tracked-changes-format-border", color);
			setColorVar(elem, "--sd-tracked-changes-format-background", background);
			setColorVar(elem, "--sd-tracked-changes-format-background-focused", backgroundFocused);
			break;
		default: break;
	}
};
var TRACK_CHANGE_MODIFIER_CLASS = {
	insert: {
		review: "highlighted",
		original: "hidden",
		final: "normal",
		off: void 0
	},
	delete: {
		review: "highlighted",
		original: "normal",
		final: "hidden",
		off: void 0
	},
	format: {
		review: "highlighted",
		original: "before",
		final: "normal",
		off: void 0
	}
};
const getTrackedChangeLayers$1 = (run) => {
	if (Array.isArray(run.trackedChanges) && run.trackedChanges.length > 0) return run.trackedChanges;
	return run.trackedChange ? [run.trackedChange] : [];
};
var resolveInsertDeleteOverlap = (layers) => {
	for (const parentInsert of layers) {
		if (parentInsert.kind !== "insert") continue;
		const childDelete = layers.find((layer) => layer.kind === "delete" && layer.overlapParentId === parentInsert.id);
		if (childDelete) return {
			parentInsert,
			childDelete
		};
	}
};
const resolveTrackedChangesConfig = (block) => {
	const attrs = block.attrs ?? {};
	return {
		mode: attrs.trackedChangesMode ?? "review",
		enabled: attrs.trackedChangesEnabled !== false
	};
};
var TRACK_CHANGE_ROW_CELL_CLASS = "track-row-cell-dec";
const applyRowTrackedChangeToCell = (elem, meta, config) => {
	if (!config.enabled || config.mode === "off") return;
	if (meta.kind !== "insert" && meta.kind !== "delete") return;
	const baseClass = TRACK_CHANGE_BASE_CLASS[meta.kind];
	if (baseClass) elem.classList.add(baseClass);
	elem.classList.add(TRACK_CHANGE_ROW_CELL_CLASS);
	const modifier = TRACK_CHANGE_MODIFIER_CLASS[meta.kind]?.[config.mode];
	if (modifier) elem.classList.add(modifier);
	applyAuthorColorVariables(elem, meta);
	elem.dataset.trackChangeId = meta.id;
	elem.dataset.trackChangeKind = meta.kind;
	elem.dataset.trackChangeStructural = "row";
	elem.dataset.storyKey = meta.storyKey ?? "body";
	if (meta.author) elem.dataset.trackChangeAuthor = meta.author;
	if (meta.authorEmail) elem.dataset.trackChangeAuthorEmail = meta.authorEmail;
	if (meta.date) elem.dataset.trackChangeDate = meta.date;
};
const applyTrackedChangeDecorations = (elem, run, config) => {
	if (!config.enabled || config.mode === "off") return;
	const textRun = run;
	const layers = getTrackedChangeLayers$1(textRun);
	if (layers.length === 0) return;
	const overlap = resolveInsertDeleteOverlap(layers);
	const meta = overlap?.parentInsert ?? textRun.trackedChange ?? layers[0];
	layers.forEach((layer) => {
		const baseClass = TRACK_CHANGE_BASE_CLASS[layer.kind];
		if (baseClass) elem.classList.add(baseClass);
		const modifier = TRACK_CHANGE_MODIFIER_CLASS[layer.kind]?.[config.mode];
		if (modifier) elem.classList.add(modifier);
		applyAuthorColorVariables(elem, layer);
	});
	if (overlap) {
		elem.classList.add(TRACK_CHANGE_OVERLAP_INSERT_DELETE_CLASS);
		elem.dataset.trackChangePreferredTargetId = overlap.childDelete.id;
	}
	elem.dataset.trackChangeId = meta.id;
	elem.dataset.trackChangeKind = meta.kind;
	elem.dataset.trackChangeIds = layers.map((layer) => layer.id).join(",");
	elem.dataset.trackChangeKinds = layers.map((layer) => layer.kind).join(",");
	elem.dataset.storyKey = meta.storyKey ?? "body";
	if (meta.author) elem.dataset.trackChangeAuthor = meta.author;
	if (meta.authorEmail) elem.dataset.trackChangeAuthorEmail = meta.authorEmail;
	if (meta.authorImage) elem.dataset.trackChangeAuthorImage = meta.authorImage;
	if (meta.date) elem.dataset.trackChangeDate = meta.date;
};
var hasAnyResolvedBorder = (borders) => Boolean(borders.top || borders.right || borders.bottom || borders.left);
var resolveRenderedCellBorders = ({ cellBorders, hasBordersAttribute, tableBorders, cellPosition, cellSpacingPx, continuesFromPrev, continuesOnNext, aboveCellBorders, leftCellBorders, rightCellBorders, nextRowLeavesRightGap, deferTopToAboveCell, nextRowSuppressesSharedTop }) => {
	const hasExplicitBorders = hasExplicitCellBorders(cellBorders);
	const cellBounds = getTableCellGridBounds(cellPosition);
	const touchesTopBoundary = cellBounds.touchesTopEdge || continuesFromPrev;
	const touchesBottomBoundary = cellBounds.touchesBottomEdge || continuesOnNext || nextRowLeavesRightGap === true;
	const hasInteriorNeighborBorder = !touchesTopBoundary && !deferTopToAboveCell && isPresentBorder(aboveCellBorders?.bottom) || !cellBounds.touchesLeftEdge && isPresentBorder(leftCellBorders?.right);
	if (cellSpacingPx === 0 && (hasExplicitBorders || hasInteriorNeighborBorder)) {
		const cb = cellBorders ?? {};
		return {
			top: touchesTopBoundary ? resolveTableBorderValue(cb.top, tableBorders?.top) : deferTopToAboveCell ? void 0 : resolveBorderConflict(cb.top, aboveCellBorders?.bottom) ?? (isExplicitNoneBorder(cb.top) && isExplicitNoneBorder(aboveCellBorders?.bottom) ? void 0 : borderValueToSpec(tableBorders?.insideH)),
			left: cellBounds.touchesLeftEdge ? resolveTableBorderValue(cb.left, tableBorders?.left) : isPresentBorder(cb.left) ? resolveBorderConflict(cb.left, leftCellBorders?.right) ?? borderValueToSpec(tableBorders?.insideV) : isPresentBorder(leftCellBorders?.right) ? void 0 : isExplicitNoneBorder(cb.left) && isExplicitNoneBorder(leftCellBorders?.right) ? void 0 : borderValueToSpec(tableBorders?.insideV),
			right: cellBounds.touchesRightEdge ? resolveTableBorderValue(cb.right, tableBorders?.right) : isPresentBorder(cb.right) && !isPresentBorder(rightCellBorders?.left) ? cb.right : void 0,
			bottom: touchesBottomBoundary ? resolveTableBorderValue(cb.bottom, tableBorders?.bottom) : void 0
		};
	}
	if (hasBordersAttribute && !hasExplicitBorders) return;
	if (!tableBorders) return hasExplicitBorders ? {
		top: cellBorders.top,
		right: cellBorders.right,
		bottom: cellBorders.bottom,
		left: cellBorders.left
	} : void 0;
	if (hasExplicitBorders) return {
		top: resolveTableBorderValue(cellBorders.top, touchesTopBoundary ? tableBorders.top : tableBorders.insideH),
		right: resolveTableBorderValue(cellBorders.right, cellBounds.touchesRightEdge ? tableBorders.right : void 0),
		bottom: resolveTableBorderValue(cellBorders.bottom, touchesBottomBoundary ? tableBorders.bottom : void 0),
		left: resolveTableBorderValue(cellBorders.left, cellBounds.touchesLeftEdge ? tableBorders.left : tableBorders.insideV)
	};
	if (cellSpacingPx > 0) {
		const interiorBorders = {
			top: touchesTopBoundary ? void 0 : borderValueToSpec(tableBorders.insideH),
			right: cellBounds.touchesRightEdge ? void 0 : borderValueToSpec(tableBorders.insideV),
			bottom: touchesBottomBoundary ? void 0 : borderValueToSpec(tableBorders.insideH),
			left: cellBounds.touchesLeftEdge ? void 0 : borderValueToSpec(tableBorders.insideV)
		};
		return hasAnyResolvedBorder(interiorBorders) ? interiorBorders : void 0;
	}
	const baseBorders = resolveTableCellBorders(tableBorders, cellPosition);
	const insideHSpec = borderValueToSpec(tableBorders.insideH);
	const interiorBottom = nextRowSuppressesSharedTop && isPresentBorder(insideHSpec) ? insideHSpec : baseBorders.bottom;
	return {
		top: touchesTopBoundary ? borderValueToSpec(tableBorders.top) : baseBorders.top,
		right: baseBorders.right,
		bottom: touchesBottomBoundary ? borderValueToSpec(tableBorders.bottom) : interiorBottom,
		left: baseBorders.left
	};
};
const renderTableRow = (deps) => {
	const { doc: doc$1, container, rowIndex, y: y$1, rowMeasure, row, prevRow, prevRowMeasure, nextRow, nextRowMeasure, rowOccupiedRightCol, nextRowOccupiedRightCol, totalRows, tableBorders, columnWidths, allRowHeights, tableIndent, isRtl, context, renderLine: renderLine$1, captureLineSnapshot, renderDrawingContent, applySdtDataset: applySdtDataset$1, ancestorContainerKey, ancestorContainerSdt, ancestorContainerKeys, ancestorContainerSdts, onSdtContainerChrome, continuesFromPrev, continuesOnNext, partialRow, cellSpacingPx = 0, chrome, resolvePhysical } = deps;
	const totalCols = columnWidths.length;
	const rowTrackedChange = row?.attrs?.trackedChange;
	let rowTrackedChangeConfig;
	if (rowTrackedChange) {
		let representativeParagraph;
		for (const cell of row?.cells ?? []) {
			const candidate = cell.paragraph ?? cell.blocks?.find((block) => block.kind === "paragraph");
			if (candidate) {
				representativeParagraph = candidate;
				break;
			}
		}
		rowTrackedChangeConfig = representativeParagraph ? resolveTrackedChangesConfig(representativeParagraph) : {
			mode: "review",
			enabled: true
		};
	}
	const rowRightEdgeCol = rowOccupiedRightCol != null && rowOccupiedRightCol > 0 ? Math.min(totalCols, rowOccupiedRightCol) : rowMeasure.cells.length ? Math.min(totalCols, Math.max(...rowMeasure.cells.map((c) => (c.gridColumnStart ?? 0) + (c.colSpan ?? 1)))) : totalCols;
	const rowBorderOverride = row?.attrs?.borders;
	const effectiveTableBorders = rowBorderOverride ? {
		...tableBorders ?? {},
		...rowBorderOverride
	} : tableBorders;
	const nextRowBorderOverride = nextRow?.attrs?.borders;
	const nextRowEffectiveInsideH = nextRowBorderOverride ? {
		...tableBorders ?? {},
		...nextRowBorderOverride
	}.insideH : void 0;
	const nextRowSuppressesSharedTop = nextRowBorderOverride !== void 0 && !isPresentBorder(borderValueToSpec(nextRowEffectiveInsideH));
	const calculateXPosition = (gridColumnStart) => {
		let x = cellSpacingPx;
		for (let i = 0; i < gridColumnStart && i < columnWidths.length; i++) x += columnWidths[i] + cellSpacingPx;
		return x;
	};
	let tableContentWidth = 0;
	if (isRtl) {
		tableContentWidth = cellSpacingPx;
		for (let i = 0; i < columnWidths.length; i++) tableContentWidth += columnWidths[i] + cellSpacingPx;
	}
	const calculateRowspanHeight = (startRowIndex, rowSpan) => {
		let totalHeight = 0;
		for (let i = 0; i < rowSpan && startRowIndex + i < allRowHeights.length; i++) totalHeight += allRowHeights[startRowIndex + i];
		return totalHeight;
	};
	const calculateColspanWidth = (gridColumnStart, colSpan) => {
		let width = 0;
		for (let i = gridColumnStart; i < gridColumnStart + colSpan && i < columnWidths.length; i++) width += columnWidths[i];
		return width;
	};
	const findCellBordersAtColumn = (cells, measureCells, gridCol) => {
		if (!cells || !measureCells) return void 0;
		for (let i = 0; i < measureCells.length; i++) {
			const start$1 = measureCells[i].gridColumnStart ?? i;
			const span = measureCells[i].colSpan ?? 1;
			if (gridCol >= start$1 && gridCol < start$1 + span) return cells[i]?.attrs?.borders;
		}
	};
	const findCellRightEdgeAtColumn = (measureCells, gridCol) => {
		if (!measureCells) return void 0;
		for (let i = 0; i < measureCells.length; i++) {
			const start$1 = measureCells[i].gridColumnStart ?? i;
			const span = measureCells[i].colSpan ?? 1;
			if (gridCol >= start$1 && gridCol < start$1 + span) return start$1 + span;
		}
	};
	const nextRowMaxCol = nextRowOccupiedRightCol != null && nextRowOccupiedRightCol > 0 ? nextRowOccupiedRightCol : nextRowMeasure?.cells?.length ? Math.max(...nextRowMeasure.cells.map((c) => (c.gridColumnStart ?? 0) + (c.colSpan ?? 1))) : Infinity;
	for (let cellIndex = 0; cellIndex < rowMeasure.cells.length; cellIndex += 1) {
		const cellMeasure = rowMeasure.cells[cellIndex];
		const cell = row?.cells?.[cellIndex];
		const gridColumnStart = cellMeasure.gridColumnStart ?? cellIndex;
		const rowSpan = cellMeasure.rowSpan ?? 1;
		const colSpan = cellMeasure.colSpan ?? 1;
		let x = calculateXPosition(gridColumnStart);
		const cellBordersAttr = cell?.attrs?.borders;
		const hasBordersAttribute = cellBordersAttr !== void 0;
		const cellPosition = {
			rowIndex,
			rowSpan,
			gridColumnStart,
			colSpan,
			totalRows,
			totalCols: rowRightEdgeCol
		};
		const aboveCellBorders = findCellBordersAtColumn(prevRow?.cells, prevRowMeasure?.cells, gridColumnStart);
		const leftCellBorders = gridColumnStart > 0 ? findCellBordersAtColumn(row?.cells, rowMeasure.cells, gridColumnStart - 1) : void 0;
		const rightCellBorders = findCellBordersAtColumn(row?.cells, rowMeasure.cells, gridColumnStart + colSpan);
		const nextRowLeavesRightGap = gridColumnStart + colSpan > nextRowMaxCol;
		const aboveCellRightEdge = findCellRightEdgeAtColumn(prevRowMeasure?.cells, gridColumnStart);
		const resolvedBorders = resolveRenderedCellBorders({
			cellBorders: cellBordersAttr,
			hasBordersAttribute,
			tableBorders: effectiveTableBorders,
			cellPosition,
			cellSpacingPx,
			continuesFromPrev: continuesFromPrev === true,
			continuesOnNext: continuesOnNext === true,
			aboveCellBorders,
			leftCellBorders,
			rightCellBorders,
			nextRowLeavesRightGap,
			deferTopToAboveCell: aboveCellRightEdge !== void 0 && aboveCellRightEdge > rowRightEdgeCol,
			nextRowSuppressesSharedTop
		});
		const finalBorders = isRtl && resolvedBorders ? swapCellBordersLR(resolvedBorders) : resolvedBorders;
		let cellHeight;
		if (partialRow) cellHeight = partialRow.partialHeight;
		else if (rowSpan > 1) cellHeight = calculateRowspanHeight(rowIndex, rowSpan);
		else cellHeight = rowMeasure.height;
		const fromLine = partialRow?.fromLineByCell?.[cellIndex];
		const toLine = partialRow?.toLineByCell?.[cellIndex];
		const computedCellWidth = calculateColspanWidth(gridColumnStart, colSpan);
		if (isRtl && computedCellWidth > 0) x = tableContentWidth - x - computedCellWidth;
		const { cellElement } = renderTableCell({
			doc: doc$1,
			x,
			y: y$1,
			rowHeight: cellHeight,
			cellMeasure,
			cell,
			borders: finalBorders,
			useDefaultBorder: false,
			renderLine: renderLine$1,
			captureLineSnapshot,
			renderDrawingContent,
			context,
			applySdtDataset: applySdtDataset$1,
			ancestorContainerKey,
			ancestorContainerSdt,
			ancestorContainerKeys,
			ancestorContainerSdts,
			onSdtContainerChrome,
			fromLine,
			toLine,
			tableIndent,
			isRtl,
			cellWidth: computedCellWidth > 0 ? computedCellWidth : void 0,
			chrome,
			resolvePhysical
		});
		if (rowTrackedChange && rowTrackedChangeConfig) applyRowTrackedChangeToCell(cellElement, rowTrackedChange, rowTrackedChangeConfig);
		container.appendChild(cellElement);
	}
};
const renderTableFragment = (deps) => {
	const { doc: doc$1, fragment, block, measure, cellSpacingPx, effectiveColumnWidths, chrome, context, sdtBoundary, ancestorContainerKey, ancestorContainerSdt, ancestorContainerKeys, ancestorContainerSdts, onSdtContainerChrome, renderLine: renderLine$1, captureLineSnapshot, renderDrawingContent, applyFragmentFrame, applySdtDataset: applySdtDataset$1, applyContainerSdtDataset: applyContainerSdtDataset$1, applyStyles: applyStyles$3, resolvePhysical } = deps;
	if (!doc$1) {
		console.error("DomPainter: document is not available");
		if (typeof document !== "undefined") {
			const placeholder = document.createElement("div");
			placeholder.classList.add(CLASS_NAMES$1.fragment, "superdoc-error-placeholder");
			placeholder.textContent = "[Document not available]";
			placeholder.style.border = "1px dashed red";
			placeholder.style.padding = "8px";
			return placeholder;
		}
		throw new Error("Document is required for table rendering");
	}
	const tableBorders = block.attrs?.borders;
	const tableIndentValue = (block.attrs?.tableIndent)?.width;
	const tableIndent = typeof tableIndentValue === "number" && Number.isFinite(tableIndentValue) ? tableIndentValue : 0;
	const isRtl = getTableVisualDirection(block.attrs) === "rtl";
	const container = doc$1.createElement("div");
	container.classList.add(CLASS_NAMES$1.fragment);
	applyStyles$3(container, fragmentStyles);
	applyFragmentFrame(container, fragment);
	if (fragment.pmStart != null) container.dataset.pmStart = String(fragment.pmStart);
	if (fragment.pmEnd != null) container.dataset.pmEnd = String(fragment.pmEnd);
	container.style.height = `${fragment.height}px`;
	applySdtDataset$1(container, block.attrs?.sdt);
	applyContainerSdtDataset$1?.(container, block.attrs?.containerSdt);
	const tableBorderWidths = measure.tableBorderWidths;
	if (tableBorderWidths) container.style.boxSizing = "border-box";
	const contentLeft = tableBorderWidths?.left ?? 0;
	const contentTop = tableBorderWidths?.top ?? 0;
	if (applySdtContainerChrome(doc$1, container, block.attrs?.sdt, block.attrs?.containerSdt, sdtBoundary, {
		ancestorContainerKey,
		ancestorContainerSdt,
		ancestorContainerKeys,
		ancestorContainerSdts
	}, chrome)) onSdtContainerChrome?.();
	const tableContainerSdt = getSdtContainerMetadata(block.attrs?.sdt, block.attrs?.containerSdt);
	const tableContainerKey = getSdtContainerKey(block.attrs?.sdt, block.attrs?.containerSdt);
	const nextAncestorContainerKeys = [
		...ancestorContainerKeys ?? [],
		ancestorContainerKey,
		hasExplicitSdtContainerKey(block.attrs?.sdt, block.attrs?.containerSdt) ? tableContainerKey : null
	].filter((key) => Boolean(key));
	const nextAncestorContainerSdts = [
		...ancestorContainerSdts ?? [],
		ancestorContainerSdt,
		tableContainerSdt
	].filter((sdt) => Boolean(sdt));
	const nextAncestorContainerKey = nextAncestorContainerKeys[nextAncestorContainerKeys.length - 1] ?? null;
	const nextAncestorContainerSdt = nextAncestorContainerSdts[nextAncestorContainerSdts.length - 1] ?? null;
	container.classList.add(DOM_CLASS_NAMES.TABLE_FRAGMENT);
	if (fragment.metadata?.columnBoundaries) {
		const columnCount = effectiveColumnWidths.length;
		const boundarySegments = [];
		for (let i = 0; i < columnCount; i++) boundarySegments.push([]);
		const renderedRows = [];
		if (fragment.repeatHeaderCount && fragment.repeatHeaderCount > 0) for (let r$1 = 0; r$1 < fragment.repeatHeaderCount; r$1++) {
			const rowMeasure = measure.rows[r$1];
			if (!rowMeasure) break;
			renderedRows.push({
				rowIndex: r$1,
				height: rowMeasure.height
			});
		}
		for (let r$1 = fragment.fromRow; r$1 < fragment.toRow; r$1++) {
			const rowMeasure = measure.rows[r$1];
			if (!rowMeasure) break;
			const actualHeight = fragment.partialRow && fragment.partialRow.rowIndex === r$1 ? fragment.partialRow.partialHeight : rowMeasure.height;
			renderedRows.push({
				rowIndex: r$1,
				height: actualHeight
			});
		}
		let rowY = cellSpacingPx;
		for (let i = 0; i < renderedRows.length; i++) {
			const { rowIndex, height } = renderedRows[i];
			const rowMeasure = measure.rows[rowIndex];
			if (!rowMeasure) continue;
			const boundariesInRow = /* @__PURE__ */ new Set();
			const occupiedCols = /* @__PURE__ */ new Set();
			for (const cellMeasure of rowMeasure.cells) {
				const s = cellMeasure.gridColumnStart ?? 0;
				const sp = cellMeasure.colSpan ?? 1;
				for (let c = s; c < s + sp; c++) occupiedCols.add(c);
			}
			const lastColIndex = columnCount - 1;
			const lastColMeta = fragment.metadata.columnBoundaries[lastColIndex];
			const skipTrailingSpacerBoundary = lastColIndex > 0 && !occupiedCols.has(lastColIndex) && !!lastColMeta && typeof lastColMeta.width === "number" && typeof lastColMeta.minWidth === "number" && lastColMeta.width < lastColMeta.minWidth;
			for (const cellMeasure of rowMeasure.cells) {
				const startCol = cellMeasure.gridColumnStart ?? 0;
				const endCol = startCol + (cellMeasure.colSpan ?? 1);
				if (startCol > 0) boundariesInRow.add(startCol);
				if (endCol < columnCount && !(skipTrailingSpacerBoundary && endCol === lastColIndex)) boundariesInRow.add(endCol);
			}
			for (const boundaryCol of boundariesInRow) {
				const segments = boundarySegments[boundaryCol];
				const lastSegment = segments[segments.length - 1];
				if (lastSegment && i > 0 && lastSegment.toRow === i) {
					lastSegment.toRow = i + 1;
					lastSegment.height += height;
				} else segments.push({
					fromRow: i,
					toRow: i + 1,
					y: rowY,
					height
				});
			}
			rowY += height + cellSpacingPx;
		}
		const metadata = {
			columns: fragment.metadata.columnBoundaries.map((boundary) => ({
				i: boundary.index,
				x: boundary.x + contentLeft,
				w: boundary.width,
				min: boundary.minWidth,
				r: boundary.resizable ? 1 : 0
			})),
			rtl: isRtl,
			segments: boundarySegments.map((segs, colIndex) => segs.map((seg) => ({
				c: colIndex,
				y: seg.y + contentTop,
				h: seg.height
			})))
		};
		if (fragment.metadata.rowBoundaries && fragment.metadata.rowBoundaries.length > 0) metadata.rows = fragment.metadata.rowBoundaries.map((rb) => ({
			i: rb.index,
			y: rb.y + contentTop,
			h: rb.height,
			min: rb.minHeight,
			r: rb.resizable ? 1 : 0
		}));
		container.setAttribute("data-table-boundaries", JSON.stringify(metadata));
	}
	if (block.id) container.setAttribute("data-sd-block-id", block.id);
	if ((block.attrs?.borderCollapse ?? (block.attrs?.cellSpacing != null ? "separate" : "collapse")) === "separate" && tableBorders) {
		applyBorder(container, "Top", borderValueToSpec(tableBorders.top));
		applyBorder(container, "Right", borderValueToSpec(isRtl ? tableBorders.left : tableBorders.right));
		applyBorder(container, "Bottom", borderValueToSpec(tableBorders.bottom));
		applyBorder(container, "Left", borderValueToSpec(isRtl ? tableBorders.right : tableBorders.left));
	}
	const allRowHeights = measure.rows.map((r$1, idx) => {
		if (fragment.partialRow && fragment.partialRow.rowIndex === idx) return fragment.partialRow.partialHeight;
		return r$1?.height ?? 0;
	});
	const rowOccupiedRightCols = new Array(measure.rows.length).fill(0);
	measure.rows.forEach((rowM, r$1) => {
		for (const c of rowM?.cells ?? []) {
			const right$1 = (c.gridColumnStart ?? 0) + (c.colSpan ?? 1);
			const lastRow = Math.min(measure.rows.length - 1, r$1 + (c.rowSpan ?? 1) - 1);
			for (let rr = r$1; rr <= lastRow; rr += 1) if (right$1 > rowOccupiedRightCols[rr]) rowOccupiedRightCols[rr] = right$1;
		}
	});
	let y$1 = cellSpacingPx;
	if (fragment.repeatHeaderCount && fragment.repeatHeaderCount > 0) for (let r$1 = 0; r$1 < fragment.repeatHeaderCount; r$1 += 1) {
		const rowMeasure = measure.rows[r$1];
		if (!rowMeasure) break;
		renderTableRow({
			doc: doc$1,
			container,
			rowIndex: r$1,
			y: y$1,
			rowMeasure,
			row: block.rows[r$1],
			prevRow: r$1 > 0 ? block.rows[r$1 - 1] : void 0,
			prevRowMeasure: r$1 > 0 ? measure.rows[r$1 - 1] : void 0,
			nextRow: r$1 < block.rows.length - 1 ? block.rows[r$1 + 1] : void 0,
			nextRowMeasure: r$1 < block.rows.length - 1 ? measure.rows[r$1 + 1] : void 0,
			rowOccupiedRightCol: rowOccupiedRightCols[r$1],
			nextRowOccupiedRightCol: rowOccupiedRightCols[r$1 + 1],
			totalRows: block.rows.length,
			tableBorders,
			columnWidths: effectiveColumnWidths,
			allRowHeights,
			tableIndent,
			isRtl,
			context,
			renderLine: renderLine$1,
			captureLineSnapshot,
			renderDrawingContent,
			applySdtDataset: applySdtDataset$1,
			ancestorContainerKey: nextAncestorContainerKey,
			ancestorContainerSdt: nextAncestorContainerSdt,
			ancestorContainerKeys: nextAncestorContainerKeys,
			ancestorContainerSdts: nextAncestorContainerSdts,
			onSdtContainerChrome,
			chrome,
			continuesFromPrev: false,
			continuesOnNext: false,
			cellSpacingPx,
			resolvePhysical
		});
		y$1 += rowMeasure.height + cellSpacingPx;
	}
	if (fragment.continuesFromPrev && fragment.fromRow > 0) {
		const repeatCount = fragment.repeatHeaderCount ?? 0;
		for (let r$1 = repeatCount; r$1 < fragment.fromRow; r$1++) {
			const srcRowMeasure = measure.rows[r$1];
			if (!srcRowMeasure) continue;
			for (let ci = 0; ci < srcRowMeasure.cells.length; ci++) {
				const srcCellMeasure = srcRowMeasure.cells[ci];
				const rowSpan = srcCellMeasure.rowSpan ?? 1;
				if (rowSpan <= 1) continue;
				const spanEndRow = r$1 + rowSpan;
				if (spanEndRow <= fragment.fromRow) continue;
				const gridCol = srcCellMeasure.gridColumnStart ?? 0;
				const colSpan = srcCellMeasure.colSpan ?? 1;
				let ghostX = 0;
				for (let i = 0; i < gridCol && i < effectiveColumnWidths.length; i++) ghostX += effectiveColumnWidths[i];
				let ghostWidth = 0;
				for (let i = gridCol; i < gridCol + colSpan && i < effectiveColumnWidths.length; i++) ghostWidth += effectiveColumnWidths[i];
				if (isRtl && ghostWidth > 0) {
					let totalWidth = cellSpacingPx;
					for (let i = 0; i < effectiveColumnWidths.length; i++) totalWidth += effectiveColumnWidths[i] + cellSpacingPx;
					let ghostXWithSpacing = cellSpacingPx;
					for (let i = 0; i < gridCol && i < effectiveColumnWidths.length; i++) ghostXWithSpacing += effectiveColumnWidths[i] + cellSpacingPx;
					ghostX = totalWidth - ghostXWithSpacing - ghostWidth;
				}
				const effectiveEnd = Math.min(spanEndRow, fragment.toRow);
				let ghostHeight = 0;
				for (let ri = fragment.fromRow; ri < effectiveEnd; ri++) ghostHeight += allRowHeights[ri] ?? 0;
				if (ghostWidth <= 0 || ghostHeight <= 0) continue;
				const ghostDiv = doc$1.createElement("div");
				ghostDiv.style.position = "absolute";
				ghostDiv.style.left = `${ghostX}px`;
				ghostDiv.style.top = `${y$1}px`;
				ghostDiv.style.width = `${ghostWidth}px`;
				ghostDiv.style.height = `${ghostHeight}px`;
				ghostDiv.style.boxSizing = "border-box";
				ghostDiv.style.overflow = "hidden";
				const srcCell = block.rows[r$1]?.cells?.[ci];
				const cellBordersAttr = srcCell?.attrs?.borders;
				const explicit = hasExplicitCellBorders(cellBordersAttr);
				const cellBounds = getTableCellGridBounds({
					rowIndex: r$1,
					rowSpan,
					gridColumnStart: gridCol,
					colSpan,
					totalRows: block.rows.length,
					totalCols: effectiveColumnWidths.length
				});
				const cellEndsWithinFragment = effectiveEnd <= fragment.toRow && spanEndRow <= fragment.toRow;
				if (tableBorders) {
					const topB = (explicit ? cellBordersAttr.top : void 0) ?? borderValueToSpec(tableBorders.top);
					let leftB = (explicit ? cellBordersAttr.left : void 0) ?? borderValueToSpec(cellBounds.touchesLeftEdge ? tableBorders.left : tableBorders.insideV);
					let rightB = (explicit ? cellBordersAttr.right : void 0) ?? borderValueToSpec(cellBounds.touchesRightEdge ? tableBorders.right : tableBorders.insideV);
					const bottomB = cellEndsWithinFragment ? (explicit ? cellBordersAttr.bottom : void 0) ?? borderValueToSpec(cellBounds.touchesBottomEdge ? tableBorders.bottom : tableBorders.insideH) : void 0;
					if (isRtl) {
						const tmp = leftB;
						leftB = rightB;
						rightB = tmp;
					}
					applyBorder(ghostDiv, "Top", topB);
					applyBorder(ghostDiv, "Left", leftB);
					applyBorder(ghostDiv, "Right", rightB);
					if (bottomB) applyBorder(ghostDiv, "Bottom", bottomB);
				}
				if (srcCell?.attrs?.background) ghostDiv.style.backgroundColor = srcCell.attrs.background;
				container.appendChild(ghostDiv);
			}
		}
	}
	for (let r$1 = fragment.fromRow; r$1 < fragment.toRow; r$1 += 1) {
		const rowMeasure = measure.rows[r$1];
		if (!rowMeasure) break;
		const isFirstRenderedBodyRow = r$1 === fragment.fromRow;
		const isLastRenderedBodyRow = r$1 === fragment.toRow - 1;
		const partialRowData = fragment.partialRow && fragment.partialRow.rowIndex === r$1 ? fragment.partialRow : void 0;
		const actualRowHeight = partialRowData ? partialRowData.partialHeight : rowMeasure.height;
		renderTableRow({
			doc: doc$1,
			container,
			rowIndex: r$1,
			y: y$1,
			rowMeasure,
			row: block.rows[r$1],
			prevRow: r$1 > 0 ? block.rows[r$1 - 1] : void 0,
			prevRowMeasure: r$1 > 0 ? measure.rows[r$1 - 1] : void 0,
			nextRow: r$1 < block.rows.length - 1 ? block.rows[r$1 + 1] : void 0,
			nextRowMeasure: r$1 < block.rows.length - 1 ? measure.rows[r$1 + 1] : void 0,
			rowOccupiedRightCol: rowOccupiedRightCols[r$1],
			nextRowOccupiedRightCol: rowOccupiedRightCols[r$1 + 1],
			totalRows: block.rows.length,
			tableBorders,
			columnWidths: effectiveColumnWidths,
			allRowHeights,
			tableIndent,
			isRtl,
			context,
			renderLine: renderLine$1,
			captureLineSnapshot,
			renderDrawingContent,
			applySdtDataset: applySdtDataset$1,
			ancestorContainerKey: nextAncestorContainerKey,
			ancestorContainerSdt: nextAncestorContainerSdt,
			ancestorContainerKeys: nextAncestorContainerKeys,
			ancestorContainerSdts: nextAncestorContainerSdts,
			onSdtContainerChrome,
			chrome,
			continuesFromPrev: isFirstRenderedBodyRow && fragment.continuesFromPrev === true,
			continuesOnNext: isLastRenderedBodyRow && fragment.continuesOnNext === true,
			partialRow: partialRowData,
			cellSpacingPx,
			resolvePhysical
		});
		y$1 += actualRowHeight + cellSpacingPx;
	}
	return container;
};
const computeSdtBoundaries = (resolvedItems, sdtLabelsRendered) => {
	const boundaries = /* @__PURE__ */ new Map();
	const containerKeys = resolvedItems.map((item) => {
		if (item && "sdtContainerKey" in item) return item.sdtContainerKey ?? null;
		return null;
	});
	const fragmentOf = (idx) => {
		const item = resolvedItems[idx];
		return item && item.kind === "fragment" ? item.fragment : null;
	};
	let i = 0;
	while (i < resolvedItems.length) {
		const currentKey = containerKeys[i];
		const startFrag = fragmentOf(i);
		if (!currentKey || !startFrag) {
			i += 1;
			continue;
		}
		let groupRight = startFrag.x + startFrag.width;
		let j = i;
		while (j + 1 < resolvedItems.length && containerKeys[j + 1] === currentKey) {
			j += 1;
			const nextFrag = fragmentOf(j);
			if (!nextFrag) break;
			const fragmentRight = nextFrag.x + nextFrag.width;
			if (fragmentRight > groupRight) groupRight = fragmentRight;
		}
		for (let k$1 = i; k$1 <= j; k$1 += 1) {
			const fragment = fragmentOf(k$1);
			if (!fragment) continue;
			const isStart = k$1 === i;
			const isEnd = k$1 === j;
			let paddingBottomOverride;
			if (!isEnd) {
				const nextFragment = fragmentOf(k$1 + 1);
				const currentHeight = resolvedItems[k$1]?.height ?? 0;
				const currentBottom = fragment.y + currentHeight;
				if (nextFragment) {
					const gapToNext = nextFragment.y - currentBottom;
					if (gapToNext > 0) paddingBottomOverride = gapToNext;
				}
			}
			const showLabel = isStart && !sdtLabelsRendered.has(currentKey);
			if (showLabel) sdtLabelsRendered.add(currentKey);
			boundaries.set(k$1, {
				isStart,
				isEnd,
				widthOverride: groupRight - fragment.x,
				paddingBottomOverride,
				showLabel
			});
		}
		i = j + 1;
	}
	return boundaries;
};
var SDT_DATASET_KEYS = [
	"sdtType",
	"sdtId",
	"sdtFieldId",
	"sdtFieldType",
	"sdtFieldVariant",
	"sdtFieldVisibility",
	"sdtFieldHidden",
	"sdtFieldLocked",
	"sdtScope",
	"sdtTag",
	"sdtAlias",
	"appearance",
	"lockMode",
	"sdtSectionTitle",
	"sdtSectionType",
	"sdtSectionLocked",
	"sdtDocpartGallery",
	"sdtDocpartId",
	"sdtDocpartInstruction"
];
var setDatasetString = (el, key, value) => {
	if (value) el.dataset[key] = value;
};
var setDatasetBoolean = (el, key, value) => {
	if (value != null) el.dataset[key] = String(value);
};
const clearSdtDataset = (el) => {
	SDT_DATASET_KEYS.forEach((key) => {
		delete el.dataset[key];
	});
};
const applySdtDataset = (el, metadata) => {
	if (!el?.dataset) return;
	clearSdtDataset(el);
	if (!metadata) return;
	el.dataset.sdtType = metadata.type;
	if ("id" in metadata && metadata.id != null) el.dataset.sdtId = String(metadata.id);
	if (metadata.type === "fieldAnnotation") {
		setDatasetString(el, "sdtFieldId", metadata.fieldId);
		setDatasetString(el, "sdtFieldType", metadata.fieldType);
		setDatasetString(el, "sdtFieldVariant", metadata.variant);
		setDatasetString(el, "sdtFieldVisibility", metadata.visibility);
		setDatasetBoolean(el, "sdtFieldHidden", metadata.hidden);
		setDatasetBoolean(el, "sdtFieldLocked", metadata.isLocked);
	} else if (metadata.type === "structuredContent") {
		setDatasetString(el, "sdtScope", metadata.scope);
		setDatasetString(el, "sdtTag", metadata.tag);
		setDatasetString(el, "sdtAlias", metadata.alias);
		setDatasetString(el, "appearance", metadata.appearance);
		setDatasetString(el, "lockMode", metadata.lockMode || "unlocked");
	} else if (metadata.type === "documentSection") {
		setDatasetString(el, "sdtSectionTitle", metadata.title);
		setDatasetString(el, "sdtSectionType", metadata.sectionType);
		setDatasetBoolean(el, "sdtSectionLocked", metadata.isLocked);
	} else if (metadata.type === "docPartObject") {
		setDatasetString(el, "sdtDocpartGallery", metadata.gallery);
		setDatasetString(el, "sdtDocpartId", metadata.uniqueId);
		setDatasetString(el, "sdtDocpartInstruction", metadata.instruction);
	}
};
const applyContainerSdtDataset = (el, metadata) => {
	if (!el?.dataset) return;
	if (!metadata) return;
	el.dataset.sdtContainerType = metadata.type;
	if ("id" in metadata && metadata.id != null) el.dataset.sdtContainerId = String(metadata.id);
	if (metadata.type === "documentSection") {
		setDatasetString(el, "sdtContainerSectionTitle", metadata.title);
		setDatasetString(el, "sdtContainerSectionType", metadata.sectionType);
		setDatasetBoolean(el, "sdtContainerSectionLocked", metadata.isLocked);
	}
};
const resolveRunSdtId = (run) => {
	const sdt = run.sdt;
	if (sdt?.type === "structuredContent" && sdt?.scope === "inline" && sdt?.id) return {
		sdtId: String(sdt.id),
		sdt
	};
	return null;
};
const createInlineSdtWrapper = (sdt, context) => {
	const wrapper = context.doc.createElement("span");
	wrapper.className = DOM_CLASS_NAMES.INLINE_SDT_WRAPPER;
	wrapper.dataset.layoutEpoch = String(context.layoutEpoch);
	context.applySdtDataset(wrapper, sdt);
	if ((sdt.type === "structuredContent" ? sdt.appearance : void 0) === "hidden") {
		wrapper.dataset.appearance = "hidden";
		return wrapper;
	}
	if (context.contentControlsChrome === "none") return wrapper;
	const alias = sdt?.alias || "Inline content";
	const labelEl = context.doc.createElement("span");
	labelEl.className = DOM_CLASS_NAMES.INLINE_SDT_LABEL;
	labelEl.textContent = alias;
	wrapper.appendChild(labelEl);
	return wrapper;
};
const syncInlineSdtWrapperTypography = (wrapper, runForSizing) => {
	const runFontSize = runForSizing && "fontSize" in runForSizing && typeof runForSizing.fontSize === "number" ? `${runForSizing.fontSize}px` : BROWSER_DEFAULT_FONT_SIZE;
	wrapper.style.fontSize = runFontSize;
	wrapper.style.lineHeight = "normal";
};
const expandSdtWrapperPmRange = (wrapper, pmStart, pmEnd) => {
	if (pmStart != null) {
		const cur = wrapper.dataset.pmStart;
		if (!cur || pmStart < parseInt(cur, 10)) wrapper.dataset.pmStart = String(pmStart);
	}
	if (pmEnd != null) {
		const cur = wrapper.dataset.pmEnd;
		if (!cur || pmEnd > parseInt(cur, 10)) wrapper.dataset.pmEnd = String(pmEnd);
	}
};
const collectSdtSnapshotEntitiesFromDomRoot = (rootEl, options) => {
	const entities = {
		structuredContentBlocks: [],
		structuredContentInlines: []
	};
	const blockSdtElements = Array.from(rootEl.querySelectorAll(`.${DOM_CLASS_NAMES.BLOCK_SDT}[data-sdt-id]`));
	for (const element of blockSdtElements) {
		const pageIndex = options.resolvePageIndex(element);
		const sdtId = element.dataset.sdtId;
		if (pageIndex == null || !sdtId) continue;
		entities.structuredContentBlocks.push(options.compactObject({
			element,
			pageIndex,
			sdtId,
			pmStart: options.readDatasetNumber(element.dataset.pmStart),
			pmEnd: options.readDatasetNumber(element.dataset.pmEnd),
			layoutSourceIdentity: options.readLayoutSourceIdentity?.(element)
		}));
	}
	const inlineSdtElements = Array.from(rootEl.querySelectorAll(`.${DOM_CLASS_NAMES.INLINE_SDT_WRAPPER}[data-sdt-id]`));
	for (const element of inlineSdtElements) {
		const pageIndex = options.resolvePageIndex(element);
		const sdtId = element.dataset.sdtId;
		if (pageIndex == null || !sdtId) continue;
		entities.structuredContentInlines.push(options.compactObject({
			element,
			pageIndex,
			sdtId,
			pmStart: options.readDatasetNumber(element.dataset.pmStart),
			pmEnd: options.readDatasetNumber(element.dataset.pmEnd),
			layoutSourceIdentity: options.readLayoutSourceIdentity?.(element)
		}));
	}
	return entities;
};
const applyParagraphFragmentPmAttributes = (el, fragment, section, resolvedItem) => {
	if (section === "body" || section === void 0) assertFragmentPmPositions(fragment, "paragraph fragment");
	const pmStart = resolvedItem ? resolvedItem.pmStart : fragment.pmStart;
	if (pmStart != null) el.dataset.pmStart = String(pmStart);
	else delete el.dataset.pmStart;
	const pmEnd = resolvedItem ? resolvedItem.pmEnd : fragment.pmEnd;
	if (pmEnd != null) el.dataset.pmEnd = String(pmEnd);
	else delete el.dataset.pmEnd;
	if (resolvedItem ? resolvedItem.continuesFromPrev : fragment.continuesFromPrev) el.dataset.continuesFromPrev = "true";
	else delete el.dataset.continuesFromPrev;
	if (resolvedItem ? resolvedItem.continuesOnNext : fragment.continuesOnNext) el.dataset.continuesOnNext = "true";
	else delete el.dataset.continuesOnNext;
};
var isMinimalWordLayout$2 = (value) => isMinimalWordLayout(value);
const renderParagraphFragment = (params$1) => {
	const { doc: doc$1, fragment, sdtBoundary, betweenInfo, resolvedItem, applyStyles: applyStyles$3, applyResolvedFragmentFrame, applyFragmentFrame, applySdtDataset: applySdtDataset$1, applyContainerSdtDataset: applyContainerSdtDataset$1, renderLine: renderLine$1, captureLineSnapshot, createErrorPlaceholder, contentControlsChrome, resolvePhysical = (css) => resolvePhysicalFamily(css) } = params$1;
	try {
		if (!doc$1) throw new Error("DomPainter: document is not available");
		if (resolvedItem?.block?.kind !== "paragraph" || resolvedItem?.measure?.kind !== "paragraph") throw new Error(`DomPainter: missing resolved paragraph block/measure for fragment ${fragment.blockId}`);
		const block = resolvedItem.block;
		const measure = resolvedItem.measure;
		const wordLayout = isMinimalWordLayout$2(block.attrs?.wordLayout) ? block.attrs.wordLayout : void 0;
		const content = resolvedItem?.content;
		const paraContinuesFromPrev = resolvedItem?.continuesFromPrev;
		const paraContinuesOnNext = resolvedItem?.continuesOnNext;
		const paraMarkerWidth = resolvedItem?.markerWidth;
		const fragmentEl = doc$1.createElement("div");
		fragmentEl.classList.add(CLASS_NAMES$1.fragment);
		const isTocEntry = block.attrs?.isTocEntry;
		const hasMarker = !paraContinuesFromPrev && paraMarkerWidth && wordLayout?.marker;
		const hasSdtContainer = shouldRenderSdtContainerChrome(block.attrs?.sdt, block.attrs?.containerSdt);
		const paraIndentForOverflow = block.attrs?.indent;
		const hasNegativeIndent = (paraIndentForOverflow?.left ?? 0) < 0 || (paraIndentForOverflow?.right ?? 0) < 0;
		applyStyles$3(fragmentEl, isTocEntry ? {
			...fragmentStyles,
			whiteSpace: "nowrap"
		} : hasMarker || hasSdtContainer || hasNegativeIndent ? {
			...fragmentStyles,
			overflow: "visible"
		} : fragmentStyles);
		if (resolvedItem) applyResolvedFragmentFrame(fragmentEl, resolvedItem, fragment);
		else applyFragmentFrame(fragmentEl, fragment);
		if (isTocEntry) {
			fragmentEl.classList.add(DOM_CLASS_NAMES.TOC_ENTRY);
			const tocId = block.attrs?.tocId;
			if (typeof tocId === "string" && tocId.length > 0) fragmentEl.dataset.tocId = tocId;
		}
		if (paraContinuesFromPrev) fragmentEl.dataset.continuesFromPrev = "true";
		if (paraContinuesOnNext) fragmentEl.dataset.continuesOnNext = "true";
		const lines = fragment.lines ?? measure.lines.slice(fragment.fromLine, fragment.toLine);
		renderParagraphContent({
			doc: doc$1,
			frameEl: fragmentEl,
			block,
			measure,
			containerKind: "body-fragment",
			width: fragment.width,
			localStartLine: 0,
			localEndLine: lines.length,
			lineIndexOffset: fragment.fromLine,
			linesOverride: lines,
			continuesFromPrev: paraContinuesFromPrev,
			continuesOnNext: paraContinuesOnNext,
			markerWidth: paraMarkerWidth,
			markerTextWidth: fragment.markerTextWidth,
			wordLayout,
			resolvedContent: content,
			betweenInfo,
			sdtBoundary,
			applySdtDataset: applySdtDataset$1,
			applyContainerSdtDataset: applyContainerSdtDataset$1,
			resolvePhysical,
			renderDropCap: (descriptor, dropCapMeasure) => renderDropCap(doc$1, descriptor, dropCapMeasure, resolvePhysical),
			renderLine: renderLine$1,
			captureLineSnapshot: (lineEl, options) => {
				captureLineSnapshot(lineEl, {
					sourceAnchor: options?.sourceAnchor,
					wrapperEl: fragmentEl
				});
			},
			sourceAnchor: resolvedItem?.sourceAnchor,
			contentControlsChrome
		});
		return fragmentEl;
	} catch (error) {
		console.error("[DomPainter] Fragment rendering failed:", {
			fragment,
			error
		});
		return createErrorPlaceholder(fragment.blockId, error);
	}
};
var renderDropCap = (doc$1, descriptor, measure, resolvePhysical = (css) => resolvePhysicalFamily(css)) => {
	const { run, mode } = descriptor;
	const dropCapEl = doc$1.createElement("span");
	dropCapEl.classList.add("superdoc-drop-cap");
	dropCapEl.textContent = run.text;
	dropCapEl.style.fontFamily = resolvePhysical(run.fontFamily, {
		weight: run.bold ? "700" : "400",
		style: run.italic ? "italic" : "normal"
	});
	dropCapEl.style.fontSize = `${run.fontSize}px`;
	allowFontSynthesis(dropCapEl);
	if (run.bold) dropCapEl.style.fontWeight = "bold";
	if (run.italic) dropCapEl.style.fontStyle = "italic";
	if (run.color) dropCapEl.style.color = run.color;
	if (mode === "drop") {
		dropCapEl.style.float = "left";
		dropCapEl.style.marginRight = "4px";
		dropCapEl.style.lineHeight = "1";
	} else if (mode === "margin") {
		dropCapEl.style.position = "absolute";
		dropCapEl.style.left = "0";
		dropCapEl.style.lineHeight = "1";
	}
	if (run.position && run.position !== 0) {
		dropCapEl.style.position = dropCapEl.style.position || "relative";
		dropCapEl.style.top = `${run.position}px`;
	}
	if (measure) {
		dropCapEl.style.width = `${measure.width}px`;
		dropCapEl.style.height = `${measure.height}px`;
	}
	return dropCapEl;
};
const setTextContentWithFormattingSpaceMarks = (element, text, doc$1, showFormattingMarks) => {
	if (!showFormattingMarks || !text.includes(" ")) {
		element.textContent = text;
		return;
	}
	element.textContent = "";
	let chunkStart = 0;
	for (let index = 0; index < text.length; index += 1) {
		if (text[index] !== " ") continue;
		if (index > chunkStart) element.appendChild(doc$1.createTextNode(text.slice(chunkStart, index)));
		const space = doc$1.createElement("span");
		space.classList.add("superdoc-formatting-space-mark");
		space.textContent = " ";
		element.appendChild(space);
		chunkStart = index + 1;
	}
	if (chunkStart < text.length) element.appendChild(doc$1.createTextNode(text.slice(chunkStart)));
};
var findLastTextRun = (runs) => {
	for (let index = runs.length - 1; index >= 0; index -= 1) {
		const run = runs[index];
		if (run && (run.kind === "text" || run.kind === void 0) && "text" in run) return {
			run,
			index
		};
	}
	return null;
};
const appendFormattingParagraphMark = (lineEl, line, runs, leftOffsetPx, availableWidth, hasExplicitPositioning, doc$1, showFormattingMarks) => {
	if (!showFormattingMarks) return;
	const lastRun = runs.length > 0 ? runs[runs.length - 1] : null;
	if (lastRun) {
		const lastRunIndex = runs.length - 1;
		if (line.toRun < lastRunIndex) return;
		if (line.toRun === lastRunIndex && (lastRun.kind === "text" || lastRun.kind === void 0) && "text" in lastRun && line.toChar < lastRun.text.length) return;
	}
	const lastTextRun = findLastTextRun(runs);
	const mark = doc$1.createElement("span");
	mark.classList.add("superdoc-formatting-paragraph-mark");
	mark.setAttribute("aria-hidden", "true");
	mark.textContent = "¶";
	const run = lastTextRun?.run;
	if (run) {
		if (run.fontFamily) mark.style.fontFamily = toCssFontFamily(run.fontFamily) ?? run.fontFamily;
		if (typeof run.fontSize === "number") mark.style.fontSize = `${run.fontSize}px`;
		if (run.bold) mark.style.fontWeight = "bold";
		if (run.italic) mark.style.fontStyle = "italic";
		if (run.letterSpacing != null) mark.style.letterSpacing = `${run.letterSpacing}px`;
	}
	mark.style.lineHeight = `${line.lineHeight}px`;
	const lineWidth = line.naturalWidth ?? line.width ?? 0;
	const alignmentSlack = Math.max(0, availableWidth - lineWidth);
	const textAlign = lineEl.style.textAlign;
	const alignmentOffset = !hasExplicitPositioning && textAlign === "center" ? alignmentSlack / 2 : !hasExplicitPositioning && textAlign === "right" ? alignmentSlack : 0;
	const visualTextEndOffset = lineEl.dir === "rtl" || lineEl.style.direction === "rtl" ? alignmentOffset : alignmentOffset + lineWidth;
	mark.style.left = `${Math.max(0, leftOffsetPx + visualTextEndOffset)}px`;
	lineEl.appendChild(mark);
};
var DEFAULT_SUPERSCRIPT_RAISE_RATIO = .33;
var DEFAULT_SUBSCRIPT_LOWER_RATIO = .14;
const underlineThicknessPx = (fontSize) => Math.max(1, Math.round(fontSize / 14));
var hasVerticalPositioning = (run) => normalizeBaselineShift(run.baselineShift) != null || run.vertAlign === "superscript" || run.vertAlign === "subscript";
var applyRunVerticalPositioning = (element, run) => {
	if (hasVerticalPositioning(run)) element.style.lineHeight = "1";
	const explicitBaselineShift = normalizeBaselineShift(run.baselineShift);
	if (explicitBaselineShift != null) {
		element.style.verticalAlign = `${explicitBaselineShift}pt`;
		return;
	}
	if (run.vertAlign === "superscript") {
		const baseFontSize = resolveBaseFontSizeForVerticalText(run.fontSize, run);
		element.style.verticalAlign = `${baseFontSize * DEFAULT_SUPERSCRIPT_RAISE_RATIO}px`;
		return;
	}
	if (run.vertAlign === "subscript") {
		const baseFontSize = resolveBaseFontSizeForVerticalText(run.fontSize, run);
		element.style.verticalAlign = `${-(baseFontSize * DEFAULT_SUBSCRIPT_LOWER_RATIO)}px`;
		return;
	}
	if (run.vertAlign === "baseline") element.style.verticalAlign = "baseline";
};
const applyRunStyles = (element, run, _isLink = false, resolvePhysical = resolvePhysicalFamily) => {
	if (run.kind === "tab" || run.kind === "image" || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation" || run.kind === "math") return;
	element.style.fontFamily = resolvePhysical(run.fontFamily, {
		weight: run.bold ? "700" : "400",
		style: run.italic ? "italic" : "normal"
	});
	element.style.fontSize = `${run.fontSize}px`;
	allowFontSynthesis(element);
	if (run.bold) element.style.fontWeight = "bold";
	if (run.italic) element.style.fontStyle = "italic";
	if (run.color) element.style.color = run.color;
	if (run.letterSpacing != null) element.style.letterSpacing = `${run.letterSpacing}px`;
	if (run.highlight) element.style.backgroundColor = run.highlight;
	if (run.textTransform) element.style.textTransform = run.textTransform;
	const decorations = [];
	if (run.underline) {
		decorations.push("underline");
		const u = run.underline;
		element.style.textDecorationStyle = u.style && u.style !== "single" ? u.style : "solid";
		element.style.textDecorationThickness = `${underlineThicknessPx(run.fontSize)}px`;
		if (u.color) element.style.textDecorationColor = u.color;
	}
	if (run.strike) decorations.push("line-through");
	if (decorations.length > 0) element.style.textDecorationLine = decorations.join(" ");
	applyRunVerticalPositioning(element, run);
};
const resolveRunText = (run, context) => {
	const runToken = "token" in run ? run.token : void 0;
	if (run.kind === "tab") return run.text;
	if (run.kind === "image") return "";
	if (run.kind === "lineBreak") return "";
	if (run.kind === "break") return "";
	if (!("text" in run)) return "";
	if (!runToken) return run.text ?? "";
	if (runToken === "pageNumber") {
		if (run.pageNumberFieldFormat) return formatChapterPageNumberText({
			pageComponent: formatPageNumberFieldValue(context.displayPageNumber ?? context.pageNumber, run.pageNumberFieldFormat),
			chapterNumberText: context.pageNumberChapterText,
			chapterSeparator: context.pageNumberChapterSeparator
		});
		if (context.pageNumberChapterText) return formatSectionPageNumberText({
			displayNumber: context.displayPageNumber ?? context.pageNumber,
			pageFormat: context.pageNumberFormat ?? "decimal",
			chapterNumberText: context.pageNumberChapterText,
			chapterSeparator: context.pageNumberChapterSeparator
		});
		return context.pageNumberText ?? String(context.pageNumber);
	}
	if (runToken === "totalPageCount") {
		if (run.pageNumberFieldFormat) return formatPageNumberFieldValue(context.totalPages || 1, run.pageNumberFieldFormat);
		return context.totalPages ? String(context.totalPages) : run.text ?? "";
	}
	if (runToken === "sectionPageCount") {
		const sectionPageCount = context.sectionPageCount;
		if (sectionPageCount == null) return run.text ?? "";
		if (run.pageNumberFieldFormat) return formatPageNumberFieldValue(sectionPageCount, run.pageNumberFieldFormat);
		return String(sectionPageCount);
	}
	return run.text ?? "";
};
const extractLinkData = (run) => {
	if (run.kind === "tab" || run.kind === "image" || run.kind === "lineBreak" || run.kind === "math") return null;
	const link = run.link;
	if (!link) return null;
	return buildLinkRenderData(link);
};
const renderTextRun = (run, context, renderContext, trackedConfig) => {
	if (!run.text) return null;
	const linkData = extractLinkData(run);
	const isActiveLink = !!(linkData && !linkData.blocked && linkData.href);
	const elem = isActiveLink ? renderContext.doc.createElement("a") : renderContext.doc.createElement("span");
	const text = resolveRunText(run, context);
	const effectiveText = run.bidi?.rtl === true && typeof text === "string" ? normalizeRtlDateTokenForWordParity(text) : text;
	setTextContentWithFormattingSpaceMarks(elem, effectiveText, renderContext.doc, renderContext.showFormattingMarks);
	if (linkData?.dataset) applyLinkDataset(elem, linkData.dataset);
	if (linkData?.blocked) {
		elem.dataset.linkBlocked = "true";
		elem.setAttribute("role", "text");
		elem.setAttribute("aria-label", "Invalid link - not clickable");
	}
	if (isActiveLink && linkData) {
		applyLinkAttributes(elem, linkData);
		enhanceAccessibility(elem, linkData, text);
		if (linkData.tooltip) renderContext.pendingTooltips.set(elem, linkData.tooltip);
	}
	applyRunStyles(elem, run, isActiveLink, renderContext.resolvePhysical);
	const dirAttr = resolveRunDirectionAttribute({
		runText: run.text,
		effectiveText,
		isRtlTagged: run.bidi?.rtl === true
	});
	if (dirAttr) elem.setAttribute("dir", dirAttr);
	const commentAnnotations = run.comments;
	if (!!commentAnnotations?.length) {
		elem.dataset.commentIds = commentAnnotations.map((c) => c.commentId).join(",");
		if (commentAnnotations.some((c) => c.internal)) elem.dataset.commentInternal = "true";
		const internalIds = commentAnnotations.filter((c) => c.internal).map((c) => c.commentId);
		if (internalIds.length > 0) elem.dataset.commentInternalIds = internalIds.join(",");
		const importedEntries = commentAnnotations.filter((c) => c.importedId && c.importedId !== c.commentId).map((c) => `${c.importedId}=${c.commentId}`);
		if (importedEntries.length > 0) elem.dataset.commentImportedIds = importedEntries.join(",");
		elem.classList.add("superdoc-comment-highlight");
	}
	elem.style.zIndex = "1";
	applyRunDataAttributes(elem, run.dataAttrs);
	const bookmarkName = run.dataAttrs?.["data-bookmark-name"];
	if (bookmarkName) elem.title = bookmarkName;
	assertPmPositions(run, "paragraph text run");
	if (run.pmStart != null) elem.dataset.pmStart = String(run.pmStart);
	if (run.pmEnd != null) elem.dataset.pmEnd = String(run.pmEnd);
	elem.dataset.layoutEpoch = String(renderContext.layoutEpoch);
	if (trackedConfig) renderContext.applyTrackedChangeDecorations(elem, run, trackedConfig);
	renderContext.applySdtDataset(elem, run.sdt);
	return elem;
};
const renderFieldAnnotationRun = (run, context) => {
	if (run.hidden) {
		const hidden = context.doc.createElement("span");
		hidden.style.display = "none";
		if (run.pmStart != null) hidden.dataset.pmStart = String(run.pmStart);
		if (run.pmEnd != null) hidden.dataset.pmEnd = String(run.pmEnd);
		hidden.dataset.layoutEpoch = String(context.layoutEpoch);
		return hidden;
	}
	const defaultBorderColor = "#b015b3";
	const defaultFieldColor = "#980043";
	const annotation = context.doc.createElement("span");
	annotation.classList.add(DOM_CLASS_NAMES.ANNOTATION);
	annotation.setAttribute("aria-label", "Field annotation");
	if (run.highlighted !== false) {
		const borderColor = run.borderColor || defaultBorderColor;
		annotation.style.border = `2px solid ${borderColor}`;
		annotation.style.borderRadius = "2px";
		annotation.style.padding = "1px 2px";
		annotation.style.boxSizing = "border-box";
		const fieldColor = run.fieldColor || defaultFieldColor;
		const bgColor = fieldColor.length === 7 ? `${fieldColor}33` : fieldColor;
		if (run.textHighlight) annotation.style.backgroundColor = run.textHighlight;
		else annotation.style.backgroundColor = bgColor;
	}
	if (run.visibility === "hidden") annotation.style.visibility = "hidden";
	if (run.size) {
		if (run.size.width) {
			if (!(run.variant === "image" || run.variant === "signature") || run.imageSrc) {
				annotation.style.width = `${run.size.width}px`;
				annotation.style.display = "inline-block";
				annotation.style.overflow = "hidden";
			}
		}
		if (run.size.height && run.variant !== "html") {
			if (!(run.variant === "image" || run.variant === "signature") || run.imageSrc) annotation.style.height = `${run.size.height}px`;
		}
	}
	{
		const resolvePhysical = context.resolvePhysical ?? resolvePhysicalFamily;
		annotation.style.fontFamily = resolvePhysical(run.fontFamily || "Arial, sans-serif", {
			weight: run.bold ? "700" : "400",
			style: run.italic ? "italic" : "normal"
		});
	}
	{
		const fontSize = run.fontSize ? typeof run.fontSize === "number" ? `${run.fontSize}pt` : run.fontSize : BROWSER_DEFAULT_FONT_SIZE;
		annotation.style.fontSize = fontSize;
	}
	if (run.textColor) annotation.style.color = run.textColor;
	allowFontSynthesis(annotation);
	if (run.bold) annotation.style.fontWeight = "bold";
	if (run.italic) annotation.style.fontStyle = "italic";
	if (run.underline) annotation.style.textDecoration = "underline";
	annotation.style.zIndex = "1";
	const content = context.doc.createElement("span");
	content.classList.add(DOM_CLASS_NAMES.ANNOTATION_CONTENT);
	content.style.pointerEvents = "none";
	content.setAttribute("contenteditable", "false");
	switch (run.variant) {
		case "image":
		case "signature":
			if (run.imageSrc) {
				const img = context.doc.createElement("img");
				if (run.imageSrc.startsWith("data:")) if (isValidImageDataUrl(run.imageSrc)) img.src = run.imageSrc;
				else {
					content.textContent = run.displayLabel;
					break;
				}
				else {
					const sanitized = sanitizeHref(run.imageSrc);
					if (sanitized) img.src = sanitized.href;
					else {
						content.textContent = run.displayLabel;
						break;
					}
				}
				img.alt = run.displayLabel;
				img.style.height = "auto";
				img.style.maxWidth = "100%";
				img.style.pointerEvents = "none";
				img.style.verticalAlign = "middle";
				if (run.variant === "signature") img.style.maxHeight = "28px";
				content.appendChild(img);
				annotation.style.display = "inline-block";
				content.style.display = "inline-block";
				annotation.style.lineHeight = "normal";
				content.style.lineHeight = "normal";
			} else content.textContent = run.displayLabel || (run.variant === "signature" ? "Signature" : "");
			break;
		case "link":
			if (run.linkUrl) {
				const link = context.doc.createElement("a");
				const sanitized = sanitizeHref(run.linkUrl);
				if (sanitized) {
					link.href = sanitized.href;
					link.target = "_blank";
					link.rel = "noopener noreferrer";
					link.textContent = run.linkUrl;
					link.style.textDecoration = "none";
					content.style.pointerEvents = "all";
					content.appendChild(link);
				} else content.textContent = run.displayLabel;
			} else content.textContent = run.displayLabel;
			break;
		case "html":
			if (run.rawHtml && typeof run.rawHtml === "string") {
				content.innerHTML = run.rawHtml.trim();
				annotation.style.display = "inline-block";
				content.style.display = "inline-block";
				annotation.style.lineHeight = "normal";
				content.style.lineHeight = "normal";
			} else content.textContent = run.displayLabel;
			break;
		case "text":
		case "checkbox":
		default:
			content.textContent = run.displayLabel;
			break;
	}
	annotation.appendChild(content);
	annotation.dataset.type = run.variant;
	annotation.dataset.displayLabel = run.displayLabel;
	if (run.fieldId) annotation.dataset.fieldId = run.fieldId;
	if (run.fieldType) annotation.dataset.fieldType = run.fieldType;
	assertPmPositions(run, "field annotation run");
	if (run.pmStart != null) annotation.dataset.pmStart = String(run.pmStart);
	if (run.pmEnd != null) annotation.dataset.pmEnd = String(run.pmEnd);
	annotation.dataset.layoutEpoch = String(context.layoutEpoch);
	context.applySdtDataset(annotation, run.sdt);
	return annotation;
};
var MATHML_NS$19 = "http://www.w3.org/1998/Math/MathML";
var OPERATOR_CHARS = new Set([
	"+",
	"-",
	"=",
	"<",
	">",
	"(",
	")",
	"[",
	"]",
	"{",
	"}",
	"|",
	"/",
	"\\",
	",",
	".",
	";",
	":",
	"!",
	"~",
	"^",
	"_",
	"±",
	"×",
	"÷",
	"←",
	"↑",
	"→",
	"↓",
	"↔",
	"∀",
	"∁",
	"∂",
	"∃",
	"∄",
	"∅",
	"∈",
	"∉",
	"∋",
	"∌",
	"∑",
	"∏",
	"√",
	"∧",
	"∨",
	"∩",
	"∪",
	"∫",
	"∬",
	"∭",
	"≠",
	"≡",
	"≤",
	"≥",
	"⊂",
	"⊃",
	"⊆",
	"⊇"
]);
function isDigit(ch) {
	return ch >= "0" && ch <= "9";
}
function codePointUnitLength(text, i) {
	const hi = text.charCodeAt(i);
	if (hi >= 55296 && hi <= 56319 && i + 1 < text.length) {
		const lo = text.charCodeAt(i + 1);
		if (lo >= 56320 && lo <= 57343) return 2;
	}
	return 1;
}
function tokenizeMathText(text) {
	const atoms = [];
	let i = 0;
	while (i < text.length) {
		const step = codePointUnitLength(text, i);
		const ch = text.slice(i, i + step);
		if (step === 1 && isDigit(ch)) {
			let end$1 = i + 1;
			let sawDot = false;
			while (end$1 < text.length) {
				const c = text[end$1];
				if (isDigit(c)) {
					end$1++;
					continue;
				}
				if (c === "." && !sawDot && end$1 + 1 < text.length && isDigit(text[end$1 + 1])) {
					sawDot = true;
					end$1++;
					continue;
				}
				break;
			}
			atoms.push({
				tag: "mn",
				content: text.slice(i, end$1)
			});
			i = end$1;
		} else if (step === 1 && OPERATOR_CHARS.has(ch)) {
			atoms.push({
				tag: "mo",
				content: ch
			});
			i++;
		} else {
			atoms.push({
				tag: "mi",
				content: ch
			});
			i += step;
		}
	}
	return atoms;
}
var STY_TO_VARIANT = {
	p: "normal",
	b: "bold",
	i: "italic",
	bi: "bold-italic"
};
var SCR_TO_VARIANT = {
	roman: "normal",
	script: "script",
	fraktur: "fraktur",
	"double-struck": "double-struck",
	"sans-serif": "sans-serif",
	monospace: "monospace"
};
function resolveMathVariant(rPr) {
	const elements = rPr?.elements ?? [];
	const sty = elements.find((el) => el.name === "m:sty")?.attributes?.["m:val"];
	if (sty && STY_TO_VARIANT[sty]) return STY_TO_VARIANT[sty];
	const scr = elements.find((el) => el.name === "m:scr")?.attributes?.["m:val"];
	if (scr && SCR_TO_VARIANT[scr]) return SCR_TO_VARIANT[scr];
	if (elements.some((el) => el.name === "m:nor")) return "normal";
	return null;
}
function extractText(node) {
	let text = "";
	for (const child of node.elements ?? []) if (child.name === "m:t") {
		for (const tc of child.elements ?? []) if (tc.type === "text" && typeof tc.text === "string") text += tc.text;
	}
	return text;
}
const convertMathRun = (node, doc$1) => {
	const text = extractText(node);
	if (!text) return null;
	const variant = resolveMathVariant((node.elements ?? []).find((el) => el.name === "m:rPr"));
	const atoms = tokenizeMathText(text);
	const createAtom = (atom) => {
		const el = doc$1.createElementNS(MATHML_NS$19, atom.tag);
		el.textContent = atom.content;
		if (variant) el.setAttribute("mathvariant", variant);
		return el;
	};
	if (atoms.length === 1) return createAtom(atoms[0]);
	const fragment = doc$1.createDocumentFragment();
	for (const atom of atoms) fragment.appendChild(createAtom(atom));
	return fragment;
};
function tokenizeFunctionNameText(text) {
	const atoms = [];
	let i = 0;
	while (i < text.length) {
		const step = codePointUnitLength(text, i);
		const ch = text.slice(i, i + step);
		if (step === 1 && isDigit(ch)) {
			let end$1 = i + 1;
			let sawDot = false;
			while (end$1 < text.length) {
				const c = text[end$1];
				if (isDigit(c)) {
					end$1++;
					continue;
				}
				if (c === "." && !sawDot && end$1 + 1 < text.length && isDigit(text[end$1 + 1])) {
					sawDot = true;
					end$1++;
					continue;
				}
				break;
			}
			atoms.push({
				tag: "mn",
				content: text.slice(i, end$1)
			});
			i = end$1;
		} else if (step === 1 && OPERATOR_CHARS.has(ch)) {
			atoms.push({
				tag: "mo",
				content: ch
			});
			i++;
		} else {
			let end$1 = i + step;
			while (end$1 < text.length) {
				const s = codePointUnitLength(text, end$1);
				const c = text.slice(end$1, end$1 + s);
				if (s === 1 && (isDigit(c) || OPERATOR_CHARS.has(c))) break;
				end$1 += s;
			}
			atoms.push({
				tag: "mi",
				content: text.slice(i, end$1)
			});
			i = end$1;
		}
	}
	return atoms;
}
function convertMathRunAsFunctionName(node, doc$1) {
	const text = extractText(node);
	if (!text) return null;
	const variant = resolveMathVariant((node.elements ?? []).find((el) => el.name === "m:rPr"));
	const atoms = tokenizeFunctionNameText(text);
	const createAtom = (atom) => {
		const el = doc$1.createElementNS(MATHML_NS$19, atom.tag);
		el.textContent = atom.content;
		if (variant) el.setAttribute("mathvariant", variant);
		return el;
	};
	if (atoms.length === 1) return createAtom(atoms[0]);
	const fragment = doc$1.createDocumentFragment();
	for (const atom of atoms) fragment.appendChild(createAtom(atom));
	return fragment;
}
var MATHML_NS$18 = "http://www.w3.org/1998/Math/MathML";
const convertFraction = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const num = elements.find((e) => e.name === "m:num");
	const den = elements.find((e) => e.name === "m:den");
	const frac = doc$1.createElementNS(MATHML_NS$18, "mfrac");
	const numRow = doc$1.createElementNS(MATHML_NS$18, "mrow");
	numRow.appendChild(convertChildren(num?.elements ?? []));
	frac.appendChild(numRow);
	const denRow = doc$1.createElementNS(MATHML_NS$18, "mrow");
	denRow.appendChild(convertChildren(den?.elements ?? []));
	frac.appendChild(denRow);
	return frac;
};
var MATHML_NS$17 = "http://www.w3.org/1998/Math/MathML";
const convertBar = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const isUnder = (elements.find((e) => e.name === "m:barPr")?.elements?.find((e) => e.name === "m:pos"))?.attributes?.["m:val"] !== "top";
	const base = elements.find((e) => e.name === "m:e");
	const wrapper = doc$1.createElementNS(MATHML_NS$17, isUnder ? "munder" : "mover");
	const baseContent = convertChildren(base?.elements ?? []);
	const mrow = doc$1.createElementNS(MATHML_NS$17, "mrow");
	mrow.appendChild(baseContent);
	wrapper.appendChild(mrow);
	const accent = doc$1.createElementNS(MATHML_NS$17, "mo");
	accent.setAttribute("stretchy", "true");
	accent.textContent = "‾";
	wrapper.appendChild(accent);
	return wrapper;
};
var MATHML_NS$16 = "http://www.w3.org/1998/Math/MathML";
var FUNCTION_APPLY_OPERATOR = "⁡";
var MATH_VARIANT_BOUNDARY_ELEMENTS = new Set([
	"munder",
	"mover",
	"munderover",
	"msub",
	"msup",
	"msubsup",
	"mmultiscripts",
	"mfrac",
	"msqrt",
	"mroot",
	"mtable",
	"mtr",
	"mtd"
]);
function forceNormalMathVariant(root) {
	for (const child of Array.from(root.children)) {
		if (MATH_VARIANT_BOUNDARY_ELEMENTS.has(child.localName)) continue;
		if (child.localName === "mi" && !child.hasAttribute("mathvariant")) child.setAttribute("mathvariant", "normal");
		forceNormalMathVariant(child);
	}
}
var BASE_BEARING_ELEMENTS = new Set([
	"munder",
	"mover",
	"munderover",
	"msub",
	"msup",
	"msubsup",
	"mmultiscripts"
]);
function collapseFunctionNameBases(root) {
	for (const child of Array.from(root.children)) if (BASE_BEARING_ELEMENTS.has(child.localName)) {
		const base = child.children[0];
		if (base) {
			collapseMrowToSingleMi(base);
			collapseFunctionNameBases(base);
		}
	} else collapseFunctionNameBases(child);
}
function collapseMrowToSingleMi(container) {
	const children = Array.from(container.children);
	if (children.length < 2) return;
	if (!children.every((c) => c.localName === "mi")) return;
	const variant = children[0].getAttribute("mathvariant");
	if (!children.every((c) => c.getAttribute("mathvariant") === variant)) return;
	const merged = container.ownerDocument.createElementNS(MATHML_NS$16, "mi");
	merged.textContent = children.map((c) => c.textContent ?? "").join("");
	if (variant) merged.setAttribute("mathvariant", variant);
	container.insertBefore(merged, children[0]);
	for (const c of children) c.remove();
}
const convertFunction = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const functionName = elements.find((element) => element.name === "m:fName");
	const argument = elements.find((element) => element.name === "m:e");
	const wrapper = doc$1.createElementNS(MATHML_NS$16, "mrow");
	const functionNameRow = doc$1.createElementNS(MATHML_NS$16, "mrow");
	for (const child of functionName?.elements ?? []) if (child.name === "m:r") {
		const atom = convertMathRunAsFunctionName(child, doc$1);
		if (atom) functionNameRow.appendChild(atom);
	} else {
		const converted = convertChildren([child]);
		if (converted.childNodes.length > 0) functionNameRow.appendChild(converted);
	}
	collapseFunctionNameBases(functionNameRow);
	forceNormalMathVariant(functionNameRow);
	if (functionNameRow.childNodes.length > 0) wrapper.appendChild(functionNameRow);
	const argumentRow = doc$1.createElementNS(MATHML_NS$16, "mrow");
	argumentRow.appendChild(convertChildren(argument?.elements ?? []));
	if (functionNameRow.childNodes.length > 0 && argumentRow.childNodes.length > 0) {
		const applyOperator = doc$1.createElementNS(MATHML_NS$16, "mo");
		applyOperator.textContent = FUNCTION_APPLY_OPERATOR;
		wrapper.appendChild(applyOperator);
	}
	if (argumentRow.childNodes.length > 0) wrapper.appendChild(argumentRow);
	return wrapper.childNodes.length > 0 ? wrapper : null;
};
var MATHML_NS$15 = "http://www.w3.org/1998/Math/MathML";
var DEFAULT_BEGIN_DELIMITER = "(";
var DEFAULT_END_DELIMITER = ")";
var DEFAULT_SEPARATOR_DELIMITER = "│";
function getDelimiterValue(properties, name, fallback) {
	const property = properties?.elements?.find((element) => element.name === name);
	if (!property) return fallback;
	return property.attributes?.["m:val"] ?? "";
}
const convertDelimiter = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const delimiterProps = elements.find((element) => element.name === "m:dPr");
	const expressions = elements.filter((element) => element.name === "m:e");
	const beginDelimiter = getDelimiterValue(delimiterProps, "m:begChr", DEFAULT_BEGIN_DELIMITER);
	const endDelimiter = getDelimiterValue(delimiterProps, "m:endChr", DEFAULT_END_DELIMITER);
	const separatorDelimiter = getDelimiterValue(delimiterProps, "m:sepChr", DEFAULT_SEPARATOR_DELIMITER);
	const wrapper = doc$1.createElementNS(MATHML_NS$15, "mrow");
	const begin = doc$1.createElementNS(MATHML_NS$15, "mo");
	begin.textContent = beginDelimiter;
	wrapper.appendChild(begin);
	let renderedCount = 0;
	for (const expression of expressions) {
		const fragment = convertChildren(expression?.elements ?? []);
		if (fragment.childNodes.length === 0) continue;
		if (renderedCount > 0) {
			const separator = doc$1.createElementNS(MATHML_NS$15, "mo");
			separator.textContent = separatorDelimiter;
			wrapper.appendChild(separator);
		}
		const group = doc$1.createElementNS(MATHML_NS$15, "mrow");
		group.appendChild(fragment);
		wrapper.appendChild(group);
		renderedCount++;
	}
	const end$1 = doc$1.createElementNS(MATHML_NS$15, "mo");
	end$1.textContent = endDelimiter;
	wrapper.appendChild(end$1);
	return wrapper;
};
var MATHML_NS$14 = "http://www.w3.org/1998/Math/MathML";
const convertSubscript = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const base = elements.find((e) => e.name === "m:e");
	const sub = elements.find((e) => e.name === "m:sub");
	const msub = doc$1.createElementNS(MATHML_NS$14, "msub");
	const baseRow = doc$1.createElementNS(MATHML_NS$14, "mrow");
	baseRow.appendChild(convertChildren(base?.elements ?? []));
	msub.appendChild(baseRow);
	const subRow = doc$1.createElementNS(MATHML_NS$14, "mrow");
	subRow.appendChild(convertChildren(sub?.elements ?? []));
	msub.appendChild(subRow);
	return msub;
};
var MATHML_NS$13 = "http://www.w3.org/1998/Math/MathML";
const convertSuperscript = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const base = elements.find((e) => e.name === "m:e");
	const sup = elements.find((e) => e.name === "m:sup");
	const msup = doc$1.createElementNS(MATHML_NS$13, "msup");
	const baseRow = doc$1.createElementNS(MATHML_NS$13, "mrow");
	baseRow.appendChild(convertChildren(base?.elements ?? []));
	msup.appendChild(baseRow);
	const supRow = doc$1.createElementNS(MATHML_NS$13, "mrow");
	supRow.appendChild(convertChildren(sup?.elements ?? []));
	msup.appendChild(supRow);
	return msup;
};
var MATHML_NS$12 = "http://www.w3.org/1998/Math/MathML";
const convertSubSuperscript = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const base = elements.find((e) => e.name === "m:e");
	const sub = elements.find((e) => e.name === "m:sub");
	const sup = elements.find((e) => e.name === "m:sup");
	const msubsup = doc$1.createElementNS(MATHML_NS$12, "msubsup");
	const baseRow = doc$1.createElementNS(MATHML_NS$12, "mrow");
	baseRow.appendChild(convertChildren(base?.elements ?? []));
	msubsup.appendChild(baseRow);
	const subRow = doc$1.createElementNS(MATHML_NS$12, "mrow");
	subRow.appendChild(convertChildren(sub?.elements ?? []));
	msubsup.appendChild(subRow);
	const supRow = doc$1.createElementNS(MATHML_NS$12, "mrow");
	supRow.appendChild(convertChildren(sup?.elements ?? []));
	msubsup.appendChild(supRow);
	return msubsup;
};
var MATHML_NS$11 = "http://www.w3.org/1998/Math/MathML";
var DEFAULT_ACCENT_CHAR = "̂";
var COMBINING_TO_SPACING = {
	"̀": "`",
	"́": "´",
	"̂": "^",
	"̃": "~",
	"̄": "¯",
	"̆": "˘",
	"̇": "˙",
	"̈": "¨",
	"̊": "˚",
	"̋": "˝",
	"̌": "ˇ",
	"⃖": "←",
	"⃗": "→"
};
const convertAccent = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const base = elements.find((e) => e.name === "m:e");
	if (!base) return null;
	const chr = elements.find((e) => e.name === "m:accPr")?.elements?.find((e) => e.name === "m:chr");
	const rawVal = chr?.attributes?.["m:val"];
	const accentChar = chr === void 0 ? DEFAULT_ACCENT_CHAR : rawVal && rawVal.length > 0 ? rawVal : "";
	const baseRow = doc$1.createElementNS(MATHML_NS$11, "mrow");
	baseRow.appendChild(convertChildren(base.elements ?? []));
	if (!accentChar) return baseRow;
	const renderChar = COMBINING_TO_SPACING[accentChar] ?? accentChar;
	const mover = doc$1.createElementNS(MATHML_NS$11, "mover");
	mover.setAttribute("accent", "true");
	mover.appendChild(baseRow);
	const mo = doc$1.createElementNS(MATHML_NS$11, "mo");
	mo.setAttribute("stretchy", "true");
	mo.textContent = renderChar;
	mover.appendChild(mo);
	return mover;
};
var MATHML_NS$10 = "http://www.w3.org/1998/Math/MathML";
const convertPreSubSuperscript = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const base = elements.find((e) => e.name === "m:e");
	const sub = elements.find((e) => e.name === "m:sub");
	const sup = elements.find((e) => e.name === "m:sup");
	const mmultiscripts = doc$1.createElementNS(MATHML_NS$10, "mmultiscripts");
	const baseRow = doc$1.createElementNS(MATHML_NS$10, "mrow");
	baseRow.appendChild(convertChildren(base?.elements ?? []));
	mmultiscripts.appendChild(baseRow);
	mmultiscripts.appendChild(doc$1.createElementNS(MATHML_NS$10, "mprescripts"));
	const subRow = doc$1.createElementNS(MATHML_NS$10, "mrow");
	subRow.appendChild(convertChildren(sub?.elements ?? []));
	mmultiscripts.appendChild(subRow);
	const supRow = doc$1.createElementNS(MATHML_NS$10, "mrow");
	supRow.appendChild(convertChildren(sup?.elements ?? []));
	mmultiscripts.appendChild(supRow);
	return mmultiscripts;
};
var MATHML_NS$9 = "http://www.w3.org/1998/Math/MathML";
var stripAlignmentMarkers = (nodes) => nodes.map((node) => {
	if (node?.type === "text" && typeof node.text === "string" && node.text.includes("&")) return {
		...node,
		text: node.text.replace(/&/g, "")
	};
	if (node?.elements) return {
		...node,
		elements: stripAlignmentMarkers(node.elements)
	};
	return node;
});
const convertEquationArray = (node, doc$1, convertChildren) => {
	const rows = (node.elements ?? []).filter((e) => e.name === "m:e");
	const mtable = doc$1.createElementNS(MATHML_NS$9, "mtable");
	mtable.setAttribute("columnalign", "left");
	for (const row of rows) {
		const mtr = doc$1.createElementNS(MATHML_NS$9, "mtr");
		const mtd = doc$1.createElementNS(MATHML_NS$9, "mtd");
		const mrow = doc$1.createElementNS(MATHML_NS$9, "mrow");
		const cleanedChildren = stripAlignmentMarkers(row.elements ?? []);
		mrow.appendChild(convertChildren(cleanedChildren));
		mtd.appendChild(mrow);
		mtr.appendChild(mtd);
		mtable.appendChild(mtr);
	}
	return mtable.childNodes.length > 0 ? mtable : null;
};
var MATHML_NS$8 = "http://www.w3.org/1998/Math/MathML";
const convertRadical = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const radPr = elements.find((e) => e.name === "m:radPr");
	const deg = elements.find((e) => e.name === "m:deg");
	const radicand = elements.find((e) => e.name === "m:e");
	const degHideEl = radPr?.elements?.find((e) => e.name === "m:degHide");
	const degHideVal = degHideEl?.attributes?.["m:val"];
	if (degHideEl !== void 0 && degHideVal !== "0" && degHideVal !== "false" && degHideVal !== "off" || !deg || (deg.elements ?? []).length === 0) {
		const msqrt = doc$1.createElementNS(MATHML_NS$8, "msqrt");
		const radicandRow$1 = doc$1.createElementNS(MATHML_NS$8, "mrow");
		radicandRow$1.appendChild(convertChildren(radicand?.elements ?? []));
		msqrt.appendChild(radicandRow$1);
		return msqrt;
	}
	const mroot = doc$1.createElementNS(MATHML_NS$8, "mroot");
	const radicandRow = doc$1.createElementNS(MATHML_NS$8, "mrow");
	radicandRow.appendChild(convertChildren(radicand?.elements ?? []));
	mroot.appendChild(radicandRow);
	const degRow = doc$1.createElementNS(MATHML_NS$8, "mrow");
	degRow.appendChild(convertChildren(deg?.elements ?? []));
	mroot.appendChild(degRow);
	return mroot;
};
var MATHML_NS$7 = "http://www.w3.org/1998/Math/MathML";
const convertLowerLimit = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const base = elements.find((e) => e.name === "m:e");
	const lim = elements.find((e) => e.name === "m:lim");
	const munder = doc$1.createElementNS(MATHML_NS$7, "munder");
	const baseRow = doc$1.createElementNS(MATHML_NS$7, "mrow");
	baseRow.appendChild(convertChildren(base?.elements ?? []));
	munder.appendChild(baseRow);
	const limRow = doc$1.createElementNS(MATHML_NS$7, "mrow");
	limRow.appendChild(convertChildren(lim?.elements ?? []));
	munder.appendChild(limRow);
	return munder;
};
var MATHML_NS$6 = "http://www.w3.org/1998/Math/MathML";
const convertUpperLimit = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const base = elements.find((e) => e.name === "m:e");
	const lim = elements.find((e) => e.name === "m:lim");
	const mover = doc$1.createElementNS(MATHML_NS$6, "mover");
	const baseRow = doc$1.createElementNS(MATHML_NS$6, "mrow");
	baseRow.appendChild(convertChildren(base?.elements ?? []));
	mover.appendChild(baseRow);
	const limRow = doc$1.createElementNS(MATHML_NS$6, "mrow");
	limRow.appendChild(convertChildren(lim?.elements ?? []));
	mover.appendChild(limRow);
	return mover;
};
var MATHML_NS$5 = "http://www.w3.org/1998/Math/MathML";
var DEFAULT_NARY_CHAR = "∫";
var INTEGRAL_CHARS = /^[\u222B-\u2233]$/;
const convertNary = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const naryPr = elements.find((e) => e.name === "m:naryPr");
	const sub = elements.find((e) => e.name === "m:sub");
	const sup = elements.find((e) => e.name === "m:sup");
	const body = elements.find((e) => e.name === "m:e");
	const chr = naryPr?.elements?.find((e) => e.name === "m:chr");
	const limLoc = naryPr?.elements?.find((e) => e.name === "m:limLoc");
	const subHide = naryPr?.elements?.find((e) => e.name === "m:subHide");
	const supHide = naryPr?.elements?.find((e) => e.name === "m:supHide");
	const grow = naryPr?.elements?.find((e) => e.name === "m:grow");
	const opChar = chr === void 0 ? DEFAULT_NARY_CHAR : chr.attributes?.["m:val"] ?? "";
	const limLocVal = limLoc?.attributes?.["m:val"];
	const isUndOvr = limLocVal === "undOvr" || limLoc !== void 0 && limLocVal === void 0 || limLoc === void 0 && opChar !== "" && !INTEGRAL_CHARS.test(opChar);
	const isStOnOffTrue = (el) => el !== void 0 && (el.attributes?.["m:val"] === "1" || el.attributes?.["m:val"] === "on" || el.attributes?.["m:val"] === "true" || !el.attributes);
	const subHidden = isStOnOffTrue(subHide);
	const supHidden = isStOnOffTrue(supHide);
	const stripCtrl = (el) => (el?.elements ?? []).filter((e) => e.name !== "m:ctrlPr");
	const subChildren = stripCtrl(sub);
	const supChildren = stripCtrl(sup);
	const promotedToSup = subHidden && !supHidden ? subChildren : [];
	const promotedToSub = supHidden && !subHidden ? supChildren : [];
	const renderSubChildren = subHidden ? [] : [...subChildren, ...promotedToSub];
	const renderSupChildren = supHidden ? [] : [...promotedToSup, ...supChildren];
	const hasSub = renderSubChildren.length > 0 || sub !== void 0 && !subHidden;
	const hasSup = renderSupChildren.length > 0 || sup !== void 0 && !supHidden;
	const growOff = grow !== void 0 && !isStOnOffTrue(grow);
	const mo = doc$1.createElementNS(MATHML_NS$5, "mo");
	mo.textContent = opChar;
	if (growOff) {
		mo.setAttribute("largeop", "false");
		mo.setAttribute("stretchy", "false");
	}
	let operatorEl;
	if (hasSub && hasSup) {
		const tag = isUndOvr ? "munderover" : "msubsup";
		operatorEl = doc$1.createElementNS(MATHML_NS$5, tag);
		operatorEl.appendChild(mo);
		const subRow = doc$1.createElementNS(MATHML_NS$5, "mrow");
		subRow.appendChild(convertChildren(renderSubChildren));
		operatorEl.appendChild(subRow);
		const supRow = doc$1.createElementNS(MATHML_NS$5, "mrow");
		supRow.appendChild(convertChildren(renderSupChildren));
		operatorEl.appendChild(supRow);
	} else if (hasSub) {
		const tag = isUndOvr ? "munder" : "msub";
		operatorEl = doc$1.createElementNS(MATHML_NS$5, tag);
		operatorEl.appendChild(mo);
		const subRow = doc$1.createElementNS(MATHML_NS$5, "mrow");
		subRow.appendChild(convertChildren(renderSubChildren));
		operatorEl.appendChild(subRow);
	} else if (hasSup) {
		const tag = isUndOvr ? "mover" : "msup";
		operatorEl = doc$1.createElementNS(MATHML_NS$5, tag);
		operatorEl.appendChild(mo);
		const supRow = doc$1.createElementNS(MATHML_NS$5, "mrow");
		supRow.appendChild(convertChildren(renderSupChildren));
		operatorEl.appendChild(supRow);
	} else operatorEl = mo;
	const wrapper = doc$1.createElementNS(MATHML_NS$5, "mrow");
	wrapper.appendChild(operatorEl);
	const bodyRow = doc$1.createElementNS(MATHML_NS$5, "mrow");
	bodyRow.appendChild(convertChildren(body?.elements ?? []));
	if (bodyRow.childNodes.length > 0) wrapper.appendChild(bodyRow);
	return wrapper;
};
var MATHML_NS$4 = "http://www.w3.org/1998/Math/MathML";
const convertPhantom = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const phantPr = elements.find((e) => e.name === "m:phantPr");
	const base = elements.find((e) => e.name === "m:e");
	const show = phantPr?.elements?.find((e) => e.name === "m:show");
	const zeroWid = phantPr?.elements?.find((e) => e.name === "m:zeroWid");
	const zeroAsc = phantPr?.elements?.find((e) => e.name === "m:zeroAsc");
	const zeroDesc = phantPr?.elements?.find((e) => e.name === "m:zeroDesc");
	const isOnOffTrue = (val) => val === "1" || val === "on" || val === "true";
	const isVisible$1 = show == null || !show.attributes || isOnOffTrue(show.attributes["m:val"]);
	const hasZeroDimension = zeroWid || zeroAsc || zeroDesc;
	const content = convertChildren(base?.elements ?? []);
	if (!isVisible$1 && !hasZeroDimension) {
		const mphantom = doc$1.createElementNS(MATHML_NS$4, "mphantom");
		mphantom.appendChild(content);
		return mphantom;
	}
	const mpadded = doc$1.createElementNS(MATHML_NS$4, "mpadded");
	const isZeroVal = (el) => el && (isOnOffTrue(el.attributes?.["m:val"]) || !el.attributes);
	if (isZeroVal(zeroWid)) mpadded.setAttribute("width", "0");
	if (isZeroVal(zeroAsc)) mpadded.setAttribute("height", "0");
	if (isZeroVal(zeroDesc)) mpadded.setAttribute("depth", "0");
	if (!isVisible$1) {
		const mphantom = doc$1.createElementNS(MATHML_NS$4, "mphantom");
		mphantom.appendChild(content);
		mpadded.appendChild(mphantom);
	} else mpadded.appendChild(content);
	return mpadded;
};
var MATHML_NS$3 = "http://www.w3.org/1998/Math/MathML";
var DEFAULT_GROUP_CHAR = "⏟";
var VERT_JC_SHIFT_EM = 1;
const convertGroupCharacter = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const groupChrPr = elements.find((e) => e.name === "m:groupChrPr");
	const base = elements.find((e) => e.name === "m:e");
	const chr = groupChrPr?.elements?.find((e) => e.name === "m:chr");
	const pos = groupChrPr?.elements?.find((e) => e.name === "m:pos");
	const vertJc = groupChrPr?.elements?.find((e) => e.name === "m:vertJc");
	const groupChar = chr ? chr.attributes?.["m:val"] ?? "" : DEFAULT_GROUP_CHAR;
	const position = pos?.attributes?.["m:val"] ?? "bot";
	const vertJustify = vertJc ? vertJc.attributes?.["m:val"] ?? "bot" : null;
	const wrapper = doc$1.createElementNS(MATHML_NS$3, position === "top" ? "mover" : "munder");
	const baseRow = doc$1.createElementNS(MATHML_NS$3, "mrow");
	baseRow.appendChild(convertChildren(base?.elements ?? []));
	wrapper.appendChild(baseRow);
	const mo = doc$1.createElementNS(MATHML_NS$3, "mo");
	mo.setAttribute("stretchy", "true");
	mo.textContent = groupChar;
	wrapper.appendChild(mo);
	if (vertJustify) {
		wrapper.setAttribute("data-vert-jc", vertJustify);
		if (vertJustify !== (position === "top" ? "bot" : "top")) {
			const direction = position === "top" ? 1 : -1;
			wrapper.setAttribute("style", `position: relative; top: ${direction * VERT_JC_SHIFT_EM}em;`);
		}
	}
	return wrapper;
};
var MATHML_NS$2 = "http://www.w3.org/1998/Math/MathML";
var EMPTY_CELL_PLACEHOLDER = "□";
function isPlaceholderHidden(plcHide) {
	if (!plcHide) return false;
	const val = plcHide.attributes?.["m:val"];
	if (val === void 0) return true;
	return val === "1" || val === "true";
}
const convertMatrix = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const rows = elements.filter((e) => e.name === "m:mr");
	const plcHide = elements.find((e) => e.name === "m:mPr")?.elements?.find((e) => e.name === "m:plcHide");
	const hidePlaceholders = isPlaceholderHidden(plcHide);
	const mtable = doc$1.createElementNS(MATHML_NS$2, "mtable");
	for (const row of rows) {
		const mtr = doc$1.createElementNS(MATHML_NS$2, "mtr");
		const cells = row.elements?.filter((e) => e.name === "m:e") ?? [];
		for (const cell of cells) {
			const mtd = doc$1.createElementNS(MATHML_NS$2, "mtd");
			const mrow = doc$1.createElementNS(MATHML_NS$2, "mrow");
			const fragment = convertChildren(cell.elements ?? []);
			if (fragment.childNodes.length === 0 && !hidePlaceholders) {
				const placeholder = doc$1.createElementNS(MATHML_NS$2, "mi");
				placeholder.textContent = EMPTY_CELL_PLACEHOLDER;
				mrow.appendChild(placeholder);
			} else mrow.appendChild(fragment);
			mtd.appendChild(mrow);
			mtr.appendChild(mtd);
		}
		mtable.appendChild(mtr);
	}
	return mtable.childNodes.length > 0 ? mtable : null;
};
var MATHML_NS$1 = "http://www.w3.org/1998/Math/MathML";
const convertBox = (node, doc$1, convertChildren) => {
	const base = (node.elements ?? []).find((e) => e.name === "m:e");
	const mrow = doc$1.createElementNS(MATHML_NS$1, "mrow");
	mrow.appendChild(convertChildren(base?.elements ?? []));
	return mrow.childNodes.length > 0 ? mrow : null;
};
const convertBorderBox = (node, doc$1, convertChildren) => {
	const elements = node.elements ?? [];
	const props = elements.find((e) => e.name === "m:borderBoxPr");
	const base = elements.find((e) => e.name === "m:e");
	const isOn = (el) => {
		if (!el) return false;
		const val = el.attributes?.["m:val"];
		if (val === void 0) return true;
		return val === "1" || val === "true" || val === "on";
	};
	const hideTop = props?.elements?.find((e) => e.name === "m:hideTop");
	const hideBot = props?.elements?.find((e) => e.name === "m:hideBot");
	const hideLeft = props?.elements?.find((e) => e.name === "m:hideLeft");
	const hideRight = props?.elements?.find((e) => e.name === "m:hideRight");
	const strikeBLTR = props?.elements?.find((e) => e.name === "m:strikeBLTR");
	const strikeH = props?.elements?.find((e) => e.name === "m:strikeH");
	const strikeTLBR = props?.elements?.find((e) => e.name === "m:strikeTLBR");
	const strikeV = props?.elements?.find((e) => e.name === "m:strikeV");
	const notations = [];
	if (!(isOn(hideTop) && isOn(hideBot) && isOn(hideLeft) && isOn(hideRight))) if (!isOn(hideTop) && !isOn(hideBot) && !isOn(hideLeft) && !isOn(hideRight)) notations.push("box");
	else {
		if (!isOn(hideTop)) notations.push("top");
		if (!isOn(hideBot)) notations.push("bottom");
		if (!isOn(hideLeft)) notations.push("left");
		if (!isOn(hideRight)) notations.push("right");
	}
	if (isOn(strikeBLTR)) notations.push("updiagonalstrike");
	if (isOn(strikeH)) notations.push("horizontalstrike");
	if (isOn(strikeTLBR)) notations.push("downdiagonalstrike");
	if (isOn(strikeV)) notations.push("verticalstrike");
	const content = convertChildren(base?.elements ?? []);
	if (content.childNodes.length === 0) return null;
	if (notations.length === 0) {
		const mrow = doc$1.createElementNS(MATHML_NS$1, "mrow");
		mrow.appendChild(content);
		return mrow;
	}
	const innerMrow = doc$1.createElementNS(MATHML_NS$1, "mrow");
	innerMrow.appendChild(content);
	const menclose = doc$1.createElementNS(MATHML_NS$1, "menclose");
	menclose.setAttribute("notation", notations.join(" "));
	menclose.appendChild(innerMrow);
	return menclose;
};
const MATHML_NS = "http://www.w3.org/1998/Math/MathML";
var MATH_OBJECT_REGISTRY = {
	"m:r": convertMathRun,
	"m:acc": convertAccent,
	"m:bar": convertBar,
	"m:d": convertDelimiter,
	"m:eqArr": convertEquationArray,
	"m:f": convertFraction,
	"m:func": convertFunction,
	"m:limLow": convertLowerLimit,
	"m:limUpp": convertUpperLimit,
	"m:m": convertMatrix,
	"m:nary": convertNary,
	"m:phant": convertPhantom,
	"m:rad": convertRadical,
	"m:sSub": convertSubscript,
	"m:sSup": convertSuperscript,
	"m:sSubSup": convertSubSuperscript,
	"m:sPre": convertPreSubSuperscript,
	"m:borderBox": convertBorderBox,
	"m:box": convertBox,
	"m:groupChr": convertGroupCharacter
};
var ARGUMENT_ELEMENTS = new Set([
	"m:e",
	"m:num",
	"m:den",
	"m:sub",
	"m:sup",
	"m:deg",
	"m:lim",
	"m:fName",
	"m:oMath"
]);
function convertChildNodes(children, doc$1) {
	const fragment = doc$1.createDocumentFragment();
	for (const child of children) {
		const result = convertNode(child, doc$1);
		if (result) fragment.appendChild(result);
	}
	return fragment;
}
function convertNode(node, doc$1) {
	if (!node) return null;
	if (node.type === "text" && typeof node.text === "string") return doc$1.createTextNode(node.text);
	const name = node.name;
	if (!name) return null;
	if (name.endsWith("Pr")) return null;
	const converter = MATH_OBJECT_REGISTRY[name];
	if (converter) return converter(node, doc$1, (children) => convertChildNodes(children, doc$1));
	if (ARGUMENT_ELEMENTS.has(name)) {
		const children = node.elements ?? [];
		if (children.length === 1) return convertNode(children[0], doc$1);
		const mrow = doc$1.createElementNS(MATHML_NS, "mrow");
		for (const child of children) {
			const result = convertNode(child, doc$1);
			if (result) mrow.appendChild(result);
		}
		return mrow.childNodes.length > 0 ? mrow : null;
	}
	if (name === "m:mr") {
		const fragment$1 = doc$1.createDocumentFragment();
		for (const child of node.elements ?? []) {
			const result = convertNode(child, doc$1);
			if (result) fragment$1.appendChild(result);
		}
		return fragment$1.childNodes.length > 0 ? fragment$1 : null;
	}
	if (name in MATH_OBJECT_REGISTRY && MATH_OBJECT_REGISTRY[name] === null) {
		const mrow = doc$1.createElementNS(MATHML_NS, "mrow");
		for (const child of node.elements ?? []) {
			const result = convertNode(child, doc$1);
			if (result) mrow.appendChild(result);
		}
		return mrow.childNodes.length > 0 ? mrow : null;
	}
	const fragment = doc$1.createDocumentFragment();
	for (const child of node.elements ?? []) {
		const result = convertNode(child, doc$1);
		if (result) fragment.appendChild(result);
	}
	return fragment.childNodes.length > 0 ? fragment : null;
}
function convertOmmlToMathml(ommlJson, doc$1) {
	if (!ommlJson || typeof ommlJson !== "object") return null;
	const root = ommlJson;
	const mathEl = doc$1.createElementNS(MATHML_NS, "math");
	mathEl.setAttribute("style", "font-family: \"Cambria Math\", math");
	if (root.name === "m:oMathPara") {
		mathEl.setAttribute("display", "block");
		mathEl.setAttribute("displaystyle", "true");
	}
	const children = root.elements ?? [];
	for (const child of children) {
		const result = convertNode(child, doc$1);
		if (result) mathEl.appendChild(result);
	}
	return mathEl.childNodes.length > 0 ? mathEl : null;
}
const renderMathRun = (run, context) => {
	const wrapper = context.doc.createElement("span");
	wrapper.className = "sd-math";
	wrapper.style.display = "inline-block";
	wrapper.style.verticalAlign = "middle";
	wrapper.style.minWidth = `${run.width}px`;
	wrapper.style.minHeight = `${run.height}px`;
	wrapper.style.fontSize = BROWSER_DEFAULT_FONT_SIZE;
	wrapper.dataset.layoutEpoch = String(context.layoutEpoch ?? 0);
	const mathEl = convertOmmlToMathml(run.ommlJson, context.doc);
	if (mathEl) wrapper.appendChild(mathEl);
	else wrapper.textContent = run.textContent || "";
	if (run.pmStart != null) wrapper.dataset.pmStart = String(run.pmStart);
	if (run.pmEnd != null) wrapper.dataset.pmEnd = String(run.pmEnd);
	return wrapper;
};
const isImageRun$1 = (run) => run.kind === "image";
const isLineBreakRun$2 = (run) => run.kind === "lineBreak";
const isBreakRun = (run) => run.kind === "break";
const isFieldAnnotationRun$1 = (run) => run.kind === "fieldAnnotation";
const isMathRun = (run) => run.kind === "math";
var renderEmptySdtPlaceholderRun = (run, renderContext) => {
	const elem = renderContext.doc.createElement("span");
	elem.classList.add("superdoc-empty-sdt-placeholder");
	if (run.visualPlaceholder === "emptyInlineSdt") elem.classList.add("superdoc-empty-inline-sdt-placeholder");
	else if (run.visualPlaceholder === "emptyBlockSdt") elem.classList.add("superdoc-empty-block-sdt-placeholder");
	elem.setAttribute("aria-hidden", "true");
	elem.dataset.placeholderText = EMPTY_SDT_PLACEHOLDER_TEXT;
	elem.dataset.layoutEpoch = String(renderContext.layoutEpoch);
	if (run.pmStart != null) elem.dataset.pmStart = String(run.pmStart);
	if (run.pmEnd != null) elem.dataset.pmEnd = String(run.pmEnd);
	renderContext.applySdtDataset(elem, run.sdt);
	applyRunStyles(elem, run, false, renderContext.resolvePhysical);
	return elem;
};
const renderRun = (run, context, renderContext, trackedConfig) => {
	if (isImageRun$1(run)) return renderImageRun(run, renderContext);
	if (isFieldAnnotationRun$1(run)) return renderFieldAnnotationRun(run, renderContext);
	if (isMathRun(run)) return renderMathRun(run, renderContext);
	if (isLineBreakRun$2(run)) return null;
	if (isBreakRun(run)) return null;
	if (isEmptySdtPlaceholderRun(run)) return renderEmptySdtPlaceholderRun(run, renderContext);
	if (!("text" in run) || !run.text) return null;
	return renderTextRun(run, context, renderContext, trackedConfig);
};
var getRunUnderline = (run) => "underline" in run ? run.underline : void 0;
var getRunFontSize = (run) => "fontSize" in run && typeof run.fontSize === "number" ? run.fontSize : 16;
var getRunColor = (run) => "color" in run && typeof run.color === "string" ? run.color : void 0;
const underlineStyleForRun = (run) => getRunUnderline(run)?.style ?? "single";
const canPaintUnderlineAsBorder = (run) => {
	if (!getRunUnderline(run)) return false;
	const style = underlineStyleForRun(run);
	return style !== "none" && style !== "words";
};
const canPaintUnderlineOverlay = (run) => {
	if (!canPaintUnderlineAsBorder(run)) return false;
	const style = underlineStyleForRun(run);
	return style === "single" || style === "double" || style === "dotted" || style === "dashed";
};
const underlineBorderForRun = (run) => {
	if (!canPaintUnderlineAsBorder(run)) return void 0;
	const underlineStyle = underlineStyleForRun(run);
	const borderStyle = underlineStyle === "double" || underlineStyle === "dotted" || underlineStyle === "dashed" ? underlineStyle : "solid";
	const underlineColor = getRunUnderline(run)?.color ?? getRunColor(run) ?? "#000000";
	return `${underlineThicknessPx(getRunFontSize(run))}px ${borderStyle} ${underlineColor}`;
};
const renderInlineTabRun = (run, line, doc$1, layoutEpoch, styleId$1, paintUnderline = true) => {
	const tabEl = doc$1.createElement("span");
	tabEl.classList.add("superdoc-tab");
	const tabWidth = run.width ?? 48;
	tabEl.style.display = "inline-block";
	tabEl.style.width = `${tabWidth}px`;
	const shouldPaintUnderline = paintUnderline && canPaintUnderlineAsBorder(run);
	if (shouldPaintUnderline) {
		tabEl.style.height = `${underlineOffsetFromLineTop(line)}px`;
		tabEl.style.verticalAlign = "top";
	} else {
		tabEl.style.height = `${line.lineHeight}px`;
		tabEl.style.verticalAlign = "bottom";
	}
	if (shouldPaintUnderline) applyTabUnderlineBorder(tabEl, run);
	if (styleId$1) tabEl.setAttribute("styleid", styleId$1);
	if (run.pmStart != null) tabEl.dataset.pmStart = String(run.pmStart);
	if (run.pmEnd != null) tabEl.dataset.pmEnd = String(run.pmEnd);
	tabEl.dataset.layoutEpoch = String(layoutEpoch);
	return tabEl;
};
const renderPositionedTabRun = (run, line, doc$1, layoutEpoch, tabStartX, indentOffset, immediateNextSegment, styleId$1, paintUnderline = true) => {
	const measuredTabEndX = tabStartX + (run.width ?? 0);
	const tabEndX = immediateNextSegment?.precedingTabEndX ?? immediateNextSegment?.x ?? measuredTabEndX;
	const actualTabWidth = tabEndX - tabStartX;
	const tabEl = doc$1.createElement("span");
	tabEl.style.position = "absolute";
	tabEl.style.left = `${tabStartX + indentOffset}px`;
	tabEl.style.top = "0px";
	tabEl.style.width = `${actualTabWidth}px`;
	const shouldPaintUnderline = paintUnderline && canPaintUnderlineAsBorder(run);
	tabEl.style.height = shouldPaintUnderline ? `${underlineOffsetFromLineTop(line)}px` : `${line.lineHeight}px`;
	tabEl.style.display = "inline-block";
	tabEl.style.pointerEvents = "none";
	tabEl.style.zIndex = "1";
	if (shouldPaintUnderline) applyTabUnderlineBorder(tabEl, run);
	else tabEl.style.visibility = "hidden";
	if (styleId$1) tabEl.setAttribute("styleid", styleId$1);
	if (run.pmStart != null) tabEl.dataset.pmStart = String(run.pmStart);
	if (run.pmEnd != null) tabEl.dataset.pmEnd = String(run.pmEnd);
	tabEl.dataset.layoutEpoch = String(layoutEpoch);
	return {
		element: tabEl,
		tabEndX,
		actualTabWidth
	};
};
const underlineOffsetFromLineTop = (line) => {
	return Math.max(0, (line.lineHeight - line.ascent - line.descent) / 2) + line.ascent + Math.min(line.descent, line.lineHeight * .08);
};
var applyTabUnderlineBorder = (tabEl, run) => {
	const border = underlineBorderForRun(run);
	if (!border) return;
	tabEl.style.borderBottom = border;
};
function isMinimalWordLayout$1(value) {
	return isMinimalWordLayout(value);
}
var applyStyles$1 = (el, styles) => {
	Object.entries(styles).forEach(([key, value]) => {
		if (value != null && value !== "" && key in el.style) el.style[key] = String(value);
	});
};
var countSpaces$1 = (text) => {
	let count = 0;
	for (let i = 0; i < text.length; i += 1) if (SPACE_CHARS.has(text[i])) count += 1;
	return count;
};
var isWhitespaceOnly = (text) => {
	if (text.length === 0) return false;
	for (let i = 0; i < text.length; i += 1) if (!SPACE_CHARS.has(text[i])) return false;
	return true;
};
var alignNormalTextBesideInlineImage = (element, run, lineContainsInlineImage) => {
	if (!lineContainsInlineImage) return;
	if (run.kind !== "text" && run.kind !== void 0 || !("text" in run)) return;
	const textRun = run;
	if (normalizeBaselineShift(textRun.baselineShift) != null || textRun.vertAlign != null) return;
	element.style.lineHeight = "normal";
	element.style.verticalAlign = "bottom";
};
var cloneTextRun = (run) => ({
	...run,
	comments: run.comments ? [...run.comments] : void 0,
	dataAttrs: run.dataAttrs ? { ...run.dataAttrs } : void 0,
	underline: run.underline ? { ...run.underline } : void 0,
	pageRefMetadata: run.pageRefMetadata ? { ...run.pageRefMetadata } : void 0
});
var normalizeJustifiedRuns = (runsForLine) => {
	const normalized = runsForLine.map((run) => {
		if (run.kind !== "text" && run.kind !== void 0 || !("text" in run)) return run;
		return cloneTextRun(run);
	});
	const merged = [];
	for (let i = 0; i < normalized.length; i += 1) {
		const run = normalized[i];
		if (run.kind !== "text" && run.kind !== void 0 || !("text" in run)) {
			merged.push(run);
			continue;
		}
		const textRun = run;
		if (!isWhitespaceOnly(textRun.text ?? "")) {
			merged.push(textRun);
			continue;
		}
		const prev = merged[merged.length - 1];
		if (prev && (prev.kind === "text" || prev.kind === void 0) && "text" in prev) {
			const prevTextRun = prev;
			if (textRunMergeSignature(prevTextRun) === textRunMergeSignature(textRun)) {
				const extra = textRun.text ?? "";
				prevTextRun.text = (prevTextRun.text ?? "") + extra;
				if (prevTextRun.pmStart != null) prevTextRun.pmEnd = prevTextRun.pmStart + prevTextRun.text.length;
				else if (prevTextRun.pmEnd != null) prevTextRun.pmEnd = prevTextRun.pmEnd + extra.length;
				continue;
			}
		}
		const next = normalized[i + 1];
		if (next && (next.kind === "text" || next.kind === void 0) && "text" in next) {
			const nextTextRun = next;
			if (textRunMergeSignature(nextTextRun) === textRunMergeSignature(textRun)) {
				const extra = textRun.text ?? "";
				nextTextRun.text = extra + (nextTextRun.text ?? "");
				if (textRun.pmStart != null) nextTextRun.pmStart = textRun.pmStart;
				else if (nextTextRun.pmStart != null) nextTextRun.pmStart = nextTextRun.pmStart - extra.length;
				if (nextTextRun.pmStart != null && nextTextRun.pmEnd == null) nextTextRun.pmEnd = nextTextRun.pmStart + nextTextRun.text.length;
				continue;
			}
		}
		merged.push(textRun);
	}
	if (merged.some((run) => (run.kind === "text" || run.kind === void 0) && "text" in run && (run.text ?? "").trim().length > 0)) for (let i = merged.length - 1; i >= 0; i -= 1) {
		const run = merged[i];
		if (run.kind !== "text" && run.kind !== void 0 || !("text" in run)) continue;
		const text = run.text ?? "";
		let trimCount = 0;
		for (let j = text.length - 1; j >= 0 && text[j] === " "; j -= 1) trimCount += 1;
		if (trimCount === 0) break;
		const nextText = text.slice(0, Math.max(0, text.length - trimCount));
		if (nextText.length === 0) {
			merged.splice(i, 1);
			continue;
		}
		run.text = nextText;
		if (run.pmEnd != null) run.pmEnd = run.pmEnd - trimCount;
		break;
	}
	return merged;
};
var isTextRun$6 = (run) => (run.kind === "text" || run.kind === void 0) && "text" in run;
var isOverlaySafeRunKind = (run) => {
	const kind = run.kind ?? "text";
	return kind === "text" || kind === "tab" || kind === "lineBreak" || kind === "break";
};
var shouldUseLineUnderlineOverlay = (runsForLine) => runsForLine.every(isOverlaySafeRunKind) && runsForLine.some((run) => run.kind === "tab" && canPaintUnderlineOverlay(run));
var cloneRunWithoutUnderline = (run) => ({
	...run,
	underline: void 0
});
var appendUnderlineOverlaySpan = (spans, from$1, to, border) => {
	if (!border || to <= from$1) return;
	const last = spans[spans.length - 1];
	if (last && last.border === border && Math.abs(last.to - from$1) < .5) {
		last.to = to;
		return;
	}
	spans.push({
		from: from$1,
		to,
		border
	});
};
var runInlinePaintWidth = (run, runIndex, segmentsByRun, spacingPerSpace) => {
	if (run.kind === "tab") return run.width ?? 48;
	const segments = segmentsByRun.get(runIndex);
	if (segments?.length) return segments.reduce((sum, segment) => {
		const text = isTextRun$6(run) ? (run.text ?? "").slice(segment.fromChar, segment.toChar) : "";
		return sum + segment.width + spacingPerSpace * countSpaces$1(text);
	}, 0);
	if ("width" in run && typeof run.width === "number") return run.width;
	return 0;
};
var buildInlineUnderlineSpans = (block, line, spacingPerSpace, lineTextStartOffsetPx) => {
	const segmentsByRun = /* @__PURE__ */ new Map();
	line.segments?.forEach((segment) => {
		const segments = segmentsByRun.get(segment.runIndex);
		if (segments) segments.push(segment);
		else segmentsByRun.set(segment.runIndex, [segment]);
	});
	const spans = [];
	let currentX = lineTextStartOffsetPx;
	for (let runIndex = line.fromRun; runIndex <= line.toRun; runIndex += 1) {
		const run = block.runs[runIndex];
		if (!run) continue;
		const width = runInlinePaintWidth(run, runIndex, segmentsByRun, spacingPerSpace);
		if (canPaintUnderlineOverlay(run)) appendUnderlineOverlaySpan(spans, currentX, currentX + width, underlineBorderForRun(run));
		currentX += width;
	}
	return spans;
};
var renderUnderlineSpans = (spans, top$1, el, doc$1) => {
	spans.forEach((span) => {
		const overlay = doc$1.createElement("div");
		overlay.classList.add("superdoc-underline-overlay");
		overlay.setAttribute("aria-hidden", "true");
		overlay.style.position = "absolute";
		overlay.style.left = `${span.from}px`;
		overlay.style.top = `${top$1}px`;
		overlay.style.width = `${Math.max(0, span.to - span.from)}px`;
		overlay.style.height = "0px";
		overlay.style.borderTop = span.border;
		overlay.style.pointerEvents = "none";
		overlay.style.zIndex = "2";
		el.appendChild(overlay);
	});
};
const renderLine = ({ block, line, context, availableWidthOverride, lineIndex, skipJustify, preExpandedRuns, resolvedListTextStartPx, indentOffsetOverride, paragraphMarkLeftOffsetOverride, runContext }) => {
	const expandedBlock = {
		...block,
		runs: preExpandedRuns ?? expandRunsForInlineNewlines(block.runs)
	};
	const lineRange = computeLinePmRange$1(expandedBlock, line);
	let runsForLine = sliceRunsForLine(expandedBlock, line);
	const el = runContext.doc.createElement("div");
	el.classList.add(CLASS_NAMES$1.line);
	applyStyles$1(el, lineStyles(line.lineHeight));
	el.dataset.layoutEpoch = String(runContext.layoutEpoch);
	const styleId$1 = (block.attrs ?? {}).styleId;
	if (styleId$1) el.setAttribute("styleid", styleId$1);
	const pAttrs = block.attrs;
	const isRtl = applyRtlStyles(el, pAttrs);
	if (lineRange.pmStart != null) el.dataset.pmStart = String(lineRange.pmStart);
	if (lineRange.pmEnd != null) el.dataset.pmEnd = String(lineRange.pmEnd);
	const trackedConfig = runContext.resolveTrackedChangesConfig(block);
	if (runsForLine.length === 0) {
		const span = runContext.doc.createElement("span");
		span.classList.add("superdoc-empty-run");
		if (lineRange.pmStart != null) span.dataset.pmStart = String(lineRange.pmStart);
		if (lineRange.pmEnd != null) span.dataset.pmEnd = String(lineRange.pmEnd);
		span.style.fontSize = `${line.lineHeight}px`;
		span.innerHTML = "&nbsp;";
		el.appendChild(span);
	}
	if (line.leaders && line.leaders.length > 0) line.leaders.forEach((ld) => {
		const leaderEl = runContext.doc.createElement("div");
		leaderEl.classList.add("superdoc-leader");
		leaderEl.setAttribute("data-style", ld.style);
		leaderEl.style.position = "absolute";
		leaderEl.style.left = `${ld.from}px`;
		leaderEl.style.width = `${Math.max(0, ld.to - ld.from)}px`;
		const baselineOffset = Math.max(1, Math.round(Math.max(1, line.descent * .5)));
		leaderEl.style.bottom = `${baselineOffset}px`;
		leaderEl.style.height = ld.style === "heavy" ? "2px" : "1px";
		leaderEl.style.pointerEvents = "none";
		leaderEl.style.zIndex = "0";
		if (ld.style === "dot" || ld.style === "middleDot") leaderEl.style.borderBottom = "1px dotted currentColor";
		else if (ld.style === "hyphen") leaderEl.style.borderBottom = "1px dashed currentColor";
		else if (ld.style === "underscore") leaderEl.style.borderBottom = "1px solid currentColor";
		else if (ld.style === "heavy") leaderEl.style.borderBottom = "2px solid currentColor";
		el.appendChild(leaderEl);
	});
	if (line.bars && line.bars.length > 0) line.bars.forEach((bar) => {
		const barEl = runContext.doc.createElement("div");
		barEl.classList.add("superdoc-tab-bar");
		barEl.style.position = "absolute";
		barEl.style.left = `${bar.x}px`;
		barEl.style.top = "0px";
		barEl.style.bottom = "0px";
		barEl.style.width = "1px";
		barEl.style.background = "currentColor";
		barEl.style.opacity = "0.6";
		barEl.style.pointerEvents = "none";
		el.appendChild(barEl);
	});
	const hasExplicitPositioning = line.segments?.some((seg) => seg.x !== void 0);
	const hasMultipleExplicitPositionedSegments = (line.segments?.filter((seg) => seg.x !== void 0).length ?? 0) > 1;
	const availableWidth = availableWidthOverride ?? line.maxWidth ?? line.width;
	const justifyShouldApply = shouldApplyJustify({
		alignment: block.attrs?.alignment,
		hasExplicitPositioning: hasExplicitPositioning ?? false,
		hasExplicitTabStops: line.hasExplicitTabStops === true,
		isLastLineOfParagraph: false,
		paragraphEndsWithLineBreak: false,
		skipJustifyOverride: skipJustify || hasMultipleExplicitPositionedSegments
	});
	if (justifyShouldApply) runsForLine = normalizeJustifiedRuns(runsForLine);
	const spaceCount = line.spaceCount ?? runsForLine.reduce((sum, run) => {
		if (run.kind !== "text" && run.kind !== void 0 || !("text" in run) || run.text == null) return sum;
		return sum + countSpaces$1(run.text);
	}, 0);
	const spacingPerSpace = calculateJustifySpacing({
		lineWidth: line.naturalWidth ?? line.width,
		availableWidth,
		spaceCount,
		shouldJustify: justifyShouldApply
	});
	const lineContainsInlineImage = runsForLine.some((run) => isImageRun$1(run));
	const useSegmentPositioning = shouldUseSegmentPositioning(hasExplicitPositioning ?? false, Boolean(line.segments), isRtl);
	const overlayAlignment = block.attrs?.alignment;
	const overlayIndent = block.attrs?.indent;
	const inlineOverlayOriginMatchesContent = overlayAlignment !== "center" && overlayAlignment !== "right" && (overlayIndent?.hanging ?? 0) === 0 && (overlayIndent?.left ?? 0) >= 0;
	const useLineUnderlineOverlay = Boolean(line.segments) && !isRtl && shouldUseLineUnderlineOverlay(runsForLine) && (useSegmentPositioning || inlineOverlayOriginMatchesContent);
	const resolveLineIndentOffset = () => {
		if (indentOffsetOverride != null) return indentOffsetOverride;
		const paraIndent = block.attrs?.indent;
		const indentLeft = paraIndent?.left ?? 0;
		const firstLine = paraIndent?.firstLine ?? 0;
		const hanging = paraIndent?.hanging ?? 0;
		const isFirstLineOfPara = lineIndex === 0 || lineIndex === void 0;
		const firstLineOffsetForCumX = isFirstLineOfPara ? firstLine - hanging : 0;
		const wordLayoutValue = block.attrs?.wordLayout;
		const wordLayout = isMinimalWordLayout$1(wordLayoutValue) ? wordLayoutValue : void 0;
		const isListParagraph$1 = Boolean(wordLayout?.marker);
		const fallbackListTextStartPx = typeof wordLayout?.marker?.textStartX === "number" && Number.isFinite(wordLayout.marker.textStartX) ? wordLayout.marker.textStartX : typeof wordLayout?.textStartPx === "number" && Number.isFinite(wordLayout.textStartPx) ? wordLayout.textStartPx : void 0;
		return isListParagraph$1 ? isFirstLineOfPara ? resolvedListTextStartPx ?? fallbackListTextStartPx ?? indentLeft : indentLeft : indentLeft + firstLineOffsetForCumX;
	};
	const lineTextStartOffsetPx = paragraphMarkLeftOffsetOverride != null ? paragraphMarkLeftOffsetOverride : resolveLineIndentOffset();
	const paragraphMarkLeftOffsetPx = lineTextStartOffsetPx;
	if (spacingPerSpace !== 0) el.style.wordSpacing = `${spacingPerSpace}px`;
	const underlineSpans = [];
	if (useSegmentPositioning) renderExplicitlyPositionedRuns({
		block,
		line,
		context,
		el,
		lineTextStartOffsetPx,
		spacingPerSpace,
		styleId: styleId$1,
		runContext,
		trackedConfig,
		lineContainsInlineImage,
		useLineUnderlineOverlay,
		underlineSpanCollector: useLineUnderlineOverlay ? underlineSpans : void 0
	});
	else {
		renderInlineRuns({
			runsForLine,
			line,
			context,
			el,
			styleId: styleId$1,
			runContext,
			trackedConfig,
			lineContainsInlineImage,
			useLineUnderlineOverlay
		});
		if (useLineUnderlineOverlay) underlineSpans.push(...buildInlineUnderlineSpans(expandedBlock, line, spacingPerSpace, lineTextStartOffsetPx));
	}
	if (useLineUnderlineOverlay && underlineSpans.length > 0) renderUnderlineSpans(underlineSpans, underlineOffsetFromLineTop(line), el, runContext.doc);
	appendFormattingParagraphMark(el, line, expandedBlock.runs, paragraphMarkLeftOffsetPx, availableWidth, hasExplicitPositioning ?? false, runContext.doc, runContext.showFormattingMarks);
	el.querySelectorAll("a[href]").forEach((anchor) => {
		const pendingTooltip = runContext.pendingTooltips.get(anchor);
		if (pendingTooltip) {
			applyTooltipAccessibility(anchor, pendingTooltip, runContext);
			runContext.pendingTooltips.delete(anchor);
		}
	});
	return el;
};
var renderExplicitlyPositionedRuns = ({ block, line, context, el, lineTextStartOffsetPx, spacingPerSpace, styleId: styleId$1, runContext, trackedConfig, lineContainsInlineImage, useLineUnderlineOverlay, underlineSpanCollector }) => {
	const indentOffset = lineTextStartOffsetPx;
	let cumulativeX = 0;
	const segments = line.segments;
	const segmentsByRun = /* @__PURE__ */ new Map();
	segments.forEach((segment) => {
		const list = segmentsByRun.get(segment.runIndex);
		if (list) list.push(segment);
		else segmentsByRun.set(segment.runIndex, [segment]);
	});
	const findImmediateNextSegment = (fromRunIndex) => {
		const nextRunIdx = fromRunIndex + 1;
		if (nextRunIdx <= line.toRun) {
			const nextSegments = segmentsByRun.get(nextRunIdx);
			if (nextSegments && nextSegments.length > 0) {
				const firstSegment = nextSegments[0];
				return firstSegment.x !== void 0 || firstSegment.precedingTabEndX !== void 0 ? firstSegment : void 0;
			}
		}
	};
	let geoSdtWrapper = null;
	let geoSdtId = null;
	let geoSdtWrapperLeft = 0;
	let geoSdtMaxRight = 0;
	const closeGeoSdtWrapper = () => {
		if (geoSdtWrapper) {
			geoSdtWrapper.style.width = `${geoSdtMaxRight - geoSdtWrapperLeft}px`;
			el.appendChild(geoSdtWrapper);
			geoSdtWrapper = null;
			geoSdtId = null;
		}
	};
	const appendToLineGeo = (elem, runForSdt, elemLeftPx, elemWidthPx) => {
		const resolved = runContext.resolveRunSdtId(runForSdt);
		const thisRunSdtId = resolved?.sdtId ?? null;
		if (thisRunSdtId !== geoSdtId) closeGeoSdtWrapper();
		if (resolved) {
			if (!geoSdtWrapper) {
				geoSdtWrapper = runContext.createInlineSdtWrapper(resolved.sdt);
				if (isEmptyInlineSdtPlaceholderRun(runForSdt)) geoSdtWrapper.dataset.empty = "true";
				geoSdtId = thisRunSdtId;
				geoSdtWrapperLeft = elemLeftPx;
				geoSdtMaxRight = elemLeftPx;
				geoSdtWrapper.style.position = "absolute";
				geoSdtWrapper.style.left = `${elemLeftPx}px`;
				geoSdtWrapper.style.top = "0px";
				geoSdtWrapper.style.height = `${line.lineHeight}px`;
				geoSdtWrapper.style.padding = "0px";
				geoSdtWrapper.style.borderWidth = "0px";
				geoSdtWrapper.style.lineHeight = `${line.lineHeight}px`;
			}
			if (isImageRun$1(runForSdt)) geoSdtWrapper.dataset.containsInlineImage = "true";
			runContext.syncInlineSdtWrapperTypography(geoSdtWrapper, runForSdt);
			geoSdtWrapper.style.lineHeight = `${line.lineHeight}px`;
			elem.style.left = `${elemLeftPx - geoSdtWrapperLeft}px`;
			elem.style.top = "0px";
			geoSdtMaxRight = Math.max(geoSdtMaxRight, elemLeftPx + elemWidthPx);
			runContext.expandSdtWrapperPmRange(geoSdtWrapper, runForSdt.pmStart, runForSdt.pmEnd);
			geoSdtWrapper.appendChild(elem);
		} else el.appendChild(elem);
	};
	for (let runIndex = line.fromRun; runIndex <= line.toRun; runIndex += 1) {
		const baseRun = block.runs[runIndex];
		if (!baseRun) continue;
		if (baseRun.kind === "tab") {
			const immediateNextSegment = findImmediateNextSegment(runIndex);
			const tabStartX = cumulativeX;
			const coveredByOverlay$1 = useLineUnderlineOverlay && canPaintUnderlineOverlay(baseRun);
			const { element: tabEl, tabEndX, actualTabWidth } = renderPositionedTabRun(baseRun, line, runContext.doc, runContext.layoutEpoch, tabStartX, indentOffset, immediateNextSegment, styleId$1, !coveredByOverlay$1);
			appendToLineGeo(tabEl, baseRun, tabStartX + indentOffset, actualTabWidth);
			if (coveredByOverlay$1 && underlineSpanCollector) appendUnderlineOverlaySpan(underlineSpanCollector, tabStartX + indentOffset, tabStartX + indentOffset + actualTabWidth, underlineBorderForRun(baseRun));
			cumulativeX = tabEndX;
			continue;
		}
		if (isImageRun$1(baseRun)) {
			const elem = renderRun(baseRun, context, runContext, trackedConfig);
			if (elem) {
				if (styleId$1) elem.setAttribute("styleid", styleId$1);
				const runSegments$1 = segmentsByRun.get(runIndex);
				const baseSegX = runSegments$1 && runSegments$1[0]?.x !== void 0 ? runSegments$1[0].x : cumulativeX;
				const segX = baseSegX + indentOffset;
				const segWidth = runSegments$1?.[0]?.width ?? 0;
				elem.style.position = "absolute";
				elem.style.left = `${segX}px`;
				appendToLineGeo(elem, baseRun, segX, segWidth);
				cumulativeX = baseSegX + segWidth;
			}
			continue;
		}
		if (isLineBreakRun$2(baseRun)) continue;
		if (isBreakRun(baseRun)) continue;
		if (isFieldAnnotationRun$1(baseRun)) {
			const elem = renderRun(baseRun, context, runContext, trackedConfig);
			if (elem) {
				if (styleId$1) elem.setAttribute("styleid", styleId$1);
				const runSegments$1 = segmentsByRun.get(runIndex);
				const baseSegX = runSegments$1 && runSegments$1[0]?.x !== void 0 ? runSegments$1[0].x : cumulativeX;
				const segX = baseSegX + indentOffset;
				const segWidth = (runSegments$1 && runSegments$1[0]?.width !== void 0 ? runSegments$1[0].width : 0) ?? 0;
				elem.style.position = "absolute";
				elem.style.left = `${segX}px`;
				appendToLineGeo(elem, baseRun, segX, segWidth);
				cumulativeX = baseSegX + segWidth;
			}
			continue;
		}
		if (isMathRun(baseRun)) {
			const elem = renderRun(baseRun, context, runContext, trackedConfig);
			if (elem) {
				if (styleId$1) elem.setAttribute("styleid", styleId$1);
				const runSegments$1 = segmentsByRun.get(runIndex);
				const baseSegX = runSegments$1 && runSegments$1[0]?.x !== void 0 ? runSegments$1[0].x : cumulativeX;
				const segX = baseSegX + indentOffset;
				const segWidth = (runSegments$1 && runSegments$1[0]?.width !== void 0 ? runSegments$1[0].width : baseRun.width) ?? 0;
				elem.style.position = "absolute";
				elem.style.left = `${segX}px`;
				appendToLineGeo(elem, baseRun, segX, segWidth);
				cumulativeX = baseSegX + segWidth;
			}
			continue;
		}
		const runSegments = segmentsByRun.get(runIndex);
		if (!runSegments || runSegments.length === 0) continue;
		if (isEmptySdtPlaceholderRun(baseRun)) {
			const elem = renderRun(baseRun, context, runContext, trackedConfig);
			if (elem) {
				if (styleId$1) elem.setAttribute("styleid", styleId$1);
				const segment = runSegments[0];
				const baseX = segment.x !== void 0 ? segment.x : cumulativeX;
				const xPos = baseX + indentOffset;
				elem.style.position = "absolute";
				elem.style.left = `${xPos}px`;
				appendToLineGeo(elem, baseRun, xPos, segment.width);
				cumulativeX = baseX + segment.width;
			}
			continue;
		}
		if (!("text" in baseRun)) continue;
		const baseText = baseRun.text ?? "";
		const runPmStart = baseRun.pmStart ?? null;
		const fallbackPmEnd = runPmStart != null && baseRun.pmEnd == null ? runPmStart + baseText.length : baseRun.pmEnd ?? null;
		const coveredByOverlay = useLineUnderlineOverlay && canPaintUnderlineOverlay(baseRun);
		runSegments.forEach((segment) => {
			const segmentText = baseText.slice(segment.fromChar, segment.toChar);
			if (!segmentText) return;
			const pmSliceStart = runPmStart != null ? runPmStart + segment.fromChar : void 0;
			const pmSliceEnd = runPmStart != null ? runPmStart + segment.toChar : fallbackPmEnd ?? void 0;
			const segmentRun = {
				...baseRun,
				text: segmentText,
				pmStart: pmSliceStart,
				pmEnd: pmSliceEnd,
				...coveredByOverlay ? { underline: void 0 } : {}
			};
			const elem = renderRun(segmentRun, context, runContext, trackedConfig);
			if (elem) {
				if (coveredByOverlay) elem.style.textDecorationLine = segmentRun.strike ? "line-through" : "none";
				if (styleId$1) elem.setAttribute("styleid", styleId$1);
				alignNormalTextBesideInlineImage(elem, segmentRun, lineContainsInlineImage);
				const baseX = segment.x !== void 0 ? segment.x : cumulativeX;
				const xPos = baseX + indentOffset;
				elem.style.position = "absolute";
				elem.style.left = `${xPos}px`;
				appendToLineGeo(elem, segmentRun, xPos, segment.width);
				const visualWidth = segment.width + (spacingPerSpace !== 0 ? spacingPerSpace * countSpaces$1(segmentText) : 0);
				if (coveredByOverlay && underlineSpanCollector) appendUnderlineOverlaySpan(underlineSpanCollector, xPos, xPos + visualWidth, underlineBorderForRun(baseRun));
				cumulativeX = baseX + visualWidth;
				if (geoSdtWrapper) geoSdtMaxRight = Math.max(geoSdtMaxRight, xPos + visualWidth);
			}
		});
	}
	closeGeoSdtWrapper();
};
var renderInlineRuns = ({ runsForLine, line, context, el, styleId: styleId$1, runContext, trackedConfig, lineContainsInlineImage, useLineUnderlineOverlay }) => {
	let currentInlineSdtWrapper = null;
	let currentInlineSdtId = null;
	const closeCurrentWrapper = () => {
		if (currentInlineSdtWrapper) {
			el.appendChild(currentInlineSdtWrapper);
			currentInlineSdtWrapper = null;
			currentInlineSdtId = null;
		}
	};
	runsForLine.forEach((run) => {
		const resolved = runContext.resolveRunSdtId(run);
		const runSdtId = resolved?.sdtId ?? null;
		if (runSdtId !== currentInlineSdtId) closeCurrentWrapper();
		const suppressUnderline = useLineUnderlineOverlay && canPaintUnderlineOverlay(run);
		const runForRender = suppressUnderline ? cloneRunWithoutUnderline(run) : run;
		const elem = run.kind === "tab" ? renderInlineTabRun(runForRender, line, runContext.doc, runContext.layoutEpoch, styleId$1, !suppressUnderline) : renderRun(runForRender, context, runContext, trackedConfig);
		if (elem) {
			if (suppressUnderline && run.kind !== "tab") elem.style.textDecorationLine = "strike" in runForRender && runForRender.strike ? "line-through" : "none";
			if (styleId$1) elem.setAttribute("styleid", styleId$1);
			alignNormalTextBesideInlineImage(elem, runForRender, lineContainsInlineImage);
			if (resolved) {
				if (!currentInlineSdtWrapper) {
					currentInlineSdtWrapper = runContext.createInlineSdtWrapper(resolved.sdt);
					if (isEmptyInlineSdtPlaceholderRun(run)) currentInlineSdtWrapper.dataset.empty = "true";
					runContext.syncInlineSdtWrapperTypography(currentInlineSdtWrapper, run);
					currentInlineSdtId = runSdtId;
				}
				if (isImageRun$1(run)) currentInlineSdtWrapper.dataset.containsInlineImage = "true";
				runContext.expandSdtWrapperPmRange(currentInlineSdtWrapper, run.pmStart, run.pmEnd);
				currentInlineSdtWrapper.appendChild(elem);
			} else el.appendChild(elem);
		}
	});
	closeCurrentWrapper();
};
const createDrawingImageElement = (doc$1, block, buildImageHyperlinkAnchor$1) => {
	return createBlockImageContent({
		doc: doc$1,
		block,
		className: "superdoc-drawing-image",
		imageDisplay: "block",
		buildImageHyperlinkAnchor: buildImageHyperlinkAnchor$1
	});
};
const createShapeGroupImageElement = (doc$1, child) => {
	const attrs = child.attrs;
	const img = doc$1.createElement("img");
	img.src = attrs.src;
	img.alt = attrs.alt ?? "";
	img.style.objectFit = "contain";
	img.style.display = "block";
	applyImageClipPath(img, attrs.clipPath);
	const opacity = resolveImageOpacity(attrs);
	if (opacity != null) img.style.opacity = opacity;
	return img;
};
const createShapeTextImageElement = (doc$1, part) => {
	const img = doc$1.createElement("img");
	img.src = part.src;
	img.alt = part.alt ?? "";
	if (typeof part.width === "number") img.style.width = `${part.width}px`;
	if (typeof part.height === "number") img.style.height = `${part.height}px`;
	img.style.display = "inline-block";
	img.style.verticalAlign = "bottom";
	return img;
};
const applyStyles = (el, styles) => {
	Object.entries(styles).forEach(([key, value]) => {
		if (value != null && value !== "" && key in el.style) el.style[key] = String(value);
	});
};
const buildImageGeometryTransform = (attrs) => {
	const transforms = [];
	if (attrs.rotation != null && attrs.rotation !== 0) {
		const angleRad = attrs.rotation * Math.PI / 180;
		const cosA = Math.cos(angleRad);
		const sinA = Math.sin(angleRad);
		const newTopLeftX = attrs.width / 2 * (1 - cosA) + attrs.height / 2 * sinA;
		const newTopLeftY = attrs.width / 2 * sinA + attrs.height / 2 * (1 - cosA);
		transforms.push(`translate(${-newTopLeftX}px, ${-newTopLeftY}px)`);
		transforms.push(`rotate(${attrs.rotation}deg)`);
	}
	if (attrs.flipH) transforms.push("scaleX(-1)");
	if (attrs.flipV) transforms.push("scaleY(-1)");
	return transforms.join(" ");
};
const applyImageGeometryTransform = (target, attrs) => {
	const transform = buildImageGeometryTransform(attrs);
	if (!transform) return;
	target.style.transform = transform;
	target.style.transformOrigin = "center";
};
const renderImageFragment = ({ doc: doc$1, fragment, context, resolvedItem, applyResolvedFragmentFrame, applyFragmentFrame, applyFragmentWrapperZIndex, applySdtDataset: applySdtDataset$1, applyContainerSdtDataset: applyContainerSdtDataset$1, buildImageHyperlinkAnchor: buildImageHyperlinkAnchor$1, createErrorPlaceholder }) => {
	try {
		if (resolvedItem?.block?.kind !== "image") throw new Error(`DomPainter: missing resolved image block for fragment ${fragment.blockId}`);
		const block = resolvedItem.block;
		if (!doc$1) throw new Error("DomPainter: document is not available");
		const fragmentEl = doc$1.createElement("div");
		fragmentEl.classList.add(CLASS_NAMES$1.fragment, DOM_CLASS_NAMES.IMAGE_FRAGMENT);
		applyStyles(fragmentEl, fragmentStyles);
		if (resolvedItem) applyResolvedFragmentFrame(fragmentEl, resolvedItem, fragment, context.section);
		else {
			applyFragmentFrame(fragmentEl, fragment, context.section);
			fragmentEl.style.height = `${fragment.height}px`;
			applyFragmentWrapperZIndex(fragmentEl, fragment);
		}
		applySdtDataset$1(fragmentEl, block.attrs?.sdt);
		applyContainerSdtDataset$1(fragmentEl, block.attrs?.containerSdt);
		if (block.id) fragmentEl.setAttribute("data-sd-block-id", block.id);
		const imgPmStart = resolvedItem?.pmStart;
		if (imgPmStart != null) fragmentEl.dataset.pmStart = String(imgPmStart);
		const imgPmEnd = resolvedItem?.pmEnd;
		if (imgPmEnd != null) fragmentEl.dataset.pmEnd = String(imgPmEnd);
		const imgMetadata = resolvedItem?.metadata;
		if (imgMetadata && !block.attrs?.vmlWatermark) fragmentEl.setAttribute("data-image-metadata", JSON.stringify(imgMetadata));
		applyImageGeometryTransform(fragmentEl, {
			width: block.width ?? fragment.width,
			height: block.height ?? fragment.height,
			rotation: block.rotation,
			flipH: block.flipH,
			flipV: block.flipV
		});
		const imageChild = createBlockImageContent({
			doc: doc$1,
			block,
			clipContainer: fragmentEl,
			buildImageHyperlinkAnchor: buildImageHyperlinkAnchor$1
		});
		fragmentEl.appendChild(imageChild);
		return fragmentEl;
	} catch (error) {
		console.error("[DomPainter] Image fragment rendering failed:", {
			fragment,
			error
		});
		return createErrorPlaceholder(fragment.blockId, error);
	}
};
var ACTIVE_HEADER_FOOTER_WATERMARK_PREVIEW_OPACITY = "1";
var INACTIVE_HEADER_FOOTER_WATERMARK_PREVIEW_OPACITY = "0.5";
function pageContextSignature(context) {
	return [
		context.pageNumber,
		context.totalPages,
		context.sectionPageCount ?? "",
		context.pageNumberText ?? "",
		context.displayPageNumber ?? "",
		context.pageNumberFormat ?? "",
		context.pageNumberChapterText ?? "",
		context.pageNumberChapterSeparator ?? ""
	].join("|");
}
function hasPageContextTokenInShapeText(textContent$1) {
	return Array.isArray(textContent$1?.parts) && textContent$1.parts.some((part) => part.fieldType === "PAGE" || part.fieldType === "NUMPAGES" || part.fieldType === "SECTIONPAGES");
}
function hasPageContextTokenInShapeGroup(shapes) {
	return Array.isArray(shapes) && shapes.some((shape) => {
		if (shape.shapeType !== "vectorShape") return false;
		return hasPageContextTokenInShapeText(shape.attrs.textContent);
	});
}
function hasPageContextTokenInBlock(block) {
	if (!block) return false;
	if (block.kind === "paragraph") {
		for (const run of block.runs) if ("token" in run && (run.token === "pageNumber" || run.token === "totalPageCount" || run.token === "sectionPageCount")) return true;
	} else if (block.kind === "list") {
		const list = block;
		for (const item of list.items ?? []) if (hasPageContextTokenInBlock(item.paragraph)) return true;
	} else if (block.kind === "table") {
		const table = block;
		for (const row of table.rows ?? []) for (const cell of row.cells ?? []) if ((cell.blocks ? cell.blocks : cell.paragraph ? [cell.paragraph] : []).some(hasPageContextTokenInBlock)) return true;
	} else if (block.kind === "drawing") {
		const drawing = block;
		if (drawing.drawingKind === "vectorShape" || drawing.drawingKind === "textboxShape") return hasPageContextTokenInShapeText(drawing.textContent);
		if (drawing.drawingKind === "shapeGroup") return hasPageContextTokenInShapeGroup(drawing.shapes);
	}
	return false;
}
function needsRebuildForPageContext(currentContext, nextContext, resolvedItem) {
	const block = resolvedItem?.kind === "fragment" && "block" in resolvedItem ? resolvedItem.block : void 0;
	return pageContextSignature(currentContext) !== pageContextSignature(nextContext) && hasPageContextTokenInBlock(block);
}
function buildSectionPageCounts(pages) {
	const counts = /* @__PURE__ */ new Map();
	for (const page of pages) {
		const sectionIndex = page.sectionIndex ?? 0;
		counts.set(sectionIndex, (counts.get(sectionIndex) ?? 0) + 1);
	}
	return counts;
}
function roundSnapshotMetric(value) {
	if (!Number.isFinite(value)) return null;
	return Math.round(value * 1e3) / 1e3;
}
function readSnapshotPxMetric(styleValue) {
	if (typeof styleValue !== "string" || styleValue.length === 0) return null;
	const parsed = Number.parseFloat(styleValue);
	return Number.isFinite(parsed) ? roundSnapshotMetric(parsed) : null;
}
function readSnapshotStyleValue(styleValue) {
	if (typeof styleValue !== "string" || styleValue.length === 0) return null;
	return styleValue;
}
function createEmptyPaintSnapshotEntities() {
	return {
		annotations: [],
		structuredContentBlocks: [],
		structuredContentInlines: [],
		images: []
	};
}
function readSnapshotDatasetNumber(value) {
	if (typeof value !== "string" || value.length === 0) return null;
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : null;
}
function resolveSnapshotPageIndex(element) {
	const pageEl = element.closest(`.${DOM_CLASS_NAMES.PAGE}`);
	if (!pageEl) return null;
	return readSnapshotDatasetNumber(pageEl.dataset.pageIndex);
}
function compactSnapshotObject(input) {
	const out = {};
	for (const [key, value] of Object.entries(input)) {
		if (value == null) continue;
		if (Array.isArray(value) && value.length === 0) continue;
		out[key] = value;
	}
	return out;
}
function applyLayoutIdentityDataset(element, identity) {
	if (!identity) {
		delete element.dataset[DATASET_KEYS.LAYOUT_FRAGMENT_ID];
		delete element.dataset[DATASET_KEYS.LAYOUT_BLOCK_REF];
		delete element.dataset[DATASET_KEYS.LAYOUT_STORY];
		return;
	}
	element.dataset[DATASET_KEYS.LAYOUT_FRAGMENT_ID] = identity.fragmentId;
	element.dataset[DATASET_KEYS.LAYOUT_BLOCK_REF] = identity.blockRef;
	element.dataset[DATASET_KEYS.LAYOUT_STORY] = encodeLayoutStoryDataset(identity.story);
}
var resolveOrBuildFragmentIdentity = (fragment, story, existing) => buildLayoutSourceIdentityForFragment(existing ? {
	...fragment,
	layoutSourceIdentity: existing,
	sourceAnchor: fragment.sourceAnchor ?? existing.sourceAnchor
} : fragment, story);
var resolveSectionStory = (section) => {
	if (!section || section === "body") return void 0;
	return { kind: section };
};
var resolveDecorationStory = (kind, data) => {
	const id = data.headerFooterRefId ?? data.sectionType;
	return typeof id === "string" && id.length > 0 ? {
		kind,
		id
	} : { kind };
};
function readSourceAnchorDataset(element) {
	if (!element) return void 0;
	const encoded = element.dataset?.sourceAnchor;
	if (typeof encoded !== "string" || encoded.length === 0) return void 0;
	try {
		const parsed = JSON.parse(encoded);
		return parsed && typeof parsed === "object" ? parsed : void 0;
	} catch {
		return;
	}
}
function readNearestSourceAnchor(element) {
	if (!element) return void 0;
	return readSourceAnchorDataset(element) ?? readSourceAnchorDataset(element.closest(`.${CLASS_NAMES$1.fragment}`));
}
function readLayoutIdentityDataset(element) {
	if (!element) return void 0;
	const fragmentId = element.dataset?.[DATASET_KEYS.LAYOUT_FRAGMENT_ID];
	const blockRef = element.dataset?.[DATASET_KEYS.LAYOUT_BLOCK_REF];
	const story = decodeLayoutStoryDataset(element.dataset?.[DATASET_KEYS.LAYOUT_STORY]);
	if (!fragmentId || !blockRef || story.kind === "unknown") return void 0;
	return compactSnapshotObject({
		schema: LAYOUT_BOUNDARY_SCHEMA,
		story,
		blockRef,
		fragmentId,
		sourceAnchor: readNearestSourceAnchor(element)
	});
}
function readNearestLayoutSourceIdentity(element) {
	if (!element) return void 0;
	return readLayoutIdentityDataset(element) ?? readLayoutIdentityDataset(element.closest(`.${CLASS_NAMES$1.fragment}`));
}
function shouldIncludeInlineImageSnapshotElement(element) {
	if (element.classList.contains(DOM_CLASS_NAMES.INLINE_IMAGE_CLIP_WRAPPER)) return true;
	if (!element.classList.contains(DOM_CLASS_NAMES.INLINE_IMAGE)) return false;
	return !element.closest(`.${DOM_CLASS_NAMES.INLINE_IMAGE_CLIP_WRAPPER}`);
}
function resolvedPaintCacheSignature(resolvedItem) {
	if (!resolvedItem) return "";
	return resolvedItem.paintCacheVersion ?? resolvedItem.version ?? "";
}
function collectPaintSnapshotEntitiesFromDomRoot(rootEl) {
	const entities = createEmptyPaintSnapshotEntities();
	const annotationElements = Array.from(rootEl.querySelectorAll(`.${DOM_CLASS_NAMES.ANNOTATION}[data-pm-start]`));
	for (const element of annotationElements) {
		const pageIndex = resolveSnapshotPageIndex(element);
		if (pageIndex == null) continue;
		entities.annotations.push(compactSnapshotObject({
			element,
			pageIndex,
			pmStart: readSnapshotDatasetNumber(element.dataset.pmStart),
			pmEnd: readSnapshotDatasetNumber(element.dataset.pmEnd),
			fieldId: element.dataset.fieldId || null,
			fieldType: element.dataset.fieldType || null,
			type: element.dataset.type || null,
			layoutSourceIdentity: readNearestLayoutSourceIdentity(element)
		}));
	}
	const sdtEntities = collectSdtSnapshotEntitiesFromDomRoot(rootEl, {
		resolvePageIndex: resolveSnapshotPageIndex,
		readDatasetNumber: readSnapshotDatasetNumber,
		readLayoutSourceIdentity: readNearestLayoutSourceIdentity,
		compactObject: compactSnapshotObject
	});
	entities.structuredContentBlocks.push(...sdtEntities.structuredContentBlocks);
	entities.structuredContentInlines.push(...sdtEntities.structuredContentInlines);
	const inlineImageElements = Array.from(rootEl.querySelectorAll(`.${DOM_CLASS_NAMES.INLINE_IMAGE_CLIP_WRAPPER}[data-pm-start], .${DOM_CLASS_NAMES.INLINE_IMAGE}[data-pm-start]`));
	for (const element of inlineImageElements) {
		if (!shouldIncludeInlineImageSnapshotElement(element)) continue;
		const pageIndex = resolveSnapshotPageIndex(element);
		if (pageIndex == null) continue;
		entities.images.push(compactSnapshotObject({
			element,
			pageIndex,
			kind: "inline",
			pmStart: readSnapshotDatasetNumber(element.dataset.pmStart),
			pmEnd: readSnapshotDatasetNumber(element.dataset.pmEnd),
			sourceAnchor: readNearestSourceAnchor(element),
			layoutSourceIdentity: readNearestLayoutSourceIdentity(element)
		}));
	}
	const fragmentImageElements = Array.from(rootEl.querySelectorAll(`.${DOM_CLASS_NAMES.IMAGE_FRAGMENT}[data-pm-start]`));
	for (const element of fragmentImageElements) {
		const pageIndex = resolveSnapshotPageIndex(element);
		if (pageIndex == null) continue;
		entities.images.push(compactSnapshotObject({
			element,
			pageIndex,
			kind: "fragment",
			pmStart: readSnapshotDatasetNumber(element.dataset.pmStart),
			pmEnd: readSnapshotDatasetNumber(element.dataset.pmEnd),
			blockId: element.getAttribute("data-sd-block-id"),
			sourceAnchor: readNearestSourceAnchor(element),
			layoutSourceIdentity: readNearestLayoutSourceIdentity(element)
		}));
	}
	return entities;
}
function snapshotLineStyleFromElement(lineEl) {
	const style = lineEl?.style;
	if (!style) return {};
	return compactSnapshotObject({
		paddingLeftPx: readSnapshotPxMetric(style.paddingLeft),
		paddingRightPx: readSnapshotPxMetric(style.paddingRight),
		textIndentPx: readSnapshotPxMetric(style.textIndent),
		marginLeftPx: readSnapshotPxMetric(style.marginLeft),
		marginRightPx: readSnapshotPxMetric(style.marginRight),
		leftPx: readSnapshotPxMetric(style.left),
		topPx: readSnapshotPxMetric(style.top),
		widthPx: readSnapshotPxMetric(style.width),
		heightPx: readSnapshotPxMetric(style.height),
		display: readSnapshotStyleValue(style.display),
		position: readSnapshotStyleValue(style.position),
		textAlign: readSnapshotStyleValue(style.textAlign),
		justifyContent: readSnapshotStyleValue(style.justifyContent)
	});
}
function applyWrapperMarginsToSnapshotStyle(lineStyle, wrapperEl) {
	if (!wrapperEl?.style) return lineStyle;
	return compactSnapshotObject({
		...lineStyle,
		marginLeftPx: readSnapshotPxMetric(wrapperEl.style.marginLeft) ?? lineStyle.marginLeftPx,
		marginRightPx: readSnapshotPxMetric(wrapperEl.style.marginRight) ?? lineStyle.marginRightPx
	});
}
function snapshotMarkerStyleFromElement(markerEl) {
	const style = markerEl?.style;
	if (!style) return {};
	return compactSnapshotObject({
		text: markerEl?.textContent ?? "",
		leftPx: readSnapshotPxMetric(style.left),
		widthPx: readSnapshotPxMetric(style.width),
		paddingRightPx: readSnapshotPxMetric(style.paddingRight),
		display: readSnapshotStyleValue(style.display),
		position: readSnapshotStyleValue(style.position),
		textAlign: readSnapshotStyleValue(style.textAlign),
		fontWeight: readSnapshotStyleValue(style.fontWeight),
		fontStyle: readSnapshotStyleValue(style.fontStyle),
		color: readSnapshotStyleValue(style.color),
		sourceAnchor: readNearestSourceAnchor(markerEl)
	});
}
function collectLineMarkersForSnapshot(lineEl) {
	const markers = [];
	const parent = lineEl?.parentElement;
	if (parent) for (const child of Array.from(parent.children)) {
		if (!(child instanceof HTMLElement)) continue;
		if (!child.classList.contains("superdoc-paragraph-marker")) continue;
		markers.push(snapshotMarkerStyleFromElement(child));
	}
	const inlineMarkers = lineEl?.querySelectorAll?.(".superdoc-paragraph-marker") ?? [];
	for (const markerEl of Array.from(inlineMarkers)) {
		if (!(markerEl instanceof HTMLElement)) continue;
		const markerStyle = snapshotMarkerStyleFromElement(markerEl);
		const markerText = markerEl.textContent ?? "";
		const markerLeft = readSnapshotPxMetric(markerEl.style.left);
		if (markers.some((existing) => existing.text === markerText && existing.leftPx === markerLeft)) continue;
		markers.push(markerStyle);
	}
	return markers;
}
function collectLineTabsForSnapshot(lineEl) {
	const tabs = [];
	const tabElements = lineEl?.querySelectorAll?.(".superdoc-tab") ?? [];
	for (const tabEl of Array.from(tabElements)) {
		if (!(tabEl instanceof HTMLElement)) continue;
		tabs.push(compactSnapshotObject({
			widthPx: readSnapshotPxMetric(tabEl.style.width),
			leftPx: readSnapshotPxMetric(tabEl.style.left),
			position: readSnapshotStyleValue(tabEl.style.position),
			borderBottom: readSnapshotStyleValue(tabEl.style.borderBottom)
		}));
	}
	return tabs;
}
var DEFAULT_PAGE_HEIGHT_PX = 1056;
var DEFAULT_VIRTUALIZED_PAGE_GAP = 72;
var SVG_NS = "http://www.w3.org/2000/svg";
var WORDART_LINE_FILL_RATIO = .9;
var DomPainter = class {
	constructor(options = {}) {
		this.mount = null;
		this.doc = null;
		this.pageStates = [];
		this.currentLayout = null;
		this.changedBlocks = /* @__PURE__ */ new Set();
		this.totalPages = 0;
		this.sectionPageCounts = /* @__PURE__ */ new Map();
		this.linkIdCounter = 0;
		this.sdtLabelsRendered = /* @__PURE__ */ new Set();
		this.pendingTooltips = /* @__PURE__ */ new WeakMap();
		this.pageGap = 24;
		this.virtualEnabled = false;
		this.virtualWindow = 5;
		this.virtualOverscan = 0;
		this.virtualGap = DEFAULT_VIRTUALIZED_PAGE_GAP;
		this.virtualPaddingTop = null;
		this.topSpacerEl = null;
		this.bottomSpacerEl = null;
		this.virtualPagesEl = null;
		this.virtualGapSpacers = [];
		this.virtualPinnedPages = [];
		this.virtualMountedKey = "";
		this.pageIndexToState = /* @__PURE__ */ new Map();
		this.virtualHeights = [];
		this.virtualOffsets = [];
		this.virtualStart = 0;
		this.virtualEnd = -1;
		this.layoutVersion = 0;
		this.layoutEpoch = 0;
		this.processedLayoutVersion = -1;
		this.currentMapping = null;
		this.onScrollHandler = null;
		this.onWindowScrollHandler = null;
		this.onResizeHandler = null;
		this.zoomFactor = 1;
		this.scrollContainer = null;
		this.scrollContainerMountOffset = null;
		this.paintSnapshotBuilder = null;
		this.lastPaintSnapshot = null;
		this.onPaintSnapshotCallback = null;
		this.mountedPageIndices = [];
		this.resolvedLayout = null;
		this.showFormattingMarks = false;
		this.contentControlsChrome = "default";
		this.options = options;
		this.layoutMode = options.layoutMode ?? "vertical";
		this.isSemanticFlow = (options.flowMode ?? "paginated") === "semantic";
		this.headerProvider = options.headerProvider;
		this.footerProvider = options.footerProvider;
		this.showFormattingMarks = options.showFormattingMarks === true;
		this.contentControlsChrome = options.contentControlsChrome ?? "default";
		const defaultGap = this.layoutMode === "horizontal" ? 20 : 24;
		this.pageGap = typeof options.pageGap === "number" && Number.isFinite(options.pageGap) ? Math.max(0, options.pageGap) : defaultGap;
		if (!this.isSemanticFlow && this.layoutMode === "vertical" && options.virtualization?.enabled) {
			this.virtualEnabled = true;
			this.virtualWindow = Math.max(1, options.virtualization.window ?? 5);
			this.virtualOverscan = Math.max(0, options.virtualization.overscan ?? 0);
			const maybeGap = options.virtualization.gap;
			if (typeof maybeGap === "number" && Number.isFinite(maybeGap)) this.virtualGap = Math.max(0, maybeGap);
			else this.virtualGap = DEFAULT_VIRTUALIZED_PAGE_GAP;
			if (typeof options.virtualization.paddingTop === "number" && Number.isFinite(options.virtualization.paddingTop)) this.virtualPaddingTop = Math.max(0, options.virtualization.paddingTop);
		}
		this.onPaintSnapshotCallback = options.onPaintSnapshot ?? null;
	}
	setShowFormattingMarks(showFormattingMarks) {
		const next = showFormattingMarks === true;
		if (this.showFormattingMarks === next) return;
		this.showFormattingMarks = next;
		this.applyFormattingMarksClass();
		this.invalidateRenderedContent();
	}
	setProviders(header, footer) {
		this.headerProvider = header;
		this.footerProvider = footer;
	}
	applyFormattingMarksClass(mount = this.mount) {
		mount?.classList.toggle("superdoc-show-formatting-marks", this.showFormattingMarks);
		mount?.classList.toggle("superdoc-cc-chrome-none", this.contentControlsChrome === "none");
	}
	invalidateRenderedContent() {
		this.pageStates = [];
		this.currentLayout = null;
		this.pageIndexToState.clear();
		this.virtualMountedKey = "";
		this.clearGapSpacers();
		this.topSpacerEl = null;
		this.bottomSpacerEl = null;
		this.virtualPagesEl = null;
		this.processedLayoutVersion = -1;
		this.layoutVersion += 1;
	}
	setVirtualizationPins(pageIndices) {
		this.virtualPinnedPages = Array.from(new Set((pageIndices ?? []).filter((n) => Number.isInteger(n)))).sort((a, b$1) => a - b$1);
		if (this.virtualEnabled && this.mount) this.updateVirtualWindow();
	}
	setZoom(zoom) {
		const next = typeof zoom === "number" && Number.isFinite(zoom) && zoom > 0 ? zoom : 1;
		if (next !== this.zoomFactor) {
			this.zoomFactor = next;
			this.scrollContainerMountOffset = null;
			if (this.virtualEnabled && this.mount) this.updateVirtualWindow();
		}
	}
	setScrollContainer(el) {
		if (el !== this.scrollContainer) {
			this.scrollContainer = el;
			this.scrollContainerMountOffset = null;
			if (this.virtualEnabled && this.mount) this.updateVirtualWindow();
		}
	}
	getResolvedPage(pageIndex) {
		return this.resolvedLayout?.pages[pageIndex] ?? null;
	}
	getPaintSnapshot() {
		return this.lastPaintSnapshot;
	}
	getMountedPageIndices() {
		return [...this.mountedPageIndices];
	}
	createAllPageIndices(pageCount) {
		return Array.from({ length: pageCount }, (_$1, pageIndex) => pageIndex);
	}
	setMountedPageIndices(pageIndices) {
		this.mountedPageIndices = [...pageIndices];
	}
	emitPaintSnapshot(snapshot) {
		this.lastPaintSnapshot = snapshot;
		this.onPaintSnapshotCallback?.(snapshot);
	}
	beginPaintSnapshot(layout) {
		this.paintSnapshotBuilder = {
			formatVersion: 1,
			lineCount: 0,
			markerCount: 0,
			tabCount: 0,
			pages: layout.pages.map((page, index) => ({
				index,
				pageNumber: Number.isFinite(page.number) ? page.number : null,
				lineCount: 0,
				lines: []
			}))
		};
	}
	finalizePaintSnapshotFromBuilder(rootEl) {
		const builder = this.paintSnapshotBuilder;
		if (!builder) {
			this.lastPaintSnapshot = null;
			return;
		}
		const pages = builder.pages.map((page) => compactSnapshotObject({
			index: page.index,
			pageNumber: page.pageNumber,
			lineCount: page.lineCount,
			lines: page.lines
		}));
		this.emitPaintSnapshot({
			formatVersion: builder.formatVersion,
			pageCount: pages.length,
			lineCount: builder.lineCount,
			markerCount: builder.markerCount,
			tabCount: builder.tabCount,
			pages,
			entities: rootEl ? collectPaintSnapshotEntitiesFromDomRoot(rootEl) : createEmptyPaintSnapshotEntities()
		});
		this.paintSnapshotBuilder = null;
	}
	capturePaintSnapshotLine(lineEl, context, options = {}) {
		const builder = this.paintSnapshotBuilder;
		if (!builder) return;
		const pageIndex = context.pageIndex;
		if (!Number.isInteger(pageIndex)) return;
		const page = builder.pages[pageIndex];
		if (!page) return;
		const markers = collectLineMarkersForSnapshot(lineEl);
		const tabs = collectLineTabsForSnapshot(lineEl);
		const lineIndex = page.lines.length;
		const style = applyWrapperMarginsToSnapshotStyle(snapshotLineStyleFromElement(lineEl), options.wrapperEl);
		page.lines.push(compactSnapshotObject({
			index: lineIndex,
			inTableFragment: options.inTableFragment === true,
			inTableParagraph: options.inTableParagraph === true,
			style,
			markers,
			tabs,
			sourceAnchor: readNearestSourceAnchor(lineEl) ?? readNearestSourceAnchor(options.wrapperEl) ?? options.sourceAnchor,
			layoutSourceIdentity: readNearestLayoutSourceIdentity(lineEl) ?? readNearestLayoutSourceIdentity(options.wrapperEl)
		}));
		page.lineCount += 1;
		builder.lineCount += 1;
		builder.markerCount += markers.length;
		builder.tabCount += tabs.length;
	}
	collectPaintSnapshotFromDomRoot(rootEl) {
		const pageElements = Array.from(rootEl?.querySelectorAll?.(".superdoc-page") ?? []);
		const pages = [];
		let lineCount = 0;
		let markerCount = 0;
		let tabCount = 0;
		for (let domPageIndex = 0; domPageIndex < pageElements.length; domPageIndex += 1) {
			const pageEl = pageElements[domPageIndex];
			if (!(pageEl instanceof HTMLElement)) continue;
			const pageIndexRaw = pageEl.dataset?.pageIndex;
			const pageIndexParsed = pageIndexRaw == null ? NaN : Number(pageIndexRaw);
			const pageIndex = Number.isInteger(pageIndexParsed) ? pageIndexParsed : domPageIndex;
			const lineElements = Array.from(pageEl.querySelectorAll(".superdoc-line"));
			const lines = [];
			for (let lineIndex = 0; lineIndex < lineElements.length; lineIndex += 1) {
				const lineEl = lineElements[lineIndex];
				if (!(lineEl instanceof HTMLElement)) continue;
				const markers = collectLineMarkersForSnapshot(lineEl);
				const tabs = collectLineTabsForSnapshot(lineEl);
				markerCount += markers.length;
				tabCount += tabs.length;
				lineCount += 1;
				lines.push(compactSnapshotObject({
					index: lineIndex,
					inTableFragment: Boolean(lineEl.closest(".superdoc-table-fragment")),
					inTableParagraph: Boolean(lineEl.closest(".superdoc-table-paragraph")),
					style: snapshotLineStyleFromElement(lineEl),
					markers,
					tabs,
					sourceAnchor: readNearestSourceAnchor(lineEl),
					layoutSourceIdentity: readNearestLayoutSourceIdentity(lineEl)
				}));
			}
			const pageNumberRaw = pageEl.dataset?.pageNumber;
			const pageNumberParsed = pageNumberRaw == null ? NaN : Number(pageNumberRaw);
			pages.push(compactSnapshotObject({
				index: pageIndex,
				pageNumber: Number.isFinite(pageNumberParsed) ? pageNumberParsed : null,
				lineCount: lines.length,
				lines
			}));
		}
		return {
			formatVersion: 1,
			pageCount: pages.length,
			lineCount,
			markerCount,
			tabCount,
			pages,
			entities: collectPaintSnapshotEntitiesFromDomRoot(rootEl)
		};
	}
	paint(input, mount, mapping) {
		const resolvedLayout = input.resolvedLayout;
		this.resolvedLayout = resolvedLayout;
		this.changedBlocks.clear();
		if (!(mount instanceof HTMLElement)) throw new Error("DomPainter.paint requires a valid HTMLElement mount");
		const doc$1 = mount.ownerDocument ?? (typeof document !== "undefined" ? document : null);
		if (!doc$1) throw new Error("DomPainter.paint requires a DOM-like document");
		this.doc = doc$1;
		this.sdtLabelsRendered.clear();
		const isSimpleTransaction = mapping && mapping.maps.length === 1;
		if (mapping && !isSimpleTransaction) {
			for (const page of input.resolvedLayout.pages) for (const item of page.items) if ("blockId" in item) this.changedBlocks.add(item.blockId);
			this.currentMapping = null;
		} else this.currentMapping = mapping ?? null;
		ensurePrintStyles(doc$1);
		ensureLinkStyles(doc$1);
		ensureTrackChangeStyles(doc$1);
		ensureFormattingMarksStyles(doc$1);
		ensureFieldAnnotationStyles(doc$1);
		ensureSdtContainerStyles(doc$1);
		ensureImageSelectionStyles(doc$1);
		ensureMathMencloseStyles(doc$1);
		if (!this.isSemanticFlow && this.options.ruler?.enabled) ensureRulerStyles(doc$1);
		mount.classList.add(CLASS_NAMES$1.container);
		this.applyFormattingMarksClass(mount);
		if (this.mount && this.mount !== mount) {
			this.resetState();
			this.applyFormattingMarksClass(mount);
		}
		this.layoutVersion += 1;
		this.layoutEpoch = resolvedLayout.layoutEpoch ?? 0;
		this.mount = mount;
		this.beginPaintSnapshot(resolvedLayout);
		this.totalPages = resolvedLayout.pages.length;
		this.sectionPageCounts = buildSectionPageCounts(resolvedLayout.pages);
		const previousLayout = this.currentLayout;
		this.currentLayout = resolvedLayout;
		if (this.isSemanticFlow) {
			applyStyles(mount, containerStyles);
			mount.style.gap = "0px";
			mount.style.alignItems = "stretch";
			if (!previousLayout || this.pageStates.length === 0) this.fullRender(resolvedLayout);
			else this.patchLayout(resolvedLayout);
			this.setMountedPageIndices(this.createAllPageIndices(resolvedLayout.pages.length));
			this.changedBlocks.clear();
			this.currentMapping = null;
			return;
		}
		let useDomSnapshotFallback = false;
		const mode = this.layoutMode;
		if (mode === "horizontal") {
			applyStyles(mount, containerStylesHorizontal);
			mount.style.gap = `${this.pageGap}px`;
			this.renderHorizontal(resolvedLayout, mount);
			this.finalizePaintSnapshotFromBuilder(mount);
			this.setMountedPageIndices(this.createAllPageIndices(resolvedLayout.pages.length));
			this.currentLayout = resolvedLayout;
			this.pageStates = [];
			this.changedBlocks.clear();
			this.currentMapping = null;
			return;
		}
		if (mode === "book") {
			applyStyles(mount, containerStyles);
			this.renderBookMode(resolvedLayout, mount);
			this.finalizePaintSnapshotFromBuilder(mount);
			this.setMountedPageIndices(this.createAllPageIndices(resolvedLayout.pages.length));
			this.currentLayout = resolvedLayout;
			this.pageStates = [];
			this.changedBlocks.clear();
			this.currentMapping = null;
			return;
		}
		applyStyles(mount, containerStyles);
		if (this.virtualEnabled) {
			mount.style.gap = "0px";
			this.renderVirtualized(resolvedLayout, mount);
			useDomSnapshotFallback = true;
			this.currentLayout = resolvedLayout;
			this.changedBlocks.clear();
			this.currentMapping = null;
		} else {
			mount.style.gap = `${this.pageGap}px`;
			if (!previousLayout || this.pageStates.length === 0) this.fullRender(resolvedLayout);
			else {
				this.patchLayout(resolvedLayout);
				useDomSnapshotFallback = true;
			}
			this.setMountedPageIndices(this.createAllPageIndices(resolvedLayout.pages.length));
		}
		if (useDomSnapshotFallback) {
			this.emitPaintSnapshot(this.collectPaintSnapshotFromDomRoot(mount));
			this.paintSnapshotBuilder = null;
		} else this.finalizePaintSnapshotFromBuilder(mount);
		this.currentLayout = resolvedLayout;
		this.changedBlocks.clear();
		this.currentMapping = null;
	}
	renderVirtualized(layout, mount) {
		if (!this.doc) return;
		this.currentLayout = layout;
		if (!this.topSpacerEl || !this.bottomSpacerEl || !this.virtualPagesEl || this.mount !== mount || this.topSpacerEl.parentElement !== mount) this.ensureVirtualizationSetup(mount);
		this.computeVirtualMetrics();
		this.updateVirtualWindow();
	}
	ensureVirtualizationSetup(mount) {
		if (!this.doc) return;
		mount.innerHTML = "";
		this.pageStates = [];
		this.pageIndexToState.clear();
		this.virtualGapSpacers = [];
		this.virtualMountedKey = "";
		this.topSpacerEl = this.doc.createElement("div");
		this.bottomSpacerEl = this.doc.createElement("div");
		this.configureSpacerElement(this.topSpacerEl, "top");
		this.configureSpacerElement(this.bottomSpacerEl, "bottom");
		this.virtualPagesEl = this.doc.createElement("div");
		this.virtualPagesEl.style.display = "flex";
		this.virtualPagesEl.style.flexDirection = "column";
		this.virtualPagesEl.style.alignItems = "center";
		this.virtualPagesEl.style.width = "100%";
		this.virtualPagesEl.style.gap = `${this.virtualGap}px`;
		this.virtualPagesEl.style.overflowAnchor = "none";
		mount.appendChild(this.topSpacerEl);
		mount.appendChild(this.virtualPagesEl);
		mount.appendChild(this.bottomSpacerEl);
		this.bindVirtualizationHandlers(mount);
	}
	configureSpacerElement(element, type) {
		element.style.width = "1px";
		element.style.height = "0px";
		element.style.flex = "0 0 auto";
		element.style.overflowAnchor = "none";
		element.setAttribute("data-virtual-spacer", type);
	}
	bindVirtualizationHandlers(mount) {
		if (this.onScrollHandler) mount.removeEventListener("scroll", this.onScrollHandler);
		this.onScrollHandler = () => {
			this.updateVirtualWindow();
		};
		mount.addEventListener("scroll", this.onScrollHandler);
		const win = this.doc?.defaultView;
		if (win) {
			if (this.onWindowScrollHandler) win.removeEventListener("scroll", this.onWindowScrollHandler);
			this.onWindowScrollHandler = () => {
				this.updateVirtualWindow();
			};
			win.addEventListener("scroll", this.onWindowScrollHandler, { passive: true });
			if (this.onResizeHandler) win.removeEventListener("resize", this.onResizeHandler);
			this.onResizeHandler = () => {
				this.scrollContainerMountOffset = null;
				this.updateVirtualWindow();
			};
			win.addEventListener("resize", this.onResizeHandler);
		}
	}
	computeVirtualMetrics() {
		if (!this.currentLayout) return;
		if (this.currentLayout.pages.length !== this.virtualHeights.length) this.virtualHeights = this.currentLayout.pages.map((p$1) => p$1.height);
		const offsets = new Array(this.virtualHeights.length + 1);
		offsets[0] = 0;
		for (let i = 0; i < this.virtualHeights.length; i += 1) offsets[i + 1] = offsets[i] + this.virtualHeights[i] + this.virtualGap;
		this.virtualOffsets = offsets;
	}
	topOfIndex(i) {
		if (i <= 0) return 0;
		return this.virtualOffsets[i];
	}
	contentTotalHeight() {
		const n = this.virtualHeights.length;
		if (n <= 0) return 0;
		return this.virtualOffsets[n] - this.virtualGap;
	}
	getMountPaddingTopPx() {
		if (this.virtualPaddingTop != null) return this.virtualPaddingTop;
		if (!this.mount || !this.doc) return 0;
		const win = this.doc.defaultView;
		if (!win) return 0;
		const pt = win.getComputedStyle(this.mount)?.paddingTop ?? "0";
		const val = Number.parseFloat(pt.replace("px", ""));
		if (Number.isFinite(val)) return Math.max(0, val);
		return 0;
	}
	onScroll() {
		if (this.virtualEnabled) this.updateVirtualWindow();
	}
	updateVirtualWindow() {
		if (!this.mount || !this.topSpacerEl || !this.bottomSpacerEl || !this.virtualPagesEl || !this.currentLayout) return;
		const layout = this.currentLayout;
		const N = layout.pages.length;
		if (N === 0) {
			this.mount.innerHTML = "";
			this.setMountedPageIndices([]);
			this.processedLayoutVersion = this.layoutVersion;
			return;
		}
		const paddingTop = this.getMountPaddingTopPx();
		const zoom = this.zoomFactor;
		let scrollY;
		const isContainerScrollable = this.mount.scrollHeight > this.mount.clientHeight + 1;
		const scrollCont = this.scrollContainer;
		const isScrollContainerActive = scrollCont != null && scrollCont.scrollHeight > scrollCont.clientHeight + 1;
		if (isContainerScrollable) scrollY = Math.max(0, this.mount.scrollTop - paddingTop);
		else if (isScrollContainerActive) {
			if (this.scrollContainerMountOffset == null) {
				const mountRect = this.mount.getBoundingClientRect();
				const containerRect = scrollCont.getBoundingClientRect();
				this.scrollContainerMountOffset = mountRect.top - containerRect.top + scrollCont.scrollTop;
			}
			scrollY = Math.max(0, (scrollCont.scrollTop - this.scrollContainerMountOffset) / zoom - paddingTop);
		} else {
			const rect = this.mount.getBoundingClientRect();
			scrollY = Math.max(0, -rect.top / zoom - paddingTop);
		}
		let lo = 0;
		let hi = N;
		while (lo < hi) {
			const mid = lo + hi >>> 1;
			if (this.topOfIndex(mid) <= scrollY) lo = mid + 1;
			else hi = mid;
		}
		const anchor = Math.max(0, lo - 1);
		const baseWindow = this.virtualWindow;
		const overscan = this.virtualOverscan;
		let start$1 = anchor - Math.floor(baseWindow / 2) - overscan;
		start$1 = Math.max(0, Math.min(start$1, Math.max(0, N - baseWindow)));
		const end$1 = Math.min(N - 1, start$1 + baseWindow - 1 + overscan * 2);
		start$1 = Math.max(0, Math.min(start$1, end$1 - baseWindow + 1));
		const needed = /* @__PURE__ */ new Set();
		for (let i = start$1; i <= end$1; i += 1) needed.add(i);
		for (const pageIndex of this.virtualPinnedPages) {
			const idx = Math.max(0, Math.min(pageIndex, N - 1));
			needed.add(idx);
		}
		const mounted = Array.from(needed).sort((a, b$1) => a - b$1);
		const mountedKey = mounted.join(",");
		const alreadyProcessedLayout = this.processedLayoutVersion === this.layoutVersion;
		if (mountedKey === this.virtualMountedKey && this.changedBlocks.size === 0 && alreadyProcessedLayout) {
			this.virtualStart = start$1;
			this.virtualEnd = end$1;
			this.updateSpacersForMountedPages(mounted);
			return;
		}
		this.virtualMountedKey = mountedKey;
		this.virtualStart = start$1;
		this.virtualEnd = end$1;
		this.setMountedPageIndices(mounted);
		this.updateSpacersForMountedPages(mounted);
		this.clearGapSpacers();
		this.sdtLabelsRendered.clear();
		for (const [idx, state] of this.pageIndexToState.entries()) if (!needed.has(idx)) {
			state.element.remove();
			this.pageIndexToState.delete(idx);
		}
		for (const i of mounted) {
			const page = layout.pages[i];
			const existing = this.pageIndexToState.get(i);
			if (!existing) {
				const newState = this.createPageState(page, i);
				newState.element.dataset.pageNumber = String(page.number);
				newState.element.dataset.pageIndex = String(i);
				applyStyles(newState.element, pageStyles(page.width, page.height, this.getEffectivePageStyles()));
				this.virtualPagesEl.appendChild(newState.element);
				this.pageIndexToState.set(i, newState);
			} else this.patchPage(existing, page, i);
		}
		if (this.mount.firstChild !== this.topSpacerEl) this.mount.insertBefore(this.topSpacerEl, this.mount.firstChild);
		if (this.virtualPagesEl.parentElement !== this.mount) this.mount.insertBefore(this.virtualPagesEl, this.bottomSpacerEl);
		this.mount.appendChild(this.bottomSpacerEl);
		let prevIndex = null;
		let cursor = this.virtualPagesEl.firstChild;
		for (const idx of mounted) {
			if (prevIndex != null && idx > prevIndex + 1) {
				const gap = this.doc.createElement("div");
				this.configureSpacerElement(gap, "gap");
				gap.dataset.gapFrom = String(prevIndex);
				gap.dataset.gapTo = String(idx);
				const gapHeight = this.topOfIndex(idx) - this.topOfIndex(prevIndex) - this.virtualHeights[prevIndex] - this.virtualGap * 2;
				gap.style.height = `${Math.max(0, Math.floor(gapHeight))}px`;
				this.virtualGapSpacers.push(gap);
				this.virtualPagesEl.insertBefore(gap, cursor);
			}
			const state = this.pageIndexToState.get(idx);
			if (state.element === cursor) cursor = state.element.nextSibling;
			else this.virtualPagesEl.insertBefore(state.element, cursor);
			prevIndex = idx;
		}
		this.changedBlocks.clear();
		this.processedLayoutVersion = this.layoutVersion;
	}
	updateSpacers(start$1, end$1) {
		if (!this.topSpacerEl || !this.bottomSpacerEl) return;
		const top$1 = this.topOfIndex(start$1);
		const bottom$1 = this.contentTotalHeight() - this.topOfIndex(end$1 + 1);
		this.topSpacerEl.style.height = `${Math.max(0, Math.floor(top$1))}px`;
		this.bottomSpacerEl.style.height = `${Math.max(0, Math.floor(bottom$1))}px`;
	}
	updateSpacersForMountedPages(mountedPageIndices) {
		if (!this.topSpacerEl || !this.bottomSpacerEl) return;
		if (mountedPageIndices.length === 0) {
			this.topSpacerEl.style.height = "0px";
			this.bottomSpacerEl.style.height = "0px";
			return;
		}
		const first$1 = mountedPageIndices[0];
		const last = mountedPageIndices[mountedPageIndices.length - 1];
		const n = this.virtualHeights.length;
		const clampedFirst = Math.max(0, Math.min(first$1, Math.max(0, n - 1)));
		const clampedLast = Math.max(0, Math.min(last, Math.max(0, n - 1)));
		const top$1 = this.topOfIndex(clampedFirst);
		const bottom$1 = this.topOfIndex(n) - this.topOfIndex(clampedLast + 1) - this.virtualGap;
		this.topSpacerEl.style.height = `${Math.max(0, Math.floor(top$1))}px`;
		this.bottomSpacerEl.style.height = `${Math.max(0, Math.floor(bottom$1))}px`;
	}
	clearGapSpacers() {
		for (const el of this.virtualGapSpacers) el.remove();
		this.virtualGapSpacers = [];
	}
	renderHorizontal(layout, mount) {
		if (!this.doc) return;
		mount.innerHTML = "";
		layout.pages.forEach((page, pageIndex) => {
			const pageEl = this.renderPage(page.width, page.height, page, pageIndex);
			mount.appendChild(pageEl);
		});
	}
	renderBookMode(layout, mount) {
		if (!this.doc) return;
		mount.innerHTML = "";
		const pages = layout.pages;
		if (pages.length === 0) return;
		const firstPage = pages[0];
		const firstPageEl = this.renderPage(firstPage.width, firstPage.height, firstPage, 0);
		mount.appendChild(firstPageEl);
		for (let i = 1; i < pages.length; i += 2) {
			const spreadEl = this.doc.createElement("div");
			spreadEl.classList.add(CLASS_NAMES$1.spread);
			applyStyles(spreadEl, spreadStyles);
			const leftPage = pages[i];
			const leftPageEl = this.renderPage(leftPage.width, leftPage.height, leftPage, i);
			spreadEl.appendChild(leftPageEl);
			if (i + 1 < pages.length) {
				const rightPage = pages[i + 1];
				const rightPageEl = this.renderPage(rightPage.width, rightPage.height, rightPage, i + 1);
				spreadEl.appendChild(rightPageEl);
			}
			mount.appendChild(spreadEl);
		}
	}
	renderPage(width, height, page, pageIndex) {
		if (!this.doc) throw new Error("DomPainter: document is not available");
		const el = this.doc.createElement("div");
		el.classList.add(CLASS_NAMES$1.page);
		applyStyles(el, pageStyles(width, height, this.getEffectivePageStyles()));
		this.applySemanticPageOverrides(el);
		el.dataset.layoutEpoch = String(this.layoutEpoch);
		el.dataset.pageNumber = String(page.number);
		el.dataset.pageIndex = String(pageIndex);
		el.dataset[DATASET_KEYS.LAYOUT_BOUNDARY_SCHEMA] = LAYOUT_BOUNDARY_SCHEMA;
		if (!this.isSemanticFlow && this.options.ruler?.enabled) {
			const rulerEl = this.renderPageRuler(width, page);
			if (rulerEl) el.appendChild(rulerEl);
		}
		const contextBase = {
			pageNumber: page.number,
			totalPages: this.totalPages,
			section: "body",
			pageNumberText: page.numberText,
			displayPageNumber: page.displayNumber,
			pageNumberFormat: page.pageNumberFormat,
			pageNumberChapterText: page.pageNumberChapterText,
			pageNumberChapterSeparator: page.pageNumberChapterSeparator,
			sectionPageCount: this.getSectionPageCount(page),
			pageIndex
		};
		const resolvedItems = page.items;
		const sdtBoundaries = computeSdtBoundaries(resolvedItems, this.sdtLabelsRendered);
		const betweenBorderFlags = computeBetweenBorderFlags(resolvedItems);
		resolvedItems.forEach((resolvedItem, index) => {
			if (resolvedItem.kind !== "fragment") return;
			const fragment = resolvedItem.fragment;
			const sdtBoundary = sdtBoundaries.get(index);
			el.appendChild(this.renderFragment(fragment, contextBase, sdtBoundary, betweenBorderFlags.get(index), resolvedItem));
		});
		this.renderDecorationsForPage(el, page, pageIndex);
		this.renderColumnSeparators(el, page, width, height);
		return el;
	}
	renderPageRuler(pageWidthPx, page) {
		if (!this.doc) {
			console.warn("[renderPageRuler] Cannot render ruler: document is not available.");
			return null;
		}
		const margins = page.margins;
		if (!margins) {
			console.warn(`[renderPageRuler] Cannot render ruler for page ${page.number}: margins not available.`);
			return null;
		}
		const leftMargin = margins.left ?? 0;
		const rightMargin = margins.right ?? 0;
		try {
			const rulerDefinition = generateRulerDefinitionFromPx({
				pageWidthPx,
				pageHeightPx: page.height ?? DEFAULT_PAGE_HEIGHT_PX,
				leftMarginPx: leftMargin,
				rightMarginPx: rightMargin
			});
			const interactive = this.options.ruler?.interactive ?? false;
			const onMarginChange = this.options.ruler?.onMarginChange;
			const rulerEl = createRulerElement({
				definition: rulerDefinition,
				doc: this.doc,
				interactive,
				onDragEnd: interactive && onMarginChange ? (side, x) => {
					try {
						const ppi = 96;
						onMarginChange(side, side === "left" ? x / ppi : (pageWidthPx - x) / ppi);
					} catch (error) {
						console.error("[renderPageRuler] Error in onMarginChange callback:", error);
					}
				} : void 0
			});
			rulerEl.style.position = "absolute";
			rulerEl.style.top = "0";
			rulerEl.style.left = "0";
			rulerEl.style.zIndex = "20";
			rulerEl.dataset.pageNumber = String(page.number);
			return rulerEl;
		} catch (error) {
			console.error(`[renderPageRuler] Failed to create ruler for page ${page.number}:`, error);
			return null;
		}
	}
	renderColumnSeparators(pageEl, page, pageWidth, pageHeight) {
		if (!this.doc) return;
		pageEl.querySelectorAll("[data-superdoc-column-separator=\"true\"]").forEach((separator) => separator.remove());
		const pageMargins = page.margins;
		if (!pageMargins) return;
		const leftMargin = pageMargins.left ?? 0;
		const rightMargin = pageMargins.right ?? 0;
		const topMargin = pageMargins.top ?? 0;
		const bottomMargin = pageMargins.bottom ?? 0;
		const contentWidth = pageWidth - leftMargin - rightMargin;
		const regions = page.columnRegions ?? (page.columns ? [{
			yStart: topMargin,
			yEnd: pageHeight - bottomMargin,
			columns: page.columns
		}] : []);
		for (const region of regions) {
			const { columns, yStart, yEnd } = region;
			if (!columns.withSeparator) continue;
			if (columns.count <= 1) continue;
			const regionHeight = yEnd - yStart;
			if (regionHeight <= 0) continue;
			const separatorPositions = this.getColumnSeparatorPositions(columns, leftMargin, contentWidth);
			if (separatorPositions.length === 0) continue;
			const fragmentsInRegion = page.items.filter((item) => item.y >= yStart - .5 && item.y < yEnd + .5);
			for (const separatorX of separatorPositions) {
				if (!fragmentsInRegion.some((f) => f.x >= separatorX)) continue;
				const separatorEl = this.doc.createElement("div");
				separatorEl.dataset.superdocColumnSeparator = "true";
				separatorEl.style.position = "absolute";
				separatorEl.style.left = `${separatorX}px`;
				separatorEl.style.top = `${yStart}px`;
				separatorEl.style.height = `${regionHeight}px`;
				separatorEl.style.width = "1px";
				separatorEl.style.backgroundColor = "#000000";
				separatorEl.style.pointerEvents = "none";
				pageEl.appendChild(separatorEl);
			}
		}
	}
	getColumnSeparatorPositions(columns, leftMargin, contentWidth) {
		const normalized = normalizeColumnLayout(columns, contentWidth);
		if (resolveColumnMode(columns) === "equal") {
			if ((contentWidth - columns.gap * (normalized.count - 1)) / normalized.count <= 1) return [];
		}
		const geometry = getColumnGeometry(normalized);
		if (geometry.length <= 1) return [];
		if (geometry.some((column) => column.width <= 1)) return [];
		return getColumnSeparatorPositions(geometry, leftMargin);
	}
	renderDecorationsForPage(pageEl, page, pageIndex) {
		if (this.isSemanticFlow) return;
		this.renderDecorationSection(pageEl, page, pageIndex, "header");
		this.renderDecorationSection(pageEl, page, pageIndex, "footer");
	}
	isPageRelativeAnchoredFragment(fragment, resolvedItem) {
		if (fragment.kind !== "image" && fragment.kind !== "drawing") return false;
		const block = resolvedItem && "block" in resolvedItem ? resolvedItem.block : void 0;
		if (!block || block.kind !== "image" && block.kind !== "drawing") return false;
		return block.anchor?.vRelativeFrom === "page";
	}
	getDecorationAnchorPageOriginY(page, kind, effectiveOffset) {
		if (kind === "header") return effectiveOffset;
		if (!Number.isFinite(page.height) || page.height <= 0) throw new Error(`DomPainter: invalid ResolvedPage.height (${page.height}) for page ${page.index}; resolve stage must produce a positive numeric height.`);
		const pageMargins = page.margins;
		const pageHeight = page.height;
		const footerDistance = pageMargins?.footer;
		if (typeof footerDistance === "number" && Number.isFinite(footerDistance)) return Math.max(0, pageHeight - Math.max(0, footerDistance));
		const bottomMargin = pageMargins?.bottom;
		if (bottomMargin == null) return effectiveOffset;
		const footnoteReserve = page.footnoteReserved ?? 0;
		const adjustedBottomMargin = Math.max(0, bottomMargin - footnoteReserve);
		return Math.max(0, pageHeight - adjustedBottomMargin);
	}
	renderDecorationSection(pageEl, page, pageIndex, kind) {
		if (!this.doc) return;
		const provider = kind === "header" ? this.headerProvider : this.footerProvider;
		const className = kind === "header" ? CLASS_NAMES$1.pageHeader : CLASS_NAMES$1.pageFooter;
		const existing = pageEl.querySelector(`.${className}`);
		const data = provider ? provider(page.number, page.margins, page) : null;
		if (!data || data.fragments.length === 0) {
			existing?.remove();
			return;
		}
		const container = existing ?? this.doc.createElement("div");
		container.className = className;
		container.innerHTML = "";
		const baseOffset = data.offset;
		const marginLeft = data.marginLeft ?? 0;
		const marginRight = page.margins?.right ?? 0;
		let effectiveHeight = data.height;
		let effectiveOffset = baseOffset;
		if (kind === "footer" && typeof data.contentHeight === "number" && Number.isFinite(data.contentHeight) && data.contentHeight > 0 && data.contentHeight > data.height) {
			effectiveHeight = data.contentHeight;
			effectiveOffset = baseOffset - (data.contentHeight - data.height);
		}
		container.style.position = "absolute";
		container.style.left = `${marginLeft}px`;
		if (typeof data.contentWidth === "number") container.style.width = `${Math.max(0, data.contentWidth)}px`;
		else container.style.width = `calc(100% - ${marginLeft + marginRight}px)`;
		container.style.pointerEvents = "none";
		container.style.height = `${effectiveHeight}px`;
		container.style.top = `${Math.max(0, effectiveOffset)}px`;
		container.style.zIndex = "1";
		container.style.overflow = "visible";
		const footerAnchorPageOriginY = kind === "footer" ? this.getDecorationAnchorPageOriginY(page, kind, effectiveOffset) : 0;
		const footerAnchorContainerOffsetY = kind === "footer" ? footerAnchorPageOriginY - effectiveOffset : 0;
		let footerYOffset = 0;
		if (kind === "footer" && data.fragments.length > 0) {
			const contentHeight = typeof data.contentHeight === "number" ? data.contentHeight : data.fragments.reduce((max$2, f, fi) => {
				const resolvedItem = data.items?.[fi];
				const fragHeight = "height" in f && typeof f.height === "number" ? f.height : this.estimateFragmentHeight(f, resolvedItem);
				return Math.max(max$2, f.y + Math.max(0, fragHeight));
			}, 0);
			footerYOffset = Math.max(0, effectiveHeight - contentHeight);
		}
		const context = {
			pageNumber: page.number,
			totalPages: this.totalPages,
			section: kind,
			story: resolveDecorationStory(kind, data),
			pageNumberText: page.numberText,
			displayPageNumber: page.displayNumber,
			pageNumberFormat: page.pageNumberFormat,
			pageNumberChapterText: page.pageNumberChapterText,
			pageNumberChapterSeparator: page.pageNumberChapterSeparator,
			sectionPageCount: this.getSectionPageCount(page),
			pageIndex
		};
		const decorationItems = data.items ?? [];
		const betweenBorderFlags = computeBetweenBorderFlags(decorationItems);
		const behindDocFragments = [];
		const normalFragments = [];
		for (let fi = 0; fi < data.fragments.length; fi += 1) {
			const fragment = data.fragments[fi];
			let isBehindDoc = false;
			if (fragment.kind === "image" || fragment.kind === "drawing") {
				const resolvedItem = decorationItems[fi];
				isBehindDoc = fragment.behindDoc === true || fragment.behindDoc == null && "zIndex" in fragment && fragment.zIndex === 0 || this.shouldRenderBehindPageContent(fragment, kind, resolvedItem);
			}
			if (isBehindDoc) behindDocFragments.push({
				fragment,
				originalIndex: fi
			});
			else normalFragments.push({
				fragment,
				originalIndex: fi
			});
		}
		const behindDocSelector = `[data-behind-doc-section="${kind}"]`;
		pageEl.querySelectorAll(behindDocSelector).forEach((el) => el.remove());
		behindDocFragments.forEach(({ fragment, originalIndex }) => {
			const resolvedItem = data.items?.[originalIndex];
			const fragEl = this.renderFragment(fragment, context, void 0, betweenBorderFlags.get(originalIndex), resolvedItem);
			this.applyHeaderFooterTextWatermarkPreviewOpacity(fragEl, data.isActiveHeaderFooter === true);
			const isPageRelative = this.isPageRelativeAnchoredFragment(fragment, resolvedItem);
			let pageY;
			if (isPageRelative && kind === "footer") pageY = footerAnchorPageOriginY + fragment.y;
			else if (isPageRelative) pageY = fragment.y;
			else pageY = effectiveOffset + fragment.y + (kind === "footer" ? footerYOffset : 0);
			fragEl.style.top = `${pageY}px`;
			fragEl.style.left = `${isPageRelative ? fragment.x : marginLeft + fragment.x}px`;
			fragEl.style.zIndex = "0";
			fragEl.dataset.behindDocSection = kind;
			pageEl.insertBefore(fragEl, pageEl.firstChild);
		});
		normalFragments.forEach(({ fragment, originalIndex }) => {
			const resolvedItem = data.items?.[originalIndex];
			const fragEl = this.renderFragment(fragment, context, void 0, betweenBorderFlags.get(originalIndex), resolvedItem);
			this.applyHeaderFooterTextWatermarkPreviewOpacity(fragEl, data.isActiveHeaderFooter === true);
			const isPageRelative = this.isPageRelativeAnchoredFragment(fragment, resolvedItem);
			if (isPageRelative && kind === "footer") fragEl.style.top = `${fragment.y + footerAnchorContainerOffsetY}px`;
			else if (isPageRelative) fragEl.style.top = `${fragment.y - effectiveOffset}px`;
			else if (footerYOffset > 0) {
				const currentTop = parseFloat(fragEl.style.top) || fragment.y;
				fragEl.style.top = `${currentTop + footerYOffset}px`;
			}
			container.appendChild(fragEl);
		});
		if (!existing) pageEl.appendChild(container);
	}
	resetState() {
		if (this.mount) {
			if (this.onScrollHandler) try {
				this.mount.removeEventListener("scroll", this.onScrollHandler);
			} catch {}
			if (this.onWindowScrollHandler && this.doc?.defaultView) try {
				this.doc.defaultView.removeEventListener("scroll", this.onWindowScrollHandler);
			} catch {}
			if (this.onResizeHandler && this.doc?.defaultView) try {
				this.doc.defaultView.removeEventListener("resize", this.onResizeHandler);
			} catch {}
			this.mount.innerHTML = "";
		}
		this.pageStates = [];
		this.currentLayout = null;
		this.pageIndexToState.clear();
		this.topSpacerEl = null;
		this.bottomSpacerEl = null;
		this.virtualPagesEl = null;
		this.onScrollHandler = null;
		this.onWindowScrollHandler = null;
		this.onResizeHandler = null;
		this.scrollContainerMountOffset = null;
		this.layoutVersion = 0;
		this.processedLayoutVersion = -1;
		this.paintSnapshotBuilder = null;
		this.lastPaintSnapshot = null;
		this.mountedPageIndices = [];
	}
	getSectionPageCount(page) {
		return this.sectionPageCounts.get(page.sectionIndex ?? 0) ?? this.totalPages ?? 1;
	}
	fullRender(layout) {
		if (!this.mount || !this.doc) return;
		this.mount.innerHTML = "";
		this.pageStates = [];
		layout.pages.forEach((page, pageIndex) => {
			const pageState = this.createPageState(page, pageIndex);
			pageState.element.dataset.pageNumber = String(page.number);
			pageState.element.dataset.pageIndex = String(pageIndex);
			this.mount.appendChild(pageState.element);
			this.pageStates.push(pageState);
		});
	}
	patchLayout(layout) {
		if (!this.mount || !this.doc) return;
		const nextStates = [];
		layout.pages.forEach((page, index) => {
			const prevState = this.pageStates[index];
			if (!prevState) {
				const newState = this.createPageState(page, index);
				newState.element.dataset.pageNumber = String(page.number);
				newState.element.dataset.pageIndex = String(index);
				this.mount.insertBefore(newState.element, this.mount.children[index] ?? null);
				nextStates.push(newState);
				return;
			}
			this.patchPage(prevState, page, index);
			nextStates.push(prevState);
		});
		if (this.pageStates.length > layout.pages.length) for (let i = layout.pages.length; i < this.pageStates.length; i += 1) this.pageStates[i]?.element.remove();
		this.pageStates = nextStates;
	}
	patchPage(state, page, pageIndex) {
		const pageEl = state.element;
		applyStyles(pageEl, pageStyles(page.width, page.height, this.getEffectivePageStyles()));
		this.applySemanticPageOverrides(pageEl);
		pageEl.dataset.pageNumber = String(page.number);
		pageEl.dataset.layoutEpoch = String(this.layoutEpoch);
		const existing = new Map(state.fragments.map((frag) => [frag.key, frag]));
		const nextFragments = [];
		const resolvedItems = page.items;
		const sdtBoundaries = computeSdtBoundaries(resolvedItems, this.sdtLabelsRendered);
		const betweenBorderFlags = computeBetweenBorderFlags(resolvedItems);
		const contextBase = {
			pageNumber: page.number,
			totalPages: this.totalPages,
			section: "body",
			pageNumberText: page.numberText,
			displayPageNumber: page.displayNumber,
			pageNumberFormat: page.pageNumberFormat,
			pageNumberChapterText: page.pageNumberChapterText,
			pageNumberChapterSeparator: page.pageNumberChapterSeparator,
			sectionPageCount: this.getSectionPageCount(page),
			pageIndex
		};
		resolvedItems.forEach((resolvedItem, index) => {
			if (resolvedItem.kind !== "fragment") return;
			const fragment = resolvedItem.fragment;
			const key = fragmentKey(fragment);
			const current = existing.get(key);
			const sdtBoundary = sdtBoundaries.get(index);
			const betweenInfo = betweenBorderFlags.get(index);
			const resolvedSig = resolvedPaintCacheSignature(resolvedItem);
			if (current) {
				existing.delete(key);
				const geometryChanged = hasFragmentGeometryChanged(current.fragment, fragment);
				const sdtBoundaryMismatch = shouldRebuildForSdtBoundary(current.element, sdtBoundary);
				const betweenBorderMismatch = current.element.dataset.betweenBorder === "true" !== (betweenInfo?.showBetweenBorder ?? false) || current.element.dataset.suppressTopBorder === "true" !== (betweenInfo?.suppressTopBorder ?? false) || (current.element.dataset.gapBelow ?? "") !== (betweenInfo?.gapBelow ? String(betweenInfo.gapBelow) : "");
				const pageContextChanged = needsRebuildForPageContext(current.context, contextBase, resolvedItem);
				const newPmStart = fragment.pmStart;
				const mappingUnreliable = this.currentMapping != null && newPmStart != null && current.element.dataset.pmStart != null && this.currentMapping.map(Number(current.element.dataset.pmStart)) !== newPmStart;
				if (geometryChanged || this.changedBlocks.has(fragment.blockId) || current.signature !== resolvedSig || sdtBoundaryMismatch || betweenBorderMismatch || pageContextChanged || mappingUnreliable) {
					const replacement = this.renderFragment(fragment, contextBase, sdtBoundary, betweenInfo, resolvedItem);
					pageEl.replaceChild(replacement, current.element);
					current.element = replacement;
					current.signature = resolvedSig;
				} else if (this.currentMapping) this.updatePositionAttributes(current.element, this.currentMapping);
				this.updateFragmentElement(current.element, fragment, contextBase.section, resolvedItem);
				if (sdtBoundary?.widthOverride != null) current.element.style.width = `${sdtBoundary.widthOverride}px`;
				current.fragment = fragment;
				current.key = key;
				current.context = contextBase;
				nextFragments.push(current);
				return;
			}
			const fresh = this.renderFragment(fragment, contextBase, sdtBoundary, betweenInfo, resolvedItem);
			pageEl.insertBefore(fresh, pageEl.children[index] ?? null);
			nextFragments.push({
				key,
				fragment,
				element: fresh,
				signature: resolvedSig,
				context: contextBase
			});
		});
		existing.forEach((state$1) => state$1.element.remove());
		nextFragments.forEach((fragmentState, index) => {
			const desiredChild = pageEl.children[index];
			if (fragmentState.element !== desiredChild) pageEl.insertBefore(fragmentState.element, desiredChild ?? null);
		});
		state.fragments = nextFragments;
		this.renderDecorationsForPage(pageEl, page, pageIndex);
		this.renderColumnSeparators(pageEl, page, page.width, page.height);
	}
	updatePositionAttributes(fragmentEl, mapping) {
		if (fragmentEl.closest(".superdoc-page-header, .superdoc-page-footer")) return;
		if (isNonBodyStoryBlockId(fragmentEl.dataset.blockId)) return;
		try {
			const fragEnd = fragmentEl.dataset.pmEnd;
			if (fragEnd !== void 0 && fragEnd !== "") {
				const endNum = Number(fragEnd);
				if (Number.isFinite(endNum) && mapping.map(endNum, -1) === endNum) return;
			}
			const elements = fragmentEl.querySelectorAll("[data-pm-start], [data-pm-end]");
			const allElements = [fragmentEl, ...Array.from(elements)];
			for (const el of allElements) {
				const oldStart = el.dataset.pmStart;
				const oldEnd = el.dataset.pmEnd;
				if (oldStart !== void 0 && oldStart !== "") {
					const num = Number(oldStart);
					if (Number.isFinite(num)) el.dataset.pmStart = String(mapping.map(num));
				}
				if (oldEnd !== void 0 && oldEnd !== "") {
					const num = Number(oldEnd);
					if (Number.isFinite(num)) el.dataset.pmEnd = String(mapping.map(num, -1));
				}
			}
		} catch (error) {
			console.error("Error updating position attributes with mapping:", error);
		}
	}
	createPageState(page, pageIndex) {
		if (!this.doc) throw new Error("DomPainter.createPageState requires a document");
		const el = this.doc.createElement("div");
		el.classList.add(CLASS_NAMES$1.page);
		applyStyles(el, pageStyles(page.width, page.height, this.getEffectivePageStyles()));
		this.applySemanticPageOverrides(el);
		el.dataset.layoutEpoch = String(this.layoutEpoch);
		el.dataset[DATASET_KEYS.LAYOUT_BOUNDARY_SCHEMA] = LAYOUT_BOUNDARY_SCHEMA;
		const contextBase = {
			pageNumber: page.number,
			totalPages: this.totalPages,
			section: "body",
			pageNumberText: page.numberText,
			displayPageNumber: page.displayNumber,
			pageNumberFormat: page.pageNumberFormat,
			pageNumberChapterText: page.pageNumberChapterText,
			pageNumberChapterSeparator: page.pageNumberChapterSeparator,
			sectionPageCount: this.getSectionPageCount(page),
			pageIndex
		};
		const resolvedItems = page.items;
		const sdtBoundaries = computeSdtBoundaries(resolvedItems, this.sdtLabelsRendered);
		const betweenBorderFlags = computeBetweenBorderFlags(resolvedItems);
		const fragmentStates = resolvedItems.flatMap((resolvedItem, index) => {
			if (resolvedItem.kind !== "fragment") return [];
			const fragment = resolvedItem.fragment;
			const sdtBoundary = sdtBoundaries.get(index);
			const fragmentEl = this.renderFragment(fragment, contextBase, sdtBoundary, betweenBorderFlags.get(index), resolvedItem);
			el.appendChild(fragmentEl);
			const initSig = resolvedPaintCacheSignature(resolvedItem);
			return [{
				key: fragmentKey(fragment),
				signature: initSig,
				fragment,
				element: fragmentEl,
				context: contextBase
			}];
		});
		this.renderDecorationsForPage(el, page, pageIndex);
		this.renderColumnSeparators(el, page, page.width, page.height);
		return {
			element: el,
			fragments: fragmentStates
		};
	}
	applySemanticPageOverrides(el) {
		if (this.isSemanticFlow) {
			el.style.overflow = "visible";
			el.style.width = "100%";
			el.style.minWidth = "100%";
		}
	}
	getEffectivePageStyles() {
		const documentBackgroundColor = this.currentLayout?.documentBackground?.color;
		const base = this.options.pageStyles ?? {};
		const baseWithDocumentBackground = documentBackgroundColor ? {
			...base,
			background: documentBackgroundColor
		} : base;
		if (this.isSemanticFlow) return {
			...baseWithDocumentBackground,
			background: baseWithDocumentBackground.background ?? "var(--sd-layout-page-bg, #fff)",
			boxShadow: "none",
			border: "none",
			margin: "0"
		};
		if (this.virtualEnabled && this.layoutMode === "vertical") return {
			...baseWithDocumentBackground,
			margin: "0 auto"
		};
		return documentBackgroundColor ? baseWithDocumentBackground : this.options.pageStyles;
	}
	renderFragment(fragment, context, sdtBoundary, betweenInfo, resolvedItem) {
		if (fragment.kind === "para") return this.renderParagraphFragment(fragment, context, sdtBoundary, betweenInfo, resolvedItem);
		if (fragment.kind === "image") return this.renderImageFragment(fragment, context, resolvedItem);
		if (fragment.kind === "drawing") return this.renderDrawingFragment(fragment, context, resolvedItem);
		if (fragment.kind === "table") return this.renderTableFragment(fragment, context, sdtBoundary, resolvedItem);
		throw new Error(`DomPainter: unsupported fragment kind ${fragment.kind}`);
	}
	renderParagraphFragment(fragment, context, sdtBoundary, betweenInfo, resolvedItem) {
		return renderParagraphFragment({
			doc: this.doc,
			fragment,
			sdtBoundary,
			betweenInfo,
			resolvedItem,
			applyStyles,
			applyResolvedFragmentFrame: (el, item, paraFragment) => this.applyResolvedFragmentFrame(el, item, paraFragment, context.section, context.story),
			applyFragmentFrame: (el, paraFragment) => this.applyFragmentFrame(el, paraFragment, context.section, context.story),
			applySdtDataset,
			applyContainerSdtDataset,
			resolvePhysical: this.options.resolvePhysical,
			renderLine: ({ block, line, availableWidth, lineIndex, skipJustify, preExpandedRuns, resolvedListTextStartPx, indentOffsetOverride, paragraphMarkLeftOffsetOverride }) => this.renderLine(block, line, context, availableWidth, lineIndex, skipJustify, preExpandedRuns, resolvedListTextStartPx, indentOffsetOverride, paragraphMarkLeftOffsetOverride),
			captureLineSnapshot: (lineEl, options) => {
				this.capturePaintSnapshotLine(lineEl, context, {
					inTableFragment: false,
					inTableParagraph: false,
					wrapperEl: options?.wrapperEl,
					sourceAnchor: options?.sourceAnchor
				});
			},
			contentControlsChrome: this.contentControlsChrome,
			createErrorPlaceholder: this.createErrorPlaceholder.bind(this)
		});
	}
	createErrorPlaceholder(blockId, error) {
		if (!this.doc) {
			const el$1 = document.createElement("div");
			el$1.className = "render-error-placeholder";
			el$1.style.cssText = "color: red; padding: 4px; border: 1px solid red; background: #fee;";
			el$1.textContent = `[Render Error: ${blockId}]`;
			return el$1;
		}
		const el = this.doc.createElement("div");
		el.className = "render-error-placeholder";
		el.style.cssText = "color: red; padding: 4px; border: 1px solid red; background: #fee;";
		el.textContent = `[Render Error: ${blockId}]`;
		if (error instanceof Error) el.title = error.message;
		return el;
	}
	renderImageFragment(fragment, context, resolvedItem) {
		const fragmentEl = renderImageFragment({
			doc: this.doc,
			fragment,
			context,
			resolvedItem,
			applyResolvedFragmentFrame: (el, item, imageFragment, section) => this.applyResolvedFragmentFrame(el, item, imageFragment, section, context.story),
			applyFragmentFrame: (el, imageFragment, section) => this.applyFragmentFrame(el, imageFragment, section, context.story),
			applyFragmentWrapperZIndex: this.applyFragmentWrapperZIndex.bind(this),
			applySdtDataset,
			applyContainerSdtDataset,
			buildImageHyperlinkAnchor: this.buildImageHyperlinkAnchor.bind(this),
			createErrorPlaceholder: this.createErrorPlaceholder.bind(this)
		});
		if (this.isVmlTextWatermarkImage(resolvedItem?.block)) fragmentEl.dataset.vmlTextWatermark = "true";
		return fragmentEl;
	}
	buildImageHyperlinkAnchor(imageEl, hyperlink, display) {
		if (!this.doc) return imageEl;
		return buildImageHyperlinkAnchor(this.doc, imageEl, hyperlink, display);
	}
	renderDrawingFragment(fragment, context, resolvedItem) {
		try {
			if (resolvedItem?.block?.kind !== "drawing") throw new Error(`DomPainter: missing resolved drawing block for fragment ${fragment.blockId}`);
			const block = resolvedItem.block;
			if (!this.doc) throw new Error("DomPainter: document is not available");
			const fragmentEl = this.doc.createElement("div");
			fragmentEl.classList.add(CLASS_NAMES$1.fragment, "superdoc-drawing-fragment");
			applyStyles(fragmentEl, fragmentStyles);
			if (resolvedItem) this.applyResolvedFragmentFrame(fragmentEl, resolvedItem, fragment, context.section, context.story);
			else {
				this.applyFragmentFrame(fragmentEl, fragment, context.section, context.story);
				fragmentEl.style.height = `${fragment.height}px`;
				this.applyFragmentWrapperZIndex(fragmentEl, fragment);
			}
			fragmentEl.style.position = "absolute";
			fragmentEl.style.overflow = "hidden";
			const innerWrapper = this.doc.createElement("div");
			innerWrapper.classList.add("superdoc-drawing-inner");
			innerWrapper.style.position = "absolute";
			innerWrapper.style.left = "50%";
			innerWrapper.style.top = "50%";
			innerWrapper.style.width = `${fragment.geometry.width}px`;
			innerWrapper.style.height = `${fragment.geometry.height}px`;
			innerWrapper.style.transformOrigin = "center";
			const scale = fragment.scale ?? 1;
			const transforms = ["translate(-50%, -50%)"];
			transforms.push(`rotate(${fragment.geometry.rotation ?? 0}deg)`);
			transforms.push(`scaleX(${fragment.geometry.flipH ? -1 : 1})`);
			transforms.push(`scaleY(${fragment.geometry.flipV ? -1 : 1})`);
			transforms.push(`scale(${scale})`);
			innerWrapper.style.transform = transforms.join(" ");
			innerWrapper.appendChild(this.renderDrawingContent(block, fragment, context));
			fragmentEl.appendChild(innerWrapper);
			return fragmentEl;
		} catch (error) {
			console.error("[DomPainter] Drawing fragment rendering failed:", {
				fragment,
				error
			});
			return this.createErrorPlaceholder(fragment.blockId, error);
		}
	}
	renderDrawingContent(block, fragment, context) {
		if (!this.doc) throw new Error("DomPainter: document is not available");
		if (block.drawingKind === "image") return createDrawingImageElement(this.doc, block, this.buildImageHyperlinkAnchor.bind(this));
		if (block.drawingKind === "vectorShape" || block.drawingKind === "textboxShape") return this.createVectorShapeElement(block, fragment.geometry, false, 1, 1, context, fragment);
		if (block.drawingKind === "shapeGroup") return this.createShapeGroupElement(block, context);
		if (block.drawingKind === "chart") return this.createChartElement(block);
		return this.createDrawingPlaceholder();
	}
	createVectorShapeElement(block, geometry, applyTransforms = false, groupScaleX = 1, groupScaleY = 1, context, fragment) {
		const container = this.doc.createElement("div");
		container.classList.add("superdoc-vector-shape");
		if (block.drawingKind === "textboxShape") container.classList.add("superdoc-textbox-shape");
		container.style.width = "100%";
		container.style.height = "100%";
		container.style.position = "relative";
		container.style.overflow = "hidden";
		const { offsetX, offsetY, innerWidth, innerHeight } = this.getEffectExtentMetrics(block, geometry);
		const contentContainer = this.doc.createElement("div");
		contentContainer.style.position = "absolute";
		contentContainer.style.left = `${offsetX}px`;
		contentContainer.style.top = `${offsetY}px`;
		contentContainer.style.width = `${innerWidth}px`;
		contentContainer.style.height = `${innerHeight}px`;
		if (applyTransforms && geometry) this.applyVectorShapeTransforms(contentContainer, geometry);
		const customGeomSvg = block.customGeometry ? this.tryCreateCustomGeometrySvg(block, innerWidth, innerHeight) : null;
		const svgMarkup = !customGeomSvg && block.shapeKind ? this.tryCreatePresetSvg(block, innerWidth, innerHeight) : null;
		const resolvedSvgMarkup = customGeomSvg || svgMarkup;
		if (resolvedSvgMarkup) {
			const svgElement = this.parseSafeSvg(resolvedSvgMarkup);
			if (svgElement) {
				svgElement.setAttribute("width", "100%");
				svgElement.setAttribute("height", "100%");
				svgElement.style.display = "block";
				if (block.fillColor && typeof block.fillColor === "object") {
					if ("type" in block.fillColor && block.fillColor.type === "gradient") applyGradientToSVG(svgElement, block.fillColor);
					else if ("type" in block.fillColor && block.fillColor.type === "solidWithAlpha") applyAlphaToSVG(svgElement, block.fillColor);
				}
				this.applyLineEnds(svgElement, block);
				contentContainer.appendChild(svgElement);
				if (block.drawingKind === "textboxShape" || this.hasShapeTextContent(block.textContent)) {
					const textElement = block.drawingKind === "textboxShape" ? this.createTextboxContentElement(block, fragment, innerWidth, innerHeight, context) : this.createShapeTextElement(block, innerWidth, innerHeight, groupScaleX, groupScaleY, context);
					contentContainer.appendChild(textElement);
				}
				container.appendChild(contentContainer);
				return container;
			}
		}
		this.applyFallbackShapeStyle(contentContainer, block);
		if (block.drawingKind === "textboxShape" || this.hasShapeTextContent(block.textContent)) {
			const textElement = block.drawingKind === "textboxShape" ? this.createTextboxContentElement(block, fragment, innerWidth, innerHeight, context) : this.createShapeTextElement(block, innerWidth, innerHeight, groupScaleX, groupScaleY, context);
			contentContainer.appendChild(textElement);
		}
		container.appendChild(contentContainer);
		return container;
	}
	applyFallbackShapeStyle(container, block) {
		if (block.fillColor === null) container.style.background = "none";
		else if (typeof block.fillColor === "string") container.style.background = block.fillColor;
		else if (typeof block.fillColor === "object" && "type" in block.fillColor) {
			if (block.fillColor.type === "solidWithAlpha") {
				const alpha = block.fillColor.alpha;
				const color = block.fillColor.color;
				container.style.background = color;
				container.style.opacity = alpha.toString();
			} else if (block.fillColor.type === "gradient") container.style.background = "rgba(15, 23, 42, 0.1)";
		} else container.style.background = "rgba(15, 23, 42, 0.1)";
		if (block.strokeColor === null) container.style.border = "none";
		else if (typeof block.strokeColor === "string") {
			const strokeWidth = block.strokeWidth ?? 1;
			container.style.border = `${strokeWidth}px solid ${block.strokeColor}`;
		} else container.style.border = "1px solid rgba(15, 23, 42, 0.3)";
	}
	hasShapeTextContent(textContent$1) {
		return Array.isArray(textContent$1?.parts) && textContent$1.parts.length > 0;
	}
	createShapeTextElement(block, width, height, groupScaleX = 1, groupScaleY = 1, context) {
		const textContent$1 = block.textContent;
		if (!this.hasShapeTextContent(textContent$1)) return this.doc.createElement("div");
		if (this.shouldUseWordArtTextRenderer(block)) return this.createWordArtTextElement(textContent$1, block.textAlign ?? "center", block.textInsets, width, height, context);
		return this.createFallbackTextElement(textContent$1, block.textAlign ?? "center", block.textVerticalAlign, block.textInsets, groupScaleX, groupScaleY, context);
	}
	createTextboxContentElement(block, fragment, width, height, context) {
		const contentMeasures = fragment?.contentMeasures ?? block.contentMeasures;
		if (!Array.isArray(contentMeasures) || contentMeasures.length === 0) return this.hasShapeTextContent(block.textContent) ? this.createShapeTextElement(block, width, height, 1, 1, context) : this.doc.createElement("div");
		const contentRoot = this.doc.createElement("div");
		contentRoot.style.position = "absolute";
		contentRoot.style.top = "0";
		contentRoot.style.left = "0";
		contentRoot.style.width = "100%";
		contentRoot.style.height = "100%";
		contentRoot.style.display = "flex";
		contentRoot.style.flexDirection = "column";
		contentRoot.style.boxSizing = "border-box";
		contentRoot.style.overflow = "hidden";
		const insets = block.textInsets ?? {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		};
		contentRoot.style.padding = `${insets.top}px ${insets.right}px ${insets.bottom}px ${insets.left}px`;
		const verticalAlign = block.textVerticalAlign ?? "top";
		contentRoot.style.justifyContent = verticalAlign === "bottom" ? "flex-end" : verticalAlign === "center" ? "center" : "flex-start";
		const linesHost = this.doc.createElement("div");
		linesHost.style.display = "flex";
		linesHost.style.flexDirection = "column";
		linesHost.style.minWidth = "0";
		linesHost.style.width = "100%";
		const renderContext = context ?? this.defaultFragmentRenderContext();
		const availableWidth = Math.max(1, width - insets.left - insets.right);
		block.contentBlocks.forEach((paragraphBlock, paragraphIndex) => {
			const measure = contentMeasures[paragraphIndex];
			if (!measure?.lines) return;
			measure.lines.forEach((line, lineIndex) => {
				linesHost.appendChild(this.renderLine(paragraphBlock, line, renderContext, availableWidth, lineIndex));
			});
		});
		contentRoot.appendChild(linesHost);
		return contentRoot;
	}
	shouldUseWordArtTextRenderer(block) {
		return block.attrs?.isWordArt === true && this.hasShapeTextContent(block.textContent);
	}
	createWordArtTextElement(textContent$1, textAlign, textInsets, width, height, context) {
		const svg = this.doc.createElementNS(SVG_NS, "svg");
		svg.classList.add("superdoc-wordart-text");
		svg.setAttribute("xmlns", SVG_NS);
		svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
		svg.setAttribute("preserveAspectRatio", "none");
		svg.style.position = "absolute";
		svg.style.left = "0";
		svg.style.top = "0";
		svg.style.width = "100%";
		svg.style.height = "100%";
		svg.style.overflow = "visible";
		svg.style.pointerEvents = "none";
		const insets = textInsets ?? {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		};
		const availableWidth = Math.max(1, width - insets.left - insets.right);
		const availableHeight = Math.max(1, height - insets.top - insets.bottom);
		const lines = this.buildWordArtLines(textContent$1, context);
		const lineHeight = availableHeight / Math.max(lines.length, 1);
		const fontSize = Math.max(1, lineHeight * WORDART_LINE_FILL_RATIO);
		const textAnchor = this.getWordArtTextAnchor(textAlign);
		const textX = this.getWordArtTextX(textAlign, insets.left, availableWidth);
		lines.forEach((parts, lineIndex) => {
			if (parts.length === 0) return;
			const textEl = this.doc.createElementNS(SVG_NS, "text");
			textEl.setAttribute("xml:space", "preserve");
			textEl.setAttribute("x", String(textX));
			textEl.setAttribute("y", String(insets.top + lineHeight * (lineIndex + .5)));
			textEl.setAttribute("text-anchor", textAnchor);
			textEl.setAttribute("dominant-baseline", "middle");
			textEl.setAttribute("font-size", String(fontSize));
			textEl.setAttribute("textLength", String(availableWidth));
			textEl.setAttribute("lengthAdjust", "spacingAndGlyphs");
			parts.forEach((part) => {
				const tspan = this.doc.createElementNS(SVG_NS, "tspan");
				tspan.setAttribute("xml:space", "preserve");
				tspan.textContent = part.text;
				this.applyWordArtTextFormatting(tspan, part.formatting);
				textEl.appendChild(tspan);
			});
			svg.appendChild(textEl);
		});
		return svg;
	}
	buildWordArtLines(textContent$1, context) {
		const lines = [[]];
		textContent$1.parts.forEach((part) => {
			if (part.isLineBreak) {
				lines.push([]);
				return;
			}
			const resolvedText = this.resolveShapeTextPartText(part, context);
			if (!resolvedText) return;
			lines[lines.length - 1].push({
				text: resolvedText,
				formatting: part.formatting
			});
		});
		const nonEmptyLines = lines.filter((line) => line.length > 0);
		return nonEmptyLines.length > 0 ? nonEmptyLines : [[]];
	}
	resolveShapeTextPartText(part, context) {
		if (part.fieldType === "PAGE") {
			if (part.pageNumberFormat || context?.pageNumberChapterText) return formatSectionPageNumberText({
				displayNumber: context?.displayPageNumber ?? context?.pageNumber ?? 1,
				pageFormat: part.pageNumberFormat ?? context?.pageNumberFormat ?? "decimal",
				chapterNumberText: context?.pageNumberChapterText,
				chapterSeparator: context?.pageNumberChapterSeparator
			});
			return context?.pageNumberText ?? String(context?.pageNumber ?? 1);
		}
		if (part.fieldType === "NUMPAGES") {
			const totalPages = context?.totalPages ?? 1;
			return part.pageNumberFormat ? formatPageNumber(totalPages, part.pageNumberFormat) : String(totalPages);
		}
		if (part.fieldType === "SECTIONPAGES") {
			if (context?.sectionPageCount == null) return part.text ?? "1";
			const sectionPageCount = context.sectionPageCount;
			return part.pageNumberFormat ? formatPageNumber(sectionPageCount, part.pageNumberFormat) : String(sectionPageCount);
		}
		return part.text;
	}
	getWordArtTextAnchor(textAlign) {
		if (textAlign === "right" || textAlign === "r") return "end";
		if (textAlign === "center") return "middle";
		return "start";
	}
	getWordArtTextX(textAlign, leftInset, availableWidth) {
		if (textAlign === "right" || textAlign === "r") return leftInset + availableWidth;
		if (textAlign === "center") return leftInset + availableWidth / 2;
		return leftInset;
	}
	applyWordArtTextFormatting(element, formatting) {
		if (!formatting) return;
		if (formatting.bold) element.setAttribute("font-weight", "bold");
		if (formatting.italic) element.setAttribute("font-style", "italic");
		if (formatting.fontFamily) element.setAttribute("font-family", formatting.fontFamily);
		if (formatting.color) {
			const validatedColor = validateHexColor(formatting.color);
			if (validatedColor) element.setAttribute("fill", validatedColor);
		}
		if (formatting.letterSpacing != null) element.setAttribute("letter-spacing", String(formatting.letterSpacing));
	}
	createFallbackTextElement(textContent$1, textAlign, textVerticalAlign, textInsets, groupScaleX = 1, groupScaleY = 1, context) {
		const textDiv = this.doc.createElement("div");
		textDiv.style.position = "absolute";
		textDiv.style.top = "0";
		textDiv.style.left = "0";
		textDiv.style.width = "100%";
		textDiv.style.height = "100%";
		textDiv.style.display = "flex";
		textDiv.style.flexDirection = "column";
		const verticalAlign = textVerticalAlign ?? "top";
		if (verticalAlign === "top") textDiv.style.justifyContent = "flex-start";
		else if (verticalAlign === "bottom") textDiv.style.justifyContent = "flex-end";
		else textDiv.style.justifyContent = "center";
		if (textInsets) textDiv.style.padding = `${textInsets.top}px ${textInsets.right}px ${textInsets.bottom}px ${textInsets.left}px`;
		else textDiv.style.padding = "10px";
		textDiv.style.boxSizing = "border-box";
		textDiv.style.wordWrap = "break-word";
		textDiv.style.overflowWrap = "break-word";
		textDiv.style.overflow = "hidden";
		textDiv.style.minWidth = "0";
		textDiv.style.fontSize = "12px";
		textDiv.style.lineHeight = "1.2";
		if (textAlign === "center") textDiv.style.textAlign = "center";
		else if (textAlign === "right" || textAlign === "r") textDiv.style.textAlign = "right";
		else textDiv.style.textAlign = "left";
		let currentParagraph = this.doc.createElement("div");
		currentParagraph.style.width = "100%";
		currentParagraph.style.minWidth = "0";
		currentParagraph.style.whiteSpace = "normal";
		textContent$1.parts.forEach((part) => {
			if (part.isLineBreak) {
				textDiv.appendChild(currentParagraph);
				currentParagraph = this.doc.createElement("div");
				currentParagraph.style.width = "100%";
				currentParagraph.style.minWidth = "0";
				currentParagraph.style.whiteSpace = "normal";
				if (part.isEmptyParagraph) currentParagraph.style.minHeight = "1em";
			} else if (part.kind === "image" && part.src) currentParagraph.appendChild(createShapeTextImageElement(this.doc, part));
			else {
				const span = this.doc.createElement("span");
				span.textContent = this.resolveShapeTextPartText(part, context);
				if (part.formatting) {
					if (part.formatting.bold) span.style.fontWeight = "bold";
					if (part.formatting.italic) span.style.fontStyle = "italic";
					if (part.formatting.fontFamily) span.style.fontFamily = part.formatting.fontFamily;
					if (part.formatting.color) {
						const validatedColor = validateHexColor(part.formatting.color);
						if (validatedColor) span.style.color = validatedColor;
					}
					if (part.formatting.fontSize) span.style.fontSize = `${part.formatting.fontSize}px`;
					if (part.formatting.letterSpacing != null) span.style.letterSpacing = `${part.formatting.letterSpacing}px`;
				}
				currentParagraph.appendChild(span);
			}
		});
		textDiv.appendChild(currentParagraph);
		return textDiv;
	}
	tryCreatePresetSvg(block, widthOverride, heightOverride) {
		try {
			let fillColor;
			if (block.fillColor === null) fillColor = "none";
			else if (typeof block.fillColor === "string") fillColor = block.fillColor;
			const strokeColor = block.strokeColor === null ? "none" : typeof block.strokeColor === "string" ? block.strokeColor : void 0;
			if (block.shapeKind === "line" || block.shapeKind === "straightConnector1") {
				const width = widthOverride ?? block.geometry.width;
				const height = heightOverride ?? block.geometry.height;
				return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
  <line x1="0" y1="0" x2="${width}" y2="${height}" stroke="${strokeColor ?? "#000000"}" stroke-width="${block.strokeWidth ?? 1}" />
</svg>`;
			}
			return k0({
				preset: block.shapeKind ?? "",
				styleOverrides: () => ({
					fill: fillColor,
					stroke: strokeColor,
					strokeWidth: block.strokeWidth ?? void 0
				}),
				width: widthOverride ?? block.geometry.width,
				height: heightOverride ?? block.geometry.height
			});
		} catch (error) {
			console.warn(`[DomPainter] Unable to render preset shape "${block.shapeKind}":`, error);
			return null;
		}
	}
	tryCreateCustomGeometrySvg(block, width, height) {
		const custGeom = block.customGeometry;
		if (!custGeom?.paths?.length) return null;
		let fillColor;
		if (block.fillColor === null) fillColor = "none";
		else if (typeof block.fillColor === "string") fillColor = block.fillColor;
		else fillColor = "#000000";
		const strokeColor = block.strokeColor === null ? "none" : typeof block.strokeColor === "string" ? block.strokeColor : "none";
		const strokeWidth = block.strokeColor === null ? 0 : block.strokeWidth ?? 0;
		const firstPath = custGeom.paths[0];
		const viewW = firstPath.w || width;
		const viewH = firstPath.h || height;
		if (viewW === 0 || viewH === 0) return null;
		const edgeStroke = fillColor !== "none" && strokeColor === "none" ? ` stroke="${fillColor}" stroke-width="0.5" vector-effect="non-scaling-stroke"` : "";
		return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${viewW} ${viewH}" preserveAspectRatio="none">
  ${custGeom.paths.map((p$1) => {
			const pathW = p$1.w || viewW;
			const pathH = p$1.h || viewH;
			const needsTransform = pathW !== viewW || pathH !== viewH;
			const scaleX = viewW / pathW;
			const scaleY = viewH / pathH;
			const transform = needsTransform ? ` transform="scale(${scaleX}, ${scaleY})"` : "";
			const strokeAttr = strokeColor !== "none" ? ` stroke="${strokeColor}" stroke-width="${strokeWidth}"` : edgeStroke;
			return `<path d="${p$1.d}" fill="${fillColor}" fill-rule="evenodd"${strokeAttr}${transform} />`;
		}).join("\n  ")}
</svg>`;
	}
	parseSafeSvg(markup) {
		const DOMParserCtor = this.doc?.defaultView?.DOMParser ?? (typeof DOMParser !== "undefined" ? DOMParser : null);
		if (!DOMParserCtor) return null;
		const parsed = new DOMParserCtor().parseFromString(markup, "image/svg+xml");
		if (!parsed || parsed.getElementsByTagName("parsererror").length > 0) return null;
		const svgElement = parsed.documentElement;
		if (!svgElement) return null;
		this.stripUnsafeSvgContent(svgElement);
		const imported = this.doc?.importNode(svgElement, true);
		return imported ? imported : null;
	}
	stripUnsafeSvgContent(element) {
		element.querySelectorAll("script").forEach((script) => script.remove());
		const sanitize = (node) => {
			Array.from(node.attributes).forEach((attr) => {
				if (attr.name.toLowerCase().startsWith("on")) node.removeAttribute(attr.name);
			});
			Array.from(node.children).forEach((child) => {
				sanitize(child);
			});
		};
		sanitize(element);
	}
	getEffectExtentMetrics(block, geometry) {
		const left$1 = block.effectExtent?.left ?? 0;
		const top$1 = block.effectExtent?.top ?? 0;
		const right$1 = block.effectExtent?.right ?? 0;
		const bottom$1 = block.effectExtent?.bottom ?? 0;
		const sourceGeometry = geometry ?? block.geometry;
		const width = sourceGeometry.width ?? 0;
		const height = sourceGeometry.height ?? 0;
		return {
			offsetX: left$1,
			offsetY: top$1,
			innerWidth: Math.max(0, width - left$1 - right$1),
			innerHeight: Math.max(0, height - top$1 - bottom$1)
		};
	}
	applyLineEnds(svgElement, block) {
		const lineEnds = block.lineEnds;
		if (!lineEnds) return;
		if (block.strokeColor === null) return;
		const strokeColor = typeof block.strokeColor === "string" ? block.strokeColor : "#000000";
		const strokeWidth = block.strokeWidth ?? 1;
		if (strokeWidth <= 0) return;
		const target = this.findLineEndTarget(svgElement);
		if (!target) return;
		const defs = this.ensureSvgDefs(svgElement);
		const baseId = this.sanitizeSvgId(`sd-line-${block.id}`);
		if (lineEnds.tail) {
			const id = `${baseId}-tail`;
			this.appendLineEndMarker(defs, id, lineEnds.tail, strokeColor, strokeWidth, true, block.effectExtent ?? void 0);
			target.setAttribute("marker-start", `url(#${id})`);
		}
		if (lineEnds.head) {
			const id = `${baseId}-head`;
			this.appendLineEndMarker(defs, id, lineEnds.head, strokeColor, strokeWidth, false, block.effectExtent ?? void 0);
			target.setAttribute("marker-end", `url(#${id})`);
		}
	}
	findLineEndTarget(svgElement) {
		const line = svgElement.querySelector("line");
		if (line) return line;
		const path = svgElement.querySelector("path");
		if (path) return path;
		return svgElement.querySelector("polyline");
	}
	ensureSvgDefs(svgElement) {
		const existing = svgElement.querySelector("defs");
		if (existing) return existing;
		const defs = this.doc.createElementNS("http://www.w3.org/2000/svg", "defs");
		svgElement.insertBefore(defs, svgElement.firstChild);
		return defs;
	}
	appendLineEndMarker(defs, id, lineEnd, strokeColor, _strokeWidth, isStart, effectExtent) {
		if (defs.querySelector(`#${id}`)) return;
		const marker = this.doc.createElementNS("http://www.w3.org/2000/svg", "marker");
		marker.setAttribute("id", id);
		marker.setAttribute("viewBox", "0 0 10 10");
		marker.setAttribute("orient", "auto");
		const sizeScale = (value) => {
			if (value === "sm") return .75;
			if (value === "lg") return 1.25;
			return 1;
		};
		const effectMax = effectExtent ? Math.max(effectExtent.left ?? 0, effectExtent.right ?? 0, effectExtent.top ?? 0, effectExtent.bottom ?? 0) : 0;
		const useEffectExtent = Number.isFinite(effectMax) && effectMax > 0;
		const markerWidth = useEffectExtent ? effectMax * 2 : 4 * sizeScale(lineEnd.length);
		const markerHeight = useEffectExtent ? effectMax * 2 : 4 * sizeScale(lineEnd.width);
		marker.setAttribute("markerUnits", useEffectExtent ? "userSpaceOnUse" : "strokeWidth");
		marker.setAttribute("markerWidth", markerWidth.toString());
		marker.setAttribute("markerHeight", markerHeight.toString());
		marker.setAttribute("refX", isStart ? "0" : "10");
		marker.setAttribute("refY", "5");
		const shape = this.createLineEndShape(lineEnd.type ?? "triangle", strokeColor, isStart);
		marker.appendChild(shape);
		defs.appendChild(marker);
	}
	createLineEndShape(type, strokeColor, isStart) {
		const normalized = type.toLowerCase();
		if (normalized === "diamond") {
			const path$1 = this.doc.createElementNS("http://www.w3.org/2000/svg", "path");
			path$1.setAttribute("d", "M 0 5 L 5 0 L 10 5 L 5 10 Z");
			path$1.setAttribute("fill", strokeColor);
			path$1.setAttribute("stroke", "none");
			return path$1;
		}
		if (normalized === "oval") {
			const circle = this.doc.createElementNS("http://www.w3.org/2000/svg", "circle");
			circle.setAttribute("cx", "5");
			circle.setAttribute("cy", "5");
			circle.setAttribute("r", "5");
			circle.setAttribute("fill", strokeColor);
			circle.setAttribute("stroke", "none");
			return circle;
		}
		const path = this.doc.createElementNS("http://www.w3.org/2000/svg", "path");
		const d = isStart ? "M 10 0 L 0 5 L 10 10 Z" : "M 0 0 L 10 5 L 0 10 Z";
		path.setAttribute("d", d);
		path.setAttribute("fill", strokeColor);
		path.setAttribute("stroke", "none");
		return path;
	}
	sanitizeSvgId(value) {
		return value.replace(/[^a-zA-Z0-9_-]/g, "");
	}
	applyVectorShapeTransforms(target, geometry) {
		const transforms = [];
		if (geometry.rotation) transforms.push(`rotate(${geometry.rotation}deg)`);
		if (geometry.flipH) transforms.push("scaleX(-1)");
		if (geometry.flipV) transforms.push("scaleY(-1)");
		if (transforms.length > 0) {
			target.style.transformOrigin = "center";
			target.style.transform = transforms.join(" ");
		} else {
			target.style.removeProperty("transform");
			target.style.removeProperty("transform-origin");
		}
	}
	createShapeGroupElement(block, context) {
		const groupEl = this.doc.createElement("div");
		groupEl.classList.add("superdoc-shape-group");
		groupEl.style.position = "relative";
		groupEl.style.width = "100%";
		groupEl.style.height = "100%";
		const groupTransform = block.groupTransform;
		let contentContainer = groupEl;
		const visibleWidth = groupTransform?.width ?? block.geometry.width ?? 0;
		const visibleHeight = groupTransform?.height ?? block.geometry.height ?? 0;
		if (groupTransform) {
			const inner = this.doc.createElement("div");
			inner.style.position = "absolute";
			inner.style.left = "0";
			inner.style.top = "0";
			inner.style.width = `${Math.max(1, visibleWidth)}px`;
			inner.style.height = `${Math.max(1, visibleHeight)}px`;
			groupEl.appendChild(inner);
			contentContainer = inner;
		}
		block.shapes.forEach((child) => {
			const childContent = this.createGroupChildContent(child, 1, 1, context);
			if (!childContent) return;
			const attrs = child.attrs ?? {};
			const wrapper = this.doc.createElement("div");
			wrapper.classList.add("superdoc-shape-group__child");
			wrapper.style.position = "absolute";
			wrapper.style.left = `${Number(attrs.x ?? 0)}px`;
			wrapper.style.top = `${Number(attrs.y ?? 0)}px`;
			const childW = typeof attrs.width === "number" ? attrs.width : block.geometry.width;
			const childH = typeof attrs.height === "number" ? attrs.height : block.geometry.height;
			wrapper.style.width = `${Math.max(1, childW)}px`;
			wrapper.style.height = `${Math.max(1, childH)}px`;
			wrapper.style.transformOrigin = "center";
			const transforms = [];
			if (attrs.rotation) transforms.push(`rotate(${attrs.rotation}deg)`);
			if (attrs.flipH) transforms.push("scaleX(-1)");
			if (attrs.flipV) transforms.push("scaleY(-1)");
			if (transforms.length > 0) wrapper.style.transform = transforms.join(" ");
			childContent.style.width = "100%";
			childContent.style.height = "100%";
			wrapper.appendChild(childContent);
			contentContainer.appendChild(wrapper);
		});
		return groupEl;
	}
	createGroupChildContent(child, groupScaleX = 1, groupScaleY = 1, context) {
		if (child.shapeType === "vectorShape" && "fillColor" in child.attrs) {
			const attrs = child.attrs;
			const childGeometry = {
				width: attrs.width ?? 0,
				height: attrs.height ?? 0,
				rotation: attrs.rotation ?? 0,
				flipH: attrs.flipH ?? false,
				flipV: attrs.flipV ?? false
			};
			const vectorChild = {
				drawingKind: "vectorShape",
				kind: "drawing",
				id: `${attrs.shapeId ?? child.shapeType}`,
				geometry: childGeometry,
				padding: void 0,
				margin: void 0,
				anchor: void 0,
				wrap: void 0,
				attrs: child.attrs,
				drawingContentId: void 0,
				drawingContent: void 0,
				shapeKind: attrs.kind,
				customGeometry: attrs.customGeometry,
				fillColor: attrs.fillColor,
				strokeColor: attrs.strokeColor,
				strokeWidth: attrs.strokeWidth,
				lineEnds: attrs.lineEnds,
				textContent: attrs.textContent,
				textAlign: attrs.textAlign,
				textVerticalAlign: attrs.textVerticalAlign,
				textInsets: attrs.textInsets
			};
			return this.createVectorShapeElement(vectorChild, childGeometry, false, groupScaleX, groupScaleY, context);
		}
		if (child.shapeType === "image" && "src" in child.attrs) return createShapeGroupImageElement(this.doc, child);
		return this.createDrawingPlaceholder();
	}
	createDrawingPlaceholder() {
		const placeholder = this.doc.createElement("div");
		placeholder.classList.add("superdoc-drawing-placeholder");
		placeholder.style.width = "100%";
		placeholder.style.height = "100%";
		placeholder.style.background = "repeating-linear-gradient(45deg, rgba(15,23,42,0.1), rgba(15,23,42,0.1) 6px, rgba(15,23,42,0.2) 6px, rgba(15,23,42,0.2) 12px)";
		placeholder.style.border = "1px dashed rgba(15, 23, 42, 0.3)";
		return placeholder;
	}
	createChartElement(block) {
		return createChartElement(this.doc, block.chartData, block.geometry);
	}
	resolveTableRenderData(fragment, resolvedItem) {
		if (!resolvedItem) throw new Error(`DomPainter: missing resolved table item for fragment ${fragment.blockId}`);
		return {
			block: resolvedItem.block,
			measure: resolvedItem.measure,
			cellSpacingPx: resolvedItem.cellSpacingPx,
			effectiveColumnWidths: resolvedItem.effectiveColumnWidths
		};
	}
	renderTableFragment(fragment, context, sdtBoundary, resolvedItem) {
		try {
			if (!this.doc) throw new Error("DomPainter: document is not available");
			const applyFragmentFrameWithSection = (el$1, frag) => {
				this.applyFragmentFrame(el$1, frag, context.section, context.story);
			};
			const tableCellExpandedRunsCache = /* @__PURE__ */ new WeakMap();
			const renderLineForTableCell = (block, line, ctx$1, lineIndex, isLastLine, resolvedListTextStartPx) => {
				const paragraphEndsWithLineBreak = (block.runs.length > 0 ? block.runs[block.runs.length - 1] : null)?.kind === "lineBreak";
				const shouldSkipJustify = isLastLine && !paragraphEndsWithLineBreak;
				let expandedRuns = tableCellExpandedRunsCache.get(block);
				if (!expandedRuns) {
					expandedRuns = expandRunsForInlineNewlines(block.runs);
					tableCellExpandedRunsCache.set(block, expandedRuns);
				}
				return this.renderLine(block, line, ctx$1, void 0, lineIndex, shouldSkipJustify, expandedRuns, resolvedListTextStartPx);
			};
			const renderDrawingContentForTableCell = (block) => {
				if (block.drawingKind === "image") return createDrawingImageElement(this.doc, block, this.buildImageHyperlinkAnchor.bind(this));
				if (block.drawingKind === "shapeGroup") return this.createShapeGroupElement(block, context);
				if (block.drawingKind === "vectorShape" || block.drawingKind === "textboxShape") return this.createVectorShapeElement(block, block.geometry, false, 1, 1, context);
				if (block.drawingKind === "chart") return this.createChartElement(block);
				return this.createDrawingPlaceholder();
			};
			const tableRenderData = this.resolveTableRenderData(fragment, resolvedItem);
			const el = renderTableFragment({
				doc: this.doc,
				fragment,
				context,
				block: tableRenderData.block,
				measure: tableRenderData.measure,
				cellSpacingPx: tableRenderData.cellSpacingPx,
				effectiveColumnWidths: tableRenderData.effectiveColumnWidths,
				chrome: this.contentControlsChrome,
				sdtBoundary,
				renderLine: renderLineForTableCell,
				captureLineSnapshot: (lineEl, lineContext, options) => {
					this.capturePaintSnapshotLine(lineEl, lineContext, {
						inTableFragment: true,
						inTableParagraph: options?.inTableParagraph ?? false,
						wrapperEl: options?.wrapperEl
					});
				},
				renderDrawingContent: renderDrawingContentForTableCell,
				applyFragmentFrame: applyFragmentFrameWithSection,
				applySdtDataset,
				applyContainerSdtDataset,
				applyStyles,
				resolvePhysical: this.options.resolvePhysical
			});
			if (resolvedItem) {
				this.applyResolvedFragmentFrame(el, resolvedItem, fragment, context.section, context.story);
				if (sdtBoundary?.widthOverride != null) el.style.width = `${sdtBoundary.widthOverride}px`;
			}
			return el;
		} catch (error) {
			console.error("[DomPainter] Table fragment rendering failed:", {
				fragment,
				error
			});
			return this.createErrorPlaceholder(fragment.blockId, error);
		}
	}
	renderLine(block, line, context, availableWidthOverride, lineIndex, skipJustify, preExpandedRuns, resolvedListTextStartPx, indentOffsetOverride, paragraphMarkLeftOffsetOverride) {
		if (!this.doc) throw new Error("DomPainter: document is not available");
		return renderLine({
			block,
			line,
			context,
			availableWidthOverride,
			lineIndex,
			skipJustify,
			preExpandedRuns,
			resolvedListTextStartPx,
			indentOffsetOverride,
			paragraphMarkLeftOffsetOverride,
			runContext: this.createRunRenderContext()
		});
	}
	createRunRenderContext() {
		if (!this.doc) throw new Error("DomPainter: document is not available");
		const runContext = {
			doc: this.doc,
			layoutEpoch: this.layoutEpoch,
			showFormattingMarks: this.showFormattingMarks,
			contentControlsChrome: this.contentControlsChrome,
			resolvePhysical: this.options.resolvePhysical,
			pendingTooltips: this.pendingTooltips,
			getNextLinkId: () => `superdoc-link-${++this.linkIdCounter}`,
			applySdtDataset,
			buildImageHyperlinkAnchor: this.buildImageHyperlinkAnchor.bind(this),
			resolveTrackedChangesConfig,
			applyTrackedChangeDecorations,
			resolveRunSdtId,
			createInlineSdtWrapper: (sdt) => createInlineSdtWrapper(sdt, runContext),
			syncInlineSdtWrapperTypography,
			expandSdtWrapperPmRange
		};
		return runContext;
	}
	defaultFragmentRenderContext() {
		return {
			pageNumber: 1,
			totalPages: 1,
			section: "body"
		};
	}
	updateFragmentElement(el, fragment, section, resolvedItem) {
		const fragmentItem = resolvedItem?.kind === "fragment" ? resolvedItem : void 0;
		const story = resolveSectionStory(section);
		if (fragmentItem) this.applyResolvedFragmentFrame(el, fragmentItem, fragment, section, story);
		else {
			this.applyFragmentFrame(el, fragment, section, story);
			if (fragment.kind === "image" || fragment.kind === "drawing") {
				el.style.height = `${fragment.height}px`;
				this.applyFragmentWrapperZIndex(el, fragment);
			}
		}
	}
	applyFragmentFrame(el, fragment, section, story) {
		el.style.left = `${fragment.x}px`;
		el.style.top = `${fragment.y}px`;
		el.style.width = `${fragment.width}px`;
		el.dataset.blockId = fragment.blockId;
		el.dataset.layoutEpoch = String(this.layoutEpoch);
		applySourceAnchorDataset(el, fragment.sourceAnchor);
		applyLayoutIdentityDataset(el, resolveOrBuildFragmentIdentity(fragment, story ?? resolveSectionStory(section)));
		if (typeof fragment.blockId === "string" && fragment.blockId.startsWith("footnote-")) el.setAttribute("contenteditable", "false");
		if (fragment.kind === "para") applyParagraphFragmentPmAttributes(el, fragment, section);
	}
	applyFragmentPmAttributes(el, fragment, section, resolvedItem) {
		if (typeof fragment.blockId === "string" && fragment.blockId.startsWith("footnote-")) el.setAttribute("contenteditable", "false");
		if (fragment.kind === "para") applyParagraphFragmentPmAttributes(el, fragment, section, resolvedItem);
	}
	isAnchoredMediaFragment(fragment) {
		return (fragment.kind === "image" || fragment.kind === "drawing") && fragment.isAnchored === true;
	}
	shouldRenderBehindPageContent(fragment, section, resolvedItem) {
		if (fragment.behindDoc === true || fragment.behindDoc == null && "zIndex" in fragment && fragment.zIndex === 0) return true;
		if (section !== "header") return false;
		if (fragment.kind === "drawing") return this.isHeaderWordArtWatermark(resolvedItem?.block);
		return this.isVmlTextWatermarkImage(resolvedItem?.block);
	}
	isHeaderWordArtWatermark(block) {
		if (!block || block.kind !== "drawing" || block.drawingKind !== "vectorShape") return false;
		const attrs = block.attrs ?? {};
		const hasTextContent = Array.isArray(block.textContent?.parts) && block.textContent.parts.length > 0;
		return attrs.isWordArt === true && attrs.isTextBox === true && hasTextContent && block.anchor?.isAnchored === true && block.anchor.hRelativeFrom === "page" && block.anchor.alignH === "center" && block.anchor.vRelativeFrom === "page" && block.anchor.alignV === "center" && block.wrap?.type === "None";
	}
	isVmlTextWatermarkImage(block) {
		return block?.kind === "image" && block.attrs?.vmlTextWatermark === true;
	}
	applyHeaderFooterTextWatermarkPreviewOpacity(el, isActiveHeaderFooter) {
		if (el.dataset.vmlTextWatermark !== "true") return;
		el.style.opacity = isActiveHeaderFooter ? ACTIVE_HEADER_FOOTER_WATERMARK_PREVIEW_OPACITY : INACTIVE_HEADER_FOOTER_WATERMARK_PREVIEW_OPACITY;
	}
	resolveFragmentWrapperZIndex(fragment, resolvedZIndex) {
		if (!this.isAnchoredMediaFragment(fragment)) return "";
		const zIndex = resolvedZIndex;
		return zIndex != null ? String(zIndex) : "";
	}
	applyFragmentWrapperZIndex(el, fragment, resolvedZIndex) {
		el.style.zIndex = this.resolveFragmentWrapperZIndex(fragment, resolvedZIndex);
	}
	applyResolvedFragmentFrame(el, item, fragment, section, story) {
		el.style.left = `${item.x}px`;
		el.style.top = `${item.y}px`;
		el.style.width = `${item.width}px`;
		el.dataset.blockId = item.blockId;
		el.dataset.layoutEpoch = String(this.layoutEpoch);
		applySourceAnchorDataset(el, item.sourceAnchor);
		applyLayoutIdentityDataset(el, resolveOrBuildFragmentIdentity(fragment, story ?? resolveSectionStory(section), item.layoutSourceIdentity ? {
			...item.layoutSourceIdentity,
			sourceAnchor: item.sourceAnchor ?? item.layoutSourceIdentity.sourceAnchor
		} : void 0));
		this.applyFragmentWrapperZIndex(el, fragment, item.zIndex);
		if (item.fragmentKind === "image" || item.fragmentKind === "drawing" || item.fragmentKind === "table") el.style.height = `${item.height}px`;
		this.applyFragmentPmAttributes(el, fragment, section, item);
	}
	estimateFragmentHeight(fragment, resolvedItem) {
		if (resolvedItem && "height" in resolvedItem && typeof resolvedItem.height === "number") return resolvedItem.height;
		if (fragment.kind === "table" || fragment.kind === "image" || fragment.kind === "drawing") return fragment.height;
		return 0;
	}
};
var fragmentKey = (fragment) => {
	switch (fragment.kind) {
		case "para": return `para:${fragment.blockId}:${fragment.fromLine}:${fragment.toLine}`;
		case "list-item": throw new Error(`DomPainter: unsupported fragment kind ${fragment.kind}`);
		case "image": return `image:${fragment.blockId}:${fragment.x}:${fragment.y}`;
		case "drawing": return `drawing:${fragment.blockId}:${fragment.x}:${fragment.y}`;
		case "table": {
			const partialKey = fragment.partialRow ? `:${fragment.partialRow.fromLineByCell.join(",")}-${fragment.partialRow.toLineByCell.join(",")}` : "";
			return `table:${fragment.blockId}:${fragment.fromRow}:${fragment.toRow}${partialKey}`;
		}
		default: return fragment;
	}
};
var hasFragmentGeometryChanged = (previous, next) => previous.x !== next.x || previous.y !== next.y || previous.width !== next.width || "height" in previous && "height" in next && typeof previous.height === "number" && typeof next.height === "number" && previous.height !== next.height;
var isNonBodyStoryBlockId = (blockId) => typeof blockId === "string" && (blockId.startsWith("footnote-") || blockId.startsWith("endnote-") || blockId.startsWith("__sd_semantic_footnote-") || blockId.startsWith("__sd_semantic_endnote-"));
const createDomPainter = (options) => {
	const painter = new DomPainter(options);
	return {
		paint(input, mount, mapping) {
			painter.paint(input, mount, mapping);
		},
		setProviders(header, footer) {
			painter.setProviders(header, footer);
		},
		setVirtualizationPins(pageIndices) {
			painter.setVirtualizationPins(pageIndices);
		},
		getMountedPageIndices() {
			return painter.getMountedPageIndices();
		},
		onScroll() {
			painter.onScroll();
		},
		setZoom(zoom) {
			painter.setZoom(zoom);
		},
		setScrollContainer(el) {
			painter.setScrollContainer(el);
		},
		setShowFormattingMarks(showFormattingMarks) {
			painter.setShowFormattingMarks(showFormattingMarks);
		}
	};
};
function appendToArrayMap(map$1, key, value) {
	const existing = map$1.get(key);
	if (existing) {
		existing.push(value);
		return;
	}
	map$1.set(key, [value]);
}
function isMountedElement(element) {
	return element instanceof HTMLElement && element.isConnected;
}
function isInlineImageWrapperElement(element) {
	return element.classList.contains(DOM_CLASS_NAMES.INLINE_IMAGE_CLIP_WRAPPER);
}
function shouldReplaceInlineImageEntity(existing, candidate) {
	if (!existing) return true;
	const existingIsWrapper = isInlineImageWrapperElement(existing.element);
	const candidateIsWrapper = isInlineImageWrapperElement(candidate.element);
	if (existingIsWrapper && !candidateIsWrapper) return false;
	return true;
}
var PresentationPaintIndex = class {
	#snapshot = null;
	#annotationsByPmStart = /* @__PURE__ */ new Map();
	#annotationsByType = /* @__PURE__ */ new Map();
	#structuredContentBlocksById = /* @__PURE__ */ new Map();
	#structuredContentInlinesById = /* @__PURE__ */ new Map();
	#inlineImagesByPmStart = /* @__PURE__ */ new Map();
	#imageFragmentsByPmStart = /* @__PURE__ */ new Map();
	reset() {
		this.#snapshot = null;
		this.#annotationsByPmStart.clear();
		this.#annotationsByType.clear();
		this.#structuredContentBlocksById.clear();
		this.#structuredContentInlinesById.clear();
		this.#inlineImagesByPmStart.clear();
		this.#imageFragmentsByPmStart.clear();
	}
	update(snapshot) {
		this.reset();
		this.#snapshot = snapshot;
		if (!snapshot?.entities) return;
		for (const annotation of snapshot.entities.annotations) {
			if (!isMountedElement(annotation.element)) continue;
			if (annotation.pmStart != null) this.#annotationsByPmStart.set(annotation.pmStart, annotation);
			if (annotation.type) appendToArrayMap(this.#annotationsByType, annotation.type, annotation);
		}
		for (const block of snapshot.entities.structuredContentBlocks) {
			if (!isMountedElement(block.element)) continue;
			appendToArrayMap(this.#structuredContentBlocksById, block.sdtId, block);
		}
		for (const inline of snapshot.entities.structuredContentInlines) {
			if (!isMountedElement(inline.element)) continue;
			appendToArrayMap(this.#structuredContentInlinesById, inline.sdtId, inline);
		}
		for (const image of snapshot.entities.images) {
			if (!isMountedElement(image.element) || image.pmStart == null) continue;
			if (image.kind === "inline") {
				if (shouldReplaceInlineImageEntity(this.#inlineImagesByPmStart.get(image.pmStart), image)) this.#inlineImagesByPmStart.set(image.pmStart, image);
				continue;
			}
			this.#imageFragmentsByPmStart.set(image.pmStart, image);
		}
	}
	get snapshot() {
		return this.#snapshot;
	}
	getAnnotationElementByPmStart(pmStart) {
		return this.#annotationsByPmStart.get(pmStart)?.element ?? null;
	}
	getAnnotationEntitiesByType(type) {
		return [...this.#annotationsByType.get(type) ?? []];
	}
	getStructuredContentBlockElementsById(id) {
		return (this.#structuredContentBlocksById.get(id) ?? []).map((entity) => entity.element);
	}
	getStructuredContentInlineElementsById(id) {
		return (this.#structuredContentInlinesById.get(id) ?? []).map((entity) => entity.element);
	}
	getInlineImageElementByPmStart(pmStart) {
		return this.#inlineImagesByPmStart.get(pmStart)?.element ?? null;
	}
	getImageFragmentElementByPmStart(pmStart) {
		return this.#imageFragmentsByPmStart.get(pmStart)?.element ?? null;
	}
};
function normalizePinnedPageIndices(pageIndices) {
	return Array.from(new Set((pageIndices ?? []).filter((pageIndex) => Number.isInteger(pageIndex)))).sort((a, b$1) => a - b$1);
}
function areNumberListsEqual(left$1, right$1) {
	if (left$1.length !== right$1.length) return false;
	for (let index = 0; index < left$1.length; index += 1) if (left$1[index] !== right$1[index]) return false;
	return true;
}
var PresentationPainterAdapter = class {
	#painter = null;
	#lastPaintSnapshot = null;
	#paintIndex = new PresentationPaintIndex();
	#headerProvider;
	#footerProvider;
	#zoom = 1;
	#scrollContainer = null;
	#virtualizationPins = [];
	#showFormattingMarks = false;
	get hasPainter() {
		return this.#painter !== null;
	}
	ensurePainter(options) {
		if (!this.#painter) {
			this.#showFormattingMarks = Boolean(options.showFormattingMarks ?? this.#showFormattingMarks);
			this.#painter = createDomPainter({
				...options,
				showFormattingMarks: this.#showFormattingMarks,
				onPaintSnapshot: (snapshot) => {
					this.#lastPaintSnapshot = snapshot;
					this.#paintIndex.update(snapshot);
				}
			});
			this.#applyPainterSurfaceState();
		}
	}
	reset() {
		this.#painter = null;
		this.#lastPaintSnapshot = null;
		this.#paintIndex.reset();
	}
	paint(input, mount, mapping) {
		this.#painter?.paint(input, mount, mapping);
	}
	setProviders(header, footer) {
		if (this.#headerProvider === header && this.#footerProvider === footer) return;
		this.#headerProvider = header;
		this.#footerProvider = footer;
		this.#applyProviders();
	}
	setShowFormattingMarks(showFormattingMarks) {
		const next = Boolean(showFormattingMarks);
		if (this.#showFormattingMarks === next) return;
		this.#showFormattingMarks = next;
		this.#applyShowFormattingMarks();
	}
	setZoom(zoom) {
		if (this.#zoom === zoom) return;
		this.#zoom = zoom;
		this.#applyZoom();
	}
	setScrollContainer(el) {
		if (this.#scrollContainer === el) return;
		this.#scrollContainer = el;
		this.#applyScrollContainer();
	}
	onScroll() {
		this.#painter?.onScroll();
	}
	setVirtualizationPins(pageIndices) {
		const normalizedPins = normalizePinnedPageIndices(pageIndices);
		if (areNumberListsEqual(this.#virtualizationPins, normalizedPins)) return;
		this.#virtualizationPins = normalizedPins;
		this.#applyVirtualizationPins();
	}
	getPaintSnapshot() {
		return this.#lastPaintSnapshot;
	}
	getMountedPageIndices() {
		const mountedPageIndices = this.#painter?.getMountedPageIndices();
		if (mountedPageIndices) return [...mountedPageIndices];
		return this.#lastPaintSnapshot?.pages.map((page) => page.index) ?? [];
	}
	getAnnotationElementByPmStart(pmStart) {
		return this.#paintIndex.getAnnotationElementByPmStart(pmStart);
	}
	getAnnotationEntitiesByType(type) {
		return this.#paintIndex.getAnnotationEntitiesByType(type);
	}
	getStructuredContentBlockElementsById(id) {
		return this.#paintIndex.getStructuredContentBlockElementsById(id);
	}
	getStructuredContentInlineElementsById(id) {
		return this.#paintIndex.getStructuredContentInlineElementsById(id);
	}
	getInlineImageElementByPmStart(pmStart) {
		return this.#paintIndex.getInlineImageElementByPmStart(pmStart);
	}
	getImageFragmentElementByPmStart(pmStart) {
		return this.#paintIndex.getImageFragmentElementByPmStart(pmStart);
	}
	#applyPainterSurfaceState() {
		this.#applyProviders();
		this.#applyZoom();
		this.#applyScrollContainer();
		this.#applyVirtualizationPins();
		this.#applyShowFormattingMarks();
	}
	#applyProviders() {
		this.#painter?.setProviders(this.#headerProvider, this.#footerProvider);
	}
	#applyZoom() {
		this.#painter?.setZoom(this.#zoom);
	}
	#applyScrollContainer() {
		this.#painter?.setScrollContainer(this.#scrollContainer);
	}
	#applyVirtualizationPins() {
		this.#painter?.setVirtualizationPins(this.#virtualizationPins);
	}
	#applyShowFormattingMarks() {
		this.#painter?.setShowFormattingMarks(this.#showFormattingMarks);
	}
};
function resolveMarkerTextWidth(markerTextWidthPx, marker) {
	const val = (v) => typeof v === "number" && Number.isFinite(v) && v >= 0 ? v : void 0;
	return val(markerTextWidthPx) ?? val(marker.glyphWidthPx) ?? val(marker.markerBoxWidthPx) ?? 0;
}
function resolverListMarkerGeometry(wordLayout, indentLeftPx, hangingIndentPx, firstLineIndentPx, markerTextWidthPx) {
	return resolveListMarkerGeometry(wordLayout, indentLeftPx, firstLineIndentPx, hangingIndentPx, (_markerText, marker) => resolveMarkerTextWidth(markerTextWidthPx, marker));
}
function resolverListTextStartPx(wordLayout, indentLeftPx, hangingIndentPx, firstLineIndentPx, markerTextWidthPx) {
	return resolveListTextStartPx(wordLayout, indentLeftPx, firstLineIndentPx, hangingIndentPx, (_markerText, marker) => resolveMarkerTextWidth(markerTextWidthPx, marker));
}
function resolveParagraphContent(fragment, block, measure) {
	const wordLayout = isMinimalWordLayout(block.attrs?.wordLayout) ? block.attrs.wordLayout : void 0;
	const paraIndent = block.attrs?.indent;
	const paraIndentLeft = paraIndent?.left ?? 0;
	const paraIndentRight = paraIndent?.right ?? 0;
	const { anchorIndentPx: paraMarkerAnchorIndent, firstLinePx: markerFirstLine, hangingPx: markerHanging } = resolveMarkerIndent(paraIndent, getParagraphInlineDirection(block.attrs) === "rtl");
	const firstLineOffset = block.attrs?.suppressFirstLineIndent === true ? 0 : (paraIndent?.firstLine ?? 0) - (paraIndent?.hanging ?? 0);
	const paragraphEndsWithLineBreak = (block.runs.length > 0 ? block.runs[block.runs.length - 1] : null)?.kind === "lineBreak";
	const lines = fragment.lines ?? measure.lines.slice(fragment.fromLine, fragment.toLine);
	const hasMarker = !fragment.continuesFromPrev && fragment.markerWidth && wordLayout?.marker;
	const listFirstLineTextStartPx = hasMarker ? resolverListTextStartPx(wordLayout, paraMarkerAnchorIndent, markerHanging, markerFirstLine, fragment.markerTextWidth) : void 0;
	const listFirstLineMarkerGeometry = !fragment.continuesFromPrev && fragment.markerWidth && wordLayout?.marker?.justification === "left" && wordLayout.firstLineIndentMode !== true && typeof fragment.markerTextWidth === "number" && Number.isFinite(fragment.markerTextWidth) && fragment.markerTextWidth >= 0 ? resolverListMarkerGeometry(wordLayout, paraMarkerAnchorIndent, markerHanging, markerFirstLine, fragment.markerTextWidth) : void 0;
	let listTabWidth = 0;
	let markerStartPos = 0;
	if (hasMarker) {
		const markerTextWidth = fragment.markerTextWidth;
		const anchorPoint = paraMarkerAnchorIndent - markerHanging + markerFirstLine;
		const markerJustification = wordLayout.marker.justification ?? "left";
		let currentPos;
		if (markerJustification === "left") {
			markerStartPos = anchorPoint;
			currentPos = markerStartPos + markerTextWidth;
		} else if (markerJustification === "right") {
			markerStartPos = anchorPoint - markerTextWidth;
			currentPos = anchorPoint;
		} else {
			markerStartPos = anchorPoint - markerTextWidth / 2;
			currentPos = markerStartPos + markerTextWidth;
		}
		const suffix = wordLayout.marker.suffix ?? "tab";
		if (listFirstLineMarkerGeometry && (suffix === "tab" || suffix === "space")) listTabWidth = listFirstLineMarkerGeometry.suffixWidthPx;
		else if (suffix === "tab") listTabWidth = computeTabWidth(currentPos, markerJustification, wordLayout.tabsPx, markerHanging, markerFirstLine, paraMarkerAnchorIndent);
		else if (suffix === "space") listTabWidth = 4;
	}
	let marker;
	if (hasMarker) {
		const m$1 = wordLayout.marker;
		const justification = m$1.justification ?? "left";
		const firstLinePaddingLeftPx = paraMarkerAnchorIndent - markerHanging + markerFirstLine;
		let centerPaddingAdjustPx;
		if (justification === "center") centerPaddingAdjustPx = fragment.markerTextWidth / 2;
		marker = {
			text: m$1.markerText ?? "",
			justification,
			suffix: m$1.suffix ?? "tab",
			vanish: m$1.run?.vanish,
			markerStartPx: markerStartPos,
			suffixWidthPx: listTabWidth,
			firstLinePaddingLeftPx,
			centerPaddingAdjustPx,
			run: {
				fontFamily: m$1.run?.fontFamily ?? "",
				fontSize: m$1.run?.fontSize ?? 0,
				bold: m$1.run?.bold,
				italic: m$1.run?.italic,
				color: m$1.run?.color,
				letterSpacing: m$1.run?.letterSpacing,
				allCaps: m$1.run?.allCaps,
				smallCaps: m$1.run?.smallCaps
			},
			sourceAnchor: block.sourceAnchor
		};
	}
	let dropCap;
	const dropCapDescriptor = block.attrs?.dropCapDescriptor;
	const dropCapMeasure = measure.dropCap;
	if (dropCapDescriptor && dropCapMeasure && !fragment.continuesFromPrev) dropCap = {
		text: dropCapDescriptor.run.text,
		mode: dropCapDescriptor.mode,
		fontFamily: dropCapDescriptor.run.fontFamily,
		fontSize: dropCapDescriptor.run.fontSize,
		bold: dropCapDescriptor.run.bold,
		italic: dropCapDescriptor.run.italic,
		color: dropCapDescriptor.run.color,
		position: dropCapDescriptor.run.position,
		width: dropCapMeasure.width,
		height: dropCapMeasure.height
	};
	return {
		lines: lines.map((line, index) => {
			const hasExplicitSegmentPositioning$1 = line.segments?.some((segment) => segment.x !== void 0) === true;
			const hasListFirstLineMarker = index === 0 && !fragment.continuesFromPrev && fragment.markerWidth && wordLayout?.marker;
			const shouldUseResolvedListTextStart = hasListFirstLineMarker && hasExplicitSegmentPositioning$1 && listFirstLineTextStartPx != null;
			const positiveIndentReduction = Math.max(0, paraIndentLeft) + Math.max(0, paraIndentRight);
			const fallbackAvailableWidth = Math.max(0, fragment.width - positiveIndentReduction);
			let availableWidth = line.maxWidth != null ? Math.min(line.maxWidth, fallbackAvailableWidth) : fallbackAvailableWidth;
			if (shouldUseResolvedListTextStart) availableWidth = fragment.width - listFirstLineTextStartPx - Math.max(0, paraIndentRight);
			const skipJustify = index === lines.length - 1 && !fragment.continuesOnNext && !paragraphEndsWithLineBreak;
			const isListFirstLine = Boolean(hasListFirstLineMarker && fragment.markerTextWidth);
			const isFirstLine = index === 0 && !fragment.continuesFromPrev;
			let paddingLeftPx = 0;
			let paddingRightPx = 0;
			let textIndentPx = 0;
			if (!isListFirstLine) {
				if (hasExplicitSegmentPositioning$1) {
					if (isFirstLine && firstLineOffset !== 0) {
						const adjustedPadding = (paraIndentLeft < 0 ? 0 : paraIndentLeft) + firstLineOffset;
						if (adjustedPadding > 0) paddingLeftPx = adjustedPadding;
					}
				} else if (paraIndentLeft && paraIndentLeft > 0) paddingLeftPx = paraIndentLeft;
				else if (!isFirstLine && paraIndent?.hanging && paraIndent.hanging > 0 && !(paraIndentLeft != null && paraIndentLeft < 0)) paddingLeftPx = paraIndent.hanging;
			}
			if (paraIndentRight && paraIndentRight > 0) paddingRightPx = paraIndentRight;
			if (!fragment.continuesFromPrev && index === 0 && firstLineOffset && !isListFirstLine) {
				if (!hasExplicitSegmentPositioning$1) textIndentPx = firstLineOffset;
			}
			const availableWidthIndentOffset = isFirstLine && !isListFirstLine && line.hasExplicitTabStops !== true ? firstLineOffset : textIndentPx;
			availableWidth = adjustAvailableWidthForTextIndent(availableWidth, availableWidthIndentOffset, line.maxWidth);
			const indentLeft = paraIndent?.left ?? 0;
			const firstLine = paraIndent?.firstLine ?? 0;
			const hanging = paraIndent?.hanging ?? 0;
			const paragraphLineIndex = fragment.fromLine + index;
			const isFirstLineOfPara = paragraphLineIndex === 0;
			const firstLineOffsetForCumX = isFirstLineOfPara ? firstLine - hanging : 0;
			const isListParagraph$1 = Boolean(wordLayout?.marker);
			const fallbackListTextStartPx = typeof wordLayout?.marker?.textStartX === "number" && Number.isFinite(wordLayout.marker.textStartX) ? wordLayout.marker.textStartX : typeof wordLayout?.textStartPx === "number" && Number.isFinite(wordLayout.textStartPx) ? wordLayout.textStartPx : void 0;
			const indentOffset = isListParagraph$1 ? isFirstLineOfPara ? (shouldUseResolvedListTextStart ? listFirstLineTextStartPx : void 0) ?? fallbackListTextStartPx ?? indentLeft : indentLeft : indentLeft + firstLineOffsetForCumX;
			return {
				line,
				lineIndex: paragraphLineIndex,
				availableWidth,
				skipJustify,
				paddingLeftPx,
				paddingRightPx,
				textIndentPx,
				isListFirstLine,
				resolvedListTextStartPx: shouldUseResolvedListTextStart ? listFirstLineTextStartPx : void 0,
				hasExplicitSegmentPositioning: hasExplicitSegmentPositioning$1,
				indentOffset
			};
		}),
		dropCap,
		marker,
		continuesFromPrev: fragment.continuesFromPrev,
		continuesOnNext: fragment.continuesOnNext,
		paragraphEndsWithLineBreak
	};
}
function buildMissingEntryMessage(fragmentKind, blockId) {
	return `[layout-resolved] Missing block/measure entry for ${fragmentKind} fragment "${blockId}".`;
}
function buildWrongKindMessage(fragmentKind, blockId, expectedBlockKind, expectedMeasureKind, actualBlockKind, actualMeasureKind) {
	return `[layout-resolved] Expected ${fragmentKind} fragment "${blockId}" to resolve to ${expectedBlockKind}/${expectedMeasureKind}, got ${actualBlockKind}/${actualMeasureKind}.`;
}
function requireResolvedBlockAndMeasure(blockMap, blockId, fragmentKind, expectedBlockKind, expectedMeasureKind) {
	const entry = blockMap.get(blockId);
	if (!entry) throw new Error(buildMissingEntryMessage(fragmentKind, blockId));
	const actualBlockKind = entry.block.kind;
	const actualMeasureKind = entry.measure.kind;
	if (!(actualBlockKind === expectedBlockKind && actualMeasureKind === expectedMeasureKind)) throw new Error(buildWrongKindMessage(fragmentKind, blockId, expectedBlockKind, expectedMeasureKind, actualBlockKind, actualMeasureKind));
	return {
		block: entry.block,
		measure: entry.measure
	};
}
function resolveTableFragmentId(fragment) {
	const partialKey = fragment.partialRow ? `:${fragment.partialRow.fromLineByCell.join(",")}-${fragment.partialRow.toLineByCell.join(",")}` : "";
	return `table:${fragment.blockId}:${fragment.fromRow}:${fragment.toRow}${partialKey}`;
}
function resolveTableItem(fragment, fragmentIndex, pageIndex, blockMap) {
	const { block, measure } = requireResolvedBlockAndMeasure(blockMap, fragment.blockId, "table", "table", "table");
	const item = {
		kind: "fragment",
		fragmentKind: "table",
		id: resolveTableFragmentId(fragment),
		pageIndex,
		x: fragment.x,
		y: fragment.y,
		width: fragment.width,
		height: fragment.height,
		zIndex: void 0,
		blockId: fragment.blockId,
		fragmentIndex,
		fragment,
		block,
		measure,
		cellSpacingPx: measure.cellSpacingPx ?? getCellSpacingPx(block.attrs?.cellSpacing),
		effectiveColumnWidths: fragment.columnWidths ?? measure.columnWidths,
		sourceAnchor: fragment.sourceAnchor ?? block.sourceAnchor
	};
	if (fragment.pmStart != null) item.pmStart = fragment.pmStart;
	if (fragment.pmEnd != null) item.pmEnd = fragment.pmEnd;
	if (fragment.continuesFromPrev != null) item.continuesFromPrev = fragment.continuesFromPrev;
	if (fragment.continuesOnNext != null) item.continuesOnNext = fragment.continuesOnNext;
	return item;
}
function resolveImageFragmentId(fragment) {
	return `image:${fragment.blockId}:${fragment.x}:${fragment.y}`;
}
function resolveImageItem(fragment, fragmentIndex, pageIndex, blockMap) {
	const { block } = requireResolvedBlockAndMeasure(blockMap, fragment.blockId, "image", "image", "image");
	const item = {
		kind: "fragment",
		fragmentKind: "image",
		id: resolveImageFragmentId(fragment),
		pageIndex,
		x: fragment.x,
		y: fragment.y,
		width: fragment.width,
		height: fragment.height,
		zIndex: fragment.isAnchored ? fragment.zIndex : void 0,
		blockId: fragment.blockId,
		fragmentIndex,
		fragment,
		block,
		sourceAnchor: fragment.sourceAnchor ?? block.sourceAnchor
	};
	if (fragment.pmStart != null) item.pmStart = fragment.pmStart;
	if (fragment.pmEnd != null) item.pmEnd = fragment.pmEnd;
	if (fragment.metadata != null) item.metadata = fragment.metadata;
	return item;
}
function resolveDrawingFragmentId(fragment) {
	return `drawing:${fragment.blockId}:${fragment.x}:${fragment.y}`;
}
function resolveDrawingItem(fragment, fragmentIndex, pageIndex, blockMap) {
	const { block } = requireResolvedBlockAndMeasure(blockMap, fragment.blockId, "drawing", "drawing", "drawing");
	const item = {
		kind: "fragment",
		fragmentKind: "drawing",
		id: resolveDrawingFragmentId(fragment),
		pageIndex,
		x: fragment.x,
		y: fragment.y,
		width: fragment.width,
		height: fragment.height,
		zIndex: fragment.isAnchored ? fragment.zIndex : void 0,
		blockId: fragment.blockId,
		fragmentIndex,
		fragment,
		block,
		sourceAnchor: fragment.sourceAnchor ?? block.sourceAnchor
	};
	if (fragment.pmStart != null) item.pmStart = fragment.pmStart;
	if (fragment.pmEnd != null) item.pmEnd = fragment.pmEnd;
	return item;
}
var hashParagraphBorder$1 = (border) => {
	const parts = [];
	if (border.style !== void 0) parts.push(`s:${border.style}`);
	if (border.width !== void 0) parts.push(`w:${border.width}`);
	if (border.color !== void 0) parts.push(`c:${border.color}`);
	if (border.space !== void 0) parts.push(`sp:${border.space}`);
	return parts.join(",");
};
const hashParagraphBorders$1 = (borders) => {
	const parts = [];
	if (borders.top) parts.push(`t:[${hashParagraphBorder$1(borders.top)}]`);
	if (borders.right) parts.push(`r:[${hashParagraphBorder$1(borders.right)}]`);
	if (borders.bottom) parts.push(`b:[${hashParagraphBorder$1(borders.bottom)}]`);
	if (borders.left) parts.push(`l:[${hashParagraphBorder$1(borders.left)}]`);
	if (borders.between) parts.push(`bw:[${hashParagraphBorder$1(borders.between)}]`);
	return parts.join(";");
};
var isNoneBorder$1 = (value) => {
	return typeof value === "object" && value !== null && "none" in value && value.none === true;
};
var isBorderSpec$1 = (value) => {
	return typeof value === "object" && value !== null && !("none" in value);
};
const hashBorderSpec$1 = (border) => {
	const parts = [];
	if (border.style !== void 0) parts.push(`s:${border.style}`);
	if (border.width !== void 0) parts.push(`w:${border.width}`);
	if (border.color !== void 0) parts.push(`c:${border.color}`);
	if (border.space !== void 0) parts.push(`sp:${border.space}`);
	return parts.join(",");
};
var hashTableBorderValue$1 = (borderValue) => {
	if (borderValue === void 0) return "";
	if (borderValue === null) return "null";
	if (isNoneBorder$1(borderValue)) return "none";
	if (isBorderSpec$1(borderValue)) return hashBorderSpec$1(borderValue);
	return "";
};
const hashTableBorders$1 = (borders) => {
	if (!borders) return "";
	const parts = [];
	if (borders.top !== void 0) parts.push(`t:[${hashTableBorderValue$1(borders.top)}]`);
	if (borders.right !== void 0) parts.push(`r:[${hashTableBorderValue$1(borders.right)}]`);
	if (borders.bottom !== void 0) parts.push(`b:[${hashTableBorderValue$1(borders.bottom)}]`);
	if (borders.left !== void 0) parts.push(`l:[${hashTableBorderValue$1(borders.left)}]`);
	if (borders.insideH !== void 0) parts.push(`ih:[${hashTableBorderValue$1(borders.insideH)}]`);
	if (borders.insideV !== void 0) parts.push(`iv:[${hashTableBorderValue$1(borders.insideV)}]`);
	return parts.join(";");
};
const hashCellBorders$1 = (borders) => {
	if (!borders) return "";
	const parts = [];
	if (borders.top) parts.push(`t:[${hashBorderSpec$1(borders.top)}]`);
	if (borders.right) parts.push(`r:[${hashBorderSpec$1(borders.right)}]`);
	if (borders.bottom) parts.push(`b:[${hashBorderSpec$1(borders.bottom)}]`);
	if (borders.left) parts.push(`l:[${hashBorderSpec$1(borders.left)}]`);
	return parts.join(";");
};
var hasStringProp = (run, prop) => {
	return prop in run && typeof run[prop] === "string";
};
var hasNumberProp = (run, prop) => {
	return prop in run && typeof run[prop] === "number";
};
var hasBooleanProp = (run, prop) => {
	return prop in run && typeof run[prop] === "boolean";
};
const getRunStringProp = (run, prop) => {
	if (hasStringProp(run, prop)) return run[prop];
	return "";
};
const getRunNumberProp = (run, prop) => {
	if (hasNumberProp(run, prop)) return run[prop];
	return 0;
};
const getRunBooleanProp = (run, prop) => {
	if (hasBooleanProp(run, prop)) return run[prop];
	return false;
};
const getRunUnderlineStyle = (run) => {
	if ("underline" in run && typeof run.underline === "boolean") return run.underline ? "single" : "";
	if ("underline" in run && run.underline && typeof run.underline === "object") return run.underline.style ?? "";
	return "";
};
const getRunUnderlineColor = (run) => {
	if ("underline" in run && run.underline && typeof run.underline === "object") return run.underline.color ?? "";
	return "";
};
var getSdtMetadataId = (metadata) => {
	if (!metadata) return "";
	if ("id" in metadata && metadata.id != null) return String(metadata.id);
	return "";
};
var getSdtMetadataLockMode = (metadata) => {
	if (!metadata) return "";
	return metadata.type === "structuredContent" ? metadata.lockMode ?? "" : "";
};
var getSdtMetadataVersion = (metadata) => {
	if (!metadata) return "";
	return [
		metadata.type,
		getSdtMetadataLockMode(metadata),
		getSdtMetadataId(metadata)
	].join(":");
};
var getTrackedChangeLayers = (run) => {
	if (Array.isArray(run.trackedChanges) && run.trackedChanges.length > 0) return run.trackedChanges;
	return run.trackedChange ? [run.trackedChange] : [];
};
var trackedChangeVersion = (run) => getTrackedChangeLayers(run).map((trackedChange) => [
	trackedChange.kind ?? "",
	trackedChange.id ?? "",
	trackedChange.storyKey ?? "",
	trackedChange.overlapParentId ?? "",
	trackedChange.relationship ?? "",
	trackedChange.author ?? "",
	trackedChange.authorEmail ?? "",
	trackedChange.authorImage ?? "",
	trackedChange.date ?? "",
	trackedChange.before ? JSON.stringify(trackedChange.before) : "",
	trackedChange.after ? JSON.stringify(trackedChange.after) : ""
].join(":")).join("|");
var CLIP_PATH_PREFIXES = [
	"inset(",
	"polygon(",
	"circle(",
	"ellipse(",
	"path(",
	"rect("
];
var readClipPathValue = (value) => {
	if (typeof value !== "string") return "";
	const normalized = value.trim();
	if (normalized.length === 0) return "";
	const lower = normalized.toLowerCase();
	if (!CLIP_PATH_PREFIXES.some((prefix) => lower.startsWith(prefix))) return "";
	return normalized;
};
var resolveClipPathFromAttrs = (attrs) => {
	if (!attrs || typeof attrs !== "object") return "";
	return readClipPathValue(attrs.clipPath);
};
var resolveBlockClipPath = (block) => {
	if (!block || typeof block !== "object") return "";
	const record = block;
	return readClipPathValue(record.clipPath) || resolveClipPathFromAttrs(record.attrs);
};
var imageHyperlinkVersion = (hyperlink) => {
	if (!hyperlink) return "";
	return JSON.stringify([hyperlink.url ?? "", hyperlink.tooltip ?? ""]);
};
var imageLuminanceVersion = (lum) => {
	if (!lum) return "";
	return [lum.bright ?? "", lum.contrast ?? ""].join(":");
};
var drawingTextVersion = (block) => {
	const textboxContentBlocks = "contentBlocks" in block && Array.isArray(block.contentBlocks) ? block.contentBlocks.map((contentBlock) => deriveBlockVersion(contentBlock)).join(";") : "";
	return JSON.stringify([
		block.textAlign ?? "",
		block.textVerticalAlign ?? "",
		block.textInsets ?? null,
		block.textContent ?? null,
		textboxContentBlocks
	]);
};
var imageAlphaModFixVersion = (alphaModFix) => {
	if (!alphaModFix) return "";
	return String(alphaModFix.amt ?? "");
};
var renderedBlockImageVersion = (image) => [
	image.src ?? "",
	image.width ?? "",
	image.height ?? "",
	image.alt ?? "",
	image.title ?? "",
	image.objectFit ?? "",
	image.display ?? "",
	image.gain ?? "",
	image.blacklevel ?? "",
	image.grayscale ? 1 : 0,
	imageLuminanceVersion(image.lum),
	imageAlphaModFixVersion(image.alphaModFix),
	image.rotation ?? "",
	image.flipH ? 1 : 0,
	image.flipV ? 1 : 0,
	imageHyperlinkVersion(image.hyperlink),
	resolveBlockClipPath(image)
].join("|");
var renderedInlineImageRunVersion = (image) => [
	"img",
	image.src ?? "",
	image.width ?? "",
	image.height ?? "",
	image.alt ?? "",
	image.title ?? "",
	typeof image.clipPath === "string" ? image.clipPath.trim() : "",
	image.distTop ?? "",
	image.distBottom ?? "",
	image.distLeft ?? "",
	image.distRight ?? "",
	image.verticalAlign ?? "",
	image.gain ?? "",
	image.blacklevel ?? "",
	image.grayscale ? 1 : 0,
	imageLuminanceVersion(image.lum),
	imageAlphaModFixVersion(image.alphaModFix),
	image.rotation ?? "",
	image.flipH ? 1 : 0,
	image.flipV ? 1 : 0,
	imageHyperlinkVersion(image.hyperlink),
	stableSerializeEvidenceValue(image.sdt),
	stableSerializeEvidenceValue(image.dataAttrs)
].join("|");
var hasListMarkerProperties = (attrs) => {
	if (!attrs || typeof attrs !== "object") return false;
	const obj = attrs;
	if (!obj.numberingProperties || typeof obj.numberingProperties !== "object") return false;
	const numProps = obj.numberingProperties;
	if ("numId" in numProps) {
		const numId = numProps.numId;
		if (typeof numId !== "number" && typeof numId !== "string") return false;
	}
	if ("ilvl" in numProps) {
		if (typeof numProps.ilvl !== "number") return false;
	}
	if ("wordLayout" in obj && obj.wordLayout !== void 0) {
		if (typeof obj.wordLayout !== "object" || obj.wordLayout === null) return false;
		const wordLayout = obj.wordLayout;
		if ("marker" in wordLayout && wordLayout.marker !== void 0) {
			if (typeof wordLayout.marker !== "object" || wordLayout.marker === null) return false;
			const marker = wordLayout.marker;
			if ("markerText" in marker && marker.markerText !== void 0) {
				if (typeof marker.markerText !== "string") return false;
			}
		}
	}
	return true;
};
var hashString = (seed, value) => {
	let hash$3 = seed >>> 0;
	for (let i = 0; i < value.length; i++) {
		hash$3 ^= value.charCodeAt(i);
		hash$3 = Math.imul(hash$3, 16777619);
	}
	return hash$3 >>> 0;
};
var hashNumber = (seed, value) => {
	let hash$3 = seed ^ (Number.isFinite(value) ? value : 0);
	hash$3 = Math.imul(hash$3, 16777619);
	hash$3 ^= hash$3 >>> 13;
	return hash$3 >>> 0;
};
var stableSerializeEvidenceValue = (value) => {
	if (value === void 0) return "";
	if (value === null) return "null";
	if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return JSON.stringify(value);
	if (Array.isArray(value)) return `[${value.map((item) => stableSerializeEvidenceValue(item)).join(",")}]`;
	if (typeof value === "object") {
		const record = value;
		return `{${Object.keys(record).sort().filter((key) => record[key] !== void 0).map((key) => `${JSON.stringify(key)}:${stableSerializeEvidenceValue(record[key])}`).join(",")}}`;
	}
	return JSON.stringify(String(value));
};
const sourceAnchorSignature = (sourceAnchor) => sourceAnchor ? stableSerializeEvidenceValue(sourceAnchor) : "";
const resolveFragmentLayoutIdentity = (fragment, story) => {
	return buildLayoutSourceIdentityForFragment(fragment, story);
};
const deriveBlockVersion = (block) => {
	if (block.kind === "paragraph") {
		const markerVersion = hasListMarkerProperties(block.attrs) ? `marker:${block.attrs.numberingProperties.numId ?? ""}:${block.attrs.numberingProperties.ilvl ?? 0}:${block.attrs.wordLayout?.marker?.markerText ?? ""}` : "";
		const runsVersion = block.runs.map((run) => {
			if (run.kind === "image") return renderedInlineImageRunVersion(run);
			if (run.kind === "lineBreak") return "linebreak";
			if (run.kind === "tab") return [
				run.text ?? "",
				"tab",
				run.underline?.style ?? "",
				run.underline?.color ?? "",
				run.fontSize ?? "",
				run.fontFamily ?? "",
				run.bold ? 1 : 0,
				run.italic ? 1 : 0,
				getFontConfigVersion(),
				run.color ?? ""
			].join(",");
			if (run.kind === "fieldAnnotation") {
				const fieldRun = run;
				const size$1 = fieldRun.size ? `${fieldRun.size.width ?? ""}x${fieldRun.size.height ?? ""}` : "";
				const highlighted = fieldRun.highlighted !== false ? 1 : 0;
				return [
					"field",
					fieldRun.variant ?? "",
					fieldRun.displayLabel ?? "",
					fieldRun.fieldColor ?? "",
					fieldRun.borderColor ?? "",
					highlighted,
					fieldRun.hidden ? 1 : 0,
					fieldRun.visibility ?? "",
					fieldRun.imageSrc ?? "",
					fieldRun.linkUrl ?? "",
					fieldRun.rawHtml ?? "",
					size$1,
					fieldRun.fontFamily ?? "",
					fieldRun.fontSize ?? "",
					fieldRun.textColor ?? "",
					fieldRun.textHighlight ?? "",
					fieldRun.bold ? 1 : 0,
					fieldRun.italic ? 1 : 0,
					fieldRun.underline ? 1 : 0,
					fieldRun.fieldId ?? "",
					fieldRun.fieldType ?? ""
				].join(",");
			}
			const textRun = run;
			const trackedVersion = trackedChangeVersion(textRun);
			return [
				textRun.text ?? "",
				textRun.fontFamily,
				getFontConfigVersion(),
				textRun.fontSize,
				textRun.bold ? 1 : 0,
				textRun.italic ? 1 : 0,
				textRun.color ?? "",
				textRun.underline?.style ?? "",
				textRun.underline?.color ?? "",
				textRun.strike ? 1 : 0,
				textRun.highlight ?? "",
				textRun.letterSpacing != null ? textRun.letterSpacing : "",
				textRun.vertAlign ?? "",
				textRun.baselineShift != null ? textRun.baselineShift : "",
				textRun.token ?? "",
				textRun.pageNumberFieldFormat ? JSON.stringify(textRun.pageNumberFieldFormat) : "",
				trackedVersion,
				textRun.comments?.length ?? 0,
				textRun.bidi ? JSON.stringify(textRun.bidi) : ""
			].join(",");
		}).join("|");
		const attrs = block.attrs;
		const paragraphAttrsVersion = attrs ? [
			attrs.alignment ?? "",
			attrs.spacing?.before ?? "",
			attrs.spacing?.after ?? "",
			attrs.spacing?.line ?? "",
			attrs.spacing?.lineRule ?? "",
			attrs.indent?.left ?? "",
			attrs.indent?.right ?? "",
			attrs.indent?.firstLine ?? "",
			attrs.indent?.hanging ?? "",
			attrs.borders ? hashParagraphBorders$1(attrs.borders) : "",
			attrs.shading?.fill ?? "",
			attrs.shading?.color ?? "",
			getParagraphInlineDirection(attrs) ?? "",
			attrs.tabs?.length ? JSON.stringify(attrs.tabs) : ""
		].join(":") : "";
		const sdtAttrs = block.attrs?.sdt;
		return [
			markerVersion,
			runsVersion,
			paragraphAttrsVersion,
			getSdtMetadataVersion(sdtAttrs)
		].filter(Boolean).join("|");
	}
	if (block.kind === "list") return block.items.map((item) => `${item.id}:${item.marker.text}:${deriveBlockVersion(item.paragraph)}`).join("|");
	if (block.kind === "image") {
		const imgSdt = block.attrs?.sdt;
		const imgSdtVersion = getSdtMetadataVersion(imgSdt);
		return [renderedBlockImageVersion(block), imgSdtVersion].join("|");
	}
	if (block.kind === "drawing") {
		if (block.drawingKind === "image") return ["drawing:image", renderedBlockImageVersion(block)].join("|");
		if (block.drawingKind === "vectorShape" || block.drawingKind === "textboxShape") {
			const vector = block;
			return [
				block.drawingKind === "textboxShape" ? "drawing:textbox" : "drawing:vector",
				vector.shapeKind ?? "",
				vector.fillColor ?? "",
				vector.strokeColor ?? "",
				vector.strokeWidth ?? "",
				vector.geometry.width,
				vector.geometry.height,
				vector.geometry.rotation ?? 0,
				vector.geometry.flipH ? 1 : 0,
				vector.geometry.flipV ? 1 : 0,
				drawingTextVersion(vector)
			].join("|");
		}
		if (block.drawingKind === "shapeGroup") {
			const group = block;
			const childSignature = group.shapes.map((child) => `${child.shapeType}:${JSON.stringify(child.attrs ?? {})}`).join(";");
			return [
				"drawing:group",
				group.geometry.width,
				group.geometry.height,
				group.groupTransform ? JSON.stringify(group.groupTransform) : "",
				childSignature
			].join("|");
		}
		if (block.drawingKind === "chart") return [
			"drawing:chart",
			block.chartData?.chartType ?? "",
			block.chartData?.series?.length ?? 0,
			block.geometry.width,
			block.geometry.height,
			block.chartRelId ?? ""
		].join("|");
		return `drawing:unknown:${block.id}`;
	}
	if (block.kind === "table") {
		const tableBlock = block;
		let hash$3 = 2166136261;
		hash$3 = hashString(hash$3, block.id);
		hash$3 = hashNumber(hash$3, tableBlock.rows.length);
		hash$3 = (tableBlock.columnWidths ?? []).reduce((acc, width) => hashNumber(acc, Math.round(width * 1e3)), hash$3);
		const rows = tableBlock.rows ?? [];
		for (const row of rows) {
			if (!row || !Array.isArray(row.cells)) continue;
			hash$3 = hashNumber(hash$3, row.cells.length);
			for (const cell of row.cells) {
				if (!cell) continue;
				const cellBlocks = cell.blocks ?? (cell.paragraph ? [cell.paragraph] : []);
				hash$3 = hashNumber(hash$3, cellBlocks.length);
				hash$3 = hashNumber(hash$3, cell.rowSpan ?? 1);
				hash$3 = hashNumber(hash$3, cell.colSpan ?? 1);
				if (cell.attrs) {
					const cellAttrs = cell.attrs;
					if (cellAttrs.borders) hash$3 = hashString(hash$3, hashCellBorders$1(cellAttrs.borders));
					if (cellAttrs.padding) {
						const p$1 = cellAttrs.padding;
						hash$3 = hashNumber(hash$3, p$1.top ?? 0);
						hash$3 = hashNumber(hash$3, p$1.right ?? 0);
						hash$3 = hashNumber(hash$3, p$1.bottom ?? 0);
						hash$3 = hashNumber(hash$3, p$1.left ?? 0);
					}
					if (cellAttrs.verticalAlign) hash$3 = hashString(hash$3, cellAttrs.verticalAlign);
					if (cellAttrs.background) hash$3 = hashString(hash$3, cellAttrs.background);
				}
				for (const cellBlock of cellBlocks) {
					hash$3 = hashString(hash$3, cellBlock?.kind ?? "unknown");
					if (cellBlock?.kind === "paragraph") {
						const paragraphBlock = cellBlock;
						const runs = paragraphBlock.runs ?? [];
						hash$3 = hashNumber(hash$3, runs.length);
						const attrs = paragraphBlock.attrs;
						if (attrs) {
							hash$3 = hashString(hash$3, attrs.alignment ?? "");
							hash$3 = hashNumber(hash$3, attrs.spacing?.before ?? 0);
							hash$3 = hashNumber(hash$3, attrs.spacing?.after ?? 0);
							hash$3 = hashNumber(hash$3, attrs.spacing?.line ?? 0);
							hash$3 = hashString(hash$3, attrs.spacing?.lineRule ?? "");
							hash$3 = hashNumber(hash$3, attrs.indent?.left ?? 0);
							hash$3 = hashNumber(hash$3, attrs.indent?.right ?? 0);
							hash$3 = hashNumber(hash$3, attrs.indent?.firstLine ?? 0);
							hash$3 = hashNumber(hash$3, attrs.indent?.hanging ?? 0);
							hash$3 = hashString(hash$3, attrs.shading?.fill ?? "");
							hash$3 = hashString(hash$3, attrs.shading?.color ?? "");
							hash$3 = hashString(hash$3, getParagraphInlineDirection(attrs) ?? "");
							if (attrs.borders) hash$3 = hashString(hash$3, hashParagraphBorders$1(attrs.borders));
						}
						for (const run of runs) {
							if (run.kind === "image") {
								hash$3 = hashString(hash$3, renderedInlineImageRunVersion(run));
								hash$3 = hashNumber(hash$3, run.pmStart ?? -1);
								hash$3 = hashNumber(hash$3, run.pmEnd ?? -1);
								continue;
							}
							if ("text" in run && typeof run.text === "string") hash$3 = hashString(hash$3, run.text);
							hash$3 = hashNumber(hash$3, run.pmStart ?? -1);
							hash$3 = hashNumber(hash$3, run.pmEnd ?? -1);
							hash$3 = hashString(hash$3, getRunStringProp(run, "color"));
							hash$3 = hashString(hash$3, getRunStringProp(run, "highlight"));
							hash$3 = hashString(hash$3, getRunBooleanProp(run, "bold") ? "1" : "");
							hash$3 = hashString(hash$3, getRunBooleanProp(run, "italic") ? "1" : "");
							hash$3 = hashNumber(hash$3, getRunNumberProp(run, "fontSize"));
							hash$3 = hashString(hash$3, getRunStringProp(run, "fontFamily"));
							hash$3 = hashString(hash$3, getRunUnderlineStyle(run));
							hash$3 = hashString(hash$3, getRunUnderlineColor(run));
							hash$3 = hashString(hash$3, getRunBooleanProp(run, "strike") ? "1" : "");
							hash$3 = hashString(hash$3, getRunStringProp(run, "vertAlign"));
							hash$3 = hashNumber(hash$3, getRunNumberProp(run, "baselineShift"));
							hash$3 = hashString(hash$3, getRunStringProp(run, "token"));
							const pageNumberFieldFormat = run.pageNumberFieldFormat;
							hash$3 = hashString(hash$3, pageNumberFieldFormat ? JSON.stringify(pageNumberFieldFormat) : "");
							const bidi = run.bidi;
							hash$3 = hashString(hash$3, bidi ? JSON.stringify(bidi) : "");
							hash$3 = hashString(hash$3, trackedChangeVersion(run));
						}
					} else if (cellBlock?.kind) hash$3 = hashString(hash$3, deriveBlockVersion(cellBlock));
				}
			}
		}
		if (tableBlock.attrs) {
			const tblAttrs = tableBlock.attrs;
			if (tblAttrs.borders) hash$3 = hashString(hash$3, hashTableBorders$1(tblAttrs.borders));
			if (tblAttrs.borderCollapse) hash$3 = hashString(hash$3, tblAttrs.borderCollapse);
			if (tblAttrs.cellSpacing !== void 0) {
				const cs = tblAttrs.cellSpacing;
				if (typeof cs === "number") hash$3 = hashNumber(hash$3, cs);
				else {
					const v = cs.value ?? 0;
					const t = cs.type ?? "px";
					hash$3 = hashString(hash$3, `cs:${v}:${t}`);
				}
			}
			if (tblAttrs.sdt) {
				hash$3 = hashString(hash$3, tblAttrs.sdt.type);
				hash$3 = hashString(hash$3, getSdtMetadataLockMode(tblAttrs.sdt));
				hash$3 = hashString(hash$3, getSdtMetadataId(tblAttrs.sdt));
			}
		}
		return [
			block.id,
			tableBlock.rows.length,
			hash$3.toString(16)
		].join("|");
	}
	return block.id;
};
const fragmentSignature = (fragment, blockVersion) => {
	if (fragment.kind === "para") return [
		blockVersion,
		fragment.fromLine,
		fragment.toLine,
		fragment.continuesFromPrev ? 1 : 0,
		fragment.continuesOnNext ? 1 : 0,
		fragment.markerWidth ?? ""
	].join("|");
	if (fragment.kind === "list-item") return [
		blockVersion,
		fragment.itemId,
		fragment.fromLine,
		fragment.toLine,
		fragment.continuesFromPrev ? 1 : 0,
		fragment.continuesOnNext ? 1 : 0
	].join("|");
	if (fragment.kind === "image") return [
		blockVersion,
		fragment.width,
		fragment.height
	].join("|");
	if (fragment.kind === "drawing") return [
		blockVersion,
		fragment.drawingKind,
		fragment.drawingContentId ?? "",
		fragment.width,
		fragment.height,
		fragment.geometry.width,
		fragment.geometry.height,
		fragment.geometry.rotation ?? 0,
		fragment.scale ?? 1,
		fragment.zIndex ?? ""
	].join("|");
	if (fragment.kind === "table") {
		const partialSig = fragment.partialRow ? `${fragment.partialRow.fromLineByCell.join(",")}-${fragment.partialRow.toLineByCell.join(",")}-${fragment.partialRow.partialHeight}` : "";
		return [
			blockVersion,
			fragment.fromRow,
			fragment.toRow,
			fragment.width,
			fragment.height,
			fragment.continuesFromPrev ? 1 : 0,
			fragment.continuesOnNext ? 1 : 0,
			fragment.repeatHeaderCount ?? 0,
			partialSig
		].join("|");
	}
	return blockVersion;
};
function resolvePageRefText(args$1) {
	const formattedTargetPageText = formatTargetPageText(args$1.target, args$1.metadata);
	if (!args$1.metadata.relativePosition) return formattedTargetPageText;
	if (args$1.sourcePage !== args$1.target.physicalPage) return `on page ${formattedTargetPageText}`;
	return args$1.target.pmPosition != null && args$1.sourcePmPosition != null && args$1.target.pmPosition < args$1.sourcePmPosition ? "above" : "below";
}
function formatTargetPageText(target, metadata) {
	const displayNumber = Math.max(1, Math.trunc(Number.isFinite(target.displayNumber) ? target.displayNumber : 1));
	if (metadata.numericPictureFormat) return formatChapterPageNumberText({
		pageComponent: formatIntegerWithNumericPicture(displayNumber, metadata.numericPictureFormat.picture),
		chapterNumberText: target.chapterNumberText,
		chapterSeparator: target.chapterSeparator
	});
	if (metadata.pageNumberFieldFormat) return formatChapterPageNumberText({
		pageComponent: formatPageNumberFieldValue(displayNumber, metadata.pageNumberFieldFormat),
		chapterNumberText: target.chapterNumberText,
		chapterSeparator: target.chapterSeparator
	});
	return target.displayText;
}
function buildBlockMap(blocks, measures) {
	const map$1 = /* @__PURE__ */ new Map();
	for (let i = 0; i < blocks.length; i++) map$1.set(blocks[i].id, {
		block: blocks[i],
		measure: measures[i]
	});
	return map$1;
}
function resolveParagraphPageRefs(fragment, block, measure, context) {
	const runTexts = collectResolvedPageRefRunTexts(block, context);
	if (runTexts.size === 0) return {
		block,
		fragment,
		changed: false
	};
	const nextRuns = resolvePageRefRuns(block, runTexts);
	const nextLines = (fragment.lines ?? measure.lines.slice(fragment.fromLine, fragment.toLine)).map((line) => adjustLineForResolvedPageRefs(line, runTexts));
	return {
		block: {
			...block,
			runs: nextRuns
		},
		fragment: {
			...fragment,
			lines: nextLines
		},
		changed: true
	};
}
function resolveParagraphPageRefBlock(block, measure, context) {
	const runTexts = collectResolvedPageRefRunTexts(block, context);
	if (runTexts.size === 0) return {
		block,
		changed: false
	};
	return {
		block: {
			...block,
			runs: resolvePageRefRuns(block, runTexts)
		},
		measure: measure ? {
			...measure,
			lines: measure.lines.map((line) => adjustLineForResolvedPageRefs(line, runTexts))
		} : void 0,
		changed: true
	};
}
function collectResolvedPageRefRunTexts(block, context) {
	const runTexts = /* @__PURE__ */ new Map();
	if (!context?.anchorMap?.size) return runTexts;
	block.runs.forEach((run, index) => {
		if (!isPageReferenceTextRun(run)) return;
		const target = context.anchorMap?.get(run.pageRefMetadata.bookmarkId);
		if (!target) return;
		const resolvedText = resolvePageRefText({
			sourcePage: context.sourcePage,
			sourcePmPosition: run.pmStart,
			target,
			metadata: run.pageRefMetadata
		});
		if (resolvedText !== run.text) runTexts.set(index, {
			text: resolvedText,
			originalLength: run.text.length
		});
	});
	return runTexts;
}
function resolvePageRefRuns(block, runTexts) {
	return block.runs.map((run, index) => runTexts.has(index) && isTextRun$5(run) ? {
		...run,
		text: runTexts.get(index).text
	} : run);
}
function resolveTablePageRefs(block, measure, context) {
	if (!context?.anchorMap?.size) return {
		block,
		changed: false
	};
	let changed = false;
	let measureChanged = false;
	const measureRows = measure?.rows.slice();
	const rows = block.rows.map((row, rowIndex) => {
		let rowChanged = false;
		const measureRow = measureRows?.[rowIndex];
		const measureCells = measureRow?.cells.slice();
		const cells = row.cells.map((cell, cellIndex) => {
			let cellChanged = false;
			let nextParagraph = cell.paragraph;
			let nextCellMeasure = measureCells?.[cellIndex];
			if (cell.paragraph) {
				const resolved = resolveParagraphPageRefBlock(cell.paragraph, nextCellMeasure?.paragraph, context);
				nextParagraph = resolved.block;
				if (resolved.measure && nextCellMeasure) nextCellMeasure = {
					...nextCellMeasure,
					paragraph: resolved.measure
				};
				cellChanged ||= resolved.changed;
			}
			let nextBlocks = cell.blocks;
			let nextBlockMeasures = nextCellMeasure?.blocks;
			if (cell.blocks) nextBlocks = cell.blocks.map((childBlock, childIndex) => {
				const childMeasure = nextBlockMeasures?.[childIndex];
				if (childBlock.kind === "paragraph") {
					const resolved = resolveParagraphPageRefBlock(childBlock, childMeasure?.kind === "paragraph" ? childMeasure : void 0, context);
					if (resolved.measure && nextBlockMeasures) {
						nextBlockMeasures = nextBlockMeasures.slice();
						nextBlockMeasures[childIndex] = resolved.measure;
					}
					cellChanged ||= resolved.changed;
					return resolved.block;
				}
				if (childBlock.kind === "table") {
					const resolved = resolveTablePageRefs(childBlock, childMeasure?.kind === "table" ? childMeasure : void 0, context);
					if (resolved.measure && nextBlockMeasures) {
						nextBlockMeasures = nextBlockMeasures.slice();
						nextBlockMeasures[childIndex] = resolved.measure;
					}
					cellChanged ||= resolved.changed;
					return resolved.block;
				}
				return childBlock;
			});
			if (!cellChanged) return cell;
			rowChanged = true;
			if (nextCellMeasure && measureCells) {
				if (nextBlockMeasures && nextBlockMeasures !== nextCellMeasure.blocks) nextCellMeasure = {
					...nextCellMeasure,
					blocks: nextBlockMeasures
				};
				measureCells[cellIndex] = nextCellMeasure;
				measureChanged = true;
			}
			return {
				...cell,
				...nextParagraph ? { paragraph: nextParagraph } : {},
				...nextBlocks ? { blocks: nextBlocks } : {}
			};
		});
		if (!rowChanged) return row;
		changed = true;
		if (measureRow && measureCells && measureCells !== measureRow.cells) measureRows[rowIndex] = {
			...measureRow,
			cells: measureCells
		};
		return {
			...row,
			cells
		};
	});
	return changed ? {
		block: {
			...block,
			rows
		},
		measure: measure && measureChanged && measureRows ? {
			...measure,
			rows: measureRows
		} : measure,
		changed: true
	} : {
		block,
		changed: false
	};
}
function resolveListItemPageRefs(block, itemId, measure, context) {
	if (!context?.anchorMap?.size) return {
		block,
		changed: false
	};
	let changed = false;
	let measureChanged = false;
	const measureItems = measure?.items.slice();
	const items = block.items.map((item) => {
		if (item.id !== itemId) return item;
		const itemMeasureIndex = measureItems?.findIndex((candidate) => candidate.itemId === itemId) ?? -1;
		const itemMeasure = itemMeasureIndex >= 0 ? measureItems?.[itemMeasureIndex] : void 0;
		const resolved = resolveParagraphPageRefBlock(item.paragraph, itemMeasure?.paragraph, context);
		if (!resolved.changed) return item;
		if (resolved.measure && itemMeasure && measureItems) {
			measureItems[itemMeasureIndex] = {
				...itemMeasure,
				paragraph: resolved.measure
			};
			measureChanged = true;
		}
		changed = true;
		return {
			...item,
			paragraph: resolved.block
		};
	});
	return changed ? {
		block: {
			...block,
			items
		},
		measure: measure && measureChanged && measureItems ? {
			...measure,
			items: measureItems
		} : measure,
		changed: true
	} : {
		block,
		changed: false
	};
}
function isTextRun$5(run) {
	return (run.kind === "text" || run.kind === void 0) && "text" in run;
}
function isPageReferenceTextRun(run) {
	return isTextRun$5(run) && run.token === "pageReference" && run.pageRefMetadata != null;
}
function adjustLineForResolvedPageRefs(line, runTexts) {
	let changed = false;
	const nextLine = { ...line };
	for (const [runIndex, resolved] of runTexts) {
		if (runIndex < line.fromRun || runIndex > line.toRun) continue;
		changed = true;
		if (line.fromRun === runIndex) nextLine.fromChar = clampResolvedRunBoundary(line.fromChar, resolved);
		if (line.toRun === runIndex) nextLine.toChar = clampResolvedRunBoundary(line.toChar, resolved);
	}
	if (line.segments?.length) nextLine.segments = line.segments.map((segment) => {
		const resolved = runTexts.get(segment.runIndex);
		if (resolved == null) return segment;
		changed = true;
		return {
			...segment,
			fromChar: clampResolvedRunBoundary(segment.fromChar, resolved),
			toChar: clampResolvedRunBoundary(segment.toChar, resolved)
		};
	});
	return changed ? nextLine : line;
}
function clampResolvedRunBoundary(offset$1, resolved) {
	if (offset$1 === resolved.originalLength) return resolved.text.length;
	return Math.min(offset$1, resolved.text.length);
}
function sumLineHeights$2(lines, from$1, to) {
	let total = 0;
	for (let i = from$1; i < to && i < lines.length; i++) total += lines[i].lineHeight;
	return total;
}
function computeFragmentHeight$1(fragment, blockMap) {
	if (fragment.kind === "image" || fragment.kind === "drawing" || fragment.kind === "table") return fragment.height;
	const entry = blockMap.get(fragment.blockId);
	if (!entry) return 0;
	if (fragment.kind === "para") {
		if (fragment.lines) return fragment.lines.reduce((sum, line) => sum + line.lineHeight, 0);
		if (entry.measure.kind === "paragraph") return sumLineHeights$2(entry.measure.lines, fragment.fromLine, fragment.toLine);
		return 0;
	}
	if (fragment.kind === "list-item") {
		const listMeasure = entry.measure;
		if (listMeasure.kind !== "list") return 0;
		const item = listMeasure.items.find((it) => it.itemId === fragment.itemId);
		if (!item) return 0;
		return sumLineHeights$2(item.paragraph.lines, fragment.fromLine, fragment.toLine);
	}
	return 0;
}
function isAnchoredMediaFragment(fragment) {
	return (fragment.kind === "image" || fragment.kind === "drawing") && fragment.isAnchored === true;
}
function resolveFragmentZIndex(fragment) {
	if (!isAnchoredMediaFragment(fragment)) return;
	return fragment.zIndex;
}
function resolveFragmentId(fragment) {
	switch (fragment.kind) {
		case "para": return `para:${fragment.blockId}:${fragment.fromLine}:${fragment.toLine}`;
		case "list-item": return `list-item:${fragment.blockId}:${fragment.itemId}:${fragment.fromLine}:${fragment.toLine}`;
		case "image": return `image:${fragment.blockId}:${fragment.x}:${fragment.y}`;
		case "drawing": return `drawing:${fragment.blockId}:${fragment.x}:${fragment.y}`;
		case "table": {
			const partialKey = fragment.partialRow ? `:${fragment.partialRow.fromLineByCell.join(",")}-${fragment.partialRow.toLineByCell.join(",")}` : "";
			return `table:${fragment.blockId}:${fragment.fromRow}:${fragment.toRow}${partialKey}`;
		}
	}
}
function resolveParagraphContentIfApplicable(fragment, blockMap, pageRefContext) {
	if (fragment.kind !== "para") return void 0;
	const entry = blockMap.get(fragment.blockId);
	if (!entry || entry.block.kind !== "paragraph" || entry.measure.kind !== "paragraph") return void 0;
	const paragraphBlock = entry.block;
	const paragraphMeasure = entry.measure;
	const resolvedPageRefs = resolveParagraphPageRefs(fragment, paragraphBlock, paragraphMeasure, pageRefContext);
	return resolveParagraphContent(resolvedPageRefs.fragment, resolvedPageRefs.block, paragraphMeasure);
}
function resolveFragmentParagraphBorders(fragment, blockMap) {
	const entry = blockMap.get(fragment.blockId);
	if (!entry) return void 0;
	if (fragment.kind === "para" && entry.block.kind === "paragraph") return entry.block.attrs?.borders;
	if (fragment.kind === "list-item" && entry.block.kind === "list") return entry.block.items.find((listItem) => listItem.id === fragment.itemId)?.paragraph.attrs?.borders;
}
function resolveFragmentSdtContainerKey(fragment, blockMap) {
	const entry = blockMap.get(fragment.blockId);
	if (!entry) return null;
	const block = entry.block;
	if (fragment.kind === "para" && block.kind === "paragraph") return getSdtContainerKey(block.attrs?.sdt, block.attrs?.containerSdt);
	if (fragment.kind === "list-item" && block.kind === "list") {
		const item = block.items.find((listItem) => listItem.id === fragment.itemId);
		return getSdtContainerKey(item?.paragraph.attrs?.sdt, item?.paragraph.attrs?.containerSdt);
	}
	if (fragment.kind === "table" && block.kind === "table") return getSdtContainerKey(block.attrs?.sdt, block.attrs?.containerSdt);
	return null;
}
function computeBlockVersion(blockId, blockMap, cache$2, fontSignature = "") {
	const cached = cache$2.get(blockId);
	if (cached !== void 0) return cached;
	const entry = blockMap.get(blockId);
	if (!entry) {
		cache$2.set(blockId, "missing");
		return "missing";
	}
	const versioned = deriveFontAwareBlockVersion(entry.block, fontSignature);
	cache$2.set(blockId, versioned);
	return versioned;
}
function deriveFontAwareBlockVersion(block, fontSignature = "") {
	const version$1 = deriveBlockVersion(block);
	return fontSignature ? `${fontSignature}|${version$1}` : version$1;
}
function applyPaintVersions(item, visualVersion) {
	const evidenceVersion = sourceAnchorSignature(item.sourceAnchor);
	item.version = visualVersion;
	if (evidenceVersion) {
		item.evidenceVersion = evidenceVersion;
		item.paintCacheVersion = `${visualVersion}|source:${evidenceVersion}`;
	} else item.paintCacheVersion = visualVersion;
}
function resolveFragmentItem(fragment, fragmentIndex, pageIndex, blockMap, blockVersionCache, story, fontSignature = "", pageRefContext) {
	const sdtContainerKey = resolveFragmentSdtContainerKey(fragment, blockMap);
	const version$1 = fragmentSignature(fragment, computeBlockVersion(fragment.blockId, blockMap, blockVersionCache, fontSignature));
	const layoutSourceIdentity = resolveFragmentLayoutIdentity(fragment, story);
	switch (fragment.kind) {
		case "table": {
			const item = resolveTableItem(fragment, fragmentIndex, pageIndex, blockMap);
			const tablePageRefs = resolveTablePageRefs(item.block, item.measure, pageRefContext);
			if (tablePageRefs.changed) {
				item.block = tablePageRefs.block;
				if (tablePageRefs.measure) item.measure = tablePageRefs.measure;
			}
			if (sdtContainerKey != null) item.sdtContainerKey = sdtContainerKey;
			if (fragment.sourceAnchor != null) item.sourceAnchor = fragment.sourceAnchor;
			item.layoutSourceIdentity = layoutSourceIdentity;
			applyPaintVersions(item, tablePageRefs.changed ? fragmentSignature(fragment, deriveFontAwareBlockVersion(tablePageRefs.block, fontSignature)) : version$1);
			return item;
		}
		case "image": {
			const item = resolveImageItem(fragment, fragmentIndex, pageIndex, blockMap);
			if (sdtContainerKey != null) item.sdtContainerKey = sdtContainerKey;
			if (fragment.sourceAnchor != null) item.sourceAnchor = fragment.sourceAnchor;
			item.layoutSourceIdentity = layoutSourceIdentity;
			applyPaintVersions(item, version$1);
			return item;
		}
		case "drawing": {
			const item = resolveDrawingItem(fragment, fragmentIndex, pageIndex, blockMap);
			if (sdtContainerKey != null) item.sdtContainerKey = sdtContainerKey;
			if (fragment.sourceAnchor != null) item.sourceAnchor = fragment.sourceAnchor;
			item.layoutSourceIdentity = layoutSourceIdentity;
			applyPaintVersions(item, version$1);
			return item;
		}
		default: {
			const entry = blockMap.get(fragment.blockId);
			const paragraphPageRefs = fragment.kind === "para" && entry?.block.kind === "paragraph" && entry.measure.kind === "paragraph" ? resolveParagraphPageRefs(fragment, entry.block, entry.measure, pageRefContext) : null;
			const listPageRefs = fragment.kind === "list-item" && entry?.block.kind === "list" ? resolveListItemPageRefs(entry.block, fragment.itemId, entry.measure.kind === "list" ? entry.measure : void 0, pageRefContext) : null;
			const itemVersion = paragraphPageRefs?.changed ? fragmentSignature(paragraphPageRefs.fragment, deriveFontAwareBlockVersion(paragraphPageRefs.block, fontSignature)) : listPageRefs?.changed ? fragmentSignature(fragment, deriveFontAwareBlockVersion(listPageRefs.block, fontSignature)) : version$1;
			const item = {
				kind: "fragment",
				id: resolveFragmentId(fragment),
				pageIndex,
				x: fragment.x,
				y: fragment.y,
				width: fragment.width,
				height: computeFragmentHeight$1(fragment, blockMap),
				zIndex: resolveFragmentZIndex(fragment),
				fragmentKind: fragment.kind,
				fragment,
				blockId: fragment.blockId,
				fragmentIndex,
				content: paragraphPageRefs ? resolveParagraphContent(paragraphPageRefs.fragment, paragraphPageRefs.block, entry.measure) : resolveParagraphContentIfApplicable(fragment, blockMap, pageRefContext),
				layoutSourceIdentity
			};
			if (sdtContainerKey != null) item.sdtContainerKey = sdtContainerKey;
			if (fragment.sourceAnchor != null) item.sourceAnchor = fragment.sourceAnchor;
			if (entry) {
				if (fragment.kind === "para" && entry.block.kind === "paragraph" && entry.measure.kind === "paragraph") {
					item.block = paragraphPageRefs?.block ?? entry.block;
					item.measure = entry.measure;
					if (item.sourceAnchor == null) item.sourceAnchor = entry.block.sourceAnchor;
				} else if (fragment.kind === "list-item" && entry.block.kind === "list" && entry.measure.kind === "list") {
					const listBlock = listPageRefs?.block ?? entry.block;
					const listItem = listBlock.items.find((candidate) => candidate.id === fragment.itemId);
					item.block = listBlock;
					item.measure = listPageRefs?.measure ?? entry.measure;
					if (item.sourceAnchor == null) item.sourceAnchor = listItem?.sourceAnchor ?? listItem?.paragraph.sourceAnchor ?? listBlock.sourceAnchor;
				}
			}
			const borders = resolveFragmentParagraphBorders(fragment, blockMap);
			if (borders) {
				item.paragraphBorders = borders;
				item.paragraphBorderHash = hashParagraphBorders$1(borders);
			}
			if (fragment.kind === "para") {
				const para = fragment;
				if (para.pmStart != null) item.pmStart = para.pmStart;
				if (para.pmEnd != null) item.pmEnd = para.pmEnd;
				if (para.continuesFromPrev != null) item.continuesFromPrev = para.continuesFromPrev;
				if (para.continuesOnNext != null) item.continuesOnNext = para.continuesOnNext;
				if (para.markerWidth != null) item.markerWidth = para.markerWidth;
			} else if (fragment.kind === "list-item") {
				const listItem = fragment;
				if (listItem.continuesFromPrev != null) item.continuesFromPrev = listItem.continuesFromPrev;
				if (listItem.continuesOnNext != null) item.continuesOnNext = listItem.continuesOnNext;
				if (listItem.markerWidth != null) item.markerWidth = listItem.markerWidth;
			}
			applyPaintVersions(item, itemVersion);
			return item;
		}
	}
}
function resolveLayout(input) {
	const { layout, flowMode, blocks, measures, bookmarks } = input;
	const fontSignature = input.fontSignature ?? "";
	const blockMap = buildBlockMap(blocks, measures);
	const blockVersionCache = /* @__PURE__ */ new Map();
	const pageRefAnchorMap = bookmarks?.size ? buildPageRefAnchorMap(bookmarks, layout, blocks, measures) : void 0;
	const pages = layout.pages.map((page, pageIndex) => ({
		id: `page-${pageIndex}`,
		index: pageIndex,
		columns: page.columns,
		columnRegions: page.columnRegions,
		number: page.number,
		width: page.size?.w ?? layout.pageSize.w,
		height: page.size?.h ?? layout.pageSize.h,
		items: page.fragments.map((fragment, fragmentIndex) => resolveFragmentItem(fragment, fragmentIndex, pageIndex, blockMap, blockVersionCache, void 0, fontSignature, pageRefAnchorMap ? {
			sourcePage: page.number,
			anchorMap: pageRefAnchorMap
		} : void 0)),
		margins: page.margins,
		footnoteReserved: page.footnoteReserved,
		displayNumber: page.displayNumber,
		numberText: page.numberText,
		effectivePageNumber: page.effectivePageNumber,
		pageNumberFormat: page.pageNumberFormat,
		pageNumberChapterText: page.pageNumberChapterText,
		pageNumberChapterSeparator: page.pageNumberChapterSeparator,
		vAlign: page.vAlign,
		baseMargins: page.baseMargins,
		sectionIndex: page.sectionIndex,
		sectionRefs: page.sectionRefs,
		orientation: page.orientation
	}));
	const resolved = {
		version: 1,
		flowMode,
		pageGap: layout.pageGap ?? 0,
		pages,
		...layout.documentBackground ? { documentBackground: layout.documentBackground } : {}
	};
	if (blocks.length > 0) resolved.blockVersions = Object.fromEntries(blocks.map((block) => [block.id, computeBlockVersion(block.id, blockMap, blockVersionCache, fontSignature)]));
	if (layout.layoutEpoch != null) resolved.layoutEpoch = layout.layoutEpoch;
	return resolved;
}
function resolveHeaderFooterLayout(layout, blocks, measures, story, fontSignature = "") {
	const pages = layout.pages.map((page) => {
		const blockMap = buildBlockMap(page.blocks ?? blocks, page.measures ?? measures);
		const blockVersionCache = /* @__PURE__ */ new Map();
		return {
			number: page.number,
			displayNumber: page.displayNumber,
			numberText: page.numberText,
			pageNumberFormat: page.pageNumberFormat,
			pageNumberChapterText: page.pageNumberChapterText,
			pageNumberChapterSeparator: page.pageNumberChapterSeparator,
			items: page.fragments.map((fragment, fragmentIndex) => resolveFragmentItem(fragment, fragmentIndex, page.number - 1, blockMap, blockVersionCache, story, fontSignature))
		};
	});
	return {
		height: layout.height,
		minY: layout.minY,
		maxY: layout.maxY,
		renderHeight: layout.renderHeight,
		pages
	};
}
function createFloatingObjectManager(columns, margins, pageWidth) {
	const zones = [];
	let currentColumns = columns;
	let currentMargins = margins;
	let currentPageWidth = pageWidth;
	let marginLeft = Math.max(0, currentMargins?.left ?? 0);
	return {
		registerDrawing(drawingBlock, measure, resolvedAnchorY, columnIndex, pageNumber) {
			if (!drawingBlock.anchor?.isAnchored) return;
			const { wrap, anchor } = drawingBlock;
			const wrapType = wrap?.type ?? "Inline";
			if (wrapType === "Inline" || wrapType === "None") return;
			const objectWidth = measure.width ?? 0;
			const objectHeight = measure.height ?? 0;
			const x = computeAnchorX(anchor, columnIndex, currentColumns, objectWidth, currentMargins, currentPageWidth);
			const zone = {
				imageBlockId: drawingBlock.id,
				pageNumber,
				columnIndex,
				bounds: {
					x,
					y: resolvedAnchorY,
					width: objectWidth,
					height: objectHeight
				},
				distances: {
					top: wrap?.distTop ?? 0,
					bottom: wrap?.distBottom ?? 0,
					left: wrap?.distLeft ?? 0,
					right: wrap?.distRight ?? 0
				},
				wrapMode: computeWrapMode(wrap, anchor),
				polygon: wrap?.polygon
			};
			zones.push(zone);
		},
		registerTable(tableBlock, measure, resolvedAnchorY, columnIndex, pageNumber) {
			if (!tableBlock.anchor?.isAnchored) return;
			const { wrap, anchor } = tableBlock;
			if ((wrap?.type ?? "None") === "None") return;
			const tableWidth = measure.totalWidth ?? 0;
			const tableHeight = measure.totalHeight ?? 0;
			const x = computeTableAnchorX(anchor, columnIndex, currentColumns, tableWidth, currentMargins, currentPageWidth);
			const zone = {
				imageBlockId: tableBlock.id,
				pageNumber,
				columnIndex,
				bounds: {
					x,
					y: resolvedAnchorY,
					width: tableWidth,
					height: tableHeight
				},
				distances: {
					top: wrap?.distTop ?? 0,
					bottom: wrap?.distBottom ?? 0,
					left: wrap?.distLeft ?? 0,
					right: wrap?.distRight ?? 0
				},
				wrapMode: computeTableWrapMode(wrap)
			};
			zones.push(zone);
		},
		getExclusionsForLine(lineY, lineHeight, columnIndex, pageNumber) {
			return zones.filter((zone) => {
				if (zone.pageNumber !== pageNumber || zone.columnIndex !== columnIndex) return false;
				const lineTop = lineY;
				const lineBottom = lineY + lineHeight;
				const zoneTop = zone.bounds.y - zone.distances.top;
				const zoneBottom = zone.bounds.y + zone.bounds.height + zone.distances.bottom;
				return lineBottom > zoneTop && lineTop < zoneBottom;
			});
		},
		computeAvailableWidth(lineY, lineHeight, baseWidth, columnIndex, pageNumber) {
			const exclusions = this.getExclusionsForLine(lineY, lineHeight, columnIndex, pageNumber);
			if (exclusions.length === 0) return {
				width: baseWidth,
				offsetX: 0
			};
			const wrappingZones = exclusions.filter((zone) => zone.wrapMode !== "none");
			if (wrappingZones.length === 0) return {
				width: baseWidth,
				offsetX: 0
			};
			const leftFloats = [];
			const rightFloats = [];
			const columnOrigin = getColumnX(getColumnGeometry(currentColumns), columnIndex, marginLeft);
			const columnCenter = columnOrigin + baseWidth / 2;
			for (const zone of wrappingZones) if (zone.wrapMode === "left") leftFloats.push(zone);
			else if (zone.wrapMode === "right") rightFloats.push(zone);
			else if (zone.wrapMode === "both" || zone.wrapMode === "largest") if (zone.bounds.x + zone.bounds.width / 2 < columnCenter) leftFloats.push(zone);
			else rightFloats.push(zone);
			let leftBoundary = 0;
			for (const zone of leftFloats) {
				const boundary = zone.bounds.x + zone.bounds.width + zone.distances.right;
				leftBoundary = Math.max(leftBoundary, boundary);
			}
			let rightBoundary = columnOrigin + baseWidth;
			for (const zone of rightFloats) {
				const boundary = zone.bounds.x - zone.distances.left;
				rightBoundary = Math.min(rightBoundary, boundary);
			}
			const availableWidth = rightBoundary - leftBoundary;
			const offsetX = Math.max(0, leftBoundary - columnOrigin);
			if (availableWidth <= 0) return {
				width: 1,
				offsetX: 0
			};
			return {
				width: availableWidth,
				offsetX
			};
		},
		getAllFloatsForPage(pageNumber) {
			return zones.filter((z$1) => z$1.pageNumber === pageNumber);
		},
		clear() {
			zones.length = 0;
		},
		setLayoutContext(nextColumns, nextMargins, nextPageWidth) {
			currentColumns = nextColumns;
			currentMargins = nextMargins;
			currentPageWidth = nextPageWidth;
			marginLeft = Math.max(0, currentMargins?.left ?? 0);
		}
	};
}
function computeAnchorX(anchor, columnIndex, columns, imageWidth, margins, pageWidth) {
	return resolveAnchoredGraphicX(anchor, columnIndex, columns, imageWidth, margins, pageWidth);
}
function computeWrapMode(wrap, _anchor) {
	if (!wrap) return "none";
	const wrapText = wrap.wrapText ?? "bothSides";
	if (wrap.type === "TopAndBottom") return "none";
	if (wrapText === "left") return "right";
	if (wrapText === "right") return "left";
	if (wrapText === "largest") return "largest";
	return "both";
}
function computeTableAnchorX(anchor, columnIndex, columns, tableWidth, margins, pageWidth) {
	const alignH = anchor.alignH ?? "left";
	const offsetH = anchor.offsetH ?? 0;
	const marginLeft = Math.max(0, margins?.left ?? 0);
	const marginRight = Math.max(0, margins?.right ?? 0);
	const contentWidth = pageWidth != null ? Math.max(1, pageWidth - (marginLeft + marginRight)) : columns.width;
	const contentLeft = marginLeft;
	const columnLeft = getColumnX(getColumnGeometry(columns), columnIndex, contentLeft);
	const relativeFrom = anchor.hRelativeFrom ?? "column";
	let baseX;
	let availableWidth;
	if (relativeFrom === "page") if (columns.count === 1) {
		baseX = contentLeft;
		availableWidth = contentWidth;
	} else {
		baseX = 0;
		availableWidth = pageWidth != null ? pageWidth : contentWidth;
	}
	else if (relativeFrom === "margin") {
		baseX = contentLeft;
		availableWidth = contentWidth;
	} else {
		baseX = columnLeft;
		availableWidth = columns.width;
	}
	let effectiveAlignH = alignH;
	if (alignH === "inside") effectiveAlignH = "left";
	if (alignH === "outside") effectiveAlignH = "right";
	return effectiveAlignH === "left" ? baseX + offsetH : effectiveAlignH === "right" ? baseX + availableWidth - tableWidth - offsetH : effectiveAlignH === "center" ? baseX + (availableWidth - tableWidth) / 2 + offsetH : baseX;
}
function computeTableWrapMode(wrap) {
	if (!wrap) return "none";
	if (wrap.type === "None") return "none";
	const wrapText = wrap.wrapText ?? "bothSides";
	if (wrapText === "left") return "right";
	if (wrapText === "right") return "left";
	if (wrapText === "largest") return "largest";
	return "both";
}
var snapshotColumns = (columns) => {
	if (!columns) return void 0;
	return cloneColumnLayout(columns);
};
function computeNextSectionPropsAtBreak(blocks) {
	const nextSectionPropsAtBreak = /* @__PURE__ */ new Map();
	const docxBreakIndexes = [];
	for (let i = 0; i < blocks.length; i += 1) {
		const block = blocks[i];
		if (!block || block.kind !== "sectionBreak") continue;
		if (block.attrs?.source !== "sectPr") continue;
		docxBreakIndexes.push(i);
	}
	const snapshotProps = (source) => {
		const props = {};
		if (source.kind !== "sectionBreak") return props;
		if (source.margins) props.margins = {
			header: source.margins.header,
			footer: source.margins.footer,
			top: source.margins.top,
			right: source.margins.right,
			bottom: source.margins.bottom,
			left: source.margins.left
		};
		if (source.pageSize) props.pageSize = {
			w: source.pageSize.w,
			h: source.pageSize.h
		};
		if (source.columns) props.columns = snapshotColumns(source.columns);
		if (source.orientation) props.orientation = source.orientation;
		if (source.vAlign) props.vAlign = source.vAlign;
		return props;
	};
	docxBreakIndexes.forEach((index, ordinal) => {
		const current = blocks[index];
		const nextIndex = docxBreakIndexes[ordinal + 1];
		const source = current?.kind === "sectionBreak" && current.attrs?.isFirstSection || typeof nextIndex !== "number" ? current : blocks[nextIndex];
		nextSectionPropsAtBreak.set(index, snapshotProps(source));
	});
	return nextSectionPropsAtBreak;
}
const SINGLE_COLUMN_DEFAULT = {
	count: 1,
	gap: 0
};
function getColumnConfig(blockColumns) {
	return blockColumns ? cloneColumnLayout(blockColumns) : { ...SINGLE_COLUMN_DEFAULT };
}
function isColumnConfigChanging(blockColumns, activeColumns) {
	if (blockColumns) return !columnRenderLayoutsEqual(blockColumns, activeColumns);
	return resolveColumnCount(activeColumns) > 1 || Boolean(activeColumns.withSeparator);
}
function scheduleSectionBreak(block, state, baseMargins, maxHeaderContentHeight = 0, maxFooterContentHeight = 0) {
	const next = { ...state };
	const calcRequiredTopMargin = (headerDistance, baseTop) => {
		if (maxHeaderContentHeight > 0) return Math.max(baseTop, headerDistance + maxHeaderContentHeight);
		return baseTop;
	};
	const calcRequiredBottomMargin = (footerDistance, baseBottom) => {
		if (maxFooterContentHeight > 0) return Math.max(baseBottom, footerDistance + maxFooterContentHeight);
		return baseBottom;
	};
	if (block.attrs?.isFirstSection && !next.hasAnyPages) {
		if (block.pageSize) {
			next.activePageSize = {
				w: block.pageSize.w,
				h: block.pageSize.h
			};
			next.pendingPageSize = null;
		}
		if (block.orientation) {
			next.activeOrientation = block.orientation;
			next.pendingOrientation = null;
		}
		const headerDistance = typeof block.margins?.header === "number" ? Math.max(0, block.margins.header) : next.activeHeaderDistance;
		const footerDistance = typeof block.margins?.footer === "number" ? Math.max(0, block.margins.footer) : next.activeFooterDistance;
		const sectionTop = typeof block.margins?.top === "number" ? Math.max(0, block.margins.top) : baseMargins.top;
		const sectionBottom = typeof block.margins?.bottom === "number" ? Math.max(0, block.margins.bottom) : baseMargins.bottom;
		if (block.margins?.header !== void 0) {
			next.activeHeaderDistance = headerDistance;
			next.pendingHeaderDistance = headerDistance;
		}
		if (block.margins?.footer !== void 0) {
			next.activeFooterDistance = footerDistance;
			next.pendingFooterDistance = footerDistance;
		}
		if (block.margins?.top !== void 0 || block.margins?.header !== void 0) {
			next.activeTopMargin = calcRequiredTopMargin(headerDistance, sectionTop);
			next.pendingTopMargin = next.activeTopMargin;
		}
		if (block.margins?.bottom !== void 0 || block.margins?.footer !== void 0) {
			next.activeBottomMargin = calcRequiredBottomMargin(footerDistance, sectionBottom);
			next.pendingBottomMargin = next.activeBottomMargin;
		}
		if (block.margins?.left !== void 0) {
			const leftMargin = Math.max(0, block.margins.left);
			next.activeLeftMargin = leftMargin;
			next.pendingLeftMargin = leftMargin;
		}
		if (block.margins?.right !== void 0) {
			const rightMargin = Math.max(0, block.margins.right);
			next.activeRightMargin = rightMargin;
			next.pendingRightMargin = rightMargin;
		}
		next.activeColumns = getColumnConfig(block.columns);
		next.pendingColumns = null;
		return {
			decision: {
				forcePageBreak: false,
				forceMidPageRegion: false
			},
			state: next
		};
	}
	const headerPx = block.margins?.header;
	const footerPx = block.margins?.footer;
	const topPx = block.margins?.top;
	const bottomPx = block.margins?.bottom;
	const nextTop = next.pendingTopMargin ?? next.activeTopMargin;
	const nextBottom = next.pendingBottomMargin ?? next.activeBottomMargin;
	const nextLeft = next.pendingLeftMargin ?? next.activeLeftMargin;
	const nextRight = next.pendingRightMargin ?? next.activeRightMargin;
	const nextHeader = next.pendingHeaderDistance ?? next.activeHeaderDistance;
	const nextFooter = next.pendingFooterDistance ?? next.activeFooterDistance;
	if (typeof headerPx === "number" || typeof topPx === "number") {
		const newHeaderDist = typeof headerPx === "number" ? Math.max(0, headerPx) : nextHeader;
		const sectionTop = typeof topPx === "number" ? Math.max(0, topPx) : baseMargins.top;
		next.pendingHeaderDistance = newHeaderDist;
		next.pendingTopMargin = calcRequiredTopMargin(newHeaderDist, sectionTop);
	} else {
		next.pendingTopMargin = nextTop;
		next.pendingHeaderDistance = nextHeader;
	}
	if (typeof footerPx === "number" || typeof bottomPx === "number") {
		const newFooterDist = typeof footerPx === "number" ? Math.max(0, footerPx) : nextFooter;
		const sectionBottom = typeof bottomPx === "number" ? Math.max(0, bottomPx) : baseMargins.bottom;
		next.pendingFooterDistance = newFooterDist;
		next.pendingBottomMargin = calcRequiredBottomMargin(newFooterDist, sectionBottom);
	} else {
		next.pendingBottomMargin = nextBottom;
		next.pendingFooterDistance = nextFooter;
	}
	if (typeof block.margins?.left === "number") next.pendingLeftMargin = Math.max(0, block.margins.left);
	else next.pendingLeftMargin = nextLeft;
	if (typeof block.margins?.right === "number") next.pendingRightMargin = Math.max(0, block.margins.right);
	else next.pendingRightMargin = nextRight;
	if (block.pageSize) next.pendingPageSize = {
		w: block.pageSize.w,
		h: block.pageSize.h
	};
	if (block.orientation) next.pendingOrientation = block.orientation;
	const sectionType = block.type ?? "continuous";
	const isColumnsChanging = isColumnConfigChanging(block.columns, next.activeColumns);
	if (block.attrs?.requirePageBoundary) {
		next.pendingColumns = getColumnConfig(block.columns);
		return {
			decision: {
				forcePageBreak: true,
				forceMidPageRegion: false
			},
			state: next
		};
	}
	switch (sectionType) {
		case "nextPage":
			next.pendingColumns = getColumnConfig(block.columns);
			return {
				decision: {
					forcePageBreak: true,
					forceMidPageRegion: false
				},
				state: next
			};
		case "evenPage":
			next.pendingColumns = getColumnConfig(block.columns);
			return {
				decision: {
					forcePageBreak: true,
					forceMidPageRegion: false,
					requiredParity: "even"
				},
				state: next
			};
		case "oddPage":
			next.pendingColumns = getColumnConfig(block.columns);
			return {
				decision: {
					forcePageBreak: true,
					forceMidPageRegion: false,
					requiredParity: "odd"
				},
				state: next
			};
		case "continuous":
		default:
			if (isColumnsChanging) {
				next.pendingColumns = getColumnConfig(block.columns);
				return {
					decision: {
						forcePageBreak: false,
						forceMidPageRegion: true
					},
					state: next
				};
			}
			next.pendingColumns = getColumnConfig(block.columns);
			return {
				decision: {
					forcePageBreak: false,
					forceMidPageRegion: false
				},
				state: next
			};
	}
}
function applyPendingToActive(state) {
	const next = { ...state };
	if (next.pendingTopMargin != null) next.activeTopMargin = next.pendingTopMargin;
	if (next.pendingBottomMargin != null) next.activeBottomMargin = next.pendingBottomMargin;
	if (next.pendingLeftMargin != null) next.activeLeftMargin = next.pendingLeftMargin;
	if (next.pendingRightMargin != null) next.activeRightMargin = next.pendingRightMargin;
	if (next.pendingHeaderDistance != null) next.activeHeaderDistance = next.pendingHeaderDistance;
	if (next.pendingFooterDistance != null) next.activeFooterDistance = next.pendingFooterDistance;
	if (next.pendingPageSize != null) next.activePageSize = next.pendingPageSize;
	if (next.pendingColumns != null) next.activeColumns = next.pendingColumns;
	if (next.pendingOrientation != null) next.activeOrientation = next.pendingOrientation;
	next.pendingTopMargin = null;
	next.pendingBottomMargin = null;
	next.pendingLeftMargin = null;
	next.pendingRightMargin = null;
	next.pendingHeaderDistance = null;
	next.pendingFooterDistance = null;
	next.pendingPageSize = null;
	next.pendingColumns = null;
	next.pendingOrientation = null;
	return next;
}
var isTextRun$4 = (run) => {
	const runWithKind = run;
	return !runWithKind.kind || runWithKind.kind === "text";
};
const isEmptyTextParagraph = (block) => {
	const runs = block.runs;
	if (!runs || runs.length === 0) return true;
	if (runs.length !== 1) return false;
	const run = runs[0];
	if (!isTextRun$4(run)) return false;
	return typeof run.text === "string" && run.text.length === 0;
};
const shouldSuppressSpacingForEmpty = (block, side) => {
	if (!isEmptyTextParagraph(block)) return false;
	const spacingExplicit = block.attrs?.spacingExplicit;
	if (!spacingExplicit) return false;
	if (side === "before") return !spacingExplicit.before;
	return !spacingExplicit.after;
};
function normalizeLines(measure) {
	if (measure.lines.length > 0) return measure.lines;
	return [{
		fromRun: 0,
		fromChar: 0,
		toRun: 0,
		toChar: 0,
		width: 0,
		ascent: 0,
		descent: 0,
		lineHeight: measure.totalHeight || 0
	}];
}
const computeFragmentPmRange = (block, lines, fromLine, toLine) => computeFragmentPmRange$1(block, lines, fromLine, toLine);
function shouldSuppressOwnSpacing(ownStyleId, ownContextualSpacing, adjacentStyleId) {
	return ownContextualSpacing && !!ownStyleId && !!adjacentStyleId && ownStyleId === adjacentStyleId;
}
function collapseSpacingBefore(spacingBefore, trailingSpacing) {
	const prevTrailing = trailingSpacing ?? 0;
	return Math.max(spacingBefore - prevTrailing, 0);
}
function rewindPreviousParagraphTrailing(cursorY, trailingSpacing) {
	const prevTrailing = trailingSpacing ?? 0;
	return prevTrailing > 0 ? cursorY - prevTrailing : cursorY;
}
function computeParagraphContentStartY(cursorY, spacingBefore, appliedSpacingBefore, trailingSpacing) {
	if (appliedSpacingBefore || spacingBefore <= 0) return cursorY;
	return cursorY + collapseSpacingBefore(spacingBefore, trailingSpacing);
}
function computeParagraphLayoutStartY(input) {
	let y$1 = input.cursorY;
	let trailingForCollapse = input.trailingSpacing;
	if (input.rewindTrailingFromPrevious) {
		y$1 = rewindPreviousParagraphTrailing(y$1, input.trailingSpacing);
		if ((input.trailingSpacing ?? 0) > 0) trailingForCollapse = 0;
	}
	const effectiveSpacingBefore = input.suppressSpacingBefore ? 0 : input.spacingBefore;
	return computeParagraphContentStartY(y$1, effectiveSpacingBefore, effectiveSpacingBefore === 0, trailingForCollapse);
}
const extractBlockPmRange = (block) => {
	if (!block || !block.attrs) return {};
	const attrs = block.attrs;
	const start$1 = typeof attrs.pmStart === "number" ? attrs.pmStart : void 0;
	return {
		pmStart: start$1,
		pmEnd: (typeof attrs.pmEnd === "number" ? attrs.pmEnd : void 0) ?? (start$1 != null ? start$1 + 1 : void 0)
	};
};
function layoutTextboxContent(block, remeasureParagraph$1) {
	if (!Array.isArray(block.contentBlocks) || block.contentBlocks.length === 0) return [];
	const insets = block.textInsets ?? {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0
	};
	const contentWidth = Math.max(1, block.geometry.width - insets.left - insets.right);
	return block.contentBlocks.map((paragraphBlock) => remeasureParagraph$1(paragraphBlock, contentWidth));
}
function describeCellRenderBlocks(cellMeasure, cellBlock, cellPadding) {
	const measuredBlocks = cellMeasure.blocks;
	const blockDataArray = cellBlock?.blocks;
	if (!measuredBlocks || measuredBlocks.length === 0) {
		if (cellMeasure.paragraph) return buildSingleParagraphBlock(cellMeasure.paragraph, cellBlock?.paragraph, cellPadding);
		return [];
	}
	const result = [];
	let globalLine = 0;
	const blockCount = measuredBlocks.length;
	for (let i = 0; i < blockCount; i++) {
		const measure = measuredBlocks[i];
		const data = i < (blockDataArray?.length ?? 0) ? blockDataArray[i] : void 0;
		const isFirstBlock = i === 0;
		const isLastBlock = i === blockCount - 1;
		if (measure.kind === "paragraph") {
			const paraMeasure = measure;
			const paraData = data?.kind === "paragraph" ? data : void 0;
			const lines = paraMeasure.lines ?? [];
			const lineHeights = lines.map((l) => l.lineHeight);
			const sumLines = sumArray(lineHeights);
			const spacingBefore = effectiveTableCellSpacing(paraData?.attrs?.spacing?.before, isFirstBlock, cellPadding.top);
			const rawAfter = paraData?.attrs?.spacing?.after;
			const spacingAfter = isLastBlock ? 0 : typeof rawAfter === "number" && rawAfter > 0 ? rawAfter : 0;
			const startLine = globalLine;
			globalLine += lines.length;
			result.push({
				kind: "paragraph",
				globalStartLine: startLine,
				globalEndLine: globalLine,
				lineHeights,
				totalHeight: paraMeasure.totalHeight ?? sumLines,
				visibleHeight: sumLines,
				isFirstBlock,
				isLastBlock,
				spacingBefore,
				spacingAfter
			});
		} else if (measure.kind === "table") {
			const tableMeasure = measure;
			const lineHeights = [];
			for (const row of tableMeasure.rows) for (const seg of getEmbeddedRowLines(row)) lineHeights.push(seg.lineHeight);
			const startLine = globalLine;
			globalLine += lineHeights.length;
			const sumLines = sumArray(lineHeights);
			result.push({
				kind: "table",
				globalStartLine: startLine,
				globalEndLine: globalLine,
				lineHeights,
				totalHeight: sumLines,
				visibleHeight: sumLines,
				isFirstBlock,
				isLastBlock,
				spacingBefore: 0,
				spacingAfter: 0
			});
		} else {
			const blockHeight = "height" in measure ? measure.height : 0;
			if (blockHeight > 0) {
				const outOfFlow = isAnchoredOutOfFlow(data);
				const startLine = globalLine;
				globalLine += 1;
				result.push({
					kind: "other",
					globalStartLine: startLine,
					globalEndLine: globalLine,
					lineHeights: [blockHeight],
					totalHeight: outOfFlow ? 0 : blockHeight,
					visibleHeight: outOfFlow ? 0 : blockHeight,
					isFirstBlock,
					isLastBlock,
					spacingBefore: 0,
					spacingAfter: 0
				});
			}
		}
	}
	return result;
}
function computeCellSliceContentHeight(blocks, fromLine, toLine) {
	let height = 0;
	for (const block of blocks) {
		if (block.globalEndLine <= fromLine || block.globalStartLine >= toLine) continue;
		const localStart = Math.max(0, fromLine - block.globalStartLine);
		const localEnd = Math.min(block.lineHeights.length, toLine - block.globalStartLine);
		const rendersEntireBlock = localStart === 0 && localEnd >= block.lineHeights.length;
		if (block.kind === "paragraph") {
			if (localStart === 0) height += block.spacingBefore;
			let sliceLineSum = 0;
			for (let i = localStart; i < localEnd; i++) sliceLineSum += block.lineHeights[i];
			if (rendersEntireBlock) {
				height += Math.max(sliceLineSum, block.totalHeight);
				height += block.spacingAfter;
			} else height += sliceLineSum;
		} else {
			if (block.visibleHeight === 0) continue;
			for (let i = localStart; i < localEnd; i++) height += block.lineHeights[i];
		}
	}
	return height;
}
function createCellSliceCursor(blocks, startLine) {
	let blockIdx = 0;
	let startedFromLine0 = false;
	let blockLineSum = 0;
	while (blockIdx < blocks.length && blocks[blockIdx].globalEndLine <= startLine) blockIdx++;
	if (blockIdx < blocks.length) {
		const block = blocks[blockIdx];
		startedFromLine0 = startLine <= block.globalStartLine;
		if (!startedFromLine0) for (let li = 0; li < startLine - block.globalStartLine; li++) blockLineSum += block.lineHeights[li] ?? 0;
	}
	return {
		advanceLine(globalLineIndex) {
			while (blockIdx < blocks.length && blocks[blockIdx].globalEndLine <= globalLineIndex) {
				blockIdx++;
				startedFromLine0 = true;
				blockLineSum = 0;
			}
			if (blockIdx >= blocks.length) return 0;
			const block = blocks[blockIdx];
			const localLine = globalLineIndex - block.globalStartLine;
			const lineHeight = block.lineHeights[localLine] ?? 0;
			let cost = 0;
			if (localLine === 0 && startedFromLine0 && block.kind === "paragraph") cost += block.spacingBefore;
			if (block.kind === "paragraph" || block.visibleHeight > 0) cost += lineHeight;
			blockLineSum += lineHeight;
			const isBlockComplete = localLine === block.lineHeights.length - 1;
			if (isBlockComplete && startedFromLine0 && block.kind === "paragraph") {
				cost += Math.max(0, block.totalHeight - blockLineSum);
				cost += block.spacingAfter;
			}
			if (isBlockComplete) {
				blockIdx++;
				startedFromLine0 = true;
				blockLineSum = 0;
			}
			return cost;
		},
		minSegmentCost(globalLineIndex) {
			const block = findBlockForLine(blocks, globalLineIndex);
			if (!block) return 0;
			const localLine = globalLineIndex - block.globalStartLine;
			const lineHeight = block.lineHeights[localLine] ?? 0;
			let cost = 0;
			if (localLine === 0 && block.kind === "paragraph") cost += block.spacingBefore;
			if (block.kind === "paragraph" || block.visibleHeight > 0) cost += lineHeight;
			if (block.lineHeights.length === 1 && block.kind === "paragraph") {
				cost += Math.max(0, block.totalHeight - lineHeight);
				cost += block.spacingAfter;
			}
			return cost;
		}
	};
}
function computeFullCellContentHeight(cellMeasure, cellBlock, cellPadding) {
	const measuredBlocks = cellMeasure.blocks;
	const blockDataArray = cellBlock?.blocks;
	if (!measuredBlocks || measuredBlocks.length === 0) {
		if (cellMeasure.paragraph) {
			const pm = cellMeasure.paragraph;
			let sumLines = 0;
			for (const l of pm.lines) sumLines += l.lineHeight;
			const paraData = cellBlock?.paragraph;
			const spacingBefore = effectiveTableCellSpacing(paraData?.attrs?.spacing?.before, true, cellPadding.top);
			const spacingAfter = effectiveTableCellSpacing(paraData?.attrs?.spacing?.after, true, cellPadding.bottom);
			return spacingBefore + Math.max(sumLines, pm.totalHeight ?? sumLines) + spacingAfter;
		}
		return 0;
	}
	let height = 0;
	const blockCount = measuredBlocks.length;
	for (let i = 0; i < blockCount; i++) {
		const measure = measuredBlocks[i];
		const data = i < (blockDataArray?.length ?? 0) ? blockDataArray[i] : void 0;
		const isFirstBlock = i === 0;
		const isLastBlock = i === blockCount - 1;
		if (measure.kind === "paragraph") {
			const pm = measure;
			const paraData = data?.kind === "paragraph" ? data : void 0;
			let sumLines = 0;
			for (const l of pm.lines ?? []) sumLines += l.lineHeight;
			height += effectiveTableCellSpacing(paraData?.attrs?.spacing?.before, isFirstBlock, cellPadding.top);
			height += Math.max(sumLines, pm.totalHeight ?? sumLines);
			if (!isLastBlock) {
				const rawAfter = paraData?.attrs?.spacing?.after;
				if (typeof rawAfter === "number" && rawAfter > 0) height += rawAfter;
			} else height += effectiveTableCellSpacing(paraData?.attrs?.spacing?.after, true, cellPadding.bottom);
		} else if (measure.kind === "table") {
			const tm = measure;
			for (const row of tm.rows) height += row.height;
		} else {
			const blockHeight = "height" in measure ? measure.height : 0;
			if (blockHeight > 0 && !isAnchoredOutOfFlow(data)) height += blockHeight;
		}
	}
	return height;
}
function buildSingleParagraphBlock(paraMeasure, paraData, cellPadding) {
	const lines = paraMeasure.lines ?? [];
	if (lines.length === 0) return [];
	const lineHeights = lines.map((l) => l.lineHeight);
	const sumLines = sumArray(lineHeights);
	return [{
		kind: "paragraph",
		globalStartLine: 0,
		globalEndLine: lines.length,
		lineHeights,
		totalHeight: paraMeasure.totalHeight ?? sumLines,
		visibleHeight: sumLines,
		isFirstBlock: true,
		isLastBlock: true,
		spacingBefore: effectiveTableCellSpacing(paraData?.attrs?.spacing?.before, true, cellPadding.top),
		spacingAfter: 0
	}];
}
function isAnchoredOutOfFlow(block) {
	if (!block || typeof block !== "object") return false;
	const b$1 = block;
	if (!b$1.anchor?.isAnchored) return false;
	return (b$1.wrap?.type ?? "Inline") !== "Inline";
}
function findBlockForLine(blocks, globalLineIndex) {
	for (const block of blocks) if (globalLineIndex >= block.globalStartLine && globalLineIndex < block.globalEndLine) return block;
}
function sumArray(arr) {
	let total = 0;
	for (const v of arr) total += v;
	return total;
}
const ANCHORED_TABLE_FULL_WIDTH_RATIO = .99;
function runText$1(run) {
	if (run.kind != null && run.kind !== "text") return "";
	return "text" in run && typeof run.text === "string" ? run.text : "";
}
function paragraphText(block) {
	return block.runs?.map(runText$1).join("") ?? "";
}
function paragraphMeasureAt(blocks, measures, index) {
	const block = blocks[index];
	const measure = measures[index];
	if (block?.kind !== "paragraph" || measure?.kind !== "paragraph") return null;
	return measure;
}
function paragraphFirstLineHeight(blocks, measures, index) {
	const measure = paragraphMeasureAt(blocks, measures, index);
	if (!measure) return 0;
	const firstLine = measure.lines?.[0];
	if (firstLine?.lineHeight != null && firstLine.lineHeight > 0) return firstLine.lineHeight;
	return measure.totalHeight ?? 0;
}
function isSingleLineParagraph(blocks, measures, index) {
	const measure = paragraphMeasureAt(blocks, measures, index);
	if (!measure) return false;
	const lineCount = measure.lines?.length ?? 0;
	if (lineCount === 1) return true;
	return lineCount === 0 && (measure.totalHeight ?? 0) > 0;
}
function isTextEmptyParagraph(blocks, index) {
	const block = blocks[index];
	if (block.kind !== "paragraph") return false;
	return paragraphText(block).trim().length === 0;
}
function findPreviousParagraphIndex(blocks, fromIndex) {
	for (let i = fromIndex - 1; i >= 0; i -= 1) if (blocks[i].kind === "paragraph") return i;
	return null;
}
function findNextParagraphIndex(blocks, fromIndex, len) {
	for (let i = fromIndex + 1; i < len; i += 1) if (blocks[i].kind === "paragraph") return i;
	return null;
}
function findNearestParagraphIndex$1(blocks, len, fromIndex) {
	return findPreviousParagraphIndex(blocks, fromIndex) ?? findNextParagraphIndex(blocks, fromIndex, len);
}
function paragraphMeasureHeight(measures, index) {
	const measure = measures[index];
	if (measure?.kind !== "paragraph") return 0;
	return measure.totalHeight ?? 0;
}
function isLineScopedTblpY$1(blocks, measures, paragraphIndex, offsetV) {
	const lineHeight = paragraphFirstLineHeight(blocks, measures, paragraphIndex);
	if (lineHeight <= 0) return offsetV <= 1;
	return offsetV <= lineHeight * 1.5;
}
function isMultiLineParagraph(blocks, measures, index) {
	const measure = paragraphMeasureAt(blocks, measures, index);
	if (!measure) return false;
	return (measure.lines?.length ?? 0) > 1;
}
function findForwardCompactOptionLine(blocks, measures, len, tableIndex) {
	for (let i = tableIndex + 1; i < len; i += 1) {
		if (blocks[i].kind !== "paragraph") continue;
		if (isTextEmptyParagraph(blocks, i)) continue;
		if (!isSingleLineParagraph(blocks, measures, i)) continue;
		const height = paragraphMeasureHeight(measures, i);
		const lineH = paragraphFirstLineHeight(blocks, measures, i);
		if (height <= 0 || lineH <= 0 || height > lineH * 1.25) continue;
		const prevIndex = findPreviousParagraphIndex(blocks, i);
		if (prevIndex == null) continue;
		if (isMultiLineParagraph(blocks, measures, prevIndex)) return i;
		if (isCompactOptionLineAfterBody(blocks, measures, i, prevIndex)) return i;
	}
	return null;
}
function isCompactOptionLineAfterBody(blocks, measures, optionIndex, bodyIndex) {
	if (bodyIndex == null) return false;
	if (!isSingleLineParagraph(blocks, measures, optionIndex)) return false;
	const optionHeight = paragraphMeasureHeight(measures, optionIndex);
	const optionLine = paragraphFirstLineHeight(blocks, measures, optionIndex);
	if (optionHeight <= 0 || optionLine <= 0 || optionHeight > optionLine * 1.25) return false;
	return paragraphMeasureHeight(measures, bodyIndex) > optionHeight * 1.5;
}
function resolutionWithLineScopedFlag(blocks, measures, paragraphIndex, offsetV, rawOffsetV, forwardResolved = false) {
	return {
		paragraphIndex,
		offsetV,
		lineScopedOnAnchor: !forwardResolved && offsetV === rawOffsetV && isLineScopedTblpY$1(blocks, measures, paragraphIndex, offsetV) && !isTextEmptyParagraph(blocks, paragraphIndex)
	};
}
function paintOffsetThroughAnchorParagraphs(blocks, measures, len, tableIndex, anchorParagraphIndex, rawOffsetV) {
	let consumed = 0;
	let index = findNextParagraphIndex(blocks, tableIndex, len);
	while (index != null && index <= anchorParagraphIndex) {
		consumed += paragraphMeasureHeight(measures, index);
		if (index === anchorParagraphIndex) break;
		index = findNextParagraphIndex(blocks, index, len);
	}
	return Math.max(0, rawOffsetV - consumed);
}
function resolveForwardParagraphByTblpY(blocks, measures, len, tableIndex, offsetV) {
	if (offsetV <= 0) return null;
	let remaining = offsetV;
	let index = findNextParagraphIndex(blocks, tableIndex, len);
	while (index != null) {
		if (blocks[index].kind !== "paragraph") {
			index = findNextParagraphIndex(blocks, index, len);
			continue;
		}
		const height = paragraphMeasureHeight(measures, index);
		if (height <= 0) {
			index = findNextParagraphIndex(blocks, index, len);
			continue;
		}
		const lineHeight = paragraphFirstLineHeight(blocks, measures, index);
		if (remaining <= height + 1) return {
			paragraphIndex: index,
			offsetV: lineHeight > 0 ? Math.min(remaining, lineHeight) : remaining,
			lineScopedOnAnchor: false
		};
		remaining -= height;
		const nextIndex = findNextParagraphIndex(blocks, index, len);
		if (nextIndex == null && remaining > 0) return {
			paragraphIndex: index,
			offsetV: lineHeight > 0 ? Math.min(remaining, lineHeight) : remaining,
			lineScopedOnAnchor: false
		};
		index = nextIndex;
	}
	return null;
}
function walkBackTblpYAnchor(blocks, measures, startIndex, offsetV) {
	let candidate = startIndex;
	while (offsetV > 0) {
		if (offsetV <= paragraphMeasureHeight(measures, candidate) + 1) break;
		const earlierIndex = findPreviousParagraphIndex(blocks, candidate);
		if (earlierIndex == null) break;
		candidate = earlierIndex;
	}
	return resolutionWithLineScopedFlag(blocks, measures, candidate, offsetV, offsetV);
}
function getTableIndentPx(attrs) {
	const tableIndent = attrs?.tableIndent;
	return typeof tableIndent?.width === "number" && Number.isFinite(tableIndent.width) ? tableIndent.width : 0;
}
function horizontalWrapMargin(wrap) {
	return (wrap?.distLeft ?? 0) + (wrap?.distRight ?? 0);
}
function measureRoundingSlack(columnCount) {
	return Math.max(1, columnCount) * .5;
}
function isAnchoredTableFullWidth(block, measure, columnWidth) {
	if (columnWidth <= 0) return false;
	const totalWidth = measure.totalWidth ?? 0;
	const indent = getTableIndentPx(block.attrs);
	const effectiveWidth = totalWidth + horizontalWrapMargin(block.wrap) + Math.max(0, -indent);
	const slack = measureRoundingSlack(measure.columnWidths?.length ?? 1);
	const tblWidth = resolveTableWidthAttr(block.attrs?.tableWidth);
	if (tblWidth?.type === "pct" && tblWidth.width >= 5e3 * .99) return true;
	return effectiveWidth + slack >= columnWidth * ANCHORED_TABLE_FULL_WIDTH_RATIO;
}
function resolveFloatingTableAnchorResolution(blocks, measures, len, tableIndex, tableBlock, paragraphIndexById) {
	const anchorParagraphId = typeof tableBlock.attrs === "object" && tableBlock.attrs ? tableBlock.attrs.anchorParagraphId : void 0;
	if (typeof anchorParagraphId === "string") {
		const explicitIndex = paragraphIndexById.get(anchorParagraphId);
		if (typeof explicitIndex === "number") {
			const offsetV$1 = tableBlock.anchor?.offsetV ?? 0;
			if ((tableBlock.anchor?.vRelativeFrom ?? "paragraph") !== "paragraph") return {
				paragraphIndex: explicitIndex,
				offsetV: offsetV$1,
				lineScopedOnAnchor: false
			};
			return resolutionWithLineScopedFlag(blocks, measures, explicitIndex, offsetV$1, offsetV$1);
		}
	}
	if ((tableBlock.anchor?.vRelativeFrom ?? "paragraph") !== "paragraph") {
		const fallback = findNearestParagraphIndex$1(blocks, len, tableIndex);
		if (fallback == null) return null;
		return {
			paragraphIndex: fallback,
			offsetV: tableBlock.anchor?.offsetV ?? 0,
			lineScopedOnAnchor: false
		};
	}
	const offsetV = tableBlock.anchor?.offsetV ?? 0;
	const prevIndex = findPreviousParagraphIndex(blocks, tableIndex);
	const nextIndex = findNextParagraphIndex(blocks, tableIndex, len);
	if (nextIndex != null && isLineScopedTblpY$1(blocks, measures, nextIndex, offsetV)) {
		if (!isTextEmptyParagraph(blocks, nextIndex) && (prevIndex == null || isTextEmptyParagraph(blocks, prevIndex))) return resolutionWithLineScopedFlag(blocks, measures, nextIndex, offsetV, offsetV);
		if (isCompactOptionLineAfterBody(blocks, measures, nextIndex, prevIndex)) return resolutionWithLineScopedFlag(blocks, measures, nextIndex, offsetV, offsetV);
	}
	if (!isLineScopedTblpY$1(blocks, measures, prevIndex ?? nextIndex ?? tableIndex, offsetV)) {
		const forwardCompact = findForwardCompactOptionLine(blocks, measures, len, tableIndex);
		if (forwardCompact != null) return {
			paragraphIndex: forwardCompact,
			offsetV: paintOffsetThroughAnchorParagraphs(blocks, measures, len, tableIndex, forwardCompact, offsetV),
			lineScopedOnAnchor: false
		};
		const forward = resolveForwardParagraphByTblpY(blocks, measures, len, tableIndex, offsetV);
		if (forward != null) return forward;
	}
	const startIndex = prevIndex ?? nextIndex;
	if (startIndex == null) return null;
	return walkBackTblpYAnchor(blocks, measures, startIndex, offsetV);
}
function getTableIndentWidth(attrs) {
	if (!attrs) return 0;
	const tableIndent = attrs.tableIndent;
	if (!tableIndent || typeof tableIndent !== "object") return 0;
	const width = tableIndent.width;
	if (width === void 0 || width === null) return 0;
	if (typeof width !== "number") return 0;
	if (!Number.isFinite(width)) return 0;
	return width;
}
function applyTableIndent(x, width, indent, columnWidth) {
	const shiftedX = x + indent;
	if (indent <= 0) return {
		x: shiftedX,
		width: Math.max(0, width - indent)
	};
	if (width > columnWidth) return {
		x: shiftedX,
		width
	};
	const maxWidthWithinColumn = Math.max(0, columnWidth - indent);
	return {
		x: shiftedX,
		width: Math.min(width, maxWidthWithinColumn)
	};
}
function resolveRenderedTableWidth(columnWidth, measuredWidth, attrs) {
	const safeMeasuredWidth = Number.isFinite(measuredWidth) && measuredWidth > 0 ? measuredWidth : Math.max(0, columnWidth);
	const configuredWidth = resolveTableWidthAttr(attrs?.tableWidth);
	if (!configuredWidth) return safeMeasuredWidth;
	if (configuredWidth.type === "pct") return Math.max(0, Math.round(columnWidth * (configuredWidth.width / OOXML_PCT_DIVISOR)));
	return safeMeasuredWidth;
}
function resolveTableFrame(baseX, columnWidth, tableWidth, attrs) {
	const width = resolveRenderedTableWidth(columnWidth, tableWidth, attrs);
	const explicitJustification = typeof attrs?.justification === "string" ? attrs.justification : void 0;
	const isRtlTable$1 = getTableVisualDirection(attrs) === "rtl";
	const effectiveJustification = explicitJustification ?? (isRtlTable$1 ? "end" : void 0);
	const tableIndent = getTableIndentWidth(attrs);
	if (effectiveJustification === "center") return {
		x: baseX + (columnWidth - width) / 2,
		width
	};
	if (effectiveJustification === "right" || effectiveJustification === "end") {
		const rightAlignedX = baseX + (columnWidth - width);
		if (explicitJustification == null && isRtlTable$1 && tableIndent !== 0) return {
			x: rightAlignedX - tableIndent,
			width
		};
		return {
			x: rightAlignedX,
			width
		};
	}
	return applyTableIndent(baseX, width, tableIndent, columnWidth);
}
var COLUMN_MIN_WIDTH_PX = 25;
var COLUMN_MAX_WIDTH_PX = 200;
var ROW_MIN_HEIGHT_PX = 10;
function calculateColumnMinWidth(measuredWidth) {
	if (!Number.isFinite(measuredWidth) || measuredWidth <= 0) return COLUMN_MIN_WIDTH_PX;
	return Math.max(COLUMN_MIN_WIDTH_PX, Math.min(COLUMN_MAX_WIDTH_PX, measuredWidth));
}
function generateColumnBoundaries(measure, effectiveWidths) {
	const boundaries = [];
	const cellSpacingPx = measure.cellSpacingPx ?? 0;
	let xPosition = cellSpacingPx;
	const widths = effectiveWidths ?? measure.columnWidths;
	for (let i = 0; i < widths.length; i++) {
		const width = widths[i];
		const minWidth = calculateColumnMinWidth(width);
		const boundary = {
			index: i,
			x: xPosition,
			width,
			minWidth,
			resizable: true
		};
		boundaries.push(boundary);
		xPosition += width + cellSpacingPx;
	}
	return boundaries;
}
function generateRowBoundaries(measure, block, fromRow, toRow, repeatHeaderCount, cellSpacingPx, partialRow) {
	const boundaries = [];
	const renderedRows = [];
	if (repeatHeaderCount > 0) for (let r$1 = 0; r$1 < repeatHeaderCount && r$1 < measure.rows.length; r$1++) renderedRows.push({
		rowIndex: r$1,
		isRepeatedHeader: fromRow > 0
	});
	for (let r$1 = fromRow; r$1 < toRow && r$1 < measure.rows.length; r$1++) renderedRows.push({
		rowIndex: r$1,
		isRepeatedHeader: false
	});
	const blockedBoundaries = /* @__PURE__ */ new Set();
	for (let r$1 = 0; r$1 < measure.rows.length; r$1++) {
		const rowMeasure = measure.rows[r$1];
		if (!rowMeasure) continue;
		for (const cellMeasure of rowMeasure.cells) {
			const rowSpan = cellMeasure.rowSpan ?? 1;
			if (rowSpan <= 1) continue;
			for (let boundaryRow = r$1; boundaryRow < r$1 + rowSpan - 1; boundaryRow++) blockedBoundaries.add(boundaryRow);
		}
	}
	let yPosition = cellSpacingPx;
	for (let ri = 0; ri < renderedRows.length; ri++) {
		const { rowIndex, isRepeatedHeader } = renderedRows[ri];
		const rowMeasure = measure.rows[rowIndex];
		if (!rowMeasure) continue;
		const isPartial = partialRow?.rowIndex === rowIndex;
		const height = isPartial ? partialRow.partialHeight : rowMeasure.height;
		const contentHeight = getRowContentHeight(block.rows[rowIndex], rowMeasure);
		const minHeight = isPartial ? Math.max(1, height) : Math.max(ROW_MIN_HEIGHT_PX, contentHeight);
		const resizable = !isRepeatedHeader && !isPartial && !blockedBoundaries.has(rowIndex);
		boundaries.push({
			index: rowIndex,
			y: yPosition,
			height,
			minHeight,
			resizable
		});
		yPosition += height + cellSpacingPx;
	}
	return boundaries;
}
function countHeaderRows(block) {
	let count = 0;
	for (let i = 0; i < block.rows.length; i++) if (block.rows[i].attrs?.tableRowProperties?.repeatHeader === true) count++;
	else break;
	return count;
}
function sumRowHeights(rows, fromRow, toRow) {
	let total = 0;
	for (let i = fromRow; i < toRow && i < rows.length; i++) total += rows[i].height;
	return total;
}
function computeFragmentHeight(measure, fromRow, toRow, repeatHeaderCount, borderCollapse, partialRow) {
	let height = 0;
	let rowCount = 0;
	if (repeatHeaderCount > 0) {
		height += sumRowHeights(measure.rows, 0, repeatHeaderCount);
		rowCount += repeatHeaderCount;
	}
	for (let i = fromRow; i < toRow && i < measure.rows.length; i++) {
		if (partialRow && partialRow.rowIndex === i) height += partialRow.partialHeight;
		else height += measure.rows[i].height;
		rowCount++;
	}
	const cellSpacingPx = measure.cellSpacingPx ?? 0;
	if (rowCount > 0 && cellSpacingPx > 0) height += (rowCount + 1) * cellSpacingPx;
	if (rowCount > 0 && measure.tableBorderWidths && borderCollapse === "separate") height += measure.tableBorderWidths.top + measure.tableBorderWidths.bottom;
	return height;
}
var MIN_PARTIAL_ROW_HEIGHT = 20;
function getEmbeddedRowLines(row) {
	if (!row.cells.some((cell) => cell.blocks?.some((b$1) => b$1.kind === "table"))) return [{ lineHeight: row.height || 0 }];
	let tallestLines = [];
	for (const cell of row.cells) {
		const cellLines = getCellLines(cell);
		if (cellLines.length > tallestLines.length) tallestLines = cellLines;
	}
	return tallestLines.length > 0 ? tallestLines : [{ lineHeight: row.height || 0 }];
}
function getCellLines(cell) {
	if (cell.blocks && cell.blocks.length > 0) {
		const allLines = [];
		for (const block of cell.blocks) if (block.kind === "paragraph") {
			if ("lines" in block) {
				const paraBlock = block;
				if (paraBlock.lines) allLines.push(...paraBlock.lines);
			}
		} else if (block.kind === "table") {
			const tableBlock = block;
			for (const row of tableBlock.rows) allLines.push(...getEmbeddedRowLines(row));
		} else {
			const blockHeight = "height" in block ? block.height : 0;
			if (blockHeight > 0) allLines.push({ lineHeight: blockHeight });
		}
		return allLines;
	}
	if (cell.paragraph?.lines) return cell.paragraph.lines;
	return [];
}
function getCellPadding(cellIdx, blockRow) {
	const padding = blockRow?.cells?.[cellIdx]?.attrs?.padding ?? {};
	return {
		top: padding.top ?? 0,
		bottom: padding.bottom ?? 0,
		left: padding.left ?? 4,
		right: padding.right ?? 4
	};
}
function getCellTotalLines(cell) {
	return getCellLines(cell).length;
}
var ROW_HEIGHT_EPSILON = .1;
function getRowContentHeight(blockRow, rowMeasure) {
	let contentHeight = 0;
	for (let cellIdx = 0; cellIdx < rowMeasure.cells.length; cellIdx++) {
		const cell = rowMeasure.cells[cellIdx];
		const cellPadding = getCellPadding(cellIdx, blockRow);
		const paddingTotal = cellPadding.top + cellPadding.bottom;
		const cellBlock = blockRow?.cells?.[cellIdx];
		const sliceHeight = computeFullCellContentHeight(cell, cellBlock, cellPadding);
		contentHeight = Math.max(contentHeight, sliceHeight + paddingTotal);
	}
	return contentHeight;
}
function hasExplicitRowHeightSlack(blockRow, rowMeasure) {
	const rowHeightSpec = blockRow?.attrs?.rowHeight;
	if (!rowHeightSpec || rowHeightSpec.value == null || !Number.isFinite(rowHeightSpec.value)) return false;
	const contentHeight = getRowContentHeight(blockRow, rowMeasure);
	return rowMeasure.height > contentHeight + ROW_HEIGHT_EPSILON;
}
function mergePmRange(target, range) {
	if (typeof range.pmStart === "number") target.pmStart = target.pmStart == null ? range.pmStart : Math.min(target.pmStart, range.pmStart);
	if (typeof range.pmEnd === "number") target.pmEnd = target.pmEnd == null ? range.pmEnd : Math.max(target.pmEnd, range.pmEnd);
}
function computeCellPmRange(cell, cellMeasure, fromLine, toLine) {
	const range = {};
	if (!cell || !cellMeasure) return range;
	const cellBlocks = cell.blocks ?? (cell.paragraph ? [cell.paragraph] : []);
	const blockMeasures = cellMeasure.blocks ?? (cellMeasure.paragraph ? [cellMeasure.paragraph] : []);
	const maxBlocks = Math.min(cellBlocks.length, blockMeasures.length);
	let cumulativeLineCount = 0;
	for (let i = 0; i < maxBlocks; i++) {
		const block = cellBlocks[i];
		const blockMeasure = blockMeasures[i];
		if (blockMeasure.kind === "paragraph" && block?.kind === "paragraph") {
			const lines = blockMeasure.lines;
			const blockLineCount = lines?.length ?? 0;
			const blockStartGlobal = cumulativeLineCount;
			const blockEndGlobal = cumulativeLineCount + blockLineCount;
			const localFrom = Math.max(fromLine, blockStartGlobal) - blockStartGlobal;
			const localTo = Math.min(toLine, blockEndGlobal) - blockStartGlobal;
			if (lines && lines.length > 0 && localFrom < localTo) mergePmRange(range, computeFragmentPmRange(block, lines, localFrom, localTo));
			else mergePmRange(range, extractBlockPmRange(block));
			cumulativeLineCount += blockLineCount;
			continue;
		}
		if (blockMeasure.kind === "table") {
			const tableMeasure = blockMeasure;
			let tableSegments = 0;
			for (const row of tableMeasure.rows) tableSegments += getEmbeddedRowLines(row).length;
			const blockStart = cumulativeLineCount;
			const blockEnd = cumulativeLineCount + tableSegments;
			if (blockStart < toLine && blockEnd > fromLine) mergePmRange(range, extractBlockPmRange(block));
			cumulativeLineCount += tableSegments;
		} else {
			const blockStart = cumulativeLineCount;
			cumulativeLineCount += 1;
			if (blockStart < toLine && blockStart >= fromLine) mergePmRange(range, extractBlockPmRange(block));
		}
	}
	return range;
}
function computeTableFragmentPmRange(block, measure, fromRow, toRow, partialRow) {
	const range = {};
	for (let rowIndex = fromRow; rowIndex < toRow; rowIndex++) {
		const row = block.rows[rowIndex];
		const rowMeasure = measure.rows[rowIndex];
		if (!row || !rowMeasure) continue;
		const isPartial = partialRow?.rowIndex === rowIndex;
		const cellCount = Math.min(row.cells.length, rowMeasure.cells.length);
		for (let cellIndex = 0; cellIndex < cellCount; cellIndex++) {
			const cell = row.cells[cellIndex];
			const cellMeasure = rowMeasure.cells[cellIndex];
			if (!cell || !cellMeasure) continue;
			const totalLines = getCellTotalLines(cellMeasure);
			let fromLine = 0;
			let toLine = totalLines;
			if (isPartial) {
				const hasValidFromLineByCell = partialRow?.fromLineByCell && cellIndex < partialRow.fromLineByCell.length;
				const hasValidToLineByCell = partialRow?.toLineByCell && cellIndex < partialRow.toLineByCell.length;
				if (hasValidFromLineByCell) {
					const rawFrom = partialRow.fromLineByCell[cellIndex];
					if (typeof rawFrom === "number" && rawFrom >= 0) fromLine = rawFrom;
				}
				if (hasValidToLineByCell) {
					const rawTo = partialRow.toLineByCell[cellIndex];
					if (typeof rawTo === "number") toLine = rawTo === -1 ? totalLines : rawTo;
				}
			}
			fromLine = Math.max(0, Math.min(fromLine, totalLines));
			toLine = Math.max(0, Math.min(toLine, totalLines));
			if (toLine < fromLine) toLine = fromLine;
			mergePmRange(range, computeCellPmRange(cell, cellMeasure, fromLine, toLine));
		}
	}
	return range;
}
function applyTableFragmentPmRange(fragment, block, measure) {
	const range = computeTableFragmentPmRange(block, measure, fragment.fromRow, fragment.toRow, fragment.partialRow);
	if (range.pmStart != null) fragment.pmStart = range.pmStart;
	if (range.pmEnd != null) fragment.pmEnd = range.pmEnd;
}
function computePartialRow(rowIndex, blockRow, measure, availableHeight, fromLineByCell, fullPageHeight) {
	const row = measure.rows[rowIndex];
	if (!row) throw new Error(`Invalid rowIndex ${rowIndex}: measure.rows has ${measure.rows.length} rows`);
	const cellCount = row.cells.length;
	const startLines = fromLineByCell || new Array(cellCount).fill(0);
	const toLineByCell = [];
	const heightByCell = [];
	const cellPaddings = row.cells.map((_$1, idx) => getCellPadding(idx, blockRow));
	for (let cellIdx = 0; cellIdx < cellCount; cellIdx++) {
		const cell = row.cells[cellIdx];
		const startLine = startLines[cellIdx] || 0;
		const cellPadding = cellPaddings[cellIdx];
		const availableForLines = Math.max(0, availableHeight - (cellPadding.top + cellPadding.bottom));
		const cellBlock = blockRow?.cells?.[cellIdx];
		const cursor = createCellSliceCursor(describeCellRenderBlocks(cell, cellBlock, cellPadding), startLine);
		const lines = getCellLines(cell);
		let cumulativeHeight = 0;
		let cutLine = startLine;
		for (let i = startLine; i < lines.length; i++) {
			const lineCost = cursor.advanceLine(i);
			if (cumulativeHeight + lineCost > availableForLines) {
				if (cumulativeHeight === 0 && i === startLine && availableForLines > 0 && fullPageHeight != null && cursor.minSegmentCost(i) > fullPageHeight) {
					cumulativeHeight += Math.min(lineCost, availableForLines);
					cutLine = i + 1;
				}
				break;
			}
			cumulativeHeight += lineCost;
			cutLine = i + 1;
		}
		toLineByCell.push(cutLine);
		heightByCell.push(cumulativeHeight);
	}
	let actualPartialHeight = 0;
	let maxPaddingTotal = 0;
	for (let cellIdx = 0; cellIdx < cellCount; cellIdx++) {
		const cellPadding = cellPaddings[cellIdx];
		const paddingTotal = cellPadding.top + cellPadding.bottom;
		maxPaddingTotal = Math.max(maxPaddingTotal, paddingTotal);
		actualPartialHeight = Math.max(actualPartialHeight, heightByCell[cellIdx] + paddingTotal);
	}
	const madeProgress = toLineByCell.some((cutLine, idx) => cutLine > (startLines[idx] || 0));
	const isFirstPart = startLines.every((l) => l === 0);
	const isLastPart = toLineByCell.every((cutLine, idx) => {
		return cutLine >= getCellTotalLines(row.cells[idx]);
	}) || !madeProgress;
	if (actualPartialHeight === 0 && isFirstPart) actualPartialHeight = maxPaddingTotal;
	return {
		rowIndex,
		fromLineByCell: startLines,
		toLineByCell,
		isFirstPart,
		isLastPart,
		partialHeight: actualPartialHeight
	};
}
function findSplitPoint(block, measure, startRow, availableHeight, fullPageHeight, _pendingPartialRow) {
	let lastFitRow = startRow;
	const borderCollapse = block.attrs?.borderCollapse ?? (block.attrs?.cellSpacing != null ? "separate" : "collapse");
	let maxRowspanEnd = startRow;
	let lastCleanFitRow = startRow;
	for (let i = startRow; i < block.rows.length; i++) {
		const row = block.rows[i];
		const rowMeasure = measure.rows[i];
		const rowHeight = rowMeasure?.height || 0;
		let cantSplit = row.attrs?.tableRowProperties?.cantSplit === true;
		if (rowMeasure && hasExplicitRowHeightSlack(row, rowMeasure) && (!fullPageHeight || rowHeight <= fullPageHeight)) cantSplit = true;
		if (rowMeasure) for (const cellMeasure of rowMeasure.cells) {
			const rs = cellMeasure.rowSpan ?? 1;
			if (rs > 1) maxRowspanEnd = Math.max(maxRowspanEnd, i + rs);
		}
		if (computeFragmentHeight(measure, startRow, i + 1, 0, borderCollapse) <= availableHeight) {
			lastFitRow = i + 1;
			if (maxRowspanEnd <= i + 1) lastCleanFitRow = i + 1;
		} else {
			let remainingHeight = availableHeight - computeFragmentHeight(measure, startRow, lastFitRow, 0, borderCollapse);
			if (lastFitRow === startRow) {
				const cellSpacingPx = measure.cellSpacingPx ?? 0;
				const topBorderPx = borderCollapse === "separate" && measure.tableBorderWidths ? measure.tableBorderWidths.top : 0;
				remainingHeight = availableHeight - cellSpacingPx - topBorderPx;
			}
			if (fullPageHeight && rowHeight > fullPageHeight) {
				const partialRow = computePartialRow(i, block.rows[i], measure, remainingHeight, void 0, fullPageHeight);
				return {
					endRow: i + 1,
					partialRow
				};
			}
			if (cantSplit) {
				if (lastFitRow === startRow) return {
					endRow: startRow,
					partialRow: null
				};
				if (maxRowspanEnd > lastFitRow && lastCleanFitRow > startRow) return {
					endRow: lastCleanFitRow,
					partialRow: null,
					forcePageBreak: true
				};
				return {
					endRow: lastFitRow,
					partialRow: null
				};
			}
			if (remainingHeight >= MIN_PARTIAL_ROW_HEIGHT) {
				const partialRow = computePartialRow(i, block.rows[i], measure, remainingHeight, void 0, fullPageHeight);
				if (partialRow.toLineByCell.some((cutLine, idx) => cutLine > (partialRow.fromLineByCell[idx] || 0))) return {
					endRow: i + 1,
					partialRow
				};
			}
			if (maxRowspanEnd > lastFitRow && lastCleanFitRow > startRow) return {
				endRow: lastCleanFitRow,
				partialRow: null,
				forcePageBreak: true
			};
			return {
				endRow: lastFitRow,
				partialRow: null
			};
		}
	}
	return {
		endRow: block.rows.length,
		partialRow: null
	};
}
function generateFragmentMetadata(measure, block, fromRow, toRow, repeatHeaderCount, effectiveWidths, partialRow) {
	const cellSpacingPx = measure.cellSpacingPx ?? 0;
	return {
		columnBoundaries: generateColumnBoundaries(measure, effectiveWidths),
		rowBoundaries: generateRowBoundaries(measure, block, fromRow, toRow, repeatHeaderCount, cellSpacingPx, partialRow),
		coordinateSystem: "fragment"
	};
}
function layoutMonolithicTable(context) {
	let state = context.ensurePage();
	if (state.cursorY + context.measure.totalHeight > state.contentBottom && state.page.fragments.length > 0) state = context.advanceColumn(state);
	state = context.ensurePage();
	const height = Math.min(context.measure.totalHeight, state.contentBottom - state.cursorY);
	const baseX = context.columnX(state);
	const baseWidth = Math.max(0, context.measure.totalWidth || context.columnWidth);
	const { x, width } = resolveTableFrame(baseX, context.columnWidth, baseWidth, context.block.attrs);
	const columnWidths = rescaleColumnWidths(context.measure.columnWidths, context.measure.totalWidth, width);
	const metadata = generateFragmentMetadata(context.measure, context.block, 0, context.block.rows.length, 0, columnWidths);
	const fragment = {
		kind: "table",
		blockId: context.block.id,
		columnIndex: state.columnIndex,
		fromRow: 0,
		toRow: context.block.rows.length,
		x,
		y: state.cursorY,
		width,
		height,
		metadata,
		columnWidths,
		sourceAnchor: context.block.sourceAnchor
	};
	applyTableFragmentPmRange(fragment, context.block, context.measure);
	state.page.fragments.push(fragment);
	state.cursorY += height;
	state.maxCursorY = Math.max(state.maxCursorY, state.cursorY);
}
function layoutTableBlock({ block, measure, columnWidth, ensurePage, advanceColumn, columnX }) {
	let treatAsInline = false;
	if (block.anchor?.isAnchored) {
		treatAsInline = isAnchoredTableFullWidth(block, measure, columnWidth);
		if (!treatAsInline) return;
	}
	const floatingProps = (block.attrs?.tableProperties)?.floatingTableProperties;
	if (floatingProps && Object.keys(floatingProps).length > 0 && !treatAsInline) {
		layoutMonolithicTable({
			block,
			measure,
			columnWidth,
			ensurePage,
			advanceColumn,
			columnX
		});
		return;
	}
	const headerCount = countHeaderRows(block);
	const headerPrefixHeights = [0];
	for (let i = 0; i < headerCount; i += 1) headerPrefixHeights.push(headerPrefixHeights[i] + (measure.rows[i]?.height ?? 0));
	let state = ensurePage();
	const availableHeight = state.contentBottom - state.cursorY;
	const hasPriorFragments = state.page.fragments.length > 0;
	if (measure.rows.length > 0 && block.rows.length > 0 && hasPriorFragments) {
		const firstRowCantSplit = block.rows[0]?.attrs?.tableRowProperties?.cantSplit === true;
		const firstRowHeight = measure.rows[0]?.height ?? measure.totalHeight ?? 0;
		const firstRowSlack = hasExplicitRowHeightSlack(block.rows[0], measure.rows[0]);
		const firstRowFitsPage = firstRowHeight <= state.contentBottom;
		if (firstRowCantSplit || firstRowSlack && firstRowFitsPage) {
			if (firstRowHeight > availableHeight) state = advanceColumn(state);
		} else {
			const partial = computePartialRow(0, block.rows[0], measure, availableHeight);
			const madeProgress = partial.toLineByCell.some((toLine, idx) => toLine > (partial.fromLineByCell[idx] || 0));
			const hasRenderableHeight = partial.partialHeight > 0;
			if (!madeProgress || !hasRenderableHeight) state = advanceColumn(state);
		}
	} else if (hasPriorFragments) {
		let minRequiredHeight = 0;
		if (measure.rows.length > 0) minRequiredHeight = sumRowHeights(measure.rows, 0, 1);
		else if (measure.totalHeight > 0) minRequiredHeight = measure.totalHeight;
		if (minRequiredHeight > availableHeight) state = advanceColumn(state);
	}
	let currentRow = 0;
	let isTableContinuation = false;
	let pendingPartialRow = null;
	if (block.rows.length === 0 && measure.totalHeight > 0) {
		const height = Math.min(measure.totalHeight, state.contentBottom - state.cursorY);
		const { x, width } = resolveTableFrame(columnX(state), columnWidth, Math.max(0, measure.totalWidth || columnWidth), block.attrs);
		const columnWidths = rescaleColumnWidths(measure.columnWidths, measure.totalWidth, width);
		const metadata = generateFragmentMetadata(measure, block, 0, 0, 0, columnWidths);
		const fragment = {
			kind: "table",
			blockId: block.id,
			columnIndex: state.columnIndex,
			fromRow: 0,
			toRow: 0,
			x,
			y: state.cursorY,
			width,
			height,
			metadata,
			columnWidths,
			sourceAnchor: block.sourceAnchor
		};
		applyTableFragmentPmRange(fragment, block, measure);
		state.page.fragments.push(fragment);
		state.cursorY += height;
		state.maxCursorY = Math.max(state.maxCursorY, state.cursorY);
		return;
	}
	const borderCollapse = block.attrs?.borderCollapse ?? (block.attrs?.cellSpacing != null ? "separate" : "collapse");
	const getRepeatedHeaderHeight = (repeatCount) => {
		return headerPrefixHeights[Math.max(0, Math.min(repeatCount, headerCount))] ?? 0;
	};
	let samePagePartialContinuation = false;
	let retryWithoutHeaders = false;
	while (currentRow < block.rows.length || pendingPartialRow !== null) {
		state = ensurePage();
		const availableHeight$1 = state.contentBottom - state.cursorY;
		let repeatHeaderCount = 0;
		if (retryWithoutHeaders) {
			repeatHeaderCount = 0;
			retryWithoutHeaders = false;
		} else if (currentRow === 0 && !pendingPartialRow) repeatHeaderCount = 0;
		else if (samePagePartialContinuation) repeatHeaderCount = 0;
		else {
			const candidateRepeatHeaderCount = pendingPartialRow && pendingPartialRow.rowIndex < headerCount ? pendingPartialRow.rowIndex : headerCount;
			const candidateHeaderHeight = getRepeatedHeaderHeight(candidateRepeatHeaderCount);
			if (candidateRepeatHeaderCount > 0 && candidateHeaderHeight < availableHeight$1) repeatHeaderCount = candidateRepeatHeaderCount;
		}
		samePagePartialContinuation = false;
		if (repeatHeaderCount > 0 && !pendingPartialRow) {
			const bodyRow = block.rows[currentRow];
			const bodyRowHeight = measure.rows[currentRow]?.height || 0;
			const bodyCantSplit = bodyRow?.attrs?.tableRowProperties?.cantSplit === true;
			const spaceWithHeaders = availableHeight$1 - getRepeatedHeaderHeight(repeatHeaderCount);
			if (bodyCantSplit && bodyRowHeight > spaceWithHeaders && bodyRowHeight <= availableHeight$1) repeatHeaderCount = 0;
		}
		const repeatedHeaderHeight = getRepeatedHeaderHeight(repeatHeaderCount);
		const availableForBody = availableHeight$1 - repeatedHeaderHeight;
		const fullPageHeightForBody = state.contentBottom - (state.topMargin ?? 0) - repeatedHeaderHeight;
		if (pendingPartialRow !== null) {
			const rowIndex = pendingPartialRow.rowIndex;
			const fromLineByCell = pendingPartialRow.toLineByCell;
			const continuationPartialRow = computePartialRow(rowIndex, block.rows[rowIndex], measure, availableForBody, fromLineByCell, fullPageHeightForBody);
			const madeProgress = continuationPartialRow.toLineByCell.some((toLine, idx) => toLine > (fromLineByCell[idx] || 0));
			const hasRemainingLinesAfterContinuation = continuationPartialRow.toLineByCell.some((toLine, idx) => {
				return toLine < getCellTotalLines(measure.rows[rowIndex].cells[idx]);
			});
			const hadRemainingLinesBefore = fromLineByCell.some((fromLine, idx) => {
				return fromLine < getCellTotalLines(measure.rows[rowIndex].cells[idx]);
			});
			const fragmentHeight$1 = computeFragmentHeight(measure, rowIndex, rowIndex + 1, repeatHeaderCount, borderCollapse, continuationPartialRow);
			if (fragmentHeight$1 > 0 && madeProgress) {
				const { x: x$1, width: width$1 } = resolveTableFrame(columnX(state), columnWidth, Math.max(0, measure.totalWidth || columnWidth), block.attrs);
				const scaledWidths$1 = rescaleColumnWidths(measure.columnWidths, measure.totalWidth, width$1);
				const fragment$1 = {
					kind: "table",
					blockId: block.id,
					columnIndex: state.columnIndex,
					fromRow: rowIndex,
					toRow: rowIndex + 1,
					x: x$1,
					y: state.cursorY,
					width: width$1,
					height: fragmentHeight$1,
					continuesFromPrev: true,
					continuesOnNext: hasRemainingLinesAfterContinuation || rowIndex + 1 < block.rows.length,
					repeatHeaderCount,
					partialRow: continuationPartialRow,
					metadata: generateFragmentMetadata(measure, block, rowIndex, rowIndex + 1, repeatHeaderCount, scaledWidths$1, continuationPartialRow),
					columnWidths: scaledWidths$1,
					sourceAnchor: block.sourceAnchor
				};
				applyTableFragmentPmRange(fragment$1, block, measure);
				state.page.fragments.push(fragment$1);
				state.cursorY += fragmentHeight$1;
				state.maxCursorY = Math.max(state.maxCursorY, state.cursorY);
			}
			if (!hasRemainingLinesAfterContinuation) {
				currentRow = rowIndex + 1;
				pendingPartialRow = null;
			} else if (!madeProgress && hadRemainingLinesBefore) if (repeatHeaderCount > 0) retryWithoutHeaders = true;
			else state = advanceColumn(state);
			else {
				pendingPartialRow = continuationPartialRow;
				samePagePartialContinuation = true;
			}
			isTableContinuation = true;
			continue;
		}
		const bodyStartRow = currentRow;
		const { endRow, partialRow, forcePageBreak } = findSplitPoint(block, measure, bodyStartRow, availableForBody, fullPageHeightForBody);
		if (endRow === bodyStartRow && partialRow === null && state.page.fragments.length > 0) {
			state = advanceColumn(state);
			continue;
		}
		if (endRow === bodyStartRow && partialRow === null) {
			const forcedPartialRow = computePartialRow(bodyStartRow, block.rows[bodyStartRow], measure, availableForBody, void 0, fullPageHeightForBody);
			if (!forcedPartialRow.toLineByCell.some((cutLine) => cutLine > 0)) {
				if (repeatHeaderCount > 0) retryWithoutHeaders = true;
				else state = advanceColumn(state);
				continue;
			}
			const forcedEndRow = bodyStartRow + 1;
			const fragmentHeight$1 = computeFragmentHeight(measure, bodyStartRow, forcedEndRow, repeatHeaderCount, borderCollapse, forcedPartialRow);
			const { x: x$1, width: width$1 } = resolveTableFrame(columnX(state), columnWidth, Math.max(0, measure.totalWidth || columnWidth), block.attrs);
			const scaledWidths$1 = rescaleColumnWidths(measure.columnWidths, measure.totalWidth, width$1);
			const fragment$1 = {
				kind: "table",
				blockId: block.id,
				columnIndex: state.columnIndex,
				fromRow: bodyStartRow,
				toRow: forcedEndRow,
				x: x$1,
				y: state.cursorY,
				width: width$1,
				height: fragmentHeight$1,
				continuesFromPrev: isTableContinuation,
				continuesOnNext: !forcedPartialRow.isLastPart || forcedEndRow < block.rows.length,
				repeatHeaderCount,
				partialRow: forcedPartialRow,
				metadata: generateFragmentMetadata(measure, block, bodyStartRow, forcedEndRow, repeatHeaderCount, scaledWidths$1, forcedPartialRow),
				columnWidths: scaledWidths$1,
				sourceAnchor: block.sourceAnchor
			};
			applyTableFragmentPmRange(fragment$1, block, measure);
			state.page.fragments.push(fragment$1);
			state.cursorY += fragmentHeight$1;
			state.maxCursorY = Math.max(state.maxCursorY, state.cursorY);
			pendingPartialRow = forcedPartialRow;
			samePagePartialContinuation = true;
			isTableContinuation = true;
			continue;
		}
		const fragmentHeight = computeFragmentHeight(measure, bodyStartRow, endRow, repeatHeaderCount, borderCollapse, partialRow);
		const { x, width } = resolveTableFrame(columnX(state), columnWidth, Math.max(0, measure.totalWidth || columnWidth), block.attrs);
		const scaledWidths = rescaleColumnWidths(measure.columnWidths, measure.totalWidth, width);
		const fragment = {
			kind: "table",
			blockId: block.id,
			columnIndex: state.columnIndex,
			fromRow: bodyStartRow,
			toRow: endRow,
			x,
			y: state.cursorY,
			width,
			height: fragmentHeight,
			continuesFromPrev: isTableContinuation,
			continuesOnNext: endRow < block.rows.length || (partialRow ? !partialRow.isLastPart : false),
			repeatHeaderCount,
			partialRow: partialRow || void 0,
			metadata: generateFragmentMetadata(measure, block, bodyStartRow, endRow, repeatHeaderCount, scaledWidths, partialRow),
			columnWidths: scaledWidths,
			sourceAnchor: block.sourceAnchor
		};
		applyTableFragmentPmRange(fragment, block, measure);
		state.page.fragments.push(fragment);
		state.cursorY += fragmentHeight;
		state.maxCursorY = Math.max(state.maxCursorY, state.cursorY);
		if (partialRow && !partialRow.isLastPart) {
			pendingPartialRow = partialRow;
			currentRow = partialRow.rowIndex;
		} else {
			currentRow = endRow;
			pendingPartialRow = null;
		}
		isTableContinuation = true;
		if (forcePageBreak && currentRow < block.rows.length) state = advanceColumn(state);
		else if (pendingPartialRow) samePagePartialContinuation = true;
	}
}
function createAnchoredTableFragment(block, measure, x, y$1) {
	const metadata = generateFragmentMetadata(measure, block, 0, block.rows.length, 0);
	const fragment = {
		kind: "table",
		blockId: block.id,
		fromRow: 0,
		toRow: block.rows.length,
		x,
		y: y$1,
		width: measure.totalWidth ?? 0,
		height: measure.totalHeight ?? 0,
		metadata,
		sourceAnchor: block.sourceAnchor
	};
	applyTableFragmentPmRange(fragment, block, measure);
	return fragment;
}
var PX_PER_PT = 96 / 72;
function isLineScopedTblpY(firstLineHeight, offsetV) {
	if (firstLineHeight <= 0) return offsetV <= 1;
	return offsetV <= firstLineHeight * 1.5;
}
function anchorForLineScopedFormField(anchor, tableHeight, firstLineHeight, layoutOffsetV, lineScopedOnAnchor = false, wrapType = "None") {
	if (!anchor) return anchor;
	if ((anchor.vRelativeFrom ?? "paragraph") !== "paragraph") return anchor;
	if (wrapType !== "None") return anchor;
	if (!lineScopedOnAnchor) return anchor;
	const offsetV = layoutOffsetV ?? anchor.offsetV ?? 0;
	if (anchor.alignV || firstLineHeight <= 0 || tableHeight <= firstLineHeight) return anchor;
	if (!isLineScopedTblpY(firstLineHeight, offsetV)) return anchor;
	return {
		...anchor,
		vRelativeFrom: "paragraph",
		alignV: "center",
		offsetV: 0
	};
}
function graphicAnchorY(anchor) {
	if (!anchor) return void 0;
	const alignV = anchor.alignV;
	const mappedAlignV = alignV === "top" || alignV === "center" || alignV === "bottom" ? alignV : void 0;
	return {
		vRelativeFrom: anchor.vRelativeFrom,
		alignV: mappedAlignV,
		offsetV: anchor.offsetV
	};
}
function graphicAnchorH(anchor) {
	const alignH = anchor.alignH;
	const mappedAlignH = alignH === "left" || alignH === "center" || alignH === "right" ? alignH : void 0;
	return {
		hRelativeFrom: anchor.hRelativeFrom,
		alignH: mappedAlignH,
		offsetH: anchor.offsetH
	};
}
var getParagraphAttrs = (block) => {
	if (!block.attrs || typeof block.attrs !== "object") return;
	return block.attrs;
};
var asString = (value) => {
	return typeof value === "string" ? value : void 0;
};
var asBoolean$1 = (value) => {
	if (value === true || value === 1) return true;
	if (typeof value === "string") {
		const normalized = value.toLowerCase();
		return normalized === "true" || normalized === "1" || normalized === "on";
	}
	return false;
};
var asSafeNumber = (value) => {
	if (typeof value !== "number") return 0;
	if (!Number.isFinite(value) || value < 0) return 0;
	return value;
};
var hashBorders = (borders) => {
	if (!borders) return void 0;
	const side = (b$1) => b$1 ? `${b$1.style ?? ""},${b$1.width ?? 0},${b$1.color ?? ""},${b$1.space ?? 0}` : "";
	return `${side(borders.top)}|${side(borders.right)}|${side(borders.bottom)}|${side(borders.left)}|${side(borders.between)}`;
};
var computeBorderVerticalExpansion = (borders) => {
	if (!borders) return {
		top: 0,
		bottom: 0
	};
	return {
		top: (borders.top?.space ?? 0) * PX_PER_PT + (borders.top?.width ?? 0),
		bottom: (borders.bottom?.space ?? 0) * PX_PER_PT + (borders.bottom?.width ?? 0)
	};
};
function calculateFirstLineIndent(block, measure) {
	const wordLayout = block.attrs?.wordLayout;
	if (!wordLayout?.firstLineIndentMode) return 0;
	if (!wordLayout.marker || !measure.marker) return 0;
	const markerWidthRaw = measure.marker.markerWidth ?? wordLayout.marker.markerBoxWidthPx ?? 0;
	const markerWidth = Number.isFinite(markerWidthRaw) && markerWidthRaw >= 0 ? markerWidthRaw : 0;
	const gutterWidthRaw = measure.marker.gutterWidth ?? 0;
	return markerWidth + (Number.isFinite(gutterWidthRaw) && gutterWidthRaw >= 0 ? gutterWidthRaw : 0);
}
function layoutParagraphBlock(ctx$1, anchors) {
	const { block, measure, columnWidth, ensurePage, advanceColumn, columnX, floatManager } = ctx$1;
	const remeasureParagraph$1 = ctx$1.remeasureParagraph;
	const frame = getParagraphAttrs(block)?.frame;
	let lines = normalizeLines(measure);
	const measurementWidth = lines[0]?.maxWidth;
	const paraIndent = block.attrs?.indent;
	const indentLeft = typeof paraIndent?.left === "number" && Number.isFinite(paraIndent.left) ? paraIndent.left : 0;
	const indentRight = typeof paraIndent?.right === "number" && Number.isFinite(paraIndent.right) ? paraIndent.right : 0;
	const negativeLeftIndent = indentLeft < 0 ? indentLeft : 0;
	const negativeRightIndent = indentRight < 0 ? indentRight : 0;
	const remeasureWidth = Math.max(1, columnWidth - indentLeft - indentRight);
	let didRemeasureForColumnWidth = false;
	let remeasuredMarkerInfo;
	if (typeof remeasureParagraph$1 === "function" && typeof measurementWidth === "number" && measurementWidth > remeasureWidth) {
		const newMeasure = remeasureParagraph$1(block, columnWidth, calculateFirstLineIndent(block, measure));
		lines = normalizeLines(newMeasure);
		didRemeasureForColumnWidth = true;
		if (newMeasure.marker) remeasuredMarkerInfo = newMeasure.marker;
	}
	let fromLine = 0;
	const attrs = getParagraphAttrs(block);
	const spacing = attrs?.spacing ?? {};
	const spacingExplicit = attrs?.spacingExplicit;
	const styleId$1 = asString(attrs?.styleId);
	const contextualSpacing = asBoolean$1(attrs?.contextualSpacing);
	let spacingBefore = Math.max(0, Number(spacing.before ?? spacing.lineSpaceBefore ?? 0));
	let spacingAfter = ctx$1.overrideSpacingAfter ?? Math.max(0, Number(spacing.after ?? spacing.lineSpaceAfter ?? 0));
	const emptyTextParagraph = isEmptyTextParagraph(block);
	if (emptyTextParagraph && spacingExplicit) {
		if (!spacingExplicit.before) spacingBefore = 0;
		if (!spacingExplicit.after) spacingAfter = 0;
	}
	const baseSpacingBefore = spacingBefore;
	let appliedSpacingBefore = spacingBefore === 0;
	let lastState = null;
	const previewState = ensurePage();
	const rawBorderExpansion = computeBorderVerticalExpansion(attrs?.borders);
	const currentBorderHash = hashBorders(attrs?.borders);
	const inBorderGroup = currentBorderHash != null && currentBorderHash === previewState.lastParagraphBorderHash;
	const borderExpansion = {
		top: inBorderGroup ? 0 : rawBorderExpansion.top,
		bottom: rawBorderExpansion.bottom
	};
	const paragraphAnchorBaseY = computeParagraphLayoutStartY({
		cursorY: previewState.cursorY,
		spacingBefore,
		trailingSpacing: previewState.trailingSpacing,
		suppressSpacingBefore: shouldSuppressOwnSpacing(styleId$1, contextualSpacing, previewState.lastParagraphStyleId),
		rewindTrailingFromPrevious: shouldSuppressOwnSpacing(previewState.lastParagraphStyleId, previewState.lastParagraphContextualSpacing, styleId$1)
	}) + borderExpansion.top - (inBorderGroup ? rawBorderExpansion.bottom : 0);
	let paragraphContentEndY = paragraphAnchorBaseY;
	const registerAnchoredDrawingsAt = (paragraphContentStartY) => {
		if (!anchors?.anchoredDrawings?.length) return;
		for (const entry of anchors.anchoredDrawings) {
			if (anchors.placedAnchoredIds.has(entry.block.id)) continue;
			const state = ensurePage();
			const contentTop = state.topMargin;
			const contentBottom = state.contentBottom;
			const anchorY = resolveAnchoredGraphicY({
				anchor: entry.block.anchor,
				objectHeight: entry.measure.height,
				contentTop,
				contentBottom,
				pageBottomMargin: anchors.pageMargins.bottom ?? 0,
				anchorParagraphY: paragraphContentStartY,
				firstLineHeight: measure.lines?.[0]?.lineHeight ?? 0
			});
			floatManager.registerDrawing(entry.block, entry.measure, anchorY, state.columnIndex, state.page.number);
			const anchorX = entry.block.anchor ? resolveAnchoredGraphicX(entry.block.anchor, state.columnIndex, anchors.columns, entry.measure.width, {
				left: anchors.pageMargins.left,
				right: anchors.pageMargins.right
			}, anchors.pageWidth) : columnX(state);
			const pmRange = extractBlockPmRange(entry.block);
			if (entry.block.kind === "image" && entry.measure.kind === "image") {
				const pageContentHeight = Math.max(0, state.contentBottom - state.topMargin);
				const relativeFrom = entry.block.anchor?.hRelativeFrom ?? "column";
				const marginLeft = anchors.pageMargins.left ?? 0;
				const marginRight = anchors.pageMargins.right ?? 0;
				let maxWidth;
				if (relativeFrom === "page") maxWidth = anchors.columns.count === 1 ? anchors.pageWidth - marginLeft - marginRight : anchors.pageWidth;
				else if (relativeFrom === "margin") maxWidth = anchors.pageWidth - marginLeft - marginRight;
				else maxWidth = anchors.columns.width;
				const aspectRatio = entry.measure.width > 0 && entry.measure.height > 0 ? entry.measure.width / entry.measure.height : 1;
				const minWidth = 20;
				const minHeight = minWidth / aspectRatio;
				const metadata = {
					originalWidth: entry.measure.width,
					originalHeight: entry.measure.height,
					maxWidth,
					maxHeight: pageContentHeight,
					aspectRatio,
					minWidth,
					minHeight
				};
				const fragment = {
					kind: "image",
					blockId: entry.block.id,
					x: anchorX,
					y: anchorY,
					width: entry.measure.width,
					height: entry.measure.height,
					isAnchored: true,
					behindDoc: entry.block.anchor?.behindDoc === true,
					zIndex: getFragmentZIndex(entry.block),
					metadata,
					sourceAnchor: entry.block.sourceAnchor
				};
				if (pmRange.pmStart != null) fragment.pmStart = pmRange.pmStart;
				if (pmRange.pmEnd != null) fragment.pmEnd = pmRange.pmEnd;
				state.page.fragments.push(fragment);
			} else if (entry.block.kind === "drawing" && entry.measure.kind === "drawing") {
				const contentMeasures = entry.block.drawingKind === "textboxShape" && typeof remeasureParagraph$1 === "function" ? layoutTextboxContent(entry.block, remeasureParagraph$1) : void 0;
				const fragment = {
					kind: "drawing",
					blockId: entry.block.id,
					drawingKind: entry.block.drawingKind,
					x: anchorX,
					y: anchorY,
					width: entry.measure.width,
					height: entry.measure.height,
					geometry: entry.measure.geometry,
					scale: entry.measure.scale,
					isAnchored: true,
					behindDoc: entry.block.anchor?.behindDoc === true,
					zIndex: getFragmentZIndex(entry.block),
					drawingContentId: entry.block.drawingContentId,
					sourceAnchor: entry.block.sourceAnchor
				};
				if (contentMeasures) fragment.contentMeasures = contentMeasures;
				if (pmRange.pmStart != null) fragment.pmStart = pmRange.pmStart;
				if (pmRange.pmEnd != null) fragment.pmEnd = pmRange.pmEnd;
				state.page.fragments.push(fragment);
			}
			anchors.placedAnchoredIds.add(entry.block.id);
		}
	};
	registerAnchoredDrawingsAt(paragraphAnchorBaseY);
	const registerAnchoredTablesAt = (paragraphContentStartY, entries) => {
		if (!entries.length) return;
		const columnWidthForTable = anchors.columnWidth;
		let nextStackY = paragraphContentStartY;
		for (const entry of entries) {
			if (anchors.placedAnchoredIds.has(entry.block.id)) continue;
			const totalWidth = entry.measure.totalWidth ?? 0;
			if (isAnchoredTableFullWidth(entry.block, entry.measure, columnWidthForTable)) continue;
			const state = ensurePage();
			const contentTop = state.topMargin;
			const contentBottom = state.contentBottom;
			const layoutOffsetV = entry.layoutOffsetV;
			const firstLineHeight = measure.lines?.[0]?.lineHeight ?? 0;
			const wrapType = entry.block.wrap?.type ?? "None";
			const anchorY = resolveAnchoredGraphicY({
				anchor: graphicAnchorY(anchorForLineScopedFormField(layoutOffsetV != null && entry.block.anchor ? {
					...entry.block.anchor,
					offsetV: layoutOffsetV
				} : entry.block.anchor, entry.measure.totalHeight ?? 0, firstLineHeight, layoutOffsetV, entry.lineScopedOnAnchor === true, wrapType)),
				objectHeight: entry.measure.totalHeight ?? 0,
				contentTop,
				contentBottom,
				pageBottomMargin: anchors.pageMargins.bottom ?? 0,
				anchorParagraphY: nextStackY,
				firstLineHeight: measure.lines?.[0]?.lineHeight ?? 0
			});
			floatManager.registerTable(entry.block, entry.measure, anchorY, state.columnIndex, state.page.number);
			const anchorX = entry.block.anchor ? resolveAnchoredGraphicX(graphicAnchorH(entry.block.anchor), state.columnIndex, anchors.columns, totalWidth, {
				left: anchors.pageMargins.left,
				right: anchors.pageMargins.right
			}, anchors.pageWidth) : columnX(state);
			state.page.fragments.push(createAnchoredTableFragment(entry.block, entry.measure, anchorX, anchorY));
			anchors.placedAnchoredIds.add(entry.block.id);
			if (wrapType !== "None") {
				const bottom$1 = anchorY + (entry.measure.totalHeight ?? 0);
				const distBottom = entry.block.wrap?.distBottom ?? 0;
				nextStackY = Math.max(nextStackY, bottom$1 + distBottom);
			}
		}
	};
	const anchoredTablesForPara = anchors?.anchoredTables ?? [];
	const totalLineHeight = lines.reduce((sum, line) => sum + (line.lineHeight ?? 0), 0);
	const remainingHeightOnStartPage = previewState.contentBottom - paragraphAnchorBaseY;
	const paragraphWillSpanPages = lines.length > 1 && totalLineHeight > remainingHeightOnStartPage;
	const shouldPreLayoutSquareTable = (entry) => entry.lineScopedOnAnchor === true && !paragraphWillSpanPages;
	registerAnchoredTablesAt(paragraphAnchorBaseY, anchoredTablesForPara.filter((entry) => {
		if ((entry.block.wrap?.type ?? "None") === "None") return true;
		return shouldPreLayoutSquareTable(entry);
	}));
	if (frame?.wrap === "none") {
		let state = ensurePage();
		if (state.cursorY >= state.contentBottom) state = advanceColumn(state);
		const fragmentWidth = lines.reduce((max$2, line) => Math.max(max$2, line.width ?? 0), 0) || columnWidth;
		let x = columnX(state);
		if (frame.xAlign === "right") x += columnWidth - fragmentWidth;
		else if (frame.xAlign === "center") x += (columnWidth - fragmentWidth) / 2;
		if (typeof frame.x === "number" && Number.isFinite(frame.x)) x += frame.x;
		const yOffset = typeof frame.y === "number" && Number.isFinite(frame.y) ? frame.y : 0;
		const fragment = {
			kind: "para",
			blockId: block.id,
			fromLine: 0,
			toLine: lines.length,
			x,
			y: state.cursorY + yOffset,
			width: fragmentWidth,
			sourceAnchor: block.sourceAnchor,
			...computeFragmentPmRange(block, lines, 0, lines.length)
		};
		if (measure.marker || remeasuredMarkerInfo) {
			fragment.markerWidth = (remeasuredMarkerInfo ?? measure.marker)?.markerWidth ?? measure.marker?.markerWidth ?? 0;
			const markerTextWidth = remeasuredMarkerInfo?.markerTextWidth ?? measure.marker?.markerTextWidth;
			if (markerTextWidth != null) fragment.markerTextWidth = markerTextWidth;
		}
		state.page.fragments.push(fragment);
		state.trailingSpacing = 0;
		state.lastParagraphStyleId = styleId$1;
		state.lastParagraphContextualSpacing = contextualSpacing;
		return;
	}
	let narrowestWidth = columnWidth;
	let narrowestOffsetX = 0;
	let didRemeasureForFloats = false;
	if (typeof remeasureParagraph$1 === "function") {
		const tempState = ensurePage();
		let tempY = paragraphAnchorBaseY;
		for (let i = 0; i < lines.length; i++) {
			const lineY = tempY;
			const lineHeight = lines[i]?.lineHeight || 0;
			const { width: availableWidth, offsetX: computedOffset } = floatManager.computeAvailableWidth(lineY, lineHeight, columnWidth, tempState.columnIndex, tempState.page.number);
			if (availableWidth < narrowestWidth) {
				narrowestWidth = availableWidth;
				narrowestOffsetX = computedOffset;
			}
			tempY += lineHeight;
		}
		const narrowestRemeasureWidth = narrowestWidth < columnWidth || narrowestOffsetX > 0 ? Math.max(1, narrowestWidth - Math.max(indentLeft, 0) - Math.max(indentRight, 0)) : Math.max(1, narrowestWidth - indentLeft - indentRight);
		if (narrowestRemeasureWidth < remeasureWidth || narrowestOffsetX > 0) {
			const newMeasure = remeasureParagraph$1(block, narrowestRemeasureWidth, calculateFirstLineIndent(block, measure));
			lines = normalizeLines(newMeasure);
			didRemeasureForFloats = true;
			if (newMeasure.marker) remeasuredMarkerInfo = newMeasure.marker;
		}
	}
	while (fromLine < lines.length) {
		let state = ensurePage();
		if (state.trailingSpacing == null) state.trailingSpacing = 0;
		if (inBorderGroup && fromLine === 0) state.cursorY -= rawBorderExpansion.bottom;
		if (shouldSuppressOwnSpacing(styleId$1, contextualSpacing, state.lastParagraphStyleId)) spacingBefore = 0;
		if (shouldSuppressOwnSpacing(state.lastParagraphStyleId, state.lastParagraphContextualSpacing, styleId$1)) {
			const prevTrailing = asSafeNumber(state.trailingSpacing);
			if (prevTrailing > 0) {
				state.cursorY = rewindPreviousParagraphTrailing(state.cursorY, prevTrailing);
				state.trailingSpacing = 0;
			}
		}
		if (attrs?.keepLines === true && fromLine === 0) {
			const neededSpacingBefore = collapseSpacingBefore(spacingBefore, state.trailingSpacing);
			const pageContentHeight = state.contentBottom - state.topMargin;
			const fullHeight = lines.reduce((sum, line) => sum + (line.lineHeight || 0), 0) + borderExpansion.top + borderExpansion.bottom;
			const fitsOnBlankPage = fullHeight + baseSpacingBefore <= pageContentHeight;
			const remainingHeightAfterSpacing = state.contentBottom - (state.cursorY + neededSpacingBefore);
			if (fitsOnBlankPage && state.page.fragments.length > 0 && fullHeight > remainingHeightAfterSpacing) {
				state = advanceColumn(state);
				spacingBefore = baseSpacingBefore;
				appliedSpacingBefore = spacingBefore === 0;
				continue;
			}
		}
		if (!appliedSpacingBefore && spacingBefore > 0) while (!appliedSpacingBefore) {
			state.trailingSpacing;
			const neededSpacingBefore = collapseSpacingBefore(spacingBefore, state.trailingSpacing);
			if (state.cursorY + neededSpacingBefore > state.contentBottom) {
				if (state.cursorY <= state.topMargin) {
					state.trailingSpacing = 0;
					appliedSpacingBefore = true;
					break;
				}
				state = advanceColumn(state);
				if (state.trailingSpacing == null) state.trailingSpacing = 0;
				continue;
			}
			if (neededSpacingBefore > 0) {
				state.cursorY += neededSpacingBefore;
				state.maxCursorY = Math.max(state.maxCursorY, state.cursorY);
			}
			state.trailingSpacing = 0;
			appliedSpacingBefore = true;
		}
		else state.trailingSpacing = 0;
		const FN_SAFETY_MARGIN_PX = 1;
		const fallbackBandOverhead = (refsTotal) => refsTotal > 0 ? 22 + Math.max(0, refsTotal - 1) * 2 : 0;
		const bandOverhead = (refsTotal) => {
			if (refsTotal <= 0) return 0;
			const fromCtx = ctx$1.getFootnoteBandOverhead?.(refsTotal);
			return (typeof fromCtx === "number" && Number.isFinite(fromCtx) && fromCtx >= 0 ? fromCtx : fallbackBandOverhead(refsTotal)) + FN_SAFETY_MARGIN_PX;
		};
		const rawContentBottom = state.contentBottom + state.pageFootnoteReserve;
		const computeEffectiveBottom = (extraDemand, extraRefs) => {
			const totalDemand = extraDemand;
			const totalRefs = state.footnoteRefsThisPage + extraRefs;
			const demandWithOverhead = totalDemand > 0 ? totalDemand + bandOverhead(totalRefs) : 0;
			const reservedSpace = Math.max(state.pageFootnoteReserve, demandWithOverhead);
			const minBodyLineHeight = lines[fromLine]?.lineHeight ?? 0;
			const maxAdditional = Math.max(0, rawContentBottom - state.topMargin - minBodyLineHeight);
			return rawContentBottom - Math.min(reservedSpace, maxAdditional);
		};
		const computeFootnoteClusterDemand = (pmStart, pmEnd) => {
			const candidate = ctx$1.getFootnoteAnchorsForBlockId ? ctx$1.getFootnoteAnchorsForBlockId(block.id, pmStart, pmEnd) : [];
			const committed = state.footnoteAnchorsThisPage ?? [];
			if (candidate.length === 0 && committed.length === 0) return 0;
			let demand = 0;
			for (const anchor of committed) demand += anchor.fullHeight;
			for (const anchor of candidate) demand += anchor.fullHeight;
			return demand;
		};
		const previewRange = computeFragmentPmRange(block, lines, fromLine, fromLine + 1);
		const previewRefs = ctx$1.getFootnoteRefCountForBlockId ? ctx$1.getFootnoteRefCountForBlockId(block.id, previewRange.pmStart, previewRange.pmEnd) : 0;
		const computePreviewBottom = () => {
			return computeEffectiveBottom(computeFootnoteClusterDemand(previewRange.pmStart ?? 0, previewRange.pmEnd ?? 0), previewRefs);
		};
		let effectiveBottom = computePreviewBottom();
		if (state.cursorY >= effectiveBottom) {
			state = advanceColumn(state);
			effectiveBottom = computePreviewBottom();
		}
		if (effectiveBottom - state.cursorY <= 0) {
			state = advanceColumn(state);
			effectiveBottom = computePreviewBottom();
		}
		const nextLineHeight = lines[fromLine].lineHeight || 0;
		const remainingHeight = effectiveBottom - state.cursorY;
		if (state.page.fragments.length > 0 && remainingHeight < nextLineHeight) {
			state = advanceColumn(state);
			effectiveBottom = computePreviewBottom();
		}
		let effectiveColumnWidth = columnWidth;
		let offsetX = 0;
		if (didRemeasureForFloats) {
			effectiveColumnWidth = narrowestWidth;
			offsetX = narrowestOffsetX;
		}
		const borderVertical = borderExpansion.top + borderExpansion.bottom;
		let toLine = fromLine;
		let height = 0;
		let sliceDemand = 0;
		let sliceRefs = 0;
		while (toLine < lines.length) {
			const lineHeight = lines[toLine].lineHeight || 0;
			const range = computeFragmentPmRange(block, lines, fromLine, toLine + 1);
			const orderedDemand = computeFootnoteClusterDemand(range.pmStart ?? 0, range.pmEnd ?? 0);
			const nextRefs = ctx$1.getFootnoteRefCountForBlockId ? ctx$1.getFootnoteRefCountForBlockId(block.id, range.pmStart, range.pmEnd) : 0;
			if (toLine === fromLine) {
				height = lineHeight;
				sliceDemand = orderedDemand;
				sliceRefs = nextRefs;
				toLine = fromLine + 1;
				continue;
			}
			if (state.cursorY + height + lineHeight + borderVertical > computeEffectiveBottom(orderedDemand, nextRefs)) break;
			height += lineHeight;
			sliceDemand = orderedDemand;
			sliceRefs = nextRefs;
			toLine += 1;
		}
		const slice = {
			toLine,
			height
		};
		const fragmentHeight = slice.height;
		if (sliceDemand > 0 || sliceRefs > 0) {
			state.footnoteDemandThisPage = sliceDemand;
			state.footnoteRefsThisPage = (state.footnoteRefsThisPage ?? 0) + sliceRefs;
		}
		if (ctx$1.getFootnoteAnchorsForBlockId) {
			const committedRange = computeFragmentPmRange(block, lines, fromLine, toLine);
			const newAnchors = ctx$1.getFootnoteAnchorsForBlockId(block.id, committedRange.pmStart, committedRange.pmEnd);
			if (newAnchors.length > 0) {
				if (!state.footnoteAnchorsThisPage) state.footnoteAnchorsThisPage = [];
				const seen = new Set(state.footnoteAnchorsThisPage.map((a) => a.refId));
				for (const a of newAnchors) if (!seen.has(a.refId)) state.footnoteAnchorsThisPage.push(a);
			}
		}
		const floatAdjustedX = columnX(state) + offsetX;
		const adjustedX = didRemeasureForFloats ? floatAdjustedX + Math.max(negativeLeftIndent, 0) : floatAdjustedX + negativeLeftIndent;
		const columnRight = columnX(state) + columnWidth;
		let adjustedWidth = didRemeasureForFloats ? effectiveColumnWidth : effectiveColumnWidth - negativeLeftIndent - negativeRightIndent;
		if (didRemeasureForFloats) adjustedWidth = Math.min(adjustedWidth, Math.max(1, columnRight - adjustedX));
		const fragment = {
			kind: "para",
			blockId: block.id,
			fromLine,
			toLine: slice.toLine,
			x: adjustedX,
			y: state.cursorY + borderExpansion.top,
			width: adjustedWidth,
			sourceAnchor: block.sourceAnchor,
			...computeFragmentPmRange(block, lines, fromLine, slice.toLine)
		};
		if (didRemeasureForColumnWidth || didRemeasureForFloats) fragment.lines = lines.slice(fromLine, slice.toLine);
		if ((measure.marker || remeasuredMarkerInfo) && fromLine === 0) {
			fragment.markerWidth = (remeasuredMarkerInfo ?? measure.marker)?.markerWidth ?? measure.marker?.markerWidth ?? 0;
			const markerTextWidth = remeasuredMarkerInfo?.markerTextWidth ?? measure.marker?.markerTextWidth;
			if (markerTextWidth != null) fragment.markerTextWidth = markerTextWidth;
			const gutterWidth = remeasuredMarkerInfo?.gutterWidth ?? measure.marker?.gutterWidth;
			if (gutterWidth != null) fragment.markerGutter = gutterWidth;
		}
		if (fromLine > 0) fragment.continuesFromPrev = true;
		if (slice.toLine < lines.length) fragment.continuesOnNext = true;
		const floatAlignment = block.attrs?.floatAlignment;
		if (floatAlignment && (floatAlignment === "right" || floatAlignment === "center")) {
			let maxLineWidth = 0;
			for (let i = fromLine; i < slice.toLine; i++) if (lines[i].width > maxLineWidth) maxLineWidth = lines[i].width;
			if (floatAlignment === "right") fragment.x = columnX(state) + offsetX + (effectiveColumnWidth - maxLineWidth);
			else if (floatAlignment === "center") fragment.x = columnX(state) + offsetX + (effectiveColumnWidth - maxLineWidth) / 2;
		}
		state.page.fragments.push(fragment);
		state.cursorY += borderExpansion.top + fragmentHeight + borderExpansion.bottom;
		state.maxCursorY = Math.max(state.maxCursorY, state.cursorY);
		lastState = state;
		paragraphContentEndY = state.cursorY;
		fromLine = slice.toLine;
	}
	if (lastState) {
		if (spacingAfter > 0) {
			let targetState = lastState;
			let appliedSpacingAfter = spacingAfter;
			if (targetState.cursorY + spacingAfter > targetState.contentBottom) {
				targetState = advanceColumn(targetState);
				appliedSpacingAfter = 0;
			} else {
				targetState.cursorY += spacingAfter;
				targetState.maxCursorY = Math.max(targetState.maxCursorY, targetState.cursorY);
			}
			targetState.trailingSpacing = appliedSpacingAfter;
		} else lastState.trailingSpacing = 0;
		lastState.lastParagraphStyleId = styleId$1;
		lastState.lastParagraphContextualSpacing = contextualSpacing;
		lastState.lastParagraphBorderHash = currentBorderHash;
	}
	const postLayoutAnchoredTables = anchoredTablesForPara.filter((entry) => {
		return (entry.block.wrap?.type ?? "None") !== "None" && !shouldPreLayoutSquareTable(entry);
	});
	if (postLayoutAnchoredTables.length > 0) registerAnchoredTablesAt(emptyTextParagraph && !paragraphWillSpanPages && postLayoutAnchoredTables.some((entry) => {
		const offsetV = entry.layoutOffsetV ?? entry.block.anchor?.offsetV ?? 0;
		return entry.lineScopedOnAnchor === false && offsetV > 0;
	}) ? paragraphAnchorBaseY : paragraphContentEndY, postLayoutAnchoredTables);
}
function layoutImageBlock({ block, measure, columns, ensurePage, advanceColumn, columnX }) {
	if (block.anchor?.isAnchored) return;
	const marginTop = Math.max(0, block.margin?.top ?? 0);
	const marginBottom = Math.max(0, block.margin?.bottom ?? 0);
	const marginLeft = Math.max(0, block.margin?.left ?? 0);
	const marginRight = Math.max(0, block.margin?.right ?? 0);
	const maxWidth = Math.max(0, columns.width - (marginLeft + marginRight));
	let width = measure.width;
	let height = measure.height;
	if (width > maxWidth && maxWidth > 0) {
		const scale = maxWidth / width;
		width = maxWidth;
		height *= scale;
	}
	let state = ensurePage();
	const pageContentHeight = Math.max(0, state.contentBottom - state.topMargin);
	if (height > pageContentHeight && pageContentHeight > 0) {
		const scale = pageContentHeight / height;
		height = pageContentHeight;
		width *= scale;
	}
	const requiredHeight = marginTop + height + marginBottom;
	if (state.cursorY + requiredHeight > state.contentBottom && state.cursorY > state.topMargin) state = advanceColumn(state);
	const pmRange = extractBlockPmRange(block);
	const aspectRatio = measure.width > 0 && measure.height > 0 ? measure.width / measure.height : 1;
	const minWidth = 20;
	const minHeight = minWidth / aspectRatio;
	const metadata = {
		originalWidth: measure.width,
		originalHeight: measure.height,
		maxWidth,
		maxHeight: pageContentHeight,
		aspectRatio,
		minWidth,
		minHeight
	};
	const fragment = {
		kind: "image",
		blockId: block.id,
		x: columnX(state) + marginLeft,
		y: state.cursorY + marginTop,
		width,
		height,
		pmStart: pmRange.pmStart,
		pmEnd: pmRange.pmEnd,
		metadata,
		sourceAnchor: block.sourceAnchor
	};
	state.page.fragments.push(fragment);
	state.cursorY += requiredHeight;
	state.maxCursorY = Math.max(state.maxCursorY, state.cursorY);
}
function layoutDrawingBlock({ block, measure, columns, ensurePage, advanceColumn, columnX, textboxContentMeasures }) {
	if (block.anchor?.isAnchored) return;
	const marginTop = Math.max(0, block.margin?.top ?? 0);
	const marginBottom = Math.max(0, block.margin?.bottom ?? 0);
	const marginLeft = Math.max(0, block.margin?.left ?? 0);
	const marginRight = Math.max(0, block.margin?.right ?? 0);
	const maxWidth = Math.max(0, columns.width - (marginLeft + marginRight));
	let width = measure.width;
	let height = measure.height;
	const attrs = block.attrs;
	const indentLeft = typeof attrs?.hrIndentLeft === "number" ? attrs.hrIndentLeft : 0;
	const indentRight = typeof attrs?.hrIndentRight === "number" ? attrs.hrIndentRight : 0;
	const maxWidthForBlock = attrs?.isFullWidth === true && maxWidth > 0 ? Math.max(1, maxWidth - indentLeft - indentRight) : maxWidth;
	const rawWrap = attrs?.wrap;
	const isInlineShapeGroup = block.drawingKind === "shapeGroup" && rawWrap?.type === "Inline";
	const inlineParagraphAlignment = attrs?.inlineParagraphAlignment === "center" || attrs?.inlineParagraphAlignment === "right" ? attrs.inlineParagraphAlignment : void 0;
	if (width > maxWidthForBlock && maxWidthForBlock > 0) {
		const scale = maxWidthForBlock / width;
		width = maxWidthForBlock;
		height *= scale;
	}
	let state = ensurePage();
	const pageContentHeight = Math.max(0, state.contentBottom - state.topMargin);
	if (height > pageContentHeight && pageContentHeight > 0) {
		const scale = pageContentHeight / height;
		height = pageContentHeight;
		width *= scale;
	}
	const requiredHeight = marginTop + height + marginBottom;
	if (state.cursorY + requiredHeight > state.contentBottom && state.cursorY > state.topMargin) state = advanceColumn(state);
	const pmRange = extractBlockPmRange(block);
	let x = columnX(state) + marginLeft + indentLeft;
	if (isInlineShapeGroup && inlineParagraphAlignment) {
		const pIndentLeft = typeof attrs?.paragraphIndentLeft === "number" ? attrs.paragraphIndentLeft : 0;
		const pIndentRight = typeof attrs?.paragraphIndentRight === "number" ? attrs.paragraphIndentRight : 0;
		const alignBox = Math.max(0, maxWidthForBlock - pIndentLeft - pIndentRight);
		const extra = Math.max(0, alignBox - width);
		x += pIndentLeft + (inlineParagraphAlignment === "center" ? extra / 2 : extra);
	}
	const fragment = {
		kind: "drawing",
		blockId: block.id,
		drawingKind: block.drawingKind,
		x,
		y: state.cursorY + marginTop,
		width,
		height,
		geometry: measure.geometry,
		scale: measure.scale,
		drawingContentId: block.drawingContentId,
		zIndex: getFragmentZIndex(block),
		pmStart: pmRange.pmStart,
		pmEnd: pmRange.pmEnd,
		sourceAnchor: block.sourceAnchor
	};
	if (textboxContentMeasures) fragment.contentMeasures = textboxContentMeasures;
	state.page.fragments.push(fragment);
	state.cursorY += requiredHeight;
	state.maxCursorY = Math.max(state.maxCursorY, state.cursorY);
}
function buildParagraphIndexById(blocks, len) {
	const paragraphIndexById = /* @__PURE__ */ new Map();
	for (let i = 0; i < len; i += 1) {
		const block = blocks[i];
		if (block.kind === "paragraph") paragraphIndexById.set(block.id, i);
	}
	return paragraphIndexById;
}
function findNearestParagraphIndex(blocks, len, fromIndex) {
	for (let i = fromIndex - 1; i >= 0; i -= 1) if (blocks[i].kind === "paragraph") return i;
	for (let i = fromIndex + 1; i < len; i += 1) if (blocks[i].kind === "paragraph") return i;
	return null;
}
function resolveAnchorParagraphIndex(blocks, len, paragraphIndexById, fromIndex, anchorParagraphId) {
	if (typeof anchorParagraphId === "string") {
		const explicitIndex = paragraphIndexById.get(anchorParagraphId);
		if (typeof explicitIndex === "number") return explicitIndex;
	}
	return findNearestParagraphIndex(blocks, len, fromIndex);
}
function isPageRelativeAnchor(block) {
	const vRelativeFrom = block.anchor?.vRelativeFrom;
	return vRelativeFrom === "margin" || vRelativeFrom === "page";
}
function collectPreRegisteredAnchors(blocks, measures) {
	const result = [];
	const len = Math.min(blocks.length, measures.length);
	for (let i = 0; i < len; i += 1) {
		const block = blocks[i];
		const measure = measures[i];
		const isImage = block.kind === "image" && measure?.kind === "image";
		const isDrawing = block.kind === "drawing" && measure?.kind === "drawing";
		if (!isImage && !isDrawing) continue;
		const drawingBlock = block;
		const drawingMeasure = measure;
		if (!drawingBlock.anchor?.isAnchored) continue;
		if (isPageRelativeAnchor(drawingBlock)) result.push({
			block: drawingBlock,
			measure: drawingMeasure
		});
	}
	return result;
}
function collectAnchoredDrawings(blocks, measures) {
	const byParagraph = /* @__PURE__ */ new Map();
	const withoutParagraph = [];
	const len = Math.min(blocks.length, measures.length);
	const paragraphIndexById = buildParagraphIndexById(blocks, len);
	for (let i = 0; i < len; i += 1) {
		const block = blocks[i];
		const measure = measures[i];
		const isImage = block.kind === "image" && measure?.kind === "image";
		const isDrawing = block.kind === "drawing" && measure?.kind === "drawing";
		if (!isImage && !isDrawing) continue;
		const drawingBlock = block;
		const drawingMeasure = measure;
		if (!drawingBlock.anchor?.isAnchored) continue;
		if (isPageRelativeAnchor(drawingBlock)) continue;
		const anchorParagraphId = typeof drawingBlock.attrs === "object" && drawingBlock.attrs ? drawingBlock.attrs.anchorParagraphId : void 0;
		const anchoredDrawing = {
			block: drawingBlock,
			measure: drawingMeasure
		};
		const anchorParaIndex = resolveAnchorParagraphIndex(blocks, len, paragraphIndexById, i, anchorParagraphId);
		if (anchorParaIndex == null) {
			withoutParagraph.push(anchoredDrawing);
			continue;
		}
		const list = byParagraph.get(anchorParaIndex) ?? [];
		list.push(anchoredDrawing);
		byParagraph.set(anchorParaIndex, list);
	}
	return {
		byParagraph,
		withoutParagraph,
		get size() {
			return byParagraph.size;
		},
		has: (index) => byParagraph.has(index),
		get: (index) => byParagraph.get(index)
	};
}
function collectAnchoredTables(blocks, measures) {
	const len = Math.min(blocks.length, measures.length);
	const byParagraph = /* @__PURE__ */ new Map();
	const withoutParagraph = [];
	const paragraphIndexById = buildParagraphIndexById(blocks, len);
	for (let i = 0; i < len; i += 1) {
		const block = blocks[i];
		const measure = measures[i];
		if (block.kind !== "table" || measure?.kind !== "table") continue;
		const tableBlock = block;
		const tableMeasure = measure;
		if (!tableBlock.anchor?.isAnchored) continue;
		const resolution = resolveFloatingTableAnchorResolution(blocks, measures, len, i, tableBlock, paragraphIndexById);
		if (resolution == null) {
			withoutParagraph.push({
				block: tableBlock,
				measure: tableMeasure
			});
			continue;
		}
		const list = byParagraph.get(resolution.paragraphIndex) ?? [];
		list.push({
			block: tableBlock,
			measure: tableMeasure,
			layoutOffsetV: resolution.offsetV,
			lineScopedOnAnchor: resolution.lineScopedOnAnchor
		});
		byParagraph.set(resolution.paragraphIndex, list);
	}
	return {
		byParagraph,
		withoutParagraph
	};
}
function computePhysicalAnchorY(block, fragmentHeight, pageHeight) {
	const alignV = block.anchor?.alignV ?? "top";
	const offsetV = block.anchor?.offsetV ?? 0;
	if (alignV === "bottom") return pageHeight - fragmentHeight + offsetV;
	if (alignV === "center") return (pageHeight - fragmentHeight) / 2 + offsetV;
	return offsetV;
}
function computeFooterBandOrigin(constraints) {
	const pageHeight = constraints.pageHeight ?? 0;
	const footerDistance = constraints.margins?.footer;
	if (typeof footerDistance === "number" && Number.isFinite(footerDistance)) return Math.max(0, pageHeight - Math.max(0, footerDistance));
	return Math.max(0, pageHeight - (constraints.margins?.bottom ?? 0));
}
function isAnchoredFragment(fragment) {
	return (fragment.kind === "image" || fragment.kind === "drawing") && fragment.isAnchored === true;
}
function isPageRelativeBlock(block) {
	return (block.kind === "image" || block.kind === "drawing") && block.anchor?.vRelativeFrom === "page";
}
function normalizeFragmentsForRegion(pages, blocks, _measures, _kind, constraints) {
	if (constraints.pageHeight == null || !constraints.margins) return pages;
	const pageHeight = constraints.pageHeight;
	const bandOrigin = computeFooterBandOrigin(constraints);
	const blockById = /* @__PURE__ */ new Map();
	for (const block of blocks) blockById.set(block.id, block);
	for (const page of pages) for (const fragment of page.fragments) {
		if (!isAnchoredFragment(fragment)) continue;
		const block = blockById.get(fragment.blockId);
		if (!block || !isPageRelativeBlock(block)) continue;
		fragment.y = computePhysicalAnchorY(block, fragment.height ?? 0, pageHeight) - bandOrigin;
	}
	return pages;
}
function createPaginator(opts) {
	const states = [];
	const pages = [];
	const pruneTrailingEmptyPages = () => {
		while (pages.length > 0 && pages[pages.length - 1].fragments.length === 0) {
			pages.pop();
			states.pop();
		}
	};
	const getActiveColumnsForState = (state) => {
		if (state.activeConstraintIndex >= 0 && state.constraintBoundaries[state.activeConstraintIndex]) return state.constraintBoundaries[state.activeConstraintIndex].columns;
		return opts.getActiveColumns();
	};
	const startNewPage = () => {
		if (opts.onNewPage) opts.onNewPage(void 0);
		const topMargin = opts.getActiveTopMargin();
		const bottomMargin = opts.getActiveBottomMargin();
		const headerDistance = opts.getActiveHeaderDistance();
		const footerDistance = opts.getActiveFooterDistance();
		const currentPageSize = opts.getActivePageSize();
		const defaultPageSize = opts.getDefaultPageSize();
		const contentBottom = currentPageSize.h - bottomMargin;
		if (contentBottom - topMargin <= 0) throw new Error("layoutDocument: pageSize and margins yield non-positive content area");
		const pageMargins = {
			top: topMargin,
			bottom: bottomMargin,
			left: opts.margins.left,
			right: opts.margins.right,
			header: headerDistance,
			footer: footerDistance
		};
		const pageSizeOverride = currentPageSize.w !== defaultPageSize.w || currentPageSize.h !== defaultPageSize.h ? currentPageSize : void 0;
		const pageIndex = pages.length;
		const pageFootnoteReserve = opts.getFootnoteReserveForPage?.(pageIndex) ?? 0;
		const state = {
			page: opts.createPage(pageIndex + 1, pageMargins, pageSizeOverride),
			cursorY: topMargin,
			columnIndex: 0,
			topMargin,
			contentBottom,
			constraintBoundaries: [],
			activeConstraintIndex: -1,
			trailingSpacing: 0,
			lastParagraphStyleId: void 0,
			lastParagraphContextualSpacing: false,
			maxCursorY: topMargin,
			pageFootnoteReserve,
			footnoteDemandThisPage: 0,
			footnoteRefsThisPage: 0,
			footnoteAnchorsThisPage: []
		};
		states.push(state);
		pages.push(state.page);
		if (opts.onNewPage) opts.onNewPage(state);
		return state;
	};
	const ensurePage = () => {
		const last = states[states.length - 1];
		if (last) return last;
		return startNewPage();
	};
	const advanceColumn = (state) => {
		const activeCols = getActiveColumnsForState(state);
		if (state.columnIndex < resolveColumnCount(activeCols) - 1) {
			state.maxCursorY = Math.max(state.maxCursorY, state.cursorY);
			state.columnIndex += 1;
			if (state.activeConstraintIndex >= 0 && state.constraintBoundaries[state.activeConstraintIndex]) state.cursorY = state.constraintBoundaries[state.activeConstraintIndex].y;
			else state.cursorY = state.topMargin;
			state.trailingSpacing = 0;
			state.lastParagraphStyleId = void 0;
			state.lastParagraphContextualSpacing = false;
			state.footnoteAnchorsThisPage = [];
			state.footnoteRefsThisPage = 0;
			return state;
		}
		return startNewPage();
	};
	const getPageByNumber = (pageNumber) => {
		return states.find((s) => s.page.number === pageNumber) ?? ensurePage();
	};
	return {
		pages,
		states,
		startNewPage,
		ensurePage,
		advanceColumn,
		getActiveColumnsForState,
		getPageByNumber,
		pruneTrailingEmptyPages
	};
}
var HEADING_STYLE_PREFIX = "heading";
var CHAPTER_MARKER_SEPARATOR_RE = /[.\-:\u2013\u2014]/;
var CLEAN_CHAPTER_MARKER_RE = /^[A-Za-z0-9]+(?:[.\-:\u2013\u2014][A-Za-z0-9]+)*$/;
function normalizeHeadingStyleId(styleId$1) {
	if (typeof styleId$1 !== "string") return;
	return styleId$1.replace(/[\s_-]+/g, "").toLowerCase();
}
function getHeadingLevel(block) {
	if (block.kind !== "paragraph") return;
	const attrs = block.attrs;
	const resolvedHeadingLevel = attrs?.headingLevel;
	if (typeof resolvedHeadingLevel === "number" && Number.isInteger(resolvedHeadingLevel) && resolvedHeadingLevel > 0) return resolvedHeadingLevel;
	const normalizedStyleId = normalizeHeadingStyleId(attrs?.styleId);
	if (!normalizedStyleId?.startsWith(HEADING_STYLE_PREFIX)) return;
	const rawLevel = normalizedStyleId.slice(7);
	if (!/^\d+$/.test(rawLevel)) return;
	const level = Number(rawLevel);
	return Number.isInteger(level) && level > 0 ? level : void 0;
}
function normalizeChapterMarkerText(markerText) {
	if (typeof markerText !== "string") return;
	const withoutSuffix = markerText.trim().replace(/[.)]\s*$/, "").trim();
	if (!withoutSuffix) return;
	return CLEAN_CHAPTER_MARKER_RE.test(withoutSuffix) ? withoutSuffix : void 0;
}
function getChapterMarkerText(block, headingLevel) {
	if (block.kind !== "paragraph") return;
	const attrs = block.attrs;
	const markerText = normalizeChapterMarkerText(attrs?.wordLayout?.marker?.markerText);
	if (markerText && markerText.split(CHAPTER_MARKER_SEPARATOR_RE).length <= headingLevel) return markerText;
	const listLevelOrdinal = attrs?.listLevelOrdinal;
	if (headingLevel === 1 && typeof listLevelOrdinal === "number" && Number.isInteger(listLevelOrdinal) && listLevelOrdinal > 0) return String(listLevelOrdinal);
}
function getBlockIdFromFragment(fragment) {
	if (typeof fragment === "object" && fragment !== null && "blockId" in fragment && typeof fragment.blockId === "string") return fragment.blockId;
}
function buildBlockById$1(blocks) {
	const blockById = /* @__PURE__ */ new Map();
	if (Array.isArray(blocks)) {
		for (const block of blocks) blockById.set(block.id, block);
		return blockById;
	}
	return blocks;
}
function getActiveChapterNumberText(activeChapterByStyle, chapterStyle) {
	for (let headingLevel = chapterStyle; headingLevel > 0; headingLevel -= 1) {
		const chapterNumberText = activeChapterByStyle.get(headingLevel);
		if (chapterNumberText) return {
			chapterNumberText,
			chapterStyle: headingLevel
		};
	}
}
function clearChildChapterNumberText(activeChapterByStyle, headingLevel) {
	for (const activeHeadingLevel of activeChapterByStyle.keys()) if (activeHeadingLevel > headingLevel) activeChapterByStyle.delete(activeHeadingLevel);
}
function buildChapterContextByPage(layout, blocks, sections) {
	const chapterStyles = /* @__PURE__ */ new Set();
	let maxChapterStyle = 0;
	const sectionByIndex = /* @__PURE__ */ new Map();
	for (const section of sections) {
		sectionByIndex.set(section.sectionIndex, section);
		const chapterStyle = section.numbering?.chapterStyle;
		if (typeof chapterStyle === "number" && Number.isInteger(chapterStyle) && chapterStyle > 0) {
			chapterStyles.add(chapterStyle);
			maxChapterStyle = Math.max(maxChapterStyle, chapterStyle);
		}
	}
	const chapterInfoByPage = /* @__PURE__ */ new Map();
	if (chapterStyles.size === 0 || layout.pages.length === 0) return chapterInfoByPage;
	const blockById = buildBlockById$1(blocks);
	const activeChapterByStyle = /* @__PURE__ */ new Map();
	for (const page of layout.pages) {
		for (const fragment of page.fragments) {
			const blockId = getBlockIdFromFragment(fragment);
			if (!blockId) continue;
			const block = blockById.get(blockId);
			if (!block) continue;
			const headingLevel = getHeadingLevel(block);
			if (!headingLevel || headingLevel > maxChapterStyle) continue;
			const chapterNumberText = getChapterMarkerText(block, headingLevel);
			if (chapterNumberText) {
				clearChildChapterNumberText(activeChapterByStyle, headingLevel);
				activeChapterByStyle.set(headingLevel, chapterNumberText);
			}
		}
		const sectionIndex = page.sectionIndex ?? 0;
		const chapterStyle = sectionByIndex.get(sectionIndex)?.numbering?.chapterStyle;
		if (!chapterStyle) continue;
		const activeChapter = getActiveChapterNumberText(activeChapterByStyle, chapterStyle);
		if (activeChapter) chapterInfoByPage.set(page.number, activeChapter);
	}
	return chapterInfoByPage;
}
function computeDisplayPageNumber(pages, sections, chapterInfoByPage) {
	const result = [];
	if (pages.length === 0) return result;
	const sectionMap = /* @__PURE__ */ new Map();
	for (const section of sections) sectionMap.set(section.sectionIndex, section);
	const sectionPageCounts = /* @__PURE__ */ new Map();
	for (const page of pages) {
		const sectionIndex = page.sectionIndex ?? 0;
		sectionPageCounts.set(sectionIndex, (sectionPageCounts.get(sectionIndex) ?? 0) + 1);
	}
	let runningCounter = 1;
	let currentSectionIndex = -1;
	let _pagesInCurrentSection = 0;
	for (let i = 0; i < pages.length; i++) {
		const page = pages[i];
		const pageSectionIndex = page.sectionIndex ?? 0;
		if (pageSectionIndex !== currentSectionIndex) {
			const sectionMetadata$1 = sectionMap.get(pageSectionIndex);
			if (sectionMetadata$1?.numbering?.start !== void 0) runningCounter = sectionMetadata$1.numbering.start;
			currentSectionIndex = pageSectionIndex;
			_pagesInCurrentSection = 0;
		}
		const sectionMetadata = sectionMap.get(pageSectionIndex);
		const format = sectionMetadata?.numbering?.format ?? "decimal";
		const chapterNumberText = (chapterInfoByPage?.get(page.number))?.chapterNumberText;
		const chapterSeparator = chapterNumberText && sectionMetadata?.numbering?.chapterStyle ? sectionMetadata.numbering.chapterSeparator ?? "hyphen" : void 0;
		const displayNumber = runningCounter;
		const displayText = formatSectionPageNumberText({
			displayNumber,
			pageFormat: format,
			chapterNumberText,
			chapterSeparator
		});
		result.push({
			physicalPage: page.number,
			displayNumber,
			displayText,
			sectionIndex: pageSectionIndex,
			sectionPageCount: sectionPageCounts.get(pageSectionIndex) ?? pages.length,
			...chapterNumberText ? { pageFormat: format } : {},
			...chapterNumberText ? { chapterNumberText } : {},
			...chapterSeparator ? { chapterSeparator } : {}
		});
		runningCounter++;
		_pagesInCurrentSection++;
	}
	return result;
}
const DEFAULT_BALANCING_CONFIG = {
	enabled: true,
	tolerance: 5,
	maxIterations: 10,
	minColumnHeight: 20
};
function calculateBalancedColumnHeight(ctx$1, config = DEFAULT_BALANCING_CONFIG) {
	if (ctx$1.columnCount <= 1) return createSingleColumnResult(ctx$1);
	if (ctx$1.contentBlocks.length === 0) return {
		targetColumnHeight: 0,
		columnAssignments: /* @__PURE__ */ new Map(),
		success: true,
		iterations: 0
	};
	const totalHeight = ctx$1.contentBlocks.reduce((sum, b$1) => sum + b$1.measuredHeight, 0);
	const maxBlockHeight = ctx$1.contentBlocks.reduce((m$1, b$1) => {
		const indivisible = b$1.canBreak && b$1.lineHeights && b$1.lineHeights.length > 1 ? Math.max(...b$1.lineHeights) : b$1.measuredHeight;
		return Math.max(m$1, indivisible);
	}, 0);
	if (totalHeight < config.minColumnHeight * ctx$1.columnCount) return createSingleColumnResult(ctx$1);
	let lo = Math.max(maxBlockHeight, config.minColumnHeight);
	let hi = Math.min(totalHeight, ctx$1.availableHeight);
	if (lo > hi) lo = hi;
	let bestResult = null;
	let bestH = hi;
	let iterations = 0;
	while (lo <= hi) {
		iterations++;
		const mid = Math.floor((lo + hi) / 2);
		const sim = simulateBalancedLayout(ctx$1, mid, config);
		const maxCol = Math.max(...sim.columnHeights);
		if (sim.assignments.size === ctx$1.contentBlocks.length && maxCol <= mid) {
			bestResult = sim;
			bestH = mid;
			hi = mid - 1;
		} else lo = mid + 1;
		if (iterations >= config.maxIterations) break;
	}
	if (bestResult) return {
		targetColumnHeight: bestH,
		columnAssignments: bestResult.assignments,
		success: true,
		iterations,
		blockBreakPoints: bestResult.breakPoints.size > 0 ? bestResult.breakPoints : void 0
	};
	return createSequentialResult(ctx$1);
}
function simulateBalancedLayout(ctx$1, targetHeight, config) {
	const assignments = /* @__PURE__ */ new Map();
	const breakPoints = /* @__PURE__ */ new Map();
	const columnHeights = new Array(ctx$1.columnCount).fill(0);
	let currentColumn = 0;
	for (let i = 0; i < ctx$1.contentBlocks.length; i++) {
		const block = ctx$1.contentBlocks[i];
		const nextBlock = ctx$1.contentBlocks[i + 1];
		if (columnHeights[currentColumn] + block.measuredHeight > targetHeight && currentColumn < ctx$1.columnCount - 1) {
			if (block.keepWithNext && nextBlock) {
				const combinedHeight = block.measuredHeight + nextBlock.measuredHeight;
				if (columnHeights[currentColumn] + combinedHeight <= targetHeight) {
					assignments.set(block.blockId, currentColumn);
					columnHeights[currentColumn] += block.measuredHeight;
					continue;
				}
			}
			if (block.canBreak && block.lineHeights && block.lineHeights.length > 1) {
				const breakPoint = calculateParagraphBreakPoint(block, targetHeight - columnHeights[currentColumn], block.orphanLines ?? 1, block.widowLines ?? 1);
				if (breakPoint.canBreak && breakPoint.breakAfterLine >= 0) {
					const heightBefore = block.lineHeights.slice(0, breakPoint.breakAfterLine + 1).reduce((sum, h$2) => sum + h$2, 0);
					const heightAfter = block.measuredHeight - heightBefore;
					breakPoints.set(block.blockId, {
						blockId: block.blockId,
						breakAfterLine: breakPoint.breakAfterLine,
						heightBeforeBreak: heightBefore,
						heightAfterBreak: heightAfter
					});
					assignments.set(block.blockId, currentColumn);
					columnHeights[currentColumn] += heightBefore;
					currentColumn++;
					columnHeights[currentColumn] += heightAfter;
					continue;
				}
			}
			currentColumn++;
		}
		assignments.set(block.blockId, currentColumn);
		columnHeights[currentColumn] += block.measuredHeight;
	}
	return {
		assignments,
		columnHeights,
		hasOverflow: columnHeights.some((h$2) => h$2 > ctx$1.availableHeight),
		breakPoints
	};
}
function calculateParagraphBreakPoint(block, availableHeight, orphanLines, widowLines) {
	if (!block.lineHeights || block.lineHeights.length === 0) return {
		breakAfterLine: -1,
		canBreak: false
	};
	const lines = block.lineHeights;
	let heightSoFar = 0;
	for (let i = 0; i < lines.length; i++) {
		heightSoFar += lines[i];
		if (heightSoFar > availableHeight) {
			const linesBeforeBreak = i;
			const linesAfterBreak = lines.length - i;
			if (linesAfterBreak < widowLines) {
				const adjustedBreak = Math.max(0, i - (widowLines - linesAfterBreak));
				if (adjustedBreak < orphanLines) return {
					breakAfterLine: -1,
					canBreak: false
				};
				return {
					breakAfterLine: adjustedBreak - 1,
					canBreak: true
				};
			}
			if (linesBeforeBreak < orphanLines) return {
				breakAfterLine: -1,
				canBreak: false
			};
			return {
				breakAfterLine: i - 1,
				canBreak: true
			};
		}
	}
	return {
		breakAfterLine: lines.length - 1,
		canBreak: true
	};
}
function createSingleColumnResult(ctx$1) {
	const assignments = /* @__PURE__ */ new Map();
	for (const block of ctx$1.contentBlocks) assignments.set(block.blockId, 0);
	return {
		targetColumnHeight: ctx$1.availableHeight,
		columnAssignments: assignments,
		success: true,
		iterations: 0
	};
}
function createSequentialResult(ctx$1) {
	const assignments = /* @__PURE__ */ new Map();
	const columnHeights = new Array(ctx$1.columnCount).fill(0);
	let currentColumn = 0;
	for (const block of ctx$1.contentBlocks) {
		if (columnHeights[currentColumn] + block.measuredHeight > ctx$1.availableHeight && currentColumn < ctx$1.columnCount - 1) currentColumn++;
		assignments.set(block.blockId, currentColumn);
		columnHeights[currentColumn] += block.measuredHeight;
	}
	return {
		targetColumnHeight: Math.max(...columnHeights),
		columnAssignments: assignments,
		success: false,
		iterations: 0
	};
}
function shouldSkipBalancing(ctx$1, config = DEFAULT_BALANCING_CONFIG) {
	if (!config.enabled) return true;
	if (ctx$1.columnCount <= 1) return true;
	if (ctx$1.contentBlocks.length === 0) return true;
	if (ctx$1.contentBlocks.length === 1) {
		if (!ctx$1.contentBlocks[0].canBreak) return true;
	}
	const totalHeight = ctx$1.contentBlocks.reduce((sum, b$1) => sum + b$1.measuredHeight, 0);
	if (totalHeight < config.minColumnHeight) return true;
	if (totalHeight / ctx$1.columnCount < config.minColumnHeight) return true;
	return false;
}
function getFragmentHeight(fragment, measureMap) {
	if (fragment.kind === "para") {
		if (fragment.lines && fragment.lines.length > 0) return fragment.lines.reduce((sum$1, l) => sum$1 + (l.lineHeight ?? 0), 0);
		const measure = measureMap.get(fragment.blockId);
		if (!measure || measure.kind !== "paragraph" || !measure.lines) return 0;
		let sum = 0;
		const fromLine = fragment.fromLine ?? 0;
		const toLine = fragment.toLine ?? measure.lines.length;
		for (let i = fromLine; i < toLine; i++) sum += measure.lines[i]?.lineHeight ?? 0;
		return sum;
	}
	if (fragment.kind === "image" || fragment.kind === "drawing" || fragment.kind === "table") {
		if (typeof fragment.height === "number" && fragment.height > 0) return fragment.height;
		const measure = measureMap.get(fragment.blockId);
		if (measure) {
			if (typeof measure.height === "number" && measure.height > 0) return measure.height;
			if (fragment.kind === "table" && typeof measure.totalHeight === "number") return measure.totalHeight;
		}
		if (typeof fragment.height === "number") return fragment.height;
	}
	return 0;
}
function getBalancingHeight(fragment, measureMap, sectPrMarkerBlockIds) {
	if (fragment.kind === "para" && sectPrMarkerBlockIds && sectPrMarkerBlockIds.has(fragment.blockId)) return 0;
	return getFragmentHeight(fragment, measureMap);
}
function allColumnWidthsEqual(widths) {
	if (widths.length <= 1) return true;
	const first$1 = widths[0];
	return widths.every((w) => Math.abs(w - first$1) <= .5);
}
function balanceSectionOnPage(args$1) {
	const { sectionColumns, sectionHasExplicitColumnBreak, sectionIndex, blockSectionMap, fragments } = args$1;
	if (sectionColumns.count <= 1) return null;
	if (sectionHasExplicitColumnBreak) return null;
	if (sectionColumns.equalWidth === false && Array.isArray(sectionColumns.widths) && sectionColumns.widths.length > 0 && !allColumnWidthsEqual(sectionColumns.widths)) return null;
	const sectionFragments = fragments.filter((f) => blockSectionMap.get(f.blockId) === sectionIndex);
	if (sectionFragments.length === 0) return null;
	const columnCount = sectionColumns.count;
	const columnGap = sectionColumns.gap;
	const columnWidth = sectionColumns.width ?? 0;
	if (columnWidth <= 0) return null;
	let sectionTopY = Number.POSITIVE_INFINITY;
	for (const f of sectionFragments) if (f.y < sectionTopY) sectionTopY = f.y;
	if (!Number.isFinite(sectionTopY)) sectionTopY = args$1.topMargin;
	const remainingHeight = args$1.availableHeight - (sectionTopY - args$1.topMargin);
	if (remainingHeight <= 0) return null;
	let precedingHeightBeforeTable = 0;
	for (const f of sectionFragments) {
		if (f.kind === "table") break;
		precedingHeightBeforeTable += getBalancingHeight(f, args$1.measureMap, args$1.sectPrMarkerBlockIds);
	}
	const splitResult = splitDominantTableAtRowBoundary({
		sectionFragments,
		fragments,
		columnCount,
		measureMap: args$1.measureMap,
		sectPrMarkerBlockIds: args$1.sectPrMarkerBlockIds,
		precedingHeight: precedingHeightBeforeTable
	});
	const ordered = [...sectionFragments].sort((a, b$1) => {
		if (a.x !== b$1.x) return a.x - b$1.x;
		return a.y - b$1.y;
	});
	const lineHeightsFor = (f) => {
		if (f.kind !== "para") return void 0;
		if (args$1.sectPrMarkerBlockIds?.has(f.blockId)) return void 0;
		if (args$1.keepLinesBlockIds?.has(f.blockId)) return void 0;
		if (f.lines && f.lines.length > 0) {
			if (f.lines.length <= 1) return void 0;
			return f.lines.map((l) => l.lineHeight);
		}
		const measure = args$1.measureMap.get(f.blockId);
		if (!measure || measure.kind !== "paragraph" || !Array.isArray(measure.lines)) return void 0;
		const fromLine = f.fromLine ?? 0;
		const toLine = f.toLine ?? measure.lines.length;
		if (toLine - fromLine <= 1) return void 0;
		return measure.lines.slice(fromLine, toLine).map((l) => l.lineHeight);
	};
	const contentBlocks = ordered.map((f, i) => {
		const lineHeights = lineHeightsFor(f);
		return {
			blockId: `${f.blockId}#${i}`,
			measuredHeight: getBalancingHeight(f, args$1.measureMap, args$1.sectPrMarkerBlockIds),
			canBreak: lineHeights !== void 0,
			keepWithNext: false,
			keepTogether: lineHeights === void 0,
			lineHeights
		};
	});
	if (shouldSkipBalancing({
		columnCount,
		columnWidth,
		columnGap,
		availableHeight: remainingHeight,
		contentBlocks
	})) {
		splitResult?.rollback();
		return null;
	}
	const result = calculateBalancedColumnHeight({
		columnCount,
		columnWidth,
		columnGap,
		availableHeight: remainingHeight,
		contentBlocks
	}, DEFAULT_BALANCING_CONFIG);
	const balancedGeometry = getColumnGeometry({
		count: columnCount,
		gap: columnGap,
		width: columnWidth,
		...Array.isArray(sectionColumns.widths) ? { widths: sectionColumns.widths } : {},
		...Array.isArray(sectionColumns.gaps) ? { gaps: sectionColumns.gaps } : {}
	});
	const columnX = (columnIndex) => getColumnX(balancedGeometry, columnIndex, args$1.margins.left);
	const colCursors = new Array(columnCount).fill(sectionTopY);
	let maxY = sectionTopY;
	for (let i = 0; i < ordered.length; i++) {
		const f = ordered[i];
		const block = contentBlocks[i];
		const col = result.columnAssignments.get(block.blockId) ?? 0;
		f.x = columnX(col);
		f.y = colCursors[col];
		f.width = columnWidth;
		const bp = result.blockBreakPoints?.get(block.blockId);
		if (bp && bp.heightAfterBreak > 0 && col < columnCount - 1) {
			const splitLine = (f.fromLine ?? 0) + bp.breakAfterLine + 1;
			const measureLineCount = args$1.measureMap.get(f.blockId)?.lines?.length ?? splitLine;
			const originalToLine = f.toLine ?? measureLineCount;
			const originalContinuesOnNext = f.continuesOnNext ?? false;
			const secondHalf = {
				...f,
				fromLine: splitLine,
				toLine: originalToLine,
				x: columnX(col + 1),
				y: colCursors[col + 1],
				width: columnWidth,
				continuesFromPrev: true,
				continuesOnNext: originalContinuesOnNext
			};
			if (f.lines && f.lines.length > 0) {
				secondHalf.lines = f.lines.slice(bp.breakAfterLine + 1);
				f.lines = f.lines.slice(0, bp.breakAfterLine + 1);
			}
			f.toLine = splitLine;
			f.continuesOnNext = true;
			colCursors[col] += bp.heightBeforeBreak;
			colCursors[col + 1] += bp.heightAfterBreak;
			const fragIdx = fragments.indexOf(f);
			if (fragIdx >= 0) fragments.splice(fragIdx + 1, 0, secondHalf);
			if (colCursors[col] > maxY) maxY = colCursors[col];
			if (colCursors[col + 1] > maxY) maxY = colCursors[col + 1];
			continue;
		}
		colCursors[col] += block.measuredHeight;
		if (colCursors[col] > maxY) maxY = colCursors[col];
	}
	return { maxY };
}
function splitDominantTableAtRowBoundary(args$1) {
	const { sectionFragments, fragments, columnCount, measureMap, sectPrMarkerBlockIds } = args$1;
	const precedingHeight = Math.max(0, args$1.precedingHeight ?? 0);
	if (columnCount <= 1) return null;
	const tables = sectionFragments.filter((f) => f.kind === "table");
	if (tables.length !== 1) return null;
	const table = tables[0];
	const fromRow = table.fromRow ?? 0;
	const toRow = table.toRow ?? fromRow;
	if (toRow - fromRow < 2) return null;
	const measure = measureMap.get(table.blockId);
	if (!measure || measure.kind !== "table" || !Array.isArray(measure.rows)) return null;
	const totalSectionHeight = sectionFragments.reduce((sum, f) => sum + getBalancingHeight(f, measureMap, sectPrMarkerBlockIds), 0);
	if (totalSectionHeight <= 0) return null;
	const target = Math.max(1, totalSectionHeight / columnCount - precedingHeight);
	if (getBalancingHeight(table, measureMap, sectPrMarkerBlockIds) <= target + 1) return null;
	let running = 0;
	let splitRow = fromRow + 1;
	for (let r$1 = fromRow; r$1 < toRow - 1; r$1++) {
		const h$2 = measure.rows[r$1]?.height ?? 0;
		if (running + h$2 >= target) {
			splitRow = r$1 + 1;
			break;
		}
		running += h$2;
		splitRow = r$1 + 2;
	}
	if (splitRow <= fromRow || splitRow >= toRow) return null;
	const firstHalfRows = measure.rows.slice(fromRow, splitRow);
	const secondHalfRows = measure.rows.slice(splitRow, toRow);
	const firstHalfHeight = firstHalfRows.reduce((s, r$1) => s + (r$1.height ?? 0), 0);
	const secondHalfHeight = secondHalfRows.reduce((s, r$1) => s + (r$1.height ?? 0), 0);
	const makeRowBoundaries = (rows, startIndex) => {
		const out = [];
		let y$1 = .5;
		for (let i = 0; i < rows.length; i++) {
			const h$2 = rows[i].height ?? 0;
			out.push({
				index: startIndex + i,
				y: y$1,
				height: h$2,
				minHeight: h$2,
				resizable: true
			});
			y$1 += h$2;
		}
		return out;
	};
	const originalMetadata = table.metadata;
	const firstMetadata = originalMetadata ? {
		...originalMetadata,
		rowBoundaries: makeRowBoundaries(firstHalfRows, 0)
	} : void 0;
	const secondMetadata = originalMetadata ? {
		...originalMetadata,
		rowBoundaries: makeRowBoundaries(secondHalfRows, 0)
	} : void 0;
	const originalToRow = table.toRow;
	const originalHeight = table.height;
	const originalContinuesOnNext = table.continuesOnNext ?? false;
	table.toRow = splitRow;
	table.height = firstHalfHeight;
	table.continuesOnNext = true;
	if (firstMetadata) table.metadata = firstMetadata;
	const secondHalf = {
		...table,
		fromRow: splitRow,
		toRow,
		height: secondHalfHeight,
		continuesFromPrev: true,
		continuesOnNext: originalContinuesOnNext,
		metadata: secondMetadata ?? table.metadata
	};
	const fragIdx = fragments.indexOf(table);
	if (fragIdx >= 0) fragments.splice(fragIdx + 1, 0, secondHalf);
	const sectIdx = sectionFragments.indexOf(table);
	if (sectIdx >= 0) sectionFragments.splice(sectIdx + 1, 0, secondHalf);
	return {
		applied: true,
		rollback: () => {
			table.toRow = originalToRow;
			table.height = originalHeight;
			table.continuesOnNext = originalContinuesOnNext;
			table.metadata = originalMetadata;
			const fIdx = fragments.indexOf(secondHalf);
			if (fIdx >= 0) fragments.splice(fIdx, 1);
			const sIdx = sectionFragments.indexOf(secondHalf);
			if (sIdx >= 0) sectionFragments.splice(sIdx, 1);
		}
	};
}
function resolvePageNumberTokens(layout, blocks, measures, numberingCtx) {
	const affectedBlockIds = /* @__PURE__ */ new Set();
	const updatedBlocks = /* @__PURE__ */ new Map();
	if (!layout?.pages || layout.pages.length === 0) return {
		affectedBlockIds,
		updatedBlocks
	};
	if (!numberingCtx || !numberingCtx.displayPages || numberingCtx.totalPages < 1) {
		console.warn("[resolvePageTokens] Invalid numbering context - skipping resolution");
		return {
			affectedBlockIds,
			updatedBlocks
		};
	}
	const blockMap = /* @__PURE__ */ new Map();
	const blockHasTokensFlags = /* @__PURE__ */ new Map();
	for (let i = 0; i < blocks.length; i++) {
		const block = blocks[i];
		blockMap.set(block.id, block);
		if (block.kind === "paragraph" && block.attrs && "hasPageTokens" in block.attrs) blockHasTokensFlags.set(block.id, Boolean(block.attrs.hasPageTokens));
	}
	const totalPagesStr = String(numberingCtx.totalPages);
	const processedBlocks = /* @__PURE__ */ new Set();
	for (const page of layout.pages) {
		const pageIndex = page.number - 1;
		const displayPageInfo = numberingCtx.displayPages[pageIndex];
		if (!displayPageInfo) {
			console.warn(`[resolvePageTokens] No display page info for page ${page.number} - skipping`);
			continue;
		}
		const sectionPageCount = displayPageInfo.sectionPageCount || numberingCtx.totalPages || 1;
		for (const fragment of page.fragments) if (fragment.kind === "para") {
			const blockId = fragment.blockId;
			if (processedBlocks.has(blockId)) continue;
			if (blockHasTokensFlags.get(blockId) === false) continue;
			const block = blockMap.get(blockId);
			if (!block || block.kind !== "paragraph") continue;
			if (!hasPageTokens$1(block)) {
				processedBlocks.add(blockId);
				continue;
			}
			const clonedBlock = cloneBlockWithResolvedTokens(block, displayPageInfo, totalPagesStr, numberingCtx.totalPages, sectionPageCount);
			if (!clonedBlock) {
				processedBlocks.add(blockId);
				continue;
			}
			updatedBlocks.set(blockId, clonedBlock);
			affectedBlockIds.add(blockId);
			processedBlocks.add(blockId);
			continue;
		}
	}
	return {
		affectedBlockIds,
		updatedBlocks
	};
}
function hasPageTokens$1(block) {
	for (const run of block.runs) if ("token" in run && (run.token === "pageNumber" || run.token === "totalPageCount" || run.token === "sectionPageCount")) return true;
	return false;
}
function cloneBlockWithResolvedTokens(block, displayPageInfo, totalPagesStr, totalPages, sectionPageCount) {
	let changed = false;
	const clonedRuns = block.runs.map((run) => {
		if ("token" in run && run.token) {
			if (run.token === "pageNumber") {
				const resolvedText = run.pageNumberFieldFormat ? formatChapterPageNumberText({
					pageComponent: formatPageNumberFieldValue(displayPageInfo.displayNumber, run.pageNumberFieldFormat),
					chapterNumberText: displayPageInfo.chapterNumberText,
					chapterSeparator: displayPageInfo.chapterSeparator
				}) : displayPageInfo.chapterNumberText ? formatSectionPageNumberText({
					displayNumber: displayPageInfo.displayNumber,
					pageFormat: displayPageInfo.pageFormat ?? "decimal",
					chapterNumberText: displayPageInfo.chapterNumberText,
					chapterSeparator: displayPageInfo.chapterSeparator
				}) : displayPageInfo.displayText;
				changed ||= run.text !== resolvedText;
				return {
					...run,
					text: resolvedText
				};
			} else if (run.token === "totalPageCount") {
				const resolvedText = run.pageNumberFieldFormat ? formatPageNumberFieldValue(totalPages, run.pageNumberFieldFormat) : totalPagesStr;
				changed ||= run.text !== resolvedText;
				return {
					...run,
					text: resolvedText
				};
			} else if (run.token === "sectionPageCount") {
				const resolvedText = run.pageNumberFieldFormat ? formatPageNumberFieldValue(sectionPageCount, run.pageNumberFieldFormat) : String(sectionPageCount);
				changed ||= run.text !== resolvedText;
				return {
					...run,
					text: resolvedText
				};
			}
		}
		return run;
	});
	return changed ? {
		...block,
		runs: clonedRuns
	} : void 0;
}
init_dist();
var getColumnWidthAt = (columns, columnIndex) => {
	if (Array.isArray(columns.widths) && columns.widths.length > 0) return columns.widths[Math.max(0, Math.min(columnIndex, columns.widths.length - 1))] ?? columns.width;
	return columns.width;
};
var DEFAULT_PARAGRAPH_LINE_HEIGHT_PX = 20;
const SEMANTIC_PAGE_HEIGHT_PX = 1e6;
function hasHeight(fragment) {
	return fragment.kind === "image" || fragment.kind === "drawing" || fragment.kind === "table";
}
function getParagraphSpacingBefore(block) {
	const spacing = block.attrs?.spacing;
	const value = spacing?.before ?? spacing?.lineSpaceBefore;
	if (shouldSuppressSpacingForEmpty(block, "before")) return 0;
	return typeof value === "number" && Number.isFinite(value) && value > 0 ? value : 0;
}
function getParagraphSpacingAfter$1(block) {
	const spacing = block.attrs?.spacing;
	const value = spacing?.after ?? spacing?.lineSpaceAfter;
	if (shouldSuppressSpacingForEmpty(block, "after")) return 0;
	return typeof value === "number" && Number.isFinite(value) && value > 0 ? value : 0;
}
function getMeasureHeight(block, measure) {
	switch (measure.kind) {
		case "paragraph": return measure.totalHeight;
		case "table": return measure.totalHeight;
		case "list": return measure.totalHeight;
		case "image":
		case "drawing": return measure.height;
		case "sectionBreak":
		case "pageBreak":
		case "columnBreak": return 0;
		default: return block.kind === "paragraph" ? DEFAULT_PARAGRAPH_LINE_HEIGHT_PX : 0;
	}
}
function buildSectionAwareReferenceKey(refId, sectionIndex) {
	return `${refId}::s${sectionIndex}`;
}
function computeKeepNextChains(blocks) {
	const chains = /* @__PURE__ */ new Map();
	const processedIndices = /* @__PURE__ */ new Set();
	for (let i = 0; i < blocks.length; i++) {
		if (processedIndices.has(i)) continue;
		const block = blocks[i];
		if (block.kind !== "paragraph") continue;
		if (block.attrs?.keepNext !== true) continue;
		const memberIndices = [i];
		let endIndex = i;
		for (let j = i + 1; j < blocks.length; j++) {
			const nextBlock = blocks[j];
			if (nextBlock.kind === "sectionBreak" || nextBlock.kind === "pageBreak" || nextBlock.kind === "columnBreak") break;
			if (nextBlock.kind !== "paragraph") break;
			if (nextBlock.attrs?.keepNext === true) {
				memberIndices.push(j);
				endIndex = j;
				processedIndices.add(j);
			} else break;
		}
		const anchorIndex = endIndex + 1 < blocks.length ? endIndex + 1 : -1;
		if (anchorIndex !== -1) {
			const anchorBlock = blocks[anchorIndex];
			if (anchorBlock.kind === "sectionBreak" || anchorBlock.kind === "pageBreak" || anchorBlock.kind === "columnBreak") {
				if (memberIndices.length > 1) chains.set(i, {
					startIndex: i,
					endIndex,
					memberIndices,
					anchorIndex: -1
				});
				continue;
			}
		}
		chains.set(i, {
			startIndex: i,
			endIndex,
			memberIndices,
			anchorIndex
		});
	}
	return chains;
}
function calculateChainHeight(chain, blocks, measures, state) {
	let totalHeight = 0;
	let prevStyleId;
	let prevSpacingAfter = 0;
	let prevContextualSpacing = false;
	let isFirstMember = true;
	for (const memberIndex of chain.memberIndices) {
		const block = blocks[memberIndex];
		const measure = measures[memberIndex];
		if (!measure) continue;
		const spacingBefore = getParagraphSpacingBefore(block);
		const spacingAfter = getParagraphSpacingAfter$1(block);
		const styleId$1 = typeof block.attrs?.styleId === "string" ? block.attrs?.styleId : void 0;
		const contextualSpacing = block.attrs?.contextualSpacing === true;
		if (isFirstMember) {
			const prevTrailing = Number.isFinite(state.trailingSpacing) && state.trailingSpacing > 0 ? state.trailingSpacing : 0;
			const prevSuppressAfter = shouldSuppressOwnSpacing(state.lastParagraphStyleId, state.lastParagraphContextualSpacing, styleId$1);
			const currSuppressBefore = shouldSuppressOwnSpacing(styleId$1, contextualSpacing, state.lastParagraphStyleId);
			let effectiveSpacingBefore;
			if (prevSuppressAfter && currSuppressBefore) effectiveSpacingBefore = 0;
			else if (prevSuppressAfter) effectiveSpacingBefore = spacingBefore;
			else if (currSuppressBefore) effectiveSpacingBefore = 0;
			else effectiveSpacingBefore = Math.max(spacingBefore - prevTrailing, 0);
			totalHeight += effectiveSpacingBefore;
			isFirstMember = false;
		} else {
			const prevSuppressAfter = shouldSuppressOwnSpacing(prevStyleId, prevContextualSpacing, styleId$1);
			const currSuppressBefore = shouldSuppressOwnSpacing(styleId$1, contextualSpacing, prevStyleId);
			const effectiveSpacingAfterPrev = prevSuppressAfter ? 0 : prevSpacingAfter;
			const effectiveSpacingBefore = currSuppressBefore ? 0 : spacingBefore;
			totalHeight += Math.max(effectiveSpacingAfterPrev, effectiveSpacingBefore);
		}
		totalHeight += getMeasureHeight(block, measure);
		prevStyleId = styleId$1;
		prevSpacingAfter = spacingAfter;
		prevContextualSpacing = contextualSpacing;
	}
	if (chain.anchorIndex !== -1) {
		const anchorBlock = blocks[chain.anchorIndex];
		const anchorMeasure = measures[chain.anchorIndex];
		if (anchorBlock && anchorMeasure) {
			if (anchorBlock.kind === "paragraph" && anchorMeasure.kind === "paragraph") {
				const anchorSpacingBefore = getParagraphSpacingBefore(anchorBlock);
				const anchorStyleId = typeof anchorBlock.attrs?.styleId === "string" ? anchorBlock.attrs?.styleId : void 0;
				const anchorContextualSpacing = anchorBlock.attrs?.contextualSpacing === true;
				const prevSuppressAfter = shouldSuppressOwnSpacing(prevStyleId, prevContextualSpacing, anchorStyleId);
				const anchorSuppressBefore = shouldSuppressOwnSpacing(anchorStyleId, anchorContextualSpacing, prevStyleId);
				const effectiveSpacingAfterPrev = prevSuppressAfter ? 0 : prevSpacingAfter;
				const effectiveAnchorSpacingBefore = anchorSuppressBefore ? 0 : anchorSpacingBefore;
				const interParagraphSpacing = Math.max(effectiveSpacingAfterPrev, effectiveAnchorSpacingBefore);
				const firstLineHeight = anchorMeasure.lines[0]?.lineHeight;
				const anchorHeight = typeof firstLineHeight === "number" && Number.isFinite(firstLineHeight) && firstLineHeight > 0 ? firstLineHeight : getMeasureHeight(anchorBlock, anchorMeasure);
				totalHeight += interParagraphSpacing + anchorHeight;
			} else if (!(anchorBlock.kind === "table" && anchorBlock.anchor?.isAnchored === true)) {
				let anchorHeight = getMeasureHeight(anchorBlock, anchorMeasure);
				if (anchorBlock.kind === "table" && anchorMeasure.kind === "table" && anchorMeasure.rows.length > 0) {
					const firstRowHeight = anchorMeasure.rows[0]?.height;
					if (typeof firstRowHeight === "number" && Number.isFinite(firstRowHeight) && firstRowHeight > 0) anchorHeight = firstRowHeight;
				}
				totalHeight += prevSpacingAfter + anchorHeight;
			}
		}
	}
	return totalHeight;
}
var DEFAULT_PAGE_SIZE$2 = {
	w: 612,
	h: 792
};
var DEFAULT_MARGINS$2 = {
	top: 72,
	right: 72,
	bottom: 72,
	left: 72
};
var COLUMN_EPSILON$1 = 1e-4;
var PAGE_START_EPSILON = 1e-4;
var asBoolean = (value) => {
	if (value === true || value === 1) return true;
	if (typeof value === "string") {
		const normalized = value.toLowerCase();
		return normalized === "true" || normalized === "1" || normalized === "on";
	}
	return false;
};
var shouldSkipRedundantPageBreakBefore = (block, state) => {
	if (block.attrs?.source !== "pageBreakBefore") return false;
	if (!state) return true;
	return state.page.fragments.length === 0 && state.columnIndex === 0 && Math.abs(state.cursorY - state.topMargin) <= PAGE_START_EPSILON;
};
var isExplicitPageBreakBlock = (block) => {
	return block?.kind === "pageBreak" && block.attrs?.source !== "pageBreakBefore";
};
var isEmptyParagraphBlock = (block) => {
	if (block?.kind !== "paragraph") return false;
	const paragraph = block;
	if (paragraph.attrs?.numberingProperties || paragraph.attrs?.wordLayout?.marker) return false;
	return (paragraph.runs ?? []).every((run) => (run.kind === void 0 || run.kind === "text") && run.text === "");
};
var isPageBreakBeforeSatisfiedByExplicitBreak = (blocks, index) => {
	const block = blocks[index];
	if (block?.kind !== "pageBreak" || block.attrs?.source !== "pageBreakBefore") return false;
	return isEmptyParagraphBlock(blocks[index - 1]) && isExplicitPageBreakBlock(blocks[index - 2]);
};
var hasOnlySectionBreakBlocks = (blocks) => {
	return blocks.length > 0 && blocks.every((block) => block.kind === "sectionBreak");
};
var layoutDebugEnabled$2 = typeof process$1$1 !== "undefined" && typeof process$1$1.env !== "undefined" && Boolean(process$1$1.env.SD_DEBUG_LAYOUT);
var layoutLog = (...args$1) => {
	if (!layoutDebugEnabled$2) return;
	console.log(...args$1);
};
function layoutDocument(blocks, measures, options = {}) {
	if (blocks.length !== measures.length) throw new Error(`layoutDocument expected measures for every block (blocks=${blocks.length}, measures=${measures.length})`);
	const pageSize = options.pageSize ?? DEFAULT_PAGE_SIZE$2;
	const margins = {
		top: options.margins?.top ?? DEFAULT_MARGINS$2.top,
		right: options.margins?.right ?? DEFAULT_MARGINS$2.right,
		bottom: options.margins?.bottom ?? DEFAULT_MARGINS$2.bottom,
		left: options.margins?.left ?? DEFAULT_MARGINS$2.left,
		header: options.margins?.header ?? options.margins?.top ?? DEFAULT_MARGINS$2.top,
		footer: options.margins?.footer ?? options.margins?.bottom ?? DEFAULT_MARGINS$2.bottom
	};
	if (pageSize.w - (margins.left + margins.right) <= 0) throw new Error("layoutDocument: pageSize and margins yield non-positive content area");
	const validateContentHeight = (height) => {
		if (height === void 0) return 0;
		if (!Number.isFinite(height) || height < 0) return 0;
		return height;
	};
	const headerContentHeights = options.headerContentHeights;
	const footerContentHeights = options.footerContentHeights;
	const headerContentHeightsByRId = options.headerContentHeightsByRId;
	const headerContentHeightsBySectionRef = options.headerContentHeightsBySectionRef;
	const footerContentHeightsByRId = options.footerContentHeightsByRId;
	const footerContentHeightsBySectionRef = options.footerContentHeightsBySectionRef;
	const getHeaderHeightForPage = (variantType, headerRef, sectionIndex) => {
		if (headerRef && sectionIndex != null) {
			const sectionKey = buildSectionAwareReferenceKey(headerRef, sectionIndex);
			if (headerContentHeightsBySectionRef?.has(sectionKey)) return validateContentHeight(headerContentHeightsBySectionRef.get(sectionKey));
		}
		if (headerRef && headerContentHeightsByRId?.has(headerRef)) return validateContentHeight(headerContentHeightsByRId.get(headerRef));
		if (headerContentHeights) return validateContentHeight(headerContentHeights[variantType]);
		return 0;
	};
	const getFooterHeightForPage = (variantType, footerRef, sectionIndex) => {
		if (footerRef && sectionIndex != null) {
			const sectionKey = buildSectionAwareReferenceKey(footerRef, sectionIndex);
			if (footerContentHeightsBySectionRef?.has(sectionKey)) return validateContentHeight(footerContentHeightsBySectionRef.get(sectionKey));
		}
		if (footerRef && footerContentHeightsByRId?.has(footerRef)) return validateContentHeight(footerContentHeightsByRId.get(footerRef));
		if (footerContentHeights) return validateContentHeight(footerContentHeights[variantType]);
		return 0;
	};
	const calculateEffectiveTopMargin = (headerContentHeight, currentHeaderDistance, baseTopMargin) => {
		if (headerContentHeight > 0) return Math.max(baseTopMargin, currentHeaderDistance + headerContentHeight);
		return baseTopMargin;
	};
	const calculateEffectiveBottomMargin = (footerContentHeight, currentFooterDistance, baseBottomMargin) => {
		if (footerContentHeight > 0) return Math.max(baseBottomMargin, currentFooterDistance + footerContentHeight);
		return baseBottomMargin;
	};
	const MIN_BODY_CONTENT_HEIGHT = 1;
	const clampHeaderFooterInflatedMargins = (topMargin, bottomMargin, baseTopMargin, baseBottomMargin, currentPageHeight) => {
		const maxMarginTotal = currentPageHeight - MIN_BODY_CONTENT_HEIGHT;
		if (topMargin + bottomMargin <= maxMarginTotal) return {
			top: topMargin,
			bottom: bottomMargin
		};
		const baseMarginTotal = baseTopMargin + baseBottomMargin;
		if (baseMarginTotal >= maxMarginTotal) return {
			top: topMargin,
			bottom: bottomMargin
		};
		const topInflation = Math.max(0, topMargin - baseTopMargin);
		const bottomInflation = Math.max(0, bottomMargin - baseBottomMargin);
		const totalInflation = topInflation + bottomInflation;
		if (totalInflation <= 0) return {
			top: topMargin,
			bottom: bottomMargin
		};
		const availableInflation = maxMarginTotal - baseMarginTotal;
		return {
			top: baseTopMargin + availableInflation * (topInflation / totalInflation),
			bottom: baseBottomMargin + availableInflation * (bottomInflation / totalInflation)
		};
	};
	const maxHeaderContentHeight = headerContentHeights ? Math.max(0, validateContentHeight(headerContentHeights.default), validateContentHeight(headerContentHeights.first), validateContentHeight(headerContentHeights.even), validateContentHeight(headerContentHeights.odd)) : 0;
	const maxFooterContentHeight = footerContentHeights ? Math.max(0, validateContentHeight(footerContentHeights.default), validateContentHeight(footerContentHeights.first), validateContentHeight(footerContentHeights.even), validateContentHeight(footerContentHeights.odd)) : 0;
	const headerDistance = margins.header ?? margins.top;
	const footerDistance = margins.footer ?? margins.bottom;
	const effectiveMargins = clampHeaderFooterInflatedMargins(calculateEffectiveTopMargin(0, headerDistance, margins.top), calculateEffectiveBottomMargin(0, footerDistance, margins.bottom), margins.top, margins.bottom, pageSize.h);
	let activeTopMargin = effectiveMargins.top;
	let activeBottomMargin = effectiveMargins.bottom;
	let activeLeftMargin = margins.left;
	let activeRightMargin = margins.right;
	let pendingTopMargin = null;
	let pendingBottomMargin = null;
	let pendingLeftMargin = null;
	let pendingRightMargin = null;
	let activeSectionBaseTopMargin = margins.top;
	let activeSectionBaseBottomMargin = margins.bottom;
	let pendingSectionBaseTopMargin = null;
	let pendingSectionBaseBottomMargin = null;
	let activeHeaderDistance = margins.header ?? margins.top;
	let pendingHeaderDistance = null;
	let activeFooterDistance = margins.footer ?? margins.bottom;
	let pendingFooterDistance = null;
	let activePageSize = {
		w: pageSize.w,
		h: pageSize.h
	};
	let pendingPageSize = null;
	let activeColumns = cloneColumnLayout(options.columns);
	let pendingColumns = null;
	const allowParagraphlessAnchoredTableFallback = options.allowParagraphlessAnchoredTableFallback !== false;
	const allowParagraphlessAnchoredDrawingFallback = options.allowParagraphlessAnchoredDrawingFallback !== false;
	const allowSectionBreakOnlyPageFallback = options.allowSectionBreakOnlyPageFallback !== false;
	let activeOrientation = null;
	let pendingOrientation = null;
	let activeVAlign = null;
	let pendingVAlign = void 0;
	const paginatorMargins = {
		left: activeLeftMargin,
		right: activeRightMargin
	};
	const floatManager = createFloatingObjectManager(normalizeColumns(activeColumns, activePageSize.w - (activeLeftMargin + activeRightMargin)), {
		left: activeLeftMargin,
		right: activeRightMargin
	}, activePageSize.w);
	const nextSectionPropsAtBreak = computeNextSectionPropsAtBreak(blocks);
	const scheduleSectionBreakCompat = (block, state, baseMargins) => {
		if (typeof scheduleSectionBreak === "function") return scheduleSectionBreak(block, state, baseMargins, maxHeaderContentHeight, maxFooterContentHeight);
		const next = { ...state };
		if (block.attrs?.isFirstSection && !next.hasAnyPages) {
			if (block.pageSize) {
				next.activePageSize = {
					w: block.pageSize.w,
					h: block.pageSize.h
				};
				next.pendingPageSize = null;
			}
			if (block.orientation) {
				next.activeOrientation = block.orientation;
				next.pendingOrientation = null;
			}
			const headerDistance$1 = typeof block.margins?.header === "number" ? Math.max(0, block.margins.header) : next.activeHeaderDistance;
			const footerDistance$1 = typeof block.margins?.footer === "number" ? Math.max(0, block.margins.footer) : next.activeFooterDistance;
			const sectionTop = typeof block.margins?.top === "number" ? Math.max(0, block.margins.top) : baseMargins.top;
			const sectionBottom = typeof block.margins?.bottom === "number" ? Math.max(0, block.margins.bottom) : baseMargins.bottom;
			if (block.margins?.header !== void 0) {
				next.activeHeaderDistance = headerDistance$1;
				next.pendingHeaderDistance = headerDistance$1;
			}
			if (block.margins?.footer !== void 0) {
				next.activeFooterDistance = footerDistance$1;
				next.pendingFooterDistance = footerDistance$1;
			}
			if (block.margins?.top !== void 0 || block.margins?.header !== void 0) {
				const requiredTop = maxHeaderContentHeight > 0 ? headerDistance$1 + maxHeaderContentHeight : 0;
				next.activeTopMargin = Math.max(sectionTop, requiredTop);
				next.pendingTopMargin = next.activeTopMargin;
			}
			if (block.margins?.bottom !== void 0 || block.margins?.footer !== void 0) {
				const requiredBottom = maxFooterContentHeight > 0 ? footerDistance$1 + maxFooterContentHeight : 0;
				next.activeBottomMargin = Math.max(sectionBottom, requiredBottom);
				next.pendingBottomMargin = next.activeBottomMargin;
			}
			if (block.margins?.left !== void 0) {
				const leftMargin = Math.max(0, block.margins.left);
				next.activeLeftMargin = leftMargin;
				next.pendingLeftMargin = leftMargin;
			}
			if (block.margins?.right !== void 0) {
				const rightMargin = Math.max(0, block.margins.right);
				next.activeRightMargin = rightMargin;
				next.pendingRightMargin = rightMargin;
			}
			if (block.columns) {
				next.activeColumns = cloneColumnLayout(block.columns);
				next.pendingColumns = null;
			} else {
				next.activeColumns = cloneColumnLayout(void 0);
				next.pendingColumns = null;
			}
			if (block.headerRefs || block.footerRefs) {
				pendingSectionRefs = mergeSectionRefs(pendingSectionRefs ?? activeSectionRefs, {
					...block.headerRefs && { headerRefs: block.headerRefs },
					...block.footerRefs && { footerRefs: block.footerRefs }
				});
				layoutLog(`[Layout] First section: Scheduled pendingSectionRefs:`, pendingSectionRefs);
			}
			const firstSectionIndexRaw = block.attrs?.sectionIndex;
			const firstMetadataIndex = typeof firstSectionIndexRaw === "number" ? firstSectionIndexRaw : Number(firstSectionIndexRaw ?? NaN);
			if (Number.isFinite(firstMetadataIndex)) activeSectionIndex = firstMetadataIndex;
			const firstSectionMetadata = Number.isFinite(firstMetadataIndex) ? getSectionMetadata(firstMetadataIndex) : void 0;
			if (firstSectionMetadata?.numbering) {
				if (firstSectionMetadata.numbering.format) activeNumberFormat = firstSectionMetadata.numbering.format;
				if (typeof firstSectionMetadata.numbering.start === "number") activePageCounter = firstSectionMetadata.numbering.start;
			}
			return {
				decision: {
					forcePageBreak: false,
					forceMidPageRegion: false
				},
				state: next
			};
		}
		const headerPx = block.margins?.header;
		const footerPx = block.margins?.footer;
		const topPx = block.margins?.top;
		const bottomPx = block.margins?.bottom;
		const leftPx = block.margins?.left;
		const rightPx = block.margins?.right;
		const nextTop = next.pendingTopMargin ?? next.activeTopMargin;
		const nextBottom = next.pendingBottomMargin ?? next.activeBottomMargin;
		const nextLeft = next.pendingLeftMargin ?? next.activeLeftMargin;
		const nextRight = next.pendingRightMargin ?? next.activeRightMargin;
		const nextHeader = next.pendingHeaderDistance ?? next.activeHeaderDistance;
		const nextFooter = next.pendingFooterDistance ?? next.activeFooterDistance;
		next.pendingHeaderDistance = typeof headerPx === "number" ? Math.max(0, headerPx) : nextHeader;
		next.pendingFooterDistance = typeof footerPx === "number" ? Math.max(0, footerPx) : nextFooter;
		if (typeof headerPx === "number" || typeof topPx === "number") {
			const sectionTop = typeof topPx === "number" ? Math.max(0, topPx) : baseMargins.top;
			const sectionHeader = next.pendingHeaderDistance;
			const requiredTop = maxHeaderContentHeight > 0 ? sectionHeader + maxHeaderContentHeight : sectionHeader;
			next.pendingTopMargin = Math.max(sectionTop, requiredTop);
		} else next.pendingTopMargin = nextTop;
		if (typeof footerPx === "number" || typeof bottomPx === "number") {
			const sectionFooter = next.pendingFooterDistance;
			const sectionBottom = typeof bottomPx === "number" ? Math.max(0, bottomPx) : baseMargins.bottom;
			const requiredBottom = maxFooterContentHeight > 0 ? sectionFooter + maxFooterContentHeight : sectionFooter;
			next.pendingBottomMargin = Math.max(sectionBottom, requiredBottom);
		} else next.pendingBottomMargin = nextBottom;
		next.pendingLeftMargin = typeof leftPx === "number" ? Math.max(0, leftPx) : nextLeft;
		next.pendingRightMargin = typeof rightPx === "number" ? Math.max(0, rightPx) : nextRight;
		if (block.pageSize) next.pendingPageSize = {
			w: block.pageSize.w,
			h: block.pageSize.h
		};
		if (block.orientation) next.pendingOrientation = block.orientation;
		const sectionType = block.type ?? "continuous";
		const isColumnsChanging = block.columns && !columnRenderLayoutsEqual(block.columns, next.activeColumns) || !block.columns && (resolveColumnCount(next.activeColumns) > 1 || Boolean(next.activeColumns.withSeparator));
		const sectionIndexRaw = block.attrs?.sectionIndex;
		const metadataIndex = typeof sectionIndexRaw === "number" ? sectionIndexRaw : Number(sectionIndexRaw ?? NaN);
		if (Number.isFinite(metadataIndex)) pendingSectionIndex = metadataIndex;
		const sectionMetadata = Number.isFinite(metadataIndex) ? getSectionMetadata(metadataIndex) : void 0;
		if (sectionMetadata?.numbering) pendingNumbering = { ...sectionMetadata.numbering };
		else if (block.numbering) pendingNumbering = { ...block.numbering };
		if (block.headerRefs || block.footerRefs) {
			pendingSectionRefs = mergeSectionRefs(pendingSectionRefs ?? activeSectionRefs, {
				...block.headerRefs && { headerRefs: block.headerRefs },
				...block.footerRefs && { footerRefs: block.footerRefs }
			});
			layoutLog(`[Layout] Compat fallback: Scheduled pendingSectionRefs:`, pendingSectionRefs);
		}
		const getColumnConfig$1 = () => cloneColumnLayout(block.columns);
		if (block.attrs?.requirePageBoundary) {
			next.pendingColumns = getColumnConfig$1();
			return {
				decision: {
					forcePageBreak: true,
					forceMidPageRegion: false
				},
				state: next
			};
		}
		if (sectionType === "nextPage") {
			next.pendingColumns = getColumnConfig$1();
			return {
				decision: {
					forcePageBreak: true,
					forceMidPageRegion: false
				},
				state: next
			};
		}
		if (sectionType === "evenPage") {
			next.pendingColumns = getColumnConfig$1();
			return {
				decision: {
					forcePageBreak: true,
					forceMidPageRegion: false,
					requiredParity: "even"
				},
				state: next
			};
		}
		if (sectionType === "oddPage") {
			next.pendingColumns = getColumnConfig$1();
			return {
				decision: {
					forcePageBreak: true,
					forceMidPageRegion: false,
					requiredParity: "odd"
				},
				state: next
			};
		}
		if (isColumnsChanging) {
			next.pendingColumns = getColumnConfig$1();
			return {
				decision: {
					forcePageBreak: false,
					forceMidPageRegion: true
				},
				state: next
			};
		}
		next.pendingColumns = getColumnConfig$1();
		return {
			decision: {
				forcePageBreak: false,
				forceMidPageRegion: false
			},
			state: next
		};
	};
	const createPage = (number, pageMargins, pageSizeOverride) => {
		const page = {
			number,
			fragments: [],
			margins: pageMargins
		};
		if (pageSizeOverride) page.size = pageSizeOverride;
		if (activeOrientation) page.orientation = activeOrientation;
		if (resolveColumnCount(activeColumns) > 1) page.columns = resolveColumnLayout(activeColumns);
		if (activeVAlign && activeVAlign !== "top") {
			page.vAlign = activeVAlign;
			page.baseMargins = {
				top: activeSectionBaseTopMargin,
				bottom: activeSectionBaseBottomMargin
			};
		}
		return page;
	};
	const footnoteAnchorsByBlockId = (() => {
		const out = /* @__PURE__ */ new Map();
		const refs = options.footnotes?.refs;
		const bodyHeights = options.footnotes?.bodyHeightById;
		const firstLineHeights = options.footnotes?.firstLineHeightById;
		if (!Array.isArray(refs) || refs.length === 0 || !bodyHeights) return out;
		const resolveBlockPmRange = (block) => {
			const attrsRange = block.attrs;
			let pmStart = typeof attrsRange?.pmStart === "number" ? attrsRange.pmStart : void 0;
			let pmEnd = typeof attrsRange?.pmEnd === "number" ? attrsRange.pmEnd : void 0;
			if (pmStart == null && block.kind === "paragraph") {
				const runs = block.runs;
				if (Array.isArray(runs)) for (const run of runs) {
					const rs = run.pmStart;
					const re = run.pmEnd;
					if (typeof rs === "number") pmStart = pmStart == null ? rs : Math.min(pmStart, rs);
					if (typeof re === "number") pmEnd = pmEnd == null ? re : Math.max(pmEnd, re);
				}
			}
			if (pmStart == null) return null;
			return {
				pmStart,
				pmEnd: pmEnd ?? pmStart + 1
			};
		};
		const refByPos = /* @__PURE__ */ new Map();
		const seenIds = /* @__PURE__ */ new Set();
		for (const ref$1 of refs) {
			if (seenIds.has(ref$1.id)) continue;
			seenIds.add(ref$1.id);
			refByPos.set(ref$1.pos, ref$1.id);
		}
		const recordIfHit = (range, topLevelId) => {
			for (const [pos, refId] of refByPos.entries()) {
				if (pos < range.pmStart || pos > range.pmEnd) continue;
				const fullHeight = bodyHeights.get(refId);
				if (typeof fullHeight !== "number" || !Number.isFinite(fullHeight) || fullHeight <= 0) continue;
				const firstLineRaw = firstLineHeights?.get(refId);
				const firstLineHeight = typeof firstLineRaw === "number" && Number.isFinite(firstLineRaw) && firstLineRaw > 0 ? Math.min(firstLineRaw, fullHeight) : fullHeight;
				const list = out.get(topLevelId) ?? [];
				list.push({
					pmPos: pos,
					refId,
					fullHeight,
					firstLineHeight
				});
				out.set(topLevelId, list);
				refByPos.delete(pos);
			}
		};
		for (const block of blocks) {
			if (refByPos.size === 0) break;
			const range = resolveBlockPmRange(block);
			if (range) recordIfHit(range, block.id);
			if (block.kind === "table") for (const row of block.rows ?? []) for (const cell of row.cells ?? []) {
				const cellChildren = cell.blocks ? cell.blocks : cell.paragraph ? [cell.paragraph] : [];
				for (const child of cellChildren) {
					const childRange = resolveBlockPmRange(child);
					if (childRange) recordIfHit(childRange, block.id);
				}
			}
		}
		for (const list of out.values()) list.sort((a, b$1) => a.pmPos - b$1.pmPos);
		return out;
	})();
	const getFootnoteAnchorsForBlockId = (blockId, pmStart, pmEnd) => {
		const entries = footnoteAnchorsByBlockId.get(blockId);
		if (!entries || entries.length === 0) return [];
		if (pmStart == null || pmEnd == null) return entries;
		const out = [];
		for (const e of entries) if (e.pmPos >= pmStart && e.pmPos <= pmEnd) out.push(e);
		return out;
	};
	const getFootnoteDemandForBlockId = (blockId, pmStart, pmEnd, committed) => {
		const candidate = getFootnoteAnchorsForBlockId(blockId, pmStart, pmEnd);
		if (candidate.length === 0 && (!committed || committed.length === 0)) return 0;
		const cluster = committed && committed.length > 0 ? [...committed, ...candidate] : candidate;
		if (cluster.length === 0) return 0;
		let total = 0;
		for (let i = 0; i < cluster.length - 1; i += 1) total += cluster[i].fullHeight;
		total += cluster[cluster.length - 1].firstLineHeight;
		return total;
	};
	const getFootnoteRefCountForBlockId = (blockId, pmStart, pmEnd) => {
		const entries = footnoteAnchorsByBlockId.get(blockId);
		if (!entries || entries.length === 0) return 0;
		if (pmStart == null || pmEnd == null) return entries.length;
		let count = 0;
		for (const e of entries) if (e.pmPos >= pmStart && e.pmPos <= pmEnd) count += 1;
		return count;
	};
	const getFootnoteBandOverhead = (() => {
		const fn = options.footnotes;
		const safeNum = (v, fallback) => typeof v === "number" && Number.isFinite(v) && v >= 0 ? v : fallback;
		const topPadding = safeNum(fn?.topPadding, 6);
		const dividerHeight = safeNum(fn?.dividerHeight, 6);
		const separatorSpacingBefore = safeNum(fn?.separatorSpacingBefore, 12);
		const gap = safeNum(fn?.gap, 2);
		return (refsTotal) => {
			if (refsTotal <= 0) return 0;
			return topPadding + dividerHeight + separatorSpacingBefore + Math.max(0, refsTotal - 1) * gap;
		};
	})();
	let pageCount = 0;
	let activeNumberFormat = "decimal";
	let activePageCounter = 1;
	let activeSectionPageCounterStart = activePageCounter;
	let pendingNumbering = null;
	const normalizeRefs = (refs) => refs && Object.keys(refs).length > 0 ? refs : void 0;
	const mergeSectionRefs = (base, next) => {
		if (!base && !next) return null;
		const headerRefs = normalizeRefs(next?.headerRefs) ?? normalizeRefs(base?.headerRefs);
		const footerRefs = normalizeRefs(next?.footerRefs) ?? normalizeRefs(base?.footerRefs);
		if (!headerRefs && !footerRefs) return null;
		return {
			...headerRefs && { headerRefs },
			...footerRefs && { footerRefs }
		};
	};
	const sectionMetadataList = options.sectionMetadata ?? [];
	const getSectionMetadata = (sectionIndex) => sectionMetadataList.find((section, fallbackIndex) => (section.sectionIndex ?? fallbackIndex) === sectionIndex);
	const runtimeSectionRefsByIndex = /* @__PURE__ */ new Map();
	const buildHeaderFooterResolutionSections = () => {
		const sectionIndexes = /* @__PURE__ */ new Set();
		sectionMetadataList.forEach((section, fallbackIndex) => sectionIndexes.add(section.sectionIndex ?? fallbackIndex));
		runtimeSectionRefsByIndex.forEach((_refs, sectionIndex) => sectionIndexes.add(sectionIndex));
		if (sectionIndexes.size === 0) sectionIndexes.add(0);
		return Array.from(sectionIndexes).sort((a, b$1) => a - b$1).map((sectionIndex) => {
			const metadata = getSectionMetadata(sectionIndex);
			const runtimeRefs = runtimeSectionRefsByIndex.get(sectionIndex);
			return {
				sectionIndex,
				titlePg: metadata?.titlePg === true,
				headerRefs: runtimeRefs?.headerRefs ?? metadata?.headerRefs,
				footerRefs: runtimeRefs?.footerRefs ?? metadata?.footerRefs
			};
		});
	};
	const hasAnyHeaderFooterRefs = (sections, kind) => {
		const refKey = kind === "header" ? "headerRefs" : "footerRefs";
		return sections.some((section) => Object.values(section[refKey] ?? {}).some(Boolean));
	};
	const initialSectionMetadata = sectionMetadataList[0];
	if (initialSectionMetadata?.numbering?.format) activeNumberFormat = initialSectionMetadata.numbering.format;
	if (typeof initialSectionMetadata?.numbering?.start === "number") {
		activePageCounter = initialSectionMetadata.numbering.start;
		activeSectionPageCounterStart = activePageCounter;
	}
	let activeSectionRefs = null;
	let pendingSectionRefs = null;
	if (initialSectionMetadata?.headerRefs || initialSectionMetadata?.footerRefs) {
		activeSectionRefs = {
			...initialSectionMetadata.headerRefs && { headerRefs: initialSectionMetadata.headerRefs },
			...initialSectionMetadata.footerRefs && { footerRefs: initialSectionMetadata.footerRefs }
		};
		runtimeSectionRefsByIndex.set(initialSectionMetadata.sectionIndex ?? 0, activeSectionRefs);
	}
	if (initialSectionMetadata?.vAlign) activeVAlign = initialSectionMetadata.vAlign;
	let activeSectionIndex = initialSectionMetadata?.sectionIndex ?? 0;
	let pendingSectionIndex = null;
	const sectionFirstPageNumbers = /* @__PURE__ */ new Map();
	const readFootnoteReserveForPageIndex = (pageIndex) => {
		const reserves = options.footnoteReservedByPageIndex;
		const reserve = Array.isArray(reserves) ? reserves[pageIndex] : 0;
		return typeof reserve === "number" && Number.isFinite(reserve) && reserve > 0 ? reserve : 0;
	};
	const paginator = createPaginator({
		margins: paginatorMargins,
		getActiveTopMargin: () => activeTopMargin,
		getActiveBottomMargin: () => {
			const pageIndex = Math.max(0, pageCount - 1);
			return activeBottomMargin + readFootnoteReserveForPageIndex(pageIndex);
		},
		getFootnoteReserveForPage: (pageIndex) => readFootnoteReserveForPageIndex(pageIndex),
		getActiveHeaderDistance: () => activeHeaderDistance,
		getActiveFooterDistance: () => activeFooterDistance,
		getActivePageSize: () => activePageSize,
		getDefaultPageSize: () => pageSize,
		getActiveColumns: () => activeColumns,
		createPage,
		onNewPage: (state) => {
			if (!state) {
				const isEnteringNewSection = pendingSectionIndex !== null;
				const isApplyingPendingSection = pendingTopMargin !== null || pendingBottomMargin !== null || pendingLeftMargin !== null || pendingRightMargin !== null || pendingHeaderDistance !== null || pendingFooterDistance !== null || pendingPageSize !== null || pendingColumns !== null || pendingOrientation !== null || pendingNumbering !== null || pendingSectionRefs !== null || pendingSectionIndex !== null || pendingVAlign !== void 0 || pendingSectionBaseTopMargin !== null || pendingSectionBaseBottomMargin !== null;
				const applied = applyPendingToActive({
					activeTopMargin,
					activeBottomMargin,
					activeLeftMargin,
					activeRightMargin,
					pendingTopMargin,
					pendingBottomMargin,
					pendingLeftMargin,
					pendingRightMargin,
					activeHeaderDistance,
					activeFooterDistance,
					pendingHeaderDistance,
					pendingFooterDistance,
					activePageSize,
					pendingPageSize,
					activeColumns,
					pendingColumns,
					activeOrientation,
					pendingOrientation,
					hasAnyPages: pageCount > 0
				});
				activeTopMargin = applied.activeTopMargin;
				activeBottomMargin = applied.activeBottomMargin;
				activeLeftMargin = applied.activeLeftMargin;
				activeRightMargin = applied.activeRightMargin;
				pendingTopMargin = applied.pendingTopMargin;
				pendingBottomMargin = applied.pendingBottomMargin;
				pendingLeftMargin = applied.pendingLeftMargin;
				pendingRightMargin = applied.pendingRightMargin;
				activeHeaderDistance = applied.activeHeaderDistance;
				activeFooterDistance = applied.activeFooterDistance;
				pendingHeaderDistance = applied.pendingHeaderDistance;
				pendingFooterDistance = applied.pendingFooterDistance;
				activePageSize = applied.activePageSize;
				pendingPageSize = applied.pendingPageSize;
				activeColumns = applied.activeColumns;
				pendingColumns = applied.pendingColumns;
				activeOrientation = applied.activeOrientation;
				pendingOrientation = applied.pendingOrientation;
				cachedColumnsState.state = null;
				paginatorMargins.left = activeLeftMargin;
				paginatorMargins.right = activeRightMargin;
				const contentWidth = activePageSize.w - (activeLeftMargin + activeRightMargin);
				floatManager.setLayoutContext(normalizeColumns(activeColumns, contentWidth), {
					left: activeLeftMargin,
					right: activeRightMargin
				}, activePageSize.w);
				if (pendingNumbering) {
					if (pendingNumbering.format) activeNumberFormat = pendingNumbering.format;
					if (typeof pendingNumbering.start === "number" && Number.isFinite(pendingNumbering.start)) activePageCounter = pendingNumbering.start;
					pendingNumbering = null;
				}
				if (pendingSectionRefs) {
					activeSectionRefs = mergeSectionRefs(activeSectionRefs, pendingSectionRefs);
					pendingSectionRefs = null;
				}
				if (pendingSectionIndex !== null) {
					activeSectionIndex = pendingSectionIndex;
					pendingSectionIndex = null;
				}
				if (activeSectionRefs) runtimeSectionRefsByIndex.set(activeSectionIndex, activeSectionRefs);
				if (pendingVAlign !== void 0) {
					activeVAlign = pendingVAlign;
					pendingVAlign = void 0;
				}
				if (pendingSectionBaseTopMargin !== null) {
					activeSectionBaseTopMargin = pendingSectionBaseTopMargin;
					pendingSectionBaseTopMargin = null;
				}
				if (pendingSectionBaseBottomMargin !== null) {
					activeSectionBaseBottomMargin = pendingSectionBaseBottomMargin;
					pendingSectionBaseBottomMargin = null;
				}
				if (isApplyingPendingSection) activeSectionPageCounterStart = activePageCounter;
				pageCount += 1;
				const newPageNumber = pageCount;
				if (isEnteringNewSection || !sectionFirstPageNumbers.has(activeSectionIndex)) sectionFirstPageNumbers.set(activeSectionIndex, newPageNumber);
				const sectionPageNumber = newPageNumber - (sectionFirstPageNumbers.get(activeSectionIndex) ?? newPageNumber) + 1;
				const titlePgEnabled = getSectionMetadata(activeSectionIndex)?.titlePg ?? false;
				const alternateHeaders = options.alternateHeaders ?? false;
				const variantType = selectHeaderFooterVariantForPage({
					sectionPageNumber,
					documentPageNumber: activePageCounter,
					titlePg: titlePgEnabled,
					alternateHeaders
				});
				const resolutionSections = buildHeaderFooterResolutionSections();
				const headerResolved = variantType && resolveEffectiveHeaderFooterRef({
					sections: resolutionSections,
					sectionIndex: activeSectionIndex,
					kind: "header",
					variant: variantType
				});
				const footerResolved = variantType && resolveEffectiveHeaderFooterRef({
					sections: resolutionSections,
					sectionIndex: activeSectionIndex,
					kind: "footer",
					variant: variantType
				});
				const hasHeaderRefs = hasAnyHeaderFooterRefs(resolutionSections, "header");
				const hasFooterRefs = hasAnyHeaderFooterRefs(resolutionSections, "footer");
				const headerHeight = headerResolved ? getHeaderHeightForPage(headerResolved.matchedVariant, headerResolved.refId, activeSectionIndex) : variantType && !hasHeaderRefs ? getHeaderHeightForPage(variantType, void 0, activeSectionIndex) : 0;
				const footerHeight = footerResolved ? getFooterHeightForPage(footerResolved.matchedVariant, footerResolved.refId, activeSectionIndex) : variantType && !hasFooterRefs ? getFooterHeightForPage(variantType, void 0, activeSectionIndex) : 0;
				const adjustedMargins = clampHeaderFooterInflatedMargins(calculateEffectiveTopMargin(headerHeight, activeHeaderDistance, activeSectionBaseTopMargin), calculateEffectiveBottomMargin(footerHeight, activeFooterDistance, activeSectionBaseBottomMargin), activeSectionBaseTopMargin, activeSectionBaseBottomMargin, activePageSize.h);
				activeTopMargin = adjustedMargins.top;
				activeBottomMargin = adjustedMargins.bottom;
				layoutLog(`[Layout] Page ${newPageNumber}: Using variant '${variantType ?? "none"}' - headerHeight: ${headerHeight}, footerHeight: ${footerHeight}`);
				layoutLog(`[Layout] Page ${newPageNumber}: Adjusted margins - top: ${activeTopMargin}, bottom: ${activeBottomMargin} (base: ${activeSectionBaseTopMargin}, ${activeSectionBaseBottomMargin})`);
				return;
			}
			if (state?.page) {
				state.page.displayNumber = activePageCounter;
				state.page.numberText = formatPageNumber(activePageCounter, activeNumberFormat);
				state.page.effectivePageNumber = activePageCounter;
				state.page.sectionIndex = activeSectionIndex;
				layoutLog(`[Layout] Page ${state.page.number}: Stamped sectionIndex:`, activeSectionIndex);
				if (activeSectionRefs) {
					state.page.sectionRefs = {
						...activeSectionRefs.headerRefs && { headerRefs: activeSectionRefs.headerRefs },
						...activeSectionRefs.footerRefs && { footerRefs: activeSectionRefs.footerRefs }
					};
					layoutLog(`[Layout] Page ${state.page.number}: Stamped sectionRefs:`, state.page.sectionRefs);
				} else layoutLog(`[Layout] Page ${state.page.number}: No activeSectionRefs to stamp`);
				activePageCounter += 1;
			}
		}
	});
	const pages = paginator.pages;
	const states = paginator.states;
	const getActiveColumnsForState = paginator.getActiveColumnsForState;
	let cachedColumnsState = {
		state: null,
		constraintIndex: -2,
		contentWidth: -1,
		colsConfig: null,
		normalized: null
	};
	const getCurrentColumns = () => {
		const currentContentWidth = activePageSize.w - (activeLeftMargin + activeRightMargin);
		const state = states[states.length - 1] ?? null;
		const colsConfig = state ? getActiveColumnsForState(state) : activeColumns;
		const constraintIndex = state ? state.activeConstraintIndex : -1;
		if (cachedColumnsState.state === state && cachedColumnsState.constraintIndex === constraintIndex && cachedColumnsState.contentWidth === currentContentWidth && columnRenderLayoutsEqual(cachedColumnsState.colsConfig ?? void 0, colsConfig) && cachedColumnsState.normalized) return cachedColumnsState.normalized;
		const normalized = normalizeColumns(colsConfig, currentContentWidth);
		cachedColumnsState = {
			state,
			constraintIndex,
			contentWidth: currentContentWidth,
			colsConfig: cloneColumnLayout(colsConfig),
			normalized
		};
		return normalized;
	};
	const getColumnGeometryForState = (state) => {
		return getColumnGeometry(normalizeColumns(state.activeConstraintIndex >= 0 && state.constraintBoundaries[state.activeConstraintIndex] ? state.constraintBoundaries[state.activeConstraintIndex].columns : state.page.columns ?? {
			count: 1,
			gap: 0
		}, (state.page.size?.w ?? pageSize.w) - ((state.page.margins?.left ?? activeLeftMargin) + (state.page.margins?.right ?? activeRightMargin))));
	};
	const columnWidthForState = (state, columnIndex = state.columnIndex) => getColumnWidth(getColumnGeometryForState(state), columnIndex);
	const columnXForState = (state, columnIndex = state.columnIndex) => getColumnX(getColumnGeometryForState(state), columnIndex, state.page.margins?.left ?? activeLeftMargin);
	const getCurrentColumnWidth = () => {
		const state = states[states.length - 1] ?? null;
		return state ? columnWidthForState(state) : getColumnWidthAt(getCurrentColumns(), 0);
	};
	const columnX = columnXForState;
	const advanceColumn = paginator.advanceColumn;
	const startMidPageRegion = (state, newColumns) => {
		const regionStartY = Math.max(state.cursorY, state.maxCursorY);
		state.cursorY = regionStartY;
		state.maxCursorY = regionStartY;
		const boundary = {
			y: regionStartY,
			columns: newColumns
		};
		state.constraintBoundaries.push(boundary);
		state.activeConstraintIndex = state.constraintBoundaries.length - 1;
		state.columnIndex = 0;
		layoutLog(`[Layout] *** COLUMNS CHANGED MID-PAGE ***`);
		layoutLog(`  OLD activeColumns: ${JSON.stringify(activeColumns)}`);
		layoutLog(`  NEW activeColumns: ${JSON.stringify(newColumns)}`);
		layoutLog(`  Current page: ${state.page.number}, cursorY: ${state.cursorY}, maxCursorY: ${state.maxCursorY}`);
		activeColumns = cloneColumnLayout(newColumns);
		cachedColumnsState.state = null;
		const contentWidth = activePageSize.w - (activeLeftMargin + activeRightMargin);
		floatManager.setLayoutContext(normalizeColumns(activeColumns, contentWidth), {
			left: activeLeftMargin,
			right: activeRightMargin
		}, activePageSize.w);
	};
	const balancingMeasureMap = /* @__PURE__ */ new Map();
	const blockSectionMap = /* @__PURE__ */ new Map();
	const sectionColumnsMap = /* @__PURE__ */ new Map();
	const sectionHasExplicitColumnBreak = /* @__PURE__ */ new Set();
	const sectionEndBreakType = /* @__PURE__ */ new Map();
	const sectionTypeIsExplicit = /* @__PURE__ */ new Map();
	let lastSectionIdx = null;
	const sectPrMarkerBlockIds = /* @__PURE__ */ new Set();
	const keepLinesBlockIds = /* @__PURE__ */ new Set();
	let documentHasExplicitColumnBreak = false;
	let documentHasAnySectionBreak = false;
	const alreadyBalancedSections = /* @__PURE__ */ new Set();
	let currentSectionIdx = null;
	blocks.forEach((block, idx) => {
		const measure = measures[idx];
		if (measure) balancingMeasureMap.set(block.id, measure);
		const blockWithAttrs = block;
		const attrSectionIdx = blockWithAttrs.attrs?.sectionIndex;
		if (block.kind === "sectionBreak") {
			documentHasAnySectionBreak = true;
			if (typeof attrSectionIdx === "number") {
				currentSectionIdx = attrSectionIdx;
				lastSectionIdx = attrSectionIdx;
				if (block.columns) sectionColumnsMap.set(attrSectionIdx, cloneColumnLayout(block.columns));
				if (typeof block.type === "string") sectionEndBreakType.set(attrSectionIdx, block.type);
				if (typeof blockWithAttrs.attrs?.typeIsExplicit === "boolean") sectionTypeIsExplicit.set(attrSectionIdx, blockWithAttrs.attrs.typeIsExplicit);
			}
		}
		if (currentSectionIdx !== null) {
			blockSectionMap.set(block.id, currentSectionIdx);
			if (block.kind === "columnBreak") {
				sectionHasExplicitColumnBreak.add(currentSectionIdx);
				documentHasExplicitColumnBreak = true;
			}
		} else if (block.kind === "columnBreak") documentHasExplicitColumnBreak = true;
		if (block.kind === "paragraph" && blockWithAttrs.attrs?.sectPrMarker === true) sectPrMarkerBlockIds.add(block.id);
		if (block.kind === "paragraph" && blockWithAttrs.attrs?.keepLines === true) keepLinesBlockIds.add(block.id);
	});
	const anchoredDrawings = collectAnchoredDrawings(blocks, measures);
	const anchoredByParagraph = anchoredDrawings.byParagraph;
	const paragraphlessAnchoredDrawings = anchoredDrawings.withoutParagraph;
	const anchoredTables = collectAnchoredTables(blocks, measures);
	const anchoredTablesByParagraph = anchoredTables.byParagraph;
	const paragraphlessAnchoredTables = anchoredTables.withoutParagraph;
	const placedAnchoredIds = /* @__PURE__ */ new Set();
	const preRegisteredAnchors = collectPreRegisteredAnchors(blocks, measures);
	const preRegisteredPositions = /* @__PURE__ */ new Map();
	const resolveParagraphlessAnchoredTableY = (block, measure, state) => {
		const contentTop = state.topMargin;
		const contentBottom = state.contentBottom;
		const tableHeight = measure.totalHeight ?? 0;
		return resolveAnchoredGraphicY({
			anchor: block.anchor,
			objectHeight: tableHeight,
			contentTop,
			contentBottom,
			pageBottomMargin: state.page.margins?.bottom ?? activeBottomMargin,
			preRegisteredFallbackToContentTop: true
		});
	};
	const resolveParagraphlessAnchoredDrawingY = (block, measure, state) => resolveAnchoredGraphicY({
		anchor: block.anchor,
		objectHeight: measure.height ?? 0,
		contentTop: state.topMargin,
		contentBottom: state.contentBottom,
		pageBottomMargin: state.page.margins?.bottom ?? activeBottomMargin,
		preRegisteredFallbackToContentTop: true
	});
	const resolveParagraphlessAnchoredDrawingX = (block, measure, state) => block.anchor ? computeAnchorX(block.anchor, state.columnIndex, normalizeColumns(activeColumns, activePageSize.w - (activeLeftMargin + activeRightMargin)), measure.width, {
		left: activeLeftMargin,
		right: activeRightMargin
	}, activePageSize.w) : columnX(state);
	for (const entry of preRegisteredAnchors) {
		const state = paginator.ensurePage();
		const contentTop = state.topMargin;
		const contentBottom = state.contentBottom;
		const anchorY = resolveAnchoredGraphicY({
			anchor: entry.block.anchor,
			objectHeight: entry.measure.height ?? 0,
			contentTop,
			contentBottom,
			pageBottomMargin: state.page.margins?.bottom ?? activeBottomMargin,
			preRegisteredFallbackToContentTop: true
		});
		const anchorX = entry.block.anchor ? computeAnchorX(entry.block.anchor, state.columnIndex, normalizeColumns(activeColumns, activePageSize.w - (activeLeftMargin + activeRightMargin)), entry.measure.width, {
			left: activeLeftMargin,
			right: activeRightMargin
		}, activePageSize.w) : activeLeftMargin;
		floatManager.registerDrawing(entry.block, entry.measure, anchorY, state.columnIndex, state.page.number);
		preRegisteredPositions.set(entry.block.id, {
			anchorX,
			anchorY
		});
	}
	const keepNextChains = computeKeepNextChains(blocks);
	const midChainIndices = /* @__PURE__ */ new Set();
	for (const chain of keepNextChains.values()) for (let i = 1; i < chain.memberIndices.length; i++) midChainIndices.add(chain.memberIndices[i]);
	for (let index = 0; index < blocks.length; index += 1) {
		const block = blocks[index];
		const measure = measures[index];
		if (!measure) throw new Error(`layoutDocument: missing measure for block ${block.id}`);
		layoutLog(`[Layout] Block ${index} (${block.kind}) - ID: ${block.id}`);
		layoutLog(`  activeColumns: ${JSON.stringify(activeColumns)}`);
		layoutLog(`  pendingColumns: ${JSON.stringify(pendingColumns)}`);
		if (block.kind === "sectionBreak") {
			const sectionBlock = block;
			layoutLog(`  sectionBreak.columns: ${JSON.stringify(sectionBlock.columns)}`);
			layoutLog(`  sectionBreak.type: ${sectionBlock.type}`);
		}
		if (block.kind === "sectionBreak") {
			if (measure.kind !== "sectionBreak") throw new Error(`layoutDocument: expected sectionBreak measure for block ${block.id}`);
			let effectiveBlock = block;
			const ahead = nextSectionPropsAtBreak.get(index);
			const hasSectionIndex = typeof effectiveBlock.attrs?.sectionIndex === "number";
			if (ahead && effectiveBlock.attrs?.source === "sectPr" && !hasSectionIndex && ahead) effectiveBlock = {
				...effectiveBlock,
				margins: ahead.margins ? {
					...effectiveBlock.margins ?? {},
					...ahead.margins
				} : effectiveBlock.margins ?? {},
				pageSize: ahead.pageSize ?? effectiveBlock.pageSize,
				columns: ahead.columns ?? effectiveBlock.columns,
				orientation: ahead.orientation ?? effectiveBlock.orientation,
				vAlign: ahead.vAlign ?? effectiveBlock.vAlign
			};
			const sectionState = {
				activeTopMargin,
				activeBottomMargin,
				activeLeftMargin,
				activeRightMargin,
				pendingTopMargin,
				pendingBottomMargin,
				pendingLeftMargin,
				pendingRightMargin,
				activeHeaderDistance,
				activeFooterDistance,
				pendingHeaderDistance,
				pendingFooterDistance,
				activePageSize,
				pendingPageSize,
				activeColumns,
				pendingColumns,
				activeOrientation,
				pendingOrientation,
				hasAnyPages: states.length > 0
			};
			const _sched = scheduleSectionBreakCompat(effectiveBlock, sectionState, {
				top: margins.top,
				bottom: margins.bottom,
				left: margins.left,
				right: margins.right
			});
			const breakInfo = _sched.decision;
			const updatedState = _sched.state ?? sectionState;
			layoutLog(`[Layout] ========== SECTION BREAK SCHEDULED ==========`);
			layoutLog(`  Block index: ${index}`);
			layoutLog(`  effectiveBlock.columns: ${JSON.stringify(effectiveBlock.columns)}`);
			layoutLog(`  effectiveBlock.type: ${effectiveBlock.type}`);
			layoutLog(`  breakInfo.forcePageBreak: ${breakInfo.forcePageBreak}`);
			layoutLog(`  breakInfo.forceMidPageRegion: ${breakInfo.forceMidPageRegion}`);
			layoutLog(`  BEFORE: activeColumns = ${JSON.stringify(sectionState.activeColumns)}, pendingColumns = ${JSON.stringify(sectionState.pendingColumns)}`);
			layoutLog(`  AFTER: activeColumns = ${JSON.stringify(updatedState.activeColumns)}, pendingColumns = ${JSON.stringify(updatedState.pendingColumns)}`);
			layoutLog(`[Layout] ========== END SECTION BREAK ==========`);
			activeTopMargin = updatedState.activeTopMargin;
			activeBottomMargin = updatedState.activeBottomMargin;
			activeLeftMargin = updatedState.activeLeftMargin;
			activeRightMargin = updatedState.activeRightMargin;
			pendingTopMargin = updatedState.pendingTopMargin;
			pendingBottomMargin = updatedState.pendingBottomMargin;
			pendingLeftMargin = updatedState.pendingLeftMargin;
			pendingRightMargin = updatedState.pendingRightMargin;
			activeHeaderDistance = updatedState.activeHeaderDistance;
			activeFooterDistance = updatedState.activeFooterDistance;
			pendingHeaderDistance = updatedState.pendingHeaderDistance;
			pendingFooterDistance = updatedState.pendingFooterDistance;
			activePageSize = updatedState.activePageSize;
			pendingPageSize = updatedState.pendingPageSize;
			activeColumns = updatedState.activeColumns;
			pendingColumns = updatedState.pendingColumns;
			activeOrientation = updatedState.activeOrientation;
			pendingOrientation = updatedState.pendingOrientation;
			const isFirstSection = effectiveBlock.attrs?.isFirstSection && states.length === 0;
			const blockTopMargin = effectiveBlock.margins?.top;
			const blockBottomMargin = effectiveBlock.margins?.bottom;
			if (isFirstSection) {
				activeSectionBaseTopMargin = typeof blockTopMargin === "number" ? blockTopMargin : margins.top;
				activeSectionBaseBottomMargin = typeof blockBottomMargin === "number" ? blockBottomMargin : margins.bottom;
			} else if (blockTopMargin !== void 0 || blockBottomMargin !== void 0) {
				if (blockTopMargin !== void 0) pendingSectionBaseTopMargin = typeof blockTopMargin === "number" ? blockTopMargin : margins.top;
				if (blockBottomMargin !== void 0) pendingSectionBaseBottomMargin = typeof blockBottomMargin === "number" ? blockBottomMargin : margins.bottom;
			}
			const sectionVAlign = effectiveBlock.vAlign ?? null;
			if (effectiveBlock.attrs?.isFirstSection && states.length === 0) {
				activeVAlign = sectionVAlign;
				pendingVAlign = void 0;
			} else pendingVAlign = sectionVAlign;
			if (effectiveBlock.headerRefs || effectiveBlock.footerRefs) {
				pendingSectionRefs = mergeSectionRefs(pendingSectionRefs ?? activeSectionRefs, {
					...effectiveBlock.headerRefs && { headerRefs: effectiveBlock.headerRefs },
					...effectiveBlock.footerRefs && { footerRefs: effectiveBlock.footerRefs }
				});
				layoutLog(`[Layout] After scheduleSectionBreakCompat: Scheduled pendingSectionRefs:`, pendingSectionRefs);
			}
			const sectionIndexRaw = effectiveBlock.attrs?.sectionIndex;
			const metadataIndex = typeof sectionIndexRaw === "number" ? sectionIndexRaw : Number(sectionIndexRaw ?? NaN);
			if (Number.isFinite(metadataIndex)) if (isFirstSection) activeSectionIndex = metadataIndex;
			else pendingSectionIndex = metadataIndex;
			const sectionMetadata = Number.isFinite(metadataIndex) ? getSectionMetadata(metadataIndex) : void 0;
			if (sectionMetadata?.numbering) if (isFirstSection) {
				if (sectionMetadata.numbering.format) activeNumberFormat = sectionMetadata.numbering.format;
				if (typeof sectionMetadata.numbering.start === "number") {
					activePageCounter = sectionMetadata.numbering.start;
					activeSectionPageCounterStart = activePageCounter;
				}
			} else pendingNumbering = { ...sectionMetadata.numbering };
			else if (effectiveBlock.numbering) if (isFirstSection) {
				if (effectiveBlock.numbering.format) activeNumberFormat = effectiveBlock.numbering.format;
				if (typeof effectiveBlock.numbering.start === "number") {
					activePageCounter = effectiveBlock.numbering.start;
					activeSectionPageCounterStart = activePageCounter;
				}
			} else pendingNumbering = { ...effectiveBlock.numbering };
			if (breakInfo.forceMidPageRegion && updatedState.pendingColumns) {
				let state = paginator.ensurePage();
				const columnIndexBefore = state.columnIndex;
				const newColumns = updatedState.pendingColumns;
				let endingSectionIndex = null;
				for (let i = state.page.fragments.length - 1; i >= 0; i--) {
					const mapped = blockSectionMap.get(state.page.fragments[i].blockId);
					if (typeof mapped === "number" && mapped !== metadataIndex) {
						endingSectionIndex = mapped;
						break;
					}
				}
				const endingSectionColumns = endingSectionIndex !== null ? sectionColumnsMap.get(endingSectionIndex) : void 0;
				const willBalance = endingSectionIndex !== null && !!endingSectionColumns && resolveColumnCount(endingSectionColumns) > 1 && !sectionHasExplicitColumnBreak.has(endingSectionIndex);
				let balanceResult = null;
				if (willBalance) {
					const activeRegionTop = state.constraintBoundaries[state.constraintBoundaries.length - 1]?.y ?? activeTopMargin;
					const availableHeight = activePageSize.h - activeBottomMargin - activeRegionTop;
					const normalized = normalizeColumns(endingSectionColumns, activePageSize.w - (activeLeftMargin + activeRightMargin));
					balanceResult = balanceSectionOnPage({
						fragments: state.page.fragments,
						sectionIndex: endingSectionIndex,
						sectionColumns: toBalancingColumns(normalized),
						sectionHasExplicitColumnBreak: false,
						blockSectionMap,
						margins: { left: activeLeftMargin },
						topMargin: activeRegionTop,
						columnWidth: normalized.width,
						availableHeight,
						measureMap: balancingMeasureMap,
						sectPrMarkerBlockIds,
						keepLinesBlockIds
					});
					if (balanceResult) {
						state.cursorY = balanceResult.maxY;
						state.maxCursorY = balanceResult.maxY;
						alreadyBalancedSections.add(endingSectionIndex);
					}
				}
				if (balanceResult === null && columnIndexBefore >= resolveColumnCount(newColumns)) state = paginator.startNewPage();
				startMidPageRegion(state, newColumns);
			}
			if (breakInfo.forcePageBreak) {
				let state = paginator.ensurePage();
				if (state.page.fragments.length > 0) {
					layoutLog(`[Layout] Starting new page due to section break (forcePageBreak=true)`);
					layoutLog(`  Before: activeColumns = ${JSON.stringify(activeColumns)}, pendingColumns = ${JSON.stringify(pendingColumns)}`);
					state = paginator.startNewPage();
					layoutLog(`  After page ${state.page.number} created: activeColumns = ${JSON.stringify(activeColumns)}, pendingColumns = ${JSON.stringify(pendingColumns)}`);
				}
				if (breakInfo.requiredParity) {
					const isCurrentEven = state.page.number % 2 === 0;
					const needsEven = breakInfo.requiredParity === "even";
					if (needsEven && !isCurrentEven || !needsEven && isCurrentEven) {
						layoutLog(`[Layout] Inserting blank page for parity (need ${breakInfo.requiredParity})`);
						state = paginator.startNewPage();
					}
				}
			}
			continue;
		}
		if (block.kind === "paragraph") {
			if (measure.kind !== "paragraph") throw new Error(`layoutDocument: expected paragraph measure for block ${block.id}`);
			const paraBlock = block;
			if (!paraBlock.runs || paraBlock.runs.length === 0 || paraBlock.runs.length === 1 && (!paraBlock.runs[0].kind || paraBlock.runs[0].kind === "text") && (!paraBlock.runs[0].text || paraBlock.runs[0].text === "")) {
				const isSectPrMarker = paraBlock.attrs?.sectPrMarker === true;
				const prevBlock = index > 0 ? blocks[index - 1] : null;
				const nextBlock = index < blocks.length - 1 ? blocks[index + 1] : null;
				const nextSectionBreak = nextBlock?.kind === "sectionBreak" ? nextBlock : null;
				const nextBreakType = nextSectionBreak?.type ?? (nextSectionBreak?.attrs?.source === "sectPr" ? "nextPage" : void 0);
				const nextBreakForcesPage = nextSectionBreak && (nextBreakType === "nextPage" || nextBreakType === "evenPage" || nextBreakType === "oddPage" || nextSectionBreak.attrs?.requirePageBoundary === true);
				if (isSectPrMarker && nextBreakForcesPage) continue;
				if (prevBlock?.kind === "pageBreak" && nextBlock?.kind === "sectionBreak") continue;
			}
			const anchorsForPara = anchoredByParagraph.get(index);
			const tablesForPara = anchoredTablesByParagraph.get(index);
			const chain = keepNextChains.get(index);
			if (midChainIndices.has(index)) {} else if (chain) {
				let state = paginator.ensurePage();
				const availableHeight = state.contentBottom - state.cursorY;
				const firstMemberBlock = blocks[chain.startIndex];
				const firstMemberStyleId = typeof firstMemberBlock.attrs?.styleId === "string" ? firstMemberBlock.attrs?.styleId : void 0;
				const prevSuppressAfter = shouldSuppressOwnSpacing(state.lastParagraphStyleId, state.lastParagraphContextualSpacing, firstMemberStyleId);
				const prevTrailing = Number.isFinite(state.trailingSpacing) && state.trailingSpacing > 0 ? state.trailingSpacing : 0;
				const effectiveAvailableHeight = prevSuppressAfter ? availableHeight + prevTrailing : availableHeight;
				const chainHeight = calculateChainHeight(chain, blocks, measures, state);
				if (chainHeight <= state.contentBottom - state.topMargin && chainHeight > effectiveAvailableHeight && state.page.fragments.length > 0) state = paginator.advanceColumn(state);
			} else if (paraBlock.attrs?.keepNext === true) {
				const nextBlock = blocks[index + 1];
				const nextMeasure = measures[index + 1];
				if (nextBlock && nextMeasure && nextBlock.kind !== "sectionBreak" && nextBlock.kind !== "pageBreak" && nextBlock.kind !== "columnBreak") {
					if (!(nextBlock.kind === "table" && nextBlock.anchor?.isAnchored === true)) {
						let state = paginator.ensurePage();
						const availableHeight = state.contentBottom - state.cursorY;
						const spacingBefore = getParagraphSpacingBefore(paraBlock);
						const spacingAfter = getParagraphSpacingAfter$1(paraBlock);
						const prevTrailing = Number.isFinite(state.trailingSpacing) && state.trailingSpacing > 0 ? state.trailingSpacing : 0;
						const currentStyleId = typeof paraBlock.attrs?.styleId === "string" ? paraBlock.attrs?.styleId : void 0;
						const currentContextualSpacing = asBoolean(paraBlock.attrs?.contextualSpacing);
						const prevSuppressAfter = shouldSuppressOwnSpacing(state.lastParagraphStyleId, state.lastParagraphContextualSpacing, currentStyleId);
						const currSuppressBefore = shouldSuppressOwnSpacing(currentStyleId, currentContextualSpacing, state.lastParagraphStyleId);
						let effectiveSpacingBefore;
						if (prevSuppressAfter && currSuppressBefore) effectiveSpacingBefore = 0;
						else if (prevSuppressAfter) effectiveSpacingBefore = spacingBefore;
						else if (currSuppressBefore) effectiveSpacingBefore = 0;
						else effectiveSpacingBefore = Math.max(spacingBefore - prevTrailing, 0);
						const currentHeight = getMeasureHeight(paraBlock, measure);
						const nextHeight = getMeasureHeight(nextBlock, nextMeasure);
						const nextIsParagraph = nextBlock.kind === "paragraph" && nextMeasure.kind === "paragraph";
						const nextSpacingBefore = nextIsParagraph ? getParagraphSpacingBefore(nextBlock) : 0;
						const nextStyleId = nextIsParagraph && typeof nextBlock.attrs?.styleId === "string" ? nextBlock.attrs?.styleId : void 0;
						const nextContextualSpacing = nextIsParagraph && asBoolean(nextBlock.attrs?.contextualSpacing);
						const currSuppressAfter = shouldSuppressOwnSpacing(currentStyleId, currentContextualSpacing, nextStyleId);
						const nextSuppressBefore = nextIsParagraph && shouldSuppressOwnSpacing(nextStyleId, nextContextualSpacing, currentStyleId);
						const effectiveSpacingAfter = currSuppressAfter ? 0 : spacingAfter;
						const effectiveNextSpacingBefore = nextSuppressBefore ? 0 : nextSpacingBefore;
						const interParagraphSpacing = nextIsParagraph ? Math.max(effectiveSpacingAfter, effectiveNextSpacingBefore) : effectiveSpacingAfter;
						const nextFirstLineHeight = (() => {
							if (!nextIsParagraph) return nextHeight;
							const firstLineHeight = nextMeasure.lines[0]?.lineHeight;
							if (typeof firstLineHeight === "number" && Number.isFinite(firstLineHeight) && firstLineHeight > 0) return firstLineHeight;
							return nextHeight;
						})();
						if ((nextIsParagraph ? effectiveSpacingBefore + currentHeight + interParagraphSpacing + nextFirstLineHeight : effectiveSpacingBefore + currentHeight + spacingAfter + nextHeight) > (prevSuppressAfter ? availableHeight + prevTrailing : availableHeight) && state.page.fragments.length > 0) state = paginator.advanceColumn(state);
					}
				}
			}
			let overrideSpacingAfter;
			const curStyleId = typeof paraBlock.attrs?.styleId === "string" ? paraBlock.attrs.styleId : void 0;
			const curContextualSpacing = asBoolean(paraBlock.attrs?.contextualSpacing);
			if (curContextualSpacing && curStyleId) {
				const nextBlock = index < blocks.length - 1 ? blocks[index + 1] : null;
				if (nextBlock?.kind === "paragraph") {
					const nextPara = nextBlock;
					if (shouldSuppressOwnSpacing(curStyleId, curContextualSpacing, typeof nextPara.attrs?.styleId === "string" ? nextPara.attrs?.styleId : void 0)) overrideSpacingAfter = 0;
				}
			}
			layoutParagraphBlock({
				block,
				measure,
				columnWidth: getCurrentColumnWidth(),
				ensurePage: paginator.ensurePage,
				advanceColumn: paginator.advanceColumn,
				columnX,
				floatManager,
				remeasureParagraph: options.remeasureParagraph,
				overrideSpacingAfter,
				getFootnoteDemandForBlockId,
				getFootnoteRefCountForBlockId,
				getFootnoteBandOverhead,
				getFootnoteAnchorsForBlockId
			}, anchorsForPara || tablesForPara ? {
				anchoredDrawings: anchorsForPara,
				anchoredTables: tablesForPara,
				columnWidth: getCurrentColumnWidth(),
				pageWidth: activePageSize.w,
				pageMargins: {
					top: activeTopMargin,
					bottom: activeBottomMargin,
					left: activeLeftMargin,
					right: activeRightMargin
				},
				columns: getCurrentColumns(),
				placedAnchoredIds
			} : void 0);
			if (tablesForPara) {
				const state = paginator.ensurePage();
				let tableBottomY = state.cursorY;
				for (const { block: tableBlock, measure: tableMeasure } of tablesForPara) {
					if (!placedAnchoredIds.has(tableBlock.id)) continue;
					if ((tableBlock.wrap?.type ?? "None") === "None") continue;
					const tableFragment = state.page.fragments.find((fragment) => fragment.kind === "table" && fragment.blockId === tableBlock.id);
					if (!tableFragment || tableFragment.kind !== "table") continue;
					const bottom$1 = tableFragment.y + (tableMeasure.totalHeight ?? 0);
					const distBottom = tableBlock.wrap?.distBottom ?? 0;
					if (bottom$1 + distBottom > tableBottomY) tableBottomY = bottom$1 + distBottom;
				}
				state.cursorY = tableBottomY;
				state.maxCursorY = Math.max(state.maxCursorY, state.cursorY);
			}
			continue;
		}
		if (block.kind === "image") {
			if (measure.kind !== "image") throw new Error(`layoutDocument: expected image measure for block ${block.id}`);
			const preRegPos = preRegisteredPositions.get(block.id);
			if (preRegPos && Number.isFinite(preRegPos.anchorX) && Number.isFinite(preRegPos.anchorY)) {
				const state = paginator.ensurePage();
				const imgBlock = block;
				const imgMeasure = measure;
				const pageContentHeight = Math.max(0, state.contentBottom - state.topMargin);
				const relativeFrom = imgBlock.anchor?.hRelativeFrom ?? "column";
				const cols = getCurrentColumns();
				let maxWidth;
				if (relativeFrom === "page") maxWidth = cols.count === 1 ? activePageSize.w - (activeLeftMargin + activeRightMargin) : activePageSize.w;
				else if (relativeFrom === "margin") maxWidth = activePageSize.w - (activeLeftMargin + activeRightMargin);
				else maxWidth = columnWidthForState(state);
				const aspectRatio = imgMeasure.width > 0 && imgMeasure.height > 0 ? imgMeasure.width / imgMeasure.height : 1;
				const minWidth = 20;
				const minHeight = minWidth / aspectRatio;
				const metadata = {
					originalWidth: imgMeasure.width,
					originalHeight: imgMeasure.height,
					maxWidth,
					maxHeight: pageContentHeight,
					aspectRatio,
					minWidth,
					minHeight
				};
				const fragment = {
					kind: "image",
					blockId: imgBlock.id,
					x: preRegPos.anchorX,
					y: preRegPos.anchorY,
					width: imgMeasure.width,
					height: imgMeasure.height,
					isAnchored: true,
					behindDoc: imgBlock.anchor?.behindDoc === true,
					zIndex: getFragmentZIndex(imgBlock),
					metadata,
					sourceAnchor: imgBlock.sourceAnchor
				};
				const attrs = imgBlock.attrs;
				if (attrs?.pmStart != null) fragment.pmStart = attrs.pmStart;
				if (attrs?.pmEnd != null) fragment.pmEnd = attrs.pmEnd;
				state.page.fragments.push(fragment);
				placedAnchoredIds.add(imgBlock.id);
				continue;
			}
			layoutImageBlock({
				block,
				measure,
				columns: getCurrentColumns(),
				ensurePage: paginator.ensurePage,
				advanceColumn: paginator.advanceColumn,
				columnX
			});
			continue;
		}
		if (block.kind === "drawing") {
			if (measure.kind !== "drawing") throw new Error(`layoutDocument: expected drawing measure for block ${block.id}`);
			const preRegPos = preRegisteredPositions.get(block.id);
			if (preRegPos && Number.isFinite(preRegPos.anchorX) && Number.isFinite(preRegPos.anchorY)) {
				const state = paginator.ensurePage();
				const drawBlock = block;
				const drawMeasure = measure;
				const contentMeasures = drawBlock.drawingKind === "textboxShape" && typeof options.remeasureParagraph === "function" ? layoutTextboxContent(drawBlock, options.remeasureParagraph) : void 0;
				const fragment = {
					kind: "drawing",
					blockId: drawBlock.id,
					drawingKind: drawBlock.drawingKind,
					x: preRegPos.anchorX,
					y: preRegPos.anchorY,
					width: drawMeasure.width,
					height: drawMeasure.height,
					geometry: drawMeasure.geometry,
					scale: drawMeasure.scale,
					isAnchored: true,
					behindDoc: drawBlock.anchor?.behindDoc === true,
					zIndex: getFragmentZIndex(drawBlock),
					drawingContentId: drawBlock.drawingContentId,
					sourceAnchor: drawBlock.sourceAnchor
				};
				if (contentMeasures) fragment.contentMeasures = contentMeasures;
				const attrs = drawBlock.attrs;
				if (attrs?.pmStart != null) fragment.pmStart = attrs.pmStart;
				if (attrs?.pmEnd != null) fragment.pmEnd = attrs.pmEnd;
				state.page.fragments.push(fragment);
				placedAnchoredIds.add(drawBlock.id);
				continue;
			}
			layoutDrawingBlock({
				block,
				measure,
				columns: getCurrentColumns(),
				ensurePage: paginator.ensurePage,
				advanceColumn: paginator.advanceColumn,
				columnX,
				textboxContentMeasures: block.drawingKind === "textboxShape" && typeof options.remeasureParagraph === "function" ? layoutTextboxContent(block, options.remeasureParagraph) : void 0
			});
			continue;
		}
		if (block.kind === "table") {
			if (measure.kind !== "table") throw new Error(`layoutDocument: expected table measure for block ${block.id}`);
			layoutTableBlock({
				block,
				measure,
				columnWidth: getCurrentColumnWidth(),
				ensurePage: paginator.ensurePage,
				advanceColumn: paginator.advanceColumn,
				columnX
			});
			continue;
		}
		if (block.kind === "pageBreak") {
			if (measure.kind !== "pageBreak") throw new Error(`layoutDocument: expected pageBreak measure for block ${block.id}`);
			const currentState = states[states.length - 1];
			if (shouldSkipRedundantPageBreakBefore(block, currentState) || isPageBreakBeforeSatisfiedByExplicitBreak(blocks, index)) continue;
			paginator.startNewPage();
			continue;
		}
		if (block.kind === "columnBreak") {
			if (measure.kind !== "columnBreak") throw new Error(`layoutDocument: expected columnBreak measure for block ${block.id}`);
			const state = paginator.ensurePage();
			const activeCols = getActiveColumnsForState(state);
			if (state.columnIndex < resolveColumnCount(activeCols) - 1) advanceColumn(state);
			else paginator.startNewPage();
			continue;
		}
		throw new Error(`layoutDocument: unsupported block kind for ${block.id}`);
	}
	paginator.pruneTrailingEmptyPages();
	const resetPaginationStateForBlankPageFallback = () => {
		pageCount = 0;
		activePageCounter = activeSectionPageCounterStart;
		sectionFirstPageNumbers.clear();
	};
	const shouldUseBlankPageFallback = pages.length === 0;
	if (shouldUseBlankPageFallback && (allowParagraphlessAnchoredTableFallback && paragraphlessAnchoredTables.length > 0 || allowParagraphlessAnchoredDrawingFallback && paragraphlessAnchoredDrawings.length > 0 || allowSectionBreakOnlyPageFallback && hasOnlySectionBreakBlocks(blocks))) resetPaginationStateForBlankPageFallback();
	if (allowParagraphlessAnchoredDrawingFallback && shouldUseBlankPageFallback && paragraphlessAnchoredDrawings.length > 0) {
		const state = paginator.ensurePage();
		for (const { block, measure } of paragraphlessAnchoredDrawings) {
			if (placedAnchoredIds.has(block.id)) continue;
			const anchorX = resolveParagraphlessAnchoredDrawingX(block, measure, state);
			const anchorY = resolveParagraphlessAnchoredDrawingY(block, measure, state);
			if (block.kind === "image" && measure.kind === "image") {
				const pageContentHeight = Math.max(0, state.contentBottom - state.topMargin);
				const aspectRatio = measure.width > 0 && measure.height > 0 ? measure.width / measure.height : 1;
				const minWidth = 20;
				const minHeight = minWidth / aspectRatio;
				const fragment = {
					kind: "image",
					blockId: block.id,
					x: anchorX,
					y: anchorY,
					width: measure.width,
					height: measure.height,
					isAnchored: true,
					behindDoc: block.anchor?.behindDoc === true,
					zIndex: getFragmentZIndex(block),
					metadata: {
						originalWidth: measure.width,
						originalHeight: measure.height,
						maxWidth: activePageSize.w - (activeLeftMargin + activeRightMargin),
						maxHeight: pageContentHeight,
						aspectRatio,
						minWidth,
						minHeight
					},
					sourceAnchor: block.sourceAnchor
				};
				const attrs = block.attrs;
				if (attrs?.pmStart != null) fragment.pmStart = attrs.pmStart;
				if (attrs?.pmEnd != null) fragment.pmEnd = attrs.pmEnd;
				state.page.fragments.push(fragment);
				placedAnchoredIds.add(block.id);
				continue;
			}
			if (block.kind === "drawing" && measure.kind === "drawing") {
				const contentMeasures = block.drawingKind === "textboxShape" && typeof options.remeasureParagraph === "function" ? layoutTextboxContent(block, options.remeasureParagraph) : void 0;
				const fragment = {
					kind: "drawing",
					blockId: block.id,
					drawingKind: block.drawingKind,
					x: anchorX,
					y: anchorY,
					width: measure.width,
					height: measure.height,
					geometry: measure.geometry,
					scale: measure.scale,
					isAnchored: true,
					behindDoc: block.anchor?.behindDoc === true,
					zIndex: getFragmentZIndex(block),
					drawingContentId: block.drawingContentId,
					sourceAnchor: block.sourceAnchor
				};
				if (contentMeasures) fragment.contentMeasures = contentMeasures;
				const attrs = block.attrs;
				if (attrs?.pmStart != null) fragment.pmStart = attrs.pmStart;
				if (attrs?.pmEnd != null) fragment.pmEnd = attrs.pmEnd;
				state.page.fragments.push(fragment);
				placedAnchoredIds.add(block.id);
			}
		}
	}
	if (allowParagraphlessAnchoredTableFallback && shouldUseBlankPageFallback && paragraphlessAnchoredTables.length > 0) {
		const state = paginator.ensurePage();
		for (const { block: tableBlock, measure: tableMeasure } of paragraphlessAnchoredTables) {
			const columnWidthForTable = getCurrentColumnWidth();
			tableMeasure.totalWidth;
			if (isAnchoredTableFullWidth(tableBlock, tableMeasure, columnWidthForTable)) continue;
			const anchorY = resolveParagraphlessAnchoredTableY(tableBlock, tableMeasure, state);
			const anchorX = tableBlock.anchor?.offsetH ?? columnX(state);
			floatManager.registerTable(tableBlock, tableMeasure, anchorY, state.columnIndex, state.page.number);
			state.page.fragments.push(createAnchoredTableFragment(tableBlock, tableMeasure, anchorX, anchorY));
		}
	}
	if (allowSectionBreakOnlyPageFallback && shouldUseBlankPageFallback && hasOnlySectionBreakBlocks(blocks)) paginator.ensurePage();
	for (const page of pages) {
		if (!page.vAlign || page.vAlign === "top") continue;
		if (page.fragments.length === 0) continue;
		const pageSizeForPage = page.size ?? pageSize;
		const baseTop = page.baseMargins?.top ?? page.margins?.top ?? margins.top;
		const baseBottom = page.baseMargins?.bottom ?? page.margins?.bottom ?? margins.bottom;
		const contentTop = baseTop;
		const contentHeight = pageSizeForPage.h - baseBottom - contentTop;
		let minY = Infinity;
		let maxY = -Infinity;
		for (const fragment of page.fragments) {
			if (fragment.y < minY) minY = fragment.y;
			let fragmentBottom = fragment.y;
			if (hasHeight(fragment)) fragmentBottom += fragment.height;
			else {
				const lineCount = fragment.toLine - fragment.fromLine;
				fragmentBottom += lineCount * DEFAULT_PARAGRAPH_LINE_HEIGHT_PX;
			}
			if (fragmentBottom > maxY) maxY = fragmentBottom;
		}
		const availableSpace = contentHeight - (maxY - minY);
		if (availableSpace <= 0) continue;
		let yOffset = 0;
		if (page.vAlign === "center") yOffset = availableSpace / 2;
		else if (page.vAlign === "bottom") yOffset = availableSpace;
		else if (page.vAlign === "both") yOffset = availableSpace / 2;
		if (yOffset > 0) for (const fragment of page.fragments) fragment.y += yOffset;
	}
	const FALLBACK_SECTION_IDX = -1;
	if (sectionColumnsMap.size === 0 && !documentHasAnySectionBreak && resolveColumnCount(activeColumns) > 1 && !documentHasExplicitColumnBreak) {
		sectionColumnsMap.set(FALLBACK_SECTION_IDX, cloneColumnLayout(activeColumns));
		for (const block of blocks) blockSectionMap.set(block.id, FALLBACK_SECTION_IDX);
	}
	for (const [sectionIdx, sectionCols] of sectionColumnsMap) {
		if (resolveColumnCount(sectionCols) <= 1) continue;
		if (sectionHasExplicitColumnBreak.has(sectionIdx)) continue;
		if (alreadyBalancedSections.has(sectionIdx)) continue;
		if (sectionIdx !== FALLBACK_SECTION_IDX) {
			const endBreakType = sectionEndBreakType.get(sectionIdx);
			const typeIsExplicit = sectionTypeIsExplicit.get(sectionIdx) === true;
			const isLast = lastSectionIdx !== null && sectionIdx === lastSectionIdx;
			const bodyExplicitContinuousIdx = lastSectionIdx !== null && sectionTypeIsExplicit.get(lastSectionIdx) === true && sectionEndBreakType.get(lastSectionIdx) === "continuous" ? lastSectionIdx : null;
			const isExplicitNonContinuous = typeIsExplicit && (endBreakType === "nextPage" || endBreakType === "evenPage" || endBreakType === "oddPage");
			let sectionPagesCount = 0;
			for (const p$1 of pages) if (p$1.fragments.some((f) => blockSectionMap.get(f.blockId) === sectionIdx)) {
				sectionPagesCount += 1;
				if (sectionPagesCount > 1) break;
			}
			const isMultiPage = sectionPagesCount > 1;
			if (isMultiPage && !isLast) continue;
			const nextSectionBeginType = sectionEndBreakType.get(sectionIdx + 1);
			const nextIsBody = lastSectionIdx !== null && sectionIdx + 1 === lastSectionIdx;
			const allowedByMidDocContinuous = !isLast && !nextIsBody && nextSectionBeginType === "continuous";
			const allowedByBodyExplicitContinuous = bodyExplicitContinuousIdx !== null && sectionIdx === bodyExplicitContinuousIdx - 1 && !isExplicitNonContinuous;
			if (!allowedByMidDocContinuous && !allowedByBodyExplicitContinuous && !isMultiPage) continue;
		}
		let lastPageForSection = null;
		for (const p$1 of pages) if (p$1.fragments.some((f) => blockSectionMap.get(f.blockId) === sectionIdx)) lastPageForSection = p$1;
		if (!lastPageForSection) continue;
		const sectionPageSize = lastPageForSection.size ?? pageSize;
		const sectionPageMargins = lastPageForSection.margins;
		const sectionLeftMargin = sectionPageMargins?.left ?? activeLeftMargin;
		const sectionRightMargin = sectionPageMargins?.right ?? activeRightMargin;
		const sectionTopMarginPx = sectionPageMargins?.top ?? activeTopMargin;
		const sectionBottomMargin = sectionPageMargins?.bottom ?? activeBottomMargin;
		const sectionContentWidth = sectionPageSize.w - (sectionLeftMargin + sectionRightMargin);
		const sectionAvailableHeight = sectionPageSize.h - sectionBottomMargin - sectionTopMarginPx;
		const normalized = normalizeColumns(sectionCols, sectionContentWidth);
		balanceSectionOnPage({
			fragments: lastPageForSection.fragments,
			sectionIndex: sectionIdx,
			sectionColumns: toBalancingColumns(normalized),
			sectionHasExplicitColumnBreak: false,
			blockSectionMap,
			margins: { left: sectionLeftMargin },
			topMargin: sectionTopMarginPx,
			columnWidth: normalized.width,
			availableHeight: sectionAvailableHeight,
			measureMap: balancingMeasureMap,
			sectPrMarkerBlockIds,
			keepLinesBlockIds
		});
	}
	for (const state of states) {
		const boundaries = state.constraintBoundaries;
		if (boundaries.length === 0) continue;
		const regions = [];
		const firstRegionColumns = state.page.columns ?? {
			count: 1,
			gap: 0
		};
		regions.push({
			yStart: state.topMargin,
			yEnd: boundaries[0].y,
			columns: firstRegionColumns
		});
		for (let i = 0; i < boundaries.length; i++) {
			const start$1 = boundaries[i];
			const end$1 = boundaries[i + 1];
			regions.push({
				yStart: start$1.y,
				yEnd: end$1 ? end$1.y : state.contentBottom,
				columns: resolveColumnLayout(start$1.columns)
			});
		}
		state.page.columnRegions = regions;
	}
	for (let i = 0; i < pages.length && i < paginator.states.length; i++) {
		const s = paginator.states[i];
		const maxY = s.maxCursorY ?? 0;
		const cursorY = s.cursorY ?? 0;
		const trailing = s.trailingSpacing ?? 0;
		const adjusted = Math.max(maxY, cursorY) - (cursorY >= maxY ? trailing : 0);
		pages[i].bodyMaxY = Math.max(s.topMargin ?? 0, adjusted);
	}
	return {
		pageSize,
		pages,
		...options.documentBackground ? { documentBackground: options.documentBackground } : {},
		columns: resolveColumnCount(activeColumns) > 1 ? resolveColumnLayout(activeColumns) : void 0
	};
}
function computeFragmentBottom(fragment, block, measure) {
	let bottom$1 = fragment.y;
	if (fragment.kind === "para" && measure?.kind === "paragraph") {
		let sum = 0;
		for (let li = fragment.fromLine; li < fragment.toLine; li += 1) sum += measure.lines[li]?.lineHeight ?? 0;
		bottom$1 += sum;
		const spacingAfter = block?.attrs?.spacing?.after;
		if (spacingAfter && fragment.toLine === measure.lines.length) bottom$1 += Math.max(0, Number(spacingAfter));
	} else if (fragment.kind === "image") bottom$1 += typeof fragment.height === "number" ? fragment.height : measure?.height ?? 0;
	else if (fragment.kind === "drawing") bottom$1 += typeof fragment.height === "number" ? fragment.height : measure?.height ?? 0;
	else if (fragment.kind === "list-item") {
		const listMeasure = measure;
		if (listMeasure) {
			const item = listMeasure.items.find((it) => it.itemId === fragment.itemId);
			if (item?.paragraph) {
				let sum = 0;
				for (let li = fragment.fromLine; li < fragment.toLine; li += 1) sum += item.paragraph.lines[li]?.lineHeight ?? 0;
				bottom$1 += sum;
			}
		}
	}
	return bottom$1;
}
function rangesIntersect(startA, endA, startB, endB) {
	return endA > startB && startA < endB;
}
function getPageRelativeMeasurementBand(kind, constraints) {
	if (!kind || !constraints.margins) return null;
	const bandSize = kind === "header" ? constraints.margins.top : constraints.margins.bottom;
	if (!Number.isFinite(bandSize) || bandSize == null || bandSize <= 0) return null;
	return {
		start: 0,
		end: bandSize
	};
}
function shouldExcludeFromMeasurement(fragment, block, fragmentBottom, canvasHeight, kind, constraints) {
	if (!((fragment.kind === "image" || fragment.kind === "drawing") && fragment.isAnchored === true)) return false;
	if (block.kind !== "image" && block.kind !== "drawing") throw new Error(`Type mismatch: fragment kind is ${fragment.kind} but block kind is ${block.kind} for block ${block.id}`);
	const anchoredBlock = block;
	if (anchoredBlock.anchor?.behindDoc) return true;
	if (isPageRelativeAnchor(anchoredBlock)) {
		const fragmentTop = fragment.y;
		if (fragmentBottom <= 0 || fragmentTop >= canvasHeight) return true;
	}
	if (anchoredBlock.anchor?.vRelativeFrom === "page") {
		const measurementBand = getPageRelativeMeasurementBand(kind, constraints);
		if (measurementBand && !rangesIntersect(fragment.y, fragmentBottom, measurementBand.start, measurementBand.end)) return true;
	}
	const fragmentHeight = typeof fragment.height === "number" ? fragment.height : fragmentBottom - fragment.y;
	const fragmentWidth = typeof fragment.width === "number" ? fragment.width : 0;
	const heightCoversCanvas = Number.isFinite(fragmentHeight) && fragmentHeight >= canvasHeight;
	const widthCoversCanvas = Number.isFinite(constraints.width) && constraints.width > 0 && fragmentWidth >= constraints.width;
	const isOverlayWrap = anchoredBlock.wrap?.type === "None";
	if (kind && heightCoversCanvas && widthCoversCanvas && isOverlayWrap) return true;
	return false;
}
function layoutHeaderFooter(blocks, measures, constraints, kind, remeasureParagraph$1) {
	if (blocks.length !== measures.length) throw new Error(`layoutHeaderFooter expected measures for every block (blocks=${blocks.length}, measures=${measures.length})`);
	const width = Number(constraints?.width);
	const height = Number(constraints?.height);
	if (!Number.isFinite(width) || width <= 0) throw new Error("layoutHeaderFooter: width must be positive");
	if (!Number.isFinite(height) || height <= 0) return {
		pages: [],
		height: 0
	};
	const layout = layoutDocument(blocks, measures, {
		pageSize: {
			w: width,
			h: height
		},
		margins: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		},
		allowParagraphlessAnchoredTableFallback: false,
		allowSectionBreakOnlyPageFallback: false,
		remeasureParagraph: remeasureParagraph$1
	});
	if (kind === "footer" && constraints.pageHeight != null) normalizeFragmentsForRegion(layout.pages, blocks, measures, kind, constraints);
	const story = kind ? { kind } : void 0;
	if (story) for (const page of layout.pages) page.fragments = page.fragments.map((fragment) => ({
		...fragment,
		layoutSourceIdentity: buildLayoutSourceIdentityForFragment(fragment, story)
	}));
	const idToIndex = /* @__PURE__ */ new Map();
	for (let i = 0; i < blocks.length; i += 1) idToIndex.set(blocks[i].id, i);
	let measureMinY = 0;
	let measureMaxY = 0;
	let renderMinY = 0;
	let renderMaxY = 0;
	for (const page of layout.pages) for (const fragment of page.fragments) {
		const idx = idToIndex.get(fragment.blockId);
		if (idx == null) continue;
		const block = blocks[idx];
		const measure = measures[idx];
		const bottom$1 = computeFragmentBottom(fragment, block, measure);
		if (fragment.y < renderMinY) renderMinY = fragment.y;
		if (bottom$1 > renderMaxY) renderMaxY = bottom$1;
		if (shouldExcludeFromMeasurement(fragment, block, bottom$1, height, kind, constraints)) continue;
		if (fragment.y < measureMinY) measureMinY = fragment.y;
		if (bottom$1 > measureMaxY) measureMaxY = bottom$1;
	}
	return {
		height: measureMaxY - measureMinY,
		minY: renderMinY,
		maxY: renderMaxY,
		renderHeight: renderMaxY - renderMinY,
		pages: layout.pages.map((page) => ({
			number: page.number,
			fragments: page.fragments
		}))
	};
}
function normalizeColumns(input, contentWidth) {
	return normalizeColumnLayout(input, contentWidth, COLUMN_EPSILON$1);
}
function toBalancingColumns(normalized) {
	return {
		count: normalized.count,
		gap: normalized.gap,
		width: normalized.width,
		...Array.isArray(normalized.widths) ? { widths: normalized.widths } : {},
		...Array.isArray(normalized.gaps) ? { gaps: normalized.gaps } : {},
		...normalized.equalWidth !== void 0 ? { equalWidth: normalized.equalWidth } : {}
	};
}
init_dist();
var measurementCanvas = null;
var measurementCtx = null;
var TAB_CHAR_LENGTH = 1;
var FOOTNOTE_MARKER_DATA_ATTR$1 = "data-sd-footnote-number";
var getRunDataAttrs = (run) => {
	if (!run || !("dataAttrs" in run)) return;
	return run.dataAttrs;
};
var getRunCharacterLength = (run) => {
	if (!run) return 0;
	if (isTabRun$1(run)) return TAB_CHAR_LENGTH;
	if ("src" in run || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation" || run.kind === "math") return 0;
	return run.text?.length ?? 0;
};
var isVisualOnlyRun = (run) => {
	return getRunDataAttrs(run)?.[FOOTNOTE_MARKER_DATA_ATTR$1] === "true";
};
var SPACE_CHARS$1 = SPACE_CHARS;
var isTabRun$1 = (run) => run?.kind === "tab";
var isWordChar$3 = (char) => {
	if (!char) return false;
	const code = char.charCodeAt(0);
	return code >= 48 && code <= 57 || code >= 65 && code <= 90 || code >= 97 && code <= 122 || char === "'";
};
var capitalizeText$3 = (text) => {
	if (!text) return text;
	let result = "";
	for (let i = 0; i < text.length; i += 1) {
		const prevChar = i > 0 ? text[i - 1] : "";
		const ch = text[i];
		result += isWordChar$3(ch) && !isWordChar$3(prevChar) ? ch.toUpperCase() : ch;
	}
	return result;
};
var applyTextTransform$3 = (text, transform) => {
	if (!text || !transform || transform === "none") return text;
	if (transform === "uppercase") return text.toUpperCase();
	if (transform === "lowercase") return text.toLowerCase();
	if (transform === "capitalize") return capitalizeText$3(text);
	return text;
};
function getMeasurementContext() {
	if (measurementCtx) return measurementCtx;
	if (typeof document === "undefined") {
		if (process$1$1.env.NODE_ENV !== "test") console.warn("[text-measurement] Canvas not available (non-browser environment)");
		return null;
	}
	measurementCanvas = document.createElement("canvas");
	try {
		measurementCtx = measurementCanvas.getContext("2d");
	} catch {
		measurementCtx = null;
	}
	if (!measurementCtx && process$1$1.env.NODE_ENV !== "test") console.warn("[text-measurement] Failed to create 2D context");
	return measurementCtx;
}
var countSpaces = (text) => {
	let spaces = 0;
	for (let i = 0; i < text.length; i += 1) if (SPACE_CHARS$1.has(text[i])) spaces += 1;
	return spaces;
};
var getJustifyAdjustment = ({ block, line, availableWidthOverride, alignmentOverride, isLastLineOfParagraph, paragraphEndsWithLineBreak, skipJustifyOverride }) => {
	if (block.kind !== "paragraph") return {
		extraPerSpace: 0,
		totalSpaces: 0
	};
	if (block.runs.length === 0) return {
		extraPerSpace: 0,
		totalSpaces: 0
	};
	const alignment$1 = alignmentOverride ?? block.attrs?.alignment;
	const lastRunIndex = block.runs.length - 1;
	const lastRun = block.runs[lastRunIndex];
	const lastRunLength = getRunCharacterLength(lastRun);
	const derivedIsLastLine = line.toRun > lastRunIndex || line.toRun === lastRunIndex && line.toChar >= lastRunLength;
	const derivedEndsWithLineBreak = lastRun ? lastRun.kind === "lineBreak" : false;
	if (!shouldApplyJustify({
		alignment: alignment$1,
		hasExplicitPositioning: line.segments?.some((seg) => seg.x !== void 0) ?? false,
		hasExplicitTabStops: line.hasExplicitTabStops === true,
		isLastLineOfParagraph: isLastLineOfParagraph ?? derivedIsLastLine,
		paragraphEndsWithLineBreak: paragraphEndsWithLineBreak ?? derivedEndsWithLineBreak,
		skipJustifyOverride
	})) return {
		extraPerSpace: 0,
		totalSpaces: 0
	};
	let totalSpaces = line.spaceCount ?? 0;
	if (totalSpaces === 0) totalSpaces = sliceRunsForLine(block, line).reduce((sum, run) => {
		if (isTabRun$1(run) || "src" in run || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation" || run.kind === "math") return sum;
		return sum + countSpaces(run.text ?? "");
	}, 0);
	const availableWidth = availableWidthOverride ?? line.maxWidth ?? line.width;
	return {
		extraPerSpace: calculateJustifySpacing({
			lineWidth: line.naturalWidth ?? line.width,
			availableWidth,
			spaceCount: totalSpaces,
			shouldJustify: true
		}),
		totalSpaces
	};
};
function getRunFontString(run) {
	if (run.kind === "tab" || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation" || run.kind === "math" || "src" in run) return "normal normal 16px Arial";
	return `${run.italic ? "italic" : "normal"} ${run.bold ? "bold" : "normal"} ${run.fontSize ?? 16}px ${run.fontFamily ?? "Arial"}`;
}
function measureCharacterX(block, line, charOffset, availableWidthOverride, alignmentOverride) {
	const ctx$1 = getMeasurementContext();
	const availableWidth = availableWidthOverride ?? line.maxWidth ?? line.width;
	const justify = getJustifyAdjustment({
		block,
		line,
		availableWidthOverride: availableWidth,
		alignmentOverride
	});
	const alignment$1 = alignmentOverride ?? (block.kind === "paragraph" ? block.attrs?.alignment : void 0);
	const renderedLineWidth = alignment$1 === "justify" && justify.extraPerSpace !== 0 ? availableWidth : line.width;
	const hasExplicitPositioning = line.segments?.some((seg) => seg.x !== void 0);
	const alignmentOffset = !hasExplicitPositioning && alignment$1 === "center" ? Math.max(0, (availableWidth - renderedLineWidth) / 2) : !hasExplicitPositioning && alignment$1 === "right" ? Math.max(0, availableWidth - renderedLineWidth) : 0;
	if (hasExplicitPositioning && line.segments && ctx$1) return measureCharacterXSegmentBased(block, line, charOffset, ctx$1);
	if (!ctx$1) {
		const runs$1 = sliceRunsForLine(block, line);
		return charOffset / Math.max(1, runs$1.reduce((sum, run) => {
			if (isTabRun$1(run)) return sum + TAB_CHAR_LENGTH;
			if ("src" in run || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation" || run.kind === "math") return sum;
			return sum + (run.text ?? "").length;
		}, 0)) * renderedLineWidth;
	}
	const runs = sliceRunsForLine(block, line);
	let currentX = 0;
	let currentCharOffset = 0;
	let spaceTally = 0;
	for (const run of runs) {
		if (isTabRun$1(run)) {
			const runLength$1 = TAB_CHAR_LENGTH;
			const tabWidth = run.width ?? 0;
			if (currentCharOffset + runLength$1 >= charOffset) {
				const offsetInRun = charOffset - currentCharOffset;
				return currentX + (offsetInRun <= 0 ? 0 : tabWidth);
			}
			currentX += tabWidth;
			currentCharOffset += runLength$1;
			continue;
		}
		const text = "src" in run || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation" || run.kind === "math" ? "" : run.text ?? "";
		const runLength = text.length;
		const displayText = applyTextTransform$3(text, isTabRun$1(run) || "src" in run || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation" || run.kind === "math" ? void 0 : run.textTransform);
		if (currentCharOffset + runLength >= charOffset) {
			const offsetInRun = charOffset - currentCharOffset;
			ctx$1.font = getRunFontString(run);
			const textUpToTarget = displayText.slice(0, offsetInRun);
			const measured$1 = ctx$1.measureText(textUpToTarget);
			const spacingWidth = computeLetterSpacingWidth(run, offsetInRun, runLength);
			const spacesInPortion = justify.extraPerSpace !== 0 ? countSpaces(text.slice(0, offsetInRun)) : 0;
			return alignmentOffset + currentX + measured$1.width + spacingWidth + justify.extraPerSpace * (spaceTally + spacesInPortion);
		}
		ctx$1.font = getRunFontString(run);
		const measured = ctx$1.measureText(displayText);
		const runLetterSpacing = computeLetterSpacingWidth(run, runLength, runLength);
		const spacesInRun = justify.extraPerSpace !== 0 ? countSpaces(text) : 0;
		currentX += measured.width + runLetterSpacing + justify.extraPerSpace * spacesInRun;
		spaceTally += spacesInRun;
		currentCharOffset += runLength;
	}
	return alignmentOffset + currentX;
}
function measureCharacterXSegmentBased(block, line, charOffset, ctx$1) {
	if (block.kind !== "paragraph" || !line.segments) return 0;
	let lineCharCount = 0;
	for (const segment of line.segments) {
		const run = block.runs[segment.runIndex];
		if (!run) continue;
		const segmentChars = segment.toChar - segment.fromChar;
		if (lineCharCount + segmentChars >= charOffset) {
			const offsetInSegment = charOffset - lineCharCount;
			let segmentBaseX = segment.x;
			if (segmentBaseX === void 0) {
				segmentBaseX = 0;
				for (const prevSeg of line.segments) {
					if (prevSeg === segment) break;
					if (!block.runs[prevSeg.runIndex]) continue;
					if (prevSeg.x !== void 0) segmentBaseX = prevSeg.x + (prevSeg.width ?? 0);
					else segmentBaseX += prevSeg.width ?? 0;
				}
			}
			if (isTabRun$1(run)) return segmentBaseX + (offsetInSegment > 0 ? segment.width ?? 0 : 0);
			if ("src" in run || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation" || run.kind === "math") return segmentBaseX + (offsetInSegment >= segmentChars ? segment.width ?? 0 : 0);
			const textUpToTarget = applyTextTransform$3(run.text ?? "", "textTransform" in run ? run.textTransform : void 0).slice(segment.fromChar, segment.toChar).slice(0, offsetInSegment);
			ctx$1.font = getRunFontString(run);
			const measured = ctx$1.measureText(textUpToTarget);
			const spacingWidth = computeLetterSpacingWidth(run, offsetInSegment, segmentChars);
			return segmentBaseX + measured.width + spacingWidth;
		}
		lineCharCount += segmentChars;
	}
	return line.width;
}
function charOffsetToPm(block, line, charOffset, fallbackPmStart) {
	if (!Number.isFinite(charOffset) || !Number.isFinite(fallbackPmStart)) {
		console.warn("[charOffsetToPm] Invalid input:", {
			charOffset,
			fallbackPmStart
		});
		return fallbackPmStart;
	}
	const safeCharOffset = Math.max(0, charOffset);
	if (block.kind !== "paragraph") return fallbackPmStart + safeCharOffset;
	const runs = sliceRunsForLine(block, line);
	let cursor = 0;
	let lastPm = fallbackPmStart;
	for (let runIndex = 0; runIndex < runs.length; runIndex += 1) {
		const run = runs[runIndex];
		const runLength = getRunCharacterLength(run);
		const runPmStart = resolveRunPmStart(run, runLength);
		const runPmEnd = resolveRunPmEnd(run, runLength, runPmStart);
		if (runPmStart != null) lastPm = runPmStart;
		if (safeCharOffset <= cursor + runLength) {
			const offsetInRun = Math.max(0, safeCharOffset - cursor);
			if (runPmStart != null) return runPmStart + Math.min(offsetInRun, runLength);
			if (isVisualOnlyRun(run)) return resolveVisualOnlyRunBoundary(runs, runIndex, offsetInRun, runLength, lastPm);
			return fallbackPmStart + safeCharOffset;
		}
		if (runPmEnd != null) lastPm = runPmEnd;
		cursor += runLength;
	}
	return lastPm;
}
var resolveRunPmStart = (run, runLength) => {
	if (!run) return null;
	if (typeof run.pmStart === "number") return run.pmStart;
	if (typeof run.pmEnd === "number") return run.pmEnd - runLength;
	return null;
};
var resolveRunPmEnd = (run, runLength, runPmStart) => {
	if (!run) return null;
	if (typeof run.pmEnd === "number") return run.pmEnd;
	if (runPmStart != null) return runPmStart + runLength;
	return null;
};
var findNextPmBoundary = (runs, startIndex, fallbackPm) => {
	for (let runIndex = startIndex; runIndex < runs.length; runIndex += 1) {
		const run = runs[runIndex];
		const runLength = getRunCharacterLength(run);
		const nextPmStart = resolveRunPmStart(run, runLength);
		if (nextPmStart != null) return nextPmStart;
		const nextPmEnd = resolveRunPmEnd(run, runLength, nextPmStart);
		if (nextPmEnd != null) return nextPmEnd;
	}
	return fallbackPm;
};
var resolveVisualOnlyRunBoundary = (runs, runIndex, offsetInRun, runLength, previousPmBoundary) => {
	const nextPmBoundary = findNextPmBoundary(runs, runIndex + 1, previousPmBoundary);
	if (runLength <= 0 || previousPmBoundary === nextPmBoundary) return previousPmBoundary;
	return offsetInRun < runLength / 2 ? previousPmBoundary : nextPmBoundary;
};
function findCharacterAtX(block, line, x, pmStart, availableWidthOverride, alignmentOverride) {
	const ctx$1 = getMeasurementContext();
	const availableWidth = availableWidthOverride ?? line.maxWidth ?? line.width;
	const justify = getJustifyAdjustment({
		block,
		line,
		availableWidthOverride: availableWidth,
		alignmentOverride
	});
	const alignment$1 = alignmentOverride ?? (block.kind === "paragraph" ? block.attrs?.alignment : void 0);
	const renderedLineWidth = alignment$1 === "justify" ? line.width + Math.max(0, availableWidth - line.width) : line.width;
	const hasExplicitPositioning = line.segments?.some((seg) => seg.x !== void 0);
	const alignmentOffset = !hasExplicitPositioning && alignment$1 === "center" ? Math.max(0, (availableWidth - renderedLineWidth) / 2) : !hasExplicitPositioning && alignment$1 === "right" ? Math.max(0, availableWidth - renderedLineWidth) : 0;
	if (!ctx$1) {
		const runs$1 = sliceRunsForLine(block, line);
		const charsInLine = Math.max(1, runs$1.reduce((sum, run) => {
			if (isTabRun$1(run)) return sum + TAB_CHAR_LENGTH;
			if ("src" in run || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation" || run.kind === "math") return sum;
			return sum + (run.text ?? "").length;
		}, 0));
		const ratio = Math.max(0, Math.min(1, (x - alignmentOffset) / renderedLineWidth));
		const charOffset = Math.round(ratio * charsInLine);
		return {
			charOffset,
			pmPosition: charOffsetToPm(block, line, charOffset, pmStart)
		};
	}
	const runs = sliceRunsForLine(block, line);
	const safeX = Math.max(0, Math.min(renderedLineWidth, x - alignmentOffset));
	let currentX = 0;
	let currentCharOffset = 0;
	let spaceTally = 0;
	for (const run of runs) {
		if (isTabRun$1(run)) {
			const tabWidth = run.width ?? 0;
			const startX = currentX;
			const endX = currentX + tabWidth;
			if (safeX <= endX) {
				const offsetInRun = safeX < startX + tabWidth / 2 ? 0 : TAB_CHAR_LENGTH;
				const charOffset = currentCharOffset + offsetInRun;
				return {
					charOffset,
					pmPosition: charOffsetToPm(block, line, charOffset, pmStart)
				};
			}
			currentX = endX;
			currentCharOffset += TAB_CHAR_LENGTH;
			continue;
		}
		const text = "src" in run || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation" || run.kind === "math" ? "" : run.text ?? "";
		const runLength = text.length;
		const displayText = applyTextTransform$3(text, isTabRun$1(run) || "src" in run || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation" || run.kind === "math" ? void 0 : run.textTransform);
		if (runLength === 0) continue;
		ctx$1.font = getRunFontString(run);
		for (let i = 0; i <= runLength; i++) {
			const textUpToChar = displayText.slice(0, i);
			const measured$1 = ctx$1.measureText(textUpToChar);
			const spacesInPortion = justify.extraPerSpace > 0 ? countSpaces(text.slice(0, i)) : 0;
			const charX = currentX + measured$1.width + computeLetterSpacingWidth(run, i, runLength) + justify.extraPerSpace * (spaceTally + spacesInPortion);
			if (charX >= safeX) {
				if (i === 0) {
					const pmPosition$1 = charOffsetToPm(block, line, currentCharOffset, pmStart);
					return {
						charOffset: currentCharOffset,
						pmPosition: pmPosition$1
					};
				}
				const prevText = displayText.slice(0, i - 1);
				const prevMeasured = ctx$1.measureText(prevText);
				const prevX = currentX + prevMeasured.width + computeLetterSpacingWidth(run, i - 1, runLength);
				const charOffset = Math.abs(safeX - prevX) < Math.abs(safeX - charX) ? currentCharOffset + i - 1 : currentCharOffset + i;
				return {
					charOffset,
					pmPosition: charOffsetToPm(block, line, charOffset, pmStart)
				};
			}
		}
		const measured = ctx$1.measureText(displayText);
		const runLetterSpacing = computeLetterSpacingWidth(run, runLength, runLength);
		const spacesInRun = justify.extraPerSpace > 0 ? countSpaces(text) : 0;
		currentX += measured.width + runLetterSpacing + justify.extraPerSpace * spacesInRun;
		spaceTally += spacesInRun;
		currentCharOffset += runLength;
	}
	const pmPosition = charOffsetToPm(block, line, currentCharOffset, pmStart);
	return {
		charOffset: currentCharOffset,
		pmPosition
	};
}
var computeLetterSpacingWidth = (run, precedingChars, runLength) => {
	if (isTabRun$1(run) || "src" in run || run.kind === "fieldAnnotation" || !("letterSpacing" in run) || !run.letterSpacing) return 0;
	const maxGaps = Math.max(runLength - 1, 0);
	if (maxGaps === 0) return 0;
	return Math.min(Math.max(precedingChars, 0), maxGaps) * run.letterSpacing;
};
DOM_CLASS_NAMES.PAGE, DOM_CLASS_NAMES.FRAGMENT, DOM_CLASS_NAMES.LINE, DOM_CLASS_NAMES.TABLE_FRAGMENT;
function getWordLayoutConfig(block) {
	if (!block || block.kind !== "paragraph") return;
	return block.attrs?.wordLayout;
}
function isListItem(markerWidth, block) {
	if (markerWidth > 0) return true;
	if (!block || block.kind !== "paragraph") return false;
	const wordLayout = getWordLayoutConfig(block);
	if (block.attrs?.listItem != null || block.attrs?.numberingProperties != null || wordLayout?.marker != null) return true;
	const hangingIndent = block.attrs?.indent?.hanging ?? 0;
	const paraIndentLeft = block.attrs?.indent?.left ?? 0;
	return hangingIndent > 0 && paraIndentLeft > 0;
}
function calculateTextStartIndent(params$1) {
	const { isFirstLine, isListItem: isListItem$1, markerWidth, markerTextWidth, paraIndentLeft, firstLineIndent, hangingIndent, wordLayout } = params$1;
	const firstLineOffset = firstLineIndent - hangingIndent;
	const effectiveMarkerTextWidth = typeof markerTextWidth === "number" && Number.isFinite(markerTextWidth) && markerTextWidth > 0 ? markerTextWidth : markerWidth;
	let indentAdjust = paraIndentLeft;
	if (isListItem$1 && isFirstLine) {
		const resolvedTextStart = resolveListTextStartPx(wordLayout, paraIndentLeft, Math.max(firstLineIndent, 0), Math.max(hangingIndent, 0), () => effectiveMarkerTextWidth);
		if (typeof resolvedTextStart === "number" && Number.isFinite(resolvedTextStart)) indentAdjust = resolvedTextStart;
		else {
			const explicitTextStart = wordLayout?.marker?.textStartX ?? wordLayout?.textStartPx;
			if (typeof explicitTextStart === "number" && Number.isFinite(explicitTextStart)) indentAdjust = explicitTextStart;
		}
	} else if (isFirstLine && !isListItem$1) indentAdjust += firstLineOffset;
	return indentAdjust;
}
function extractParagraphIndent(indent) {
	return {
		left: typeof indent?.left === "number" && Number.isFinite(indent.left) ? indent.left : 0,
		right: typeof indent?.right === "number" && Number.isFinite(indent.right) ? indent.right : 0,
		firstLine: typeof indent?.firstLine === "number" && Number.isFinite(indent.firstLine) ? indent.firstLine : 0,
		hanging: typeof indent?.hanging === "number" && Number.isFinite(indent.hanging) ? indent.hanging : 0
	};
}
const defaultHeaderFooterIdentifier = () => ({
	headerIds: {
		default: null,
		first: null,
		even: null,
		odd: null
	},
	footerIds: {
		default: null,
		first: null,
		even: null,
		odd: null
	},
	titlePg: false,
	alternateHeaders: false
});
const extractIdentifierFromConverter = (converter) => {
	const identifier = defaultHeaderFooterIdentifier();
	if (!converter) return identifier;
	const headerIds = converter.headerIds ?? {};
	const footerIds = converter.footerIds ?? {};
	identifier.headerIds = {
		default: headerIds.default ?? null,
		first: headerIds.first ?? null,
		even: headerIds.even ?? null,
		odd: headerIds.odd ?? null
	};
	identifier.footerIds = {
		default: footerIds.default ?? null,
		first: footerIds.first ?? null,
		even: footerIds.even ?? null,
		odd: footerIds.odd ?? null
	};
	identifier.titlePg = Boolean(headerIds.titlePg ?? footerIds.titlePg ?? false);
	identifier.alternateHeaders = Boolean(converter.pageStyles?.alternateHeaders ?? false);
	return identifier;
};
const getHeaderFooterType = (pageNumber, identifier, options) => {
	if (pageNumber <= 0) return null;
	const kind = options?.kind ?? "header";
	const parityPageNumber = options?.parityPageNumber ?? pageNumber;
	const ids = kind === "header" ? identifier.headerIds : identifier.footerIds;
	const hasFirst = Boolean(ids.first);
	const hasEven = Boolean(ids.even);
	const hasOdd = Boolean(ids.odd);
	const hasDefault = Boolean(ids.default);
	const titlePgEnabled = identifier.titlePg && hasFirst;
	if (pageNumber === 1 && titlePgEnabled) return "first";
	if (identifier.alternateHeaders) {
		if (parityPageNumber % 2 === 0 && hasEven) return "even";
		if (parityPageNumber % 2 !== 0 && (hasOdd || hasDefault)) return hasOdd ? "odd" : "default";
		return null;
	}
	if (hasDefault) return "default";
	return null;
};
const defaultMultiSectionIdentifier = () => ({
	headerIds: {
		default: null,
		first: null,
		even: null,
		odd: null
	},
	footerIds: {
		default: null,
		first: null,
		even: null,
		odd: null
	},
	titlePg: false,
	alternateHeaders: false,
	sectionCount: 0,
	sectionHeaderIds: /* @__PURE__ */ new Map(),
	sectionFooterIds: /* @__PURE__ */ new Map(),
	sectionTitlePg: /* @__PURE__ */ new Map(),
	sections: []
});
function refreshResolutionSections(identifier) {
	if (identifier.sectionCount === 0 && identifier.sectionHeaderIds.size === 0 && identifier.sectionFooterIds.size === 0 && identifier.sectionTitlePg.size === 0) {
		identifier.sections = [];
		return;
	}
	const maxIndex = Math.max(identifier.sectionCount - 1, ...Array.from(identifier.sectionHeaderIds.keys()), ...Array.from(identifier.sectionFooterIds.keys()), ...Array.from(identifier.sectionTitlePg.keys()));
	const sections = [];
	for (let sectionIndex = 0; sectionIndex <= maxIndex; sectionIndex += 1) sections.push({
		sectionIndex,
		titlePg: identifier.sectionTitlePg.get(sectionIndex) ?? false,
		headerRefs: identifier.sectionHeaderIds.get(sectionIndex),
		footerRefs: identifier.sectionFooterIds.get(sectionIndex)
	});
	identifier.sections = sections;
}
function getSectionTitlePg(identifier, sectionIndex) {
	return identifier.sectionTitlePg.get(sectionIndex) ?? false;
}
function buildMultiSectionIdentifier(sectionMetadata, pageStyles$1, converterIds) {
	const identifier = defaultMultiSectionIdentifier();
	identifier.alternateHeaders = Boolean(pageStyles$1?.alternateHeaders ?? false);
	identifier.sectionCount = sectionMetadata.length;
	for (const section of sectionMetadata) {
		const idx = section.sectionIndex;
		if (section.headerRefs) identifier.sectionHeaderIds.set(idx, {
			default: section.headerRefs.default ?? null,
			first: section.headerRefs.first ?? null,
			even: section.headerRefs.even ?? null,
			odd: section.headerRefs.odd ?? null
		});
		if (section.footerRefs) identifier.sectionFooterIds.set(idx, {
			default: section.footerRefs.default ?? null,
			first: section.footerRefs.first ?? null,
			even: section.footerRefs.even ?? null,
			odd: section.footerRefs.odd ?? null
		});
		if (Object.prototype.hasOwnProperty.call(section, "titlePg")) identifier.sectionTitlePg.set(idx, section.titlePg === true);
	}
	const section0Headers = identifier.sectionHeaderIds.get(0);
	const section0Footers = identifier.sectionFooterIds.get(0);
	if (section0Headers) identifier.headerIds = { ...section0Headers };
	if (section0Footers) identifier.footerIds = { ...section0Footers };
	identifier.titlePg = identifier.sectionTitlePg.get(0) ?? false;
	if (converterIds?.headerIds) {
		if (!identifier.titlePg && converterIds.headerIds.titlePg) identifier.titlePg = true;
		identifier.headerIds.default = identifier.headerIds.default ?? converterIds.headerIds.default ?? null;
		identifier.headerIds.first = identifier.headerIds.first ?? converterIds.headerIds.first ?? null;
		identifier.headerIds.even = identifier.headerIds.even ?? converterIds.headerIds.even ?? null;
		identifier.headerIds.odd = identifier.headerIds.odd ?? converterIds.headerIds.odd ?? null;
	}
	if (converterIds?.footerIds) {
		if (!identifier.titlePg && converterIds.footerIds.titlePg) identifier.titlePg = true;
		identifier.footerIds.default = identifier.footerIds.default ?? converterIds.footerIds.default ?? null;
		identifier.footerIds.first = identifier.footerIds.first ?? converterIds.footerIds.first ?? null;
		identifier.footerIds.even = identifier.footerIds.even ?? converterIds.footerIds.even ?? null;
		identifier.footerIds.odd = identifier.footerIds.odd ?? converterIds.footerIds.odd ?? null;
	}
	refreshResolutionSections(identifier);
	return identifier;
}
function getHeaderFooterTypeForSection(pageNumber, sectionIndex, identifier, options) {
	if (!Number.isFinite(pageNumber)) return null;
	const kind = options?.kind ?? "header";
	const sectionPageNumber = options?.sectionPageNumber ?? pageNumber;
	const variant = selectHeaderFooterVariantForPage({
		documentPageNumber: options?.parityPageNumber ?? pageNumber,
		sectionPageNumber,
		titlePg: getSectionTitlePg(identifier, sectionIndex),
		alternateHeaders: identifier.alternateHeaders
	});
	if (!variant) return null;
	return resolveEffectiveHeaderFooterRef({
		sections: identifier.sections,
		sectionIndex,
		kind,
		variant
	}) ? variant : null;
}
const fieldAnnotationKey = (run) => {
	if (run.kind !== "fieldAnnotation") return "";
	const annotation = run;
	const sizeKey = annotation.size ? `${annotation.size.width ?? ""}x${annotation.size.height ?? ""}` : "";
	const highlightKey = annotation.highlighted === false ? "nohl" : "hl";
	const hiddenKey = annotation.hidden ? "hidden" : "";
	return [
		annotation.variant ?? "",
		annotation.displayLabel ?? "",
		annotation.imageSrc ?? "",
		annotation.rawHtml ?? "",
		annotation.linkUrl ?? "",
		annotation.fontFamily ?? "",
		annotation.fontSize ?? "",
		annotation.bold ? "b" : "",
		annotation.italic ? "i" : "",
		annotation.underline ? "u" : "",
		highlightKey,
		hiddenKey,
		annotation.visibility ?? "",
		sizeKey
	].join("|");
};
const hasTrackedChange = (run) => {
	return "trackedChange" in run && run.trackedChange !== void 0 && run.trackedChange !== null;
};
const resolveTrackedChangesEnabled = (attrs, defaultEnabled = true) => {
	if (!attrs || !("trackedChangesEnabled" in attrs)) return defaultEnabled;
	return attrs.trackedChangesEnabled !== false;
};
const hashParagraphBorder = (border) => {
	const parts = [];
	if (border.style !== void 0) parts.push(`s:${border.style}`);
	if (border.width !== void 0) parts.push(`w:${border.width}`);
	if (border.color !== void 0) parts.push(`c:${border.color}`);
	if (border.space !== void 0) parts.push(`sp:${border.space}`);
	return parts.join(",");
};
const hashParagraphBorders = (borders) => {
	const parts = [];
	if (borders.top) parts.push(`t:[${hashParagraphBorder(borders.top)}]`);
	if (borders.right) parts.push(`r:[${hashParagraphBorder(borders.right)}]`);
	if (borders.bottom) parts.push(`b:[${hashParagraphBorder(borders.bottom)}]`);
	if (borders.left) parts.push(`l:[${hashParagraphBorder(borders.left)}]`);
	if (borders.between) parts.push(`bw:[${hashParagraphBorder(borders.between)}]`);
	return parts.join(";");
};
function isNoneBorder(value) {
	return typeof value === "object" && value !== null && "none" in value && value.none === true;
}
function isBorderSpec(value) {
	return typeof value === "object" && value !== null && !("none" in value);
}
const hashBorderSpec = (border) => {
	const parts = [];
	if (border.style !== void 0) parts.push(`s:${border.style}`);
	if (border.width !== void 0) parts.push(`w:${border.width}`);
	if (border.color !== void 0) parts.push(`c:${border.color}`);
	if (border.space !== void 0) parts.push(`sp:${border.space}`);
	return parts.join(",");
};
const hashTableBorderValue = (borderValue) => {
	if (borderValue === void 0) return "";
	if (borderValue === null) return "null";
	if (isNoneBorder(borderValue)) return "none";
	if (isBorderSpec(borderValue)) return hashBorderSpec(borderValue);
	return "";
};
const hashTableBorders = (borders) => {
	if (!borders) return "";
	const parts = [];
	if (borders.top !== void 0) parts.push(`t:[${hashTableBorderValue(borders.top)}]`);
	if (borders.right !== void 0) parts.push(`r:[${hashTableBorderValue(borders.right)}]`);
	if (borders.bottom !== void 0) parts.push(`b:[${hashTableBorderValue(borders.bottom)}]`);
	if (borders.left !== void 0) parts.push(`l:[${hashTableBorderValue(borders.left)}]`);
	if (borders.insideH !== void 0) parts.push(`ih:[${hashTableBorderValue(borders.insideH)}]`);
	if (borders.insideV !== void 0) parts.push(`iv:[${hashTableBorderValue(borders.insideV)}]`);
	return parts.join(";");
};
const hashCellBorders = (borders) => {
	if (!borders) return "";
	const parts = [];
	if (borders.top) parts.push(`t:[${hashBorderSpec(borders.top)}]`);
	if (borders.right) parts.push(`r:[${hashBorderSpec(borders.right)}]`);
	if (borders.bottom) parts.push(`b:[${hashBorderSpec(borders.bottom)}]`);
	if (borders.left) parts.push(`l:[${hashBorderSpec(borders.left)}]`);
	return parts.join(";");
};
const hashRunVisualMarks = (run) => {
	const bold = "bold" in run ? run.bold : false;
	const italic = "italic" in run ? run.italic : false;
	const underline = "underline" in run ? run.underline : void 0;
	const strike = "strike" in run ? run.strike : false;
	const color = "color" in run ? run.color : void 0;
	const fontSize = "fontSize" in run ? run.fontSize : void 0;
	const fontFamily = "fontFamily" in run ? run.fontFamily : void 0;
	const highlight = "highlight" in run ? run.highlight : void 0;
	const link = "link" in run ? run.link : void 0;
	const bidi = "bidi" in run ? run.bidi : void 0;
	return [
		bold ? "b" : "",
		italic ? "i" : "",
		underline ? `u:${JSON.stringify(underline)}` : "",
		strike ? "s" : "",
		color ?? "",
		fontSize !== void 0 ? `fs:${fontSize}` : "",
		fontFamily ? `ff:${fontFamily}` : "",
		highlight ? `hl:${highlight}` : "",
		link ? `ln:${JSON.stringify(link)}` : "",
		bidi ? `bd:${JSON.stringify(bidi)}` : ""
	].join("");
};
function hasComments$1(run) {
	return "comments" in run && Array.isArray(run.comments) && run.comments.length > 0;
}
var MAX_CACHE_SIZE$1 = 1e4;
var BYTES_PER_ENTRY_ESTIMATE = 5e3;
var hashParagraphFrame = (frame) => {
	const parts = [];
	if (frame.wrap !== void 0) parts.push(`w:${frame.wrap}`);
	if (frame.x !== void 0) parts.push(`x:${frame.x}`);
	if (frame.y !== void 0) parts.push(`y:${frame.y}`);
	if (frame.xAlign !== void 0) parts.push(`xa:${frame.xAlign}`);
	if (frame.yAlign !== void 0) parts.push(`ya:${frame.yAlign}`);
	if (frame.hAnchor !== void 0) parts.push(`ha:${frame.hAnchor}`);
	if (frame.vAnchor !== void 0) parts.push(`va:${frame.vAnchor}`);
	return parts.join(",");
};
var getTableCellBlocks = (cell) => {
	return cell.blocks ?? (cell.paragraph ? [cell.paragraph] : []);
};
var readBlockClipPath = (block) => {
	if (typeof block.clipPath === "string") return block.clipPath;
	if (typeof block.attrs?.clipPath === "string") return block.attrs.clipPath;
	return "";
};
var hashDrawingGeometry = (geometry) => {
	return [
		geometry.width,
		geometry.height,
		geometry.rotation ?? 0,
		geometry.flipH ? 1 : 0,
		geometry.flipV ? 1 : 0
	].join(":");
};
var hashImageLikeBlock = (block) => {
	return [
		block.src.slice(0, 50),
		block.width ?? "",
		block.height ?? "",
		block.alt ?? "",
		block.title ?? "",
		block.objectFit ?? "",
		readBlockClipPath(block),
		block.rotation ?? "",
		block.flipH ? 1 : 0,
		block.flipV ? 1 : 0
	].join(":");
};
var hashListBlock = (block) => {
	return block.items.map((item) => `${item.id}:${item.marker.text}:${hashRuns(item.paragraph)}`).join("|");
};
var hashDrawingBlock = (block) => {
	if (block.drawingKind === "image") return `drawing:image:${hashImageLikeBlock(block)}`;
	if (block.drawingKind === "vectorShape") return [
		"drawing:vector",
		hashDrawingGeometry(block.geometry),
		block.shapeKind ?? "",
		JSON.stringify(block.fillColor ?? null),
		JSON.stringify(block.strokeColor ?? null),
		block.strokeWidth ?? "",
		JSON.stringify(block.customGeometry ?? null),
		JSON.stringify(block.lineEnds ?? null),
		JSON.stringify(block.effectExtent ?? null),
		JSON.stringify(block.textContent ?? null),
		block.textAlign ?? "",
		block.textVerticalAlign ?? "",
		JSON.stringify(block.textInsets ?? null)
	].join(":");
	if (block.drawingKind === "textboxShape") return [
		"drawing:textbox",
		hashDrawingGeometry(block.geometry),
		block.shapeKind ?? "",
		JSON.stringify(block.fillColor ?? null),
		JSON.stringify(block.strokeColor ?? null),
		block.strokeWidth ?? "",
		JSON.stringify(block.customGeometry ?? null),
		JSON.stringify(block.lineEnds ?? null),
		JSON.stringify(block.effectExtent ?? null),
		JSON.stringify(block.textContent ?? null),
		block.textAlign ?? "",
		block.textVerticalAlign ?? "",
		JSON.stringify(block.textInsets ?? null),
		block.contentBlocks.map((contentBlock) => `${contentBlock.id}:${hashRuns(contentBlock)}`).join("|")
	].join(":");
	if (block.drawingKind === "shapeGroup") return [
		"drawing:shapeGroup",
		hashDrawingGeometry(block.geometry),
		JSON.stringify(block.groupTransform ?? null),
		JSON.stringify(block.shapes),
		block.size?.width ?? "",
		block.size?.height ?? ""
	].join(":");
	return [
		"drawing:chart",
		hashDrawingGeometry(block.geometry),
		block.chartData?.chartType ?? "",
		block.chartData?.subType ?? "",
		JSON.stringify(block.chartData?.series ?? []),
		block.chartRelId ?? ""
	].join(":");
};
var hashNonParagraphCellBlock = (block) => {
	if (block.kind === "table") return `table:${hashRuns(block)}`;
	if (block.kind === "image") return `image:${hashImageLikeBlock(block)}`;
	if (block.kind === "drawing") return hashDrawingBlock(block);
	if (block.kind === "list") return `list:${hashListBlock(block)}`;
	return `${block.kind}:${block.id}`;
};
var hashRuns = (block) => {
	if (block.kind === "table") {
		const tableBlock = block;
		const cellHashes = [];
		if (!tableBlock.rows) return `${block.id}:table:`;
		for (const row of tableBlock.rows) {
			if (!row.cells) continue;
			for (const cell of row.cells) {
				if (cell.attrs) {
					const cellAttrs = cell.attrs;
					const cellAttrParts = [];
					if (cellAttrs.borders) cellAttrParts.push(`cb:${hashCellBorders(cellAttrs.borders)}`);
					if (cellAttrs.padding) {
						const p$1 = cellAttrs.padding;
						cellAttrParts.push(`cp:${p$1.top ?? 0}:${p$1.right ?? 0}:${p$1.bottom ?? 0}:${p$1.left ?? 0}`);
					}
					if (cellAttrs.verticalAlign) cellAttrParts.push(`va:${cellAttrs.verticalAlign}`);
					if (cellAttrs.background) cellAttrParts.push(`bg:${cellAttrs.background}`);
					if (cellAttrParts.length > 0) cellHashes.push(`ca:${cellAttrParts.join(":")}`);
				}
				const cellBlocks = getTableCellBlocks(cell);
				for (const cellBlock of cellBlocks) {
					if (cellBlock.kind !== "paragraph") {
						cellHashes.push(`nb:${hashNonParagraphCellBlock(cellBlock)}`);
						continue;
					}
					const paragraphBlock = cellBlock;
					if (!paragraphBlock.runs) continue;
					for (const run of paragraphBlock.runs) {
						const text = "text" in run && typeof run.text === "string" ? run.text : "";
						const marks = hashRunVisualMarks(run);
						const commentHash = hasComments$1(run) ? run.comments.map((c) => `${c.commentId ?? ""}:${c.internal ? "1" : "0"}`).join("|") : "";
						let trackedKey = "";
						if (hasTrackedChange(run)) {
							const tc = run.trackedChange;
							const beforeHash = tc.before ? JSON.stringify(tc.before) : "";
							const afterHash = tc.after ? JSON.stringify(tc.after) : "";
							trackedKey = `|tc:${tc.kind ?? ""}:${tc.id ?? ""}:${tc.author ?? ""}:${tc.date ?? ""}:${beforeHash}:${afterHash}`;
						}
						const commentKey = commentHash ? `|cm:${commentHash}` : "";
						cellHashes.push(`${text}:${marks}${trackedKey}${commentKey}`);
					}
					if (paragraphBlock.attrs) {
						const attrs = paragraphBlock.attrs;
						const parts = [];
						if (attrs.alignment) parts.push(`al:${attrs.alignment}`);
						if (attrs.spacing) {
							const s = attrs.spacing;
							if (s.before !== void 0) parts.push(`sb:${s.before}`);
							if (s.after !== void 0) parts.push(`sa:${s.after}`);
							if (s.line !== void 0) parts.push(`sl:${s.line}`);
							if (s.lineRule) parts.push(`sr:${s.lineRule}`);
						}
						if (attrs.indent) {
							const ind = attrs.indent;
							if (ind.left !== void 0) parts.push(`il:${ind.left}`);
							if (ind.right !== void 0) parts.push(`ir:${ind.right}`);
							if (ind.firstLine !== void 0) parts.push(`if:${ind.firstLine}`);
							if (ind.hanging !== void 0) parts.push(`ih:${ind.hanging}`);
						}
						if (attrs.borders) parts.push(`br:${hashParagraphBorders(attrs.borders)}`);
						if (attrs.shading) {
							const sh = attrs.shading;
							if (sh.fill) parts.push(`shf:${sh.fill}`);
							if (sh.color) parts.push(`shc:${sh.color}`);
						}
						const cellDir = getParagraphInlineDirection(attrs);
						if (cellDir) parts.push(`dir:${cellDir}`);
						if (parts.length > 0) cellHashes.push(`pa:${parts.join(":")}`);
					}
				}
			}
		}
		let tableAttrsKey = "";
		if (tableBlock.attrs) {
			const tblAttrs = tableBlock.attrs;
			const tableAttrParts = [];
			if (tblAttrs.borders) tableAttrParts.push(`tb:${hashTableBorders(tblAttrs.borders)}`);
			if (tblAttrs.borderCollapse) tableAttrParts.push(`bc:${tblAttrs.borderCollapse}`);
			if (tblAttrs.cellSpacing !== void 0) {
				const cs = tblAttrs.cellSpacing;
				const csKey = typeof cs === "number" ? `cs:n:${cs}` : `cs:${cs.value ?? 0}:${cs.type ?? "px"}`;
				tableAttrParts.push(csKey);
			}
			if (tableAttrParts.length > 0) tableAttrsKey = `|ta:${tableAttrParts.join(":")}`;
		}
		const contentHash = cellHashes.join("|");
		return `${block.id}:table:${contentHash}${tableAttrsKey}`;
	}
	if (block.kind !== "paragraph") return block.id;
	const trackedMode = block.attrs && "trackedChangesMode" in block.attrs && block.attrs.trackedChangesMode || "review";
	const trackedEnabled = resolveTrackedChangesEnabled(block.attrs, true);
	const runsHash = block.runs.map((run) => {
		if (run.kind === "image") {
			const imgRun = run;
			return `img:${imgRun.src.slice(0, 50)}:${imgRun.width}x${imgRun.height}`;
		}
		if (run.kind === "fieldAnnotation") return `fa:${fieldAnnotationKey(run)}`;
		if (run.kind === "math") return `math:${run.textContent}:${run.width}:${run.height}`;
		const text = "src" in run || run.kind === "lineBreak" || run.kind === "break" ? "" : run.text ?? "";
		const marks = hashRunVisualMarks(run);
		let trackedKey = "";
		if (hasTrackedChange(run)) {
			const tc = run.trackedChange;
			const beforeHash = tc.before ? JSON.stringify(tc.before) : "";
			const afterHash = tc.after ? JSON.stringify(tc.after) : "";
			trackedKey = `|tc:${tc.kind ?? ""}:${tc.id ?? ""}:${tc.author ?? ""}:${tc.date ?? ""}:${beforeHash}:${afterHash}`;
		}
		return `${text}:${marks}${trackedKey}`;
	}).join("|");
	let numberingKey = "";
	if (block.attrs) {
		const attrs = block.attrs;
		if (attrs.numberingProperties) {
			const np = attrs.numberingProperties;
			let markerTextKey;
			if (!attrs.wordLayout?.marker) markerTextKey = "<NULL>";
			else {
				const markerText = attrs.wordLayout.marker.markerText;
				markerTextKey = markerText === "" ? "<EMPTY>" : markerText ?? "<NULL>";
			}
			numberingKey = `|num:${np.numId ?? ""}:${np.ilvl ?? 0}:${markerTextKey}`;
		}
	}
	let paragraphAttrsKey = "";
	if (block.attrs) {
		const attrs = block.attrs;
		const parts = [];
		if (attrs.alignment) parts.push(`al:${attrs.alignment}`);
		if (attrs.spacing) {
			const s = attrs.spacing;
			if (s.before !== void 0) parts.push(`sb:${s.before}`);
			if (s.after !== void 0) parts.push(`sa:${s.after}`);
			if (s.line !== void 0) parts.push(`sl:${s.line}`);
			if (s.lineRule) parts.push(`sr:${s.lineRule}`);
		}
		if (attrs.indent) {
			const ind = attrs.indent;
			if (ind.left !== void 0) parts.push(`il:${ind.left}`);
			if (ind.right !== void 0) parts.push(`ir:${ind.right}`);
			if (ind.firstLine !== void 0) parts.push(`if:${ind.firstLine}`);
			if (ind.hanging !== void 0) parts.push(`ih:${ind.hanging}`);
		}
		if (attrs.borders) parts.push(`br:${hashParagraphBorders(attrs.borders)}`);
		if (attrs.shading) {
			const sh = attrs.shading;
			if (sh.fill) parts.push(`shf:${sh.fill}`);
			if (sh.color) parts.push(`shc:${sh.color}`);
		}
		if (attrs.tabs && attrs.tabs.length > 0) {
			const tabsHash = attrs.tabs.map((t) => `${t.val ?? ""}:${t.pos ?? ""}:${t.leader ?? ""}`).join(",");
			parts.push(`tb:${tabsHash}`);
		}
		const dir = getParagraphInlineDirection(attrs);
		if (dir) parts.push(`dir:${dir}`);
		if (attrs.keepNext) parts.push("kn");
		if (attrs.keepLines) parts.push("kl");
		if (attrs.floatAlignment) parts.push(`fa:${attrs.floatAlignment}`);
		if (attrs.contextualSpacing) parts.push("cs");
		if (attrs.suppressFirstLineIndent) parts.push("sfi");
		if (attrs.dropCap) parts.push(`dc:${attrs.dropCap}`);
		if (attrs.dropCapDescriptor) {
			const dcd = attrs.dropCapDescriptor;
			parts.push(`dcd:${dcd.mode ?? ""}:${dcd.lines ?? ""}`);
		}
		if (attrs.frame) parts.push(`fr:${hashParagraphFrame(attrs.frame)}`);
		if (attrs.tabIntervalTwips !== void 0) parts.push(`ti:${attrs.tabIntervalTwips}`);
		if (attrs.decimalSeparator) parts.push(`ds:${attrs.decimalSeparator}`);
		if (parts.length > 0) paragraphAttrsKey = `|pa:${parts.join(":")}`;
	}
	return `${trackedMode}:${trackedEnabled ? "on" : "off"}|${runsHash}${numberingKey}${paragraphAttrsKey}`;
};
var createStats = () => ({
	hits: 0,
	misses: 0,
	sets: 0,
	invalidations: 0,
	clears: 0,
	evictions: 0,
	size: 0,
	memorySizeEstimate: 0
});
var MAX_DIMENSION = 1e6;
var MeasureCache = class {
	constructor() {
		this.cache = /* @__PURE__ */ new Map();
		this.stats = createStats();
	}
	get(block, width, height, fontSignature = "") {
		if (!block || !block.id) return;
		const key = this.composeKey(block, width, height, fontSignature);
		const value = this.cache.get(key);
		if (value !== void 0) {
			this.stats.hits += 1;
			this.cache.delete(key);
			this.cache.set(key, value);
			return value;
		} else {
			this.stats.misses += 1;
			return;
		}
	}
	set(block, width, height, value, fontSignature = "") {
		if (!block || !block.id) return;
		const key = this.composeKey(block, width, height, fontSignature);
		if (this.cache.has(key)) this.cache.delete(key);
		if (this.cache.size >= MAX_CACHE_SIZE$1) {
			const oldestKey = this.cache.keys().next().value;
			if (oldestKey !== void 0) {
				this.cache.delete(oldestKey);
				this.stats.evictions += 1;
			}
		}
		this.cache.set(key, value);
		this.stats.sets += 1;
		this.updateSizeStats();
	}
	invalidate(blockIds) {
		let removed = 0;
		blockIds.forEach((id) => {
			for (const key of this.cache.keys()) if (key.startsWith(id + "@")) {
				this.cache.delete(key);
				removed += 1;
			}
		});
		this.stats.invalidations += removed;
		this.updateSizeStats();
	}
	clear() {
		this.cache.clear();
		this.stats.clears += 1;
		this.updateSizeStats();
	}
	resetStats() {
		const currentSize = this.cache.size;
		const currentMemory = currentSize * BYTES_PER_ENTRY_ESTIMATE;
		this.stats = createStats();
		this.stats.size = currentSize;
		this.stats.memorySizeEstimate = currentMemory;
	}
	getStats() {
		return { ...this.stats };
	}
	getSize() {
		return this.cache.size;
	}
	getMaxSize() {
		return MAX_CACHE_SIZE$1;
	}
	isNearCapacity(threshold = .9) {
		return this.cache.size >= MAX_CACHE_SIZE$1 * threshold;
	}
	updateSizeStats() {
		this.stats.size = this.cache.size;
		this.stats.memorySizeEstimate = this.cache.size * BYTES_PER_ENTRY_ESTIMATE;
	}
	composeKey(block, width, height, fontSignature) {
		const safeWidth = Number.isFinite(width) ? Math.max(0, Math.min(Math.floor(width), MAX_DIMENSION)) : 0;
		const safeHeight = Number.isFinite(height) ? Math.max(0, Math.min(Math.floor(height), MAX_DIMENSION)) : 0;
		const hash$3 = hashRuns(block);
		return `${block.id}@${safeWidth}x${safeHeight}:${hash$3}#${fontSignature}`;
	}
};
function forEachParagraphBlock(blocks, visit) {
	for (const block of blocks) if (block.kind === "paragraph") visit(block);
	else if (block.kind === "list") {
		const list = block;
		for (const item of list.items ?? []) forEachParagraphBlock([item.paragraph], visit);
	} else if (block.kind === "table") {
		const table = block;
		for (const row of table.rows ?? []) for (const cell of row.cells ?? []) if (cell.blocks && cell.blocks.length > 0) forEachParagraphBlock(cell.blocks, visit);
		else if (cell.paragraph) forEachParagraphBlock([cell.paragraph], visit);
	}
}
function resolveHeaderFooterTokens(blocks, pageNumber, totalPages, pageNumberText, displayPageNumber, sectionPageCount, pageNumberFormat, chapterNumberText, chapterSeparator) {
	if (!blocks || blocks.length === 0) return;
	if (!Number.isFinite(pageNumber) || pageNumber < 1) {
		console.warn("[resolveHeaderFooterTokens] Invalid pageNumber:", pageNumber, "- using 1 as fallback");
		pageNumber = 1;
	}
	if (!Number.isFinite(totalPages) || totalPages < 1) {
		console.warn("[resolveHeaderFooterTokens] Invalid totalPages:", totalPages, "- using 1 as fallback");
		totalPages = 1;
	}
	const pageNumberStr = pageNumberText ?? String(pageNumber);
	const totalPagesStr = String(totalPages);
	const displayNumber = displayPageNumber ?? pageNumber;
	const sectionPageNumberFormat = pageNumberFormat ?? "decimal";
	const sectionPageCountNumber = sectionPageCount || totalPages || 1;
	const sectionPageCountStr = String(sectionPageCountNumber);
	forEachParagraphBlock(blocks, (paraBlock) => {
		for (const run of paraBlock.runs) if ("token" in run && run.token) {
			if (run.token === "pageNumber") run.text = run.pageNumberFieldFormat ? formatChapterPageNumberText({
				pageComponent: formatPageNumberFieldValue(displayNumber, run.pageNumberFieldFormat),
				chapterNumberText,
				chapterSeparator
			}) : chapterNumberText ? formatSectionPageNumberText({
				displayNumber,
				pageFormat: sectionPageNumberFormat,
				chapterNumberText,
				chapterSeparator
			}) : pageNumberStr;
			else if (run.token === "totalPageCount") run.text = run.pageNumberFieldFormat ? formatPageNumberFieldValue(totalPages, run.pageNumberFieldFormat) : totalPagesStr;
			else if (run.token === "sectionPageCount") run.text = run.pageNumberFieldFormat ? formatPageNumberFieldValue(sectionPageCountNumber, run.pageNumberFieldFormat) : sectionPageCountStr;
		}
	});
}
function cloneHeaderFooterBlocks(blocks) {
	if (!blocks || blocks.length === 0) return [];
	return blocks.map(cloneHeaderFooterBlock);
}
function cloneHeaderFooterBlock(block) {
	if (block.kind === "paragraph") {
		const paraBlock = block;
		return {
			...paraBlock,
			runs: paraBlock.runs.map((run) => ({ ...run })),
			attrs: paraBlock.attrs ? { ...paraBlock.attrs } : void 0
		};
	}
	if (block.kind === "table") {
		const table = block;
		return {
			...table,
			rows: (table.rows ?? []).map((row) => ({
				...row,
				cells: (row.cells ?? []).map((cell) => ({
					...cell,
					paragraph: cell.paragraph ? cloneHeaderFooterBlock(cell.paragraph) : cell.paragraph,
					blocks: cell.blocks ? cell.blocks.map(cloneHeaderFooterBlock) : cell.blocks
				}))
			}))
		};
	}
	if (block.kind === "list") {
		const list = block;
		return {
			...list,
			items: (list.items ?? []).map((item) => ({
				...item,
				paragraph: cloneHeaderFooterBlock(item.paragraph)
			}))
		};
	}
	return { ...block };
}
init_dist();
function isEnabled(envVar, defaultValue) {
	if (typeof process$1$1 === "undefined" || typeof process$1$1.env === "undefined") return defaultValue;
	const value = process$1$1.env[envVar];
	if (value === "true" || value === "1") return true;
	if (value === "false" || value === "0") return false;
	return defaultValue;
}
const FeatureFlags = {
	NUMBERING_SECTION_AWARE: isEnabled("SD_NUMBERING_SECTION_AWARE", true),
	BODY_PAGE_TOKENS: isEnabled("SD_BODY_PAGE_TOKENS", true),
	HEADER_FOOTER_PAGE_TOKENS: isEnabled("SD_HEADER_FOOTER_PAGE_TOKENS", true),
	HF_DIGIT_BUCKETING: isEnabled("SD_HF_DIGIT_BUCKETING", true),
	DEBUG_PAGE_TOKENS: isEnabled("SD_DEBUG_PAGE_TOKENS", false),
	DEBUG_HF_CACHE: isEnabled("SD_DEBUG_HF_CACHE", false),
	DEBUG_LAYOUT_VERSION: isEnabled("SD_DEBUG_LAYOUT_VERSION", false)
};
const PageTokenLogger = {
	logIterationStart(iteration, totalPages) {
		if (!FeatureFlags.DEBUG_PAGE_TOKENS) return;
		console.log(`[PageTokens] Iteration ${iteration}: Resolving tokens for ${totalPages} pages`);
	},
	logAffectedBlocks(iteration, affectedBlockIds, blockSamples = []) {
		if (!FeatureFlags.DEBUG_PAGE_TOKENS) return;
		const count = affectedBlockIds.size;
		const samples = blockSamples.slice(0, 5).join(", ");
		console.log(`[PageTokens] Iteration ${iteration}: ${count} blocks affected`, samples ? `(samples: ${samples})` : "");
	},
	logConvergence(iteration, converged, totalTimeMs) {
		if (!FeatureFlags.DEBUG_PAGE_TOKENS) return;
		if (converged) console.log(`[PageTokens] Converged after ${iteration} iterations in ${totalTimeMs.toFixed(2)}ms`);
		else console.warn(`[PageTokens] Did NOT converge after ${iteration} iterations (${totalTimeMs.toFixed(2)}ms)`);
	},
	logError(blockId, error) {
		if (!FeatureFlags.DEBUG_PAGE_TOKENS) return;
		console.error(`[PageTokens] Error resolving tokens in block ${blockId}:`, error);
	},
	logRemeasure(blockCount, timeMs) {
		if (!FeatureFlags.DEBUG_PAGE_TOKENS) return;
		console.log(`[PageTokens] Re-measured ${blockCount} blocks in ${timeMs.toFixed(2)}ms`);
	}
};
const HeaderFooterCacheLogger = {
	logCacheHit(variantType, pageNumber, bucket) {
		if (!FeatureFlags.DEBUG_HF_CACHE) return;
		console.log(`[HF Cache] HIT: variant=${variantType}, page=${pageNumber}, bucket=${bucket}`);
	},
	logCacheMiss(variantType, pageNumber, bucket) {
		if (!FeatureFlags.DEBUG_HF_CACHE) return;
		console.log(`[HF Cache] MISS: variant=${variantType}, page=${pageNumber}, bucket=${bucket}`);
	},
	logInvalidation(reason, affectedBlockIds) {
		if (!FeatureFlags.DEBUG_HF_CACHE) return;
		console.log(`[HF Cache] INVALIDATE: reason=${reason}, blocks=${affectedBlockIds.length}`);
	},
	logStats(stats) {
		if (!FeatureFlags.DEBUG_HF_CACHE) return;
		const hitRate = stats.hits + stats.misses > 0 ? (stats.hits / (stats.hits + stats.misses) * 100).toFixed(1) : "0.0";
		console.log(`[HF Cache] Stats: hits=${stats.hits}, misses=${stats.misses}, hitRate=${hitRate}%, size=${stats.size}, evictions=${stats.evictions}`);
	},
	logBucketingDecision(totalPages, useBucketing, buckets) {
		if (!FeatureFlags.DEBUG_HF_CACHE) return;
		if (useBucketing && buckets) console.log(`[HF Cache] Bucketing enabled: ${totalPages} pages, buckets=${buckets.join(", ")}`);
		else console.log(`[HF Cache] Bucketing disabled: ${totalPages} pages (per-page layouts)`);
	}
};
var MetricsCollector = class {
	constructor() {
		this.pageTokenMetrics = null;
		this.headerFooterCacheMetrics = null;
		this.layoutMetrics = null;
	}
	recordPageTokenMetrics(metrics) {
		this.pageTokenMetrics = { ...metrics };
		this.checkPageTokenRollbackTriggers(metrics);
	}
	recordHeaderFooterCacheMetrics(stats) {
		const hitRate = stats.hits + stats.misses > 0 ? stats.hits / (stats.hits + stats.misses) * 100 : 0;
		this.headerFooterCacheMetrics = {
			hits: stats.hits,
			misses: stats.misses,
			hitRate,
			cacheSize: stats.size,
			memoryEstimate: stats.memorySizeEstimate,
			evictions: stats.evictions
		};
		this.checkCacheRollbackTriggers(this.headerFooterCacheMetrics);
	}
	recordLayoutMetrics(metrics) {
		this.layoutMetrics = { ...metrics };
	}
	getMetrics() {
		return {
			pageTokens: this.pageTokenMetrics,
			headerFooterCache: this.headerFooterCacheMetrics,
			layout: this.layoutMetrics
		};
	}
	reset() {
		this.pageTokenMetrics = null;
		this.headerFooterCacheMetrics = null;
		this.layoutMetrics = null;
	}
	checkPageTokenRollbackTriggers(metrics) {
		if (metrics.iterations > 2 && !metrics.converged) console.warn(`[Rollback Trigger] Page token resolution did not converge after ${metrics.iterations} iterations. Consider disabling SD_BODY_PAGE_TOKENS if this persists.`);
		if (metrics.totalTimeMs > 100 && metrics.iterations > 0) console.warn(`[Rollback Trigger] Page token resolution took ${metrics.totalTimeMs.toFixed(2)}ms (>100ms threshold). Consider disabling SD_BODY_PAGE_TOKENS if performance is unacceptable.`);
	}
	checkCacheRollbackTriggers(metrics) {
		const MIN_HIT_RATE = 30;
		const MAX_MEMORY_PER_100_PAGES = 1e6;
		if (metrics.hits + metrics.misses > 10 && metrics.hitRate < MIN_HIT_RATE) console.warn(`[Rollback Trigger] Header/footer cache hit rate is low (${metrics.hitRate.toFixed(1)}% < ${MIN_HIT_RATE}%). Consider disabling SD_HF_DIGIT_BUCKETING if cache thrashing persists.`);
		if (metrics.memoryEstimate > MAX_MEMORY_PER_100_PAGES) console.warn(`[Rollback Trigger] Header/footer cache memory usage is high (${(metrics.memoryEstimate / 1e6).toFixed(2)}MB). Monitor for excessive growth.`);
	}
};
const globalMetrics = new MetricsCollector();
var MIN_PAGES_FOR_BUCKETING = 100;
function getBucketForPageNumber(pageNumber) {
	if (pageNumber < 10) return "d1";
	if (pageNumber < 100) return "d2";
	if (pageNumber < 1e3) return "d3";
	return "d4";
}
function getBucketRepresentative(bucket) {
	switch (bucket) {
		case "d1": return 5;
		case "d2": return 50;
		case "d3": return 500;
		case "d4": return 5e3;
	}
}
function getBucketForDigitCount(digitCount) {
	if (digitCount <= 1) return "d1";
	if (digitCount === 2) return "d2";
	if (digitCount === 3) return "d3";
	return "d4";
}
function getBucketForRenderedPageNumberText(text) {
	const digitCount = (text.match(/\d/g) ?? []).length;
	if (digitCount <= 0) return null;
	return getBucketForDigitCount(digitCount);
}
function forEachPageNumberRun(blocks, visit) {
	for (const block of blocks) if (block.kind === "paragraph") {
		const paraBlock = block;
		for (const run of paraBlock.runs) if ("token" in run && run.token === "pageNumber") visit(run);
	} else if (block.kind === "list") {
		const list = block;
		for (const item of list.items ?? []) for (const run of item.paragraph.runs) if ("token" in run && run.token === "pageNumber") visit(run);
	} else if (block.kind === "table") {
		const table = block;
		for (const row of table.rows ?? []) for (const cell of row.cells ?? []) forEachPageNumberRun(cell.blocks ? cell.blocks : cell.paragraph ? [cell.paragraph] : [], visit);
	}
}
function buildCompatibleFieldFormatKey(fieldFormat) {
	return `${fieldFormat.format ?? "decimal"}:${fieldFormat.zeroPadding ?? ""}`;
}
function getPageNumberBucketingStrategy(blocks) {
	let sawImplicitPageNumber = false;
	const explicitFieldFormats = /* @__PURE__ */ new Map();
	forEachPageNumberRun(blocks, (run) => {
		const fieldFormat = run.pageNumberFieldFormat;
		if (!fieldFormat) {
			sawImplicitPageNumber = true;
			return;
		}
		if (!isDigitBucketCompatiblePageNumberFormat(fieldFormat.format)) {
			explicitFieldFormats.clear();
			sawImplicitPageNumber = true;
			return;
		}
		explicitFieldFormats.set(buildCompatibleFieldFormatKey(fieldFormat), fieldFormat);
	});
	if (explicitFieldFormats.size === 0) return sawImplicitPageNumber ? { kind: "displayText" } : null;
	if (sawImplicitPageNumber || explicitFieldFormats.size > 1) return null;
	return {
		kind: "fieldFormat",
		fieldFormat: explicitFieldFormats.values().next().value
	};
}
function canUseDigitBucketingForVariant(blocks, docTotalPages, pageResolver) {
	const strategy = getPageNumberBucketingStrategy(blocks);
	if (!strategy) return false;
	const renderedBucketForPage = (pageNumber) => {
		const pageInfo = pageResolver(pageNumber);
		const renderedText = strategy.kind === "fieldFormat" ? Number.isFinite(pageInfo.displayNumber) ? formatChapterPageNumberText({
			pageComponent: formatPageNumberFieldValue(pageInfo.displayNumber ?? pageNumber, strategy.fieldFormat),
			chapterNumberText: pageInfo.chapterNumberText,
			chapterSeparator: pageInfo.chapterSeparator
		}) : null : pageInfo.displayText;
		return renderedText ? getBucketForRenderedPageNumberText(renderedText) : null;
	};
	const expectedRenderedBuckets = /* @__PURE__ */ new Map();
	for (let pageNumber = 1; pageNumber <= docTotalPages; pageNumber += 1) {
		const physicalBucket = getBucketForPageNumber(pageNumber);
		const renderedBucket = renderedBucketForPage(pageNumber);
		if (!renderedBucket) return false;
		const expectedBucket = expectedRenderedBuckets.get(physicalBucket);
		if (!expectedBucket) {
			expectedRenderedBuckets.set(physicalBucket, renderedBucket);
			continue;
		}
		if (expectedBucket !== renderedBucket) return false;
	}
	for (const [physicalBucket, expectedRenderedBucket] of expectedRenderedBuckets) if (renderedBucketForPage(getBucketRepresentative(physicalBucket)) !== expectedRenderedBucket) return false;
	return true;
}
function paragraphHasPageToken(para) {
	for (const run of para.runs) if ("token" in run && (run.token === "pageNumber" || run.token === "totalPageCount" || run.token === "sectionPageCount")) return true;
	return false;
}
function paragraphHasSectionPageCountToken(para) {
	for (const run of para.runs) if ("token" in run && run.token === "sectionPageCount") return true;
	return false;
}
function paragraphHasPageNumberToken(para) {
	for (const run of para.runs) if ("token" in run && run.token === "pageNumber") return true;
	return false;
}
function isDigitBucketCompatiblePageNumberFormat(format) {
	return !format || format === "decimal" || format === "numberInDash";
}
function paragraphRequiresPerPageLayout(para) {
	for (const run of para.runs) if ("token" in run && run.token === "pageNumber" && run.pageNumberFieldFormat && !isDigitBucketCompatiblePageNumberFormat(run.pageNumberFieldFormat.format)) return true;
	return false;
}
function hasPageTokens(blocks) {
	for (const block of blocks) if (block.kind === "paragraph") {
		if (paragraphHasPageToken(block)) return true;
	} else if (block.kind === "list") {
		const list = block;
		for (const item of list.items ?? []) if (paragraphHasPageToken(item.paragraph)) return true;
	} else if (block.kind === "table") {
		const table = block;
		for (const row of table.rows ?? []) for (const cell of row.cells ?? []) if (hasPageTokens(cell.blocks ? cell.blocks : cell.paragraph ? [cell.paragraph] : [])) return true;
	}
	return false;
}
function hasSectionPageCountTokens(blocks) {
	for (const block of blocks) if (block.kind === "paragraph") {
		if (paragraphHasSectionPageCountToken(block)) return true;
	} else if (block.kind === "list") {
		const list = block;
		for (const item of list.items ?? []) if (paragraphHasSectionPageCountToken(item.paragraph)) return true;
	} else if (block.kind === "table") {
		const table = block;
		for (const row of table.rows ?? []) for (const cell of row.cells ?? []) if (hasSectionPageCountTokens(cell.blocks ? cell.blocks : cell.paragraph ? [cell.paragraph] : [])) return true;
	}
	return false;
}
function hasPageNumberTokens(blocks) {
	for (const block of blocks) if (block.kind === "paragraph") {
		if (paragraphHasPageNumberToken(block)) return true;
	} else if (block.kind === "list") {
		const list = block;
		for (const item of list.items ?? []) if (paragraphHasPageNumberToken(item.paragraph)) return true;
	} else if (block.kind === "table") {
		const table = block;
		for (const row of table.rows ?? []) for (const cell of row.cells ?? []) if (hasPageNumberTokens(cell.blocks ? cell.blocks : cell.paragraph ? [cell.paragraph] : [])) return true;
	}
	return false;
}
function hasPageNumberTokensRequiringPerPageLayout(blocks) {
	for (const block of blocks) if (block.kind === "paragraph") {
		if (paragraphRequiresPerPageLayout(block)) return true;
	} else if (block.kind === "list") {
		const list = block;
		for (const item of list.items ?? []) if (paragraphRequiresPerPageLayout(item.paragraph)) return true;
	} else if (block.kind === "table") {
		const table = block;
		for (const row of table.rows ?? []) for (const cell of row.cells ?? []) if (hasPageNumberTokensRequiringPerPageLayout(cell.blocks ? cell.blocks : cell.paragraph ? [cell.paragraph] : [])) return true;
	}
	return false;
}
var HeaderFooterLayoutCache = class {
	constructor() {
		this.cache = new MeasureCache();
	}
	async measureBlocks(blocks, constraints, measureBlock$1, fontSignature = "") {
		const measures = [];
		for (const block of blocks) {
			const cached = this.cache.get(block, constraints.width, constraints.height, fontSignature);
			if (cached) {
				measures.push(cached);
				continue;
			}
			const measurement = await measureBlock$1(block, {
				maxWidth: constraints.width,
				maxHeight: constraints.height
			});
			this.cache.set(block, constraints.width, constraints.height, measurement, fontSignature);
			measures.push(measurement);
		}
		return measures;
	}
	invalidate(blockIds) {
		this.cache.invalidate(blockIds);
	}
	getStats() {
		return this.cache.getStats();
	}
};
var sharedHeaderFooterCache = new HeaderFooterLayoutCache();
async function layoutHeaderFooterWithCache(sections, constraints, measureBlock$1, cache$2 = sharedHeaderFooterCache, totalPages, pageResolver, kind, fontSignature = "", remeasureParagraph$1) {
	const result = {};
	if (!pageResolver) {
		const numPages = totalPages ?? 1;
		for (const [type, blocks] of Object.entries(sections)) {
			if (!blocks || blocks.length === 0) continue;
			const clonedBlocks = cloneHeaderFooterBlocks(blocks);
			resolveHeaderFooterTokens(clonedBlocks, 1, numPages);
			const measures = await cache$2.measureBlocks(clonedBlocks, constraints, measureBlock$1, fontSignature);
			result[type] = {
				blocks: clonedBlocks,
				measures,
				layout: layoutHeaderFooter(clonedBlocks, measures, constraints, kind, remeasureParagraph$1)
			};
		}
		return result;
	}
	const { totalPages: docTotalPages } = pageResolver(1);
	if (!Number.isFinite(docTotalPages) || docTotalPages <= 0) return result;
	const useBucketing = FeatureFlags.HF_DIGIT_BUCKETING && docTotalPages >= MIN_PAGES_FOR_BUCKETING;
	for (const [type, blocks] of Object.entries(sections)) {
		if (!blocks || blocks.length === 0) continue;
		if (!hasPageTokens(blocks)) {
			const measures = await cache$2.measureBlocks(blocks, constraints, measureBlock$1, fontSignature);
			result[type] = {
				blocks,
				measures,
				layout: layoutHeaderFooter(blocks, measures, constraints, kind, remeasureParagraph$1)
			};
			continue;
		}
		let pagesToLayout;
		const hasPageNumberToken = hasPageNumberTokens(blocks);
		if (!(useBucketing && !hasPageNumberTokensRequiringPerPageLayout(blocks) && !hasSectionPageCountTokens(blocks) && (!hasPageNumberToken || canUseDigitBucketingForVariant(blocks, docTotalPages, pageResolver)))) {
			pagesToLayout = Array.from({ length: docTotalPages }, (_$1, i) => i + 1);
			HeaderFooterCacheLogger.logBucketingDecision(docTotalPages, false);
		} else {
			const bucketsNeeded = /* @__PURE__ */ new Set();
			for (let p$1 = 1; p$1 <= docTotalPages; p$1++) bucketsNeeded.add(getBucketForPageNumber(p$1));
			pagesToLayout = Array.from(bucketsNeeded).map((bucket) => getBucketRepresentative(bucket));
			HeaderFooterCacheLogger.logBucketingDecision(docTotalPages, true, Array.from(bucketsNeeded));
		}
		const pages = [];
		for (const pageNum of pagesToLayout) {
			const clonedBlocks = cloneHeaderFooterBlocks(blocks);
			const { displayText, displayNumber, totalPages: totalPagesForPage, sectionPageCount, pageFormat, chapterNumberText, chapterSeparator } = pageResolver(pageNum);
			resolveHeaderFooterTokens(clonedBlocks, pageNum, totalPagesForPage, displayText, displayNumber, sectionPageCount, pageFormat, chapterNumberText, chapterSeparator);
			const measures = await cache$2.measureBlocks(clonedBlocks, constraints, measureBlock$1, fontSignature);
			const pageLayout = layoutHeaderFooter(clonedBlocks, measures, constraints, kind, remeasureParagraph$1);
			const measuresById = /* @__PURE__ */ new Map();
			for (let i = 0; i < clonedBlocks.length; i += 1) measuresById.set(clonedBlocks[i].id, measures[i]);
			const fragmentsWithLines = pageLayout.pages[0]?.fragments.map((fragment) => {
				if (fragment.kind !== "para") return fragment;
				const measure = measuresById.get(fragment.blockId);
				if (!measure || measure.kind !== "paragraph") return fragment;
				return {
					...fragment,
					lines: measure.lines.slice(fragment.fromLine, fragment.toLine)
				};
			}) ?? [];
			pages.push({
				number: pageNum,
				displayNumber,
				blocks: clonedBlocks,
				measures,
				fragments: fragmentsWithLines,
				layout: pageLayout,
				numberText: displayText,
				pageNumberFormat: pageFormat,
				pageNumberChapterText: chapterNumberText,
				pageNumberChapterSeparator: chapterSeparator
			});
		}
		const pageLayouts = pages.map((page) => page.layout);
		const minYValues = pageLayouts.map((layout) => layout.minY).filter((value) => value !== void 0);
		const maxYValues = pageLayouts.map((layout) => layout.maxY).filter((value) => value !== void 0);
		const minY = minYValues.length > 0 ? Math.min(...minYValues) : void 0;
		const maxY = maxYValues.length > 0 ? Math.max(...maxYValues) : void 0;
		const renderHeight = minY !== void 0 && maxY !== void 0 ? maxY - minY : void 0;
		const finalLayout = {
			height: pageLayouts.reduce((maxHeight, layout) => Math.max(maxHeight, layout.height), 0),
			minY,
			maxY,
			renderHeight,
			pages: pages.map((p$1) => ({
				number: p$1.number,
				displayNumber: p$1.displayNumber,
				fragments: p$1.fragments,
				numberText: p$1.numberText,
				pageNumberFormat: p$1.pageNumberFormat,
				pageNumberChapterText: p$1.pageNumberChapterText,
				pageNumberChapterSeparator: p$1.pageNumberChapterSeparator,
				blocks: p$1.blocks,
				measures: p$1.measures
			}))
		};
		result[type] = {
			blocks: pages[0]?.blocks ?? blocks,
			measures: pages[0]?.measures ?? [],
			layout: finalLayout
		};
	}
	return result;
}
function findWordBoundaries(blocks, pos) {
	const blockInfo = findBlockAtPosition(blocks, pos);
	if (!blockInfo) return null;
	const { block, localPos } = blockInfo;
	if (block.kind !== "paragraph") return null;
	const { text, pmStart } = extractBlockText(block);
	if (text.length === 0) return null;
	const clampedPos = Math.max(0, Math.min(localPos, text.length));
	let wordStart = clampedPos;
	while (wordStart > 0 && isWordChar$2(text[wordStart - 1])) wordStart--;
	let wordEnd = clampedPos;
	while (wordEnd < text.length && isWordChar$2(text[wordEnd])) wordEnd++;
	if (wordStart === wordEnd) {
		while (wordStart > 0 && isWhitespace(text[wordStart - 1])) wordStart--;
		while (wordEnd < text.length && isWhitespace(text[wordEnd])) wordEnd++;
		if (wordStart === wordEnd) return null;
	}
	return {
		from: pmStart + wordStart,
		to: pmStart + wordEnd
	};
}
function findParagraphBoundaries(blocks, pos) {
	const blockInfo = findBlockAtPosition(blocks, pos);
	if (!blockInfo) return null;
	const { block } = blockInfo;
	if (block.kind === "paragraph") {
		const { pmStart, pmEnd } = extractBlockText(block);
		return {
			from: pmStart,
			to: pmEnd
		};
	}
	if (block.kind === "image") return {
		from: pos,
		to: pos + 1
	};
	return null;
}
function extractBlockText(block) {
	if (block.kind !== "paragraph") return {
		text: "",
		pmStart: 0,
		pmEnd: 0
	};
	let text = "";
	let pmStart = Infinity;
	let pmEnd = 0;
	for (const run of block.runs) {
		text += "src" in run || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation" || run.kind === "math" ? "" : run.text;
		if (run.pmStart !== void 0) pmStart = Math.min(pmStart, run.pmStart);
		if (run.pmEnd !== void 0) pmEnd = Math.max(pmEnd, run.pmEnd);
	}
	if (pmStart === Infinity) pmStart = 0;
	if (pmEnd === 0 && text.length > 0) pmEnd = pmStart + text.length;
	return {
		text,
		pmStart,
		pmEnd
	};
}
function findBlockAtPosition(blocks, pos) {
	for (const block of blocks) if (block.kind === "paragraph") {
		const { pmStart, pmEnd } = extractBlockText(block);
		if (pos >= pmStart && pos <= pmEnd) return {
			block,
			localPos: pos - pmStart
		};
	}
	return null;
}
function isWordChar$2(char) {
	return /[\p{L}\p{N}_]/u.test(char);
}
function isWhitespace(char) {
	return /\s/.test(char);
}
var HEADER_FOOTER_VARIANTS$1 = [
	"default",
	"first",
	"even",
	"odd"
];
function buildSectionAwareHeaderFooterLayoutKey(rId, sectionIndex) {
	return `${rId}::s${sectionIndex}`;
}
function buildSectionContentWidth(section, fallback) {
	const pageWidth = section.pageSize?.w ?? fallback.pageWidth ?? 0;
	const marginLeft = section.margins?.left ?? fallback.margins?.left ?? 0;
	const marginRight = section.margins?.right ?? fallback.margins?.right ?? 0;
	return pageWidth - marginLeft - marginRight;
}
function buildEffectiveHeaderFooterRefsBySection(sectionMetadata, kind) {
	const effectiveRefsBySection = /* @__PURE__ */ new Map();
	let inheritedRefs = {};
	for (const section of sectionMetadata) {
		const explicitRefs = kind === "header" ? section.headerRefs : section.footerRefs;
		const effectiveRefs = { ...inheritedRefs };
		for (const variant of HEADER_FOOTER_VARIANTS$1) {
			const refId = explicitRefs?.[variant];
			if (refId) effectiveRefs[variant] = refId;
		}
		if (Object.keys(effectiveRefs).length > 0) effectiveRefsBySection.set(section.sectionIndex, effectiveRefs);
		inheritedRefs = effectiveRefs;
	}
	return effectiveRefsBySection;
}
function collectReferencedHeaderFooterRIds(effectiveRefsBySection) {
	const referencedRIds = /* @__PURE__ */ new Set();
	for (const refs of effectiveRefsBySection.values()) for (const variant of HEADER_FOOTER_VARIANTS$1) {
		const refId = refs[variant];
		if (refId) referencedRIds.add(refId);
	}
	return referencedRIds;
}
function buildConstraintsForSection(section, fallback, minWidth) {
	const pageWidth = section.pageSize?.w ?? fallback.pageWidth ?? 0;
	const pageHeight = section.pageSize?.h ?? fallback.pageHeight;
	const marginLeft = section.margins?.left ?? fallback.margins?.left ?? 0;
	const marginRight = section.margins?.right ?? fallback.margins?.right ?? 0;
	const marginTop = section.margins?.top ?? fallback.margins?.top;
	const marginBottom = section.margins?.bottom ?? fallback.margins?.bottom;
	const headerMargin = section.margins?.header ?? fallback.margins?.header;
	const footerMargin = section.margins?.footer ?? fallback.margins?.footer;
	const contentWidth = pageWidth - marginLeft - marginRight;
	const maxWidth = pageWidth - marginLeft;
	const effectiveWidth = minWidth ? Math.min(Math.max(contentWidth, minWidth), maxWidth) : contentWidth;
	const sectionMarginTop = marginTop ?? 0;
	const sectionMarginBottom = marginBottom ?? 0;
	return {
		width: effectiveWidth,
		height: pageHeight != null ? Math.max(1, pageHeight - sectionMarginTop - sectionMarginBottom) : fallback.height,
		pageWidth,
		pageHeight,
		margins: {
			left: marginLeft,
			right: marginRight,
			top: marginTop,
			bottom: marginBottom,
			header: headerMargin,
			footer: footerMargin
		},
		overflowBaseHeight: fallback.overflowBaseHeight
	};
}
function getTableWidthSpec(blocks) {
	let widestSpec;
	let maxResolvedWidth = 0;
	for (const block of blocks) {
		if (block.kind !== "table") continue;
		const tableWidth = block.attrs?.tableWidth;
		const widthValue = tableWidth?.width ?? tableWidth?.value;
		if (tableWidth?.type === "pct" && typeof widthValue === "number" && widthValue > 0) {
			if (!widestSpec || widestSpec.type !== "pct" || widthValue > widestSpec.value) {
				widestSpec = {
					type: "pct",
					value: widthValue
				};
				maxResolvedWidth = Number.POSITIVE_INFINITY;
			}
			continue;
		}
		if ((tableWidth?.type === "px" || tableWidth?.type === "pixel") && typeof widthValue === "number") {
			if (widthValue > maxResolvedWidth) {
				maxResolvedWidth = widthValue;
				widestSpec = {
					type: "px",
					value: widthValue
				};
			}
			continue;
		}
		if (block.columnWidths && block.columnWidths.length > 0) {
			const gridWidth = block.columnWidths.reduce((sum, columnWidth) => sum + columnWidth, 0);
			if (gridWidth > maxResolvedWidth) {
				maxResolvedWidth = gridWidth;
				widestSpec = {
					type: "grid",
					value: gridWidth
				};
			}
		}
	}
	return widestSpec;
}
function resolveTableMinWidth(spec, contentWidth) {
	if (!spec) return 0;
	if (spec.type === "pct") return contentWidth * (spec.value / OOXML_PCT_DIVISOR);
	return spec.value;
}
function buildSectionAwareHeaderFooterMeasurementGroups(kind, blocksByRId, sectionMetadata, fallbackConstraints) {
	if (!blocksByRId || sectionMetadata.length === 0) return [];
	const effectiveRefsBySection = buildEffectiveHeaderFooterRefsBySection(sectionMetadata, kind);
	const tableWidthSpecByRId = /* @__PURE__ */ new Map();
	for (const [rId, blocks] of blocksByRId) {
		const tableWidthSpec = getTableWidthSpec(blocks);
		if (tableWidthSpec) tableWidthSpecByRId.set(rId, tableWidthSpec);
	}
	const groups = /* @__PURE__ */ new Map();
	for (const section of sectionMetadata) {
		const refs = effectiveRefsBySection.get(section.sectionIndex);
		if (!refs) continue;
		const uniqueRIds = /* @__PURE__ */ new Set();
		for (const variant of HEADER_FOOTER_VARIANTS$1) {
			const refId = refs[variant];
			if (refId) uniqueRIds.add(refId);
		}
		for (const rId of uniqueRIds) {
			if (!blocksByRId.has(rId)) continue;
			const contentWidth = buildSectionContentWidth(section, fallbackConstraints);
			const sectionConstraints = buildConstraintsForSection(section, fallbackConstraints, resolveTableMinWidth(tableWidthSpecByRId.get(rId), contentWidth) || void 0);
			const effectiveWidth = sectionConstraints.width;
			const groupKey = [
				rId,
				`w${effectiveWidth}`,
				`ph${sectionConstraints.pageHeight ?? ""}`,
				`mt${sectionConstraints.margins?.top ?? ""}`,
				`mb${sectionConstraints.margins?.bottom ?? ""}`,
				`mh${sectionConstraints.margins?.header ?? ""}`,
				`mf${sectionConstraints.margins?.footer ?? ""}`
			].join("::");
			const existingGroup = groups.get(groupKey);
			if (existingGroup) {
				existingGroup.sectionIndices.add(section.sectionIndex);
				continue;
			}
			groups.set(groupKey, {
				rId,
				sectionIndices: new Set([section.sectionIndex]),
				sectionConstraints,
				effectiveWidth
			});
		}
	}
	return Array.from(groups.values());
}
var canvas = null;
var ctx = null;
function getCtx() {
	if (ctx) return ctx;
	if (typeof document === "undefined") return null;
	canvas = document.createElement("canvas");
	ctx = canvas.getContext("2d");
	return ctx;
}
function isTextRun$3(run) {
	if (run.kind === "tab" || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation") return false;
	if ("src" in run) return false;
	return true;
}
function fontString(run) {
	const textRun = isTextRun$3(run) ? run : null;
	const size$1 = textRun?.fontSize ?? 16;
	const family = textRun?.fontFamily ?? "Arial";
	return `${textRun?.italic ? "italic " : ""}${textRun?.bold ? "bold " : ""}${size$1}px ${family}`.trim();
}
function runText(run) {
	if (isEmptySdtPlaceholderRun(run)) return run.sdt?.type === "structuredContent" && run.sdt.appearance === "hidden" ? "" : EMPTY_SDT_PLACEHOLDER_TEXT;
	return "src" in run || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation" || run.kind === "math" ? "" : run.text ?? "";
}
var isWordChar$1 = (char) => {
	if (!char) return false;
	const code = char.charCodeAt(0);
	return code >= 48 && code <= 57 || code >= 65 && code <= 90 || code >= 97 && code <= 122 || char === "'";
};
var capitalizeText$2 = (text, fullText, startOffset) => {
	if (!text) return text;
	const hasFullText = typeof startOffset === "number" && fullText != null;
	let result = "";
	for (let i = 0; i < text.length; i += 1) {
		const prevChar = hasFullText ? startOffset + i > 0 ? fullText[startOffset + i - 1] : "" : i > 0 ? text[i - 1] : "";
		const ch = text[i];
		result += isWordChar$1(ch) && !isWordChar$1(prevChar) ? ch.toUpperCase() : ch;
	}
	return result;
};
var applyTextTransform$2 = (text, transform, fullText, startOffset) => {
	if (!text || !transform || transform === "none") return text;
	if (transform === "uppercase") return text.toUpperCase();
	if (transform === "lowercase") return text.toLowerCase();
	if (transform === "capitalize") return capitalizeText$2(text, fullText, startOffset);
	return text;
};
var DEFAULT_TAB_INTERVAL_TWIPS$1 = 720;
var TWIPS_PER_PX$2 = 1440 / 96;
var TAB_EPSILON$1 = .1;
var WIDTH_FUDGE_PX = .5;
var twipsToPx$1 = (twips) => twips / TWIPS_PER_PX$2;
var pxToTwips$1 = (px) => Math.round(px * TWIPS_PER_PX$2);
var sanitizeIndent$1 = (value) => typeof value === "number" && Number.isFinite(value) ? Math.max(0, value) : 0;
var sanitizeRawIndent = (value) => typeof value === "number" && Number.isFinite(value) ? value : 0;
var sanitizeDecimalSeparator$1 = (value) => value === "," ? "," : ".";
var getRunWidth = (run) => {
	const width = run.width;
	return typeof width === "number" ? width : 0;
};
var isLineBreakRun$1 = (run) => run.kind === "lineBreak" || run.kind === "break" && run.breakType === "line";
var markerFontString = (run) => {
	const size$1 = run?.fontSize ?? 16;
	const family = run?.fontFamily ?? "Arial";
	return `${run?.italic ? "italic " : ""}${run?.bold ? "bold " : ""}${size$1}px ${family}`.trim();
};
var buildTabStopsPx$1 = (indent, tabs, tabIntervalTwips) => {
	const paragraphIndentTwips = {
		left: pxToTwips$1(sanitizeIndent$1(indent?.left)),
		right: pxToTwips$1(sanitizeIndent$1(indent?.right)),
		firstLine: pxToTwips$1(sanitizeIndent$1(indent?.firstLine)),
		hanging: pxToTwips$1(sanitizeIndent$1(indent?.hanging))
	};
	const rawParagraphIndentTwips = {
		left: pxToTwips$1(sanitizeRawIndent(indent?.left)),
		right: pxToTwips$1(sanitizeRawIndent(indent?.right)),
		firstLine: pxToTwips$1(sanitizeRawIndent(indent?.firstLine)),
		hanging: pxToTwips$1(sanitizeIndent$1(indent?.hanging))
	};
	return computeTabStops$1({
		explicitStops: tabs ?? [],
		defaultTabInterval: tabIntervalTwips ?? DEFAULT_TAB_INTERVAL_TWIPS$1,
		paragraphIndent: paragraphIndentTwips,
		rawParagraphIndent: rawParagraphIndentTwips
	}).map((stop) => ({
		pos: twipsToPx$1(stop.pos),
		val: stop.val,
		leader: stop.leader,
		source: stop.source
	}));
};
var getNextTabStopPx$1 = (currentX, tabStops, startIndex) => {
	let index = startIndex;
	while (index < tabStops.length && tabStops[index].pos <= currentX + TAB_EPSILON$1) index += 1;
	if (index < tabStops.length) return {
		target: tabStops[index].pos,
		nextIndex: index + 1,
		stop: tabStops[index]
	};
	return {
		target: currentX + twipsToPx$1(DEFAULT_TAB_INTERVAL_TWIPS$1),
		nextIndex: index
	};
};
function measureRunSliceWidth(run, fromChar, toChar) {
	const context = getCtx();
	const fullText = runText(run);
	const transform = isTextRun$3(run) ? run.textTransform : void 0;
	const text = applyTextTransform$2(fullText.slice(fromChar, toChar), transform, fullText, fromChar);
	if (!context) {
		const size$1 = (isTextRun$3(run) ? run : null)?.fontSize ?? 16;
		return Math.max(1, text.length * (size$1 * .6));
	}
	context.font = fontString(run);
	return context.measureText(text).width;
}
var scanTabAlignmentGroup = (runs, startRunIndex, startChar, decimalSeparator) => {
	let totalWidth = 0;
	let beforeDecimalWidth;
	let foundDecimal = false;
	let endRun = startRunIndex;
	let endChar = startChar;
	for (let r$1 = startRunIndex; r$1 < runs.length; r$1 += 1) {
		const run = runs[r$1];
		if (!run) continue;
		if (run.kind === "tab") return {
			totalWidth,
			beforeDecimalWidth,
			endRun,
			endChar,
			resumeRun: r$1,
			resumeChar: 0
		};
		if (isLineBreakRun$1(run)) return {
			totalWidth,
			beforeDecimalWidth,
			endRun,
			endChar,
			resumeRun: r$1,
			resumeChar: 0
		};
		const text = runText(run);
		if (!text) {
			const runWidth = getRunWidth(run);
			if (runWidth > 0) {
				totalWidth += runWidth;
				endRun = r$1;
				endChar = 1;
			}
			continue;
		}
		const sliceStart = r$1 === startRunIndex ? startChar : 0;
		if (sliceStart >= text.length) continue;
		const tabIndex = text.indexOf("	", sliceStart);
		const effectiveEnd = tabIndex >= 0 ? tabIndex : text.length;
		if (effectiveEnd > sliceStart) {
			const sliceWidth = measureRunSliceWidth(run, sliceStart, effectiveEnd);
			if (!foundDecimal) {
				const decimalIndex = text.slice(sliceStart, effectiveEnd).indexOf(decimalSeparator);
				if (decimalIndex >= 0) {
					foundDecimal = true;
					const beforeWidth = decimalIndex > 0 ? measureRunSliceWidth(run, sliceStart, sliceStart + decimalIndex) : 0;
					beforeDecimalWidth = totalWidth + beforeWidth;
				}
			}
			totalWidth += sliceWidth;
			endRun = r$1;
			endChar = effectiveEnd;
		}
		if (tabIndex >= 0) return {
			totalWidth,
			beforeDecimalWidth,
			endRun,
			endChar,
			resumeRun: r$1,
			resumeChar: tabIndex
		};
	}
	return {
		totalWidth,
		beforeDecimalWidth,
		endRun,
		endChar,
		resumeRun: runs.length,
		resumeChar: 0
	};
};
var measureTabAlignmentGroupInLine = (runs, line, startRunIndex, startChar, decimalSeparator) => {
	let totalWidth = 0;
	let beforeDecimalWidth;
	let foundDecimal = false;
	for (let r$1 = startRunIndex; r$1 <= line.toRun; r$1 += 1) {
		const run = runs[r$1];
		if (!run) continue;
		if (run.kind === "tab") break;
		if (isLineBreakRun$1(run)) break;
		const text = runText(run);
		if (!text) {
			totalWidth += getRunWidth(run);
			continue;
		}
		const sliceStart = r$1 === startRunIndex ? startChar : 0;
		const sliceEnd = r$1 === line.toRun ? line.toChar : text.length;
		if (sliceStart >= sliceEnd) continue;
		const slice = text.slice(sliceStart, sliceEnd);
		const tabIndex = slice.indexOf("	");
		const effectiveSlice = tabIndex >= 0 ? slice.slice(0, tabIndex) : slice;
		const effectiveSliceEnd = tabIndex >= 0 ? sliceStart + tabIndex : sliceEnd;
		if (effectiveSlice.length > 0) {
			const sliceWidth = measureRunSliceWidth(run, sliceStart, effectiveSliceEnd);
			totalWidth += sliceWidth;
			if (!foundDecimal) {
				const decimalIndex = effectiveSlice.indexOf(decimalSeparator);
				if (decimalIndex >= 0) {
					foundDecimal = true;
					const beforeWidth = decimalIndex > 0 ? measureRunSliceWidth(run, sliceStart, sliceStart + decimalIndex) : 0;
					beforeDecimalWidth = totalWidth - sliceWidth + beforeWidth;
				}
			}
		}
		if (tabIndex >= 0) break;
	}
	return {
		totalWidth,
		beforeDecimalWidth
	};
};
var applyTabLayoutToLines = (lines, runs, tabStops, decimalSeparator, indentLeft, rawFirstLineOffset) => {
	const totalTabRuns = runs.reduce((count, run) => run.kind === "tab" ? count + 1 : count, 0);
	const alignmentTabStopsPx = tabStops.map((stop, index) => ({
		stop,
		index
	})).filter(({ stop }) => stop.val === "end" || stop.val === "center" || stop.val === "decimal");
	const tabSegmentInfo = /* @__PURE__ */ new Map();
	{
		let segmentTabRunIndices = [];
		const closeSegment = () => {
			const total = segmentTabRunIndices.length;
			segmentTabRunIndices.forEach((runIdx, ord) => {
				tabSegmentInfo.set(runIdx, {
					localOrdinal: ord,
					segmentTotal: total
				});
			});
			segmentTabRunIndices = [];
		};
		for (let i = 0; i < runs.length; i++) {
			const r$1 = runs[i];
			if (r$1.kind === "lineBreak" || r$1.kind === "break" && r$1.breakType === "line") closeSegment();
			else if (r$1.kind === "tab") segmentTabRunIndices.push(i);
		}
		closeSegment();
	}
	const getAlignmentStopForOrdinal = (ordinal, runIdx) => {
		if (alignmentTabStopsPx.length === 0 || totalTabRuns === 0 || !Number.isFinite(ordinal)) return null;
		let scopeOrdinal = ordinal;
		let scopeTotal = totalTabRuns;
		if (runIdx !== void 0) {
			const info = tabSegmentInfo.get(runIdx);
			if (info) {
				scopeOrdinal = info.localOrdinal;
				scopeTotal = info.segmentTotal;
			}
		}
		if (scopeOrdinal < 0 || scopeOrdinal >= scopeTotal) return null;
		const remainingTabs = scopeTotal - scopeOrdinal - 1;
		const targetIndex = alignmentTabStopsPx.length - 1 - remainingTabs;
		if (targetIndex < 0 || targetIndex >= alignmentTabStopsPx.length) return null;
		return alignmentTabStopsPx[targetIndex];
	};
	let sequentialTabIndex = 0;
	const consumeTabOrdinal = (explicitIndex) => {
		if (typeof explicitIndex === "number" && Number.isFinite(explicitIndex)) {
			sequentialTabIndex = Math.max(sequentialTabIndex, explicitIndex + 1);
			return explicitIndex;
		}
		const ordinal = sequentialTabIndex;
		sequentialTabIndex += 1;
		return ordinal;
	};
	lines.forEach((line, lineIndex) => {
		let cursorX = 0;
		let lineWidth = 0;
		let tabStopCursor = 0;
		let pendingTabAlignStartX = null;
		const segments = [];
		const leaders = [];
		const effectiveIndent = lineIndex === 0 ? indentLeft + rawFirstLineOffset : indentLeft;
		const maxAbsWidth = typeof line.maxWidth === "number" && Number.isFinite(line.maxWidth) ? line.maxWidth + effectiveIndent : Number.POSITIVE_INFINITY;
		const applyTab = (startRunIndex, startChar, run, tabOrdinal, tabRunIdx) => {
			const originX = cursorX;
			const absCurrentX = cursorX + effectiveIndent;
			let stop;
			let target;
			const greedy = getNextTabStopPx$1(absCurrentX, tabStops, tabStopCursor);
			const forcedAlignment = greedy.stop?.source === "default" && typeof tabOrdinal === "number" && Number.isFinite(tabOrdinal) ? getAlignmentStopForOrdinal(tabOrdinal, tabRunIdx) : null;
			if (forcedAlignment && forcedAlignment.stop.pos > absCurrentX + TAB_EPSILON$1) {
				stop = forcedAlignment.stop;
				target = forcedAlignment.stop.pos;
				tabStopCursor = forcedAlignment.index + 1;
			} else {
				stop = greedy.stop;
				target = greedy.target;
				tabStopCursor = greedy.nextIndex;
			}
			const clampedTarget = Number.isFinite(maxAbsWidth) ? Math.min(target, maxAbsWidth) : target;
			const relativeTarget = clampedTarget - effectiveIndent;
			const stopVal = stop?.val ?? "start";
			const shouldCompensateNegativeLeft = stopVal === "start" && indentLeft < 0 && effectiveIndent === indentLeft && stop?.source !== "explicit";
			const paintTarget = shouldCompensateNegativeLeft ? relativeTarget - Math.min(effectiveIndent, 0) : relativeTarget;
			const precedingTabEndX = shouldCompensateNegativeLeft ? relativeTarget : void 0;
			lineWidth = Math.max(lineWidth, relativeTarget);
			if (stop?.source === "explicit") line.hasExplicitTabStops = true;
			let currentLeader = null;
			if (stop?.leader && stop.leader !== "none") {
				currentLeader = {
					from: Math.min(originX + effectiveIndent, clampedTarget),
					to: Math.max(originX + effectiveIndent, clampedTarget),
					style: stop.leader
				};
				leaders.push(currentLeader);
			}
			if (stopVal === "end" || stopVal === "center" || stopVal === "decimal") {
				const groupMeasure = measureTabAlignmentGroupInLine(runs, line, startRunIndex, startChar, decimalSeparator);
				if (groupMeasure.totalWidth > 0) {
					let groupStartX;
					if (stopVal === "end") groupStartX = Math.max(0, relativeTarget - groupMeasure.totalWidth);
					else if (stopVal === "center") groupStartX = Math.max(0, relativeTarget - groupMeasure.totalWidth / 2);
					else {
						const beforeDecimal = groupMeasure.beforeDecimalWidth ?? groupMeasure.totalWidth;
						groupStartX = Math.max(0, relativeTarget - beforeDecimal);
					}
					if (currentLeader) currentLeader.to = groupStartX + effectiveIndent;
					pendingTabAlignStartX = {
						layoutX: groupStartX,
						paintX: groupStartX
					};
				} else cursorX = Math.max(cursorX, relativeTarget);
			} else {
				cursorX = Math.max(cursorX, relativeTarget);
				pendingTabAlignStartX = {
					layoutX: relativeTarget,
					paintX: paintTarget,
					...precedingTabEndX !== void 0 ? { precedingTabEndX } : {}
				};
			}
			if (run && run.kind === "tab") run.width = Math.max(0, relativeTarget - originX);
		};
		const consumePendingTabAlignStart = () => {
			const pending = pendingTabAlignStartX;
			pendingTabAlignStartX = null;
			return pending;
		};
		for (let runIndex = line.fromRun; runIndex <= line.toRun; runIndex += 1) {
			const run = runs[runIndex];
			if (!run) continue;
			if (run.kind === "tab") {
				const ordinal = consumeTabOrdinal(run.tabIndex);
				applyTab(runIndex + 1, 0, run, ordinal, runIndex);
				continue;
			}
			const text = runText(run);
			if (!text) {
				cursorX += getRunWidth(run);
				lineWidth = Math.max(lineWidth, cursorX);
				continue;
			}
			const sliceStart = runIndex === line.fromRun ? line.fromChar : 0;
			const sliceEnd = runIndex === line.toRun ? line.toChar : text.length;
			if (sliceStart >= sliceEnd) continue;
			let segmentStart = sliceStart;
			for (let i = sliceStart; i < sliceEnd; i += 1) {
				if (text[i] !== "	") continue;
				if (i > segmentStart) {
					const segmentWidth = measureRunSliceWidth(run, segmentStart, i);
					const segment = {
						runIndex,
						fromChar: segmentStart,
						toChar: i,
						width: segmentWidth
					};
					const pendingTabAlign = consumePendingTabAlignStart();
					if (pendingTabAlign != null) {
						segment.x = pendingTabAlign.paintX;
						if (pendingTabAlign.precedingTabEndX !== void 0) segment.precedingTabEndX = pendingTabAlign.precedingTabEndX;
						cursorX = pendingTabAlign.layoutX + segmentWidth;
					} else cursorX += segmentWidth;
					lineWidth = Math.max(lineWidth, cursorX);
					segments.push(segment);
				}
				const ordinal = consumeTabOrdinal();
				applyTab(runIndex, i + 1, void 0, ordinal);
				segmentStart = i + 1;
			}
			if (segmentStart < sliceEnd) {
				const segmentWidth = measureRunSliceWidth(run, segmentStart, sliceEnd);
				const segment = {
					runIndex,
					fromChar: segmentStart,
					toChar: sliceEnd,
					width: segmentWidth
				};
				const pendingTabAlign = consumePendingTabAlignStart();
				if (pendingTabAlign != null) {
					segment.x = pendingTabAlign.paintX;
					if (pendingTabAlign.precedingTabEndX !== void 0) segment.precedingTabEndX = pendingTabAlign.precedingTabEndX;
					cursorX = pendingTabAlign.layoutX + segmentWidth;
				} else cursorX += segmentWidth;
				lineWidth = Math.max(lineWidth, cursorX);
				segments.push(segment);
			}
		}
		if (segments.length > 0) line.segments = segments;
		if (leaders.length > 0) line.leaders = leaders;
		if (lineWidth > 0) line.width = Math.max(line.width, lineWidth);
	});
};
function lineHeightForRuns(runs, fromRun, toRun, fallbackFontSize = 16) {
	let maxSize$1 = 0;
	for (let i = fromRun; i <= toRun; i += 1) {
		const run = runs[i];
		const size$1 = (run && isTextRun$3(run) ? run : null)?.fontSize ?? 0;
		if (size$1 > maxSize$1) maxSize$1 = size$1;
	}
	return (maxSize$1 > 0 ? maxSize$1 : fallbackFontSize) * 1.2;
}
function remeasureParagraph(block, maxWidth, firstLineIndent = 0) {
	if (!Number.isFinite(maxWidth) || maxWidth <= 0) throw new Error(`remeasureParagraph: maxWidth must be a positive number, got ${maxWidth}`);
	if (!Number.isFinite(firstLineIndent)) throw new Error(`remeasureParagraph: firstLineIndent must be a finite number, got ${firstLineIndent}`);
	if (!block) throw new Error("remeasureParagraph: block must be defined");
	if (!Array.isArray(block.runs)) throw new Error(`remeasureParagraph: block.runs must be an array, got ${typeof block.runs}`);
	const runs = block.runs ?? [];
	const lines = [];
	const attrs = block.attrs;
	const indent = attrs?.indent;
	const wordLayout = attrs?.wordLayout;
	const rawIndentLeft = typeof indent?.left === "number" && Number.isFinite(indent.left) ? indent.left : 0;
	const rawIndentRight = typeof indent?.right === "number" && Number.isFinite(indent.right) ? indent.right : 0;
	const indentLeft = rawIndentLeft;
	const indentRight = rawIndentRight;
	const indentFirstLine = Math.max(0, indent?.firstLine ?? 0);
	const indentHanging = Math.max(0, indent?.hanging ?? 0);
	const baseFirstLineOffset = attrs?.suppressFirstLineIndent === true ? 0 : firstLineIndent || indentFirstLine - indentHanging;
	const clampedFirstLineOffset = Math.max(0, baseFirstLineOffset);
	const hasNegativeLeftIndent = rawIndentLeft < 0;
	const allowNegativeFirstLineOffset = !wordLayout?.marker && !hasNegativeLeftIndent && baseFirstLineOffset < 0;
	const effectiveFirstLineOffset = wordLayout?.marker ? 0 : allowNegativeFirstLineOffset ? baseFirstLineOffset : clampedFirstLineOffset;
	const contentWidth = Math.max(1, maxWidth - indentLeft - indentRight);
	const textStartPx = wordLayout?.textStartPx;
	let measuredMarkerTextWidth;
	const effectiveTextStartPx = resolveListTextStartPx(wordLayout, indentLeft, indentFirstLine, indentHanging, (markerText, marker$1) => {
		const context = getCtx();
		if (!context) return 0;
		context.font = markerFontString(marker$1.run);
		const width = context.measureText(markerText).width;
		measuredMarkerTextWidth = width;
		return width;
	}) ?? textStartPx;
	const treatAsHanging = !wordLayout?.marker && effectiveTextStartPx && indentLeft === 0 && indentHanging === 0;
	const firstLineWidth = typeof effectiveTextStartPx === "number" && effectiveTextStartPx > indentLeft && !treatAsHanging ? Math.max(1, maxWidth - effectiveTextStartPx - indentRight) : Math.max(1, contentWidth - effectiveFirstLineOffset);
	const tabStops = buildTabStopsPx$1(indent, attrs?.tabs, attrs?.tabIntervalTwips);
	const decimalSeparator = sanitizeDecimalSeparator$1(attrs?.decimalSeparator);
	let currentRun = 0;
	let currentChar = 0;
	let lastMeasuredFontSize = runs.find((run) => isTextRun$3(run) && typeof run.fontSize === "number")?.fontSize ?? 16;
	while (currentRun < runs.length) {
		const isFirstLine = lines.length === 0;
		const effectiveMaxWidth = Math.max(1, isFirstLine ? firstLineWidth : contentWidth);
		const effectiveIndent = isFirstLine ? indentLeft + baseFirstLineOffset : indentLeft;
		const startRun = currentRun;
		const startChar = currentChar;
		let width = 0;
		let widthAtLastBreak = -1;
		let lastBreakRun = -1;
		let lastBreakChar = -1;
		let endRun = currentRun;
		let endChar = currentChar;
		let tabStopCursor = 0;
		let didBreakInThisLine = false;
		let explicitLineBreakRun = -1;
		let resumeRun = -1;
		let resumeChar = 0;
		let lineMaxTextFontSize = 0;
		for (let r$1 = currentRun; r$1 < runs.length; r$1 += 1) {
			const run = runs[r$1];
			if (isLineBreakRun$1(run)) {
				explicitLineBreakRun = r$1;
				if (startRun === r$1 && startChar === 0 && width === 0) {
					endRun = r$1;
					endChar = 0;
				}
				didBreakInThisLine = true;
				break;
			}
			if (run.kind === "tab") {
				const absCurrentX = width + effectiveIndent;
				const { target, nextIndex, stop } = getNextTabStopPx$1(absCurrentX, tabStops, tabStopCursor);
				const maxAbsWidth = effectiveMaxWidth + effectiveIndent;
				const clampedTarget = Math.min(target, maxAbsWidth);
				const tabAdvance = Math.max(0, clampedTarget - absCurrentX);
				width += tabAdvance;
				tabStopCursor = nextIndex;
				if (stop && (stop.val === "end" || stop.val === "center" || stop.val === "decimal")) {
					const group = scanTabAlignmentGroup(runs, r$1 + 1, 0, decimalSeparator);
					if (group.totalWidth > 0) {
						const relativeTarget = clampedTarget - effectiveIndent;
						let groupStartX;
						if (stop.val === "end") groupStartX = Math.max(0, relativeTarget - group.totalWidth);
						else if (stop.val === "center") groupStartX = Math.max(0, relativeTarget - group.totalWidth / 2);
						else {
							const beforeDecimal = group.beforeDecimalWidth ?? group.totalWidth;
							groupStartX = Math.max(0, relativeTarget - beforeDecimal);
						}
						const rightEdge = stop.val === "end" ? relativeTarget : groupStartX + group.totalWidth;
						width = Math.max(width, rightEdge);
						endRun = group.endRun;
						endChar = group.endChar;
						lastBreakRun = group.endRun;
						lastBreakChar = group.endChar;
						widthAtLastBreak = width;
						if (group.resumeRun >= runs.length) {
							didBreakInThisLine = true;
							break;
						}
						if (group.resumeRun > r$1) {
							resumeRun = group.resumeRun;
							resumeChar = group.resumeChar;
							r$1 = resumeRun - 1;
							continue;
						}
					}
				}
				endRun = r$1;
				endChar = 1;
				lastBreakRun = r$1;
				lastBreakChar = 1;
				widthAtLastBreak = width;
				continue;
			}
			const text = runText(run);
			const start$1 = r$1 === currentRun ? currentChar : r$1 === resumeRun ? resumeChar : 0;
			if (r$1 === resumeRun) resumeRun = -1;
			if (text.length > 0 && isTextRun$3(run)) lineMaxTextFontSize = Math.max(lineMaxTextFontSize, run.fontSize ?? 16);
			if (isEmptySdtPlaceholderRun(run)) {
				const placeholderWidth = text.length > 0 ? measureRunSliceWidth(run, 0, text.length) : 0;
				if (width > 0 && width + placeholderWidth > effectiveMaxWidth - WIDTH_FUDGE_PX) {
					didBreakInThisLine = true;
					break;
				}
				width += placeholderWidth;
				endRun = r$1;
				endChar = text.length > 0 ? text.length : start$1 + 1;
				continue;
			}
			for (let c = start$1; c < text.length; c += 1) {
				const ch = text[c];
				if (ch === "	") {
					const absCurrentX = width + effectiveIndent;
					const { target, nextIndex, stop } = getNextTabStopPx$1(absCurrentX, tabStops, tabStopCursor);
					const maxAbsWidth = effectiveMaxWidth + effectiveIndent;
					const clampedTarget = Math.min(target, maxAbsWidth);
					const tabAdvance = Math.max(0, clampedTarget - absCurrentX);
					width += tabAdvance;
					tabStopCursor = nextIndex;
					if (stop && (stop.val === "end" || stop.val === "center" || stop.val === "decimal")) {
						const group = scanTabAlignmentGroup(runs, r$1, c + 1, decimalSeparator);
						if (group.totalWidth > 0) {
							const relativeTarget = clampedTarget - effectiveIndent;
							let groupStartX;
							if (stop.val === "end") groupStartX = Math.max(0, relativeTarget - group.totalWidth);
							else if (stop.val === "center") groupStartX = Math.max(0, relativeTarget - group.totalWidth / 2);
							else {
								const beforeDecimal = group.beforeDecimalWidth ?? group.totalWidth;
								groupStartX = Math.max(0, relativeTarget - beforeDecimal);
							}
							const rightEdge = stop.val === "end" ? relativeTarget : groupStartX + group.totalWidth;
							width = Math.max(width, rightEdge);
							endRun = group.endRun;
							endChar = group.endChar;
							lastBreakRun = group.endRun;
							lastBreakChar = group.endChar;
							widthAtLastBreak = width;
							if (group.resumeRun >= runs.length) {
								didBreakInThisLine = true;
								break;
							}
							if (group.resumeRun > r$1) {
								resumeRun = group.resumeRun;
								resumeChar = group.resumeChar;
								r$1 = resumeRun - 1;
								break;
							}
							if (group.resumeRun === r$1) {
								c = group.resumeChar - 1;
								continue;
							}
						}
					}
					endRun = r$1;
					endChar = c + 1;
					lastBreakRun = r$1;
					lastBreakChar = c + 1;
					widthAtLastBreak = width;
					continue;
				}
				const w = measureRunSliceWidth(run, c, c + 1);
				if (width + w > effectiveMaxWidth - WIDTH_FUDGE_PX && width > 0) {
					if (lastBreakRun < 0 && width + w <= effectiveMaxWidth + WIDTH_FUDGE_PX) {
						width += w;
						endRun = r$1;
						endChar = c + 1;
						continue;
					}
					if (lastBreakRun >= 0) {
						endRun = lastBreakRun;
						endChar = lastBreakChar;
						width = widthAtLastBreak >= 0 ? widthAtLastBreak : width;
					} else {
						endRun = r$1;
						endChar = c;
					}
					didBreakInThisLine = true;
					break;
				}
				width += w;
				endRun = r$1;
				endChar = c + 1;
				if (ch === " " || ch === "	" || ch === "-") {
					lastBreakRun = r$1;
					lastBreakChar = c + 1;
					widthAtLastBreak = width;
				}
			}
			if (didBreakInThisLine) break;
		}
		if (explicitLineBreakRun < 0 && startRun === endRun && startChar === endChar) {
			endRun = startRun;
			endChar = startChar + 1;
		}
		const line = {
			fromRun: startRun,
			fromChar: startChar,
			toRun: endRun,
			toChar: endChar,
			width,
			ascent: 0,
			descent: 0,
			lineHeight: lineHeightForRuns(runs, startRun, endRun, lastMeasuredFontSize),
			maxWidth: effectiveMaxWidth
		};
		lines.push(line);
		if (lineMaxTextFontSize > 0) lastMeasuredFontSize = lineMaxTextFontSize;
		if (explicitLineBreakRun >= 0) {
			if (startRun === explicitLineBreakRun && startChar === 0 && endRun === explicitLineBreakRun && endChar === 0) currentRun = explicitLineBreakRun + 1;
			else {
				let nextNonBreakRun = explicitLineBreakRun + 1;
				while (nextNonBreakRun < runs.length && isLineBreakRun$1(runs[nextNonBreakRun])) nextNonBreakRun += 1;
				currentRun = nextNonBreakRun >= runs.length ? explicitLineBreakRun : explicitLineBreakRun + 1;
			}
			currentChar = 0;
		} else {
			currentRun = endRun;
			currentChar = endChar;
		}
		if (currentRun >= runs.length) break;
		if (!isLineBreakRun$1(runs[currentRun]) && currentChar >= runText(runs[currentRun]).length) {
			currentRun += 1;
			currentChar = 0;
		}
	}
	const hasTabRun = runs.some((run) => run?.kind === "tab");
	const hasTextTab = runs.some((run) => run?.kind === "text" && typeof run.text === "string" && run.text.includes("	"));
	if (hasTabRun || hasTextTab) applyTabLayoutToLines(lines, runs, tabStops, decimalSeparator, indentLeft, baseFirstLineOffset);
	const totalHeight = lines.reduce((s, l) => s + l.lineHeight, 0);
	const marker = wordLayout?.marker;
	return {
		kind: "paragraph",
		lines,
		totalHeight,
		marker: marker ? {
			markerWidth: indentHanging ?? 0,
			markerTextWidth: measuredMarkerTextWidth ?? 0,
			indentLeft,
			gutterWidth: marker.gutterWidthPx
		} : void 0
	};
}
function hasComments(run) {
	return "comments" in run && Array.isArray(run.comments) && run.comments.length > 0;
}
const computeDirtyRegions = (previous, next) => {
	const prevMap = new Map(previous.map((block, index) => [block.id, {
		block,
		index
	}]));
	const nextMap = new Map(next.map((block, index) => [block.id, {
		block,
		index
	}]));
	const stableBlockIds = /* @__PURE__ */ new Set();
	let firstDirtyIndex = next.length;
	let lastStableIndex = -1;
	let prevPointer = 0;
	let nextPointer = 0;
	while (prevPointer < previous.length && nextPointer < next.length) {
		const prevBlock = previous[prevPointer];
		const nextBlock = next[nextPointer];
		if (prevBlock.id === nextBlock.id && shallowEqual$1(prevBlock, nextBlock)) {
			lastStableIndex = nextPointer;
			stableBlockIds.add(prevBlock.id);
			prevPointer += 1;
			nextPointer += 1;
			continue;
		}
		firstDirtyIndex = Math.min(firstDirtyIndex, nextPointer);
		if (!nextMap.has(prevBlock.id)) prevPointer += 1;
		else if (!prevMap.has(nextBlock.id)) nextPointer += 1;
		else {
			prevPointer += 1;
			nextPointer += 1;
		}
	}
	const insertedBlockIds = next.filter((block) => !prevMap.has(block.id)).map((block) => block.id);
	const deletedBlockIds = previous.filter((block) => !nextMap.has(block.id)).map((block) => block.id);
	if (firstDirtyIndex === next.length && previous.length !== next.length) firstDirtyIndex = Math.min(prevPointer, nextPointer);
	return {
		firstDirtyIndex: firstDirtyIndex === next.length ? next.length : firstDirtyIndex,
		lastStableIndex,
		insertedBlockIds,
		deletedBlockIds,
		stableBlockIds
	};
};
var shallowEqual$1 = (a, b$1) => {
	if (a.kind !== b$1.kind) return false;
	if (a.kind === "image" && b$1.kind === "image") return imageBlocksEqual(a, b$1);
	if (a.kind === "paragraph" && b$1.kind === "paragraph") return paragraphBlocksEqual(a, b$1);
	if (a.kind === "drawing" && b$1.kind === "drawing") return drawingBlocksEqual(a, b$1);
	return false;
};
var getTrackedChangeKey = (run) => {
	if (hasTrackedChange(run)) {
		const tc = run.trackedChange;
		const beforeHash = tc.before ? JSON.stringify(tc.before) : "";
		const afterHash = tc.after ? JSON.stringify(tc.after) : "";
		return `${tc.kind ?? ""}:${tc.id ?? ""}:${tc.author ?? ""}:${tc.date ?? ""}:${beforeHash}:${afterHash}`;
	}
	return "";
};
var getCommentKey = (run) => {
	if (!hasComments(run)) return "";
	return run.comments.map((c) => `${c.commentId ?? ""}:${c.internal ? "1" : "0"}`).join("|");
};
var paragraphSpacingEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	return a.before === b$1.before && a.after === b$1.after && a.line === b$1.line && a.lineRule === b$1.lineRule && a.beforeAutospacing === b$1.beforeAutospacing && a.afterAutospacing === b$1.afterAutospacing;
};
var paragraphIndentEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	return a.left === b$1.left && a.right === b$1.right && a.firstLine === b$1.firstLine && a.hanging === b$1.hanging;
};
var paragraphBorderEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	return a.style === b$1.style && a.width === b$1.width && a.color === b$1.color && a.space === b$1.space;
};
var paragraphBordersEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	return paragraphBorderEqual(a.top, b$1.top) && paragraphBorderEqual(a.right, b$1.right) && paragraphBorderEqual(a.bottom, b$1.bottom) && paragraphBorderEqual(a.left, b$1.left);
};
var paragraphShadingEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	return a.fill === b$1.fill && a.color === b$1.color && a.val === b$1.val && a.themeColor === b$1.themeColor && a.themeFill === b$1.themeFill && a.themeFillShade === b$1.themeFillShade && a.themeFillTint === b$1.themeFillTint && a.themeShade === b$1.themeShade && a.themeTint === b$1.themeTint;
};
var tabStopEqual = (a, b$1) => {
	return a.val === b$1.val && a.pos === b$1.pos && a.leader === b$1.leader;
};
var tabStopsEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	if (a.length !== b$1.length) return false;
	for (let i = 0; i < a.length; i += 1) if (!tabStopEqual(a[i], b$1[i])) return false;
	return true;
};
var paragraphFrameEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	return a.wrap === b$1.wrap && a.x === b$1.x && a.y === b$1.y && a.xAlign === b$1.xAlign && a.yAlign === b$1.yAlign && a.hAnchor === b$1.hAnchor && a.vAnchor === b$1.vAnchor;
};
var dropCapDescriptorEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	if (a.mode !== b$1.mode || a.lines !== b$1.lines) return false;
	const runA = a.run;
	const runB = b$1.run;
	if (!runA || !runB) return !runA && !runB;
	if (runA.text !== runB.text || runA.fontFamily !== runB.fontFamily || runA.fontSize !== runB.fontSize || runA.bold !== runB.bold || runA.italic !== runB.italic || runA.color !== runB.color) return false;
	return true;
};
var paragraphAttrsEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	if (a.alignment !== b$1.alignment || a.contextualSpacing !== b$1.contextualSpacing || a.suppressFirstLineIndent !== b$1.suppressFirstLineIndent || a.dropCap !== b$1.dropCap || a.decimalSeparator !== b$1.decimalSeparator || a.tabIntervalTwips !== b$1.tabIntervalTwips || a.keepNext !== b$1.keepNext || a.keepLines !== b$1.keepLines || getParagraphInlineDirection(a) !== getParagraphInlineDirection(b$1) || a.floatAlignment !== b$1.floatAlignment) return false;
	if (!paragraphSpacingEqual(a.spacing, b$1.spacing)) return false;
	if (!paragraphIndentEqual(a.indent, b$1.indent)) return false;
	if (!paragraphBordersEqual(a.borders, b$1.borders)) return false;
	if (!paragraphShadingEqual(a.shading, b$1.shading)) return false;
	if (!tabStopsEqual(a.tabs, b$1.tabs)) return false;
	if (!paragraphFrameEqual(a.frame, b$1.frame)) return false;
	if (!dropCapDescriptorEqual(a.dropCapDescriptor, b$1.dropCapDescriptor)) return false;
	return true;
};
var paragraphBlocksEqual = (a, b$1) => {
	if ((a.attrs?.trackedChangesMode ?? "review") !== (b$1.attrs?.trackedChangesMode ?? "review")) return false;
	if (resolveTrackedChangesEnabled(a.attrs, true) !== resolveTrackedChangesEnabled(b$1.attrs, true)) return false;
	const aMarker = a.attrs?.wordLayout?.marker;
	const bMarker = b$1.attrs?.wordLayout?.marker;
	if ((aMarker?.markerText ?? null) !== (bMarker?.markerText ?? null)) return false;
	if ((aMarker?.justification ?? null) !== (bMarker?.justification ?? null)) return false;
	if (!paragraphAttrsEqual(a.attrs, b$1.attrs)) return false;
	if (a.runs.length !== b$1.runs.length) return false;
	for (let i = 0; i < a.runs.length; i += 1) {
		const runA = a.runs[i];
		const runB = b$1.runs[i];
		if (runA.kind === "image" || runB.kind === "image") {
			if (runA.kind !== "image" || runB.kind !== "image") return false;
			if (!imageRunsEqual(runA, runB)) return false;
			continue;
		}
		if (runA.kind === "math" || runB.kind === "math") {
			if (runA.kind !== runB.kind) return false;
			if (runA.kind === "math" && runB.kind === "math") {
				if (runA.textContent !== runB.textContent) return false;
			}
			continue;
		}
		if (("src" in runA || runA.kind === "lineBreak" || runA.kind === "break" || runA.kind === "fieldAnnotation" ? "" : runA.text) !== ("src" in runB || runB.kind === "lineBreak" || runB.kind === "break" || runB.kind === "fieldAnnotation" ? "" : runB.text) || fieldAnnotationKey(runA) !== fieldAnnotationKey(runB) || hashRunVisualMarks(runA) !== hashRunVisualMarks(runB) || getTrackedChangeKey(runA) !== getTrackedChangeKey(runB) || getCommentKey(runA) !== getCommentKey(runB)) return false;
	}
	return true;
};
var imageRunsEqual = (a, b$1) => {
	return a.src === b$1.src && a.width === b$1.width && a.height === b$1.height && a.alt === b$1.alt && a.title === b$1.title && a.clipPath === b$1.clipPath && a.distTop === b$1.distTop && a.distBottom === b$1.distBottom && a.distLeft === b$1.distLeft && a.distRight === b$1.distRight && a.verticalAlign === b$1.verticalAlign && a.rotation === b$1.rotation && a.flipH === b$1.flipH && a.flipV === b$1.flipV && a.gain === b$1.gain && a.blacklevel === b$1.blacklevel && a.grayscale === b$1.grayscale && jsonEqual(a.lum, b$1.lum) && jsonEqual(a.hyperlink, b$1.hyperlink) && jsonEqual(a.sdt, b$1.sdt) && shallowRecordEqual(a.dataAttrs, b$1.dataAttrs);
};
var imageBlocksEqual = (a, b$1) => {
	return a.src === b$1.src && a.width === b$1.width && a.height === b$1.height && a.alt === b$1.alt && a.title === b$1.title && a.objectFit === b$1.objectFit && a.display === b$1.display && boxSpacingEqual(a.margin, b$1.margin) && boxSpacingEqual(a.padding, b$1.padding) && imageAnchorEqual(a.anchor, b$1.anchor) && imageWrapEqual(a.wrap, b$1.wrap) && shallowRecordEqual(a.attrs, b$1.attrs);
};
var drawingBlocksEqual = (a, b$1) => {
	if (a.drawingKind !== b$1.drawingKind) return false;
	if (!boxSpacingEqual(a.margin, b$1.margin)) return false;
	if (!boxSpacingEqual(a.padding, b$1.padding)) return false;
	if (!imageAnchorEqual(a.anchor, b$1.anchor)) return false;
	if (!imageWrapEqual(a.wrap, b$1.wrap)) return false;
	if (a.zIndex !== b$1.zIndex) return false;
	if (a.drawingContentId !== b$1.drawingContentId) return false;
	if (!jsonEqual(a.drawingContent, b$1.drawingContent)) return false;
	if (!shallowRecordEqual(a.attrs, b$1.attrs)) return false;
	if (a.drawingKind === "image" && b$1.drawingKind === "image") return imageBlocksEqual(a, b$1);
	if ((a.drawingKind === "vectorShape" || a.drawingKind === "textboxShape") && (b$1.drawingKind === "vectorShape" || b$1.drawingKind === "textboxShape")) {
		const textboxContentEqual = a.drawingKind !== "textboxShape" || b$1.drawingKind !== "textboxShape" || jsonEqual(a.contentBlocks, b$1.contentBlocks);
		return drawingGeometryEqual(a.geometry, b$1.geometry) && a.shapeKind === b$1.shapeKind && a.fillColor === b$1.fillColor && a.strokeColor === b$1.strokeColor && a.strokeWidth === b$1.strokeWidth && a.textAlign === b$1.textAlign && a.textVerticalAlign === b$1.textVerticalAlign && jsonEqual(a.textInsets, b$1.textInsets) && jsonEqual(a.textContent, b$1.textContent) && jsonEqual(a.customGeometry, b$1.customGeometry) && jsonEqual(a.lineEnds, b$1.lineEnds) && jsonEqual(a.effectExtent, b$1.effectExtent) && textboxContentEqual;
	}
	if (a.drawingKind === "shapeGroup" && b$1.drawingKind === "shapeGroup") return drawingGeometryEqual(a.geometry, b$1.geometry) && shapeGroupTransformEqual(a.groupTransform, b$1.groupTransform) && shapeGroupSizeEqual(a.size, b$1.size) && shapeGroupChildrenEqual(a.shapes, b$1.shapes);
	if (a.drawingKind === "chart" && b$1.drawingKind === "chart") return drawingGeometryEqual(a.geometry, b$1.geometry) && a.chartRelId === b$1.chartRelId && jsonEqual(a.chartData, b$1.chartData);
	return true;
};
var boxSpacingEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	return a.top === b$1.top && a.right === b$1.right && a.bottom === b$1.bottom && a.left === b$1.left;
};
var imageAnchorEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	return a.isAnchored === b$1.isAnchored && a.hRelativeFrom === b$1.hRelativeFrom && a.vRelativeFrom === b$1.vRelativeFrom && a.alignH === b$1.alignH && a.alignV === b$1.alignV && a.offsetH === b$1.offsetH && a.offsetV === b$1.offsetV && a.behindDoc === b$1.behindDoc;
};
var imageWrapEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	return a.type === b$1.type && a.wrapText === b$1.wrapText && a.distTop === b$1.distTop && a.distBottom === b$1.distBottom && a.distLeft === b$1.distLeft && a.distRight === b$1.distRight && a.behindDoc === b$1.behindDoc && polygonEqual(a.polygon, b$1.polygon);
};
var polygonEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	if (a.length !== b$1.length) return false;
	for (let i = 0; i < a.length; i += 1) {
		const rowA = a[i];
		const rowB = b$1[i];
		if (!rowA || !rowB) return false;
		if (rowA.length !== rowB.length) return false;
		for (let j = 0; j < rowA.length; j += 1) if (rowA[j] !== rowB[j]) return false;
	}
	return true;
};
var drawingGeometryEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	return a.width === b$1.width && a.height === b$1.height && (a.rotation ?? 0) === (b$1.rotation ?? 0) && Boolean(a.flipH) === Boolean(b$1.flipH) && Boolean(a.flipV) === Boolean(b$1.flipV);
};
var shapeGroupTransformEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	return a.x === b$1.x && a.y === b$1.y && a.width === b$1.width && a.height === b$1.height && a.childX === b$1.childX && a.childY === b$1.childY && a.childWidth === b$1.childWidth && a.childHeight === b$1.childHeight && a.childOriginXEmu === b$1.childOriginXEmu && a.childOriginYEmu === b$1.childOriginYEmu;
};
var shapeGroupSizeEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	return a.width === b$1.width && a.height === b$1.height;
};
var shapeGroupChildrenEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	if (a.length !== b$1.length) return false;
	for (let i = 0; i < a.length; i += 1) {
		const childA = a[i];
		const childB = b$1[i];
		if (!childA || !childB) return false;
		if (childA.shapeType !== childB.shapeType) return false;
		if (!jsonEqual(childA.attrs, childB.attrs)) return false;
	}
	return true;
};
var shallowRecordEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (!a || !b$1) return !a && !b$1;
	const aKeys = Object.keys(a);
	const bKeys = Object.keys(b$1);
	if (aKeys.length !== bKeys.length) return false;
	for (const key of aKeys) {
		if (!Object.prototype.hasOwnProperty.call(b$1, key)) return false;
		if (a[key] !== b$1[key]) return false;
	}
	return true;
};
var jsonEqual = (a, b$1) => {
	if (a === b$1) return true;
	if (a == null || b$1 == null) return a == null && b$1 == null;
	try {
		return JSON.stringify(a) === JSON.stringify(b$1);
	} catch {
		return false;
	}
};
function computeHeaderFooterContentHash(blocks) {
	if (!blocks || blocks.length === 0) return "";
	const parts = [];
	for (const block of blocks) {
		parts.push(block.id);
		if (block.kind === "paragraph") for (const run of block.runs) {
			if (run.kind === "math") parts.push(`math:${run.textContent}`);
			else if (!("src" in run) && run.kind !== "lineBreak" && run.kind !== "break" && run.kind !== "fieldAnnotation") parts.push(run.text ?? "");
			if ("bold" in run && run.bold) parts.push("b");
			if ("italic" in run && run.italic) parts.push("i");
			if ("token" in run && run.token) parts.push(`token:${run.token}`);
			if ("pageNumberFieldFormat" in run && run.pageNumberFieldFormat) parts.push(`pnf:${JSON.stringify(run.pageNumberFieldFormat)}`);
		}
	}
	return parts.join("|");
}
function computeSectionMetadataHash(sections) {
	if (!sections || sections.length === 0) return "";
	const parts = [];
	for (const section of sections) {
		parts.push(`section:${section.sectionIndex}`);
		if (section.numbering) {
			const num = section.numbering;
			parts.push(`num:${num.format ?? "decimal"}:${num.start ?? 1}`);
		}
		if (section.headerRefs) {
			const refs = section.headerRefs;
			if (refs.default) parts.push(`hdr-def:${refs.default}`);
			if (refs.first) parts.push(`hdr-first:${refs.first}`);
			if (refs.even) parts.push(`hdr-even:${refs.even}`);
			if (refs.odd) parts.push(`hdr-odd:${refs.odd}`);
		}
		if (section.footerRefs) {
			const refs = section.footerRefs;
			if (refs.default) parts.push(`ftr-def:${refs.default}`);
			if (refs.first) parts.push(`ftr-first:${refs.first}`);
			if (refs.even) parts.push(`ftr-even:${refs.even}`);
			if (refs.odd) parts.push(`ftr-odd:${refs.odd}`);
		}
	}
	return parts.join("|");
}
function computeConstraintsHash(constraints) {
	const { width, height, pageWidth, pageHeight, margins, overflowBaseHeight } = constraints;
	const parts = [`w:${width}`, `h:${height}`];
	if (pageWidth !== void 0) parts.push(`pw:${pageWidth}`);
	if (pageHeight !== void 0) parts.push(`ph:${pageHeight}`);
	if (overflowBaseHeight !== void 0) parts.push(`obh:${overflowBaseHeight}`);
	if (margins) {
		parts.push(`ml:${margins.left}`, `mr:${margins.right}`);
		if (margins.top !== void 0) parts.push(`mt:${margins.top}`);
		if (margins.bottom !== void 0) parts.push(`mb:${margins.bottom}`);
		if (margins.header !== void 0) parts.push(`mh:${margins.header}`);
		if (margins.footer !== void 0) parts.push(`mf:${margins.footer}`);
	}
	return parts.join("|");
}
var HeaderFooterCacheState = class {
	constructor() {
		this.contentHashes = /* @__PURE__ */ new Map();
		this.constraintsHash = "";
		this.sectionMetadataHash = "";
	}
	hasContentChanged(variantKey, blocks) {
		const currentHash = computeHeaderFooterContentHash(blocks);
		const previousHash = this.contentHashes.get(variantKey);
		if (previousHash === void 0) {
			this.contentHashes.set(variantKey, currentHash);
			return false;
		}
		const changed = currentHash !== previousHash;
		if (changed) this.contentHashes.set(variantKey, currentHash);
		return changed;
	}
	hasConstraintsChanged(constraints) {
		const currentHash = computeConstraintsHash(constraints);
		if (this.constraintsHash === "") {
			this.constraintsHash = currentHash;
			return false;
		}
		const changed = currentHash !== this.constraintsHash;
		if (changed) this.constraintsHash = currentHash;
		return changed;
	}
	hasSectionMetadataChanged(sections) {
		const currentHash = computeSectionMetadataHash(sections);
		if (this.sectionMetadataHash === "") {
			this.sectionMetadataHash = currentHash;
			return false;
		}
		const changed = currentHash !== this.sectionMetadataHash;
		if (changed) this.sectionMetadataHash = currentHash;
		return changed;
	}
	reset() {
		this.contentHashes.clear();
		this.constraintsHash = "";
		this.sectionMetadataHash = "";
	}
};
function invalidateHeaderFooterCache(cache$2, cacheState, headerBlocks, footerBlocks, constraints, sections) {
	const invalidationReasons = [];
	const affectedBlockIds = [];
	if (constraints && cacheState.hasConstraintsChanged(constraints)) {
		invalidationReasons.push("constraints changed");
		if (headerBlocks) Object.values(headerBlocks).forEach((blocks) => {
			if (blocks) affectedBlockIds.push(...blocks.map((b$1) => b$1.id));
		});
		if (footerBlocks) Object.values(footerBlocks).forEach((blocks) => {
			if (blocks) affectedBlockIds.push(...blocks.map((b$1) => b$1.id));
		});
	}
	if (sections && cacheState.hasSectionMetadataChanged(sections)) {
		invalidationReasons.push("section metadata changed");
		if (headerBlocks) Object.values(headerBlocks).forEach((blocks) => {
			if (blocks) affectedBlockIds.push(...blocks.map((b$1) => b$1.id));
		});
		if (footerBlocks) Object.values(footerBlocks).forEach((blocks) => {
			if (blocks) affectedBlockIds.push(...blocks.map((b$1) => b$1.id));
		});
	}
	if (headerBlocks) for (const [variant, blocks] of Object.entries(headerBlocks)) {
		if (!blocks) continue;
		const variantKey = `header-${variant}`;
		if (cacheState.hasContentChanged(variantKey, blocks)) {
			invalidationReasons.push(`header ${variant} content changed`);
			affectedBlockIds.push(...blocks.map((b$1) => b$1.id));
		}
	}
	if (footerBlocks) for (const [variant, blocks] of Object.entries(footerBlocks)) {
		if (!blocks) continue;
		const variantKey = `footer-${variant}`;
		if (cacheState.hasContentChanged(variantKey, blocks)) {
			invalidationReasons.push(`footer ${variant} content changed`);
			affectedBlockIds.push(...blocks.map((b$1) => b$1.id));
		}
	}
	if (affectedBlockIds.length > 0) {
		const uniqueBlockIds = Array.from(new Set(affectedBlockIds));
		cache$2.invalidate(uniqueBlockIds);
		HeaderFooterCacheLogger.logInvalidation(invalidationReasons.join(", "), uniqueBlockIds);
	}
}
var DEFAULT_WINDOW_AHEAD = 3;
var DEFAULT_PREFERRED_DELTA_THRESHOLD_PX = 8;
var DEFAULT_MANDATORY_ONLY_TOLERANCE_PX = 2;
var DEFAULT_DEAD_RESERVE_BLOAT_THRESHOLD_PX = 128;
var DEFAULT_WHOLE_DOCUMENT_DEAD_RESERVE_BLOAT_THRESHOLD_PX = 128;
var FULL_ANCHOR_RENDER_SENTINEL = Number.MAX_SAFE_INTEGER;
var DEFAULT_TRIAL_TARGET_COUNT = 12;
const isMandatoryOnlyFootnotePage = (ledger, preferredDeltaThresholdPx = DEFAULT_PREFERRED_DELTA_THRESHOLD_PX, mandatoryOnlyTolerancePx = DEFAULT_MANDATORY_ONLY_TOLERANCE_PX) => {
	if (ledger.anchorIds.length === 0) return false;
	return Math.abs(ledger.actualBandHeightPx - ledger.mandatoryReservePx) <= mandatoryOnlyTolerancePx && ledger.preferredReservePx - ledger.mandatoryReservePx > preferredDeltaThresholdPx && ledger.lastAnchorRenderedLines <= 1;
};
const isSplitLastAnchorFootnotePage = (ledger, preferredDeltaThresholdPx = DEFAULT_PREFERRED_DELTA_THRESHOLD_PX) => {
	if (ledger.anchorIds.length === 0) return false;
	const lastAnchorId = ledger.anchorIds[ledger.anchorIds.length - 1];
	if (!ledger.continuationOut.some((entry) => entry.id === lastAnchorId)) return false;
	return ledger.preferredReservePx - ledger.mandatoryReservePx > preferredDeltaThresholdPx && ledger.actualBandHeightPx < ledger.preferredReservePx - preferredDeltaThresholdPx;
};
const getPreferredReserveCandidates = (ledgers, preferredDeltaThresholdPx = DEFAULT_PREFERRED_DELTA_THRESHOLD_PX, mandatoryOnlyTolerancePx = DEFAULT_MANDATORY_ONLY_TOLERANCE_PX) => {
	return ledgers.filter((ledger) => isMandatoryOnlyFootnotePage(ledger, preferredDeltaThresholdPx, mandatoryOnlyTolerancePx) || isSplitLastAnchorFootnotePage(ledger, preferredDeltaThresholdPx)).map((ledger) => ({
		pageIndex: ledger.pageIndex,
		anchorIds: ledger.anchorIds.slice(),
		mandatoryReservePx: ledger.mandatoryReservePx,
		preferredReservePx: ledger.preferredReservePx,
		reserveDeltaPx: ledger.preferredReservePx - ledger.mandatoryReservePx,
		actualBandHeightPx: ledger.actualBandHeightPx,
		lastAnchorRenderedLines: ledger.lastAnchorRenderedLines
	}));
};
const getPreferredReserveTrialTargets = (candidate, currentReservePx, preferredDeltaThresholdPx = DEFAULT_PREFERRED_DELTA_THRESHOLD_PX, maxTargets = DEFAULT_TRIAL_TARGET_COUNT) => {
	const current = Number.isFinite(currentReservePx) ? Math.max(0, currentReservePx) : 0;
	const floor$1 = Math.max(current, candidate.mandatoryReservePx);
	const ceiling = Math.max(floor$1, candidate.preferredReservePx);
	const delta = ceiling - floor$1;
	if (delta <= preferredDeltaThresholdPx) return [];
	const targets = /* @__PURE__ */ new Set();
	const addTarget = (value) => {
		if (!Number.isFinite(value)) return;
		const rounded = Math.ceil(Math.max(floor$1, Math.min(ceiling, value)));
		if (rounded - floor$1 > preferredDeltaThresholdPx) targets.add(rounded);
	};
	[
		1,
		.75,
		.5,
		.33,
		.25,
		.15
	].forEach((fraction) => addTarget(floor$1 + delta * fraction));
	[
		96,
		72,
		48,
		24,
		12
	].forEach((px) => addTarget(floor$1 + Math.min(delta, px)));
	return Array.from(targets).sort((a, b$1) => b$1 - a).slice(0, Math.max(1, maxTargets));
};
var getWindowBounds = (layout, candidatePageIndex, windowAhead) => ({
	windowStart: Math.max(0, candidatePageIndex),
	windowEnd: Math.min(layout.pages.length - 1, candidatePageIndex + Math.max(0, windowAhead))
});
var getDocumentBounds = (layout) => ({
	windowStart: 0,
	windowEnd: Math.max(0, layout.pages.length - 1)
});
var isInWindow = (ledger, windowStart, windowEnd) => ledger.pageIndex >= windowStart && ledger.pageIndex <= windowEnd;
var getLastAnchorId = (ledger) => {
	if (!ledger || ledger.anchorIds.length === 0) return void 0;
	return ledger.anchorIds[ledger.anchorIds.length - 1];
};
var collectLedgerDiagnostics = (ledgers, windowStart, windowEnd, preferredDeltaThresholdPx, mandatoryOnlyTolerancePx) => {
	const diagnostics = {
		mandatoryOnlyCount: 0,
		mandatoryOnlyAnchorIds: /* @__PURE__ */ new Set(),
		deadReserveSum: 0,
		clusterSplitCount: 0,
		clusterSplitAnchorIds: /* @__PURE__ */ new Set()
	};
	for (const ledger of ledgers) {
		if (!isInWindow(ledger, windowStart, windowEnd)) continue;
		diagnostics.deadReserveSum += Math.max(0, ledger.deadReservePx);
		if (isMandatoryOnlyFootnotePage(ledger, preferredDeltaThresholdPx, mandatoryOnlyTolerancePx)) {
			diagnostics.mandatoryOnlyCount += 1;
			const id = getLastAnchorId(ledger);
			if (id) diagnostics.mandatoryOnlyAnchorIds.add(id);
		}
		const anchorIds = new Set(ledger.anchorIds);
		let splitsCurrentAnchorCluster = false;
		for (const entry of ledger.continuationOut) {
			if (!anchorIds.has(entry.id)) continue;
			diagnostics.clusterSplitAnchorIds.add(entry.id);
			splitsCurrentAnchorCluster = true;
		}
		if (splitsCurrentAnchorCluster) diagnostics.clusterSplitCount += 1;
	}
	return diagnostics;
};
var hasNewId = (after, before) => {
	for (const id of after) if (!before.has(id)) return true;
	return false;
};
var getCandidateRenderedLines = (ledgers, candidateAnchorId) => {
	if (!candidateAnchorId) return void 0;
	const anchorLedger = ledgers.find((ledger) => ledger.anchorIds.includes(candidateAnchorId));
	if (!anchorLedger) return void 0;
	if (getLastAnchorId(anchorLedger) === candidateAnchorId) return anchorLedger.lastAnchorRenderedLines;
	return FULL_ANCHOR_RENDER_SENTINEL;
};
var candidateRenderedLinesImproved = (before, after) => typeof before.candidateRenderedLines === "number" && typeof after.candidateRenderedLines === "number" && after.candidateRenderedLines > before.candidateRenderedLines;
const summarizeFootnoteWindow = (layout, ledgers, candidatePageIndex, windowAhead = DEFAULT_WINDOW_AHEAD, preferredDeltaThresholdPx = DEFAULT_PREFERRED_DELTA_THRESHOLD_PX, mandatoryOnlyTolerancePx = DEFAULT_MANDATORY_ONLY_TOLERANCE_PX, candidateAnchorId) => {
	const { windowStart, windowEnd } = getWindowBounds(layout, candidatePageIndex, windowAhead);
	const diagnostics = collectLedgerDiagnostics(ledgers, windowStart, windowEnd, preferredDeltaThresholdPx, mandatoryOnlyTolerancePx);
	return {
		totalPages: layout.pages.length,
		mandatoryOnlyCount: diagnostics.mandatoryOnlyCount,
		deadReserveSum: diagnostics.deadReserveSum,
		clusterSplitCount: diagnostics.clusterSplitCount,
		candidateRenderedLines: getCandidateRenderedLines(ledgers, candidateAnchorId)
	};
};
const scoreFootnoteWindow = (input) => {
	const windowAhead = input.windowAhead ?? DEFAULT_WINDOW_AHEAD;
	const preferredDeltaThresholdPx = input.preferredDeltaThresholdPx ?? DEFAULT_PREFERRED_DELTA_THRESHOLD_PX;
	const mandatoryOnlyTolerancePx = input.mandatoryOnlyTolerancePx ?? DEFAULT_MANDATORY_ONLY_TOLERANCE_PX;
	const deadReserveBloatThresholdPx = input.deadReserveBloatThresholdPx ?? DEFAULT_DEAD_RESERVE_BLOAT_THRESHOLD_PX;
	const wholeDocumentDeadReserveBloatThresholdPx = input.wholeDocumentDeadReserveBloatThresholdPx ?? DEFAULT_WHOLE_DOCUMENT_DEAD_RESERVE_BLOAT_THRESHOLD_PX;
	const beforeCandidateLedger = input.beforeLedger.find((ledger) => ledger.pageIndex === input.candidatePageIndex);
	const candidateAnchorId = input.candidateAnchorId ?? getLastAnchorId(beforeCandidateLedger);
	const before = summarizeFootnoteWindow(input.beforeLayout, input.beforeLedger, input.candidatePageIndex, windowAhead, preferredDeltaThresholdPx, mandatoryOnlyTolerancePx, candidateAnchorId);
	const after = summarizeFootnoteWindow(input.afterLayout, input.afterLedger, input.candidatePageIndex, windowAhead, preferredDeltaThresholdPx, mandatoryOnlyTolerancePx, candidateAnchorId);
	const beforeBounds = getWindowBounds(input.beforeLayout, input.candidatePageIndex, windowAhead);
	const afterBounds = getWindowBounds(input.afterLayout, input.candidatePageIndex, windowAhead);
	const beforeWindowDiagnostics = collectLedgerDiagnostics(input.beforeLedger, beforeBounds.windowStart, beforeBounds.windowEnd, preferredDeltaThresholdPx, mandatoryOnlyTolerancePx);
	const afterWindowDiagnostics = collectLedgerDiagnostics(input.afterLedger, afterBounds.windowStart, afterBounds.windowEnd, preferredDeltaThresholdPx, mandatoryOnlyTolerancePx);
	const beforeDocumentBounds = getDocumentBounds(input.beforeLayout);
	const afterDocumentBounds = getDocumentBounds(input.afterLayout);
	const beforeDocumentDiagnostics = collectLedgerDiagnostics(input.beforeLedger, beforeDocumentBounds.windowStart, beforeDocumentBounds.windowEnd, preferredDeltaThresholdPx, mandatoryOnlyTolerancePx);
	const afterDocumentDiagnostics = collectLedgerDiagnostics(input.afterLedger, afterDocumentBounds.windowStart, afterDocumentBounds.windowEnd, preferredDeltaThresholdPx, mandatoryOnlyTolerancePx);
	const eliminatesSplitInWindow = beforeWindowDiagnostics.clusterSplitCount > afterWindowDiagnostics.clusterSplitCount;
	const eliminatesSplitInDoc = beforeDocumentDiagnostics.clusterSplitCount > afterDocumentDiagnostics.clusterSplitCount;
	if (after.totalPages > before.totalPages) {
		if (!(after.totalPages === before.totalPages + 1 && eliminatesSplitInDoc)) return {
			accept: false,
			reason: "page-count-grew",
			before,
			after
		};
	}
	if (after.clusterSplitCount > before.clusterSplitCount || hasNewId(afterWindowDiagnostics.clusterSplitAnchorIds, beforeWindowDiagnostics.clusterSplitAnchorIds)) return {
		accept: false,
		reason: "cluster-spill",
		before,
		after
	};
	if (afterDocumentDiagnostics.clusterSplitAnchorIds.size > beforeDocumentDiagnostics.clusterSplitAnchorIds.size || hasNewId(afterDocumentDiagnostics.clusterSplitAnchorIds, beforeDocumentDiagnostics.clusterSplitAnchorIds)) return {
		accept: false,
		reason: "cluster-spill",
		before,
		after
	};
	if (hasNewId(afterWindowDiagnostics.mandatoryOnlyAnchorIds, beforeWindowDiagnostics.mandatoryOnlyAnchorIds)) return {
		accept: false,
		reason: "new-mandatory-only",
		before,
		after
	};
	if (hasNewId(afterDocumentDiagnostics.mandatoryOnlyAnchorIds, beforeDocumentDiagnostics.mandatoryOnlyAnchorIds)) return {
		accept: false,
		reason: "new-mandatory-only",
		before,
		after
	};
	const windowDeadAllowance = eliminatesSplitInWindow ? deadReserveBloatThresholdPx * 2 : deadReserveBloatThresholdPx;
	const docDeadAllowance = eliminatesSplitInDoc ? wholeDocumentDeadReserveBloatThresholdPx * 2 : wholeDocumentDeadReserveBloatThresholdPx;
	if (after.deadReserveSum > before.deadReserveSum + windowDeadAllowance) return {
		accept: false,
		reason: "dead-reserve-bloat",
		before,
		after
	};
	if (afterDocumentDiagnostics.deadReserveSum > beforeDocumentDiagnostics.deadReserveSum + docDeadAllowance) return {
		accept: false,
		reason: "dead-reserve-bloat",
		before,
		after
	};
	if (!candidateRenderedLinesImproved(before, after)) return {
		accept: false,
		reason: "candidate-not-improved",
		before,
		after
	};
	return {
		accept: true,
		reason: "globally-safe",
		before,
		after
	};
};
init_dist();
const measureCache = new MeasureCache();
var headerMeasureCache = new HeaderFooterLayoutCache();
var headerFooterCacheState = new HeaderFooterCacheState();
var layoutDebugEnabled$1 = typeof process$1$1 !== "undefined" && typeof process$1$1.env !== "undefined" && Boolean(process$1$1.env.SD_DEBUG_LAYOUT);
var perfLog$1 = (...args$1) => {
	if (!layoutDebugEnabled$1) return;
	console.log(...args$1);
};
var isFootnotesLayoutInput = (value) => {
	if (!value || typeof value !== "object") return false;
	const v = value;
	if (!Array.isArray(v.refs)) return false;
	if (!(v.blocksById instanceof Map)) return false;
	return true;
};
var findPageIndexForPos = (layout, pos) => {
	if (!Number.isFinite(pos)) return null;
	const fallbackRanges = [];
	for (let pageIndex = 0; pageIndex < layout.pages.length; pageIndex++) {
		const page = layout.pages[pageIndex];
		let minStart = null;
		let maxEnd = null;
		for (const fragment of page.fragments) {
			const pmStart = fragment.pmStart;
			const pmEnd = fragment.pmEnd;
			if (pmStart == null || pmEnd == null) continue;
			if (minStart == null || pmStart < minStart) minStart = pmStart;
			if (maxEnd == null || pmEnd > maxEnd) maxEnd = pmEnd;
			if (pos >= pmStart && pos <= pmEnd) return pageIndex;
		}
		fallbackRanges[pageIndex] = minStart != null && maxEnd != null ? {
			pageIndex,
			minStart,
			maxEnd
		} : null;
	}
	let best = null;
	for (const entry of fallbackRanges) {
		if (!entry) continue;
		const distance = pos < entry.minStart ? entry.minStart - pos : pos > entry.maxEnd ? pos - entry.maxEnd : 0;
		if (!best || distance < best.distance) best = {
			pageIndex: entry.pageIndex,
			distance
		};
	}
	if (best) return best.pageIndex;
	if (layout.pages.length > 0) return layout.pages.length - 1;
	return null;
};
var footnoteColumnKey = (pageIndex, columnIndex) => `${pageIndex}:${columnIndex}`;
var COLUMN_EPSILON = .01;
var resolveMaxColumnWidth = (contentWidth, columns) => {
	if (!columns || columns.count <= 1) return contentWidth;
	return normalizeColumnsForFootnotes(columns, contentWidth).width;
};
var normalizeColumnsForFootnotes = (input, contentWidth) => {
	return normalizeColumnLayout(input, contentWidth, COLUMN_EPSILON);
};
var ooXmlSectionColumns = (columns) => cloneColumnLayout(columns);
var resolveSectionColumnsByIndex = (options, blocks) => {
	const result = /* @__PURE__ */ new Map();
	let activeColumns = cloneColumnLayout(options.columns);
	if (blocks && blocks.length > 0) for (const block of blocks) {
		if (block.kind !== "sectionBreak") continue;
		const sectionIndexRaw = block.attrs?.sectionIndex;
		const sectionIndex = typeof sectionIndexRaw === "number" && Number.isFinite(sectionIndexRaw) ? sectionIndexRaw : result.size;
		activeColumns = ooXmlSectionColumns(block.columns);
		result.set(sectionIndex, cloneColumnLayout(activeColumns));
	}
	if (result.size === 0) result.set(0, cloneColumnLayout(activeColumns));
	return result;
};
var resolvePageColumns = (layout, options, blocks) => {
	const sectionColumns = resolveSectionColumnsByIndex(options, blocks);
	const result = /* @__PURE__ */ new Map();
	for (let pageIndex = 0; pageIndex < layout.pages.length; pageIndex += 1) {
		const page = layout.pages[pageIndex];
		const pageSize = page.size ?? layout.pageSize ?? DEFAULT_PAGE_SIZE$1;
		const marginLeft = normalizeMargin(page.margins?.left, normalizeMargin(options.margins?.left, DEFAULT_MARGINS$1.left));
		const marginRight = normalizeMargin(page.margins?.right, normalizeMargin(options.margins?.right, DEFAULT_MARGINS$1.right));
		const contentWidth = pageSize.w - (marginLeft + marginRight);
		const sectionIndex = page.sectionIndex ?? 0;
		const normalized = normalizeColumnsForFootnotes(sectionColumns.get(sectionIndex) ?? options.columns ?? SINGLE_COLUMN_DEFAULT, contentWidth);
		result.set(pageIndex, {
			...normalized,
			left: marginLeft,
			contentWidth
		});
	}
	return result;
};
var findFragmentForPos = (page, pos) => {
	for (const fragment of page.fragments) {
		const pmStart = fragment.pmStart;
		const pmEnd = fragment.pmEnd;
		if (pmStart == null || pmEnd == null) continue;
		if (pos >= pmStart && pos <= pmEnd) return fragment;
	}
	return null;
};
var assignFootnotesToColumns = (layout, refs, pageColumns) => {
	const result = /* @__PURE__ */ new Map();
	const seenByColumn = /* @__PURE__ */ new Map();
	for (const ref$1 of refs) {
		const pageIndex = findPageIndexForPos(layout, ref$1.pos);
		if (pageIndex == null) continue;
		const columns = pageColumns.get(pageIndex);
		const page = layout.pages[pageIndex];
		let columnIndex = 0;
		if (columns && columns.count > 1 && page) {
			const fragment = findFragmentForPos(page, ref$1.pos);
			if (fragment?.kind === "table" && typeof fragment.columnIndex === "number") columnIndex = Math.max(0, Math.min(columns.count - 1, fragment.columnIndex));
			else if (fragment && typeof fragment.x === "number") {
				const geometry = getColumnGeometry(columns);
				columnIndex = Math.max(0, geometry.length - 1);
				for (const col of geometry) if (fragment.x < columns.left + col.x + col.width + col.gapAfter / 2) {
					columnIndex = col.index;
					break;
				}
			}
		}
		const key = footnoteColumnKey(pageIndex, columnIndex);
		let seen = seenByColumn.get(key);
		if (!seen) {
			seen = /* @__PURE__ */ new Set();
			seenByColumn.set(key, seen);
		}
		if (seen.has(ref$1.id)) continue;
		seen.add(ref$1.id);
		const pageMap = result.get(pageIndex) ?? /* @__PURE__ */ new Map();
		const list = pageMap.get(columnIndex) ?? [];
		list.push(ref$1.id);
		pageMap.set(columnIndex, list);
		result.set(pageIndex, pageMap);
	}
	return result;
};
var resolveFootnoteMeasurementWidth = (options, blocks) => {
	const pageSize = options.pageSize ?? DEFAULT_PAGE_SIZE$1;
	const margins = {
		right: normalizeMargin(options.margins?.right, DEFAULT_MARGINS$1.right),
		left: normalizeMargin(options.margins?.left, DEFAULT_MARGINS$1.left)
	};
	let width = pageSize.w - (margins.left + margins.right);
	let activeColumns = cloneColumnLayout(options.columns);
	let activePageSize = pageSize;
	let activeMargins = { ...margins };
	const resolveColumnWidth = () => {
		const contentWidth = activePageSize.w - (activeMargins.left + activeMargins.right);
		return normalizeColumnsForFootnotes(activeColumns, contentWidth).width;
	};
	width = resolveColumnWidth();
	if (blocks && blocks.length > 0) for (const block of blocks) {
		if (block.kind !== "sectionBreak") continue;
		activePageSize = block.pageSize ?? activePageSize;
		activeMargins = {
			right: normalizeMargin(block.margins?.right, activeMargins.right),
			left: normalizeMargin(block.margins?.left, activeMargins.left)
		};
		activeColumns = ooXmlSectionColumns(block.columns);
		const w = resolveColumnWidth();
		if (w > 0 && w < width) width = w;
	}
	if (!Number.isFinite(width) || width <= 0) return 0;
	return width;
};
var MIN_FOOTNOTE_BODY_HEIGHT = 1;
var DEFAULT_FOOTNOTE_SEPARATOR_SPACING_BEFORE = 12;
var MAX_FOOTNOTE_LAYOUT_PASSES = 4;
var computeMaxFootnoteReserve = (layoutForPages, pageIndex, baseReserve = 0) => {
	const page = layoutForPages.pages?.[pageIndex];
	if (!page) return 0;
	const pageSize = page.size ?? layoutForPages.pageSize ?? DEFAULT_PAGE_SIZE$1;
	const topMargin = normalizeMargin(page.margins?.top, DEFAULT_MARGINS$1.top);
	const bottomWithReserve = normalizeMargin(page.margins?.bottom, DEFAULT_MARGINS$1.bottom);
	const baseReserveSafe = Number.isFinite(baseReserve) ? Math.max(0, baseReserve) : 0;
	const bottomMargin = Math.max(0, bottomWithReserve - baseReserveSafe);
	const bodyMaxY = page.bodyMaxY;
	if (typeof bodyMaxY === "number" && Number.isFinite(bodyMaxY) && bodyMaxY > topMargin) return Math.max(0, pageSize.h - bottomMargin - bodyMaxY);
	const availableForBody = pageSize.h - topMargin - bottomMargin;
	if (!Number.isFinite(availableForBody)) return 0;
	return Math.max(0, availableForBody - MIN_FOOTNOTE_BODY_HEIGHT);
};
var sumLineHeights$1 = (lines, fromLine, toLine) => {
	if (!lines || fromLine >= toLine) return 0;
	let total = 0;
	for (let i = fromLine; i < toLine; i += 1) total += lines[i]?.lineHeight ?? 0;
	return total;
};
var getParagraphSpacingAfter = (block) => {
	const spacing = block.attrs?.spacing;
	const value = spacing?.after ?? spacing?.lineSpaceAfter;
	return typeof value === "number" && Number.isFinite(value) && value > 0 ? value : 0;
};
var resolveSeparatorSpacingBefore = (rangesByFootnoteId, measuresById, explicitValue, fallbackValue) => {
	if (typeof explicitValue === "number" && Number.isFinite(explicitValue)) return Math.max(0, explicitValue);
	for (const ranges of rangesByFootnoteId.values()) for (const range of ranges) {
		if (range.kind === "paragraph") {
			const measure = measuresById.get(range.blockId);
			if (measure?.kind !== "paragraph") continue;
			const lineHeight = measure.lines?.[range.fromLine]?.lineHeight ?? measure.lines?.[0]?.lineHeight;
			if (typeof lineHeight === "number" && Number.isFinite(lineHeight) && lineHeight > 0) return lineHeight;
		}
		if (range.kind === "list-item") {
			const measure = measuresById.get(range.blockId);
			if (measure?.kind !== "list") continue;
			const itemMeasure = measure.items.find((item) => item.itemId === range.itemId);
			const lineHeight = itemMeasure?.paragraph?.lines?.[range.fromLine]?.lineHeight ?? itemMeasure?.paragraph?.lines?.[0]?.lineHeight;
			if (typeof lineHeight === "number" && Number.isFinite(lineHeight) && lineHeight > 0) return lineHeight;
		}
	}
	return Math.max(0, fallbackValue);
};
var getRangeRenderHeight = (range) => {
	if (range.kind === "paragraph" || range.kind === "list-item") {
		const spacing = range.toLine >= range.totalLines ? range.spacingAfter : 0;
		return range.height + spacing;
	}
	return range.height;
};
var buildFootnoteRanges = (blocks, measuresById) => {
	const ranges = [];
	blocks.forEach((block) => {
		const measure = measuresById.get(block.id);
		if (!measure) return;
		if (block.kind === "paragraph") {
			if (measure.kind !== "paragraph") return;
			const lineCount = measure.lines?.length ?? 0;
			if (lineCount === 0) return;
			ranges.push({
				kind: "paragraph",
				blockId: block.id,
				fromLine: 0,
				toLine: lineCount,
				totalLines: lineCount,
				height: sumLineHeights$1(measure.lines, 0, lineCount),
				spacingAfter: getParagraphSpacingAfter(block)
			});
			return;
		}
		if (block.kind === "list") {
			if (measure.kind !== "list") return;
			block.items.forEach((item) => {
				const itemMeasure = measure.items.find((entry) => entry.itemId === item.id);
				if (!itemMeasure) return;
				const lineCount = itemMeasure.paragraph.lines?.length ?? 0;
				if (lineCount === 0) return;
				ranges.push({
					kind: "list-item",
					blockId: block.id,
					itemId: item.id,
					fromLine: 0,
					toLine: lineCount,
					totalLines: lineCount,
					height: sumLineHeights$1(itemMeasure.paragraph.lines, 0, lineCount),
					spacingAfter: getParagraphSpacingAfter(item.paragraph)
				});
			});
			return;
		}
		if (block.kind === "table" && measure.kind === "table") {
			const height = Math.max(0, measure.totalHeight ?? 0);
			if (height > 0) ranges.push({
				kind: "table",
				blockId: block.id,
				height
			});
			return;
		}
		if (block.kind === "image" && measure.kind === "image") {
			const height = Math.max(0, measure.height ?? 0);
			if (height > 0) ranges.push({
				kind: "image",
				blockId: block.id,
				height
			});
			return;
		}
		if (block.kind === "drawing" && measure.kind === "drawing") {
			const height = Math.max(0, measure.height ?? 0);
			if (height > 0) ranges.push({
				kind: "drawing",
				blockId: block.id,
				height
			});
		}
	});
	return ranges;
};
var splitRangeAtHeight = (range, availableHeight, measuresById) => {
	if (availableHeight <= 0) return {
		fitted: null,
		remaining: range
	};
	if (range.kind !== "paragraph") return getRangeRenderHeight(range) <= availableHeight ? {
		fitted: range,
		remaining: null
	} : {
		fitted: null,
		remaining: range
	};
	const measure = measuresById.get(range.blockId);
	if (!measure || measure.kind !== "paragraph" || !measure.lines) return getRangeRenderHeight(range) <= availableHeight ? {
		fitted: range,
		remaining: null
	} : {
		fitted: null,
		remaining: range
	};
	let accumulatedHeight = 0;
	let splitLine = range.fromLine;
	for (let i = range.fromLine; i < range.toLine; i += 1) {
		const lineHeight = measure.lines[i]?.lineHeight ?? 0;
		if (accumulatedHeight + lineHeight > availableHeight) break;
		accumulatedHeight += lineHeight;
		splitLine = i + 1;
	}
	if (splitLine === range.fromLine) return {
		fitted: null,
		remaining: range
	};
	const fitted = {
		...range,
		toLine: splitLine,
		height: sumLineHeights$1(measure.lines, range.fromLine, splitLine)
	};
	if (splitLine >= range.toLine) {
		if (fitted.height <= availableHeight) return {
			fitted,
			remaining: null
		};
		return {
			fitted: null,
			remaining: range
		};
	}
	return {
		fitted,
		remaining: {
			...range,
			fromLine: splitLine,
			height: sumLineHeights$1(measure.lines, splitLine, range.toLine)
		}
	};
};
var forceFitFirstRange = (range, measuresById) => {
	if (range.kind !== "paragraph") return {
		fitted: range,
		remaining: null
	};
	const measure = measuresById.get(range.blockId);
	if (!measure || measure.kind !== "paragraph" || !measure.lines?.length) return {
		fitted: range,
		remaining: null
	};
	const nextLine = Math.min(range.fromLine + 1, range.toLine);
	const fitted = {
		...range,
		toLine: nextLine,
		height: sumLineHeights$1(measure.lines, range.fromLine, nextLine)
	};
	if (nextLine >= range.toLine) return {
		fitted,
		remaining: null
	};
	return {
		fitted,
		remaining: {
			...range,
			fromLine: nextLine,
			height: sumLineHeights$1(measure.lines, nextLine, range.toLine)
		}
	};
};
var fitFootnoteContent = (id, inputRanges, availableHeight, pageIndex, columnIndex, isContinuation, measuresById, forceFirstRange) => {
	const fittedRanges = [];
	let remainingRanges = [];
	let usedHeight = 0;
	const maxHeight = Math.max(0, availableHeight);
	for (let index = 0; index < inputRanges.length; index += 1) {
		const range = inputRanges[index];
		const remainingSpace = maxHeight - usedHeight;
		const rangeHeight = getRangeRenderHeight(range);
		if (rangeHeight <= remainingSpace) {
			fittedRanges.push(range);
			usedHeight += rangeHeight;
			continue;
		}
		if (range.kind === "paragraph") {
			const split = splitRangeAtHeight(range, remainingSpace, measuresById);
			if (split.fitted) {
				const fittedBodyHeight = split.fitted.height;
				const fittedFullHeight = getRangeRenderHeight(split.fitted);
				const charged = !split.remaining ? fittedBodyHeight : fittedFullHeight;
				if (charged <= remainingSpace) {
					fittedRanges.push(split.fitted);
					usedHeight += charged;
				}
			}
			if (split.remaining) remainingRanges = [split.remaining, ...inputRanges.slice(index + 1)];
			else remainingRanges = inputRanges.slice(index + 1);
			break;
		}
		remainingRanges = [range, ...inputRanges.slice(index + 1)];
		break;
	}
	if (fittedRanges.length === 0 && forceFirstRange && inputRanges.length > 0) {
		const forced = forceFitFirstRange(inputRanges[0], measuresById);
		if (forced.fitted) {
			fittedRanges.push(forced.fitted);
			usedHeight = getRangeRenderHeight(forced.fitted);
			remainingRanges = [];
			if (forced.remaining) remainingRanges.push(forced.remaining);
			remainingRanges.push(...inputRanges.slice(1));
		}
	}
	return {
		slice: {
			id,
			pageIndex,
			columnIndex,
			isContinuation,
			ranges: fittedRanges,
			totalHeight: usedHeight
		},
		remainingRanges
	};
};
async function incrementalLayout(previousBlocks, _previousLayout, nextBlocks, options, measureBlock$1, headerFooter, previousMeasures, fontRuntime) {
	const fontSignature = fontRuntime?.fontContext?.fontSignature ?? "";
	const previousFontSignature = fontRuntime?.previousFontSignature ?? "";
	const isSemanticFlow = options.flowMode === "semantic";
	if (isSemanticFlow) {
		headerFooter = void 0;
		nextBlocks = rewriteSectionBreaksForSemanticFlow(nextBlocks, options);
	}
	const dirty = computeDirtyRegions(previousBlocks, nextBlocks);
	if (dirty.deletedBlockIds.length > 0) measureCache.invalidate(dirty.deletedBlockIds);
	const perSectionConstraints = computePerSectionConstraints(options, nextBlocks);
	const { measurementWidth, measurementHeight } = resolveMeasurementConstraints(options, nextBlocks);
	if (measurementWidth <= 0 || measurementHeight <= 0) throw new Error("incrementalLayout: invalid measurement constraints resolved from options");
	const hasPreviousMeasures = Array.isArray(previousMeasures) && previousMeasures.length === previousBlocks.length;
	const previousConstraints = hasPreviousMeasures && !isSemanticFlow ? resolveMeasurementConstraints(options, previousBlocks) : null;
	const canReusePreviousMeasures = hasPreviousMeasures && fontSignature === previousFontSignature && previousConstraints?.measurementWidth === measurementWidth && previousConstraints?.measurementHeight === measurementHeight;
	const previousPerSectionConstraints = canReusePreviousMeasures ? computePerSectionConstraints(options, previousBlocks) : null;
	const previousMeasuresById = canReusePreviousMeasures ? new Map(previousBlocks.map((block, index) => [block.id, previousMeasures[index]])) : null;
	const previousConstraintsById = canReusePreviousMeasures ? new Map(previousBlocks.map((block, index) => [block.id, previousPerSectionConstraints[index]])) : null;
	const measureStart = performance.now();
	const measures = [];
	let cacheHits = 0;
	let cacheMisses = 0;
	let reusedMeasures = 0;
	let cacheLookupTime = 0;
	let actualMeasureTime = 0;
	for (let blockIndex = 0; blockIndex < nextBlocks.length; blockIndex++) {
		const block = nextBlocks[blockIndex];
		if (block.kind === "sectionBreak") {
			measures.push({ kind: "sectionBreak" });
			continue;
		}
		const sectionConstraints = perSectionConstraints[blockIndex];
		const blockMeasureWidth = sectionConstraints.maxWidth;
		const blockMeasureHeight = sectionConstraints.maxHeight;
		if (canReusePreviousMeasures && dirty.stableBlockIds.has(block.id)) {
			const previousMeasure = previousMeasuresById?.get(block.id);
			const previousBlockConstraints = previousConstraintsById?.get(block.id);
			if (previousMeasure && previousBlockConstraints?.maxWidth === blockMeasureWidth && previousBlockConstraints?.maxHeight === blockMeasureHeight) {
				measures.push(previousMeasure);
				reusedMeasures++;
				continue;
			}
		}
		const lookupStart = performance.now();
		const cached = measureCache.get(block, blockMeasureWidth, blockMeasureHeight, fontSignature);
		cacheLookupTime += performance.now() - lookupStart;
		if (cached) {
			measures.push(cached);
			cacheHits++;
			continue;
		}
		const measureBlockStart = performance.now();
		const measurement = await measureBlock$1(block, sectionConstraints);
		actualMeasureTime += performance.now() - measureBlockStart;
		measureCache.set(block, blockMeasureWidth, blockMeasureHeight, measurement, fontSignature);
		measures.push(measurement);
		cacheMisses++;
	}
	perfLog$1(`[Perf] 4.1 Measure all blocks: ${(performance.now() - measureStart).toFixed(2)}ms (${cacheMisses} measured, ${cacheHits} cached, ${reusedMeasures} reused)`);
	let headerContentHeights;
	let headerContentHeightsByRId;
	let headerContentHeightsBySectionRef;
	const hasHeaderBlocks = headerFooter?.headerBlocks && Object.keys(headerFooter.headerBlocks).length > 0;
	const hasHeaderBlocksByRId = headerFooter?.headerBlocksByRId && headerFooter.headerBlocksByRId.size > 0;
	const sectionMetadata = options.sectionMetadata ?? [];
	const measureHeightsByReference = async (kind, blocksByRId, constraints, measureFn, pageResolver) => {
		if (!blocksByRId || blocksByRId.size === 0) return {};
		const heightsByRId = /* @__PURE__ */ new Map();
		const heightsBySectionRef = /* @__PURE__ */ new Map();
		const sectionAwareGroups = buildSectionAwareHeaderFooterMeasurementGroups(kind, blocksByRId, sectionMetadata, constraints);
		if (sectionAwareGroups.length > 0) {
			for (const group of sectionAwareGroups) {
				const blocks = blocksByRId.get(group.rId);
				if (!blocks || blocks.length === 0) continue;
				const layout$1 = (await layoutHeaderFooterWithCache({ default: blocks }, group.sectionConstraints, measureFn, headerMeasureCache, 1, pageResolver, kind, void 0, (block, maxWidth, firstLineIndent) => remeasureParagraph(block, maxWidth, firstLineIndent))).default?.layout;
				if (!layout$1 || !(layout$1.height > 0)) continue;
				const nextHeight = Math.max(0, layout$1.height);
				if (nextHeight > (heightsByRId.get(group.rId) ?? 0)) heightsByRId.set(group.rId, nextHeight);
				for (const sectionIndex of group.sectionIndices) heightsBySectionRef.set(buildSectionAwareHeaderFooterLayoutKey(group.rId, sectionIndex), nextHeight);
			}
			return {
				heightsByRId: heightsByRId.size > 0 ? heightsByRId : void 0,
				heightsBySectionRef: heightsBySectionRef.size > 0 ? heightsBySectionRef : void 0
			};
		}
		for (const [rId, blocks] of blocksByRId) {
			if (!blocks || blocks.length === 0) continue;
			const layout$1 = (await layoutHeaderFooterWithCache({ default: blocks }, constraints, measureFn, headerMeasureCache, 1, pageResolver, kind, void 0, (block, maxWidth, firstLineIndent) => remeasureParagraph(block, maxWidth, firstLineIndent))).default?.layout;
			if (layout$1 && layout$1.height > 0) heightsByRId.set(rId, layout$1.height);
		}
		return { heightsByRId: heightsByRId.size > 0 ? heightsByRId : void 0 };
	};
	if (headerFooter?.constraints && (hasHeaderBlocks || hasHeaderBlocksByRId)) {
		const hfPreStart = performance.now();
		const measureFn = headerFooter.measure ?? measureBlock$1;
		invalidateHeaderFooterCache(headerMeasureCache, headerFooterCacheState, headerFooter.headerBlocks, headerFooter.footerBlocks, headerFooter.constraints, options.sectionMetadata);
		const HEADER_PRELAYOUT_PLACEHOLDER_PAGE_COUNT = 1;
		const prelayoutPageResolver = buildConservativePrelayoutPageResolver(nextBlocks, sectionMetadata);
		const isValidHeaderType = (key) => {
			return [
				"default",
				"first",
				"even",
				"odd"
			].includes(key);
		};
		headerContentHeights = {};
		if (hasHeaderBlocks && headerFooter.headerBlocks) {
			const preHeaderLayouts = await layoutHeaderFooterWithCache(headerFooter.headerBlocks, headerFooter.constraints, measureFn, headerMeasureCache, HEADER_PRELAYOUT_PLACEHOLDER_PAGE_COUNT, prelayoutPageResolver, "header", fontSignature, (block, maxWidth, firstLineIndent) => remeasureParagraph(block, maxWidth, firstLineIndent));
			for (const [type, value] of Object.entries(preHeaderLayouts)) {
				if (!isValidHeaderType(type)) continue;
				if (value?.layout && typeof value.layout.height === "number") {
					const height = value.layout.height;
					if (Number.isFinite(height) && height >= 0) headerContentHeights[type] = height;
				}
			}
		}
		if (hasHeaderBlocksByRId && headerFooter.headerBlocksByRId) {
			const measuredHeights = await measureHeightsByReference("header", headerFooter.headerBlocksByRId, headerFooter.constraints, measureFn, prelayoutPageResolver);
			headerContentHeightsByRId = measuredHeights.heightsByRId;
			headerContentHeightsBySectionRef = measuredHeights.heightsBySectionRef;
		}
		perfLog$1(`[Perf] 4.1.5 Pre-layout headers for height: ${(performance.now() - hfPreStart).toFixed(2)}ms`);
	}
	let footerContentHeights;
	let footerContentHeightsByRId;
	let footerContentHeightsBySectionRef;
	const hasFooterBlocks = headerFooter?.footerBlocks && Object.keys(headerFooter.footerBlocks).length > 0;
	const hasFooterBlocksByRId = headerFooter?.footerBlocksByRId && headerFooter.footerBlocksByRId.size > 0;
	if (headerFooter?.constraints && (hasFooterBlocks || hasFooterBlocksByRId)) {
		const footerPreStart = performance.now();
		const measureFn = headerFooter.measure ?? measureBlock$1;
		if (!hasHeaderBlocks && !hasHeaderBlocksByRId) invalidateHeaderFooterCache(headerMeasureCache, headerFooterCacheState, headerFooter.headerBlocks, headerFooter.footerBlocks, headerFooter.constraints, options.sectionMetadata);
		const FOOTER_PRELAYOUT_PLACEHOLDER_PAGE_COUNT = 1;
		const prelayoutPageResolver = buildConservativePrelayoutPageResolver(nextBlocks, sectionMetadata);
		const isValidFooterType = (key) => {
			return [
				"default",
				"first",
				"even",
				"odd"
			].includes(key);
		};
		footerContentHeights = {};
		try {
			if (hasFooterBlocks && headerFooter.footerBlocks) {
				const preFooterLayouts = await layoutHeaderFooterWithCache(headerFooter.footerBlocks, headerFooter.constraints, measureFn, headerMeasureCache, FOOTER_PRELAYOUT_PLACEHOLDER_PAGE_COUNT, prelayoutPageResolver, "footer", fontSignature, (block, maxWidth, firstLineIndent) => remeasureParagraph(block, maxWidth, firstLineIndent));
				for (const [type, value] of Object.entries(preFooterLayouts)) {
					if (!isValidFooterType(type)) continue;
					if (value?.layout && typeof value.layout.height === "number") {
						const height = value.layout.height;
						if (Number.isFinite(height) && height >= 0) footerContentHeights[type] = height;
					}
				}
			}
			if (hasFooterBlocksByRId && headerFooter.footerBlocksByRId) {
				const measuredHeights = await measureHeightsByReference("footer", headerFooter.footerBlocksByRId, headerFooter.constraints, measureFn, prelayoutPageResolver);
				footerContentHeightsByRId = measuredHeights.heightsByRId;
				footerContentHeightsBySectionRef = measuredHeights.heightsBySectionRef;
			}
		} catch (error) {
			console.error("[Layout] Footer pre-layout failed:", error);
			footerContentHeights = void 0;
		}
		perfLog$1(`[Perf] 4.1.6 Pre-layout footers for height: ${(performance.now() - footerPreStart).toFixed(2)}ms`);
	}
	const layoutStart = performance.now();
	let layout = layoutDocument(nextBlocks, measures, {
		...options,
		headerContentHeights,
		footerContentHeights,
		headerContentHeightsBySectionRef,
		headerContentHeightsByRId,
		footerContentHeightsBySectionRef,
		footerContentHeightsByRId,
		remeasureParagraph: (block, maxWidth, firstLineIndent) => remeasureParagraph(block, maxWidth, firstLineIndent)
	});
	perfLog$1(`[Perf] 4.2 Layout document (pagination): ${(performance.now() - layoutStart).toFixed(2)}ms`);
	const maxIterations = 3;
	let currentBlocks = nextBlocks;
	let currentMeasures = measures;
	let iteration = 0;
	const chapterBlockById = buildBlockById(currentBlocks);
	const chapterContextCache = {};
	const pageTokenStart = performance.now();
	let totalAffectedBlocks = 0;
	let totalRemeasureTime = 0;
	let totalRelayoutTime = 0;
	let converged = true;
	if (!isSemanticFlow && FeatureFlags.BODY_PAGE_TOKENS) {
		while (iteration < maxIterations) {
			const sections$1 = options.sectionMetadata ?? [];
			const numberingCtx$1 = buildNumberingContext(layout, sections$1, chapterBlockById, chapterContextCache);
			PageTokenLogger.logIterationStart(iteration, layout.pages.length);
			const tokenResult = resolvePageNumberTokens(layout, currentBlocks, currentMeasures, numberingCtx$1);
			if (tokenResult.affectedBlockIds.size === 0) {
				perfLog$1(`[Perf] 4.3 Page token resolution converged after ${iteration} iterations`);
				break;
			}
			perfLog$1(`[Perf] 4.3.${iteration + 1} Page tokens resolved: ${tokenResult.affectedBlockIds.size} blocks affected`);
			const blockSamples = Array.from(tokenResult.affectedBlockIds).slice(0, 5);
			PageTokenLogger.logAffectedBlocks(iteration, tokenResult.affectedBlockIds, blockSamples);
			totalAffectedBlocks += tokenResult.affectedBlockIds.size;
			currentBlocks = currentBlocks.map((block) => tokenResult.updatedBlocks.get(block.id) ?? block);
			measureCache.invalidate(Array.from(tokenResult.affectedBlockIds));
			const remeasureStart = performance.now();
			const currentPerSectionConstraints = computePerSectionConstraints(options, currentBlocks);
			currentMeasures = await remeasureAffectedBlocks(currentBlocks, currentMeasures, tokenResult.affectedBlockIds, currentPerSectionConstraints, measureBlock$1, fontSignature, measureCache);
			const remeasureTime = performance.now() - remeasureStart;
			totalRemeasureTime += remeasureTime;
			perfLog$1(`[Perf] 4.3.${iteration + 1}.1 Re-measure: ${remeasureTime.toFixed(2)}ms`);
			PageTokenLogger.logRemeasure(tokenResult.affectedBlockIds.size, remeasureTime);
			const relayoutStart = performance.now();
			layout = layoutDocument(currentBlocks, currentMeasures, {
				...options,
				headerContentHeights,
				footerContentHeights,
				headerContentHeightsBySectionRef,
				headerContentHeightsByRId,
				footerContentHeightsBySectionRef,
				footerContentHeightsByRId,
				remeasureParagraph: (block, maxWidth, firstLineIndent) => remeasureParagraph(block, maxWidth, firstLineIndent)
			});
			const relayoutTime = performance.now() - relayoutStart;
			totalRelayoutTime += relayoutTime;
			perfLog$1(`[Perf] 4.3.${iteration + 1}.2 Re-layout: ${relayoutTime.toFixed(2)}ms`);
			iteration++;
		}
		if (iteration >= maxIterations) {
			converged = false;
			console.warn(`[incrementalLayout] Page token resolution did not converge after ${maxIterations} iterations - stopping`);
		}
	}
	hydrateTableTextboxMeasures(currentBlocks, (block, maxWidth) => remeasureParagraph(block, maxWidth));
	const totalTokenTime = performance.now() - pageTokenStart;
	if (iteration > 0) {
		perfLog$1(`[Perf] 4.3 Total page token resolution time: ${totalTokenTime.toFixed(2)}ms`);
		PageTokenLogger.logConvergence(iteration, converged, totalTokenTime);
		globalMetrics.recordPageTokenMetrics({
			totalTimeMs: totalTokenTime,
			iterations: iteration,
			affectedBlocks: totalAffectedBlocks,
			remeasureTimeMs: totalRemeasureTime,
			relayoutTimeMs: totalRelayoutTime,
			converged
		});
	}
	let extraBlocks;
	let extraMeasures;
	const footnotesInput = isFootnotesLayoutInput(options.footnotes) ? options.footnotes : null;
	if (!isSemanticFlow && footnotesInput && footnotesInput.refs.length > 0 && footnotesInput.blocksById.size > 0) {
		const gap = typeof footnotesInput.gap === "number" && Number.isFinite(footnotesInput.gap) ? footnotesInput.gap : 2;
		const topPadding = typeof footnotesInput.topPadding === "number" && Number.isFinite(footnotesInput.topPadding) ? footnotesInput.topPadding : 6;
		const dividerHeight = typeof footnotesInput.dividerHeight === "number" && Number.isFinite(footnotesInput.dividerHeight) ? footnotesInput.dividerHeight : 6;
		const safeGap = Math.max(0, gap);
		const safeTopPadding = Math.max(0, topPadding);
		const safeDividerHeight = Math.max(0, dividerHeight);
		const continuationDividerHeight = safeDividerHeight;
		const SEPARATOR_DEFAULT_WIDTH_FACTOR = .5;
		const footnoteWidth = resolveFootnoteMeasurementWidth(options, currentBlocks);
		if (footnoteWidth > 0) {
			const footnoteConstraints = {
				maxWidth: footnoteWidth,
				maxHeight: measurementHeight
			};
			const collectFootnoteIdsByColumn = (idsByColumn$1) => {
				const ids = /* @__PURE__ */ new Set();
				idsByColumn$1.forEach((columns) => {
					columns.forEach((list) => {
						list.forEach((id) => ids.add(id));
					});
				});
				return ids;
			};
			const measureFootnoteBlocks = async (ids) => {
				const needed = /* @__PURE__ */ new Map();
				ids.forEach((id) => {
					(footnotesInput.blocksById.get(id) ?? []).forEach((block) => {
						if (block?.id && !needed.has(block.id)) needed.set(block.id, block);
					});
				});
				const blocks = Array.from(needed.values());
				const measuresById$1 = /* @__PURE__ */ new Map();
				await Promise.all(blocks.map(async (block) => {
					const cached = measureCache.get(block, footnoteConstraints.maxWidth, footnoteConstraints.maxHeight, fontSignature);
					if (cached) {
						measuresById$1.set(block.id, cached);
						return;
					}
					const measurement = await measureBlock$1(block, footnoteConstraints);
					measureCache.set(block, footnoteConstraints.maxWidth, footnoteConstraints.maxHeight, measurement, fontSignature);
					measuresById$1.set(block.id, measurement);
				}));
				return {
					blocks,
					measuresById: measuresById$1
				};
			};
			const computeFootnoteLayoutPlan = (layoutForPages, idsByColumn$1, measuresById$1, baseReserves = [], pageColumns$1) => {
				const pageCount = layoutForPages.pages.length;
				const slicesByPage = /* @__PURE__ */ new Map();
				const reserves$1 = new Array(pageCount).fill(0);
				const hasContinuationByColumn = /* @__PURE__ */ new Map();
				const rangesByFootnoteId = /* @__PURE__ */ new Map();
				const cappedPages = /* @__PURE__ */ new Set();
				const ledgersByPage = /* @__PURE__ */ new Map();
				collectFootnoteIdsByColumn(idsByColumn$1).forEach((id) => {
					const blocks = footnotesInput.blocksById.get(id) ?? [];
					rangesByFootnoteId.set(id, buildFootnoteRanges(blocks, measuresById$1));
				});
				const separatorSpacingBefore = resolveSeparatorSpacingBefore(rangesByFootnoteId, measuresById$1, footnotesInput.separatorSpacingBefore, DEFAULT_FOOTNOTE_SEPARATOR_SPACING_BEFORE);
				const safeSeparatorSpacingBefore = Math.max(0, separatorSpacingBefore);
				let pendingByColumn = /* @__PURE__ */ new Map();
				for (let pageIndex = 0; pageIndex < pageCount; pageIndex += 1) {
					const baseReserve = Number.isFinite(baseReserves?.[pageIndex]) ? Math.max(0, baseReserves[pageIndex]) : 0;
					const maxReserve = computeMaxFootnoteReserve(layoutForPages, pageIndex, baseReserve);
					const columns = pageColumns$1.get(pageIndex);
					const columnCount = Math.max(1, Math.floor(columns?.count ?? 1));
					const placementCeiling = maxReserve;
					const fullHeightOf = (id) => {
						const ranges = rangesByFootnoteId.get(id) ?? [];
						let total = 0;
						ranges.forEach((range) => {
							const spacingAfter = "spacingAfter" in range ? range.spacingAfter ?? 0 : 0;
							total += range.height + spacingAfter;
						});
						return total;
					};
					const firstLineOf = (id) => {
						const measured = firstLineHeightById.get(id);
						if (typeof measured === "number" && Number.isFinite(measured) && measured > 0) return measured;
						const ranges = rangesByFootnoteId.get(id) ?? [];
						return ranges.length > 0 ? ranges[0].height : 0;
					};
					const pendingForPage = /* @__PURE__ */ new Map();
					pendingByColumn.forEach((entries, columnIndex) => {
						const targetIndex = columnIndex < columnCount ? columnIndex : Math.max(0, columnCount - 1);
						const list = pendingForPage.get(targetIndex) ?? [];
						list.push(...entries);
						pendingForPage.set(targetIndex, list);
					});
					const continuationInForPage = [];
					pendingForPage.forEach((entries) => {
						entries.forEach((entry) => {
							let total = 0;
							entry.ranges.forEach((range) => {
								const spacingAfter = "spacingAfter" in range ? range.spacingAfter ?? 0 : 0;
								total += range.height + spacingAfter;
							});
							continuationInForPage.push({
								id: entry.id,
								remainingRangeCount: entry.ranges.length,
								remainingHeightPx: total
							});
						});
					});
					pendingByColumn = /* @__PURE__ */ new Map();
					const pageSlices = [];
					let pageReserve = 0;
					for (let columnIndex = 0; columnIndex < columnCount; columnIndex += 1) {
						let usedHeight = 0;
						const columnSlices = [];
						const nextPending = [];
						const columnKey = footnoteColumnKey(pageIndex, columnIndex);
						const placeFootnote = (id, ranges, isContinuation, isLastOnPage) => {
							if (!ranges || ranges.length === 0) return {
								placed: false,
								remaining: []
							};
							const isFirstSlice = columnSlices.length === 0;
							const overhead = isFirstSlice ? (isFirstSlice ? safeSeparatorSpacingBefore : 0) + (isFirstSlice ? isContinuation ? continuationDividerHeight : safeDividerHeight : 0) + safeTopPadding : 0;
							const gapBefore = !isFirstSlice ? safeGap : 0;
							const { slice, remainingRanges } = fitFootnoteContent(id, ranges, Math.max(0, placementCeiling - usedHeight - overhead - gapBefore), pageIndex, columnIndex, isContinuation, measuresById$1, (isLastOnPage || isContinuation) && placementCeiling > 0);
							if (slice.ranges.length === 0) return {
								placed: false,
								remaining: ranges
							};
							if (!isLastOnPage && !isContinuation && remainingRanges.length > 0) return {
								placed: false,
								remaining: ranges
							};
							if (isFirstSlice) {
								usedHeight += overhead;
								if (isContinuation) hasContinuationByColumn.set(columnKey, true);
							}
							if (gapBefore > 0) usedHeight += gapBefore;
							usedHeight += slice.totalHeight;
							columnSlices.push(slice);
							return {
								placed: true,
								remaining: remainingRanges
							};
						};
						const ids = idsByColumn$1.get(pageIndex)?.get(columnIndex) ?? [];
						const lastIdx = ids.length - 1;
						let clusterReserve = 0;
						for (let i = 0; i < ids.length; i += 1) {
							clusterReserve += i === lastIdx ? firstLineOf(ids[i]) : fullHeightOf(ids[i]);
							if (i > 0) clusterReserve += safeGap;
						}
						usedHeight += clusterReserve;
						const pending = pendingForPage.get(columnIndex) ?? [];
						for (let pendingIdx = 0; pendingIdx < pending.length; pendingIdx += 1) {
							const entry = pending[pendingIdx];
							if (!entry.ranges || entry.ranges.length === 0) continue;
							const result = placeFootnote(entry.id, entry.ranges, true, false);
							if (!result.placed) {
								for (let deferIdx = pendingIdx; deferIdx < pending.length; deferIdx += 1) nextPending.push(pending[deferIdx]);
								break;
							}
							if (result.remaining.length > 0) nextPending.push({
								id: entry.id,
								ranges: result.remaining
							});
						}
						usedHeight -= clusterReserve;
						for (let idIndex = 0; idIndex < ids.length; idIndex += 1) {
							const id = ids[idIndex];
							const ranges = rangesByFootnoteId.get(id) ?? [];
							if (ranges.length === 0) continue;
							const result = placeFootnote(id, ranges, false, idIndex === lastIdx);
							if (!result.placed) {
								nextPending.push({
									id,
									ranges
								});
								for (let remainingIndex = idIndex + 1; remainingIndex < ids.length; remainingIndex += 1) {
									const remainingId = ids[remainingIndex];
									const remainingRanges = rangesByFootnoteId.get(remainingId) ?? [];
									nextPending.push({
										id: remainingId,
										ranges: remainingRanges
									});
								}
								break;
							}
							if (result.remaining.length > 0) nextPending.push({
								id,
								ranges: result.remaining
							});
						}
						if (columnSlices.length > 0) {
							const rawReserve = Math.max(0, Math.ceil(usedHeight));
							const cappedReserve = Math.min(rawReserve, maxReserve);
							if (cappedReserve < rawReserve) cappedPages.add(pageIndex);
							pageReserve = Math.max(pageReserve, cappedReserve);
							pageSlices.push(...columnSlices);
						}
						if (nextPending.length > 0) pendingByColumn.set(columnIndex, nextPending);
					}
					if (pageSlices.length > 0) slicesByPage.set(pageIndex, pageSlices);
					reserves$1[pageIndex] = Math.max(reserves$1[pageIndex] ?? 0, pageReserve);
					{
						const idsOnPage = (() => {
							const out = [];
							for (let cIdx = 0; cIdx < columnCount; cIdx += 1) {
								const colIds = idsByColumn$1.get(pageIndex)?.get(cIdx) ?? [];
								for (const id of colIds) if (!out.includes(id)) out.push(id);
							}
							return out;
						})();
						const seenNewAnchor = /* @__PURE__ */ new Set();
						const mandatorySliceIds = [];
						const continuationSliceIds = [];
						const extendedSliceIds = [];
						let actualBandHeight = 0;
						const overheadBase = Math.max(0, separatorSpacingBefore) + safeDividerHeight + safeTopPadding;
						for (const slice of pageSlices) {
							if (slice.isContinuation) continuationSliceIds.push(slice.id);
							else if (!seenNewAnchor.has(slice.id)) {
								mandatorySliceIds.push(slice.id);
								seenNewAnchor.add(slice.id);
							} else extendedSliceIds.push(slice.id);
							actualBandHeight += slice.totalHeight;
						}
						if (pageSlices.length > 0) actualBandHeight += overheadBase + safeGap * Math.max(0, pageSlices.length - 1);
						let mandatoryReserve = 0;
						let preferredReserve = 0;
						let continuationInHeight = 0;
						for (const entry of continuationInForPage) continuationInHeight += entry.remainingHeightPx;
						if (continuationInHeight > 0) {
							mandatoryReserve += continuationInHeight;
							preferredReserve += continuationInHeight;
							if (idsOnPage.length > 0) {
								mandatoryReserve += safeGap;
								preferredReserve += safeGap;
							}
						}
						if (idsOnPage.length > 0) {
							for (let i = 0; i < idsOnPage.length; i += 1) {
								const isLast = i === idsOnPage.length - 1;
								mandatoryReserve += isLast ? firstLineOf(idsOnPage[i]) : fullHeightOf(idsOnPage[i]);
								preferredReserve += fullHeightOf(idsOnPage[i]);
								if (i > 0) {
									mandatoryReserve += safeGap;
									preferredReserve += safeGap;
								}
							}
							mandatoryReserve += overheadBase;
							preferredReserve += overheadBase;
						} else if (continuationInHeight > 0) {
							mandatoryReserve += overheadBase;
							preferredReserve += overheadBase;
						}
						let lastAnchorRenderedLines = 0;
						if (idsOnPage.length > 0) {
							const lastId = idsOnPage[idsOnPage.length - 1];
							for (const slice of pageSlices) {
								if (slice.id !== lastId || slice.isContinuation) continue;
								for (const range of slice.ranges) if (range.kind === "paragraph" || range.kind === "list-item") lastAnchorRenderedLines += Math.max(0, range.toLine - range.fromLine);
								else lastAnchorRenderedLines += 1;
							}
						}
						const continuationOut = [];
						pendingByColumn.forEach((entries) => {
							entries.forEach((entry) => {
								let total = 0;
								entry.ranges.forEach((range) => {
									const spacingAfter = "spacingAfter" in range ? range.spacingAfter ?? 0 : 0;
									total += range.height + spacingAfter;
								});
								continuationOut.push({
									id: entry.id,
									remainingRangeCount: entry.ranges.length,
									remainingHeightPx: total
								});
							});
						});
						ledgersByPage.set(pageIndex, {
							anchorIds: idsOnPage,
							mandatorySliceIds,
							continuationSliceIds,
							extendedSliceIds,
							continuationIn: continuationInForPage,
							continuationOut,
							mandatoryReservePx: Math.ceil(mandatoryReserve),
							preferredReservePx: Math.ceil(preferredReserve),
							actualBandHeightPx: Math.ceil(actualBandHeight),
							lastAnchorRenderedLines
						});
					}
					if (pageIndex + 1 < pageCount) {
						let continuationDemand = 0;
						pendingByColumn.forEach((entries) => {
							entries.forEach((entry) => {
								entry.ranges.forEach((range) => {
									const spacingAfter = "spacingAfter" in range ? range.spacingAfter ?? 0 : 0;
									continuationDemand += range.height + spacingAfter;
								});
							});
						});
						let nextClusterDemand = 0;
						for (let cIdx = 0; cIdx < columnCount; cIdx += 1) {
							const idsNext = idsByColumn$1.get(pageIndex + 1)?.get(cIdx) ?? [];
							if (idsNext.length === 0) continue;
							let columnCluster = 0;
							for (let i = 0; i < idsNext.length; i += 1) {
								const isLast = i === idsNext.length - 1;
								columnCluster += isLast ? firstLineOf(idsNext[i]) : fullHeightOf(idsNext[i]);
								if (i > 0) columnCluster += safeGap;
							}
							if (columnCluster > nextClusterDemand) nextClusterDemand = columnCluster;
						}
						if (continuationDemand > 0 || nextClusterDemand > 0) {
							const overhead = safeSeparatorSpacingBefore + continuationDividerHeight + safeTopPadding;
							const nextPage = layoutForPages.pages?.[pageIndex + 1];
							const nextPageSize = nextPage?.size ?? layoutForPages.pageSize ?? DEFAULT_PAGE_SIZE$1;
							const nextTop = normalizeMargin(nextPage?.margins?.top, DEFAULT_MARGINS$1.top);
							const nextBottomRaw = normalizeMargin(nextPage?.margins?.bottom, DEFAULT_MARGINS$1.bottom);
							const physicalContentHeight = Math.max(0, nextPageSize.h - nextTop - nextBottomRaw);
							const minBodyHeight = MIN_FOOTNOTE_BODY_HEIGHT * 20;
							const nextPageMaxBand = Math.max(0, physicalContentHeight - minBodyHeight);
							const overheadForBand = nextClusterDemand > 0 || continuationDemand > 0 ? overhead : 0;
							const clusterRoomPx = nextClusterDemand > 0 ? Math.min(nextClusterDemand, Math.max(0, nextPageMaxBand - overheadForBand)) : 0;
							const continuationRoomPx = Math.max(0, nextPageMaxBand - overheadForBand - clusterRoomPx);
							const continuationToReservePx = Math.min(continuationDemand, continuationRoomPx);
							const finalReserve = Math.min(clusterRoomPx + continuationToReservePx + overheadForBand, nextPageMaxBand);
							reserves$1[pageIndex + 1] = Math.max(reserves$1[pageIndex + 1] ?? 0, Math.ceil(finalReserve));
						}
					}
				}
				if (cappedPages.size > 0) console.warn("[layout] Footnote reserve capped to preserve body area", { pages: Array.from(cappedPages) });
				if (pendingByColumn.size > 0) {
					const pendingIds = /* @__PURE__ */ new Set();
					pendingByColumn.forEach((entries) => entries.forEach((entry) => pendingIds.add(entry.id)));
					console.warn("[layout] Footnote content truncated: extends beyond document pages", { ids: Array.from(pendingIds) });
				}
				return {
					slicesByPage,
					reserves: reserves$1,
					hasContinuationByColumn,
					separatorSpacingBefore: safeSeparatorSpacingBefore,
					ledgersByPage
				};
			};
			const injectFragments = (layoutForPages, plan$1, measuresById$1, reservesByPageIndex, blockById, pageColumns$1) => {
				const decorativeBlocks = [];
				const decorativeMeasures = [];
				for (let pageIndex = 0; pageIndex < layoutForPages.pages.length; pageIndex++) {
					const page = layoutForPages.pages[pageIndex];
					page.footnoteReserved = Math.max(0, reservesByPageIndex[pageIndex] ?? plan$1.reserves[pageIndex] ?? 0);
					const draft = plan$1.ledgersByPage.get(pageIndex);
					if (draft) page.footnoteLedger = {
						pageIndex,
						anchorIds: draft.anchorIds,
						mandatorySliceIds: draft.mandatorySliceIds,
						continuationSliceIds: draft.continuationSliceIds,
						extendedSliceIds: draft.extendedSliceIds,
						continuationIn: draft.continuationIn,
						continuationOut: draft.continuationOut,
						mandatoryReservePx: draft.mandatoryReservePx,
						preferredReservePx: draft.preferredReservePx,
						actualBandHeightPx: draft.actualBandHeightPx,
						appliedBodyReservePx: page.footnoteReserved ?? 0,
						deadReservePx: Math.max(0, (page.footnoteReserved ?? 0) - draft.actualBandHeightPx),
						lastAnchorRenderedLines: draft.lastAnchorRenderedLines
					};
					const slices = plan$1.slicesByPage.get(pageIndex) ?? [];
					if (slices.length === 0) continue;
					if (!page.margins) continue;
					const pageSize = page.size ?? layoutForPages.pageSize;
					const marginLeft = normalizeMargin(page.margins.left, normalizeMargin(options.margins?.left, DEFAULT_MARGINS$1.left));
					const marginRight = normalizeMargin(page.margins.right, normalizeMargin(options.margins?.right, DEFAULT_MARGINS$1.right));
					const pageContentWidth = pageSize.w - (marginLeft + marginRight);
					const fallbackColumns = normalizeColumnsForFootnotes(options.columns ?? SINGLE_COLUMN_DEFAULT, pageContentWidth);
					const columns = pageColumns$1.get(pageIndex) ?? {
						...fallbackColumns,
						left: marginLeft,
						contentWidth: pageContentWidth
					};
					const physicalBottomMargin = Math.max(0, (page.margins.bottom ?? 0) - (page.footnoteReserved ?? 0));
					const pageBottomLimit = pageSize.h - physicalBottomMargin;
					const bodyMaxYValue = page.bodyMaxY;
					const bodyMaxY = typeof bodyMaxYValue === "number" && Number.isFinite(bodyMaxYValue) ? bodyMaxYValue : pageSize.h - (page.margins.bottom ?? 0);
					const slicesByColumn = /* @__PURE__ */ new Map();
					slices.forEach((slice) => {
						const columnIndex = Number.isFinite(slice.columnIndex) ? slice.columnIndex : 0;
						const list = slicesByColumn.get(columnIndex) ?? [];
						list.push(slice);
						slicesByColumn.set(columnIndex, list);
					});
					slicesByColumn.forEach((columnSlices, rawColumnIndex) => {
						if (columnSlices.length === 0) return;
						const columnIndex = Math.max(0, Math.min(columns.count - 1, rawColumnIndex));
						const columnX = getColumnX(getColumnGeometry(columns), columnIndex, columns.left);
						const contentWidth = Math.min(columns.width, footnoteWidth);
						if (!Number.isFinite(contentWidth) || contentWidth <= 0) return;
						const columnKey = footnoteColumnKey(pageIndex, columnIndex);
						const isContinuation = plan$1.hasContinuationByColumn.get(columnKey) ?? false;
						const colSeparatorHeight = isContinuation ? continuationDividerHeight : safeDividerHeight;
						let colTotalBandHeight = Math.max(0, plan$1.separatorSpacingBefore) + colSeparatorHeight + safeTopPadding;
						for (let s = 0; s < columnSlices.length; s += 1) {
							colTotalBandHeight += columnSlices[s].totalHeight;
							if (s > 0) colTotalBandHeight += safeGap;
						}
						let cursorY = Math.max(bodyMaxY, pageBottomLimit - colTotalBandHeight) + Math.max(0, plan$1.separatorSpacingBefore);
						const separatorHeight = isContinuation ? continuationDividerHeight : safeDividerHeight;
						const separatorWidth = isContinuation ? contentWidth : Math.max(0, contentWidth * SEPARATOR_DEFAULT_WIDTH_FACTOR);
						if (separatorHeight > 0 && separatorWidth > 0) {
							const separatorId = isContinuation ? `footnote-continuation-separator-page-${page.number}-col-${columnIndex}` : `footnote-separator-page-${page.number}-col-${columnIndex}`;
							decorativeBlocks.push({
								kind: "drawing",
								id: separatorId,
								drawingKind: "vectorShape",
								geometry: {
									width: separatorWidth,
									height: separatorHeight
								},
								shapeKind: "rect",
								fillColor: "#000000",
								strokeColor: null,
								strokeWidth: 0
							});
							decorativeMeasures.push({
								kind: "drawing",
								drawingKind: "vectorShape",
								width: separatorWidth,
								height: separatorHeight,
								scale: 1,
								naturalWidth: separatorWidth,
								naturalHeight: separatorHeight,
								geometry: {
									width: separatorWidth,
									height: separatorHeight
								}
							});
							page.fragments.push({
								kind: "drawing",
								blockId: separatorId,
								drawingKind: "vectorShape",
								x: columnX,
								y: cursorY,
								width: separatorWidth,
								height: separatorHeight,
								geometry: {
									width: separatorWidth,
									height: separatorHeight
								},
								scale: 1
							});
							cursorY += separatorHeight;
						}
						cursorY += safeTopPadding;
						columnSlices.forEach((slice, sliceIndex) => {
							slice.ranges.forEach((range) => {
								if (range.kind === "paragraph") {
									const measure = measuresById$1.get(range.blockId);
									if (!measure || measure.kind !== "paragraph") return;
									const marker = measure.marker;
									page.fragments.push({
										kind: "para",
										blockId: range.blockId,
										fromLine: range.fromLine,
										toLine: range.toLine,
										x: columnX,
										y: cursorY,
										width: contentWidth,
										continuesFromPrev: range.fromLine > 0,
										continuesOnNext: range.toLine < range.totalLines,
										...marker?.markerWidth != null ? { markerWidth: marker.markerWidth } : {},
										...marker?.markerTextWidth != null ? { markerTextWidth: marker.markerTextWidth } : {},
										...marker?.gutterWidth != null ? { markerGutter: marker.gutterWidth } : {}
									});
									cursorY += getRangeRenderHeight(range);
									return;
								}
								if (range.kind === "list-item") {
									const measure = measuresById$1.get(range.blockId);
									const block = blockById.get(range.blockId);
									if (!measure || measure.kind !== "list") return;
									if (!block || block.kind !== "list") return;
									const itemMeasure = measure.items.find((entry) => entry.itemId === range.itemId);
									if (!itemMeasure) return;
									const indentLeft = Number.isFinite(itemMeasure.indentLeft) ? itemMeasure.indentLeft : 0;
									const markerWidth = Number.isFinite(itemMeasure.markerWidth) ? itemMeasure.markerWidth : 0;
									const itemWidth = Math.max(0, contentWidth - indentLeft - markerWidth);
									page.fragments.push({
										kind: "list-item",
										blockId: range.blockId,
										itemId: range.itemId,
										fromLine: range.fromLine,
										toLine: range.toLine,
										x: columnX + indentLeft + markerWidth,
										y: cursorY,
										width: itemWidth,
										markerWidth,
										continuesFromPrev: range.fromLine > 0,
										continuesOnNext: range.toLine < range.totalLines
									});
									cursorY += getRangeRenderHeight(range);
									return;
								}
								if (range.kind === "table") {
									const measure = measuresById$1.get(range.blockId);
									const block = blockById.get(range.blockId);
									if (!measure || measure.kind !== "table") return;
									if (!block || block.kind !== "table") return;
									const { x: tableX, width: tableWidth } = resolveTableFrame(columnX, contentWidth, Math.max(0, measure.totalWidth ?? contentWidth), block.attrs);
									const fragmentColumnWidths = rescaleColumnWidths(measure.columnWidths, measure.totalWidth, tableWidth);
									page.fragments.push({
										kind: "table",
										blockId: range.blockId,
										columnIndex,
										fromRow: 0,
										toRow: block.rows.length,
										x: tableX,
										y: cursorY,
										width: tableWidth,
										height: Math.max(0, measure.totalHeight ?? 0),
										columnWidths: fragmentColumnWidths
									});
									cursorY += getRangeRenderHeight(range);
									return;
								}
								if (range.kind === "image") {
									const measure = measuresById$1.get(range.blockId);
									if (!measure || measure.kind !== "image") return;
									page.fragments.push({
										kind: "image",
										blockId: range.blockId,
										x: columnX,
										y: cursorY,
										width: Math.min(contentWidth, Math.max(0, measure.width ?? 0)),
										height: Math.max(0, measure.height ?? 0)
									});
									cursorY += getRangeRenderHeight(range);
									return;
								}
								if (range.kind === "drawing") {
									const measure = measuresById$1.get(range.blockId);
									const block = blockById.get(range.blockId);
									if (!measure || measure.kind !== "drawing") return;
									if (!block || block.kind !== "drawing") return;
									page.fragments.push({
										kind: "drawing",
										blockId: range.blockId,
										drawingKind: block.drawingKind,
										x: columnX,
										y: cursorY,
										width: Math.min(contentWidth, Math.max(0, measure.width ?? 0)),
										height: Math.max(0, measure.height ?? 0),
										geometry: measure.geometry,
										scale: measure.scale
									});
									cursorY += getRangeRenderHeight(range);
								}
							});
							if (sliceIndex < columnSlices.length - 1) cursorY += safeGap;
						});
					});
				}
				return {
					decorativeBlocks,
					decorativeMeasures
				};
			};
			const resolveFootnoteAssignments = (layoutForPages) => {
				const columns = resolvePageColumns(layoutForPages, options, currentBlocks);
				return {
					columns,
					idsByColumn: assignFootnotesToColumns(layoutForPages, footnotesInput.refs, columns)
				};
			};
			let bodyHeightById = /* @__PURE__ */ new Map();
			let firstLineHeightById = /* @__PURE__ */ new Map();
			const refreshBodyHeights = (measures$1) => {
				const totalMap = /* @__PURE__ */ new Map();
				const firstLineMap = /* @__PURE__ */ new Map();
				footnotesInput.blocksById.forEach((blocks, footnoteId) => {
					let total = 0;
					let firstLine = 0;
					for (const block of blocks) {
						const measure = measures$1.get(block.id);
						if (!measure) continue;
						if (measure.kind === "paragraph") {
							const measureH = measure.totalHeight;
							if (typeof measureH === "number" && Number.isFinite(measureH)) total += measureH;
							const spacing = block.attrs?.spacing;
							const after = spacing?.after ?? spacing?.lineSpaceAfter;
							if (typeof after === "number" && Number.isFinite(after) && after > 0) total += after;
							if (firstLine === 0) {
								const lines = measure.lines;
								const lh = lines && lines.length > 0 ? lines[0].lineHeight : void 0;
								if (typeof lh === "number" && Number.isFinite(lh) && lh > 0) firstLine = lh;
							}
						} else if (measure.kind === "image" || measure.kind === "drawing") {
							const measureH = measure.height;
							if (typeof measureH === "number" && Number.isFinite(measureH)) total += measureH;
							if (firstLine === 0 && typeof measureH === "number" && Number.isFinite(measureH)) firstLine = measureH;
						} else if (measure.kind === "table") {
							const measureH = measure.totalHeight;
							if (typeof measureH === "number" && Number.isFinite(measureH)) total += measureH;
							if (firstLine === 0 && typeof measureH === "number" && Number.isFinite(measureH)) firstLine = measureH;
						} else if (measure.kind === "list" && block.kind === "list") {
							for (const item of block.items) {
								const itemMeasure = measure.items.find((entry) => entry.itemId === item.id);
								if (!itemMeasure?.paragraph?.lines) continue;
								for (const line of itemMeasure.paragraph.lines) total += line.lineHeight ?? 0;
								total += getParagraphSpacingAfter(item.paragraph);
							}
							if (firstLine === 0) {
								const lh = measure.items[0]?.paragraph?.lines?.[0]?.lineHeight;
								if (typeof lh === "number" && Number.isFinite(lh) && lh > 0) firstLine = lh;
							}
						}
					}
					if (total > 0) totalMap.set(footnoteId, total);
					if (firstLine > 0) firstLineMap.set(footnoteId, firstLine);
				});
				bodyHeightById = totalMap;
				firstLineHeightById = firstLineMap;
			};
			const relayout = (footnoteReservedByPageIndex, plannerSeparatorSpacingBefore) => layoutDocument(currentBlocks, currentMeasures, {
				...options,
				footnoteReservedByPageIndex,
				footnotes: {
					...footnotesInput,
					bodyHeightById,
					firstLineHeightById,
					...typeof plannerSeparatorSpacingBefore === "number" && Number.isFinite(plannerSeparatorSpacingBefore) ? { separatorSpacingBefore: plannerSeparatorSpacingBefore } : {}
				},
				headerContentHeights,
				footerContentHeights,
				headerContentHeightsBySectionRef,
				headerContentHeightsByRId,
				footerContentHeightsBySectionRef,
				footerContentHeightsByRId,
				remeasureParagraph: (block, maxWidth, firstLineIndent) => remeasureParagraph(block, maxWidth, firstLineIndent)
			});
			const allFootnoteIds = new Set(footnotesInput.refs.map((ref$1) => ref$1.id));
			let { columns: pageColumns, idsByColumn } = resolveFootnoteAssignments(layout);
			let { measuresById } = await measureFootnoteBlocks(allFootnoteIds);
			refreshBodyHeights(measuresById);
			let plan = computeFootnoteLayoutPlan(layout, idsByColumn, measuresById, [], pageColumns);
			let reserves = plan.reserves;
			if (reserves.some((h$2) => h$2 > 0)) {
				let reservesStabilized = false;
				const seenReserveVectors = [reserves.slice()];
				for (let pass = 0; pass < MAX_FOOTNOTE_LAYOUT_PASSES; pass += 1) {
					layout = relayout(reserves, plan.separatorSpacingBefore);
					({columns: pageColumns, idsByColumn} = resolveFootnoteAssignments(layout));
					({measuresById} = await measureFootnoteBlocks(allFootnoteIds));
					refreshBodyHeights(measuresById);
					plan = computeFootnoteLayoutPlan(layout, idsByColumn, measuresById, reserves, pageColumns);
					const nextReserves = plan.reserves;
					if (nextReserves.length === reserves.length && nextReserves.every((h$2, i) => (reserves[i] ?? 0) === h$2) && reserves.every((h$2, i) => (nextReserves[i] ?? 0) === h$2)) {
						reserves = nextReserves;
						reservesStabilized = true;
						break;
					}
					if (seenReserveVectors.some((v) => v.join(",") === nextReserves.join(","))) break;
					seenReserveVectors.push(nextReserves.slice());
					if (pass < MAX_FOOTNOTE_LAYOUT_PASSES - 1) reserves = nextReserves;
				}
				if (!reservesStabilized) console.warn(`[incrementalLayout] Footnote reserve loop did not converge (max ${MAX_FOOTNOTE_LAYOUT_PASSES} passes); layout may have suboptimal footnote placement.`);
				let { columns: finalPageColumns, idsByColumn: finalIdsByColumn } = resolveFootnoteAssignments(layout);
				let { blocks: finalBlocks, measuresById: finalMeasuresById } = await measureFootnoteBlocks(collectFootnoteIdsByColumn(finalIdsByColumn));
				let finalPlan = computeFootnoteLayoutPlan(layout, finalIdsByColumn, finalMeasuresById, reserves, finalPageColumns);
				let reservesAppliedToLayout = reserves;
				const vectorsEqual = (a, b$1) => {
					for (let i = 0; i < Math.max(a.length, b$1.length); i += 1) if ((a[i] ?? 0) !== (b$1[i] ?? 0)) return false;
					return true;
				};
				const applyReserves = async (target) => {
					layout = relayout(target, finalPlan.separatorSpacingBefore);
					reservesAppliedToLayout = target;
					({columns: finalPageColumns, idsByColumn: finalIdsByColumn} = resolveFootnoteAssignments(layout));
					({blocks: finalBlocks, measuresById: finalMeasuresById} = await measureFootnoteBlocks(allFootnoteIds));
					refreshBodyHeights(finalMeasuresById);
					finalPlan = computeFootnoteLayoutPlan(layout, finalIdsByColumn, finalMeasuresById, reservesAppliedToLayout, finalPageColumns);
				};
				const buildFootnoteLedgers = (plan$1, appliedReserves, pageCount) => {
					const ledgers = [];
					for (let pageIndex = 0; pageIndex < pageCount; pageIndex += 1) {
						const draft = plan$1.ledgersByPage.get(pageIndex);
						if (!draft) continue;
						const appliedBodyReservePx = Math.max(0, appliedReserves[pageIndex] ?? plan$1.reserves[pageIndex] ?? 0);
						ledgers.push({
							pageIndex,
							anchorIds: draft.anchorIds,
							mandatorySliceIds: draft.mandatorySliceIds,
							continuationSliceIds: draft.continuationSliceIds,
							extendedSliceIds: draft.extendedSliceIds,
							continuationIn: draft.continuationIn,
							continuationOut: draft.continuationOut,
							mandatoryReservePx: draft.mandatoryReservePx,
							preferredReservePx: draft.preferredReservePx,
							actualBandHeightPx: draft.actualBandHeightPx,
							appliedBodyReservePx,
							deadReservePx: Math.max(0, appliedBodyReservePx - draft.actualBandHeightPx),
							lastAnchorRenderedLines: draft.lastAnchorRenderedLines
						});
					}
					return ledgers;
				};
				const capReserveForRelayout = (requestedReserve, pageIndex, referenceLayout, referenceReserves) => {
					const requested = Number.isFinite(requestedReserve) ? Math.max(0, requestedReserve) : 0;
					const page = referenceLayout.pages?.[pageIndex];
					if (!page) return requested;
					const pageSize = page.size ?? referenceLayout.pageSize ?? DEFAULT_PAGE_SIZE$1;
					const topMargin = normalizeMargin(page.margins?.top, DEFAULT_MARGINS$1.top);
					const bottomWithReserve = normalizeMargin(page.margins?.bottom, DEFAULT_MARGINS$1.bottom);
					const currentReserve = Number.isFinite(referenceReserves[pageIndex]) ? Math.max(0, referenceReserves[pageIndex]) : 0;
					const physicalBottomMargin = Math.max(0, bottomWithReserve - currentReserve);
					const physicalContentHeight = pageSize.h - topMargin - physicalBottomMargin;
					if (!Number.isFinite(physicalContentHeight)) return requested;
					return Math.min(requested, Math.max(0, physicalContentHeight - MIN_FOOTNOTE_BODY_HEIGHT));
				};
				const growReserves = async (maxPasses) => {
					const seen = [reservesAppliedToLayout.slice()];
					for (let pass = 0; pass < maxPasses; pass += 1) {
						const target = reservesAppliedToLayout.slice();
						const plan$1 = finalPlan.reserves;
						let grew = false;
						for (let i = 0; i < Math.max(target.length, plan$1.length); i += 1) if ((plan$1[i] ?? 0) > (target[i] ?? 0)) {
							target[i] = plan$1[i];
							grew = true;
						}
						if (!grew) return true;
						let next = target;
						if (seen.some((prev) => vectorsEqual(prev, target))) {
							const last = seen[seen.length - 1];
							next = target.map((v, i) => Math.max(v, last[i] ?? 0));
							if (vectorsEqual(next, reservesAppliedToLayout)) return true;
						}
						await applyReserves(next);
						seen.push(next);
					}
					return false;
				};
				const GROW_MAX_PASSES = 10;
				const PREFERRED_RESERVE_MAX_CANDIDATES = 12;
				const PREFERRED_RESERVE_MAX_ACCEPTED_CANDIDATES = PREFERRED_RESERVE_MAX_CANDIDATES;
				const PREFERRED_RESERVE_WINDOW_AHEAD = 3;
				const runPreferredReserveTrials = async () => {
					let acceptedPreferredTrials = 0;
					let rejectedPreferredTrials = 0;
					const rejectedPreferredPages = /* @__PURE__ */ new Set();
					for (let candidatePass = 0; candidatePass < PREFERRED_RESERVE_MAX_CANDIDATES; candidatePass += 1) {
						const beforeLayout = layout;
						const beforePlan = finalPlan;
						const beforeReserves = reservesAppliedToLayout.slice();
						const beforeLedgers = buildFootnoteLedgers(beforePlan, beforeReserves, beforeLayout.pages.length);
						const candidate = getPreferredReserveCandidates(beforeLedgers).find((entry) => !rejectedPreferredPages.has(entry.pageIndex));
						if (!candidate) break;
						const targetReserves = getPreferredReserveTrialTargets(candidate, beforeReserves[candidate.pageIndex] ?? 0);
						let acceptedCandidate = false;
						for (const targetReserve of targetReserves) {
							const trialReserves = beforeReserves.slice();
							const cappedPreferredReserve = capReserveForRelayout(targetReserve, candidate.pageIndex, beforeLayout, beforeReserves);
							trialReserves[candidate.pageIndex] = Math.max(trialReserves[candidate.pageIndex] ?? 0, cappedPreferredReserve);
							await applyReserves(trialReserves);
							const trialConverged = await growReserves(GROW_MAX_PASSES);
							const afterLedgers = buildFootnoteLedgers(finalPlan, reservesAppliedToLayout, layout.pages.length);
							const score = scoreFootnoteWindow({
								beforeLayout,
								afterLayout: layout,
								candidatePageIndex: candidate.pageIndex,
								candidateAnchorId: candidate.anchorIds[candidate.anchorIds.length - 1],
								beforeLedger: beforeLedgers,
								afterLedger: afterLedgers,
								windowAhead: PREFERRED_RESERVE_WINDOW_AHEAD
							});
							if (trialConverged && score.accept) {
								if (layoutDebugEnabled$1) console.log("[incrementalLayout] Accepted footnote preferred-reserve trial", {
									pageIndex: candidate.pageIndex,
									targetReserve,
									score
								});
								acceptedPreferredTrials += 1;
								acceptedCandidate = true;
								break;
							}
							if (layoutDebugEnabled$1) console.log("[incrementalLayout] Rejected footnote preferred-reserve trial", {
								pageIndex: candidate.pageIndex,
								targetReserve,
								trialConverged,
								score
							});
							await applyReserves(beforeReserves);
						}
						if (acceptedCandidate) {
							if (acceptedPreferredTrials >= PREFERRED_RESERVE_MAX_ACCEPTED_CANDIDATES) break;
							continue;
						}
						rejectedPreferredTrials += 1;
						rejectedPreferredPages.add(candidate.pageIndex);
					}
					if (layoutDebugEnabled$1 && (acceptedPreferredTrials > 0 || rejectedPreferredTrials > 0)) console.log("[incrementalLayout] Footnote preferred-reserve trials", {
						accepted: acceptedPreferredTrials,
						rejected: rejectedPreferredTrials
					});
				};
				const TIGHTEN_SLACK_PX = 8;
				if ((() => {
					const plan$1 = finalPlan.reserves;
					const applied = reservesAppliedToLayout;
					const len = Math.max(plan$1.length, applied.length);
					for (let i = 0; i < len; i += 1) {
						const a = applied[i] ?? 0;
						const p$1 = plan$1[i] ?? 0;
						if (p$1 > a) return true;
						if (a >= TIGHTEN_SLACK_PX && p$1 === 0) return true;
						if (a >= TIGHTEN_SLACK_PX && a - p$1 > TIGHTEN_SLACK_PX) return true;
					}
					return false;
				})()) {
					if (!await growReserves(GROW_MAX_PASSES)) console.warn("[incrementalLayout] Footnote post-reserve loop did not converge; some pages may have footnotes overflowing the reserved band.");
					const MAX_TIGHTEN_ITERATIONS = 8;
					for (let iteration$1 = 0; iteration$1 < MAX_TIGHTEN_ITERATIONS; iteration$1 += 1) {
						const pagesToTighten = [];
						for (let i = 0; i < reservesAppliedToLayout.length; i += 1) {
							const applied = reservesAppliedToLayout[i] ?? 0;
							const planned = finalPlan.reserves[i] ?? 0;
							if (applied < TIGHTEN_SLACK_PX) continue;
							if (planned === 0) pagesToTighten.push({
								i,
								target: 0
							});
							else if (applied - planned > TIGHTEN_SLACK_PX) pagesToTighten.push({
								i,
								target: planned
							});
						}
						if (pagesToTighten.length === 0) break;
						const safeApplied = reservesAppliedToLayout.slice();
						const safePageCount = layout.pages.length;
						const tightened = reservesAppliedToLayout.slice();
						for (const { i, target } of pagesToTighten) tightened[i] = target;
						await applyReserves(tightened);
						if (!await growReserves(GROW_MAX_PASSES) || layout.pages.length > safePageCount) {
							await applyReserves(safeApplied);
							break;
						}
					}
				}
				const ONE_LINE_TAIL_PX = 24;
				const runWidowOrphanAbsorb = async () => {
					const ledgers = buildFootnoteLedgers(finalPlan, reservesAppliedToLayout, layout.pages.length);
					const target = reservesAppliedToLayout.slice();
					let bumped = 0;
					for (const ledger of ledgers) {
						const tailPx = ledger.continuationOut.reduce((s, e) => s + (e.remainingHeightPx || 0), 0);
						if (tailPx <= 0 || tailPx > ONE_LINE_TAIL_PX) continue;
						const requested = capReserveForRelayout(ledger.preferredReservePx, ledger.pageIndex, layout, reservesAppliedToLayout);
						if (requested > (target[ledger.pageIndex] ?? 0)) {
							target[ledger.pageIndex] = requested;
							bumped += 1;
						}
					}
					if (bumped === 0) return;
					const safeApplied = reservesAppliedToLayout.slice();
					await applyReserves(target);
					if (!await growReserves(GROW_MAX_PASSES)) await applyReserves(safeApplied);
				};
				await runWidowOrphanAbsorb();
				await runPreferredReserveTrials();
				const blockById = /* @__PURE__ */ new Map();
				finalBlocks.forEach((block) => {
					blockById.set(block.id, block);
				});
				const injected = injectFragments(layout, finalPlan, finalMeasuresById, reservesAppliedToLayout, blockById, finalPageColumns);
				const alignedBlocks = [];
				const alignedMeasures = [];
				finalBlocks.forEach((block) => {
					const measure = finalMeasuresById.get(block.id);
					if (!measure) return;
					alignedBlocks.push(block);
					alignedMeasures.push(measure);
				});
				extraBlocks = injected ? alignedBlocks.concat(injected.decorativeBlocks) : alignedBlocks;
				extraMeasures = injected ? alignedMeasures.concat(injected.decorativeMeasures) : alignedMeasures;
			}
		}
	}
	let headers;
	let footers;
	const sections = options.sectionMetadata ?? [];
	const numberingCtx = buildNumberingContext(layout, sections, chapterBlockById, chapterContextCache);
	applyNumberingContextToLayout(layout, numberingCtx);
	if (headerFooter?.constraints && (headerFooter.headerBlocks || headerFooter.footerBlocks)) {
		const hfStart = performance.now();
		const measureFn = headerFooter.measure ?? measureBlock$1;
		invalidateHeaderFooterCache(headerMeasureCache, headerFooterCacheState, headerFooter.headerBlocks, headerFooter.footerBlocks, headerFooter.constraints, options.sectionMetadata);
		const pageResolver = FeatureFlags.HEADER_FOOTER_PAGE_TOKENS ? (pageNumber) => {
			const pageIndex = pageNumber - 1;
			const displayInfo = numberingCtx.displayPages[pageIndex];
			return {
				displayText: displayInfo?.displayText ?? String(pageNumber),
				displayNumber: displayInfo?.displayNumber ?? pageNumber,
				totalPages: numberingCtx.totalPages,
				sectionPageCount: displayInfo?.sectionPageCount ?? numberingCtx.totalPages ?? 1,
				pageFormat: displayInfo?.pageFormat,
				chapterNumberText: displayInfo?.chapterNumberText,
				chapterSeparator: displayInfo?.chapterSeparator
			};
		} : void 0;
		const hfRemeasure = (block, maxWidth) => remeasureParagraph(block, maxWidth);
		if (headerFooter.headerBlocks) {
			for (const blocks of Object.values(headerFooter.headerBlocks)) hydrateTableTextboxMeasures(blocks, hfRemeasure);
			headers = serializeHeaderFooterResults("header", await layoutHeaderFooterWithCache(headerFooter.headerBlocks, headerFooter.constraints, measureFn, headerMeasureCache, FeatureFlags.HEADER_FOOTER_PAGE_TOKENS ? void 0 : numberingCtx.totalPages, pageResolver, "header", fontSignature, (block, maxWidth, firstLineIndent) => remeasureParagraph(block, maxWidth, firstLineIndent)));
		}
		if (headerFooter.footerBlocks) {
			for (const blocks of Object.values(headerFooter.footerBlocks)) hydrateTableTextboxMeasures(blocks, hfRemeasure);
			footers = serializeHeaderFooterResults("footer", await layoutHeaderFooterWithCache(headerFooter.footerBlocks, headerFooter.constraints, measureFn, headerMeasureCache, FeatureFlags.HEADER_FOOTER_PAGE_TOKENS ? void 0 : numberingCtx.totalPages, pageResolver, "footer", fontSignature, (block, maxWidth, firstLineIndent) => remeasureParagraph(block, maxWidth, firstLineIndent)));
		}
		perfLog$1(`[Perf] 4.4 Header/footer layout: ${(performance.now() - hfStart).toFixed(2)}ms`);
		const cacheStats = headerMeasureCache.getStats();
		globalMetrics.recordHeaderFooterCacheMetrics(cacheStats);
		HeaderFooterCacheLogger.logStats(cacheStats);
	}
	return {
		layout,
		measures: currentMeasures,
		dirty,
		headers,
		footers,
		extraBlocks,
		extraMeasures
	};
}
var DEFAULT_PAGE_SIZE$1 = {
	w: 612,
	h: 792
};
var DEFAULT_MARGINS$1 = {
	top: 72,
	right: 72,
	bottom: 72,
	left: 72
};
const normalizeMargin = (value, fallback) => Number.isFinite(value) ? value : fallback;
function hydrateTableTextboxMeasures(blocks, remeasure) {
	for (const block of blocks) {
		if (block.kind !== "table") continue;
		for (const row of block.rows ?? []) for (const cell of row.cells ?? []) for (const cellBlock of cell.blocks ?? []) if (cellBlock.kind === "drawing" && cellBlock.drawingKind === "textboxShape") cellBlock.contentMeasures = layoutTextboxContent(cellBlock, remeasure);
		else if (cellBlock.kind === "table") hydrateTableTextboxMeasures([cellBlock], remeasure);
	}
}
function rewriteSectionBreaksForSemanticFlow(blocks, options) {
	const semanticPageSize = options.pageSize;
	const semanticMargins = options.margins;
	if (!semanticPageSize) return blocks;
	if (!blocks.some((b$1) => b$1.kind === "sectionBreak")) return blocks;
	return blocks.map((block) => {
		if (block.kind !== "sectionBreak") return block;
		const sb = block;
		return {
			...sb,
			pageSize: {
				w: semanticPageSize.w,
				h: semanticPageSize.h
			},
			margins: {
				...sb.margins,
				top: semanticMargins?.top,
				right: semanticMargins?.right,
				bottom: semanticMargins?.bottom,
				left: semanticMargins?.left
			},
			columns: {
				count: 1,
				gap: 0
			}
		};
	});
}
function computePerSectionConstraints(options, blocks) {
	const pageSize = options.pageSize ?? DEFAULT_PAGE_SIZE$1;
	const defaultMargins = {
		top: normalizeMargin(options.margins?.top, DEFAULT_MARGINS$1.top),
		right: normalizeMargin(options.margins?.right, DEFAULT_MARGINS$1.right),
		bottom: normalizeMargin(options.margins?.bottom, DEFAULT_MARGINS$1.bottom),
		left: normalizeMargin(options.margins?.left, DEFAULT_MARGINS$1.left)
	};
	const defaultContentWidth = pageSize.w - (defaultMargins.left + defaultMargins.right);
	const defaultContentHeight = pageSize.h - (defaultMargins.top + defaultMargins.bottom);
	let current = {
		maxWidth: resolveMaxColumnWidth(defaultContentWidth, options.columns),
		maxHeight: defaultContentHeight
	};
	const result = [];
	for (const block of blocks) {
		if (block.kind === "sectionBreak") {
			const sb = block;
			const sectionPageSize = sb.pageSize ?? pageSize;
			const sectionMargins = {
				top: normalizeMargin(sb.margins?.top, defaultMargins.top),
				right: normalizeMargin(sb.margins?.right, defaultMargins.right),
				bottom: normalizeMargin(sb.margins?.bottom, defaultMargins.bottom),
				left: normalizeMargin(sb.margins?.left, defaultMargins.left)
			};
			const contentWidth = sectionPageSize.w - (sectionMargins.left + sectionMargins.right);
			const contentHeight = sectionPageSize.h - (sectionMargins.top + sectionMargins.bottom);
			if (contentWidth > 0 && contentHeight > 0) current = {
				maxWidth: resolveMaxColumnWidth(contentWidth, ooXmlSectionColumns(sb.columns)),
				maxHeight: contentHeight
			};
		}
		result.push(current);
	}
	return result;
}
function resolveMeasurementConstraints(options, blocks) {
	if (options.flowMode === "semantic") {
		const semanticContentWidth = options.semantic?.contentWidth;
		if (typeof semanticContentWidth === "number" && Number.isFinite(semanticContentWidth) && semanticContentWidth > 0) {
			const semanticTop = normalizeMargin(options.semantic?.marginTop, normalizeMargin(options.margins?.top, DEFAULT_MARGINS$1.top));
			const semanticBottom = normalizeMargin(options.semantic?.marginBottom, normalizeMargin(options.margins?.bottom, DEFAULT_MARGINS$1.bottom));
			const measurementHeight$1 = Math.max(1, SEMANTIC_PAGE_HEIGHT_PX - (semanticTop + semanticBottom));
			return {
				measurementWidth: Math.max(1, Math.floor(semanticContentWidth)),
				measurementHeight: measurementHeight$1
			};
		}
	}
	const pageSize = options.pageSize ?? DEFAULT_PAGE_SIZE$1;
	const margins = {
		top: normalizeMargin(options.margins?.top, DEFAULT_MARGINS$1.top),
		right: normalizeMargin(options.margins?.right, DEFAULT_MARGINS$1.right),
		bottom: normalizeMargin(options.margins?.bottom, DEFAULT_MARGINS$1.bottom),
		left: normalizeMargin(options.margins?.left, DEFAULT_MARGINS$1.left)
	};
	const baseContentWidth = pageSize.w - (margins.left + margins.right);
	const baseContentHeight = pageSize.h - (margins.top + margins.bottom);
	let measurementWidth = resolveMaxColumnWidth(baseContentWidth, options.columns);
	let measurementHeight = baseContentHeight;
	if (blocks && blocks.length > 0) for (const block of blocks) {
		if (block.kind !== "sectionBreak") continue;
		const sectionPageSize = block.pageSize ?? pageSize;
		const sectionMargins = {
			top: normalizeMargin(block.margins?.top, margins.top),
			right: normalizeMargin(block.margins?.right, margins.right),
			bottom: normalizeMargin(block.margins?.bottom, margins.bottom),
			left: normalizeMargin(block.margins?.left, margins.left)
		};
		const contentWidth = sectionPageSize.w - (sectionMargins.left + sectionMargins.right);
		const contentHeight = sectionPageSize.h - (sectionMargins.top + sectionMargins.bottom);
		if (contentWidth <= 0 || contentHeight <= 0) continue;
		const columnWidth = resolveMaxColumnWidth(contentWidth, ooXmlSectionColumns(block.columns));
		if (columnWidth > measurementWidth) measurementWidth = columnWidth;
		if (contentHeight > measurementHeight) measurementHeight = contentHeight;
	}
	return {
		measurementWidth,
		measurementHeight
	};
}
var serializeHeaderFooterResults = (kind, batch) => {
	const results = [];
	Object.entries(batch).forEach(([type, value]) => {
		if (!value) return;
		results.push({
			kind,
			type,
			layout: value.layout,
			blocks: value.blocks,
			measures: value.measures
		});
	});
	return results;
};
function buildBlockById(blocks) {
	const blockById = /* @__PURE__ */ new Map();
	for (const block of blocks) blockById.set(block.id, block);
	return blockById;
}
function getFragmentBlockId(fragment) {
	if (typeof fragment === "object" && fragment !== null && "blockId" in fragment && typeof fragment.blockId === "string") return fragment.blockId;
	return "";
}
function buildChapterContextSignature(layout) {
	return layout.pages.map((page) => {
		return [
			page.number,
			page.sectionIndex ?? 0,
			page.fragments.length,
			page.fragments.map((fragment) => getFragmentBlockId(fragment)).join(",")
		].join(":");
	}).join("|");
}
function sectionsHaveChapterNumbering(sections) {
	return sections.some((section) => {
		const chapterStyle = section.numbering?.chapterStyle;
		return typeof chapterStyle === "number" && Number.isInteger(chapterStyle) && chapterStyle > 0;
	});
}
var PRELAYOUT_CHAPTER_MARKER_SEPARATOR_RE = /[.\-:\u2013\u2014]/;
var PRELAYOUT_MIN_PAGE_COMPONENT = 10;
function getPrelayoutHeadingLevel(block) {
	if (block.kind !== "paragraph") return;
	const attrs = block.attrs;
	const headingLevel = attrs?.headingLevel;
	if (typeof headingLevel === "number" && Number.isInteger(headingLevel) && headingLevel > 0) return headingLevel;
	const styleId$1 = attrs?.styleId;
	if (typeof styleId$1 !== "string") return;
	const normalizedStyleId = styleId$1.replace(/[\s_-]+/g, "").toLowerCase();
	const match$1 = /^heading(\d+)$/.exec(normalizedStyleId);
	if (!match$1) return;
	const level = Number(match$1[1]);
	return Number.isInteger(level) && level > 0 ? level : void 0;
}
function getPrelayoutChapterMarkerText(block, chapterStyle) {
	const headingLevel = getPrelayoutHeadingLevel(block);
	if (!headingLevel || headingLevel > chapterStyle || block.kind !== "paragraph") return;
	const attrs = block.attrs;
	const markerText = normalizeChapterMarkerText(attrs?.wordLayout?.marker?.markerText);
	if (!markerText) {
		const listLevelOrdinal = attrs?.listLevelOrdinal;
		return headingLevel === 1 && typeof listLevelOrdinal === "number" && Number.isInteger(listLevelOrdinal) && listLevelOrdinal > 0 ? String(listLevelOrdinal) : void 0;
	}
	return markerText.split(PRELAYOUT_CHAPTER_MARKER_SEPARATOR_RE).length <= chapterStyle ? markerText : void 0;
}
function buildConservativePrelayoutPageResolver(blocks, sections) {
	if (sections.length === 0) return;
	let longestDisplay;
	const considerDisplay = (display) => {
		if (!longestDisplay || display.displayText.length > longestDisplay.displayText.length) longestDisplay = display;
	};
	for (const section of sections) {
		const sectionStart = typeof section.numbering?.start === "number" && Number.isFinite(section.numbering.start) ? section.numbering.start : 1;
		const displayNumber = Math.max(sectionStart, PRELAYOUT_MIN_PAGE_COMPONENT);
		const pageFormat = section.numbering?.format ?? "decimal";
		considerDisplay({
			displayText: formatSectionPageNumberText({
				displayNumber,
				pageFormat
			}),
			displayNumber,
			totalPages: PRELAYOUT_MIN_PAGE_COMPONENT,
			sectionPageCount: PRELAYOUT_MIN_PAGE_COMPONENT,
			pageFormat
		});
		const chapterStyle = section.numbering?.chapterStyle;
		if (!(typeof chapterStyle === "number" && Number.isInteger(chapterStyle) && chapterStyle > 0)) continue;
		for (const block of blocks) {
			const chapterNumberText = getPrelayoutChapterMarkerText(block, chapterStyle);
			if (!chapterNumberText) continue;
			const chapterSeparator = section.numbering?.chapterSeparator ?? "hyphen";
			considerDisplay({
				displayText: formatSectionPageNumberText({
					displayNumber,
					pageFormat,
					chapterNumberText,
					chapterSeparator
				}),
				displayNumber,
				totalPages: PRELAYOUT_MIN_PAGE_COMPONENT,
				sectionPageCount: PRELAYOUT_MIN_PAGE_COMPONENT,
				pageFormat,
				chapterNumberText,
				chapterSeparator
			});
		}
	}
	if (!longestDisplay) return;
	const resolvedDisplay = longestDisplay;
	return () => resolvedDisplay;
}
function getChapterContextByPage(layout, sections, blockById, cache$2) {
	if (!sectionsHaveChapterNumbering(sections)) return;
	const signature = buildChapterContextSignature(layout);
	if (cache$2.signature === signature && cache$2.context) return cache$2.context;
	const context = buildChapterContextByPage(layout, blockById, sections);
	cache$2.signature = signature;
	cache$2.context = context;
	return context;
}
function applyNumberingContextToLayout(layout, numberingCtx) {
	const displayInfoByPage = new Map(numberingCtx.displayPages.map((page) => [page.physicalPage, page]));
	for (const page of layout.pages) {
		const displayInfo = displayInfoByPage.get(page.number);
		if (!displayInfo) continue;
		page.numberText = displayInfo.displayText;
		page.displayNumber = displayInfo.displayNumber;
		page.pageNumberFormat = displayInfo.pageFormat;
		page.pageNumberChapterText = displayInfo.chapterNumberText;
		page.pageNumberChapterSeparator = displayInfo.chapterSeparator;
	}
}
function buildNumberingContext(layout, sections, blockById, chapterContextCache) {
	const totalPages = layout.pages.length;
	const chapterInfoByPage = getChapterContextByPage(layout, sections, blockById, chapterContextCache);
	const sectionByIndex = new Map(sections.map((section) => [section.sectionIndex, section]));
	return {
		totalPages,
		displayPages: computeDisplayPageNumber(layout.pages, sections, chapterInfoByPage).map((displayPage) => ({
			...displayPage,
			pageFormat: sectionByIndex.get(displayPage.sectionIndex)?.numbering?.format ?? "decimal"
		}))
	};
}
async function remeasureAffectedBlocks(blocks, measures, affectedBlockIds, perBlockConstraints, measureBlock$1, fontSignature, measureCache$1) {
	const updatedMeasures = [...measures];
	for (let i = 0; i < blocks.length; i++) {
		const block = blocks[i];
		if (!affectedBlockIds.has(block.id)) continue;
		try {
			const newMeasure = await measureBlock$1(block, perBlockConstraints[i]);
			updatedMeasures[i] = newMeasure;
			const blockConstraints = perBlockConstraints[i];
			measureCache$1?.set(block, blockConstraints.maxWidth, blockConstraints.maxHeight, newMeasure, fontSignature);
		} catch (error) {
			console.warn(`[incrementalLayout] Failed to re-measure block ${block.id} after token resolution:`, error);
		}
	}
	return updatedMeasures;
}
const isAtomicFragment = (fragment) => {
	return fragment.kind === "drawing" || fragment.kind === "image";
};
var blockPmRangeFromAttrs = (block) => {
	const attrs = block?.attrs;
	const pmStart = typeof attrs?.pmStart === "number" ? attrs.pmStart : void 0;
	return {
		pmStart,
		pmEnd: typeof attrs?.pmEnd === "number" ? attrs.pmEnd : pmStart != null ? pmStart + 1 : void 0
	};
};
const getAtomicPmRange = (fragment, block) => {
	return {
		pmStart: typeof fragment.pmStart === "number" ? fragment.pmStart : blockPmRangeFromAttrs(block).pmStart,
		pmEnd: typeof fragment.pmEnd === "number" ? fragment.pmEnd : blockPmRangeFromAttrs(block).pmEnd
	};
};
const isRtlBlock = (block) => {
	if (block.kind !== "paragraph") return false;
	return getParagraphInlineDirection(block.attrs) === "rtl";
};
function resolveColumnsForHit(layout, page, fragmentY) {
	if (page === void 0) return layout.columns;
	if (page.columnRegions && typeof fragmentY === "number") {
		const region = page.columnRegions.find((r$1) => fragmentY >= r$1.yStart && fragmentY < r$1.yEnd);
		if (region) return region.columns;
	}
	return page.columns;
}
const determineColumn = (layout, fragmentX, page, fragmentY) => {
	const columns = resolveColumnsForHit(layout, page, fragmentY);
	if (!columns || columns.count <= 1) return 0;
	const pageWidth = page?.size?.w ?? layout.pageSize.w;
	const margins = page?.margins ?? layout.pages[0]?.margins;
	const marginLeft = Math.max(0, margins?.left ?? 0);
	const marginRight = Math.max(0, margins?.right ?? 0);
	return getColumnAtX(getColumnGeometry(normalizeColumnLayout(columns, Math.max(1, pageWidth - (marginLeft + marginRight)))), fragmentX, marginLeft);
};
const determineTableColumn = (layout, fragment, page) => {
	if (typeof fragment.columnIndex === "number") {
		const count = resolveColumnsForHit(layout, page, fragment.y)?.count ?? 1;
		return Math.max(0, Math.min(Math.max(0, count - 1), fragment.columnIndex));
	}
	return determineColumn(layout, fragment.x, page, fragment.y);
};
const findLineIndexAtY = (lines, offsetY, fromLine, toLine) => {
	if (!lines || lines.length === 0) return null;
	const lineCount = lines.length;
	if (fromLine < 0 || toLine > lineCount || fromLine >= toLine) return null;
	let cursor = 0;
	for (let i = fromLine; i < toLine; i += 1) {
		const line = lines[i];
		if (!line) return null;
		const next = cursor + line.lineHeight;
		if (offsetY >= cursor && offsetY < next) return i;
		cursor = next;
	}
	return toLine - 1;
};
const mapPointToPm = (block, line, x, isRTL, availableWidthOverride, alignmentOverride) => {
	if (block.kind !== "paragraph") return null;
	const range = computeLinePmRange$1(block, line);
	if (range.pmStart == null || range.pmEnd == null) return null;
	const result = findCharacterAtX(block, line, x, range.pmStart, availableWidthOverride, alignmentOverride);
	let pmPosition = result.pmPosition;
	if (isRTL) {
		const charOffset = result.charOffset;
		const charsInLine = Math.max(1, line.toChar - line.fromChar);
		pmPosition = charOffsetToPm(block, line, Math.max(0, Math.min(charsInLine, charsInLine - charOffset)), range.pmStart);
	}
	return pmPosition;
};
function snapToNearestFragment(pageHit, blocks, measures, pageRelativePoint) {
	const fragments = pageHit.page.fragments.filter((f) => f != null && typeof f === "object");
	let nearestHit = null;
	let nearestDist = Infinity;
	for (const frag of fragments) {
		const isPara = frag.kind === "para";
		const isAtomic = isAtomicFragment(frag);
		if (!isPara && !isAtomic) continue;
		const blockIndex = findBlockIndexByFragmentId(blocks, frag.blockId);
		if (blockIndex === -1) continue;
		const block = blocks[blockIndex];
		const measure = measures[blockIndex];
		if (!block || !measure) continue;
		let fragHeight = 0;
		if (isAtomic) fragHeight = frag.height;
		else if (isPara && block.kind === "paragraph" && measure.kind === "paragraph") fragHeight = measure.lines.slice(frag.fromLine, frag.toLine).reduce((sum, line) => sum + line.lineHeight, 0);
		else continue;
		const top$1 = frag.y;
		const bottom$1 = frag.y + fragHeight;
		let dist;
		if (pageRelativePoint.y < top$1) dist = top$1 - pageRelativePoint.y;
		else if (pageRelativePoint.y > bottom$1) dist = pageRelativePoint.y - bottom$1;
		else dist = 0;
		if (dist < nearestDist) {
			nearestDist = dist;
			const pageY = Math.max(0, Math.min(pageRelativePoint.y - top$1, fragHeight));
			nearestHit = {
				fragment: frag,
				block,
				measure,
				pageIndex: pageHit.pageIndex,
				pageY
			};
		}
	}
	return nearestHit;
}
function findBlockIndexByFragmentId(blocks, fragmentBlockId, targetPmRange) {
	const index = blocks.findIndex((block) => block.id === fragmentBlockId && block.kind !== "pageBreak" && block.kind !== "sectionBreak");
	if (index !== -1) return index;
	const baseBlockId = fragmentBlockId.replace(/-\d+$/, "");
	if (baseBlockId === fragmentBlockId) return -1;
	const matchingIndices = [];
	blocks.forEach((block, idx) => {
		if (block.id === baseBlockId && block.kind === "paragraph") matchingIndices.push(idx);
	});
	if (matchingIndices.length === 0) return -1;
	if (matchingIndices.length === 1) return matchingIndices[0];
	if (targetPmRange) for (const idx of matchingIndices) {
		const block = blocks[idx];
		if (block.kind !== "paragraph") continue;
		if (block.runs.some((run) => {
			if (run.pmStart == null || run.pmEnd == null) return false;
			return run.pmEnd > targetPmRange.from && run.pmStart < targetPmRange.to;
		})) return idx;
	}
	return matchingIndices[0];
}
const calculatePageTopFallback = (layout, pageIndex) => {
	const pageGap = layout.pageGap ?? 0;
	let y$1 = 0;
	for (let i = 0; i < pageIndex; i++) {
		const pageHeight = layout.pages[i]?.size?.h ?? layout.pageSize.h;
		y$1 += pageHeight + pageGap;
	}
	return y$1;
};
function hitTestPage(layout, point, geometryHelper) {
	if (geometryHelper) {
		const pageIndex = geometryHelper.getPageIndexAtY(point.y);
		if (pageIndex !== null) return {
			pageIndex,
			page: layout.pages[pageIndex]
		};
		const nearest = geometryHelper.getNearestPageIndex(point.y);
		if (nearest !== null) return {
			pageIndex: nearest,
			page: layout.pages[nearest]
		};
		return null;
	}
	const pageGap = layout.pageGap ?? 0;
	let cursorY = 0;
	let nearestIndex = null;
	let nearestDistance = Infinity;
	for (let pageIndex = 0; pageIndex < layout.pages.length; pageIndex += 1) {
		const page = layout.pages[pageIndex];
		const pageHeight = page.size?.h ?? layout.pageSize.h;
		const top$1 = cursorY;
		const bottom$1 = top$1 + pageHeight;
		if (point.y >= top$1 && point.y < bottom$1) return {
			pageIndex,
			page
		};
		const center = top$1 + pageHeight / 2;
		const distance = Math.abs(point.y - center);
		if (distance < nearestDistance) {
			nearestDistance = distance;
			nearestIndex = pageIndex;
		}
		cursorY = bottom$1 + pageGap;
	}
	if (nearestIndex !== null) return {
		pageIndex: nearestIndex,
		page: layout.pages[nearestIndex]
	};
	return null;
}
function hitTestFragment(layout, pageHit, blocks, measures, point) {
	const fragments = [...pageHit.page.fragments].sort((a, b$1) => {
		const ay = a.kind === "para" ? a.y : 0;
		const by = b$1.kind === "para" ? b$1.y : 0;
		if (Math.abs(ay - by) > .5) return ay - by;
		return (a.kind === "para" ? a.x : 0) - (b$1.kind === "para" ? b$1.x : 0);
	});
	for (const fragment of fragments) {
		if (fragment.kind !== "para") continue;
		const blockIndex = findBlockIndexByFragmentId(blocks, fragment.blockId);
		if (blockIndex === -1) continue;
		const block = blocks[blockIndex];
		const measure = measures[blockIndex];
		if (!block || block.kind !== "paragraph" || measure?.kind !== "paragraph") continue;
		const fragmentHeight = measure.lines.slice(fragment.fromLine, fragment.toLine).reduce((sum, line) => sum + line.lineHeight, 0);
		const withinX = point.x >= fragment.x && point.x <= fragment.x + fragment.width;
		const withinY = point.y >= fragment.y && point.y <= fragment.y + fragmentHeight;
		if (!withinX || !withinY) continue;
		return {
			fragment,
			block,
			measure,
			pageIndex: pageHit.pageIndex,
			pageY: point.y - fragment.y
		};
	}
	return null;
}
const hitTestAtomicFragment = (pageHit, blocks, measures, point) => {
	for (const fragment of pageHit.page.fragments) {
		if (!isAtomicFragment(fragment)) continue;
		const withinX = point.x >= fragment.x && point.x <= fragment.x + fragment.width;
		const withinY = point.y >= fragment.y && point.y <= fragment.y + fragment.height;
		if (!withinX || !withinY) continue;
		const blockIndex = findBlockIndexByFragmentId(blocks, fragment.blockId);
		if (blockIndex === -1) continue;
		const block = blocks[blockIndex];
		const measure = measures[blockIndex];
		if (!block || !measure) continue;
		return {
			fragment,
			block,
			measure,
			pageIndex: pageHit.pageIndex,
			pageY: 0
		};
	}
	return null;
};
const hitTestTableFragment = (pageHit, blocks, measures, point) => {
	for (const fragment of pageHit.page.fragments) {
		if (fragment.kind !== "table") continue;
		const tableFragment = fragment;
		const withinX = point.x >= tableFragment.x && point.x <= tableFragment.x + tableFragment.width;
		const withinY = point.y >= tableFragment.y && point.y <= tableFragment.y + tableFragment.height;
		if (!withinX || !withinY) continue;
		const blockIndex = blocks.findIndex((block$1) => block$1.id === tableFragment.blockId);
		if (blockIndex === -1) continue;
		const block = blocks[blockIndex];
		const measure = measures[blockIndex];
		if (!block || block.kind !== "table" || !measure || measure.kind !== "table") continue;
		const tableBlock = block;
		const tableMeasure = measure;
		const localX = point.x - tableFragment.x;
		const localY = point.y - tableFragment.y;
		let rowY = 0;
		let rowIndex = -1;
		if (tableMeasure.rows.length === 0 || tableBlock.rows.length === 0) continue;
		for (let r$1 = tableFragment.fromRow; r$1 < tableFragment.toRow && r$1 < tableMeasure.rows.length; r$1++) {
			const rowMeasure$1 = tableMeasure.rows[r$1];
			if (localY >= rowY && localY < rowY + rowMeasure$1.height) {
				rowIndex = r$1;
				break;
			}
			rowY += rowMeasure$1.height;
		}
		if (rowIndex === -1) {
			rowIndex = Math.min(tableFragment.toRow - 1, tableMeasure.rows.length - 1);
			if (rowIndex < tableFragment.fromRow) continue;
		}
		const rowMeasure = tableMeasure.rows[rowIndex];
		const row = tableBlock.rows[rowIndex];
		if (!rowMeasure || !row) continue;
		const firstCellGridStart = rowMeasure.cells[0]?.gridColumnStart ?? 0;
		let colX = 0;
		if (firstCellGridStart > 0 && tableMeasure.columnWidths) for (let col = 0; col < firstCellGridStart && col < tableMeasure.columnWidths.length; col++) colX += tableMeasure.columnWidths[col];
		const initialColX = colX;
		let colIndex = -1;
		if (rowMeasure.cells.length === 0 || row.cells.length === 0) continue;
		for (let c = 0; c < rowMeasure.cells.length; c++) {
			const cellMeasure$1 = rowMeasure.cells[c];
			if (localX >= colX && localX < colX + cellMeasure$1.width) {
				colIndex = c;
				break;
			}
			colX += cellMeasure$1.width;
		}
		if (colIndex === -1) {
			if (localX < initialColX) colIndex = 0;
			else colIndex = rowMeasure.cells.length - 1;
			if (colIndex < 0) continue;
		}
		const cellMeasure = rowMeasure.cells[colIndex];
		const cell = row.cells[colIndex];
		if (!cellMeasure || !cell) continue;
		const cellBlocks = cell.blocks ?? (cell.paragraph ? [cell.paragraph] : []);
		const rawMeasures = cellMeasure.blocks ?? (cellMeasure.paragraph ? [cellMeasure.paragraph] : []);
		const cellBlockMeasures = (Array.isArray(rawMeasures) ? rawMeasures : []).filter((m$1) => m$1 != null && typeof m$1 === "object" && "kind" in m$1);
		let blockStartY = 0;
		let blockStartGlobalLines = 0;
		const getBlockHeight = (m$1) => {
			if (!m$1) return 0;
			if ("totalHeight" in m$1 && typeof m$1.totalHeight === "number") return m$1.totalHeight;
			if ("height" in m$1 && typeof m$1.height === "number") return m$1.height;
			return 0;
		};
		let nearestParagraphHit = null;
		for (let i = 0; i < cellBlocks.length && i < cellBlockMeasures.length; i++) {
			const cellBlock = cellBlocks[i];
			const cellBlockMeasure = cellBlockMeasures[i];
			if (cellBlock?.kind !== "paragraph" || cellBlockMeasure?.kind !== "paragraph") {
				blockStartY += getBlockHeight(cellBlockMeasure);
				continue;
			}
			const blockHeight = getBlockHeight(cellBlockMeasure);
			const blockEndY = blockStartY + blockHeight;
			const padding = cell.attrs?.padding ?? {
				top: 0,
				left: 4,
				right: 4,
				bottom: 0
			};
			const cellLocalX = localX - colX - (padding.left ?? 4);
			const cellLocalY = localY - rowY - (padding.top ?? 0);
			const paragraphBlock = cellBlock;
			const paragraphMeasure = cellBlockMeasure;
			if (cellLocalY >= blockStartY && cellLocalY < blockEndY) {
				const unclampedLocalY = cellLocalY - blockStartY;
				const localYWithinBlock = Math.max(0, Math.min(unclampedLocalY, Math.max(blockHeight, 0)));
				return {
					fragment: tableFragment,
					block: tableBlock,
					measure: tableMeasure,
					pageIndex: pageHit.pageIndex,
					cellRowIndex: rowIndex,
					cellColIndex: colIndex,
					cellBlock: paragraphBlock,
					cellMeasure: paragraphMeasure,
					localX: Math.max(0, cellLocalX),
					localY: Math.max(0, localYWithinBlock),
					blockStartGlobal: blockStartGlobalLines
				};
			}
			const distanceToBlock = cellLocalY < blockStartY ? blockStartY - cellLocalY : Math.max(0, cellLocalY - blockEndY);
			if (!nearestParagraphHit || distanceToBlock < nearestParagraphHit.distance) {
				const unclampedLocalY = cellLocalY - blockStartY;
				nearestParagraphHit = {
					cellBlock: paragraphBlock,
					cellMeasure: paragraphMeasure,
					localX: Math.max(0, cellLocalX),
					localY: Math.max(0, Math.min(unclampedLocalY, Math.max(blockHeight, 0))),
					blockStartGlobal: blockStartGlobalLines,
					distance: distanceToBlock
				};
			}
			blockStartY = blockEndY;
			blockStartGlobalLines += paragraphMeasure.lines.length;
		}
		if (nearestParagraphHit) return {
			fragment: tableFragment,
			block: tableBlock,
			measure: tableMeasure,
			pageIndex: pageHit.pageIndex,
			cellRowIndex: rowIndex,
			cellColIndex: colIndex,
			cellBlock: nearestParagraphHit.cellBlock,
			cellMeasure: nearestParagraphHit.cellMeasure,
			localX: nearestParagraphHit.localX,
			localY: nearestParagraphHit.localY,
			blockStartGlobal: nearestParagraphHit.blockStartGlobal
		};
	}
	return null;
};
const resolveTextboxContentHit = (fragment, block, measure, pageIndex, point) => {
	const fragmentWithContent = fragment;
	const contentMeasures = Array.isArray(fragmentWithContent.contentMeasures) ? fragmentWithContent.contentMeasures : Array.isArray(block.contentMeasures) ? block.contentMeasures : [];
	const contentBlocks = Array.isArray(block.contentBlocks) ? block.contentBlocks : [];
	if (contentMeasures.length === 0 || contentBlocks.length === 0) return null;
	const insets = block.textInsets ?? {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0
	};
	const localX = Math.max(0, point.x - fragment.x - insets.left);
	const rawLocalY = point.y - fragment.y - insets.top;
	const totalContentHeight = contentMeasures.reduce((sum, m$1) => sum + (m$1?.kind === "paragraph" ? m$1.totalHeight ?? 0 : 0), 0);
	const availableHeight = Math.max(0, fragment.height - insets.top - insets.bottom);
	const verticalAlign = block.textVerticalAlign ?? "top";
	let contentOffset = 0;
	if (verticalAlign === "center") contentOffset = Math.max(0, (availableHeight - totalContentHeight) / 2);
	else if (verticalAlign === "bottom") contentOffset = Math.max(0, availableHeight - totalContentHeight);
	const localY = rawLocalY - contentOffset;
	let paragraphStartY = 0;
	let blockStartGlobal = 0;
	let nearestParagraphHit = null;
	for (let i = 0; i < contentBlocks.length && i < contentMeasures.length; i += 1) {
		const contentBlock = contentBlocks[i];
		const contentMeasure = contentMeasures[i];
		if (contentBlock?.kind !== "paragraph" || contentMeasure?.kind !== "paragraph") continue;
		const paragraphHeight = contentMeasure.totalHeight;
		const paragraphEndY = paragraphStartY + paragraphHeight;
		if (localY >= paragraphStartY && localY < paragraphEndY) return {
			fragment,
			block,
			measure,
			pageIndex,
			contentBlock,
			contentMeasure,
			paragraphIndex: i,
			localX,
			localY: Math.max(0, Math.min(localY - paragraphStartY, Math.max(paragraphHeight, 0))),
			blockStartGlobal
		};
		const distanceToParagraph = localY < paragraphStartY ? paragraphStartY - localY : Math.max(0, localY - paragraphEndY);
		if (!nearestParagraphHit || distanceToParagraph < nearestParagraphHit.distance) nearestParagraphHit = {
			contentBlock,
			contentMeasure,
			paragraphIndex: i,
			localX,
			localY: Math.max(0, Math.min(localY - paragraphStartY, Math.max(paragraphHeight, 0))),
			blockStartGlobal,
			distance: distanceToParagraph
		};
		paragraphStartY = paragraphEndY;
		blockStartGlobal += contentMeasure.lines.length;
	}
	if (nearestParagraphHit) return {
		fragment,
		block,
		measure,
		pageIndex,
		contentBlock: nearestParagraphHit.contentBlock,
		contentMeasure: nearestParagraphHit.contentMeasure,
		paragraphIndex: nearestParagraphHit.paragraphIndex,
		localX: nearestParagraphHit.localX,
		localY: nearestParagraphHit.localY,
		blockStartGlobal: nearestParagraphHit.blockStartGlobal
	};
	return null;
};
function resolvePositionHitFromDomPosition(layout, blocks, measures, domPos, layoutEpoch) {
	let blockId = "";
	let pageIndex = 0;
	let column = 0;
	let lineIndex = -1;
	for (let pi = 0; pi < layout.pages.length; pi++) {
		const page = layout.pages[pi];
		for (const fragment of page.fragments) if (fragment.kind === "para" && fragment.pmStart != null && fragment.pmEnd != null) {
			if (domPos >= fragment.pmStart && domPos <= fragment.pmEnd) {
				blockId = fragment.blockId;
				pageIndex = pi;
				column = determineColumn(layout, fragment.x, page, fragment.y);
				const blockIndex = findBlockIndexByFragmentId(blocks, fragment.blockId);
				if (blockIndex !== -1) {
					const measure = measures[blockIndex];
					if (measure && measure.kind === "paragraph") if (fragment.lines && fragment.lines.length > 0) for (let localIndex = 0; localIndex < fragment.lines.length; localIndex++) {
						const line = fragment.lines[localIndex];
						if (!line) continue;
						const range = computeLinePmRange$1(blocks[blockIndex], line);
						if (range.pmStart != null && range.pmEnd != null) {
							if (domPos >= range.pmStart && domPos <= range.pmEnd) {
								lineIndex = fragment.fromLine + localIndex;
								break;
							}
						}
					}
					else for (let li = fragment.fromLine; li < fragment.toLine; li++) {
						const line = measure.lines[li];
						if (!line) continue;
						const range = computeLinePmRange$1(blocks[blockIndex], line);
						if (range.pmStart != null && range.pmEnd != null) {
							if (domPos >= range.pmStart && domPos <= range.pmEnd) {
								lineIndex = li;
								break;
							}
						}
					}
				}
				return {
					pos: domPos,
					layoutEpoch,
					blockId,
					pageIndex,
					column,
					lineIndex
				};
			}
		}
	}
	return {
		pos: domPos,
		layoutEpoch,
		blockId: "",
		pageIndex: 0,
		column: 0,
		lineIndex: -1
	};
}
function clickToPositionGeometry(layout, blocks, measures, containerPoint, options) {
	const layoutEpoch = layout.layoutEpoch ?? 0;
	const geometryHelper = options?.geometryHelper;
	const pageHint = options?.pageHint;
	let pageHit = null;
	if (pageHint != null) {
		const pi = pageHint.pageIndex;
		if (pi >= 0 && pi < layout.pages.length) pageHit = {
			pageIndex: pi,
			page: layout.pages[pi]
		};
	}
	if (!pageHit) pageHit = hitTestPage(layout, containerPoint, geometryHelper);
	if (!pageHit) return null;
	const pageTopY = geometryHelper ? geometryHelper.getPageTop(pageHit.pageIndex) : calculatePageTopFallback(layout, pageHit.pageIndex);
	const pageRelativePoint = {
		x: containerPoint.x,
		y: pageHint?.pageRelativeY ?? containerPoint.y - pageTopY
	};
	let fragmentHit = hitTestFragment(layout, pageHit, blocks, measures, pageRelativePoint);
	if (!fragmentHit) {
		if (!pageHit.page.fragments.filter((f) => f.kind === "table").some((f) => {
			const tf = f;
			return pageRelativePoint.x >= tf.x && pageRelativePoint.x <= tf.x + tf.width && pageRelativePoint.y >= tf.y && pageRelativePoint.y <= tf.y + tf.height;
		})) fragmentHit = snapToNearestFragment(pageHit, blocks, measures, pageRelativePoint);
	}
	if (fragmentHit) {
		const { fragment, block, measure, pageIndex, pageY } = fragmentHit;
		if (fragment.kind === "para" && measure.kind === "paragraph" && block.kind === "paragraph") {
			const lines = fragment.lines ?? measure.lines.slice(fragment.fromLine, fragment.toLine);
			const lineIndex = findLineIndexAtY(lines, pageY, 0, lines.length);
			if (lineIndex == null) return null;
			const line = lines[lineIndex];
			const isRTL = isRtlBlock(block);
			const indentLeft = typeof block.attrs?.indent?.left === "number" ? block.attrs.indent.left : 0;
			const indentRight = typeof block.attrs?.indent?.right === "number" ? block.attrs.indent.right : 0;
			const totalIndent = (Number.isFinite(indentLeft) ? indentLeft : 0) + (Number.isFinite(indentRight) ? indentRight : 0);
			let availableWidth = Math.max(0, fragment.width - totalIndent);
			if (totalIndent > fragment.width) console.warn(`[clickToPosition] Paragraph indents (${totalIndent}px) exceed fragment width (${fragment.width}px) for block ${fragment.blockId}. This may indicate a layout miscalculation. Available width clamped to 0.`);
			const isListItem$1 = (fragment.markerWidth ?? measure.marker?.markerWidth ?? 0) > 0;
			const hasRenderedMarkerText = isListItem$1 && Boolean(fragment.markerTextWidth);
			if (lineIndex === 0 && !fragment.continuesFromPrev && !hasRenderedMarkerText) {
				const suppressFLI = block.attrs?.suppressFirstLineIndent === true;
				const firstLineOffset = getFirstLineIndentOffset(block.attrs?.indent, suppressFLI);
				availableWidth = adjustAvailableWidthForTextIndent(availableWidth, firstLineOffset, line.maxWidth);
			}
			const isJustified = block.attrs?.alignment === "justify";
			const alignmentOverride = isListItem$1 && !isJustified ? "left" : void 0;
			const pos = mapPointToPm(block, line, pageRelativePoint.x - fragment.x, isRTL, availableWidth, alignmentOverride);
			if (pos == null) return null;
			const column = determineColumn(layout, fragment.x, layout.pages[pageIndex], fragment.y);
			return {
				pos,
				layoutEpoch,
				blockId: fragment.blockId,
				pageIndex,
				column,
				lineIndex
			};
		}
		if (fragment.kind === "drawing" && fragment.drawingKind === "textboxShape" && block.kind === "drawing" && block.drawingKind === "textboxShape") {
			const textboxHit = resolveTextboxContentHit(fragment, block, measure, pageIndex, pageRelativePoint);
			if (textboxHit) {
				const { contentBlock, contentMeasure, localX, localY, pageIndex: pageIndex$1, paragraphIndex } = textboxHit;
				const lineIndex = findLineIndexAtY(contentMeasure.lines, localY, 0, contentMeasure.lines.length);
				if (lineIndex != null) {
					const line = contentMeasure.lines[lineIndex];
					const isRTL = isRtlBlock(contentBlock);
					const indentLeft = typeof contentBlock.attrs?.indent?.left === "number" ? contentBlock.attrs.indent.left : 0;
					const indentRight = typeof contentBlock.attrs?.indent?.right === "number" ? contentBlock.attrs.indent.right : 0;
					const totalIndent = (Number.isFinite(indentLeft) ? indentLeft : 0) + (Number.isFinite(indentRight) ? indentRight : 0);
					const insets = textboxHit.block.textInsets ?? {
						top: 0,
						right: 0,
						bottom: 0,
						left: 0
					};
					let availableWidth = Math.max(0, textboxHit.fragment.width - insets.left - insets.right - totalIndent);
					if (totalIndent > textboxHit.fragment.width) console.warn(`[clickToPosition:textbox] Paragraph indents (${totalIndent}px) exceed fragment width (${textboxHit.fragment.width}px) for block ${textboxHit.fragment.blockId}. This may indicate a layout miscalculation. Available width clamped to 0.`);
					if (lineIndex === 0) {
						const suppressFLI = contentBlock.attrs?.suppressFirstLineIndent === true;
						const firstLineOffset = getFirstLineIndentOffset(contentBlock.attrs?.indent, suppressFLI);
						availableWidth = adjustAvailableWidthForTextIndent(availableWidth, firstLineOffset, line.maxWidth);
					}
					const pos = mapPointToPm(contentBlock, line, localX, isRTL, availableWidth);
					if (pos != null) return {
						pos,
						layoutEpoch,
						blockId: textboxHit.fragment.blockId,
						pageIndex: pageIndex$1,
						column: determineColumn(layout, textboxHit.fragment.x, layout.pages[pageIndex$1], textboxHit.fragment.y),
						lineIndex
					};
				}
				const firstRun = contentBlock.runs?.[0];
				if (firstRun && firstRun.pmStart != null) return {
					pos: firstRun.pmStart,
					layoutEpoch,
					blockId: textboxHit.fragment.blockId,
					pageIndex: pageIndex$1,
					column: determineColumn(layout, textboxHit.fragment.x, layout.pages[pageIndex$1], textboxHit.fragment.y),
					lineIndex: 0
				};
			}
		}
		if (isAtomicFragment(fragment)) {
			const pmRange = getAtomicPmRange(fragment, block);
			const pos = pmRange.pmStart ?? pmRange.pmEnd ?? null;
			if (pos == null) return null;
			return {
				pos,
				layoutEpoch,
				blockId: fragment.blockId,
				pageIndex,
				column: determineColumn(layout, fragment.x, layout.pages[pageIndex], fragment.y),
				lineIndex: -1
			};
		}
	}
	const tableHit = hitTestTableFragment(pageHit, blocks, measures, pageRelativePoint);
	if (tableHit) {
		const { cellBlock, cellMeasure, localX, localY, pageIndex } = tableHit;
		const lineIndex = findLineIndexAtY(cellMeasure.lines, localY, 0, cellMeasure.lines.length);
		if (lineIndex != null) {
			const line = cellMeasure.lines[lineIndex];
			const isRTL = isRtlBlock(cellBlock);
			const indentLeft = typeof cellBlock.attrs?.indent?.left === "number" ? cellBlock.attrs.indent.left : 0;
			const indentRight = typeof cellBlock.attrs?.indent?.right === "number" ? cellBlock.attrs.indent.right : 0;
			const totalIndent = (Number.isFinite(indentLeft) ? indentLeft : 0) + (Number.isFinite(indentRight) ? indentRight : 0);
			let availableWidth = Math.max(0, tableHit.fragment.width - totalIndent);
			if (totalIndent > tableHit.fragment.width) console.warn(`[clickToPosition:table] Paragraph indents (${totalIndent}px) exceed fragment width (${tableHit.fragment.width}px) for block ${tableHit.fragment.blockId}. This may indicate a layout miscalculation. Available width clamped to 0.`);
			const isListItem$1 = (cellMeasure.marker?.markerWidth ?? 0) > 0;
			const cellLineStart = tableHit.fragment.partialRow?.fromLineByCell?.[tableHit.cellColIndex] ?? 0;
			const localStartLine = Math.max(0, cellLineStart - tableHit.blockStartGlobal);
			if (lineIndex === 0 && localStartLine === 0 && !isListItem$1) {
				const suppressFLI = cellBlock.attrs?.suppressFirstLineIndent === true;
				const firstLineOffset = getFirstLineIndentOffset(cellBlock.attrs?.indent, suppressFLI);
				availableWidth = adjustAvailableWidthForTextIndent(availableWidth, firstLineOffset, line.maxWidth);
			}
			const isJustified = cellBlock.attrs?.alignment === "justify";
			const pos = mapPointToPm(cellBlock, line, localX, isRTL, availableWidth, isListItem$1 && !isJustified ? "left" : void 0);
			if (pos != null) return {
				pos,
				layoutEpoch,
				blockId: tableHit.fragment.blockId,
				pageIndex,
				column: determineTableColumn(layout, tableHit.fragment, layout.pages[pageIndex]),
				lineIndex
			};
		}
		const fallbackPos = (cellBlock.runs?.[0])?.pmStart ?? blockPmRangeFromAttrs(cellBlock).pmStart;
		if (fallbackPos != null) return {
			pos: fallbackPos,
			layoutEpoch,
			blockId: tableHit.fragment.blockId,
			pageIndex,
			column: determineTableColumn(layout, tableHit.fragment, layout.pages[pageIndex]),
			lineIndex: 0
		};
	}
	const atomicHit = hitTestAtomicFragment(pageHit, blocks, measures, pageRelativePoint);
	if (atomicHit && isAtomicFragment(atomicHit.fragment)) {
		const { fragment, block, pageIndex } = atomicHit;
		const pmRange = getAtomicPmRange(fragment, block);
		const pos = pmRange.pmStart ?? pmRange.pmEnd ?? null;
		if (pos == null) return null;
		return {
			pos,
			layoutEpoch,
			blockId: fragment.blockId,
			pageIndex,
			column: determineColumn(layout, fragment.x, layout.pages[pageIndex], fragment.y),
			lineIndex: -1
		};
	}
	return null;
}
(() => {
	const chars = [];
	for (let i = 32; i <= 126; i++) chars.push(String.fromCharCode(i));
	return chars;
})();
var PageGeometryHelper = class {
	constructor(config) {
		this.cache = null;
		this.config = config;
	}
	updateLayout(layout, pageGap) {
		this.config.layout = layout;
		if (pageGap !== void 0) this.config.pageGap = pageGap;
		this.cache = null;
	}
	updatePageGap(pageGap) {
		if (this.config.pageGap !== pageGap) {
			this.config.pageGap = pageGap;
			this.cache = null;
		}
	}
	getPageTop(pageIndex) {
		this.ensureCache();
		if (pageIndex < 0 || pageIndex >= this.cache.cumulativeY.length) return 0;
		return this.cache.cumulativeY[pageIndex];
	}
	getPageHeight(pageIndex) {
		this.ensureCache();
		if (pageIndex < 0 || pageIndex >= this.cache.pageHeights.length) return 0;
		return this.cache.pageHeights[pageIndex];
	}
	getPageGap() {
		this.ensureCache();
		return this.cache.pageGap;
	}
	getTotalHeight() {
		this.ensureCache();
		return this.cache.totalHeight;
	}
	getPageCount() {
		return this.config.layout.pages.length;
	}
	getPageIndexAtY(containerY) {
		this.ensureCache();
		const cache$2 = this.cache;
		for (let i = 0; i < cache$2.cumulativeY.length; i++) {
			const pageTop = cache$2.cumulativeY[i];
			const pageBottom = pageTop + cache$2.pageHeights[i];
			if (containerY >= pageTop && containerY < pageBottom) return i;
		}
		return null;
	}
	getNearestPageIndex(containerY) {
		this.ensureCache();
		const cache$2 = this.cache;
		const pageCount = cache$2.pageHeights.length;
		if (pageCount === 0) return null;
		const direct = this.getPageIndexAtY(containerY);
		if (direct !== null) return direct;
		let nearestIndex = 0;
		let nearestDistance = Infinity;
		for (let i = 0; i < pageCount; i++) {
			const center = cache$2.cumulativeY[i] + cache$2.pageHeights[i] / 2;
			const distance = Math.abs(containerY - center);
			if (distance < nearestDistance) {
				nearestDistance = distance;
				nearestIndex = i;
			}
		}
		return nearestIndex;
	}
	ensureCache() {
		if (this.cache !== null) if (!Array.isArray(this.cache.cumulativeY) || !Array.isArray(this.cache.pageHeights)) {
			console.warn("[PageGeometryHelper] Cache corruption detected, rebuilding cache");
			this.cache = null;
		} else return;
		this.buildCache();
	}
	buildCache() {
		try {
			const layout = this.config.layout;
			if (!layout || !Array.isArray(layout.pages)) throw new Error("Invalid layout: missing or invalid pages array");
			const pageGap = this.config.pageGap ?? layout.pageGap ?? 0;
			const pageCount = layout.pages.length;
			if (!Number.isFinite(pageGap) || pageGap < 0) throw new Error(`Invalid pageGap: ${pageGap} (must be non-negative finite number)`);
			const cumulativeY = new Array(pageCount);
			const pageHeights = new Array(pageCount);
			let currentY = 0;
			for (let i = 0; i < pageCount; i++) {
				const page = layout.pages[i];
				if (!page) throw new Error(`Invalid page at index ${i}: page is null or undefined`);
				const pageHeight = page.size?.h ?? layout.pageSize.h;
				if (!Number.isFinite(pageHeight) || pageHeight < 0) throw new Error(`Invalid page height at index ${i}: ${pageHeight} (must be non-negative finite number)`);
				cumulativeY[i] = currentY;
				pageHeights[i] = pageHeight;
				currentY += pageHeight;
				if (i < pageCount - 1) currentY += pageGap;
			}
			this.cache = {
				cumulativeY,
				pageHeights,
				pageGap,
				totalHeight: currentY,
				layoutVersion: 0
			};
		} catch (error) {
			const errorMessage = error instanceof Error ? error.message : String(error);
			console.error(`[PageGeometryHelper] Cache build failed: ${errorMessage}. Using fallback empty cache.`);
			this.cache = {
				cumulativeY: [],
				pageHeights: [],
				pageGap: 0,
				totalHeight: 0,
				layoutVersion: 0
			};
		}
	}
	clearCache() {
		this.cache = null;
	}
	getDebugInfo() {
		this.ensureCache();
		return {
			isCached: this.cache !== null,
			pageCount: this.config.layout.pages.length,
			pageGap: this.cache.pageGap,
			totalHeight: this.cache.totalHeight,
			cumulativeY: [...this.cache.cumulativeY],
			pageHeights: [...this.cache.pageHeights]
		};
	}
};
function calculateSummary(samples) {
	if (samples.length === 0) return {
		count: 0,
		min: 0,
		max: 0,
		avg: 0,
		p50: 0,
		p95: 0,
		p99: 0
	};
	const values = samples.map((s) => s.value).sort((a, b$1) => a - b$1);
	const count = values.length;
	const sum = values.reduce((acc, v) => acc + v, 0);
	return {
		count,
		min: values[0],
		max: values[count - 1],
		avg: sum / count,
		p50: percentile(values, .5),
		p95: percentile(values, .95),
		p99: percentile(values, .99)
	};
}
function percentile(sortedValues, p$1) {
	if (sortedValues.length === 0) return 0;
	if (sortedValues.length === 1) return sortedValues[0];
	const index = (sortedValues.length - 1) * p$1;
	const lower = Math.floor(index);
	const upper = Math.ceil(index);
	const weight = index - lower;
	return sortedValues[lower] * (1 - weight) + sortedValues[upper] * weight;
}
var PerformanceMetricsCollector = class {
	constructor(budgets, maxSamples = 1e3) {
		this.maxSamples = maxSamples;
		this.budgets = budgets || {};
		this.metrics = {
			cursorUpdateLatency: [],
			p0LayoutDuration: [],
			p1LayoutDuration: [],
			workerRoundTrip: [],
			layoutStaleness: [],
			geometryFallbackRate: [],
			cacheMissRate: [],
			droppedEvents: []
		};
	}
	record(metric, value, context) {
		const sample = {
			timestamp: Date.now(),
			value,
			context
		};
		this.metrics[metric].push(sample);
		if (this.metrics[metric].length > this.maxSamples) this.metrics[metric].shift();
	}
	startTimer(metric) {
		const startTime = performance.now();
		return () => {
			const duration = performance.now() - startTime;
			this.record(metric, duration);
		};
	}
	getSummary(metric) {
		return calculateSummary(this.metrics[metric]);
	}
	getAllSummaries() {
		return {
			cursorUpdateLatency: this.getSummary("cursorUpdateLatency"),
			p0LayoutDuration: this.getSummary("p0LayoutDuration"),
			p1LayoutDuration: this.getSummary("p1LayoutDuration"),
			workerRoundTrip: this.getSummary("workerRoundTrip"),
			layoutStaleness: this.getSummary("layoutStaleness"),
			geometryFallbackRate: this.getSummary("geometryFallbackRate"),
			cacheMissRate: this.getSummary("cacheMissRate"),
			droppedEvents: this.getSummary("droppedEvents")
		};
	}
	checkBudgets() {
		const violations = [];
		for (const [metric, budget] of Object.entries(this.budgets)) {
			const summary = this.getSummary(metric);
			if (summary.count > 0 && summary.p95 > budget) violations.push({
				metric,
				value: summary.p95,
				budget
			});
		}
		return violations;
	}
	export() {
		return {
			cursorUpdateLatency: [...this.metrics.cursorUpdateLatency],
			p0LayoutDuration: [...this.metrics.p0LayoutDuration],
			p1LayoutDuration: [...this.metrics.p1LayoutDuration],
			workerRoundTrip: [...this.metrics.workerRoundTrip],
			layoutStaleness: [...this.metrics.layoutStaleness],
			geometryFallbackRate: [...this.metrics.geometryFallbackRate],
			cacheMissRate: [...this.metrics.cacheMissRate],
			droppedEvents: [...this.metrics.droppedEvents]
		};
	}
	clear() {
		for (const metric of Object.keys(this.metrics)) this.metrics[metric] = [];
	}
};
new PerformanceMetricsCollector({
	cursorUpdateLatency: 2,
	p0LayoutDuration: 5,
	p1LayoutDuration: 50,
	workerRoundTrip: 10,
	layoutStaleness: 100
});
var logSelectionMapDebug = (payload) => {};
var rangesOverlap = (startA, endA, startB, endB) => {
	if (startA == null) return false;
	return (endA ?? startA + 1) > startB && startA < endB;
};
var DEFAULT_CELL_PADDING$2 = {
	top: 0,
	bottom: 0,
	left: 4,
	right: 4
};
var getCellPaddingFromRow = (cellIdx, row) => {
	const padding = row?.cells?.[cellIdx]?.attrs?.padding ?? {};
	return {
		top: padding.top ?? DEFAULT_CELL_PADDING$2.top,
		bottom: padding.bottom ?? DEFAULT_CELL_PADDING$2.bottom,
		left: padding.left ?? DEFAULT_CELL_PADDING$2.left,
		right: padding.right ?? DEFAULT_CELL_PADDING$2.right
	};
};
var getCellBlocks = (cell) => {
	if (!cell) return [];
	return cell.blocks ?? (cell.paragraph ? [cell.paragraph] : []);
};
var getCellMeasures = (cell) => {
	if (!cell) return [];
	return cell.blocks ?? (cell.paragraph ? [cell.paragraph] : []);
};
var countBlockSegments = (measure) => {
	if (measure.kind === "paragraph") return measure.lines?.length ?? 0;
	if (measure.kind === "table") {
		let count = 0;
		for (const row of measure.rows) count += getEmbeddedRowLines(row).length;
		return count;
	}
	return (typeof measure.height === "number" ? measure.height : 0) > 0 ? 1 : 0;
};
var sumLineHeights = (measure, fromLine, toLine) => {
	let height = 0;
	for (let i = fromLine; i < toLine && i < measure.lines.length; i += 1) height += measure.lines[i]?.lineHeight ?? 0;
	return height;
};
function pushEmptyLineSelectionBand(rects, opts) {
	const lineOffset = sumLineHeights(opts.measure, opts.startLineIndex, opts.lineIndex);
	rects.push({
		x: opts.x,
		y: opts.yBase + lineOffset,
		width: Math.max(1, opts.width),
		height: opts.lineHeight,
		pageIndex: opts.pageIndex
	});
}
function selectionToRects(layout, blocks, measures, from$1, to, geometryHelper) {
	if (from$1 === to) return [];
	const rects = [];
	layout.pages.forEach((page, pageIndex) => {
		const pageTopY = geometryHelper ? geometryHelper.getPageTop(pageIndex) : calculatePageTopFallback(layout, pageIndex);
		page.fragments.forEach((fragment) => {
			if (fragment.kind === "para") {
				const blockIndex = findBlockIndexByFragmentId(blocks, fragment.blockId, {
					from: from$1,
					to
				});
				if (blockIndex === -1) return;
				const block = blocks[blockIndex];
				const measure = measures[blockIndex];
				if (!block || block.kind !== "paragraph" || measure?.kind !== "paragraph") return;
				findLinesIntersectingRange(block, measure, from$1, to).forEach(({ line, index }) => {
					if (index < fragment.fromLine || index >= fragment.toLine) return;
					const range = computeLinePmRange(block, line);
					if (range.pmStart == null || range.pmEnd == null) return;
					const sliceFrom = Math.max(range.pmStart, from$1);
					const sliceTo = Math.min(range.pmEnd, to);
					if (sliceFrom >= sliceTo) {
						pushEmptyLineSelectionBand(rects, {
							x: fragment.x,
							yBase: fragment.y + pageTopY,
							width: fragment.width,
							lineHeight: line.lineHeight,
							pageIndex,
							measure,
							lineIndex: index,
							startLineIndex: fragment.fromLine
						});
						return;
					}
					pmPosToCharOffset(block, line, sliceFrom);
					pmPosToCharOffset(block, line, sliceTo);
					const visualCharOffsetFrom = pmPosToVisualCharOffset(block, line, sliceFrom);
					const visualCharOffsetTo = pmPosToVisualCharOffset(block, line, sliceTo);
					const markerWidth = fragment.markerWidth ?? measure.marker?.markerWidth ?? 0;
					const isListItemFlag = isListItem(markerWidth, block);
					const isJustified = block.attrs?.alignment === "justify";
					const alignmentOverride = isListItemFlag && !isJustified ? "left" : void 0;
					const isFirstLine = index === fragment.fromLine && !fragment.continuesFromPrev;
					const fragmentMarkerTextWidth = fragment.markerTextWidth ?? measure.marker?.markerTextWidth ?? void 0;
					const startX = mapPmToX(block, line, visualCharOffsetFrom, fragment.width, alignmentOverride, isFirstLine, fragmentMarkerTextWidth);
					const endX = mapPmToX(block, line, visualCharOffsetTo, fragment.width, alignmentOverride, isFirstLine, fragmentMarkerTextWidth);
					const indent = extractParagraphIndent(block.attrs?.indent);
					const wordLayout = getWordLayoutConfig(block);
					const indentAdjust = calculateTextStartIndent({
						isFirstLine,
						isListItem: isListItemFlag,
						markerWidth,
						markerTextWidth: fragmentMarkerTextWidth,
						paraIndentLeft: indent.left,
						firstLineIndent: indent.firstLine,
						hangingIndent: indent.hanging,
						wordLayout
					});
					const rectX = fragment.x + indentAdjust + Math.min(startX, endX);
					const rectWidth = Math.max(1, Math.min(Math.abs(endX - startX), line.width));
					const lineOffset = lineHeightBeforeIndex$1(measure, index) - lineHeightBeforeIndex$1(measure, fragment.fromLine);
					const rectY = fragment.y + lineOffset;
					rects.push({
						x: rectX,
						y: rectY + pageTopY,
						width: rectWidth,
						height: line.lineHeight,
						pageIndex
					});
				});
				return;
			}
			if (fragment.kind === "table") {
				const blockIndex = findBlockIndexByFragmentId(blocks, fragment.blockId, {
					from: from$1,
					to
				});
				if (blockIndex === -1) return;
				const block = blocks[blockIndex];
				const measure = measures[blockIndex];
				if (!block || block.kind !== "table" || measure?.kind !== "table") return;
				const tableBlock = block;
				const tableMeasure = measure;
				const tableFragment = fragment;
				const rowHeights = tableMeasure.rows.map((rowMeasure, idx) => {
					if (tableFragment.partialRow && tableFragment.partialRow.rowIndex === idx) return tableFragment.partialRow.partialHeight;
					return rowMeasure?.height ?? 0;
				});
				const cellSpacingPx = tableMeasure.cellSpacingPx ?? 0;
				const tableBorderWidths = tableMeasure.tableBorderWidths;
				const contentOffsetX = tableBlock.attrs?.borderCollapse === "separate" ? tableBorderWidths?.left ?? 0 : 0;
				const contentOffsetY = tableBlock.attrs?.borderCollapse === "separate" ? tableBorderWidths?.top ?? 0 : 0;
				const calculateCellX = (cellIdx, cellMeasure) => {
					const gridStart = cellMeasure.gridColumnStart ?? cellIdx;
					let x = cellSpacingPx;
					for (let i = 0; i < gridStart && i < tableMeasure.columnWidths.length; i += 1) x += tableMeasure.columnWidths[i] + cellSpacingPx;
					return x;
				};
				const processRow = (rowIndex, rowOffset) => {
					const rowMeasure = tableMeasure.rows[rowIndex];
					const row = tableBlock.rows[rowIndex];
					if (!rowMeasure || !row) return rowOffset;
					const rowHeight = rowHeights[rowIndex] ?? rowMeasure.height;
					const partialRowData = tableFragment.partialRow?.rowIndex === rowIndex ? tableFragment.partialRow : null;
					const totalColumns = Math.min(rowMeasure.cells.length, row.cells.length);
					for (let cellIdx = 0; cellIdx < totalColumns; cellIdx += 1) {
						const cellMeasure = rowMeasure.cells[cellIdx];
						const cell = row.cells[cellIdx];
						if (!cellMeasure || !cell) continue;
						const padding = getCellPaddingFromRow(cellIdx, row);
						const cellX = calculateCellX(cellIdx, cellMeasure);
						const cellBlocks = getCellBlocks(cell);
						const cellBlockMeasures = getCellMeasures(cellMeasure);
						const cellRenderBlocks = describeCellRenderBlocks(cellMeasure, cell, padding);
						const totalCellLines = cellRenderBlocks.length > 0 ? cellRenderBlocks[cellRenderBlocks.length - 1].globalEndLine : 0;
						const cellAllowedStart = partialRowData?.fromLineByCell?.[cellIdx] ?? 0;
						const rawCellAllowedEnd = partialRowData?.toLineByCell?.[cellIdx];
						const cellAllowedEnd = rawCellAllowedEnd == null || rawCellAllowedEnd === -1 ? totalCellLines : rawCellAllowedEnd;
						const renderedBlocks = [];
						let cumulativeLine = 0;
						const blockCount = Math.min(cellBlocks.length, cellBlockMeasures.length);
						for (let i = 0; i < blockCount; i += 1) {
							const paraBlock = cellBlocks[i];
							const paraMeasure = cellBlockMeasures[i];
							if (!paraBlock || !paraMeasure || paraBlock.kind !== "paragraph" || paraMeasure.kind !== "paragraph") {
								if (paraMeasure) cumulativeLine += countBlockSegments(paraMeasure);
								continue;
							}
							const lineCount = paraMeasure.lines.length;
							const blockStart = cumulativeLine;
							const blockEnd = cumulativeLine + lineCount;
							cumulativeLine = blockEnd;
							const renderStartGlobal = Math.max(blockStart, cellAllowedStart);
							const renderEndGlobal = Math.min(blockEnd, cellAllowedEnd);
							if (renderStartGlobal >= renderEndGlobal) continue;
							const startLine = renderStartGlobal - blockStart;
							const endLine = renderEndGlobal - blockStart;
							let height = sumLineHeights(paraMeasure, startLine, endLine);
							if (startLine === 0 && endLine >= lineCount) {
								const totalHeight = paraMeasure.totalHeight;
								if (typeof totalHeight === "number" && totalHeight > height) height = totalHeight;
								const isFirstBlock = i === 0;
								const spacingBefore = paraBlock.attrs?.spacing?.before;
								height += effectiveTableCellSpacing(spacingBefore, isFirstBlock, padding.top);
								if (!(i === blockCount - 1)) {
									const spacingAfter = paraBlock.attrs?.spacing?.after;
									if (typeof spacingAfter === "number" && spacingAfter > 0) height += spacingAfter;
								}
							}
							renderedBlocks.push({
								block: paraBlock,
								measure: paraMeasure,
								startLine,
								endLine,
								height,
								originalBlockIndex: i,
								globalBlockStart: blockStart
							});
						}
						const contentHeight = computeCellSliceContentHeight(cellRenderBlocks, cellAllowedStart, cellAllowedEnd);
						const contentAreaHeight = Math.max(0, rowHeight - (padding.top + padding.bottom));
						const freeSpace = Math.max(0, contentAreaHeight - contentHeight);
						let verticalOffset = 0;
						const vAlign = cell.attrs?.verticalAlign;
						if (vAlign === "center" || vAlign === "middle") verticalOffset = freeSpace / 2;
						else if (vAlign === "bottom") verticalOffset = freeSpace;
						let blockTopCursor = padding.top + verticalOffset;
						let prevBlockGlobalEndLine = cellAllowedStart;
						renderedBlocks.forEach((info) => {
							for (const rb of cellRenderBlocks) {
								if (rb.kind === "paragraph") continue;
								if (rb.visibleHeight === 0) continue;
								if (rb.globalEndLine <= prevBlockGlobalEndLine) continue;
								if (rb.globalStartLine >= info.globalBlockStart) break;
								const localStart = Math.max(0, cellAllowedStart - rb.globalStartLine);
								const localEnd = Math.min(rb.lineHeights.length, cellAllowedEnd - rb.globalStartLine);
								for (let li = localStart; li < localEnd; li++) blockTopCursor += rb.lineHeights[li];
							}
							const paragraphMarkerWidth = info.measure.marker?.markerWidth ?? 0;
							const cellIsListItem = isListItem(paragraphMarkerWidth, info.block);
							const alignmentOverride = cellIsListItem ? "left" : void 0;
							const cellIndent = extractParagraphIndent(info.block.kind === "paragraph" ? info.block.attrs?.indent : void 0);
							const cellWordLayout = getWordLayoutConfig(info.block);
							const intersectingLines = findLinesIntersectingRange(info.block, info.measure, from$1, to);
							const rawSpacingBefore = info.block.attrs?.spacing?.before;
							const effectiveSpacingBeforePx = info.startLine === 0 ? effectiveTableCellSpacing(rawSpacingBefore, info.originalBlockIndex === 0, padding.top) : 0;
							intersectingLines.forEach(({ line, index }) => {
								if (index < info.startLine || index >= info.endLine) return;
								const range = computeLinePmRange(info.block, line);
								if (range.pmStart == null || range.pmEnd == null) return;
								const sliceFrom = Math.max(range.pmStart, from$1);
								const sliceTo = Math.min(range.pmEnd, to);
								if (sliceFrom >= sliceTo) {
									pushEmptyLineSelectionBand(rects, {
										x: fragment.x + contentOffsetX + cellX + padding.left,
										yBase: fragment.y + contentOffsetY + rowOffset + blockTopCursor + effectiveSpacingBeforePx + pageTopY,
										width: cellMeasure.width - padding.left - padding.right,
										lineHeight: line.lineHeight,
										pageIndex,
										measure: info.measure,
										lineIndex: index,
										startLineIndex: info.startLine
									});
									return;
								}
								pmPosToCharOffset(info.block, line, sliceFrom);
								pmPosToCharOffset(info.block, line, sliceTo);
								const visualCharOffsetFrom = pmPosToVisualCharOffset(info.block, line, sliceFrom);
								const visualCharOffsetTo = pmPosToVisualCharOffset(info.block, line, sliceTo);
								const availableWidth = Math.max(1, cellMeasure.width - padding.left - padding.right);
								const isFirstLine = index === 0;
								const cellMarkerTextWidth = info.measure?.marker?.markerTextWidth ?? void 0;
								const startX = mapPmToX(info.block, line, visualCharOffsetFrom, availableWidth, alignmentOverride, isFirstLine, cellMarkerTextWidth);
								const endX = mapPmToX(info.block, line, visualCharOffsetTo, availableWidth, alignmentOverride, isFirstLine, cellMarkerTextWidth);
								const textIndentAdjust = calculateTextStartIndent({
									isFirstLine,
									isListItem: cellIsListItem,
									markerWidth: paragraphMarkerWidth,
									markerTextWidth: cellMarkerTextWidth,
									paraIndentLeft: cellIndent.left,
									firstLineIndent: cellIndent.firstLine,
									hangingIndent: cellIndent.hanging,
									wordLayout: cellWordLayout
								});
								const rectX = fragment.x + contentOffsetX + cellX + padding.left + textIndentAdjust + Math.min(startX, endX);
								const rectWidth = Math.max(1, Math.min(Math.abs(endX - startX), line.width));
								const lineOffset = lineHeightBeforeIndex$1(info.measure, index) - lineHeightBeforeIndex$1(info.measure, info.startLine);
								const rectY = fragment.y + contentOffsetY + rowOffset + blockTopCursor + effectiveSpacingBeforePx + lineOffset;
								rects.push({
									x: rectX,
									y: rectY + pageTopY,
									width: rectWidth,
									height: line.lineHeight,
									pageIndex
								});
							});
							blockTopCursor += info.height;
							prevBlockGlobalEndLine = info.globalBlockStart + info.endLine;
						});
					}
					return rowOffset + rowHeight;
				};
				let rowCursor = cellSpacingPx;
				const repeatHeaderCount = tableFragment.repeatHeaderCount ?? 0;
				for (let r$1 = 0; r$1 < repeatHeaderCount && r$1 < tableMeasure.rows.length; r$1 += 1) {
					rowCursor = processRow(r$1, rowCursor);
					rowCursor += cellSpacingPx;
				}
				for (let r$1 = tableFragment.fromRow; r$1 < tableFragment.toRow && r$1 < tableMeasure.rows.length; r$1 += 1) {
					rowCursor = processRow(r$1, rowCursor);
					rowCursor += cellSpacingPx;
				}
				return;
			}
			if (isAtomicFragment(fragment)) {
				const blockIndex = findBlockIndexByFragmentId(blocks, fragment.blockId, {
					from: from$1,
					to
				});
				if (blockIndex === -1) return;
				const block = blocks[blockIndex];
				const pmRange = getAtomicPmRange(fragment, block);
				if (!rangesOverlap(pmRange.pmStart, pmRange.pmEnd, from$1, to)) return;
				rects.push({
					x: fragment.x,
					y: fragment.y + pageTopY,
					width: fragment.width,
					height: fragment.height,
					pageIndex
				});
			}
		});
	});
	return rects;
}
function getFragmentAtPosition(layout, blocks, measures, pos) {
	for (let pageIndex = 0; pageIndex < layout.pages.length; pageIndex += 1) {
		const page = layout.pages[pageIndex];
		for (const fragment of page.fragments) {
			const blockIndex = findBlockIndexByFragmentId(blocks, fragment.blockId);
			if (blockIndex === -1) continue;
			const block = blocks[blockIndex];
			const measure = measures[blockIndex];
			if (!block || !measure) continue;
			if (fragment.kind === "para") {
				if (block.kind !== "paragraph" || measure.kind !== "paragraph") continue;
				if (fragment.pmStart != null && fragment.pmEnd != null && pos >= fragment.pmStart && pos <= fragment.pmEnd) return {
					fragment,
					block,
					measure,
					pageIndex,
					pageY: 0
				};
				continue;
			}
			if (fragment.kind === "table") {
				if (block.kind !== "table" || measure.kind !== "table") continue;
				const tableBlock = block;
				const tableFragment = fragment;
				let tableMinPos = null;
				let tableMaxPos = null;
				for (let r$1 = tableFragment.fromRow; r$1 < tableFragment.toRow && r$1 < tableBlock.rows.length; r$1++) {
					const row = tableBlock.rows[r$1];
					for (const cell of row.cells) {
						const cellBlocks = cell.blocks ?? (cell.paragraph ? [cell.paragraph] : []);
						for (const cellBlock of cellBlocks) if (cellBlock?.kind === "paragraph") {
							const paraBlock = cellBlock;
							for (const run of paraBlock.runs ?? []) {
								if (run.pmStart != null) {
									if (tableMinPos === null || run.pmStart < tableMinPos) tableMinPos = run.pmStart;
									if (tableMaxPos === null || run.pmStart > tableMaxPos) tableMaxPos = run.pmStart;
								}
								if (run.pmEnd != null) {
									if (tableMinPos === null || run.pmEnd < tableMinPos) tableMinPos = run.pmEnd;
									if (tableMaxPos === null || run.pmEnd > tableMaxPos) tableMaxPos = run.pmEnd;
								}
							}
						}
					}
				}
				if (tableMinPos != null && tableMaxPos != null && pos >= tableMinPos && pos <= tableMaxPos) return {
					fragment,
					block,
					measure,
					pageIndex,
					pageY: 0
				};
				continue;
			}
			if (isAtomicFragment(fragment)) {
				const { pmStart, pmEnd } = getAtomicPmRange(fragment, block);
				const start$1 = pmStart ?? pmEnd;
				const end$1 = pmEnd ?? pmStart;
				if (start$1 == null || end$1 == null) continue;
				if (pos >= Math.min(start$1, end$1) && pos <= Math.max(start$1, end$1)) return {
					fragment,
					block,
					measure,
					pageIndex,
					pageY: 0
				};
			}
		}
	}
	return null;
}
function findLinesIntersectingRange(block, measure, from$1, to) {
	if (block.kind !== "paragraph" || measure.kind !== "paragraph") return [];
	const hits = [];
	measure.lines.forEach((line, idx) => {
		const range = computeLinePmRange(block, line);
		if (range.pmStart == null || range.pmEnd == null) return;
		if (range.pmEnd > from$1 && range.pmStart < to) hits.push({
			line,
			index: idx
		});
	});
	return hits;
}
function computeLinePmRange(block, line) {
	return computeLinePmRange$1(block, line);
}
function pmPosToCharOffset(block, line, pmPos) {
	if (block.kind !== "paragraph") return 0;
	let charOffset = 0;
	for (let runIndex = line.fromRun; runIndex <= line.toRun; runIndex += 1) {
		const run = block.runs[runIndex];
		if (!run) continue;
		const text = "src" in run || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation" || run.kind === "math" ? "" : run.text ?? "";
		const runTextLength = text.length;
		const runPmStart = run.pmStart ?? null;
		const runPmEnd = run.pmEnd ?? (runPmStart != null ? runPmStart + runTextLength : null);
		if (runPmStart == null || runPmEnd == null || runTextLength === 0) continue;
		const isFirstRun = runIndex === line.fromRun;
		const isLastRun = runIndex === line.toRun;
		const lineStartChar = isFirstRun ? line.fromChar : 0;
		const lineEndChar = isLastRun ? line.toChar : runTextLength;
		const runSliceCharCount = lineEndChar - lineStartChar;
		const runPmRange = runPmEnd - runPmStart;
		const runSlicePmStart = runPmStart + lineStartChar / runTextLength * runPmRange;
		const runSlicePmEnd = runPmStart + lineEndChar / runTextLength * runPmRange;
		if (pmPos >= runSlicePmStart && pmPos <= runSlicePmEnd) {
			const runSlicePmRange = runSlicePmEnd - runSlicePmStart;
			if (runSlicePmRange > 0) {
				const pmOffsetInSlice = pmPos - runSlicePmStart;
				const charOffsetInSlice = Math.round(pmOffsetInSlice / runSlicePmRange * runSliceCharCount);
				const result = charOffset + Math.min(charOffsetInSlice, runSliceCharCount);
				const runText$2 = text;
				const offsetInRun = result - charOffset - (isFirstRun ? 0 : 0);
				logSelectionMapDebug({
					kind: "pmPosToCharOffset-hit",
					blockId: block.id,
					pmPos,
					runIndex,
					lineFromRun: line.fromRun,
					lineToRun: line.toRun,
					runPmStart,
					runPmEnd,
					runSlicePmStart,
					runSlicePmEnd,
					runSliceCharCount,
					pmOffsetInSlice,
					charOffsetInSlice,
					result,
					runTextPreview: runText$2.slice(Math.max(0, offsetInRun - 10), Math.min(runText$2.length, offsetInRun + 10))
				});
				return result;
			}
			logSelectionMapDebug({
				kind: "pmPosToCharOffset-zero-range",
				blockId: block.id,
				pmPos,
				runIndex
			});
			return charOffset;
		}
		if (pmPos > runSlicePmEnd) charOffset += runSliceCharCount;
	}
	logSelectionMapDebug({
		kind: "pmPosToCharOffset-fallback",
		blockId: block.id,
		pmPos,
		lineFromRun: line.fromRun,
		lineToRun: line.toRun,
		result: charOffset
	});
	return charOffset;
}
function pmPosToVisualCharOffset(block, line, pmPos) {
	if (block.kind !== "paragraph") return 0;
	let visualOffset = 0;
	for (let runIndex = line.fromRun; runIndex <= line.toRun; runIndex += 1) {
		const run = block.runs[runIndex];
		if (!run) continue;
		const runTextLength = ("src" in run || run.kind === "lineBreak" || run.kind === "break" || run.kind === "fieldAnnotation" || run.kind === "math" ? "" : run.text ?? "").length;
		if (runTextLength === 0) continue;
		const isFirstRun = runIndex === line.fromRun;
		const isLastRun = runIndex === line.toRun;
		const lineStartChar = isFirstRun ? line.fromChar : 0;
		const lineEndChar = isLastRun ? line.toChar : runTextLength;
		const runSliceCharCount = lineEndChar - lineStartChar;
		if (runSliceCharCount <= 0) continue;
		const runPmStart = run.pmStart ?? null;
		const runPmEnd = run.pmEnd ?? (runPmStart != null ? runPmStart + runTextLength : null);
		if (runPmStart == null || runPmEnd == null) {
			visualOffset += runSliceCharCount;
			continue;
		}
		const runPmRange = runPmEnd - runPmStart;
		const runSlicePmStart = runPmStart + lineStartChar / runTextLength * runPmRange;
		const runSlicePmEnd = runPmStart + lineEndChar / runTextLength * runPmRange;
		if (pmPos >= runSlicePmStart && pmPos <= runSlicePmEnd) {
			const runSlicePmRange = runSlicePmEnd - runSlicePmStart;
			if (runSlicePmRange <= 0) return visualOffset;
			const pmOffsetInSlice = pmPos - runSlicePmStart;
			const visualOffsetInSlice = Math.round(pmOffsetInSlice / runSlicePmRange * runSliceCharCount);
			return visualOffset + Math.min(visualOffsetInSlice, runSliceCharCount);
		}
		if (pmPos > runSlicePmEnd) {
			visualOffset += runSliceCharCount;
			continue;
		}
		return visualOffset;
	}
	return visualOffset;
}
var lineHeightBeforeIndex$1 = (measure, absoluteLineIndex) => {
	if (measure.kind !== "paragraph") return 0;
	let height = 0;
	for (let i = 0; i < absoluteLineIndex; i += 1) height += measure.lines[i]?.lineHeight ?? 0;
	return height;
};
var mapPmToX = (block, line, offset$1, fragmentWidth, alignmentOverride, isFirstLine, markerTextWidth) => {
	if (fragmentWidth <= 0 || line.width <= 0) return 0;
	let paraIndentLeft = 0;
	let paraIndentRight = 0;
	let effectiveLeft = 0;
	let isListParagraph$1 = false;
	let wl;
	if (block.kind === "paragraph") {
		const indentLeft = typeof block.attrs?.indent?.left === "number" ? block.attrs.indent.left : 0;
		const indentRight = typeof block.attrs?.indent?.right === "number" ? block.attrs.indent.right : 0;
		paraIndentLeft = Number.isFinite(indentLeft) ? indentLeft : 0;
		paraIndentRight = Number.isFinite(indentRight) ? indentRight : 0;
		effectiveLeft = paraIndentLeft;
		wl = getWordLayoutConfig(block);
		isListParagraph$1 = Boolean(block.attrs?.numberingProperties) || Boolean(wl?.marker);
		if (isListParagraph$1) {
			const explicitTextStart = typeof wl?.marker?.textStartX === "number" && Number.isFinite(wl.marker.textStartX) ? wl.marker.textStartX : typeof wl?.textStartPx === "number" && Number.isFinite(wl.textStartPx) ? wl.textStartPx : void 0;
			if (typeof explicitTextStart === "number" && explicitTextStart > paraIndentLeft) effectiveLeft = explicitTextStart;
		}
	}
	const totalIndent = effectiveLeft + paraIndentRight;
	let availableWidth = Math.max(0, fragmentWidth - totalIndent);
	if (totalIndent > fragmentWidth) console.warn(`[mapPmToX] Paragraph indents (${totalIndent}px) exceed fragment width (${fragmentWidth}px) for block ${block.id}. This may indicate a layout miscalculation. Available width clamped to 0.`);
	const hasRenderedMarkerText = isListParagraph$1 && (markerTextWidth ?? 0) > 0;
	if (isFirstLine && block.kind === "paragraph" && !hasRenderedMarkerText) {
		const suppressFLI = block.attrs?.suppressFirstLineIndent === true;
		const firstLineOffset = getFirstLineIndentOffset(block.attrs?.indent, suppressFLI);
		availableWidth = adjustAvailableWidthForTextIndent(availableWidth, firstLineOffset, line.maxWidth);
	}
	return measureCharacterX(block, line, offset$1, availableWidth, alignmentOverride);
};
var WORD_CHARACTER_REGEX = /[\p{L}\p{N}'\u2018\u2019_~-]/u;
function isWordCharacter$1(char) {
	if (!char) return false;
	return WORD_CHARACTER_REGEX.test(char);
}
function calculateExtendedSelection(blocks, anchor, head, mode) {
	if (mode === "word") {
		const anchorBounds = findWordBoundaries(blocks, anchor);
		const headBounds = findWordBoundaries(blocks, head);
		if (anchorBounds && headBounds) if (head >= anchor) return {
			selAnchor: anchorBounds.from,
			selHead: headBounds.to
		};
		else return {
			selAnchor: anchorBounds.to,
			selHead: headBounds.from
		};
	} else if (mode === "para") {
		const anchorBounds = findParagraphBoundaries(blocks, anchor);
		const headBounds = findParagraphBoundaries(blocks, head);
		if (anchorBounds && headBounds) if (head >= anchor) return {
			selAnchor: anchorBounds.from,
			selHead: headBounds.to
		};
		else return {
			selAnchor: anchorBounds.to,
			selHead: headBounds.from
		};
	}
	return {
		selAnchor: anchor,
		selHead: head
	};
}
function selectionCollapsesAcrossTableCells(doc$1, anchor, head) {
	if (anchor === head) return false;
	try {
		const size$1 = doc$1.content.size;
		if (anchor < 0 || head < 0 || anchor > size$1 || head > size$1) return false;
		const $from = doc$1.resolve(Math.min(anchor, head));
		const $to = doc$1.resolve(Math.max(anchor, head));
		return cellWrapping($from) !== cellWrapping($to) && $to.parentOffset === 0;
	} catch {
		return false;
	}
}
function stabilizeTextSelectionAcrossTableCells(doc$1, anchor, head) {
	if (!selectionCollapsesAcrossTableCells(doc$1, anchor, head)) return {
		selAnchor: anchor,
		selHead: head
	};
	try {
		const anchorIsUpper = anchor > head;
		const upperPos = anchorIsUpper ? anchor : head;
		if (upperPos < 0 || upperPos >= doc$1.content.size) return null;
		const $upper = doc$1.resolve(upperPos);
		if (!$upper.parent.inlineContent || $upper.parent.content.size !== 0) return null;
		const stabilizedUpperPos = upperPos + 1;
		if (stabilizedUpperPos > doc$1.content.size) return null;
		const selAnchor = anchorIsUpper ? stabilizedUpperPos : anchor;
		const selHead = anchorIsUpper ? head : stabilizedUpperPos;
		if (selectionCollapsesAcrossTableCells(doc$1, selAnchor, selHead)) return null;
		return {
			selAnchor,
			selHead
		};
	} catch {
		return null;
	}
}
function registerPointerClick(event, previous, options) {
	const time = event.timeStamp ?? performance.now();
	const withinTime = time - previous.lastClickTime <= options.timeThresholdMs;
	const distanceX = Math.abs(event.clientX - previous.lastClickPosition.x);
	const distanceY = Math.abs(event.clientY - previous.lastClickPosition.y);
	const withinDistance = distanceX <= options.distanceThresholdPx && distanceY <= options.distanceThresholdPx;
	return {
		clickCount: withinTime && withinDistance ? Math.min(previous.clickCount + 1, options.maxClickCount) : 1,
		lastClickTime: time,
		lastClickPosition: {
			x: event.clientX,
			y: event.clientY
		}
	};
}
function getFirstTextPosition(doc$1) {
	if (!doc$1 || !doc$1.content) return 1;
	let validPos = 1;
	let found = false;
	doc$1.nodesBetween(0, doc$1.content.size, (node, pos) => {
		if (found) return false;
		if (node.isTextblock) {
			validPos = pos + 1;
			found = true;
			return false;
		}
		return true;
	});
	return validPos;
}
function computeWordSelectionRangeAt(state, pos) {
	if (!state?.doc) return null;
	if (pos < 0 || pos > state.doc.content.size) return null;
	const textblockPos = findNearestTextblockResolvedPos(state.doc, pos);
	if (!textblockPos) return null;
	const parentStart = textblockPos.start();
	const parentEnd = textblockPos.end();
	const sampleEnd = Math.min(pos + 1, parentEnd);
	if (!isWordCharacter$1(state.doc.textBetween(pos, sampleEnd, "\0", "\0"))) return null;
	let startPos = pos;
	while (startPos > parentStart) {
		if (!isWordCharacter$1(state.doc.textBetween(startPos - 1, startPos, "\0", "\0"))) break;
		startPos -= 1;
	}
	let endPos = pos;
	while (endPos < parentEnd) {
		if (!isWordCharacter$1(state.doc.textBetween(endPos, endPos + 1, "\0", "\0"))) break;
		endPos += 1;
	}
	if (startPos === endPos) return null;
	return {
		from: startPos,
		to: endPos
	};
}
function computeParagraphSelectionRangeAt(state, pos) {
	if (!state?.doc) return null;
	const textblockPos = findNearestTextblockResolvedPos(state.doc, pos);
	if (!textblockPos) return null;
	return {
		from: textblockPos.start(),
		to: textblockPos.end()
	};
}
function findNearestTextblockResolvedPos(doc$1, pos) {
	let textblockPos = doc$1.resolve(pos);
	while (textblockPos.depth > 0) {
		if (textblockPos.parent?.isTextblock) break;
		if (!textblockPos.parent || textblockPos.depth === 0) break;
		const beforePos = textblockPos.before();
		if (beforePos < 0 || beforePos > doc$1.content.size) return null;
		textblockPos = doc$1.resolve(beforePos);
	}
	if (!textblockPos.parent?.isTextblock) return null;
	return textblockPos;
}
function matchesStructuredContentId(node, id) {
	if (!id) return false;
	const attrs = node.attrs;
	const nodeId = attrs?.id;
	const nodeSdtId = attrs?.sdtId;
	return nodeId != null && String(nodeId) === id || nodeSdtId != null && String(nodeSdtId) === id;
}
function resolvePosSafely(doc$1, pos) {
	if (!Number.isInteger(pos)) return null;
	try {
		return doc$1.resolve(pos);
	} catch {
		return null;
	}
}
function findStructuredContentBlockAtPos(doc$1, pos) {
	if (!Number.isInteger(pos)) return null;
	const nodeAtPos = typeof doc$1.nodeAt === "function" ? doc$1.nodeAt(pos) : null;
	if (nodeAtPos?.type?.name === "structuredContentBlock") return {
		node: nodeAtPos,
		pos,
		start: pos + 1,
		end: pos + nodeAtPos.nodeSize - 1
	};
	const $pos = resolvePosSafely(doc$1, pos);
	if (!$pos) return null;
	for (let depth = $pos.depth; depth > 0; depth--) {
		const node = $pos.node(depth);
		if (node.type?.name === "structuredContentBlock") return {
			node,
			pos: $pos.before(depth),
			start: $pos.start(depth),
			end: $pos.end(depth)
		};
	}
	return null;
}
function findStructuredContentBlockById(doc$1, id) {
	if (!id) return null;
	let found = null;
	doc$1.descendants((node, pos) => {
		if (node.type?.name !== "structuredContentBlock") return true;
		if (!matchesStructuredContentId(node, id)) return true;
		found = {
			node,
			pos,
			start: pos + 1,
			end: pos + node.nodeSize - 1
		};
		return false;
	});
	return found;
}
function findStructuredContentInlineAtPos(doc$1, pos) {
	if (!Number.isFinite(pos)) return null;
	const $pos = resolvePosSafely(doc$1, pos);
	if (!$pos) return null;
	for (let depth = $pos.depth; depth > 0; depth--) {
		const node = $pos.node(depth);
		if (node.type?.name === "structuredContent") return {
			node,
			pos: $pos.before(depth),
			start: $pos.start(depth),
			end: $pos.end(depth)
		};
	}
	return null;
}
function findStructuredContentInlineById(doc$1, id) {
	if (!id) return null;
	let found = null;
	doc$1.descendants((node, pos) => {
		if (node.type?.name !== "structuredContent") return true;
		if (!matchesStructuredContentId(node, id)) return true;
		found = {
			node,
			pos,
			start: pos + 1,
			end: pos + node.nodeSize - 1
		};
		return false;
	});
	return found;
}
var EpochPositionMapper = class {
	#currentEpoch = 0;
	#mapsByFromEpoch = /* @__PURE__ */ new Map();
	#maxEpochsToKeep;
	constructor(options) {
		const maxEpochsToKeep = options?.maxEpochsToKeep ?? 100;
		this.#maxEpochsToKeep = Math.max(1, Math.floor(maxEpochsToKeep));
	}
	getCurrentEpoch() {
		return this.#currentEpoch;
	}
	recordTransaction(tr) {
		if (!tr.docChanged) return;
		const fromEpoch = this.#currentEpoch;
		const maps = Array.isArray(tr.mapping?.maps) ? tr.mapping.maps : [];
		this.#mapsByFromEpoch.set(fromEpoch, maps);
		this.#currentEpoch = fromEpoch + 1;
		this.#pruneByCurrentEpoch();
	}
	onLayoutComplete(layoutEpoch) {
		for (const epoch of this.#mapsByFromEpoch.keys()) if (epoch < layoutEpoch) this.#mapsByFromEpoch.delete(epoch);
		this.#pruneByCurrentEpoch();
	}
	mapPosFromLayoutToCurrent(pos, fromEpoch, assoc = 1) {
		const result = this.mapPosFromLayoutToCurrentDetailed(pos, fromEpoch, assoc);
		return result.ok ? result.pos : null;
	}
	mapPosFromLayoutToCurrentDetailed(pos, fromEpoch, assoc = 1) {
		const toEpoch = this.#currentEpoch;
		if (!Number.isFinite(pos) || pos < 0) return {
			ok: false,
			reason: "invalid_pos",
			fromEpoch,
			toEpoch
		};
		if (!Number.isFinite(fromEpoch) || fromEpoch < 0) return {
			ok: false,
			reason: "invalid_epoch",
			fromEpoch,
			toEpoch
		};
		if (fromEpoch > toEpoch) return {
			ok: false,
			reason: "invalid_epoch",
			fromEpoch,
			toEpoch
		};
		if (fromEpoch === toEpoch) return {
			ok: true,
			pos,
			fromEpoch,
			toEpoch
		};
		if (fromEpoch < Math.max(0, toEpoch - this.#maxEpochsToKeep)) return {
			ok: false,
			reason: "epoch_too_old",
			fromEpoch,
			toEpoch
		};
		let mapped = pos;
		for (let epoch = fromEpoch; epoch < toEpoch; epoch += 1) {
			const maps = this.#mapsByFromEpoch.get(epoch);
			if (!maps) return {
				ok: false,
				reason: "missing_stepmap",
				fromEpoch,
				toEpoch
			};
			for (const map$1 of maps) {
				const r$1 = map$1.mapResult(mapped, assoc);
				if (r$1.deleted) return {
					ok: false,
					reason: "deleted",
					fromEpoch,
					toEpoch
				};
				mapped = r$1.pos;
			}
		}
		return {
			ok: true,
			pos: mapped,
			fromEpoch,
			toEpoch
		};
	}
	#pruneByCurrentEpoch() {
		const minKeptFromEpoch = Math.max(0, this.#currentEpoch - this.#maxEpochsToKeep);
		for (const epoch of this.#mapsByFromEpoch.keys()) if (epoch < minKeptFromEpoch) this.#mapsByFromEpoch.delete(epoch);
	}
};
var DEFAULT_CONFIG = {
	logLevel: "off",
	hud: false,
	dumpRects: false,
	disableRectDedupe: false
};
var levelOrder = {
	error: 0,
	warn: 1,
	info: 2,
	verbose: 3
};
function getSelectionDebugConfig() {
	if (typeof window === "undefined") return DEFAULT_CONFIG;
	window.superdocDebug ??= {};
	window.superdocDebug.selection ??= {};
	const cfg = window.superdocDebug.selection;
	return {
		logLevel: cfg.logLevel ?? DEFAULT_CONFIG.logLevel,
		hud: cfg.hud ?? DEFAULT_CONFIG.hud,
		dumpRects: cfg.dumpRects ?? DEFAULT_CONFIG.dumpRects,
		disableRectDedupe: cfg.disableRectDedupe ?? DEFAULT_CONFIG.disableRectDedupe
	};
}
function debugLog(level, message, data) {
	const cfg = getSelectionDebugConfig();
	if (cfg.logLevel === "off") return;
	if (levelOrder[level] > levelOrder[cfg.logLevel]) return;
	const prefix = "[Selection]";
	if (data) console.log(prefix, message, data);
	else console.log(prefix, message);
}
var HUD_DATA_ATTR = "data-superdoc-selection-debug-hud";
function updateSelectionDebugHud(host, state) {
	const cfg = getSelectionDebugConfig();
	const doc$1 = host.ownerDocument ?? (typeof document !== "undefined" ? document : null);
	if (!doc$1) return;
	const existing = host.querySelector(`[${HUD_DATA_ATTR}="true"]`);
	if (!cfg.hud) {
		existing?.remove();
		return;
	}
	const hud = existing ?? doc$1.createElement("div");
	hud.setAttribute(HUD_DATA_ATTR, "true");
	hud.style.position = "absolute";
	hud.style.top = "8px";
	hud.style.left = "8px";
	hud.style.zIndex = "9999";
	hud.style.maxWidth = "420px";
	hud.style.padding = "6px 8px";
	hud.style.borderRadius = "6px";
	hud.style.background = "rgba(0, 0, 0, 0.72)";
	hud.style.color = "white";
	hud.style.fontFamily = "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace";
	hud.style.fontSize = "12px";
	hud.style.lineHeight = "1.3";
	hud.style.pointerEvents = "none";
	hud.style.whiteSpace = "pre";
	const behind = Math.max(0, state.docEpoch - state.layoutEpoch);
	const selectionText = state.selection ? `${state.selection.from}..${state.selection.to}` : "null";
	const pointerText = state.lastPointer ? `${state.lastPointer.clientX},${state.lastPointer.clientY} -> ${Math.round(state.lastPointer.x)},${Math.round(state.lastPointer.y)}` : "null";
	const hitText = state.lastHit ? `${state.lastHit.source} pos=${state.lastHit.pos ?? "null"} epoch=${state.lastHit.layoutEpoch ?? "null"} mapped=${state.lastHit.mappedPos ?? "null"}` : "null";
	hud.textContent = [
		`docEpoch=${state.docEpoch} layoutEpoch=${state.layoutEpoch} behind=${behind}`,
		`selection=${selectionText}`,
		`pointer=${pointerText}`,
		`hit=${hitText}`
	].join("\n");
	if (!existing) host.appendChild(hud);
}
var import_lodash = require_lodash();
function isExcludedFromBodyDomIndex(node) {
	if (STRUCTURED_CONTENT_CHROME_LABEL_CLASS_NAMES.some((className) => node.classList.contains(className))) return true;
	if (node.closest(".superdoc-page-header, .superdoc-page-footer")) return true;
	const blockId = node.closest("[data-block-id]")?.dataset.blockId ?? "";
	return blockId.startsWith("footnote-") || blockId.startsWith("__sd_semantic_footnote-") || blockId.startsWith("endnote-") || blockId.startsWith("__sd_semantic_endnote-");
}
var DomPositionIndex = class {
	#entries = [];
	get size() {
		return this.#entries.length;
	}
	rebuild(container, options = {}) {
		const leafOnly = options.leafOnly !== false;
		const nodes = Array.from(container.querySelectorAll("[data-pm-start][data-pm-end]"));
		const entries = [];
		const pmNodes = [];
		for (const node of nodes) {
			if (!(node instanceof HTMLElement)) continue;
			pmNodes.push(node);
		}
		const nonLeaf = /* @__PURE__ */ new WeakSet();
		if (leafOnly) {
			const pmNodeSet = /* @__PURE__ */ new WeakSet();
			pmNodes.forEach((n) => pmNodeSet.add(n));
			for (const node of pmNodes) {
				let parent = node.parentElement;
				while (parent && parent !== container) {
					if (pmNodeSet.has(parent)) nonLeaf.add(parent);
					parent = parent.parentElement;
				}
			}
		}
		for (const node of pmNodes) {
			if (node.classList.contains(DOM_CLASS_NAMES.INLINE_SDT_WRAPPER)) continue;
			if (isExcludedFromBodyDomIndex(node)) continue;
			if (leafOnly && nonLeaf.has(node)) continue;
			const pmStart = Number(node.dataset.pmStart ?? "NaN");
			const pmEnd = Number(node.dataset.pmEnd ?? "NaN");
			if (!Number.isFinite(pmStart) || !Number.isFinite(pmEnd)) continue;
			if (pmEnd < pmStart) continue;
			entries.push({
				pmStart,
				pmEnd,
				el: node
			});
		}
		entries.sort((a, b$1) => a.pmStart - b$1.pmStart !== 0 ? a.pmStart - b$1.pmStart : a.pmEnd - b$1.pmEnd);
		this.#entries = entries;
		if (getSelectionDebugConfig().logLevel === "verbose") {
			const counts = {
				total: entries.length,
				body: 0,
				header: 0,
				footer: 0
			};
			const bodySamples = [];
			const headerSamples = [];
			const footerSamples = [];
			for (const entry of entries) {
				const pageIndex = entry.el.closest(`.${DOM_CLASS_NAMES.PAGE}`)?.dataset.pageIndex ?? null;
				const section = entry.el.closest(".superdoc-page-header") ? "header" : entry.el.closest(".superdoc-page-footer") ? "footer" : "body";
				if (section === "header") {
					counts.header += 1;
					if (headerSamples.length < 10) headerSamples.push({
						pmStart: entry.pmStart,
						pmEnd: entry.pmEnd,
						pageIndex,
						text: (entry.el.textContent ?? "").slice(0, 40)
					});
					continue;
				}
				if (section === "footer") {
					counts.footer += 1;
					if (footerSamples.length < 10) footerSamples.push({
						pmStart: entry.pmStart,
						pmEnd: entry.pmEnd,
						pageIndex,
						text: (entry.el.textContent ?? "").slice(0, 40)
					});
					continue;
				}
				counts.body += 1;
				if (bodySamples.length < 10) bodySamples.push({
					pmStart: entry.pmStart,
					pmEnd: entry.pmEnd,
					pageIndex,
					text: (entry.el.textContent ?? "").slice(0, 40)
				});
			}
			debugLog("verbose", `DomPositionIndex: rebuild summary ${JSON.stringify({
				counts,
				bodySamples,
				headerSamples,
				footerSamples
			})}`);
		}
	}
	findEntryAtPosition(pos) {
		if (!Number.isFinite(pos)) return null;
		const entries = this.#entries;
		if (entries.length === 0) return null;
		let lo = 0;
		let hi = entries.length;
		while (lo < hi) {
			const mid = lo + hi >>> 1;
			if (entries[mid].pmStart <= pos) lo = mid + 1;
			else hi = mid;
		}
		const idx = lo - 1;
		if (idx < 0) return null;
		const entry = entries[idx];
		if (pos < entry.pmStart || pos > entry.pmEnd) return null;
		return entry;
	}
	findEntryClosestToPosition(pos) {
		if (!Number.isFinite(pos)) return null;
		const entries = this.#entries;
		if (entries.length === 0) return null;
		const entryAtPos = this.findEntryAtPosition(pos);
		if (entryAtPos) return entryAtPos;
		const idx = (0, import_lodash.sortedIndexBy)(entries, { pmStart: pos }, "pmStart") - 1;
		const beforeEntry = idx >= 0 ? entries[idx] : null;
		const afterEntry = idx < entries.length - 1 ? entries[idx + 1] : null;
		if (beforeEntry && afterEntry) return pos - beforeEntry.pmEnd <= afterEntry.pmStart - pos ? beforeEntry : afterEntry;
		if (beforeEntry) return beforeEntry;
		if (afterEntry) return afterEntry;
		return null;
	}
	findElementAtPosition(pos) {
		return this.findEntryAtPosition(pos)?.el ?? null;
	}
	findEntriesInRange(from$1, to, options) {
		if (!Number.isFinite(from$1) || !Number.isFinite(to)) return [];
		const start$1 = Math.min(from$1, to);
		const end$1 = Math.max(from$1, to);
		if (start$1 === end$1) return [];
		const entries = this.#entries;
		if (entries.length === 0) return [];
		const inclusive = options?.boundaryInclusive === true;
		let lo = 0;
		let hi = entries.length;
		while (lo < hi) {
			const mid = lo + hi >>> 1;
			if (entries[mid].pmStart < start$1) lo = mid + 1;
			else hi = mid;
		}
		let idx = Math.max(0, lo - 1);
		while (idx < entries.length && entries[idx].pmEnd < start$1) idx += 1;
		const out = [];
		for (let i = idx; i < entries.length; i += 1) {
			const entry = entries[i];
			if (inclusive ? entry.pmStart > end$1 : entry.pmStart >= end$1) break;
			if (inclusive ? entry.pmEnd < start$1 : entry.pmEnd <= start$1) continue;
			out.push(entry);
		}
		return out;
	}
	findElementsInRange(from$1, to) {
		return this.findEntriesInRange(from$1, to).map((e) => e.el);
	}
};
var DomPositionIndexObserverManager = class {
	#windowRoot;
	#getPainterHost;
	#onRebuild;
	#observer = null;
	#rebuildScheduled = false;
	#rebuildRafId = null;
	constructor(options) {
		this.#windowRoot = options.windowRoot;
		this.#getPainterHost = options.getPainterHost;
		this.#onRebuild = options.onRebuild;
	}
	setup() {
		if (typeof this.#windowRoot.MutationObserver !== "function") return;
		this.#observer?.disconnect();
		this.#observer = new this.#windowRoot.MutationObserver(() => {
			this.scheduleRebuild();
		});
		this.resume();
	}
	pause() {
		this.#observer?.disconnect();
	}
	resume() {
		const observer = this.#observer;
		if (!observer) return;
		const painterHost = this.#getPainterHost();
		if (!painterHost) return;
		try {
			observer.observe(painterHost, { childList: true });
		} catch {}
	}
	destroy() {
		this.#observer?.disconnect();
		this.#observer = null;
		this.#rebuildScheduled = false;
		if (this.#rebuildRafId != null && typeof this.#windowRoot.cancelAnimationFrame === "function") this.#windowRoot.cancelAnimationFrame(this.#rebuildRafId);
		this.#rebuildRafId = null;
	}
	scheduleRebuild() {
		if (this.#rebuildScheduled) return;
		this.#rebuildScheduled = true;
		this.#rebuildRafId = this.#windowRoot.requestAnimationFrame(() => {
			this.#rebuildScheduled = false;
			this.#rebuildRafId = null;
			if (!this.#getPainterHost()?.isConnected) return;
			this.#onRebuild();
		});
	}
};
function computeSelectionRectsFromDom(options, from$1, to) {
	const painterHost = options.painterHost;
	if (!painterHost) return null;
	const layout = options.layout;
	if (!layout) return null;
	if (!Number.isFinite(from$1) || !Number.isFinite(to)) return null;
	const start$1 = Math.min(from$1, to);
	const end$1 = Math.max(from$1, to);
	if (start$1 === end$1) return [];
	if (options.domPositionIndex.size === 0) options.rebuildDomPositionIndex();
	const zoom = options.zoom;
	const pageHeight = options.pageHeight;
	const pageGap = options.pageGap;
	const pageEls = Array.from(painterHost.querySelectorAll(`.${DOM_CLASS_NAMES.PAGE}[data-page-index]`));
	const out = [];
	let rebuiltOnce = false;
	const debugConfig = getSelectionDebugConfig();
	const isVerbose = debugConfig.logLevel === "verbose";
	const dumpRects = isVerbose && debugConfig.dumpRects;
	const disableRectDedupe = debugConfig.disableRectDedupe;
	const entryDebugInfo = (entry) => {
		const pageEl = entry.el.closest(`.${DOM_CLASS_NAMES.PAGE}`);
		const section = entry.el.closest(".superdoc-page-header") ? "header" : entry.el.closest(".superdoc-page-footer") ? "footer" : "body";
		return {
			pmStart: entry.pmStart,
			pmEnd: entry.pmEnd,
			pageIndex: pageEl?.dataset.pageIndex ?? null,
			section,
			connected: entry.el.isConnected,
			layoutEpoch: entry.el.dataset.layoutEpoch ?? null,
			pageEpoch: pageEl?.dataset.layoutEpoch ?? null,
			text: (entry.el.textContent ?? "").slice(0, 80)
		};
	};
	const rectDebugInfo = (rect) => ({
		x: rect.x,
		y: rect.y,
		width: rect.width,
		height: rect.height,
		top: rect.top,
		left: rect.left,
		right: rect.right,
		bottom: rect.bottom
	});
	for (const pageEl of pageEls) {
		const pageIndex = Number(pageEl.dataset.pageIndex ?? "NaN");
		if (!Number.isFinite(pageIndex)) continue;
		const page = layout.pages[pageIndex];
		if (!page) continue;
		let pagePmStart = Infinity;
		let pagePmEnd = -Infinity;
		for (const fragment of page.fragments) {
			const pmStart = fragment.pmStart;
			const pmEnd = fragment.pmEnd;
			if (typeof pmStart === "number" && Number.isFinite(pmStart)) pagePmStart = Math.min(pagePmStart, pmStart);
			if (typeof pmEnd === "number" && Number.isFinite(pmEnd)) pagePmEnd = Math.max(pagePmEnd, pmEnd);
		}
		if (!Number.isFinite(pagePmStart) || !Number.isFinite(pagePmEnd) || pagePmEnd <= pagePmStart) continue;
		const sliceFrom = Math.max(start$1, pagePmStart);
		const sliceTo = Math.min(end$1, pagePmEnd);
		if (sliceFrom >= sliceTo) continue;
		const rangeOpts = { boundaryInclusive: true };
		let sliceEntries = options.domPositionIndex.findEntriesInRange(sliceFrom, sliceTo, rangeOpts);
		if (sliceEntries.length === 0) continue;
		const filterPageEntries = (entries) => entries.filter((entry) => pageEl.contains(entry.el));
		let pageEntries = filterPageEntries(sliceEntries);
		if (pageEntries.length === 0 && !rebuiltOnce) {
			options.rebuildDomPositionIndex();
			rebuiltOnce = true;
			sliceEntries = options.domPositionIndex.findEntriesInRange(sliceFrom, sliceTo, rangeOpts);
			pageEntries = filterPageEntries(sliceEntries);
		}
		if (pageEntries.length === 0) continue;
		if (isVerbose) debugLog("verbose", `DOM selection rects: slice entries ${JSON.stringify({
			pageIndex,
			sliceFrom,
			sliceTo,
			entriesCount: sliceEntries.length,
			entriesPreview: sliceEntries.slice(0, 20).map(entryDebugInfo)
		})}`);
		const pickEntryForPos = (entries, pos, fallbackIndex) => {
			const direct = entries.find((entry) => pos >= entry.pmStart && pos <= entry.pmEnd);
			if (!direct) return entries[fallbackIndex];
			return direct;
		};
		let startEntry = pickEntryForPos(pageEntries, sliceFrom, 0);
		let endEntry = pickEntryForPos(pageEntries, sliceTo, pageEntries.length - 1);
		if ((!startEntry?.el?.isConnected || !endEntry?.el?.isConnected) && !rebuiltOnce) {
			options.rebuildDomPositionIndex();
			rebuiltOnce = true;
			sliceEntries = options.domPositionIndex.findEntriesInRange(sliceFrom, sliceTo, rangeOpts);
			pageEntries = filterPageEntries(sliceEntries);
			if (pageEntries.length === 0) continue;
			startEntry = pickEntryForPos(pageEntries, sliceFrom, 0);
			endEntry = pickEntryForPos(pageEntries, sliceTo, pageEntries.length - 1);
		}
		if (!startEntry?.el?.isConnected || !endEntry?.el?.isConnected) continue;
		if (isVerbose) debugLog("verbose", `DOM selection rects: boundaries ${JSON.stringify({
			pageIndex,
			sliceFrom,
			sliceTo,
			start: entryDebugInfo(startEntry),
			end: entryDebugInfo(endEntry)
		})}`);
		const doc$1 = pageEl.ownerDocument ?? document;
		const range = doc$1.createRange();
		try {
			if (!setDomRangeStart(range, startEntry, sliceFrom)) return null;
			if (!setDomRangeEnd(range, endEntry, sliceTo)) return null;
		} catch (error) {
			debugLog("warn", "DOM selection rects: Range boundary set failed", { error: String(error) });
			return null;
		}
		let clientRects = [];
		try {
			let rawRects = Array.from(range.getClientRects());
			if (dumpRects) debugLog("verbose", `DOM selection rects: raw rects ${JSON.stringify({
				pageIndex,
				sliceFrom,
				sliceTo,
				rects: rawRects.map(rectDebugInfo)
			})}`);
			let missingEntries = null;
			if (typeof range.intersectsNode === "function") for (const entry of pageEntries) try {
				if (!range.intersectsNode(entry.el)) {
					missingEntries ??= [];
					missingEntries.push(entry);
				}
			} catch {}
			const spansMultipleLines = countDistinctLines(pageEntries) > 1;
			if (spansMultipleLines || missingEntries && missingEntries.length > 0) {
				if (isVerbose) debugLog("verbose", `DOM selection rects: switching to per-line rects ${JSON.stringify({
					pageIndex,
					sliceFrom,
					sliceTo,
					spansMultipleLines,
					missingCount: missingEntries?.length ?? 0,
					missingPreview: (missingEntries ?? []).slice(0, 20).map(entryDebugInfo)
				})}`);
				rawRects = collectClientRectsByLine(doc$1, pageEntries, sliceFrom, sliceTo);
				if (dumpRects) debugLog("verbose", `DOM selection rects: fallback raw rects ${JSON.stringify({
					pageIndex,
					sliceFrom,
					sliceTo,
					rects: rawRects.map(rectDebugInfo)
				})}`);
			}
			clientRects = disableRectDedupe ? rawRects : deduplicateOverlappingRects(rawRects);
			if (dumpRects) {
				debugLog("verbose", `DOM selection rects: final rects ${JSON.stringify({
					pageIndex,
					sliceFrom,
					sliceTo,
					dedupeDisabled: disableRectDedupe,
					rects: clientRects.map(rectDebugInfo)
				})}`);
				const nonPositive = clientRects.filter((rect) => !Number.isFinite(rect.width) || !Number.isFinite(rect.height) || rect.width <= 0 || rect.height <= 0);
				if (nonPositive.length > 0) debugLog("verbose", `DOM selection rects: non-positive rects ${JSON.stringify({
					pageIndex,
					sliceFrom,
					sliceTo,
					rects: nonPositive.map(rectDebugInfo)
				})}`);
			}
		} catch (error) {
			debugLog("warn", "DOM selection rects: getClientRects failed", { error: String(error) });
			return null;
		}
		const pageRect = pageEl.getBoundingClientRect();
		for (const r$1 of clientRects) {
			const width = r$1.width / zoom;
			const height = r$1.height / zoom;
			if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) continue;
			const localX = (r$1.left - pageRect.left) / zoom;
			const localY = (r$1.top - pageRect.top) / zoom;
			if (!Number.isFinite(localX) || !Number.isFinite(localY)) continue;
			out.push({
				pageIndex,
				x: localX,
				y: pageIndex * (pageHeight + pageGap) + localY,
				width: Math.max(1, width),
				height: Math.max(1, height)
			});
		}
	}
	return out;
}
function collectClientRectsByLine(doc$1, entries, sliceFrom, sliceTo) {
	const rects = [];
	const lineMap = /* @__PURE__ */ new Map();
	const looseEntries = [];
	for (const entry of entries) {
		const lineEl = entry.el.closest(".superdoc-line");
		if (!lineEl) {
			looseEntries.push(entry);
			continue;
		}
		const list = lineMap.get(lineEl);
		if (list) list.push(entry);
		else lineMap.set(lineEl, [entry]);
	}
	for (const [lineEl, lineEntries] of lineMap) {
		lineEntries.sort((a, b$1) => a.pmStart - b$1.pmStart !== 0 ? a.pmStart - b$1.pmStart : a.pmEnd - b$1.pmEnd);
		const linePmStart = lineEntries[0]?.pmStart ?? Infinity;
		const linePmEnd = lineEntries[lineEntries.length - 1]?.pmEnd ?? -Infinity;
		if (sliceFrom < linePmStart && linePmEnd < sliceTo && lineEl.isConnected) {
			const boxRect = lineEl.getBoundingClientRect();
			if (boxRect.width > 0 && boxRect.height > 0) {
				rects.push(boxRect);
				continue;
			}
		}
		if (!Number.isFinite(linePmStart) || !Number.isFinite(linePmEnd) || linePmEnd <= linePmStart) continue;
		const lineFrom = Math.max(sliceFrom, linePmStart);
		const lineTo = Math.min(sliceTo, linePmEnd);
		if (lineFrom >= lineTo) continue;
		const startEntry = lineEntries.find((entry) => lineFrom >= entry.pmStart && lineFrom <= entry.pmEnd) ?? lineEntries[0];
		const endEntry = lineEntries.find((entry) => lineTo >= entry.pmStart && lineTo <= entry.pmEnd) ?? lineEntries[lineEntries.length - 1];
		const range = doc$1.createRange();
		try {
			if (!setDomRangeStart(range, startEntry, lineFrom)) continue;
			if (!setDomRangeEnd(range, endEntry, lineTo)) continue;
		} catch {
			continue;
		}
		rects.push(...Array.from(range.getClientRects()));
	}
	for (const entry of looseEntries) {
		const entryFrom = Math.max(sliceFrom, entry.pmStart);
		const entryTo = Math.min(sliceTo, entry.pmEnd);
		if (entryFrom >= entryTo) continue;
		const range = doc$1.createRange();
		try {
			if (!setDomRangeStart(range, entry, entryFrom)) continue;
			if (!setDomRangeEnd(range, entry, entryTo)) continue;
		} catch {
			continue;
		}
		rects.push(...Array.from(range.getClientRects()));
	}
	return rects;
}
function countDistinctLines(entries) {
	const lines = /* @__PURE__ */ new Set();
	let hasLoose = false;
	for (const entry of entries) {
		const lineEl = entry.el.closest(".superdoc-line");
		if (lineEl) lines.add(lineEl);
		else hasLoose = true;
	}
	return lines.size + (hasLoose ? 1 : 0);
}
function setDomRangeStart(range, entry, pos) {
	const el = entry.el;
	const pmStart = entry.pmStart;
	const boundary = resolveTextBoundaryInElement(el, pos, pmStart, entry.pmEnd, "forward");
	if (boundary) {
		range.setStart(boundary.node, boundary.offset);
		return true;
	}
	if (!el.isConnected || !el.parentNode) return false;
	if (pos <= pmStart) {
		range.setStartBefore(el);
		return true;
	}
	range.setStartAfter(el);
	return true;
}
function setDomRangeEnd(range, entry, pos) {
	const el = entry.el;
	const pmStart = entry.pmStart;
	const boundary = resolveTextBoundaryInElement(el, pos, pmStart, entry.pmEnd, "backward");
	if (boundary) {
		range.setEnd(boundary.node, boundary.offset);
		return true;
	}
	if (!el.isConnected || !el.parentNode) return false;
	if (pos <= pmStart) {
		range.setEndBefore(el);
		return true;
	}
	range.setEndAfter(el);
	return true;
}
function computeDomCaretPageLocal(options, pos) {
	if (!options.painterHost) return null;
	if (options.domPositionIndex.size === 0) options.rebuildDomPositionIndex();
	let entry = options.domPositionIndex.findEntryClosestToPosition(pos);
	if (entry && !entry.el.isConnected) {
		options.rebuildDomPositionIndex();
		entry = options.domPositionIndex.findEntryClosestToPosition(pos);
	}
	if (!entry) return null;
	const targetEl = entry.el;
	const page = targetEl.closest(`.${DOM_CLASS_NAMES.PAGE}`);
	if (!page) return null;
	const pageRect = page.getBoundingClientRect();
	const zoom = options.zoom;
	const boundary = resolveTextBoundaryInElement(targetEl, pos, entry.pmStart, entry.pmEnd, "forward");
	if (!boundary) {
		const elRect = targetEl.getBoundingClientRect();
		if (targetEl.classList.contains("superdoc-line")) {
			const paddingLeft = parseFloat(targetEl.style.paddingLeft) || 0;
			const paddingRight = parseFloat(targetEl.style.paddingRight) || 0;
			const lineLeft = (elRect.left - pageRect.left) / zoom + paddingLeft;
			const lineRight = (elRect.right - pageRect.left) / zoom - paddingRight;
			const textAlign = targetEl.style.textAlign;
			let x;
			if (textAlign === "center") x = (lineLeft + lineRight) / 2;
			else if (textAlign === "right") x = lineRight;
			else x = lineLeft;
			return {
				pageIndex: Number(page.dataset.pageIndex ?? "0"),
				x,
				y: (elRect.top - pageRect.top) / zoom
			};
		}
		const isEmptySdtPlaceholder = targetEl.classList.contains("superdoc-empty-sdt-placeholder") || targetEl.classList.contains("superdoc-empty-inline-sdt-placeholder") || targetEl.classList.contains("superdoc-empty-block-sdt-placeholder");
		const atEnd = isEmptySdtPlaceholder ? pos > entry.pmEnd : pos >= entry.pmEnd;
		const yRect = (isEmptySdtPlaceholder || targetEl.classList.contains("superdoc-tab") ? targetEl.closest(".superdoc-line") : null)?.getBoundingClientRect() ?? elRect;
		return {
			pageIndex: Number(page.dataset.pageIndex ?? "0"),
			x: ((atEnd ? elRect.right : elRect.left) - pageRect.left) / zoom,
			y: (yRect.top - pageRect.top) / zoom
		};
	}
	const range = document.createRange();
	range.setStart(boundary.node, boundary.offset);
	range.setEnd(boundary.node, boundary.offset);
	const rangeRect = range.getBoundingClientRect();
	const lineRect = targetEl.closest(".superdoc-line")?.getBoundingClientRect() ?? rangeRect;
	return {
		pageIndex: Number(page.dataset.pageIndex ?? "0"),
		x: (rangeRect.left - pageRect.left) / zoom,
		y: (lineRect.top - pageRect.top) / zoom
	};
}
function resolveTextBoundaryInElement(element, pos, pmStart, pmEnd, affinity) {
	const textLength = element.textContent?.length ?? 0;
	if (textLength <= 0) return null;
	return resolveDescendantTextBoundary(element, mapPmPosToCharIndex(pos, pmStart, pmEnd, textLength), affinity);
}
function resolveDescendantTextBoundary(element, targetOffset, affinity) {
	const walker = (element.ownerDocument ?? document).createTreeWalker(element, NodeFilter.SHOW_TEXT);
	let consumed = 0;
	let previous = null;
	let current = walker.nextNode();
	while (current) {
		const textNode = current;
		const textLength = textNode.textContent?.length ?? 0;
		if (textLength <= 0) {
			current = walker.nextNode();
			continue;
		}
		const segmentEnd = consumed + textLength;
		if (targetOffset < segmentEnd) return {
			node: textNode,
			offset: Math.max(0, targetOffset - consumed)
		};
		if (targetOffset === segmentEnd) {
			if (affinity === "backward") return {
				node: textNode,
				offset: textLength
			};
			previous = {
				node: textNode,
				offset: textLength
			};
			consumed = segmentEnd;
			current = walker.nextNode();
			continue;
		}
		previous = {
			node: textNode,
			offset: textLength
		};
		consumed = segmentEnd;
		current = walker.nextNode();
	}
	return previous;
}
function mapPmPosToCharIndex(pos, pmStart, pmEnd, textLength) {
	if (!Number.isFinite(pos) || !Number.isFinite(pmStart) || !Number.isFinite(pmEnd)) return 0;
	if (textLength <= 0) return 0;
	const pmRange = pmEnd - pmStart;
	if (!Number.isFinite(pmRange) || pmRange <= 0) return 0;
	if (pmRange === textLength) {
		const mapped = pos - pmStart;
		return Math.min(textLength, Math.max(0, mapped));
	}
	if (pos <= pmStart) return 0;
	if (pos >= pmEnd) return textLength;
	return pos <= pmStart + pmRange / 2 ? 0 : textLength;
}
var Y_SORT_THRESHOLD_PX = 2;
var Y_SAME_LINE_THRESHOLD_PX = 3;
var HORIZONTAL_OVERLAP_THRESHOLD = .8;
function deduplicateOverlappingRects(rects) {
	if (rects.length <= 1) return rects;
	const sorted = [...rects].sort((a, b$1) => {
		const yDiff = a.y - b$1.y;
		if (Math.abs(yDiff) > Y_SORT_THRESHOLD_PX) return yDiff;
		return a.x - b$1.x;
	});
	const result = [];
	const groups = [];
	let currentGroup = [];
	for (const rect of sorted) {
		if (currentGroup.length === 0) {
			currentGroup.push(rect);
			continue;
		}
		const groupY = currentGroup[0].y;
		if (Math.abs(rect.y - groupY) <= Y_SAME_LINE_THRESHOLD_PX) currentGroup.push(rect);
		else {
			groups.push(currentGroup);
			currentGroup = [rect];
		}
	}
	if (currentGroup.length > 0) groups.push(currentGroup);
	const SIZE_EPS_PX = .5;
	const X_DUPLICATE_EPS_PX = 1;
	const hasSignificantOverlap = (a, b$1) => {
		const xOverlapStart = Math.max(a.x, b$1.x);
		const xOverlapEnd = Math.min(a.x + a.width, b$1.x + b$1.width);
		if (!(xOverlapEnd > xOverlapStart)) return false;
		const overlapWidth = Math.max(0, xOverlapEnd - xOverlapStart);
		const minWidth = Math.min(a.width, b$1.width);
		return minWidth > 0 && overlapWidth / minWidth > HORIZONTAL_OVERLAP_THRESHOLD;
	};
	const isLargerRect = (a, b$1) => {
		return a.width > b$1.width + SIZE_EPS_PX || a.height > b$1.height + SIZE_EPS_PX;
	};
	for (const group of groups) {
		const unique$2 = [];
		for (const rect of group) if (!unique$2.some((existing) => {
			const xClose = Math.abs(existing.x - rect.x) <= X_DUPLICATE_EPS_PX;
			const yClose = Math.abs(existing.y - rect.y) <= Y_SAME_LINE_THRESHOLD_PX;
			const widthClose = Math.abs(existing.width - rect.width) <= SIZE_EPS_PX;
			const heightClose = Math.abs(existing.height - rect.height) <= SIZE_EPS_PX;
			return xClose && yClose && widthClose && heightClose;
		})) unique$2.push(rect);
		if (unique$2.length <= 1) {
			result.push(...unique$2);
			continue;
		}
		const containers = /* @__PURE__ */ new Set();
		for (const rect of unique$2) for (const other of unique$2) {
			if (rect === other) continue;
			if (!hasSignificantOverlap(rect, other)) continue;
			if (isLargerRect(rect, other)) {
				containers.add(rect);
				break;
			}
		}
		const filtered = unique$2.filter((rect) => !containers.has(rect));
		result.push(...filtered.length > 0 ? filtered : unique$2);
	}
	return result;
}
function getPageElementByIndex(painterHost, pageIndex) {
	if (!painterHost) return null;
	const pageElements = painterHost.querySelectorAll("[data-page-index]");
	for (let i = 0; i < pageElements.length; i++) {
		const el = pageElements[i];
		const dataPageIndex = el.getAttribute("data-page-index");
		if (dataPageIndex && parseInt(dataPageIndex, 10) === pageIndex) return el;
	}
	return null;
}
var log = (...args$1) => {};
var CLASS = {
	page: DOM_CLASS_NAMES.PAGE,
	fragment: DOM_CLASS_NAMES.FRAGMENT,
	line: DOM_CLASS_NAMES.LINE,
	tableFragment: DOM_CLASS_NAMES.TABLE_FRAGMENT,
	inlineSdtWrapper: DOM_CLASS_NAMES.INLINE_SDT_WRAPPER,
	emptySdtPlaceholder: "superdoc-empty-sdt-placeholder"
};
function safeElementsFromPoint(doc$1, x, y$1) {
	if (typeof doc$1.elementsFromPoint !== "function") return [];
	try {
		return doc$1.elementsFromPoint(x, y$1) ?? [];
	} catch {
		return [];
	}
}
function hasElementsFromPoint(doc$1) {
	return typeof doc$1.elementsFromPoint === "function";
}
function getContainerDocument(domContainer) {
	return domContainer.ownerDocument ?? null;
}
function getNodeDocument(node) {
	return node.ownerDocument ?? null;
}
function createRangeForNode(node) {
	return getNodeDocument(node)?.createRange() ?? null;
}
function isVisibleRect(rect) {
	return rect.width > 0 && rect.height > 0;
}
function isRtlLine(lineEl) {
	return getComputedStyle(lineEl).direction === "rtl";
}
function readPmRange(el) {
	return {
		start: Number(el.dataset.pmStart ?? "NaN"),
		end: Number(el.dataset.pmEnd ?? "NaN")
	};
}
function getInlineSdtWrapperBoundaryPos(spanEl, side) {
	if (!(spanEl instanceof HTMLElement)) return null;
	const wrapper = spanEl.closest(`.${CLASS.inlineSdtWrapper}`);
	if (!wrapper) return null;
	const { start: start$1, end: end$1 } = readPmRange(wrapper);
	if (!Number.isFinite(start$1) || !Number.isFinite(end$1)) return null;
	return side === "before" ? start$1 - 1 : end$1 + 1;
}
function isStructuredContentChromeLabel(el) {
	return STRUCTURED_CONTENT_CHROME_LABEL_CLASS_NAMES.some((className) => el.classList.contains(className));
}
function getClickableSpans(lineEl) {
	return Array.from(lineEl.querySelectorAll("span, a")).filter((el) => el.dataset.pmStart !== void 0 && el.dataset.pmEnd !== void 0 && !el.classList.contains(CLASS.inlineSdtWrapper) && !isStructuredContentChromeLabel(el));
}
function clickToPositionDom(domContainer, clientX, clientY) {
	log("=== clickToPositionDom START ===", {
		clientX,
		clientY
	});
	const pageEl = findPageElement(domContainer, clientX, clientY);
	if (!pageEl) {
		log("No page element found");
		return null;
	}
	log("Page found:", { pageIndex: pageEl.dataset.pageIndex });
	const doc$1 = getContainerDocument(domContainer);
	if (!doc$1) {
		log("No owner document found");
		return null;
	}
	const hitChain = safeElementsFromPoint(doc$1, clientX, clientY);
	if (!Array.isArray(hitChain)) {
		log("elementsFromPoint returned non-array");
		return null;
	}
	logHitChain(hitChain);
	const fragmentEl = hitChain.find((el) => el.classList?.contains?.(CLASS.fragment));
	if (!fragmentEl) {
		if (hasElementsFromPoint(doc$1)) {
			log("No fragment in hit chain; deferring to geometry");
			return null;
		}
		const fallback = pageEl.querySelector(`.${CLASS.fragment}`);
		if (!fallback) return null;
		log("Using fallback fragment (no elementsFromPoint)");
		return resolveFragment(fallback, clientX, clientY);
	}
	const hitChainLine = hitChain.find((el) => el.classList?.contains?.(CLASS.line) && el.dataset?.pmStart !== void 0 && el.dataset?.pmEnd !== void 0);
	if (hitChainLine) {
		log("Using hit-chain line directly");
		return resolveLineAtX(hitChainLine, clientX);
	}
	if (fragmentEl.classList.contains(CLASS.tableFragment)) {
		const scopedContainer = findScopedLineContainer(hitChain, fragmentEl);
		if (scopedContainer) {
			log("Resolving table click from scoped line container");
			return resolveFromLines(getLinesInPageFragment(scopedContainer, pageEl, fragmentEl), clientX, clientY);
		}
	}
	if (fragmentEl.classList.contains(CLASS.tableFragment)) {
		log("Table fragment without line in hit chain — deferring to geometry");
		return null;
	}
	return resolveFragment(fragmentEl, clientX, clientY);
}
function resolvePositionWithinFragmentDom(fragmentEl, clientX, clientY) {
	if (!fragmentEl.classList?.contains?.(CLASS.fragment)) return null;
	return resolveFragment(fragmentEl, clientX, clientY);
}
function findPageElement(domContainer, clientX, clientY) {
	if (domContainer.classList?.contains?.(CLASS.page)) return domContainer;
	const doc$1 = getContainerDocument(domContainer);
	if (!doc$1) return null;
	const pageFromHit = safeElementsFromPoint(doc$1, clientX, clientY).find((el) => el.classList?.contains?.(CLASS.page));
	if (pageFromHit) return pageFromHit;
	const pages = Array.from(domContainer.querySelectorAll(`.${CLASS.page}`));
	for (const page of pages) {
		const r$1 = page.getBoundingClientRect();
		if (clientX >= r$1.left && clientX <= r$1.right && clientY >= r$1.top && clientY <= r$1.bottom) return page;
	}
	return pages[0] ?? null;
}
function readLayoutEpochFromDom(domContainer, clientX, clientY) {
	const doc$1 = getContainerDocument(domContainer);
	if (!doc$1 || !hasElementsFromPoint(doc$1)) return null;
	const hitChain = safeElementsFromPoint(doc$1, clientX, clientY);
	let latestEpoch = null;
	for (const el of hitChain) {
		if (!(el instanceof HTMLElement)) continue;
		if (!domContainer.contains(el)) continue;
		const epoch = Number(el.dataset.layoutEpoch);
		if (!Number.isFinite(epoch)) continue;
		if (latestEpoch == null || epoch > latestEpoch) latestEpoch = epoch;
	}
	return latestEpoch;
}
function resolveFragment(fragmentEl, viewX, viewY) {
	return resolveFromLines(Array.from(fragmentEl.querySelectorAll(`.${CLASS.line}`)), viewX, viewY);
}
function resolveFromLines(lineEls, viewX, viewY) {
	if (lineEls.length === 0) {
		log("No lines in fragment");
		return null;
	}
	const lineEl = findLineAtY(lineEls, viewY);
	if (!lineEl) return null;
	return resolveLineAtX(lineEl, viewX);
}
function resolveTextBoundaryWithinFragmentDom(fragmentEl, clientX, clientY) {
	if (!fragmentEl.classList?.contains?.(CLASS.fragment)) return null;
	const lineEls = Array.from(fragmentEl.querySelectorAll(`.${CLASS.line}`));
	if (lineEls.length === 0) return null;
	const lineEl = findLineAtY(lineEls, clientY);
	if (!lineEl) return null;
	return resolveLineTextBoundaryAtX(lineEl, clientX);
}
function getLinesInPageFragment(containerEl, pageEl, fragmentEl) {
	return Array.from(containerEl.querySelectorAll(`.${CLASS.line}`)).filter((lineEl) => {
		if (lineEl.dataset.pmStart === void 0 || lineEl.dataset.pmEnd === void 0) return false;
		return lineEl.closest(`.${CLASS.page}`) === pageEl && lineEl.closest(`.${CLASS.tableFragment}`) === fragmentEl;
	});
}
function resolveLineAtX(lineEl, viewX) {
	const { start: lineStart, end: lineEnd } = readPmRange(lineEl);
	if (!Number.isFinite(lineStart) || !Number.isFinite(lineEnd)) {
		log("Line has invalid PM positions");
		return null;
	}
	return resolvePositionInLine(lineEl, lineStart, lineEnd, getClickableSpans(lineEl), viewX);
}
function resolveLineTextBoundaryAtX(lineEl, viewX) {
	const spanEls = getClickableSpans(lineEl);
	if (spanEls.length === 0) return null;
	const rtl = isRtlLine(lineEl);
	const allRects = spanEls.map((el) => el.getBoundingClientRect());
	const visibleRects = allRects.filter(isVisibleRect);
	const boundsRects = visibleRects.length > 0 ? visibleRects : allRects;
	const visualLeft = Math.min(...boundsRects.map((r$1) => r$1.left));
	const visualRight = Math.max(...boundsRects.map((r$1) => r$1.right));
	if (viewX <= visualLeft) return resolveElementBoundary(rtl ? spanEls[spanEls.length - 1] : spanEls[0], rtl ? "after" : "before");
	if (viewX >= visualRight) return resolveElementBoundary(rtl ? spanEls[0] : spanEls[spanEls.length - 1], rtl ? "before" : "after");
	const targetEl = findSpanAtX(spanEls, viewX);
	if (!targetEl) return null;
	const textNode = findFirstTextNode(targetEl);
	if (!textNode || !textNode.textContent) {
		const targetRect = targetEl.getBoundingClientRect();
		const closerToLeft = Math.abs(viewX - targetRect.left) <= Math.abs(viewX - targetRect.right);
		return resolveElementBoundary(targetEl, rtl ? closerToLeft ? "after" : "before" : closerToLeft ? "before" : "after");
	}
	return {
		node: textNode,
		offset: findCharIndexAtX(textNode, viewX, rtl)
	};
}
function resolvePositionInLine(lineEl, lineStart, lineEnd, spanEls, viewX) {
	if (spanEls.length === 0) {
		log("No spans in line, returning lineStart:", lineStart);
		return lineStart;
	}
	const rtl = isRtlLine(lineEl);
	const allRects = spanEls.map((el) => el.getBoundingClientRect());
	const visibleRects = allRects.filter(isVisibleRect);
	const boundsRects = visibleRects.length > 0 ? visibleRects : allRects;
	const visualLeft = Math.min(...boundsRects.map((r$1) => r$1.left));
	const visualRight = Math.max(...boundsRects.map((r$1) => r$1.right));
	if (viewX <= visualLeft) return getInlineSdtWrapperBoundaryPos(rtl ? spanEls[spanEls.length - 1] : spanEls[0], rtl ? "after" : "before") ?? (rtl ? lineEnd : lineStart);
	if (viewX >= visualRight) return getInlineSdtWrapperBoundaryPos(rtl ? spanEls[0] : spanEls[spanEls.length - 1], rtl ? "before" : "after") ?? (rtl ? lineStart : lineEnd);
	const targetEl = findSpanAtX(spanEls, viewX);
	if (!targetEl) return lineStart;
	const targetIndex = spanEls.indexOf(targetEl);
	if (targetIndex < 0) return lineStart;
	const { start: spanStart, end: spanEnd } = readPmRange(targetEl);
	if (!Number.isFinite(spanStart) || !Number.isFinite(spanEnd)) return null;
	if (targetEl.classList.contains(CLASS.emptySdtPlaceholder)) return spanStart;
	const rightCaretBoundary = resolveRightCaretBoundary(spanEls, targetIndex, spanStart, spanEnd);
	const firstChild = targetEl.firstChild;
	if (!firstChild || firstChild.nodeType !== Node.TEXT_NODE || !firstChild.textContent) {
		const targetRect = targetEl.getBoundingClientRect();
		const closerToLeft = Math.abs(viewX - targetRect.left) <= Math.abs(viewX - targetRect.right);
		return rtl ? closerToLeft ? rightCaretBoundary : spanStart : closerToLeft ? spanStart : rightCaretBoundary;
	}
	const textNode = firstChild;
	const charIndex = findCharIndexAtX(textNode, viewX, rtl);
	return mapCharIndexToPm(spanStart, spanEnd, rightCaretBoundary, textNode.length, charIndex);
}
function resolveElementBoundary(element, side) {
	if (!(element instanceof HTMLElement)) return null;
	const textNode = findFirstTextNode(element);
	if (!textNode) return null;
	return {
		node: textNode,
		offset: side === "before" ? 0 : textNode.textContent?.length ?? 0
	};
}
function findFirstTextNode(element) {
	const doc$1 = getNodeDocument(element);
	if (!doc$1) return null;
	const node = doc$1.createTreeWalker(element, NodeFilter.SHOW_TEXT).nextNode();
	return node instanceof Text ? node : null;
}
function resolveRightCaretBoundary(spanEls, targetIndex, spanStart, spanEnd) {
	for (let index = targetIndex + 1; index < spanEls.length; index += 1) {
		const { start: nextStart } = readPmRange(spanEls[index]);
		if (!Number.isFinite(nextStart)) continue;
		if (nextStart > spanEnd) return nextStart;
		break;
	}
	return spanEnd;
}
function findLineAtY(lineEls, viewY) {
	if (lineEls.length === 0) return null;
	let nearest = lineEls[0];
	let minDistance = Infinity;
	for (const lineEl of lineEls) {
		const r$1 = lineEl.getBoundingClientRect();
		if (viewY >= r$1.top && viewY <= r$1.bottom) return lineEl;
		const distance = viewY < r$1.top ? r$1.top - viewY : Math.max(0, viewY - r$1.bottom);
		if (distance < minDistance) {
			minDistance = distance;
			nearest = lineEl;
		}
	}
	return nearest;
}
function findSpanAtX(spanEls, viewX) {
	if (spanEls.length === 0) return null;
	let nearest = spanEls[0];
	let minDist = Infinity;
	for (const span of spanEls) {
		const r$1 = span.getBoundingClientRect();
		if (!isVisibleRect(r$1)) continue;
		if (viewX >= r$1.left && viewX <= r$1.right) return span;
		const dist = Math.min(Math.abs(viewX - r$1.left), Math.abs(viewX - r$1.right));
		if (dist < minDist) {
			minDist = dist;
			nearest = span;
		}
	}
	return nearest;
}
function findScopedLineContainer(hitChain, fragmentEl) {
	for (const el of hitChain) {
		if (!(el instanceof HTMLElement)) continue;
		if (el === fragmentEl) break;
		if (!fragmentEl.contains(el)) continue;
		if (el.querySelector(`.${CLASS.line}`)) return el;
	}
	return null;
}
function mapCharIndexToPm(spanStart, spanEnd, rightCaretBoundary, textLength, charIndex) {
	if (!Number.isFinite(spanStart) || !Number.isFinite(spanEnd)) return spanStart;
	if (textLength <= 0) return spanStart;
	const pmRange = spanEnd - spanStart;
	if (!Number.isFinite(pmRange) || pmRange <= 0) return spanStart;
	const safeRightBoundary = Number.isFinite(rightCaretBoundary) && rightCaretBoundary >= spanEnd ? rightCaretBoundary : spanEnd;
	const clampedIndex = Math.max(0, Math.min(textLength, charIndex));
	if (safeRightBoundary > spanEnd) {
		if (clampedIndex >= textLength) return safeRightBoundary;
		const directPos = spanStart + clampedIndex;
		if (directPos <= spanEnd) return directPos;
	}
	if (pmRange === textLength) return Math.min(spanEnd, Math.max(spanStart, spanStart + clampedIndex));
	return clampedIndex / textLength <= .5 ? spanStart : safeRightBoundary;
}
function findCharIndexAtX(textNode, targetX, rtl) {
	const text = textNode.textContent ?? "";
	if (text.length === 0) return 0;
	const container = textNode.parentElement;
	if (!container) return 0;
	const containerRect = container.getBoundingClientRect();
	const caretIndex = caretOffsetFromPoint(targetX, containerRect.top + containerRect.height / 2, textNode);
	if (caretIndex != null) return caretIndex;
	return binarySearchCharIndex(textNode, text.length, targetX, rtl, containerRect);
}
function caretOffsetFromPoint(x, y$1, expectedNode) {
	const doc$1 = getNodeDocument(expectedNode);
	if (!doc$1) return null;
	if (typeof doc$1.caretPositionFromPoint === "function") {
		const cp = doc$1.caretPositionFromPoint(x, y$1);
		if (cp && cp.offsetNode === expectedNode) return cp.offset;
	}
	if (typeof doc$1.caretRangeFromPoint === "function") {
		const r$1 = doc$1.caretRangeFromPoint(x, y$1);
		if (r$1 && r$1.startContainer === expectedNode) return r$1.startOffset;
	}
	return null;
}
function binarySearchCharIndex(textNode, length$1, targetX, rtl, containerRect) {
	const range = createRangeForNode(textNode);
	if (!range) return 0;
	const measureX = (i) => {
		if (i <= 0) return rtl ? containerRect.right : containerRect.left;
		range.setStart(textNode, 0);
		range.setEnd(textNode, i);
		const r$1 = range.getBoundingClientRect();
		return rtl ? r$1.left : r$1.right;
	};
	let lo = 0;
	let hi = length$1;
	while (lo < hi) {
		const mid = Math.floor((lo + hi) / 2);
		if (rtl ? measureX(mid) > targetX : measureX(mid) < targetX) lo = mid + 1;
		else hi = mid;
	}
	const index = Math.max(0, Math.min(length$1, lo));
	if (index > 0 && Math.abs(measureX(index - 1) - targetX) < Math.abs(measureX(index) - targetX)) return index - 1;
	return index;
}
function logHitChain(hitChain) {}
function getPageOffsets(options) {
	if (!options.painterHost || !options.viewportHost) return null;
	const pageEl = getPageElementByIndex(options.painterHost, options.pageIndex);
	if (!pageEl) return null;
	const pageRect = pageEl.getBoundingClientRect();
	const viewportRect = options.viewportHost.getBoundingClientRect();
	return {
		x: (pageRect.left - viewportRect.left) / options.zoom,
		y: (pageRect.top - viewportRect.top) / options.zoom
	};
}
function getPageOffsetX(options) {
	return getPageOffsets(options)?.x ?? null;
}
function getPageOffsetY(options) {
	return getPageOffsets(options)?.y ?? null;
}
function convertPageLocalToOverlayCoords(options) {
	if (!Number.isFinite(options.pageIndex) || options.pageIndex < 0) {
		console.warn(`[PresentationEditor] #convertPageLocalToOverlayCoords: Invalid pageIndex ${options.pageIndex}. Expected a finite non-negative number.`);
		return null;
	}
	if (!Number.isFinite(options.pageLocalX)) {
		console.warn(`[PresentationEditor] #convertPageLocalToOverlayCoords: Invalid pageLocalX ${options.pageLocalX}. Expected a finite number.`);
		return null;
	}
	if (!Number.isFinite(options.pageLocalY)) {
		console.warn(`[PresentationEditor] #convertPageLocalToOverlayCoords: Invalid pageLocalY ${options.pageLocalY}. Expected a finite number.`);
		return null;
	}
	const pageOffsets = getPageOffsets({
		painterHost: options.painterHost,
		viewportHost: options.viewportHost,
		zoom: options.zoom,
		pageIndex: options.pageIndex
	});
	if (pageOffsets) return {
		x: pageOffsets.x + options.pageLocalX,
		y: pageOffsets.y + options.pageLocalY
	};
	return {
		x: options.pageLocalX,
		y: options.pageIndex * (options.pageHeight + options.pageGap) + options.pageLocalY
	};
}
function normalizeClientPoint(options, clientX, clientY) {
	if (!Number.isFinite(clientX) || !Number.isFinite(clientY)) return null;
	const rect = options.viewportHost.getBoundingClientRect();
	const scrollLeft = options.visibleHost.scrollLeft ?? 0;
	const scrollTop = options.visibleHost.scrollTop ?? 0;
	const baseX = (clientX - rect.left + scrollLeft) / options.zoom;
	const baseY = (clientY - rect.top + scrollTop) / options.zoom;
	let adjustedX = baseX;
	let detectedPageIndex;
	let pageLocalY;
	const doc$1 = options.visibleHost.ownerDocument ?? document;
	const hitChain = typeof doc$1.elementsFromPoint === "function" ? doc$1.elementsFromPoint(clientX, clientY) : [];
	const pageEl = Array.isArray(hitChain) ? hitChain.find((el) => el?.classList?.contains("superdoc-page")) : null;
	if (pageEl) {
		const pageIndex = Number(pageEl.dataset.pageIndex ?? "NaN");
		if (Number.isFinite(pageIndex)) {
			detectedPageIndex = pageIndex;
			const pageOffsetX = options.getPageOffsetX(pageIndex);
			if (pageOffsetX != null) adjustedX = baseX - pageOffsetX;
			pageLocalY = (clientY - pageEl.getBoundingClientRect().top) / options.zoom;
		}
	}
	return {
		x: adjustedX,
		y: baseY,
		pageIndex: detectedPageIndex,
		pageLocalY
	};
}
function denormalizeClientPoint(options, layoutX, layoutY, pageIndex, height) {
	if (!Number.isFinite(layoutX) || !Number.isFinite(layoutY)) return null;
	let pageOffsetX = 0;
	let pageOffsetY = 0;
	if (Number.isFinite(pageIndex)) {
		pageOffsetX = options.getPageOffsetX(Number(pageIndex)) ?? 0;
		pageOffsetY = options.getPageOffsetY(Number(pageIndex)) ?? 0;
	}
	const rect = options.viewportHost.getBoundingClientRect();
	const scrollLeft = options.visibleHost.scrollLeft ?? 0;
	const scrollTop = options.visibleHost.scrollTop ?? 0;
	const result = {
		x: (layoutX + pageOffsetX) * options.zoom + rect.left - scrollLeft,
		y: (layoutY + pageOffsetY) * options.zoom + rect.top - scrollTop
	};
	if (Number.isFinite(height)) result["height"] = height * options.zoom;
	return result;
}
function inchesToPx(value) {
	if (value == null) return void 0;
	const num = Number(value);
	if (!Number.isFinite(num)) return void 0;
	return num * 96;
}
function parseColumns(raw) {
	if (!raw || typeof raw !== "object") return void 0;
	const columnSource = raw;
	const rawCount = Number(columnSource.count ?? columnSource.num ?? columnSource.numberOfColumns ?? 1);
	if (!Number.isFinite(rawCount) || rawCount <= 1) return;
	return {
		count: Math.max(1, Math.floor(rawCount)),
		gap: inchesToPx(columnSource.space ?? columnSource.gap) ?? 0,
		withSeparator: typeof columnSource.withSeparator === "boolean" ? columnSource.withSeparator : false
	};
}
function createLayoutMetrics(perf, startMark, layout, blocks) {
	if (!perf || startMark == null || typeof perf.now !== "function") return;
	return {
		durationMs: Math.max(0, perf.now() - startMark),
		blockCount: blocks.length,
		pageCount: layout.pages?.length ?? 0
	};
}
function computeNoteNumbering(editorState, noteTypeName, options) {
	const numberById = {};
	const formatById = {};
	const order$1 = [];
	if (!editorState) return {
		numberById,
		order: order$1
	};
	const seen = /* @__PURE__ */ new Set();
	const sectionConfigs = options.sectionConfigs ?? /* @__PURE__ */ new Map();
	const refPageById = options.refPageById;
	let sectionIndex = 0;
	let lastPage = null;
	let anyOverride = false;
	const restartFor = (s) => sectionConfigs.get(s)?.numRestart ?? options.defaultRestart ?? "continuous";
	const numStartFor = (s) => sectionConfigs.get(s)?.numStart ?? options.startCounter;
	const numFmtFor = (s) => sectionConfigs.get(s)?.numFmt ?? options.defaultNumFmt;
	let counter = numStartFor(0);
	try {
		editorState.doc?.descendants?.((node) => {
			const typeName = node?.type?.name;
			if (typeName === "sectionBreak") {
				const nextSection = sectionIndex + 1;
				const nextRestart = restartFor(nextSection);
				if (nextRestart === "eachSect" || nextRestart === "eachPage") {
					counter = numStartFor(nextSection);
					lastPage = null;
				}
				sectionIndex = nextSection;
				return;
			}
			if (typeName !== noteTypeName) return;
			const rawId = node?.attrs?.id;
			if (rawId == null) return;
			const key = String(rawId);
			if (!key || seen.has(key)) return;
			seen.add(key);
			order$1.push(key);
			if (isCustomMarkFollows(node?.attrs?.customMarkFollows)) return;
			if (refPageById && restartFor(sectionIndex) === "eachPage") {
				const thisPage = refPageById.get(key) ?? 0;
				if (lastPage !== null && thisPage !== lastPage) counter = numStartFor(sectionIndex);
				lastPage = thisPage;
			}
			numberById[key] = counter;
			const fmt = numFmtFor(sectionIndex);
			if (fmt) {
				formatById[key] = fmt;
				if (sectionConfigs.has(sectionIndex) && sectionConfigs.get(sectionIndex)?.numFmt) anyOverride = true;
			}
			counter += 1;
		});
	} catch (_$1) {}
	return anyOverride ? {
		numberById,
		formatById,
		order: order$1
	} : {
		numberById,
		order: order$1
	};
}
function isCustomMarkFollows(value) {
	if (value === true || value === 1) return true;
	if (typeof value !== "string") return false;
	const v = value.trim().toLowerCase();
	return v === "1" || v === "true" || v === "on";
}
var FOOTNOTE_MARKER_DATA_ATTR = "data-sd-footnote-number";
var DEFAULT_MARKER_FONT_FAMILY$1 = "Arial";
var DEFAULT_MARKER_FONT_SIZE$1 = 12;
function buildFootnotesInput(editorState, converter, converterContext, themeColors, renderOverride = null, resolveTrackedChangeColor) {
	if (!editorState) return null;
	const footnoteNumberById = converterContext?.footnoteNumberById;
	const footnoteNumberFormat = converterContext?.footnoteNumberFormat;
	const footnoteFormatById = converterContext?.footnoteFormatById;
	const importedFootnotes = Array.isArray(converter?.footnotes) ? converter.footnotes : [];
	if (importedFootnotes.length === 0) return null;
	const refs = [];
	const idsInUse = /* @__PURE__ */ new Set();
	const customMarkIds = /* @__PURE__ */ new Set();
	editorState.doc.descendants((node, pos) => {
		if (node.type?.name !== "footnoteReference") return;
		const id = node.attrs?.id;
		if (id == null) return;
		const key = String(id);
		const insidePos = Math.min(pos + 1, editorState.doc.content.size);
		refs.push({
			id: key,
			pos: insidePos
		});
		idsInUse.add(key);
		if (isCustomMarkFollows(node.attrs?.customMarkFollows)) customMarkIds.add(key);
	});
	if (refs.length === 0) return null;
	const blocksById = /* @__PURE__ */ new Map();
	idsInUse.forEach((id) => {
		try {
			const footnoteDoc = resolveNoteDocJson(id, importedFootnotes, renderOverride);
			if (!footnoteDoc) return;
			const result = toFlowBlocks(footnoteDoc, {
				blockIdPrefix: `footnote-${id}-`,
				storyKey: buildStoryKey({
					kind: "story",
					storyType: "footnote",
					noteId: id
				}),
				enableRichHyperlinks: true,
				themeColors,
				converterContext,
				resolveTrackedChangeColor
			});
			if (result?.blocks?.length) {
				if (!customMarkIds.has(id)) {
					const numFmtForId = footnoteFormatById?.[id] ?? footnoteNumberFormat;
					ensureFootnoteMarker(result.blocks, id, footnoteNumberById, numFmtForId);
				}
				blocksById.set(id, result.blocks);
			}
		} catch (_$1) {}
	});
	if (blocksById.size === 0) return null;
	return {
		refs,
		blocksById,
		gap: 2,
		topPadding: 4,
		dividerHeight: 1
	};
}
function isFootnoteMarker(run) {
	return Boolean(run.dataAttrs?.[FOOTNOTE_MARKER_DATA_ATTR]);
}
function resolveDisplayNumber$1(id, footnoteNumberById) {
	if (!footnoteNumberById || typeof footnoteNumberById !== "object") return 1;
	const num = footnoteNumberById[id];
	if (typeof num === "number" && Number.isFinite(num) && num > 0) return num;
	return 1;
}
function resolveMarkerFontFamily$1(firstTextRun) {
	return typeof firstTextRun?.fontFamily === "string" ? firstTextRun.fontFamily : DEFAULT_MARKER_FONT_FAMILY$1;
}
function resolveMarkerBaseFontSize$1(firstTextRun) {
	if (typeof firstTextRun?.fontSize === "number" && Number.isFinite(firstTextRun.fontSize) && firstTextRun.fontSize > 0) return firstTextRun.fontSize;
	return DEFAULT_MARKER_FONT_SIZE$1;
}
function buildMarkerRun$1(markerText, firstTextRun) {
	const markerRun = {
		kind: "text",
		text: `${markerText}\u00A0`,
		dataAttrs: { [FOOTNOTE_MARKER_DATA_ATTR]: "true" },
		fontFamily: resolveMarkerFontFamily$1(firstTextRun),
		fontSize: resolveMarkerBaseFontSize$1(firstTextRun) * SUBSCRIPT_SUPERSCRIPT_SCALE,
		vertAlign: "superscript"
	};
	if (firstTextRun?.color != null) markerRun.color = firstTextRun.color;
	return markerRun;
}
function cloneJsonValue$1(value) {
	return JSON.parse(JSON.stringify(value));
}
function cloneNoteContentJson$1(content) {
	return cloneJsonValue$1(content);
}
function resolveNoteDocJson(id, importedFootnotes, renderOverride) {
	if (renderOverride && renderOverride.noteId === id) return normalizeNotePmJson(cloneJsonValue$1(renderOverride.docJson));
	const content = findNoteEntryById(importedFootnotes, id)?.content;
	if (!Array.isArray(content) || content.length === 0) return null;
	return normalizeNotePmJson({
		type: "doc",
		content: cloneNoteContentJson$1(content)
	});
}
function syncMarkerRun$1(target, source) {
	target.kind = source.kind;
	target.text = source.text;
	target.dataAttrs = source.dataAttrs;
	target.fontFamily = source.fontFamily;
	target.fontSize = source.fontSize;
	target.bold = source.bold;
	target.italic = source.italic;
	target.letterSpacing = source.letterSpacing;
	target.color = source.color;
	target.vertAlign = source.vertAlign;
	target.baselineShift = source.baselineShift;
	delete target.pmStart;
	delete target.pmEnd;
}
function ensureFootnoteMarker(blocks, id, footnoteNumberById, footnoteNumberFormat) {
	const firstParagraph = blocks.find((b$1) => b$1?.kind === "paragraph");
	if (!firstParagraph) return;
	const runs = Array.isArray(firstParagraph.runs) ? firstParagraph.runs : [];
	const normalizedMarkerRun = buildMarkerRun$1(formatFootnoteCardinal(resolveDisplayNumber$1(id, footnoteNumberById), footnoteNumberFormat), runs.find((run) => typeof run.text === "string" && !isFootnoteMarker(run)));
	const existingMarker = runs.find(isFootnoteMarker);
	if (existingMarker) {
		syncMarkerRun$1(existingMarker, normalizedMarkerRun);
		return;
	}
	runs.unshift(normalizedMarkerRun);
	firstParagraph.runs = runs;
}
function safeCleanup(fn, context) {
	try {
		fn();
	} catch (error) {
		console.warn(`[PresentationEditor] ${context} cleanup failed:`, error);
	}
}
function createHiddenHost(doc$1, widthPx) {
	const wrapper = doc$1.createElement("div");
	wrapper.className = "presentation-editor__hidden-host-wrapper";
	wrapper.style.setProperty("position", "fixed");
	wrapper.style.setProperty("left", "-9999px");
	wrapper.style.setProperty("top", "0");
	wrapper.style.setProperty("width", "1px");
	wrapper.style.setProperty("height", "1px");
	wrapper.style.setProperty("overflow", "hidden");
	wrapper.style.setProperty("opacity", "0");
	wrapper.style.setProperty("z-index", "-1");
	wrapper.style.setProperty("pointer-events", "none");
	const host = doc$1.createElement("div");
	host.className = "presentation-editor__hidden-host";
	host.style.setProperty("position", "absolute");
	host.style.setProperty("left", "0");
	host.style.setProperty("top", "0");
	if (widthPx >= 0) host.style.setProperty("width", `${widthPx}px`);
	host.style.setProperty("overflow-anchor", "none");
	host.style.setProperty("user-select", "none");
	wrapper.appendChild(host);
	return {
		wrapper,
		host
	};
}
function findRenderedCommentElements(host, commentId, storyKey) {
	if (!host || !commentId) return [];
	return Array.from(host.querySelectorAll("[data-comment-ids]")).filter((el) => {
		const raw = el.dataset.commentIds;
		if (!raw) return false;
		if (!raw.split(",").some((token$1) => token$1.trim() === commentId)) return false;
		if (!storyKey) return true;
		const elStoryKey = el.dataset.storyKey;
		if (elStoryKey) return elStoryKey === storyKey;
		return storyKey === BODY_STORY_KEY;
	});
}
function findRenderedTrackedChangeElementsStrict(host, entityId, escapeAttrValue$1, storyKey) {
	if (!host || !entityId) return [];
	const baseSelector = `[data-track-change-id="${escapeAttrValue$1(entityId)}"]`;
	if (!storyKey) return Array.from(host.querySelectorAll(baseSelector));
	const storySelector = `${baseSelector}[data-story-key="${escapeAttrValue$1(storyKey)}"]`;
	return Array.from(host.querySelectorAll(storySelector));
}
function findRenderedContentControlElements(host, entityId, escapeAttrValue$1, _storyKey) {
	if (!host || !entityId) return [];
	const id = escapeAttrValue$1(entityId);
	const selector = `.${DOM_CLASS_NAMES.INLINE_SDT_WRAPPER}[data-sdt-id="${id}"][data-sdt-type="structuredContent"],.${DOM_CLASS_NAMES.BLOCK_SDT}[data-sdt-id="${id}"][data-sdt-type="structuredContent"]`;
	return Array.from(host.querySelectorAll(selector));
}
function elementsToRangeRects(elements) {
	const result = [];
	for (const element of elements) {
		const rect = element.getBoundingClientRect();
		if (![
			rect.top,
			rect.left,
			rect.right,
			rect.bottom,
			rect.width,
			rect.height
		].every(Number.isFinite)) continue;
		const pageEl = element.closest(".superdoc-page");
		const pageIndexAttr = Number(pageEl?.dataset?.pageIndex ?? 0);
		result.push({
			pageIndex: Number.isFinite(pageIndexAttr) ? pageIndexAttr : 0,
			left: rect.left,
			top: rect.top,
			right: rect.right,
			bottom: rect.bottom,
			width: rect.width,
			height: rect.height
		});
	}
	return result;
}
function getFallbackCursorColor(clientId, fallbackColors) {
	return fallbackColors[clientId % fallbackColors.length];
}
function validateCursorColor(color, clientId, fallbackColors) {
	return color.match(/^#[0-9A-Fa-f]{6}$/) ? color : getFallbackCursorColor(clientId, fallbackColors);
}
function normalizeAwarenessStates(options) {
	const provider = options.provider;
	if (!provider?.awareness) return /* @__PURE__ */ new Map();
	const editorState = options.editorState;
	if (!editorState) return /* @__PURE__ */ new Map();
	const ystate = ySyncPluginKey.getState(editorState);
	if (!ystate) return /* @__PURE__ */ new Map();
	const states = provider.awareness?.getStates?.();
	const normalized = /* @__PURE__ */ new Map();
	const localClientId = provider.awareness?.clientID ?? provider.awareness?.doc?.clientID;
	states?.forEach((aw, clientId) => {
		if (localClientId != null && clientId === localClientId) return;
		const awState = aw;
		if (!awState.cursor) return;
		try {
			const anchor = relativePositionToAbsolutePosition(ystate.doc, ystate.type, Y.createRelativePositionFromJSON(awState.cursor.anchor), ystate.binding.mapping);
			const head = relativePositionToAbsolutePosition(ystate.doc, ystate.type, Y.createRelativePositionFromJSON(awState.cursor.head), ystate.binding.mapping);
			if (anchor === null || head === null) return;
			const docSize = editorState.doc.content.size;
			const clampedAnchor = Math.max(0, Math.min(anchor, docSize));
			const clampedHead = Math.max(0, Math.min(head, docSize));
			const previousState = options.previousState.get(clientId);
			const positionChanged = !previousState || previousState.anchor !== clampedAnchor || previousState.head !== clampedHead;
			normalized.set(clientId, {
				clientId,
				user: {
					name: awState.user?.name,
					email: awState.user?.email,
					color: awState.user?.color || getFallbackCursorColor(clientId, options.fallbackColors)
				},
				anchor: clampedAnchor,
				head: clampedHead,
				updatedAt: positionChanged ? Date.now() : previousState?.updatedAt ?? Date.now()
			});
		} catch (error) {
			console.warn(`Failed to normalize cursor for client ${clientId}:`, error);
		}
	});
	const staleThreshold = Date.now() - options.staleTimeoutMs;
	const staleClients = [];
	options.previousState.forEach((cursor, clientId) => {
		if (cursor.updatedAt < staleThreshold && !normalized.has(clientId)) staleClients.push(clientId);
	});
	staleClients.forEach((clientId) => {
		options.previousState.delete(clientId);
	});
	return normalized;
}
function renderRemoteCursors(options) {
	const layout = options.layout;
	const blocks = options.blocks;
	const measures = options.measures;
	const maxVisible = options.presence?.maxVisible ?? 20;
	const sortedCursors = Array.from(options.remoteCursorState.values()).sort((a, b$1) => b$1.updatedAt - a.updatedAt).slice(0, maxVisible);
	const visibleClientIds = /* @__PURE__ */ new Set();
	sortedCursors.forEach((cursor) => {
		visibleClientIds.add(cursor.clientId);
		(options.remoteCursorOverlay?.querySelectorAll(`.presentation-editor__remote-selection[data-client-id="${cursor.clientId}"]`))?.forEach((el) => el.remove());
		if (cursor.anchor === cursor.head) renderRemoteCaret({
			cursor,
			presence: options.presence,
			remoteCursorElements: options.remoteCursorElements,
			remoteCursorOverlay: options.remoteCursorOverlay,
			doc: options.doc,
			computeCaretLayoutRect: options.computeCaretLayoutRect,
			convertPageLocalToOverlayCoords: options.convertPageLocalToOverlayCoords,
			fallbackColors: options.fallbackColors,
			cursorStyles: options.cursorStyles
		});
		else renderRemoteSelection({
			cursor,
			layout,
			blocks,
			measures,
			pageGeometryHelper: options.pageGeometryHelper,
			presence: options.presence,
			remoteCursorOverlay: options.remoteCursorOverlay,
			doc: options.doc,
			convertPageLocalToOverlayCoords: options.convertPageLocalToOverlayCoords,
			fallbackColors: options.fallbackColors,
			cursorStyles: options.cursorStyles,
			maxSelectionRectsPerUser: options.maxSelectionRectsPerUser,
			defaultPageHeight: options.defaultPageHeight,
			fallbackPageHeight: options.fallbackPageHeight,
			renderCaret: () => renderRemoteCaret({
				cursor,
				presence: options.presence,
				remoteCursorElements: options.remoteCursorElements,
				remoteCursorOverlay: options.remoteCursorOverlay,
				doc: options.doc,
				computeCaretLayoutRect: options.computeCaretLayoutRect,
				convertPageLocalToOverlayCoords: options.convertPageLocalToOverlayCoords,
				fallbackColors: options.fallbackColors,
				cursorStyles: options.cursorStyles
			})
		});
	});
	options.remoteCursorElements.forEach((element, clientId) => {
		if (!visibleClientIds.has(clientId)) {
			element.remove();
			options.remoteCursorElements.delete(clientId);
		}
	});
}
function renderRemoteCaret(options) {
	const caretLayout = options.computeCaretLayoutRect(options.cursor.head);
	const color = validateCursorColor(options.cursor.user.color, options.cursor.clientId, options.fallbackColors);
	let caretEl = options.remoteCursorElements.get(options.cursor.clientId);
	if (!caretEl) {
		caretEl = options.doc.createElement("div");
		caretEl.className = "presentation-editor__remote-caret";
		caretEl.style.position = "absolute";
		caretEl.style.width = `${options.cursorStyles.CARET_WIDTH}px`;
		caretEl.style.borderLeft = `${options.cursorStyles.CARET_WIDTH}px solid ${color}`;
		caretEl.style.pointerEvents = "none";
		caretEl.style.transition = "opacity 100ms ease-out";
		caretEl.style.willChange = "transform";
		caretEl.setAttribute("data-client-id", options.cursor.clientId.toString());
		caretEl.setAttribute("aria-hidden", "true");
		if (options.presence?.showLabels !== false) renderRemoteCursorLabel({
			caretEl,
			cursor: options.cursor,
			presence: options.presence,
			doc: options.doc,
			fallbackColors: options.fallbackColors,
			cursorStyles: options.cursorStyles
		});
		options.remoteCursorElements.set(options.cursor.clientId, caretEl);
		options.remoteCursorOverlay?.appendChild(caretEl);
	}
	if (!caretLayout) {
		caretEl.style.opacity = "0";
		return;
	}
	const coords = options.convertPageLocalToOverlayCoords(caretLayout.pageIndex, caretLayout.x, caretLayout.y);
	if (!coords) {
		caretEl.style.opacity = "0";
		return;
	}
	caretEl.style.opacity = "1";
	caretEl.style.transform = `translate(${coords.x}px, ${coords.y}px)`;
	caretEl.style.height = `${Math.max(1, caretLayout.height)}px`;
	caretEl.style.borderLeftColor = color;
	const labelEl = caretEl.querySelector(".presentation-editor__remote-label");
	if (labelEl) labelEl.style.backgroundColor = color;
}
function renderRemoteCursorLabel(options) {
	const labelFormatter = options.presence?.labelFormatter;
	let labelText = labelFormatter ? labelFormatter(options.cursor.user) : options.cursor.user.name || options.cursor.user.email || "Anonymous";
	if (labelText.length > options.cursorStyles.MAX_LABEL_LENGTH) labelText = labelText.substring(0, options.cursorStyles.MAX_LABEL_LENGTH - 1) + "…";
	const color = validateCursorColor(options.cursor.user.color, options.cursor.clientId, options.fallbackColors);
	const labelEl = options.doc.createElement("div");
	labelEl.className = "presentation-editor__remote-label";
	labelEl.textContent = labelText;
	labelEl.style.position = "absolute";
	labelEl.style.top = options.cursorStyles.LABEL_OFFSET;
	labelEl.style.left = "-1px";
	labelEl.style.fontSize = `${options.cursorStyles.LABEL_FONT_SIZE}px`;
	labelEl.style.backgroundColor = color;
	labelEl.style.color = "white";
	labelEl.style.padding = options.cursorStyles.LABEL_PADDING;
	labelEl.style.borderRadius = "3px";
	labelEl.style.whiteSpace = "nowrap";
	labelEl.style.pointerEvents = "none";
	labelEl.title = `${options.cursor.user.name || options.cursor.user.email} – editing`;
	options.caretEl.appendChild(labelEl);
}
function renderRemoteSelection(options) {
	const start$1 = Math.min(options.cursor.anchor, options.cursor.head);
	const end$1 = Math.max(options.cursor.anchor, options.cursor.head);
	const rects = selectionToRects(options.layout, options.blocks, options.measures, start$1, end$1, options.pageGeometryHelper ?? void 0) ?? [];
	const color = validateCursorColor(options.cursor.user.color, options.cursor.clientId, options.fallbackColors);
	const opacity = options.presence?.highlightOpacity ?? .35;
	const pageHeight = options.layout.pageSize?.h ?? options.fallbackPageHeight ?? options.defaultPageHeight;
	const pageGap = options.layout.pageGap ?? 0;
	rects.slice(0, options.maxSelectionRectsPerUser).forEach((rect) => {
		const pageLocalY = rect.y - rect.pageIndex * (pageHeight + pageGap);
		const coords = options.convertPageLocalToOverlayCoords(rect.pageIndex, rect.x, pageLocalY);
		if (!coords) return;
		const selectionEl = options.doc.createElement("div");
		selectionEl.className = "presentation-editor__remote-selection";
		selectionEl.style.position = "absolute";
		selectionEl.style.left = `${coords.x}px`;
		selectionEl.style.top = `${coords.y}px`;
		selectionEl.style.width = `${Math.max(1, rect.width)}px`;
		selectionEl.style.height = `${Math.max(1, rect.height)}px`;
		selectionEl.style.backgroundColor = color;
		selectionEl.style.opacity = opacity.toString();
		selectionEl.style.borderRadius = options.cursorStyles.SELECTION_BORDER_RADIUS;
		selectionEl.style.pointerEvents = "none";
		selectionEl.setAttribute("data-client-id", options.cursor.clientId.toString());
		selectionEl.setAttribute("aria-hidden", "true");
		options.remoteCursorOverlay?.appendChild(selectionEl);
	});
	options.renderCaret();
}
var SCROLL_DEBOUNCE_MS = 32;
var DEFAULT_STALE_TIMEOUT_MS = 300 * 1e3;
var THROTTLE_MS = 16;
var RemoteCursorManager = class {
	#options;
	#remoteCursorState = /* @__PURE__ */ new Map();
	#remoteCursorElements = /* @__PURE__ */ new Map();
	#remoteCursorDirty = false;
	#remoteCursorUpdateScheduled = false;
	#lastRemoteCursorRenderTime = 0;
	#remoteCursorThrottleTimeout = null;
	#awarenessCleanup = null;
	#scrollCleanup = null;
	#scrollTimeout = void 0;
	#isSetup = false;
	#onTelemetry = null;
	#onCursorsUpdate = null;
	constructor(options) {
		this.#options = options;
	}
	get state() {
		return this.#remoteCursorState;
	}
	get elements() {
		return this.#remoteCursorElements;
	}
	get isSetup() {
		return this.#isSetup;
	}
	setTelemetryCallback(callback) {
		this.#onTelemetry = callback;
	}
	setCursorsUpdateCallback(callback) {
		this.#onCursorsUpdate = callback;
	}
	setCollaborationProvider(provider) {
		this.#options.collaborationProvider = provider;
	}
	setup() {
		const awareness = this.#options.collaborationProvider?.awareness;
		if (!awareness || typeof awareness.on !== "function" || typeof awareness.off !== "function") {
			if (awareness) console.warn("[remote-cursors] provider.awareness is missing on/off methods; remote cursors will not be wired.");
			return;
		}
		this.#cleanupSubscriptions();
		const handleAwarenessChange = () => {
			this.#remoteCursorDirty = true;
			this.scheduleUpdate();
		};
		awareness.on("change", handleAwarenessChange);
		awareness.on("update", handleAwarenessChange);
		this.#awarenessCleanup = () => {
			awareness.off?.("change", handleAwarenessChange);
			awareness.off?.("update", handleAwarenessChange);
		};
		const handleScroll = () => {
			if (this.#remoteCursorState.size > 0) {
				this.#remoteCursorDirty = true;
				this.scheduleUpdate();
			}
		};
		const debouncedHandleScroll = () => {
			if (this.#scrollTimeout !== void 0) clearTimeout(this.#scrollTimeout);
			this.#scrollTimeout = window.setTimeout(handleScroll, SCROLL_DEBOUNCE_MS);
		};
		this.#options.visibleHost.addEventListener("scroll", debouncedHandleScroll, { passive: true });
		this.#scrollCleanup = () => {
			if (this.#scrollTimeout !== void 0) {
				clearTimeout(this.#scrollTimeout);
				this.#scrollTimeout = void 0;
			}
			this.#options.visibleHost.removeEventListener("scroll", debouncedHandleScroll);
		};
		this.#isSetup = true;
		handleAwarenessChange();
	}
	#cleanupSubscriptions() {
		if (this.#awarenessCleanup) {
			this.#awarenessCleanup();
			this.#awarenessCleanup = null;
		}
		if (this.#scrollCleanup) {
			this.#scrollCleanup();
			this.#scrollCleanup = null;
		}
	}
	markDirty() {
		this.#remoteCursorDirty = true;
	}
	scheduleUpdate() {
		if (this.#options.presence?.enabled === false) return;
		if (this.#remoteCursorUpdateScheduled) return;
		this.#remoteCursorUpdateScheduled = true;
		queueMicrotask(() => {
			if (!this.#remoteCursorUpdateScheduled) return;
			const now = performance.now();
			const elapsed = now - this.#lastRemoteCursorRenderTime;
			if (elapsed >= THROTTLE_MS) {
				if (this.#remoteCursorThrottleTimeout !== null) {
					clearTimeout(this.#remoteCursorThrottleTimeout);
					this.#remoteCursorThrottleTimeout = null;
				}
				this.#remoteCursorUpdateScheduled = false;
				this.#lastRemoteCursorRenderTime = now;
				this.#pendingUpdateCallback?.();
				return;
			}
			const remaining = THROTTLE_MS - elapsed;
			this.#remoteCursorThrottleTimeout = window.setTimeout(() => {
				this.#remoteCursorUpdateScheduled = false;
				this.#remoteCursorThrottleTimeout = null;
				this.#lastRemoteCursorRenderTime = performance.now();
				this.#pendingUpdateCallback?.();
			}, remaining);
		});
	}
	#pendingUpdateCallback = null;
	setUpdateCallback(callback) {
		this.#pendingUpdateCallback = callback;
	}
	update(editorState, deps) {
		if (this.#options.presence?.enabled === false) {
			this.#clearState();
			return;
		}
		if (!this.#remoteCursorDirty) return;
		this.#remoteCursorDirty = false;
		const startTime = performance.now();
		this.#remoteCursorState = normalizeAwarenessStates({
			provider: this.#options.collaborationProvider ?? null,
			editorState,
			previousState: this.#remoteCursorState,
			fallbackColors: this.#options.fallbackColors,
			staleTimeoutMs: this.#options.presence?.staleTimeout ?? DEFAULT_STALE_TIMEOUT_MS
		});
		this.render(deps);
		if (this.#onCursorsUpdate) this.#onCursorsUpdate(Array.from(this.#remoteCursorState.values()));
		if (this.#onTelemetry) {
			const renderTime = performance.now() - startTime;
			const maxVisible = this.#options.presence?.maxVisible ?? 20;
			const visibleCount = Math.min(this.#remoteCursorState.size, maxVisible);
			this.#onTelemetry({
				collaboratorCount: this.#remoteCursorState.size,
				visibleCount,
				renderTimeMs: renderTime
			});
		}
	}
	render(deps) {
		const { layout, blocks, measures } = deps;
		if (!layout || !blocks || !measures) return;
		const doc$1 = this.#options.visibleHost.ownerDocument ?? document;
		renderRemoteCursors({
			layout,
			blocks,
			measures,
			pageGeometryHelper: deps.pageGeometryHelper,
			presence: this.#options.presence,
			remoteCursorState: this.#remoteCursorState,
			remoteCursorElements: this.#remoteCursorElements,
			remoteCursorOverlay: this.#options.remoteCursorOverlay,
			doc: doc$1,
			computeCaretLayoutRect: deps.computeCaretLayoutRect,
			convertPageLocalToOverlayCoords: deps.convertPageLocalToOverlayCoords,
			fallbackColors: this.#options.fallbackColors,
			cursorStyles: this.#options.cursorStyles,
			maxSelectionRectsPerUser: this.#options.maxSelectionRectsPerUser,
			defaultPageHeight: this.#options.defaultPageHeight,
			fallbackPageHeight: deps.pageHeight
		});
	}
	updateLocalCursor(editorState) {
		const provider = this.#options.collaborationProvider;
		if (!provider?.awareness) return;
		if (typeof provider.awareness.setLocalStateField !== "function") return;
		if (!editorState) return;
		const ystate = ySyncPluginKey.getState(editorState);
		if (!ystate?.binding?.mapping) return;
		const { selection } = editorState;
		const { anchor, head } = selection;
		try {
			const relAnchor = absolutePositionToRelativePosition(anchor, ystate.type, ystate.binding.mapping);
			const relHead = absolutePositionToRelativePosition(head, ystate.type, ystate.binding.mapping);
			if (relAnchor && relHead) {
				const cursorData = {
					anchor: relAnchor,
					head: relHead
				};
				provider.awareness.setLocalStateField("cursor", cursorData);
			}
		} catch {}
	}
	#clearState() {
		this.#remoteCursorState.clear();
		this.#remoteCursorElements.clear();
		if (this.#options.remoteCursorOverlay) this.#options.remoteCursorOverlay.innerHTML = "";
	}
	updatePresenceOptions(presence) {
		this.#options.presence = presence;
	}
	hasRemoteCursors() {
		return this.#remoteCursorState.size > 0;
	}
	destroy() {
		if (this.#remoteCursorThrottleTimeout !== null) {
			clearTimeout(this.#remoteCursorThrottleTimeout);
			this.#remoteCursorThrottleTimeout = null;
		}
		this.#cleanupSubscriptions();
		this.#remoteCursorState.clear();
		this.#remoteCursorElements.clear();
		this.#pendingUpdateCallback = null;
		this.#onTelemetry = null;
		this.#onCursorsUpdate = null;
		this.#isSetup = false;
	}
};
function resolvePointerPositionHit(options) {
	const { layout, blocks, measures, containerPoint, domContainer, clientX, clientY, geometryHelper } = options;
	const layoutEpoch = layout.layoutEpoch ?? 0;
	if (domContainer != null && clientX != null && clientY != null) {
		const domPos = clickToPositionDom(domContainer, clientX, clientY);
		const domLayoutEpoch = readLayoutEpochFromDom(domContainer, clientX, clientY) ?? layoutEpoch;
		if (domPos != null) return resolvePositionHitFromDomPosition(layout, blocks, measures, domPos, domLayoutEpoch);
		const pageEl = findPageElement(domContainer, clientX, clientY);
		if (pageEl) {
			const domPageIndex = Number(pageEl.dataset.pageIndex ?? "NaN");
			if (Number.isFinite(domPageIndex) && domPageIndex >= 0 && domPageIndex < layout.pages.length) {
				const page = layout.pages[domPageIndex];
				const pageRect = pageEl.getBoundingClientRect();
				const layoutPageHeight = page.size?.h ?? layout.pageSize.h;
				const domPageHeight = pageRect.height;
				const effectiveZoom = domPageHeight > 0 && layoutPageHeight > 0 ? domPageHeight / layoutPageHeight : 1;
				return clickToPositionGeometry(layout, blocks, measures, containerPoint, {
					geometryHelper,
					pageHint: {
						pageIndex: domPageIndex,
						pageRelativeY: (clientY - pageRect.top) / effectiveZoom
					}
				});
			}
		}
	}
	return clickToPositionGeometry(layout, blocks, measures, containerPoint, { geometryHelper });
}
function getTableBlocks(blocks) {
	return blocks.filter((block) => block.kind === "table");
}
function getTopLevelTablePosByIndex(doc$1, targetTableIndex) {
	if (!Number.isInteger(targetTableIndex) || targetTableIndex < 0) return null;
	let tablePos = null;
	let currentTableIndex = 0;
	doc$1.descendants((node, pos) => {
		if (tablePos !== null) return false;
		if (node.type.name !== "table") return true;
		if (currentTableIndex === targetTableIndex) tablePos = pos;
		currentTableIndex += 1;
		return false;
	});
	return tablePos;
}
function getTopLevelTableIndexAtPos(doc$1, targetTablePos) {
	if (!Number.isFinite(targetTablePos) || targetTablePos < 0 || targetTablePos > doc$1.content.size) return null;
	let tableIndex = null;
	let currentTableIndex = 0;
	doc$1.descendants((node, pos) => {
		if (tableIndex !== null) return false;
		if (node.type.name !== "table") return true;
		if (pos === targetTablePos) tableIndex = currentTableIndex;
		currentTableIndex += 1;
		return false;
	});
	return tableIndex;
}
function getCellCoordinatesFromCellPos(doc$1, tablePos, cellPos) {
	const tableNode = doc$1.nodeAt(tablePos);
	if (!tableNode || tableNode.type.name !== "table") return null;
	let rowPos = tablePos + 1;
	for (let rowIndex = 0; rowIndex < tableNode.childCount; rowIndex += 1) {
		const rowNode = tableNode.child(rowIndex);
		let currentCellPos = rowPos + 1;
		for (let cellColIndex = 0; cellColIndex < rowNode.childCount; cellColIndex += 1) {
			if (currentCellPos === cellPos) return {
				rowIndex,
				cellColIndex
			};
			currentCellPos += rowNode.child(cellColIndex).nodeSize;
		}
		rowPos += rowNode.nodeSize;
	}
	return null;
}
function getTopLevelTableBlockAtPos(doc$1, blocks, tablePos) {
	if (!doc$1) return null;
	const tableIndex = getTopLevelTableIndexAtPos(doc$1, tablePos);
	if (tableIndex === null) return null;
	return getTableBlocks(blocks)[tableIndex] ?? null;
}
function resolveCellContextAtResolvedPos($pos) {
	const $cell = cellAround$1($pos);
	if (!$cell) return null;
	const table = findTable($cell);
	if (!table) return null;
	return {
		$cell,
		cellPos: $cell.pos,
		tablePos: table.pos
	};
}
function resolveCellAnchorStateFromCellPos(doc$1, blocks, cellPos) {
	if (!doc$1 || !Number.isFinite(cellPos) || cellPos < 0 || cellPos > doc$1.content.size) return null;
	const tableRole = doc$1.nodeAt(cellPos)?.type.spec.tableRole;
	if (tableRole !== "cell" && tableRole !== "header_cell") return null;
	const context = resolveCellContext(doc$1, Math.min(cellPos + 1, doc$1.content.size));
	if (!context || context.cellPos !== cellPos) return null;
	const tableBlock = getTopLevelTableBlockAtPos(doc$1, blocks, context.tablePos);
	if (!tableBlock) return null;
	const cellCoordinates = getCellCoordinatesFromCellPos(doc$1, context.tablePos, cellPos);
	if (!cellCoordinates) return null;
	return {
		tablePos: context.tablePos,
		cellPos,
		tableBlockId: tableBlock.id,
		cellRowIndex: cellCoordinates.rowIndex,
		cellColIndex: cellCoordinates.cellColIndex
	};
}
function getCellPosFromTableHit(tableHit, doc$1, blocks) {
	if (!tableHit || !tableHit.block || typeof tableHit.block.id !== "string") {
		console.warn("[getCellPosFromTableHit] Invalid tableHit input:", tableHit);
		return null;
	}
	if (typeof tableHit.cellRowIndex !== "number" || typeof tableHit.cellColIndex !== "number" || tableHit.cellRowIndex < 0 || tableHit.cellColIndex < 0) {
		console.warn("[getCellPosFromTableHit] Invalid cell indices:", {
			row: tableHit.cellRowIndex,
			col: tableHit.cellColIndex
		});
		return null;
	}
	if (!doc$1) return null;
	const targetTableIndex = getTableBlocks(blocks).findIndex((b$1) => b$1.id === tableHit.block.id);
	if (targetTableIndex === -1) return null;
	let tablePos = null;
	try {
		tablePos = getTopLevelTablePosByIndex(doc$1, targetTableIndex);
	} catch (error) {
		console.error("[getCellPosFromTableHit] Error during document traversal:", error);
		return null;
	}
	if (tablePos === null) return null;
	const tableNode = doc$1.nodeAt(tablePos);
	if (!tableNode || tableNode.type.name !== "table") return null;
	const targetRowIndex = tableHit.cellRowIndex;
	const targetColIndex = tableHit.cellColIndex;
	if (targetRowIndex >= tableNode.childCount) {
		console.warn("[getCellPosFromTableHit] Target row index out of bounds:", {
			targetRowIndex,
			tableChildCount: tableNode.childCount
		});
		return null;
	}
	let currentPos = tablePos + 1;
	for (let r$1 = 0; r$1 < tableNode.childCount && r$1 <= targetRowIndex; r$1++) {
		const row = tableNode.child(r$1);
		if (r$1 === targetRowIndex) {
			currentPos += 1;
			let logicalCol = 0;
			for (let cellIndex = 0; cellIndex < row.childCount; cellIndex++) {
				const cell = row.child(cellIndex);
				const rawColspan = cell.attrs?.colspan;
				const colspan = typeof rawColspan === "number" && Number.isFinite(rawColspan) && rawColspan > 0 ? rawColspan : 1;
				if (targetColIndex >= logicalCol && targetColIndex < logicalCol + colspan) return currentPos;
				currentPos += cell.nodeSize;
				logicalCol += colspan;
			}
			console.warn("[getCellPosFromTableHit] Target column not found in row:", {
				targetColIndex,
				logicalColReached: logicalCol,
				rowCellCount: row.childCount
			});
			return null;
		} else currentPos += row.nodeSize;
	}
	return null;
}
function getTablePosFromHit(tableHit, doc$1, blocks) {
	if (!doc$1) return null;
	const targetTableIndex = getTableBlocks(blocks).findIndex((b$1) => b$1.id === tableHit.block.id);
	if (targetTableIndex === -1) return null;
	return getTopLevelTablePosByIndex(doc$1, targetTableIndex);
}
function resolveCellContext(doc$1, pos) {
	if (!doc$1 || !Number.isFinite(pos) || pos < 0 || pos > doc$1.content.size) return null;
	let $pos;
	try {
		$pos = doc$1.resolve(pos);
	} catch {
		return null;
	}
	const context = resolveCellContextAtResolvedPos($pos);
	if (!context) return null;
	return {
		cellPos: context.cellPos,
		tablePos: context.tablePos
	};
}
function resolveCrossCellSelection(doc$1, anchorPos, headPos) {
	if (!doc$1) return null;
	let $anchorPos;
	let $headPos;
	try {
		$anchorPos = doc$1.resolve(anchorPos);
		$headPos = doc$1.resolve(headPos);
	} catch {
		return null;
	}
	const anchor = resolveCellContextAtResolvedPos($anchorPos);
	const head = resolveCellContextAtResolvedPos($headPos);
	if (!anchor || !head) return null;
	if (!inSameTable(anchor.$cell, head.$cell)) return null;
	if (anchor.cellPos === head.cellPos) return null;
	return {
		anchorCellPos: anchor.cellPos,
		headCellPos: head.cellPos
	};
}
function shouldUseCellSelection(currentTableHit, cellAnchor, cellDragMode) {
	if (!cellAnchor) return false;
	if (!currentTableHit) return cellDragMode === "active";
	if (currentTableHit.block.id !== cellAnchor.tableBlockId) return cellDragMode === "active";
	if (!(currentTableHit.cellRowIndex === cellAnchor.cellRowIndex && currentTableHit.cellColIndex === cellAnchor.cellColIndex)) return true;
	return cellDragMode === "active";
}
function hitTestTable(layout, blocks, measures, normalizedX, normalizedY, configuredPageHeight, pageGapFallback, geometryHelper) {
	if (!layout) return null;
	let pageY = 0;
	let pageHit = null;
	if (geometryHelper) {
		const idx = geometryHelper.getPageIndexAtY(normalizedY) ?? geometryHelper.getNearestPageIndex(normalizedY);
		if (idx != null && layout.pages[idx]) {
			pageHit = {
				pageIndex: idx,
				page: layout.pages[idx]
			};
			pageY = geometryHelper.getPageTop(idx);
		}
	}
	if (!pageHit) {
		const gap = layout.pageGap ?? pageGapFallback;
		for (let i = 0; i < layout.pages.length; i++) {
			const page = layout.pages[i];
			const pageHeight = page.size?.h ?? configuredPageHeight;
			if (normalizedY >= pageY && normalizedY < pageY + pageHeight) {
				pageHit = {
					pageIndex: i,
					page
				};
				break;
			}
			pageY += pageHeight + gap;
		}
	}
	if (!pageHit) return null;
	const point = {
		x: normalizedX,
		y: normalizedY - pageY
	};
	return hitTestTableFragment(pageHit, blocks, measures, point);
}
const SEMANTIC_FOOTNOTES_HEADING_BLOCK_ID = "__sd_semantic_footnotes_heading";
const SEMANTIC_FOOTNOTE_BLOCK_ID_PREFIX = "__sd_semantic_footnote";
function isSemanticFootnoteBlockId(blockId) {
	return typeof blockId === "string" && blockId.startsWith("__sd_semantic_footnote");
}
var MULTI_CLICK_TIME_THRESHOLD_MS = 400;
var MULTI_CLICK_DISTANCE_THRESHOLD_PX = 5;
var DRAG_SELECTION_DISTANCE_THRESHOLD_PX = 5;
var AUTO_SCROLL_EDGE_PX = 32;
var AUTO_SCROLL_MAX_SPEED_PX = 24;
var SCROLL_DETECTION_TOLERANCE_PX = 1;
var DEFAULT_PAGE_MARGIN_PX = 72;
var COMMENT_HIGHLIGHT_SELECTOR = ".superdoc-comment-highlight";
var TRACK_CHANGE_SELECTOR = "[data-track-change-id]";
var PM_TRACK_CHANGE_SELECTOR = ".track-insert[data-id], .track-delete[data-id], .track-format[data-id]";
var VISIBLE_HEADER_FOOTER_SELECTOR = ".superdoc-page-header, .superdoc-page-footer";
var VISIBLE_BODY_CONTENT_SELECTOR = ".superdoc-line, .superdoc-fragment, [data-block-id]";
var COMMENT_THREAD_HIT_TOLERANCE_PX = 3;
var INLINE_SDT_LABEL_SELECTOR = `.${DOM_CLASS_NAMES.INLINE_SDT_LABEL}`;
var BLOCK_SDT_LABEL_SELECTOR = `.${DOM_CLASS_NAMES.BLOCK_SDT_LABEL}`;
var SDT_LABEL_SELECTOR = `${INLINE_SDT_LABEL_SELECTOR}, ${BLOCK_SDT_LABEL_SELECTOR}`;
var EMPTY_SDT_PLACEHOLDER_SELECTOR = ".superdoc-empty-sdt-placeholder";
var COMMENT_THREAD_HIT_SAMPLE_OFFSETS = [
	[0, 0],
	[-COMMENT_THREAD_HIT_TOLERANCE_PX, 0],
	[COMMENT_THREAD_HIT_TOLERANCE_PX, 0],
	[0, -COMMENT_THREAD_HIT_TOLERANCE_PX],
	[0, COMMENT_THREAD_HIT_TOLERANCE_PX]
];
var clamp = (value, min$2, max$2) => Math.max(min$2, Math.min(max$2, value));
var DRAG_SOURCE_SELECTOR = "[data-draggable=\"true\"], [data-drag-source-kind]";
function isRenderedNoteBlockId(blockId) {
	return typeof blockId === "string" && (blockId.startsWith("footnote-") || blockId.startsWith("endnote-") || isSemanticFootnoteBlockId(blockId));
}
function parseRenderedNoteTarget$1(blockId) {
	if (typeof blockId !== "string" || blockId.length === 0) return null;
	if (blockId.startsWith("footnote-")) {
		const noteId = blockId.slice(9).split("-")[0] ?? "";
		return noteId ? {
			storyType: "footnote",
			noteId
		} : null;
	}
	if (blockId.startsWith("__sd_semantic_footnote-")) {
		const noteId = blockId.slice(23).split("-")[0] ?? "";
		return noteId ? {
			storyType: "footnote",
			noteId
		} : null;
	}
	if (blockId.startsWith("endnote-")) {
		const noteId = blockId.slice(8).split("-")[0] ?? "";
		return noteId ? {
			storyType: "endnote",
			noteId
		} : null;
	}
	return null;
}
function isSameRenderedNoteTarget(left$1, right$1) {
	if (!left$1 || !right$1) return false;
	return left$1.storyType === right$1.storyType && left$1.noteId === right$1.noteId;
}
function isOutsidePageBodyContent(layout, x, pageIndex, pageLocalY) {
	if (!Number.isFinite(x) || !Number.isFinite(pageIndex) || !Number.isFinite(pageLocalY)) return false;
	const page = layout?.pages?.[pageIndex];
	if (!page) return false;
	const pageWidth = page.size?.w ?? layout.pageSize.w;
	const pageHeight = page.size?.h ?? layout.pageSize.h;
	if (!Number.isFinite(pageWidth) || pageWidth <= 0 || !Number.isFinite(pageHeight) || pageHeight <= 0) return false;
	const margins = page.margins ?? null;
	const marginLeft = Number.isFinite(margins?.left) ? margins.left : DEFAULT_PAGE_MARGIN_PX;
	const marginRight = Number.isFinite(margins?.right) ? margins.right : DEFAULT_PAGE_MARGIN_PX;
	const marginTop = Number.isFinite(margins?.top) ? margins.top : DEFAULT_PAGE_MARGIN_PX;
	const marginBottom = Number.isFinite(margins?.bottom) ? margins.bottom : DEFAULT_PAGE_MARGIN_PX;
	const bodyLeft = Math.max(0, marginLeft);
	const bodyRight = Math.min(pageWidth, pageWidth - Math.max(0, marginRight));
	const bodyTop = Math.max(0, marginTop);
	const bodyBottom = Math.min(pageHeight, pageHeight - Math.max(0, marginBottom));
	if (bodyLeft >= bodyRight || bodyTop >= bodyBottom) return false;
	return x < bodyLeft || x > bodyRight || pageLocalY < bodyTop || pageLocalY > bodyBottom;
}
function getCommentHighlightThreadIds(target) {
	if (!(target instanceof Element)) return [];
	const threadIds = target.closest(COMMENT_HIGHLIGHT_SELECTOR)?.getAttribute("data-comment-ids");
	if (!threadIds) return [];
	return threadIds.split(",").map((threadId) => threadId.trim()).filter(Boolean);
}
function isDirectSingleCommentHighlightHit(target) {
	return getCommentHighlightThreadIds(target).length === 1;
}
function isDirectTrackedChangeHit(target) {
	if (!(target instanceof Element)) return false;
	return target.closest(`${TRACK_CHANGE_SELECTOR}, ${PM_TRACK_CHANGE_SELECTOR}`) != null;
}
function resolveTrackChangeThreadId(target) {
	if (!(target instanceof Element)) return null;
	const trackedChangeElement = target.closest(`${TRACK_CHANGE_SELECTOR}, ${PM_TRACK_CHANGE_SELECTOR}`);
	const threadId = trackedChangeElement?.getAttribute("data-track-change-id")?.trim() ?? trackedChangeElement?.getAttribute("data-id")?.trim();
	return threadId ? threadId : null;
}
function resolveCommentThreadHit(target) {
	const threadIds = getCommentHighlightThreadIds(target);
	if (threadIds.length > 1) return {
		isAmbiguous: true,
		threadId: null
	};
	if (threadIds.length === 1) return {
		isAmbiguous: false,
		threadId: threadIds[0]
	};
	return {
		isAmbiguous: false,
		threadId: resolveTrackChangeThreadId(target)
	};
}
function collectElementsNearPointerTarget(target, clientX, clientY) {
	const candidates = [];
	const seen = /* @__PURE__ */ new Set();
	const ownerDocument = target instanceof Element ? target.ownerDocument : document;
	const ownerWindow = ownerDocument.defaultView;
	const addCandidate = (candidate) => {
		if (!candidate || seen.has(candidate)) return;
		seen.add(candidate);
		candidates.push(candidate);
	};
	if (target instanceof Element) addCandidate(target);
	if (typeof ownerDocument.elementsFromPoint !== "function" || !ownerWindow) return candidates;
	const maxX = Math.max(ownerWindow.innerWidth - 1, 0);
	const maxY = Math.max(ownerWindow.innerHeight - 1, 0);
	for (const [offsetX, offsetY] of COMMENT_THREAD_HIT_SAMPLE_OFFSETS) {
		const sampleX = clamp(clientX + offsetX, 0, maxX);
		const sampleY = clamp(clientY + offsetY, 0, maxY);
		const elements = ownerDocument.elementsFromPoint(sampleX, sampleY);
		for (const element of elements) addCandidate(element);
	}
	return candidates;
}
function elementContainsPointerSample(element, clientX, clientY) {
	const rect = element.getBoundingClientRect();
	if (![
		rect.left,
		rect.top,
		rect.right,
		rect.bottom
	].every(Number.isFinite) || rect.width <= 0 || rect.height <= 0) return false;
	for (const [offsetX, offsetY] of COMMENT_THREAD_HIT_SAMPLE_OFFSETS) {
		const sampleX = clientX + offsetX;
		const sampleY = clientY + offsetY;
		if (sampleX >= rect.left && sampleX <= rect.right && sampleY >= rect.top && sampleY <= rect.bottom) return true;
	}
	return false;
}
function resolveCommentThreadIdFromGeometry(elements, clientX, clientY) {
	let resolvedThreadId = null;
	for (const element of elements) {
		if (!elementContainsPointerSample(element, clientX, clientY)) continue;
		const hit = resolveCommentThreadHit(element);
		if (hit.isAmbiguous) return null;
		if (!hit.threadId) continue;
		if (resolvedThreadId && resolvedThreadId !== hit.threadId) return null;
		resolvedThreadId = hit.threadId;
	}
	return resolvedThreadId;
}
function resolveCommentThreadIdNearPointer(target, clientX, clientY) {
	const directHit = resolveCommentThreadHit(target);
	if (directHit.isAmbiguous || directHit.threadId) return directHit.threadId;
	const nearbyElements = collectElementsNearPointerTarget(target, clientX, clientY);
	for (const element of nearbyElements) {
		const hit = resolveCommentThreadHit(element);
		if (hit.isAmbiguous) return null;
		if (hit.threadId) return hit.threadId;
	}
	return null;
}
function resolveVisibleSurfaceAtPointer(target, clientX, clientY) {
	const ownerDocument = target instanceof Element ? target.ownerDocument : document;
	const ownerWindow = ownerDocument.defaultView;
	if (typeof ownerDocument.elementFromPoint !== "function" || !ownerWindow) return null;
	const sampleX = clamp(clientX, 0, Math.max(ownerWindow.innerWidth - 1, 0));
	const sampleY = clamp(clientY, 0, Math.max(ownerWindow.innerHeight - 1, 0));
	const sampledElements = typeof ownerDocument.elementsFromPoint === "function" ? ownerDocument.elementsFromPoint(sampleX, sampleY) : [ownerDocument.elementFromPoint(sampleX, sampleY)];
	for (const element of sampledElements) {
		if (!(element instanceof HTMLElement)) continue;
		const visibleHeaderFooterSurface = element.closest(VISIBLE_HEADER_FOOTER_SELECTOR);
		if (visibleHeaderFooterSurface) return {
			kind: "headerFooter",
			surface: visibleHeaderFooterSurface
		};
		if (element.closest(VISIBLE_BODY_CONTENT_SELECTOR)) return { kind: "bodyContent" };
	}
	return null;
}
function getActiveCommentThreadId(editor) {
	const activeThreadId = CommentsPluginKey.getState(editor.state)?.activeThreadId;
	if (typeof activeThreadId !== "string" || activeThreadId.length === 0) return null;
	return activeThreadId;
}
function shouldIgnoreRepeatClickOnActiveComment(target, clientX, clientY, activeThreadId) {
	if (!activeThreadId) return false;
	if (isDirectSingleCommentHighlightHit(target) || isDirectTrackedChangeHit(target)) return false;
	return resolveCommentThreadIdNearPointer(target, clientX, clientY) === activeThreadId;
}
var EditorInputManager = class {
	#deps = null;
	#callbacks = {};
	#isDragging = false;
	#dragAnchor = null;
	#dragAnchorPageIndex = null;
	#dragExtensionMode = "char";
	#dragLastPointer = null;
	#dragLastRawHit = null;
	#dragUsedPageNotMountedFallback = false;
	#dragStartClient = null;
	#dragThresholdExceeded = false;
	#autoScrollActive = false;
	#autoScrollTimer = null;
	#autoScrollVelocity = {
		x: 0,
		y: 0
	};
	#lastPointerClient = null;
	#clickCount = 0;
	#lastClickTime = 0;
	#lastClickPosition = null;
	#cellAnchor = null;
	#cellDragMode = "none";
	#pendingMarginClick = null;
	#pendingTocLinkNav = null;
	#lastSelectedImageBlockId = null;
	#suppressFocusInFromDraggable = false;
	#pendingStructuredContentLabelGesture = null;
	#debugLastPointer = null;
	#debugLastHit = null;
	#boundHandleStructuredContentLabelPointerDown = null;
	#boundHandleStructuredContentLabelPointerUp = null;
	#boundHandleStructuredContentLabelPointerCancel = null;
	#boundHandleStructuredContentLabelClick = null;
	#boundHandlePointerDown = null;
	#boundHandlePointerMove = null;
	#boundHandlePointerUp = null;
	#boundHandlePointerLeave = null;
	#boundHandleDoubleClick = null;
	#boundHandleClick = null;
	#boundHandleKeyDown = null;
	#boundHandleFocusIn = null;
	#boundHandleEditorFocus = null;
	#boundHandleEditorBlur = null;
	constructor() {}
	setDependencies(deps) {
		this.#deps = deps;
	}
	setCallbacks(callbacks) {
		this.#callbacks = callbacks;
	}
	bind() {
		if (!this.#deps) return;
		const viewportHost = this.#deps.getViewportHost();
		const visibleHost = this.#deps.getVisibleHost();
		const doc$1 = viewportHost.ownerDocument ?? document;
		this.#boundHandleStructuredContentLabelPointerDown = this.#handleStructuredContentLabelPointerDown.bind(this);
		this.#boundHandleStructuredContentLabelPointerUp = this.#handleStructuredContentLabelPointerUp.bind(this);
		this.#boundHandleStructuredContentLabelPointerCancel = this.#handleStructuredContentLabelPointerCancel.bind(this);
		this.#boundHandleStructuredContentLabelClick = this.#handleStructuredContentLabelClickEvent.bind(this);
		this.#boundHandlePointerDown = this.#handlePointerDown.bind(this);
		this.#boundHandlePointerMove = this.#handlePointerMove.bind(this);
		this.#boundHandlePointerUp = this.#handlePointerUp.bind(this);
		this.#boundHandlePointerLeave = this.#handlePointerLeave.bind(this);
		this.#boundHandleDoubleClick = this.#handleDoubleClick.bind(this);
		this.#boundHandleClick = this.#handleClick.bind(this);
		this.#boundHandleKeyDown = this.#handleKeyDown.bind(this);
		this.#boundHandleFocusIn = this.#handleFocusIn.bind(this);
		this.#boundHandleEditorFocus = this.#handleEditorFocus.bind(this);
		this.#boundHandleEditorBlur = this.#handleEditorBlur.bind(this);
		doc$1.addEventListener("pointerdown", this.#boundHandleStructuredContentLabelPointerDown, true);
		doc$1.addEventListener("pointerup", this.#boundHandleStructuredContentLabelPointerUp, true);
		doc$1.addEventListener("pointercancel", this.#boundHandleStructuredContentLabelPointerCancel, true);
		doc$1.addEventListener("click", this.#boundHandleStructuredContentLabelClick, true);
		viewportHost.addEventListener("pointerdown", this.#boundHandlePointerDown);
		viewportHost.addEventListener("pointermove", this.#boundHandlePointerMove);
		viewportHost.addEventListener("pointerup", this.#boundHandlePointerUp);
		viewportHost.addEventListener("pointerleave", this.#boundHandlePointerLeave);
		viewportHost.addEventListener("dblclick", this.#boundHandleDoubleClick);
		viewportHost.addEventListener("click", this.#boundHandleClick);
		const container = viewportHost.closest(".presentation-editor");
		if (container) container.addEventListener("keydown", this.#boundHandleKeyDown);
		visibleHost.addEventListener("focusin", this.#boundHandleFocusIn);
		const editor = this.#deps.getEditor();
		editor.on?.("focus", this.#boundHandleEditorFocus);
		editor.on?.("blur", this.#boundHandleEditorBlur);
	}
	unbind() {
		if (!this.#deps) return;
		const viewportHost = this.#deps.getViewportHost();
		const visibleHost = this.#deps.getVisibleHost();
		const doc$1 = viewportHost.ownerDocument ?? document;
		if (this.#boundHandleStructuredContentLabelPointerDown) doc$1.removeEventListener("pointerdown", this.#boundHandleStructuredContentLabelPointerDown, true);
		if (this.#boundHandleStructuredContentLabelPointerUp) doc$1.removeEventListener("pointerup", this.#boundHandleStructuredContentLabelPointerUp, true);
		if (this.#boundHandleStructuredContentLabelPointerCancel) doc$1.removeEventListener("pointercancel", this.#boundHandleStructuredContentLabelPointerCancel, true);
		if (this.#boundHandleStructuredContentLabelClick) doc$1.removeEventListener("click", this.#boundHandleStructuredContentLabelClick, true);
		if (this.#boundHandlePointerDown) viewportHost.removeEventListener("pointerdown", this.#boundHandlePointerDown);
		if (this.#boundHandlePointerMove) viewportHost.removeEventListener("pointermove", this.#boundHandlePointerMove);
		if (this.#boundHandlePointerUp) viewportHost.removeEventListener("pointerup", this.#boundHandlePointerUp);
		if (this.#boundHandlePointerLeave) viewportHost.removeEventListener("pointerleave", this.#boundHandlePointerLeave);
		if (this.#boundHandleDoubleClick) viewportHost.removeEventListener("dblclick", this.#boundHandleDoubleClick);
		if (this.#boundHandleClick) viewportHost.removeEventListener("click", this.#boundHandleClick);
		if (this.#boundHandleKeyDown) {
			const container = viewportHost.closest(".presentation-editor");
			if (container) container.removeEventListener("keydown", this.#boundHandleKeyDown);
		}
		if (this.#boundHandleFocusIn) visibleHost.removeEventListener("focusin", this.#boundHandleFocusIn);
		if (this.#boundHandleEditorFocus) this.#deps.getEditor().off?.("focus", this.#boundHandleEditorFocus);
		if (this.#boundHandleEditorBlur) this.#deps.getEditor().off?.("blur", this.#boundHandleEditorBlur);
		this.#boundHandleStructuredContentLabelPointerDown = null;
		this.#boundHandleStructuredContentLabelPointerUp = null;
		this.#boundHandleStructuredContentLabelPointerCancel = null;
		this.#boundHandleStructuredContentLabelClick = null;
		this.#boundHandlePointerDown = null;
		this.#boundHandlePointerMove = null;
		this.#boundHandlePointerUp = null;
		this.#boundHandlePointerLeave = null;
		this.#boundHandleDoubleClick = null;
		this.#boundHandleClick = null;
		this.#boundHandleKeyDown = null;
		this.#boundHandleFocusIn = null;
		this.#boundHandleEditorFocus = null;
		this.#boundHandleEditorBlur = null;
	}
	destroy() {
		this.unbind();
		this.#deps = null;
		this.#callbacks = {};
		this.#clearDragState();
		this.#clearCellAnchor();
	}
	get isDragging() {
		return this.#isDragging;
	}
	get dragAnchor() {
		return this.#dragAnchor;
	}
	get cellAnchor() {
		return this.#cellAnchor;
	}
	get debugLastPointer() {
		return this.#debugLastPointer;
	}
	get debugLastHit() {
		return this.#debugLastHit;
	}
	get lastSelectedImageBlockId() {
		return this.#lastSelectedImageBlockId;
	}
	notifyTargetChanged() {
		this.#resetMultiClickTracking();
		this.#pendingMarginClick = null;
	}
	get dragAnchorPageIndex() {
		return this.#dragAnchorPageIndex;
	}
	get dragLastHitPageIndex() {
		return this.#dragLastRawHit?.pageIndex ?? null;
	}
	get dragLastRawHit() {
		return this.#dragLastRawHit;
	}
	clearCellAnchor() {
		this.#clearCellAnchor();
	}
	setSuppressFocusInFromDraggable(value) {
		this.#suppressFocusInFromDraggable = value;
	}
	#clearDragState() {
		this.#isDragging = false;
		this.#dragAnchor = null;
		this.#dragAnchorPageIndex = null;
		this.#dragExtensionMode = "char";
		this.#dragLastPointer = null;
		this.#dragLastRawHit = null;
		this.#dragUsedPageNotMountedFallback = false;
		this.#dragStartClient = null;
		this.#dragThresholdExceeded = false;
		this.#lastPointerClient = null;
		this.#stopAutoScroll();
	}
	#hasExceededDragSelectionThreshold(clientX, clientY) {
		if (this.#dragThresholdExceeded) return true;
		if (!this.#dragStartClient) return true;
		const deltaX = clientX - this.#dragStartClient.clientX;
		const deltaY = clientY - this.#dragStartClient.clientY;
		const thresholdSquared = DRAG_SELECTION_DISTANCE_THRESHOLD_PX * DRAG_SELECTION_DISTANCE_THRESHOLD_PX;
		if (deltaX * deltaX + deltaY * deltaY < thresholdSquared) return false;
		this.#dragThresholdExceeded = true;
		return true;
	}
	#clearCellAnchor() {
		this.#cellAnchor = null;
		this.#cellDragMode = "none";
	}
	#resetMultiClickTracking() {
		this.#clickCount = 0;
		this.#lastClickTime = 0;
		this.#lastClickPosition = null;
	}
	#registerPointerClick(event) {
		const nextState = registerPointerClick(event, {
			clickCount: this.#clickCount,
			lastClickTime: this.#lastClickTime,
			lastClickPosition: this.#lastClickPosition ?? {
				x: 0,
				y: 0
			}
		}, {
			timeThresholdMs: MULTI_CLICK_TIME_THRESHOLD_MS,
			distanceThresholdPx: MULTI_CLICK_DISTANCE_THRESHOLD_PX,
			maxClickCount: 3
		});
		this.#clickCount = nextState.clickCount;
		this.#lastClickTime = nextState.lastClickTime;
		this.#lastClickPosition = nextState.lastClickPosition;
		return nextState.clickCount;
	}
	#getFirstTextPosition() {
		return getFirstTextPosition((this.#deps?.getActiveEditor() ?? this.#deps?.getEditor())?.state?.doc ?? null);
	}
	#resolveBodyPointerHit(layoutState, normalized, clientX, clientY) {
		const viewportHost = this.#deps?.getViewportHost();
		const pageGeometryHelper = this.#deps?.getPageGeometryHelper();
		if (!viewportHost) return null;
		return resolvePointerPositionHit({
			layout: layoutState.layout,
			blocks: layoutState.blocks,
			measures: layoutState.measures,
			containerPoint: normalized,
			domContainer: viewportHost,
			clientX,
			clientY,
			geometryHelper: pageGeometryHelper ?? void 0
		}) ?? null;
	}
	#resolveSelectionPointerHit(options) {
		const { layoutState, normalized, clientX, clientY, editor, useActiveSurfaceHitTest } = options;
		const doc$1 = editor.state?.doc;
		const rawHit = useActiveSurfaceHitTest && this.#callbacks.hitTest ? this.#callbacks.hitTest(clientX, clientY) : this.#resolveBodyPointerHit(layoutState, normalized, clientX, clientY);
		if (!rawHit || !doc$1) return {
			rawHit,
			hit: null
		};
		if (useActiveSurfaceHitTest) return {
			rawHit,
			hit: {
				...rawHit,
				pos: clamp(rawHit.pos, 0, doc$1.content.size)
			}
		};
		const epochMapper = this.#deps?.getEpochMapper();
		if (!epochMapper) return {
			rawHit,
			hit: null
		};
		const mapped = epochMapper.mapPosFromLayoutToCurrentDetailed(rawHit.pos, rawHit.layoutEpoch, 1);
		if (!mapped.ok) {
			debugLog("warn", "pointer mapping failed", mapped);
			return {
				rawHit,
				hit: null
			};
		}
		return {
			rawHit,
			hit: {
				...rawHit,
				pos: clamp(mapped.pos, 0, doc$1.content.size),
				layoutEpoch: mapped.toEpoch
			}
		};
	}
	#calculateExtendedSelection(anchor, head, mode) {
		const layoutState = this.#deps?.getLayoutState();
		return calculateExtendedSelection(layoutState?.blocks ?? [], anchor, head, mode);
	}
	#shouldUseCellSelection(currentTableHit) {
		return shouldUseCellSelection(currentTableHit, this.#cellAnchor, this.#cellDragMode);
	}
	#getCellPosFromTableHit(tableHit) {
		const editor = this.#deps?.getEditor();
		const layoutState = this.#deps?.getLayoutState();
		return getCellPosFromTableHit(tableHit, editor?.state?.doc ?? null, layoutState?.blocks ?? []);
	}
	#getTablePosFromHit(tableHit) {
		const editor = this.#deps?.getEditor();
		const layoutState = this.#deps?.getLayoutState();
		return getTablePosFromHit(tableHit, editor?.state?.doc ?? null, layoutState?.blocks ?? []);
	}
	#setCellAnchorState(cellAnchor, mode = "pending") {
		this.#cellAnchor = cellAnchor;
		this.#cellDragMode = mode;
	}
	#setCellAnchor(tableHit, tablePos) {
		const cellPos = this.#getCellPosFromTableHit(tableHit);
		if (cellPos === null) return;
		this.#setCellAnchorState({
			tablePos,
			cellPos,
			cellRowIndex: tableHit.cellRowIndex,
			cellColIndex: tableHit.cellColIndex,
			tableBlockId: tableHit.block.id
		}, "pending");
	}
	#setCellAnchorFromCellPos(cellPos, mode = "pending") {
		const editor = this.#deps?.getEditor();
		const layoutState = this.#deps?.getLayoutState();
		const cellAnchor = resolveCellAnchorStateFromCellPos(editor?.state?.doc ?? null, layoutState?.blocks ?? [], cellPos);
		if (!cellAnchor) return false;
		this.#setCellAnchorState(cellAnchor, mode);
		return true;
	}
	#dispatchExtendedTextSelection(editor, anchor, head) {
		const { selAnchor, selHead } = this.#calculateExtendedSelection(anchor, head, this.#dragExtensionMode);
		const stabilized = stabilizeTextSelectionAcrossTableCells(editor.state.doc, selAnchor, selHead);
		if (!stabilized) return false;
		try {
			const tr = editor.state.tr.setSelection(TextSelection.create(editor.state.doc, stabilized.selAnchor, stabilized.selHead));
			editor.view?.dispatch(tr);
			this.#callbacks.scheduleSelectionUpdate?.();
			return true;
		} catch (error) {
			console.warn("[SELECTION] Failed to extend text selection:", error);
			return false;
		}
	}
	#hitTestTable(x, y$1) {
		return this.#callbacks.hitTestTable?.(x, y$1) ?? null;
	}
	#getAutoScrollWindow() {
		return (this.#deps?.getVisibleHost())?.ownerDocument?.defaultView ?? (typeof window !== "undefined" ? window : null);
	}
	#getScrollTarget() {
		if (!this.#deps) return null;
		const visibleHost = this.#deps.getVisibleHost();
		const doc$1 = visibleHost.ownerDocument ?? document;
		const win = doc$1.defaultView ?? (typeof window !== "undefined" ? window : null);
		if (!win) return null;
		const scrollContainer = this.#findScrollableAncestor(visibleHost);
		if (scrollContainer) {
			const elementCanScrollX = scrollContainer.scrollWidth > scrollContainer.clientWidth + SCROLL_DETECTION_TOLERANCE_PX;
			const elementCanScrollY = scrollContainer.scrollHeight > scrollContainer.clientHeight + SCROLL_DETECTION_TOLERANCE_PX;
			const rect = scrollContainer.getBoundingClientRect();
			return {
				kind: "element",
				rect: {
					top: rect.top,
					bottom: rect.bottom,
					left: rect.left,
					right: rect.right
				},
				canScrollX: elementCanScrollX,
				canScrollY: elementCanScrollY,
				win,
				element: scrollContainer
			};
		}
		const docEl = doc$1.documentElement;
		const body = doc$1.body;
		const scrollWidth = Math.max(docEl?.scrollWidth ?? 0, body?.scrollWidth ?? 0);
		const scrollHeight = Math.max(docEl?.scrollHeight ?? 0, body?.scrollHeight ?? 0);
		const clientWidth = win.innerWidth;
		const clientHeight = win.innerHeight;
		const canScrollX = scrollWidth > clientWidth + SCROLL_DETECTION_TOLERANCE_PX;
		const canScrollY = scrollHeight > clientHeight + SCROLL_DETECTION_TOLERANCE_PX;
		return {
			kind: "window",
			rect: {
				top: 0,
				bottom: clientHeight,
				left: 0,
				right: clientWidth
			},
			canScrollX,
			canScrollY,
			win,
			scrollWidth,
			scrollHeight
		};
	}
	#findScrollableAncestor(host) {
		const doc$1 = host.ownerDocument ?? document;
		const win = doc$1.defaultView ?? (typeof window !== "undefined" ? window : null);
		let node = host;
		while (node && node !== doc$1.body) {
			const style = win?.getComputedStyle ? win.getComputedStyle(node) : null;
			const overflowY = style?.overflowY ?? style?.overflow ?? "";
			const overflowX = style?.overflowX ?? style?.overflow ?? "";
			const canScrollY = node.scrollHeight > node.clientHeight + SCROLL_DETECTION_TOLERANCE_PX;
			const canScrollX = node.scrollWidth > node.clientWidth + SCROLL_DETECTION_TOLERANCE_PX;
			if (canScrollY && (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay") || canScrollX && (overflowX === "auto" || overflowX === "scroll" || overflowX === "overlay")) return node;
			node = node.parentElement;
		}
		return null;
	}
	#scheduleAutoScrollTick() {
		if (this.#autoScrollTimer) return;
		const win = this.#getAutoScrollWindow();
		if (win?.requestAnimationFrame) {
			this.#autoScrollTimer = {
				id: win.requestAnimationFrame(() => this.#tickAutoScroll()),
				kind: "raf"
			};
			return;
		}
		this.#autoScrollTimer = {
			id: win?.setTimeout ? win.setTimeout(() => this.#tickAutoScroll(), 16) : setTimeout(() => this.#tickAutoScroll(), 16),
			kind: "timeout"
		};
	}
	#startAutoScroll() {
		if (this.#autoScrollActive) return;
		this.#autoScrollActive = true;
		this.#scheduleAutoScrollTick();
	}
	#stopAutoScroll() {
		this.#autoScrollActive = false;
		this.#autoScrollVelocity = {
			x: 0,
			y: 0
		};
		if (!this.#autoScrollTimer) return;
		const win = this.#getAutoScrollWindow();
		if (this.#autoScrollTimer.kind === "raf") (win?.cancelAnimationFrame ?? (typeof cancelAnimationFrame !== "undefined" ? cancelAnimationFrame : void 0))?.(this.#autoScrollTimer.id);
		else clearTimeout(this.#autoScrollTimer.id);
		this.#autoScrollTimer = null;
	}
	#updateAutoScrollFromPointer(clientX, clientY) {
		if (!this.#deps || !this.#isDragging) {
			this.#stopAutoScroll();
			return;
		}
		if ((this.#deps.getHeaderFooterSession()?.session?.mode ?? "body") !== "body" || this.#deps.isViewLocked()) {
			this.#stopAutoScroll();
			return;
		}
		const target = this.#getScrollTarget();
		if (!target || !target.canScrollX && !target.canScrollY) {
			this.#stopAutoScroll();
			return;
		}
		const { rect } = target;
		const topDist = clientY - rect.top;
		const bottomDist = rect.bottom - clientY;
		const leftDist = clientX - rect.left;
		const rightDist = rect.right - clientX;
		let vx = 0;
		let vy = 0;
		if (target.canScrollY) {
			const topFactor = clamp((AUTO_SCROLL_EDGE_PX - topDist) / AUTO_SCROLL_EDGE_PX, 0, 1);
			const bottomFactor = clamp((AUTO_SCROLL_EDGE_PX - bottomDist) / AUTO_SCROLL_EDGE_PX, 0, 1);
			if (topFactor > 0) vy = -AUTO_SCROLL_MAX_SPEED_PX * topFactor;
			else if (bottomFactor > 0) vy = AUTO_SCROLL_MAX_SPEED_PX * bottomFactor;
		}
		if (this.#deps.getLayoutMode() !== "vertical" && target.canScrollX) {
			const leftFactor = clamp((AUTO_SCROLL_EDGE_PX - leftDist) / AUTO_SCROLL_EDGE_PX, 0, 1);
			const rightFactor = clamp((AUTO_SCROLL_EDGE_PX - rightDist) / AUTO_SCROLL_EDGE_PX, 0, 1);
			if (leftFactor > 0) vx = -AUTO_SCROLL_MAX_SPEED_PX * leftFactor;
			else if (rightFactor > 0) vx = AUTO_SCROLL_MAX_SPEED_PX * rightFactor;
		}
		if (vx === 0 && vy === 0) {
			this.#stopAutoScroll();
			return;
		}
		this.#autoScrollVelocity = {
			x: vx,
			y: vy
		};
		this.#startAutoScroll();
	}
	#tickAutoScroll() {
		this.#autoScrollTimer = null;
		if (!this.#autoScrollActive || !this.#deps || !this.#isDragging) {
			this.#stopAutoScroll();
			return;
		}
		const target = this.#getScrollTarget();
		if (!target || !target.canScrollX && !target.canScrollY) {
			this.#stopAutoScroll();
			return;
		}
		const { x, y: y$1 } = this.#autoScrollVelocity;
		if (x === 0 && y$1 === 0) {
			this.#stopAutoScroll();
			return;
		}
		let didScroll = false;
		if (target.kind === "element" && target.element) {
			const maxScrollTop = Math.max(0, target.element.scrollHeight - target.element.clientHeight);
			const maxScrollLeft = Math.max(0, target.element.scrollWidth - target.element.clientWidth);
			const nextTop = clamp(target.element.scrollTop + y$1, 0, maxScrollTop);
			const nextLeft = clamp(target.element.scrollLeft + x, 0, maxScrollLeft);
			didScroll = nextTop !== target.element.scrollTop || nextLeft !== target.element.scrollLeft;
			if (didScroll) {
				target.element.scrollTop = nextTop;
				target.element.scrollLeft = nextLeft;
			}
		} else if (target.kind === "window" && target.win) {
			const scrollWidth = target.scrollWidth ?? 0;
			const scrollHeight = target.scrollHeight ?? 0;
			const maxScrollTop = Math.max(0, scrollHeight - target.win.innerHeight);
			const maxScrollLeft = Math.max(0, scrollWidth - target.win.innerWidth);
			const currentTop = target.win.scrollY ?? 0;
			const currentLeft = target.win.scrollX ?? 0;
			const nextTop = clamp(currentTop + y$1, 0, maxScrollTop);
			const nextLeft = clamp(currentLeft + x, 0, maxScrollLeft);
			didScroll = nextTop !== currentTop || nextLeft !== currentLeft;
			if (didScroll) target.win.scrollTo(nextLeft, nextTop);
		}
		if (didScroll) {
			const lastPointer = this.#lastPointerClient;
			if (lastPointer) this.#handleDragSelectionAt(lastPointer.clientX, lastPointer.clientY);
			this.#scheduleAutoScrollTick();
			return;
		}
		this.#stopAutoScroll();
	}
	#handleClick(event) {
		const linkEl = event.target?.closest?.("a.superdoc-link");
		if (linkEl) {
			event.preventDefault();
			if (!event.pointerId && event.detail === 0) this.#handleLinkClick(event, linkEl);
		}
	}
	#handlePointerDown(event) {
		if (!this.#deps) return;
		const bodyEditor = this.#deps.getEditor();
		bodyEditor.emit?.("pointerDown", {
			editor: bodyEditor,
			event
		});
		if (event.button === 2 || event.ctrlKey && navigator.platform.includes("Mac")) bodyEditor.emit?.("rightClick", {
			editor: bodyEditor,
			event
		});
		if (event.button !== 0) return;
		if (event.ctrlKey && navigator.platform.includes("Mac")) return;
		this.#pendingMarginClick = null;
		const target = event.target;
		if (target?.closest?.(".superdoc-ruler-handle") != null) return;
		if (this.#pendingStructuredContentLabelGesture) {
			this.#suppressFocusInFromDraggable = target?.closest?.(DRAG_SOURCE_SELECTOR) != null;
			return;
		}
		const linkEl = target?.closest?.("a.superdoc-link");
		this.#pendingTocLinkNav = null;
		if (linkEl) if (linkEl.closest(`.${DOM_CLASS_NAMES.TOC_ENTRY}`)) this.#pendingTocLinkNav = linkEl;
		else {
			this.#handleLinkClick(event, linkEl);
			return;
		}
		const annotationEl = target?.closest?.(buildAnnotationSelector());
		const isDraggableAnnotation = target?.closest?.(DRAGGABLE_SELECTOR) != null;
		const isNativeDragSource = target?.closest?.(DRAG_SOURCE_SELECTOR) != null;
		const structuredContentDragSource = target?.closest?.("[data-drag-source-kind=\"structuredContent\"]");
		const suppressFocusForDrag = isDraggableAnnotation || isNativeDragSource;
		this.#suppressFocusInFromDraggable = suppressFocusForDrag;
		if (annotationEl) {
			this.#handleAnnotationClick(event, annotationEl);
			return;
		}
		if (structuredContentDragSource) return;
		const layoutState = this.#deps.getLayoutState();
		const clickedNoteTarget = this.#resolveRenderedNoteTargetAtPointer(target, event.clientX, event.clientY);
		const sessionMode = this.#deps.getHeaderFooterSession()?.session?.mode ?? "body";
		let activeStorySession = this.#deps.getActiveStorySession?.() ?? null;
		let activeNoteSession = activeStorySession?.kind === "note" ? activeStorySession : null;
		const activeNoteTarget = this.#getActiveRenderedNoteTarget();
		if (!layoutState.layout) {
			if (clickedNoteTarget && !isSameRenderedNoteTarget(activeNoteTarget, clickedNoteTarget)) {
				if (!suppressFocusForDrag) event.preventDefault();
				if (this.#callbacks.activateRenderedNoteSession?.(clickedNoteTarget, {
					clientX: event.clientX,
					clientY: event.clientY
				})) {
					this.#syncNonBodyCommentActivation(event, target, bodyEditor);
					return;
				}
				this.#focusEditor();
				return;
			}
			if (!clickedNoteTarget && activeNoteSession) this.#callbacks.exitActiveStorySession?.();
			if (!(sessionMode !== "body" || activeNoteSession != null)) {
				if (this.#handleSingleCommentHighlightClick(event, target, bodyEditor)) return;
				if (this.#handleRepeatClickOnActiveComment(event, target, bodyEditor)) return;
			} else this.#syncNonBodyCommentActivation(event, target, bodyEditor);
			this.#handleClickWithoutLayout(event, suppressFocusForDrag);
			return;
		}
		const normalizedPoint = this.#callbacks.normalizeClientPoint?.(event.clientX, event.clientY);
		if (!normalizedPoint) return;
		const { x, y: y$1 } = normalizedPoint;
		this.#debugLastPointer = {
			clientX: event.clientX,
			clientY: event.clientY,
			x,
			y: y$1
		};
		if (clickedNoteTarget) {
			if (!isSameRenderedNoteTarget(activeNoteTarget, clickedNoteTarget)) {
				if (!suppressFocusForDrag) event.preventDefault();
				if (this.#callbacks.activateRenderedNoteSession?.(clickedNoteTarget, {
					clientX: event.clientX,
					clientY: event.clientY,
					pageIndex: normalizedPoint.pageIndex
				})) {
					this.#syncNonBodyCommentActivation(event, target, bodyEditor);
					return;
				}
				this.#focusEditor();
				return;
			}
		} else if (activeNoteSession) {
			this.#callbacks.exitActiveStorySession?.();
			activeStorySession = null;
			activeNoteSession = null;
		}
		if (!(sessionMode !== "body" || activeStorySession != null)) {
			if (this.#handleSingleCommentHighlightClick(event, target, bodyEditor)) return;
			if (this.#handleRepeatClickOnActiveComment(event, target, bodyEditor)) return;
		} else this.#syncNonBodyCommentActivation(event, target, bodyEditor);
		const isNoteEditing = activeNoteSession != null;
		let currentSessionMode = sessionMode;
		let useActiveSurfaceHitTest = currentSessionMode !== "body" || activeStorySession != null;
		let editor = currentSessionMode === "body" && !isNoteEditing ? bodyEditor : this.#deps.getActiveEditor();
		if (currentSessionMode !== "body") {
			if (this.#handleClickInHeaderFooterMode(event, x, y$1, normalizedPoint.pageIndex, normalizedPoint.pageLocalY)) return;
			if ((this.#deps.getHeaderFooterSession()?.session?.mode ?? "body") === "body" && !isNoteEditing) {
				activeStorySession = this.#deps.getActiveStorySession?.() ?? null;
				currentSessionMode = "body";
				useActiveSurfaceHitTest = activeStorySession != null;
				editor = bodyEditor;
			}
		}
		if (this.#callbacks.hitTestHeaderFooterRegion?.(x, y$1, normalizedPoint.pageIndex, normalizedPoint.pageLocalY)) {
			if (sessionMode === "body") {
				event.preventDefault();
				return;
			}
		}
		if (!useActiveSurfaceHitTest) {
			if (!Number.isFinite(normalizedPoint.pageIndex) || isOutsidePageBodyContent(layoutState.layout, x, normalizedPoint.pageIndex, normalizedPoint.pageLocalY)) {
				event.preventDefault();
				this.#focusEditor();
				return;
			}
		}
		const { rawHit, hit } = this.#resolveSelectionPointerHit({
			layoutState,
			normalized: {
				x,
				y: y$1
			},
			clientX: event.clientX,
			clientY: event.clientY,
			editor,
			useActiveSurfaceHitTest
		});
		const doc$1 = editor.state?.doc;
		this.#debugLastHit = hit ? {
			source: "dom",
			pos: rawHit?.pos ?? null,
			layoutEpoch: rawHit?.layoutEpoch ?? null,
			mappedPos: hit.pos
		} : {
			source: "none",
			pos: rawHit?.pos ?? null,
			layoutEpoch: rawHit?.layoutEpoch ?? null,
			mappedPos: null
		};
		this.#callbacks.updateSelectionDebugHud?.();
		if (!suppressFocusForDrag) event.preventDefault();
		if (!rawHit) {
			this.#focusEditor();
			return;
		}
		if (isNoteEditing && activeNoteTarget && !isSameRenderedNoteTarget(parseRenderedNoteTarget$1(rawHit.blockId), activeNoteTarget)) {
			this.#callbacks.exitActiveStorySession?.();
			this.#focusEditor();
			return;
		}
		if (isRenderedNoteBlockId(rawHit.blockId) && !isNoteEditing) {
			this.#focusEditor();
			return;
		}
		if (!hit || !doc$1) {
			this.#callbacks.setPendingDocChange?.();
			this.#callbacks.scheduleRerender?.();
			return;
		}
		const fragmentHit = useActiveSurfaceHitTest ? null : getFragmentAtPosition(layoutState.layout, layoutState.blocks, layoutState.measures, rawHit.pos);
		const targetImg = event.target?.closest?.("img");
		if (!useActiveSurfaceHitTest) {
			const epochMapper = this.#deps.getEpochMapper();
			if (this.#handleInlineImageClick(event, targetImg, rawHit, doc$1, epochMapper)) return;
		}
		if (this.#handleFragmentClick(event, fragmentHit, hit, doc$1)) return;
		if (this.#lastSelectedImageBlockId) {
			this.#callbacks.emit?.("imageDeselected", { blockId: this.#lastSelectedImageBlockId });
			this.#lastSelectedImageBlockId = null;
		}
		if (event.shiftKey && editor.state.selection.$anchor) {
			this.#handleShiftClick(event, hit.pos);
			return;
		}
		const clickDepth = this.#registerPointerClick(event);
		if (clickDepth === 1) {
			this.#dragAnchor = hit.pos;
			this.#dragAnchorPageIndex = hit.pageIndex;
			this.#pendingMarginClick = this.#callbacks.computePendingMarginClick?.(event.pointerId, x, y$1) ?? null;
			const tableHit = this.#hitTestTable(x, y$1);
			if (tableHit) {
				const tablePos = this.#getTablePosFromHit(tableHit);
				const hitIsInsideTable = tablePos !== null && doc$1 && hit.pos >= tablePos && hit.pos <= tablePos + (doc$1.nodeAt(tablePos)?.nodeSize ?? 0);
				if (tablePos !== null && hitIsInsideTable) this.#setCellAnchor(tableHit, tablePos);
				else this.#clearCellAnchor();
			} else this.#clearCellAnchor();
		} else this.#pendingMarginClick = null;
		this.#dragLastPointer = {
			clientX: event.clientX,
			clientY: event.clientY,
			x,
			y: y$1
		};
		this.#dragLastRawHit = hit;
		this.#dragUsedPageNotMountedFallback = false;
		this.#dragStartClient = {
			clientX: event.clientX,
			clientY: event.clientY
		};
		this.#dragThresholdExceeded = false;
		this.#lastPointerClient = {
			clientX: event.clientX,
			clientY: event.clientY
		};
		this.#isDragging = true;
		if (clickDepth >= 3) this.#dragExtensionMode = "para";
		else if (clickDepth === 2) this.#dragExtensionMode = "word";
		else this.#dragExtensionMode = "char";
		const viewportHost = this.#deps.getViewportHost();
		if (typeof viewportHost.setPointerCapture === "function") viewportHost.setPointerCapture(event.pointerId);
		let handledByDepth = false;
		const selectionPos = clickDepth >= 2 && this.#dragAnchor !== null ? this.#dragAnchor : hit.pos;
		if (clickDepth >= 3) handledByDepth = this.#callbacks.selectParagraphAt?.(selectionPos) ?? false;
		else if (clickDepth === 2) handledByDepth = this.#callbacks.selectWordAt?.(selectionPos) ?? false;
		this.#focusEditor();
		if (!handledByDepth) try {
			let nextSelection;
			let inlineSdtBoundaryPos = null;
			let inlineSdtBoundaryDirection = null;
			const clickedEmptySdtPlaceholder = target?.closest?.(EMPTY_SDT_PLACEHOLDER_SELECTOR) != null;
			const inlineSdt = clickDepth === 1 ? findStructuredContentInlineAtPos(doc$1, hit.pos) : null;
			if (!clickedEmptySdtPlaceholder && inlineSdt && hit.pos >= inlineSdt.end) {
				const afterInlineSdt = inlineSdt.pos + inlineSdt.node.nodeSize;
				inlineSdtBoundaryPos = afterInlineSdt;
				inlineSdtBoundaryDirection = "after";
				nextSelection = TextSelection.create(doc$1, afterInlineSdt);
			} else if (!clickedEmptySdtPlaceholder && inlineSdt && hit.pos <= inlineSdt.start) {
				inlineSdtBoundaryPos = inlineSdt.pos;
				inlineSdtBoundaryDirection = "before";
				nextSelection = TextSelection.create(doc$1, inlineSdt.pos);
			} else nextSelection = TextSelection.create(doc$1, hit.pos);
			if (!nextSelection.$from.parent.inlineContent) nextSelection = Selection.near(doc$1.resolve(hit.pos), 1);
			let tr = editor.state.tr.setSelection(nextSelection).setMeta("uiEvent", "click");
			if (inlineSdtBoundaryPos != null && inlineSdtBoundaryDirection) {
				tr = applyEditableSlotAtInlineBoundary(tr, inlineSdtBoundaryPos, inlineSdtBoundaryDirection);
				nextSelection = tr.selection;
			}
			if (nextSelection instanceof TextSelection && nextSelection.empty && editor.state.storedMarks) tr.setStoredMarks(editor.state.storedMarks);
			editor.view?.dispatch(tr);
		} catch {}
		this.#callbacks.scheduleSelectionUpdate?.();
	}
	#handleStructuredContentLabelPointerDown(event) {
		if (!this.#deps) return;
		this.#pendingStructuredContentLabelGesture = null;
		if (event.button !== 0) return;
		const target = event.target;
		const label = this.#resolveStructuredContentLabelTarget(event, target);
		this.#pendingStructuredContentLabelGesture = label ? {
			label,
			clientX: event.clientX,
			clientY: event.clientY,
			pointerId: event.pointerId
		} : null;
	}
	#handleStructuredContentLabelPointerUp(event) {
		if (!this.#deps) return;
		if (event.button !== 0) return;
		const pending = this.#pendingStructuredContentLabelGesture;
		if (!pending) return;
		if (pending.pointerId !== event.pointerId) return;
		const deltaX = event.clientX - pending.clientX;
		const deltaY = event.clientY - pending.clientY;
		if (Math.hypot(deltaX, deltaY) > DRAG_SELECTION_DISTANCE_THRESHOLD_PX) this.#pendingStructuredContentLabelGesture = null;
	}
	#handleStructuredContentLabelPointerCancel(event) {
		const pending = this.#pendingStructuredContentLabelGesture;
		if (!pending || pending.pointerId !== event.pointerId) return;
		this.#pendingStructuredContentLabelGesture = null;
	}
	#handleStructuredContentLabelClickEvent(event) {
		if (!this.#deps) return;
		const target = event.target;
		const bodyEditor = this.#deps.getEditor();
		try {
			if (this.#handleStructuredContentLabelClick(event, target, bodyEditor)) {
				event.stopImmediatePropagation();
				return;
			}
			const editor = this.#deps.getActiveEditor();
			if (bodyEditor !== editor && this.#handleStructuredContentLabelClick(event, target, editor)) event.stopImmediatePropagation();
		} finally {
			this.#pendingStructuredContentLabelGesture = null;
		}
	}
	#handlePointerMove(event) {
		if (!this.#deps) return;
		if (!this.#deps.getLayoutState().layout) return;
		if (this.#isDragging && this.#dragAnchor !== null && event.buttons & 1) {
			if (!this.#hasExceededDragSelectionThreshold(event.clientX, event.clientY)) return;
			this.#lastPointerClient = {
				clientX: event.clientX,
				clientY: event.clientY
			};
			this.#handleDragSelectionAt(event.clientX, event.clientY);
			this.#updateAutoScrollFromPointer(event.clientX, event.clientY);
			return;
		}
		const normalized = this.#callbacks.normalizeClientPoint?.(event.clientX, event.clientY);
		if (!normalized) return;
		if (this.#deps.getActiveStorySession?.()?.kind === "note") {
			this.#callbacks.clearHoverRegion?.();
			return;
		}
		this.#handleHover(normalized);
	}
	#handlePointerUp(event) {
		if (!this.#deps) return;
		const editor = this.#deps.getEditor();
		editor.emit?.("pointerUp", {
			editor,
			event
		});
		this.#suppressFocusInFromDraggable = false;
		const pendingTocLink = this.#pendingTocLinkNav;
		this.#pendingTocLinkNav = null;
		if (pendingTocLink && !this.#dragThresholdExceeded) this.#handleLinkClick(event, pendingTocLink);
		if (!this.#isDragging) {
			this.#stopAutoScroll();
			return;
		}
		const viewportHost = this.#deps.getViewportHost();
		if (typeof viewportHost.hasPointerCapture === "function" && typeof viewportHost.releasePointerCapture === "function" && viewportHost.hasPointerCapture(event.pointerId)) viewportHost.releasePointerCapture(event.pointerId);
		const pendingMarginClick = this.#pendingMarginClick;
		this.#pendingMarginClick = null;
		const dragAnchor = this.#dragAnchor;
		const dragMode = this.#dragExtensionMode;
		if ((!pendingMarginClick || pendingMarginClick.pointerId !== event.pointerId) && dragAnchor != null && this.#dragThresholdExceeded) this.#handleDragSelectionAt(event.clientX, event.clientY);
		const dragUsedFallback = this.#dragUsedPageNotMountedFallback;
		const dragPointer = this.#dragLastPointer;
		this.#isDragging = false;
		this.#stopAutoScroll();
		if (this.#cellDragMode !== "none") this.#cellDragMode = "none";
		if (!pendingMarginClick || pendingMarginClick.pointerId !== event.pointerId) {
			this.#callbacks.updateSelectionVirtualizationPins?.({ includeDragBuffer: false });
			if (dragUsedFallback && dragAnchor != null) {
				const pointer = dragPointer ?? {
					clientX: event.clientX,
					clientY: event.clientY
				};
				this.#callbacks.finalizeDragSelectionWithDom?.(pointer, dragAnchor, dragMode);
			}
			this.#callbacks.notifyDragSelectionEnded?.();
			this.#callbacks.scheduleA11ySelectionAnnouncement?.({ immediate: true });
			this.#dragLastPointer = null;
			this.#dragLastRawHit = null;
			this.#dragUsedPageNotMountedFallback = false;
			this.#dragStartClient = null;
			this.#dragThresholdExceeded = false;
			this.#lastPointerClient = null;
			return;
		}
		this.#handleMarginClickEnd(event, pendingMarginClick);
	}
	#handlePointerLeave() {
		if (!this.#isDragging) this.#stopAutoScroll();
		this.#callbacks.clearHoverRegion?.();
	}
	#handleDoubleClick(event) {
		if (!this.#deps) return;
		if (event.button !== 0) return;
		const target = event.target;
		const annotationEl = target?.closest?.(buildAnnotationSelector());
		if (annotationEl) {
			event.preventDefault();
			event.stopPropagation();
			this.#handleAnnotationDoubleClick(event, annotationEl);
			return;
		}
		const sessionMode = this.#deps.getHeaderFooterSession()?.session?.mode ?? "body";
		if (!this.#deps.getLayoutState().layout) return;
		const normalized = this.#callbacks.normalizeClientPoint?.(event.clientX, event.clientY);
		if (!normalized) return;
		const clickedNoteTarget = this.#resolveRenderedNoteTargetAtPointer(target, event.clientX, event.clientY);
		if (clickedNoteTarget) {
			if (isSameRenderedNoteTarget(this.#getActiveRenderedNoteTarget(), clickedNoteTarget)) {
				if (this.#clickCount <= 1) this.#resetMultiClickTracking();
				return;
			}
			event.preventDefault();
			event.stopPropagation();
			this.#callbacks.activateRenderedNoteSession?.(clickedNoteTarget, {
				clientX: event.clientX,
				clientY: event.clientY,
				pageIndex: normalized.pageIndex
			});
			return;
		}
		const region = this.#callbacks.hitTestHeaderFooterRegion?.(normalized.x, normalized.y, normalized.pageIndex, normalized.pageLocalY);
		if (region) {
			if (sessionMode === "body" || this.#isDifferentHeaderFooterRegionFromActiveSession(region)) {
				event.preventDefault();
				event.stopPropagation();
				this.#callbacks.activateHeaderFooterRegion?.(region, {
					clientX: event.clientX,
					clientY: event.clientY,
					pageIndex: normalized.pageIndex,
					source: "pointerDoubleClick"
				});
			}
		} else if ((this.#deps.getHeaderFooterSession()?.session?.mode ?? "body") !== "body") this.#callbacks.exitHeaderFooterMode?.();
	}
	#handleAnnotationDoubleClick(event, annotationEl) {
		const editor = this.#deps?.getEditor();
		if (!editor?.isEditable) return;
		const resolved = this.#callbacks.resolveFieldAnnotationSelectionFromElement?.(annotationEl);
		if (resolved) {
			try {
				const tr = editor.state.tr.setSelection(NodeSelection.create(editor.state.doc, resolved.pos));
				editor.view?.dispatch(tr);
			} catch {}
			editor.emit("fieldAnnotationDoubleClicked", {
				editor,
				node: resolved.node,
				nodePos: resolved.pos,
				event,
				currentTarget: annotationEl
			});
		}
	}
	#handleKeyDown(event) {
		if (!this.#deps) return;
		const sessionMode = this.#deps.getHeaderFooterSession()?.session?.mode ?? "body";
		const activeStorySession = this.#deps.getActiveStorySession?.() ?? null;
		if (event.key === "Escape" && sessionMode !== "body") {
			event.preventDefault();
			this.#callbacks.exitHeaderFooterMode?.();
			return;
		}
		if (event.key === "Escape" && activeStorySession?.kind === "note") {
			event.preventDefault();
			this.#callbacks.exitActiveStorySession?.();
			return;
		}
		if (event.ctrlKey && event.altKey && !event.shiftKey) {
			if (event.code === "KeyH") {
				event.preventDefault();
				this.#focusHeaderFooterShortcut("header");
			} else if (event.code === "KeyF") {
				event.preventDefault();
				this.#focusHeaderFooterShortcut("footer");
			}
		}
	}
	#handleFocusIn(event) {
		if (!this.#deps) return;
		if (this.#suppressFocusInFromDraggable) {
			this.#suppressFocusInFromDraggable = false;
			return;
		}
		this.#focusEditorView(this.#deps.getActiveEditor().view);
		this.#callbacks.scheduleSelectionUpdate?.();
	}
	#handleEditorFocus() {
		if (!this.#deps) return;
		this.#callbacks.scheduleSelectionUpdate?.();
	}
	#handleEditorBlur() {
		if (!this.#deps) return;
		this.#callbacks.scheduleSelectionUpdate?.();
	}
	#handleLinkClick(event, linkEl) {
		const href = linkEl.getAttribute("href") ?? "";
		if (href.startsWith("#") && href.length > 1) {
			event.preventDefault();
			event.stopPropagation();
			this.#callbacks.goToAnchor?.(href);
			return;
		}
		event.preventDefault();
		event.stopPropagation();
		const linkClickEvent = new CustomEvent("superdoc-link-click", {
			bubbles: true,
			composed: true,
			detail: {
				href,
				target: linkEl.getAttribute("target"),
				rel: linkEl.getAttribute("rel"),
				tooltip: linkEl.getAttribute("title"),
				element: linkEl,
				clientX: event.clientX,
				clientY: event.clientY
			}
		});
		linkEl.dispatchEvent(linkClickEvent);
	}
	#handleAnnotationClick(event, annotationEl) {
		const editor = this.#deps?.getEditor();
		if (!editor?.isEditable) return;
		const resolved = this.#callbacks.resolveFieldAnnotationSelectionFromElement?.(annotationEl);
		if (resolved) {
			try {
				const tr = editor.state.tr.setSelection(NodeSelection.create(editor.state.doc, resolved.pos));
				editor.view?.dispatch(tr);
			} catch {}
			editor.emit("fieldAnnotationClicked", {
				editor,
				node: resolved.node,
				nodePos: resolved.pos,
				event,
				currentTarget: annotationEl
			});
		}
	}
	#handleStructuredContentLabelClick(event, target, editor) {
		const doc$1 = editor.state?.doc;
		if (!doc$1) return false;
		const labelTarget = this.#resolveStructuredContentLabelTarget(event, target);
		const inlineLabel = labelTarget?.closest?.(INLINE_SDT_LABEL_SELECTOR);
		if (inlineLabel) {
			const resolved = this.#resolveStructuredContentInlineFromElement(doc$1, inlineLabel);
			if (resolved) {
				event.preventDefault();
				const applyNodeSelection = () => {
					const state = editor.view?.state ?? editor.state;
					const tr = state.tr.setSelection(NodeSelection.create(state.doc, resolved.pos));
					editor.view?.dispatch(tr);
				};
				try {
					applyNodeSelection();
				} catch {
					const tr = editor.state.tr.setSelection(TextSelection.create(doc$1, resolved.start, resolved.end));
					editor.view?.dispatch(tr);
				}
				this.#callbacks.scheduleSelectionUpdate?.();
				this.#focusEditor();
				return true;
			}
		}
		const blockLabel = labelTarget?.closest?.(BLOCK_SDT_LABEL_SELECTOR);
		if (blockLabel) {
			const resolved = this.#resolveStructuredContentBlockFromElement(doc$1, blockLabel);
			if (resolved) {
				event.preventDefault();
				const applySelection = () => {
					const state = editor.view?.state ?? editor.state;
					const selection = NodeSelection.create(state.doc, resolved.pos);
					const tr = state.tr.setSelection(selection);
					editor.view?.dispatch(tr);
				};
				try {
					applySelection();
				} catch {
					const state = editor.view?.state ?? editor.state;
					const tr = state.tr.setSelection(TextSelection.create(state.doc, resolved.start, resolved.end));
					editor.view?.dispatch(tr);
				}
				this.#callbacks.scheduleSelectionUpdate?.();
				this.#focusEditor();
				return true;
			}
		}
		return false;
	}
	#resolveStructuredContentLabelTarget(event, target) {
		const directLabel = target?.closest?.(SDT_LABEL_SELECTOR);
		if (directLabel && this.#isStructuredContentLabelOwned(directLabel)) return directLabel;
		const doc$1 = target?.ownerDocument ?? document;
		const elementsFromPoint = doc$1.elementsFromPoint?.bind(doc$1);
		if (!elementsFromPoint) return null;
		const pointElements = elementsFromPoint(event.clientX, event.clientY);
		const topElement = doc$1.elementFromPoint?.(event.clientX, event.clientY) ?? pointElements[0] ?? null;
		for (const element of pointElements) {
			if (!(element instanceof HTMLElement)) continue;
			const label = element.closest?.(SDT_LABEL_SELECTOR);
			if (label && this.#isStructuredContentLabelOwned(label) && this.#isStructuredContentLabelTopHit(label, topElement)) return label;
		}
		for (const label of Array.from(doc$1.querySelectorAll(SDT_LABEL_SELECTOR))) {
			if (!this.#isStructuredContentLabelOwned(label)) continue;
			const rect = label.getBoundingClientRect();
			if (rect.width > 0 && rect.height > 0 && event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom && this.#isStructuredContentLabelTopHit(label, topElement)) return label;
		}
		return null;
	}
	#isStructuredContentLabelTopHit(label, topElement) {
		return Boolean(topElement && (label === topElement || label.contains(topElement)));
	}
	#isStructuredContentLabelOwned(label) {
		const visibleHost = this.#deps?.getVisibleHost();
		const viewportHost = this.#deps?.getViewportHost();
		return Boolean(visibleHost?.contains(label) || viewportHost?.contains(label));
	}
	#resolveStructuredContentBlockFromElement(doc$1, element) {
		const elementSdtId = element.dataset?.sdtId;
		if (elementSdtId) {
			const match$1 = findStructuredContentBlockById(doc$1, elementSdtId);
			if (match$1) return match$1;
		}
		const elementPmStartRaw = element.dataset?.pmStart;
		const elementPmStart = elementPmStartRaw != null ? Number(elementPmStartRaw) : NaN;
		if (Number.isFinite(elementPmStart)) {
			const match$1 = findStructuredContentBlockAtPos(doc$1, elementPmStart);
			if (match$1) return match$1;
		}
		const container = element.closest?.(".superdoc-structured-content-block");
		if (!container) return null;
		const sdtId = container.dataset?.sdtId;
		if (sdtId) {
			const match$1 = findStructuredContentBlockById(doc$1, sdtId);
			if (match$1) return match$1;
		}
		const containerSdtId = container.dataset?.sdtContainerId;
		if (containerSdtId) {
			const match$1 = findStructuredContentBlockById(doc$1, containerSdtId);
			if (match$1) return match$1;
		}
		const pmStartRaw = container.dataset?.pmStart;
		const pmStart = pmStartRaw != null ? Number(pmStartRaw) : NaN;
		if (Number.isFinite(pmStart)) return findStructuredContentBlockAtPos(doc$1, pmStart);
		return null;
	}
	#resolveStructuredContentInlineFromElement(doc$1, element) {
		const elementSdtId = element.dataset?.sdtId;
		if (elementSdtId) {
			const match$1 = findStructuredContentInlineById(doc$1, elementSdtId);
			if (match$1) return match$1;
		}
		const elementPmStartRaw = element.dataset?.pmStart;
		const elementPmStart = elementPmStartRaw != null ? Number(elementPmStartRaw) : NaN;
		if (Number.isFinite(elementPmStart)) {
			const match$1 = findStructuredContentInlineAtPos(doc$1, elementPmStart);
			if (match$1) return match$1;
		}
		const container = element.closest?.(".superdoc-structured-content-inline");
		if (!container) return null;
		const sdtId = container.dataset?.sdtId;
		if (sdtId) {
			const match$1 = findStructuredContentInlineById(doc$1, sdtId);
			if (match$1) return match$1;
		}
		const pmStartRaw = container.dataset?.pmStart;
		const pmStart = pmStartRaw != null ? Number(pmStartRaw) : NaN;
		if (Number.isFinite(pmStart)) return findStructuredContentInlineAtPos(doc$1, pmStart);
		return null;
	}
	#handleClickWithoutLayout(event, isDraggableAnnotation) {
		if (!isDraggableAnnotation) event.preventDefault();
		if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
		this.#focusEditorAtFirstPosition();
	}
	#handleClickInHeaderFooterMode(event, x, y$1, pageIndex, pageLocalY) {
		const session = this.#deps?.getHeaderFooterSession();
		const activeSurfaceSelector = session?.session?.mode === "footer" ? ".superdoc-page-footer" : ".superdoc-page-header";
		const visiblePointerSurface = resolveVisibleSurfaceAtPointer(event.target, event.clientX, event.clientY);
		const clickedInsideVisibleActiveSurface = visiblePointerSurface?.kind === "headerFooter" && visiblePointerSurface.surface.closest(activeSurfaceSelector) != null;
		if (visiblePointerSurface?.kind === "bodyContent") {
			const behindDocSection = (event.target instanceof Element ? event.target.closest("[data-behind-doc-section]") : null)?.dataset.behindDocSection;
			const sessionMode = session?.session?.mode;
			if (behindDocSection && behindDocSection === sessionMode) return false;
			this.#callbacks.exitHeaderFooterMode?.();
			return false;
		}
		const headerFooterRegion = this.#callbacks.hitTestHeaderFooterRegion?.(x, y$1, pageIndex, pageLocalY);
		if (!headerFooterRegion) {
			this.#callbacks.exitHeaderFooterMode?.();
			return false;
		}
		if (visiblePointerSurface?.kind === "headerFooter" && !clickedInsideVisibleActiveSurface) {
			if (this.#isDifferentHeaderFooterRegionFromActiveSession(headerFooterRegion)) {
				event.preventDefault();
				return true;
			}
			this.#callbacks.exitHeaderFooterMode?.();
			return false;
		}
		this.#syncNonBodyCommentSelection(event, event.target, this.#deps.getEditor(), { clearOnMiss: true });
		return false;
	}
	#isDifferentHeaderFooterRegionFromActiveSession(region) {
		const session = this.#deps?.getHeaderFooterSession()?.session;
		if (!session || session.mode === "body") return true;
		if (session.mode !== region.kind) return true;
		if (session.headerFooterRefId && region.headerFooterRefId && session.headerFooterRefId !== region.headerFooterRefId) return true;
		if (Number.isFinite(session.pageIndex) && Number.isFinite(region.pageIndex) && session.pageIndex !== region.pageIndex) return true;
		return (session.sectionType ?? null) !== (region.sectionType ?? null);
	}
	#isSameHeaderFooterRegion(left$1, right$1) {
		if (!left$1 || !right$1) return false;
		if (left$1.kind !== right$1.kind || left$1.pageIndex !== right$1.pageIndex) return false;
		if ((left$1.sectionId ?? null) !== (right$1.sectionId ?? null)) return false;
		if ((left$1.sectionType ?? null) !== (right$1.sectionType ?? null)) return false;
		const leftRefId = left$1.headerFooterRefId ?? null;
		const rightRefId = right$1.headerFooterRefId ?? null;
		if (leftRefId && rightRefId && leftRefId !== rightRefId) return false;
		return true;
	}
	#handleInlineImageClick(event, targetImg, rawHit, doc$1, epochMapper) {
		if (!targetImg) return false;
		const wrapper = targetImg.closest?.(`.${DOM_CLASS_NAMES.INLINE_IMAGE_CLIP_WRAPPER}`);
		const pmStartSource = wrapper ?? targetImg;
		const imgPmStart = pmStartSource?.dataset?.pmStart ? Number(pmStartSource.dataset.pmStart) : null;
		if (Number.isNaN(imgPmStart) || imgPmStart == null) return false;
		const imgLayoutEpochRaw = pmStartSource?.dataset?.layoutEpoch;
		const imgLayoutEpoch = imgLayoutEpochRaw != null ? Number(imgLayoutEpochRaw) : NaN;
		const rawLayoutEpoch = Number.isFinite(rawHit.layoutEpoch) ? rawHit.layoutEpoch : NaN;
		const effectiveEpoch = Number.isFinite(imgLayoutEpoch) && Number.isFinite(rawLayoutEpoch) ? Math.max(imgLayoutEpoch, rawLayoutEpoch) : Number.isFinite(imgLayoutEpoch) ? imgLayoutEpoch : rawHit.layoutEpoch;
		const mappedImg = epochMapper.mapPosFromLayoutToCurrentDetailed(imgPmStart, effectiveEpoch, 1);
		if (!mappedImg.ok) {
			debugLog("warn", "inline image mapping failed", mappedImg);
			this.#callbacks.setPendingDocChange?.();
			this.#callbacks.scheduleRerender?.();
			return true;
		}
		const clampedImgPos = Math.max(0, Math.min(mappedImg.pos, doc$1.content.size));
		if (clampedImgPos < 0 || clampedImgPos >= doc$1.content.size) return true;
		const newSelectionId = `inline-${clampedImgPos}`;
		if (this.#lastSelectedImageBlockId && this.#lastSelectedImageBlockId !== newSelectionId) this.#callbacks.emit?.("imageDeselected", { blockId: this.#lastSelectedImageBlockId });
		const editor = this.#deps?.getEditor();
		try {
			const tr = editor.state.tr.setSelection(NodeSelection.create(doc$1, clampedImgPos));
			editor.view?.dispatch(tr);
			const targetElement = this.#callbacks.resolveInlineImageElementByPmStart?.(imgPmStart) ?? null;
			const elementForHighlight = wrapper ?? targetElement ?? targetImg;
			this.#callbacks.emit?.("imageSelected", {
				element: elementForHighlight,
				blockId: null,
				pmStart: clampedImgPos
			});
			this.#lastSelectedImageBlockId = newSelectionId;
		} catch (error) {
			if (process$1.env.NODE_ENV === "development") console.warn(`[EditorInputManager] Failed to create NodeSelection for inline image:`, error);
		}
		this.#callbacks.focusEditorAfterImageSelection?.();
		return true;
	}
	#handleFragmentClick(event, fragmentHit, hit, doc$1) {
		if (!fragmentHit) return false;
		if (fragmentHit.fragment.kind !== "image" && fragmentHit.fragment.kind !== "drawing") return false;
		if (fragmentHit.fragment.kind === "drawing" && fragmentHit.fragment.drawingKind === "textboxShape") return false;
		const editor = this.#deps?.getEditor();
		try {
			const tr = editor.state.tr.setSelection(NodeSelection.create(doc$1, hit.pos));
			editor.view?.dispatch(tr);
			if (this.#lastSelectedImageBlockId && this.#lastSelectedImageBlockId !== fragmentHit.fragment.blockId) this.#callbacks.emit?.("imageDeselected", { blockId: this.#lastSelectedImageBlockId });
			if (fragmentHit.fragment.kind === "image") {
				const targetElement = fragmentHit.fragment.pmStart != null ? this.#callbacks.resolveImageFragmentElementByPmStart?.(fragmentHit.fragment.pmStart) ?? null : null;
				if (targetElement) {
					this.#callbacks.emit?.("imageSelected", {
						element: targetElement,
						blockId: fragmentHit.fragment.blockId,
						pmStart: fragmentHit.fragment.pmStart
					});
					this.#lastSelectedImageBlockId = fragmentHit.fragment.blockId;
				}
			}
		} catch (error) {
			if (process$1.env.NODE_ENV === "development") console.warn("[EditorInputManager] Failed to create NodeSelection for atomic fragment:", error);
		}
		this.#callbacks.focusEditorAfterImageSelection?.();
		return true;
	}
	#handleShiftClick(event, headPos) {
		const editor = this.#deps?.getActiveEditor() ?? this.#deps?.getEditor();
		if (!editor) return;
		const anchor = editor.state.selection.anchor;
		this.#dispatchExtendedTextSelection(editor, anchor, headPos);
		this.#focusEditor();
	}
	#handleDragSelectionAt(clientX, clientY) {
		if (!this.#deps) return;
		const layoutState = this.#deps.getLayoutState();
		if (!layoutState.layout) return;
		const normalized = this.#callbacks.normalizeClientPoint?.(clientX, clientY);
		if (!normalized) return;
		this.#pendingMarginClick = null;
		this.#dragLastPointer = {
			clientX,
			clientY,
			x: normalized.x,
			y: normalized.y
		};
		const activeStorySession = this.#deps.getActiveStorySession?.() ?? null;
		const useActiveSurfaceHitTest = (this.#deps.getHeaderFooterSession()?.session?.mode ?? "body") !== "body" || activeStorySession != null;
		const editor = useActiveSurfaceHitTest ? this.#deps.getActiveEditor() : this.#deps.getEditor();
		const { rawHit, hit } = this.#resolveSelectionPointerHit({
			layoutState,
			normalized: {
				x: normalized.x,
				y: normalized.y
			},
			clientX,
			clientY,
			editor,
			useActiveSurfaceHitTest
		});
		if (!rawHit || !hit) return;
		if (!useActiveSurfaceHitTest && isRenderedNoteBlockId(rawHit.blockId)) return;
		if (!editor.state?.doc) return;
		this.#dragLastRawHit = rawHit;
		const pageMounted = this.#deps.getPageElement(rawHit.pageIndex) != null;
		if (!pageMounted && this.#deps.isSelectionAwareVirtualizationEnabled()) this.#dragUsedPageNotMountedFallback = true;
		this.#callbacks.updateSelectionVirtualizationPins?.({
			includeDragBuffer: true,
			extraPages: [rawHit.pageIndex]
		});
		this.#debugLastHit = {
			source: useActiveSurfaceHitTest || pageMounted ? "dom" : "geometry",
			pos: rawHit.pos,
			layoutEpoch: rawHit.layoutEpoch,
			mappedPos: hit.pos
		};
		this.#callbacks.updateSelectionDebugHud?.();
		const currentTableHit = useActiveSurfaceHitTest ? null : this.#hitTestTable(normalized.x, normalized.y);
		if (this.#shouldUseCellSelection(currentTableHit) && this.#cellAnchor) {
			this.#handleCellDragSelection(currentTableHit, hit);
			return;
		}
		const anchor = this.#dragAnchor;
		const head = hit.pos;
		if (!useActiveSurfaceHitTest) {
			const crossCell = resolveCrossCellSelection(editor.state.doc, anchor, head);
			if (crossCell) try {
				const tr = editor.state.tr.setSelection(CellSelection.create(editor.state.doc, crossCell.anchorCellPos, crossCell.headCellPos));
				editor.view?.dispatch(tr);
				if (!this.#setCellAnchorFromCellPos(crossCell.anchorCellPos, "active")) console.warn("[CELL-SELECTION] Failed to cache anchor state for cross-cell drag selection.");
				this.#callbacks.scheduleSelectionUpdate?.();
				return;
			} catch (error) {
				console.warn("[SELECTION] Failed to create cross-cell CellSelection during drag:", error);
			}
		}
		this.#dispatchExtendedTextSelection(editor, anchor, head);
	}
	#handleCellDragSelection(currentTableHit, hit) {
		if (!this.#cellAnchor) return;
		if (!currentTableHit || currentTableHit.block.id !== this.#cellAnchor.tableBlockId) return;
		const headCellPos = this.#getCellPosFromTableHit(currentTableHit);
		if (headCellPos === null) return;
		if (this.#cellDragMode !== "active") this.#cellDragMode = "active";
		const editor = this.#deps?.getEditor();
		if (!editor) return;
		try {
			const doc$1 = editor.state.doc;
			const anchorCellPos = this.#cellAnchor.cellPos;
			const clampedAnchor = Math.max(0, Math.min(anchorCellPos, doc$1.content.size));
			const clampedHead = Math.max(0, Math.min(headCellPos, doc$1.content.size));
			const cellSelection = CellSelection.create(doc$1, clampedAnchor, clampedHead);
			const tr = editor.state.tr.setSelection(cellSelection);
			editor.view?.dispatch(tr);
			this.#callbacks.scheduleSelectionUpdate?.();
		} catch (error) {
			console.warn("[CELL-SELECTION] Failed to create CellSelection, falling back to TextSelection:", error);
			const anchor = this.#dragAnchor;
			this.#dispatchExtendedTextSelection(editor, anchor, hit.pos);
		}
	}
	#handleHover(normalized) {
		if (!this.#deps) return;
		if (this.#deps.getDocumentMode() === "viewing") {
			this.#callbacks.clearHoverRegion?.();
			return;
		}
		const sessionMode = this.#deps.getHeaderFooterSession()?.session?.mode ?? "body";
		const region = this.#callbacks.hitTestHeaderFooterRegion?.(normalized.x, normalized.y, normalized.pageIndex, normalized.pageLocalY);
		if (!region) {
			this.#callbacks.clearHoverRegion?.();
			return;
		}
		if (sessionMode !== "body" && !this.#isDifferentHeaderFooterRegionFromActiveSession(region)) {
			this.#callbacks.clearHoverRegion?.();
			return;
		}
		const currentHover = this.#deps.getHeaderFooterSession()?.hoverRegion;
		if (this.#isSameHeaderFooterRegion(currentHover, region)) return;
		this.#deps.getHeaderFooterSession()?.renderHover(region);
		this.#callbacks.renderHoverRegion?.(region);
	}
	#handleMarginClickEnd(event, pendingMarginClick) {
		if ((this.#deps?.getHeaderFooterSession()?.session?.mode ?? "body") !== "body" || this.#deps?.isViewLocked()) {
			this.#clearDragPointerState();
			return;
		}
		const editor = this.#deps?.getEditor();
		const doc$1 = editor?.state?.doc;
		if (!doc$1) {
			this.#clearDragPointerState();
			return;
		}
		const epochMapper = this.#deps?.getEpochMapper();
		if (!epochMapper) {
			this.#clearDragPointerState();
			return;
		}
		if (pendingMarginClick.kind === "aboveFirstLine") {
			const pos = this.#getFirstTextPosition();
			try {
				const tr = editor.state.tr.setSelection(TextSelection.create(doc$1, pos));
				editor.view?.dispatch(tr);
				this.#callbacks.scheduleSelectionUpdate?.();
			} catch {}
			this.#debugLastHit = {
				source: "margin",
				pos: null,
				layoutEpoch: null,
				mappedPos: pos
			};
			this.#callbacks.updateSelectionDebugHud?.();
			this.#clearDragPointerState();
			return;
		}
		if (pendingMarginClick.kind === "right") {
			const mappedEnd$1 = epochMapper.mapPosFromLayoutToCurrentDetailed(pendingMarginClick.pmEnd, pendingMarginClick.layoutEpoch, 1);
			if (!mappedEnd$1.ok) {
				this.#callbacks.setPendingDocChange?.();
				this.#callbacks.scheduleRerender?.();
				this.#clearDragPointerState();
				return;
			}
			const caretPos = Math.max(0, Math.min(mappedEnd$1.pos, doc$1.content.size));
			try {
				const tr = editor.state.tr.setSelection(TextSelection.create(doc$1, caretPos));
				editor.view?.dispatch(tr);
				this.#callbacks.scheduleSelectionUpdate?.();
			} catch {}
			this.#debugLastHit = {
				source: "margin",
				pos: pendingMarginClick.pmEnd,
				layoutEpoch: pendingMarginClick.layoutEpoch,
				mappedPos: caretPos
			};
			this.#callbacks.updateSelectionDebugHud?.();
			this.#clearDragPointerState();
			return;
		}
		const mappedStart = epochMapper.mapPosFromLayoutToCurrentDetailed(pendingMarginClick.pmStart, pendingMarginClick.layoutEpoch, 1);
		const mappedEnd = epochMapper.mapPosFromLayoutToCurrentDetailed(pendingMarginClick.pmEnd, pendingMarginClick.layoutEpoch, -1);
		if (!mappedStart.ok || !mappedEnd.ok) {
			this.#callbacks.setPendingDocChange?.();
			this.#callbacks.scheduleRerender?.();
			this.#clearDragPointerState();
			return;
		}
		const selFrom = Math.max(0, Math.min(Math.min(mappedStart.pos, mappedEnd.pos), doc$1.content.size));
		const selTo = Math.max(0, Math.min(Math.max(mappedStart.pos, mappedEnd.pos), doc$1.content.size));
		try {
			const tr = editor.state.tr.setSelection(TextSelection.create(doc$1, selFrom, selTo));
			editor.view?.dispatch(tr);
			this.#callbacks.scheduleSelectionUpdate?.();
		} catch {}
		this.#debugLastHit = {
			source: "margin",
			pos: pendingMarginClick.pmStart,
			layoutEpoch: pendingMarginClick.layoutEpoch,
			mappedPos: selFrom
		};
		this.#callbacks.updateSelectionDebugHud?.();
		this.#clearDragPointerState();
	}
	#clearDragPointerState() {
		this.#dragLastPointer = null;
		this.#dragLastRawHit = null;
		this.#dragUsedPageNotMountedFallback = false;
		this.#dragStartClient = null;
		this.#dragThresholdExceeded = false;
		this.#lastPointerClient = null;
		this.#stopAutoScroll();
	}
	#focusHeaderFooterShortcut(kind) {
		const pageIndex = this.#callbacks.getCurrentPageIndex?.() ?? 0;
		const region = this.#callbacks.findRegionForPage?.(kind, pageIndex);
		if (!region) {
			this.#callbacks.emitHeaderFooterEditBlocked?.("missingRegion");
			return;
		}
		this.#callbacks.activateHeaderFooterRegion?.(region);
	}
	#getActiveRenderedNoteTarget() {
		const activeStorySession = this.#deps?.getActiveStorySession?.() ?? null;
		if (activeStorySession?.kind !== "note") return null;
		const locator = activeStorySession.locator;
		if (locator.storyType !== "footnote" && locator.storyType !== "endnote") return null;
		return {
			storyType: locator.storyType,
			noteId: locator.noteId
		};
	}
	#resolveRenderedNoteTargetAtPointer(target, clientX, clientY) {
		const parsedFromTarget = parseRenderedNoteTarget$1(target?.closest?.("[data-block-id]")?.getAttribute?.("data-block-id") ?? "");
		if (parsedFromTarget) return parsedFromTarget;
		const doc$1 = this.#deps?.getViewportHost()?.ownerDocument ?? document;
		if (typeof doc$1.elementsFromPoint !== "function") return null;
		for (const element of doc$1.elementsFromPoint(clientX, clientY)) {
			if (!(element instanceof HTMLElement)) continue;
			const parsed = parseRenderedNoteTarget$1(element.closest("[data-block-id]")?.getAttribute("data-block-id") ?? "");
			if (parsed) return parsed;
		}
		return null;
	}
	#focusEditorAtFirstPosition() {
		const editor = this.#deps?.getActiveEditor() ?? this.#deps?.getEditor();
		const editorDom = editor?.view?.dom;
		if (!editorDom) return;
		const validPos = this.#getFirstTextPosition();
		const doc$1 = editor?.state?.doc;
		if (doc$1) try {
			const tr = editor.state.tr.setSelection(TextSelection.create(doc$1, validPos));
			editor.view?.dispatch(tr);
		} catch {}
		editorDom.focus();
		this.#focusEditorView(editor?.view);
		this.#callbacks.scheduleSelectionUpdate?.();
	}
	#focusEditor() {
		const view = (this.#deps?.getActiveEditor() ?? this.#deps?.getEditor())?.view;
		const editorDom = view?.dom;
		if (!editorDom) return;
		const active = document.activeElement;
		if (active === editorDom || !!active && editorDom.contains?.(active)) {
			this.#focusEditorView(view);
			return;
		}
		if (active instanceof HTMLElement) active.blur();
		editorDom.focus();
		this.#focusEditorView(view);
	}
	#focusEditorView(view) {
		if (typeof view?.focus !== "function") return;
		try {
			view.focus();
		} catch {}
	}
	#handleRepeatClickOnActiveComment(event, target, editor) {
		const activeThreadId = getActiveCommentThreadId(editor);
		if (!shouldIgnoreRepeatClickOnActiveComment(target, event.clientX, event.clientY, activeThreadId)) return false;
		event.preventDefault();
		editor.emit?.("commentsUpdate", {
			type: comments_module_events.SELECTED,
			activeCommentId: activeThreadId
		});
		return true;
	}
	#syncNonBodyCommentActivation(event, target, editor) {
		this.#syncNonBodyCommentSelection(event, target, editor);
	}
	#resolveHeaderFooterCommentThreadIdFromGeometry(clientX, clientY) {
		const sessionMode = this.#deps?.getHeaderFooterSession()?.session?.mode ?? "body";
		if (sessionMode !== "header" && sessionMode !== "footer") return null;
		const viewportHost = this.#deps?.getViewportHost();
		if (!viewportHost) return null;
		const activeSurfaceSelector = sessionMode === "footer" ? ".superdoc-page-footer" : ".superdoc-page-header";
		const annotationSelector = [
			`${activeSurfaceSelector} ${COMMENT_HIGHLIGHT_SELECTOR}`,
			`${activeSurfaceSelector} ${TRACK_CHANGE_SELECTOR}`,
			`${activeSurfaceSelector} ${PM_TRACK_CHANGE_SELECTOR}`
		].join(", ");
		return resolveCommentThreadIdFromGeometry(Array.from(viewportHost.querySelectorAll(annotationSelector)), clientX, clientY);
	}
	#syncNonBodyCommentSelection(event, target, editor, { clearOnMiss = false } = {}) {
		const clickedThreadId = resolveCommentThreadIdNearPointer(target, event.clientX, event.clientY) ?? this.#resolveHeaderFooterCommentThreadIdFromGeometry(event.clientX, event.clientY);
		const activeThreadId = getActiveCommentThreadId(editor);
		if (!clickedThreadId) {
			if (!clearOnMiss || !activeThreadId) return;
			editor.emit?.("commentsUpdate", {
				type: comments_module_events.SELECTED,
				activeCommentId: null
			});
			return;
		}
		if (clickedThreadId === activeThreadId) return;
		editor.emit?.("commentsUpdate", {
			type: comments_module_events.SELECTED,
			activeCommentId: clickedThreadId
		});
	}
	#handleSingleCommentHighlightClick(event, target, editor) {
		if (isDirectSingleCommentHighlightHit(target) || isDirectTrackedChangeHit(target)) return false;
		const clickedThreadId = resolveCommentThreadIdNearPointer(target, event.clientX, event.clientY);
		if (!clickedThreadId) return false;
		if (clickedThreadId === getActiveCommentThreadId(editor)) return false;
		event.preventDefault();
		if (!editor.commands?.setCursorById?.(clickedThreadId, { activeCommentId: clickedThreadId })) editor.emit?.("commentsUpdate", {
			type: comments_module_events.SELECTED,
			activeCommentId: clickedThreadId
		});
		return true;
	}
};
var createDefaultScheduler = () => {
	if (typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") return {
		requestAnimationFrame: (cb) => window.requestAnimationFrame(cb),
		cancelAnimationFrame: (handle) => window.cancelAnimationFrame(handle)
	};
	const anyGlobal = globalThis;
	if (typeof anyGlobal.requestAnimationFrame === "function" && typeof anyGlobal.cancelAnimationFrame === "function") return {
		requestAnimationFrame: (cb) => anyGlobal.requestAnimationFrame(cb),
		cancelAnimationFrame: (handle) => anyGlobal.cancelAnimationFrame(handle)
	};
	return {
		requestAnimationFrame: (cb) => {
			return anyGlobal.setTimeout?.(() => cb(Date.now()), 0);
		},
		cancelAnimationFrame: (handle) => {
			anyGlobal.clearTimeout?.(handle);
		}
	};
};
var SelectionSyncCoordinator = class extends EventEmitter {
	#docEpoch = 0;
	#layoutEpoch = 0;
	#layoutUpdating = false;
	#pending = false;
	#scheduled = false;
	#rafHandle = null;
	#scheduler;
	constructor(options) {
		super();
		this.#scheduler = options?.scheduler ?? createDefaultScheduler();
	}
	getDocEpoch() {
		return this.#docEpoch;
	}
	getLayoutEpoch() {
		return this.#layoutEpoch;
	}
	isLayoutUpdating() {
		return this.#layoutUpdating;
	}
	setDocEpoch(epoch) {
		if (!Number.isFinite(epoch) || epoch < 0) return;
		if (epoch === this.#docEpoch) return;
		this.#docEpoch = epoch;
		this.#cancelScheduledRender();
		this.#maybeSchedule();
	}
	onLayoutStart() {
		if (this.#layoutUpdating) return;
		this.#layoutUpdating = true;
		this.#cancelScheduledRender();
	}
	onLayoutComplete(layoutEpoch) {
		this.#layoutUpdating = false;
		if (Number.isFinite(layoutEpoch) && layoutEpoch >= 0) this.#layoutEpoch = layoutEpoch;
		this.#maybeSchedule();
	}
	onLayoutAbort() {
		this.#layoutUpdating = false;
		this.#maybeSchedule();
	}
	requestRender(options) {
		this.#pending = true;
		if (options?.immediate) this.flushNow();
		this.#maybeSchedule();
	}
	flushNow() {
		if (!this.#pending) return;
		if (!this.#isSafeToRender()) return;
		this.#cancelScheduledRender();
		this.#pending = false;
		this.emit("render", {
			docEpoch: this.#docEpoch,
			layoutEpoch: this.#layoutEpoch
		});
	}
	destroy() {
		this.#cancelScheduledRender();
		this.removeAllListeners();
	}
	#isSafeToRender() {
		return !this.#layoutUpdating && this.#layoutEpoch >= this.#docEpoch;
	}
	#maybeSchedule() {
		if (!this.#pending) return;
		if (!this.#isSafeToRender()) return;
		if (this.#scheduled) return;
		this.#scheduled = true;
		this.#rafHandle = this.#scheduler.requestAnimationFrame(() => {
			this.#scheduled = false;
			this.#rafHandle = null;
			if (!this.#pending) return;
			if (!this.#isSafeToRender()) return;
			this.#pending = false;
			this.emit("render", {
				docEpoch: this.#docEpoch,
				layoutEpoch: this.#layoutEpoch
			});
		});
	}
	#cancelScheduledRender() {
		if (this.#rafHandle != null) try {
			this.#scheduler.cancelAnimationFrame(this.#rafHandle);
		} finally {
			this.#rafHandle = null;
		}
		this.#scheduled = false;
	}
};
var uiSurfaces = /* @__PURE__ */ new WeakSet();
function isInRegisteredSurface(event) {
	const path = typeof event.composedPath === "function" ? event.composedPath() : [];
	if (path.length > 0) {
		for (const node$1 of path) {
			if (uiSurfaces.has(node$1)) return true;
			if (node$1?.hasAttribute?.("data-editor-ui-surface")) return true;
		}
		return false;
	}
	let node = event.target;
	while (node) {
		if (uiSurfaces.has(node)) return true;
		if (node.hasAttribute?.("data-editor-ui-surface")) return true;
		node = node.parentElement;
	}
	return false;
}
const CONTEXT_MENU_HANDLED_FLAG = "__sdHandledByContextMenu";
var BRIDGE_FORWARDED_FLAG = Symbol("presentation-input-bridge-forwarded");
var PresentationInputBridge = class {
	#windowRoot;
	#layoutSurfaces;
	#getTargetDom;
	#getTargetEditor;
	#isEditable;
	#onTargetChanged;
	#listeners;
	#currentTarget = null;
	#destroyed = false;
	#useWindowFallback;
	constructor(windowRoot, layoutSurface, getTargetDom, isEditable, onTargetChanged, options) {
		this.#windowRoot = windowRoot;
		this.#layoutSurfaces = new Set([layoutSurface]);
		this.#getTargetDom = getTargetDom;
		this.#getTargetEditor = options?.getTargetEditor;
		this.#isEditable = isEditable;
		this.#onTargetChanged = onTargetChanged;
		this.#listeners = [];
		this.#useWindowFallback = options?.useWindowFallback ?? false;
	}
	bind() {
		if (this.#useWindowFallback) {
			this.#addListener("keydown", this.#captureStaleKeyboardEvent, this.#windowRoot, true);
			this.#addListener("beforeinput", this.#captureStaleTextEvent, this.#windowRoot, true);
			this.#addListener("input", this.#captureStaleTextEvent, this.#windowRoot, true);
			this.#addListener("compositionstart", this.#captureStaleCompositionEvent, this.#windowRoot, true);
			this.#addListener("compositionupdate", this.#captureStaleCompositionEvent, this.#windowRoot, true);
			this.#addListener("compositionend", this.#captureStaleCompositionEvent, this.#windowRoot, true);
		}
		this.#getListenerTargets().forEach((target) => {
			this.#addListener("keydown", this.#forwardKeyboardEvent, target);
			this.#addListener("keyup", this.#forwardKeyboardEvent, target);
		});
		this.#getListenerTargets().forEach((target) => {
			this.#addListener("compositionstart", this.#forwardCompositionEvent, target);
			this.#addListener("compositionupdate", this.#forwardCompositionEvent, target);
			this.#addListener("compositionend", this.#forwardCompositionEvent, target);
		});
		this.#getListenerTargets().forEach((target) => {
			this.#addListener("beforeinput", this.#forwardTextEvent, target);
			this.#addListener("input", this.#forwardTextEvent, target);
			this.#addListener("textInput", this.#forwardTextEvent, target);
		});
		this.#getListenerTargets().forEach((target) => {
			this.#addListener("contextmenu", this.#forwardContextMenu, target);
		});
	}
	destroy() {
		this.#listeners.forEach(({ type, handler, target, useCapture }) => {
			target.removeEventListener(type, handler, useCapture);
		});
		this.#listeners = [];
		this.#currentTarget = null;
		this.#destroyed = true;
	}
	notifyTargetChanged() {
		if (this.#destroyed) return;
		const nextTarget = this.#getTargetDom();
		if (nextTarget === this.#currentTarget) return;
		if (this.#currentTarget) {
			let synthetic = null;
			if (typeof CompositionEvent !== "undefined") synthetic = new CompositionEvent("compositionend", {
				data: "",
				bubbles: true,
				cancelable: true
			});
			else synthetic = new Event("compositionend", {
				bubbles: true,
				cancelable: true
			});
			try {
				this.#currentTarget.dispatchEvent(synthetic);
			} catch (error) {
				if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] Failed to dispatch composition event:", error);
			}
		}
		this.#currentTarget = nextTarget;
		this.#onTargetChanged?.(nextTarget ?? null);
	}
	#addListener(type, handler, target, useCapture = false) {
		const bound = handler.bind(this);
		this.#listeners.push({
			type,
			handler: bound,
			target,
			useCapture
		});
		target.addEventListener(type, bound, useCapture);
	}
	#dispatchToTarget(originalEvent, synthetic) {
		const target = this.#resolveDispatchTarget();
		if (!target) return;
		this.#dispatchToResolvedTarget(originalEvent, synthetic, target);
	}
	#dispatchToResolvedTarget(originalEvent, synthetic, target, options) {
		if (this.#destroyed) return;
		if (target.isConnected === false) return;
		if (options?.suppressOriginal) this.#suppressOriginalEvent(originalEvent);
		if (options?.focusTarget) this.#focusTargetDom(target, { force: options?.forceFocusTarget ?? false });
		this.#currentTarget = target;
		try {
			if (!target.dispatchEvent(synthetic) || synthetic.defaultPrevented) originalEvent.preventDefault();
		} catch (error) {
			if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] Failed to dispatch event to target:", error);
		}
	}
	#resolveDispatchTarget() {
		const target = this.#getTargetDom();
		this.#currentTarget = target;
		if (!target) return null;
		if (target.isConnected === false) return null;
		return target;
	}
	#focusTargetDom(target, options) {
		const forceFocusRestore = options?.force ?? false;
		const doc$1 = target.ownerDocument ?? document;
		const selection = doc$1.getSelection?.() ?? null;
		const selectionInsideTarget = !!selection?.anchorNode && target.contains(selection.anchorNode);
		if (!forceFocusRestore && selectionInsideTarget) return;
		const targetEditor = this.#getTargetEditor?.() ?? null;
		const targetEditorDom = targetEditor?.view?.dom ?? null;
		if (targetEditorDom === target && typeof targetEditor?.focus === "function") {
			targetEditor.focus();
			this.#syncEditorSelectionToDom(targetEditor);
			return;
		}
		const active = doc$1.activeElement;
		const activeIsTarget = active === target || !!active && target.contains(active);
		if (!forceFocusRestore && activeIsTarget) return;
		try {
			target.focus({ preventScroll: true });
		} catch {
			target.focus();
		}
		if (targetEditorDom === target) this.#syncEditorSelectionToDom(targetEditor);
	}
	#syncEditorSelectionToDom(editor) {
		const selection = editor?.state?.selection;
		const transaction = editor?.state?.tr;
		const dispatch = editor?.view?.dispatch;
		const setSelection = transaction?.setSelection;
		if (!selection || !transaction || typeof setSelection !== "function" || typeof dispatch !== "function") return;
		const selectionTransaction = setSelection.call(transaction, selection);
		selectionTransaction?.setMeta?.("addToHistory", false);
		dispatch(selectionTransaction);
	}
	#suppressOriginalEvent(event) {
		event.preventDefault();
		event.stopPropagation();
		if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
	}
	#resolveStaleEditorOrigin(event) {
		const activeTarget = this.#resolveDispatchTarget();
		if (!activeTarget) return null;
		if (this.#isEventOnActiveTarget(event)) return null;
		if (this.#isInLayoutSurface(event)) return null;
		if (isInRegisteredSurface(event)) return null;
		const originNode = event.target;
		const staleEditorTarget = (originNode instanceof HTMLElement ? originNode : originNode?.parentElement instanceof HTMLElement ? originNode.parentElement : null)?.closest?.(".ProseMirror[contenteditable=\"true\"]");
		if (!staleEditorTarget || staleEditorTarget === activeTarget) return null;
		return {
			activeTarget,
			staleEditorTarget
		};
	}
	#forwardKeyboardEvent(event) {
		if (this.#wasForwardedByBridge(event)) return;
		if (!this.#isEditable()) return;
		if (this.#shouldSkipSurface(event)) return;
		if (event.defaultPrevented) return;
		if (this.#isCompositionKeyboardEvent(event)) return;
		if (this.#isPlainCharacterKey(event)) return;
		this.#markForwardedByBridge(event);
		const synthetic = new KeyboardEvent(event.type, {
			key: event.key,
			code: event.code,
			location: event.location,
			repeat: event.repeat,
			ctrlKey: event.ctrlKey,
			shiftKey: event.shiftKey,
			altKey: event.altKey,
			metaKey: event.metaKey,
			bubbles: true,
			cancelable: true
		});
		this.#dispatchToTarget(event, synthetic);
	}
	#captureStaleKeyboardEvent(event) {
		if (!this.#isEditable()) return;
		if (event.defaultPrevented) return;
		const staleOrigin = this.#resolveStaleEditorOrigin(event);
		if (!staleOrigin) return;
		this.#focusTargetDom(staleOrigin.activeTarget);
		if (this.#isCompositionKeyboardEvent(event) || this.#isPlainCharacterKey(event)) return;
		const synthetic = new KeyboardEvent(event.type, {
			key: event.key,
			code: event.code,
			location: event.location,
			repeat: event.repeat,
			ctrlKey: event.ctrlKey,
			shiftKey: event.shiftKey,
			altKey: event.altKey,
			metaKey: event.metaKey,
			bubbles: true,
			cancelable: true
		});
		this.#dispatchToResolvedTarget(event, synthetic, staleOrigin.activeTarget, {
			focusTarget: true,
			forceFocusTarget: true,
			suppressOriginal: true
		});
	}
	#forwardTextEvent(event) {
		if (this.#wasForwardedByBridge(event)) return;
		if (!this.#isEditable()) return;
		if (this.#shouldSkipSurface(event)) return;
		if (event.defaultPrevented) return;
		this.#markForwardedByBridge(event);
		const dispatchSyntheticEvent = () => {
			if (event.defaultPrevented) return;
			let synthetic;
			if (typeof InputEvent !== "undefined") synthetic = new InputEvent(event.type, {
				data: event.data ?? event.data ?? null,
				inputType: event.inputType ?? "insertText",
				dataTransfer: event.dataTransfer ?? null,
				isComposing: event.isComposing ?? false,
				bubbles: true,
				cancelable: true
			});
			else synthetic = new Event(event.type, {
				bubbles: true,
				cancelable: true
			});
			this.#dispatchToTarget(event, synthetic);
		};
		if (event.isComposing) {
			dispatchSyntheticEvent();
			return;
		}
		queueMicrotask(dispatchSyntheticEvent);
	}
	#captureStaleTextEvent(event) {
		if (!this.#isEditable()) return;
		if (event.defaultPrevented) return;
		const staleOrigin = this.#resolveStaleEditorOrigin(event);
		if (!staleOrigin) return;
		let synthetic;
		if (typeof InputEvent !== "undefined") synthetic = new InputEvent(event.type, {
			data: event.data ?? event.data ?? null,
			inputType: event.inputType ?? "insertText",
			dataTransfer: event.dataTransfer ?? null,
			isComposing: event.isComposing ?? false,
			bubbles: true,
			cancelable: true
		});
		else synthetic = new Event(event.type, {
			bubbles: true,
			cancelable: true
		});
		this.#dispatchToResolvedTarget(event, synthetic, staleOrigin.activeTarget, {
			focusTarget: true,
			forceFocusTarget: true,
			suppressOriginal: true
		});
	}
	#forwardCompositionEvent(event) {
		if (this.#wasForwardedByBridge(event)) return;
		if (!this.#isEditable()) return;
		if (this.#shouldSkipSurface(event)) return;
		if (event.defaultPrevented) return;
		this.#markForwardedByBridge(event);
		let synthetic;
		if (typeof CompositionEvent !== "undefined") synthetic = new CompositionEvent(event.type, {
			data: event.data ?? "",
			bubbles: true,
			cancelable: true
		});
		else synthetic = new Event(event.type, {
			bubbles: true,
			cancelable: true
		});
		this.#dispatchToTarget(event, synthetic);
	}
	#captureStaleCompositionEvent(event) {
		if (!this.#isEditable()) return;
		if (event.defaultPrevented) return;
		const staleOrigin = this.#resolveStaleEditorOrigin(event);
		if (!staleOrigin) return;
		let synthetic;
		if (typeof CompositionEvent !== "undefined") synthetic = new CompositionEvent(event.type, {
			data: event.data ?? "",
			bubbles: true,
			cancelable: true
		});
		else synthetic = new Event(event.type, {
			bubbles: true,
			cancelable: true
		});
		this.#dispatchToResolvedTarget(event, synthetic, staleOrigin.activeTarget, {
			focusTarget: true,
			forceFocusTarget: true,
			suppressOriginal: true
		});
	}
	#forwardContextMenu(event) {
		if (Boolean(event["__sdHandledByContextMenu"])) return;
		if (this.#wasForwardedByBridge(event)) return;
		if (!this.#isEditable()) return;
		if (this.#shouldSkipSurface(event)) return;
		if (event.defaultPrevented) return;
		this.#markForwardedByBridge(event);
		const synthetic = new MouseEvent("contextmenu", {
			bubbles: true,
			cancelable: true,
			clientX: event.clientX,
			clientY: event.clientY,
			screenX: event.screenX,
			screenY: event.screenY,
			button: event.button,
			buttons: event.buttons,
			ctrlKey: event.ctrlKey,
			shiftKey: event.shiftKey,
			altKey: event.altKey,
			metaKey: event.metaKey
		});
		this.#dispatchToTarget(event, synthetic);
	}
	#isEventOnActiveTarget(event) {
		const targetDom = this.#getTargetDom();
		if (!targetDom) return false;
		const origin = event.target;
		if (!origin) return false;
		const targetNode = targetDom;
		const containsFn = typeof targetNode.contains === "function" ? targetNode.contains : null;
		if (targetNode === origin) return true;
		if (containsFn) return containsFn.call(targetNode, origin);
		return false;
	}
	#shouldSkipSurface(event) {
		if (this.#isEventOnActiveTarget(event)) return true;
		if (!this.#isInLayoutSurface(event)) return true;
		if (isInRegisteredSurface(event)) return true;
		return false;
	}
	#isInLayoutSurface(event) {
		const path = typeof event.composedPath === "function" ? event.composedPath() : [];
		if (path.length) return path.some((node) => this.#layoutSurfaces.has(node));
		const origin = event.target;
		return origin ? this.#layoutSurfaces.has(origin) : false;
	}
	#wasForwardedByBridge(event) {
		return Boolean(event[BRIDGE_FORWARDED_FLAG]);
	}
	#markForwardedByBridge(event) {
		event[BRIDGE_FORWARDED_FLAG] = true;
	}
	#getListenerTargets() {
		const targets = new Set(this.#layoutSurfaces);
		if (this.#useWindowFallback) targets.add(this.#windowRoot);
		return Array.from(targets);
	}
	#isPlainCharacterKey(event) {
		return event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey;
	}
	#isCompositionKeyboardEvent(event) {
		return event.isComposing || event.keyCode === 229 || event.key === "Dead" || event.key === "Compose";
	}
};
function getAtomNodeTypes(schema) {
	if (!schema) return [];
	const types = [];
	try {
		for (const name in schema.nodes) {
			if (name === "text") continue;
			const nodeType = schema.nodes[name];
			if (nodeType && (nodeType.isAtom || nodeType.isLeaf)) types.push(name);
		}
	} catch {
		return [];
	}
	return types;
}
var isObject = (value) => typeof value === "object" && value !== null;
function buildPositionMapFromPmDoc(pmDoc, jsonDoc) {
	if (!pmDoc || !isObject(jsonDoc)) return null;
	const map$1 = /* @__PURE__ */ new WeakMap();
	const walk = (pmNode, jsonNode, pos, isDoc) => {
		const jsonType = jsonNode.type;
		const expectedType = pmNode.isText ? "text" : pmNode.type?.name;
		if (!expectedType || jsonType !== expectedType) return false;
		const end$1 = pos + (isDoc ? pmNode.content.size : pmNode.nodeSize);
		map$1.set(jsonNode, {
			start: pos,
			end: end$1
		});
		if (pmNode.isLeaf) return true;
		const jsonContent = Array.isArray(jsonNode.content) ? jsonNode.content : [];
		if (pmNode.childCount !== jsonContent.length) return false;
		const base = pos + (isDoc ? 0 : 1);
		let ok = true;
		pmNode.forEach((child, offset$1, index) => {
			const jsonChild = jsonContent[index];
			if (!isObject(jsonChild)) {
				ok = false;
				return;
			}
			if (!walk(child, jsonChild, base + offset$1, false)) ok = false;
		});
		return ok;
	};
	if (!walk(pmDoc, jsonDoc, 0, true)) return null;
	return map$1;
}
function syncHiddenEditorA11yAttributes(pmDom, documentMode) {
	const element = pmDom;
	if (!(element instanceof HTMLElement)) return;
	if (!element.hasAttribute("tabindex")) element.tabIndex = 0;
	if (!element.hasAttribute("role")) element.setAttribute("role", "textbox");
	if (!element.hasAttribute("aria-multiline")) element.setAttribute("aria-multiline", "true");
	if (!element.hasAttribute("aria-label")) element.setAttribute("aria-label", "Document content area");
	element.setAttribute("aria-readonly", documentMode === "viewing" ? "true" : "false");
}
function scheduleA11ySelectionAnnouncement(deps, options) {
	if (!deps.ariaLiveRegion) return deps.currentTimeout;
	if (deps.sessionMode !== "body") return deps.currentTimeout;
	if (deps.isDragging && !options?.immediate) return deps.currentTimeout;
	if (deps.currentTimeout != null) clearTimeout(deps.currentTimeout);
	const win = deps.visibleHost?.ownerDocument?.defaultView ?? window;
	const delayMs = Boolean(options?.immediate) ? 0 : 150;
	return win.setTimeout(() => {
		deps.announceNow();
	}, delayMs);
}
function computeA11ySelectionAnnouncement(editorState) {
	const selection = editorState?.selection;
	if (!selection) return null;
	const fromRaw = selection.from;
	const toRaw$1 = selection.to;
	if (typeof fromRaw !== "number" || typeof toRaw$1 !== "number") return null;
	const from$1 = fromRaw;
	const to = toRaw$1;
	let message;
	if (selection instanceof CellSelection) message = "Table cells selected.";
	else if (from$1 === to) message = "Cursor moved.";
	else {
		const start$1 = Math.max(0, Math.min(from$1, to));
		const end$1 = Math.max(0, Math.max(from$1, to));
		const doc$1 = editorState?.doc;
		let snippet = "";
		if (doc$1 && typeof doc$1.textBetween === "function") try {
			const sampleEnd = Math.min(end$1, start$1 + 256);
			snippet = doc$1.textBetween(start$1, sampleEnd, " ", " ").replace(/\s+/g, " ").trim();
			if (sampleEnd < end$1 && snippet.length > 0) snippet = `${snippet}…`;
		} catch {}
		message = snippet.length > 0 ? `Selected: ${snippet}` : "Selection updated.";
	}
	const key = `${from$1}:${to}:${message}`;
	return {
		from: from$1,
		to,
		message,
		key
	};
}
function computeSelectionVirtualizationPins(options) {
	const pageCount = options.layout.pages.length;
	if (pageCount <= 0) return [];
	const pinned = /* @__PURE__ */ new Set();
	const add = (pageIndex) => {
		if (!Number.isFinite(pageIndex)) return;
		const idx = Math.floor(pageIndex);
		if (idx < 0 || idx >= pageCount) return;
		pinned.add(idx);
		if (!options.includeDragBuffer) return;
		if (idx - 1 >= 0) pinned.add(idx - 1);
		if (idx + 1 < pageCount) pinned.add(idx + 1);
	};
	if (options.isDragging && options.dragAnchorPageIndex != null && options.dragLastHitPageIndex != null) {
		add(options.dragAnchorPageIndex);
		add(options.dragLastHitPageIndex);
	} else if (options.selection) {
		const anchorPos = options.selection.anchor ?? options.selection.from;
		const headPos = options.selection.head ?? options.selection.to;
		const anchorFrag = getFragmentAtPosition(options.layout, options.blocks, options.measures, anchorPos);
		const headFrag = getFragmentAtPosition(options.layout, options.blocks, options.measures, headPos);
		if (anchorFrag) add(anchorFrag.pageIndex);
		if (headFrag) add(headFrag.pageIndex);
		if (options.docSize != null) {
			if (!anchorFrag && anchorPos <= 1) add(0);
			if (!headFrag && headPos >= options.docSize) add(pageCount - 1);
		}
	}
	for (const extra of options.extraPages ?? []) add(extra);
	return Array.from(pinned).sort((a, b$1) => a - b$1);
}
function renderCellSelectionOverlay({ selection, layout, localSelectionLayer, blocks, measures, cellAnchorTableBlockId, convertPageLocalToOverlayCoords: convertPageLocalToOverlayCoords$1 }) {
	if (!selection || !layout || !layout.pages) {
		console.warn("[renderCellSelectionOverlay] Invalid input parameters");
		return;
	}
	const $anchorCell = selection.$anchorCell;
	if (!$anchorCell) {
		console.warn("[renderCellSelectionOverlay] No anchor cell in selection");
		return;
	}
	let tableDepth = $anchorCell.depth;
	while (tableDepth > 0 && $anchorCell.node(tableDepth).type.name !== "table") tableDepth--;
	if (tableDepth === 0 && $anchorCell.node(0).type.name !== "table") {
		console.warn("[renderCellSelectionOverlay] Could not find table node in selection hierarchy");
		return;
	}
	const tableNode = $anchorCell.node(tableDepth);
	const tableStart = $anchorCell.start(tableDepth) - 1;
	let tableBlock;
	if (cellAnchorTableBlockId) tableBlock = blocks.find((block) => block.kind === "table" && block.id === cellAnchorTableBlockId);
	if (!tableBlock) tableBlock = getTopLevelTableBlockAtPos($anchorCell.node(0), blocks, tableStart) ?? void 0;
	if (!tableBlock) return;
	const tableFragments = [];
	layout.pages.forEach((page, pageIndex) => {
		page.fragments.forEach((fragment) => {
			if (fragment.kind === "table" && fragment.blockId === tableBlock.id) tableFragments.push({
				fragment,
				pageIndex
			});
		});
	});
	if (tableFragments.length === 0) return;
	let tableMap;
	try {
		tableMap = TableMap.get(tableNode);
	} catch (error) {
		console.error("[renderCellSelectionOverlay] TableMap.get failed:", error);
		return;
	}
	const selectedCells = [];
	selection.forEachCell((cellNode, cellPos) => {
		const cellOffset = cellPos - tableStart - 1;
		const mapIndex = tableMap.map.indexOf(cellOffset);
		if (mapIndex === -1) return;
		const row = Math.floor(mapIndex / tableMap.width);
		const col = mapIndex % tableMap.width;
		const rawColspan = cellNode.attrs?.colspan;
		const rawRowspan = cellNode.attrs?.rowspan;
		const colspan = typeof rawColspan === "number" && Number.isFinite(rawColspan) && rawColspan > 0 ? rawColspan : 1;
		const rowspan = typeof rawRowspan === "number" && Number.isFinite(rawRowspan) && rawRowspan > 0 ? rawRowspan : 1;
		selectedCells.push({
			row,
			col,
			colspan,
			rowspan
		});
	});
	const tableBlockIndex = blocks.indexOf(tableBlock);
	const measureAtIndex = tableBlockIndex !== -1 ? measures[tableBlockIndex] : void 0;
	const tableMeasure = measureAtIndex?.kind === "table" ? measureAtIndex : void 0;
	const rowPositions = [];
	if (tableMeasure?.rows) {
		let currentY = 0;
		for (const rowMeasure of tableMeasure.rows) {
			rowPositions.push({
				y: currentY,
				height: rowMeasure.height
			});
			currentY += rowMeasure.height;
		}
	}
	for (const { fragment, pageIndex } of tableFragments) {
		const { columnBoundaries } = fragment.metadata ?? {};
		if (!columnBoundaries) continue;
		for (const { row, col, colspan, rowspan } of selectedCells) {
			if (row < fragment.fromRow || row >= fragment.toRow) continue;
			const colBoundary = columnBoundaries.find((cb) => cb.index === col);
			if (!colBoundary) continue;
			let cellWidth = colBoundary.width;
			if (colspan > 1) for (let c = 1; c < colspan; c++) {
				const nextColBoundary = columnBoundaries.find((cb) => cb.index === col + c);
				if (nextColBoundary) cellWidth += nextColBoundary.width;
			}
			let rowY;
			let rowHeight;
			if (row >= 0 && row < rowPositions.length && rowPositions[row]) {
				const fragmentStartY = fragment.fromRow > 0 && fragment.fromRow < rowPositions.length && rowPositions[fragment.fromRow] ? rowPositions[fragment.fromRow].y : 0;
				rowY = rowPositions[row].y - fragmentStartY;
				rowHeight = rowPositions[row].height;
				if (rowspan > 1) for (let r$1 = 1; r$1 < rowspan && row + r$1 < rowPositions.length && rowPositions[row + r$1]; r$1++) rowHeight += rowPositions[row + r$1].height;
			} else {
				const rowCount = fragment.toRow - fragment.fromRow;
				const estimatedRowHeight = rowCount > 0 ? fragment.height / rowCount : 20;
				rowY = (row - fragment.fromRow) * estimatedRowHeight;
				rowHeight = estimatedRowHeight * rowspan;
			}
			const coords = convertPageLocalToOverlayCoords$1(pageIndex, fragment.x + colBoundary.x, fragment.y + rowY);
			if (!coords) continue;
			const highlight = localSelectionLayer.ownerDocument?.createElement("div");
			if (!highlight) continue;
			highlight.className = "presentation-editor__cell-selection-rect";
			highlight.style.position = "absolute";
			highlight.style.left = `${coords.x}px`;
			highlight.style.top = `${coords.y}px`;
			highlight.style.width = `${Math.max(1, cellWidth)}px`;
			highlight.style.height = `${Math.max(1, rowHeight)}px`;
			highlight.style.backgroundColor = "rgba(51, 132, 255, 0.35)";
			highlight.style.pointerEvents = "none";
			localSelectionLayer.appendChild(highlight);
		}
	}
}
function renderSelectionRects({ localSelectionLayer, rects, pageHeight, pageGap, convertPageLocalToOverlayCoords: convertPageLocalToOverlayCoords$1 }) {
	rects.forEach((rect) => {
		const pageLocalY = rect.y - rect.pageIndex * (pageHeight + pageGap);
		const coords = convertPageLocalToOverlayCoords$1(rect.pageIndex, rect.x, pageLocalY);
		if (!coords) return;
		const highlight = localSelectionLayer.ownerDocument?.createElement("div");
		if (!highlight) return;
		highlight.className = "presentation-editor__selection-rect";
		highlight.style.position = "absolute";
		highlight.style.left = `${coords.x}px`;
		highlight.style.top = `${coords.y}px`;
		highlight.style.width = `${Math.max(1, rect.width)}px`;
		highlight.style.height = `${Math.max(1, rect.height)}px`;
		highlight.style.backgroundColor = "rgba(51, 132, 255, 0.35)";
		highlight.style.borderRadius = "2px";
		highlight.style.pointerEvents = "none";
		localSelectionLayer.appendChild(highlight);
	});
}
function renderCaretOverlay({ localSelectionLayer, caretLayout, convertPageLocalToOverlayCoords: convertPageLocalToOverlayCoords$1 }) {
	const coords = convertPageLocalToOverlayCoords$1(caretLayout.pageIndex, caretLayout.x, caretLayout.y);
	if (!coords) return;
	const finalHeight = Math.max(1, caretLayout.height);
	const caretEl = localSelectionLayer.ownerDocument?.createElement("div");
	if (!caretEl) return;
	caretEl.className = "presentation-editor__selection-caret";
	caretEl.style.position = "absolute";
	caretEl.style.left = `${coords.x}px`;
	caretEl.style.top = `${coords.y}px`;
	caretEl.style.width = "2px";
	caretEl.style.height = `${finalHeight}px`;
	caretEl.style.backgroundColor = "#000000";
	caretEl.style.borderRadius = "1px";
	caretEl.style.boxShadow = "0 0 0 1px rgba(255, 255, 255, 0.92)";
	caretEl.style.pointerEvents = "none";
	localSelectionLayer.appendChild(caretEl);
}
function computeTableCaretLayoutRectFromDom({ viewportHost, visibleHost, zoom }, pos, _fragment, _tableBlock, _tableMeasure, pageIndex) {
	const lineEls = Array.from(viewportHost.querySelectorAll(".superdoc-line"));
	if (lineEls.length === 0) return null;
	for (const lineEl of lineEls) {
		const pmStart = Number(lineEl.dataset.pmStart ?? "NaN");
		const pmEnd = Number(lineEl.dataset.pmEnd ?? "NaN");
		if (!Number.isFinite(pmStart) || !Number.isFinite(pmEnd)) continue;
		if (pos < pmStart || pos > pmEnd) continue;
		const spanEls = Array.from(lineEl.querySelectorAll("span[data-pm-start]"));
		for (const spanEl of spanEls) {
			const spanStart = Number(spanEl.dataset.pmStart ?? "NaN");
			const spanEnd = Number(spanEl.dataset.pmEnd ?? "NaN");
			if (!Number.isFinite(spanStart) || !Number.isFinite(spanEnd)) continue;
			if (pos < spanStart || pos > spanEnd) continue;
			const textNode = spanEl.firstChild;
			if (!textNode || textNode.nodeType !== Node.TEXT_NODE) {
				const spanRect = spanEl.getBoundingClientRect();
				const viewportRect$2 = viewportHost.getBoundingClientRect();
				return {
					pageIndex,
					x: (spanRect.left - viewportRect$2.left + visibleHost.scrollLeft) / zoom,
					y: (spanRect.top - viewportRect$2.top + visibleHost.scrollTop) / zoom,
					height: spanRect.height / zoom
				};
			}
			const text = textNode.textContent ?? "";
			const charOffset = Math.max(0, Math.min(text.length, pos - spanStart));
			const range = document.createRange();
			range.setStart(textNode, charOffset);
			range.setEnd(textNode, charOffset);
			const rangeRect = range.getBoundingClientRect();
			const viewportRect$1 = viewportHost.getBoundingClientRect();
			const lineRect$1 = lineEl.getBoundingClientRect();
			return {
				pageIndex,
				x: (rangeRect.left - viewportRect$1.left + visibleHost.scrollLeft) / zoom,
				y: (lineRect$1.top - viewportRect$1.top + visibleHost.scrollTop) / zoom,
				height: lineRect$1.height / zoom
			};
		}
		const lineRect = lineEl.getBoundingClientRect();
		const viewportRect = viewportHost.getBoundingClientRect();
		return {
			pageIndex,
			x: (lineRect.left - viewportRect.left + visibleHost.scrollLeft) / zoom,
			y: (lineRect.top - viewportRect.top + visibleHost.scrollTop) / zoom,
			height: lineRect.height / zoom
		};
	}
	return null;
}
function findTextboxFragmentElement(viewportHost, blockId, pageIndex) {
	const pageEl = viewportHost.querySelector(`[data-page-index="${pageIndex}"]`) ?? viewportHost;
	return Array.from(pageEl.querySelectorAll("[data-block-id]")).find((el) => el.dataset.blockId === blockId) ?? null;
}
function computeTextboxCaretLayoutRectFromDom({ viewportHost, visibleHost, zoom }, pos, fragment, _block, pageIndex) {
	const fragmentEl = findTextboxFragmentElement(viewportHost, fragment.blockId, pageIndex);
	if (!fragmentEl) return null;
	const lineEls = Array.from(fragmentEl.querySelectorAll(".superdoc-line[data-pm-start][data-pm-end]"));
	if (lineEls.length === 0) return null;
	for (let lineIdx = 0; lineIdx < lineEls.length; lineIdx++) {
		const lineEl = lineEls[lineIdx];
		const pmStart = Number(lineEl.dataset.pmStart ?? "NaN");
		const pmEnd = Number(lineEl.dataset.pmEnd ?? "NaN");
		if (!Number.isFinite(pmStart) || !Number.isFinite(pmEnd)) continue;
		const isLastLine = lineIdx === lineEls.length - 1;
		if (pos < pmStart || (isLastLine ? pos > pmEnd : pos >= pmEnd)) continue;
		const spanEls = Array.from(lineEl.querySelectorAll("span[data-pm-start][data-pm-end]"));
		for (let spanIdx = 0; spanIdx < spanEls.length; spanIdx++) {
			const spanEl = spanEls[spanIdx];
			const spanStart = Number(spanEl.dataset.pmStart ?? "NaN");
			const spanEnd = Number(spanEl.dataset.pmEnd ?? "NaN");
			if (!Number.isFinite(spanStart) || !Number.isFinite(spanEnd)) continue;
			const isLastSpan = spanIdx === spanEls.length - 1;
			if (pos < spanStart || (isLastSpan ? pos > spanEnd : pos >= spanEnd)) continue;
			const textNode = spanEl.firstChild;
			if (!textNode || textNode.nodeType !== Node.TEXT_NODE) {
				const spanRect = spanEl.getBoundingClientRect();
				const viewportRect$2 = viewportHost.getBoundingClientRect();
				return {
					pageIndex,
					x: (spanRect.left - viewportRect$2.left + visibleHost.scrollLeft) / zoom,
					y: (spanRect.top - viewportRect$2.top + visibleHost.scrollTop) / zoom,
					height: spanRect.height / zoom
				};
			}
			const text = textNode.textContent ?? "";
			const charOffset = Math.max(0, Math.min(text.length, pos - spanStart));
			const range = document.createRange();
			range.setStart(textNode, charOffset);
			range.setEnd(textNode, charOffset);
			const rangeRect = range.getBoundingClientRect();
			const viewportRect$1 = viewportHost.getBoundingClientRect();
			const lineRect$1 = lineEl.getBoundingClientRect();
			return {
				pageIndex,
				x: (rangeRect.left - viewportRect$1.left + visibleHost.scrollLeft) / zoom,
				y: (lineRect$1.top - viewportRect$1.top + visibleHost.scrollTop) / zoom,
				height: lineRect$1.height / zoom
			};
		}
		const lineRect = lineEl.getBoundingClientRect();
		const viewportRect = viewportHost.getBoundingClientRect();
		return {
			pageIndex,
			x: (lineRect.left - viewportRect.left + visibleHost.scrollLeft) / zoom,
			y: (lineRect.top - viewportRect.top + visibleHost.scrollTop) / zoom,
			height: lineRect.height / zoom
		};
	}
	return null;
}
function findLineContainingPos(block, measure, fromLine, toLine, pos) {
	if (measure.kind !== "paragraph" || block.kind !== "paragraph") return null;
	for (let lineIndex = fromLine; lineIndex < toLine; lineIndex += 1) {
		const line = measure.lines[lineIndex];
		if (!line) continue;
		const range = computeLinePmRange(block, line);
		if (range.pmStart == null || range.pmEnd == null) continue;
		if (pos >= range.pmStart && pos <= range.pmEnd) return {
			line,
			index: lineIndex
		};
	}
	return null;
}
function lineHeightBeforeIndex(lines, fromLine, targetIndex) {
	let offset$1 = 0;
	for (let i = fromLine; i < targetIndex; i += 1) offset$1 += lines[i]?.lineHeight ?? 0;
	return offset$1;
}
function computeCaretLayoutRectGeometry({ layout, blocks, measures, painterHost, viewportHost, visibleHost, zoom }, pos, includeDomFallback = true) {
	if (!layout) return null;
	const originalPos = pos;
	let effectivePos = pos;
	let hit = getFragmentAtPosition(layout, blocks, measures, pos);
	if (!hit) {
		const fallbackCandidates = [
			pos - 1,
			pos + 1,
			pos - 2,
			pos + 2
		].filter((candidate) => candidate >= 0);
		for (const candidate of fallbackCandidates) {
			const fallbackHit = getFragmentAtPosition(layout, blocks, measures, candidate);
			if (fallbackHit) {
				hit = fallbackHit;
				effectivePos = candidate;
				break;
			}
		}
		if (!hit) return null;
	}
	const block = hit.block;
	const measure = hit.measure;
	if (hit.fragment.kind === "table" && block?.kind === "table" && measure?.kind === "table") return computeTableCaretLayoutRectFromDom({
		viewportHost,
		visibleHost,
		zoom
	}, effectivePos, hit.fragment, block, measure, hit.pageIndex);
	if (hit.fragment.kind === "drawing" && block?.kind === "drawing" && block.drawingKind === "textboxShape" && measure?.kind === "drawing") return computeTextboxCaretLayoutRectFromDom({
		viewportHost,
		visibleHost,
		zoom
	}, effectivePos, hit.fragment, block, hit.pageIndex);
	if (!block || block.kind !== "paragraph" || measure?.kind !== "paragraph") return null;
	if (hit.fragment.kind !== "para") return null;
	const fragment = hit.fragment;
	const lineInfo = findLineContainingPos(block, measure, fragment.fromLine, fragment.toLine, effectivePos);
	if (!lineInfo) return null;
	const { line, index } = lineInfo;
	const range = computeLinePmRange(block, line);
	if (range.pmStart == null || range.pmEnd == null) return null;
	const pmOffset = pmPosToCharOffset(block, line, effectivePos);
	const markerWidth = fragment.markerWidth ?? measure.marker?.markerWidth ?? 0;
	const markerTextWidth = fragment.markerTextWidth ?? measure.marker?.markerTextWidth ?? void 0;
	const isFirstLine = index === fragment.fromLine;
	const isListItemFlag = isListItem(markerWidth, block);
	const wordLayout = getWordLayoutConfig(block);
	const indent = extractParagraphIndent(block.attrs?.indent);
	const indentAdjust = calculateTextStartIndent({
		isFirstLine,
		isListItem: isListItemFlag,
		markerWidth,
		markerTextWidth,
		paraIndentLeft: indent.left,
		firstLineIndent: indent.firstLine,
		hangingIndent: indent.hanging,
		wordLayout
	});
	const availableWidth = Math.max(0, fragment.width - (indentAdjust + indent.right));
	const charX = measureCharacterX(block, line, pmOffset, availableWidth);
	const resolvedCharX = getParagraphInlineDirection(block.attrs) === "rtl" ? Math.max(0, availableWidth - charX) : charX;
	const localX = fragment.x + indentAdjust + resolvedCharX;
	const lineOffset = lineHeightBeforeIndex(measure.lines, fragment.fromLine, index);
	const localY = fragment.y + lineOffset;
	const result = {
		pageIndex: hit.pageIndex,
		x: localX,
		y: localY,
		height: line.lineHeight
	};
	const pageEl = getPageElementByIndex(painterHost ?? null, hit.pageIndex);
	const pageRect = pageEl?.getBoundingClientRect();
	if (includeDomFallback && pageRect) {
		const selection = pageEl?.ownerDocument?.getSelection();
		if (selection?.rangeCount && selection.isCollapsed) {
			const nativeRange = selection.getRangeAt(0);
			if (typeof nativeRange.getBoundingClientRect === "function") {
				const nativeRect = nativeRange.getBoundingClientRect();
				const inPageBounds = Number.isFinite(nativeRect.left) && Number.isFinite(nativeRect.top) && Number.isFinite(nativeRect.height) && nativeRect.height > 0 && nativeRect.left >= pageRect.left - 2 && nativeRect.left <= pageRect.right + 2 && nativeRect.top >= pageRect.top - 2 && nativeRect.top <= pageRect.bottom + 2;
				const nativeX = (nativeRect.left - pageRect.left) / zoom;
				const nativeY = (nativeRect.top - pageRect.top) / zoom;
				const withinGeometrySanity = Math.abs(nativeX - result.x) <= 80;
				if (inPageBounds && withinGeometrySanity) return {
					pageIndex: hit.pageIndex,
					x: nativeX,
					y: nativeY,
					height: line.lineHeight
				};
			}
		}
	}
	let domCaretX = null;
	let domCaretY = null;
	const spanCandidates = [];
	const pushUnique = (el) => {
		if (!spanCandidates.includes(el)) spanCandidates.push(el);
	};
	const collectSpans = (root) => {
		if (!root) return;
		const spans = root.querySelectorAll("span[data-pm-start][data-pm-end]");
		for (const span of Array.from(spans)) if (span instanceof HTMLElement) pushUnique(span);
	};
	const lineEls = pageEl?.querySelectorAll(".superdoc-line[data-pm-start][data-pm-end]");
	let localLineEl = null;
	for (const lineEl of Array.from(lineEls ?? [])) {
		if (!(lineEl instanceof HTMLElement)) continue;
		const lineStart = Number(lineEl.dataset.pmStart);
		const lineEnd = Number(lineEl.dataset.pmEnd);
		if (!Number.isFinite(lineStart) || !Number.isFinite(lineEnd)) continue;
		if (effectivePos >= lineStart && effectivePos <= lineEnd) {
			localLineEl = lineEl;
			break;
		}
	}
	collectSpans(localLineEl);
	if (spanCandidates.length === 0) {
		const MAX_PM_DISTANCE = 8;
		const pageSpans = pageEl?.querySelectorAll("span[data-pm-start][data-pm-end]");
		for (const span of Array.from(pageSpans ?? [])) {
			if (!(span instanceof HTMLElement)) continue;
			const pmStart = Number(span.dataset.pmStart);
			const pmEnd = Number(span.dataset.pmEnd);
			if (!Number.isFinite(pmStart) || !Number.isFinite(pmEnd)) continue;
			if (effectivePos >= pmStart && effectivePos <= pmEnd) {
				pushUnique(span);
				continue;
			}
			if (Math.abs(pmStart - effectivePos) <= MAX_PM_DISTANCE || Math.abs(pmEnd - effectivePos) <= MAX_PM_DISTANCE) pushUnique(span);
		}
	}
	const domProbePositions = Array.from(new Set([
		originalPos,
		effectivePos,
		originalPos - 1,
		originalPos + 1
	])).filter((candidate) => candidate >= 0);
	let resolved = false;
	for (const probePos of domProbePositions) {
		for (const spanEl of spanCandidates) {
			const pmStart = Number(spanEl.dataset.pmStart);
			const pmEnd = Number(spanEl.dataset.pmEnd);
			if (probePos >= pmStart && probePos <= pmEnd && spanEl.firstChild?.nodeType === Node.TEXT_NODE) {
				const textNode = spanEl.firstChild;
				const charIndex = Math.min(probePos - pmStart, textNode.length);
				const rangeObj = document.createRange();
				rangeObj.setStart(textNode, charIndex);
				rangeObj.setEnd(textNode, charIndex);
				if (typeof rangeObj.getBoundingClientRect !== "function") continue;
				const rangeRect = rangeObj.getBoundingClientRect();
				if (pageRect) {
					domCaretX = (rangeRect.left - pageRect.left) / zoom;
					domCaretY = (rangeRect.top - pageRect.top) / zoom;
					resolved = true;
					break;
				}
			}
		}
		if (resolved) break;
	}
	if (includeDomFallback && domCaretX != null && domCaretY != null) return {
		pageIndex: hit.pageIndex,
		x: domCaretX,
		y: domCaretY,
		height: line.lineHeight
	};
	return result;
}
const shouldUseNativeCaretFallback = (selection, pos) => {
	if (!selection) return false;
	if (!selection.empty) return false;
	return selection.head === pos;
};
function measureVisibleTextOffset(root, boundaryNode, boundaryOffset) {
	if (!root || !boundaryNode) return null;
	if (boundaryNode !== root && !root.contains(boundaryNode)) return null;
	const doc$1 = root.ownerDocument ?? document;
	const boundary = doc$1.createRange();
	try {
		boundary.setStart(boundaryNode, boundaryOffset);
		boundary.setEnd(boundaryNode, boundaryOffset);
	} catch {
		return null;
	}
	const walker = doc$1.createTreeWalker(root, NodeFilter.SHOW_TEXT);
	let total = 0;
	let currentNode = walker.nextNode();
	while (currentNode) {
		const textNode = currentNode;
		const textLength = textNode.textContent?.length ?? 0;
		if (textLength === 0) {
			currentNode = walker.nextNode();
			continue;
		}
		const textRange = doc$1.createRange();
		textRange.selectNodeContents(textNode);
		if (textRange.compareBoundaryPoints(Range.END_TO_END, boundary) <= 0) {
			total += textLength;
			currentNode = walker.nextNode();
			continue;
		}
		if (textNode === boundaryNode) return total + Math.max(0, Math.min(boundaryOffset, textLength));
		if (textRange.compareBoundaryPoints(Range.START_TO_START, boundary) >= 0) return total;
		return total;
	}
	return total;
}
function measureVisibleTextOffsetInContainers(containers, boundaryNode, boundaryOffset) {
	const root = containers[0];
	if (!root || !boundaryNode) return null;
	if (!containers.some((container) => boundaryNode === container || container.contains(boundaryNode))) return null;
	const doc$1 = root.ownerDocument ?? document;
	const boundary = doc$1.createRange();
	try {
		boundary.setStart(boundaryNode, boundaryOffset);
		boundary.setEnd(boundaryNode, boundaryOffset);
	} catch {
		return null;
	}
	const model = collectVisibleTextModel(containers);
	for (const segment of model.segments) {
		const textNode = segment.node;
		const textLength = textNode.textContent?.length ?? 0;
		if (textLength === 0) continue;
		const textRange = doc$1.createRange();
		textRange.selectNodeContents(textNode);
		if (textRange.compareBoundaryPoints(Range.END_TO_END, boundary) <= 0) continue;
		if (textNode === boundaryNode) return segment.startOffset + Math.max(0, Math.min(boundaryOffset, textLength));
		if (textRange.compareBoundaryPoints(Range.START_TO_START, boundary) >= 0) return segment.startOffset;
		return segment.startOffset;
	}
	return model.totalLength;
}
function computeCaretRectFromVisibleTextOffset(options, textOffset) {
	const model = collectVisibleTextModel(options.containers);
	if (!model.segments.length) return null;
	const point = resolveTextPoint(model, textOffset, "forward");
	if (!point) return null;
	const range = (point.node.ownerDocument ?? document).createRange();
	range.setStart(point.node, point.offset);
	range.setEnd(point.node, point.offset);
	const rangeRect = range.getBoundingClientRect();
	const lineRect = point.lineElement?.getBoundingClientRect() ?? rangeRect;
	const pageRect = point.pageElement.getBoundingClientRect();
	const pageIndex = Number(point.pageElement.dataset.pageIndex ?? "NaN");
	if (!Number.isFinite(pageIndex)) return null;
	const localX = (rangeRect.left - pageRect.left) / options.zoom;
	const localY = (lineRect.top - pageRect.top) / options.zoom;
	if (!Number.isFinite(localX) || !Number.isFinite(localY)) return null;
	return {
		pageIndex,
		x: localX,
		y: pageIndex * (options.pageHeight + options.pageGap) + localY,
		width: 1,
		height: Math.max(1, lineRect.height / options.zoom)
	};
}
function computeSelectionRectsFromVisibleTextOffsets(options, fromOffset, toOffset) {
	if (!Number.isFinite(fromOffset) || !Number.isFinite(toOffset)) return null;
	const startOffset = Math.min(fromOffset, toOffset);
	const endOffset = Math.max(fromOffset, toOffset);
	if (startOffset === endOffset) return [];
	const model = collectVisibleTextModel(options.containers);
	if (!model.segments.length) return null;
	const startPoint = resolveTextPoint(model, startOffset, "forward");
	const endPoint = resolveTextPoint(model, endOffset, "backward");
	if (!startPoint || !endPoint) return null;
	const range = (startPoint.node.ownerDocument ?? document).createRange();
	try {
		range.setStart(startPoint.node, startPoint.offset);
		range.setEnd(endPoint.node, endPoint.offset);
	} catch {
		return null;
	}
	const rawRects = Array.from(range.getClientRects());
	const pageElements = collectUniquePageElements(model.segments);
	const rects = deduplicateOverlappingRects(rawRects);
	const layoutRects = [];
	for (const rect of rects) {
		if (!Number.isFinite(rect.width) || !Number.isFinite(rect.height) || rect.width <= 0 || rect.height <= 0) continue;
		const pageElement = findPageElementForRect(rect, pageElements);
		if (!pageElement) continue;
		const pageRect = pageElement.getBoundingClientRect();
		const pageIndex = Number(pageElement.dataset.pageIndex ?? "NaN");
		if (!Number.isFinite(pageIndex)) continue;
		const localX = (rect.left - pageRect.left) / options.zoom;
		const localY = (rect.top - pageRect.top) / options.zoom;
		if (!Number.isFinite(localX) || !Number.isFinite(localY)) continue;
		layoutRects.push({
			pageIndex,
			x: localX,
			y: pageIndex * (options.pageHeight + options.pageGap) + localY,
			width: Math.max(1, rect.width / options.zoom),
			height: Math.max(1, rect.height / options.zoom)
		});
	}
	return layoutRects;
}
function collectVisibleTextModel(containers) {
	const lines = collectRenderedLineElements(containers);
	if (!lines.length) return {
		segments: [],
		totalLength: 0
	};
	const segments = [];
	let totalLength = 0;
	for (let lineIndex = 0; lineIndex < lines.length; lineIndex += 1) {
		const lineElement = lines[lineIndex];
		const leafElements = collectLeafPmElements(lineElement);
		let lineVisibleLength = 0;
		for (const leafElement of leafElements) {
			const pageElement = leafElement.closest(`.${DOM_CLASS_NAMES.PAGE}[data-page-index]`);
			if (!pageElement) continue;
			const walker = (leafElement.ownerDocument ?? document).createTreeWalker(leafElement, NodeFilter.SHOW_TEXT);
			let currentNode = walker.nextNode();
			while (currentNode) {
				const textNode = currentNode;
				const textLength = textNode.textContent?.length ?? 0;
				if (textLength > 0) {
					segments.push({
						node: textNode,
						startOffset: totalLength + lineVisibleLength,
						endOffset: totalLength + lineVisibleLength + textLength,
						pageElement,
						lineElement
					});
					lineVisibleLength += textLength;
				}
				currentNode = walker.nextNode();
			}
		}
		const lineTrailingGap = computeLineTrailingGap(lineElement, leafElements);
		const nextLineGap = computeGapToNextLine(lineElement, lines[lineIndex + 1] ?? null);
		totalLength += lineVisibleLength + lineTrailingGap + nextLineGap;
	}
	return {
		segments,
		totalLength
	};
}
function collectRenderedLineElements(containers) {
	const lines = [];
	for (const container of containers) lines.push(...Array.from(container.querySelectorAll(".superdoc-line[data-pm-start][data-pm-end]")));
	return lines;
}
function computeLineTrailingGap(lineElement, leafElements) {
	const linePmEnd = getPmEnd(lineElement);
	const lastLeafElement = leafElements[leafElements.length - 1];
	const lastLeafPmEnd = lastLeafElement ? getPmEnd(lastLeafElement) : null;
	if (linePmEnd == null || lastLeafPmEnd == null) return 0;
	return Math.max(0, linePmEnd - lastLeafPmEnd);
}
function computeGapToNextLine(currentLine, nextLine) {
	if (!nextLine) return 0;
	const currentLinePmEnd = getPmEnd(currentLine);
	const nextLinePmStart = getPmStart(nextLine);
	if (currentLinePmEnd == null || nextLinePmStart == null) return 0;
	return Math.max(0, nextLinePmStart - currentLinePmEnd);
}
function collectLeafPmElements(container) {
	const pmElements = [];
	if (container.matches("[data-pm-start][data-pm-end]")) pmElements.push(container);
	pmElements.push(...Array.from(container.querySelectorAll("[data-pm-start][data-pm-end]")));
	const pmElementSet = new WeakSet(pmElements);
	const nonLeaf = /* @__PURE__ */ new WeakSet();
	for (const element of pmElements) {
		if (element.classList.contains(DOM_CLASS_NAMES.INLINE_SDT_WRAPPER)) continue;
		let parent = element.parentElement;
		while (parent) {
			if (pmElementSet.has(parent)) nonLeaf.add(parent);
			if (parent === container) break;
			parent = parent.parentElement;
		}
	}
	return pmElements.filter((element) => !element.classList.contains(DOM_CLASS_NAMES.INLINE_SDT_WRAPPER) && !nonLeaf.has(element));
}
function resolveTextPoint(model, targetOffset, affinity) {
	const { segments, totalLength } = model;
	if (!segments.length || !Number.isFinite(targetOffset)) return null;
	if (targetOffset < 0 || targetOffset > totalLength) return null;
	let previousSegment = null;
	for (let index = 0; index < segments.length; index += 1) {
		const segment = segments[index];
		if (targetOffset < segment.startOffset) {
			if (affinity === "forward") return {
				node: segment.node,
				offset: 0,
				pageElement: segment.pageElement,
				lineElement: segment.lineElement
			};
			if (previousSegment) return {
				node: previousSegment.node,
				offset: previousSegment.node.textContent?.length ?? 0,
				pageElement: previousSegment.pageElement,
				lineElement: previousSegment.lineElement
			};
			return {
				node: segment.node,
				offset: 0,
				pageElement: segment.pageElement,
				lineElement: segment.lineElement
			};
		}
		if (targetOffset >= segment.startOffset && targetOffset < segment.endOffset) return {
			node: segment.node,
			offset: targetOffset - segment.startOffset,
			pageElement: segment.pageElement,
			lineElement: segment.lineElement
		};
		if (targetOffset !== segment.endOffset) {
			previousSegment = segment;
			continue;
		}
		if (affinity === "forward" && index + 1 < segments.length) {
			previousSegment = segment;
			continue;
		}
		return {
			node: segment.node,
			offset: segment.node.textContent?.length ?? 0,
			pageElement: segment.pageElement,
			lineElement: segment.lineElement
		};
	}
	const lastSegment = segments[segments.length - 1];
	if (!lastSegment) return null;
	return {
		node: lastSegment.node,
		offset: lastSegment.node.textContent?.length ?? 0,
		pageElement: lastSegment.pageElement,
		lineElement: lastSegment.lineElement
	};
}
function getPmStart(element) {
	return parsePmValue(element.dataset.pmStart);
}
function getPmEnd(element) {
	return parsePmValue(element.dataset.pmEnd);
}
function parsePmValue(value) {
	if (!value) return null;
	const parsedValue = Number(value);
	return Number.isFinite(parsedValue) ? parsedValue : null;
}
function collectUniquePageElements(segments) {
	const seen = /* @__PURE__ */ new Set();
	const pages = [];
	for (const segment of segments) {
		if (seen.has(segment.pageElement)) continue;
		seen.add(segment.pageElement);
		pages.push(segment.pageElement);
	}
	return pages;
}
function findPageElementForRect(rect, pageElements) {
	const centerX = rect.left + rect.width / 2;
	const centerY = rect.top + rect.height / 2;
	for (const pageElement of pageElements) {
		const pageRect = pageElement.getBoundingClientRect();
		if (centerX >= pageRect.left && centerX <= pageRect.right && centerY >= pageRect.top && centerY <= pageRect.bottom) return pageElement;
	}
	return null;
}
function collectCommentPositions(doc$1, options) {
	if (!doc$1) return {};
	const storyKey = options.storyKey ?? "body";
	const positions = {};
	doc$1.descendants((node, pos) => {
		const marks = node.marks || [];
		for (const mark of marks) {
			const descriptor = describeThreadMark(mark, options);
			if (!descriptor) continue;
			const canonicalKey = descriptor.kind === "trackedChange" ? makeTrackedChangeAnchorKey({
				storyKey,
				rawId: descriptor.rawId
			}) : makeCommentAnchorKey(descriptor.rawId);
			const storageKey = descriptor.kind === "trackedChange" ? canonicalKey : descriptor.rawId;
			const nodeEnd = pos + node.nodeSize;
			const existing = positions[storageKey];
			if (!existing) {
				positions[storageKey] = {
					threadId: descriptor.rawId,
					key: canonicalKey,
					storyKey,
					kind: descriptor.kind,
					start: pos,
					end: nodeEnd
				};
				continue;
			}
			existing.start = Math.min(existing.start, pos);
			existing.end = Math.max(existing.end, nodeEnd);
		}
	});
	return positions;
}
function describeThreadMark(mark, options) {
	if (mark.type.name === options.commentMarkName) {
		const commentId = mark.attrs.commentId ?? mark.attrs.importedId;
		if (!commentId) return void 0;
		return {
			rawId: commentId,
			kind: "comment"
		};
	}
	if (options.trackChangeMarkNames.includes(mark.type.name)) {
		const rawId = mark.attrs.id;
		if (!rawId) return void 0;
		return {
			rawId,
			kind: "trackedChange"
		};
	}
}
function getCurrentSectionPageStyles(layout, pageIndex, converterPageStyles) {
	const PPI$1 = 96;
	const page = layout?.pages?.[pageIndex];
	const defaultMargins = (converterPageStyles ?? {}).pageMargins ?? {
		left: 1,
		right: 1,
		top: 1,
		bottom: 1
	};
	const safeMargins = {
		left: typeof defaultMargins.left === "number" ? defaultMargins.left : 1,
		right: typeof defaultMargins.right === "number" ? defaultMargins.right : 1,
		top: typeof defaultMargins.top === "number" ? defaultMargins.top : 1,
		bottom: typeof defaultMargins.bottom === "number" ? defaultMargins.bottom : 1
	};
	if (!page) return {
		pageSize: {
			width: 8.5,
			height: 11
		},
		pageMargins: safeMargins,
		sectionIndex: 0,
		orientation: "portrait"
	};
	const pageOrientation = page.orientation === "landscape" || page.orientation === "portrait" ? page.orientation : "portrait";
	const standardPortrait = {
		w: 8.5 * PPI$1,
		h: 11 * PPI$1
	};
	const standardLandscape = {
		w: 11 * PPI$1,
		h: 8.5 * PPI$1
	};
	const orientationDefault = pageOrientation === "landscape" ? standardLandscape : standardPortrait;
	const pageWidthPx = page.size?.w ?? orientationDefault.w;
	const pageHeightPx = page.size?.h ?? orientationDefault.h;
	const marginLeftPx = page.margins?.left ?? safeMargins.left * PPI$1;
	const marginRightPx = page.margins?.right ?? safeMargins.right * PPI$1;
	const marginTopPx = page.margins?.top ?? safeMargins.top * PPI$1;
	const marginBottomPx = page.margins?.bottom ?? safeMargins.bottom * PPI$1;
	return {
		pageSize: {
			width: pageWidthPx / PPI$1,
			height: pageHeightPx / PPI$1
		},
		pageMargins: {
			left: marginLeftPx / PPI$1,
			right: marginRightPx / PPI$1,
			top: marginTopPx / PPI$1,
			bottom: marginBottomPx / PPI$1
		},
		sectionIndex: page.sectionIndex ?? 0,
		orientation: pageOrientation
	};
}
function computeAnchorMap(bookmarks, layout, blocks) {
	const anchorMap = /* @__PURE__ */ new Map();
	const blockPmRanges = /* @__PURE__ */ new Map();
	const computeBlockRange = (blockId) => {
		if (blockPmRanges.has(blockId)) {
			const cached = blockPmRanges.get(blockId);
			return {
				pmStart: cached.pmStart,
				pmEnd: cached.pmEnd
			};
		}
		const block = blocks.find((b$1) => b$1.id === blockId);
		if (!block || block.kind !== "paragraph") {
			blockPmRanges.set(blockId, {
				pmStart: null,
				pmEnd: null,
				hasFragmentPositions: false
			});
			return {
				pmStart: null,
				pmEnd: null
			};
		}
		let pmStart = null;
		let pmEnd = null;
		for (const run of block.runs) {
			if (run.pmStart != null) pmStart = pmStart == null ? run.pmStart : Math.min(pmStart, run.pmStart);
			if (run.pmEnd != null) pmEnd = pmEnd == null ? run.pmEnd : Math.max(pmEnd, run.pmEnd);
		}
		blockPmRanges.set(blockId, {
			pmStart,
			pmEnd,
			hasFragmentPositions: false
		});
		return {
			pmStart,
			pmEnd
		};
	};
	bookmarks.forEach((pmPosition, bookmarkName) => {
		for (const page of layout.pages) for (const fragment of page.fragments) {
			if (fragment.kind !== "para") continue;
			let fragStart = fragment.pmStart;
			let fragEnd = fragment.pmEnd;
			if (fragStart == null || fragEnd == null) {
				const range = computeBlockRange(fragment.blockId);
				if (range.pmStart != null && range.pmEnd != null) {
					fragStart = range.pmStart;
					fragEnd = range.pmEnd;
				}
			} else {
				const cached = blockPmRanges.get(fragment.blockId);
				blockPmRanges.set(fragment.blockId, {
					pmStart: cached?.pmStart ?? fragStart,
					pmEnd: cached?.pmEnd ?? fragEnd,
					hasFragmentPositions: true
				});
			}
			if (fragStart == null || fragEnd == null) continue;
			if (pmPosition >= fragStart && pmPosition < fragEnd) {
				anchorMap.set(bookmarkName, page.number);
				return;
			}
		}
	});
	return anchorMap;
}
async function goToAnchor({ anchor, layout, blocks, measures, bookmarks, resolveAnchorPosition, pageGeometryHelper, painterHost, scrollContainer, zoom, scrollPageIntoView, waitForPageMount, getActiveEditor, timeoutMs }) {
	if (!anchor) return false;
	if (!layout) return false;
	const normalized = anchor.startsWith("#") ? anchor.slice(1) : anchor;
	if (!normalized) return false;
	const pmPos = bookmarks.get(normalized) ?? resolveAnchorPosition?.(normalized) ?? null;
	if (pmPos == null) return false;
	let pageIndex = (selectionToRects(layout, blocks, measures, pmPos, pmPos + 1, pageGeometryHelper) ?? [])[0]?.pageIndex ?? null;
	let fragmentY = null;
	if (pageIndex == null) {
		let nextFragmentPage = null;
		let nextFragmentStart = null;
		let nextFragmentY = null;
		let prevFragmentPage = null;
		let prevFragmentEnd = null;
		let prevFragmentY = null;
		for (const page of layout.pages) {
			for (const fragment of page.fragments) {
				if (fragment.kind !== "para") continue;
				const fragStart = fragment.pmStart;
				const fragEnd = fragment.pmEnd;
				if (fragStart == null || fragEnd == null) continue;
				if (pmPos >= fragStart && pmPos < fragEnd) {
					pageIndex = page.number - 1;
					fragmentY = fragment.y;
					break;
				}
				if (fragStart > pmPos && (nextFragmentStart === null || fragStart < nextFragmentStart)) {
					nextFragmentPage = page.number - 1;
					nextFragmentStart = fragStart;
					nextFragmentY = fragment.y;
				}
				if (fragEnd <= pmPos && (prevFragmentEnd === null || fragEnd > prevFragmentEnd)) {
					prevFragmentPage = page.number - 1;
					prevFragmentEnd = fragEnd;
					prevFragmentY = fragment.y;
				}
			}
			if (pageIndex != null) break;
		}
		if (pageIndex == null) {
			const prevGap = prevFragmentEnd != null ? pmPos - prevFragmentEnd : Infinity;
			const nextGap = nextFragmentStart != null ? nextFragmentStart - pmPos : Infinity;
			if (prevFragmentPage != null && prevGap < nextGap) {
				pageIndex = prevFragmentPage;
				fragmentY = prevFragmentY;
			} else if (nextFragmentPage != null) {
				pageIndex = nextFragmentPage;
				fragmentY = nextFragmentY;
			}
		}
	}
	if (pageIndex == null) return false;
	scrollPageIntoView(pageIndex);
	await waitForPageMount(pageIndex, timeoutMs);
	const pageEl = getPageElementByIndex(painterHost, pageIndex);
	if (pageEl && fragmentY != null) {
		const scaledY = fragmentY * zoom;
		if (scrollContainer instanceof Element) {
			const pageRect = pageEl.getBoundingClientRect();
			const containerRect = scrollContainer.getBoundingClientRect();
			const targetY = pageRect.top - containerRect.top + scrollContainer.scrollTop + scaledY;
			scrollContainer.scrollTo({
				top: targetY,
				behavior: "instant"
			});
		} else {
			const targetY = pageEl.getBoundingClientRect().top + scrollContainer.scrollY + scaledY;
			scrollContainer.scrollTo({
				top: targetY,
				behavior: "instant"
			});
		}
	} else if (pageEl) pageEl.scrollIntoView({
		behavior: "instant",
		block: "start"
	});
	const activeEditor = getActiveEditor();
	if (activeEditor?.commands?.setTextSelection) activeEditor.commands.setTextSelection({
		from: pmPos,
		to: pmPos
	});
	else console.warn("[PresentationEditor] goToAnchor: Navigation succeeded but could not move caret (editor commands unavailable)");
	return true;
}
const INTERNAL_OBJECT_MIME_TYPE = "application/x-superdoc-internal-object";
function isFiniteNumber(value) {
	return typeof value === "number" && Number.isFinite(value);
}
function readString(value) {
	return typeof value === "string" && value.trim().length > 0 ? value.trim() : null;
}
function readNumber(value) {
	if (isFiniteNumber(value)) return value;
	if (typeof value === "string" && value.trim().length > 0) {
		const parsed = Number(value);
		return Number.isFinite(parsed) ? parsed : null;
	}
	return null;
}
function buildStructuredContentDragPayload(sourceElement) {
	const dataset = sourceElement.dataset;
	const sdtId = readString(dataset.sdtId);
	const sourceStart = readNumber(dataset.pmStart);
	const sourceEnd = readNumber(dataset.pmEnd);
	if (!sdtId || sourceStart == null || sourceEnd == null) return null;
	return {
		kind: "structuredContent",
		nodeType: dataset.nodeType === "structuredContentBlock" ? "structuredContentBlock" : "structuredContent",
		sdtId,
		label: readString(dataset.displayLabel) ?? sourceElement.textContent?.trim() ?? "Structured content",
		sourceStart,
		sourceEnd,
		lockMode: readString(dataset.lockMode) ?? "unlocked"
	};
}
function buildExistingImageDragPayload(sourceElement) {
	const dataset = sourceElement.dataset;
	const sourceStart = readNumber(dataset.pmStart);
	const sourceEnd = readNumber(dataset.pmEnd);
	if (sourceStart == null || sourceEnd == null) return null;
	return {
		kind: "existingImage",
		imageKind: dataset.imageKind === "block" ? "block" : "inline",
		nodeType: dataset.nodeType ?? "image",
		sourceStart,
		sourceEnd,
		blockId: readString(dataset.blockId) ?? readString(sourceElement.getAttribute("data-block-id")) ?? readString(sourceElement.getAttribute("data-sd-block-id")) ?? void 0,
		label: readString(dataset.displayLabel) ?? sourceElement.getAttribute("aria-label") ?? "Image"
	};
}
function buildInternalObjectDragPayload(sourceElement) {
	const sourceKind = sourceElement.dataset.dragSourceKind;
	if (sourceKind === "structuredContent") return buildStructuredContentDragPayload(sourceElement);
	if (sourceKind === "existingImage") return buildExistingImageDragPayload(sourceElement);
	return null;
}
function canInsertNodeAtPosition(doc$1, pos, node) {
	try {
		const resolvedPos = doc$1.resolve(pos);
		const { parent } = resolvedPos;
		const index = resolvedPos.index();
		if (typeof parent.canReplaceWith === "function") return parent.canReplaceWith(index, index, node.type);
		return Boolean(parent.type.contentMatch.matchType(node.type));
	} catch {
		return false;
	}
}
function resolveInsertionBoundary(doc$1, pos, node, canInsertAt, bias, avoidPos) {
	try {
		const resolvedPos = doc$1.resolve(pos);
		const candidates = [];
		for (let depth = resolvedPos.depth; depth > 0; depth--) candidates.push({
			pos: resolvedPos.before(depth),
			side: "before"
		}, {
			pos: resolvedPos.after(depth),
			side: "after"
		});
		candidates.sort((a, b$1) => {
			const distanceDelta = Math.abs(a.pos - pos) - Math.abs(b$1.pos - pos);
			if (distanceDelta !== 0) return distanceDelta;
			if (a.side === bias && b$1.side !== bias) return -1;
			if (b$1.side === bias && a.side !== bias) return 1;
			return 0;
		});
		let avoidedCandidate = null;
		for (const candidate of candidates) {
			const candidatePos = candidate.pos;
			if (candidatePos < 0 || candidatePos > doc$1.content.size) continue;
			if (candidatePos === pos) continue;
			if (!canInsertAt(doc$1, candidatePos, node)) continue;
			if (avoidPos != null && candidatePos === avoidPos) {
				avoidedCandidate = candidatePos;
				continue;
			}
			return candidatePos;
		}
		return avoidedCandidate;
	} catch {
		return null;
	}
}
function createInternalNodeMoveTransaction(state, request) {
	const { sourceStart, sourceEnd, targetPos, expectedNodeType, canInsertAt } = request;
	if (targetPos >= sourceStart && targetPos <= sourceEnd) return {
		ok: false,
		reason: "same-range"
	};
	const sourceNode = state.doc.nodeAt(sourceStart);
	if (!sourceNode || sourceEnd !== sourceStart + sourceNode.nodeSize) return {
		ok: false,
		reason: "invalid-source"
	};
	if (expectedNodeType && sourceNode.type.name !== expectedNodeType) return {
		ok: false,
		reason: "wrong-node-type"
	};
	const tr = state.tr;
	tr.delete(sourceStart, sourceEnd);
	const mappedTarget = tr.mapping.map(targetPos);
	const mappedSourceStart = tr.mapping.map(sourceStart);
	if (mappedTarget < 0 || mappedTarget > tr.doc.content.size) return {
		ok: false,
		reason: "invalid-target"
	};
	let insertTarget = mappedTarget;
	if (!canInsertAt(tr.doc, insertTarget, sourceNode)) {
		const boundaryTarget = resolveInsertionBoundary(tr.doc, insertTarget, sourceNode, canInsertAt, targetPos <= sourceStart ? "before" : "after", mappedSourceStart);
		if (boundaryTarget == null) return {
			ok: false,
			reason: "invalid-target"
		};
		insertTarget = boundaryTarget;
	}
	tr.insert(insertTarget, sourceNode);
	tr.setMeta("uiEvent", "drop");
	return {
		ok: true,
		transaction: tr,
		mappedTarget: insertTarget
	};
}
var INTERNAL_MIME_TYPE = "application/x-field-annotation";
const FIELD_ANNOTATION_DATA_TYPE = "fieldAnnotation";
function isValidFieldAnnotationAttributes(attrs) {
	if (!attrs || typeof attrs !== "object") return false;
	const a = attrs;
	return typeof a.fieldId === "string" && typeof a.fieldType === "string" && typeof a.displayLabel === "string" && typeof a.type === "string";
}
function parseIntSafe(value) {
	if (!value) return void 0;
	const parsed = parseInt(value, 10);
	return Number.isFinite(parsed) ? parsed : void 0;
}
function extractFieldAnnotationData(element) {
	const dataset = element.dataset;
	const attributes = {};
	for (const key in dataset) {
		const value = dataset[key];
		if (value !== void 0) attributes[key] = value;
	}
	return {
		fieldId: dataset.fieldId,
		fieldType: dataset.fieldType,
		variant: dataset.variant ?? dataset.type,
		displayLabel: dataset.displayLabel,
		pmStart: parseIntSafe(dataset.pmStart),
		pmEnd: parseIntSafe(dataset.pmEnd),
		attributes
	};
}
function hasFieldAnnotationData(event) {
	if (!event.dataTransfer) return false;
	const lowerTypes = Array.from(event.dataTransfer.types ?? []).map((type) => type.toLowerCase());
	if (lowerTypes.includes(INTERNAL_MIME_TYPE.toLowerCase()) || lowerTypes.includes("fieldAnnotation".toLowerCase())) return true;
	return Boolean(event.dataTransfer.getData(INTERNAL_MIME_TYPE) || event.dataTransfer.getData("fieldAnnotation"));
}
function isInternalDrag(event) {
	return event.dataTransfer?.types?.includes(INTERNAL_MIME_TYPE) ?? false;
}
function hasInternalObjectType(event) {
	if (!event.dataTransfer) return false;
	return Array.from(event.dataTransfer.types ?? []).map((type) => type.toLowerCase()).includes(INTERNAL_OBJECT_MIME_TYPE.toLowerCase());
}
function extractDragData(event) {
	if (!event.dataTransfer) return null;
	let jsonData = event.dataTransfer.getData(INTERNAL_MIME_TYPE);
	if (!jsonData) jsonData = event.dataTransfer.getData(FIELD_ANNOTATION_DATA_TYPE);
	if (!jsonData) return null;
	try {
		const parsed = JSON.parse(jsonData);
		return parsed.sourceField ?? parsed.attributes ?? parsed;
	} catch {
		return null;
	}
}
function resolveDragSourceElement(event) {
	return event.target?.closest?.("[data-drag-source-kind]");
}
function resolveInternalObjectSourceRange(doc$1, payload) {
	if (payload.kind === "structuredContent") {
		const resolved = payload.nodeType === "structuredContentBlock" ? findStructuredContentBlockById(doc$1, payload.sdtId) : findStructuredContentInlineById(doc$1, payload.sdtId);
		if (resolved) return {
			sourceStart: resolved.pos,
			sourceEnd: resolved.pos + resolved.node.nodeSize
		};
	}
	return {
		sourceStart: payload.sourceStart,
		sourceEnd: payload.sourceEnd
	};
}
function hasPossibleFiles(event) {
	return event.dataTransfer?.types?.includes("Files") ?? false;
}
var IMAGE_EXTENSIONS = new Set([
	".png",
	".jpg",
	".jpeg",
	".gif",
	".bmp",
	".webp",
	".svg",
	".ico",
	".tiff",
	".tif"
]);
function looksLikeImage(file) {
	if (file.type.startsWith("image/")) return true;
	if (file.type === "") {
		const dotIndex = file.name.lastIndexOf(".");
		if (dotIndex !== -1) return IMAGE_EXTENSIONS.has(file.name.slice(dotIndex).toLowerCase());
	}
	return false;
}
function getDroppedImageFiles(event) {
	const files = event.dataTransfer?.files;
	if (!files) return [];
	const images = [];
	for (let i = 0; i < files.length; i++) if (looksLikeImage(files[i])) images.push(files[i]);
	return images;
}
function getDropPayloadKind(event) {
	if (hasFieldAnnotationData(event)) return "fieldAnnotation";
	if (hasInternalObjectType(event)) return "internalObject";
	if (hasPossibleFiles(event)) return "imageFiles";
	return "none";
}
var DragDropManager = class {
	#deps = null;
	#dragOverRaf = null;
	#pendingDragOver = null;
	#activeInternalObjectPayload = null;
	#boundHandleDragStart = null;
	#boundHandleDragOver = null;
	#boundHandleDrop = null;
	#boundHandleDragEnd = null;
	#boundHandleDragLeave = null;
	#boundHandleWindowDragOver = null;
	#boundHandleWindowDrop = null;
	setDependencies(deps) {
		this.#deps = deps;
	}
	bind() {
		if (!this.#deps) return;
		const viewportHost = this.#deps.getViewportHost();
		const painterHost = this.#deps.getPainterHost();
		this.#boundHandleDragStart = this.#handleDragStart.bind(this);
		this.#boundHandleDragOver = this.#handleDragOver.bind(this);
		this.#boundHandleDrop = this.#handleDrop.bind(this);
		this.#boundHandleDragEnd = this.#handleDragEnd.bind(this);
		this.#boundHandleDragLeave = this.#handleDragLeave.bind(this);
		this.#boundHandleWindowDragOver = this.#handleWindowDragOver.bind(this);
		this.#boundHandleWindowDrop = this.#handleWindowDrop.bind(this);
		painterHost.addEventListener("dragstart", this.#boundHandleDragStart);
		painterHost.addEventListener("dragend", this.#boundHandleDragEnd);
		viewportHost.addEventListener("dragover", this.#boundHandleDragOver);
		viewportHost.addEventListener("drop", this.#boundHandleDrop);
		viewportHost.addEventListener("dragleave", this.#boundHandleDragLeave);
		window.addEventListener("dragover", this.#boundHandleWindowDragOver, false);
		window.addEventListener("drop", this.#boundHandleWindowDrop, false);
	}
	unbind() {
		if (!this.#deps) return;
		const viewportHost = this.#deps.getViewportHost();
		const painterHost = this.#deps.getPainterHost();
		if (this.#boundHandleDragStart) painterHost.removeEventListener("dragstart", this.#boundHandleDragStart);
		if (this.#boundHandleDragEnd) painterHost.removeEventListener("dragend", this.#boundHandleDragEnd);
		if (this.#boundHandleDragOver) viewportHost.removeEventListener("dragover", this.#boundHandleDragOver);
		if (this.#boundHandleDrop) viewportHost.removeEventListener("drop", this.#boundHandleDrop);
		if (this.#boundHandleDragLeave) viewportHost.removeEventListener("dragleave", this.#boundHandleDragLeave);
		if (this.#boundHandleWindowDragOver) window.removeEventListener("dragover", this.#boundHandleWindowDragOver, false);
		if (this.#boundHandleWindowDrop) window.removeEventListener("drop", this.#boundHandleWindowDrop, false);
		this.#boundHandleDragStart = null;
		this.#boundHandleDragOver = null;
		this.#boundHandleDrop = null;
		this.#boundHandleDragEnd = null;
		this.#boundHandleDragLeave = null;
		this.#boundHandleWindowDragOver = null;
		this.#boundHandleWindowDrop = null;
	}
	destroy() {
		this.#cancelPendingDragOverSelection();
		this.#activeInternalObjectPayload = null;
		this.#deps?.clearDragDropIndicator();
		this.unbind();
		this.#deps = null;
	}
	#handleDragStart(event) {
		const target = event.target;
		const sourceElement = resolveDragSourceElement(event);
		const fieldAnnotationElement = target?.closest?.(`[${DATASET_KEYS.DRAGGABLE}="true"]`);
		if (!target) {
			this.#activeInternalObjectPayload = null;
			return;
		}
		const internalObjectPayload = sourceElement ? buildInternalObjectDragPayload(sourceElement) : null;
		const isInternalObjectSource = internalObjectPayload !== null;
		const isFieldAnnotation = fieldAnnotationElement != null;
		this.#activeInternalObjectPayload = isInternalObjectSource ? internalObjectPayload : null;
		if (!isFieldAnnotation && !isInternalObjectSource) {
			this.#activeInternalObjectPayload = null;
			return;
		}
		if (event.dataTransfer) {
			if (isInternalObjectSource && internalObjectPayload) {
				const jsonData = JSON.stringify(internalObjectPayload);
				event.dataTransfer.setData(INTERNAL_OBJECT_MIME_TYPE, jsonData);
				event.dataTransfer.setData("text/plain", internalObjectPayload.label);
				event.dataTransfer.setDragImage(sourceElement ?? target, 0, 0);
			} else {
				const draggableTarget = fieldAnnotationElement ?? target;
				const data = extractFieldAnnotationData(draggableTarget);
				const jsonData = JSON.stringify({
					attributes: data.attributes,
					sourceField: data
				});
				event.dataTransfer.setData(INTERNAL_MIME_TYPE, jsonData);
				event.dataTransfer.setData(FIELD_ANNOTATION_DATA_TYPE, jsonData);
				event.dataTransfer.setData("text/plain", data.displayLabel ?? "Field Annotation");
				event.dataTransfer.setDragImage(draggableTarget, 0, 0);
			}
			event.dataTransfer.effectAllowed = "move";
		}
	}
	#handleDragOver(event) {
		if (!this.#deps) return;
		const kind = getDropPayloadKind(event);
		if (kind === "none") return;
		if (!this.#deps.getActiveEditor()?.isEditable) return;
		event.preventDefault();
		if (event.dataTransfer) if (kind === "fieldAnnotation") event.dataTransfer.dropEffect = isInternalDrag(event) ? "move" : "copy";
		else if (kind === "internalObject") event.dataTransfer.dropEffect = "move";
		else event.dataTransfer.dropEffect = "copy";
		this.#scheduleDragOverSelection(event.clientX, event.clientY);
	}
	#handleDrop(event) {
		if (!this.#deps) return;
		const kind = getDropPayloadKind(event);
		if (kind === "none") return;
		event.preventDefault();
		event.stopPropagation();
		this.#cancelPendingDragOverSelection();
		this.#deps.clearDragDropIndicator();
		const activeEditor = this.#deps.getActiveEditor();
		if (!activeEditor?.isEditable) return;
		if (kind === "imageFiles") {
			this.#handleImageDrop(event);
			return;
		}
		const { state, view } = activeEditor;
		if (!state || !view) return;
		const hit = this.#deps.hitTest(event.clientX, event.clientY);
		const fallbackPos = state.selection?.from ?? state.doc?.content.size ?? null;
		const dropPos = hit?.pos ?? fallbackPos;
		if (dropPos == null) return;
		if (kind === "internalObject") {
			try {
				this.#handleInternalObjectDrop(event, dropPos);
			} finally {
				this.#activeInternalObjectPayload = null;
			}
			return;
		}
		if (isInternalDrag(event)) {
			this.#handleInternalDrop(event, dropPos);
			return;
		}
		this.#handleExternalDrop(event, dropPos);
	}
	#handleDragEnd(_event) {
		this.#cancelPendingDragOverSelection();
		this.#activeInternalObjectPayload = null;
		this.#deps?.clearDragDropIndicator();
		this.#deps?.getPainterHost()?.classList.remove("drag-over");
	}
	#handleDragLeave(event) {
		const viewportHost = this.#deps?.getViewportHost();
		if (!viewportHost) return;
		const relatedTarget = event.relatedTarget;
		if (relatedTarget && viewportHost.contains(relatedTarget)) return;
		this.#cancelPendingDragOverSelection();
		this.#deps?.clearDragDropIndicator();
		this.#deps?.getPainterHost()?.classList.remove("drag-over");
	}
	#scheduleDragOverSelection(clientX, clientY) {
		if (!this.#deps) return;
		this.#pendingDragOver = {
			x: clientX,
			y: clientY
		};
		if (this.#dragOverRaf !== null) return;
		this.#dragOverRaf = (this.#deps.getViewportHost()?.ownerDocument?.defaultView ?? window).requestAnimationFrame(() => {
			this.#dragOverRaf = null;
			const pending = this.#pendingDragOver;
			this.#pendingDragOver = null;
			if (!pending || !this.#deps) return;
			this.#applyDragOverSelection(pending.x, pending.y);
		});
	}
	#cancelPendingDragOverSelection() {
		if (this.#dragOverRaf !== null) {
			(this.#deps?.getViewportHost()?.ownerDocument?.defaultView ?? window).cancelAnimationFrame(this.#dragOverRaf);
			this.#dragOverRaf = null;
		}
		this.#pendingDragOver = null;
	}
	#applyDragOverSelection(clientX, clientY) {
		if (!this.#deps) return;
		const activeEditor = this.#deps.getActiveEditor();
		if (!activeEditor?.isEditable) return;
		const hit = this.#deps.hitTest(clientX, clientY);
		const doc$1 = activeEditor.state?.doc;
		if (!hit || !doc$1) {
			this.#deps.clearDragDropIndicator();
			return;
		}
		const pos = Math.min(Math.max(hit.pos, 1), doc$1.content.size);
		this.#deps.showDragDropIndicator(pos);
	}
	async #handleImageDrop(event) {
		if (!this.#deps) return;
		const activeEditor = this.#deps.getActiveEditor();
		const { state, view } = activeEditor;
		if (!state || !view) return;
		const imageFiles = getDroppedImageFiles(event);
		if (imageFiles.length === 0) return;
		const dropPos = this.#resolveDropPosition(event.clientX, event.clientY);
		if (dropPos == null) return;
		this.#setSelectionAt(dropPos);
		for (const file of imageFiles) try {
			await this.#deps.insertImageFile({
				file,
				editor: activeEditor,
				view: activeEditor.view,
				editorOptions: activeEditor.options,
				getMaxContentSize: () => activeEditor.getMaxContentSize()
			});
		} catch {}
		this.#focusEditor();
		this.#deps.scheduleSelectionUpdate();
	}
	#resolveDropPosition(clientX, clientY) {
		if (!this.#deps) return null;
		const { state } = this.#deps.getActiveEditor();
		if (!state) return null;
		const hit = this.#deps.hitTest(clientX, clientY);
		if (hit?.pos != null) return hit.pos;
		if (state.selection?.from != null) return state.selection.from;
		return state.doc?.content.size ?? null;
	}
	#setSelectionAt(pos) {
		if (!this.#deps) return;
		const activeEditor = this.#deps.getActiveEditor();
		const doc$1 = activeEditor.state?.doc;
		if (!doc$1) return;
		const clampedPos = Math.min(Math.max(pos, 1), doc$1.content.size);
		try {
			const tr = activeEditor.state.tr.setSelection(TextSelection.create(doc$1, clampedPos)).setMeta("addToHistory", false);
			activeEditor.view?.dispatch(tr);
		} catch {}
	}
	#focusEditor() {
		if (!this.#deps) return;
		const activeEditor = this.#deps.getActiveEditor();
		const editorDom = activeEditor.view?.dom;
		if (editorDom) {
			editorDom.focus();
			activeEditor.view?.focus();
		}
	}
	#handleInternalDrop(event, targetPos) {
		if (!this.#deps) return;
		const { state, view } = this.#deps.getActiveEditor();
		if (!state || !view) return;
		const data = extractDragData(event);
		if (!data?.fieldId) return;
		const pmStart = data.pmStart;
		let sourceStart = null;
		let sourceEnd = null;
		let sourceNode = null;
		if (pmStart != null) {
			const nodeAt = state.doc.nodeAt(pmStart);
			if (nodeAt?.type?.name === "fieldAnnotation") {
				sourceStart = pmStart;
				sourceEnd = pmStart + nodeAt.nodeSize;
				sourceNode = nodeAt;
			}
		}
		if (sourceStart == null || sourceEnd == null || !sourceNode) state.doc.descendants((node, pos) => {
			if (node.type.name === "fieldAnnotation" && node.attrs.fieldId === data.fieldId) {
				sourceStart = pos;
				sourceEnd = pos + node.nodeSize;
				sourceNode = node;
				return false;
			}
			return true;
		});
		if (sourceStart === null || sourceEnd === null || !sourceNode) return;
		const result = createInternalNodeMoveTransaction({
			doc: state.doc,
			tr: state.tr
		}, {
			sourceStart,
			sourceEnd,
			targetPos,
			expectedNodeType: "fieldAnnotation",
			canInsertAt: () => true
		});
		if (!result.ok) return;
		view.dispatch(result.transaction);
	}
	#handleInternalObjectDrop(event, targetPos) {
		if (!this.#deps) return;
		const { state, view } = this.#deps.getActiveEditor();
		if (!state || !view) return;
		const payload = this.#activeInternalObjectPayload;
		if (!payload) return;
		if (payload.kind === "structuredContent" && payload.lockMode !== "unlocked") return;
		const { sourceStart, sourceEnd } = resolveInternalObjectSourceRange(state.doc, payload);
		const result = createInternalNodeMoveTransaction({
			doc: state.doc,
			tr: state.tr
		}, {
			sourceStart,
			sourceEnd,
			targetPos,
			expectedNodeType: payload.nodeType,
			canInsertAt: canInsertNodeAtPosition
		});
		if (!result.ok) return;
		view.dispatch(result.transaction);
		this.#focusEditor();
		this.#deps.scheduleSelectionUpdate();
	}
	#handleExternalDrop(event, pos) {
		if (!this.#deps) return;
		const activeEditor = this.#deps.getActiveEditor();
		const fieldAnnotationData = event.dataTransfer?.getData(FIELD_ANNOTATION_DATA_TYPE);
		if (!fieldAnnotationData) return;
		let parsedData = null;
		try {
			parsedData = JSON.parse(fieldAnnotationData);
		} catch {
			return;
		}
		const { attributes, sourceField } = parsedData ?? {};
		activeEditor.emit?.("fieldAnnotationDropped", {
			sourceField,
			editor: activeEditor,
			coordinates: this.#deps.hitTest(event.clientX, event.clientY),
			pos
		});
		if (attributes && isValidFieldAnnotationAttributes(attributes)) {
			activeEditor.commands?.addFieldAnnotation?.(pos, attributes, true);
			const posAfter = Math.min(pos + 1, activeEditor.state?.doc?.content.size ?? pos + 1);
			const tr = activeEditor.state?.tr.setSelection(TextSelection.create(activeEditor.state.doc, posAfter));
			if (tr) activeEditor.view?.dispatch(tr);
			this.#deps.scheduleSelectionUpdate();
		}
		this.#focusEditor();
	}
	#handleWindowDragOver(event) {
		const kind = getDropPayloadKind(event);
		if (kind === "none") return;
		const viewportHost = this.#deps?.getViewportHost();
		const target = event.target;
		if (viewportHost?.contains(target)) return;
		event.preventDefault();
		if (event.dataTransfer) if (kind === "fieldAnnotation") event.dataTransfer.dropEffect = isInternalDrag(event) ? "move" : "copy";
		else if (kind === "internalObject") event.dataTransfer.dropEffect = "move";
		else event.dataTransfer.dropEffect = "copy";
	}
	#handleWindowDrop(event) {
		if (getDropPayloadKind(event) === "none") return;
		const viewportHost = this.#deps?.getViewportHost();
		const target = event.target;
		if (viewportHost?.contains(target)) return;
		this.#handleDrop(event);
	}
};
new PluginKey("paginationPlugin");
const createHeaderFooterEditor = ({ editor, data, editorContainer, editorHost, headerFooterRefId, type, availableWidth, availableHeight, currentPageNumber, currentPageNumberText, currentPageDisplayNumber, currentPageChapterNumberText, currentPageChapterSeparator, totalPageCount, sectionPageCount }) => {
	if (!editor) throw new TypeError("editor parameter is required");
	if (!data) throw new TypeError("data parameter is required");
	if (!editorContainer) throw new TypeError("editorContainer parameter is required");
	if (!(editorContainer instanceof HTMLElement)) throw new TypeError("editorContainer must be an HTMLElement");
	if (editorHost !== void 0 && !(editorHost instanceof HTMLElement)) throw new TypeError("editorHost must be an HTMLElement or undefined");
	if (availableWidth !== void 0) {
		if (typeof availableWidth !== "number" || !Number.isFinite(availableWidth) || availableWidth <= 0) throw new RangeError("availableWidth must be a positive number");
	}
	if (availableHeight !== void 0) {
		if (typeof availableHeight !== "number" || !Number.isFinite(availableHeight) || availableHeight <= 0) throw new RangeError("availableHeight must be a positive number");
	}
	if (currentPageNumber !== void 0) {
		if (typeof currentPageNumber !== "number" || !Number.isInteger(currentPageNumber) || currentPageNumber < 1) throw new RangeError("currentPageNumber must be a positive integer");
	}
	if (totalPageCount !== void 0) {
		if (typeof totalPageCount !== "number" || !Number.isInteger(totalPageCount) || totalPageCount < 1) throw new RangeError("totalPageCount must be a positive integer");
	}
	if (sectionPageCount !== void 0) {
		if (typeof sectionPageCount !== "number" || !Number.isInteger(sectionPageCount) || sectionPageCount < 1) throw new RangeError("sectionPageCount must be a positive integer");
	}
	const { fontSizePt, typeface, fontFamilyCss } = editor.converter.getDocumentDefaultStyles();
	const fontSizeInPixles = fontSizePt * 1.3333;
	const lineHeight = fontSizeInPixles * 1.2;
	applyStyleIsolationClass(editorContainer);
	const isFooter = type === "footer";
	Object.assign(editorContainer.style, {
		padding: "0",
		margin: "0",
		border: "none",
		boxSizing: "border-box",
		position: "absolute",
		top: "0",
		left: "0",
		width: availableWidth ? `${availableWidth}px` : "100%",
		height: availableHeight ? `${availableHeight}px` : "auto",
		maxWidth: "none",
		fontFamily: fontFamilyCss || typeface,
		fontSize: `${fontSizeInPixles}px`,
		lineHeight: `${lineHeight}px`,
		overflow: isFooter ? "visible" : "hidden",
		pointerEvents: "auto",
		backgroundColor: "white"
	});
	if (editorHost) editorHost.appendChild(editorContainer);
	else {
		console.warn("[createHeaderFooterEditor] No editorHost provided, falling back to document.body");
		document.body.appendChild(editorContainer);
	}
	const headerFooterEditor = createStoryEditor(editor, data, {
		documentId: headerFooterRefId || "headerFooterRefId",
		isHeaderOrFooter: true,
		currentPageNumber,
		currentPageNumberText,
		currentPageDisplayNumber,
		currentPageChapterNumberText,
		currentPageChapterSeparator,
		totalPageCount,
		sectionPageCount,
		element: editorContainer,
		editorOptions: {
			headerFooterRefId,
			headerFooterType: type,
			onCreate: (evt) => setEditorToolbar(evt, editor),
			onBlur: (evt) => onHeaderFooterDataUpdate(evt, editor, headerFooterRefId, type)
		}
	});
	const pm = editorContainer.querySelector(".ProseMirror");
	if (pm) {
		pm.style.maxHeight = "100%";
		pm.style.minHeight = "100%";
		pm.style.outline = "none";
		pm.style.border = "none";
		pm.classList.add("sd-header-footer");
		pm.setAttribute("role", "textbox");
		pm.setAttribute("aria-multiline", true);
		pm.setAttribute("aria-label", `${type} content area. Double click to start typing.`);
	}
	return headerFooterEditor;
};
const onHeaderFooterDataUpdate = ({ editor, transaction }, mainEditor, headerFooterRefId, type) => {
	if (!type || !headerFooterRefId) return;
	if (isApplyingRemotePartChanges()) return;
	const updatedData = editor.getUpdatedJson();
	const editorsList = mainEditor.converter[`${type}Editors`];
	if (Array.isArray(editorsList)) editorsList.forEach((item) => {
		if (item.id === headerFooterRefId) {
			item.editor.setOptions({
				media: editor.options.media,
				mediaFiles: editor.options.mediaFiles
			});
			if (item.editor !== editor) item.editor.replaceContent(updatedData);
		}
		item.editor.setOptions({ lastSelection: transaction?.selection });
	});
	mainEditor.converter[`${type}s`][headerFooterRefId] = updatedData;
	mainEditor.setOptions({ isHeaderFooterChanged: editor.docChanged });
	if (editor.docChanged && mainEditor.converter) mainEditor.converter.headerFooterModified = true;
	exportSubEditorToPart(mainEditor, editor, headerFooterRefId, type);
};
var setEditorToolbar = ({ editor }, mainEditor) => {
	editor.setToolbar(mainEditor.toolbar);
};
var HEADER_FOOTER_VARIANTS = [
	"default",
	"first",
	"even",
	"odd"
];
var DEFAULT_HEADER_FOOTER_HEIGHT = 100;
var EDITOR_READY_TIMEOUT_MS = 5e3;
var MAX_CACHED_EDITORS_LIMIT = 100;
var HeaderFooterEditorManager = class extends EventEmitter {
	#editor;
	#descriptors = /* @__PURE__ */ new Map();
	#collections = null;
	#editorEntries = /* @__PURE__ */ new Map();
	#maxCachedEditors = 10;
	#editorAccessOrder = [];
	#pendingCreations = /* @__PURE__ */ new Map();
	#cacheHits = 0;
	#cacheMisses = 0;
	#evictions = 0;
	#pinnedIds = /* @__PURE__ */ new Set();
	constructor(editor) {
		super();
		this.#editor = editor;
		this.refresh();
	}
	#hasConverter(editor) {
		return "converter" in editor && editor.converter !== void 0 && editor.converter !== null;
	}
	refresh(options) {
		if (options?.purgeCachedEditors) this.#teardownEditors();
		this.#collections = this.#extractCollections();
		const nextDescriptors = this.#collectDescriptors(this.#collections);
		this.#teardownMissingEditors(nextDescriptors);
		this.#descriptors = nextDescriptors;
	}
	destroy() {
		this.#descriptors.clear();
		this.#collections = null;
		this.#teardownEditors();
		this.removeAllListeners();
	}
	async ensureEditor(descriptor, options) {
		if (!descriptor?.id) return null;
		if (options) {
			if (options.editorHost !== void 0 && !(options.editorHost instanceof HTMLElement)) {
				console.error("[HeaderFooterEditorManager] editorHost must be an HTMLElement");
				this.emit("error", {
					descriptor,
					error: /* @__PURE__ */ new TypeError("editorHost must be an HTMLElement")
				});
				return null;
			}
			if (options.availableWidth !== void 0) {
				if (typeof options.availableWidth !== "number" || !Number.isFinite(options.availableWidth) || options.availableWidth <= 0) {
					console.error("[HeaderFooterEditorManager] availableWidth must be a positive number");
					this.emit("error", {
						descriptor,
						error: /* @__PURE__ */ new TypeError("availableWidth must be a positive number")
					});
					return null;
				}
			}
			if (options.availableHeight !== void 0) {
				if (typeof options.availableHeight !== "number" || !Number.isFinite(options.availableHeight) || options.availableHeight <= 0) {
					console.error("[HeaderFooterEditorManager] availableHeight must be a positive number");
					this.emit("error", {
						descriptor,
						error: /* @__PURE__ */ new TypeError("availableHeight must be a positive number")
					});
					return null;
				}
			}
			if (options.currentPageNumber !== void 0) {
				if (typeof options.currentPageNumber !== "number" || !Number.isInteger(options.currentPageNumber) || options.currentPageNumber < 1) {
					console.error("[HeaderFooterEditorManager] currentPageNumber must be a positive integer");
					this.emit("error", {
						descriptor,
						error: /* @__PURE__ */ new TypeError("currentPageNumber must be a positive integer")
					});
					return null;
				}
			}
			if (options.totalPageCount !== void 0) {
				if (typeof options.totalPageCount !== "number" || !Number.isInteger(options.totalPageCount) || options.totalPageCount < 1) {
					console.error("[HeaderFooterEditorManager] totalPageCount must be a positive integer");
					this.emit("error", {
						descriptor,
						error: /* @__PURE__ */ new TypeError("totalPageCount must be a positive integer")
					});
					return null;
				}
			}
			if (options.sectionPageCount !== void 0) {
				if (typeof options.sectionPageCount !== "number" || !Number.isInteger(options.sectionPageCount) || options.sectionPageCount < 1) {
					console.error("[HeaderFooterEditorManager] sectionPageCount must be a positive integer");
					this.emit("error", {
						descriptor,
						error: /* @__PURE__ */ new TypeError("sectionPageCount must be a positive integer")
					});
					return null;
				}
			}
		}
		const existing = this.#editorEntries.get(descriptor.id);
		if (existing) {
			this.#cacheHits += 1;
			this.#updateAccessOrder(descriptor.id);
			await existing.ready.catch((error) => {
				console.error("[HeaderFooterEditorManager] Editor initialization failed:", error);
				this.emit("error", {
					descriptor,
					error
				});
			});
			this.#mountAndUpdateEntry(existing, options);
			return existing.editor;
		}
		const pending = this.#pendingCreations.get(descriptor.id);
		if (pending) return pending;
		this.#cacheMisses += 1;
		const creationPromise = (async () => {
			try {
				const entry = this.#createEditorEntry(descriptor, options);
				if (!entry) return null;
				this.#editorEntries.set(descriptor.id, entry);
				this.#updateAccessOrder(descriptor.id);
				this.#enforceCacheSizeLimit();
				await entry.ready.catch((error) => {
					console.error("[HeaderFooterEditorManager] Editor initialization failed:", error);
					this.emit("error", {
						descriptor,
						error
					});
				});
				return entry.editor;
			} finally {
				this.#pendingCreations.delete(descriptor.id);
			}
		})();
		this.#pendingCreations.set(descriptor.id, creationPromise);
		return creationPromise;
	}
	ensureEditorSync(descriptor, options) {
		if (!descriptor?.id) return null;
		const existing = this.#editorEntries.get(descriptor.id);
		if (existing) {
			this.#cacheHits += 1;
			this.#updateAccessOrder(descriptor.id);
			this.#mountAndUpdateEntry(existing, options);
			return existing.editor;
		}
		const entry = this.#createEditorEntry(descriptor, options);
		if (!entry) return null;
		this.#cacheMisses += 1;
		this.#editorEntries.set(descriptor.id, entry);
		this.#updateAccessOrder(descriptor.id);
		this.#enforceCacheSizeLimit();
		return entry.editor;
	}
	#refreshPageNumberDisplay(editor) {
		const container = editor.view?.dom;
		if (!container) return;
		const opts = editor.options;
		const parentEditor = opts.parentEditor;
		const currentPage = String(opts.currentPageNumberText || opts.currentPageNumber || "1");
		const currentPageNumber = Number(opts.currentPageDisplayNumber || opts.currentPageNumber || 1);
		const chapterNumberText = typeof opts.currentPageChapterNumberText === "string" ? opts.currentPageChapterNumberText : void 0;
		const chapterSeparator = typeof opts.currentPageChapterSeparator === "string" ? opts.currentPageChapterSeparator : void 0;
		const totalPages = Number(opts.totalPageCount || parentEditor?.currentTotalPages || 1) || 1;
		const sectionPages = opts.sectionPageCount;
		const pageNumberEls = container.querySelectorAll("[data-id=\"auto-page-number\"]");
		const totalPagesEls = container.querySelectorAll("[data-id=\"auto-total-pages\"]");
		const sectionPagesEls = container.querySelectorAll("[data-id=\"auto-section-pages\"]");
		pageNumberEls.forEach((el) => {
			const pageNumberFormat = this.#getPageNumberFormatForDomNode(editor, el);
			const text = pageNumberFormat ? formatSectionPageNumberText({
				displayNumber: currentPageNumber,
				pageFormat: pageNumberFormat,
				chapterNumberText,
				chapterSeparator
			}) : currentPage;
			if (el.textContent !== text) el.textContent = text;
		});
		totalPagesEls.forEach((el) => {
			const text = formatPageNumberFieldValue(totalPages, this.#getPageNumberFieldFormatForDomNode(editor, el));
			if (el.textContent !== text) el.textContent = text;
		});
		sectionPagesEls.forEach((el) => {
			if (sectionPages == null) return;
			const pageNumberFormat = this.#getPageNumberFormatForDomNode(editor, el);
			const sectionPageCount = Number(sectionPages) || 1;
			const text = pageNumberFormat ? formatPageNumber(sectionPageCount, pageNumberFormat) : String(sectionPageCount);
			if (el.textContent !== text) el.textContent = text;
		});
	}
	#getPageNumberFormatForDomNode(editor, el) {
		try {
			const view = editor.view;
			if (!view) return null;
			const pos = view.posAtDOM(el, 0);
			const format = editor.state.doc.nodeAt(pos)?.attrs?.pageNumberFormat;
			return typeof format === "string" ? format : null;
		} catch {
			return null;
		}
	}
	#getPageNumberFieldFormatForDomNode(editor, el) {
		try {
			const view = editor.view;
			if (!view) return void 0;
			const pos = view.posAtDOM(el, 0);
			return getPageNumberFieldFormat(editor.state.doc.nodeAt(pos)?.attrs);
		} catch {
			return;
		}
	}
	getEditor(descriptor) {
		if (!descriptor?.id) return null;
		return this.#editorEntries.get(descriptor.id)?.editor ?? null;
	}
	getDescriptors(kind) {
		const entries = Array.from(this.#descriptors.values());
		if (!kind) return entries;
		return entries.filter((descriptor) => descriptor.kind === kind);
	}
	getDescriptorById(id) {
		return this.#descriptors.get(id);
	}
	getDocumentJson(descriptor) {
		if (!descriptor?.id) return null;
		const liveEntry = this.#editorEntries.get(descriptor.id);
		if (liveEntry) try {
			return liveEntry.editor.getJSON?.();
		} catch {}
		const collections = this.#collections;
		if (!collections) return null;
		if (descriptor.kind === "header") return collections.headers?.[descriptor.id] ?? null;
		return collections.footers?.[descriptor.id] ?? null;
	}
	get rootEditor() {
		return this.#editor;
	}
	getVariantId(kind, variant) {
		const collections = this.#collections;
		if (!collections) return null;
		const value = (kind === "header" ? collections.headerIds : collections.footerIds)?.[variant];
		if (typeof value === "string") return value;
		return null;
	}
	#extractCollections() {
		if (!this.#hasConverter(this.#editor)) return null;
		const converter = this.#editor.converter;
		if (!converter) return null;
		return {
			headers: converter.headers,
			footers: converter.footers,
			headerIds: converter.headerIds,
			footerIds: converter.footerIds
		};
	}
	#collectDescriptors(collections) {
		const descriptors = /* @__PURE__ */ new Map();
		if (!collections) return descriptors;
		const register = (kind, rId, variant) => {
			if (typeof rId !== "string" || rId.length === 0) return;
			const existing = descriptors.get(rId);
			if (existing) {
				if (variant && !existing.variant) existing.variant = variant;
				return;
			}
			descriptors.set(rId, {
				id: rId,
				kind,
				variant
			});
		};
		HEADER_FOOTER_VARIANTS.forEach((variant) => {
			const headerId = collections.headerIds?.[variant];
			const footerId = collections.footerIds?.[variant];
			if (typeof headerId === "string") register("header", headerId, variant);
			if (typeof footerId === "string") register("footer", footerId, variant);
		});
		const headerIdsArray = collections.headerIds?.ids;
		if (Array.isArray(headerIdsArray)) headerIdsArray.forEach((rId) => {
			if (typeof rId === "string" && !descriptors.has(rId)) register("header", rId);
		});
		const footerIdsArray = collections.footerIds?.ids;
		if (Array.isArray(footerIdsArray)) footerIdsArray.forEach((rId) => {
			if (typeof rId === "string" && !descriptors.has(rId)) register("footer", rId);
		});
		return descriptors;
	}
	#teardownMissingEditors(nextDescriptors) {
		const toRemove = [];
		this.#editorEntries.forEach((entry, key) => {
			if (!nextDescriptors.has(key)) {
				try {
					entry.disposer();
				} catch (error) {
					console.warn("[HeaderFooterEditorManager] Cleanup failed for editor:", key, error);
				}
				toRemove.push({
					key,
					descriptor: entry.descriptor
				});
			}
		});
		toRemove.forEach(({ key, descriptor }) => {
			this.#editorEntries.delete(key);
			this.#pinnedIds.delete(key);
			this.emit("editorDisposed", { descriptor });
		});
	}
	#teardownEditors() {
		const descriptors = [];
		this.#editorEntries.forEach((entry) => {
			descriptors.push(entry.descriptor);
			try {
				entry.disposer();
			} catch (error) {
				console.warn("[HeaderFooterEditorManager] Cleanup failed:", error);
			}
		});
		this.#editorEntries.clear();
		this.#pinnedIds.clear();
		descriptors.forEach((descriptor) => {
			this.emit("editorDisposed", { descriptor });
		});
	}
	#createEditorEntry(descriptor, options) {
		const json = this.getDocumentJson(descriptor);
		if (!json) return null;
		let editor;
		let container;
		try {
			container = this.#createEditorContainer();
			editor = createHeaderFooterEditor({
				editor: this.#editor,
				data: json,
				editorContainer: container,
				editorHost: options?.editorHost,
				headerFooterRefId: descriptor.id,
				type: descriptor.kind,
				availableWidth: options?.availableWidth,
				availableHeight: options?.availableHeight ?? DEFAULT_HEADER_FOOTER_HEIGHT,
				currentPageNumber: options?.currentPageNumber ?? 1,
				currentPageNumberText: options?.currentPageNumberText,
				currentPageDisplayNumber: options?.currentPageDisplayNumber,
				currentPageChapterNumberText: options?.currentPageChapterNumberText,
				currentPageChapterSeparator: options?.currentPageChapterSeparator,
				totalPageCount: options?.totalPageCount ?? 1,
				sectionPageCount: options?.sectionPageCount
			});
		} catch (error) {
			console.error("[HeaderFooterEditorManager] Editor creation failed:", error);
			return null;
		}
		const handleUpdate = async ({ transaction }) => {
			this.emit("contentChanged", { descriptor });
			try {
				onHeaderFooterDataUpdate({
					editor,
					transaction
				}, this.#editor, descriptor.id, descriptor.kind);
			} catch (error) {
				console.error("[HeaderFooterEditorManager] Failed to sync header/footer update", {
					descriptor,
					error
				});
				this.emit("syncError", {
					descriptor,
					error
				});
			}
		};
		editor.on("update", handleUpdate);
		this.#registerConverterEditor(descriptor, editor);
		const disposer = () => {
			try {
				editor.off?.("update", handleUpdate);
			} catch (error) {
				console.warn("[HeaderFooterEditorManager] Failed to remove update listener:", error);
			}
			try {
				editor.destroy?.();
			} catch (error) {
				console.warn("[HeaderFooterEditorManager] Failed to destroy editor:", error);
			}
			try {
				if (container.parentNode) container.parentNode.removeChild(container);
			} catch (error) {
				console.warn("[HeaderFooterEditorManager] Failed to remove container from DOM:", error);
			}
			try {
				this.#unregisterConverterEditor(descriptor);
			} catch (error) {
				console.warn("[HeaderFooterEditorManager] Failed to unregister converter editor:", error);
			}
		};
		const ready = new Promise((resolve, reject) => {
			let isResolved = false;
			const timeoutId = setTimeout(() => {
				if (!isResolved) {
					isResolved = true;
					reject(/* @__PURE__ */ new Error(`Editor initialization timed out after ${EDITOR_READY_TIMEOUT_MS}ms for ${descriptor.kind} ${descriptor.id}`));
				}
			}, EDITOR_READY_TIMEOUT_MS);
			editor.once?.("create", () => {
				if (!isResolved) {
					isResolved = true;
					clearTimeout(timeoutId);
					resolve();
				}
			});
			editor.once?.("error", (error) => {
				if (!isResolved) {
					isResolved = true;
					clearTimeout(timeoutId);
					reject(error instanceof Error ? error : new Error(String(error)));
				}
			});
		});
		const entry = {
			descriptor,
			editor,
			container,
			disposer,
			ready
		};
		this.emit("editorCreated", {
			descriptor,
			editor
		});
		return entry;
	}
	#mountAndUpdateEntry(entry, options) {
		if (entry.container && options?.editorHost && entry.container.parentElement !== options.editorHost) options.editorHost.appendChild(entry.container);
		if (!options) return;
		const updateOptions = {};
		if (options.currentPageNumber !== void 0) updateOptions.currentPageNumber = options.currentPageNumber;
		if (options.currentPageNumberText !== void 0) updateOptions.currentPageNumberText = options.currentPageNumberText;
		if (options.currentPageDisplayNumber !== void 0) updateOptions.currentPageDisplayNumber = options.currentPageDisplayNumber;
		const hasPageContext = options.currentPageNumber !== void 0 || options.currentPageNumberText !== void 0 || options.currentPageDisplayNumber !== void 0;
		if (hasPageContext || options.currentPageChapterNumberText !== void 0) updateOptions.currentPageChapterNumberText = options.currentPageChapterNumberText;
		if (hasPageContext || options.currentPageChapterSeparator !== void 0) updateOptions.currentPageChapterSeparator = options.currentPageChapterSeparator;
		if (options.totalPageCount !== void 0) updateOptions.totalPageCount = options.totalPageCount;
		if (options.sectionPageCount !== void 0) updateOptions.sectionPageCount = options.sectionPageCount;
		if (options.availableWidth !== void 0) updateOptions.availableWidth = options.availableWidth;
		if (options.availableHeight !== void 0) updateOptions.availableHeight = options.availableHeight;
		if (Object.keys(updateOptions).length > 0) {
			entry.editor.setOptions(updateOptions);
			this.#refreshPageNumberDisplay(entry.editor);
		}
	}
	#createEditorContainer() {
		return (this.#editor.options?.element?.ownerDocument ?? globalThis.document ?? void 0)?.createElement("div") ?? document.createElement("div");
	}
	#registerConverterEditor(descriptor, editor) {
		if (!this.#hasConverter(this.#editor)) return;
		const converter = this.#editor.converter;
		if (!converter) return;
		const targetKey = descriptor.kind === "header" ? "headerEditors" : "footerEditors";
		if (!Array.isArray(converter[targetKey])) converter[targetKey] = [];
		const converterEditors = converter[targetKey];
		if (!Array.isArray(converterEditors)) return;
		if (!converterEditors.some((entry) => {
			return entry && typeof entry === "object" && "id" in entry && entry.id === descriptor.id;
		})) converterEditors.push({
			id: descriptor.id,
			editor
		});
	}
	#unregisterConverterEditor(descriptor) {
		if (!this.#hasConverter(this.#editor)) return;
		const converter = this.#editor.converter;
		if (!converter) return;
		const targetKey = descriptor.kind === "header" ? "headerEditors" : "footerEditors";
		const converterEditors = converter[targetKey];
		if (!Array.isArray(converterEditors)) return;
		converter[targetKey] = converterEditors.filter((entry) => {
			return !(entry && typeof entry === "object" && "id" in entry && entry.id === descriptor.id);
		});
	}
	#updateAccessOrder(id) {
		this.#editorAccessOrder = this.#editorAccessOrder.filter((existingId) => existingId !== id);
		this.#editorAccessOrder.push(id);
	}
	#enforceCacheSizeLimit() {
		const overflow = () => this.#countEvictableEntries() > this.#maxCachedEditors;
		let guard$1 = this.#editorAccessOrder.length;
		while (overflow() && guard$1 > 0) {
			guard$1 -= 1;
			const oldestId = this.#findOldestEvictableId();
			if (!oldestId) break;
			this.#evictById(oldestId);
		}
	}
	#countEvictableEntries() {
		let count = 0;
		for (const id of this.#editorAccessOrder) if (!this.#pinnedIds.has(id)) count += 1;
		return count;
	}
	#findOldestEvictableId() {
		for (const id of this.#editorAccessOrder) if (!this.#pinnedIds.has(id)) return id;
		return null;
	}
	#evictById(id) {
		this.#editorAccessOrder = this.#editorAccessOrder.filter((existingId) => existingId !== id);
		const oldEntry = this.#editorEntries.get(id);
		if (!oldEntry) return;
		try {
			oldEntry.disposer();
			this.#evictions += 1;
		} catch (error) {
			console.warn("[HeaderFooterEditorManager] LRU eviction cleanup failed:", error);
		}
		this.#editorEntries.delete(id);
		this.emit("editorDisposed", { descriptor: oldEntry.descriptor });
	}
	pin(id) {
		if (!id) return;
		this.#pinnedIds.add(id);
	}
	unpin(id) {
		if (!id) return;
		this.#pinnedIds.delete(id);
		this.#enforceCacheSizeLimit();
	}
	isPinned(id) {
		return this.#pinnedIds.has(id);
	}
	setMaxCachedEditors(max$2) {
		if (max$2 < 1) throw new Error("Max cached editors must be at least 1");
		if (max$2 > MAX_CACHED_EDITORS_LIMIT) throw new Error(`Max cached editors must not exceed ${MAX_CACHED_EDITORS_LIMIT}`);
		if (!Number.isInteger(max$2)) throw new Error("Max cached editors must be an integer");
		this.#maxCachedEditors = max$2;
		this.#enforceCacheSizeLimit();
	}
	getCacheStats() {
		const totalAccesses = this.#cacheHits + this.#cacheMisses;
		const hitRate = totalAccesses > 0 ? this.#cacheHits / totalAccesses : 0;
		return {
			cachedEditors: this.#editorEntries.size,
			maxCachedEditors: this.#maxCachedEditors,
			cacheHits: this.#cacheHits,
			cacheMisses: this.#cacheMisses,
			evictions: this.#evictions,
			hitRate
		};
	}
	resetCacheStats() {
		this.#cacheHits = 0;
		this.#cacheMisses = 0;
		this.#evictions = 0;
	}
};
var HeaderFooterLayoutAdapter = class {
	#manager;
	#mediaFiles;
	#blockCache = /* @__PURE__ */ new Map();
	#trackedChangesRenderConfig = {
		mode: "review",
		enabled: true
	};
	constructor(manager, mediaFiles) {
		this.#manager = manager;
		this.#mediaFiles = mediaFiles;
	}
	setTrackedChangesRenderConfig(config) {
		const nextConfig = {
			mode: config.mode,
			enabled: config.enabled
		};
		if (this.#trackedChangesRenderConfig.mode === nextConfig.mode && this.#trackedChangesRenderConfig.enabled === nextConfig.enabled) return;
		this.#trackedChangesRenderConfig = nextConfig;
		this.invalidateAll();
	}
	getBatch(kind) {
		const descriptors = this.#manager.getDescriptors(kind);
		if (!descriptors.length) return;
		const batch = {};
		let hasBlocks = false;
		descriptors.forEach((descriptor) => {
			if (!descriptor.variant) return;
			const blocks = this.#getBlocks(descriptor);
			if (blocks && blocks.length > 0) {
				batch[descriptor.variant] = blocks;
				hasBlocks = true;
			}
		});
		return hasBlocks ? batch : void 0;
	}
	getBlocksByRId(kind) {
		const descriptors = this.#manager.getDescriptors(kind);
		if (!descriptors.length) return void 0;
		const blocksMap = /* @__PURE__ */ new Map();
		descriptors.forEach((descriptor) => {
			const blocks = this.#getBlocks(descriptor);
			if (blocks && blocks.length > 0) blocksMap.set(descriptor.id, blocks);
		});
		return blocksMap.size > 0 ? blocksMap : void 0;
	}
	getBlocksForRId(rId) {
		const descriptor = this.#manager.getDescriptorById(rId);
		if (!descriptor) return void 0;
		return this.#getBlocks(descriptor);
	}
	invalidate(rId) {
		this.#blockCache.delete(rId);
	}
	invalidateAll() {
		this.#blockCache.clear();
	}
	clear() {
		this.#blockCache.clear();
	}
	#getBlocks(descriptor) {
		const doc$1 = this.#manager.getDocumentJson(descriptor);
		if (!doc$1) return void 0;
		const renderConfigKey = this.#serializeRenderConfig();
		const cacheEntry = this.#blockCache.get(descriptor.id);
		if (cacheEntry?.docRef === doc$1 && cacheEntry.renderConfigKey === renderConfigKey) return cacheEntry.blocks;
		const blockIdPrefix = `hf-${descriptor.kind}-${descriptor.id}-`;
		const converterContext = this.#getConverterContext();
		const rootConverter = this.#manager.rootEditor?.converter;
		const providedMedia = this.#mediaFiles;
		const fallbackMedia = rootConverter?.media;
		const mediaFiles = providedMedia && Object.keys(providedMedia).length > 0 ? providedMedia : fallbackMedia;
		const atomNodeTypes = getAtomNodeTypes(this.#manager.rootEditor?.schema ?? null);
		const docDefaults = rootConverter?.getDocumentDefaultStyles?.();
		const defaultFont = docDefaults?.typeface;
		const blocks = toFlowBlocks(doc$1, {
			mediaFiles,
			blockIdPrefix,
			converterContext,
			defaultFont,
			defaultSize: docDefaults?.fontSizePt != null ? docDefaults.fontSizePt * (96 / 72) : void 0,
			trackedChangesMode: this.#trackedChangesRenderConfig.mode,
			enableTrackedChanges: this.#trackedChangesRenderConfig.enabled,
			storyKey: buildStoryKey({
				kind: "story",
				storyType: "headerFooterPart",
				refId: descriptor.id
			}),
			...atomNodeTypes.length > 0 ? { atomNodeTypes } : {}
		}).blocks;
		this.#blockCache.set(descriptor.id, {
			docRef: doc$1,
			renderConfigKey,
			blocks
		});
		return blocks;
	}
	#serializeRenderConfig() {
		return `${this.#trackedChangesRenderConfig.mode}|${this.#trackedChangesRenderConfig.enabled ? "1" : "0"}`;
	}
	#getConverterContext() {
		const rootEditor = this.#manager.rootEditor;
		if (!("converter" in rootEditor)) return;
		const converter = rootEditor.converter;
		if (!converter) return void 0;
		return {
			docx: converter.convertedXml,
			numbering: converter.numbering,
			translatedLinkedStyles: converter.translatedLinkedStyles,
			translatedNumbering: converter.translatedNumbering
		};
	}
};
function initHeaderFooterRegistry({ editor, converter, mediaFiles, isDebug, initBudgetMs, resetSession, requestRerender, previousCleanups, previousAdapter, previousManager }) {
	const startTime = performance.now();
	previousCleanups.forEach((fn) => {
		try {
			fn();
		} catch (error) {
			console.warn("[PresentationEditor] Header/footer cleanup failed:", error);
		}
	});
	previousAdapter?.clear();
	previousManager?.destroy();
	resetSession();
	const headerFooterIdentifier = extractIdentifierFromConverter(converter);
	const headerFooterManager = new HeaderFooterEditorManager(editor);
	const headerFooterAdapter = new HeaderFooterLayoutAdapter(headerFooterManager, mediaFiles);
	const cleanups = [];
	const handleContentChange = ({ descriptor }) => {
		headerFooterAdapter.invalidate(descriptor.id);
		requestRerender();
	};
	headerFooterManager.on("contentChanged", handleContentChange);
	cleanups.push(() => {
		headerFooterManager.off("contentChanged", handleContentChange);
	});
	const duration = performance.now() - startTime;
	if (isDebug && duration > initBudgetMs) console.warn(`[PresentationEditor] Header/footer initialization took ${duration.toFixed(2)}ms (budget: ${initBudgetMs}ms)`);
	return {
		headerFooterIdentifier,
		headerFooterManager,
		headerFooterAdapter,
		cleanups
	};
}
const EMUS_PER_INCH = 914400;
96 / EMUS_PER_INCH;
EMUS_PER_INCH / 96;
function calculateRotatedBounds(input) {
	const width = Math.max(0, input.width);
	const height = Math.max(0, input.height);
	const theta = degToRad(input.rotation ?? 0);
	const cos = Math.cos(theta);
	const sin = Math.sin(theta);
	return {
		width: Math.abs(width * cos) + Math.abs(height * sin),
		height: Math.abs(width * sin) + Math.abs(height * cos)
	};
}
function normalizeRotation(rotation) {
	if (!Number.isFinite(rotation)) return 0;
	let normalized = rotation % 360;
	if (normalized < 0) normalized += 360;
	return normalized;
}
function degToRad(degrees) {
	return degrees * Math.PI / 180;
}
var maxSize = 5e3;
var cache = /* @__PURE__ */ new Map();
var makeKey = (text, font, letterSpacing) => {
	return `${text}|${font}|${letterSpacing || 0}`;
};
function clearMeasurementCache() {
	cache.clear();
}
function getMeasuredTextWidth(text, font, letterSpacing, ctx$1) {
	if (text.length > 32e3) text = text.substring(0, 32e3);
	const key = makeKey(text, font, letterSpacing);
	const hit = cache.get(key);
	if (hit !== void 0) {
		cache.delete(key);
		cache.set(key, hit);
		return hit.width;
	}
	try {
		ctx$1.font = font;
		const width = ctx$1.measureText(text).width + (letterSpacing ? Math.max(0, text.length - 1) * letterSpacing : 0);
		cache.set(key, { width });
		evictIfNeeded();
		return width;
	} catch {
		return 0;
	}
}
function evictIfNeeded() {
	while (cache.size > maxSize) {
		const oldestKey = cache.keys().next().value;
		if (oldestKey === void 0) break;
		cache.delete(oldestKey);
	}
}
var fontMetricsCache = /* @__PURE__ */ new Map();
var MAX_CACHE_SIZE = 1e3;
var METRICS_TEST_STRING = "MHgypbdlÁÉÍ";
function getFontKey(fontInfo) {
	return `${fontInfo.fontFamily}|${fontInfo.fontSize}|${fontInfo.bold ?? false}|${fontInfo.italic ?? false}`;
}
function buildFontStringForMetrics(fontInfo, mode, fonts) {
	const parts = [];
	if (fontInfo.italic) parts.push("italic");
	if (fontInfo.bold) parts.push("bold");
	parts.push(`${fontInfo.fontSize}px`);
	if (mode === "deterministic") parts.push(fonts.fallbackStack.length > 0 ? fonts.fallbackStack.join(", ") : fonts.deterministicFamily);
	else parts.push(fontInfo.fontFamily);
	return parts.join(" ");
}
function getFontMetrics(ctx$1, fontInfo, mode, fonts) {
	if (!ctx$1 || typeof ctx$1 !== "object") throw new TypeError("Canvas context must be a valid CanvasRenderingContext2D object");
	if (typeof fontInfo.fontSize !== "number" || !Number.isFinite(fontInfo.fontSize) || fontInfo.fontSize <= 0) throw new TypeError(`Font size must be a positive finite number, got: ${typeof fontInfo.fontSize === "number" ? fontInfo.fontSize : typeof fontInfo.fontSize}`);
	if (typeof fontInfo.fontFamily !== "string" || fontInfo.fontFamily.trim().length === 0) throw new TypeError("Font family must be a non-empty string");
	if (mode !== "browser" && mode !== "deterministic") throw new TypeError(`Mode must be 'browser' or 'deterministic', got: ${mode}`);
	const key = getFontKey(fontInfo);
	const cached = fontMetricsCache.get(key);
	if (cached) return cached;
	ctx$1.font = buildFontStringForMetrics(fontInfo, mode, fonts);
	const textMetrics = ctx$1.measureText(METRICS_TEST_STRING);
	let ascent;
	let descent;
	if (typeof textMetrics.actualBoundingBoxAscent === "number" && typeof textMetrics.actualBoundingBoxDescent === "number" && textMetrics.actualBoundingBoxAscent > 0) {
		ascent = textMetrics.actualBoundingBoxAscent;
		descent = textMetrics.actualBoundingBoxDescent;
	} else {
		ascent = fontInfo.fontSize * .8;
		descent = fontInfo.fontSize * .2;
	}
	const result = {
		ascent,
		descent
	};
	if (fontMetricsCache.size >= MAX_CACHE_SIZE) {
		const firstKey = fontMetricsCache.keys().next().value;
		if (firstKey) fontMetricsCache.delete(firstKey);
	}
	fontMetricsCache.set(key, result);
	return result;
}
function clearFontMetricsCache() {
	fontMetricsCache.clear();
}
function computeFixedTableColumnWidths(input) {
	const gridColumnCount = Math.max(0, sanitizeColumnCount(input.gridColumnCount), Array.isArray(input.preferredColumnWidths) ? input.preferredColumnWidths.length : 0);
	const preferredTableWidth = sanitizeOptionalWidth$1(input.preferredTableWidth);
	const defaultAddedColumnWidth = resolveDefaultAddedColumnWidth(input.preferredColumnWidths, preferredTableWidth);
	const columnWidths = buildInitialGrid(input.preferredColumnWidths, gridColumnCount, defaultAddedColumnWidth);
	if (input.preserveAuthoredGrid === true) return {
		columnWidths,
		totalWidth: sumWidths$2(columnWidths),
		gridColumnCount: columnWidths.length,
		preferredTableWidth
	};
	if (input.rows.length === 0) {
		if (preferredTableWidth != null) shrinkToPreferredTableWidth(columnWidths, preferredTableWidth);
		return {
			columnWidths,
			totalWidth: sumWidths$2(columnWidths),
			gridColumnCount: columnWidths.length,
			preferredTableWidth
		};
	}
	applyFirstRowRequests(columnWidths, input.rows[0], defaultAddedColumnWidth);
	if (preferredTableWidth != null) shrinkToPreferredTableWidth(columnWidths, preferredTableWidth);
	for (const row of input.rows.slice(1)) {
		applySubsequentRowRequests(columnWidths, row, defaultAddedColumnWidth);
		if (preferredTableWidth != null) shrinkToPreferredTableWidth(columnWidths, preferredTableWidth);
	}
	return {
		columnWidths,
		totalWidth: sumWidths$2(columnWidths),
		gridColumnCount: columnWidths.length,
		preferredTableWidth
	};
}
function buildInitialGrid(preferredColumnWidths, gridColumnCount, defaultAddedColumnWidth) {
	const next = preferredColumnWidths.slice(0, gridColumnCount).map((width) => sanitizeNonNegativeWidth(width) ?? 0);
	while (next.length < gridColumnCount) next.push(defaultAddedColumnWidth);
	return next;
}
function applyFirstRowRequests(columnWidths, row, defaultAddedColumnWidth) {
	ensureGridWidth(columnWidths, row.logicalColumnCount, defaultAddedColumnWidth);
	for (const skippedColumn of row.skippedColumns) setSkippedColumnWidth(columnWidths, skippedColumn, defaultAddedColumnWidth);
	for (const cell of row.cells) setCellSpanWidth(columnWidths, cell, defaultAddedColumnWidth);
}
function applySubsequentRowRequests(columnWidths, row, defaultAddedColumnWidth) {
	ensureGridWidth(columnWidths, row.logicalColumnCount, defaultAddedColumnWidth);
	for (const skippedColumn of row.skippedColumns) growSkippedColumnWidth(columnWidths, skippedColumn, defaultAddedColumnWidth);
	for (const cell of row.cells) growCellSpanWidth(columnWidths, cell, defaultAddedColumnWidth);
}
function setSkippedColumnWidth(columnWidths, skippedColumn, defaultAddedColumnWidth) {
	const preferredWidth = sanitizeOptionalWidth$1(skippedColumn.preferredWidth);
	if (preferredWidth == null) return;
	ensureGridWidth(columnWidths, skippedColumn.columnIndex + 1, defaultAddedColumnWidth);
	columnWidths[skippedColumn.columnIndex] = preferredWidth;
}
function growSkippedColumnWidth(columnWidths, skippedColumn, defaultAddedColumnWidth) {
	const preferredWidth = sanitizeOptionalWidth$1(skippedColumn.preferredWidth);
	if (preferredWidth == null) return;
	ensureGridWidth(columnWidths, skippedColumn.columnIndex + 1, defaultAddedColumnWidth);
	columnWidths[skippedColumn.columnIndex] = Math.max(columnWidths[skippedColumn.columnIndex] ?? 0, preferredWidth);
}
function setCellSpanWidth(columnWidths, cell, defaultAddedColumnWidth) {
	const span = Math.max(1, sanitizeColumnCount(cell.span));
	const preferredWidth = sanitizeOptionalWidth$1(cell.preferredWidth);
	const endColumn = cell.startColumn + span;
	ensureGridWidth(columnWidths, endColumn, defaultAddedColumnWidth);
	if (preferredWidth == null) return;
	const currentSpanWidth = sumSpan$1(columnWidths, cell.startColumn, span);
	const lastColumnIndex = endColumn - 1;
	columnWidths[lastColumnIndex] = Math.max(0, (columnWidths[lastColumnIndex] ?? 0) + (preferredWidth - currentSpanWidth));
}
function growCellSpanWidth(columnWidths, cell, defaultAddedColumnWidth) {
	const span = Math.max(1, sanitizeColumnCount(cell.span));
	const preferredWidth = sanitizeOptionalWidth$1(cell.preferredWidth);
	const endColumn = cell.startColumn + span;
	ensureGridWidth(columnWidths, endColumn, defaultAddedColumnWidth);
	if (preferredWidth == null) return;
	const deficit = preferredWidth - sumSpan$1(columnWidths, cell.startColumn, span);
	if (deficit <= 0) return;
	const lastColumnIndex = endColumn - 1;
	columnWidths[lastColumnIndex] = Math.max(0, (columnWidths[lastColumnIndex] ?? 0) + deficit);
}
function shrinkToPreferredTableWidth(columnWidths, preferredTableWidth) {
	const totalWidth = sumWidths$2(columnWidths);
	if (preferredTableWidth <= 0 || totalWidth <= preferredTableWidth || totalWidth <= 0) return;
	const scale = preferredTableWidth / totalWidth;
	let consumed = 0;
	for (let index = 0; index < columnWidths.length; index++) {
		if (index === columnWidths.length - 1) {
			columnWidths[index] = Math.max(0, preferredTableWidth - consumed);
			continue;
		}
		const scaled = Math.max(0, (columnWidths[index] ?? 0) * scale);
		columnWidths[index] = scaled;
		consumed += scaled;
	}
}
function ensureGridWidth(columnWidths, requiredColumnCount, defaultAddedColumnWidth) {
	while (columnWidths.length < requiredColumnCount) columnWidths.push(defaultAddedColumnWidth);
}
function resolveDefaultAddedColumnWidth(preferredColumnWidths, preferredTableWidth) {
	for (let index = preferredColumnWidths.length - 1; index >= 0; index--) {
		const width = sanitizeNonNegativeWidth(preferredColumnWidths[index]);
		if (width != null && width > 0) return width;
	}
	const positiveAuthoredWidths = preferredColumnWidths.map((width) => sanitizeNonNegativeWidth(width)).filter((width) => width != null && width > 0);
	if (positiveAuthoredWidths.length > 0) return sumWidths$2(positiveAuthoredWidths) / positiveAuthoredWidths.length;
	if (preferredTableWidth != null && preferredTableWidth > 0) return preferredTableWidth;
	return 1;
}
function sumSpan$1(columnWidths, startColumn, span) {
	let total = 0;
	for (let offset$1 = 0; offset$1 < span; offset$1++) total += columnWidths[startColumn + offset$1] ?? 0;
	return total;
}
function sumWidths$2(columnWidths) {
	return columnWidths.reduce((sum, width) => sum + Math.max(0, width), 0);
}
function sanitizeColumnCount(value) {
	if (typeof value !== "number" || !Number.isFinite(value) || value <= 0) return 0;
	return Math.floor(value);
}
function sanitizeOptionalWidth$1(value) {
	const width = sanitizeNonNegativeWidth(value);
	return width == null ? void 0 : width;
}
function sanitizeNonNegativeWidth(value) {
	if (typeof value !== "number" || !Number.isFinite(value)) return;
	return Math.max(0, value);
}
var DEFAULT_MIN_COLUMN_WIDTH = 8;
function computeAutoFitColumnWidths(input) {
	const { workingInput, fixedLayout, rowMetrics, minColumnWidth } = resolveAutoFitContext(input);
	if (workingInput.layoutMode === "fixed") return finalizeResult("fixed", fixedLayout.columnWidths, minColumnWidth);
	const gridColumnCount = fixedLayout.gridColumnCount;
	if (gridColumnCount === 0) return buildFallbackResult(workingInput.layoutMode, minColumnWidth);
	const normalizedRows = buildNormalizedRows(workingInput, rowMetrics);
	const currentWidths = fixedLayout.columnWidths.slice(0, gridColumnCount);
	const minBounds = new Array(gridColumnCount).fill(0);
	const maxBounds = new Array(gridColumnCount).fill(0);
	const preferredOverrides = new Array(gridColumnCount).fill(void 0);
	const multiSpanCells = [];
	accumulateBounds({
		rows: normalizedRows,
		minBounds,
		maxBounds,
		preferredOverrides,
		multiSpanCells
	});
	applyMultiSpanMinimums(minBounds, multiSpanCells);
	applySingleSpanPreferredOverrides(maxBounds, minBounds, preferredOverrides);
	applyMultiSpanMaximums(maxBounds, minBounds, multiSpanCells, currentWidths);
	const triggerCells = collectTriggerCells(currentWidths, multiSpanCells, normalizedRows);
	const postTriggerGrowableColumns = triggerCells.length > 0 ? collectNonProtectedColumns(triggerCells, gridColumnCount) : void 0;
	let resolvedWidths = currentWidths.slice();
	const preferredTableWidth = sanitizeOptionalWidth(workingInput.preferredTableWidth);
	const autoGridWidthBudget = sanitizeOptionalWidth(workingInput.autoGridWidthBudget);
	let targetTableWidth = preferredTableWidth ?? (autoGridWidthBudget != null ? Math.min(fixedLayout.totalWidth, autoGridWidthBudget) : fixedLayout.totalWidth);
	const maxResolvedTableWidth = preferredTableWidth != null || autoGridWidthBudget == null && hasCompleteAuthoredGrid(workingInput) ? Math.max(workingInput.maxTableWidth, targetTableWidth) : workingInput.maxTableWidth;
	const shouldPreservePreferredGrid = workingInput.preserveAutoGrid === true || workingInput.preserveExplicitAutoGrid === true;
	if (triggerCells.length > 0) {
		resolvedWidths = raiseToMinimums(resolvedWidths, minBounds);
		resolvedWidths = expandTriggersWithinCurrentTable(resolvedWidths, triggerCells, minBounds, maxBounds);
		resolvedWidths = expandTriggersByGrowingTable(resolvedWidths, triggerCells, maxBounds, maxResolvedTableWidth);
		targetTableWidth = Math.max(targetTableWidth, sumWidths$1(resolvedWidths));
		targetTableWidth = Math.min(targetTableWidth, maxResolvedTableWidth);
	} else {
		targetTableWidth = Math.min(targetTableWidth, maxResolvedTableWidth);
		if (!shouldPreservePreferredGrid) {
			resolvedWidths = redistributeTowardMaximumsWithinCurrentTable(resolvedWidths, minBounds, maxBounds);
			resolvedWidths = redistributeTowardContentWeightedShape(resolvedWidths, minBounds, maxBounds);
		}
	}
	resolvedWidths = shrinkToTargetWidth(resolvedWidths, targetTableWidth, minBounds);
	resolvedWidths = growToTargetWidth(resolvedWidths, targetTableWidth, maxBounds, postTriggerGrowableColumns);
	if (sumWidths$1(resolvedWidths) < targetTableWidth) resolvedWidths = distributeRemainingSlack(resolvedWidths, targetTableWidth, postTriggerGrowableColumns);
	if (triggerCells.length > 0) resolvedWidths = clampTriggeredSpansToTargets(resolvedWidths, triggerCells, minBounds, maxBounds, currentWidths);
	if (sumWidths$1(resolvedWidths) > maxResolvedTableWidth) resolvedWidths = shrinkToTargetWidth(resolvedWidths, maxResolvedTableWidth, minBounds);
	return finalizeResult(workingInput.layoutMode, resolvedWidths, minColumnWidth);
}
function hasCompleteAuthoredGrid(workingInput) {
	const authoredColumnCount = workingInput.preferredColumnWidths.length;
	if (authoredColumnCount === 0) return false;
	return workingInput.rows.some((row) => row.logicalColumnCount >= authoredColumnCount);
}
function resolveAutoFitContext(input) {
	const minColumnWidth = sanitizeWidth(input.minColumnWidth, DEFAULT_MIN_COLUMN_WIDTH);
	if (isExplicitInput(input)) return {
		workingInput: input.workingInput,
		fixedLayout: input.fixedLayout,
		rowMetrics: input.contentMetrics.rowMetrics,
		minColumnWidth
	};
	const layoutMode = resolveLayoutMode$1(input.tableLayout);
	const normalizedRows = normalizeLegacyRows(input.rows ?? []);
	const gridColumnCount = determineGridColumnCount$1(input.preferredColumnWidths ?? [], normalizedRows);
	const workingInput = {
		layoutMode,
		maxTableWidth: Math.max(minColumnWidth, sanitizeWidth(input.maxTableWidth, minColumnWidth)),
		preferredTableWidth: sanitizeOptionalWidth(input.preferredTableWidth),
		preferredColumnWidths: (input.preferredColumnWidths ?? []).map((width) => Math.max(0, width)),
		gridColumnCount,
		rows: normalizedRows.map((row) => ({
			skippedBefore: row.skippedColumns.filter((column) => column.columnIndex < firstCellStart(row)),
			skippedAfter: row.skippedColumns.filter((column) => column.columnIndex >= lastCellEnd(row)),
			skippedColumns: row.skippedColumns,
			cells: row.cells.map((cell) => ({
				cellId: void 0,
				startColumn: cell.startColumn,
				span: cell.span,
				preferredWidth: cell.preferredWidth
			})),
			logicalColumnCount: row.logicalColumnCount
		}))
	};
	return {
		workingInput,
		fixedLayout: computeFixedTableColumnWidths(workingInput),
		rowMetrics: normalizedRows.map((row, rowIndex) => ({
			rowIndex,
			cells: row.cells.map((cell) => ({
				cellIndex: cell.cellIndex,
				span: cell.span,
				preferredWidth: cell.preferredWidth,
				minContentWidth: cell.minContentWidth,
				maxContentWidth: cell.maxContentWidth
			}))
		})),
		minColumnWidth
	};
}
function isExplicitInput(input) {
	return "workingInput" in input && "fixedLayout" in input && "contentMetrics" in input;
}
function resolveLayoutMode$1(tableLayout) {
	return tableLayout === "fixed" ? "fixed" : "autofit";
}
function normalizeLegacyRows(rows) {
	return rows.map((row, rowIndex) => {
		let columnIndex = 0;
		const skippedColumns = [];
		const cells = [];
		for (const skipped of row.skippedBefore ?? []) {
			skippedColumns.push(normalizeSkippedColumn(skipped, columnIndex));
			columnIndex += 1;
		}
		for (let cellIndex = 0; cellIndex < (row.cells ?? []).length; cellIndex++) {
			const cell = row.cells?.[cellIndex];
			if (!cell) continue;
			const span = Math.max(1, Math.floor(cell.span ?? 1));
			cells.push({
				rowIndex,
				cellIndex,
				startColumn: columnIndex,
				span,
				preferredWidth: sanitizeOptionalWidth(cell.preferredWidth),
				minContentWidth: Math.max(0, cell.minContentWidth ?? 0),
				maxContentWidth: Math.max(0, cell.maxContentWidth ?? cell.minContentWidth ?? 0)
			});
			columnIndex += span;
		}
		for (const skipped of row.skippedAfter ?? []) {
			skippedColumns.push(normalizeSkippedColumn(skipped, columnIndex));
			columnIndex += 1;
		}
		return {
			cells,
			skippedColumns,
			logicalColumnCount: columnIndex
		};
	});
}
function normalizeSkippedColumn(skipped, columnIndex) {
	return {
		columnIndex,
		preferredWidth: sanitizeOptionalWidth(skipped.preferredWidth),
		minContentWidth: Math.max(0, skipped.minContentWidth ?? 0),
		maxContentWidth: Math.max(0, skipped.maxContentWidth ?? skipped.minContentWidth ?? 0)
	};
}
function buildNormalizedRows(workingInput, rowMetrics) {
	return workingInput.rows.map((workingRow, rowIndex) => {
		const metricsRow = rowMetrics[rowIndex];
		return {
			cells: (workingRow.cells ?? []).map((cell, cellIndex) => {
				const metrics = metricsRow?.cells[cellIndex];
				const placedCell = cell;
				return {
					rowIndex,
					cellIndex: metrics?.cellIndex ?? cellIndex,
					startColumn: placedCell.startColumn,
					span: Math.max(1, placedCell.span ?? metrics?.span ?? 1),
					preferredWidth: sanitizeOptionalWidth(metrics?.preferredWidth ?? placedCell.preferredWidth),
					minContentWidth: Math.max(0, metrics?.minContentWidth ?? 0),
					maxContentWidth: Math.max(0, metrics?.maxContentWidth ?? metrics?.minContentWidth ?? 0)
				};
			}),
			skippedColumns: (workingRow.skippedColumns ?? []).map((skipped) => ({
				columnIndex: skipped.columnIndex,
				preferredWidth: sanitizeOptionalWidth(skipped.preferredWidth),
				minContentWidth: Math.max(0, skipped.minContentWidth ?? 0),
				maxContentWidth: Math.max(0, skipped.maxContentWidth ?? skipped.minContentWidth ?? 0)
			})),
			logicalColumnCount: workingRow.logicalColumnCount
		};
	});
}
function accumulateBounds(args$1) {
	const { rows, minBounds, maxBounds, preferredOverrides, multiSpanCells } = args$1;
	for (const row of rows) {
		for (const skipped of row.skippedColumns) {
			minBounds[skipped.columnIndex] = Math.max(minBounds[skipped.columnIndex], skipped.minContentWidth);
			maxBounds[skipped.columnIndex] = Math.max(maxBounds[skipped.columnIndex], skipped.maxContentWidth);
			if (preferredOverrides[skipped.columnIndex] == null && skipped.preferredWidth != null) preferredOverrides[skipped.columnIndex] = skipped.preferredWidth;
		}
		for (const cell of row.cells) if (cell.span === 1) {
			minBounds[cell.startColumn] = Math.max(minBounds[cell.startColumn], cell.minContentWidth);
			maxBounds[cell.startColumn] = Math.max(maxBounds[cell.startColumn], cell.maxContentWidth);
			if (preferredOverrides[cell.startColumn] == null && cell.preferredWidth != null) preferredOverrides[cell.startColumn] = cell.preferredWidth;
		} else multiSpanCells.push(cell);
	}
}
function applyMultiSpanMinimums(minBounds, cells) {
	for (const cell of cells) growSpanTotal(minBounds, cell.startColumn, cell.span, cell.minContentWidth);
}
function applySingleSpanPreferredOverrides(maxBounds, minBounds, preferredOverrides) {
	for (let index = 0; index < maxBounds.length; index++) {
		const currentMax = Math.max(maxBounds[index], minBounds[index]);
		maxBounds[index] = preferredOverrides[index] ?? currentMax;
		maxBounds[index] = Math.max(maxBounds[index], minBounds[index]);
	}
}
function applyMultiSpanMaximums(maxBounds, minBounds, cells, fixedWidths) {
	for (const cell of cells) {
		const targetTotal = cell.preferredWidth != null ? Math.max(cell.preferredWidth, sumSpan(minBounds, cell.startColumn, cell.span)) : Math.max(cell.maxContentWidth, sumSpan(minBounds, cell.startColumn, cell.span));
		setSpanTotal(maxBounds, minBounds, fixedWidths, cell.startColumn, cell.span, targetTotal);
	}
}
function collectTriggerCells(currentWidths, multiSpanCells, rows) {
	const triggers = [];
	for (const row of rows) for (const cell of row.cells) if (sumSpan(currentWidths, cell.startColumn, cell.span) < cell.minContentWidth) triggers.push(cell);
	for (const cell of multiSpanCells) if (sumSpan(currentWidths, cell.startColumn, cell.span) < cell.minContentWidth) triggers.push(cell);
	return coalesceEquivalentTriggerCells(dedupeCells(triggers));
}
function setSpanTotal(widths, minBounds, fixedWidths, startColumn, span, targetTotal) {
	const currentTotal = sumSpan(widths, startColumn, span);
	const minTotal = sumSpan(minBounds, startColumn, span);
	const boundedTarget = Math.max(targetTotal, minTotal);
	if (currentTotal < boundedTarget) {
		growSpanTotal(widths, startColumn, span, boundedTarget, fixedWidths);
		return;
	}
	if (currentTotal === boundedTarget) return;
	const reducibleRanges = collectSpanRanges(widths, minBounds, startColumn, span);
	const totalReducible = reducibleRanges.reduce((sum, range) => sum + range.amount, 0);
	if (totalReducible <= 0) return;
	const reduction = currentTotal - boundedTarget;
	let applied = 0;
	for (let rangeIndex = 0; rangeIndex < reducibleRanges.length; rangeIndex++) {
		const range = reducibleRanges[rangeIndex];
		const portion = rangeIndex === reducibleRanges.length - 1 ? reduction - applied : reduction * (range.amount / totalReducible);
		widths[range.index] = Math.max(minBounds[range.index], widths[range.index] - portion);
		applied += portion;
	}
}
function growSpanTotal(widths, startColumn, span, targetTotal, fixedWidths) {
	const deficit = targetTotal - sumSpan(widths, startColumn, span);
	if (deficit <= 0) return;
	const weights = Array.from({ length: span }, (_$1, offset$1) => {
		const index = startColumn + offset$1;
		return Math.max(fixedWidths?.[index] ?? 0, widths[index] ?? 0, 1);
	});
	const totalWeight = weights.reduce((sum, weight) => sum + weight, 0);
	let applied = 0;
	for (let offset$1 = 0; offset$1 < span; offset$1++) {
		const index = startColumn + offset$1;
		const increment = offset$1 === span - 1 ? deficit - applied : deficit * (weights[offset$1] / totalWeight);
		widths[index] = Math.max(0, (widths[index] ?? 0) + increment);
		applied += increment;
	}
}
function shrinkToTargetWidth(widths, targetWidth, minBounds) {
	const currentTotal = sumWidths$1(widths);
	if (currentTotal <= targetWidth) return widths;
	const minTotal = sumWidths$1(minBounds);
	if (targetWidth <= 0) return widths;
	if (targetWidth < minTotal) return scaleToTargetWidth(widths, targetWidth);
	const capacities = widths.map((width, index) => Math.max(0, width - minBounds[index]));
	const totalCapacity = capacities.reduce((sum, capacity) => sum + capacity, 0);
	if (totalCapacity <= 0) return widths;
	const excess = currentTotal - targetWidth;
	return widths.map((width, index) => {
		const shrink = excess * (capacities[index] / totalCapacity);
		return Math.max(minBounds[index], width - shrink);
	});
}
function growToTargetWidth(widths, targetWidth, maxBounds, growableColumns) {
	const currentTotal = sumWidths$1(widths);
	if (currentTotal >= targetWidth) return widths;
	const ranges = widths.map((width, index) => growableColumns == null || growableColumns.has(index) ? Math.max(0, maxBounds[index] - width) : 0);
	const totalRange = ranges.reduce((sum, range) => sum + range, 0);
	if (totalRange <= 0) return widths;
	const slack = targetWidth - currentTotal;
	return widths.map((width, index) => width + slack * (ranges[index] / totalRange));
}
function distributeRemainingSlack(widths, targetWidth, growableColumns) {
	const currentTotal = sumWidths$1(widths);
	if (currentTotal >= targetWidth) return widths;
	const basis = widths.reduce((sum, width, index) => {
		if (growableColumns != null && !growableColumns.has(index)) return sum;
		return sum + Math.max(width, 1);
	}, 0);
	const slack = targetWidth - currentTotal;
	if (basis <= 0) {
		if (growableColumns == null) return widths;
		const growableIndexes = widths.map((_$1, index) => index).filter((index) => growableColumns.has(index));
		if (growableIndexes.length === 0) return widths;
		const share = slack / growableIndexes.length;
		return widths.map((width, index) => growableColumns.has(index) ? width + share : width);
	}
	return widths.map((width, index) => {
		if (growableColumns != null && !growableColumns.has(index)) return width;
		return width + slack * (Math.max(width, 1) / basis);
	});
}
function raiseToMinimums(widths, minBounds) {
	const next = widths.slice();
	const deficits = next.map((width, index) => Math.max(0, minBounds[index] - width));
	const totalDeficit = deficits.reduce((sum, deficit) => sum + deficit, 0);
	if (totalDeficit <= 0) return next;
	const capacities = next.map((width, index) => Math.max(0, width - minBounds[index]));
	const totalCapacity = capacities.reduce((sum, capacity) => sum + capacity, 0);
	const borrowAmount = Math.min(totalDeficit, totalCapacity);
	if (borrowAmount > 0 && totalCapacity > 0) {
		let borrowed = 0;
		for (let index = 0; index < next.length; index++) {
			const reduction = index === next.length - 1 ? borrowAmount - borrowed : borrowAmount * (capacities[index] / totalCapacity);
			next[index] = Math.max(minBounds[index], next[index] - reduction);
			borrowed += reduction;
		}
	}
	for (let index = 0; index < next.length; index++) next[index] = Math.max(next[index], Math.min(minBounds[index], widths[index] + deficits[index]));
	return next;
}
function redistributeTowardMaximumsWithinCurrentTable(widths, minBounds, maxBounds) {
	const next = widths.slice();
	for (let iteration = 0; iteration < 8; iteration++) {
		const receiverHeadrooms = next.map((width, index) => Math.max(0, maxBounds[index] - width));
		const totalReceiverHeadroom = receiverHeadrooms.reduce((sum, headroom) => sum + headroom, 0);
		if (totalReceiverHeadroom <= .001) break;
		const donorCapacities = next.map((width, index) => receiverHeadrooms[index] > .001 ? 0 : Math.max(0, width - minBounds[index]));
		let totalDonorCapacity = donorCapacities.reduce((sum, capacity) => sum + capacity, 0);
		if (totalDonorCapacity <= .001) {
			for (let index = 0; index < next.length; index++) donorCapacities[index] = Math.max(0, next[index] - minBounds[index]);
			totalDonorCapacity = donorCapacities.reduce((sum, capacity) => sum + capacity, 0);
		}
		if (totalDonorCapacity <= .001) break;
		const redistribution = Math.min(totalReceiverHeadroom, totalDonorCapacity);
		shrinkColumnsByCapacity(next, donorCapacities, minBounds, redistribution);
		growColumnsByHeadroom(next, receiverHeadrooms, redistribution);
	}
	return next;
}
function redistributeTowardContentWeightedShape(widths, minBounds, maxBounds) {
	const distributableWidth = sumWidths$1(widths) - sumWidths$1(minBounds);
	if (distributableWidth <= .001 || widths.length === 0) return widths;
	const demandWeights = widths.map((width, index) => {
		const demand = Math.max(maxBounds[index], width, minBounds[index], 1);
		return demand * demand;
	});
	const totalDemandWeight = demandWeights.reduce((sum, weight) => sum + weight, 0);
	if (totalDemandWeight <= .001) return widths;
	return widths.map((_$1, index) => minBounds[index] + distributableWidth * (demandWeights[index] / totalDemandWeight));
}
function expandTriggersWithinCurrentTable(widths, triggerCells, minBounds, maxBounds) {
	const next = widths.slice();
	const protectedColumns = collectProtectedColumns(triggerCells);
	for (let iteration = 0; iteration < 8; iteration++) {
		const totalHeadroom = collectTriggerHeadrooms(next, triggerCells, maxBounds).reduce((sum, headroom) => sum + headroom, 0);
		if (totalHeadroom <= .001) break;
		const donorCapacities = next.map((width, index) => protectedColumns.has(index) ? 0 : Math.max(0, width - minBounds[index]));
		const totalDonorCapacity = donorCapacities.reduce((sum, capacity) => sum + capacity, 0);
		if (totalDonorCapacity <= .001) break;
		const borrowedWidth = Math.min(totalHeadroom, totalDonorCapacity);
		shrinkColumnsByCapacity(next, donorCapacities, minBounds, borrowedWidth);
		applyTriggerGrowth(next, triggerCells, maxBounds, borrowedWidth);
	}
	return next;
}
function expandTriggersByGrowingTable(widths, triggerCells, maxBounds, maxTableWidth) {
	const next = widths.slice();
	for (let iteration = 0; iteration < 8; iteration++) {
		const totalHeadroom = collectTriggerHeadrooms(next, triggerCells, maxBounds).reduce((sum, headroom) => sum + headroom, 0);
		if (totalHeadroom <= .001) break;
		const remainingTableGrowth = Math.max(0, maxTableWidth - sumWidths$1(next));
		if (remainingTableGrowth <= .001) break;
		applyTriggerGrowth(next, triggerCells, maxBounds, Math.min(totalHeadroom, remainingTableGrowth));
	}
	return next;
}
function collectTriggerHeadrooms(widths, triggerCells, maxBounds) {
	return triggerCells.map((cell) => {
		const currentTotal = sumSpan(widths, cell.startColumn, cell.span);
		const targetTotal = resolveTriggerTargetTotal(cell, maxBounds);
		return Math.max(0, targetTotal - currentTotal);
	});
}
function resolveTriggerTargetTotal(cell, maxBounds) {
	if (cell.span === 1) return maxBounds[cell.startColumn] ?? cell.maxContentWidth;
	return cell.preferredWidth != null ? Math.max(cell.preferredWidth, cell.minContentWidth) : Math.max(cell.maxContentWidth, cell.minContentWidth);
}
function collectProtectedColumns(cells) {
	const protectedColumns = /* @__PURE__ */ new Set();
	for (const cell of cells) for (let offset$1 = 0; offset$1 < cell.span; offset$1++) protectedColumns.add(cell.startColumn + offset$1);
	return protectedColumns;
}
function collectNonProtectedColumns(cells, columnCount) {
	const protectedColumns = collectProtectedColumns(cells);
	const growableColumns = /* @__PURE__ */ new Set();
	for (let index = 0; index < columnCount; index++) if (!protectedColumns.has(index)) growableColumns.add(index);
	return growableColumns;
}
function shrinkColumnsByCapacity(widths, capacities, minBounds, shrinkAmount) {
	const totalCapacity = capacities.reduce((sum, capacity) => sum + capacity, 0);
	if (totalCapacity <= 0 || shrinkAmount <= 0) return;
	let applied = 0;
	for (let index = 0; index < widths.length; index++) {
		const reduction = index === widths.length - 1 ? shrinkAmount - applied : shrinkAmount * (capacities[index] / totalCapacity);
		widths[index] = Math.max(minBounds[index], widths[index] - reduction);
		applied += reduction;
	}
}
function growColumnsByHeadroom(widths, headrooms, growthAmount) {
	const totalHeadroom = headrooms.reduce((sum, headroom) => sum + headroom, 0);
	if (totalHeadroom <= 0 || growthAmount <= 0) return;
	let applied = 0;
	const activeIndexes = headrooms.map((headroom, index) => ({
		headroom,
		index
	})).filter((entry) => entry.headroom > .001);
	for (let activeIndex = 0; activeIndex < activeIndexes.length; activeIndex++) {
		const { index, headroom } = activeIndexes[activeIndex];
		const growth = activeIndex === activeIndexes.length - 1 ? growthAmount - applied : growthAmount * (headroom / totalHeadroom);
		widths[index] += Math.min(headroom, growth);
		applied += Math.min(headroom, growth);
	}
}
function applyTriggerGrowth(widths, triggerCells, maxBounds, growthAmount) {
	let remainingGrowth = growthAmount;
	for (let iteration = 0; iteration < 16 && remainingGrowth > .001; iteration++) {
		const headrooms = collectTriggerHeadrooms(widths, triggerCells, maxBounds);
		const totalHeadroom = headrooms.reduce((sum, headroom) => sum + headroom, 0);
		if (totalHeadroom <= .001) break;
		const stepGrowth = Math.min(remainingGrowth, totalHeadroom);
		const activeIndexes = headrooms.map((headroom, index) => ({
			headroom,
			index
		})).filter((entry) => entry.headroom > .001);
		let appliedThisRound = 0;
		for (let activeIndex = 0; activeIndex < activeIndexes.length; activeIndex++) {
			const { index, headroom } = activeIndexes[activeIndex];
			const cell = triggerCells[index];
			const proportionalGrowth = activeIndex === activeIndexes.length - 1 ? stepGrowth - appliedThisRound : stepGrowth * (headroom / totalHeadroom);
			const boundedGrowth = Math.min(headroom, proportionalGrowth);
			if (boundedGrowth <= 0) continue;
			growSpanTotal(widths, cell.startColumn, cell.span, sumSpan(widths, cell.startColumn, cell.span) + boundedGrowth);
			appliedThisRound += boundedGrowth;
		}
		if (appliedThisRound <= .001) break;
		remainingGrowth -= appliedThisRound;
	}
}
function clampTriggeredSpansToTargets(widths, triggerCells, minBounds, maxBounds, fixedWidths) {
	const next = widths.slice();
	for (let iteration = 0; iteration < 8; iteration++) {
		let changed = false;
		for (const cell of triggerCells) {
			const currentTotal = sumSpan(next, cell.startColumn, cell.span);
			const targetTotal = resolveTriggerTargetTotal(cell, maxBounds);
			if (currentTotal > targetTotal + .001) {
				setSpanTotal(next, minBounds, fixedWidths, cell.startColumn, cell.span, targetTotal);
				changed = true;
			}
		}
		if (!changed) break;
	}
	return next;
}
function collectSpanRanges(widths, minBounds, startColumn, span) {
	const ranges = [];
	for (let offset$1 = 0; offset$1 < span; offset$1++) {
		const index = startColumn + offset$1;
		const amount = Math.max(0, widths[index] - minBounds[index]);
		if (amount > 0) ranges.push({
			index,
			amount
		});
	}
	return ranges;
}
function dedupeCells(cells) {
	const seen = /* @__PURE__ */ new Set();
	return cells.filter((cell) => {
		const key = `${cell.rowIndex}:${cell.startColumn}:${cell.span}:${cell.cellIndex}`;
		if (seen.has(key)) return false;
		seen.add(key);
		return true;
	});
}
function coalesceEquivalentTriggerCells(cells) {
	const strongestBySpan = /* @__PURE__ */ new Map();
	for (const cell of cells) {
		const key = `${cell.startColumn}:${cell.span}`;
		const current = strongestBySpan.get(key);
		if (!current || resolveTriggerStrength(cell) > resolveTriggerStrength(current)) strongestBySpan.set(key, cell);
	}
	return [...strongestBySpan.values()];
}
function resolveTriggerStrength(cell) {
	return cell.preferredWidth != null ? Math.max(cell.preferredWidth, cell.minContentWidth) : Math.max(cell.maxContentWidth, cell.minContentWidth);
}
function determineGridColumnCount$1(preferredColumnWidths, rows) {
	return Math.max(preferredColumnWidths.length, ...rows.map((row) => row.logicalColumnCount), 0);
}
function firstCellStart(row) {
	return row.cells[0]?.startColumn ?? row.logicalColumnCount;
}
function lastCellEnd(row) {
	const lastCell = row.cells[row.cells.length - 1];
	return lastCell ? lastCell.startColumn + lastCell.span : 0;
}
function sumSpan(widths, startColumn, span) {
	let total = 0;
	for (let offset$1 = 0; offset$1 < span; offset$1++) total += widths[startColumn + offset$1] ?? 0;
	return total;
}
function sumWidths$1(widths) {
	return widths.reduce((sum, width) => sum + Math.max(0, width), 0);
}
function scaleToTargetWidth(widths, targetWidth) {
	const currentTotal = sumWidths$1(widths);
	if (currentTotal <= 0 || targetWidth <= 0) return widths;
	const scale = targetWidth / currentTotal;
	return widths.map((width) => Math.max(0, width * scale));
}
function sanitizeWidth(value, fallback) {
	return typeof value === "number" && Number.isFinite(value) && value > 0 ? value : fallback;
}
function sanitizeOptionalWidth(value) {
	return typeof value === "number" && Number.isFinite(value) && value >= 0 ? value : void 0;
}
function buildFallbackResult(layoutMode, minColumnWidth) {
	return {
		layoutMode,
		columnWidths: [minColumnWidth],
		totalWidth: minColumnWidth,
		gridColumnCount: 1
	};
}
function finalizeResult(layoutMode, widths, minColumnWidth) {
	if (widths.length === 0) return buildFallbackResult(layoutMode, minColumnWidth);
	return {
		layoutMode,
		columnWidths: widths,
		totalWidth: sumWidths$1(widths),
		gridColumnCount: widths.length
	};
}
var TWIPS_PER_PX$1 = 15;
var PLACEHOLDER_COLUMN_MAX_WIDTH = 1;
function buildAutoFitWorkingGridInput(block, constraints) {
	const maxTableWidth = sanitizePositiveNumber(constraints.maxWidth);
	const layoutMode = resolveLayoutMode(block.attrs?.tableLayout);
	const tableWidth = block.attrs?.tableWidth;
	const preferredTableWidth = resolvePreferredTableWidth(tableWidth, maxTableWidth);
	const rawPreferredColumnWidths = normalizePreferredColumnWidths(block.columnWidths);
	const logicalColumnLimit = resolveTrailingPlaceholderColumnLimit(rawPreferredColumnWidths);
	let activeRowSpans = [];
	const rows = block.rows.map((row) => {
		const normalized = normalizeRow(row, preferredTableWidth ?? maxTableWidth, activeRowSpans, logicalColumnLimit);
		activeRowSpans = normalized.nextActiveRowSpans;
		return normalized.row;
	});
	const preferredColumnWidths = trimTrailingUnoccupiedPlaceholderColumns(rawPreferredColumnWidths, determineGridColumnCount(0, rows));
	const gridColumnCount = determineGridColumnCount(preferredColumnWidths.length, rows);
	const preserveAuthoredGrid = shouldPreserveAuthoredGrid({
		layoutMode,
		preferredColumnWidths,
		preferredTableWidth,
		gridColumnCount
	});
	const preserveAutoGrid = shouldPreserveAutoGrid({
		layoutMode,
		preferredColumnWidths,
		preferredTableWidth,
		gridColumnCount
	});
	const preserveExplicitAutoGrid = shouldPreserveExplicitAutoGrid({
		layoutMode,
		preferredColumnWidths,
		preferredTableWidth,
		gridColumnCount,
		rows
	});
	const autoGridWidthBudget = resolveAutoGridWidthBudget({
		layoutMode,
		tableWidth,
		preferredColumnWidths,
		preferredTableWidth,
		gridColumnCount,
		maxTableWidth
	});
	return {
		layoutMode,
		maxTableWidth,
		...preserveAuthoredGrid ? { preserveAuthoredGrid } : {},
		...preserveAutoGrid ? { preserveAutoGrid } : {},
		...preserveExplicitAutoGrid ? { preserveExplicitAutoGrid } : {},
		...autoGridWidthBudget != null ? { autoGridWidthBudget } : {},
		preferredTableWidth,
		preferredColumnWidths,
		gridColumnCount,
		rows
	};
}
function resolveLayoutMode(tableLayout) {
	return tableLayout === "fixed" ? "fixed" : "autofit";
}
function shouldPreserveAuthoredGrid(args$1) {
	const { layoutMode, preferredColumnWidths, preferredTableWidth, gridColumnCount } = args$1;
	if (layoutMode !== "fixed") return false;
	if (preferredTableWidth == null || preferredTableWidth <= 0) return false;
	if (preferredColumnWidths.length === 0 || preferredColumnWidths.length !== gridColumnCount) return false;
	const totalPreferredColumnWidth = sumWidths(preferredColumnWidths);
	return approximatelyEqual(totalPreferredColumnWidth, preferredTableWidth) || isSlightlyUnderPreferredTableWidth(totalPreferredColumnWidth, preferredTableWidth);
}
function shouldPreserveAutoGrid(args$1) {
	const { layoutMode, preferredColumnWidths, preferredTableWidth, gridColumnCount } = args$1;
	if (layoutMode !== "autofit") return false;
	if (preferredTableWidth != null) return false;
	if (preferredColumnWidths.length === 0 || preferredColumnWidths.length !== gridColumnCount) return false;
	if (!hasNonUniformGrid(preferredColumnWidths)) return false;
	return true;
}
function shouldPreserveExplicitAutoGrid(args$1) {
	const { layoutMode, preferredColumnWidths, preferredTableWidth, gridColumnCount, rows } = args$1;
	if (layoutMode !== "autofit") return false;
	if (preferredTableWidth == null || preferredTableWidth <= 0) return false;
	if (preferredColumnWidths.length === 0 || preferredColumnWidths.length !== gridColumnCount) return false;
	if (!hasNonUniformGrid(preferredColumnWidths) && !hasConcreteCellWidthRequest(rows)) return false;
	return approximatelyEqual(sumWidths(preferredColumnWidths), preferredTableWidth);
}
function resolveAutoGridWidthBudget(args$1) {
	const { layoutMode, tableWidth, preferredColumnWidths, preferredTableWidth, gridColumnCount, maxTableWidth } = args$1;
	if (layoutMode !== "autofit") return void 0;
	if (!hasAutoTableWidthSemantics(tableWidth)) return void 0;
	if (preferredTableWidth != null) return void 0;
	if (preferredColumnWidths.length === 0 || preferredColumnWidths.length !== gridColumnCount) return void 0;
	const gridWidth = sumWidths(preferredColumnWidths);
	if (gridWidth <= 0) return void 0;
	if (gridWidth > maxTableWidth + .5) return void 0;
	return gridWidth;
}
function hasAutoTableWidthSemantics(tableWidth) {
	if (tableWidth == null) return false;
	if (typeof tableWidth !== "object") return false;
	if ((typeof tableWidth.type === "string" ? tableWidth.type.toLowerCase() : void 0) !== "auto") return false;
	const rawWidth = tableWidth.width ?? tableWidth.value;
	return rawWidth == null || typeof rawWidth === "number" && Number.isFinite(rawWidth) && rawWidth <= 0;
}
function hasNonUniformGrid(widths) {
	if (widths.length <= 1) return true;
	const firstWidth = widths[0];
	return widths.some((width) => !approximatelyEqual(width, firstWidth));
}
function hasConcreteCellWidthRequest(rows) {
	return rows.some((row) => row.cells.some((cell) => cell.preferredWidth != null));
}
function trimTrailingUnoccupiedPlaceholderColumns(widths, occupiedGridColumnCount) {
	const occupiedCount = Math.max(0, Math.floor(occupiedGridColumnCount));
	if (occupiedCount <= 0 || widths.length <= occupiedCount) return widths;
	if (!widths.slice(occupiedCount).every((width) => width <= PLACEHOLDER_COLUMN_MAX_WIDTH)) return widths;
	return widths.slice(0, occupiedCount);
}
function resolveTrailingPlaceholderColumnLimit(widths) {
	let trailingPlaceholderCount = 0;
	for (let index = widths.length - 1; index >= 0; index--) {
		if (widths[index] > PLACEHOLDER_COLUMN_MAX_WIDTH) break;
		trailingPlaceholderCount += 1;
	}
	if (trailingPlaceholderCount === 0 || trailingPlaceholderCount === widths.length) return;
	return widths.length - trailingPlaceholderCount;
}
function normalizePreferredColumnWidths(columnWidths) {
	if (!Array.isArray(columnWidths)) return [];
	return columnWidths.map((width) => sanitizeNonNegativeNumber(width)).filter((width) => width !== void 0).map((width) => width);
}
function normalizeRow(row, percentageBasis, activeRowSpans, logicalColumnLimit) {
	const rowProps = row.attrs?.tableRowProperties ?? {};
	const skippedBeforeCount = sanitizeCount(rowProps.gridBefore);
	const skippedAfterCount = normalizeSkippedAfterCount(rowProps.gridAfter, rowProps.wAfter, percentageBasis);
	const cells = Array.isArray(row.cells) ? row.cells : [];
	let columnIndex = advancePastOccupiedColumns(activeRowSpans, 0);
	const skippedBeforePlacement = buildSkippedColumns(skippedBeforeCount, rowProps.wBefore, percentageBasis, columnIndex, activeRowSpans);
	columnIndex = skippedBeforePlacement.nextColumnIndex;
	const normalizedCells = cells.map((cell) => {
		columnIndex = advancePastOccupiedColumns(activeRowSpans, columnIndex);
		const normalizedCell = normalizeCell(cell, percentageBasis, columnIndex, logicalColumnLimit);
		columnIndex += normalizedCell.span ?? 1;
		return normalizedCell;
	});
	const skippedAfterPlacement = buildSkippedColumns(skippedAfterCount, rowProps.wAfter, percentageBasis, columnIndex, activeRowSpans);
	columnIndex = skippedAfterPlacement.nextColumnIndex;
	const logicalColumnCount = Math.max(columnIndex, resolveOccupiedLogicalColumnCount(activeRowSpans));
	const nextActiveRowSpans = advanceRowSpans(activeRowSpans);
	normalizedCells.forEach((cell, index) => {
		const rowSpan = sanitizeCount(cells[index]?.rowSpan) || 1;
		if (rowSpan > 1) markRowSpanOccupancy(nextActiveRowSpans, cell.startColumn, cell.span ?? 1, rowSpan - 1);
	});
	return {
		row: {
			skippedBefore: skippedBeforePlacement.columns,
			cells: normalizedCells,
			skippedAfter: skippedAfterPlacement.columns,
			skippedColumns: [...skippedBeforePlacement.columns, ...skippedAfterPlacement.columns],
			logicalColumnCount
		},
		nextActiveRowSpans
	};
}
function buildSkippedColumns(count, preferredWidthMeasurement, percentageBasis, startColumnIndex, activeRowSpans) {
	if (count <= 0) return {
		columns: [],
		nextColumnIndex: startColumnIndex
	};
	const totalPreferredWidth = resolveMeasurementToPx(preferredWidthMeasurement, percentageBasis);
	const perColumnPreferredWidth = totalPreferredWidth != null && count > 0 ? Math.max(0, totalPreferredWidth / count) : void 0;
	const columns = [];
	let columnIndex = startColumnIndex;
	for (let index = 0; index < count; index++) {
		columnIndex = advancePastOccupiedColumns(activeRowSpans, columnIndex);
		columns.push({
			columnIndex,
			preferredWidth: perColumnPreferredWidth,
			minContentWidth: 0,
			maxContentWidth: 0
		});
		columnIndex += 1;
	}
	return {
		columns,
		nextColumnIndex: columnIndex
	};
}
function normalizeSkippedAfterCount(countValue, preferredWidthMeasurement, percentageBasis) {
	const count = sanitizeCount(countValue);
	if (count <= 0) return 0;
	const totalPreferredWidth = resolveMeasurementToPx(preferredWidthMeasurement, percentageBasis);
	if (totalPreferredWidth != null && totalPreferredWidth <= PLACEHOLDER_COLUMN_MAX_WIDTH * count) return 0;
	return count;
}
function normalizeCell(cell, percentageBasis, startColumn, logicalColumnLimit) {
	const cellProps = cell.attrs?.tableCellProperties ?? {};
	const rawSpan = sanitizeCount(cell.colSpan) || 1;
	const span = logicalColumnLimit != null && startColumn < logicalColumnLimit && startColumn + rawSpan > logicalColumnLimit ? Math.max(1, logicalColumnLimit - startColumn) : rawSpan;
	return {
		cellId: cell.id,
		startColumn,
		span,
		preferredWidth: resolveMeasurementToPx(cellProps.cellWidth, percentageBasis)
	};
}
function advancePastOccupiedColumns(activeRowSpans, columnIndex) {
	let nextColumnIndex = columnIndex;
	while ((activeRowSpans[nextColumnIndex] ?? 0) > 0) nextColumnIndex += 1;
	return nextColumnIndex;
}
function resolveOccupiedLogicalColumnCount(activeRowSpans) {
	for (let index = activeRowSpans.length - 1; index >= 0; index--) if ((activeRowSpans[index] ?? 0) > 0) return index + 1;
	return 0;
}
function advanceRowSpans(activeRowSpans) {
	return activeRowSpans.map((remainingRows) => Math.max(0, remainingRows - 1));
}
function markRowSpanOccupancy(activeRowSpans, startColumn, span, remainingRows) {
	const boundedSpan = Math.max(1, sanitizeCount(span));
	for (let offset$1 = 0; offset$1 < boundedSpan; offset$1++) {
		const columnIndex = startColumn + offset$1;
		activeRowSpans[columnIndex] = Math.max(activeRowSpans[columnIndex] ?? 0, remainingRows);
	}
}
function determineGridColumnCount(preferredColumnCount, rows) {
	return Math.max(preferredColumnCount, ...rows.map((row) => {
		if ("logicalColumnCount" in row && typeof row.logicalColumnCount === "number") return row.logicalColumnCount;
		const skippedBefore = row.skippedBefore?.length ?? 0;
		const skippedAfter = row.skippedAfter?.length ?? 0;
		const cellSpanTotal = (row.cells ?? []).reduce((sum, cell) => sum + Math.max(1, cell.span ?? 1), 0);
		return skippedBefore + skippedAfter + cellSpanTotal;
	}), 0);
}
function resolvePreferredTableWidth(tableWidth, maxWidth) {
	const resolvedWidth = resolveTableWidthAttr(tableWidth);
	if (!resolvedWidth) return void 0;
	if (resolvedWidth.type === "pct") return Math.round(maxWidth * (resolvedWidth.width / OOXML_PCT_DIVISOR));
	return resolvedWidth.width;
}
function resolveMeasurementToPx(measurement, percentageBasis) {
	if (!measurement || typeof measurement !== "object" || !Number.isFinite(measurement.value)) return;
	const value = measurement.value;
	switch ((measurement.type ?? "dxa").toLowerCase()) {
		case "dxa": return value / TWIPS_PER_PX$1;
		case "pct": return Math.round(percentageBasis * (value / OOXML_PCT_DIVISOR));
		case "px":
		case "pixel": return value;
		case "auto":
		case "nil": return;
		default: return value;
	}
}
function sanitizeCount(value) {
	if (typeof value !== "number" || !Number.isFinite(value)) return 0;
	return Math.max(0, Math.floor(value));
}
function sanitizePositiveNumber(value) {
	if (typeof value !== "number" || !Number.isFinite(value) || value <= 0) return 1;
	return value;
}
function sanitizeNonNegativeNumber(value) {
	if (typeof value !== "number" || !Number.isFinite(value) || value < 0) return void 0;
	return value;
}
function sumWidths(widths) {
	return widths.reduce((sum, width) => sum + Math.max(0, width), 0);
}
function approximatelyEqual(left$1, right$1) {
	return Math.abs(left$1 - right$1) <= .01;
}
function isSlightlyUnderPreferredTableWidth(totalColumnWidth, preferredTableWidth) {
	if (totalColumnWidth <= 0 || totalColumnWidth >= preferredTableWidth) return false;
	return preferredTableWidth - totalColumnWidth <= preferredTableWidth * .05;
}
var DEFAULT_CELL_PADDING$1 = {
	top: 0,
	right: 4,
	bottom: 0,
	left: 4
};
var DEFAULT_FIELD_ANNOTATION_FONT_SIZE$1 = 16;
var FIELD_ANNOTATION_PILL_PADDING$1 = 8;
var TABLE_CELL_METRICS_CACHE_SIZE = 2e3;
var TABLE_AUTOFIT_RESULT_CACHE_SIZE = 500;
var NO_WRAP_MAX_WIDTH = Number.MAX_SAFE_INTEGER;
var TOKEN_BOUNDARY_PATTERN = /[ \t\f\v\-\u00ad\u2010\u2012\u2013\u2014\u200b\u2028\u2029]+|\r\n|\r|\n|\u2028|\u2029/gu;
var LruCache = class {
	constructor(maxSize$1) {
		this.cache = /* @__PURE__ */ new Map();
		this.maxSize = maxSize$1;
	}
	get(key) {
		const hit = this.cache.get(key);
		if (!hit) return void 0;
		this.cache.delete(key);
		this.cache.set(key, hit);
		return hit.value;
	}
	set(key, value) {
		this.cache.set(key, { value });
		this.evictIfNeeded();
	}
	clear() {
		this.cache.clear();
	}
	resize(nextSize) {
		if (!Number.isFinite(nextSize) || nextSize <= 0) return;
		this.maxSize = nextSize;
		this.evictIfNeeded();
	}
	evictIfNeeded() {
		while (this.cache.size > this.maxSize) {
			const oldestKey = this.cache.keys().next().value;
			if (oldestKey === void 0) break;
			this.cache.delete(oldestKey);
		}
	}
};
var tableCellMetricsCache = new LruCache(TABLE_CELL_METRICS_CACHE_SIZE);
var autoFitTableResultCache = new LruCache(TABLE_AUTOFIT_RESULT_CACHE_SIZE);
var canvasContext$1 = null;
function clearTableAutoFitMeasurementCaches() {
	tableCellMetricsCache.clear();
	autoFitTableResultCache.clear();
}
function buildTableCellContentMetricsCacheKey(cell, options) {
	const fontContext = options.fontContext ?? DEFAULT_FONT_MEASURE_CONTEXT;
	return stableSerialize({
		maxWidth: Math.max(1, Math.round(options.maxWidth)),
		fontSignature: fontContext.fontSignature ?? "",
		layoutEpoch: options.layoutEpoch ?? null,
		attrs: cell.attrs ?? null,
		paragraph: cell.paragraph ?? null,
		blocks: cell.blocks ?? null
	});
}
function buildAutoFitTableResultCacheKey(table, options) {
	return stableSerialize({
		id: table.id,
		attrs: table.attrs ?? null,
		columnWidths: table.columnWidths ?? null,
		rowCount: table.rows.length,
		maxWidth: Math.max(1, Math.round(options.maxWidth)),
		fontSignature: options.fontSignature ?? "",
		layoutEpoch: options.layoutEpoch ?? null,
		cellMetricKeys: options.cellMetricKeys,
		workingGrid: {
			layoutMode: options.workingInput.layoutMode,
			gridColumnCount: options.workingInput.gridColumnCount,
			preserveAuthoredGrid: options.workingInput.preserveAuthoredGrid === true,
			preserveAutoGrid: options.workingInput.preserveAutoGrid === true,
			preserveExplicitAutoGrid: options.workingInput.preserveExplicitAutoGrid === true,
			autoGridWidthBudget: options.workingInput.autoGridWidthBudget ?? null,
			preferredTableWidth: options.workingInput.preferredTableWidth ?? null,
			preferredColumnWidths: options.workingInput.preferredColumnWidths,
			rows: options.workingInput.rows.map((row) => ({
				logicalColumnCount: row.logicalColumnCount,
				skippedColumns: (row.skippedColumns ?? []).map((column) => ({
					columnIndex: column.columnIndex,
					preferredWidth: column.preferredWidth ?? null
				})),
				cells: row.cells.map((cell) => ({
					startColumn: cell.startColumn,
					span: cell.span ?? 1,
					preferredWidth: cell.preferredWidth ?? null
				}))
			}))
		},
		fixedLayout: {
			columnWidths: options.fixedLayout.columnWidths,
			totalWidth: options.fixedLayout.totalWidth,
			gridColumnCount: options.fixedLayout.gridColumnCount,
			preferredTableWidth: options.fixedLayout.preferredTableWidth ?? null
		}
	});
}
function getCachedAutoFitTableResult(cacheKey) {
	return autoFitTableResultCache.get(cacheKey);
}
function setCachedAutoFitTableResult(cacheKey, result) {
	autoFitTableResultCache.set(cacheKey, result);
}
async function measureTableCellContentMetrics(cell, options) {
	const fontContext = options.fontContext ?? DEFAULT_FONT_MEASURE_CONTEXT;
	const normalizedOptions = {
		...options,
		fontContext
	};
	const cacheKey = buildTableCellContentMetricsCacheKey(cell, normalizedOptions);
	const cached = tableCellMetricsCache.get(cacheKey);
	if (cached) return cached;
	const horizontalInsets = getHorizontalCellInsets(cell);
	const contentBlocks = cell.blocks ?? (cell.paragraph ? [cell.paragraph] : []);
	if (contentBlocks.length === 0) {
		const emptyMetrics = {
			minWidthPx: horizontalInsets,
			maxWidthPx: horizontalInsets
		};
		tableCellMetricsCache.set(cacheKey, emptyMetrics);
		return emptyMetrics;
	}
	let minContentWidthPx = 0;
	let maxContentWidthPx = 0;
	for (const block of contentBlocks) {
		const metrics = await measureIntrinsicBlockWidthMetrics(block, normalizedOptions);
		minContentWidthPx = Math.max(minContentWidthPx, metrics.minWidthPx);
		maxContentWidthPx = Math.max(maxContentWidthPx, metrics.maxWidthPx);
	}
	const result = {
		minWidthPx: minContentWidthPx + horizontalInsets,
		maxWidthPx: maxContentWidthPx + horizontalInsets
	};
	tableCellMetricsCache.set(cacheKey, result);
	return result;
}
async function measureTableAutoFitContentMetrics(table, workingInput, fixedLayout, measureBlock$1, fontContext = DEFAULT_FONT_MEASURE_CONTEXT) {
	const tableMeasurementBasis = Math.max(1, fixedLayout.totalWidth);
	const cellMetricKeys = [];
	const rowMetrics = await Promise.all(table.rows.map(async (row, rowIndex) => {
		const normalizedRow = workingInput.rows[rowIndex] ?? {};
		return {
			rowIndex,
			cells: await Promise.all(row.cells.map(async (cell, cellIndex) => {
				const normalizedCell = normalizedRow.cells?.[cellIndex];
				const span = normalizedCell?.span ?? cell.colSpan ?? 1;
				const measurementMaxWidth = resolveAutoFitCellMeasurementMaxWidth(cell, normalizedCell, span, fixedLayout, tableMeasurementBasis, workingInput.gridColumnCount);
				cellMetricKeys.push(buildTableCellContentMetricsCacheKey(cell, {
					maxWidth: measurementMaxWidth,
					fontContext
				}));
				const metrics = await measureTableCellContentMetrics(cell, {
					maxWidth: measurementMaxWidth,
					measureBlock: measureBlock$1,
					fontContext
				});
				return {
					cellIndex,
					span,
					preferredWidth: normalizedCell?.preferredWidth,
					minContentWidth: metrics.minWidthPx,
					maxContentWidth: metrics.maxWidthPx
				};
			}))
		};
	}));
	return {
		rowMetrics,
		rows: rowMetrics.map((rowMetrics$1, rowIndex) => {
			const normalizedRow = workingInput.rows[rowIndex] ?? {};
			return {
				skippedBefore: normalizedRow.skippedBefore ?? [],
				cells: rowMetrics$1.cells.map((cellMetrics) => ({
					span: cellMetrics.span,
					preferredWidth: cellMetrics.preferredWidth,
					minContentWidth: cellMetrics.minContentWidth,
					maxContentWidth: cellMetrics.maxContentWidth
				})),
				skippedAfter: normalizedRow.skippedAfter ?? []
			};
		}),
		cellMetricKeys
	};
}
async function measureIntrinsicBlockWidthMetrics(block, options) {
	if (block.kind === "paragraph") return measureParagraphIntrinsicWidthMetrics(block, options.measureBlock, options.fontContext);
	if (block.kind === "table") return measureNestedTableIntrinsicWidthMetrics(block, options);
	const intrinsicWidth = getIntrinsicAtomicBlockWidth(block);
	return {
		minWidthPx: intrinsicWidth,
		maxWidthPx: intrinsicWidth
	};
}
async function measureParagraphIntrinsicWidthMetrics(paragraph, measureBlock$1, fontContext) {
	const maxLineWidth = (await measureBlock$1(paragraph, {
		maxWidth: NO_WRAP_MAX_WIDTH,
		maxHeight: Infinity
	})).lines.reduce((widest, line) => Math.max(widest, line.width), 0);
	return {
		minWidthPx: measureParagraphMinTokenWidth(paragraph, fontContext),
		maxWidthPx: maxLineWidth
	};
}
async function measureNestedTableIntrinsicWidthMetrics(table, options) {
	const nestedMeasure = await options.measureBlock(table, {
		maxWidth: Math.max(1, options.maxWidth),
		maxHeight: Infinity
	});
	if (nestedMeasure.kind !== "table") return {
		minWidthPx: 0,
		maxWidthPx: 0
	};
	return {
		minWidthPx: nestedMeasure.totalWidth,
		maxWidthPx: nestedMeasure.totalWidth
	};
}
function measureParagraphMinTokenWidth(paragraph, fontContext) {
	let widestToken = 0;
	let currentTokenWidth = 0;
	const flushToken = () => {
		widestToken = Math.max(widestToken, currentTokenWidth);
		currentTokenWidth = 0;
	};
	for (const run of paragraph.runs) {
		if (isExplicitLineBreakRun(run)) {
			flushToken();
			continue;
		}
		if (isTextLikeRun(run)) {
			accumulateTextRunMinTokenWidth(run, (width) => {
				currentTokenWidth += width;
			}, flushToken, fontContext);
			continue;
		}
		flushToken();
		if (run.kind === "image") {
			widestToken = Math.max(widestToken, run.width ?? 0);
			continue;
		}
		if (run.kind === "fieldAnnotation") {
			widestToken = Math.max(widestToken, measureFieldAnnotationWidth(run, fontContext));
			continue;
		}
		if (run.kind === "math") widestToken = Math.max(widestToken, run.width ?? 0);
	}
	flushToken();
	return widestToken;
}
function accumulateTextRunMinTokenWidth(run, appendTokenPiece, flushToken, fontContext) {
	const font = buildFontString$1(run, fontContext);
	let cursor = 0;
	for (const boundary of run.text.matchAll(TOKEN_BOUNDARY_PATTERN)) {
		const boundaryStart = boundary.index ?? cursor;
		if (boundaryStart > cursor) appendTokenPiece(measureTextRunTokenSlice(run, cursor, boundaryStart, font));
		flushToken();
		cursor = boundaryStart + boundary[0].length;
	}
	if (cursor < run.text.length) appendTokenPiece(measureTextRunTokenSlice(run, cursor, run.text.length, font));
}
function measureTextRunTokenSlice(run, start$1, end$1, font) {
	return getMeasuredTextWidth(applyTextTransform$1(run.text.slice(start$1, end$1), run, start$1), font, getLetterSpacing(run), getCanvasContext$1());
}
function getIntrinsicAtomicBlockWidth(block) {
	if (block.kind === "image") return block.width ?? 0;
	if (block.drawingKind === "image") return block.width ?? 0;
	if (block.drawingKind === "shapeGroup") return block.size?.width ?? block.geometry.width;
	return block.geometry.width;
}
function resolveAutoFitCellMeasurementMaxWidth(cell, normalizedCell, span, fixedLayout, tableWidthBasis, gridColumnCount) {
	const outerWidth = resolveFixedPassCellOuterWidth(normalizedCell, span, fixedLayout) ?? normalizedCell?.preferredWidth ?? Math.max(1, tableWidthBasis * (Math.max(1, span) / Math.max(1, gridColumnCount || span || 1)));
	const padding = cell.attrs?.padding ?? DEFAULT_CELL_PADDING$1;
	const leftPadding = padding.left ?? DEFAULT_CELL_PADDING$1.left;
	const rightPadding = padding.right ?? DEFAULT_CELL_PADDING$1.right;
	const leftBorder = getCellBorderWidthPx(cell.attrs?.borders?.left);
	const rightBorder = getCellBorderWidthPx(cell.attrs?.borders?.right);
	return Math.max(1, outerWidth - leftPadding - rightPadding - leftBorder - rightBorder);
}
function resolveFixedPassCellOuterWidth(normalizedCell, fallbackSpan, fixedLayout) {
	if (normalizedCell?.startColumn == null) return;
	const span = Math.max(1, normalizedCell.span ?? fallbackSpan);
	let width = 0;
	for (let offset$1 = 0; offset$1 < span; offset$1++) width += fixedLayout.columnWidths[normalizedCell.startColumn + offset$1] ?? 0;
	return width > 0 ? width : void 0;
}
function getHorizontalCellInsets(cell) {
	const padding = cell.attrs?.padding ?? DEFAULT_CELL_PADDING$1;
	const leftPadding = padding.left ?? DEFAULT_CELL_PADDING$1.left;
	const rightPadding = padding.right ?? DEFAULT_CELL_PADDING$1.right;
	const leftBorder = getCellBorderWidthPx(cell.attrs?.borders?.left);
	const rightBorder = getCellBorderWidthPx(cell.attrs?.borders?.right);
	return leftPadding + rightPadding + leftBorder + rightBorder;
}
function getCellBorderWidthPx(border) {
	if (!border || border.style === "none") return 0;
	const width = typeof border.width === "number" ? border.width : 0;
	if (border.style === "thick") return Math.max(width * 2, 3);
	return Math.max(0, width);
}
function getCanvasContext$1() {
	if (!canvasContext$1) {
		canvasContext$1 = document.createElement("canvas").getContext("2d");
		if (!canvasContext$1) throw new Error("Failed to create canvas context for AutoFit cell measurement.");
	}
	return canvasContext$1;
}
function buildFontString$1(run, fontContext) {
	const parts = [];
	if (run.italic) parts.push("italic");
	if (run.bold) parts.push("bold");
	parts.push(`${normalizeFontSize$1(run.fontSize)}px`);
	const face = {
		weight: run.bold ? "700" : "400",
		style: run.italic ? "italic" : "normal"
	};
	const physicalFamily = normalizeFontFamily$1(fontContext.resolvePhysical(normalizeFontFamily$1(run.fontFamily), face));
	parts.push(toCssFontFamily(physicalFamily) ?? physicalFamily);
	return parts.join(" ");
}
function applyTextTransform$1(text, run, startOffset = 0) {
	const transform = run.textTransform;
	if (!text || !transform || transform === "none") return text;
	if (transform === "uppercase") return text.toUpperCase();
	if (transform === "lowercase") return text.toLowerCase();
	if (transform === "capitalize") return capitalizeText$1(text, run.text ?? text, startOffset);
	return text;
}
function capitalizeText$1(text, fullText, startOffset) {
	let result = "";
	for (let index = 0; index < text.length; index++) {
		const absoluteIndex = startOffset + index;
		const currentChar = text[index];
		const previousChar = absoluteIndex > 0 ? fullText[absoluteIndex - 1] : "";
		result += isWordCharacter(currentChar) && !isWordCharacter(previousChar) ? currentChar.toUpperCase() : currentChar;
	}
	return result;
}
function measureFieldAnnotationWidth(run, fontContext) {
	const fontSize = typeof run.fontSize === "number" ? run.fontSize : typeof run.fontSize === "string" ? parseFloat(run.fontSize) || DEFAULT_FIELD_ANNOTATION_FONT_SIZE$1 : DEFAULT_FIELD_ANNOTATION_FONT_SIZE$1;
	const font = buildFontString$1({
		fontFamily: normalizeFontFamily$1(run.fontFamily ?? "Arial"),
		fontSize,
		bold: run.bold,
		italic: run.italic
	}, fontContext);
	return getMeasuredTextWidth(applyTextTransform$1(run.displayLabel || "", { text: run.displayLabel || "" }), font, 0, getCanvasContext$1()) + (run.highlighted === false ? 0 : FIELD_ANNOTATION_PILL_PADDING$1);
}
function isExplicitLineBreakRun(run) {
	return run.kind === "lineBreak" || run.kind === "break" && run.breakType === "line";
}
function isTextLikeRun(run) {
	return "text" in run && typeof run.text === "string";
}
function getLetterSpacing(run) {
	return "letterSpacing" in run && typeof run.letterSpacing === "number" ? run.letterSpacing : 0;
}
function normalizeFontSize$1(value) {
	if (typeof value === "number" && Number.isFinite(value) && value > 0) return value;
	if (typeof value === "string") {
		const parsed = parseFloat(value);
		if (Number.isFinite(parsed) && parsed > 0) return parsed;
	}
	return 12;
}
function normalizeFontFamily$1(value) {
	return typeof value === "string" && value.trim().length > 0 ? value : "Arial";
}
function stableSerialize(value) {
	if (value === null || typeof value !== "object") return JSON.stringify(value);
	if (Array.isArray(value)) return `[${value.map((item) => stableSerialize(item)).join(",")}]`;
	return `{${Object.entries(value).sort(([left$1], [right$1]) => left$1.localeCompare(right$1)).map(([key, entry]) => `${JSON.stringify(key)}:${stableSerialize(entry)}`).join(",")}}`;
}
function isWordCharacter(value) {
	return /[A-Za-z0-9]/.test(value);
}
function clearTextMeasurementCaches() {
	clearMeasurementCache();
	clearFontMetricsCache();
	clearTableAutoFitMeasurementCaches();
	canvasContext = null;
}
var { computeTabStops } = engines_exports;
var measurementConfig = {
	mode: "browser",
	fonts: {
		deterministicFamily: "Noto Sans",
		fallbackStack: [
			"Noto Sans",
			"Arial",
			"sans-serif"
		]
	},
	cacheSize: 5e3
};
var canvasContext = null;
var DEFAULT_TAB_INTERVAL_TWIPS = 720;
var TWIPS_PER_PX = 1440 / 96;
var twipsToPx = (twips) => twips / TWIPS_PER_PX;
var pxToTwips = (px) => Math.round(px * TWIPS_PER_PX);
function getTableBorderWidthPx(value) {
	if (value == null) return 0;
	if (typeof value === "object" && "none" in value && value.none) return 0;
	const raw = value;
	const w = typeof raw.width === "number" ? raw.width : typeof raw.size === "number" ? raw.size : 1;
	const width = Math.max(0, w);
	if (raw.style === "none") return 0;
	if (raw.style === "thick") return Math.max(width * 2, 3);
	return width;
}
function getTableBorderWidths(borders) {
	return {
		top: getTableBorderWidthPx(borders?.top),
		right: getTableBorderWidthPx(borders?.right),
		bottom: getTableBorderWidthPx(borders?.bottom),
		left: getTableBorderWidthPx(borders?.left)
	};
}
var DEFAULT_TAB_INTERVAL_PX = twipsToPx(DEFAULT_TAB_INTERVAL_TWIPS);
var TAB_EPSILON = .1;
var DEFAULT_CELL_PADDING = {
	top: 0,
	left: 4,
	right: 4,
	bottom: 0
};
var DEFAULT_DECIMAL_SEPARATOR = ".";
var ALLOWED_TAB_VALS = new Set([
	"start",
	"center",
	"end",
	"decimal",
	"bar",
	"clear"
]);
var FIELD_ANNOTATION_PILL_PADDING = 8;
var FIELD_ANNOTATION_LINE_HEIGHT_MULTIPLIER = 1.2;
var FIELD_ANNOTATION_VERTICAL_PADDING = 6;
var DEFAULT_FIELD_ANNOTATION_FONT_SIZE = 16;
var DEFAULT_PARAGRAPH_FONT_SIZE = 12;
var DEFAULT_PARAGRAPH_FONT_FAMILY = "Arial";
var isValidFontSize = (value) => typeof value === "number" && Number.isFinite(value) && value > 0;
var normalizeFontSize = (value, fallback = DEFAULT_PARAGRAPH_FONT_SIZE) => {
	if (isValidFontSize(value)) return value;
	if (typeof value === "string") {
		const parsed = parseFloat(value);
		if (isValidFontSize(parsed)) return parsed;
	}
	return fallback;
};
var normalizeFontFamily = (value, fallback = DEFAULT_PARAGRAPH_FONT_FAMILY) => typeof value === "string" && value.trim().length > 0 ? value : fallback;
var roundValue = (value) => measurementConfig.mode === "deterministic" ? Math.round(value * 10) / 10 : value;
function getCanvasContext() {
	if (!canvasContext) {
		const canvas$1 = typeof document !== "undefined" ? document.createElement("canvas") : null;
		if (!canvas$1) throw new Error("Canvas not available. Ensure this runs in a DOM environment (browser or jsdom).");
		canvasContext = canvas$1.getContext("2d");
		if (!canvasContext) throw new Error("Failed to get 2D context from canvas");
	}
	return canvasContext;
}
function faceOf(run) {
	return {
		weight: run.bold ? "700" : "400",
		style: run.italic ? "italic" : "normal"
	};
}
function buildFontString(run, fontContext) {
	const parts = [];
	if (run.italic) parts.push("italic");
	if (run.bold) parts.push("bold");
	parts.push(`${run.fontSize}px`);
	const physicalFamily = fontContext.resolvePhysical(run.fontFamily, faceOf(run));
	if (measurementConfig.mode === "deterministic") parts.push(measurementConfig.fonts.fallbackStack.length > 0 ? measurementConfig.fonts.fallbackStack.join(", ") : measurementConfig.fonts.deterministicFamily);
	else parts.push(physicalFamily);
	return {
		font: parts.join(" "),
		fontFamily: physicalFamily
	};
}
function measureText(text, font, ctx$1, _fontFamily, _letterSpacing) {
	ctx$1.font = font;
	const metrics = ctx$1.measureText(text);
	const advanceWidth = metrics.width;
	const paintedWidth = (metrics.actualBoundingBoxLeft || 0) + (metrics.actualBoundingBoxRight || 0);
	return Math.max(advanceWidth, paintedWidth);
}
var WORD_SINGLE_LINE_SPACING_MULTIPLIER = 1.15;
function calculateTypographyMetrics(fontSize, spacing, fontInfo) {
	const resolvedFontSize = normalizeFontSize(fontSize);
	let ascent;
	let descent;
	if (fontInfo && isValidFontSize(fontInfo.fontSize) && typeof fontInfo.fontFamily === "string" && fontInfo.fontFamily.trim().length > 0) {
		const metrics = getFontMetrics(getCanvasContext(), fontInfo, measurementConfig.mode, measurementConfig.fonts);
		ascent = roundValue(metrics.ascent);
		descent = roundValue(metrics.descent);
	} else {
		ascent = roundValue(resolvedFontSize * .8);
		descent = roundValue(resolvedFontSize * .2);
	}
	const lineHeight = resolveLineHeight(spacing, fontSize, ascent + descent);
	return {
		ascent,
		descent,
		lineHeight
	};
}
function finalizeLineMetrics(line, spacing) {
	const metrics = calculateTypographyMetrics(line.maxFontSize, spacing, line.maxFontInfo);
	const imageH = line.maxImageHeight ?? 0;
	if (imageH > metrics.lineHeight) metrics.lineHeight = imageH;
	return metrics;
}
function calculateEmptyParagraphMetrics(fontSize, spacing, fontInfo) {
	const resolvedFontSize = normalizeFontSize(fontSize);
	let ascent;
	let descent;
	if (fontInfo && isValidFontSize(fontInfo.fontSize) && typeof fontInfo.fontFamily === "string" && fontInfo.fontFamily.trim().length > 0) {
		const metrics = getFontMetrics(getCanvasContext(), fontInfo, measurementConfig.mode, measurementConfig.fonts);
		ascent = roundValue(metrics.ascent);
		descent = roundValue(metrics.descent);
	} else {
		ascent = roundValue(resolvedFontSize * .8);
		descent = roundValue(resolvedFontSize * .2);
	}
	const lineHeight = roundValue(resolveLineHeight(spacing, resolvedFontSize, Math.max(resolvedFontSize, ascent + descent)));
	return {
		ascent,
		descent,
		lineHeight
	};
}
function lineHeightFontSize(run) {
	return resolveBaseFontSizeForVerticalText(run.fontSize, run);
}
function getFontInfoFromRun(run, fontContext) {
	return {
		fontFamily: normalizeFontFamily(fontContext.resolvePhysical(run.fontFamily, faceOf(run))),
		fontSize: normalizeFontSize(lineHeightFontSize(run)),
		bold: run.bold,
		italic: run.italic
	};
}
function updateMaxFontInfo(currentMaxSize, currentMaxInfo, newRun, fontContext) {
	if (lineHeightFontSize(newRun) >= currentMaxSize) return getFontInfoFromRun(newRun, fontContext);
	return currentMaxInfo;
}
function isTextRun$2(run) {
	return run.kind === "text" || run.kind === void 0;
}
function isTabRun(run) {
	return run.kind === "tab";
}
function isImageRun(run) {
	return run.kind === "image";
}
function isLineBreakRun(run) {
	return run.kind === "lineBreak";
}
var isEmptyTextRun = (run) => {
	if (run.kind && run.kind !== "text") return false;
	return typeof run.text === "string" && run.text.length === 0;
};
function isFieldAnnotationRun(run) {
	return run.kind === "fieldAnnotation";
}
var normalizeRunsForMeasurement = (runs, fallbackFontSize, fallbackFontFamily) => runs.map((run) => {
	if (run.kind && run.kind !== "text") return run;
	if (!("text" in run)) return run;
	const textRun = run;
	const fontSize = normalizeFontSize(textRun.fontSize, fallbackFontSize);
	const fontFamily = normalizeFontFamily(textRun.fontFamily, fallbackFontFamily);
	if (fontSize === textRun.fontSize && fontFamily === textRun.fontFamily) return run;
	return {
		...textRun,
		fontSize,
		fontFamily
	};
});
function measureTabAlignmentGroup(startRunIndex, runs, ctx$1, decimalSeparator = ".", fontContext) {
	const result = {
		totalWidth: 0,
		runs: [],
		endRunIndex: runs.length
	};
	let foundDecimal = false;
	for (let i = startRunIndex; i < runs.length; i++) {
		const run = runs[i];
		if (isTabRun(run)) {
			result.endRunIndex = i;
			break;
		}
		if (isLineBreakRun(run) || run.kind === "break" && run.breakType === "line") {
			result.endRunIndex = i;
			break;
		}
		if (run.kind === "text" || run.kind === void 0) {
			const textRun = run;
			const text = textRun.text || "";
			if (text.length > 0) {
				const { font } = buildFontString(textRun, fontContext);
				const width = measureRunWidth(text, font, ctx$1, textRun, 0);
				let beforeDecimalWidth;
				if (!foundDecimal) {
					const decimalIdx = text.indexOf(decimalSeparator);
					if (decimalIdx >= 0) {
						foundDecimal = true;
						const beforeText = text.slice(0, decimalIdx);
						beforeDecimalWidth = beforeText.length > 0 ? measureRunWidth(beforeText, font, ctx$1, textRun, 0) : 0;
						result.beforeDecimalWidth = result.totalWidth + beforeDecimalWidth;
					}
				}
				result.runs.push({
					runIndex: i,
					width,
					text,
					beforeDecimalWidth
				});
				result.totalWidth += width;
			} else result.runs.push({
				runIndex: i,
				width: 0,
				text: ""
			});
			continue;
		}
		if (isImageRun(run)) {
			const leftSpace = run.distLeft ?? 0;
			const rightSpace = run.distRight ?? 0;
			const imageWidth = run.width + leftSpace + rightSpace;
			result.runs.push({
				runIndex: i,
				width: imageWidth
			});
			result.totalWidth += imageWidth;
			continue;
		}
		if (run.kind === "math") {
			const mathWidth = run.width ?? 20;
			result.runs.push({
				runIndex: i,
				width: mathWidth
			});
			result.totalWidth += mathWidth;
			continue;
		}
		if (isFieldAnnotationRun(run)) {
			const fontSize = run.fontSize ?? DEFAULT_FIELD_ANNOTATION_FONT_SIZE;
			const { font } = buildFontString({
				fontFamily: run.fontFamily ?? "Arial",
				fontSize,
				bold: run.bold,
				italic: run.italic
			}, fontContext);
			const pillWidth = (run.displayLabel ? measureRunWidth(run.displayLabel, font, ctx$1, run, 0) : 0) + FIELD_ANNOTATION_PILL_PADDING;
			result.runs.push({
				runIndex: i,
				width: pillWidth
			});
			result.totalWidth += pillWidth;
			continue;
		}
		result.runs.push({
			runIndex: i,
			width: 0
		});
	}
	return result;
}
async function measureBlock(block, constraints, fontContext = DEFAULT_FONT_MEASURE_CONTEXT) {
	const normalized = normalizeConstraints(constraints);
	if (block.kind === "drawing") return measureDrawingBlock(block, normalized);
	if (block.kind === "image") return measureImageBlock(block, normalized);
	if (block.kind === "list") return measureListBlock(block, normalized, fontContext);
	if (block.kind === "table") return measureTableBlock(block, normalized, fontContext);
	if (block.kind === "sectionBreak") return { kind: "sectionBreak" };
	if (block.kind === "pageBreak") return { kind: "pageBreak" };
	if (block.kind === "columnBreak") return { kind: "columnBreak" };
	return measureParagraphBlock(block, normalized.maxWidth, fontContext);
}
async function measureParagraphBlock(block, maxWidth, fontContext) {
	const ctx$1 = getCanvasContext();
	const wordLayout = block.attrs?.wordLayout;
	const firstTextRunWithSize = block.runs.find((run) => isTextRun$2(run) && "fontSize" in run && run.fontSize != null);
	const fallbackFontSize = normalizeFontSize((firstTextRunWithSize ?? block.runs.find((run) => typeof run.fontSize === "number" && run.fontSize > 0))?.fontSize, DEFAULT_PARAGRAPH_FONT_SIZE);
	const fallbackFontFamily = (block.runs.find((run) => isTextRun$2(run) && typeof run.fontFamily === "string" && run.fontFamily.trim().length > 0) ?? block.runs.find((run) => typeof run.fontFamily === "string" && run.fontFamily.trim().length > 0))?.fontFamily ?? DEFAULT_PARAGRAPH_FONT_FAMILY;
	const normalizedRuns = normalizeRunsForMeasurement(block.runs, fallbackFontSize, fallbackFontFamily);
	const markerInfo = wordLayout?.marker ? (() => {
		const { font: markerFont } = buildFontString({
			fontFamily: toCssFontFamily(wordLayout.marker.run.fontFamily) ?? wordLayout.marker.run.fontFamily,
			fontSize: wordLayout.marker.run.fontSize ?? fallbackFontSize,
			bold: wordLayout.marker.run.bold,
			italic: wordLayout.marker.run.italic
		}, fontContext);
		const markerText = wordLayout.marker.markerText ?? "";
		const glyphWidth = markerText ? measureText(markerText, markerFont, ctx$1) : 0;
		const gutter = typeof wordLayout.marker.gutterWidthPx === "number" && isFinite(wordLayout.marker.gutterWidthPx) && wordLayout.marker.gutterWidthPx >= 0 ? wordLayout.marker.gutterWidthPx : 8;
		return {
			markerWidth: Math.max(0, glyphWidth + 8),
			markerTextWidth: glyphWidth,
			indentLeft: wordLayout.indentLeftPx ?? 0,
			gutterWidth: gutter
		};
	})() : void 0;
	const WIDTH_FUDGE_PX$1 = .5;
	const lines = [];
	const indent = block.attrs?.indent;
	const spacing = block.attrs?.spacing;
	const indentLeft = sanitizeIndent(indent?.left);
	const indentRight = sanitizeIndent(indent?.right);
	const firstLine = indent?.firstLine ?? 0;
	const hanging = indent?.hanging ?? 0;
	const isWordLayoutList = Boolean(wordLayout?.marker);
	const rawFirstLineOffset = block.attrs?.suppressFirstLineIndent === true ? 0 : firstLine - hanging;
	const firstLineOffset = isWordLayoutList ? 0 : !isWordLayoutList && !(indentLeft < 0) && rawFirstLineOffset < 0 ? rawFirstLineOffset : Math.max(0, rawFirstLineOffset);
	const contentWidth = Math.max(1, maxWidth - indentLeft - indentRight);
	const bodyContentWidth = contentWidth;
	let initialAvailableWidth;
	const rawTextStartPx = wordLayout?.textStartPx;
	const textStartPx = typeof rawTextStartPx === "number" && Number.isFinite(rawTextStartPx) ? rawTextStartPx : void 0;
	const effectiveTextStartPx = resolveListTextStartPx(wordLayout, indentLeft, firstLine, hanging, (markerText, marker) => {
		const { font: markerFont } = buildFontString({
			fontFamily: toCssFontFamily(marker.run?.fontFamily) ?? marker.run?.fontFamily ?? "Arial",
			fontSize: marker.run?.fontSize ?? fallbackFontSize,
			bold: marker.run?.bold ?? false,
			italic: marker.run?.italic ?? false
		}, fontContext);
		return measureText(markerText, markerFont, ctx$1);
	}) ?? textStartPx;
	if (typeof effectiveTextStartPx === "number" && effectiveTextStartPx > indentLeft) initialAvailableWidth = Math.max(1, maxWidth - effectiveTextStartPx - indentRight);
	else initialAvailableWidth = Math.max(1, contentWidth - firstLineOffset);
	const tabStops = buildTabStopsPx(indent, block.attrs?.tabs, block.attrs?.tabIntervalTwips);
	const alignmentTabStopsPx = tabStops.map((stop, index) => ({
		stop,
		index
	})).filter(({ stop }) => stop.val === "end" || stop.val === "center" || stop.val === "decimal");
	const decimalSeparator = sanitizeDecimalSeparator(block.attrs?.decimalSeparator);
	const barTabStops = tabStops.filter((stop) => stop.val === "bar");
	const addBarTabsToLine = (line) => {
		if (barTabStops.length > 0) line.bars = barTabStops.map((stop) => ({ x: stop.pos }));
	};
	const dropCapDescriptor = block.attrs?.dropCapDescriptor;
	let dropCapMeasure = null;
	if (dropCapDescriptor) if (!dropCapDescriptor.run || !dropCapDescriptor.run.text || !dropCapDescriptor.lines) console.warn("Invalid drop cap descriptor - missing required fields:", dropCapDescriptor);
	else {
		const dropCapMeasured = measureDropCap(ctx$1, dropCapDescriptor, spacing, fontContext);
		dropCapMeasure = dropCapMeasured;
		dropCapDescriptor.measuredWidth = dropCapMeasured.width;
		dropCapDescriptor.measuredHeight = dropCapMeasured.height;
	}
	const emptyParagraphRun = normalizedRuns.length === 1 && isEmptyTextRun(normalizedRuns[0]) && !isEmptySdtPlaceholderRun(normalizedRuns[0]) ? normalizedRuns[0] : null;
	if (emptyParagraphRun) {
		const metrics = calculateEmptyParagraphMetrics(emptyParagraphRun.fontSize ?? DEFAULT_PARAGRAPH_FONT_SIZE, spacing, getFontInfoFromRun(emptyParagraphRun, fontContext));
		const emptyLine = {
			fromRun: 0,
			fromChar: 0,
			toRun: 0,
			toChar: 0,
			width: 0,
			...metrics
		};
		addBarTabsToLine(emptyLine);
		lines.push(emptyLine);
		return {
			kind: "paragraph",
			lines,
			totalHeight: metrics.lineHeight,
			...markerInfo ? { marker: markerInfo } : {}
		};
	}
	if (normalizedRuns.length === 0) {
		const metrics = calculateEmptyParagraphMetrics(DEFAULT_PARAGRAPH_FONT_SIZE, spacing);
		const emptyLine = {
			fromRun: 0,
			fromChar: 0,
			toRun: 0,
			toChar: 0,
			width: 0,
			...metrics
		};
		addBarTabsToLine(emptyLine);
		lines.push(emptyLine);
		return {
			kind: "paragraph",
			lines,
			totalHeight: metrics.lineHeight,
			...markerInfo ? { marker: markerInfo } : {}
		};
	}
	const fallbackFontInfo = firstTextRunWithSize ? getFontInfoFromRun(firstTextRunWithSize, fontContext) : void 0;
	let currentLine = null;
	const getEffectiveWidth = (baseWidth) => {
		if (dropCapMeasure && lines.length < dropCapMeasure.lines && dropCapMeasure.mode === "drop") return Math.max(1, baseWidth - dropCapMeasure.width);
		return baseWidth;
	};
	let lastFontSize = fallbackFontSize;
	let hasSeenTextRun = false;
	let tabStopCursor = 0;
	let pendingTabAlignment = null;
	let pendingSegmentPrecedingTabEndX;
	let pendingLeader = null;
	let pendingRunSpacing = 0;
	let lastAppliedTabAlign = null;
	const warnedTabVals = /* @__PURE__ */ new Set();
	let activeTabGroup = null;
	const validateTabStopVal = (stop) => {
		if (!ALLOWED_TAB_VALS.has(stop.val) && !warnedTabVals.has(stop.val)) {
			warnedTabVals.add(stop.val);
			return false;
		}
		return true;
	};
	const resolveBoundarySpacing = (lineWidth, isRunStart, run) => {
		if (lineWidth <= 0) return 0;
		return isRunStart ? pendingRunSpacing : run.letterSpacing ?? 0;
	};
	const alignPendingTabForWidth = (segmentWidth, beforeDecimalWidth) => {
		if (!pendingTabAlignment || !currentLine) return void 0;
		if (segmentWidth < 0) segmentWidth = 0;
		const { target, val, compensateNegativeLeft } = pendingTabAlignment;
		let startX = currentLine.width;
		if (val === "decimal") {
			const beforeWidth = beforeDecimalWidth ?? 0;
			startX = Math.max(0, target - beforeWidth);
		} else if (val === "end") startX = Math.max(0, target - segmentWidth);
		else if (val === "center") startX = Math.max(0, target - segmentWidth / 2);
		else startX = Math.max(0, target);
		const effectiveIndent = lines.length === 0 ? indentLeft + rawFirstLineOffset : indentLeft;
		if (pendingLeader) pendingLeader.to = startX + effectiveIndent;
		currentLine.width = roundValue(startX);
		lastAppliedTabAlign = {
			target,
			val
		};
		pendingTabAlignment = null;
		pendingLeader = null;
		const shouldCompensateNegativeLeft = compensateNegativeLeft === true;
		pendingSegmentPrecedingTabEndX = shouldCompensateNegativeLeft ? startX : void 0;
		return shouldCompensateNegativeLeft ? startX - Math.min(effectiveIndent, 0) : startX;
	};
	const consumePendingPrecedingTabEndX = () => {
		const value = pendingSegmentPrecedingTabEndX;
		pendingSegmentPrecedingTabEndX = void 0;
		return value;
	};
	const clearPendingPrecedingTabEndX = () => {
		pendingSegmentPrecedingTabEndX = void 0;
	};
	const alignSegmentAtTab = (segmentText, font, runContext, segmentStartChar) => {
		if (!pendingTabAlignment || !currentLine) return void 0;
		const { val } = pendingTabAlignment;
		let segmentWidth = 0;
		let beforeDecimalWidth;
		if (val === "decimal") {
			const idx = segmentText.indexOf(decimalSeparator);
			if (idx >= 0) {
				const beforeText = segmentText.slice(0, idx);
				beforeDecimalWidth = beforeText.length > 0 ? measureRunWidth(beforeText, font, ctx$1, runContext, segmentStartChar) : 0;
			}
			segmentWidth = segmentText.length > 0 ? measureRunWidth(segmentText, font, ctx$1, runContext, segmentStartChar) : 0;
		} else if (val === "end" || val === "center") segmentWidth = segmentText.length > 0 ? measureRunWidth(segmentText, font, ctx$1, runContext, segmentStartChar) : 0;
		return alignPendingTabForWidth(segmentWidth, beforeDecimalWidth);
	};
	let runsToProcess = [];
	for (const run of normalizedRuns) if (run.text && typeof run.text === "string" && run.text.includes("\n")) {
		const textRun = run;
		const segments = textRun.text.split("\n");
		let cursor = textRun.pmStart ?? 0;
		segments.forEach((seg, idx) => {
			runsToProcess.push({
				...textRun,
				text: seg,
				pmStart: cursor,
				pmEnd: cursor + seg.length
			});
			cursor += seg.length;
			if (idx !== segments.length - 1) {
				runsToProcess.push({
					kind: "break",
					breakType: "line",
					pmStart: cursor,
					pmEnd: cursor + 1,
					sdt: run.sdt
				});
				cursor += 1;
			}
		});
	} else runsToProcess.push(run);
	if (runsToProcess.some((run) => isTextRun$2(run) && typeof run.text === "string" && run.text.includes("	"))) {
		const expandedRuns = [];
		for (const run of runsToProcess) {
			if (!isTextRun$2(run) || typeof run.text !== "string" || !run.text.includes("	")) {
				expandedRuns.push(run);
				continue;
			}
			const textRun = run;
			let buffer = "";
			let cursor = textRun.pmStart ?? 0;
			const text = textRun.text;
			for (let i = 0; i < text.length; i += 1) {
				const char = text[i];
				if (char === "	") {
					if (buffer.length > 0) {
						expandedRuns.push({
							...textRun,
							text: buffer,
							pmStart: cursor - buffer.length,
							pmEnd: cursor
						});
						buffer = "";
					}
					const tabRun = {
						kind: "tab",
						text: "	",
						pmStart: cursor,
						pmEnd: cursor + 1,
						tabStops: block.attrs?.tabs,
						indent,
						leader: textRun?.leader ?? null,
						sdt: textRun.sdt
					};
					expandedRuns.push(tabRun);
					cursor += 1;
					continue;
				}
				buffer += char;
				cursor += 1;
			}
			if (buffer.length > 0) expandedRuns.push({
				...textRun,
				text: buffer,
				pmStart: cursor - buffer.length,
				pmEnd: cursor
			});
		}
		runsToProcess = expandedRuns;
	}
	const totalTabRuns = runsToProcess.reduce((count, run) => isTabRun(run) ? count + 1 : count, 0);
	const trimTrailingWrapSpaces = (lineToTrim) => {
		const lastRun = runsToProcess[lineToTrim.toRun];
		if (!lastRun || !("text" in lastRun) || typeof lastRun.text !== "string") return;
		const sliceStart = lineToTrim.toRun === lineToTrim.fromRun ? lineToTrim.fromChar : 0;
		const sliceEnd = lineToTrim.toChar;
		if (sliceEnd <= sliceStart) return;
		const sliceText = lastRun.text.slice(sliceStart, sliceEnd);
		let trimCount = 0;
		for (let i = sliceText.length - 1; i >= 0 && sliceText[i] === " "; i -= 1) trimCount += 1;
		if (trimCount === 0) return;
		if (lineToTrim.fromRun === lineToTrim.toRun && sliceText.trim().length === 0) return;
		const keptText = sliceText.slice(0, Math.max(0, sliceText.length - trimCount));
		const { font } = buildFontString(lastRun, fontContext);
		const fullWidth = measureRunWidth(sliceText, font, ctx$1, lastRun, sliceStart);
		const keptWidth = keptText.length > 0 ? measureRunWidth(keptText, font, ctx$1, lastRun, sliceStart) : 0;
		const delta = Math.max(0, fullWidth - keptWidth);
		lineToTrim.width = roundValue(Math.max(0, lineToTrim.width - delta));
		lineToTrim.spaceCount = Math.max(0, lineToTrim.spaceCount - trimCount);
		if (lineToTrim.naturalWidth != null && typeof lineToTrim.naturalWidth === "number") lineToTrim.naturalWidth = roundValue(Math.max(0, lineToTrim.naturalWidth - delta));
	};
	const tabSegmentInfo = /* @__PURE__ */ new Map();
	{
		let segmentTabRunIndices = [];
		const closeSegment = () => {
			const total = segmentTabRunIndices.length;
			segmentTabRunIndices.forEach((runIdx, ord) => {
				tabSegmentInfo.set(runIdx, {
					localOrdinal: ord,
					segmentTotal: total
				});
			});
			segmentTabRunIndices = [];
		};
		for (let i = 0; i < runsToProcess.length; i++) {
			const r$1 = runsToProcess[i];
			if (isLineBreakRun(r$1) || r$1.kind === "break" && r$1.breakType === "line") closeSegment();
			else if (isTabRun(r$1)) segmentTabRunIndices.push(i);
		}
		closeSegment();
	}
	const getAlignmentStopForOrdinal = (ordinal, runIdx) => {
		if (alignmentTabStopsPx.length === 0 || totalTabRuns === 0 || !Number.isFinite(ordinal)) return null;
		let scopeOrdinal = ordinal;
		let scopeTotal = totalTabRuns;
		if (runIdx !== void 0) {
			const info = tabSegmentInfo.get(runIdx);
			if (info) {
				scopeOrdinal = info.localOrdinal;
				scopeTotal = info.segmentTotal;
			}
		}
		if (scopeOrdinal < 0 || scopeOrdinal >= scopeTotal) return null;
		const remainingTabs = scopeTotal - scopeOrdinal - 1;
		const targetIndex = alignmentTabStopsPx.length - 1 - remainingTabs;
		if (targetIndex < 0 || targetIndex >= alignmentTabStopsPx.length) return null;
		return alignmentTabStopsPx[targetIndex];
	};
	let sequentialTabIndex = 0;
	for (let runIndex = 0; runIndex < runsToProcess.length; runIndex++) {
		const run = runsToProcess[runIndex];
		if (run.kind === "break") {
			if (currentLine) {
				const metrics = finalizeLineMetrics(currentLine, spacing);
				const completedLine = {
					...currentLine,
					...metrics
				};
				addBarTabsToLine(completedLine);
				lines.push(completedLine);
				currentLine = null;
			} else {
				const metrics = calculateTypographyMetrics(fallbackFontSize, spacing, fallbackFontInfo);
				const emptyLine = {
					fromRun: runIndex,
					fromChar: 0,
					toRun: runIndex,
					toChar: 0,
					width: 0,
					segments: [],
					...metrics
				};
				addBarTabsToLine(emptyLine);
				lines.push(emptyLine);
			}
			tabStopCursor = 0;
			pendingTabAlignment = null;
			pendingLeader = null;
			lastAppliedTabAlign = null;
			pendingRunSpacing = 0;
			continue;
		}
		if (isLineBreakRun(run)) {
			const lineBreakFontInfo = hasSeenTextRun ? void 0 : fallbackFontInfo;
			if (currentLine) {
				const metrics = finalizeLineMetrics(currentLine, spacing);
				const completedLine = {
					...currentLine,
					...metrics
				};
				addBarTabsToLine(completedLine);
				lines.push(completedLine);
			} else {
				const metrics = calculateTypographyMetrics(lastFontSize, spacing, lineBreakFontInfo);
				const emptyLine = {
					fromRun: runIndex,
					fromChar: 0,
					toRun: runIndex,
					toChar: 0,
					width: 0,
					maxWidth: getEffectiveWidth(lines.length === 0 ? initialAvailableWidth : bodyContentWidth),
					segments: [],
					...metrics
				};
				addBarTabsToLine(emptyLine);
				lines.push(emptyLine);
			}
			const nextLineMaxWidth = lines.length > 0 ? getEffectiveWidth(bodyContentWidth) : getEffectiveWidth(initialAvailableWidth);
			currentLine = {
				fromRun: runIndex,
				fromChar: 0,
				toRun: runIndex,
				toChar: 0,
				width: 0,
				maxFontSize: lastFontSize,
				maxFontInfo: lineBreakFontInfo,
				maxWidth: nextLineMaxWidth,
				segments: [],
				spaceCount: 0,
				isLineBreakPlaceholder: true
			};
			tabStopCursor = 0;
			pendingTabAlignment = null;
			pendingLeader = null;
			lastAppliedTabAlign = null;
			pendingRunSpacing = 0;
			continue;
		}
		if (currentLine?.isLineBreakPlaceholder) {
			currentLine.fromRun = runIndex;
			currentLine.toRun = runIndex;
			currentLine.isLineBreakPlaceholder = false;
		}
		if (isTabRun(run)) {
			activeTabGroup = null;
			pendingLeader = null;
			if (!currentLine) currentLine = {
				fromRun: runIndex,
				fromChar: 0,
				toRun: runIndex,
				toChar: 1,
				width: 0,
				maxFontSize: lastFontSize,
				maxFontInfo: hasSeenTextRun ? void 0 : fallbackFontInfo ?? getFontInfoFromRun(run, fontContext),
				maxWidth: getEffectiveWidth(lines.length === 0 ? initialAvailableWidth : bodyContentWidth),
				segments: [],
				spaceCount: 0
			};
			const originX = currentLine.width;
			const effectiveIndent = lines.length === 0 ? indentLeft + rawFirstLineOffset : indentLeft;
			const absCurrentX = currentLine.width + effectiveIndent;
			let stop;
			let target;
			const resolvedTabIndex = typeof run.tabIndex === "number" && Number.isFinite(run.tabIndex) ? run.tabIndex : sequentialTabIndex;
			sequentialTabIndex = Math.max(sequentialTabIndex, resolvedTabIndex + 1);
			const greedy = getNextTabStopPx(absCurrentX, tabStops, tabStopCursor);
			const forcedAlignment = greedy.stop?.source === "default" ? getAlignmentStopForOrdinal(resolvedTabIndex, runIndex) : null;
			if (forcedAlignment && forcedAlignment.stop.pos > absCurrentX + TAB_EPSILON) {
				stop = forcedAlignment.stop;
				target = forcedAlignment.stop.pos;
				tabStopCursor = forcedAlignment.index + 1;
			} else {
				target = greedy.target;
				tabStopCursor = greedy.nextIndex;
				stop = greedy.stop;
			}
			const maxAbsWidth = currentLine.maxWidth + effectiveIndent;
			const clampedTarget = Math.min(target, maxAbsWidth);
			const tabAdvance = Math.max(0, clampedTarget - absCurrentX);
			currentLine.width = roundValue(currentLine.width + tabAdvance);
			if (stop?.source === "explicit") currentLine.hasExplicitTabStops = true;
			run.width = tabAdvance;
			currentLine.maxFontSize = Math.max(currentLine.maxFontSize, lastFontSize);
			currentLine.toRun = runIndex;
			currentLine.toChar = 1;
			let currentLeader = null;
			if (stop && stop.leader && stop.leader !== "none") {
				const leaderStyle = stop.leader;
				const from$1 = Math.min(originX + effectiveIndent, clampedTarget);
				const to = Math.max(originX + effectiveIndent, clampedTarget);
				if (!currentLine.leaders) currentLine.leaders = [];
				currentLeader = {
					from: from$1,
					to,
					style: leaderStyle
				};
				currentLine.leaders.push(currentLeader);
			}
			if (stop) {
				validateTabStopVal(stop);
				if (stop.val === "end" || stop.val === "center" || stop.val === "decimal") {
					const groupMeasure = measureTabAlignmentGroup(runIndex + 1, runsToProcess, ctx$1, decimalSeparator, fontContext);
					if (groupMeasure.totalWidth > 0) {
						const relativeTarget = clampedTarget - effectiveIndent;
						let groupStartX;
						if (stop.val === "end") groupStartX = Math.max(0, relativeTarget - groupMeasure.totalWidth);
						else if (stop.val === "center") groupStartX = Math.max(0, relativeTarget - groupMeasure.totalWidth / 2);
						else {
							const beforeDecimal = groupMeasure.beforeDecimalWidth ?? groupMeasure.totalWidth;
							groupStartX = Math.max(0, relativeTarget - beforeDecimal);
						}
						if (currentLeader) currentLeader.to = groupStartX + effectiveIndent;
						activeTabGroup = {
							measure: groupMeasure,
							startX: groupStartX,
							currentX: groupStartX,
							target: relativeTarget,
							val: stop.val
						};
						currentLine.width = roundValue(groupStartX);
					}
					pendingTabAlignment = null;
					pendingLeader = null;
				} else pendingTabAlignment = {
					target: clampedTarget - effectiveIndent,
					val: stop.val,
					compensateNegativeLeft: stop.val === "start" && indentLeft < 0 && effectiveIndent === indentLeft && stop.source !== "explicit"
				};
			} else {
				pendingTabAlignment = null;
				pendingLeader = null;
			}
			pendingRunSpacing = 0;
			continue;
		}
		if (isImageRun(run)) {
			const leftSpace = run.distLeft ?? 0;
			const rightSpace = run.distRight ?? 0;
			const imageWidth = run.width + leftSpace + rightSpace;
			const topSpace = run.distTop ?? 0;
			const bottomSpace = run.distBottom ?? 0;
			const imageHeight = run.height + topSpace + bottomSpace;
			let imageStartX;
			if (activeTabGroup && currentLine) {
				imageStartX = activeTabGroup.currentX;
				activeTabGroup.currentX = roundValue(activeTabGroup.currentX + imageWidth);
			} else if (pendingTabAlignment && currentLine) imageStartX = alignPendingTabForWidth(imageWidth);
			const imagePrecedingTabEndX = imageStartX !== void 0 ? consumePendingPrecedingTabEndX() : void 0;
			if (!currentLine) {
				currentLine = {
					fromRun: runIndex,
					fromChar: 0,
					toRun: runIndex,
					toChar: 1,
					width: imageWidth,
					maxFontSize: 0,
					maxImageHeight: imageHeight,
					maxWidth: getEffectiveWidth(lines.length === 0 ? initialAvailableWidth : bodyContentWidth),
					spaceCount: 0,
					segments: [{
						runIndex,
						fromChar: 0,
						toChar: 1,
						width: imageWidth,
						...imageStartX !== void 0 ? { x: imageStartX } : {},
						...imagePrecedingTabEndX !== void 0 ? { precedingTabEndX: imagePrecedingTabEndX } : {}
					}]
				};
				pendingRunSpacing = 0;
				if (activeTabGroup && runIndex + 1 >= activeTabGroup.measure.endRunIndex) activeTabGroup = null;
				continue;
			}
			const appliedTabAlign = lastAppliedTabAlign;
			if (!(activeTabGroup !== null) && currentLine.width + imageWidth > currentLine.maxWidth && currentLine.width > 0) {
				trimTrailingWrapSpaces(currentLine);
				const metrics = finalizeLineMetrics(currentLine, spacing);
				const completedLine = {
					...currentLine,
					...metrics
				};
				addBarTabsToLine(completedLine);
				lines.push(completedLine);
				tabStopCursor = 0;
				pendingTabAlignment = null;
				pendingLeader = null;
				lastAppliedTabAlign = null;
				activeTabGroup = null;
				currentLine = {
					fromRun: runIndex,
					fromChar: 0,
					toRun: runIndex,
					toChar: 1,
					width: imageWidth,
					maxFontSize: 0,
					maxImageHeight: imageHeight,
					maxWidth: getEffectiveWidth(bodyContentWidth),
					spaceCount: 0,
					segments: [{
						runIndex,
						fromChar: 0,
						toChar: 1,
						width: imageWidth
					}]
				};
			} else {
				currentLine.toRun = runIndex;
				currentLine.toChar = 1;
				currentLine.width = roundValue(currentLine.width + imageWidth);
				currentLine.maxImageHeight = Math.max(currentLine.maxImageHeight ?? 0, imageHeight);
				if (!currentLine.segments) currentLine.segments = [];
				currentLine.segments.push({
					runIndex,
					fromChar: 0,
					toChar: 1,
					width: imageWidth,
					...imageStartX !== void 0 ? { x: imageStartX } : {},
					...imagePrecedingTabEndX !== void 0 ? { precedingTabEndX: imagePrecedingTabEndX } : {}
				});
			}
			if (activeTabGroup && runIndex + 1 >= activeTabGroup.measure.endRunIndex) activeTabGroup = null;
			const tabAlign = appliedTabAlign;
			if (tabAlign && currentLine && tabAlign.val === "end") currentLine.width = roundValue(tabAlign.target);
			lastAppliedTabAlign = null;
			pendingRunSpacing = 0;
			continue;
		}
		if (run.kind === "math") {
			const mathRun = run;
			const mathWidth = mathRun.width ?? 20;
			const mathHeight = mathRun.height ?? 24;
			if (!currentLine) currentLine = {
				fromRun: runIndex,
				fromChar: 0,
				toRun: runIndex,
				toChar: 1,
				width: mathWidth,
				maxFontSize: lastFontSize,
				maxWidth: getEffectiveWidth(lines.length === 0 ? initialAvailableWidth : bodyContentWidth),
				segments: [{
					runIndex,
					fromChar: 0,
					toChar: 1,
					width: mathWidth
				}],
				spaceCount: 0,
				maxImageHeight: mathHeight
			};
			else {
				currentLine.toRun = runIndex;
				currentLine.toChar = 1;
				currentLine.width = roundValue(currentLine.width + mathWidth);
				currentLine.maxImageHeight = Math.max(currentLine.maxImageHeight ?? 0, mathHeight);
				if (!currentLine.segments) currentLine.segments = [];
				currentLine.segments.push({
					runIndex,
					fromChar: 0,
					toChar: 1,
					width: mathWidth
				});
			}
			pendingRunSpacing = 0;
			continue;
		}
		if (isFieldAnnotationRun(run)) {
			const displayText = applyTextTransform(run.displayLabel || "", run);
			const annotationFontSize = typeof run.fontSize === "number" ? run.fontSize : typeof run.fontSize === "string" ? parseFloat(run.fontSize) || DEFAULT_FIELD_ANNOTATION_FONT_SIZE : DEFAULT_FIELD_ANNOTATION_FONT_SIZE;
			const annotationFontFamily = fontContext.resolvePhysical(run.fontFamily || "Arial, sans-serif", faceOf(run));
			const fontWeight = run.bold ? "bold" : "normal";
			ctx$1.font = `${run.italic ? "italic" : "normal"} ${fontWeight} ${annotationFontSize}px ${annotationFontFamily}`;
			const textWidth = displayText ? ctx$1.measureText(displayText).width : 0;
			const annotationHorizontalPadding = run.highlighted === false ? 0 : FIELD_ANNOTATION_PILL_PADDING;
			const annotationVerticalPadding = run.highlighted === false ? 0 : FIELD_ANNOTATION_VERTICAL_PADDING;
			const annotationWidth = textWidth + annotationHorizontalPadding;
			let annotationHeight = annotationFontSize * FIELD_ANNOTATION_LINE_HEIGHT_MULTIPLIER + annotationVerticalPadding;
			if (run.variant === "signature" && run.imageSrc) {
				const signatureHeight = 28 + annotationVerticalPadding;
				annotationHeight = Math.max(annotationHeight, signatureHeight);
			}
			if (run.variant === "image" && run.imageSrc && run.size?.height) {
				const imageHeight = run.size.height + annotationVerticalPadding;
				annotationHeight = Math.max(annotationHeight, imageHeight);
			}
			if (run.variant === "html" && run.size?.height) annotationHeight = Math.max(annotationHeight, run.size.height);
			let annotationStartX;
			if (pendingTabAlignment && currentLine) annotationStartX = alignPendingTabForWidth(annotationWidth);
			const annotationPrecedingTabEndX = annotationStartX !== void 0 ? consumePendingPrecedingTabEndX() : void 0;
			if (!currentLine) {
				currentLine = {
					fromRun: runIndex,
					fromChar: 0,
					toRun: runIndex,
					toChar: 1,
					width: annotationWidth,
					maxFontSize: annotationHeight,
					maxWidth: getEffectiveWidth(lines.length === 0 ? initialAvailableWidth : bodyContentWidth),
					spaceCount: 0,
					segments: [{
						runIndex,
						fromChar: 0,
						toChar: 1,
						width: annotationWidth,
						...annotationStartX !== void 0 ? { x: annotationStartX } : {},
						...annotationPrecedingTabEndX !== void 0 ? { precedingTabEndX: annotationPrecedingTabEndX } : {}
					}]
				};
				pendingRunSpacing = 0;
				continue;
			}
			if (currentLine.width + annotationWidth > currentLine.maxWidth && currentLine.width > 0) {
				trimTrailingWrapSpaces(currentLine);
				const metrics = finalizeLineMetrics(currentLine, spacing);
				const completedLine = {
					...currentLine,
					...metrics
				};
				addBarTabsToLine(completedLine);
				lines.push(completedLine);
				tabStopCursor = 0;
				pendingTabAlignment = null;
				pendingLeader = null;
				lastAppliedTabAlign = null;
				currentLine = {
					fromRun: runIndex,
					fromChar: 0,
					toRun: runIndex,
					toChar: 1,
					width: annotationWidth,
					maxFontSize: annotationHeight,
					maxWidth: getEffectiveWidth(bodyContentWidth),
					spaceCount: 0,
					segments: [{
						runIndex,
						fromChar: 0,
						toChar: 1,
						width: annotationWidth
					}]
				};
			} else {
				currentLine.toRun = runIndex;
				currentLine.toChar = 1;
				currentLine.width = roundValue(currentLine.width + annotationWidth);
				currentLine.maxFontSize = Math.max(currentLine.maxFontSize, annotationHeight);
				if (!currentLine.segments) currentLine.segments = [];
				currentLine.segments.push({
					runIndex,
					fromChar: 0,
					toChar: 1,
					width: annotationWidth,
					...annotationStartX !== void 0 ? { x: annotationStartX } : {},
					...annotationPrecedingTabEndX !== void 0 ? { precedingTabEndX: annotationPrecedingTabEndX } : {}
				});
			}
			const tabAlign = lastAppliedTabAlign;
			if (tabAlign && currentLine && tabAlign.val === "end") currentLine.width = roundValue(tabAlign.target);
			lastAppliedTabAlign = null;
			pendingRunSpacing = 0;
			continue;
		}
		if (!("text" in run) || !("fontSize" in run)) {
			pendingRunSpacing = 0;
			continue;
		}
		if (isEmptySdtPlaceholderRun(run)) {
			const placeholderFont = buildFontString(run, fontContext).font;
			const placeholderText = applyTextTransform(EMPTY_SDT_PLACEHOLDER_TEXT, run);
			const measuredPlaceholderWidth = getMeasuredTextWidth(placeholderText, placeholderFont, run.letterSpacing ?? 0, ctx$1);
			const fallbackPlaceholderWidth = placeholderText.length * run.fontSize * .45;
			const placeholderWidth = run.sdt?.type === "structuredContent" && run.sdt.appearance === "hidden" ? 0 : measuredPlaceholderWidth > 0 ? measuredPlaceholderWidth : fallbackPlaceholderWidth;
			if (!currentLine) currentLine = {
				fromRun: runIndex,
				fromChar: 0,
				toRun: runIndex,
				toChar: 0,
				width: placeholderWidth,
				maxFontSize: lineHeightFontSize(run),
				maxFontInfo: getFontInfoFromRun(run, fontContext),
				maxWidth: getEffectiveWidth(lines.length === 0 ? initialAvailableWidth : bodyContentWidth),
				segments: [{
					runIndex,
					fromChar: 0,
					toChar: 0,
					width: placeholderWidth
				}],
				spaceCount: 0
			};
			else {
				const boundarySpacing = resolveBoundarySpacing(currentLine.width, true, run);
				if (currentLine.width + boundarySpacing + placeholderWidth > currentLine.maxWidth - WIDTH_FUDGE_PX$1 && currentLine.width > 0) {
					trimTrailingWrapSpaces(currentLine);
					const metrics = finalizeLineMetrics(currentLine, spacing);
					const completedLine = {
						...currentLine,
						...metrics
					};
					addBarTabsToLine(completedLine);
					lines.push(completedLine);
					tabStopCursor = 0;
					pendingTabAlignment = null;
					pendingLeader = null;
					lastAppliedTabAlign = null;
					activeTabGroup = null;
					currentLine = {
						fromRun: runIndex,
						fromChar: 0,
						toRun: runIndex,
						toChar: 0,
						width: placeholderWidth,
						maxFontSize: lineHeightFontSize(run),
						maxFontInfo: getFontInfoFromRun(run, fontContext),
						maxWidth: getEffectiveWidth(bodyContentWidth),
						segments: [{
							runIndex,
							fromChar: 0,
							toChar: 0,
							width: placeholderWidth
						}],
						spaceCount: 0
					};
				} else {
					currentLine.toRun = runIndex;
					currentLine.toChar = 0;
					currentLine.width = roundValue(currentLine.width + boundarySpacing + placeholderWidth);
					currentLine.maxFontInfo = updateMaxFontInfo(currentLine.maxFontSize, currentLine.maxFontInfo, run, fontContext);
					currentLine.maxFontSize = Math.max(currentLine.maxFontSize, lineHeightFontSize(run));
					appendSegment(currentLine.segments, runIndex, 0, 0, placeholderWidth);
				}
			}
			lastFontSize = run.fontSize;
			hasSeenTextRun = true;
			pendingRunSpacing = 0;
			continue;
		}
		lastFontSize = run.fontSize;
		hasSeenTextRun = true;
		if (run.text === "") {
			pendingRunSpacing = 0;
			continue;
		}
		const { font } = buildFontString(run, fontContext);
		const tabSegments = run.text.split("	");
		let charPosInRun = 0;
		for (let segmentIndex = 0; segmentIndex < tabSegments.length; segmentIndex++) {
			const segment = tabSegments[segmentIndex];
			const isLastSegment = segmentIndex === tabSegments.length - 1;
			if (/^[ ]+$/.test(segment)) {
				const isRunStart = charPosInRun === 0 && segmentIndex === 0;
				const spacesLength = segment.length;
				const spacesStartChar = charPosInRun;
				const spacesEndChar = charPosInRun + spacesLength;
				const spacesWidth = measureRunWidth(segment, font, ctx$1, run, spacesStartChar);
				if (!currentLine) currentLine = {
					fromRun: runIndex,
					fromChar: spacesStartChar,
					toRun: runIndex,
					toChar: spacesEndChar,
					width: spacesWidth,
					maxFontSize: lineHeightFontSize(run),
					maxFontInfo: getFontInfoFromRun(run, fontContext),
					maxWidth: getEffectiveWidth(lines.length === 0 ? initialAvailableWidth : bodyContentWidth),
					segments: [{
						runIndex,
						fromChar: spacesStartChar,
						toChar: spacesEndChar,
						width: spacesWidth
					}],
					spaceCount: spacesLength
				};
				else {
					const boundarySpacing = resolveBoundarySpacing(currentLine.width, isRunStart, run);
					if (currentLine.width + boundarySpacing + spacesWidth > currentLine.maxWidth - WIDTH_FUDGE_PX$1 && currentLine.width > 0) {
						trimTrailingWrapSpaces(currentLine);
						const metrics = finalizeLineMetrics(currentLine, spacing);
						const completedLine = {
							...currentLine,
							...metrics
						};
						addBarTabsToLine(completedLine);
						lines.push(completedLine);
						tabStopCursor = 0;
						pendingTabAlignment = null;
						pendingLeader = null;
						lastAppliedTabAlign = null;
						currentLine = {
							fromRun: runIndex,
							fromChar: spacesStartChar,
							toRun: runIndex,
							toChar: spacesEndChar,
							width: spacesWidth,
							maxFontSize: lineHeightFontSize(run),
							maxFontInfo: getFontInfoFromRun(run, fontContext),
							maxWidth: getEffectiveWidth(bodyContentWidth),
							segments: [{
								runIndex,
								fromChar: spacesStartChar,
								toChar: spacesEndChar,
								width: spacesWidth
							}],
							spaceCount: spacesLength
						};
					} else {
						currentLine.toRun = runIndex;
						currentLine.toChar = spacesEndChar;
						currentLine.width = roundValue(currentLine.width + boundarySpacing + spacesWidth);
						currentLine.maxFontInfo = updateMaxFontInfo(currentLine.maxFontSize, currentLine.maxFontInfo, run, fontContext);
						currentLine.maxFontSize = Math.max(currentLine.maxFontSize, lineHeightFontSize(run));
						appendSegment(currentLine.segments, runIndex, spacesStartChar, spacesEndChar, spacesWidth);
						currentLine.spaceCount += spacesLength;
					}
				}
				charPosInRun = spacesEndChar;
				continue;
			}
			const words = segment.split(" ");
			let lastNonEmptyWordIndex = -1;
			for (let i = words.length - 1; i >= 0; i -= 1) if (words[i] !== "") {
				lastNonEmptyWordIndex = i;
				break;
			}
			let segmentStartX;
			let inActiveTabGroup = false;
			if (activeTabGroup && currentLine) {
				segmentStartX = activeTabGroup.currentX;
				inActiveTabGroup = true;
			} else if (currentLine && pendingTabAlignment) {
				segmentStartX = alignSegmentAtTab(segment, font, run, charPosInRun);
				if (segmentStartX == null) segmentStartX = currentLine.width;
			}
			let hasPendingSegmentTabGeometry = segmentStartX !== void 0;
			const consumeSegmentPrecedingTabEndX = () => {
				if (!hasPendingSegmentTabGeometry) return void 0;
				hasPendingSegmentTabGeometry = false;
				return consumePendingPrecedingTabEndX();
			};
			const clearWrapState = () => {
				segmentStartX = void 0;
				hasPendingSegmentTabGeometry = false;
				clearPendingPrecedingTabEndX();
			};
			for (let wordIndex = 0; wordIndex < words.length; wordIndex++) {
				const word$1 = words[wordIndex];
				if (word$1 === "") {
					const spaceStartChar = charPosInRun;
					const spaceEndChar = charPosInRun + 1;
					const singleSpaceWidth = measureRunWidth(" ", font, ctx$1, run, spaceStartChar);
					const isRunStart$1 = charPosInRun === 0 && segmentIndex === 0 && wordIndex === 0;
					if (!currentLine) currentLine = {
						fromRun: runIndex,
						fromChar: spaceStartChar,
						toRun: runIndex,
						toChar: spaceEndChar,
						width: singleSpaceWidth,
						maxFontSize: lineHeightFontSize(run),
						maxFontInfo: getFontInfoFromRun(run, fontContext),
						maxWidth: getEffectiveWidth(lines.length === 0 ? initialAvailableWidth : bodyContentWidth),
						segments: [{
							runIndex,
							fromChar: spaceStartChar,
							toChar: spaceEndChar,
							width: singleSpaceWidth
						}],
						spaceCount: 1
					};
					else {
						const boundarySpacing$1 = resolveBoundarySpacing(currentLine.width, isRunStart$1, run);
						if (currentLine.width + boundarySpacing$1 + singleSpaceWidth > currentLine.maxWidth - WIDTH_FUDGE_PX$1 && currentLine.width > 0) {
							trimTrailingWrapSpaces(currentLine);
							const metrics = finalizeLineMetrics(currentLine, spacing);
							const completedLine = {
								...currentLine,
								...metrics
							};
							addBarTabsToLine(completedLine);
							lines.push(completedLine);
							tabStopCursor = 0;
							pendingTabAlignment = null;
							pendingLeader = null;
							lastAppliedTabAlign = null;
							activeTabGroup = null;
							clearWrapState();
							currentLine = {
								fromRun: runIndex,
								fromChar: spaceStartChar,
								toRun: runIndex,
								toChar: spaceEndChar,
								width: singleSpaceWidth,
								maxFontSize: lineHeightFontSize(run),
								maxFontInfo: getFontInfoFromRun(run, fontContext),
								maxWidth: getEffectiveWidth(bodyContentWidth),
								segments: [{
									runIndex,
									fromChar: spaceStartChar,
									toChar: spaceEndChar,
									width: singleSpaceWidth
								}],
								spaceCount: 1
							};
						} else {
							currentLine.toRun = runIndex;
							currentLine.toChar = spaceEndChar;
							currentLine.width = roundValue(currentLine.width + boundarySpacing$1 + singleSpaceWidth);
							currentLine.maxFontInfo = updateMaxFontInfo(currentLine.maxFontSize, currentLine.maxFontInfo, run, fontContext);
							currentLine.maxFontSize = Math.max(currentLine.maxFontSize, lineHeightFontSize(run));
							let spaceExplicitX;
							let spacePrecedingTabEndX;
							if (inActiveTabGroup && activeTabGroup) {
								spaceExplicitX = activeTabGroup.currentX;
								activeTabGroup.currentX = roundValue(activeTabGroup.currentX + singleSpaceWidth);
							} else if (wordIndex === 0 && segmentStartX !== void 0) {
								spaceExplicitX = segmentStartX;
								spacePrecedingTabEndX = consumeSegmentPrecedingTabEndX();
							}
							appendSegment(currentLine.segments, runIndex, spaceStartChar, spaceEndChar, singleSpaceWidth, spaceExplicitX, spacePrecedingTabEndX);
							currentLine.spaceCount += 1;
						}
					}
					charPosInRun = spaceEndChar;
					continue;
				}
				const wordStartChar = charPosInRun;
				const wordOnlyWidth = measureRunWidth(word$1, font, ctx$1, run, wordStartChar);
				const shouldIncludeDelimiterSpace = wordIndex < lastNonEmptyWordIndex;
				const wordEndNoSpace = charPosInRun + word$1.length;
				const spaceWidth = shouldIncludeDelimiterSpace ? measureRunWidth(" ", font, ctx$1, run, wordEndNoSpace) : 0;
				const wordCommitWidth = wordOnlyWidth + spaceWidth;
				const wordEndWithSpace = wordEndNoSpace + (shouldIncludeDelimiterSpace ? 1 : 0);
				if (wordOnlyWidth > (currentLine ? currentLine.maxWidth : getEffectiveWidth(lines.length === 0 ? initialAvailableWidth : contentWidth)) + WIDTH_FUDGE_PX$1 && word$1.length > 1) {
					if (currentLine && currentLine.width > 0 && currentLine.segments && currentLine.segments.length > 0) {
						trimTrailingWrapSpaces(currentLine);
						const metrics = finalizeLineMetrics(currentLine, spacing);
						const completedLine = {
							...currentLine,
							...metrics
						};
						addBarTabsToLine(completedLine);
						lines.push(completedLine);
						tabStopCursor = 0;
						pendingTabAlignment = null;
						pendingLeader = null;
						currentLine = null;
						clearWrapState();
					}
					const lineMaxWidth = getEffectiveWidth(lines.length === 0 ? initialAvailableWidth : contentWidth);
					const hasTabOnlyLine = currentLine && currentLine.segments && currentLine.segments.length === 0 && currentLine.width > 0;
					const remainingWidthAfterTab = hasTabOnlyLine ? currentLine.maxWidth - currentLine.width : lineMaxWidth;
					const chunks = breakWordIntoChunks(word$1, hasTabOnlyLine ? Math.max(remainingWidthAfterTab, lineMaxWidth * .25) : lineMaxWidth, font, ctx$1, run, wordStartChar);
					let chunkCharOffset = wordStartChar;
					for (let chunkIndex = 0; chunkIndex < chunks.length; chunkIndex++) {
						const chunk = chunks[chunkIndex];
						const chunkStartChar = chunkCharOffset;
						const chunkEndChar = chunkCharOffset + chunk.text.length;
						const isLastChunk = chunkIndex === chunks.length - 1;
						if (chunkIndex === 0 && hasTabOnlyLine && currentLine && currentLine.segments) {
							currentLine.toRun = runIndex;
							currentLine.toChar = chunkEndChar;
							currentLine.width = roundValue(currentLine.width + chunk.width);
							currentLine.maxFontSize = Math.max(currentLine.maxFontSize, lineHeightFontSize(run));
							currentLine.maxFontInfo = getFontInfoFromRun(run, fontContext);
							currentLine.segments.push({
								runIndex,
								fromChar: chunkStartChar,
								toChar: chunkEndChar,
								width: chunk.width
							});
							if (isLastChunk) {
								const ls = run.letterSpacing ?? 0;
								if (shouldIncludeDelimiterSpace && currentLine.width + spaceWidth <= currentLine.maxWidth - WIDTH_FUDGE_PX$1) {
									currentLine.toChar = wordEndWithSpace;
									currentLine.width = roundValue(currentLine.width + spaceWidth + ls);
									charPosInRun = wordEndWithSpace;
									currentLine.spaceCount += 1;
								} else charPosInRun = wordEndWithSpace;
							} else {
								trimTrailingWrapSpaces(currentLine);
								const metrics = finalizeLineMetrics(currentLine, spacing);
								const completedLine = {
									...currentLine,
									...metrics
								};
								addBarTabsToLine(completedLine);
								lines.push(completedLine);
								tabStopCursor = 0;
								pendingTabAlignment = null;
								pendingLeader = null;
								currentLine = null;
								clearWrapState();
							}
						} else if (isLastChunk) {
							currentLine = {
								fromRun: runIndex,
								fromChar: chunkStartChar,
								toRun: runIndex,
								toChar: chunkEndChar,
								width: chunk.width,
								maxFontSize: lineHeightFontSize(run),
								maxFontInfo: getFontInfoFromRun(run, fontContext),
								maxWidth: getEffectiveWidth(contentWidth),
								segments: [{
									runIndex,
									fromChar: chunkStartChar,
									toChar: chunkEndChar,
									width: chunk.width
								}],
								spaceCount: 0
							};
							const ls = run.letterSpacing ?? 0;
							if (shouldIncludeDelimiterSpace && currentLine.width + spaceWidth <= currentLine.maxWidth - WIDTH_FUDGE_PX$1) {
								currentLine.toChar = wordEndWithSpace;
								currentLine.width = roundValue(currentLine.width + spaceWidth + ls);
								charPosInRun = wordEndWithSpace;
								currentLine.spaceCount += 1;
							} else charPosInRun = wordEndWithSpace;
						} else {
							const chunkLineMaxWidth = getEffectiveWidth(lines.length === 0 ? initialAvailableWidth : contentWidth);
							const metrics = calculateTypographyMetrics(run.fontSize, spacing, getFontInfoFromRun(run, fontContext));
							const chunkLine = {
								fromRun: runIndex,
								fromChar: chunkStartChar,
								toRun: runIndex,
								toChar: chunkEndChar,
								width: chunk.width,
								maxWidth: chunkLineMaxWidth,
								segments: [{
									runIndex,
									fromChar: chunkStartChar,
									toChar: chunkEndChar,
									width: chunk.width
								}],
								...metrics
							};
							addBarTabsToLine(chunkLine);
							lines.push(chunkLine);
							clearWrapState();
						}
						chunkCharOffset = chunkEndChar;
					}
					continue;
				}
				if (!currentLine) {
					currentLine = {
						fromRun: runIndex,
						fromChar: wordStartChar,
						toRun: runIndex,
						toChar: wordEndNoSpace,
						width: wordOnlyWidth,
						maxFontSize: lineHeightFontSize(run),
						maxFontInfo: getFontInfoFromRun(run, fontContext),
						maxWidth: getEffectiveWidth(lines.length === 0 ? initialAvailableWidth : bodyContentWidth),
						segments: [{
							runIndex,
							fromChar: wordStartChar,
							toChar: wordEndNoSpace,
							width: wordOnlyWidth
						}],
						spaceCount: 0
					};
					const ls = run.letterSpacing ?? 0;
					if (shouldIncludeDelimiterSpace && currentLine.width + spaceWidth <= currentLine.maxWidth - WIDTH_FUDGE_PX$1) {
						currentLine.toChar = wordEndWithSpace;
						currentLine.width = roundValue(currentLine.width + spaceWidth + ls);
						charPosInRun = wordEndWithSpace;
						currentLine.spaceCount += 1;
						if (currentLine.segments?.[0]) {
							currentLine.segments[0].toChar = wordEndWithSpace;
							currentLine.segments[0].width += spaceWidth;
						}
					} else charPosInRun = wordEndWithSpace;
					continue;
				}
				const isTocEntry = block.attrs?.isTocEntry;
				const isRunStart = charPosInRun === 0 && segmentIndex === 0 && wordIndex === 0;
				const boundarySpacing = resolveBoundarySpacing(currentLine.width, isRunStart, run);
				const justifyAlignment = block.attrs?.alignment === "justify";
				const totalWidthWithWord = currentLine.width + boundarySpacing + wordCommitWidth + (shouldIncludeDelimiterSpace ? run.letterSpacing ?? 0 : 0);
				const availableWidth = currentLine.maxWidth - WIDTH_FUDGE_PX$1;
				let shouldBreak = !inActiveTabGroup && currentLine.width + boundarySpacing + wordOnlyWidth > availableWidth && currentLine.width > 0 && !isTocEntry;
				let compressedWidth = null;
				if (shouldBreak && justifyAlignment) {
					if (!(isLastSegment && wordIndex === lastNonEmptyWordIndex && runIndex === runsToProcess.length - 1)) {
						const candidateSpaces = (currentLine.spaceCount ?? 0) + (shouldIncludeDelimiterSpace ? 1 : 0);
						if (candidateSpaces > 0) {
							const overflow = totalWidthWithWord - availableWidth;
							if (overflow > 0) {
								const baseSpaceWidth = spaceWidth || measureRunWidth(" ", font, ctx$1, run, wordEndNoSpace) || Math.max(1, boundarySpacing);
								if (overflow / candidateSpaces <= baseSpaceWidth * .25) {
									shouldBreak = false;
									compressedWidth = availableWidth;
								}
							}
						}
					}
				}
				if (shouldBreak) {
					if (wordIndex === 0 && hasPendingSegmentTabGeometry) clearWrapState();
					trimTrailingWrapSpaces(currentLine);
					const metrics = finalizeLineMetrics(currentLine, spacing);
					const completedLine = {
						...currentLine,
						...metrics
					};
					addBarTabsToLine(completedLine);
					lines.push(completedLine);
					tabStopCursor = 0;
					pendingTabAlignment = null;
					pendingLeader = null;
					currentLine = {
						fromRun: runIndex,
						fromChar: wordStartChar,
						toRun: runIndex,
						toChar: wordEndNoSpace,
						width: wordOnlyWidth,
						maxFontSize: lineHeightFontSize(run),
						maxFontInfo: getFontInfoFromRun(run, fontContext),
						maxWidth: getEffectiveWidth(bodyContentWidth),
						segments: [{
							runIndex,
							fromChar: wordStartChar,
							toChar: wordEndNoSpace,
							width: wordOnlyWidth
						}],
						spaceCount: 0
					};
					if (shouldIncludeDelimiterSpace && currentLine.width + spaceWidth <= currentLine.maxWidth - WIDTH_FUDGE_PX$1) {
						currentLine.toChar = wordEndWithSpace;
						currentLine.width = roundValue(currentLine.width + spaceWidth + (run.letterSpacing ?? 0));
						charPosInRun = wordEndWithSpace;
						currentLine.spaceCount += 1;
						if (currentLine.segments?.[0]) {
							currentLine.segments[0].toChar = wordEndWithSpace;
							currentLine.segments[0].width += spaceWidth;
						}
					} else charPosInRun = wordEndWithSpace;
				} else {
					currentLine.toRun = runIndex;
					if (shouldIncludeDelimiterSpace && currentLine.width + boundarySpacing + wordOnlyWidth + spaceWidth > currentLine.maxWidth - WIDTH_FUDGE_PX$1) {
						currentLine.toChar = wordEndNoSpace;
						currentLine.width = roundValue(currentLine.width + boundarySpacing + wordOnlyWidth);
						currentLine.maxFontInfo = updateMaxFontInfo(currentLine.maxFontSize, currentLine.maxFontInfo, run, fontContext);
						currentLine.maxFontSize = Math.max(currentLine.maxFontSize, lineHeightFontSize(run));
						let explicitXHere;
						if (inActiveTabGroup && activeTabGroup) {
							explicitXHere = activeTabGroup.currentX;
							activeTabGroup.currentX = roundValue(activeTabGroup.currentX + wordOnlyWidth);
						} else if (wordIndex === 0 && segmentStartX !== void 0) explicitXHere = segmentStartX;
						appendSegment(currentLine.segments, runIndex, wordStartChar, wordEndNoSpace, wordOnlyWidth, explicitXHere, wordIndex === 0 ? consumeSegmentPrecedingTabEndX() : void 0);
						trimTrailingWrapSpaces(currentLine);
						const metrics = finalizeLineMetrics(currentLine, spacing);
						const completedLine = {
							...currentLine,
							...metrics
						};
						addBarTabsToLine(completedLine);
						lines.push(completedLine);
						tabStopCursor = 0;
						pendingTabAlignment = null;
						pendingLeader = null;
						currentLine = null;
						charPosInRun = wordEndNoSpace + 1;
						continue;
					}
					const newToChar = shouldIncludeDelimiterSpace ? wordEndWithSpace : wordEndNoSpace;
					currentLine.toChar = newToChar;
					let explicitX;
					if (inActiveTabGroup && activeTabGroup) {
						explicitX = activeTabGroup.currentX;
						activeTabGroup.currentX = roundValue(activeTabGroup.currentX + wordCommitWidth);
					} else if (wordIndex === 0 && segmentStartX !== void 0) explicitX = segmentStartX;
					const targetWidth = compressedWidth != null ? compressedWidth : currentLine.width + boundarySpacing + wordCommitWidth + (shouldIncludeDelimiterSpace ? run.letterSpacing ?? 0 : 0);
					if (compressedWidth != null) currentLine.naturalWidth = roundValue(totalWidthWithWord);
					currentLine.width = roundValue(targetWidth);
					currentLine.maxFontInfo = updateMaxFontInfo(currentLine.maxFontSize, currentLine.maxFontInfo, run, fontContext);
					currentLine.maxFontSize = Math.max(currentLine.maxFontSize, lineHeightFontSize(run));
					appendSegment(currentLine.segments, runIndex, wordStartChar, newToChar, wordCommitWidth, explicitX, wordIndex === 0 ? consumeSegmentPrecedingTabEndX() : void 0);
					if (shouldIncludeDelimiterSpace) currentLine.spaceCount += 1;
				}
				charPosInRun = shouldIncludeDelimiterSpace ? wordEndWithSpace : wordEndNoSpace;
			}
			if (lastAppliedTabAlign && currentLine) {
				const appliedTab = lastAppliedTabAlign;
				if (appliedTab.val === "end") currentLine.width = roundValue(appliedTab.target);
			}
			lastAppliedTabAlign = null;
			if (activeTabGroup && runIndex + 1 >= activeTabGroup.measure.endRunIndex) {
				if (currentLine && activeTabGroup.val === "end") currentLine.width = roundValue(activeTabGroup.target);
				activeTabGroup = null;
			}
			if (!isLastSegment) {
				pendingTabAlignment = null;
				pendingLeader = null;
				if (!currentLine) currentLine = {
					fromRun: runIndex,
					fromChar: charPosInRun,
					toRun: runIndex,
					toChar: charPosInRun,
					width: 0,
					maxFontSize: lineHeightFontSize(run),
					maxFontInfo: getFontInfoFromRun(run, fontContext),
					maxWidth: getEffectiveWidth(lines.length === 0 ? initialAvailableWidth : bodyContentWidth),
					segments: [],
					spaceCount: 0
				};
				const originX = currentLine.width;
				const effectiveIndent = lines.length === 0 ? indentLeft + rawFirstLineOffset : indentLeft;
				const absCurrentX = currentLine.width + effectiveIndent;
				const { target, nextIndex, stop } = getNextTabStopPx(absCurrentX, tabStops, tabStopCursor);
				tabStopCursor = nextIndex;
				const maxAbsWidth = currentLine.maxWidth + effectiveIndent;
				const clampedTarget = Math.min(target, maxAbsWidth);
				const tabAdvance = Math.max(0, clampedTarget - absCurrentX);
				currentLine.width = roundValue(currentLine.width + tabAdvance);
				if (stop?.source === "explicit") currentLine.hasExplicitTabStops = true;
				currentLine.maxFontInfo = updateMaxFontInfo(currentLine.maxFontSize, currentLine.maxFontInfo, run, fontContext);
				currentLine.maxFontSize = Math.max(currentLine.maxFontSize, lineHeightFontSize(run));
				currentLine.toRun = runIndex;
				currentLine.toChar = charPosInRun;
				charPosInRun += 1;
				if (stop) {
					validateTabStopVal(stop);
					pendingTabAlignment = {
						target: clampedTarget - effectiveIndent,
						val: stop.val,
						compensateNegativeLeft: stop.val === "start" && indentLeft < 0 && effectiveIndent === indentLeft && stop.source !== "explicit"
					};
				} else {
					pendingTabAlignment = null;
					pendingLeader = null;
				}
				if (stop && stop.leader && stop.leader !== "none" && stop.leader !== "middleDot") {
					const leaderStyle = stop.leader;
					const from$1 = Math.min(originX + effectiveIndent, clampedTarget);
					const to = Math.max(originX + effectiveIndent, clampedTarget);
					if (!currentLine.leaders) currentLine.leaders = [];
					const leader = {
						from: from$1,
						to,
						style: leaderStyle
					};
					currentLine.leaders.push(leader);
					pendingLeader = leader;
				}
			}
		}
		pendingRunSpacing = run.letterSpacing ?? 0;
	}
	if (!currentLine && lines.length === 0) {
		const fallbackLine = {
			fromRun: 0,
			fromChar: 0,
			toRun: 0,
			toChar: 0,
			width: 0,
			segments: [],
			...calculateTypographyMetrics((normalizedRuns[0]?.kind === "text" ? normalizedRuns[0].fontSize : void 0) ?? DEFAULT_PARAGRAPH_FONT_SIZE, spacing)
		};
		addBarTabsToLine(fallbackLine);
		lines.push(fallbackLine);
	}
	if (currentLine) {
		const metrics = finalizeLineMetrics(currentLine, spacing);
		const finalLine = {
			...currentLine,
			...metrics
		};
		addBarTabsToLine(finalLine);
		lines.push(finalLine);
	}
	return {
		kind: "paragraph",
		lines,
		totalHeight: lines.reduce((sum, line) => sum + line.lineHeight, 0),
		...markerInfo ? { marker: markerInfo } : {},
		...dropCapMeasure ? { dropCap: dropCapMeasure } : {}
	};
}
async function measureTableBlock(block, constraints, fontContext) {
	const workingInput = buildAutoFitWorkingGridInput(block, { maxWidth: typeof constraints === "number" ? constraints : constraints.maxWidth });
	const columnWidths = await resolveRuntimeTableColumnWidths(block, workingInput, fontContext);
	const gridColumnCount = columnWidths.length;
	const calculateCellWidth = (startCol, colspan) => {
		let width = 0;
		for (let i = 0; i < colspan && startCol + i < columnWidths.length; i++) width += columnWidths[startCol + i];
		return Math.max(1, width);
	};
	const rowspanTracker = new Array(gridColumnCount).fill(0);
	const rows = [];
	const rowBaseHeights = new Array(block.rows.length).fill(0);
	const spanConstraints = [];
	for (let rowIndex = 0; rowIndex < block.rows.length; rowIndex++) {
		const row = block.rows[rowIndex];
		const normalizedRow = workingInput.rows[rowIndex];
		const cellMeasures = [];
		let gridColIndex = 0;
		for (let cellIndex = 0; cellIndex < row.cells.length; cellIndex++) {
			const cell = row.cells[cellIndex];
			const colspan = cell.colSpan ?? 1;
			const rowspan = cell.rowSpan ?? 1;
			const preferredStartColumn = (normalizedRow?.cells?.[cellIndex])?.startColumn ?? gridColIndex;
			while (gridColIndex < gridColumnCount && gridColIndex < preferredStartColumn) {
				if (rowspanTracker[gridColIndex] > 0) rowspanTracker[gridColIndex]--;
				gridColIndex++;
			}
			while (gridColIndex < gridColumnCount && rowspanTracker[gridColIndex] > 0) {
				rowspanTracker[gridColIndex]--;
				gridColIndex++;
			}
			if (gridColIndex >= gridColumnCount) break;
			const cellWidth = calculateCellWidth(gridColIndex, colspan);
			if (rowspan > 1) for (let c = 0; c < colspan && gridColIndex + c < gridColumnCount; c++) rowspanTracker[gridColIndex + c] = rowspan - 1;
			const cellPadding = cell.attrs?.padding ?? DEFAULT_CELL_PADDING;
			const paddingTop = cellPadding.top ?? 0;
			const paddingBottom = cellPadding.bottom ?? 0;
			const paddingLeft = cellPadding.left ?? 4;
			const paddingRight = cellPadding.right ?? 4;
			const contentWidth$1 = Math.max(1, cellWidth - paddingLeft - paddingRight);
			const blockMeasures = [];
			let contentHeight$1 = 0;
			const cellBlocks = cell.blocks ?? (cell.paragraph ? [cell.paragraph] : []);
			for (let blockIndex = 0; blockIndex < cellBlocks.length; blockIndex++) {
				const block$1 = cellBlocks[blockIndex];
				const measure = await measureBlock(block$1, {
					maxWidth: contentWidth$1,
					maxHeight: Infinity
				}, fontContext);
				blockMeasures.push(measure);
				const blockHeight = "totalHeight" in measure ? measure.totalHeight : "height" in measure ? measure.height : 0;
				if ((block$1.kind === "image" || block$1.kind === "drawing") && block$1.anchor?.isAnchored === true && (block$1.wrap?.type ?? "Inline") !== "Inline") continue;
				contentHeight$1 += blockHeight;
				const isFirstBlock = blockIndex === 0;
				const isLastBlock = blockIndex === cellBlocks.length - 1;
				if (block$1.kind === "paragraph") {
					const spacingBefore = block$1.attrs?.spacing?.before;
					contentHeight$1 += effectiveTableCellSpacing(spacingBefore, isFirstBlock, paddingTop);
					const spacingAfter = block$1.attrs?.spacing?.after;
					contentHeight$1 += effectiveTableCellSpacing(spacingAfter, isLastBlock, paddingBottom);
				}
			}
			const totalCellHeight = contentHeight$1 + paddingTop + paddingBottom;
			cellMeasures.push({
				blocks: blockMeasures,
				paragraph: blockMeasures[0]?.kind === "paragraph" ? blockMeasures[0] : void 0,
				width: cellWidth,
				height: totalCellHeight,
				gridColumnStart: gridColIndex,
				colSpan: colspan,
				rowSpan: rowspan
			});
			if (rowspan === 1) rowBaseHeights[rowIndex] = Math.max(rowBaseHeights[rowIndex], totalCellHeight);
			else spanConstraints.push({
				startRow: rowIndex,
				rowSpan: rowspan,
				requiredHeight: totalCellHeight
			});
			gridColIndex += colspan;
		}
		for (let col = gridColIndex; col < gridColumnCount; col++) if (rowspanTracker[col] > 0) rowspanTracker[col]--;
		rows.push({
			cells: cellMeasures,
			height: 0
		});
	}
	const rowHeights = [...rowBaseHeights];
	for (const constraint of spanConstraints) {
		const { startRow, rowSpan, requiredHeight } = constraint;
		if (rowSpan <= 0) continue;
		let currentHeight = 0;
		for (let i = 0; i < rowSpan && startRow + i < rowHeights.length; i++) currentHeight += rowHeights[startRow + i];
		if (currentHeight < requiredHeight) {
			const spanLength = Math.min(rowSpan, rowHeights.length - startRow);
			const increment = spanLength > 0 ? (requiredHeight - currentHeight) / spanLength : 0;
			for (let i = 0; i < spanLength; i++) rowHeights[startRow + i] += increment;
		}
	}
	block.rows.forEach((row, index) => {
		const spec = row.attrs?.rowHeight;
		if (spec?.value != null && Number.isFinite(spec.value)) if ((spec.rule ?? "atLeast") === "exact") rowHeights[index] = spec.value;
		else rowHeights[index] = Math.max(rowHeights[index], spec.value);
	});
	for (let i = 0; i < rows.length; i++) rows[i].height = Math.max(0, rowHeights[i]);
	const contentHeight = rowHeights.reduce((sum, h$2) => sum + h$2, 0);
	const contentWidth = columnWidths.reduce((a, b$1) => a + b$1, 0);
	const cellSpacingPx = getCellSpacingPx(block.attrs?.cellSpacing);
	const numRows = block.rows.length;
	const horizontalGaps = gridColumnCount > 0 ? (gridColumnCount + 1) * cellSpacingPx : 0;
	const verticalGaps = numRows > 0 ? (numRows + 1) * cellSpacingPx : 0;
	const tableBorderWidths = getTableBorderWidths(block.attrs?.borders);
	const borderWidthH = tableBorderWidths.left + tableBorderWidths.right;
	const borderWidthV = tableBorderWidths.top + tableBorderWidths.bottom;
	const includeOuterBordersInTotal = (block.attrs?.borderCollapse ?? (block.attrs?.cellSpacing != null ? "separate" : "collapse")) === "separate";
	return {
		kind: "table",
		rows,
		columnWidths,
		totalWidth: contentWidth + horizontalGaps + (includeOuterBordersInTotal ? borderWidthH : 0),
		totalHeight: contentHeight + verticalGaps + (includeOuterBordersInTotal ? borderWidthV : 0),
		cellSpacingPx: cellSpacingPx > 0 ? cellSpacingPx : void 0,
		tableBorderWidths: borderWidthH > 0 || borderWidthV > 0 ? tableBorderWidths : void 0
	};
}
async function resolveRuntimeTableColumnWidths(block, workingInput, fontContext) {
	const fixedLayout = computeFixedTableColumnWidths(workingInput);
	if (workingInput.layoutMode === "fixed") return fixedLayout.columnWidths;
	const { contentMetrics, cellMetricKeys } = await buildMeasuredAutoFitContentMetrics(block, workingInput, fixedLayout, fontContext);
	const cacheKey = buildAutoFitTableResultCacheKey(block, {
		maxWidth: workingInput.maxTableWidth,
		cellMetricKeys,
		fontSignature: fontContext.fontSignature,
		workingInput,
		fixedLayout
	});
	const cached = getCachedAutoFitTableResult(cacheKey);
	if (cached) return cached.columnWidths;
	const result = computeAutoFitColumnWidths({
		workingInput,
		fixedLayout,
		contentMetrics: { rowMetrics: contentMetrics.rowMetrics }
	});
	setCachedAutoFitTableResult(cacheKey, {
		columnWidths: result.columnWidths,
		totalWidth: result.totalWidth
	});
	return result.columnWidths;
}
async function buildMeasuredAutoFitContentMetrics(block, workingInput, fixedLayout, fontContext) {
	const measureBlockWithFontContext = (childBlock, childConstraints) => measureBlock(childBlock, childConstraints, fontContext);
	const contentMetrics = await measureTableAutoFitContentMetrics(block, workingInput, fixedLayout, measureBlockWithFontContext, fontContext);
	return {
		contentMetrics,
		cellMetricKeys: contentMetrics.cellMetricKeys
	};
}
async function measureImageBlock(block, constraints) {
	const intrinsic = getIntrinsicImageSize(block, constraints.maxWidth);
	const isBlockBehindDoc = block.anchor?.behindDoc;
	const isBlockWrapBehindDoc = block.wrap?.type === "None" && block.wrap?.behindDoc;
	const isPageRelativeAnchor$1 = block.anchor?.isAnchored && (block.anchor?.hRelativeFrom === "page" || block.anchor?.hRelativeFrom === "margin");
	const maxWidth = isBlockBehindDoc || isBlockWrapBehindDoc || isPageRelativeAnchor$1 || constraints.maxWidth <= 0 ? intrinsic.width : constraints.maxWidth;
	const maxHeight = block.anchor?.isAnchored && (typeof block.anchor?.offsetV === "number" && block.anchor.offsetV < 0 || typeof block.margin?.top === "number" && block.margin.top < 0) || block.objectFit === "cover" || !constraints.maxHeight || constraints.maxHeight <= 0 ? Infinity : constraints.maxHeight;
	const widthScale = maxWidth / intrinsic.width;
	const heightScale = maxHeight / intrinsic.height;
	const scale = Math.min(1, widthScale, heightScale);
	return {
		kind: "image",
		width: Number.isFinite(scale) ? intrinsic.width * scale : intrinsic.width,
		height: Number.isFinite(scale) ? intrinsic.height * scale : intrinsic.height
	};
}
async function measureDrawingBlock(block, constraints) {
	if (block.drawingKind === "image") {
		const intrinsic = getIntrinsicSizeFromDims(block.width, block.height, constraints.maxWidth);
		const maxWidth$1 = constraints.maxWidth > 0 ? constraints.maxWidth : intrinsic.width;
		const maxHeight$1 = constraints.maxHeight && constraints.maxHeight > 0 ? constraints.maxHeight : Infinity;
		const widthScale$1 = maxWidth$1 / intrinsic.width;
		const heightScale$1 = maxHeight$1 / intrinsic.height;
		const scale$1 = Math.min(1, widthScale$1, heightScale$1);
		return {
			kind: "drawing",
			drawingKind: "image",
			width: Number.isFinite(scale$1) ? intrinsic.width * scale$1 : intrinsic.width,
			height: Number.isFinite(scale$1) ? intrinsic.height * scale$1 : intrinsic.height,
			scale: Number.isFinite(scale$1) ? scale$1 : 1,
			naturalWidth: intrinsic.width,
			naturalHeight: intrinsic.height,
			geometry: {
				width: intrinsic.width,
				height: intrinsic.height,
				rotation: 0,
				flipH: false,
				flipV: false
			}
		};
	}
	const geometry = ensureDrawingGeometry(block.geometry);
	const attrs = block.attrs;
	const indentLeft = typeof attrs?.hrIndentLeft === "number" ? attrs.hrIndentLeft : 0;
	const indentRight = typeof attrs?.hrIndentRight === "number" ? attrs.hrIndentRight : 0;
	const fullWidthMax = attrs?.isFullWidth === true && constraints.maxWidth > 0 ? Math.max(1, constraints.maxWidth - indentLeft - indentRight) : void 0;
	if (fullWidthMax != null) geometry.width = fullWidthMax;
	const rotatedBounds = calculateRotatedBounds(geometry);
	const naturalWidth = Math.max(1, rotatedBounds.width);
	const naturalHeight = Math.max(1, rotatedBounds.height);
	const isFloating = block.wrap?.type === "None";
	const maxWidth = fullWidthMax ?? (constraints.maxWidth > 0 && !isFloating ? constraints.maxWidth : naturalWidth);
	const maxHeight = block.anchor?.isAnchored && (typeof block.anchor?.offsetV === "number" && block.anchor.offsetV < 0 || typeof block.margin?.top === "number" && block.margin.top < 0) || !constraints.maxHeight || constraints.maxHeight <= 0 ? Infinity : constraints.maxHeight;
	const widthScale = maxWidth / naturalWidth;
	const heightScale = maxHeight / naturalHeight;
	const normalizedScale = Math.min(1, widthScale, heightScale);
	const scale = Number.isFinite(normalizedScale) ? normalizedScale : 1;
	const width = naturalWidth * scale;
	const height = naturalHeight * scale;
	return {
		kind: "drawing",
		drawingKind: block.drawingKind,
		width,
		height,
		scale,
		naturalWidth,
		naturalHeight,
		geometry: { ...geometry },
		...block.drawingKind === "shapeGroup" && block.groupTransform ? { groupTransform: { ...block.groupTransform } } : {}
	};
}
function getIntrinsicImageSize(block, fallback) {
	const safeFallback = fallback > 0 ? fallback : 1;
	return {
		width: typeof block.width === "number" && block.width > 0 ? block.width : safeFallback,
		height: typeof block.height === "number" && block.height > 0 ? block.height : safeFallback * .75
	};
}
function getIntrinsicSizeFromDims(width, height, fallback = 1) {
	const safeFallback = fallback > 0 ? fallback : 1;
	return {
		width: typeof width === "number" && width > 0 ? width : safeFallback,
		height: typeof height === "number" && height > 0 ? height : safeFallback * .75
	};
}
function ensureDrawingGeometry(geometry) {
	if (geometry) return {
		width: Math.max(1, geometry.width),
		height: Math.max(1, geometry.height),
		rotation: normalizeRotation(geometry.rotation ?? 0),
		flipH: Boolean(geometry.flipH),
		flipV: Boolean(geometry.flipV)
	};
	return {
		width: 1,
		height: 1,
		rotation: 0,
		flipH: false,
		flipV: false
	};
}
function normalizeConstraints(constraints) {
	if (typeof constraints === "number") return { maxWidth: constraints };
	return constraints;
}
async function measureListBlock(block, constraints, fontContext) {
	const ctx$1 = getCanvasContext();
	const items = [];
	let totalHeight = 0;
	for (const item of block.items) {
		const wordLayout = item.paragraph.attrs?.wordLayout;
		let markerTextWidth;
		let markerWidth;
		let indentLeft;
		if (wordLayout?.marker) {
			const marker = wordLayout.marker;
			const paragraphFallbackFontSize = getPrimaryRun(item.paragraph).fontSize ?? DEFAULT_PARAGRAPH_FONT_SIZE;
			const { font: markerFont } = buildFontString({
				text: marker.markerText,
				fontFamily: toCssFontFamily(marker.run.fontFamily) ?? marker.run.fontFamily,
				fontSize: marker.run.fontSize ?? paragraphFallbackFontSize,
				bold: marker.run.bold,
				italic: marker.run.italic,
				letterSpacing: marker.run.letterSpacing
			}, fontContext);
			markerTextWidth = marker.markerText ? measureText(marker.markerText, markerFont, ctx$1) : 0;
			markerWidth = 0;
			indentLeft = wordLayout.indentLeftPx ?? 0;
		} else {
			const { font: markerFont } = buildFontString(getPrimaryRun(item.paragraph), fontContext);
			const markerText = item.marker.text ?? "";
			markerTextWidth = markerText ? measureText(markerText, markerFont, ctx$1) : 0;
			indentLeft = resolveIndentLeft(item);
			const indentHanging = resolveIndentHanging(item);
			markerWidth = Math.max(24, markerTextWidth + 8, indentHanging);
		}
		const paragraphWidth = Math.max(1, constraints.maxWidth - indentLeft - markerWidth);
		const paragraphMeasure = await measureParagraphBlock(item.paragraph, paragraphWidth, fontContext);
		totalHeight += paragraphMeasure.totalHeight;
		items.push({
			itemId: item.id,
			markerWidth,
			markerTextWidth,
			indentLeft,
			paragraph: paragraphMeasure
		});
	}
	return {
		kind: "list",
		items,
		totalHeight
	};
}
var getPrimaryRun = (paragraph) => {
	return paragraph.runs.find((run) => run.kind === "text" && Boolean(run.fontFamily && run.fontSize)) || {
		text: "",
		fontFamily: "Arial",
		fontSize: 16
	};
};
var isWordChar = (char) => {
	if (!char) return false;
	const code = char.charCodeAt(0);
	return code >= 48 && code <= 57 || code >= 65 && code <= 90 || code >= 97 && code <= 122 || char === "'";
};
var capitalizeText = (text, fullText, startOffset) => {
	if (!text) return text;
	const hasFullText = typeof startOffset === "number" && fullText != null;
	let result = "";
	for (let i = 0; i < text.length; i += 1) {
		const prevChar = hasFullText ? startOffset + i > 0 ? fullText[startOffset + i - 1] : "" : i > 0 ? text[i - 1] : "";
		const ch = text[i];
		result += isWordChar(ch) && !isWordChar(prevChar) ? ch.toUpperCase() : ch;
	}
	return result;
};
var applyTextTransform = (text, run, startOffset) => {
	const transform = "textTransform" in run ? run.textTransform : void 0;
	if (!text || !transform || transform === "none") return text;
	if (transform === "uppercase") return text.toUpperCase();
	if (transform === "lowercase") return text.toLowerCase();
	if (transform === "capitalize") return capitalizeText(text, "text" in run && typeof run.text === "string" ? run.text : text, startOffset);
	return text;
};
var measureRunWidth = (text, font, ctx$1, run, startOffset) => {
	const letterSpacing = run.kind === "text" || run.kind === void 0 ? run.letterSpacing || 0 : 0;
	return roundValue(getMeasuredTextWidth(applyTextTransform(text, run, startOffset), font, letterSpacing, ctx$1));
};
var breakWordIntoChunks = (word$1, maxWidth, font, ctx$1, run, startOffset) => {
	const chunks = [];
	const baseOffset = typeof startOffset === "number" ? startOffset : 0;
	if (maxWidth <= 0) {
		for (let i = 0; i < word$1.length; i++) {
			const char = word$1[i];
			const charWidth = measureRunWidth(char, font, ctx$1, run, baseOffset + i);
			chunks.push({
				text: char,
				width: charWidth
			});
		}
		return chunks;
	}
	let currentChunk = "";
	let currentWidth = 0;
	for (let i = 0; i < word$1.length; i++) {
		const char = word$1[i];
		const testChunk = currentChunk + char;
		const testWidth = measureRunWidth(testChunk, font, ctx$1, run, baseOffset);
		if (testWidth > maxWidth && currentChunk.length > 0) {
			chunks.push({
				text: currentChunk,
				width: currentWidth
			});
			currentChunk = char;
			currentWidth = measureRunWidth(char, font, ctx$1, run, baseOffset + i);
		} else {
			currentChunk = testChunk;
			currentWidth = testWidth;
		}
	}
	if (currentChunk.length > 0) chunks.push({
		text: currentChunk,
		width: currentWidth
	});
	return chunks;
};
var appendSegment = (segments, runIndex, fromChar, toChar, width, x, precedingTabEndX) => {
	if (!segments) return;
	const last = segments[segments.length - 1];
	if (last && last.runIndex === runIndex && last.toChar === fromChar && last.x === void 0 && last.precedingTabEndX === void 0 && x === void 0 && precedingTabEndX === void 0) {
		last.toChar = toChar;
		last.width += width;
		return;
	}
	segments.push({
		runIndex,
		fromChar,
		toChar,
		width,
		...x !== void 0 ? { x } : {},
		...precedingTabEndX !== void 0 ? { precedingTabEndX } : {}
	});
};
var resolveLineHeight = (spacing, fontSize, maxHeight = -1) => {
	let computedHeight = spacing?.line ?? WORD_SINGLE_LINE_SPACING_MULTIPLIER;
	if (spacing?.lineUnit === "multiplier") computedHeight = computedHeight * fontSize;
	const lineRule = spacing?.lineRule ?? "auto";
	if (["atLeast", "auto"].includes(lineRule)) return Math.max(computedHeight, maxHeight, WORD_SINGLE_LINE_SPACING_MULTIPLIER * fontSize);
	return computedHeight;
};
var sanitizePositive = (value) => typeof value === "number" && Number.isFinite(value) ? Math.max(0, value) : 0;
const sanitizeIndent = (value) => typeof value === "number" && Number.isFinite(value) ? value : 0;
var sanitizeDecimalSeparator = (value) => {
	if (value === ",") return ",";
	return DEFAULT_DECIMAL_SEPARATOR;
};
var DROP_CAP_PADDING_PX = 4;
var measureDropCap = (ctx$1, descriptor, spacing, fontContext) => {
	const { run, lines, mode } = descriptor;
	const { font } = buildFontString({
		fontFamily: run.fontFamily,
		fontSize: run.fontSize,
		bold: run.bold,
		italic: run.italic
	}, fontContext);
	ctx$1.font = font;
	const displayText = applyTextTransform(run.text, run);
	const metrics = ctx$1.measureText(displayText);
	const advanceWidth = metrics.width;
	const paintedWidth = (metrics.actualBoundingBoxLeft || 0) + (metrics.actualBoundingBoxRight || 0);
	return {
		width: roundValue(Math.max(advanceWidth, paintedWidth) + DROP_CAP_PADDING_PX),
		height: roundValue(resolveLineHeight(spacing, run.fontSize) * lines),
		lines,
		mode
	};
};
var resolveIndentLeft = (item) => {
	const indentLeft = sanitizePositive(item.paragraph.attrs?.indent?.left);
	if (indentLeft > 0) return indentLeft;
	return 24 + item.marker.level * 24;
};
var resolveIndentHanging = (item) => {
	const indentHanging = sanitizePositive(item.paragraph.attrs?.indent?.hanging);
	if (indentHanging > 0) return indentHanging;
	return 18;
};
var buildTabStopsPx = (indent, tabs, tabIntervalTwips) => {
	const paragraphIndentTwips = {
		left: pxToTwips(sanitizePositive(indent?.left)),
		right: pxToTwips(sanitizePositive(indent?.right)),
		firstLine: pxToTwips(sanitizePositive(indent?.firstLine)),
		hanging: pxToTwips(sanitizePositive(indent?.hanging))
	};
	const rawParagraphIndentTwips = {
		left: pxToTwips(sanitizeIndent(indent?.left)),
		right: pxToTwips(sanitizeIndent(indent?.right)),
		firstLine: pxToTwips(sanitizeIndent(indent?.firstLine)),
		hanging: pxToTwips(sanitizePositive(indent?.hanging))
	};
	return computeTabStops({
		explicitStops: tabs ?? [],
		defaultTabInterval: tabIntervalTwips ?? DEFAULT_TAB_INTERVAL_TWIPS,
		paragraphIndent: paragraphIndentTwips,
		rawParagraphIndent: rawParagraphIndentTwips
	}).map((stop) => ({
		pos: twipsToPx(stop.pos),
		val: stop.val,
		leader: stop.leader,
		source: stop.source
	}));
};
var getNextTabStopPx = (currentX, tabStops, startIndex) => {
	let index = startIndex;
	while (index < tabStops.length && tabStops[index].pos <= currentX + TAB_EPSILON) index++;
	if (index < tabStops.length) return {
		target: tabStops[index].pos,
		nextIndex: index + 1,
		stop: tabStops[index]
	};
	return {
		target: currentX + DEFAULT_TAB_INTERVAL_PX,
		nextIndex: index
	};
};
async function layoutPerRIdHeaderFooters(headerFooterInput, layout, sectionMetadata, deps, fontResolver, hasFace, effectiveSignature) {
	deps.headerLayoutsByRId.clear();
	deps.footerLayoutsByRId.clear();
	if (!headerFooterInput) return;
	const { headerBlocksByRId, footerBlocksByRId, constraints } = headerFooterInput;
	const displayPages = computeDisplayPageNumber(layout.pages, sectionMetadata);
	const pageByNumber = new Map(layout.pages.map((page) => [page.number, page]));
	const totalPages = layout.pages.length;
	const pageResolver = (pageNumber) => {
		const displayInfo = displayPages[pageNumber - 1];
		const page = pageByNumber.get(pageNumber);
		return {
			displayText: page?.numberText ?? displayInfo?.displayText ?? String(pageNumber),
			displayNumber: page?.displayNumber ?? displayInfo?.displayNumber ?? pageNumber,
			totalPages,
			sectionPageCount: displayInfo?.sectionPageCount ?? totalPages ?? 1,
			pageFormat: page?.pageNumberFormat,
			chapterNumberText: page?.pageNumberChapterText,
			chapterSeparator: page?.pageNumberChapterSeparator
		};
	};
	if (sectionMetadata.length > 1 && sectionMetadata.some((s) => s.margins || s.pageSize)) {
		await layoutWithPerSectionConstraints("header", headerBlocksByRId, sectionMetadata, constraints, pageResolver, deps.headerLayoutsByRId, fontResolver, hasFace, effectiveSignature);
		await layoutWithPerSectionConstraints("footer", footerBlocksByRId, sectionMetadata, constraints, pageResolver, deps.footerLayoutsByRId, fontResolver, hasFace, effectiveSignature);
	} else {
		const effectiveHeaderRefsBySection = buildEffectiveHeaderFooterRefsBySection(sectionMetadata, "header");
		const effectiveFooterRefsBySection = buildEffectiveHeaderFooterRefsBySection(sectionMetadata, "footer");
		await layoutBlocksByRId("header", headerBlocksByRId, collectReferencedHeaderFooterRIds(effectiveHeaderRefsBySection), constraints, pageResolver, deps.headerLayoutsByRId, fontResolver, hasFace, effectiveSignature);
		await layoutBlocksByRId("footer", footerBlocksByRId, collectReferencedHeaderFooterRIds(effectiveFooterRefsBySection), constraints, pageResolver, deps.footerLayoutsByRId, fontResolver, hasFace, effectiveSignature);
	}
}
async function layoutBlocksByRId(kind, blocksByRId, referencedRIds, constraints, pageResolver, layoutsByRId, fontResolver, hasFace, effectiveSignature) {
	if (!blocksByRId || referencedRIds.size === 0) return;
	const fontSignature = effectiveSignature ?? "";
	const fontMeasureContext = fontResolver ? {
		resolvePhysical: (css, face) => hasFace ? fontResolver.resolvePhysicalFamilyForFace(css, face, hasFace) : fontResolver.resolvePhysicalFamily(css),
		fontSignature
	} : void 0;
	for (const [rId, blocks] of blocksByRId) {
		if (!referencedRIds.has(rId)) continue;
		if (!blocks || blocks.length === 0) continue;
		try {
			const batchResult = await layoutHeaderFooterWithCache({ default: blocks }, constraints, (block, c) => measureBlock(block, c, fontMeasureContext), void 0, void 0, pageResolver, kind, fontSignature, (block, maxWidth, firstLineIndent) => remeasureParagraph(block, maxWidth, firstLineIndent));
			if (batchResult.default) layoutsByRId.set(rId, {
				kind,
				type: "default",
				layout: batchResult.default.layout,
				blocks: batchResult.default.blocks,
				measures: batchResult.default.measures
			});
		} catch (error) {
			console.warn(`[PresentationEditor] Failed to layout ${kind} rId=${rId}:`, error);
		}
	}
}
function cloneHeaderFooterLayout(layout) {
	return {
		...layout,
		pages: layout.pages.map((page) => ({
			...page,
			fragments: page.fragments.map((f) => ({ ...f }))
		}))
	};
}
function adjustFramePositionsForContentWidth(layout, blocks, effectiveWidth, contentWidth) {
	if (effectiveWidth <= contentWidth) return;
	const widthDiff = effectiveWidth - contentWidth;
	const blockById = /* @__PURE__ */ new Map();
	for (const block of blocks) blockById.set(block.id, block);
	for (const page of layout.pages) for (const fragment of page.fragments) {
		if (fragment.kind !== "para") continue;
		const block = blockById.get(fragment.blockId);
		if (!block || block.kind !== "paragraph") continue;
		const frame = block.attrs?.frame;
		if (!frame || frame.wrap !== "none") continue;
		if (frame.xAlign === "right") fragment.x -= widthDiff;
		else if (frame.xAlign === "center") fragment.x -= widthDiff / 2;
	}
}
async function layoutWithPerSectionConstraints(kind, blocksByRId, sectionMetadata, fallbackConstraints, pageResolver, layoutsByRId, fontResolver, hasFace, effectiveSignature) {
	if (!blocksByRId) return;
	const fontSignature = effectiveSignature ?? "";
	const fontMeasureContext = fontResolver ? {
		resolvePhysical: (css, face) => hasFace ? fontResolver.resolvePhysicalFamilyForFace(css, face, hasFace) : fontResolver.resolvePhysicalFamily(css),
		fontSignature
	} : void 0;
	const groups = buildSectionAwareHeaderFooterMeasurementGroups(kind, blocksByRId, sectionMetadata, fallbackConstraints);
	for (const group of groups) {
		const blocks = blocksByRId.get(group.rId);
		if (!blocks || blocks.length === 0) continue;
		try {
			const batchResult = await layoutHeaderFooterWithCache({ default: blocks }, group.sectionConstraints, (block, c) => measureBlock(block, c, fontMeasureContext), void 0, void 0, pageResolver, kind, fontSignature, (block, maxWidth, firstLineIndent) => remeasureParagraph(block, maxWidth, firstLineIndent));
			if (batchResult.default) for (const sectionIndex of group.sectionIndices) {
				const contentWidth = buildSectionContentWidth(sectionMetadata.find((s) => s.sectionIndex === sectionIndex), fallbackConstraints);
				const needsFrameAdjust = group.effectiveWidth > contentWidth;
				let layout = batchResult.default.layout;
				if (needsFrameAdjust) {
					layout = cloneHeaderFooterLayout(layout);
					adjustFramePositionsForContentWidth(layout, batchResult.default.blocks, group.effectiveWidth, contentWidth);
				}
				const result = {
					kind,
					type: "default",
					layout,
					blocks: batchResult.default.blocks,
					measures: batchResult.default.measures,
					effectiveWidth: needsFrameAdjust ? group.effectiveWidth : void 0
				};
				layoutsByRId.set(buildSectionAwareHeaderFooterLayoutKey(group.rId, sectionIndex), result);
			}
		} catch (error) {
			console.warn(`[PresentationEditor] Failed to layout ${kind} rId=${group.rId}:`, error);
		}
	}
}
var COMPOSITE_KEY_SUFFIX = /::s(\d+)$/;
function roundNullable(value) {
	if (value == null || !Number.isFinite(value)) return null;
	return Math.round(value * 1e3) / 1e3 + 0;
}
function roundNumber(value) {
	return roundNullable(value) ?? 0;
}
function naturalCompare(a, b$1) {
	const re = /(\d+)|(\D+)/g;
	const aParts = a.match(re) ?? [];
	const bParts = b$1.match(re) ?? [];
	const len = Math.min(aParts.length, bParts.length);
	for (let i = 0; i < len; i += 1) {
		const an = Number(aParts[i]);
		const bn = Number(bParts[i]);
		if (!Number.isNaN(an) && !Number.isNaN(bn)) {
			if (an !== bn) return an - bn;
		} else if (aParts[i] !== bParts[i]) return aParts[i] < bParts[i] ? -1 : 1;
	}
	return aParts.length - bParts.length;
}
function makeStoryKey(kind, layoutKey) {
	return `${kind}::${layoutKey}`;
}
function refIdFromLayoutKey(layoutKey) {
	return layoutKey.replace(COMPOSITE_KEY_SUFFIX, "");
}
function resolveBindingStoryKey(kind, refId, sectionIndex, layoutsByRId) {
	if (!refId) return null;
	const composite = buildSectionAwareHeaderFooterLayoutKey(refId, sectionIndex);
	if (layoutsByRId.has(composite)) return makeStoryKey(kind, composite);
	if (layoutsByRId.has(refId)) return makeStoryKey(kind, refId);
	return makeStoryKey(kind, composite);
}
function summarizeRegion(region) {
	return {
		localX: roundNumber(region.localX),
		localY: roundNumber(region.localY),
		width: roundNumber(region.width),
		height: roundNumber(region.height),
		contentHeight: roundNullable(region.contentHeight)
	};
}
function summarizeBinding(kind, region, layoutsByRId) {
	const refId = region.headerFooterRefId ?? null;
	return {
		storyKey: resolveBindingStoryKey(kind, refId, region.sectionIndex ?? 0, layoutsByRId),
		refId,
		variant: region.matchedVariant ?? region.sectionType ?? null,
		region: summarizeRegion(region)
	};
}
function hasBoundStoryRegion(region) {
	return typeof region?.headerFooterRefId === "string" && region.headerFooterRefId.length > 0;
}
function summarizeFragment(fragment) {
	const withSize = fragment;
	return {
		kind: fragment.kind,
		blockId: typeof fragment.blockId === "string" ? fragment.blockId : null,
		x: roundNumber(fragment.x),
		y: roundNumber(fragment.y),
		width: roundNullable(withSize.width),
		height: roundNullable(withSize.height)
	};
}
function summarizeRawLayout(result) {
	const { layout } = result;
	return {
		height: roundNumber(layout.height),
		minY: roundNullable(layout.minY),
		maxY: roundNullable(layout.maxY),
		renderHeight: roundNullable(layout.renderHeight),
		pages: [...layout.pages].sort((a, b$1) => a.number - b$1.number).map((page) => ({
			number: page.number,
			displayNumber: page.displayNumber ?? null,
			numberText: page.numberText ?? null,
			fragments: page.fragments.map(summarizeFragment)
		}))
	};
}
function summarizeResolvedItem(item) {
	const withMeta = item;
	return {
		kind: item.kind,
		blockId: typeof withMeta.blockId === "string" ? withMeta.blockId : null,
		fragmentKind: typeof withMeta.fragmentKind === "string" ? withMeta.fragmentKind : null,
		x: roundNumber(item.x),
		y: roundNumber(item.y),
		width: roundNullable(item.width),
		height: roundNullable(item.height),
		childCount: Array.isArray(withMeta.children) ? withMeta.children.length : null
	};
}
function summarizeResolvedLayout(resolved) {
	return {
		height: roundNumber(resolved.height),
		minY: roundNullable(resolved.minY),
		maxY: roundNullable(resolved.maxY),
		renderHeight: roundNullable(resolved.renderHeight),
		pages: [...resolved.pages].sort((a, b$1) => a.number - b$1.number).map((page) => ({
			number: page.number,
			displayNumber: page.displayNumber ?? null,
			numberText: page.numberText ?? null,
			items: page.items.map(summarizeResolvedItem)
		}))
	};
}
function buildPageBindings(source) {
	const sectionsByStoryKey = /* @__PURE__ */ new Map();
	const recordSection = (storyKey, sectionIndex) => {
		if (!storyKey) return;
		let sections = sectionsByStoryKey.get(storyKey);
		if (!sections) {
			sections = /* @__PURE__ */ new Set();
			sectionsByStoryKey.set(storyKey, sections);
		}
		sections.add(sectionIndex);
	};
	const pageIndices = new Set([...source.headerRegions.keys(), ...source.footerRegions.keys()]);
	const pageBindings = [];
	for (const pageIndex of [...pageIndices].sort((a, b$1) => a - b$1)) {
		const headerRegion = source.headerRegions.get(pageIndex) ?? null;
		const footerRegion = source.footerRegions.get(pageIndex) ?? null;
		const boundHeaderRegion = hasBoundStoryRegion(headerRegion) ? headerRegion : null;
		const boundFooterRegion = hasBoundStoryRegion(footerRegion) ? footerRegion : null;
		const anchor = boundHeaderRegion ?? boundFooterRegion;
		if (!anchor) continue;
		const header = boundHeaderRegion ? summarizeBinding("header", boundHeaderRegion, source.headerLayoutsByRId) : null;
		const footer = boundFooterRegion ? summarizeBinding("footer", boundFooterRegion, source.footerLayoutsByRId) : null;
		if (header) recordSection(header.storyKey, boundHeaderRegion.sectionIndex ?? 0);
		if (footer) recordSection(footer.storyKey, boundFooterRegion.sectionIndex ?? 0);
		pageBindings.push({
			pageIndex,
			pageNumber: anchor.pageNumber,
			sectionIndex: anchor.sectionIndex ?? 0,
			header,
			footer
		});
	}
	return {
		pageBindings,
		sectionsByStoryKey
	};
}
function makeStorySnapshot(kind, storyKey, refId, sectionIndices, rawLayout, resolvedLayout) {
	return {
		storyKey,
		kind,
		refId,
		sectionIndices: [...new Set(sectionIndices)].sort((a, b$1) => a - b$1),
		rawLayout: summarizeRawLayout(rawLayout),
		resolvedLayout: resolvedLayout ? summarizeResolvedLayout(resolvedLayout) : null
	};
}
function buildVariantResultMaps(results, resolvedLayouts) {
	const rawByVariant = /* @__PURE__ */ new Map();
	const resolvedByVariant = /* @__PURE__ */ new Map();
	if (!results) return {
		rawByVariant,
		resolvedByVariant
	};
	for (const [index, result] of results.entries()) if (!rawByVariant.has(result.type)) {
		rawByVariant.set(result.type, result);
		const resolved = resolvedLayouts?.[index];
		if (resolved) resolvedByVariant.set(result.type, resolved);
	}
	return {
		rawByVariant,
		resolvedByVariant
	};
}
function buildStoryLayouts(kind, pageBindings, layoutsByRId, layoutResults, resolvedByRId, resolvedLayouts, sectionsByStoryKey) {
	const entries = /* @__PURE__ */ new Map();
	for (const [layoutKey, result] of layoutsByRId) {
		const storyKey = makeStoryKey(kind, layoutKey);
		const sections = new Set(sectionsByStoryKey.get(storyKey) ?? []);
		const compositeMatch = COMPOSITE_KEY_SUFFIX.exec(layoutKey);
		if (compositeMatch) sections.add(Number(compositeMatch[1]));
		const resolved = resolvedByRId.get(layoutKey) ?? null;
		entries.set(storyKey, makeStorySnapshot(kind, storyKey, refIdFromLayoutKey(layoutKey), sections, result, resolved));
	}
	const { rawByVariant, resolvedByVariant } = buildVariantResultMaps(layoutResults, resolvedLayouts);
	for (const pageBinding of pageBindings) {
		const binding = kind === "header" ? pageBinding.header : pageBinding.footer;
		if (!binding?.storyKey || !binding.refId || !binding.variant || entries.has(binding.storyKey)) continue;
		const fallbackRawLayout = rawByVariant.get(binding.variant);
		if (!fallbackRawLayout) continue;
		entries.set(binding.storyKey, makeStorySnapshot(kind, binding.storyKey, binding.refId, sectionsByStoryKey.get(binding.storyKey) ?? [pageBinding.sectionIndex], fallbackRawLayout, resolvedByVariant.get(binding.variant) ?? null));
	}
	return [...entries.values()].sort((a, b$1) => naturalCompare(a.storyKey, b$1.storyKey));
}
function buildHeaderFooterLayoutSnapshot(source) {
	const { pageBindings, sectionsByStoryKey } = buildPageBindings(source);
	return {
		pageBindings,
		storyLayouts: {
			headers: buildStoryLayouts("header", pageBindings, source.headerLayoutsByRId, source.headerLayoutResults, source.resolvedHeaderByRId, source.resolvedHeaderLayouts, sectionsByStoryKey),
			footers: buildStoryLayouts("footer", pageBindings, source.footerLayoutsByRId, source.footerLayoutResults, source.resolvedFooterByRId, source.resolvedFooterLayouts, sectionsByStoryKey)
		}
	};
}
function hasSectionRefsForKind(identifier, kind) {
	const refKey = kind === "header" ? "headerRefs" : "footerRefs";
	return Boolean(identifier?.sections?.some((section) => section[refKey] !== void 0));
}
function buildSurfacePmEntries(surface) {
	const nodes = Array.from(surface.querySelectorAll("[data-pm-start][data-pm-end]"));
	const nonLeaf = /* @__PURE__ */ new WeakSet();
	const nodeSet = /* @__PURE__ */ new WeakSet();
	nodes.forEach((node) => nodeSet.add(node));
	for (const node of nodes) {
		let parent = node.parentElement;
		while (parent && parent !== surface) {
			if (nodeSet.has(parent)) nonLeaf.add(parent);
			parent = parent.parentElement;
		}
	}
	const entries = [];
	for (const node of nodes) {
		if (node.classList.contains(DOM_CLASS_NAMES.INLINE_SDT_WRAPPER)) continue;
		if (nonLeaf.has(node)) continue;
		const pmStart = Number(node.dataset.pmStart ?? "NaN");
		const pmEnd = Number(node.dataset.pmEnd ?? "NaN");
		if (!Number.isFinite(pmStart) || !Number.isFinite(pmEnd) || pmEnd < pmStart) continue;
		entries.push({
			pmStart,
			pmEnd,
			el: node
		});
	}
	entries.sort((a, b$1) => a.pmStart - b$1.pmStart !== 0 ? a.pmStart - b$1.pmStart : a.pmEnd - b$1.pmEnd);
	return entries;
}
function findSurfaceEntriesInRange(entries, from$1, to, options) {
	if (!Number.isFinite(from$1) || !Number.isFinite(to) || entries.length === 0) return [];
	const start$1 = Math.min(from$1, to);
	const end$1 = Math.max(from$1, to);
	if (start$1 === end$1) return [];
	const boundaryInclusive = options?.boundaryInclusive === true;
	return entries.filter((entry) => boundaryInclusive ? entry.pmStart <= end$1 && entry.pmEnd >= start$1 : entry.pmStart < end$1 && entry.pmEnd > start$1);
}
function findSurfaceEntryAtPos(entries, pos) {
	if (!Number.isFinite(pos) || entries.length === 0) return null;
	const exactEntry = entries.find((entry) => pos >= entry.pmStart && pos <= entry.pmEnd);
	if (exactEntry) return exactEntry;
	const nextEntry = entries.find((entry) => pos < entry.pmStart);
	if (nextEntry) return nextEntry;
	return entries[entries.length - 1] ?? null;
}
function mapPmPosToTextOffset(pos, pmStart, pmEnd, textLength) {
	if (!Number.isFinite(pos) || !Number.isFinite(pmStart) || !Number.isFinite(pmEnd) || textLength <= 0) return 0;
	const pmRange = pmEnd - pmStart;
	if (!Number.isFinite(pmRange) || pmRange <= 0) return 0;
	if (pmRange === textLength) return Math.min(textLength, Math.max(0, pos - pmStart));
	if (pos <= pmStart) return 0;
	if (pos >= pmEnd) return textLength;
	return pos <= pmStart + pmRange / 2 ? 0 : textLength;
}
function setSurfaceRangeStart(range, entry, pos) {
	const textNode = entry.el.firstChild;
	if (textNode && textNode.nodeType === Node.TEXT_NODE) {
		range.setStart(textNode, mapPmPosToTextOffset(pos, entry.pmStart, entry.pmEnd, textNode.length));
		return true;
	}
	if (!entry.el.isConnected || !entry.el.parentNode) return false;
	if (pos <= entry.pmStart) {
		range.setStartBefore(entry.el);
		return true;
	}
	range.setStartAfter(entry.el);
	return true;
}
function setSurfaceRangeEnd(range, entry, pos) {
	const textNode = entry.el.firstChild;
	if (textNode && textNode.nodeType === Node.TEXT_NODE) {
		range.setEnd(textNode, mapPmPosToTextOffset(pos, entry.pmStart, entry.pmEnd, textNode.length));
		return true;
	}
	if (!entry.el.isConnected || !entry.el.parentNode) return false;
	if (pos <= entry.pmStart) {
		range.setEndBefore(entry.el);
		return true;
	}
	range.setEndAfter(entry.el);
	return true;
}
function buildHeaderFooterStory(kind, id) {
	const normalizedId = typeof id === "string" && id.length > 0 ? id : void 0;
	return normalizedId ? namedStoryLocator(kind, normalizedId) : { kind };
}
function storyIdFromHeaderFooterLayoutKey(key) {
	return key.replace(/::s\d+$/, "");
}
function refForVariant(refs, variant) {
	const ref$1 = refs?.[variant];
	if (ref$1) return {
		refId: ref$1,
		matchedVariant: variant
	};
	return variant === "odd" && refs?.default ? {
		refId: refs.default,
		matchedVariant: "default"
	} : void 0;
}
function resolveResult(result, storyId, fontSignature = "") {
	const story = buildHeaderFooterStory(result.kind, storyId ?? String(result.type));
	return resolveHeaderFooterLayout(result.layout, result.blocks, result.measures, story, fontSignature);
}
function shiftResolvedPaintItemY(item, yOffset) {
	if (item.kind === "group") return {
		...item,
		y: item.y + yOffset,
		children: item.children.map((child) => shiftResolvedPaintItemY(child, yOffset))
	};
	return {
		...item,
		y: item.y + yOffset
	};
}
function isExplicitBehindDocMediaFragment(fragment) {
	return (fragment.kind === "image" || fragment.kind === "drawing") && fragment.behindDoc === true;
}
function getDecorationNormalizationMinY(fragments, layoutMinY) {
	if (!Number.isFinite(layoutMinY) || layoutMinY >= 0) return 0;
	let minY = Infinity;
	for (const fragment of fragments) {
		if (isExplicitBehindDocMediaFragment(fragment)) continue;
		if (Number.isFinite(fragment.y)) minY = Math.min(minY, fragment.y);
	}
	return minY < 0 ? minY : 0;
}
function normalizeDecorationFragments(fragments, normalizationMinY) {
	if (normalizationMinY >= 0) return fragments;
	const yOffset = -normalizationMinY;
	return fragments.map((fragment) => ({
		...fragment,
		y: fragment.y + yOffset
	}));
}
function normalizeDecorationItems(items, normalizationMinY) {
	if (normalizationMinY >= 0) return items;
	const yOffset = -normalizationMinY;
	return items.map((item) => shiftResolvedPaintItemY(item, yOffset));
}
var HeaderFooterSessionManager = class {
	#options;
	#deps = null;
	#callbacks = {};
	#headerFooterManager = null;
	#headerFooterAdapter = null;
	#headerFooterIdentifier = null;
	#multiSectionIdentifier = null;
	#managerCleanups = [];
	#headerLayoutResults = null;
	#footerLayoutResults = null;
	#headerLayoutsByRId = /* @__PURE__ */ new Map();
	#footerLayoutsByRId = /* @__PURE__ */ new Map();
	#resolvedHeaderLayouts = null;
	#resolvedFooterLayouts = null;
	#resolvedHeaderByRId = /* @__PURE__ */ new Map();
	#resolvedFooterByRId = /* @__PURE__ */ new Map();
	#headerDecorationProvider;
	#footerDecorationProvider;
	#headerRegions = /* @__PURE__ */ new Map();
	#footerRegions = /* @__PURE__ */ new Map();
	#publishedHeaderFooterLayoutSnapshot = {
		pageBindings: [],
		storyLayouts: {
			headers: [],
			footers: []
		}
	};
	#headerFooterLayoutSnapshotPending = false;
	#session = { mode: "body" };
	#activeEditor = null;
	#activeEditorEventCleanup = null;
	#hoverOverlay = null;
	#hoverTooltip = null;
	#modeBanner = null;
	#activeBorderLine = null;
	#hoverRegion = null;
	#documentMode = "editing";
	#trackedChangesRenderConfig = {
		mode: "review",
		enabled: true
	};
	constructor(options) {
		this.#options = options;
	}
	get mode() {
		return this.#session.mode;
	}
	get session() {
		return this.#session;
	}
	get isEditing() {
		return this.#session.mode !== "body";
	}
	get activeEditor() {
		return this.#activeEditor;
	}
	setEditor(editor) {
		this.#options.editor = editor;
	}
	get headerDecorationProvider() {
		return this.#headerDecorationProvider;
	}
	set headerDecorationProvider(provider) {
		this.#headerDecorationProvider = provider;
	}
	get footerDecorationProvider() {
		return this.#footerDecorationProvider;
	}
	set footerDecorationProvider(provider) {
		this.#footerDecorationProvider = provider;
	}
	get adapter() {
		return this.#headerFooterAdapter;
	}
	get manager() {
		return this.#headerFooterManager;
	}
	refreshStructure(options) {
		this.#headerFooterManager?.refresh(options?.purgeCachedEditors ? { purgeCachedEditors: true } : void 0);
		this.#headerFooterAdapter?.invalidateAll();
	}
	invalidateLayoutForRefs(refIds) {
		const adapter = this.#headerFooterAdapter;
		if (!adapter) return;
		refIds.forEach((refId) => {
			adapter.invalidate(refId);
		});
	}
	get headerLayoutResults() {
		return this.#headerLayoutResults;
	}
	set headerLayoutResults(results) {
		this.#headerFooterLayoutSnapshotPending = true;
		this.#headerLayoutResults = results;
		this.#resolvedHeaderLayouts = results ? results.map((result) => this.#resolveResult(result)) : null;
	}
	get footerLayoutResults() {
		return this.#footerLayoutResults;
	}
	set footerLayoutResults(results) {
		this.#headerFooterLayoutSnapshotPending = true;
		this.#footerLayoutResults = results;
		this.#resolvedFooterLayouts = results ? results.map((result) => this.#resolveResult(result)) : null;
	}
	get headerLayoutsByRId() {
		return this.#headerLayoutsByRId;
	}
	get footerLayoutsByRId() {
		return this.#footerLayoutsByRId;
	}
	get multiSectionIdentifier() {
		return this.#multiSectionIdentifier;
	}
	set multiSectionIdentifier(identifier) {
		this.#multiSectionIdentifier = identifier;
	}
	get headerFooterIdentifier() {
		return this.#headerFooterIdentifier;
	}
	set headerFooterIdentifier(identifier) {
		this.#headerFooterIdentifier = identifier;
	}
	get headerRegions() {
		return this.#headerRegions;
	}
	get footerRegions() {
		return this.#footerRegions;
	}
	getHeaderFooterLayoutSnapshot() {
		if (this.#headerFooterLayoutSnapshotPending) return this.#publishedHeaderFooterLayoutSnapshot;
		return this.#buildLiveHeaderFooterLayoutSnapshot();
	}
	#buildLiveHeaderFooterLayoutSnapshot() {
		return buildHeaderFooterLayoutSnapshot({
			headerRegions: this.#headerRegions,
			footerRegions: this.#footerRegions,
			headerLayoutsByRId: this.#headerLayoutsByRId,
			footerLayoutsByRId: this.#footerLayoutsByRId,
			headerLayoutResults: this.#headerLayoutResults,
			footerLayoutResults: this.#footerLayoutResults,
			resolvedHeaderByRId: this.#resolvedHeaderByRId,
			resolvedFooterByRId: this.#resolvedFooterByRId,
			resolvedHeaderLayouts: this.#resolvedHeaderLayouts,
			resolvedFooterLayouts: this.#resolvedFooterLayouts
		});
	}
	setDependencies(deps) {
		this.#deps = deps;
	}
	setCallbacks(callbacks) {
		this.#callbacks = callbacks;
	}
	setHoverElements(elements) {
		this.#hoverOverlay = elements.hoverOverlay;
		this.#hoverTooltip = elements.hoverTooltip;
		this.#modeBanner = elements.modeBanner;
	}
	setDocumentMode(mode) {
		this.#documentMode = mode;
		if (this.#activeEditor) this.#applyChildEditorDocumentMode(this.#activeEditor, mode);
	}
	setTrackedChangesRenderConfig(config) {
		const nextConfig = {
			mode: config.mode,
			enabled: config.enabled
		};
		if (this.#trackedChangesRenderConfig.mode === nextConfig.mode && this.#trackedChangesRenderConfig.enabled === nextConfig.enabled) return;
		this.#trackedChangesRenderConfig = nextConfig;
		this.#headerFooterAdapter?.setTrackedChangesRenderConfig(nextConfig);
	}
	setLayoutResults(headerResults, footerResults) {
		this.#headerFooterLayoutSnapshotPending = true;
		this.#headerLayoutResults = headerResults;
		this.#footerLayoutResults = footerResults;
		this.#resolvedHeaderLayouts = headerResults ? headerResults.map((result) => this.#resolveResult(result)) : null;
		this.#resolvedFooterLayouts = footerResults ? footerResults.map((result) => this.#resolveResult(result)) : null;
	}
	initialize() {
		if (!this.#options.editor) return;
		const optionsMedia = this.#options?.mediaFiles;
		const storageMedia = this.#options.editor.storage?.image?.media;
		const converter = this.#options.editor.converter;
		const mediaFiles = optionsMedia ?? storageMedia;
		const result = initHeaderFooterRegistry({
			editor: this.#options.editor,
			converter,
			mediaFiles,
			isDebug: Boolean(this.#options.isDebug),
			initBudgetMs: this.#options.initBudgetMs ?? 200,
			resetSession: () => {
				this.#managerCleanups = [];
				this.#session = { mode: "body" };
				this.#teardownActiveEditorEventBridge();
				this.#activeEditor = null;
				this.#deps?.notifyInputBridgeTargetChanged();
			},
			requestRerender: () => {
				this.#deps?.setPendingDocChange();
				this.#deps?.scheduleRerender();
			},
			previousCleanups: this.#managerCleanups,
			previousAdapter: this.#headerFooterAdapter,
			previousManager: this.#headerFooterManager
		});
		this.#headerFooterIdentifier = result.headerFooterIdentifier;
		this.#headerFooterManager = result.headerFooterManager;
		this.#headerFooterAdapter = result.headerFooterAdapter;
		this.#headerFooterAdapter?.setTrackedChangesRenderConfig(this.#trackedChangesRenderConfig);
		this.#managerCleanups = result.cleanups;
	}
	rebuildRegions(resolvedLayout) {
		this.#headerRegions.clear();
		this.#footerRegions.clear();
		const layoutOptions = this.#deps?.getLayoutOptions() ?? {};
		const fallbackPageHeight = resolvedLayout.pages[0]?.height ?? layoutOptions.pageSize?.h ?? this.#options.defaultPageSize.h;
		if (fallbackPageHeight <= 0) return;
		const sectionFirstPageNumbers = /* @__PURE__ */ new Map();
		const sectionPageCounts = /* @__PURE__ */ new Map();
		for (const p$1 of resolvedLayout.pages) {
			const idx = p$1.sectionIndex ?? 0;
			if (!sectionFirstPageNumbers.has(idx)) sectionFirstPageNumbers.set(idx, p$1.number);
			sectionPageCounts.set(idx, (sectionPageCounts.get(idx) ?? 0) + 1);
		}
		const sectionIdBySectionIndex = this.#buildSectionIdMap();
		const defaultMargins = this.#options.defaultMargins;
		resolvedLayout.pages.forEach((page, pageIndex) => {
			const margins = page.margins ?? layoutOptions.margins ?? defaultMargins;
			const actualPageHeight = page.height ?? fallbackPageHeight;
			const sectionIndex = page.sectionIndex ?? 0;
			const sectionId = sectionIdBySectionIndex.get(sectionIndex) ?? `section-${sectionIndex}`;
			const sectionPageCount = sectionPageCounts.get(sectionIndex) ?? resolvedLayout.pages.length ?? 1;
			const headerPayload = this.#headerDecorationProvider?.(page.number, margins, page) ?? null;
			const headerBox = this.#computeDecorationBox("header", margins, actualPageHeight);
			const displayPageNumber = page.numberText ?? String(page.number);
			const displayPageNumberValue = page.displayNumber ?? page.number;
			const displayPageChapterNumberText = page.pageNumberChapterText;
			const displayPageChapterSeparator = page.pageNumberChapterSeparator;
			this.#headerRegions.set(pageIndex, {
				kind: "header",
				headerFooterRefId: headerPayload?.headerFooterRefId,
				sectionType: headerPayload?.sectionType ?? this.#computeExpectedSectionType("header", page, sectionFirstPageNumbers),
				matchedVariant: headerPayload?.matchedVariant ?? void 0,
				sectionId,
				sectionIndex,
				pageIndex,
				pageNumber: page.number,
				displayPageNumber,
				displayPageNumberValue,
				displayPageChapterNumberText,
				displayPageChapterSeparator,
				sectionPageCount,
				localX: headerPayload?.hitRegion?.x ?? headerBox.x,
				localY: headerPayload?.hitRegion?.y ?? headerBox.offset,
				width: headerPayload?.hitRegion?.width ?? headerBox.width,
				height: headerPayload?.hitRegion?.height ?? headerBox.height,
				contentHeight: headerPayload?.contentHeight,
				minY: headerPayload?.minY
			});
			const footerPayload = this.#footerDecorationProvider?.(page.number, margins, page) ?? null;
			const footerBoxMargins = this.#stripFootnoteReserveFromBottomMargin(margins, page);
			const footerBox = this.#computeDecorationBox("footer", footerBoxMargins, actualPageHeight);
			this.#footerRegions.set(pageIndex, {
				kind: "footer",
				headerFooterRefId: footerPayload?.headerFooterRefId,
				sectionType: footerPayload?.sectionType ?? this.#computeExpectedSectionType("footer", page, sectionFirstPageNumbers),
				matchedVariant: footerPayload?.matchedVariant ?? void 0,
				sectionId,
				sectionIndex,
				pageIndex,
				pageNumber: page.number,
				displayPageNumber,
				displayPageNumberValue,
				displayPageChapterNumberText,
				displayPageChapterSeparator,
				sectionPageCount,
				localX: footerPayload?.hitRegion?.x ?? footerBox.x,
				localY: footerPayload?.hitRegion?.y ?? footerBox.offset,
				width: footerPayload?.hitRegion?.width ?? footerBox.width,
				height: footerPayload?.hitRegion?.height ?? footerBox.height,
				contentHeight: footerPayload?.contentHeight,
				minY: footerPayload?.minY
			});
		});
		if (this.#options.isDebug) {
			for (const [, region] of this.#headerRegions) if (!region.sectionId) console.error("[HeaderFooterSessionManager] Header region missing sectionId", region);
			for (const [, region] of this.#footerRegions) if (!region.sectionId) console.error("[HeaderFooterSessionManager] Footer region missing sectionId", region);
		}
		this.#syncActiveBorder();
	}
	#buildSectionIdMap() {
		const map$1 = /* @__PURE__ */ new Map();
		try {
			const projections = resolveSectionProjections(this.#options.editor);
			for (let i = 0; i < projections.length; i++) map$1.set(i, projections[i].sectionId);
		} catch {}
		return map$1;
	}
	hitTestRegion(x, y$1, layout, knownPageIndex, knownPageLocalY) {
		if (!layout) return null;
		const layoutOptions = this.#deps?.getLayoutOptions() ?? {};
		const defaultPageHeight = layout.pageSize?.h ?? layoutOptions.pageSize?.h ?? this.#options.defaultPageSize.h;
		const pageGap = layout.pageGap ?? 0;
		if (defaultPageHeight <= 0) return null;
		let pageIndex;
		let pageLocalY;
		if (knownPageIndex != null && knownPageLocalY != null) {
			pageIndex = knownPageIndex;
			pageLocalY = knownPageLocalY;
		} else if (knownPageIndex != null) {
			pageIndex = knownPageIndex;
			let pageTopY = 0;
			for (let i = 0; i < pageIndex && i < layout.pages.length; i++) pageTopY += (layout.pages[i].size?.h ?? defaultPageHeight) + pageGap;
			pageLocalY = y$1 - pageTopY;
		} else {
			pageIndex = Math.max(0, Math.floor(y$1 / (defaultPageHeight + pageGap)));
			pageLocalY = y$1 - pageIndex * (defaultPageHeight + pageGap);
		}
		const headerRegion = this.#headerRegions.get(pageIndex);
		if (headerRegion && this.#pointInRegion(headerRegion, x, pageLocalY)) return headerRegion;
		const footerRegion = this.#footerRegions.get(pageIndex);
		if (footerRegion && this.#pointInRegion(footerRegion, x, pageLocalY)) return footerRegion;
		return null;
	}
	getRegionForPage(kind, pageIndex) {
		return (kind === "header" ? this.#headerRegions : this.#footerRegions).get(pageIndex) ?? null;
	}
	findRegionForPage(kind, pageIndex) {
		const regionMap = kind === "header" ? this.#headerRegions : this.#footerRegions;
		if (!regionMap) return null;
		return regionMap.get(pageIndex) ?? regionMap.values().next().value ?? null;
	}
	resolveDescriptorForRegion(region) {
		const manager = this.#headerFooterManager;
		if (!manager) return null;
		if (region.headerFooterRefId) {
			const descriptor = manager.getDescriptorById(region.headerFooterRefId);
			if (descriptor) return descriptor;
		}
		if (region.sectionType) {
			const match$1 = manager.getDescriptors(region.kind).find((entry) => entry.variant === region.sectionType);
			if (match$1) return match$1;
		}
		return null;
	}
	#pointInRegion(region, x, localY) {
		const withinX = x >= region.localX && x <= region.localX + region.width;
		const withinY = localY >= region.localY && localY <= region.localY + region.height;
		return withinX && withinY;
	}
	activateRegion(region, options) {
		const permission = this.#validateEditPermission();
		if (!permission.allowed) {
			this.#callbacks.onEditBlocked?.(permission.reason ?? "restricted");
			return Promise.resolve(null);
		}
		return this.#enterMode(region, options);
	}
	exitMode() {
		if (this.#session.mode === "body") return;
		const editedHeaderId = this.#session.headerFooterRefId;
		if (this.#activeEditor) this.#applyChildEditorDocumentMode(this.#activeEditor, "viewing");
		this.#teardownActiveEditorEventBridge();
		this.#deps?.getStorySessionManager?.()?.exit();
		this.#activeEditor = null;
		this.#session = { mode: "body" };
		this.#emitModeChanged();
		this.#emitEditingContext(this.#options.editor);
		this.#deps?.notifyInputBridgeTargetChanged();
		if (editedHeaderId) this.#headerFooterAdapter?.invalidate(editedHeaderId);
		this.#headerFooterManager?.refresh();
		this.#deps?.setPendingDocChange();
		this.#deps?.scheduleRerender();
		this.#options.editor?.view?.focus();
	}
	focusShortcut(kind) {
		const region = this.getRegionForPage(kind, 0);
		if (!region) {
			this.#callbacks.onEditBlocked?.("missingRegion");
			return;
		}
		this.activateRegion(region);
	}
	#activateStorySessionForRegion(region, descriptor) {
		const storySessionManager = this.#deps?.getStorySessionManager?.() ?? null;
		if (!storySessionManager) return null;
		const locator = {
			kind: "story",
			storyType: "headerFooterPart",
			refId: descriptor.id
		};
		const bodyPageCount = this.#deps?.getBodyPageCount() ?? 1;
		return storySessionManager.activate(locator, {
			commitPolicy: "onExit",
			preferHiddenHost: true,
			hostWidthPx: Math.max(1, region.width),
			editorContext: {
				availableWidth: Math.max(1, region.width),
				availableHeight: Math.max(1, region.height),
				currentPageNumber: Math.max(1, region.pageNumber ?? 1),
				currentPageNumberText: region.displayPageNumber,
				currentPageDisplayNumber: Math.max(1, region.displayPageNumberValue ?? region.pageNumber ?? 1),
				currentPageChapterNumberText: region.displayPageChapterNumberText,
				currentPageChapterSeparator: region.displayPageChapterSeparator,
				totalPageCount: Math.max(1, bodyPageCount),
				sectionPageCount: Math.max(1, region.sectionPageCount ?? bodyPageCount),
				surfaceKind: region.kind
			}
		})?.editor ?? null;
	}
	async #enterMode(region, options) {
		try {
			if (!this.#headerFooterManager) {
				this.clearHover();
				return null;
			}
			if (this.#session.mode !== "body") {
				if (this.#activeEditor) this.#applyChildEditorDocumentMode(this.#activeEditor, "viewing");
				this.#teardownActiveEditorEventBridge();
				this.#deps?.getStorySessionManager?.()?.exit();
				this.#activeEditor = null;
				this.#session = { mode: "body" };
			}
			let descriptor = this.#resolveDescriptorForRegion(region);
			if (!descriptor && region.sectionId) {
				const materializationResult = ensureExplicitHeaderFooterSlot(this.#options.editor, {
					sectionId: region.sectionId,
					kind: region.kind,
					variant: normalizeVariant(region.sectionType ?? "default"),
					addToHistory: false
				});
				if (materializationResult) {
					this.#headerFooterManager.refresh();
					descriptor = this.#headerFooterManager.getDescriptorById(materializationResult.refId) ?? null;
				}
			}
			if (!descriptor) {
				console.warn("[HeaderFooterSessionManager] No descriptor found for region after materialization attempt:", region);
				this.clearHover();
				return null;
			}
			if (!descriptor.id) {
				console.warn("[HeaderFooterSessionManager] Descriptor missing id:", descriptor);
				this.clearHover();
				return null;
			}
			let pageElement = this.#deps?.getPageElement(region.pageIndex) ?? null;
			if (!pageElement) try {
				this.#deps?.scrollPageIntoView(region.pageIndex);
				if (!await this.#deps?.waitForPageMount(region.pageIndex, { timeout: 2e3 })) {
					console.error("[HeaderFooterSessionManager] Failed to mount page for header/footer editing");
					this.clearHover();
					this.#callbacks.onError?.({
						error: /* @__PURE__ */ new Error("Failed to mount page for editing"),
						context: "enterMode"
					});
					return null;
				}
				pageElement = this.#deps?.getPageElement(region.pageIndex) ?? null;
			} catch (scrollError) {
				console.error("[HeaderFooterSessionManager] Error mounting page:", scrollError);
				this.clearHover();
				this.#callbacks.onError?.({
					error: scrollError,
					context: "enterMode.pageMount"
				});
				return null;
			}
			if (!pageElement) {
				console.error("[HeaderFooterSessionManager] Page element not found after mount attempt");
				this.clearHover();
				this.#callbacks.onError?.({
					error: /* @__PURE__ */ new Error("Page element not found after mount"),
					context: "enterMode"
				});
				return null;
			}
			let editor;
			if (!(this.#deps?.getStorySessionManager?.() ?? null)) {
				this.clearHover();
				this.#callbacks.onError?.({
					error: /* @__PURE__ */ new Error("Story session manager unavailable"),
					context: "enterMode.storySessionUnavailable"
				});
				return null;
			}
			try {
				editor = this.#activateStorySessionForRegion(region, descriptor);
			} catch (editorError) {
				console.error("[HeaderFooterSessionManager] Error creating story session:", editorError);
				this.clearHover();
				this.#callbacks.onError?.({
					error: editorError,
					context: "enterMode.storySession"
				});
				return null;
			}
			if (!editor) {
				console.warn("[HeaderFooterSessionManager] Failed to ensure editor for descriptor:", descriptor);
				this.clearHover();
				this.#callbacks.onError?.({
					error: /* @__PURE__ */ new Error("Failed to create editor instance"),
					context: "enterMode.ensureEditor"
				});
				return null;
			}
			const shouldRestoreInitialSelection = options?.initialSelection !== "defer";
			try {
				this.#applyChildEditorDocumentMode(editor, this.#documentMode);
				if (shouldRestoreInitialSelection) this.#applyDefaultSelectionAtStoryEnd(editor, "Could not set cursor to end");
			} catch (editableError) {
				console.error("[HeaderFooterSessionManager] Error setting editor editable:", editableError);
				this.clearHover();
				this.#callbacks.onError?.({
					error: editableError,
					context: "enterMode.setEditable"
				});
				return null;
			}
			this.#activeEditor = editor;
			this.#setupActiveEditorEventBridge(editor);
			this.#session = {
				mode: region.kind,
				kind: region.kind,
				headerFooterRefId: descriptor.id,
				sectionType: descriptor.variant ?? region.sectionType ?? null,
				pageIndex: region.pageIndex,
				pageNumber: region.pageNumber
			};
			this.clearHover();
			try {
				editor.view?.focus();
			} catch (focusError) {
				console.warn("[HeaderFooterSessionManager] Could not focus editor:", focusError);
			}
			if (shouldRestoreInitialSelection) {
				this.#applyDefaultSelectionAtStoryEnd(editor, "Could not restore cursor after focus");
				try {
					editor.view?.focus();
				} catch (focusError) {
					console.warn("[HeaderFooterSessionManager] Could not refocus editor after restoring selection:", focusError);
				}
				this.#scheduleSelectionRestoreAfterFocus(editor);
			}
			this.#emitModeChanged();
			this.#emitEditingContext(editor);
			this.#deps?.notifyInputBridgeTargetChanged();
			this.#deps?.setPendingDocChange();
			this.#deps?.scheduleRerender();
			return editor;
		} catch (error) {
			console.error("[HeaderFooterSessionManager] Unexpected error in enterMode:", error);
			try {
				this.#deps?.getStorySessionManager?.()?.exit();
				this.clearHover();
				this.#teardownActiveEditorEventBridge();
				this.#activeEditor = null;
				this.#session = { mode: "body" };
			} catch (cleanupError) {
				console.error("[HeaderFooterSessionManager] Error during cleanup:", cleanupError);
			}
			this.#callbacks.onError?.({
				error,
				context: "enterMode"
			});
			return null;
		}
	}
	#applyChildEditorDocumentMode(editor, mode) {
		const pm = editor.view?.dom ?? null;
		if (mode === "viewing") {
			editor.commands?.enableTrackChangesShowOriginal?.();
			editor.setOptions?.({ documentMode: "viewing" });
			editor.setEditable?.(false);
		} else if (mode === "suggesting") {
			editor.commands?.disableTrackChangesShowOriginal?.();
			editor.commands?.enableTrackChanges?.();
			editor.setOptions?.({ documentMode: "suggesting" });
			editor.setEditable?.(true);
		} else {
			editor.commands?.disableTrackChangesShowOriginal?.();
			editor.commands?.disableTrackChanges?.();
			editor.setOptions?.({ documentMode: "editing" });
			editor.setEditable?.(true);
		}
		if (pm instanceof HTMLElement) {
			pm.setAttribute("aria-readonly", mode === "viewing" ? "true" : "false");
			pm.setAttribute("documentmode", mode);
			pm.classList.toggle("view-mode", mode === "viewing");
		}
	}
	#getDefaultSelectionAtStoryEnd(editor) {
		const doc$1 = editor.state?.doc;
		if (!doc$1) return null;
		const endPos = doc$1.content.size - 1;
		const pos = Math.max(1, endPos);
		return {
			from: pos,
			to: pos
		};
	}
	#applyEditorTextSelection(editor, selection, warningMessage) {
		try {
			editor.commands?.setTextSelection?.(selection);
		} catch (error) {
			console.warn(`[HeaderFooterSessionManager] ${warningMessage}:`, error);
		}
	}
	#applyDefaultSelectionAtStoryEnd(editor, warningMessage) {
		const selection = this.#getDefaultSelectionAtStoryEnd(editor);
		if (!selection) return;
		this.#applyEditorTextSelection(editor, selection, warningMessage);
	}
	#scheduleSelectionRestoreAfterFocus(editor) {
		const win = editor.view?.dom?.ownerDocument?.defaultView;
		if (!win) return;
		win.requestAnimationFrame(() => {
			if (this.#activeEditor !== editor || this.#session.mode === "body") return;
			this.#applyDefaultSelectionAtStoryEnd(editor, "Could not restore cursor on the next frame");
			try {
				editor.view?.focus();
			} catch (focusError) {
				console.warn("[HeaderFooterSessionManager] Could not refocus editor on the next frame:", focusError);
			}
		});
	}
	#validateEditPermission() {
		if (this.#deps?.isViewLocked()) return {
			allowed: false,
			reason: "documentMode"
		};
		if (!this.#options.editor?.isEditable) return {
			allowed: false,
			reason: "readOnly"
		};
		return { allowed: true };
	}
	#resolveDescriptorForRegion(region) {
		if (!this.#headerFooterManager) return null;
		if (region.headerFooterRefId) {
			const descriptor = this.#headerFooterManager.getDescriptorById(region.headerFooterRefId);
			if (descriptor) return descriptor;
		}
		if (region.sectionType) {
			const match$1 = this.#headerFooterManager.getDescriptors(region.kind).find((entry) => entry.variant === region.sectionType);
			if (match$1) return match$1;
		}
		return null;
	}
	#emitModeChanged() {
		this.#callbacks.onModeChanged?.(this.#session);
		this.#callbacks.onUpdateAwarenessSession?.(this.#session);
		this.#updateModeBanner();
		this.#syncActiveBorder();
	}
	#isActiveDecoration(kind, headerFooterRefId, pageNumber) {
		if (this.#session.mode !== kind) return false;
		if (headerFooterRefId && this.#session.headerFooterRefId) return headerFooterRefId === this.#session.headerFooterRefId;
		return this.#session.pageNumber === pageNumber;
	}
	#emitEditingContext(editor) {
		this.#callbacks.onEditingContext?.({
			kind: this.#session.mode,
			editor,
			headerId: this.#session.headerFooterRefId,
			sectionType: this.#session.sectionType
		});
		const message = this.#session.mode === "body" ? "Exited header/footer edit mode." : `Editing ${this.#session.kind === "header" ? "Header" : "Footer"} (${this.#session.sectionType ?? "default"})`;
		this.#callbacks.onAnnounce?.(message);
	}
	#setupActiveEditorEventBridge(editor) {
		this.#teardownActiveEditorEventBridge();
		const emitSurfaceUpdate = () => {
			if (this.#session.mode !== "header" && this.#session.mode !== "footer") return;
			this.#callbacks.onSurfaceUpdate?.({
				sourceEditor: editor,
				surface: this.#session.mode,
				headerId: this.#session.headerFooterRefId ?? null,
				sectionType: this.#session.sectionType ?? null
			});
		};
		const emitSurfaceTransaction = ({ transaction, duration }) => {
			if (this.#session.mode !== "header" && this.#session.mode !== "footer") return;
			this.#callbacks.onSurfaceTransaction?.({
				sourceEditor: editor,
				surface: this.#session.mode,
				headerId: this.#session.headerFooterRefId ?? null,
				sectionType: this.#session.sectionType ?? null,
				transaction,
				duration
			});
		};
		editor.on("update", emitSurfaceUpdate);
		editor.on("transaction", emitSurfaceTransaction);
		this.#activeEditorEventCleanup = () => {
			editor.off?.("update", emitSurfaceUpdate);
			editor.off?.("transaction", emitSurfaceTransaction);
		};
	}
	#teardownActiveEditorEventBridge() {
		try {
			this.#activeEditorEventCleanup?.();
		} catch (error) {
			console.warn("[HeaderFooterSessionManager] Failed to clean up active editor bridge:", error);
		} finally {
			this.#activeEditorEventCleanup = null;
		}
	}
	#updateModeBanner() {
		if (!this.#modeBanner) return;
		if (this.#session.mode === "body") {
			this.#modeBanner.style.display = "none";
			this.#modeBanner.textContent = "";
			return;
		}
		const title = this.#session.kind === "header" ? "Header" : "Footer";
		const variant = this.#session.sectionType ?? "default";
		const page = this.#session.pageNumber != null ? `Page ${this.#session.pageNumber}` : "";
		this.#modeBanner.textContent = `Editing ${title} (${variant}) ${page} – Press Esc to return`;
		this.#modeBanner.style.display = "block";
	}
	renderHover(region) {
		if (this.#documentMode === "viewing") {
			this.clearHover();
			return;
		}
		if (!this.#hoverOverlay || !this.#hoverTooltip) return;
		this.#hoverRegion = region;
		const coords = this.#deps?.convertPageLocalToOverlayCoords(region.pageIndex, region.localX, region.localY);
		if (!coords) {
			this.clearHover();
			return;
		}
		this.#hoverOverlay.style.display = "block";
		this.#hoverOverlay.style.left = `${coords.x}px`;
		this.#hoverOverlay.style.top = `${coords.y}px`;
		this.#hoverOverlay.style.width = `${region.width}px`;
		this.#hoverOverlay.style.height = `${region.height}px`;
		const tooltipText = `Double-click to edit ${region.kind === "header" ? "header" : "footer"}`;
		this.#hoverTooltip.textContent = tooltipText;
		this.#hoverTooltip.style.display = "block";
		this.#hoverTooltip.style.left = `${coords.x}px`;
		const tooltipHeight = 24;
		const spaceAbove = coords.y;
		const regionHeight = region.height;
		const tooltipY = spaceAbove < tooltipHeight + 4 ? coords.y + regionHeight + 4 : coords.y - tooltipHeight;
		this.#hoverTooltip.style.top = `${Math.max(0, tooltipY)}px`;
	}
	clearHover() {
		this.#hoverRegion = null;
		if (this.#hoverOverlay) this.#hoverOverlay.style.display = "none";
		if (this.#hoverTooltip) this.#hoverTooltip.style.display = "none";
	}
	get hoverRegion() {
		return this.#hoverRegion;
	}
	#getActiveRegion() {
		if (this.#session.mode === "header") return this.#headerRegions.get(this.#session.pageIndex ?? -1) ?? null;
		if (this.#session.mode === "footer") return this.#footerRegions.get(this.#session.pageIndex ?? -1) ?? null;
		return null;
	}
	#hideActiveBorder() {
		if (this.#activeBorderLine) {
			this.#activeBorderLine.remove();
			this.#activeBorderLine = null;
		}
	}
	#syncActiveBorder() {
		this.#hideActiveBorder();
		const region = this.#getActiveRegion();
		if (!region || this.#session.mode === "body") return;
		const pageElement = this.#deps?.getPageElement(region.pageIndex);
		if (!pageElement) return;
		const borderLine = pageElement.ownerDocument.createElement("div");
		borderLine.className = "superdoc-header-footer-border";
		Object.assign(borderLine.style, {
			position: "absolute",
			left: "0",
			right: "0",
			top: `${region.kind === "header" ? region.localY + region.height : region.localY}px`,
			height: "1px",
			backgroundColor: "#4472c4",
			pointerEvents: "none",
			zIndex: "8"
		});
		pageElement.appendChild(borderLine);
		this.#activeBorderLine = borderLine;
	}
	buildLayoutInput() {
		if (!this.#headerFooterAdapter) return null;
		const headerBlocks = this.#headerFooterAdapter.getBatch("header");
		const footerBlocks = this.#headerFooterAdapter.getBatch("footer");
		const headerBlocksByRId = this.#headerFooterAdapter.getBlocksByRId("header");
		const footerBlocksByRId = this.#headerFooterAdapter.getBlocksByRId("footer");
		if (!headerBlocks && !footerBlocks && !headerBlocksByRId && !footerBlocksByRId) return null;
		const constraints = this.#computeConstraints();
		if (!constraints) return null;
		return {
			headerBlocks,
			footerBlocks,
			headerBlocksByRId,
			footerBlocksByRId,
			constraints
		};
	}
	#computeConstraints() {
		const layoutOptions = this.#deps?.getLayoutOptions() ?? {};
		const pageSize = layoutOptions.pageSize ?? this.#options.defaultPageSize;
		const margins = layoutOptions.margins ?? this.#options.defaultMargins;
		const marginLeft = margins.left ?? this.#options.defaultMargins.left ?? 0;
		const marginRight = margins.right ?? this.#options.defaultMargins.right ?? 0;
		const bodyContentWidth = pageSize.w - (marginLeft + marginRight);
		if (!Number.isFinite(bodyContentWidth) || bodyContentWidth <= 0) return null;
		const measurementWidth = bodyContentWidth;
		const marginTop = margins.top ?? this.#options.defaultMargins.top ?? 0;
		const marginBottom = margins.bottom ?? this.#options.defaultMargins.bottom ?? 0;
		if (!Number.isFinite(marginTop) || !Number.isFinite(marginBottom)) {
			console.warn("[HeaderFooterSessionManager] Invalid top or bottom margin: not a finite number");
			return null;
		}
		const totalVerticalMargins = marginTop + marginBottom;
		if (totalVerticalMargins >= pageSize.h) {
			console.warn(`[HeaderFooterSessionManager] Invalid margins: top (${marginTop}) + bottom (${marginBottom}) = ${totalVerticalMargins} >= page height (${pageSize.h})`);
			return null;
		}
		const MIN_HEADER_FOOTER_HEIGHT = 1;
		const height = Math.max(MIN_HEADER_FOOTER_HEIGHT, pageSize.h - totalVerticalMargins);
		const headerMargin = margins.header ?? 0;
		const footerMargin = margins.footer ?? 0;
		const headerBand = Math.max(MIN_HEADER_FOOTER_HEIGHT, marginTop - headerMargin);
		const footerBand = Math.max(MIN_HEADER_FOOTER_HEIGHT, marginBottom - footerMargin);
		const overflowBaseHeight = Math.max(headerBand, footerBand);
		return {
			width: measurementWidth,
			height,
			pageWidth: pageSize.w,
			pageHeight: pageSize.h,
			margins: {
				left: marginLeft,
				right: marginRight,
				top: marginTop,
				bottom: marginBottom,
				header: headerMargin
			},
			overflowBaseHeight
		};
	}
	#resolveResult(result, storyId) {
		return resolveResult(result, storyId, this.#options.getFontSignature?.() ?? "");
	}
	async layoutPerRId(headerFooterInput, layout, sectionMetadata, fontResolver, hasFace, effectiveSignature) {
		await layoutPerRIdHeaderFooters(headerFooterInput, layout, sectionMetadata, {
			headerLayoutsByRId: this.#headerLayoutsByRId,
			footerLayoutsByRId: this.#footerLayoutsByRId
		}, fontResolver, hasFace, effectiveSignature);
		this.#resolvedHeaderByRId.clear();
		for (const [key, result] of this.#headerLayoutsByRId) this.#resolvedHeaderByRId.set(key, this.#resolveResult(result, storyIdFromHeaderFooterLayoutKey(key)));
		this.#resolvedFooterByRId.clear();
		for (const [key, result] of this.#footerLayoutsByRId) this.#resolvedFooterByRId.set(key, this.#resolveResult(result, storyIdFromHeaderFooterLayoutKey(key)));
	}
	#computeMetrics(kind, layoutHeight, box, pageHeight, footerMargin) {
		const validatedLayoutHeight = Number.isFinite(layoutHeight) && layoutHeight >= 0 ? layoutHeight : 0;
		const containerHeight = Math.max(box.height, validatedLayoutHeight);
		return {
			layoutHeight: validatedLayoutHeight,
			containerHeight,
			offset: kind === "header" ? box.offset : Math.max(0, pageHeight - footerMargin - containerHeight)
		};
	}
	#computeDecorationBox(kind, margins, pageHeight) {
		const pageSize = (this.#deps?.getLayoutOptions() ?? {}).pageSize ?? this.#options.defaultPageSize;
		const defaultMargins = this.#options.defaultMargins;
		const marginLeft = margins?.left ?? defaultMargins.left ?? 0;
		const marginRight = margins?.right ?? defaultMargins.right ?? 0;
		const marginTop = margins?.top ?? defaultMargins.top ?? 0;
		const marginBottom = margins?.bottom ?? defaultMargins.bottom ?? 0;
		const headerMargin = margins?.header ?? defaultMargins.header ?? 0;
		const footerMargin = margins?.footer ?? defaultMargins.footer ?? 0;
		const width = pageSize.w - marginLeft - marginRight;
		if (kind === "header") return {
			x: marginLeft,
			width,
			height: Math.max(1, marginTop - headerMargin),
			offset: headerMargin
		};
		else return {
			x: marginLeft,
			width,
			height: Math.max(1, marginBottom - footerMargin),
			offset: pageHeight - marginBottom
		};
	}
	#computeExpectedSectionType(kind, page, sectionFirstPageNumbers) {
		const pageNumber = page.number;
		const effectivePageNumber = page.effectivePageNumber ?? page.displayNumber ?? pageNumber;
		const sectionIndex = page.sectionIndex ?? 0;
		const isFirstPageOfSection = sectionFirstPageNumbers.get(sectionIndex) === pageNumber;
		const converter = this.#options.editor.converter;
		const hasAlternateHeaders = this.#multiSectionIdentifier?.alternateHeaders === true || converter?.pageStyles?.alternateHeaders === true;
		const headerIds = converter?.headerIds;
		const footerIds = converter?.footerIds;
		let titlePgEnabled = headerIds?.titlePg === true || footerIds?.titlePg === true;
		if (this.#multiSectionIdentifier?.sectionTitlePg?.has(sectionIndex)) titlePgEnabled = this.#multiSectionIdentifier.sectionTitlePg.get(sectionIndex) === true;
		if (isFirstPageOfSection && titlePgEnabled) return "first";
		if (hasAlternateHeaders) return effectivePageNumber % 2 === 0 ? "even" : "odd";
		return "default";
	}
	#stripFootnoteReserveFromBottomMargin(margins, page) {
		const footnoteReserved = page?.footnoteReserved ?? 0;
		if (footnoteReserved <= 0) return margins;
		const currentBottom = margins?.bottom ?? this.#options.defaultMargins.bottom ?? 0;
		return {
			...margins,
			bottom: Math.max(0, currentBottom - footnoteReserved)
		};
	}
	computeSelectionRects(from$1, to) {
		if (this.#session.mode === "body") return [];
		const activeEditor = this.#activeEditor;
		if (!activeEditor?.view) return [];
		const view = activeEditor.view;
		const context = this.getContext();
		if (!context) {
			console.warn("[HeaderFooterSessionManager] Header/footer context unavailable for selection rects", {
				mode: this.#session.mode,
				pageIndex: this.#session.pageIndex
			});
			return [];
		}
		const region = context.region;
		const pageIndex = region.pageIndex;
		const bodyPageHeight = this.#deps?.getBodyPageHeight() ?? this.#options.defaultPageSize.h;
		const hiddenHostRects = this.#computeHiddenHostSelectionRects(context, from$1, to, bodyPageHeight);
		if (hiddenHostRects) return hiddenHostRects;
		const domRectList = this.#computeEditorRangeClientRects(view, from$1, to);
		if (!domRectList.length) return [];
		const editorHostRect = view.dom.getBoundingClientRect();
		const layoutOptions = this.#deps?.getLayoutOptions() ?? {};
		const zoom = typeof layoutOptions.zoom === "number" && Number.isFinite(layoutOptions.zoom) && layoutOptions.zoom > 0 ? layoutOptions.zoom : 1;
		const toLayoutUnits = (viewportPixels) => viewportPixels / zoom;
		const layoutRects = [];
		for (const clientRect of domRectList) {
			const horizontallyOverlaps = clientRect.right > editorHostRect.left && clientRect.left < editorHostRect.right;
			const verticallyOverlaps = clientRect.bottom > editorHostRect.top && clientRect.top < editorHostRect.bottom;
			if (!horizontallyOverlaps || !verticallyOverlaps) continue;
			const localX = toLayoutUnits(clientRect.left - editorHostRect.left);
			const localY = toLayoutUnits(clientRect.top - editorHostRect.top);
			const width = toLayoutUnits(clientRect.width);
			const height = toLayoutUnits(clientRect.height);
			if (!Number.isFinite(localX) || !Number.isFinite(localY) || width <= 0 || height <= 0) continue;
			layoutRects.push({
				pageIndex,
				x: region.localX + localX,
				y: pageIndex * bodyPageHeight + region.localY + localY,
				width,
				height
			});
		}
		return layoutRects;
	}
	#computeHiddenHostSelectionRects(context, from$1, to, bodyPageHeight) {
		const activeEditor = this.#activeEditor;
		if (!(activeEditor?.view?.dom)?.closest?.(".presentation-editor__story-hidden-host")) return null;
		const visibleSurfaceRects = this.#computeVisibleSurfaceSelectionRects(context, from$1, to, bodyPageHeight);
		if (visibleSurfaceRects?.length) return visibleSurfaceRects;
		const localRects = selectionToRects(context.layout, context.blocks, context.measures, from$1, to) ?? [];
		if (localRects.length) return localRects.map((rect) => ({
			pageIndex: context.region.pageIndex,
			x: context.region.localX + rect.x,
			y: context.region.pageIndex * bodyPageHeight + context.region.localY + rect.y,
			width: rect.width,
			height: rect.height
		}));
		const liveRect = activeEditor ? this.#computeHiddenHostLiveRangeRect(activeEditor, from$1, to, context, bodyPageHeight) : null;
		return liveRect ? [liveRect] : [];
	}
	#computeVisibleSurfaceSelectionRects(context, from$1, to, bodyPageHeight) {
		const pageElement = this.#deps?.getPageElement(context.region.pageIndex);
		if (!pageElement) return null;
		const surfaceSelector = this.#session.mode === "header" ? ".superdoc-page-header" : ".superdoc-page-footer";
		const surfaceElement = pageElement.querySelector(surfaceSelector);
		if (!surfaceElement) return null;
		const surfaceEntries = findSurfaceEntriesInRange(buildSurfacePmEntries(surfaceElement), from$1, to, { boundaryInclusive: true });
		if (!surfaceEntries.length) return null;
		const start$1 = Math.min(from$1, to);
		const end$1 = Math.max(from$1, to);
		const startEntry = surfaceEntries.find((entry) => start$1 >= entry.pmStart && start$1 <= entry.pmEnd) ?? surfaceEntries[0] ?? null;
		const endEntry = surfaceEntries.find((entry) => end$1 >= entry.pmStart && end$1 <= entry.pmEnd) ?? surfaceEntries[surfaceEntries.length - 1] ?? null;
		if (!startEntry || !endEntry) return null;
		const doc$1 = pageElement.ownerDocument;
		if (!doc$1?.createRange) return null;
		const range = doc$1.createRange();
		try {
			if (!setSurfaceRangeStart(range, startEntry, start$1)) return null;
			if (!setSurfaceRangeEnd(range, endEntry, end$1)) return null;
		} catch {
			return null;
		}
		let clientRects = [];
		try {
			clientRects = deduplicateOverlappingRects(Array.from(range.getClientRects()));
		} catch {
			return null;
		}
		if (!clientRects.length) return null;
		const layoutOptions = this.#deps?.getLayoutOptions() ?? {};
		const zoom = typeof layoutOptions.zoom === "number" && Number.isFinite(layoutOptions.zoom) && layoutOptions.zoom > 0 ? layoutOptions.zoom : 1;
		const pageRect = pageElement.getBoundingClientRect();
		const layoutRects = [];
		for (const clientRect of clientRects) {
			const width = clientRect.width / zoom;
			const height = clientRect.height / zoom;
			if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) continue;
			const localX = (clientRect.left - pageRect.left) / zoom;
			const localY = (clientRect.top - pageRect.top) / zoom;
			if (!Number.isFinite(localX) || !Number.isFinite(localY)) continue;
			layoutRects.push({
				pageIndex: context.region.pageIndex,
				x: localX,
				y: context.region.pageIndex * bodyPageHeight + localY,
				width: Math.max(1, width),
				height: Math.max(1, height)
			});
		}
		return layoutRects.length ? layoutRects : null;
	}
	#computeVisibleSurfaceCaretRect(context, pos, bodyPageHeight) {
		const pageElement = this.#deps?.getPageElement(context.region.pageIndex);
		if (!pageElement) return null;
		const surfaceSelector = this.#session.mode === "header" ? ".superdoc-page-header" : ".superdoc-page-footer";
		const surfaceElement = pageElement.querySelector(surfaceSelector);
		if (!surfaceElement) return null;
		const behindDocFragments = Array.from(pageElement.querySelectorAll(`[data-behind-doc-section="${this.#session.mode}"]`));
		const entry = findSurfaceEntryAtPos([...buildSurfacePmEntries(surfaceElement), ...behindDocFragments.flatMap((frag) => buildSurfacePmEntries(frag))].sort((a, b$1) => a.pmStart - b$1.pmStart || a.pmEnd - b$1.pmEnd), pos);
		if (!entry) return null;
		const pageRect = pageElement.getBoundingClientRect();
		const zoom = typeof this.#deps?.getLayoutOptions()?.zoom === "number" && Number.isFinite(this.#deps?.getLayoutOptions()?.zoom) && (this.#deps?.getLayoutOptions()?.zoom ?? 0) > 0 ? this.#deps?.getLayoutOptions()?.zoom : 1;
		const textNode = Array.from(entry.el.childNodes).find((node) => node.nodeType === Node.TEXT_NODE);
		if (textNode) {
			const range = entry.el.ownerDocument?.createRange();
			if (!range) return null;
			const charIndex = mapPmPosToTextOffset(pos, entry.pmStart, entry.pmEnd, textNode.length);
			range.setStart(textNode, charIndex);
			range.setEnd(textNode, charIndex);
			const rangeRect = range.getBoundingClientRect();
			if (!Number.isFinite(rangeRect.left) || !Number.isFinite(rangeRect.top) || rangeRect.height <= 0) return null;
			return {
				pageIndex: context.region.pageIndex,
				x: (rangeRect.left - pageRect.left) / zoom,
				y: context.region.pageIndex * bodyPageHeight + (rangeRect.top - pageRect.top) / zoom,
				width: 1,
				height: Math.max(1, rangeRect.height / zoom)
			};
		}
		const elementRect = entry.el.getBoundingClientRect();
		if (!Number.isFinite(elementRect.left) || !Number.isFinite(elementRect.top) || elementRect.height <= 0) return null;
		const localX = (pos <= entry.pmStart ? elementRect.left : elementRect.right) - pageRect.left;
		return {
			pageIndex: context.region.pageIndex,
			x: localX / zoom,
			y: context.region.pageIndex * bodyPageHeight + (elementRect.top - pageRect.top) / zoom,
			width: 1,
			height: Math.max(1, elementRect.height / zoom)
		};
	}
	#computeHiddenHostLiveRangeRect(editor, from$1, to, context, bodyPageHeight) {
		const view = editor.view;
		if (!view || typeof view.coordsAtPos !== "function") return null;
		const docSize = editor.state?.doc?.content?.size ?? 0;
		const start$1 = Math.max(0, Math.min(Math.min(from$1, to), docSize));
		const end$1 = Math.max(0, Math.min(Math.max(from$1, to), docSize));
		const layoutOptions = this.#deps?.getLayoutOptions() ?? {};
		const zoom = typeof layoutOptions.zoom === "number" && Number.isFinite(layoutOptions.zoom) && layoutOptions.zoom > 0 ? layoutOptions.zoom : 1;
		const editorHostRect = view.dom.getBoundingClientRect();
		try {
			const startCoords = view.coordsAtPos(start$1);
			const endCoords = start$1 === end$1 ? startCoords : view.coordsAtPos(end$1, -1);
			const left$1 = Math.min(startCoords.left, endCoords.left);
			const right$1 = Math.max(startCoords.right, endCoords.right);
			const top$1 = Math.min(startCoords.top, endCoords.top);
			const bottom$1 = Math.max(startCoords.bottom, endCoords.bottom);
			const width = Math.max(1, (right$1 - left$1) / zoom);
			const height = Math.max(1, (bottom$1 - top$1) / zoom);
			const localX = (left$1 - editorHostRect.left) / zoom;
			const localY = (top$1 - editorHostRect.top) / zoom;
			if (!Number.isFinite(localX) || !Number.isFinite(localY)) return null;
			return {
				pageIndex: context.region.pageIndex,
				x: context.region.localX + localX,
				y: context.region.pageIndex * bodyPageHeight + context.region.localY + localY,
				width,
				height
			};
		} catch {
			return null;
		}
	}
	#computeEditorRangeClientRects(view, from$1, to) {
		if (!Number.isFinite(from$1) || !Number.isFinite(to)) return [];
		const docSize = view.state?.doc?.content?.size ?? 0;
		const start$1 = Math.max(0, Math.min(Math.min(from$1, to), docSize));
		const end$1 = Math.max(0, Math.min(Math.max(from$1, to), docSize));
		if (start$1 === end$1 || typeof view.domAtPos !== "function") return [];
		const range = view.dom.ownerDocument?.createRange?.();
		if (!range) return [];
		try {
			const startBoundary = view.domAtPos(start$1);
			const endBoundary = view.domAtPos(end$1);
			range.setStart(startBoundary.node, startBoundary.offset);
			range.setEnd(endBoundary.node, endBoundary.offset);
		} catch {
			return [];
		}
		try {
			return deduplicateOverlappingRects(Array.from(range.getClientRects()));
		} catch {
			return [];
		}
	}
	computeCaretRect(pos) {
		if (this.#session.mode === "body") return null;
		const context = this.getContext();
		if (!context) return null;
		const region = context.region;
		const bodyPageHeight = this.#deps?.getBodyPageHeight() ?? this.#options.defaultPageSize.h;
		const visibleSurfaceCaretRect = this.#computeVisibleSurfaceCaretRect(context, pos, bodyPageHeight);
		if (visibleSurfaceCaretRect) return visibleSurfaceCaretRect;
		const layoutOptions = this.#deps?.getLayoutOptions() ?? {};
		const geometry = computeCaretLayoutRectGeometry({
			layout: context.layout,
			blocks: context.blocks,
			measures: context.measures,
			painterHost: null,
			viewportHost: this.#options.visibleHost,
			visibleHost: this.#options.visibleHost,
			zoom: layoutOptions.zoom ?? 1
		}, pos, false);
		if (geometry) return {
			pageIndex: region.pageIndex,
			x: region.localX + geometry.x,
			y: region.pageIndex * bodyPageHeight + region.localY + geometry.y,
			width: 1,
			height: geometry.height
		};
		const liveRect = this.#activeEditor ? this.#computeHiddenHostLiveRangeRect(this.#activeEditor, pos, pos, context, bodyPageHeight) : null;
		if (liveRect) return {
			pageIndex: liveRect.pageIndex,
			x: liveRect.x,
			y: liveRect.y,
			width: 1,
			height: liveRect.height
		};
		return null;
	}
	getContext() {
		if (this.#session.mode === "body") return null;
		if (!this.#headerFooterManager) return null;
		const pageIndex = this.#session.pageIndex;
		if (pageIndex == null) return null;
		const region = (this.#session.mode === "header" ? this.#headerRegions : this.#footerRegions).get(pageIndex);
		if (!region) {
			console.warn("[HeaderFooterSessionManager] Header/footer region not found for pageIndex:", pageIndex);
			return null;
		}
		const activeLayoutResult = this.#resolveActiveLayoutResult(region);
		if (!activeLayoutResult) {
			console.warn("[HeaderFooterSessionManager] Header/footer layout results not available");
			return null;
		}
		return {
			layout: {
				pageSize: {
					w: Math.max(1, region.width),
					h: Math.max(1, activeLayoutResult.layout.height ?? region.height ?? 1)
				},
				pages: activeLayoutResult.layout.pages.map((page) => ({
					number: page.number,
					displayNumber: page.displayNumber,
					numberText: page.numberText,
					fragments: page.fragments
				}))
			},
			blocks: activeLayoutResult.blocks,
			measures: activeLayoutResult.measures,
			region
		};
	}
	#resolveActiveLayoutResult(region) {
		const layoutsByRId = this.#session.mode === "header" ? this.#headerLayoutsByRId : this.#footerLayoutsByRId;
		const concreteRefId = this.#session.headerFooterRefId ?? region.headerFooterRefId ?? null;
		if (concreteRefId && layoutsByRId.size > 0) {
			const compositeKey = buildSectionAwareHeaderFooterLayoutKey(concreteRefId, region.sectionIndex ?? 0);
			const layoutByRef = layoutsByRId.get(compositeKey) ?? layoutsByRId.get(concreteRefId) ?? null;
			if (layoutByRef) return layoutByRef;
		}
		const results = this.#session.mode === "header" ? this.#headerLayoutResults : this.#footerLayoutResults;
		if (!results || results.length === 0) return null;
		return results.find((entry) => entry.type === this.#session.sectionType) ?? results[0] ?? null;
	}
	getPageHeight() {
		const context = this.getContext();
		if (!context) {
			console.warn("[HeaderFooterSessionManager] Header/footer context missing when computing page height");
			return 1;
		}
		return context.layout.pageSize?.h ?? context.region.height ?? 1;
	}
	setMultiSectionIdentifier(identifier) {
		this.#multiSectionIdentifier = identifier;
	}
	updateDecorationProviders(resolvedLayout) {
		this.#headerDecorationProvider = this.createDecorationProvider("header", resolvedLayout);
		this.#footerDecorationProvider = this.createDecorationProvider("footer", resolvedLayout);
		this.rebuildRegions(resolvedLayout);
		this.#publishedHeaderFooterLayoutSnapshot = this.#buildLiveHeaderFooterLayoutSnapshot();
		this.#headerFooterLayoutSnapshotPending = false;
	}
	resolveAlignedDecorationItems(fragments, slotPageNumber, result, cachedResolvedLayout, contextLabel, storyId) {
		const cachedItems = (cachedResolvedLayout?.pages.find((page) => page.number === slotPageNumber))?.items;
		if (cachedItems && cachedItems.length === fragments.length) return cachedItems;
		if (cachedItems) console.warn(`[HeaderFooterSessionManager] Resolved items length (${cachedItems.length}) does not match fragments length (${fragments.length}) for ${contextLabel}. Recomputing items.`);
		const freshItems = this.#resolveResult(result, storyId).pages.find((page) => page.number === slotPageNumber)?.items;
		if (freshItems && freshItems.length === fragments.length) return freshItems;
		if (freshItems) console.warn(`[HeaderFooterSessionManager] Fresh resolved items length (${freshItems.length}) does not match fragments length (${fragments.length}) for ${contextLabel}. Dropping items.`);
	}
	createDecorationProvider(kind, resolvedLayout) {
		const results = kind === "header" ? this.#headerLayoutResults : this.#footerLayoutResults;
		const layoutsByRId = kind === "header" ? this.#headerLayoutsByRId : this.#footerLayoutsByRId;
		const resolvedResults = kind === "header" ? this.#resolvedHeaderLayouts : this.#resolvedFooterLayouts;
		const resolvedByRId = kind === "header" ? this.#resolvedHeaderByRId : this.#resolvedFooterByRId;
		if ((!results || results.length === 0) && (!layoutsByRId || layoutsByRId.size === 0)) return;
		const multiSectionId = this.#multiSectionIdentifier;
		const legacyIdentifier = this.#headerFooterIdentifier ?? extractIdentifierFromConverter(this.#options.editor.converter);
		const layoutOptions = this.#deps?.getLayoutOptions() ?? {};
		const defaultPageSize = this.#options.defaultPageSize;
		const defaultMargins = this.#options.defaultMargins;
		const sectionFirstPageNumbers = /* @__PURE__ */ new Map();
		for (const p$1 of resolvedLayout.pages) {
			const idx = p$1.sectionIndex ?? 0;
			if (!sectionFirstPageNumbers.has(idx)) sectionFirstPageNumbers.set(idx, p$1.number);
		}
		const hasSectionResolution = hasSectionRefsForKind(multiSectionId, kind);
		return (pageNumber, pageMargins, page) => {
			const sectionIndex = page?.sectionIndex ?? 0;
			const effectivePageNumber = page?.effectivePageNumber ?? page?.displayNumber ?? pageNumber;
			const firstPageInSection = sectionFirstPageNumbers.get(sectionIndex);
			const sectionPageNumber = typeof firstPageInSection === "number" ? pageNumber - firstPageInSection + 1 : pageNumber;
			const headerFooterType = hasSectionResolution ? getHeaderFooterTypeForSection(effectivePageNumber, sectionIndex, multiSectionId, {
				kind,
				sectionPageNumber,
				parityPageNumber: effectivePageNumber
			}) : getHeaderFooterType(pageNumber, legacyIdentifier, {
				kind,
				parityPageNumber: effectivePageNumber
			});
			if (!headerFooterType) return null;
			const pageSectionRefs = kind === "header" ? page?.sectionRefs?.headerRefs : page?.sectionRefs?.footerRefs;
			const sectionResolvedRef = hasSectionResolution ? resolveEffectiveHeaderFooterRef({
				sections: multiSectionId.sections,
				sectionIndex,
				kind,
				variant: headerFooterType
			}) : null;
			const legacyRefs = kind === "header" ? legacyIdentifier.headerIds : legacyIdentifier.footerIds;
			const resolvedRef = refForVariant(pageSectionRefs, headerFooterType) ?? sectionResolvedRef ?? (!hasSectionResolution ? refForVariant(legacyRefs, headerFooterType) : void 0);
			const sectionRId = resolvedRef?.refId;
			const layoutVariantType = resolvedRef?.matchedVariant ?? headerFooterType;
			const compositeKey = sectionRId ? `${sectionRId}::s${sectionIndex}` : void 0;
			const rIdLayoutKey = compositeKey && layoutsByRId.has(compositeKey) && compositeKey || sectionRId && layoutsByRId.has(sectionRId) && sectionRId || void 0;
			if (rIdLayoutKey) {
				const rIdLayout = layoutsByRId.get(rIdLayoutKey);
				if (!rIdLayout) console.warn(`[HeaderFooterSessionManager] Inconsistent state: layoutsByRId.has('${sectionRId}') returned true but get() returned undefined`);
				else {
					const slotPage$1 = this.#findPageForNumber(rIdLayout.layout.pages, pageNumber);
					if (slotPage$1) {
						const fragments$1 = slotPage$1.fragments ?? [];
						const rIdResolvedLayout = resolvedByRId.get(rIdLayoutKey);
						const alignedItems = this.resolveAlignedDecorationItems(fragments$1, slotPage$1.number, rIdLayout, rIdResolvedLayout, `rId '${rIdLayoutKey}' page ${pageNumber}`, sectionRId);
						if (!alignedItems) return null;
						const pageHeight$1 = page?.height ?? resolvedLayout.pages[0]?.height ?? layoutOptions.pageSize?.h ?? defaultPageSize.h;
						const margins$1 = pageMargins ?? resolvedLayout.pages[0]?.margins ?? layoutOptions.margins ?? defaultMargins;
						const decorationMargins$1 = kind === "footer" ? this.#stripFootnoteReserveFromBottomMargin(margins$1, page ?? null) : margins$1;
						const box$1 = this.#computeDecorationBox(kind, decorationMargins$1, pageHeight$1);
						const effectiveWidth = rIdLayout.effectiveWidth ?? box$1.width;
						const rawLayoutHeight$1 = rIdLayout.layout.height ?? 0;
						const metrics$1 = this.#computeMetrics(kind, rawLayoutHeight$1, box$1, pageHeight$1, margins$1?.footer ?? 0);
						const layoutMinY$1 = rIdLayout.layout.minY ?? 0;
						const normalizationMinY$1 = getDecorationNormalizationMinY(fragments$1, layoutMinY$1);
						const normalizedFragments$1 = normalizeDecorationFragments(fragments$1, normalizationMinY$1);
						const normalizedItems$1 = normalizeDecorationItems(alignedItems, normalizationMinY$1);
						const isActiveHeaderFooter$1 = this.#isActiveDecoration(kind, sectionRId, pageNumber);
						return {
							fragments: normalizedFragments$1,
							items: normalizedItems$1,
							height: metrics$1.containerHeight,
							contentHeight: metrics$1.layoutHeight > 0 ? metrics$1.layoutHeight : metrics$1.containerHeight,
							offset: metrics$1.offset,
							marginLeft: box$1.x,
							contentWidth: effectiveWidth,
							headerFooterRefId: sectionRId,
							sectionType: headerFooterType,
							isActiveHeaderFooter: isActiveHeaderFooter$1,
							minY: layoutMinY$1,
							box: {
								x: box$1.x,
								y: metrics$1.offset,
								width: effectiveWidth,
								height: metrics$1.containerHeight
							},
							hitRegion: {
								x: box$1.x,
								y: metrics$1.offset,
								width: effectiveWidth,
								height: metrics$1.containerHeight
							},
							matchedVariant: layoutVariantType
						};
					}
				}
			}
			if (!results || results.length === 0) return null;
			const variantIndex = results.findIndex((entry) => entry.type === layoutVariantType);
			const variant = variantIndex >= 0 ? results[variantIndex] : void 0;
			if (!variant || !variant.layout?.pages?.length) return null;
			const slotPage = this.#findPageForNumber(variant.layout.pages, pageNumber);
			if (!slotPage) return null;
			const fragments = slotPage.fragments ?? [];
			const fallbackId = this.#headerFooterManager?.getVariantId(kind, headerFooterType);
			const finalHeaderId = sectionRId ?? fallbackId ?? void 0;
			const resolvedVariant = resolvedResults?.[variantIndex];
			const alignedVariantItems = this.resolveAlignedDecorationItems(fragments, slotPage.number, variant, resolvedVariant, `variant '${layoutVariantType}' page ${pageNumber}`, finalHeaderId ?? headerFooterType);
			if (!alignedVariantItems) return null;
			const pageHeight = page?.height ?? resolvedLayout.pages[0]?.height ?? layoutOptions.pageSize?.h ?? defaultPageSize.h;
			const margins = pageMargins ?? resolvedLayout.pages[0]?.margins ?? layoutOptions.margins ?? defaultMargins;
			const decorationMargins = kind === "footer" ? this.#stripFootnoteReserveFromBottomMargin(margins, page ?? null) : margins;
			const box = this.#computeDecorationBox(kind, decorationMargins, pageHeight);
			const rawLayoutHeight = variant.layout.height ?? 0;
			const metrics = this.#computeMetrics(kind, rawLayoutHeight, box, pageHeight, margins?.footer ?? 0);
			const layoutMinY = variant.layout.minY ?? 0;
			const normalizationMinY = getDecorationNormalizationMinY(fragments, layoutMinY);
			const normalizedFragments = normalizeDecorationFragments(fragments, normalizationMinY);
			const normalizedItems = normalizeDecorationItems(alignedVariantItems, normalizationMinY);
			const isActiveHeaderFooter = this.#isActiveDecoration(kind, finalHeaderId, pageNumber);
			return {
				fragments: normalizedFragments,
				items: normalizedItems,
				height: metrics.containerHeight,
				contentHeight: metrics.layoutHeight > 0 ? metrics.layoutHeight : metrics.containerHeight,
				offset: metrics.offset,
				marginLeft: box.x,
				contentWidth: box.width,
				headerFooterRefId: finalHeaderId,
				sectionType: headerFooterType,
				isActiveHeaderFooter,
				minY: layoutMinY,
				box: {
					x: box.x,
					y: metrics.offset,
					width: box.width,
					height: metrics.containerHeight
				},
				hitRegion: {
					x: box.x,
					y: metrics.offset,
					width: box.width,
					height: metrics.containerHeight
				},
				matchedVariant: layoutVariantType
			};
		};
	}
	#findPageForNumber(pages, pageNumber) {
		if (!pages || pages.length === 0) return;
		const exactMatch = pages.find((p$1) => p$1.number === pageNumber);
		if (exactMatch) return exactMatch;
		const representative = getBucketRepresentative(getBucketForPageNumber(pageNumber));
		const bucketMatch = pages.find((p$1) => p$1.number === representative);
		if (bucketMatch) return bucketMatch;
		return pages[0];
	}
	destroy() {
		this.#teardownActiveEditorEventBridge();
		this.#managerCleanups.forEach((fn) => {
			try {
				fn();
			} catch (e) {
				console.error("[HeaderFooterSessionManager] Cleanup error:", e);
			}
		});
		this.#managerCleanups = [];
		this.#headerFooterAdapter?.clear();
		this.#headerFooterAdapter = null;
		this.#headerFooterManager?.destroy();
		this.#headerFooterManager = null;
		this.#headerFooterIdentifier = null;
		this.#multiSectionIdentifier = null;
		this.#headerLayoutResults = null;
		this.#footerLayoutResults = null;
		this.#headerLayoutsByRId.clear();
		this.#footerLayoutsByRId.clear();
		this.#resolvedHeaderLayouts = null;
		this.#resolvedFooterLayouts = null;
		this.#resolvedHeaderByRId.clear();
		this.#resolvedFooterByRId.clear();
		this.#publishedHeaderFooterLayoutSnapshot = {
			pageBindings: [],
			storyLayouts: {
				headers: [],
				footers: []
			}
		};
		this.#headerFooterLayoutSnapshotPending = false;
		this.#headerDecorationProvider = void 0;
		this.#footerDecorationProvider = void 0;
		this.#headerRegions.clear();
		this.#footerRegions.clear();
		this.#session = { mode: "body" };
		this.#activeEditor = null;
		this.#hideActiveBorder();
		this.#hoverOverlay = null;
		this.#hoverTooltip = null;
		this.#modeBanner = null;
		this.#hoverRegion = null;
	}
};
const STORY_HIDDEN_HOST_CLASS = "presentation-editor__story-hidden-host";
const STORY_HIDDEN_HOST_WRAPPER_CLASS = "presentation-editor__story-hidden-host-wrapper";
function createStoryHiddenHost(doc$1, widthPx, options = {}) {
	const { wrapper, host } = createHiddenHost(doc$1, widthPx);
	wrapper.classList.add(STORY_HIDDEN_HOST_WRAPPER_CLASS);
	host.classList.add(STORY_HIDDEN_HOST_CLASS);
	if (options.storyKey) host.setAttribute("data-story-key", options.storyKey);
	if (options.storyKind) host.setAttribute("data-story-kind", options.storyKind);
	return {
		wrapper,
		host
	};
}
var StoryPresentationSessionManager = class {
	#options;
	#active = null;
	constructor(options) {
		this.#options = options;
	}
	getActiveSession() {
		return this.#active;
	}
	getActiveEditorDomTarget() {
		return this.#active?.domTarget ?? null;
	}
	activate(locator, options = {}) {
		if (this.#active) this.exit();
		const runtime = this.#options.resolveRuntime(locator);
		if (runtime.kind === "body") throw new Error("StoryPresentationSessionManager cannot host a body runtime.");
		const preferHiddenHost = options.preferHiddenHost !== false;
		const commitPolicy = options.commitPolicy ?? "onExit";
		let hostWrapper = null;
		let editor = runtime.editor;
		let factoryDispose;
		let sessionBeforeDispose;
		if (preferHiddenHost && this.#options.editorFactory) {
			const mountContainer = this.#options.getMountContainer();
			if (!mountContainer) throw new Error("StoryPresentationSessionManager: no mount container available for hidden host.");
			const hidden = createStoryHiddenHost(mountContainer.ownerDocument ?? document, options.hostWidthPx ?? mountContainer.clientWidth ?? 1, {
				storyKey: runtime.storyKey,
				storyKind: runtime.kind
			});
			mountContainer.appendChild(hidden.wrapper);
			const factoryResult = this.#options.editorFactory({
				runtime,
				hostElement: hidden.host,
				activationOptions: options
			});
			editor = factoryResult.editor;
			factoryDispose = factoryResult.dispose;
			hostWrapper = hidden.wrapper;
		}
		if (commitPolicy === "continuous" && typeof editor.on === "function") {
			const handleTransaction = ({ transaction }) => {
				if (transaction?.docChanged) session.commit();
			};
			editor.on("transaction", handleTransaction);
			sessionBeforeDispose = () => {
				editor.off?.("transaction", handleTransaction);
			};
		}
		const domTarget = editor.view?.dom ?? hostWrapper ?? null;
		const unregisterRuntime = registerLiveStorySessionRuntime(resolveSessionHostEditor(editor, runtime), runtime, editor);
		const session = new MutableStorySession({
			locator,
			runtime,
			editor,
			kind: runtime.kind,
			hostWrapper,
			domTarget,
			commitPolicy,
			shouldDisposeRuntime: runtime.cacheable === false,
			beforeDispose: sessionBeforeDispose,
			unregisterRuntime,
			teardown: () => {
				try {
					factoryDispose?.();
				} finally {
					if (hostWrapper && hostWrapper.parentNode) hostWrapper.parentNode.removeChild(hostWrapper);
				}
			}
		});
		this.#active = session;
		this.#options.onActiveSessionChanged?.(session);
		return session;
	}
	exit() {
		const active = this.#active;
		if (!active) return;
		this.#active = null;
		try {
			active.dispose();
		} finally {
			this.#options.onActiveSessionChanged?.(null);
		}
	}
	destroy() {
		this.exit();
	}
};
var MutableStorySession = class {
	#disposed = false;
	#shouldDisposeRuntime;
	#beforeDispose;
	#unregisterRuntime;
	#teardown;
	constructor(init) {
		this.locator = init.locator;
		this.runtime = init.runtime;
		this.editor = init.editor;
		this.kind = init.kind;
		this.hostWrapper = init.hostWrapper;
		this.domTarget = init.domTarget;
		this.commitPolicy = init.commitPolicy;
		this.#shouldDisposeRuntime = init.shouldDisposeRuntime;
		this.#beforeDispose = init.beforeDispose;
		this.#unregisterRuntime = init.unregisterRuntime;
		this.#teardown = init.teardown;
		init.afterActivate?.();
	}
	get isDisposed() {
		return this.#disposed;
	}
	commit() {
		if (this.#disposed) return;
		const hostEditor = getHostEditor(this.editor) ?? getHostEditor(this.runtime.editor) ?? this.runtime.editor;
		if (this.runtime.commitEditor) {
			this.runtime.commitEditor(hostEditor, this.editor);
			return;
		}
		this.runtime.commit?.(hostEditor);
	}
	dispose() {
		if (this.#disposed) return;
		try {
			if (this.commitPolicy === "onExit") this.commit();
		} finally {
			this.#disposed = true;
			try {
				this.#beforeDispose?.();
			} finally {
				try {
					this.#unregisterRuntime();
				} finally {
					try {
						if (this.#shouldDisposeRuntime) this.runtime.dispose?.();
					} finally {
						this.#teardown();
					}
				}
			}
		}
	}
};
function getHostEditor(editor) {
	return editor.options?.parentEditor ?? null;
}
function resolveSessionHostEditor(editor, runtime) {
	return getHostEditor(editor) ?? getHostEditor(runtime.editor) ?? runtime.editor;
}
var ENDNOTE_MARKER_DATA_ATTR = "data-sd-endnote-number";
var DEFAULT_MARKER_FONT_FAMILY = "Arial";
var DEFAULT_MARKER_FONT_SIZE = 12;
function buildEndnoteBlocks(editorState, converter, converterContext, themeColors, renderOverride = null, resolveTrackedChangeColor) {
	if (!editorState) return [];
	const endnoteNumberById = converterContext?.endnoteNumberById;
	const endnoteNumberFormat = converterContext?.endnoteNumberFormat;
	const endnoteFormatById = converterContext?.endnoteFormatById;
	const importedEndnotes = Array.isArray(converter?.endnotes) ? converter.endnotes : [];
	if (importedEndnotes.length === 0) return [];
	const orderedEndnoteIds = [];
	const seen = /* @__PURE__ */ new Set();
	const customMarkIds = /* @__PURE__ */ new Set();
	editorState.doc.descendants((node) => {
		if (node.type?.name !== "endnoteReference") return;
		const id = node.attrs?.id;
		if (id == null) return;
		const key = String(id);
		if (!key || seen.has(key)) return;
		seen.add(key);
		orderedEndnoteIds.push(key);
		if (isCustomMarkFollows(node.attrs?.customMarkFollows)) customMarkIds.add(key);
	});
	if (orderedEndnoteIds.length === 0) return [];
	const blocks = [];
	orderedEndnoteIds.forEach((id) => {
		try {
			const endnoteDoc = resolveEndnoteDocJson(id, importedEndnotes, renderOverride);
			if (!endnoteDoc) return;
			const result = toFlowBlocks(endnoteDoc, {
				blockIdPrefix: `endnote-${id}-`,
				storyKey: buildStoryKey({
					kind: "story",
					storyType: "endnote",
					noteId: id
				}),
				enableRichHyperlinks: true,
				themeColors,
				converterContext,
				resolveTrackedChangeColor
			});
			if (result?.blocks?.length) {
				if (!customMarkIds.has(id)) {
					const numFmtForId = endnoteFormatById?.[id] ?? endnoteNumberFormat;
					ensureEndnoteMarker(result.blocks, id, endnoteNumberById, numFmtForId);
				}
				blocks.push(...result.blocks);
			}
		} catch {}
	});
	return blocks;
}
function isTextRun$1(run) {
	return (run.kind === "text" || run.kind == null) && typeof run.text === "string";
}
function isEndnoteMarker(run) {
	return isTextRun$1(run) && Boolean(run.dataAttrs?.[ENDNOTE_MARKER_DATA_ATTR]);
}
function resolveDisplayNumber(id, endnoteNumberById) {
	if (!endnoteNumberById || typeof endnoteNumberById !== "object") return 1;
	const num = endnoteNumberById[id];
	if (typeof num === "number" && Number.isFinite(num) && num > 0) return num;
	return 1;
}
function resolveMarkerFontFamily(firstTextRun) {
	return typeof firstTextRun?.fontFamily === "string" ? firstTextRun.fontFamily : DEFAULT_MARKER_FONT_FAMILY;
}
function resolveMarkerBaseFontSize(firstTextRun) {
	if (typeof firstTextRun?.fontSize === "number" && Number.isFinite(firstTextRun.fontSize) && firstTextRun.fontSize > 0) return firstTextRun.fontSize;
	return DEFAULT_MARKER_FONT_SIZE;
}
function buildMarkerRun(markerText, firstTextRun) {
	const markerRun = {
		kind: "text",
		text: `${markerText}\u00A0`,
		dataAttrs: { [ENDNOTE_MARKER_DATA_ATTR]: "true" },
		fontFamily: resolveMarkerFontFamily(firstTextRun),
		fontSize: resolveMarkerBaseFontSize(firstTextRun) * SUBSCRIPT_SUPERSCRIPT_SCALE,
		vertAlign: "superscript"
	};
	if (firstTextRun?.color != null) markerRun.color = firstTextRun.color;
	return markerRun;
}
function syncMarkerRun(target, source) {
	target.kind = source.kind;
	target.text = source.text;
	target.dataAttrs = source.dataAttrs;
	target.fontFamily = source.fontFamily;
	target.fontSize = source.fontSize;
	target.bold = source.bold;
	target.italic = source.italic;
	target.letterSpacing = source.letterSpacing;
	target.color = source.color;
	target.vertAlign = source.vertAlign;
	target.baselineShift = source.baselineShift;
	delete target.pmStart;
	delete target.pmEnd;
}
function cloneJsonValue(value) {
	return JSON.parse(JSON.stringify(value));
}
function cloneNoteContentJson(content) {
	return cloneJsonValue(content);
}
function resolveEndnoteDocJson(id, importedEndnotes, renderOverride) {
	if (renderOverride && renderOverride.noteId === id) return normalizeNotePmJson(cloneJsonValue(renderOverride.docJson));
	const content = findNoteEntryById(importedEndnotes, id)?.content;
	if (!Array.isArray(content) || content.length === 0) return null;
	return normalizeNotePmJson({
		type: "doc",
		content: cloneNoteContentJson(content)
	});
}
function ensureEndnoteMarker(blocks, id, endnoteNumberById, endnoteNumberFormat) {
	const firstParagraph = blocks.find((block) => block.kind === "paragraph");
	if (!firstParagraph) return;
	const runs = Array.isArray(firstParagraph.runs) ? firstParagraph.runs : [];
	firstParagraph.runs = runs;
	const firstTextRun = runs.find((run) => isTextRun$1(run) && !isEndnoteMarker(run) && run.text.length > 0);
	const markerRun = buildMarkerRun(formatFootnoteCardinal(resolveDisplayNumber(id, endnoteNumberById), endnoteNumberFormat), firstTextRun);
	if (runs[0] && isTextRun$1(runs[0]) && isEndnoteMarker(runs[0])) {
		syncMarkerRun(runs[0], markerRun);
		return;
	}
	runs.unshift(markerRun);
}
var FontLateLoadReflowScheduler = class {
	#quietMs;
	#cooldownMs;
	#flush;
	#scheduleTimeout;
	#cancelTimeout;
	#pending = /* @__PURE__ */ new Set();
	#quietHandle = null;
	#cooldownHandle = null;
	#trailing = false;
	constructor(options) {
		this.#quietMs = options.quietMs ?? 250;
		this.#cooldownMs = options.cooldownMs ?? 2e3;
		this.#flush = options.flush;
		this.#scheduleTimeout = options.scheduleTimeout ?? ((cb, ms) => globalThis.setTimeout(cb, ms));
		this.#cancelTimeout = options.cancelTimeout ?? ((handle) => globalThis.clearTimeout(handle));
	}
	schedule(changedFaceKeys) {
		let added = false;
		for (const key of changedFaceKeys) if (!this.#pending.has(key)) {
			this.#pending.add(key);
			added = true;
		}
		if (!added) return;
		if (this.#cooldownHandle !== null) {
			this.#trailing = true;
			return;
		}
		if (this.#quietHandle !== null) return;
		this.#quietHandle = this.#scheduleTimeout(() => this.#onQuietElapsed(), this.#quietMs);
	}
	cancel() {
		this.#clearTimers();
		this.#pending.clear();
		this.#trailing = false;
	}
	#onQuietElapsed() {
		this.#quietHandle = null;
		this.#doFlush("quiet");
	}
	#onCooldownElapsed() {
		this.#cooldownHandle = null;
		if (this.#trailing && this.#pending.size > 0) this.#doFlush("throttle");
	}
	#doFlush(reason) {
		this.#trailing = false;
		try {
			if (this.#pending.size > 0) {
				const faceKeys = [...this.#pending];
				this.#pending.clear();
				this.#flush({
					reason,
					faceKeys
				});
			}
		} catch {} finally {
			this.#cooldownHandle = this.#scheduleTimeout(() => this.#onCooldownElapsed(), this.#cooldownMs);
		}
	}
	#clearTimers() {
		if (this.#quietHandle !== null) {
			this.#cancelTimeout(this.#quietHandle);
			this.#quietHandle = null;
		}
		if (this.#cooldownHandle !== null) {
			this.#cancelTimeout(this.#cooldownHandle);
			this.#cooldownHandle = null;
		}
	}
};
var FontReadinessGate = class {
	#getDocumentFonts;
	#getRequiredFaces;
	#getUsedFaces;
	#resolveFamilies;
	#fontResolver;
	#requestReflow;
	#getFontEnvironment;
	#registryOverride;
	#onRegistryResolved;
	#timeoutMs;
	#invalidateCaches;
	#context = null;
	#packInstalledFor = null;
	#fontConfigVersion = 0;
	#requiredSignature = "";
	#requiredFamilies = /* @__PURE__ */ new Set();
	#requiredFaceKeys = /* @__PURE__ */ new Set();
	#seenAvailable = /* @__PURE__ */ new Set();
	#seenAvailableFaces = /* @__PURE__ */ new Set();
	#seenFailedFaces = /* @__PURE__ */ new Set();
	#lastSummary = null;
	#loadingDoneHandler = null;
	#lateLoadScheduler;
	constructor(options) {
		this.#getDocumentFonts = options.getDocumentFonts;
		this.#getRequiredFaces = options.getRequiredFaces ?? null;
		this.#getUsedFaces = options.getUsedFaces ?? null;
		this.#fontResolver = options.fontResolver ?? null;
		const resolver = this.#fontResolver;
		this.#resolveFamilies = options.resolveFamilies ?? (resolver ? (families) => resolver.resolvePhysicalFamilies(families) : (families) => families);
		this.#requestReflow = options.requestReflow;
		this.#getFontEnvironment = options.getFontEnvironment ?? defaultFontEnvironment;
		this.#registryOverride = options.registry ?? null;
		this.#onRegistryResolved = options.onRegistryResolved ?? null;
		this.#timeoutMs = options.timeoutMs ?? 3e3;
		this.#invalidateCaches = options.invalidateCaches ?? defaultInvalidate;
		this.#lateLoadScheduler = new FontLateLoadReflowScheduler({
			quietMs: options.reflowQuietMs,
			cooldownMs: options.reflowCooldownMs,
			flush: () => this.#flushLateFontLoads(),
			scheduleTimeout: options.scheduleTimeout,
			cancelTimeout: options.cancelTimeout
		});
	}
	get fontConfigVersion() {
		return this.#fontConfigVersion;
	}
	getDiagnostics() {
		return this.#lastSummary;
	}
	getReport() {
		let declared = [];
		try {
			declared = this.#getDocumentFonts();
		} catch {
			return [];
		}
		const registry = this.#resolveContext().registry;
		const resolver = this.#fontResolver ?? void 0;
		const usedFaces = this.#getUsedFaces?.() ?? [];
		const faceRows = buildFaceReport(usedFaces, registry, resolver);
		const usedFamilies = new Set(usedFaces.map((u) => u.logicalFamily.toLowerCase()));
		const declaredRows = buildFontReport(declared.filter((family) => family && !usedFamilies.has(family.toLowerCase())), registry, resolver);
		return [...faceRows, ...declaredRows];
	}
	getDocumentFontOptions() {
		try {
			const usedFaces = this.#getUsedFaces?.() ?? [];
			if (!usedFaces.length) return [];
			const { registry } = this.#resolveContext();
			return buildDocumentFontOptions(usedFaces, registry, this.#fontResolver ?? void 0);
		} catch {
			return [];
		}
	}
	async ensureReadyForMeasure() {
		if (this.#getRequiredFaces) return this.#ensureFacesReady(this.#getRequiredFaces);
		return this.#ensureFamiliesReady();
	}
	async #ensureFacesReady(getRequiredFaces) {
		const registry = this.#resolveContext().registry;
		let required;
		try {
			required = getRequiredFaces();
		} catch {
			return this.#ensureFamiliesReady();
		}
		const keyed = required.map((r$1) => ({
			request: r$1,
			key: faceKeyOf(r$1.family, r$1.weight, r$1.style)
		}));
		const signature = keyed.map((k$1) => k$1.key).sort().join("|");
		if (signature === this.#requiredSignature && keyed.every((k$1) => registry.getFaceStatus(k$1.request) === "loaded") && this.#lastSummary) return this.#lastSummary;
		this.#requiredSignature = signature;
		this.#requiredFaceKeys = new Set(keyed.map((k$1) => k$1.key));
		this.#requiredFamilies = /* @__PURE__ */ new Set();
		this.#ensureSubscribed();
		let results = [];
		try {
			results = required.length ? await registry.awaitFaceRequests(required, { timeoutMs: this.#timeoutMs }) : [];
		} catch {
			results = [];
		}
		const failedKeys = [];
		for (const result of results) {
			const key = faceKeyOf(result.request.family, result.request.weight, result.request.style);
			if (result.status === "loaded") this.#seenAvailableFaces.add(key);
			else if (result.status === "failed" && !this.#seenFailedFaces.has(key)) {
				this.#seenFailedFaces.add(key);
				failedKeys.push(key);
			}
		}
		if (failedKeys.length > 0) this.#scheduleAvailabilityReflow(failedKeys);
		this.#lastSummary = summarizeFaces(results);
		return this.#lastSummary;
	}
	async #ensureFamiliesReady() {
		const registry = this.#resolveContext().registry;
		let required;
		try {
			required = [...new Set(this.#resolveFamilies(this.#getDocumentFonts()).filter(Boolean))];
		} catch {
			return this.#lastSummary ?? emptySummary();
		}
		const signature = required.slice().sort().join("|");
		if (signature === this.#requiredSignature && required.every((family) => registry.getStatus(family) === "loaded") && this.#lastSummary) return this.#lastSummary;
		this.#requiredSignature = signature;
		this.#requiredFamilies = new Set(required);
		this.#requiredFaceKeys = /* @__PURE__ */ new Set();
		this.#ensureSubscribed();
		let results = [];
		try {
			results = required.length ? await registry.awaitFaces(required, { timeoutMs: this.#timeoutMs }) : [];
		} catch {
			results = [];
		}
		for (const result of results) if (result.status === "loaded") this.#seenAvailable.add(result.family);
		this.#lastSummary = summarize(results);
		return this.#lastSummary;
	}
	notifyDocumentFontConfigChanged(options) {
		this.#fontConfigVersion += 1;
		this.#resetRequiredAndSeen();
		this.#lateLoadScheduler.cancel();
		if (options?.availabilityChanged) {
			bumpFontConfigVersion();
			this.#invalidateCaches();
		}
		this.#requestReflow();
	}
	invalidateCachesForConfigRegistration() {
		this.#invalidateCaches();
	}
	resolveRegistry() {
		return this.#resolveContext().registry;
	}
	resetForDocumentChange() {
		this.#lateLoadScheduler.cancel();
		this.#resetRequiredAndSeen();
	}
	#resetRequiredAndSeen() {
		this.#requiredSignature = "";
		this.#requiredFaceKeys = /* @__PURE__ */ new Set();
		this.#requiredFamilies = /* @__PURE__ */ new Set();
		this.#seenAvailable.clear();
		this.#seenAvailableFaces.clear();
		this.#seenFailedFaces.clear();
		this.#lastSummary = null;
	}
	dispose() {
		const fontSet = this.#context?.fontSet ?? null;
		if (fontSet && this.#loadingDoneHandler && typeof fontSet.removeEventListener === "function") fontSet.removeEventListener("loadingdone", this.#loadingDoneHandler);
		this.#loadingDoneHandler = null;
		this.#lateLoadScheduler.cancel();
	}
	#resolveContext() {
		if (this.#context && this.#context.fontSet) return this.#context;
		const env = this.#getFontEnvironment();
		const fontSet = env?.fontSet ?? null;
		const registry = this.#registryOverride ?? getFontRegistryFor(fontSet, env?.FontFaceCtor ?? null);
		this.#context = {
			fontSet,
			registry
		};
		if (this.#onRegistryResolved && registry !== this.#packInstalledFor) {
			this.#packInstalledFor = registry;
			try {
				this.#onRegistryResolved(registry);
			} catch {}
		}
		return this.#context;
	}
	#ensureSubscribed() {
		if (this.#loadingDoneHandler) return;
		const fontSet = this.#resolveContext().fontSet;
		if (!fontSet || typeof fontSet.addEventListener !== "function") return;
		const handler = (event) => this.#onLoadingDone(event);
		fontSet.addEventListener("loadingdone", handler);
		this.#loadingDoneHandler = handler;
	}
	#onLoadingDone(event) {
		const faces = event?.fontfaces ?? [];
		if (faces.length === 0) return;
		const changedKeys = [];
		if (this.#requiredFaceKeys.size > 0) {
			const loadedFaceKeys = new Set(faces.map((face) => faceKeyOf(face.family, normalizeWeightToken(face.weight), normalizeStyleToken(face.style))));
			for (const key of this.#requiredFaceKeys) {
				if (this.#seenAvailableFaces.has(key)) continue;
				if (loadedFaceKeys.has(key)) {
					this.#seenAvailableFaces.add(key);
					changedKeys.push(key);
				}
			}
		} else {
			const loadedFamilies = new Set(faces.map((face) => normalizeFamilyKey(face.family)));
			for (const family of this.#requiredFamilies) {
				if (this.#seenAvailable.has(family)) continue;
				if (loadedFamilies.has(normalizeFamilyKey(family))) {
					this.#seenAvailable.add(family);
					changedKeys.push(normalizeFamilyKey(family));
				}
			}
		}
		if (changedKeys.length === 0) return;
		this.#scheduleAvailabilityReflow(changedKeys);
	}
	#scheduleAvailabilityReflow(changedKeys) {
		this.#fontConfigVersion += 1;
		bumpFontConfigVersion();
		this.#invalidateCaches();
		this.#lateLoadScheduler.schedule(changedKeys);
	}
	#flushLateFontLoads() {
		this.#requestReflow();
	}
};
function normalizeFamilyKey(family) {
	return family.trim().replace(/^["']|["']$/g, "").toLowerCase();
}
function normalizeWeightToken(weight) {
	if (!weight) return "400";
	const w = weight.trim().toLowerCase();
	if (w === "bold" || w === "bolder") return "700";
	const n = Number(w);
	return Number.isFinite(n) && n >= 600 ? "700" : "400";
}
function normalizeStyleToken(style) {
	if (!style) return "normal";
	const s = style.trim().toLowerCase();
	return s.startsWith("italic") || s.startsWith("oblique") ? "italic" : "normal";
}
function faceKeyOf(family, weight, style) {
	return `${normalizeFamilyKey(family)}|${weight}|${style}`;
}
function summarize(results) {
	const summary = emptySummary();
	summary.results = results;
	for (const result of results) if (result.status === "loaded") summary.loaded += 1;
	else if (result.status === "failed") summary.failed += 1;
	else if (result.status === "timed_out") summary.timedOut += 1;
	else if (result.status === "fallback_used") summary.fallbackUsed += 1;
	return summary;
}
var FACE_STATUS_PRIORITY = [
	"failed",
	"timed_out",
	"fallback_used",
	"loaded",
	"loading",
	"unloaded"
];
function summarizeFaces(results) {
	const worstByFamily = /* @__PURE__ */ new Map();
	for (const { request, status } of results) {
		const prev = worstByFamily.get(request.family);
		if (prev === void 0 || FACE_STATUS_PRIORITY.indexOf(status) < FACE_STATUS_PRIORITY.indexOf(prev)) worstByFamily.set(request.family, status);
	}
	const summary = emptySummary();
	for (const [family, status] of worstByFamily) {
		summary.results.push({
			family,
			status
		});
		if (status === "loaded") summary.loaded += 1;
		else if (status === "failed") summary.failed += 1;
		else if (status === "timed_out") summary.timedOut += 1;
		else if (status === "fallback_used") summary.fallbackUsed += 1;
	}
	return summary;
}
function emptySummary() {
	return {
		loaded: 0,
		failed: 0,
		timedOut: 0,
		fallbackUsed: 0,
		results: []
	};
}
function defaultFontEnvironment() {
	const doc$1 = globalThis.document ?? null;
	const view = doc$1?.defaultView ?? null;
	const fontSet = doc$1?.fonts ?? null;
	const ctor = view?.FontFace ?? (typeof FontFace !== "undefined" ? FontFace : null);
	if (!fontSet || !ctor) return null;
	return {
		fontSet,
		FontFaceCtor: ctor
	};
}
function defaultInvalidate() {
	clearTextMeasurementCaches();
	measureCache.clear();
}
function toCssFontSource(url) {
	return /^\s*url\(/i.test(url) ? url : `url(${JSON.stringify(url)})`;
}
var embeddedDocumentCounter = 0;
function nextEmbeddedNamespace() {
	embeddedDocumentCounter += 1;
	return `__superdoc_embedded_${embeddedDocumentCounter}__`;
}
function sanitizeFamilyToken(family) {
	return family.replace(/[^A-Za-z0-9]+/g, "_").replace(/^_+|_+$/g, "") || "font";
}
var DocumentFontController = class {
	#resolver;
	#getGate;
	#onDocumentFontConfigApplied;
	#scheduleMicrotask;
	#runtimeReflowQueued = false;
	#runtimeReflowToken = 0;
	#runtimeAvailabilityChanged = false;
	#embeddedDisposers = [];
	#embeddedNamespace = nextEmbeddedNamespace();
	#embeddedPhysical = /* @__PURE__ */ new Map();
	#embeddedGeneration = 0;
	constructor(deps) {
		this.#resolver = deps.resolver;
		this.#getGate = deps.getGate;
		this.#onDocumentFontConfigApplied = deps.onDocumentFontConfigApplied;
		this.#scheduleMicrotask = deps.scheduleMicrotask ?? defaultScheduleMicrotask;
	}
	map(mappings) {
		if (this.#applyMappings(mappings)) this.#queueRuntimeReflow();
	}
	unmap(families) {
		const before = this.#resolver.signature;
		for (const family of Array.isArray(families) ? families : [families]) this.#resolver.unmap(family);
		this.#reflowIfChanged(before);
	}
	reset() {
		this.#cancelPendingRuntimeReflow();
		this.#releaseEmbeddedFaces();
		this.#resolver.reset();
	}
	dispose() {
		this.#cancelPendingRuntimeReflow();
		this.#releaseEmbeddedFaces();
	}
	applyInitialConfig(config) {
		this.#cancelPendingRuntimeReflow();
		if (!config) return;
		const registered$1 = this.#registerFamilies(config.families);
		this.#applyMappings(config.map);
		if (registered$1) this.#getGate()?.invalidateCachesForConfigRegistration();
	}
	applyEmbeddedFaces(faces) {
		this.#releaseEmbeddedFaces();
		if (!faces?.length) return;
		const registry = this.#getGate()?.resolveRegistry();
		if (!registry) return;
		this.#embeddedGeneration += 1;
		let registered$1 = false;
		for (const face of faces) {
			if (!face?.embeddable) continue;
			const physicalFamily = this.#physicalFamilyFor(face.family);
			const release = registry.registerOwnedFace({
				family: physicalFamily,
				source: face.source,
				weight: face.weight,
				style: face.style
			});
			if (release) {
				this.#embeddedDisposers.push(release);
				this.#resolver.mapEmbedded(face.family, physicalFamily);
				registered$1 = true;
			}
		}
		if (registered$1) this.#getGate()?.invalidateCachesForConfigRegistration();
	}
	#physicalFamilyFor(logicalFamily) {
		const key = logicalFamily.trim().toLowerCase();
		let physical = this.#embeddedPhysical.get(key);
		if (!physical) {
			physical = `${this.#embeddedNamespace}${this.#embeddedGeneration}_${this.#embeddedPhysical.size}_${sanitizeFamilyToken(logicalFamily)}`;
			this.#embeddedPhysical.set(key, physical);
		}
		return physical;
	}
	add(families) {
		let committed = false;
		try {
			this.#registerFamilies(families, () => {
				committed = true;
			});
		} finally {
			if (committed) {
				this.#runtimeAvailabilityChanged = true;
				this.#queueRuntimeReflow();
			}
		}
	}
	#registerFamilies(families, onFaceRegistered) {
		if (!families?.length) return false;
		const registry = this.#getGate()?.resolveRegistry();
		if (!registry) throw new Error("[superdoc] fonts.add: the font registry is not ready yet");
		let changed = false;
		for (const entry of families) {
			const family = entry?.family;
			const faces = entry?.faces;
			if (typeof family !== "string" || !family.trim()) throw new Error("[superdoc] fonts.add: each family needs a non-empty \"family\" name");
			if (!Array.isArray(faces) || faces.length === 0) throw new Error(`[superdoc] fonts.add: family "${family}" needs at least one face in "faces"`);
			for (const face of faces) {
				if (!face || typeof face.source !== "string" || !face.source.trim()) throw new Error(`[superdoc] fonts.add: family "${family}" has a face with no "source" URL`);
				if (registry.register({
					family,
					source: toCssFontSource(face.source),
					descriptors: {
						weight: face.weight == null ? void 0 : String(face.weight),
						style: face.style
					}
				}).changed) {
					changed = true;
					onFaceRegistered?.();
				}
			}
		}
		return changed;
	}
	async preload(families) {
		if (!Array.isArray(families)) throw new Error("[superdoc] fonts.preload expects an array of logical family names, e.g. preload([\"Georgia\"])");
		const registry = this.#getGate()?.resolveRegistry();
		if (!registry) throw new Error("[superdoc] fonts.preload: the font registry is not ready yet");
		const hasFace = (family, weight, style) => registry.hasFace(family, weight, style);
		const face = {
			weight: "400",
			style: "normal"
		};
		const requests = families.map((logical) => ({
			family: this.#resolver.resolveFace(logical, face, hasFace).physicalFamily,
			weight: "400",
			style: "normal"
		}));
		await registry.awaitFaceRequests(requests);
	}
	#reflowIfChanged(signatureBefore) {
		if (this.#resolver.signature !== signatureBefore) this.#queueRuntimeReflow();
	}
	#applyMappings(mappings) {
		if (!mappings) return false;
		const before = this.#resolver.signature;
		for (const [logicalFamily, physicalFamily] of Object.entries(mappings)) this.#resolver.map(logicalFamily, physicalFamily);
		return this.#resolver.signature !== before;
	}
	#queueRuntimeReflow() {
		if (this.#runtimeReflowQueued) return;
		this.#runtimeReflowQueued = true;
		const token$1 = ++this.#runtimeReflowToken;
		this.#scheduleMicrotask(() => {
			if (!this.#runtimeReflowQueued || token$1 !== this.#runtimeReflowToken) return;
			this.#runtimeReflowQueued = false;
			const availabilityChanged = this.#runtimeAvailabilityChanged;
			this.#runtimeAvailabilityChanged = false;
			this.#onDocumentFontConfigApplied();
			this.#getGate()?.notifyDocumentFontConfigChanged({ availabilityChanged });
		});
	}
	#cancelPendingRuntimeReflow() {
		this.#runtimeAvailabilityChanged = false;
		if (!this.#runtimeReflowQueued) return;
		this.#runtimeReflowQueued = false;
		this.#runtimeReflowToken += 1;
	}
	#releaseEmbeddedFaces() {
		for (const release of this.#embeddedDisposers) release();
		this.#embeddedDisposers.length = 0;
		this.#embeddedPhysical.clear();
		this.#resolver.clearEmbedded();
	}
};
function defaultScheduleMicrotask(callback) {
	if (typeof queueMicrotask === "function") {
		queueMicrotask(callback);
		return;
	}
	Promise.resolve().then(callback);
}
function primaryFamily(css) {
	const comma = css.indexOf(",");
	return (comma === -1 ? css : css.slice(0, comma)).trim().replace(/^["']|["']$/g, "");
}
function makeResolveFace(resolver, hasFace) {
	if (resolver && hasFace) return (logical, face) => {
		const r$1 = resolver.resolveFace(logical, face, hasFace);
		return {
			physicalFamily: r$1.physicalFamily,
			reason: r$1.reason,
			sourceFace: r$1.sourceFace
		};
	};
	if (resolver) return (logical) => {
		const r$1 = resolver.resolveFontFamily(logical);
		return {
			physicalFamily: r$1.physicalFamily,
			reason: r$1.reason
		};
	};
	return (logical) => {
		const r$1 = resolveFontFamily(logical);
		return {
			physicalFamily: r$1.physicalFamily,
			reason: r$1.reason
		};
	};
}
function collect(acc, node, resolveFace) {
	if (!node || typeof node.fontFamily !== "string" || !node.fontFamily) return;
	const weight = node.bold === true ? "700" : "400";
	const style = node.italic === true ? "italic" : "normal";
	const logicalPrimary = primaryFamily(node.fontFamily);
	if (!logicalPrimary) return;
	const usedKey = `${logicalPrimary.toLowerCase()}|${weight}|${style}`;
	if (acc.usedFaces.has(usedKey)) return;
	const { physicalFamily, reason, sourceFace } = resolveFace(node.fontFamily, {
		weight,
		style
	});
	const requiredFace = sourceFace ?? {
		weight,
		style
	};
	acc.usedFaces.set(usedKey, {
		logicalFamily: logicalPrimary,
		weight,
		style
	});
	acc.sigEntries.set(usedKey, [
		logicalPrimary.toLowerCase(),
		weight,
		style,
		(physicalFamily || "").toLowerCase(),
		requiredFace.weight,
		requiredFace.style,
		reason
	]);
	if (physicalFamily) {
		const reqKey = `${physicalFamily.toLowerCase()}|${requiredFace.weight}|${requiredFace.style}`;
		if (!acc.requiredFaces.has(reqKey)) acc.requiredFaces.set(reqKey, {
			family: physicalFamily,
			weight: requiredFace.weight,
			style: requiredFace.style
		});
	}
}
function collectRuns(acc, runs, resolveFace) {
	if (!runs) return;
	for (const run of runs) {
		const bearing = run;
		if (run.kind === "fieldAnnotation" && (typeof bearing.fontFamily !== "string" || !bearing.fontFamily)) collect(acc, {
			...bearing,
			fontFamily: "Arial"
		}, resolveFace);
		else collect(acc, bearing, resolveFace);
	}
}
function collectParagraph(acc, paragraph, resolveFace) {
	if (!paragraph) return;
	collectRuns(acc, paragraph.runs, resolveFace);
	collect(acc, paragraph.attrs?.wordLayout?.marker?.run, resolveFace);
	collect(acc, paragraph.attrs?.dropCapDescriptor?.run, resolveFace);
}
function collectTable(acc, table, resolveFace) {
	for (const row of table.rows) for (const cell of row.cells) {
		collectParagraph(acc, cell.paragraph, resolveFace);
		if (cell.blocks) for (const b$1 of cell.blocks) collectBlock(acc, b$1, resolveFace);
	}
}
function collectList(acc, list, resolveFace) {
	for (const item of list.items) collectParagraph(acc, item.paragraph, resolveFace);
}
function collectBlock(acc, block, resolveFace) {
	switch (block.kind) {
		case "paragraph":
			collectParagraph(acc, block, resolveFace);
			break;
		case "table":
			collectTable(acc, block, resolveFace);
			break;
		case "list":
			collectList(acc, block, resolveFace);
			break;
		default: break;
	}
}
function planFontFaces(blocks, resolver, hasFace) {
	const resolveFace = makeResolveFace(resolver, hasFace);
	const acc = {
		requiredFaces: /* @__PURE__ */ new Map(),
		usedFaces: /* @__PURE__ */ new Map(),
		sigEntries: /* @__PURE__ */ new Map()
	};
	if (blocks) for (const block of blocks) collectBlock(acc, block, resolveFace);
	return {
		requiredFaces: [...acc.requiredFaces.values()],
		usedFaces: [...acc.usedFaces.values()],
		effectiveSignature: acc.sigEntries.size === 0 ? "" : JSON.stringify([...acc.sigEntries.entries()].sort(([a], [b$1]) => a < b$1 ? -1 : a > b$1 ? 1 : 0).map(([, tuple]) => tuple))
	};
}
const DEFAULT_SEMANTIC_FOOTNOTE_HEADING_STYLE = {
	fontFamily: "Arial",
	fontSize: 14,
	bold: true,
	spacing: {
		before: 24,
		after: 12
	}
};
function buildSemanticFootnoteBlocks(input, footnotesMode) {
	if (!input || input.refs.length === 0 || input.blocksById.size === 0) return [];
	if ((footnotesMode ?? "endOfDocument") !== "endOfDocument") return [];
	const orderedFootnoteIds = [];
	const seen = /* @__PURE__ */ new Set();
	input.refs.forEach((ref$1) => {
		if (!ref$1?.id || seen.has(ref$1.id)) return;
		seen.add(ref$1.id);
		orderedFootnoteIds.push(ref$1.id);
	});
	if (orderedFootnoteIds.length === 0) return [];
	const result = [createSemanticFootnoteHeadingBlock(resolveSemanticFootnoteHeadingRunStyle(input.blocksById, orderedFootnoteIds))];
	orderedFootnoteIds.forEach((id, footnoteIndex) => {
		(input.blocksById.get(id) ?? []).forEach((block, blockIndex) => {
			result.push(cloneFlowBlockForSemanticFootnote(block, id, footnoteIndex, blockIndex));
		});
	});
	return result;
}
function resolveSemanticFootnoteHeadingRunStyle(blocksById, orderedFootnoteIds) {
	for (const footnoteId of orderedFootnoteIds) {
		const blocks = blocksById.get(footnoteId) ?? [];
		for (const block of blocks) {
			if (block.kind !== "paragraph") continue;
			for (const run of block.runs) {
				const fontFamily = run.fontFamily;
				const fontSize = run.fontSize;
				if (typeof fontFamily === "string" && fontFamily.length > 0 && typeof fontSize === "number") {
					if (Number.isFinite(fontSize) && fontSize > 0) return {
						fontFamily,
						fontSize
					};
				}
			}
		}
	}
	return {
		fontFamily: DEFAULT_SEMANTIC_FOOTNOTE_HEADING_STYLE.fontFamily,
		fontSize: DEFAULT_SEMANTIC_FOOTNOTE_HEADING_STYLE.fontSize
	};
}
function createSemanticFootnoteHeadingBlock(style) {
	return {
		kind: "paragraph",
		id: SEMANTIC_FOOTNOTES_HEADING_BLOCK_ID,
		attrs: { spacing: DEFAULT_SEMANTIC_FOOTNOTE_HEADING_STYLE.spacing },
		runs: [{
			kind: "text",
			text: "Footnotes",
			fontFamily: style.fontFamily,
			fontSize: style.fontSize,
			bold: DEFAULT_SEMANTIC_FOOTNOTE_HEADING_STYLE.bold
		}]
	};
}
function cloneFlowBlock(block) {
	return JSON.parse(JSON.stringify(block));
}
function stripPmRangesDeep(value) {
	if (Array.isArray(value)) {
		value.forEach((item) => stripPmRangesDeep(item));
		return;
	}
	if (!value || typeof value !== "object") return;
	const record = value;
	if ("pmStart" in record) delete record.pmStart;
	if ("pmEnd" in record) delete record.pmEnd;
	Object.values(record).forEach((nested) => stripPmRangesDeep(nested));
}
function cloneFlowBlockForSemanticFootnote(block, footnoteId, footnoteIndex, blockIndex) {
	const cloned = cloneFlowBlock(block);
	stripPmRangesDeep(cloned);
	cloned.id = `${SEMANTIC_FOOTNOTE_BLOCK_ID_PREFIX}-${footnoteId}-${footnoteIndex}-${blockIndex}-${block.id}`;
	return cloned;
}
function getBoundaries(ranges) {
	const set = /* @__PURE__ */ new Set();
	for (const r$1 of ranges) {
		if (Number.isFinite(r$1.from)) set.add(r$1.from);
		if (Number.isFinite(r$1.to)) set.add(r$1.to);
	}
	return [...set].sort((a, b$1) => a - b$1);
}
function isTextRun(run) {
	return "text" in run && typeof run.text === "string";
}
function splitParagraphRuns(paragraph, boundaries) {
	const newRuns = [];
	for (const run of paragraph.runs) {
		if (!isTextRun(run)) {
			newRuns.push(run);
			continue;
		}
		const start$1 = run.pmStart;
		const end$1 = run.pmEnd;
		if (start$1 == null || end$1 == null || start$1 >= end$1) {
			newRuns.push(run);
			continue;
		}
		const runBoundaries = boundaries.filter((b$1) => b$1 > start$1 && b$1 < end$1);
		if (runBoundaries.length === 0) {
			newRuns.push(run);
			continue;
		}
		const positions = [
			start$1,
			...runBoundaries,
			end$1
		];
		for (let i = 0; i < positions.length - 1; i++) {
			const segStart = positions[i];
			const segEnd = positions[i + 1];
			const charStart = segStart - start$1;
			const charEnd = segEnd - start$1;
			const segmentText = run.text.slice(charStart, charEnd);
			if (segmentText.length === 0) continue;
			newRuns.push({
				...run,
				text: segmentText,
				pmStart: segStart,
				pmEnd: segEnd
			});
		}
	}
	return {
		...paragraph,
		runs: newRuns
	};
}
function splitRunsInTableCell(cell, boundaries) {
	const result = { ...cell };
	if (cell.paragraph) result.paragraph = splitParagraphRuns(cell.paragraph, boundaries);
	if (cell.blocks?.length) result.blocks = cell.blocks.map((b$1) => {
		if (b$1.kind === "paragraph") return splitParagraphRuns(b$1, boundaries);
		if (b$1.kind === "table") return splitRunsInBlock(b$1, boundaries);
		return b$1;
	});
	return result;
}
function splitRunsInBlock(block, boundaries) {
	if (block.kind === "paragraph") return splitParagraphRuns(block, boundaries);
	if (block.kind === "table") {
		const table = block;
		return {
			...table,
			rows: table.rows.map((row) => ({
				...row,
				cells: row.cells.map((cell) => splitRunsInTableCell(cell, boundaries))
			}))
		};
	}
	if (block.kind === "list") {
		const list = block;
		return {
			...list,
			items: list.items.map((item) => ({
				...item,
				paragraph: splitParagraphRuns(item.paragraph, boundaries)
			}))
		};
	}
	return block;
}
function splitRunsAtDecorationBoundaries(blocks, ranges) {
	if (ranges.length === 0) return blocks;
	const boundaries = getBoundaries(ranges);
	return blocks.map((block) => splitRunsInBlock(block, boundaries));
}
var NATIVE_SELECTION_STYLES = `
/* Hide native browser selection on layout engine content.
 * We render our own selection overlay via PresentationEditor's #localSelectionLayer
 * for precise control over selection geometry across pages and zoom levels. */
.superdoc-layout *::selection {
  background: transparent;
}

.superdoc-layout *::-moz-selection {
  background: transparent;
}

`;
var nativeSelectionStylesInjected = false;
function ensureEditorNativeSelectionStyles(doc$1) {
	if (nativeSelectionStylesInjected || !doc$1) return;
	const styleEl = doc$1.createElement("style");
	styleEl.setAttribute("data-superdoc-editor-native-selection-styles", "true");
	styleEl.textContent = NATIVE_SELECTION_STYLES;
	doc$1.head?.appendChild(styleEl);
	nativeSelectionStylesInjected = true;
}
var FIELD_ANNOTATION_INTERACTION_STYLES = `
/* Editing affordance: allow text selection on draggable annotations */
.superdoc-layout .annotation[data-draggable="true"] {
  user-select: text;
}

/* Editing affordance: hover feedback */
.superdoc-layout .annotation[data-draggable="true"]:hover {
  opacity: 0.9;
}

/* Editing affordance: active/grab cursor */
.superdoc-layout .annotation[data-draggable="true"]:active {
  cursor: grabbing;
}

/* Editing affordance: drag over indicator for drop targets */
.superdoc-layout.drag-over {
  outline: 2px dashed #b015b3;
  outline-offset: -2px;
}

/* Editing affordance: drop zone indicator */
.superdoc-layout .superdoc-drop-indicator {
  position: absolute;
  width: 2px;
  background-color: #b015b3;
  pointer-events: none;
  z-index: 1000;
}
`;
var fieldAnnotationInteractionStylesInjected = false;
function ensureEditorFieldAnnotationInteractionStyles(doc$1) {
	if (fieldAnnotationInteractionStylesInjected || !doc$1) return;
	const styleEl = doc$1.createElement("style");
	styleEl.setAttribute("data-superdoc-editor-field-annotation-interaction-styles", "true");
	styleEl.textContent = FIELD_ANNOTATION_INTERACTION_STYLES;
	doc$1.head?.appendChild(styleEl);
	fieldAnnotationInteractionStylesInjected = true;
}
var MOVABLE_OBJECT_INTERACTION_STYLES = `
/* Editing affordance: allow grab cursors for draggable SDT labels and images */
.superdoc-layout [data-drag-source-kind] {
  cursor: grab;
}

.superdoc-layout [data-drag-source-kind]:active {
  cursor: grabbing;
}

/* Header/footer decoration containers are pointer-events:none; keep images targetable for hover/resize. */
.superdoc-layout .superdoc-page-header .superdoc-image-fragment,
.superdoc-layout .superdoc-page-footer .superdoc-image-fragment,
.superdoc-layout .superdoc-page-header .superdoc-inline-image-clip-wrapper,
.superdoc-layout .superdoc-page-footer .superdoc-inline-image-clip-wrapper,
.superdoc-layout .superdoc-page-header .superdoc-inline-image,
.superdoc-layout .superdoc-page-footer .superdoc-inline-image {
  pointer-events: auto;
}

/* Keep the active drag source from selecting text while dragging */
.superdoc-layout .superdoc-structured-content__label,
.superdoc-layout .superdoc-structured-content-inline__label,
.superdoc-layout .superdoc-image-fragment[data-drag-source-kind="existingImage"],
.superdoc-layout .superdoc-inline-image-clip-wrapper[data-drag-source-kind="existingImage"],
.superdoc-layout .superdoc-inline-image[data-drag-source-kind="existingImage"] {
  user-select: none;
}
`;
var movableObjectInteractionStylesInjected = false;
function ensureEditorMovableObjectInteractionStyles(doc$1) {
	if (movableObjectInteractionStylesInjected || !doc$1) return;
	const styleEl = doc$1.createElement("style");
	styleEl.setAttribute("data-superdoc-editor-movable-object-interaction-styles", "true");
	styleEl.textContent = MOVABLE_OBJECT_INTERACTION_STYLES;
	doc$1.head?.appendChild(styleEl);
	movableObjectInteractionStylesInjected = true;
}
function serializeSectionConfigs(map$1) {
	if (map$1.size === 0) return "";
	return [...map$1.entries()].sort((a, b$1) => a[0] - b$1[0]).map(([i, c]) => `${i}:${c.numFmt ?? ""}/${c.numStart ?? ""}/${c.numRestart ?? ""}`).join(";");
}
function serializePerIdNumbering(order$1, numberById, formatById) {
	if (order$1.length === 0) return "";
	const parts = [];
	for (const id of order$1) {
		const n = numberById[id];
		const f = formatById?.[id] ?? "";
		parts.push(`${id}:${n ?? ""}/${f}`);
	}
	return parts.join(";");
}
var INTERNAL_NOTE_COMMIT_SOURCES = new Set(["story-runtime:commit:footnote", "story-runtime:commit:endnote"]);
var isInternalNoteCommitSource = (event) => {
	return typeof event?.source === "string" && INTERNAL_NOTE_COMMIT_SOURCES.has(event.source);
};
function parseRenderedNoteTarget(blockId) {
	if (typeof blockId !== "string" || blockId.length === 0) return null;
	if (blockId.startsWith("footnote-")) {
		const noteId = blockId.slice(9).split("-")[0] ?? "";
		return noteId ? {
			storyType: "footnote",
			noteId
		} : null;
	}
	if (blockId.startsWith("__sd_semantic_footnote-")) {
		const noteId = blockId.slice(23).split("-")[0] ?? "";
		return noteId ? {
			storyType: "footnote",
			noteId
		} : null;
	}
	if (blockId.startsWith("endnote-")) {
		const noteId = blockId.slice(8).split("-")[0] ?? "";
		return noteId ? {
			storyType: "endnote",
			noteId
		} : null;
	}
	return null;
}
var DOCUMENT_RELS_PART_ID = "word/_rels/document.xml.rels";
var DEFAULT_PAGE_SIZE = {
	w: 612,
	h: 792
};
var DEFAULT_MARGINS = {
	top: 72,
	right: 72,
	bottom: 72,
	left: 72
};
var DEFAULT_PAGE_GAP = 24;
var DEFAULT_HORIZONTAL_PAGE_GAP = 20;
var layoutDebugEnabled = typeof process$1 !== "undefined" && typeof process$1.env !== "undefined" && Boolean(process$1.env.SD_DEBUG_LAYOUT);
var perfLog = (...args$1) => {
	if (!layoutDebugEnabled) return;
	console.log(...args$1);
};
var HEADER_FOOTER_INIT_BUDGET_MS = 200;
var MAX_ZOOM_WARNING_THRESHOLD = 10;
var MAX_SELECTION_RECTS_PER_USER = 100;
var SEMANTIC_RESIZE_DEBOUNCE_MS = 120;
var MIN_SEMANTIC_CONTENT_WIDTH_PX = 1;
var GLOBAL_PERFORMANCE = typeof performance !== "undefined" ? performance : void 0;
var PresentationEditor = class PresentationEditor extends EventEmitter {
	static #instances = /* @__PURE__ */ new Map();
	static {
		this.FALLBACK_COLORS = [
			"#FF6B6B",
			"#4ECDC4",
			"#45B7D1",
			"#FFA07A",
			"#98D8C8",
			"#F7DC6F",
			"#BB8FCE",
			"#85C1E2"
		];
	}
	static {
		this.CURSOR_STYLES = {
			CARET_WIDTH: 2,
			LABEL_FONT_SIZE: 13,
			LABEL_PADDING: "2px 6px",
			LABEL_OFFSET: "-1.05em",
			SELECTION_BORDER_RADIUS: "2px",
			MAX_LABEL_LENGTH: 30
		};
	}
	static getInstance(documentId) {
		return PresentationEditor.#instances.get(documentId);
	}
	static setGlobalZoom(zoom) {
		PresentationEditor.#instances.forEach((instance) => {
			instance.setZoom(zoom);
		});
	}
	#options;
	#registryKey = null;
	#editor;
	#visibleHost;
	#viewportHost;
	#painterHost;
	#selectionOverlay;
	#permissionOverlay = null;
	#hiddenHost;
	#hiddenHostWrapper;
	#layoutOptions;
	#configuredDocumentBackground;
	#layoutState = {
		blocks: [],
		measures: [],
		layout: null,
		bookmarks: /* @__PURE__ */ new Map()
	};
	#layoutFontSignature = "";
	#layoutLookupBlocks = [];
	#layoutLookupMeasures = [];
	#flowBlockCache = new FlowBlockCache();
	#footnoteNumberSignature = null;
	#endnoteNumberSignature = null;
	#warnedUnsupportedRestart = {
		footnote: false,
		endnote: false
	};
	#painterAdapter = new PresentationPainterAdapter();
	#pageGeometryHelper = null;
	#dragDropManager = null;
	#layoutError = null;
	#layoutErrorState = "healthy";
	#errorBanner = null;
	#errorBannerMessage = null;
	#renderScheduled = false;
	#pendingDocChange = false;
	#focusScrollRafId = null;
	#pendingMapping = null;
	#isRerendering = false;
	#selectionSync = new SelectionSyncCoordinator();
	#fontGate = null;
	#fontResolver = createFontResolver();
	#nextFontsChangedSource = null;
	#fontController = new DocumentFontController({
		resolver: this.#fontResolver,
		getGate: () => this.#fontGate,
		onDocumentFontConfigApplied: () => {
			this.#nextFontsChangedSource = "config-change";
		}
	});
	#fontPlanBlocks = null;
	#fontPlan = null;
	#hasFace = (family, weight, style) => this.#fontGate ? this.#fontGate.resolveRegistry().hasFace(family, weight, style) : false;
	#lastFontsChangedKey = null;
	#lastFontsChangedVersion = -1;
	#lastFontsChangedPayload = null;
	#shouldScrollSelectionIntoView = false;
	#suppressSelectionScrollUntilRaf = false;
	#dragDropIndicatorPos = null;
	#epochMapper = new EpochPositionMapper();
	#layoutEpoch = 0;
	#htmlAnnotationHeights = /* @__PURE__ */ new Map();
	#htmlAnnotationMeasureEpoch = -1;
	#htmlAnnotationMeasureAttempts = 0;
	#domPositionIndex = new DomPositionIndex();
	#domIndexObserverManager = null;
	#postPaintPipeline = new PresentationPostPaintPipeline();
	#proofingManager = null;
	#decorationSyncRafHandle = null;
	#rafHandle = null;
	#semanticResizeObserver = null;
	#semanticResizeRaf = null;
	#semanticResizeDebounce = null;
	#lastSemanticContainerWidth = null;
	#editorListeners = [];
	#scrollHandler = null;
	#handledScrollEvents = /* @__PURE__ */ new WeakSet();
	#scrollContainer = null;
	#scrollContainerValidated = false;
	#sectionMetadata = [];
	#documentMode = "editing";
	#inputBridge = null;
	#trackedChangesMode = "review";
	#trackedChangesEnabled = true;
	#trackedChangesOverrides;
	#headerFooterSession = null;
	#storySessionManager = null;
	#hoverOverlay = null;
	#hoverTooltip = null;
	#modeBanner = null;
	#ariaLiveRegion = null;
	#a11ySelectionAnnounceTimeout = null;
	#a11yLastAnnouncedSelectionKey = null;
	#headerFooterSelectionHandler = null;
	#headerFooterEditor = null;
	#storySessionSelectionHandler = null;
	#storySessionTransactionHandler = null;
	#storySessionEditor = null;
	#historyCoordinator = null;
	#noteEditorRegistry = null;
	#historyCoordinatorCleanup = [];
	#coordinatorDrivenNotePurges = /* @__PURE__ */ new Set();
	#lastPublishedActiveSurface = null;
	#activeSurfaceUiEventEditor = null;
	#activeSurfaceUiUpdateHandler = null;
	#activeSurfaceUiContextMenuOpenHandler = null;
	#activeSurfaceUiContextMenuCloseHandler = null;
	#lastSelectedFieldAnnotation = null;
	#lastSelectedStructuredContentBlock = null;
	#lastSelectedStructuredContentInline = null;
	#sdtHoverCoordinator = null;
	#tocHoverCoordinator = null;
	#remoteCursorManager = null;
	#cursorUpdateTimer = null;
	#remoteCursorOverlay = null;
	#localSelectionLayer = null;
	#editorInputManager = null;
	constructor(options) {
		super();
		if (!options?.element) throw new Error("PresentationEditor requires an `element` to mount into.");
		this.#options = options;
		this.#documentMode = options.documentMode ?? "editing";
		this.#visibleHost = options.element;
		this.#visibleHost.innerHTML = "";
		this.#visibleHost.classList.add("presentation-editor");
		this.#syncDocumentModeClass();
		if (!this.#visibleHost.hasAttribute("tabindex")) this.#visibleHost.tabIndex = 0;
		if ((this.#visibleHost.ownerDocument?.defaultView ?? window).getComputedStyle(this.#visibleHost).position === "static") this.#visibleHost.style.position = "relative";
		const doc$1 = this.#visibleHost.ownerDocument ?? document;
		const rawPresence = options.layoutEngineOptions?.presence;
		const validatedPresence = rawPresence ? {
			...rawPresence,
			maxVisible: rawPresence.maxVisible !== void 0 ? Math.max(1, Math.min(rawPresence.maxVisible, 100)) : rawPresence.maxVisible,
			highlightOpacity: rawPresence.highlightOpacity !== void 0 ? Math.max(0, Math.min(rawPresence.highlightOpacity, 1)) : rawPresence.highlightOpacity
		} : void 0;
		const requestedFlowMode = options.layoutEngineOptions?.flowMode === "semantic" ? "semantic" : "paginated";
		const requestedLayoutMode = options.layoutEngineOptions?.layoutMode ?? "vertical";
		this.#configuredDocumentBackground = this.#coerceDocumentBackground(options.layoutEngineOptions?.documentBackground);
		this.#layoutOptions = {
			pageSize: options.layoutEngineOptions?.pageSize ?? DEFAULT_PAGE_SIZE,
			margins: options.layoutEngineOptions?.margins ?? DEFAULT_MARGINS,
			virtualization: requestedFlowMode === "semantic" ? {
				...options.layoutEngineOptions?.virtualization ?? {},
				enabled: false
			} : options.layoutEngineOptions?.virtualization,
			zoom: options.layoutEngineOptions?.zoom ?? 1,
			...this.#configuredDocumentBackground ? { documentBackground: this.#configuredDocumentBackground } : {},
			pageStyles: options.layoutEngineOptions?.pageStyles,
			debugLabel: options.layoutEngineOptions?.debugLabel,
			layoutMode: requestedFlowMode === "semantic" ? "vertical" : requestedLayoutMode,
			flowMode: requestedFlowMode,
			semanticOptions: options.layoutEngineOptions?.semanticOptions,
			trackedChanges: options.layoutEngineOptions?.trackedChanges,
			resolveTrackedChangeColor: options.layoutEngineOptions?.resolveTrackedChangeColor,
			emitCommentPositionsInViewing: options.layoutEngineOptions?.emitCommentPositionsInViewing,
			enableCommentsInViewing: options.layoutEngineOptions?.enableCommentsInViewing,
			presence: validatedPresence,
			showBookmarks: options.layoutEngineOptions?.showBookmarks ?? false,
			showFormattingMarks: options.layoutEngineOptions?.showFormattingMarks ?? false,
			contentControlsChrome: options.layoutEngineOptions?.contentControlsChrome
		};
		this.#trackedChangesOverrides = options.layoutEngineOptions?.trackedChanges;
		this.#viewportHost = doc$1.createElement("div");
		this.#viewportHost.className = "presentation-editor__viewport";
		this.#viewportHost.setAttribute("aria-hidden", "true");
		this.#viewportHost.style.position = "relative";
		this.#viewportHost.style.isolation = "isolate";
		this.#viewportHost.style.width = "100%";
		const pageHeight = this.#layoutOptions.pageSize?.h ?? DEFAULT_PAGE_SIZE.h;
		this.#viewportHost.style.minHeight = `${pageHeight}px`;
		this.#visibleHost.appendChild(this.#viewportHost);
		this.#painterHost = doc$1.createElement("div");
		this.#painterHost.className = "presentation-editor__pages";
		this.#painterHost.style.transformOrigin = "top left";
		this.#viewportHost.appendChild(this.#painterHost);
		this.#postPaintPipeline.setContainer(this.#painterHost);
		ensureEditorNativeSelectionStyles(doc$1);
		ensureEditorFieldAnnotationInteractionStyles(doc$1);
		ensureEditorMovableObjectInteractionStyles(doc$1);
		this.#initializeHoverCoordinators();
		this.#painterHost.addEventListener("mouseover", this.#sdtHoverCoordinator.handleMouseEnter);
		this.#painterHost.addEventListener("mouseout", this.#sdtHoverCoordinator.handleMouseLeave);
		this.#painterHost.addEventListener("mouseover", this.#tocHoverCoordinator.handleMouseEnter);
		this.#painterHost.addEventListener("mouseout", this.#tocHoverCoordinator.handleMouseLeave);
		this.#domIndexObserverManager = new DomPositionIndexObserverManager({
			windowRoot: this.#visibleHost?.ownerDocument?.defaultView ?? window,
			getPainterHost: () => this.#painterHost,
			onRebuild: () => {
				this.#refreshEditorDomAugmentations();
				this.#selectionSync.requestRender({ immediate: true });
			}
		});
		this.#domIndexObserverManager.setup();
		this.#selectionSync.on("render", () => this.#updateSelection());
		this.#selectionSync.on("render", () => this.#updatePermissionOverlay());
		this.#permissionOverlay = doc$1.createElement("div");
		this.#permissionOverlay.className = "presentation-editor__permission-overlay";
		Object.assign(this.#permissionOverlay.style, {
			position: "absolute",
			inset: "0",
			pointerEvents: "none",
			zIndex: "5"
		});
		this.#viewportHost.appendChild(this.#permissionOverlay);
		this.#selectionOverlay = doc$1.createElement("div");
		this.#selectionOverlay.className = "presentation-editor__selection-overlay";
		this.#selectionOverlay.id = `presentation-overlay-${options.documentId || "default"}`;
		this.#selectionOverlay.style.position = "absolute";
		this.#selectionOverlay.style.inset = "0";
		this.#selectionOverlay.style.pointerEvents = "none";
		this.#selectionOverlay.style.zIndex = "10";
		this.#remoteCursorOverlay = doc$1.createElement("div");
		this.#remoteCursorOverlay.className = "presentation-editor__selection-layer--remote";
		this.#remoteCursorOverlay.style.position = "absolute";
		this.#remoteCursorOverlay.style.inset = "0";
		this.#remoteCursorOverlay.style.pointerEvents = "none";
		this.#localSelectionLayer = doc$1.createElement("div");
		this.#localSelectionLayer.className = "presentation-editor__selection-layer--local";
		this.#localSelectionLayer.style.position = "absolute";
		this.#localSelectionLayer.style.inset = "0";
		this.#localSelectionLayer.style.pointerEvents = "none";
		this.#selectionOverlay.appendChild(this.#remoteCursorOverlay);
		this.#selectionOverlay.appendChild(this.#localSelectionLayer);
		this.#viewportHost.appendChild(this.#selectionOverlay);
		this.#remoteCursorManager = new RemoteCursorManager({
			visibleHost: this.#visibleHost,
			remoteCursorOverlay: this.#remoteCursorOverlay,
			presence: validatedPresence,
			collaborationProvider: options.collaborationProvider,
			fallbackColors: PresentationEditor.FALLBACK_COLORS,
			cursorStyles: PresentationEditor.CURSOR_STYLES,
			maxSelectionRectsPerUser: MAX_SELECTION_RECTS_PER_USER,
			defaultPageHeight: DEFAULT_PAGE_SIZE.h
		});
		this.#remoteCursorManager.setUpdateCallback(() => this.#updateRemoteCursors());
		this.#hoverOverlay = doc$1.createElement("div");
		this.#hoverOverlay.className = "presentation-editor__hover-overlay";
		Object.assign(this.#hoverOverlay.style, {
			position: "absolute",
			border: "1px dashed rgba(51, 102, 255, 0.8)",
			borderRadius: "2px",
			pointerEvents: "none",
			display: "none",
			zIndex: "11"
		});
		this.#selectionOverlay.appendChild(this.#hoverOverlay);
		this.#hoverTooltip = doc$1.createElement("div");
		this.#hoverTooltip.className = "presentation-editor__hover-tooltip";
		Object.assign(this.#hoverTooltip.style, {
			position: "absolute",
			background: "rgba(18, 22, 33, 0.85)",
			color: "#fff",
			padding: "2px 6px",
			fontSize: "12px",
			borderRadius: "2px",
			pointerEvents: "none",
			display: "none",
			zIndex: "12",
			whiteSpace: "nowrap"
		});
		this.#selectionOverlay.appendChild(this.#hoverTooltip);
		this.#modeBanner = doc$1.createElement("div");
		this.#modeBanner.className = "presentation-editor__mode-banner";
		Object.assign(this.#modeBanner.style, {
			position: "absolute",
			top: "0",
			left: "50%",
			transform: "translate(-50%, -100%)",
			background: "#1b3fbf",
			color: "#fff",
			padding: "4px 12px",
			borderRadius: "6px",
			fontSize: "13px",
			display: "none",
			zIndex: "15"
		});
		this.#visibleHost.appendChild(this.#modeBanner);
		this.#headerFooterSession = new HeaderFooterSessionManager({
			painterHost: this.#painterHost,
			visibleHost: this.#visibleHost,
			selectionOverlay: this.#selectionOverlay,
			editor: null,
			isDebug: this.#options.isDebug,
			initBudgetMs: HEADER_FOOTER_INIT_BUDGET_MS,
			defaultPageSize: DEFAULT_PAGE_SIZE,
			defaultMargins: DEFAULT_MARGINS,
			getFontSignature: () => this.#layoutFontSignature
		});
		this.#headerFooterSession.setHoverElements({
			hoverOverlay: this.#hoverOverlay,
			hoverTooltip: this.#hoverTooltip,
			modeBanner: this.#modeBanner
		});
		this.#headerFooterSession.setDocumentMode(this.#documentMode);
		this.#headerFooterSession.setTrackedChangesRenderConfig({
			mode: this.#trackedChangesMode,
			enabled: this.#trackedChangesEnabled
		});
		this.#ariaLiveRegion = doc$1.createElement("div");
		this.#ariaLiveRegion.className = "presentation-editor__aria-live";
		this.#ariaLiveRegion.setAttribute("role", "status");
		this.#ariaLiveRegion.setAttribute("aria-live", "polite");
		this.#ariaLiveRegion.setAttribute("aria-atomic", "true");
		Object.assign(this.#ariaLiveRegion.style, {
			position: "absolute",
			width: "1px",
			height: "1px",
			overflow: "hidden",
			clip: "rect(1px, 1px, 1px, 1px)"
		});
		this.#visibleHost.appendChild(this.#ariaLiveRegion);
		const { wrapper: hiddenHostWrapper, host: hiddenHost } = createHiddenHost(doc$1, this.#layoutOptions.pageSize?.w ?? DEFAULT_PAGE_SIZE.w);
		this.#hiddenHostWrapper = hiddenHostWrapper;
		this.#hiddenHost = hiddenHost;
		if (doc$1.body) doc$1.body.appendChild(this.#hiddenHostWrapper);
		else this.#visibleHost.appendChild(this.#hiddenHostWrapper);
		const { layoutEngineOptions: _layoutEngineOptions, element: _element, ...editorOptions } = options;
		const normalizedEditorProps = {
			...editorOptions.editorProps ?? {},
			editable: () => {
				return !this.#isViewLocked();
			}
		};
		try {
			this.#editor = new Editor({
				...editorOptions,
				element: this.#hiddenHost,
				editorProps: normalizedEditorProps,
				documentMode: this.#documentMode
			});
			this.#wrapOffscreenEditorFocus(this.#editor);
			this.#editor.presentationEditor = this;
			this.#editor._presentationEditor = this;
			this.#syncHiddenEditorA11yAttributes();
			this.#fontGate = new FontReadinessGate({
				getDocumentFonts: () => {
					return this.#editor.converter?.getDocumentFonts?.() ?? [];
				},
				requestReflow: () => this.#requestFontReflow(),
				getRequiredFaces: () => this.#fontPlan?.requiredFaces ?? [],
				getUsedFaces: () => this.#fontPlan?.usedFaces ?? [],
				fontResolver: this.#fontResolver,
				onRegistryResolved: (registry) => installBundledSubstitutes(registry, {
					assetBaseUrl: this.#options.fontAssets?.assetBaseUrl,
					resolveAssetUrl: this.#options.fontAssets?.resolveAssetUrl
				}),
				getFontEnvironment: () => {
					const ownerDoc = this.#visibleHost?.ownerDocument ?? (typeof document !== "undefined" ? document : null);
					const view = ownerDoc?.defaultView ?? (typeof window !== "undefined" ? window : null);
					const fontSet = ownerDoc?.fonts ?? null;
					const FontFaceCtor = view?.FontFace ?? (typeof FontFace !== "undefined" ? FontFace : null);
					return fontSet && FontFaceCtor ? {
						fontSet,
						FontFaceCtor
					} : null;
				}
			});
			this.#fontController.applyInitialConfig(this.#options.fontAssets);
			this.#applyEmbeddedDocumentFonts();
			if (typeof this.#options.disableContextMenu === "boolean") this.setContextMenuDisabled(this.#options.disableContextMenu);
			this.#setupHeaderFooterSession();
			this.#setupStorySessionManager();
			this.#setupUnifiedHistoryCoordinator();
			this.#applyZoom();
			this.#setupEditorListeners();
			this.#initializeEditorInputManager();
			this.#setupPointerHandlers();
			this.#setupDragHandlers();
			this.#setupInputBridge();
			this.#syncTrackedChangesPreferences();
			this.#syncHeaderFooterTrackedChangesRenderConfig();
			this.#setupSemanticResizeObserver();
			this.#initializeProofing();
			this.#registryKey = options.documentId || `__anonymous_${Date.now()}_${Math.random().toString(36).slice(2)}`;
			PresentationEditor.#instances.set(this.#registryKey, this);
			this.#pendingDocChange = true;
			this.#scheduleRerender();
			if (this.#options.collaborationProvider?.awareness) {
				if (ySyncPluginKey.getState(this.#editor.state) && this.#layoutOptions.presence?.enabled !== false) this.#setupCollaborationCursors();
			}
		} catch (error) {
			this.destroy();
			throw error;
		}
	}
	#warnUnsupportedNumberingRestart(kind) {
		if (this.#warnedUnsupportedRestart[kind]) return;
		this.#warnedUnsupportedRestart[kind] = true;
		console.warn(`[PresentationEditor] ${kind} numRestart="eachPage" is not yet supported (requires a two-pass pagination handshake). Falling back to "continuous". Tracked for follow-up.`);
	}
	#wrapOffscreenEditorFocus(editor) {
		const view = editor?.view;
		if (!view || !view.dom || typeof view.focus !== "function") return;
		const viewWithFlag = view;
		if (viewWithFlag.__sdPreventScrollFocus) return;
		if (view.focus.mock) return;
		viewWithFlag.__sdPreventScrollFocus = true;
		const originalFocus = view.focus.bind(view);
		view.focus = () => {
			const win = this.#visibleHost.ownerDocument?.defaultView;
			if (!win) {
				originalFocus();
				return;
			}
			const beforeX = win.scrollX;
			const beforeY = win.scrollY;
			if (!view.hasFocus()) view.domObserver.suppressSelectionUpdates();
			let domFocused = false;
			try {
				view.dom.focus({ preventScroll: true });
				domFocused = true;
			} catch (error) {
				debugLog("warn", "Off-screen editor focus: preventScroll failed", {
					error: String(error),
					strategy: "preventScroll"
				});
			}
			if (!domFocused) try {
				view.dom.focus();
				domFocused = true;
			} catch (error) {
				debugLog("warn", "Off-screen editor focus: standard focus failed", {
					error: String(error),
					strategy: "standard"
				});
			}
			try {
				originalFocus();
			} catch (error) {
				if (!domFocused) debugLog("error", "Off-screen editor focus: all strategies failed", {
					error: String(error),
					strategy: "original"
				});
				else debugLog("warn", "Off-screen editor focus: ProseMirror selection sync failed", {
					error: String(error),
					strategy: "original"
				});
			}
			if (win.scrollX !== beforeX || win.scrollY !== beforeY) win.scrollTo(beforeX, beforeY);
			if (this.#focusScrollRafId != null) win.cancelAnimationFrame(this.#focusScrollRafId);
			this.#focusScrollRafId = win.requestAnimationFrame(() => {
				this.#focusScrollRafId = null;
				if (win.scrollX !== beforeX || win.scrollY !== beforeY) win.scrollTo(beforeX, beforeY);
			});
		};
	}
	get editor() {
		return this.#editor;
	}
	attachCollaboration({ ydoc, collaborationProvider }) {
		const prevProvider = this.#options.collaborationProvider;
		this.#options.collaborationProvider = collaborationProvider;
		this.#remoteCursorManager?.setCollaborationProvider(collaborationProvider);
		try {
			this.#editor.attachCollaboration({
				ydoc,
				collaborationProvider
			});
		} catch (err) {
			this.#options.collaborationProvider = prevProvider;
			this.#remoteCursorManager?.setCollaborationProvider(prevProvider ?? null);
			throw err;
		}
	}
	get element() {
		return this.#visibleHost;
	}
	get proofingManager() {
		return this.#proofingManager;
	}
	updateProofingConfig(patch) {
		if (!this.#proofingManager) {
			if (patch.enabled && patch.provider) {
				this.#proofingManager = new ProofingSessionManager({
					...patch,
					enabled: true
				});
				this.#wireProofingManagerAdapters();
				if (this.#editor?.state?.doc) this.#proofingManager.runInitialCheck(this.#editor.state.doc);
			}
			return;
		}
		this.#proofingManager.updateConfig(patch, this.#editor?.state?.doc);
		this.#applyProofingPass();
	}
	get commands() {
		return this.getActiveEditor().commands;
	}
	get state() {
		return this.getActiveEditor().state;
	}
	get isEditable() {
		return this.getActiveEditor().isEditable;
	}
	get options() {
		return this.getActiveEditor().options;
	}
	dispatch(tr) {
		this.getActiveEditor().view?.dispatch(tr);
	}
	focus() {
		this.getActiveEditor().view?.focus();
	}
	getActiveEditor() {
		const storySession = this.#storySessionManager?.getActiveSession();
		if (storySession) return storySession.editor;
		const session = this.#headerFooterSession?.session;
		const activeHfEditor = this.#headerFooterSession?.activeEditor;
		if (!session || session.mode === "body" || !activeHfEditor) return this.#editor;
		return activeHfEditor;
	}
	#getActiveStorySession() {
		return this.#storySessionManager?.getActiveSession() ?? null;
	}
	#getActiveNoteStorySession() {
		const session = this.#getActiveStorySession();
		if (!session || session.kind !== "note") return null;
		if (session.locator.storyType !== "footnote" && session.locator.storyType !== "endnote") return null;
		return session;
	}
	#buildActiveNoteRenderOverride(storyType) {
		const session = this.#getActiveNoteStorySession();
		if (!session || session.locator.storyType !== storyType) return null;
		const storyEditor = session.editor;
		const docJson = typeof storyEditor.getUpdatedJson === "function" ? storyEditor.getUpdatedJson() : typeof storyEditor.getJSON === "function" ? storyEditor.getJSON() : null;
		if (!docJson || typeof docJson !== "object") return null;
		return {
			noteId: session.locator.noteId,
			docJson
		};
	}
	#getActiveTrackedChangeStorySurface() {
		const storySession = this.#getActiveStorySession();
		if (storySession) return {
			storyKey: buildStoryKey(storySession.locator),
			editor: storySession.editor
		};
		const headerFooterSession = this.#headerFooterSession?.session;
		const activeHeaderFooterEditor = this.#headerFooterSession?.activeEditor;
		const headerFooterRefId = headerFooterSession && headerFooterSession.mode !== "body" ? headerFooterSession.headerFooterRefId : null;
		if (!headerFooterRefId || !activeHeaderFooterEditor) return null;
		return {
			storyKey: buildStoryKey({
				kind: "story",
				storyType: "headerFooterPart",
				refId: headerFooterRefId
			}),
			editor: activeHeaderFooterEditor
		};
	}
	getStorySessionManager() {
		return this.#storySessionManager;
	}
	getActiveStoryLocator() {
		const storySession = this.#storySessionManager?.getActiveSession();
		if (storySession) return storySession.locator;
		const session = this.#headerFooterSession?.session;
		if (!session || session.mode === "body" || !session.headerFooterRefId) return null;
		return {
			kind: "story",
			storyType: "headerFooterPart",
			refId: session.headerFooterRefId
		};
	}
	exitActiveStorySurface() {
		if ((this.#headerFooterSession?.session?.mode ?? "body") !== "body") this.#exitHeaderFooterMode();
		if (this.#getActiveStorySession()) this.#exitActiveStorySession();
	}
	#resolveActiveSurface() {
		const mode = this.#headerFooterSession?.session?.mode ?? "body";
		if (mode === "header") return "header";
		if (mode === "footer") return "footer";
		const locator = (this.#storySessionManager?.getActiveSession())?.locator;
		if (locator?.storyType === "footnote") return "note";
		if (locator?.storyType === "endnote") return "endnote";
		return "body";
	}
	captureCurrentSelectionHandle() {
		const surface = this.#resolveSelectionHandleSurface();
		return this.getActiveEditor().captureCurrentSelectionHandle(surface);
	}
	captureEffectiveSelectionHandle() {
		const surface = this.#resolveSelectionHandleSurface();
		return this.getActiveEditor().captureEffectiveSelectionHandle(surface);
	}
	#resolveSelectionHandleSurface() {
		const surface = this.#resolveActiveSurface();
		return surface === "header" || surface === "footer" ? surface : "body";
	}
	resolveSelectionHandle(handle) {
		const ownerEditor = handle._owner;
		const range = ownerEditor.resolveSelectionHandle(handle);
		if (!range) return null;
		return {
			editor: ownerEditor,
			doc: ownerEditor.doc,
			surface: handle.surface,
			range
		};
	}
	releaseSelectionHandle(handle) {
		handle._owner.releaseSelectionHandle(handle);
	}
	getCurrentSelectionRange() {
		return this.getActiveEditor().getCurrentSelectionRange();
	}
	getEffectiveSelectionRange() {
		return this.getActiveEditor().getEffectiveSelectionRange();
	}
	getCurrentSelectionContext() {
		const activeEditor = this.getActiveEditor();
		return {
			editor: activeEditor,
			doc: activeEditor.doc,
			surface: this.#resolveSelectionHandleSurface(),
			range: activeEditor.getCurrentSelectionRange()
		};
	}
	getEffectiveSelectionContext() {
		const activeEditor = this.getActiveEditor();
		return {
			editor: activeEditor,
			doc: activeEditor.doc,
			surface: this.#resolveSelectionHandleSurface(),
			range: activeEditor.getEffectiveSelectionRange()
		};
	}
	#canRunEditorHistoryCommand(editor, command$1) {
		if (!editor) return false;
		try {
			return Boolean(command$1 === "undo" ? runEditorUndo(editor, { allowDispatch: false }) : runEditorRedo(editor, { allowDispatch: false }));
		} catch {
			return false;
		}
	}
	canUndo() {
		if (this.#historyCoordinator) return this.#historyCoordinator.canUndo();
		return this.#canRunEditorHistoryCommand(this.getActiveEditor(), "undo");
	}
	canRedo() {
		if (this.#historyCoordinator) return this.#historyCoordinator.canRedo();
		return this.#canRunEditorHistoryCommand(this.getActiveEditor(), "redo");
	}
	undo() {
		if (this.#historyCoordinator) {
			const result = this.#historyCoordinator.undo();
			this.#debugUnifiedHistory("undo()", {
				mode: "coordinator",
				result,
				activeSurface: this.#resolveActiveSurface(),
				state: this.#historyCoordinator.getState()
			});
			return result;
		}
		try {
			const result = Boolean(runEditorUndo(this.getActiveEditor()));
			this.#debugUnifiedHistory("undo()", {
				mode: "legacy",
				result,
				activeSurface: this.#resolveActiveSurface(),
				state: readEditorHistorySnapshot(this.getActiveEditor())
			});
			return result;
		} catch {
			return false;
		}
	}
	redo() {
		if (this.#historyCoordinator) {
			const result = this.#historyCoordinator.redo();
			this.#debugUnifiedHistory("redo()", {
				mode: "coordinator",
				result,
				activeSurface: this.#resolveActiveSurface(),
				state: this.#historyCoordinator.getState()
			});
			return result;
		}
		try {
			const result = Boolean(runEditorRedo(this.getActiveEditor()));
			this.#debugUnifiedHistory("redo()", {
				mode: "legacy",
				result,
				activeSurface: this.#resolveActiveSurface(),
				state: readEditorHistorySnapshot(this.getActiveEditor())
			});
			return result;
		} catch {
			return false;
		}
	}
	getHistoryState() {
		if (this.#historyCoordinator) return this.#historyCoordinator.getState();
		const activeEditorSnapshot = readEditorHistorySnapshot(this.getActiveEditor());
		return {
			canUndo: this.canUndo(),
			canRedo: this.canRedo(),
			undoDepth: activeEditorSnapshot.undoDepth,
			redoDepth: activeEditorSnapshot.redoDepth
		};
	}
	get historyCoordinator() {
		return this.#historyCoordinator;
	}
	recordHistoryBatch(batch) {
		this.#historyCoordinator?.withHistoryBatch(batch);
	}
	dispatchInActiveEditor(callback) {
		callback(this.getActiveEditor());
	}
	get visibleHost() {
		return this.#visibleHost;
	}
	get scrollContainer() {
		const container = this.#scrollContainer;
		if (!container || !("ownerDocument" in container)) return null;
		const HTMLElementCtor = container.ownerDocument?.defaultView?.HTMLElement;
		return HTMLElementCtor && container instanceof HTMLElementCtor ? container : null;
	}
	get overlayElement() {
		return this.#selectionOverlay ?? null;
	}
	get zoom() {
		return this.#layoutOptions.zoom ?? 1;
	}
	setDocumentMode(mode) {
		if (typeof mode !== "string") throw new TypeError(`[PresentationEditor] setDocumentMode expects a string, received ${typeof mode}`);
		const validModes = [
			"editing",
			"viewing",
			"suggesting"
		];
		if (!validModes.includes(mode)) throw new TypeError(`[PresentationEditor] Invalid mode "${mode}". Must be one of: ${validModes.join(", ")}`);
		const modeChanged = this.#documentMode !== mode;
		this.#documentMode = mode;
		this.#editor.setDocumentMode(mode);
		this.#headerFooterSession?.setDocumentMode(mode);
		this.#syncActiveStorySessionDocumentMode(this.#storySessionManager?.getActiveSession() ?? null);
		this.#syncDocumentModeClass();
		this.#syncHiddenEditorA11yAttributes();
		const trackedChangesChanged = this.#syncTrackedChangesPreferences();
		this.#syncHeaderFooterTrackedChangesRenderConfig();
		if (modeChanged || trackedChangesChanged) {
			this.#flowBlockCache.clear();
			this.#pendingDocChange = true;
			this.#scheduleRerender();
		}
		this.#updatePermissionOverlay();
		this.emit("documentModeChange", {
			editor: this.#editor,
			documentMode: mode
		});
	}
	#syncDocumentModeClass() {
		if (!this.#visibleHost) return;
		this.#visibleHost.classList.toggle("presentation-editor--viewing", this.#documentMode === "viewing");
		this.#visibleHost.classList.toggle("presentation-editor--allow-selection", this.#documentMode === "viewing" && !!this.#options.allowSelectionInViewMode);
	}
	setTrackedChangesOverrides(overrides) {
		if (overrides !== void 0 && (typeof overrides !== "object" || overrides === null || Array.isArray(overrides))) throw new TypeError("[PresentationEditor] setTrackedChangesOverrides expects an object or undefined");
		if (overrides !== void 0) {
			const validModes = [
				"review",
				"original",
				"final",
				"off"
			];
			if (overrides.mode !== void 0 && !validModes.includes(overrides.mode)) throw new TypeError(`[PresentationEditor] Invalid tracked changes mode "${overrides.mode}". Must be one of: ${validModes.join(", ")}`);
			if (overrides.enabled !== void 0 && typeof overrides.enabled !== "boolean") throw new TypeError("[PresentationEditor] tracked changes \"enabled\" must be a boolean");
		}
		this.#trackedChangesOverrides = overrides;
		this.#layoutOptions.trackedChanges = overrides;
		const trackedChangesChanged = this.#syncTrackedChangesPreferences();
		this.#syncHeaderFooterTrackedChangesRenderConfig();
		if (trackedChangesChanged) {
			this.#flowBlockCache.clear();
			this.#pendingDocChange = true;
			this.#scheduleRerender();
		}
	}
	setViewingCommentOptions(options = {}) {
		if (options !== void 0 && (typeof options !== "object" || options === null || Array.isArray(options))) throw new TypeError("[PresentationEditor] setViewingCommentOptions expects an object or undefined");
		let hasChanges = false;
		if (typeof options.emitCommentPositionsInViewing === "boolean") {
			if (this.#layoutOptions.emitCommentPositionsInViewing !== options.emitCommentPositionsInViewing) {
				this.#layoutOptions.emitCommentPositionsInViewing = options.emitCommentPositionsInViewing;
				hasChanges = true;
			}
		}
		if (typeof options.enableCommentsInViewing === "boolean") {
			if (this.#layoutOptions.enableCommentsInViewing !== options.enableCommentsInViewing) {
				this.#layoutOptions.enableCommentsInViewing = options.enableCommentsInViewing;
				hasChanges = true;
			}
		}
		if (hasChanges) {
			this.#flowBlockCache.clear();
			this.#pendingDocChange = true;
			this.#scheduleRerender();
		}
	}
	setContextMenuDisabled(disabled) {
		this.#editor.setOptions({ disableContextMenu: Boolean(disabled) });
	}
	onLayoutUpdated(handler) {
		this.on("layoutUpdated", handler);
		return () => this.off("layoutUpdated", handler);
	}
	onLayoutError(handler) {
		this.on("layoutError", handler);
		return () => this.off("layoutError", handler);
	}
	getPages() {
		return this.#layoutState.layout?.pages ?? [];
	}
	getLayoutError() {
		return this.#layoutError;
	}
	isLayoutHealthy() {
		return this.#layoutErrorState === "healthy";
	}
	getLayoutHealthState() {
		return this.#layoutErrorState;
	}
	getSelectionRects(relativeTo) {
		const selection = this.getActiveEditor().state?.selection;
		if (!selection || selection.empty) return [];
		return this.getRangeRects(selection.from, selection.to, relativeTo);
	}
	#computeRangeRects(from$1, to, relativeTo, options = {}) {
		if (!this.#selectionOverlay) return [];
		if (!Number.isFinite(from$1) || !Number.isFinite(to)) return [];
		const start$1 = Math.min(from$1, to);
		const end$1 = Math.max(from$1, to);
		const zoom = this.#layoutOptions.zoom ?? 1;
		const relativeRect = relativeTo?.getBoundingClientRect() ?? null;
		const containerRect = this.#visibleHost.getBoundingClientRect();
		const scrollLeft = this.#visibleHost.scrollLeft ?? 0;
		const scrollTop = this.#visibleHost.scrollTop ?? 0;
		let usedDomRects = false;
		const sessionMode = this.#headerFooterSession?.session?.mode ?? "body";
		const activeNoteSession = this.#getActiveNoteStorySession();
		const useHeaderFooterSurface = !options.forceBodySurface && sessionMode !== "body";
		const useNoteSurface = !options.forceBodySurface && activeNoteSession != null;
		const layoutRectSource = () => {
			if (useHeaderFooterSurface) return this.#computeHeaderFooterSelectionRects(start$1, end$1);
			if (useNoteSurface) return this.#computeNoteSelectionRects(start$1, end$1) ?? [];
			const domRects = this.#computeSelectionRectsFromDom(start$1, end$1);
			if (domRects != null) {
				usedDomRects = true;
				return domRects;
			}
			if (!this.#layoutState.layout) return [];
			return selectionToRects(this.#layoutState.layout, this.#layoutState.blocks, this.#layoutState.measures, start$1, end$1, this.#pageGeometryHelper ?? void 0) ?? [];
		};
		const rawRects = layoutRectSource();
		if (!rawRects.length) return [];
		let domCaretStart = null;
		let domCaretEnd = null;
		const pageDelta = {};
		if (!usedDomRects && !useNoteSurface) {
			try {
				domCaretStart = this.#computeDomCaretPageLocal(start$1);
				domCaretEnd = this.#computeDomCaretPageLocal(end$1);
			} catch (error) {
				if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] DOM caret computation failed in getRectsForRange:", error);
			}
			const layoutCaretStart = this.#computeCaretLayoutRectGeometry(start$1, false);
			if (domCaretStart && layoutCaretStart && domCaretStart.pageIndex === layoutCaretStart.pageIndex) pageDelta[domCaretStart.pageIndex] = {
				dx: domCaretStart.x - layoutCaretStart.x,
				dy: domCaretStart.y - layoutCaretStart.y
			};
		}
		const pageHeight = this.#getBodyPageHeight();
		const pageGap = useHeaderFooterSurface || !this.#layoutState.layout ? 0 : this.#layoutState.layout.pageGap ?? 0;
		return rawRects.map((rect, idx, allRects) => {
			let adjustedX = rect.x;
			let adjustedY = rect.y;
			if (!usedDomRects) {
				const delta = pageDelta[rect.pageIndex];
				adjustedX = delta ? rect.x + delta.dx : rect.x;
				adjustedY = delta ? rect.y + delta.dy : rect.y;
				const isFirstRect = idx === 0;
				const isLastRect = idx === allRects.length - 1;
				if (isFirstRect && domCaretStart && rect.pageIndex === domCaretStart.pageIndex) adjustedX = domCaretStart.x;
				if (isLastRect && domCaretEnd && rect.pageIndex === domCaretEnd.pageIndex) {
					const endX = domCaretEnd.x;
					const newWidth = Math.max(1, endX - adjustedX);
					rect = {
						...rect,
						width: newWidth
					};
				}
			}
			const pageLocalY = adjustedY - rect.pageIndex * (pageHeight + pageGap);
			const coords = this.#convertPageLocalToOverlayCoords(rect.pageIndex, adjustedX, pageLocalY);
			if (!coords) return null;
			const absLeft = coords.x * zoom - scrollLeft + containerRect.left;
			const absTop = coords.y * zoom - scrollTop + containerRect.top;
			const left$1 = relativeRect ? absLeft - relativeRect.left : absLeft;
			const top$1 = relativeRect ? absTop - relativeRect.top : absTop;
			const width = Math.max(1, rect.width * zoom);
			const height = Math.max(1, rect.height * zoom);
			return {
				pageIndex: rect.pageIndex,
				left: left$1,
				top: top$1,
				right: left$1 + width,
				bottom: top$1 + height,
				width,
				height
			};
		}).filter((rect) => Boolean(rect));
	}
	getRangeRects(from$1, to, relativeTo) {
		return this.#computeRangeRects(from$1, to, relativeTo);
	}
	getBodyRangeRects(from$1, to, relativeTo) {
		return this.#computeRangeRects(from$1, to, relativeTo, { forceBodySurface: true });
	}
	getSelectionBounds(from$1, to, relativeTo) {
		if (!this.#layoutState.layout) return null;
		const rects = this.getRangeRects(from$1, to, relativeTo);
		if (!rects.length) return null;
		const bounds = this.#aggregateLayoutBounds(rects);
		if (!bounds) return null;
		return {
			rects,
			bounds,
			pageIndex: rects[0]?.pageIndex ?? 0
		};
	}
	getEntityRects(target) {
		if (!target || typeof target !== "object") return [];
		const entityType = target.entityType;
		const entityId = target.entityId;
		if (typeof entityType !== "string" || typeof entityId !== "string" || entityId.length === 0) return [];
		const host = this.#visibleHost;
		if (!host) return [];
		const storyKey = resolveStoryKeyFromAddress(target.story);
		let elements;
		if (entityType === "trackedChange") elements = findRenderedTrackedChangeElementsStrict(host, entityId, escapeAttrValue, storyKey);
		else if (entityType === "comment") elements = findRenderedCommentElements(host, entityId, storyKey);
		else if (entityType === "contentControl") elements = findRenderedContentControlElements(host, entityId, escapeAttrValue, storyKey);
		else return [];
		return elementsToRangeRects(elements);
	}
	#getThreadSelectionBounds(data, relativeTo) {
		const start$1 = Number.isFinite(data.start ?? data.pos) ? Number(data.start ?? data.pos) : void 0;
		const end$1 = Number.isFinite(data.end) ? Number(data.end) : start$1;
		if (!Number.isFinite(start$1) || !Number.isFinite(end$1)) return null;
		const rects = (typeof data.storyKey === "string" ? data.storyKey : null) === "body" ? this.#computeRangeRects(start$1, end$1, relativeTo, { forceBodySurface: true }) : this.getRangeRects(start$1, end$1, relativeTo);
		if (!rects.length) return null;
		const bounds = this.#aggregateLayoutBounds(rects);
		if (!bounds) return null;
		return {
			rects,
			bounds,
			pageIndex: rects[0]?.pageIndex ?? 0
		};
	}
	getCommentBounds(positions, relativeTo) {
		if (!positions || typeof positions !== "object") return positions;
		if (!this.#layoutState.layout) return positions;
		const entries = Object.entries(positions);
		if (!entries.length) return positions;
		let hasUpdates = false;
		const remapped = {};
		entries.forEach(([threadId, data]) => {
			if (!data) {
				remapped[threadId] = data;
				return;
			}
			const storyTrackedBounds = this.#getStoryTrackedChangeBounds(data, relativeTo);
			if (storyTrackedBounds) {
				hasUpdates = true;
				remapped[threadId] = {
					...data,
					bounds: storyTrackedBounds.bounds,
					rects: storyTrackedBounds.rects,
					pageIndex: storyTrackedBounds.pageIndex
				};
				return;
			}
			const start$1 = data.start ?? data.pos;
			const end$1 = data.end ?? start$1;
			if (!Number.isFinite(start$1) || !Number.isFinite(end$1)) {
				remapped[threadId] = data;
				return;
			}
			const layoutRange = this.#getThreadSelectionBounds(data, relativeTo);
			if (!layoutRange) {
				remapped[threadId] = data;
				return;
			}
			hasUpdates = true;
			remapped[threadId] = {
				...data,
				bounds: layoutRange.bounds,
				rects: layoutRange.rects,
				pageIndex: layoutRange.pageIndex
			};
		});
		return hasUpdates ? remapped : positions;
	}
	#shouldEmitCommentPositions() {
		const allowViewingCommentPositions = this.#layoutOptions.emitCommentPositionsInViewing === true;
		return this.#documentMode !== "viewing" || allowViewingCommentPositions;
	}
	#emitCommentPositions(relativeTo) {
		if (!this.#shouldEmitCommentPositions()) return;
		const commentPositions = this.#collectCommentPositions();
		const positionsWithBounds = relativeTo != null ? this.getCommentBounds(commentPositions, relativeTo) : commentPositions;
		this.emit("commentPositions", { positions: positionsWithBounds });
	}
	#collectCommentPositions() {
		return {
			...collectCommentPositions(this.#editor?.state?.doc ?? null, {
				commentMarkName: CommentMarkName,
				trackChangeMarkNames: [
					TrackInsertMarkName,
					TrackDeleteMarkName,
					TrackFormatMarkName
				],
				storyKey: BODY_STORY_KEY
			}),
			...this.#collectIndexedTrackedChangePositions(),
			...this.#collectStructuralBodyTrackedChangePositions(),
			...this.#collectRenderedTrackedChangePositions()
		};
	}
	#collectStructuralBodyTrackedChangePositions() {
		const positions = {};
		let snapshots = [];
		try {
			snapshots = getTrackedChangeIndex(this.#editor).getAll();
		} catch {
			return positions;
		}
		snapshots.forEach((snapshot) => {
			if (snapshot?.type !== "structural") return;
			const storyKey = typeof snapshot?.runtimeRef?.storyKey === "string" ? snapshot.runtimeRef.storyKey : BODY_STORY_KEY;
			if (storyKey !== "body") return;
			const key = typeof snapshot?.anchorKey === "string" ? snapshot.anchorKey : null;
			const rawId = snapshot?.runtimeRef?.rawId;
			const threadId = rawId == null ? null : String(rawId);
			if (!key || !threadId || positions[key]) return;
			const start$1 = Number.isFinite(snapshot?.range?.from) ? Number(snapshot.range.from) : void 0;
			const end$1 = Number.isFinite(snapshot?.range?.to) ? Number(snapshot.range.to) : void 0;
			positions[key] = {
				threadId,
				key,
				storyKey,
				kind: "trackedChange",
				structural: true,
				...start$1 !== void 0 ? { start: start$1 } : {},
				...end$1 !== void 0 ? { end: end$1 } : {}
			};
		});
		return positions;
	}
	#collectIndexedTrackedChangePositions() {
		const positions = {};
		let snapshots = [];
		try {
			snapshots = getTrackedChangeIndex(this.#editor).getAll();
		} catch {
			return positions;
		}
		snapshots.forEach((snapshot) => {
			const key = typeof snapshot?.anchorKey === "string" ? snapshot.anchorKey : null;
			const storyKey = typeof snapshot?.runtimeRef?.storyKey === "string" ? snapshot.runtimeRef.storyKey : null;
			const rawId = snapshot?.runtimeRef?.rawId;
			const threadId = rawId == null ? null : String(rawId);
			if (!key || !storyKey || !threadId || storyKey === "body" || positions[key]) return;
			const start$1 = Number.isFinite(snapshot?.range?.from) ? Number(snapshot.range.from) : void 0;
			const end$1 = Number.isFinite(snapshot?.range?.to) ? Number(snapshot.range.to) : void 0;
			positions[key] = {
				threadId,
				key,
				storyKey,
				kind: "trackedChange",
				...start$1 !== void 0 ? { start: start$1 } : {},
				...end$1 !== void 0 ? { end: end$1 } : {}
			};
		});
		return positions;
	}
	#collectRenderedTrackedChangePositions() {
		const positions = {};
		const host = this.#visibleHost;
		if (!host) return positions;
		host.querySelectorAll("[data-track-change-id][data-story-key]").forEach((element) => {
			const storyKey = element.dataset.storyKey?.trim();
			const rawId = element.dataset.trackChangeId?.trim();
			if (!storyKey || !rawId || storyKey === "body") return;
			const key = makeTrackedChangeAnchorKey({
				storyKey,
				rawId
			});
			if (positions[key]) return;
			positions[key] = {
				threadId: rawId,
				key,
				storyKey,
				kind: "trackedChange"
			};
		});
		return positions;
	}
	#getStoryTrackedChangeBounds(data, relativeTo) {
		if (data?.kind !== "trackedChange") return null;
		const storyKey = typeof data.storyKey === "string" ? data.storyKey : null;
		if (!storyKey || storyKey === "body") return null;
		const activeSurface = this.#getActiveTrackedChangeStorySurface();
		if (!activeSurface || activeSurface.storyKey !== storyKey) return this.#getRenderedTrackedChangeBounds(data, relativeTo);
		const start$1 = Number.isFinite(data.start) ? Number(data.start) : void 0;
		const end$1 = Number.isFinite(data.end) ? Number(data.end) : start$1;
		if (!Number.isFinite(start$1) || !Number.isFinite(end$1)) return this.#getRenderedTrackedChangeBounds(data, relativeTo);
		const rects = this.getRangeRects(start$1, end$1, relativeTo);
		if (!rects.length) return this.#getRenderedTrackedChangeBounds(data, relativeTo);
		const bounds = this.#aggregateLayoutBounds(rects);
		if (!bounds) return this.#getRenderedTrackedChangeBounds(data, relativeTo);
		return {
			bounds,
			rects,
			pageIndex: rects[0]?.pageIndex ?? 0
		};
	}
	#getRenderedTrackedChangeBounds(data, relativeTo) {
		if (data?.kind !== "trackedChange") return null;
		const storyKey = typeof data.storyKey === "string" ? data.storyKey : null;
		const rawId = typeof data.threadId === "string" ? data.threadId : null;
		if (!storyKey || !rawId || storyKey === "body") return null;
		const elements = this.#findRenderedTrackedChangeElements(rawId, storyKey);
		if (!elements.length) return null;
		const relativeRect = relativeTo?.getBoundingClientRect?.();
		const rects = elements.map((element) => {
			const rect = element.getBoundingClientRect();
			if (![
				rect.top,
				rect.left,
				rect.right,
				rect.bottom,
				rect.width,
				rect.height
			].every(Number.isFinite)) return null;
			const pageIndex = Number(element.closest(".superdoc-page")?.dataset?.pageIndex ?? 0);
			return {
				pageIndex: Number.isFinite(pageIndex) ? pageIndex : 0,
				left: rect.left - (relativeRect?.left ?? 0),
				top: rect.top - (relativeRect?.top ?? 0),
				right: rect.right - (relativeRect?.left ?? 0),
				bottom: rect.bottom - (relativeRect?.top ?? 0),
				width: rect.width,
				height: rect.height
			};
		}).filter((rect) => Boolean(rect));
		if (!rects.length) return null;
		const groupedRects = this.#groupRangeRectsByPage(rects);
		const preferredPageIndex = this.#getPreferredRenderedTrackedChangePageIndex(storyKey, groupedRects, relativeTo);
		const anchorRects = groupedRects.get(preferredPageIndex) ?? rects;
		const bounds = this.#aggregateLayoutBounds(anchorRects);
		if (!bounds) return null;
		return {
			bounds,
			rects,
			pageIndex: preferredPageIndex
		};
	}
	#findRenderedTrackedChangeElements(rawId, storyKey) {
		const host = this.#visibleHost;
		if (!host) return [];
		const baseSelector = `[data-track-change-id="${escapeAttrValue(rawId)}"]`;
		if (!storyKey) return Array.from(host.querySelectorAll(baseSelector));
		const storySelector = `${baseSelector}[data-story-key="${escapeAttrValue(storyKey)}"]`;
		const exactMatches = Array.from(host.querySelectorAll(storySelector));
		const allMatches = Array.from(host.querySelectorAll(baseSelector));
		if (exactMatches.length > 1 || exactMatches.length === allMatches.length || allMatches.length === 0) return exactMatches;
		return allMatches;
	}
	#groupRangeRectsByPage(rects) {
		const grouped = /* @__PURE__ */ new Map();
		rects.forEach((rect) => {
			const pageIndex = Number.isFinite(rect.pageIndex) ? rect.pageIndex : 0;
			const pageRects = grouped.get(pageIndex);
			if (pageRects) {
				pageRects.push(rect);
				return;
			}
			grouped.set(pageIndex, [rect]);
		});
		return grouped;
	}
	#getPreferredRenderedTrackedChangePageIndex(storyKey, groupedRects, relativeTo) {
		const activeHeaderFooterSession = this.#headerFooterSession?.session;
		const activePageIndex = (activeHeaderFooterSession?.mode !== "body" && activeHeaderFooterSession?.headerFooterRefId ? buildStoryKey({
			kind: "story",
			storyType: "headerFooterPart",
			refId: activeHeaderFooterSession.headerFooterRefId
		}) : null) === storyKey && Number.isFinite(activeHeaderFooterSession?.pageIndex) ? Number(activeHeaderFooterSession?.pageIndex) : null;
		if (activePageIndex != null && groupedRects.has(activePageIndex)) return activePageIndex;
		const viewportRect = (this.#scrollContainer instanceof Window ? {
			top: 0,
			bottom: this.#scrollContainer.innerHeight
		} : this.#scrollContainer instanceof Element ? this.#scrollContainer.getBoundingClientRect() : this.#visibleHost?.ownerDocument?.defaultView ? {
			top: 0,
			bottom: this.#visibleHost.ownerDocument.defaultView.innerHeight
		} : this.#visibleHost?.getBoundingClientRect?.()) ?? null;
		if (viewportRect) {
			const relativeRect = relativeTo?.getBoundingClientRect?.();
			const visibleTop = viewportRect.top - (relativeRect?.top ?? 0);
			const visibleBottom = viewportRect.bottom - (relativeRect?.top ?? 0);
			const viewportCenter = visibleTop + (visibleBottom - visibleTop) / 2;
			let bestPageIndex = null;
			let bestIntersection = -1;
			let bestDistance = Number.POSITIVE_INFINITY;
			groupedRects.forEach((pageRects, pageIndex) => {
				const pageBounds = this.#aggregateLayoutBounds(pageRects);
				if (!pageBounds) return;
				const intersection = Math.max(0, Math.min(pageBounds.bottom, visibleBottom) - Math.max(pageBounds.top, visibleTop));
				const pageCenter = pageBounds.top + pageBounds.height / 2;
				const distance = Math.abs(pageCenter - viewportCenter);
				if (intersection > bestIntersection || intersection === bestIntersection && distance < bestDistance || intersection === bestIntersection && distance === bestDistance && (bestPageIndex == null || pageIndex < bestPageIndex)) {
					bestPageIndex = pageIndex;
					bestIntersection = intersection;
					bestDistance = distance;
				}
			});
			if (bestPageIndex != null) return bestPageIndex;
		}
		return [...groupedRects.keys()].sort((left$1, right$1) => left$1 - right$1)[0] ?? 0;
	}
	getLayoutSnapshot() {
		return {
			layout: this.#layoutState.layout,
			blocks: this.#layoutState.blocks,
			measures: this.#layoutState.measures,
			sectionMetadata: this.#sectionMetadata
		};
	}
	getLayoutResolveSnapshot() {
		const blocks = this.#layoutLookupBlocks.length > 0 ? this.#layoutLookupBlocks : this.#layoutState.blocks;
		const measures = this.#layoutLookupMeasures.length > 0 ? this.#layoutLookupMeasures : this.#layoutState.measures;
		return {
			layout: this.#layoutState.layout,
			blocks,
			measures,
			sectionMetadata: this.#sectionMetadata
		};
	}
	getHeaderFooterLayoutSnapshot() {
		return this.#headerFooterSession?.getHeaderFooterLayoutSnapshot() ?? {
			pageBindings: [],
			storyLayouts: {
				headers: [],
				footers: []
			}
		};
	}
	getFontReport() {
		return this.#fontGate?.getReport() ?? [];
	}
	getDocumentFontOptions() {
		return this.#fontGate?.getDocumentFontOptions() ?? [];
	}
	getMissingFonts() {
		return [...new Set(this.getFontReport().filter((record) => record.missing).map((record) => record.logicalFamily))];
	}
	mapFonts(mappings) {
		this.#fontController.map(mappings);
	}
	unmapFonts(families) {
		this.#fontController.unmap(families);
	}
	addFonts(families) {
		this.#fontController.add(families);
	}
	async preloadFonts(families) {
		await this.#fontController.preload(families);
	}
	#applyEmbeddedDocumentFonts() {
		const converter = this.#editor.converter;
		this.#fontController.applyEmbeddedFaces(converter?.getEmbeddedFontFaces?.());
	}
	#requestFontReflow() {
		this.#layoutState = {
			...this.#layoutState,
			blocks: [],
			measures: [],
			layout: null
		};
		this.#pendingDocChange = true;
		this.#scheduleRerender();
	}
	#emitFontsChangedIfChanged(summary) {
		const gate = this.#fontGate;
		if (!gate) return;
		const version$1 = gate.fontConfigVersion;
		const statusKey = summary ? summary.results.map((result) => `${result.family}:${result.status}`).sort().join(",") : "";
		const key = `${version$1}|${this.#fontPlan?.effectiveSignature ?? ""}|${statusKey}`;
		if (key === this.#lastFontsChangedKey) return;
		const isInitial = this.#lastFontsChangedKey === null;
		const epochBumped = !isInitial && version$1 !== this.#lastFontsChangedVersion;
		this.#lastFontsChangedKey = key;
		this.#lastFontsChangedVersion = version$1;
		const pendingSource = this.#nextFontsChangedSource;
		this.#nextFontsChangedSource = null;
		const source = isInitial ? "initial" : pendingSource ?? (epochBumped ? "late-load" : "render-change");
		let resolutions;
		try {
			resolutions = gate.getReport();
		} catch {
			return;
		}
		const payload = {
			documentFonts: [...new Set(resolutions.map((record) => record.logicalFamily))],
			resolutions,
			missingFonts: [...new Set(resolutions.filter((record) => record.missing).map((record) => record.logicalFamily))],
			loadSummary: summary ?? {
				loaded: 0,
				failed: 0,
				timedOut: 0,
				fallbackUsed: 0,
				results: []
			},
			source,
			version: version$1
		};
		this.#lastFontsChangedPayload = payload;
		try {
			this.#editor.emit("fonts-changed", payload);
		} catch {}
	}
	getLastFontsChangedPayload() {
		return this.#lastFontsChangedPayload;
	}
	#resetFontReportStateForDocumentChange() {
		this.#nextFontsChangedSource = null;
		this.#lastFontsChangedKey = null;
		this.#lastFontsChangedVersion = -1;
		this.#lastFontsChangedPayload = null;
		this.#fontPlan = null;
		this.#fontPlanBlocks = null;
	}
	getLayoutOptions() {
		return { ...this.#layoutOptions };
	}
	#isSemanticFlowMode() {
		return this.#layoutOptions.flowMode === "semantic";
	}
	#resolveSemanticMargins(margins) {
		const mode = this.#layoutOptions.semanticOptions?.marginsMode ?? "firstSection";
		if (mode === "none") return {
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		};
		const clamp$2 = (value, fallback) => {
			const v = typeof value === "number" && Number.isFinite(value) ? value : fallback;
			return v >= 0 ? v : fallback;
		};
		if (mode === "custom") {
			const custom = this.#layoutOptions.semanticOptions?.customMargins;
			return {
				left: clamp$2(custom?.left, clamp$2(margins.left, DEFAULT_MARGINS.left)),
				right: clamp$2(custom?.right, clamp$2(margins.right, DEFAULT_MARGINS.right)),
				top: clamp$2(custom?.top, clamp$2(margins.top, DEFAULT_MARGINS.top)),
				bottom: clamp$2(custom?.bottom, clamp$2(margins.bottom, DEFAULT_MARGINS.bottom))
			};
		}
		return {
			left: clamp$2(margins.left, DEFAULT_MARGINS.left),
			right: clamp$2(margins.right, DEFAULT_MARGINS.right),
			top: 0,
			bottom: 0
		};
	}
	#resolveSemanticContainerInnerWidth() {
		const host = this.#visibleHost;
		if (!host) return DEFAULT_PAGE_SIZE.w;
		const style = (host.ownerDocument?.defaultView ?? window).getComputedStyle(host);
		const paddingLeft = Number.parseFloat(style.paddingLeft ?? "0");
		const paddingRight = Number.parseFloat(style.paddingRight ?? "0");
		const horizontalPadding = (Number.isFinite(paddingLeft) ? paddingLeft : 0) + (Number.isFinite(paddingRight) ? paddingRight : 0);
		const clientWidth = host.clientWidth;
		if (Number.isFinite(clientWidth) && clientWidth > 0) return Math.max(1, clientWidth - horizontalPadding);
		const rectWidth = host.getBoundingClientRect().width;
		if (Number.isFinite(rectWidth) && rectWidth > 0) return Math.max(1, rectWidth - horizontalPadding);
		return Math.max(1, DEFAULT_PAGE_SIZE.w - horizontalPadding);
	}
	#setupSemanticResizeObserver() {
		if (!this.#isSemanticFlowMode()) return;
		const ResizeObs = (this.#visibleHost.ownerDocument?.defaultView ?? window).ResizeObserver;
		if (typeof ResizeObs !== "function") return;
		this.#lastSemanticContainerWidth = this.#resolveSemanticContainerInnerWidth();
		this.#semanticResizeObserver = new ResizeObs(() => {
			this.#scheduleSemanticResizeRelayout();
		});
		this.#semanticResizeObserver.observe(this.#visibleHost);
	}
	#scheduleSemanticResizeRelayout() {
		if (!this.#isSemanticFlowMode()) return;
		const view = this.#visibleHost.ownerDocument?.defaultView ?? window;
		if (this.#semanticResizeRaf == null) this.#semanticResizeRaf = view.requestAnimationFrame(() => {
			this.#semanticResizeRaf = null;
			this.#applySemanticResizeRelayout();
		});
		if (this.#semanticResizeDebounce != null) view.clearTimeout(this.#semanticResizeDebounce);
		this.#semanticResizeDebounce = view.setTimeout(() => {
			this.#semanticResizeDebounce = null;
			this.#applySemanticResizeRelayout();
		}, SEMANTIC_RESIZE_DEBOUNCE_MS);
	}
	#applySemanticResizeRelayout() {
		if (!this.#isSemanticFlowMode()) return;
		const nextWidth = this.#resolveSemanticContainerInnerWidth();
		const prevWidth = this.#lastSemanticContainerWidth;
		if (prevWidth != null && Math.abs(nextWidth - prevWidth) < 1) return;
		this.#lastSemanticContainerWidth = nextWidth;
		this.#pendingDocChange = true;
		this.#scheduleRerender();
	}
	getPaintSnapshot() {
		return this.#painterAdapter.getPaintSnapshot();
	}
	getCurrentSectionPageStyles() {
		return getCurrentSectionPageStyles(this.#layoutState.layout, this.#getCurrentPageIndex(), this.#editor.converter?.pageStyles ?? null);
	}
	getRemoteCursors() {
		return Array.from(this.#remoteCursorManager?.state.values() ?? []);
	}
	setLayoutMode(mode) {
		if (this.#isSemanticFlowMode()) return;
		if (!mode || this.#layoutOptions.layoutMode === mode) return;
		this.#layoutOptions.layoutMode = mode;
		if (mode !== "vertical" && this.#layoutOptions.virtualization?.enabled) this.#layoutOptions.virtualization = {
			...this.#layoutOptions.virtualization,
			enabled: false
		};
		this.#painterAdapter.reset();
		this.#pageGeometryHelper = null;
		this.#pendingDocChange = true;
		this.#scheduleRerender();
	}
	setShowBookmarks(showBookmarks) {
		const next = !!showBookmarks;
		if (this.#layoutOptions.showBookmarks === next) return;
		this.#layoutOptions.showBookmarks = next;
		this.#flowBlockCache?.clear();
		this.#pendingDocChange = true;
		this.#scheduleRerender();
	}
	setShowFormattingMarks(showFormattingMarks) {
		const next = !!showFormattingMarks;
		if (this.#layoutOptions.showFormattingMarks === next) return;
		this.#layoutOptions.showFormattingMarks = next;
		this.#painterAdapter.setShowFormattingMarks(next);
		if (!this.#repaintCurrentLayout()) {
			this.#pendingDocChange = true;
			this.#scheduleRerender();
		}
	}
	#repaintCurrentLayout() {
		const layout = this.#layoutState.layout;
		if (!layout) return false;
		const blocks = this.#layoutLookupBlocks.length > 0 ? this.#layoutLookupBlocks : this.#layoutState.blocks;
		const measures = this.#layoutLookupMeasures.length > 0 ? this.#layoutLookupMeasures : this.#layoutState.measures;
		if (blocks.length === 0 || blocks.length !== measures.length) return false;
		const resolvedLayout = resolveLayout({
			layout,
			flowMode: this.#layoutOptions.flowMode ?? "paginated",
			blocks,
			measures,
			fontSignature: this.#layoutFontSignature,
			bookmarks: this.#layoutState.bookmarks
		});
		const isSemanticFlow = this.#layoutOptions.flowMode === "semantic";
		this.#ensurePainter();
		if (!isSemanticFlow) this.#painterAdapter.setProviders(this.#headerFooterSession?.headerDecorationProvider, this.#headerFooterSession?.footerDecorationProvider);
		this.#domIndexObserverManager?.pause();
		try {
			this.#painterAdapter.paint({ resolvedLayout }, this.#painterHost);
			this.#refreshEditorDomAugmentations();
		} finally {
			this.#domIndexObserverManager?.resume();
		}
		this.#revalidateScrollContainer();
		this.#updatePermissionOverlay();
		this.#applyZoom();
		return true;
	}
	hitTest(clientX, clientY) {
		const normalized = this.#normalizeClientPoint(clientX, clientY);
		if (!normalized) return null;
		const noteContext = this.#buildActiveNoteLayoutContext();
		if (noteContext) {
			const geometryHit = clickToPositionGeometry(this.#layoutState.layout, noteContext.blocks, noteContext.measures, normalized, { geometryHelper: this.#pageGeometryHelper ?? void 0 });
			const domHit = this.#resolveNoteDomHit(noteContext, clientX, clientY);
			this.#recordNoteHitDebug({
				clientX,
				clientY,
				geometryPos: geometryHit?.pos ?? null,
				domPos: domHit?.pos ?? null
			});
			const rawHit$1 = domHit ?? geometryHit;
			if (!rawHit$1) return null;
			const doc$2 = this.getActiveEditor().state?.doc;
			if (!doc$2) return rawHit$1;
			return {
				...rawHit$1,
				pos: Math.max(0, Math.min(rawHit$1.pos, doc$2.content.size))
			};
		}
		if ((this.#headerFooterSession?.session?.mode ?? "body") !== "body") {
			const context = this.#getHeaderFooterContext();
			if (!context) return null;
			const pageGap = this.#layoutState.layout?.pageGap ?? this.#getEffectivePageGap();
			const bodyPageHeight = this.#getBodyPageHeight();
			if ((normalized.pageIndex ?? Math.max(0, Math.floor(normalized.y / (bodyPageHeight + pageGap)))) !== context.region.pageIndex) return null;
			const localX = normalized.x - context.region.localX;
			const localY = (normalized.pageLocalY ?? normalized.y - context.region.pageIndex * (bodyPageHeight + pageGap)) - context.region.localY;
			const domHit = this.#resolveHeaderFooterDomHit(context, clientX, clientY);
			if (domHit) {
				const doc$3 = this.getActiveEditor().state?.doc;
				return {
					...domHit,
					pos: doc$3 ? Math.max(0, Math.min(domHit.pos, doc$3.content.size)) : domHit.pos
				};
			}
			if (localX < 0 || localY < 0 || localX > context.region.width || localY > context.region.height) return null;
			const headerPoint = {
				x: localX,
				y: localY
			};
			const hit = clickToPositionGeometry(context.layout, context.blocks, context.measures, headerPoint) ?? null;
			if (!hit) return null;
			const doc$2 = this.getActiveEditor().state?.doc;
			if (!doc$2) return hit;
			return {
				...hit,
				pos: Math.max(0, Math.min(hit.pos, doc$2.content.size))
			};
		}
		if (!this.#layoutState.layout) return null;
		const rawHit = resolvePointerPositionHit({
			layout: this.#layoutState.layout,
			blocks: this.#layoutState.blocks,
			measures: this.#layoutState.measures,
			containerPoint: normalized,
			domContainer: this.#viewportHost,
			clientX,
			clientY,
			geometryHelper: this.#pageGeometryHelper ?? void 0
		}) ?? null;
		if (!rawHit) return null;
		const doc$1 = this.#editor.state?.doc;
		if (!doc$1) return rawHit;
		const mapped = this.#epochMapper.mapPosFromLayoutToCurrentDetailed(rawHit.pos, rawHit.layoutEpoch, 1);
		if (!mapped.ok) {
			debugLog("warn", "hitTest mapping failed", mapped);
			return null;
		}
		const clamped = Math.max(0, Math.min(mapped.pos, doc$1.content.size));
		return {
			...rawHit,
			pos: clamped,
			layoutEpoch: mapped.toEpoch
		};
	}
	#updateSelectionDebugHud() {
		try {
			const activeEditor = this.getActiveEditor();
			const selection = activeEditor?.state?.selection ? {
				from: activeEditor.state.selection.from,
				to: activeEditor.state.selection.to
			} : null;
			updateSelectionDebugHud(this.#viewportHost, {
				docEpoch: this.#epochMapper.getCurrentEpoch(),
				layoutEpoch: this.#layoutEpoch,
				selection,
				lastPointer: this.#editorInputManager?.debugLastPointer ?? null,
				lastHit: this.#editorInputManager?.debugLastHit ?? null
			});
		} catch {}
	}
	#computePendingMarginClick(pointerId, x, y$1) {
		const layout = this.#layoutState.layout;
		const geometryHelper = this.#pageGeometryHelper;
		if (!layout || !geometryHelper) return null;
		const pageIndex = geometryHelper.getPageIndexAtY(y$1);
		if (pageIndex == null) return null;
		const page = layout.pages[pageIndex];
		if (!page) return null;
		const pageWidth = page.size?.w ?? layout.pageSize.w;
		if (!Number.isFinite(pageWidth) || pageWidth <= 0) return null;
		if (!Number.isFinite(x) || x < 0 || x > pageWidth) return null;
		const margins = page.margins ?? this.#layoutOptions.margins ?? DEFAULT_MARGINS;
		const marginLeft = Number.isFinite(margins.left) ? margins.left : DEFAULT_MARGINS.left ?? 0;
		const marginRight = Number.isFinite(margins.right) ? margins.right : DEFAULT_MARGINS.right ?? 0;
		const isLeftMargin = marginLeft > 0 && x < marginLeft;
		const isRightMargin = marginRight > 0 && x > pageWidth - marginRight;
		const pageEl = getPageElementByIndex(this.#viewportHost, pageIndex);
		if (!pageEl) return null;
		const localY = y$1 - geometryHelper.getPageTop(pageIndex);
		if (!Number.isFinite(localY)) return null;
		const zoom = this.#layoutOptions.zoom ?? 1;
		const pageRect = pageEl.getBoundingClientRect();
		const candidates = [];
		const lineEls = Array.from(pageEl.querySelectorAll(".superdoc-line"));
		for (const lineEl of lineEls) {
			if (lineEl.closest(".superdoc-page-header, .superdoc-page-footer")) continue;
			const pmStart = Number(lineEl.dataset.pmStart ?? "NaN");
			const pmEnd = Number(lineEl.dataset.pmEnd ?? "NaN");
			if (!Number.isFinite(pmStart) || !Number.isFinite(pmEnd)) continue;
			const rect = lineEl.getBoundingClientRect();
			const top$1 = (rect.top - pageRect.top) / zoom;
			const bottom$1 = (rect.bottom - pageRect.top) / zoom;
			if (!Number.isFinite(top$1) || !Number.isFinite(bottom$1)) continue;
			const lineEpochRaw = lineEl.dataset.layoutEpoch;
			const pageEpochRaw = pageEl.dataset.layoutEpoch;
			const lineEpoch = lineEpochRaw != null ? Number(lineEpochRaw) : NaN;
			const pageEpoch = pageEpochRaw != null ? Number(pageEpochRaw) : NaN;
			const layoutEpoch = Number.isFinite(lineEpoch) && Number.isFinite(pageEpoch) ? Math.max(lineEpoch, pageEpoch) : Number.isFinite(lineEpoch) ? lineEpoch : Number.isFinite(pageEpoch) ? pageEpoch : 0;
			candidates.push({
				pmStart,
				pmEnd,
				layoutEpoch: Number.isFinite(layoutEpoch) ? layoutEpoch : 0,
				top: top$1,
				bottom: bottom$1
			});
		}
		if (candidates.length === 0) return null;
		const firstBodyLineTop = Math.min(...candidates.map((c) => c.top));
		if (pageIndex === 0 && Number.isFinite(firstBodyLineTop) && localY < firstBodyLineTop) return {
			pointerId,
			kind: "aboveFirstLine"
		};
		if (!isLeftMargin && !isRightMargin) return null;
		let best = null;
		for (const c of candidates) if (localY >= c.top && localY <= c.bottom) {
			best = c;
			break;
		}
		if (!best) {
			let bestDistance = Infinity;
			for (const c of candidates) {
				const center = (c.top + c.bottom) / 2;
				const distance = Math.abs(localY - center);
				if (distance < bestDistance) {
					bestDistance = distance;
					best = c;
				}
			}
		}
		if (!best) return null;
		return {
			pointerId,
			kind: isLeftMargin ? "left" : "right",
			layoutEpoch: best.layoutEpoch,
			pmStart: best.pmStart,
			pmEnd: best.pmEnd
		};
	}
	normalizeClientPoint(clientX, clientY) {
		return this.#normalizeClientPoint(clientX, clientY);
	}
	coordsAtPos(pos) {
		if (!Number.isFinite(pos)) {
			console.warn("[PresentationEditor] coordsAtPos called with invalid position:", pos);
			return null;
		}
		if ((this.#headerFooterSession?.session?.mode ?? "body") !== "body") {
			if (!this.#getHeaderFooterContext()) {
				console.warn("[PresentationEditor] Header/footer context not available for coordsAtPos");
				return null;
			}
			let rect = this.#computeHeaderFooterSelectionRects(pos, pos)?.[0] ?? null;
			if (!rect) rect = this.#computeHeaderFooterCaretRect(pos);
			if (!rect) return null;
			const zoom = this.#layoutOptions.zoom ?? 1;
			const containerRect = this.#visibleHost.getBoundingClientRect();
			const scrollLeft = this.#visibleHost.scrollLeft ?? 0;
			const scrollTop = this.#visibleHost.scrollTop ?? 0;
			const pageHeight = this.#getBodyPageHeight();
			const pageGap = this.#layoutState.layout?.pageGap ?? 0;
			const pageLocalY = rect.y - rect.pageIndex * (pageHeight + pageGap);
			const coords = this.#convertPageLocalToOverlayCoords(rect.pageIndex, rect.x, pageLocalY);
			if (!coords) return null;
			return {
				top: coords.y * zoom - scrollTop + containerRect.top,
				bottom: coords.y * zoom - scrollTop + containerRect.top + rect.height * zoom,
				left: coords.x * zoom - scrollLeft + containerRect.left,
				right: coords.x * zoom - scrollLeft + containerRect.left + rect.width * zoom,
				width: rect.width * zoom,
				height: rect.height * zoom
			};
		}
		if (this.#getActiveNoteStorySession()) {
			let rect = (this.#computeNoteSelectionRects(pos, pos) ?? [])?.[0] ?? null;
			if (!rect) rect = this.#computeNoteCaretRect(pos);
			if (!rect) return null;
			const zoom = this.#layoutOptions.zoom ?? 1;
			const containerRect = this.#visibleHost.getBoundingClientRect();
			const scrollLeft = this.#visibleHost.scrollLeft ?? 0;
			const scrollTop = this.#visibleHost.scrollTop ?? 0;
			const pageHeight = this.#getBodyPageHeight();
			const pageGap = this.#layoutState.layout?.pageGap ?? 0;
			const pageLocalY = rect.y - rect.pageIndex * (pageHeight + pageGap);
			const coords = this.#convertPageLocalToOverlayCoords(rect.pageIndex, rect.x, pageLocalY);
			if (!coords) return null;
			return {
				top: coords.y * zoom - scrollTop + containerRect.top,
				bottom: coords.y * zoom - scrollTop + containerRect.top + rect.height * zoom,
				left: coords.x * zoom - scrollLeft + containerRect.left,
				right: coords.x * zoom - scrollLeft + containerRect.left + Math.max(1, rect.width) * zoom,
				width: Math.max(1, rect.width) * zoom,
				height: rect.height * zoom
			};
		}
		const rects = this.getRangeRects(pos, pos);
		if (rects && rects.length > 0) {
			const rect = rects[0];
			return {
				top: rect.top,
				bottom: rect.bottom,
				left: rect.left,
				right: rect.right,
				width: rect.width,
				height: rect.height
			};
		}
		const caretRect = this.#computeCaretLayoutRect(pos);
		if (caretRect) {
			const viewport$1 = this.denormalizeClientPoint(caretRect.x, caretRect.y, caretRect.pageIndex, caretRect.height);
			if (viewport$1) {
				const h$2 = viewport$1.height ?? caretRect.height;
				return {
					top: viewport$1.y,
					bottom: viewport$1.y + h$2,
					left: viewport$1.x,
					right: viewport$1.x + 1,
					width: 1,
					height: h$2
				};
			}
		}
		return null;
	}
	getElementAtPos(pos, options = {}) {
		if (!Number.isFinite(pos)) return null;
		if (!this.#painterHost) return null;
		if ((this.#headerFooterSession?.session?.mode ?? "body") !== "body") return null;
		if (options.forceRebuild || this.#domPositionIndex.size === 0) this.#rebuildDomPositionIndex();
		const indexed = this.#domPositionIndex.findElementAtPosition(pos);
		if (indexed) return indexed;
		if (!options.fallbackToCoords) return null;
		const rects = this.getRangeRects(pos, pos);
		if (!rects.length) return null;
		const doc$1 = this.#visibleHost.ownerDocument ?? document;
		for (const rect of rects) {
			const el = doc$1.elementFromPoint(rect.left + rect.width / 2, rect.top + rect.height / 2);
			if (el instanceof HTMLElement && this.#painterHost.contains(el)) return el.closest("[data-pm-start][data-pm-end]") ?? el;
		}
		return null;
	}
	#isElementFullyVisibleInScrollContainer(el) {
		const rect = el.getBoundingClientRect();
		const viewport$1 = this.#scrollContainer instanceof Window ? {
			top: 0,
			bottom: this.#scrollContainer.innerHeight
		} : this.#scrollContainer instanceof Element ? this.#scrollContainer.getBoundingClientRect() : this.#visibleHost?.ownerDocument?.defaultView ? {
			top: 0,
			bottom: this.#visibleHost.ownerDocument.defaultView.innerHeight
		} : null;
		if (!viewport$1) return false;
		return rect.top >= viewport$1.top && rect.bottom <= viewport$1.bottom;
	}
	scrollToPosition(pos, options = {}) {
		if (this.#focusScrollRafId != null) {
			const win = this.#visibleHost.ownerDocument?.defaultView;
			if (win) win.cancelAnimationFrame(this.#focusScrollRafId);
			this.#focusScrollRafId = null;
		}
		const doc$1 = this.getActiveEditor()?.state?.doc;
		if (!doc$1) return false;
		if (!Number.isFinite(pos)) return false;
		const clampedPos = Math.max(0, Math.min(pos, doc$1.content.size));
		const behavior = options.behavior ?? "auto";
		const requestedBlock = options.block ?? "center";
		const layout = this.#layoutState.layout;
		const sessionMode = this.#headerFooterSession?.session?.mode ?? "body";
		if (layout && sessionMode === "body") {
			let pageIndex = null;
			for (let idx = 0; idx < layout.pages.length; idx++) {
				const page = layout.pages[idx];
				for (const fragment of page.fragments) {
					const frag = fragment;
					if (frag.pmStart != null && frag.pmEnd != null && clampedPos >= frag.pmStart && clampedPos <= frag.pmEnd) {
						pageIndex = idx;
						break;
					}
				}
				if (pageIndex != null) break;
			}
			if (pageIndex != null) {
				const pageEl = getPageElementByIndex(this.#viewportHost, pageIndex);
				if (pageEl) {
					const targetEl = this.#findElementAtPosition(pageEl, clampedPos);
					const elToScroll = targetEl ?? pageEl;
					const block = options.ifNeeded && targetEl && this.#isElementFullyVisibleInScrollContainer(targetEl) ? "nearest" : requestedBlock;
					elToScroll.scrollIntoView({
						block,
						inline: "nearest",
						behavior
					});
					this.#shouldScrollSelectionIntoView = false;
					const win = this.#visibleHost.ownerDocument?.defaultView;
					if (win) {
						if (options.suppressSelectionSyncScroll) this.#suppressSelectionScrollUntilRaf = true;
						win.requestAnimationFrame(() => {
							elToScroll.scrollIntoView({
								block,
								inline: "nearest",
								behavior
							});
							this.#shouldScrollSelectionIntoView = false;
							this.#suppressSelectionScrollUntilRaf = false;
						});
					}
					return true;
				}
			}
			return false;
		} else return false;
	}
	getReachableThreadAnchorClientY(threadId, targetClientY) {
		return this.#buildThreadAnchorScrollPlan(threadId, targetClientY)?.achievedClientY ?? null;
	}
	scrollThreadAnchorToClientY(threadId, targetClientY, options = {}) {
		const scrollPlan = this.#buildThreadAnchorScrollPlan(threadId, targetClientY);
		if (!scrollPlan) return false;
		const behavior = options.behavior ?? "auto";
		scrollPlan.applyScroll(behavior);
		return true;
	}
	#buildThreadAnchorScrollPlan(threadId, targetClientY) {
		if (!threadId || !Number.isFinite(targetClientY)) return null;
		const threadPosition = this.#resolveCommentPositionEntry(threadId);
		if (!threadPosition) return null;
		const boundedEntry = this.getCommentBounds({ [threadId]: threadPosition })[threadId] ?? threadPosition;
		const currentTopValue = typeof boundedEntry.bounds === "object" && boundedEntry.bounds != null ? boundedEntry.bounds.top : void 0;
		if (!Number.isFinite(currentTopValue)) return null;
		const currentTop = Number(currentTopValue);
		const requestedScrollDelta = currentTop - targetClientY;
		const scrollTarget = this.#scrollContainer ?? this.#visibleHost;
		if (scrollTarget instanceof Window) return this.#buildWindowThreadAnchorScrollPlan(scrollTarget, currentTop, requestedScrollDelta);
		if (scrollTarget instanceof HTMLElement) return this.#buildElementThreadAnchorScrollPlan(scrollTarget, currentTop, requestedScrollDelta);
		return null;
	}
	#resolveCommentPositionEntry(threadId) {
		const positions = this.#collectCommentPositions();
		const directMatch = positions[threadId];
		if (directMatch) return directMatch;
		return Object.values(positions).find((entry) => entry?.key === threadId || entry?.threadId === threadId) ?? null;
	}
	#buildWindowThreadAnchorScrollPlan(scrollTarget, currentTop, requestedScrollDelta) {
		const scrollRoot = scrollTarget.document.scrollingElement ?? scrollTarget.document.documentElement ?? scrollTarget.document.body ?? null;
		const currentScrollTop = scrollTarget.scrollY ?? scrollTarget.pageYOffset ?? scrollRoot?.scrollTop ?? 0;
		const viewportHeight = scrollTarget.innerHeight ?? scrollRoot?.clientHeight ?? 0;
		const maxScrollTop = Math.max(0, (scrollRoot?.scrollHeight ?? 0) - viewportHeight);
		const nextScrollTop = Math.max(0, Math.min(maxScrollTop, currentScrollTop + requestedScrollDelta));
		const appliedScrollDelta = nextScrollTop - currentScrollTop;
		return {
			achievedClientY: currentTop - appliedScrollDelta,
			applyScroll: (behavior) => {
				if (Math.abs(appliedScrollDelta) < 1) return;
				scrollTarget.scrollTo({
					top: nextScrollTop,
					behavior
				});
			}
		};
	}
	#buildElementThreadAnchorScrollPlan(scrollTarget, currentTop, requestedScrollDelta) {
		const currentScrollTop = scrollTarget.scrollTop;
		const maxScrollTop = Math.max(0, scrollTarget.scrollHeight - scrollTarget.clientHeight);
		const nextScrollTop = Math.max(0, Math.min(maxScrollTop, currentScrollTop + requestedScrollDelta));
		const appliedScrollDelta = nextScrollTop - currentScrollTop;
		return {
			achievedClientY: currentTop - appliedScrollDelta,
			applyScroll: (behavior) => {
				if (Math.abs(appliedScrollDelta) < 1) return;
				scrollTarget.scrollTo({
					top: nextScrollTop,
					behavior
				});
			}
		};
	}
	#findElementAtPosition(pageEl, pos) {
		const elements = Array.from(pageEl.querySelectorAll("[data-pm-start][data-pm-end]"));
		let bestMatch = null;
		let smallestRange = Infinity;
		for (const el of elements) {
			const htmlEl = el;
			if (htmlEl.closest(".superdoc-page-header, .superdoc-page-footer")) continue;
			const start$1 = Number(htmlEl.dataset.pmStart);
			const end$1 = Number(htmlEl.dataset.pmEnd);
			if (!Number.isFinite(start$1) || !Number.isFinite(end$1)) continue;
			if (pos >= start$1 && pos <= end$1) {
				const range = end$1 - start$1;
				if (range < smallestRange) {
					smallestRange = range;
					bestMatch = htmlEl;
				}
			}
		}
		return bestMatch;
	}
	async scrollToPositionAsync(pos, options = {}) {
		if (this.scrollToPosition(pos, options)) return true;
		const doc$1 = this.getActiveEditor()?.state?.doc;
		if (!doc$1 || !Number.isFinite(pos)) return false;
		const clampedPos = Math.max(0, Math.min(pos, doc$1.content.size));
		const layout = this.#layoutState.layout;
		const sessionMode = this.#headerFooterSession?.session?.mode ?? "body";
		if (!layout || sessionMode !== "body") return false;
		let pageIndex = null;
		for (let idx = 0; idx < layout.pages.length; idx++) {
			const page = layout.pages[idx];
			for (const fragment of page.fragments) {
				const frag = fragment;
				if (frag.pmStart != null && frag.pmEnd != null && clampedPos >= frag.pmStart && clampedPos <= frag.pmEnd) {
					pageIndex = idx;
					break;
				}
			}
			if (pageIndex != null) break;
		}
		if (pageIndex == null) return false;
		this.#scrollPageIntoView(pageIndex);
		if (!await this.#waitForPageMount(pageIndex, { timeout: PresentationEditor.ANCHOR_NAV_TIMEOUT_MS })) {
			console.warn(`[PresentationEditor] scrollToPositionAsync: Page ${pageIndex} failed to mount within timeout`);
			return false;
		}
		return this.scrollToPosition(pos, {
			...options,
			ifNeeded: false
		});
	}
	async scrollContentControlIntoView(entityId, options = {}) {
		const pos = this.#resolveContentControlCaretPos(entityId);
		if (pos == null) return false;
		return this.scrollToPositionAsync(pos, {
			behavior: options.behavior ?? "smooth",
			block: options.block ?? "center"
		});
	}
	#resolveContentControlCaretPos(entityId) {
		const editor = this.#editor;
		if (!editor || typeof entityId !== "string" || entityId.length === 0) return null;
		let found = null;
		editor.state.doc.descendants((node, pos) => {
			if (found) return false;
			const name = node.type?.name;
			if ((name === "structuredContent" || name === "structuredContentBlock") && String(node.attrs?.id) === entityId) {
				found = {
					pos,
					node
				};
				return false;
			}
			return true;
		});
		if (!found) return null;
		let contentPos = found.pos + 1;
		let textFound = false;
		found.node?.descendants((child, rel) => {
			if (textFound) return false;
			if (child.isText) {
				contentPos = found.pos + 1 + rel;
				textFound = true;
				return false;
			}
			return true;
		});
		return contentPos;
	}
	async focusContentControl(entityId, options = {}) {
		const editor = this.#editor;
		if (!editor) return {
			success: false,
			reason: "not-ready"
		};
		if (typeof entityId !== "string" || entityId.length === 0) return {
			success: false,
			reason: "invalid-id"
		};
		const pos = this.#resolveContentControlCaretPos(entityId);
		if (pos == null) return {
			success: false,
			reason: "not-found"
		};
		if (typeof editor.commands?.setTextSelection !== "function") return {
			success: false,
			reason: "not-ready"
		};
		if (!await this.scrollToPositionAsync(pos, {
			behavior: options.behavior ?? "smooth",
			block: options.block ?? "center"
		})) return {
			success: false,
			reason: "not-reachable"
		};
		if (!editor.commands.setTextSelection({
			from: pos,
			to: pos
		})) return {
			success: false,
			reason: "not-reachable"
		};
		return { success: true };
	}
	async scrollToPage(pageNumber, scrollBehavior = "smooth") {
		const layout = this.#layoutState.layout;
		if (!layout) return false;
		if (!Number.isInteger(pageNumber)) return false;
		const pageIndex = pageNumber - 1;
		const maxPage = layout.pages.length - 1;
		if (pageIndex < 0 || pageIndex > maxPage) return false;
		let pageEl = getPageElementByIndex(this.#viewportHost, pageIndex);
		if (!pageEl) {
			this.#scrollPageIntoView(pageIndex);
			if (!await this.#waitForPageMount(pageIndex, { timeout: 2e3 })) return false;
			pageEl = getPageElementByIndex(this.#viewportHost, pageIndex);
		}
		if (pageEl) {
			pageEl.scrollIntoView({
				block: "start",
				inline: "nearest",
				behavior: scrollBehavior
			});
			return true;
		}
		return false;
	}
	posAtCoords(coords) {
		const clientX = coords?.clientX ?? coords?.left ?? null;
		const clientY = coords?.clientY ?? coords?.top ?? null;
		if (!Number.isFinite(clientX) || !Number.isFinite(clientY)) {
			console.warn("[PresentationEditor] posAtCoords called with invalid coordinates:", coords);
			return null;
		}
		const hit = this.hitTest(clientX, clientY);
		if (!hit) return null;
		return {
			pos: hit.pos,
			inside: -1
		};
	}
	#aggregateLayoutBounds(rects) {
		if (!rects.length) return null;
		const top$1 = Math.min(...rects.map((rect) => rect.top));
		const left$1 = Math.min(...rects.map((rect) => rect.left));
		const bottom$1 = Math.max(...rects.map((rect) => rect.bottom));
		const right$1 = Math.max(...rects.map((rect) => rect.right));
		if (!Number.isFinite(top$1) || !Number.isFinite(left$1) || !Number.isFinite(bottom$1) || !Number.isFinite(right$1)) return null;
		return {
			top: top$1,
			left: left$1,
			bottom: bottom$1,
			right: right$1,
			width: right$1 - left$1,
			height: bottom$1 - top$1
		};
	}
	setZoom(zoom) {
		if (typeof zoom !== "number") throw new TypeError(`[PresentationEditor] setZoom expects a number, received ${typeof zoom}`);
		if (Number.isNaN(zoom)) throw new RangeError("[PresentationEditor] setZoom expects a valid number (not NaN)");
		if (!Number.isFinite(zoom)) throw new RangeError("[PresentationEditor] setZoom expects a finite number");
		if (zoom <= 0) throw new RangeError("[PresentationEditor] setZoom expects a positive number greater than 0");
		if (zoom > MAX_ZOOM_WARNING_THRESHOLD) console.warn(`[PresentationEditor] Zoom level ${zoom} exceeds recommended maximum of ${MAX_ZOOM_WARNING_THRESHOLD}. Performance may degrade.`);
		this.#layoutOptions.zoom = zoom;
		this.#applyZoom();
		this.#painterAdapter.setZoom(zoom);
		this.emit("zoomChange", { zoom });
		this.#shouldScrollSelectionIntoView = true;
		this.#scheduleSelectionUpdate();
		if (this.#remoteCursorManager?.hasRemoteCursors()) {
			this.#remoteCursorManager.markDirty();
			this.#remoteCursorManager.scheduleUpdate();
		}
		this.#pendingDocChange = true;
		this.#scheduleRerender();
	}
	destroy() {
		if (this.#rafHandle != null) safeCleanup(() => {
			(this.#visibleHost?.ownerDocument?.defaultView ?? window).cancelAnimationFrame(this.#rafHandle);
			this.#rafHandle = null;
		}, "Layout RAF");
		if (this.#focusScrollRafId != null) safeCleanup(() => {
			(this.#visibleHost?.ownerDocument?.defaultView ?? window).cancelAnimationFrame(this.#focusScrollRafId);
			this.#focusScrollRafId = null;
		}, "Focus scroll RAF");
		if (this.#decorationSyncRafHandle != null) safeCleanup(() => {
			(this.#visibleHost?.ownerDocument?.defaultView ?? window).cancelAnimationFrame(this.#decorationSyncRafHandle);
			this.#decorationSyncRafHandle = null;
		}, "Decoration sync RAF");
		this.#postPaintPipeline.destroy();
		this.#proofingManager?.dispose();
		this.#proofingManager = null;
		this.#fontController.dispose();
		this.#fontGate?.dispose();
		this.#fontGate = null;
		if (this.#cursorUpdateTimer !== null) {
			clearTimeout(this.#cursorUpdateTimer);
			this.#cursorUpdateTimer = null;
		}
		if (this.#semanticResizeRaf != null) safeCleanup(() => {
			(this.#visibleHost?.ownerDocument?.defaultView ?? window).cancelAnimationFrame(this.#semanticResizeRaf);
			this.#semanticResizeRaf = null;
		}, "Semantic resize RAF");
		if (this.#semanticResizeDebounce != null) safeCleanup(() => {
			(this.#visibleHost?.ownerDocument?.defaultView ?? window).clearTimeout(this.#semanticResizeDebounce);
			this.#semanticResizeDebounce = null;
		}, "Semantic resize debounce");
		this.#semanticResizeObserver?.disconnect();
		this.#semanticResizeObserver = null;
		if (this.#remoteCursorManager) safeCleanup(() => {
			this.#remoteCursorManager?.destroy();
			this.#remoteCursorManager = null;
		}, "Remote cursor manager");
		this.#remoteCursorOverlay = null;
		this.#selectionSync.destroy();
		this.#editorListeners.forEach(({ event, handler }) => this.#editor?.off(event, handler));
		this.#editorListeners = [];
		this.#domIndexObserverManager?.destroy();
		this.#domIndexObserverManager = null;
		if (this.#editorInputManager) safeCleanup(() => {
			this.#editorInputManager?.destroy();
			this.#editorInputManager = null;
		}, "Editor input manager");
		if (this.#scrollHandler) {
			if (this.#scrollContainer) this.#scrollContainer.removeEventListener("scroll", this.#scrollHandler, { capture: true });
			(this.#visibleHost?.ownerDocument?.defaultView)?.removeEventListener("scroll", this.#scrollHandler, { capture: true });
			this.#scrollHandler = null;
			this.#handledScrollEvents = /* @__PURE__ */ new WeakSet();
			this.#scrollContainer = null;
		}
		this.#inputBridge?.notifyTargetChanged();
		this.#inputBridge?.destroy();
		this.#inputBridge = null;
		if (this.#a11ySelectionAnnounceTimeout != null) {
			clearTimeout(this.#a11ySelectionAnnounceTimeout);
			this.#a11ySelectionAnnounceTimeout = null;
		}
		this.#teardownStorySessionEventBridge();
		this.#teardownActiveSurfaceUiEventBridge();
		if (this.#registryKey) {
			PresentationEditor.#instances.delete(this.#registryKey);
			this.#registryKey = null;
		}
		safeCleanup(() => {
			this.#teardownUnifiedHistoryCoordinator();
		}, "Unified history coordinator");
		safeCleanup(() => {
			this.#headerFooterSession?.destroy();
			this.#headerFooterSession = null;
		}, "Header/footer session manager");
		safeCleanup(() => {
			this.#storySessionManager?.destroy();
			this.#storySessionManager = null;
		}, "Story presentation session manager");
		this.#flowBlockCache.clear();
		this.#layoutLookupBlocks = [];
		this.#layoutLookupMeasures = [];
		this.#painterAdapter.reset();
		this.#pageGeometryHelper = null;
		this.#dragDropManager?.destroy();
		this.#dragDropManager = null;
		this.#selectionOverlay?.remove();
		this.#painterHost?.remove();
		this.#hiddenHostWrapper?.remove();
		this.#hoverOverlay = null;
		this.#hoverTooltip = null;
		this.#modeBanner?.remove();
		this.#modeBanner = null;
		this.#ariaLiveRegion?.remove();
		this.#ariaLiveRegion = null;
		this.#errorBanner?.remove();
		if (this.#editor) {
			this.#editor.presentationEditor = null;
			this.#editor.destroy();
		}
	}
	#rebuildDomPositionIndex() {
		if (!this.#painterHost) return;
		try {
			this.#domPositionIndex.rebuild(this.#painterHost);
		} catch (error) {
			debugLog("warn", "DomPositionIndex rebuild failed", { error: String(error) });
		}
	}
	#initializeProofing() {
		const proofingConfig = this.#options.layoutEngineOptions?.proofing;
		if (!proofingConfig) return;
		this.#proofingManager = new ProofingSessionManager(proofingConfig);
		this.#wireProofingManagerAdapters();
		if (proofingConfig.enabled && this.#editor?.state?.doc) setTimeout(() => {
			this.#proofingManager?.runInitialCheck(this.#editor.state.doc);
		}, 0);
	}
	#buildPageResolver() {
		return (pmPos) => {
			const layout = this.#layoutState.layout;
			if (!layout?.pages) return void 0;
			for (let idx = 0; idx < layout.pages.length; idx++) {
				const page = layout.pages[idx];
				for (const fragment of page.fragments) {
					const frag = fragment;
					if (frag.pmStart != null && frag.pmEnd != null && pmPos >= frag.pmStart && pmPos <= frag.pmEnd) return idx;
				}
			}
		};
	}
	#wireProofingManagerAdapters() {
		const mgr = this.#proofingManager;
		if (!mgr) return;
		mgr.setDocumentId(this.#options.documentId ?? null);
		mgr.onResultsChanged = () => this.#applyProofingPass();
		mgr.setVisibilitySource({ getVisiblePageIndices: () => {
			const mountedPageIndices = this.#painterAdapter.getMountedPageIndices();
			return mountedPageIndices.length > 0 ? mountedPageIndices : null;
		} });
		mgr.setPageResolver(this.#buildPageResolver());
		const editorDom = this.#editor?.view?.dom;
		if (editorDom) {
			editorDom.addEventListener("compositionstart", () => mgr.setComposing(true));
			editorDom.addEventListener("compositionend", () => mgr.setComposing(false));
		}
	}
	#buildProofingAnnotations() {
		if (!this.#proofingManager?.isEnabled) return null;
		const editorState = this.#editor?.state;
		let activeWordRange = null;
		if (editorState?.selection.empty) activeWordRange = computeWordSelectionRangeAt(editorState, editorState.selection.head);
		return this.#proofingManager.getPaintSlices(activeWordRange).map((s) => ({
			pmFrom: s.pmFrom,
			pmTo: s.pmTo,
			kind: s.kind
		}));
	}
	#applyProofingPass() {
		this.#postPaintPipeline.applyProofingAnnotations(this.#buildProofingAnnotations(), () => this.#rebuildDomPositionIndex());
	}
	#notifyProofingOfDocChange(transaction) {
		if (!this.#proofingManager?.isEnabled) return;
		const doc$1 = this.#editor?.state?.doc;
		if (!doc$1) return;
		const changedRanges = [];
		const { mapping } = transaction;
		mapping.maps.forEach((map$1, stepIndex) => {
			const mapFrom = mapping.slice(stepIndex + 1);
			map$1.forEach((_oldStart, _oldEnd, newStart, newEnd) => {
				changedRanges.push({
					from: mapFrom.map(newStart, -1),
					to: mapFrom.map(newEnd, 1)
				});
			});
		});
		this.#proofingManager.onDocumentChanged(doc$1, changedRanges, transaction.mapping);
	}
	#syncCommentHighlights() {
		this.#postPaintPipeline.applyCommentHighlights();
	}
	#syncInlineStyleLayers() {
		const state = this.#editor?.view?.state;
		if (!state) {
			this.#syncCommentHighlights();
			return;
		}
		try {
			this.#postPaintPipeline.syncInlineStyleLayers(state, this.#domPositionIndex);
		} catch (error) {
			console.warn("[PresentationEditor] Inline style layer sync failed:", error);
		}
	}
	#syncDecorations() {
		const state = this.#editor?.view?.state;
		if (!state) return;
		try {
			this.#postPaintPipeline.syncDecorations(state, this.#domPositionIndex);
		} catch (error) {
			console.warn("[PresentationEditor] Decoration sync failed:", error);
		}
	}
	#shouldRestoreEmptyDecorationsAfterTransaction(transaction, state) {
		if (transaction) return transaction.docChanged === true;
		return this.#postPaintPipeline.hasCurrentDecorationRanges(state);
	}
	#scheduleDecorationSync() {
		if (this.#renderScheduled || this.#isRerendering) return;
		const state = this.#editor?.view?.state;
		if (!state || !this.#postPaintPipeline.hasDecorationChanges(state)) return;
		if (this.#decorationSyncRafHandle != null) return;
		this.#decorationSyncRafHandle = (this.#visibleHost?.ownerDocument?.defaultView ?? window).requestAnimationFrame(() => {
			this.#decorationSyncRafHandle = null;
			if (this.#renderScheduled || this.#isRerendering) return;
			this.#syncDecorations();
		});
	}
	#setupEditorListeners() {
		const handleUpdate = ({ transaction }) => {
			const trackedChangesChanged = this.#syncTrackedChangesPreferences();
			this.#syncHeaderFooterTrackedChangesRenderConfig();
			if (transaction) {
				this.#epochMapper.recordTransaction(transaction);
				this.#selectionSync.setDocEpoch(this.#epochMapper.getCurrentEpoch());
				const inputType = transaction.getMeta?.("inputType");
				const ySyncMeta = transaction.getMeta?.(ySyncPluginKey);
				if (transaction.docChanged && (ySyncMeta?.isChangeOrigin || inputType === "historyUndo" || inputType === "historyRedo")) this.#flowBlockCache?.setHasExternalChanges?.(true);
			}
			if (trackedChangesChanged || transaction?.docChanged) {
				this.#pendingDocChange = true;
				if (transaction?.docChanged) if (this.#pendingMapping !== null) {
					const combined = this.#pendingMapping.slice();
					combined.appendMapping(transaction.mapping);
					this.#pendingMapping = combined;
				} else this.#pendingMapping = transaction.mapping;
				this.#selectionSync.onLayoutStart();
				this.#scheduleRerender();
			}
			if (transaction?.docChanged) {
				this.#notifyProofingOfDocChange(transaction);
				this.#updateLocalAwarenessCursor();
				this.#editorInputManager?.clearCellAnchor();
			}
		};
		const handleSelection = () => {
			if (!this.#editorInputManager?.isDragging) this.#shouldScrollSelectionIntoView = true;
			this.#scheduleSelectionUpdate({ immediate: true });
			this.#updateLocalAwarenessCursor();
			this.#scheduleA11ySelectionAnnouncement();
		};
		const handleTransaction = (event) => {
			const tr = event?.transaction;
			this.#postPaintPipeline.recordDecorationTransaction(tr);
			const state = this.#editor?.view?.state;
			const decorationChanged = state && this.#postPaintPipeline.hasDecorationChanges(state);
			if (decorationChanged) {
				const restoreEmpty = this.#shouldRestoreEmptyDecorationsAfterTransaction(tr, state);
				this.#postPaintPipeline.syncDecorations(state, this.#domPositionIndex, { restoreEmptyDecorations: restoreEmpty });
			} else this.#scheduleDecorationSync();
			if (decorationChanged) {
				this.#pendingDocChange = true;
				this.#selectionSync.onLayoutStart();
				this.#scheduleRerender();
			}
		};
		this.#editor.on("update", handleUpdate);
		this.#editor.on("selectionUpdate", handleSelection);
		this.#editor.on("transaction", handleTransaction);
		this.#editorListeners.push({
			event: "update",
			handler: handleUpdate
		});
		this.#editorListeners.push({
			event: "selectionUpdate",
			handler: handleSelection
		});
		this.#editorListeners.push({
			event: "transaction",
			handler: handleTransaction
		});
		const handlePageStyleUpdate = () => {
			this.#pendingDocChange = true;
			this.#selectionSync.onLayoutStart();
			this.#scheduleRerender();
		};
		this.#editor.on("pageStyleUpdate", handlePageStyleUpdate);
		this.#editorListeners.push({
			event: "pageStyleUpdate",
			handler: handlePageStyleUpdate
		});
		const handleStylesDefaultsChanged = () => {
			this.#flowBlockCache.clear();
			this.#pendingDocChange = true;
			this.#selectionSync.onLayoutStart();
			this.#scheduleRerender();
		};
		this.#editor.on("stylesDefaultsChanged", handleStylesDefaultsChanged);
		this.#editorListeners.push({
			event: "stylesDefaultsChanged",
			handler: handleStylesDefaultsChanged
		});
		this.#syncActiveSurfaceUiEventBridge(this.#editor);
		const handleNotesPartChanged = (event) => {
			this.#flowBlockCache.setHasExternalChanges?.(true);
			this.#pendingDocChange = true;
			this.#selectionSync.onLayoutStart();
			this.#scheduleRerender();
			if (!isInternalNoteCommitSource(event)) this.#purgeAllNoteParticipantsOnExternalInvalidation();
		};
		this.#editor.on("notes-part-changed", handleNotesPartChanged);
		this.#editorListeners.push({
			event: "notes-part-changed",
			handler: handleNotesPartChanged
		});
		const handlePartChanged = (event) => {
			if (!event?.parts?.length) return;
			const isInternalHeaderFooterSync = event.source === SOURCE_HEADER_FOOTER_LOCAL;
			const headerFooterStructureChanged = event.parts.some((part) => part.partId === DOCUMENT_RELS_PART_ID);
			const changedHeaderFooterRefIds = Array.from(new Set(event.parts.filter((part) => isHeaderFooterPartId(part.partId)).map((part) => part.sectionId).filter((refId) => typeof refId === "string" && refId.length > 0)));
			if (!headerFooterStructureChanged && changedHeaderFooterRefIds.length === 0) return;
			if (headerFooterStructureChanged) this.#headerFooterSession?.refreshStructure();
			if (changedHeaderFooterRefIds.length > 0) {
				this.#headerFooterSession?.invalidateLayoutForRefs(changedHeaderFooterRefIds);
				if (!isInternalHeaderFooterSync) this.#purgeHeaderFooterParticipantsOnExternalInvalidation(changedHeaderFooterRefIds);
			}
			this.#pendingDocChange = true;
			this.#selectionSync.onLayoutStart();
			this.#scheduleRerender();
		};
		this.#editor.on("partChanged", handlePartChanged);
		this.#editorListeners.push({
			event: "partChanged",
			handler: handlePartChanged
		});
		const handleCollaborationReady = (payload) => {
			this.emit("collaborationReady", payload);
			this.#refreshHeaderFooterStructureThenRerender();
			if (this.#options.collaborationProvider?.awareness && this.#layoutOptions.presence?.enabled !== false) this.#setupCollaborationCursors();
		};
		this.#editor.on("collaborationReady", handleCollaborationReady);
		this.#editorListeners.push({
			event: "collaborationReady",
			handler: handleCollaborationReady
		});
		const handleDocumentReplaced = () => {
			this.#fontGate?.resetForDocumentChange();
			this.#fontController.reset();
			this.#layoutFontSignature = "";
			this.#fontController.applyInitialConfig(this.#options.fontAssets);
			this.#applyEmbeddedDocumentFonts();
			this.#resetFontReportStateForDocumentChange();
			this.#refreshHeaderFooterStructureThenRerender({ purgeCachedEditors: true });
		};
		this.#editor.on("documentReplaced", handleDocumentReplaced);
		this.#editorListeners.push({
			event: "documentReplaced",
			handler: handleDocumentReplaced
		});
		const handleCommentsUpdate = (payload) => {
			if ("activeCommentId" in payload) {
				const activeId = payload.activeCommentId ?? null;
				if (this.#postPaintPipeline.setActiveComment(activeId)) this.#syncInlineStyleLayers();
			}
		};
		this.#editor.on("commentsUpdate", handleCommentsUpdate);
		this.#editorListeners.push({
			event: "commentsUpdate",
			handler: handleCommentsUpdate
		});
		const handleProtectionChanged = () => {
			this.#updatePermissionOverlay();
			this.#pendingDocChange = true;
			this.#scheduleRerender();
		};
		this.#editor.on("protectionChanged", handleProtectionChanged);
		this.#editorListeners.push({
			event: "protectionChanged",
			handler: handleProtectionChanged
		});
	}
	#setupCollaborationCursors() {
		this.#remoteCursorManager?.setup();
	}
	#updateLocalAwarenessCursor() {
		if (this.#cursorUpdateTimer !== null) clearTimeout(this.#cursorUpdateTimer);
		this.#cursorUpdateTimer = setTimeout(() => {
			this.#cursorUpdateTimer = null;
			this.#remoteCursorManager?.updateLocalCursor(this.#editor?.state ?? null);
		}, 100);
	}
	#getRemoteCursorRenderDeps() {
		return {
			layout: this.#layoutState?.layout ?? null,
			blocks: this.#layoutState?.blocks ?? [],
			measures: this.#layoutState?.measures ?? [],
			pageGeometryHelper: this.#pageGeometryHelper,
			pageHeight: this.#layoutOptions.pageSize?.h ?? DEFAULT_PAGE_SIZE.h,
			computeCaretLayoutRect: (pos) => this.#computeCaretLayoutRect(pos),
			convertPageLocalToOverlayCoords: (pageIndex, x, y$1) => this.#convertPageLocalToOverlayCoords(pageIndex, x, y$1)
		};
	}
	#updateRemoteCursors() {
		if (!this.#remoteCursorManager) return;
		this.#remoteCursorManager.update(this.#editor?.state ?? null, this.#getRemoteCursorRenderDeps());
		this.emit("remoteCursorsUpdate", { cursors: Array.from(this.#remoteCursorManager.state.values()) });
	}
	#renderRemoteCursors() {
		this.#remoteCursorManager?.render(this.#getRemoteCursorRenderDeps());
	}
	#initializeEditorInputManager() {
		this.#editorInputManager = new EditorInputManager();
		this.#editorInputManager.setDependencies({
			getActiveEditor: () => this.getActiveEditor(),
			getEditor: () => this.#editor,
			getLayoutState: () => this.#layoutState,
			getEpochMapper: () => this.#epochMapper,
			getViewportHost: () => this.#viewportHost,
			getVisibleHost: () => this.#visibleHost,
			getLayoutMode: () => this.#layoutOptions.layoutMode ?? "vertical",
			getHeaderFooterSession: () => this.#headerFooterSession,
			getPageGeometryHelper: () => this.#pageGeometryHelper,
			getZoom: () => this.#layoutOptions.zoom ?? 1,
			isViewLocked: () => this.#isViewLocked(),
			getDocumentMode: () => this.#documentMode,
			getPageElement: (pageIndex) => this.#getPageElement(pageIndex),
			isSelectionAwareVirtualizationEnabled: () => this.#isSelectionAwareVirtualizationEnabled(),
			getActiveStorySession: () => this.#getActiveStorySession()
		});
		this.#editorInputManager.setCallbacks({
			scheduleSelectionUpdate: () => this.#scheduleSelectionUpdate(),
			scheduleRerender: () => this.#scheduleRerender(),
			setPendingDocChange: () => {
				this.#pendingDocChange = true;
			},
			updateSelectionVirtualizationPins: (options) => this.#updateSelectionVirtualizationPins(options),
			scheduleA11ySelectionAnnouncement: (options) => this.#scheduleA11ySelectionAnnouncement(options),
			goToAnchor: (href) => this.goToAnchor(href),
			emit: (event, payload) => this.emit(event, payload),
			normalizeClientPoint: (clientX, clientY) => this.#normalizeClientPoint(clientX, clientY),
			hitTestHeaderFooterRegion: (x, y$1, pageIndex, pageLocalY) => this.#hitTestHeaderFooterRegion(x, y$1, pageIndex, pageLocalY),
			exitHeaderFooterMode: () => this.#exitHeaderFooterMode(),
			activateHeaderFooterRegion: (region, options) => this.#activateHeaderFooterRegion(region, options),
			emitHeaderFooterEditBlocked: (reason) => this.#emitHeaderFooterEditBlocked(reason),
			findRegionForPage: (kind, pageIndex) => this.#findRegionForPage(kind, pageIndex),
			getCurrentPageIndex: () => this.#getCurrentPageIndex(),
			resolveDescriptorForRegion: (region) => this.#resolveDescriptorForRegion(region),
			updateSelectionDebugHud: () => this.#updateSelectionDebugHud(),
			clearHoverRegion: () => this.#clearHoverRegion(),
			renderHoverRegion: (region) => this.#renderHoverRegion(region),
			hitTest: (clientX, clientY) => this.hitTest(clientX, clientY),
			focusEditorAfterImageSelection: () => this.#focusEditorAfterImageSelection(),
			resolveInlineImageElementByPmStart: (pmStart) => this.#painterAdapter.getInlineImageElementByPmStart(pmStart),
			resolveImageFragmentElementByPmStart: (pmStart) => this.#painterAdapter.getImageFragmentElementByPmStart(pmStart),
			resolveFieldAnnotationSelectionFromElement: (el) => this.#resolveFieldAnnotationSelectionFromElement(el),
			computePendingMarginClick: (pointerId, x, y$1) => this.#computePendingMarginClick(pointerId, x, y$1),
			selectWordAt: (pos) => this.#selectWordAt(pos),
			selectParagraphAt: (pos) => this.#selectParagraphAt(pos),
			finalizeDragSelectionWithDom: (pointer, dragAnchor, dragMode) => this.#finalizeDragSelectionWithDom(pointer, dragAnchor, dragMode),
			notifyDragSelectionEnded: () => {
				this.#shouldScrollSelectionIntoView = true;
				this.#scheduleSelectionUpdate({ immediate: true });
			},
			hitTestTable: (x, y$1) => this.#hitTestTable(x, y$1),
			activateRenderedNoteSession: (target, options) => this.#activateRenderedNoteSession(target, options),
			exitActiveStorySession: () => this.#exitActiveStorySession()
		});
	}
	#setupPointerHandlers() {
		this.#editorInputManager?.bind();
		this.#handledScrollEvents = /* @__PURE__ */ new WeakSet();
		this.#scrollHandler = (event) => {
			if (event) {
				if (this.#handledScrollEvents.has(event)) return;
				this.#handledScrollEvents.add(event);
			}
			this.#painterAdapter.onScroll();
		};
		this.#scrollContainer = this.#findScrollableAncestor(this.#visibleHost);
		if (this.#scrollContainer) this.#scrollContainer.addEventListener("scroll", this.#scrollHandler, {
			passive: true,
			capture: true
		});
		const win = this.#visibleHost.ownerDocument?.defaultView;
		if (win && this.#scrollContainer !== win) win.addEventListener("scroll", this.#scrollHandler, {
			passive: true,
			capture: true
		});
	}
	#findScrollableAncestor(element) {
		const win = element.ownerDocument?.defaultView;
		if (!win) return null;
		let current = element;
		while (current) {
			const overflowY = win.getComputedStyle(current).overflowY;
			if (overflowY === "auto" || overflowY === "scroll") return current;
			current = current.parentElement;
		}
		return win;
	}
	#revalidateScrollContainer() {
		if (this.#scrollContainerValidated) return;
		this.#scrollContainerValidated = true;
		if (!(this.#scrollContainer instanceof Element)) return;
		if (this.#scrollContainer.scrollHeight > this.#scrollContainer.clientHeight + 1) return;
		const win = this.#scrollContainer.ownerDocument?.defaultView;
		const viewportHeight = win?.innerHeight ?? 0;
		if (this.#scrollContainer.clientHeight <= viewportHeight) return;
		let el = this.#scrollContainer.parentElement;
		let next = win ?? null;
		while (el) {
			const { overflowY } = getComputedStyle(el);
			if ((overflowY === "auto" || overflowY === "scroll") && el.scrollHeight > el.clientHeight + 1) {
				next = el;
				break;
			}
			el = el.parentElement;
		}
		if (!next || next === this.#scrollContainer) return;
		this.#scrollContainer.removeEventListener("scroll", this.#scrollHandler, { capture: true });
		this.#scrollContainer = next;
		if (next instanceof Element) next.addEventListener("scroll", this.#scrollHandler, {
			passive: true,
			capture: true
		});
		this.#painterAdapter.setScrollContainer(next instanceof HTMLElement ? next : null);
	}
	#setupDragHandlers() {
		this.#dragDropManager?.destroy();
		this.#dragDropManager = new DragDropManager();
		this.#dragDropManager.setDependencies({
			getActiveEditor: () => this.getActiveEditor(),
			hitTest: (clientX, clientY) => this.hitTest(clientX, clientY),
			scheduleSelectionUpdate: () => this.#scheduleSelectionUpdate(),
			showDragDropIndicator: (pos) => this.#showDragDropIndicator(pos),
			clearDragDropIndicator: () => this.#clearDragDropIndicator(),
			getViewportHost: () => this.#viewportHost,
			getPainterHost: () => this.#painterHost,
			insertImageFile: (params$1) => processAndInsertImageFile(params$1)
		});
		this.#dragDropManager.bind();
	}
	#showDragDropIndicator(pos) {
		const docSize = this.getActiveEditor()?.state?.doc?.content.size;
		if (!Number.isFinite(pos) || docSize == null) return;
		const clampedPos = Math.min(Math.max(pos, 1), docSize);
		if (this.#dragDropIndicatorPos === clampedPos) return;
		this.#dragDropIndicatorPos = clampedPos;
		this.#scheduleSelectionUpdate({ immediate: true });
	}
	#clearDragDropIndicator() {
		if (this.#dragDropIndicatorPos == null) return;
		this.#dragDropIndicatorPos = null;
		this.#scheduleSelectionUpdate({ immediate: true });
	}
	#focusEditorAfterImageSelection() {
		this.#shouldScrollSelectionIntoView = true;
		if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
		const editorDom = this.#editor.view?.dom;
		if (editorDom) {
			editorDom.focus();
			this.#editor.view?.focus();
		}
		this.#scheduleSelectionUpdate({ immediate: true });
	}
	#resolveFieldAnnotationSelectionFromElement(annotationEl) {
		const pmStartRaw = annotationEl.dataset?.pmStart;
		if (pmStartRaw == null) return null;
		const pmStart = Number(pmStartRaw);
		if (!Number.isFinite(pmStart)) return null;
		const doc$1 = this.#editor.state?.doc;
		if (!doc$1) return null;
		const layoutEpochRaw = annotationEl.dataset?.layoutEpoch;
		const layoutEpoch = layoutEpochRaw != null ? Number(layoutEpochRaw) : NaN;
		const effectiveEpoch = Number.isFinite(layoutEpoch) ? layoutEpoch : this.#epochMapper.getCurrentEpoch();
		const mapped = this.#epochMapper.mapPosFromLayoutToCurrentDetailed(pmStart, effectiveEpoch, 1);
		if (!mapped.ok) {
			const fallbackPos = Math.max(0, Math.min(pmStart, doc$1.content.size));
			const fallbackNode = doc$1.nodeAt(fallbackPos);
			if (fallbackNode?.type?.name === "fieldAnnotation") return {
				node: fallbackNode,
				pos: fallbackPos
			};
			this.#pendingDocChange = true;
			this.#scheduleRerender();
			return null;
		}
		const clampedPos = Math.max(0, Math.min(mapped.pos, doc$1.content.size));
		const node = doc$1.nodeAt(clampedPos);
		if (!node || node.type.name !== "fieldAnnotation") return null;
		return {
			node,
			pos: clampedPos
		};
	}
	#setupInputBridge() {
		this.#inputBridge?.destroy();
		this.#inputBridge = new PresentationInputBridge(this.#visibleHost.ownerDocument?.defaultView ?? window, this.#visibleHost, () => this.#getActiveDomTarget(), () => !this.#isViewLocked(), () => this.#editorInputManager?.notifyTargetChanged(), {
			useWindowFallback: true,
			getTargetEditor: () => this.getActiveEditor()
		});
		this.#inputBridge.bind();
	}
	#setupHeaderFooterSession() {
		if (!this.#headerFooterSession) return;
		this.#headerFooterSession.setEditor(this.#editor);
		this.#headerFooterSession.setDependencies({
			getLayoutOptions: () => this.#layoutOptions,
			getPageElement: (pageIndex) => this.#getPageElement(pageIndex),
			scrollPageIntoView: (pageIndex) => this.#scrollPageIntoView(pageIndex),
			waitForPageMount: (pageIndex, options) => this.#waitForPageMount(pageIndex, options),
			convertPageLocalToOverlayCoords: (pageIndex, x, y$1) => this.#convertPageLocalToOverlayCoords(pageIndex, x, y$1),
			isViewLocked: () => this.#isViewLocked(),
			getBodyPageHeight: () => this.#getBodyPageHeight(),
			notifyInputBridgeTargetChanged: () => this.#inputBridge?.notifyTargetChanged(),
			scheduleRerender: () => this.#scheduleRerender(),
			setPendingDocChange: () => {
				this.#pendingDocChange = true;
			},
			getBodyPageCount: () => this.#layoutState?.layout?.pages?.length ?? 1,
			getStorySessionManager: () => this.#ensureStorySessionManager()
		});
		this.#headerFooterSession.setCallbacks({
			onModeChanged: (session) => {
				this.emit("headerFooterModeChanged", {
					mode: session.mode,
					kind: session.kind,
					headerId: session.headerFooterRefId,
					sectionType: session.sectionType,
					pageIndex: session.pageIndex,
					pageNumber: session.pageNumber
				});
				this.#refreshEditorDomAugmentations();
				this.#updateAwarenessSession();
			},
			onEditingContext: (data) => {
				this.emit("headerFooterEditingContext", data);
				if (this.#headerFooterEditor && this.#headerFooterSelectionHandler) {
					this.#headerFooterEditor.off?.("selectionUpdate", this.#headerFooterSelectionHandler);
					this.#headerFooterEditor = null;
					this.#headerFooterSelectionHandler = null;
				}
				if (data.kind === "body") {
					this.#announce("Exited header/footer edit mode.");
					this.#scheduleSelectionUpdate({ immediate: true });
				} else {
					this.#announce(`Editing ${data.kind === "header" ? "Header" : "Footer"} (${data.sectionType ?? "default"})`);
					const headerFooterEditor = data.editor;
					const handler = () => {
						this.#scheduleSelectionUpdate();
						this.#scheduleA11ySelectionAnnouncement();
					};
					headerFooterEditor.on?.("selectionUpdate", handler);
					this.#headerFooterEditor = headerFooterEditor;
					this.#headerFooterSelectionHandler = handler;
					this.#scheduleSelectionUpdate({ immediate: true });
					this.#scheduleA11ySelectionAnnouncement({ immediate: true });
				}
				this.#syncActiveSurfaceUiEventBridge();
				this.#publishActiveSurfaceChange();
			},
			onEditBlocked: (reason) => {
				this.emit("headerFooterEditBlocked", { reason });
			},
			onError: (data) => {
				this.emit("error", data);
			},
			onAnnounce: (message) => {
				this.#announce(message);
			},
			onUpdateAwarenessSession: () => {
				this.#updateAwarenessSession();
			},
			onSurfaceUpdate: ({ sourceEditor, surface, headerId, sectionType }) => {
				this.emit("headerFooterUpdate", {
					editor: this.#editor,
					sourceEditor,
					surface,
					headerId,
					sectionType
				});
			},
			onSurfaceTransaction: ({ sourceEditor, surface, headerId, sectionType, transaction, duration }) => {
				if ((transaction && typeof transaction === "object" ? transaction : null)?.docChanged && headerId) {
					this.#invalidateTrackedChangesForStory({
						kind: "story",
						storyType: "headerFooterPart",
						refId: headerId
					});
					this.#headerFooterSession?.invalidateLayoutForRefs([headerId]);
					this.#flowBlockCache.setHasExternalChanges?.(true);
					this.#pendingDocChange = true;
					this.#selectionSync.onLayoutStart();
					this.#scheduleRerender();
					this.#emitCommentPositions();
				}
				this.emit("headerFooterTransaction", {
					editor: this.#editor,
					sourceEditor,
					surface,
					headerId,
					sectionType,
					transaction,
					duration
				});
			}
		});
		this.#headerFooterSession.initialize();
	}
	#teardownStorySessionEventBridge() {
		if (this.#storySessionEditor) {
			if (this.#storySessionSelectionHandler) this.#storySessionEditor.off?.("selectionUpdate", this.#storySessionSelectionHandler);
			if (this.#storySessionTransactionHandler) this.#storySessionEditor.off?.("transaction", this.#storySessionTransactionHandler);
		}
		this.#storySessionEditor = null;
		this.#storySessionSelectionHandler = null;
		this.#storySessionTransactionHandler = null;
	}
	#teardownActiveSurfaceUiEventBridge() {
		if (this.#activeSurfaceUiEventEditor) {
			if (this.#activeSurfaceUiUpdateHandler) this.#activeSurfaceUiEventEditor.off?.("update", this.#activeSurfaceUiUpdateHandler);
			if (this.#activeSurfaceUiContextMenuOpenHandler) this.#activeSurfaceUiEventEditor.off?.("contextMenu:open", this.#activeSurfaceUiContextMenuOpenHandler);
			if (this.#activeSurfaceUiContextMenuCloseHandler) this.#activeSurfaceUiEventEditor.off?.("contextMenu:close", this.#activeSurfaceUiContextMenuCloseHandler);
		}
		this.#activeSurfaceUiEventEditor = null;
		this.#activeSurfaceUiUpdateHandler = null;
		this.#activeSurfaceUiContextMenuOpenHandler = null;
		this.#activeSurfaceUiContextMenuCloseHandler = null;
	}
	#syncActiveSurfaceUiEventBridge(editor = this.getActiveEditor()) {
		const nextEditor = editor ?? null;
		if (nextEditor === this.#activeSurfaceUiEventEditor) return;
		this.#teardownActiveSurfaceUiEventBridge();
		if (!nextEditor) return;
		const updateHandler = (event) => {
			this.emit("update", {
				...event ?? {},
				editor: this
			});
		};
		const contextMenuOpenHandler = (event) => {
			this.emit("contextMenu:open", event ?? {});
		};
		const contextMenuCloseHandler = () => {
			this.emit("contextMenu:close");
		};
		nextEditor.on?.("update", updateHandler);
		nextEditor.on?.("contextMenu:open", contextMenuOpenHandler);
		nextEditor.on?.("contextMenu:close", contextMenuCloseHandler);
		this.#activeSurfaceUiEventEditor = nextEditor;
		this.#activeSurfaceUiUpdateHandler = updateHandler;
		this.#activeSurfaceUiContextMenuOpenHandler = contextMenuOpenHandler;
		this.#activeSurfaceUiContextMenuCloseHandler = contextMenuCloseHandler;
	}
	#syncStorySessionEventBridge(session) {
		this.#teardownStorySessionEventBridge();
		if (!session) {
			this.#scheduleSelectionUpdate({ immediate: true });
			return;
		}
		const handler = () => {
			this.#scheduleSelectionUpdate();
			this.#scheduleA11ySelectionAnnouncement();
		};
		const transactionHandler = ({ transaction }) => {
			if (!transaction?.docChanged) return;
			this.#syncActiveStorySessionHistoryTransaction(session);
			if (session.kind === "note") {
				this.#invalidateTrackedChangesForStory(session.locator);
				this.#pendingDocChange = true;
				this.#selectionSync.onLayoutStart();
				this.#scheduleRerender();
			}
		};
		session.editor.on?.("selectionUpdate", handler);
		session.editor.on?.("transaction", transactionHandler);
		this.#storySessionEditor = session.editor;
		this.#storySessionSelectionHandler = handler;
		this.#storySessionTransactionHandler = transactionHandler;
		this.#scheduleSelectionUpdate({ immediate: true });
		this.#scheduleA11ySelectionAnnouncement({ immediate: true });
		this.#syncActiveSurfaceUiEventBridge();
	}
	#resolveStorySessionHistoryParticipantKey(session) {
		const locator = session.locator;
		if (locator.kind !== "story") return null;
		if (locator.storyType === "headerFooterPart") return buildHeaderFooterParticipantKey(locator.refId);
		if (locator.storyType === "footnote" || locator.storyType === "endnote") return buildStoryKey(locator);
		return null;
	}
	#syncActiveStorySessionHistoryTransaction(session) {
		const participantKey = this.#resolveStorySessionHistoryParticipantKey(session);
		if (!participantKey) return;
		this.#debugUnifiedHistory("Reconciling active story-session history transaction.", {
			participantKey,
			sessionKind: session.kind
		});
		this.#historyCoordinator?.syncParticipant(participantKey);
	}
	#syncActiveStorySessionDocumentMode(session) {
		if (!session || session.kind !== "note") return;
		if (typeof session.editor.setDocumentMode === "function") {
			session.editor.setDocumentMode(this.#documentMode);
			return;
		}
		session.editor.setEditable?.(this.#documentMode !== "viewing");
		session.editor.setOptions?.({ documentMode: this.#documentMode });
	}
	#syncActiveStorySessionHistoryParticipant(session) {
		const coordinator = this.#historyCoordinator;
		if (!coordinator || !session) return;
		const locator = session.locator;
		if (session.kind !== "headerFooter" || locator.kind !== "story" || locator.storyType !== "headerFooterPart") return;
		const surfaceKind = session.editor.options.headerFooterType === "footer" ? "footer" : "header";
		this.#debugUnifiedHistory("Syncing active header/footer session editor into coordinator.", {
			refId: locator.refId,
			surface: surfaceKind
		});
		coordinator.register(createHeaderFooterParticipant(session.editor, {
			id: locator.refId,
			kind: surfaceKind
		}));
		this.#syncUnifiedHistoryParticipantPins();
	}
	#invalidateTrackedChangesForStory(locator) {
		try {
			getTrackedChangeIndex(this.#editor).invalidate(locator);
		} catch {}
	}
	#ensureStorySessionManager() {
		if (this.#storySessionManager) return this.#storySessionManager;
		this.#storySessionManager = new StoryPresentationSessionManager({
			resolveRuntime: (locator) => resolveStoryRuntime(this.#editor, locator, { intent: "write" }),
			getMountContainer: () => {
				return (this.#visibleHost?.ownerDocument)?.body ?? this.#visibleHost ?? null;
			},
			editorFactory: (input) => this.#createStorySessionEditor(input),
			onActiveSessionChanged: () => {
				const activeSession = this.#storySessionManager?.getActiveSession() ?? null;
				if (activeSession?.hostWrapper) this.#wrapOffscreenEditorFocus(activeSession.editor);
				this.#syncActiveStorySessionHistoryParticipant(activeSession);
				this.#syncActiveStorySessionDocumentMode(activeSession);
				this.#syncStorySessionEventBridge(activeSession);
				this.#syncActiveSurfaceUiEventBridge();
				this.#publishActiveSurfaceChange();
				this.#inputBridge?.notifyTargetChanged();
			}
		});
		return this.#storySessionManager;
	}
	#createStorySessionEditor(input) {
		const { runtime, hostElement, activationOptions } = input;
		const editorContext = activationOptions.editorContext ?? {};
		if (runtime.kind === "headerFooter" && runtime.locator.storyType === "headerFooterPart") {
			const descriptor = this.#headerFooterSession?.manager?.getDescriptorById(runtime.locator.refId) ?? null;
			const persisted = descriptor ? this.#headerFooterSession?.manager?.ensureEditorSync(descriptor, {
				editorHost: hostElement,
				availableWidth: editorContext.availableWidth,
				availableHeight: editorContext.availableHeight,
				currentPageNumber: editorContext.currentPageNumber,
				currentPageNumberText: editorContext.currentPageNumberText,
				currentPageDisplayNumber: editorContext.currentPageDisplayNumber,
				currentPageChapterNumberText: editorContext.currentPageChapterNumberText,
				currentPageChapterSeparator: editorContext.currentPageChapterSeparator,
				totalPageCount: editorContext.totalPageCount,
				sectionPageCount: editorContext.sectionPageCount
			}) ?? null : null;
			if (persisted) return { editor: persisted };
		}
		if (runtime.kind === "note" && this.#noteEditorRegistry) return this.#createNoteSessionEditor(input);
		return this.#createFreshStorySessionEditor(input);
	}
	#createFreshStorySessionEditor(input) {
		const { runtime, hostElement, activationOptions } = input;
		const editorContext = activationOptions.editorContext ?? {};
		const pmJson = runtime.editor.getJSON();
		const headerFooterRefId = runtime.locator.storyType === "headerFooterPart" ? runtime.locator.refId : void 0;
		const fresh = createStoryEditor(this.#editor, pmJson, {
			documentId: runtime.storyKey,
			isHeaderOrFooter: runtime.kind === "headerFooter",
			headless: false,
			element: hostElement,
			currentPageNumber: editorContext.currentPageNumber,
			currentPageNumberText: editorContext.currentPageNumberText,
			currentPageDisplayNumber: editorContext.currentPageDisplayNumber,
			currentPageChapterNumberText: editorContext.currentPageChapterNumberText,
			currentPageChapterSeparator: editorContext.currentPageChapterSeparator,
			totalPageCount: editorContext.totalPageCount,
			sectionPageCount: editorContext.sectionPageCount,
			editorOptions: headerFooterRefId ? { headerFooterRefId } : void 0
		});
		return {
			editor: fresh,
			dispose: () => {
				try {
					fresh.destroy();
				} catch {}
			}
		};
	}
	#createNoteSessionEditor(input) {
		const registry = this.#noteEditorRegistry;
		if (!registry) return this.#createFreshStorySessionEditor(input);
		const { runtime, hostElement } = input;
		const locator = runtime.locator;
		if (locator.storyType !== "footnote" && locator.storyType !== "endnote") return this.#createFreshStorySessionEditor(input);
		const commitHook = runtime.commitEditor ?? null;
		const existing = registry.get(runtime.storyKey);
		if (existing) {
			if (commitHook) registry.setCommitHook(runtime.storyKey, commitHook);
			this.#remountStorySessionEditor(existing, hostElement);
			registry.touch(runtime.storyKey);
			return { editor: existing };
		}
		const fresh = this.#createFreshStorySessionEditor(input);
		registry.register({
			storyKey: runtime.storyKey,
			locator,
			editor: fresh.editor,
			commit: commitHook
		});
		if (fresh.dispose) registry.attachDisposer(runtime.storyKey, fresh.dispose);
		return { editor: fresh.editor };
	}
	#remountStorySessionEditor(editor, hostElement) {
		editor.setOptions({ element: hostElement });
		editor.unmount?.();
		editor.mount?.(hostElement);
	}
	#setupStorySessionManager() {
		this.#ensureStorySessionManager();
	}
	#isUnifiedHistoryEnabled() {
		return this.#options.experimental?.unifiedHistory !== false;
	}
	#isUnifiedHistoryDebugEnabled() {
		if (this.#options.isDebug) return true;
		return globalThis.__SD_DEBUG_UNIFIED_HISTORY__ === true;
	}
	#debugUnifiedHistory(message, detail) {
		if (!this.#isUnifiedHistoryDebugEnabled()) return;
		if (detail && Object.keys(detail).length > 0) {
			console.debug("[PresentationEditor][UnifiedHistory]", message, detail);
			return;
		}
		console.debug("[PresentationEditor][UnifiedHistory]", message);
	}
	#recordNoteHitDebug(entry) {
		const debugGlobal = globalThis;
		if (debugGlobal.__SD_DEBUG_NOTE_HIT__ !== true) return;
		const existingLog = Array.isArray(debugGlobal.__SD_DEBUG_NOTE_HIT_LOG__) ? debugGlobal.__SD_DEBUG_NOTE_HIT_LOG__ : [];
		existingLog.push(entry);
		if (existingLog.length > 100) existingLog.splice(0, existingLog.length - 100);
		debugGlobal.__SD_DEBUG_NOTE_HIT_LOG__ = existingLog;
	}
	#setupUnifiedHistoryCoordinator() {
		if (!this.#isUnifiedHistoryEnabled()) {
			this.#debugUnifiedHistory("Coordinator disabled by configuration.", { documentId: this.#options.documentId ?? null });
			return;
		}
		const coordinator = new DocumentHistoryCoordinator({ onDiagnostic: (message, detail) => this.#debugUnifiedHistory(message, detail) });
		this.#historyCoordinator = coordinator;
		this.#debugUnifiedHistory("Coordinator enabled.", { documentId: this.#options.documentId ?? null });
		const registry = new NoteEditorRegistry({ onBeforeAutoDispose: (storyKey) => coordinator.purge(storyKey, "capacity-eviction") });
		this.#noteEditorRegistry = registry;
		coordinator.register(createBodyParticipant(this.#editor));
		const unbindChange = coordinator.onChange(() => {
			this.#syncUnifiedHistoryParticipantPins();
			this.#debugUnifiedHistory("Coordinator state changed.", {
				state: coordinator.getState(),
				reachableKeys: Array.from(coordinator.getReachableKeys())
			});
			this.emit("historyStateChange", coordinator.getState());
		});
		const unbindPurge = coordinator.onPurge(() => {
			this.#syncUnifiedHistoryParticipantPins();
		});
		const unbindCue = coordinator.onCue((event) => {
			this.#announce(this.#formatUnifiedHistoryCue(event));
			this.emit("unifiedHistoryCue", event);
		});
		this.#historyCoordinatorCleanup.push(unbindChange, unbindPurge, unbindCue);
		this.#bindHeaderFooterParticipants(coordinator);
		this.#bindNoteParticipants(coordinator, registry);
		this.#syncUnifiedHistoryParticipantPins();
		this.#publishActiveSurfaceChange(true);
	}
	#bindNoteParticipants(coordinator, registry) {
		const handleCreated = (payload) => {
			this.#debugUnifiedHistory("Registering note participant.", {
				storyKey: payload.storyKey,
				storyType: payload.locator.storyType
			});
			const participant = createNoteParticipant({
				storyKey: payload.storyKey,
				storyType: payload.locator.storyType,
				editor: payload.editor,
				flushAfterReplay: () => this.#flushNoteAfterReplay(payload.storyKey, payload.editor),
				onInvalidated: () => this.#purgeNoteRegistryEntry(registry, payload.storyKey)
			});
			coordinator.register(participant);
			this.#syncUnifiedHistoryParticipantPins();
		};
		const handleDisposed = (payload) => {
			if (this.#coordinatorDrivenNotePurges.has(payload.storyKey)) return;
			this.#debugUnifiedHistory("Disposing note participant.", { storyKey: payload.storyKey });
			if (coordinator.hasParticipant(payload.storyKey)) coordinator.purge(payload.storyKey, "destroyed");
			this.#syncUnifiedHistoryParticipantPins();
		};
		registry.on("editorCreated", handleCreated);
		registry.on("editorDisposed", handleDisposed);
		this.#historyCoordinatorCleanup.push(() => registry.off("editorCreated", handleCreated), () => registry.off("editorDisposed", handleDisposed));
	}
	#flushNoteAfterReplay(storyKey, noteEditor) {
		const commitHook = this.#noteEditorRegistry?.getCommitHook(storyKey);
		if (commitHook) try {
			commitHook(this.#editor, noteEditor);
		} catch (error) {
			console.warn("[PresentationEditor] Note commit after replay failed:", error);
		}
		this.#pendingDocChange = true;
		this.#scheduleRerender();
	}
	#bindHeaderFooterParticipants(coordinator) {
		const manager = this.#headerFooterSession?.manager;
		if (!manager) return;
		const handleCreated = (payload) => {
			this.#debugUnifiedHistory("Registering header/footer participant.", {
				refId: payload.descriptor.id,
				surface: payload.descriptor.kind
			});
			const participant = createHeaderFooterParticipant(payload.editor, payload.descriptor);
			coordinator.register(participant);
			this.#syncUnifiedHistoryParticipantPins();
		};
		const handleDisposed = (payload) => {
			const key = buildHeaderFooterParticipantKey(payload.descriptor.id);
			this.#debugUnifiedHistory("Disposing header/footer participant.", {
				refId: payload.descriptor.id,
				participantKey: key
			});
			coordinator.purge(key, "destroyed");
			this.#syncUnifiedHistoryParticipantPins();
		};
		manager.on("editorCreated", handleCreated);
		manager.on("editorDisposed", handleDisposed);
		this.#historyCoordinatorCleanup.push(() => manager.off?.("editorCreated", handleCreated), () => manager.off?.("editorDisposed", handleDisposed));
	}
	#purgeNoteRegistryEntry(registry, storyKey) {
		if (this.#coordinatorDrivenNotePurges.has(storyKey)) return;
		this.#coordinatorDrivenNotePurges.add(storyKey);
		try {
			registry.purge(storyKey, "purge");
		} finally {
			this.#coordinatorDrivenNotePurges.delete(storyKey);
		}
	}
	#syncUnifiedHistoryParticipantPins() {
		const coordinator = this.#historyCoordinator;
		if (!coordinator) return;
		const reachableKeys = coordinator.getReachableKeys();
		const headerFooterManager = this.#headerFooterSession?.manager;
		const noteRegistry = this.#noteEditorRegistry;
		if (headerFooterManager && typeof headerFooterManager.getDescriptors === "function") headerFooterManager.getDescriptors().forEach((descriptor) => {
			const participantKey = buildHeaderFooterParticipantKey(descriptor.id);
			if (!coordinator.hasParticipant(participantKey)) return;
			const shouldPin = reachableKeys.has(participantKey);
			coordinator.setPinned(participantKey, shouldPin);
			if (shouldPin) {
				headerFooterManager.pin?.(descriptor.id);
				return;
			}
			headerFooterManager.unpin?.(descriptor.id);
		});
		if (!noteRegistry) return;
		noteRegistry.keys().forEach((storyKey) => {
			if (!coordinator.hasParticipant(storyKey)) return;
			const shouldPin = reachableKeys.has(storyKey);
			coordinator.setPinned(storyKey, shouldPin);
			if (shouldPin) {
				noteRegistry.pin(storyKey);
				return;
			}
			noteRegistry.unpin(storyKey);
		});
	}
	#publishActiveSurfaceChange(force = false) {
		const surface = this.#resolveActiveSurface();
		this.#historyCoordinator?.setActiveSurface(surface);
		if (!force && surface === this.#lastPublishedActiveSurface) return;
		this.#lastPublishedActiveSurface = surface;
		this.#debugUnifiedHistory("Active surface changed.", { surface });
		this.emit("activeSurfaceChange", { surface });
	}
	#formatUnifiedHistoryCue(event) {
		const action = event.action === "undo" ? "Undid" : "Redid";
		switch (event.surface) {
			case "header": return `${action} change in Header.`;
			case "footer": return `${action} change in Footer.`;
			case "note": return `${action} change in Footnote.`;
			case "endnote": return `${action} change in Endnote.`;
			default: return `${action} change in Document.`;
		}
	}
	#purgeHeaderFooterParticipantsOnExternalInvalidation(refIds) {
		const coordinator = this.#historyCoordinator;
		if (!coordinator) return;
		refIds.forEach((refId) => {
			coordinator.purge(buildHeaderFooterParticipantKey(refId), "external-invalidation");
		});
	}
	#purgeAllNoteParticipantsOnExternalInvalidation() {
		const coordinator = this.#historyCoordinator;
		const registry = this.#noteEditorRegistry;
		if (!coordinator || !registry) return;
		registry.keys().forEach((storyKey) => {
			coordinator.purge(storyKey, "external-invalidation");
		});
	}
	#teardownUnifiedHistoryCoordinator() {
		this.#historyCoordinatorCleanup.forEach((cleanup) => {
			try {
				cleanup();
			} catch (error) {
				console.warn("[PresentationEditor] Unified history cleanup failed:", error);
			}
		});
		this.#historyCoordinatorCleanup.length = 0;
		this.#historyCoordinator?.destroy();
		this.#historyCoordinator = null;
		this.#noteEditorRegistry?.destroy();
		this.#noteEditorRegistry = null;
		this.#coordinatorDrivenNotePurges.clear();
		this.#lastPublishedActiveSurface = null;
	}
	#hitTestTable(normalizedX, normalizedY) {
		const configuredPageHeight = (this.#layoutOptions.pageSize ?? DEFAULT_PAGE_SIZE).h;
		return hitTestTable(this.#layoutState.layout, this.#layoutState.blocks, this.#layoutState.measures, normalizedX, normalizedY, configuredPageHeight, this.#getEffectivePageGap(), this.#pageGeometryHelper);
	}
	#selectWordAt(pos) {
		const activeEditor = this.getActiveEditor();
		const state = activeEditor.state;
		if (!state?.doc) return false;
		const range = computeWordSelectionRangeAt(state, pos);
		if (!range) return false;
		const tr = state.tr.setSelection(TextSelection.create(state.doc, range.from, range.to));
		try {
			activeEditor.view?.dispatch(tr);
			return true;
		} catch (error) {
			if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] Failed to select word:", error);
			return false;
		}
	}
	#selectParagraphAt(pos) {
		const activeEditor = this.getActiveEditor();
		const state = activeEditor.state;
		if (!state?.doc) return false;
		const range = computeParagraphSelectionRangeAt(state, pos);
		if (!range) return false;
		const tr = state.tr.setSelection(TextSelection.create(state.doc, range.from, range.to));
		try {
			activeEditor.view?.dispatch(tr);
			return true;
		} catch (error) {
			if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] Failed to select paragraph:", error);
			return false;
		}
	}
	#calculateExtendedSelection(anchor, head, mode) {
		return calculateExtendedSelection(this.#layoutState.blocks, anchor, head, mode);
	}
	#refreshHeaderFooterStructureThenRerender(options) {
		this.#headerFooterSession?.refreshStructure(options);
		this.#flowBlockCache.setHasExternalChanges?.(true);
		this.#pendingDocChange = true;
		this.#selectionSync.onLayoutStart();
		this.#scheduleRerender();
	}
	#scheduleRerender() {
		if (this.#renderScheduled) return;
		this.#renderScheduled = true;
		this.#rafHandle = (this.#visibleHost.ownerDocument?.defaultView ?? window).requestAnimationFrame(() => {
			this.#renderScheduled = false;
			this.#flushRerenderQueue().catch((error) => {
				this.#handleLayoutError("render", error instanceof Error ? error : new Error(String(error)));
			});
		});
	}
	async #flushRerenderQueue() {
		if (this.#isRerendering) {
			this.#pendingDocChange = true;
			return;
		}
		if (!this.#pendingDocChange) return;
		this.#pendingDocChange = false;
		this.#isRerendering = true;
		const activeHfEditor = (this.#headerFooterSession?.session?.mode ?? "body") !== "body" ? this.#headerFooterSession?.activeEditor : null;
		const hadHfFocus = activeHfEditor?.view?.hasFocus?.() ?? false;
		try {
			await this.#rerender();
		} finally {
			this.#isRerendering = false;
			if (this.#pendingDocChange) this.#scheduleRerender();
			if (hadHfFocus && activeHfEditor?.view && this.#headerFooterSession?.activeEditor === activeHfEditor) {
				const doc$1 = this.#visibleHost.ownerDocument;
				const editorDom = activeHfEditor.view.dom;
				if (doc$1 && !editorDom.contains(doc$1.activeElement)) try {
					activeHfEditor.view.focus();
				} catch {}
			}
		}
	}
	async #rerender() {
		this.#selectionSync.onLayoutStart();
		let layoutCompleted = false;
		try {
			let docJson;
			const perf = (this.#visibleHost.ownerDocument?.defaultView ?? window)?.performance ?? GLOBAL_PERFORMANCE;
			const perfNow = () => perf?.now ? perf.now() : Date.now();
			const startMark = perf?.now?.();
			try {
				const getJsonStart = perfNow();
				docJson = this.#editor.getJSON();
				perfLog(`[Perf] getJSON: ${(perfNow() - getJsonStart).toFixed(2)}ms`);
			} catch (error) {
				this.#handleLayoutError("render", this.#decorateError(error, "getJSON"));
				return;
			}
			const layoutEpoch = this.#epochMapper.getCurrentEpoch();
			const sectionMetadata = [];
			let blocks;
			let bookmarks = /* @__PURE__ */ new Map();
			let converterContext = void 0;
			try {
				const converter$1 = this.#editor.converter;
				let defaultTableStyleId;
				let footnoteNumberFormat;
				let endnoteNumberFormat;
				let footnoteNumberStart = 1;
				let endnoteNumberStart = 1;
				let footnoteNumberRestart;
				let endnoteNumberRestart;
				let footnotePosition;
				let endnotePosition;
				let footnoteSectionConfigs = /* @__PURE__ */ new Map();
				let endnoteSectionConfigs = /* @__PURE__ */ new Map();
				if (converter$1) {
					const settingsRoot = readSettingsRoot(converter$1);
					if (settingsRoot) {
						defaultTableStyleId = readDefaultTableStyle(settingsRoot) ?? void 0;
						footnoteNumberFormat = readFootnoteNumberFormat(settingsRoot) ?? void 0;
						endnoteNumberFormat = readEndnoteNumberFormat(settingsRoot) ?? void 0;
						footnoteNumberStart = readFootnoteNumberStart(settingsRoot) ?? 1;
						endnoteNumberStart = readEndnoteNumberStart(settingsRoot) ?? 1;
						footnoteNumberRestart = readFootnoteNumberRestart(settingsRoot) ?? void 0;
						endnoteNumberRestart = readEndnoteNumberRestart(settingsRoot) ?? void 0;
						footnotePosition = readFootnotePosition(settingsRoot) ?? void 0;
						endnotePosition = readEndnotePosition(settingsRoot) ?? void 0;
					}
					const documentPart = converter$1.convertedXml?.["word/document.xml"];
					if (documentPart) {
						footnoteSectionConfigs = readSectionNoteConfigs(documentPart, "w:footnotePr");
						endnoteSectionConfigs = readSectionNoteConfigs(documentPart, "w:endnotePr");
					}
				}
				if (footnoteNumberRestart === "eachPage") {
					this.#warnUnsupportedNumberingRestart("footnote");
					footnoteNumberRestart = "continuous";
				}
				if (endnoteNumberRestart === "eachPage") {
					this.#warnUnsupportedNumberingRestart("endnote");
					endnoteNumberRestart = "continuous";
				}
				for (const [secIndex, cfg] of footnoteSectionConfigs) if (cfg.numRestart === "eachPage") {
					footnoteSectionConfigs.set(secIndex, {
						...cfg,
						numRestart: "continuous"
					});
					this.#warnUnsupportedNumberingRestart("footnote");
				}
				for (const [secIndex, cfg] of endnoteSectionConfigs) if (cfg.numRestart === "eachPage") {
					endnoteSectionConfigs.set(secIndex, {
						...cfg,
						numRestart: "continuous"
					});
					this.#warnUnsupportedNumberingRestart("endnote");
				}
				const footnoteNumbering = computeNoteNumbering(this.#editor?.state, "footnoteReference", {
					startCounter: footnoteNumberStart,
					defaultNumFmt: footnoteNumberFormat,
					defaultRestart: footnoteNumberRestart,
					sectionConfigs: footnoteSectionConfigs
				});
				const footnoteNumberById = footnoteNumbering.numberById;
				const footnoteFormatById = footnoteNumbering.formatById;
				const footnoteOrder = footnoteNumbering.order;
				const footnoteSignature = `${footnoteNumberStart}|${footnoteNumberFormat ?? ""}|${footnoteNumberRestart ?? ""}|${serializeSectionConfigs(footnoteSectionConfigs)}|${serializePerIdNumbering(footnoteOrder, footnoteNumberById, footnoteFormatById)}`;
				if (footnoteSignature !== this.#footnoteNumberSignature) {
					this.#flowBlockCache.clear();
					this.#footnoteNumberSignature = footnoteSignature;
				}
				const endnoteNumbering = computeNoteNumbering(this.#editor?.state, "endnoteReference", {
					startCounter: endnoteNumberStart,
					defaultNumFmt: endnoteNumberFormat,
					defaultRestart: endnoteNumberRestart,
					sectionConfigs: endnoteSectionConfigs
				});
				const endnoteNumberById = endnoteNumbering.numberById;
				const endnoteFormatById = endnoteNumbering.formatById;
				const endnoteOrder = endnoteNumbering.order;
				const endnoteSignature = `${endnoteNumberStart}|${endnoteNumberFormat ?? ""}|${endnoteNumberRestart ?? ""}|${serializeSectionConfigs(endnoteSectionConfigs)}|${serializePerIdNumbering(endnoteOrder, endnoteNumberById, endnoteFormatById)}`;
				if (endnoteSignature !== this.#endnoteNumberSignature) {
					this.#flowBlockCache.clear();
					this.#endnoteNumberSignature = endnoteSignature;
				}
				try {
					if (converter$1 && typeof converter$1 === "object") {
						converter$1["footnoteNumberById"] = footnoteNumberById;
						converter$1["endnoteNumberById"] = endnoteNumberById;
					}
				} catch {}
				converterContext = converter$1 ? {
					docx: converter$1.convertedXml,
					...Object.keys(footnoteNumberById).length ? { footnoteNumberById } : {},
					...Object.keys(endnoteNumberById).length ? { endnoteNumberById } : {},
					...footnoteNumberFormat ? { footnoteNumberFormat } : {},
					...endnoteNumberFormat ? { endnoteNumberFormat } : {},
					...footnoteFormatById && Object.keys(footnoteFormatById).length ? { footnoteFormatById } : {},
					...endnoteFormatById && Object.keys(endnoteFormatById).length ? { endnoteFormatById } : {},
					...footnotePosition ? { footnotePosition } : {},
					...endnotePosition ? { endnotePosition } : {},
					translatedLinkedStyles: converter$1.translatedLinkedStyles,
					translatedNumbering: converter$1.translatedNumbering,
					...defaultTableStyleId ? { defaultTableStyleId } : {}
				} : void 0;
				const atomNodeTypes = getAtomNodeTypes(this.#editor?.schema ?? null);
				const positionMapStart = perfNow();
				const positionMap = this.#editor?.state?.doc && docJson ? buildPositionMapFromPmDoc(this.#editor.state.doc, docJson) : null;
				perfLog(`[Perf] buildPositionMapFromPmDoc: ${(perfNow() - positionMapStart).toFixed(2)}ms`);
				const commentsEnabled = this.#documentMode !== "viewing" || this.#layoutOptions.enableCommentsInViewing === true;
				const toFlowBlocksStart = perfNow();
				const result = toFlowBlocks(docJson, {
					mediaFiles: (this.#editor?.storage?.image)?.media,
					emitSectionBreaks: true,
					sectionMetadata,
					trackedChangesMode: this.#trackedChangesMode,
					enableTrackedChanges: this.#trackedChangesEnabled,
					resolveTrackedChangeColor: this.#layoutOptions.resolveTrackedChangeColor,
					enableComments: commentsEnabled,
					enableRichHyperlinks: true,
					themeColors: this.#editor?.converter?.themeColors ?? void 0,
					converterContext,
					flowBlockCache: this.#flowBlockCache,
					showBookmarks: this.#layoutOptions.showBookmarks ?? false,
					...positionMap ? { positions: positionMap } : {},
					...atomNodeTypes.length > 0 ? { atomNodeTypes } : {}
				});
				perfLog(`[Perf] toFlowBlocks: ${(perfNow() - toFlowBlocksStart).toFixed(2)}ms (blocks=${result.blocks.length})`);
				blocks = result.blocks;
				bookmarks = result.bookmarks ?? /* @__PURE__ */ new Map();
			} catch (error) {
				this.#handleLayoutError("render", this.#decorateError(error, "toFlowBlocks"));
				return;
			}
			if (!blocks) {
				this.#handleLayoutError("render", /* @__PURE__ */ new Error("toFlowBlocks returned undefined blocks"));
				return;
			}
			const state = this.#editor?.view?.state;
			const decorationRanges = state ? this.#postPaintPipeline.collectDecorationRanges(state) : [];
			if (decorationRanges.length > 0) blocks = splitRunsAtDecorationBoundaries(blocks, decorationRanges.map((r$1) => ({
				from: r$1.from,
				to: r$1.to
			})));
			this.#applyHtmlAnnotationMeasurements(blocks);
			const isSemanticFlow = this.#isSemanticFlowMode();
			const baseLayoutOptions = this.#resolveLayoutOptions(blocks, sectionMetadata);
			const activeFootnoteOverride = this.#buildActiveNoteRenderOverride("footnote");
			const footnotesLayoutInput = buildFootnotesInput(this.#editor?.state, this.#editor?.converter, converterContext, this.#editor?.converter?.themeColors ?? void 0, activeFootnoteOverride, this.#layoutOptions.resolveTrackedChangeColor);
			const semanticFootnoteBlocks = isSemanticFlow ? buildSemanticFootnoteBlocks(footnotesLayoutInput, this.#layoutOptions.semanticOptions?.footnotesMode) : [];
			const activeEndnoteOverride = this.#buildActiveNoteRenderOverride("endnote");
			const endnoteBlocks = buildEndnoteBlocks(this.#editor?.state, this.#editor?.converter, converterContext, this.#editor?.converter?.themeColors ?? void 0, activeEndnoteOverride, this.#layoutOptions.resolveTrackedChangeColor);
			const blocksForLayout = semanticFootnoteBlocks.length > 0 || endnoteBlocks.length > 0 ? [
				...blocks,
				...semanticFootnoteBlocks,
				...endnoteBlocks
			] : blocks;
			const layoutOptions = !isSemanticFlow && footnotesLayoutInput ? {
				...baseLayoutOptions,
				footnotes: footnotesLayoutInput
			} : baseLayoutOptions;
			const previousBlocks = this.#layoutState.blocks;
			const previousLayout = this.#layoutState.layout;
			const previousMeasures = this.#layoutState.measures;
			const resolvePhysical = (css, face) => this.#fontResolver.resolvePhysicalFamilyForFace(css, face, this.#hasFace);
			let fontSignature = "";
			const previousFontSignature = this.#layoutFontSignature;
			let fontMeasureContext = {
				resolvePhysical,
				fontSignature
			};
			let layout;
			let measures;
			let resolvedLayout;
			let bodyBlocksForPaint = blocksForLayout;
			let bodyMeasuresForPaint = [];
			let headerLayouts;
			let footerLayouts;
			let extraBlocks;
			let extraMeasures;
			let resolveBlocks = blocksForLayout;
			let resolveMeasures = previousMeasures;
			const headerFooterInput = this.#buildHeaderFooterInput();
			try {
				this.#fontPlanBlocks = [
					...blocksForLayout,
					...headerFooterInput ? this.#collectHeaderFooterFaceBlocks(headerFooterInput) : [],
					...!isSemanticFlow && footnotesLayoutInput?.blocksById ? [...footnotesLayoutInput.blocksById.values()].flat() : []
				];
				this.#fontPlan = planFontFaces(this.#fontPlanBlocks, this.#fontResolver, this.#hasFace);
				fontSignature = this.#fontPlan.effectiveSignature;
				fontMeasureContext = {
					resolvePhysical,
					fontSignature
				};
				const fontSummary = await this.#fontGate?.ensureReadyForMeasure() ?? null;
				this.#emitFontsChangedIfChanged(fontSummary);
			} catch {}
			try {
				const incrementalLayoutStart = perfNow();
				const result = await incrementalLayout(previousBlocks, previousLayout, blocksForLayout, layoutOptions, (block, constraints) => measureBlock(block, constraints, fontMeasureContext), headerFooterInput ?? void 0, previousMeasures, {
					fontContext: fontMeasureContext,
					previousFontSignature
				});
				perfLog(`[Perf] incrementalLayout: ${(perfNow() - incrementalLayoutStart).toFixed(2)}ms`);
				if (!result || typeof result !== "object") {
					this.#handleLayoutError("render", /* @__PURE__ */ new Error("incrementalLayout returned invalid result"));
					return;
				}
				if (!result.layout || typeof result.layout !== "object") {
					this.#handleLayoutError("render", /* @__PURE__ */ new Error("incrementalLayout returned invalid layout"));
					return;
				}
				if (!Array.isArray(result.measures)) {
					this.#handleLayoutError("render", /* @__PURE__ */ new Error("incrementalLayout returned invalid measures"));
					return;
				}
				({layout, measures} = result);
				extraBlocks = Array.isArray(result.extraBlocks) ? result.extraBlocks : void 0;
				extraMeasures = Array.isArray(result.extraMeasures) ? result.extraMeasures : void 0;
				layout.pageGap = this.#getEffectivePageGap();
				layout.layoutEpoch = layoutEpoch;
				bodyBlocksForPaint = extraBlocks ? [...blocksForLayout, ...extraBlocks] : blocksForLayout;
				bodyMeasuresForPaint = extraMeasures ? [...measures, ...extraMeasures] : measures;
				resolveBlocks = bodyBlocksForPaint;
				resolveMeasures = bodyMeasuresForPaint;
				resolvedLayout = resolveLayout({
					layout,
					flowMode: this.#layoutOptions.flowMode ?? "paginated",
					blocks: bodyBlocksForPaint,
					measures: bodyMeasuresForPaint,
					fontSignature,
					bookmarks
				});
				headerLayouts = result.headers;
				footerLayouts = result.footers;
			} catch (error) {
				this.#handleLayoutError("render", this.#decorateError(error, "incrementalLayout"));
				return;
			}
			this.#sectionMetadata = sectionMetadata;
			const converter = this.#editor.converter;
			const multiSectionId = buildMultiSectionIdentifier(sectionMetadata, { alternateHeaders: this.#resolveAlternateHeadersFlag() }, {
				headerIds: converter?.headerIds,
				footerIds: converter?.footerIds
			});
			if (this.#headerFooterSession) this.#headerFooterSession.multiSectionIdentifier = multiSectionId;
			const anchorMap = computeAnchorMap(bookmarks, layout, blocksForLayout);
			this.#layoutState = {
				blocks: blocksForLayout,
				measures,
				layout,
				bookmarks,
				anchorMap
			};
			this.#layoutFontSignature = fontSignature;
			this.#layoutLookupBlocks = resolveBlocks;
			this.#layoutLookupMeasures = resolveMeasures;
			const tocStorage = this.#editor.storage?.tableOfContents;
			if (tocStorage) {
				const pageMap = /* @__PURE__ */ new Map();
				for (const page of layout.pages) for (const fragment of page.fragments) if (!pageMap.has(fragment.blockId)) pageMap.set(fragment.blockId, page.number);
				tocStorage.pageMap = pageMap;
				tocStorage.pageMapDoc = this.#editor.state.doc;
			}
			if (this.#headerFooterSession) {
				this.#headerFooterSession.headerLayoutResults = headerLayouts ?? null;
				this.#headerFooterSession.footerLayoutResults = footerLayouts ?? null;
			}
			if (this.#layoutState.layout) {
				const pageGap = this.#layoutState.layout.pageGap ?? this.#getEffectivePageGap();
				if (!this.#pageGeometryHelper) this.#pageGeometryHelper = new PageGeometryHelper({
					layout: this.#layoutState.layout,
					pageGap
				});
				else this.#pageGeometryHelper.updateLayout(this.#layoutState.layout, pageGap);
			}
			if (!isSemanticFlow) {
				await this.#layoutPerRIdHeaderFooters(headerFooterInput, layout, sectionMetadata);
				this.#updateDecorationProviders(resolvedLayout);
			}
			this.#ensurePainter();
			if (!isSemanticFlow) this.#painterAdapter.setProviders(this.#headerFooterSession?.headerDecorationProvider, this.#headerFooterSession?.footerDecorationProvider);
			this.#domIndexObserverManager?.pause();
			const mapping = this.#pendingMapping;
			this.#pendingMapping = null;
			const painterPaintStart = perfNow();
			const paintInput = { resolvedLayout };
			this.#painterAdapter.paint(paintInput, this.#painterHost, mapping ?? void 0);
			perfLog(`[Perf] painter.paint: ${(perfNow() - painterPaintStart).toFixed(2)}ms`);
			const painterPostStart = perfNow();
			this.#refreshEditorDomAugmentations();
			this.#domIndexObserverManager?.resume();
			perfLog(`[Perf] painter.postPaint: ${(perfNow() - painterPostStart).toFixed(2)}ms`);
			this.#layoutEpoch = layoutEpoch;
			if (this.#updateHtmlAnnotationMeasurements(layoutEpoch)) {
				this.#pendingDocChange = true;
				this.#scheduleRerender();
			}
			this.#epochMapper.onLayoutComplete(layoutEpoch);
			this.#selectionSync.onLayoutComplete(layoutEpoch);
			layoutCompleted = true;
			this.#revalidateScrollContainer();
			this.#updatePermissionOverlay();
			this.#layoutError = null;
			this.#layoutErrorState = "healthy";
			this.#dismissErrorBanner();
			this.#applyZoom();
			const metrics = createLayoutMetrics(perf, startMark, layout, blocksForLayout);
			const payload = {
				layout,
				blocks: blocksForLayout,
				measures,
				metrics
			};
			this.emit("layoutUpdated", payload);
			this.emit("paginationUpdate", payload);
			this.#emitCommentPositions();
			this.#selectionSync.requestRender({ immediate: true });
			if (this.#remoteCursorManager?.hasRemoteCursors()) {
				this.#remoteCursorManager.markDirty();
				this.#remoteCursorManager.scheduleUpdate();
			}
		} finally {
			if (!layoutCompleted) this.#selectionSync.onLayoutAbort();
		}
	}
	#ensurePainter() {
		if (this.#painterAdapter.hasPainter) return;
		const virtualization = this.#layoutOptions.virtualization;
		const effectiveGap = this.#getEffectivePageGap();
		const normalizedVirtualization = virtualization?.enabled ? {
			...virtualization,
			gap: virtualization.gap ?? effectiveGap
		} : virtualization;
		this.#painterAdapter.ensurePainter({
			layoutMode: this.#layoutOptions.layoutMode ?? "vertical",
			flowMode: this.#layoutOptions.flowMode ?? "paginated",
			virtualization: normalizedVirtualization,
			pageStyles: this.#layoutOptions.pageStyles,
			headerProvider: this.#headerFooterSession?.headerDecorationProvider,
			footerProvider: this.#headerFooterSession?.footerDecorationProvider,
			ruler: this.#layoutOptions.ruler,
			pageGap: this.#layoutState.layout?.pageGap ?? effectiveGap,
			showFormattingMarks: this.#layoutOptions.showFormattingMarks ?? false,
			contentControlsChrome: this.#layoutOptions.contentControlsChrome ?? "default",
			resolvePhysical: (css, face) => this.#fontResolver.resolvePhysicalFamilyForFace(css, face, this.#hasFace)
		});
		const currentZoom = this.#layoutOptions.zoom ?? 1;
		if (currentZoom !== 1) this.#painterAdapter.setZoom(currentZoom);
		if (this.#scrollContainer && this.#scrollContainer instanceof HTMLElement) this.#painterAdapter.setScrollContainer(this.#scrollContainer);
	}
	#applyHtmlAnnotationMeasurements(blocks) {
		if (this.#htmlAnnotationHeights.size === 0) return;
		blocks.forEach((block) => {
			if (block.kind !== "paragraph") return;
			block.runs.forEach((run) => {
				if (run.kind !== "fieldAnnotation" || run.variant !== "html") return;
				if (run.pmStart == null || run.pmEnd == null) return;
				const key = `${run.pmStart}-${run.pmEnd}`;
				const height = this.#htmlAnnotationHeights.get(key);
				if (!height || height <= 0) return;
				const currentSize = run.size ?? {};
				if (currentSize.height === height) return;
				run.size = {
					...currentSize,
					height
				};
			});
		});
	}
	#updateHtmlAnnotationMeasurements(layoutEpoch) {
		const nextHeights = new Map(this.#htmlAnnotationHeights);
		const threshold = 1;
		let changed = false;
		this.#painterAdapter.getAnnotationEntitiesByType("html").forEach((annotation) => {
			const element = annotation.element;
			if (annotation.pmStart == null || annotation.pmEnd == null) return;
			const height = element.offsetHeight;
			if (height <= 0) return;
			const key = `${annotation.pmStart}-${annotation.pmEnd}`;
			const prev = nextHeights.get(key);
			if (prev != null && Math.abs(prev - height) <= threshold) return;
			nextHeights.set(key, height);
			changed = true;
		});
		if (layoutEpoch !== this.#htmlAnnotationMeasureEpoch) {
			this.#htmlAnnotationMeasureEpoch = layoutEpoch;
			this.#htmlAnnotationMeasureAttempts = 0;
		}
		this.#htmlAnnotationHeights = nextHeights;
		if (!changed) return false;
		if (this.#htmlAnnotationMeasureAttempts >= 2) return false;
		this.#htmlAnnotationMeasureAttempts += 1;
		return true;
	}
	#scheduleSelectionUpdate(options) {
		this.#selectionSync.requestRender(options);
	}
	#clearSelectedFieldAnnotationClass() {
		if (this.#lastSelectedFieldAnnotation?.element?.classList?.contains("ProseMirror-selectednode")) this.#lastSelectedFieldAnnotation.element.classList.remove("ProseMirror-selectednode");
		this.#lastSelectedFieldAnnotation = null;
	}
	#setSelectedFieldAnnotationClass(element, pmStart) {
		if (this.#lastSelectedFieldAnnotation?.element && this.#lastSelectedFieldAnnotation.element !== element) this.#lastSelectedFieldAnnotation.element.classList.remove("ProseMirror-selectednode");
		element.classList.add("ProseMirror-selectednode");
		this.#lastSelectedFieldAnnotation = {
			element,
			pmStart
		};
	}
	#syncSelectedFieldAnnotationClass(selection) {
		if (!selection || !(selection instanceof NodeSelection)) {
			this.#clearSelectedFieldAnnotationClass();
			return;
		}
		const node = selection.node;
		if (!node || node.type?.name !== "fieldAnnotation") {
			this.#clearSelectedFieldAnnotationClass();
			return;
		}
		if (!this.#painterHost) {
			this.#clearSelectedFieldAnnotationClass();
			return;
		}
		const pmStart = selection.from;
		if (this.#lastSelectedFieldAnnotation?.pmStart === pmStart && this.#lastSelectedFieldAnnotation.element) return;
		const element = this.#painterAdapter.getAnnotationElementByPmStart(pmStart);
		if (!element) {
			this.#clearSelectedFieldAnnotationClass();
			return;
		}
		this.#setSelectedFieldAnnotationClass(element, pmStart);
	}
	#clearSelectedStructuredContentBlockClass() {
		if (!this.#lastSelectedStructuredContentBlock) return;
		this.#lastSelectedStructuredContentBlock.elements.forEach((element) => {
			element.classList.remove("ProseMirror-selectednode");
		});
		this.#lastSelectedStructuredContentBlock = null;
	}
	#setSelectedStructuredContentBlockClass(elements, id) {
		if (this.#lastSelectedStructuredContentBlock && this.#lastSelectedStructuredContentBlock.id === id && this.#lastSelectedStructuredContentBlock.elements.length === elements.length && this.#lastSelectedStructuredContentBlock.elements.every((el) => elements.includes(el))) return;
		this.#clearSelectedStructuredContentBlockClass();
		elements.forEach((element) => element.classList.add("ProseMirror-selectednode"));
		this.#lastSelectedStructuredContentBlock = {
			id,
			elements
		};
	}
	#syncSelectedStructuredContentBlockClass(selection) {
		if (!selection) {
			this.#clearSelectedStructuredContentBlockClass();
			return;
		}
		let node = null;
		let pos = null;
		let id = null;
		let fallbackPos = null;
		if (selection instanceof NodeSelection) if (selection.node?.type?.name === "structuredContentBlock") {
			node = selection.node;
			pos = selection.from;
		} else {
			fallbackPos = selection.from;
			const editorDoc = this.#editor?.view?.state?.doc;
			const resolved = editorDoc ? findStructuredContentBlockAtPos(editorDoc, selection.from) : null;
			if (!resolved) {
				this.#clearSelectedStructuredContentBlockClass();
				return;
			}
			node = resolved.node;
			pos = resolved.pos;
		}
		else {
			const editorDoc = this.#editor?.view?.state?.doc;
			if (!editorDoc) {
				this.#clearSelectedStructuredContentBlockClass();
				return;
			}
			const resolved = findStructuredContentBlockAtPos(editorDoc, selection.from);
			if (!resolved) {
				this.#clearSelectedStructuredContentBlockClass();
				return;
			}
			node = resolved.node;
			pos = resolved.pos;
		}
		if (pos == null) {
			this.#clearSelectedStructuredContentBlockClass();
			return;
		}
		if (!this.#painterHost) {
			this.#clearSelectedStructuredContentBlockClass();
			return;
		}
		const rawId = node.attrs?.id;
		id = rawId != null ? String(rawId) : null;
		let elements = [];
		if (id) elements = this.#painterAdapter.getStructuredContentBlockElementsById(id);
		if (elements.length === 0) {
			const container = this.getElementAtPos(pos, { fallbackToCoords: true })?.closest?.(`.${DOM_CLASS_NAMES.BLOCK_SDT}`);
			if (container) elements = [container];
		}
		if (elements.length === 0 && fallbackPos != null && fallbackPos !== pos) {
			const container = this.getElementAtPos(fallbackPos, { fallbackToCoords: true })?.closest?.(`.${DOM_CLASS_NAMES.BLOCK_SDT}`);
			if (container) elements = [container];
		}
		if (elements.length === 0) {
			this.#clearSelectedStructuredContentBlockClass();
			return;
		}
		this.#setSelectedStructuredContentBlockClass(elements, id);
	}
	#initializeHoverCoordinators() {
		if (this.#sdtHoverCoordinator || this.#tocHoverCoordinator) return;
		this.#sdtHoverCoordinator = new HoverGroupCoordinator({
			entrySelector: `.${DOM_CLASS_NAMES.BLOCK_SDT}`,
			getId: (entry) => entry.dataset.sdtId,
			queryGroup: (id) => this.#painterAdapter.getStructuredContentBlockElementsById(id),
			hoverClass: DOM_CLASS_NAMES.SDT_GROUP_HOVER,
			shouldApplyTo: (element) => !element.classList.contains("ProseMirror-selectednode")
		});
		this.#tocHoverCoordinator = new HoverGroupCoordinator({
			entrySelector: `.${DOM_CLASS_NAMES.TOC_ENTRY}`,
			getId: (entry) => entry.dataset.tocId,
			queryGroup: (id) => this.#queryTocEntryElementsById(id),
			hoverClass: DOM_CLASS_NAMES.TOC_GROUP_HOVER,
			onApply: (elements) => this.#applyTocGapFill(elements),
			onClear: (element) => element.style.removeProperty("--toc-gap-below")
		});
	}
	#applyTocGapFill(elements) {
		if (elements.length < 2) return;
		const measured = elements.map((element) => ({
			element,
			rect: element.getBoundingClientRect()
		})).sort((a, b$1) => a.rect.top - b$1.rect.top);
		for (let i = 0; i < measured.length - 1; i++) {
			const current = measured[i];
			const next = measured[i + 1];
			const currentPage = current.element.closest("[data-page-index]");
			if (!currentPage || currentPage !== next.element.closest("[data-page-index]")) continue;
			const rawGap = next.rect.top - current.rect.bottom;
			const scaleY = current.rect.height && current.element.offsetHeight ? current.rect.height / current.element.offsetHeight : 1;
			const gap = scaleY > 0 ? rawGap / scaleY : rawGap;
			if (gap > 0) current.element.style.setProperty("--toc-gap-below", `${gap + 1}px`);
		}
	}
	#queryTocEntryElementsById(id) {
		if (!this.#painterHost) return [];
		const escapedId = escapeAttrValue(id);
		return Array.from(this.#painterHost.querySelectorAll(`.${DOM_CLASS_NAMES.TOC_ENTRY}[data-toc-id="${escapedId}"]`));
	}
	#refreshEditorDomAugmentations() {
		this.#postPaintPipeline.refreshAfterPaint({
			layoutEpoch: this.#layoutEpoch,
			activeHeaderFooterMode: this.#headerFooterSession?.session?.mode ?? "body",
			editorState: this.#editor?.view?.state,
			domPositionIndex: this.#domPositionIndex,
			proofingAnnotations: this.#buildProofingAnnotations(),
			rebuildDomPositionIndex: () => this.#rebuildDomPositionIndex(),
			reapplyStructuredContentHover: () => this.#sdtHoverCoordinator?.reapply(),
			reapplyTocGroupHover: () => this.#tocHoverCoordinator?.reapply()
		});
	}
	#clearSelectedStructuredContentInlineClass() {
		if (!this.#lastSelectedStructuredContentInline) return;
		this.#lastSelectedStructuredContentInline.elements.forEach((element) => {
			element.classList.remove("ProseMirror-selectednode");
		});
		this.#lastSelectedStructuredContentInline = null;
	}
	#setSelectedStructuredContentInlineClass(elements, id) {
		if (this.#lastSelectedStructuredContentInline && this.#lastSelectedStructuredContentInline.id === id && this.#lastSelectedStructuredContentInline.elements.length === elements.length && this.#lastSelectedStructuredContentInline.elements.every((el) => elements.includes(el))) return;
		this.#clearSelectedStructuredContentInlineClass();
		elements.forEach((element) => element.classList.add("ProseMirror-selectednode"));
		this.#lastSelectedStructuredContentInline = {
			id,
			elements
		};
	}
	#syncSelectedStructuredContentInlineClass(selection) {
		if (!selection) {
			this.#clearSelectedStructuredContentInlineClass();
			return;
		}
		let node = null;
		let id = null;
		let pos = null;
		if (selection instanceof NodeSelection) {
			if (selection.node?.type?.name !== "structuredContent") {
				this.#clearSelectedStructuredContentInlineClass();
				return;
			}
			node = selection.node;
			pos = selection.from;
		} else {
			const editorDoc = this.#editor?.view?.state?.doc;
			if (!editorDoc) {
				this.#clearSelectedStructuredContentInlineClass();
				return;
			}
			const resolved = findStructuredContentInlineAtPos(editorDoc, selection.from);
			if (!resolved) {
				this.#clearSelectedStructuredContentInlineClass();
				return;
			}
			node = resolved.node;
			pos = resolved.pos;
		}
		if (!this.#painterHost) {
			this.#clearSelectedStructuredContentInlineClass();
			return;
		}
		const rawId = node.attrs?.id;
		id = rawId != null ? String(rawId) : null;
		let elements = [];
		if (id) elements = this.#painterAdapter.getStructuredContentInlineElementsById(id);
		if (elements.length === 0) {
			const container = this.getElementAtPos(pos, { fallbackToCoords: true })?.closest?.(`.${DOM_CLASS_NAMES.INLINE_SDT_WRAPPER}`);
			if (container) elements = [container];
		}
		if (elements.length === 0) {
			this.#clearSelectedStructuredContentInlineClass();
			return;
		}
		this.#setSelectedStructuredContentInlineClass(elements, id);
	}
	#updateSelection() {
		const shouldScrollIntoView = this.#shouldScrollSelectionIntoView && !this.#editorInputManager?.isDragging;
		this.#shouldScrollSelectionIntoView = false;
		const activeStorySession = this.#getActiveStorySession();
		if (activeStorySession?.kind === "headerFooter") {
			this.#updateHeaderFooterSelection(shouldScrollIntoView);
			return;
		}
		if (activeStorySession?.kind === "note") {
			this.#updateNoteSelection(shouldScrollIntoView);
			return;
		}
		if ((this.#headerFooterSession?.session?.mode ?? "body") !== "body") {
			this.#updateHeaderFooterSelection(shouldScrollIntoView);
			return;
		}
		if (!this.#localSelectionLayer) return;
		if (this.#isViewLocked() && !this.#options.allowSelectionInViewMode) {
			try {
				this.#clearSelectedFieldAnnotationClass();
				this.#localSelectionLayer.innerHTML = "";
			} catch (error) {
				if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] Failed to clear selection layer in viewing mode:", error);
			}
			return;
		}
		const activeEditor = this.getActiveEditor();
		const hasFocus = activeEditor?.view?.hasFocus?.() ?? false;
		const contextMenuOpen = activeEditor?.state ? !!ContextMenuPluginKey.getState(activeEditor.state)?.open : false;
		const isOnEditorUi = !!document.activeElement?.closest?.("[data-editor-ui-surface], .sd-toolbar-dropdown-menu, .toolbar-dropdown-menu");
		const isDragDropIndicatorActive = this.#dragDropIndicatorPos != null;
		if (!hasFocus && !contextMenuOpen && !isOnEditorUi && !isDragDropIndicatorActive) {
			try {
				this.#clearSelectedFieldAnnotationClass();
				this.#localSelectionLayer.innerHTML = "";
			} catch {}
			return;
		}
		const layout = this.#layoutState.layout;
		const selection = activeEditor.state?.selection;
		if (!selection) {
			try {
				this.#clearSelectedFieldAnnotationClass();
				this.#clearSelectedStructuredContentBlockClass();
				this.#clearSelectedStructuredContentInlineClass();
				this.#localSelectionLayer.innerHTML = "";
			} catch (error) {
				if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] Failed to clear selection layer (no selection):", error);
			}
			return;
		}
		if (!layout) return;
		const { from: from$1, to } = selection;
		const docEpoch = this.#epochMapper.getCurrentEpoch();
		if (this.#layoutEpoch < docEpoch) return;
		this.#syncSelectedFieldAnnotationClass(selection);
		this.#syncSelectedStructuredContentBlockClass(selection);
		this.#syncSelectedStructuredContentInlineClass(selection);
		this.#updateSelectionVirtualizationPins({ includeDragBuffer: this.#editorInputManager?.isDragging ?? false });
		if (selection instanceof CellSelection) {
			try {
				this.#localSelectionLayer.innerHTML = "";
				this.#renderCellSelectionOverlay(selection, layout);
			} catch (error) {
				console.warn("[PresentationEditor] Failed to render cell selection overlay:", error);
			}
			return;
		}
		if (from$1 === to || isDragDropIndicatorActive) {
			const caretPos = this.#dragDropIndicatorPos ?? from$1;
			const caretLayout = this.#computeCaretLayoutRect(caretPos);
			if (!caretLayout) return;
			try {
				this.#localSelectionLayer.innerHTML = "";
				renderCaretOverlay({
					localSelectionLayer: this.#localSelectionLayer,
					caretLayout,
					convertPageLocalToOverlayCoords: (pageIndex, x, y$1) => this.#convertPageLocalToOverlayCoords(pageIndex, x, y$1)
				});
			} catch (error) {
				if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] Failed to render caret overlay:", error);
			}
			if (shouldScrollIntoView && !isDragDropIndicatorActive) this.#scrollActiveEndIntoView(caretLayout.pageIndex);
			return;
		}
		const domRects = this.#computeSelectionRectsFromDom(from$1, to);
		if (domRects == null) {
			debugLog("warn", "Local selection: DOM rect computation failed", {
				from: from$1,
				to
			});
			return;
		}
		if (domRects.length === 0 && from$1 !== to && this.#editorInputManager?.isDragging) {
			debugLog("warn", "[drawSelection] zero rects for non-collapsed selection — preserving last overlay", {
				from: from$1,
				to
			});
			return;
		}
		try {
			this.#localSelectionLayer.innerHTML = "";
			const isFieldAnnotationSelection = selection instanceof NodeSelection && selection.node?.type?.name === "fieldAnnotation";
			if (domRects.length > 0 && !isFieldAnnotationSelection) renderSelectionRects({
				localSelectionLayer: this.#localSelectionLayer,
				rects: domRects,
				pageHeight: this.#getBodyPageHeight(),
				pageGap: this.#layoutState.layout?.pageGap ?? 0,
				convertPageLocalToOverlayCoords: (pageIndex, x, y$1) => this.#convertPageLocalToOverlayCoords(pageIndex, x, y$1)
			});
		} catch (error) {
			if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] Failed to render selection rects:", error);
		}
		if (shouldScrollIntoView) {
			const head = activeEditor?.view?.state?.selection?.head ?? to;
			const headLayout = this.#computeCaretLayoutRect(head);
			if (headLayout) this.#scrollActiveEndIntoView(headLayout.pageIndex);
		}
	}
	#scrollScreenRectIntoView(screenTop, screenBottom) {
		const scrollContainer = this.#scrollContainer;
		if (!scrollContainer) return;
		let containerTop;
		let containerBottom;
		if (scrollContainer instanceof Window) {
			containerTop = 0;
			containerBottom = scrollContainer.innerHeight;
		} else {
			const r$1 = scrollContainer.getBoundingClientRect();
			containerTop = r$1.top;
			containerBottom = r$1.bottom;
		}
		const SCROLL_MARGIN = 20;
		if (screenBottom > containerBottom - SCROLL_MARGIN) {
			const delta = screenBottom - containerBottom + SCROLL_MARGIN;
			if (scrollContainer instanceof Window) scrollContainer.scrollBy({ top: delta });
			else scrollContainer.scrollTop += delta;
		} else if (screenTop < containerTop + SCROLL_MARGIN) {
			const delta = containerTop + SCROLL_MARGIN - screenTop;
			if (scrollContainer instanceof Window) scrollContainer.scrollBy({ top: -delta });
			else scrollContainer.scrollTop -= delta;
		}
	}
	#scrollActiveEndIntoView(pageIndex) {
		if (this.#suppressSelectionScrollUntilRaf) return;
		if (!!!this.#painterHost.querySelector(`[data-page-index="${pageIndex}"]`)) {
			this.#scrollPageIntoView(pageIndex);
			return;
		}
		const caretEl = this.#localSelectionLayer?.querySelector(".presentation-editor__selection-caret");
		if (caretEl) {
			const r$1 = caretEl.getBoundingClientRect();
			this.#scrollScreenRectIntoView(r$1.top, r$1.bottom);
			return;
		}
		const sel = this.getActiveEditor()?.view?.state?.selection;
		const headRect = !sel || sel.head >= sel.anchor ? this.#localSelectionLayer?.lastElementChild : this.#localSelectionLayer?.firstElementChild;
		if (headRect) {
			const r$1 = headRect.getBoundingClientRect();
			this.#scrollScreenRectIntoView(r$1.top, r$1.bottom);
		}
	}
	#updatePermissionOverlay() {
		const overlay = this.#permissionOverlay;
		if (!overlay) return;
		if ((this.#headerFooterSession?.session?.mode ?? "body") !== "body") {
			overlay.innerHTML = "";
			return;
		}
		const ranges = (this.#editor?.storage?.permissionRanges)?.ranges ?? [];
		if (!(ranges.length > 0)) {
			overlay.innerHTML = "";
			return;
		}
		const layout = this.#layoutState.layout;
		if (!layout) {
			overlay.innerHTML = "";
			return;
		}
		const docEpoch = this.#epochMapper.getCurrentEpoch();
		if (this.#layoutEpoch < docEpoch) return;
		const pageHeight = this.#getBodyPageHeight();
		const pageGap = layout.pageGap ?? this.#getEffectivePageGap();
		const fragment = overlay.ownerDocument?.createDocumentFragment();
		if (!fragment) {
			overlay.innerHTML = "";
			return;
		}
		ranges.forEach(({ from: from$1, to }) => {
			const rects = this.#computeSelectionRectsFromDom(from$1, to);
			if (!rects?.length) return;
			rects.forEach((rect) => {
				const pageLocalY = rect.y - rect.pageIndex * (pageHeight + pageGap);
				const coords = this.#convertPageLocalToOverlayCoords(rect.pageIndex, rect.x, pageLocalY);
				if (!coords) return;
				const highlight = overlay.ownerDocument?.createElement("div");
				if (!highlight) return;
				highlight.className = "presentation-editor__permission-highlight";
				Object.assign(highlight.style, {
					position: "absolute",
					left: `${coords.x}px`,
					top: `${coords.y}px`,
					width: `${Math.max(1, rect.width)}px`,
					height: `${Math.max(1, rect.height)}px`,
					borderRadius: "2px",
					pointerEvents: "none",
					zIndex: 1
				});
				fragment.appendChild(highlight);
			});
		});
		overlay.innerHTML = "";
		overlay.appendChild(fragment);
	}
	#resolveAlternateHeadersFlag() {
		const converter = this.#editor?.converter;
		if (!converter) return false;
		const settingsPart = converter.convertedXml?.["word/settings.xml"];
		const fromSettings = resolveEvenAndOddHeadersFromSettingsPart(settingsPart);
		if (fromSettings !== null) return fromSettings;
		return converter.pageStyles?.alternateHeaders === true;
	}
	#resolveLayoutOptions(blocks, sectionMetadata) {
		const defaults = this.#computeDefaultLayoutDefaults();
		const firstSection = blocks?.find((block) => block.kind === "sectionBreak" && block?.attrs?.isFirstSection);
		const pageSize = firstSection?.pageSize ?? defaults.pageSize;
		const margins = {
			...defaults.margins,
			...firstSection?.margins?.top != null ? { top: firstSection.margins.top } : {},
			...firstSection?.margins?.right != null ? { right: firstSection.margins.right } : {},
			...firstSection?.margins?.bottom != null ? { bottom: firstSection.margins.bottom } : {},
			...firstSection?.margins?.left != null ? { left: firstSection.margins.left } : {},
			...firstSection?.margins?.header != null ? { header: firstSection.margins.header } : {},
			...firstSection?.margins?.footer != null ? { footer: firstSection.margins.footer } : {}
		};
		const columns = firstSection ? firstSection.columns ?? {
			count: 1,
			gap: 0
		} : defaults.columns;
		this.#layoutOptions.pageSize = pageSize;
		this.#layoutOptions.margins = margins;
		const flowMode = this.#layoutOptions.flowMode ?? "paginated";
		const documentBackground = this.#resolveDocumentBackground();
		if (documentBackground) this.#layoutOptions.documentBackground = documentBackground;
		else delete this.#layoutOptions.documentBackground;
		const resolvedMargins = {
			top: margins.top,
			right: margins.right,
			bottom: margins.bottom,
			left: margins.left,
			...margins.header != null ? { header: margins.header } : {},
			...margins.footer != null ? { footer: margins.footer } : {}
		};
		if (flowMode === "semantic") {
			const semanticMargins = this.#resolveSemanticMargins(margins);
			const containerWidth = this.#resolveSemanticContainerInnerWidth();
			const semanticContentWidth = Math.max(MIN_SEMANTIC_CONTENT_WIDTH_PX, containerWidth - semanticMargins.left - semanticMargins.right);
			const semanticPageWidth = semanticContentWidth + semanticMargins.left + semanticMargins.right;
			this.#hiddenHost.style.width = `${semanticContentWidth}px`;
			this.#lastSemanticContainerWidth = containerWidth;
			return {
				flowMode: "semantic",
				pageSize: {
					w: semanticPageWidth,
					h: pageSize.h
				},
				margins: {
					...resolvedMargins,
					top: semanticMargins.top,
					right: semanticMargins.right,
					bottom: semanticMargins.bottom,
					left: semanticMargins.left
				},
				columns: {
					count: 1,
					gap: 0
				},
				semantic: {
					contentWidth: semanticContentWidth,
					marginLeft: semanticMargins.left,
					marginRight: semanticMargins.right,
					marginTop: semanticMargins.top,
					marginBottom: semanticMargins.bottom
				},
				sectionMetadata,
				...documentBackground ? { documentBackground } : {}
			};
		}
		this.#hiddenHost.style.width = `${pageSize.w}px`;
		const alternateHeaders = this.#resolveAlternateHeadersFlag();
		return {
			flowMode: "paginated",
			pageSize,
			margins: resolvedMargins,
			...documentBackground ? { documentBackground } : {},
			...columns ? { columns } : {},
			sectionMetadata,
			alternateHeaders
		};
	}
	#collectHeaderFooterFaceBlocks(input) {
		const out = [];
		for (const batch of [input.headerBlocks, input.footerBlocks]) if (batch) {
			for (const blocks of Object.values(batch)) if (blocks) out.push(...blocks);
		}
		for (const byRId of [input.headerBlocksByRId, input.footerBlocksByRId]) if (byRId) for (const blocks of byRId.values()) out.push(...blocks);
		return out;
	}
	#coerceDocumentBackground(candidate) {
		if (!candidate || typeof candidate !== "object") return void 0;
		const color = candidate.color;
		return typeof color === "string" && color.length > 0 ? { color } : void 0;
	}
	#resolveDocumentBackground() {
		return this.#coerceDocumentBackground(this.#editor?.state?.doc?.attrs?.documentBackground) ?? (this.#configuredDocumentBackground ? { ...this.#configuredDocumentBackground } : void 0);
	}
	#buildHeaderFooterInput() {
		if (this.#isSemanticFlowMode()) return null;
		const adapter = this.#headerFooterSession?.adapter;
		if (!adapter) return null;
		const headerBlocks = adapter.getBatch("header");
		const footerBlocks = adapter.getBatch("footer");
		const headerBlocksByRId = adapter.getBlocksByRId("header");
		const footerBlocksByRId = adapter.getBlocksByRId("footer");
		if (!headerBlocks && !footerBlocks && !headerBlocksByRId && !footerBlocksByRId) return null;
		const constraints = this.#computeHeaderFooterConstraints();
		if (!constraints) return null;
		return {
			headerBlocks,
			footerBlocks,
			headerBlocksByRId,
			footerBlocksByRId,
			constraints
		};
	}
	#computeHeaderFooterConstraints() {
		const pageSize = this.#layoutOptions.pageSize ?? DEFAULT_PAGE_SIZE;
		const margins = this.#layoutOptions.margins ?? DEFAULT_MARGINS;
		const marginLeft = margins.left ?? DEFAULT_MARGINS.left;
		const marginRight = margins.right ?? DEFAULT_MARGINS.right;
		const bodyContentWidth = pageSize.w - (marginLeft + marginRight);
		if (!Number.isFinite(bodyContentWidth) || bodyContentWidth <= 0) return null;
		const measurementWidth = bodyContentWidth;
		const marginTop = margins.top ?? DEFAULT_MARGINS.top;
		const marginBottom = margins.bottom ?? DEFAULT_MARGINS.bottom;
		if (!Number.isFinite(marginTop) || !Number.isFinite(marginBottom)) {
			console.warn("[PresentationEditor] Invalid top or bottom margin: not a finite number");
			return null;
		}
		const totalVerticalMargins = marginTop + marginBottom;
		if (totalVerticalMargins >= pageSize.h) {
			console.warn(`[PresentationEditor] Invalid margins: top (${marginTop}) + bottom (${marginBottom}) = ${totalVerticalMargins} >= page height (${pageSize.h})`);
			return null;
		}
		const MIN_HEADER_FOOTER_HEIGHT = 1;
		const height = Math.max(MIN_HEADER_FOOTER_HEIGHT, pageSize.h - totalVerticalMargins);
		const headerMargin = margins.header ?? 0;
		const footerMargin = margins.footer ?? 0;
		const headerBand = Math.max(MIN_HEADER_FOOTER_HEIGHT, marginTop - headerMargin);
		const footerBand = Math.max(MIN_HEADER_FOOTER_HEIGHT, marginBottom - footerMargin);
		const overflowBaseHeight = Math.max(headerBand, footerBand);
		return {
			width: measurementWidth,
			height,
			pageWidth: pageSize.w,
			pageHeight: pageSize.h,
			margins: {
				left: marginLeft,
				right: marginRight,
				top: marginTop,
				bottom: marginBottom,
				header: headerMargin,
				...margins.footer != null ? { footer: footerMargin } : {}
			},
			overflowBaseHeight
		};
	}
	async #layoutPerRIdHeaderFooters(headerFooterInput, layout, sectionMetadata) {
		if (this.#headerFooterSession) await this.#headerFooterSession.layoutPerRId(headerFooterInput, layout, sectionMetadata, this.#fontResolver, this.#hasFace, this.#fontPlan?.effectiveSignature ?? "");
	}
	#updateDecorationProviders(resolvedLayout) {
		this.#headerFooterSession?.updateDecorationProviders(resolvedLayout);
	}
	#hitTestHeaderFooterRegion(x, y$1, pageIndex, pageLocalY) {
		return this.#headerFooterSession?.hitTestRegion(x, y$1, this.#layoutState.layout, pageIndex, pageLocalY) ?? null;
	}
	#activateHeaderFooterRegion(region, options) {
		this.#activateHeaderFooterRegionAtPoint(region, options);
	}
	async #activateHeaderFooterRegionAtPoint(region, options) {
		const editor = await this.#headerFooterSession?.activateRegion(region, { initialSelection: options ? "defer" : "end" }) ?? null;
		if (!editor || !options) return;
		const doc$1 = editor.state?.doc;
		const hit = this.hitTest(options.clientX, options.clientY);
		if (!doc$1 || !hit) return;
		try {
			const selection = this.#createCollapsedSelectionNearInlineContent(doc$1, hit.pos);
			const tr = editor.state.tr.setSelection(selection);
			editor.view?.dispatch(tr);
			editor.view?.focus?.();
			this.#shouldScrollSelectionIntoView = true;
			this.#scheduleSelectionUpdate({ immediate: true });
		} catch {}
	}
	#exitHeaderFooterMode() {
		this.#headerFooterSession?.exitMode();
		this.#pendingDocChange = true;
		this.#scheduleRerender();
		this.#editor.view?.focus();
	}
	#buildNoteLayoutContext(target) {
		const layout = this.#layoutState.layout;
		if (!target || !layout) return null;
		const blocks = [];
		const measures = [];
		const noteBlockIds = /* @__PURE__ */ new Set();
		this.#layoutLookupBlocks.forEach((block, index) => {
			const blockId = typeof block?.id === "string" ? block.id : "";
			const parsed = parseRenderedNoteTarget(blockId);
			if (!parsed) return;
			if (parsed.storyType !== target.storyType || parsed.noteId !== target.noteId) return;
			blocks.push(block);
			measures.push(this.#layoutLookupMeasures[index]);
			noteBlockIds.add(blockId);
		});
		if (blocks.length === 0 || measures.length !== blocks.length) return null;
		let firstPageIndex = -1;
		let hostWidthPx = 0;
		layout.pages.forEach((page, pageIndex) => {
			page.fragments.forEach((fragment) => {
				if (!noteBlockIds.has(fragment.blockId)) return;
				if (firstPageIndex < 0) firstPageIndex = pageIndex;
				const fragmentWidth = typeof fragment.width === "number" ? fragment.width : 0;
				hostWidthPx = Math.max(hostWidthPx, fragmentWidth);
			});
		});
		if (firstPageIndex < 0) firstPageIndex = 0;
		if (!(hostWidthPx > 0)) {
			const page = layout.pages[firstPageIndex];
			const pageWidth = page?.size?.w ?? layout.pageSize.w ?? DEFAULT_PAGE_SIZE.w;
			const margins = page?.margins ?? this.#layoutOptions.margins ?? DEFAULT_MARGINS;
			const marginLeft = margins.left ?? DEFAULT_MARGINS.left ?? 0;
			const marginRight = margins.right ?? DEFAULT_MARGINS.right ?? 0;
			hostWidthPx = Math.max(1, pageWidth - marginLeft - marginRight);
		}
		return {
			target,
			blocks,
			measures,
			firstPageIndex,
			hostWidthPx: Math.max(1, hostWidthPx)
		};
	}
	#buildActiveNoteLayoutContext() {
		const session = this.#getActiveNoteStorySession();
		if (!session) return null;
		return this.#buildNoteLayoutContext({
			storyType: session.locator.storyType,
			noteId: session.locator.noteId
		});
	}
	#toStoryNoteVisibleTextOffset(_noteFragments, renderedTextOffset) {
		return Math.max(0, renderedTextOffset);
	}
	#toRenderedNoteVisibleTextOffset(_noteFragments, storyTextOffset) {
		return Math.max(0, storyTextOffset);
	}
	#collectNoteBlockIds(context) {
		return new Set(context.blocks.map((block) => typeof block?.id === "string" ? block.id : null).filter((blockId) => !!blockId));
	}
	#resolveRenderedPageIndexForElement(element) {
		const pageElement = element.closest("[data-page-index]");
		const pageIndex = Number(pageElement?.dataset.pageIndex ?? "NaN");
		if (Number.isFinite(pageIndex) && pageIndex >= 0) return pageIndex;
		const blockId = element.getAttribute("data-block-id") ?? "";
		const layout = this.#layoutState.layout;
		if (!blockId || !layout) return 0;
		for (let index = 0; index < layout.pages.length; index += 1) if (layout.pages[index]?.fragments?.some((fragment) => fragment.blockId === blockId)) return index;
		return 0;
	}
	#getRenderedNoteFragmentElements(noteBlockIds) {
		if (!this.#viewportHost || noteBlockIds.size === 0) return [];
		return Array.from(this.#viewportHost.querySelectorAll("[data-block-id]")).filter((element) => noteBlockIds.has(element.getAttribute("data-block-id") ?? ""));
	}
	#measureRenderedNoteVisibleTextOffset(context, clientX, clientY) {
		const noteBlockIds = this.#collectNoteBlockIds(context);
		const noteFragments = this.#getRenderedNoteFragmentElements(noteBlockIds);
		if (!noteFragments.length) return null;
		const fragmentHit = this.#findRenderedNoteFragmentAtPoint(noteBlockIds, clientX, clientY);
		if (!fragmentHit) return null;
		const boundary = resolveTextBoundaryWithinFragmentDom(fragmentHit.fragmentElement, clientX, clientY);
		if (!boundary) return null;
		const renderedTextOffset = measureVisibleTextOffsetInContainers(noteFragments, boundary.node, boundary.offset);
		if (renderedTextOffset == null) return null;
		return this.#toStoryNoteVisibleTextOffset(noteFragments, renderedTextOffset);
	}
	#resolveActiveEditorPosFromVisibleTextOffset(textOffset) {
		if (!Number.isFinite(textOffset)) return null;
		const docSize = this.getActiveEditor()?.state?.doc?.content.size;
		if (!Number.isFinite(docSize)) return null;
		const targetOffset = Math.max(0, textOffset);
		const visibleOffsetCache = /* @__PURE__ */ new Map();
		const readVisibleOffset = (pos) => {
			if (!visibleOffsetCache.has(pos)) visibleOffsetCache.set(pos, this.#measureActiveEditorVisibleTextOffset(pos));
			return visibleOffsetCache.get(pos) ?? null;
		};
		const resolveLastPosAtOrBeforeOffset = () => {
			let low = 0;
			let high = docSize;
			let bestPos = null;
			while (low <= high) {
				const mid = Math.floor((low + high) / 2);
				const visibleOffset = readVisibleOffset(mid);
				if (visibleOffset == null) {
					high = mid - 1;
					continue;
				}
				if (visibleOffset <= targetOffset) {
					bestPos = mid;
					low = mid + 1;
					continue;
				}
				high = mid - 1;
			}
			return bestPos;
		};
		const resolveFirstPosAtOrAfterOffset = () => {
			let low = 0;
			let high = docSize;
			let bestPos = null;
			while (low <= high) {
				const mid = Math.floor((low + high) / 2);
				const visibleOffset = readVisibleOffset(mid);
				if (visibleOffset == null) {
					high = mid - 1;
					continue;
				}
				if (visibleOffset >= targetOffset) {
					bestPos = mid;
					high = mid - 1;
					continue;
				}
				low = mid + 1;
			}
			return bestPos;
		};
		return targetOffset === 0 ? resolveLastPosAtOrBeforeOffset() : resolveFirstPosAtOrAfterOffset();
	}
	#findRenderedNoteFragmentAtPoint(noteBlockIds, clientX, clientY) {
		const doc$1 = this.#viewportHost.ownerDocument ?? document;
		const elementsFromPoint = typeof doc$1.elementsFromPoint === "function" ? doc$1.elementsFromPoint.bind(doc$1) : null;
		const toFragmentHit = (element) => {
			const fragmentElement = element instanceof HTMLElement ? element.closest("[data-block-id]") : null;
			const blockId = fragmentElement?.getAttribute("data-block-id") ?? "";
			if (!fragmentElement || !noteBlockIds.has(blockId)) return null;
			return {
				fragmentElement,
				pageIndex: this.#resolveRenderedPageIndexForElement(fragmentElement)
			};
		};
		if (elementsFromPoint) for (const element of elementsFromPoint(clientX, clientY)) {
			const fragmentHit = toFragmentHit(element);
			if (fragmentHit) return fragmentHit;
		}
		for (const fragmentElement of this.#getRenderedNoteFragmentElements(noteBlockIds)) {
			const rect = fragmentElement.getBoundingClientRect();
			if (clientX < rect.left || clientX > rect.right || clientY < rect.top || clientY > rect.bottom) continue;
			return {
				fragmentElement,
				pageIndex: this.#resolveRenderedPageIndexForElement(fragmentElement)
			};
		}
		return null;
	}
	#resolveNoteDomHit(context, clientX, clientY) {
		const layout = this.#layoutState.layout;
		if (!layout) return null;
		const noteBlockIds = this.#collectNoteBlockIds(context);
		if (noteBlockIds.size === 0) return null;
		const fragmentHit = this.#findRenderedNoteFragmentAtPoint(noteBlockIds, clientX, clientY);
		if (!fragmentHit) return null;
		const bridgedTextOffset = this.#measureRenderedNoteVisibleTextOffset(context, clientX, clientY);
		const bridgedPos = bridgedTextOffset == null ? null : this.#resolveActiveEditorPosFromVisibleTextOffset(bridgedTextOffset);
		if (bridgedTextOffset != null && bridgedPos != null) this.#recordNoteHitDebug({
			bridgedTextOffset,
			bridgedPos,
			bridgedVisibleOffsets: [
				bridgedPos - 2,
				bridgedPos - 1,
				bridgedPos,
				bridgedPos + 1,
				bridgedPos + 2
			].filter((pos$1) => pos$1 >= 0).map((pos$1) => ({
				pos: pos$1,
				visibleOffset: this.#measureActiveEditorVisibleTextOffset(pos$1)
			}))
		});
		if (bridgedPos != null) return {
			pos: bridgedPos,
			layoutEpoch: readLayoutEpochFromDom(fragmentHit.fragmentElement, clientX, clientY) ?? layout.layoutEpoch ?? 0,
			blockId: fragmentHit.fragmentElement.getAttribute("data-block-id") ?? "",
			pageIndex: fragmentHit.pageIndex,
			column: 0,
			lineIndex: -1
		};
		const pos = resolvePositionWithinFragmentDom(fragmentHit.fragmentElement, clientX, clientY);
		if (pos == null) return null;
		return {
			pos,
			layoutEpoch: readLayoutEpochFromDom(fragmentHit.fragmentElement, clientX, clientY) ?? layout.layoutEpoch ?? 0,
			blockId: fragmentHit.fragmentElement.getAttribute("data-block-id") ?? "",
			pageIndex: fragmentHit.pageIndex,
			column: 0,
			lineIndex: -1
		};
	}
	#resolveHeaderFooterDomHit(context, clientX, clientY) {
		const layout = this.#layoutState.layout;
		if (!layout) return null;
		const blockIds = new Set(context.blocks.map((block) => block.id).filter((id) => typeof id === "string" && id.length > 0));
		if (blockIds.size === 0) return null;
		const doc$1 = this.#viewportHost.ownerDocument ?? document;
		const elementsFromPoint = typeof doc$1.elementsFromPoint === "function" ? doc$1.elementsFromPoint.bind(doc$1) : null;
		const tryResolve = (element, enforceKnownBlockIds = true) => {
			const fragmentElement = element instanceof HTMLElement ? element.closest("[data-block-id]") : null;
			const blockId = fragmentElement?.getAttribute("data-block-id") ?? "";
			if (!fragmentElement) return null;
			if (enforceKnownBlockIds && !blockIds.has(blockId)) return null;
			const pos = resolvePositionWithinFragmentDom(fragmentElement, clientX, clientY);
			if (pos == null) return null;
			return {
				pos,
				layoutEpoch: readLayoutEpochFromDom(fragmentElement, clientX, clientY) ?? layout.layoutEpoch ?? 0,
				blockId,
				pageIndex: this.#resolveRenderedPageIndexForElement(fragmentElement),
				column: 0,
				lineIndex: -1
			};
		};
		if (elementsFromPoint) {
			for (const element of elementsFromPoint(clientX, clientY)) {
				const hit = tryResolve(element, true);
				if (hit) return hit;
			}
			for (const element of elementsFromPoint(clientX, clientY)) {
				if (!element.closest(".superdoc-page-header, .superdoc-page-footer")) continue;
				const hit = tryResolve(element, false);
				if (hit) return hit;
			}
		}
		const surfaceSelector = context.region.kind === "footer" ? ".superdoc-page-footer" : ".superdoc-page-header";
		const surface = getPageElementByIndex(this.#viewportHost, context.region.pageIndex)?.querySelector(surfaceSelector) ?? null;
		if (surface instanceof HTMLElement) {
			const fragments = Array.from(surface.querySelectorAll(".superdoc-fragment"));
			for (const fragment of fragments) {
				const rect = fragment.getBoundingClientRect();
				if (clientX < rect.left || clientX > rect.right || clientY < rect.top || clientY > rect.bottom) continue;
				const hit = tryResolve(fragment, false);
				if (hit) return hit;
			}
		}
		return null;
	}
	#createCollapsedSelectionNearInlineContent(doc$1, pos) {
		const clampedPos = Math.max(0, Math.min(pos, doc$1.content.size));
		const directSelection = TextSelection.create(doc$1, clampedPos);
		if (directSelection.$from.parent.inlineContent) return directSelection;
		const bias = clampedPos >= doc$1.content.size ? -1 : 1;
		return Selection.near(doc$1.resolve(clampedPos), bias);
	}
	#activateRenderedNoteSession(target, options) {
		if ((this.#headerFooterSession?.session?.mode ?? "body") !== "body") this.#headerFooterSession?.exitMode();
		const storySessionManager = this.#ensureStorySessionManager();
		if (target.storyType !== "footnote" && target.storyType !== "endnote") return false;
		const targetContext = this.#buildNoteLayoutContext(target);
		const totalPageCount = this.#layoutState.layout?.pages?.length ?? 1;
		const pageNumber = Math.max(1, (options.pageIndex ?? targetContext?.firstPageIndex ?? 0) + 1);
		const session = storySessionManager.activate({
			kind: "story",
			storyType: target.storyType,
			noteId: target.noteId
		}, {
			commitPolicy: "onExit",
			preferHiddenHost: true,
			hostWidthPx: targetContext?.hostWidthPx ?? this.#visibleHost.clientWidth ?? 1,
			editorContext: {
				currentPageNumber: pageNumber,
				totalPageCount: Math.max(1, totalPageCount),
				surfaceKind: target.storyType === "endnote" ? "endnote" : "note"
			}
		});
		const hit = this.hitTest(options.clientX, options.clientY);
		const doc$1 = session.editor.state?.doc;
		if (hit && doc$1) try {
			const selection = this.#createCollapsedSelectionNearInlineContent(doc$1, hit.pos);
			const tr = session.editor.state.tr.setSelection(selection);
			session.editor.view?.dispatch(tr);
		} catch {}
		session.editor.view?.focus();
		this.#shouldScrollSelectionIntoView = true;
		this.#scheduleSelectionUpdate({ immediate: true });
		return true;
	}
	#exitActiveStorySession() {
		if (!this.#getActiveStorySession()) return;
		this.#storySessionManager?.exit();
		this.#pendingDocChange = true;
		this.#scheduleRerender();
		this.#editor.view?.focus();
	}
	#getActiveDomTarget() {
		const storyTarget = this.#storySessionManager?.getActiveEditorDomTarget();
		if (storyTarget) return storyTarget;
		const session = this.#headerFooterSession?.session;
		if (session && session.mode !== "body") return (this.#headerFooterSession?.activeEditor)?.view?.dom ?? this.#editor.view?.dom ?? null;
		return this.#editor.view?.dom ?? null;
	}
	#updateAwarenessSession() {
		const awareness = this.#options.collaborationProvider?.awareness;
		if (!awareness || typeof awareness.setLocalStateField !== "function") return;
		const session = this.#headerFooterSession?.session;
		if (!session || session.mode === "body") {
			awareness.setLocalStateField("layoutSession", null);
			return;
		}
		awareness.setLocalStateField("layoutSession", {
			kind: session.kind,
			headerId: session.headerFooterRefId ?? null,
			pageNumber: session.pageNumber ?? null
		});
	}
	#announce(message) {
		if (!this.#ariaLiveRegion) return;
		this.#ariaLiveRegion.textContent = message;
	}
	#syncHiddenEditorA11yAttributes() {
		syncHiddenEditorA11yAttributes(this.#editor?.view?.dom, this.#documentMode);
	}
	#scheduleA11ySelectionAnnouncement(options) {
		const sessionMode = this.#headerFooterSession?.session?.mode ?? "body";
		this.#a11ySelectionAnnounceTimeout = scheduleA11ySelectionAnnouncement({
			ariaLiveRegion: this.#ariaLiveRegion,
			sessionMode,
			isDragging: this.#editorInputManager?.isDragging ?? false,
			visibleHost: this.#visibleHost,
			currentTimeout: this.#a11ySelectionAnnounceTimeout,
			announceNow: () => {
				this.#a11ySelectionAnnounceTimeout = null;
				this.#announceSelectionNow();
			}
		}, options);
	}
	#announceSelectionNow() {
		if (!this.#ariaLiveRegion) return;
		const announcement = computeA11ySelectionAnnouncement(this.getActiveEditor().state);
		if (!announcement) return;
		if (announcement.key === this.#a11yLastAnnouncedSelectionKey) return;
		this.#a11yLastAnnouncedSelectionKey = announcement.key;
		this.#announce(announcement.message);
	}
	#emitHeaderFooterEditBlocked(reason) {
		this.emit("headerFooterEditBlocked", { reason });
	}
	#resolveDescriptorForRegion(region) {
		return this.#headerFooterSession?.resolveDescriptorForRegion(region) ?? null;
	}
	#getPageElement(pageIndex) {
		return getPageElementByIndex(this.#painterHost, pageIndex);
	}
	#isSelectionAwareVirtualizationEnabled() {
		return Boolean(this.#layoutOptions.virtualization?.enabled && this.#layoutOptions.layoutMode === "vertical");
	}
	#updateSelectionVirtualizationPins(options) {
		if (!this.#isSelectionAwareVirtualizationEnabled()) return;
		if (!this.#painterAdapter.hasPainter) return;
		const layout = this.#layoutState.layout;
		if (!layout) return;
		const state = this.getActiveEditor().state;
		const selection = state?.selection ?? null;
		const docSize = state?.doc?.content.size ?? null;
		const pins = computeSelectionVirtualizationPins({
			layout,
			blocks: this.#layoutState.blocks,
			measures: this.#layoutState.measures,
			selection: selection ? {
				from: selection.from,
				to: selection.to,
				anchor: selection.anchor,
				head: selection.head
			} : null,
			docSize,
			includeDragBuffer: Boolean(options?.includeDragBuffer),
			isDragging: this.#editorInputManager?.isDragging ?? false,
			dragAnchorPageIndex: this.#editorInputManager?.dragAnchorPageIndex ?? null,
			dragLastHitPageIndex: this.#editorInputManager?.dragLastHitPageIndex ?? null,
			extraPages: options?.extraPages
		});
		this.#painterAdapter.setVirtualizationPins(pins);
	}
	#finalizeDragSelectionWithDom(pointer, anchor, mode) {
		const layout = this.#layoutState.layout;
		if (!layout) return;
		if (this.getActiveEditor().state?.selection instanceof CellSelection) return;
		const normalized = this.#normalizeClientPoint(pointer.clientX, pointer.clientY);
		if (!normalized) return;
		const dragLastRawHit = this.#editorInputManager?.dragLastRawHit;
		this.#updateSelectionVirtualizationPins({
			includeDragBuffer: false,
			extraPages: dragLastRawHit ? [dragLastRawHit.pageIndex] : void 0
		});
		const refined = resolvePointerPositionHit({
			layout,
			blocks: this.#layoutState.blocks,
			measures: this.#layoutState.measures,
			containerPoint: {
				x: normalized.x,
				y: normalized.y
			},
			domContainer: this.#viewportHost,
			clientX: pointer.clientX,
			clientY: pointer.clientY,
			geometryHelper: this.#pageGeometryHelper ?? void 0
		});
		if (!refined) return;
		if (this.#isSelectionAwareVirtualizationEnabled() && this.#getPageElement(refined.pageIndex) == null) {
			debugLog("warn", "Drag finalize: endpoint page still not mounted", { pageIndex: refined.pageIndex });
			return;
		}
		const prior = dragLastRawHit;
		if (prior && (prior.pos !== refined.pos || prior.pageIndex !== refined.pageIndex)) debugLog("info", "Drag finalize refined hit", {
			fromPos: prior.pos,
			toPos: refined.pos,
			fromPageIndex: prior.pageIndex,
			toPageIndex: refined.pageIndex
		});
		const doc$1 = this.#editor.state?.doc;
		if (!doc$1) return;
		const mappedHead = this.#epochMapper.mapPosFromLayoutToCurrentDetailed(refined.pos, refined.layoutEpoch, 1);
		if (!mappedHead.ok) {
			debugLog("warn", "drag finalize mapping failed", mappedHead);
			return;
		}
		const head = Math.max(0, Math.min(mappedHead.pos, doc$1.content.size));
		const extended = this.#calculateExtendedSelection(anchor, head, mode);
		const stabilized = stabilizeTextSelectionAcrossTableCells(doc$1, extended.selAnchor, extended.selHead);
		if (!stabilized) return;
		const current = this.#editor.state.selection;
		const desiredFrom = Math.min(stabilized.selAnchor, stabilized.selHead);
		const desiredTo = Math.max(stabilized.selAnchor, stabilized.selHead);
		if (current.from === desiredFrom && current.to === desiredTo) return;
		try {
			const tr = this.#editor.state.tr.setSelection(TextSelection.create(this.#editor.state.doc, stabilized.selAnchor, stabilized.selHead));
			this.#editor.view?.dispatch(tr);
			this.#scheduleSelectionUpdate();
		} catch {}
	}
	#scrollPageIntoView(pageIndex) {
		const layout = this.#layoutState.layout;
		if (!layout) return;
		const defaultHeight = layout.pageSize?.h ?? DEFAULT_PAGE_SIZE.h;
		const virtualGap = this.#getEffectivePageGap();
		let yPosition = 0;
		for (let i = 0; i < pageIndex; i++) {
			const pageHeight = layout.pages[i]?.size?.h ?? defaultHeight;
			yPosition += pageHeight + virtualGap;
		}
		if (this.#scrollContainer instanceof Window) this.#scrollContainer.scrollTo({ top: yPosition });
		else if (this.#scrollContainer) this.#scrollContainer.scrollTop = yPosition;
		if (this.#visibleHost && this.#visibleHost !== this.#scrollContainer) this.#visibleHost.scrollTop = yPosition;
	}
	static {
		this.ANCHOR_NAV_TIMEOUT_MS = 2e3;
	}
	async scrollToElement(elementId) {
		if (!elementId) return false;
		if (await this.navigateTo({
			kind: "block",
			nodeId: elementId
		})) return true;
		if (await this.navigateTo({
			kind: "entity",
			entityType: "comment",
			entityId: elementId
		})) return true;
		if (await this.navigateTo({
			kind: "entity",
			entityType: "trackedChange",
			entityId: elementId
		})) return true;
		return false;
	}
	async navigateTo(target, options = {}) {
		if (!target) return false;
		try {
			if (target.kind === "block") return await this.#navigateToBlock(target, options);
			if (target.kind === "entity") {
				if (target.entityType === "bookmark") return await this.#navigateToBookmark(target);
				if (target.entityType === "comment") return await this.#navigateToComment(target.entityId, options);
				if (target.entityType === "trackedChange") return await this.#navigateToTrackedChange(target.entityId, resolveStoryKeyFromAddress(target.story), target.pageIndex, options);
			}
			return false;
		} catch (error) {
			console.error("[PresentationEditor] navigateTo failed:", error);
			this.emit("error", {
				error,
				context: "navigateTo"
			});
			return false;
		}
	}
	async #navigateToBlock(target, options = {}) {
		const editor = this.#editor;
		if (!editor) return false;
		const index = getBlockIndex(editor);
		let candidate;
		try {
			if (target.nodeType) candidate = findBlockById(index, {
				kind: "block",
				nodeType: target.nodeType,
				nodeId: target.nodeId
			});
			else candidate = findBlockByNodeIdOnly(index, target.nodeId);
		} catch {
			return false;
		}
		if (!candidate) return false;
		return this.#scrollToBlockCandidate(editor, candidate, options);
	}
	async #scrollToBlockCandidate(editor, candidate, options = {}) {
		const blockNode = editor.state.doc.nodeAt(candidate.pos);
		let contentPos = candidate.pos + 1;
		if (blockNode) blockNode.forEach((child, offset$1) => {
			if (contentPos !== candidate.pos + 1) return;
			if (child.textContent.length > 0) contentPos = candidate.pos + 1 + offset$1 + (child.isText ? 0 : 1);
		});
		if (!await this.scrollToPositionAsync(contentPos, {
			behavior: options.behavior ?? "auto",
			block: options.block ?? "center"
		})) return false;
		editor.commands?.setTextSelection?.({
			from: contentPos,
			to: contentPos
		});
		editor.view?.focus?.();
		return true;
	}
	async #navigateToComment(entityId, options = {}) {
		const editor = this.#editor;
		if (!editor) return false;
		const setCursorById = editor.commands?.setCursorById;
		if (typeof setCursorById !== "function") return false;
		if (!setCursorById(entityId, {
			preferredActiveThreadId: entityId,
			activeCommentId: entityId
		})) return false;
		await this.scrollToPositionAsync(editor.state.selection.from, {
			behavior: options.behavior ?? "auto",
			block: options.block ?? "center"
		});
		return true;
	}
	async #navigateToBookmark(target) {
		const editor = this.#editor;
		if (!editor) return false;
		let storyKey = resolveStoryKeyFromAddress(target.story);
		if (!storyKey) {
			const entry = findAllBookmarksInDocument(editor).find((bookmark) => bookmark.name === target.name);
			if (!entry) return false;
			storyKey = entry.storyKey;
		}
		if (!storyKey || storyKey === "body") {
			this.exitActiveStorySurface();
			return await this.goToAnchor(target.name);
		}
		if (this.#navigateToActiveStoryBookmark(target.name, storyKey)) return true;
		const activatedStoryKey = await this.#activateBookmarkStorySurface(storyKey);
		if (activatedStoryKey) return this.#navigateToActiveStoryBookmark(target.name, activatedStoryKey);
		return false;
	}
	async #navigateToTrackedChange(entityId, storyKey, preferredPageIndex, options = {}) {
		const editor = this.#editor;
		if (!editor) return false;
		const behavior = options.behavior ?? "auto";
		const block = options.block ?? "center";
		const navigationIds = this.#resolveTrackedChangeNavigationIds(entityId, storyKey);
		if (storyKey && storyKey !== "body") {
			for (const id of navigationIds) if (this.#navigateToActiveStoryTrackedChange(id, storyKey)) return true;
			for (const id of navigationIds) if (await this.#activateTrackedChangeStorySurface(id, storyKey, preferredPageIndex)) {
				for (const activeId of navigationIds) if (this.#navigateToActiveStoryTrackedChange(activeId, storyKey)) return true;
			}
			for (const id of navigationIds) if (await this.#scrollToRenderedTrackedChange(id, storyKey, preferredPageIndex, {
				behavior,
				block
			})) return true;
			return false;
		}
		const setCursorById = editor.commands?.setCursorById;
		if (typeof setCursorById === "function") {
			for (const id of navigationIds) if (setCursorById(id, { preferredActiveThreadId: id })) {
				await this.scrollToPositionAsync(editor.state.selection.from, {
					behavior,
					block
				});
				return true;
			}
		}
		const resolved = navigationIds.map((id) => resolveTrackedChange(editor, id)).find(Boolean);
		if (!resolved) {
			for (const id of navigationIds) if (await this.#scrollToRenderedTrackedChange(id, void 0, preferredPageIndex, {
				behavior,
				block
			})) return true;
			return false;
		}
		if (typeof setCursorById === "function" && resolved.rawId !== entityId) {
			if (setCursorById(resolved.rawId, { preferredActiveThreadId: resolved.rawId })) {
				await this.scrollToPositionAsync(editor.state.selection.from, {
					behavior,
					block
				});
				return true;
			}
		}
		if (!await this.scrollToPositionAsync(resolved.from, {
			behavior,
			block
		})) return false;
		editor.commands?.setTextSelection?.({
			from: resolved.from,
			to: resolved.from
		});
		editor.view?.focus?.();
		return true;
	}
	#resolveTrackedChangeNavigationIds(entityId, storyKey) {
		const ids = [];
		const seen = /* @__PURE__ */ new Set();
		const add = (value) => {
			if (value === void 0 || value === null) return;
			const id = String(value).trim();
			if (!id || seen.has(id)) return;
			seen.add(id);
			ids.push(id);
		};
		add(entityId);
		let story;
		if (storyKey && storyKey !== "body") try {
			story = parseStoryKey(storyKey);
		} catch {
			story = void 0;
		}
		try {
			const resolved = resolveTrackedChangeInStory(this.#editor, {
				kind: "entity",
				entityType: "trackedChange",
				entityId,
				...story ? { story } : {}
			});
			add(resolved?.change?.commandRawId);
			add(resolved?.change?.rawId);
			add(resolved?.change?.id);
		} catch {}
		return ids;
	}
	async #activateTrackedChangeStorySurface(entityId, storyKey, preferredPageIndex) {
		let locator = null;
		try {
			locator = parseStoryKey(storyKey);
		} catch {
			return false;
		}
		if (!locator || locator.storyType === "body") return false;
		const candidate = this.#findRenderedTrackedChangeElement(entityId, storyKey, preferredPageIndex);
		if (!candidate) return false;
		const rect = candidate.getBoundingClientRect();
		const clientX = rect.left + Math.max(rect.width / 2, 1);
		const clientY = rect.top + Math.max(rect.height / 2, 1);
		const pageIndex = this.#resolveRenderedPageIndexForElement(candidate);
		if (locator.storyType === "footnote" || locator.storyType === "endnote") {
			try {
				if (!this.#activateRenderedNoteSession({
					storyType: locator.storyType,
					noteId: locator.noteId
				}, {
					clientX,
					clientY,
					pageIndex
				})) return false;
			} catch {
				return false;
			}
			return this.#waitForTrackedChangeStorySurface(storyKey);
		}
		if (locator.storyType !== "headerFooterPart") return false;
		const pageRect = candidate.closest(".superdoc-page")?.getBoundingClientRect();
		const pageLocalY = pageRect ? clientY - pageRect.top : void 0;
		const region = this.#hitTestHeaderFooterRegion(clientX, clientY, pageIndex, pageLocalY);
		if (!region) return false;
		this.#activateHeaderFooterRegion(region, {
			clientX,
			clientY,
			pageIndex,
			source: "programmatic"
		});
		return this.#waitForTrackedChangeStorySurface(storyKey);
	}
	async #waitForTrackedChangeStorySurface(storyKey, timeoutMs = 500) {
		const deadline = Date.now() + timeoutMs;
		while (Date.now() < deadline) {
			if (this.#getActiveTrackedChangeStorySurface()?.storyKey === storyKey) return true;
			await new Promise((resolve) => setTimeout(resolve, 16));
		}
		return this.#getActiveTrackedChangeStorySurface()?.storyKey === storyKey;
	}
	async #activateBookmarkStorySurface(storyKey) {
		let locator = null;
		try {
			locator = parseStoryKey(storyKey);
		} catch {
			return null;
		}
		if (!locator || locator.storyType === "body") return null;
		if (locator.storyType === "footnote" || locator.storyType === "endnote") return this.#activateBookmarkNoteStorySurface(locator);
		if (locator.storyType === "headerFooterPart" || locator.storyType === "headerFooterSlot") return this.#activateBookmarkHeaderFooterSurface(locator);
		return null;
	}
	async #activateBookmarkNoteStorySurface(locator) {
		const targetContext = this.#buildNoteLayoutContext({
			storyType: locator.storyType,
			noteId: locator.noteId
		});
		if ((this.#headerFooterSession?.session?.mode ?? "body") !== "body") this.#headerFooterSession?.exitMode();
		const firstPageIndex = targetContext?.firstPageIndex ?? 0;
		const hostWidthPx = targetContext?.hostWidthPx ?? Math.max(1, this.#visibleHost?.clientWidth ?? 1);
		this.#scrollPageIntoView(firstPageIndex);
		const totalPageCount = this.#layoutState.layout?.pages?.length ?? 1;
		const pageNumber = Math.max(1, firstPageIndex + 1);
		this.#ensureStorySessionManager().activate(locator, {
			commitPolicy: "onExit",
			preferHiddenHost: true,
			hostWidthPx,
			editorContext: {
				currentPageNumber: pageNumber,
				totalPageCount: Math.max(1, totalPageCount),
				surfaceKind: locator.storyType === "endnote" ? "endnote" : "note"
			}
		});
		const storyKey = buildStoryKey(locator);
		return await this.#waitForTrackedChangeStorySurface(storyKey) ? storyKey : null;
	}
	async #activateBookmarkHeaderFooterSurface(locator) {
		const region = this.#findHeaderFooterRegionForBookmarkLocator(locator);
		const expectedRefId = locator.storyType === "headerFooterPart" ? locator.refId : region ? this.#resolveBookmarkHeaderFooterRefId(region, locator) : null;
		if (!region || !expectedRefId) return null;
		this.#scrollPageIntoView(region.pageIndex);
		await this.#waitForPageMount(region.pageIndex, { timeout: PresentationEditor.ANCHOR_NAV_TIMEOUT_MS });
		if (!await this.#headerFooterSession?.activateRegion(region, { initialSelection: "defer" })) return null;
		return buildStoryKey({
			kind: "story",
			storyType: "headerFooterPart",
			refId: expectedRefId
		});
	}
	#resolveBookmarkHeaderFooterRefId(region, locator) {
		if (region.headerFooterRefId) return region.headerFooterRefId;
		const page = this.#layoutState.layout?.pages?.[region.pageIndex];
		if (!page) return null;
		const refCollection = locator.headerFooterKind === "header" ? page.sectionRefs?.headerRefs : page.sectionRefs?.footerRefs;
		if (!refCollection) return null;
		const normalizedRegionVariant = region.sectionType ? normalizeVariant(region.sectionType) : null;
		const candidates = [
			region.sectionType,
			normalizedRegionVariant,
			locator.variant
		].filter((variant) => typeof variant === "string" && variant.length > 0);
		for (const variant of candidates) {
			const refId = refCollection[variant];
			if (typeof refId === "string" && refId.length > 0) return refId;
		}
		return null;
	}
	#findHeaderFooterRegionForBookmarkLocator(locator) {
		const manager = this.#headerFooterSession;
		if (!manager) return null;
		const searchRegions = locator.storyType === "headerFooterSlot" ? locator.headerFooterKind === "header" ? manager.headerRegions : manager.footerRegions : new Map([...manager.headerRegions.entries(), ...manager.footerRegions.entries()]);
		for (const region of searchRegions.values()) {
			if (locator.storyType === "headerFooterPart") {
				if (region.headerFooterRefId === locator.refId) return region;
				continue;
			}
			if (region.sectionId !== locator.section.sectionId) continue;
			if (region.sectionType && normalizeVariant(region.sectionType) !== locator.variant) continue;
			return region;
		}
		if (locator.storyType === "headerFooterPart") {
			const layout = this.#layoutState.layout;
			if (!layout) return null;
			for (let pageIndex = 0; pageIndex < layout.pages.length; pageIndex += 1) {
				const page = layout.pages[pageIndex];
				if (Object.values(page.sectionRefs?.headerRefs ?? {}).includes(locator.refId)) return manager.getRegionForPage("header", pageIndex) ?? manager.findRegionForPage("header", pageIndex);
				if (Object.values(page.sectionRefs?.footerRefs ?? {}).includes(locator.refId)) return manager.getRegionForPage("footer", pageIndex) ?? manager.findRegionForPage("footer", pageIndex);
			}
		}
		return null;
	}
	#navigateToActiveStoryBookmark(name, storyKey) {
		const activeSurface = this.#getActiveTrackedChangeStorySurface();
		if (!activeSurface || activeSurface.storyKey !== storyKey) return false;
		let resolved;
		try {
			resolved = resolveBookmarkTarget(activeSurface.editor.state.doc, {
				kind: "entity",
				entityType: "bookmark",
				name
			});
		} catch {
			return false;
		}
		activeSurface.editor.commands?.setTextSelection?.({
			from: resolved.pos,
			to: resolved.pos
		});
		this.#focusAndRevealActiveStorySelection(activeSurface.editor);
		return true;
	}
	#navigateToActiveStoryTrackedChange(entityId, storyKey) {
		const activeSurface = this.#getActiveTrackedChangeStorySurface();
		if (!activeSurface || activeSurface.storyKey !== storyKey) return false;
		const sessionEditor = activeSurface.editor;
		const setCursorById = sessionEditor.commands?.setCursorById;
		if (typeof setCursorById === "function" && setCursorById(entityId, { preferredActiveThreadId: entityId })) {
			this.#focusAndRevealActiveStorySelection(sessionEditor);
			return true;
		}
		const resolved = resolveTrackedChange(sessionEditor, entityId);
		if (!resolved) return false;
		if (typeof setCursorById === "function" && resolved.rawId !== entityId) {
			if (setCursorById(resolved.rawId, { preferredActiveThreadId: resolved.rawId })) {
				this.#focusAndRevealActiveStorySelection(sessionEditor);
				return true;
			}
		}
		sessionEditor.commands?.setTextSelection?.({
			from: resolved.from,
			to: resolved.from
		});
		this.#focusAndRevealActiveStorySelection(sessionEditor);
		return true;
	}
	#focusAndRevealActiveStorySelection(editor) {
		editor.view?.focus?.();
		this.#shouldScrollSelectionIntoView = true;
		this.#scheduleSelectionUpdate({ immediate: true });
	}
	#findRenderedTrackedChangeElement(entityId, storyKey, preferredPageIndex) {
		const candidates = this.#findRenderedTrackedChangeElements(entityId, storyKey);
		if (!candidates.length) return null;
		if (!Number.isFinite(preferredPageIndex)) return candidates[0] ?? null;
		return candidates.find((candidate) => this.#resolveRenderedPageIndexForElement(candidate) === preferredPageIndex) ?? candidates[0] ?? null;
	}
	async #scrollToRenderedTrackedChange(entityId, storyKey, preferredPageIndex, options = {}) {
		const candidate = this.#findRenderedTrackedChangeElement(entityId, storyKey, preferredPageIndex);
		if (!candidate) return false;
		try {
			candidate.scrollIntoView({
				behavior: options.behavior ?? "auto",
				block: options.block ?? "center",
				inline: "nearest"
			});
			return true;
		} catch {
			return false;
		}
	}
	async goToAnchor(anchor) {
		try {
			return await goToAnchor({
				anchor,
				layout: this.#layoutState.layout,
				blocks: this.#layoutState.blocks,
				measures: this.#layoutState.measures,
				bookmarks: this.#layoutState.bookmarks,
				resolveAnchorPosition: (name) => {
					try {
						return resolveBookmarkTarget(this.#editor.state.doc, {
							kind: "entity",
							entityType: "bookmark",
							name
						}).pos;
					} catch {
						return null;
					}
				},
				pageGeometryHelper: this.#pageGeometryHelper ?? void 0,
				painterHost: this.#painterHost,
				scrollContainer: this.#scrollContainer ?? this.#visibleHost,
				zoom: this.zoom,
				scrollPageIntoView: (pageIndex) => this.#scrollPageIntoView(pageIndex),
				waitForPageMount: (pageIndex, timeoutMs) => this.#waitForPageMount(pageIndex, { timeout: timeoutMs }),
				getActiveEditor: () => this.getActiveEditor(),
				timeoutMs: PresentationEditor.ANCHOR_NAV_TIMEOUT_MS
			});
		} catch (error) {
			console.error("[PresentationEditor] goToAnchor failed:", error);
			this.emit("error", {
				error,
				context: "goToAnchor"
			});
			return false;
		}
	}
	async #waitForPageMount(pageIndex, options = {}) {
		const timeout$1 = options.timeout ?? 2e3;
		const startTime = performance.now();
		return new Promise((resolve) => {
			const checkPage = () => {
				if (this.#getPageElement(pageIndex)) {
					resolve(true);
					return;
				}
				if (performance.now() - startTime >= timeout$1) {
					resolve(false);
					return;
				}
				requestAnimationFrame(checkPage);
			};
			checkPage();
		});
	}
	#getEffectivePageGap() {
		if (this.#isSemanticFlowMode()) return 0;
		if (this.#layoutOptions.virtualization?.enabled) return Math.max(0, this.#layoutOptions.virtualization.gap ?? DEFAULT_PAGE_GAP);
		if (this.#layoutOptions.layoutMode === "horizontal") return DEFAULT_HORIZONTAL_PAGE_GAP;
		return DEFAULT_PAGE_GAP;
	}
	#getBodyPageHeight() {
		return this.#layoutState.layout?.pageSize?.h ?? this.#layoutOptions.pageSize?.h ?? DEFAULT_PAGE_SIZE.h;
	}
	#getHeaderFooterPageHeight() {
		return this.#headerFooterSession?.getPageHeight() ?? 1;
	}
	#renderCellSelectionOverlay(selection, layout) {
		const localSelectionLayer = this.#localSelectionLayer;
		if (!localSelectionLayer) return;
		renderCellSelectionOverlay({
			selection,
			layout,
			localSelectionLayer,
			blocks: this.#layoutState.blocks,
			measures: this.#layoutState.measures,
			cellAnchorTableBlockId: this.#editorInputManager?.cellAnchor?.tableBlockId ?? null,
			convertPageLocalToOverlayCoords: (pageIndex, x, y$1) => this.#convertPageLocalToOverlayCoords(pageIndex, x, y$1)
		});
	}
	#renderHoverRegion(region) {
		this.#headerFooterSession?.renderHover(region);
	}
	#clearHoverRegion() {
		this.#headerFooterSession?.clearHover();
	}
	#getHeaderFooterContext() {
		return this.#headerFooterSession?.getContext() ?? null;
	}
	#computeHeaderFooterSelectionRects(from$1, to) {
		return this.#headerFooterSession?.computeSelectionRects(from$1, to) ?? [];
	}
	#computeHeaderFooterCaretRect(pos) {
		return this.#headerFooterSession?.computeCaretRect(pos) ?? null;
	}
	#measureActiveEditorVisibleTextOffset(pos) {
		if (!Number.isFinite(pos)) return null;
		const view = this.getActiveEditor()?.view;
		const root = view?.dom;
		if (!view || !root) return null;
		try {
			const domPoint = view.domAtPos(pos);
			if (!domPoint?.node) return null;
			return measureVisibleTextOffset(root, domPoint.node, domPoint.offset);
		} catch (error) {
			if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] Failed to measure active editor visible text offset:", error);
			return null;
		}
	}
	#computeNoteSelectionRectsFromDom(context, from$1, to) {
		const layout = this.#layoutState.layout;
		if (!layout) return null;
		const startOffset = this.#measureActiveEditorVisibleTextOffset(Math.min(from$1, to));
		const endOffset = this.#measureActiveEditorVisibleTextOffset(Math.max(from$1, to));
		if (startOffset == null || endOffset == null) return null;
		const noteFragments = this.#getRenderedNoteFragmentElements(this.#collectNoteBlockIds(context));
		if (!noteFragments.length) return null;
		const renderedStartOffset = this.#toRenderedNoteVisibleTextOffset(noteFragments, startOffset);
		const renderedEndOffset = this.#toRenderedNoteVisibleTextOffset(noteFragments, endOffset);
		return computeSelectionRectsFromVisibleTextOffsets({
			containers: noteFragments,
			zoom: this.#layoutOptions.zoom ?? 1,
			pageHeight: this.#getBodyPageHeight(),
			pageGap: layout.pageGap ?? this.#getEffectivePageGap()
		}, renderedStartOffset, renderedEndOffset);
	}
	#computeNoteSelectionRects(from$1, to) {
		const context = this.#buildActiveNoteLayoutContext();
		const layout = this.#layoutState.layout;
		if (!context || !layout) return null;
		const domRects = this.#computeNoteSelectionRectsFromDom(context, from$1, to);
		if (domRects != null) return domRects;
		return selectionToRects(layout, context.blocks, context.measures, from$1, to, this.#pageGeometryHelper ?? void 0);
	}
	#computeNoteDomCaretRect(context, pos) {
		const layout = this.#layoutState.layout;
		if (!layout) return null;
		const noteBlockIds = this.#collectNoteBlockIds(context);
		if (noteBlockIds.size === 0) return null;
		const textOffset = this.#measureActiveEditorVisibleTextOffset(pos);
		if (textOffset == null) return null;
		const noteFragments = this.#getRenderedNoteFragmentElements(noteBlockIds);
		if (!noteFragments.length) return null;
		const renderedTextOffset = this.#toRenderedNoteVisibleTextOffset(noteFragments, textOffset);
		return computeCaretRectFromVisibleTextOffset({
			containers: noteFragments,
			zoom: this.#layoutOptions.zoom ?? 1,
			pageHeight: this.#getBodyPageHeight(),
			pageGap: layout.pageGap ?? this.#getEffectivePageGap()
		}, renderedTextOffset);
	}
	#computeNoteCaretRect(pos) {
		const context = this.#buildActiveNoteLayoutContext();
		const layout = this.#layoutState.layout;
		if (!context || !layout) return null;
		const domRect = this.#computeNoteDomCaretRect(context, pos);
		if (domRect) return domRect;
		const geometry = computeCaretLayoutRectGeometry({
			layout,
			blocks: context.blocks,
			measures: context.measures,
			painterHost: this.#painterHost,
			viewportHost: this.#viewportHost,
			visibleHost: this.#visibleHost,
			zoom: this.#layoutOptions.zoom ?? 1
		}, pos, false);
		if (!geometry) return null;
		const pageStride = this.#getBodyPageHeight() + (layout.pageGap ?? 0);
		return {
			pageIndex: geometry.pageIndex,
			x: geometry.x,
			y: geometry.pageIndex * pageStride + geometry.y,
			width: 1,
			height: geometry.height
		};
	}
	#syncTrackedChangesPreferences() {
		const mode = this.#deriveTrackedChangesMode();
		const enabled = this.#deriveTrackedChangesEnabled();
		const hasChanged = mode !== this.#trackedChangesMode || enabled !== this.#trackedChangesEnabled;
		if (hasChanged) {
			this.#trackedChangesMode = mode;
			this.#trackedChangesEnabled = enabled;
		}
		return hasChanged;
	}
	#syncHeaderFooterTrackedChangesRenderConfig() {
		this.#headerFooterSession?.setTrackedChangesRenderConfig({
			mode: this.#trackedChangesMode,
			enabled: this.#trackedChangesEnabled
		});
	}
	#deriveTrackedChangesMode() {
		const overrideMode = this.#trackedChangesOverrides?.mode;
		if (overrideMode) return overrideMode;
		const pluginState = this.#getTrackChangesPluginState();
		if (pluginState?.onlyOriginalShown) return "original";
		if (pluginState?.onlyModifiedShown) return "final";
		if (this.#documentMode === "viewing") return "final";
		return "review";
	}
	#deriveTrackedChangesEnabled() {
		if (typeof this.#trackedChangesOverrides?.enabled === "boolean") return this.#trackedChangesOverrides.enabled;
		return true;
	}
	#getTrackChangesPluginState() {
		const state = this.#editor?.state;
		if (!state) return null;
		try {
			return TrackChangesBasePluginKey.getState(state) ?? null;
		} catch (error) {
			if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] Failed to get track changes plugin state:", error);
			return null;
		}
	}
	#computeDefaultLayoutDefaults() {
		const pageStyles$1 = (this.#editor?.converter)?.pageStyles ?? {};
		const size$1 = pageStyles$1.pageSize ?? {};
		const pageMargins = pageStyles$1.pageMargins ?? {};
		return {
			pageSize: {
				w: inchesToPx(size$1.width) ?? DEFAULT_PAGE_SIZE.w,
				h: inchesToPx(size$1.height) ?? DEFAULT_PAGE_SIZE.h
			},
			margins: {
				top: inchesToPx(pageMargins.top) ?? DEFAULT_MARGINS.top,
				right: inchesToPx(pageMargins.right) ?? DEFAULT_MARGINS.right,
				bottom: inchesToPx(pageMargins.bottom) ?? DEFAULT_MARGINS.bottom,
				left: inchesToPx(pageMargins.left) ?? DEFAULT_MARGINS.left,
				...inchesToPx(pageMargins.header) != null ? { header: inchesToPx(pageMargins.header) } : {},
				...inchesToPx(pageMargins.footer) != null ? { footer: inchesToPx(pageMargins.footer) } : {}
			},
			columns: parseColumns(pageStyles$1.columns)
		};
	}
	#applyZoom() {
		if (this.#isSemanticFlowMode()) {
			const zoom$1 = this.#layoutOptions.zoom ?? 1;
			this.#viewportHost.style.minWidth = "";
			this.#viewportHost.style.minHeight = "";
			if (zoom$1 === 1) {
				this.#viewportHost.style.width = "100%";
				this.#viewportHost.style.transform = "";
				this.#painterHost.style.width = "100%";
				this.#painterHost.style.minHeight = "";
				this.#painterHost.style.transformOrigin = "";
				this.#painterHost.style.transform = "";
				this.#selectionOverlay.style.width = "100%";
				this.#selectionOverlay.style.height = "100%";
				this.#selectionOverlay.style.transformOrigin = "";
				this.#selectionOverlay.style.transform = "";
			} else {
				this.#viewportHost.style.width = `${100 / zoom$1}%`;
				this.#viewportHost.style.transform = "";
				this.#painterHost.style.width = "100%";
				this.#painterHost.style.minHeight = "";
				this.#painterHost.style.transformOrigin = "top left";
				this.#painterHost.style.transform = `scale(${zoom$1})`;
				this.#selectionOverlay.style.width = "100%";
				this.#selectionOverlay.style.height = "100%";
				this.#selectionOverlay.style.transformOrigin = "top left";
				this.#selectionOverlay.style.transform = `scale(${zoom$1})`;
			}
			return;
		}
		const zoom = this.#layoutOptions.zoom ?? 1;
		const layoutMode = this.#layoutOptions.layoutMode ?? "vertical";
		const pages = this.#layoutState.layout?.pages;
		const pageGap = this.#getEffectivePageGap();
		const defaultWidth = this.#layoutOptions.pageSize?.w ?? DEFAULT_PAGE_SIZE.w;
		const defaultHeight = this.#layoutOptions.pageSize?.h ?? DEFAULT_PAGE_SIZE.h;
		let maxWidth = defaultWidth;
		let maxHeight = defaultHeight;
		let totalWidth = 0;
		let totalHeight = 0;
		if (Array.isArray(pages) && pages.length > 0) pages.forEach((page, index) => {
			const pageWidth = page.size && typeof page.size.w === "number" && page.size.w > 0 ? page.size.w : defaultWidth;
			const pageHeight = page.size && typeof page.size.h === "number" && page.size.h > 0 ? page.size.h : defaultHeight;
			maxWidth = Math.max(maxWidth, pageWidth);
			maxHeight = Math.max(maxHeight, pageHeight);
			totalWidth += pageWidth;
			totalHeight += pageHeight;
			if (index < pages.length - 1) {
				totalWidth += pageGap;
				totalHeight += pageGap;
			}
		});
		else {
			totalWidth = defaultWidth;
			totalHeight = defaultHeight;
		}
		if (layoutMode === "horizontal") {
			const scaledWidth$1 = totalWidth * zoom;
			const scaledHeight$1 = maxHeight * zoom;
			this.#viewportHost.style.width = `${scaledWidth$1}px`;
			this.#viewportHost.style.minWidth = `${scaledWidth$1}px`;
			this.#viewportHost.style.minHeight = `${scaledHeight$1}px`;
			this.#viewportHost.style.height = "";
			this.#viewportHost.style.overflow = "";
			this.#viewportHost.style.transform = "";
			this.#painterHost.style.width = `${totalWidth}px`;
			this.#painterHost.style.minHeight = `${maxHeight}px`;
			this.#painterHost.style.marginBottom = zoom !== 1 ? `${maxHeight * zoom - maxHeight}px` : "";
			this.#painterHost.style.transformOrigin = "top left";
			this.#painterHost.style.transform = zoom === 1 ? "" : `scale(${zoom})`;
			this.#selectionOverlay.style.width = `${totalWidth}px`;
			this.#selectionOverlay.style.height = `${maxHeight}px`;
			this.#selectionOverlay.style.transformOrigin = "top left";
			this.#selectionOverlay.style.transform = zoom === 1 ? "" : `scale(${zoom})`;
			return;
		}
		const scaledWidth = maxWidth * zoom;
		const scaledHeight = totalHeight * zoom;
		this.#viewportHost.style.width = `${scaledWidth}px`;
		this.#viewportHost.style.minWidth = `${scaledWidth}px`;
		this.#viewportHost.style.minHeight = `${scaledHeight}px`;
		this.#viewportHost.style.height = "";
		this.#viewportHost.style.overflow = "";
		this.#viewportHost.style.transform = "";
		this.#painterHost.style.width = `${maxWidth}px`;
		this.#painterHost.style.minHeight = `${totalHeight}px`;
		this.#painterHost.style.marginBottom = zoom !== 1 ? `${totalHeight * zoom - totalHeight}px` : "";
		this.#painterHost.style.transformOrigin = "top left";
		this.#painterHost.style.transform = zoom === 1 ? "" : `scale(${zoom})`;
		this.#selectionOverlay.style.width = `${maxWidth}px`;
		this.#selectionOverlay.style.height = `${totalHeight}px`;
		this.#selectionOverlay.style.transformOrigin = "top left";
		this.#selectionOverlay.style.transform = zoom === 1 ? "" : `scale(${zoom})`;
	}
	#getPageOffsetX(pageIndex) {
		return getPageOffsetX({
			painterHost: this.#painterHost,
			viewportHost: this.#viewportHost,
			zoom: this.#layoutOptions.zoom ?? 1,
			pageIndex
		});
	}
	#getPageOffsetY(pageIndex) {
		return getPageOffsetY({
			painterHost: this.#painterHost,
			viewportHost: this.#viewportHost,
			zoom: this.#layoutOptions.zoom ?? 1,
			pageIndex
		});
	}
	#convertPageLocalToOverlayCoords(pageIndex, pageLocalX, pageLocalY) {
		const pageHeight = this.#layoutOptions.pageSize?.h ?? DEFAULT_PAGE_SIZE.h;
		const pageGap = this.#layoutState.layout?.pageGap ?? 0;
		return convertPageLocalToOverlayCoords({
			painterHost: this.#painterHost,
			viewportHost: this.#viewportHost,
			zoom: this.#layoutOptions.zoom ?? 1,
			pageIndex,
			pageLocalX,
			pageLocalY,
			pageHeight,
			pageGap
		});
	}
	#computeSelectionRectsFromDom(from$1, to) {
		const layout = this.#layoutState.layout;
		if (!layout) return null;
		return computeSelectionRectsFromDom({
			painterHost: this.#painterHost,
			layout,
			domPositionIndex: this.#domPositionIndex,
			rebuildDomPositionIndex: () => this.#rebuildDomPositionIndex(),
			zoom: this.#layoutOptions.zoom ?? 1,
			pageHeight: this.#getBodyPageHeight(),
			pageGap: layout.pageGap ?? this.#getEffectivePageGap()
		}, from$1, to);
	}
	#computeDomCaretPageLocal(pos) {
		return computeDomCaretPageLocal({
			painterHost: this.#painterHost,
			domPositionIndex: this.#domPositionIndex,
			rebuildDomPositionIndex: () => this.#rebuildDomPositionIndex(),
			zoom: this.#layoutOptions.zoom ?? 1
		}, pos);
	}
	#normalizeClientPoint(clientX, clientY) {
		return normalizeClientPoint({
			viewportHost: this.#viewportHost,
			visibleHost: this.#visibleHost,
			zoom: this.#layoutOptions.zoom ?? 1,
			getPageOffsetX: (pageIndex) => this.#getPageOffsetX(pageIndex),
			getPageOffsetY: (pageIndex) => this.#getPageOffsetY(pageIndex)
		}, clientX, clientY);
	}
	denormalizeClientPoint(layoutX, layoutY, pageIndex, height) {
		return denormalizeClientPoint({
			viewportHost: this.#viewportHost,
			visibleHost: this.#visibleHost,
			zoom: this.#layoutOptions.zoom ?? 1,
			getPageOffsetX: (pageIndex$1) => this.#getPageOffsetX(pageIndex$1),
			getPageOffsetY: (pageIndex$1) => this.#getPageOffsetY(pageIndex$1)
		}, layoutX, layoutY, pageIndex, height);
	}
	#computeCaretLayoutRectGeometry(pos, includeDomFallback = true) {
		return computeCaretLayoutRectGeometry({
			layout: this.#layoutState.layout,
			blocks: this.#layoutState.blocks,
			measures: this.#layoutState.measures,
			painterHost: this.#painterHost,
			viewportHost: this.#viewportHost,
			visibleHost: this.#visibleHost,
			zoom: this.#layoutOptions.zoom ?? 1
		}, pos, includeDomFallback);
	}
	#computeCaretLayoutRect(pos) {
		const useNativeFallback = shouldUseNativeCaretFallback(this.editor?.state?.selection, pos);
		const geometry = this.#computeCaretLayoutRectGeometry(pos, useNativeFallback);
		let dom = null;
		try {
			dom = this.#computeDomCaretPageLocal(pos);
		} catch (error) {
			if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] DOM caret computation failed in #computeCaretLayoutRect:", error);
		}
		if (dom && geometry) return {
			pageIndex: dom.pageIndex,
			x: dom.x,
			y: dom.y,
			height: geometry.height
		};
		return geometry;
	}
	computeCaretLayoutRect(pos) {
		return this.#computeCaretLayoutRect(pos);
	}
	#getCurrentPageIndex() {
		const session = this.#headerFooterSession?.session;
		if (session && session.mode !== "body") return session.pageIndex ?? 0;
		if (this.#getActiveNoteStorySession()) {
			const selection$1 = this.getActiveEditor().state?.selection;
			if (!selection$1) return this.#buildActiveNoteLayoutContext()?.firstPageIndex ?? 0;
			const rects$1 = this.#computeNoteSelectionRects(selection$1.from, selection$1.to) ?? [];
			if (rects$1.length > 0) return rects$1[0]?.pageIndex ?? 0;
			return this.#computeNoteCaretRect(selection$1.from)?.pageIndex ?? this.#buildActiveNoteLayoutContext()?.firstPageIndex ?? 0;
		}
		const layout = this.#layoutState.layout;
		const selection = this.#editor.state?.selection;
		if (!layout || !selection) return 0;
		const rects = selectionToRects(layout, this.#layoutState.blocks, this.#layoutState.measures, selection.from, selection.to, this.#pageGeometryHelper ?? void 0) ?? [];
		if (rects.length > 0) return rects[0]?.pageIndex ?? 0;
		const pos = selection.from;
		for (let pageIdx = 0; pageIdx < layout.pages.length; pageIdx++) {
			const page = layout.pages[pageIdx];
			for (const fragment of page.fragments) {
				const frag = fragment;
				if (frag.pmStart != null && frag.pmEnd != null) {
					if (pos >= frag.pmStart && pos <= frag.pmEnd) return pageIdx;
				}
			}
		}
		return 0;
	}
	#findRegionForPage(kind, pageIndex) {
		return this.#headerFooterSession?.findRegionForPage(kind, pageIndex) ?? null;
	}
	#handleLayoutError(phase, error) {
		console.error("[PresentationEditor] Layout error", error);
		this.#layoutError = {
			phase,
			error,
			timestamp: Date.now()
		};
		if (phase === "initialization") this.#layoutErrorState = "failed";
		else this.#layoutErrorState = this.#layoutState.layout ? "degraded" : "failed";
		this.emit("layoutError", this.#layoutError);
		this.#showLayoutErrorBanner(error);
	}
	#decorateError(error, stage) {
		if (error instanceof Error) {
			error.message = `[${stage}] ${error.message}`;
			return error;
		}
		return /* @__PURE__ */ new Error(`[${stage}] ${String(error)}`);
	}
	#showLayoutErrorBanner(error) {
		const doc$1 = this.#visibleHost.ownerDocument ?? document;
		if (!this.#errorBanner) {
			const banner = doc$1.createElement("div");
			banner.className = "presentation-editor__layout-error";
			banner.style.display = "flex";
			banner.style.alignItems = "center";
			banner.style.justifyContent = "space-between";
			banner.style.gap = "8px";
			banner.style.padding = "8px 12px";
			banner.style.background = "#FFF6E5";
			banner.style.border = "1px solid #F5B971";
			banner.style.borderRadius = "6px";
			banner.style.marginBottom = "8px";
			const message = doc$1.createElement("span");
			banner.appendChild(message);
			const retry = doc$1.createElement("button");
			retry.type = "button";
			retry.textContent = "Reload layout";
			retry.style.border = "none";
			retry.style.borderRadius = "4px";
			retry.style.background = "#F5B971";
			retry.style.color = "#3F2D00";
			retry.style.padding = "6px 10px";
			retry.style.cursor = "pointer";
			retry.addEventListener("click", () => {
				this.#layoutError = null;
				this.#dismissErrorBanner();
				this.#pendingDocChange = true;
				this.#scheduleRerender();
			});
			banner.appendChild(retry);
			this.#visibleHost.prepend(banner);
			this.#errorBanner = banner;
			this.#errorBannerMessage = message;
		}
		if (this.#errorBannerMessage) {
			this.#errorBannerMessage.textContent = "Layout engine hit an error. Your document is safe — try reloading layout.";
			if (this.#layoutOptions.debugLabel) this.#errorBannerMessage.textContent += ` (${this.#layoutOptions.debugLabel}: ${error.message})`;
		}
	}
	#updateHeaderFooterSelection(shouldScrollIntoView = false) {
		this.#clearSelectedFieldAnnotationClass();
		if (!this.#localSelectionLayer) return;
		const activeEditor = this.getActiveEditor();
		const selection = activeEditor?.state?.selection;
		if (!selection) {
			try {
				this.#localSelectionLayer.innerHTML = "";
			} catch {}
			return;
		}
		const { from: from$1, to } = selection;
		if (from$1 === to) {
			const caretRect = this.#computeHeaderFooterCaretRect(from$1);
			if (!caretRect) {
				try {
					this.#localSelectionLayer.innerHTML = "";
				} catch {}
				return;
			}
			try {
				this.#localSelectionLayer.innerHTML = "";
				renderCaretOverlay({
					localSelectionLayer: this.#localSelectionLayer,
					caretLayout: {
						pageIndex: caretRect.pageIndex,
						x: caretRect.x,
						y: caretRect.y - caretRect.pageIndex * this.#getBodyPageHeight(),
						height: caretRect.height
					},
					convertPageLocalToOverlayCoords: (pageIndex, x, y$1) => this.#convertPageLocalToOverlayCoords(pageIndex, x, y$1)
				});
			} catch (error) {
				if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] Failed to render header/footer caret:", error);
			}
			if (shouldScrollIntoView) this.#scrollActiveEndIntoView(caretRect.pageIndex);
			return;
		}
		const rects = this.#computeHeaderFooterSelectionRects(from$1, to);
		if (!rects.length) return;
		const pageHeight = this.#getBodyPageHeight();
		const pageGap = 0;
		try {
			this.#localSelectionLayer.innerHTML = "";
			renderSelectionRects({
				localSelectionLayer: this.#localSelectionLayer,
				rects,
				pageHeight,
				pageGap,
				convertPageLocalToOverlayCoords: (pageIndex, x, y$1) => this.#convertPageLocalToOverlayCoords(pageIndex, x, y$1)
			});
		} catch (error) {
			if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] Failed to render header/footer selection rects:", error);
		}
		if (shouldScrollIntoView) {
			const selectionHead = activeEditor?.state?.selection?.head ?? to;
			const headPageIndex = this.#computeHeaderFooterCaretRect(selectionHead)?.pageIndex ?? rects.at(-1)?.pageIndex ?? rects[0]?.pageIndex;
			if (Number.isFinite(headPageIndex)) this.#scrollActiveEndIntoView(headPageIndex);
		}
	}
	#updateNoteSelection(shouldScrollIntoView = false) {
		this.#clearSelectedFieldAnnotationClass();
		if (!this.#localSelectionLayer) return;
		const activeEditor = this.getActiveEditor();
		const selection = activeEditor?.state?.selection;
		if (!selection) {
			try {
				this.#localSelectionLayer.innerHTML = "";
			} catch {}
			return;
		}
		const { from: from$1, to } = selection;
		if (from$1 === to) {
			const caretRect = this.#computeNoteCaretRect(from$1);
			if (!caretRect) return;
			try {
				this.#localSelectionLayer.innerHTML = "";
				renderCaretOverlay({
					localSelectionLayer: this.#localSelectionLayer,
					caretLayout: {
						pageIndex: caretRect.pageIndex,
						x: caretRect.x,
						y: caretRect.y - caretRect.pageIndex * (this.#getBodyPageHeight() + (this.#layoutState.layout?.pageGap ?? 0)),
						height: caretRect.height
					},
					convertPageLocalToOverlayCoords: (pageIndex, x, y$1) => this.#convertPageLocalToOverlayCoords(pageIndex, x, y$1)
				});
			} catch (error) {
				if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] Failed to render note caret:", error);
			}
			if (shouldScrollIntoView) this.#scrollActiveEndIntoView(caretRect.pageIndex);
			return;
		}
		const rects = this.#computeNoteSelectionRects(from$1, to);
		if (rects == null || !rects.length) return;
		try {
			this.#localSelectionLayer.innerHTML = "";
			renderSelectionRects({
				localSelectionLayer: this.#localSelectionLayer,
				rects,
				pageHeight: this.#getBodyPageHeight(),
				pageGap: this.#layoutState.layout?.pageGap ?? 0,
				convertPageLocalToOverlayCoords: (pageIndex, x, y$1) => this.#convertPageLocalToOverlayCoords(pageIndex, x, y$1)
			});
		} catch (error) {
			if (process$1.env.NODE_ENV === "development") console.warn("[PresentationEditor] Failed to render note selection rects:", error);
		}
		if (shouldScrollIntoView) {
			const selectionHead = activeEditor?.state?.selection?.head ?? to;
			const headPageIndex = this.#computeNoteCaretRect(selectionHead)?.pageIndex ?? rects.at(-1)?.pageIndex ?? rects[0]?.pageIndex;
			if (Number.isFinite(headPageIndex)) this.#scrollActiveEndIntoView(headPageIndex);
		}
	}
	#dismissErrorBanner() {
		this.#errorBanner?.remove();
		this.#errorBanner = null;
		this.#errorBannerMessage = null;
	}
	#isViewLocked() {
		const protectionStorage = this.#editor?.storage?.protection;
		if (protectionStorage?.initialized === true && protectionStorage?.state?.editingRestriction?.runtimeEnforced === true) return !!!this.#editor?.storage?.permissionRanges?.hasAllowedRanges;
		if (this.#documentMode !== "viewing") return false;
		if (!!this.#editor?.storage?.permissionRanges?.hasAllowedRanges) return false;
		return this.#documentMode === "viewing";
	}
};
function escapeAttrValue(value) {
	const cssApi = typeof globalThis === "object" && globalThis && "CSS" in globalThis ? globalThis.CSS : void 0;
	if (typeof cssApi?.escape === "function") return cssApi.escape(value);
	return value.replace(/["\\]/g, (char) => `\\${char}`);
}
function resolveStoryKeyFromAddress(story) {
	if (!isStoryLocator(story)) return;
	try {
		return buildStoryKey(story);
	} catch {
		return;
	}
}
const onMarginClickCursorChange = (event, editor) => {
	const y$1 = event.clientY;
	const x = event.clientX;
	const { view } = editor;
	const editorRect = view.dom.getBoundingClientRect();
	let coords = {
		left: 0,
		top: y$1
	};
	let isRightMargin = false;
	if (x > editorRect.right) {
		coords.left = editorRect.left + editorRect.width - 1;
		isRightMargin = true;
	} else if (x < editorRect.left) coords.left = editorRect.left;
	const pos = view.posAtCoords(coords)?.pos;
	if (pos) {
		let cursorPos = pos;
		if (isRightMargin) {
			const charOffset = view.state.doc.resolve(pos).textOffset;
			const node = view.state.doc.nodeAt(pos);
			const charAtPos = (node?.text)?.charAt(charOffset);
			cursorPos = node?.isText && charAtPos !== " " ? pos - 1 : pos;
		}
		const transaction = view.state.tr.setSelection(TextSelection.create(view.state.doc, cursorPos));
		view.dispatch(transaction);
		view.focus();
	}
};
const checkNodeSpecificClicks = (editor, event, popoverControls) => {
	if (!editor) return;
	const state = editor.state;
	if (!state) return;
	const surface = getEditorSurfaceElement(editor);
	if (!surface) return;
	if (selectionHasNodeOrMark(state, "link", { requireEnds: true })) {
		popoverControls.component = LinkInput_default;
		const surfaceRect = surface.getBoundingClientRect();
		if (!surfaceRect) return;
		popoverControls.position = {
			left: `${event.clientX - surfaceRect.left}px`,
			top: `${event.clientY - surfaceRect.top + 15}px`
		};
		popoverControls.props = { showInput: true };
		popoverControls.visible = true;
	}
};
function selectionHasNodeOrMark(state, name, options = {}) {
	const { requireEnds = false } = options;
	const $from = state.selection.$from;
	const $to = state.selection.$to;
	if (requireEnds) {
		for (let d = $from.depth; d > 0; d--) if ($from.node(d).type.name === name) return true;
		for (let d = $to.depth; d > 0; d--) if ($to.node(d).type.name === name) return true;
	} else for (let d = $from.depth; d > 0; d--) if ($from.node(d).type.name === name) return true;
	const markType = state.schema.marks[name];
	if (markType) {
		const { from: from$1, to, empty: empty$1 } = state.selection;
		if (requireEnds) {
			const fromMarks = markType.isInSet($from.marks());
			const toMarks = markType.isInSet($to.marks());
			if (fromMarks || toMarks) return true;
			if (empty$1 && markType.isInSet(state.storedMarks || $from.marks())) return true;
		} else if (empty$1) {
			if (markType.isInSet(state.storedMarks || $from.marks())) return true;
		} else {
			let hasMark = false;
			state.doc.nodesBetween(from$1, to, (node) => {
				if (markType.isInSet(node.marks)) {
					hasMark = true;
					return false;
				}
			});
			if (hasMark) return true;
		}
	}
	return false;
}
function moveCursorToMouseEvent(event, editor) {
	if (!editor) return;
	const state = editor.state;
	if (!state) return;
	const coords = {
		left: event.clientX,
		top: event.clientY
	};
	const result = editor.posAtCoords?.(coords);
	if (typeof result?.pos === "number") {
		const tr = state.tr.setSelection(TextSelection.create(state.doc, result.pos));
		if (typeof editor.dispatch === "function") editor.dispatch(tr);
		editor.focus?.();
	}
}
const ICONS = {
	addRowBefore: plus_solid_default,
	addRowAfter: plus_solid_default,
	addColumnBefore: plus_solid_default,
	addColumnAfter: plus_solid_default,
	deleteRow: trash_can_solid_default,
	deleteColumn: trash_can_solid_default,
	deleteTable: trash_can_solid_default,
	deleteBorders: border_none_solid_default,
	mergeCells: arrows_to_dot_solid_default,
	splitCell: arrows_left_right_solid_default,
	fixTables: wrench_solid_default,
	ai: magic_wand_solid_default,
	link: link_solid_default,
	table: table_solid_default,
	cut: scissors_solid_default,
	copy: copy_solid_default,
	paste: paste_solid_default,
	addDocumentSection: plus_solid_default,
	removeDocumentSection: trash_can_solid_default,
	trackChangesAccept: check_solid_default,
	trackChangesReject: xmark_solid_default,
	cellBackground: paint_roller_solid_default,
	updateTableOfContents: rotate_right_solid_default,
	listRestartNumbering: list_ol_solid_default,
	listContinueNumbering: list_ol_solid_default,
	listDecreaseIndent: outdent_solid_default,
	listIncreaseIndent: indent_solid_default
};
const TEXTS = {
	addRowBefore: "Insert row above",
	addRowAfter: "Insert row below",
	addColumnBefore: "Insert column left",
	addColumnAfter: "Insert column right",
	deleteRow: "Delete row",
	deleteColumn: "Delete column",
	deleteTable: "Delete table",
	removeBorders: "Remove borders",
	mergeCells: "Merge cells",
	splitCell: "Split cell",
	fixTables: "Fix tables",
	insertText: "Insert text",
	replaceText: "Replace text",
	insertLink: "Insert link",
	insertTable: "Insert table",
	editTable: "Edit table",
	cut: "Cut",
	copy: "Copy",
	paste: "Paste",
	removeDocumentSection: "Remove section",
	createDocumentSection: "Create section",
	trackChangesAccept: "Accept change",
	trackChangesReject: "Reject change",
	cellBackground: "Cell background",
	updateTableOfContents: "Update table of contents",
	listRestartNumbering: "Restart numbering",
	listContinueNumbering: "Continue numbering",
	listDecreaseIndent: "Decrease indent",
	listIncreaseIndent: "Increase indent"
};
const tableActionsOptions = [
	{
		label: TEXTS.addRowBefore,
		command: "addRowBefore",
		icon: ICONS.addRowBefore,
		props: {
			"data-item": "btn-tableActions-option",
			ariaLabel: "Add row before"
		}
	},
	{
		label: TEXTS.addRowAfter,
		command: "addRowAfter",
		icon: ICONS.addRowAfter,
		props: {
			"data-item": "btn-tableActions-option",
			ariaLabel: "Add row after"
		}
	},
	{
		label: TEXTS.addColumnBefore,
		command: "addColumnBefore",
		icon: ICONS.addColumnBefore,
		props: {
			"data-item": "btn-tableActions-option",
			ariaLabel: "Add column before"
		}
	},
	{
		label: TEXTS.addColumnAfter,
		command: "addColumnAfter",
		icon: ICONS.addColumnAfter,
		bottomBorder: true,
		props: {
			"data-item": "btn-tableActions-option",
			ariaLabel: "Add column after"
		}
	},
	{
		label: TEXTS.deleteRow,
		command: "deleteRow",
		icon: ICONS.deleteRow,
		props: {
			"data-item": "btn-tableActions-option",
			ariaLabel: "Delete row"
		}
	},
	{
		label: TEXTS.deleteColumn,
		command: "deleteColumn",
		icon: ICONS.deleteColumn,
		props: {
			"data-item": "btn-tableActions-option",
			ariaLabel: "Delete column"
		}
	},
	{
		label: TEXTS.deleteTable,
		command: "deleteTable",
		icon: ICONS.deleteTable,
		props: {
			"data-item": "btn-tableActions-option",
			ariaLabel: "Delete table"
		}
	},
	{
		label: TEXTS.removeBorders,
		command: "deleteCellAndTableBorders",
		icon: ICONS.deleteBorders,
		bottomBorder: true,
		props: {
			"data-item": "btn-tableActions-option",
			ariaLabel: "Delete cell and table borders"
		}
	},
	{
		label: TEXTS.mergeCells,
		command: "mergeCells",
		icon: ICONS.mergeCells,
		props: {
			"data-item": "btn-tableActions-option",
			ariaLabel: "Merge cells"
		}
	},
	{
		label: TEXTS.splitCell,
		command: "splitCell",
		icon: ICONS.splitCell,
		props: {
			"data-item": "btn-tableActions-option",
			ariaLabel: "Split cells"
		}
	},
	{
		label: TEXTS.fixTables,
		command: "fixTables",
		icon: ICONS.fixTables,
		props: {
			"data-item": "btn-tableActions-option",
			ariaLabel: "Fix tables"
		}
	}
];
const TRIGGERS = {
	slash: "slash",
	click: "click"
};
function findTocAncestor(doc$1, pos) {
	if (!doc$1 || typeof pos !== "number" || !Number.isFinite(pos)) return null;
	let resolved;
	try {
		resolved = doc$1.resolve(pos);
	} catch {
		return null;
	}
	const found = findParentNodeClosestToPos(resolved, (n) => n.type.name === "tableOfContents");
	if (!found) return null;
	const sdBlockId = typeof found.node.attrs?.sdBlockId === "string" ? found.node.attrs.sdBlockId : null;
	return {
		node: found.node,
		pos: found.pos,
		sdBlockId
	};
}
const resolveContextMenuCommandEditor = (editor) => {
	return typeof editor?.getActiveEditor === "function" ? editor.getActiveEditor() : editor;
};
var TRACKED_MARK_NAMES = new Set([
	"trackInsert",
	"trackDelete",
	"trackFormat"
]);
var TRACKED_MARK_PRIORITY = {
	trackDelete: 3,
	trackFormat: 2,
	trackInsert: 1
};
function isTrackedChangeMark(mark) {
	return Boolean(mark?.type?.name && TRACKED_MARK_NAMES.has(mark.type.name));
}
function choosePreferredTrackedChangeId(marks) {
	const candidates = [];
	const seen = /* @__PURE__ */ new Set();
	marks.forEach((mark, index) => {
		if (!isTrackedChangeMark(mark)) return;
		const id = typeof mark.attrs?.id === "string" ? mark.attrs.id : "";
		if (!id) return;
		const key = `${mark.type.name}:${id}`;
		if (seen.has(key)) return;
		seen.add(key);
		candidates.push({
			id,
			markType: mark.type.name,
			isChildOverlap: Boolean(mark.attrs?.overlapParentId),
			index
		});
	});
	candidates.sort((a, b$1) => {
		if (a.isChildOverlap !== b$1.isChildOverlap) return a.isChildOverlap ? -1 : 1;
		const priorityDelta = (TRACKED_MARK_PRIORITY[b$1.markType] ?? 0) - (TRACKED_MARK_PRIORITY[a.markType] ?? 0);
		if (priorityDelta !== 0) return priorityDelta;
		return a.index - b$1.index;
	});
	return candidates[0]?.id ?? null;
}
const getPropsByItemId = (itemId, props) => {
	const editor = resolveContextMenuCommandEditor(props.editor);
	const baseProps = { editor: markRaw(editor) };
	switch (itemId) {
		case "insert-text":
			const { state } = editor.view;
			const { from: from$1, to, empty: empty$1 } = state.selection;
			const selectedText = !empty$1 ? state.doc.textBetween(from$1, to) : "";
			return {
				...baseProps,
				selectedText,
				handleClose: props.closePopover || (() => null),
				apiKey: editor.options?.aiApiKey,
				endpoint: editor.options?.aiEndpoint
			};
		case "insert-link": return baseProps;
		case "insert-table": return {
			...baseProps,
			onSelect: ({ rows, cols }) => {
				editor.commands.insertTable({
					rows,
					cols
				});
				props.closePopover();
			}
		};
		case "edit-table": return {
			...baseProps,
			options: tableActionsOptions,
			onSelect: ({ command: command$1 }) => {
				if (editor.commands[command$1]) editor.commands[command$1]();
				props.closePopover();
			}
		};
		case "copy":
		case "paste": return { ...baseProps };
		default: return baseProps;
	}
};
async function getEditorContext(editor, event) {
	if (!editor) return null;
	const state = editor.state;
	if (!state) return null;
	const { from: from$1 } = state.selection;
	let pos = null;
	let node = null;
	if (event && typeof event.clientX === "number" && typeof event.clientY === "number") {
		const coords = {
			left: event.clientX,
			top: event.clientY
		};
		const hit = editor.posAtCoords?.(coords);
		if (typeof hit?.pos === "number") {
			pos = hit.pos;
			node = state.doc.nodeAt(pos);
		}
	}
	if (pos === null && typeof from$1 === "number") {
		pos = from$1;
		node = state.doc.nodeAt(pos);
	}
	const selection = getContextSelection({
		editor,
		state,
		pos,
		event
	});
	const hasSelection = hasExpandedSelection(selection);
	const selectedText = hasSelection ? state.doc.textBetween(selection.from, selection.to) : "";
	const clipboardContent = {
		html: null,
		text: null,
		hasContent: true,
		raw: null
	};
	const structureFromResolvedPos = pos !== null ? getStructureFromResolvedPos(state, pos) : null;
	const tocAncestor = pos !== null ? findTocAncestor(state.doc, pos) : null;
	const isInTable$1 = structureFromResolvedPos?.isInTable ?? selectionHasNodeOrMark(state, "table", { requireEnds: true });
	const isInList = structureFromResolvedPos?.isInList ?? selectionIncludesListParagraph(state);
	const isOnListMarker = Boolean(event?.target?.closest?.(`.${DOM_CLASS_NAMES.LIST_MARKER}, .list-marker`));
	const isInSectionNode = structureFromResolvedPos?.isInSectionNode ?? selectionHasNodeOrMark(state, "documentSection", { requireEnds: true });
	const currentNodeType = node?.type?.name || null;
	const cellSelectionInfo = getCellSelectionInfo(state);
	const activeMarks = [];
	let trackedChangeId = null;
	const trackedMarkCandidates = [];
	if (event && pos !== null) {
		const $pos = state.doc.resolve(pos);
		const processMark = (mark) => {
			if (!activeMarks.includes(mark.type.name)) activeMarks.push(mark.type.name);
			if (isTrackedChangeMark(mark)) trackedMarkCandidates.push(mark);
		};
		$pos.marks().forEach(processMark);
		const nodeBefore = $pos.nodeBefore;
		const nodeAfter = $pos.nodeAfter;
		if (nodeBefore?.marks) nodeBefore.marks.forEach(processMark);
		if (nodeAfter?.marks) nodeAfter.marks.forEach(processMark);
		state.storedMarks?.forEach(processMark);
		trackedChangeId = choosePreferredTrackedChangeId(trackedMarkCandidates);
	} else {
		state.storedMarks?.forEach((mark) => activeMarks.push(mark.type.name));
		state.selection.$head.marks().forEach((mark) => activeMarks.push(mark.type.name));
	}
	const isTrackedChange = activeMarks.includes("trackInsert") || activeMarks.includes("trackDelete") || activeMarks.includes("trackFormat");
	const trackedChanges = (event && pos !== null ? hasExpandedSelection(selection) && selectionContainsPos(selection, pos) : hasSelection) ? collectTrackedChanges({
		state,
		from: selection.from,
		to: selection.to
	}) : event && pos !== null ? collectTrackedChangesForContext({
		state,
		pos,
		trackedChangeId
	}) : collectTrackedChanges({
		state,
		from: selection.from,
		to: selection.to
	});
	const cursorCoords = pos !== null ? editor.coordsAtPos?.(pos) : null;
	const cursorPosition = cursorCoords ? {
		x: cursorCoords.left,
		y: cursorCoords.top
	} : event ? {
		x: event.clientX,
		y: event.clientY
	} : null;
	const proofingContext = resolveProofingContext(editor, pos);
	return {
		selectedText,
		hasSelection,
		selectionStart: selection.from,
		selectionEnd: selection.to,
		isInTable: isInTable$1,
		isInList,
		isOnListMarker,
		isInSectionNode,
		isCellSelection: cellSelectionInfo.isCellSelection,
		tableSelectionKind: cellSelectionInfo.tableSelectionKind,
		currentNodeType,
		activeMarks,
		isTrackedChange,
		trackedChangeId,
		documentMode: editor.options?.documentMode || "editing",
		canUndo: computeCanUndo(editor, state),
		canRedo: computeCanRedo(editor, state),
		isEditable: editor.isEditable,
		clipboardContent,
		cursorPosition,
		pos,
		node,
		event,
		trigger: event ? "click" : "slash",
		editor: markRaw(editor),
		trackedChanges,
		proofingContext,
		tocAncestor
	};
}
function selectionContainsPos(selection, pos) {
	return hasExpandedSelection(selection) && Number.isFinite(pos) && pos >= selection.from && pos <= selection.to;
}
function getContextSelection({ editor, state, pos, event }) {
	const currentSelection = state.selection;
	const preservedSelection = editor?.options?.preservedSelection ?? editor?.options?.lastSelection;
	if (hasExpandedSelection(currentSelection)) return currentSelection;
	if (!hasExpandedSelection(preservedSelection)) return currentSelection;
	if (event) return selectionContainsPos(preservedSelection, pos) ? preservedSelection : currentSelection;
	return preservedSelection;
}
function computeCanUndo(editor, state) {
	if (typeof editor?.can === "function") try {
		const can = editor.can();
		if (can && typeof can.undo === "function") return !!can.undo();
	} catch (error) {
		console.warn("[ContextMenu] Unable to determine undo availability via editor.can():", error);
	}
	if (isCollaborationEnabled(editor)) try {
		const undoManager = yUndoPluginKey.getState(state)?.undoManager;
		return !!undoManager && undoManager.undoStack.length > 0;
	} catch (error) {
		console.warn("[ContextMenu] Unable to determine undo availability via y-prosemirror:", error);
	}
	try {
		return undoDepth(state) > 0;
	} catch (error) {
		console.warn("[ContextMenu] Unable to determine undo availability via history plugin:", error);
		return false;
	}
}
function computeCanRedo(editor, state) {
	if (typeof editor?.can === "function") try {
		const can = editor.can();
		if (can && typeof can.redo === "function") return !!can.redo();
	} catch (error) {
		console.warn("[ContextMenu] Unable to determine redo availability via editor.can():", error);
	}
	if (isCollaborationEnabled(editor)) try {
		const undoManager = yUndoPluginKey.getState(state)?.undoManager;
		return !!undoManager && undoManager.redoStack.length > 0;
	} catch (error) {
		console.warn("[ContextMenu] Unable to determine redo availability via y-prosemirror:", error);
	}
	try {
		return redoDepth(state) > 0;
	} catch (error) {
		console.warn("[ContextMenu] Unable to determine redo availability via history plugin:", error);
		return false;
	}
}
function isCollaborationEnabled(editor) {
	return Boolean(editor?.options?.collaborationProvider && editor?.options?.ydoc);
}
function selectionIncludesListParagraph(state) {
	const { $from, $to, from: from$1, to } = state.selection;
	const hasListInResolvedPos = ($pos) => {
		for (let depth = $pos.depth; depth > 0; depth--) if (isList($pos.node(depth))) return true;
		return false;
	};
	if (hasListInResolvedPos($from) || hasListInResolvedPos($to)) return true;
	let found = false;
	state.doc.nodesBetween(from$1, to, (node) => {
		if (isList(node)) {
			found = true;
			return false;
		}
		return true;
	});
	return found;
}
function getCellSelectionInfo(state) {
	if (!isCellSelection(state.selection)) return {
		isCellSelection: false,
		tableSelectionKind: null
	};
	let tableSelectionKind = "cells";
	try {
		const rect = selectedRect(state);
		const selectedRows = rect.bottom - rect.top;
		const selectedCols = rect.right - rect.left;
		const totalRows = rect.map.height;
		const totalCols = rect.map.width;
		const allRows = selectedRows === totalRows;
		const allCols = selectedCols === totalCols;
		if (allRows && allCols) tableSelectionKind = "table";
		else if (allCols) tableSelectionKind = "row";
		else if (allRows) tableSelectionKind = "column";
	} catch (error) {
		console.warn("[ContextMenu] Unable to resolve cell selection rectangle:", error);
	}
	return {
		isCellSelection: true,
		tableSelectionKind
	};
}
function getStructureFromResolvedPos(state, pos) {
	try {
		const $pos = state.doc.resolve(pos);
		let isInList = false;
		let isInTable$1 = false;
		let isInSectionNode = false;
		for (let depth = $pos.depth; depth > 0; depth--) {
			const node = $pos.node(depth);
			const name = node.type.name;
			if (!isInList && isList(node)) isInList = true;
			if (!isInTable$1 && (name === "table" || name === "tableRow" || name === "tableCell" || name === "tableHeader")) isInTable$1 = true;
			if (!isInSectionNode && name === "documentSection") isInSectionNode = true;
			if (isInList && isInTable$1 && isInSectionNode) break;
		}
		return {
			isInTable: isInTable$1,
			isInList,
			isInSectionNode
		};
	} catch (error) {
		console.warn("[ContextMenu] Unable to resolve position for structural context:", error);
		return null;
	}
}
function resolveProofingContext(editor, pos) {
	if (pos == null || !Number.isFinite(pos)) return null;
	try {
		const manager = editor?._presentationEditor?.proofingManager ?? editor?.presentationEditor?.proofingManager ?? editor?.proofingManager ?? null;
		if (!manager) return null;
		const issue = manager.getIssueAtPosition(pos);
		if (!issue) return null;
		const config = manager.config;
		return {
			issue,
			suggestions: issue.replacements?.slice(0, config.maxSuggestions) ?? [],
			canIgnore: config.allowIgnoreWord,
			word: issue.word ?? "",
			ignoreWord: (word$1) => manager.ignoreWord(word$1)
		};
	} catch {
		return null;
	}
}
var CellBackgroundPicker_default = {
	__name: "CellBackgroundPicker",
	props: {
		editor: {
			type: Object,
			required: true
		},
		closePopover: {
			type: Function,
			required: true
		}
	},
	setup(__props) {
		const props = __props;
		const activeColor = { value: null };
		const ensureCellSelection = () => {
			const { state } = props.editor;
			if (isCellSelection(state.selection)) return;
			const $from = state.selection.$from;
			const cell = cellAround($from);
			if (cell) props.editor.commands.setCellSelection({
				anchorCell: cell.pos,
				headCell: cell.pos
			});
		};
		const handleSelect = (color) => {
			ensureCellSelection();
			if (color === "none") props.editor.commands.setCellAttr("background", null);
			else props.editor.commands.setCellBackground(color);
			props.closePopover();
		};
		return (_ctx, _cache) => {
			return openBlock(), createBlock(IconGrid_default, {
				icons: unref(icons),
				customIcons: [],
				activeColor,
				hasNoneIcon: true,
				onSelect: handleSelect
			}, null, 8, ["icons"]);
		};
	}
};
var createPasteEventShim = (clipboard) => {
	const html = clipboard?.html || "";
	const text = clipboard?.text || "";
	return {
		type: "paste",
		preventDefault: () => {},
		stopPropagation: () => {},
		clipboardData: { getData: (type) => {
			if (type === "text/html") return html;
			if (type === "text/plain") return text;
			return "";
		} }
	};
};
var isModuleEnabled = (editorOptions, moduleName) => {
	switch (moduleName) {
		case "ai": return !!editorOptions?.isAiEnabled;
		default: return true;
	}
};
var shouldShowItem = (item, context) => {
	if (typeof item.showWhen === "function") try {
		return Boolean(item.showWhen(context));
	} catch (error) {
		console.warn("[ContextMenu] showWhen error for item", item.id, ":", error);
		return false;
	}
	return true;
};
var canPerformTrackedChange = (context, action) => {
	if (!context?.editor) return true;
	return isTrackedChangeActionAllowed({
		editor: context.editor,
		action,
		trackedChanges: context.trackedChanges ?? []
	});
};
var buildProofingItems = (context) => {
	const items = [];
	const proofing = context?.proofingContext;
	if (context?.trigger === TRIGGERS.click && proofing?.issue && proofing?.suggestions?.length) proofing.suggestions.forEach((suggestion, i) => {
		items.push({
			id: `proofing-replace-${i}`,
			label: suggestion,
			isDefault: true,
			action: (editor) => {
				const { state, dispatch } = editor.view;
				const { pmFrom, pmTo } = proofing.issue;
				let commonMarks = null;
				state.doc.nodesBetween(pmFrom, pmTo, (node) => {
					if (node.isText) if (commonMarks === null) commonMarks = [...node.marks];
					else commonMarks = commonMarks.filter((existing) => node.marks.some((m$1) => existing.eq(m$1)));
				});
				const existingMarks = commonMarks ?? [];
				const tr = state.tr;
				const replacement = state.schema.text(suggestion, existingMarks);
				tr.replaceWith(pmFrom, pmTo, replacement);
				dispatch(tr);
			}
		});
	});
	items.push({
		id: "proofing-ignore",
		label: "Ignore",
		isDefault: true,
		action: (editor, context$1) => {
			const proofing$1 = context$1.proofingContext;
			if (!proofing$1?.word) return;
			proofing$1.ignoreWord(proofing$1.word);
		},
		showWhen: (context$1) => {
			return context$1.trigger === TRIGGERS.click && !!context$1.proofingContext?.canIgnore && !!context$1.proofingContext?.word;
		}
	});
	return items;
};
function getItems(context, customItems = [], includeDefaultItems = true) {
	const { selectedText, editor } = context;
	if (editor?.options?.slashMenuConfig && !editor?.options?.contextMenuConfig) console.warn("[ContextMenu] editor.options.slashMenuConfig is deprecated. Use contextMenuConfig instead.");
	const menuConfig = editor?.options?.contextMenuConfig ?? editor?.options?.slashMenuConfig;
	if (arguments.length === 1 && menuConfig) {
		customItems = menuConfig.items || menuConfig.customItems || [];
		includeDefaultItems = menuConfig.includeDefaultItems !== false;
	}
	const enhancedContext = {
		...context,
		isInTable: context.isInTable ?? false,
		isInSectionNode: context.isInSectionNode ?? false,
		isTrackedChange: context.isTrackedChange ?? false,
		isCellSelection: context.isCellSelection ?? false,
		tableSelectionKind: context.tableSelectionKind ?? null,
		clipboardContent: context.clipboardContent ?? { hasContent: false },
		selectedText: context.selectedText ?? "",
		hasSelection: context.hasSelection ?? Boolean(context.selectedText)
	};
	const defaultSections = [
		{
			id: "proofing",
			isDefault: true,
			items: buildProofingItems(enhancedContext)
		},
		{
			id: "ai-content",
			isDefault: true,
			items: [{
				id: "insert-text",
				label: selectedText ? TEXTS.replaceText : TEXTS.insertText,
				icon: ICONS.ai,
				component: AIWriter_default,
				isDefault: true,
				action: (editor$1) => {
					if (editor$1?.commands && typeof editor$1.commands?.insertAiMark === "function") editor$1.commands.insertAiMark();
				},
				showWhen: (context$1) => {
					const { trigger } = context$1;
					return [TRIGGERS.slash, TRIGGERS.click].includes(trigger) && isModuleEnabled(context$1.editor?.options, "ai");
				}
			}]
		},
		{
			id: "track-changes",
			isDefault: true,
			items: [{
				id: "track-changes-accept",
				icon: ICONS.trackChangesAccept,
				label: TEXTS.trackChangesAccept,
				isDefault: true,
				action: (editor$1, context$1) => {
					editor$1.commands.acceptTrackedChangeFromContextMenu({
						from: context$1?.selectionStart,
						to: context$1?.selectionEnd,
						trackedChangeId: context$1?.trackedChangeId
					});
				},
				showWhen: (context$1) => {
					const { trigger, isTrackedChange } = context$1;
					return trigger === TRIGGERS.click && isTrackedChange && canPerformTrackedChange(context$1, "accept");
				}
			}, {
				id: "track-changes-reject",
				label: TEXTS.trackChangesReject,
				icon: ICONS.trackChangesReject,
				isDefault: true,
				action: (editor$1, context$1) => {
					editor$1.commands.rejectTrackedChangeFromContextMenu({
						from: context$1?.selectionStart,
						to: context$1?.selectionEnd,
						trackedChangeId: context$1?.trackedChangeId
					});
				},
				showWhen: (context$1) => {
					const { trigger, isTrackedChange } = context$1;
					return trigger === TRIGGERS.click && isTrackedChange && canPerformTrackedChange(context$1, "reject");
				}
			}]
		},
		{
			id: "document-sections",
			isDefault: true,
			items: [{
				id: "insert-document-section",
				label: TEXTS.createDocumentSection,
				icon: ICONS.addDocumentSection,
				isDefault: true,
				action: (editor$1) => {
					editor$1.commands.createDocumentSection();
				},
				showWhen: () => {
					return false;
				}
			}, {
				id: "remove-section",
				label: TEXTS.removeDocumentSection,
				icon: ICONS.removeDocumentSection,
				isDefault: true,
				action: (editor$1) => {
					editor$1.commands.removeSectionAtSelection();
				},
				showWhen: (context$1) => {
					const { trigger, isInSectionNode } = context$1;
					return trigger === TRIGGERS.click && isInSectionNode;
				}
			}]
		},
		{
			id: "list-marker",
			isDefault: true,
			items: [
				{
					id: "list-restart-numbering",
					label: TEXTS.listRestartNumbering,
					icon: ICONS.listRestartNumbering,
					isDefault: true,
					action: (editor$1) => editor$1.commands.restartNumbering(),
					showWhen: (context$1) => context$1.trigger === TRIGGERS.click && context$1.isOnListMarker
				},
				{
					id: "list-continue-numbering",
					label: TEXTS.listContinueNumbering,
					icon: ICONS.listContinueNumbering,
					isDefault: true,
					action: (editor$1) => editor$1.commands.continueNumbering(),
					showWhen: (context$1) => context$1.trigger === TRIGGERS.click && context$1.isOnListMarker
				},
				{
					id: "list-decrease-indent",
					label: TEXTS.listDecreaseIndent,
					icon: ICONS.listDecreaseIndent,
					isDefault: true,
					action: (editor$1) => editor$1.commands.decreaseListIndent(),
					showWhen: (context$1) => context$1.trigger === TRIGGERS.click && context$1.isOnListMarker
				},
				{
					id: "list-increase-indent",
					label: TEXTS.listIncreaseIndent,
					icon: ICONS.listIncreaseIndent,
					isDefault: true,
					action: (editor$1) => editor$1.commands.increaseListIndent(),
					showWhen: (context$1) => context$1.trigger === TRIGGERS.click && context$1.isOnListMarker
				}
			]
		},
		{
			id: "general",
			isDefault: true,
			items: [
				{
					id: "insert-link",
					label: TEXTS.insertLink,
					icon: ICONS.link,
					component: LinkInput_default,
					isDefault: true,
					showWhen: (context$1) => {
						const { trigger } = context$1;
						return trigger === TRIGGERS.click;
					}
				},
				{
					id: "insert-table",
					label: TEXTS.insertTable,
					icon: ICONS.table,
					component: TableGrid_default,
					isDefault: true,
					showWhen: (context$1) => {
						const { trigger, isInTable: isInTable$1 } = context$1;
						return [TRIGGERS.slash, TRIGGERS.click].includes(trigger) && !isInTable$1;
					}
				},
				{
					id: "edit-table",
					label: TEXTS.editTable,
					icon: ICONS.table,
					component: TableActions_default,
					isDefault: true,
					showWhen: (context$1) => {
						const { trigger, isInTable: isInTable$1 } = context$1;
						return [TRIGGERS.slash, TRIGGERS.click].includes(trigger) && isInTable$1;
					}
				},
				{
					id: "cell-background",
					label: TEXTS.cellBackground,
					icon: ICONS.cellBackground,
					component: CellBackgroundPicker_default,
					isDefault: true,
					showWhen: (context$1) => {
						return context$1.trigger === TRIGGERS.click && (context$1.isCellSelection || context$1.isInTable);
					}
				},
				{
					id: "update-table-of-contents",
					label: TEXTS.updateTableOfContents,
					icon: ICONS.updateTableOfContents,
					isDefault: true,
					action: (editor$1, context$1) => {
						const sdBlockId = context$1.tocAncestor?.sdBlockId;
						if (!sdBlockId) return;
						try {
							editor$1.doc?.toc?.update?.({
								target: {
									kind: "block",
									nodeType: "tableOfContents",
									nodeId: sdBlockId
								},
								mode: "all"
							});
						} catch (error) {
							console.warn("[ContextMenu] toc.update failed:", error);
						}
					},
					showWhen: (context$1) => context$1.trigger === TRIGGERS.click && !!context$1.tocAncestor?.sdBlockId
				}
			]
		},
		{
			id: "clipboard",
			isDefault: true,
			items: [
				{
					id: "cut",
					label: TEXTS.cut,
					icon: ICONS.cut,
					isDefault: true,
					action: (editor$1) => {
						editor$1.focus?.();
						document.execCommand("cut");
					},
					showWhen: (context$1) => {
						const { trigger, selectedText: selectedText$1 } = context$1;
						return trigger === TRIGGERS.click && selectedText$1;
					}
				},
				{
					id: "copy",
					label: TEXTS.copy,
					icon: ICONS.copy,
					isDefault: true,
					action: (editor$1) => {
						editor$1.focus?.();
						document.execCommand("copy");
					},
					showWhen: (context$1) => {
						const { trigger, selectedText: selectedText$1 } = context$1;
						return trigger === TRIGGERS.click && selectedText$1;
					}
				},
				{
					id: "paste",
					label: TEXTS.paste,
					icon: ICONS.paste,
					isDefault: true,
					action: async (editor$1) => {
						const targetEditor = resolveContextMenuCommandEditor(editor$1);
						const { view } = targetEditor ?? {};
						if (!view) return;
						const savedFrom = view.state.selection.from;
						const savedTo = view.state.selection.to;
						view.focus();
						const { html, text } = await readClipboardRaw();
						if (view.state?.doc?.content) {
							const { tr, doc: doc$1 } = view.state;
							const maxPos = doc$1.content.size;
							const safeFrom = Math.min(savedFrom, maxPos);
							const safeTo = Math.min(savedTo, maxPos);
							const SelectionType = view.state.selection.constructor;
							if (typeof SelectionType.create === "function") view.dispatch(tr.setSelection(SelectionType.create(doc$1, safeFrom, safeTo)));
						}
						if (!handleClipboardPaste({
							editor: targetEditor,
							view
						}, html, text)) {
							const pasteEvent = createPasteEventShim({
								html,
								text
							});
							if (html && typeof view.pasteHTML === "function") {
								view.pasteHTML(html, pasteEvent);
								return;
							}
							if (text && typeof view.pasteText === "function") {
								view.pasteText(text, pasteEvent);
								return;
							}
							if (text && targetEditor.commands?.insertContent) targetEditor.commands.insertContent(text, { contentType: "text" });
						}
					},
					showWhen: (context$1) => {
						const { trigger } = context$1;
						return [TRIGGERS.click, TRIGGERS.slash].includes(trigger);
					}
				}
			]
		}
	];
	let allSections = [];
	if (includeDefaultItems) allSections = [...defaultSections];
	if (customItems.length > 0) customItems.forEach((customSection) => {
		const existingSectionIndex = allSections.findIndex((section) => section.id === customSection.id);
		if (existingSectionIndex !== -1) allSections[existingSectionIndex].items = [...allSections[existingSectionIndex].items, ...customSection.items.map((item) => ({
			...item,
			isDefault: false
		}))];
		else allSections.push({
			...customSection,
			isDefault: false,
			items: customSection.items.map((item) => ({
				...item,
				isDefault: false
			}))
		});
	});
	if (menuConfig?.menuProvider) try {
		allSections = menuConfig.menuProvider(enhancedContext, allSections) || allSections;
	} catch (error) {
		console.warn("[ContextMenu] menuProvider error:", error);
	}
	return allSections.map((section) => {
		const filteredItems = section.items.filter((item) => shouldShowItem(item, enhancedContext));
		return {
			...section,
			items: filteredItems
		};
	}).filter((section) => section.items.length > 0);
}
var _hoisted_1$4 = {
	key: 0,
	class: "context-menu-search-header"
};
var _hoisted_2$2 = { class: "context-menu-search-header-value" };
var _hoisted_3$1 = { class: "context-menu-items" };
var _hoisted_4$1 = {
	key: 0,
	class: "context-menu-divider",
	tabindex: "0"
};
var _hoisted_5$1 = ["onClick"];
var _hoisted_6 = ["innerHTML"];
var _hoisted_7 = {
	key: 0,
	class: "context-menu-empty"
};
var TABLE_SURFACE_SELECTOR = ".superdoc-table-fragment, .superdoc-table-cell";
var ContextMenu_default = {
	__name: "ContextMenu",
	props: {
		editor: {
			type: Object,
			required: true
		},
		openPopover: {
			type: Function,
			required: true
		},
		closePopover: {
			type: Function,
			required: true
		}
	},
	setup(__props) {
		const props = __props;
		const searchInput = ref(null);
		const searchQuery = ref("");
		const isOpen = ref(false);
		const menuPosition = ref({
			left: "0px",
			top: "0px"
		});
		const menuRef = ref(null);
		const sections = ref([]);
		const selectedId = ref(null);
		const currentContext = ref(null);
		const hasExpandedSelection$1 = (selection) => {
			return Number.isFinite(selection?.from) && Number.isFinite(selection?.to) && Number(selection.from) !== Number(selection.to);
		};
		const setSelectionNearPos = (editor, pos, options = {}) => {
			if (!editor?.state?.doc || !Number.isFinite(pos)) return false;
			const doc$1 = editor.state.doc;
			const maxPos = doc$1.content.size;
			const clampedPos = Math.max(0, Math.min(pos, maxPos));
			try {
				const resolved = doc$1.resolve(clampedPos);
				const nextSelection = Selection.near(resolved, 1);
				const tr = editor.state.tr.setSelection(nextSelection);
				if (options.addToHistory === false) tr.setMeta("addToHistory", false);
				editor.dispatch?.(tr);
				if (options.focus) editor.focus?.();
				return true;
			} catch {
				return false;
			}
		};
		const handleEditorUpdate = () => {
			if (!props.editor?.isEditable && isOpen.value) closeMenu({ restoreCursor: false });
		};
		const flattenedItems = computed(() => {
			const items = [];
			sections.value.forEach((section) => {
				section.items.forEach((item) => {
					items.push(item);
				});
			});
			return items;
		});
		const filteredItems = computed(() => {
			if (!searchQuery.value) return flattenedItems.value;
			return flattenedItems.value.filter((item) => item.label?.toLowerCase().includes(searchQuery.value.toLowerCase()));
		});
		const filteredSections = computed(() => {
			if (!searchQuery.value) return sections.value;
			return [{
				id: "search-results",
				items: filteredItems.value
			}];
		});
		watch(isOpen, (open) => {
			if (open) nextTick(() => {
				if (searchInput.value) searchInput.value.focus({ preventScroll: true });
			});
		});
		watch(flattenedItems, (newItems) => {
			if (newItems.length > 0) selectedId.value = newItems[0].id;
		});
		const customItemRefs = /* @__PURE__ */ new Map();
		const setCustomItemRef = (el, item) => {
			if (el) {
				customItemRefs.set(item.id, {
					element: el,
					item
				});
				nextTick(() => {
					renderCustomItem(item.id);
				});
			}
		};
		const defaultRender = (context) => {
			const item = context.item || context.currentItem;
			const container = document.createElement("div");
			container.className = "context-menu-default-content";
			if (item.icon) {
				const iconSpan = document.createElement("span");
				iconSpan.className = "context-menu-item-icon";
				iconSpan.innerHTML = item.icon;
				container.appendChild(iconSpan);
			}
			const labelSpan = document.createElement("span");
			labelSpan.textContent = item.label;
			container.appendChild(labelSpan);
			return container;
		};
		const renderCustomItem = async (itemId) => {
			const refData = customItemRefs.get(itemId);
			if (!refData || refData.element.hasCustomContent) return;
			const { element, item } = refData;
			try {
				if (!currentContext.value) currentContext.value = await getEditorContext(props.editor);
				const contextWithItem = {
					...currentContext.value,
					currentItem: item
				};
				const customElement = (item.render || defaultRender)(contextWithItem);
				if (customElement instanceof HTMLElement) {
					element.innerHTML = "";
					element.appendChild(customElement);
					element.hasCustomContent = true;
				}
			} catch (error) {
				console.warn(`[ContextMenu] Error rendering custom item ${itemId}:`, error);
				const fallbackElement = defaultRender({
					...currentContext.value || {},
					currentItem: item
				});
				element.innerHTML = "";
				element.appendChild(fallbackElement);
				element.hasCustomContent = true;
			}
		};
		const cleanupCustomItems = () => {
			customItemRefs.forEach((refData) => {
				if (refData.element) refData.element.hasCustomContent = false;
			});
			customItemRefs.clear();
		};
		const handleGlobalKeyDown = (event) => {
			if ((event.key === "Escape" || event.key === "ArrowLeft") && isOpen.value) {
				event.preventDefault();
				event.stopPropagation();
				const pluginState = ContextMenuPluginKey.getState(props.editor?.state);
				const anchorPos = pluginState?.anchorPos;
				const trigger = pluginState?.trigger;
				closeMenu({ restoreCursor: false });
				if (trigger === "slash" && props.editor && anchorPos !== null && anchorPos !== void 0) {
					const tr = props.editor.state.tr.insertText("/", anchorPos);
					const insertedAt = anchorPos + 1;
					tr.setSelection(props.editor.state.selection.constructor.near(tr.doc.resolve(insertedAt)));
					props.editor.dispatch(tr);
				}
				props.editor?.focus?.();
				return;
			}
			if ((event.key === "Backspace" || event.key === "Delete") && isOpen.value && !searchQuery.value) {
				event.preventDefault();
				event.stopPropagation();
				closeMenu({ restoreCursor: true });
				props.editor?.focus?.();
				return;
			}
			if (isOpen.value && (event.target === searchInput.value || menuRef.value && menuRef.value.contains(event.target))) {
				const currentItems = filteredItems.value;
				const currentIndex = currentItems.findIndex((item) => item.id === selectedId.value);
				switch (event.key) {
					case "ArrowDown":
						event.preventDefault();
						if (currentIndex < currentItems.length - 1) selectedId.value = currentItems[currentIndex + 1].id;
						break;
					case "ArrowUp":
						event.preventDefault();
						if (currentIndex > 0) selectedId.value = currentItems[currentIndex - 1].id;
						break;
					case "Enter": {
						event.preventDefault();
						const selectedItem = currentItems.find((item) => item.id === selectedId.value);
						if (selectedItem) executeCommand(selectedItem);
						break;
					}
				}
			}
		};
		const handleGlobalOutsideClick = (event) => {
			if (isOpen.value && menuRef.value && !menuRef.value.contains(event.target)) {
				const isCtrlClickOnMac = event.ctrlKey && isMacOS();
				if (event.button === 0 && !isCtrlClickOnMac) moveCursorToMouseEvent(event, props.editor);
				closeMenu({ restoreCursor: false });
			}
		};
		const shouldHandleContextMenu = (event) => {
			const readOnly = !props.editor?.isEditable;
			const contextMenuDisabled = props.editor?.options?.disableContextMenu;
			const bypass = shouldBypassContextMenu(event);
			return !readOnly && !contextMenuDisabled && !bypass;
		};
		const getContextMenuTargets = () => {
			const targets = /* @__PURE__ */ new Set();
			const surface = getEditorSurfaceElement(props.editor);
			if (surface) targets.add(surface);
			const activeDom = resolveContextMenuCommandEditor(props.editor)?.view?.dom;
			if (activeDom instanceof HTMLElement) targets.add(activeDom);
			return [...targets];
		};
		const isEventWithinContextMenuTargets = (event) => {
			const target = event?.target;
			if (!(target instanceof Node)) return false;
			return getContextMenuTargets().some((surface) => surface === target || typeof surface?.contains === "function" && surface.contains(target));
		};
		const handleRightClickCapture = (event) => {
			try {
				if (isEventWithinContextMenuTargets(event) && shouldHandleContextMenu(event)) event[CONTEXT_MENU_HANDLED_FLAG] = true;
			} catch (error) {
				console.warn("[ContextMenu] Error in capture phase context menu handler:", error);
			}
		};
		const handleRightClick = async (event) => {
			if (!isEventWithinContextMenuTargets(event)) return;
			if (!shouldHandleContextMenu(event)) return;
			event.preventDefault();
			const editorState = props.editor?.state;
			const hasRangeSelection = hasExpandedSelection$1(editorState?.selection);
			let isClickInsideSelection = false;
			if (hasRangeSelection && Number.isFinite(event.clientX) && Number.isFinite(event.clientY)) {
				const hit = props.editor?.posAtCoords?.({
					left: event.clientX,
					top: event.clientY
				});
				if (typeof hit?.pos === "number") {
					const { from: from$1, to } = editorState.selection;
					isClickInsideSelection = hit.pos >= from$1 && hit.pos <= to;
				}
			}
			const target = event?.target;
			const tableSurface = target instanceof Element ? target.closest(TABLE_SURFACE_SELECTOR) : null;
			const tableCandidatePm = target instanceof Element ? target.closest("[data-pm-start]") : null;
			const tableAnchorPos = Number.isFinite(Number(tableCandidatePm?.dataset?.pmStart)) ? Number(tableCandidatePm.dataset.pmStart) : null;
			const selectionIsCell = isCellSelection(editorState?.selection);
			if (tableSurface && Number.isFinite(tableAnchorPos) && !selectionIsCell && !hasRangeSelection) setSelectionNearPos(props.editor, tableAnchorPos, { focus: true });
			else if (!isClickInsideSelection) moveCursorToMouseEvent(event, props.editor);
			try {
				const context = await getEditorContext(props.editor, event);
				if (Boolean(tableSurface) && context?.isInTable && Number.isFinite(context?.pos) && !isCellSelection(props.editor?.state?.selection) && !hasExpandedSelection$1(props.editor?.state?.selection)) setSelectionNearPos(props.editor, context.pos, { focus: true });
				currentContext.value = context;
				sections.value = getItems({
					...context,
					trigger: "click"
				});
				selectedId.value = flattenedItems.value[0]?.id || null;
				searchQuery.value = "";
				const currentState = props.editor.state;
				if (!currentState) return;
				props.editor.dispatch(currentState.tr.setMeta(ContextMenuPluginKey, {
					type: "open",
					pos: context?.pos ?? currentState.selection.from,
					clientX: event.clientX,
					clientY: event.clientY
				}));
			} catch (error) {
				console.error("[ContextMenu] Error opening context menu:", error);
			}
		};
		const executeCommand = async (item) => {
			if (props.editor) {
				const commandEditor = resolveContextMenuCommandEditor(props.editor);
				const currentPos = currentContext.value?.pos;
				if (currentContext.value?.event?.type === "contextmenu" && currentContext.value?.isInTable && Number.isFinite(currentPos) && !isCellSelection(props.editor?.state?.selection) && !hasExpandedSelection$1(props.editor?.state?.selection)) setSelectionNearPos(props.editor, currentPos, {
					focus: true,
					addToHistory: false
				});
				item.action && await item.action(commandEditor, currentContext.value);
				if (item.component) {
					const menuElement = menuRef.value;
					const componentProps = getPropsByItemId(item.id, {
						...props,
						editor: commandEditor
					});
					let popoverPosition = {
						left: menuPosition.value.left,
						top: menuPosition.value.top
					};
					if (menuElement) {
						const menuRect = menuElement.getBoundingClientRect();
						const container = menuElement.closest(".super-editor");
						if (container) {
							const containerRect = container.getBoundingClientRect();
							popoverPosition = {
								left: `${menuRect.left - containerRect.left}px`,
								top: `${menuRect.top - containerRect.top}px`
							};
						}
					}
					props.openPopover(markRaw(item.component), componentProps, popoverPosition);
					closeMenu({ restoreCursor: false });
				} else closeMenu({ restoreCursor: item.id !== "paste" });
			}
		};
		const closeMenu = (options = { restoreCursor: true }) => {
			if (!props.editor) return;
			const state = props.editor.state;
			if (!state) return;
			const anchorPos = ContextMenuPluginKey.getState(state)?.anchorPos;
			props.editor.dispatch(state.tr.setMeta(ContextMenuPluginKey, { type: "close" }));
			if (options.restoreCursor && anchorPos !== null && anchorPos !== void 0) {
				const tr = props.editor.state.tr.setSelection(props.editor.state.selection.constructor.near(props.editor.state.doc.resolve(anchorPos)));
				props.editor.dispatch(tr);
				props.editor.focus?.();
			}
			cleanupCustomItems();
			currentContext.value = null;
			isOpen.value = false;
			searchQuery.value = "";
			sections.value = [];
		};
		let contextMenuOpenHandler = null;
		let contextMenuCloseHandler = null;
		onMounted(() => {
			if (!props.editor) return;
			document.addEventListener("keydown", handleGlobalKeyDown);
			document.addEventListener("pointerdown", handleGlobalOutsideClick);
			document.addEventListener("contextmenu", handleRightClickCapture, true);
			document.addEventListener("contextmenu", handleRightClick);
			props.editor.on("update", handleEditorUpdate);
			contextMenuOpenHandler = async (event) => {
				if (!props.editor?.isEditable) return;
				let nextSections = sections.value;
				if (!currentContext.value) {
					const context = await getEditorContext(props.editor);
					currentContext.value = context;
					nextSections = getItems({
						...context,
						trigger: "slash"
					});
				} else if (sections.value.length === 0) {
					const trigger = currentContext.value.event?.type === "contextmenu" ? "click" : "slash";
					nextSections = getItems({
						...currentContext.value,
						trigger
					});
				}
				if (!nextSections.length) {
					const state = props.editor?.state;
					if (state) props.editor.dispatch(state.tr.setMeta(ContextMenuPluginKey, { type: "close" }));
					return;
				}
				sections.value = nextSections;
				menuPosition.value = event.menuPosition;
				searchQuery.value = "";
				selectedId.value = flattenedItems.value[0]?.id || null;
				isOpen.value = true;
			};
			props.editor.on("contextMenu:open", contextMenuOpenHandler);
			contextMenuCloseHandler = () => {
				cleanupCustomItems();
				isOpen.value = false;
				searchQuery.value = "";
				currentContext.value = null;
			};
			props.editor.on("contextMenu:close", contextMenuCloseHandler);
		});
		onBeforeUnmount(() => {
			document.removeEventListener("keydown", handleGlobalKeyDown);
			document.removeEventListener("pointerdown", handleGlobalOutsideClick);
			document.removeEventListener("contextmenu", handleRightClickCapture, true);
			document.removeEventListener("contextmenu", handleRightClick);
			cleanupCustomItems();
			if (props.editor) try {
				if (contextMenuOpenHandler) props.editor.off("contextMenu:open", contextMenuOpenHandler);
				if (contextMenuCloseHandler) props.editor.off("contextMenu:close", contextMenuCloseHandler);
				props.editor.off("update", handleEditorUpdate);
			} catch (error) {
				console.warn("[ContextMenu] Error during cleanup:", error);
			}
		});
		return (_ctx, _cache) => {
			return isOpen.value ? (openBlock(), createElementBlock("div", {
				key: 0,
				ref_key: "menuRef",
				ref: menuRef,
				class: "context-menu",
				style: normalizeStyle(menuPosition.value),
				onPointerdown: _cache[2] || (_cache[2] = withModifiers(() => {}, ["stop"]))
			}, [
				withDirectives(createElementVNode("input", {
					ref_key: "searchInput",
					ref: searchInput,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => searchQuery.value = $event),
					type: "text",
					class: "context-menu-hidden-input",
					onKeydown: [handleGlobalKeyDown, _cache[1] || (_cache[1] = withModifiers(() => {}, ["stop"]))]
				}, null, 544), [[vModelText, searchQuery.value]]),
				searchQuery.value ? (openBlock(), createElementBlock("div", _hoisted_1$4, [_cache[3] || (_cache[3] = createElementVNode("span", { class: "context-menu-search-header-label" }, "Searching:", -1)), createElementVNode("span", _hoisted_2$2, "/" + toDisplayString(searchQuery.value), 1)])) : createCommentVNode("", true),
				createElementVNode("div", _hoisted_3$1, [(openBlock(true), createElementBlock(Fragment, null, renderList(filteredSections.value, (section, sectionIndex) => {
					return openBlock(), createElementBlock(Fragment, { key: section.id }, [sectionIndex > 0 && section.items.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_4$1)) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(section.items, (item) => {
						return openBlock(), createElementBlock("div", {
							key: item.id,
							class: normalizeClass(["context-menu-item", { "sd-is-selected": item.id === selectedId.value }]),
							onClick: ($event) => executeCommand(item)
						}, [createElementVNode("div", {
							ref_for: true,
							ref: (el) => setCustomItemRef(el, item),
							class: "context-menu-custom-item"
						}, [!item.render ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [item.icon ? (openBlock(), createElementBlock("span", {
							key: 0,
							class: "context-menu-item-icon",
							innerHTML: item.icon
						}, null, 8, _hoisted_6)) : createCommentVNode("", true), createElementVNode("span", null, toDisplayString(item.label), 1)], 64)) : createCommentVNode("", true)], 512)], 10, _hoisted_5$1);
					}), 128))], 64);
				}), 128)), searchQuery.value && filteredItems.value.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_7, "No matching commands")) : createCommentVNode("", true)])
			], 36)) : createCommentVNode("", true);
		};
	}
};
var MIN_WIDTH = 200;
var PPI = 96;
var alignment = "flex-end";
var Ruler_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "Ruler",
	props: {
		orientation: {
			type: String,
			default: "horizontal"
		},
		length: {
			type: Number,
			default: 0
		},
		editor: {
			type: Object,
			required: true
		}
	},
	emits: ["margin-change"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const props = __props;
		const ruler = ref(null);
		const rulerDefinition = ref(null);
		const rulerHandleOriginalColor = ref("#CCCCCC");
		const rulerHandleActiveColor = ref("#2563EB66");
		const pageSize = ref(null);
		const pageMargins = ref(null);
		const currentSectionIndex = ref(0);
		const isDragging = ref(false);
		const currentHandle = ref(null);
		const leftHandle = reactive({
			side: "left",
			x: 0
		});
		const rightHandle = reactive({
			side: "right",
			x: 0
		});
		const showVerticalIndicator = ref(false);
		const initialX = ref(0);
		let offsetX = 0;
		let selectionUpdateHandler = null;
		let zoomChangeHandler = null;
		const currentZoom = ref(1);
		const getPresentationEditor = () => {
			const editor = props.editor;
			if (!editor) return null;
			if (typeof editor.zoom === "number" && typeof editor.setZoom === "function") return editor;
			if (editor.presentationEditor) return editor.presentationEditor;
			return null;
		};
		const updateRulerForCurrentSection = () => {
			if (!props.editor || props.editor.options?.mode !== "docx") return;
			const presentationEditor = getPresentationEditor();
			let docSize, docMargins, sectionIndex;
			if (presentationEditor && typeof presentationEditor.getCurrentSectionPageStyles === "function") {
				const sectionStyles = presentationEditor.getCurrentSectionPageStyles();
				docSize = sectionStyles.pageSize;
				docMargins = sectionStyles.pageMargins;
				sectionIndex = sectionStyles.sectionIndex;
			} else {
				const styles = props.editor.getPageStyles();
				docSize = styles.pageSize ?? {
					width: 8.5,
					height: 11
				};
				docMargins = styles.pageMargins ?? {
					left: 1,
					right: 1,
					top: 1,
					bottom: 1
				};
				sectionIndex = 0;
			}
			if (pageSize.value && currentSectionIndex.value === sectionIndex) return;
			currentSectionIndex.value = sectionIndex;
			pageSize.value = docSize;
			pageMargins.value = docMargins;
			const definition = generateRulerDefinition({
				pageSize: {
					width: docSize.width,
					height: docSize.height
				},
				pageMargins: {
					left: docMargins.left,
					right: docMargins.right,
					top: docMargins.top ?? 1,
					bottom: docMargins.bottom ?? 1
				}
			});
			leftHandle.x = definition.leftMarginPx;
			rightHandle.x = definition.rightMarginPx;
			rulerDefinition.value = definition;
		};
		const getTickStyle = computed(() => (tick) => {
			const zoom = currentZoom.value;
			return {
				position: "absolute",
				left: `${tick.x * zoom}px`,
				bottom: "0",
				width: "1px",
				height: tick.height,
				backgroundColor: "#666",
				pointerEvents: "none"
			};
		});
		const getHandlePosition = computed(() => (side) => {
			const handle = side === "left" ? leftHandle : rightHandle;
			const zoom = currentZoom.value;
			return { left: `${handle.x * zoom}px` };
		});
		const getVerticalIndicatorStyle = computed(() => {
			if (!ruler.value) return {
				left: "0px",
				minHeight: "100%"
			};
			const zoom = currentZoom.value;
			const editor = ruler.value.parentElement?.querySelector(".super-editor") ?? document.querySelector(".super-editor");
			if (!editor) return {
				left: `${currentHandle.value.x * zoom}px`,
				minHeight: "100%"
			};
			const editorBounds = editor.getBoundingClientRect();
			return {
				left: `${currentHandle.value.x * zoom}px`,
				minHeight: `${editorBounds.height}px`
			};
		});
		const screenToLocalX = (screenX) => {
			if (!ruler.value) return screenX;
			const rulerRect = ruler.value.getBoundingClientRect();
			const zoom = currentZoom.value;
			return (screenX - rulerRect.left) / zoom;
		};
		const handleMouseDown = (event) => {
			isDragging.value = true;
			setRulerHandleActive();
			currentHandle.value = event.currentTarget.id === "left-margin-handle" ? leftHandle : rightHandle;
			initialX.value = currentHandle.value.x;
			offsetX = screenToLocalX(event.clientX) - currentHandle.value.x;
			showVerticalIndicator.value = true;
		};
		const handleMouseMove = (event) => {
			if (!isDragging.value || !pageSize.value) return;
			const newLeft = screenToLocalX(event.clientX) - offsetX;
			const pageWidthPx = pageSize.value.width * PPI;
			const otherHandleX = currentHandle.value.side === "left" ? rightHandle.x : leftHandle.x;
			currentHandle.value.x = clampHandlePosition(newLeft, currentHandle.value.side, otherHandleX, pageWidthPx, MIN_WIDTH);
		};
		const handleMouseUp = () => {
			isDragging.value = false;
			showVerticalIndicator.value = false;
			setRulerHandleInactive();
			if (currentHandle.value && currentHandle.value.x !== initialX.value) {
				const marginValue = getNewMarginValue();
				emit("margin-change", {
					side: currentHandle.value.side,
					value: marginValue,
					sectionIndex: currentSectionIndex.value
				});
			}
		};
		const setRulerHandleActive = () => {
			rulerHandleOriginalColor.value = rulerHandleActiveColor.value;
		};
		const setRulerHandleInactive = () => {
			rulerHandleOriginalColor.value = "#CCC";
		};
		const getNewMarginValue = () => {
			if (!pageSize.value) return 0;
			const pageWidthPx = pageSize.value.width * PPI;
			return calculateMarginFromHandle(currentHandle.value.x, currentHandle.value.side, pageWidthPx, PPI);
		};
		const wrapperStyle = computed(() => {
			const scaledWidth = (rulerDefinition.value?.widthPx ?? pageSize.value?.width * PPI ?? 816) * currentZoom.value;
			return {
				width: `${scaledWidth}px`,
				minWidth: `${scaledWidth}px`,
				height: "25px",
				overflow: "visible",
				flexShrink: 0
			};
		});
		const rulerStyle = computed(() => {
			return {
				width: `${(rulerDefinition.value?.widthPx ?? pageSize.value?.width * PPI ?? 816) * currentZoom.value}px`,
				height: "25px"
			};
		});
		const getStyleVars = computed(() => {
			return {
				"--alignment": alignment,
				"--ruler-handle-color": rulerHandleOriginalColor.value,
				"--ruler-handle-active-color": rulerHandleActiveColor.value
			};
		});
		const handleSelectionUpdate = () => {
			if (isDragging.value) return;
			updateRulerForCurrentSection();
		};
		const handleZoomChange = ({ zoom }) => {
			currentZoom.value = zoom;
		};
		const initializeZoom = () => {
			const presentationEditor = getPresentationEditor();
			if (presentationEditor && typeof presentationEditor.zoom === "number") currentZoom.value = presentationEditor.zoom;
			else currentZoom.value = 1;
		};
		const setupEditorListeners = () => {
			if (!props.editor) return;
			selectionUpdateHandler = handleSelectionUpdate;
			props.editor.on("selectionUpdate", selectionUpdateHandler);
			const presentationEditor = getPresentationEditor();
			if (presentationEditor) {
				zoomChangeHandler = handleZoomChange;
				presentationEditor.on("zoomChange", zoomChangeHandler);
				initializeZoom();
			}
		};
		const cleanupEditorListeners = () => {
			if (props.editor && selectionUpdateHandler) {
				props.editor.off("selectionUpdate", selectionUpdateHandler);
				selectionUpdateHandler = null;
			}
			const presentationEditor = getPresentationEditor();
			if (presentationEditor && zoomChangeHandler) {
				presentationEditor.off("zoomChange", zoomChangeHandler);
				zoomChangeHandler = null;
			}
		};
		const getPresentationEditorFrom = (editor) => {
			if (!editor) return null;
			if (typeof editor.zoom === "number" && typeof editor.setZoom === "function") return editor;
			return editor.presentationEditor ?? null;
		};
		watch(() => props.editor, (newEditor, oldEditor) => {
			if (oldEditor) {
				if (selectionUpdateHandler) oldEditor.off("selectionUpdate", selectionUpdateHandler);
				const oldPresentationEditor = getPresentationEditorFrom(oldEditor);
				if (oldPresentationEditor && zoomChangeHandler) oldPresentationEditor.off("zoomChange", zoomChangeHandler);
			}
			if (zoomChangeHandler && !oldEditor) zoomChangeHandler = null;
			if (newEditor) {
				setupEditorListeners();
				updateRulerForCurrentSection();
			}
		});
		onMounted(() => {
			updateRulerForCurrentSection();
			setupEditorListeners();
			window.addEventListener("mousemove", handleMouseMove);
			window.addEventListener("mouseup", handleMouseUp);
		});
		onUnmounted(() => {
			cleanupEditorListeners();
			window.removeEventListener("mousemove", handleMouseMove);
			window.removeEventListener("mouseup", handleMouseUp);
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "ruler-wrapper",
				style: normalizeStyle([wrapperStyle.value, getStyleVars.value])
			}, [createElementVNode("div", {
				class: "ruler",
				ref_key: "ruler",
				ref: ruler,
				style: normalizeStyle(rulerStyle.value)
			}, [
				createElementVNode("div", {
					class: "margin-handle handle-left",
					id: "left-margin-handle",
					onMousedown: handleMouseDown,
					style: normalizeStyle(getHandlePosition.value("left"))
				}, null, 36),
				createElementVNode("div", {
					class: "margin-handle handle-right",
					id: "right-margin-handle",
					onMousedown: handleMouseDown,
					style: normalizeStyle(getHandlePosition.value("right"))
				}, null, 36),
				showVerticalIndicator.value ? (openBlock(), createElementBlock("div", {
					key: 0,
					class: "vertical-indicator",
					style: normalizeStyle(getVerticalIndicatorStyle.value)
				}, null, 4)) : createCommentVNode("", true),
				rulerDefinition.value ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(rulerDefinition.value.ticks, (tick, index) => {
					return openBlock(), createElementBlock("div", {
						key: index,
						class: normalizeClass(["ruler-tick", `ruler-tick--${tick.size}`]),
						style: normalizeStyle(getTickStyle.value(tick))
					}, [tick.label !== void 0 ? (openBlock(), createElementBlock("span", {
						key: 0,
						class: normalizeClass(["numbering", { "numbering--edge-start": tick.x === 0 }])
					}, toDisplayString(tick.label), 3)) : createCommentVNode("", true)], 6);
				}), 128)) : createCommentVNode("", true)
			], 4)], 4);
		};
	}
}, [["__scopeId", "data-v-0c05f0ba"]]);
var GenericPopover_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "GenericPopover",
	props: {
		editor: {
			type: Object,
			required: true
		},
		styles: {
			type: Object,
			default: () => ({})
		},
		visible: {
			type: Boolean,
			default: false
		},
		position: {
			type: Object,
			default: () => ({
				left: "0px",
				top: "0px"
			})
		}
	},
	emits: ["close"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const popover = ref(null);
		function handleClickOutside$1(event) {
			if (popover.value && !popover.value.contains(event.target)) emit("close");
			moveCursorToMouseEvent(event, props.editor);
		}
		function handleEscape(event) {
			if (event.key === "Escape") emit("close");
		}
		watch(() => props.visible, (val) => {
			if (val) {
				document.addEventListener("pointerdown", handleClickOutside$1);
				document.addEventListener("keydown", handleEscape);
			} else {
				document.removeEventListener("pointerdown", handleClickOutside$1);
				document.removeEventListener("keydown", handleEscape);
			}
		});
		onMounted(() => {
			if (props.visible) {
				document.addEventListener("pointerdown", handleClickOutside$1);
				document.addEventListener("keydown", handleEscape);
			}
		});
		onBeforeUnmount(() => {
			document.removeEventListener("pointerdown", handleClickOutside$1);
			document.removeEventListener("keydown", handleEscape);
		});
		const derivedStyles = computed(() => ({
			left: props.position.left,
			top: props.position.top,
			...props.styles
		}));
		return (_ctx, _cache) => {
			return __props.visible ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: "generic-popover",
				style: normalizeStyle(derivedStyles.value),
				ref_key: "popover",
				ref: popover,
				onPointerdown: _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop"])),
				onClick: _cache[1] || (_cache[1] = withModifiers(() => {}, ["stop"]))
			}, [renderSlot(_ctx.$slots, "default", {}, void 0, true)], 36)) : createCommentVNode("", true);
		};
	}
}, [["__scopeId", "data-v-9df8c02c"]]);
var _sfc_main$4 = {};
var _hoisted_1$3 = { class: "placeholder-editor" };
var _hoisted_2$1 = { class: "placeholder-block" };
var _hoisted_3 = { class: "placeholder-block placeholder-block--narrow" };
var _hoisted_4 = { class: "placeholder-block" };
var _hoisted_5 = { class: "placeholder-block placeholder-block--tail" };
function _sfc_render(_ctx, _cache) {
	return openBlock(), createElementBlock("div", _hoisted_1$3, [
		_cache[4] || (_cache[4] = createElementVNode("div", { class: "placeholder-title" }, [createElementVNode("div", { class: "placeholder-line placeholder-line--60" })], -1)),
		createElementVNode("div", _hoisted_2$1, [(openBlock(), createElementBlock(Fragment, null, renderList(7, (n) => {
			return createElementVNode("div", {
				key: `p-1-${n}`,
				class: "placeholder-line"
			});
		}), 64)), _cache[0] || (_cache[0] = createElementVNode("div", { class: "placeholder-line placeholder-line--60" }, null, -1))]),
		createElementVNode("div", _hoisted_3, [(openBlock(), createElementBlock(Fragment, null, renderList(6, (n) => {
			return createElementVNode("div", {
				key: `p-2-${n}`,
				class: "placeholder-line placeholder-line--30"
			});
		}), 64))]),
		createElementVNode("div", _hoisted_4, [
			_cache[1] || (_cache[1] = createElementVNode("div", { class: "placeholder-line placeholder-line--60" }, null, -1)),
			(openBlock(), createElementBlock(Fragment, null, renderList(7, (n) => {
				return createElementVNode("div", {
					key: `p-3-${n}`,
					class: "placeholder-line"
				});
			}), 64)),
			_cache[2] || (_cache[2] = createElementVNode("div", { class: "placeholder-line placeholder-line--30" }, null, -1))
		]),
		createElementVNode("div", _hoisted_5, [(openBlock(), createElementBlock(Fragment, null, renderList(8, (n) => {
			return createElementVNode("div", {
				key: `p-4-${n}`,
				class: "placeholder-line"
			});
		}), 64)), _cache[3] || (_cache[3] = createElementVNode("div", { class: "placeholder-line placeholder-line--70" }, null, -1))])
	]);
}
var EditorSkeleton_default = /* @__PURE__ */ __plugin_vue_export_helper_default(_sfc_main$4, [["render", _sfc_render], ["__scopeId", "data-v-48c88161"]]);
var _hoisted_1$2 = [
	"data-boundary-index",
	"data-boundary-type",
	"onMousedown"
];
var _hoisted_2 = ["data-row-boundary-index", "onMousedown"];
var RESIZE_HANDLE_WIDTH_PX = 9;
var RESIZE_HANDLE_HEIGHT_PX = 9;
var RESIZE_HANDLE_OFFSET_PX = 4;
var THROTTLE_INTERVAL_MS = 16;
var MIN_RESIZE_DELTA_PX = 1;
var TableResizeOverlay_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "TableResizeOverlay",
	props: {
		editor: {
			type: Object,
			required: true
		},
		visible: {
			type: Boolean,
			default: false
		},
		tableElement: {
			type: Object,
			default: null
		}
	},
	emits: [
		"resize-start",
		"resize-move",
		"resize-end",
		"resize-success",
		"resize-error"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const overlayEl = ref(null);
		const overlayRect = ref(null);
		const tableScreenWidth = computed(() => `${overlayRect.value?.width ?? 0}px`);
		const tableScreenHeight = computed(() => `${overlayRect.value?.height ?? 0}px`);
		const isViewingMode = () => props.editor?.options?.documentMode === "viewing";
		const tableMetadata = ref(null);
		function normalizeColumnMinWidth(width, rawMin) {
			const safeWidth = Math.max(1, Number(width) || 1);
			const safeMin = Math.max(1, Number(rawMin) || 1);
			if (safeMin < safeWidth) return safeMin;
			if (safeWidth <= 2) return 1;
			const candidate = Math.max(1, Math.max(25, Math.floor(safeWidth * .5)));
			return Math.min(safeWidth - 1, candidate);
		}
		const getZoom = () => {
			const editor = props.editor;
			if (editor && typeof editor.zoom === "number") return editor.zoom;
			if (editor?.presentationEditor && typeof editor.presentationEditor.zoom === "number") return editor.presentationEditor.zoom;
			console.warn("[TableResizeOverlay] getZoom: Unable to retrieve zoom from editor instance, using fallback value of 1. This may indicate the editor is not fully initialized or is not a PresentationEditor instance. Table resize handles may be misaligned.");
			return 1;
		};
		const dragState = ref(null);
		const rowDragState = ref(null);
		const forcedCleanup = ref(false);
		let rafId = null;
		let isUnmounted = false;
		function removeInteractionCancelListeners() {
			window.removeEventListener("blur", onInteractionCancel);
			document.removeEventListener("visibilitychange", onInteractionCancel);
		}
		function cancelActiveResizeDrag() {
			if (!dragState.value && !rowDragState.value) return;
			forcedCleanup.value = true;
			if (dragState.value) onDocumentMouseUp(new MouseEvent("mouseup"));
			if (rowDragState.value) onRowDocumentMouseUp();
			forcedCleanup.value = false;
		}
		function onInteractionCancel(event) {
			if (!dragState.value && !rowDragState.value) return;
			if (event?.type === "visibilitychange" && document.visibilityState === "visible") return;
			if (document.visibilityState && document.visibilityState !== "visible") {
				cancelActiveResizeDrag();
				return;
			}
			cancelActiveResizeDrag();
		}
		function startOverlayTracking() {
			if (rafId !== null) return;
			const step = () => {
				updateOverlayRect();
				rafId = requestAnimationFrame(step);
			};
			rafId = requestAnimationFrame(step);
		}
		function stopOverlayTracking() {
			if (rafId !== null) {
				cancelAnimationFrame(rafId);
				rafId = null;
			}
		}
		const overlayStyle = computed(() => {
			if (!overlayRect.value || !props.tableElement) return {};
			const rect = overlayRect.value;
			const isDragging = dragState.value || rowDragState.value;
			return {
				position: "absolute",
				left: `${rect.left}px`,
				top: `${rect.top}px`,
				width: `${rect.width}px`,
				height: `${rect.height}px`,
				pointerEvents: isDragging ? "auto" : "none",
				zIndex: 10
			};
		});
		function updateOverlayRect() {
			if (!props.tableElement) {
				overlayRect.value = null;
				return;
			}
			const tableRect = props.tableElement.getBoundingClientRect();
			if (tableRect.width === 0 || tableRect.height === 0) {
				overlayRect.value = null;
				return;
			}
			const referenceEl = overlayEl.value?.offsetParent;
			if (referenceEl) {
				const referenceRect = referenceEl.getBoundingClientRect();
				overlayRect.value = {
					left: tableRect.left - referenceRect.left + (referenceEl.scrollLeft || 0),
					top: tableRect.top - referenceRect.top + (referenceEl.scrollTop || 0),
					width: tableRect.width,
					height: tableRect.height
				};
			} else overlayRect.value = {
				left: props.tableElement.offsetLeft,
				top: props.tableElement.offsetTop,
				width: tableRect.width,
				height: tableRect.height
			};
		}
		const isRtlTable$1 = computed(() => tableMetadata.value?.rtl === true);
		const tableContentWidth = computed(() => {
			const columns = tableMetadata.value?.columns;
			if (!columns || columns.length === 0) return 0;
			const last = columns[columns.length - 1];
			return last.x + last.w;
		});
		const tableContentLeft = computed(() => {
			const columns = tableMetadata.value?.columns;
			if (!columns || columns.length === 0) return 0;
			return columns[0].x;
		});
		const resizableBoundaries = computed(() => {
			if (!tableMetadata.value?.columns) return [];
			const columns = tableMetadata.value.columns;
			const boundaries = [];
			for (let i = 0; i < columns.length - 1; i++) {
				const col = columns[i];
				const logicalX = columns[i + 1].x;
				const visualX = isRtlTable$1.value ? tableContentLeft.value + tableContentWidth.value - logicalX : logicalX;
				boundaries.push({
					...col,
					index: i,
					x: visualX,
					type: "inner"
				});
			}
			const lastCol = columns[columns.length - 1];
			const rtlRightEdgeX = tableContentWidth.value;
			boundaries.push({
				...lastCol,
				index: isRtlTable$1.value ? 0 : columns.length - 1,
				x: isRtlTable$1.value ? rtlRightEdgeX : lastCol.x + lastCol.w,
				type: "right-edge"
			});
			return boundaries;
		});
		const resizableRowBoundaries = computed(() => {
			if (!tableMetadata.value?.rows || !Array.isArray(tableMetadata.value.rows)) return [];
			return tableMetadata.value.rows.filter((row) => row.r === 1).map((row) => ({
				...row,
				handleY: row.y + row.h
			}));
		});
		function getBoundarySegments(boundary) {
			if (boundary.type === "right-edge") return [{
				y: 0,
				h: null
			}];
			const segmentsData = tableMetadata.value?.segments;
			if (!segmentsData || !Array.isArray(segmentsData)) return [{
				y: 0,
				h: null
			}];
			const colSegments = segmentsData[boundary.index + 1];
			if (!colSegments || colSegments.length === 0) return [];
			return colSegments.filter((seg) => seg && typeof seg === "object").map((seg) => ({
				y: typeof seg.y === "number" ? seg.y : 0,
				h: seg.h !== null && typeof seg.h === "number" ? seg.h : null
			}));
		}
		function getSegmentHandleStyle(boundary, segment) {
			const zoom = getZoom();
			const scaledX = boundary.x * zoom;
			const scaledY = segment.y != null ? segment.y * zoom : null;
			const scaledH = segment.h != null ? segment.h * zoom : null;
			return {
				position: "absolute",
				left: `${scaledX}px`,
				top: scaledY != null ? `${scaledY}px` : "0",
				width: `${RESIZE_HANDLE_WIDTH_PX}px`,
				height: scaledH != null ? `${scaledH}px` : tableScreenHeight.value,
				transform: `translateX(-${RESIZE_HANDLE_OFFSET_PX}px)`,
				cursor: "col-resize",
				pointerEvents: "auto"
			};
		}
		const guidelineStyle = computed(() => {
			if (!dragState.value || !tableMetadata.value) return { display: "none" };
			const initialBoundary = resizableBoundaries.value[dragState.value.resizableBoundaryIndex];
			if (!initialBoundary) return { display: "none" };
			const zoom = getZoom();
			return {
				position: "absolute",
				left: `${(initialBoundary.x + dragState.value.constrainedDelta) * zoom}px`,
				top: "0",
				width: "2px",
				height: tableScreenHeight.value,
				backgroundColor: "#4A90E2",
				pointerEvents: "none",
				zIndex: 20
			};
		});
		function getRowHandleStyle(rowBoundary) {
			const zoom = getZoom();
			return {
				position: "absolute",
				left: "0",
				top: `${rowBoundary.handleY * zoom}px`,
				width: tableScreenWidth.value,
				height: `${RESIZE_HANDLE_HEIGHT_PX}px`,
				transform: `translateY(-${RESIZE_HANDLE_OFFSET_PX}px)`,
				cursor: "row-resize",
				pointerEvents: "auto"
			};
		}
		const rowGuidelineStyle = computed(() => {
			if (!rowDragState.value || !tableMetadata.value) return { display: "none" };
			const rowBoundary = resizableRowBoundaries.value[rowDragState.value.rowBoundaryIndex];
			if (!rowBoundary) return { display: "none" };
			const zoom = getZoom();
			return {
				position: "absolute",
				left: "0",
				top: `${(rowBoundary.handleY + rowDragState.value.constrainedDelta) * zoom}px`,
				width: tableScreenWidth.value,
				height: "2px",
				backgroundColor: "#4A90E2",
				pointerEvents: "none",
				zIndex: 20
			};
		});
		function parseTableMetadata() {
			if (!props.tableElement) {
				tableMetadata.value = null;
				return;
			}
			try {
				const boundariesAttr = props.tableElement.getAttribute("data-table-boundaries");
				if (!boundariesAttr) {
					tableMetadata.value = null;
					return;
				}
				const parsed = JSON.parse(boundariesAttr);
				if (!parsed || typeof parsed !== "object" || !Array.isArray(parsed.columns)) {
					tableMetadata.value = null;
					return;
				}
				const validatedColumns = parsed.columns.filter((col) => {
					return typeof col === "object" && Number.isFinite(col.i) && col.i >= 0 && Number.isFinite(col.x) && col.x >= 0 && Number.isFinite(col.w) && col.w > 0 && Number.isFinite(col.min) && col.min > 0 && (col.r === 0 || col.r === 1);
				}).map((col) => ({
					w: Math.max(1, col.w),
					min: normalizeColumnMinWidth(col.w, col.min),
					i: col.i,
					x: Math.max(0, col.x),
					r: col.r
				}));
				if (validatedColumns.length === 0) {
					tableMetadata.value = null;
					emit("resize-error", {
						error: "Table metadata is corrupted or empty after validation",
						rawMetadata: boundariesAttr
					});
					return;
				}
				tableMetadata.value = {
					columns: validatedColumns,
					segments: Array.isArray(parsed.segments) ? parsed.segments : void 0,
					rows: Array.isArray(parsed.rows) ? parsed.rows.filter((row) => typeof row === "object" && Number.isFinite(row.i) && row.i >= 0 && Number.isFinite(row.y) && row.y >= 0 && Number.isFinite(row.h) && row.h > 0 && Number.isFinite(row.min) && row.min > 0 && (row.r === 0 || row.r === 1)) : void 0,
					rtl: parsed.rtl === true
				};
			} catch (error) {
				tableMetadata.value = null;
				emit("resize-error", {
					error: error instanceof Error ? error.message : "Failed to parse table boundaries",
					rawMetadata: props.tableElement?.getAttribute("data-table-boundaries")
				});
			}
		}
		function onHandleMouseDown(event, resizableBoundaryIndex) {
			event.preventDefault();
			event.stopPropagation();
			if (isViewingMode()) return;
			if (!tableMetadata.value?.columns) return;
			const boundary = resizableBoundaries.value[resizableBoundaryIndex];
			if (!boundary) return;
			const columns = tableMetadata.value.columns;
			const isRightEdge = boundary.type === "right-edge";
			const leftColumn = columns[boundary.index];
			const rightColumn = isRightEdge ? null : columns[boundary.index + 1];
			dragState.value = {
				columnIndex: boundary.index,
				resizableBoundaryIndex,
				isRightEdge,
				initialX: event.clientX,
				initialWidths: columns.map((col) => col.w),
				leftColumn: {
					width: leftColumn.w,
					minWidth: leftColumn.min
				},
				rightColumn: rightColumn ? {
					width: rightColumn.w,
					minWidth: rightColumn.min
				} : null,
				constrainedDelta: 0
			};
			if (!props.editor?.view?.dom) {
				emit("resize-error", { error: "Editor view not available" });
				dragState.value = null;
				return;
			}
			const pmView = props.editor.view.dom;
			pmView.style.pointerEvents = "none";
			try {
				document.addEventListener("mousemove", onDocumentMouseMove$1);
				document.addEventListener("mouseup", onDocumentMouseUp);
				window.addEventListener("blur", onInteractionCancel);
				document.addEventListener("visibilitychange", onInteractionCancel);
				emit("resize-start", {
					columnIndex: boundary.index,
					isRightEdge,
					initialWidths: dragState.value.initialWidths
				});
			} catch (error) {
				document.removeEventListener("mousemove", onDocumentMouseMove$1);
				document.removeEventListener("mouseup", onDocumentMouseUp);
				pmView.style.pointerEvents = "auto";
				dragState.value = null;
				emit("resize-error", { error: error instanceof Error ? error.message : String(error) });
			}
		}
		function throttle$1(func, limit) {
			let inThrottle;
			let timeoutId = null;
			const throttled = function(...args$1) {
				if (!inThrottle) {
					func.apply(this, args$1);
					inThrottle = true;
					timeoutId = setTimeout(() => {
						inThrottle = false;
						timeoutId = null;
					}, limit);
				}
			};
			const cancel = () => {
				if (timeoutId !== null) {
					clearTimeout(timeoutId);
					timeoutId = null;
					inThrottle = false;
				}
			};
			return {
				throttled,
				cancel
			};
		}
		const mouseMoveThrottle = throttle$1((event) => {
			if (isUnmounted || !dragState.value) return;
			const zoom = getZoom();
			const visualDelta = (event.clientX - dragState.value.initialX) / zoom;
			const delta = isRtlTable$1.value && !dragState.value.isRightEdge ? -visualDelta : visualDelta;
			const minDelta = -(dragState.value.leftColumn.width - dragState.value.leftColumn.minWidth);
			let maxDelta;
			if (dragState.value.isRightEdge) {
				const tableRect = props.tableElement.getBoundingClientRect();
				const pageEl = props.tableElement.closest(".superdoc-page");
				if (pageEl) {
					const pageRect = pageEl.getBoundingClientRect();
					const rightMargin = tableRect.left - pageRect.left;
					const availableSpace = (pageRect.right - rightMargin - tableRect.right) / zoom;
					maxDelta = Math.max(0, availableSpace);
				} else maxDelta = Infinity;
			} else maxDelta = dragState.value.rightColumn.width - dragState.value.rightColumn.minWidth;
			const constrainedDelta = Math.max(minDelta, Math.min(maxDelta, delta));
			const constrainedVisualDelta = isRtlTable$1.value && !dragState.value.isRightEdge ? -constrainedDelta : constrainedDelta;
			dragState.value.constrainedDelta = constrainedVisualDelta;
			emit("resize-move", {
				columnIndex: dragState.value.columnIndex,
				delta: constrainedDelta
			});
		}, THROTTLE_INTERVAL_MS);
		const onDocumentMouseMove$1 = mouseMoveThrottle.throttled;
		function onDocumentMouseUp(event) {
			if (!dragState.value) return;
			const visualFinalDelta = dragState.value.constrainedDelta;
			const finalDelta = isRtlTable$1.value && !dragState.value.isRightEdge ? -visualFinalDelta : visualFinalDelta;
			const columnIndex = dragState.value.columnIndex;
			const initialWidths = dragState.value.initialWidths;
			const isRightEdge = dragState.value.isRightEdge;
			const newWidths = [...initialWidths];
			newWidths[columnIndex] = initialWidths[columnIndex] + finalDelta;
			if (!isRightEdge) newWidths[columnIndex + 1] = initialWidths[columnIndex + 1] - finalDelta;
			document.removeEventListener("mousemove", onDocumentMouseMove$1);
			document.removeEventListener("mouseup", onDocumentMouseUp);
			removeInteractionCancelListeners();
			if (props.editor?.view?.dom) {
				const pmView = props.editor.view.dom;
				pmView.style.pointerEvents = "auto";
			}
			if (!forcedCleanup.value && Math.abs(finalDelta) > MIN_RESIZE_DELTA_PX) dispatchResizeTransaction(columnIndex, newWidths, isRightEdge);
			emit("resize-end", {
				columnIndex,
				finalWidths: newWidths,
				delta: finalDelta
			});
			dragState.value = null;
		}
		function dispatchResizeTransaction(columnIndex, newWidths, isRightEdge = false) {
			if (!props.editor?.view || !props.tableElement) return;
			try {
				const { state, dispatch } = props.editor.view;
				const tr = state.tr;
				const tablePos = findTablePosition(state, props.tableElement);
				if (tablePos === null) {
					emit("resize-error", {
						columnIndex,
						error: "Table position not found in document"
					});
					return;
				}
				const tableNode = state.doc.nodeAt(tablePos);
				if (!tableNode || tableNode.type.name !== "table") {
					emit("resize-error", {
						columnIndex,
						error: "Invalid table node at position"
					});
					return;
				}
				const newGrid = newWidths.map((w) => pixelsToTwips(w)).map((twips) => ({ col: twips }));
				const newAttrs = buildWidthAuthoringTableAttrs(tableNode.attrs, { grid: newGrid });
				tr.setNodeMarkup(tablePos, null, newAttrs);
				updateCellColwidths(tr, tableNode, tablePos, isRightEdge ? [columnIndex] : [columnIndex, columnIndex + 1], newWidths);
				dispatch(tr);
				const blockId = props.tableElement?.getAttribute("data-sd-block-id");
				if (blockId && blockId.trim()) measureCache.invalidate([blockId]);
				emit("resize-success", {
					columnIndex,
					newWidths
				});
			} catch (error) {
				emit("resize-error", {
					columnIndex,
					error: error instanceof Error ? error.message : String(error)
				});
			}
		}
		function findTablePosition(state, tableElement) {
			const pmElement = tableElement.querySelector("[data-pm-start]");
			if (!pmElement) return null;
			const pmStartAttr = pmElement.getAttribute("data-pm-start");
			if (!pmStartAttr) return null;
			const pmStart = parseInt(pmStartAttr, 10);
			if (!Number.isFinite(pmStart)) return null;
			let tablePos = null;
			state.doc.descendants((node, pos) => {
				if (node.type.name === "table") {
					const tableEnd = pos + node.nodeSize;
					if (pmStart >= pos && pmStart < tableEnd) {
						tablePos = pos;
						return false;
					}
				}
			});
			return tablePos;
		}
		function updateCellColwidths(tr, tableNode, tablePos, affectedColumns, newWidths) {
			let currentCol = 0;
			tableNode.descendants((node, pos, parent) => {
				if (node.type.name === "tableRow") {
					currentCol = 0;
					return true;
				}
				if (node.type.name === "tableCell" || node.type.name === "tableHeader") {
					const { colspan = 1 } = node.attrs;
					if (affectedColumns.some((affectedCol) => affectedCol >= currentCol && affectedCol < currentCol + colspan)) {
						const absolutePos = tablePos + 1 + pos;
						const newColwidth = [];
						for (let i = 0; i < colspan; i++) {
							const width = newWidths[currentCol + i];
							if (width !== void 0 && width > 0) newColwidth.push(width);
						}
						if (newColwidth.length > 0) {
							const spanTwips = newColwidth.reduce((sum, w) => sum + pixelsToTwips(w), 0);
							const existingTableCellProperties = node.attrs.tableCellProperties;
							const tableCellProperties = {
								...existingTableCellProperties && typeof existingTableCellProperties === "object" ? existingTableCellProperties : {},
								cellWidth: {
									value: spanTwips,
									type: "dxa"
								}
							};
							tr.setNodeMarkup(absolutePos, null, {
								...node.attrs,
								colwidth: newColwidth,
								tableCellProperties
							});
						}
					}
					currentCol += colspan;
					return false;
				}
				return true;
			});
		}
		function onRowHandleMouseDown(event, rowBoundaryIndex) {
			event.preventDefault();
			event.stopPropagation();
			if (isViewingMode()) return;
			const rowBoundary = resizableRowBoundaries.value[rowBoundaryIndex];
			if (!rowBoundary) return;
			rowDragState.value = {
				rowIndex: rowBoundary.i,
				rowBoundaryIndex,
				initialY: event.clientY,
				initialHeight: rowBoundary.h,
				minHeight: rowBoundary.min,
				constrainedDelta: 0
			};
			if (!props.editor?.view?.dom) {
				emit("resize-error", { error: "Editor view not available" });
				rowDragState.value = null;
				return;
			}
			props.editor.view.dom.style.pointerEvents = "none";
			document.addEventListener("mousemove", onRowDocumentMouseMove);
			document.addEventListener("mouseup", onRowDocumentMouseUp);
			window.addEventListener("blur", onInteractionCancel);
			document.addEventListener("visibilitychange", onInteractionCancel);
			emit("resize-start", { rowIndex: rowBoundary.i });
		}
		const rowMouseMoveThrottle = throttle$1((event) => {
			if (isUnmounted || !rowDragState.value) return;
			const zoom = getZoom();
			const delta = (event.clientY - rowDragState.value.initialY) / zoom;
			const minDelta = -(rowDragState.value.initialHeight - rowDragState.value.minHeight);
			const constrainedDelta = Math.max(minDelta, delta);
			rowDragState.value.constrainedDelta = constrainedDelta;
			emit("resize-move", {
				rowIndex: rowDragState.value.rowIndex,
				delta: constrainedDelta
			});
		}, THROTTLE_INTERVAL_MS);
		const onRowDocumentMouseMove = rowMouseMoveThrottle.throttled;
		function onRowDocumentMouseUp() {
			if (!rowDragState.value) return;
			const finalDelta = rowDragState.value.constrainedDelta;
			const rowIndex = rowDragState.value.rowIndex;
			const newHeight = rowDragState.value.initialHeight + finalDelta;
			document.removeEventListener("mousemove", onRowDocumentMouseMove);
			document.removeEventListener("mouseup", onRowDocumentMouseUp);
			removeInteractionCancelListeners();
			if (props.editor?.view?.dom) props.editor.view.dom.style.pointerEvents = "auto";
			if (!forcedCleanup.value && Math.abs(finalDelta) > MIN_RESIZE_DELTA_PX) dispatchRowResizeTransaction(rowIndex, newHeight);
			emit("resize-end", {
				rowIndex,
				newHeight,
				delta: finalDelta
			});
			rowDragState.value = null;
		}
		function dispatchRowResizeTransaction(rowIndex, newHeightPx) {
			if (!props.editor?.view || !props.tableElement) return;
			try {
				const { state, dispatch } = props.editor.view;
				const tr = state.tr;
				const tablePos = findTablePosition(state, props.tableElement);
				if (tablePos === null) {
					emit("resize-error", {
						rowIndex,
						error: "Table position not found"
					});
					return;
				}
				const tableNode = state.doc.nodeAt(tablePos);
				if (!tableNode || tableNode.type.name !== "table") {
					emit("resize-error", {
						rowIndex,
						error: "Invalid table node"
					});
					return;
				}
				let currentRowIdx = 0;
				let rowPos = null;
				let rowNode = null;
				tableNode.forEach((child, offset$1) => {
					if (child.type.name === "tableRow" && currentRowIdx === rowIndex) {
						rowPos = tablePos + 1 + offset$1;
						rowNode = child;
					}
					if (child.type.name === "tableRow") currentRowIdx++;
				});
				if (rowPos === null || !rowNode) {
					emit("resize-error", {
						rowIndex,
						error: "Row not found at index"
					});
					return;
				}
				const heightTwips = pixelsToTwips(newHeightPx);
				const existingRowProps = rowNode.attrs.tableRowProperties || {};
				const newAttrs = {
					...rowNode.attrs,
					rowHeight: newHeightPx,
					tableRowProperties: {
						...existingRowProps,
						rowHeight: {
							value: heightTwips,
							rule: "atLeast"
						}
					}
				};
				tr.setNodeMarkup(rowPos, null, newAttrs);
				dispatch(tr);
				const blockId = props.tableElement?.getAttribute("data-sd-block-id");
				if (blockId && blockId.trim()) measureCache.invalidate([blockId]);
				emit("resize-success", {
					rowIndex,
					newHeight: newHeightPx
				});
			} catch (error) {
				emit("resize-error", {
					rowIndex,
					error: error instanceof Error ? error.message : String(error)
				});
			}
		}
		watch(() => props.tableElement, () => {
			parseTableMetadata();
			updateOverlayRect();
			if (props.visible && props.tableElement) startOverlayTracking();
			else if (!props.tableElement) stopOverlayTracking();
		}, { immediate: true });
		watch(() => props.visible, (visible) => {
			if (visible) {
				parseTableMetadata();
				updateOverlayRect();
				startOverlayTracking();
			} else {
				stopOverlayTracking();
				cancelActiveResizeDrag();
			}
		});
		onMounted(() => {
			window.addEventListener("scroll", updateOverlayRect, true);
			window.addEventListener("resize", updateOverlayRect);
			updateOverlayRect();
		});
		onBeforeUnmount(() => {
			isUnmounted = true;
			mouseMoveThrottle.cancel();
			rowMouseMoveThrottle.cancel();
			stopOverlayTracking();
			if (dragState.value) {
				document.removeEventListener("mousemove", onDocumentMouseMove$1);
				document.removeEventListener("mouseup", onDocumentMouseUp);
			}
			if (rowDragState.value) {
				document.removeEventListener("mousemove", onRowDocumentMouseMove);
				document.removeEventListener("mouseup", onRowDocumentMouseUp);
			}
			if ((dragState.value || rowDragState.value) && props.editor?.view?.dom) props.editor.view.dom.style.pointerEvents = "auto";
			removeInteractionCancelListeners();
			window.removeEventListener("scroll", updateOverlayRect, true);
			window.removeEventListener("resize", updateOverlayRect);
		});
		return (_ctx, _cache) => {
			return __props.visible && tableMetadata.value ? (openBlock(), createElementBlock("div", {
				key: 0,
				ref_key: "overlayEl",
				ref: overlayEl,
				class: "superdoc-table-resize-overlay",
				style: normalizeStyle(overlayStyle.value),
				onMousedown: _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop"]))
			}, [
				(openBlock(true), createElementBlock(Fragment, null, renderList(resizableBoundaries.value, (boundary, resizableBoundaryIndex) => {
					return openBlock(), createElementBlock(Fragment, { key: `boundary-${resizableBoundaryIndex}` }, [(openBlock(true), createElementBlock(Fragment, null, renderList(getBoundarySegments(boundary), (segment, segmentIndex) => {
						return withDirectives((openBlock(), createElementBlock("div", {
							key: `handle-${boundary.type}-${boundary.index}-${segmentIndex}`,
							class: normalizeClass(["resize-handle", {
								"resize-handle--active": dragState.value && dragState.value.resizableBoundaryIndex === resizableBoundaryIndex,
								"resize-handle--edge": boundary.type === "right-edge"
							}]),
							"data-boundary-index": resizableBoundaryIndex,
							"data-boundary-type": boundary.type,
							style: normalizeStyle(getSegmentHandleStyle(boundary, segment)),
							onMousedown: ($event) => onHandleMouseDown($event, resizableBoundaryIndex)
						}, null, 46, _hoisted_1$2)), [[vShow, !rowDragState.value]]);
					}), 128))], 64);
				}), 128)),
				dragState.value ? (openBlock(), createElementBlock("div", {
					key: 0,
					class: "resize-guideline",
					style: normalizeStyle(guidelineStyle.value)
				}, null, 4)) : createCommentVNode("", true),
				(openBlock(true), createElementBlock(Fragment, null, renderList(resizableRowBoundaries.value, (rowBoundary, rowBoundaryIndex) => {
					return withDirectives((openBlock(), createElementBlock("div", {
						key: `row-handle-${rowBoundary.i}`,
						class: normalizeClass(["resize-handle resize-handle--row", { "resize-handle--active": rowDragState.value && rowDragState.value.rowBoundaryIndex === rowBoundaryIndex }]),
						"data-row-boundary-index": rowBoundaryIndex,
						style: normalizeStyle(getRowHandleStyle(rowBoundary)),
						onMousedown: ($event) => onRowHandleMouseDown($event, rowBoundaryIndex)
					}, null, 46, _hoisted_2)), [[vShow, !dragState.value]]);
				}), 128)),
				rowDragState.value ? (openBlock(), createElementBlock("div", {
					key: 1,
					class: "resize-guideline resize-guideline--row",
					style: normalizeStyle(rowGuidelineStyle.value)
				}, null, 4)) : createCommentVNode("", true)
			], 36)) : createCommentVNode("", true);
		};
	}
}, [["__scopeId", "data-v-84086c7d"]]);
var _hoisted_1$1 = ["data-handle-position", "onMousedown"];
var OVERLAY_EXPANSION_PX = 2e3;
var RESIZE_HANDLE_SIZE_PX = 12;
var MOUSE_MOVE_THROTTLE_MS = 16;
var DIMENSION_CHANGE_THRESHOLD_PX = 1;
var Z_INDEX_OVERLAY = 10;
var Z_INDEX_HANDLE = 15;
var Z_INDEX_GUIDELINE = 20;
var ImageResizeOverlay_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "ImageResizeOverlay",
	props: {
		editor: {
			type: Object,
			required: true
		},
		visible: {
			type: Boolean,
			default: false
		},
		imageElement: {
			type: Object,
			default: null
		}
	},
	emits: [
		"resize-start",
		"resize-move",
		"resize-end",
		"resize-success",
		"resize-error"
	],
	setup(__props, { emit: __emit }) {
		useCssVars((_ctx) => ({
			"v5f180fdf": RESIZE_HANDLE_SIZE_PX + "px",
			"v6e602466": Z_INDEX_HANDLE
		}));
		function isValidEditor(editor) {
			return editor && typeof editor === "object" && editor.view && typeof editor.view === "object" && editor.view.dom instanceof HTMLElement && editor.view.state && typeof editor.view.dispatch === "function";
		}
		const props = __props;
		const emit = __emit;
		const resizeEditor = computed(() => {
			const editor = props.editor;
			return typeof editor?.getActiveEditor === "function" ? editor.getActiveEditor() : editor;
		});
		const isImageContentLocked = computed(() => {
			return isContentLockedMode(resolveImageLockMode(props.imageElement));
		});
		const isResizeDisabled = computed(() => resizeEditor.value?.options?.documentMode === "viewing" || !resizeEditor.value?.isEditable || isImageContentLocked.value);
		const imageMetadata = ref(null);
		const dragState = ref(null);
		const forcedCleanup = ref(false);
		function readLockMode(element) {
			return element?.dataset?.lockMode || element?.getAttribute?.("data-lock-mode") || null;
		}
		function resolveImageLockMode(imageElement) {
			if (!imageElement) return null;
			const lockModes = [];
			const directLockMode = readLockMode(imageElement);
			if (directLockMode) lockModes.push(directLockMode);
			imageElement.querySelectorAll?.("[data-lock-mode]").forEach((element) => {
				const lockMode = readLockMode(element);
				if (lockMode) lockModes.push(lockMode);
			});
			let sdtElement = imageElement.closest?.(".superdoc-structured-content-block[data-lock-mode], .superdoc-structured-content-inline[data-lock-mode]");
			while (sdtElement) {
				const lockMode = readLockMode(sdtElement);
				if (lockMode) lockModes.push(lockMode);
				sdtElement = sdtElement.parentElement?.closest?.(".superdoc-structured-content-block[data-lock-mode], .superdoc-structured-content-inline[data-lock-mode]");
			}
			return lockModes.find(isContentLockedMode) ?? lockModes[0] ?? null;
		}
		const overlayStyle = computed(() => {
			if (!props.imageElement || !props.imageElement.isConnected) return {};
			const imageRect = props.imageElement.getBoundingClientRect();
			const wrapper = props.imageElement.closest(".super-editor");
			if (!wrapper) return {
				position: "absolute",
				left: `${props.imageElement.offsetLeft}px`,
				top: `${props.imageElement.offsetTop}px`,
				width: `${imageRect.width}px`,
				height: `${imageRect.height}px`,
				pointerEvents: dragState.value ? "auto" : "none",
				zIndex: Z_INDEX_OVERLAY
			};
			const wrapperRect = wrapper.getBoundingClientRect();
			const scrollLeft = wrapper.scrollLeft || 0;
			const scrollTop = wrapper.scrollTop || 0;
			const relativeLeft = imageRect.left - wrapperRect.left + scrollLeft;
			const relativeTop = imageRect.top - wrapperRect.top + scrollTop;
			let overlayWidth = imageRect.width;
			let overlayHeight = imageRect.height;
			let offsetX = 0;
			let offsetY = 0;
			if (dragState.value) {
				const expansion = OVERLAY_EXPANSION_PX;
				overlayWidth = imageRect.width + expansion * 2;
				overlayHeight = imageRect.height + expansion * 2;
				offsetX = -expansion;
				offsetY = -expansion;
			}
			return {
				position: "absolute",
				left: `${relativeLeft + offsetX}px`,
				top: `${relativeTop + offsetY}px`,
				width: `${overlayWidth}px`,
				height: `${overlayHeight}px`,
				pointerEvents: dragState.value ? "auto" : "none",
				zIndex: Z_INDEX_OVERLAY
			};
		});
		const resizeHandles = computed(() => {
			if (!imageMetadata.value || !props.imageElement) return [];
			const rect = props.imageElement.getBoundingClientRect();
			const width = rect.width;
			const height = rect.height;
			const offset$1 = RESIZE_HANDLE_SIZE_PX / 2;
			const expansion = dragState.value ? OVERLAY_EXPANSION_PX : 0;
			return [
				{
					position: "nw",
					style: {
						left: `${expansion - offset$1}px`,
						top: `${expansion - offset$1}px`,
						cursor: "nwse-resize"
					}
				},
				{
					position: "ne",
					style: {
						left: `${expansion + width - offset$1}px`,
						top: `${expansion - offset$1}px`,
						cursor: "nesw-resize"
					}
				},
				{
					position: "sw",
					style: {
						left: `${expansion - offset$1}px`,
						top: `${expansion + height - offset$1}px`,
						cursor: "nesw-resize"
					}
				},
				{
					position: "se",
					style: {
						left: `${expansion + width - offset$1}px`,
						top: `${expansion + height - offset$1}px`,
						cursor: "nwse-resize"
					}
				}
			];
		});
		const guidelineStyle = computed(() => {
			if (!dragState.value || !props.imageElement) return { display: "none" };
			const expansion = OVERLAY_EXPANSION_PX;
			return {
				position: "absolute",
				left: `${expansion}px`,
				top: `${expansion}px`,
				width: `${dragState.value.constrainedWidth}px`,
				height: `${dragState.value.constrainedHeight}px`,
				border: "2px solid #4A90E2",
				pointerEvents: "none",
				zIndex: Z_INDEX_GUIDELINE,
				boxSizing: "border-box"
			};
		});
		function parseImageMetadata() {
			if (!props.imageElement || !props.imageElement.isConnected) {
				imageMetadata.value = null;
				return;
			}
			const metadataAttr = (props.imageElement.hasAttribute("data-image-metadata") ? props.imageElement : props.imageElement.querySelector?.("[data-image-metadata]"))?.getAttribute?.("data-image-metadata");
			try {
				if (!metadataAttr) {
					imageMetadata.value = null;
					return;
				}
				const parsed = JSON.parse(metadataAttr);
				if (!parsed || typeof parsed !== "object") {
					imageMetadata.value = null;
					return;
				}
				for (const field of [
					"originalWidth",
					"originalHeight",
					"maxWidth",
					"maxHeight",
					"aspectRatio",
					"minWidth",
					"minHeight"
				]) if (!Number.isFinite(parsed[field]) || parsed[field] <= 0) {
					console.warn(`[ImageResizeOverlay] Invalid or missing metadata field: ${field}`);
					imageMetadata.value = null;
					return;
				}
				imageMetadata.value = parsed;
			} catch (error) {
				imageMetadata.value = null;
				emit("resize-error", {
					error: error instanceof Error ? error.message : "Failed to parse image metadata",
					rawMetadata: metadataAttr
				});
			}
		}
		function onHandleMouseDown(event, handlePosition) {
			event.preventDefault();
			event.stopPropagation();
			if (isResizeDisabled.value) return;
			const editor = resizeEditor.value;
			if (!isValidEditor(editor) || !imageMetadata.value || !props.imageElement) return;
			const rect = props.imageElement.getBoundingClientRect();
			dragState.value = {
				handle: handlePosition,
				initialX: event.clientX,
				initialY: event.clientY,
				initialWidth: rect.width,
				initialHeight: rect.height,
				aspectRatio: imageMetadata.value.aspectRatio,
				constrainedWidth: rect.width,
				constrainedHeight: rect.height
			};
			const pmView = editor.view.dom;
			pmView.style.pointerEvents = "none";
			document.addEventListener("mousemove", onDocumentMouseMove$1);
			document.addEventListener("mouseup", onDocumentMouseUp);
			document.addEventListener("keydown", onEscapeKey);
			emit("resize-start", {
				blockId: props.imageElement.getAttribute("data-sd-block-id"),
				initialWidth: rect.width,
				initialHeight: rect.height
			});
		}
		function throttle$1(func, limit) {
			let inThrottle;
			let timeoutId = null;
			const throttled = function(...args$1) {
				if (!inThrottle) {
					func.apply(this, args$1);
					inThrottle = true;
					timeoutId = setTimeout(() => {
						inThrottle = false;
						timeoutId = null;
					}, limit);
				}
			};
			const cancel = () => {
				if (timeoutId !== null) {
					clearTimeout(timeoutId);
					timeoutId = null;
					inThrottle = false;
				}
			};
			return {
				throttled,
				cancel
			};
		}
		const mouseMoveThrottle = throttle$1((event) => {
			if (!dragState.value || !imageMetadata.value) return;
			let deltaX = event.clientX - dragState.value.initialX;
			let deltaY = event.clientY - dragState.value.initialY;
			const handle = dragState.value.handle;
			if (handle === "nw") {
				deltaX = -deltaX;
				deltaY = -deltaY;
			} else if (handle === "ne") deltaY = -deltaY;
			else if (handle === "sw") deltaX = -deltaX;
			const scaleX = (dragState.value.initialWidth + deltaX) / dragState.value.initialWidth;
			const scaleY = (dragState.value.initialHeight + deltaY) / dragState.value.initialHeight;
			const scale = Math.max(scaleX, scaleY);
			let newWidth = dragState.value.initialWidth * scale;
			let newHeight = dragState.value.initialHeight * scale;
			const minWidth = imageMetadata.value.minWidth;
			const minHeight = imageMetadata.value.minHeight;
			const maxWidth = imageMetadata.value.maxWidth;
			const maxHeight = imageMetadata.value.maxHeight;
			if (newWidth < minWidth) {
				newWidth = minWidth;
				newHeight = newWidth / dragState.value.aspectRatio;
			}
			if (newHeight < minHeight) {
				newHeight = minHeight;
				newWidth = newHeight * dragState.value.aspectRatio;
			}
			if (newWidth > maxWidth) {
				newWidth = maxWidth;
				newHeight = newWidth / dragState.value.aspectRatio;
			}
			if (newHeight > maxHeight) {
				newHeight = maxHeight;
				newWidth = newHeight * dragState.value.aspectRatio;
			}
			dragState.value.constrainedWidth = newWidth;
			dragState.value.constrainedHeight = newHeight;
			emit("resize-move", {
				blockId: props.imageElement.getAttribute("data-sd-block-id"),
				width: newWidth,
				height: newHeight
			});
		}, MOUSE_MOVE_THROTTLE_MS);
		const onDocumentMouseMove$1 = mouseMoveThrottle.throttled;
		function onEscapeKey(event) {
			if (event.key === "Escape" && dragState.value) {
				forcedCleanup.value = true;
				onDocumentMouseUp(new MouseEvent("mouseup"));
				forcedCleanup.value = false;
			}
		}
		function onDocumentMouseUp(event) {
			if (!dragState.value) return;
			const finalWidth = dragState.value.constrainedWidth;
			const finalHeight = dragState.value.constrainedHeight;
			const blockId = props.imageElement?.getAttribute("data-sd-block-id");
			document.removeEventListener("mousemove", onDocumentMouseMove$1);
			document.removeEventListener("mouseup", onDocumentMouseUp);
			document.removeEventListener("keydown", onEscapeKey);
			const editor = resizeEditor.value;
			if (editor?.view) {
				const pmView = editor.view.dom;
				if (pmView && pmView.style) pmView.style.pointerEvents = "auto";
			}
			const widthDelta = Math.abs(finalWidth - dragState.value.initialWidth);
			const heightDelta = Math.abs(finalHeight - dragState.value.initialHeight);
			if (!forcedCleanup.value && (widthDelta > DIMENSION_CHANGE_THRESHOLD_PX || heightDelta > DIMENSION_CHANGE_THRESHOLD_PX)) {
				dispatchResizeTransaction(blockId, finalWidth, finalHeight);
				emit("resize-end", {
					blockId,
					finalWidth,
					finalHeight
				});
			}
			dragState.value = null;
		}
		function dispatchResizeTransaction(blockId, newWidth, newHeight) {
			const editor = resizeEditor.value;
			if (!isValidEditor(editor) || !props.imageElement || isResizeDisabled.value) return;
			if (!Number.isFinite(newWidth) || !Number.isFinite(newHeight) || newWidth <= 0 || newHeight <= 0) {
				emit("resize-error", {
					blockId,
					error: "Invalid dimensions: width and height must be positive finite numbers"
				});
				return;
			}
			try {
				const { state, dispatch } = editor.view;
				const tr = state.tr;
				const pmStartAttr = props.imageElement.getAttribute("data-pm-start");
				if (!pmStartAttr) {
					emit("resize-error", {
						blockId,
						error: "Image position marker (data-pm-start) not found"
					});
					return;
				}
				const imagePos = parseInt(pmStartAttr, 10);
				if (!Number.isFinite(imagePos) || imagePos < 0) {
					emit("resize-error", {
						blockId,
						error: "Invalid image position marker"
					});
					return;
				}
				const imageNode = state.doc.nodeAt(imagePos);
				if (!imageNode || imageNode.type.name !== "image") {
					emit("resize-error", {
						blockId,
						error: "Invalid image node at position"
					});
					return;
				}
				tr.setNodeAttribute(imagePos, "size", {
					width: Math.round(newWidth),
					height: Math.round(newHeight)
				});
				const $imagePos = state.doc.resolve(imagePos);
				for (let depth = $imagePos.depth; depth > 0; depth--) {
					const ancestor = $imagePos.node(depth);
					if (!nodeAllowsSdBlockRevAttr(ancestor)) continue;
					const currentRev = Number.parseInt(ancestor.attrs?.sdBlockRev, 10);
					if (!Number.isFinite(currentRev)) continue;
					tr.setNodeAttribute($imagePos.before(depth), "sdBlockRev", currentRev + 1);
				}
				dispatch(tr);
				if (blockId && blockId.trim()) measureCache.invalidate([blockId]);
				emit("resize-success", {
					blockId,
					newWidth,
					newHeight
				});
			} catch (error) {
				emit("resize-error", {
					blockId,
					error: error instanceof Error ? error.message : String(error)
				});
			}
		}
		watch(() => props.imageElement, () => {
			parseImageMetadata();
		}, { immediate: true });
		watch(() => props.visible, (visible) => {
			if (visible) parseImageMetadata();
			else if (dragState.value) {
				forcedCleanup.value = true;
				onDocumentMouseUp(new MouseEvent("mouseup"));
				forcedCleanup.value = false;
			}
		});
		onBeforeUnmount(() => {
			mouseMoveThrottle.cancel();
			if (dragState.value) {
				document.removeEventListener("mousemove", onDocumentMouseMove$1);
				document.removeEventListener("mouseup", onDocumentMouseUp);
				document.removeEventListener("keydown", onEscapeKey);
				const editor = resizeEditor.value;
				if (editor?.view?.dom) editor.view.dom.style.pointerEvents = "auto";
			}
		});
		return (_ctx, _cache) => {
			return __props.visible && imageMetadata.value ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: "superdoc-image-resize-overlay",
				style: normalizeStyle(overlayStyle.value),
				onMousedown: _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop"]))
			}, [(openBlock(true), createElementBlock(Fragment, null, renderList(resizeHandles.value, (handle) => {
				return openBlock(), createElementBlock("div", {
					key: handle.position,
					class: normalizeClass(["resize-handle", {
						"resize-handle--active": dragState.value && dragState.value.handle === handle.position,
						[`resize-handle--${handle.position}`]: true
					}]),
					style: normalizeStyle(handle.style),
					"data-handle-position": handle.position,
					onMousedown: ($event) => onHandleMouseDown($event, handle.position)
				}, null, 46, _hoisted_1$1);
			}), 128)), dragState.value ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: "resize-guideline",
				style: normalizeStyle(guidelineStyle.value)
			}, null, 4)) : createCommentVNode("", true)], 36)) : createCommentVNode("", true);
		};
	}
}, [["__scopeId", "data-v-c832a57e"]]);
var LINK_CLICK_DEBOUNCE_MS = 300;
var CURSOR_UPDATE_TIMEOUT_MS = 10;
var POPOVER_VERTICAL_OFFSET_PX = 15;
var LinkClickHandler_default = {
	__name: "LinkClickHandler",
	props: {
		editor: {
			type: Object,
			required: true
		},
		openPopover: {
			type: Function,
			required: true
		},
		closePopover: {
			type: Function,
			required: true
		},
		popoverVisible: {
			type: Boolean,
			default: false
		},
		linkPopoverResolver: {
			type: Function,
			default: void 0
		}
	},
	setup(__props) {
		const props = __props;
		let lastLinkClickTime = 0;
		const EXTERNAL_POPOVER_STYLES = {
			position: "absolute",
			zIndex: "var(--sd-external-link-popover-z-index, var(--sd-popover-z-index, 1000))",
			borderRadius: "var(--sd-external-link-popover-radius, var(--sd-popover-radius, 6px))",
			boxShadow: "var(--sd-external-link-popover-shadow, var(--sd-popover-shadow, 0 0 0 1px rgba(0, 0, 0, 0.05), 0px 10px 20px rgba(0, 0, 0, 0.1)))",
			minWidth: "var(--sd-external-link-popover-min-width, var(--sd-popover-min-width, 120px))",
			minHeight: "var(--sd-external-link-popover-min-height, var(--sd-popover-min-height, 40px))",
			backgroundColor: "var(--sd-external-link-popover-bg, var(--sd-popover-bg, white))"
		};
		let activeExternalPopover = null;
		const cleanupExternalPopover = () => {
			if (!activeExternalPopover) return;
			const { container, destroyFn, onPointerDown, onKeyDown } = activeExternalPopover;
			activeExternalPopover = null;
			try {
				destroyFn?.();
			} catch {}
			container.remove();
			document.removeEventListener("pointerdown", onPointerDown);
			document.removeEventListener("keydown", onKeyDown);
			props.editor?.view?.focus();
		};
		const computePopoverPosition = (detail, surface) => {
			const rect = surface.getBoundingClientRect();
			if (!rect) return null;
			return {
				left: `${detail.clientX - rect.left}px`,
				top: `${detail.clientY - rect.top + POPOVER_VERTICAL_OFFSET_PX}px`
			};
		};
		const openDefaultPopover = (position) => {
			props.openPopover(markRaw(LinkInput_default), {
				showInput: true,
				editor: props.editor,
				closePopover: props.closePopover
			}, position);
		};
		const openCustomPopover = (resolution, position) => {
			props.openPopover(markRaw(resolution.component), {
				editor: props.editor,
				closePopover: props.closePopover,
				...resolution.props || {}
			}, position);
		};
		const openExternalPopover = (resolution, position, detail, surface) => {
			cleanupExternalPopover();
			const container = document.createElement("div");
			container.classList.add("sd-external-link-popover");
			Object.assign(container.style, EXTERNAL_POPOVER_STYLES, {
				left: position.left,
				top: position.top
			});
			container.addEventListener("pointerdown", (e) => e.stopPropagation());
			container.addEventListener("click", (e) => e.stopPropagation());
			const mountTarget = surface.closest(".super-editor-container") ?? surface.parentElement;
			if (!mountTarget) return;
			mountTarget.appendChild(container);
			let renderResult;
			try {
				renderResult = resolution.render({
					container,
					closePopover: cleanupExternalPopover,
					editor: props.editor,
					href: detail.href ?? ""
				});
			} catch (error) {
				container.remove();
				props.editor.options?.onException?.({
					error,
					editor: props.editor
				});
				openDefaultPopover(position);
				return;
			}
			const onPointerDown = (event) => {
				if (!container.contains(event.target)) cleanupExternalPopover();
			};
			const onKeyDown = (event) => {
				if (event.key === "Escape") cleanupExternalPopover();
			};
			document.addEventListener("pointerdown", onPointerDown);
			document.addEventListener("keydown", onKeyDown);
			activeExternalPopover = {
				container,
				destroyFn: typeof renderResult?.destroy === "function" ? renderResult.destroy : null,
				onPointerDown,
				onKeyDown
			};
		};
		const resolveAndOpenPopover = (detail, surface) => {
			const position = computePopoverPosition(detail, surface);
			if (!position) return;
			if (typeof props.linkPopoverResolver !== "function") {
				openDefaultPopover(position);
				return;
			}
			const href = detail.href ?? "";
			const ctx$1 = {
				editor: props.editor,
				href,
				target: detail.target ?? null,
				rel: detail.rel ?? null,
				tooltip: detail.tooltip ?? null,
				element: detail.element,
				clientX: detail.clientX,
				clientY: detail.clientY,
				isAnchorLink: href.startsWith("#") && href.length > 1,
				documentMode: props.editor.options?.documentMode ?? "editing",
				position,
				closePopover: props.closePopover
			};
			let resolution;
			try {
				resolution = props.linkPopoverResolver(ctx$1);
			} catch (error) {
				props.editor.options?.onException?.({
					error,
					editor: props.editor
				});
				openDefaultPopover(position);
				return;
			}
			if (!resolution || resolution.type === "default") {
				openDefaultPopover(position);
				return;
			}
			if (resolution.type === "none") return;
			if (resolution.type === "custom") {
				if (!resolution.component) {
					openDefaultPopover(position);
					return;
				}
				openCustomPopover(resolution, position);
				return;
			}
			if (resolution.type === "external") {
				if (typeof resolution.render !== "function") {
					openDefaultPopover(position);
					return;
				}
				openExternalPopover(resolution, position, detail, surface);
				return;
			}
			openDefaultPopover(position);
		};
		const openLinkInViewingMode = (detail) => {
			const href = detail.href ?? "";
			if (!href) return;
			if (href.startsWith("#") && href.length > 1) {
				(props.editor?.presentationEditor ?? null)?.goToAnchor?.(href);
				return;
			}
			const target = detail.target || "_self";
			const relTokens = String(detail.rel ?? "").split(/\s+/).filter(Boolean);
			const features = ["noopener", "noreferrer"].filter((token$1) => relTokens.includes(token$1)).join(",");
			window.open(href, target, features || void 0);
		};
		const isImageLinkClick = (detail) => detail.element instanceof HTMLElement && detail.element.querySelector("img") !== null;
		const handleLinkClick = (event) => {
			const detail = event?.detail ?? {};
			const linkElement = detail.element;
			const now = Date.now();
			if (now - lastLinkClickTime < LINK_CLICK_DEBOUNCE_MS) return;
			lastLinkClickTime = now;
			if (props.popoverVisible || activeExternalPopover) {
				if (props.popoverVisible) props.closePopover();
				cleanupExternalPopover();
				return;
			}
			if (!props.editor || !props.editor.state) return;
			if (props.editor.options?.documentMode === "viewing") {
				openLinkInViewingMode(detail);
				return;
			}
			if (isImageLinkClick(detail)) {
				openLinkInViewingMode(detail);
				return;
			}
			const surface = getEditorSurfaceElement(props.editor);
			if (!surface) return;
			const pmStart = linkElement?.dataset?.pmStart;
			if (pmStart != null) {
				const pos = parseInt(pmStart, 10);
				const state = props.editor.state;
				const doc$1 = state.doc;
				if (!isNaN(pos) && pos >= 0 && pos <= doc$1.content.size) {
					const tr = state.tr.setSelection(TextSelection.create(doc$1, pos));
					props.editor.dispatch(tr);
				} else {
					console.warn(`Invalid PM position from data-pm-start: ${pmStart}, falling back to coordinate-based positioning`);
					moveCursorToMouseEvent(detail, props.editor);
				}
			} else moveCursorToMouseEvent(detail, props.editor);
			setTimeout(() => {
				const currentState = props.editor.state;
				const $from = currentState.selection.$from;
				const linkMarkType = currentState.schema.marks.link;
				const nodeAfter = $from.nodeAfter;
				const nodeBefore = $from.nodeBefore;
				const marksOnNodeAfter = nodeAfter?.marks || [];
				const marksOnNodeBefore = nodeBefore?.marks || [];
				const linkOnNodeAfter = linkMarkType && marksOnNodeAfter.some((m$1) => m$1.type === linkMarkType);
				const linkOnNodeBefore = linkMarkType && marksOnNodeBefore.some((m$1) => m$1.type === linkMarkType);
				const hasLinkAdjacent = linkOnNodeAfter || linkOnNodeBefore;
				if (selectionHasNodeOrMark(currentState, "link", { requireEnds: true }) || hasLinkAdjacent) resolveAndOpenPopover(detail, surface);
			}, CURSOR_UPDATE_TIMEOUT_MS);
		};
		let surfaceElement = null;
		onMounted(() => {
			if (!props.editor) return;
			surfaceElement = getEditorSurfaceElement(props.editor);
			if (surfaceElement) surfaceElement.addEventListener("superdoc-link-click", handleLinkClick);
		});
		onBeforeUnmount(() => {
			if (surfaceElement) surfaceElement.removeEventListener("superdoc-link-click", handleLinkClick);
			cleanupExternalPopover();
		});
		return (_ctx, _cache) => {
			return null;
		};
	}
};
function adjustPaginationBreaks(editorElem, editor) {
	if (!editorElem.value || !editor?.value?.options?.scale || isHeadless(editor)) return;
	const zoom = editor.value.options.scale;
	const bounds = editorElem.value.getBoundingClientRect();
	const breakNodes = editorElem.value.querySelectorAll(".pagination-break-wrapper");
	let firstLeft;
	breakNodes.forEach((node) => {
		const left$1 = (node.getBoundingClientRect().left - bounds.left) / zoom * -1 + 1;
		if (!firstLeft) firstLeft = left$1;
		if (left$1 !== firstLeft) {
			const diff = left$1 - firstLeft;
			node.style.transform = `translateX(${diff}px)`;
		}
	});
}
var DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
var FILE_LOAD_ERROR_MESSAGE = "Unable to load the file. Please verify the .docx is valid.";
var TABLE_RESIZE_HOVER_THRESHOLD = 8;
var TABLE_RESIZE_THROTTLE_MS = 16;
var SuperEditor_default = /* @__PURE__ */ __plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "SuperEditor",
	props: {
		documentId: {
			type: String,
			required: false
		},
		fileSource: {
			type: [File, Blob],
			required: false
		},
		state: {
			type: Object,
			required: false,
			default: () => null
		},
		options: {
			type: Object,
			required: false,
			default: () => ({})
		}
	},
	emits: [
		"editor-ready",
		"editor-click",
		"editor-keydown",
		"comments-loaded",
		"selection-update"
	],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const props = __props;
		const editorReady = ref(false);
		const editor = shallowRef(null);
		const activeEditor = computed(() => {
			if (editor.value && "editor" in editor.value && editor.value.editor) return editor.value.editor;
			return editor.value;
		});
		const contextMenuEditor = computed(() => {
			if (editor.value instanceof PresentationEditor) return editor.value;
			return activeEditor.value;
		});
		const contextMenuDisabled = computed(() => {
			const active = activeEditor.value;
			return active?.options ? Boolean(active.options.disableContextMenu) : Boolean(props.options.disableContextMenu);
		});
		const isWebLayout = computed(() => {
			return props.options.viewOptions?.layout === "web";
		});
		const isContained = computed(() => {
			return Boolean(props.options.contained);
		});
		const rulersVisible = ref(Boolean(props.options.rulers));
		const currentZoom = ref(1);
		let zoomChangeHandler = null;
		let documentModeChangeHandler = null;
		let headerFooterModeChangeHandler = null;
		const activeHeaderFooterMode = ref("body");
		watch(() => props.options, (newOptions) => {
			const rulers = newOptions?.rulers;
			if (rulers && typeof rulers === "object" && "value" in rulers) rulersVisible.value = Boolean(rulers.value);
			else rulersVisible.value = Boolean(rulers);
		}, {
			immediate: true,
			deep: true
		});
		watch(() => props.options?.rulerContainer, () => {
			nextTick(() => {
				syncRulerOffset();
				setupRulerObservers();
			});
		}, { immediate: true });
		watch(rulersVisible, (visible) => {
			nextTick(() => {
				if (visible) {
					syncRulerOffset();
					setupRulerObservers();
				} else {
					rulerHostStyle.value = {};
					cleanupRulerObservers();
				}
			});
		}, { immediate: true });
		watch(() => props.options?.documentMode, (documentMode) => {
			if (documentMode === "viewing") cleanupViewingModeUi();
		});
		const containerStyle = computed(() => {
			if (isWebLayout.value) return {};
			let maxWidth = 8.5 * 96;
			const ed = editor.value;
			if (ed && "getPages" in ed && typeof ed.getPages === "function") {
				const pages = ed.getPages();
				if (Array.isArray(pages) && pages.length > 0) {
					for (const page of pages) if (page.size && typeof page.size.w === "number" && page.size.w > 0) maxWidth = Math.max(maxWidth, page.size.w);
				}
			}
			if (maxWidth === 8.5 * 96 && ed && "getPageStyles" in ed && typeof ed.getPageStyles === "function") {
				const styles = ed.getPageStyles();
				if (styles && typeof styles === "object" && styles.pageSize && typeof styles.pageSize === "object" && typeof styles.pageSize.width === "number" && styles.pageSize.width > 0) maxWidth = styles.pageSize.width * 96;
			}
			return { minWidth: `${maxWidth * currentZoom.value}px` };
		});
		const rulerHostStyle = ref({});
		const rulerContainerEl = ref(null);
		let editorResizeObserver = null;
		let rulerContainerResizeObserver = null;
		let layoutUpdatedHandler = null;
		const resolveRulerContainer = () => {
			const container = props.options?.rulerContainer;
			if (!container) return null;
			if (typeof container === "string") return (editorWrapper.value?.ownerDocument ?? document).querySelector(container);
			return container instanceof HTMLElement ? container : null;
		};
		const getViewportRect$1 = () => {
			const host = editorWrapper.value;
			if (!host) return null;
			return (host.querySelector(".presentation-editor__viewport") ?? host).getBoundingClientRect();
		};
		const syncRulerOffset = () => {
			if (!rulersVisible.value) {
				rulerHostStyle.value = {};
				return;
			}
			rulerContainerEl.value = resolveRulerContainer();
			if (!rulerContainerEl.value) {
				rulerHostStyle.value = {};
				return;
			}
			const viewportRect = getViewportRect$1();
			if (!viewportRect) return;
			const hostRect = rulerContainerEl.value.getBoundingClientRect();
			const paddingLeft = Math.max(0, viewportRect.left - hostRect.left);
			const paddingRight = Math.max(0, hostRect.right - viewportRect.right);
			rulerHostStyle.value = {
				paddingLeft: `${paddingLeft}px`,
				paddingRight: `${paddingRight}px`
			};
		};
		const cleanupRulerObservers = () => {
			if (editorResizeObserver) {
				editorResizeObserver.disconnect();
				editorResizeObserver = null;
			}
			if (rulerContainerResizeObserver) {
				rulerContainerResizeObserver.disconnect();
				rulerContainerResizeObserver = null;
			}
		};
		const setupRulerObservers = () => {
			cleanupRulerObservers();
			if (typeof ResizeObserver === "undefined") return;
			const viewportHost = editorWrapper.value;
			const rulerHost = resolveRulerContainer();
			if (viewportHost) {
				editorResizeObserver = new ResizeObserver(() => syncRulerOffset());
				editorResizeObserver.observe(viewportHost);
			}
			if (rulerHost) {
				rulerContainerResizeObserver = new ResizeObserver(() => syncRulerOffset());
				rulerContainerResizeObserver.observe(rulerHost);
			}
		};
		const editorWrapper = ref(null);
		const editorElem = ref(null);
		const fileSource = ref(null);
		const popoverControls = reactive({
			visible: false,
			position: {
				left: "0px",
				top: "0px"
			},
			component: null,
			props: {}
		});
		const closePopover = () => {
			popoverControls.visible = false;
			popoverControls.component = null;
			popoverControls.props = {};
			activeEditor.value?.view?.focus();
		};
		const openPopover = (component, props$1, position) => {
			popoverControls.component = component;
			popoverControls.props = props$1;
			popoverControls.position = position;
			popoverControls.visible = true;
		};
		const tableResizeState = reactive({
			visible: false,
			tableElement: null,
			dragging: false
		});
		const imageResizeState = reactive({
			visible: false,
			imageElement: null,
			blockId: null
		});
		const cleanupViewingModeUi = () => {
			hideTableResizeOverlay();
			hideImageResizeOverlay();
			clearSelectedImage();
		};
		const selectedImageState = reactive({
			element: null,
			blockId: null,
			pmStart: null
		});
		const getEditorZoom = () => {
			const active = activeEditor.value;
			if (active && typeof active.zoom === "number") return active.zoom;
			if (active?.presentationEditor && typeof active.presentationEditor.zoom === "number") return active.presentationEditor.zoom;
			console.warn("[SuperEditor] getEditorZoom: Unable to retrieve zoom from editor instance, using fallback value of 1. This may indicate the editor is not fully initialized or is not a PresentationEditor instance.");
			return 1;
		};
		let lastUpdateTableResizeTimestamp = 0;
		const isNearColumnBoundary = (event, tableElement) => {
			if (!event || typeof event.clientX !== "number" || typeof event.clientY !== "number") {
				console.warn("[isNearColumnBoundary] Invalid event: missing clientX or clientY", event);
				return false;
			}
			if (!tableElement || !(tableElement instanceof HTMLElement)) {
				console.warn("[isNearColumnBoundary] Invalid tableElement: not an HTMLElement", tableElement);
				return false;
			}
			const boundariesAttr = tableElement.getAttribute("data-table-boundaries");
			if (!boundariesAttr) return false;
			try {
				const metadata = JSON.parse(boundariesAttr);
				if (!metadata.columns || !Array.isArray(metadata.columns)) return false;
				const isRtl = metadata.rtl === true;
				const firstColumn = metadata.columns[0];
				const lastColumn = metadata.columns[metadata.columns.length - 1];
				const tableContentLeft = firstColumn && typeof firstColumn.x === "number" ? firstColumn.x : 0;
				const tableContentWidth = lastColumn && typeof lastColumn.x === "number" && typeof lastColumn.w === "number" ? lastColumn.x + lastColumn.w : 0;
				const zoom = getEditorZoom();
				const tableRect = tableElement.getBoundingClientRect();
				const mouseXScreen = event.clientX - tableRect.left;
				const mouseYScreen = event.clientY - tableRect.top;
				for (let i = 0; i < metadata.columns.length; i++) {
					const col = metadata.columns[i];
					if (!col || typeof col !== "object") {
						console.warn(`[isNearColumnBoundary] Invalid column at index ${i}: not an object`, col);
						continue;
					}
					if (typeof col.x !== "number" || !Number.isFinite(col.x)) {
						console.warn(`[isNearColumnBoundary] Invalid column.x at index ${i}:`, col.x);
						continue;
					}
					if (typeof col.w !== "number" || !Number.isFinite(col.w) || col.w <= 0) {
						console.warn(`[isNearColumnBoundary] Invalid column.w at index ${i}:`, col.w);
						continue;
					}
					const logicalBoundaryX = col.x + col.w;
					const boundaryXScreen = (isRtl ? tableContentLeft + tableContentWidth - logicalBoundaryX : logicalBoundaryX) * zoom;
					if (Math.abs(mouseXScreen - boundaryXScreen) <= TABLE_RESIZE_HOVER_THRESHOLD) {
						const segmentColIndex = i + 1;
						const segments = metadata.segments?.[segmentColIndex];
						if (!segments || segments.length === 0) {
							if (i === metadata.columns.length - 1) return true;
							continue;
						}
						for (const seg of segments) {
							const segTopScreen = (seg.y || 0) * zoom;
							const segBottomScreen = seg.h != null ? segTopScreen + seg.h * zoom : tableRect.height;
							if (mouseYScreen >= segTopScreen && mouseYScreen <= segBottomScreen) return true;
						}
					}
				}
				const tableWidthScreen = tableRect.width;
				if (Math.abs(mouseXScreen) <= TABLE_RESIZE_HOVER_THRESHOLD || Math.abs(mouseXScreen - tableWidthScreen) <= TABLE_RESIZE_HOVER_THRESHOLD) return true;
				return false;
			} catch (e) {
				console.warn("[isNearColumnBoundary] Failed to parse table boundary metadata:", e);
				return false;
			}
		};
		const isNearRowBoundary = (event, tableElement) => {
			if (!event || typeof event.clientX !== "number" || typeof event.clientY !== "number") return false;
			if (!tableElement || !(tableElement instanceof HTMLElement)) return false;
			const boundariesAttr = tableElement.getAttribute("data-table-boundaries");
			if (!boundariesAttr) return false;
			try {
				const metadata = JSON.parse(boundariesAttr);
				if (!metadata.rows || !Array.isArray(metadata.rows)) return false;
				const zoom = getEditorZoom();
				const tableRect = tableElement.getBoundingClientRect();
				const mouseYScreen = event.clientY - tableRect.top;
				for (const row of metadata.rows) {
					if (!row || typeof row.y !== "number" || typeof row.h !== "number") continue;
					if (row.r !== 1) continue;
					const boundaryYScreen = (row.y + row.h) * zoom;
					if (Math.abs(mouseYScreen - boundaryYScreen) <= TABLE_RESIZE_HOVER_THRESHOLD) return true;
				}
				return false;
			} catch {
				return false;
			}
		};
		const updateTableResizeOverlay = (event) => {
			if (tableResizeState.dragging) return;
			const now = Date.now();
			if (now - lastUpdateTableResizeTimestamp < TABLE_RESIZE_THROTTLE_MS) return;
			lastUpdateTableResizeTimestamp = now;
			if (!editorElem.value) return;
			let target = event.target;
			while (target && target !== editorElem.value) {
				if (target.classList?.contains("superdoc-table-resize-overlay")) return;
				if (target.classList?.contains("superdoc-table-fragment") && target.hasAttribute("data-table-boundaries")) {
					if (isNearColumnBoundary(event, target) || isNearRowBoundary(event, target)) {
						tableResizeState.visible = true;
						tableResizeState.tableElement = target;
					} else {
						tableResizeState.visible = false;
						tableResizeState.tableElement = null;
					}
					return;
				}
				target = target.parentElement;
			}
			tableResizeState.visible = false;
			tableResizeState.tableElement = null;
		};
		const hideTableResizeOverlay = () => {
			if (tableResizeState.dragging) return;
			tableResizeState.visible = false;
			tableResizeState.tableElement = null;
		};
		const onTableResizeStart = () => {
			tableResizeState.dragging = true;
		};
		const onTableResizeEnd = () => {
			tableResizeState.dragging = false;
			tableResizeState.visible = false;
			tableResizeState.tableElement = null;
		};
		const getBehindDocSection$1 = (element) => {
			return element?.closest?.("[data-behind-doc-section]")?.getAttribute("data-behind-doc-section") ?? null;
		};
		const canInteractWithHeaderFooterOwnedMedia = (element) => {
			const section = getBehindDocSection$1(element);
			if (!section) return true;
			return section === activeHeaderFooterMode.value;
		};
		const updateImageResizeOverlay = (event) => {
			if (!editorElem.value) return;
			if (isViewingMode() || !activeEditor.value?.isEditable) {
				hideImageResizeOverlay();
				return;
			}
			if (!(event.target instanceof Element)) {
				imageResizeState.visible = false;
				imageResizeState.imageElement = null;
				imageResizeState.blockId = null;
				return;
			}
			let target = event.target;
			while (target && target !== document.body) {
				if (target.classList?.contains("superdoc-image-resize-overlay") || target.closest?.(".superdoc-image-resize-overlay")) return;
				if (target.classList?.contains(DOM_CLASS_NAMES.IMAGE_FRAGMENT) && target.hasAttribute("data-image-metadata")) {
					if (!canInteractWithHeaderFooterOwnedMedia(target)) {
						hideImageResizeOverlay();
						return;
					}
					imageResizeState.visible = true;
					imageResizeState.imageElement = target;
					imageResizeState.blockId = target.getAttribute("data-sd-block-id");
					return;
				}
				if (target.classList?.contains(DOM_CLASS_NAMES.INLINE_IMAGE_CLIP_WRAPPER) && target.querySelector?.("[data-image-metadata]")) {
					if (!canInteractWithHeaderFooterOwnedMedia(target)) {
						hideImageResizeOverlay();
						return;
					}
					imageResizeState.visible = true;
					imageResizeState.imageElement = target;
					imageResizeState.blockId = target.getAttribute("data-pm-start");
					return;
				}
				if (target.classList?.contains(DOM_CLASS_NAMES.INLINE_IMAGE) && target.hasAttribute("data-image-metadata")) {
					if (!canInteractWithHeaderFooterOwnedMedia(target)) {
						hideImageResizeOverlay();
						return;
					}
					imageResizeState.visible = true;
					const wrapper = target.closest?.(`.${DOM_CLASS_NAMES.INLINE_IMAGE_CLIP_WRAPPER}`);
					imageResizeState.imageElement = wrapper ?? target;
					imageResizeState.blockId = (wrapper ?? target).getAttribute("data-pm-start");
					return;
				}
				target = target.parentElement;
			}
			imageResizeState.visible = false;
			imageResizeState.imageElement = null;
			imageResizeState.blockId = null;
		};
		const hideImageResizeOverlay = () => {
			imageResizeState.visible = false;
			imageResizeState.imageElement = null;
			imageResizeState.blockId = null;
		};
		const clearSelectedImage = () => {
			if (selectedImageState.element?.classList?.contains("superdoc-image-selected")) selectedImageState.element.classList.remove("superdoc-image-selected");
			selectedImageState.element = null;
			selectedImageState.blockId = null;
			selectedImageState.pmStart = null;
		};
		const setSelectedImage = (element, blockId, pmStart) => {
			if (isViewingMode() || !activeEditor.value?.isEditable) {
				clearSelectedImage();
				return;
			}
			if (element && !canInteractWithHeaderFooterOwnedMedia(element)) {
				clearSelectedImage();
				hideImageResizeOverlay();
				return;
			}
			if (selectedImageState.element && selectedImageState.element !== element) selectedImageState.element.classList.remove("superdoc-image-selected");
			if (element && element.classList) {
				element.classList.add("superdoc-image-selected");
				selectedImageState.element = element;
				selectedImageState.blockId = blockId ?? null;
				selectedImageState.pmStart = typeof pmStart === "number" ? pmStart : null;
			} else clearSelectedImage();
		};
		const cleanupInactiveHeaderFooterOwnedImageUi = () => {
			if (imageResizeState.imageElement && !canInteractWithHeaderFooterOwnedMedia(imageResizeState.imageElement)) hideImageResizeOverlay();
			if (selectedImageState.element && !canInteractWithHeaderFooterOwnedMedia(selectedImageState.element)) clearSelectedImage();
		};
		const getDocumentMode = () => {
			if (activeEditor.value?.options?.documentMode) return activeEditor.value.options.documentMode;
			if (props.options?.documentMode) return props.options.documentMode;
			return "editing";
		};
		const isViewingMode = () => getDocumentMode() === "viewing";
		const handleOverlayUpdates = (event) => {
			if (isViewingMode()) {
				cleanupViewingModeUi();
				return;
			}
			updateTableResizeOverlay(event);
			if (!tableResizeState.dragging) updateImageResizeOverlay(event);
		};
		const handleOverlayHide = () => {
			hideTableResizeOverlay();
			hideImageResizeOverlay();
		};
		const setDefaultBlankFile = async () => {
			fileSource.value = await getFileObject(blank_default, "blank.docx", DOCX);
		};
		const loadNewFileData = async () => {
			if (!fileSource.value) fileSource.value = props.fileSource;
			if (!fileSource.value || fileSource.value.type !== DOCX) await setDefaultBlankFile();
			try {
				const [docx, media, mediaFiles, fonts, decryptedData] = await Editor.loadXmlData(fileSource.value, false, { password: props.options.password });
				if (decryptedData) fileSource.value = new Blob([decryptedData], { type: DOCX });
				return {
					content: docx,
					media,
					mediaFiles,
					fonts
				};
			} catch (err) {
				if (err instanceof DocxEncryptionError) {
					if (typeof props.options.onException === "function" && props.options.onException({
						error: err,
						editor: null,
						code: err.code
					}) === true) throw err;
					console.debug("[SuperDoc] Error loading file:", err);
					return;
				}
				console.debug("[SuperDoc] Error loading file:", err);
				if (typeof props.options.onException === "function") props.options.onException({
					error: err,
					editor: null
				});
			}
		};
		const waitForCollaborativeFragmentSettling = async (ydoc, maxWaitMs = 200) => {
			const fragment = ydoc.getXmlFragment("supereditor");
			if (fragment.length > 0) return fragment;
			await new Promise((resolve) => {
				const timeout$1 = setTimeout(() => {
					fragment.unobserve?.(observer);
					resolve();
				}, maxWaitMs);
				const observer = () => {
					if (fragment.length <= 0) return;
					clearTimeout(timeout$1);
					fragment.unobserve?.(observer);
					resolve();
				};
				fragment.observe?.(observer);
			});
			return fragment;
		};
		const notifyFileLoadError = () => {
			console.warn(FILE_LOAD_ERROR_MESSAGE);
		};
		const initializeData = async () => {
			if (props.fileSource) {
				let fileData;
				try {
					fileData = await loadNewFileData();
				} catch (err) {
					if (err instanceof DocxEncryptionError) return;
					throw err;
				}
				if (!fileData) {
					notifyFileLoadError();
					await setDefaultBlankFile();
					fileData = await loadNewFileData();
				}
				return initEditor(fileData);
			} else if (props.options.ydoc && props.options.collaborationProvider) {
				delete props.options.content;
				const ydoc = props.options.ydoc;
				const provider = props.options.collaborationProvider;
				const waitForSync = () => {
					if (provider.isSynced || provider.synced) return Promise.resolve();
					return new Promise((resolve) => {
						const onSync = (synced) => {
							if (synced === false) return;
							provider.off("synced", onSync);
							provider.off("sync", onSync);
							resolve();
						};
						provider.on("synced", onSync);
						provider.on("sync", onSync);
					});
				};
				waitForSync().then(async () => {
					const partsMap = ydoc.getMap("parts");
					const metaMap = ydoc.getMap("meta");
					const hasLegacyContent = metaMap.has("docx");
					const fragment = hasLegacyContent ? ydoc.getXmlFragment("supereditor") : await waitForCollaborativeFragmentSettling(ydoc);
					if (fragment.length > 0 || partsMap.size > 0 || hasLegacyContent) {
						props.options.isNewFile = false;
						if (fragment.length > 0) {
							props.options.fragment = fragment;
							initEditor({});
							return;
						}
						delete props.options.fragment;
						if (hasLegacyContent) {
							initEditor({ content: metaMap.get("docx") });
							return;
						}
						initEditor({});
					} else {
						props.options.isNewFile = true;
						delete props.options.fragment;
						try {
							const fileData = await loadNewFileData();
							if (fileData) initEditor(fileData);
						} catch (err) {
							if (err instanceof DocxEncryptionError) return;
							throw err;
						}
					}
				});
			}
		};
		const getExtensions = () => getStarterExtensions();
		const initEditor = async ({ content, media = {}, mediaFiles = {}, fonts = {} } = {}) => {
			if (!editorElem.value) return;
			const { editorCtor, ...editorOptions } = props.options || {};
			const EditorCtor = editorCtor ?? Editor;
			clearSelectedImage();
			editor.value = new EditorCtor({
				mode: "docx",
				element: editorElem.value,
				fileSource: fileSource.value,
				extensions: getExtensions(),
				documentId: props.documentId,
				content,
				media,
				mediaFiles,
				fonts,
				...editorOptions
			});
			emit("editor-ready", {
				editor: activeEditor.value,
				presentationEditor: editor.value instanceof PresentationEditor ? editor.value : null
			});
			const documentModeEmitter = editor.value instanceof PresentationEditor ? editor.value : activeEditor.value;
			if (documentModeEmitter?.on) {
				documentModeChangeHandler = ({ documentMode } = {}) => {
					if (documentMode === "viewing") cleanupViewingModeUi();
				};
				documentModeEmitter.on("documentModeChange", documentModeChangeHandler);
			}
			if (editor.value instanceof PresentationEditor) {
				const presentationEditor = editor.value;
				presentationEditor.on("imageSelected", ({ element, blockId, pmStart }) => {
					setSelectedImage(element, blockId ?? null, pmStart);
				});
				presentationEditor.on("imageDeselected", () => {
					clearSelectedImage();
				});
				headerFooterModeChangeHandler = ({ mode } = {}) => {
					activeHeaderFooterMode.value = mode ?? "body";
					cleanupInactiveHeaderFooterOwnedImageUi();
				};
				presentationEditor.on("headerFooterModeChanged", headerFooterModeChangeHandler);
				layoutUpdatedHandler = () => {
					if (imageResizeState.visible && imageResizeState.blockId) {
						const escapedBlockId = CSS.escape(imageResizeState.blockId);
						let newElement = editorElem.value?.querySelector(`.${DOM_CLASS_NAMES.IMAGE_FRAGMENT}[data-sd-block-id="${escapedBlockId}"]`);
						if (!newElement) newElement = editorElem.value?.querySelector(buildInlineImagePmSelector(escapedBlockId));
						if (newElement) if (canInteractWithHeaderFooterOwnedMedia(newElement)) imageResizeState.imageElement = newElement;
						else hideImageResizeOverlay();
						else {
							imageResizeState.visible = false;
							imageResizeState.imageElement = null;
							imageResizeState.blockId = null;
						}
					}
					if (selectedImageState.blockId) {
						const escapedBlockId = CSS.escape(selectedImageState.blockId);
						const refreshed = editorElem.value?.querySelector(`.${DOM_CLASS_NAMES.IMAGE_FRAGMENT}[data-sd-block-id="${escapedBlockId}"]`);
						if (refreshed) setSelectedImage(refreshed, selectedImageState.blockId, selectedImageState.pmStart);
						else {
							if (selectedImageState.pmStart != null) {
								const pmElement = editorElem.value?.querySelector(buildImagePmSelector(selectedImageState.pmStart));
								if (pmElement) {
									setSelectedImage(pmElement, selectedImageState.blockId, selectedImageState.pmStart);
									return;
								}
							}
							clearSelectedImage();
						}
					}
					nextTick(() => syncRulerOffset());
				};
				presentationEditor.on("layoutUpdated", layoutUpdatedHandler);
				zoomChangeHandler = ({ zoom }) => {
					currentZoom.value = zoom;
					nextTick(() => syncRulerOffset());
				};
				presentationEditor.on("zoomChange", zoomChangeHandler);
				if (typeof presentationEditor.zoom === "number") {
					currentZoom.value = presentationEditor.zoom;
					nextTick(() => syncRulerOffset());
				}
			}
			editor.value.on("paginationUpdate", () => {
				const base = activeEditor.value;
				if (isHeadless(base)) return;
				adjustPaginationBreaks(editorElem, editor.value?.editor ? { value: base } : editor);
			});
			editor.value.on("collaborationReady", () => {
				setTimeout(() => {
					editorReady.value = true;
				}, 150);
			});
		};
		const handleSuperEditorKeydown = (event) => {
			if ((event.metaKey || event.ctrlKey) && event.altKey && event.shiftKey) {
				if (event.code === "KeyM") {
					const toolbar = document.querySelector(".superdoc-toolbar");
					if (toolbar) {
						toolbar.setAttribute("tabindex", "0");
						toolbar.focus();
					}
				}
			}
			if ((event.metaKey || event.ctrlKey) && !event.shiftKey && !event.altKey && (event.key === "k" || event.key === "K")) {
				event.preventDefault();
				const base = activeEditor.value;
				if (!base) return;
				const view = base.view;
				const { state } = view;
				const container = editorWrapper.value;
				if (!container) return;
				const containerRect = container.getBoundingClientRect();
				const cursorCoords = view.coordsAtPos(state.selection.head);
				const left$1 = `${cursorCoords.left - containerRect.left}px`;
				const top$1 = `${cursorCoords.bottom - containerRect.top + 6}px`;
				openPopover(markRaw(LinkInput_default), {}, {
					left: left$1,
					top: top$1
				});
			}
			emit("editor-keydown", { editor: activeEditor.value });
		};
		const handleSuperEditorClick = (event) => {
			emit("editor-click", { editor: activeEditor.value });
			let pmElement = editorElem.value?.querySelector(".ProseMirror");
			const base = activeEditor.value;
			if (!pmElement || !base) return;
			let isInsideEditor = pmElement.contains(event.target);
			if (!isInsideEditor && base.isEditable) base.view?.focus();
			if (isInsideEditor && base.isEditable) checkNodeSpecificClicks(base, event, popoverControls);
			if (isViewingMode()) cleanupViewingModeUi();
			else updateTableResizeOverlay(event);
		};
		onMounted(() => {
			initializeData();
			if (props.options?.suppressSkeletonLoader || !props.options?.collaborationProvider) editorReady.value = true;
			window.addEventListener("resize", syncRulerOffset, { passive: true });
			nextTick(() => {
				syncRulerOffset();
				setupRulerObservers();
			});
		});
		const handleMarginClick = (event) => {
			if (event.button !== 0) return;
			if (event.ctrlKey && isMacOS()) return;
			const target = event.target;
			if (target?.classList?.contains("ProseMirror")) return;
			if (target?.closest?.(".presentation-editor, .superdoc-layout, .context-menu")) return;
			onMarginClickCursorChange(event, activeEditor.value);
		};
		const handleMarginChange = ({ side, value }) => {
			const base = activeEditor.value;
			if (!base) return;
			const payload = side === "left" ? { leftInches: value } : side === "right" ? { rightInches: value } : side === "top" ? { topInches: value } : side === "bottom" ? { bottomInches: value } : {};
			if (!(typeof base.commands?.setSectionPageMarginsAtSelection === "function" ? base.commands.setSectionPageMarginsAtSelection(payload) : false)) {
				const { pageMargins } = base.getPageStyles();
				const update = {
					...pageMargins,
					[side]: value
				};
				base?.updatePageStyle({ pageMargins: update });
			}
		};
		onBeforeUnmount(() => {
			clearSelectedImage();
			if (documentModeChangeHandler) {
				(editor.value instanceof PresentationEditor ? editor.value : activeEditor.value)?.off?.("documentModeChange", documentModeChangeHandler);
				documentModeChangeHandler = null;
			}
			if (editor.value instanceof PresentationEditor && zoomChangeHandler) {
				editor.value.off("zoomChange", zoomChangeHandler);
				zoomChangeHandler = null;
			}
			if (editor.value instanceof PresentationEditor && headerFooterModeChangeHandler) {
				editor.value.off("headerFooterModeChanged", headerFooterModeChangeHandler);
				headerFooterModeChangeHandler = null;
			}
			if (editor.value instanceof PresentationEditor && layoutUpdatedHandler) {
				editor.value.off("layoutUpdated", layoutUpdatedHandler);
				layoutUpdatedHandler = null;
			}
			cleanupRulerObservers();
			window.removeEventListener("resize", syncRulerOffset);
			editor.value?.destroy();
			editor.value = null;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: normalizeClass(["super-editor-container", {
					"web-layout": isWebLayout.value,
					contained: isContained.value
				}]),
				style: normalizeStyle(containerStyle.value),
				"data-sd-part": "editor-root"
			}, [
				__props.options.rulerContainer && rulersVisible.value && !isWebLayout.value && !!activeEditor.value ? (openBlock(), createBlock(Teleport, {
					key: 0,
					to: __props.options.rulerContainer
				}, [createElementVNode("div", {
					class: "ruler-host",
					style: normalizeStyle(rulerHostStyle.value)
				}, [createVNode(Ruler_default, {
					class: "ruler superdoc-ruler",
					editor: activeEditor.value,
					onMarginChange: handleMarginChange
				}, null, 8, ["editor"])], 4)], 8, ["to"])) : rulersVisible.value && !isWebLayout.value && !!activeEditor.value ? (openBlock(), createElementBlock("div", {
					key: 1,
					class: "ruler-host",
					style: normalizeStyle(rulerHostStyle.value)
				}, [createVNode(Ruler_default, {
					class: "ruler",
					editor: activeEditor.value,
					onMarginChange: handleMarginChange
				}, null, 8, ["editor"])], 4)) : createCommentVNode("", true),
				createElementVNode("div", {
					class: "super-editor",
					ref_key: "editorWrapper",
					ref: editorWrapper,
					onKeydown: handleSuperEditorKeydown,
					onClick: handleSuperEditorClick,
					onMousedown: handleMarginClick,
					onMousemove: handleOverlayUpdates,
					onMouseleave: handleOverlayHide
				}, [
					createElementVNode("div", {
						ref_key: "editorElem",
						ref: editorElem,
						class: "editor-element super-editor__element",
						role: "presentation"
					}, null, 512),
					!contextMenuDisabled.value && editorReady.value && contextMenuEditor.value ? (openBlock(), createBlock(ContextMenu_default, {
						key: 0,
						editor: contextMenuEditor.value,
						popoverControls,
						openPopover,
						closePopover
					}, null, 8, ["editor", "popoverControls"])) : createCommentVNode("", true),
					editorReady.value && activeEditor.value ? (openBlock(), createBlock(LinkClickHandler_default, {
						key: 1,
						editor: activeEditor.value,
						openPopover,
						closePopover,
						popoverVisible: popoverControls.visible,
						linkPopoverResolver: props.options.linkPopoverResolver
					}, null, 8, [
						"editor",
						"popoverVisible",
						"linkPopoverResolver"
					])) : createCommentVNode("", true),
					editorReady.value && activeEditor.value ? (openBlock(), createBlock(TableResizeOverlay_default, {
						key: 2,
						editor: activeEditor.value,
						visible: tableResizeState.visible,
						tableElement: tableResizeState.tableElement,
						onResizeStart: onTableResizeStart,
						onResizeEnd: onTableResizeEnd
					}, null, 8, [
						"editor",
						"visible",
						"tableElement"
					])) : createCommentVNode("", true),
					editorReady.value && activeEditor.value ? (openBlock(), createBlock(ImageResizeOverlay_default, {
						key: 3,
						editor: contextMenuEditor.value,
						visible: imageResizeState.visible,
						imageElement: imageResizeState.imageElement
					}, null, 8, [
						"editor",
						"visible",
						"imageElement"
					])) : createCommentVNode("", true)
				], 544),
				!editorReady.value ? (openBlock(), createBlock(EditorSkeleton_default, { key: 2 })) : createCommentVNode("", true),
				activeEditor.value ? (openBlock(), createBlock(GenericPopover_default, {
					key: 3,
					editor: activeEditor.value,
					visible: popoverControls.visible,
					position: popoverControls.position,
					onClose: closePopover
				}, {
					default: withCtx(() => [(openBlock(), createBlock(resolveDynamicComponent(popoverControls.component), normalizeProps(guardReactiveProps({
						...popoverControls.props,
						editor: activeEditor.value,
						closePopover
					})), null, 16))]),
					_: 1
				}, 8, [
					"editor",
					"visible",
					"position"
				])) : createCommentVNode("", true)
			], 6);
		};
	}
}), [["__scopeId", "data-v-ba551159"]]);
var _hoisted_1 = ["innerHTML"];
var SuperInput_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "SuperInput",
	props: {
		modelValue: { type: String },
		placeholder: {
			type: String,
			required: false,
			default: "Type something..."
		},
		options: {
			type: Object,
			required: false,
			default: () => ({})
		},
		users: {
			type: Array,
			required: false,
			default: () => []
		}
	},
	emits: [
		"update:modelValue",
		"focus",
		"blur"
	],
	setup(__props, { expose: __expose, emit: __emit }) {
		const emit = __emit;
		const props = __props;
		const editor = shallowRef();
		const editorElem = ref(null);
		const contentElem = ref(null);
		const isFocused = ref(false);
		const onTransaction = ({ editor: editor$1, transaction }) => {
			emit("update:modelValue", editor$1.getHTML());
		};
		const onFocus = ({ editor: editor$1, transaction }) => {
			isFocused.value = true;
			updateUsersState();
			emit("focus", {
				editor: editor$1,
				transaction
			});
		};
		const onBlur = ({ editor: editor$1, transaction }) => {
			isFocused.value = false;
			emit("blur", {
				editor: editor$1,
				transaction
			});
		};
		const initEditor = async () => {
			Placeholder.options.placeholder = props.placeholder || "Type something...";
			props.options.onTransaction = onTransaction;
			props.options.onFocus = onFocus;
			props.options.onBlur = onBlur;
			editor.value = new Editor({
				mode: "text",
				content: props.modelValue ?? contentElem.value?.innerHTML ?? "",
				element: editorElem.value,
				extensions: getRichTextExtensions(),
				users: props.users,
				...props.options
			});
		};
		const focus = (options = {}) => {
			const { moveCursorToEnd = true } = options;
			isFocused.value = true;
			const instance = editor.value;
			instance?.view?.focus();
			if (moveCursorToEnd) {
				const docSize = instance?.state?.doc?.content?.size;
				if (typeof docSize === "number" && instance?.commands?.setTextSelection) instance.commands.setTextSelection({
					from: docSize,
					to: docSize
				});
			}
		};
		const handleFocus = () => {
			focus({ moveCursorToEnd: false });
		};
		const updateUsersState = () => {
			editor.value?.setOptions({ users: props.users });
		};
		onMounted(() => {
			initEditor();
		});
		onBeforeUnmount(() => {
			editor.value?.destroy();
			editor.value = null;
		});
		__expose({ focus });
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: normalizeClass(["super-editor super-input", { "super-input-active": isFocused.value }]),
				onClick: withModifiers(handleFocus, ["stop", "prevent"])
			}, [createElementVNode("div", {
				ref_key: "contentElem",
				ref: contentElem,
				style: { "display": "none" },
				innerHTML: __props.modelValue
			}, null, 8, _hoisted_1), createElementVNode("div", {
				ref_key: "editorElem",
				ref: editorElem,
				class: "editor-element super-editor__element"
			}, null, 512)], 2);
		};
	}
}, [["__scopeId", "data-v-69c44db7"]]);
var SlashMenu = ContextMenu_default;
var Extensions = {
	Node: Node$1,
	Attribute,
	Extension,
	Mark,
	Plugin,
	PluginKey,
	Decoration,
	DecorationSet
};
export { map as $, trackChangesHelpers_exports as A, getFileObject as B, ellipsis_vertical_solid_default as C, AIWriter_default as D, comment_solid_default as E, TrackChangesBasePluginKey as F, isNode as G, createUint8ArrayFromArrayBuffer as H, SectionHelpers as I, varStorage as J, offChange as K, seedEditorStateToYDoc as L, AnnotatorHelpers as M, CommentsPluginKey as N, getRichTextExtensions as O, createOrUpdateTrackedChangeComment as P, removeAwarenessStates as Q, onCollaborationProviderSynced as R, caret_down_solid_default as S, check_solid_default as T, fromBase64 as U, comments_module_events as V, toBase64 as W, applyAwarenessUpdate as X, Awareness as Y, encodeAwarenessUpdate as Z, parseTrackedChangeAnchorKey as _, isMarkType as _t, ContextMenu_default as a, readVarUint as at, SuperToolbar as b, initPartsRuntime as c, length as ct, COMMENT_ANCHOR_KEY_PREFIX as d, writeVarUint8Array as dt, ObservableV2 as et, TRACKED_CHANGE_ANCHOR_KEY_PREFIX as f, create$2 as ft, makeTrackedChangeAnchorKey as g, defineNode as gt, makeCommentAnchorKey as h, defineMark as ht, SuperEditor_default as i, readVarString as it, fieldAnnotationHelpers_exports as j, getStarterExtensions as k, getDocumentApiAdapters as l, toUint8Array as lt, isTrackedChangeAnchorKey as m, pow as mt, SlashMenu as n, getUnixTime as nt, PresentationEditor as o, readVarUint8Array as ot, isCommentAnchorKey as p, min$1 as pt, onChange as q, SuperInput_default as r, createDecoder as rt, Editor as s, createEncoder as st, Extensions as t, setIfUndefined as tt, getTrackedChangeIndex as u, writeVarUint as ut, syncCommentEntitiesFromCollaboration as v, assertNodeType as vt, xmark_solid_default as w, Toolbar_default as x, BLANK_DOCX_BASE64 as y, isNodeType as yt, v_click_outside_default as z };
